(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[888],{

/***/ 2234:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(59312);
tslib_1.__exportStar(__webpack_require__(93359), exports);
tslib_1.__exportStar(__webpack_require__(29738), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 533:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.mapSections = void 0;
const jsx_runtime_1 = __webpack_require__(24246);
const react_error_boundary_1 = __webpack_require__(48656);
const uuid_1 = __webpack_require__(338);
/**
 * Will take in the page sections data and react section components
 * and render in the order they appear in the page sections data.
 * @param {*} pageSections
 * @param {*} sectionComponents
 */
const mapSections = (pageSections, sectionComponents, pageData) => {
    const componentMap = sectionComponents
        ? sectionComponents.reduce((compMap, Component) => {
            let schemaKey = '';
            if (Component?.Schema && typeof Component?.Schema === 'function') {
                schemaKey = Component.Schema(pageData)?.key;
            }
            else {
                schemaKey = Component.Schema.key;
            }
            if (!schemaKey) {
                return compMap;
            }
            compMap[schemaKey] = Component;
            return compMap;
        }, {})
        : {};
    return pageSections.reduce((acc, section) => {
        if (!section)
            return acc;
        const { _template: CompSchemaKey, ...cms } = section;
        const Comp = componentMap[CompSchemaKey];
        if (!Comp)
            return acc;
        if (cms?.sectionVisibility === 'hidden')
            return acc;
        return [
            ...acc,
            // sections wrapper with data-comp and data-comp-id for easy scrolling on section select
            (0, jsx_runtime_1.jsx)("section", { "data-comp": CompSchemaKey, "data-comp-id": cms?.id, children: (0, jsx_runtime_1.jsx)(react_error_boundary_1.ErrorBoundary, { "data-comp": "SectionErrorBoundary", FallbackComponent: () => ((0, jsx_runtime_1.jsx)(SectionErrorFallback, { name: CompSchemaKey })), children: (0, jsx_runtime_1.jsx)(Comp, { "comp-name": CompSchemaKey, cms: cms }) }) }, (0, uuid_1.v4)()),
        ];
    }, []);
};
exports.mapSections = mapSections;
function SectionErrorFallback({ name }) {
    return ((0, jsx_runtime_1.jsx)("section", { style: {
            padding: '16px',
        }, children: (0, jsx_runtime_1.jsxs)("div", { style: {
                border: 'thin solid #f87171',
                height: '350px',
                width: '100%',
                backgroundColor: '#fecaca',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: '8px',
            }, children: ["An error occured in your", (0, jsx_runtime_1.jsxs)("span", { style: { fontWeight: 'bold', fontFamily: 'monospace' }, children: ["\u00A0", name, "\u00A0"] }), "section"] }) }));
}
//# sourceMappingURL=mapSections.js.map

/***/ }),

/***/ 60118:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.mapSectionsWithAddedProps = void 0;
const mapSectionsWithAddedProps = (props) => (section) => {
    try {
        if (!section)
            return null;
        if (!props)
            return section;
        if (typeof props !== 'object') {
            console.warn('mapSectionsWithAddedProps:error: props must be an object');
            return section;
        }
        return {
            ...section,
            props: {
                ...section.props,
                children: {
                    ...section.props.children,
                    props: {
                        ...section.props.children.props,
                        children: {
                            ...section.props.children.props.children,
                            props: {
                                ...section.props.children.props.children.props,
                                ...props,
                            },
                        },
                    },
                },
            },
        };
    }
    catch (error) {
        return section;
    }
};
exports.mapSectionsWithAddedProps = mapSectionsWithAddedProps;
//# sourceMappingURL=mapSectionsWithAddedProps.js.map

/***/ }),

/***/ 29738:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.renderSections = void 0;
const mapSections_1 = __webpack_require__(533);
const mapSectionsWithAddedProps_1 = __webpack_require__(60118);
const renderSections = (pageData, sectionComponents) => {
    const pageDataSections = pageData?.page?.sections ||
        pageData?.article?.sections ||
        pageData?.blog?.sections;
    if (!pageDataSections) {
        return () => {
            return null;
        };
    }
    const allSections = (0, mapSections_1.mapSections)([...pageDataSections], sectionComponents, pageData);
    const pageDataTemplateSections = pageDataSections?.filter((section) => section.parentContentType === 'template');
    const pageDataPageSections = pageDataSections?.filter((section) => section.parentContentType !== 'template');
    const templateSections = (0, mapSections_1.mapSections)(pageDataTemplateSections, sectionComponents, pageData);
    const pageSections = (0, mapSections_1.mapSections)(pageDataPageSections, sectionComponents, pageData);
    return (options) => {
        try {
            if (!options)
                return allSections;
            if (typeof options !== 'object') {
                throw new Error(`parameter must be an object; received ${typeof options}`);
            }
            if (options.type && !['template', 'page', 'all'].includes(options.type)) {
                console.warn('renderSections:', '`type` must be "template", "page", or "all"');
            }
            if (options.props && typeof options.props !== 'object') {
                throw new Error(`\`props\` must be an object; received ${typeof options.props}`);
            }
            const { props, type } = options;
            switch (type) {
                case 'template':
                    if (props) {
                        return templateSections.map((0, mapSectionsWithAddedProps_1.mapSectionsWithAddedProps)(props));
                    }
                    return templateSections;
                case 'page':
                    if (props) {
                        return pageSections.map((0, mapSectionsWithAddedProps_1.mapSectionsWithAddedProps)(props));
                    }
                    return pageSections;
                default:
                    if (props) {
                        return allSections.map((0, mapSectionsWithAddedProps_1.mapSectionsWithAddedProps)(props));
                    }
                    return allSections;
            }
        }
        catch (error) {
            console.error('renderSections:error', error.message);
            return allSections;
        }
    };
};
exports.renderSections = renderSections;
//# sourceMappingURL=renderSections.js.map

/***/ }),

/***/ 93359:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomizerShell = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable react-hooks/rules-of-hooks */
const react_1 = __webpack_require__(27378);
const penpal_1 = __webpack_require__(97221);
const router_1 = tslib_1.__importDefault(__webpack_require__(86677));
const useCustomizerShell = ({ environment = 'production', isPreview, isShareableToken, sectionComponents, staticProps, storefrontSettingsSchema, }) => {
    if (!isPreview || (isPreview && isShareableToken)) {
        return {
            pageData: staticProps.page || staticProps.blog || staticProps.article,
            storefrontSettings: staticProps?.settings?.settings,
        };
    }
    try {
        const [_pageData, _setPageData] = (0, react_1.useState)(null);
        const [_storefrontSettings, _setStorefrontSettings] = (0, react_1.useState)(null);
        const [parentConnection, setParentConnection] = (0, react_1.useState)(null);
        const [hasLoadedOnce, setHasLoadedOnce] = (0, react_1.useState)(false);
        const [isRouteChanging, setIsRouteChanging] = (0, react_1.useState)(false);
        // eslint-disable-next-line consistent-return
        const _refreshSections = (0, react_1.useCallback)(() => {
            if (!sectionComponents)
                return [];
            const sectionSchemas = sectionComponents
                .map((section) => {
                if (section.Schema && typeof section.Schema === 'function') {
                    const qualifiedSchema = section.Schema({ ...staticProps });
                    return qualifiedSchema;
                }
                return section.Schema;
            })
                .filter(Boolean);
            if (parentConnection) {
                try {
                    const sectionSchemasString = JSON.stringify(sectionSchemas);
                    parentConnection.setSectionsSchemas(sectionSchemasString);
                }
                catch (error) {
                    console.error(error);
                    // parentConnection.displayError('Something went wrong parsing sections');
                }
            }
        }, [staticProps, parentConnection, sectionComponents]);
        // eslint-disable-next-line consistent-return
        const _refreshStorefrontSettingsSchema = (0, react_1.useCallback)(() => {
            if (!storefrontSettingsSchema)
                return [];
            const storefrontSettingsSchemaString = JSON.stringify(storefrontSettingsSchema);
            if (parentConnection) {
                if (sectionComponents) {
                    parentConnection.setStorefrontSettingsSchema(storefrontSettingsSchemaString);
                }
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [staticProps, parentConnection, storefrontSettingsSchema]);
        const handleRouteChangeStart = (url) => {
            if (url !== router_1.default.asPath) {
                setIsRouteChanging(true);
                _setPageData(null); // Clear page data when route changes to new path
            }
        };
        const handleRouteChangeComplete = (0, react_1.useCallback)((url) => {
            if (url === router_1.default.asPath)
                setIsRouteChanging(false);
            if (parentConnection) {
                const currentRoute = {
                    environment,
                    currentPath: router_1.default.router.asPath,
                    template: staticProps?.template,
                    templateType: staticProps?.templateType,
                    handle: staticProps?.pageHandle,
                    title: staticProps?.pageTitle,
                    description: staticProps?.pageDescription,
                };
                parentConnection.setCurrentRoute(currentRoute);
            }
        }, [parentConnection, staticProps, environment]);
        (0, react_1.useEffect)(() => {
            router_1.default.events.on('routeChangeStart', handleRouteChangeStart);
            router_1.default.events.on('routeChangeComplete', handleRouteChangeComplete);
            router_1.default.events.on('routeChangeError', handleRouteChangeComplete);
            return () => {
                router_1.default.events.off('routeChangeStart', handleRouteChangeStart);
                router_1.default.events.off('routeChangeComplete', handleRouteChangeComplete);
                router_1.default.events.off('routeChangeError', handleRouteChangeComplete);
            };
        }, [handleRouteChangeStart, handleRouteChangeComplete]);
        (0, react_1.useEffect)(() => {
            if (parentConnection) {
                parentConnection.onRouteChange(isRouteChanging);
            }
        }, [isRouteChanging, parentConnection]);
        (0, react_1.useEffect)(() => {
            const connection = (0, penpal_1.connectToParent)({
                // Methods child is exposing to parent.
                // parentOrigin: 'http://localhost:3000', // TODO: make this the platform URL
                // parentOrigin: 'https://backpack-platform.herokuapp.com', // TODO: make this the platform URL
                methods: {
                    routeToPage: (path) => {
                        router_1.default.push(path);
                    },
                    scrollToSection: (sectionId) => {
                        const sectionEl = document.querySelector(`[data-comp-id="${sectionId}"]`);
                        if (sectionEl) {
                            sectionEl.scrollIntoView({
                                block: 'center',
                                behavior: 'smooth',
                            });
                        }
                    },
                    /**
                     * This is the live form data from the shell that will be used to render the page.
                     * @param {Object} content : The page content data from form to be rendered;
                     */
                    setPageData: (content) => {
                        _setPageData(content);
                    },
                    /**
                     * This is the live storefront settings from the shell that will be used to render the page.
                     * @param {*} settings : The storefront settings data from form to be rendered;
                     */
                    setStorefrontSettings: (settings) => {
                        _setStorefrontSettings(settings);
                    },
                },
            });
            async function setConnectionMethods() {
                try {
                    const newParentConnection = await connection.promise;
                    setParentConnection(newParentConnection);
                }
                catch (e) {
                    console.error('Error when trying to connect Frame to Customizer Shell.', e);
                }
            }
            setConnectionMethods();
        }, []);
        // Inform the Customizer shell which page we are on on initial load.
        (0, react_1.useEffect)(() => {
            if (parentConnection && !hasLoadedOnce) {
                const currentRoute = {
                    environment,
                    currentPath: router_1.default.router.asPath,
                    template: staticProps?.template,
                    templateType: staticProps?.templateType,
                    handle: staticProps?.pageHandle,
                    title: staticProps?.pageTitle,
                    description: staticProps?.pageDescription, // Needed?
                };
                parentConnection.setCurrentRoute(currentRoute);
                setHasLoadedOnce(true);
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [parentConnection, staticProps]);
        (0, react_1.useEffect)(() => {
            _refreshSections();
            _refreshStorefrontSettingsSchema();
        }, [
            staticProps,
            _refreshSections,
            _refreshStorefrontSettingsSchema,
            sectionComponents,
        ]);
        return {
            pageData: _pageData,
            error: null,
            storefrontSettings: _storefrontSettings,
        };
    }
    catch (error) {
        console.error(error);
        return {
            pageData: staticProps.page,
            error,
            storefrontSettings: staticProps.settings,
        };
    }
};
exports.useCustomizerShell = useCustomizerShell;
//# sourceMappingURL=useCustomizerShell.js.map

/***/ }),

/***/ 96759:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
exports.N$ = __webpack_unused_export__ = void 0;
var memoize_1 = __webpack_require__(29234);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return memoize_1.memoize; } });
var rafTimeoutInterval_1 = __webpack_require__(41756);
Object.defineProperty(exports, "N$", ({ enumerable: true, get: function () { return rafTimeoutInterval_1.rafTimeoutInterval; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 29234:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.memoize = void 0;
const memoize = (fn) => {
    const cache = {};
    return (...args) => {
        const n = args[0];
        if (n in cache) {
            return cache[n];
        }
        const result = fn(n);
        cache[n] = result;
        return result;
    };
};
exports.memoize = memoize;
//# sourceMappingURL=memoize.js.map

/***/ }),

/***/ 41756:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

// See the links below for more information:
// http://creativejs.com/resources/requestanimationframe/
// https://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
//
// Source:
// https://gist.github.com/joyrexus/7304146
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.rafTimeoutInterval = void 0;
const rafTimeoutInterval = () => {
    if (typeof window === 'undefined')
        return;
    var requestAnimFrame = (function () {
        return (window.requestAnimationFrame ||
            window.webkitRequestAnimationFrame ||
            window.mozRequestAnimationFrame ||
            window.oRequestAnimationFrame ||
            window.msRequestAnimationFrame ||
            function (callback) {
                window.setTimeout(callback, 1000 / 60);
            });
    })();
    /**
     * Behaves the same as setInterval except uses requestAnimationFrame() where possible for better performance
     * @param {function} fn The callback function
     * @param {int} delay The delay in milliseconds
     */
    var requestInterval = function (fn, delay) {
        if (!window.requestAnimationFrame &&
            !window.webkitRequestAnimationFrame &&
            // Firefox 5 ships without cancel support
            !(window.mozRequestAnimationFrame && window.mozCancelRequestAnimationFrame) &&
            !window.oRequestAnimationFrame &&
            !window.msRequestAnimationFrame) {
            return window.setInterval(fn, delay);
        }
        var start = new Date().getTime();
        var handle = new Object();
        function loop() {
            var current = new Date().getTime();
            var delta = current - start;
            if (delta >= delay) {
                fn.call();
                start = new Date().getTime();
            }
            handle.value = requestAnimFrame(loop);
        }
        ;
        handle.value = requestAnimFrame(loop);
        return handle;
    };
    /**
    * Behaves the same as setTimeout except uses requestAnimationFrame() where possible for better performance
    * @param {function} fn The callback function
    * @param {int} delay The delay in milliseconds
    */
    var requestTimeout = function (fn, delay) {
        if (!window.requestAnimationFrame &&
            !window.webkitRequestAnimationFrame &&
            // Firefox 5 ships without cancelsupport
            !(window.mozRequestAnimationFrame && window.mozCancelRequestAnimationFrame) &&
            !window.oRequestAnimationFrame &&
            !window.msRequestAnimationFrame) {
            return window.setTimeout(fn, delay);
        }
        var start = new Date().getTime();
        var handle = new Object();
        function loop() {
            var current = new Date().getTime();
            var delta = current - start;
            delta >= delay
                ? fn.call()
                : handle.value = requestAnimFrame(loop);
        }
        ;
        handle.value = requestAnimFrame(loop);
        return handle;
    };
    /**
    * Behaves the same as clearInterval except uses cancelRequestAnimationFrame() where possible for better performance
    * @param {int|object} fn The callback function
    */
    var clearRequestInterval = function (handle) {
        window.cancelAnimationFrame
            ? window.cancelAnimationFrame(handle.value)
            : window.webkitCancelAnimationFrame
                ? window.webkitCancelAnimationFrame(handle.value)
                : window.webkitCancelRequestAnimationFrame
                    ? window.webkitCancelRequestAnimationFrame(handle.value)
                    : /* Support for legacy API */ window.mozCancelRequestAnimationFrame
                        ? window.mozCancelRequestAnimationFrame(handle.value)
                        : window.oCancelRequestAnimationFrame
                            ? window.oCancelRequestAnimationFrame(handle.value)
                            : window.msCancelRequestAnimationFrame
                                ? window.msCancelRequestAnimationFrame(handle.value)
                                : clearInterval(handle);
    };
    /**
     * Behaves the same as clearTimeout except uses cancelRequestAnimationFrame() where possible for better performance
     * @param {int|object} fn The callback function
     */
    var clearRequestTimeout = function (handle) {
        window.cancelAnimationFrame
            ? window.cancelAnimationFrame(handle.value)
            : window.webkitCancelAnimationFrame
                ? window.webkitCancelAnimationFrame(handle.value)
                : window.webkitCancelRequestAnimationFrame
                    ? window.webkitCancelRequestAnimationFrame(handle.value)
                    : /* Support for legacy API */ window.mozCancelRequestAnimationFrame
                        ? window.mozCancelRequestAnimationFrame(handle.value)
                        : window.oCancelRequestAnimationFrame
                            ? window.oCancelRequestAnimationFrame(handle.value)
                            : window.msCancelRequestAnimationFrame
                                ? window.msCancelRequestAnimationFrame(handle.value)
                                : clearTimeout(handle);
    };
    window.requestAnimFrame = requestAnimFrame;
    window.requestInterval = requestInterval;
    window.requestTimeout = requestTimeout;
    window.clearRequestInterval = clearRequestInterval;
    window.clearRequestTimeout = clearRequestTimeout;
};
exports.rafTimeoutInterval = rafTimeoutInterval;
//# sourceMappingURL=rafTimeoutInterval.js.map

/***/ }),

/***/ 48656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ErrorBoundary": function() { return /* binding */ ErrorBoundary; },
/* harmony export */   "ErrorBoundaryContext": function() { return /* binding */ ErrorBoundaryContext; },
/* harmony export */   "useErrorBoundary": function() { return /* binding */ useErrorBoundary; },
/* harmony export */   "withErrorBoundary": function() { return /* binding */ withErrorBoundary; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
'use client';


const ErrorBoundaryContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);

const initialState = {
  didCatch: false,
  error: null
};
class ErrorBoundary extends react__WEBPACK_IMPORTED_MODULE_0__.Component {
  constructor(props) {
    super(props);
    this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
    this.state = initialState;
  }
  static getDerivedStateFromError(error) {
    return {
      didCatch: true,
      error
    };
  }
  resetErrorBoundary() {
    const {
      error
    } = this.state;
    if (error !== null) {
      var _this$props$onReset, _this$props;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 ? void 0 : _this$props$onReset.call(_this$props, {
        args,
        reason: "imperative-api"
      });
      this.setState(initialState);
    }
  }
  componentDidCatch(error, info) {
    var _this$props$onError, _this$props2;
    (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 ? void 0 : _this$props$onError.call(_this$props2, error, info);
  }
  componentDidUpdate(prevProps, prevState) {
    const {
      didCatch
    } = this.state;
    const {
      resetKeys
    } = this.props;

    // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
    // we'd end up resetting the error boundary immediately.
    // This would likely trigger a second error to be thrown.
    // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.

    if (didCatch && prevState.error !== null && hasArrayChanged(prevProps.resetKeys, resetKeys)) {
      var _this$props$onReset2, _this$props3;
      (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 ? void 0 : _this$props$onReset2.call(_this$props3, {
        next: resetKeys,
        prev: prevProps.resetKeys,
        reason: "keys"
      });
      this.setState(initialState);
    }
  }
  render() {
    const {
      children,
      fallbackRender,
      FallbackComponent,
      fallback
    } = this.props;
    const {
      didCatch,
      error
    } = this.state;
    let childToRender = children;
    if (didCatch) {
      const props = {
        error,
        resetErrorBoundary: this.resetErrorBoundary
      };
      if (typeof fallbackRender === "function") {
        childToRender = fallbackRender(props);
      } else if (FallbackComponent) {
        childToRender = (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(FallbackComponent, props);
      } else if (fallback === null || (0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(fallback)) {
        childToRender = fallback;
      } else {
        throw error;
      }
    }
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(ErrorBoundaryContext.Provider, {
      value: {
        didCatch,
        error,
        resetErrorBoundary: this.resetErrorBoundary
      }
    }, childToRender);
  }
}
function hasArrayChanged() {
  let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return a.length !== b.length || a.some((item, index) => !Object.is(item, b[index]));
}

function assertErrorBoundaryContext(value) {
  if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") {
    throw new Error("ErrorBoundaryContext not found");
  }
}

function useErrorBoundary() {
  const context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ErrorBoundaryContext);
  assertErrorBoundaryContext(context);
  const [state, setState] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
    error: null,
    hasError: false
  });
  const memoized = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => ({
    resetBoundary: () => {
      context.resetErrorBoundary();
      setState({
        error: null,
        hasError: false
      });
    },
    showBoundary: error => setState({
      error,
      hasError: true
    })
  }), [context.resetErrorBoundary]);
  if (state.hasError) {
    throw state.error;
  }
  return memoized;
}

function withErrorBoundary(component, errorBoundaryProps) {
  const Wrapped = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, ref) => (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(ErrorBoundary, errorBoundaryProps, (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(component, {
    ...props,
    ref
  })));

  // Format for display in DevTools
  const name = component.displayName || component.name || "Unknown";
  Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
  return Wrapped;
}




/***/ }),

/***/ 79141:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(14284);

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.StateProvider = void 0;
const tslib_1 = __webpack_require__(59312);
const jsx_runtime_1 = __webpack_require__(24246);
const recoil_1 = __webpack_require__(69853);
const recoil_toolkit_1 = __webpack_require__(80434);
const store_1 = tslib_1.__importDefault(__webpack_require__(24385));
function StateProvider({ storefrontSettings, route, pageData, pageProps, children, }) {
    function initializeState({ set }) {
        set(store_1.default.storefrontSettings, storefrontSettings);
        set(store_1.default.route, route);
        if (!pageData)
            return;
        if (pageData?.resourceType === 'product_page') {
            set(store_1.default.product, pageProps.product);
        }
        if (pageData?.resourceType === 'collection_page') {
            set(store_1.default.collection, pageProps.collection);
        }
        if (pageData?.resourceType === 'page') {
            set(store_1.default.page, pageProps.page);
        }
        if (pageData?.resourceType === 'blog') {
            set(store_1.default.blog, pageProps.blog);
        }
        if (pageData?.resourceType === 'article') {
            set(store_1.default.article, pageProps.article);
        }
    }
    const isDevelopment = "production" === 'development';
    // eslint-disable-next-line eqeqeq
    const recoilDevToolsEnabled = process.env.RECOIL_DEV_TOOLS_ENABLED == 'true';
    if (isDevelopment && recoilDevToolsEnabled) {
        return (
        // eslint-disable-next-line react/jsx-filename-extension
        (0, jsx_runtime_1.jsxs)(recoil_1.RecoilRoot, { initializeState: initializeState, children: [(0, jsx_runtime_1.jsx)(recoil_toolkit_1.RecoilDevTools, { enableConsole: true }), children] }));
    }
    return (0, jsx_runtime_1.jsx)(recoil_1.RecoilRoot, { initializeState: initializeState, children: children });
}
exports.StateProvider = StateProvider;
//# sourceMappingURL=StateProvider.js.map

/***/ }),

/***/ 98043:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.analyticsStore = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable max-lines */
const recoil_1 = __webpack_require__(69853);
const effects_1 = tslib_1.__importDefault(__webpack_require__(49025));
/**
  Analytics State
*/
const customerAndCartInit = (0, recoil_1.atom)({
    key: 'analytics/customerAndCartInit',
    default: false,
    effects: [
        // effects.logStateChange('customerAndCartInit'),
        effects_1.default.onChange({
            key: 'customerAndCartInit',
            topic: 'CUSTOMER_AND_CART_INIT',
            actions: ['publishGtmEvent', 'publishBusEvent'],
        }),
    ],
});
exports.analyticsStore = {
    // actual state - atoms
    customerAndCartInit,
};
//# sourceMappingURL=analytics.js.map

/***/ }),

/***/ 9807:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.analyticsStore = void 0;
var analytics_1 = __webpack_require__(98043);
Object.defineProperty(exports, "analyticsStore", ({ enumerable: true, get: function () { return analytics_1.analyticsStore; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 772:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useArticle = void 0;
var useArticle_1 = __webpack_require__(94170);
Object.defineProperty(exports, "useArticle", ({ enumerable: true, get: function () { return useArticle_1.useArticle; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 94170:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useArticle = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useArticle = () => (0, store_1.useRecoilValue)(store_1.default.article);
exports.useArticle = useArticle;
//# sourceMappingURL=useArticle.js.map

/***/ }),

/***/ 11634:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.articleStore = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable max-lines */
const recoil_1 = __webpack_require__(69853);
const effects_1 = tslib_1.__importDefault(__webpack_require__(49025));
/**
  Article State
*/
const article = (0, recoil_1.atom)({
    key: 'article/article',
    default: null,
    effects: [
        // effects.logStateChange('article'),
        effects_1.default.onChange({
            key: 'article',
            topic: 'ARTICLE_UPDATE',
            actions: ['publishBusEvent'],
        }),
    ],
});
const articlesList = (0, recoil_1.atom)({
    key: 'article/articlesList',
    default: [],
});
// articles json fuse index
const articlesIndex = (0, recoil_1.atom)({
    key: 'article/articlesIndex',
    default: null, // { keys: [], records: [] }
});
exports.articleStore = {
    // actual state - atoms
    article,
    articlesIndex,
    articlesList,
};
//# sourceMappingURL=article.js.map

/***/ }),

/***/ 32159:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.articleStore = void 0;
var article_1 = __webpack_require__(11634);
Object.defineProperty(exports, "articleStore", ({ enumerable: true, get: function () { return article_1.articleStore; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 51457:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useBlog = void 0;
var useBlog_1 = __webpack_require__(2897);
Object.defineProperty(exports, "useBlog", ({ enumerable: true, get: function () { return useBlog_1.useBlog; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2897:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useBlog = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useBlog = () => (0, store_1.useRecoilValue)(store_1.default.blog);
exports.useBlog = useBlog;
//# sourceMappingURL=useBlog.js.map

/***/ }),

/***/ 6345:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.blogStore = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable max-lines */
const recoil_1 = __webpack_require__(69853);
const effects_1 = tslib_1.__importDefault(__webpack_require__(49025));
/**
  Blog State
*/
const blog = (0, recoil_1.atom)({
    key: 'blog/blog',
    default: null,
    effects: [
        effects_1.default.onChange({
            key: 'blog',
            topic: 'BLOG_UPDATE',
            actions: ['publishBusEvent'],
        }),
    ],
});
const blogsList = (0, recoil_1.atom)({
    key: 'blog/blogsList',
    default: [],
});
// blogs json fuse index
const blogsIndex = (0, recoil_1.atom)({
    key: 'blog/blogsIndex',
    default: null, // { keys: [], recors: [] }
});
exports.blogStore = {
    // actual state - atoms
    blog,
    blogsIndex,
    blogsList,
};
//# sourceMappingURL=blog.js.map

/***/ }),

/***/ 3727:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.blogStore = void 0;
var blog_1 = __webpack_require__(6345);
Object.defineProperty(exports, "blogStore", ({ enumerable: true, get: function () { return blog_1.blogStore; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 90106:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CartClient = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable no-undef */
/* eslint-disable class-methods-use-this */
const graphql_request_1 = __webpack_require__(63671);
const humanize_graphql_response_1 = tslib_1.__importDefault(__webpack_require__(27207));
const queries_1 = __webpack_require__(24765);
const mutations_1 = __webpack_require__(69881);
/**
 * @see: https://shopify.dev/custom-storefronts/cart
 */
class CartClient {
    constructor({ apiToken, apiVersion, domain, debug }) {
        this.apiToken = apiToken;
        this.apiVersion = apiVersion;
        this.domain = domain;
        this.endpoint = '';
        this.options = {};
        this.debug = debug || false;
        this.client = this.initClient();
    }
    initClient() {
        this.endpoint = `https://${this.domain}/api/${this.apiVersion}/graphql.json`;
        // client
        this.options = {
            method: 'POST',
            mode: 'cors',
            headers: {
                'X-Shopify-Storefront-Access-Token': this.apiToken,
                'Content-Type': 'application/json; charset=utf-8',
            },
        };
        return new graphql_request_1.GraphQLClient(this.endpoint, this.options);
    }
    /**
     * Customer queries client
     * @param {gqlQuery} query
     * @param {object} variables
     * @returns
     */
    async query({ query, variables }) {
        if (this.debug) {
            console.log('CartClient:', query, variables);
        }
        return this.client.rawRequest(query, variables);
    }
    /**
     * Customer mutation client
     * @param {gqlMutation} mutation
     * @param {object} variables
     * @returns
     */
    async mutate({ mutation, variables }) {
        if (this.debug) {
            console.log('CartClient:', mutation, variables);
        }
        return this.client.rawRequest(mutation, variables);
    }
    /**
     * Create a new cart
     * @param {country} twoDigitCountryCode - US, MX..
     * @param {cartInput} cartInput - can pass any valid cart param here: e.g — buyerIdentity, attributes etc..
     * @returns a new full cart instance
     */
    async create({ country, cartInput } = { county: 'US', cartInput: {} }) {
        try {
            if (!cartInput) {
                throw new Error('cart create failed "cartInput" not provided');
            }
            const { data, errors, status } = await this.mutate({
                mutation: mutations_1.mutations.create,
                variables: { country, cartInput },
            });
            if (status !== 200) {
                throw new Error(`Network request failed with status ${status}`);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            const { cartCreate: { cart, userErrors }, } = data;
            if (userErrors?.length) {
                throw new Error(userErrors[0].message);
            }
            return { error: null, newCart: (0, humanize_graphql_response_1.default)(cart) };
        }
        catch (error) {
            return { error: error.message, newCart: null };
        }
    }
    /**
     * Retrieve an existing cart by id
     * @param {id} cart.id "Z2lkOi8vc2hvcGlmeS9DYXJ0LzRlMDFmMTQ5YTQ2MThlYzFmYzgwYjljMjk1ZGZjZTk4"
     * @returns full cart object
     */
    async get({ id, country } = { id: '', country: 'US' }) {
        try {
            if (!id) {
                throw new Error('cart get failed "id" not provided');
            }
            const query = queries_1.queries.get;
            const variables = { id, country };
            // get cart
            const { data, errors, status } = await this.query({ query, variables });
            if (status !== 200) {
                throw new Error(`Network request failed with status ${status}`);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            if (!data?.cart) {
                throw new Error('Cart object not returned in response');
            }
            return { error: null, existingCart: (0, humanize_graphql_response_1.default)(data.cart) };
        }
        catch (error) {
            return { error: error.message, existingCart: null };
        }
    }
    /**
     * Add a line item to the cart
     * @param {*} param0
     * @returns
     */
    async addItem({ cartId, country, merchandiseId, quantity, sellingPlanId, attributes } = {
        cartId: null,
        country: 'US',
        attributes: [],
        merchandiseId: null,
        quantity: 1,
        sellingPlanId: null,
    }) {
        try {
            if (!cartId) {
                throw new Error('addItem "cartId" not provided');
            }
            if (!merchandiseId) {
                throw new Error('addItem "merchandiseId" not provided');
            }
            // update cart with a single line item
            const { data, errors, status } = await this.mutate({
                mutation: mutations_1.mutations.addItems,
                variables: sellingPlanId
                    ? {
                        cartId,
                        country,
                        lines: [{ attributes, merchandiseId, quantity, sellingPlanId }],
                    }
                    : {
                        cartId,
                        country,
                        lines: [{ attributes, merchandiseId, quantity }],
                    },
            });
            if (status !== 200) {
                throw new Error(`Add item request failed with status ${status}`);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            if (!data?.cartLinesAdd?.updatedCart) {
                throw new Error('Add item cart object not returned in response');
            }
            const { updatedCart } = data.cartLinesAdd;
            return { error: null, updatedCart: (0, humanize_graphql_response_1.default)(updatedCart) };
        }
        catch (error) {
            return { error: error.message, updatedCart: null };
        }
    }
    /**
     * Add multiple line items to the cart
     * @param {*} param0
     * @returns
     */
    async addItems({ cartId, lines, country } = {
        cartId: null,
        country: 'US',
        lines: [],
    }) {
        try {
            if (!cartId) {
                throw new Error('addItems "cartId" not provided');
            }
            if (!lines) {
                throw new Error('addItems "lines" not provided');
            }
            const { data, errors, status } = await this.mutate({
                mutation: mutations_1.mutations.addItems,
                variables: { cartId, country, lines },
            });
            if (status !== 200) {
                throw new Error(`Add item request failed with status ${status}`);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            if (!data?.cartLinesAdd?.updatedCart) {
                throw new Error('Add item cart object not returned in response');
            }
            const { updatedCart } = data.cartLinesAdd;
            return { error: null, updatedCart: (0, humanize_graphql_response_1.default)(updatedCart) };
        }
        catch (error) {
            return { error: error.message, updatedCart: null };
        }
    }
    /**
     * Remove a line item by id
     * @param {*} param0
     * @returns
     */
    async removeItem({ cartId, country, lineId } = {
        cartId: null,
        country: 'US',
        lineId: null,
    }) {
        try {
            if (!cartId) {
                throw new Error('removeItem "cartId" not provided');
            }
            if (!lineId) {
                throw new Error('removeItem "lineId" not provided');
            }
            const { data, errors, status } = await this.mutate({
                mutation: mutations_1.mutations.removeItems,
                variables: {
                    cartId,
                    country,
                    lineIds: [lineId],
                },
            });
            if (status !== 200) {
                throw new Error(`Add item request failed with status ${status}`);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            if (!data?.cartLinesRemove?.updatedCart) {
                throw new Error('Remove item cart object not returned in response');
            }
            const { updatedCart } = data.cartLinesRemove;
            return { error: null, updatedCart: (0, humanize_graphql_response_1.default)(updatedCart) };
        }
        catch (error) {
            return { error: error.message, updatedCart: null };
        }
    }
    /**
     * Remove multiple items from the cart by lineIds
     * @param {*} param0
     * @returns
     */
    async removeItems({ cartId, country, lineIds } = {
        cartId: null,
        country: 'US',
        lineIds: [],
    }) {
        try {
            if (!cartId) {
                throw new Error('removeItems "cartId" not provided');
            }
            if (!lineIds) {
                throw new Error('removeItems "lineIds" not provided');
            }
            const { data, errors, status } = await this.mutate({
                mutation: mutations_1.mutations.removeItems,
                variables: {
                    cartId,
                    country,
                    lineIds,
                },
            });
            if (status !== 200) {
                throw new Error(`Add item request failed with status ${status}`);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            if (!data?.cartLinesRemove?.updatedCart) {
                throw new Error('Remove item cart object not returned in response');
            }
            const { updatedCart } = data.cartLinesRemove;
            return { error: null, updatedCart: (0, humanize_graphql_response_1.default)(updatedCart) };
        }
        catch (error) {
            return { error: error.message, updatedCart: null };
        }
    }
    /**
     * Update a line item property
     * @param {*} param0
     * @returns
     */
    async updateItem({ cartId, country, lineId, quantity, merchandiseId, attributes, sellingPlanId, } = {
        cartId: null,
        country: 'US',
        lineId: null,
        quantity: 0,
        merchandiseId: null,
        attributes: [],
        sellingPlanId: null,
    }) {
        try {
            if (!cartId) {
                throw new Error('updateItem "cartId" not provided');
            }
            if (!lineId) {
                throw new Error('updateItem "lineId" not provided');
            }
            const update = { id: lineId };
            if (quantity) {
                update.quantity = quantity;
            }
            if (merchandiseId) {
                update.merchandiseId = merchandiseId;
            }
            if (attributes) {
                update.attributes = attributes;
            }
            if (sellingPlanId) {
                update.sellingPlanId = sellingPlanId;
            }
            const { data, errors, status } = await this.mutate({
                mutation: mutations_1.mutations.updateItems,
                variables: {
                    cartId,
                    country,
                    lines: [update],
                },
            });
            if (status !== 200) {
                throw new Error(`Update item request failed with status ${status}`);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            if (!data?.cartLinesUpdate?.updatedCart) {
                throw new Error('Update item cart object not returned in response');
            }
            const { updatedCart } = data.cartLinesUpdate;
            return { error: null, updatedCart: (0, humanize_graphql_response_1.default)(updatedCart) };
        }
        catch (error) {
            return { error: error.message, updatedCart: null };
        }
    }
    /**
     * Update multiple line items at once
     * @param {*} param0
     * @returns
     */
    async updateItems({ cartId, country, lines } = {
        cartId: null,
        country: 'US',
        lines: [],
    }) {
        try {
            if (!cartId) {
                throw new Error('updateItems "cartId" not provided');
            }
            if (!lines?.length) {
                throw new Error('updateItems "lines" not provided');
            }
            const lineToUpdate = (line) => {
                const updatedLine = {
                    id: line.lineId,
                    quantity: line?.quantity,
                    merchandiseId: line?.variant?.id || '',
                    attributes: line?.attributes || [],
                };
                if (line?.sellingPlanId) {
                    updatedLine.sellingPlanId = line.sellingPlanId;
                }
                return updatedLine;
            };
            const { data, errors, status } = await this.mutate({
                mutation: mutations_1.mutations.updateItems,
                variables: {
                    cartId,
                    country,
                    lines: lines.map(lineToUpdate),
                },
            });
            if (status !== 200) {
                throw new Error(`Update items request failed with status ${status}`);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            if (!data?.cartLinesUpdate?.updatedCart) {
                throw new Error('Update items cart object not returned in response');
            }
            const { updatedCart } = data.cartLinesUpdate;
            return { error: null, updatedCart: (0, humanize_graphql_response_1.default)(updatedCart) };
        }
        catch (error) {
            return { error: error.message, updatedCart: null };
        }
    }
    /**
     * Update cart note
     * @param {*} param0
     * @returns
     */
    async updateNote({ cartId, country, note } = {
        cartId: null,
        country: 'US',
        note: '',
    }) {
        try {
            if (!cartId) {
                throw new Error('updateNode "cartId" not provided');
            }
            if (typeof note === 'undefined') {
                throw new Error('updateNode "note" not provided');
            }
            const { data, errors, status } = await this.mutate({
                mutation: mutations_1.mutations.updateNote,
                variables: { cartId, country, note },
            });
            if (status !== 200) {
                throw new Error(`Update note request failed with status ${status}`);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            if (!data?.cartNoteUpdate?.updatedCart) {
                throw new Error('Update note cart object not returned in response');
            }
            const { updatedCart } = data.cartNoteUpdate;
            return { error: null, updatedCart: (0, humanize_graphql_response_1.default)(updatedCart) };
        }
        catch (error) {
            return { error: error.message, updatedCart: null };
        }
    }
    /**
     * Update cart discount code
     * @param {*} param0
     * @returns
     */
    async updateDiscount({ cartId, country, discountCode } = {
        cartId: null,
        country: 'US',
        discountCode: '',
    }) {
        try {
            if (!cartId) {
                throw new Error('updateDiscount "cartId" not provided');
            }
            if (!discountCode) {
                throw new Error('updateDiscount "discountCode" not provided');
            }
            // only one is discountCode is allowed, god knows why they want this as an array.
            const { data, errors, status } = await this.mutate({
                mutation: mutations_1.mutations.updateDiscountCode,
                variables: { cartId, country, discountCodes: [discountCode] },
            });
            if (status !== 200) {
                throw new Error(`Update discount request failed with status ${status}`);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            if (!data?.cartDiscountCodesUpdate?.updatedCart) {
                throw new Error('Update discount cart object not returned in response');
            }
            const { updatedCart } = data.cartDiscountCodesUpdate;
            return { error: null, updatedCart: (0, humanize_graphql_response_1.default)(updatedCart) };
        }
        catch (error) {
            return { error: error.message, updatedCart: null };
        }
    }
    /**
     * Remove cart discount code
     * @param {*} param0
     * @returns
     */
    async removeDiscount({ cartId, country } = {
        cartId: null,
        country: 'US',
    }) {
        try {
            if (!cartId) {
                throw new Error('removeDiscount "cartId" not provided');
            }
            // remove discount code by passing an empty array
            const { data, errors, status } = await this.mutate({
                mutation: mutations_1.mutations.updateDiscountCode,
                variables: { cartId, country, discountCodes: [] },
            });
            if (status !== 200) {
                throw new Error(`remove discount request failed with status ${status}`);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            if (!data?.cartDiscountCodesUpdate?.updatedCart) {
                throw new Error('Update discount cart object not returned in response');
            }
            const { updatedCart } = data.cartDiscountCodesUpdate;
            return { error: null, updatedCart: (0, humanize_graphql_response_1.default)(updatedCart) };
        }
        catch (error) {
            return { error: error.message, updatedCart: null };
        }
    }
    /**
     * Update cart attributes
     * @param {[{ key, value }...]} attributes
     * @returns
     */
    async updateAttributes({ cartId, country, attributes } = {
        cartId: null,
        country: 'US',
        attributes: [],
    }) {
        try {
            if (!cartId) {
                throw new Error('updateAttributes "cartId" not provided');
            }
            if (!attributes) {
                throw new Error('updateAttributes "attributes" not provided');
            }
            // update cart-level attributes (not line attributes)
            const { data, errors, status } = await this.mutate({
                mutation: mutations_1.mutations.updateAttributes,
                variables: { cartId, country, attributes },
            });
            if (status !== 200) {
                throw new Error(`Update attributes request failed with status ${status}`);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            if (!data?.cartAttributesUpdate?.updatedCart) {
                throw new Error('Update attributes cart object not returned in response');
            }
            const { updatedCart } = data.cartAttributesUpdate;
            return { error: null, updatedCart: (0, humanize_graphql_response_1.default)(updatedCart) };
        }
        catch (error) {
            return { error: error.message, updatedCart: null };
        }
    }
    /**
     * Update cart attributes
     * @param {object} buyerIdentity
     * @param {country} twoDigitCountryCode - US, MX..
     * @returns
     */
    async updateBuyerIdentity({ cartId, country, buyerIdentity } = {
        cartId: null,
        buyerIdentity: null,
        country: 'US',
    }) {
        try {
            if (!cartId) {
                throw new Error('updateBuyerIdentity "cartId" not provided');
            }
            if (!buyerIdentity) {
                throw new Error('updateBuyerIdentity "buyerIdentity" not provided');
            }
            // update cart-level attributes (not line attributes)
            const { data, errors, status } = await this.mutate({
                mutation: mutations_1.mutations.updateBuyerIdentity,
                variables: { cartId, country, buyerIdentity },
            });
            if (status !== 200) {
                throw new Error(`Update buyerIdentity request failed with status ${status}`);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            if (!data?.cartBuyerIdentityUpdate?.updatedCart) {
                throw new Error('Update attributes cart object not returned in response');
            }
            const updatedCart = (0, humanize_graphql_response_1.default)(data.cartBuyerIdentityUpdate.updatedCart);
            return { error: null, updatedCart };
        }
        catch (error) {
            return { error: error.message, updatedCart: null };
        }
    }
}
exports.CartClient = CartClient;
//# sourceMappingURL=client.js.map

/***/ }),

/***/ 72728:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const graphql_request_1 = __webpack_require__(63671);
const customerFragment = (0, graphql_request_1.gql) `
  fragment Customer on Customer {
    acceptsMarketing
    createdAt
    defaultAddress {
      firstName
      lastName
      formatted
      formattedArea
      name
      address1
      address2
      latitude
      longitude
      id
      company
      country
      countryCodeV2
      province
      provinceCode
      phone
    }
    displayName
    email
    firstName
    id
    lastName
    phone
    tags
    updatedAt
    orders(first: 10) {
      edges {
        node {
          orderNumber
          id
        }
      }
    }
  }
`;
const buyerIdentity = (0, graphql_request_1.gql) `
  fragment BuyerIdentity on CartBuyerIdentity {
    email
    phone
    countryCode
    customer {
      ...Customer
    }
  }
  ${customerFragment}
`;
const attribute = (0, graphql_request_1.gql) `
  fragment Attribute on Attribute {
    key
    value
  }
`;
const discountCode = (0, graphql_request_1.gql) `
  fragment DiscountCode on CartDiscountCode {
    applicable
    code
  }
`;
const moneyV2 = (0, graphql_request_1.gql) `
  fragment MoneyV2 on MoneyV2 {
    amount
    currencyCode
  }
`;
const estimatedCost = (0, graphql_request_1.gql) `
  fragment EstimatedCost on CartEstimatedCost {
    subtotalAmount {
      ...MoneyV2
    }
    totalAmount {
      ...MoneyV2
    }
    totalDutyAmount {
      ...MoneyV2
    }
    totalTaxAmount {
      ...MoneyV2
    }
  }
`;
const lineEstimatedCost = (0, graphql_request_1.gql) `
  fragment LineEstimatedCost on CartLineEstimatedCost {
    subtotalAmount {
      ...MoneyV2
    }
    totalAmount {
      ...MoneyV2
    }
  }
`;
const discountAllocation = (0, graphql_request_1.gql) `
  fragment DiscountAllocation on CartDiscountAllocation {
    discountedAmount {
      ...MoneyV2
    }
    ... on CartCodeDiscountAllocation {
      __typename
      code
      discountedAmount {
        ...MoneyV2
      }
    }
    ... on CartCustomDiscountAllocation {
      __typename
      discountedAmount {
        ...MoneyV2
      }
      title
    }
    ... on CartAutomaticDiscountAllocation {
      __typename
      discountedAmount {
        ...MoneyV2
      }
      title
    }
  }
`;
const image = (0, graphql_request_1.gql) `
  fragment Image on Image {
    altText
    height
    src
    id
    width
  }
`;
const selectedOption = (0, graphql_request_1.gql) `
  fragment SelectedOption on SelectedOption {
    name
    value
  }
`;
const unitPriceMeasurement = (0, graphql_request_1.gql) `
  fragment UnitPriceMeasurement on UnitPriceMeasurement {
    measuredType
    quantityUnit
    quantityValue
    referenceUnit
    referenceValue
  }
`;
// barcode is erroring for some reason
const productVariant = (0, graphql_request_1.gql) `
  fragment ProductVariant on ProductVariant {
    availableForSale
    compareAtPriceV2 {
      ...MoneyV2
    }
    currentlyNotInStock
    id
    image {
      ...Image
    }
    priceV2 {
      ...MoneyV2
    }
    product {
      handle
      id
      title
      tags
      onlineStoreUrl
      collections(first: 100) {
        nodes {
          handle
        }
      }
      productType
    }
    quantityAvailable
    requiresShipping
    selectedOptions {
      ...SelectedOption
    }
    sku
    title
    unitPrice {
      ...MoneyV2
    }
    unitPriceMeasurement {
      ...UnitPriceMeasurement
    }
    weight
    weightUnit
  }
`;
const merchandise = (0, graphql_request_1.gql) `
  fragment Merchandise on Merchandise {
    ...ProductVariant
  }
`;
const priceAdjustment = (0, graphql_request_1.gql) `
  fragment PriceAdjustment on SellingPlanAllocationPriceAdjustment {
    compareAtPrice {
      ...MoneyV2
    }
    perDeliveryPrice {
      ...MoneyV2
    }
    price {
      ...MoneyV2
    }
    unitPrice {
      ...MoneyV2
    }
  }
`;
const sellingPlanOption = (0, graphql_request_1.gql) `
  fragment SellingPlanOption on SellingPlanOption {
    name
    value
  }
`;
const sellingPlan = (0, graphql_request_1.gql) `
  fragment SellingPlan on SellingPlan {
    description
    id
    name
    options {
      ...SellingPlanOption
    }
    recurringDeliveries
  }
`;
const fullCartFragment = (0, graphql_request_1.gql) `
  fragment FullCart on Cart {
    attributes {
      ...Attribute
    }
    buyerIdentity {
      ...BuyerIdentity
    }
    checkoutUrl
    createdAt
    discountAllocations {
      ...DiscountAllocation
    }
    discountCodes {
      ...DiscountCode
    }
    estimatedCost {
      ...EstimatedCost
    }
    id
    lines(first: 100) {
      edges {
        node {
          attributes {
            ...Attribute
          }
          discountAllocations {
            ...DiscountAllocation
          }
          estimatedCost {
            ...LineEstimatedCost
          }
          id
          variant: merchandise {
            ...Merchandise
          }
          quantity
          sellingPlanAllocation {
            sellingPlan {
              ...SellingPlan
            }
            priceAdjustments {
              ...PriceAdjustment
            }
          }
        }
      }
    }
    note
    updatedAt
    __typename
  }
  ${buyerIdentity}
  ${attribute}
  ${discountCode}
  ${moneyV2}
  ${estimatedCost}
  ${lineEstimatedCost}
  ${discountAllocation}
  ${image}
  ${selectedOption}
  ${unitPriceMeasurement}
  ${priceAdjustment}
  ${sellingPlan}
  ${sellingPlanOption}
  ${productVariant}
  ${merchandise}
`;
const useErrors = (0, graphql_request_1.gql) `
  fragment UserError on CartUserError {
    code
    field
    message
  }
`;
exports["default"] = {
    useErrors,
    fullCartFragment,
};
//# sourceMappingURL=fragments.js.map

/***/ }),

/***/ 4812:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CartClient = void 0;
var client_1 = __webpack_require__(90106);
Object.defineProperty(exports, "CartClient", ({ enumerable: true, get: function () { return client_1.CartClient; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 69881:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.mutations = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable prettier/prettier */
const graphql_request_1 = __webpack_require__(63671);
const fragments_1 = tslib_1.__importDefault(__webpack_require__(72728));
/*
  Mutations
*/
const addItems = (0, graphql_request_1.gql) `
  mutation addItems($country: CountryCode, $cartId: ID!, $lines: [CartLineInput!]!)
  @inContext(country: $country) {
    cartLinesAdd(cartId: $cartId, lines: $lines) {
      updatedCart: cart {
        ...FullCart
      }
      userErrors {
        ...UserError
      }
    }
  }
  ${fragments_1.default.fullCartFragment}
  ${fragments_1.default.useErrors}
`;
const create = (0, graphql_request_1.gql) `
  mutation create($country: CountryCode, $cartInput: CartInput)
  @inContext(country: $country) {
    cartCreate(input: $cartInput) {
      cart {
        ...FullCart
      }
      userErrors {
        ...UserError
      }
    }
  }
  ${fragments_1.default.fullCartFragment}
  ${fragments_1.default.useErrors}
`;
const removeItems = (0, graphql_request_1.gql) `
  mutation removeItems($country: CountryCode, $cartId: ID!, $lineIds: [ID!]!)
  @inContext(country: $country) {
    cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {
      updatedCart: cart {
        ...FullCart
      }
      userErrors {
        ...UserError
      }
    }
  }
  ${fragments_1.default.fullCartFragment}
  ${fragments_1.default.useErrors}
`;
const updateAttributes = (0, graphql_request_1.gql) `
  mutation updateAttributes($country: CountryCode, $cartId: ID!, $attributes: [AttributeInput!]!)
  @inContext(country: $country) {
    cartAttributesUpdate(cartId: $cartId, attributes: $attributes) {
      updatedCart: cart {
        ...FullCart
      }
      userErrors {
        ...UserError
      }
    }
  }
  ${fragments_1.default.fullCartFragment}
  ${fragments_1.default.useErrors}
`;
const updateBuyerIdentity = (0, graphql_request_1.gql) `
  mutation updateBuyerIdentity($country: CountryCode, $cartId: ID!, $buyerIdentity: CartBuyerIdentityInput!)
  @inContext(country: $country) {
    cartBuyerIdentityUpdate(cartId: $cartId, buyerIdentity: $buyerIdentity) {
      updatedCart: cart {
        ...FullCart
      }
      userErrors {
        ...UserError
      }
    }
  }
  ${fragments_1.default.fullCartFragment}
  ${fragments_1.default.useErrors}
`;
const updateDiscountCode = (0, graphql_request_1.gql) `
  mutation updateDiscountCode($country: CountryCode, $cartId: ID!, $discountCodes: [String!])
  @inContext(country: $country) {
    cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
      updatedCart: cart {
        ...FullCart
      }
      userErrors {
        ...UserError
      }
    }
  }
  ${fragments_1.default.fullCartFragment}
  ${fragments_1.default.useErrors}
`;
const updateItems = (0, graphql_request_1.gql) `
  mutation updateItems($country: CountryCode, $cartId: ID!, $lines: [CartLineUpdateInput!]!)
  @inContext(country: $country) {
    cartLinesUpdate(cartId: $cartId, lines: $lines) {
      updatedCart: cart {
        ...FullCart
      }
      userErrors {
        ...UserError
      }
    }
  }
  ${fragments_1.default.fullCartFragment}
  ${fragments_1.default.useErrors}
`;
const updateNote = (0, graphql_request_1.gql) `
  mutation updateNote($country: CountryCode, $cartId: ID!, $note: String)
  @inContext(country: $country) {
    cartNoteUpdate(cartId: $cartId, note: $note) {
      updatedCart: cart {
        ...FullCart
      }
      userErrors {
        ...UserError
      }
    }
  }
  ${fragments_1.default.fullCartFragment}
  ${fragments_1.default.useErrors}
`;
exports.mutations = {
    addItems,
    create,
    removeItems,
    updateAttributes,
    updateBuyerIdentity,
    updateDiscountCode,
    updateItems,
    updateNote,
};
//# sourceMappingURL=mutations.js.map

/***/ }),

/***/ 24765:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.queries = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable prettier/prettier */
const graphql_request_1 = __webpack_require__(63671);
const fragments_1 = tslib_1.__importDefault(__webpack_require__(72728));
/*
  Queries
*/
const get = (0, graphql_request_1.gql) `
  query ($id: ID!, $country: CountryCode) @inContext(country: $country) {
    cart(id: $id) {
      ...FullCart
    }
  }
  ${fragments_1.default.fullCartFragment}
`;
exports.queries = {
    get,
};
//# sourceMappingURL=queries.js.map

/***/ }),

/***/ 48081:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(59312);
tslib_1.__exportStar(__webpack_require__(87892), exports);
tslib_1.__exportStar(__webpack_require__(26228), exports);
tslib_1.__exportStar(__webpack_require__(91887), exports);
tslib_1.__exportStar(__webpack_require__(44717), exports);
// getters / selectors
tslib_1.__exportStar(__webpack_require__(67542), exports);
tslib_1.__exportStar(__webpack_require__(69659), exports);
tslib_1.__exportStar(__webpack_require__(63953), exports);
tslib_1.__exportStar(__webpack_require__(53660), exports);
tslib_1.__exportStar(__webpack_require__(88587), exports);
tslib_1.__exportStar(__webpack_require__(10295), exports);
tslib_1.__exportStar(__webpack_require__(82914), exports);
tslib_1.__exportStar(__webpack_require__(83061), exports);
tslib_1.__exportStar(__webpack_require__(13437), exports);
tslib_1.__exportStar(__webpack_require__(13015), exports); // no-op
tslib_1.__exportStar(__webpack_require__(26511), exports);
tslib_1.__exportStar(__webpack_require__(69745), exports);
tslib_1.__exportStar(__webpack_require__(68692), exports);
tslib_1.__exportStar(__webpack_require__(72249), exports);
tslib_1.__exportStar(__webpack_require__(11350), exports);
tslib_1.__exportStar(__webpack_require__(44471), exports);
tslib_1.__exportStar(__webpack_require__(95153), exports);
tslib_1.__exportStar(__webpack_require__(77411), exports);
tslib_1.__exportStar(__webpack_require__(70339), exports);
tslib_1.__exportStar(__webpack_require__(79249), exports);
tslib_1.__exportStar(__webpack_require__(42177), exports); // no-op
tslib_1.__exportStar(__webpack_require__(69997), exports); // no-op
tslib_1.__exportStar(__webpack_require__(91899), exports);
tslib_1.__exportStar(__webpack_require__(24502), exports);
tslib_1.__exportStar(__webpack_require__(70364), exports);
tslib_1.__exportStar(__webpack_require__(65201), exports);
tslib_1.__exportStar(__webpack_require__(76307), exports);
tslib_1.__exportStar(__webpack_require__(10579), exports);
tslib_1.__exportStar(__webpack_require__(67759), exports);
tslib_1.__exportStar(__webpack_require__(50684), exports);
tslib_1.__exportStar(__webpack_require__(83781), exports);
tslib_1.__exportStar(__webpack_require__(96442), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 67542:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCart = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const helpers_1 = __webpack_require__(85542);
const useCart = () => {
    const isMounted = (0, helpers_1.useMounted)();
    const cart = (0, store_1.useRecoilValue)(store_1.default.cart);
    const cartItems = (0, store_1.useRecoilValue)(store_1.default.cartItems$());
    return isMounted && cart ? { ...cart, lines: cartItems } : null;
};
exports.useCart = useCart;
//# sourceMappingURL=useCart.js.map

/***/ }),

/***/ 91899:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartAddAttributes = void 0;
const tslib_1 = __webpack_require__(59312);
const react_1 = __webpack_require__(27378);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCartStartFinishErrors_1 = __webpack_require__(74420);
const useCartUpdateAttributes_1 = __webpack_require__(70364);
const useCartAddAttributes = (options) => {
    const { setStarted, setFinished, setErrors, ...status } = (0, useCartStartFinishErrors_1.useCartStartFinishErrors)({
        ...options,
        id: 'cart/addAttributes',
    });
    // action
    const setCart = (0, store_1.useSetRecoilState)(store_1.default.cart);
    const existingAttributes = (0, store_1.useRecoilValue)(store_1.default.cartAttributes$);
    const { cartUpdateAttributes } = (0, useCartUpdateAttributes_1.useCartUpdateAttributes)();
    const cartAddAttributes = (0, react_1.useCallback)(async (data, callback) => {
        try {
            setStarted(true);
            let validationErrors = null;
            switch (true) {
                case !data: {
                    validationErrors = [
                        `parameter is required; must be an object with "attributes", e.g. "{ attributes: [{ key: 'abc', value: '123' }] }"`,
                    ];
                    break;
                }
                case typeof data !== 'object': {
                    validationErrors = [
                        `parameter must be an object with "attributes", e.g. "{ attributes: [{ key: 'abc', value: '123' }] }"`,
                    ];
                    break;
                }
                case !data?.attributes: {
                    validationErrors = [
                        `"attributes" is required in parameter object, e.g. "{ attributes: [{ key: 'abc', value: '123' }] }"`,
                    ];
                    break;
                }
                case !Array.isArray(data?.attributes): {
                    validationErrors = [
                        `"attributes" must be an array, e.g. "{ attributes: [{ key: 'abc', value: '123' }] }"`,
                    ];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                throw new Error(validationErrors[0]);
            }
            const updatedCart = await cartUpdateAttributes({
                attributes: [...existingAttributes, ...data.attributes],
            });
            if (!updatedCart || !updatedCart?.id) {
                throw new Error('Invalid cart add attributes response');
            }
            setFinished(true);
            setCart(updatedCart);
            if (callback)
                callback(updatedCart);
            return updatedCart;
        }
        catch (error) {
            console.error('cartAddAttributes:error', error.message);
            setErrors([error.message]);
            return null;
        }
    });
    return {
        cartAddAttributes,
        setStarted,
        setFinished,
        setErrors,
        ...status,
    };
};
exports.useCartAddAttributes = useCartAddAttributes;
//# sourceMappingURL=useCartAddAttributes.js.map

/***/ }),

/***/ 77411:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartAddDiscount = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCartStartFinishErrors_1 = __webpack_require__(74420);
const useCartAddDiscount = (options) => {
    const { setStarted, setFinished, setErrors, ...status } = (0, useCartStartFinishErrors_1.useCartStartFinishErrors)({ ...options, id: 'cart/addDiscount' });
    const setCart = (0, store_1.useSetRecoilState)(store_1.default.cart);
    const cartAddDiscount = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        const release = snapshot.retain();
        try {
            setStarted(true);
            let validationErrors = null;
            switch (true) {
                case !data:
                    validationErrors = [
                        `parameter is required; must be an object with "discountCode", e.g. "{ discountCode: 'abc123' }"`,
                    ];
                    break;
                case typeof data !== 'object':
                    validationErrors = [
                        `parameter must be an object with "discountCode", e.g. "{ discountCode: 'abc123' }"`,
                    ];
                    break;
                case !data?.discountCode: {
                    validationErrors = [
                        `"discountCode" is required in parameter object, e.g. "{ discountCode: 'abc123' }"`,
                    ];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                throw new Error(validationErrors[0]);
            }
            const { error, updatedCart } = await snapshot.getPromise(store_1.default.cartUpdateDiscount(data));
            if (error) {
                throw new Error(error);
            }
            if (!updatedCart || updatedCart?.__typename !== 'Cart') {
                throw new Error(`Invalid cart note update response for note ${data?.note}`);
            }
            setFinished(true);
            setCart(updatedCart);
            if (callback)
                callback(updatedCart);
            return updatedCart;
        }
        catch (error) {
            console.error('cartAddDiscount:error', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    return {
        cartAddDiscount,
        setStarted,
        setFinished,
        setErrors,
        ...status,
    };
};
exports.useCartAddDiscount = useCartAddDiscount;
//# sourceMappingURL=useCartAddDiscount.js.map

/***/ }),

/***/ 70339:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartAddDiscountUrl = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable no-unused-expressions */
const router_1 = __webpack_require__(86677);
const react_1 = __webpack_require__(27378);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCartAddDiscount_1 = __webpack_require__(77411);
const DEBUG = false;
const defaultProps = {
    queryParams: ['discount_code', 'discountCode'],
    removeParams: true,
};
/**
  looks for ?discountCode=xyz and attempts to apply it to the cart
  if we want to use another param we can pass it to this hook via queryParams
  e.g — useCartAddDiscountUrl({ queryParams: ['promo'] }) -> would work on  https..?promo=PACK_TEST
*/
const useCartAddDiscountUrl = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const cartId = (0, store_1.useRecoilValue)(store_1.default.cartId$);
    const [appliedDiscount, setApplied] = (0, react_1.useState)();
    const router = (0, router_1.useRouter)();
    const { cartAddDiscount } = (0, useCartAddDiscount_1.useCartAddDiscount)();
    const applyDiscountCodeOnMount = async () => {
        // already has a discount applied
        if (appliedDiscount || !cartId) {
            return null;
        }
        try {
            // search url params for a discount param, continue after the first find.
            const discountCode = Object.keys(router.query).reduce((_code, param) => {
                const isDiscountParam = props.queryParams.includes(param);
                if (_code)
                    return _code;
                if (isDiscountParam) {
                    const code = router.query[param];
                    return code;
                }
                return _code;
            }, null);
            DEBUG && console.log('useCartAddDiscountUrl:discountCode', discountCode);
            // eslint-disable-next-line prettier/prettier
            DEBUG && console.log(`useCartAddDiscountUrl: detected discount code ${discountCode} in a param(s) ${props.queryParams.join(',')}`);
            if (!discountCode)
                return null;
            DEBUG && console.log('useCartAddDiscountUrl: applying discount...');
            const cartWithDiscount = await cartAddDiscount({
                discountCode,
                checkoutId: cartId,
            });
            // eslint-disable-next-line prettier/prettier
            DEBUG && console.log('useCartAddDiscountUrl: discount application response', cartWithDiscount);
            // check if invalid discountCode provided
            if (!cartWithDiscount?.discountApplications?.length) {
                setApplied(false);
                // eslint-disable-next-line prettier/prettier
                DEBUG && console.log('useCartAddDiscountUrl: discount code application failed');
                return null;
            }
            DEBUG && console.log('useCartAddDiscountUrl: discount code applied!');
            const [base, params] = router.asPath.split('?');
            // if we have url param(s)
            if (params?.length && props.removeParams) {
                const cleanParams = new URLSearchParams(params);
                // remove promo from url after its been applied
                props.queryParams.forEach((param) => {
                    cleanParams.delete(param);
                });
                // if we still have other params after removing the discount one we keep them
                if (cleanParams.toString().length) {
                    // eslint-disable-next-line prettier/prettier
                    router.replace(`${base}?${cleanParams}`, undefined, { shallow: true });
                }
                else {
                    router.replace(`${base}`, undefined, { shallow: true });
                }
            }
            const appliedCode = cartWithDiscount.discountApplications[0];
            setApplied(appliedCode);
            return appliedCode;
        }
        catch (error) {
            setApplied(false);
            return null;
        }
    };
    (0, react_1.useEffect)(() => {
        applyDiscountCodeOnMount();
    }, [Object.keys(router.query).join(','), cartId]);
    return appliedDiscount;
};
exports.useCartAddDiscountUrl = useCartAddDiscountUrl;
//# sourceMappingURL=useCartAddDiscountUrl.js.map

/***/ }),

/***/ 42177:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartAddGiftCard = void 0;
const react_1 = __webpack_require__(27378);
const useCartAddGiftCard = () => {
    (0, react_1.useEffect)(() => {
        console.warn('Cart giftcards are not yet supported on Cart API (v2)');
    }, []);
    return {
        cartAddGiftCard: null,
    };
};
exports.useCartAddGiftCard = useCartAddGiftCard;
//# sourceMappingURL=useCartAddGiftCard.js.map

/***/ }),

/***/ 76307:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartAddItem = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCartStartFinishErrors_1 = __webpack_require__(74420);
const helpers_1 = __webpack_require__(85542);
const useCartAddItem = (options) => {
    const { setStarted, setFinished, setErrors, ...status } = (0, useCartStartFinishErrors_1.useCartStartFinishErrors)({ ...options, id: 'cart/addItem' });
    // action
    const setCart = (0, store_1.useSetRecoilState)(store_1.default.cart);
    // fetch an existing cart using a checkoutId
    const cartAddItem = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        const release = snapshot.retain();
        // current cart
        try {
            setStarted(true);
            let validationErrors = null;
            switch (true) {
                case !data:
                    validationErrors = [
                        `parameter is required; must be an object with "merchandiseId" and "quantity", e.g. "{ merchandiseId: 'abc123', quantity: 1 }"`,
                    ];
                    break;
                case typeof data !== 'object':
                    validationErrors = [
                        `parameter must be an object with "merchandiseId" and "quantity", e.g. "{ merchandiseId: 'abc123', quantity: 1 }"`,
                    ];
                    break;
                case !data?.merchandiseId:
                    validationErrors = [
                        `"merchandiseId" is required in parameter object, e.g. "{ merchandiseId: 'abc123', quantity: 1 }"`,
                    ];
                    break;
                case !data?.quantity:
                    validationErrors = [
                        `"quantity" is required in parameter object, e.g. "{ merchandiseId: 'abc123', quantity: 1 }"`,
                    ];
                    break;
                default:
                    break;
            }
            if (validationErrors?.length) {
                throw new Error(validationErrors[0]);
            }
            const _cart = snapshot.getLoadable(store_1.default.cart).contents;
            const { itemInCart, attributes, haveSameAttributes } = (0, helpers_1.getAddAction)({
                cart: _cart,
                data,
            });
            const addItemPromise = store_1.default.cartAddItem({
                ...data,
                attributes,
            });
            const updateItemPromise = store_1.default.cartUpdateItem({
                ...data,
                lineId: itemInCart?.id,
                quantity: data.quantity + (itemInCart?.quantity || 0),
                attributes,
            });
            const updateExisting = itemInCart && haveSameAttributes;
            // update existing cart item if already in cart
            const { error, updatedCart } = updateExisting
                ? await snapshot.getPromise(updateItemPromise) // update existing item
                : await snapshot.getPromise(addItemPromise); // add the item
            if (error) {
                throw new Error(error);
            }
            if (!updatedCart || updatedCart?.__typename !== 'Cart') {
                throw new Error(`Invalid cart add item response for merchandiseId ${data?.merchandiseId}`);
            }
            setFinished(true);
            setCart(updatedCart);
            if (callback)
                callback(updatedCart);
            return updatedCart;
        }
        catch (error) {
            console.error('cartAddItem:error', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    return {
        cartAddItem,
        setErrors,
        setFinished,
        setStarted,
        ...status,
    };
};
exports.useCartAddItem = useCartAddItem;
//# sourceMappingURL=useCartAddItem.js.map

/***/ }),

/***/ 10579:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartAddItems = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable no-await-in-loop */
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCartStartFinishErrors_1 = __webpack_require__(74420);
const helpers_1 = __webpack_require__(85542);
const useCartAddItems = (options) => {
    const { setStarted, setFinished, setErrors, ...status } = (0, useCartStartFinishErrors_1.useCartStartFinishErrors)({ ...options, id: 'cart/addItems' });
    // action
    const setCart = (0, store_1.useSetRecoilState)(store_1.default.cart);
    const cartAddItems = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        const release = snapshot.retain();
        try {
            setStarted(true);
            let validationErrors = null;
            switch (true) {
                case !data:
                    validationErrors = [
                        `parameter is required; must be an array of objects with "merchandiseId" and "quantity", e.g. "[{ merchandiseId: 'abc123', quantity: 1 }]"`,
                    ];
                    break;
                case !Array.isArray(data):
                    validationErrors = [
                        `parameter must be an array of objects with "merchandiseId" and "quantity", e.g. "[{ merchandiseId: 'abc123', quantity: 1 }]"`,
                    ];
                    break;
                case !data?.length:
                    validationErrors = [
                        `parameter array must have at least one item to add, e.g. "[{ merchandiseId: 'abc123', quantity: 1 }]"`,
                    ];
                    break;
                // check all passed items to add have a variantId prop
                case data?.some((item) => !item?.merchandiseId):
                    validationErrors = [
                        `"merchandiseId" is required in every object in parameter array, e.g. "[{ merchandiseId: 'abc123', quantity: 1 }]"`,
                    ];
                    break;
                // check all passed items to add have a quantity prop
                case data?.some((item) => !item?.quantity):
                    validationErrors = [
                        `"quantity" is required in every object in parameter array, e.g. "[{ merchandiseId: 'abc123', quantity: 1 }]"`,
                    ];
                    break;
                default:
                    break;
            }
            if (validationErrors?.length) {
                throw new Error(validationErrors[0]);
            }
            const results = [];
            // add or update each line item
            for (let index = 0; index < data.length; index += 1) {
                const currentItem = data[index];
                const _cart = snapshot.getLoadable(store_1.default.cart).contents;
                const { itemInCart, attributes, haveSameAttributes } = (0, helpers_1.getAddAction)({
                    cart: _cart,
                    data: currentItem,
                });
                const addItemPromise = store_1.default.cartAddItem({
                    ...currentItem,
                    quantity: itemInCart && haveSameAttributes
                        ? itemInCart.quantity + currentItem.quantity
                        : currentItem.quantity,
                    attributes,
                });
                const updateItemPromise = store_1.default.cartUpdateItem({
                    lineId: itemInCart?.id,
                    quantity: currentItem.quantity + (itemInCart?.quantity || 0),
                    attributes,
                });
                // update existing cart item if already in cart
                const { error, updatedCart } = itemInCart && haveSameAttributes
                    ? await snapshot.getPromise(updateItemPromise) // update existing item
                    : await snapshot.getPromise(addItemPromise); // add the item
                if (error) {
                    throw new Error(error);
                }
                if (!updatedCart || updatedCart?.__typename !== 'Cart') {
                    throw new Error(`Failed to add item with id ${currentItem.merchandiseId}`);
                }
                else {
                    results.push(updatedCart);
                    snapshot.map(({ set }) => set(store_1.default.cart, updatedCart));
                }
            }
            const isValidCart = (cart) => cart && cart?.id;
            const success = results.filter(isValidCart).filter(Boolean).length === data?.length;
            if (!success) {
                throw new Error('Invalid add line items cart response');
            }
            const cart = results[results.length - 1];
            setFinished(true);
            setCart(cart);
            if (callback)
                callback(cart);
            return cart;
        }
        catch (error) {
            console.error('cartAddItems:error', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    return {
        cartAddItems,
        setStarted,
        setErrors,
        setFinished,
        ...status,
    };
};
exports.useCartAddItems = useCartAddItems;
//# sourceMappingURL=useCartAddItems.js.map

/***/ }),

/***/ 26511:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartAttributes = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const helpers_1 = __webpack_require__(85542);
const useCartAttributes = () => {
    const isMounted = (0, helpers_1.useMounted)();
    const cartAttributes = (0, store_1.useRecoilValue)(store_1.default.cartAttributes$);
    return isMounted ? cartAttributes : [];
};
exports.useCartAttributes = useCartAttributes;
//# sourceMappingURL=useCartAttributes.js.map

/***/ }),

/***/ 26228:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartBuyer = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const helpers_1 = __webpack_require__(85542);
const useCartBuyer = () => {
    const isMounted = (0, helpers_1.useMounted)();
    const cartBuyer = (0, store_1.useRecoilValue)(store_1.default.cartBuyer);
    return isMounted ? cartBuyer : null;
};
exports.useCartBuyer = useCartBuyer;
//# sourceMappingURL=useCartBuyer.js.map

/***/ }),

/***/ 95153:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartCheckout = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable no-undef */
const react_1 = __webpack_require__(27378);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCartStartFinishErrors_1 = __webpack_require__(74420);
const useCartCheckout = (options) => {
    const { setStarted, setFinished, setErrors, ...status } = (0, useCartStartFinishErrors_1.useCartStartFinishErrors)({ ...options, id: 'cart/checkout' });
    const cartCheckoutUrl = (0, store_1.useRecoilValue)(store_1.default.cartCheckoutUrl$);
    const customer = (0, store_1.useRecoilValue)(store_1.default.customer);
    const setCartCheckout = (0, store_1.useSetRecoilState)(store_1.default.cartCheckout);
    // attempts to redirect the user to the checkout logged in (with Shopify+ multi-pass token)
    const cartCheckout = (0, react_1.useCallback)(async (data, callback) => {
        const redirect = typeof data?.redirect !== 'undefined' ? data?.redirect : true;
        let loggedOutCartCheckout;
        let checkoutUrl = cartCheckoutUrl; // e.g — storefront.myshopify.com
        // if we have cart domain we modify the checkout url host — e.g shop.storefront.com
        if (true) {
            checkoutUrl = new URL(cartCheckoutUrl);
            checkoutUrl.host = "shop.brumate.com";
        }
        const maybeCheckoutViaMultiPass = async () => {
            // data for multi-pass token
            const multiPassCustomer = {
                email: customer.email,
                addresses: customer.defaultAddress ? [customer.defaultAddress] : [],
                firstName: customer.firstName,
                lastName: customer.lastName,
                acceptsMarketing: customer.acceptsMarketing,
                return_to: checkoutUrl,
                tag_string: customer.tags.join(', '),
                created_at: new Date().toISOString(),
            };
            if (!multiPassCustomer)
                throw new Error('Missing multiPassCustomer');
            // fetch an authenticated multipass token from our api
            const multiPassReq = await fetch('/api/multipass', {
                method: 'POST',
                body: JSON.stringify(multiPassCustomer),
            });
            const multiPass = await multiPassReq.json();
            if (multiPassReq?.status !== 200) {
                console.log(`Checking out without multipass (401):`, multiPass.error);
                setErrors([`multipass api failed: ${multiPass.error}`]);
                setFinished(true);
                setCartCheckout(loggedOutCartCheckout);
                if (callback)
                    callback(checkoutUrl);
                return checkoutUrl;
            }
            if (multiPass?.error) {
                setErrors(['There was an error creating a multipass token']);
                setFinished(true);
                setCartCheckout(loggedOutCartCheckout);
                if (callback)
                    callback(checkoutUrl);
                return checkoutUrl;
            }
            if (multiPass?.url) {
                // got multi-pass url, go to checkout with multi-pass
                setFinished(true);
                const checkout = {
                    url: multiPass.url,
                    multiPass: true,
                    redirect,
                };
                setCartCheckout(checkout);
                if (callback)
                    callback(multiPass.url);
                return multiPass.url;
            }
            // just in case
            setFinished(true);
            setCartCheckout(loggedOutCartCheckout);
            if (callback)
                callback(checkoutUrl);
            return checkoutUrl;
        };
        // Attempt to checkout via multipass or regular
        try {
            setStarted(true);
            if (!checkoutUrl) {
                setErrors(['Cart checkoutUrl not provided']);
                return null;
            }
            // default checkout object (if no multipass)
            loggedOutCartCheckout = {
                url: checkoutUrl,
                redirect,
                multiPass: false,
            };
            // only if we have a customer we can attempt to multi-pass checkout
            if (customer) {
                await maybeCheckoutViaMultiPass();
                return true;
            }
            setFinished(true);
            // setting cartCheckout will trigger a redirect (if true)
            setCartCheckout(loggedOutCartCheckout);
            if (callback)
                callback(loggedOutCartCheckout);
            return loggedOutCartCheckout;
        }
        catch (exception) {
            setErrors([exception.message]);
            const checkout = {
                url: checkoutUrl,
                redirect,
                multiPass: false,
            };
            setCartCheckout(checkout);
            return checkout;
        }
    }, [customer, cartCheckoutUrl]);
    return {
        cartCheckout,
        setStarted,
        setErrors,
        setFinished,
        ...status,
    };
};
exports.useCartCheckout = useCartCheckout;
//# sourceMappingURL=useCartCheckout.js.map

/***/ }),

/***/ 44471:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartClear = void 0;
const tslib_1 = __webpack_require__(59312);
const react_1 = __webpack_require__(27378);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCartRemoveItems_1 = __webpack_require__(50684);
const useCartClear = () => {
    const cart = (0, store_1.useRecoilValue)(store_1.default.cart);
    const { cartRemoveItems, ...removeItemsState } = (0, useCartRemoveItems_1.useCartRemoveItems)();
    const cartClear = (0, react_1.useCallback)(async (callback) => {
        if (!cart?.lines?.length) {
            removeItemsState.setErrors(['Cart is already empty']);
            if (callback)
                callback(null);
            return null;
        }
        const lineIds = cart?.lines.map(({ id }) => id);
        const _cart = await cartRemoveItems({ lineIds });
        if (callback)
            callback(_cart);
        return _cart;
    }, [cart?.lines?.length, removeItemsState]);
    return {
        cartClear,
        ...removeItemsState,
    };
};
exports.useCartClear = useCartClear;
//# sourceMappingURL=useCartClear.js.map

/***/ }),

/***/ 63953:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartCount = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const helpers_1 = __webpack_require__(85542);
const useCartCount = () => {
    const isMounted = (0, helpers_1.useMounted)();
    const cartCount = (0, store_1.useRecoilValue)(store_1.default.cartCount$);
    return isMounted ? cartCount : null;
};
exports.useCartCount = useCartCount;
//# sourceMappingURL=useCartCount.js.map

/***/ }),

/***/ 11350:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartCreate = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCartStartFinishErrors_1 = __webpack_require__(74420);
const useCartCreate = (options) => {
    const { setStarted, setFinished, setErrors, ...status } = (0, useCartStartFinishErrors_1.useCartStartFinishErrors)({ ...options, id: 'cart/create' });
    // action
    const setCart = (0, store_1.useSetRecoilState)(store_1.default.cart);
    // create a new cart with optional email, shippingAddress and note
    const cartCreate = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        const release = snapshot.retain();
        try {
            setStarted(true);
            const { error, newCart } = await snapshot.getPromise(store_1.default.cartCreate({
                country: data?.country || 'US',
                cartInput: data?.cartInput || {},
            }));
            if (error) {
                throw new Error(error);
            }
            if (!newCart || !newCart?.id || newCart?.__typename !== 'Cart') {
                throw new Error(`Invalid cart create response ${newCart}`);
            }
            setFinished(true);
            setCart(newCart);
            if (callback)
                callback(newCart);
            return newCart;
        }
        catch (error) {
            console.error('cartCreate:error', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    return {
        cartCreate,
        setStarted,
        setErrors,
        setFinished,
        ...status,
    };
};
exports.useCartCreate = useCartCreate;
//# sourceMappingURL=useCartCreate.js.map

/***/ }),

/***/ 69745:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartDiscounts = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const helpers_1 = __webpack_require__(85542);
const useCartDiscounts = () => {
    const isMounted = (0, helpers_1.useMounted)();
    const cartDiscounts = (0, store_1.useRecoilValue)(store_1.default.cartDiscounts$);
    return isMounted ? cartDiscounts : [];
};
exports.useCartDiscounts = useCartDiscounts;
//# sourceMappingURL=useCartDiscounts.js.map

/***/ }),

/***/ 88587:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartEmail = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const helpers_1 = __webpack_require__(85542);
const useCartEmail = () => {
    const isMounted = (0, helpers_1.useMounted)();
    const cartEmail = (0, store_1.useRecoilValue)(store_1.default.cartEmail$);
    return isMounted ? cartEmail : null;
};
exports.useCartEmail = useCartEmail;
//# sourceMappingURL=useCartEmail.js.map

/***/ }),

/***/ 82914:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartEmpty = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const helpers_1 = __webpack_require__(85542);
const useCartEmpty = () => {
    const isMounted = (0, helpers_1.useMounted)();
    const cartEmpty = (0, store_1.useRecoilValue)(store_1.default.cartEmpty$);
    return isMounted ? cartEmpty : null;
};
exports.useCartEmpty = useCartEmpty;
//# sourceMappingURL=useCartEmpty.js.map

/***/ }),

/***/ 72249:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartGet = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCartStartFinishErrors_1 = __webpack_require__(74420);
const useCartGet = (options) => {
    const country = (0, store_1.useRecoilValue)(store_1.default.country);
    const countryCode = country?.isoCode || 'US';
    const currencyCode = country?.currency?.isoCode || 'USD';
    // action
    const setCart = (0, store_1.useSetRecoilState)(store_1.default.cart);
    const { setStarted, setFinished, setErrors, ...status } = (0, useCartStartFinishErrors_1.useCartStartFinishErrors)({
        ...options,
        id: `cart/get/${countryCode}/${currencyCode}`,
    });
    // fetch an existing cart using a checkoutId
    const cartGet = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        const release = snapshot.retain();
        try {
            setStarted(true);
            let validationErrors = null;
            switch (true) {
                case !data:
                    validationErrors = [
                        `parameter is required; must be an object with "id", e.g. "{ id: 'abc123' }"`,
                    ];
                    break;
                case typeof data !== 'object':
                    validationErrors = [
                        `parameter must be an object with "id", e.g. "{ id: 'abc123' }"`,
                    ];
                    break;
                case !data?.id: {
                    validationErrors = [
                        `"id" is required in parameter object, e.g. "{ id: 'abc123' }"`,
                    ];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                throw new Error(validationErrors[0]);
            }
            const { error, existingCart } = await snapshot.getPromise(store_1.default.cartGet({ id: data?.id || null }));
            if (error) {
                throw new Error(error);
            }
            if (!existingCart || existingCart?.__typename !== 'Cart') {
                throw new Error(`Invalid cart fetch response for id: ${data?.id}`);
            }
            setFinished(true);
            setCart(existingCart);
            if (callback)
                callback(existingCart);
            return existingCart;
        }
        catch (error) {
            console.error('cartGet:error', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    return {
        cartGet,
        setStarted,
        setErrors,
        setFinished,
        ...status,
    };
};
exports.useCartGet = useCartGet;
//# sourceMappingURL=useCartGet.js.map

/***/ }),

/***/ 13015:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartGiftCards = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const helpers_1 = __webpack_require__(85542);
// Not yet supported on CART API
const useCartGiftCards = () => {
    const isMounted = (0, helpers_1.useMounted)();
    const giftCards = (0, store_1.useRecoilValue)(store_1.default.cartGiftCards$);
    return isMounted ? giftCards : [];
};
exports.useCartGiftCards = useCartGiftCards;
//# sourceMappingURL=useCartGiftCards.js.map

/***/ }),

/***/ 69659:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartId = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const helpers_1 = __webpack_require__(85542);
const useCartId = () => {
    const isMounted = (0, helpers_1.useMounted)();
    const cartId = (0, store_1.useRecoilValue)(store_1.default.cart)?.id;
    return isMounted ? cartId : null;
};
exports.useCartId = useCartId;
//# sourceMappingURL=useCartId.js.map

/***/ }),

/***/ 68692:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartInit = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable no-unused-expressions */
const react_1 = __webpack_require__(27378);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCartGet_1 = __webpack_require__(72249);
const useCartCreate_1 = __webpack_require__(11350);
const DEBUG = false;
const defaultProps = {
    fetchOnMount: false,
    options: {},
};
const useCartInit = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const initializing = (0, react_1.useRef)(false);
    const setCustomerAndCartInit = (0, store_1.useSetRecoilState)(store_1.default.customerAndCartInit);
    const customerInit = (0, store_1.useRecoilValue)(store_1.default.customerInit);
    const [cartInit, setCartInit] = (0, store_1.useRecoilState)(store_1.default.cartInit);
    const [cart, setCart] = (0, store_1.useRecoilState)(store_1.default.cart);
    const customer = (0, store_1.useRecoilValue)(store_1.default.customer);
    const { cartGet, ...carGetStatus } = (0, useCartGet_1.useCartGet)();
    const { cartCreate, ...carCreateStatus } = (0, useCartCreate_1.useCartCreate)();
    const getCartAction = (0, react_1.useCallback)((_cart) => {
        // only run when customer has been initialized
        const thenDaysAgo = new Date();
        thenDaysAgo.setDate(thenDaysAgo.getDate() - 10);
        const createdAt = _cart?.createdAt ? new Date(_cart.createdAt) : new Date();
        // validations
        const noPersistedCart = !_cart;
        const cartPurchased = _cart?.completedAt || false;
        const persistedCartInvalid = !_cart?.id || (_cart?.__typename && _cart.__typename !== 'Cart');
        const isTenDaysOld = createdAt < thenDaysAgo;
        // any true returns true
        const shouldCreate = [
            noPersistedCart,
            cartPurchased,
            persistedCartInvalid,
            isTenDaysOld,
        ].some(Boolean);
        if (shouldCreate) {
            let createReason = null;
            if (noPersistedCart) {
                createReason = "Don't have a persisted cart, creating new cart...";
            }
            else if (persistedCartInvalid) {
                createReason =
                    'Have persisted cart, buts its invalid. creating new cart...';
            }
            else if (cartPurchased) {
                createReason =
                    'Have persisted cart but its been purchased, creating new cart...';
            }
            else if (isTenDaysOld) {
                createReason =
                    'Have expired persisted cart (10+ days old), creating new cart...';
            }
            // just for troubleshooting
            DEBUG &&
                createReason &&
                console.log(`🛒 cart init: creating new cart due: ${createReason}`);
        }
        return shouldCreate;
    }, []);
    const createNewCart = (0, react_1.useCallback)(async ({ email, attempt = 0 }) => {
        const maxRetries = 2;
        let newCart = null;
        if (attempt >= maxRetries) {
            setCartInit(false);
            return null;
        }
        newCart = await cartCreate({
            cartInput: email ? { buyerIdentity: { email } } : {},
        });
        if (newCart?.id) {
            setCartInit(true);
            return newCart;
        }
        // if we fail to create we should retry one more time
        return createNewCart({
            email,
            attempt: attempt + 1,
        });
    }, []);
    const createOrGetCartOnCustomerInit = () => {
        if (!props.fetchOnMount)
            return;
        if (!customerInit)
            return;
        if (initializing.current)
            return;
        if (cartInit) {
            setCustomerAndCartInit(true); // set for analytics (customer event)
            return;
        }
        initializing.current = true;
        const validatePersistedCartAndReuseOrCreate = async () => {
            const existingCart = await cartGet({ id: cart.id });
            if (existingCart?.id) {
                setCart(existingCart);
                setCartInit(true);
                return;
            }
            if (!existingCart) {
                setCart(null);
                await createNewCart({ email: customer?.email, attempt: 1 });
            }
        };
        if (getCartAction(cart)) {
            createNewCart({ email: customer?.email, attempt: 1 });
        }
        else {
            validatePersistedCartAndReuseOrCreate();
        }
    };
    (0, react_1.useEffect)(() => {
        createOrGetCartOnCustomerInit();
    }, [customerInit, cartInit, cart, customer, props?.fetchOnMount]);
    // no bueno if we get here
    const cartInitErrorHandler = () => {
        // todo: currently if we error and then retry and succeed this would still show the initial error
        const anyErrors = carGetStatus?.errors?.length || carCreateStatus?.errors?.length;
        if (anyErrors) {
            console.groupCollapsed('🛒 cart init: failed 🚫');
            carGetStatus?.errors &&
                console.log('🛒 cart init: get errors:\t\t\t', carGetStatus?.errors);
            carCreateStatus?.errors &&
                console.log('🛒 cart init: create errors:\t\t\t', carCreateStatus?.errors);
            console.groupEnd();
        }
    };
    (0, react_1.useEffect)(() => {
        cartInitErrorHandler();
    }, [carGetStatus?.errors?.length, carCreateStatus?.errors?.length]);
    return cart;
};
exports.useCartInit = useCartInit;
//# sourceMappingURL=useCartInit.js.map

/***/ }),

/***/ 83061:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartItem = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const helpers_1 = __webpack_require__(85542);
const useCartItem = ({ id } = { id: null }) => {
    const isMounted = (0, helpers_1.useMounted)();
    const cartItem = (0, store_1.useRecoilValue)(store_1.default.cartItem$({ id }));
    return isMounted && id ? cartItem : null;
};
exports.useCartItem = useCartItem;
//# sourceMappingURL=useCartItem.js.map

/***/ }),

/***/ 53660:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartItems = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const helpers_1 = __webpack_require__(85542);
const useCartItems = () => {
    const isMounted = (0, helpers_1.useMounted)();
    const cartItems = (0, store_1.useRecoilValue)(store_1.default.cartItems$());
    return isMounted ? cartItems : [];
};
exports.useCartItems = useCartItems;
//# sourceMappingURL=useCartItems.js.map

/***/ }),

/***/ 24502:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartRemoveAttributes = void 0;
const tslib_1 = __webpack_require__(59312);
const react_1 = __webpack_require__(27378);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCartStartFinishErrors_1 = __webpack_require__(74420);
const useCartUpdateAttributes_1 = __webpack_require__(70364);
const useCartRemoveAttributes = (options) => {
    const { setStarted, setFinished, setErrors, ...status } = (0, useCartStartFinishErrors_1.useCartStartFinishErrors)({ ...options, id: 'cart/removeAttribute' });
    // action
    const existingCustomAttributes = (0, store_1.useRecoilValue)(store_1.default.cartAttributes$);
    const { cartUpdateAttributes } = (0, useCartUpdateAttributes_1.useCartUpdateAttributes)();
    const cartRemoveAttributes = (0, react_1.useCallback)(async (data, callback) => {
        try {
            setStarted(true);
            let validationErrors = null;
            switch (true) {
                case !data:
                    validationErrors = [
                        `parameter is required; must be an object with "attributeKeys", e.g. "{ attributeKeys: ['abc'] }"`,
                    ];
                    break;
                case typeof data !== 'object':
                    validationErrors = [
                        `parameter must be an object with "attributeKeys", e.g. "{ attributeKeys: ['abc'] }"`,
                    ];
                    break;
                case !Array.isArray(data?.attributeKeys):
                    validationErrors = [
                        `"attributeKeys" must be an array of strings, e.g. "{ attributeKeys: ['abc'] }"`,
                    ];
                    break;
                case !data?.attributeKeys?.length:
                    validationErrors = [
                        `"attributeKeys" must have at least one key, e.g. "{ attributeKeys: ['abc'] }"`,
                    ];
                    break;
                case data?.attributeKeys?.some((key) => typeof key !== 'string'):
                    validationErrors = [
                        `Every key in "attributeKeys" must be a string, e.g. "{ attributeKeys: ['abc'] }"`,
                    ];
                    break;
                default:
                    break;
            }
            if (validationErrors?.length) {
                throw new Error(validationErrors[0]);
            }
            // filter out attributes to remove
            const updatedAttributes = existingCustomAttributes.filter((attribute) => {
                try {
                    const markedForRemoval = data.attributeKeys.includes(attribute.key);
                    return !markedForRemoval;
                }
                catch (error) {
                    return true;
                }
            });
            const cartAttributes = await cartUpdateAttributes({
                attributes: updatedAttributes,
            });
            if (cartAttributes?.type?.name !== 'Attribute') {
                throw new Error('Invalid cart delete attributes response');
            }
            setFinished(true);
            // cartUpdateAttributes will updated the cart via setCart(cart)
            if (callback)
                callback(cartAttributes);
            return cartAttributes;
        }
        catch (error) {
            console.error('cartRemoveAttributes:error', error.message);
            setErrors([error.message]);
            return null;
        }
    });
    return {
        cartRemoveAttributes,
        setStarted,
        setErrors,
        setFinished,
        ...status,
    };
};
exports.useCartRemoveAttributes = useCartRemoveAttributes;
//# sourceMappingURL=useCartRemoveAttributes.js.map

/***/ }),

/***/ 79249:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartRemoveDiscount = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCartStartFinishErrors_1 = __webpack_require__(74420);
const useCartRemoveDiscount = (options) => {
    const { setStarted, setFinished, setErrors, ...status } = (0, useCartStartFinishErrors_1.useCartStartFinishErrors)({ ...options, id: 'cart/removeDiscount' });
    const setCart = (0, store_1.useSetRecoilState)(store_1.default.cart);
    const cartRemoveDiscount = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        const release = snapshot.retain();
        try {
            setStarted(true);
            const { error, updatedCart } = await snapshot.getPromise(store_1.default.cartRemoveDiscount());
            if (error) {
                throw new Error(error);
            }
            if (!updatedCart || !updatedCart?.id) {
                throw new Error('Invalid discount remove response');
            }
            setFinished(true);
            // not triggering an update of side effects for some reason
            setCart(updatedCart);
            if (callback)
                callback(updatedCart);
            return updatedCart;
        }
        catch (error) {
            console.error('cartRemoveDiscount:error', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    return {
        cartRemoveDiscount,
        setStarted,
        setErrors,
        setFinished,
        ...status,
    };
};
exports.useCartRemoveDiscount = useCartRemoveDiscount;
//# sourceMappingURL=useCartRemoveDiscount.js.map

/***/ }),

/***/ 69997:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartRemoveGiftCard = void 0;
const react_1 = __webpack_require__(27378);
const useCartRemoveGiftCard = () => {
    (0, react_1.useEffect)(() => {
        console.warn('Cart giftcards are not yet supported on Cart API (v2)');
    }, []);
    return {
        cartRemoveGiftCard: null,
    };
};
exports.useCartRemoveGiftCard = useCartRemoveGiftCard;
//# sourceMappingURL=useCartRemoveGiftCard.js.map

/***/ }),

/***/ 67759:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartRemoveItem = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCartStartFinishErrors_1 = __webpack_require__(74420);
const useCartRemoveItem = (options) => {
    const { setStarted, setFinished, setErrors, ...status } = (0, useCartStartFinishErrors_1.useCartStartFinishErrors)({ ...options, id: 'cart/removeItem' });
    // action
    const setCart = (0, store_1.useSetRecoilState)(store_1.default.cart);
    // fetch an existing cart using a checkoutId
    const cartRemoveItem = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        const release = snapshot.retain();
        try {
            setStarted(true);
            let validationErrors = null;
            switch (true) {
                case !data:
                    validationErrors = [
                        `parameter is required; must be an object with "lineId", e.g. "{ lineId: 'abc123' }"`,
                    ];
                    break;
                case typeof data !== 'object':
                    validationErrors = [
                        `parameter must be an object with "lineId", e.g. "{ lineId: 'abc123' }"`,
                    ];
                    break;
                case !data?.lineId:
                    validationErrors = [
                        `"lineId" is required in parameter object, e.g. "{ lineId: 'abc123' }"`,
                    ];
                    break;
                default:
                    break;
            }
            if (validationErrors?.length) {
                throw new Error(validationErrors[0]);
            }
            const { error, updatedCart } = await snapshot.getPromise(store_1.default.cartRemoveItem(data));
            if (error) {
                throw new Error(error);
            }
            if (!updatedCart || updatedCart?.__typename !== 'Cart') {
                throw new Error(`Invalid cart remove item response for lineId ${data?.lineId}`);
            }
            setFinished(true);
            setCart(updatedCart);
            if (callback)
                callback(updatedCart);
            return updatedCart;
        }
        catch (error) {
            console.error('cartRemoveItem:error', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    return {
        cartRemoveItem,
        setStarted,
        setErrors,
        setFinished,
        ...status,
    };
};
exports.useCartRemoveItem = useCartRemoveItem;
//# sourceMappingURL=useCartRemoveItem.js.map

/***/ }),

/***/ 50684:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartRemoveItems = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCartStartFinishErrors_1 = __webpack_require__(74420);
const useCartRemoveItems = (options) => {
    const { setStarted, setFinished, setErrors, ...status } = (0, useCartStartFinishErrors_1.useCartStartFinishErrors)({ ...options, id: 'cart/removeItems' });
    // action
    const setCart = (0, store_1.useSetRecoilState)(store_1.default.cart);
    // fetch an existing cart using a checkoutId
    const cartRemoveItems = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        const release = snapshot.retain();
        try {
            setStarted(true);
            let validationErrors = null;
            switch (true) {
                case !data:
                    validationErrors = [
                        `parameter is required; must be an object with "lineIds", e.g. "{ lineIds: ['abc123'] }"`,
                    ];
                    break;
                case typeof data !== 'object':
                    validationErrors = [
                        `parameter must be an object with "lineIds", e.g. "{ lineIds: ['abc123'] }"`,
                    ];
                    break;
                case !data?.lineIds:
                    validationErrors = [
                        `"lineIds" is required in parameter object, e.g. "{ lineIds: ['abc123'] }"`,
                    ];
                    break;
                case !Array.isArray(data?.lineIds):
                    validationErrors = [
                        `"lineIds" must be an array of strings, e.g. "{ lineIds: ['abc123'] }"`,
                    ];
                    break;
                case !data?.lineIds?.length:
                    validationErrors = [
                        `"lineIds" must have at least one line id to remove, e.g. "{ lineIds: ['abc123'] }"`,
                    ];
                    break;
                case data?.lineIds?.some((lineId) => typeof lineId !== 'string'):
                    validationErrors = [
                        `Every line id in "lineIds" must be a string, e.g. "{ lineIds: ['abc123'] }"`,
                    ];
                    break;
                default:
                    break;
            }
            if (validationErrors?.length) {
                throw new Error(validationErrors[0]);
            }
            const { error, updatedCart } = await snapshot.getPromise(store_1.default.cartRemoveItems(data));
            if (error) {
                throw new Error(error);
            }
            if (!updatedCart || updatedCart?.__typename !== 'Cart') {
                throw new Error(`Invalid cart remove items response for lineIds ${data?.lineIds}`);
            }
            setFinished(true);
            setCart(updatedCart);
            if (callback)
                callback(updatedCart);
            return updatedCart;
        }
        catch (error) {
            console.error('cartRemoveItems:error', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    return {
        cartRemoveItems,
        setStarted,
        setErrors,
        setFinished,
        ...status,
    };
};
exports.useCartRemoveItems = useCartRemoveItems;
//# sourceMappingURL=useCartRemoveItems.js.map

/***/ }),

/***/ 74420:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartStartFinishErrors = void 0;
const tslib_1 = __webpack_require__(59312);
const react_1 = __webpack_require__(27378);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const DEBUG = false;
const useCartStartFinishErrors = (options) => {
    const setCartStarted = (0, store_1.useSetRecoilState)(store_1.default.cartStatusStarted('cart/all'));
    const setCartFinished = (0, store_1.useSetRecoilState)(store_1.default.cartStatusFinished('cart/all'));
    const setCartSuccess = (0, store_1.useSetRecoilState)(store_1.default.cartStatusSuccess('cart/all'));
    const setCartErrors = (0, store_1.useSetRecoilState)(store_1.default.cartStatusErrors('cart/all'));
    const isCartId = /^cart/.test(options?.id);
    const [started, setStarted] = (0, store_1.useRecoilState)(store_1.default.cartStatusStarted(options?.id || ''));
    const [finished, setFinished] = (0, store_1.useRecoilState)(store_1.default.cartStatusFinished(options?.id || ''));
    const [success, setSuccess] = (0, store_1.useRecoilState)(store_1.default.cartStatusSuccess(options?.id || ''));
    const [errors, setErrors] = (0, store_1.useRecoilState)(store_1.default.cartStatusErrors(options?.id || ''));
    const autoReset = (0, react_1.useRef)(options?.autoReset || 0);
    const resetTimer = (0, react_1.useRef)(options?.resetTimer || null);
    // update local hook status
    const reset = (0, react_1.useCallback)(() => {
        if (typeof setErrors === 'undefined')
            return;
        setErrors([]);
        setStarted(false);
        setFinished(false);
        setSuccess(false);
        resetTimer.current = null;
    }, []);
    const updateStateOnErrors = () => {
        let unMounting = false;
        if (errors?.length > 0) {
            if (unMounting)
                return;
            setFinished(true);
            setSuccess(false);
        }
        // eslint-disable-next-line consistent-return
        return () => {
            unMounting = true;
        };
    };
    const updateStateOnFinished = () => {
        let unMounting = false;
        if (finished) {
            if (DEBUG) {
                console.groupCollapsed('status:', options?.id);
                console.log('started', started);
                console.log('errors', errors);
                console.log('finished', finished);
                console.log('success', success);
                console.groupEnd();
            }
            if (unMounting)
                return;
            const withoutErrors = errors?.length === 0;
            setStarted(false);
            setSuccess(withoutErrors);
            if (autoReset?.current) {
                const to = setTimeout(() => {
                    if (unMounting)
                        return;
                    reset();
                    clearTimeout(to);
                }, autoReset.current);
            }
        }
        // eslint-disable-next-line consistent-return
        return () => {
            unMounting = true;
        };
    };
    (0, react_1.useEffect)(() => {
        updateStateOnErrors();
    }, [errors?.length]);
    (0, react_1.useEffect)(() => {
        updateStateOnFinished();
    }, [finished, options?.id]);
    // update global cart status
    (0, react_1.useEffect)(() => {
        if (isCartId) {
            setCartErrors(errors);
        }
    }, [errors?.length]);
    (0, react_1.useEffect)(() => {
        if (isCartId) {
            setCartStarted(started);
        }
    }, [started]);
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        setCartFinished(finished);
        const to = setTimeout(() => {
            if (unMounting)
                return;
            setCartFinished(false);
            clearTimeout(to);
        }, 1000);
        return () => {
            unMounting = true;
        };
    }, [finished]);
    (0, react_1.useEffect)(() => {
        if (isCartId) {
            setCartSuccess(success);
        }
    }, [success]);
    return {
        started,
        setStarted,
        finished,
        setFinished,
        success,
        setSuccess,
        errors,
        setErrors,
        reset,
        resetTimer,
    };
};
exports.useCartStartFinishErrors = useCartStartFinishErrors;
//# sourceMappingURL=useCartStartFinishErrors.js.map

/***/ }),

/***/ 91887:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartStatus = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
// global status of the cart, any cart action will trigger
// these states via useRecoilStartFinishErrors.js
const useCartStatus = () => {
    return {
        started: (0, store_1.useRecoilValue)(store_1.default.cartStatusStarted('cart/all')),
        finished: (0, store_1.useRecoilValue)(store_1.default.cartStatusFinished('cart/all')),
        success: (0, store_1.useRecoilValue)(store_1.default.cartStatusSuccess('cart/all')),
        errors: (0, store_1.useRecoilValue)(store_1.default.cartStatusErrors('cart/all')),
    };
};
exports.useCartStatus = useCartStatus;
//# sourceMappingURL=useCartStatus.js.map

/***/ }),

/***/ 10295:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartTotalPrice = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const helpers_1 = __webpack_require__(85542);
const useCartTotalPrice = () => {
    const isMounted = (0, helpers_1.useMounted)();
    const cartTotalPrice = (0, store_1.useRecoilValue)(store_1.default.cartTotal$);
    return isMounted ? cartTotalPrice : null;
};
exports.useCartTotalPrice = useCartTotalPrice;
//# sourceMappingURL=useCartTotalPrice.js.map

/***/ }),

/***/ 87892:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartTotals = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const helpers_1 = __webpack_require__(85542);
// not localized
const useCartTotals = () => {
    const isMounted = (0, helpers_1.useMounted)();
    const _cart = (0, store_1.useRecoilValue)(store_1.default.cart);
    const cartTotal = (0, store_1.useRecoilValue)(store_1.default.cartTotal$);
    const cartSubtotal = (0, store_1.useRecoilValue)(store_1.default.cartSubtotal$);
    const cartTax = (0, store_1.useRecoilValue)(store_1.default.cartTax$);
    const cartDuty = (0, store_1.useRecoilValue)(store_1.default.cartDuty$);
    const cartDiscountTotal = (0, store_1.useRecoilValue)(store_1.default.cartDiscountTotal$);
    return _cart && isMounted
        ? {
            total: cartTotal,
            subtotal: cartSubtotal,
            duty: cartDuty,
            tax: cartTax,
            discount: cartDiscountTotal,
        }
        : {
            total: 0,
            subtotal: 0,
            duty: 0,
            tax: 0,
            discount: 0,
        };
};
exports.useCartTotals = useCartTotals;
//# sourceMappingURL=useCartTotals.js.map

/***/ }),

/***/ 70364:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartUpdateAttributes = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCartStartFinishErrors_1 = __webpack_require__(74420);
const useCartUpdateAttributes = (options) => {
    const { setStarted, setFinished, setErrors, ...status } = (0, useCartStartFinishErrors_1.useCartStartFinishErrors)({ ...options, id: 'cart/updateAttributes' });
    const setCart = (0, store_1.useSetRecoilState)(store_1.default.cart);
    const cartUpdateAttributes = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        const release = snapshot.retain();
        try {
            setStarted(true);
            let validationErrors = null;
            switch (true) {
                case !data: {
                    validationErrors = [
                        `parameter is required; must be an object with "attributes", e.g. "{ attributes: [{ key: 'abc123', value: '123' }] }"`,
                    ];
                    break;
                }
                case typeof data !== 'object': {
                    validationErrors = [
                        `parameter must be an object with "attributes", e.g. "{ attributes: [{ key: 'abc123', value: '123' }] }"`,
                    ];
                    break;
                }
                case !data?.attributes: {
                    validationErrors = [
                        `"attributes" is required in parameter object, e.g. "{ attributes: [{ key: 'abc123', value: '123' }] }"`,
                    ];
                    break;
                }
                case !Array.isArray(data?.attributes): {
                    validationErrors = [
                        `"attributes" must be an array, e.g. "{ attributes: [{ key: 'abc123', value: '123' }] }"`,
                    ];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                throw new Error(validationErrors[0]);
            }
            const { error, updatedCart } = await snapshot.getPromise(store_1.default.cartUpdateAttributes(data));
            if (error) {
                throw new Error(error);
            }
            if (!updatedCart || updatedCart?.__typename !== 'Cart') {
                throw new Error(`Invalid cart attributes update response for ${data?.attributes}`);
            }
            setFinished(true);
            setCart(updatedCart);
            if (callback)
                callback(updatedCart);
            return updatedCart;
        }
        catch (error) {
            console.error('cartUpdateAttributes:error', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    return {
        cartUpdateAttributes,
        setStarted,
        setErrors,
        setFinished,
        ...status,
    };
};
exports.useCartUpdateAttributes = useCartUpdateAttributes;
//# sourceMappingURL=useCartUpdateAttributes.js.map

/***/ }),

/***/ 44717:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartUpdateBuyerIdentity = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCartStartFinishErrors_1 = __webpack_require__(74420);
const useCartUpdateBuyerIdentity = (options) => {
    const { setStarted, setFinished, setErrors, ...status } = (0, useCartStartFinishErrors_1.useCartStartFinishErrors)({ ...options, id: 'cart/updateBuyerIdentity' });
    const setCart = (0, store_1.useSetRecoilState)(store_1.default.cart);
    const cartUpdateBuyerIdentity = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        const release = snapshot.retain();
        try {
            setStarted(true);
            let validationErrors = null;
            switch (true) {
                case !data: {
                    validationErrors = [
                        'parameter is required; must be an object with "buyerIdentity", e.g. "{ buyerIdentity: { ... } }"',
                    ];
                    break;
                }
                case typeof data !== 'object': {
                    validationErrors = [
                        'parameter must be an object with "buyerIdentity", e.g. "{ buyerIdentity: { ... } }"',
                    ];
                    break;
                }
                case !data?.buyerIdentity: {
                    validationErrors = [
                        '"buyerIdentity" is required in parameter object, e.g. "{ buyerIdentity: { ... } }"',
                    ];
                    break;
                }
                case typeof data?.buyerIdentity !== 'object': {
                    validationErrors = [
                        '"buyerIdentity" must be an object, e.g. "{ buyerIdentity: { ... } }"',
                    ];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                throw new Error(validationErrors[0]);
            }
            const { error, updatedCart } = await snapshot.getPromise(store_1.default.cartUpdateBuyerIdentity(data));
            if (error) {
                throw new Error(error);
            }
            if (!updatedCart || updatedCart?.__typename !== 'Cart') {
                throw new Error(`Invalid cart buyerIdentity update response for ${data?.buyerIdentity}`);
            }
            setFinished(true);
            setCart(updatedCart);
            if (callback)
                callback(updatedCart);
            return updatedCart;
        }
        catch (error) {
            console.error('cartUpdateBuyerIdentity:error', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    return {
        cartUpdateBuyerIdentity,
        setStarted,
        setErrors,
        setFinished,
        ...status,
    };
};
exports.useCartUpdateBuyerIdentity = useCartUpdateBuyerIdentity;
//# sourceMappingURL=useCartUpdateBuyerIdentity.js.map

/***/ }),

/***/ 83781:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartUpdateItem = void 0;
const tslib_1 = __webpack_require__(59312);
const deepmerge_1 = tslib_1.__importDefault(__webpack_require__(20406));
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCartStartFinishErrors_1 = __webpack_require__(74420);
const useCartUpdateItem = (options) => {
    const { setStarted, setFinished, setErrors, ...status } = (0, useCartStartFinishErrors_1.useCartStartFinishErrors)({ ...options, id: 'cart/updateItem' });
    // action
    const setCart = (0, store_1.useSetRecoilState)(store_1.default.cart);
    // fetch an existing cart using a checkoutId
    const cartUpdateItem = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        const release = snapshot.retain();
        try {
            setStarted(true);
            let validationErrors = null;
            switch (true) {
                case !data:
                    validationErrors = [
                        `parameter is required; must be an object with "lineId", e.g. "{ lineId: 'abc123', quantity: 1 (optional), attributes: [{ key: 'abc', value: '123' }] (optional), sellingPlanId: 'abc123' (optional) }"`,
                    ];
                    break;
                case typeof data !== 'object':
                    validationErrors = [
                        `parameter must be an object with "lineId", e.g. "{ lineId: 'abc123', quantity: 1 (optional), attributes: [{ key: 'abc', value: '123' }] (optional), sellingPlanId: 'abc123' (optional) }"`,
                    ];
                    break;
                case !data?.lineId:
                    validationErrors = [
                        `"lineId" is required in parameter object, e.g. "{ lineId: 'abc123', quantity: 1 (optional), attributes: [{ key: 'abc', value: '123' }] (optional), sellingPlanId: 'abc123' (optional) }"`,
                    ];
                    break;
                // quantity, attributes, merchandiseId, sellingPlanId are optional
                default:
                    break;
            }
            if (validationErrors?.length) {
                throw new Error(validationErrors[0]);
            }
            const _cart = snapshot.getLoadable(store_1.default.cart).contents;
            // find the item to update and merge in the updated props
            const updatedItemData = _cart.lines
                .filter((_line) => _line.id === data.lineId)
                .map((line) => (0, deepmerge_1.default)(line, data))[0];
            const { error, updatedCart } = await snapshot.getPromise(store_1.default.cartUpdateItem(updatedItemData));
            if (error) {
                throw new Error(error);
            }
            if (!updatedCart || updatedCart?.__typename !== 'Cart') {
                throw new Error(`Invalid cart update item response for merchandiseId ${data?.id}`);
            }
            setFinished(true);
            setCart(updatedCart);
            const updatedItem = updatedCart.lines.find((item) => item.id === data?.lineId) || null;
            if (callback)
                callback(updatedItem);
            return updatedItem;
        }
        catch (error) {
            console.error('cartUpdateItem:error', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    return {
        cartUpdateItem,
        setStarted,
        setErrors,
        setFinished,
        ...status,
    };
};
exports.useCartUpdateItem = useCartUpdateItem;
//# sourceMappingURL=useCartUpdateItem.js.map

/***/ }),

/***/ 96442:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartUpdateItems = void 0;
const tslib_1 = __webpack_require__(59312);
const deepmerge_1 = tslib_1.__importDefault(__webpack_require__(20406));
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCartStartFinishErrors_1 = __webpack_require__(74420);
const useCartUpdateItems = (options) => {
    const { setStarted, setFinished, setErrors, ...status } = (0, useCartStartFinishErrors_1.useCartStartFinishErrors)({ ...options, id: 'cart/updateItems' });
    // action
    const setCart = (0, store_1.useSetRecoilState)(store_1.default.cart);
    // fetch an existing cart using a checkoutId
    const cartUpdateItems = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        const release = snapshot.retain();
        try {
            setStarted(true);
            let validationErrors = null;
            switch (true) {
                case !data:
                    validationErrors = [
                        `parameter is required; must be an array of objects with "lineId", e.g. "[{ lineId: 'abc123', quantity: 1 (optional), attributes: [{ key: 'abc', value: '123' }] (optional), sellingPlanId: 'abc123' (optional) }]"`,
                    ];
                    break;
                case !Array.isArray(data):
                    validationErrors = [
                        `parameter must be an array of objects with "lineId", e.g. "[{ lineId: 'abc123', quantity: 1 (optional), attributes: [{ key: 'abc', value: '123' }] (optional), sellingPlanId: 'abc123' (optional) }]"`,
                    ];
                    break;
                case !data?.length:
                    validationErrors = [
                        `parameter array must have at least one item to update, e.g. "[{ lineId: 'abc123', quantity: 1 (optional), attributes: [{ key: 'abc', value: '123' }] (optional), sellingPlanId: 'abc123' (optional) }]"`,
                    ];
                    break;
                case data?.some((item) => !item?.lineId):
                    validationErrors = [
                        `"lineId" is required in every object in parameter array, e.g. "[{ lineId: 'abc123', quantity: 1 (optional), attributes: [{ key: 'abc', value: '123' }] (optional), sellingPlanId: 'abc123' (optional) }]"`,
                    ];
                    break;
                // there's other check we could do like checking quantity is an integer,
                // attributes and array and sellingPlanId a string
                default:
                    break;
            }
            if (validationErrors?.length) {
                throw new Error(validationErrors[0]);
            }
            const _cart = snapshot.getLoadable(store_1.default.cart).contents;
            const lines = _cart.lines.map((_line) => {
                const updatingLine = data.find((_updatingLine) => _updatingLine.lineId === _line.id);
                if (!updatingLine) {
                    return _line;
                }
                return (0, deepmerge_1.default)(_line, updatingLine);
            });
            const { error, updatedCart } = await snapshot.getPromise(store_1.default.cartUpdateItems({ lines }));
            if (error) {
                throw new Error(error);
            }
            if (!updatedCart || updatedCart?.__typename !== 'Cart') {
                throw new Error(`Invalid cart lines update response`);
            }
            setFinished(true);
            setCart(updatedCart);
            const updatingItemIds = data.map((line) => line.lineId);
            const updatedItems = updatedCart.lines.filter((item) => updatingItemIds.includes(item.id)) || [null];
            if (callback)
                callback(updatedItems);
            return updatedItems;
        }
        catch (error) {
            console.error('cartUpdateItems:error', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    return {
        cartUpdateItems,
        setStarted,
        setErrors,
        setFinished,
        ...status,
    };
};
exports.useCartUpdateItems = useCartUpdateItems;
//# sourceMappingURL=useCartUpdateItems.js.map

/***/ }),

/***/ 65201:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartUpdateNote = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCartStartFinishErrors_1 = __webpack_require__(74420);
const useCartUpdateNote = (options) => {
    const { setStarted, setFinished, setErrors, ...status } = (0, useCartStartFinishErrors_1.useCartStartFinishErrors)({ ...options, id: 'cart/updateNote' });
    const setCart = (0, store_1.useSetRecoilState)(store_1.default.cart);
    const cartUpdateNote = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        const release = snapshot.retain();
        try {
            setStarted(true);
            let validationErrors = null;
            switch (true) {
                case !data:
                    validationErrors = [
                        `parameter is required; must be an object with "note", e.g. "{ note: 'hello' }"`,
                    ];
                    break;
                case typeof data !== 'object':
                    validationErrors = [
                        `parameter must be an object with "note", e.g. "{ note: 'hello' }"`,
                    ];
                    break;
                case !data?.note: {
                    validationErrors = [
                        `"note" is required in parameter object, e.g. "{ note: 'hello' }"`,
                    ];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                throw new Error(validationErrors[0]);
            }
            const { error, updatedCart } = await snapshot.getPromise(store_1.default.cartUpdateNote(data));
            if (error) {
                throw new Error(error);
            }
            if (!updatedCart || updatedCart?.__typename !== 'Cart') {
                throw new Error(`Invalid cart note update response for note ${data?.note}`);
            }
            setFinished(true);
            setCart(updatedCart);
            if (callback)
                callback(updatedCart.note);
            return updatedCart.note;
        }
        catch (error) {
            console.error('cartUpdateNote:error', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    return {
        cartUpdateNote,
        setStarted,
        setErrors,
        setFinished,
        ...status,
    };
};
exports.useCartUpdateNote = useCartUpdateNote;
//# sourceMappingURL=useCartUpdateNote.js.map

/***/ }),

/***/ 13437:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartUpdatedAt = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const helpers_1 = __webpack_require__(85542);
const useCartUpdatedAt = () => {
    const isMounted = (0, helpers_1.useMounted)();
    const cartUpdatedAt = (0, store_1.useRecoilValue)(store_1.default.cart)?.updatedAt;
    return isMounted ? cartUpdatedAt : null;
};
exports.useCartUpdatedAt = useCartUpdatedAt;
//# sourceMappingURL=useCartUpdatedAt.js.map

/***/ }),

/***/ 74021:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.cartStore = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable max-lines */
const recoil_1 = __webpack_require__(69853);
const atob_1 = tslib_1.__importDefault(__webpack_require__(88981));
const effects_1 = tslib_1.__importDefault(__webpack_require__(49025));
const store_1 = __webpack_require__(20437);
const client_1 = __webpack_require__(4812);
const client_2 = __webpack_require__(25431);
const cartClient = new client_1.CartClient({
    apiToken: "7b8296bfc85c0cb6fbc85bd5fa81686f",
    apiVersion: '2024-10',
    domain: "shop.brumate.com" || 0,
});
const productClient = new client_2.ProductClient({
    apiToken: "7b8296bfc85c0cb6fbc85bd5fa81686f",
    apiVersion: '2024-10',
    domain: "kryo-gear.myshopify.com",
});
/**
  CART STATE
*/
const cartInit = (0, recoil_1.atom)({
    key: 'cart/cartInit',
    default: null,
    effects: [
        // effects.logStateChange('cartInit'),
        effects_1.default.onChange({
            key: 'cartInit',
            topic: 'CART_INIT',
            actions: ['publishGtmEvent', 'publishBusEvent'],
        }),
    ],
});
const cart = (0, recoil_1.atom)({
    key: 'cart/cart',
    default: null,
    effects: [
        // effects.logStateChange('cart'),
        effects_1.default.setSelfToPersistedKey('cart', `Cart|${effects_1.default.SHOPIFY_NAME}`, 'CART_EXISTING'),
        effects_1.default.onSetUpdatePersistedKey(`Cart|${effects_1.default.SHOPIFY_NAME}`),
        effects_1.default.onChange({
            key: 'cart',
            topic: 'CART_UPDATE',
            actions: ['publishGtmEvent', 'publishBusEvent'],
        }),
    ],
});
const cartLinePriceIn = (0, recoil_1.atomFamily)({
    key: 'cart/linePriceIn',
    default: null,
});
/* Status */
const cartStatusStarted = (0, recoil_1.atomFamily)({
    key: 'cart/statusStarted',
    default: false,
});
const cartStatusFinished = (0, recoil_1.atomFamily)({
    key: 'cart/statusFinished',
    default: false,
});
const cartStatusSuccess = (0, recoil_1.atomFamily)({
    key: 'cart/statusSuccess',
    default: false,
});
const cartStatusErrors = (0, recoil_1.atomFamily)({
    key: 'cart/statusErrors',
    default: [],
});
const cartCheckout = (0, recoil_1.atom)({
    key: 'cart/checkout',
    default: {
        url: null,
        redirect: true,
        multiPass: undefined,
    },
    effects: [
        effects_1.default.onChange({
            key: 'cartCheckout',
            topic: 'CHECKOUT',
            actions: ['publishGtmEvent', 'publishBusEvent'],
        }),
        effects_1.default.onSetRedirectToCheckout(), // last so we have a chance to fire events
    ],
});
/*
  ---------------
  Getters
  ---------------
*/
const cartId$ = (0, recoil_1.selector)({
    key: 'cart/cartId$',
    get: ({ get }) => {
        const _cart = get(cart);
        if (!_cart)
            return null;
        return _cart.id;
    },
});
const cartCount$ = (0, recoil_1.selector)({
    key: 'cart/cartCount$',
    get: ({ get }) => {
        const _cart = get(cart);
        if (!_cart)
            return 0;
        const { lines = [] } = _cart;
        const accLineTotals = (items, { quantity }) => items + quantity;
        const totalItems = lines?.reduce(accLineTotals, 0);
        return totalItems || 0;
    },
});
const cartLocale$ = (0, recoil_1.selector)({
    key: 'cart/locale$',
    get: ({ get }) => {
        const _cart = get(cart);
        if (!_cart?.locale)
            return null;
        return _cart.locale;
    },
});
const cartEmpty$ = (0, recoil_1.selector)({
    key: 'cart/cartEmpty$',
    get: ({ get }) => {
        const _cartCount = get(cartCount$);
        return _cartCount === 0;
    },
});
// not yet supported on CartAPI
const cartGiftCards$ = (0, recoil_1.selector)({
    key: 'cart/cartGiftCards$',
    get: () => {
        return [];
    },
});
const cartDiscounts$ = (0, recoil_1.selector)({
    key: 'cart/cartDiscounts$',
    get: ({ get }) => {
        const _cart = get(cart);
        return _cart?.discountCodes || [];
    },
});
const cartAttributes$ = (0, recoil_1.selector)({
    key: 'cartAttributes$',
    get: ({ get }) => {
        const _cart = get(cart);
        return _cart
            ? _cart.attributes.map(({ key, value }) => ({ key, value }))
            : [];
    },
});
const cartTotal$ = (0, recoil_1.selector)({
    key: 'cart/total$',
    get: ({ get }) => {
        const _cart = get(cart);
        if (!_cart?.estimatedCost?.totalAmount?.amount)
            return 0;
        return _cart.estimatedCost.totalAmount.amount;
    },
});
const cartSubtotal$ = (0, recoil_1.selector)({
    key: 'cart/subtotal$',
    get: ({ get }) => {
        const _cart = get(cart);
        if (!_cart?.estimatedCost?.subtotalAmount?.amount)
            return 0;
        return _cart.estimatedCost.subtotalAmount.amount;
    },
});
const cartTax$ = (0, recoil_1.selector)({
    key: 'cart/tax$',
    get: ({ get }) => {
        const _cart = get(cart);
        if (!_cart?.estimatedCost?.totalTaxAmount?.amount)
            return 0;
        return _cart.estimatedCost.totalTaxAmount.amount;
    },
});
const cartDuty$ = (0, recoil_1.selector)({
    key: 'cart/duty$',
    get: ({ get }) => {
        const _cart = get(cart);
        if (!_cart?.estimatedCost?.totalDutyAmount?.amount)
            return 0;
        return _cart.estimatedCost.totalDutyAmount.amount;
    },
});
const cartDiscountTotal$ = (0, recoil_1.selector)({
    key: 'cart/discountTotal$',
    get: ({ get }) => {
        const _cart = get(cart);
        if (!_cart?.estimatedCost?.totalDiscountAmount?.amount)
            return 0;
        return _cart.estimatedCost.totalDiscountAmount.amount;
    },
});
const cartCheckoutUrl$ = (0, recoil_1.selector)({
    key: 'cart/CheckoutUrl$',
    get: ({ get }) => {
        const _cart = get(cart);
        if (!_cart)
            return null;
        return _cart.checkoutUrl;
    },
});
const cartItems$ = (0, recoil_1.selectorFamily)({
    key: 'cart/cartItems$',
    get: () => ({ get }) => {
        const _cart = get(cart);
        if (!_cart?.lines?.length)
            return [];
        return [..._cart.lines].reverse();
    },
});
const cartItem$ = (0, recoil_1.selectorFamily)({
    key: 'cart/cartItem$',
    get: ({ id: desiredItemId }) => function getCallback({ get }) {
        const _cartItems = get(cartItems$);
        // this helps us build  /products/handle?variant=legacyId from cart items
        const convertItemVariantIdsToLegacy = ({ merchandise, ...item }) => ({
            ...item,
            merchandise: {
                ...merchandise,
                id: (0, atob_1.default)(merchandise.id).split('/').pop(),
            },
        });
        return _cartItems.length
            ? _cartItems
                .filter(({ id }) => id === desiredItemId)
                .map(convertItemVariantIdsToLegacy)[0]
            : null;
    },
});
const cartBuyer$ = (0, recoil_1.selector)({
    key: 'cart/cartBuyer$',
    get: ({ get }) => {
        const _cart = get(cart);
        return _cart.buyerIdentity;
    },
});
const cartEmail$ = (0, recoil_1.selector)({
    key: 'cart/cartEmail$',
    get: ({ get }) => {
        const _cart = get(cart);
        return _cart?.buyerIdentity?.email ? _cart.buyerIdentity.email : null;
    },
});
/**
 * New async fetchers and setters
 */
const cartCreate = (0, recoil_1.selectorFamily)({
    key: 'cart/create',
    get: ({ country, cartInput }) => async () => {
        return cartClient.create({ country, cartInput });
    },
});
const cartGet = (0, recoil_1.selectorFamily)({
    key: 'cart/get',
    get: ({ id }) => async ({ get }) => {
        const _country = get(store_1.shopStore.country);
        const country = _country;
        return cartClient.get({ id, country: country.isoCode });
    },
});
const cartAddItem = (0, recoil_1.selectorFamily)({
    key: 'cart/addItem',
    get: (data) => async ({ get }) => {
        const _cart = get(cart);
        const _cartId = _cart?.id || null;
        const country = get(store_1.shopStore.country);
        return cartClient.addItem({
            cartId: _cartId,
            country: country?.isoCode,
            ...data,
        });
    },
});
const cartAddItems = (0, recoil_1.selectorFamily)({
    key: 'cart/addItems',
    get: ({ lines = [] }) => async ({ get }) => {
        const _cart = get(cart);
        const _cartId = _cart?.id || null;
        const country = get(store_1.shopStore.country);
        return cartClient.addItem({
            cartId: _cartId,
            country: country?.isoCode,
            lines,
        });
    },
});
const cartRemoveItem = (0, recoil_1.selectorFamily)({
    key: 'cart/removeItem',
    get: ({ lineId }) => async ({ get }) => {
        const _cart = get(cart);
        const _cartId = _cart?.id || null;
        const country = get(store_1.shopStore.country);
        return cartClient.removeItem({
            cartId: _cartId,
            country: country?.isoCode,
            lineId,
        });
    },
});
const cartRemoveItems = (0, recoil_1.selectorFamily)({
    key: 'cart/removeItems',
    get: ({ lineIds = [] }) => async ({ get }) => {
        const _cart = get(cart);
        const _cartId = _cart?.id || null;
        const country = get(store_1.shopStore.country);
        return cartClient.removeItems({
            cartId: _cartId,
            country: country?.isoCode,
            lineIds,
        });
    },
});
const cartUpdateItem = (0, recoil_1.selectorFamily)({
    key: 'cart/updateItem',
    get: (data) => async ({ get }) => {
        const _cart = get(cart);
        const _cartId = _cart?.id || null;
        const country = get(store_1.shopStore.country);
        return cartClient.updateItem({
            cartId: _cartId,
            country: country?.isoCode,
            ...data,
        });
    },
});
const cartUpdateItems = (0, recoil_1.selectorFamily)({
    key: 'cart/updateItems',
    get: (data) => async ({ get }) => {
        const _cart = get(cart);
        const _cartId = _cart?.id || null;
        const country = get(store_1.shopStore.country);
        return cartClient.updateItems({
            cartId: _cartId,
            country: country?.isoCode,
            ...data,
        });
    },
});
const cartUpdateNote = (0, recoil_1.selectorFamily)({
    key: 'cart/updateNote',
    get: (data) => async ({ get }) => {
        const _cart = get(cart);
        const _cartId = _cart?.id || null;
        const country = get(store_1.shopStore.country);
        return cartClient.updateNote({
            cartId: _cartId,
            country: country?.isoCode,
            ...data,
        });
    },
});
const cartUpdateDiscount = (0, recoil_1.selectorFamily)({
    key: 'cart/updateDiscount',
    get: (data) => async ({ get }) => {
        const _cart = get(cart);
        const _cartId = _cart?.id || null;
        const country = get(store_1.shopStore.country);
        return cartClient.updateDiscount({
            cartId: _cartId,
            country: country?.isoCode,
            ...data,
        });
    },
});
const cartRemoveDiscount = (0, recoil_1.selectorFamily)({
    key: 'cart/removeDiscount',
    get: () => async ({ get }) => {
        const _cart = get(cart);
        const _cartId = _cart?.id || null;
        const country = get(store_1.shopStore.country);
        return cartClient.removeDiscount({
            cartId: _cartId,
            country: country?.isoCode,
            discountCodes: [],
        });
    },
});
const cartUpdateAttributes = (0, recoil_1.selectorFamily)({
    key: 'cart/updateAttributes',
    get: (data) => async ({ get }) => {
        const _cart = get(cart);
        const _cartId = _cart?.id || null;
        const country = get(store_1.shopStore.country);
        return cartClient.updateAttributes({
            cartId: _cartId,
            country: country?.isoCode,
            ...data,
        });
    },
});
const cartUpdateBuyerIdentity = (0, recoil_1.selectorFamily)({
    key: 'cart/updateBuyerIdentity',
    get: (data) => async ({ get }) => {
        const _cart = get(cart);
        const _cartId = _cart?.id || null;
        const country = get(store_1.shopStore.country);
        return cartClient.updateBuyerIdentity({
            cartId: _cartId,
            country: data?.country || country?.isoCode,
            ...data,
        });
    },
});
const fetchCartLinePriceIn = (0, recoil_1.selectorFamily)({
    key: 'cart/fetchCartLinePriceIn',
    get: (data) => async ({ get }) => {
        const passedCountryCode = data?.country?.isoCode || data?.country;
        const country = get(store_1.shopStore.country);
        const _country = passedCountryCode || country.isoCode || 'US';
        return productClient.getLocalizedProduct({
            ...data,
            country: _country,
        });
    },
});
exports.cartStore = {
    // actual state - atoms
    cart,
    cartInit,
    cartCheckout,
    cartLinePriceIn,
    // status
    cartStatusStarted,
    cartStatusFinished,
    cartStatusSuccess,
    cartStatusErrors,
    // computed utils
    cartLocale$,
    cartBuyer$,
    cartId$,
    cartEmpty$,
    cartCount$,
    cartCheckoutUrl$,
    cartGiftCards$,
    cartAttributes$,
    cartDiscounts$,
    cartItems$,
    cartEmail$,
    cartItem$,
    // computed totals
    cartTotal$,
    cartSubtotal$,
    cartTax$,
    cartDuty$,
    cartDiscountTotal$,
    // Async queries and mutations
    cartCreate,
    cartGet,
    cartAddItem,
    cartAddItems,
    cartRemoveItem,
    cartRemoveItems,
    cartRemoveDiscount,
    cartUpdateItem,
    cartUpdateItems,
    cartUpdateNote,
    cartUpdateDiscount,
    cartUpdateAttributes,
    cartUpdateBuyerIdentity,
    fetchCartLinePriceIn,
};
//# sourceMappingURL=cart.js.map

/***/ }),

/***/ 29005:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.cartStore = void 0;
var cart_1 = __webpack_require__(74021);
Object.defineProperty(exports, "cartStore", ({ enumerable: true, get: function () { return cart_1.cartStore; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 50010:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(59312);
tslib_1.__exportStar(__webpack_require__(82311), exports);
tslib_1.__exportStar(__webpack_require__(70673), exports);
tslib_1.__exportStar(__webpack_require__(43301), exports);
tslib_1.__exportStar(__webpack_require__(41198), exports);
tslib_1.__exportStar(__webpack_require__(85583), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 82311:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCollection = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCollection = () => (0, store_1.useRecoilValue)(store_1.default.collection);
exports.useCollection = useCollection;
//# sourceMappingURL=useCollection.js.map

/***/ }),

/***/ 70673:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCollectionByHandle = void 0;
const tslib_1 = __webpack_require__(59312);
const react_1 = __webpack_require__(27378);
const router_1 = __webpack_require__(86677);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const helpers_1 = __webpack_require__(85542);
const store_2 = __webpack_require__(57152);
const useCollectionByHandle = ({ handle = null, fetchOnMount = true, options, }) => {
    const { started, setStarted, finished, setFinished, success, setSuccess, errors, setErrors, reset, resetTimer, } = (0, helpers_1.useStartFinishErrors)(options);
    const { isPreview } = (0, router_1.useRouter)();
    const setCollections = (0, store_1.useSetRecoilState)(store_1.default.collections);
    const [collection, setCollection] = (0, store_1.useRecoilState)(store_1.default.collectionByHandle$(handle));
    // fetch json collection on mount
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        if (!handle) {
            setErrors(['A collection "handle" must be provided']);
        }
        const earlyExitIf = [
            !fetchOnMount,
            !handle,
            finished && collection?.id, // already have a collection
        ];
        if (earlyExitIf.some(Boolean))
            return undefined;
        if (!unMounting)
            setStarted(true);
        store_2.collectionActions
            .fetchCollectionByHandle({ handle, version: 'full' })
            .then((jsonCollection) => {
            // bad response
            if ((!jsonCollection || !jsonCollection?.id) && !unMounting) {
                setErrors(['Invalid collection response']);
            }
            // fetch collection products
            fetch(`/json/collections/products/${jsonCollection.handle}.json`)
                .then((response) => response.json())
                .then((result) => {
                const loadedProducts = isPreview
                    ? result
                    : result.filter((product) => product.status === 'ACTIVE');
                const fullJsonCollection = {
                    ...jsonCollection,
                    products: [...jsonCollection.products, ...loadedProducts],
                };
                if (!unMounting)
                    setCollection(fullJsonCollection);
                if (!unMounting)
                    setFinished(true);
                // all good update collections, which in turns updates
                // the collectionByHandle familiy selector
                if (!unMounting) {
                    setCollections((collections) => ({
                        ...collections,
                        [jsonCollection.handle]: fullJsonCollection,
                    }));
                }
            });
        })
            .catch((error) => {
            if (!unMounting)
                setErrors([error.message]);
        });
        return () => {
            unMounting = true;
        };
    }, [handle, fetchOnMount]);
    return {
        collection: collection || null,
        fetchCollectionByHandle: store_2.collectionActions.fetchCollectionByHandle,
        started,
        finished,
        success,
        setSuccess,
        errors,
        setErrors,
        resetTimer,
        reset,
    };
};
exports.useCollectionByHandle = useCollectionByHandle;
//# sourceMappingURL=useCollectionByHandle.js.map

/***/ }),

/***/ 43301:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCollectionHandles = void 0;
const tslib_1 = __webpack_require__(59312);
const react_1 = __webpack_require__(27378);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const helpers_1 = __webpack_require__(85542);
const store_2 = __webpack_require__(57152);
const useCollectionHandles = ({ fetchOnMount, options } = { fetchOnMount: true, options: null }) => {
    const { started, setStarted, finished, setFinished, success, setSuccess, errors, setErrors, reset, resetTimer, } = (0, helpers_1.useStartFinishErrors)(options);
    const [collectionHandles, setCollectionHandles] = (0, store_1.useRecoilState)(store_1.default.collectionHandles);
    // fetch json collection on mount
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [
            !fetchOnMount,
            finished && collectionHandles?.length, // already have a collection
        ];
        if (earlyExitIf.some(Boolean))
            return undefined;
        if (!unMounting)
            setStarted(true);
        store_2.collectionActions
            .fetchCollectionHandles()
            .then((jsonCollectionHandles) => {
            // bad response
            if ((!jsonCollectionHandles || !jsonCollectionHandles?.length) &&
                !unMounting) {
                setErrors(['Invalid collection handles response']);
            }
            if (!unMounting)
                setFinished(true);
            // all good update collections, which in turns updates
            // the collectionByHandle familiy selector
            if (!unMounting)
                setCollectionHandles(jsonCollectionHandles);
        })
            .catch((error) => {
            if (!unMounting)
                setErrors([error.message]);
        });
        return () => {
            unMounting = true;
        };
    }, [fetchOnMount, collectionHandles]);
    return {
        collectionHandles,
        fetchCollectionHandles: store_2.collectionActions.fetchCollectionHandles,
        started,
        finished,
        success,
        setSuccess,
        errors,
        setErrors,
        resetTimer,
        reset,
    };
};
exports.useCollectionHandles = useCollectionHandles;
//# sourceMappingURL=useCollectionHandles.js.map

/***/ }),

/***/ 85583:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCollectionsIndex = void 0;
const tslib_1 = __webpack_require__(59312);
const react_1 = __webpack_require__(27378);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const helpers_1 = __webpack_require__(85542);
const store_2 = __webpack_require__(57152);
const useCollectionsIndex = ({ fetchOnMount, options } = { fetchOnMount: true, options: null }) => {
    const { started, setStarted, finished, setFinished, success, setSuccess, errors, setErrors, reset, resetTimer, } = (0, helpers_1.useStartFinishErrors)(options);
    const [collectionsIndex, setCollectionIndex] = (0, store_1.useRecoilState)(store_1.default.collectionsIndex);
    // fetch json collections on mount
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [
            !fetchOnMount,
            finished && collectionsIndex?.keys, // already have a collections
        ];
        if (earlyExitIf.some(Boolean))
            return undefined;
        if (!unMounting)
            setStarted(true);
        store_2.collectionActions
            .fetchCollectionsIndex()
            .then((jsonCollectionIndex) => {
            // bad response
            if ((!jsonCollectionIndex || !jsonCollectionIndex?.keys) &&
                !unMounting) {
                setErrors(['Invalid collections index response']);
            }
            if (!unMounting)
                setFinished(true);
            // all good update collectionss, which in turns updates
            // the collectionsByHandle familiy selector
            if (!unMounting)
                setCollectionIndex(jsonCollectionIndex);
        })
            .catch((error) => {
            console.log('error', error);
            if (!unMounting)
                setErrors([error.message]);
        });
        return () => {
            unMounting = true;
        };
    }, [fetchOnMount, collectionsIndex]);
    return {
        collectionsIndex,
        fetchCollectionsIndex: store_2.collectionActions.fetchCollectionsIndex,
        started,
        finished,
        success,
        setSuccess,
        errors,
        setErrors,
        resetTimer,
        reset,
    };
};
exports.useCollectionsIndex = useCollectionsIndex;
//# sourceMappingURL=useCollectionsIndex.js.map

/***/ }),

/***/ 41198:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCollectionsList = void 0;
const tslib_1 = __webpack_require__(59312);
const react_1 = __webpack_require__(27378);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const helpers_1 = __webpack_require__(85542);
const store_2 = __webpack_require__(57152);
const useCollectionsList = ({ fetchOnMount, options } = { fetchOnMount: true, options: null }) => {
    const { started, setStarted, finished, setFinished, success, setSuccess, errors, setErrors, reset, resetTimer, } = (0, helpers_1.useStartFinishErrors)(options);
    const [collectionsList, setCollectionList] = (0, store_1.useRecoilState)(store_1.default.collectionsList);
    // fetch json collections on mount
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [
            !fetchOnMount,
            finished && collectionsList?.length, // already have a collections
        ];
        if (earlyExitIf.some(Boolean))
            return undefined;
        if (!unMounting)
            setStarted(true);
        store_2.collectionActions
            .fetchCollectionsList()
            .then((jsonCollectionList) => {
            // bad response
            if ((!jsonCollectionList || !jsonCollectionList?.length) &&
                !unMounting) {
                setErrors(['Invalid collections list response']);
            }
            if (!unMounting)
                setFinished(true);
            // all good update collectionss, which in turns updates
            // the collectionsByHandle familiy selector
            if (!unMounting)
                setCollectionList(jsonCollectionList);
        })
            .catch((error) => {
            if (!unMounting)
                setErrors([error.message]);
        });
        return () => {
            unMounting = true;
        };
    }, [fetchOnMount, collectionsList]);
    return {
        collectionsList,
        fetchCollectionsList: store_2.collectionActions.fetchCollectionsList,
        started,
        finished,
        success,
        setSuccess,
        errors,
        setErrors,
        resetTimer,
        reset,
    };
};
exports.useCollectionsList = useCollectionsList;
//# sourceMappingURL=useCollectionsList.js.map

/***/ }),

/***/ 39939:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fetchCollectionHandles = exports.fetchCollectionsIndex = exports.fetchCollectionsList = exports.fetchCollectionByHandle = void 0;
const fetchCollectionByHandle = async ({ handle }) => {
    if (!handle)
        throw new TypeError('Missing required product "handle"');
    try {
        const url = `/json/collections/${handle}.json`;
        // eslint-disable-next-line no-undef
        const response = await fetch(url);
        if (response?.ok) {
            return await response.json();
        }
        return null;
    }
    catch (error) {
        console.error(`Failed to fetch ${handle} collection due to`, error.message);
        throw error;
    }
};
exports.fetchCollectionByHandle = fetchCollectionByHandle;
// collection listings and index fetch factory
const _fetchCollections = (target) => async () => {
    if (!target)
        throw new TypeError('Missing required collection endpoint "target"');
    try {
        const productUrl = `/json/${target}.json`;
        // eslint-disable-next-line no-undef
        const response = await fetch(productUrl);
        if (response?.ok) {
            return await response.json();
        }
        return null;
    }
    catch (error) {
        console.error(`Failed to fetch ${target} due to`, error.message);
        throw error;
    }
};
// product listings and indexes
exports.fetchCollectionsList = _fetchCollections('collections-list');
exports.fetchCollectionsIndex = _fetchCollections('collections-index');
exports.fetchCollectionHandles = _fetchCollections('collections');
//# sourceMappingURL=actions.js.map

/***/ }),

/***/ 12255:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.collectionStore = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable max-lines */
const recoil_1 = __webpack_require__(69853);
const effects_1 = tslib_1.__importDefault(__webpack_require__(49025));
/**
  Product State
*/
const collection = (0, recoil_1.atom)({
    key: 'collection/collection',
    default: null,
    effects: [
        effects_1.default.onChange({
            key: 'collection',
            topic: 'COLLECTION_UPDATE',
            actions: ['publishBusEvent'],
        }),
    ],
});
const collections = (0, recoil_1.atom)({
    key: 'collection/collections',
    default: {},
});
const collectionsList = (0, recoil_1.atom)({
    key: 'collection/collectionsList',
    default: [],
});
// collections json fuse index
const collectionsIndex = (0, recoil_1.atom)({
    key: 'collection/collectionsIndex',
    default: null,
});
const collectionHandles = (0, recoil_1.atom)({
    key: 'collection/collectionHandles',
    default: [],
});
const collectionByHandle$ = (0, recoil_1.selectorFamily)({
    key: 'collection/collectionByHandle$',
    get: (handle) => function ({ get }) {
        const _collections = get(collections);
        const _collection = _collections && handle ? _collections[handle] : null;
        return _collection || null;
    },
    set: (handle) => ({ get, set }, newCollection) => {
        const _collections = get(collections);
        if (newCollection && newCollection?.handle && !_collections[handle]) {
            // add collection to cached list
            const _updatedCollections = {
                ..._collections,
                [handle]: newCollection,
            };
            set(collections, _updatedCollections);
            // set collection as default
            set(collection, newCollection);
        }
    },
});
exports.collectionStore = {
    // actual state - atoms
    collection,
    collections,
    collectionHandles,
    collectionsIndex,
    collectionsList,
    collectionByHandle$,
};
//# sourceMappingURL=collection.js.map

/***/ }),

/***/ 57152:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.collectionActions = exports.collectionStore = void 0;
const tslib_1 = __webpack_require__(59312);
var collection_1 = __webpack_require__(12255);
Object.defineProperty(exports, "collectionStore", ({ enumerable: true, get: function () { return collection_1.collectionStore; } }));
exports.collectionActions = tslib_1.__importStar(__webpack_require__(39939));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 86910:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CustomerClient = void 0;
class CustomerClient {
    constructor({ debug }) {
        this.debug = debug || false;
    }
    // eslint-disable-next-line class-methods-use-this
    async customerApi({ endpoint = 'get', body }) {
        const method = 'POST';
        const url = `/api/customer/${endpoint}`;
        const headers = { 'Content-Type': 'application/json' };
        try {
            // eslint-disable-next-line no-undef
            const request = await fetch(url, {
                method,
                headers,
                body: JSON.stringify(body),
            });
            if (!request?.ok) {
                throw new Error(`${endpoint} request not ok`);
            }
            const data = await request.json();
            if (this.debug) {
                console.log(`CustomerClient: ${url}`, body);
            }
            const { ok, errors, response } = data;
            if (errors?.length) {
                throw new Error(errors[0]);
            }
            if (!ok) {
                throw new Error(`${endpoint} response not ok`);
            }
            return { error: null, data: response };
        }
        catch (error) {
            console.log(`CustomerClient: ${url}/error: ${error.message}`);
            return { error: error.message, data: null };
        }
    }
    // Customer
    async activate(body) {
        return this.customerApi({ endpoint: 'activate', body });
    }
    async get(body) {
        return this.customerApi({ endpoint: 'get', body });
    }
    async login(body) {
        return this.customerApi({ endpoint: 'login', body });
    }
    async create(body) {
        return this.customerApi({ endpoint: 'create', body });
    }
    async update(body) {
        return this.customerApi({ endpoint: 'update', body });
    }
    async orders(body) {
        return this.customerApi({ endpoint: 'orders', body });
    }
    async order(body) {
        return this.customerApi({ endpoint: 'order', body });
    }
    async metafield(body) {
        return this.customerApi({ endpoint: 'metafield', body });
    }
    // Address
    async addresses(body) {
        return this.customerApi({ endpoint: 'addresses', body });
    }
    async addressCreate(body) {
        return this.customerApi({ endpoint: 'address-create', body });
    }
    async addressUpdate(body) {
        return this.customerApi({ endpoint: 'address-update', body });
    }
    async addressDelete(body) {
        return this.customerApi({ endpoint: 'address-delete', body });
    }
    // Password
    async passwordRecover(body) {
        return this.customerApi({ endpoint: 'password-recover', body });
    }
    async passwordReset(body) {
        return this.customerApi({ endpoint: 'password-reset', body });
    }
}
exports.CustomerClient = CustomerClient;
//# sourceMappingURL=client.js.map

/***/ }),

/***/ 40354:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CustomerClient = void 0;
var client_1 = __webpack_require__(86910);
Object.defineProperty(exports, "CustomerClient", ({ enumerable: true, get: function () { return client_1.CustomerClient; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 33296:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(59312);
tslib_1.__exportStar(__webpack_require__(28640), exports); // new on v2 (async);
tslib_1.__exportStar(__webpack_require__(23478), exports); // new on v2
tslib_1.__exportStar(__webpack_require__(62081), exports); // new on v2
// getters — selectors
tslib_1.__exportStar(__webpack_require__(78138), exports); // now async on v2
tslib_1.__exportStar(__webpack_require__(52995), exports); // now async on v2
tslib_1.__exportStar(__webpack_require__(16764), exports);
tslib_1.__exportStar(__webpack_require__(61491), exports);
tslib_1.__exportStar(__webpack_require__(17382), exports);
// musts
tslib_1.__exportStar(__webpack_require__(41674), exports);
tslib_1.__exportStar(__webpack_require__(50124), exports);
// customer apis
tslib_1.__exportStar(__webpack_require__(67839), exports);
tslib_1.__exportStar(__webpack_require__(49638), exports);
tslib_1.__exportStar(__webpack_require__(81820), exports);
tslib_1.__exportStar(__webpack_require__(81151), exports);
tslib_1.__exportStar(__webpack_require__(52174), exports);
tslib_1.__exportStar(__webpack_require__(81041), exports);
// address apis
tslib_1.__exportStar(__webpack_require__(53063), exports);
tslib_1.__exportStar(__webpack_require__(59130), exports);
tslib_1.__exportStar(__webpack_require__(9230), exports);
// password apis
tslib_1.__exportStar(__webpack_require__(62148), exports);
tslib_1.__exportStar(__webpack_require__(23246), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 16764:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomer = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCustomer = () => (0, store_1.useRecoilValue)(store_1.default.customer);
exports.useCustomer = useCustomer;
//# sourceMappingURL=useCustomer.js.map

/***/ }),

/***/ 17382:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerAccessToken = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCustomerAccessToken = () => (0, store_1.useRecoilValue)(store_1.default.accessToken);
exports.useCustomerAccessToken = useCustomerAccessToken;
//# sourceMappingURL=useCustomerAccessToken.js.map

/***/ }),

/***/ 81820:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerActivate = void 0;
const tslib_1 = __webpack_require__(59312);
const useCustomerStartFinishErrors_1 = __webpack_require__(22957);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const defaultProps = {
    options: {},
};
const useCustomerActivate = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const { started, setStarted, finished, setFinished, errors, setErrors, reset, resetTimer, } = (0, useCustomerStartFinishErrors_1.useCustomerStartFinishErrors)({
        ...props.options,
        id: 'customer/activate',
    });
    // state
    const _accessToken = (0, store_1.useRecoilValue)(store_1.default.accessToken);
    const _customer = (0, store_1.useRecoilValue)(store_1.default.customer);
    // login method - get token from email and password then get customer from token
    const activateAccount = (0, store_1.useRecoilCallback)(({ snapshot, set }) => async (data, callback) => {
        const release = snapshot.retain();
        setStarted(true);
        let validationErrors = null;
        switch (true) {
            case !data?.customerId:
                validationErrors = ['customerId not provided'];
                break;
            case !data?.activationToken:
                validationErrors = ['activationToken not provided'];
                break;
            case !data?.password:
                validationErrors = ['password not provided'];
                break;
            default:
                break;
        }
        if (validationErrors?.length) {
            setErrors(validationErrors);
            return null;
        }
        try {
            const { error, data: response } = await snapshot.getPromise(store_1.default.fetchCustomerActivate(data));
            if (error) {
                setErrors([error]);
                return null;
            }
            if (!response?.customer) {
                setErrors(['Invalid activate response missing customer']);
                return null;
            }
            if (!response?.accessToken) {
                setErrors(['Invalid activate response missing accessToken']);
                return null;
            }
            const { customer, accessToken } = response;
            setFinished(true);
            set(store_1.default.accessToken, accessToken);
            set(store_1.default.customer, customer);
            if (callback)
                callback(customer);
            return customer;
        }
        catch (error) {
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    // hook return
    return {
        activateAccount,
        accessToken: finished ? _accessToken : null,
        customer: finished ? _customer : null,
        started,
        finished,
        success: !errors?.length || false,
        errors,
        setErrors,
        resetTimer,
        reset,
    };
};
exports.useCustomerActivate = useCustomerActivate;
//# sourceMappingURL=useCustomerActivate.js.map

/***/ }),

/***/ 52995:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerAddresses = void 0;
const tslib_1 = __webpack_require__(59312);
const react_1 = __webpack_require__(27378);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCustomerStartFinishErrors_1 = __webpack_require__(22957);
const defaultProps = {
    fetchOnMount: true,
    options: {},
};
const useCustomerAddresses = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const fetching = (0, react_1.useRef)(false);
    const { setStarted, setFinished, setErrors, finished, ...status } = (0, useCustomerStartFinishErrors_1.useCustomerStartFinishErrors)({
        ...props.options,
        id: 'customer/addresses',
    });
    const [addresses, setAddresses] = (0, store_1.useRecoilState)(store_1.default.customerAddresses);
    const getAddresses = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        const release = snapshot.retain();
        setStarted(true);
        try {
            const { error, data: response } = await snapshot.getPromise(store_1.default.fetchAddresses());
            if (error) {
                setErrors([error]);
                return null;
            }
            if (!response?.addresses) {
                setErrors([`Missing addresses data for ${data}`]);
                return null;
            }
            setFinished(true);
            setAddresses(response.addresses);
            if (callback)
                callback(response.addresses);
            return response.addresses;
        }
        catch (error) {
            console.error('getAddresses:error', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    }, []);
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [
            !props.fetchOnMount,
            fetching.current,
            addresses?.length, // already have order
        ];
        if (earlyExitIf.some(Boolean)) {
            return undefined;
        }
        fetching.current = true;
        getAddresses()
            .then((_addresses) => {
            if (unMounting)
                return;
            setAddresses(_addresses);
            fetching.current = false;
        })
            .catch((error) => {
            console.error('failed to getAddresses due to', error.message);
        });
        return () => {
            unMounting = true;
            fetching.current = false;
        };
    }, [props.fetchOnMount]);
    return {
        addresses,
        getAddresses,
        setStarted,
        setFinished,
        setErrors,
        finished,
        ...status,
    };
};
exports.useCustomerAddresses = useCustomerAddresses;
//# sourceMappingURL=useCustomerAddresses.js.map

/***/ }),

/***/ 41674:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerAuth = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable prettier/prettier */
const react_1 = __webpack_require__(27378);
const router_1 = __webpack_require__(86677);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCustomer_1 = __webpack_require__(16764);
const defaultProps = {
    autoRedirect: true,
    defaultRoute: '/account/orders',
    id: '', // to help console.log specific useCustomerAuth instances
};
const useCustomerAuth = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const { autoRedirect, defaultRoute, id } = props;
    const router = (0, router_1.useRouter)();
    const customer = (0, useCustomer_1.useCustomer)();
    const customerInit = (0, store_1.useRecoilValue)(store_1.default.customerInit);
    const [authenticated, setAuthenticated] = (0, store_1.useRecoilState)(store_1.default.authenticated);
    // path checkers
    const onLoginPath = /\/login/g.test(router?.asPath || '');
    const onRegisterPath = /\/register/g.test(router?.asPath || '');
    const onResetPath = /\/reset/g.test(router?.asPath || '');
    const onActivatePath = /\/activate/g.test(router?.asPath || '');
    const onLoginRegisterActivateOrResetPath = onLoginPath || onRegisterPath || onActivatePath || onResetPath;
    const onAnyAccountPath = /\/account/g.test(router?.asPath || '');
    const onAuthenticatedPath = onAnyAccountPath && !onLoginRegisterActivateOrResetPath;
    const queriedRedirectPath = router.query?.redirect;
    const onRedirectToPath = queriedRedirectPath
        ? router?.asPath === queriedRedirectPath
        : false;
    const isDefaultRoute = router?.asPath === defaultRoute;
    // Authenticate the user and maybe auto-redirect
    const authenticateUser = () => {
        // console.log(id, 'authenticateUser:customerInit', customerInit);
        if (!customerInit) {
            // Customer not ready, waiting for customerInit..
            return;
        }
        if (authenticated || authenticated === false) {
            // console.log(id, 'authenticateUser: non need to reauthenticate')
            return;
        }
        // Customer is ready..
        const loggedIn = customer?.id;
        if (loggedIn) {
            setAuthenticated(true);
            return;
        }
        setAuthenticated(false);
    };
    const routeGuest = () => {
        // Customer is ready..
        const loggedIn = customer?.id;
        if (loggedIn) {
            // console.log(id, 'routeGuest: already logged in early exit')
            return null;
        }
        if (authenticated !== false) {
            // console.log(id, 'routeGuest: authenticated or not yet authenticated early exit');
            return null; // can be 'undefined', 'false', true
        }
        // console.log('kick out if not logged in and the current path is protected')
        if (onAuthenticatedPath) {
            // console.log(id, 'routeGuest:Not logged in accessing a protected route. redirecting to login')
            router.push('/account/login');
        }
        else {
            // console.log(id, 'routeGuest:Not logged and accessing unprotected route. not redirecting (login, register, reset, activate)');
        }
        return null;
    };
    const routeCustomer = () => {
        if (!authenticated) {
            // console.log(id, 'routeCustomer: not authenticated early exit');
            return;
        }
        if (!onAnyAccountPath) {
            // console.log(id, `routeCustomer:Modal login scenario — NOT coming from /account/login, /account/register or /account/reset or any /account/x don't auto redirect`);
            return;
        }
        // if user sets withLogin.. HOC authOptions to autoRedirect: false
        if (!autoRedirect) {
            // console.log(id, 'routeCustomer:user needs to manually redirect away from these routes');
            return;
        }
        // user passed a redirect url via  ?redirect=/pages/xxx
        if (queriedRedirectPath && !onRedirectToPath) {
            // console.log(id, 'routeCustomer:Auto-redirecting to passed ?redirect');
            router.push(queriedRedirectPath);
            return;
        }
        /*
          This could be cleaned up into no if/else,
          I just want to keep it like this for clarity
          and future troubleshooting
        */
        if (onAuthenticatedPath) {
            // console.log(id, 'routeCustomer:Inside a protected account route. Not redirecting - eg. from /account/orders to /account/address')
        }
        else if (isDefaultRoute) {
            // console.log(id, 'routeCustomer:Already in default account route e.g /account/orders, No redirecting')
        }
        else {
            // console.log(id, `routeCustomer:Auto-redirecting to default ${defaultRoute || '/account/orders'}`)
            router.push(defaultRoute || '/account/orders');
        }
    };
    (0, react_1.useEffect)(() => {
        authenticateUser();
    }, [customerInit, authenticated, id]);
    // logged-out routing
    (0, react_1.useEffect)(() => {
        routeGuest();
    }, [authenticated, id, customer, onAuthenticatedPath]);
    // logged-in routing
    (0, react_1.useEffect)(() => {
        routeCustomer();
    }, [
        authenticated,
        id,
        customer,
        onAnyAccountPath,
        autoRedirect,
        queriedRedirectPath,
        onRedirectToPath,
        onAuthenticatedPath,
        isDefaultRoute,
        defaultRoute,
    ]);
    return { authenticated, customer, customerInit };
};
exports.useCustomerAuth = useCustomerAuth;
//# sourceMappingURL=useCustomerAuth.js.map

/***/ }),

/***/ 49638:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerCreate = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCustomerStartFinishErrors_1 = __webpack_require__(22957);
const defaultProps = {
    options: {},
};
const useCustomerCreate = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const { started, setStarted, finished, setFinished, errors, setErrors, reset, resetTimer, } = (0, useCustomerStartFinishErrors_1.useCustomerStartFinishErrors)({ ...props.options, id: 'customer/create' });
    // state
    const _accessToken = (0, store_1.useRecoilValue)(store_1.default.accessToken);
    const _customer = (0, store_1.useRecoilValue)(store_1.default.customer);
    // sign up method
    const customerCreate = (0, store_1.useRecoilCallback)(({ snapshot, set }) => async (data, callback) => {
        setStarted(true);
        let validationErrors = null;
        switch (true) {
            case !data:
                validationErrors = ['data not provided'];
                break;
            case !data.firstName:
                validationErrors = ['firstName not provided'];
                break;
            case !data.lastName:
                validationErrors = ['lastName not provided'];
                break;
            case !data.email:
                validationErrors = ['email not provided'];
                break;
            case !data.password:
                validationErrors = ['password not provided'];
                break;
            case typeof data.acceptsMarketing === 'undefined':
                validationErrors = ['acceptsMarketing not provided'];
                break;
            default:
                break;
        }
        if (validationErrors?.length) {
            setErrors(validationErrors);
            return null;
        }
        try {
            const { error, data: response } = await snapshot.getPromise(store_1.default.fetchCustomerCreate(data));
            if (error) {
                setErrors([error]);
                return null;
            }
            const { customer, accessToken } = response;
            if (!customer?.__typename === 'Customer') {
                setErrors(['Invalid customer response']);
                return null;
            }
            if (!accessToken?.__typename === 'CustomerAccessToken') {
                setErrors(['Invalid customer accessToken response']);
                return null;
            }
            setFinished(true);
            // used to distinguish new sign ups and fire GTM events
            set(store_1.default.customer, customer);
            set(store_1.default.newCustomer, customer);
            set(store_1.default.accessToken, accessToken);
            set(store_1.default.authenticated, true);
            if (callback)
                callback(customer);
            return customer;
        }
        catch (error) {
            setErrors([error.message]);
            return null;
        }
    });
    // hook return
    return {
        customerCreate,
        accessToken: finished ? _accessToken : null,
        customer: finished ? _customer : null,
        started,
        finished,
        success: !errors?.length || false,
        errors,
        setErrors,
        resetTimer,
        reset,
    };
};
exports.useCustomerCreate = useCustomerCreate;
//# sourceMappingURL=useCustomerCreate.js.map

/***/ }),

/***/ 53063:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerCreateAddress = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCustomerStartFinishErrors_1 = __webpack_require__(22957);
const useCustomerGet_1 = __webpack_require__(67839);
const defaultProps = {
    options: {},
};
const useCustomerCreateAddress = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const { started, setStarted, finished, setFinished, errors, setErrors, reset, resetTimer, } = (0, useCustomerStartFinishErrors_1.useCustomerStartFinishErrors)({
        ...props.options,
        id: 'customer/addressCreate',
    });
    const { customerGet } = (0, useCustomerGet_1.useCustomerGet)();
    const addresses = (0, store_1.useRecoilValue)(store_1.default.customerAddresses);
    // update a customer address, (optionally) set as default and get fresh customer
    const createAddress = (0, store_1.useRecoilCallback)(({ snapshot, set }) => async (data, callback) => {
        const release = snapshot.retain();
        try {
            setStarted(true);
            let validationErrors = null;
            switch (true) {
                case !data?.address: {
                    validationErrors = ['address object to update not provided'];
                    break;
                }
                case typeof data?.isDefault === 'undefined': {
                    validationErrors = ['isDefault not provided'];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                setErrors(validationErrors);
                return null;
            }
            // accessToken is required and will be injected at addressCreate$
            const { error, data: response } = await snapshot.getPromise(store_1.default.fetchAddressCreate(data));
            if (error) {
                setErrors([error]);
                return null;
            }
            if (!response?.address) {
                setErrors(['Invalid address create response']);
                return null;
            }
            const { address: newAddress } = response;
            // update the cached address and add the new address
            const updatedAddresses = [...addresses, newAddress];
            set(store_1.default.customerAddresses, updatedAddresses);
            setFinished(true);
            if (callback)
                callback(newAddress);
            await customerGet({ forceUpdate: true });
            return newAddress; // new address
        }
        catch (error) {
            console.error(`createAddress:error ${error.message}`);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    // hook return
    return {
        createAddress,
        started,
        finished,
        success: !errors?.length || false,
        errors,
        setErrors,
        resetTimer,
        reset,
    };
};
exports.useCustomerCreateAddress = useCustomerCreateAddress;
//# sourceMappingURL=useCustomerCreateAddress.js.map

/***/ }),

/***/ 61491:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerDefaultAddress = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCustomerDefaultAddress = () => {
    return (0, store_1.useRecoilValue)(store_1.default.customerDefaultAddress$);
};
exports.useCustomerDefaultAddress = useCustomerDefaultAddress;
//# sourceMappingURL=useCustomerDefaultAddress.js.map

/***/ }),

/***/ 9230:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerDeleteAddress = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCustomerStartFinishErrors_1 = __webpack_require__(22957);
const useCustomerGet_1 = __webpack_require__(67839);
const useCustomerDeleteAddress = (options) => {
    const { started, setStarted, finished, setFinished, errors, setErrors, reset, resetTimer, } = (0, useCustomerStartFinishErrors_1.useCustomerStartFinishErrors)(options);
    const { customerGet } = (0, useCustomerGet_1.useCustomerGet)();
    // state
    const _accessToken = (0, store_1.useRecoilValue)(store_1.default.accessToken);
    const addresses = (0, store_1.useRecoilValue)(store_1.default.customerAddresses);
    // delete a customer address
    const deleteAddress = (0, store_1.useRecoilCallback)(({ snapshot, set }) => async (data, callback) => {
        const release = snapshot.retain();
        try {
            setStarted(true);
            let validationErrors = null;
            switch (true) {
                case !data?.id: {
                    validationErrors = ['address id to delete not provided'];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                setErrors(validationErrors);
                return null;
            }
            // accessToken is required and will be injected at addressDelete$
            const { error, data: response } = await snapshot.getPromise(store_1.default.fetchAddressDelete(data));
            if (error) {
                setErrors([error]);
                return null;
            }
            if (!response?.deletedCustomerAddressId) {
                setErrors(['Invalid address delete response']);
                return null;
            }
            const { deletedCustomerAddressId } = response;
            // update the cached address by removing the currently deleted address
            const updatedAddresses = addresses.filter((_address) => {
                const wasDeleted = _address.id.split('?')[0] === data?.id.split('?')[0];
                if (wasDeleted)
                    return false;
                return true;
            });
            set(store_1.default.customerAddresses, updatedAddresses);
            setFinished(true);
            if (callback)
                callback(deletedCustomerAddressId);
            await customerGet({ forceUpdate: true });
            return deletedCustomerAddressId;
        }
        catch (error) {
            console.error(`deleteAddress:error ${error.message}`);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    // hook return
    return {
        deleteAddress,
        accessToken: finished ? _accessToken : null,
        started,
        finished,
        success: !errors?.length || false,
        errors,
        setErrors,
        resetTimer,
        reset,
    };
};
exports.useCustomerDeleteAddress = useCustomerDeleteAddress;
//# sourceMappingURL=useCustomerDeleteAddress.js.map

/***/ }),

/***/ 67839:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerGet = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCustomerStartFinishErrors_1 = __webpack_require__(22957);
const defaultProps = {
    options: {},
};
const useCustomerGet = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const customer = (0, store_1.useRecoilValue)(store_1.default.customer);
    const accessToken = (0, store_1.useRecoilValue)(store_1.default.accessToken);
    const { setStarted, setFinished, setErrors, ...status } = (0, useCustomerStartFinishErrors_1.useCustomerStartFinishErrors)({
        id: `customer/${accessToken?.token ?? ''}/get`,
        ...props.options,
    });
    const customerGet = (0, store_1.useRecoilCallback)(({ snapshot, set }) => async (data, callback) => {
        setStarted(true);
        const release = snapshot.retain();
        try {
            // return cached customer
            if (customer?.id && !data?.forceUpdate) {
                setFinished(true);
                return customer;
            }
            // can pass accessToken or will use the on in store
            const { error, data: response } = await snapshot.getPromise(store_1.default.fetchCustomerGet(data));
            if (error) {
                setErrors([error]);
                return null;
            }
            if (!response?.customer) {
                setErrors(['customer get response missing customer data']);
                return null;
            }
            if (!response?.customer?.__typename === 'Customer') {
                setErrors(['customer get invalid customer response']);
                return null;
            }
            const { customer: _customer } = response;
            setFinished(true);
            set(store_1.default.customer, _customer);
            if (callback)
                callback(_customer);
            return _customer;
        }
        catch (error) {
            console.error(`customerGet:error ${error.message}`);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    }, [customer]);
    return {
        customerGet,
        customer,
        setStarted,
        setFinished,
        setErrors,
        ...status,
    };
};
exports.useCustomerGet = useCustomerGet;
//# sourceMappingURL=useCustomerGet.js.map

/***/ }),

/***/ 50124:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerInit = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable prettier/prettier */
/* eslint-disable no-unused-expressions */
const react_1 = __webpack_require__(27378);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCustomerGet_1 = __webpack_require__(67839);
const useCustomerLogout_1 = __webpack_require__(52174);
// temp while we validate new customer works as expected;
const DEBUG = false;
const defaultProps = {
    fetchOnMount: false,
    options: {},
};
const useCustomerInit = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const initializing = (0, react_1.useRef)(false);
    const customer = (0, store_1.useRecoilValue)(store_1.default.customer);
    const accessToken = (0, store_1.useRecoilValue)(store_1.default.accessToken);
    const isValidAccessToken = (0, store_1.useRecoilValue)(store_1.default.isValidAccessToken$);
    const { customerLogout } = (0, useCustomerLogout_1.useCustomerLogout)();
    const { customerGet } = (0, useCustomerGet_1.useCustomerGet)();
    const init = (0, store_1.useRecoilCallback)(({ snapshot, set }) => async (data, callback) => {
        if (!props?.fetchOnMount)
            return null;
        if (initializing.current)
            return null;
        initializing.current = true;
        const release = snapshot.retain();
        try {
            switch (true) {
                case customer: {
                    DEBUG &&
                        console.log('👷‍♂️ customer init: Found existing customer (auto-login)'); // auto-login
                    break;
                }
                case !accessToken: {
                    DEBUG && console.log('👷‍♂️ customer init: No access token found.'); // no persisted token -> no auto-login attempt
                    set(store_1.default.customer, null);
                    break;
                }
                case isValidAccessToken: {
                    DEBUG &&
                        console.log('👷‍♂️ customer init: Have valid token fetching customer');
                    await customerGet({ accessToken }); // update customer data
                    break;
                }
                default: {
                    DEBUG &&
                        console.log('👷‍♂️ customer init: Invalid/expired token logging customer out');
                    await customerLogout(); // deletes stale accessToken
                    set(store_1.default.customerInit, false);
                    return null;
                }
            }
            set(store_1.default.customerInit, true);
            if (callback)
                callback(customer);
            return customer;
        }
        catch (error) {
            console.error('👷‍♂️ customer init: error', error.message);
            return null;
        }
        finally {
            release();
        }
    });
    // manage customer here, so that we don't cause un-necessary top level re-renders
    (0, react_1.useEffect)(() => {
        init();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customer, accessToken, isValidAccessToken, props?.fetchOnMount]);
    return customer;
};
exports.useCustomerInit = useCustomerInit;
//# sourceMappingURL=useCustomerInit.js.map

/***/ }),

/***/ 81151:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerLogin = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCustomerStartFinishErrors_1 = __webpack_require__(22957);
const defaultProps = {
    options: {},
};
const useCustomerLogin = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const { started, setStarted, finished, setFinished, errors, setErrors, reset, resetTimer, } = (0, useCustomerStartFinishErrors_1.useCustomerStartFinishErrors)({ ...props.options, id: 'customer/login' });
    // state
    const accessToken = (0, store_1.useRecoilValue)(store_1.default.accessToken);
    const customer = (0, store_1.useRecoilValue)(store_1.default.customer);
    // login method - get token from email and password then get customer from token
    const customerLogin = (0, store_1.useRecoilCallback)(({ snapshot, set }) => async (data, callback) => {
        const release = snapshot.retain();
        try {
            setStarted(true);
            let validationErrors = null;
            switch (true) {
                case !data?.email:
                    validationErrors = ['email not provided'];
                    break;
                case !data?.password:
                    validationErrors = ['password not provided'];
                    break;
                default:
                    break;
            }
            if (validationErrors?.length) {
                setErrors(validationErrors);
                return null;
            }
            // get accessToken and customer via /api/customer-login
            const { error, data: response } = await snapshot.getPromise(store_1.default.fetchCustomerLogin(data));
            if (error) {
                setErrors([error]);
                return null;
            }
            if (!response?.accessToken) {
                setErrors(['Invalid login response access token']);
                return null;
            }
            if (!response?.customer) {
                setErrors(['Invalid login response missing customer']);
                return null;
            }
            const { accessToken: _accessToken, customer: _customer } = response;
            setFinished(true);
            set(store_1.default.accessToken, _accessToken);
            set(store_1.default.customer, _customer);
            set(store_1.default.authenticated, true);
            if (callback)
                callback(customer);
            return customer || null;
        }
        catch (error) {
            console.error(`customerLogin:error ${error.message}`);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    // hook return
    return {
        customerLogin,
        accessToken: finished ? accessToken : null,
        customer: finished ? customer : null,
        started,
        finished,
        success: !errors?.length || false,
        errors,
        setErrors,
        resetTimer,
        reset,
    };
};
exports.useCustomerLogin = useCustomerLogin;
//# sourceMappingURL=useCustomerLogin.js.map

/***/ }),

/***/ 52174:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerLogout = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCustomerStartFinishErrors_1 = __webpack_require__(22957);
const defaultProps = {
    options: {},
};
// keeping same verbose structure for consistency despite the fact that we don't need async calls
const useCustomerLogout = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const accessToken = (0, store_1.useRecoilValue)(store_1.default.accessToken);
    const { started, setStarted, finished, setFinished, errors, setErrors, reset: resetStatus, resetTimer, } = (0, useCustomerStartFinishErrors_1.useCustomerStartFinishErrors)({
        ...props.options,
        id: `customer/${accessToken?.token ?? ''}/logout`,
    });
    // login method - get token from email and password then get customer from token
    const customerLogout = (0, store_1.useRecoilCallback)(({ snapshot, reset, set }) => async (data, callback) => {
        const release = snapshot.retain();
        try {
            setStarted(true);
            setFinished(true);
            // will set both localStorage and state to null
            set(store_1.default.customer, null);
            reset(store_1.default.accessToken);
            reset(store_1.default.authenticated);
            // reset ancillary customer state
            reset(store_1.default.customerAddresses);
            reset(store_1.default.customerMetafield(undefined));
            reset(store_1.default.customerOrder(undefined));
            reset(store_1.default.customerOrders(1));
            reset(store_1.default.customerOrdersAction);
            reset(store_1.default.customerOrdersCursor(1));
            reset(store_1.default.customerOrdersPage);
            if (callback)
                callback(true);
            return true;
        }
        catch (error) {
            console.error(`customerLogout:error ${error.message}`);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    // hook return
    return {
        customerLogout,
        started,
        finished,
        success: !errors?.length || false,
        errors,
        setErrors,
        resetTimer,
        reset: resetStatus,
    };
};
exports.useCustomerLogout = useCustomerLogout;
//# sourceMappingURL=useCustomerLogout.js.map

/***/ }),

/***/ 62081:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerMetafield = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable no-undef */
const react_1 = __webpack_require__(27378);
const helpers_1 = __webpack_require__(85542);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const defaultProps = {
    key: '',
    namespace: '',
    fetchOnMount: true,
    options: {},
};
const useCustomerMetafield = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    let { key, namespace } = props;
    if (!key)
        throw new Error('"key" prop not provided');
    if (!namespace)
        throw new Error('"namespace" prop not provided');
    const { finished, setStarted, setFinished, setErrors, ...status } = (0, helpers_1.useRecoilStartFinishErrors)({
        id: `product/getProductMetafield/${namespace}/${key}`,
        ...props.options,
    });
    const [metafield, setMetafield] = (0, store_1.useRecoilState)(store_1.default.productMetafield({ key, namespace }));
    const getMetafield = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        try {
            setStarted(true);
            // eslint-disable-next-line no-use-before-define
            if (metafield) {
                setFinished(true);
                if (callback)
                    callback(metafield);
                return metafield;
            }
            if (data?.key) {
                key = data.key;
            }
            if (data?.namespace) {
                namespace = data.namespace;
            }
            let validationErrors = null;
            switch (true) {
                case !key: {
                    validationErrors = ['key not provided'];
                    break;
                }
                case !namespace: {
                    validationErrors = ['namespace not provided'];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                setErrors(validationErrors);
                return null;
            }
            // get the metafield via the product client
            const { error, data: response } = await snapshot.getPromise(store_1.default.fetchCustomerMetafield({ key, namespace }));
            if (error) {
                setErrors([error]);
                return null;
            }
            if (!response?.metafield) {
                setErrors([
                    `Invalid customer metafield response: ${JSON.stringify(response)}`,
                ]);
                return null;
            }
            setFinished(true);
            setMetafield(response.metafield);
            if (callback)
                callback(response.metafield);
            return response.metafield;
        }
        catch (error) {
            console.error(`getCustomerMetafield:error ${error.message}`);
            setErrors([error.message]);
            return null;
        }
    }, [key, namespace]);
    // fetch on change
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [
            !key,
            !namespace,
            !props.fetchOnMount,
            finished && metafield, // already have metafield
        ];
        const shouldExit = !earlyExitIf.some(Boolean);
        if (shouldExit) {
            getMetafield({ key, namespace })
                .then((_metafield) => {
                if (unMounting || !_metafield)
                    return;
                setMetafield(_metafield);
            })
                .catch((error) => {
                console.error('failed to getMetafield due to', error.message);
            });
        }
        return () => {
            if (shouldExit) {
                unMounting = true;
            }
        };
    }, [key, namespace, props.fetchOnMount]);
    return {
        metafield,
        getMetafield,
        finished,
        setErrors,
        setFinished,
        setStarted,
        ...status,
    };
};
exports.useCustomerMetafield = useCustomerMetafield;
//# sourceMappingURL=useCustomerMetafield.js.map

/***/ }),

/***/ 28640:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerOrder = void 0;
const tslib_1 = __webpack_require__(59312);
const react_1 = __webpack_require__(27378);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCustomerStartFinishErrors_1 = __webpack_require__(22957);
const defaultProps = {
    id: null,
    fetchOnMount: true,
    options: {},
};
const useCustomerOrder = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    if (!props?.id) {
        throw new Error('id not provided');
    }
    const fetching = (0, react_1.useRef)(false);
    const { setStarted, setFinished, setErrors, finished, ...status } = (0, useCustomerStartFinishErrors_1.useCustomerStartFinishErrors)({
        ...props.options,
        id: `customer/order/${props.id}`,
    });
    const [order, setOrder] = (0, store_1.useRecoilState)(store_1.default.customerOrder(props.id));
    const getOrder = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        const release = snapshot.retain();
        setStarted(true);
        let validationErrors = null;
        switch (true) {
            case !data.id:
                validationErrors = ['id not provided'];
                break;
            default:
                break;
        }
        if (validationErrors?.length) {
            setErrors(validationErrors);
            return null;
        }
        try {
            const { error, data: response } = await snapshot.getPromise(store_1.default.fetchCustomerOrder(data));
            if (error) {
                setErrors([error]);
                return null;
            }
            if (!response?.order?.id) {
                setErrors([`Missing order data for ${JSON.stringify(data)}`]);
                return null;
            }
            setFinished(true);
            setOrder(response.order);
            if (callback)
                callback(response.order);
            return response.order;
        }
        catch (error) {
            console.error('getOrder:error', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    }, []);
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [
            !props?.id,
            !props.fetchOnMount,
            fetching.current,
            order, // already have order
        ];
        if (earlyExitIf.some(Boolean)) {
            return undefined;
        }
        fetching.current = true;
        getOrder({ id: props?.id })
            .then((_order) => {
            if (unMounting)
                return;
            setOrder(_order);
            fetching.current = false;
        })
            .catch((error) => {
            console.error('failed to getOrder due to', error.message);
        });
        return () => {
            unMounting = true;
            fetching.current = false;
        };
    }, [props.fetchOnMount, props?.id]);
    return {
        order,
        setStarted,
        setFinished,
        setErrors,
        finished,
        ...status,
    };
};
exports.useCustomerOrder = useCustomerOrder;
//# sourceMappingURL=useCustomerOrder.js.map

/***/ }),

/***/ 78138:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerOrders = void 0;
const tslib_1 = __webpack_require__(59312);
const react_1 = __webpack_require__(27378);
const useCustomerStartFinishErrors_1 = __webpack_require__(22957);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const defaultProps = {
    page: 1,
    perPage: 10,
    fetchOnMount: true,
    options: {},
};
const useCustomerOrders = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const fetching = (0, react_1.useRef)(false);
    const customer = (0, store_1.useRecoilValue)(store_1.default.customer);
    const accessToken = (0, store_1.useRecoilValue)(store_1.default.accessToken);
    const [page, setPage] = (0, store_1.useRecoilState)(store_1.default.customerOrdersPage);
    const setAction = (0, store_1.useSetRecoilState)(store_1.default.customerOrdersAction);
    const [cursor, setCursor] = (0, store_1.useRecoilState)(store_1.default.customerOrdersCursor(page));
    const [orders, setOrders] = (0, store_1.useRecoilState)(store_1.default.customerOrders(page));
    const { setStarted, setFinished, setErrors, finished, ...status } = (0, useCustomerStartFinishErrors_1.useCustomerStartFinishErrors)({
        ...props.options,
        id: `customer/${accessToken?.token ?? ''}/orders/${props.page}`,
    });
    const getNext = (0, react_1.useCallback)(() => {
        if (cursor?.after) {
            setFinished(false);
            setPage((_page) => _page + 1);
            setAction('next');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cursor?.after]);
    const getPrevious = (0, react_1.useCallback)(() => {
        if (cursor?.before && page > 1) {
            setFinished(false);
            setPage((_page) => _page - 1);
            setAction('prev');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cursor?.before, page]);
    const getPageOrdersData = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        const release = snapshot.retain();
        setStarted(true);
        let validationErrors = null;
        switch (true) {
            case !data?.page:
                validationErrors = ['page not provided'];
                break;
            case !data?.perPage:
                validationErrors = ['perPage not provided'];
                break;
            default:
                break;
        }
        if (validationErrors?.length) {
            setErrors(validationErrors);
            return null;
        }
        try {
            const { error, data: response } = await snapshot.getPromise(store_1.default.fetchCustomerOrders(data));
            if (error) {
                setErrors([error]);
                return null;
            }
            if (!Array.isArray(response.orders)) {
                setErrors([`Missing orders data for ${data}`]);
                return null;
            }
            setFinished(true);
            if (callback)
                callback(response);
            return response;
        }
        catch (error) {
            console.error('getPageOrdersData:error', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    }, []);
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [
            !customer,
            !page,
            !props.perPage,
            !props.fetchOnMount,
            fetching.current,
            orders?.length, // already have metafield
        ];
        if (earlyExitIf.some(Boolean)) {
            return undefined;
        }
        fetching.current = true;
        getPageOrdersData({ page, perPage: props.perPage })
            .then((data) => {
            if (unMounting)
                return;
            setCursor({
                after: data.after || null,
                before: data.before || null,
            });
            setOrders(data.orders);
            fetching.current = false;
        })
            .catch((error) => {
            console.error('failed to getPageOrdersData due to', error.message);
        });
        return () => {
            unMounting = true;
            fetching.current = false;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customer, props.fetchOnMount, props.perPage, page]);
    return {
        orders,
        page,
        hasPrevious: !!cursor?.before,
        getPrevious,
        hasNext: !!cursor?.after,
        getNext,
        setStarted,
        setFinished,
        setErrors,
        finished,
        ...status,
    };
};
exports.useCustomerOrders = useCustomerOrders;
//# sourceMappingURL=useCustomerOrders.js.map

/***/ }),

/***/ 62148:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerRecoverPassword = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCustomerStartFinishErrors_1 = __webpack_require__(22957);
const defaultProps = {
    options: {},
};
const useCustomerRecoverPassword = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const { started, setStarted, finished, setFinished, errors, setErrors, reset, resetTimer, } = (0, useCustomerStartFinishErrors_1.useCustomerStartFinishErrors)({
        ...props.options,
        id: 'customer/passwordRecover',
    });
    // login method - get token from email and password then get customer from token
    const recoverPassword = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        setStarted(true);
        let validationErrors = null;
        switch (true) {
            case !data?.email:
                validationErrors = ['email not provided'];
                break;
            default:
                break;
        }
        if (validationErrors?.length) {
            setErrors(validationErrors);
            return null;
        }
        try {
            const { error, data: response } = await snapshot.getPromise(store_1.default.fetchPasswordRecover(data));
            if (error) {
                setErrors([error]);
                return null;
            }
            if (typeof response?.emailSent === 'undefined') {
                setErrors(['Invalid recover email response']);
                return null;
            }
            const { emailSent } = response;
            setFinished(true);
            if (callback)
                callback(emailSent);
            return emailSent;
        }
        catch (error) {
            console.error('recoverPassword:error', error.message);
            setErrors([error.message]);
            return null;
        }
    });
    // hook return
    return {
        recoverPassword,
        emailSent: (finished && !errors?.length) || null,
        started,
        finished,
        success: !errors?.length || false,
        errors,
        setErrors,
        resetTimer,
        reset,
    };
};
exports.useCustomerRecoverPassword = useCustomerRecoverPassword;
//# sourceMappingURL=useCustomerRecoverPassword.js.map

/***/ }),

/***/ 23246:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerResetPassword = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCustomerStartFinishErrors_1 = __webpack_require__(22957);
const defaultProps = {
    options: {},
};
const useCustomerResetPassword = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const { started, setStarted, finished, setFinished, errors, setErrors, reset, resetTimer, } = (0, useCustomerStartFinishErrors_1.useCustomerStartFinishErrors)({
        ...props.options,
        id: 'customer/passwordReset',
    });
    // state
    const _accessToken = (0, store_1.useRecoilValue)(store_1.default.accessToken);
    const _customer = (0, store_1.useRecoilValue)(store_1.default.customer);
    // login method - get token from email and password then get customer from token
    const resetPassword = (0, store_1.useRecoilCallback)(({ snapshot, set }) => async (data, callback) => {
        setStarted(true);
        let validationErrors = null;
        switch (true) {
            case !data?.password:
                validationErrors = ['password not provided'];
                break;
            case !data?.url:
                validationErrors = ['url not provided'];
                break;
            default:
                break;
        }
        if (validationErrors?.length) {
            setErrors(validationErrors);
            return null;
        }
        try {
            const { error, data: response } = await snapshot.getPromise(store_1.default.fetchPasswordReset(data));
            if (error) {
                setErrors([error]);
                return null;
            }
            if (!response?.customer) {
                setErrors(['Invalid reset response missing customer']);
                return null;
            }
            if (!response?.accessToken) {
                setErrors(['Invalid reset response missing accessToken']);
                return null;
            }
            const { customer, accessToken } = response;
            setFinished(true);
            set(store_1.default.accessToken, accessToken);
            set(store_1.default.customer, customer);
            set(store_1.default.authenticated, true);
            if (callback)
                callback(customer);
            return customer;
        }
        catch (error) {
            console.error('resetPassword:error', error.message);
            setErrors([error.message]);
            return null;
        }
    });
    // hook return
    return {
        resetPassword,
        accessToken: finished ? _accessToken : null,
        customer: finished ? _customer : null,
        started,
        finished,
        success: !errors?.length || false,
        errors,
        setErrors,
        resetTimer,
        reset,
    };
};
exports.useCustomerResetPassword = useCustomerResetPassword;
//# sourceMappingURL=useCustomerResetPassword.js.map

/***/ }),

/***/ 22957:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerStartFinishErrors = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable prettier/prettier */
const react_1 = __webpack_require__(27378);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const DEBUG = false;
const useCustomerStartFinishErrors = (options) => {
    const setCustomerStarted = (0, store_1.useSetRecoilState)(store_1.default.customerStatusStarted('customer/all'));
    const setCustomerFinished = (0, store_1.useSetRecoilState)(store_1.default.customerStatusFinished('customer/all'));
    const setCustomerSuccess = (0, store_1.useSetRecoilState)(store_1.default.customerStatusSuccess('customer/all'));
    const setCustomerErrors = (0, store_1.useSetRecoilState)(store_1.default.customerStatusErrors('customer/all'));
    const [started, setStarted] = (0, store_1.useRecoilState)(store_1.default.customerStatusStarted(options?.id || ''));
    const [finished, setFinished] = (0, store_1.useRecoilState)(store_1.default.customerStatusFinished(options?.id || ''));
    const [success, setSuccess] = (0, store_1.useRecoilState)(store_1.default.customerStatusSuccess(options?.id || ''));
    const [errors, setErrors] = (0, store_1.useRecoilState)(store_1.default.customerStatusErrors(options?.id || ''));
    const autoReset = (0, react_1.useRef)(options?.autoReset || 0);
    const resetTimer = (0, react_1.useRef)(options?.resetTimer || null);
    const isCustomerId = /^customer/.test(options?.id);
    // update local hook status
    const reset = (0, react_1.useCallback)(() => {
        if (typeof setErrors === 'undefined')
            return;
        setErrors([]);
        setStarted(false);
        setFinished(false);
        setSuccess(false);
        resetTimer.current = null;
    }, []);
    const updateStateOnErrors = () => {
        let unMounting = false;
        if (errors?.length > 0) {
            if (unMounting)
                return;
            setFinished(true);
            setSuccess(false);
        }
        // eslint-disable-next-line consistent-return
        return () => {
            unMounting = true;
        };
    };
    const updateStateOnFinished = () => {
        let unMounting = false;
        if (finished) {
            if (DEBUG) {
                console.groupCollapsed('status:', options?.id);
                console.log('started', started);
                console.log('errors', errors);
                console.log('finished', finished);
                console.log('success', success);
                console.groupEnd();
            }
            if (unMounting)
                return;
            const withoutErrors = errors?.length === 0;
            setStarted(false);
            setSuccess(withoutErrors);
            if (autoReset?.current) {
                const to = setTimeout(() => {
                    if (unMounting)
                        return;
                    reset();
                    clearTimeout(to);
                }, autoReset.current);
            }
        }
        // eslint-disable-next-line consistent-return
        return () => {
            unMounting = true;
        };
    };
    (0, react_1.useEffect)(() => {
        updateStateOnErrors();
    }, [errors?.length]);
    (0, react_1.useEffect)(() => {
        updateStateOnFinished();
    }, [finished, options?.id]);
    // update global cart status
    (0, react_1.useEffect)(() => {
        if (isCustomerId) {
            setCustomerErrors(errors);
        }
    }, [errors?.length]);
    (0, react_1.useEffect)(() => {
        if (isCustomerId) {
            setCustomerStarted(started);
        }
    }, [started]);
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        setCustomerFinished(finished);
        const to = setTimeout(() => {
            if (unMounting)
                return;
            setCustomerFinished(false);
            clearTimeout(to);
        }, 1000);
        return () => {
            unMounting = true;
        };
    }, [finished]);
    (0, react_1.useEffect)(() => {
        if (isCustomerId) {
            setCustomerSuccess(success);
        }
    }, [success]);
    return {
        started,
        setStarted,
        finished,
        setFinished,
        success,
        setSuccess,
        errors,
        setErrors,
        reset,
        resetTimer,
    };
};
exports.useCustomerStartFinishErrors = useCustomerStartFinishErrors;
//# sourceMappingURL=useCustomerStartFinishErrors.js.map

/***/ }),

/***/ 23478:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerStatus = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
// global status of the customer, any customer action will trigger
// these states via useRecoilStartFinishErrors.js
const useCustomerStatus = () => {
    return {
        started: (0, store_1.useRecoilValue)(store_1.default.customerStatusStarted('customer/all')),
        finished: (0, store_1.useRecoilValue)(store_1.default.customerStatusFinished('customer/all')),
        success: (0, store_1.useRecoilValue)(store_1.default.customerStatusSuccess('customer/all')),
        errors: (0, store_1.useRecoilValue)(store_1.default.customerStatusErrors('customer/all')),
    };
};
exports.useCustomerStatus = useCustomerStatus;
//# sourceMappingURL=useCustomerStatus.js.map

/***/ }),

/***/ 59130:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerUpdateAddress = void 0;
const tslib_1 = __webpack_require__(59312);
const react_1 = __webpack_require__(27378);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCustomerStartFinishErrors_1 = __webpack_require__(22957);
const useCustomerGet_1 = __webpack_require__(67839);
const defaultProps = {
    options: {},
};
const useCustomerUpdateAddress = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const { started, setStarted, finished, setFinished, success, errors, setErrors, reset, resetTimer, } = (0, useCustomerStartFinishErrors_1.useCustomerStartFinishErrors)({
        ...props.options,
        id: 'customer/updateAddress',
    });
    const { customerGet } = (0, useCustomerGet_1.useCustomerGet)();
    // state
    const [address, setAddress] = (0, react_1.useState)();
    const addresses = (0, store_1.useRecoilValue)(store_1.default.customerAddresses);
    // update a customer address, (optionally) set as default and get fresh customer
    const updateAddress = (0, store_1.useRecoilCallback)(({ snapshot, set }) => async (data, callback) => {
        const release = snapshot.retain();
        try {
            setStarted(true);
            let validationErrors = null;
            switch (true) {
                case !data?.id: {
                    validationErrors = ['address to update id not provided'];
                    break;
                }
                case !data?.address: {
                    validationErrors = ['address object to update not provided'];
                    break;
                }
                case typeof data?.isDefault === 'undefined': {
                    validationErrors = ['address isDefault to update not provided'];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                setErrors(validationErrors);
                return null;
            }
            // accessToken is required and will be injected at addressUpdate$
            const { error, data: response } = await snapshot.getPromise(store_1.default.fetchAddressUpdate(data));
            if (error) {
                setErrors([error]);
                return null;
            }
            if (!response?.address) {
                setErrors(['Invalid address update response']);
                return null;
            }
            const { address: _updatedAddress } = response;
            setFinished(true);
            setAddress(_updatedAddress);
            // update the cached address which was just updated
            const updatedAddresses = addresses.map((_address) => {
                const wasUpdated = _address.id.split('?')[0] === _updatedAddress.id.split('?')[0];
                if (!wasUpdated)
                    return _address;
                return _updatedAddress;
            });
            set(store_1.default.customerAddresses, updatedAddresses);
            if (callback)
                callback(_updatedAddress);
            await customerGet({ forceUpdate: true });
            return _updatedAddress; // updated address
        }
        catch (error) {
            console.error('updateAddress:error', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    // hook return
    return {
        address,
        updateAddress,
        started,
        finished,
        success,
        errors,
        setErrors,
        resetTimer,
        reset,
    };
};
exports.useCustomerUpdateAddress = useCustomerUpdateAddress;
//# sourceMappingURL=useCustomerUpdateAddress.js.map

/***/ }),

/***/ 81041:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerUpdateDetails = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useCustomerStartFinishErrors_1 = __webpack_require__(22957);
const defaultProps = {
    options: {},
};
const useCustomerUpdateDetails = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const { started, setStarted, finished, setFinished, success, errors, setErrors, reset, resetTimer, } = (0, useCustomerStartFinishErrors_1.useCustomerStartFinishErrors)({ ...props.options, id: 'customer/update' });
    // state
    const _customer = (0, store_1.useRecoilValue)(store_1.default.customer);
    // login method - get token from email and password then get customer from token
    const customerUpdateDetails = (0, store_1.useRecoilCallback)(({ snapshot, set }) => async (data, callback) => {
        setStarted(true);
        let validationErrors = null;
        switch (true) {
            case !data:
                validationErrors = ['data not provided'];
                break;
            case !data.firstName:
                validationErrors = ['firstName not provided'];
                break;
            case !data.lastName:
                validationErrors = ['lastName not provided'];
                break;
            case !data.email:
                validationErrors = ['email not provided'];
                break;
            case typeof data.acceptsMarketing === 'undefined':
                validationErrors = ['acceptsMarketing not provided'];
                break;
            default:
                break;
        }
        if (validationErrors?.length) {
            setErrors(validationErrors);
            return null;
        }
        try {
            // accessToken is also required so will be injected at customerUpdate$
            const { error, data: response } = await snapshot.getPromise(store_1.default.fetchCustomerUpdate({ customer: data }));
            if (error) {
                setErrors([error]);
                return null;
            }
            if (!response?.customer ||
                !response?.customer?.id ||
                !response?.accessToken) {
                setErrors(['Invalid customer update response response']);
                return null;
            }
            const { customer, accessToken } = response;
            setFinished(true);
            set(store_1.default.accessToken, accessToken);
            set(store_1.default.customer, customer);
            if (callback)
                callback(customer);
            return customer;
        }
        catch (error) {
            console.error('customerUpdateDetails:error', error.message);
            setErrors([error.message]);
            return null;
        }
    });
    // hook return
    return {
        customerUpdateDetails,
        customer: finished ? _customer : null,
        started,
        finished,
        success,
        errors,
        setErrors,
        resetTimer,
        reset,
    };
};
exports.useCustomerUpdateDetails = useCustomerUpdateDetails;
//# sourceMappingURL=useCustomerUpdateDetails.js.map

/***/ }),

/***/ 26029:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.customerStore = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable max-lines */
const recoil_1 = __webpack_require__(69853);
const effects_1 = tslib_1.__importDefault(__webpack_require__(49025));
const store_1 = __webpack_require__(20437);
const client_1 = __webpack_require__(40354);
const client = new client_1.CustomerClient({
    debug: false,
});
/**
  Customer State
*/
const customerInit = (0, recoil_1.atom)({
    key: 'customer/init',
    default: false,
    effects: [
        // effects.logStateChange('customerInit'),
        effects_1.default.onChange({
            key: 'customerInit',
            topic: 'CUSTOMER_INIT',
            actions: ['publishGtmEvent', 'publishBusEvent'],
        }),
    ],
});
const accessToken = (0, recoil_1.atom)({
    key: 'customer/accessToken',
    default: null,
    effects: [
        // effects.logStateChange('accessToken'),
        effects_1.default.setSelfToPersistedKey('accessToken', `CustomerToken|${effects_1.default.SHOPIFY_NAME}`),
        effects_1.default.onSetUpdatePersistedKey(`CustomerToken|${effects_1.default.SHOPIFY_NAME}`),
    ],
});
const customer = (0, recoil_1.atom)({
    key: 'customer/customer',
    default: undefined,
    effects: [
        // effects.logStateChange('customer'),
        effects_1.default.onChange({
            key: 'customer',
            topic: 'CUSTOMER_UPDATE',
            actions: ['publishGtmEvent', 'publishBusEvent'],
        }),
    ],
});
// async
const customerAddresses = (0, recoil_1.atom)({
    key: 'customer/addresses',
    default: null,
});
// Paginated lists of order summaries for order history listing
const customerOrders = (0, recoil_1.atomFamily)({
    key: 'customer/orders',
    default: null,
});
// full order items with line items etc..
const customerOrder = (0, recoil_1.atomFamily)({
    key: 'customer/order',
    default: null,
});
const customerMetafield = (0, recoil_1.atomFamily)({
    key: 'customer/metafield',
    default: null,
});
const customerOrdersPage = (0, recoil_1.atom)({
    key: 'customer/ordersPage',
    default: 1,
});
const customerOrdersCursor = (0, recoil_1.atomFamily)({
    key: 'customer/ordersCursor',
    default: { before: null, after: null },
});
const customerOrdersAction = (0, recoil_1.atom)({
    key: 'customer/ordersAction',
    default: 'next', // || prev
});
const authenticated = (0, recoil_1.atom)({
    key: 'customer/authenticated',
    default: undefined,
});
const newCustomer = (0, recoil_1.atom)({
    key: 'customer/new',
    default: false,
    effects: [
        effects_1.default.onChange({
            key: 'newCustomer',
            topic: 'CUSTOMER_REGISTERED',
            actions: ['publishGtmEvent', 'publishBusEvent'],
        }),
    ],
});
/*
  ---------------
  Status
  ---------------
*/
const customerStatusStarted = (0, recoil_1.atomFamily)({
    key: 'customer/statusStarted',
    default: false,
});
const customerStatusFinished = (0, recoil_1.atomFamily)({
    key: 'customer/statusFinished',
    default: false,
});
const customerStatusSuccess = (0, recoil_1.atomFamily)({
    key: 'customer/statusSuccess',
    default: false,
});
const customerStatusErrors = (0, recoil_1.atomFamily)({
    key: 'customer/statusErrors',
    default: [],
});
/*
  ---------------
  Getters
  ---------------
*/
const customerDefaultAddress$ = (0, recoil_1.selector)({
    key: 'customer/defaultAddress$',
    get: ({ get }) => {
        const _customer = get(customer);
        return _customer ? _customer.defaultAddress : null;
    },
});
const isValidAccessToken$ = (0, recoil_1.selector)({
    key: 'customer/isValidToken',
    get: ({ get }) => {
        const _accessToken = get(accessToken);
        const isValidToken = _accessToken?.expires
            ? Date.parse(_accessToken.expires) > Date.now()
            : false;
        return isValidToken;
    },
});
/*
  ---------------
  Async fetchers and setters
  ---------------
*/
/*
  Customer: ACTIVATE, LOGIN, GET, CREATE, UPDATE
*/
const fetchCustomerActivate = (0, recoil_1.selectorFamily)({
    key: 'customer/active',
    get: (activateDetails) => async ({ get }) => {
        const country = get(store_1.shopStore.country);
        return client.activate({
            ...activateDetails,
            country: country?.isoCode,
        });
    },
});
const fetchCustomerGet = (0, recoil_1.selectorFamily)({
    key: 'customer/get',
    get: ({ accessToken: passedToken, forceUpdate = false }) => async ({ get }) => {
        const _customer = get(customer);
        const _accessToken = get(accessToken);
        const country = get(store_1.shopStore.country);
        if (passedToken || forceUpdate) {
            return client.get({
                accessToken: passedToken || _accessToken,
                country: country?.isoCode,
            });
        }
        return Promise.resolve(_customer);
    },
});
const fetchCustomerLogin = (0, recoil_1.selectorFamily)({
    key: 'customer/login',
    get: (loginDetails) => async ({ get }) => {
        const country = get(store_1.shopStore.country);
        return client.login({
            ...loginDetails,
            country: country?.isoCode,
        });
    },
});
const fetchCustomerCreate = (0, recoil_1.selectorFamily)({
    key: 'customer/create',
    get: (newCustomerData) => async ({ get }) => {
        const country = get(store_1.shopStore.country);
        return client.create({
            ...newCustomerData,
            country: country?.isoCode,
        });
    },
});
const fetchCustomerUpdate = (0, recoil_1.selectorFamily)({
    key: 'customer/update',
    get: ({ accessToken: passedToken, customer: updatedCustomer }) => async ({ get }) => {
        const _accessToken = get(accessToken);
        const country = get(store_1.shopStore.country);
        return client.update({
            accessToken: passedToken || _accessToken,
            customer: updatedCustomer,
            country: country?.isoCode,
        });
    },
});
const fetchCustomerOrder = (0, recoil_1.selectorFamily)({
    key: 'customer/fetchCustomerOrder',
    get: ({ orderNumber = null, id = null }) => async ({ get }) => {
        const _accessToken = get(accessToken);
        const country = get(store_1.shopStore.country);
        const { error, data } = await client.order({
            orderNumber,
            id,
            accessToken: _accessToken,
            country: country?.isoCode,
        });
        if (error) {
            return {
                error,
                data: null,
            };
        }
        return {
            error: null,
            data,
        };
    },
});
const fetchCustomerMetafield = (0, recoil_1.selectorFamily)({
    key: 'customer/fetchCustomerMetafield',
    get: ({ namespace = null, key = null }) => async ({ get }) => {
        const _accessToken = get(accessToken);
        const country = get(store_1.shopStore.country);
        const { error, data } = await client.metafield({
            namespace,
            key,
            accessToken: _accessToken,
            country: country?.isoCode,
        });
        if (error) {
            return {
                error,
                data: null,
            };
        }
        return {
            error: null,
            data,
        };
    },
});
const fetchCustomerOrders = (0, recoil_1.selectorFamily)({
    key: 'customer/fetchCustomerOrders',
    get: ({ page = 1, perPage = 4 }) => async ({ get }) => {
        const _accessToken = get(accessToken);
        const country = get(store_1.shopStore.country);
        const _cursor = get(customerOrdersCursor(page));
        const _prevCursor = get(customerOrdersCursor(page > 2 ? page - 1 : 1));
        const _action = get(customerOrdersAction);
        const fetchPage = async ({ page: _page, perPage: _perPage }) => {
            const pageInfo = {
                accessToken: _accessToken.token,
                country: country?.isoCode,
            };
            const isFirst = _page === 1;
            const isNext = _action === 'next';
            const isPrev = _action === 'previous';
            switch (true) {
                case isFirst: {
                    pageInfo.first = _perPage;
                    break;
                }
                case isNext: {
                    if (_prevCursor.after) {
                        pageInfo.after = _prevCursor.after;
                    }
                    pageInfo.first = _perPage;
                    break;
                }
                case isPrev: {
                    pageInfo.last = _perPage;
                    pageInfo.before = _cursor.before;
                    break;
                }
                default:
                    pageInfo.first = _perPage;
                    break;
            }
            const { error, data } = await client.orders(pageInfo);
            if (error) {
                return {
                    error,
                    data: {
                        orders: null,
                        ...pageInfo,
                    },
                };
            }
            // good
            return {
                error: null,
                data,
            };
        };
        return fetchPage({ page, perPage });
    },
});
/*
  Address: CREATE, DELETE, UPDATE
*/
const fetchAddresses = (0, recoil_1.selectorFamily)({
    key: 'customer/addresses',
    get: () => async ({ get }) => {
        const _accessToken = get(accessToken);
        const country = get(store_1.shopStore.country);
        return client.addresses({
            accessToken: _accessToken,
            country: country?.isoCode,
        });
    },
});
const fetchAddressCreate = (0, recoil_1.selectorFamily)({
    key: 'customer/addressCreate',
    get: (newAddressData) => async ({ get }) => {
        const _accessToken = get(accessToken);
        const country = get(store_1.shopStore.country);
        return client.addressCreate({
            ...newAddressData,
            accessToken: _accessToken,
            country: country?.isoCode,
        });
    },
});
const fetchAddressDelete = (0, recoil_1.selectorFamily)({
    key: 'customer/addressDelete',
    get: ({ id, accessToken: passedToken }) => async ({ get }) => {
        const _accessToken = get(accessToken);
        const country = get(store_1.shopStore.country);
        return client.addressDelete({
            id,
            accessToken: passedToken || _accessToken,
            country: country?.isoCode,
        });
    },
});
const fetchAddressUpdate = (0, recoil_1.selectorFamily)({
    key: 'customer/addressUpdate',
    get: (addressUpdateData) => async ({ get }) => {
        const _accessToken = get(accessToken);
        const country = get(store_1.shopStore.country);
        return client.addressUpdate({
            ...addressUpdateData,
            accessToken: _accessToken,
            country: country?.isoCode,
        });
    },
});
/*
  Password: RESET, RECOVER
*/
const fetchPasswordReset = (0, recoil_1.selectorFamily)({
    key: 'customer/passwordReset',
    get: (resetData) => async ({ get }) => {
        const country = get(store_1.shopStore.country);
        return client.passwordReset({
            ...resetData,
            country: country?.isoCode,
        });
    },
});
const fetchPasswordRecover = (0, recoil_1.selectorFamily)({
    key: 'customer/passwordRecover',
    get: ({ email }) => async ({ get }) => {
        const country = get(store_1.shopStore.country);
        return client.passwordRecover({
            email,
            country: country?.isoCode,
        });
    },
});
exports.customerStore = {
    // status — new on v2
    customerStatusStarted,
    customerStatusFinished,
    customerStatusSuccess,
    customerStatusErrors,
    // Async fetchers and setters — new on v2
    fetchAddresses,
    fetchAddressCreate,
    fetchAddressDelete,
    fetchAddressUpdate,
    // actual state - atoms
    customerAddresses,
    customerInit,
    accessToken,
    customer,
    customerMetafield,
    customerOrder,
    customerOrders,
    customerOrdersPage,
    customerOrdersCursor,
    customerOrdersAction,
    authenticated,
    newCustomer,
    // getters
    isValidAccessToken$,
    customerDefaultAddress$,
    fetchCustomerActivate,
    fetchCustomerCreate,
    fetchCustomerGet,
    fetchCustomerLogin,
    fetchCustomerMetafield,
    fetchCustomerOrder,
    fetchCustomerOrders,
    fetchCustomerUpdate,
    fetchPasswordRecover,
    fetchPasswordReset,
};
//# sourceMappingURL=customer.js.map

/***/ }),

/***/ 90747:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.customerStore = void 0;
var customer_1 = __webpack_require__(26029);
Object.defineProperty(exports, "customerStore", ({ enumerable: true, get: function () { return customer_1.customerStore; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 49025:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const logStateChange_1 = __webpack_require__(63645);
const onSetRedirectToCheckout_1 = __webpack_require__(69060);
const onSetUpdatePersistedKey_1 = __webpack_require__(85417);
const setSelfToPersistedKey_1 = __webpack_require__(95973);
const onChange_1 = __webpack_require__(24889);
const shared_1 = __webpack_require__(32065);
exports["default"] = {
    // shared utils
    SHOPIFY_NAME: shared_1.SHOPIFY_NAME,
    publishBusEvent: shared_1.publishBusEvent,
    publishGtmEvent: shared_1.publishGtmEvent,
    resolveTopicData: shared_1.resolveTopicData,
    routeToTemplate: shared_1.routeToTemplate,
    // effects
    logStateChange: logStateChange_1.logStateChange,
    onSetRedirectToCheckout: onSetRedirectToCheckout_1.onSetRedirectToCheckout,
    onSetUpdatePersistedKey: onSetUpdatePersistedKey_1.onSetUpdatePersistedKey,
    setSelfToPersistedKey: setSelfToPersistedKey_1.setSelfToPersistedKey,
    onChange: onChange_1.onChange,
};
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 63645:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.logStateChange = void 0;
const logStateChange = key => ({ onSet }) => {
    onSet((newValue, oldValue) => {
        console.groupCollapsed(`updated "${key}"`);
        console.log('is:\t\t', newValue);
        console.log('was:\t', oldValue);
        console.groupEnd();
        return newValue;
    });
};
exports.logStateChange = logStateChange;
//# sourceMappingURL=logStateChange.js.map

/***/ }),

/***/ 24889:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.onChange = void 0;
const shared_1 = __webpack_require__(32065);
const isBrowser = typeof window !== 'undefined';
// todo: we can use Router.page.data
const onChange = ({ topic: topicGroup, actions: passedActions }) => ({ onSet }) => {
    onSet((newValue, oldValue) => {
        if (!isBrowser)
            return newValue;
        if (!topicGroup)
            return newValue;
        if (!passedActions)
            return newValue;
        if (!newValue && !oldValue)
            return newValue;
        let actions = passedActions;
        if (!Array.isArray(passedActions)) {
            if (typeof passedActions === 'string') {
                actions = [passedActions];
            }
            else {
                console.warn('Invalid onChange actions provided. "actions" must be an array or a string', passedActions);
                return newValue;
            }
        }
        // converts a generic topic e.g CART_UPDATE to a more specific action if applicable
        try {
            const [topic, topicData] = (0, shared_1.resolveTopicData)(topicGroup, newValue, oldValue);
            if (!topic) {
                console.warn(`Could not determine topic for ${topicGroup}`);
                return newValue;
            }
            if (typeof topicData === 'undefined') {
                console.error(`No ${topic} topic data`);
                return newValue;
            }
            // perform each onChange action
            actions.forEach((action) => {
                switch (action) {
                    case 'publishGtmEvent': {
                        return (0, shared_1.publishGtmEvent)(topic, topicData);
                    }
                    case 'publishBusEvent': {
                        return (0, shared_1.publishBusEvent)(topic, topicData);
                    }
                    default:
                        console.warn(`Unsupported onChange action ${action}`);
                        return newValue;
                }
            });
            return newValue;
        }
        catch (error) {
            console.error(topicGroup, error.message);
            return newValue;
        }
    });
};
exports.onChange = onChange;
//# sourceMappingURL=onChange.js.map

/***/ }),

/***/ 69060:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.onSetRedirectToCheckout = void 0;
const onSetRedirectToCheckout = () => ({ onSet }) => {
    onSet((newValue, oldValue) => {
        if (!newValue?.redirect)
            return; // In case user wants to manually redirect
        // redirect to either multipass or regular checkout
        window.location.href = newValue.url;
        return newValue;
    });
};
exports.onSetRedirectToCheckout = onSetRedirectToCheckout;
//# sourceMappingURL=onSetRedirectToCheckout.js.map

/***/ }),

/***/ 85417:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.onSetUpdatePersistedKey = void 0;
/* eslint-disable max-lines */
const shared_1 = __webpack_require__(32065);
const onSetUpdatePersistedKey = (key) => ({ onSet }) => {
    onSet((newValue) => {
        let safeNewValue = newValue;
        switch (key) {
            case `CustomerToken|${shared_1.SHOPIFY_NAME}`: {
                // if somehow, we have an invalid token in state, we don't persist it.
                if (!newValue?.token || !newValue?.expires) {
                    safeNewValue = null;
                }
                break;
            }
            case `Cart|${shared_1.SHOPIFY_NAME}`: {
                // if somehow, we have an invalid cart in state, we skip the update to persist it.
                if (!newValue?.id) {
                    safeNewValue = null;
                }
                break;
            }
            default:
                break;
        }
        // eslint-disable-next-line no-undef
        window.localStorage.setItem(key, JSON.stringify(safeNewValue));
        return safeNewValue;
    });
};
exports.onSetUpdatePersistedKey = onSetUpdatePersistedKey;
//# sourceMappingURL=onSetUpdatePersistedKey.js.map

/***/ }),

/***/ 95973:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setSelfToPersistedKey = void 0;
const shared_1 = __webpack_require__(32065);
const isBrowser = typeof window !== 'undefined';
const setSelfToPersistedKey = (key, cachedKey, topic) => ({ setSelf }) => {
    setSelf(() => {
        if (!isBrowser)
            return null;
        try {
            let cachedJsonValue = JSON.parse(window.localStorage.getItem(cachedKey));
            const isValidAccessToken = !!cachedJsonValue?.expires &&
                Date.parse(cachedJsonValue.expires) > Date.now();
            switch (key) {
                case 'accessToken': {
                    if (cachedJsonValue && cachedJsonValue?.expires) {
                        if (!isValidAccessToken) {
                            console.log('Token is expired deleting..');
                            window.localStorage.setItem(cachedKey, null);
                            cachedJsonValue = null;
                        }
                    }
                    break;
                }
                case 'cart': {
                    if (cachedJsonValue && cachedJsonValue?.completedAt) {
                        if (!isValidAccessToken) {
                            console.log('Cart completed at deleting..');
                            window.localStorage.setItem(cachedKey, null);
                            cachedJsonValue = null;
                        }
                    }
                    break;
                }
                case 'country': {
                    if (cachedJsonValue && !cachedJsonValue?.isoCode) {
                        console.log('Invalid cached country object resetting..');
                        window.localStorage.setItem(cachedKey, null);
                        cachedJsonValue = null;
                    }
                    break;
                }
                default:
                    break;
            }
            // console.log('Setting initial', `"${key}"`, 'to', cachedJsonValue)
            if (topic && cachedJsonValue)
                (0, shared_1.publishBusEvent)(topic, cachedJsonValue);
            return cachedJsonValue;
        }
        catch (error) {
            console.error('setSelfToPersistedKey: Could not set initial persisted values for', key, error.message);
            return null;
        }
    });
};
exports.setSelfToPersistedKey = setSelfToPersistedKey;
//# sourceMappingURL=setSelfToPersistedKey.js.map

/***/ }),

/***/ 32065:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.resolveTopicData = exports.resolveCartTopics = exports.resolveCustomerTopics = exports.resolveViewRouteTopics = exports.routeToTemplate = exports.publishGtmEvent = exports.publishBusEvent = exports.SHOPIFY_NAME = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable max-lines */
const router_1 = tslib_1.__importDefault(__webpack_require__(86677));
const pubsub_js_1 = tslib_1.__importDefault(__webpack_require__(67651));
const isBrowser = typeof window !== 'undefined';
exports.SHOPIFY_NAME = "kryo-gear.myshopify.com"?.split('.')[0] || '';
// Publish to EventBus
// eslint-disable-next-line consistent-return
const publishBusEvent = (topic, data) => {
    if (typeof topic === 'undefined') {
        console.warn(`No topic was provided for Bus event`);
        return null;
    }
    if (typeof data === 'undefined') {
        console.warn(`No data was provided for ${topic} Bus event`);
        return null;
    }
    pubsub_js_1.default.publish(topic, data);
};
exports.publishBusEvent = publishBusEvent;
const publishGtmEvent = (topic, gtmData) => {
    if (!isBrowser)
        return null;
    if (typeof topic === 'undefined') {
        console.warn(`No topic was provided for GTM event`);
        return null;
    }
    if (typeof gtmData === 'undefined') {
        console.warn(`No data was provided for ${topic} GTM event`);
        return null;
    }
    // eslint-disable-next-line no-undef
    if (!window?.dataLayer) {
        // console.warn(`An initialized dataLayer is required before publishing GTM ${topic} events`);
        return false;
    }
    // add event to GTM
    // eslint-disable-next-line no-undef
    window.dataLayer.push({
        event: topic,
        data: gtmData,
    });
    return true;
};
exports.publishGtmEvent = publishGtmEvent;
const routeToTemplate = ({ route }) => [
    {
        path: '/',
        name: 'isHome',
    },
    {
        path: '/account',
        name: 'isAccount',
    },
    {
        path: '/cart',
        name: 'isCart',
    },
    {
        path: '/collections/',
        name: 'isCollection',
    },
    {
        path: '/pages/',
        name: 'isPage',
    },
    {
        path: '/products/',
        name: 'isProduct',
    },
    {
        path: '/blogs/',
        name: 'isBlog',
    },
    {
        path: '/articles/',
        name: 'isArticle',
    },
    {
        path: '/404',
        name: 'is404',
    },
].reduce((templates, template) => {
    const _templates = templates;
    // check for home
    if (template.path === '/') {
        _templates[template.name] = route === template.path;
    }
    else {
        // non home routes
        const isValidPath = route.includes(template.path);
        _templates[template.name] = !!isValidPath;
    }
    return _templates;
}, {
    // initial templates
    isAccount: false,
    isArticle: false,
    isBlog: false,
    isCart: false,
    isCollection: false,
    isHome: false,
    isPage: false,
    isProduct: false,
    is404: false,
});
exports.routeToTemplate = routeToTemplate;
const resolveViewRouteTopics = (route) => {
    try {
        const template = (0, exports.routeToTemplate)({ route });
        const { isAccount, isArticle, isBlog, isCart, isCollection, isHome, isPage, isProduct, is404, } = template;
        const routeProps = router_1.default?.router?.components?.[router_1.default.route]?.props?.pageProps || null;
        switch (true) {
            case isAccount:
                return ['VIEW_ACCOUNT', route];
            case isArticle:
                return ['VIEW_ARTICLE', routeProps?.article || route];
            case isBlog:
                return ['VIEW_BLOG', routeProps?.blog || route];
            case isCart:
                return ['VIEW_CART', route];
            case isCollection: {
                const collectionFirst100products = {
                    ...routeProps?.collection,
                    products: routeProps?.collection?.products?.slice(0, 100),
                };
                return ['VIEW_COLLECTION', collectionFirst100products || route];
            }
            case isHome:
                return ['VIEW_HOME', routeProps?.page || route];
            case isPage:
                return ['VIEW_PAGE', routeProps?.page || route];
            case isProduct:
                return ['VIEW_PRODUCT', routeProps?.product || route];
            case is404:
                return ['VIEW_404', routeProps?.page || route];
            default:
                return ['VIEW_OTHER', route];
        }
    }
    catch (error) {
        console.error('resolveViewRouteTopics failed due to', error.message);
        return ['ROUTE_UPDATE', null];
    }
};
exports.resolveViewRouteTopics = resolveViewRouteTopics;
const resolveVariantTopics = (topic, currentVariant) => {
    const variantIsAvailable = currentVariant &&
        (currentVariant?.inventoryPolicy === 'CONTINUE' ||
            currentVariant?.inventoryQuantity > 0);
    if (variantIsAvailable) {
        if (currentVariant.inventoryPolicy === 'CONTINUE') {
            return ['SELECTED_VARIANT_AVAILABLE_CONTINUE', currentVariant];
        }
        return ['SELECTED_VARIANT_AVAILABLE', currentVariant];
    }
    if (!variantIsAvailable) {
        return ['SELECTED_VARIANT_SOLDOUT', currentVariant];
    }
    return [topic, currentVariant];
};
// eslint-disable-next-line consistent-return
const resolveCustomerTopics = (customer, prevCustomer) => {
    if (prevCustomer && customer) {
        return ['CUSTOMER_LOGIN', customer];
    }
    if (!prevCustomer && customer) {
        return ['CUSTOMER_LOGIN', customer];
    }
    if (prevCustomer && !customer) {
        return ['CUSTOMER_LOGOUT', prevCustomer];
    }
    return [];
};
exports.resolveCustomerTopics = resolveCustomerTopics;
const getTotalItems = (items) => items?.length
    ? items.reduce((total, { quantity }) => total + quantity, 0)
    : 0;
const resolveCartTopics = (topic, cart, prevCart) => {
    try {
        const lineItems = cart?.lines?.length;
        const lineItemsPrev = prevCart?.lines?.length || 0;
        const totalItems = getTotalItems(cart?.lines);
        const totalItemsPrev = getTotalItems(prevCart?.lines) || 0;
        const discounts = cart?.discountApplications?.length;
        const discountsPrev = prevCart?.discountApplications?.length;
        const createdAt = cart?.createdAt ? new Date(cart.createdAt) : null;
        const updatedAt = cart?.updatedAt ? new Date(cart.updatedAt) : null;
        const completedAt = cart?.completedAt ? new Date(cart.completedAt) : null;
        if (lineItems > lineItemsPrev) {
            // diff between both lineItemLists
            const addedItem = cart.lines?.filter(({ id: id1 }) => !prevCart?.lines?.some(({ id: id2 }) => id2 === id1));
            return ['CART_ADD_ITEM', addedItem];
        }
        if (lineItems < lineItemsPrev) {
            const removedItem = prevCart?.lines?.length
                ? prevCart.lines.filter(({ id: id1 }) => !cart.lines?.some(({ id: id2 }) => id2 === id1))
                : null;
            if (totalItemsPrev > 1 && totalItems === 0) {
                return ['CART_CLEARED', prevCart];
            }
            return ['CART_REMOVE_ITEM', removedItem];
        }
        if (totalItems !== totalItemsPrev) {
            if (totalItems > totalItemsPrev) {
                const modifiedItem = cart.lines?.filter(({ id: id1, quantity: qty1 }) => !prevCart?.lines?.some(({ id: id2, quantity: qty2 }) => id2 === id1 && qty1 === qty2));
                return ['CART_INCREASE_ITEM_QUANTITY', modifiedItem];
            }
            const modifiedItem = prevCart.lines?.filter(({ id: id1, quantity: qty1 }) => !cart?.lines?.some(({ id: id2, quantity: qty2 }) => id2 === id1 && qty1 === qty2));
            return ['CART_REDUCE_ITEM_QUANTITY', modifiedItem];
        }
        // Discounts
        if (discountsPrev < discounts) {
            // eslint-disable-next-line no-undef
            if (window?.location?.href?.includes('discountCode=')) {
                return ['CART_ADD_DISCOUNT_URL', cart?.discountApplications?.[0]?.code];
            }
            return ['CART_ADD_DISCOUNT', cart?.discountApplications?.[0]?.code];
        }
        if (discountsPrev > discounts) {
            return [
                'CART_REMOVE_DISCOUNT',
                prevCart?.discountApplications?.[0]?.code,
            ];
        }
        // notes
        if (cart?.note !== prevCart?.note) {
            if (prevCart?.note === null && cart.note) {
                return ['CART_ADD_NOTE', cart?.note];
            }
            if (prevCart?.note !== cart.note) {
                return ['CART_UPDATED_NOTE', cart?.note];
            }
            if (cart?.note === null && prevCart.note) {
                return ['CART_REMOVED_NOTE', cart?.note];
            }
        }
        if (completedAt) {
            return ['CART_PURCHASED', cart];
        }
        if (updatedAt > createdAt && totalItems) {
            return ['CART_UPDATED', cart];
        }
        if (!prevCart && cart) {
            return ['CART_CREATE', cart];
        }
        return ['CART_READY', cart];
    }
    catch (error) {
        console.error('resolveCartTopics failed due to:', error.message);
        return [null, null];
    }
};
exports.resolveCartTopics = resolveCartTopics;
// eslint-disable-next-line consistent-return
const resolveTopicData = (topicGroup, newValue, oldValue) => {
    try {
        switch (true) {
            case ['ROUTE_UPDATE'].includes(topicGroup): {
                return (0, exports.resolveViewRouteTopics)(newValue, oldValue);
            }
            case ['CUSTOMER_INIT'].includes(topicGroup): {
                return ['CUSTOMER_INIT', newValue];
            }
            case ['CUSTOMER_UPDATE'].includes(topicGroup): {
                return (0, exports.resolveCustomerTopics)(newValue, oldValue);
            }
            case ['CART_UPDATE'].includes(topicGroup): {
                return (0, exports.resolveCartTopics)(topicGroup, newValue, oldValue);
            }
            case ['COUNTRY_UPDATE'].includes(topicGroup): {
                return ['COUNTRY_UPDATE', newValue];
            }
            case ['VARIANT_UPDATE'].includes(topicGroup): {
                return resolveVariantTopics(topicGroup, newValue, oldValue);
            }
            case ['CHECKOUT'].includes(topicGroup): {
                return ['CHECKOUT', newValue];
            }
            case ['CUSTOMER_REGISTERED'].includes(topicGroup): {
                return ['CUSTOMER_REGISTERED', newValue];
            }
            default: {
                return [topicGroup, newValue];
            }
        }
    }
    catch (error) {
        console.error('resolveTopicData failed due', error.message);
    }
};
exports.resolveTopicData = resolveTopicData;
//# sourceMappingURL=shared.js.map

/***/ }),

/***/ 42667:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Localize = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable no-undef */
/* eslint-disable class-methods-use-this */
const isomorphic_fetch_1 = tslib_1.__importDefault(__webpack_require__(84447));
const defaultProps = { country: 'US', currency: 'USD' };
class Localize {
    constructor({ country, currency } = defaultProps) {
        this.country = country;
        this.currency = currency;
    }
    /**
     * fetch a country's locale (extended info) by currencyCode or countryCode
     */
    async fetchLocale({ countryCode, currencyCode }) {
        if (!currencyCode && !countryCode) {
            throw new Error('"currencyCode" or "countryCode" must be provided');
        }
        const isDev = "production" !== 'production';
        const server = isDev ? 'http://localhost:8080' : "https://www.brumate.com";
        const endpoint = `${server}/api/shopify/locale`;
        const localeRequest = await (0, isomorphic_fetch_1.default)(endpoint, {
            method: 'POST',
            body: JSON.stringify({ countryCode, currencyCode }),
        });
        const { response } = await localeRequest.json();
        const { locale } = response;
        return locale;
    }
    localize({ amount, locale }) {
        const localeOptions = {
            style: 'currency',
            currency: locale.currency || this.currency,
        };
        const localizedAmount = new Intl.NumberFormat(locale.defaultLocale, localeOptions).format(amount);
        return localizedAmount.replace(/\.00$/, '');
    }
    /**
     * Add locale info to the cart, and localizes estimatedCosts and line prices for the current country
     * @param {*} param0
     * @returns
     */
    cartTotals({ cart, locale }) {
        const { discountAmount, totalSavingsAmount, totalDiscountAmount, totalCompareAtAmount, } = this.cartCombinedTotals({
            lines: cart.lines,
            locale,
        });
        const estimatedCost = this.estimatedCost({
            estimatedCost: cart.estimatedCost,
            locale,
            discountAmount,
            totalDiscountAmount,
            totalSavingsAmount,
            totalCompareAtAmount,
        });
        return { ...cart, locale, estimatedCost };
    }
    // estimate the total discount amount from, discount codes + subscriptions
    cartCombinedTotals({ lines, locale }) {
        let discountAmount = null; // custom
        let totalDiscountAmount = null; // custom
        let totalSavingsAmount = null; // custom
        let totalCompareAtAmount = null; // custom
        // get combined savings, discounts and compareAt (full price)
        // from all line items so we can display the full breakdown
        const combinedDefault = {
            combinedSavings: 0,
            combinedDiscount: 0,
            combinedDiscountTotal: 0,
            combineCompareAt: 0,
        };
        const itemTotals = (_total, line) => {
            const localizedLine = this.cartLine({ line, locale });
            // subscription discounts
            const savingsAmount = localizedLine?.estimatedCost?.savingsAmount;
            const lineDiscount = localizedLine?.estimatedCost?.discountAmount;
            const compareAtPriceAmount = localizedLine?.estimatedCost?.compareAtPriceAmount;
            const lineTotal = { ..._total };
            if (savingsAmount) {
                lineTotal.combinedSavings += savingsAmount.amountTotal;
            }
            if (lineDiscount) {
                lineTotal.combinedDiscount += lineDiscount.amountTotal;
            }
            if (compareAtPriceAmount) {
                lineTotal.combineCompareAt += compareAtPriceAmount.amountTotal;
            }
            // used as Discounted Total when theres discounts as subTotal does not include discount deductions
            lineTotal.combinedDiscountTotal +=
                localizedLine?.estimatedCost.totalAmount.amount;
            return lineTotal;
        };
        const { combinedSavings, combinedDiscountTotal, combinedDiscount, combineCompareAt, } = lines.reduce(itemTotals, combinedDefault);
        if (combinedSavings) {
            totalSavingsAmount = {
                amount: combinedSavings,
                currencyCode: locale.currency,
                locale: this.localize({ amount: combinedSavings, locale }),
            };
        }
        if (combinedDiscount) {
            discountAmount = {
                amount: combinedDiscount,
                currencyCode: locale.currency,
                locale: this.localize({ amount: combinedDiscount, locale }),
            };
        }
        if (combinedDiscountTotal) {
            totalDiscountAmount = {
                amount: combinedDiscountTotal,
                currencyCode: locale.currency,
                locale: this.localize({ amount: combinedDiscountTotal, locale }),
            };
        }
        if (combineCompareAt) {
            totalCompareAtAmount = {
                amount: combineCompareAt,
                currencyCode: locale.currency,
                locale: this.localize({ amount: combineCompareAt, locale }),
            };
        }
        return {
            discountAmount,
            totalDiscountAmount,
            totalSavingsAmount,
            totalCompareAtAmount,
        };
    }
    /**
     * Adds locale, compareAt and priceV2 locale pricing to a variant
     */
    cartLine({ line, locale }) {
        try {
            const variant = { ...line.variant, locale };
            let compareAtPriceAmount = null; // the full price before (sale)
            // localize cart line discountAllocations
            const { discountAllocations, discountAmount } = this.cartLineDiscountAllocations({
                discountAllocations: [...line.discountAllocations],
                quantity: line.quantity,
                locale,
            });
            // localize cartLine variant
            // localize priceV2
            const priceV2amount = parseFloat(variant.priceV2.amount);
            const priceV2amountTotal = priceV2amount * line.quantity;
            variant.priceV2 = {
                ...variant.priceV2,
                amount: priceV2amount,
                amountTotal: priceV2amountTotal,
                locale: this.localize({ amount: priceV2amount, locale }),
                localeTotal: this.localize({ amount: priceV2amountTotal, locale }),
            };
            compareAtPriceAmount = variant.priceV2;
            // // localize compareAtPriceV2
            if (variant?.compareAtPriceV2) {
                const compareAtPriceV2amount = parseFloat(variant.compareAtPriceV2.amount);
                const compareAtPriceV2amountTotal = compareAtPriceV2amount * line.quantity;
                variant.compareAtPriceV2 = {
                    ...variant.compareAtPriceV2,
                    amount: compareAtPriceV2amount,
                    amountTotal: compareAtPriceV2amountTotal,
                    locale: this.localize({ amount: compareAtPriceV2amount, locale }),
                    localeTotal: this.localize({
                        amount: compareAtPriceV2amountTotal,
                        locale,
                    }),
                };
                compareAtPriceAmount = variant.compareAtPriceV2;
            }
            // // localize compareAtPriceV2
            if (variant?.unitPrice) {
                const unitPriceAmount = parseFloat(variant.unitPrice.amount);
                const unitPriceAmountTotal = unitPriceAmount * line.quantity;
                variant.unitPrice = {
                    ...variant.unitPrice,
                    amount: unitPriceAmount,
                    amountTotal: unitPriceAmountTotal,
                    locale: this.localize({ amount: unitPriceAmount, locale }),
                    localeTotal: this.localize({
                        amount: unitPriceAmountTotal,
                        locale,
                    }),
                };
            }
            // // localize discountAtPrice
            if (variant?.discountAtPrice) {
                const discountAtPriceAmount = parseFloat(variant.discountAtPrice.amount);
                const discountAtPriceAmountTotal = discountAtPriceAmount * line.quantity;
                variant.discountAtPrice = {
                    ...variant.discountAtPrice,
                    amount: discountAtPriceAmount,
                    amountTotal: discountAtPriceAmountTotal,
                    locale: this.localize({
                        amount: discountAtPriceAmount,
                        locale,
                    }),
                    localeTotal: this.localize({
                        amount: discountAtPriceAmountTotal,
                        locale,
                    }),
                };
            }
            // maybe localize selling plan allocation for the line item
            let { sellingPlanAllocation } = line;
            if (sellingPlanAllocation) {
                sellingPlanAllocation = this.cartLineSellingPlanAllocation({
                    sellingPlanAllocation: { ...line.sellingPlanAllocation },
                    locale,
                    quantity: line.quantity,
                });
            }
            // if subscription, we use the sellingPlanAllocation savings else,
            // we use the variant compareAt and priceV2amount to estimate the savings
            let savingsAmount = null;
            const isSubscription = sellingPlanAllocation;
            if (isSubscription) {
                savingsAmount = sellingPlanAllocation.priceAdjustments[0].savingsAmount;
                // we overwrite this use the one from subscription
                compareAtPriceAmount =
                    sellingPlanAllocation.priceAdjustments[0].compareAtPrice;
            }
            else if (variant.compareAtPriceV2) {
                // one-time item
                const savingAmount = variant.compareAtPriceV2.amount - variant.priceV2.amount;
                const savingAmountTotal = variant.compareAtPriceV2.amountTotal - variant.priceV2.amountTotal;
                savingsAmount = savingAmount
                    ? {
                        amount: parseFloat(savingAmount.toFixed(2)),
                        amountTotal: parseFloat(savingAmountTotal.toFixed(2)),
                        currencyCode: locale.currency,
                        locale: this.localize({ amount: savingAmount, locale }),
                        localeTotal: this.localize({
                            amount: savingAmountTotal,
                            locale,
                        }),
                    }
                    : null;
            }
            // localize estimatedCost
            const estimatedCost = this.estimatedCost({
                estimatedCost: { ...line.estimatedCost },
                locale,
                discountAmount,
                savingsAmount,
                compareAtPriceAmount,
            });
            return {
                ...line,
                sellingPlanAllocation,
                estimatedCost,
                discountAllocations,
                variant,
                locale,
            };
        }
        catch (error) {
            console.error('cartLine:error', error);
            return line;
        }
    }
    /**
     * Adds locale, compareAt and priceV2 locale pricing to a variant
     */
    estimatedCost({ estimatedCost: cost, locale, discountAmount, // optional
    savingsAmount, // optional
    compareAtPriceAmount, // optional
    totalSavingsAmount, // optional
    totalDiscountAmount, // optional
    totalCompareAtAmount, // optional
     }) {
        const estimatedCost = { ...cost };
        // localize official fields
        if (cost?.subtotalAmount) {
            const subTotalAmount = parseFloat(cost.subtotalAmount.amount);
            estimatedCost.subtotalAmount = {
                ...estimatedCost.subtotalAmount,
                amount: subTotalAmount,
                locale: this.localize({ amount: subTotalAmount, locale }),
            };
        }
        if (cost?.totalAmount) {
            const totalAmount = parseFloat(cost.totalAmount.amount);
            estimatedCost.totalAmount = {
                ...estimatedCost.totalAmount,
                amount: totalAmount,
                locale: this.localize({ amount: totalAmount, locale }),
            };
        }
        if (cost?.totalDutyAmount) {
            const totalDutyAmount = parseFloat(cost.totalDutyAmount.amount);
            estimatedCost.totalDutyAmount = {
                ...estimatedCost.totalDutyAmount,
                amount: totalDutyAmount,
                locale: this.localize({ amount: totalDutyAmount, locale }),
            };
        }
        if (cost?.totalTaxAmount) {
            const totalTaxAmount = parseFloat(cost.totalTaxAmount.amount);
            estimatedCost.totalTaxAmount = {
                ...estimatedCost.totalTaxAmount,
                amount: totalTaxAmount,
                locale: this.localize({ amount: totalTaxAmount, locale }),
            };
        }
        // localize custom fields
        if (typeof discountAmount !== 'undefined') {
            estimatedCost.discountAmount = discountAmount;
        }
        if (typeof savingsAmount !== 'undefined') {
            estimatedCost.savingsAmount = savingsAmount;
        }
        if (typeof totalDiscountAmount !== 'undefined') {
            estimatedCost.totalDiscountAmount = totalDiscountAmount;
        }
        if (typeof totalSavingsAmount !== 'undefined') {
            estimatedCost.totalSavingsAmount = totalSavingsAmount;
        }
        if (typeof totalCompareAtAmount !== 'undefined') {
            estimatedCost.totalCompareAtAmount = totalCompareAtAmount;
        }
        if (compareAtPriceAmount) {
            estimatedCost.compareAtPriceAmount = compareAtPriceAmount;
        }
        return estimatedCost;
    }
    // Localize the line item's subscription pricing
    cartLineSellingPlanAllocation({ sellingPlanAllocation: _sellingPlanAllocation, locale, quantity, }) {
        const { priceAdjustments: _priceAdjustments, sellingPlan } = _sellingPlanAllocation;
        // localize each selling plan price adjustment for the given line item
        /**
          A list of price adjustments, with a maximum of two. When there are two
          the first price adjustment goes into effect at the time of purchase,
          while the second one starts after a certain number of orders
         */
        const priceAdjustments = _priceAdjustments?.map(({ compareAtPrice, perDeliveryPrice, price, unitPrice }) => {
            const localized = {};
            /**
              The price of the variant when it's purchased without a selling plan for the same number of deliveries.
              For example, if a customer purchases 6 deliveries of $10.00 granola separately, then the price is 6 x $10.00 = $60.00.
             */
            if (compareAtPrice) {
                localized.compareAtPrice = { ...compareAtPrice };
                const compareAtPriceAmount = parseFloat(compareAtPrice.amount);
                const compareAtPriceAmountTotal = compareAtPriceAmount * quantity;
                localized.compareAtPrice.amount = compareAtPriceAmount;
                localized.compareAtPrice.amountTotal = compareAtPriceAmountTotal;
                localized.compareAtPrice.locale = this.localize({
                    amount: compareAtPriceAmount,
                    locale,
                });
                localized.compareAtPrice.localeTotal = this.localize({
                    amount: compareAtPriceAmountTotal,
                    locale,
                });
            }
            /**
              The effective price for a single delivery. For example, for a prepaid subscription plan that
              includes 6 deliveries at the price of $48.00, the per delivery price is $8.00.
             */
            if (perDeliveryPrice) {
                localized.perDeliveryPrice = { ...perDeliveryPrice };
                const perDeliveryPriceAmount = parseFloat(perDeliveryPrice.amount);
                const perDeliveryPriceAmountTotal = perDeliveryPriceAmount * quantity;
                localized.perDeliveryPrice.amount = perDeliveryPriceAmount;
                localized.perDeliveryPrice.amountTotal = perDeliveryPriceAmountTotal;
                localized.perDeliveryPrice.locale = this.localize({
                    amount: perDeliveryPriceAmount,
                    locale,
                });
                localized.perDeliveryPrice.localeTotal = this.localize({
                    amount: perDeliveryPriceAmountTotal,
                    locale,
                });
            }
            /**
              The price of the variant when it's purchased with a selling plan For example, for a prepaid subscription plan
              that includes 6 deliveries of $10.00 granola, where the customer gets 20% off, the price is 6 x $10.00 x 0.80 = $48.00.
             */
            if (price) {
                localized.price = { ...price };
                const priceAmount = parseFloat(price.amount);
                const priceAmountTotal = priceAmount * quantity;
                localized.price.amount = priceAmount;
                localized.price.amountTotal = priceAmountTotal;
                localized.price.locale = this.localize({
                    amount: priceAmount,
                    locale,
                });
                localized.price.localeTotal = this.localize({
                    amount: priceAmountTotal,
                    locale,
                });
            }
            /**
              The resulting price per unit for the variant associated with the selling plan.
              If the variant isn't sold by quantity or measurement, then this field returns null.
             */
            if (unitPrice) {
                localized.unitPrice = { ...unitPrice };
                const unitPriceAmount = parseFloat(unitPrice.amount);
                const unitPriceAmountTotal = unitPriceAmount * quantity;
                localized.unitPrice.amount = unitPriceAmount;
                localized.unitPrice.amountTotal = unitPriceAmountTotal;
                localized.unitPrice.locale = this.localize({
                    amount: unitPriceAmount,
                    locale,
                });
                localized.unitPrice.localeTotal = this.localize({
                    amount: unitPriceAmountTotal,
                    locale,
                });
            }
            /**
              A custom property we add to calculate the discount amount applied by the subscription
             */
            const savingsAmount = localized.compareAtPrice.amount - localized.price.amount;
            const savingsAmountTotal = localized.compareAtPrice.amountTotal - localized.price.amountTotal;
            localized.savingsAmount = savingsAmount
                ? {
                    amount: parseFloat(savingsAmount.toFixed(2)),
                    amountTotal: parseFloat(savingsAmountTotal.toFixed(2)),
                    currencyCode: localized.compareAtPrice.currencyCode,
                    locale: this.localize({
                        amount: savingsAmount,
                        locale,
                    }),
                    localeTotal: this.localize({
                        amount: savingsAmountTotal,
                        locale,
                    }),
                }
                : null;
            return localized;
        });
        return { priceAdjustments, sellingPlan };
    }
    cartLineDiscountAllocations({ discountAllocations: _discountAllocations, quantity, locale, }) {
        let discountAmount = null; // the amount discounted
        const discountAllocations = [..._discountAllocations].map(({ discountedAmount: _discountAmount }) => {
            const amount = parseFloat(_discountAmount.amount);
            const amountTotal = amount * quantity;
            discountAmount = {
                ..._discountAmount,
                amount,
                amountTotal,
                locale: this.localize({ amount, locale }),
                localeTotal: this.localize({ amount: amountTotal, locale }),
            };
            return { discountAmount };
        });
        return { discountAllocations, discountAmount };
    }
    /**
     * Adds locale, locale min and max pricing to the product and compareAt and priceV2 locale pricing to its variants
     */
    product({ product: rawProduct, locale }) {
        const product = { ...rawProduct, locale };
        product.priceRange.maxVariantPrice.locale = this.localize({
            amount: product.priceRange.maxVariantPrice.amount,
            locale,
        });
        // localize minVariantPrice
        product.priceRange.minVariantPrice.locale = this.localize({
            amount: product.priceRange.minVariantPrice.amount,
            locale,
        });
        // localize variants
        product.variants = this.variants({
            variants: product.variants,
            locale,
        });
        return product;
    }
    /**
     * Localizes all product variants
     */
    variants({ variants = [], locale }) {
        return variants.map((variant) => {
            return this.variant({ variant, locale });
        });
    }
    /**
     * Adds locale, compareAt and priceV2 locale pricing to a variant
     */
    variant({ variant: rawVariant, locale }) {
        const variant = { ...rawVariant, locale };
        // localize the variant price
        let amount = parseFloat(variant.priceV2.amount);
        variant.priceV2 = {
            ...variant.priceV2,
            amount,
            locale: this.localize({ amount, locale }),
        };
        // localize the variant compareAtPriceV2
        if (variant?.compareAtPriceV2?.amount) {
            amount = parseFloat(variant.compareAtPriceV2.amount);
            variant.compareAtPriceV2 = {
                ...variant?.compareAtPriceV2,
                amount,
                locale: this.localize({ amount, locale }),
            };
        }
        // localize the variant sellingPlansAllocations
        if (variant?.sellingPlanAllocations?.length) {
            variant.sellingPlanAllocations = this.sellingPlanAllocations({
                sellingPlanAllocations: variant.sellingPlanAllocations,
                locale,
            });
        }
        return variant;
    }
    /**
     * Localize all selling plan allocations
     */
    sellingPlanAllocations({ sellingPlanAllocations: _sellingPlanAllocations = [], locale, }) {
        const sellingPlanAllocations = [..._sellingPlanAllocations];
        return sellingPlanAllocations.map((allocation) => {
            return this.sellingPlan({ allocation, locale });
        });
    }
    /**
     * Localize a single selling plan
     */
    sellingPlan({ allocation: _allocation, locale }) {
        const { priceAdjustments: _priceAdjustments, sellingPlan } = _allocation;
        // const adjustmentValue = sellingPlan?.priceAdjustments?.[0]?.adjustmentValue;
        // // A percentage amount that's deducted from the original variant price. For example, 10% off.
        // const percentageOff = adjustmentValue?.adjustmentPercentage || 0;
        // // A fixed price adjustment for a variant that's purchased with a selling plan.
        // const fixedPrice = adjustmentValue?.price?.amount || 0;
        // // A fixed amount that's deducted from the original variant price. For example, $10.00 off.
        // const amountOff = adjustmentValue?.adjustmentAmount?.amount || 0;
        const priceAdjustments = _priceAdjustments.map((adjustment) => {
            let { compareAtPrice, price, perDeliveryPrice, unitPrice } = adjustment;
            // localize selling plan compareAtPrice (Full price if no discount)
            if (compareAtPrice?.amount) {
                const amount = parseFloat(compareAtPrice.amount);
                compareAtPrice = {
                    ...compareAtPrice,
                    amount,
                    locale: this.localize({ amount, locale }),
                };
            }
            // localize selling plan price
            if (price?.amount) {
                const amount = parseFloat(price.amount);
                price = {
                    ...price,
                    amount,
                    locale: this.localize({ amount, locale }),
                };
            }
            // localize selling plan perDeliveryPrice
            if (perDeliveryPrice?.amount) {
                const amount = parseFloat(perDeliveryPrice.amount);
                perDeliveryPrice = {
                    ...perDeliveryPrice,
                    amount,
                    locale: this.localize({ amount, locale }),
                };
            }
            // localize selling plan unitPrice
            if (unitPrice?.amount) {
                const amount = parseFloat(unitPrice.amount);
                unitPrice = {
                    ...unitPrice,
                    amount,
                    locale: this.localize({ amount, locale }),
                };
            }
            return { compareAtPrice, price, perDeliveryPrice, unitPrice };
        });
        return { priceAdjustments, sellingPlan };
    }
    orderTotals({ order: rawOrder, locale }) {
        const order = { ...rawOrder, locale };
        // currents
        if (order?.currentTotalTax?.amount) {
            const amount = parseFloat(order.currentTotalTax.amount);
            order.currentTotalTax = {
                ...order?.currentTotalTax,
                amount,
                locale: this.localize({ amount, locale }),
            };
        }
        if (order?.currentTotalDuties?.amount) {
            const amount = parseFloat(order.currentTotalDuties.amount);
            order.currentTotalDuties = {
                ...order.currentTotalDuties,
                amount,
                locale: this.localize({ amount, locale }),
            };
        }
        if (order?.currentSubtotalPrice?.amount) {
            const amount = parseFloat(order.currentSubtotalPrice.amount);
            order.currentSubtotalPrice = {
                ...order.currentSubtotalPrice,
                amount,
                locale: this.localize({ amount, locale }),
            };
        }
        // totals
        if (order?.totalPriceV2?.amount) {
            const amount = parseFloat(order.totalPriceV2.amount);
            order.totalPriceV2 = {
                ...order.totalPriceV2,
                amount,
                locale: this.localize({ amount, locale }),
            };
        }
        if (order?.subtotalPriceV2?.amount) {
            const amount = parseFloat(order.subtotalPriceV2.amount);
            order.subtotalPriceV2 = {
                ...order.subtotalPriceV2,
                amount,
                locale: this.localize({ amount, locale }),
            };
        }
        if (order?.totalRefundedV2?.amount) {
            const amount = parseFloat(order.totalRefundedV2.amount);
            order.totalRefundedV2 = {
                ...order.totalRefundedV2,
                amount,
                locale: this.localize({ amount, locale }),
            };
        }
        if (order?.totalShippingPriceV2?.amount) {
            const amount = parseFloat(order.totalShippingPriceV2.amount);
            order.totalShippingPriceV2 = {
                ...order.totalShippingPriceV2,
                amount,
                locale: this.localize({ amount, locale }),
            };
        }
        if (order?.totalTaxV2?.amount) {
            const amount = parseFloat(order.totalTaxV2.amount);
            order.totalTaxV2 = {
                ...order.totalTaxV2,
                amount,
                locale: this.localize({ amount, locale }),
            };
        }
        return order;
    }
    orderLine({ line: rawLine, locale, currentLocale }) {
        const line = { ...rawLine, locale };
        // localize to order's original locale
        if (line?.originalTotalPrice?.amount) {
            const amount = parseFloat(line.originalTotalPrice.amount);
            line.originalTotalPrice = {
                ...line.originalTotalPrice,
                amount,
                locale: this.localize({
                    amount,
                    locale,
                }),
            };
        }
        // discounted line price
        let allocatedAmount = null;
        line.discountAllocations = line.discountAllocations.map(({ allocatedAmount: _allocatedAmount }) => {
            const amount = parseFloat(_allocatedAmount.amount);
            allocatedAmount = {
                ..._allocatedAmount,
                amount,
                locale: this.localize({
                    amount,
                    locale,
                }),
            };
            return { allocatedAmount };
        });
        line.discountAmount = allocatedAmount;
        // overwriting
        const discountedPriceAmount = allocatedAmount?.amount
            ? parseFloat(line.originalTotalPrice.amount) -
                parseFloat(line.discountAmount.amount)
            : line.originalTotalPrice.amount;
        line.discountedTotalPrice = {
            ...line.originalTotalPrice,
            amount: discountedPriceAmount,
            locale: this.localize({
                amount: discountedPriceAmount,
                locale,
            }),
        };
        // localize variants to current locale (not orders loale)
        line.variant = this.variant({
            variant: line.variant,
            locale: currentLocale,
        });
        return line;
    }
}
exports.Localize = Localize;
//# sourceMappingURL=Localize.js.map

/***/ }),

/***/ 21772:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.decodedId = void 0;
/**
 * Decodes a base64 encoded id to a string.
 *  Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zOTYzMDYzMzU5OTE2MA -> gid://shopify/ProductVariant/39630633599160
 * @param {*} id a base64 encodedId
 * @returns decoded if
 */
const decodedId = (id) => {
    try {
        if (!id)
            return null;
        return window.atob(id);
    }
    catch (error) {
        return id;
    }
};
exports.decodedId = decodedId;
//# sourceMappingURL=decodedId.js.map

/***/ }),

/***/ 82708:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getAddAction = void 0;
const tslib_1 = __webpack_require__(59312);
const lodash_isequal_1 = tslib_1.__importDefault(__webpack_require__(62004));
const getAddAction = ({ cart, data }) => {
    const sameVariantIdAndSellingPlan = ({ variant, sellingPlanAllocation }) => {
        // if the variant id is the same, and the selling plan is the same
        return (variant.id === data?.merchandiseId &&
            sellingPlanAllocation?.sellingPlan?.id === data?.sellingPlanId);
    };
    const mapAttributes = (attributesArray = []) => attributesArray.reduce((attrs, { key, value }) => {
        return { ...attrs, [key]: value };
    }, {});
    const itemInCart = cart.lines.find(sameVariantIdAndSellingPlan) || null;
    const itemInCartAttributes = itemInCart?.attributes
        ? mapAttributes(itemInCart.attributes)
        : {};
    const addingItemAttributes = data?.attributes
        ? mapAttributes(data.attributes)
        : {};
    const haveSameAttributes = itemInCart
        ? (0, lodash_isequal_1.default)(itemInCartAttributes, addingItemAttributes)
        : false;
    const attributes = data?.attributes?.length ? data.attributes : [];
    return { itemInCart, haveSameAttributes, attributes };
};
exports.getAddAction = getAddAction;
//# sourceMappingURL=getAddAction.js.map

/***/ }),

/***/ 85542:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Localize = exports.useRecoilStartFinishErrors = exports.useStartFinishErrors = exports.useMounted = exports.getAddAction = exports.decodedId = void 0;
var decodedId_1 = __webpack_require__(21772);
Object.defineProperty(exports, "decodedId", ({ enumerable: true, get: function () { return decodedId_1.decodedId; } }));
var getAddAction_1 = __webpack_require__(82708);
Object.defineProperty(exports, "getAddAction", ({ enumerable: true, get: function () { return getAddAction_1.getAddAction; } }));
var useMounted_1 = __webpack_require__(14180);
Object.defineProperty(exports, "useMounted", ({ enumerable: true, get: function () { return useMounted_1.useMounted; } }));
var useStartFinishErrors_1 = __webpack_require__(50798);
Object.defineProperty(exports, "useStartFinishErrors", ({ enumerable: true, get: function () { return useStartFinishErrors_1.useStartFinishErrors; } }));
var useRecoilStartFinishErrors_1 = __webpack_require__(62574);
Object.defineProperty(exports, "useRecoilStartFinishErrors", ({ enumerable: true, get: function () { return useRecoilStartFinishErrors_1.useRecoilStartFinishErrors; } }));
var Localize_1 = __webpack_require__(42667);
Object.defineProperty(exports, "Localize", ({ enumerable: true, get: function () { return Localize_1.Localize; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 14180:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useMounted = void 0;
const react_1 = __webpack_require__(27378);
const useMounted = () => {
    const [isMounted, setIsMounted] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        let unmounting = false;
        if (!unmounting) {
            setIsMounted(true);
        }
        return () => {
            unmounting = true;
        };
    }, []);
    return isMounted;
};
exports.useMounted = useMounted;
//# sourceMappingURL=useMounted.js.map

/***/ }),

/***/ 62574:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useRecoilStartFinishErrors = void 0;
const tslib_1 = __webpack_require__(59312);
const react_1 = __webpack_require__(27378);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useRecoilStartFinishErrors = (options) => {
    const setCartStarted = (0, store_1.useSetRecoilState)(store_1.default.cartStatusStarted('cart/all'));
    const setCartFinished = (0, store_1.useSetRecoilState)(store_1.default.cartStatusFinished('cart/all'));
    const setCartSuccess = (0, store_1.useSetRecoilState)(store_1.default.cartStatusSuccess('cart/all'));
    const setCartErrors = (0, store_1.useSetRecoilState)(store_1.default.cartStatusErrors('cart/all'));
    const isCartId = /^cart/.test(options?.id);
    const [started, setStarted] = (0, store_1.useRecoilState)(store_1.default.cartStatusStarted(options?.id || ''));
    const [finished, setFinished] = (0, store_1.useRecoilState)(store_1.default.cartStatusFinished(options?.id || ''));
    const [success, setSuccess] = (0, store_1.useRecoilState)(store_1.default.cartStatusSuccess(options?.id || ''));
    const [errors, setErrors] = (0, store_1.useRecoilState)(store_1.default.cartStatusErrors(options?.id || ''));
    const autoReset = (0, react_1.useRef)(options?.autoReset || 0);
    const resetTimer = (0, react_1.useRef)(options?.resetTimer || null);
    // update local hook status
    const reset = (0, react_1.useCallback)(() => {
        if (typeof setErrors === 'undefined')
            return;
        setErrors([]);
        setStarted(false);
        setFinished(false);
        setSuccess(false);
        resetTimer.current = null;
    }, []);
    const updateStateOnErrors = () => {
        console.log(options.id, 'updateStateOnErrors....', errors);
        let unMounting = false;
        if (errors?.length > 0) {
            if (unMounting)
                return;
            setFinished(true);
            setSuccess(false);
        }
        // eslint-disable-next-line consistent-return
        return () => {
            unMounting = true;
        };
    };
    const updateStateOnFinished = () => {
        let unMounting = false;
        if (finished) {
            if (options?.id) {
                console.groupCollapsed('id', options?.id);
                console.log('started', started);
                console.log('errors', errors);
                console.log('finished', finished);
                console.log('success', success);
                console.groupEnd();
            }
            if (unMounting)
                return;
            const withoutErrors = errors?.length === 0;
            setStarted(false);
            setSuccess(withoutErrors);
            if (autoReset?.current) {
                const to = setTimeout(() => {
                    if (unMounting)
                        return;
                    reset();
                    clearTimeout(to);
                }, autoReset.current);
            }
        }
        // eslint-disable-next-line consistent-return
        return () => {
            unMounting = true;
        };
    };
    (0, react_1.useEffect)(() => {
        updateStateOnErrors();
    }, [errors?.length]);
    (0, react_1.useEffect)(() => {
        updateStateOnFinished();
    }, [finished, options?.id]);
    // update global cart status
    (0, react_1.useEffect)(() => {
        if (isCartId) {
            setCartErrors(errors);
        }
    }, [errors?.length]);
    (0, react_1.useEffect)(() => {
        if (isCartId) {
            setCartStarted(started);
        }
    }, [started]);
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        setCartFinished(finished);
        const to = setTimeout(() => {
            if (unMounting)
                return;
            setCartFinished(false);
            clearTimeout(to);
        }, 1000);
        return () => {
            unMounting = true;
        };
    }, [finished]);
    (0, react_1.useEffect)(() => {
        if (isCartId) {
            setCartSuccess(success);
        }
    }, [success]);
    return {
        started,
        setStarted,
        finished,
        setFinished,
        success,
        setSuccess,
        errors,
        setErrors,
        reset,
        resetTimer,
    };
};
exports.useRecoilStartFinishErrors = useRecoilStartFinishErrors;
//# sourceMappingURL=useRecoilStartFinishErrors.js.map

/***/ }),

/***/ 50798:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useStartFinishErrors = void 0;
const tslib_1 = __webpack_require__(59312);
const react_1 = __webpack_require__(27378);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useStartFinishErrors = (options) => {
    const setCartStarted = (0, store_1.useSetRecoilState)(store_1.default.cartStatusStarted('global'));
    const setCartFinished = (0, store_1.useSetRecoilState)(store_1.default.cartStatusFinished('global'));
    const setCartSuccess = (0, store_1.useSetRecoilState)(store_1.default.cartStatusSuccess('global'));
    const setCartErrors = (0, store_1.useSetRecoilState)(store_1.default.cartStatusErrors('global'));
    const [started, setStarted] = (0, react_1.useState)(options?.started || false);
    const [success, setSuccess] = (0, react_1.useState)(options?.success || false);
    const [finished, setFinished] = (0, react_1.useState)(options?.finished || false);
    const [errors, setErrors] = (0, react_1.useState)(options?.errors || []);
    const autoReset = (0, react_1.useRef)(options?.autoReset || 0);
    const resetTimer = (0, react_1.useRef)(options?.resetTimer || null);
    // update local hook status
    const reset = (0, react_1.useCallback)(() => {
        if (typeof setErrors === 'undefined')
            return;
        setErrors([]);
        setStarted(false);
        setFinished(false);
        setSuccess(false);
        resetTimer.current = null;
    }, []);
    const updateStateOnErrors = () => {
        let unMounting = false;
        if (errors?.length > 0) {
            if (unMounting)
                return;
            setFinished(true);
            setSuccess(false);
        }
        // eslint-disable-next-line consistent-return
        return () => {
            unMounting = true;
        };
    };
    const updateStateOnFinished = () => {
        let unMounting = false;
        if (finished) {
            if (options?.id) {
                console.groupCollapsed('id', options?.id);
                console.log('started', started);
                console.log('errors', errors);
                console.log('finished', finished);
                console.log('success', success);
                console.groupEnd();
            }
            if (unMounting)
                return;
            setStarted(false);
            setSuccess(errors?.length === 0);
            if (autoReset?.current) {
                const to = setTimeout(() => {
                    if (unMounting)
                        return;
                    reset();
                    clearTimeout(to);
                }, autoReset.current);
            }
        }
        // eslint-disable-next-line consistent-return
        return () => {
            unMounting = true;
        };
    };
    (0, react_1.useEffect)(() => {
        updateStateOnErrors();
    }, [errors?.length]);
    (0, react_1.useEffect)(() => {
        updateStateOnFinished();
    }, [finished, options?.id]);
    // update global cart status
    (0, react_1.useEffect)(() => {
        setCartErrors(errors);
    }, [errors?.length]);
    (0, react_1.useEffect)(() => {
        if (options?.id) {
            console.log('setting started to', started);
            setCartStarted(started);
        }
    }, [started]);
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        if (options?.id) {
            console.log('setting finished to', finished);
            setCartFinished(finished);
            const to = setTimeout(() => {
                if (unMounting)
                    return;
                setCartFinished(false);
                clearTimeout(to);
            }, 1000);
        }
        return () => {
            unMounting = true;
        };
    }, [finished]);
    (0, react_1.useEffect)(() => {
        setCartSuccess(success);
    }, [success]);
    return {
        started,
        setStarted,
        finished,
        setFinished,
        success,
        setSuccess,
        errors,
        setErrors,
        reset,
        resetTimer,
    };
};
exports.useStartFinishErrors = useStartFinishErrors;
//# sourceMappingURL=useStartFinishErrors.js.map

/***/ }),

/***/ 17610:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(59312);
tslib_1.__exportStar(__webpack_require__(772), exports);
tslib_1.__exportStar(__webpack_require__(51457), exports);
tslib_1.__exportStar(__webpack_require__(48081), exports);
tslib_1.__exportStar(__webpack_require__(50010), exports);
tslib_1.__exportStar(__webpack_require__(33296), exports);
tslib_1.__exportStar(__webpack_require__(29196), exports);
tslib_1.__exportStar(__webpack_require__(95314), exports);
tslib_1.__exportStar(__webpack_require__(68335), exports);
tslib_1.__exportStar(__webpack_require__(80972), exports);
tslib_1.__exportStar(__webpack_require__(5852), exports);
tslib_1.__exportStar(__webpack_require__(42022), exports);
tslib_1.__exportStar(__webpack_require__(8844), exports);
tslib_1.__exportStar(__webpack_require__(85542), exports);
//# sourceMappingURL=hooks.js.map

/***/ }),

/***/ 52031:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.store = exports.StateProvider = void 0;
const tslib_1 = __webpack_require__(59312);
/* exports all storefront effects so they can be used in the project */
const effects_1 = tslib_1.__importDefault(__webpack_require__(49025));
/**
 * Pass down the storefront recoil hooks to the project
 * so that they can be in the same shared recoil instance
 */
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
var StateProvider_1 = __webpack_require__(79141);
Object.defineProperty(exports, "StateProvider", ({ enumerable: true, get: function () { return StateProvider_1.StateProvider; } }));
/* eslint-disable import/export */
tslib_1.__exportStar(__webpack_require__(17610), exports); // These hooks will be the default hooks found in @backpackjs/storefront
exports.store = {
    state: store_1.default,
    effects: effects_1.default,
    recoil: {
        useRecoilState: store_1.useRecoilState,
        useRecoilStateLoadable: store_1.useRecoilStateLoadable,
        useSetRecoilState: store_1.useSetRecoilState,
        useResetRecoilState: store_1.useResetRecoilState,
        useRecoilValue: store_1.useRecoilValue,
        useRecoilValueLoadable: store_1.useRecoilValueLoadable,
        useRecoilSnapshot: store_1.useRecoilSnapshot,
        useRecoilCallback: store_1.useRecoilCallback,
        atom: store_1.atom,
        atomFamily: store_1.atomFamily,
        selector: store_1.selector,
        selectorFamily: store_1.selectorFamily,
    },
};
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 29196:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useLocalizedOrderTotals = exports.useLocalizedOrderLine = exports.useLocalizedCartTotals = exports.useLocalizedCartLine = exports.useLocalizedVariant = exports.useLocalizedProduct = void 0;
var useLocalizedProduct_1 = __webpack_require__(77831);
Object.defineProperty(exports, "useLocalizedProduct", ({ enumerable: true, get: function () { return useLocalizedProduct_1.useLocalizedProduct; } }));
var useLocalizedVariant_1 = __webpack_require__(30865);
Object.defineProperty(exports, "useLocalizedVariant", ({ enumerable: true, get: function () { return useLocalizedVariant_1.useLocalizedVariant; } }));
var useLocalizedCartLine_1 = __webpack_require__(94642);
Object.defineProperty(exports, "useLocalizedCartLine", ({ enumerable: true, get: function () { return useLocalizedCartLine_1.useLocalizedCartLine; } }));
var useLocalizedCartTotals_1 = __webpack_require__(54260);
Object.defineProperty(exports, "useLocalizedCartTotals", ({ enumerable: true, get: function () { return useLocalizedCartTotals_1.useLocalizedCartTotals; } }));
var useLocalizedOrderLine_1 = __webpack_require__(88370);
Object.defineProperty(exports, "useLocalizedOrderLine", ({ enumerable: true, get: function () { return useLocalizedOrderLine_1.useLocalizedOrderLine; } }));
var useLocalizedOrderTotals_1 = __webpack_require__(34205);
Object.defineProperty(exports, "useLocalizedOrderTotals", ({ enumerable: true, get: function () { return useLocalizedOrderTotals_1.useLocalizedOrderTotals; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 35988:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useLocaleStartFinishErrors = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable prettier/prettier */
const react_1 = __webpack_require__(27378);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const DEBUG = false;
const useLocaleStartFinishErrors = (options) => {
    const setCartStarted = (0, store_1.useSetRecoilState)(store_1.default.localeStatusStarted('locale/all'));
    const setCartFinished = (0, store_1.useSetRecoilState)(store_1.default.localeStatusFinished('locale/all'));
    const setCartSuccess = (0, store_1.useSetRecoilState)(store_1.default.localeStatusSuccess('locale/all'));
    const setCartErrors = (0, store_1.useSetRecoilState)(store_1.default.localeStatusErrors('locale/all'));
    const isCartId = /^cart/.test(options?.id);
    const [started, setStarted] = (0, store_1.useRecoilState)(store_1.default.localeStatusStarted(options?.id || ''));
    const [finished, setFinished] = (0, store_1.useRecoilState)(store_1.default.localeStatusFinished(options?.id || ''));
    const [success, setSuccess] = (0, store_1.useRecoilState)(store_1.default.localeStatusSuccess(options?.id || ''));
    const [errors, setErrors] = (0, store_1.useRecoilState)(store_1.default.localeStatusErrors(options?.id || ''));
    const autoReset = (0, react_1.useRef)(options?.autoReset || 0);
    const resetTimer = (0, react_1.useRef)(options?.resetTimer || null);
    // update local hook status
    const reset = (0, react_1.useCallback)(() => {
        if (typeof setErrors === 'undefined')
            return;
        setErrors([]);
        setStarted(false);
        setFinished(false);
        setSuccess(false);
        resetTimer.current = null;
    }, []);
    const updateStateOnErrors = () => {
        let unMounting = false;
        if (errors?.length > 0) {
            if (unMounting)
                return;
            setFinished(true);
            setSuccess(false);
        }
        // eslint-disable-next-line consistent-return
        return () => {
            unMounting = true;
        };
    };
    const updateStateOnFinished = () => {
        let unMounting = false;
        if (finished) {
            if (DEBUG) {
                console.groupCollapsed('status:', options?.id);
                console.log('started', started);
                console.log('errors', errors);
                console.log('finished', finished);
                console.log('success', success);
                console.groupEnd();
            }
            if (unMounting)
                return;
            const withoutErrors = errors?.length === 0;
            setStarted(false);
            setSuccess(withoutErrors);
            if (autoReset?.current) {
                const to = setTimeout(() => {
                    if (unMounting)
                        return;
                    reset();
                    clearTimeout(to);
                }, autoReset.current);
            }
        }
        // eslint-disable-next-line consistent-return
        return () => {
            unMounting = true;
        };
    };
    (0, react_1.useEffect)(() => {
        updateStateOnErrors();
    }, [errors?.length]);
    (0, react_1.useEffect)(() => {
        updateStateOnFinished();
    }, [finished, options?.id]);
    // update global cart status
    (0, react_1.useEffect)(() => {
        if (isCartId) {
            setCartErrors(errors);
        }
    }, [errors?.length]);
    (0, react_1.useEffect)(() => {
        if (isCartId) {
            setCartStarted(started);
        }
    }, [started]);
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        setCartFinished(finished);
        const to = setTimeout(() => {
            if (unMounting)
                return;
            setCartFinished(false);
            clearTimeout(to);
        }, 1000);
        return () => {
            unMounting = true;
        };
    }, [finished]);
    (0, react_1.useEffect)(() => {
        if (isCartId) {
            setCartSuccess(success);
        }
    }, [success]);
    return {
        started,
        setStarted,
        finished,
        setFinished,
        success,
        setSuccess,
        errors,
        setErrors,
        reset,
        resetTimer,
    };
};
exports.useLocaleStartFinishErrors = useLocaleStartFinishErrors;
//# sourceMappingURL=useLocaleStartFinishErrors.js.map

/***/ }),

/***/ 94642:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useLocalizedCartLine = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable no-undef */
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const defaultProps = {
    line: null,
    options: {},
};
/**
 * Localized a cart line item
 * @param {*} passedProps
 * @returns
 */
const useLocalizedCartLine = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    if (!props.line) {
        console.warn('useLocalizedCartLine "line" prop no provided');
        return { localized: null };
    }
    return {
        localized: (0, store_1.useRecoilValue)(store_1.default.localizedCartLine(props.line)),
    };
};
exports.useLocalizedCartLine = useLocalizedCartLine;
//# sourceMappingURL=useLocalizedCartLine.js.map

/***/ }),

/***/ 54260:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useLocalizedCartTotals = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable no-undef */
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
/**
 * Localized a cart line totals
 * @param {*} passedProps
 * @returns
 */
const useLocalizedCartTotals = () => {
    return {
        localized: (0, store_1.useRecoilValue)(store_1.default.localizedCartTotals),
    };
};
exports.useLocalizedCartTotals = useLocalizedCartTotals;
//# sourceMappingURL=useLocalizedCartTotals.js.map

/***/ }),

/***/ 88370:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useLocalizedOrderLine = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable no-undef */
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const defaultProps = {
    line: null,
    currencyCode: '',
    options: {},
};
/**
 * Localized a order line item
 * @param {*} passedProps
 * @returns
 */
const useLocalizedOrderLine = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    if (!props.line) {
        console.warn('useLocalizedOrderLine "line" prop no provided');
        return { localized: null };
    }
    if (!props.currencyCode) {
        console.warn('useLocalizedOrderLine "currencyCode" prop no provided');
        return { localized: null };
    }
    return {
        localized: (0, store_1.useRecoilValue)(store_1.default.localizedOrderLine(props)),
    };
};
exports.useLocalizedOrderLine = useLocalizedOrderLine;
//# sourceMappingURL=useLocalizedOrderLine.js.map

/***/ }),

/***/ 34205:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useLocalizedOrderTotals = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable no-undef */
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const defaultProps = {
    order: null,
    options: {},
};
/**
 * Localized a cart line totals
 * @param {*} passedProps
 * @returns
 */
const useLocalizedOrderTotals = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    if (!props.order) {
        console.warn('useLocalizedOrderTotals "order" prop no provided');
        return { localized: null };
    }
    return {
        localized: (0, store_1.useRecoilValue)(store_1.default.localizedOrderTotals(props.order)),
    };
};
exports.useLocalizedOrderTotals = useLocalizedOrderTotals;
//# sourceMappingURL=useLocalizedOrderTotals.js.map

/***/ }),

/***/ 77831:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useLocalizedProduct = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable no-undef */
const deepmerge_1 = tslib_1.__importDefault(__webpack_require__(20406));
const react_1 = __webpack_require__(27378);
const useLocaleStartFinishErrors_1 = __webpack_require__(35988);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const defaultProps = {
    handle: null,
    product: null,
    countryCode: null,
    currency: null,
    localizeVariants: false,
    fetchOnMount: true,
    options: {},
};
/**
 * Retrieve the localized prices for a product in a given country
 * @param {*} passedProps
 * @returns
 */
const useLocalizedProduct = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const isBusy = (0, react_1.useRef)(false);
    const recoilProduct = (0, store_1.useRecoilValue)(store_1.default.product);
    const product = props.product?.handle ? props.product : recoilProduct;
    let handle = props.handle || product?.handle;
    const recoilCountry = (0, store_1.useRecoilValue)(store_1.default.country);
    let country = props.countryCode || recoilCountry?.isoCode;
    let currency = props.currency || recoilCountry?.currency?.isoCode;
    const { finished, setStarted, setFinished, setErrors, ...status } = (0, useLocaleStartFinishErrors_1.useLocaleStartFinishErrors)({
        ...props.options,
        id: `locale/product/${handle}/${country?.isoCode || country}/${currency}`,
    });
    const [localized, setLocalized] = (0, store_1.useRecoilState)(store_1.default.localizedProduct({ handle, country, currency }));
    const localize = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        const release = snapshot.retain();
        try {
            setStarted(true);
            // if the user passes a handle via the fetcher prioritize it
            if (data?.handle) {
                handle = data.handle;
            }
            if (data?.country) {
                country = data.country;
            }
            if (data?.currency) {
                currency = data.currency;
            }
            let validationErrors = null;
            switch (true) {
                case !handle: {
                    validationErrors = ['handle not provided'];
                    break;
                }
                case !country: {
                    validationErrors = ['country not provided'];
                    break;
                }
                case !currency: {
                    validationErrors = ['currency not provided'];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                setErrors(validationErrors);
                return null;
            }
            const { error, product: _product } = await snapshot.getPromise(store_1.default.fetchLocaleProduct({ handle, country, currency }));
            if (error) {
                setErrors([error]);
                return null;
            }
            if (!_product) {
                setErrors([`Invalid product price in response ${_product}`]);
                return null;
            }
            if (!product?.variants) {
                setErrors([`Invalid source product provided ${product}`]);
                return null;
            }
            setFinished(true);
            // console.log('original product', product);
            // console.log('localized product', _product);
            // merge the original product with the localized version
            const mergedProduct = {
                ...product,
                locale: _product.locale,
                priceRange: _product.priceRange,
                requiresSellingPlan: _product.requiresSellingPlan,
                sellingPlanGroups: _product.requiresSellingPlan,
            };
            // localize all product variants including fromGrouping (optional)
            if (props.localizeVariants) {
                // merge the original variants (that have no locale) with the localized versions
                const localizedProductVariants = product.variants
                    .filter((variant) => !variant.fromGrouping)
                    .map((variant) => {
                    const localizedVariant = _product.variants.find((_variant) => _variant.id === variant.id);
                    return (0, deepmerge_1.default)(variant, localizedVariant);
                });
                // fetch locale for grouping variants as shopify knows nothing about the grouping
                const groupingVariants = product.variants.filter((variant) => variant.fromGrouping);
                const groupingVariantInPromise = groupingVariants.map((_variant) => snapshot.getPromise(store_1.default.fetchProductVariantPriceIn({
                    handle: _variant.product.handle,
                    selectedOptions: _variant.selectedOptions,
                })));
                const groupingLocalizedVariantsResponse = await Promise.all(groupingVariantInPromise);
                const groupingLocalizedVariants = groupingLocalizedVariantsResponse.map((response) => {
                    if (response.error) {
                        return null;
                    }
                    return response.variant;
                });
                // apply merged variants
                mergedProduct.variants = [
                    ...localizedProductVariants,
                    ...groupingLocalizedVariants,
                ];
            }
            setLocalized(mergedProduct);
            if (callback)
                callback(mergedProduct);
            return mergedProduct;
        }
        catch (error) {
            console.error('localize:error', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    // fetch on mount
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [
            !handle,
            !country,
            !currency,
            !props.fetchOnMount,
            isBusy.current,
            localized,
        ];
        if (earlyExitIf.some(Boolean)) {
            return undefined;
        }
        isBusy.current = true;
        localize({ handle, country, currency })
            .then((_product) => {
            if (unMounting)
                return null;
            setLocalized(_product);
            isBusy.current = false;
            return _product;
        })
            .catch((error) => {
            console.error('failed to localize due to', error.message);
        });
        return () => {
            unMounting = true;
        };
    }, [handle, country, currency, localized, props.fetchOnMount]);
    return {
        localized: localized || null,
        localize,
        finished,
        setErrors,
        setFinished,
        setStarted,
        ...status,
    };
};
exports.useLocalizedProduct = useLocalizedProduct;
//# sourceMappingURL=useLocalizedProduct.js.map

/***/ }),

/***/ 30865:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useLocalizedVariant = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable no-undef */
const react_1 = __webpack_require__(27378);
const useLocaleStartFinishErrors_1 = __webpack_require__(35988);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const defaultProps = {
    variant: { product: { handle: null }, selectedOptions: null, id: '' },
    countryCode: null,
    currency: null,
    fetchOnMount: true,
    options: {},
};
/**
 * Retrieve the localized prices for a product in a given country
 * @param {*} passedProps
 * @returns
 */
const useLocalizedVariant = (passedProps) => {
    const fallbackCountry = (0, store_1.useRecoilValue)(store_1.default.country)?.isoCode;
    const fallbackCurrency = (0, store_1.useRecoilValue)(store_1.default.country)?.currency?.isoCode;
    const props = passedProps?.variant
        ? { ...defaultProps, ...passedProps }
        : defaultProps;
    let { handle } = props.variant.product;
    let { selectedOptions } = props.variant;
    let country = props.countryCode || fallbackCountry;
    let currency = props.currency || fallbackCurrency;
    const statusId = `locale/product/${handle}/variant/${props.variant.id
        .split('/')
        .pop()}/${country}/${currency}`;
    const { finished, setStarted, setFinished, setErrors, ...status } = (0, useLocaleStartFinishErrors_1.useLocaleStartFinishErrors)({ ...props.options, id: statusId });
    const [localized, setLocalized] = (0, store_1.useRecoilState)(store_1.default.localizedVariant({ handle, selectedOptions, country, currency }));
    const localize = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        const release = snapshot.retain();
        try {
            setStarted(true);
            // if the user passes a handle via the fetcher prioritize it
            if (data?.handle) {
                handle = data.handle;
            }
            if (data?.selectedOptions) {
                selectedOptions = data.selectedOptions;
            }
            if (data?.country) {
                country = data.country;
            }
            if (data?.currency) {
                currency = data.currency;
            }
            let validationErrors = null;
            switch (true) {
                case !handle: {
                    validationErrors = ['handle not provided'];
                    break;
                }
                case !selectedOptions: {
                    validationErrors = ['selectedOptions not provided'];
                    break;
                }
                case !country: {
                    validationErrors = ['country not provided'];
                    break;
                }
                case !currency: {
                    validationErrors = ['currency not provided'];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                setErrors(validationErrors);
                return null;
            }
            const { error, variant: _variant } = await snapshot.getPromise(store_1.default.fetchLocalizedVariant({
                handle,
                selectedOptions,
                country,
                currency,
            }));
            if (error) {
                setErrors([error]);
                return null;
            }
            if (!_variant) {
                setErrors([
                    `Invalid product variant price in response: ${_variant}`,
                ]);
                return null;
            }
            setFinished(true);
            setLocalized(_variant);
            if (callback)
                callback(_variant);
            return _variant;
        }
        catch (error) {
            console.error('localize:error', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [
            !handle,
            !selectedOptions?.length,
            !country,
            !currency,
            !props.fetchOnMount,
            finished,
        ];
        if (earlyExitIf.some(Boolean)) {
            return;
        }
        localize({ handle, country, currency })
            .then((variant) => {
            if (unMounting)
                return;
            setLocalized(variant);
        })
            .catch((error) => {
            console.error('failed to localize due to', error.message);
        });
        // eslint-disable-next-line
        return () => {
            unMounting = true;
        };
    }, [
        country,
        currency,
        finished,
        handle,
        props.fetchOnMount,
        props.variant.id,
        selectedOptions,
    ]);
    return {
        localized: localized || null,
        localize,
        finished,
        setErrors,
        setFinished,
        setStarted,
        ...status,
    };
};
exports.useLocalizedVariant = useLocalizedVariant;
//# sourceMappingURL=useLocalizedVariant.js.map

/***/ }),

/***/ 29970:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.localeStore = void 0;
var locale_1 = __webpack_require__(24415);
Object.defineProperty(exports, "localeStore", ({ enumerable: true, get: function () { return locale_1.localeStore; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 24415:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.localeStore = void 0;
/* eslint-disable max-lines */
const recoil_1 = __webpack_require__(69853);
const client_1 = __webpack_require__(25431);
const store_1 = __webpack_require__(20437);
const store_2 = __webpack_require__(29005);
const Localize_1 = __webpack_require__(42667);
const localize = new Localize_1.Localize();
const productClient = new client_1.ProductClient({
    apiToken: "7b8296bfc85c0cb6fbc85bd5fa81686f",
    apiVersion: '2024-10',
    domain: "kryo-gear.myshopify.com",
});
/**
  Locale State
*/
const localizedProduct = (0, recoil_1.atomFamily)({
    key: 'locale/product',
    default: null,
});
const localizedVariant = (0, recoil_1.atomFamily)({
    key: 'locale/variant',
    default: null,
});
const localizedCartLine = (0, recoil_1.selectorFamily)({
    key: 'locale/cartLine',
    get: (line) => ({ get }) => {
        const { locale } = get(store_1.shopStore.country);
        return localize.cartLine({ line, locale });
    },
});
const localizedCartTotals = (0, recoil_1.selector)({
    key: 'locale/cartTotals',
    get: ({ get }) => {
        const cart = get(store_2.cartStore.cart);
        const { locale } = get(store_1.shopStore.country);
        return localize.cartTotals({ cart, locale });
    },
});
const localizedOrderLine = (0, recoil_1.selectorFamily)({
    key: 'locale/orderLine',
    get: ({ line, currencyCode }) => ({ get }) => {
        const { locale: currentLocale } = get(store_1.shopStore.country);
        const countries = get(store_1.shopStore.countries);
        const orderCounty = countries.find((country) => {
            return country.currency?.isoCode === currencyCode;
        });
        const orderLocale = orderCounty?.locale || currentLocale;
        return localize.orderLine({
            line,
            currentLocale,
            locale: orderLocale,
        });
    },
});
const localizedOrderTotals = (0, recoil_1.selectorFamily)({
    key: 'locale/orderTotals',
    get: (order) => ({ get }) => {
        const countries = get(store_1.shopStore.countries);
        const orderCounty = countries.find((country) => {
            return country.currency?.isoCode === order.currencyCode;
        });
        const orderLocale = orderCounty?.locale;
        return localize.orderTotals({
            order,
            locale: orderLocale,
        });
    },
});
/* Status */
const localeStatusStarted = (0, recoil_1.atomFamily)({
    key: 'locale/statusStarted',
    default: false,
});
const localeStatusFinished = (0, recoil_1.atomFamily)({
    key: 'locale/statusFinished',
    default: false,
});
const localeStatusSuccess = (0, recoil_1.atomFamily)({
    key: 'locale/statusSuccess',
    default: false,
});
const localeStatusErrors = (0, recoil_1.atomFamily)({
    key: 'locale/statusErrors',
    default: [],
});
/* Async */
const fetchLocaleProduct = (0, recoil_1.selectorFamily)({
    key: 'locale/fetchProduct',
    get: (data) => async ({ get }) => {
        const passedCountryCode = data?.country?.isoCode || data?.country;
        const country = get(store_1.shopStore.country);
        const _country = passedCountryCode || country?.isoCode || 'US';
        try {
            // get product in country's currency
            const { error, product: _product } = await productClient.getLocalizedProduct({
                ...data,
                country: _country,
            });
            if (error) {
                throw new Error(error);
            }
            if (!_product || !_product?.id) {
                throw new Error('Invalid locale product response');
            }
            // add locale to localized product
            const _localizedProduct = localize.product({
                product: _product,
                locale: country.locale,
            });
            return { error: null, product: _localizedProduct };
        }
        catch (error) {
            return { error: error.message, product: null };
        }
    },
});
const fetchLocalizedVariant = (0, recoil_1.selectorFamily)({
    key: 'locale/fetchVariant',
    get: (data) => async ({ get }) => {
        const passedCountryCode = data?.country?.isoCode || data?.country;
        const country = get(store_1.shopStore.country);
        const _country = passedCountryCode || country?.isoCode || 'US';
        try {
            // get variant localized in the current country
            const { error, variant: rawVariant } = await productClient.getLocalizedVariant({
                ...data,
                country: _country,
                locale: country.locale,
            });
            if (error) {
                throw new Error(error);
            }
            if (!rawVariant || !rawVariant?.id) {
                throw new Error('Invalid locale variant response');
            }
            // add locale to localized variant
            const _localizedVariant = localize.variant({
                variant: rawVariant,
                locale: country.locale,
            });
            // convert sellingPlanAllocations to a map
            const spsByKey = (_sps, sp) => {
                return {
                    ..._sps,
                    [sp.sellingPlan.id]: sp,
                };
            };
            // added to make it easier to find the active selling plan
            const sellingPlans = _localizedVariant.sellingPlanAllocations.reduce(spsByKey, {});
            const variant = { ..._localizedVariant, sellingPlans };
            return { error: null, variant };
        }
        catch (error) {
            return { error: error.message, variant: null };
        }
    },
});
// Localized stored
exports.localeStore = {
    localizedProduct,
    localizedVariant,
    localizedCartLine,
    localizedCartTotals,
    localizedOrderLine,
    localizedOrderTotals,
    // status
    localeStatusStarted,
    localeStatusFinished,
    localeStatusSuccess,
    localeStatusErrors,
    // async
    fetchLocaleProduct,
    fetchLocalizedVariant,
};
//# sourceMappingURL=locale.js.map

/***/ }),

/***/ 95314:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(59312);
tslib_1.__exportStar(__webpack_require__(43031), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 43031:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.usePage = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const usePage = () => (0, store_1.useRecoilValue)(store_1.default.page);
exports.usePage = usePage;
//# sourceMappingURL=usePage.js.map

/***/ }),

/***/ 98886:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.pageStore = void 0;
var page_1 = __webpack_require__(80523);
Object.defineProperty(exports, "pageStore", ({ enumerable: true, get: function () { return page_1.pageStore; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 80523:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.pageStore = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable max-lines */
const recoil_1 = __webpack_require__(69853);
const effects_1 = tslib_1.__importDefault(__webpack_require__(49025));
/**
  Page State
*/
const page = (0, recoil_1.atom)({
    key: 'page/page',
    default: null,
    effects: [
        // effects.logStateChange('page'),
        effects_1.default.onChange({
            key: 'page',
            topic: 'PAGE_UPDATE',
            actions: ['publishBusEvent'],
        }),
    ],
});
const pagesList = (0, recoil_1.atom)({
    key: 'page/pagesList',
    default: [],
});
// pages json fuse index
const pagesIndex = (0, recoil_1.atom)({
    key: 'page/pagesIndex',
    default: null,
});
exports.pageStore = {
    // actual state - atoms
    page,
    pagesIndex,
    pagesList,
};
//# sourceMappingURL=page.js.map

/***/ }),

/***/ 466:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ProductClient = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable no-undef */
/* eslint-disable class-methods-use-this */
const graphql_request_1 = __webpack_require__(63671);
const humanize_graphql_response_1 = tslib_1.__importDefault(__webpack_require__(27207));
const queries_1 = __webpack_require__(68318);
/**
 * @see: https://shopify.dev/custom-storefronts/cart
 */
class ProductClient {
    constructor({ apiToken, apiVersion, domain }) {
        this.apiToken = apiToken;
        this.apiVersion = apiVersion;
        this.domain = domain;
        this.endpoint = `https://${this.domain}/api/${apiVersion}/graphql.json`;
        this.options = {
            method: 'POST',
            mode: 'cors',
            headers: {
                'X-Shopify-Storefront-Access-Token': this.apiToken,
                'Content-Type': 'application/json; charset=utf-8',
            },
        };
        this.client = new graphql_request_1.GraphQLClient(this.endpoint, this.options);
    }
    /**
     *
     * @param
     * @returns
     */
    async storefront({ query, variables }) {
        return this.client.rawRequest(query, variables);
    }
    /**
     * Fetch a /json/ hosted file
     * @param {jsonPath} path a valid /json/**.* path
     * @returns a json object
     */
    async json({ path }) {
        try {
            if (!path)
                throw new TypeError('Missing required json "path"');
            const jsonUrl = `/json/${path}`;
            // eslint-disable-next-line no-undef
            const response = await fetch(jsonUrl);
            if (!response?.ok) {
                return { error: 'json response not ok', data: null };
            }
            const data = await response.json();
            return { error: null, data };
        }
        catch (error) {
            const errorMsg = `requestJson: failed to fetch json ${path} due to ${error.message}`;
            console.error(errorMsg);
            return { error, data: null };
        }
    }
    /**
     * Get a product's live sellingPlans by handle
     * @param {string} handle - can pass any valid cart param here: e.g — buyerIdentity, attributes etc..
     * @returns a new full cart instance
     */
    async getByHandle({ handle } = { handle: null }) {
        try {
            if (!handle) {
                throw new Error('get product failed "handle" not provided');
            }
            const productPath = `products/${handle}.json`;
            const { error, data } = await this.json({
                path: productPath,
            });
            if (error) {
                throw new Error(error);
            }
            return { error: null, product: data };
        }
        catch (error) {
            console.error('getByHandle:error', error.message);
            return { error: error.message, product: null };
        }
    }
    /**
     * Fetch a list of all products with some basic meta (great for building collection filters)
     * @returns products-list.json
     */
    async getList() {
        try {
            const { error, data } = await this.json({
                path: 'products-list.json',
            });
            if (error) {
                throw new Error(error);
            }
            return { error: null, productsList: data };
        }
        catch (error) {
            console.error('getList:error', error.message);
            return { error: error.message, productsList: null };
        }
    }
    /**
     * Fetch a index of all products (used by fuse search index)
     * @returns products-index.json
     */
    async getIndex() {
        try {
            const { error, data } = await this.json({
                path: 'products-index.json',
            });
            if (error) {
                throw new Error(error);
            }
            return { error: null, productsIndex: data };
        }
        catch (error) {
            console.error('getIndex:error', error.message);
            return { error: error.message, productsIndex: null };
        }
    }
    /**
     * Fetch a set of uniq product properties
     * @returns products-uniq.json
     */
    async getUniq() {
        try {
            const { error, data } = await this.json({
                path: 'products-uniq.json',
            });
            if (error) {
                throw new Error(error);
            }
            return { error: null, productsUniq: data };
        }
        catch (error) {
            return { error: error.message, productsUniq: null };
        }
    }
    /**
     * Fetch a list of all product handles
     * @returns products.json
     */
    async getHandles() {
        try {
            const { error, data } = await this.json({
                path: 'products.json',
            });
            if (error) {
                throw new Error(error);
            }
            return { error: null, productHandles: data };
        }
        catch (error) {
            console.error('getHandles:error', error.message);
            return { error: error.message, productHandles: null };
        }
    }
    /**
     * Get a product's live sellingPlans by handle
     * @param {twoDigitCountryCode} country - US, MX..
     * @param {string} handle - can pass any valid cart param here: e.g — buyerIdentity, attributes etc..
     * @returns a new full cart instance
     */
    async getSellingPlans({ country, handle } = { country: 'US', handle: null }) {
        try {
            if (!handle) {
                throw new Error('get selling plans failed "handle" not provided');
            }
            const { data, errors, status } = await this.storefront({
                query: queries_1.queries.getProductSellingPlans,
                variables: { country, handle },
            });
            if (status !== 200) {
                throw new Error(`Network request failed with status ${status}`);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            const { product } = data;
            return { error: null, product: (0, humanize_graphql_response_1.default)(product) };
        }
        catch (error) {
            console.error('getProductSellingPlans:error', error.message);
            return { error: error.message, product: null };
        }
    }
    /**
     * Get a variant selling plans in a given countries context
     * @param {twoDigitCountryCode} country - US, MX..
     * @param {String} handle - the target product's handle
     * @param {String} selectedOptions - the target variant's selectedOptions
     * @returns a full variant with prices in a target country
     */
    async getVariantSellingPlans({ country, currency, handle, selectedOptions } = {
        country: 'US',
        currency: 'USD',
        handle: null,
        selectedOptions: [],
        locale,
    }) {
        try {
            if (!handle) {
                throw new Error('get variant selling plan failed "handle" not provided');
            }
            if (!selectedOptions) {
                throw new Error('get variant selling plan failed "selectedOptions" not provided');
            }
            // get variant price in country
            const { data, errors, status } = await this.storefront({
                query: queries_1.queries.getProductVariantSellingPlans,
                variables: { country, handle, selectedOptions },
            });
            if (status !== 200) {
                throw new Error(`Network request failed with status ${status}`);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            const { product } = (0, humanize_graphql_response_1.default)(data);
            let { variant } = product;
            // add locale pricing and info to the variant
            variant = this._localizeVariant({ variant, locale, currency });
            return { error: null, variant };
        }
        catch (error) {
            console.error('getVariantSellingPlans:error', error.message);
            return { error: error.message, variant: null };
        }
    }
    /**
     * Get a product's live inventory by handle
     * @param {twoDigitCountryCode} country - US, MX..
     * @param {String} handle - can pass any valid cart param here: e.g — buyerIdentity, attributes etc..
     * @param {Boolean} withQuantity - if true we return the quantities available too
     * @returns live inventory for a product
     */
    async getInventory({ country, handle, withQuantity } = {
        country: 'US',
        handle: null,
        withQuantity: true,
    }) {
        try {
            if (!handle) {
                throw new Error('get inventory failed "handle" not provided');
            }
            const { data, errors, status } = await this.storefront({
                query: withQuantity
                    ? queries_1.queries.getInventoryWithQuantity
                    : queries_1.queries.getInventory,
                variables: { country, handle },
            });
            if (status !== 200) {
                throw new Error(`Network request failed with status ${status}`);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            const { product } = data;
            return { error: null, product: (0, humanize_graphql_response_1.default)(product) };
        }
        catch (error) {
            console.error('getInventory:error', error.message);
            return { error: error.message, product: null };
        }
    }
    /**
     * Get a product and variants price in a given countries context
     * @param {twoDigitCountryCode} country - US, MX..
     * @param {String} handle - the target product's handle
     * @returns product and variants prices in that country
     */
    async getLocalizedProduct({ country, handle } = {
        country: 'US',
        handle: null,
    }) {
        try {
            if (!handle) {
                throw new Error('get localized product failed "handle" not provided');
            }
            const { data, errors, status } = await this.storefront({
                query: queries_1.queries.getLocalizedProduct,
                variables: { country, handle },
            });
            if (status !== 200) {
                throw new Error(`Network request failed with status ${status}`);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            const { product } = (0, humanize_graphql_response_1.default)(data);
            return { error: null, product };
        }
        catch (error) {
            console.error('getLocalizedProduct:error', error.message);
            return { error: error.message, product: null };
        }
    }
    /**
     * Get a variant price in a given countries context
     * @param {twoDigitCountryCode} country - US, MX..
     * @param {String} locale - country locale
     * @param {String} handle - the target product's handle
     * @param {String} selectedOptions - the target variant's selectedOptions
     * @returns a full variant with prices in a target country
     */
    async getLocalizedVariant({ country, handle, selectedOptions } = {
        country: 'US',
        locale: null,
        handle: null,
        selectedOptions: [],
    }) {
        try {
            if (!country) {
                throw new Error('get localized variant "country" not provided');
            }
            if (!handle) {
                throw new Error('get localized variant "handle" not provided');
            }
            if (!selectedOptions) {
                throw new Error('get localized variant "selectedOptions" not provided');
            }
            // get variant price in country
            const { data, errors, status } = await this.storefront({
                query: queries_1.queries.getLocalizedVariant,
                variables: { country, handle, selectedOptions },
            });
            if (status !== 200) {
                throw new Error(`Network request failed with status ${status}`);
            }
            if (!data.product) {
                throw new Error(`No localized variant found for product with handle \`${handle}\``);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            const { product } = (0, humanize_graphql_response_1.default)(data);
            const { variant } = product;
            return { error: null, variant };
        }
        catch (error) {
            console.error('getLocalizedVariant:error', error.message);
            return { error: error.message, variant: null };
        }
    }
    /**
     * Get a product's recommendations via shopify
     * @param {String} productId - product legacyResourceId
     * @param {Integer|String} limit - how many recommendations to get
     * @returns a new full cart instance
     */
    async getRecommendations({ productId, limit } = {
        productId: null,
        limit: 6,
    }) {
        try {
            if (!productId) {
                throw new Error('get recommendations failed "productId" not provided');
            }
            // eslint-disable-next-line no-undef
            const url = window.location.origin;
            const endpoint = `${url}/api/shopify/recommendations`;
            // eslint-disable-next-line no-undef
            const request = await fetch(endpoint, {
                method: 'POSt',
                body: JSON.stringify({ productId, limit }),
            });
            if (!request?.ok) {
                throw new Error('Recommendations request not ok');
            }
            const { errors, response } = await request.json();
            if (errors?.length) {
                throw new Error(errors[0]);
            }
            if (!response?.products) {
                throw new Error('Invalid recommendations response');
            }
            const { products } = response;
            const recommendations = products.map((product) => {
                return {
                    handle: product.handle,
                    legacyResourceId: productId,
                };
            });
            return { error: null, recommendations };
        }
        catch (error) {
            console.error('getRecommendations:error', error.message);
            return { error: error.message, recommendations: [] };
        }
    }
    /**
     * Get a product's metafield by handle
     * @param {twoDigitCountryCode} country - US, MX..
     * @param {String} handle - the product handle
     * @param {String} key - the metafield key
     * @param {String} namespace - the metafield namespace
     * @returns a metafield key and value
     */
    async getMetafield({ country, handle, key, namespace } = {
        country: 'US',
        handle: null,
        key: '',
        namespace: '',
    }) {
        try {
            if (!handle) {
                throw new Error('get metafield failed "handle" not provided');
            }
            if (!key) {
                throw new Error('get metafield failed "key" not provided');
            }
            if (!namespace) {
                throw new Error('get metafield failed "namespace" not provided');
            }
            const { data, errors, status } = await this.storefront({
                query: queries_1.queries.getMetafield,
                variables: { country, handle, key, namespace },
            });
            if (status !== 200) {
                throw new Error(`Network request failed with status ${status}`);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            const { product } = data;
            return { error: null, metafield: product?.metafield };
        }
        catch (error) {
            console.error('getMetafield:error', error.message);
            return { error: error.message, metafield: null };
        }
    }
    /**
     * Get a product variant metafield
     * @param {twoDigitCountryCode} country - US, MX..
     * @param {String} handle - the product handle
     * @param {[Object]} selectedOptions - the selectedOptions of the target variant
     * @param {String} key - the metafield key
     * @param {String} namespace - the metafield namespace
     * @returns a metafield key and value
     */
    async getVariantMetafield({ country, handle, key, namespace, selectedOptions } = {
        country: 'US',
        handle: null,
        key: '',
        namespace: '',
        selectedOptions: [], // eg.. [{ Size: '50 cm', ...}]
    }) {
        try {
            if (!handle) {
                throw new Error('get metafield failed "handle" not provided');
            }
            if (!key) {
                throw new Error('get metafield failed "key" not provided');
            }
            if (!namespace) {
                throw new Error('get metafield failed "namespace" not provided');
            }
            if (!selectedOptions) {
                throw new Error('get metafield failed "selectedOptions" not provided');
            }
            if (!Array.isArray(selectedOptions)) {
                throw new Error('get metafield failed "selectedOptions" must be an array');
            }
            const { data, errors, status } = await this.storefront({
                query: queries_1.queries.getVariantMetafield,
                variables: { country, handle, key, namespace, selectedOptions },
            });
            if (status !== 200) {
                throw new Error(`Network request failed with status ${status}`);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            const { product } = data;
            const { selectedVariant } = product;
            return { error: null, metafield: selectedVariant.metafield };
        }
        catch (error) {
            console.error('getVariantMetafield:error', error.message);
            return { error: error.message, metafield: null };
        }
    }
    /**
     * Search shopify admin api for products
     * @param {String} term - product term to search
     * @param {number} limit - optional limit 10 max
     * @returns a list of products
     */
    async searchProducts({ term, limit }) {
        try {
            // eslint-disable-next-line no-undef
            const request = await fetch('/api/shopify/search', {
                method: 'POST',
                body: JSON.stringify({
                    term,
                    limit: limit || 10,
                    types: ['product'],
                }),
            });
            if (!request?.ok) {
                throw new Error('Products search response not ok');
            }
            const { errors, response } = await request.json();
            if (errors?.length) {
                throw new Error(errors[0]);
            }
            return { error: null, results: response.results.products };
        }
        catch (error) {
            console.error('searchProducts:error', error.message);
            return { error: error.message, results: null };
        }
    }
}
exports.ProductClient = ProductClient;
//# sourceMappingURL=client.js.map

/***/ }),

/***/ 69195:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const graphql_request_1 = __webpack_require__(63671);
const Price = (0, graphql_request_1.gql) `
  fragment Price on MoneyV2 {
    amount
    currencyCode
  }
`;
const SellingPlan = (0, graphql_request_1.gql) `
  fragment SellingPlan on SellingPlan {
    id
    name
    description
    priceAdjustments {
      adjustmentValue {
        ... on SellingPlanFixedAmountPriceAdjustment {
          adjustmentAmount {
            amount
            currencyCode
          }
        }
        ... on SellingPlanFixedPriceAdjustment {
          price {
            amount
            currencyCode
          }
        }
        ... on SellingPlanPercentagePriceAdjustment {
          adjustmentPercentage
        }
      }
      orderCount
    }
    recurringDeliveries
    options {
      name
      value
    }
  }
`;
const SellingPlanAllocation = (0, graphql_request_1.gql) `
  fragment SellingPlanAllocation on SellingPlanAllocation {
    priceAdjustments {
      compareAtPrice {
        ...Price
      }
      price {
        ...Price
      }
      perDeliveryPrice {
        ...Price
      }
      unitPrice {
        ...Price
      }
    }
    sellingPlan {
      ...SellingPlan
    }
  }
`;
const SellingPlanGroup = (0, graphql_request_1.gql) `
  fragment SellingPlanGroup on SellingPlanGroup {
    appName
    name
    options {
      name
      values
    }
    sellingPlans(first: 10) {
      edges {
        node {
          ...SellingPlan
        }
      }
    }
  }
`;
const LiveInventoryVariant = (0, graphql_request_1.gql) `
  fragment LiveInventoryVariant on ProductVariant {
    id
    availableForSale
    currentlyNotInStock
    product {
      handle
    }
  }
`;
const LiveInventoryVariantWithQuantity = (0, graphql_request_1.gql) `
  fragment LiveInventoryVariantWithQuantity on ProductVariant {
    id
    quantityAvailable
    currentlyNotInStock
    availableForSale
    product {
      handle
    }
  }
`;
const CountryPriceVariant = (0, graphql_request_1.gql) `
  fragment CountryPriceVariant on ProductVariant {
    id
    product {
      handle
    }
    compareAtPriceV2 {
      ...Price
    }
    priceV2 {
      ...Price
    }
    sellingPlanAllocations(first: 10) {
      edges {
        node {
          ...SellingPlanAllocation
        }
      }
    }
  }
`;
const CountryPriceSelectedVariant = (0, graphql_request_1.gql) `
  fragment CountryPriceSelectedVariant on ProductVariant {
    compareAtPriceV2 {
      ...Price
    }
    id
    priceV2 {
      ...Price
    }
    product {
      handle
      id
    }
    selectedOptions {
      name
      value
    }
    sellingPlanAllocations(first: 10) {
      edges {
        node {
          ...SellingPlanAllocation
        }
      }
    }
    unitPrice {
      ...Price
    }
    unitPriceMeasurement {
      measuredType
      quantityUnit
      quantityValue
    }
  }
`;
const FullVariant = (0, graphql_request_1.gql) `
  fragment FullVariant on ProductVariant {
    availableForSale
    barcode
    id
    compareAtPriceV2 {
      ...Price
    }
    product {
      handle
      id
    }
    sku
    image {
      originalSrc
      altText
      width
      height
    }
    quantityAvailable
    requiresShipping
    weight
    weightUnit
    availableForSale
    sellingPlanAllocations(first: 10) {
      edges {
        node {
          ...SellingPlanAllocation
        }
      }
    }
    selectedOptions {
      name
      value
    }
    unitPrice {
      ...Price
    }
    unitPriceMeasurement {
      measuredType
      quantityUnit
      quantityValue
    }
    priceV2 {
      ...Price
    }
  }
`;
const MinMaxVariantPrice = (0, graphql_request_1.gql) `
  fragment MinMaxVariantPrice on ProductPriceRange {
    maxVariantPrice {
      ...Price
    }
    minVariantPrice {
      ...Price
    }
  }
`;
const Metafield = (0, graphql_request_1.gql) `
  fragment Metafield on Metafield {
    key
    id
    value
    namespace
  }
`;
exports["default"] = {
    LiveInventoryVariant,
    LiveInventoryVariantWithQuantity,
    CountryPriceVariant,
    CountryPriceSelectedVariant,
    Metafield,
    MinMaxVariantPrice,
    Price,
    SellingPlan,
    SellingPlanAllocation,
    SellingPlanGroup,
};
//# sourceMappingURL=fragments.js.map

/***/ }),

/***/ 25431:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ProductClient = void 0;
var client_1 = __webpack_require__(466);
Object.defineProperty(exports, "ProductClient", ({ enumerable: true, get: function () { return client_1.ProductClient; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 68318:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.queries = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable prettier/prettier */
const graphql_request_1 = __webpack_require__(63671);
const fragments_1 = tslib_1.__importDefault(__webpack_require__(69195));
/*
  Queries
*/
const getProductSellingPlans = (0, graphql_request_1.gql) `
  query getProductSellingPlans($country: CountryCode, $handle: String!)
  @inContext(country: $country) {
    product: productByHandle(handle: $handle) {
      id
      handle
      requiresSellingPlan
      sellingPlanGroups(first: 1) {
        edges {
          node {
            ...SellingPlanGroup
          }
        }
      }
    }
  }
  ${fragments_1.default.SellingPlan}
  ${fragments_1.default.SellingPlanGroup}
`;
const getProductVariantSellingPlans = (0, graphql_request_1.gql) `
  query getProductVariantSellingPlans($country: CountryCode, $handle: String!, $selectedOptions: [SelectedOptionInput!]!)
  @inContext(country: $country) {
    product: productByHandle(handle: $handle) {
      id
      handle
      requiresSellingPlan
      sellingPlanGroups(first: 1) {
        edges {
          node {
            ...SellingPlanGroup
          }
        }
      }
      variant: variantBySelectedOptions(selectedOptions: $selectedOptions) {
        ...CountryPriceSelectedVariant
      }
    }
  }
  ${fragments_1.default.Price}
  ${fragments_1.default.SellingPlan}
  ${fragments_1.default.SellingPlanGroup}
  ${fragments_1.default.SellingPlanAllocation}
  ${fragments_1.default.CountryPriceSelectedVariant}
`;
// withQuantity === false
const getInventory = (0, graphql_request_1.gql) `
  query getInventory($country: CountryCode, $handle: String!)
  @inContext(country: $country) {
    product: productByHandle(handle: $handle) {
      id
      handle
      availableForSale
      variants(first: 250) {
        edges {
          node {
            ...LiveInventoryVariant
          }
        }
      }
    }
  }
  ${fragments_1.default.LiveInventoryVariant}
`;
// withQuantity === true (default)
const getInventoryWithQuantity = (0, graphql_request_1.gql) `
  query getInventoryWithQuantity($country: CountryCode, $handle: String!)
  @inContext(country: $country) {
    product: productByHandle(handle: $handle) {
      id
      handle
      availableForSale
      totalInventory
      variants(first: 250) {
        edges {
          node {
            ...LiveInventoryVariantWithQuantity
          }
        }
      }
    }
  }
  ${fragments_1.default.LiveInventoryVariantWithQuantity}
`;
/*
  Temp querying for sellingPlanAllocations as we don't sync them atm
  Shorthand for now as this will be merged with the SSG product
  at productIn hooh
*/
const getLocalizedProduct = (0, graphql_request_1.gql) `
  query getLocalizedProduct($country: CountryCode, $handle: String!)
  @inContext(country: $country) {
    product: productByHandle(handle: $handle) {
      id
      handle
      priceRange {
        ...MinMaxVariantPrice
      }
      compareAtPriceRange {
        ...MinMaxVariantPrice
      }
      requiresSellingPlan
      sellingPlanGroups(first: 1) {
        edges {
          node {
            ...SellingPlanGroup
          }
        }
      }
      variants(first: 250) {
        edges {
          node {
            ...CountryPriceVariant
          }
        }
      }
    }
  }
  ${fragments_1.default.Price}
  ${fragments_1.default.SellingPlan}
  ${fragments_1.default.SellingPlanGroup}
  ${fragments_1.default.MinMaxVariantPrice}
  ${fragments_1.default.SellingPlanAllocation}
  ${fragments_1.default.CountryPriceVariant}
`;
const getLocalizedVariant = (0, graphql_request_1.gql) `
  query getLocalizedVariant($country: CountryCode, $handle: String!, $selectedOptions: [SelectedOptionInput!]!)
  @inContext(country: $country) {
    product: productByHandle(handle: $handle) {
      id
      handle
      priceRange {
        ...MinMaxVariantPrice
      }
      compareAtPriceRange {
        ...MinMaxVariantPrice
      }
      variant: variantBySelectedOptions(selectedOptions: $selectedOptions) {
        ...CountryPriceSelectedVariant
      }
    }
  }
  ${fragments_1.default.Price}
  ${fragments_1.default.MinMaxVariantPrice}
  ${fragments_1.default.SellingPlan}
  ${fragments_1.default.SellingPlanAllocation}
  ${fragments_1.default.CountryPriceSelectedVariant}
`;
const getMetafield = (0, graphql_request_1.gql) `
  query getMetafield($country: CountryCode, $handle: String!, $key: String!, $namespace: String!)
  @inContext(country: $country) {
    product: productByHandle(handle: $handle) {
      handle
      id
      metafield(key: $key, namespace: $namespace) {
        ...Metafield
      }
    }
  }
  ${fragments_1.default.Metafield}
`;
const getVariantMetafield = (0, graphql_request_1.gql) `
  query getVariantMetafield($country: CountryCode, $handle: String!, $key: String!, $namespace: String!, $selectedOptions: [SelectedOptionInput!]!)
  @inContext(country: $country) {
    product: productByHandle(handle: $handle) {
      handle
      id
      selectedVariant: variantBySelectedOptions(selectedOptions: $selectedOptions) {
        id
        metafield(key: $key, namespace: $namespace) {
          ...Metafield
        }
      }
    }
  }
  ${fragments_1.default.Metafield}
`;
exports.queries = {
    getProductSellingPlans,
    getProductVariantSellingPlans,
    getInventory,
    getInventoryWithQuantity,
    getLocalizedProduct,
    getLocalizedVariant,
    getMetafield,
    getVariantMetafield,
};
//# sourceMappingURL=queries.js.map

/***/ }),

/***/ 68335:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(59312);
// new in V2
tslib_1.__exportStar(__webpack_require__(89901), exports);
tslib_1.__exportStar(__webpack_require__(30476), exports);
tslib_1.__exportStar(__webpack_require__(75343), exports);
tslib_1.__exportStar(__webpack_require__(76722), exports);
tslib_1.__exportStar(__webpack_require__(99122), exports);
tslib_1.__exportStar(__webpack_require__(27080), exports);
tslib_1.__exportStar(__webpack_require__(89045), exports);
// Modified in v2
tslib_1.__exportStar(__webpack_require__(53269), exports); // renamed from useProductLiveInventory
// single products
tslib_1.__exportStar(__webpack_require__(79918), exports);
tslib_1.__exportStar(__webpack_require__(12631), exports);
tslib_1.__exportStar(__webpack_require__(42186), exports);
tslib_1.__exportStar(__webpack_require__(2237), exports);
tslib_1.__exportStar(__webpack_require__(56701), exports);
// listings and indexes
tslib_1.__exportStar(__webpack_require__(60869), exports);
tslib_1.__exportStar(__webpack_require__(64433), exports);
tslib_1.__exportStar(__webpack_require__(27220), exports);
tslib_1.__exportStar(__webpack_require__(62701), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 79918:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useProduct = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useProduct = (initial) => (0, store_1.useRecoilValue)(store_1.default.product) || initial;
exports.useProduct = useProduct;
//# sourceMappingURL=useProduct.js.map

/***/ }),

/***/ 42186:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useProductByHandle = void 0;
const tslib_1 = __webpack_require__(59312);
const react_1 = __webpack_require__(27378);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useProductStartFinishErrors_1 = __webpack_require__(42315);
const defaultProps = {
    handle: null,
    version: 'full',
    fetchOnMount: true,
    options: {},
};
const useProductByHandle = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const { finished, setStarted, setFinished, setErrors, ...status } = (0, useProductStartFinishErrors_1.useProductStartFinishErrors)({
        ...props.options,
        id: `product/${props?.handle}/getProductByHandle`,
    });
    let { handle, version } = props;
    const [product, setProduct] = (0, store_1.useRecoilState)(store_1.default.productByHandle({ handle, version }));
    const fetchProductByHandle = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        try {
            setStarted(true);
            if (product) {
                setFinished(true);
                if (callback)
                    callback(product);
                return product;
            }
            // if the user passes a handle via the fetcher prioritize it
            if (data?.handle) {
                handle = data.handle;
            }
            if (data?.version) {
                version = data.version;
            }
            let validationErrors = null;
            switch (true) {
                case !handle: {
                    validationErrors = ['handle not provided'];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                setErrors(validationErrors);
                return null;
            }
            const { error, product: _product } = await snapshot.getPromise(store_1.default.fetchProductByHandle({ handle, version }));
            if (error) {
                setErrors([error]);
            }
            if (!_product || !_product?.id) {
                setErrors([`invalid product response: ${_product}`]);
                return null;
            }
            setFinished(true);
            setProduct(_product);
            if (callback)
                callback(_product);
            return _product;
        }
        catch (error) {
            setErrors([error.message]);
            return null;
        }
    }, [handle, product, version]);
    // fetch json product on mount
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [
            !props.fetchOnMount,
            !handle,
            finished && product, // already have a product
        ];
        if (earlyExitIf.some(Boolean))
            return undefined;
        if (!unMounting) {
            setStarted(true);
        }
        fetchProductByHandle({ handle, version })
            .then((_product) => {
            if (!_product || unMounting)
                return;
            setProduct(_product);
        })
            .catch((error) => {
            console.error('failed to getProductByHandle due to', error.message);
        });
        return () => {
            unMounting = true;
        };
    }, [handle, props.fetchOnMount]);
    return {
        product,
        fetchProductByHandle,
        finished,
        setErrors,
        setFinished,
        setStarted,
        ...status,
    };
};
exports.useProductByHandle = useProductByHandle;
//# sourceMappingURL=useProductByHandle.js.map

/***/ }),

/***/ 62701:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useProductHandles = void 0;
const tslib_1 = __webpack_require__(59312);
const react_1 = __webpack_require__(27378);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useProductStartFinishErrors_1 = __webpack_require__(42315);
const defaultProps = { fetchOnMount: true, options: {} };
const useProductHandles = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const { finished, setStarted, setFinished, setErrors, ...status } = (0, useProductStartFinishErrors_1.useProductStartFinishErrors)({
        ...props.options,
        id: 'product/getProductHandles',
    });
    const [productHandles, setProductHandles] = (0, store_1.useRecoilState)(store_1.default.productHandles);
    const fetchProductHandles = (0, store_1.useRecoilCallback)(({ snapshot }) => async (_, callback) => {
        try {
            setStarted(true);
            // eslint-disable-next-line no-use-before-define
            if (productHandles) {
                setFinished(true);
                if (callback)
                    callback(productHandles);
                return productHandles;
            }
            const { error, productHandles: _productHandles } = await snapshot.getPromise(store_1.default.fetchProductHandles());
            if (error) {
                setErrors([error]);
                return null;
            }
            if (!Array.isArray(_productHandles)) {
                setErrors([`invalid product response: ${_productHandles}`]);
                return null;
            }
            setFinished(true);
            setProductHandles(_productHandles);
            if (callback)
                callback(_productHandles);
            return _productHandles;
        }
        catch (error) {
            setErrors([error.message]);
            return null;
        }
    }, []);
    // fetch json product on mount
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [
            !props.fetchOnMount,
            finished && productHandles?.length, // already have a product
        ];
        if (earlyExitIf.some(Boolean))
            return undefined;
        fetchProductHandles()
            .then((jsonProductHandles) => {
            if (unMounting)
                return;
            // bad response
            if (!Array.isArray(jsonProductHandles)) {
                setErrors(['Invalid product handles response']);
                return;
            }
            setFinished(true);
            // all good update products, which in turns updates
            // the productByHandle family selector
            setProductHandles(jsonProductHandles);
        })
            .catch((error) => {
            if (!unMounting) {
                setErrors([error.message]);
            }
        });
        return () => {
            unMounting = true;
        };
    }, [props.fetchOnMount, productHandles]);
    return {
        productHandles,
        fetchProductHandles,
        finished,
        setErrors,
        setFinished,
        setStarted,
        ...status,
    };
};
exports.useProductHandles = useProductHandles;
//# sourceMappingURL=useProductHandles.js.map

/***/ }),

/***/ 53269:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useProductInventory = void 0;
const tslib_1 = __webpack_require__(59312);
const react_1 = __webpack_require__(27378);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const helpers_1 = __webpack_require__(85542);
const useProductStartFinishErrors_1 = __webpack_require__(42315);
const defaultProps = {
    handle: null,
    fetchOnMount: true,
    withQuantity: true,
    options: {},
};
const useProductInventory = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const { finished, setStarted, setFinished, setErrors, ...status } = (0, useProductStartFinishErrors_1.useProductStartFinishErrors)({
        ...props.options,
        id: `product/${props.handle}/getInventory`,
    });
    const recoilProduct = (0, store_1.useRecoilValue)(store_1.default.product);
    let handle = props.handle || recoilProduct?.handle;
    let { withQuantity } = props;
    const [inventory, setInventory] = (0, store_1.useRecoilState)(store_1.default.productInventory({ handle, withQuantity }));
    const getInventory = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        try {
            setStarted(true);
            if (inventory) {
                setFinished(true);
                if (callback)
                    callback(inventory);
                return inventory;
            }
            // if the user passes a handle via the fetcher prioritize it
            if (data?.handle) {
                handle = data.handle;
            }
            if (data?.withQuantity) {
                withQuantity = data.withQuantity;
            }
            let validationErrors = null;
            switch (true) {
                case !handle: {
                    validationErrors = ['handle not provided'];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                setErrors(validationErrors);
                return null;
            }
            const { error, product } = await snapshot.getPromise(store_1.default.fetchProductInventoryByHandle({ handle, withQuantity }));
            if (error) {
                setErrors([error]);
            }
            if (!product || !product?.id) {
                setErrors([`Invalid product live inventory response: ${product}`]);
                return null;
            }
            // convert variants array to keyed-object
            const _productInventory = {
                ...product,
                variants: product.variants.reduce((_variants, variant) => {
                    return { ..._variants, [(0, helpers_1.decodedId)(variant.id)]: variant };
                }, {}),
            };
            setFinished(true);
            setInventory(_productInventory);
            if (callback)
                callback(_productInventory);
            return _productInventory;
        }
        catch (error) {
            setErrors([error.message]);
            return null;
        }
    }, [handle, inventory, withQuantity]);
    // fetch json product on mount
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [!props.fetchOnMount, !handle, finished && inventory];
        if (earlyExitIf.some(Boolean)) {
            return undefined;
        }
        getInventory({ handle, withQuantity })
            .then((liveInventory) => {
            if (!liveInventory || unMounting)
                return;
            setInventory(liveInventory);
        })
            .catch((error) => {
            console.error('failed to fetchInventoryOnMount due to', error.message);
        });
        return () => {
            unMounting = true;
        };
    }, [handle, props.fetchOnMount, inventory, withQuantity]);
    return {
        inventory,
        getInventory,
        finished,
        setStarted,
        setFinished,
        setErrors,
        ...status,
    };
};
exports.useProductInventory = useProductInventory;
//# sourceMappingURL=useProductInventory.js.map

/***/ }),

/***/ 12631:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useProductInventoryByHandle = void 0;
const useProductInventory_1 = __webpack_require__(53269);
const defaultProps = {
    handle: null,
    withQuantity: true,
    fetchOnMount: true,
    options: {},
};
const useProductInventoryByHandle = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    return (0, useProductInventory_1.useProductInventory)({
        handle: props.handle,
        withQuantity: typeof props.withQuantity === 'undefined' ? true : props.withQuantity,
        fetchOnMount: typeof props.fetchOnMount === 'undefined' ? true : props.fetchOnMount,
    });
};
exports.useProductInventoryByHandle = useProductInventoryByHandle;
//# sourceMappingURL=useProductInventoryByHandle.js.map

/***/ }),

/***/ 2237:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useProductItemByHandle = void 0;
const react_1 = __webpack_require__(27378);
const useProductByHandle_1 = __webpack_require__(42186);
const defaultProps = {
    handle: null,
    fetchOnMount: true,
    options: {},
};
// DEPRECATED - use useProductByHandle instead
const useProductItemByHandle = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const { product: productItem, fetchProductByHandle, ...productByHandleStatus } = (0, useProductByHandle_1.useProductByHandle)(props);
    (0, react_1.useEffect)(() => {
        if (false) {}
    }, []);
    return {
        productItem,
        fetchProductItemByHandle: fetchProductByHandle,
        ...productByHandleStatus,
    };
};
exports.useProductItemByHandle = useProductItemByHandle;
//# sourceMappingURL=useProductItemByHandle.js.map

/***/ }),

/***/ 75343:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useProductMetafield = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable no-undef */
const react_1 = __webpack_require__(27378);
const useProductStartFinishErrors_1 = __webpack_require__(42315);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const defaultProps = {
    handle: null,
    key: '',
    namespace: '',
    fetchOnMount: true,
    options: {},
};
const useProductMetafield = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const { finished, setStarted, setFinished, setErrors, ...status } = (0, useProductStartFinishErrors_1.useProductStartFinishErrors)({
        ...props.options,
        id: `product/${props?.handle}/getProductMetafield`,
    });
    const recoilProduct = (0, store_1.useRecoilValue)(store_1.default.product);
    let handle = props.handle || recoilProduct?.handle;
    let { key, namespace } = props;
    const [metafield, setMetafield] = (0, store_1.useRecoilState)(store_1.default.productMetafield({ handle, key, namespace }));
    const getMetafield = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        try {
            setStarted(true);
            // eslint-disable-next-line no-use-before-define
            if (metafield) {
                setFinished(true);
                if (callback)
                    callback(metafield);
                return metafield;
            }
            // if the user passes a handle via the fetcher prioritize it
            if (data?.handle) {
                handle = data.handle;
            }
            if (data?.key) {
                key = data.key;
            }
            if (data?.namespace) {
                namespace = data.namespace;
            }
            let validationErrors = null;
            switch (true) {
                case !handle: {
                    validationErrors = ['handle not provided'];
                    break;
                }
                case !key: {
                    validationErrors = ['key not provided'];
                    break;
                }
                case !namespace: {
                    validationErrors = ['namespace not provided'];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                setErrors(validationErrors);
                return null;
            }
            // get the metafield via the product client
            const { error, metafield: _metafield } = await snapshot.getPromise(store_1.default.fetchMetafield({ handle, key, namespace }));
            if (error) {
                setErrors([error]);
            }
            if (!_metafield) {
                setErrors([`Invalid product metafield response: ${_metafield}`]);
                return [];
            }
            setFinished(true);
            setMetafield(_metafield);
            if (callback)
                callback(_metafield);
            return _metafield;
        }
        catch (error) {
            setErrors([error.message]);
            return [];
        }
    }, [key, handle, namespace]);
    // fetch on change
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [
            !handle,
            !key,
            !namespace,
            !props.fetchOnMount,
            finished && metafield, // already have metafield
        ];
        if (earlyExitIf.some(Boolean)) {
            return undefined;
        }
        getMetafield({ handle, key, namespace })
            .then((_metafield) => {
            if (unMounting || !_metafield)
                return;
            setMetafield(_metafield);
        })
            .catch((error) => {
            console.error('failed to getMetafield due to', error.message);
        });
        return () => {
            unMounting = true;
        };
    }, [handle, key, namespace, props.fetchOnMount]);
    return {
        metafield,
        getMetafield,
        finished,
        setErrors,
        setFinished,
        setStarted,
        ...status,
    };
};
exports.useProductMetafield = useProductMetafield;
//# sourceMappingURL=useProductMetafield.js.map

/***/ }),

/***/ 56701:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useProductRecommendations = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable no-undef */
const react_1 = __webpack_require__(27378);
const useProductStartFinishErrors_1 = __webpack_require__(42315);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const defaultProps = {
    legacyResourceId: null,
    fetchOnMount: true,
    limit: 6,
    options: {},
};
const useProductRecommendations = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const recoilProduct = (0, store_1.useRecoilValue)(store_1.default.product);
    const product = props.product || recoilProduct;
    let { limit } = props;
    let legacyResourceId = props?.legacyResourceId || product?.legacyResourceId || null;
    const { finished, setStarted, setFinished, setErrors, ...status } = (0, useProductStartFinishErrors_1.useProductStartFinishErrors)({
        ...props.options,
        id: `product/${legacyResourceId}/getRecommendations`,
    });
    const [recommendations, setRecommendations] = (0, store_1.useRecoilState)(store_1.default.productRecommendations({
        productId: legacyResourceId,
        limit,
    }));
    const getRecommendations = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        try {
            setStarted(true);
            // if the user passes a handle via the fetcher prioritize it
            if (data?.legacyResourceId) {
                legacyResourceId = data.legacyResourceId;
            }
            if (data?.limit) {
                limit = data.limit;
            }
            let validationErrors = null;
            switch (true) {
                case !legacyResourceId: {
                    validationErrors = ['legacyResourceId not provided'];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                setErrors(validationErrors);
                return null;
            }
            const { error, recommendations: _recommendations } = await snapshot.getPromise(store_1.default.fetchProductRecommendations({
                productId: legacyResourceId,
                limit: limit || 6,
            }));
            if (error) {
                setErrors([error]);
            }
            if (!_recommendations) {
                setErrors([
                    `Invalid product recommendations response: ${_recommendations}`,
                ]);
                return [];
            }
            setFinished(true);
            setRecommendations(_recommendations);
            if (callback)
                callback(_recommendations);
            return _recommendations;
        }
        catch (error) {
            setErrors([error.message]);
            return [];
        }
    }, [legacyResourceId, limit]);
    // fetch recommendations on mount
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [!props.fetchOnMount, !legacyResourceId, finished];
        if (earlyExitIf.some(Boolean)) {
            return undefined;
        }
        getRecommendations({ legacyResourceId, limit })
            // eslint-disable-next-line no-shadow
            .then((recommendations) => {
            if (!recommendations || unMounting)
                return;
            setRecommendations(recommendations);
        })
            .catch((error) => {
            console.error('failed to fetchRecommendationsOnMount due to', error.message);
        });
        return () => {
            unMounting = true;
        };
    }, [legacyResourceId, props.fetchOnMount, limit]);
    return {
        recommendations,
        getRecommendations,
        finished,
        setErrors,
        setFinished,
        setStarted,
        ...status,
    };
};
exports.useProductRecommendations = useProductRecommendations;
//# sourceMappingURL=useProductRecommendations.js.map

/***/ }),

/***/ 99122:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useProductRecommendationsByHandle = void 0;
const react_1 = __webpack_require__(27378);
const useProductRecommendations_1 = __webpack_require__(56701);
const useProductByHandle_1 = __webpack_require__(42186);
const useProductStartFinishErrors_1 = __webpack_require__(42315);
const defaultProps = {
    handle: null,
    fetchOnMount: true,
    limit: 6,
    options: {},
};
const useProductRecommendationsByHandle = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const [recommendations, setRecommendations] = (0, react_1.useState)([]);
    const { finished, setStarted, setFinished, setErrors, ...status } = (0, useProductStartFinishErrors_1.useProductStartFinishErrors)({
        ...props.options,
        id: `product/${props.handle}/getRecommendationsByHandle`,
    });
    // fetch the product by handle to find the legacyResourceId which
    // shopify recommendation API requires
    const { product, ...productStatus } = (0, useProductByHandle_1.useProductByHandle)({
        handle: props.handle,
    });
    const { getRecommendations } = (0, useProductRecommendations_1.useProductRecommendations)({
        fetchOnMount: false,
    });
    // fetch the recommendations once we have the product legacyResourceId
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        setStarted(true);
        const earlyExitIf = [!props.fetchOnMount, !product?.legacyResourceId];
        if (earlyExitIf.some(Boolean))
            return undefined;
        if (recommendations?.length) {
            setFinished(true);
            return undefined;
        }
        getRecommendations({
            legacyResourceId: product.legacyResourceId,
            limit: props.limit,
        })
            .then((_recommendations) => {
            if (!_recommendations || unMounting)
                return null;
            setFinished(true);
            setRecommendations(_recommendations);
            return _recommendations;
        })
            .catch((error) => {
            setErrors([error.message]);
            console.error('failed to fetchRecommendationsOnMount due to', error.message);
        });
        return () => {
            unMounting = true;
        };
    }, [productStatus?.finished, product?.handle, props.fetchOnMount]);
    return {
        recommendations,
        finished,
        setErrors,
        setFinished,
        setStarted,
        ...status,
    };
};
exports.useProductRecommendationsByHandle = useProductRecommendationsByHandle;
//# sourceMappingURL=useProductRecommendationsByHandle.js.map

/***/ }),

/***/ 27080:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useProductSearch = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable no-undef */
const react_1 = __webpack_require__(27378);
const useProductStartFinishErrors_1 = __webpack_require__(42315);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const defaultProps = {
    term: null,
    fetchOnMount: true,
    limit: 6,
    options: {},
};
const useProductSearch = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const { finished, setStarted, setFinished, setErrors, ...status } = (0, useProductStartFinishErrors_1.useProductStartFinishErrors)({
        ...props.options,
        id: `product/search/${props.term}`,
    });
    let { term, limit } = props;
    const [results, setResults] = (0, store_1.useRecoilState)(store_1.default.productSearchResults(term));
    const getSearchResults = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        try {
            setStarted(true);
            // if the user passes a handle via the fetcher prioritize it
            if (data?.term) {
                term = data.term;
            }
            if (data?.limit) {
                limit = data.limit;
            }
            let validationErrors = null;
            switch (true) {
                case typeof term === 'undefined': {
                    validationErrors = ['term not provided'];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                setErrors(validationErrors);
                return null;
            }
            const { error, results: _results } = await snapshot.getPromise(store_1.default.fetchSearchResults({ term, limit }));
            if (error) {
                setErrors([error]);
            }
            if (!_results) {
                setErrors([`Invalid product search response: ${_results}`]);
                return [];
            }
            setFinished(true);
            setResults(_results);
            if (callback)
                callback(_results);
            return _results;
        }
        catch (error) {
            setErrors([error.message]);
            return [];
        }
    });
    // fetch results on mount
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [!props.fetchOnMount, !term, finished];
        if (earlyExitIf.some(Boolean))
            return undefined;
        getSearchResults({ term, limit })
            // eslint-disable-next-line no-shadow
            .then((_results) => {
            if (unMounting)
                return;
            setResults(_results);
        })
            .catch((error) => {
            console.error('failed to getSearchResults due to', error.message);
        });
        return () => {
            unMounting = true;
        };
    }, [term, props.fetchOnMount, limit]);
    return {
        results,
        getSearchResults,
        finished,
        setErrors,
        setFinished,
        setStarted,
        ...status,
    };
};
exports.useProductSearch = useProductSearch;
//# sourceMappingURL=useProductSearch.js.map

/***/ }),

/***/ 89901:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useProductSellingPlans = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable no-undef */
const react_1 = __webpack_require__(27378);
const useProductStartFinishErrors_1 = __webpack_require__(42315);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const defaultProps = {
    handle: null,
    fetchOnMount: true,
    options: {},
};
const useProductSellingPlans = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const recoilProduct = (0, store_1.useRecoilValue)(store_1.default.product);
    let handle = props.handle || recoilProduct?.handle;
    const { finished, setStarted, setFinished, setErrors, ...status } = (0, useProductStartFinishErrors_1.useProductStartFinishErrors)({
        ...props.options,
        id: `product/${handle}/getSellingPlans`,
    });
    const [sellingPlans, setSellingPlans] = (0, store_1.useRecoilState)(store_1.default.productSellingPlans({ handle }));
    const getSellingPlans = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        try {
            setStarted(true);
            // eslint-disable-next-line no-use-before-define
            if (sellingPlans) {
                setFinished(true);
                if (callback)
                    callback(sellingPlans);
                return sellingPlans;
            }
            // if the user passes a handle via the fetcher prioritize it
            if (data?.handle) {
                handle = data.handle;
            }
            let validationErrors = null;
            switch (true) {
                case !handle: {
                    validationErrors = ['handle not provided'];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                setErrors(validationErrors);
                return null;
            }
            const { error, product: _product } = await snapshot.getPromise(store_1.default.fetchProductSellingPlan({ handle }));
            if (error) {
                setErrors([error]);
                return null;
            }
            if (!_product || !_product?.sellingPlanGroups) {
                setErrors([`Invalid product selling plans response: ${_product}`]);
                return null;
            }
            setFinished(true);
            const { requiresSellingPlan, sellingPlanGroups } = _product;
            const response = { requiresSellingPlan, sellingPlanGroups };
            setSellingPlans(response);
            if (callback)
                callback(response);
            return response;
        }
        catch (error) {
            setErrors([error.message]);
            return null;
        }
    }, [handle]);
    // fetch on handle change
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [
            !handle,
            !props.fetchOnMount,
            finished && sellingPlans, // already have recommendations
        ];
        if (earlyExitIf.some(Boolean))
            return undefined;
        getSellingPlans({ handle })
            .then((data) => {
            if (unMounting || !data)
                return;
            setSellingPlans(data);
        })
            .catch((error) => {
            console.error('failed to fetchProductSellingPlanByHandle due to', error.message);
        });
        return () => {
            unMounting = true;
        };
    }, [handle, props.fetchOnMount]);
    return {
        requiresSellingPlan: typeof sellingPlans?.requiresSellingPlan !== 'undefined'
            ? sellingPlans?.requiresSellingPlan
            : null,
        sellingPlanGroups: sellingPlans?.sellingPlanGroups || null,
        hasSellingPlans: sellingPlans?.sellingPlanGroups?.length > 0,
        getSellingPlans,
        finished,
        setErrors,
        setFinished,
        setStarted,
        ...status,
    };
};
exports.useProductSellingPlans = useProductSellingPlans;
//# sourceMappingURL=useProductSellingPlans.js.map

/***/ }),

/***/ 42315:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useProductStartFinishErrors = void 0;
const tslib_1 = __webpack_require__(59312);
const react_1 = __webpack_require__(27378);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const DEBUG = false;
const useProductStartFinishErrors = (options) => {
    const setCartStarted = (0, store_1.useSetRecoilState)(store_1.default.productStatusStarted('product/all'));
    const setCartFinished = (0, store_1.useSetRecoilState)(store_1.default.productStatusFinished('product/all'));
    const setCartSuccess = (0, store_1.useSetRecoilState)(store_1.default.productStatusSuccess('product/all'));
    const setCartErrors = (0, store_1.useSetRecoilState)(store_1.default.productStatusErrors('product/all'));
    const isCartId = /^cart/.test(options?.id);
    const [started, setStarted] = (0, store_1.useRecoilState)(store_1.default.productStatusStarted(options?.id || ''));
    const [finished, setFinished] = (0, store_1.useRecoilState)(store_1.default.productStatusFinished(options?.id || ''));
    const [success, setSuccess] = (0, store_1.useRecoilState)(store_1.default.productStatusSuccess(options?.id || ''));
    const [errors, setErrors] = (0, store_1.useRecoilState)(store_1.default.productStatusErrors(options?.id || ''));
    const autoReset = (0, react_1.useRef)(options?.autoReset || 0);
    const resetTimer = (0, react_1.useRef)(options?.resetTimer || null);
    // update local hook status
    const reset = (0, react_1.useCallback)(() => {
        if (typeof setErrors === 'undefined')
            return;
        setErrors([]);
        setStarted(false);
        setFinished(false);
        setSuccess(false);
        resetTimer.current = null;
    }, []);
    const updateStateOnErrors = () => {
        let unMounting = false;
        if (errors?.length > 0) {
            if (unMounting)
                return;
            setFinished(true);
            setSuccess(false);
        }
        // eslint-disable-next-line consistent-return
        return () => {
            unMounting = true;
        };
    };
    const updateStateOnFinished = () => {
        let unMounting = false;
        if (finished) {
            if (DEBUG) {
                console.groupCollapsed('status:', options?.id);
                console.log('started', started);
                console.log('errors', errors);
                console.log('finished', finished);
                console.log('success', success);
                console.groupEnd();
            }
            if (unMounting)
                return;
            const withoutErrors = errors?.length === 0;
            setStarted(false);
            setSuccess(withoutErrors);
            if (autoReset?.current) {
                const to = setTimeout(() => {
                    if (unMounting)
                        return;
                    reset();
                    clearTimeout(to);
                }, autoReset.current);
            }
        }
        // eslint-disable-next-line consistent-return
        return () => {
            unMounting = true;
        };
    };
    (0, react_1.useEffect)(() => {
        updateStateOnErrors();
    }, [errors?.length]);
    (0, react_1.useEffect)(() => {
        updateStateOnFinished();
    }, [finished, options?.id]);
    // update global cart status
    (0, react_1.useEffect)(() => {
        if (isCartId)
            setCartErrors(errors);
    }, [errors?.length]);
    (0, react_1.useEffect)(() => {
        if (isCartId)
            setCartStarted(started);
    }, [started]);
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        setCartFinished(finished);
        const to = setTimeout(() => {
            if (unMounting)
                return;
            setCartFinished(false);
            clearTimeout(to);
        }, 1000);
        return () => {
            unMounting = true;
        };
    }, [finished]);
    (0, react_1.useEffect)(() => {
        if (isCartId)
            setCartSuccess(success);
    }, [success]);
    return {
        started,
        setStarted,
        finished,
        setFinished,
        success,
        setSuccess,
        errors,
        setErrors,
        reset,
        resetTimer,
    };
};
exports.useProductStartFinishErrors = useProductStartFinishErrors;
//# sourceMappingURL=useProductStartFinishErrors.js.map

/***/ }),

/***/ 76722:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useProductVariantMetafield = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable no-undef */
const react_1 = __webpack_require__(27378);
const useProductStartFinishErrors_1 = __webpack_require__(42315);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
// TODO: input should be selectedVariant, handle and selectedOptions should be decipher from it
// @see: useProductVariantPriceIn
const defaultProps = {
    handle: null,
    key: '',
    namespace: '',
    selectedOptions: null,
    fetchOnMount: true,
    options: {},
};
const useProductVariantMetafield = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const recoilProduct = (0, store_1.useRecoilValue)(store_1.default.product);
    let handle = props.handle || recoilProduct?.handle;
    let { key, namespace, selectedOptions } = props;
    const { finished, errors, setStarted, setFinished, setErrors, ...status } = (0, useProductStartFinishErrors_1.useProductStartFinishErrors)({
        ...props.options,
        id: `product/${handle}/${props?.key}/getProductVariantMetafield`,
    });
    const [metafield, setMetafield] = (0, store_1.useRecoilState)(store_1.default.productVariantMetafield({ handle, key, namespace, selectedOptions }));
    const getVariantMetafield = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        try {
            setStarted(true);
            // eslint-disable-next-line no-use-before-define
            if (metafield) {
                setFinished(true);
                if (callback)
                    callback(metafield);
                return metafield;
            }
            // if the user passes a handle via the fetcher prioritize it
            if (data?.handle) {
                handle = data.handle;
            }
            if (data?.key) {
                key = data.key;
            }
            if (data?.namespace) {
                namespace = data.namespace;
            }
            if (data?.selectedOptions) {
                selectedOptions = data.selectedOptions;
            }
            let validationErrors = null;
            switch (true) {
                case !handle: {
                    validationErrors = ['handle not provided'];
                    break;
                }
                case !key: {
                    validationErrors = ['key not provided'];
                    break;
                }
                case !namespace: {
                    validationErrors = ['namespace not provided'];
                    break;
                }
                case !selectedOptions: {
                    validationErrors = ['selectedOptions not provided'];
                    break;
                }
                case !Array.isArray(selectedOptions): {
                    // eslint-disable-next-line prettier/prettier
                    validationErrors = [
                        'get metafield failed "selectedOptions" must be an array',
                    ];
                    break;
                }
                case !selectedOptions[0]?.name || !selectedOptions[0]?.value: {
                    // eslint-disable-next-line prettier/prettier
                    validationErrors = [
                        'get metafield failed invalid "selectedOptions". Must be in the shape [{ name: "Size", value: "50 cm" }, ..]',
                    ];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                throw new Error(validationErrors[0]);
            }
            const { error, metafield: _metafield } = await snapshot.getPromise(store_1.default.fetchVariantMetafield({
                handle,
                key,
                namespace,
                selectedOptions,
            }));
            if (error) {
                throw new Error(error);
            }
            setFinished(true);
            setMetafield(_metafield);
            if (callback)
                callback(_metafield);
            return _metafield;
        }
        catch (error) {
            console.error('failed to getVariantMetafield due to', error.message);
            setErrors([error.message]);
            return null;
        }
    }, [key, handle, namespace, selectedOptions]);
    // fetch on change
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [
            !handle,
            !key,
            !namespace,
            !selectedOptions,
            !props.fetchOnMount,
            finished && metafield,
            errors.length, // finished and errors
        ];
        if (earlyExitIf.some(Boolean)) {
            return undefined;
        }
        getVariantMetafield({ handle, key, namespace, selectedOptions })
            .then((_metafield) => {
            if (unMounting)
                return;
            setMetafield(_metafield);
        })
            .catch((error) => {
            console.error('failed to getVariantMetafield due to', error.message);
        });
        return () => {
            unMounting = true;
        };
    }, [handle, key, namespace, props.fetchOnMount, selectedOptions, finished]);
    return {
        metafield,
        getVariantMetafield,
        finished,
        errors,
        setErrors,
        setFinished,
        setStarted,
        ...status,
    };
};
exports.useProductVariantMetafield = useProductVariantMetafield;
//# sourceMappingURL=useProductVariantMetafield.js.map

/***/ }),

/***/ 89045:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useProductVariantSellingPlan = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable no-undef */
const react_1 = __webpack_require__(27378);
const useProductStartFinishErrors_1 = __webpack_require__(42315);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const defaultProps = {
    variant: { product: { handle: null }, selectedOptions: null, id: '' },
    countryCode: null,
    currency: null,
    fetchOnMount: true,
    options: {},
};
const useProductVariantSellingPlan = (passedProps) => {
    const countryFallback = (0, store_1.useRecoilValue)(store_1.default.country)?.isoCode;
    const currencyFallback = (0, store_1.useRecoilValue)(store_1.default.country)?.currency?.isoCode;
    const props = passedProps?.variant
        ? { ...defaultProps, ...passedProps }
        : defaultProps;
    let { handle } = props.variant.product;
    let { selectedOptions } = props.variant;
    let country = props.countryCode || countryFallback;
    let currency = props.currency || currencyFallback;
    const statusId = `product/${handle}/variant/${props.variant.id
        .split('/')
        .pop()}/${country}/${currency}/sellingPlan`;
    const { finished, setStarted, setFinished, setErrors, ...status } = (0, useProductStartFinishErrors_1.useProductStartFinishErrors)({ ...props.options, id: statusId });
    const [variantSub, setVariantSub] = (0, store_1.useRecoilState)(store_1.default.productVariantSellingPlan({
        handle,
        selectedOptions,
        country,
        currency,
    }));
    const getVariantSellingPlans = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        try {
            setStarted(true);
            // if the user passes a handle via the fetcher prioritize it
            if (data?.handle) {
                handle = data.handle;
            }
            if (data?.selectedOptions) {
                selectedOptions = data.selectedOptions;
            }
            if (data?.country) {
                country = data.country;
            }
            if (data?.currency) {
                currency = data.currency;
            }
            let validationErrors = null;
            switch (true) {
                case !handle: {
                    validationErrors = ['handle not provided'];
                    break;
                }
                case !selectedOptions: {
                    validationErrors = ['selectedOptions not provided'];
                    break;
                }
                case !country: {
                    validationErrors = ['country not provided'];
                    break;
                }
                case !currency: {
                    validationErrors = ['currency not provided'];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                setErrors(validationErrors);
                return null;
            }
            const { error, variant } = await snapshot.getPromise(store_1.default.fetchProductVariantSellingPlan({
                handle,
                selectedOptions,
                country,
                currency,
            }));
            if (error) {
                setErrors([error]);
                return null;
            }
            if (!variant) {
                setErrors([
                    `Invalid product variant price in response: ${variant}`,
                ]);
                return null;
            }
            setFinished(true);
            setVariantSub(variant);
            if (callback)
                callback(variant);
            return variant;
        }
        catch (error) {
            setErrors([error.message]);
            return [];
        }
    });
    // fetch on handle change
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [
            !handle,
            !selectedOptions?.length,
            !country,
            !currency,
            !props.fetchOnMount,
            finished && variantSub,
        ];
        if (earlyExitIf.some(Boolean)) {
            return undefined;
        }
        getVariantSellingPlans({ handle })
            .then((data) => {
            if (unMounting)
                return;
            setVariantSub(data);
        })
            .catch((error) => {
            console.error('failed to getVariantSellingPlans due to', error.message);
        });
        return () => {
            unMounting = true;
        };
    }, [
        handle,
        props.variant.id,
        selectedOptions,
        country,
        currency,
        variantSub,
    ]);
    return {
        variantSub: variantSub || null,
        getVariantSellingPlans,
        finished,
        setErrors,
        setFinished,
        setStarted,
        ...status,
    };
};
exports.useProductVariantSellingPlan = useProductVariantSellingPlan;
//# sourceMappingURL=useProductVariantSellingPlan.js.map

/***/ }),

/***/ 30476:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useProductsFromHandles = void 0;
/* eslint-disable consistent-return */
const react_1 = __webpack_require__(27378);
const useProductStartFinishErrors_1 = __webpack_require__(42315);
const defaultProps = {
    handles: null,
    options: {},
};
const useProductsFromHandles = (passedProps = defaultProps) => {
    const props = { ...defaultProps, ...passedProps };
    const { finished, setStarted, setFinished, setErrors, ...status } = (0, useProductStartFinishErrors_1.useProductStartFinishErrors)({
        ...props.options,
        id: `product/${props?.handles?.join('/')}/getProductsFromHandles`,
    });
    const [products, setProducts] = (0, react_1.useState)(null);
    const [productsMap, setProductsMap] = (0, react_1.useState)(null);
    // fetch bundle products from handles
    (0, react_1.useEffect)(() => {
        if (!props.handles?.length) {
            return;
        }
        if (products?.length) {
            setFinished(true);
            return;
        }
        setStarted(true);
        let unMounting;
        const fetchProductFromHandle = (handle) => {
            // if we have already fetched return it, else fetch it
            const product = products?.[handle] || null;
            if (product)
                return product;
            const endpoint = `/json/products/${handle}.json`;
            // eslint-disable-next-line no-undef
            return fetch(endpoint)
                .then((response) => response.json())
                .catch((error) => {
                // console.error('Problem fetching', handle, error.message);
                setErrors([error.message]);
                return { handle };
            });
        };
        const setBundleProducts = (_products) => {
            if (!_products?.length) {
                // didn't fetch
                if (unMounting)
                    return;
                setFinished(true);
                return;
            }
            // have fetched products
            if (unMounting)
                return;
            // we return a products map keyed by handle — not an array
            const mergedProducts = (prevProducts) => {
                const newProducts = _products.reduce((byHandle, product) => {
                    return {
                        ...byHandle,
                        [product.handle]: product,
                    };
                }, {});
                return {
                    ...prevProducts,
                    ...newProducts,
                };
            };
            if (unMounting)
                return;
            setFinished(true);
            setProducts(_products);
            setProductsMap(mergedProducts);
        };
        const bundleProductsPromises = props.handles.map(fetchProductFromHandle);
        Promise.all(bundleProductsPromises).then(setBundleProducts);
        return () => {
            unMounting = true;
        };
    }, [props.handles?.join('|')]);
    return {
        products,
        productsMap,
        finished,
        setErrors,
        setFinished,
        setStarted,
        ...status,
    };
};
exports.useProductsFromHandles = useProductsFromHandles;
//# sourceMappingURL=useProductsFromHandles.js.map

/***/ }),

/***/ 60869:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useProductsIndex = void 0;
const tslib_1 = __webpack_require__(59312);
const react_1 = __webpack_require__(27378);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useProductStartFinishErrors_1 = __webpack_require__(42315);
const defaultProps = {
    fetchOnMount: true,
    options: {},
};
const useProductsIndex = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const { finished, setStarted, setFinished, setErrors, ...status } = (0, useProductStartFinishErrors_1.useProductStartFinishErrors)({
        ...props.options,
        id: 'product/productsIndex',
    });
    const [productsIndex, setProductsIndex] = (0, store_1.useRecoilState)(store_1.default.productsIndex);
    const fetchProductHandles = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        try {
            setStarted(true);
            // eslint-disable-next-line no-use-before-define
            if (productsIndex) {
                setFinished(true);
                if (callback)
                    callback(productsIndex);
                return productsIndex;
            }
            const { error, productsIndex: _productsIndex } = await snapshot.getPromise(store_1.default.fetchProductsIndex());
            if (error) {
                setErrors([error]);
            }
            if (!_productsIndex) {
                setErrors([`invalid product response: ${_productsIndex}`]);
                return null;
            }
            setFinished(true);
            setProductsIndex(_productsIndex);
            if (callback)
                callback(_productsIndex);
            return _productsIndex;
        }
        catch (error) {
            setErrors([error.message]);
            return null;
        }
    }, []);
    // fetch json product on mount
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [
            !props.fetchOnMount,
            finished && productsIndex?.length, // already have a product
        ];
        if (earlyExitIf.some(Boolean))
            return undefined;
        if (!unMounting) {
            setStarted(true);
        }
        fetchProductHandles()
            .then((jsonProductsIndex) => {
            if (unMounting)
                return;
            // bad response
            if (!jsonProductsIndex) {
                setErrors(['Invalid products index response']);
                return;
            }
            setFinished(true);
            // all good update products, which in turns updates
            // the productByHandle family selector
            setProductsIndex(jsonProductsIndex);
        })
            .catch((error) => {
            if (!unMounting) {
                setErrors([error.message]);
            }
        });
        return () => {
            unMounting = true;
        };
    }, [props.fetchOnMount, productsIndex]);
    return {
        productsIndex,
        fetchProductHandles,
        finished,
        setErrors,
        setFinished,
        setStarted,
        ...status,
    };
};
exports.useProductsIndex = useProductsIndex;
//# sourceMappingURL=useProductsIndex.js.map

/***/ }),

/***/ 64433:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useProductsList = void 0;
const tslib_1 = __webpack_require__(59312);
const react_1 = __webpack_require__(27378);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useProductStartFinishErrors_1 = __webpack_require__(42315);
const defaultProps = {
    fetchOnMount: true,
    options: {},
};
const useProductsList = (passedPops) => {
    const props = { ...defaultProps, ...passedPops };
    const { finished, setStarted, setFinished, setErrors, ...status } = (0, useProductStartFinishErrors_1.useProductStartFinishErrors)({
        ...props.options,
        id: 'product/productsList',
    });
    const [productsList, setProductsList] = (0, store_1.useRecoilState)(store_1.default.productsList);
    const fetchProductsList = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        try {
            setStarted(true);
            // eslint-disable-next-line no-use-before-define
            if (productsList) {
                setFinished(true);
                if (callback)
                    callback(productsList);
                return productsList;
            }
            const { error, productsList: _productsList } = await snapshot.getPromise(store_1.default.fetchProductsList());
            if (error) {
                setErrors([error]);
            }
            if (!_productsList || !Array.isArray(_productsList)) {
                setErrors([`invalid product list response: ${_productsList}`]);
                return null;
            }
            setFinished(true);
            setProductsList(_productsList);
            if (callback)
                callback(_productsList);
            return _productsList;
        }
        catch (error) {
            setErrors([error.message]);
            return null;
        }
    }, []);
    // fetch json product on mount
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [
            !props.fetchOnMount,
            finished && productsList?.length, // already have a product
        ];
        if (earlyExitIf.some(Boolean))
            return undefined;
        fetchProductsList()
            .then((jsonProductsList) => {
            if (unMounting)
                return;
            // bad response
            if (!Array.isArray(jsonProductsList)) {
                setErrors(['Invalid products index response']);
                return;
            }
            setFinished(true);
            // all good update products, which in turns updates
            // the productByHandle family selector
            setProductsList(jsonProductsList);
        })
            .catch((error) => {
            if (!unMounting) {
                setErrors([error.message]);
            }
        });
        return () => {
            unMounting = true;
        };
    }, [props.fetchOnMount, productsList]);
    return {
        productsList,
        fetchProductsList,
        finished,
        setErrors,
        setFinished,
        setStarted,
        ...status,
    };
};
exports.useProductsList = useProductsList;
//# sourceMappingURL=useProductsList.js.map

/***/ }),

/***/ 27220:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useProductsUniq = void 0;
const tslib_1 = __webpack_require__(59312);
const react_1 = __webpack_require__(27378);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useProductStartFinishErrors_1 = __webpack_require__(42315);
const defaultProps = { fetchOnMount: true, options: {} };
const useProductsUniq = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const { finished, setStarted, setFinished, setErrors, ...status } = (0, useProductStartFinishErrors_1.useProductStartFinishErrors)({
        ...props.options,
        id: 'product/productsUniq',
    });
    const [productsUniq, setProductsUniq] = (0, store_1.useRecoilState)(store_1.default.productsUniq);
    const fetchProductsUniq = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        try {
            setStarted(true);
            // eslint-disable-next-line no-use-before-define
            if (productsUniq) {
                setFinished(true);
                if (callback)
                    callback(productsUniq);
                return productsUniq;
            }
            const { error, productsUniq: _productsUniq } = await snapshot.getPromise(store_1.default.fetchProductsUniq());
            if (error) {
                setErrors([error]);
            }
            if (!_productsUniq) {
                setErrors([`invalid product uniq response: ${_productsUniq}`]);
                return null;
            }
            setFinished(true);
            setProductsUniq(_productsUniq);
            if (callback)
                callback(_productsUniq);
            return _productsUniq;
        }
        catch (error) {
            setErrors([error.message]);
            return null;
        }
    }, []);
    // fetch json product on mount
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [
            !props.fetchOnMount,
            finished && productsUniq, // already have a product
        ];
        if (earlyExitIf.some(Boolean))
            return undefined;
        if (!unMounting) {
            setStarted(true);
        }
        fetchProductsUniq()
            .then((jsonProductsUniq) => {
            if (unMounting)
                return;
            // bad response
            if (!jsonProductsUniq) {
                setErrors(['Invalid products uniq response']);
                return;
            }
            setFinished(true);
            // all good update products, which in turns updates
            // the productByHandle family selector
            setProductsUniq(jsonProductsUniq);
        })
            .catch((error) => {
            if (!unMounting) {
                setErrors([error.message]);
            }
        });
        return () => {
            unMounting = true;
        };
    }, [props.fetchOnMount, productsUniq]);
    return {
        productsUniq,
        fetchProductsUniq,
        finished,
        setErrors,
        setFinished,
        setStarted,
        ...status,
    };
};
exports.useProductsUniq = useProductsUniq;
//# sourceMappingURL=useProductsUniq.js.map

/***/ }),

/***/ 21857:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.productStore = void 0;
var product_1 = __webpack_require__(7099);
Object.defineProperty(exports, "productStore", ({ enumerable: true, get: function () { return product_1.productStore; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 7099:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.productStore = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable max-lines */
const recoil_1 = __webpack_require__(69853);
const effects_1 = tslib_1.__importDefault(__webpack_require__(49025));
const store_1 = __webpack_require__(20437);
const client_1 = __webpack_require__(25431);
const client = new client_1.ProductClient({
    apiToken: "7b8296bfc85c0cb6fbc85bd5fa81686f",
    apiVersion: '2024-10',
    domain: "kryo-gear.myshopify.com",
});
/**
  Product State
*/
const product = (0, recoil_1.atom)({
    key: 'product/product',
    default: null,
    effects: [
        // effects.logStateChange('product'),
        effects_1.default.onChange({
            key: 'product',
            topic: 'PRODUCT_UPDATE',
            actions: ['publishBusEvent'],
        }),
    ],
});
const productByHandle = (0, recoil_1.atomFamily)({
    key: 'product/byHandle',
    default: null,
});
const productInventory = (0, recoil_1.atomFamily)({
    key: 'product/inventory',
    default: null,
});
const productSellingPlans = (0, recoil_1.atomFamily)({
    key: 'product/sellingPlans',
    default: null,
});
// market/country price
const productPriceIn = (0, recoil_1.atomFamily)({
    key: 'product/priceIn',
    default: null,
});
const productVariantPriceIn = (0, recoil_1.atomFamily)({
    key: 'product/variantPriceIn',
    default: null,
});
const productVariantSellingPlan = (0, recoil_1.atomFamily)({
    key: 'product/variantSellingPlan',
    default: null,
});
const productRecommendations = (0, recoil_1.atomFamily)({
    key: 'product/recommendations',
    default: [],
});
const productSearchResults = (0, recoil_1.atomFamily)({
    key: 'product/searchResults',
    default: [],
});
const productMetafield = (0, recoil_1.atomFamily)({
    key: 'product/metafield',
    default: null,
});
const productVariantMetafield = (0, recoil_1.atomFamily)({
    key: 'product/variantMetafield',
    default: null,
});
const productsList = (0, recoil_1.atom)({
    key: 'product/productsList',
    default: null,
});
const productsUniq = (0, recoil_1.atom)({
    key: 'product/productsUniq',
    default: null, // { types: [], vendors: [], options: [] }
});
// products json fuse index
const productsIndex = (0, recoil_1.atom)({
    key: 'product/productsIndex',
    default: null,
});
const productHandles = (0, recoil_1.atom)({
    key: 'product/productHandles',
    default: null, // []
});
/* Status */
const productStatusStarted = (0, recoil_1.atomFamily)({
    key: 'product/statusStarted',
    default: false,
});
const productStatusFinished = (0, recoil_1.atomFamily)({
    key: 'product/statusFinished',
    default: false,
});
const productStatusSuccess = (0, recoil_1.atomFamily)({
    key: 'product/statusSuccess',
    default: false,
});
const productStatusErrors = (0, recoil_1.atomFamily)({
    key: 'product/statusErrors',
    default: [],
});
/*
  Async fetchers
*/
const fetchProductByHandle = (0, recoil_1.selectorFamily)({
    key: 'product/fetchProductByHandle',
    get: ({ handle, version }) => async () => {
        return client.getByHandle({
            handle,
            version,
        });
    },
});
const fetchProductInventoryByHandle = (0, recoil_1.selectorFamily)({
    key: 'product/fetchProductInventoryByHandle',
    get: (data) => async ({ get }) => {
        const country = get(store_1.shopStore.country);
        const passedCountryCode = data?.country?.isoCode || data?.country;
        const _country = passedCountryCode || country?.isoCode || 'US';
        return client.getInventory({
            ...data,
            country: _country,
        });
    },
});
const fetchProductSellingPlan = (0, recoil_1.selectorFamily)({
    key: 'product/fetchProductSellingPlan',
    get: (data) => async ({ get }) => {
        const country = get(store_1.shopStore.country);
        const passedCountryCode = data?.country?.isoCode || data?.country;
        const _country = passedCountryCode || country?.isoCode || 'US';
        return client.getSellingPlans({
            ...data,
            country: _country,
        });
    },
});
const fetchProductVariantSellingPlan = (0, recoil_1.selectorFamily)({
    key: 'product/fetchProductVariantSellingPlan',
    get: (data) => async ({ get }) => {
        const country = get(store_1.shopStore.country);
        const passedCountryCode = data?.country?.isoCode || data?.country;
        const _country = passedCountryCode || country?.isoCode || 'US';
        return client.getVariantSellingPlans({
            ...data,
            country: _country,
            locale: country?.locale,
        });
    },
});
const fetchProductHandles = (0, recoil_1.selectorFamily)({
    key: 'product/fetchProductHandles',
    get: () => async () => {
        return client.getHandles();
    },
});
const fetchProductsList = (0, recoil_1.selectorFamily)({
    key: 'product/fetchProductsList',
    get: () => async () => {
        return client.getList();
    },
});
const fetchProductsUniq = (0, recoil_1.selectorFamily)({
    key: 'product/fetchProductsUniq',
    get: () => async () => {
        return client.getUniq();
    },
});
const fetchProductsIndex = (0, recoil_1.selectorFamily)({
    key: 'product/fetchProductsIndex',
    get: () => async () => {
        return client.getIndex();
    },
});
const fetchProductRecommendations = (0, recoil_1.selectorFamily)({
    key: 'product/fetchProductRecommendations',
    get: ({ productId, limit }) => async () => {
        return client.getRecommendations({
            productId,
            limit,
        });
    },
});
const fetchSearchResults = (0, recoil_1.selectorFamily)({
    key: 'product/fetchSearchResults',
    get: ({ term, limit }) => async () => {
        return client.searchProducts({
            term,
            limit,
        });
    },
});
const fetchMetafield = (0, recoil_1.selectorFamily)({
    key: 'product/fetchMetafield',
    get: ({ handle, key, namespace }) => async () => {
        return client.getMetafield({
            handle,
            key,
            namespace,
        });
    },
});
const fetchVariantMetafield = (0, recoil_1.selectorFamily)({
    key: 'product/fetchVariantMetafield',
    get: ({ handle, key, namespace, selectedOptions }) => async () => {
        return client.getVariantMetafield({
            handle,
            key,
            namespace,
            selectedOptions,
        });
    },
});
exports.productStore = {
    // actual state - atoms
    product,
    productPriceIn,
    productVariantPriceIn,
    productVariantSellingPlan,
    productSellingPlans,
    productInventory,
    productByHandle,
    productMetafield,
    productVariantMetafield,
    productRecommendations,
    productSearchResults,
    productsIndex,
    productsList,
    productsUniq,
    productHandles,
    // status
    productStatusStarted,
    productStatusFinished,
    productStatusSuccess,
    productStatusErrors,
    // async fetches
    fetchProductByHandle,
    fetchProductSellingPlan,
    fetchProductVariantSellingPlan,
    fetchProductInventoryByHandle,
    fetchProductHandles,
    fetchProductsList,
    fetchProductsUniq,
    fetchProductsIndex,
    fetchProductRecommendations,
    fetchSearchResults,
    fetchMetafield,
    fetchVariantMetafield,
};
//# sourceMappingURL=product.js.map

/***/ }),

/***/ 80972:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(59312);
tslib_1.__exportStar(__webpack_require__(72962), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 72962:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.withRouter = exports.useRouter = exports.Router = void 0;
const tslib_1 = __webpack_require__(59312);
const router_1 = tslib_1.__importStar(__webpack_require__(86677));
exports.Router = router_1.default;
exports.useRouter = router_1.useRouter;
exports.withRouter = router_1.withRouter;
//# sourceMappingURL=useRouter.js.map

/***/ }),

/***/ 5852:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(59312);
tslib_1.__exportStar(__webpack_require__(82842), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 82842:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useSettings = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useSettings = () => {
    return (0, store_1.useRecoilValue)(store_1.default.storefrontSettings);
};
exports.useSettings = useSettings;
//# sourceMappingURL=useSettings.js.map

/***/ }),

/***/ 98584:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.settingsStore = void 0;
var settings_1 = __webpack_require__(21782);
Object.defineProperty(exports, "settingsStore", ({ enumerable: true, get: function () { return settings_1.settingsStore; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 21782:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.settingsStore = void 0;
const recoil_1 = __webpack_require__(69853);
const storefrontSettings = (0, recoil_1.atom)({
    key: 'storefront/settings',
    default: null,
    effects: [],
});
exports.settingsStore = {
    // actual state - atoms
    storefrontSettings,
};
//# sourceMappingURL=settings.js.map

/***/ }),

/***/ 95587:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ShopClient = void 0;
const tslib_1 = __webpack_require__(59312);
const graphql_request_1 = __webpack_require__(63671);
const humanize_graphql_response_1 = tslib_1.__importDefault(__webpack_require__(27207));
const queries_1 = __webpack_require__(15982);
class ShopClient {
    constructor({ apiToken, apiVersion, domain, debug }) {
        this.apiToken = apiToken;
        this.apiVersion = apiVersion;
        this.domain = domain;
        this.endpoint = '';
        this.options = {};
        this.debug = debug || false;
        this.client = this.init();
    }
    init() {
        this.endpoint = `https://${this.domain}/api/${this.apiVersion}/graphql.json`;
        // client
        this.options = {
            method: 'POST',
            mode: 'cors',
            headers: {
                'X-Shopify-Storefront-Access-Token': this.apiToken,
                'Content-Type': 'application/json; charset=utf-8',
            },
        };
        return new graphql_request_1.GraphQLClient(this.endpoint, this.options);
    }
    /**
     * Customer queries client
     * @param {gqlQuery} query
     * @param {object} variables
     * @returns
     */
    async query({ query, variables }) {
        if (this.debug) {
            console.log('ShopClient:', query, variables);
        }
        return this.client.rawRequest(query, variables);
    }
    /**
     * Customer mutation client
     * @param {gqlMutation} mutation
     * @param {object} variables
     * @returns
     */
    async mutate({ mutation, variables }) {
        if (this.debug) {
            console.log('ShopClient:', mutation, variables);
        }
        return this.client.rawRequest(mutation, variables);
    }
    /**
     * Query the storefront shop object data
     * @param {String} country
     */
    async getShop() {
        try {
            const request = await this.query({
                query: queries_1.queries.shop,
                variables: {},
            });
            const shop = request?.data?.shop;
            return { error: null, data: (0, humanize_graphql_response_1.default)(shop) };
        }
        catch (error) {
            return { error: error.message, data: null };
        }
    }
    /**
     * Query all countries locales
     * @param {String} country
     */
    async getLocales(props) {
        try {
            const { countryCode } = props;
            const request = await this.query({
                query: queries_1.queries.localization,
                variables: { country: countryCode },
            });
            const localization = request?.data?.localization;
            const countryCodes = localization.availableCountries.map((_country) => _country?.isoCode);
            // eslint-disable-next-line no-undef
            const localesRequest = await fetch('/api/shopify/locales', {
                method: 'POST',
                body: JSON.stringify({ countryCodes }),
            });
            const { response } = await localesRequest.json();
            if (!response) {
                throw new Error('getLocales: shopify locales response not ok');
            }
            const { locales } = response;
            return { error: null, data: locales };
        }
        catch (error) {
            console.error('getLocales:error', error.message);
            return { error: error.message, data: null };
        }
    }
    /**
     * Query available countries and currencies
     * @param {String} country
     * @see https://shopify.dev/custom-storefronts/products/international-pricing#query-available-countries-and-currencies
     */
    async getCountries(props) {
        try {
            if (!props?.countryCode) {
                throw new Error('getCountries: missing primary countryCode');
            }
            if (!props?.currencyCode) {
                throw new Error('getCountries: missing primary currencyCode');
            }
            if (!props?.currencies) {
                throw new Error('getCountries: missing currencies');
            }
            const { countryCode } = props;
            const request = await this.query({
                query: queries_1.queries.localization,
                variables: { country: countryCode },
            });
            if (request.status !== 200) {
                throw new Error(`getCountries: response error ${request.status}`);
            }
            const data = (0, humanize_graphql_response_1.default)(request?.data);
            const localization = data?.localization; // { availableCountries: [...], country: {..} }
            // fetch local for each available country and add it to each item
            const { data: locales } = await this.getLocales({ countryCode });
            const countryWithLocale = (_country) => {
                const locale = locales[_country?.isoCode];
                // if we don't a full locale for this country filter it out. Kosovo and Netherland Antilles
                // currently missing from country-locale-map@^1.8.0. I've requested the developer to add them.
                // @see: https://github.com/atnmorrison/country-locale-map/issues/27
                if (!locale)
                    return null;
                return { ..._country, locale: locales[_country?.isoCode] };
            };
            // default country
            localization.country.locale = locales[localization.country?.isoCode];
            // all available countries in the store (not the same as enabled markets)
            localization.availableCountries = localization.availableCountries
                .map(countryWithLocale)
                .filter(Boolean);
            /*
              Each currency represents an enabled market,
              if only one is set then markets are disabled
            */
            if (props.currencies?.length === 1) {
                localization.activeCountries = [localization.country];
            }
            else {
                // multiple markets enabled, filter
                localization.activeCountries = localization.availableCountries.filter((country) => {
                    return props.currencies.includes(country.locale.currency);
                });
            }
            return {
                error: null,
                data: localization,
            };
        }
        catch (error) {
            return { error: error.message, data: null };
        }
    }
}
exports.ShopClient = ShopClient;
//# sourceMappingURL=client.js.map

/***/ }),

/***/ 90465:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const graphql_request_1 = __webpack_require__(63671);
const Country = (0, graphql_request_1.gql) `
  fragment Country on Country {
    currency {
      isoCode
      name
      symbol
    }
    isoCode
    name
    unitSystem
  }
`;
const Policy = (0, graphql_request_1.gql) `
  fragment Policy on ShopPolicy {
    handle
    id
    title
    body
    __typename
  }
`;
exports["default"] = {
    Country,
    Policy,
};
//# sourceMappingURL=fragments.js.map

/***/ }),

/***/ 76574:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ShopClient = void 0;
var client_1 = __webpack_require__(95587);
Object.defineProperty(exports, "ShopClient", ({ enumerable: true, get: function () { return client_1.ShopClient; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 15982:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.queries = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable prettier/prettier */
const graphql_request_1 = __webpack_require__(63671);
const fragments_1 = tslib_1.__importDefault(__webpack_require__(90465));
/*
  Queries
*/
const shop = (0, graphql_request_1.gql) `
  query {
    shop {
      description
      moneyFormat
      name
      paymentSettings {
        acceptedCardBrands
        cardVaultUrl
        countryCode
        currencyCode
        enabledPresentmentCurrencies
        supportedDigitalWallets
        shopifyPaymentsAccountId
      }
      primaryDomain {
        host
        sslEnabled
        url
      }
      shipsToCountries
    }
  }
`;
const localization = (0, graphql_request_1.gql) `
  query ($country: CountryCode) @inContext(country: $country) {
    shop {
      paymentSettings {
        enabledCurrencies: enabledPresentmentCurrencies
      }
    }
    localization {
      availableCountries {
        ...Country
      }
      country {
        ...Country
      }
    }
  }
  ${fragments_1.default.Country}
`;
exports.queries = {
    localization,
    shop,
};
//# sourceMappingURL=queries.js.map

/***/ }),

/***/ 42022:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useLocale = exports.useAvailableCountries = exports.useCountries = exports.useCountry = exports.useCurrencies = exports.useCurrency = exports.useShop = exports.useStorefrontInit = exports.useCountriesInit = exports.useShopInit = void 0;
var useShopInit_1 = __webpack_require__(33840);
Object.defineProperty(exports, "useShopInit", ({ enumerable: true, get: function () { return useShopInit_1.useShopInit; } }));
var useCountriesInit_1 = __webpack_require__(77344);
Object.defineProperty(exports, "useCountriesInit", ({ enumerable: true, get: function () { return useCountriesInit_1.useCountriesInit; } }));
// eslint-disable-next-line import/no-cycle
var useStorefrontInit_1 = __webpack_require__(28123); // new on v2
Object.defineProperty(exports, "useStorefrontInit", ({ enumerable: true, get: function () { return useStorefrontInit_1.useStorefrontInit; } }));
// getters
var useShop_1 = __webpack_require__(69056);
Object.defineProperty(exports, "useShop", ({ enumerable: true, get: function () { return useShop_1.useShop; } }));
var useCurrency_1 = __webpack_require__(28422);
Object.defineProperty(exports, "useCurrency", ({ enumerable: true, get: function () { return useCurrency_1.useCurrency; } }));
var useCurrencies_1 = __webpack_require__(371);
Object.defineProperty(exports, "useCurrencies", ({ enumerable: true, get: function () { return useCurrencies_1.useCurrencies; } }));
var useCountry_1 = __webpack_require__(85030);
Object.defineProperty(exports, "useCountry", ({ enumerable: true, get: function () { return useCountry_1.useCountry; } }));
var useCountries_1 = __webpack_require__(12411);
Object.defineProperty(exports, "useCountries", ({ enumerable: true, get: function () { return useCountries_1.useCountries; } }));
var useAvailableCountries_1 = __webpack_require__(17310);
Object.defineProperty(exports, "useAvailableCountries", ({ enumerable: true, get: function () { return useAvailableCountries_1.useAvailableCountries; } }));
var useLocale_1 = __webpack_require__(96376);
Object.defineProperty(exports, "useLocale", ({ enumerable: true, get: function () { return useLocale_1.useLocale; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 17310:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useAvailableCountries = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const helpers_1 = __webpack_require__(85542);
const useAvailableCountries = () => {
    const isMounted = (0, helpers_1.useMounted)();
    const availableCountries = (0, store_1.useRecoilValue)(store_1.default.availableCountries);
    return isMounted ? availableCountries : null;
};
exports.useAvailableCountries = useAvailableCountries;
//# sourceMappingURL=useAvailableCountries.js.map

/***/ }),

/***/ 12411:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCountries = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const helpers_1 = __webpack_require__(85542);
const useCountries = () => {
    const isMounted = (0, helpers_1.useMounted)();
    const countries = (0, store_1.useRecoilValue)(store_1.default.countries);
    return isMounted ? countries : null;
};
exports.useCountries = useCountries;
//# sourceMappingURL=useCountries.js.map

/***/ }),

/***/ 77344:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCountriesInit = void 0;
const tslib_1 = __webpack_require__(59312);
const react_1 = __webpack_require__(27378);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useShopStartFinishErrors_1 = __webpack_require__(81108);
const defaultProps = {
    fetchOnMount: false,
    options: {},
};
const useCountriesInit = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const [country, setCountry] = (0, store_1.useRecoilState)(store_1.default.country);
    const [countries, setCountries] = (0, store_1.useRecoilState)(store_1.default.countries);
    const [availableCountries, setAvailableCountries] = (0, store_1.useRecoilState)(store_1.default.availableCountries);
    const { setStarted, setFinished, setErrors, finished, ...status } = (0, useShopStartFinishErrors_1.useShopStartFinishErrors)({
        ...props.options,
        id: `shop/countries/init`,
    });
    const getCountries = (0, store_1.useRecoilCallback)(({ snapshot }) => async (_, callback) => {
        setStarted(true);
        const release = snapshot.retain();
        try {
            // can pass accessToken or will use the on in store
            const { error, data: response } = await snapshot.getPromise(store_1.default.fetchCountries());
            if (error) {
                setErrors([error]);
                return null;
            }
            if (!response?.country) {
                setErrors(['countries init response missing country data']);
                return null;
            }
            if (!response?.country?.name) {
                setErrors(['countries init invalid response']);
                return null;
            }
            const { country: _country, availableCountries: _availableCountries, activeCountries: _countries, } = response;
            setFinished(true);
            setAvailableCountries(_availableCountries);
            // mark the primary market as default
            const primaryCountry = { ..._country, isPrimary: true };
            const countriesWithPrimary = _countries.map((__country) => {
                if (__country?.isoCode === primaryCountry?.isoCode) {
                    return primaryCountry;
                }
                return __country;
            });
            // if we don't have a persisted country we set the shop default as default
            if (!country) {
                setCountry(primaryCountry);
            }
            setCountries(countriesWithPrimary);
            const data = {
                country: primaryCountry,
                countries: countriesWithPrimary,
                availableCountries: _availableCountries,
            };
            if (callback)
                callback(data);
            return data;
        }
        catch (error) {
            console.error(`getCountries:error ${error.message}`);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    // fetch on mount
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [!props.fetchOnMount, finished];
        if (earlyExitIf.some(Boolean)) {
            return undefined;
        }
        getCountries()
            // eslint-disable-next-line no-shadow
            .then((data) => {
            if (unMounting || !data)
                return null;
            if (!country) {
                setCountry(data.country);
            }
            setCountries(data.countries);
            return data;
        })
            .catch((error) => {
            console.error('failed to getCountries due to', error.message);
        });
        return () => {
            unMounting = true;
        };
    }, [props.fetchOnMount, country, finished]);
    return {
        country,
        countries,
        availableCountries,
        getCountries,
        finished,
        setStarted,
        setFinished,
        setErrors,
        ...status,
    };
};
exports.useCountriesInit = useCountriesInit;
//# sourceMappingURL=useCountriesInit.js.map

/***/ }),

/***/ 85030:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCountry = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const helpers_1 = __webpack_require__(85542);
const useShopStartFinishErrors_1 = __webpack_require__(81108);
const useCartUpdateBuyerIdentity_1 = __webpack_require__(44717);
const useCountry = (options) => {
    const isMounted = (0, helpers_1.useMounted)();
    const country = (0, store_1.useRecoilValue)(store_1.default.country);
    const { setStarted, setFinished, setErrors, ...status } = (0, useShopStartFinishErrors_1.useShopStartFinishErrors)({ ...options, id: 'shop/updatedCountry' });
    const { cartUpdateBuyerIdentity } = (0, useCartUpdateBuyerIdentity_1.useCartUpdateBuyerIdentity)();
    const updateCountry = (0, store_1.useRecoilCallback)(({ snapshot, set }) => async (data, callback) => {
        const release = snapshot.retain();
        let validationErrors = null;
        switch (true) {
            case !data || !data?.country: {
                validationErrors = ['country data not provided'];
                break;
            }
            case !data?.country?.isoCode: {
                validationErrors = ['country must include an isoCode'];
                break;
            }
            default:
                break;
        }
        if (validationErrors?.length) {
            setErrors(validationErrors);
            return null;
        }
        try {
            setStarted(true);
            // update the cart locale
            const updatedCart = await cartUpdateBuyerIdentity({
                country: data.country?.isoCode,
                buyerIdentity: {
                    countryCode: data.country?.isoCode,
                },
            });
            if (!updatedCart?.id) {
                setErrors(['Failed to update cart buyer identity countryCode']);
                return null;
            }
            // update the shop state
            set(store_1.default.country, data.country);
            setFinished(true);
            if (callback)
                callback(data.country);
            return data.country;
        }
        catch (error) {
            console.error('failed to update country to due to', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    return {
        country: isMounted ? country : null,
        updateCountry,
        setStarted,
        setErrors,
        setFinished,
        ...status,
    };
};
exports.useCountry = useCountry;
//# sourceMappingURL=useCountry.js.map

/***/ }),

/***/ 371:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCurrencies = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const helpers_1 = __webpack_require__(85542);
const useCurrencies = () => {
    const isMounted = (0, helpers_1.useMounted)();
    const currencies = (0, store_1.useRecoilValue)(store_1.default.currencies$);
    return isMounted ? currencies : null;
};
exports.useCurrencies = useCurrencies;
//# sourceMappingURL=useCurrencies.js.map

/***/ }),

/***/ 28422:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCurrency = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const helpers_1 = __webpack_require__(85542);
const useCurrency = () => {
    const isMounted = (0, helpers_1.useMounted)();
    const country = (0, store_1.useRecoilValue)(store_1.default.country);
    return isMounted ? country?.locale?.currency || null : null;
};
exports.useCurrency = useCurrency;
//# sourceMappingURL=useCurrency.js.map

/***/ }),

/***/ 96376:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useLocale = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const helpers_1 = __webpack_require__(85542);
const useLocale = () => {
    const isMounted = (0, helpers_1.useMounted)();
    const country = (0, store_1.useRecoilValue)(store_1.default.country);
    return isMounted ? country?.locale || null : null;
};
exports.useLocale = useLocale;
//# sourceMappingURL=useLocale.js.map

/***/ }),

/***/ 69056:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useShop = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const helpers_1 = __webpack_require__(85542);
const useShop = () => {
    const isMounted = (0, helpers_1.useMounted)();
    const shop = (0, store_1.useRecoilValue)(store_1.default.shop);
    return isMounted ? shop : null;
};
exports.useShop = useShop;
//# sourceMappingURL=useShop.js.map

/***/ }),

/***/ 33840:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useShopInit = void 0;
const tslib_1 = __webpack_require__(59312);
const react_1 = __webpack_require__(27378);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useShopStartFinishErrors_1 = __webpack_require__(81108);
const defaultProps = {
    fetchOnMount: true,
    options: {},
};
const useShopInit = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const [shop, setShop] = (0, store_1.useRecoilState)(store_1.default.shop);
    const [, setShopInit] = (0, store_1.useRecoilState)(store_1.default.shopInit);
    const { setStarted, setFinished, setErrors, finished, ...status } = (0, useShopStartFinishErrors_1.useShopStartFinishErrors)({
        ...props.options,
        id: `shop/init`,
    });
    const getShop = (0, store_1.useRecoilCallback)(({ snapshot }) => async (_, callback) => {
        setStarted(true);
        const release = snapshot.retain();
        try {
            // can pass accessToken or will use the on in store
            const { error, data: _shop } = await snapshot.getPromise(store_1.default.fetchShop());
            if (error) {
                setErrors([error]);
                return null;
            }
            if (!_shop) {
                setErrors(['shop get response missing shop data']);
                return null;
            }
            setFinished(true);
            setShopInit(true);
            setShop(_shop);
            if (callback)
                callback(_shop);
            return _shop;
        }
        catch (error) {
            console.error(`getShop:error ${error.message}`);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    // fetch on mount
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [!props.fetchOnMount, shop];
        if (earlyExitIf.some(Boolean)) {
            return undefined;
        }
        getShop()
            // eslint-disable-next-line no-shadow
            .then((shop) => {
            if (unMounting)
                return;
            setShop(shop);
        })
            .catch((error) => {
            console.error('failed to getShop due to', error.message);
        });
        return () => {
            unMounting = true;
        };
    }, [props.fetchOnMount, shop, finished]);
    return {
        shop,
        getShop,
        finished,
        setStarted,
        setFinished,
        setErrors,
        ...status,
    };
};
exports.useShopInit = useShopInit;
//# sourceMappingURL=useShopInit.js.map

/***/ }),

/***/ 81108:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useShopStartFinishErrors = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable prettier/prettier */
const react_1 = __webpack_require__(27378);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const DEBUG = false;
const useShopStartFinishErrors = (options) => {
    const setShopStarted = (0, store_1.useSetRecoilState)(store_1.default.shopStatusStarted('shop/all'));
    const setShopFinished = (0, store_1.useSetRecoilState)(store_1.default.shopStatusFinished('shop/all'));
    const setShopSuccess = (0, store_1.useSetRecoilState)(store_1.default.shopStatusSuccess('shop/all'));
    const setShopErrors = (0, store_1.useSetRecoilState)(store_1.default.shopStatusErrors('shop/all'));
    const [started, setStarted] = (0, store_1.useRecoilState)(store_1.default.shopStatusStarted(options?.id || ''));
    const [finished, setFinished] = (0, store_1.useRecoilState)(store_1.default.shopStatusFinished(options?.id || ''));
    const [success, setSuccess] = (0, store_1.useRecoilState)(store_1.default.shopStatusSuccess(options?.id || ''));
    const [errors, setErrors] = (0, store_1.useRecoilState)(store_1.default.shopStatusErrors(options?.id || ''));
    const autoReset = (0, react_1.useRef)(options?.autoReset || 0);
    const resetTimer = (0, react_1.useRef)(options?.resetTimer || null);
    const isCustomerId = /^customer/.test(options?.id);
    // update local hook status
    const reset = (0, react_1.useCallback)(() => {
        if (typeof setErrors === 'undefined')
            return;
        setErrors([]);
        setStarted(false);
        setFinished(false);
        setSuccess(false);
        resetTimer.current = null;
    }, []);
    const updateStateOnErrors = () => {
        let unMounting = false;
        if (errors?.length > 0) {
            if (unMounting)
                return;
            setFinished(true);
            setSuccess(false);
        }
        // eslint-disable-next-line consistent-return
        return () => {
            unMounting = true;
        };
    };
    const updateStateOnFinished = () => {
        let unMounting = false;
        if (finished) {
            if (DEBUG) {
                console.groupCollapsed('status:', options?.id);
                console.log('started', started);
                console.log('errors', errors);
                console.log('finished', finished);
                console.log('success', success);
                console.groupEnd();
            }
            if (unMounting)
                return;
            const withoutErrors = errors?.length === 0;
            setStarted(false);
            setSuccess(withoutErrors);
            if (autoReset?.current) {
                const to = setTimeout(() => {
                    if (unMounting)
                        return;
                    reset();
                    clearTimeout(to);
                }, autoReset.current);
            }
        }
        // eslint-disable-next-line consistent-return
        return () => {
            unMounting = true;
        };
    };
    (0, react_1.useEffect)(() => {
        updateStateOnErrors();
    }, [errors?.length]);
    (0, react_1.useEffect)(() => {
        updateStateOnFinished();
    }, [finished, options?.id]);
    // update global cart status
    (0, react_1.useEffect)(() => {
        if (isCustomerId) {
            setShopErrors(errors);
        }
    }, [errors?.length]);
    (0, react_1.useEffect)(() => {
        if (isCustomerId) {
            setShopStarted(started);
        }
    }, [started]);
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        setShopFinished(finished);
        const to = setTimeout(() => {
            if (unMounting)
                return;
            setShopFinished(false);
            clearTimeout(to);
        }, 1000);
        return () => {
            unMounting = true;
        };
    }, [finished]);
    (0, react_1.useEffect)(() => {
        if (isCustomerId) {
            setShopSuccess(success);
        }
    }, [success]);
    return {
        started,
        setStarted,
        finished,
        setFinished,
        success,
        setSuccess,
        errors,
        setErrors,
        reset,
        resetTimer,
    };
};
exports.useShopStartFinishErrors = useShopStartFinishErrors;
//# sourceMappingURL=useShopStartFinishErrors.js.map

/***/ }),

/***/ 28123:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useStorefrontInit = void 0;
const useShopInit_1 = __webpack_require__(33840);
const useCountriesInit_1 = __webpack_require__(77344);
const hooks_1 = __webpack_require__(48081);
const hooks_2 = __webpack_require__(33296);
const useStorefrontInit = () => {
    // 1. initialize the shop to determine primary currency code and country
    const { shop, ...shopStatus } = (0, useShopInit_1.useShopInit)();
    const primaryCountryCode = shop?.paymentSettings?.countryCode;
    // 2. initialize the countries to get all the available countries/markets info
    const { country, countries, ...countriesStatus } = (0, useCountriesInit_1.useCountriesInit)({
        fetchOnMount: primaryCountryCode,
    });
    const fullCountryCode = country?.isoCode;
    // 3. initialize customer and cart (the cart will be initialized once customerInit is true)
    const cart = (0, hooks_1.useCartInit)({ fetchOnMount: fullCountryCode });
    const customer = (0, hooks_2.useCustomerInit)({ fetchOnMount: fullCountryCode });
    return {
        customer,
        cart,
        shop,
        country,
        countries,
        finished: customer && cart && shop && country && countries,
        errors: [...countriesStatus.errors, ...shopStatus.errors],
    };
};
exports.useStorefrontInit = useStorefrontInit;
//# sourceMappingURL=useStorefrontInit.js.map

/***/ }),

/***/ 20437:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.shopStore = void 0;
var shop_1 = __webpack_require__(44652);
Object.defineProperty(exports, "shopStore", ({ enumerable: true, get: function () { return shop_1.shopStore; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 44652:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.shopStore = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable max-lines */
const recoil_1 = __webpack_require__(69853);
const effects_1 = tslib_1.__importDefault(__webpack_require__(49025));
const client_1 = __webpack_require__(76574);
const client = new client_1.ShopClient({
    apiToken: "7b8296bfc85c0cb6fbc85bd5fa81686f",
    apiVersion: '2024-10',
    domain: "kryo-gear.myshopify.com",
    debug: false,
});
// @see: https://shopify.dev/themes/internationalization/multiple-currencies-languages#javascript-submission-of-the-localization-form
const shop = (0, recoil_1.atom)({
    key: 'shop',
    default: null,
    effects: [
    // effects.logStateChange('shop')
    ],
});
const shopInit = (0, recoil_1.atom)({
    key: 'shop/init',
    default: false,
});
const country = (0, recoil_1.atom)({
    key: 'shop/country',
    default: null,
    // default: {
    //   currency: {
    //     isoCode: 'USD',
    //     name: 'United States Dollar',
    //     symbol: '$',
    //   },
    //   isoCode: 'US',
    //   name: 'United States',
    //   unitSystem: 'IMPERIAL_SYSTEM',
    // },
    effects: [
        // effects.logStateChange('country'),
        effects_1.default.setSelfToPersistedKey('country', `Country|${effects_1.default.SHOPIFY_NAME}`, 'COUNTRY_EXISTING'),
        effects_1.default.onSetUpdatePersistedKey(`Country|${effects_1.default.SHOPIFY_NAME}`),
        effects_1.default.onChange({
            key: 'country',
            topic: 'COUNTRY_UPDATE',
            actions: ['publishGtmEvent', 'publishBusEvent'],
        }),
    ],
});
/*
  ---------------
  Getters
  ---------------
*/
const primaryCurrencyCode$ = (0, recoil_1.selector)({
    key: 'shop/primaryCurrencyCode$',
    get: ({ get }) => {
        const _shop = get(shop);
        return _shop?.paymentSettings?.currencyCode || null;
    },
});
const primaryCountryCode$ = (0, recoil_1.selector)({
    key: 'shop/primaryCountryCode$',
    get: ({ get }) => {
        const _shop = get(shop);
        return _shop?.paymentSettings?.countryCode || null;
    },
});
/*
  When multiple markets are enabled on a store
  it will return an array of currencyCodes the user can checkout with
    e.g ['BR', 'CA', 'CN', 'DE', 'FR', 'GB', 'MX', 'RU', 'US']

  When no markets have been configured the array will include only the
  default market's currency code
    e.g ['USD] – user can only checkout in USD
*/
const currencies$ = (0, recoil_1.selector)({
    key: 'shop/currencies$',
    get: ({ get }) => {
        const _shop = get(shop);
        return _shop?.paymentSettings?.enabledPresentmentCurrencies || [];
    },
});
/*
  ---------------
  Status
  ---------------
*/
const countries = (0, recoil_1.atom)({
    key: 'shop/countries',
    default: [],
});
const availableCountries = (0, recoil_1.atom)({
    key: 'shop/availableCountries',
    default: [],
});
const shopStatusStarted = (0, recoil_1.atomFamily)({
    key: 'shop/statusStarted',
    default: false,
});
const shopStatusFinished = (0, recoil_1.atomFamily)({
    key: 'shop/statusFinished',
    default: false,
});
const shopStatusSuccess = (0, recoil_1.atomFamily)({
    key: 'shop/statusSuccess',
    default: false,
});
const shopStatusErrors = (0, recoil_1.atomFamily)({
    key: 'shop/statusErrors',
    default: [],
});
/*
  ---------------
  Async fetchers and setters
  ---------------
*/
/*
  Shop: countries...
*/
const fetchShop = (0, recoil_1.selectorFamily)({
    key: 'shop/fetchShop',
    get: () => async () => {
        return client.getShop();
    },
});
const fetchCountries = (0, recoil_1.selectorFamily)({
    key: 'shop/fetchCountries',
    get: () => async ({ get }) => {
        const primaryCurrencyCode = get(primaryCurrencyCode$);
        const primaryCountryCode = get(primaryCountryCode$);
        const currencies = get(currencies$);
        if (!primaryCountryCode)
            return null;
        return client.getCountries({
            countryCode: primaryCountryCode,
            currencyCode: primaryCurrencyCode,
            currencies, // presentmentCurrencies.
        });
    },
});
// new on v2
exports.shopStore = {
    shop,
    shopInit,
    country,
    countries,
    availableCountries,
    primaryCurrencyCode$,
    primaryCountryCode$,
    currencies$,
    shopStatusStarted,
    shopStatusFinished,
    shopStatusSuccess,
    shopStatusErrors,
    fetchShop,
    fetchCountries,
};
//# sourceMappingURL=shop.js.map

/***/ }),

/***/ 24385:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.selectorFamily = exports.selector = exports.atomFamily = exports.atom = exports.useGotoRecoilSnapshot = exports.useRecoilCallback = exports.useRecoilSnapshot = exports.useRecoilValueLoadable = exports.useRecoilValue = exports.useResetRecoilState = exports.useSetRecoilState = exports.useRecoilStateLoadable = exports.useRecoilState = void 0;
const store_1 = __webpack_require__(9807);
const store_2 = __webpack_require__(32159);
const store_3 = __webpack_require__(3727);
const store_4 = __webpack_require__(29005);
const store_5 = __webpack_require__(57152);
const store_6 = __webpack_require__(90747);
const store_7 = __webpack_require__(29970);
const store_8 = __webpack_require__(98886);
const store_9 = __webpack_require__(21857);
const store_10 = __webpack_require__(20437);
const store_11 = __webpack_require__(6839);
const store_12 = __webpack_require__(98584);
// just so that we don't need to imports in components
var recoil_1 = __webpack_require__(69853);
Object.defineProperty(exports, "useRecoilState", ({ enumerable: true, get: function () { return recoil_1.useRecoilState; } }));
Object.defineProperty(exports, "useRecoilStateLoadable", ({ enumerable: true, get: function () { return recoil_1.useRecoilStateLoadable; } }));
Object.defineProperty(exports, "useSetRecoilState", ({ enumerable: true, get: function () { return recoil_1.useSetRecoilState; } }));
Object.defineProperty(exports, "useResetRecoilState", ({ enumerable: true, get: function () { return recoil_1.useResetRecoilState; } }));
Object.defineProperty(exports, "useRecoilValue", ({ enumerable: true, get: function () { return recoil_1.useRecoilValue; } }));
Object.defineProperty(exports, "useRecoilValueLoadable", ({ enumerable: true, get: function () { return recoil_1.useRecoilValueLoadable; } }));
Object.defineProperty(exports, "useRecoilSnapshot", ({ enumerable: true, get: function () { return recoil_1.useRecoilSnapshot; } }));
Object.defineProperty(exports, "useRecoilCallback", ({ enumerable: true, get: function () { return recoil_1.useRecoilCallback; } }));
Object.defineProperty(exports, "useGotoRecoilSnapshot", ({ enumerable: true, get: function () { return recoil_1.useGotoRecoilSnapshot; } }));
Object.defineProperty(exports, "atom", ({ enumerable: true, get: function () { return recoil_1.atom; } }));
Object.defineProperty(exports, "atomFamily", ({ enumerable: true, get: function () { return recoil_1.atomFamily; } }));
Object.defineProperty(exports, "selector", ({ enumerable: true, get: function () { return recoil_1.selector; } }));
Object.defineProperty(exports, "selectorFamily", ({ enumerable: true, get: function () { return recoil_1.selectorFamily; } }));
// eslint-disable-next-line import/no-default-export
exports["default"] = {
    ...store_1.analyticsStore,
    ...store_2.articleStore,
    ...store_3.blogStore,
    ...store_4.cartStore,
    ...store_5.collectionStore,
    ...store_6.customerStore,
    ...store_7.localeStore,
    ...store_8.pageStore,
    ...store_9.productStore,
    ...store_10.shopStore,
    ...store_11.viewStore,
    ...store_12.settingsStore,
};
//# sourceMappingURL=store.js.map

/***/ }),

/***/ 8844:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useTemplate = void 0;
var useTemplate_1 = __webpack_require__(30412);
Object.defineProperty(exports, "useTemplate", ({ enumerable: true, get: function () { return useTemplate_1.useTemplate; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 30412:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useTemplate = void 0;
const tslib_1 = __webpack_require__(59312);
const store_1 = tslib_1.__importStar(__webpack_require__(24385));
const useTemplate = () => (0, store_1.useRecoilValue)(store_1.default.template);
exports.useTemplate = useTemplate;
//# sourceMappingURL=useTemplate.js.map

/***/ }),

/***/ 6839:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.viewStore = void 0;
var view_1 = __webpack_require__(74979);
Object.defineProperty(exports, "viewStore", ({ enumerable: true, get: function () { return view_1.viewStore; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 74979:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.viewStore = void 0;
const tslib_1 = __webpack_require__(59312);
/* eslint-disable max-lines */
const recoil_1 = __webpack_require__(69853);
const effects_1 = tslib_1.__importDefault(__webpack_require__(49025));
/**
  ROUTE_VIEW State
*/
const route = (0, recoil_1.atom)({
    key: 'view/route',
    default: '',
    effects: [
        effects_1.default.onChange({
            key: 'route',
            topic: 'ROUTE_UPDATE',
            actions: ['publishGtmEvent', 'publishBusEvent'],
        }),
    ],
});
const template = (0, recoil_1.selector)({
    key: 'view/template',
    default: null,
    get: ({ get }) => {
        const _route = get(route);
        const _template = _route
            ? effects_1.default.routeToTemplate({ route: _route })
            : null; // not ready
        return _template;
    },
});
// viewStore
exports.viewStore = {
    route,
    template,
};
//# sourceMappingURL=view.js.map

/***/ }),

/***/ 93853:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ createCache; }
});

;// CONCATENATED MODULE: ../node_modules/@emotion/sheet/dist/emotion-sheet.esm.js
var isDevelopment = false;

/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/

function sheetForTag(tag) {
  if (tag.sheet) {
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      return document.styleSheets[i];
    }
  } // this function should always return with a value
  // TS can't understand it though so we make it stop complaining here


  return undefined;
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}

var StyleSheet = /*#__PURE__*/function () {
  // Using Node instead of HTMLElement since container may be a ShadowRoot
  function StyleSheet(options) {
    var _this = this;

    this._insertTag = function (tag) {
      var before;

      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }

      _this.container.insertBefore(tag, before);

      _this.tags.push(tag);
    };

    this.isSpeedy = options.speedy === undefined ? !isDevelopment : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }

    var tag = this.tags[this.tags.length - 1];

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    this.tags.forEach(function (tag) {
      var _tag$parentNode;

      return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };

  return StyleSheet;
}();



;// CONCATENATED MODULE: ../node_modules/stylis/src/Utility.js
/**
 * @param {number}
 * @return {number}
 */
var abs = Math.abs

/**
 * @param {number}
 * @return {string}
 */
var Utility_from = String.fromCharCode

/**
 * @param {object}
 * @return {object}
 */
var Utility_assign = Object.assign

/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */
function hash (value, length) {
	return Utility_charat(value, 0) ^ 45 ? (((((((length << 2) ^ Utility_charat(value, 0)) << 2) ^ Utility_charat(value, 1)) << 2) ^ Utility_charat(value, 2)) << 2) ^ Utility_charat(value, 3) : 0
}

/**
 * @param {string} value
 * @return {string}
 */
function trim (value) {
	return value.trim()
}

/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */
function Utility_match (value, pattern) {
	return (value = pattern.exec(value)) ? value[0] : value
}

/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */
function Utility_replace (value, pattern, replacement) {
	return value.replace(pattern, replacement)
}

/**
 * @param {string} value
 * @param {string} search
 * @return {number}
 */
function indexof (value, search) {
	return value.indexOf(search)
}

/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */
function Utility_charat (value, index) {
	return value.charCodeAt(index) | 0
}

/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function Utility_substr (value, begin, end) {
	return value.slice(begin, end)
}

/**
 * @param {string} value
 * @return {number}
 */
function Utility_strlen (value) {
	return value.length
}

/**
 * @param {any[]} value
 * @return {number}
 */
function Utility_sizeof (value) {
	return value.length
}

/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */
function Utility_append (value, array) {
	return array.push(value), value
}

/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */
function Utility_combine (array, callback) {
	return array.map(callback).join('')
}

;// CONCATENATED MODULE: ../node_modules/stylis/src/Tokenizer.js


var line = 1
var column = 1
var Tokenizer_length = 0
var position = 0
var character = 0
var characters = ''

/**
 * @param {string} value
 * @param {object | null} root
 * @param {object | null} parent
 * @param {string} type
 * @param {string[] | string} props
 * @param {object[] | string} children
 * @param {number} length
 */
function node (value, root, parent, type, props, children, length) {
	return {value: value, root: root, parent: parent, type: type, props: props, children: children, line: line, column: column, length: length, return: ''}
}

/**
 * @param {object} root
 * @param {object} props
 * @return {object}
 */
function Tokenizer_copy (root, props) {
	return Utility_assign(node('', null, null, '', null, null, 0), root, {length: -root.length}, props)
}

/**
 * @return {number}
 */
function Tokenizer_char () {
	return character
}

/**
 * @return {number}
 */
function prev () {
	character = position > 0 ? Utility_charat(characters, --position) : 0

	if (column--, character === 10)
		column = 1, line--

	return character
}

/**
 * @return {number}
 */
function next () {
	character = position < Tokenizer_length ? Utility_charat(characters, position++) : 0

	if (column++, character === 10)
		column = 1, line++

	return character
}

/**
 * @return {number}
 */
function peek () {
	return Utility_charat(characters, position)
}

/**
 * @return {number}
 */
function caret () {
	return position
}

/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function slice (begin, end) {
	return Utility_substr(characters, begin, end)
}

/**
 * @param {number} type
 * @return {number}
 */
function token (type) {
	switch (type) {
		// \0 \t \n \r \s whitespace token
		case 0: case 9: case 10: case 13: case 32:
			return 5
		// ! + , / > @ ~ isolate token
		case 33: case 43: case 44: case 47: case 62: case 64: case 126:
		// ; { } breakpoint token
		case 59: case 123: case 125:
			return 4
		// : accompanied token
		case 58:
			return 3
		// " ' ( [ opening delimit token
		case 34: case 39: case 40: case 91:
			return 2
		// ) ] closing delimit token
		case 41: case 93:
			return 1
	}

	return 0
}

/**
 * @param {string} value
 * @return {any[]}
 */
function alloc (value) {
	return line = column = 1, Tokenizer_length = Utility_strlen(characters = value), position = 0, []
}

/**
 * @param {any} value
 * @return {any}
 */
function dealloc (value) {
	return characters = '', value
}

/**
 * @param {number} type
 * @return {string}
 */
function delimit (type) {
	return trim(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)))
}

/**
 * @param {string} value
 * @return {string[]}
 */
function Tokenizer_tokenize (value) {
	return dealloc(tokenizer(alloc(value)))
}

/**
 * @param {number} type
 * @return {string}
 */
function whitespace (type) {
	while (character = peek())
		if (character < 33)
			next()
		else
			break

	return token(type) > 2 || token(character) > 3 ? '' : ' '
}

/**
 * @param {string[]} children
 * @return {string[]}
 */
function tokenizer (children) {
	while (next())
		switch (token(character)) {
			case 0: append(identifier(position - 1), children)
				break
			case 2: append(delimit(character), children)
				break
			default: append(from(character), children)
		}

	return children
}

/**
 * @param {number} index
 * @param {number} count
 * @return {string}
 */
function escaping (index, count) {
	while (--count && next())
		// not 0-9 A-F a-f
		if (character < 48 || character > 102 || (character > 57 && character < 65) || (character > 70 && character < 97))
			break

	return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32))
}

/**
 * @param {number} type
 * @return {number}
 */
function delimiter (type) {
	while (next())
		switch (character) {
			// ] ) " '
			case type:
				return position
			// " '
			case 34: case 39:
				if (type !== 34 && type !== 39)
					delimiter(character)
				break
			// (
			case 40:
				if (type === 41)
					delimiter(type)
				break
			// \
			case 92:
				next()
				break
		}

	return position
}

/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */
function commenter (type, index) {
	while (next())
		// //
		if (type + character === 47 + 10)
			break
		// /*
		else if (type + character === 42 + 42 && peek() === 47)
			break

	return '/*' + slice(index, position - 1) + '*' + Utility_from(type === 47 ? type : next())
}

/**
 * @param {number} index
 * @return {string}
 */
function identifier (index) {
	while (!token(peek()))
		next()

	return slice(index, position)
}

;// CONCATENATED MODULE: ../node_modules/stylis/src/Enum.js
var Enum_MS = '-ms-'
var Enum_MOZ = '-moz-'
var Enum_WEBKIT = '-webkit-'

var COMMENT = 'comm'
var Enum_RULESET = 'rule'
var Enum_DECLARATION = 'decl'

var PAGE = '@page'
var MEDIA = '@media'
var IMPORT = '@import'
var CHARSET = '@charset'
var VIEWPORT = '@viewport'
var SUPPORTS = '@supports'
var DOCUMENT = '@document'
var NAMESPACE = '@namespace'
var Enum_KEYFRAMES = '@keyframes'
var FONT_FACE = '@font-face'
var COUNTER_STYLE = '@counter-style'
var FONT_FEATURE_VALUES = '@font-feature-values'
var LAYER = '@layer'

;// CONCATENATED MODULE: ../node_modules/stylis/src/Serializer.js



/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function Serializer_serialize (children, callback) {
	var output = ''
	var length = Utility_sizeof(children)

	for (var i = 0; i < length; i++)
		output += callback(children[i], i, children, callback) || ''

	return output
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function stringify (element, index, children, callback) {
	switch (element.type) {
		case LAYER: if (element.children.length) break
		case IMPORT: case Enum_DECLARATION: return element.return = element.return || element.value
		case COMMENT: return ''
		case Enum_KEYFRAMES: return element.return = element.value + '{' + Serializer_serialize(element.children, callback) + '}'
		case Enum_RULESET: element.value = element.props.join(',')
	}

	return Utility_strlen(children = Serializer_serialize(element.children, callback)) ? element.return = element.value + '{' + children + '}' : ''
}

;// CONCATENATED MODULE: ../node_modules/stylis/src/Middleware.js






/**
 * @param {function[]} collection
 * @return {function}
 */
function middleware (collection) {
	var length = Utility_sizeof(collection)

	return function (element, index, children, callback) {
		var output = ''

		for (var i = 0; i < length; i++)
			output += collection[i](element, index, children, callback) || ''

		return output
	}
}

/**
 * @param {function} callback
 * @return {function}
 */
function rulesheet (callback) {
	return function (element) {
		if (!element.root)
			if (element = element.return)
				callback(element)
	}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 */
function prefixer (element, index, children, callback) {
	if (element.length > -1)
		if (!element.return)
			switch (element.type) {
				case DECLARATION: element.return = prefix(element.value, element.length, children)
					return
				case KEYFRAMES:
					return serialize([copy(element, {value: replace(element.value, '@', '@' + WEBKIT)})], callback)
				case RULESET:
					if (element.length)
						return combine(element.props, function (value) {
							switch (match(value, /(::plac\w+|:read-\w+)/)) {
								// :read-(only|write)
								case ':read-only': case ':read-write':
									return serialize([copy(element, {props: [replace(value, /:(read-\w+)/, ':' + MOZ + '$1')]})], callback)
								// :placeholder
								case '::placeholder':
									return serialize([
										copy(element, {props: [replace(value, /:(plac\w+)/, ':' + WEBKIT + 'input-$1')]}),
										copy(element, {props: [replace(value, /:(plac\w+)/, ':' + MOZ + '$1')]}),
										copy(element, {props: [replace(value, /:(plac\w+)/, MS + 'input-$1')]})
									], callback)
							}

							return ''
						})
			}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 */
function namespace (element) {
	switch (element.type) {
		case RULESET:
			element.props = element.props.map(function (value) {
				return combine(tokenize(value), function (value, index, children) {
					switch (charat(value, 0)) {
						// \f
						case 12:
							return substr(value, 1, strlen(value))
						// \0 ( + > ~
						case 0: case 40: case 43: case 62: case 126:
							return value
						// :
						case 58:
							if (children[++index] === 'global')
								children[index] = '', children[++index] = '\f' + substr(children[index], index = 1, -1)
						// \s
						case 32:
							return index === 1 ? '' : value
						default:
							switch (index) {
								case 0: element = value
									return sizeof(children) > 1 ? '' : value
								case index = sizeof(children) - 1: case 2:
									return index === 2 ? value + element + element : value + element
								default:
									return value
							}
					}
				})
			})
	}
}

;// CONCATENATED MODULE: ../node_modules/stylis/src/Parser.js




/**
 * @param {string} value
 * @return {object[]}
 */
function compile (value) {
	return dealloc(parse('', null, null, null, [''], value = alloc(value), 0, [0], value))
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */
function parse (value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
	var index = 0
	var offset = 0
	var length = pseudo
	var atrule = 0
	var property = 0
	var previous = 0
	var variable = 1
	var scanning = 1
	var ampersand = 1
	var character = 0
	var type = ''
	var props = rules
	var children = rulesets
	var reference = rule
	var characters = type

	while (scanning)
		switch (previous = character, character = next()) {
			// (
			case 40:
				if (previous != 108 && Utility_charat(characters, length - 1) == 58) {
					if (indexof(characters += Utility_replace(delimit(character), '&', '&\f'), '&\f') != -1)
						ampersand = -1
					break
				}
			// " ' [
			case 34: case 39: case 91:
				characters += delimit(character)
				break
			// \t \n \r \s
			case 9: case 10: case 13: case 32:
				characters += whitespace(previous)
				break
			// \
			case 92:
				characters += escaping(caret() - 1, 7)
				continue
			// /
			case 47:
				switch (peek()) {
					case 42: case 47:
						Utility_append(comment(commenter(next(), caret()), root, parent), declarations)
						break
					default:
						characters += '/'
				}
				break
			// {
			case 123 * variable:
				points[index++] = Utility_strlen(characters) * ampersand
			// } ; \0
			case 125 * variable: case 59: case 0:
				switch (character) {
					// \0 }
					case 0: case 125: scanning = 0
					// ;
					case 59 + offset: if (ampersand == -1) characters = Utility_replace(characters, /\f/g, '')
						if (property > 0 && (Utility_strlen(characters) - length))
							Utility_append(property > 32 ? declaration(characters + ';', rule, parent, length - 1) : declaration(Utility_replace(characters, ' ', '') + ';', rule, parent, length - 2), declarations)
						break
					// @ ;
					case 59: characters += ';'
					// { rule/at-rule
					default:
						Utility_append(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets)

						if (character === 123)
							if (offset === 0)
								parse(characters, root, reference, reference, props, rulesets, length, points, children)
							else
								switch (atrule === 99 && Utility_charat(characters, 3) === 110 ? 100 : atrule) {
									// d l m s
									case 100: case 108: case 109: case 115:
										parse(value, reference, reference, rule && Utility_append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children)
										break
									default:
										parse(characters, reference, reference, reference, [''], children, 0, points, children)
								}
				}

				index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo
				break
			// :
			case 58:
				length = 1 + Utility_strlen(characters), property = previous
			default:
				if (variable < 1)
					if (character == 123)
						--variable
					else if (character == 125 && variable++ == 0 && prev() == 125)
						continue

				switch (characters += Utility_from(character), character * variable) {
					// &
					case 38:
						ampersand = offset > 0 ? 1 : (characters += '\f', -1)
						break
					// ,
					case 44:
						points[index++] = (Utility_strlen(characters) - 1) * ampersand, ampersand = 1
						break
					// @
					case 64:
						// -
						if (peek() === 45)
							characters += delimit(next())

						atrule = peek(), offset = length = Utility_strlen(type = characters += identifier(caret())), character++
						break
					// -
					case 45:
						if (previous === 45 && Utility_strlen(characters) == 2)
							variable = 0
				}
		}

	return rulesets
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @return {object}
 */
function ruleset (value, root, parent, index, offset, rules, points, type, props, children, length) {
	var post = offset - 1
	var rule = offset === 0 ? rules : ['']
	var size = Utility_sizeof(rule)

	for (var i = 0, j = 0, k = 0; i < index; ++i)
		for (var x = 0, y = Utility_substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x)
			if (z = trim(j > 0 ? rule[x] + ' ' + y : Utility_replace(y, /&\f/g, rule[x])))
				props[k++] = z

	return node(value, root, parent, offset === 0 ? Enum_RULESET : type, props, children, length)
}

/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @return {object}
 */
function comment (value, root, parent) {
	return node(value, root, parent, COMMENT, Utility_from(Tokenizer_char()), Utility_substr(value, 2, -2), 0)
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @return {object}
 */
function declaration (value, root, parent, length) {
	return node(value, root, parent, Enum_DECLARATION, Utility_substr(value, 0, length), Utility_substr(value, length + 1, -1), length)
}

;// CONCATENATED MODULE: ../node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js





var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
  var previous = 0;
  var character = 0;

  while (true) {
    previous = character;
    character = peek(); // &\f

    if (previous === 38 && character === 12) {
      points[index] = 1;
    }

    if (token(character)) {
      break;
    }

    next();
  }

  return slice(begin, position);
};

var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;

  do {
    switch (token(character)) {
      case 0:
        // &\f
        if (character === 38 && peek() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }

        parsed[index] += identifierWithPointTracking(position - 1, points, index);
        break;

      case 2:
        parsed[index] += delimit(character);
        break;

      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = peek() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += Utility_from(character);
    }
  } while (character = next());

  return parsed;
};

var getRules = function getRules(value, points) {
  return dealloc(toRules(alloc(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11


var fixedElements = /* #__PURE__ */new WeakMap();
var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }

  var value = element.value;
  var parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;

  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case


  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */
  && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"


  if (isImplicitRule) {
    return;
  }

  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;

  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;

    if ( // charcode for l
    value.charCodeAt(0) === 108 && // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};

/* eslint-disable no-fallthrough */

function emotion_cache_browser_esm_prefix(value, length) {
  switch (hash(value, length)) {
    // color-adjust
    case 5103:
      return Enum_WEBKIT + 'print-' + value + value;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)

    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921: // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break

    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005: // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,

    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855: // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)

    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return Enum_WEBKIT + value + value;
    // appearance, user-select, transform, hyphens, text-size-adjust

    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Enum_WEBKIT + value + Enum_MOZ + value + Enum_MS + value + value;
    // flex, flex-direction

    case 6828:
    case 4268:
      return Enum_WEBKIT + value + Enum_MS + value + value;
    // order

    case 6165:
      return Enum_WEBKIT + value + Enum_MS + 'flex-' + value + value;
    // align-items

    case 5187:
      return Enum_WEBKIT + value + Utility_replace(value, /(\w+).+(:[^]+)/, Enum_WEBKIT + 'box-$1$2' + Enum_MS + 'flex-$1$2') + value;
    // align-self

    case 5443:
      return Enum_WEBKIT + value + Enum_MS + 'flex-item-' + Utility_replace(value, /flex-|-self/, '') + value;
    // align-content

    case 4675:
      return Enum_WEBKIT + value + Enum_MS + 'flex-line-pack' + Utility_replace(value, /align-content|flex-|-self/, '') + value;
    // flex-shrink

    case 5548:
      return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, 'shrink', 'negative') + value;
    // flex-basis

    case 5292:
      return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, 'basis', 'preferred-size') + value;
    // flex-grow

    case 6060:
      return Enum_WEBKIT + 'box-' + Utility_replace(value, '-grow', '') + Enum_WEBKIT + value + Enum_MS + Utility_replace(value, 'grow', 'positive') + value;
    // transition

    case 4554:
      return Enum_WEBKIT + Utility_replace(value, /([^-])(transform)/g, '$1' + Enum_WEBKIT + '$2') + value;
    // cursor

    case 6187:
      return Utility_replace(Utility_replace(Utility_replace(value, /(zoom-|grab)/, Enum_WEBKIT + '$1'), /(image-set)/, Enum_WEBKIT + '$1'), value, '') + value;
    // background, background-image

    case 5495:
    case 3959:
      return Utility_replace(value, /(image-set\([^]*)/, Enum_WEBKIT + '$1' + '$`$1');
    // justify-content

    case 4968:
      return Utility_replace(Utility_replace(value, /(.+:)(flex-)?(.*)/, Enum_WEBKIT + 'box-pack:$3' + Enum_MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + Enum_WEBKIT + value + value;
    // (margin|padding)-inline-(start|end)

    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Utility_replace(value, /(.+)-inline(.+)/, Enum_WEBKIT + '$1$2') + value;
    // (min|max)?(width|height|inline-size|block-size)

    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      // stretch, max-content, min-content, fill-available
      if (Utility_strlen(value) - 1 - length > 6) switch (Utility_charat(value, length + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          // -
          if (Utility_charat(value, length + 4) !== 45) break;
        // (f)ill-available, (f)it-content

        case 102:
          return Utility_replace(value, /(.+:)(.+)-([^]+)/, '$1' + Enum_WEBKIT + '$2-$3' + '$1' + Enum_MOZ + (Utility_charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
        // (s)tretch

        case 115:
          return ~indexof(value, 'stretch') ? emotion_cache_browser_esm_prefix(Utility_replace(value, 'stretch', 'fill-available'), length) + value : value;
      }
      break;
    // position: sticky

    case 4949:
      // (s)ticky?
      if (Utility_charat(value, length + 1) !== 115) break;
    // display: (flex|inline-flex)

    case 6444:
      switch (Utility_charat(value, Utility_strlen(value) - 3 - (~indexof(value, '!important') && 10))) {
        // stic(k)y
        case 107:
          return Utility_replace(value, ':', ':' + Enum_WEBKIT) + value;
        // (inline-)?fl(e)x

        case 101:
          return Utility_replace(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + Enum_WEBKIT + (Utility_charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + Enum_WEBKIT + '$2$3' + '$1' + Enum_MS + '$2box$3') + value;
      }

      break;
    // writing-mode

    case 5936:
      switch (Utility_charat(value, length + 11)) {
        // vertical-l(r)
        case 114:
          return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
        // vertical-r(l)

        case 108:
          return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
        // horizontal(-)tb

        case 45:
          return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
      }

      return Enum_WEBKIT + value + Enum_MS + value + value;
  }

  return value;
}

var emotion_cache_browser_esm_prefixer = function prefixer(element, index, children, callback) {
  if (element.length > -1) if (!element["return"]) switch (element.type) {
    case Enum_DECLARATION:
      element["return"] = emotion_cache_browser_esm_prefix(element.value, element.length);
      break;

    case Enum_KEYFRAMES:
      return Serializer_serialize([Tokenizer_copy(element, {
        value: Utility_replace(element.value, '@', '@' + Enum_WEBKIT)
      })], callback);

    case Enum_RULESET:
      if (element.length) return Utility_combine(element.props, function (value) {
        switch (Utility_match(value, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ':read-only':
          case ':read-write':
            return Serializer_serialize([Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(read-\w+)/, ':' + Enum_MOZ + '$1')]
            })], callback);
          // :placeholder

          case '::placeholder':
            return Serializer_serialize([Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(plac\w+)/, ':' + Enum_WEBKIT + 'input-$1')]
            }), Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(plac\w+)/, ':' + Enum_MOZ + '$1')]
            }), Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(plac\w+)/, Enum_MS + 'input-$1')]
            })], callback);
        }

        return '';
      });
  }
};

var defaultStylisPlugins = [emotion_cache_browser_esm_prefixer];

var createCache = function createCache(options) {
  var key = options.key;

  if (key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');

      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }

      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }

  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;

  var inserted = {};
  var container;
  var nodesToHydrate = [];

  {
    container = options.container || document.head;
    Array.prototype.forEach.call( // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
      var attrib = node.getAttribute("data-emotion").split(' ');

      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }

      nodesToHydrate.push(node);
    });
  }

  var _insert;

  var omnipresentPlugins = [compat, removeLabel];

  {
    var currentSheet;
    var finalizingPlugins = [stringify, rulesheet(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

    var stylis = function stylis(styles) {
      return Serializer_serialize(compile(styles), serializer);
    };

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;

      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  }

  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};




/***/ }),

/***/ 17960:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ memoize; }
/* harmony export */ });
function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}




/***/ }),

/***/ 44512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ CacheProvider; },
/* harmony export */   "E": function() { return /* binding */ Emotion$1; },
/* harmony export */   "T": function() { return /* binding */ ThemeContext; },
/* harmony export */   "c": function() { return /* binding */ createEmotionProps; },
/* harmony export */   "h": function() { return /* binding */ hasOwn; },
/* harmony export */   "u": function() { return /* binding */ useTheme; },
/* harmony export */   "w": function() { return /* binding */ withEmotionCache; }
/* harmony export */ });
/* unused harmony exports _, a, b, i */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var _emotion_cache__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93853);
/* harmony import */ var _emotion_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53211);
/* harmony import */ var _emotion_serialize__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74235);
/* harmony import */ var _emotion_use_insertion_effect_with_fallbacks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37164);










var isDevelopment = false;

var EmotionCacheContext = /* #__PURE__ */react__WEBPACK_IMPORTED_MODULE_0__.createContext( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */(0,_emotion_cache__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
  key: 'css'
}) : null);

var CacheProvider = EmotionCacheContext.Provider;
var __unsafe_useEmotionCache = function useEmotionCache() {
  return useContext(EmotionCacheContext);
};

var withEmotionCache = function withEmotionCache(func) {
  return /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (props, ref) {
    // the cache will never be null in the browser
    var cache = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(EmotionCacheContext);
    return func(props, cache, ref);
  });
};

var ThemeContext = /* #__PURE__ */react__WEBPACK_IMPORTED_MODULE_0__.createContext({});

var useTheme = function useTheme() {
  return react__WEBPACK_IMPORTED_MODULE_0__.useContext(ThemeContext);
};

var getTheme = function getTheme(outerTheme, theme) {
  if (typeof theme === 'function') {
    var mergedTheme = theme(outerTheme);

    return mergedTheme;
  }

  return _extends({}, outerTheme, theme);
};

var createCacheWithTheme = /* #__PURE__ */(/* unused pure expression or super */ null && (weakMemoize(function (outerTheme) {
  return weakMemoize(function (theme) {
    return getTheme(outerTheme, theme);
  });
})));
var ThemeProvider = function ThemeProvider(props) {
  var theme = React.useContext(ThemeContext);

  if (props.theme !== theme) {
    theme = createCacheWithTheme(theme)(props.theme);
  }

  return /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: theme
  }, props.children);
};
function withTheme(Component) {
  var componentName = Component.displayName || Component.name || 'Component';
  var WithTheme = /*#__PURE__*/React.forwardRef(function render(props, ref) {
    var theme = React.useContext(ThemeContext);
    return /*#__PURE__*/React.createElement(Component, _extends({
      theme: theme,
      ref: ref
    }, props));
  });
  WithTheme.displayName = "WithTheme(" + componentName + ")";
  return hoistNonReactStatics(WithTheme, Component);
}

var hasOwn = {}.hasOwnProperty;

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {

  var newProps = {};

  for (var _key in props) {
    if (hasOwn.call(props, _key)) {
      newProps[_key] = props[_key];
    }
  }

  newProps[typePropName] = type; // Runtime labeling is an opt-in feature because:

  return newProps;
};

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serialized = _ref.serialized,
      isStringTag = _ref.isStringTag;
  (0,_emotion_utils__WEBPACK_IMPORTED_MODULE_4__/* .registerStyles */ .hC)(cache, serialized, isStringTag);
  (0,_emotion_use_insertion_effect_with_fallbacks__WEBPACK_IMPORTED_MODULE_3__/* .useInsertionEffectAlwaysWithSyncFallback */ .L)(function () {
    return (0,_emotion_utils__WEBPACK_IMPORTED_MODULE_4__/* .insertStyles */ .My)(cache, serialized, isStringTag);
  });

  return null;
};

var Emotion = /* #__PURE__ */withEmotionCache(function (props, cache, ref) {
  var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var WrappedComponent = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = (0,_emotion_utils__WEBPACK_IMPORTED_MODULE_4__/* .getRegisteredStyles */ .fp)(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = (0,_emotion_serialize__WEBPACK_IMPORTED_MODULE_2__/* .serializeStyles */ .O)(registeredStyles, undefined, react__WEBPACK_IMPORTED_MODULE_0__.useContext(ThemeContext));

  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var _key2 in props) {
    if (hasOwn.call(props, _key2) && _key2 !== 'css' && _key2 !== typePropName && (!isDevelopment )) {
      newProps[_key2] = props[_key2];
    }
  }

  newProps.className = className;

  if (ref) {
    newProps.ref = ref;
  }

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Insertion, {
    cache: cache,
    serialized: serialized,
    isStringTag: typeof WrappedComponent === 'string'
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(WrappedComponent, newProps));
});

var Emotion$1 = Emotion;




/***/ }),

/***/ 10043:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F4": function() { return /* binding */ keyframes; },
/* harmony export */   "iv": function() { return /* binding */ css; },
/* harmony export */   "tZ": function() { return /* binding */ jsx; },
/* harmony export */   "xB": function() { return /* binding */ Global; }
/* harmony export */ });
/* unused harmony exports ClassNames, createElement */
/* harmony import */ var _emotion_element_f0de968e_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44512);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var _emotion_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(53211);
/* harmony import */ var _emotion_use_insertion_effect_with_fallbacks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37164);
/* harmony import */ var _emotion_serialize__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74235);
/* harmony import */ var _emotion_cache__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93853);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55839);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_4__);












var jsx = function jsx(type, props) {
  // eslint-disable-next-line prefer-rest-params
  var args = arguments;

  if (props == null || !_emotion_element_f0de968e_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__.h.call(props, 'css')) {
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement.apply(undefined, args);
  }

  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = _emotion_element_f0de968e_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__.E;
  createElementArgArray[1] = (0,_emotion_element_f0de968e_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__.c)(type, props);

  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  }

  return react__WEBPACK_IMPORTED_MODULE_0__.createElement.apply(null, createElementArgArray);
};

(function (_jsx) {
  var JSX;

  (function (_JSX) {})(JSX || (JSX = _jsx.JSX || (_jsx.JSX = {})));
})(jsx || (jsx = {}));

// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag

var Global = /* #__PURE__ */(0,_emotion_element_f0de968e_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__.w)(function (props, cache) {

  var styles = props.styles;
  var serialized = (0,_emotion_serialize__WEBPACK_IMPORTED_MODULE_2__/* .serializeStyles */ .O)([styles], undefined, react__WEBPACK_IMPORTED_MODULE_0__.useContext(_emotion_element_f0de968e_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__.T));
  // but it is based on a constant that will never change at runtime
  // it's effectively like having two implementations and switching them out
  // so it's not actually breaking anything


  var sheetRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  (0,_emotion_use_insertion_effect_with_fallbacks__WEBPACK_IMPORTED_MODULE_1__/* .useInsertionEffectWithLayoutFallback */ .j)(function () {
    var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675

    var sheet = new cache.sheet.constructor({
      key: key,
      nonce: cache.sheet.nonce,
      container: cache.sheet.container,
      speedy: cache.sheet.isSpeedy
    });
    var rehydrating = false;
    var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");

    if (cache.sheet.tags.length) {
      sheet.before = cache.sheet.tags[0];
    }

    if (node !== null) {
      rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s

      node.setAttribute('data-emotion', key);
      sheet.hydrate([node]);
    }

    sheetRef.current = [sheet, rehydrating];
    return function () {
      sheet.flush();
    };
  }, [cache]);
  (0,_emotion_use_insertion_effect_with_fallbacks__WEBPACK_IMPORTED_MODULE_1__/* .useInsertionEffectWithLayoutFallback */ .j)(function () {
    var sheetRefCurrent = sheetRef.current;
    var sheet = sheetRefCurrent[0],
        rehydrating = sheetRefCurrent[1];

    if (rehydrating) {
      sheetRefCurrent[1] = false;
      return;
    }

    if (serialized.next !== undefined) {
      // insert keyframes
      (0,_emotion_utils__WEBPACK_IMPORTED_MODULE_6__/* .insertStyles */ .My)(cache, serialized.next, true);
    }

    if (sheet.tags.length) {
      // if this doesn't exist then it will be null so the style element will be appended
      var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
      sheet.before = element;
      sheet.flush();
    }

    cache.insert("", serialized, sheet, false);
  }, [cache, serialized.name]);
  return null;
});

function css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return (0,_emotion_serialize__WEBPACK_IMPORTED_MODULE_2__/* .serializeStyles */ .O)(args);
}

function keyframes() {
  var insertable = css.apply(void 0, arguments);
  var name = "animation-" + insertable.name;
  return {
    name: name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}

var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {

            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serializedArr = _ref.serializedArr;
  useInsertionEffectAlwaysWithSyncFallback(function () {

    for (var i = 0; i < serializedArr.length; i++) {
      insertStyles(cache, serializedArr[i], false);
    }
  });

  return null;
};

var ClassNames = /* #__PURE__ */(/* unused pure expression or super */ null && (withEmotionCache(function (props, cache) {
  var hasRendered = false;
  var serializedArr = [];

  var css = function css() {
    if (hasRendered && isDevelopment) {
      throw new Error('css can only be used during render');
    }

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var serialized = serializeStyles(args, cache.registered);
    serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`

    registerStyles(cache, serialized, false);
    return cache.key + "-" + serialized.name;
  };

  var cx = function cx() {
    if (hasRendered && isDevelopment) {
      throw new Error('cx can only be used during render');
    }

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return merge(cache.registered, css, classnames(args));
  };

  var content = {
    css: css,
    cx: cx,
    theme: React.useContext(ThemeContext)
  };
  var ele = props.children(content);
  hasRendered = true;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Insertion, {
    cache: cache,
    serializedArr: serializedArr
  }), ele);
})));




/***/ }),

/***/ 74235:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ serializeStyles; }
});

;// CONCATENATED MODULE: ../node_modules/@emotion/hash/dist/emotion-hash.esm.js
/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}



;// CONCATENATED MODULE: ../node_modules/@emotion/unitless/dist/emotion-unitless.esm.js
var unitlessKeys = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};



// EXTERNAL MODULE: ../node_modules/@emotion/memoize/dist/emotion-memoize.esm.js
var emotion_memoize_esm = __webpack_require__(17960);
;// CONCATENATED MODULE: ../node_modules/@emotion/serialize/dist/emotion-serialize.esm.js




var isDevelopment = false;

var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = /* #__PURE__ */(0,emotion_memoize_esm/* default */.Z)(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

var noComponentSelectorMessage = 'Component selectors can only be used in conjunction with ' + '@emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware ' + 'compiler transform.';

function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  var componentSelector = interpolation;

  if (componentSelector.__emotion_styles !== undefined) {

    return componentSelector;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        var keyframes = interpolation;

        if (keyframes.anim === 1) {
          cursor = {
            name: keyframes.name,
            styles: keyframes.styles,
            next: cursor
          };
          return keyframes.name;
        }

        var serializedStyles = interpolation;

        if (serializedStyles.styles !== undefined) {
          var next = serializedStyles.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = serializedStyles.styles + ";";
          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        }

        break;
      }
  } // finalize string values (regular strings and functions interpolated into css calls)


  var asString = interpolation;

  if (registered == null) {
    return asString;
  }

  var cached = registered[asString];
  return cached !== undefined ? cached : asString;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var key in obj) {
      var value = obj[key];

      if (typeof value !== 'object') {
        var asString = value;

        if (registered != null && registered[asString] !== undefined) {
          string += key + "{" + registered[asString] + "}";
        } else if (isProcessableValue(asString)) {
          string += processStyleName(key) + ":" + processStyleValue(key, asString) + ";";
        }
      } else {
        if (key === 'NO_COMPONENT_SELECTOR' && isDevelopment) {
          throw new Error(noComponentSelectorMessage);
        }

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(key) + ":" + processStyleValue(key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);

          switch (key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(key) + ":" + interpolated + ";";
                break;
              }

            default:
              {

                string += key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list

var cursor;
function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    var asTemplateStringsArr = strings;

    styles += asTemplateStringsArr[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);

    if (stringMode) {
      var templateStringsArr = strings;

      styles += templateStringsArr[i];
    }
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + match[1];
  }

  var name = murmur2(styles) + identifierName;

  return {
    name: name,
    styles: styles,
    next: cursor
  };
}




/***/ }),

/***/ 37164:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
var react__WEBPACK_IMPORTED_MODULE_0___namespace_cache;
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useInsertionEffectAlwaysWithSyncFallback; },
/* harmony export */   "j": function() { return /* binding */ useInsertionEffectWithLayoutFallback; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);


var syncFallback = function syncFallback(create) {
  return create();
};

var useInsertionEffect = /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2)))['useInsertion' + 'Effect'] ? /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2)))['useInsertion' + 'Effect'] : false;
var useInsertionEffectAlwaysWithSyncFallback = useInsertionEffect || syncFallback;
var useInsertionEffectWithLayoutFallback = useInsertionEffect || react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect;




/***/ }),

/***/ 53211:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "My": function() { return /* binding */ insertStyles; },
/* harmony export */   "fp": function() { return /* binding */ getRegisteredStyles; },
/* harmony export */   "hC": function() { return /* binding */ registerStyles; }
/* harmony export */ });
var isBrowser = true;

function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else if (className) {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === false ) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;

  if (cache.inserted[serialized.name] === undefined) {
    var current = serialized;

    do {
      cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

      current = current.next;
    } while (current !== undefined);
  }
};




/***/ }),

/***/ 62680:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$j": function() { return /* binding */ Spinner; },
/* harmony export */   "Ee": function() { return /* binding */ Image; },
/* harmony export */   "II": function() { return /* binding */ Input; },
/* harmony export */   "Ph": function() { return /* binding */ Select; },
/* harmony export */   "W2": function() { return /* binding */ Container; },
/* harmony export */   "X6": function() { return /* binding */ Heading; },
/* harmony export */   "XZ": function() { return /* binding */ Checkbox; },
/* harmony export */   "Y8": function() { return /* binding */ Radio; },
/* harmony export */   "__": function() { return /* binding */ Label; },
/* harmony export */   "bZ": function() { return /* binding */ Alert; },
/* harmony export */   "cx": function() { return /* binding */ Embed; },
/* harmony export */   "gN": function() { return /* binding */ Field; },
/* harmony export */   "gx": function() { return /* binding */ Textarea; },
/* harmony export */   "kC": function() { return /* binding */ Flex; },
/* harmony export */   "nv": function() { return /* binding */ Paragraph; },
/* harmony export */   "oM": function() { return /* binding */ AspectRatio; },
/* harmony export */   "rU": function() { return /* binding */ Link; },
/* harmony export */   "rj": function() { return /* binding */ Grid; },
/* harmony export */   "xu": function() { return /* binding */ Box$1; },
/* harmony export */   "xv": function() { return /* binding */ Text; },
/* harmony export */   "zx": function() { return /* binding */ Button; }
/* harmony export */ });
/* unused harmony exports AspectImage, Avatar, Badge, Card, Close, CloseIcon, Divider, Donut, IconButton, MenuButton, MenuIcon, Message, NavLink, Progress, Slider, Switch, __isBoxStyledSystemProp */
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44512);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10043);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var _theme_ui_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56861);




function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var _excluded$g = ["__themeKey", "__css", "variant", "css", "sx", "as"];
var boxSystemProps = [// space scale props (inherited from @styled-system/space)
'margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'm', 'mt', 'mr', 'mb', 'ml', 'mx', 'my', 'padding', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 'paddingX', 'paddingY', 'p', 'pt', 'pr', 'pb', 'pl', 'px', 'py', // color props (inherited from @styled-system/color)
'color', 'backgroundColor', 'bg', 'opacity'];

/**
 * @internal
 */
var __isBoxStyledSystemProp = function __isBoxStyledSystemProp(prop) {
  return boxSystemProps.includes(prop);
};

var pickSystemProps = function pickSystemProps(props) {
  var res = {};

  for (var _iterator = _createForOfIteratorHelperLoose(boxSystemProps), _step; !(_step = _iterator()).done;) {
    var key = _step.value;
    res[key] = props[key];
  }

  return res;
};
/**
 * Use the Box component as a layout primitive to add margin, padding, and colors to content.
 * @see https://theme-ui.com/components/box
 */


var Box$1 = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function Box(props, ref) {
  var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.u)();

  var _ref = props,
      _ref$__themeKey = _ref.__themeKey,
      __themeKey = _ref$__themeKey === void 0 ? 'variants' : _ref$__themeKey,
      __css = _ref.__css,
      variant = _ref.variant,
      cssProp = _ref.css,
      sx = _ref.sx,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'div' : _ref$as,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$g);

  var baseStyles = {
    boxSizing: 'border-box',
    margin: 0,
    minWidth: 0
  };

  var __cssStyles = (0,_theme_ui_css__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(__css)(theme);

  var variantInTheme = (0,_theme_ui_css__WEBPACK_IMPORTED_MODULE_2__/* .get */ .U2)(theme, __themeKey + "." + variant) || (0,_theme_ui_css__WEBPACK_IMPORTED_MODULE_2__/* .get */ .U2)(theme, variant);
  var variantStyles = variantInTheme && (0,_theme_ui_css__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(variantInTheme)(theme);
  var sxPropStyles = (0,_theme_ui_css__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(sx)(theme);
  var systemPropsStyles = (0,_theme_ui_css__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(pickSystemProps(rest))(theme);
  var style = [baseStyles, __cssStyles, variantStyles, sxPropStyles, systemPropsStyles, cssProp];
  boxSystemProps.forEach(function (name) {
    delete rest[name];
  });
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(Component, _extends({
    ref: ref,
    css: style
  }, rest));
});

/**
 * Use the Flex component to create flexbox layouts.
 * @see https://theme-ui.com/components/flex
 */
var Flex = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Flex(props, ref) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Box$1, _extends({
    ref: ref
  }, props, {
    sx: _extends({
      display: 'flex'
    }, props.sx)
  }));
});

var getProps = function getProps(test) {
  return function (props) {
    var next = {};

    for (var key in props) {
      if (test(key || '')) next[key] = props[key];
    }

    return next;
  };
};
var MRE = /^m[trblxy]?$/;
var getMargin = getProps(function (k) {
  return MRE.test(k);
});
var omitMargin = getProps(function (k) {
  return !MRE.test(k);
});
/** @internal */

function __internalProps(props) {
  return props;
}
/**
 * @internal Props used by Theme UI Components not intended for user code.
 */

var _excluded$f = ["width", "columns", "gap", "repeat"];

var px = function px(n) {
  return typeof n === 'number' ? n + 'px' : n;
};

var singleWidthToColumns = function singleWidthToColumns(width, repeat) {
  return width ? "repeat(auto-" + repeat + ", minmax(" + px(width) + ", 1fr))" : null;
};

var widthToColumns = function widthToColumns(width, repeat) {
  return Array.isArray(width) ? width.map(function (w) {
    return singleWidthToColumns(w, repeat);
  }) : singleWidthToColumns(width, repeat);
};

var singleCountToColumns = function singleCountToColumns(n) {
  return n ? typeof n === 'number' ? "repeat(" + n + ", 1fr)" : n : null;
};

var countToColumns = function countToColumns(n) {
  return Array.isArray(n) ? n.map(singleCountToColumns) : singleCountToColumns(n);
};

/**
 * CSS grid layout component to arrange direct child elements in a tiled grid layout.
 * @see https://theme-ui.com/components/grid
 */
var Grid = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Grid(_ref, ref) {
  var width = _ref.width,
      columns = _ref.columns,
      _ref$gap = _ref.gap,
      gap = _ref$gap === void 0 ? 3 : _ref$gap,
      _ref$repeat = _ref.repeat,
      repeat = _ref$repeat === void 0 ? 'fit' : _ref$repeat,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$f);

  var gridTemplateColumns = !!width ? widthToColumns(width, repeat) : countToColumns(columns);
  var __css = {
    display: 'grid',
    gridGap: gap,
    gridTemplateColumns: gridTemplateColumns
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Box$1, _extends({
    ref: ref
  }, props, __internalProps({
    __themeKey: 'grids',
    __css: __css
  })));
});

var Box = Box$1;

/**
 * Primitive button component with variants
 * @see https://theme-ui.com/components/button
 */
var Button = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Button(props, ref) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Box, _extends({
    ref: ref,
    as: "button",
    variant: "primary"
  }, props, __internalProps({
    __themeKey: 'buttons',
    __css: {
      appearance: 'none',
      display: props.hidden ? undefined : 'inline-block',
      textAlign: 'center',
      lineHeight: 'inherit',
      textDecoration: 'none',
      fontSize: 'inherit',
      px: 3,
      py: 2,
      color: 'white',
      bg: 'primary',
      border: 0,
      borderRadius: 4
    }
  })));
});

/**
 * Link variants can be defined in the `theme.links` object.
 * By default the Link component will use styles defined in `theme.styles.a`.
 * @see https://theme-ui.com/components/link
 */
var Link = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Link(props, ref) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Box$1, _extends({
    ref: ref,
    as: "a",
    variant: "styles.a"
  }, props, __internalProps({
    __themeKey: 'links'
  })));
});

/**
 * Primitive typographic component.
 *
 * Text style variants can be defined in the theme.text object.
 * The Paragraph component uses theme.text.paragraph as its default variant style.
 * @see https://theme-ui.com/components/paragraph
 */
var Paragraph = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Paragraph(props, ref) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Box$1, _extends({
    ref: ref,
    as: "p",
    variant: "paragraph"
  }, props, __internalProps({
    __themeKey: 'text',
    __css: {
      fontFamily: 'body',
      fontWeight: 'body',
      lineHeight: 'body'
    }
  })));
});

/**
 * Primitive typographic component.
 *
 * Text style variants can be defined in the theme.text object.
 * @see https://theme-ui.com/components/text
 */
var Text = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Text(props, ref) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Box$1, _extends({
    as: "span",
    ref: ref,
    variant: "default"
  }, props, __internalProps({
    __themeKey: 'text'
  })));
});

/**
 * Primitive heading component, defaults to <h2>.
 *
 * Text style variants can be defined in the theme.text object.
 * The Heading component uses theme.text.heading as its default variant style.
 * @see https://theme-ui.com/components/heading
 */
var Heading = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Heading(props, ref) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Box$1, _extends({
    ref: ref,
    as: "h2",
    variant: "heading"
  }, props, __internalProps({
    __themeKey: 'text',
    __css: {
      fontFamily: 'heading',
      fontWeight: 'heading',
      lineHeight: 'heading'
    }
  })));
});

/**
 * Image style variants can be defined in the theme.images object.
 * @see https://theme-ui.com/components/image/
 */
var Image = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Image(props, ref) {
  var __outerCss = props.__css;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Box$1, _extends({
    ref: ref,
    as: "img"
  }, props, __internalProps({
    __themeKey: 'images',
    __css: _extends({
      maxWidth: '100%',
      height: 'auto'
    }, __outerCss)
  })));
});

/**
 * Card style variants can be defined in the `theme.cards` object.
 * By default the Card component uses the `theme.cards.primary` variant.
 * @see https://theme-ui.com/components/card
 */
var Card = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Card(props, ref) {
  return /*#__PURE__*/React.createElement(Box$1, _extends({
    ref: ref,
    variant: "primary"
  }, props, __internalProps({
    __themeKey: 'cards'
  })));
})));

/**
 * Label variants can be defined in `theme.forms`
 * and the component uses the `theme.forms.label` variant by default.
 * @see https://theme-ui.com/components/label/
 */
var Label = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Label(props, ref) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Box$1, _extends({
    ref: ref,
    as: "label",
    variant: "label"
  }, props, __internalProps({
    __themeKey: 'forms',
    __css: {
      width: '100%',
      display: 'flex'
    }
  })));
});

var _excluded$e = ["sx", "autofillBackgroundColor"];
var autofillStyles = {
  boxShadow: 'inset 0 0 0 1000px var(--theme-ui-input-autofill-bg)',
  fontSize: 'inherit',
  ':first-line': {
    fontSize: '1rem'
  }
};
var defaultInputStyles = {
  display: 'block',
  width: '100%',
  p: 2,
  appearance: 'none',
  fontSize: 'inherit',
  lineHeight: 'inherit',
  border: '1px solid',
  borderRadius: 4,
  color: 'inherit',
  bg: 'transparent',
  ':autofill, :autofill:hover, :autofill:focus': autofillStyles,
  ':-webkit-autofill, :-webkit-autofill:hover, :-webkit-autofill:focus': autofillStyles
};

/**
 * Input variants can be defined in `theme.forms`
 * and the component uses the `theme.forms.input` variant by default.
 * @see https://theme-ui.com/components/input/
 */
var Input = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Input(_ref, ref) {
  var sx = _ref.sx,
      _ref$autofillBackgrou = _ref.autofillBackgroundColor,
      autofillBackgroundColor = _ref$autofillBackgrou === void 0 ? 'background' : _ref$autofillBackgrou,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$e);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Box$1, _extends({
    ref: ref,
    as: "input",
    variant: "input",
    sx: _extends({
      '--theme-ui-input-autofill-bg': function themeUiInputAutofillBg(theme) {
        return theme.colors && (0,_theme_ui_css__WEBPACK_IMPORTED_MODULE_2__/* .get */ .U2)(theme.colors, autofillBackgroundColor, null);
      }
    }, sx)
  }, rest, __internalProps({
    __themeKey: 'forms',
    __css: defaultInputStyles
  })));
});

var _excluded$d = ["size"];
var SVG = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function SVG(_ref, ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$d);

  var svgProps = _extends({
    xmlns: 'http://www.w3.org/2000/svg',
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: 'currentcolor'
  }, rest);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Box$1, _extends({
    ref: ref,
    as: "svg"
  }, svgProps));
});
SVG.displayName = 'SVG';

var _excluded$c = ["arrow"];

var DownArrow = function DownArrow(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(SVG, props, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M7 10l5 5 5-5z"
  }));
};

/**
 * Select variants can be defined in `theme.forms`
 * and the component uses the `theme.forms.select` variant by default.
 * @see https://theme-ui.com/components/select/
 */
var Select = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Select(_ref, ref) {
  var arrow = _ref.arrow,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$c);

  var __css = {
    display: 'block',
    width: '100%',
    p: 2,
    paddingRight: 4,
    appearance: 'none',
    fontSize: 'inherit',
    lineHeight: 'inherit',
    border: '1px solid',
    borderRadius: 4,
    color: 'inherit',
    backgroundColor: function backgroundColor(theme) {
      return (0,_theme_ui_css__WEBPACK_IMPORTED_MODULE_2__/* .get */ .U2)(theme, 'colors.background', null);
    }
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Box$1, _extends({}, getMargin(props), {
    sx: {
      display: 'flex'
    }
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Box$1, _extends({
    ref: ref,
    as: "select",
    variant: "select"
  }, omitMargin(props), __internalProps({
    __themeKey: 'forms',
    __css: __css
  }))), arrow || /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(DownArrow, {
    sx: {
      ml: -28,
      alignSelf: 'center',
      pointerEvents: 'none'
    }
  }));
});

/**
 * Form textarea component
 *
 * Textarea variants can be defined in `theme.forms`
 * and the component uses the `theme.forms.textarea` variant by default.
 * @see https://theme-ui.com/components/textarea/
 */
var Textarea = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Textarea(props, ref) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Box$1, _extends({
    ref: ref,
    as: "textarea",
    variant: "textarea"
  }, props, __internalProps({
    __themeKey: 'forms',
    __css: {
      display: 'block',
      width: '100%',
      p: 2,
      appearance: 'none',
      fontSize: 'inherit',
      lineHeight: 'inherit',
      border: '1px solid',
      borderRadius: 4,
      color: 'inherit',
      bg: 'transparent'
    }
  })));
});

var _excluded$b = ["className", "sx", "variant"];

var RadioChecked = function RadioChecked(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(SVG, props, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }));
};

var RadioUnchecked = function RadioUnchecked(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(SVG, props, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }));
};

var RadioIcon = function RadioIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(RadioChecked, _extends({}, props, __internalProps({
    __css: {
      display: 'none',
      'input:checked ~ &': {
        display: 'block'
      }
    }
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(RadioUnchecked, _extends({}, props, __internalProps({
    __css: {
      display: 'block',
      'input:checked ~ &': {
        display: 'none'
      }
    }
  }))));
};

/**
 * Form radio input component
 *
 * Radio variants can be defined in `theme.forms` and the
 * component uses the `theme.forms.radio variant` by default.
 * @see https://theme-ui.com/components/radio/
 */
var Radio = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Radio(_ref, ref) {
  var className = _ref.className,
      sx = _ref.sx,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'radio' : _ref$variant,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$b);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Box$1, {
    sx: {
      minWidth: 'min-content'
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Box$1, _extends({
    ref: ref,
    as: "input",
    type: "radio"
  }, props, {
    sx: {
      position: 'absolute',
      opacity: 0,
      zIndex: -1,
      width: 1,
      height: 1,
      overflow: 'hidden'
    }
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Box$1, _extends({
    as: RadioIcon,
    "aria-hidden": "true",
    variant: variant,
    className: className,
    sx: sx
  }, __internalProps({
    __themeKey: 'forms',
    __css: {
      mr: 2,
      borderRadius: 9999,
      color: 'gray',
      flexShrink: 0,
      'input:checked ~ &': {
        color: 'primary'
      },
      'input:focus ~ &': {
        bg: 'highlight'
      }
    }
  }))));
});

var _excluded$a = ["className", "sx", "variant", "children"];

var CheckboxChecked = function CheckboxChecked(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(SVG, props, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
  }));
};

var CheckboxUnchecked = function CheckboxUnchecked(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(SVG, props, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
  }));
};

var CheckboxIcon = function CheckboxIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(CheckboxChecked, _extends({}, props, __internalProps({
    __css: {
      display: 'none',
      'input:checked ~ &': {
        display: 'block'
      }
    }
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(CheckboxUnchecked, _extends({}, props, __internalProps({
    __css: {
      display: 'block',
      'input:checked ~ &': {
        display: 'none'
      }
    }
  }))));
};

/**
 * Form checkbox input component
 *
 * Checkbox variants can be defined in `theme.forms` and the
 * component uses the `theme.forms.checkbox` variant by default.
 * @see https://theme-ui.com/components/checkbox/
 */
var Checkbox = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Checkbox(_ref, ref) {
  var className = _ref.className,
      sx = _ref.sx,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'checkbox' : _ref$variant,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$a);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Box$1, {
    sx: {
      minWidth: 'min-content'
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Box$1, _extends({
    ref: ref,
    as: "input",
    type: "checkbox"
  }, props, {
    sx: {
      position: 'absolute',
      opacity: 0,
      zIndex: -1,
      width: 1,
      height: 1,
      overflow: 'hidden'
    }
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Box$1, _extends({
    as: CheckboxIcon,
    "aria-hidden": "true",
    variant: variant,
    className: className,
    sx: sx
  }, __internalProps({
    __themeKey: 'forms',
    __css: {
      mr: 2,
      borderRadius: 4,
      color: 'gray',
      flexShrink: 0,
      'input:checked ~ &': {
        color: 'primary'
      },
      'input:focus ~ &': {
        color: 'primary',
        bg: 'highlight'
      }
    }
  }))), children);
});

var _excluded$9 = (/* unused pure expression or super */ null && (["className", "label", "sx", "variant"]));
var GUTTER = 2;
var SIZE = 18;

/**
 * Form switch component
 *
 * Switch variants can be defined in `theme.forms`
 * and the component uses the `theme.forms.switch` variant by default.
 */
var Switch = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Switch(_ref, ref) {
  var className = _ref.className,
      label = _ref.label,
      sx = _ref.sx,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'switch' : _ref$variant,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$9);

  var __css = {
    position: 'relative',
    flexShrink: 0,
    bg: 'gray',
    borderRadius: SIZE,
    height: SIZE + GUTTER * 2,
    width: SIZE * 2 + GUTTER * 2,
    mr: 2,
    'input:disabled ~ &': {
      opacity: 0.5,
      cursor: 'not-allowed'
    },
    '& > div': {
      display: 'flex',
      alignItems: 'center',
      borderRadius: '50%',
      height: SIZE,
      width: SIZE,
      bg: 'white',
      boxShadow: '0 1px 2px rgba(0, 0, 0, 0.1)',
      position: 'relative',
      transform: 'translateX(0%)',
      transition: "transform 240ms cubic-bezier(0.165, 0.840, 0.440, 1.000)"
    },
    'input:checked ~ &': {
      bg: 'primary',
      '> div': {
        transform: 'translateX(100%)'
      }
    }
  };
  return /*#__PURE__*/React.createElement(Label, {
    sx: {
      cursor: 'pointer'
    }
  }, /*#__PURE__*/React.createElement(Box$1, _extends({
    ref: ref,
    as: "input",
    type: "checkbox",
    "aria-label": label
  }, rest, {
    sx: {
      position: 'absolute',
      opacity: 0,
      zIndex: -1,
      width: 1,
      height: 1,
      overflow: 'hidden'
    }
  }, __internalProps({
    __themeKey: 'forms'
  }))), /*#__PURE__*/React.createElement(Box$1, _extends({
    css: {
      padding: GUTTER
    },
    variant: variant,
    className: className,
    sx: sx
  }, __internalProps({
    __themeKey: 'forms',
    __css: __css
  })), /*#__PURE__*/React.createElement(Box$1, null)), /*#__PURE__*/React.createElement("span", null, label));
})));

var thumbStyle = {
  appearance: 'none',
  width: 16,
  height: 16,
  bg: 'currentcolor',
  border: 0,
  borderRadius: 9999,
  variant: 'forms.slider.thumb'
};
var sliderStyle = {
  display: 'block',
  width: '100%',
  height: 4,
  my: 2,
  cursor: 'pointer',
  appearance: 'none',
  borderRadius: 9999,
  color: 'inherit',
  bg: 'gray',
  ':focus': {
    outline: 'none',
    color: 'primary'
  },
  '&::-webkit-slider-thumb': thumbStyle,
  '&::-moz-range-thumb': thumbStyle,
  '&::-ms-thumb': thumbStyle
};

/**
 * Range input element
 *
 * Slider variants can be defined in the `theme.forms` object.
 * The Slider component uses `theme.forms.slider` as its default variant style.
 * @see https://theme-ui.com/components/slider/
 */
var Slider = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Slider(props, ref) {
  return /*#__PURE__*/React.createElement(Box$1, _extends({
    ref: ref,
    as: "input",
    type: "range",
    variant: "slider"
  }, props, __internalProps({
    __themeKey: 'forms',
    __css: sliderStyle
  })));
})));

var _excluded$8 = ["as", "label", "id", "name"];
var Field = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Field(_ref, ref) {
  var _ref$as = _ref.as,
      Control = _ref$as === void 0 ? Input : _ref$as,
      label = _ref.label,
      id = _ref.id,
      name = _ref.name,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$8);

  var fieldIdentifier = id || name;

  var controlProps = _extends({
    ref: ref,
    name: name,
    id: fieldIdentifier
  }, omitMargin(rest));

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Box$1, getMargin(rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Label, {
    htmlFor: fieldIdentifier
  }, label), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Control, controlProps));
}); // Field is generic bcs of `as` prop, so we can't just use types from forwardRef

/**
 * Horizontal `<progress />` bar
 * @see https://theme-ui.com/components/progress/
 */
var Progress = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Progress(props, ref) {
  var __css = {
    display: 'block',
    width: '100%',
    height: '4px',
    margin: 0,
    padding: 0,
    overflow: 'hidden',
    appearance: 'none',
    color: 'primary',
    bg: 'gray',
    borderRadius: 9999,
    border: 'none',
    '&::-webkit-progress-bar': {
      bg: 'transparent'
    },
    '&::-webkit-progress-value': {
      bg: 'currentcolor'
    },
    '&::-moz-progress-bar': {
      bg: 'currentcolor'
    }
  };
  return /*#__PURE__*/React.createElement(Box$1, _extends({
    ref: ref,
    as: "progress",
    variant: "styles.progress"
  }, props, __internalProps({
    __css: __css
  })));
})));

var _excluded$7 = (/* unused pure expression or super */ null && (["size", "strokeWidth", "value", "min", "max", "title"]));

/**
 * Single value SVG donut chart
 * @see https://theme-ui.com/components/donut/
 */
var Donut = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Donut(_ref, ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 128 : _ref$size,
      _ref$strokeWidth = _ref.strokeWidth,
      strokeWidth = _ref$strokeWidth === void 0 ? 2 : _ref$strokeWidth,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? 0 : _ref$value,
      _ref$min = _ref.min,
      min = _ref$min === void 0 ? 0 : _ref$min,
      _ref$max = _ref.max,
      max = _ref$max === void 0 ? 1 : _ref$max,
      title = _ref.title,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$7);

  var r = 16 - (typeof strokeWidth === 'number' ? strokeWidth : parseFloat(strokeWidth));
  var C = 2 * r * Math.PI;
  var offset = C - (value - min) / (max - min) * C;
  var svgProps = {
    strokeWidth: strokeWidth,
    viewBox: '0 0 32 32',
    width: size,
    height: size,
    fill: 'none',
    stroke: 'currentcolor'
  };
  return /*#__PURE__*/React.createElement(Box$1, _extends({
    ref: ref,
    as: "svg",
    role: "img",
    "aria-valuenow": value,
    "aria-valuemin": min,
    "aria-valuemax": max
  }, svgProps, props, __internalProps({
    __css: {
      color: 'primary'
    }
  })), title && /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: r,
    opacity: 1 / 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: r,
    strokeDasharray: C,
    strokeDashoffset: offset,
    transform: "rotate(-90 16 16)"
  }));
})));

var _excluded$6 = ["size", "strokeWidth", "max", "title", "duration"];
var Spinner = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Spinner(_ref, ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 48 : _ref$size,
      _ref$strokeWidth = _ref.strokeWidth,
      strokeWidth = _ref$strokeWidth === void 0 ? 4 : _ref$strokeWidth;
      _ref.max;
      var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Loading' : _ref$title,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? 750 : _ref$duration,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$6);

  var __css = {
    color: 'primary',
    overflow: 'visible'
  };
  var svgProps = {
    strokeWidth: strokeWidth,
    viewBox: '0 0 32 32',
    width: size,
    height: size,
    fill: 'none',
    stroke: 'currentColor',
    role: 'img'
  };
  var circleProps = {
    strokeWidth: strokeWidth,
    r: 16 - strokeWidth,
    cx: 16,
    cy: 16,
    fill: 'none'
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Box$1, _extends({
    ref: ref,
    as: "svg"
  }, svgProps, props, __internalProps({
    __css: __css
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", null, title), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", _extends({}, circleProps, {
    opacity: 1 / 8
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", _extends({}, circleProps, {
    strokeDasharray: "20 110"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    from: "0 16 16",
    to: "360 16 16",
    dur: duration + "ms",
    repeatCount: "indefinite"
  })));
});

var _excluded$5 = (/* unused pure expression or super */ null && (["size"]));
var Avatar = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Avatar(_ref, ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 48 : _ref$size,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$5);

  return /*#__PURE__*/React.createElement(Image, _extends({
    ref: ref,
    width: size,
    height: size,
    variant: "avatar"
  }, props, __internalProps({
    __css: {
      borderRadius: 9999
    }
  })));
})));

var Badge = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Badge(props, ref) {
  return /*#__PURE__*/React.createElement(Box$1, _extends({
    ref: ref,
    variant: "primary"
  }, props, __internalProps({
    __themeKey: 'badges',
    __css: {
      display: 'inline-block',
      verticalAlign: 'baseline',
      fontSize: 0,
      fontWeight: 'bold',
      whiteSpace: 'nowrap',
      px: 1,
      borderRadius: 2,
      color: 'white',
      bg: 'primary'
    }
  })));
})));

var _excluded$4 = (/* unused pure expression or super */ null && (["size"]));

/**
 * Transparent button for SVG icons
 *
 * IconButton variants can be defined in the `theme.buttons` object.
 * By default the IconButton component will use styles defined in `theme.buttons.icon`.
 *
 * @see https://theme-ui.com/components/icon-button
 */
var IconButton = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function IconButton(_ref, ref) {
  var _css;

  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 32 : _ref$size,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4);

  var emotionCssLabel = ((_css = props.__css) == null ? void 0 : _css.label) || 'IconButton';
  return /*#__PURE__*/React.createElement(Box$1, _extends({
    ref: ref,
    as: "button",
    variant: "icon"
  }, props, __internalProps({
    __themeKey: 'buttons',
    __css: {
      label: emotionCssLabel,
      appearance: 'none',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 1,
      width: size,
      height: size,
      color: 'inherit',
      bg: 'transparent',
      border: 'none',
      borderRadius: 4
    }
  })));
})));

var _excluded$3 = (/* unused pure expression or super */ null && (["size"]));
var CloseIcon = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}));

/**
 * Button with close (×) icon.
 *
 * The Close component renders as a <button> element by default.
 * Pass any button attributes as props to the component.
 *
 * Close component variants can be defined in the theme.buttons object.
 * The Close component uses theme.buttons.close as its default variant style.
 */
var Close = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Close(_ref, ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 32 : _ref$size,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3);

  return /*#__PURE__*/React.createElement(IconButton, _extends({
    ref: ref,
    size: size,
    title: "Close",
    "aria-label": "Close",
    variant: "close"
  }, props, {
    children: CloseIcon
  }));
})));

/**
 * Component for displaying messages, notifications, or other application state.
 *
 * Alert variants can be defined in `theme.alerts`.
 * The Alert component uses `theme.alerts.primary` as its default variant.
 */
var Alert = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Alert(props, ref) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Box$1, _extends({
    ref: ref,
    variant: "primary"
  }, props, __internalProps({
    __themeKey: 'alerts',
    __css: {
      display: 'flex',
      alignItems: 'center',
      px: 3,
      py: 2,
      fontWeight: 'bold',
      color: 'white',
      bg: 'primary',
      borderRadius: 4
    }
  })));
});

/**
 * The Divider component reuses styles from `theme.styles.hr` as its default variant.
 */
var Divider = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Divider(props, ref) {
  return /*#__PURE__*/React.createElement(Box$1, _extends({
    ref: ref,
    as: "hr",
    variant: "styles.hr"
  }, props, __internalProps({
    __css: {
      color: 'gray',
      m: 0,
      my: 2,
      border: 0,
      borderBottom: '1px solid'
    }
  })));
})));

var _excluded$2 = ["variant", "sx", "ratio", "src", "frameBorder", "allowFullScreen", "width", "height", "allow"];
var getContainerProps = getProps(__isBoxStyledSystemProp);
var getIframeProps = getProps(function (str) {
  return !__isBoxStyledSystemProp(str);
});

/**
 * Responsive iframe for video embeds.
 *
 * Embed variants can be defined anywhere in the theme object.
 *
 * @see https://theme-ui.com/components/embed
 */
var Embed = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Embed(_ref, ref) {
  var variant = _ref.variant,
      sx = _ref.sx,
      _ref$ratio = _ref.ratio,
      ratio = _ref$ratio === void 0 ? 16 / 9 : _ref$ratio,
      src = _ref.src,
      _ref$frameBorder = _ref.frameBorder,
      frameBorder = _ref$frameBorder === void 0 ? 0 : _ref$frameBorder,
      _ref$allowFullScreen = _ref.allowFullScreen,
      allowFullScreen = _ref$allowFullScreen === void 0 ? true : _ref$allowFullScreen,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 560 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 315 : _ref$height,
      allow = _ref.allow,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$2);

  var iframeProps = _extends({
    src: src,
    width: width,
    height: height,
    frameBorder: frameBorder,
    allowFullScreen: allowFullScreen,
    allow: allow
  }, getIframeProps(rest));

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Box$1, _extends({
    variant: variant,
    sx: sx
  }, getContainerProps(rest), __internalProps({
    __css: {
      width: '100%',
      height: 0,
      paddingBottom: 100 / ratio + '%',
      position: 'relative',
      overflow: 'hidden'
    }
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Box$1, _extends({
    ref: ref,
    as: "iframe"
  }, iframeProps, __internalProps({
    __css: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      top: 0,
      bottom: 0,
      left: 0,
      border: 0
    }
  }))));
});

var _excluded$1 = ["ratio", "children"];

/**
 * Component for maintaining a fluid-width aspect ratio
 * @see https://theme-ui.com/components/aspect-ratio
 */
var AspectRatio = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function AspectRatio(_ref, ref) {
  var _ref$ratio = _ref.ratio,
      ratio = _ref$ratio === void 0 ? 4 / 3 : _ref$ratio,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Box$1, {
    ref: ref,
    sx: {
      position: 'relative',
      overflow: 'hidden'
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Box$1, {
    sx: {
      width: '100%',
      height: 0,
      paddingBottom: 100 / ratio + '%'
    }
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Box$1, _extends({}, props, __internalProps({
    __css: {
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }
  })), children));
});

var _excluded = (/* unused pure expression or super */ null && (["ratio"]));

/**
 * Image component constrained by as aspect ratio.
 * @see https://theme-ui.com/components/aspect-image
 */
var AspectImage = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function AspectImage(_ref, ref) {
  var ratio = _ref.ratio,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/React.createElement(AspectRatio, {
    ratio: ratio
  }, /*#__PURE__*/React.createElement(Image, _extends({
    ref: ref
  }, props, __internalProps({
    __css: {
      objectFit: 'cover'
    }
  }))));
})));

/**
 * Centered, max-width layout component
 *
 * Container variants can be defined in the `theme.layout` object.
 * The Container component uses `theme.layout.container` as its default variant style.
 * @see https://theme-ui.com/components/container
 */
var Container = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Container(props, ref) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Box$1, _extends({
    ref: ref,
    variant: "container"
  }, props, __internalProps({
    __themeKey: 'layout',
    __css: {
      width: '100%',
      maxWidth: 'container',
      mx: 'auto'
    }
  })));
});

/**
 * Link component for use in navigation
 *
 * NavLink variants can be defined in the `theme.links` object.
 * By default the NavLink component will use styles defined in `theme.links.nav`.
 * @see https://theme-ui.com/components/nav-link
 */
var NavLink = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function NavLink(props, ref) {
  var __css = {
    color: 'inherit',
    textDecoration: 'none',
    fontWeight: 'bold',
    display: 'inline-block',
    '&:hover, &:focus, &.active': {
      color: 'primary'
    }
  };
  return /*#__PURE__*/React.createElement(Link, _extends({
    ref: ref,
    variant: "nav"
  }, props, __internalProps({
    __css: __css
  })));
})));

/**
 * Styled Box component for callouts and inline messages
 *
 * Message variants can be defined in the theme.messages object.
 * @see https://theme-ui.com/components/message
 */
var Message = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Message(props, ref) {
  var __css = {
    padding: 3,
    paddingLeft: function paddingLeft(t) {
      return t.space && Number(t.space[3]) - Number(t.space[1]);
    },
    borderLeftWidth: function borderLeftWidth(t) {
      return t.space && Number(t.space[1]);
    },
    borderLeftStyle: 'solid',
    borderLeftColor: 'primary',
    borderRadius: 4,
    bg: 'highlight'
  };
  return /*#__PURE__*/React.createElement(Box$1, _extends({
    ref: ref
  }, props, __internalProps({
    __themeKey: 'messages',
    __css: __css
  })));
})));

var MenuIcon = function MenuIcon(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size;
  return jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: size,
    height: size,
    fill: "currentColor",
    css: {
      display: 'block',
      margin: 0,
      boxSizing: 'border-box',
      minWidth: 0
    }
  }, jsx("path", {
    d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
  }));
};

/**
 * MenuButton variants can be defined in the `theme.buttons` object.
 * By default the MenuButton component will use styles defined in `theme.buttons.menu`.
 *
 * @see https://theme-ui.com/components/menu-button
 */
var MenuButton = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function MenuButton(props, ref) {
  return jsx(IconButton, _extends({
    ref: ref,
    title: "Menu",
    "aria-label": "Toggle Menu",
    variant: "menu"
  }, props), jsx(MenuIcon, null));
})));




/***/ }),

/***/ 75902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ parseProps; }
/* harmony export */ });
/* harmony import */ var _theme_ui_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56861);


var getCSS = function getCSS(props) {
  return function (theme) {
    var styles = (0,_theme_ui_css__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(props.sx)(theme);
    var raw = typeof props.css === 'function' ? props.css(theme) : props.css;
    return [styles, raw];
  };
};

function parseProps(props) {
  if (!props || !props.sx && !props.css) return props;
  var next = {};

  for (var key in props) {
    if (key === 'sx') continue;
    next[key] = props[key];
  }

  next.css = getCSS(props);
  return next;
}




/***/ }),

/***/ 56861:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U2": function() { return /* binding */ get; },
/* harmony export */   "iv": function() { return /* binding */ css; }
/* harmony export */ });
/* unused harmony exports THEME_UI_DEFAULT_KEY, defaultBreakpoints, getObjectWithVariants, multiples, scales */
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

/**
 * Allows for nested scales with shorthand values
 * @example
 * {
 *   colors: {
 *     primary: { __default: '#00f', light: '#33f' }
 *   }
 * }
 * css({ color: 'primary' }); // { color: '#00f' }
 * css({ color: 'primary.light' }) // { color: '#33f' }
 */

var THEME_UI_DEFAULT_KEY = '__default';

var hasDefault = function hasDefault(x) {
  return typeof x === 'object' && x !== null && THEME_UI_DEFAULT_KEY in x;
};
/**
 * Extracts value under path from a deeply nested object.
 * Used for Themes, variants and Theme UI style objects.
 * Given a path to object with `__default` key, returns the value under that key.
 *
 * @param obj a theme, variant or style object
 * @param path path separated with dots (`.`)
 * @param fallback default value returned if get(obj, path) is not found
 */


function get(obj, path, fallback, p, undef) {
  var pathArray = path && typeof path === 'string' ? path.split('.') : [path];

  for (p = 0; p < pathArray.length; p++) {
    obj = obj ? obj[pathArray[p]] : undef;
  }

  if (obj === undef) return fallback;
  return hasDefault(obj) ? obj[THEME_UI_DEFAULT_KEY] : obj;
}
var getObjectWithVariants = function getObjectWithVariants(obj, theme) {
  if (obj && obj['variant']) {
    var result = {};

    for (var key in obj) {
      var x = obj[key];

      if (key === 'variant') {
        var val = typeof x === 'function' ? x(theme) : x;
        var variant = getObjectWithVariants(get(theme, val), theme);
        result = _extends({}, result, variant);
      } else {
        result[key] = x;
      }
    }

    return result;
  }

  return obj;
};
var defaultBreakpoints = [40, 52, 64].map(function (n) {
  return n + 'em';
});
var defaultTheme = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
};
var aliases = {
  bg: 'backgroundColor',
  m: 'margin',
  mt: 'marginTop',
  mr: 'marginRight',
  mb: 'marginBottom',
  ml: 'marginLeft',
  mx: 'marginX',
  my: 'marginY',
  p: 'padding',
  pt: 'paddingTop',
  pr: 'paddingRight',
  pb: 'paddingBottom',
  pl: 'paddingLeft',
  px: 'paddingX',
  py: 'paddingY'
};
var multiples = {
  marginX: ['marginLeft', 'marginRight'],
  marginY: ['marginTop', 'marginBottom'],
  paddingX: ['paddingLeft', 'paddingRight'],
  paddingY: ['paddingTop', 'paddingBottom'],
  scrollMarginX: ['scrollMarginLeft', 'scrollMarginRight'],
  scrollMarginY: ['scrollMarginTop', 'scrollMarginBottom'],
  scrollPaddingX: ['scrollPaddingLeft', 'scrollPaddingRight'],
  scrollPaddingY: ['scrollPaddingTop', 'scrollPaddingBottom'],
  size: ['width', 'height']
};
var scales = {
  color: 'colors',
  background: 'colors',
  backgroundColor: 'colors',
  borderColor: 'colors',
  caretColor: 'colors',
  columnRuleColor: 'colors',
  outlineColor: 'colors',
  textDecorationColor: 'colors',
  opacity: 'opacities',
  transition: 'transitions',
  margin: 'space',
  marginTop: 'space',
  marginRight: 'space',
  marginBottom: 'space',
  marginLeft: 'space',
  marginX: 'space',
  marginY: 'space',
  marginBlock: 'space',
  marginBlockEnd: 'space',
  marginBlockStart: 'space',
  marginInline: 'space',
  marginInlineEnd: 'space',
  marginInlineStart: 'space',
  padding: 'space',
  paddingTop: 'space',
  paddingRight: 'space',
  paddingBottom: 'space',
  paddingLeft: 'space',
  paddingX: 'space',
  paddingY: 'space',
  paddingBlock: 'space',
  paddingBlockEnd: 'space',
  paddingBlockStart: 'space',
  paddingInline: 'space',
  paddingInlineEnd: 'space',
  paddingInlineStart: 'space',
  scrollMargin: 'space',
  scrollMarginTop: 'space',
  scrollMarginRight: 'space',
  scrollMarginBottom: 'space',
  scrollMarginLeft: 'space',
  scrollMarginX: 'space',
  scrollMarginY: 'space',
  scrollPadding: 'space',
  scrollPaddingTop: 'space',
  scrollPaddingRight: 'space',
  scrollPaddingBottom: 'space',
  scrollPaddingLeft: 'space',
  scrollPaddingX: 'space',
  scrollPaddingY: 'space',
  inset: 'space',
  insetBlock: 'space',
  insetBlockEnd: 'space',
  insetBlockStart: 'space',
  insetInline: 'space',
  insetInlineEnd: 'space',
  insetInlineStart: 'space',
  top: 'space',
  right: 'space',
  bottom: 'space',
  left: 'space',
  gridGap: 'space',
  gridColumnGap: 'space',
  gridRowGap: 'space',
  gap: 'space',
  columnGap: 'space',
  rowGap: 'space',
  fontFamily: 'fonts',
  fontSize: 'fontSizes',
  fontWeight: 'fontWeights',
  lineHeight: 'lineHeights',
  letterSpacing: 'letterSpacings',
  border: 'borders',
  borderTop: 'borders',
  borderRight: 'borders',
  borderBottom: 'borders',
  borderLeft: 'borders',
  borderWidth: 'borderWidths',
  borderStyle: 'borderStyles',
  borderRadius: 'radii',
  borderTopRightRadius: 'radii',
  borderTopLeftRadius: 'radii',
  borderBottomRightRadius: 'radii',
  borderBottomLeftRadius: 'radii',
  borderTopWidth: 'borderWidths',
  borderTopColor: 'colors',
  borderTopStyle: 'borderStyles',
  borderBottomWidth: 'borderWidths',
  borderBottomColor: 'colors',
  borderBottomStyle: 'borderStyles',
  borderLeftWidth: 'borderWidths',
  borderLeftColor: 'colors',
  borderLeftStyle: 'borderStyles',
  borderRightWidth: 'borderWidths',
  borderRightColor: 'colors',
  borderRightStyle: 'borderStyles',
  borderBlock: 'borders',
  borderBlockColor: 'colors',
  borderBlockEnd: 'borders',
  borderBlockEndColor: 'colors',
  borderBlockEndStyle: 'borderStyles',
  borderBlockEndWidth: 'borderWidths',
  borderBlockStart: 'borders',
  borderBlockStartColor: 'colors',
  borderBlockStartStyle: 'borderStyles',
  borderBlockStartWidth: 'borderWidths',
  borderBlockStyle: 'borderStyles',
  borderBlockWidth: 'borderWidths',
  borderEndEndRadius: 'radii',
  borderEndStartRadius: 'radii',
  borderInline: 'borders',
  borderInlineColor: 'colors',
  borderInlineEnd: 'borders',
  borderInlineEndColor: 'colors',
  borderInlineEndStyle: 'borderStyles',
  borderInlineEndWidth: 'borderWidths',
  borderInlineStart: 'borders',
  borderInlineStartColor: 'colors',
  borderInlineStartStyle: 'borderStyles',
  borderInlineStartWidth: 'borderWidths',
  borderInlineStyle: 'borderStyles',
  borderInlineWidth: 'borderWidths',
  borderStartEndRadius: 'radii',
  borderStartStartRadius: 'radii',
  columnRuleWidth: 'borderWidths',
  boxShadow: 'shadows',
  textShadow: 'shadows',
  zIndex: 'zIndices',
  width: 'sizes',
  minWidth: 'sizes',
  maxWidth: 'sizes',
  height: 'sizes',
  minHeight: 'sizes',
  maxHeight: 'sizes',
  flexBasis: 'sizes',
  size: 'sizes',
  blockSize: 'sizes',
  inlineSize: 'sizes',
  maxBlockSize: 'sizes',
  maxInlineSize: 'sizes',
  minBlockSize: 'sizes',
  minInlineSize: 'sizes',
  columnWidth: 'sizes',
  // svg
  fill: 'colors',
  stroke: 'colors'
};

var positiveOrNegative = function positiveOrNegative(scale, value) {
  if (typeof value !== 'number' || value >= 0) {
    if (typeof value === 'string' && value.startsWith('-')) {
      var valueWithoutMinus = value.substring(1);

      var _n = get(scale, valueWithoutMinus, valueWithoutMinus);

      if (typeof _n === 'number') {
        return _n * -1;
      }

      return "-" + _n;
    }

    return get(scale, value, value);
  }

  var absolute = Math.abs(value);
  var n = get(scale, absolute, absolute);
  if (typeof n === 'string') return '-' + n;
  return Number(n) * -1;
};

var transforms = ['margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'marginBlock', 'marginBlockEnd', 'marginBlockStart', 'marginInline', 'marginInlineEnd', 'marginInlineStart', 'top', 'bottom', 'left', 'right'].reduce(function (acc, curr) {
  var _extends2;

  return _extends({}, acc, (_extends2 = {}, _extends2[curr] = positiveOrNegative, _extends2));
}, {});

var responsive = function responsive(styles) {
  return function (theme) {
    var next = {};
    var breakpoints = theme && theme.breakpoints || defaultBreakpoints;
    var mediaQueries = [null].concat(breakpoints.map(function (n) {
      return n.includes('@media') ? n : "@media screen and (min-width: " + n + ")";
    }));

    for (var k in styles) {
      var key = k;
      var value = styles[key];

      if (typeof value === 'function') {
        value = value(theme || {});
      }

      if (value === false || value == null) {
        continue;
      }

      if (!Array.isArray(value)) {
        next[key] = value;
        continue;
      }

      for (var i = 0; i < value.slice(0, mediaQueries.length).length; i++) {
        var media = mediaQueries[i];

        if (!media) {
          next[key] = value[i];
          continue;
        }

        next[media] = next[media] || {};
        if (value[i] == null) continue;
        next[media][key] = value[i];
      }
    }

    return next;
  };
};

var css = function css(args) {
  if (args === void 0) {
    args = {};
  }

  return function (props) {
    if (props === void 0) {
      props = {};
    }

    var theme = _extends({}, defaultTheme, 'theme' in props ? props.theme : props); // insert variant props before responsive styles, so they can be merged
    // we need to maintain order of the style props, so if a variant is place in the middle
    // of other props, it will extends its props at that same location order.


    var obj = getObjectWithVariants(typeof args === 'function' ? args(theme) : args, theme);
    var styles = responsive(obj)(theme);
    var result = {};

    for (var key in styles) {
      var x = styles[key];
      var val = typeof x === 'function' ? x(theme) : x;

      if (val && typeof val === 'object') {
        if (hasDefault(val)) {
          result[key] = val[THEME_UI_DEFAULT_KEY];
          continue;
        } // On type level, val can also be an array here,
        // but we transform all arrays in `responsive` function.


        result[key] = css(val)(theme);
        continue;
      }

      var prop = key in aliases ? aliases[key] : key;
      var scaleName = prop in scales ? scales[prop] : undefined;
      var scale = scaleName ? theme == null ? void 0 : theme[scaleName] : get(theme, prop, {});
      var transform = get(transforms, prop, get);
      var value = transform(scale, val, val);

      if (prop in multiples) {
        var dirs = multiples[prop];

        for (var i = 0; i < dirs.length; i++) {
          result[dirs[i]] = value;
        }
      } else {
        result[prop] = value;
      }
    }

    return result;
  };
};




/***/ }),

/***/ 88981:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
/* provided dependency */ var Buffer = __webpack_require__(30816)["lW"];
(function (w) {
  "use strict";

  function findBest(atobNative) {
    // normal window
    if ('function' === typeof atobNative) { return atobNative; }


    // browserify (web worker)
    if ('function' === typeof Buffer) {
      return function atobBrowserify(a) {
        //!! Deliberately using an API that's deprecated in node.js because
        //!! this file is for browsers and we expect them to cope with it.
        //!! Discussion: github.com/node-browser-compat/atob/pull/9
        return new Buffer(a, 'base64').toString('binary');
      };
    }

    // ios web worker with base64js
    if ('object' === typeof w.base64js) {
      // bufferToBinaryString
      // https://git.coolaj86.com/coolaj86/unibabel.js/blob/master/index.js#L50
      return function atobWebWorker_iOS(a) {
        var buf = w.base64js.b64ToByteArray(a);
        return Array.prototype.map.call(buf, function (ch) {
          return String.fromCharCode(ch);
        }).join('');
      };
    }

		return function () {
			// ios web worker without base64js
			throw new Error("You're probably in an old browser or an iOS webworker." +
				" It might help to include beatgammit's base64-js.");
    };
  }

  var atobBest = findBest(w.atob);
  w.atob = atobBest;

  if (( true) && module && module.exports) {
    module.exports = atobBest;
  }
}(window));


/***/ }),

/***/ 24782:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ 30816:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(24782)
var ieee754 = __webpack_require__(78898)
var customInspectSymbol =
  (typeof Symbol === 'function' && typeof Symbol['for'] === 'function') // eslint-disable-line dot-notation
    ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
    : null

exports.lW = Buffer
__webpack_unused_export__ = SlowBuffer
exports.h2 = 50

var K_MAX_LENGTH = 0x7fffffff
__webpack_unused_export__ = K_MAX_LENGTH

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
    typeof console.error === 'function') {
  console.error(
    'This browser lacks typed array (Uint8Array) support which is required by ' +
    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
  )
}

function typedArraySupport () {
  // Can typed array instances can be augmented?
  try {
    var arr = new Uint8Array(1)
    var proto = { foo: function () { return 42 } }
    Object.setPrototypeOf(proto, Uint8Array.prototype)
    Object.setPrototypeOf(arr, proto)
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.buffer
  }
})

Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.byteOffset
  }
})

function createBuffer (length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"')
  }
  // Return an augmented `Uint8Array` instance
  var buf = new Uint8Array(length)
  Object.setPrototypeOf(buf, Buffer.prototype)
  return buf
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError(
        'The "string" argument must be of type string. Received type number'
      )
    }
    return allocUnsafe(arg)
  }
  return from(arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

function from (value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset)
  }

  if (ArrayBuffer.isView(value)) {
    return fromArrayView(value)
  }

  if (value == null) {
    throw new TypeError(
      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
      'or Array-like Object. Received type ' + (typeof value)
    )
  }

  if (isInstance(value, ArrayBuffer) ||
      (value && isInstance(value.buffer, ArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof SharedArrayBuffer !== 'undefined' &&
      (isInstance(value, SharedArrayBuffer) ||
      (value && isInstance(value.buffer, SharedArrayBuffer)))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof value === 'number') {
    throw new TypeError(
      'The "value" argument must not be of type number. Received type number'
    )
  }

  var valueOf = value.valueOf && value.valueOf()
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length)
  }

  var b = fromObject(value)
  if (b) return b

  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
      typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(
      value[Symbol.toPrimitive]('string'), encodingOrOffset, length
    )
  }

  throw new TypeError(
    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
    'or Array-like Object. Received type ' + (typeof value)
  )
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length)
}

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype)
Object.setPrototypeOf(Buffer, Uint8Array)

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number')
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"')
  }
}

function alloc (size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(size).fill(fill, encoding)
      : createBuffer(size).fill(fill)
  }
  return createBuffer(size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding)
}

function allocUnsafe (size) {
  assertSize(size)
  return createBuffer(size < 0 ? 0 : checked(size) | 0)
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size)
}

function fromString (string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding)
  }

  var length = byteLength(string, encoding) | 0
  var buf = createBuffer(length)

  var actual = buf.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  var buf = createBuffer(length)
  for (var i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayView (arrayView) {
  if (isInstance(arrayView, Uint8Array)) {
    var copy = new Uint8Array(arrayView)
    return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength)
  }
  return fromArrayLike(arrayView)
}

function fromArrayBuffer (array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds')
  }

  var buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(buf, Buffer.prototype)

  return buf
}

function fromObject (obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    var buf = createBuffer(len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0)
    }
    return fromArrayLike(obj)
  }

  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data)
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return b != null && b._isBuffer === true &&
    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
}

Buffer.compare = function compare (a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError(
      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
    )
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (isInstance(buf, Uint8Array)) {
      if (pos + buf.length > buffer.length) {
        Buffer.from(buf).copy(buffer, pos)
      } else {
        Uint8Array.prototype.set.call(
          buffer,
          buf,
          pos
        )
      }
    } else if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    } else {
      buf.copy(buffer, pos)
    }
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    throw new TypeError(
      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
      'Received type ' + typeof string
    )
  }

  var len = string.length
  var mustMatch = (arguments.length > 2 && arguments[2] === true)
  if (!mustMatch && len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
        }
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.toLocaleString = Buffer.prototype.toString

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.h2
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
  if (this.length > max) str += ' ... '
  return '<Buffer ' + str + '>'
}
if (customInspectSymbol) {
  Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength)
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError(
      'The "target" argument must be one of type Buffer or Uint8Array. ' +
      'Received type ' + (typeof target)
    )
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  var strLen = string.length

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (numberIsNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0
    if (isFinite(length)) {
      length = length >>> 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
      case 'latin1':
      case 'binary':
        return asciiWrite(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF)
      ? 4
      : (firstByte > 0xDF)
          ? 3
          : (firstByte > 0xBF)
              ? 2
              : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += hexSliceLookupTable[buf[i]]
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
  for (var i = 0; i < bytes.length - 1; i += 2) {
    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf = this.subarray(start, end)
  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(newBuf, Buffer.prototype)

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUintLE =
Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUintBE =
Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUint8 =
Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUint16LE =
Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUint16BE =
Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUint32LE =
Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUint32BE =
Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUintLE =
Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUintBE =
Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUint8 =
Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeUint16LE =
Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeUint16BE =
Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeUint32LE =
Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset + 3] = (value >>> 24)
  this[offset + 2] = (value >>> 16)
  this[offset + 1] = (value >>> 8)
  this[offset] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeUint32BE =
Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  this[offset + 2] = (value >>> 16)
  this[offset + 3] = (value >>> 24)
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start

  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end)
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, end),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if ((encoding === 'utf8' && code < 128) ||
          encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  } else if (typeof val === 'boolean') {
    val = Number(val)
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : Buffer.from(val, encoding)
    var len = bytes.length
    if (len === 0) {
      throw new TypeError('The value "' + val +
        '" is invalid for argument "value"')
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0]
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance (obj, type) {
  return obj instanceof type ||
    (obj != null && obj.constructor != null && obj.constructor.name != null &&
      obj.constructor.name === type.name)
}
function numberIsNaN (obj) {
  // For IE11 support
  return obj !== obj // eslint-disable-line no-self-compare
}

// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var hexSliceLookupTable = (function () {
  var alphabet = '0123456789abcdef'
  var table = new Array(256)
  for (var i = 0; i < 16; ++i) {
    var i16 = i * 16
    for (var j = 0; j < 16; ++j) {
      table[i16 + j] = alphabet[i] + alphabet[j]
    }
  }
  return table
})()


/***/ }),

/***/ 89372:
/***/ (function(module, exports) {

var global = typeof self !== 'undefined' ? self : this;
var __self__ = (function () {
function F() {
this.fetch = false;
this.DOMException = global.DOMException
}
F.prototype = global;
return new F();
})();
(function(self) {

var irrelevant = (function (exports) {

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob:
      'FileReader' in self &&
      'Blob' in self &&
      (function() {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  };

  function isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function(obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift();
        return {done: value === undefined, value: value}
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {};

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value);
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1]);
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
      }, this);
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function(name) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true;
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result);
      };
      reader.onerror = function() {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]);
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false;

    this._initBody = function(body) {
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this);
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      };

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      };
    }

    this.text = function() {
      var rejected = consumed(this);
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    };

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      };
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    };

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input, options) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url;
      this.credentials = input.credentials;
      if (!options.headers) {
        this.headers = new Headers(input.headers);
      }
      this.method = input.method;
      this.mode = input.mode;
      this.signal = input.signal;
      if (!body && input._bodyInit != null) {
        body = input._bodyInit;
        input.bodyUsed = true;
      }
    } else {
      this.url = String(input);
    }

    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers);
    }
    this.method = normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal;
    this.referrer = null;

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body);
  }

  Request.prototype.clone = function() {
    return new Request(this, {body: this._bodyInit})
  };

  function decode(body) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function(bytes) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit, options) {
    if (!options) {
      options = {};
    }

    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    this.headers = new Headers(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''});
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  };

  exports.DOMException = self.DOMException;
  try {
    new exports.DOMException();
  } catch (err) {
    exports.DOMException = function(message, name) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    exports.DOMException.prototype = Object.create(Error.prototype);
    exports.DOMException.prototype.constructor = exports.DOMException;
  }

  function fetch(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new exports.DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : xhr.responseText;
        resolve(new Response(body, options));
      };

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'));
      };

      xhr.onabort = function() {
        reject(new exports.DOMException('Aborted', 'AbortError'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value);
      });

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function() {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!self.fetch) {
    self.fetch = fetch;
    self.Headers = Headers;
    self.Request = Request;
    self.Response = Response;
  }

  exports.Headers = Headers;
  exports.Request = Request;
  exports.Response = Response;
  exports.fetch = fetch;

  Object.defineProperty(exports, '__esModule', { value: true });

  return exports;

})({});
})(__self__);
__self__.fetch.ponyfill = true;
// Remove "polyfill" property added by whatwg-fetch
delete __self__.fetch.polyfill;
// Choose between native implementation (global) or custom implementation (__self__)
// var ctx = global.fetch ? global : __self__;
var ctx = __self__; // this line disable service worker support temporarily
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
exports["default"] = ctx.fetch // For TypeScript consumers without esModuleInterop.
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
exports.Headers = ctx.Headers
exports.Request = ctx.Request
exports.Response = ctx.Response
module.exports = exports


/***/ }),

/***/ 20406:
/***/ (function(module) {

"use strict";


var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function getMergeFunction(key, options) {
	if (!options.customMerge) {
		return deepmerge
	}
	var customMerge = options.customMerge(key);
	return typeof customMerge === 'function' ? customMerge : deepmerge
}

function getEnumerableOwnPropertySymbols(target) {
	return Object.getOwnPropertySymbols
		? Object.getOwnPropertySymbols(target).filter(function(symbol) {
			return Object.propertyIsEnumerable.call(target, symbol)
		})
		: []
}

function getKeys(target) {
	return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target))
}

function propertyIsOnObject(object, property) {
	try {
		return property in object
	} catch(_) {
		return false
	}
}

// Protects from prototype poisoning and unexpected merging up the prototype chain.
function propertyIsUnsafe(target, key) {
	return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
		&& !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
			&& Object.propertyIsEnumerable.call(target, key)) // and also unsafe if they're nonenumerable.
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		getKeys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	getKeys(source).forEach(function(key) {
		if (propertyIsUnsafe(target, key)) {
			return
		}

		if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
			destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
		} else {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;
	// cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
	// implementations can use it. The caller may not replace it.
	options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

module.exports = deepmerge_1;


/***/ }),

/***/ 66471:
/***/ (function(module) {

"use strict";


// do not edit .js files directly - edit src/index.jst



module.exports = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }



    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      var key = keys[i];

      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  // true if both NaN, false otherwise
  return a!==a && b!==b;
};


/***/ }),

/***/ 27001:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports gql, resetCaches, disableFragmentWarnings, enableExperimentalFragmentVariables, disableExperimentalFragmentVariables */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59312);
/* harmony import */ var graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65449);


var docCache = new Map();
var fragmentSourceMap = new Map();
var printFragmentWarnings = true;
var experimentalFragmentVariables = false;
function normalize(string) {
    return string.replace(/[\s,]+/g, ' ').trim();
}
function cacheKeyFromLoc(loc) {
    return normalize(loc.source.body.substring(loc.start, loc.end));
}
function processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function (fragmentDefinition) {
        if (fragmentDefinition.kind === 'FragmentDefinition') {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if (printFragmentWarnings) {
                    console.warn("Warning: fragment with name " + fragmentName + " already exists.\n"
                        + "graphql-tag enforces all fragment names across your application to be unique; read more about\n"
                        + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
                }
            }
            else if (!sourceKeySet) {
                fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            }
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        }
        else {
            definitions.push(fragmentDefinition);
        }
    });
    return (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_0__.__assign)({}, ast), { definitions: definitions });
}
function stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function (node) {
        if (node.loc)
            delete node.loc;
        Object.keys(node).forEach(function (key) {
            var value = node[key];
            if (value && typeof value === 'object') {
                workSet.add(value);
            }
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function parseDocument(source) {
    var cacheKey = normalize(source);
    if (!docCache.has(cacheKey)) {
        var parsed = (0,graphql__WEBPACK_IMPORTED_MODULE_1__/* .parse */ .Qc)(source, {
            experimentalFragmentVariables: experimentalFragmentVariables,
            allowLegacyFragmentVariables: experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== 'Document') {
            throw new Error('Not a valid GraphQL document.');
        }
        docCache.set(cacheKey, stripLoc(processFragments(parsed)));
    }
    return docCache.get(cacheKey);
}
function gql(literals) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (typeof literals === 'string') {
        literals = [literals];
    }
    var result = literals[0];
    args.forEach(function (arg, i) {
        if (arg && arg.kind === 'Document') {
            result += arg.loc.source.body;
        }
        else {
            result += arg;
        }
        result += literals[i + 1];
    });
    return parseDocument(result);
}
function resetCaches() {
    docCache.clear();
    fragmentSourceMap.clear();
}
function disableFragmentWarnings() {
    printFragmentWarnings = false;
}
function enableExperimentalFragmentVariables() {
    experimentalFragmentVariables = true;
}
function disableExperimentalFragmentVariables() {
    experimentalFragmentVariables = false;
}
var extras = {
    gql: gql,
    resetCaches: resetCaches,
    disableFragmentWarnings: disableFragmentWarnings,
    enableExperimentalFragmentVariables: enableExperimentalFragmentVariables,
    disableExperimentalFragmentVariables: disableExperimentalFragmentVariables
};
(function (gql_1) {
    gql_1.gql = extras.gql, gql_1.resetCaches = extras.resetCaches, gql_1.disableFragmentWarnings = extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = extras.disableExperimentalFragmentVariables;
})(gql || (gql = {}));
gql["default"] = gql;
/* harmony default export */ __webpack_exports__["ZP"] = (gql);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 55839:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(19185);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 27207:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const isObject = __webpack_require__(83710)

function humanizeGraphQLResponse (input) {
  if (!input) return null
  const output = {}

  Object.keys(input).forEach(key => {
    if (input[key] && input[key].edges) {
      output[key] = input[key].edges.map(edge => humanizeGraphQLResponse(edge.node))
    } else if (isObject(input[key])) {
      output[key] = humanizeGraphQLResponse(input[key])
    } else {
      output[key] = input[key]
    }
  })

  return output
}

module.exports = humanizeGraphQLResponse


/***/ }),

/***/ 83710:
/***/ (function(module) {

module.exports = function isObject (obj) {
  return obj !== null && typeof obj === 'object' && !Array.isArray(obj)
}


/***/ }),

/***/ 78898:
/***/ (function(__unused_webpack_module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ 84447:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// the whatwg-fetch polyfill installs the fetch() function
// on the global object (window or self)
//
// Return that as the export for use in Webpack, Browserify etc.
__webpack_require__(42572);
module.exports = self.fetch.bind(self);


/***/ }),

/***/ 78916:
/***/ (function(module) {

module.exports = {
  space: '',
  cycles: false,
  replacer: (k, v) => v,
  stringify: JSON.stringify
}


/***/ }),

/***/ 77332:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const DEFAULTS = __webpack_require__(78916)
const isFunction = (__webpack_require__(99306).isFunction)
const isBoolean = (__webpack_require__(99306).isBoolean)
const isObject = (__webpack_require__(99306).isObject)
const isArray = (__webpack_require__(99306).isArray)
const isRegex = (__webpack_require__(99306).isRegex)
const assign = (__webpack_require__(99306).assign)
const keys = (__webpack_require__(99306).keys)

function serialize (obj) {
  if (obj === null || obj === undefined) return obj
  if (isRegex(obj)) return obj.toString()
  return obj.toJSON ? obj.toJSON() : obj
}

function stringifyDeterministic (obj, opts) {
  opts = opts || assign({}, DEFAULTS)

  if (isFunction(opts)) opts = { compare: opts }

  const space = opts.space || DEFAULTS.space
  const cycles = isBoolean(opts.cycles) ? opts.cycles : DEFAULTS.cycles
  const replacer = opts.replacer || DEFAULTS.replacer
  const stringify = opts.stringify || DEFAULTS.stringify

  const compare = opts.compare && (function (f) {
    return function (node) {
      return function (a, b) {
        const aobj = { key: a, value: node[a] }
        const bobj = { key: b, value: node[b] }
        return f(aobj, bobj)
      }
    }
  })(opts.compare)

  // Detect circular structure in obj and raise error efficiently.
  if (!cycles) stringify(obj)

  const seen = []

  return (function _deterministic (parent, key, node, level) {
    const indent = space ? ('\n' + new Array(level + 1).join(space)) : ''
    const colonSeparator = space ? ': ' : ':'

    node = serialize(node)
    node = replacer.call(parent, key, node)

    if (node === undefined) return

    if (!isObject(node) || node === null) return stringify(node)

    if (isArray(node)) {
      const out = []
      for (let i = 0; i < node.length; i++) {
        const item = _deterministic(node, i, node[i], level + 1) || stringify(null)
        out.push(indent + space + item)
      }
      return '[' + out.join(',') + indent + ']'
    } else {
      if (cycles) {
        if (seen.indexOf(node) !== -1) {
          return stringify('[Circular]')
        } else {
          seen.push(node)
        }
      }

      const nodeKeys = keys(node).sort(compare && compare(node))
      const out = []
      for (let i = 0; i < nodeKeys.length; i++) {
        const key = nodeKeys[i]
        const value = _deterministic(node, key, node[key], level + 1)

        if (!value) continue

        const keyValue = stringify(key) + colonSeparator + value
        out.push(indent + space + keyValue)
      }
      seen.splice(seen.indexOf(node), 1)
      return '{' + out.join(',') + indent + '}'
    }
  })({ '': obj }, '', obj, 0)
}

module.exports = stringifyDeterministic


/***/ }),

/***/ 99306:
/***/ (function(module) {

"use strict";


module.exports = {
  isArray: Array.isArray,
  assign: Object.assign,
  isObject: v => typeof v === 'object',
  isFunction: v => typeof v === 'function',
  isBoolean: v => typeof v === 'boolean',
  isRegex: v => v instanceof RegExp,
  keys: Object.keys
}


/***/ }),

/***/ 65763:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
    rsComboSymbolsRange = '\\u20d0-\\u20f0',
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]",
    rsAstral = '[' + rsAstralRange + ']',
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var rsLowerMisc = '(?:' + rsLower + '|' + rsMisc + ')',
    rsUpperMisc = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptLowerContr = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptUpperContr = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo, 'g');

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptLowerContr + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsUpperMisc + '+' + rsOptUpperContr + '(?=' + [rsBreak, rsUpper + rsLowerMisc, '$'].join('|') + ')',
  rsUpper + '?' + rsLowerMisc + '+' + rsOptLowerContr,
  rsUpper + '+' + rsOptUpperContr,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboMarksRange + rsComboSymbolsRange + rsVarRange + ']');

/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 'ss'
};

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array ? array.length : 0;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = basePropertyOf(deburredLetters);

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function(string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */
var camelCase = createCompounder(function(result, word, index) {
  word = word.toLowerCase();
  return result + (index ? capitalize(word) : word);
});

/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize(string) {
  return upperFirst(toString(string).toLowerCase());
}

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = toString(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = toString(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}

module.exports = camelCase;


/***/ }),

/***/ 62004:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    asyncTag = '[object AsyncFunction]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    nullTag = '[object Null]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    proxyTag = '[object Proxy]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    undefinedTag = '[object Undefined]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = isEqual;


/***/ }),

/***/ 78372:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
    rsComboSymbolsRange = '\\u20d0-\\u20f0',
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]",
    rsAstral = '[' + rsAstralRange + ']',
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var rsLowerMisc = '(?:' + rsLower + '|' + rsMisc + ')',
    rsUpperMisc = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptLowerContr = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptUpperContr = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo, 'g');

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptLowerContr + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsUpperMisc + '+' + rsOptUpperContr + '(?=' + [rsBreak, rsUpper + rsLowerMisc, '$'].join('|') + ')',
  rsUpper + '?' + rsLowerMisc + '+' + rsOptLowerContr,
  rsUpper + '+' + rsOptUpperContr,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboMarksRange + rsComboSymbolsRange + rsVarRange + ']');

/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 'ss'
};

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array ? array.length : 0;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = basePropertyOf(deburredLetters);

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function(string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = toString(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

/**
 * Converts `string` to
 * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
 *
 * @static
 * @memberOf _
 * @since 3.1.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the start cased string.
 * @example
 *
 * _.startCase('--foo-bar--');
 * // => 'Foo Bar'
 *
 * _.startCase('fooBar');
 * // => 'Foo Bar'
 *
 * _.startCase('__FOO_BAR__');
 * // => 'FOO BAR'
 */
var startCase = createCompounder(function(result, word, index) {
  return result + (index ? ' ' : '') + upperFirst(word);
});

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = toString(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}

module.exports = startCase;


/***/ }),

/***/ 62195:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to compose bitmasks for comparison styles. */
var UNORDERED_COMPARE_FLAG = 1,
    PARTIAL_COMPARE_FLAG = 2;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array ? array.length : 0;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  if (value !== value) {
    return baseFindIndex(array, baseIsNaN, fromIndex);
  }
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Checks if a cache value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values ? values.length : 0;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {boolean} [bitmask] The bitmask of comparison flags.
 *  The bitmask may be composed of the following flags:
 *     1 - Unordered comparison
 *     2 - Partial comparison
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, customizer, bitmask, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
}

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = arrayTag,
      othTag = arrayTag;

  if (!objIsArr) {
    objTag = getTag(object);
    objTag = objTag == argsTag ? objectTag : objTag;
  }
  if (!othIsArr) {
    othTag = getTag(other);
    othTag = othTag == argsTag ? objectTag : othTag;
  }
  var objIsObj = objTag == objectTag && !isHostObject(object),
      othIsObj = othTag == objectTag && !isHostObject(other),
      isSameTag = objTag == othTag;

  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
      : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
  }
  if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
}

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
  };
}

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & UNORDERED_COMPARE_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!seen.has(othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
              return seen.add(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, customizer, bitmask, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= UNORDERED_COMPARE_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
      objProps = keys(object),
      objLength = objProps.length,
      othProps = keys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = isKey(path, object) ? [path] : castPath(path);

  var result,
      index = -1,
      length = path.length;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result) {
    return result;
  }
  var length = object ? object.length : 0;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity]
 *  The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
function uniqBy(array, iteratee) {
  return (array && array.length)
    ? baseUniq(array, baseIteratee(iteratee, 2))
    : [];
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = uniqBy;


/***/ }),

/***/ 86312:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to compose bitmasks for comparison styles. */
var UNORDERED_COMPARE_FLAG = 1,
    PARTIAL_COMPARE_FLAG = 2;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array ? array.length : 0,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array ? array.length : 0;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  if (value !== value) {
    return baseFindIndex(array, baseIsNaN, fromIndex);
  }
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Checks if a cache value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object),
    nativeMax = Math.max;

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values ? values.length : 0;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference(array, values, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;

  if (!length) {
    return result;
  }
  if (iteratee) {
    values = arrayMap(values, baseUnary(iteratee));
  }
  if (comparator) {
    includes = arrayIncludesWith;
    isCommon = false;
  }
  else if (values.length >= LARGE_ARRAY_SIZE) {
    includes = cacheHas;
    isCommon = false;
    values = new SetCache(values);
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }
      result.push(value);
    }
    else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }
  return result;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {boolean} [bitmask] The bitmask of comparison flags.
 *  The bitmask may be composed of the following flags:
 *     1 - Unordered comparison
 *     2 - Partial comparison
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, customizer, bitmask, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
}

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = arrayTag,
      othTag = arrayTag;

  if (!objIsArr) {
    objTag = getTag(object);
    objTag = objTag == argsTag ? objectTag : objTag;
  }
  if (!othIsArr) {
    othTag = getTag(other);
    othTag = othTag == argsTag ? objectTag : othTag;
  }
  var objIsObj = objTag == objectTag && !isHostObject(object),
      othIsObj = othTag == objectTag && !isHostObject(other),
      isSameTag = objTag == othTag;

  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
      : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
  }
  if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
}

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
  };
}

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

/**
 * The base implementation of methods like `_.xor`, without support for
 * iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of values.
 */
function baseXor(arrays, iteratee, comparator) {
  var index = -1,
      length = arrays.length;

  while (++index < length) {
    var result = result
      ? arrayPush(
          baseDifference(result, arrays[index], iteratee, comparator),
          baseDifference(arrays[index], result, iteratee, comparator)
        )
      : arrays[index];
  }
  return (result && result.length) ? baseUniq(result, iteratee, comparator) : [];
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & UNORDERED_COMPARE_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!seen.has(othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
              return seen.add(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, customizer, bitmask, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= UNORDERED_COMPARE_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
      objProps = keys(object),
      objLength = objProps.length,
      othProps = keys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = isKey(path, object) ? [path] : castPath(path);

  var result,
      index = -1,
      length = path.length;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result) {
    return result;
  }
  var length = object ? object.length : 0;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array ? array.length : 0;
  return length ? array[length - 1] : undefined;
}

/**
 * This method is like `_.xor` except that it accepts `iteratee` which is
 * invoked for each element of each `arrays` to generate the criterion by
 * which by which they're compared. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [iteratee=_.identity]
 *  The iteratee invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
 * // => [1.2, 3.4]
 *
 * // The `_.property` iteratee shorthand.
 * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 2 }]
 */
var xorBy = baseRest(function(arrays) {
  var iteratee = last(arrays);
  if (isArrayLikeObject(iteratee)) {
    iteratee = undefined;
  }
  return baseXor(arrayFilter(arrays, isArrayLikeObject), baseIteratee(iteratee, 2));
});

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = xorBy;


/***/ }),

/***/ 98784:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports =  true && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else {}
}.call(this));


/***/ }),

/***/ 18425:
/***/ (function(module) {

(function(f){if(true){module.exports=f()}else { var g; }})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=undefined;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=undefined;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
module.exports = function(forceSimilar) {
	if (typeof Map !== 'function' || forceSimilar) {
		var Similar = _dereq_('./similar');
		return new Similar();
	}
	else {
		return new Map();
	}
}

},{"./similar":2}],2:[function(_dereq_,module,exports){
function Similar() {
	this.list = [];
	this.lastItem = undefined;
	this.size = 0;

	return this;
}

Similar.prototype.get = function(key) {
	var index;

	if (this.lastItem && this.isEqual(this.lastItem.key, key)) {
		return this.lastItem.val;
	}

	index = this.indexOf(key);
	if (index >= 0) {
		this.lastItem = this.list[index];
		return this.list[index].val;
	}

	return undefined;
};

Similar.prototype.set = function(key, val) {
	var index;

	if (this.lastItem && this.isEqual(this.lastItem.key, key)) {
		this.lastItem.val = val;
		return this;
	}

	index = this.indexOf(key);
	if (index >= 0) {
		this.lastItem = this.list[index];
		this.list[index].val = val;
		return this;
	}

	this.lastItem = { key: key, val: val };
	this.list.push(this.lastItem);
	this.size++;

	return this;
};

Similar.prototype.delete = function(key) {
	var index;

	if (this.lastItem && this.isEqual(this.lastItem.key, key)) {
		this.lastItem = undefined;
	}

	index = this.indexOf(key);
	if (index >= 0) {
		this.size--;
		return this.list.splice(index, 1)[0];
	}

	return undefined;
};


// important that has() doesn't use get() in case an existing key has a falsy value, in which case has() would return false
Similar.prototype.has = function(key) {
	var index;

	if (this.lastItem && this.isEqual(this.lastItem.key, key)) {
		return true;
	}

	index = this.indexOf(key);
	if (index >= 0) {
		this.lastItem = this.list[index];
		return true;
	}

	return false;
};

Similar.prototype.forEach = function(callback, thisArg) {
	var i;
	for (i = 0; i < this.size; i++) {
		callback.call(thisArg || this, this.list[i].val, this.list[i].key, this);
	}
};

Similar.prototype.indexOf = function(key) {
	var i;
	for (i = 0; i < this.size; i++) {
		if (this.isEqual(this.list[i].key, key)) {
			return i;
		}
	}
	return -1;
};

// check if the numbers are equal, or whether they are both precisely NaN (isNaN returns true for all non-numbers)
Similar.prototype.isEqual = function(val1, val2) {
	return val1 === val2 || (val1 !== val1 && val2 !== val2);
};

module.exports = Similar;
},{}],3:[function(_dereq_,module,exports){
var MapOrSimilar = _dereq_('map-or-similar');

module.exports = function (limit) {
	var cache = new MapOrSimilar(undefined === 'true'),
		lru = [];

	return function (fn) {
		var memoizerific = function () {
			var currentCache = cache,
				newMap,
				fnResult,
				argsLengthMinusOne = arguments.length - 1,
				lruPath = Array(argsLengthMinusOne + 1),
				isMemoized = true,
				i;

			if ((memoizerific.numArgs || memoizerific.numArgs === 0) && memoizerific.numArgs !== argsLengthMinusOne + 1) {
				throw new Error('Memoizerific functions should always be called with the same number of arguments');
			}

			// loop through each argument to traverse the map tree
			for (i = 0; i < argsLengthMinusOne; i++) {
				lruPath[i] = {
					cacheItem: currentCache,
					arg: arguments[i]
				};

				// climb through the hierarchical map tree until the second-last argument has been found, or an argument is missing.
				// if all arguments up to the second-last have been found, this will potentially be a cache hit (determined later)
				if (currentCache.has(arguments[i])) {
					currentCache = currentCache.get(arguments[i]);
					continue;
				}

				isMemoized = false;

				// make maps until last value
				newMap = new MapOrSimilar(undefined === 'true');
				currentCache.set(arguments[i], newMap);
				currentCache = newMap;
			}

			// we are at the last arg, check if it is really memoized
			if (isMemoized) {
				if (currentCache.has(arguments[argsLengthMinusOne])) {
					fnResult = currentCache.get(arguments[argsLengthMinusOne]);
				}
				else {
					isMemoized = false;
				}
			}

			if (!isMemoized) {
				fnResult = fn.apply(null, arguments);
				currentCache.set(arguments[argsLengthMinusOne], fnResult);
			}

			if (limit > 0) {
				lruPath[argsLengthMinusOne] = {
					cacheItem: currentCache,
					arg: arguments[argsLengthMinusOne]
				};

				if (isMemoized) {
					moveToMostRecentLru(lru, lruPath);
				}
				else {
					lru.push(lruPath);
				}

				if (lru.length > limit) {
					removeCachedResult(lru.shift());
				}
			}

			memoizerific.wasMemoized = isMemoized;
			memoizerific.numArgs = argsLengthMinusOne + 1;

			return fnResult;
		};

		memoizerific.limit = limit;
		memoizerific.wasMemoized = false;
		memoizerific.cache = cache;
		memoizerific.lru = lru;

		return memoizerific;
	};
};

// move current args to most recent position
function moveToMostRecentLru(lru, lruPath) {
	var lruLen = lru.length,
		lruPathLen = lruPath.length,
		isMatch,
		i, ii;

	for (i = 0; i < lruLen; i++) {
		isMatch = true;
		for (ii = 0; ii < lruPathLen; ii++) {
			if (!isEqual(lru[i][ii].arg, lruPath[ii].arg)) {
				isMatch = false;
				break;
			}
		}
		if (isMatch) {
			break;
		}
	}

	lru.push(lru.splice(i, 1)[0]);
}

// remove least recently used cache item and all dead branches
function removeCachedResult(removedLru) {
	var removedLruLen = removedLru.length,
		currentLru = removedLru[removedLruLen - 1],
		tmp,
		i;

	currentLru.cacheItem.delete(currentLru.arg);

	// walk down the tree removing dead branches (size 0) along the way
	for (i = removedLruLen - 2; i >= 0; i--) {
		currentLru = removedLru[i];
		tmp = currentLru.cacheItem.get(currentLru.arg);

		if (!tmp || !tmp.size) {
			currentLru.cacheItem.delete(currentLru.arg);
		} else {
			break;
		}
	}
}

// check if the numbers are equal, or whether they are both precisely NaN (isNaN returns true for all non-numbers)
function isEqual(val1, val2) {
	return val1 === val2 || (val1 !== val1 && val2 !== val2);
}
},{"map-or-similar":1}]},{},[3])(3)
});

/***/ }),

/***/ 14195:
/***/ (function(module) {

"use strict";


function Cache () {
  var _cache = Object.create(null);
  var _hitCount = 0;
  var _missCount = 0;
  var _size = 0;
  var _debug = false;

  this.put = function(key, value, time, timeoutCallback) {
    if (_debug) {
      console.log('caching: %s = %j (@%s)', key, value, time);
    }

    if (typeof time !== 'undefined' && (typeof time !== 'number' || isNaN(time) || time <= 0)) {
      throw new Error('Cache timeout must be a positive number');
    } else if (typeof timeoutCallback !== 'undefined' && typeof timeoutCallback !== 'function') {
      throw new Error('Cache timeout callback must be a function');
    }

    var oldRecord = _cache[key];
    if (oldRecord) {
      clearTimeout(oldRecord.timeout);
    } else {
      _size++;
    }

    var record = {
      value: value,
      expire: time + Date.now()
    };

    if (!isNaN(record.expire)) {
      record.timeout = setTimeout(function() {
        _del(key);
        if (timeoutCallback) {
          timeoutCallback(key, value);
        }
      }.bind(this), time);
    }

    _cache[key] = record;

    return value;
  };

  this.del = function(key) {
    var canDelete = true;

    var oldRecord = _cache[key];
    if (oldRecord) {
      clearTimeout(oldRecord.timeout);
      if (!isNaN(oldRecord.expire) && oldRecord.expire < Date.now()) {
        canDelete = false;
      }
    } else {
      canDelete = false;
    }

    if (canDelete) {
      _del(key);
    }

    return canDelete;
  };

  function _del(key){
    _size--;
    delete _cache[key];
  }

  this.clear = function() {
    for (var key in _cache) {
      clearTimeout(_cache[key].timeout);
    }
    _size = 0;
    _cache = Object.create(null);
    if (_debug) {
      _hitCount = 0;
      _missCount = 0;
    }
  };

  this.get = function(key) {
    var data = _cache[key];
    if (typeof data != "undefined") {
      if (isNaN(data.expire) || data.expire >= Date.now()) {
        if (_debug) _hitCount++;
        return data.value;
      } else {
        // free some space
        if (_debug) _missCount++;
        _size--;
        delete _cache[key];
      }
    } else if (_debug) {
      _missCount++;
    }
    return null;
  };

  this.size = function() {
    return _size;
  };

  this.memsize = function() {
    var size = 0,
      key;
    for (key in _cache) {
      size++;
    }
    return size;
  };

  this.debug = function(bool) {
    _debug = bool;
  };

  this.hits = function() {
    return _hitCount;
  };

  this.misses = function() {
    return _missCount;
  };

  this.keys = function() {
    return Object.keys(_cache);
  };

  this.exportJson = function() {
    var plainJsCache = {};

    // Discard the `timeout` property.
    // Note: JSON doesn't support `NaN`, so convert it to `'NaN'`.
    for (var key in _cache) {
      var record = _cache[key];
      plainJsCache[key] = {
        value: record.value,
        expire: record.expire || 'NaN',
      };
    }

    return JSON.stringify(plainJsCache);
  };

  this.importJson = function(jsonToImport, options) {
    var cacheToImport = JSON.parse(jsonToImport);
    var currTime = Date.now();

    var skipDuplicates = options && options.skipDuplicates;

    for (var key in cacheToImport) {
      if (cacheToImport.hasOwnProperty(key)) {
        if (skipDuplicates) {
          var existingRecord = _cache[key];
          if (existingRecord) {
            if (_debug) {
              console.log('Skipping duplicate imported key \'%s\'', key);
            }
            continue;
          }
        }

        var record = cacheToImport[key];

        // record.expire could be `'NaN'` if no expiry was set.
        // Try to subtract from it; a string minus a number is `NaN`, which is perfectly fine here.
        var remainingTime = record.expire - currTime;

        if (remainingTime <= 0) {
          // Delete any record that might exist with the same key, since this key is expired.
          this.del(key);
          continue;
        }

        // Remaining time must now be either positive or `NaN`,
        // but `put` will throw an error if we try to give it `NaN`.
        remainingTime = remainingTime > 0 ? remainingTime : undefined;

        this.put(key, record.value, remainingTime);
      }
    }

    return this.size();
  };
}

module.exports = new Cache();
module.exports.Cache = Cache;


/***/ }),

/***/ 42572:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

/* globals self */ exports.Headers = self.Headers;
exports.Request = self.Request;
exports.Response = self.Response;
exports.fetch = self.fetch;

//# sourceMappingURL=whatwg-fetch.js.map

/***/ }),

/***/ 14284:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ref, ref1;
module.exports = ((ref = __webpack_require__.g.process) == null ? void 0 : ref.env) && typeof ((ref1 = __webpack_require__.g.process) == null ? void 0 : ref1.env) === "object" ? __webpack_require__.g.process : __webpack_require__(66118);

//# sourceMappingURL=process.js.map

/***/ }),

/***/ 6461:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(86302);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 93183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "iT": function() { return /* reexport */ AccountsAuthLoader; },
  "bg": function() { return /* reexport */ PageErrorBoundary; },
  "yG": function() { return /* reexport */ PageHead; },
  "iA": function() { return /* reexport */ Partytown_Partytown; },
  "UZ": function() { return /* reexport */ PreviewModeToast; },
  "$j": function() { return /* reexport */ Spinner_Spinner; }
});

// UNUSED EXPORTS: RoutingSpinner

// EXTERNAL MODULE: ../node_modules/theme-ui/jsx-runtime/dist/theme-ui-jsx-runtime.esm.js + 2 modules
var theme_ui_jsx_runtime_esm = __webpack_require__(70863);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ./src/_components/Spinner.module.css
var Spinner_module = __webpack_require__(34386);
var Spinner_module_default = /*#__PURE__*/__webpack_require__.n(Spinner_module);
;// CONCATENATED MODULE: ./src/_components/Spinner.jsx



function Spinner_Spinner(props) {
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: (Spinner_module_default()).spinner,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.25 3C11.25 2.58579 11.5858 2.25 12 2.25C17.3848 2.25 21.75 6.61522 21.75 12C21.75 17.3848 17.3848 21.75 12 21.75C6.61522 21.75 2.25 17.3848 2.25 12C2.25 10.4448 2.61468 8.97258 3.26388 7.66623C3.44822 7.29529 3.89836 7.14403 4.26929 7.32836C4.64023 7.5127 4.79149 7.96284 4.60716 8.33377C4.05873 9.43734 3.75 10.6815 3.75 12C3.75 16.5563 7.44365 20.25 12 20.25C16.5563 20.25 20.25 16.5563 20.25 12C20.25 7.44365 16.5563 3.75 12 3.75C11.5858 3.75 11.25 3.41421 11.25 3Z",
            fill: props.color || "#1F2937"
        })
    });
}

;// CONCATENATED MODULE: ./src/_components/AccountsAuthLoader.jsx



function AccountsAuthLoader(param) {
    var _minHeight = param.minHeight, minHeight = _minHeight === void 0 ? 650 : _minHeight, _width = param.width, width = _width === void 0 ? "100%" : _width;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
        style: {
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            margin: 0,
            width: width || "100%",
            minWidth: 0,
            minHeight: minHeight || 650
        },
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
            style: {
                boxSizing: "border-box",
                margin: 0,
                minWidth: 0
            },
            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Spinner_Spinner, {})
        })
    });
}

// EXTERNAL MODULE: ../node_modules/react-error-boundary/dist/react-error-boundary.umd.js
var react_error_boundary_umd = __webpack_require__(68715);
// EXTERNAL MODULE: ./src/_components/PageErrorBoundary.module.css
var PageErrorBoundary_module = __webpack_require__(11218);
var PageErrorBoundary_module_default = /*#__PURE__*/__webpack_require__.n(PageErrorBoundary_module);
;// CONCATENATED MODULE: ./src/_components/PageErrorBoundary.jsx




function PageError() {
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)("div", {
        role: "alert",
        style: {
            margin: 0,
            width: "100%",
            height: "100%",
            minWidth: 0,
            padding: "16px",
            boxSizing: "border-box"
        },
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                className: (PageErrorBoundary_module_default()).skeletonBox,
                style: {
                    width: "100%",
                    height: "320px",
                    marginBottom: "24px"
                }
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                className: (PageErrorBoundary_module_default()).skeletonBox,
                style: {
                    width: "100%",
                    height: "24px",
                    marginBottom: "8px"
                }
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                className: (PageErrorBoundary_module_default()).skeletonBox,
                style: {
                    width: "80%",
                    height: "24px",
                    marginBottom: "8px"
                }
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                className: (PageErrorBoundary_module_default()).skeletonBox,
                style: {
                    width: "60%",
                    height: "24px",
                    marginBottom: "8px"
                }
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                className: (PageErrorBoundary_module_default()).skeletonBox,
                style: {
                    width: "60%",
                    height: "24px",
                    marginBottom: "8px"
                }
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                className: (PageErrorBoundary_module_default()).skeletonBox,
                style: {
                    width: "100%",
                    height: "24px",
                    marginBottom: "24px"
                }
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)("div", {
                style: {
                    display: "flex",
                    gap: "16px",
                    marginBottom: "24px"
                },
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                        className: (PageErrorBoundary_module_default()).skeletonBox,
                        style: {
                            width: "100%",
                            height: "100%",
                            aspectRatio: "1 / 1"
                        }
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                        className: (PageErrorBoundary_module_default()).skeletonBox,
                        style: {
                            width: "100%",
                            height: "100%",
                            aspectRatio: "1 / 1"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                className: (PageErrorBoundary_module_default()).skeletonBox,
                style: {
                    width: "100%",
                    height: "24px",
                    marginBottom: "24px"
                }
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                className: (PageErrorBoundary_module_default()).skeletonBox,
                style: {
                    width: "100%",
                    height: "320px",
                    marginBottom: "24px"
                }
            })
        ]
    });
}
function PageErrorBoundary(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(react_error_boundary_umd.ErrorBoundary, {
        "data-comp": "PageErrorBoundary",
        FallbackComponent: PageError,
        children: children
    });
}

// EXTERNAL MODULE: ../node_modules/next/head.js
var head = __webpack_require__(88038);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./src/_components/PageHead.jsx
/* provided dependency */ var process = __webpack_require__(14284);



var backpackHeadUserConfig = {};
function PageHead(param) {
    var _page = param.page, page = _page === void 0 ? {} : _page, children = param.children;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    var resourceType = (page || {}).resourceType;
    var ref12 = (page === null || page === void 0 ? void 0 : page.seo) || {}, noIndex = ref12.noIndex, noFollow = ref12.noFollow;
    var index = noIndex ? "noindex" : "index";
    var follow = noFollow ? "nofollow" : "follow";
    var pageUrl = "";
    if (resourceType === "home_page") {
        pageUrl = "https://www.brumate.com";
    } else if (resourceType === "page") {
        pageUrl = "".concat("https://www.brumate.com", "/pages/").concat(page.handle);
    } else if (resourceType === "product_page") {
        pageUrl = "".concat("https://www.brumate.com", "/products/").concat(page.handle);
    } else if (resourceType === "collection_page") {
        pageUrl = "".concat("https://www.brumate.com", "/collections/").concat(page.handle);
    } else if (resourceType === "article") {
        pageUrl = "".concat("https://www.brumate.com", "/articles/").concat(page.handle);
    } else if (resourceType === "blog") {
        pageUrl = "".concat("https://www.brumate.com", "/blogs/").concat(page.handle);
    } else {
        pageUrl = "https://www.brumate.com";
    }
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_jsx_runtime_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("title", {
                        children: page === null || page === void 0 ? void 0 : (ref = page.seo) === null || ref === void 0 ? void 0 : ref.title
                    }, "page-title"),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("meta", {
                        name: "description",
                        content: page === null || page === void 0 ? void 0 : (ref1 = page.seo) === null || ref1 === void 0 ? void 0 : ref1.description
                    }, "page-description"),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("meta", {
                        name: "keywords",
                        content: page === null || page === void 0 ? void 0 : (ref2 = page.seo) === null || ref2 === void 0 ? void 0 : ref2.keywords
                    }, "page-keywords"),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("link", {
                        rel: "canonical",
                        href: pageUrl
                    }, "page-canonical-url"),
                    (page === null || page === void 0 ? void 0 : page.favicon) ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("link", {
                        rel: "shortcut icon",
                        href: page.favicon
                    }) : null,
                    (page === null || page === void 0 ? void 0 : (ref3 = page.seo) === null || ref3 === void 0 ? void 0 : ref3.image) ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_jsx_runtime_esm/* Fragment */.HY, {
                        children: [
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("meta", {
                                property: "og:image",
                                content: page.seo.image
                            }, "page:fb:image"),
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("meta", {
                                property: "og:image:alt",
                                content: (page === null || page === void 0 ? void 0 : (ref4 = page.seo) === null || ref4 === void 0 ? void 0 : ref4.title) || (backpackHeadUserConfig === null || backpackHeadUserConfig === void 0 ? void 0 : backpackHeadUserConfig.title)
                            }, "page:fb:image:alt"),
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("meta", {
                                name: "twitter:image",
                                content: page.seo.image
                            }, "page:twitter:image")
                        ]
                    }) : null,
                    process.env.FACEBOOK_APP_ID ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("meta", {
                        property: "fb:app_id",
                        content: process.env.FACEBOOK_APP_ID
                    }, "page:fb:app_id") : null,
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("meta", {
                        property: "og:url",
                        content: pageUrl
                    }, "page:fb:url"),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("meta", {
                        property: "og:type",
                        content: "website"
                    }, "page:fb:type"),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("meta", {
                        property: "og:title",
                        content: (page === null || page === void 0 ? void 0 : (ref5 = page.seo) === null || ref5 === void 0 ? void 0 : ref5.title) || (backpackHeadUserConfig === null || backpackHeadUserConfig === void 0 ? void 0 : backpackHeadUserConfig.title)
                    }, "page:fb:title"),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("meta", {
                        property: "og:description",
                        content: (page === null || page === void 0 ? void 0 : (ref6 = page.seo) === null || ref6 === void 0 ? void 0 : ref6.description) || (backpackHeadUserConfig === null || backpackHeadUserConfig === void 0 ? void 0 : backpackHeadUserConfig.description)
                    }, "page:fb:description"),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("meta", {
                        property: "og:locale",
                        content: backpackHeadUserConfig === null || backpackHeadUserConfig === void 0 ? void 0 : backpackHeadUserConfig.locale
                    }, "page:fb:locale"),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("meta", {
                        property: "og:author",
                        content: backpackHeadUserConfig === null || backpackHeadUserConfig === void 0 ? void 0 : backpackHeadUserConfig.description
                    }, "page:fb:author"),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("meta", {
                        name: "twitter:card",
                        content: "summary"
                    }, "page:twitter:card"),
                    (backpackHeadUserConfig === null || backpackHeadUserConfig === void 0 ? void 0 : (ref7 = backpackHeadUserConfig.social) === null || ref7 === void 0 ? void 0 : ref7.twitter) ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("meta", {
                        name: "twitter:site",
                        content: backpackHeadUserConfig.social.twitter
                    }, "page:twitter:site") : null,
                    (backpackHeadUserConfig === null || backpackHeadUserConfig === void 0 ? void 0 : (ref8 = backpackHeadUserConfig.social) === null || ref8 === void 0 ? void 0 : ref8.twitter) ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("meta", {
                        name: "twitter:creator",
                        content: backpackHeadUserConfig.social.twitter
                    }, "page:twitter:creator") : null,
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("meta", {
                        name: "twitter:url",
                        content: pageUrl
                    }, "page:twitter:url"),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("meta", {
                        name: "twitter:title",
                        content: (page === null || page === void 0 ? void 0 : (ref9 = page.seo) === null || ref9 === void 0 ? void 0 : ref9.title) || (backpackHeadUserConfig === null || backpackHeadUserConfig === void 0 ? void 0 : backpackHeadUserConfig.title)
                    }, "page:twitter:title"),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("meta", {
                        name: "twitter:description",
                        content: (page === null || page === void 0 ? void 0 : (ref10 = page.seo) === null || ref10 === void 0 ? void 0 : ref10.description) || (backpackHeadUserConfig === null || backpackHeadUserConfig === void 0 ? void 0 : backpackHeadUserConfig.description)
                    }, "page:twitter:description"),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("meta", {
                        name: "twitter:image:alt",
                        content: (page === null || page === void 0 ? void 0 : (ref11 = page.seo) === null || ref11 === void 0 ? void 0 : ref11.title) || (backpackHeadUserConfig === null || backpackHeadUserConfig === void 0 ? void 0 : backpackHeadUserConfig.title)
                    }, "page:twitter:image:alt"),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("meta", {
                        name: "robots",
                        content: "".concat(index, ",").concat(follow)
                    }, "default-all-search-engines-crawling"),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("meta", {
                        name: "googlebot",
                        content: "".concat(index, ",").concat(follow)
                    }, "default-google-engine-crawling")
                ]
            }),
            children
        ]
    });
}

;// CONCATENATED MODULE: ./src/_components/RoutingSpinner.jsx


function RoutingSpinner() {
    return /*#__PURE__*/ _jsx("div", {
        style: {
            width: "100%",
            height: "100%",
            position: "fixed",
            zIndex: "2147483647",
            pointerEvents: "none"
        },
        children: /*#__PURE__*/ _jsx("div", {
            style: {
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#374151cc"
            },
            children: /*#__PURE__*/ _jsx(Spinner, {
                color: "white"
            })
        })
    });
}

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
;// CONCATENATED MODULE: ../node_modules/@builder.io/partytown/integration/index.mjs
const PartytownSnippet = "/* Partytown 0.8.0 - MIT builder.io */\n!function(t,e,n,i,r,o,a,d,s,c,l,p){function u(){p||(p=1,\"/\"==(a=(o.lib||\"/~partytown/\")+(o.debug?\"debug/\":\"\"))[0]&&(s=e.querySelectorAll('script[type=\"text/partytown\"]'),i!=t?i.dispatchEvent(new CustomEvent(\"pt1\",{detail:t})):(d=setTimeout(f,1e4),e.addEventListener(\"pt0\",w),r?h(1):n.serviceWorker?n.serviceWorker.register(a+(o.swPath||\"partytown-sw.js\"),{scope:a}).then((function(t){t.active?h():t.installing&&t.installing.addEventListener(\"statechange\",(function(t){\"activated\"==t.target.state&&h()}))}),console.error):f())))}function h(t){c=e.createElement(t?\"script\":\"iframe\"),t||(c.setAttribute(\"style\",\"display:block;width:0;height:0;border:0;visibility:hidden\"),c.setAttribute(\"aria-hidden\",!0)),c.src=a+\"partytown-\"+(t?\"atomics.js?v=0.8.0\":\"sandbox-sw.html?\"+Date.now()),e.querySelector(o.sandboxParent||\"body\").appendChild(c)}function f(n,r){for(w(),i==t&&(o.forward||[]).map((function(e){delete t[e.split(\".\")[0]]})),n=0;n<s.length;n++)(r=e.createElement(\"script\")).innerHTML=s[n].innerHTML,e.head.appendChild(r);c&&c.parentNode.removeChild(c)}function w(){clearTimeout(d)}o=t.partytown||{},i==t&&(o.forward||[]).map((function(e){l=t,e.split(\".\").map((function(e,n,i){l=l[i[n]]=n+1<i.length?\"push\"==i[n+1]?[]:l[i[n]]||{}:function(){(t._ptf=t._ptf||[]).push(i,arguments)}}))})),\"complete\"==e.readyState?u():(t.addEventListener(\"DOMContentLoaded\",u),t.addEventListener(\"load\",u))}(window,document,navigator,top,window.crossOriginIsolated);";

const createSnippet = (config, snippetCode) => {
    const { forward = [], ...filteredConfig } = config || {};
    const configStr = JSON.stringify(filteredConfig, (k, v) => {
        if (typeof v === 'function') {
            v = String(v);
            if (v.startsWith(k + '(')) {
                v = 'function ' + v;
            }
        }
        return v;
    });
    return [
        `!(function(w,p,f,c){`,
        Object.keys(filteredConfig).length > 0
            ? `c=w[p]=Object.assign(w[p]||{},${configStr});`
            : `c=w[p]=w[p]||{};`,
        `c[f]=(c[f]||[])`,
        forward.length > 0 ? `.concat(${JSON.stringify(forward)})` : ``,
        `})(window,'partytown','forward');`,
        snippetCode,
    ].join('');
};

/**
 * The `type` attribute for Partytown scripts, which does two things:
 *
 * 1. Prevents the `<script>` from executing on the main thread.
 * 2. Is used as a selector so the Partytown library can find all scripts to execute in a web worker.
 *
 * @public
 */
const SCRIPT_TYPE = (/* unused pure expression or super */ null && (`text/partytown`));

/**
 * Function that returns the Partytown snippet as a string, which can be
 * used as the innerHTML of the inlined Partytown script in the head.
 *
 * @public
 */
const partytownSnippet = (config) => createSnippet(config, PartytownSnippet);



;// CONCATENATED MODULE: ../node_modules/@builder.io/partytown/react/index.mjs



/**
 * The React `<Partytown/>` component should be placed within the `<head>`
 * of the document. This component should work for SSR/SSG only HTML
 * (static HTML without javascript), clientside javascript only
 * (entire React app is build with clientside javascript),
 * and both SSR/SSG HTML that's then hydrated by the client.
 *
 * @public
 */
const Partytown = (props = {}) => {
    // purposely not using useState() or useEffect() so this component
    // can also work as a React Server Component
    // this check is only be done on the client, and skipped over on the server
    if (typeof document !== 'undefined' && !document._partytown) {
        if (!document.querySelector('script[data-partytown]')) {
            // the append script to document code should only run on the client
            // and only if the SSR'd script doesn't already exist within the document.
            // If the SSR'd script isn't found in the document, then this
            // must be a clientside only render. Append the partytown script
            // to the <head>.
            const scriptElm = document.createElement('script');
            scriptElm.dataset.partytown = '';
            scriptElm.innerHTML = partytownSnippet(props);
            document.head.appendChild(scriptElm);
        }
        // should only append this script once per document, and is not dynamic
        document._partytown = true;
    }
    // `dangerouslySetInnerHTML` only works for scripts rendered as HTML from SSR.
    // The added code will set the [type="data-pt-script"] attribute to the SSR rendered
    // <script>. If this code renders as SSR HTML, then on the client it'll execute
    // and add the attribute which will tell the Client JS of the component to NOT
    // add the same script to the <head>.
    const innerHTML = partytownSnippet(props) + 'document.currentScript.dataset.partytown="";';
    return react.createElement("script", { suppressHydrationWarning: true, dangerouslySetInnerHTML: { __html: innerHTML } });
};



;// CONCATENATED MODULE: ./src/_components/Partytown.jsx
/* provided dependency */ var Partytown_process = __webpack_require__(14284);
/* eslint-disable react/destructuring-assignment */ 





var isNetlify = "true" === "true";
var context = Partytown_process.env.CONTEXT;
var isDev =  false || context === "dev";
var isPreview = [
    "deploy-preview",
    "branch-deploy"
].includes(context);
var isProduction =  true || 0;
var getProxyUrl = function(url) {
    try {
        if (url.startsWith("http")) return url;
        if (isDev) {
            return "http://localhost:".concat(Partytown_process.env.PORT, "/proxy/").concat(url);
        }
        if (isPreview) {
            return "".concat(Partytown_process.env.DEPLOY_PRIME_URL, "/proxy/").concat(url);
        // could also be `${process.env.DEPLOY_URL}/proxy/${url}` (unique deploy url)
        }
        if (isProduction && isNetlify) {
            return "".concat(Partytown_process.env.URL, "/proxy/").concat(url);
        }
        return "".concat(window.location.origin, "/proxy/").concat(url);
    } catch (error) {
        return "".concat("https://www.brumate.com", "/proxy/").concat(url);
    }
};
var resolveUrl = function(url, location, type) {
    var host = url.host, pathname = url.pathname, search = url.search;
    return type === "script" && !pathname.startsWith("/proxy") ? new URL("".concat(location.origin, "/proxy/").concat(host).concat(pathname).concat(search)) : url;
};
function Partytown_Partytown(props) {
    var ref;
    if (props.enabled !== true) return null;
    var options = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        resolveUrl: props.resolveUrl || resolveUrl,
        loadScriptsOnMainThread: props === null || props === void 0 ? void 0 : (ref = props.loadScriptsOnMainThread) === null || ref === void 0 ? void 0 : ref.flatMap(getProxyUrl)
    });
    if (isDev && props.debug === "verbose") {
        console.log("partytown options", options);
    }
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)((head_default()), {
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Partytown, (0,_object_spread/* default */.Z)({}, options))
    });
}

// EXTERNAL MODULE: ./src/_components/PreviewModeToast.module.css
var PreviewModeToast_module = __webpack_require__(35309);
var PreviewModeToast_module_default = /*#__PURE__*/__webpack_require__.n(PreviewModeToast_module);
;// CONCATENATED MODULE: ./src/_components/PreviewModeToast.jsx




function Eye(props) {
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2.75 12c0-.338.136-.905.493-1.591a7.858 7.858 0 0 1 1.64-2.108C6.374 6.926 8.694 5.75 12 5.75c3.308 0 5.627 1.176 7.116 2.551a7.86 7.86 0 0 1 1.64 2.108c.358.686.494 1.253.494 1.591 0 .338-.136.905-.493 1.591a7.86 7.86 0 0 1-1.64 2.108c-1.49 1.375-3.81 2.551-7.117 2.551-3.308 0-5.627-1.176-7.116-2.551a7.858 7.858 0 0 1-1.64-2.108c-.358-.686-.494-1.253-.494-1.591ZM12 4.25c-3.692 0-6.373 1.324-8.134 2.949a9.356 9.356 0 0 0-1.953 2.517c-.424.814-.663 1.622-.663 2.284 0 .662.24 1.47.663 2.284a9.356 9.356 0 0 0 1.953 2.517C5.627 18.426 8.308 19.75 12 19.75s6.373-1.324 8.134-2.949a9.356 9.356 0 0 0 1.953-2.517c.424-.814.663-1.622.663-2.284 0-.662-.24-1.47-.663-2.284a9.355 9.355 0 0 0-1.953-2.517C18.373 5.574 15.692 4.25 12 4.25ZM9.75 12a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0ZM12 8.25a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5Z",
            fill: "currentColor"
        })
    }));
}
function PreviewModeToast() {
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)("div", {
        className: (PreviewModeToast_module_default()).container,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Eye, {
                style: {
                    width: 16,
                    height: 16,
                    minWidth: 16
                }
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("p", {
                className: (PreviewModeToast_module_default()).message,
                children: "You are currently previewing your storefront with draft content"
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("a", {
                href: "/api/exitEdit",
                title: "Leave preview mode",
                style: {
                    fontSize: 12,
                    textAlign: "right"
                },
                children: "Exit preview mode"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/_components/index.js









/***/ }),

/***/ 74424:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "yn": function() { return /* reexport */ useBodyScrollLock; },
  "Gc": function() { return /* reexport */ useBreakpoint; },
  "Sx": function() { return /* reexport */ useBreakpointValue; },
  "Ps": function() { return /* reexport */ useCJCookies; },
  "Wy": function() { return /* reexport */ useCartRedirect; },
  "T0": function() { return /* reexport */ useCartStatus; },
  "au": function() { return /* reexport */ useCountdown; },
  "KZ": function() { return /* reexport */ useDataLayerActions; },
  "Nr": function() { return /* reexport */ useDebounce; },
  "vk": function() { return /* reexport */ useEmailSignup; },
  "JE": function() { return /* reexport */ useFiltersSidebar; },
  "sC": function() { return /* reexport */ useGatedProduct; },
  "ZZ": function() { return /* reexport */ useGeolocation; },
  "tG": function() { return /* reexport */ useGiftWithPurchase; },
  "ns": function() { return /* reexport */ useInitSelectedVariant; },
  "N8": function() { return /* reexport */ useInitWishlist; },
  "_": function() { return /* reexport */ useLocalStorage; },
  "ag": function() { return /* reexport */ useMatchMedia_useMatchMedia; },
  "dd": function() { return /* reexport */ useModal; },
  "E4": function() { return /* reexport */ useOkendo; },
  "dO": function() { return /* reexport */ useOkendoScrollToReviews; },
  "BJ": function() { return /* reexport */ useOkendoStars; },
  "Ir": function() { return /* reexport */ useOverlay; },
  "ws": function() { return /* reexport */ usePackCookie; },
  "uE": function() { return /* reexport */ usePasswordProtected; },
  "FU": function() { return /* reexport */ usePickedSections; },
  "$E": function() { return /* reexport */ useProductInventoryByHandles; },
  "Ep": function() { return /* reexport */ useProductItemImages; },
  "$t": function() { return /* reexport */ useProductRecommendations; },
  "Fo": function() { return /* reexport */ useRebuy; },
  "JN": function() { return /* reexport */ useSearchspring; },
  "fo": function() { return /* reexport */ useSearchspringBeacon; },
  "gf": function() { return /* reexport */ useSelectedOptionIsAvailable; },
  "C": function() { return /* reexport */ useSelectedOptions; },
  "JM": function() { return /* reexport */ useSelectedPlan; },
  "BK": function() { return /* reexport */ useSelectedVariant; },
  "cy": function() { return /* reexport */ useSetHeaderHeightCssVar; },
  "ri": function() { return /* reexport */ useSetViewportHeightCssVar; },
  "bu": function() { return /* reexport */ useShopifyAnalytics; },
  "Xs": function() { return /* reexport */ useShopperId; },
  "Ap": function() { return /* reexport */ useSidebar; },
  "x0": function() { return /* reexport */ useTrackSettings; },
  "Ei": function() { return /* reexport */ useWishlist; }
});

// UNUSED EXPORTS: useBottomToIosFooterBar, useHideCustomizerBar, useLocalizedProducts, useLocalizedSelectedVariant

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(23842);
// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(59312);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/@backpackjs/storefront/dist/index.js
var dist = __webpack_require__(52031);
// EXTERNAL MODULE: ./src/store/index.js + 12 modules
var store = __webpack_require__(27695);
;// CONCATENATED MODULE: ./src/hooks/useSidebar.js





var useSidebar = function() {
    var router = (0,dist.useRouter)();
    var sidebar = (0,store/* useRecoilValue */.sJ)(store/* default.sidebar */.ZP.sidebar);
    var gotoSnapshot = (0,store/* useGotoRecoilSnapshot */.le)();
    var closeSidebar = (0,store/* useRecoilCallback */._8)(function(param) {
        var snapshot = param.snapshot;
        return /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var release, updatedState;
            return (0,tslib_es6.__generator)(this, function(_state) {
                release = snapshot.retain();
                try {
                    updatedState = snapshot.map(function(param) {
                        var set = param.set;
                        return set(store/* default.sidebar */.ZP.sidebar, null);
                    }).map(function(param) {
                        var set = param.set;
                        return set(store/* default.overlay */.ZP.overlay, false);
                    });
                    // update state
                    gotoSnapshot(updatedState);
                } finally{
                    release();
                }
                return [
                    2
                ];
            });
        });
    });
    var openSidebar = (0,store/* useRecoilCallback */._8)(function(param) {
        var snapshot = param.snapshot;
        return function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(type) {
                var release, updatedState;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    release = snapshot.retain();
                    if (!type) {
                        console.warn('A sidebar type not provided. Must be "cart", "search" or "colors"');
                        release();
                        return [
                            2
                        ];
                    }
                    try {
                        updatedState = snapshot.map(function(param) {
                            var set = param.set;
                            set(store/* default.sidebar */.ZP.sidebar, type || null);
                            set(store/* default.overlay */.ZP.overlay, true);
                            set(store/* default.modal */.ZP.modal, null);
                        });
                        // update state
                        gotoSnapshot(updatedState);
                    // animateIn
                    // eg — await animations.revealDrawer();
                    } finally{
                        release();
                    }
                    return [
                        2
                    ];
                });
            });
            return function(type) {
                return _ref.apply(this, arguments);
            };
        }();
    });
    var openCartSidebar = (0,react.useCallback)(function() {
        openSidebar("cart");
    }, []);
    var openSearchSidebar = (0,react.useCallback)(function() {
        openSidebar("search");
    }, []);
    var openColorsSidebar = (0,react.useCallback)(function() {
        openSidebar("colors");
    }, []);
    var closeSidebarToNavigate = (0,store/* useRecoilCallback */._8)(function(param) {
        var snapshot = param.snapshot;
        return /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var release, updatedState;
            return (0,tslib_es6.__generator)(this, function(_state) {
                release = snapshot.retain();
                try {
                    updatedState = snapshot.map(function(param) {
                        var set = param.set;
                        set(store/* default.sidebar */.ZP.sidebar, null);
                        set(store/* default.overlay */.ZP.overlay, false);
                        set(store/* default.selectedItem */.ZP.selectedItem, false);
                        set(store/* default.menuSidebar */.ZP.menuSidebar, false);
                        set(store/* default.modal */.ZP.modal, null);
                    });
                    // update state
                    gotoSnapshot(updatedState);
                } finally{
                    release();
                }
                return [
                    2
                ];
            });
        });
    });
    return [
        // state
        {
            sidebar: sidebar,
            isCart: sidebar === "cart",
            isSearch: sidebar === "search",
            isColors: sidebar === "colors"
        },
        // actions
        {
            closeSidebar: closeSidebar,
            openSidebar: openSidebar,
            openCartSidebar: openCartSidebar,
            openSearchSidebar: openSearchSidebar,
            openColorsSidebar: openColorsSidebar,
            closeSidebarToNavigate: closeSidebarToNavigate
        }, 
    ];
};

// EXTERNAL MODULE: ../node_modules/recoil/es/index.js
var es = __webpack_require__(69853);
;// CONCATENATED MODULE: ./src/hooks/useModal.js


 // todo expose on @backpackjs/storefront

var useModal = function() {
    var gotoSnapshot = (0,es.useGotoRecoilSnapshot)();
    var modal = (0,store/* useRecoilValue */.sJ)(store/* default.modal */.ZP.modal);
    var closeModal = (0,store/* useRecoilCallback */._8)(function(param) {
        var snapshot = param.snapshot;
        return /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var release, updatedState;
            return (0,tslib_es6.__generator)(this, function(_state) {
                release = snapshot.retain();
                try {
                    updatedState = snapshot.map(function(param) {
                        var set = param.set;
                        return set(store/* default.modal */.ZP.modal, null);
                    }).map(function(param) {
                        var set = param.set;
                        return set(store/* default.overlay */.ZP.overlay, false);
                    });
                    // update state
                    gotoSnapshot(updatedState);
                } finally{
                    release();
                }
                return [
                    2
                ];
            });
        });
    });
    var openModal = (0,store/* useRecoilCallback */._8)(function(param) {
        var snapshot = param.snapshot;
        return function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(modalChildren, fromSidebar) {
                var release, updatedState;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    release = snapshot.retain();
                    try {
                        updatedState = snapshot.map(function(param) {
                            var set = param.set;
                            set(store/* default.modal */.ZP.modal, modalChildren);
                            set(store/* default.overlay */.ZP.overlay, true);
                            if (fromSidebar) {
                                set(store/* default.sidebar */.ZP.sidebar, false);
                            }
                        });
                        // update state
                        gotoSnapshot(updatedState);
                    } finally{
                        release();
                    }
                    return [
                        2
                    ];
                });
            });
            return function(modalChildren, fromSidebar) {
                return _ref.apply(this, arguments);
            };
        }();
    });
    return [
        // state
        {
            modal: modal
        },
        // actions
        {
            closeModal: closeModal,
            openModal: openModal
        }, 
    ];
};

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(52050);
;// CONCATENATED MODULE: ./src/hooks/useOverlay.js






var useOverlay = function() {
    var gotoSnapshot = (0,store/* useGotoRecoilSnapshot */.le)();
    var overlay = (0,store/* useRecoilValue */.sJ)(store/* default.overlay */.ZP.overlay);
    var ref = useBodyScrollLock(), lockScroll = ref.lockScroll, unlockScroll = ref.unlockScroll;
    var ref1 = (0,_sliced_to_array/* default */.Z)(useFiltersSidebar(), 2), closeFiltersSidebar = ref1[1].closeFiltersSidebar;
    var closeOverlay = (0,store/* useRecoilCallback */._8)(function(param) {
        var snapshot = param.snapshot;
        return /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var release, updatedState;
            return (0,tslib_es6.__generator)(this, function(_state) {
                release = snapshot.retain();
                try {
                    updatedState = snapshot.map(function(param) {
                        var set = param.set;
                        return set(store/* default.modal */.ZP.modal, null);
                    }).map(function(param) {
                        var set = param.set;
                        return set(store/* default.sidebar */.ZP.sidebar, false);
                    }).map(function(param) {
                        var set = param.set;
                        return set(store/* default.overlay */.ZP.overlay, false);
                    });
                    // update state
                    gotoSnapshot(updatedState);
                } finally{
                    release();
                }
                closeFiltersSidebar();
                return [
                    2
                ];
            });
        });
    }, []);
    (0,react.useEffect)(function() {
        if (overlay) {
            lockScroll();
        } else {
            unlockScroll();
        }
    }, [
        overlay
    ]);
    return [
        {
            overlay: overlay
        },
        {
            closeOverlay: closeOverlay
        }
    ];
};

;// CONCATENATED MODULE: ./src/hooks/useFiltersSidebar.js



var useFiltersSidebar = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* default.filtersSidebar */.ZP.filtersSidebar), 2), filtersSidebar = ref[0], setFiltersSidebar = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* default.overlay */.ZP.overlay), 2), overlay = ref1[0], setOverlay = ref1[1];
    var toggleFiltersSidebar = (0,react.useCallback)(function(content) {
        setFiltersSidebar(filtersSidebar ? null : content || null);
        setOverlay(!filtersSidebar);
    }, [
        filtersSidebar
    ]);
    var closeFiltersSidebar = (0,react.useCallback)(function() {
        setFiltersSidebar(null);
    }, [
        filtersSidebar
    ]);
    return [
        // state
        {
            filtersSidebar: filtersSidebar,
            isSize: (filtersSidebar === null || filtersSidebar === void 0 ? void 0 : filtersSidebar.isSize) || false,
            isFiltersAndSort: (filtersSidebar === null || filtersSidebar === void 0 ? void 0 : filtersSidebar.isFiltersAndSort) || false,
            isSearchPage: (filtersSidebar === null || filtersSidebar === void 0 ? void 0 : filtersSidebar.isSearchPage) || false
        },
        // actions
        {
            toggleFiltersSidebar: toggleFiltersSidebar,
            closeFiltersSidebar: closeFiltersSidebar
        }, 
    ];
};

// EXTERNAL MODULE: ./src/utils/index.js + 7 modules
var utils = __webpack_require__(39136);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(86677);
;// CONCATENATED MODULE: ./src/hooks/useGeolocation.js





var requestGeolocation = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var url, response, err;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        4,
                        ,
                        5
                    ]);
                    url = "/api/geolocation";
                    return [
                        4,
                        fetch(url)
                    ];
                case 1:
                    response = _state.sent();
                    if (!response.ok) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
                case 3:
                    return [
                        2,
                        {}
                    ];
                case 4:
                    err = _state.sent();
                    throw new Error(err);
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function requestGeolocation() {
        return _ref.apply(this, arguments);
    };
}();
var useGeolocation = function() {
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        if (!utils/* isBrowser */.jU) return;
        var getGeo = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var data, countryCode, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                requestGeolocation()
                            ];
                        case 1:
                            data = _state.sent();
                            countryCode = data === null || data === void 0 ? void 0 : data["x-country"];
                            if (countryCode) {
                                if (countryCode === "JP") {
                                    router.replace("https://www.brumate.jp/");
                                } else if (countryCode === "GB") {
                                    router.replace("https://www.brumate.co.uk/");
                                }
                            }
                            return [
                                3,
                                3
                            ];
                        case 2:
                            error = _state.sent();
                            console.log("useGeolocation:error", error.message);
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function getGeo() {
                return _ref.apply(this, arguments);
            };
        }();
        getGeo();
    }, []);
};

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(31373);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3204);
;// CONCATENATED MODULE: ./src/hooks/usePasswordProtected.js








var DEBUG = false;
var getExpirationDate = function() {
    var now = new Date();
    var time = now.getTime();
    var expireTime = time + 1000 * 604800; // 7 days
    now.setTime(expireTime);
    return now;
};
var usePasswordProtected = function() {
    var asPath = (0,next_router.useRouter)().asPath;
    var settings = (0,dist.useSettings)();
    var gatedPages = ((0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : settings.gatedPages) || {}).gatedPages;
    var ref = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* default.hasAccess */.ZP.hasAccess), 2), hasAccess = ref[0], setHasAccess = ref[1];
    var ref1 = (0,react.useState)(false), hasCookie = ref1[0], setHasCookie = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* default.gatedPage */.ZP.gatedPage), 2), gatedPage = ref2[0], setGatedPage = ref2[1];
    var ref3 = (0,react.useState)(false), showErrorMessage = ref3[0], setShowErrorMessage = ref3[1];
    var _ref = (0,dist.useStartFinishErrors)(), setStarted = _ref.setStarted, setFinished = _ref.setFinished, setErrors = _ref.setErrors, reset = _ref.reset, status = (0,_object_without_properties/* default */.Z)(_ref, [
        "setStarted",
        "setFinished",
        "setErrors",
        "reset"
    ]);
    // gatedPage needs to be store in global state
    var getGatedPage = (0,react.useCallback)(function() {
        var _gatedPage = !!(gatedPages === null || gatedPages === void 0 ? void 0 : gatedPages.length) && (gatedPages === null || gatedPages === void 0 ? void 0 : gatedPages.find(function(param) {
            var enable = param.enable, page = param.page;
            var pages = (0,_object_spread/* default */.Z)({}, page).pages;
            if (!enable) return false;
            var pageAndProductUrls = (pages === null || pages === void 0 ? void 0 : pages.reduce(function(carry, _page) {
                var ref, ref1, ref2;
                var productHandles = (ref1 = _page === null || _page === void 0 ? void 0 : (ref = _page.products) === null || ref === void 0 ? void 0 : ref.map(function(param) {
                    var product = param.product;
                    return "/products/".concat(product === null || product === void 0 ? void 0 : product.handle);
                })) === null || ref1 === void 0 ? void 0 : ref1.filter(Boolean);
                return (ref2 = (0,_to_consumable_array/* default */.Z)(carry).concat((0,_to_consumable_array/* default */.Z)(productHandles || []), [
                    (_page === null || _page === void 0 ? void 0 : _page.pageUrl) || null, 
                ])) === null || ref2 === void 0 ? void 0 : ref2.filter(Boolean);
            }, [])) || [];
            return pageAndProductUrls === null || pageAndProductUrls === void 0 ? void 0 : pageAndProductUrls.some(function(url) {
                return url === (asPath === null || asPath === void 0 ? void 0 : asPath.split("?")[0]);
            });
        }));
        if (_gatedPage) {
            setGatedPage(_gatedPage);
        } else {
            setGatedPage(null);
        }
    }, [
        asPath,
        gatedPages
    ]);
    // creates an array of product handles used as reference to hide from search results
    var hiddenProductHandles = (0,react.useMemo)(function() {
        return !!(gatedPages === null || gatedPages === void 0 ? void 0 : gatedPages.length) && gatedPages.reduce(function(carry, param) {
            var enable = param.enable, page = param.page;
            if (enable) {
                var pages = (0,_object_spread/* default */.Z)({}, page).pages;
                var _products = pages === null || pages === void 0 ? void 0 : pages.reduce(function(_carry, _page) {
                    var ref, ref1;
                    return (0,_to_consumable_array/* default */.Z)(_carry).concat((0,_to_consumable_array/* default */.Z)(((ref1 = _page === null || _page === void 0 ? void 0 : (ref = _page.products) === null || ref === void 0 ? void 0 : ref.map(function(param) {
                        var product = param.product;
                        return product === null || product === void 0 ? void 0 : product.handle;
                    })) === null || ref1 === void 0 ? void 0 : ref1.filter(Boolean)) || []));
                }, []);
                return (0,_to_consumable_array/* default */.Z)(carry).concat((0,_to_consumable_array/* default */.Z)(_products || []));
            }
            return carry;
        }, []);
    }, [
        gatedPages
    ]);
    var requiredPassword = (0,react.useMemo)(function() {
        var ref;
        return gatedPage === null || gatedPage === void 0 ? void 0 : (ref = gatedPage.password) === null || ref === void 0 ? void 0 : ref.password;
    }, [
        gatedPage
    ]);
    var submitPassword = (0,react.useCallback)(function(passwordInput) {
        if (passwordInput && (requiredPassword === null || requiredPassword === void 0 ? void 0 : requiredPassword.toLowerCase()) === (passwordInput === null || passwordInput === void 0 ? void 0 : passwordInput.toLowerCase())) {
            var ref;
            var gatedPagePasswords = null;
            (ref = document.cookie) === null || ref === void 0 ? void 0 : ref.split(/\s*;\s*/).find(function(cookie) {
                var ref = (0,_sliced_to_array/* default */.Z)(cookie.split(/\s*=\s*/), 2), key = ref[0], value = ref[1];
                if (key !== "gated_page_passwords") return false;
                gatedPagePasswords = value;
                return true;
            });
            DEBUG && console.log("password entered was successful...");
            var passwords = gatedPagePasswords ? JSON.parse(gatedPagePasswords) : [];
            if (!gatedPagePasswords) {
                var ref1;
                // if cookie doesn't exist, create one with password
                document.cookie = "gated_page_passwords=".concat(JSON.stringify([
                    requiredPassword === null || requiredPassword === void 0 ? void 0 : requiredPassword.toLowerCase(), 
                ]), ";expires=").concat((ref1 = getExpirationDate()) === null || ref1 === void 0 ? void 0 : ref1.toUTCString());
                DEBUG && console.log("creating cookie with saved password...");
            } else if (!passwords.some(function(password) {
                return (password === null || password === void 0 ? void 0 : password.toLowerCase()) === (requiredPassword === null || requiredPassword === void 0 ? void 0 : requiredPassword.toLowerCase());
            })) {
                var ref2;
                // if cookie already exists, add additional password if cookie doesn't contain password
                passwords.push(requiredPassword);
                document.cookie = "gated_page_passwords=".concat(JSON.stringify(passwords), ";expires=").concat((ref2 = getExpirationDate()) === null || ref2 === void 0 ? void 0 : ref2.toUTCString());
                DEBUG && console.log("updating cookie with saved passwords...");
            }
            setHasCookie(true);
        } else {
            setShowErrorMessage(true);
        }
    }, [
        requiredPassword
    ]);
    (0,react.useEffect)(function() {
        reset();
        setStarted(true);
        getGatedPage();
    }, [
        asPath,
        gatedPages
    ]);
    (0,react.useEffect)(function() {
        var checkCookie = function() {
            var ref;
            var gatedPagePasswords = null;
            (ref = document.cookie) === null || ref === void 0 ? void 0 : ref.split(/\s*;\s*/).find(function(cookie) {
                var ref = (0,_sliced_to_array/* default */.Z)(cookie.split(/\s*=\s*/), 2), key = ref[0], value = ref[1];
                if (key !== "gated_page_passwords") return false;
                gatedPagePasswords = value;
                return true;
            });
            var passwords = gatedPagePasswords ? JSON.parse(gatedPagePasswords) : [];
            DEBUG && console.log("passwords:", passwords);
            if (passwords.some(function(password) {
                return (password === null || password === void 0 ? void 0 : password.toLowerCase()) === (requiredPassword === null || requiredPassword === void 0 ? void 0 : requiredPassword.toLowerCase());
            })) {
                DEBUG && console.log("has cookie with password");
                setHasCookie(true);
            } else {
                DEBUG && console.log("does not have cookie with password");
                setHasCookie(false);
            }
        };
        checkCookie();
    }, [
        requiredPassword
    ]);
    (0,react.useEffect)(function() {
        if (!gatedPage || hasCookie && !!gatedPage || !(gatedPage === null || gatedPage === void 0 ? void 0 : gatedPage.show)) {
            setHasAccess(true);
        } else {
            setHasAccess(false);
        }
        setFinished(true);
    }, [
        hasCookie,
        gatedPage
    ]);
    return (0,_object_spread/* default */.Z)({
        hasAccess: hasAccess,
        hiddenProductHandles: hiddenProductHandles,
        gatedPage: gatedPage,
        setShowErrorMessage: setShowErrorMessage,
        showErrorMessage: showErrorMessage,
        submitPassword: submitPassword
    }, status);
};

;// CONCATENATED MODULE: ./src/hooks/useGatedProduct.js


var useGatedProduct = function(param) {
    var gatedPage = param.gatedPage, product = param.product, _currentUrl = param.currentUrl, currentUrl = _currentUrl === void 0 ? null : _currentUrl;
    var enableFullProductAccess = (0,react.useMemo)(function() {
        var pages = (0,_object_spread/* default */.Z)({}, gatedPage === null || gatedPage === void 0 ? void 0 : gatedPage.page).pages;
        var gatedProduct = pages === null || pages === void 0 ? void 0 : pages.reduce(function(carry, param) {
            var products = param.products, enableFullProductAccess = param.enableFullProductAccess;
            if (carry) return carry;
            var foundProduct = {
                product: products === null || products === void 0 ? void 0 : products.find(function(_product) {
                    var ref;
                    return (_product === null || _product === void 0 ? void 0 : (ref = _product.product) === null || ref === void 0 ? void 0 : ref.handle) === (product === null || product === void 0 ? void 0 : product.handle);
                }),
                enableFullProductAccess: enableFullProductAccess
            };
            if (foundProduct === null || foundProduct === void 0 ? void 0 : foundProduct.product) return foundProduct;
            return carry;
        }, null);
        // if gatedProduct, check to see whether product is in Phase 1 or 2
        // Phase 1 - No access
        // Phase 2 - Access (ATC, Links)
        if (gatedProduct === null || gatedProduct === void 0 ? void 0 : gatedProduct.product) {
            return gatedProduct === null || gatedProduct === void 0 ? void 0 : gatedProduct.enableFullProductAccess;
        }
        return true;
    }, [
        gatedPage,
        product
    ]);
    // returns list of gated products
    var gatedProducts = (0,react.useMemo)(function() {
        var ref;
        var pages = (0,_object_spread/* default */.Z)({}, gatedPage === null || gatedPage === void 0 ? void 0 : gatedPage.page).pages;
        var gatedCollection = pages === null || pages === void 0 ? void 0 : pages.find(function(_page) {
            var ref;
            return (_page === null || _page === void 0 ? void 0 : (ref = _page.pageUrl) === null || ref === void 0 ? void 0 : ref.indexOf(currentUrl)) > -1;
        });
        var _gatedProducts = gatedCollection === null || gatedCollection === void 0 ? void 0 : (ref = gatedCollection.products) === null || ref === void 0 ? void 0 : ref.map(function(param) {
            var product = param.product;
            if (product === null || product === void 0 ? void 0 : product.data) {
                return (0,_object_spread/* default */.Z)({}, product, product === null || product === void 0 ? void 0 : product.data);
            }
            return product;
        });
        return _gatedProducts;
    }, [
        gatedPage,
        currentUrl
    ]);
    return {
        enableFullProductAccess: enableFullProductAccess,
        gatedProducts: gatedProducts
    };
};

;// CONCATENATED MODULE: ./src/hooks/useInitSelectedVariant.js



var VERBOSE = false;
var useInitSelectedVariant = function() {
    var initProduct = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    var product = (0,dist.useProduct)();
    if (initProduct === null || initProduct === void 0 ? void 0 : initProduct.handle) {
        product = initProduct;
    }
    var router = (0,dist.useRouter)();
    var setSelectedOptions = (0,store/* useSetRecoilState */.Zl)(store/* default.setSelectedOptions$ */.ZP.setSelectedOptions$(product === null || product === void 0 ? void 0 : product.handle));
    var selectedVariant = (0,store/* useRecoilValue */.sJ)(store/* default.selectedVariant */.ZP.selectedVariant(product === null || product === void 0 ? void 0 : product.handle));
    // set initial variant
    (0,react.useEffect)(function() {
        if (!product) return;
        var queryKey = "variant";
        var queryValue = router.query[queryKey] || router.asPath.match(new RegExp("[&?]".concat(queryKey, "=(.*)(&|$)")));
        var queriedVariantId = Array.isArray(queryValue) && (queryValue === null || queryValue === void 0 ? void 0 : queryValue.length) ? queryValue[1] : queryValue;
        if (queriedVariantId) {
            var ref;
            // if ?variant=123123123 is passed we use that as selectedVariant
            // VERBOSE && console.log('useInitSelectedVariant:queriedVariantId', queriedVariantId)
            var queriedVariant = product === null || product === void 0 ? void 0 : (ref = product.variants) === null || ref === void 0 ? void 0 : ref.find(function(param) {
                var legacyResourceId = param.legacyResourceId;
                return legacyResourceId === queriedVariantId;
            });
            if (!queriedVariant) {
                var ref1, ref2;
                VERBOSE && console.log("Set initial variant to first variant");
                setSelectedOptions(product === null || product === void 0 ? void 0 : (ref1 = product.variants) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.selectedOptionsMap);
            } else {
                // good
                VERBOSE && console.log("Set initial variant to queried variant", queriedVariant);
                setSelectedOptions(queriedVariant.selectedOptionsMap);
            }
        } else {
            var ref3, ref4;
            var isApparel = (product === null || product === void 0 ? void 0 : product.productType) === "Apparel";
            var firstAvailableVariant = isApparel ? product === null || product === void 0 ? void 0 : (ref3 = product.variants) === null || ref3 === void 0 ? void 0 : ref3.find(function(param) {
                var availableForSale = param.availableForSale;
                return availableForSale;
            }) : null;
            if (firstAvailableVariant) {
                VERBOSE && console.log("Set initial variant to first available");
                setSelectedOptions(firstAvailableVariant.selectedOptionsMap);
            } else if (product === null || product === void 0 ? void 0 : (ref4 = product.variants) === null || ref4 === void 0 ? void 0 : ref4.length) {
                var ref5, ref6;
                // set initial selectedVariant
                VERBOSE && console.log("Set initial variant to first variant");
                setSelectedOptions(product === null || product === void 0 ? void 0 : (ref5 = product.variants) === null || ref5 === void 0 ? void 0 : (ref6 = ref5[0]) === null || ref6 === void 0 ? void 0 : ref6.selectedOptionsMap);
            } else {
                // Should never be get here..
                setSelectedOptions(null);
            }
        }
        return function() {
            // on unmount
            setSelectedOptions(null);
        };
    }, [
        product === null || product === void 0 ? void 0 : product.handle
    ]);
    return selectedVariant;
};

;// CONCATENATED MODULE: ./src/hooks/useProductItemImages.js

var useProductItemImages = function(param) {
    var product = param.product;
    return (0,react.useMemo)(function() {
        var ref;
        if (!product) return {
            primary: null,
            hover: null
        };
        // If no media, return first variant image if available
        if (!((ref = product.media) === null || ref === void 0 ? void 0 : ref.length)) {
            var ref1, ref2;
            return {
                primary: ((ref1 = product.variants) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.image) || null,
                hover: null
            };
        }
        // Find first media item with type "image"
        var imageIndex = null;
        var primary = product.media.find(function(item, index) {
            if (item.mediaContentType === "IMAGE") {
                imageIndex = index;
                return true;
            }
            return false;
        });
        // Find second media item with type "image"
        // If encounter media with different handle, early exit
        var noHoverImage = false;
        var hover = product.media.find(function(item, index) {
            var ref;
            if (((ref = item.product) === null || ref === void 0 ? void 0 : ref.handle) !== product.handle) {
                noHoverImage = true;
                return true;
            }
            return index > imageIndex && item.mediaContentType === "IMAGE";
        });
        return {
            primary: (primary === null || primary === void 0 ? void 0 : primary.image) || null,
            hover: noHoverImage ? null : (hover === null || hover === void 0 ? void 0 : hover.image) || null
        };
    }, [
        product === null || product === void 0 ? void 0 : product.id
    ]);
};

;// CONCATENATED MODULE: ./src/hooks/useSelectedOptionIsAvailable.js

var useSelectedOptionIsAvailable = function() {
    return function(queriedOption) {
        return (0,store/* useRecoilValue */.sJ)(store/* default.optionIsAvailable$ */.ZP.optionIsAvailable$(queriedOption));
    };
};

;// CONCATENATED MODULE: ./src/hooks/useSelectedOptions.js


var useSelectedOptions = function() {
    var product = (0,dist.useProduct)();
    var selectedOptions = (0,store/* useRecoilValue */.sJ)(store/* default.selectedOptions */.ZP.selectedOptions(product === null || product === void 0 ? void 0 : product.handle));
    var setSelectedOptions = (0,store/* useSetRecoilState */.Zl)(store/* default.setSelectedOptions$ */.ZP.setSelectedOptions$(product === null || product === void 0 ? void 0 : product.handle));
    return [
        selectedOptions,
        setSelectedOptions
    ];
};

;// CONCATENATED MODULE: ./src/hooks/useSelectedPlan.js

var useSelectedPlan = function(param) {
    var selectedVariant = param.selectedVariant;
    return (0,store/* useRecoilState */.FV)(store/* default.selectedPlan */.ZP.selectedPlan(selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id));
};

;// CONCATENATED MODULE: ./src/hooks/useSelectedVariant.js


var useSelectedVariant = function() {
    var handle = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        handle: null
    }).handle;
    var product = (0,dist.useProduct)();
    return (0,store/* useRecoilState */.FV)(store/* default.selectedVariant */.ZP.selectedVariant(handle || (product === null || product === void 0 ? void 0 : product.handle)));
};

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
;// CONCATENATED MODULE: ./src/hooks/useGiftWithPurchase.js
/* provided dependency */ var Buffer = __webpack_require__(30816)["lW"];








var useGiftWithPurchase = function() {
    var settings = (0,dist.useSettings)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* default.gwpVariantIds */.ZP.gwpVariantIds), 2), gwpVariantIds = ref[0], setGwpVariantIds = ref[1];
    var setGwpProducts = (0,store/* useSetRecoilState */.Zl)(store/* default.gwpProducts */.ZP.gwpProducts);
    var ref1 = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : settings.gwp), _enabled = ref1.enabled, enabled = _enabled === void 0 ? false : _enabled, _threshold = ref1.threshold, threshold = _threshold === void 0 ? 100 : _threshold, products = ref1.products;
    var ref2 = (0,_object_spread/* default */.Z)({}, products), displayType = ref2.displayType, imageGroup = ref2.imageGroup, sliderGroup = ref2.sliderGroup, excludedProducts = ref2.excludedProducts;
    var getGiftProducts = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, ref2, giftProducts, ref3, ref4, fetchUrls, giftResponses, gifts, validGifts, ref5, variantIds, response, responseJSON, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!enabled) return [
                            2
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            ,
                            8
                        ]);
                        giftProducts = [];
                        if (displayType === "image") {
                            ;
                            giftProducts = (imageGroup === null || imageGroup === void 0 ? void 0 : (ref3 = imageGroup.giftProduct) === null || ref3 === void 0 ? void 0 : ref3.handle) ? [
                                imageGroup.giftProduct
                            ] : [];
                        } else {
                            ;
                            giftProducts = (sliderGroup === null || sliderGroup === void 0 ? void 0 : (ref4 = sliderGroup.giftProducts) === null || ref4 === void 0 ? void 0 : ref4.map(function(param) {
                                var giftProduct = param.giftProduct;
                                return giftProduct;
                            }).filter(function(giftProduct) {
                                return !!(giftProduct === null || giftProduct === void 0 ? void 0 : giftProduct.handle);
                            })) || [];
                        }
                        if (!giftProducts) return [
                            3,
                            4
                        ];
                        fetchUrls = giftProducts.map(function(giftProduct) {
                            return "/json/products/".concat(giftProduct.handle, ".json");
                        });
                        return [
                            4,
                            Promise.all(fetchUrls.map(function(url) {
                                return fetch(url);
                            }))
                        ];
                    case 2:
                        giftResponses = _state.sent();
                        return [
                            4,
                            Promise.all(giftResponses.map(function(giftResp) {
                                return giftResp.json();
                            }))
                        ];
                    case 3:
                        gifts = _state.sent();
                        validGifts = gifts === null || gifts === void 0 ? void 0 : gifts.filter(function(param) {
                            var status = param.status;
                            return status !== "DRAFT";
                        });
                        if (validGifts === null || validGifts === void 0 ? void 0 : validGifts.length) {
                            ;
                            variantIds = validGifts.map(function(gift) {
                                var ref;
                                return (ref = gift.variants[0]) === null || ref === void 0 ? void 0 : ref.storefrontId;
                            });
                            setGwpProducts((ref5 = validGifts.map(function(gift) {
                                var ref;
                                var gwpSettings = sliderGroup === null || sliderGroup === void 0 ? void 0 : (ref = sliderGroup.giftProducts) === null || ref === void 0 ? void 0 : ref.find(function(param) {
                                    var giftProduct = param.giftProduct;
                                    return giftProduct.handle === gift.handle;
                                });
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, gift), {
                                    gwpSettings: gwpSettings
                                });
                            })) === null || ref5 === void 0 ? void 0 : ref5.slice(0, 3));
                            setGwpVariantIds(variantIds);
                            return [
                                2
                            ];
                        }
                        _state.label = 4;
                    case 4:
                        return [
                            4,
                            fetch("https://mystery-gift.herokuapp.com/get-discount-codes")
                        ];
                    case 5:
                        response = _state.sent();
                        if (!response.ok) return [
                            2
                        ];
                        return [
                            4,
                            response.json()
                        ];
                    case 6:
                        responseJSON = _state.sent();
                        if (!(responseJSON === null || responseJSON === void 0 ? void 0 : (ref = responseJSON.data) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.variants_id) === null || ref2 === void 0 ? void 0 : ref2.length)) return [
                            2
                        ];
                        setGwpProducts((0,_object_spread/* default */.Z)({}, responseJSON.data[0]));
                        setGwpVariantIds(Buffer.from("gid://shopify/ProductVariant/".concat(responseJSON.data[0].variants_id[0])).toString("base64"));
                        return [
                            3,
                            8
                        ];
                    case 7:
                        error = _state.sent();
                        console.error(error);
                        return [
                            3,
                            8
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        });
        return function getGiftProducts() {
            return _ref.apply(this, arguments);
        };
    }();
    var isEligible = function(cart) {
        var ref, ref1, ref2, ref3;
        var ids = gwpVariantIds;
        if (!ids) return false;
        var subtotalAmount = parseFloat(cart === null || cart === void 0 ? void 0 : (ref = cart.estimatedCost) === null || ref === void 0 ? void 0 : (ref1 = ref.subtotalAmount) === null || ref1 === void 0 ? void 0 : ref1.amount);
        var excludedProductHandles = excludedProducts === null || excludedProducts === void 0 ? void 0 : excludedProducts.map(function(param) {
            var product = param.product;
            return product === null || product === void 0 ? void 0 : product.handle;
        });
        var trueSubtotalAmount = cart === null || cart === void 0 ? void 0 : (ref2 = cart.lines) === null || ref2 === void 0 ? void 0 : ref2.reduce(function(carry, line) {
            var ref, ref1, ref2, ref3;
            var itemHandle = line === null || line === void 0 ? void 0 : (ref = line.variant) === null || ref === void 0 ? void 0 : (ref1 = ref.product) === null || ref1 === void 0 ? void 0 : ref1.handle;
            if (!(excludedProductHandles === null || excludedProductHandles === void 0 ? void 0 : excludedProductHandles.some(function(handle) {
                return handle === itemHandle;
            }))) return carry;
            // remove line item subtotal from cart subtotal if product is excluded from GWP's cart threshold
            var itemSubtotal = parseFloat(line === null || line === void 0 ? void 0 : (ref2 = line.estimatedCost) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.subtotalAmount) === null || ref3 === void 0 ? void 0 : ref3.amount);
            return (carry * 100 - itemSubtotal * 100) / 100;
        }, subtotalAmount);
        return enabled && trueSubtotalAmount >= parseFloat(threshold) && !(cart === null || cart === void 0 ? void 0 : (ref3 = cart.lines) === null || ref3 === void 0 ? void 0 : ref3.some(function(line) {
            var ref;
            if (!(line === null || line === void 0 ? void 0 : (ref = line.variant) === null || ref === void 0 ? void 0 : ref.id)) return false;
            var id = "gid://shopify/ProductVariant/".concat((0,utils/* getValidId */.MM)(line.variant.id));
            return ids.some(function(_id) {
                return _id === id;
            });
        }) // GWP is not in cart
        );
    };
    return {
        getGiftProducts: getGiftProducts,
        isEligible: isEligible
    };
};

;// CONCATENATED MODULE: ./src/hooks/useRebuy.js






var useRebuy = function() {
    var _ref = (0,dist.useStartFinishErrors)(), setStarted = _ref.setStarted, setFinished = _ref.setFinished, setErrors = _ref.setErrors, reset = _ref.reset, status = (0,_object_without_properties/* default */.Z)(_ref, [
        "setStarted",
        "setFinished",
        "setErrors",
        "reset"
    ]);
    var getRebuyProducts = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var shopify_product_ids, cart_item_count, url, options, options2, response, response2, crossSells, upSells, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        shopify_product_ids = param.shopify_product_ids, cart_item_count = param.cart_item_count;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            ,
                            7
                        ]);
                        reset();
                        setStarted(true);
                        url = "/api/rebuy";
                        options = {
                            method: "POST",
                            body: JSON.stringify({
                                shopify_product_ids: shopify_product_ids || "",
                                cart_item_count: cart_item_count
                            })
                        };
                        options2 = {
                            method: "POST",
                            body: JSON.stringify({
                                shopify_product_ids: shopify_product_ids || "",
                                cart_item_count: cart_item_count,
                                isUpsell: true
                            })
                        };
                        return [
                            4,
                            fetch(url, options)
                        ];
                    case 2:
                        response = _state.sent();
                        return [
                            4,
                            fetch(url, options2)
                        ];
                    case 3:
                        response2 = _state.sent();
                        if (!response.ok) {
                            setErrors([
                                "Error with rebuy."
                            ]);
                            console.error("Response back from API not successful:", response);
                            return [
                                2,
                                null
                            ];
                        }
                        if (!response2.ok) {
                            setErrors([
                                "Error with rebuy."
                            ]);
                            console.error("Response2 back from API not successful:", response2);
                            return [
                                2,
                                null
                            ];
                        }
                        return [
                            4,
                            response.json()
                        ];
                    case 4:
                        crossSells = _state.sent();
                        return [
                            4,
                            response2.json()
                        ];
                    case 5:
                        upSells = _state.sent();
                        if (!(crossSells === null || crossSells === void 0 ? void 0 : crossSells.data) || !(upSells === null || upSells === void 0 ? void 0 : upSells.data)) {
                            setErrors([
                                "Error with rebuy."
                            ]);
                            return [
                                2,
                                null
                            ];
                        }
                        setFinished(true);
                        return [
                            2,
                            {
                                crossSells: crossSells,
                                upSells: upSells
                            }
                        ];
                    case 6:
                        error = _state.sent();
                        setErrors([
                            "Error with rebuy."
                        ]);
                        console.error("Error with rebuy: ".concat(error));
                        return [
                            3,
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    return (0,_object_spread/* default */.Z)({
        getRebuyProducts: getRebuyProducts,
        setErrors: setErrors,
        reset: reset
    }, status);
};

;// CONCATENATED MODULE: ./src/hooks/useBodyScrollLock.js


var useBodyScrollLock_DEBUG = false;
var initial = {
    html: {
        overflowY: "",
        paddingTop: ""
    },
    header: {
        position: "",
        top: ""
    },
    promo: {
        position: "",
        top: ""
    },
    customizer: {
        marginRight: ""
    }
};
var useBodyScrollLock = function(props) {
    var scrollElement = (props === null || props === void 0 ? void 0 : props.scrollElement) || null;
    var header = (0,react.useRef)();
    var promo = (0,react.useRef)();
    var customizer = (0,react.useRef)();
    var html = (0,react.useRef)(utils/* isBrowser */.jU ? scrollElement || document.documentElement : null);
    var runCallback = (0,react.useCallback)(function(props) {
        if (typeof (props === null || props === void 0 ? void 0 : props.onComplete) === "function") {
            props.onComplete();
        }
    }, []);
    var bindRefs = (0,react.useCallback)(function() {
        if (!header.current) {
            header.current = document.querySelector("header");
        }
        if (!promo.current) {
            promo.current = document.querySelector("[data-comp=PromoBar]");
        }
        if (!customizer.current) {
            customizer.current = document.querySelector('div[class^="StyledToolbar-sc-"]');
        }
    }, []);
    var cacheInitial = (0,react.useCallback)(function() {
        // Cache initial values of element styles that will be modified
        var htmlStyles = window.getComputedStyle(html.current);
        initial.html.overflowY = htmlStyles.overflowY;
        initial.html.paddingTop = htmlStyles.paddingTop;
        var headerStyles = window.getComputedStyle(header.current);
        initial.header.position = headerStyles.position;
        initial.header.top = headerStyles.top;
        var promoStyles = window.getComputedStyle(promo.current);
        initial.promo.position = promoStyles.position;
        initial.promo.top = promoStyles.top;
        if (customizer.current) {
            var customizerStyles = window.getComputedStyle(customizer.current);
            initial.customizer.marginRight = customizerStyles.marginRight;
        }
    }, []);
    var lock = (0,react.useCallback)(function() {
        var scrollY = window.scrollY;
        var headerHeight = header.current.clientHeight;
        var promoHeight = promo.current.clientHeight;
        var headerPromoHeight = headerHeight + promoHeight;
        var top;
        if (!scrollY || scrollY <= 0) {
            top = 0;
        } else if (scrollY <= headerPromoHeight) {
            top = headerPromoHeight - scrollY;
        } else {
            top = (scrollY - headerHeight) * -1;
        }
        // prevent scroll and mark as locked
        html.current.classList.toggle("scroll-locked");
        html.current.style.overflowY = "hidden";
        // set body position to fixed for iOS compatibility
        document.body.style.cssText = "position: fixed; top: ".concat(top, "px; left: 0; right: 0;");
        // no scroll — no need to apply lock styles
        if (scrollY === 0) {
            runCallback(props);
            return;
        }
        // Have scrolled
        /*
      To prevent the body from jumping horizontally
      (due to scrollbar disappearing) after we set overflowY=hidden
      we capture the scrollbar width and set it as margin-right
    */ var scrollbarWidthPx = window.innerWidth - document.body.clientWidth || 0;
        // console.log({
        //   scrollY,
        //   headerHeight,
        //   promoHeight,
        //   headerPromoHeight,
        // });
        // set header from sticky to fixed
        header.current.style.position = "fixed";
        // header.current.style.right = `${scrollbarWidthPx/2}px`;
        // scrolled but not passed promobar + header height
        if (scrollY <= headerPromoHeight) {
            promo.current.style.position = "fixed";
            promo.current.style.top = "-".concat(scrollY, "px");
            // scrolled but no pass the promo height
            if (scrollY <= promoHeight) {
                header.current.style.top = "".concat(promoHeight - scrollY, "px");
            }
            html.current.style.paddingTop = "calc(var(--header-height) + var(--promoBar-height))";
        } else {
            // scrolled past the header + promo
            html.current.style.paddingTop = "var(--header-height)";
        }
        // html.current.style.paddingTop = 'var(--header-height)';
        /*
      add margin to the tina container
      for the disabled scroll bar during lock
    */ if (customizer.current) {
            customizer.current.style.marginRight = "".concat(scrollbarWidthPx, "px");
        }
    }, []);
    var resetLock = (0,react.useCallback)(function() {
        // reset original document overflow value
        html.current.style.removeProperty("overflow-y");
        // reset locked html
        html.current.classList.toggle("scroll-locked");
        html.current.style.paddingTop = initial.html.paddingTop; // 'unset';
        var headerHeight = header.current.clientHeight;
        var promoHeight = promo.current.clientHeight;
        var headerPromoHeight = headerHeight + promoHeight;
        var top = parseFloat(document.body.style.top || "0") * -1;
        // reset promo and header back to initial values
        promo.current.style.position = initial.promo.position; // 'relative'
        promo.current.style.top = initial.promo.top; // 'unset';
        header.current.style.position = initial.header.position;
        header.current.style.top = initial.header.top;
        // Determine scroll to y position
        var y;
        if (top < 0) {
            y = headerPromoHeight + top;
        } else if (top === 0) {
            y = 0;
        } else {
            y = top + headerHeight;
        }
        // clear body fixed styles
        document.body.style.cssText = "";
        // scroll to y position
        window.scrollTo(0, y);
        if (customizer.current) {
            customizer.current.style.marginRight = initial.customizer.marginRight; // '0px'
        }
    }, []);
    var lockScroll = (0,react.useCallback)(function(props) {
        var isLocked = html.current.classList.contains("scroll-locked");
        if (isLocked) {
            runCallback(props);
            return;
        }
        useBodyScrollLock_DEBUG && console.log("\uD83D\uDD12 Locking scroll...");
        /**
      Make sure the position-sticky header and relative promoBar
      do not disappear on scroll lock by switching it to fixed and adding
      header height to the scroll container to prevent the vertical jump
    */ try {
            bindRefs();
            cacheInitial();
            useBodyScrollLock_DEBUG && console.log("\uD83D\uDD12 Lock", {
                initial: initial,
                html: html,
                header: header,
                promo: promo,
                customizer: customizer
            });
            lock();
            runCallback(props);
        } catch (error) {
            console.error("\uD83D\uDD12 lockScroll:error", error.message);
        }
    });
    /**
   * Unlock body scroll by resetting all lock scroll styles
   */ var unlockScroll = (0,react.useCallback)(function(props) {
        var isLocked = html.current.classList.contains("scroll-locked");
        if (!isLocked) {
            useBodyScrollLock_DEBUG && console.log("\uD83D\uDD13 unlockScroll: nothing to unlock. Good Bye");
            return;
        }
        useBodyScrollLock_DEBUG && console.log("\uD83D\uDD13 Unlocking scroll...");
        // reset header to sticky
        try {
            bindRefs();
            resetLock();
            runCallback(props);
        } catch (error) {}
    });
    if (!utils/* isBrowser */.jU) {
        // SSR default
        return {
            lockScroll: function() {},
            unlockScroll: function() {}
        };
    }
    return {
        lockScroll: lockScroll,
        unlockScroll: unlockScroll
    };
};

;// CONCATENATED MODULE: ./src/hooks/useBottomToIosFooterBar.js


var useBottomToIosFooterBar = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        targetRef: null
    }, _targetRef = ref.targetRef, targetRef = _targetRef === void 0 ? null : _targetRef;
    var baseWindowHeight = useRef(isBrowser ? Math.max(window.innerHeight) : 0);
    var bodyRef = useRef(isBrowser ? document.body : null);
    // .ios-toolbar-gone button {
    //   transform: translateY(-2rem);
    // }
    useEffect(function() {
        if (!(targetRef === null || targetRef === void 0 ? void 0 : targetRef.current) || !isBrowser) return;
        /*
      Maybe try with an observer for performance.
      I could have hidden spacer behind the sidebar with 50px height
      and detect when its out of the screen
    */ var updateHeight = function() {
            var newWindowHeight = Math.max(window.innerHeight);
            if (newWindowHeight - 50 > baseWindowHeight.current) {
                if (!bodyRef.current.classList.contains("ios-toolbar-gone")) {
                    bodyRef.current.classList.add("ios-toolbar-gone");
                }
            } else if (bodyRef.current.classList.contains("ios-toolbar-gone")) {
                bodyRef.current.classList.remove("ios-toolbar-gone");
            }
        };
        document.addEventListener("scroll", updateHeight);
        return function() {
            document.removeEventListener("scroll", updateHeight);
        };
    }, []);
};

;// CONCATENATED MODULE: ../node_modules/use-match-media-hook/dist/bundle.esm.js


function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function useMatchMedia(queries) {
  var defaultValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var initialValues = defaultValues.length ? defaultValues : Array(queries.length).fill(false);
  if (typeof window === 'undefined') return initialValues;
  var mediaQueryLists = queries.map(function (q) {
    return window.matchMedia(q);
  });

  var getValue = function getValue() {
    // Return the value for the given queries
    var matchedQueries = mediaQueryLists.map(function (mql) {
      return mql.matches;
    });
    return matchedQueries;
  }; // State and setter for matched value


  var _useState = (0,react.useState)(getValue),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  (0,react.useLayoutEffect)(function () {
    // Event listener callback
    // Note: By defining getValue outside of useEffect we ensure that it has ...
    // ... current values of hook args (as this hook only runs on mount/dismount).
    var handler = function handler() {
      return setValue(getValue);
    }; // Set a listener for each media query with above handler as callback.


    mediaQueryLists.forEach(function (mql) {
      return mql.addListener(handler);
    }); // Remove listeners on cleanup

    return function () {
      return mediaQueryLists.forEach(function (mql) {
        return mql.removeListener(handler);
      });
    };
  }, []);
  return value;
}

/* harmony default export */ var bundle_esm = (useMatchMedia);

// EXTERNAL MODULE: ./src/theme/index.js + 16 modules
var theme = __webpack_require__(30450);
;// CONCATENATED MODULE: ./src/hooks/useBreakpoint.js




var useBreakpoint = function() {
    // breakpoint values conversion from em to (px - 1)
    var ref = (0,react.useMemo)(function() {
        return theme/* theme.breakpoints.map */.r.breakpoints.map(function(bpEm) {
            var ref = (0,_sliced_to_array/* default */.Z)(bpEm.split("em"), 1), valueStr = ref[0];
            return "".concat(parseInt(valueStr, 10) * 16 - 1, "px");
        });
    }, [
        theme/* theme.breakpoints.join */.r.breakpoints.join(",")
    ]), minuS = ref[0], minusM = ref[1], minusL = ref[2], minusXl = ref[3];
    var queries = (0,react.useRef)([
        "(max-width: ".concat(minuS, ")"),
        "(max-width: ".concat(minusM, ")"),
        "(min-width: ".concat(theme/* theme.breakpoints.0 */.r.breakpoints[0], ") and (max-width: ").concat(minusM, ")"),
        "(min-width: ".concat(theme/* theme.breakpoints.0 */.r.breakpoints[0], ")"),
        "(max-width: ".concat(minusL, ")"),
        "(min-width: ".concat(theme/* theme.breakpoints.1 */.r.breakpoints[1], ") and (max-width: ").concat(minusL, ")"),
        "(min-width: ".concat(theme/* theme.breakpoints.1 */.r.breakpoints[1], ")"),
        "(max-width: ".concat(minusXl, ")"),
        "(min-width: ".concat(theme/* theme.breakpoints.2 */.r.breakpoints[2], ") and (max-width: ").concat(minusXl, ")"),
        "(min-width: ".concat(theme/* theme.breakpoints.2 */.r.breakpoints[2], ")")
    ]);
    var ref1 = (0,_sliced_to_array/* default */.Z)(bundle_esm(queries.current, [
        true
    ]), 10), s = ref1[0], _m = ref1[1], m = ref1[2], m_ = ref1[3], _l = ref1[4], l = ref1[5], l_ = ref1[6], _xl = ref1[7], xl = ref1[8], xl_ = ref1[9];
    return {
        s: s,
        m: m,
        _m: _m,
        m_: m_,
        _l: _l,
        l: l,
        l_: l_,
        _xl: _xl,
        xl: xl,
        xl_: xl_
    };
};

;// CONCATENATED MODULE: ./src/hooks/useBreakpointValue.js





var useBreakpointValue = function() {
    var values = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    if (!(values === null || values === void 0 ? void 0 : values.length)) {
        console.warn("No values provided. Please provide an array of responsive values");
        return null;
    }
    // refresh result memo on value change
    var refresh = values === null || values === void 0 ? void 0 : values.map(function(value) {
        return JSON.stringify(value);
    }).join(",");
    var ref = useBreakpoint(), s = ref.s, m_ = ref.m_, l_ = ref.l_, xl_ = ref.xl_, xxl = ref.xxl;
    return (0,react.useMemo)(function() {
        var ref = (0,_sliced_to_array/* default */.Z)(new Array(theme/* theme.breakpoints.length */.r.breakpoints.length + 1).fill().reduce(function(_values, _, index) {
            var initialValue = values[index];
            var altValue = initialValue === null || initialValue === undefined ? _values[index - 1] : initialValue;
            var finalValue = altValue === null || altValue === undefined ? null : altValue;
            return (0,_to_consumable_array/* default */.Z)(_values).concat([
                finalValue
            ]);
        }, []), 5), valueS = ref[0], valueM = ref[1], valueL = ref[2], valueXl = ref[3], valueXxl = ref[4];
        return (values === null || values === void 0 ? void 0 : values.length) ? xxl ? valueXxl : xl_ ? valueXl : l_ ? valueL : m_ ? valueM : s ? valueS : null : null; // no values provided
    }, [
        s,
        m_,
        l_,
        xl_,
        xxl,
        refresh
    ]);
};

;// CONCATENATED MODULE: ./src/hooks/useDebounce.js
// @see: https://usehooks.com/useDebounce/

var useDebounce = function(value, delay) {
    // State and setters for debounced value
    var ref = (0,react.useState)(value), debouncedValue = ref[0], setDebouncedValue = ref[1];
    (0,react.useEffect)(function() {
        // Update debounced value after delay
        var handler = window.requestTimeout(function() {
            setDebouncedValue(value);
        }, delay);
        // Cancel the timeout if value changes (also on delay change or unmount)
        // This is how we prevent debounced value from updating if value is changed ...
        // .. within the delay period. Timeout gets cleared and restarted.
        return function() {
            window.clearRequestTimeout(handler);
        };
    }, [
        value,
        delay
    ] // Only re-call effect if value or delay changes
    );
    return debouncedValue;
};

;// CONCATENATED MODULE: ./src/hooks/usePickedSections.js


var defaultProps = {
    firstOf: [],
    anyOf: [],
    sections: []
};
var usePickedSections = function(passedProps) {
    var filteredFirstOfs = [];
    var filteredAnyOfs = [];
    var props = (0,_object_spread/* default */.Z)({}, defaultProps, passedProps);
    var sections = Array.isArray(props.sections) ? props.sections : [];
    var firstOf = Array.isArray(props.firstOf) ? props.firstOf : [];
    var anyOf = Array.isArray(props.anyOf) ? props.anyOf : [];
    var firstOfSections = (firstOf === null || firstOf === void 0 ? void 0 : firstOf.length) ? firstOf.reduce(function(_firstOf, key) {
        var matchingKey = function(section) {
            var ref;
            return (section === null || section === void 0 ? void 0 : (ref = section.props) === null || ref === void 0 ? void 0 : ref["data-comp"]) === key;
        };
        var firstOfKeyIndex = sections.findIndex(matchingKey);
        // track filtered
        filteredFirstOfs.push(firstOfKeyIndex);
        _firstOf[key] = sections[firstOfKeyIndex];
        return _firstOf;
    }, {}) : null;
    var anyOfSections = (anyOf === null || anyOf === void 0 ? void 0 : anyOf.length) ? anyOf.reduce(function(_anyOf, key) {
        var matchingKey = function(section) {
            var ref;
            return (section === null || section === void 0 ? void 0 : (ref = section.props) === null || ref === void 0 ? void 0 : ref["data-comp"]) === key;
        };
        var matchingIndexes = sections.reduce(function(_indexes, section, index) {
            var ref;
            var matchesKey = (section === null || section === void 0 ? void 0 : (ref = section.props) === null || ref === void 0 ? void 0 : ref["data-comp"]) === key;
            if (matchesKey) {
                _indexes = (0,_to_consumable_array/* default */.Z)(_indexes).concat([
                    index
                ]);
            }
            return _indexes;
        }, []);
        // track anyOfs
        filteredAnyOfs = (0,_to_consumable_array/* default */.Z)(new Set((0,_to_consumable_array/* default */.Z)(filteredAnyOfs).concat((0,_to_consumable_array/* default */.Z)(matchingIndexes))));
        _anyOf[key] = sections.filter(matchingKey);
        return _anyOf;
    }, {}) : [];
    var pickedIndexes = (0,_to_consumable_array/* default */.Z)(new Set((0,_to_consumable_array/* default */.Z)(filteredFirstOfs).concat((0,_to_consumable_array/* default */.Z)(filteredAnyOfs))));
    var unpickedSections = sections.filter(function(_, index) {
        return !pickedIndexes.includes(index);
    });
    return {
        firstOf: firstOfSections,
        anyOf: anyOfSections,
        otherSections: unpickedSections
    };
};

;// CONCATENATED MODULE: ./src/hooks/useSetHeaderHeightCssVar.js

// sets the CSS var --header-height on mount and resize
var useSetHeaderHeightCssVar = function() {
    var headerRef = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        headerRef: null
    }).headerRef;
    (0,react.useEffect)(function() {
        var setHeaderHeightCssVar = function() {
            if (!(headerRef === null || headerRef === void 0 ? void 0 : headerRef.current)) {
                return console.warn("No header ref...");
            }
            document.documentElement.style.setProperty("--header-height", "".concat(headerRef.current.clientHeight, "px"));
        };
        window.addEventListener("resize", setHeaderHeightCssVar);
        setHeaderHeightCssVar();
        return function() {
            window.removeEventListener("resize", setHeaderHeightCssVar);
        };
    }, []);
};

;// CONCATENATED MODULE: ./src/hooks/useSetViewportHeightCssVar.js


/*
  sets the CSS variable root { --viewport-height: 123px } on mount and updates on screen resize.
  This allows us to do i.e sx={{ minHeight: var(--viewport-height) }} to get full height instead
  of using sx= {{ minHeight: 100vh }} which is NOT supported on Safari
*/ var useSetViewportHeightCssVar = function() {
    var isPreview = (0,dist.useRouter)().isPreview;
    (0,react.useEffect)(function() {
        var setViewportHeight = function() {
            var doc = document.documentElement;
            // when in preview we make viewport height - the height of the customizer toolbar
            var viewportHeight = isPreview ? "calc(".concat(window.innerHeight, "px - var(--backpack-toolbar-height))") : "".concat(window.innerHeight, "px");
            doc.style.setProperty("--viewport-height", viewportHeight);
        };
        if (true) {
            window.addEventListener("resize", setViewportHeight);
            setViewportHeight();
        }
        return function() {
            window.removeEventListener("resize", setViewportHeight);
        };
    }, []);
};

;// CONCATENATED MODULE: ./src/hooks/useLocalStorage.js


var useLocalStorage = function(key) {
    var defaultValue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var ref = (0,react.useState)(function() {
        if (!utils/* isBrowser */.jU) return defaultValue;
        var storedValue = localStorage.getItem(key);
        return storedValue !== null ? JSON.parse(storedValue) : defaultValue;
    }), value = ref[0], setValue = ref[1];
    (0,react.useEffect)(function() {
        localStorage.setItem(key, JSON.stringify(value));
    }, [
        key,
        value
    ]);
    return [
        value,
        setValue
    ];
};

;// CONCATENATED MODULE: ./src/hooks/useMatchMedia.js

// e.g. const isDesktopViewport = useMatchMedia('(min-width: 768px)');
// NOTE: do not use match media to dictate the layout or visual elements between breakpoints, as it will cause hydration errors or layout shift and flashing of changing content with SSG upon hydration
// INSTEAD: use Tailwind breakpoint styling to avoid layout shift with SSG
function fallbackMatchMedia(query) {
    if ( false || typeof window.matchMedia !== "function") {
        return null;
    }
    return window.matchMedia(query);
}
function omitMatchMediaResult(matchMediaResult) {
    if (!matchMediaResult) {
        return null;
    }
    return {
        media: matchMediaResult.media,
        matches: matchMediaResult.matches
    };
}
function useMedia(query) {
    var ref = (0,react.useState)(false), mounted = ref[0], setMounted = ref[1];
    var ref1 = (0,react.useState)(function() {
        return omitMatchMediaResult(fallbackMatchMedia(query));
    }), result = ref1[0], setResult = ref1[1];
    var callback = (0,react.useCallback)(function(matchMediaResult) {
        return setResult(omitMatchMediaResult(matchMediaResult));
    }, []);
    (0,react.useEffect)(function() {
        setMounted(true);
    }, []);
    (0,react.useEffect)(function() {
        var matchMediaResult = fallbackMatchMedia(query);
        callback(matchMediaResult);
        if (matchMediaResult) {
            matchMediaResult.addEventListener("change", callback);
        }
        return function() {
            if (matchMediaResult) {
                matchMediaResult.removeEventListener("change", callback);
            }
        };
    }, [
        query
    ]);
    if (!mounted) {
        return null;
    }
    return result;
}
function useMatchMedia_useMatchMedia(query) {
    var result = useMedia(query);
    return result && result.matches || false;
}

;// CONCATENATED MODULE: ./src/hooks/useHideCustomizerBar.js

/*
  Hides the top customizer bar.
  this can be potentially useful (temporarily)
  while developing a new header.
*/ var useHideCustomizerBar = function() {
    var hide = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        hide: false
    }).hide;
    var killTinaToolBar = function() {
        var _next;
        try {
            _next = document.getElementById("__next");
        } catch (error) {
            return;
        }
        console.groupCollapsed("Hiding customizer toolbar");
        for(var i = 0; i < _next.children.length; i++){
            var child = _next.children[i];
            for(var y = 0, l = child.classList.length; y < l; ++y){
                var childClass = child.classList[y];
                var classesToHide = /ToolbarPlaceholder*|StyledToolbar*/;
                if (classesToHide.test(childClass)) {
                    console.log("Hiding element with class", childClass);
                    child.style.display = "none";
                    break;
                }
            }
        }
        console.groupEnd("Hiding editor toolbar");
    };
    hide && useEffect(function() {
        killTinaToolBar;
    }, []);
};

;// CONCATENATED MODULE: ./src/hooks/useTrackSettings.js



var useTrackSettings = function() {
    var settings = (0,dist.useSettings)();
    var setRecoilSettings = (0,store/* useSetRecoilState */.Zl)(store/* default.siteSettings */.ZP.siteSettings);
    (0,react.useEffect)(function() {
        // on siteSettings change, update store.updateSettings
        setRecoilSettings(settings);
    });
};

;// CONCATENATED MODULE: ./src/hooks/useCartStatus.js


var useCartStatus = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* default.addingToCartStatus */.ZP.addingToCartStatus), 2), addingToCartStatus = ref[0], setAddingToCartStatus = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* default.updatingCartStatus */.ZP.updatingCartStatus), 2), updatingCartStatus = ref1[0], setUpdatingCartStatus = ref1[1];
    return [
        {
            addingToCartStatus: addingToCartStatus,
            updatingCartStatus: updatingCartStatus
        },
        {
            setAddingToCartStatus: setAddingToCartStatus,
            setUpdatingCartStatus: setUpdatingCartStatus
        }, 
    ];
};

;// CONCATENATED MODULE: ./src/hooks/useCartRedirect.js





var useCartRedirect = function() {
    var ref = (0,_sliced_to_array/* default */.Z)(useSidebar(), 2), isCart = ref[0].isCart, openCartSidebar = ref[1].openCartSidebar;
    var router = (0,dist.useRouter)();
    var route = router.route, query = router.query;
    var isOpenCart = (query === null || query === void 0 ? void 0 : query.cart) === "true";
    (0,react.useEffect)(function() {
        if (route !== "/cart") return;
        router.push("/?cart=true");
    }, [
        route
    ]);
    (0,react.useEffect)(function() {
        if (!isOpenCart) return;
        openCartSidebar();
    }, [
        isOpenCart
    ]);
    (0,react.useEffect)(function() {
        if (!isCart || !isOpenCart) return;
        var newQuery = (0,_object_spread/* default */.Z)({}, query);
        delete newQuery.cart;
        router.replace({
            pathname: "/",
            query: newQuery
        });
    }, [
        isCart,
        isOpenCart
    ]);
    return null;
};

// EXTERNAL MODULE: ../node_modules/nanoid/index.browser.js
var index_browser = __webpack_require__(72155);
;// CONCATENATED MODULE: ./src/hooks/useSearchspring.js






var useSearchspring = function() {
    // Check if specific ss id exists from cookies, if not generate new one
    var getClientIp = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var response, data, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        fetch("/api/client-ip")
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    data = _state.sent();
                    return [
                        2,
                        (data === null || data === void 0 ? void 0 : data.query) || null
                    ];
                case 3:
                    error = _state.sent();
                    console.error(error);
                    return [
                        2,
                        null
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), []);
    var getIdOrGenerateId = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(name) {
            var ref, id, newId;
            return (0,tslib_es6.__generator)(this, function(_state) {
                try {
                    ;
                    if (!name) return [
                        2
                    ];
                    id = null;
                    (ref = document.cookie) === null || ref === void 0 ? void 0 : ref.split(/\s*;\s*/).find(function(item) {
                        var ref = (0,_sliced_to_array/* default */.Z)(item.split(/\s*=\s*/), 2), key = ref[0], value = ref[1];
                        if (key !== name) return false;
                        id = value;
                        return true;
                    });
                    if (id) {
                        return [
                            2,
                            id
                        ];
                    }
                    newId = (0,index_browser/* nanoid */.x0)();
                    document.cookie = "".concat(name, "=").concat(newId);
                    return [
                        2,
                        newId
                    ];
                } catch (error) {
                    console.error("Error with getIdOrGenerateId", error.message);
                    throw new Error(error.message);
                }
                return [
                    2
                ];
            });
        });
        return function(name) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    // Request searchspring api
    var requestSearchspring = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var action, params, hasUserTracking, ssUserId, _tmp, sessionId, _tmp1, ip, url, options, response, data, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        action = param.action, params = param.params;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            11,
                            ,
                            12
                        ]);
                        if (!action) throw new Error("No Searchspring action provided");
                        hasUserTracking = [
                            "getCollection",
                            "getSearchResults"
                        ].includes(action);
                        if (!hasUserTracking) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            getIdOrGenerateId("ssUserId")
                        ];
                    case 2:
                        _tmp = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        _tmp = null;
                        _state.label = 4;
                    case 4:
                        ssUserId = _tmp;
                        if (!hasUserTracking) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            getIdOrGenerateId("ssSessionIdNamespace")
                        ];
                    case 5:
                        _tmp1 = _state.sent();
                        return [
                            3,
                            7
                        ];
                    case 6:
                        _tmp1 = null;
                        _state.label = 7;
                    case 7:
                        sessionId = _tmp1;
                        return [
                            4,
                            getClientIp()
                        ];
                    case 8:
                        ip = _state.sent();
                        url = "/api/searchspring";
                        options = {
                            method: "POST",
                            body: JSON.stringify((0,_object_spread/* default */.Z)({
                                action: action
                            }, params, hasUserTracking ? {
                                userId: ssUserId
                            } : null, hasUserTracking ? {
                                sessionId: sessionId
                            } : null, hasUserTracking ? {
                                header: {
                                    "searchspring-session-id": sessionId,
                                    "searchspring-user-id": ssUserId,
                                    "searchspring-page-load-id": (0,index_browser/* nanoid */.x0)(),
                                    "User-Agent": navigator.userAgent || "",
                                    "X-Forwarded-For": ip || ""
                                }
                            } : null))
                        };
                        return [
                            4,
                            fetch(url, options)
                        ];
                    case 9:
                        response = _state.sent();
                        return [
                            4,
                            response.json()
                        ];
                    case 10:
                        data = _state.sent();
                        return [
                            2,
                            data === null || data === void 0 ? void 0 : data.data
                        ];
                    case 11:
                        error = _state.sent();
                        console.error("Error with requestSearchspring: ".concat(error.message));
                        throw error;
                    case 12:
                        return [
                            2
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    return {
        requestSearchspring: requestSearchspring
    };
};

;// CONCATENATED MODULE: ./src/hooks/useSearchspringBeacon.js







// https://searchspring.zendesk.com/hc/en-us/articles/360052114591-Beacon-API-Recommendations
var useSearchspringBeacon = function() {
    var requestSearchspring = useSearchspring().requestSearchspring;
    // const customer = useCustomer();
    // const customerId = customer?.id || '';
    var getIdOrGenerateId = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(name) {
            var ref, id, newId;
            return (0,tslib_es6.__generator)(this, function(_state) {
                try {
                    ;
                    if (!name) return [
                        2
                    ];
                    id = null;
                    (ref = document.cookie) === null || ref === void 0 ? void 0 : ref.split(/\s*;\s*/).find(function(item) {
                        var ref = (0,_sliced_to_array/* default */.Z)(item.split(/\s*=\s*/), 2), key = ref[0], value = ref[1];
                        if (key !== name) return false;
                        id = value;
                        return true;
                    });
                    if (id) {
                        return [
                            2,
                            id
                        ];
                    }
                    newId = (0,index_browser/* nanoid */.x0)();
                    document.cookie = "".concat(name, "=").concat(newId);
                    return [
                        2,
                        newId
                    ];
                } catch (error) {
                    console.error("Error with getIdOrGenerateId", error.message);
                    throw new Error(error.message);
                }
                return [
                    2
                ];
            });
        });
        return function(name) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    var sendEventsToBeacon = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var _profileTypes, profileTypes, _productTypes, productTypes, tag, placement, _products, products, _visibleProducts, visibleProducts, clickedProduct, seed, userId, sessionId, pageLoadId, pids, context, profileEvents, productEvents, events, data, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _profileTypes = param.profileTypes, profileTypes = _profileTypes === void 0 ? [] : _profileTypes, _productTypes = param.productTypes, productTypes = _productTypes === void 0 ? [] : _productTypes, tag = param.tag, placement = param.placement, _products = param.products, products = _products === void 0 ? [] : _products, _visibleProducts = param.visibleProducts, visibleProducts = _visibleProducts === void 0 ? [] : _visibleProducts, clickedProduct = param.clickedProduct, seed = param.seed;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        if (!tag) {
                            throw new Error("No tag provided to sendEventsToBeacon");
                        }
                        if (!placement) {
                            throw new Error("No placement provided to sendEventsToBeacon");
                        }
                        if (!profileTypes.length && !productTypes.length) {
                            throw new Error("No profileTypes or productTypes provided to sendEventsToBeacon");
                        }
                        if (productTypes.includes("profile.product.render") && !products.length) {
                            throw new Error("products are required for profile.product.render");
                        }
                        if (productTypes.includes("profile.product.impression") && !visibleProducts.length) {
                            throw new Error("visibleProducts are required for profile.product.impression");
                        }
                        if (productTypes.includes("profile.product.click") && !clickedProduct) {
                            throw new Error("clickedProduct is required for profile.product.click");
                        }
                        return [
                            4,
                            getIdOrGenerateId("ssUserId")
                        ];
                    case 2:
                        userId = _state.sent();
                        return [
                            4,
                            getIdOrGenerateId("ssSessionIdNamespace")
                        ];
                    case 3:
                        sessionId = _state.sent();
                        pageLoadId = (0,index_browser/* nanoid */.x0)();
                        pids = {};
                        context = {
                            website: {
                                trackingCode: "nr3jmv"
                            },
                            userId: userId,
                            sessionId: sessionId,
                            pageLoadId: pageLoadId
                        };
                        profileEvents = profileTypes.map(function(type) {
                            var id = (0,index_browser/* nanoid */.x0)();
                            pids[type] = id;
                            return {
                                type: type,
                                category: "searchspring.recommendations.user-interactions",
                                id: id,
                                pid: null,
                                event: {
                                    profile: {
                                        tag: tag,
                                        placement: placement,
                                        seed: seed
                                    },
                                    context: {
                                        type: "product-recommendation",
                                        tag: tag,
                                        placement: placement
                                    }
                                },
                                context: context
                            };
                        });
                        productEvents = productTypes.reduce(function(acc, type) {
                            var _products;
                            if (type === "profile.product.render") _products = products;
                            else if (type === "profile.product.impression") _products = visibleProducts;
                            else if (type === "profile.product.click") _products = [
                                clickedProduct
                            ];
                            else _products = [];
                            var events = _products.map(function(product) {
                                return {
                                    type: type,
                                    category: "searchspring.recommendations.user-interactions",
                                    id: (0,index_browser/* nanoid */.x0)(),
                                    pid: pids[type.replace(".product.", ".")] || null,
                                    event: {
                                        product: {
                                            id: product.id,
                                            seed: seed,
                                            mappings: product.mappings
                                        },
                                        context: {
                                            type: "product-recommendation",
                                            tag: tag,
                                            placement: placement
                                        }
                                    },
                                    context: context
                                };
                            });
                            return (0,_to_consumable_array/* default */.Z)(acc).concat((0,_to_consumable_array/* default */.Z)(events));
                        }, []);
                        events = (0,_to_consumable_array/* default */.Z)(profileEvents).concat((0,_to_consumable_array/* default */.Z)(productEvents));
                        return [
                            4,
                            requestSearchspring({
                                action: "sendToBeacon",
                                params: {
                                    events: events
                                }
                            })
                        ];
                    case 4:
                        data = _state.sent();
                        return [
                            2,
                            data
                        ];
                    case 5:
                        error = _state.sent();
                        console.error("Error with useSearchspringBeacon: ".concat(error.message));
                        throw error;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    return {
        sendEventsToBeacon: sendEventsToBeacon
    };
};

;// CONCATENATED MODULE: ./src/hooks/useProductRecommendations.js








// https://searchspring.zendesk.com/hc/en-us/articles/360052114611-Personalized-Recommendations-API-Request
var useProductRecommendations = function(param) {
    var tag = param.tag, productId = param.productId, limit = param.limit;
    var ref;
    var requestSearchspring = useSearchspring().requestSearchspring;
    var customer = (0,dist.useCustomer)();
    var cartItems = (0,dist.useCartItems)();
    var ref1 = (0,react.useState)(false), mounted = ref1[0], setMounted = ref1[1];
    var ref2 = (0,react.useState)(null), profileData = ref2[0], setProfileData = ref2[1];
    var ref3 = (0,react.useState)(null), recommendations = ref3[0], setRecommendations = ref3[1];
    var customerId = (customer === null || customer === void 0 ? void 0 : customer.id) || "";
    var cart = cartItems === null || cartItems === void 0 ? void 0 : cartItems.map(function(item) {
        return item.variant.sku;
    }).join(",");
    var lastViewed = utils/* isBrowser */.jU ? window.localStorage.getItem("lastViewed") || "" : "";
    // Get product recommendations from Searchspring
    var getProductRecommendations = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var ref, ref1, shopper, params, data, formattedRecs, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    if (!mounted) return [
                        2
                    ];
                    if (!tag) {
                        // Tag derived from product recommendation profile from Searchspring
                        // E.g. 'customers-also-bought', 'customers-also-viewed', 'recently-viewed', 'home', 'view-cart'
                        throw new Error("Tag is required to get product recommendations");
                    }
                    shopper = (0,utils/* getValidId */.MM)(customerId);
                    params = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        tags: tag,
                        product: productId || ""
                    }, shopper ? {
                        shopper: shopper
                    } : null), {
                        cart: cart,
                        lastViewed: lastViewed,
                        limits: limit > 20 ? 20 : limit
                    });
                    return [
                        4,
                        requestSearchspring({
                            action: "getRecommendations",
                            params: params
                        })
                    ];
                case 1:
                    data = _state.sent();
                    formattedRecs = data === null || data === void 0 ? void 0 : (ref = data[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.results) === null || ref1 === void 0 ? void 0 : ref1.map(function(item) {
                        var ref, ref1, ref2;
                        return {
                            handle: ((ref = item.mappings) === null || ref === void 0 ? void 0 : (ref1 = ref.core) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.url) === null || ref2 === void 0 ? void 0 : ref2.split("/").pop()) || ""
                        };
                    });
                    setProfileData((data === null || data === void 0 ? void 0 : data[0]) || null);
                    setRecommendations(formattedRecs || null);
                    return [
                        3,
                        3
                    ];
                case 2:
                    error = _state.sent();
                    console.error("Error with getProductRecommendations: ".concat(error.message));
                    throw error;
                case 3:
                    return [
                        2
                    ];
            }
        });
    }), [
        cart,
        customerId,
        tag,
        productId,
        limit,
        lastViewed,
        mounted
    ]);
    // Add delay for cart
    (0,react.useEffect)(function() {
        setTimeout(function() {
            return setMounted(true);
        }, 300);
    }, []);
    (0,react.useEffect)(function() {
        getProductRecommendations();
    }, [
        cart,
        customerId,
        tag,
        productId,
        limit,
        lastViewed,
        mounted
    ]);
    return {
        profileData: profileData,
        profileTag: (profileData === null || profileData === void 0 ? void 0 : (ref = profileData.profile) === null || ref === void 0 ? void 0 : ref.tag) || null,
        recommendations: recommendations,
        getProductRecommendations: getProductRecommendations
    };
};

;// CONCATENATED MODULE: ./src/hooks/okendo/requestOkendo.js


var requestOkendo = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var action, params, url, options, response, data, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    action = param.action, params = param.params;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    if (!action) throw new Error("requestOkendo error: No action provided!");
                    url = "/api/okendo";
                    options = {
                        method: "POST",
                        body: JSON.stringify({
                            action: action,
                            params: params
                        }),
                        headers: {
                            "Content-Type": "application/json"
                        }
                    };
                    return [
                        4,
                        fetch(url, options)
                    ];
                case 2:
                    response = _state.sent();
                    return [
                        4,
                        response.json()
                    ];
                case 3:
                    data = _state.sent();
                    if (!data) throw new Error("requestOkendo data error: ".concat(data.message));
                    return [
                        2,
                        data
                    ];
                case 4:
                    error = _state.sent();
                    console.error("requestOkendo error: ".concat(error.message));
                    throw error;
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function requestOkendo(_) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/hooks/okendo/useOkendo.js



var useOkendo = function(param) {
    var orderBy = param.orderBy, count = param.count, inView = param.inView;
    var ref = (0,react.useState)([]), reviews = ref[0], setReviews = ref[1];
    (0,react.useEffect)(function() {
        if (!inView) return;
        var paramsAndData = {
            action: "getReviews",
            params: {
                limit: JSON.stringify(count),
                orderBy: orderBy
            }
        };
        requestOkendo(paramsAndData).then(function(res) {
            return setReviews((0,_to_consumable_array/* default */.Z)(res.data.reviews) || []);
        });
    }, [
        count,
        orderBy,
        inView
    ]);
    return {
        requestOkendo: requestOkendo,
        reviews: reviews
    };
};

;// CONCATENATED MODULE: ./src/hooks/okendo/useOkendoStars.js


var useOkendoStars = function(param) {
    var productId = param.productId;
    var ref = (0,react.useState)(null), stars = ref[0], setStars = ref[1];
    (0,react.useEffect)(function() {
        if (!productId) return;
        var paramsAndData = {
            action: "getProductReviewAggregate",
            params: {
                productId: productId
            }
        };
        requestOkendo(paramsAndData).then(function(res) {
            var ref, ref1;
            var data = (ref = res.data) === null || ref === void 0 ? void 0 : ref.reviewAggregate;
            if (!data) return;
            var count = data === null || data === void 0 ? void 0 : data.reviewCount;
            var totalStars = data === null || data === void 0 ? void 0 : data.reviewRatingValuesTotal;
            setStars({
                totalReviews: count,
                averageScore: totalStars / count,
                fiveStarTotalReviews: (data === null || data === void 0 ? void 0 : (ref1 = data.reviewCountByLevel) === null || ref1 === void 0 ? void 0 : ref1.level5Count) || 0
            });
        });
    }, [
        productId
    ]);
    return {
        stars: stars
    };
};

;// CONCATENATED MODULE: ./src/hooks/okendo/useOkendoScrollToReviews.js


var useOkendoScrollToReviews = function() {
    var router = (0,dist.useRouter)();
    // used by OkendoStars to scroll to the main reviews section on PDPs
    var scrollToReviews = (0,react.useCallback)(function() {
        try {
            var isProductPage = /\/products\//.test(router.asPath);
            if (!isProductPage) return;
            var reviewsContainer = document.querySelector('[data-comp="ProductReviews"]');
            reviewsContainer.scrollIntoView({
                behavior: "smooth",
                block: "start",
                inline: "nearest"
            });
        } catch (error) {
            // throw new Error(error)
            console.warn("Error while scrolling to reviews form", error.message);
        }
    });
    return {
        scrollToReviews: scrollToReviews
    };
};

;// CONCATENATED MODULE: ./src/hooks/okendo/index.js




// EXTERNAL MODULE: ../node_modules/lodash.uniqby/index.js
var lodash_uniqby = __webpack_require__(62195);
var lodash_uniqby_default = /*#__PURE__*/__webpack_require__.n(lodash_uniqby);
;// CONCATENATED MODULE: ./src/hooks/useInitWishlist.js








var fetchUserWishlist = function(param) {
    var email = param.email, cachedWishlist = param.cachedWishlist;
    /*#__PURE__*/ return (0,_async_to_generator/* default */.Z)(function() {
        var endpoint, response, ref, data, wishlist, createResponse, createData, lid, remoteWishlist, mergedWishlistItems, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    endpoint = "/api/swym";
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        8,
                        ,
                        9
                    ]);
                    return [
                        4,
                        fetch(endpoint, {
                            method: "post",
                            body: JSON.stringify({
                                action: "getLists",
                                email: email
                            })
                        })
                    ];
                case 2:
                    response = _state.sent();
                    if (!response.ok) return [
                        3,
                        7
                    ];
                    return [
                        4,
                        response.json()
                    ];
                case 3:
                    data = _state.sent();
                    wishlist = data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : ref.find(function(list) {
                        return list.lname === "wishlist";
                    });
                    if (!!wishlist) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        fetch(endpoint, {
                            method: "post",
                            body: JSON.stringify({
                                action: "createList",
                                email: email
                            })
                        })
                    ];
                case 4:
                    createResponse = _state.sent();
                    return [
                        4,
                        createResponse.json()
                    ];
                case 5:
                    createData = _state.sent();
                    wishlist = createData.data;
                    _state.label = 6;
                case 6:
                    lid = wishlist.lid;
                    remoteWishlist = wishlist.listcontents ? wishlist.listcontents.reduce(function(itemsObj, item) {
                        itemsObj.items.push({
                            empi: item.empi,
                            epi: item.epi,
                            du: item.du
                        });
                        return itemsObj;
                    }, {
                        items: []
                    }) : {
                        items: []
                    };
                    mergedWishlistItems = (cachedWishlist === null || cachedWishlist === void 0 ? void 0 : cachedWishlist.items) ? lodash_uniqby_default()((0,_to_consumable_array/* default */.Z)(cachedWishlist.items).concat((0,_to_consumable_array/* default */.Z)(remoteWishlist.items)), "epi") : remoteWishlist.items;
                    return [
                        2,
                        {
                            items: mergedWishlistItems,
                            lid: lid
                        }
                    ];
                case 7:
                    return [
                        2,
                        {
                            items: (cachedWishlist === null || cachedWishlist === void 0 ? void 0 : cachedWishlist.items) || []
                        }
                    ];
                case 8:
                    error = _state.sent();
                    console.error("fetchUserWishlist:", error.message);
                    return [
                        2,
                        null
                    ];
                case 9:
                    return [
                        2
                    ];
            }
        });
    });
};
var useInitWishlist = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* default.wishlistInit */.ZP.wishlistInit), 2), wishlistInit = ref[0], setWishlistInit = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* default.wishlist */.ZP.wishlist), 2), wishlist = ref1[0], setWishlist = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* default.wishlistEmail */.ZP.wishlistEmail), 2), wishlistEmail = ref2[0], setWishlistEmail = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* default.wishlistId */.ZP.wishlistId), 2), wishlistId = ref3[0], setWishlistId = ref3[1];
    var customer = (0,dist.useCustomer)();
    (0,react.useEffect)(function() {
        if (wishlistInit) return;
        setWishlistInit(true);
        var getWishlistedProducts;
        var _wishlistEmail = (customer === null || customer === void 0 ? void 0 : customer.email) || (wishlistEmail === null || wishlistEmail === void 0 ? void 0 : wishlistEmail.email) || null;
        var anonymousWishlist = function(list) {
            return function() {
                return new Promise(function(resolve) {
                    resolve(list);
                });
            };
        };
        if (_wishlistEmail) {
            getWishlistedProducts = fetchUserWishlist({
                email: _wishlistEmail,
                cachedWishlist: wishlist
            });
        } else if (wishlist) {
            getWishlistedProducts = anonymousWishlist(wishlist);
        } else {
            getWishlistedProducts = anonymousWishlist({
                items: []
            });
        }
        (0,_async_to_generator/* default */.Z)(function() {
            var data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            getWishlistedProducts()
                        ];
                    case 1:
                        data = _state.sent();
                        if (Array.isArray(data === null || data === void 0 ? void 0 : data.items)) {
                            if (setWishlist) {
                                setWishlistEmail(_wishlistEmail);
                                setWishlist(data.items);
                                setWishlistId(data.lid);
                            }
                        } else {
                            console.warn("Invalid getWishlist data", data);
                        }
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        customer
    ]);
};

;// CONCATENATED MODULE: ./src/hooks/useWishlist.js




var useWishlist = function() {
    var updateWishlist = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var params, response, json, data, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        params = param.params;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            fetch("/api/swym", {
                                method: "post",
                                body: JSON.stringify((0,_object_spread/* default */.Z)({
                                    action: "updateListProducts"
                                }, params))
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        return [
                            4,
                            response.json()
                        ];
                    case 3:
                        json = _state.sent();
                        data = json.data;
                        return [
                            2,
                            data
                        ];
                    case 4:
                        error = _state.sent();
                        console.log("updateWishlist error:", error);
                        return [
                            2,
                            null
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    return {
        updateWishlist: updateWishlist
    };
};

;// CONCATENATED MODULE: ./src/hooks/useCJCookies.js


var useCJCookies = function() {
    var query = (0,next_router.useRouter)().query;
    var cjEvent = query.cjevent;
    (0,react.useEffect)(function() {
        if (!cjEvent) return;
        var expiration = new Date(Date.now() + 86400000 * 390).toGMTString();
        document.cookie = "brumate_cje=".concat(cjEvent, ";expires=").concat(expiration, ";domain=.brumate.com;path=/;SameSite=None;Secure");
    }, [
        cjEvent
    ]);
};

;// CONCATENATED MODULE: ./src/hooks/useShopperId.js




// set shopper id for searchspring intellisuggest
var useShopperId = function() {
    var customer = (0,dist.useCustomer)();
    var setShopperId = (0,store/* useSetRecoilState */.Zl)(store/* default.shopperId */.ZP.shopperId);
    var ref = (0,react.useState)(false), mounted = ref[0], setMounted = ref[1];
    var customerId = (0,react.useMemo)(function() {
        return (customer === null || customer === void 0 ? void 0 : customer.id) ? (0,utils/* getValidId */.MM)(customer.id) : "";
    }, [
        customer === null || customer === void 0 ? void 0 : customer.id
    ]);
    var setMountedOnDelayForClearing = (0,react.useCallback)(function() {
        setTimeout(function() {
            return setMounted(true);
        }, 5000);
    }, []);
    var clearShopperIdOnNoCustomer = (0,react.useCallback)(function() {
        if (!mounted || customerId) return;
        setShopperId(null);
        window.localStorage.removeItem("bru_shopperId");
    }, [
        customerId,
        mounted
    ]);
    var setShopperIdOnMount = (0,react.useCallback)(function() {
        var localShopperId = window.localStorage.getItem("bru_shopperId");
        if (customerId && localShopperId !== customerId) {
            setShopperId(customerId);
            window.localStorage.setItem("bru_shopperId", customerId);
            return;
        }
        if (localShopperId) {
            setShopperId(localShopperId);
        }
    }, [
        customerId
    ]);
    (0,react.useEffect)(function() {
        setMountedOnDelayForClearing();
    }, []);
    (0,react.useEffect)(function() {
        clearShopperIdOnNoCustomer();
    }, [
        mounted
    ]);
    (0,react.useEffect)(function() {
        setShopperIdOnMount();
    }, [
        customerId
    ]);
};

;// CONCATENATED MODULE: ./src/hooks/localization/useLocalizedSelectedVariant.js






var useLocalizedSelectedVariant = function() {
    var localize = (0,dist.useLocalizedVariant)().localize;
    var getLocalizedVariant = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var countryCode, variant, ref, ref1, ref2, ref3, ref4, ref5, ref6, localizedVariant, localCurrencyCode, localizedAmount, localizedCompareAtAmount, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        countryCode = param.countryCode, variant = param.variant;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        if (!variant) return [
                            2,
                            null
                        ];
                        if (!countryCode) return [
                            2,
                            variant
                        ];
                        return [
                            4,
                            localize({
                                handle: variant.product.handle,
                                selectedOptions: variant.selectedOptions,
                                country: countryCode
                            })
                        ];
                    case 2:
                        localizedVariant = _state.sent();
                        if (!localizedVariant) return [
                            2,
                            variant
                        ];
                        localCurrencyCode = (ref = localizedVariant.priceV2) === null || ref === void 0 ? void 0 : ref.currencyCode;
                        localizedAmount = (ref1 = localizedVariant.priceV2) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.amount) === null || ref2 === void 0 ? void 0 : ref2.toFixed(2);
                        localizedCompareAtAmount = (ref3 = localizedVariant.compareAtPriceV2) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.amount) === null || ref4 === void 0 ? void 0 : ref4.toFixed(2);
                        return [
                            2,
                            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, variant), {
                                currencyCode: localCurrencyCode,
                                priceV2: {
                                    amount: localizedAmount || ((ref5 = variant.priceV2) === null || ref5 === void 0 ? void 0 : ref5.amount),
                                    currencyCode: localCurrencyCode
                                },
                                compareAtPriceV2: {
                                    amount: localizedCompareAtAmount || ((ref6 = variant.compareAtPriceV2) === null || ref6 === void 0 ? void 0 : ref6.amount),
                                    currencyCode: localCurrencyCode
                                },
                                price: localizedAmount || variant.price,
                                compareAtPrice: localizedCompareAtAmount || variant.compareAtPrice
                            })
                        ];
                    case 3:
                        error = _state.sent();
                        console.error("getLocalizedVariant:error", error.message);
                        return [
                            2,
                            variant
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    return {
        getLocalizedVariant: getLocalizedVariant
    };
};

;// CONCATENATED MODULE: ./src/hooks/localization/useLocalizedProducts.js






var useLocalizedProducts = function() {
    var getLocalizedVariant = useLocalizedSelectedVariant().getLocalizedVariant;
    var getLocalizedProductsWithFirstVariant = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var countryCode, products, localizedPromises, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        countryCode = param.countryCode, products = param.products;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        if (!(products === null || products === void 0 ? void 0 : products.length)) return [
                            2,
                            []
                        ];
                        if (!countryCode) return [
                            2,
                            products
                        ];
                        localizedPromises = products.map(function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(function(product) {
                                var ref, ref1, ref2, localizedVariant, amount, currencyCode;
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            if (!(product === null || product === void 0 ? void 0 : (ref = product.variants) === null || ref === void 0 ? void 0 : ref[0])) return [
                                                2,
                                                null
                                            ];
                                            return [
                                                4,
                                                getLocalizedVariant({
                                                    variant: product.variants[0],
                                                    countryCode: countryCode
                                                })
                                            ];
                                        case 1:
                                            localizedVariant = _state.sent();
                                            amount = (ref1 = localizedVariant.priceV2) === null || ref1 === void 0 ? void 0 : ref1.amount;
                                            currencyCode = (ref2 = localizedVariant.priceV2) === null || ref2 === void 0 ? void 0 : ref2.currencyCode;
                                            return [
                                                2,
                                                (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, product), {
                                                    priceRange: {
                                                        max: amount,
                                                        maxVariantPrice: {
                                                            amount: amount,
                                                            currencyCode: currencyCode
                                                        },
                                                        min: amount,
                                                        minVariantPrice: {
                                                            amount: amount,
                                                            currencyCode: currencyCode
                                                        }
                                                    },
                                                    variants: [
                                                        localizedVariant
                                                    ]
                                                })
                                            ];
                                    }
                                });
                            });
                            return function(product) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                        return [
                            4,
                            Promise.all(localizedPromises)
                        ];
                    case 2:
                        return [
                            2,
                            _state.sent()
                        ];
                    case 3:
                        error = _state.sent();
                        console.error("getLocalizedProductsWithFirstVariant:error", error.message);
                        return [
                            2,
                            products
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    return {
        getLocalizedProductsWithFirstVariant: getLocalizedProductsWithFirstVariant
    };
};

;// CONCATENATED MODULE: ./src/hooks/localization/index.js



;// CONCATENATED MODULE: ./src/hooks/datalayer/useDataLayerActions.js








var isDevelopment = "production" === "development";
var useDataLayerActions = function() {
    var getLocalizedVariant = useLocalizedSelectedVariant().getLocalizedVariant;
    var getLocalizedProductsWithFirstVariant = useLocalizedProducts().getLocalizedProductsWithFirstVariant;
    var country = (0,dist.useCountry)().country;
    var countryCode = country === null || country === void 0 ? void 0 : country.isoCode;
    var sendClickProductItemEvent = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var isSearchResult, listIndex, localized, product, searchTerm, selectedVariant, localizedVariant;
            return (0,tslib_es6.__generator)(this, function(_state) {
                isSearchResult = param.isSearchResult, listIndex = param.listIndex, localized = param.localized, product = param.product, searchTerm = param.searchTerm, selectedVariant = param.selectedVariant;
                try {
                    if (!selectedVariant || typeof listIndex !== "number") return [
                        2
                    ];
                    localizedVariant = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, selectedVariant), {
                        priceV2: (localized === null || localized === void 0 ? void 0 : localized.priceV2) || (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.priceV2),
                        compareAtPriceV2: (localized === null || localized === void 0 ? void 0 : localized.compareAtPriceV2) || (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.compareAtPriceV2),
                        image: selectedVariant.image || (product === null || product === void 0 ? void 0 : product.featuredImage) || "",
                        index: listIndex,
                        product: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.product), {
                            collections: product === null || product === void 0 ? void 0 : product.collections,
                            vendor: product === null || product === void 0 ? void 0 : product.vendor
                        }),
                        list: window.location.pathname.startsWith("/collections") ? window.location.pathname : "",
                        searchTerm: searchTerm
                    });
                    PubSub.publish(isSearchResult ? "CLICK_SEARCH_ITEM" : "CLICK_COLLECTION_ITEM", localizedVariant);
                } catch (error) {
                    if (!isDevelopment) return [
                        2
                    ];
                    console.error("DataLayer:sendClickProductItemEvent error", error.message);
                }
                return [
                    2
                ];
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    var sendViewCollectionEvent = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var collectionId, passedCountryCode, products, fullProducts, localizedProducts, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        collectionId = param.collectionId, passedCountryCode = param.countryCode, products = param.products;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        if (!(products === null || products === void 0 ? void 0 : products.length) || !collectionId) return [
                            2
                        ];
                        if (!passedCountryCode && !countryCode) return [
                            2
                        ];
                        return [
                            4,
                            (0,utils/* fetchProductsFromHandles */.H4)(products.slice(0, 7).map(function(param) {
                                var handle = param.handle;
                                return handle;
                            }))
                        ];
                    case 2:
                        fullProducts = _state.sent();
                        return [
                            4,
                            getLocalizedProductsWithFirstVariant({
                                products: fullProducts,
                                countryCode: passedCountryCode || countryCode
                            })
                        ];
                    case 3:
                        localizedProducts = _state.sent();
                        PubSub.publish("VIEW_COLLECTION_PAGE", {
                            products: localizedProducts === null || localizedProducts === void 0 ? void 0 : localizedProducts.filter(Boolean),
                            id: collectionId.split("/").pop()
                        });
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        if (!isDevelopment) return [
                            2
                        ];
                        console.error("DataLayer:sendViewCollectionEvent error", error.message);
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        countryCode
    ]);
    var sendViewProductEvent = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var passedCountryCode, product, _selectedVariant, selectedVariant, ref, localizedVariant, image, ref1, ref2, handle, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        passedCountryCode = param.countryCode, product = param.product, _selectedVariant = param.selectedVariant;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        if (!product) return [
                            2
                        ];
                        if (!passedCountryCode && !countryCode) return [
                            2
                        ];
                        selectedVariant = _selectedVariant;
                        // if no selected variant is passed, use the first variant
                        if (!selectedVariant) {
                            ;
                            selectedVariant = (ref = product.variants) === null || ref === void 0 ? void 0 : ref[0];
                        }
                        if (!selectedVariant) return [
                            2
                        ];
                        return [
                            4,
                            getLocalizedVariant({
                                variant: selectedVariant,
                                countryCode: passedCountryCode || countryCode
                            })
                        ];
                    case 2:
                        localizedVariant = _state.sent();
                        image = product.featuredImage;
                        if (!localizedVariant.image) {
                            ;
                            handle = localizedVariant === null || localizedVariant === void 0 ? void 0 : (ref1 = localizedVariant.product) === null || ref1 === void 0 ? void 0 : ref1.handle;
                            image = (ref2 = product.media.find(function(media) {
                                return media.product.handle === handle;
                            })) === null || ref2 === void 0 ? void 0 : ref2.image;
                        }
                        localizedVariant = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, localizedVariant), {
                            image: localizedVariant.image || image,
                            product: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, localizedVariant.product), {
                                collections: product.collections,
                                vendor: product.vendor
                            })
                        });
                        PubSub.publish("VIEW_PRODUCT_PAGE", localizedVariant);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        if (!isDevelopment) return [
                            2
                        ];
                        console.error("DataLayer:sendViewProductEvent error", error.message);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        countryCode
    ]);
    var sendViewSearchResultsEvent = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var passedCountryCode, isSearchPage, products, searchTerm, fullProducts, localizedProducts, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        passedCountryCode = param.countryCode, isSearchPage = param.isSearchPage, products = param.products, searchTerm = param.searchTerm;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        if (!(products === null || products === void 0 ? void 0 : products.length)) return [
                            2
                        ];
                        if (!passedCountryCode && !countryCode) return [
                            2
                        ];
                        return [
                            4,
                            (0,utils/* fetchProductsFromHandles */.H4)(products.slice(0, 12).map(function(param) {
                                var handle = param.handle;
                                return handle;
                            }))
                        ];
                    case 2:
                        fullProducts = _state.sent();
                        return [
                            4,
                            getLocalizedProductsWithFirstVariant({
                                products: fullProducts,
                                countryCode: passedCountryCode || countryCode
                            })
                        ];
                    case 3:
                        localizedProducts = _state.sent();
                        PubSub.publish(isSearchPage ? "VIEW_SEARCH_PAGE_RESULTS" : "VIEW_SEARCH_RESULTS", localizedProducts === null || localizedProducts === void 0 ? void 0 : localizedProducts.filter(Boolean).map(function(product) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, product), {
                                searchTerm: searchTerm
                            });
                        }));
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        if (!isDevelopment) return [
                            2
                        ];
                        console.error("DataLayer:sendViewSearchResultsEvent error", error.message);
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        countryCode
    ]);
    var sendSubscribeEvent = (0,react.useCallback)(function(param) {
        var email = param.email, phone = param.phone;
        if (email) {
            PubSub.publish("SUBSCRIBE_EMAIL", email);
        }
        if (phone) {
            PubSub.publish("SUBSCRIBE_PHONE", phone);
        }
    }, []);
    var sendLogInEvent = (0,react.useCallback)(function() {
        PubSub.publish("CUSTOMER_LOGGED_IN");
    }, []);
    var sendRegisterEvent = (0,react.useCallback)(function() {
        PubSub.publish("CUSTOMER_REGISTERED");
    }, []);
    return {
        sendClickProductItemEvent: sendClickProductItemEvent,
        sendViewCollectionEvent: sendViewCollectionEvent,
        sendViewProductEvent: sendViewProductEvent,
        sendViewSearchResultsEvent: sendViewSearchResultsEvent,
        sendSubscribeEvent: sendSubscribeEvent,
        sendLogInEvent: sendLogInEvent,
        sendRegisterEvent: sendRegisterEvent
    };
};

;// CONCATENATED MODULE: ./src/hooks/datalayer/index.js


;// CONCATENATED MODULE: ./src/hooks/usePackCookie.js

function usePackCookie() {
    (0,react.useEffect)(function() {
        fetch("/api/pack-cookie");
    }, []);
}

;// CONCATENATED MODULE: ../node_modules/@shopify/hydrogen-react/dist/browser-prod/analytics-constants.mjs
const AnalyticsEventName = {
  PAGE_VIEW: "PAGE_VIEW",
  ADD_TO_CART: "ADD_TO_CART"
};
const AnalyticsPageType = {
  article: "article",
  blog: "blog",
  captcha: "captcha",
  cart: "cart",
  collection: "collection",
  customersAccount: "customers/account",
  customersActivateAccount: "customers/activate_account",
  customersAddresses: "customers/addresses",
  customersLogin: "customers/login",
  customersOrder: "customers/order",
  customersRegister: "customers/register",
  customersResetPassword: "customers/reset_password",
  giftCard: "gift_card",
  home: "index",
  listCollections: "list-collections",
  forbidden: "403",
  notFound: "404",
  page: "page",
  password: "password",
  product: "product",
  policy: "policy",
  search: "search"
};
const ShopifySalesChannel = {
  hydrogen: "hydrogen",
  headless: "headless"
};
const ShopifyAppId = {
  hydrogen: "6167201",
  headless: "12875497473"
};

//# sourceMappingURL=analytics-constants.mjs.map

;// CONCATENATED MODULE: ../node_modules/@shopify/hydrogen-react/dist/browser-prod/cart-constants.mjs
const CART_ID_STORAGE_KEY = "shopifyCartId";
const SHOPIFY_STOREFRONT_ID_HEADER = "Shopify-Storefront-Id";
const SHOPIFY_STOREFRONT_Y_HEADER = "Shopify-Storefront-Y";
const SHOPIFY_STOREFRONT_S_HEADER = "Shopify-Storefront-S";
const SHOPIFY_Y = "_shopify_y";
const SHOPIFY_S = "_shopify_s";

//# sourceMappingURL=cart-constants.mjs.map

;// CONCATENATED MODULE: ../node_modules/@shopify/hydrogen-react/dist/browser-prod/analytics-utils.mjs
function schemaWrapper(schemaId, payload) {
  return {
    schema_id: schemaId,
    payload,
    metadata: {
      event_created_at_ms: Date.now()
    }
  };
}
function parseGid(gid) {
  const defaultReturn = {
    id: "",
    resource: null,
    resourceId: null,
    search: "",
    searchParams: new URLSearchParams(),
    hash: ""
  };
  if (typeof gid !== "string") {
    return defaultReturn;
  }
  try {
    const { search, searchParams, pathname, hash } = new URL(gid);
    const pathnameParts = pathname.split("/");
    const lastPathnamePart = pathnameParts[pathnameParts.length - 1];
    const resourcePart = pathnameParts[pathnameParts.length - 2];
    if (!lastPathnamePart || !resourcePart) {
      return defaultReturn;
    }
    const id = `${lastPathnamePart}${search}${hash}` || "";
    const resourceId = lastPathnamePart || null;
    const resource = resourcePart ?? null;
    return { id, resource, resourceId, search, searchParams, hash };
  } catch {
    return defaultReturn;
  }
}
function addDataIf(keyValuePairs, formattedData) {
  if (typeof keyValuePairs !== "object") {
    return {};
  }
  Object.entries(keyValuePairs).forEach(([key, value]) => {
    if (value) {
      formattedData[key] = value;
    }
  });
  return formattedData;
}
function errorIfServer(fnName) {
  if (typeof document === "undefined") {
    console.error(
      `${fnName} should only be used within the useEffect callback or event handlers`
    );
    return true;
  }
  return false;
}

//# sourceMappingURL=analytics-utils.mjs.map

;// CONCATENATED MODULE: ../node_modules/worktop/cookie/index.mjs
// src/cookie.ts
var g = new Set([
  "domain",
  "path",
  "max-age",
  "expires",
  "samesite",
  "secure",
  "httponly"
]);
function u(a) {
  let r = {}, e, t, n = 0, m = a.split(/;\s*/g), s, i;
  for (; n < m.length; n++)
    if (t = m[n], e = t.indexOf("="), ~e) {
      if (s = t.substring(0, e++).trim(), i = t.substring(e).trim(), i[0] === '"' && (i = i.substring(1, i.length - 1)), ~i.indexOf("%"))
        try {
          i = decodeURIComponent(i);
        } catch (f) {
        }
      g.has(t = s.toLowerCase()) ? t === "expires" ? r.expires = new Date(i) : t === "max-age" ? r.maxage = +i : r[t] = i : r[s] = i;
    } else
      (s = t.trim().toLowerCase()) && (s === "httponly" || s === "secure") && (r[s] = !0);
  return r;
}
function l(a, r, e = {}) {
  let t = a + "=" + encodeURIComponent(r);
  return e.expires && (t += "; Expires=" + new Date(e.expires).toUTCString()), e.maxage != null && e.maxage >= 0 && (t += "; Max-Age=" + (e.maxage | 0)), e.domain && (t += "; Domain=" + e.domain), e.path && (t += "; Path=" + e.path), e.samesite && (t += "; SameSite=" + e.samesite), (e.secure || e.samesite === "None") && (t += "; Secure"), e.httponly && (t += "; HttpOnly"), t;
}


;// CONCATENATED MODULE: ../node_modules/@shopify/hydrogen-react/dist/browser-prod/cookies-utils.mjs


const tokenHash = "xxxx-4xxx-xxxx-xxxxxxxxxxxx";
function buildUUID() {
  let hash = "";
  try {
    const crypto = window.crypto;
    const randomValuesArray = new Uint16Array(31);
    crypto.getRandomValues(randomValuesArray);
    let i = 0;
    hash = tokenHash.replace(/[x]/g, (c) => {
      const r = randomValuesArray[i] % 16;
      const v = c === "x" ? r : r & 3 | 8;
      i++;
      return v.toString(16);
    }).toUpperCase();
  } catch (err) {
    hash = tokenHash.replace(/[x]/g, (c) => {
      const r = Math.random() * 16 | 0;
      const v = c === "x" ? r : r & 3 | 8;
      return v.toString(16);
    }).toUpperCase();
  }
  return `${hexTime()}-${hash}`;
}
function hexTime() {
  let dateNumber = 0;
  let perfNumber = 0;
  dateNumber = (/* @__PURE__ */ new Date()).getTime() >>> 0;
  try {
    perfNumber = performance.now() >>> 0;
  } catch (err) {
    perfNumber = 0;
  }
  const output = Math.abs(dateNumber + perfNumber).toString(16).toLowerCase();
  return output.padStart(8, "0");
}
function getShopifyCookies(cookies) {
  const cookieData = u(cookies);
  return {
    [SHOPIFY_Y]: cookieData[SHOPIFY_Y] || "",
    [SHOPIFY_S]: cookieData[SHOPIFY_S] || ""
  };
}

//# sourceMappingURL=cookies-utils.mjs.map

;// CONCATENATED MODULE: ../node_modules/@shopify/hydrogen-react/dist/browser-prod/analytics-schema-trekkie-storefront-page-view.mjs



const SCHEMA_ID = "trekkie_storefront_page_view/1.4";
const OXYGEN_DOMAIN = "myshopify.dev";
function pageView(payload) {
  const pageViewPayload = payload;
  const { id, resource } = parseGid(pageViewPayload.resourceId);
  const resourceType = resource ? resource.toLowerCase() : void 0;
  return [
    schemaWrapper(
      SCHEMA_ID,
      addDataIf(
        {
          pageType: pageViewPayload.pageType,
          customerId: pageViewPayload.customerId,
          resourceType,
          resourceId: parseInt(id)
        },
        formatPayload(pageViewPayload)
      )
    )
  ];
}
function formatPayload(payload) {
  return {
    appClientId: payload.shopifySalesChannel ? ShopifyAppId[payload.shopifySalesChannel] : ShopifyAppId.headless,
    isMerchantRequest: isMerchantRequest(payload.url),
    hydrogenSubchannelId: payload.storefrontId || "0",
    isPersistentCookie: payload.hasUserConsent,
    uniqToken: payload.uniqueToken,
    visitToken: payload.visitToken,
    microSessionId: buildUUID(),
    microSessionCount: 1,
    url: payload.url,
    path: payload.path,
    search: payload.search,
    referrer: payload.referrer,
    title: payload.title,
    shopId: parseInt(parseGid(payload.shopId).id),
    currency: payload.currency,
    contentLanguage: payload.acceptedLanguage || "en"
  };
}
function isMerchantRequest(url) {
  if (typeof url !== "string") {
    return false;
  }
  const hostname = new URL(url).hostname;
  if (hostname.indexOf(OXYGEN_DOMAIN) !== -1 || hostname === "localhost") {
    return true;
  }
  return false;
}

//# sourceMappingURL=analytics-schema-trekkie-storefront-page-view.mjs.map

;// CONCATENATED MODULE: ../node_modules/@shopify/hydrogen-react/dist/browser-prod/analytics-schema-custom-storefront-customer-tracking.mjs



const analytics_schema_custom_storefront_customer_tracking_SCHEMA_ID = "custom_storefront_customer_tracking/1.0";
const PAGE_RENDERED_EVENT_NAME = "page_rendered";
const COLLECTION_PAGE_RENDERED_EVENT_NAME = "collection_page_rendered";
const PRODUCT_PAGE_RENDERED_EVENT_NAME = "product_page_rendered";
const PRODUCT_ADDED_TO_CART_EVENT_NAME = "product_added_to_cart";
const SEARCH_SUBMITTED_EVENT_NAME = "search_submitted";
function analytics_schema_custom_storefront_customer_tracking_pageView(payload) {
  const pageViewPayload = payload;
  const additionalPayload = {
    canonical_url: pageViewPayload.canonicalUrl || pageViewPayload.url,
    customer_id: pageViewPayload.customerId
  };
  const pageType = pageViewPayload.pageType;
  const pageViewEvents = [];
  pageViewEvents.push(
    schemaWrapper(
      analytics_schema_custom_storefront_customer_tracking_SCHEMA_ID,
      addDataIf(
        {
          event_name: PAGE_RENDERED_EVENT_NAME,
          ...additionalPayload
        },
        analytics_schema_custom_storefront_customer_tracking_formatPayload(pageViewPayload)
      )
    )
  );
  switch (pageType) {
    case AnalyticsPageType.collection:
      pageViewEvents.push(
        schemaWrapper(
          analytics_schema_custom_storefront_customer_tracking_SCHEMA_ID,
          addDataIf(
            {
              event_name: COLLECTION_PAGE_RENDERED_EVENT_NAME,
              ...additionalPayload,
              collection_name: pageViewPayload.collectionHandle
            },
            analytics_schema_custom_storefront_customer_tracking_formatPayload(pageViewPayload)
          )
        )
      );
      break;
    case AnalyticsPageType.product:
      pageViewEvents.push(
        schemaWrapper(
          analytics_schema_custom_storefront_customer_tracking_SCHEMA_ID,
          addDataIf(
            {
              event_name: PRODUCT_PAGE_RENDERED_EVENT_NAME,
              ...additionalPayload,
              products: formatProductPayload(pageViewPayload.products),
              total_value: pageViewPayload.totalValue
            },
            analytics_schema_custom_storefront_customer_tracking_formatPayload(pageViewPayload)
          )
        )
      );
      break;
    case AnalyticsPageType.search:
      pageViewEvents.push(
        schemaWrapper(
          analytics_schema_custom_storefront_customer_tracking_SCHEMA_ID,
          addDataIf(
            {
              event_name: SEARCH_SUBMITTED_EVENT_NAME,
              ...additionalPayload,
              search_string: pageViewPayload.searchString
            },
            analytics_schema_custom_storefront_customer_tracking_formatPayload(pageViewPayload)
          )
        )
      );
      break;
  }
  return pageViewEvents;
}
function addToCart(payload) {
  const addToCartPayload = payload;
  const cartToken = parseGid(addToCartPayload.cartId);
  const cart_token = (cartToken == null ? void 0 : cartToken.id) ? `${cartToken.id}` : null;
  return [
    schemaWrapper(
      analytics_schema_custom_storefront_customer_tracking_SCHEMA_ID,
      addDataIf(
        {
          event_name: PRODUCT_ADDED_TO_CART_EVENT_NAME,
          customerId: addToCartPayload.customerId,
          cart_token,
          total_value: addToCartPayload.totalValue,
          products: formatProductPayload(addToCartPayload.products)
        },
        analytics_schema_custom_storefront_customer_tracking_formatPayload(addToCartPayload)
      )
    )
  ];
}
function analytics_schema_custom_storefront_customer_tracking_formatPayload(payload) {
  return {
    source: payload.shopifySalesChannel || ShopifySalesChannel.headless,
    hydrogenSubchannelId: payload.storefrontId || "0",
    is_persistent_cookie: payload.hasUserConsent,
    ccpa_enforced: false,
    gdpr_enforced: false,
    unique_token: payload.uniqueToken,
    event_time: Date.now(),
    event_id: buildUUID(),
    event_source_url: payload.url,
    referrer: payload.referrer,
    user_agent: payload.userAgent,
    navigation_type: payload.navigationType,
    navigation_api: payload.navigationApi,
    shop_id: parseInt(parseGid(payload.shopId).id),
    currency: payload.currency
  };
}
function formatProductPayload(products) {
  return products ? products.map((p) => {
    const product = addDataIf(
      {
        variant_gid: p.variantGid,
        category: p.category,
        sku: p.sku,
        product_id: parseInt(parseGid(p.productGid).id),
        variant_id: parseInt(parseGid(p.variantGid).id)
      },
      {
        product_gid: p.productGid,
        name: p.name,
        variant: p.variantName || "",
        brand: p.brand,
        price: parseFloat(p.price),
        quantity: Number(p.quantity || 0)
      }
    );
    return JSON.stringify(product);
  }) : [];
}

//# sourceMappingURL=analytics-schema-custom-storefront-customer-tracking.mjs.map

;// CONCATENATED MODULE: ../node_modules/@shopify/hydrogen-react/dist/browser-prod/analytics.mjs






function sendShopifyAnalytics(event, shopDomain) {
  const { eventName, payload } = event;
  if (!payload.hasUserConsent)
    return Promise.resolve();
  let events = [];
  if (eventName === AnalyticsEventName.PAGE_VIEW) {
    const pageViewPayload = payload;
    events = events.concat(
      pageView(pageViewPayload),
      analytics_schema_custom_storefront_customer_tracking_pageView(pageViewPayload)
    );
  } else if (eventName === AnalyticsEventName.ADD_TO_CART) {
    events = events.concat(
      addToCart(payload)
    );
  }
  if (events.length) {
    return sendToShopify(events, shopDomain);
  } else {
    return Promise.resolve();
  }
}
const ERROR_MESSAGE = "sendShopifyAnalytics request is unsuccessful";
function sendToShopify(events, shopDomain) {
  const eventsToBeSent = {
    events,
    metadata: {
      event_sent_at_ms: Date.now()
    }
  };
  try {
    return fetch(
      shopDomain ? `https://${shopDomain}/.well-known/shopify/monorail/unstable/produce_batch` : "https://monorail-edge.shopifysvc.com/unstable/produce_batch",
      {
        method: "post",
        headers: {
          "content-type": "text/plain"
        },
        body: JSON.stringify(eventsToBeSent)
      }
    ).then((response) => {
      if (!response.ok) {
        throw new Error("Response failed");
      }
      return response.text();
    }).then((data) => {
      if (data) {
        const jsonResponse = JSON.parse(data);
        jsonResponse.result.forEach((eventResponse) => {
          if (eventResponse.status !== 200) {
            console.error(ERROR_MESSAGE, "\n\n", eventResponse.message);
          }
        });
      }
    }).catch((err) => {
      console.error(ERROR_MESSAGE, err);
      if (false)
        {}
    });
  } catch (error) {
    return Promise.resolve();
  }
}
function getClientBrowserParameters() {
  if (errorIfServer("getClientBrowserParameters")) {
    return {
      uniqueToken: "",
      visitToken: "",
      url: "",
      path: "",
      search: "",
      referrer: "",
      title: "",
      userAgent: "",
      navigationType: "",
      navigationApi: ""
    };
  }
  const [navigationType, navigationApi] = getNavigationType();
  const cookies = getShopifyCookies(document.cookie);
  return {
    uniqueToken: cookies[SHOPIFY_Y],
    visitToken: cookies[SHOPIFY_S],
    url: location.href,
    path: location.pathname,
    search: location.search,
    referrer: document.referrer,
    title: document.title,
    userAgent: navigator.userAgent,
    navigationType,
    navigationApi
  };
}
function getNavigationTypeExperimental() {
  try {
    const navigationEntries = (performance == null ? void 0 : performance.getEntriesByType) && (performance == null ? void 0 : performance.getEntriesByType("navigation"));
    if (navigationEntries && navigationEntries[0]) {
      const rawType = window.performance.getEntriesByType(
        "navigation"
      )[0]["type"];
      const navType = rawType && rawType.toString();
      return navType;
    }
  } catch (err) {
  }
  return void 0;
}
function getNavigationTypeLegacy() {
  var _a, _b;
  try {
    if (PerformanceNavigation && ((_a = performance == null ? void 0 : performance.navigation) == null ? void 0 : _a.type) !== null && ((_b = performance == null ? void 0 : performance.navigation) == null ? void 0 : _b.type) !== void 0) {
      const rawType = performance.navigation.type;
      switch (rawType) {
        case PerformanceNavigation.TYPE_NAVIGATE:
          return "navigate";
          break;
        case PerformanceNavigation.TYPE_RELOAD:
          return "reload";
          break;
        case PerformanceNavigation.TYPE_BACK_FORWARD:
          return "back_forward";
          break;
        default:
          return `unknown: ${rawType}`;
      }
    }
  } catch (err) {
  }
  return void 0;
}
function getNavigationType() {
  try {
    let navApi = "PerformanceNavigationTiming";
    let navType = getNavigationTypeExperimental();
    if (!navType) {
      navType = getNavigationTypeLegacy();
      navApi = "performance.navigation";
    }
    if (navType) {
      return [navType, navApi];
    } else {
      return ["unknown", "unknown"];
    }
  } catch (err) {
  }
  return ["error", "error"];
}

//# sourceMappingURL=analytics.mjs.map

;// CONCATENATED MODULE: ../node_modules/@shopify/hydrogen-react/dist/browser-prod/useShopifyCookies.mjs




const longTermLength = 60 * 60 * 24 * 360 * 1;
const shortTermLength = 60 * 30;
function useShopifyCookies(options) {
  const { hasUserConsent = false, domain = "" } = options || {};
  (0,react.useEffect)(() => {
    const cookies = getShopifyCookies(document.cookie);
    if (hasUserConsent) {
      setCookie(
        SHOPIFY_Y,
        cookies[SHOPIFY_Y] || buildUUID(),
        longTermLength,
        domain
      );
      setCookie(
        SHOPIFY_S,
        cookies[SHOPIFY_S] || buildUUID(),
        shortTermLength,
        domain
      );
    } else {
      setCookie(SHOPIFY_Y, "", 0, domain);
      setCookie(SHOPIFY_S, "", 0, domain);
    }
  });
}
function setCookie(name, value, maxage, domain) {
  document.cookie = l(name, value, {
    maxage,
    domain,
    samesite: "Lax",
    path: "/"
  });
}

//# sourceMappingURL=useShopifyCookies.mjs.map

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(17599);
// EXTERNAL MODULE: ../node_modules/fast-deep-equal/index.js
var fast_deep_equal = __webpack_require__(66471);
var fast_deep_equal_default = /*#__PURE__*/__webpack_require__.n(fast_deep_equal);
;// CONCATENATED MODULE: ./src/hooks/shopify-analytics/useShopifyAnalyticsAddToCart.js







function useShopifyAnalyticsAddToCart(param) {
    var basePayload = param.basePayload, sendShopifyAnalyticsEvent = param.sendShopifyAnalyticsEvent;
    var cart = (0,dist.useCart)();
    var cartCount = (0,dist.useCartCount)();
    var cartItems = (0,dist.useCartItems)();
    var ref = (0,react.useState)(null), previousCartCount = ref[0], setPreviousCartCount = ref[1];
    var ref1 = (0,react.useState)(null), previousCartItems = ref1[0], setPreviousCartItems = ref1[1];
    var ref2 = (0,react.useState)(null), previousCartItemsMap = ref2[0], setPreviousCartItemsMap = ref2[1];
    (0,react.useEffect)(function() {
        if (!basePayload || !cart) return;
        var cartItemsMap = cartItems.reduce(function(acc, line) {
            if (!line.variant) return acc;
            var variantId = line.variant.id;
            if (!acc[variantId]) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, variantId, [
                    line
                ]));
            }
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, variantId, (0,_to_consumable_array/* default */.Z)(acc[variantId]).concat([
                line
            ])));
        }, {});
        if (!previousCartItems || cartCount <= previousCartCount) {
            setPreviousCartItems(cartItems);
            setPreviousCartCount(cartCount);
            setPreviousCartItemsMap(cartItemsMap);
            return;
        }
        var isAddedItems = [];
        var isIncreasedItems = [];
        cartItems.forEach(function(line, index) {
            var ref, ref1;
            var variantId = (ref = line.variant) === null || ref === void 0 ? void 0 : ref.id;
            if (!variantId) return;
            var previousLine = (ref1 = previousCartItemsMap[variantId]) === null || ref1 === void 0 ? void 0 : ref1.find(function(prevLine) {
                return fast_deep_equal_default()(prevLine.attributes, line.attributes);
            });
            if (!previousLine) {
                var ref2, ref3;
                isAddedItems.push((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, line), {
                    index: index,
                    quantityAdded: line.quantity,
                    totalPrice: (ref2 = line.estimatedCost) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.totalAmount) === null || ref3 === void 0 ? void 0 : ref3.amount
                }));
                return;
            }
            if (line.quantity > previousLine.quantity) {
                var ref4, ref5;
                var quantityAdded = line.quantity - previousLine.quantity;
                var totalAmount = ((ref4 = line.estimatedCost) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.totalAmount) === null || ref5 === void 0 ? void 0 : ref5.amount) || "0";
                isIncreasedItems.push((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, line), {
                    index: index,
                    quantityAdded: quantityAdded,
                    totalPrice: (parseFloat(totalAmount) / line.quantity * quantityAdded).toFixed(2)
                }));
            }
        });
        var updatedCartItems = (0,_to_consumable_array/* default */.Z)(isAddedItems).concat((0,_to_consumable_array/* default */.Z)(isIncreasedItems));
        if (!updatedCartItems.length) return;
        var totalValue = updatedCartItems.reduce(function(acc, line) {
            return acc + parseFloat(line.totalPrice || "0");
        }, 0);
        var products = updatedCartItems.map(function(line) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                productGid: line.variant.product.id,
                name: line.variant.product.title,
                price: line.totalPrice,
                variantGid: line.variant.id,
                variantName: line.variant.title,
                category: line.variant.product.productType,
                brand: "BrüMate" || 0
            }, line.variant.sku ? {
                sku: line.variant.sku
            } : null), {
                quantity: line.quantityAdded
            });
        });
        sendShopifyAnalyticsEvent(// payload
        (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, basePayload), {
            cartId: cart.id,
            totalValue: totalValue,
            products: products
        }), // event name
        "ADD_TO_CART", // callback
        function() {
            setPreviousCartItems(cartItems);
            setPreviousCartCount(cartCount);
            setPreviousCartItemsMap(cartItemsMap);
        });
    }, [
        basePayload,
        cart === null || cart === void 0 ? void 0 : cart.updatedAt
    ]);
}

;// CONCATENATED MODULE: ./src/hooks/shopify-analytics/useShopifyAnalyticsPageView.js




var PAGE_TYPES = {
    "/": "home",
    "/account": "customersAccount",
    "/account/activate": "customersActivateAccount",
    "/account/address-book": "customersAddresses",
    "/account/login": "customersLogin",
    "/account/orders/": "customersOrders",
    "/account/register": "customersRegister",
    "/account/reset-password": "customersResetPassword",
    "/articles": "article",
    "/blogs": "blog",
    "/cart": "cart",
    "/collections": "collection",
    "/not-found": "notFound",
    "/pages": "page",
    "/pages/404": "notFound",
    "/pages/privacy-policy": "policy",
    "/pages/search": "search",
    "/products": "product"
};
function useShopifyAnalyticsPageView(param) {
    var basePayload = param.basePayload, collection = param.collection, product = param.product, sendShopifyAnalyticsEvent = param.sendShopifyAnalyticsEvent;
    var pathnameRef = (0,react.useRef)(null);
    var ref = (0,next_router.useRouter)(), asPath = ref.asPath, query = ref.query;
    var pathname = asPath.split("?")[0];
    var searchString = pathname === "/pages/search" && query.term;
    (0,react.useEffect)(function() {
        if (!basePayload || pathnameRef.current === pathname && !searchString) return undefined;
        sendShopifyAnalyticsEvent(// payload
        (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, basePayload), {
            canonicalUrl: "".concat("https://www.brumate.com").concat(window.location.pathname === "/" ? "" : window.location.pathname),
            pageType: pathname.startsWith("/account/orders/") ? PAGE_TYPES["/account/orders/"] : PAGE_TYPES[pathname] || PAGE_TYPES[pathname.split("/").slice(0, -1).join("/")] || ""
        }), searchString ? {
            searchString: searchString
        } : null, collection ? {
            collectionHandle: collection.handle,
            resourceId: collection.id
        } : null, product ? {
            totalValue: parseFloat(product.priceRange.min),
            resourceId: product.id,
            products: [
                {
                    productGid: product.id,
                    name: product.title,
                    brand: product.vendor,
                    price: product.priceRange.min,
                    category: product.productType
                }, 
            ]
        } : null), // event name
        "PAGE_VIEW");
        pathnameRef.current = pathname;
        return function() {
            pathnameRef.current = pathname;
        };
    }, [
        basePayload,
        pathname,
        searchString
    ]);
}

;// CONCATENATED MODULE: ./src/hooks/shopify-analytics/useShopifyAnalytics.js








// Envs to set:
// * NEXT_PUBLIC_SHOPIFY_SHOP_ID // see readme on where to obtain
// * NEXT_PUBLIC_SITE_TITLE // provides brand name
var useShopifyAnalytics_DEBUG = true;
var sendShopifyAnalyticsEvent = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(analyticsPageData, eventName, callback) {
        var payload, event, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    if (!AnalyticsEventName[eventName]) return [
                        2
                    ];
                    payload = (0,_object_spread/* default */.Z)({}, getClientBrowserParameters(), analyticsPageData);
                    event = {
                        eventName: AnalyticsEventName[eventName],
                        payload: payload
                    };
                    return [
                        4,
                        sendShopifyAnalytics(event)
                    ];
                case 1:
                    _state.sent();
                    if (typeof callback === "function") callback(event);
                    if (useShopifyAnalytics_DEBUG) console.log("sendShopifyAnalytics:event", event);
                    return [
                        3,
                        3
                    ];
                case 2:
                    error = _state.sent();
                    console.error("sendShopifyAnalyticsEvent:error", error.message);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function sendShopifyAnalyticsEvent(analyticsPageData, eventName, callback) {
        return _ref.apply(this, arguments);
    };
}();
var hasUserConsent = true;
function useShopifyAnalytics(param) {
    var collection = param.collection, product = param.product;
    var currency = (0,dist.useCurrency)();
    var customer = (0,dist.useCustomer)();
    var settings = (0,dist.useSettings)();
    var enabled = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : settings.analytics).enabled;
    var customerPending = typeof customer === "undefined";
    var basePayload = (0,react.useMemo)(function() {
        if (!currency || customerPending || !enabled || !"11142308") return null;
        return (0,_object_spread/* default */.Z)({
            hasUserConsent: hasUserConsent,
            shopId: "gid://shopify/Shop/".concat("11142308"),
            currency: currency,
            acceptedLanguage: "en",
            shopifySalesChannel: "headless"
        }, customer ? {
            customerId: parseInt(customer.id.split("/").pop(), 10)
        } : null);
    }, [
        currency,
        customer,
        enabled,
        hasUserConsent
    ]);
    useShopifyCookies({
        hasUserConsent: hasUserConsent && !!enabled
    });
    useShopifyAnalyticsPageView({
        basePayload: basePayload,
        collection: collection,
        product: product,
        sendShopifyAnalyticsEvent: sendShopifyAnalyticsEvent
    });
    useShopifyAnalyticsAddToCart({
        basePayload: basePayload,
        sendShopifyAnalyticsEvent: sendShopifyAnalyticsEvent
    });
}

;// CONCATENATED MODULE: ./src/hooks/shopify-analytics/index.js


;// CONCATENATED MODULE: ./src/hooks/useCountdown.js

var getReturnValues = function(countDown) {
    // calculate time left
    var days = Math.floor(countDown / (1000 * 60 * 60 * 24));
    var hours = Math.floor(countDown % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
    var minutes = Math.floor(countDown % (1000 * 60 * 60) / (1000 * 60));
    var seconds = Math.floor(countDown % (1000 * 60) / 1000);
    return [
        days,
        hours,
        minutes,
        seconds
    ];
};
var useCountdown = function(targetDate) {
    var countDownDate = new Date(targetDate).getTime();
    var ref = (0,react.useState)(countDownDate - new Date().getTime()), countDown = ref[0], setCountDown = ref[1];
    (0,react.useEffect)(function() {
        var interval = setInterval(function() {
            setCountDown(countDownDate - new Date().getTime());
        }, 1000);
        return function() {
            return clearInterval(interval);
        };
    }, [
        countDownDate
    ]);
    return getReturnValues(countDown);
};


;// CONCATENATED MODULE: ./src/hooks/useEmailSignup.js






var useEmailSignup = function() {
    var _ref = (0,dist.useStartFinishErrors)(), setStarted = _ref.setStarted, setFinished = _ref.setFinished, setErrors = _ref.setErrors, reset = _ref.reset, status = (0,_object_without_properties/* default */.Z)(_ref, [
        "setStarted",
        "setFinished",
        "setErrors",
        "reset"
    ]);
    var submitEmailSignup = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(emailListId, email, source) {
            var url, options, response, data, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        if (!email) {
                            return [
                                2,
                                console.error("Missing required parameter: email")
                            ];
                        }
                        reset();
                        setStarted(true);
                        url = "/api/klaviyo";
                        options = {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({
                                action: "emailSignup",
                                emailListId: emailListId,
                                email: email,
                                source: source
                            })
                        };
                        return [
                            4,
                            fetch(url, options)
                        ];
                    case 1:
                        response = _state.sent();
                        return [
                            4,
                            response.json()
                        ];
                    case 2:
                        data = _state.sent();
                        if (data === null || data === void 0 ? void 0 : data.success) {
                            setFinished(true);
                            return [
                                2,
                                data
                            ];
                        }
                        setErrors([
                            "Error with subscribing to Klaviyo."
                        ]);
                        console.error("Response back from API not successful: ".concat(data));
                        return [
                            2,
                            null
                        ];
                    case 3:
                        error = _state.sent();
                        setErrors([
                            "Error with subscribing to Klaviyo."
                        ]);
                        console.error("Error with subscribeToBackInStock: ".concat(error));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(emailListId, email, source) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    return (0,_object_spread/* default */.Z)({
        submitEmailSignup: submitEmailSignup,
        setErrors: setErrors,
        reset: reset
    }, status);
};

;// CONCATENATED MODULE: ./src/hooks/useProductInventoryByHandles.js




var useProductInventoryByHandles = function(param) {
    var _handles = param.handles, handles = _handles === void 0 ? [] : _handles;
    var ref = (0,react.useState)(0), count = ref[0], setCount = ref[1];
    var ref1 = (0,react.useState)([]), inventories = ref1[0], setInventories = ref1[1];
    var handle = (0,react.useMemo)(function() {
        return handles === null || handles === void 0 ? void 0 : handles[count];
    }, [
        count
    ]);
    var _ref = (0,dist.useProductInventoryByHandle)({
        handle: handle,
        withQuantity: true
    }), inventory = _ref.inventory, inventoryStatus = (0,_object_without_properties/* default */.Z)(_ref, [
        "inventory"
    ]);
    (0,react.useEffect)(function() {
        if (!inventory) return;
        setInventories(function(prevInventories) {
            if (!(prevInventories === null || prevInventories === void 0 ? void 0 : prevInventories.length)) return [
                {
                    inventory: inventory,
                    inventoryStatus: inventoryStatus
                }
            ];
            if (prevInventories === null || prevInventories === void 0 ? void 0 : prevInventories.find(function(i) {
                return i.inventory.handle === handle;
            })) return prevInventories;
            if (!(inventory === null || inventory === void 0 ? void 0 : inventory.availableForSale)) {
                return (0,_to_consumable_array/* default */.Z)(prevInventories).concat([
                    {
                        inventory: inventory,
                        inventoryStatus: inventoryStatus
                    }
                ]);
            }
            var firstElement = prevInventories.shift();
            return [
                firstElement,
                {
                    inventory: inventory,
                    inventoryStatus: inventoryStatus
                }
            ].concat((0,_to_consumable_array/* default */.Z)(prevInventories));
        });
        if (count < ((handles === null || handles === void 0 ? void 0 : handles.length) || 0) - 1) setCount(count + 1);
    }, [
        inventory
    ]);
    if ((inventories === null || inventories === void 0 ? void 0 : inventories.length) !== (handles === null || handles === void 0 ? void 0 : handles.length)) return [];
    return inventories;
};

;// CONCATENATED MODULE: ./src/hooks/index.js
// global







// product








// utils










// cms


// cart


// api







// customer

// datalayer



// localization

// Countdown

// Email Signup


// @hooks



/***/ }),

/***/ 86302:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ../node_modules/theme-ui/jsx-runtime/dist/theme-ui-jsx-runtime.esm.js + 2 modules
var theme_ui_jsx_runtime_esm = __webpack_require__(70863);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/@backpackjs/core-nextjs/dist/utils/index.js
var utils = __webpack_require__(96759);
// EXTERNAL MODULE: ../node_modules/@backpackjs/storefront/dist/index.js
var dist = __webpack_require__(52031);
// EXTERNAL MODULE: ../node_modules/telejson/dist/index.mjs
var telejson_dist = __webpack_require__(73347);
// EXTERNAL MODULE: ../node_modules/@backpackjs/core-nextjs/dist/customizerUtils/index.js
var customizerUtils = __webpack_require__(2234);
// EXTERNAL MODULE: ./src/_components/index.js + 9 modules
var _components = __webpack_require__(93183);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3204);
// EXTERNAL MODULE: ../node_modules/@theme-ui/components/dist/theme-ui-components.esm.js
var theme_ui_components_esm = __webpack_require__(62680);
// EXTERNAL MODULE: ./src/snippets/index.js + 352 modules
var snippets = __webpack_require__(81234);
// EXTERNAL MODULE: ./src/utils/index.js + 7 modules
var src_utils = __webpack_require__(39136);
;// CONCATENATED MODULE: ./src/sections/Accordions/Accordion.jsx






function Accordion(param) {
    var accordion = param.accordion, theme = param.theme, forceActiveState = param.forceActiveState;
    var ref = (0,react.useState)(0), headingHeight = ref[0], setHeadingHeight = ref[1];
    var ref1 = (0,react.useState)(0), bodyHeight = ref1[0], setBodyHeight = ref1[1];
    var ref2 = (0,react.useState)(false), markdownLoaded = ref2[0], setMarkdownLoaded = ref2[1];
    var ref3 = (0,react.useState)(forceActiveState), isActive = ref3[0], setIsActive = ref3[1];
    var headingRef = (0,react.useRef)();
    var bodyRef = (0,react.useRef)();
    var getMaxHeightValue = (0,react.useMemo)(function() {
        if (isActive) {
            return headingHeight + bodyHeight;
        }
        return headingHeight;
    }, [
        headingHeight,
        bodyHeight,
        isActive
    ]);
    var getMarginBottomValue = function(node) {
        var ref;
        if (!window) return 0;
        return parseInt((ref = window.getComputedStyle(node)) === null || ref === void 0 ? void 0 : ref.marginBottom.replace("px", ""), 10);
    };
    var setHeightValues = function() {
        var ref, ref1;
        setHeadingHeight((((ref = headingRef.current) === null || ref === void 0 ? void 0 : ref.clientHeight) || 0) + getMarginBottomValue(headingRef.current));
        setBodyHeight((ref1 = bodyRef.current) === null || ref1 === void 0 ? void 0 : ref1.clientHeight);
    };
    (0,react.useEffect)(function() {
        window.addEventListener("resize", setHeightValues);
        return function() {
            window.removeEventListener("resize", setHeightValues);
        };
    }, []);
    (0,react.useEffect)(function() {
        setHeightValues();
    }, [
        isActive,
        markdownLoaded
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Button */.zx, {
        variant: "plain",
        onClick: function() {
            return setIsActive(!isActive);
        },
        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.accordion(isActive)), {
            maxHeight: getMaxHeightValue
        }),
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Heading */.X6, {
                ref: headingRef,
                variant: "h5",
                sx: (0,_object_spread/* default */.Z)({}, theme.accordionHeading(isActive), function() {
                    if (isActive) return {};
                    return {
                        backgroundColor: accordion.headingBgColor || "mediumLightGray",
                        color: accordion.headingTextColor || "black"
                    };
                }()),
                children: [
                    accordion.heading,
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Svg */.ny, {
                        alt: "chevron",
                        viewBox: "0 0 16 16",
                        src: "/svgs/chevron/down.svg#down",
                        loading: "lazy",
                        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.accordionIcon(isActive)), {
                            color: accordion.headingTextColor || isActive ? "white" : "black"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Markdown */.UG, {
                ref: bodyRef,
                text: accordion.body,
                textSx: {
                    m: 0
                },
                sx: (0,_object_spread/* default */.Z)({}, theme.accordionBody(isActive)),
                setIsLoaded: setMarkdownLoaded
            })
        ]
    });
}
Accordion.displayName = "Accordion";

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(17599);
// EXTERNAL MODULE: ./src/settings/common/index.js + 7 modules
var common = __webpack_require__(33580);
;// CONCATENATED MODULE: ./src/sections/Accordions/Accordions.schema.js


function Schema() {
    var _obj;
    return {
        label: "Accordions",
        key: "accordions",
        fields: [
            {
                name: "heading",
                label: "Heading",
                component: "text",
                defaultValue: "Accordions Heading"
            },
            {
                name: "accordionsGroup",
                label: "Accordions Group",
                component: "group-list",
                itemProps: {
                    label: "{{item.heading}}"
                },
                defaultItem: {
                    heading: "Accordions Group Heading",
                    accordions: [
                        {
                            heading: "Accordion Heading",
                            headingBgColor: "#F1F2F4",
                            headingTextColor: "#000000",
                            body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod, nisl vel tincidunt aliquam, nunc nisl aliquet nisl, eget aliquam nisl nisl eget lorem. Sed euismod, nisl vel tincidunt aliquam, nunc nisl aliquet nisl, eget aliquam nisl nisl eget lorem."
                        }, 
                    ]
                },
                fields: [
                    {
                        name: "heading",
                        label: "Heading",
                        component: "text",
                        defaultValue: "Accordions Group Heading"
                    },
                    {
                        name: "accordions",
                        label: "Accordions",
                        component: "group-list",
                        itemProps: {
                            label: "{{item.heading}}"
                        },
                        defaultItem: {
                            heading: "Accordion Heading",
                            headingBgColor: "#F1F2F4",
                            headingTextColor: "#000000",
                            body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod, nisl vel tincidunt aliquam, nunc nisl aliquet nisl, eget aliquam nisl nisl eget lorem. Sed euismod, nisl vel tincidunt aliquam, nunc nisl aliquet nisl, eget aliquam nisl nisl eget lorem."
                        },
                        fields: [
                            {
                                name: "heading",
                                label: "Heading",
                                component: "text",
                                defaultValue: "Accordion Heading"
                            },
                            {
                                name: "headingBgColor",
                                label: "Heading Background Color",
                                component: "select",
                                options: common/* color.options */.$_.options,
                                defaultValue: "#F1F2F4"
                            },
                            (_obj = {
                                name: "headingTextColor",
                                label: "Heading Text Color",
                                component: "select"
                            }, (0,_define_property/* default */.Z)(_obj, "component", "select"), (0,_define_property/* default */.Z)(_obj, "options", common/* color.options */.$_.options), (0,_define_property/* default */.Z)(_obj, "defaultValue", "#000000"), _obj),
                            {
                                name: "body",
                                label: "Body",
                                component: "markdown",
                                defaultValue: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod, nisl vel tincidunt aliquam, nunc nisl aliquet nisl, eget aliquam nisl nisl eget lorem. Sed euismod, nisl vel tincidunt aliquam, nunc nisl aliquet nisl, eget aliquam nisl nisl eget lorem."
                            }, 
                        ],
                        defaultValue: [
                            {
                                heading: "Accordion Heading 1",
                                headingBgColor: "#F1F2F4",
                                headingTextColor: "#000000",
                                body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod, nisl vel tincidunt aliquam, nunc nisl aliquet nisl, eget aliquam nisl nisl eget lorem. Sed euismod, nisl vel tincidunt aliquam, nunc nisl aliquet nisl, eget aliquam nisl nisl eget lorem."
                            }, 
                        ]
                    }, 
                ],
                defaultValue: [
                    {
                        heading: "Accordions Group Heading 1",
                        accordions: [
                            {
                                heading: "Accordion Heading 1",
                                headingBgColor: "#F1F2F4",
                                headingTextColor: "#000000",
                                body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod, nisl vel tincidunt aliquam, nunc nisl aliquet nisl, eget aliquam nisl nisl eget lorem. Sed euismod, nisl vel tincidunt aliquam, nunc nisl aliquet nisl, eget aliquam nisl nisl eget lorem."
                            }, 
                        ]
                    }, 
                ]
            }, 
        ],
        defaultValue: {
            heading: "Accordions Heading",
            accordionsGroup: [
                {
                    heading: "Accordions Group Heading 1",
                    accordions: [
                        {
                            heading: "Accordion Heading 1",
                            headingBgColor: "#F1F2F4",
                            headingTextColor: "#000000",
                            body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod, nisl vel tincidunt aliquam, nunc nisl aliquet nisl, eget aliquam nisl nisl eget lorem. Sed euismod, nisl vel tincidunt aliquam, nunc nisl aliquet nisl, eget aliquam nisl nisl eget lorem."
                        }, 
                    ]
                }, 
            ]
        }
    };
}

// EXTERNAL MODULE: ./src/theme/create.jsx
var create = __webpack_require__(73355);
;// CONCATENATED MODULE: ./src/sections/Accordions/Accordions.theme.js

var themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        display: "flex",
        flexDirection: "column",
        variant: "layout.content",
        maxWidth: "800px",
        py: [
            14,
            17
        ]
    };
    this.heading = {
        textAlign: "center",
        mb: [
            11,
            14
        ]
    };
    this.accordionGroup = {
        mb: [
            11,
            14
        ],
        "&:last-child": {
            mb: 0
        }
    };
    this.accordionGroupHeading = {
        mb: 8
    };
    this.accordion = function() {
        return {
            textAlign: "left",
            overflow: "hidden",
            transition: ".3s ease-in-out max-height",
            "&:last-child": {
                mb: 0
            }
        };
    };
    this.accordionHeading = function() {
        var isActive = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        return {
            position: "relative",
            mb: 8,
            pl: [
                8,
                12
            ],
            pr: [
                16,
                18
            ],
            py: [
                8,
                10
            ],
            backgroundColor: isActive ? "black" : "#F1F2F4",
            color: isActive ? "white" : "black"
        };
    };
    this.accordionBody = function() {
        return {
            mt: -8,
            mb: 8,
            px: [
                0,
                11
            ],
            py: [
                11,
                12
            ]
        };
    };
    this.accordionIcon = function() {
        var isActive = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        return {
            width: "16px",
            position: "absolute",
            top: "calc(50% - 8px)",
            right: [
                "20px",
                "36px"
            ],
            color: isActive ? "white" : "black",
            transform: isActive ? "rotate(180deg)" : "rotate(0)"
        };
    };
}());

// EXTERNAL MODULE: ../node_modules/next/head.js
var head = __webpack_require__(88038);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ../node_modules/marked/lib/marked.esm.js
/**
 * marked v4.3.0 - a markdown parser
 * Copyright (c) 2011-2023, Christopher Jeffrey. (MIT Licensed)
 * https://github.com/markedjs/marked
 */

/**
 * DO NOT EDIT THIS FILE
 * The code in this file is generated from files in ./src/
 */

function getDefaults() {
  return {
    async: false,
    baseUrl: null,
    breaks: false,
    extensions: null,
    gfm: true,
    headerIds: true,
    headerPrefix: '',
    highlight: null,
    hooks: null,
    langPrefix: 'language-',
    mangle: true,
    pedantic: false,
    renderer: null,
    sanitize: false,
    sanitizer: null,
    silent: false,
    smartypants: false,
    tokenizer: null,
    walkTokens: null,
    xhtml: false
  };
}

let defaults = getDefaults();

function changeDefaults(newDefaults) {
  defaults = newDefaults;
}

/**
 * Helpers
 */
const escapeTest = /[&<>"']/;
const escapeReplace = new RegExp(escapeTest.source, 'g');
const escapeTestNoEncode = /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/;
const escapeReplaceNoEncode = new RegExp(escapeTestNoEncode.source, 'g');
const escapeReplacements = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;'
};
const getEscapeReplacement = (ch) => escapeReplacements[ch];
function marked_esm_escape(html, encode) {
  if (encode) {
    if (escapeTest.test(html)) {
      return html.replace(escapeReplace, getEscapeReplacement);
    }
  } else {
    if (escapeTestNoEncode.test(html)) {
      return html.replace(escapeReplaceNoEncode, getEscapeReplacement);
    }
  }

  return html;
}

const unescapeTest = /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig;

/**
 * @param {string} html
 */
function marked_esm_unescape(html) {
  // explicitly match decimal, hex, and named HTML entities
  return html.replace(unescapeTest, (_, n) => {
    n = n.toLowerCase();
    if (n === 'colon') return ':';
    if (n.charAt(0) === '#') {
      return n.charAt(1) === 'x'
        ? String.fromCharCode(parseInt(n.substring(2), 16))
        : String.fromCharCode(+n.substring(1));
    }
    return '';
  });
}

const caret = /(^|[^\[])\^/g;

/**
 * @param {string | RegExp} regex
 * @param {string} opt
 */
function edit(regex, opt) {
  regex = typeof regex === 'string' ? regex : regex.source;
  opt = opt || '';
  const obj = {
    replace: (name, val) => {
      val = val.source || val;
      val = val.replace(caret, '$1');
      regex = regex.replace(name, val);
      return obj;
    },
    getRegex: () => {
      return new RegExp(regex, opt);
    }
  };
  return obj;
}

const nonWordAndColonTest = /[^\w:]/g;
const originIndependentUrl = /^$|^[a-z][a-z0-9+.-]*:|^[?#]/i;

/**
 * @param {boolean} sanitize
 * @param {string} base
 * @param {string} href
 */
function cleanUrl(sanitize, base, href) {
  if (sanitize) {
    let prot;
    try {
      prot = decodeURIComponent(marked_esm_unescape(href))
        .replace(nonWordAndColonTest, '')
        .toLowerCase();
    } catch (e) {
      return null;
    }
    if (prot.indexOf('javascript:') === 0 || prot.indexOf('vbscript:') === 0 || prot.indexOf('data:') === 0) {
      return null;
    }
  }
  if (base && !originIndependentUrl.test(href)) {
    href = resolveUrl(base, href);
  }
  try {
    href = encodeURI(href).replace(/%25/g, '%');
  } catch (e) {
    return null;
  }
  return href;
}

const baseUrls = {};
const justDomain = /^[^:]+:\/*[^/]*$/;
const protocol = /^([^:]+:)[\s\S]*$/;
const domain = /^([^:]+:\/*[^/]*)[\s\S]*$/;

/**
 * @param {string} base
 * @param {string} href
 */
function resolveUrl(base, href) {
  if (!baseUrls[' ' + base]) {
    // we can ignore everything in base after the last slash of its path component,
    // but we might need to add _that_
    // https://tools.ietf.org/html/rfc3986#section-3
    if (justDomain.test(base)) {
      baseUrls[' ' + base] = base + '/';
    } else {
      baseUrls[' ' + base] = rtrim(base, '/', true);
    }
  }
  base = baseUrls[' ' + base];
  const relativeBase = base.indexOf(':') === -1;

  if (href.substring(0, 2) === '//') {
    if (relativeBase) {
      return href;
    }
    return base.replace(protocol, '$1') + href;
  } else if (href.charAt(0) === '/') {
    if (relativeBase) {
      return href;
    }
    return base.replace(domain, '$1') + href;
  } else {
    return base + href;
  }
}

const noopTest = { exec: function noopTest() {} };

function splitCells(tableRow, count) {
  // ensure that every cell-delimiting pipe has a space
  // before it to distinguish it from an escaped pipe
  const row = tableRow.replace(/\|/g, (match, offset, str) => {
      let escaped = false,
        curr = offset;
      while (--curr >= 0 && str[curr] === '\\') escaped = !escaped;
      if (escaped) {
        // odd number of slashes means | is escaped
        // so we leave it alone
        return '|';
      } else {
        // add space before unescaped |
        return ' |';
      }
    }),
    cells = row.split(/ \|/);
  let i = 0;

  // First/last cell in a row cannot be empty if it has no leading/trailing pipe
  if (!cells[0].trim()) { cells.shift(); }
  if (cells.length > 0 && !cells[cells.length - 1].trim()) { cells.pop(); }

  if (cells.length > count) {
    cells.splice(count);
  } else {
    while (cells.length < count) cells.push('');
  }

  for (; i < cells.length; i++) {
    // leading or trailing whitespace is ignored per the gfm spec
    cells[i] = cells[i].trim().replace(/\\\|/g, '|');
  }
  return cells;
}

/**
 * Remove trailing 'c's. Equivalent to str.replace(/c*$/, '').
 * /c*$/ is vulnerable to REDOS.
 *
 * @param {string} str
 * @param {string} c
 * @param {boolean} invert Remove suffix of non-c chars instead. Default falsey.
 */
function rtrim(str, c, invert) {
  const l = str.length;
  if (l === 0) {
    return '';
  }

  // Length of suffix matching the invert condition.
  let suffLen = 0;

  // Step left until we fail to match the invert condition.
  while (suffLen < l) {
    const currChar = str.charAt(l - suffLen - 1);
    if (currChar === c && !invert) {
      suffLen++;
    } else if (currChar !== c && invert) {
      suffLen++;
    } else {
      break;
    }
  }

  return str.slice(0, l - suffLen);
}

function findClosingBracket(str, b) {
  if (str.indexOf(b[1]) === -1) {
    return -1;
  }
  const l = str.length;
  let level = 0,
    i = 0;
  for (; i < l; i++) {
    if (str[i] === '\\') {
      i++;
    } else if (str[i] === b[0]) {
      level++;
    } else if (str[i] === b[1]) {
      level--;
      if (level < 0) {
        return i;
      }
    }
  }
  return -1;
}

function checkSanitizeDeprecation(opt) {
  if (opt && opt.sanitize && !opt.silent) {
    console.warn('marked(): sanitize and sanitizer parameters are deprecated since version 0.7.0, should not be used and will be removed in the future. Read more here: https://marked.js.org/#/USING_ADVANCED.md#options');
  }
}

// copied from https://stackoverflow.com/a/5450113/806777
/**
 * @param {string} pattern
 * @param {number} count
 */
function repeatString(pattern, count) {
  if (count < 1) {
    return '';
  }
  let result = '';
  while (count > 1) {
    if (count & 1) {
      result += pattern;
    }
    count >>= 1;
    pattern += pattern;
  }
  return result + pattern;
}

function outputLink(cap, link, raw, lexer) {
  const href = link.href;
  const title = link.title ? marked_esm_escape(link.title) : null;
  const text = cap[1].replace(/\\([\[\]])/g, '$1');

  if (cap[0].charAt(0) !== '!') {
    lexer.state.inLink = true;
    const token = {
      type: 'link',
      raw,
      href,
      title,
      text,
      tokens: lexer.inlineTokens(text)
    };
    lexer.state.inLink = false;
    return token;
  }
  return {
    type: 'image',
    raw,
    href,
    title,
    text: marked_esm_escape(text)
  };
}

function indentCodeCompensation(raw, text) {
  const matchIndentToCode = raw.match(/^(\s+)(?:```)/);

  if (matchIndentToCode === null) {
    return text;
  }

  const indentToCode = matchIndentToCode[1];

  return text
    .split('\n')
    .map(node => {
      const matchIndentInNode = node.match(/^\s+/);
      if (matchIndentInNode === null) {
        return node;
      }

      const [indentInNode] = matchIndentInNode;

      if (indentInNode.length >= indentToCode.length) {
        return node.slice(indentToCode.length);
      }

      return node;
    })
    .join('\n');
}

/**
 * Tokenizer
 */
class Tokenizer {
  constructor(options) {
    this.options = options || defaults;
  }

  space(src) {
    const cap = this.rules.block.newline.exec(src);
    if (cap && cap[0].length > 0) {
      return {
        type: 'space',
        raw: cap[0]
      };
    }
  }

  code(src) {
    const cap = this.rules.block.code.exec(src);
    if (cap) {
      const text = cap[0].replace(/^ {1,4}/gm, '');
      return {
        type: 'code',
        raw: cap[0],
        codeBlockStyle: 'indented',
        text: !this.options.pedantic
          ? rtrim(text, '\n')
          : text
      };
    }
  }

  fences(src) {
    const cap = this.rules.block.fences.exec(src);
    if (cap) {
      const raw = cap[0];
      const text = indentCodeCompensation(raw, cap[3] || '');

      return {
        type: 'code',
        raw,
        lang: cap[2] ? cap[2].trim().replace(this.rules.inline._escapes, '$1') : cap[2],
        text
      };
    }
  }

  heading(src) {
    const cap = this.rules.block.heading.exec(src);
    if (cap) {
      let text = cap[2].trim();

      // remove trailing #s
      if (/#$/.test(text)) {
        const trimmed = rtrim(text, '#');
        if (this.options.pedantic) {
          text = trimmed.trim();
        } else if (!trimmed || / $/.test(trimmed)) {
          // CommonMark requires space before trailing #s
          text = trimmed.trim();
        }
      }

      return {
        type: 'heading',
        raw: cap[0],
        depth: cap[1].length,
        text,
        tokens: this.lexer.inline(text)
      };
    }
  }

  hr(src) {
    const cap = this.rules.block.hr.exec(src);
    if (cap) {
      return {
        type: 'hr',
        raw: cap[0]
      };
    }
  }

  blockquote(src) {
    const cap = this.rules.block.blockquote.exec(src);
    if (cap) {
      const text = cap[0].replace(/^ *>[ \t]?/gm, '');
      const top = this.lexer.state.top;
      this.lexer.state.top = true;
      const tokens = this.lexer.blockTokens(text);
      this.lexer.state.top = top;
      return {
        type: 'blockquote',
        raw: cap[0],
        tokens,
        text
      };
    }
  }

  list(src) {
    let cap = this.rules.block.list.exec(src);
    if (cap) {
      let raw, istask, ischecked, indent, i, blankLine, endsWithBlankLine,
        line, nextLine, rawLine, itemContents, endEarly;

      let bull = cap[1].trim();
      const isordered = bull.length > 1;

      const list = {
        type: 'list',
        raw: '',
        ordered: isordered,
        start: isordered ? +bull.slice(0, -1) : '',
        loose: false,
        items: []
      };

      bull = isordered ? `\\d{1,9}\\${bull.slice(-1)}` : `\\${bull}`;

      if (this.options.pedantic) {
        bull = isordered ? bull : '[*+-]';
      }

      // Get next list item
      const itemRegex = new RegExp(`^( {0,3}${bull})((?:[\t ][^\\n]*)?(?:\\n|$))`);

      // Check if current bullet point can start a new List Item
      while (src) {
        endEarly = false;
        if (!(cap = itemRegex.exec(src))) {
          break;
        }

        if (this.rules.block.hr.test(src)) { // End list if bullet was actually HR (possibly move into itemRegex?)
          break;
        }

        raw = cap[0];
        src = src.substring(raw.length);

        line = cap[2].split('\n', 1)[0].replace(/^\t+/, (t) => ' '.repeat(3 * t.length));
        nextLine = src.split('\n', 1)[0];

        if (this.options.pedantic) {
          indent = 2;
          itemContents = line.trimLeft();
        } else {
          indent = cap[2].search(/[^ ]/); // Find first non-space char
          indent = indent > 4 ? 1 : indent; // Treat indented code blocks (> 4 spaces) as having only 1 indent
          itemContents = line.slice(indent);
          indent += cap[1].length;
        }

        blankLine = false;

        if (!line && /^ *$/.test(nextLine)) { // Items begin with at most one blank line
          raw += nextLine + '\n';
          src = src.substring(nextLine.length + 1);
          endEarly = true;
        }

        if (!endEarly) {
          const nextBulletRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}(?:[*+-]|\\d{1,9}[.)])((?:[ \t][^\\n]*)?(?:\\n|$))`);
          const hrRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`);
          const fencesBeginRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}(?:\`\`\`|~~~)`);
          const headingBeginRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}#`);

          // Check if following lines should be included in List Item
          while (src) {
            rawLine = src.split('\n', 1)[0];
            nextLine = rawLine;

            // Re-align to follow commonmark nesting rules
            if (this.options.pedantic) {
              nextLine = nextLine.replace(/^ {1,4}(?=( {4})*[^ ])/g, '  ');
            }

            // End list item if found code fences
            if (fencesBeginRegex.test(nextLine)) {
              break;
            }

            // End list item if found start of new heading
            if (headingBeginRegex.test(nextLine)) {
              break;
            }

            // End list item if found start of new bullet
            if (nextBulletRegex.test(nextLine)) {
              break;
            }

            // Horizontal rule found
            if (hrRegex.test(src)) {
              break;
            }

            if (nextLine.search(/[^ ]/) >= indent || !nextLine.trim()) { // Dedent if possible
              itemContents += '\n' + nextLine.slice(indent);
            } else {
              // not enough indentation
              if (blankLine) {
                break;
              }

              // paragraph continuation unless last line was a different block level element
              if (line.search(/[^ ]/) >= 4) { // indented code block
                break;
              }
              if (fencesBeginRegex.test(line)) {
                break;
              }
              if (headingBeginRegex.test(line)) {
                break;
              }
              if (hrRegex.test(line)) {
                break;
              }

              itemContents += '\n' + nextLine;
            }

            if (!blankLine && !nextLine.trim()) { // Check if current line is blank
              blankLine = true;
            }

            raw += rawLine + '\n';
            src = src.substring(rawLine.length + 1);
            line = nextLine.slice(indent);
          }
        }

        if (!list.loose) {
          // If the previous item ended with a blank line, the list is loose
          if (endsWithBlankLine) {
            list.loose = true;
          } else if (/\n *\n *$/.test(raw)) {
            endsWithBlankLine = true;
          }
        }

        // Check for task list items
        if (this.options.gfm) {
          istask = /^\[[ xX]\] /.exec(itemContents);
          if (istask) {
            ischecked = istask[0] !== '[ ] ';
            itemContents = itemContents.replace(/^\[[ xX]\] +/, '');
          }
        }

        list.items.push({
          type: 'list_item',
          raw,
          task: !!istask,
          checked: ischecked,
          loose: false,
          text: itemContents
        });

        list.raw += raw;
      }

      // Do not consume newlines at end of final item. Alternatively, make itemRegex *start* with any newlines to simplify/speed up endsWithBlankLine logic
      list.items[list.items.length - 1].raw = raw.trimRight();
      list.items[list.items.length - 1].text = itemContents.trimRight();
      list.raw = list.raw.trimRight();

      const l = list.items.length;

      // Item child tokens handled here at end because we needed to have the final item to trim it first
      for (i = 0; i < l; i++) {
        this.lexer.state.top = false;
        list.items[i].tokens = this.lexer.blockTokens(list.items[i].text, []);

        if (!list.loose) {
          // Check if list should be loose
          const spacers = list.items[i].tokens.filter(t => t.type === 'space');
          const hasMultipleLineBreaks = spacers.length > 0 && spacers.some(t => /\n.*\n/.test(t.raw));

          list.loose = hasMultipleLineBreaks;
        }
      }

      // Set all items to loose if list is loose
      if (list.loose) {
        for (i = 0; i < l; i++) {
          list.items[i].loose = true;
        }
      }

      return list;
    }
  }

  html(src) {
    const cap = this.rules.block.html.exec(src);
    if (cap) {
      const token = {
        type: 'html',
        raw: cap[0],
        pre: !this.options.sanitizer
          && (cap[1] === 'pre' || cap[1] === 'script' || cap[1] === 'style'),
        text: cap[0]
      };
      if (this.options.sanitize) {
        const text = this.options.sanitizer ? this.options.sanitizer(cap[0]) : marked_esm_escape(cap[0]);
        token.type = 'paragraph';
        token.text = text;
        token.tokens = this.lexer.inline(text);
      }
      return token;
    }
  }

  def(src) {
    const cap = this.rules.block.def.exec(src);
    if (cap) {
      const tag = cap[1].toLowerCase().replace(/\s+/g, ' ');
      const href = cap[2] ? cap[2].replace(/^<(.*)>$/, '$1').replace(this.rules.inline._escapes, '$1') : '';
      const title = cap[3] ? cap[3].substring(1, cap[3].length - 1).replace(this.rules.inline._escapes, '$1') : cap[3];
      return {
        type: 'def',
        tag,
        raw: cap[0],
        href,
        title
      };
    }
  }

  table(src) {
    const cap = this.rules.block.table.exec(src);
    if (cap) {
      const item = {
        type: 'table',
        header: splitCells(cap[1]).map(c => { return { text: c }; }),
        align: cap[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
        rows: cap[3] && cap[3].trim() ? cap[3].replace(/\n[ \t]*$/, '').split('\n') : []
      };

      if (item.header.length === item.align.length) {
        item.raw = cap[0];

        let l = item.align.length;
        let i, j, k, row;
        for (i = 0; i < l; i++) {
          if (/^ *-+: *$/.test(item.align[i])) {
            item.align[i] = 'right';
          } else if (/^ *:-+: *$/.test(item.align[i])) {
            item.align[i] = 'center';
          } else if (/^ *:-+ *$/.test(item.align[i])) {
            item.align[i] = 'left';
          } else {
            item.align[i] = null;
          }
        }

        l = item.rows.length;
        for (i = 0; i < l; i++) {
          item.rows[i] = splitCells(item.rows[i], item.header.length).map(c => { return { text: c }; });
        }

        // parse child tokens inside headers and cells

        // header child tokens
        l = item.header.length;
        for (j = 0; j < l; j++) {
          item.header[j].tokens = this.lexer.inline(item.header[j].text);
        }

        // cell child tokens
        l = item.rows.length;
        for (j = 0; j < l; j++) {
          row = item.rows[j];
          for (k = 0; k < row.length; k++) {
            row[k].tokens = this.lexer.inline(row[k].text);
          }
        }

        return item;
      }
    }
  }

  lheading(src) {
    const cap = this.rules.block.lheading.exec(src);
    if (cap) {
      return {
        type: 'heading',
        raw: cap[0],
        depth: cap[2].charAt(0) === '=' ? 1 : 2,
        text: cap[1],
        tokens: this.lexer.inline(cap[1])
      };
    }
  }

  paragraph(src) {
    const cap = this.rules.block.paragraph.exec(src);
    if (cap) {
      const text = cap[1].charAt(cap[1].length - 1) === '\n'
        ? cap[1].slice(0, -1)
        : cap[1];
      return {
        type: 'paragraph',
        raw: cap[0],
        text,
        tokens: this.lexer.inline(text)
      };
    }
  }

  text(src) {
    const cap = this.rules.block.text.exec(src);
    if (cap) {
      return {
        type: 'text',
        raw: cap[0],
        text: cap[0],
        tokens: this.lexer.inline(cap[0])
      };
    }
  }

  escape(src) {
    const cap = this.rules.inline.escape.exec(src);
    if (cap) {
      return {
        type: 'escape',
        raw: cap[0],
        text: marked_esm_escape(cap[1])
      };
    }
  }

  tag(src) {
    const cap = this.rules.inline.tag.exec(src);
    if (cap) {
      if (!this.lexer.state.inLink && /^<a /i.test(cap[0])) {
        this.lexer.state.inLink = true;
      } else if (this.lexer.state.inLink && /^<\/a>/i.test(cap[0])) {
        this.lexer.state.inLink = false;
      }
      if (!this.lexer.state.inRawBlock && /^<(pre|code|kbd|script)(\s|>)/i.test(cap[0])) {
        this.lexer.state.inRawBlock = true;
      } else if (this.lexer.state.inRawBlock && /^<\/(pre|code|kbd|script)(\s|>)/i.test(cap[0])) {
        this.lexer.state.inRawBlock = false;
      }

      return {
        type: this.options.sanitize
          ? 'text'
          : 'html',
        raw: cap[0],
        inLink: this.lexer.state.inLink,
        inRawBlock: this.lexer.state.inRawBlock,
        text: this.options.sanitize
          ? (this.options.sanitizer
            ? this.options.sanitizer(cap[0])
            : marked_esm_escape(cap[0]))
          : cap[0]
      };
    }
  }

  link(src) {
    const cap = this.rules.inline.link.exec(src);
    if (cap) {
      const trimmedUrl = cap[2].trim();
      if (!this.options.pedantic && /^</.test(trimmedUrl)) {
        // commonmark requires matching angle brackets
        if (!(/>$/.test(trimmedUrl))) {
          return;
        }

        // ending angle bracket cannot be escaped
        const rtrimSlash = rtrim(trimmedUrl.slice(0, -1), '\\');
        if ((trimmedUrl.length - rtrimSlash.length) % 2 === 0) {
          return;
        }
      } else {
        // find closing parenthesis
        const lastParenIndex = findClosingBracket(cap[2], '()');
        if (lastParenIndex > -1) {
          const start = cap[0].indexOf('!') === 0 ? 5 : 4;
          const linkLen = start + cap[1].length + lastParenIndex;
          cap[2] = cap[2].substring(0, lastParenIndex);
          cap[0] = cap[0].substring(0, linkLen).trim();
          cap[3] = '';
        }
      }
      let href = cap[2];
      let title = '';
      if (this.options.pedantic) {
        // split pedantic href and title
        const link = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(href);

        if (link) {
          href = link[1];
          title = link[3];
        }
      } else {
        title = cap[3] ? cap[3].slice(1, -1) : '';
      }

      href = href.trim();
      if (/^</.test(href)) {
        if (this.options.pedantic && !(/>$/.test(trimmedUrl))) {
          // pedantic allows starting angle bracket without ending angle bracket
          href = href.slice(1);
        } else {
          href = href.slice(1, -1);
        }
      }
      return outputLink(cap, {
        href: href ? href.replace(this.rules.inline._escapes, '$1') : href,
        title: title ? title.replace(this.rules.inline._escapes, '$1') : title
      }, cap[0], this.lexer);
    }
  }

  reflink(src, links) {
    let cap;
    if ((cap = this.rules.inline.reflink.exec(src))
        || (cap = this.rules.inline.nolink.exec(src))) {
      let link = (cap[2] || cap[1]).replace(/\s+/g, ' ');
      link = links[link.toLowerCase()];
      if (!link) {
        const text = cap[0].charAt(0);
        return {
          type: 'text',
          raw: text,
          text
        };
      }
      return outputLink(cap, link, cap[0], this.lexer);
    }
  }

  emStrong(src, maskedSrc, prevChar = '') {
    let match = this.rules.inline.emStrong.lDelim.exec(src);
    if (!match) return;

    // _ can't be between two alphanumerics. \p{L}\p{N} includes non-english alphabet/numbers as well
    if (match[3] && prevChar.match(/[\p{L}\p{N}]/u)) return;

    const nextChar = match[1] || match[2] || '';

    if (!nextChar || (nextChar && (prevChar === '' || this.rules.inline.punctuation.exec(prevChar)))) {
      const lLength = match[0].length - 1;
      let rDelim, rLength, delimTotal = lLength, midDelimTotal = 0;

      const endReg = match[0][0] === '*' ? this.rules.inline.emStrong.rDelimAst : this.rules.inline.emStrong.rDelimUnd;
      endReg.lastIndex = 0;

      // Clip maskedSrc to same section of string as src (move to lexer?)
      maskedSrc = maskedSrc.slice(-1 * src.length + lLength);

      while ((match = endReg.exec(maskedSrc)) != null) {
        rDelim = match[1] || match[2] || match[3] || match[4] || match[5] || match[6];

        if (!rDelim) continue; // skip single * in __abc*abc__

        rLength = rDelim.length;

        if (match[3] || match[4]) { // found another Left Delim
          delimTotal += rLength;
          continue;
        } else if (match[5] || match[6]) { // either Left or Right Delim
          if (lLength % 3 && !((lLength + rLength) % 3)) {
            midDelimTotal += rLength;
            continue; // CommonMark Emphasis Rules 9-10
          }
        }

        delimTotal -= rLength;

        if (delimTotal > 0) continue; // Haven't found enough closing delimiters

        // Remove extra characters. *a*** -> *a*
        rLength = Math.min(rLength, rLength + delimTotal + midDelimTotal);

        const raw = src.slice(0, lLength + match.index + (match[0].length - rDelim.length) + rLength);

        // Create `em` if smallest delimiter has odd char count. *a***
        if (Math.min(lLength, rLength) % 2) {
          const text = raw.slice(1, -1);
          return {
            type: 'em',
            raw,
            text,
            tokens: this.lexer.inlineTokens(text)
          };
        }

        // Create 'strong' if smallest delimiter has even char count. **a***
        const text = raw.slice(2, -2);
        return {
          type: 'strong',
          raw,
          text,
          tokens: this.lexer.inlineTokens(text)
        };
      }
    }
  }

  codespan(src) {
    const cap = this.rules.inline.code.exec(src);
    if (cap) {
      let text = cap[2].replace(/\n/g, ' ');
      const hasNonSpaceChars = /[^ ]/.test(text);
      const hasSpaceCharsOnBothEnds = /^ /.test(text) && / $/.test(text);
      if (hasNonSpaceChars && hasSpaceCharsOnBothEnds) {
        text = text.substring(1, text.length - 1);
      }
      text = marked_esm_escape(text, true);
      return {
        type: 'codespan',
        raw: cap[0],
        text
      };
    }
  }

  br(src) {
    const cap = this.rules.inline.br.exec(src);
    if (cap) {
      return {
        type: 'br',
        raw: cap[0]
      };
    }
  }

  del(src) {
    const cap = this.rules.inline.del.exec(src);
    if (cap) {
      return {
        type: 'del',
        raw: cap[0],
        text: cap[2],
        tokens: this.lexer.inlineTokens(cap[2])
      };
    }
  }

  autolink(src, mangle) {
    const cap = this.rules.inline.autolink.exec(src);
    if (cap) {
      let text, href;
      if (cap[2] === '@') {
        text = marked_esm_escape(this.options.mangle ? mangle(cap[1]) : cap[1]);
        href = 'mailto:' + text;
      } else {
        text = marked_esm_escape(cap[1]);
        href = text;
      }

      return {
        type: 'link',
        raw: cap[0],
        text,
        href,
        tokens: [
          {
            type: 'text',
            raw: text,
            text
          }
        ]
      };
    }
  }

  url(src, mangle) {
    let cap;
    if (cap = this.rules.inline.url.exec(src)) {
      let text, href;
      if (cap[2] === '@') {
        text = marked_esm_escape(this.options.mangle ? mangle(cap[0]) : cap[0]);
        href = 'mailto:' + text;
      } else {
        // do extended autolink path validation
        let prevCapZero;
        do {
          prevCapZero = cap[0];
          cap[0] = this.rules.inline._backpedal.exec(cap[0])[0];
        } while (prevCapZero !== cap[0]);
        text = marked_esm_escape(cap[0]);
        if (cap[1] === 'www.') {
          href = 'http://' + cap[0];
        } else {
          href = cap[0];
        }
      }
      return {
        type: 'link',
        raw: cap[0],
        text,
        href,
        tokens: [
          {
            type: 'text',
            raw: text,
            text
          }
        ]
      };
    }
  }

  inlineText(src, smartypants) {
    const cap = this.rules.inline.text.exec(src);
    if (cap) {
      let text;
      if (this.lexer.state.inRawBlock) {
        text = this.options.sanitize ? (this.options.sanitizer ? this.options.sanitizer(cap[0]) : marked_esm_escape(cap[0])) : cap[0];
      } else {
        text = marked_esm_escape(this.options.smartypants ? smartypants(cap[0]) : cap[0]);
      }
      return {
        type: 'text',
        raw: cap[0],
        text
      };
    }
  }
}

/**
 * Block-Level Grammar
 */
const block = {
  newline: /^(?: *(?:\n|$))+/,
  code: /^( {4}[^\n]+(?:\n(?: *(?:\n|$))*)?)+/,
  fences: /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/,
  hr: /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/,
  heading: /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/,
  blockquote: /^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/,
  list: /^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/,
  html: '^ {0,3}(?:' // optional indentation
    + '<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)' // (1)
    + '|comment[^\\n]*(\\n+|$)' // (2)
    + '|<\\?[\\s\\S]*?(?:\\?>\\n*|$)' // (3)
    + '|<![A-Z][\\s\\S]*?(?:>\\n*|$)' // (4)
    + '|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)' // (5)
    + '|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n *)+\\n|$)' // (6)
    + '|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)' // (7) open tag
    + '|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)' // (7) closing tag
    + ')',
  def: /^ {0,3}\[(label)\]: *(?:\n *)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n *)?| *\n *)(title))? *(?:\n+|$)/,
  table: noopTest,
  lheading: /^((?:.|\n(?!\n))+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
  // regex template, placeholders will be replaced according to different paragraph
  // interruption rules of commonmark and the original markdown spec:
  _paragraph: /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/,
  text: /^[^\n]+/
};

block._label = /(?!\s*\])(?:\\.|[^\[\]\\])+/;
block._title = /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/;
block.def = edit(block.def)
  .replace('label', block._label)
  .replace('title', block._title)
  .getRegex();

block.bullet = /(?:[*+-]|\d{1,9}[.)])/;
block.listItemStart = edit(/^( *)(bull) */)
  .replace('bull', block.bullet)
  .getRegex();

block.list = edit(block.list)
  .replace(/bull/g, block.bullet)
  .replace('hr', '\\n+(?=\\1?(?:(?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$))')
  .replace('def', '\\n+(?=' + block.def.source + ')')
  .getRegex();

block._tag = 'address|article|aside|base|basefont|blockquote|body|caption'
  + '|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption'
  + '|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe'
  + '|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option'
  + '|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr'
  + '|track|ul';
block._comment = /<!--(?!-?>)[\s\S]*?(?:-->|$)/;
block.html = edit(block.html, 'i')
  .replace('comment', block._comment)
  .replace('tag', block._tag)
  .replace('attribute', / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/)
  .getRegex();

block.paragraph = edit(block._paragraph)
  .replace('hr', block.hr)
  .replace('heading', ' {0,3}#{1,6} ')
  .replace('|lheading', '') // setex headings don't interrupt commonmark paragraphs
  .replace('|table', '')
  .replace('blockquote', ' {0,3}>')
  .replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n')
  .replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
  .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)')
  .replace('tag', block._tag) // pars can be interrupted by type (6) html blocks
  .getRegex();

block.blockquote = edit(block.blockquote)
  .replace('paragraph', block.paragraph)
  .getRegex();

/**
 * Normal Block Grammar
 */

block.normal = { ...block };

/**
 * GFM Block Grammar
 */

block.gfm = {
  ...block.normal,
  table: '^ *([^\\n ].*\\|.*)\\n' // Header
    + ' {0,3}(?:\\| *)?(:?-+:? *(?:\\| *:?-+:? *)*)(?:\\| *)?' // Align
    + '(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)' // Cells
};

block.gfm.table = edit(block.gfm.table)
  .replace('hr', block.hr)
  .replace('heading', ' {0,3}#{1,6} ')
  .replace('blockquote', ' {0,3}>')
  .replace('code', ' {4}[^\\n]')
  .replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n')
  .replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
  .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)')
  .replace('tag', block._tag) // tables can be interrupted by type (6) html blocks
  .getRegex();

block.gfm.paragraph = edit(block._paragraph)
  .replace('hr', block.hr)
  .replace('heading', ' {0,3}#{1,6} ')
  .replace('|lheading', '') // setex headings don't interrupt commonmark paragraphs
  .replace('table', block.gfm.table) // interrupt paragraphs with table
  .replace('blockquote', ' {0,3}>')
  .replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n')
  .replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
  .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)')
  .replace('tag', block._tag) // pars can be interrupted by type (6) html blocks
  .getRegex();
/**
 * Pedantic grammar (original John Gruber's loose markdown specification)
 */

block.pedantic = {
  ...block.normal,
  html: edit(
    '^ *(?:comment *(?:\\n|\\s*$)'
    + '|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)' // closed tag
    + '|<tag(?:"[^"]*"|\'[^\']*\'|\\s[^\'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))')
    .replace('comment', block._comment)
    .replace(/tag/g, '(?!(?:'
      + 'a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub'
      + '|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)'
      + '\\b)\\w+(?!:|[^\\w\\s@]*@)\\b')
    .getRegex(),
  def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
  heading: /^(#{1,6})(.*)(?:\n+|$)/,
  fences: noopTest, // fences not supported
  lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
  paragraph: edit(block.normal._paragraph)
    .replace('hr', block.hr)
    .replace('heading', ' *#{1,6} *[^\n]')
    .replace('lheading', block.lheading)
    .replace('blockquote', ' {0,3}>')
    .replace('|fences', '')
    .replace('|list', '')
    .replace('|html', '')
    .getRegex()
};

/**
 * Inline-Level Grammar
 */
const inline = {
  escape: /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/,
  autolink: /^<(scheme:[^\s\x00-\x1f<>]*|email)>/,
  url: noopTest,
  tag: '^comment'
    + '|^</[a-zA-Z][\\w:-]*\\s*>' // self-closing tag
    + '|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>' // open tag
    + '|^<\\?[\\s\\S]*?\\?>' // processing instruction, e.g. <?php ?>
    + '|^<![a-zA-Z]+\\s[\\s\\S]*?>' // declaration, e.g. <!DOCTYPE html>
    + '|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>', // CDATA section
  link: /^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/,
  reflink: /^!?\[(label)\]\[(ref)\]/,
  nolink: /^!?\[(ref)\](?:\[\])?/,
  reflinkSearch: 'reflink|nolink(?!\\()',
  emStrong: {
    lDelim: /^(?:\*+(?:([punct_])|[^\s*]))|^_+(?:([punct*])|([^\s_]))/,
    //        (1) and (2) can only be a Right Delimiter. (3) and (4) can only be Left.  (5) and (6) can be either Left or Right.
    //          () Skip orphan inside strong                                      () Consume to delim     (1) #***                (2) a***#, a***                             (3) #***a, ***a                 (4) ***#              (5) #***#                 (6) a***a
    rDelimAst: /^(?:[^_*\\]|\\.)*?\_\_(?:[^_*\\]|\\.)*?\*(?:[^_*\\]|\\.)*?(?=\_\_)|(?:[^*\\]|\\.)+(?=[^*])|[punct_](\*+)(?=[\s]|$)|(?:[^punct*_\s\\]|\\.)(\*+)(?=[punct_\s]|$)|[punct_\s](\*+)(?=[^punct*_\s])|[\s](\*+)(?=[punct_])|[punct_](\*+)(?=[punct_])|(?:[^punct*_\s\\]|\\.)(\*+)(?=[^punct*_\s])/,
    rDelimUnd: /^(?:[^_*\\]|\\.)*?\*\*(?:[^_*\\]|\\.)*?\_(?:[^_*\\]|\\.)*?(?=\*\*)|(?:[^_\\]|\\.)+(?=[^_])|[punct*](\_+)(?=[\s]|$)|(?:[^punct*_\s\\]|\\.)(\_+)(?=[punct*\s]|$)|[punct*\s](\_+)(?=[^punct*_\s])|[\s](\_+)(?=[punct*])|[punct*](\_+)(?=[punct*])/ // ^- Not allowed for _
  },
  code: /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/,
  br: /^( {2,}|\\)\n(?!\s*$)/,
  del: noopTest,
  text: /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/,
  punctuation: /^([\spunctuation])/
};

// list of punctuation marks from CommonMark spec
// without * and _ to handle the different emphasis markers * and _
inline._punctuation = '!"#$%&\'()+\\-.,/:;<=>?@\\[\\]`^{|}~';
inline.punctuation = edit(inline.punctuation).replace(/punctuation/g, inline._punctuation).getRegex();

// sequences em should skip over [title](link), `code`, <html>
inline.blockSkip = /\[[^\]]*?\]\([^\)]*?\)|`[^`]*?`|<[^>]*?>/g;
// lookbehind is not available on Safari as of version 16
// inline.escapedEmSt = /(?<=(?:^|[^\\)(?:\\[^])*)\\[*_]/g;
inline.escapedEmSt = /(?:^|[^\\])(?:\\\\)*\\[*_]/g;

inline._comment = edit(block._comment).replace('(?:-->|$)', '-->').getRegex();

inline.emStrong.lDelim = edit(inline.emStrong.lDelim)
  .replace(/punct/g, inline._punctuation)
  .getRegex();

inline.emStrong.rDelimAst = edit(inline.emStrong.rDelimAst, 'g')
  .replace(/punct/g, inline._punctuation)
  .getRegex();

inline.emStrong.rDelimUnd = edit(inline.emStrong.rDelimUnd, 'g')
  .replace(/punct/g, inline._punctuation)
  .getRegex();

inline._escapes = /\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/g;

inline._scheme = /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/;
inline._email = /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/;
inline.autolink = edit(inline.autolink)
  .replace('scheme', inline._scheme)
  .replace('email', inline._email)
  .getRegex();

inline._attribute = /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/;

inline.tag = edit(inline.tag)
  .replace('comment', inline._comment)
  .replace('attribute', inline._attribute)
  .getRegex();

inline._label = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
inline._href = /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/;
inline._title = /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/;

inline.link = edit(inline.link)
  .replace('label', inline._label)
  .replace('href', inline._href)
  .replace('title', inline._title)
  .getRegex();

inline.reflink = edit(inline.reflink)
  .replace('label', inline._label)
  .replace('ref', block._label)
  .getRegex();

inline.nolink = edit(inline.nolink)
  .replace('ref', block._label)
  .getRegex();

inline.reflinkSearch = edit(inline.reflinkSearch, 'g')
  .replace('reflink', inline.reflink)
  .replace('nolink', inline.nolink)
  .getRegex();

/**
 * Normal Inline Grammar
 */

inline.normal = { ...inline };

/**
 * Pedantic Inline Grammar
 */

inline.pedantic = {
  ...inline.normal,
  strong: {
    start: /^__|\*\*/,
    middle: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
    endAst: /\*\*(?!\*)/g,
    endUnd: /__(?!_)/g
  },
  em: {
    start: /^_|\*/,
    middle: /^()\*(?=\S)([\s\S]*?\S)\*(?!\*)|^_(?=\S)([\s\S]*?\S)_(?!_)/,
    endAst: /\*(?!\*)/g,
    endUnd: /_(?!_)/g
  },
  link: edit(/^!?\[(label)\]\((.*?)\)/)
    .replace('label', inline._label)
    .getRegex(),
  reflink: edit(/^!?\[(label)\]\s*\[([^\]]*)\]/)
    .replace('label', inline._label)
    .getRegex()
};

/**
 * GFM Inline Grammar
 */

inline.gfm = {
  ...inline.normal,
  escape: edit(inline.escape).replace('])', '~|])').getRegex(),
  _extended_email: /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/,
  url: /^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/,
  _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
  del: /^(~~?)(?=[^\s~])([\s\S]*?[^\s~])\1(?=[^~]|$)/,
  text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
};

inline.gfm.url = edit(inline.gfm.url, 'i')
  .replace('email', inline.gfm._extended_email)
  .getRegex();
/**
 * GFM + Line Breaks Inline Grammar
 */

inline.breaks = {
  ...inline.gfm,
  br: edit(inline.br).replace('{2,}', '*').getRegex(),
  text: edit(inline.gfm.text)
    .replace('\\b_', '\\b_| {2,}\\n')
    .replace(/\{2,\}/g, '*')
    .getRegex()
};

/**
 * smartypants text replacement
 * @param {string} text
 */
function smartypants(text) {
  return text
    // em-dashes
    .replace(/---/g, '\u2014')
    // en-dashes
    .replace(/--/g, '\u2013')
    // opening singles
    .replace(/(^|[-\u2014/(\[{"\s])'/g, '$1\u2018')
    // closing singles & apostrophes
    .replace(/'/g, '\u2019')
    // opening doubles
    .replace(/(^|[-\u2014/(\[{\u2018\s])"/g, '$1\u201c')
    // closing doubles
    .replace(/"/g, '\u201d')
    // ellipses
    .replace(/\.{3}/g, '\u2026');
}

/**
 * mangle email addresses
 * @param {string} text
 */
function mangle(text) {
  let out = '',
    i,
    ch;

  const l = text.length;
  for (i = 0; i < l; i++) {
    ch = text.charCodeAt(i);
    if (Math.random() > 0.5) {
      ch = 'x' + ch.toString(16);
    }
    out += '&#' + ch + ';';
  }

  return out;
}

/**
 * Block Lexer
 */
class Lexer {
  constructor(options) {
    this.tokens = [];
    this.tokens.links = Object.create(null);
    this.options = options || defaults;
    this.options.tokenizer = this.options.tokenizer || new Tokenizer();
    this.tokenizer = this.options.tokenizer;
    this.tokenizer.options = this.options;
    this.tokenizer.lexer = this;
    this.inlineQueue = [];
    this.state = {
      inLink: false,
      inRawBlock: false,
      top: true
    };

    const rules = {
      block: block.normal,
      inline: inline.normal
    };

    if (this.options.pedantic) {
      rules.block = block.pedantic;
      rules.inline = inline.pedantic;
    } else if (this.options.gfm) {
      rules.block = block.gfm;
      if (this.options.breaks) {
        rules.inline = inline.breaks;
      } else {
        rules.inline = inline.gfm;
      }
    }
    this.tokenizer.rules = rules;
  }

  /**
   * Expose Rules
   */
  static get rules() {
    return {
      block,
      inline
    };
  }

  /**
   * Static Lex Method
   */
  static lex(src, options) {
    const lexer = new Lexer(options);
    return lexer.lex(src);
  }

  /**
   * Static Lex Inline Method
   */
  static lexInline(src, options) {
    const lexer = new Lexer(options);
    return lexer.inlineTokens(src);
  }

  /**
   * Preprocessing
   */
  lex(src) {
    src = src
      .replace(/\r\n|\r/g, '\n');

    this.blockTokens(src, this.tokens);

    let next;
    while (next = this.inlineQueue.shift()) {
      this.inlineTokens(next.src, next.tokens);
    }

    return this.tokens;
  }

  /**
   * Lexing
   */
  blockTokens(src, tokens = []) {
    if (this.options.pedantic) {
      src = src.replace(/\t/g, '    ').replace(/^ +$/gm, '');
    } else {
      src = src.replace(/^( *)(\t+)/gm, (_, leading, tabs) => {
        return leading + '    '.repeat(tabs.length);
      });
    }

    let token, lastToken, cutSrc, lastParagraphClipped;

    while (src) {
      if (this.options.extensions
        && this.options.extensions.block
        && this.options.extensions.block.some((extTokenizer) => {
          if (token = extTokenizer.call({ lexer: this }, src, tokens)) {
            src = src.substring(token.raw.length);
            tokens.push(token);
            return true;
          }
          return false;
        })) {
        continue;
      }

      // newline
      if (token = this.tokenizer.space(src)) {
        src = src.substring(token.raw.length);
        if (token.raw.length === 1 && tokens.length > 0) {
          // if there's a single \n as a spacer, it's terminating the last line,
          // so move it there so that we don't get unecessary paragraph tags
          tokens[tokens.length - 1].raw += '\n';
        } else {
          tokens.push(token);
        }
        continue;
      }

      // code
      if (token = this.tokenizer.code(src)) {
        src = src.substring(token.raw.length);
        lastToken = tokens[tokens.length - 1];
        // An indented code block cannot interrupt a paragraph.
        if (lastToken && (lastToken.type === 'paragraph' || lastToken.type === 'text')) {
          lastToken.raw += '\n' + token.raw;
          lastToken.text += '\n' + token.text;
          this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
        } else {
          tokens.push(token);
        }
        continue;
      }

      // fences
      if (token = this.tokenizer.fences(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }

      // heading
      if (token = this.tokenizer.heading(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }

      // hr
      if (token = this.tokenizer.hr(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }

      // blockquote
      if (token = this.tokenizer.blockquote(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }

      // list
      if (token = this.tokenizer.list(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }

      // html
      if (token = this.tokenizer.html(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }

      // def
      if (token = this.tokenizer.def(src)) {
        src = src.substring(token.raw.length);
        lastToken = tokens[tokens.length - 1];
        if (lastToken && (lastToken.type === 'paragraph' || lastToken.type === 'text')) {
          lastToken.raw += '\n' + token.raw;
          lastToken.text += '\n' + token.raw;
          this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
        } else if (!this.tokens.links[token.tag]) {
          this.tokens.links[token.tag] = {
            href: token.href,
            title: token.title
          };
        }
        continue;
      }

      // table (gfm)
      if (token = this.tokenizer.table(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }

      // lheading
      if (token = this.tokenizer.lheading(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }

      // top-level paragraph
      // prevent paragraph consuming extensions by clipping 'src' to extension start
      cutSrc = src;
      if (this.options.extensions && this.options.extensions.startBlock) {
        let startIndex = Infinity;
        const tempSrc = src.slice(1);
        let tempStart;
        this.options.extensions.startBlock.forEach(function(getStartIndex) {
          tempStart = getStartIndex.call({ lexer: this }, tempSrc);
          if (typeof tempStart === 'number' && tempStart >= 0) { startIndex = Math.min(startIndex, tempStart); }
        });
        if (startIndex < Infinity && startIndex >= 0) {
          cutSrc = src.substring(0, startIndex + 1);
        }
      }
      if (this.state.top && (token = this.tokenizer.paragraph(cutSrc))) {
        lastToken = tokens[tokens.length - 1];
        if (lastParagraphClipped && lastToken.type === 'paragraph') {
          lastToken.raw += '\n' + token.raw;
          lastToken.text += '\n' + token.text;
          this.inlineQueue.pop();
          this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
        } else {
          tokens.push(token);
        }
        lastParagraphClipped = (cutSrc.length !== src.length);
        src = src.substring(token.raw.length);
        continue;
      }

      // text
      if (token = this.tokenizer.text(src)) {
        src = src.substring(token.raw.length);
        lastToken = tokens[tokens.length - 1];
        if (lastToken && lastToken.type === 'text') {
          lastToken.raw += '\n' + token.raw;
          lastToken.text += '\n' + token.text;
          this.inlineQueue.pop();
          this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
        } else {
          tokens.push(token);
        }
        continue;
      }

      if (src) {
        const errMsg = 'Infinite loop on byte: ' + src.charCodeAt(0);
        if (this.options.silent) {
          console.error(errMsg);
          break;
        } else {
          throw new Error(errMsg);
        }
      }
    }

    this.state.top = true;
    return tokens;
  }

  inline(src, tokens = []) {
    this.inlineQueue.push({ src, tokens });
    return tokens;
  }

  /**
   * Lexing/Compiling
   */
  inlineTokens(src, tokens = []) {
    let token, lastToken, cutSrc;

    // String with links masked to avoid interference with em and strong
    let maskedSrc = src;
    let match;
    let keepPrevChar, prevChar;

    // Mask out reflinks
    if (this.tokens.links) {
      const links = Object.keys(this.tokens.links);
      if (links.length > 0) {
        while ((match = this.tokenizer.rules.inline.reflinkSearch.exec(maskedSrc)) != null) {
          if (links.includes(match[0].slice(match[0].lastIndexOf('[') + 1, -1))) {
            maskedSrc = maskedSrc.slice(0, match.index) + '[' + repeatString('a', match[0].length - 2) + ']' + maskedSrc.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex);
          }
        }
      }
    }
    // Mask out other blocks
    while ((match = this.tokenizer.rules.inline.blockSkip.exec(maskedSrc)) != null) {
      maskedSrc = maskedSrc.slice(0, match.index) + '[' + repeatString('a', match[0].length - 2) + ']' + maskedSrc.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
    }

    // Mask out escaped em & strong delimiters
    while ((match = this.tokenizer.rules.inline.escapedEmSt.exec(maskedSrc)) != null) {
      maskedSrc = maskedSrc.slice(0, match.index + match[0].length - 2) + '++' + maskedSrc.slice(this.tokenizer.rules.inline.escapedEmSt.lastIndex);
      this.tokenizer.rules.inline.escapedEmSt.lastIndex--;
    }

    while (src) {
      if (!keepPrevChar) {
        prevChar = '';
      }
      keepPrevChar = false;

      // extensions
      if (this.options.extensions
        && this.options.extensions.inline
        && this.options.extensions.inline.some((extTokenizer) => {
          if (token = extTokenizer.call({ lexer: this }, src, tokens)) {
            src = src.substring(token.raw.length);
            tokens.push(token);
            return true;
          }
          return false;
        })) {
        continue;
      }

      // escape
      if (token = this.tokenizer.escape(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }

      // tag
      if (token = this.tokenizer.tag(src)) {
        src = src.substring(token.raw.length);
        lastToken = tokens[tokens.length - 1];
        if (lastToken && token.type === 'text' && lastToken.type === 'text') {
          lastToken.raw += token.raw;
          lastToken.text += token.text;
        } else {
          tokens.push(token);
        }
        continue;
      }

      // link
      if (token = this.tokenizer.link(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }

      // reflink, nolink
      if (token = this.tokenizer.reflink(src, this.tokens.links)) {
        src = src.substring(token.raw.length);
        lastToken = tokens[tokens.length - 1];
        if (lastToken && token.type === 'text' && lastToken.type === 'text') {
          lastToken.raw += token.raw;
          lastToken.text += token.text;
        } else {
          tokens.push(token);
        }
        continue;
      }

      // em & strong
      if (token = this.tokenizer.emStrong(src, maskedSrc, prevChar)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }

      // code
      if (token = this.tokenizer.codespan(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }

      // br
      if (token = this.tokenizer.br(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }

      // del (gfm)
      if (token = this.tokenizer.del(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }

      // autolink
      if (token = this.tokenizer.autolink(src, mangle)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }

      // url (gfm)
      if (!this.state.inLink && (token = this.tokenizer.url(src, mangle))) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }

      // text
      // prevent inlineText consuming extensions by clipping 'src' to extension start
      cutSrc = src;
      if (this.options.extensions && this.options.extensions.startInline) {
        let startIndex = Infinity;
        const tempSrc = src.slice(1);
        let tempStart;
        this.options.extensions.startInline.forEach(function(getStartIndex) {
          tempStart = getStartIndex.call({ lexer: this }, tempSrc);
          if (typeof tempStart === 'number' && tempStart >= 0) { startIndex = Math.min(startIndex, tempStart); }
        });
        if (startIndex < Infinity && startIndex >= 0) {
          cutSrc = src.substring(0, startIndex + 1);
        }
      }
      if (token = this.tokenizer.inlineText(cutSrc, smartypants)) {
        src = src.substring(token.raw.length);
        if (token.raw.slice(-1) !== '_') { // Track prevChar before string of ____ started
          prevChar = token.raw.slice(-1);
        }
        keepPrevChar = true;
        lastToken = tokens[tokens.length - 1];
        if (lastToken && lastToken.type === 'text') {
          lastToken.raw += token.raw;
          lastToken.text += token.text;
        } else {
          tokens.push(token);
        }
        continue;
      }

      if (src) {
        const errMsg = 'Infinite loop on byte: ' + src.charCodeAt(0);
        if (this.options.silent) {
          console.error(errMsg);
          break;
        } else {
          throw new Error(errMsg);
        }
      }
    }

    return tokens;
  }
}

/**
 * Renderer
 */
class Renderer {
  constructor(options) {
    this.options = options || defaults;
  }

  code(code, infostring, escaped) {
    const lang = (infostring || '').match(/\S*/)[0];
    if (this.options.highlight) {
      const out = this.options.highlight(code, lang);
      if (out != null && out !== code) {
        escaped = true;
        code = out;
      }
    }

    code = code.replace(/\n$/, '') + '\n';

    if (!lang) {
      return '<pre><code>'
        + (escaped ? code : marked_esm_escape(code, true))
        + '</code></pre>\n';
    }

    return '<pre><code class="'
      + this.options.langPrefix
      + marked_esm_escape(lang)
      + '">'
      + (escaped ? code : marked_esm_escape(code, true))
      + '</code></pre>\n';
  }

  /**
   * @param {string} quote
   */
  blockquote(quote) {
    return `<blockquote>\n${quote}</blockquote>\n`;
  }

  html(html) {
    return html;
  }

  /**
   * @param {string} text
   * @param {string} level
   * @param {string} raw
   * @param {any} slugger
   */
  heading(text, level, raw, slugger) {
    if (this.options.headerIds) {
      const id = this.options.headerPrefix + slugger.slug(raw);
      return `<h${level} id="${id}">${text}</h${level}>\n`;
    }

    // ignore IDs
    return `<h${level}>${text}</h${level}>\n`;
  }

  hr() {
    return this.options.xhtml ? '<hr/>\n' : '<hr>\n';
  }

  list(body, ordered, start) {
    const type = ordered ? 'ol' : 'ul',
      startatt = (ordered && start !== 1) ? (' start="' + start + '"') : '';
    return '<' + type + startatt + '>\n' + body + '</' + type + '>\n';
  }

  /**
   * @param {string} text
   */
  listitem(text) {
    return `<li>${text}</li>\n`;
  }

  checkbox(checked) {
    return '<input '
      + (checked ? 'checked="" ' : '')
      + 'disabled="" type="checkbox"'
      + (this.options.xhtml ? ' /' : '')
      + '> ';
  }

  /**
   * @param {string} text
   */
  paragraph(text) {
    return `<p>${text}</p>\n`;
  }

  /**
   * @param {string} header
   * @param {string} body
   */
  table(header, body) {
    if (body) body = `<tbody>${body}</tbody>`;

    return '<table>\n'
      + '<thead>\n'
      + header
      + '</thead>\n'
      + body
      + '</table>\n';
  }

  /**
   * @param {string} content
   */
  tablerow(content) {
    return `<tr>\n${content}</tr>\n`;
  }

  tablecell(content, flags) {
    const type = flags.header ? 'th' : 'td';
    const tag = flags.align
      ? `<${type} align="${flags.align}">`
      : `<${type}>`;
    return tag + content + `</${type}>\n`;
  }

  /**
   * span level renderer
   * @param {string} text
   */
  strong(text) {
    return `<strong>${text}</strong>`;
  }

  /**
   * @param {string} text
   */
  em(text) {
    return `<em>${text}</em>`;
  }

  /**
   * @param {string} text
   */
  codespan(text) {
    return `<code>${text}</code>`;
  }

  br() {
    return this.options.xhtml ? '<br/>' : '<br>';
  }

  /**
   * @param {string} text
   */
  del(text) {
    return `<del>${text}</del>`;
  }

  /**
   * @param {string} href
   * @param {string} title
   * @param {string} text
   */
  link(href, title, text) {
    href = cleanUrl(this.options.sanitize, this.options.baseUrl, href);
    if (href === null) {
      return text;
    }
    let out = '<a href="' + href + '"';
    if (title) {
      out += ' title="' + title + '"';
    }
    out += '>' + text + '</a>';
    return out;
  }

  /**
   * @param {string} href
   * @param {string} title
   * @param {string} text
   */
  image(href, title, text) {
    href = cleanUrl(this.options.sanitize, this.options.baseUrl, href);
    if (href === null) {
      return text;
    }

    let out = `<img src="${href}" alt="${text}"`;
    if (title) {
      out += ` title="${title}"`;
    }
    out += this.options.xhtml ? '/>' : '>';
    return out;
  }

  text(text) {
    return text;
  }
}

/**
 * TextRenderer
 * returns only the textual part of the token
 */
class TextRenderer {
  // no need for block level renderers
  strong(text) {
    return text;
  }

  em(text) {
    return text;
  }

  codespan(text) {
    return text;
  }

  del(text) {
    return text;
  }

  html(text) {
    return text;
  }

  text(text) {
    return text;
  }

  link(href, title, text) {
    return '' + text;
  }

  image(href, title, text) {
    return '' + text;
  }

  br() {
    return '';
  }
}

/**
 * Slugger generates header id
 */
class Slugger {
  constructor() {
    this.seen = {};
  }

  /**
   * @param {string} value
   */
  serialize(value) {
    return value
      .toLowerCase()
      .trim()
      // remove html tags
      .replace(/<[!\/a-z].*?>/ig, '')
      // remove unwanted chars
      .replace(/[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,./:;<=>?@[\]^`{|}~]/g, '')
      .replace(/\s/g, '-');
  }

  /**
   * Finds the next safe (unique) slug to use
   * @param {string} originalSlug
   * @param {boolean} isDryRun
   */
  getNextSafeSlug(originalSlug, isDryRun) {
    let slug = originalSlug;
    let occurenceAccumulator = 0;
    if (this.seen.hasOwnProperty(slug)) {
      occurenceAccumulator = this.seen[originalSlug];
      do {
        occurenceAccumulator++;
        slug = originalSlug + '-' + occurenceAccumulator;
      } while (this.seen.hasOwnProperty(slug));
    }
    if (!isDryRun) {
      this.seen[originalSlug] = occurenceAccumulator;
      this.seen[slug] = 0;
    }
    return slug;
  }

  /**
   * Convert string to unique id
   * @param {object} [options]
   * @param {boolean} [options.dryrun] Generates the next unique slug without
   * updating the internal accumulator.
   */
  slug(value, options = {}) {
    const slug = this.serialize(value);
    return this.getNextSafeSlug(slug, options.dryrun);
  }
}

/**
 * Parsing & Compiling
 */
class Parser {
  constructor(options) {
    this.options = options || defaults;
    this.options.renderer = this.options.renderer || new Renderer();
    this.renderer = this.options.renderer;
    this.renderer.options = this.options;
    this.textRenderer = new TextRenderer();
    this.slugger = new Slugger();
  }

  /**
   * Static Parse Method
   */
  static parse(tokens, options) {
    const parser = new Parser(options);
    return parser.parse(tokens);
  }

  /**
   * Static Parse Inline Method
   */
  static parseInline(tokens, options) {
    const parser = new Parser(options);
    return parser.parseInline(tokens);
  }

  /**
   * Parse Loop
   */
  parse(tokens, top = true) {
    let out = '',
      i,
      j,
      k,
      l2,
      l3,
      row,
      cell,
      header,
      body,
      token,
      ordered,
      start,
      loose,
      itemBody,
      item,
      checked,
      task,
      checkbox,
      ret;

    const l = tokens.length;
    for (i = 0; i < l; i++) {
      token = tokens[i];

      // Run any renderer extensions
      if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[token.type]) {
        ret = this.options.extensions.renderers[token.type].call({ parser: this }, token);
        if (ret !== false || !['space', 'hr', 'heading', 'code', 'table', 'blockquote', 'list', 'html', 'paragraph', 'text'].includes(token.type)) {
          out += ret || '';
          continue;
        }
      }

      switch (token.type) {
        case 'space': {
          continue;
        }
        case 'hr': {
          out += this.renderer.hr();
          continue;
        }
        case 'heading': {
          out += this.renderer.heading(
            this.parseInline(token.tokens),
            token.depth,
            marked_esm_unescape(this.parseInline(token.tokens, this.textRenderer)),
            this.slugger);
          continue;
        }
        case 'code': {
          out += this.renderer.code(token.text,
            token.lang,
            token.escaped);
          continue;
        }
        case 'table': {
          header = '';

          // header
          cell = '';
          l2 = token.header.length;
          for (j = 0; j < l2; j++) {
            cell += this.renderer.tablecell(
              this.parseInline(token.header[j].tokens),
              { header: true, align: token.align[j] }
            );
          }
          header += this.renderer.tablerow(cell);

          body = '';
          l2 = token.rows.length;
          for (j = 0; j < l2; j++) {
            row = token.rows[j];

            cell = '';
            l3 = row.length;
            for (k = 0; k < l3; k++) {
              cell += this.renderer.tablecell(
                this.parseInline(row[k].tokens),
                { header: false, align: token.align[k] }
              );
            }

            body += this.renderer.tablerow(cell);
          }
          out += this.renderer.table(header, body);
          continue;
        }
        case 'blockquote': {
          body = this.parse(token.tokens);
          out += this.renderer.blockquote(body);
          continue;
        }
        case 'list': {
          ordered = token.ordered;
          start = token.start;
          loose = token.loose;
          l2 = token.items.length;

          body = '';
          for (j = 0; j < l2; j++) {
            item = token.items[j];
            checked = item.checked;
            task = item.task;

            itemBody = '';
            if (item.task) {
              checkbox = this.renderer.checkbox(checked);
              if (loose) {
                if (item.tokens.length > 0 && item.tokens[0].type === 'paragraph') {
                  item.tokens[0].text = checkbox + ' ' + item.tokens[0].text;
                  if (item.tokens[0].tokens && item.tokens[0].tokens.length > 0 && item.tokens[0].tokens[0].type === 'text') {
                    item.tokens[0].tokens[0].text = checkbox + ' ' + item.tokens[0].tokens[0].text;
                  }
                } else {
                  item.tokens.unshift({
                    type: 'text',
                    text: checkbox
                  });
                }
              } else {
                itemBody += checkbox;
              }
            }

            itemBody += this.parse(item.tokens, loose);
            body += this.renderer.listitem(itemBody, task, checked);
          }

          out += this.renderer.list(body, ordered, start);
          continue;
        }
        case 'html': {
          // TODO parse inline content if parameter markdown=1
          out += this.renderer.html(token.text);
          continue;
        }
        case 'paragraph': {
          out += this.renderer.paragraph(this.parseInline(token.tokens));
          continue;
        }
        case 'text': {
          body = token.tokens ? this.parseInline(token.tokens) : token.text;
          while (i + 1 < l && tokens[i + 1].type === 'text') {
            token = tokens[++i];
            body += '\n' + (token.tokens ? this.parseInline(token.tokens) : token.text);
          }
          out += top ? this.renderer.paragraph(body) : body;
          continue;
        }

        default: {
          const errMsg = 'Token with "' + token.type + '" type was not found.';
          if (this.options.silent) {
            console.error(errMsg);
            return;
          } else {
            throw new Error(errMsg);
          }
        }
      }
    }

    return out;
  }

  /**
   * Parse Inline Tokens
   */
  parseInline(tokens, renderer) {
    renderer = renderer || this.renderer;
    let out = '',
      i,
      token,
      ret;

    const l = tokens.length;
    for (i = 0; i < l; i++) {
      token = tokens[i];

      // Run any renderer extensions
      if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[token.type]) {
        ret = this.options.extensions.renderers[token.type].call({ parser: this }, token);
        if (ret !== false || !['escape', 'html', 'link', 'image', 'strong', 'em', 'codespan', 'br', 'del', 'text'].includes(token.type)) {
          out += ret || '';
          continue;
        }
      }

      switch (token.type) {
        case 'escape': {
          out += renderer.text(token.text);
          break;
        }
        case 'html': {
          out += renderer.html(token.text);
          break;
        }
        case 'link': {
          out += renderer.link(token.href, token.title, this.parseInline(token.tokens, renderer));
          break;
        }
        case 'image': {
          out += renderer.image(token.href, token.title, token.text);
          break;
        }
        case 'strong': {
          out += renderer.strong(this.parseInline(token.tokens, renderer));
          break;
        }
        case 'em': {
          out += renderer.em(this.parseInline(token.tokens, renderer));
          break;
        }
        case 'codespan': {
          out += renderer.codespan(token.text);
          break;
        }
        case 'br': {
          out += renderer.br();
          break;
        }
        case 'del': {
          out += renderer.del(this.parseInline(token.tokens, renderer));
          break;
        }
        case 'text': {
          out += renderer.text(token.text);
          break;
        }
        default: {
          const errMsg = 'Token with "' + token.type + '" type was not found.';
          if (this.options.silent) {
            console.error(errMsg);
            return;
          } else {
            throw new Error(errMsg);
          }
        }
      }
    }
    return out;
  }
}

class Hooks {
  constructor(options) {
    this.options = options || defaults;
  }

  static passThroughHooks = new Set([
    'preprocess',
    'postprocess'
  ]);

  /**
   * Process markdown before marked
   */
  preprocess(markdown) {
    return markdown;
  }

  /**
   * Process HTML after marked is finished
   */
  postprocess(html) {
    return html;
  }
}

function onError(silent, async, callback) {
  return (e) => {
    e.message += '\nPlease report this to https://github.com/markedjs/marked.';

    if (silent) {
      const msg = '<p>An error occurred:</p><pre>'
        + marked_esm_escape(e.message + '', true)
        + '</pre>';
      if (async) {
        return Promise.resolve(msg);
      }
      if (callback) {
        callback(null, msg);
        return;
      }
      return msg;
    }

    if (async) {
      return Promise.reject(e);
    }
    if (callback) {
      callback(e);
      return;
    }
    throw e;
  };
}

function parseMarkdown(lexer, parser) {
  return (src, opt, callback) => {
    if (typeof opt === 'function') {
      callback = opt;
      opt = null;
    }

    const origOpt = { ...opt };
    opt = { ...marked.defaults, ...origOpt };
    const throwError = onError(opt.silent, opt.async, callback);

    // throw error in case of non string input
    if (typeof src === 'undefined' || src === null) {
      return throwError(new Error('marked(): input parameter is undefined or null'));
    }
    if (typeof src !== 'string') {
      return throwError(new Error('marked(): input parameter is of type '
        + Object.prototype.toString.call(src) + ', string expected'));
    }

    checkSanitizeDeprecation(opt);

    if (opt.hooks) {
      opt.hooks.options = opt;
    }

    if (callback) {
      const highlight = opt.highlight;
      let tokens;

      try {
        if (opt.hooks) {
          src = opt.hooks.preprocess(src);
        }
        tokens = lexer(src, opt);
      } catch (e) {
        return throwError(e);
      }

      const done = function(err) {
        let out;

        if (!err) {
          try {
            if (opt.walkTokens) {
              marked.walkTokens(tokens, opt.walkTokens);
            }
            out = parser(tokens, opt);
            if (opt.hooks) {
              out = opt.hooks.postprocess(out);
            }
          } catch (e) {
            err = e;
          }
        }

        opt.highlight = highlight;

        return err
          ? throwError(err)
          : callback(null, out);
      };

      if (!highlight || highlight.length < 3) {
        return done();
      }

      delete opt.highlight;

      if (!tokens.length) return done();

      let pending = 0;
      marked.walkTokens(tokens, function(token) {
        if (token.type === 'code') {
          pending++;
          setTimeout(() => {
            highlight(token.text, token.lang, function(err, code) {
              if (err) {
                return done(err);
              }
              if (code != null && code !== token.text) {
                token.text = code;
                token.escaped = true;
              }

              pending--;
              if (pending === 0) {
                done();
              }
            });
          }, 0);
        }
      });

      if (pending === 0) {
        done();
      }

      return;
    }

    if (opt.async) {
      return Promise.resolve(opt.hooks ? opt.hooks.preprocess(src) : src)
        .then(src => lexer(src, opt))
        .then(tokens => opt.walkTokens ? Promise.all(marked.walkTokens(tokens, opt.walkTokens)).then(() => tokens) : tokens)
        .then(tokens => parser(tokens, opt))
        .then(html => opt.hooks ? opt.hooks.postprocess(html) : html)
        .catch(throwError);
    }

    try {
      if (opt.hooks) {
        src = opt.hooks.preprocess(src);
      }
      const tokens = lexer(src, opt);
      if (opt.walkTokens) {
        marked.walkTokens(tokens, opt.walkTokens);
      }
      let html = parser(tokens, opt);
      if (opt.hooks) {
        html = opt.hooks.postprocess(html);
      }
      return html;
    } catch (e) {
      return throwError(e);
    }
  };
}

/**
 * Marked
 */
function marked(src, opt, callback) {
  return parseMarkdown(Lexer.lex, Parser.parse)(src, opt, callback);
}

/**
 * Options
 */

marked.options =
marked.setOptions = function(opt) {
  marked.defaults = { ...marked.defaults, ...opt };
  changeDefaults(marked.defaults);
  return marked;
};

marked.getDefaults = getDefaults;

marked.defaults = defaults;

/**
 * Use Extension
 */

marked.use = function(...args) {
  const extensions = marked.defaults.extensions || { renderers: {}, childTokens: {} };

  args.forEach((pack) => {
    // copy options to new object
    const opts = { ...pack };

    // set async to true if it was set to true before
    opts.async = marked.defaults.async || opts.async || false;

    // ==-- Parse "addon" extensions --== //
    if (pack.extensions) {
      pack.extensions.forEach((ext) => {
        if (!ext.name) {
          throw new Error('extension name required');
        }
        if (ext.renderer) { // Renderer extensions
          const prevRenderer = extensions.renderers[ext.name];
          if (prevRenderer) {
            // Replace extension with func to run new extension but fall back if false
            extensions.renderers[ext.name] = function(...args) {
              let ret = ext.renderer.apply(this, args);
              if (ret === false) {
                ret = prevRenderer.apply(this, args);
              }
              return ret;
            };
          } else {
            extensions.renderers[ext.name] = ext.renderer;
          }
        }
        if (ext.tokenizer) { // Tokenizer Extensions
          if (!ext.level || (ext.level !== 'block' && ext.level !== 'inline')) {
            throw new Error("extension level must be 'block' or 'inline'");
          }
          if (extensions[ext.level]) {
            extensions[ext.level].unshift(ext.tokenizer);
          } else {
            extensions[ext.level] = [ext.tokenizer];
          }
          if (ext.start) { // Function to check for start of token
            if (ext.level === 'block') {
              if (extensions.startBlock) {
                extensions.startBlock.push(ext.start);
              } else {
                extensions.startBlock = [ext.start];
              }
            } else if (ext.level === 'inline') {
              if (extensions.startInline) {
                extensions.startInline.push(ext.start);
              } else {
                extensions.startInline = [ext.start];
              }
            }
          }
        }
        if (ext.childTokens) { // Child tokens to be visited by walkTokens
          extensions.childTokens[ext.name] = ext.childTokens;
        }
      });
      opts.extensions = extensions;
    }

    // ==-- Parse "overwrite" extensions --== //
    if (pack.renderer) {
      const renderer = marked.defaults.renderer || new Renderer();
      for (const prop in pack.renderer) {
        const prevRenderer = renderer[prop];
        // Replace renderer with func to run extension, but fall back if false
        renderer[prop] = (...args) => {
          let ret = pack.renderer[prop].apply(renderer, args);
          if (ret === false) {
            ret = prevRenderer.apply(renderer, args);
          }
          return ret;
        };
      }
      opts.renderer = renderer;
    }
    if (pack.tokenizer) {
      const tokenizer = marked.defaults.tokenizer || new Tokenizer();
      for (const prop in pack.tokenizer) {
        const prevTokenizer = tokenizer[prop];
        // Replace tokenizer with func to run extension, but fall back if false
        tokenizer[prop] = (...args) => {
          let ret = pack.tokenizer[prop].apply(tokenizer, args);
          if (ret === false) {
            ret = prevTokenizer.apply(tokenizer, args);
          }
          return ret;
        };
      }
      opts.tokenizer = tokenizer;
    }

    // ==-- Parse Hooks extensions --== //
    if (pack.hooks) {
      const hooks = marked.defaults.hooks || new Hooks();
      for (const prop in pack.hooks) {
        const prevHook = hooks[prop];
        if (Hooks.passThroughHooks.has(prop)) {
          hooks[prop] = (arg) => {
            if (marked.defaults.async) {
              return Promise.resolve(pack.hooks[prop].call(hooks, arg)).then(ret => {
                return prevHook.call(hooks, ret);
              });
            }

            const ret = pack.hooks[prop].call(hooks, arg);
            return prevHook.call(hooks, ret);
          };
        } else {
          hooks[prop] = (...args) => {
            let ret = pack.hooks[prop].apply(hooks, args);
            if (ret === false) {
              ret = prevHook.apply(hooks, args);
            }
            return ret;
          };
        }
      }
      opts.hooks = hooks;
    }

    // ==-- Parse WalkTokens extensions --== //
    if (pack.walkTokens) {
      const walkTokens = marked.defaults.walkTokens;
      opts.walkTokens = function(token) {
        let values = [];
        values.push(pack.walkTokens.call(this, token));
        if (walkTokens) {
          values = values.concat(walkTokens.call(this, token));
        }
        return values;
      };
    }

    marked.setOptions(opts);
  });
};

/**
 * Run callback for every token
 */

marked.walkTokens = function(tokens, callback) {
  let values = [];
  for (const token of tokens) {
    values = values.concat(callback.call(marked, token));
    switch (token.type) {
      case 'table': {
        for (const cell of token.header) {
          values = values.concat(marked.walkTokens(cell.tokens, callback));
        }
        for (const row of token.rows) {
          for (const cell of row) {
            values = values.concat(marked.walkTokens(cell.tokens, callback));
          }
        }
        break;
      }
      case 'list': {
        values = values.concat(marked.walkTokens(token.items, callback));
        break;
      }
      default: {
        if (marked.defaults.extensions && marked.defaults.extensions.childTokens && marked.defaults.extensions.childTokens[token.type]) { // Walk any extensions
          marked.defaults.extensions.childTokens[token.type].forEach(function(childTokens) {
            values = values.concat(marked.walkTokens(token[childTokens], callback));
          });
        } else if (token.tokens) {
          values = values.concat(marked.walkTokens(token.tokens, callback));
        }
      }
    }
  }
  return values;
};

/**
 * Parse Inline
 * @param {string} src
 */
marked.parseInline = parseMarkdown(Lexer.lexInline, Parser.parseInline);

/**
 * Expose
 */
marked.Parser = Parser;
marked.parser = Parser.parse;
marked.Renderer = Renderer;
marked.TextRenderer = TextRenderer;
marked.Lexer = Lexer;
marked.lexer = Lexer.lex;
marked.Tokenizer = Tokenizer;
marked.Slugger = Slugger;
marked.Hooks = Hooks;
marked.parse = marked;

const options = marked.options;
const setOptions = marked.setOptions;
const use = marked.use;
const walkTokens = marked.walkTokens;
const parseInline = marked.parseInline;
const parse = (/* unused pure expression or super */ null && (marked));
const parser = Parser.parse;
const lexer = Lexer.lex;



;// CONCATENATED MODULE: ./src/sections/Accordions/FAQPageSeo.jsx



function FAQPageSeo(param) {
    var accordions = param.accordions;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)((head_default()), {
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("script", {
            type: "application/ld+json",
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML: {
                __html: JSON.stringify({
                    "@context": "https://schema.org/",
                    "@type": "FAQPage",
                    mainEntity: accordions.map(function(item) {
                        if (!item.body || !item.heading) return null;
                        return {
                            "@type": "Question",
                            name: item.heading,
                            acceptedAnswer: {
                                "@type": "Answer",
                                text: marked.parse(item.body)
                            }
                        };
                    })
                })
            }
        })
    });
}

;// CONCATENATED MODULE: ./src/sections/Accordions/Accordions.jsx










var Accordions = (0,src_utils/* withInView */.Dh)(themed(function(param) {
    var theme = param.theme, cms = param.cms;
    var ref;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(snippets/* Section */.$0, {
        children: [
            (cms === null || cms === void 0 ? void 0 : cms.accordionsGroup) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(FAQPageSeo, {
                accordions: cms.accordionsGroup.map(function(accordionGroup) {
                    return (0,_to_consumable_array/* default */.Z)(accordionGroup.accordions) || [];
                }).flat()
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Container */.W2, {
                "data-comp": Accordions.displayName,
                sx: theme.wrapper,
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                        variant: "h2",
                        sx: theme.heading,
                        children: cms === null || cms === void 0 ? void 0 : cms.heading
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                        children: cms === null || cms === void 0 ? void 0 : (ref = cms.accordionsGroup) === null || ref === void 0 ? void 0 : ref.map(function(accordionGroup, accordionGroupIndex) {
                            var ref;
                            return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                                variant: "flex.column",
                                sx: theme.accordionGroup,
                                children: [
                                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                                        variant: "h3",
                                        sx: theme.accordionGroupHeading,
                                        children: accordionGroup.heading
                                    }),
                                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                                            variant: "flex.column",
                                            children: (ref = accordionGroup.accordions) === null || ref === void 0 ? void 0 : ref.map(function(accordion, index) {
                                                var forceActiveState = accordionGroupIndex === 0 && index === 0;
                                                return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Accordion, {
                                                    accordion: accordion,
                                                    theme: theme,
                                                    forceActiveState: forceActiveState
                                                }, "".concat(accordionGroup.heading, "-accordion-").concat(index));
                                            })
                                        })
                                    })
                                ]
                            }, accordionGroupIndex);
                        })
                    })
                ]
            })
        ]
    });
}), {
    triggerOnce: true
});
Accordions.displayName = "Accordions";
Accordions.Schema = Schema;

;// CONCATENATED MODULE: ./src/sections/Accordions/index.js


;// CONCATENATED MODULE: ./src/sections/Aftership/Aftership.schema.js



var Aftership_schema_Schema = function() {
    return {
        label: "Aftership",
        key: "aftership",
        fields: [
            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, common/* section */.qi), {
                defaultValue: {
                    bgColor: common/* color.value.background */.$_.value.background,
                    color: common/* color.value.text */.$_.value.text,
                    desktop: {
                        container: "full-bleed",
                        mt: "none",
                        py: "none"
                    },
                    mobile: {
                        container: "full-bleed",
                        mt: "none",
                        py: "none"
                    }
                }
            }), 
        ]
    };
};

;// CONCATENATED MODULE: ./src/sections/Aftership/Aftership.jsx




function Aftership(param) {
    var cms = param.cms;
    var section = cms.section;
    (0,react.useEffect)(function() {
        var iframe = document.getElementById("aftership-iframe");
        var addIframeScrollHeight = function(event) {
            if (event.data && event.data.type === "resize" && typeof event.data.scrollHeight === "number" && iframe) {
                iframe.style.height = "".concat(event.data.scrollHeight, "px");
            }
        };
        window.addEventListener("message", addIframeScrollHeight);
        return function() {
            return window.removeEventListener("message", addIframeScrollHeight);
        };
    }, []);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Section */.$0, {
        "data-comp": Aftership.displayName,
        section: section,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("iframe", {
            id: "aftership-iframe",
            title: "aftership",
            src: "https://brumate.aftership.com/iframe?page-name=tracking-page",
            scrolling: "no",
            frameBorder: "0",
            style: {
                width: "100%"
            }
        })
    });
}
Aftership.displayName = "Aftership";
Aftership.Schema = Aftership_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/Aftership/index.js


;// CONCATENATED MODULE: ./src/sections/AccessibilityStatement/AccessibilityStatement.theme.js


var AccessibilityStatement_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = (0,_define_property/* default */.Z)({
        table: {
            width: "100%"
        },
        thead: {
            backgroundColor: "lightgrey"
        },
        "th, td": {
            py: "5px"
        },
        "tr:nth-of-type(even)": {
            backgroundColor: "#f5f5f5"
        },
        p: {
            mb: 8,
            fontFamily: "body"
        },
        "ul, ol": {
            mb: 8,
            pl: 13
        },
        ul: {
            li: {
                listStyleType: "disc"
            }
        },
        ol: {
            li: {
                listStyleType: "decimal"
            }
        },
        li: {
            mb: 4,
            listStylePosition: "inside",
            textIndent: "-22px",
            fontFamily: "body"
        },
        a: {
            textDecoration: "underline",
            fontFamily: "body"
        },
        h1: {
            variant: "text.h1",
            mb: 11
        },
        h2: {
            variant: "text.h2",
            mt: 11,
            mb: 10
        },
        h3: {
            variant: "text.h3",
            mt: [
                9,
                null,
                11
            ],
            mb: 9
        },
        h4: {
            variant: "text.h4",
            mb: 9
        },
        h5: {
            variant: "text.h5",
            mb: 9
        },
        h6: {
            variant: "text.h6",
            mb: 9
        },
        "span, del": {
            textDecorationColor: "currentColor"
        },
        strong: {
            fontWeight: "700 !important"
        },
        modal: {
            textDecoration: "underline",
            fontFamily: "body",
            cursor: "pointer"
        }
    }, "modal", {
        textDecoration: "underline",
        fontFamily: "body",
        cursor: "pointer"
    });
}());

;// CONCATENATED MODULE: ./src/sections/AccessibilityStatement/AccessibilityStatement.schema.js



function AccessibilityStatement_schema_Schema(param) {
    var page = param.page;
    if ((page === null || page === void 0 ? void 0 : page.handle) !== "accessibility-statement-site") return null;
    return {
        label: "Accessibility Statement",
        key: "accessibility-statement",
        fields: [
            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, common/* section */.qi), {
                defaultValue: {
                    bgColor: common/* color.value.background */.$_.value.background,
                    color: common/* color.value.text */.$_.value.text,
                    desktop: {
                        container: "content",
                        mt: "none",
                        py: "s"
                    },
                    mobile: {
                        container: "content",
                        mt: "none",
                        py: "s"
                    }
                }
            }), 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/AccessibilityStatement/AccessibilityStatement.jsx







var AccessibilityStatement = (0,src_utils/* withInView */.Dh)(AccessibilityStatement_theme_themed(function(param) {
    var theme = param.theme, cms = param.cms;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Section */.$0, {
        section: cms.section,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Container */.W2, {
            "data-comp": AccessibilityStatement.displayName,
            sx: theme.wrapper,
            children: [
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)((head_default()), {
                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("script", {
                        src: "https://a40.usablenet.com/pt/c/statement/brumate/accessibilitystatement.js? l=1"
                    })
                }),
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                    id: "a40AccessibilityStatement"
                })
            ]
        })
    });
}), {
    triggerOnce: true
});
AccessibilityStatement.displayName = "AccessibilityStatement";
AccessibilityStatement.Schema = AccessibilityStatement_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/AccessibilityStatement/index.js


;// CONCATENATED MODULE: ./src/sections/BlogGrid/Tile/Image/Image.theme.js

var Image_theme_themed = (0,create/* create */.U)(new function() {
    this.image = {
        ":hover": {
            pointerEvents: "none",
            transform: "scale3d(1.03, 1.03, 1.03)"
        },
        transform: "scale3d(1.01, 1.01, 1.01)",
        transition: "transform 0.3s ease-in-out"
    };
}());

;// CONCATENATED MODULE: ./src/sections/BlogGrid/Tile/Image/Image.jsx





var Image_Image = Image_theme_themed(function(param) {
    var theme = param.theme, articleImage = param.articleImage, alt = param.alt;
    var image = articleImage || "https://cdn.shopify.com/s/files/1/1114/2308/files/brumate-blog-placeholder.jpg?v=1660081495";
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Image */.Ee, {
        src: image,
        alt: alt,
        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.image), {
            objectFit: "cover",
            width: "100%",
            maxHeight: [
                240,
                280
            ],
            minHeight: [
                240,
                280
            ]
        })
    });
});
Image_Image.displayName = "Image";

;// CONCATENATED MODULE: ./src/sections/BlogGrid/Tile/Image/index.js


// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(52050);
;// CONCATENATED MODULE: ./src/sections/BlogGrid/Tile/Content/Content.theme.js



var Content_theme_themed = (0,create/* create */.U)(new function() {
    this.outer = {
        width: "100%",
        justifyContent: "flex-start",
        alignItems: "flex-start"
    };
    this.innerLeft = {
        variant: "flex.column",
        width: "100%",
        alignItems: "flex-start"
    };
    this.innerRight = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this.innerLeft), {
        alignItems: "flex-end"
    });
    this.innerCenter = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this.innerLeft), {
        alignItems: "center"
    });
    this.date = {
        mt: 0
    };
    this.title = {
        variant: "text.articleTitle",
        fontSize: "28px",
        lineHeight: "32px",
        overflowWrap: "break-word",
        maxWidth: "324px",
        my: 3,
        cursor: "pointer"
    };
    this.excerpt = {};
    this.link = {
        mt: [
            3,
            6
        ],
        cursor: "pointer"
    };
}());

;// CONCATENATED MODULE: ./src/sections/BlogGrid/Tile/Content/Content.jsx








var Content = Content_theme_themed(function(param) {
    var theme = param.theme, settings = param.settings, article = param.article, url = param.url;
    var ref = (0,_object_spread/* default */.Z)({}, settings), linkText = ref.linkText, linkStyle = ref.linkStyle, linkStyleMobile = ref.linkStyleMobile, align = ref.align, alignMobile = ref.alignMobile;
    var ref1 = (0,_object_spread/* default */.Z)({}, article), author = ref1.author, title = ref1.title, excerpt = ref1.excerpt, _createdAt = ref1._createdAt, createdAt = ref1.createdAt;
    var ref2 = (0,_sliced_to_array/* default */.Z)(new Date(Date.parse(_createdAt || createdAt)).toString().split(" "), 4), month = ref2[1], day = ref2[2], year = ref2[3];
    var date = "".concat(month, " ").concat(day, ", ").concat(year);
    var textAlign = [
        alignMobile,
        align
    ];
    var slicedExcerpt = excerpt.length > 80 ? "".concat(excerpt.slice(0, excerpt.indexOf(" ", 60)), " ...") : excerpt;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
        "data-comp": Content.displayName,
        sx: theme.outer,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
            sx: {
                variant: "flex.column",
                width: "100%",
                alignItems: [
                    (0,src_utils/* convertAlignToFlex */.nG)(alignMobile),
                    (0,src_utils/* convertAlignToFlex */.nG)(align), 
                ]
            },
            children: [
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Paragraph */.nv, {
                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.date), {
                        textAlign: textAlign
                    }),
                    children: [
                        author,
                        " | ",
                        date
                    ]
                }),
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Link */.rU, {
                    href: url,
                    "aria-label": title,
                    sx: {
                        cursor: "pointer",
                        variant: "buttons.plain"
                    },
                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                        as: "h4",
                        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.title), {
                            textAlign: textAlign
                        }),
                        children: title
                    })
                }),
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.excerpt), {
                        textAlign: textAlign
                    }),
                    children: slicedExcerpt
                }),
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Link */.rU, {
                    variant: "buttons.".concat(linkStyleMobile || "link.2"),
                    href: url,
                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.link), {
                        display: [
                            "block",
                            "none"
                        ]
                    }),
                    children: linkText
                }),
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Link */.rU, {
                    variant: "buttons.".concat(linkStyle || "link.2"),
                    href: url,
                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.link), {
                        display: [
                            "none",
                            "block"
                        ]
                    }),
                    children: linkText
                })
            ]
        })
    });
});
Content.displayName = "Content";

;// CONCATENATED MODULE: ./src/sections/BlogGrid/Tile/Content/index.js


;// CONCATENATED MODULE: ./src/sections/BlogGrid/Tile/Tile.theme.js

var Tile_theme_themed = (0,create/* create */.U)(new function() {
    this.grid = {
        display: "flex",
        position: "relative",
        gap: [
            4,
            4,
            7
        ]
    };
    this.image = {
        cursor: "pointer"
    };
}());

;// CONCATENATED MODULE: ./src/sections/BlogGrid/Tile/Tile.jsx
/* eslint-disable jsx-a11y/anchor-is-valid */ 








var Tile = Tile_theme_themed(function(param) {
    var theme = param.theme, article = param.article, tileSettings = param.tileSettings;
    var image = tileSettings.image, content = tileSettings.content;
    var articleImage = (0,react.useMemo)(function() {
        var ref, ref1, ref2;
        if (!(article === null || article === void 0 ? void 0 : article.excerpt)) return null;
        if ((ref = article.seo) === null || ref === void 0 ? void 0 : ref.image) return article.seo.image;
        if (!article.bodyHtml) return null;
        var jpg = (ref1 = article.bodyHtml) === null || ref1 === void 0 ? void 0 : ref1.slice(article === null || article === void 0 ? void 0 : article.bodyHtml.indexOf("cdn"), article === null || article === void 0 ? void 0 : article.bodyHtml.indexOf(".jpg"));
        var png = article === null || article === void 0 ? void 0 : (ref2 = article.bodyHtml) === null || ref2 === void 0 ? void 0 : ref2.slice(article === null || article === void 0 ? void 0 : article.bodyHtml.indexOf("cdn"), article === null || article === void 0 ? void 0 : article.bodyHtml.indexOf(".png"));
        var srcUrl = (jpg === null || jpg === void 0 ? void 0 : jpg.length) < 200 ? jpg : png;
        var extension = (jpg === null || jpg === void 0 ? void 0 : jpg.length) < 200 ? ".jpg" : ".png";
        return jpg || png ? "https://".concat(srcUrl).concat(extension) : "https://cdn.shopify.com/s/files/1/1114/2308/files/brumate-blog-placeholder.jpg";
    }, [
        article
    ]);
    var imageTop = (image === null || image === void 0 ? void 0 : image.location) === "top";
    var url = "/articles/".concat(article === null || article === void 0 ? void 0 : article.handle);
    return article.excerpt ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Container */.W2, {
        "data-comp": Tile.displayName,
        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.grid), {
            flexDirection: imageTop ? "column" : "column-reverse"
        }),
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Link */.rU, {
                href: url,
                "aria-label": article === null || article === void 0 ? void 0 : article.title,
                sx: {
                    cursor: "pointer"
                },
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Image_Image, {
                    articleImage: articleImage,
                    alt: article === null || article === void 0 ? void 0 : article.title,
                    sx: theme.image
                })
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Content, {
                article: article,
                settings: content,
                url: url
            })
        ]
    }) : null;
});
Tile.displayName = "Tile";

;// CONCATENATED MODULE: ./src/sections/BlogGrid/Tile/index.js


// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(31373);
;// CONCATENATED MODULE: ./src/sections/BlogGrid/Pagination/Pagination.theme.js

var Pagination_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        variant: "flex.row.center",
        my: 13
    };
    this.list = {
        pl: 0
    };
    this.arrowListItem = {
        display: "flex",
        alignItems: "center"
    };
    this.arrowButton = function(disabled) {
        return {
            cursor: disabled ? "default" : "pointer"
        };
    };
    this.arrowIcon = function(disabled) {
        return {
            width: "16px",
            transition: "all .2s ease-in-out",
            color: disabled ? "gray" : "text"
        };
    };
    this.listItem = {
        mr: 5
    };
    this.pageButton = function(isCurrentPage) {
        return {
            position: "relative",
            ":after": {
                content: '""',
                width: "100%",
                position: "absolute",
                height: "1px",
                left: 0,
                top: "100%",
                bg: "text",
                transition: "transform .2s ease-in-out",
                transform: isCurrentPage ? "scaleX(1)" : "scaleX(0)"
            }
        };
    };
}());

;// CONCATENATED MODULE: ./src/sections/BlogGrid/Pagination/Pagination.jsx








var Pagination = Pagination_theme_themed(function(_param) {
    var theme = _param.theme, currentPage = _param.currentPage, totalPages = _param.totalPages, goToPrevPage = _param.goToPrevPage, goToNextPage = _param.goToNextPage, goToPage = _param.goToPage, resultsPerPage = _param.resultsPerPage, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme",
        "currentPage",
        "totalPages",
        "goToPrevPage",
        "goToNextPage",
        "goToPage",
        "resultsPerPage"
    ]);
    var isFirstPage = currentPage === 1;
    var isLastPage = currentPage === totalPages;
    return totalPages > 1 ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-comp": Pagination.displayName
    }, props), {
        sx: (0,_object_spread/* default */.Z)({}, theme.wrapper, props.sx),
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
            as: "nav",
            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                as: "ul",
                variant: "flex.row.start.center",
                sx: theme.list,
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                        as: "li",
                        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.arrowListItem), {
                            mr: 5
                        }),
                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                            variant: "buttons.plain",
                            onClick: goToPrevPage,
                            disabled: isFirstPage,
                            "aria-label": "Go to previous page",
                            sx: theme.arrowButton(isFirstPage),
                            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Svg */.ny, {
                                alt: "chevron",
                                viewBox: "0 0 16 16",
                                src: "/svgs/chevron/left.svg#left",
                                sx: theme.arrowIcon(isFirstPage)
                            })
                        })
                    }),
                    (0,_to_consumable_array/* default */.Z)(Array(totalPages).keys()).map(function(i) {
                        var page = i + 1;
                        return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                            as: "li",
                            sx: theme.listItem,
                            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                                variant: "buttons.plain",
                                onClick: function() {
                                    return goToPage(page);
                                },
                                "aria-label": "Go to page ".concat(page),
                                sx: theme.pageButton(page === currentPage),
                                children: page
                            }, page)
                        }, page);
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                        as: "li",
                        sx: theme.arrowListItem,
                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                            variant: "buttons.plain",
                            onClick: goToNextPage,
                            disabled: isLastPage,
                            "aria-label": "Go to next page",
                            sx: theme.arrowButton(isLastPage),
                            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Svg */.ny, {
                                alt: "chevron",
                                viewBox: "0 0 16 16",
                                src: "/svgs/chevron/right.svg#right",
                                sx: theme.arrowIcon(isLastPage)
                            })
                        })
                    })
                ]
            })
        })
    })) : null;
});
Pagination.displayName = "Pagination";

;// CONCATENATED MODULE: ./src/sections/BlogGrid/Pagination/index.js


;// CONCATENATED MODULE: ./src/sections/BlogGrid/BlogGrid.schema.js



function BlogGrid_schema_Schema(param) {
    var blog = param.blog;
    if (!blog) return null;
    return {
        label: "Blog Grid",
        key: "blog-grid",
        fields: [
            // Todo: Max number of tiles to display before showing "More Articles" button/event.
            {
                label: "Tile Settings",
                name: "tile",
                description: "Max of 3 tiles",
                component: "group",
                fields: [
                    {
                        label: "First tile visibility",
                        name: "toggleVisibility",
                        description: "Hide the most recent article if Featured Article section is enabled",
                        component: "toggle",
                        toggleLabels: {
                            true: "Visible",
                            false: "Hidden"
                        }
                    },
                    {
                        label: "Content Settings",
                        name: "content",
                        component: "group",
                        fields: [
                            {
                                label: "Content alignment",
                                name: "align",
                                component: "radio-group",
                                direction: "horizontal",
                                variant: "radio",
                                options: common/* align.options */.AJ.options
                            },
                            {
                                label: "Content alignment (mobile)",
                                name: "alignMobile",
                                component: "radio-group",
                                direction: "horizontal",
                                variant: "radio",
                                options: common/* align.options */.AJ.options
                            },
                            {
                                label: "Link text",
                                name: "linkText",
                                component: "text"
                            },
                            {
                                label: "Link style",
                                name: "linkStyle",
                                component: "select",
                                options: common/* button.options */.LI.options
                            },
                            {
                                label: "Link style (mobile)",
                                name: "linkStyleMobile",
                                component: "select",
                                options: common/* button.options */.LI.options
                            }, 
                        ]
                    },
                    {
                        label: "Image Settings",
                        name: "image",
                        component: "group",
                        fields: [
                            {
                                label: "Image placement",
                                name: "location",
                                component: "radio-group",
                                direction: "horizontal",
                                variant: "radio",
                                options: [
                                    {
                                        value: "top",
                                        label: "Top"
                                    },
                                    {
                                        value: "bottom",
                                        label: "Bottom"
                                    }, 
                                ]
                            },
                            {
                                label: "Image placement (mobile)",
                                name: "locationMobile",
                                component: "radio-group",
                                direction: "horizontal",
                                variant: "radio",
                                options: [
                                    {
                                        value: "top",
                                        label: "Top"
                                    },
                                    {
                                        value: "bottom",
                                        label: "Bottom"
                                    }, 
                                ]
                            }, 
                        ]
                    }, 
                ],
                defaultValue: {
                    toggleVisibility: false,
                    content: {
                        align: "left",
                        alignMobile: "left",
                        linkText: "Read More",
                        linkStyle: "articleLink",
                        linkStyleMobile: "articleLink"
                    },
                    image: {
                        location: "top",
                        locationMobile: "top"
                    }
                }
            },
            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, common/* section */.qi), {
                defaultValue: {
                    bgColor: common/* color.value.background */.$_.value.background,
                    color: common/* color.value.text */.$_.value.text,
                    desktop: {
                        container: "content",
                        mt: "none",
                        py: "xs"
                    },
                    mobile: {
                        container: "container",
                        mt: "none",
                        py: "xs"
                    }
                }
            }), 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/BlogGrid/BlogGrid.theme.js

var BlogGrid_theme_themed = (0,create/* create */.U)(new function() {
    this.grid = {
        gridTemplateColumns: [
            "1fr",
            "repeat(3, 1fr)"
        ],
        gridColumnGap: 10,
        gridRowGap: [
            12,
            14
        ]
    };
    this.moreArticles = {
        variant: "text.base"
    };
    this.loadMore = {
        mt: 13,
        width: "100%"
    };
}());

;// CONCATENATED MODULE: ./src/sections/BlogGrid/BlogGrid.jsx










var BlogGrid = (0,src_utils/* withInView */.Dh)(BlogGrid_theme_themed(function(param) {
    var theme = param.theme, cms = param.cms;
    var ref, ref1, ref2, ref3;
    var tile = cms.tile, section = cms.section;
    var blog = (0,dist.useBlog)();
    var articles = blog === null || blog === void 0 ? void 0 : (ref = blog.articles) === null || ref === void 0 ? void 0 : ref.filter(function(article) {
        return !!article.excerpt;
    });
    var resultsPerPage = 9;
    var ref4 = (0,react.useState)(1), currentResultsPage = ref4[0], setCurrentResultsPage = ref4[1];
    var router = (0,dist.useRouter)();
    var urlCategory = (router === null || router === void 0 ? void 0 : (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.category) || null;
    var page = parseInt((router === null || router === void 0 ? void 0 : (ref2 = router.query) === null || ref2 === void 0 ? void 0 : ref2.page) || "1", 10);
    var routePath = (ref3 = router.asPath) === null || ref3 === void 0 ? void 0 : ref3.split("?")[0];
    (0,react.useEffect)(function() {
        if (!articles) return;
        setCurrentResultsPage(page || 1);
    }, [
        page
    ]);
    var categoryArticles = (0,react.useMemo)(function() {
        if (!(articles === null || articles === void 0 ? void 0 : articles.length)) return [];
        var articlesMap = articles.reduce(function(map, article) {
            if (map[article.id]) return map;
            map[article.id] = article;
            return map;
        }, {});
        var articlesObj = Object.values(articlesMap).reverse();
        var sortedByDate = articlesObj.sort(function(a, b) {
            var aDate = new Date(a.createdAt);
            var bDate = new Date(b.createdAt);
            return bDate.getTime() - aDate.getTime();
        });
        var articlesCache = {};
        var uniqueArticles = sortedByDate.filter(function(article) {
            if (articlesCache[article.handle]) return false;
            articlesCache[article.handle] = true;
            return true;
        });
        return urlCategory ? uniqueArticles.filter(function(param) {
            var category = param.category;
            return category.toLowerCase() === urlCategory.toLowerCase();
        }) : uniqueArticles;
    }, [
        articles,
        urlCategory
    ]);
    var totalPages = Math.ceil(categoryArticles.length / resultsPerPage);
    var previousPage = currentResultsPage > 1 ? currentResultsPage - 1 : null;
    var nextPage = currentResultsPage < totalPages ? currentResultsPage + 1 : null;
    var goToPrevPage = (0,react.useCallback)(function() {
        if (!previousPage) return;
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        router.push({
            pathname: routePath,
            query: {
                category: urlCategory,
                page: previousPage
            }
        });
    }, [
        previousPage
    ]);
    var goToNextPage = (0,react.useCallback)(function() {
        if (!nextPage) return;
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        router.push({
            pathname: routePath,
            query: {
                category: urlCategory,
                page: nextPage
            }
        });
    }, [
        nextPage
    ]);
    var goToPage = (0,react.useCallback)(function(num) {
        if (!num || num > totalPages) return;
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        router.push({
            pathname: routePath,
            query: {
                category: urlCategory,
                page: num
            }
        });
    }, [
        totalPages
    ]);
    var ref5 = (0,react.useState)(0), startIndex = ref5[0], setStartIndex = ref5[1];
    var ref6 = (0,react.useState)(8), endIndex = ref6[0], setEndIndex = ref6[1];
    (0,react.useEffect)(function() {
        if (!articles) return;
        setStartIndex(currentResultsPage * resultsPerPage - resultsPerPage);
        setEndIndex(currentResultsPage * resultsPerPage);
    }, [
        currentResultsPage,
        resultsPerPage
    ]);
    return articles ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(snippets/* Section */.$0, {
        section: section,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Grid */.rj, {
                "data-comp": BlogGrid.displayName,
                sx: theme.grid,
                children: (categoryArticles === null || categoryArticles === void 0 ? void 0 : categoryArticles.length) ? categoryArticles.slice(startIndex, endIndex).map(function(article, index) {
                    if (!(tile === null || tile === void 0 ? void 0 : tile.toggleVisibility) && index === 0) return null;
                    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Tile, {
                        article: article,
                        tileSettings: tile
                    }, article === null || article === void 0 ? void 0 : article.id);
                }) : "No articles to display for ".concat(router.query.category, ".")
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Pagination, {
                resultsPerPage: resultsPerPage,
                currentPage: currentResultsPage,
                totalPages: totalPages || 1,
                goToPrevPage: goToPrevPage,
                goToNextPage: goToNextPage,
                goToPage: goToPage
            })
        ]
    }) : null;
}), {
    renderOnce: true
});
BlogGrid.displayName = "BlogGrid";
BlogGrid.Schema = BlogGrid_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/BlogGrid/index.js


;// CONCATENATED MODULE: ./src/sections/CollectionCategories/CollectionCategories.schema.js
function CollectionCategories_schema_Schema(param) {
    var collection = param.collection;
    if (!collection) return null;
    return {
        label: "Collection Categories",
        key: "collection-categories",
        fields: [
            {
                label: "Name",
                name: "name",
                component: "text",
                defaultValue: "Size"
            },
            {
                name: "collapsed",
                label: "Dropdown Collapsed (Desktop)",
                component: "toggle",
                toggleLabels: {
                    true: "On",
                    false: "Off"
                },
                defaultValue: true
            },
            {
                label: "Categories",
                name: "categories",
                component: "group-list",
                itemProps: {
                    label: "{{item.link.text}}"
                },
                defaultItem: {
                    link: {
                        text: "Slim (12oz Slim Cans)",
                        url: "/collections/hopsulator-slim"
                    },
                    mobileImage: {
                        product: {
                            handle: "hopsulator-slim-onyx-leopard-12oz-slim-cans"
                        }
                    }
                },
                fields: [
                    {
                        label: "Collection Link",
                        name: "link",
                        component: "link"
                    },
                    {
                        label: "Image",
                        name: "mobileImage",
                        description: "Use default image of specific product or manual upload of image",
                        component: "group",
                        fields: [
                            {
                                name: "image",
                                label: "Manual Image",
                                component: "image",
                                description: "If provided, this image will override the default image of the product"
                            },
                            {
                                name: "product",
                                component: "productSearch",
                                label: "Default Image of Specific Product"
                            }, 
                        ],
                        defaultValue: {}
                    }, 
                ],
                defaultValue: [
                    {
                        link: {
                            text: "All Can Holders",
                            url: "/collections/can-holders"
                        },
                        mobileImage: {
                            product: {
                                handle: "hopsulator-slim-gold-leopard-12oz-slim-cans"
                            }
                        }
                    },
                    {
                        link: {
                            text: "Slim (12oz Slim Cans)",
                            url: "/collections/hopsulator-slim"
                        },
                        mobileImage: {
                            product: {
                                handle: "hopsulator-slim-onyx-leopard-12oz-slim-cans"
                            }
                        }
                    },
                    {
                        link: {
                            text: "Trio (12/16oz Cans)",
                            url: "/collections/hopsulator-trio"
                        },
                        mobileImage: {
                            product: {
                                handle: "hopsulator-trio-v2-0-by-brumate-matte-navy"
                            }
                        }
                    }, 
                ]
            }, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/CollectionCategories/CollectionCategories.theme.js

var CollectionCategories_theme_themed = (0,create/* create */.U)(new function() {}());

;// CONCATENATED MODULE: ./src/sections/CollectionCategories/CollectionCategories.jsx





var CollectionCategories = (0,src_utils/* withInView */.Dh)(CollectionCategories_theme_themed(function(param) {
    var cms = param.cms;
    var categories = cms.categories, name = cms.name, collapsed = cms.collapsed;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* CollectionCategories */.g0, {
        name: name,
        categories: categories,
        collapsed: collapsed
    });
}), {
    triggerOnce: true
});
CollectionCategories.displayName = "CollectionCategories";
CollectionCategories.Schema = CollectionCategories_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/CollectionCategories/index.js


// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(86677);
// EXTERNAL MODULE: ./src/store/index.js + 12 modules
var store = __webpack_require__(27695);
// EXTERNAL MODULE: ./src/hooks/index.js + 64 modules
var hooks = __webpack_require__(74424);
// EXTERNAL MODULE: ./src/templates/collection/CollectionGrid/index.js + 10 modules
var CollectionGrid = __webpack_require__(6469);
;// CONCATENATED MODULE: ./src/sections/CollectionGrid/CollectionGrid.schema.js
function CollectionGrid_schema_Schema(param) {
    var collection = param.collection;
    if (collection) return null;
    return {
        label: "Collection Grid",
        key: "collection-grid",
        fields: [
            {
                component: "group-list",
                name: "products",
                label: "Products",
                itemProps: {
                    label: "{{item.product.handle}}" || 0
                },
                fields: [
                    {
                        component: "productSearch",
                        name: "product",
                        label: "Product"
                    }, 
                ]
            }, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/CollectionGrid/CollectionGrid.jsx







function CollectionGrid_CollectionGrid(param) {
    var cms = param.cms;
    var asPath = (0,next_router.useRouter)().asPath;
    var products = cms.products;
    var gatedPage = (0,store/* useRecoilValue */.sJ)(store/* default.gatedPage */.ZP.gatedPage);
    var gatedProducts = (0,hooks/* useGatedProduct */.sC)({
        gatedPage: gatedPage,
        currentUrl: asPath === null || asPath === void 0 ? void 0 : asPath.split("?")[0]
    }).gatedProducts;
    products = products === null || products === void 0 ? void 0 : products.map(function(param) {
        var product = param.product;
        return product;
    });
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Container */.W2, {
        "data-comp": CollectionGrid_CollectionGrid.displayName,
        sx: {
            variant: "layout.content"
        },
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(CollectionGrid/* CollectionGrid */.U, {
            products: gatedProducts || products,
            hasInitialProducts: products,
            gatedPage: gatedPage
        })
    });
}
CollectionGrid_CollectionGrid.displayName = "CollectionGrid";
CollectionGrid_CollectionGrid.Schema = CollectionGrid_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/CollectionGrid/index.js


// EXTERNAL MODULE: ./src/utils/common.js
var utils_common = __webpack_require__(57795);
// EXTERNAL MODULE: ./src/theme/theme.space.js
var theme_space = __webpack_require__(58486);
;// CONCATENATED MODULE: ./src/sections/CollectionHero/CollectionHero.theme.js

var CollectionHero_theme_themed = (0,create/* create */.U)(new function() {
    this.image = {
        position: "absolute",
        width: "100%",
        height: "100%",
        top: 0,
        left: 0,
        bottom: 0,
        right: 0
    };
    this.contentWrapper = {
        display: "flex",
        flexDirection: "column",
        height: "100%",
        pointerEvents: "none",
        position: "relative",
        width: "100%"
    };
    this.content = {
        px: [
            12,
            15
        ],
        py: [
            15,
            17
        ],
        pointerEvents: "auto",
        "@media only screen and (max-width: 479px)": {
            px: 10
        }
    };
    this.heading = {
        variant: "text.h2",
        m: 0
    };
    this.subheading = {
        variant: "text.lg"
    };
}());

;// CONCATENATED MODULE: ./src/sections/CollectionHero/Content.jsx










var Content_Content = CollectionHero_theme_themed(function(param) {
    var theme = param.theme, text = param.text, content = param.content, showBreadCrumb = param.showBreadCrumb;
    var textAlign = [
        content === null || content === void 0 ? void 0 : content.alignment,
        content === null || content === void 0 ? void 0 : content.alignmentDt
    ];
    var collection = (0,dist.useCollection)();
    // Mobile content position
    var posMb = (0,react.useMemo)(function() {
        return (0,utils_common/* parseContentPosition */.M0)(content === null || content === void 0 ? void 0 : content.position);
    }, [
        content === null || content === void 0 ? void 0 : content.position
    ]);
    // Desktop content position
    var posDt = (0,react.useMemo)(function() {
        return (0,utils_common/* parseContentPosition */.M0)(content === null || content === void 0 ? void 0 : content.positionDt);
    }, [
        content === null || content === void 0 ? void 0 : content.positionDt
    ]);
    var breadJustifyContent = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3;
        return [
            (ref1 = content === null || content === void 0 ? void 0 : (ref = content.alignment) === null || ref === void 0 ? void 0 : ref.replace("left", "start")) === null || ref1 === void 0 ? void 0 : ref1.replace("right", "end"),
            (ref3 = content === null || content === void 0 ? void 0 : (ref2 = content.alignmentDt) === null || ref2 === void 0 ? void 0 : ref2.replace("left", "start")) === null || ref3 === void 0 ? void 0 : ref3.replace("right", "end"), 
        ];
    }, [
        content === null || content === void 0 ? void 0 : content.alignment,
        content === null || content === void 0 ? void 0 : content.alignmentDt
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
        "data-comp": Content_Content.displayName,
        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.contentWrapper), {
            alignItems: [
                posMb.alignItems,
                posDt.alignItems
            ],
            justifyContent: [
                posMb.justifyContent,
                posDt.justifyContent
            ]
        }),
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
            sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.content), {
                maxWidth: (content === null || content === void 0 ? void 0 : content.maxWidth) ? [
                    content.maxWidth + theme_space/* space.12 */.D[12] * 2,
                    content.maxWidth + theme_space/* space.15 */.D[15] * 2, 
                ] : "none"
            }),
            children: [
                (collection === null || collection === void 0 ? void 0 : collection.handle) && !!showBreadCrumb && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                    sx: {
                        mx: [
                            -8,
                            -10,
                            -11,
                            -80
                        ],
                        alignItems: [
                            posMb.alignItems,
                            posDt.alignItems
                        ],
                        justifyContent: breadJustifyContent,
                        textAlign: textAlign
                    },
                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Breadcrumbs */.Oo, {
                        isCollection: true,
                        collectionTitle: (collection === null || collection === void 0 ? void 0 : collection.title) || ""
                    })
                }),
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Markdown */.UG, {
                    text: text === null || text === void 0 ? void 0 : text.heading,
                    textSx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.heading), {
                        textAlign: textAlign
                    }),
                    sx: {
                        mb: (text === null || text === void 0 ? void 0 : text.subheading) ? [
                            4,
                            6
                        ] : 0
                    }
                }),
                (text === null || text === void 0 ? void 0 : text.subheading) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Markdown */.UG, {
                    text: text === null || text === void 0 ? void 0 : text.subheading,
                    textSx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.subheading), {
                        textAlign: textAlign
                    })
                })
            ]
        })
    });
});
Content_Content.displayName = "Content";

;// CONCATENATED MODULE: ./src/sections/CollectionHero/Image.jsx



var CollectionHero_Image_Image = CollectionHero_theme_themed(function(param) {
    var theme = param.theme, image = param.image;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var mobileImg = image === null || image === void 0 ? void 0 : (ref = image.image) === null || ref === void 0 ? void 0 : ref.src;
    var desktopImg = image === null || image === void 0 ? void 0 : (ref1 = image.imageDt) === null || ref1 === void 0 ? void 0 : ref1.src;
    return mobileImg || desktopImg ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Picture */.t, {
        "data-comp": CollectionHero_Image_Image.displayName,
        alt: image === null || image === void 0 ? void 0 : image.alt,
        aboveTheFold: true,
        images: [
            {
                src: mobileImg,
                width: 768,
                ratio: (image === null || image === void 0 ? void 0 : (ref2 = image.image) === null || ref2 === void 0 ? void 0 : ref2.ratio) || 1.2
            },
            {
                src: desktopImg,
                width: 1024,
                ratio: (image === null || image === void 0 ? void 0 : (ref3 = image.imageDt) === null || ref3 === void 0 ? void 0 : ref3.ratio) || 1.2
            },
            {
                src: desktopImg,
                width: 1280,
                ratio: (image === null || image === void 0 ? void 0 : (ref4 = image.imageDt) === null || ref4 === void 0 ? void 0 : ref4.ratio) || 1.2
            },
            {
                src: desktopImg,
                width: 1440,
                ratio: (image === null || image === void 0 ? void 0 : (ref5 = image.imageDt) === null || ref5 === void 0 ? void 0 : ref5.ratio) || 1.2
            }, 
        ],
        sx: theme.image,
        imageSx: {
            objectPosition: [
                image === null || image === void 0 ? void 0 : image.position,
                image === null || image === void 0 ? void 0 : image.positionDt
            ]
        }
    }) : null;
});
CollectionHero_Image_Image.displayName = "Image";

;// CONCATENATED MODULE: ./src/sections/CollectionHero/CollectionHero.schema.js



var CollectionHero_schema_image = function(param) {
    var position = param.position;
    return {
        label: "Image Settings",
        name: "image",
        description: "Image, image position",
        component: "group",
        fields: [
            {
                name: "alt",
                component: "text",
                description: "Brief description of image for accessibility compliance",
                label: "Alt"
            },
            {
                name: "image",
                label: "Image (mobile)",
                component: "image"
            },
            {
                name: "position",
                component: "select",
                label: "Image position (mobile)",
                options: position.object
            },
            {
                name: "imageDt",
                label: "Image (desktop)",
                component: "image"
            },
            {
                name: "positionDt",
                component: "select",
                label: "Image position (desktop)",
                options: position.object
            }, 
        ],
        defaultValue: {
            alt: "Hero image",
            position: "center center",
            positionDt: "center center"
        }
    };
};
var CollectionHero_schema_text = function() {
    return {
        label: "Text Settings",
        name: "text",
        description: "Heading, subheading",
        component: "group",
        fields: [
            {
                name: "heading",
                component: "markdown",
                label: "Heading",
                description: 'Ensure heading is "H1" by starting with "# " e.g. "# Shop All". Text below will become large and bold to indicate "H1".'
            },
            {
                name: "subheading",
                component: "markdown",
                label: "Subheading"
            }, 
        ],
        defaultValue: {
            heading: "# Collection",
            subheading: ""
        }
    };
};
var content = function(param) {
    var position = param.position;
    return {
        label: "Content Settings",
        name: "content",
        description: "Content alignment, content position",
        component: "group",
        fields: [
            {
                name: "alignment",
                label: "Content alignment (mobile)",
                component: "radio-group",
                direction: "horizontal",
                variant: "radio",
                options: common/* align.options */.AJ.options
            },
            {
                name: "position",
                component: "select",
                label: "Content position (mobile)",
                options: position.flex
            },
            {
                name: "alignmentDt",
                label: "Content alignment (desktop)",
                component: "radio-group",
                direction: "horizontal",
                variant: "radio",
                options: common/* align.options */.AJ.options
            },
            {
                name: "positionDt",
                component: "select",
                label: "Content position (desktop)",
                options: position.flex
            },
            {
                name: "maxWidth",
                component: "number",
                label: "Max content pixel width"
            }, 
        ],
        defaultValue: {
            alignment: "center",
            position: "center center",
            alignmentDt: "center",
            positionDt: "center center",
            maxWidth: 600
        }
    };
};
function CollectionHero_schema_Schema(param) {
    var collection = param.collection;
    if (!collection) return null;
    return {
        label: "Collection Hero",
        key: "collection-hero",
        fields: [
            CollectionHero_schema_image({
                position: common/* position */.FK
            }),
            CollectionHero_schema_text({
                color: common/* color */.$_
            }),
            content({
                position: common/* position */.FK
            }),
            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, common/* sectionWithHeight */.Z1), {
                defaultValue: {
                    bgColor: common/* color.value.dark */.$_.value.dark,
                    color: common/* color.value.white */.$_.value.white,
                    mobile: {
                        container: "container",
                        mt: "none",
                        py: "none",
                        maxHeight: 200,
                        minHeight: 200
                    },
                    desktop: {
                        container: "container",
                        mt: "none",
                        py: "none",
                        maxHeight: 380,
                        minHeight: 380
                    }
                }
            }), 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/CollectionHero/CollectionHero.jsx









var CollectionHero = (0,src_utils/* withInView */.Dh)(CollectionHero_theme_themed(function(param) {
    var cms = param.cms;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var section = cms.section, image = cms.image, text = cms.text, content = cms.content, _showBreadCrumb = cms.showBreadCrumb, showBreadCrumb = _showBreadCrumb === void 0 ? false : _showBreadCrumb;
    var height = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3;
        return [
            (section === null || section === void 0 ? void 0 : (ref = section.mobile) === null || ref === void 0 ? void 0 : ref.maxHeight) ? (0,src_utils/* calcResponsiveHeight */.ku)({
                maxHeight: section === null || section === void 0 ? void 0 : (ref1 = section.mobile) === null || ref1 === void 0 ? void 0 : ref1.maxHeight,
                viewport: 768
            }) : "auto",
            (section === null || section === void 0 ? void 0 : (ref2 = section.desktop) === null || ref2 === void 0 ? void 0 : ref2.maxHeight) ? (0,src_utils/* calcResponsiveHeight */.ku)({
                maxHeight: section === null || section === void 0 ? void 0 : (ref3 = section.desktop) === null || ref3 === void 0 ? void 0 : ref3.maxHeight,
                viewport: 1280
            }) : "auto", 
        ];
    }, [
        section === null || section === void 0 ? void 0 : (ref = section.mobile) === null || ref === void 0 ? void 0 : ref.maxHeight,
        section === null || section === void 0 ? void 0 : (ref1 = section.desktop) === null || ref1 === void 0 ? void 0 : ref1.maxHeight
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Section */.$0, {
        section: section,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Container */.W2, {
            "data-comp": CollectionHero.displayName,
            sx: {
                height: height,
                minHeight: [
                    "".concat(section === null || section === void 0 ? void 0 : (ref2 = section.mobile) === null || ref2 === void 0 ? void 0 : ref2.minHeight, "px"),
                    "".concat(section === null || section === void 0 ? void 0 : (ref3 = section.desktop) === null || ref3 === void 0 ? void 0 : ref3.minHeight, "px"), 
                ],
                maxHeight: [
                    "".concat(section === null || section === void 0 ? void 0 : (ref4 = section.mobile) === null || ref4 === void 0 ? void 0 : ref4.maxHeight, "px"),
                    "".concat(section === null || section === void 0 ? void 0 : (ref5 = section.desktop) === null || ref5 === void 0 ? void 0 : ref5.maxHeight, "px"), 
                ]
            },
            children: [
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(CollectionHero_Image_Image, {
                    image: image
                }),
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Content_Content, {
                    text: text,
                    content: content,
                    showBreadCrumb: showBreadCrumb
                })
            ]
        })
    });
}), {
    triggerOnce: true
});
CollectionHero.displayName = "CollectionHero";
CollectionHero.Schema = CollectionHero_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/CollectionHero/index.js


;// CONCATENATED MODULE: ./src/sections/FeaturedArticle/Content/Content.theme.js



var Content_Content_theme_themed = (0,create/* create */.U)(new function() {
    this.outer = {
        width: "100%",
        justifyContent: "center",
        alignItems: "flex-start",
        py: [
            12,
            0
        ],
        px: [
            0,
            11
        ],
        "@media only screen and (max-width: 479px)": {
            py: 6
        }
    };
    this.innerLeft = {
        variant: "flex.column",
        width: "100%",
        alignItems: "flex-start"
    };
    this.innerRight = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this.innerLeft), {
        alignItems: "flex-end"
    });
    this.innerCenter = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this.innerLeft), {
        alignItems: "center"
    });
    this.date = {
        variant: "text.body"
    };
    this.heading = {
        variant: "text.articleTitle",
        fontSize: "28px",
        lineHeight: "32px",
        maxWidth: 300,
        overflowWrap: "break-word",
        mt: 3
    };
    this.excerpt = {
        variant: "text.base",
        mt: 3
    };
    this.readMore = {
        mt: 3
    };
}());

;// CONCATENATED MODULE: ./src/sections/FeaturedArticle/Content/Content.jsx








var Content_Content_Content = Content_Content_theme_themed(function(param) {
    var theme = param.theme, content = param.content;
    var textAlign = [
        content === null || content === void 0 ? void 0 : content.alignment,
        content === null || content === void 0 ? void 0 : content.alignmentDt
    ];
    var flexAlign = textAlign.map(function(align) {
        return (0,utils_common/* convertAlignToFlex */.nG)(align);
    });
    var ref = (0,_sliced_to_array/* default */.Z)(new Date(Date.parse((content === null || content === void 0 ? void 0 : content._createdAt) || (content === null || content === void 0 ? void 0 : content.createdAt))).toString().split(" "), 4), month = ref[1], day = ref[2], year = ref[3];
    var date = "".concat(month, " ").concat(day, ", ").concat(year);
    var excerpt = content === null || content === void 0 ? void 0 : content.excerpt;
    var slicedExcerpt = excerpt.length > 80 ? "".concat(excerpt.slice(0, excerpt.indexOf(" ", 60)), "...") : excerpt;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
        "data-comp": Content_Content_Content.displayName,
        sx: theme.outer,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
            sx: {
                variant: "flex.column",
                width: "100%",
                alignItems: flexAlign
            },
            children: [
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Paragraph */.nv, {
                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.date), {
                        textAlign: textAlign
                    }),
                    children: [
                        content === null || content === void 0 ? void 0 : content.author,
                        " | ",
                        date
                    ]
                }),
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                    as: "h4",
                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.heading), {
                        textAlign: textAlign
                    }),
                    children: content === null || content === void 0 ? void 0 : content.title
                }),
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.excerpt), {
                        textAlign: textAlign
                    }),
                    children: slicedExcerpt
                }),
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Link */.rU, {
                    variant: "buttons.".concat((content === null || content === void 0 ? void 0 : content.ctaStyle) || "articleLink"),
                    href: "articles/".concat(content === null || content === void 0 ? void 0 : content.handle),
                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.readMore), {
                        alignSelf: flexAlign
                    }),
                    children: (content === null || content === void 0 ? void 0 : content.linkText) || "Read More"
                })
            ]
        })
    });
});
Content_Content_Content.displayName = "Content";

;// CONCATENATED MODULE: ./src/sections/FeaturedArticle/Content/index.js


;// CONCATENATED MODULE: ./src/sections/FeaturedArticle/Image/Image.theme.js

var Image_Image_theme_themed = (0,create/* create */.U)(new function() {
    this.image = {
        position: "absolute",
        width: "100%",
        height: "100%",
        top: 0,
        left: 0,
        bottom: 0,
        right: 0
    };
}());

;// CONCATENATED MODULE: ./src/sections/FeaturedArticle/Image/Image.jsx





var Image_Image_Image = Image_Image_theme_themed(function(param) {
    var theme = param.theme, alt = param.alt, image = param.image;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Image */.Ee, {
        src: image,
        alt: "Blog post image",
        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.image), {
            objectFit: "cover",
            width: "100%",
            objectPosition: [
                image === null || image === void 0 ? void 0 : image.position,
                image === null || image === void 0 ? void 0 : image.positionDt
            ]
        })
    });
});
Image_Image_Image.displayName = "Image";

;// CONCATENATED MODULE: ./src/sections/FeaturedArticle/Image/index.js


;// CONCATENATED MODULE: ./src/sections/FeaturedArticle/FeaturedArticle.schema.js



function FeaturedArticle_schema_Schema(param) {
    var blog = param.blog;
    if (!blog) return null;
    return {
        label: "Featured Article",
        key: "featured-article",
        fields: [
            {
                label: "Article handle",
                name: "articleHandle",
                component: "text",
                description: "Provide the handle of the article to feature."
            },
            {
                label: "Hide on mobile",
                name: "hideMobile",
                component: "toggle",
                description: "Optional: Hide the featured article on mobile. This can be useful to prevent duplicate articles",
                toggleLabels: {
                    true: "Visible",
                    false: "Hidden"
                },
                defaultValue: false
            },
            {
                label: "Image Settings",
                name: "image",
                description: "Image, position, placement, aspect ratio",
                component: "group",
                fields: [
                    {
                        label: "Placement",
                        component: "radio-group",
                        direction: "horizontal",
                        variant: "radio",
                        name: "locationDt",
                        options: [
                            {
                                value: "left",
                                label: "Left"
                            },
                            {
                                value: "right",
                                label: "Right"
                            }, 
                        ]
                    },
                    {
                        label: "Image position",
                        name: "positionDt",
                        component: "select",
                        options: common/* position.object */.FK.object
                    },
                    {
                        label: "Placement (mobile)",
                        name: "location",
                        component: "radio-group",
                        direction: "horizontal",
                        variant: "radio",
                        options: [
                            {
                                value: "top",
                                label: "Top"
                            },
                            {
                                value: "bottom",
                                label: "Bottom"
                            }, 
                        ]
                    },
                    {
                        name: "position",
                        component: "select",
                        label: "Image position (mobile)",
                        options: common/* position.object */.FK.object
                    }, 
                ],
                defaultValue: {
                    positionDt: "center center",
                    locationDt: "left",
                    location: "top",
                    position: "center center"
                }
            },
            {
                label: "Content Settings",
                name: "content",
                description: "Link style, content alignment",
                component: "group",
                fields: [
                    {
                        label: "Full article link text",
                        name: "linkText",
                        component: "text"
                    },
                    {
                        name: "ctaStyle",
                        label: "Link Style",
                        component: "select",
                        options: common/* button.options */.LI.options
                    },
                    {
                        label: "Content alignment (desktop)",
                        name: "alignmentDt",
                        component: "radio-group",
                        direction: "horizontal",
                        variant: "radio",
                        options: common/* align.options */.AJ.options
                    },
                    {
                        label: "Content alignment (mobile)",
                        name: "alignment",
                        component: "radio-group",
                        direction: "horizontal",
                        variant: "radio",
                        options: common/* align.options */.AJ.options
                    }, 
                ],
                defaultValue: {
                    linkText: "Read more",
                    ctaStyle: "articleLink",
                    alignmentDt: common/* align.value.left */.AJ.value.left,
                    alignment: common/* align.value.left */.AJ.value.left
                }
            },
            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, common/* sectionWithHeight */.Z1), {
                defaultValue: {
                    desktop: {
                        container: "content",
                        mt: "l",
                        minHeight: 460
                    },
                    mobile: {
                        container: "content",
                        mt: "s"
                    }
                }
            }), 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/FeaturedArticle/FeaturedArticle.theme.js

var FeaturedArticle_theme_themed = (0,create/* create */.U)(new function() {
    this.grid = {
        position: "relative",
        display: "grid",
        gridGap: [
            0,
            0,
            3
        ]
    };
    this.media = {
        gridArea: "media",
        position: "relative",
        width: "100%",
        height: "100%",
        overflow: "hidden"
    };
    this.content = {
        gridArea: "content",
        display: "flex",
        position: "relative",
        width: "100%",
        height: "100%"
    };
}());

;// CONCATENATED MODULE: ./src/sections/FeaturedArticle/FeaturedArticle.jsx
/* eslint-disable consistent-return */ 











var FeaturedArticle = (0,src_utils/* withInView */.Dh)(FeaturedArticle_theme_themed(function(param) {
    var theme = param.theme, cms = param.cms;
    var ref, ref1, ref2, ref3;
    var articleHandle = cms.articleHandle, hideMobile = cms.hideMobile, image = cms.image, content = cms.content, section = cms.section;
    var blog = (0,dist.useBlog)();
    var matchedArticle = Object.values((0,_object_spread/* default */.Z)({}, blog === null || blog === void 0 ? void 0 : blog.articles)).find(function(article) {
        return article.handle === articleHandle;
    });
    // Fall back scaffolding.
    var articleObj = !matchedArticle ? {
        title: "ERROR!",
        image: "https://cdn.shopify.com/s/files/1/1114/2308/files/brumate-blog-placeholder.jpg",
        author: "Platform Error",
        _createdAt: "February 04, 2022",
        excerpt: "ERROR: Handle invalid."
    } : matchedArticle;
    var imageLeft = (image === null || image === void 0 ? void 0 : image.locationDt) === "left"; // mobile
    var imageTop = (image === null || image === void 0 ? void 0 : image.location) === "top"; // desktop
    var gridTemplateAreas = imageLeft ? [
        "1fr",
        "2fr 1fr"
    ] : [
        "1fr",
        "1fr 2fr"
    ];
    // Commented for now while imported featured images are figured out.
    // const featuredImage = {
    //   ...image,
    //   ...articleObj,
    // };
    var contentObj = (0,_object_spread/* default */.Z)({}, content, articleObj);
    var articleImage = (0,react.useMemo)(function() {
        var ref;
        if (!matchedArticle) return null;
        if ((ref = matchedArticle.seo) === null || ref === void 0 ? void 0 : ref.image) return matchedArticle.seo.image;
        var body = matchedArticle.bodyHtml;
        return body ? "https://".concat(body.slice(body.indexOf("cdn"), body.indexOf(".jpg")), ".jpg") : "https://cdn.shopify.com/s/files/1/1114/2308/files/brumate-blog-placeholder.jpg?v=1660081495";
    }, [
        matchedArticle
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Section */.$0, {
        section: section,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Container */.W2, {
            "data-comp": FeaturedArticle.displayName,
            sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.grid), {
                display: [
                    hideMobile ? "grid" : "none",
                    "grid"
                ],
                gridTemplateAreas: [
                    imageTop ? '"media" "content"' : '"content" "media"',
                    imageLeft ? '"media content"' : '"content media"', 
                ],
                gridTemplateColumns: gridTemplateAreas,
                minHeight: [
                    section === null || section === void 0 ? void 0 : (ref = section.mobile) === null || ref === void 0 ? void 0 : ref.minHeight,
                    section === null || section === void 0 ? void 0 : (ref1 = section.desktop) === null || ref1 === void 0 ? void 0 : ref1.minHeight, 
                ],
                maxHeight: [
                    section === null || section === void 0 ? void 0 : (ref2 = section.mobile) === null || ref2 === void 0 ? void 0 : ref2.maxHeight,
                    section === null || section === void 0 ? void 0 : (ref3 = section.desktop) === null || ref3 === void 0 ? void 0 : ref3.maxHeight, 
                ]
            }),
            children: [
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Link */.rU, {
                    href: matchedArticle ? "/articles/".concat(matchedArticle.handle) : "",
                    "aria-label": matchedArticle === null || matchedArticle === void 0 ? void 0 : matchedArticle.title,
                    sx: theme.media,
                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Image_Image_Image, {
                        image: articleImage
                    })
                }),
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.content), {
                        justifyContent: imageLeft ? "flex-start" : "flex-end",
                        ":before": {
                            content: '""',
                            float: "left"
                        }
                    }),
                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Content_Content_Content, {
                        content: contentObj
                    })
                })
            ]
        })
    });
}), {
    renderOnce: true
});
FeaturedArticle.displayName = "FeaturedArticle";
FeaturedArticle.Schema = FeaturedArticle_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/FeaturedArticle/index.js


;// CONCATENATED MODULE: ./src/sections/FeaturedThreeTile/FeaturedThreeTile.schema.js



function FeaturedThreeTile_schema_Schema(param) {
    var article = param.article, blog = param.blog, collection = param.collection;
    if (article || blog || collection) return null;
    var defaultTiles = [
        {
            alt: "Woman in a red dress sitting on a couch.",
            image: {
                src: "https://cdn.shopify.com/s/files/1/1114/2308/files/ValentinesTile.png"
            },
            cta: {
                text: "Valentines day gift guide",
                url: "/collections/all"
            },
            style: common/* button.value.inverse */.LI.value.inverse
        },
        {
            alt: "Woman holding a brumate MUV.",
            image: {
                src: "https://cdn.shopify.com/s/files/1/1114/2308/files/MuvTile_d1b8fb12-b0f2-43b5-a0d2-7f8536c976be.png"
            },
            cta: {
                text: "M\xdcV Collection",
                url: "/collections/all"
            },
            style: common/* button.value.inverse */.LI.value.inverse
        },
        {
            alt: "A canned beverage sitting inside of a Brumate Hopsulator.",
            image: {
                src: "https://cdn.shopify.com/s/files/1/1114/2308/files/HopsTile.png"
            },
            cta: {
                text: "Deals & Steals",
                url: "/collections/all"
            },
            style: common/* button.value.inverse */.LI.value.inverse
        }, 
    ];
    return {
        label: "Featured Three Tile",
        key: "featured-three-tile",
        fields: [
            {
                name: "tiles",
                label: "Tiles",
                description: "Max of 3 tiles",
                component: "group-list",
                itemProps: {
                    label: "{{item.cta.text}}"
                },
                defaultItem: {
                    alt: "Woman in a red dress sitting on a couch.",
                    image: {
                        src: "https://cdn.shopify.com/s/files/1/1114/2308/files/RedVelvetTile.png"
                    },
                    overlay: true,
                    cta: {
                        text: "valentines day gift guide",
                        url: "/collections/all"
                    },
                    style: common/* button.value.inverse */.LI.value.inverse
                },
                validate: {
                    maxItems: 3
                },
                fields: [
                    {
                        name: "alt",
                        label: "Image Alt",
                        component: "text",
                        description: "Provide a brief description of the image for accessibility compliance"
                    },
                    {
                        name: "image",
                        label: "Image",
                        component: "image"
                    },
                    {
                        label: "Link",
                        name: "cta",
                        component: "link"
                    },
                    {
                        name: "style",
                        label: "Link style",
                        component: "select",
                        options: common/* button.options */.LI.options
                    }, 
                ],
                defaultValue: defaultTiles
            },
            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, common/* section */.qi), {
                defaultValue: {
                    bgColor: common/* color.value.background */.$_.value.background,
                    color: common/* color.value.text */.$_.value.text,
                    desktop: {
                        container: "content",
                        mt: "none",
                        py: "xs"
                    },
                    mobile: {
                        container: "container",
                        mt: "none",
                        py: "xs"
                    }
                }
            }), 
        ]
    };
}

// EXTERNAL MODULE: ../node_modules/swiper/esm/react/swiper.js + 8 modules
var react_swiper = __webpack_require__(48148);
// EXTERNAL MODULE: ../node_modules/swiper/esm/react/swiper-slide.js
var swiper_slide = __webpack_require__(95445);
;// CONCATENATED MODULE: ./src/sections/FeaturedThreeTile/Slider/Slider.theme.js

var Slider_theme_themed = (0,create/* create */.U)(new function() {
    this.swiper = {
        ".swiper-container": {
            cursor: [
                "grab",
                "auto"
            ],
            pl: [
                "16px",
                "unset"
            ]
        },
        ".swiper-container, .swiper-wrapper": {
            height: "auto !important",
            width: "100%"
        },
        ".swiper-slide": {
            height: "auto !important",
            width: "100%",
            ":before": {
                content: '""',
                pb: "".concat(1 / 0.75 * 100, "%"),
                float: "left"
            }
        }
    };
}());

;// CONCATENATED MODULE: ./src/sections/FeaturedThreeTile/Slider/useSliderParams.js

var useSliderParams = function() {
    var defaultParams = (0,react.useMemo)(function() {
        return {
            spaceBetween: 16,
            slidesPerView: 1.3,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 16,
            slidesPerGroup: 1,
            centeredSlides: false,
            centeredSlidesBounds: true,
            centerInsufficientSlides: true,
            autoHeight: true,
            navigation: false,
            loop: false,
            watchOverflow: true,
            breakpoints: {
                480: {
                    spaceBetween: 16,
                    slidesPerView: 1.3,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 16,
                    slidesPerGroup: 1,
                    centeredSlides: false,
                    centeredSlidesBounds: true,
                    centerInsufficientSlides: true
                },
                600: {
                    spaceBetween: 16,
                    slidesPerView: 2.4,
                    slidesOffsetBefore: 16,
                    slidesOffsetAfter: 16,
                    slidesPerGroup: 1,
                    centeredSlides: false,
                    centeredSlidesBounds: true,
                    centerInsufficientSlides: true
                },
                768: {
                    spaceBetween: 20,
                    slidesPerView: 3,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0,
                    slidesPerGroup: 1,
                    centeredSlides: false,
                    centeredSlidesBounds: false,
                    centerInsufficientSlides: true
                },
                1024: {
                    spaceBetween: 20,
                    slidesPerView: 3,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0,
                    slidesPerGroup: 1,
                    centeredSlides: false,
                    centeredSlidesBounds: false,
                    centerInsufficientSlides: true
                },
                1280: {
                    spaceBetween: 20,
                    slidesPerView: 3,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0,
                    slidesPerGroup: 1,
                    centeredSlides: false,
                    centeredSlidesBounds: false,
                    centerInsufficientSlides: true
                }
            }
        };
    }, []);
    return defaultParams;
};

;// CONCATENATED MODULE: ./src/sections/FeaturedThreeTile/Tile/Tile.theme.js



var Tile_Tile_theme_themed = (0,create/* create */.U)(new function() {
    this.image = {
        position: "relative"
    };
    this.imageLink = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this.image), {
        ":hover": {
            img: {
                pointerEvents: "none",
                transform: "scale3d(1.03, 1.03, 1.03)"
            }
        },
        img: {
            transform: "scale3d(1.01, 1.01, 1.01)",
            transition: "transform 0.3s ease-in-out"
        }
    });
    this.button = {
        position: "absolute",
        width: "fit-content",
        bottom: [
            10,
            30
        ],
        left: "50%",
        transform: "translate3d(-50%, -50%, 0)",
        pointerEvents: "auto"
    };
}());

;// CONCATENATED MODULE: ./src/sections/FeaturedThreeTile/Tile/Tile.jsx







var Tile_Tile = Tile_Tile_theme_themed(function(_param) {
    var theme = _param.theme, item = _param.item, inputRef = _param.inputRef, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme",
        "item",
        "inputRef"
    ]);
    var alt = item.alt, image = item.image, cta = item.cta, style = item.style;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-comp": Tile_Tile.displayName
    }, props), {
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(snippets/* Link */.rU, {
            href: cta === null || cta === void 0 ? void 0 : cta.url,
            newTab: cta === null || cta === void 0 ? void 0 : cta.newTab,
            sx: (cta === null || cta === void 0 ? void 0 : cta.url) ? theme.imageLink : theme.image,
            children: [
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Picture */.t, {
                    alt: alt,
                    images: [
                        {
                            src: image === null || image === void 0 ? void 0 : image.src,
                            ratio: 0.75
                        }, 
                    ]
                }),
                (cta === null || cta === void 0 ? void 0 : cta.text) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                    variant: "buttons.".concat(style || "inverse"),
                    sx: theme.button,
                    children: cta === null || cta === void 0 ? void 0 : cta.text
                })
            ]
        })
    }));
});
Tile_Tile.displayName = "Tile";

;// CONCATENATED MODULE: ./src/sections/FeaturedThreeTile/Tile/index.js


;// CONCATENATED MODULE: ./src/sections/FeaturedThreeTile/Slider/Slider.jsx









var Slider = Slider_theme_themed(function(param) {
    var theme = param.theme, tiles = param.tiles;
    var ref = (0,react.useState)(), swiper = ref[0], setSwiper = ref[1];
    var defaultParams = useSliderParams();
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Container */.W2, {
        "data-comp": Slider.displayName,
        sx: theme.swiper,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(react_swiper/* Swiper */.t, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            onSwiper: setSwiper
        }, defaultParams), {
            children: tiles === null || tiles === void 0 ? void 0 : tiles.slice(0, 3).map(function(item, index) {
                return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(swiper_slide/* SwiperSlide */.o, {
                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Tile_Tile, {
                        item: item
                    })
                }, index);
            })
        }))
    });
});
Slider.displayName = "Slider";

;// CONCATENATED MODULE: ./src/sections/FeaturedThreeTile/Slider/index.js


;// CONCATENATED MODULE: ./src/sections/FeaturedThreeTile/FeaturedThreeTile.jsx






var FeaturedThreeTile = (0,src_utils/* withInView */.Dh)(function(param) {
    var cms = param.cms;
    var section = cms.section, tiles = cms.tiles;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Section */.$0, {
        section: section,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Container */.W2, {
            "data-comp": FeaturedThreeTile.displayName,
            children: (tiles === null || tiles === void 0 ? void 0 : tiles.length) > 0 && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Slider, {
                tiles: tiles
            })
        })
    });
}, {
    triggerOnce: true
});
FeaturedThreeTile.displayName = "FeaturedThreeTile";
FeaturedThreeTile.Schema = FeaturedThreeTile_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/FeaturedThreeTile/index.js


;// CONCATENATED MODULE: ./src/sections/FeaturedTwoTile/FeaturedTwoTile.schema.js




var FeaturedTwoTile_schema_Schema = function() {
    return {
        label: "Featured Two Tile",
        key: "featuredTwoTile",
        fields: [
            {
                name: "tiles",
                label: "Tiles",
                description: "Image, heading, description, link, settings. Note: Max of 2 tiles",
                component: "group-list",
                itemProps: {
                    label: "{{item.heading}}"
                },
                defaultItem: {
                    heading: "For the adventurer",
                    description: "Nulla vitae elit libero, a pharetra augue.",
                    alt: "A woman holding a cansulator.",
                    image: {
                        src: "https://cdn.shopify.com/s/files/1/1114/2308/files/FeatCollections1.png"
                    },
                    cta: {
                        text: "for the adventurer",
                        url: "/collections/all"
                    }
                },
                validate: {
                    maxItems: 2
                },
                fields: [
                    {
                        name: "heading",
                        label: "Heading",
                        component: "text"
                    },
                    {
                        name: "description",
                        label: "Description",
                        component: "markdown"
                    },
                    {
                        component: "select",
                        name: "color",
                        label: "Text color",
                        options: [
                            {
                                label: "Default",
                                value: ""
                            }
                        ].concat((0,_to_consumable_array/* default */.Z)(common/* color.options */.$_.options))
                    },
                    {
                        label: "Link",
                        name: "cta",
                        component: "link"
                    },
                    {
                        label: "Image Alt",
                        name: "alt",
                        component: "text",
                        description: "Provide a brief description of the image for accessibility compliance"
                    },
                    {
                        label: "Image",
                        name: "image",
                        component: "image"
                    },
                    {
                        label: "Optional: Image Alt (mobile)",
                        name: "altMobile",
                        component: "text",
                        description: "If using custom mobile image that is different from the desktop version, provide a brief description of the image for accessibility compliance"
                    },
                    {
                        label: "Optional: Image (mobile)",
                        name: "imageMobile",
                        component: "image"
                    }, 
                ],
                defaultValue: [
                    {
                        heading: "For the adventurer",
                        description: "Nulla vitae elit libero, a pharetra augue.",
                        cta: {
                            text: "for the adventurer",
                            url: "/collections/all"
                        },
                        alt: "A woman holding a cansulator.",
                        image: {
                            src: "https://cdn.shopify.com/s/files/1/1114/2308/files/FeatCollections1.png"
                        }
                    },
                    {
                        heading: "For the coffee lover",
                        description: "Nulla vitae elit libero, a pharetra augue.",
                        alt: "Two women enjoying their beverages in the winter.",
                        color: "Nulla vitae elit libero, a pharetra augue.",
                        image: {
                            src: "https://cdn.shopify.com/s/files/1/1114/2308/files/FeatCollections2.png"
                        },
                        cta: {
                            text: "For the coffee lover",
                            url: "/collections/all"
                        }
                    }, 
                ]
            },
            {
                label: "Tile Settings",
                name: "tile",
                description: "Image ratio, text position, text align, link style",
                component: "group",
                fields: [
                    {
                        name: "textPosition",
                        label: "Text position",
                        component: "radio-group",
                        direction: "horizontal",
                        variant: "radio",
                        options: [
                            {
                                label: "Contained",
                                value: "absolute"
                            },
                            {
                                label: "Below",
                                value: "relative"
                            }, 
                        ]
                    },
                    {
                        name: "textAlign",
                        label: "Text alignment",
                        component: "radio-group",
                        direction: "horizontal",
                        variant: "radio",
                        options: common/* align.options */.AJ.options
                    },
                    {
                        name: "imageRatio",
                        label: "Image aspect ratio (mobile)",
                        component: "radio-group",
                        direction: "horizontal",
                        variant: "radio",
                        options: [
                            {
                                label: "3:4",
                                value: "portrait"
                            },
                            {
                                label: "1:1",
                                value: "square"
                            }, 
                        ]
                    },
                    {
                        name: "imageRatioDt",
                        label: "Image aspect ratio (desktop)",
                        component: "radio-group",
                        direction: "horizontal",
                        variant: "radio",
                        options: [
                            {
                                label: "3:4",
                                value: "portrait"
                            },
                            {
                                label: "1:3",
                                value: "wide"
                            }, 
                        ]
                    },
                    {
                        name: "overlay",
                        label: "Image overlay",
                        component: "radio-group",
                        direction: "horizontal",
                        variant: "radio",
                        options: [
                            {
                                label: "None",
                                value: "none"
                            },
                            {
                                label: "Dark",
                                value: "dark"
                            }, 
                        ]
                    },
                    {
                        name: "ctaStyle",
                        label: "Link style",
                        component: "select",
                        options: common/* button.options */.LI.options
                    }, 
                ],
                defaultValue: {
                    textPosition: "relative",
                    textAlign: common/* align.value.left */.AJ.value.left,
                    imageRatio: "wide",
                    imageRatioDt: "wide",
                    overlay: "none",
                    ctaStyle: common/* button.value.secondary */.LI.value.secondary
                }
            },
            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, common/* section */.qi), {
                defaultValue: {
                    bgColor: common/* color.value.background */.$_.value.background,
                    color: common/* color.value.text */.$_.value.text,
                    mobile: {
                        container: "content",
                        mt: "s",
                        py: "none"
                    },
                    desktop: {
                        container: "content",
                        mt: "none",
                        py: "s"
                    }
                }
            }), 
        ]
    };
};

;// CONCATENATED MODULE: ./src/sections/FeaturedTwoTile/GridDisplay/GridDisplay.theme.js

var GridDisplay_theme_themed = (0,create/* create */.U)(new function() {
    this.grid = {
        display: "grid",
        gridGap: [
            10
        ],
        gridTemplateColumns: [
            "1fr",
            "repeat(2, 1fr)"
        ]
    };
    this.portrait = {
        width: "100%",
        ":before": {
            content: '""',
            pb: "".concat(1 / 0.75 * 100, "%"),
            float: "left"
        }
    };
    this.square = {
        width: "100%",
        ":before": {
            content: '""',
            pb: "100%",
            float: "left"
        }
    };
}());

;// CONCATENATED MODULE: ./src/sections/FeaturedTwoTile/Tile/Tile.theme.js



var FeaturedTwoTile_Tile_Tile_theme_themed = (0,create/* create */.U)(new function() {
    this.tile = {
        position: "relative"
    };
    this.tileLink = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this.tile), {
        img: {
            transform: "scale(1.01)",
            transition: "transform 0.3s ease-in-out"
        },
        ":hover": {
            img: {
                transform: "scale(1.03)"
            }
        }
    });
    this.contentRelative = {
        flexDirection: "column",
        position: "relative",
        py: [
            4,
            8
        ]
    };
    this.contentAbsolute = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this.contentRelative), {
        position: "absolute",
        pointerEvents: "none",
        width: "100%",
        bottom: 0,
        left: 0,
        mt: 0,
        p: [
            10,
            10,
            14
        ]
    });
    this.heading = {
        variant: "text.h3"
    };
    this.body = {
        variant: "text.lg",
        py: [
            0,
            0
        ]
    };
    this.flexed = {
        display: "flex",
        alignItems: "center",
        ":hover": {
            svg: {
                transform: "translate3d(5px, 0, 0)",
                transition: "transform 0.3s ease-in-out"
            }
        }
    };
    this.icon = {
        ml: 7,
        width: "24px"
    };
    this.button = {
        mt: 8,
        pointerEvents: "auto"
    };
}());

;// CONCATENATED MODULE: ./src/sections/FeaturedTwoTile/Tile/TileContent.jsx







var TileContent = FeaturedTwoTile_Tile_Tile_theme_themed(function(param) {
    var theme = param.theme, item = param.item, _tile = param.tile, tile = _tile === void 0 ? {} : _tile;
    var ref, ref1;
    var textAlign = tile.textAlign;
    var textColor = (item === null || item === void 0 ? void 0 : item.color) || "currentColor";
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
        "data-comp": TileContent.displayName,
        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (tile === null || tile === void 0 ? void 0 : tile.textPosition) === "relative" ? theme.contentRelative : theme.contentAbsolute), {
            alignItems: (0,src_utils/* convertAlignToFlex */.nG)(textAlign),
            textAlign: textAlign,
            color: textColor
        }),
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Link */.rU, {
                href: item === null || item === void 0 ? void 0 : (ref = item.cta) === null || ref === void 0 ? void 0 : ref.url,
                newTab: item === null || item === void 0 ? void 0 : (ref1 = item.cta) === null || ref1 === void 0 ? void 0 : ref1.newTab,
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                    sx: theme.flexed,
                    children: [
                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                            sx: theme.heading,
                            children: item === null || item === void 0 ? void 0 : item.heading
                        }),
                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Svg */.ny, {
                            src: "/svgs/arrow-right.svg#arrow-right",
                            alt: "Arrow pointing right",
                            viewBox: "0 0 24 24",
                            sx: theme.icon
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Markdown */.UG, {
                text: item === null || item === void 0 ? void 0 : item.description,
                textAlign: textAlign,
                textSx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.body), {
                    color: textColor
                })
            })
        ]
    });
});
TileContent.displayName = "TileContent";

;// CONCATENATED MODULE: ./src/sections/FeaturedTwoTile/Tile/Tile.jsx









var Tile_Tile_Tile = FeaturedTwoTile_Tile_Tile_theme_themed(function(_param) {
    var theme = _param.theme, item = _param.item, tile = _param.tile, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme",
        "item",
        "tile"
    ]);
    var ref, ref1, ref2, ref3, ref4, ref5;
    var mobileAlt = (0,hooks/* useBreakpointValue */.Sx)([
        (item === null || item === void 0 ? void 0 : item.altMobile) || (item === null || item === void 0 ? void 0 : item.alt),
        item === null || item === void 0 ? void 0 : item.alt, 
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-comp": Tile_Tile_Tile.displayName
    }, props), {
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                sx: (item === null || item === void 0 ? void 0 : (ref = item.cta) === null || ref === void 0 ? void 0 : ref.url) ? theme.tileLink : theme.tile,
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Link */.rU, {
                        href: item === null || item === void 0 ? void 0 : (ref1 = item.cta) === null || ref1 === void 0 ? void 0 : ref1.url,
                        newTab: item === null || item === void 0 ? void 0 : (ref2 = item.cta) === null || ref2 === void 0 ? void 0 : ref2.newTab,
                        tabIndex: "-1",
                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Picture */.t, {
                            alt: mobileAlt,
                            images: [
                                {
                                    src: (item === null || item === void 0 ? void 0 : (ref3 = item.imageMobile) === null || ref3 === void 0 ? void 0 : ref3.src) || (item === null || item === void 0 ? void 0 : (ref4 = item.image) === null || ref4 === void 0 ? void 0 : ref4.src),
                                    width: 768,
                                    ratio: (tile === null || tile === void 0 ? void 0 : tile.imageRatio) === "portrait" ? 0.75 : 1.5
                                },
                                {
                                    src: (ref5 = item.image) === null || ref5 === void 0 ? void 0 : ref5.src,
                                    width: 700,
                                    ratio: (tile === null || tile === void 0 ? void 0 : tile.imageRatioDt) === "portrait" ? 0.75 : 1.3
                                }, 
                            ]
                        })
                    }),
                    tile.overlay === "dark" && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                        sx: {
                            position: "absolute",
                            left: 0,
                            top: 0,
                            width: "100%",
                            height: "100%",
                            bg: "dark",
                            opacity: 0.2,
                            pointerEvents: "none"
                        }
                    }),
                    (tile === null || tile === void 0 ? void 0 : tile.textPosition) === "absolute" && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(TileContent, {
                        item: item,
                        tile: tile
                    })
                ]
            }),
            (tile === null || tile === void 0 ? void 0 : tile.textPosition) === "relative" && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(TileContent, {
                item: item,
                tile: tile
            })
        ]
    }));
});
Tile_Tile_Tile.displayName = "Tile";

;// CONCATENATED MODULE: ./src/sections/FeaturedTwoTile/Tile/index.js


;// CONCATENATED MODULE: ./src/sections/FeaturedTwoTile/GridDisplay/GridDisplay.jsx




var GridDisplay = GridDisplay_theme_themed(function(param) {
    var theme = param.theme, tiles = param.tiles, tile = param.tile;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Container */.W2, {
        "data-comp": GridDisplay.displayName,
        sx: theme.grid,
        children: tiles === null || tiles === void 0 ? void 0 : tiles.slice(0, 2).map(function(item, index) {
            return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                sx: {
                    width: "100%",
                    ":before": {
                        content: '""',
                        pb: [
                            (tile === null || tile === void 0 ? void 0 : tile.imageRatio) === "portrait" ? "".concat(1 / 0.75 * 100, "%") : "100%",
                            (tile === null || tile === void 0 ? void 0 : tile.imageRatioDt) === "portrait" ? "".concat(1 / 0.75 * 100, "%") : "100%", 
                        ],
                        float: "left"
                    }
                },
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Tile_Tile_Tile, {
                    item: item,
                    tile: tile
                })
            }, index);
        })
    });
});
GridDisplay.displayName = "GridDisplay";

;// CONCATENATED MODULE: ./src/sections/FeaturedTwoTile/GridDisplay/index.js


;// CONCATENATED MODULE: ./src/sections/FeaturedTwoTile/FeaturedTwoTile.jsx






var FeaturedTwoTile = (0,src_utils/* withInView */.Dh)(function(param) {
    var cms = param.cms;
    var section = cms.section, tiles = cms.tiles, tile = cms.tile;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Section */.$0, {
        section: section,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Container */.W2, {
            "data-comp": FeaturedTwoTile.displayName,
            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(GridDisplay, {
                tiles: tiles,
                tile: tile
            })
        })
    });
}, {
    triggerOnce: true
});
FeaturedTwoTile.displayName = "FeaturedTwoTile";
FeaturedTwoTile.Schema = FeaturedTwoTile_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/FeaturedTwoTile/index.js


;// CONCATENATED MODULE: ./src/sections/FeaturedIcons/Icons.js
var icons = {
    options: [
        {
            label: "none",
            value: "none"
        },
        {
            label: "exclusive",
            value: "/svgs/noprecache/exclusive.svg#exclusive"
        },
        {
            label: "gift",
            value: "/svgs/noprecache/gift.svg#gift"
        },
        {
            label: "next",
            value: "/svgs/noprecache/next.svg#next"
        },
        {
            label: "discount",
            value: "/svgs/noprecache/discount.svg#discount"
        }, 
    ],
    value: {
        none: "none",
        exclusive: "/svgs/noprecache/exclusive.svg#exclusive",
        gift: "/svgs/noprecache/gift.svg#gift",
        next: "/svgs/noprecache/next.svg#next",
        discount: "/svgs/noprecache/discount.svg#discount"
    }
};

;// CONCATENATED MODULE: ./src/sections/FeaturedIcons/FeaturedIcons.schema.js




function FeaturedIcons_schema_Schema() {
    return {
        label: "Featured Icons",
        key: "featured-icons",
        fields: [
            {
                label: "heading",
                name: "heading",
                component: "text",
                defaultValue: "BECOME A VIP AMBASSADOR"
            },
            {
                label: "subtitle",
                name: "subtitle",
                component: "textarea",
                defaultValue: "Be a part of a growing community of avid Br\xfcMate fans, and gain exclusive access to new product developments, color releases, charity events, contests and more! Join now"
            },
            {
                label: "Link",
                name: "cta",
                component: "link",
                defaultValue: {
                    text: "Join Now",
                    url: "/account/login"
                }
            },
            {
                label: "Content",
                name: "icons",
                description: "Set the content.",
                component: "group-list",
                itemProps: {
                    label: "{{item.text}}" || 0
                },
                defaultItem: {
                    text: "Icon Description",
                    icon: icons.value.exclusive
                },
                // each icon
                fields: [
                    {
                        label: "Icon",
                        name: "icon",
                        component: "select",
                        options: icons.options,
                        defaultValue: icons.value.exclusive
                    },
                    {
                        label: "Text",
                        name: "text",
                        component: "text",
                        defaultValue: "Place an Order"
                    }, 
                ],
                defaultValue: [
                    {
                        text: "EXCLUSIVE CHARITY EVENTS",
                        icon: icons.value.exclusive
                    },
                    {
                        text: "Weekly contests",
                        icon: icons.value.gift
                    },
                    {
                        text: "have a say un what comes next",
                        icon: icons.value.next
                    },
                    {
                        text: "15% discount for life",
                        icon: icons.value.discount
                    }, 
                ]
            },
            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, common/* section */.qi), {
                defaultValue: {
                    desktop: {
                        container: "content",
                        mt: "l"
                    },
                    mobile: {
                        container: "content",
                        mt: "s"
                    }
                }
            }), 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/FeaturedIcons/FeaturedIcons.theme.js

var FeaturedIcons_theme_themed = (0,create/* create */.U)(new function() {
    this.grid = {
        position: "relative",
        display: "grid",
        gridGap: [
            0,
            0,
            3
        ]
    };
    this.media = {
        gridArea: "media",
        position: "relative",
        width: "100%",
        height: "100%",
        maxHeight: 460,
        overflow: "hidden"
    };
    this.content = {
        gridArea: "content",
        display: "flex",
        position: "relative",
        width: "100%",
        height: "100%"
    };
}());

;// CONCATENATED MODULE: ./src/sections/FeaturedIcons/Content/Content.theme.js

var FeaturedIcons_Content_Content_theme_themed = (0,create/* create */.U)(new function() {
    this.container = {
        width: "100%",
        py: "1.75rem"
    };
    this.heading = {
        my: 5
    };
    this.text = {
        variant: "text.base",
        textAlign: "center",
        width: "100%",
        letterSpacing: 3
    };
    this.icon = {
        maxWidth: 100,
        margin: "auto",
        px: 5
    };
}());

;// CONCATENATED MODULE: ./src/sections/FeaturedIcons/Content/Content.jsx





var FeaturedIcons_Content_Content_Content = FeaturedIcons_Content_Content_theme_themed(function(param) {
    var theme = param.theme, content = param.content;
    if (!content) return null;
    var heading = content.heading, subtitle = content.subtitle, icons = content.icons, cta = content.cta;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
        "data-comp": FeaturedIcons_Content_Content_Content.displayName,
        sx: theme.container,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
            sx: {
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center"
            },
            children: [
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                    as: "h2",
                    variant: "text.h2",
                    sx: (0,_object_spread/* default */.Z)({}, theme.heading),
                    children: heading
                }),
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                    variant: "text.base",
                    children: subtitle
                }),
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                    sx: {
                        flexDirection: [
                            "column",
                            "row"
                        ],
                        my: 80
                    },
                    children: icons === null || icons === void 0 ? void 0 : icons.map(function(item, index) {
                        return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                            sx: {
                                flexDirection: "column",
                                px: 80,
                                justifyContent: "center",
                                alignItems: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Svg */.ny, {
                                    alt: item.text,
                                    src: item.icon,
                                    viewBox: "0 0 90 100",
                                    sx: theme.icon
                                }),
                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Text */.xv, {
                                    sx: theme.text,
                                    children: item.text
                                })
                            ]
                        }, item.id || index);
                    })
                }),
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Link */.rU, {
                    variant: "buttons.primary",
                    href: cta === null || cta === void 0 ? void 0 : cta.url,
                    newTab: cta === null || cta === void 0 ? void 0 : cta.newTab,
                    sx: {
                        width: "40%"
                    },
                    children: cta === null || cta === void 0 ? void 0 : cta.text
                })
            ]
        })
    });
});
FeaturedIcons_Content_Content_Content.displayName = "Content";

;// CONCATENATED MODULE: ./src/sections/FeaturedIcons/Content/index.js


;// CONCATENATED MODULE: ./src/sections/FeaturedIcons/FeaturedIcons.jsx








var FeaturedIcons = (0,src_utils/* withInView */.Dh)(FeaturedIcons_theme_themed(function(param) {
    var theme = param.theme, cms = param.cms;
    var section = cms.section;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Section */.$0, {
        section: section,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Container */.W2, {
            "data-comp": FeaturedIcons.displayName,
            sx: (0,_object_spread/* default */.Z)({}, theme.grid),
            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(FeaturedIcons_Content_Content_Content, {
                content: cms
            })
        })
    });
}), {
    renderOnce: true
});
FeaturedIcons.displayName = "FeaturedIcons";
FeaturedIcons.Schema = FeaturedIcons_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/FeaturedIcons/index.js


// EXTERNAL MODULE: ../node_modules/pascal-case/dist.es2015/index.js
var dist_es2015 = __webpack_require__(27526);
;// CONCATENATED MODULE: ./src/sections/Form/Form.theme.js

var Form_theme_themed = (0,create/* create */.U)(new function() {
//
}());

;// CONCATENATED MODULE: ./src/sections/Form/FormField.jsx







var FormField = Form_theme_themed(function(param) {
    var element = param.element, onInputChange = param.onInputChange, formResponse = param.formResponse;
    var ref, ref1;
    var type = element.type, label = element.label, column = element.column, position = element.position, placeholder = element.placeholder;
    var isTextarea = type === "textarea";
    var isRadio = type === "radio";
    var isSelect = type === "select";
    var isHidden = type === "hidden";
    var isRatings = type === "ratings";
    // Non inputs
    var isLabel = type === "label";
    var isSpace = type === "space";
    var isLineBreak = type === "lineBreak";
    var isRawHtml = type === "raw_html";
    var isHeadings = type === "headings";
    var isParagraph = type === "paragraph";
    var isHtml = isRawHtml || isHeadings || isParagraph;
    var hasLabel = !isHtml && !isSpace && !isLineBreak && !isHidden && !isLabel;
    // Uses <checkbox>
    var isCheckbox = type === "checkbox";
    var isMultiCheckbox = type === "multipleCheckbox";
    var isTerms = type === "terms_conditions";
    var isCheckboxType = isCheckbox || isMultiCheckbox || isTerms;
    // Uses <input type="file">
    var isFile = type === "file";
    var isImage = type === "image";
    var isSignature = type === "signature";
    var isFileType = isFile || isImage || isSignature;
    // Uses <input>
    var isText = type === "text";
    var isEmail = type === "email";
    var isPhone = type === "phone";
    var isDate = type === "newdate";
    var isNumber = type === "number";
    var isUrl = type === "url";
    var isTime = type === "time";
    var isAddress = type === "address";
    var isInput = isText || isEmail || isPhone || isDate || isNumber || isUrl || isTime || isAddress;
    var isNotFullWidth = isCheckbox || isRadio || isFileType || isCheckboxType;
    // settings
    var isHalfWidth = element.halfwidth === "yes";
    var isRequired = element.required === "yes";
    var hideElement = false;
    var conditionValue = element.Conditions.SelectedValue;
    var conditionElement = element.Conditions.SelectedElemenet;
    if (conditionValue) {
        var conditionMet;
        if (typeof (formResponse === null || formResponse === void 0 ? void 0 : formResponse[conditionElement]) === "string") {
            conditionMet = formResponse[conditionElement].toLowerCase() === (conditionValue === null || conditionValue === void 0 ? void 0 : conditionValue.toLowerCase());
        } else {
            conditionMet = (formResponse === null || formResponse === void 0 ? void 0 : formResponse[conditionElement]) === conditionValue;
        }
        hideElement = !conditionMet;
    }
    var values = (ref1 = (ref = element.values) === null || ref === void 0 ? void 0 : ref.split("\n")) === null || ref1 === void 0 ? void 0 : ref1.map(function(value) {
        return value.trim();
    }).filter(Boolean);
    return !hideElement ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
        "data-comp": FormField.displayName,
        sx: {
            flexDirection: "column",
            width: "100%",
            gridColumn: isHalfWidth ? column : "1 / span 2",
            alignItems: isNotFullWidth ? "flex-start" : "stretch",
            label: {
                mb: 0
            },
            input: {
                p: 3
            }
        },
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Label */.__, {
                onChange: function(param) {
                    var target = param.target;
                    return onInputChange({
                        target: target,
                        element: element
                    });
                },
                className: isLabel ? element.customClass || null : null,
                id: isLabel ? element.customID || null : null,
                sx: {
                    width: isNotFullWidth ? "auto" : "100%",
                    display: "flex",
                    flexDirection: isCheckbox || isTerms ? "row" : "column-reverse",
                    columnGap: 2,
                    rowGap: 3,
                    justifySelf: isCheckbox || isRadio || isFileType ? "flex-start" : "stretch"
                },
                children: [
                    isLabel && label,
                    isFileType && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Input */.II, {
                        "data-comp": (0,dist_es2015/* pascalCase */.Ho)(type),
                        type: "file",
                        required: isRequired,
                        name: label,
                        className: element.customClass || null,
                        id: element.customID || null,
                        onChange: function(param) {
                            var target = param.target;
                            return onInputChange({
                                target: target,
                                element: element
                            });
                        }
                    }),
                    isInput && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Input */.II, (0,_object_spread/* default */.Z)({
                        "data-comp": (0,dist_es2015/* pascalCase */.Ho)(type),
                        // eslint-disable-next-line no-nested-ternary
                        type: isDate ? "date" : isPhone ? "tel" : type,
                        required: isRequired,
                        placeholder: placeholder,
                        name: label,
                        className: element.customClass || null,
                        id: element.customID || null,
                        onChange: function(param) {
                            var target = param.target;
                            return onInputChange({
                                target: target,
                                element: element
                            });
                        }
                    }, isNumber ? {
                        min: element.minNumber || "",
                        max: element.maxNumber || ""
                    } : null)),
                    isHtml && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                        "data-comp": (0,dist_es2015/* pascalCase */.Ho)(type),
                        dangerouslySetInnerHTML: {
                            __html: element.rowHtmlCode || element[type]
                        }
                    }),
                    isTextarea && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Textarea */.gx, {
                        "data-comp": (0,dist_es2015/* pascalCase */.Ho)(type),
                        type: type,
                        required: isRequired,
                        name: label,
                        className: element.customClass || null,
                        id: element.customID || null,
                        onChange: function(param) {
                            var target = param.target;
                            return onInputChange({
                                target: target,
                                element: element
                            });
                        },
                        placeholder: placeholder,
                        sx: {
                            resize: "none",
                            p: 3
                        }
                    }),
                    isTerms && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Checkbox */.XZ, {
                        "data-comp": (0,dist_es2015/* pascalCase */.Ho)(type),
                        required: isRequired,
                        name: label,
                        checked: (formResponse === null || formResponse === void 0 ? void 0 : formResponse[label]) === "on",
                        className: element.customClass || null,
                        id: element.customID || null,
                        onClick: function(param) {
                            var target = param.target;
                            return onInputChange({
                                target: target,
                                element: element
                            });
                        }
                    }),
                    isCheckbox && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Checkbox */.XZ, {
                        "data-comp": (0,dist_es2015/* pascalCase */.Ho)(type),
                        required: isRequired,
                        name: label,
                        checked: (formResponse === null || formResponse === void 0 ? void 0 : formResponse[label]) === "on",
                        className: element.customClass || null,
                        id: element.customID || null,
                        onClick: function(param) {
                            var target = param.target;
                            return onInputChange({
                                target: target,
                                element: element
                            });
                        }
                    }),
                    isMultiCheckbox && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                        "data-comp": (0,dist_es2015/* pascalCase */.Ho)(type),
                        sx: {
                            flexDirection: element.align === "vertical" ? "column" : "row",
                            columnGap: 4,
                            rowGap: 2,
                            justifyContent: "flex-start",
                            alignSelf: "flex-start"
                        },
                        children: values === null || values === void 0 ? void 0 : values.map(function(value) {
                            return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Label */.__, {
                                children: [
                                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Checkbox */.XZ, {
                                        required: isRequired,
                                        name: label,
                                        value: value,
                                        className: element.customClass || null,
                                        id: element.customID || null,
                                        onClick: function(param) {
                                            var target = param.target;
                                            onInputChange({
                                                target: target,
                                                element: element
                                            });
                                        }
                                    }),
                                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Link */.rU, {
                                        href: element.redirect || "",
                                        newTab: true,
                                        children: value
                                    })
                                ]
                            }, value);
                        })
                    }),
                    isRadio && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                        "data-comp": (0,dist_es2015/* pascalCase */.Ho)(type),
                        sx: {
                            flexDirection: element.align === "vertical" ? "column" : "row",
                            columnGap: 4,
                            rowGap: 2,
                            justifyContent: "flex-start",
                            alignSelf: "flex-start"
                        },
                        children: values === null || values === void 0 ? void 0 : values.map(function(value) {
                            return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Label */.__, {
                                children: [
                                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Radio */.Y8, {
                                        value: value,
                                        name: label,
                                        className: element.customClass || null,
                                        id: element.customID || null,
                                        onClick: function(param) {
                                            var target = param.target;
                                            return onInputChange({
                                                target: target,
                                                element: element
                                            });
                                        }
                                    }),
                                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Text */.xv, {
                                        children: value
                                    })
                                ]
                            }, value);
                        })
                    }),
                    isSelect && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Select */.Ph, {
                        "data-comp": (0,dist_es2015/* pascalCase */.Ho)(type),
                        required: isRequired,
                        name: label,
                        className: element.customClass || null,
                        id: element.customID || null,
                        onChange: function(param) {
                            var target = param.target;
                            return onInputChange({
                                target: target,
                                element: element
                            });
                        },
                        children: [
                            placeholder || ""
                        ].concat((0,_to_consumable_array/* default */.Z)(values || [])).map(function(value, index) {
                            return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("option", {
                                value: value,
                                disabled: index === 0,
                                selected: index === 0,
                                children: value
                            }, value);
                        })
                    }),
                    isSpace && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                        "data-comp": (0,dist_es2015/* pascalCase */.Ho)(type),
                        sx: {
                            height: "16px",
                            bg: "transparent"
                        }
                    }),
                    isLineBreak && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                        "data-comp": (0,dist_es2015/* pascalCase */.Ho)(type),
                        sx: {
                            height: "1px",
                            bg: "gray",
                            my: "15px"
                        }
                    }),
                    isHidden && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Input */.II, {
                        "data-comp": (0,dist_es2015/* pascalCase */.Ho)(type),
                        name: label,
                        type: "hidden",
                        value: element.fieldvalue
                    }),
                    isRatings && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                        children: "Ratings field is not yet implemented."
                    }),
                    hasLabel && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Text */.xv, {
                        dangerouslySetInnerHTML: {
                            __html: label + (isRequired ? " *" : "")
                        },
                        sx: {}
                    })
                ]
            }),
            element.infoMessage && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                sx: {
                    variant: "text.sm",
                    color: "mediumDarkGray",
                    mt: 2
                },
                children: element.infoMessage
            })
        ]
    }, position) : null;
});
FormField.displayName = "FormField";

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(23842);
// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(59312);
;// CONCATENATED MODULE: ./src/sections/Form/useForm.js








var useForm = function(param) {
    var formId = param.formId;
    var formRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(null), formData = ref[0], setFormData = ref[1];
    var ref1 = (0,react.useState)(null), formResponse = ref1[0], setFormResponse = ref1[1];
    var ref2 = (0,react.useState)(false), isSubmitting = ref2[0], setIsSubmitting = ref2[1];
    var ref3 = (0,react.useState)(null), errors = ref3[0], setErrors = ref3[1];
    var ref4 = (0,react.useState)(null), message = ref4[0], setMessage = ref4[1];
    var details = formData === null || formData === void 0 ? void 0 : formData.form_details;
    var successMessage = details === null || details === void 0 ? void 0 : details.after_submit_msg;
    var getForm = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, url, options, response, data, _formResponse, columnCounter, mapWithIndexes, formElements, _formData, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    if (!formId) {
                        return [
                            2,
                            console.error("No formId provided")
                        ];
                    }
                    url = "/api/hulkapps";
                    options = {
                        method: "POST",
                        body: JSON.stringify({
                            action: "getForm",
                            formId: formId
                        })
                    };
                    return [
                        4,
                        fetch(url, options)
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    data = _state.sent();
                    _formResponse = data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : (ref1 = ref.form_details) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.formElements) === null || ref2 === void 0 ? void 0 : ref2.reduce(function(obj, param) {
                        var type = param.type, label = param.label, checked = param.checked, values = param.values;
                        if ([
                            "label",
                            "raw_html",
                            "space",
                            "lineBreak",
                            "headings",
                            "paragraph", 
                        ].includes(type)) return obj;
                        var isCheckbox = type === "checkbox" || type === "terms_conditions";
                        var isChecked = isCheckbox && checked === "yes";
                        var value = isChecked ? "on" : "";
                        var isMultiCheckbox = type === "multipleCheckbox";
                        if (isMultiCheckbox) {
                            var maxChoices = values === null || values === void 0 ? void 0 : values.split("\n").length;
                            obj[label] = Array(maxChoices).fill("");
                        }
                        // If there are more than one field with same label name, generate array of answers
                        if (Array.isArray(obj[label])) {
                            obj[label].push(value);
                        } else if (obj[label] !== undefined) {
                            obj[label] = [
                                obj[label],
                                value
                            ];
                        } else {
                            obj[label] = value;
                        }
                        return obj;
                    }, {});
                    columnCounter = 0;
                    mapWithIndexes = {};
                    formElements = data === null || data === void 0 ? void 0 : (ref3 = data.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.form_details) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.formElements) === null || ref5 === void 0 ? void 0 : ref5.map(function(element) {
                        var isHalfWidth = element.halfwidth === "yes";
                        var column = 1;
                        if (columnCounter % 2 !== 0 && !isHalfWidth) {
                            columnCounter = 0;
                            column = 1;
                        } else if (columnCounter % 2 === 0 && !isHalfWidth) {
                            columnCounter += 2;
                            column = 2;
                        } else if (columnCounter % 2 !== 0 && isHalfWidth) {
                            columnCounter += 1;
                            column = 2;
                        } else if (columnCounter % 2 === 0 && isHalfWidth) {
                            columnCounter += 1;
                            column = 1;
                        }
                        if (mapWithIndexes[element.label] !== undefined) {
                            mapWithIndexes[element.label] += 1;
                        } else {
                            mapWithIndexes[element.label] = 0;
                        }
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, element), {
                            column: column,
                            index: mapWithIndexes[element.label]
                        });
                    });
                    _formData = (data === null || data === void 0 ? void 0 : data.data) ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data === null || data === void 0 ? void 0 : data.data), {
                        form_details: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data === null || data === void 0 ? void 0 : (ref6 = data.data) === null || ref6 === void 0 ? void 0 : ref6.form_details), {
                            formElements: formElements
                        })
                    }) : null;
                    setFormData(_formData);
                    setFormResponse(_formResponse);
                    return [
                        2,
                        _formData
                    ];
                case 3:
                    error = _state.sent();
                    console.error(error);
                    return [
                        2,
                        null
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), [
        formId
    ]);
    var submitForm = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var event, captchaLoaded, ref, ref1, captchaResponse, parsedFormReponse, url, options, response, data, _$error, hasErrors, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event = param.event, captchaLoaded = param.captchaLoaded;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            ,
                            7
                        ]);
                        event.preventDefault();
                        if (!formId) {
                            return [
                                2,
                                console.error("No formId provided")
                            ];
                        }
                        if (!formResponse) {
                            return [
                                2,
                                console.error("No formResponse provided")
                            ];
                        }
                        setIsSubmitting(true);
                        setErrors(null);
                        setMessage(null);
                        if (!captchaLoaded) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            (ref1 = window.grecaptcha) === null || ref1 === void 0 ? void 0 : ref1.getResponse()
                        ];
                    case 2:
                        captchaResponse = _state.sent();
                        if (!captchaResponse) {
                            setIsSubmitting(false);
                            return [
                                2,
                                setErrors([
                                    "Please verify that you are not a robot"
                                ])
                            ];
                        }
                        _state.label = 3;
                    case 3:
                        parsedFormReponse = Object.entries(formResponse).reduce(function(obj, param) {
                            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
                            var ref;
                            if (Array.isArray(value) && ((ref = value[0]) === null || ref === void 0 ? void 0 : ref.isMultiCheckbox)) {
                                obj[key] = value.slice(1).filter(Boolean).join("\n");
                            } else {
                                obj[key] = value;
                            }
                            return obj;
                        }, {});
                        url = "/api/hulkapps";
                        options = {
                            method: "POST",
                            body: JSON.stringify({
                                action: "submitForm",
                                formId: formId,
                                formResponse: parsedFormReponse
                            })
                        };
                        return [
                            4,
                            fetch(url, options)
                        ];
                    case 4:
                        response = _state.sent();
                        return [
                            4,
                            response.json()
                        ];
                    case 5:
                        data = _state.sent();
                        console.log("submitForm data", data);
                        _$error = data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : ref.error;
                        hasErrors = (_$error === null || _$error === void 0 ? void 0 : _$error.length) > 0;
                        if ((data === null || data === void 0 ? void 0 : data.ok) && !hasErrors) {
                            setMessage(successMessage);
                            formRef.current.reset();
                        }
                        if (hasErrors) {
                            setErrors(_$error);
                        }
                        setIsSubmitting(false);
                        return [
                            2,
                            data || null
                        ];
                    case 6:
                        error = _state.sent();
                        setIsSubmitting(false);
                        console.error(error);
                        return [
                            2,
                            null
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        formId,
        formResponse,
        successMessage
    ]);
    var onInputChange = (0,react.useCallback)(function(param) {
        var target = param.target, element = param.element;
        var label = element.label, type = element.type, values = element.values;
        if (!target || !label) return;
        var value = target.value;
        var checked = target.checked;
        var isCheckbox = type === "checkbox" || type === "terms_conditions";
        var isMultiCheckbox = type === "multipleCheckbox";
        if (isCheckbox) value = checked ? "on" : "";
        var finalValue = value;
        // If form response value is an array, add new value to array
        if (Array.isArray(formResponse[label])) {
            var map = formResponse[label].reduce(function(obj, arrValue, index) {
                obj[index] = arrValue;
                return obj;
            }, {});
            map[element.index] = value;
            finalValue = Object.values(map);
        }
        // If form response value is multiple choice, add or remove values from string
        if (isMultiCheckbox) {
            var optionsArr = values === null || values === void 0 ? void 0 : values.split("\n");
            var maxOptions = optionsArr === null || optionsArr === void 0 ? void 0 : optionsArr.length;
            var emptyArr = [
                {
                    isMultiCheckbox: true
                }, 
            ].concat((0,_to_consumable_array/* default */.Z)(Array(maxOptions).fill("")));
            var initArr = Array.isArray(formResponse[label]) ? formResponse[label] : emptyArr;
            var map1 = initArr.reduce(function(obj, arrValue, index) {
                obj[index] = arrValue;
                return obj;
            }, {});
            var valueIndex = optionsArr.indexOf(value) + 1;
            if (checked) {
                map1[valueIndex] = value;
            } else {
                map1[valueIndex] = "";
            }
            finalValue = Object.values(map1);
        }
        setFormResponse((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formResponse), (0,_define_property/* default */.Z)({}, label, finalValue)));
    }, [
        formResponse
    ]);
    (0,react.useEffect)(function() {
        getForm();
    }, [
        formId
    ]);
    return [
        {
            formData: formData,
            ref: formRef,
            isSubmitting: isSubmitting,
            errors: errors,
            message: message,
            formResponse: formResponse
        },
        {
            submitForm: submitForm,
            onInputChange: onInputChange
        }, 
    ];
};
useForm.displayName = "useForm";

;// CONCATENATED MODULE: ./src/sections/Form/Form.schema.js



var Form_schema_Schema = function() {
    return {
        label: "Form",
        key: "form",
        fields: [
            {
                label: "Form ID",
                name: "formId",
                component: "text",
                defaultValue: "R64QCXVXVeSvVeROi5opSg"
            },
            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, common/* section */.qi), {
                defaultValue: {
                    bgColor: common/* color.value.white */.$_.value.white,
                    color: common/* color.value.white */.$_.value.white,
                    desktop: {
                        container: "contentNarrow",
                        mt: "none",
                        py: "xl"
                    },
                    mobile: {
                        container: "contentNarrow",
                        mt: "none",
                        py: "xl"
                    }
                }
            }), 
        ]
    };
};

;// CONCATENATED MODULE: ./src/sections/Form/Form.jsx











var Form = (0,src_utils/* withInView */.Dh)(Form_theme_themed(function(param) {
    var theme = param.theme, cms = param.cms;
    var ref, ref1, ref2;
    var formId = cms.formId, section = cms.section;
    var captchaRef = (0,react.useRef)(null);
    var ref3 = (0,_sliced_to_array/* default */.Z)(useForm({
        formId: formId
    }), 2), ref4 = ref3[0], formData = ref4.formData, ref5 = ref4.ref, isSubmitting = ref4.isSubmitting, errors = ref4.errors, message = ref4.message, formResponse = ref4.formResponse, ref6 = ref3[1], submitForm = ref6.submitForm, onInputChange = ref6.onInputChange;
    var ref7 = (0,react.useState)(false), captchaLoaded = ref7[0], setCaptchaLoaded = ref7[1];
    var details = formData === null || formData === void 0 ? void 0 : formData.form_details;
    var submitText = details === null || details === void 0 ? void 0 : details.form_submit;
    var captchaAlign = details === null || details === void 0 ? void 0 : details.captcha_align;
    var hasCaptcha = (details === null || details === void 0 ? void 0 : details.captcha_enable) === "yes";
    var renderCaptcha =  true ? window === null || window === void 0 ? void 0 : (ref = window.grecaptcha) === null || ref === void 0 ? void 0 : ref.render : 0;
    var captchaReady = typeof renderCaptcha === "function";
    (0,react.useEffect)(function() {
        try {
            if (!captchaReady || !hasCaptcha) return;
            renderCaptcha("form-captcha-widget", {
                sitekey: "6LfvrGshAAAAAB3e0obWMRxvWnpoyX7NvtXDiqVS"
            });
        } catch (error) {
            console.error(error);
        }
    }, [
        captchaReady,
        hasCaptcha
    ]);
    (0,react.useEffect)(function() {
        if (!captchaRef.current || !hasCaptcha) return;
        var observer = new MutationObserver(function() {
            setCaptchaLoaded(true);
            observer.disconnect();
        });
        observer.observe(captchaRef.current, {
            attributes: true,
            characterData: true,
            childList: true,
            subtree: true
        });
        return function() {
            return observer.disconnect();
        };
    }, [
        hasCaptcha
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(snippets/* Section */.$0, {
        section: section,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)((head_default()), {
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("script", {
                    src: "https://www.google.com/recaptcha/api.js",
                    async: true,
                    defer: true
                })
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Container */.W2, {
                "data-comp": Form.displayName,
                sx: {
                    minHeight: "400px"
                },
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Grid */.rj, {
                    as: "form",
                    ref: ref5,
                    sx: {
                        width: "100%",
                        gridTemplateColumns: "repeat(2, 1fr)",
                        color: "text",
                        gap: 5
                    },
                    action: "https://formbuilder.hulkapps.com/forms/create_response/".concat(formId),
                    method: "post",
                    enctype: "multipart/form-data",
                    onSubmit: function(event) {
                        return submitForm({
                            event: event,
                            captchaLoaded: captchaLoaded
                        });
                    },
                    children: [
                        formData === null || formData === void 0 ? void 0 : (ref1 = formData.form_details) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.formElements) === null || ref2 === void 0 ? void 0 : ref2.map(function(element) {
                            return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(FormField, {
                                element: element,
                                onInputChange: onInputChange,
                                formResponse: formResponse
                            });
                        }),
                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                            sx: {
                                flexDirection: "column",
                                gap: 8,
                                gridColumn: "1 / span 2"
                            },
                            children: [
                                hasCaptcha && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                                    ref: captchaRef,
                                    sx: {
                                        my: 6,
                                        width: "100%",
                                        justifyContent: // eslint-disable-next-line no-nested-ternary
                                        captchaAlign === "right" ? "flex-end" : captchaAlign === "center" ? "center" : "flex-start"
                                    },
                                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                                        id: "form-captcha-widget"
                                    })
                                }),
                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                                    sx: {
                                        width: "auto",
                                        maxWidth: "200px",
                                        mt: 10
                                    },
                                    children: isSubmitting ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Spinner */.$j, {
                                        "aria-label": "Loading",
                                        sx: {
                                            color: "currentColor",
                                            height: "60%",
                                            position: "absolute",
                                            left: "50%",
                                            top: "50%",
                                            transform: "translate(-50%, -50%)"
                                        }
                                    }) : submitText
                                }),
                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                                    sx: {
                                        flexDirection: "column",
                                        gap: 2
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                                            dangerouslySetInnerHTML: {
                                                __html: message
                                            },
                                            sx: {
                                                "*": {
                                                    color: "text"
                                                }
                                            }
                                        }),
                                        errors === null || errors === void 0 ? void 0 : errors.map(function(error) {
                                            return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                                                sx: {
                                                    color: "red"
                                                },
                                                children: error
                                            }, error);
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}), {
    triggerOnce: true
});
Form.displayName = "Form";
Form.Schema = Form_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/Form/index.js


;// CONCATENATED MODULE: ./src/sections/FormBuilder/FormBuilder.theme.js

var FormBuilder_theme_themed = (0,create/* create */.U)(new function() {
    this.heading = {
        variant: "text.h2",
        mb: [
            12,
            14
        ]
    };
    this.form = {
        width: "100%",
        gridTemplateColumns: "repeat(2, 1fr)",
        color: "text",
        gap: 5
    };
    this.submitWrapper = {
        flexDirection: "column",
        gap: 8,
        gridColumn: "1 / span 2"
    };
    this.recaptcha = {
        my: 6,
        width: "100%"
    };
    this.submit = {
        width: "auto",
        maxWidth: "200px",
        mt: 10
    };
    this.errors = {
        flexDirection: "column",
        gap: 2
    };
    this.error = {
        color: "red"
    };
}());

;// CONCATENATED MODULE: ./src/sections/FormBuilder/CountryField.jsx






var firstCountries = [
    "United States",
    "Canada",
    "United Kingdom",
    "France",
    "Australia",
    "New Zealand",
    "--", 
];
var CountryField = FormBuilder_theme_themed(function(param) {
    var label = param.label, required = param.required, placeholder = param.placeholder;
    var countries = (0,dist.useCountries)();
    var orderedCountries = (0,react.useMemo)(function() {
        if (!(countries === null || countries === void 0 ? void 0 : countries.length)) return null;
        return (0,_to_consumable_array/* default */.Z)(countries).sort(function(a, b) {
            var aName = a.locale.name;
            var bName = b.locale.name;
            if (aName < bName) return -1;
            if (aName > bName) return 1;
            return 0;
        });
    }, [
        countries === null || countries === void 0 ? void 0 : countries.length
    ]);
    var countryOptions = (0,react.useMemo)(function() {
        if (!(orderedCountries === null || orderedCountries === void 0 ? void 0 : orderedCountries.length)) return null;
        var localize = function(country) {
            return {
                locale: {
                    name: country
                }
            };
        };
        return [
            localize(placeholder || ""), 
        ].concat((0,_to_consumable_array/* default */.Z)(firstCountries.map(localize)), (0,_to_consumable_array/* default */.Z)(orderedCountries));
    }, [
        orderedCountries === null || orderedCountries === void 0 ? void 0 : orderedCountries.length,
        firstCountries,
        placeholder
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Select */.Ph, {
        "data-comp": "Country",
        required: required,
        name: label,
        children: countryOptions === null || countryOptions === void 0 ? void 0 : countryOptions.map(function(param, index) {
            var locale = param.locale;
            return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("option", {
                value: locale.name,
                disabled: index === 0 || locale.name === "--",
                selected: index === 0,
                children: locale.name
            }, locale.name);
        })
    });
});
CountryField.displayName = "CountryField";

;// CONCATENATED MODULE: ./src/sections/FormBuilder/FormField.jsx






var FormField_FormField = FormBuilder_theme_themed(function(param) {
    var field = param.field, index = param.index;
    var type = field._template, column = field.column, direction = field.direction, halfWidth = field.halfWidth, hideLabel = field.hideLabel, infoMessage = field.infoMessage, isAutoresponseEmail = field.isAutoresponseEmail, label = field.label, link = field.link, options = field.options, placeholder = field.placeholder, required = field.required;
    var isTextarea = type === "textArea";
    var isRadio = type === "radio";
    var isSelect = type === "select";
    var isCountry = type === "country";
    // Non inputs
    var isLabel = type === "label";
    var hasLabel = !isLabel;
    // Uses <checkbox>
    var isCheckbox = type === "checkbox";
    var isMultiCheckbox = type === "multipleCheckbox";
    var isCheckboxType = isCheckbox || isMultiCheckbox;
    // Uses <input type="file">
    var isFile = type === "file";
    var isFileType = isFile;
    // Uses <input>
    var isText = type === "text";
    var isEmail = type === "email";
    var isPhone = type === "phone";
    var isDate = type === "date";
    var isNumber = type === "number";
    var isUrl = type === "url";
    var isTime = type === "time";
    var isAddress = type === "address";
    var isInput = isText || isEmail || isPhone || isDate || isNumber || isUrl || isTime || isAddress;
    var isNotFullWidth = isCheckbox || isRadio || isFileType || isCheckboxType;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
        "data-comp": FormField_FormField.displayName,
        sx: {
            flexDirection: "column",
            width: "100%",
            gridColumn: halfWidth ? column : "1 / span 2",
            alignItems: isNotFullWidth ? "flex-start" : "stretch",
            label: {
                mb: 0,
                fontWeight: 400
            },
            input: {
                p: 4,
                borderColor: "mediumGray"
            },
            "select, textarea": {
                p: 4,
                borderRadius: 0,
                borderColor: "mediumGray"
            }
        },
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Label */.__, {
                sx: {
                    width: isNotFullWidth ? "auto" : "100%",
                    display: "flex",
                    flexDirection: isCheckbox ? "row" : "column-reverse",
                    py: isCheckbox || isLabel ? 2 : 0,
                    columnGap: 2,
                    rowGap: 3,
                    fontWeight: 400,
                    justifySelf: isCheckbox || isRadio || isFileType ? "flex-start" : "stretch"
                },
                children: [
                    isLabel && label,
                    isFileType && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Input */.II, {
                        "data-comp": (0,dist_es2015/* pascalCase */.Ho)(type),
                        type: "file",
                        required: required,
                        name: label
                    }),
                    isInput && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Input */.II, {
                        "data-comp": (0,dist_es2015/* pascalCase */.Ho)(type),
                        type: isPhone ? "tel" : type,
                        required: required,
                        placeholder: placeholder,
                        name: isAutoresponseEmail ? "email" : label
                    }),
                    isTextarea && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Textarea */.gx, {
                        "data-comp": (0,dist_es2015/* pascalCase */.Ho)(type),
                        type: "textarea",
                        required: required,
                        name: label,
                        placeholder: placeholder,
                        sx: {
                            resize: "none",
                            p: 3
                        }
                    }),
                    isCheckbox && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_jsx_runtime_esm/* Fragment */.HY, {
                        children: [
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Checkbox */.XZ, {
                                "data-comp": (0,dist_es2015/* pascalCase */.Ho)(type),
                                required: required,
                                name: label,
                                value: "yes"
                            }),
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                                type: "hidden",
                                name: label,
                                value: "no"
                            })
                        ]
                    }),
                    isMultiCheckbox && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                        "data-comp": (0,dist_es2015/* pascalCase */.Ho)(type),
                        sx: {
                            flexDirection: direction === "vertical" ? "column" : "row",
                            columnGap: 4,
                            rowGap: 2,
                            justifyContent: "flex-start",
                            alignSelf: "flex-start",
                            flexWrap: "wrap"
                        },
                        children: options === null || options === void 0 ? void 0 : options.map(function(value) {
                            return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Label */.__, {
                                children: [
                                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Checkbox */.XZ, {
                                        name: value,
                                        value: "yes"
                                    }),
                                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                                        type: "hidden",
                                        name: value,
                                        value: "no"
                                    }),
                                    value
                                ]
                            }, value);
                        })
                    }),
                    isRadio && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                        "data-comp": (0,dist_es2015/* pascalCase */.Ho)(type),
                        sx: {
                            flexDirection: direction === "vertical" ? "column" : "row",
                            columnGap: 4,
                            rowGap: 2,
                            justifyContent: "flex-start",
                            alignSelf: "flex-start"
                        },
                        children: options === null || options === void 0 ? void 0 : options.map(function(value) {
                            return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Label */.__, {
                                children: [
                                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Radio */.Y8, {
                                        value: value,
                                        name: label
                                    }),
                                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Text */.xv, {
                                        children: value
                                    })
                                ]
                            }, value);
                        })
                    }),
                    isSelect && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Select */.Ph, {
                        "data-comp": (0,dist_es2015/* pascalCase */.Ho)(type),
                        required: required,
                        name: label,
                        children: [
                            placeholder || ""
                        ].concat((0,_to_consumable_array/* default */.Z)(options || [])).map(function(value, index) {
                            return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("option", {
                                value: value,
                                disabled: index === 0,
                                selected: index === 0,
                                children: value
                            }, value);
                        })
                    }),
                    isCountry && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(CountryField, {
                        label: label,
                        required: required,
                        placeholder: placeholder
                    }),
                    hasLabel && !hideLabel && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Text */.xv, {
                        dangerouslySetInnerHTML: {
                            __html: "".concat(label).concat((link === null || link === void 0 ? void 0 : link.text) ? '&nbsp;<a href="'.concat(link.url, '" onclick="event.preventDefault" target="_blank" style"position:inline;">').concat(link.text, "</a>") : "").concat(required ? " *" : "")
                        },
                        sx: {
                            a: {
                                textDecoration: "underline"
                            }
                        }
                    })
                ]
            }),
            infoMessage && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                sx: {
                    variant: "text.sm",
                    color: "mediumDarkGray",
                    mt: 2
                },
                children: infoMessage
            })
        ]
    }, index);
});
FormField_FormField.displayName = "FormField";

;// CONCATENATED MODULE: ./src/sections/FormBuilder/useForm.js



var useForm_useForm = function(param) {
    var fields = param.fields;
    var parsedFields = (0,react.useMemo)(function() {
        if (!(fields === null || fields === void 0 ? void 0 : fields.length)) return [];
        // Determine the intended column number for the form field
        var columnCounter = 0;
        return fields.map(function(field) {
            var isHalfWidth = !!field.halfWidth;
            var column = 1;
            if (columnCounter % 2 !== 0 && !isHalfWidth) {
                columnCounter = 0;
                column = 1;
            } else if (columnCounter % 2 === 0 && !isHalfWidth) {
                columnCounter += 2;
                column = 2;
            } else if (columnCounter % 2 !== 0 && isHalfWidth) {
                columnCounter += 1;
                column = 2;
            } else if (columnCounter % 2 === 0 && isHalfWidth) {
                columnCounter += 1;
                column = 1;
            }
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, field), {
                column: column
            });
        });
    }, [
        fields
    ]);
    return {
        parsedFields: parsedFields
    };
};

// EXTERNAL MODULE: ../node_modules/lodash.camelcase/index.js
var lodash_camelcase = __webpack_require__(65763);
var lodash_camelcase_default = /*#__PURE__*/__webpack_require__.n(lodash_camelcase);
;// CONCATENATED MODULE: ./src/sections/FormBuilder/FormBuilder.schema.js





var inputField = function(type) {
    return {
        label: type,
        key: lodash_camelcase_default()(type),
        defaultItem: {
            label: "".concat(type)
        },
        itemProps: function(item) {
            return {
                label: "".concat(type).concat(item.label ? ": ".concat(item.label) : "")
            };
        },
        fields: [
            {
                label: "Label",
                name: "label",
                component: "text"
            },
            {
                label: "Placeholder",
                name: "placeholder",
                component: "text"
            },
            {
                label: "Info Message",
                name: "infoMessage",
                component: "text"
            }, 
        ].concat((0,_to_consumable_array/* default */.Z)(type === "Email" ? [
            {
                label: "Email For Autoresponse",
                name: "isAutoresponseEmail",
                component: "toggle",
                description: 'Toggle on for only one email field per form. Field will automatically be named "email" in the form submission',
                toggleLabels: {
                    true: "On",
                    false: "Off"
                }
            }, 
        ] : []), [
            {
                label: "Required",
                name: "required",
                component: "toggle",
                toggleLabels: {
                    true: "On",
                    false: "Off"
                }
            },
            {
                label: "Half Width",
                name: "halfWidth",
                component: "toggle",
                toggleLabels: {
                    true: "On",
                    false: "Off"
                }
            }, 
        ])
    };
};
var multiChoiceField = function(type) {
    return {
        label: type,
        key: lodash_camelcase_default()(type),
        defaultItem: {
            label: "".concat(type)
        },
        itemProps: function(item) {
            return {
                label: "".concat(type).concat(item.label ? ": ".concat(item.label) : "")
            };
        },
        fields: [
            {
                label: "Label",
                name: "label",
                component: "text"
            }, 
        ].concat((0,_to_consumable_array/* default */.Z)(type === "Select" ? [
            {
                label: "Placeholder",
                name: "placeholder",
                component: "text"
            }, 
        ] : []), [
            {
                label: "Info Message",
                name: "infoMessage",
                component: "text"
            },
            {
                label: "Options",
                name: "options",
                component: "list",
                field: {
                    component: "text"
                }
            }, 
        ], (0,_to_consumable_array/* default */.Z)(type === "Radio" || type === "Multiple Checkbox" ? [
            {
                label: "Direction",
                name: "direction",
                component: "radio-group",
                direction: "horizontal",
                variant: "radio",
                options: [
                    {
                        label: "Horizontal",
                        value: "horizontal"
                    },
                    {
                        label: "Vertical",
                        value: "vertical"
                    }, 
                ],
                defaultValue: "horizontal"
            }, 
        ] : []), (0,_to_consumable_array/* default */.Z)(type !== "Multiple Checkbox" ? [
            {
                label: "Required",
                name: "required",
                component: "toggle",
                toggleLabels: {
                    true: "On",
                    false: "Off"
                }
            }, 
        ] : []), [
            {
                label: "Half Width",
                name: "halfWidth",
                component: "toggle",
                toggleLabels: {
                    true: "On",
                    false: "Off"
                }
            }, 
        ], (0,_to_consumable_array/* default */.Z)(type === "Multiple Checkbox" ? [
            {
                label: "Hide Label",
                name: "hideLabel",
                component: "toggle",
                toggleLabels: {
                    true: "On",
                    false: "Off"
                }
            }, 
        ] : []))
    };
};
var countryField = {
    label: "Country",
    key: "country",
    defaultItem: {
        label: "Country"
    },
    itemProps: function(item) {
        return {
            label: "Country".concat(item.label ? ": ".concat(item.label) : "")
        };
    },
    fields: [
        {
            label: "Label",
            name: "label",
            component: "text"
        },
        {
            label: "Placeholder",
            name: "placeholder",
            component: "text"
        },
        {
            label: "Info Message",
            name: "infoMessage",
            component: "text"
        },
        {
            label: "Required",
            name: "required",
            component: "toggle",
            toggleLabels: {
                true: "On",
                false: "Off"
            }
        },
        {
            label: "Half Width",
            name: "halfWidth",
            component: "toggle",
            toggleLabels: {
                true: "On",
                false: "Off"
            }
        }, 
    ]
};
var labelField = {
    label: "Label",
    key: "label",
    defaultItem: {
        label: "Label Text"
    },
    itemProps: function(item) {
        return {
            label: "Label".concat(item.label ? ": ".concat(item.label) : "")
        };
    },
    fields: [
        {
            label: "Label",
            name: "label",
            component: "text"
        }, 
    ]
};
var checkboxField = {
    label: "Checkbox",
    key: "checkbox",
    defaultItem: {
        label: "Checkbox"
    },
    itemProps: function(item) {
        return {
            label: "Checkbox".concat(item.label ? ": ".concat(item.label) : "")
        };
    },
    fields: [
        {
            label: "Label",
            name: "label",
            component: "text"
        },
        {
            label: "Link",
            name: "link",
            component: "link"
        },
        {
            label: "Required",
            name: "required",
            component: "toggle",
            toggleLabels: {
                true: "On",
                false: "Off"
            }
        },
        {
            label: "Half Width",
            name: "halfWidth",
            component: "toggle",
            toggleLabels: {
                true: "On",
                false: "Off"
            }
        }, 
    ]
};
var fileField = {
    label: "File",
    key: "file",
    defaultItem: {
        label: "File Upload"
    },
    itemProps: function(item) {
        return {
            label: "File".concat(item.label ? ": ".concat(item.label) : "")
        };
    },
    fields: [
        {
            label: "Label",
            name: "label",
            component: "text"
        },
        {
            label: "Info Message",
            name: "infoMessage",
            component: "text"
        },
        {
            label: "Required",
            name: "required",
            component: "toggle",
            toggleLabels: {
                true: "On",
                false: "Off"
            }
        },
        {
            label: "Half Width",
            name: "halfWidth",
            component: "toggle",
            toggleLabels: {
                true: "On",
                false: "Off"
            }
        }, 
    ]
};
var FormBuilder_schema_Schema = function() {
    return {
        label: "Form Builder",
        key: "form-builder",
        fields: [
            {
                label: "Form Endpoint",
                name: "endpoint",
                component: "text",
                description: "Submit button will be disabled until this is entered.\nE.g. https://getform.io/f/1234-5678-90abcdef"
            },
            {
                label: "Heading",
                name: "heading",
                component: "text",
                defaultValue: "Form"
            },
            {
                label: "Fields",
                name: "fields",
                description: "Ensure each field's label is unique to avoid conflicts",
                component: "blocks",
                templates: {
                    checkbox: checkboxField,
                    country: countryField,
                    date: inputField("Date"),
                    email: inputField("Email"),
                    file: fileField,
                    label: labelField,
                    multipleCheckbox: multiChoiceField("Multiple Checkbox"),
                    number: inputField("Number"),
                    phone: inputField("Phone"),
                    radio: multiChoiceField("Radio"),
                    select: multiChoiceField("Select"),
                    text: inputField("Text"),
                    textArea: inputField("Text Area"),
                    time: inputField("Time"),
                    url: inputField("Url")
                }
            },
            {
                label: "Submit Button Text",
                name: "submitText",
                component: "text",
                defaultValue: "Submit"
            },
            {
                label: "reCAPTCHA Enabled",
                name: "recaptchaEnabled",
                component: "toggle",
                toggleLabels: {
                    true: "On",
                    false: "Off"
                }
            },
            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, common/* section */.qi), {
                defaultValue: {
                    bgColor: common/* color.value.background */.$_.value.background,
                    color: common/* color.value.text */.$_.value.text,
                    desktop: {
                        container: "contentNarrow",
                        mt: "none",
                        py: "s"
                    },
                    mobile: {
                        container: "contentNarrow",
                        mt: "none",
                        py: "s"
                    }
                }
            }), 
        ]
    };
};

;// CONCATENATED MODULE: ./src/sections/FormBuilder/FormBuilder.jsx














var FormBuilder = (0,src_utils/* withInView */.Dh)(FormBuilder_theme_themed(function(param) {
    var theme = param.theme, cms = param.cms;
    var ref;
    var endpoint = cms.endpoint, heading = cms.heading, fields = cms.fields, submitText = cms.submitText, recaptchaEnabled = cms.recaptchaEnabled, section = cms.section;
    var formRef = (0,react.useRef)(null);
    var captchaRef = (0,react.useRef)(null);
    var ref1 = (0,react.useState)([]), errors = ref1[0], setErrors = ref1[1];
    var parsedFields = useForm_useForm({
        fields: fields
    }).parsedFields;
    var ref2 = (0,react.useState)(false), captchaLoaded = ref2[0], setCaptchaLoaded = ref2[1];
    var renderCaptcha =  true ? window === null || window === void 0 ? void 0 : (ref = window.grecaptcha) === null || ref === void 0 ? void 0 : ref.render : 0;
    var captchaReady = typeof renderCaptcha === "function";
    var handleSubmit = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            var ref, ref1, formIsValid, captchaResponse, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        setErrors([]);
                        formIsValid = (ref = formRef.current) === null || ref === void 0 ? void 0 : ref.checkValidity();
                        if (!recaptchaEnabled || !captchaLoaded || !formIsValid) return [
                            2
                        ];
                        e.preventDefault();
                        return [
                            4,
                            (ref1 = window.grecaptcha) === null || ref1 === void 0 ? void 0 : ref1.getResponse()
                        ];
                    case 1:
                        captchaResponse = _state.sent();
                        if (!captchaResponse) {
                            setErrors([
                                "Please verify that you are not a robot"
                            ]);
                            return [
                                2
                            ];
                        }
                        formRef.current.submit();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        console.error(error.message);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(e) {
            return _ref.apply(this, arguments);
        };
    }(), [
        recaptchaEnabled,
        captchaLoaded
    ]);
    (0,react.useEffect)(function() {
        try {
            if (!captchaReady || !recaptchaEnabled) return;
            renderCaptcha("form-captcha-widget", {
                sitekey: "6LfvrGshAAAAAB3e0obWMRxvWnpoyX7NvtXDiqVS"
            });
        } catch (error) {
            console.error(error);
        }
    }, [
        captchaReady,
        recaptchaEnabled
    ]);
    (0,react.useEffect)(function() {
        if (!captchaRef.current || !recaptchaEnabled) return;
        var observer = new MutationObserver(function() {
            setCaptchaLoaded(true);
            observer.disconnect();
        });
        observer.observe(captchaRef.current, {
            attributes: true,
            characterData: true,
            childList: true,
            subtree: true
        });
        return function() {
            return observer.disconnect();
        };
    }, [
        recaptchaEnabled
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(snippets/* Section */.$0, {
        section: section,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)((head_default()), {
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("script", {
                    src: "https://www.google.com/recaptcha/api.js"
                })
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Container */.W2, {
                "data-comp": FormBuilder.displayName,
                children: [
                    heading && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                        sx: theme.heading,
                        children: heading
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Grid */.rj, {
                        as: "form",
                        ref: formRef,
                        sx: theme.form,
                        action: endpoint,
                        method: "POST",
                        encType: "multipart/form-data",
                        children: [
                            parsedFields === null || parsedFields === void 0 ? void 0 : parsedFields.map(function(field, index) {
                                return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(FormField_FormField, {
                                    field: field,
                                    index: index
                                });
                            }),
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                                sx: theme.submitWrapper,
                                children: [
                                    recaptchaEnabled && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                                        ref: captchaRef,
                                        sx: theme.recaptcha,
                                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                                            id: "form-captcha-widget"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                                        type: "submit",
                                        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.submit), {
                                            opacity: !endpoint ? 0.2 : 1
                                        }),
                                        disabled: !endpoint,
                                        onClick: handleSubmit,
                                        children: submitText || "Submit"
                                    }),
                                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                                        sx: theme.errors,
                                        children: errors === null || errors === void 0 ? void 0 : errors.map(function(error) {
                                            return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                                                sx: theme.error,
                                                children: error
                                            }, error);
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}), {
    triggerOnce: true
});
FormBuilder.displayName = "FormBuilder";
FormBuilder.Schema = FormBuilder_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/FormBuilder/index.js


;// CONCATENATED MODULE: ./src/sections/FourSixty/FourSixty.theme.js

var FourSixty_theme_themed = (0,create/* create */.U)(new function() {
    this.fourSixty = {
        ".fs-has-links::after": {
            p: "5px 7.5px",
            backgroundColor: "#ffffff",
            color: "rgba(0, 0, 0, 0.8)",
            content: '"Shop Now"'
        },
        ".fs-showcase_v2_5.fs-desktop .fs-entry-container": {
            width: "25% !important",
            pt: "25% !important"
        },
        ".fs-showcase_v2_5.fs-mobile .fs-entry-container": {
            width: "50% !important",
            pt: "50% !important"
        },
        ".fs-wrapper div.fs-text-container .fs-entry-title, div.fs-detail-title": {
            fontFamily: "Times New Roman, serif",
            fontStyle: "normal",
            fontWeight: "normal",
            fontSize: "14px"
        },
        "div.fs-text-container .fs-entry-date, div.fs-detail-container .fs-post-info, div.fs-wrapper div.fs-has-links::after, .fs-text-product, .fs-overlink-text": {
            fontFamily: "Helvetica Nueue, Helvetica, Arial, sans-serif",
            fontStyle: "normal",
            fontWeight: "normal",
            fontSize: "14px"
        },
        ".fs-wrapper div.fs-text-container *": {
            color: "#ffffff"
        },
        ".fs-wrapper div.fs-text-container": {
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            margin: "0px"
        },
        "div.fs-entry-date": {
            display: "none"
        },
        "div.fs-entry-title": {
            display: "none"
        },
        ".fs-showcase_v2_5.fs-wrapper div.fs-timeline-entry": {
            margin: "6px"
        }
    };
}());

;// CONCATENATED MODULE: ./src/sections/FourSixty/FourSixty.schema.js



var FourSixty_schema_Schema = function() {
    return {
        label: "Four Sixty",
        key: "four-sixty",
        fields: [
            {
                label: "Gallery ID",
                name: "galleryId",
                component: "text",
                defaultValue: "kryo-gear_1"
            },
            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, common/* section */.qi), {
                defaultValue: {
                    bgColor: common/* color.value.white */.$_.value.white,
                    color: common/* color.value.white */.$_.value.white,
                    desktop: {
                        container: "container",
                        mt: "none",
                        py: "s"
                    },
                    mobile: {
                        container: "container",
                        mt: "none",
                        py: "none"
                    }
                }
            }), 
        ]
    };
};

;// CONCATENATED MODULE: ./src/sections/FourSixty/FourSixty.jsx









var FourSixty = (0,src_utils/* withInView */.Dh)(FourSixty_theme_themed(function(param) {
    var theme = param.theme, cms = param.cms, inView = param.inView;
    var section = cms.section;
    var galleryId = cms === null || cms === void 0 ? void 0 : cms.galleryId;
    var ref = (0,react.useState)(false), isMounted = ref[0], setIsMounted = ref[1];
    (0,react.useEffect)(function() {
        if (isMounted || !galleryId || !inView) return;
        var scriptInit = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var element, script, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            element = document.getElementById("four-sixty-div");
                            script = document.createElement("script");
                            script.type = "text/javascript";
                            script.src = "//foursixty.com/media/scripts/fs.embed.v2.5.js";
                            script.id = "four-sixty-script";
                            script.setAttribute("key", "foursixtylib");
                            script.setAttribute("data-feed-id", galleryId);
                            script.setAttribute("data-open-links-in-same-page", "true");
                            script.setAttribute("data-theme", "showcase_v2_5");
                            script.setAttribute("data-page-size", "4");
                            return [
                                4,
                                element.appendChild(script)
                            ];
                        case 1:
                            _state.sent();
                            setIsMounted(true);
                            return [
                                3,
                                3
                            ];
                        case 2:
                            error = _state.sent();
                            setIsMounted(false);
                            throw new Error(error);
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function scriptInit() {
                return _ref.apply(this, arguments);
            };
        }();
        scriptInit();
    }, [
        galleryId,
        isMounted,
        inView
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Section */.$0, {
        section: section,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Container */.W2, {
            "data-comp": FourSixty.displayName,
            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                id: "four-sixty-div",
                sx: theme.fourSixty
            })
        })
    });
}), {
    triggerOnce: true
});
FourSixty.displayName = "FourSixty";
FourSixty.Schema = FourSixty_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/FourSixty/index.js


;// CONCATENATED MODULE: ./src/sections/FullPageReviews/FullPageReviews.schema.js



function FullPageReviews_schema_Schema(param) {
    var article = param.article, blog = param.blog, collection = param.collection;
    if (article || blog || collection) return null;
    return {
        label: "Full Page Reviews",
        key: "full-page-reviews",
        fields: [
            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, common/* section */.qi), {
                defaultValue: {
                    desktop: {
                        container: "container",
                        mt: "none",
                        py: "none"
                    },
                    mobile: {
                        container: "container",
                        mt: "none",
                        py: "none"
                    }
                }
            }), 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/FullPageReviews/FullPageReviews.jsx




var FullPageReviews = (0,src_utils/* withInView */.Dh)(function(param) {
    var cms = param.cms;
    var section = cms.section;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Section */.$0, {
        section: section,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* SiteReviews */.cn, {})
    });
}, {
    renderOnce: true
});
FullPageReviews.displayName = "FullPageReviews";
FullPageReviews.Schema = FullPageReviews_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/FullPageReviews/index.js


;// CONCATENATED MODULE: ./src/sections/FunctionalSchemaDemo/FunctionalSchemaDemo.schema.js
var FunctionalSchemaDemo_schema_Schema = function(param) {
    var product = param.product;
    var ref;
    if (!product) return;
    // we create a cms select with the collections this product belongs to
    var productCollectionsOptions = (product === null || product === void 0 ? void 0 : (ref = product.collections) === null || ref === void 0 ? void 0 : ref.length) ? product === null || product === void 0 ? void 0 : product.collections.map(function(collection) {
        var collectionTitle = collection.handle.replace(/-/g, " ");
        var collectionTitleCapitalized = collectionTitle.charAt(0).toUpperCase() + collectionTitle.slice(1);
        return {
            label: collectionTitleCapitalized,
            value: collection.handle
        };
    }) : [];
    return {
        label: "Back to Collection",
        description: "Demonstrate how we can use product data inside our cms editor section",
        key: "functionalSchemaDemo",
        fields: [
            // field with "dynamic" product data
            {
                name: "backToCollection",
                label: "Back to collection",
                component: "select",
                options: productCollectionsOptions,
                defaultValue: (productCollectionsOptions === null || productCollectionsOptions === void 0 ? void 0 : productCollectionsOptions.length) ? productCollectionsOptions[0].value : ""
            },
            // conditional field for "Premium Fixed Gear Bike" product types only
            (product === null || product === void 0 ? void 0 : product.productType) === "Premium Fixed Gear Bike" ? {
                name: "tiresOnly",
                label: "Tire brand",
                component: "text",
                defaultValue: "Good Year"
            } : null, 
        ].filter(Boolean)
    };
};

;// CONCATENATED MODULE: ./src/sections/FunctionalSchemaDemo/FunctionalSchemaDemo.jsx




// Displays a simple call to action linking back to a collection this product belongs to
function FunctionalSchemaDemo(param) {
    var cms = param.cms;
    return (cms === null || cms === void 0 ? void 0 : cms.backToCollection) ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
        "data-comp": FunctionalSchemaDemo.displayName,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                sx: {
                    mr: 3
                },
                children: "Go back to"
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Link */.rU, {
                href: "/collections/".concat(cms.backToCollection),
                children: "".concat(cms === null || cms === void 0 ? void 0 : cms.backToCollection, " collection")
            })
        ]
    }) : null;
}
FunctionalSchemaDemo.displayName = "FunctionalSchemaDemo";
FunctionalSchemaDemo.Schema = FunctionalSchemaDemo_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/FunctionalSchemaDemo/index.js


;// CONCATENATED MODULE: ./src/sections/HalfMedia/HalfMedia.schema.js




function HalfMedia_schema_Schema(param) {
    var article = param.article, blog = param.blog;
    if (article || blog) return null;
    return {
        label: "Half Media",
        key: "half-media",
        fields: [
            {
                label: "Image Settings",
                name: "image",
                description: "Image, alt text",
                component: "group",
                fields: [
                    {
                        label: "Image Alt",
                        name: "alt",
                        component: "text",
                        description: "Provide a brief description of the image for accessibility compliance"
                    },
                    {
                        name: "imageDt",
                        label: "Image (desktop)",
                        component: "image"
                    },
                    {
                        label: "Image (mobile)",
                        name: "image",
                        component: "image"
                    }, 
                ],
                defaultValue: {
                    alt: "A Woman sitting on a couch with a Hopsulator slim in her hand.",
                    image: {
                        src: "https://cdn.shopify.com/s/files/1/1114/2308/files/FirstCanCooler.png"
                    },
                    imageDt: {
                        src: "https://cdn.shopify.com/s/files/1/1114/2308/files/FirstCanCooler.png"
                    }
                }
            },
            {
                label: "Video Settings",
                name: "video",
                description: "Direct Video Link, Thumbnail",
                component: "group",
                fields: [
                    {
                        label: "Enable Video",
                        name: "enabled",
                        component: "toggle",
                        toggleLabels: {
                            true: "On",
                            false: "Off"
                        }
                    },
                    {
                        label: "Video Alt",
                        name: "alt",
                        component: "text",
                        description: "Provide a brief description of the video for accessibility compliance"
                    },
                    {
                        label: "Direct Video Link",
                        description: "Direct video links usually end in or contain '.mp4'",
                        name: "src",
                        component: "text"
                    },
                    {
                        label: "Video Thumbnail",
                        description: "Usually the first or best frame of the video",
                        name: "poster",
                        component: "image"
                    }, 
                ],
                defaultValue: {
                    alt: "Hopsulator Duo image.",
                    enabled: true,
                    src: "https://cdn.shopify.com/s/files/1/1114/2308/files/duoOptimized.mp4",
                    poster: {
                        src: "https://cdn.shopify.com/s/files/1/1114/2308/files/HopsulatorDuo_93eedf12-7170-4eee-bf26-61636f3674b8.png"
                    }
                }
            },
            {
                label: "HTML Settings",
                name: "html",
                component: "group",
                fields: [
                    {
                        label: "HTML",
                        name: "html",
                        component: "html",
                        description: "This html will replace any image or video used for the media section"
                    }, 
                ]
            },
            {
                label: "Media Settings",
                name: "media",
                description: "Position, placement, aspect ratio",
                component: "group",
                fields: [
                    {
                        name: "disableMobileMedia",
                        label: "Disable Media on Mobile",
                        component: "toggle",
                        toggleLabels: {
                            true: "Disable",
                            false: "Enable (default)"
                        }
                    },
                    {
                        label: "Media position",
                        name: "positionDt",
                        component: "select",
                        options: common/* position.object */.FK.object
                    },
                    {
                        label: "Placement (desktop)",
                        component: "radio-group",
                        direction: "horizontal",
                        variant: "radio",
                        name: "locationDt",
                        options: [
                            {
                                value: "left",
                                label: "Left"
                            },
                            {
                                value: "right",
                                label: "Right"
                            }, 
                        ]
                    },
                    {
                        label: "Aspect ratio (desktop)",
                        name: "ratioDt",
                        component: "radio-group",
                        description: "Only applies to images and video files not already set to 1:1 ratio",
                        direction: "horizontal",
                        variant: "radio",
                        options: [
                            {
                                value: "80%",
                                label: "5:4"
                            },
                            {
                                value: "100%",
                                label: "1:1"
                            },
                            {
                                value: "120%",
                                label: "5:6"
                            },
                            {
                                value: "calc(400% / 9)",
                                label: "4:9"
                            }, 
                        ]
                    },
                    {
                        label: "Media position (mobile)",
                        name: "position",
                        component: "select",
                        options: common/* position.object */.FK.object
                    },
                    {
                        label: "Placement (mobile)",
                        name: "location",
                        component: "radio-group",
                        direction: "horizontal",
                        variant: "radio",
                        options: [
                            {
                                value: "top",
                                label: "Top"
                            },
                            {
                                value: "bottom",
                                label: "Bottom"
                            }, 
                        ]
                    },
                    {
                        label: "Aspect ratio (mobile)",
                        component: "radio-group",
                        description: "Only applies to images and video files not already set to 1:1 ratio",
                        direction: "horizontal",
                        variant: "radio",
                        name: "ratio",
                        options: [
                            {
                                value: "80%",
                                label: "5:4"
                            },
                            {
                                value: "100%",
                                label: "1:1"
                            },
                            {
                                value: "120%",
                                label: "5:6"
                            }, 
                        ]
                    }, 
                ],
                defaultValue: {
                    disableMobileMedia: false,
                    location: "top",
                    locationDt: "left",
                    ratio: "100%",
                    ratioDt: "100%",
                    position: "center center",
                    positionDt: "center center"
                }
            },
            {
                label: "Content Settings",
                name: "content",
                description: "Heading, superheading body, link, content alignment",
                component: "group",
                fields: [
                    {
                        label: "Heading",
                        name: "heading",
                        component: "text"
                    },
                    {
                        component: "select",
                        name: "headingColor",
                        label: "Heading color",
                        options: [
                            {
                                label: "Default",
                                value: ""
                            }
                        ].concat((0,_to_consumable_array/* default */.Z)(common/* color.options */.$_.options))
                    },
                    {
                        label: "Superheading",
                        name: "superheading",
                        component: "text"
                    },
                    {
                        label: "Body",
                        name: "body",
                        component: "markdown"
                    },
                    {
                        label: "Link",
                        name: "cta",
                        component: "link"
                    },
                    {
                        name: "ctaStyle",
                        label: "Link Style",
                        component: "select",
                        options: common/* button.options */.LI.options
                    },
                    {
                        label: "Content alignment (mobile)",
                        name: "alignment",
                        component: "radio-group",
                        direction: "horizontal",
                        variant: "radio",
                        options: common/* align.options */.AJ.options
                    },
                    {
                        label: "Content alignment (desktop)",
                        name: "alignmentDt",
                        component: "radio-group",
                        direction: "horizontal",
                        variant: "radio",
                        options: common/* align.options */.AJ.options
                    }, 
                ],
                defaultValue: {
                    heading: "THE WORLD'S FIRST SLIM CAN COOLER.",
                    body: "The Hopsulator Slim keeps all of your\n          favorite 12oz slim canned beverages icy-\n          cold, no matter how hot the party gets.\n* Works with all 12oz Slim Cans\n* Works with all 12oz Slim Cans\n* Works with all 12oz Slim Cans\n* Works with all 12oz Slim Cans",
                    ctaStyle: common/* button.value.secondary */.LI.value.secondary,
                    alignment: common/* align.value.left */.AJ.value.left,
                    alignmentDt: common/* align.value.left */.AJ.value.left
                }
            },
            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, common/* section */.qi), {
                defaultValue: {
                    desktop: {
                        container: "container",
                        mt: "none",
                        py: "none"
                    },
                    mobile: {
                        container: "content",
                        mt: "none",
                        py: "none"
                    }
                }
            }), 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/HalfMedia/HalfMedia.theme.js

var HalfMedia_theme_themed = (0,create/* create */.U)(new function() {
    this.grid = {
        position: "relative",
        display: "grid",
        gridGap: 0
    };
    this.gridNoMedia = {
        position: "relative",
        display: "grid",
        gridGap: 0
    };
    this.media = {
        gridArea: "media",
        position: "relative",
        width: "100%",
        height: "100%",
        overflow: "hidden"
    };
    this.content = {
        gridArea: "content",
        display: "flex",
        position: "relative",
        width: "100%",
        height: "100%"
    };
}());

;// CONCATENATED MODULE: ./src/sections/HalfMedia/Video/Video.jsx





var defaultTransSx = {
    transition: "all 0.3s ease-in-out",
    transform: "translate(-50%, -50%) scale(1.1)",
    opacity: 0
};
function Video(param) {
    var video = param.video, media = param.media;
    var ref = (0,react.useRef)();
    var videoRef = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(false), paused = ref1[0], setPaused = ref1[1];
    var ref2 = (0,react.useState)(defaultTransSx), transitionSx = ref2[0], setTransitionSx = ref2[1];
    var showHideButton = function() {
        setTransitionSx({
            opacity: 0.5,
            transform: "translate(-50%, -50%) scale(1.01)",
            transition: "none"
        });
        setTimeout(function() {
            setTransitionSx(defaultTransSx);
        }, 0);
    };
    var handleVideoClick = function() {
        if (paused) {
            videoRef.current.play();
            setPaused(false);
            showHideButton();
        } else {
            videoRef.current.pause();
            setPaused(true);
            showHideButton();
        }
    };
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": Video.displayName,
        ref: ref,
        sx: {
            display: "block",
            position: "relative",
            width: "100%",
            height: "100%",
            overflow: "hidden"
        },
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                as: "video",
                ref: videoRef,
                muted: true,
                playsInline: true,
                loop: true,
                autoPlay: true,
                poster: video === null || video === void 0 ? void 0 : video.poster,
                sx: {
                    position: "absolute",
                    height: "101%",
                    width: "101%",
                    objectFit: "contain",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    objectPosition: [
                        media === null || media === void 0 ? void 0 : media.position,
                        media === null || media === void 0 ? void 0 : media.positionDt
                    ]
                },
                onClick: handleVideoClick,
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("source", {
                    src: video === null || video === void 0 ? void 0 : video.src,
                    type: "video/mp4"
                }, video === null || video === void 0 ? void 0 : video.src)
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                variant: "flex.row.center.center",
                sx: (0,_object_spread/* default */.Z)({
                    position: "absolute",
                    width: "100px",
                    height: "100px",
                    left: "50%",
                    top: "50%",
                    borderRadius: "50%",
                    bg: "black"
                }, transitionSx),
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Svg */.ny, {
                    src: !paused ? "/svgs/noprecache/svg/play.svg#play-icon" : "/svgs/noprecache/svg/pause.svg#pause-icon",
                    alt: !paused ? "Play Video" : "Pause Video",
                    viewBox: !paused ? "0 0 29 32" : "0 0 512 512",
                    sx: {
                        color: "white",
                        mr: !paused ? "-4px" : 0,
                        width: !paused ? "40px" : "50px"
                    }
                })
            })
        ]
    });
}
Video.displayName = "Video";

;// CONCATENATED MODULE: ./src/sections/HalfMedia/Video/index.js


;// CONCATENATED MODULE: ./src/sections/HalfMedia/Content/Content.theme.js


var HalfMedia_Content_Content_theme_themed = (0,create/* create */.U)(new function() {
    this.outer = {
        width: "100%",
        justifyContent: "center",
        alignItems: [
            "flex-start",
            "center"
        ],
        px: 12,
        py: [
            18,
            16
        ],
        "@media only screen and (max-width: 479px)": {
            py: 15
        }
    };
    this.superheading = {
        variant: "text.label.1",
        mb: 2
    };
    this.heading = {
        variant: "text.h2"
    };
    this.bodyWithoutHeading = {
        variant: "text.base",
        mt: 0,
        ul: {
            ml: 0
        },
        "p:last-of-type": {
            mb: 0
        }
    };
    this.bodyWithHeading = (0,_object_spread/* default */.Z)({}, this.bodyWithoutHeading);
}());

;// CONCATENATED MODULE: ./src/sections/HalfMedia/Content/Content.jsx









var HalfMedia_Content_Content_Content = HalfMedia_Content_Content_theme_themed(function(param) {
    var theme = param.theme, content = param.content, hasMedia = param.hasMedia, showBreadCrumb = param.showBreadCrumb;
    var ref, ref1, ref2, ref3;
    var textAlign = [
        content === null || content === void 0 ? void 0 : content.alignment,
        content === null || content === void 0 ? void 0 : content.alignmentDt
    ];
    var flexAlign = textAlign.map(function(align) {
        return (0,utils_common/* convertAlignToFlex */.nG)(align);
    });
    var collection = (0,dist.useCollection)();
    var subCollections = (0,store/* useRecoilValue */.sJ)(store/* default.collectionsMap */.ZP.collectionsMap);
    var superCollectionTitle = (0,store/* useRecoilValue */.sJ)(store/* default.superCollectionTitle */.ZP.superCollectionTitle);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
        "data-comp": HalfMedia_Content_Content_Content.displayName,
        sx: theme.outer,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
            sx: {
                variant: "flex.column",
                width: "100%",
                maxWidth: hasMedia ? [
                    "600px",
                    "450px"
                ] : "100%",
                alignItems: flexAlign
            },
            children: [
                (subCollections === null || subCollections === void 0 ? void 0 : subCollections.length) ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                    sx: {
                        mx: [
                            -8,
                            -10,
                            -11,
                            -80
                        ]
                    },
                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Breadcrumbs */.Oo, {
                        isSuperCollection: true,
                        superCollectionTitle: superCollectionTitle || ""
                    })
                }) : (collection === null || collection === void 0 ? void 0 : collection.handle) && showBreadCrumb && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                    sx: {
                        mx: [
                            -8,
                            -10,
                            -11,
                            -80
                        ]
                    },
                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Breadcrumbs */.Oo, {
                        isCollection: true,
                        collectionTitle: (collection === null || collection === void 0 ? void 0 : collection.title) || ""
                    })
                }),
                (content === null || content === void 0 ? void 0 : content.superheading) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.superheading), {
                        textAlign: textAlign
                    }),
                    children: content.superheading
                }),
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.heading), {
                        textAlign: textAlign,
                        color: (content === null || content === void 0 ? void 0 : content.headingColor) || "inherit"
                    }),
                    children: content === null || content === void 0 ? void 0 : content.heading
                }),
                (content === null || content === void 0 ? void 0 : content.body) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Markdown */.UG, {
                    text: content.body,
                    sx: (0,_object_spread/* default */.Z)({}, (content === null || content === void 0 ? void 0 : content.heading) ? theme.bodyWithHeading : theme.bodyWithoutHeading),
                    textSx: {
                        textAlign: textAlign
                    }
                }),
                (content === null || content === void 0 ? void 0 : (ref = content.cta) === null || ref === void 0 ? void 0 : ref.text) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Link */.rU, {
                    variant: "buttons.".concat((content === null || content === void 0 ? void 0 : content.ctaStyle) || "secondary"),
                    href: content === null || content === void 0 ? void 0 : (ref1 = content.cta) === null || ref1 === void 0 ? void 0 : ref1.url,
                    newTab: content === null || content === void 0 ? void 0 : (ref2 = content.cta) === null || ref2 === void 0 ? void 0 : ref2.newTab,
                    sx: {
                        mt: (content === null || content === void 0 ? void 0 : content.heading) || (content === null || content === void 0 ? void 0 : content.body) ? [
                            10,
                            11
                        ] : 0,
                        alignSelf: flexAlign
                    },
                    children: content === null || content === void 0 ? void 0 : (ref3 = content.cta) === null || ref3 === void 0 ? void 0 : ref3.text
                })
            ]
        })
    });
});
HalfMedia_Content_Content_Content.displayName = "Content";

;// CONCATENATED MODULE: ./src/sections/HalfMedia/Content/index.js


;// CONCATENATED MODULE: ./src/sections/HalfMedia/Image/Image.theme.js

var HalfMedia_Image_Image_theme_themed = (0,create/* create */.U)(new function() {
    this.image = {
        position: "absolute",
        width: "100%",
        height: "100%",
        top: 0,
        left: 0,
        bottom: 0,
        right: 0
    };
}());

;// CONCATENATED MODULE: ./src/sections/HalfMedia/Image/Image.jsx



var HalfMedia_Image_Image_Image = HalfMedia_Image_Image_theme_themed(function(param) {
    var theme = param.theme, image = param.image, media = param.media;
    var ref, ref1, ref2, ref3, ref4, ref5;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Picture */.t, {
        "data-comp": HalfMedia_Image_Image_Image.displayName,
        alt: image === null || image === void 0 ? void 0 : image.alt,
        mobileRatio: (image === null || image === void 0 ? void 0 : (ref = image.image) === null || ref === void 0 ? void 0 : ref.aspectRatio) || 1,
        desktopRatio: (image === null || image === void 0 ? void 0 : (ref1 = image.imageDt) === null || ref1 === void 0 ? void 0 : ref1.aspectRatio) || 1,
        preload: true,
        images: [
            {
                src: image === null || image === void 0 ? void 0 : (ref2 = image.image) === null || ref2 === void 0 ? void 0 : ref2.src,
                width: 768,
                ratio: 1
            },
            {
                src: image === null || image === void 0 ? void 0 : (ref3 = image.imageDt) === null || ref3 === void 0 ? void 0 : ref3.src,
                width: 512,
                ratio: 1
            },
            {
                src: image === null || image === void 0 ? void 0 : (ref4 = image.imageDt) === null || ref4 === void 0 ? void 0 : ref4.src,
                width: 640,
                ratio: 1
            },
            {
                src: image === null || image === void 0 ? void 0 : (ref5 = image.imageDt) === null || ref5 === void 0 ? void 0 : ref5.src,
                width: 720,
                ratio: 1
            }, 
        ],
        imageSx: {
            objectPosition: [
                media === null || media === void 0 ? void 0 : media.position,
                media === null || media === void 0 ? void 0 : media.positionDt
            ]
        },
        sx: theme.image
    });
});
HalfMedia_Image_Image_Image.displayName = "Image";

;// CONCATENATED MODULE: ./src/sections/HalfMedia/Image/index.js


;// CONCATENATED MODULE: ./src/sections/HalfMedia/HalfMedia.jsx












var HalfMedia = (0,src_utils/* withInView */.Dh)(HalfMedia_theme_themed(function(param) {
    var theme = param.theme, cms = param.cms, inView = param.inView;
    var ref, ref1;
    var image = cms.image, video = cms.video, media = cms.media, content = cms.content, section = cms.section, html = cms.html, _showBreadCrumb = cms.showBreadCrumb, showBreadCrumb = _showBreadCrumb === void 0 ? false : _showBreadCrumb;
    var mediaLeft = (media === null || media === void 0 ? void 0 : media.locationDt) === "left"; // mobile
    var mediaTop = (media === null || media === void 0 ? void 0 : media.location) === "top"; // desktop
    var hasDtMedia = (image === null || image === void 0 ? void 0 : (ref = image.imageDt) === null || ref === void 0 ? void 0 : ref.src) || (video === null || video === void 0 ? void 0 : video.enabled) && (video === null || video === void 0 ? void 0 : video.src) || (html === null || html === void 0 ? void 0 : html.html);
    var hasMbMedia = ((image === null || image === void 0 ? void 0 : (ref1 = image.image) === null || ref1 === void 0 ? void 0 : ref1.src) || (video === null || video === void 0 ? void 0 : video.enabled) && (video === null || video === void 0 ? void 0 : video.src) || (html === null || html === void 0 ? void 0 : html.html)) && !(media === null || media === void 0 ? void 0 : media.disableMobileMedia);
    var hasMedia = hasDtMedia && hasMbMedia;
    var gridTemplateColumns = (0,react.useMemo)(function() {
        var arr = [
            "1fr"
        ];
        if (hasDtMedia) {
            arr.push("1fr 1fr");
        } else {
            arr.push("1fr");
        }
        return arr;
    }, [
        hasDtMedia,
        hasMbMedia
    ]);
    var gridTemplateAreas = (0,react.useMemo)(function() {
        var arr = Array(0);
        if (hasMbMedia) {
            if (mediaTop) {
                arr.push('"media" "content"');
            } else {
                arr.push('"content" "media"');
            }
        } else {
            arr.push('"content"');
        }
        if (hasDtMedia) {
            if (mediaLeft) {
                arr.push('"media content"');
            } else {
                arr.push('"content media"');
            }
        } else {
            arr.push('"content"');
        }
        return arr;
    }, [
        hasDtMedia,
        hasMbMedia,
        mediaTop,
        mediaLeft
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Section */.$0, {
        section: section,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Container */.W2, {
            "data-comp": HalfMedia.displayName,
            sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, !hasMedia ? theme.gridNoMedia : theme.grid), {
                gridTemplateAreas: gridTemplateAreas,
                gridTemplateColumns: gridTemplateColumns
            }),
            children: [
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.media), {
                        ":before": {
                            content: '""',
                            float: "left",
                            pb: [
                                hasMbMedia ? (media === null || media === void 0 ? void 0 : media.ratio) || "100%" : 0,
                                hasDtMedia ? (media === null || media === void 0 ? void 0 : media.ratioDt) || "100%" : 0, 
                            ]
                        }
                    }),
                    className: "".concat(hasDtMedia ? "" : "md:hidden", " ").concat(hasMbMedia ? "" : "max-md:hidden"),
                    children: [
                        !(html === null || html === void 0 ? void 0 : html.html) && (inView && (video === null || video === void 0 ? void 0 : video.enabled) ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Video, {
                            video: video,
                            media: media
                        }) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(HalfMedia_Image_Image_Image, {
                            image: image,
                            media: media
                        })),
                        (html === null || html === void 0 ? void 0 : html.html) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                            sx: {
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "100%"
                            },
                            dangerouslySetInnerHTML: {
                                __html: html === null || html === void 0 ? void 0 : html.html
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.content), {
                        justifyContent: mediaLeft ? "flex-start" : "flex-end",
                        ":before": {
                            content: '""',
                            float: "left",
                            pb: [
                                0,
                                hasDtMedia ? (media === null || media === void 0 ? void 0 : media.ratioDt) || "100%" : 0
                            ]
                        }
                    }),
                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(HalfMedia_Content_Content_Content, {
                        content: content,
                        hasMedia: hasMedia,
                        showBreadCrumb: showBreadCrumb
                    })
                })
            ]
        })
    });
}), {
    triggerOnce: true
});
HalfMedia.displayName = "HalfMedia";
HalfMedia.Schema = HalfMedia_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/HalfMedia/index.js


;// CONCATENATED MODULE: ./src/hooks/useParallax.js

var useParallax = function(param) {
    var _enabled = param.enabled, enabled = _enabled === void 0 ? false : _enabled, _textColorOutside = param.textColorOutside, textColorOutside = _textColorOutside === void 0 ? "" : _textColorOutside, _textColorInside = param.textColorInside, textColorInside = _textColorInside === void 0 ? "" : _textColorInside;
    var ref = (0,react.useState)(0), scrollY = ref[0], setScrollY = ref[1];
    var ref1 = (0,react.useState)(false), isTextInside = ref1[0], setIsTextInside = ref1[1];
    var heroRef = (0,react.useRef)(null);
    var contentRef = (0,react.useRef)(null);
    var UPWARD_MOVEMENT_LIMIT = -30;
    var PARALLAX_MAX_OFFSET = 300;
    var PARALLAX_SCROLL_MULTIPLIER = 0.45;
    var handleScroll = (0,react.useCallback)(function() {
        if (!enabled || !heroRef.current || !contentRef.current) return;
        var scrollPosition = window.scrollY;
        setScrollY(scrollPosition);
        var heroRect = heroRef.current.getBoundingClientRect();
        var contentRect = contentRef.current.getBoundingClientRect();
        // Check if text content is overlapping with the background image
        var heroTop = heroRect.top + scrollPosition;
        var heroBottom = heroTop + heroRect.height;
        var contentTop = contentRect.top + scrollPosition;
        var contentBottom = contentTop + contentRect.height;
        // Determine if text is inside the image area based on scroll position
        var isInside = contentTop < heroBottom && contentBottom > heroTop;
        setIsTextInside(isInside);
    }, [
        enabled
    ]);
    (0,react.useEffect)(function() {
        if (!enabled) return undefined;
        handleScroll();
        window.addEventListener("scroll", handleScroll, {
            passive: true
        });
        window.addEventListener("resize", handleScroll, {
            passive: true
        });
        return function() {
            window.removeEventListener("scroll", handleScroll);
            window.removeEventListener("resize", handleScroll);
        };
    }, [
        enabled,
        handleScroll
    ]);
    var getImageTransform = (0,react.useCallback)(function() {
        if (!enabled) return {};
        // Image stays sticky/fixed - no transform needed
        return {};
    }, [
        enabled
    ]);
    var getImageStyles = (0,react.useCallback)(function() {
        if (!enabled) return {};
        // Image stays in normal position
        return {};
    }, [
        enabled
    ]);
    var getTextTransform = (0,react.useCallback)(function() {
        if (!enabled || !heroRef.current) return {};
        // Get hero element position
        var heroRect = heroRef.current.getBoundingClientRect();
        var heroTop = heroRect.top + scrollY;
        // Only apply parallax when hero is in viewport
        if (heroRect.bottom < 0 || heroRect.top > window.innerHeight) {
            return {};
        }
        // Text moves down significantly as you scroll
        var scrollDelta = scrollY - heroTop;
        var parallaxOffset = Math.max(UPWARD_MOVEMENT_LIMIT, Math.min(PARALLAX_MAX_OFFSET, scrollDelta * PARALLAX_SCROLL_MULTIPLIER) // Even more downward movement
        );
        return {
            transform: "translateY(".concat(parallaxOffset, "px)"),
            willChange: "transform"
        };
    }, [
        enabled,
        scrollY
    ]);
    var getTextColor = (0,react.useCallback)(function() {
        if (!enabled) return "currentColor";
        if (isTextInside && textColorInside) {
            return textColorInside;
        }
        if (!isTextInside && textColorOutside) {
            return textColorOutside;
        }
        return "currentColor";
    }, [
        enabled,
        isTextInside,
        textColorInside,
        textColorOutside
    ]);
    return {
        heroRef: heroRef,
        contentRef: contentRef,
        scrollY: scrollY,
        isTextInside: isTextInside,
        getImageTransform: getImageTransform,
        getImageStyles: getImageStyles,
        getTextTransform: getTextTransform,
        getTextColor: getTextColor,
        enabled: enabled
    };
};

;// CONCATENATED MODULE: ./src/sections/Hero/Image/Image.theme.js

var Hero_Image_Image_theme_themed = (0,create/* create */.U)(new function() {
    this.image = {
        position: "absolute",
        width: "100%",
        height: "100%",
        top: 0,
        left: 0,
        bottom: 0,
        right: 0
    };
}());

;// CONCATENATED MODULE: ./src/sections/Hero/Image/Image.jsx





var Hero_Image_Image_Image = Hero_Image_Image_theme_themed(function(param) {
    var theme = param.theme, image = param.image, preload = param.preload, aboveTheFold = param.aboveTheFold, parallax = param.parallax;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    if (!(image === null || image === void 0 ? void 0 : (ref = image.imageDt) === null || ref === void 0 ? void 0 : ref.src)) return null;
    var parallaxTransform = (parallax === null || parallax === void 0 ? void 0 : parallax.enabled) ? parallax.getImageTransform() : {};
    var parallaxImageStyles = (parallax === null || parallax === void 0 ? void 0 : parallax.enabled) ? parallax.getImageStyles() : {};
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_jsx_runtime_esm/* Fragment */.HY, {
        children: [
            (image === null || image === void 0 ? void 0 : image.image) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Picture */.t, {
                "data-comp": Hero_Image_Image_Image.displayName,
                alt: image === null || image === void 0 ? void 0 : image.alt,
                aboveTheFold: aboveTheFold,
                images: [
                    {
                        src: image === null || image === void 0 ? void 0 : (ref1 = image.image) === null || ref1 === void 0 ? void 0 : ref1.src,
                        width: 768,
                        ratio: 1.1
                    }, 
                ],
                sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.image, parallaxImageStyles, parallaxTransform), {
                    display: (image === null || image === void 0 ? void 0 : image.imageDt) ? [
                        "block",
                        "none"
                    ] : ""
                }),
                preload: preload,
                width: image === null || image === void 0 ? void 0 : (ref2 = image.image) === null || ref2 === void 0 ? void 0 : ref2.width,
                height: image === null || image === void 0 ? void 0 : (ref3 = image.image) === null || ref3 === void 0 ? void 0 : ref3.height,
                imageSx: (0,_object_spread/* default */.Z)({
                    objectPosition: [
                        image === null || image === void 0 ? void 0 : image.position,
                        image === null || image === void 0 ? void 0 : image.positionDt
                    ]
                }, parallaxImageStyles)
            }),
            (image === null || image === void 0 ? void 0 : image.imageDt) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Picture */.t, {
                "data-comp": Hero_Image_Image_Image.displayName,
                alt: image === null || image === void 0 ? void 0 : image.alt,
                aboveTheFold: aboveTheFold,
                images: [
                    {
                        src: image === null || image === void 0 ? void 0 : (ref4 = image.imageDt) === null || ref4 === void 0 ? void 0 : ref4.src,
                        width: 1024,
                        ratio: 1.2
                    },
                    {
                        src: image === null || image === void 0 ? void 0 : (ref5 = image.imageDt) === null || ref5 === void 0 ? void 0 : ref5.src,
                        width: 1280,
                        ratio: 1.2
                    },
                    {
                        src: image === null || image === void 0 ? void 0 : (ref6 = image.imageDt) === null || ref6 === void 0 ? void 0 : ref6.src,
                        width: 1440,
                        ratio: 1.2
                    }, 
                ],
                sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.image, parallaxImageStyles, parallaxTransform), {
                    display: (image === null || image === void 0 ? void 0 : image.image) ? [
                        "none",
                        "block"
                    ] : ""
                }),
                preload: preload,
                width: image === null || image === void 0 ? void 0 : (ref7 = image.imageDt) === null || ref7 === void 0 ? void 0 : ref7.width,
                height: image === null || image === void 0 ? void 0 : (ref8 = image.imageDt) === null || ref8 === void 0 ? void 0 : ref8.height,
                imageSx: (0,_object_spread/* default */.Z)({
                    objectPosition: [
                        image === null || image === void 0 ? void 0 : image.position,
                        image === null || image === void 0 ? void 0 : image.positionDt
                    ]
                }, parallaxImageStyles)
            })
        ]
    });
});
Hero_Image_Image_Image.displayName = "Image";

;// CONCATENATED MODULE: ./src/sections/Hero/Image/index.js


;// CONCATENATED MODULE: ./src/sections/Hero/Content/Content.theme.js

var Hero_Content_Content_theme_themed = (0,create/* create */.U)(new function() {
    this.contentBelow = {
        position: "relative"
    };
    this.contentWrapper = {
        display: "flex",
        flexDirection: "column",
        height: "100%",
        width: "100%",
        pointerEvents: "none",
        position: "relative"
    };
    this.content = {
        height: "fit-content",
        width: "100%",
        px: 12,
        pointerEvents: "auto",
        "@media only screen and (max-width: 479px)": {
            px: 0
        }
    };
    this.superheading = {
        variant: "text.label.1",
        display: [
            "none",
            "block"
        ]
    };
    this.heading = function(fontFamily) {
        return {
            mt: 5,
            variant: "text.h2",
            fontFamily: fontFamily === "text.h1.2" ? "heading" : "Reckless Neue"
        };
    };
    this.subheading = {
        variant: "text.lg"
    };
    this.buttons = {
        mt: [
            11,
            12
        ],
        gridAutoFlow: "column",
        gridGap: 9,
        "@media only screen and (max-width: 479px)": {
            gridAutoFlow: "row",
            gridGap: 6
        }
    };
}());

;// CONCATENATED MODULE: ./src/sections/Hero/Content/CTA.jsx
/* eslint-disable jsx-a11y/anchor-is-valid */ 

function CTA(param) {
    var mobile = param.mobile, desktop = param.desktop, index = param.index, url = param.url, newTab = param.newTab, clickable = param.clickable, text = param.text;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_jsx_runtime_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Link */.rU, {
                "data-comp": "".concat(CTA.displayName, "desktopButton"),
                variant: "buttons.".concat(desktop || "secondary"),
                href: clickable ? null : url,
                sx: {
                    display: [
                        "none",
                        "block"
                    ],
                    cursor: "pointer"
                },
                children: text
            }, "".concat(index, "desktop")),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Link */.rU, {
                "data-comp": "".concat(CTA.displayName, "mobileButton"),
                variant: "buttons.".concat(mobile || "secondary"),
                href: clickable ? null : url,
                sx: {
                    display: [
                        "block",
                        "none"
                    ],
                    cursor: "pointer"
                },
                children: text
            }, "".concat(index, "mobile"))
        ]
    });
}
CTA.displayName = "CTA";

;// CONCATENATED MODULE: ./src/sections/Hero/Content/Content.jsx











var Hero_Content_Content_Content = Hero_Content_Content_theme_themed(function(_param) {
    var theme = _param.theme, content = _param.content, isContentBelow = _param.isContentBelow, clickable = _param.clickable, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme",
        "content",
        "isContentBelow",
        "clickable"
    ]);
    var ref, ref1;
    var text = content.text, button = content.button, settings = content.settings, parallax = content.parallax;
    var baseColor = [
        (text === null || text === void 0 ? void 0 : text.color) || "currentColor",
        (text === null || text === void 0 ? void 0 : text.colorDt) || "currentColor", 
    ];
    var parallaxColor = (parallax === null || parallax === void 0 ? void 0 : parallax.enabled) ? parallax.getTextColor() : null;
    var color = parallaxColor ? [
        parallaxColor,
        parallaxColor
    ] : baseColor;
    var textAlign = [
        settings === null || settings === void 0 ? void 0 : settings.alignment,
        settings === null || settings === void 0 ? void 0 : settings.alignmentDt
    ];
    var flexAlign = textAlign.map(function(align) {
        return (0,utils_common/* convertAlignToFlex */.nG)(align);
    });
    // Mobile content position
    var posMb = (0,react.useMemo)(function() {
        return (0,utils_common/* parseContentPosition */.M0)(settings === null || settings === void 0 ? void 0 : settings.position);
    }, [
        settings === null || settings === void 0 ? void 0 : settings.position
    ]);
    // Desktop content position
    var posDt = (0,react.useMemo)(function() {
        return (0,utils_common/* parseContentPosition */.M0)(settings === null || settings === void 0 ? void 0 : settings.positionDt);
    }, [
        settings === null || settings === void 0 ? void 0 : settings.positionDt
    ]);
    var calculatedMaxWidth = (0,react.useMemo)(function() {
        return (settings === null || settings === void 0 ? void 0 : settings.maxWidthDt) ? [
            settings.maxWidth + theme_space/* space.12 */.D[12] * 2,
            settings.maxWidthDt + theme_space/* space.15 */.D[15] * 2, 
        ] : "unset";
    }, [
        settings
    ]);
    var textTransform = (parallax === null || parallax === void 0 ? void 0 : parallax.enabled) ? parallax.getTextTransform() : {};
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
        "data-comp": Hero_Content_Content_Content.displayName,
        sx: (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.contentWrapper), {
            justifyContent: [
                posMb.justifyContent,
                posDt.justifyContent
            ]
        }), props.sx),
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
            sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, textTransform), {
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: [
                    posMb.alignItems,
                    posDt.alignItems
                ]
            }),
            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                ref: parallax === null || parallax === void 0 ? void 0 : parallax.contentRef,
                sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.content), {
                    maxWidth: calculatedMaxWidth,
                    mx: isContentBelow ? 0 : [
                        settings === null || settings === void 0 ? void 0 : settings.margin,
                        settings === null || settings === void 0 ? void 0 : settings.marginDt
                    ],
                    py: isContentBelow ? [
                        10,
                        12
                    ] : [
                        15,
                        17
                    ]
                }),
                children: [
                    (text === null || text === void 0 ? void 0 : text.superheading) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                        as: "h6",
                        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.superheading), {
                            textAlign: textAlign,
                            color: color
                        }),
                        children: text === null || text === void 0 ? void 0 : text.superheading
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Markdown */.UG, {
                        text: text === null || text === void 0 ? void 0 : text.heading,
                        textSx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.heading(text === null || text === void 0 ? void 0 : text.headingOption)), {
                            textAlign: textAlign,
                            color: color
                        }),
                        sx: {
                            mb: (text === null || text === void 0 ? void 0 : text.subheading) ? [
                                4,
                                6
                            ] : 0,
                            "h1,h2,h3": {
                                fontSize: [
                                    "".concat(text.mobileFontSize === "custom" ? text.customMobileFontSize || 44 : text.mobileFontSize || 44, "px"),
                                    "".concat(text.desktopFontSize === "custom" ? text.customDesktopFontSize || 84 : text.desktopFontSize || 84, "px"), 
                                ],
                                lineHeight: "1"
                            }
                        }
                    }),
                    (text === null || text === void 0 ? void 0 : text.subheading) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Markdown */.UG, {
                        text: text === null || text === void 0 ? void 0 : text.subheading,
                        textSx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.subheading), {
                            textAlign: textAlign,
                            color: color
                        })
                    }),
                    !(button === null || button === void 0 ? void 0 : button.hideButtons) && (button === null || button === void 0 ? void 0 : (ref = button.buttons) === null || ref === void 0 ? void 0 : ref.length) > 0 && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Grid */.rj, {
                        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.buttons), {
                            justifyContent: flexAlign,
                            "@media only screen and (max-width: 479px)": {
                                alignItems: flexAlign
                            }
                        }),
                        children: button === null || button === void 0 ? void 0 : (ref1 = button.buttons) === null || ref1 === void 0 ? void 0 : ref1.slice(0, 2).map(function(item, index) {
                            var ref, ref1, ref2;
                            return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(CTA, {
                                index: index,
                                desktop: item === null || item === void 0 ? void 0 : item.styleDt,
                                mobile: item === null || item === void 0 ? void 0 : item.style,
                                newTab: item === null || item === void 0 ? void 0 : (ref = item.cta) === null || ref === void 0 ? void 0 : ref.newTab,
                                text: item === null || item === void 0 ? void 0 : (ref1 = item.cta) === null || ref1 === void 0 ? void 0 : ref1.text,
                                url: item === null || item === void 0 ? void 0 : (ref2 = item.cta) === null || ref2 === void 0 ? void 0 : ref2.url,
                                clickable: clickable && !isContentBelow
                            }, index);
                        })
                    })
                ]
            })
        })
    });
});
Hero_Content_Content_Content.displayName = "Content";

;// CONCATENATED MODULE: ./src/sections/Hero/Content/ContentBelow.jsx






var ContentBelow = Hero_Content_Content_theme_themed(function(param) {
    var theme = param.theme, bgColor = param.bgColor, content = param.content;
    var ref, ref1;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Container */.W2, {
        "data-comp": ContentBelow.displayName,
        children: (content === null || content === void 0 ? void 0 : (ref = content.image) === null || ref === void 0 ? void 0 : (ref1 = ref.imageDt) === null || ref1 === void 0 ? void 0 : ref1.src) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
            sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.content), {
                bg: bgColor || "background"
            }),
            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Hero_Content_Content_Content, {
                content: content,
                isContentBelow: true
            })
        })
    });
});
ContentBelow.displayName = "ContentBelow";

;// CONCATENATED MODULE: ./src/sections/Hero/Content/index.js



;// CONCATENATED MODULE: ./src/sections/Hero/Hero.theme.js

var Hero_theme_themed = (0,create/* create */.U)(new function() {
    this.hero = {
        bg: "ghostwhite",
        display: "flex",
        flexDirection: "column"
    }, this.contentWrapper = {
        height: "100%",
        position: "relative",
        width: "100%"
    };
}());

;// CONCATENATED MODULE: ./src/sections/Hero/Hero.schema.js




var Hero_schema_image = function(param) {
    var position = param.position;
    return {
        label: "Image Settings",
        name: "image",
        description: "Image, image position, media type",
        component: "group",
        fields: [
            {
                name: "alt",
                component: "text",
                description: "Provide a brief description of the image for accessibility compliance",
                label: "Alt"
            },
            {
                name: "mediaType",
                component: "radio-group",
                direction: "horizontal",
                variant: "radio",
                label: "Media Type",
                options: [
                    {
                        label: "Image",
                        value: "image"
                    },
                    {
                        label: "GIF",
                        value: "gif"
                    }, 
                ],
                defaultValue: "image"
            },
            {
                name: "imageDt",
                label: "Image (desktop)",
                component: "image"
            },
            {
                name: "positionDt",
                component: "select",
                label: "Image position (desktop)",
                options: position.object
            },
            {
                name: "image",
                label: "Image (mobile)",
                component: "image"
            },
            {
                name: "position",
                component: "select",
                label: "Image position (mobile)",
                options: position.object
            }, 
        ],
        defaultValue: {
            alt: "Hero image",
            imageDt: {
                src: "https://cdn.shopify.com/s/files/1/1114/2308/files/HeroBg.png"
            },
            positionDt: "left center",
            image: {
                src: "https://cdn.shopify.com/s/files/1/1114/2308/files/Screen_Shot_2022-04-27_at_2.33.14_PM.png"
            },
            position: "left center"
        }
    };
};
var Hero_schema_text = function(param) {
    var color = param.color;
    return {
        label: "Text Settings",
        name: "text",
        description: "Superheading, heading, subheading, text color",
        component: "group",
        fields: [
            {
                name: "superheading",
                component: "text",
                label: "Superheading"
            },
            {
                name: "heading",
                component: "markdown",
                label: "Heading",
                description: 'Tip: You can ensure heading is "h1" by starting with "# " e.g. "# Shop All". Text below will become large and bold to indicate "h1"'
            },
            {
                name: "headingOption",
                label: "Font Family Heading Option",
                component: "radio-group",
                direction: "horizontal",
                variant: "radio",
                options: [
                    {
                        label: "Reckless Neue",
                        value: "text.h1"
                    },
                    {
                        label: "Fellix",
                        value: "text.h1.2"
                    }, 
                ],
                defaultValue: "text.h1"
            },
            {
                name: "desktopFontSize",
                component: "select",
                label: "Heading Desktop Font Size",
                description: "Font size for desktop devices",
                options: [
                    {
                        label: "60px",
                        value: 60
                    },
                    {
                        label: "72px",
                        value: 72
                    },
                    {
                        label: "84px (Default)",
                        value: 84
                    },
                    {
                        label: "96px",
                        value: 96
                    },
                    {
                        label: "108px",
                        value: 108
                    },
                    {
                        label: "Custom",
                        value: "custom"
                    }, 
                ],
                defaultValue: 84
            },
            {
                name: "customDesktopFontSize",
                component: "number",
                label: "Custom Heading Desktop Font Size (px)",
                description: 'Only used when "Custom" is selected above',
                condition: {
                    component: "desktopFontSize",
                    operator: "===",
                    value: "custom"
                }
            },
            {
                name: "mobileFontSize",
                component: "select",
                label: "Heading Mobile Font Size",
                description: "Font size for mobile devices",
                options: [
                    {
                        label: "32px",
                        value: 32
                    },
                    {
                        label: "40px",
                        value: 40
                    },
                    {
                        label: "44px (Default)",
                        value: 44
                    },
                    {
                        label: "48px",
                        value: 48
                    },
                    {
                        label: "56px",
                        value: 56
                    },
                    {
                        label: "Custom",
                        value: "custom"
                    }, 
                ],
                defaultValue: 44
            },
            {
                name: "customMobileFontSize",
                component: "number",
                label: "Custom Heading Mobile Font Size (px)",
                description: 'Only used when "Custom" is selected above',
                condition: {
                    component: "mobileFontSize",
                    operator: "===",
                    value: "custom"
                }
            },
            {
                name: "subheading",
                component: "markdown",
                label: "Subheading / Body",
                description: "Tip: You can add in-line links by highlighting the section of text and clicking the link button in the menu options"
            },
            {
                component: "select",
                name: "colorDt",
                label: "Text color (tablet & desktop)",
                options: [
                    {
                        label: "Default",
                        value: ""
                    }
                ].concat((0,_to_consumable_array/* default */.Z)(color.options))
            },
            {
                component: "select",
                name: "color",
                label: "Text color (mobile)",
                options: [
                    {
                        label: "Default",
                        value: ""
                    }
                ].concat((0,_to_consumable_array/* default */.Z)(color.options))
            }, 
        ],
        defaultValue: {
            superheading: "our commitment",
            heading: "## See what everybody is talking about",
            desktopFontSize: 84,
            customDesktopFontSize: 84,
            mobileFontSize: 44,
            customMobileFontSize: 44,
            subheading: "Morbi leo risus, porta ac consectetur ac, vestibulum at eros. Nulla vitae elit libero, a pharetra augue. Aenean Cursus Curabitur blandit tempus. Link here",
            color: "",
            colorDt: ""
        }
    };
};
var buttons = function(param) {
    var button = param.button;
    return {
        label: "Button Settings",
        name: "button",
        description: "Buttons, clickable hero",
        component: "group",
        fields: [
            {
                label: "Clickable hero",
                description: "Allows entire hero to be clickable, using the first button link as url. Note: You MUST provide a valid URL in a button before this option will activate",
                name: "clickableHero",
                component: "toggle",
                toggleLabels: {
                    true: "On",
                    false: "Off"
                },
                defaultValue: false
            },
            {
                label: "Hide buttons",
                name: "hideButtons",
                component: "toggle",
                toggleLabels: {
                    true: "On",
                    false: "Off"
                },
                defaultValue: false
            },
            {
                name: "buttons",
                label: "Buttons",
                component: "group-list",
                description: "Max of 2 buttons",
                itemProps: {
                    label: "{{item.cta.text}}"
                },
                validate: {
                    maxItems: 2
                },
                defaultItem: {
                    cta: {
                        text: "Learn More",
                        url: "/collections/all"
                    },
                    style: "inverse"
                },
                fields: [
                    {
                        name: "cta",
                        component: "link",
                        label: "Button"
                    },
                    {
                        name: "styleDt",
                        label: "Button style",
                        component: "select",
                        options: button.options
                    },
                    {
                        name: "style",
                        label: "Button style (mobile)",
                        component: "select",
                        description: "Optional",
                        options: button.options
                    }, 
                ],
                defaultValue: [
                    {
                        cta: {
                            text: "Learn More",
                            url: "/collections/all"
                        },
                        styleDt: "inverseSecondary",
                        style: "primary"
                    }, 
                ]
            }, 
        ]
    };
};
var parallaxSettings = function(param) {
    var color = param.color;
    return {
        name: "parallaxSettings",
        label: "Parallax Settings",
        description: "Parallax animation and text color settings",
        component: "group",
        fields: [
            {
                name: "enabled",
                label: "Enable Parallax",
                component: "toggle",
                toggleLabels: {
                    true: "On",
                    false: "Off"
                },
                defaultValue: false
            },
            {
                name: "textColorOutside",
                component: "select",
                label: "Text color (outside image)",
                description: "Text color when outside the background image area",
                options: [
                    {
                        label: "Default",
                        value: ""
                    }
                ].concat((0,_to_consumable_array/* default */.Z)(color.options))
            },
            {
                name: "textColorInside",
                component: "select",
                label: "Text color (inside image)",
                description: "Text color when inside the background image area",
                options: [
                    {
                        label: "Default",
                        value: ""
                    }
                ].concat((0,_to_consumable_array/* default */.Z)(color.options))
            },
            {
                name: "animationType",
                component: "radio-group",
                direction: "horizontal",
                variant: "radio",
                label: "Animation Type",
                options: [
                    {
                        label: "Hero Section (Sticky)",
                        value: "hero"
                    }
                ],
                defaultValue: "hero"
            }, 
        ],
        defaultValue: {
            enabled: false,
            textColorOutside: "",
            textColorInside: "",
            animationType: "hero"
        }
    };
};
var contentSettings = function(param) {
    var position = param.position;
    return {
        name: "contentSettings",
        label: "Content Settings",
        description: "Content alignment, content position",
        component: "group",
        fields: [
            {
                name: "placementDt",
                component: "radio-group",
                direction: "horizontal",
                variant: "radio",
                label: "Placement",
                options: [
                    {
                        label: "Contained",
                        value: "absolute"
                    },
                    {
                        label: "Below",
                        value: "relative"
                    }, 
                ]
            },
            {
                component: "radio-group",
                direction: "horizontal",
                variant: "radio",
                name: "placement",
                label: "Placement (mobile)",
                options: [
                    {
                        label: "Contained",
                        value: "absolute"
                    },
                    {
                        label: "Below",
                        value: "relative"
                    }, 
                ]
            },
            {
                name: "marginDt",
                component: "number",
                label: "Contained margin (px)",
                description: "Optional: Add horizontal margin to the contained placement"
            },
            {
                name: "margin",
                component: "number",
                label: "Contained margin (mobile)"
            },
            {
                name: "maxWidthDt",
                component: "number",
                label: "Max content pixel width",
                description: "Note: Leaving this blank will default to the max width of the hero"
            },
            {
                name: "maxWidth",
                component: "number",
                label: "Max content pixel width (mobile)"
            },
            {
                name: "alignmentDt",
                label: "Alignment",
                component: "radio-group",
                direction: "horizontal",
                variant: "radio",
                options: common/* align.options */.AJ.options
            },
            {
                name: "positionDt",
                component: "select",
                label: "Position",
                options: position.flex
            },
            {
                name: "alignment",
                label: "Alignment (mobile)",
                component: "radio-group",
                direction: "horizontal",
                variant: "radio",
                options: common/* align.options */.AJ.options
            },
            {
                name: "position",
                component: "select",
                label: "Position (mobile)",
                options: position.flex
            }, 
        ],
        defaultValue: {
            placementDt: "absolute",
            placement: "relative",
            maxWidthDt: 420,
            marginDt: 100,
            alignmentDt: "left",
            positionDt: "flex-end center",
            alignment: "left"
        }
    };
};
var section = function(param) {
    var sectionWithHeight = param.sectionWithHeight;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sectionWithHeight), {
        fields: [
            {
                label: "Above the fold",
                name: "aboveTheFold",
                component: "toggle",
                toggleLabels: {
                    true: "Yes",
                    false: "No"
                },
                defaultValue: false
            }, 
        ].concat((0,_to_consumable_array/* default */.Z)(sectionWithHeight.fields)),
        defaultValue: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sectionWithHeight.desktop), {
            desktop: {
                container: "content",
                maxHeight: 540,
                minHeight: 540
            }
        }), sectionWithHeight.mobile), {
            mobile: {
                container: "content",
                maxHeight: 240,
                minHeight: 240
            }
        })
    });
};
var defaultHero = function(param) {
    var button = param.button;
    return {
        image: {
            alt: "A drink being raised in the air.",
            mediaType: "image",
            imageDt: {
                src: "https://cdn.shopify.com/s/files/1/1114/2308/files/HeroBg.png"
            },
            positionDt: "center bottom",
            image: {
                src: "https://cdn.shopify.com/s/files/1/1114/2308/files/Screen_Shot_2022-04-27_at_2.33.14_PM.png"
            },
            position: "left center"
        },
        text: {
            superheading: "Our commitment",
            heading: "## See what everybody is talking about",
            subheading: "Morbi leo risus, porta ac consectetur ac, vestibulum at eros. Nulla vitae elit libero, a pharetra augue. Aenean Cursus Curabitur blandit tempus. [Link here](./)"
        },
        button: {
            buttons: [
                {
                    cta: {
                        text: "learn more",
                        url: "/collections/all"
                    },
                    styleDt: button.value.inverseSecondary,
                    style: button.value.primary
                }, 
            ]
        },
        contentSettings: {
            placementDt: "absolute",
            placement: "relative",
            maxWidthDt: 420,
            marginDt: 100,
            alignmentDt: "left",
            positionDt: "flex-end center",
            alignment: "left"
        },
        parallaxSettings: {
            enabled: false,
            textColorOutside: "",
            textColorInside: "",
            animationType: "hero"
        }
    };
};
var Hero_schema_Schema = function() {
    return {
        label: "Hero",
        key: "hero",
        fields: [
            Hero_schema_image({
                position: common/* position */.FK
            }),
            Hero_schema_text({
                color: common/* color */.$_
            }),
            buttons({
                button: common/* button */.LI
            }),
            contentSettings({
                position: common/* position */.FK
            }),
            parallaxSettings({
                color: common/* color */.$_
            }),
            section({
                sectionWithHeight: common/* sectionWithHeight */.Z1
            }), 
        ],
        defaultValue: defaultHero({
            button: common/* button */.LI
        })
    };
};

;// CONCATENATED MODULE: ./src/sections/Hero/Hero.jsx












var Hero = (0,src_utils/* withInView */.Dh)(Hero_theme_themed(function(param) {
    var theme = param.theme, cms = param.cms;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var button = cms.button, image = cms.image, text = cms.text, contentSettings = cms.contentSettings, section = cms.section, parallaxSettings = cms.parallaxSettings;
    var ref8 = (0,_object_spread/* default */.Z)({}, contentSettings), placement = ref8.placement, placementDt = ref8.placementDt;
    var parallax = useParallax({
        enabled: parallaxSettings === null || parallaxSettings === void 0 ? void 0 : parallaxSettings.enabled,
        textColorOutside: parallaxSettings === null || parallaxSettings === void 0 ? void 0 : parallaxSettings.textColorOutside,
        textColorInside: parallaxSettings === null || parallaxSettings === void 0 ? void 0 : parallaxSettings.textColorInside
    });
    var content = (0,react.useMemo)(function() {
        return {
            image: image,
            text: text,
            button: button,
            settings: contentSettings,
            parallax: parallax
        };
    }, [
        cms,
        parallax
    ]);
    var cta = button === null || button === void 0 ? void 0 : (ref = button.buttons) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.cta;
    var clickable = (button === null || button === void 0 ? void 0 : button.clickableHero) && !!(cta === null || cta === void 0 ? void 0 : cta.url);
    var height = (0,react.useMemo)(function() {
        var ref, ref1;
        return [
            (0,src_utils/* calcResponsiveHeight */.ku)({
                maxHeight: section === null || section === void 0 ? void 0 : (ref = section.mobile) === null || ref === void 0 ? void 0 : ref.maxHeight,
                viewport: 768
            }),
            (0,src_utils/* calcResponsiveHeight */.ku)({
                maxHeight: section === null || section === void 0 ? void 0 : (ref1 = section.desktop) === null || ref1 === void 0 ? void 0 : ref1.maxHeight,
                viewport: 1280
            }), 
        ];
    }, [
        section === null || section === void 0 ? void 0 : (ref2 = section.mobile) === null || ref2 === void 0 ? void 0 : ref2.maxHeight,
        section === null || section === void 0 ? void 0 : (ref3 = section.desktop) === null || ref3 === void 0 ? void 0 : ref3.maxHeight
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(snippets/* Section */.$0, {
        section: section,
        suppressHydrationWarning: true,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Link */.rU, {
                "data-comp": Hero.displayName,
                href: clickable ? cta === null || cta === void 0 ? void 0 : cta.url : null,
                newTab: cta === null || cta === void 0 ? void 0 : cta.newTab,
                "aria-label": clickable && (button === null || button === void 0 ? void 0 : button.hideButtons) ? cta === null || cta === void 0 ? void 0 : cta.text : "",
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Container */.W2, {
                    ref: parallax.heroRef,
                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.hero), {
                        height: height,
                        minHeight: [
                            "".concat(section === null || section === void 0 ? void 0 : (ref4 = section.mobile) === null || ref4 === void 0 ? void 0 : ref4.minHeight, "px"),
                            "".concat(section === null || section === void 0 ? void 0 : (ref5 = section.desktop) === null || ref5 === void 0 ? void 0 : ref5.minHeight, "px"), 
                        ],
                        maxHeight: [
                            "".concat(section === null || section === void 0 ? void 0 : (ref6 = section.mobile) === null || ref6 === void 0 ? void 0 : ref6.maxHeight, "px"),
                            "".concat(section === null || section === void 0 ? void 0 : (ref7 = section.desktop) === null || ref7 === void 0 ? void 0 : ref7.maxHeight, "px"), 
                        ],
                        cursor: clickable ? "pointer" : "auto",
                        overflow: "hidden",
                        position: "relative"
                    }),
                    children: [
                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Hero_Image_Image_Image, {
                            image: image,
                            preload: section.aboveTheFold,
                            aboveTheFold: section.aboveTheFold,
                            parallax: parallax
                        }),
                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                            sx: {
                                display: [
                                    placement === "relative" ? "none" : "block",
                                    placementDt === "relative" ? "none" : "block", 
                                ],
                                height: "100%"
                            },
                            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Hero_Content_Content_Content, {
                                content: content,
                                clickable: clickable
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                sx: {
                    display: [
                        placement === "relative" ? "block" : "none",
                        placementDt === "relative" ? "block" : "none", 
                    ]
                },
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(ContentBelow, {
                    bgColor: section === null || section === void 0 ? void 0 : section.bgColor,
                    content: content
                })
            })
        ]
    });
}), {
    triggerOnce: true
});
Hero.displayName = "Hero";
Hero.Schema = Hero_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/Hero/index.js


;// CONCATENATED MODULE: ../node_modules/luxon/src/errors.js
// these aren't really private, but nor are they really useful to document

/**
 * @private
 */
class LuxonError extends Error {}

/**
 * @private
 */
class InvalidDateTimeError extends LuxonError {
  constructor(reason) {
    super(`Invalid DateTime: ${reason.toMessage()}`);
  }
}

/**
 * @private
 */
class InvalidIntervalError extends LuxonError {
  constructor(reason) {
    super(`Invalid Interval: ${reason.toMessage()}`);
  }
}

/**
 * @private
 */
class InvalidDurationError extends LuxonError {
  constructor(reason) {
    super(`Invalid Duration: ${reason.toMessage()}`);
  }
}

/**
 * @private
 */
class ConflictingSpecificationError extends LuxonError {}

/**
 * @private
 */
class InvalidUnitError extends LuxonError {
  constructor(unit) {
    super(`Invalid unit ${unit}`);
  }
}

/**
 * @private
 */
class InvalidArgumentError extends LuxonError {}

/**
 * @private
 */
class ZoneIsAbstractError extends LuxonError {
  constructor() {
    super("Zone is an abstract class");
  }
}

;// CONCATENATED MODULE: ../node_modules/luxon/src/impl/formats.js
/**
 * @private
 */

const n = "numeric",
  s = "short",
  l = "long";

const DATE_SHORT = {
  year: n,
  month: n,
  day: n,
};

const DATE_MED = {
  year: n,
  month: s,
  day: n,
};

const DATE_MED_WITH_WEEKDAY = {
  year: n,
  month: s,
  day: n,
  weekday: s,
};

const DATE_FULL = {
  year: n,
  month: l,
  day: n,
};

const DATE_HUGE = {
  year: n,
  month: l,
  day: n,
  weekday: l,
};

const TIME_SIMPLE = {
  hour: n,
  minute: n,
};

const TIME_WITH_SECONDS = {
  hour: n,
  minute: n,
  second: n,
};

const TIME_WITH_SHORT_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  timeZoneName: s,
};

const TIME_WITH_LONG_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  timeZoneName: l,
};

const TIME_24_SIMPLE = {
  hour: n,
  minute: n,
  hourCycle: "h23",
};

const TIME_24_WITH_SECONDS = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23",
};

const TIME_24_WITH_SHORT_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23",
  timeZoneName: s,
};

const TIME_24_WITH_LONG_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23",
  timeZoneName: l,
};

const DATETIME_SHORT = {
  year: n,
  month: n,
  day: n,
  hour: n,
  minute: n,
};

const DATETIME_SHORT_WITH_SECONDS = {
  year: n,
  month: n,
  day: n,
  hour: n,
  minute: n,
  second: n,
};

const DATETIME_MED = {
  year: n,
  month: s,
  day: n,
  hour: n,
  minute: n,
};

const DATETIME_MED_WITH_SECONDS = {
  year: n,
  month: s,
  day: n,
  hour: n,
  minute: n,
  second: n,
};

const DATETIME_MED_WITH_WEEKDAY = {
  year: n,
  month: s,
  day: n,
  weekday: s,
  hour: n,
  minute: n,
};

const DATETIME_FULL = {
  year: n,
  month: l,
  day: n,
  hour: n,
  minute: n,
  timeZoneName: s,
};

const DATETIME_FULL_WITH_SECONDS = {
  year: n,
  month: l,
  day: n,
  hour: n,
  minute: n,
  second: n,
  timeZoneName: s,
};

const DATETIME_HUGE = {
  year: n,
  month: l,
  day: n,
  weekday: l,
  hour: n,
  minute: n,
  timeZoneName: l,
};

const DATETIME_HUGE_WITH_SECONDS = {
  year: n,
  month: l,
  day: n,
  weekday: l,
  hour: n,
  minute: n,
  second: n,
  timeZoneName: l,
};

;// CONCATENATED MODULE: ../node_modules/luxon/src/zone.js


/**
 * @interface
 */
class Zone {
  /**
   * The type of zone
   * @abstract
   * @type {string}
   */
  get type() {
    throw new ZoneIsAbstractError();
  }

  /**
   * The name of this zone.
   * @abstract
   * @type {string}
   */
  get name() {
    throw new ZoneIsAbstractError();
  }

  /**
   * The IANA name of this zone.
   * Defaults to `name` if not overwritten by a subclass.
   * @abstract
   * @type {string}
   */
  get ianaName() {
    return this.name;
  }

  /**
   * Returns whether the offset is known to be fixed for the whole year.
   * @abstract
   * @type {boolean}
   */
  get isUniversal() {
    throw new ZoneIsAbstractError();
  }

  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(ts, opts) {
    throw new ZoneIsAbstractError();
  }

  /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(ts, format) {
    throw new ZoneIsAbstractError();
  }

  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(ts) {
    throw new ZoneIsAbstractError();
  }

  /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(otherZone) {
    throw new ZoneIsAbstractError();
  }

  /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */
  get isValid() {
    throw new ZoneIsAbstractError();
  }
}

;// CONCATENATED MODULE: ../node_modules/luxon/src/zones/systemZone.js



let singleton = null;

/**
 * Represents the local zone for this JavaScript environment.
 * @implements {Zone}
 */
class SystemZone extends Zone {
  /**
   * Get a singleton instance of the local zone
   * @return {SystemZone}
   */
  static get instance() {
    if (singleton === null) {
      singleton = new SystemZone();
    }
    return singleton;
  }

  /** @override **/
  get type() {
    return "system";
  }

  /** @override **/
  get name() {
    return new Intl.DateTimeFormat().resolvedOptions().timeZone;
  }

  /** @override **/
  get isUniversal() {
    return false;
  }

  /** @override **/
  offsetName(ts, { format, locale }) {
    return parseZoneInfo(ts, format, locale);
  }

  /** @override **/
  formatOffset(ts, format) {
    return formatOffset(this.offset(ts), format);
  }

  /** @override **/
  offset(ts) {
    return -new Date(ts).getTimezoneOffset();
  }

  /** @override **/
  equals(otherZone) {
    return otherZone.type === "system";
  }

  /** @override **/
  get isValid() {
    return true;
  }
}

;// CONCATENATED MODULE: ../node_modules/luxon/src/zones/IANAZone.js



let dtfCache = {};
function makeDTF(zone) {
  if (!dtfCache[zone]) {
    dtfCache[zone] = new Intl.DateTimeFormat("en-US", {
      hour12: false,
      timeZone: zone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      era: "short",
    });
  }
  return dtfCache[zone];
}

const typeToPos = {
  year: 0,
  month: 1,
  day: 2,
  era: 3,
  hour: 4,
  minute: 5,
  second: 6,
};

function hackyOffset(dtf, date) {
  const formatted = dtf.format(date).replace(/\u200E/g, ""),
    parsed = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(formatted),
    [, fMonth, fDay, fYear, fadOrBc, fHour, fMinute, fSecond] = parsed;
  return [fYear, fMonth, fDay, fadOrBc, fHour, fMinute, fSecond];
}

function partsOffset(dtf, date) {
  const formatted = dtf.formatToParts(date);
  const filled = [];
  for (let i = 0; i < formatted.length; i++) {
    const { type, value } = formatted[i];
    const pos = typeToPos[type];

    if (type === "era") {
      filled[pos] = value;
    } else if (!isUndefined(pos)) {
      filled[pos] = parseInt(value, 10);
    }
  }
  return filled;
}

let ianaZoneCache = {};
/**
 * A zone identified by an IANA identifier, like America/New_York
 * @implements {Zone}
 */
class IANAZone extends Zone {
  /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */
  static create(name) {
    if (!ianaZoneCache[name]) {
      ianaZoneCache[name] = new IANAZone(name);
    }
    return ianaZoneCache[name];
  }

  /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCache() {
    ianaZoneCache = {};
    dtfCache = {};
  }

  /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @deprecated For backward compatibility, this forwards to isValidZone, better use `isValidZone()` directly instead.
   * @return {boolean}
   */
  static isValidSpecifier(s) {
    return this.isValidZone(s);
  }

  /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */
  static isValidZone(zone) {
    if (!zone) {
      return false;
    }
    try {
      new Intl.DateTimeFormat("en-US", { timeZone: zone }).format();
      return true;
    } catch (e) {
      return false;
    }
  }

  constructor(name) {
    super();
    /** @private **/
    this.zoneName = name;
    /** @private **/
    this.valid = IANAZone.isValidZone(name);
  }

  /**
   * The type of zone. `iana` for all instances of `IANAZone`.
   * @override
   * @type {string}
   */
  get type() {
    return "iana";
  }

  /**
   * The name of this zone (i.e. the IANA zone name).
   * @override
   * @type {string}
   */
  get name() {
    return this.zoneName;
  }

  /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns false for all IANA zones.
   * @override
   * @type {boolean}
   */
  get isUniversal() {
    return false;
  }

  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(ts, { format, locale }) {
    return parseZoneInfo(ts, format, locale, this.name);
  }

  /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(ts, format) {
    return formatOffset(this.offset(ts), format);
  }

  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @override
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(ts) {
    const date = new Date(ts);

    if (isNaN(date)) return NaN;

    const dtf = makeDTF(this.name);
    let [year, month, day, adOrBc, hour, minute, second] = dtf.formatToParts
      ? partsOffset(dtf, date)
      : hackyOffset(dtf, date);

    if (adOrBc === "BC") {
      year = -Math.abs(year) + 1;
    }

    // because we're using hour12 and https://bugs.chromium.org/p/chromium/issues/detail?id=1025564&can=2&q=%2224%3A00%22%20datetimeformat
    const adjustedHour = hour === 24 ? 0 : hour;

    const asUTC = objToLocalTS({
      year,
      month,
      day,
      hour: adjustedHour,
      minute,
      second,
      millisecond: 0,
    });

    let asTS = +date;
    const over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return (asUTC - asTS) / (60 * 1000);
  }

  /**
   * Return whether this Zone is equal to another zone
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(otherZone) {
    return otherZone.type === "iana" && otherZone.name === this.name;
  }

  /**
   * Return whether this Zone is valid.
   * @override
   * @type {boolean}
   */
  get isValid() {
    return this.valid;
  }
}

;// CONCATENATED MODULE: ../node_modules/luxon/src/impl/locale.js






// todo - remap caching

let intlLFCache = {};
function getCachedLF(locString, opts = {}) {
  const key = JSON.stringify([locString, opts]);
  let dtf = intlLFCache[key];
  if (!dtf) {
    dtf = new Intl.ListFormat(locString, opts);
    intlLFCache[key] = dtf;
  }
  return dtf;
}

let intlDTCache = {};
function getCachedDTF(locString, opts = {}) {
  const key = JSON.stringify([locString, opts]);
  let dtf = intlDTCache[key];
  if (!dtf) {
    dtf = new Intl.DateTimeFormat(locString, opts);
    intlDTCache[key] = dtf;
  }
  return dtf;
}

let intlNumCache = {};
function getCachedINF(locString, opts = {}) {
  const key = JSON.stringify([locString, opts]);
  let inf = intlNumCache[key];
  if (!inf) {
    inf = new Intl.NumberFormat(locString, opts);
    intlNumCache[key] = inf;
  }
  return inf;
}

let intlRelCache = {};
function getCachedRTF(locString, opts = {}) {
  const { base, ...cacheKeyOpts } = opts; // exclude `base` from the options
  const key = JSON.stringify([locString, cacheKeyOpts]);
  let inf = intlRelCache[key];
  if (!inf) {
    inf = new Intl.RelativeTimeFormat(locString, opts);
    intlRelCache[key] = inf;
  }
  return inf;
}

let sysLocaleCache = null;
function systemLocale() {
  if (sysLocaleCache) {
    return sysLocaleCache;
  } else {
    sysLocaleCache = new Intl.DateTimeFormat().resolvedOptions().locale;
    return sysLocaleCache;
  }
}

let weekInfoCache = {};
function getCachedWeekInfo(locString) {
  let data = weekInfoCache[locString];
  if (!data) {
    const locale = new Intl.Locale(locString);
    // browsers currently implement this as a property, but spec says it should be a getter function
    data = "getWeekInfo" in locale ? locale.getWeekInfo() : locale.weekInfo;
    weekInfoCache[locString] = data;
  }
  return data;
}

function parseLocaleString(localeStr) {
  // I really want to avoid writing a BCP 47 parser
  // see, e.g. https://github.com/wooorm/bcp-47
  // Instead, we'll do this:

  // a) if the string has no -u extensions, just leave it alone
  // b) if it does, use Intl to resolve everything
  // c) if Intl fails, try again without the -u

  // private subtags and unicode subtags have ordering requirements,
  // and we're not properly parsing this, so just strip out the
  // private ones if they exist.
  const xIndex = localeStr.indexOf("-x-");
  if (xIndex !== -1) {
    localeStr = localeStr.substring(0, xIndex);
  }

  const uIndex = localeStr.indexOf("-u-");
  if (uIndex === -1) {
    return [localeStr];
  } else {
    let options;
    let selectedStr;
    try {
      options = getCachedDTF(localeStr).resolvedOptions();
      selectedStr = localeStr;
    } catch (e) {
      const smaller = localeStr.substring(0, uIndex);
      options = getCachedDTF(smaller).resolvedOptions();
      selectedStr = smaller;
    }

    const { numberingSystem, calendar } = options;
    return [selectedStr, numberingSystem, calendar];
  }
}

function intlConfigString(localeStr, numberingSystem, outputCalendar) {
  if (outputCalendar || numberingSystem) {
    if (!localeStr.includes("-u-")) {
      localeStr += "-u";
    }

    if (outputCalendar) {
      localeStr += `-ca-${outputCalendar}`;
    }

    if (numberingSystem) {
      localeStr += `-nu-${numberingSystem}`;
    }
    return localeStr;
  } else {
    return localeStr;
  }
}

function mapMonths(f) {
  const ms = [];
  for (let i = 1; i <= 12; i++) {
    const dt = DateTime.utc(2009, i, 1);
    ms.push(f(dt));
  }
  return ms;
}

function mapWeekdays(f) {
  const ms = [];
  for (let i = 1; i <= 7; i++) {
    const dt = DateTime.utc(2016, 11, 13 + i);
    ms.push(f(dt));
  }
  return ms;
}

function listStuff(loc, length, englishFn, intlFn) {
  const mode = loc.listingMode();

  if (mode === "error") {
    return null;
  } else if (mode === "en") {
    return englishFn(length);
  } else {
    return intlFn(length);
  }
}

function supportsFastNumbers(loc) {
  if (loc.numberingSystem && loc.numberingSystem !== "latn") {
    return false;
  } else {
    return (
      loc.numberingSystem === "latn" ||
      !loc.locale ||
      loc.locale.startsWith("en") ||
      new Intl.DateTimeFormat(loc.intl).resolvedOptions().numberingSystem === "latn"
    );
  }
}

/**
 * @private
 */

class PolyNumberFormatter {
  constructor(intl, forceSimple, opts) {
    this.padTo = opts.padTo || 0;
    this.floor = opts.floor || false;

    const { padTo, floor, ...otherOpts } = opts;

    if (!forceSimple || Object.keys(otherOpts).length > 0) {
      const intlOpts = { useGrouping: false, ...opts };
      if (opts.padTo > 0) intlOpts.minimumIntegerDigits = opts.padTo;
      this.inf = getCachedINF(intl, intlOpts);
    }
  }

  format(i) {
    if (this.inf) {
      const fixed = this.floor ? Math.floor(i) : i;
      return this.inf.format(fixed);
    } else {
      // to match the browser's numberformatter defaults
      const fixed = this.floor ? Math.floor(i) : roundTo(i, 3);
      return padStart(fixed, this.padTo);
    }
  }
}

/**
 * @private
 */

class PolyDateFormatter {
  constructor(dt, intl, opts) {
    this.opts = opts;
    this.originalZone = undefined;

    let z = undefined;
    if (this.opts.timeZone) {
      // Don't apply any workarounds if a timeZone is explicitly provided in opts
      this.dt = dt;
    } else if (dt.zone.type === "fixed") {
      // UTC-8 or Etc/UTC-8 are not part of tzdata, only Etc/GMT+8 and the like.
      // That is why fixed-offset TZ is set to that unless it is:
      // 1. Representing offset 0 when UTC is used to maintain previous behavior and does not become GMT.
      // 2. Unsupported by the browser:
      //    - some do not support Etc/
      //    - < Etc/GMT-14, > Etc/GMT+12, and 30-minute or 45-minute offsets are not part of tzdata
      const gmtOffset = -1 * (dt.offset / 60);
      const offsetZ = gmtOffset >= 0 ? `Etc/GMT+${gmtOffset}` : `Etc/GMT${gmtOffset}`;
      if (dt.offset !== 0 && IANAZone.create(offsetZ).valid) {
        z = offsetZ;
        this.dt = dt;
      } else {
        // Not all fixed-offset zones like Etc/+4:30 are present in tzdata so
        // we manually apply the offset and substitute the zone as needed.
        z = "UTC";
        this.dt = dt.offset === 0 ? dt : dt.setZone("UTC").plus({ minutes: dt.offset });
        this.originalZone = dt.zone;
      }
    } else if (dt.zone.type === "system") {
      this.dt = dt;
    } else if (dt.zone.type === "iana") {
      this.dt = dt;
      z = dt.zone.name;
    } else {
      // Custom zones can have any offset / offsetName so we just manually
      // apply the offset and substitute the zone as needed.
      z = "UTC";
      this.dt = dt.setZone("UTC").plus({ minutes: dt.offset });
      this.originalZone = dt.zone;
    }

    const intlOpts = { ...this.opts };
    intlOpts.timeZone = intlOpts.timeZone || z;
    this.dtf = getCachedDTF(intl, intlOpts);
  }

  format() {
    if (this.originalZone) {
      // If we have to substitute in the actual zone name, we have to use
      // formatToParts so that the timezone can be replaced.
      return this.formatToParts()
        .map(({ value }) => value)
        .join("");
    }
    return this.dtf.format(this.dt.toJSDate());
  }

  formatToParts() {
    const parts = this.dtf.formatToParts(this.dt.toJSDate());
    if (this.originalZone) {
      return parts.map((part) => {
        if (part.type === "timeZoneName") {
          const offsetName = this.originalZone.offsetName(this.dt.ts, {
            locale: this.dt.locale,
            format: this.opts.timeZoneName,
          });
          return {
            ...part,
            value: offsetName,
          };
        } else {
          return part;
        }
      });
    }
    return parts;
  }

  resolvedOptions() {
    return this.dtf.resolvedOptions();
  }
}

/**
 * @private
 */
class PolyRelFormatter {
  constructor(intl, isEnglish, opts) {
    this.opts = { style: "long", ...opts };
    if (!isEnglish && hasRelative()) {
      this.rtf = getCachedRTF(intl, opts);
    }
  }

  format(count, unit) {
    if (this.rtf) {
      return this.rtf.format(count, unit);
    } else {
      return formatRelativeTime(unit, count, this.opts.numeric, this.opts.style !== "long");
    }
  }

  formatToParts(count, unit) {
    if (this.rtf) {
      return this.rtf.formatToParts(count, unit);
    } else {
      return [];
    }
  }
}

const fallbackWeekSettings = {
  firstDay: 1,
  minimalDays: 4,
  weekend: [6, 7],
};

/**
 * @private
 */

class Locale {
  static fromOpts(opts) {
    return Locale.create(
      opts.locale,
      opts.numberingSystem,
      opts.outputCalendar,
      opts.weekSettings,
      opts.defaultToEN
    );
  }

  static create(locale, numberingSystem, outputCalendar, weekSettings, defaultToEN = false) {
    const specifiedLocale = locale || Settings.defaultLocale;
    // the system locale is useful for human-readable strings but annoying for parsing/formatting known formats
    const localeR = specifiedLocale || (defaultToEN ? "en-US" : systemLocale());
    const numberingSystemR = numberingSystem || Settings.defaultNumberingSystem;
    const outputCalendarR = outputCalendar || Settings.defaultOutputCalendar;
    const weekSettingsR = validateWeekSettings(weekSettings) || Settings.defaultWeekSettings;
    return new Locale(localeR, numberingSystemR, outputCalendarR, weekSettingsR, specifiedLocale);
  }

  static resetCache() {
    sysLocaleCache = null;
    intlDTCache = {};
    intlNumCache = {};
    intlRelCache = {};
  }

  static fromObject({ locale, numberingSystem, outputCalendar, weekSettings } = {}) {
    return Locale.create(locale, numberingSystem, outputCalendar, weekSettings);
  }

  constructor(locale, numbering, outputCalendar, weekSettings, specifiedLocale) {
    const [parsedLocale, parsedNumberingSystem, parsedOutputCalendar] = parseLocaleString(locale);

    this.locale = parsedLocale;
    this.numberingSystem = numbering || parsedNumberingSystem || null;
    this.outputCalendar = outputCalendar || parsedOutputCalendar || null;
    this.weekSettings = weekSettings;
    this.intl = intlConfigString(this.locale, this.numberingSystem, this.outputCalendar);

    this.weekdaysCache = { format: {}, standalone: {} };
    this.monthsCache = { format: {}, standalone: {} };
    this.meridiemCache = null;
    this.eraCache = {};

    this.specifiedLocale = specifiedLocale;
    this.fastNumbersCached = null;
  }

  get fastNumbers() {
    if (this.fastNumbersCached == null) {
      this.fastNumbersCached = supportsFastNumbers(this);
    }

    return this.fastNumbersCached;
  }

  listingMode() {
    const isActuallyEn = this.isEnglish();
    const hasNoWeirdness =
      (this.numberingSystem === null || this.numberingSystem === "latn") &&
      (this.outputCalendar === null || this.outputCalendar === "gregory");
    return isActuallyEn && hasNoWeirdness ? "en" : "intl";
  }

  clone(alts) {
    if (!alts || Object.getOwnPropertyNames(alts).length === 0) {
      return this;
    } else {
      return Locale.create(
        alts.locale || this.specifiedLocale,
        alts.numberingSystem || this.numberingSystem,
        alts.outputCalendar || this.outputCalendar,
        validateWeekSettings(alts.weekSettings) || this.weekSettings,
        alts.defaultToEN || false
      );
    }
  }

  redefaultToEN(alts = {}) {
    return this.clone({ ...alts, defaultToEN: true });
  }

  redefaultToSystem(alts = {}) {
    return this.clone({ ...alts, defaultToEN: false });
  }

  months(length, format = false) {
    return listStuff(this, length, months, () => {
      const intl = format ? { month: length, day: "numeric" } : { month: length },
        formatStr = format ? "format" : "standalone";
      if (!this.monthsCache[formatStr][length]) {
        this.monthsCache[formatStr][length] = mapMonths((dt) => this.extract(dt, intl, "month"));
      }
      return this.monthsCache[formatStr][length];
    });
  }

  weekdays(length, format = false) {
    return listStuff(this, length, weekdays, () => {
      const intl = format
          ? { weekday: length, year: "numeric", month: "long", day: "numeric" }
          : { weekday: length },
        formatStr = format ? "format" : "standalone";
      if (!this.weekdaysCache[formatStr][length]) {
        this.weekdaysCache[formatStr][length] = mapWeekdays((dt) =>
          this.extract(dt, intl, "weekday")
        );
      }
      return this.weekdaysCache[formatStr][length];
    });
  }

  meridiems() {
    return listStuff(
      this,
      undefined,
      () => meridiems,
      () => {
        // In theory there could be aribitrary day periods. We're gonna assume there are exactly two
        // for AM and PM. This is probably wrong, but it's makes parsing way easier.
        if (!this.meridiemCache) {
          const intl = { hour: "numeric", hourCycle: "h12" };
          this.meridiemCache = [DateTime.utc(2016, 11, 13, 9), DateTime.utc(2016, 11, 13, 19)].map(
            (dt) => this.extract(dt, intl, "dayperiod")
          );
        }

        return this.meridiemCache;
      }
    );
  }

  eras(length) {
    return listStuff(this, length, eras, () => {
      const intl = { era: length };

      // This is problematic. Different calendars are going to define eras totally differently. What I need is the minimum set of dates
      // to definitely enumerate them.
      if (!this.eraCache[length]) {
        this.eraCache[length] = [DateTime.utc(-40, 1, 1), DateTime.utc(2017, 1, 1)].map((dt) =>
          this.extract(dt, intl, "era")
        );
      }

      return this.eraCache[length];
    });
  }

  extract(dt, intlOpts, field) {
    const df = this.dtFormatter(dt, intlOpts),
      results = df.formatToParts(),
      matching = results.find((m) => m.type.toLowerCase() === field);
    return matching ? matching.value : null;
  }

  numberFormatter(opts = {}) {
    // this forcesimple option is never used (the only caller short-circuits on it, but it seems safer to leave)
    // (in contrast, the rest of the condition is used heavily)
    return new PolyNumberFormatter(this.intl, opts.forceSimple || this.fastNumbers, opts);
  }

  dtFormatter(dt, intlOpts = {}) {
    return new PolyDateFormatter(dt, this.intl, intlOpts);
  }

  relFormatter(opts = {}) {
    return new PolyRelFormatter(this.intl, this.isEnglish(), opts);
  }

  listFormatter(opts = {}) {
    return getCachedLF(this.intl, opts);
  }

  isEnglish() {
    return (
      this.locale === "en" ||
      this.locale.toLowerCase() === "en-us" ||
      new Intl.DateTimeFormat(this.intl).resolvedOptions().locale.startsWith("en-us")
    );
  }

  getWeekSettings() {
    if (this.weekSettings) {
      return this.weekSettings;
    } else if (!hasLocaleWeekInfo()) {
      return fallbackWeekSettings;
    } else {
      return getCachedWeekInfo(this.locale);
    }
  }

  getStartOfWeek() {
    return this.getWeekSettings().firstDay;
  }

  getMinDaysInFirstWeek() {
    return this.getWeekSettings().minimalDays;
  }

  getWeekendDays() {
    return this.getWeekSettings().weekend;
  }

  equals(other) {
    return (
      this.locale === other.locale &&
      this.numberingSystem === other.numberingSystem &&
      this.outputCalendar === other.outputCalendar
    );
  }

  toString() {
    return `Locale(${this.locale}, ${this.numberingSystem}, ${this.outputCalendar})`;
  }
}

;// CONCATENATED MODULE: ../node_modules/luxon/src/zones/fixedOffsetZone.js



let fixedOffsetZone_singleton = null;

/**
 * A zone with a fixed offset (meaning no DST)
 * @implements {Zone}
 */
class FixedOffsetZone extends Zone {
  /**
   * Get a singleton instance of UTC
   * @return {FixedOffsetZone}
   */
  static get utcInstance() {
    if (fixedOffsetZone_singleton === null) {
      fixedOffsetZone_singleton = new FixedOffsetZone(0);
    }
    return fixedOffsetZone_singleton;
  }

  /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */
  static instance(offset) {
    return offset === 0 ? FixedOffsetZone.utcInstance : new FixedOffsetZone(offset);
  }

  /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */
  static parseSpecifier(s) {
    if (s) {
      const r = s.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
      if (r) {
        return new FixedOffsetZone(signedOffset(r[1], r[2]));
      }
    }
    return null;
  }

  constructor(offset) {
    super();
    /** @private **/
    this.fixed = offset;
  }

  /**
   * The type of zone. `fixed` for all instances of `FixedOffsetZone`.
   * @override
   * @type {string}
   */
  get type() {
    return "fixed";
  }

  /**
   * The name of this zone.
   * All fixed zones' names always start with "UTC" (plus optional offset)
   * @override
   * @type {string}
   */
  get name() {
    return this.fixed === 0 ? "UTC" : `UTC${formatOffset(this.fixed, "narrow")}`;
  }

  /**
   * The IANA name of this zone, i.e. `Etc/UTC` or `Etc/GMT+/-nn`
   *
   * @override
   * @type {string}
   */
  get ianaName() {
    if (this.fixed === 0) {
      return "Etc/UTC";
    } else {
      return `Etc/GMT${formatOffset(-this.fixed, "narrow")}`;
    }
  }

  /**
   * Returns the offset's common name at the specified timestamp.
   *
   * For fixed offset zones this equals to the zone name.
   * @override
   */
  offsetName() {
    return this.name;
  }

  /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(ts, format) {
    return formatOffset(this.fixed, format);
  }

  /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns true for all fixed offset zones.
   * @override
   * @type {boolean}
   */
  get isUniversal() {
    return true;
  }

  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   *
   * For fixed offset zones, this is constant and does not depend on a timestamp.
   * @override
   * @return {number}
   */
  offset() {
    return this.fixed;
  }

  /**
   * Return whether this Zone is equal to another zone (i.e. also fixed and same offset)
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(otherZone) {
    return otherZone.type === "fixed" && otherZone.fixed === this.fixed;
  }

  /**
   * Return whether this Zone is valid:
   * All fixed offset zones are valid.
   * @override
   * @type {boolean}
   */
  get isValid() {
    return true;
  }
}

;// CONCATENATED MODULE: ../node_modules/luxon/src/zones/invalidZone.js


/**
 * A zone that failed to parse. You should never need to instantiate this.
 * @implements {Zone}
 */
class InvalidZone extends Zone {
  constructor(zoneName) {
    super();
    /**  @private */
    this.zoneName = zoneName;
  }

  /** @override **/
  get type() {
    return "invalid";
  }

  /** @override **/
  get name() {
    return this.zoneName;
  }

  /** @override **/
  get isUniversal() {
    return false;
  }

  /** @override **/
  offsetName() {
    return null;
  }

  /** @override **/
  formatOffset() {
    return "";
  }

  /** @override **/
  offset() {
    return NaN;
  }

  /** @override **/
  equals() {
    return false;
  }

  /** @override **/
  get isValid() {
    return false;
  }
}

;// CONCATENATED MODULE: ../node_modules/luxon/src/impl/zoneUtil.js
/**
 * @private
 */









function normalizeZone(input, defaultZone) {
  let offset;
  if (isUndefined(input) || input === null) {
    return defaultZone;
  } else if (input instanceof Zone) {
    return input;
  } else if (isString(input)) {
    const lowered = input.toLowerCase();
    if (lowered === "default") return defaultZone;
    else if (lowered === "local" || lowered === "system") return SystemZone.instance;
    else if (lowered === "utc" || lowered === "gmt") return FixedOffsetZone.utcInstance;
    else return FixedOffsetZone.parseSpecifier(lowered) || IANAZone.create(input);
  } else if (isNumber(input)) {
    return FixedOffsetZone.instance(input);
  } else if (typeof input === "object" && "offset" in input && typeof input.offset === "function") {
    // This is dumb, but the instanceof check above doesn't seem to really work
    // so we're duck checking it
    return input;
  } else {
    return new InvalidZone(input);
  }
}

;// CONCATENATED MODULE: ../node_modules/luxon/src/impl/digits.js
const numberingSystems = {
  arab: "[\u0660-\u0669]",
  arabext: "[\u06F0-\u06F9]",
  bali: "[\u1B50-\u1B59]",
  beng: "[\u09E6-\u09EF]",
  deva: "[\u0966-\u096F]",
  fullwide: "[\uFF10-\uFF19]",
  gujr: "[\u0AE6-\u0AEF]",
  hanidec: "[〇|一|二|三|四|五|六|七|八|九]",
  khmr: "[\u17E0-\u17E9]",
  knda: "[\u0CE6-\u0CEF]",
  laoo: "[\u0ED0-\u0ED9]",
  limb: "[\u1946-\u194F]",
  mlym: "[\u0D66-\u0D6F]",
  mong: "[\u1810-\u1819]",
  mymr: "[\u1040-\u1049]",
  orya: "[\u0B66-\u0B6F]",
  tamldec: "[\u0BE6-\u0BEF]",
  telu: "[\u0C66-\u0C6F]",
  thai: "[\u0E50-\u0E59]",
  tibt: "[\u0F20-\u0F29]",
  latn: "\\d",
};

const numberingSystemsUTF16 = {
  arab: [1632, 1641],
  arabext: [1776, 1785],
  bali: [6992, 7001],
  beng: [2534, 2543],
  deva: [2406, 2415],
  fullwide: [65296, 65303],
  gujr: [2790, 2799],
  khmr: [6112, 6121],
  knda: [3302, 3311],
  laoo: [3792, 3801],
  limb: [6470, 6479],
  mlym: [3430, 3439],
  mong: [6160, 6169],
  mymr: [4160, 4169],
  orya: [2918, 2927],
  tamldec: [3046, 3055],
  telu: [3174, 3183],
  thai: [3664, 3673],
  tibt: [3872, 3881],
};

const hanidecChars = numberingSystems.hanidec.replace(/[\[|\]]/g, "").split("");

function parseDigits(str) {
  let value = parseInt(str, 10);
  if (isNaN(value)) {
    value = "";
    for (let i = 0; i < str.length; i++) {
      const code = str.charCodeAt(i);

      if (str[i].search(numberingSystems.hanidec) !== -1) {
        value += hanidecChars.indexOf(str[i]);
      } else {
        for (const key in numberingSystemsUTF16) {
          const [min, max] = numberingSystemsUTF16[key];
          if (code >= min && code <= max) {
            value += code - min;
          }
        }
      }
    }
    return parseInt(value, 10);
  } else {
    return value;
  }
}

// cache of {numberingSystem: {append: regex}}
let digitRegexCache = {};
function resetDigitRegexCache() {
  digitRegexCache = {};
}

function digitRegex({ numberingSystem }, append = "") {
  const ns = numberingSystem || "latn";

  if (!digitRegexCache[ns]) {
    digitRegexCache[ns] = {};
  }
  if (!digitRegexCache[ns][append]) {
    digitRegexCache[ns][append] = new RegExp(`${numberingSystems[ns]}${append}`);
  }

  return digitRegexCache[ns][append];
}

;// CONCATENATED MODULE: ../node_modules/luxon/src/settings.js









let now = () => Date.now(),
  defaultZone = "system",
  defaultLocale = null,
  defaultNumberingSystem = null,
  defaultOutputCalendar = null,
  twoDigitCutoffYear = 60,
  throwOnInvalid,
  defaultWeekSettings = null;

/**
 * Settings contains static getters and setters that control Luxon's overall behavior. Luxon is a simple library with few options, but the ones it does have live here.
 */
class Settings {
  /**
   * Get the callback for returning the current timestamp.
   * @type {function}
   */
  static get now() {
    return now;
  }

  /**
   * Set the callback for returning the current timestamp.
   * The function should return a number, which will be interpreted as an Epoch millisecond count
   * @type {function}
   * @example Settings.now = () => Date.now() + 3000 // pretend it is 3 seconds in the future
   * @example Settings.now = () => 0 // always pretend it's Jan 1, 1970 at midnight in UTC time
   */
  static set now(n) {
    now = n;
  }

  /**
   * Set the default time zone to create DateTimes in. Does not affect existing instances.
   * Use the value "system" to reset this value to the system's time zone.
   * @type {string}
   */
  static set defaultZone(zone) {
    defaultZone = zone;
  }

  /**
   * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
   * The default value is the system's time zone (the one set on the machine that runs this code).
   * @type {Zone}
   */
  static get defaultZone() {
    return normalizeZone(defaultZone, SystemZone.instance);
  }

  /**
   * Get the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultLocale() {
    return defaultLocale;
  }

  /**
   * Set the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultLocale(locale) {
    defaultLocale = locale;
  }

  /**
   * Get the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultNumberingSystem() {
    return defaultNumberingSystem;
  }

  /**
   * Set the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultNumberingSystem(numberingSystem) {
    defaultNumberingSystem = numberingSystem;
  }

  /**
   * Get the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultOutputCalendar() {
    return defaultOutputCalendar;
  }

  /**
   * Set the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultOutputCalendar(outputCalendar) {
    defaultOutputCalendar = outputCalendar;
  }

  /**
   * @typedef {Object} WeekSettings
   * @property {number} firstDay
   * @property {number} minimalDays
   * @property {number[]} weekend
   */

  /**
   * @return {WeekSettings|null}
   */
  static get defaultWeekSettings() {
    return defaultWeekSettings;
  }

  /**
   * Allows overriding the default locale week settings, i.e. the start of the week, the weekend and
   * how many days are required in the first week of a year.
   * Does not affect existing instances.
   *
   * @param {WeekSettings|null} weekSettings
   */
  static set defaultWeekSettings(weekSettings) {
    defaultWeekSettings = validateWeekSettings(weekSettings);
  }

  /**
   * Get the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   */
  static get twoDigitCutoffYear() {
    return twoDigitCutoffYear;
  }

  /**
   * Set the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   * @example Settings.twoDigitCutoffYear = 0 // all 'yy' are interpreted as 20th century
   * @example Settings.twoDigitCutoffYear = 99 // all 'yy' are interpreted as 21st century
   * @example Settings.twoDigitCutoffYear = 50 // '49' -> 2049; '50' -> 1950
   * @example Settings.twoDigitCutoffYear = 1950 // interpreted as 50
   * @example Settings.twoDigitCutoffYear = 2050 // ALSO interpreted as 50
   */
  static set twoDigitCutoffYear(cutoffYear) {
    twoDigitCutoffYear = cutoffYear % 100;
  }

  /**
   * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static get throwOnInvalid() {
    return throwOnInvalid;
  }

  /**
   * Set whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static set throwOnInvalid(t) {
    throwOnInvalid = t;
  }

  /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCaches() {
    Locale.resetCache();
    IANAZone.resetCache();
    DateTime.resetCache();
    resetDigitRegexCache();
  }
}

;// CONCATENATED MODULE: ../node_modules/luxon/src/impl/invalid.js
class Invalid {
  constructor(reason, explanation) {
    this.reason = reason;
    this.explanation = explanation;
  }

  toMessage() {
    if (this.explanation) {
      return `${this.reason}: ${this.explanation}`;
    } else {
      return this.reason;
    }
  }
}

;// CONCATENATED MODULE: ../node_modules/luxon/src/impl/conversions.js




const nonLeapLadder = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334],
  leapLadder = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];

function unitOutOfRange(unit, value) {
  return new Invalid(
    "unit out of range",
    `you specified ${value} (of type ${typeof value}) as a ${unit}, which is invalid`
  );
}

function dayOfWeek(year, month, day) {
  const d = new Date(Date.UTC(year, month - 1, day));

  if (year < 100 && year >= 0) {
    d.setUTCFullYear(d.getUTCFullYear() - 1900);
  }

  const js = d.getUTCDay();

  return js === 0 ? 7 : js;
}

function computeOrdinal(year, month, day) {
  return day + (isLeapYear(year) ? leapLadder : nonLeapLadder)[month - 1];
}

function uncomputeOrdinal(year, ordinal) {
  const table = isLeapYear(year) ? leapLadder : nonLeapLadder,
    month0 = table.findIndex((i) => i < ordinal),
    day = ordinal - table[month0];
  return { month: month0 + 1, day };
}

function isoWeekdayToLocal(isoWeekday, startOfWeek) {
  return ((isoWeekday - startOfWeek + 7) % 7) + 1;
}

/**
 * @private
 */

function gregorianToWeek(gregObj, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const { year, month, day } = gregObj,
    ordinal = computeOrdinal(year, month, day),
    weekday = isoWeekdayToLocal(dayOfWeek(year, month, day), startOfWeek);

  let weekNumber = Math.floor((ordinal - weekday + 14 - minDaysInFirstWeek) / 7),
    weekYear;

  if (weekNumber < 1) {
    weekYear = year - 1;
    weekNumber = weeksInWeekYear(weekYear, minDaysInFirstWeek, startOfWeek);
  } else if (weekNumber > weeksInWeekYear(year, minDaysInFirstWeek, startOfWeek)) {
    weekYear = year + 1;
    weekNumber = 1;
  } else {
    weekYear = year;
  }

  return { weekYear, weekNumber, weekday, ...timeObject(gregObj) };
}

function weekToGregorian(weekData, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const { weekYear, weekNumber, weekday } = weekData,
    weekdayOfJan4 = isoWeekdayToLocal(dayOfWeek(weekYear, 1, minDaysInFirstWeek), startOfWeek),
    yearInDays = daysInYear(weekYear);

  let ordinal = weekNumber * 7 + weekday - weekdayOfJan4 - 7 + minDaysInFirstWeek,
    year;

  if (ordinal < 1) {
    year = weekYear - 1;
    ordinal += daysInYear(year);
  } else if (ordinal > yearInDays) {
    year = weekYear + 1;
    ordinal -= daysInYear(weekYear);
  } else {
    year = weekYear;
  }

  const { month, day } = uncomputeOrdinal(year, ordinal);
  return { year, month, day, ...timeObject(weekData) };
}

function gregorianToOrdinal(gregData) {
  const { year, month, day } = gregData;
  const ordinal = computeOrdinal(year, month, day);
  return { year, ordinal, ...timeObject(gregData) };
}

function ordinalToGregorian(ordinalData) {
  const { year, ordinal } = ordinalData;
  const { month, day } = uncomputeOrdinal(year, ordinal);
  return { year, month, day, ...timeObject(ordinalData) };
}

/**
 * Check if local week units like localWeekday are used in obj.
 * If so, validates that they are not mixed with ISO week units and then copies them to the normal week unit properties.
 * Modifies obj in-place!
 * @param obj the object values
 */
function usesLocalWeekValues(obj, loc) {
  const hasLocaleWeekData =
    !isUndefined(obj.localWeekday) ||
    !isUndefined(obj.localWeekNumber) ||
    !isUndefined(obj.localWeekYear);
  if (hasLocaleWeekData) {
    const hasIsoWeekData =
      !isUndefined(obj.weekday) || !isUndefined(obj.weekNumber) || !isUndefined(obj.weekYear);

    if (hasIsoWeekData) {
      throw new ConflictingSpecificationError(
        "Cannot mix locale-based week fields with ISO-based week fields"
      );
    }
    if (!isUndefined(obj.localWeekday)) obj.weekday = obj.localWeekday;
    if (!isUndefined(obj.localWeekNumber)) obj.weekNumber = obj.localWeekNumber;
    if (!isUndefined(obj.localWeekYear)) obj.weekYear = obj.localWeekYear;
    delete obj.localWeekday;
    delete obj.localWeekNumber;
    delete obj.localWeekYear;
    return {
      minDaysInFirstWeek: loc.getMinDaysInFirstWeek(),
      startOfWeek: loc.getStartOfWeek(),
    };
  } else {
    return { minDaysInFirstWeek: 4, startOfWeek: 1 };
  }
}

function hasInvalidWeekData(obj, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const validYear = isInteger(obj.weekYear),
    validWeek = integerBetween(
      obj.weekNumber,
      1,
      weeksInWeekYear(obj.weekYear, minDaysInFirstWeek, startOfWeek)
    ),
    validWeekday = integerBetween(obj.weekday, 1, 7);

  if (!validYear) {
    return unitOutOfRange("weekYear", obj.weekYear);
  } else if (!validWeek) {
    return unitOutOfRange("week", obj.weekNumber);
  } else if (!validWeekday) {
    return unitOutOfRange("weekday", obj.weekday);
  } else return false;
}

function hasInvalidOrdinalData(obj) {
  const validYear = isInteger(obj.year),
    validOrdinal = integerBetween(obj.ordinal, 1, daysInYear(obj.year));

  if (!validYear) {
    return unitOutOfRange("year", obj.year);
  } else if (!validOrdinal) {
    return unitOutOfRange("ordinal", obj.ordinal);
  } else return false;
}

function hasInvalidGregorianData(obj) {
  const validYear = isInteger(obj.year),
    validMonth = integerBetween(obj.month, 1, 12),
    validDay = integerBetween(obj.day, 1, daysInMonth(obj.year, obj.month));

  if (!validYear) {
    return unitOutOfRange("year", obj.year);
  } else if (!validMonth) {
    return unitOutOfRange("month", obj.month);
  } else if (!validDay) {
    return unitOutOfRange("day", obj.day);
  } else return false;
}

function hasInvalidTimeData(obj) {
  const { hour, minute, second, millisecond } = obj;
  const validHour =
      integerBetween(hour, 0, 23) ||
      (hour === 24 && minute === 0 && second === 0 && millisecond === 0),
    validMinute = integerBetween(minute, 0, 59),
    validSecond = integerBetween(second, 0, 59),
    validMillisecond = integerBetween(millisecond, 0, 999);

  if (!validHour) {
    return unitOutOfRange("hour", hour);
  } else if (!validMinute) {
    return unitOutOfRange("minute", minute);
  } else if (!validSecond) {
    return unitOutOfRange("second", second);
  } else if (!validMillisecond) {
    return unitOutOfRange("millisecond", millisecond);
  } else return false;
}

;// CONCATENATED MODULE: ../node_modules/luxon/src/impl/util.js
/*
  This is just a junk drawer, containing anything used across multiple classes.
  Because Luxon is small(ish), this should stay small and we won't worry about splitting
  it up into, say, parsingUtil.js and basicUtil.js and so on. But they are divided up by feature area.
*/





/**
 * @private
 */

// TYPES

function isUndefined(o) {
  return typeof o === "undefined";
}

function isNumber(o) {
  return typeof o === "number";
}

function isInteger(o) {
  return typeof o === "number" && o % 1 === 0;
}

function isString(o) {
  return typeof o === "string";
}

function isDate(o) {
  return Object.prototype.toString.call(o) === "[object Date]";
}

// CAPABILITIES

function hasRelative() {
  try {
    return typeof Intl !== "undefined" && !!Intl.RelativeTimeFormat;
  } catch (e) {
    return false;
  }
}

function hasLocaleWeekInfo() {
  try {
    return (
      typeof Intl !== "undefined" &&
      !!Intl.Locale &&
      ("weekInfo" in Intl.Locale.prototype || "getWeekInfo" in Intl.Locale.prototype)
    );
  } catch (e) {
    return false;
  }
}

// OBJECTS AND ARRAYS

function maybeArray(thing) {
  return Array.isArray(thing) ? thing : [thing];
}

function bestBy(arr, by, compare) {
  if (arr.length === 0) {
    return undefined;
  }
  return arr.reduce((best, next) => {
    const pair = [by(next), next];
    if (!best) {
      return pair;
    } else if (compare(best[0], pair[0]) === best[0]) {
      return best;
    } else {
      return pair;
    }
  }, null)[1];
}

function util_pick(obj, keys) {
  return keys.reduce((a, k) => {
    a[k] = obj[k];
    return a;
  }, {});
}

function util_hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

function validateWeekSettings(settings) {
  if (settings == null) {
    return null;
  } else if (typeof settings !== "object") {
    throw new InvalidArgumentError("Week settings must be an object");
  } else {
    if (
      !integerBetween(settings.firstDay, 1, 7) ||
      !integerBetween(settings.minimalDays, 1, 7) ||
      !Array.isArray(settings.weekend) ||
      settings.weekend.some((v) => !integerBetween(v, 1, 7))
    ) {
      throw new InvalidArgumentError("Invalid week settings");
    }
    return {
      firstDay: settings.firstDay,
      minimalDays: settings.minimalDays,
      weekend: Array.from(settings.weekend),
    };
  }
}

// NUMBERS AND STRINGS

function integerBetween(thing, bottom, top) {
  return isInteger(thing) && thing >= bottom && thing <= top;
}

// x % n but takes the sign of n instead of x
function floorMod(x, n) {
  return x - n * Math.floor(x / n);
}

function padStart(input, n = 2) {
  const isNeg = input < 0;
  let padded;
  if (isNeg) {
    padded = "-" + ("" + -input).padStart(n, "0");
  } else {
    padded = ("" + input).padStart(n, "0");
  }
  return padded;
}

function parseInteger(string) {
  if (isUndefined(string) || string === null || string === "") {
    return undefined;
  } else {
    return parseInt(string, 10);
  }
}

function parseFloating(string) {
  if (isUndefined(string) || string === null || string === "") {
    return undefined;
  } else {
    return parseFloat(string);
  }
}

function parseMillis(fraction) {
  // Return undefined (instead of 0) in these cases, where fraction is not set
  if (isUndefined(fraction) || fraction === null || fraction === "") {
    return undefined;
  } else {
    const f = parseFloat("0." + fraction) * 1000;
    return Math.floor(f);
  }
}

function roundTo(number, digits, towardZero = false) {
  const factor = 10 ** digits,
    rounder = towardZero ? Math.trunc : Math.round;
  return rounder(number * factor) / factor;
}

// DATE BASICS

function isLeapYear(year) {
  return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}

function daysInYear(year) {
  return isLeapYear(year) ? 366 : 365;
}

function daysInMonth(year, month) {
  const modMonth = floorMod(month - 1, 12) + 1,
    modYear = year + (month - modMonth) / 12;

  if (modMonth === 2) {
    return isLeapYear(modYear) ? 29 : 28;
  } else {
    return [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][modMonth - 1];
  }
}

// convert a calendar object to a local timestamp (epoch, but with the offset baked in)
function objToLocalTS(obj) {
  let d = Date.UTC(
    obj.year,
    obj.month - 1,
    obj.day,
    obj.hour,
    obj.minute,
    obj.second,
    obj.millisecond
  );

  // for legacy reasons, years between 0 and 99 are interpreted as 19XX; revert that
  if (obj.year < 100 && obj.year >= 0) {
    d = new Date(d);
    // set the month and day again, this is necessary because year 2000 is a leap year, but year 100 is not
    // so if obj.year is in 99, but obj.day makes it roll over into year 100,
    // the calculations done by Date.UTC are using year 2000 - which is incorrect
    d.setUTCFullYear(obj.year, obj.month - 1, obj.day);
  }
  return +d;
}

// adapted from moment.js: https://github.com/moment/moment/blob/000ac1800e620f770f4eb31b5ae908f6167b0ab2/src/lib/units/week-calendar-utils.js
function firstWeekOffset(year, minDaysInFirstWeek, startOfWeek) {
  const fwdlw = isoWeekdayToLocal(dayOfWeek(year, 1, minDaysInFirstWeek), startOfWeek);
  return -fwdlw + minDaysInFirstWeek - 1;
}

function weeksInWeekYear(weekYear, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const weekOffset = firstWeekOffset(weekYear, minDaysInFirstWeek, startOfWeek);
  const weekOffsetNext = firstWeekOffset(weekYear + 1, minDaysInFirstWeek, startOfWeek);
  return (daysInYear(weekYear) - weekOffset + weekOffsetNext) / 7;
}

function untruncateYear(year) {
  if (year > 99) {
    return year;
  } else return year > Settings.twoDigitCutoffYear ? 1900 + year : 2000 + year;
}

// PARSING

function parseZoneInfo(ts, offsetFormat, locale, timeZone = null) {
  const date = new Date(ts),
    intlOpts = {
      hourCycle: "h23",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    };

  if (timeZone) {
    intlOpts.timeZone = timeZone;
  }

  const modified = { timeZoneName: offsetFormat, ...intlOpts };

  const parsed = new Intl.DateTimeFormat(locale, modified)
    .formatToParts(date)
    .find((m) => m.type.toLowerCase() === "timezonename");
  return parsed ? parsed.value : null;
}

// signedOffset('-5', '30') -> -330
function signedOffset(offHourStr, offMinuteStr) {
  let offHour = parseInt(offHourStr, 10);

  // don't || this because we want to preserve -0
  if (Number.isNaN(offHour)) {
    offHour = 0;
  }

  const offMin = parseInt(offMinuteStr, 10) || 0,
    offMinSigned = offHour < 0 || Object.is(offHour, -0) ? -offMin : offMin;
  return offHour * 60 + offMinSigned;
}

// COERCION

function asNumber(value) {
  const numericValue = Number(value);
  if (typeof value === "boolean" || value === "" || Number.isNaN(numericValue))
    throw new InvalidArgumentError(`Invalid unit value ${value}`);
  return numericValue;
}

function normalizeObject(obj, normalizer) {
  const normalized = {};
  for (const u in obj) {
    if (util_hasOwnProperty(obj, u)) {
      const v = obj[u];
      if (v === undefined || v === null) continue;
      normalized[normalizer(u)] = asNumber(v);
    }
  }
  return normalized;
}

/**
 * Returns the offset's value as a string
 * @param {number} ts - Epoch milliseconds for which to get the offset
 * @param {string} format - What style of offset to return.
 *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
 * @return {string}
 */
function formatOffset(offset, format) {
  const hours = Math.trunc(Math.abs(offset / 60)),
    minutes = Math.trunc(Math.abs(offset % 60)),
    sign = offset >= 0 ? "+" : "-";

  switch (format) {
    case "short":
      return `${sign}${padStart(hours, 2)}:${padStart(minutes, 2)}`;
    case "narrow":
      return `${sign}${hours}${minutes > 0 ? `:${minutes}` : ""}`;
    case "techie":
      return `${sign}${padStart(hours, 2)}${padStart(minutes, 2)}`;
    default:
      throw new RangeError(`Value format ${format} is out of range for property format`);
  }
}

function timeObject(obj) {
  return util_pick(obj, ["hour", "minute", "second", "millisecond"]);
}

;// CONCATENATED MODULE: ../node_modules/luxon/src/impl/english.js



function stringify(obj) {
  return JSON.stringify(obj, Object.keys(obj).sort());
}

/**
 * @private
 */

const monthsLong = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const monthsShort = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const monthsNarrow = ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];

function months(length) {
  switch (length) {
    case "narrow":
      return [...monthsNarrow];
    case "short":
      return [...monthsShort];
    case "long":
      return [...monthsLong];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
    case "2-digit":
      return ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    default:
      return null;
  }
}

const weekdaysLong = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

const weekdaysShort = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

const weekdaysNarrow = ["M", "T", "W", "T", "F", "S", "S"];

function weekdays(length) {
  switch (length) {
    case "narrow":
      return [...weekdaysNarrow];
    case "short":
      return [...weekdaysShort];
    case "long":
      return [...weekdaysLong];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7"];
    default:
      return null;
  }
}

const meridiems = ["AM", "PM"];

const erasLong = ["Before Christ", "Anno Domini"];

const erasShort = ["BC", "AD"];

const erasNarrow = ["B", "A"];

function eras(length) {
  switch (length) {
    case "narrow":
      return [...erasNarrow];
    case "short":
      return [...erasShort];
    case "long":
      return [...erasLong];
    default:
      return null;
  }
}

function meridiemForDateTime(dt) {
  return meridiems[dt.hour < 12 ? 0 : 1];
}

function weekdayForDateTime(dt, length) {
  return weekdays(length)[dt.weekday - 1];
}

function monthForDateTime(dt, length) {
  return months(length)[dt.month - 1];
}

function eraForDateTime(dt, length) {
  return eras(length)[dt.year < 0 ? 0 : 1];
}

function formatRelativeTime(unit, count, numeric = "always", narrow = false) {
  const units = {
    years: ["year", "yr."],
    quarters: ["quarter", "qtr."],
    months: ["month", "mo."],
    weeks: ["week", "wk."],
    days: ["day", "day", "days"],
    hours: ["hour", "hr."],
    minutes: ["minute", "min."],
    seconds: ["second", "sec."],
  };

  const lastable = ["hours", "minutes", "seconds"].indexOf(unit) === -1;

  if (numeric === "auto" && lastable) {
    const isDay = unit === "days";
    switch (count) {
      case 1:
        return isDay ? "tomorrow" : `next ${units[unit][0]}`;
      case -1:
        return isDay ? "yesterday" : `last ${units[unit][0]}`;
      case 0:
        return isDay ? "today" : `this ${units[unit][0]}`;
      default: // fall through
    }
  }

  const isInPast = Object.is(count, -0) || count < 0,
    fmtValue = Math.abs(count),
    singular = fmtValue === 1,
    lilUnits = units[unit],
    fmtUnit = narrow
      ? singular
        ? lilUnits[1]
        : lilUnits[2] || lilUnits[1]
      : singular
      ? units[unit][0]
      : unit;
  return isInPast ? `${fmtValue} ${fmtUnit} ago` : `in ${fmtValue} ${fmtUnit}`;
}

function formatString(knownFormat) {
  // these all have the offsets removed because we don't have access to them
  // without all the intl stuff this is backfilling
  const filtered = pick(knownFormat, [
      "weekday",
      "era",
      "year",
      "month",
      "day",
      "hour",
      "minute",
      "second",
      "timeZoneName",
      "hourCycle",
    ]),
    key = stringify(filtered),
    dateTimeHuge = "EEEE, LLLL d, yyyy, h:mm a";
  switch (key) {
    case stringify(Formats.DATE_SHORT):
      return "M/d/yyyy";
    case stringify(Formats.DATE_MED):
      return "LLL d, yyyy";
    case stringify(Formats.DATE_MED_WITH_WEEKDAY):
      return "EEE, LLL d, yyyy";
    case stringify(Formats.DATE_FULL):
      return "LLLL d, yyyy";
    case stringify(Formats.DATE_HUGE):
      return "EEEE, LLLL d, yyyy";
    case stringify(Formats.TIME_SIMPLE):
      return "h:mm a";
    case stringify(Formats.TIME_WITH_SECONDS):
      return "h:mm:ss a";
    case stringify(Formats.TIME_WITH_SHORT_OFFSET):
      return "h:mm a";
    case stringify(Formats.TIME_WITH_LONG_OFFSET):
      return "h:mm a";
    case stringify(Formats.TIME_24_SIMPLE):
      return "HH:mm";
    case stringify(Formats.TIME_24_WITH_SECONDS):
      return "HH:mm:ss";
    case stringify(Formats.TIME_24_WITH_SHORT_OFFSET):
      return "HH:mm";
    case stringify(Formats.TIME_24_WITH_LONG_OFFSET):
      return "HH:mm";
    case stringify(Formats.DATETIME_SHORT):
      return "M/d/yyyy, h:mm a";
    case stringify(Formats.DATETIME_MED):
      return "LLL d, yyyy, h:mm a";
    case stringify(Formats.DATETIME_FULL):
      return "LLLL d, yyyy, h:mm a";
    case stringify(Formats.DATETIME_HUGE):
      return dateTimeHuge;
    case stringify(Formats.DATETIME_SHORT_WITH_SECONDS):
      return "M/d/yyyy, h:mm:ss a";
    case stringify(Formats.DATETIME_MED_WITH_SECONDS):
      return "LLL d, yyyy, h:mm:ss a";
    case stringify(Formats.DATETIME_MED_WITH_WEEKDAY):
      return "EEE, d LLL yyyy, h:mm a";
    case stringify(Formats.DATETIME_FULL_WITH_SECONDS):
      return "LLLL d, yyyy, h:mm:ss a";
    case stringify(Formats.DATETIME_HUGE_WITH_SECONDS):
      return "EEEE, LLLL d, yyyy, h:mm:ss a";
    default:
      return dateTimeHuge;
  }
}

;// CONCATENATED MODULE: ../node_modules/luxon/src/impl/formatter.js




function stringifyTokens(splits, tokenToString) {
  let s = "";
  for (const token of splits) {
    if (token.literal) {
      s += token.val;
    } else {
      s += tokenToString(token.val);
    }
  }
  return s;
}

const macroTokenToFormatOpts = {
  D: DATE_SHORT,
  DD: DATE_MED,
  DDD: DATE_FULL,
  DDDD: DATE_HUGE,
  t: TIME_SIMPLE,
  tt: TIME_WITH_SECONDS,
  ttt: TIME_WITH_SHORT_OFFSET,
  tttt: TIME_WITH_LONG_OFFSET,
  T: TIME_24_SIMPLE,
  TT: TIME_24_WITH_SECONDS,
  TTT: TIME_24_WITH_SHORT_OFFSET,
  TTTT: TIME_24_WITH_LONG_OFFSET,
  f: DATETIME_SHORT,
  ff: DATETIME_MED,
  fff: DATETIME_FULL,
  ffff: DATETIME_HUGE,
  F: DATETIME_SHORT_WITH_SECONDS,
  FF: DATETIME_MED_WITH_SECONDS,
  FFF: DATETIME_FULL_WITH_SECONDS,
  FFFF: DATETIME_HUGE_WITH_SECONDS,
};

/**
 * @private
 */

class Formatter {
  static create(locale, opts = {}) {
    return new Formatter(locale, opts);
  }

  static parseFormat(fmt) {
    // white-space is always considered a literal in user-provided formats
    // the " " token has a special meaning (see unitForToken)

    let current = null,
      currentFull = "",
      bracketed = false;
    const splits = [];
    for (let i = 0; i < fmt.length; i++) {
      const c = fmt.charAt(i);
      if (c === "'") {
        if (currentFull.length > 0) {
          splits.push({ literal: bracketed || /^\s+$/.test(currentFull), val: currentFull });
        }
        current = null;
        currentFull = "";
        bracketed = !bracketed;
      } else if (bracketed) {
        currentFull += c;
      } else if (c === current) {
        currentFull += c;
      } else {
        if (currentFull.length > 0) {
          splits.push({ literal: /^\s+$/.test(currentFull), val: currentFull });
        }
        currentFull = c;
        current = c;
      }
    }

    if (currentFull.length > 0) {
      splits.push({ literal: bracketed || /^\s+$/.test(currentFull), val: currentFull });
    }

    return splits;
  }

  static macroTokenToFormatOpts(token) {
    return macroTokenToFormatOpts[token];
  }

  constructor(locale, formatOpts) {
    this.opts = formatOpts;
    this.loc = locale;
    this.systemLoc = null;
  }

  formatWithSystemDefault(dt, opts) {
    if (this.systemLoc === null) {
      this.systemLoc = this.loc.redefaultToSystem();
    }
    const df = this.systemLoc.dtFormatter(dt, { ...this.opts, ...opts });
    return df.format();
  }

  dtFormatter(dt, opts = {}) {
    return this.loc.dtFormatter(dt, { ...this.opts, ...opts });
  }

  formatDateTime(dt, opts) {
    return this.dtFormatter(dt, opts).format();
  }

  formatDateTimeParts(dt, opts) {
    return this.dtFormatter(dt, opts).formatToParts();
  }

  formatInterval(interval, opts) {
    const df = this.dtFormatter(interval.start, opts);
    return df.dtf.formatRange(interval.start.toJSDate(), interval.end.toJSDate());
  }

  resolvedOptions(dt, opts) {
    return this.dtFormatter(dt, opts).resolvedOptions();
  }

  num(n, p = 0) {
    // we get some perf out of doing this here, annoyingly
    if (this.opts.forceSimple) {
      return padStart(n, p);
    }

    const opts = { ...this.opts };

    if (p > 0) {
      opts.padTo = p;
    }

    return this.loc.numberFormatter(opts).format(n);
  }

  formatDateTimeFromString(dt, fmt) {
    const knownEnglish = this.loc.listingMode() === "en",
      useDateTimeFormatter = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory",
      string = (opts, extract) => this.loc.extract(dt, opts, extract),
      formatOffset = (opts) => {
        if (dt.isOffsetFixed && dt.offset === 0 && opts.allowZ) {
          return "Z";
        }

        return dt.isValid ? dt.zone.formatOffset(dt.ts, opts.format) : "";
      },
      meridiem = () =>
        knownEnglish
          ? meridiemForDateTime(dt)
          : string({ hour: "numeric", hourCycle: "h12" }, "dayperiod"),
      month = (length, standalone) =>
        knownEnglish
          ? monthForDateTime(dt, length)
          : string(standalone ? { month: length } : { month: length, day: "numeric" }, "month"),
      weekday = (length, standalone) =>
        knownEnglish
          ? weekdayForDateTime(dt, length)
          : string(
              standalone ? { weekday: length } : { weekday: length, month: "long", day: "numeric" },
              "weekday"
            ),
      maybeMacro = (token) => {
        const formatOpts = Formatter.macroTokenToFormatOpts(token);
        if (formatOpts) {
          return this.formatWithSystemDefault(dt, formatOpts);
        } else {
          return token;
        }
      },
      era = (length) =>
        knownEnglish ? eraForDateTime(dt, length) : string({ era: length }, "era"),
      tokenToString = (token) => {
        // Where possible: https://cldr.unicode.org/translation/date-time/date-time-symbols
        switch (token) {
          // ms
          case "S":
            return this.num(dt.millisecond);
          case "u":
          // falls through
          case "SSS":
            return this.num(dt.millisecond, 3);
          // seconds
          case "s":
            return this.num(dt.second);
          case "ss":
            return this.num(dt.second, 2);
          // fractional seconds
          case "uu":
            return this.num(Math.floor(dt.millisecond / 10), 2);
          case "uuu":
            return this.num(Math.floor(dt.millisecond / 100));
          // minutes
          case "m":
            return this.num(dt.minute);
          case "mm":
            return this.num(dt.minute, 2);
          // hours
          case "h":
            return this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12);
          case "hh":
            return this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12, 2);
          case "H":
            return this.num(dt.hour);
          case "HH":
            return this.num(dt.hour, 2);
          // offset
          case "Z":
            // like +6
            return formatOffset({ format: "narrow", allowZ: this.opts.allowZ });
          case "ZZ":
            // like +06:00
            return formatOffset({ format: "short", allowZ: this.opts.allowZ });
          case "ZZZ":
            // like +0600
            return formatOffset({ format: "techie", allowZ: this.opts.allowZ });
          case "ZZZZ":
            // like EST
            return dt.zone.offsetName(dt.ts, { format: "short", locale: this.loc.locale });
          case "ZZZZZ":
            // like Eastern Standard Time
            return dt.zone.offsetName(dt.ts, { format: "long", locale: this.loc.locale });
          // zone
          case "z":
            // like America/New_York
            return dt.zoneName;
          // meridiems
          case "a":
            return meridiem();
          // dates
          case "d":
            return useDateTimeFormatter ? string({ day: "numeric" }, "day") : this.num(dt.day);
          case "dd":
            return useDateTimeFormatter ? string({ day: "2-digit" }, "day") : this.num(dt.day, 2);
          // weekdays - standalone
          case "c":
            // like 1
            return this.num(dt.weekday);
          case "ccc":
            // like 'Tues'
            return weekday("short", true);
          case "cccc":
            // like 'Tuesday'
            return weekday("long", true);
          case "ccccc":
            // like 'T'
            return weekday("narrow", true);
          // weekdays - format
          case "E":
            // like 1
            return this.num(dt.weekday);
          case "EEE":
            // like 'Tues'
            return weekday("short", false);
          case "EEEE":
            // like 'Tuesday'
            return weekday("long", false);
          case "EEEEE":
            // like 'T'
            return weekday("narrow", false);
          // months - standalone
          case "L":
            // like 1
            return useDateTimeFormatter
              ? string({ month: "numeric", day: "numeric" }, "month")
              : this.num(dt.month);
          case "LL":
            // like 01, doesn't seem to work
            return useDateTimeFormatter
              ? string({ month: "2-digit", day: "numeric" }, "month")
              : this.num(dt.month, 2);
          case "LLL":
            // like Jan
            return month("short", true);
          case "LLLL":
            // like January
            return month("long", true);
          case "LLLLL":
            // like J
            return month("narrow", true);
          // months - format
          case "M":
            // like 1
            return useDateTimeFormatter
              ? string({ month: "numeric" }, "month")
              : this.num(dt.month);
          case "MM":
            // like 01
            return useDateTimeFormatter
              ? string({ month: "2-digit" }, "month")
              : this.num(dt.month, 2);
          case "MMM":
            // like Jan
            return month("short", false);
          case "MMMM":
            // like January
            return month("long", false);
          case "MMMMM":
            // like J
            return month("narrow", false);
          // years
          case "y":
            // like 2014
            return useDateTimeFormatter ? string({ year: "numeric" }, "year") : this.num(dt.year);
          case "yy":
            // like 14
            return useDateTimeFormatter
              ? string({ year: "2-digit" }, "year")
              : this.num(dt.year.toString().slice(-2), 2);
          case "yyyy":
            // like 0012
            return useDateTimeFormatter
              ? string({ year: "numeric" }, "year")
              : this.num(dt.year, 4);
          case "yyyyyy":
            // like 000012
            return useDateTimeFormatter
              ? string({ year: "numeric" }, "year")
              : this.num(dt.year, 6);
          // eras
          case "G":
            // like AD
            return era("short");
          case "GG":
            // like Anno Domini
            return era("long");
          case "GGGGG":
            return era("narrow");
          case "kk":
            return this.num(dt.weekYear.toString().slice(-2), 2);
          case "kkkk":
            return this.num(dt.weekYear, 4);
          case "W":
            return this.num(dt.weekNumber);
          case "WW":
            return this.num(dt.weekNumber, 2);
          case "n":
            return this.num(dt.localWeekNumber);
          case "nn":
            return this.num(dt.localWeekNumber, 2);
          case "ii":
            return this.num(dt.localWeekYear.toString().slice(-2), 2);
          case "iiii":
            return this.num(dt.localWeekYear, 4);
          case "o":
            return this.num(dt.ordinal);
          case "ooo":
            return this.num(dt.ordinal, 3);
          case "q":
            // like 1
            return this.num(dt.quarter);
          case "qq":
            // like 01
            return this.num(dt.quarter, 2);
          case "X":
            return this.num(Math.floor(dt.ts / 1000));
          case "x":
            return this.num(dt.ts);
          default:
            return maybeMacro(token);
        }
      };

    return stringifyTokens(Formatter.parseFormat(fmt), tokenToString);
  }

  formatDurationFromString(dur, fmt) {
    const tokenToField = (token) => {
        switch (token[0]) {
          case "S":
            return "millisecond";
          case "s":
            return "second";
          case "m":
            return "minute";
          case "h":
            return "hour";
          case "d":
            return "day";
          case "w":
            return "week";
          case "M":
            return "month";
          case "y":
            return "year";
          default:
            return null;
        }
      },
      tokenToString = (lildur) => (token) => {
        const mapped = tokenToField(token);
        if (mapped) {
          return this.num(lildur.get(mapped), token.length);
        } else {
          return token;
        }
      },
      tokens = Formatter.parseFormat(fmt),
      realTokens = tokens.reduce(
        (found, { literal, val }) => (literal ? found : found.concat(val)),
        []
      ),
      collapsed = dur.shiftTo(...realTokens.map(tokenToField).filter((t) => t));
    return stringifyTokens(tokens, tokenToString(collapsed));
  }
}

;// CONCATENATED MODULE: ../node_modules/luxon/src/impl/regexParser.js





/*
 * This file handles parsing for well-specified formats. Here's how it works:
 * Two things go into parsing: a regex to match with and an extractor to take apart the groups in the match.
 * An extractor is just a function that takes a regex match array and returns a { year: ..., month: ... } object
 * parse() does the work of executing the regex and applying the extractor. It takes multiple regex/extractor pairs to try in sequence.
 * Extractors can take a "cursor" representing the offset in the match to look at. This makes it easy to combine extractors.
 * combineExtractors() does the work of combining them, keeping track of the cursor through multiple extractions.
 * Some extractions are super dumb and simpleParse and fromStrings help DRY them.
 */

const ianaRegex = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;

function combineRegexes(...regexes) {
  const full = regexes.reduce((f, r) => f + r.source, "");
  return RegExp(`^${full}$`);
}

function combineExtractors(...extractors) {
  return (m) =>
    extractors
      .reduce(
        ([mergedVals, mergedZone, cursor], ex) => {
          const [val, zone, next] = ex(m, cursor);
          return [{ ...mergedVals, ...val }, zone || mergedZone, next];
        },
        [{}, null, 1]
      )
      .slice(0, 2);
}

function regexParser_parse(s, ...patterns) {
  if (s == null) {
    return [null, null];
  }

  for (const [regex, extractor] of patterns) {
    const m = regex.exec(s);
    if (m) {
      return extractor(m);
    }
  }
  return [null, null];
}

function simpleParse(...keys) {
  return (match, cursor) => {
    const ret = {};
    let i;

    for (i = 0; i < keys.length; i++) {
      ret[keys[i]] = parseInteger(match[cursor + i]);
    }
    return [ret, null, cursor + i];
  };
}

// ISO and SQL parsing
const offsetRegex = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/;
const isoExtendedZone = `(?:${offsetRegex.source}?(?:\\[(${ianaRegex.source})\\])?)?`;
const isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/;
const isoTimeRegex = RegExp(`${isoTimeBaseRegex.source}${isoExtendedZone}`);
const isoTimeExtensionRegex = RegExp(`(?:T${isoTimeRegex.source})?`);
const isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/;
const isoWeekRegex = /(\d{4})-?W(\d\d)(?:-?(\d))?/;
const isoOrdinalRegex = /(\d{4})-?(\d{3})/;
const extractISOWeekData = simpleParse("weekYear", "weekNumber", "weekDay");
const extractISOOrdinalData = simpleParse("year", "ordinal");
const sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/; // dumbed-down version of the ISO one
const sqlTimeRegex = RegExp(
  `${isoTimeBaseRegex.source} ?(?:${offsetRegex.source}|(${ianaRegex.source}))?`
);
const sqlTimeExtensionRegex = RegExp(`(?: ${sqlTimeRegex.source})?`);

function regexParser_int(match, pos, fallback) {
  const m = match[pos];
  return isUndefined(m) ? fallback : parseInteger(m);
}

function extractISOYmd(match, cursor) {
  const item = {
    year: regexParser_int(match, cursor),
    month: regexParser_int(match, cursor + 1, 1),
    day: regexParser_int(match, cursor + 2, 1),
  };

  return [item, null, cursor + 3];
}

function extractISOTime(match, cursor) {
  const item = {
    hours: regexParser_int(match, cursor, 0),
    minutes: regexParser_int(match, cursor + 1, 0),
    seconds: regexParser_int(match, cursor + 2, 0),
    milliseconds: parseMillis(match[cursor + 3]),
  };

  return [item, null, cursor + 4];
}

function extractISOOffset(match, cursor) {
  const local = !match[cursor] && !match[cursor + 1],
    fullOffset = signedOffset(match[cursor + 1], match[cursor + 2]),
    zone = local ? null : FixedOffsetZone.instance(fullOffset);
  return [{}, zone, cursor + 3];
}

function extractIANAZone(match, cursor) {
  const zone = match[cursor] ? IANAZone.create(match[cursor]) : null;
  return [{}, zone, cursor + 1];
}

// ISO time parsing

const isoTimeOnly = RegExp(`^T?${isoTimeBaseRegex.source}$`);

// ISO duration parsing

const isoDuration =
  /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;

function extractISODuration(match) {
  const [s, yearStr, monthStr, weekStr, dayStr, hourStr, minuteStr, secondStr, millisecondsStr] =
    match;

  const hasNegativePrefix = s[0] === "-";
  const negativeSeconds = secondStr && secondStr[0] === "-";

  const maybeNegate = (num, force = false) =>
    num !== undefined && (force || (num && hasNegativePrefix)) ? -num : num;

  return [
    {
      years: maybeNegate(parseFloating(yearStr)),
      months: maybeNegate(parseFloating(monthStr)),
      weeks: maybeNegate(parseFloating(weekStr)),
      days: maybeNegate(parseFloating(dayStr)),
      hours: maybeNegate(parseFloating(hourStr)),
      minutes: maybeNegate(parseFloating(minuteStr)),
      seconds: maybeNegate(parseFloating(secondStr), secondStr === "-0"),
      milliseconds: maybeNegate(parseMillis(millisecondsStr), negativeSeconds),
    },
  ];
}

// These are a little braindead. EDT *should* tell us that we're in, say, America/New_York
// and not just that we're in -240 *right now*. But since I don't think these are used that often
// I'm just going to ignore that
const obsOffsets = {
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60,
};

function fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
  const result = {
    year: yearStr.length === 2 ? untruncateYear(parseInteger(yearStr)) : parseInteger(yearStr),
    month: monthsShort.indexOf(monthStr) + 1,
    day: parseInteger(dayStr),
    hour: parseInteger(hourStr),
    minute: parseInteger(minuteStr),
  };

  if (secondStr) result.second = parseInteger(secondStr);
  if (weekdayStr) {
    result.weekday =
      weekdayStr.length > 3
        ? weekdaysLong.indexOf(weekdayStr) + 1
        : weekdaysShort.indexOf(weekdayStr) + 1;
  }

  return result;
}

// RFC 2822/5322
const rfc2822 =
  /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;

function extractRFC2822(match) {
  const [
      ,
      weekdayStr,
      dayStr,
      monthStr,
      yearStr,
      hourStr,
      minuteStr,
      secondStr,
      obsOffset,
      milOffset,
      offHourStr,
      offMinuteStr,
    ] = match,
    result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);

  let offset;
  if (obsOffset) {
    offset = obsOffsets[obsOffset];
  } else if (milOffset) {
    offset = 0;
  } else {
    offset = signedOffset(offHourStr, offMinuteStr);
  }

  return [result, new FixedOffsetZone(offset)];
}

function preprocessRFC2822(s) {
  // Remove comments and folding whitespace and replace multiple-spaces with a single space
  return s
    .replace(/\([^()]*\)|[\n\t]/g, " ")
    .replace(/(\s\s+)/g, " ")
    .trim();
}

// http date

const rfc1123 =
    /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/,
  rfc850 =
    /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/,
  ascii =
    /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;

function extractRFC1123Or850(match) {
  const [, weekdayStr, dayStr, monthStr, yearStr, hourStr, minuteStr, secondStr] = match,
    result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  return [result, FixedOffsetZone.utcInstance];
}

function extractASCII(match) {
  const [, weekdayStr, monthStr, dayStr, hourStr, minuteStr, secondStr, yearStr] = match,
    result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  return [result, FixedOffsetZone.utcInstance];
}

const isoYmdWithTimeExtensionRegex = combineRegexes(isoYmdRegex, isoTimeExtensionRegex);
const isoWeekWithTimeExtensionRegex = combineRegexes(isoWeekRegex, isoTimeExtensionRegex);
const isoOrdinalWithTimeExtensionRegex = combineRegexes(isoOrdinalRegex, isoTimeExtensionRegex);
const isoTimeCombinedRegex = combineRegexes(isoTimeRegex);

const extractISOYmdTimeAndOffset = combineExtractors(
  extractISOYmd,
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);
const extractISOWeekTimeAndOffset = combineExtractors(
  extractISOWeekData,
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);
const extractISOOrdinalDateAndTime = combineExtractors(
  extractISOOrdinalData,
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);
const extractISOTimeAndOffset = combineExtractors(
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);

/*
 * @private
 */

function parseISODate(s) {
  return regexParser_parse(
    s,
    [isoYmdWithTimeExtensionRegex, extractISOYmdTimeAndOffset],
    [isoWeekWithTimeExtensionRegex, extractISOWeekTimeAndOffset],
    [isoOrdinalWithTimeExtensionRegex, extractISOOrdinalDateAndTime],
    [isoTimeCombinedRegex, extractISOTimeAndOffset]
  );
}

function parseRFC2822Date(s) {
  return regexParser_parse(preprocessRFC2822(s), [rfc2822, extractRFC2822]);
}

function parseHTTPDate(s) {
  return regexParser_parse(
    s,
    [rfc1123, extractRFC1123Or850],
    [rfc850, extractRFC1123Or850],
    [ascii, extractASCII]
  );
}

function parseISODuration(s) {
  return regexParser_parse(s, [isoDuration, extractISODuration]);
}

const extractISOTimeOnly = combineExtractors(extractISOTime);

function parseISOTimeOnly(s) {
  return regexParser_parse(s, [isoTimeOnly, extractISOTimeOnly]);
}

const sqlYmdWithTimeExtensionRegex = combineRegexes(sqlYmdRegex, sqlTimeExtensionRegex);
const sqlTimeCombinedRegex = combineRegexes(sqlTimeRegex);

const extractISOTimeOffsetAndIANAZone = combineExtractors(
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);

function parseSQL(s) {
  return regexParser_parse(
    s,
    [sqlYmdWithTimeExtensionRegex, extractISOYmdTimeAndOffset],
    [sqlTimeCombinedRegex, extractISOTimeOffsetAndIANAZone]
  );
}

;// CONCATENATED MODULE: ../node_modules/luxon/src/duration.js









const INVALID = "Invalid Duration";

// unit conversion constants
const lowOrderMatrix = {
    weeks: {
      days: 7,
      hours: 7 * 24,
      minutes: 7 * 24 * 60,
      seconds: 7 * 24 * 60 * 60,
      milliseconds: 7 * 24 * 60 * 60 * 1000,
    },
    days: {
      hours: 24,
      minutes: 24 * 60,
      seconds: 24 * 60 * 60,
      milliseconds: 24 * 60 * 60 * 1000,
    },
    hours: { minutes: 60, seconds: 60 * 60, milliseconds: 60 * 60 * 1000 },
    minutes: { seconds: 60, milliseconds: 60 * 1000 },
    seconds: { milliseconds: 1000 },
  },
  casualMatrix = {
    years: {
      quarters: 4,
      months: 12,
      weeks: 52,
      days: 365,
      hours: 365 * 24,
      minutes: 365 * 24 * 60,
      seconds: 365 * 24 * 60 * 60,
      milliseconds: 365 * 24 * 60 * 60 * 1000,
    },
    quarters: {
      months: 3,
      weeks: 13,
      days: 91,
      hours: 91 * 24,
      minutes: 91 * 24 * 60,
      seconds: 91 * 24 * 60 * 60,
      milliseconds: 91 * 24 * 60 * 60 * 1000,
    },
    months: {
      weeks: 4,
      days: 30,
      hours: 30 * 24,
      minutes: 30 * 24 * 60,
      seconds: 30 * 24 * 60 * 60,
      milliseconds: 30 * 24 * 60 * 60 * 1000,
    },

    ...lowOrderMatrix,
  },
  daysInYearAccurate = 146097.0 / 400,
  daysInMonthAccurate = 146097.0 / 4800,
  accurateMatrix = {
    years: {
      quarters: 4,
      months: 12,
      weeks: daysInYearAccurate / 7,
      days: daysInYearAccurate,
      hours: daysInYearAccurate * 24,
      minutes: daysInYearAccurate * 24 * 60,
      seconds: daysInYearAccurate * 24 * 60 * 60,
      milliseconds: daysInYearAccurate * 24 * 60 * 60 * 1000,
    },
    quarters: {
      months: 3,
      weeks: daysInYearAccurate / 28,
      days: daysInYearAccurate / 4,
      hours: (daysInYearAccurate * 24) / 4,
      minutes: (daysInYearAccurate * 24 * 60) / 4,
      seconds: (daysInYearAccurate * 24 * 60 * 60) / 4,
      milliseconds: (daysInYearAccurate * 24 * 60 * 60 * 1000) / 4,
    },
    months: {
      weeks: daysInMonthAccurate / 7,
      days: daysInMonthAccurate,
      hours: daysInMonthAccurate * 24,
      minutes: daysInMonthAccurate * 24 * 60,
      seconds: daysInMonthAccurate * 24 * 60 * 60,
      milliseconds: daysInMonthAccurate * 24 * 60 * 60 * 1000,
    },
    ...lowOrderMatrix,
  };

// units ordered by size
const orderedUnits = [
  "years",
  "quarters",
  "months",
  "weeks",
  "days",
  "hours",
  "minutes",
  "seconds",
  "milliseconds",
];

const reverseUnits = orderedUnits.slice(0).reverse();

// clone really means "create another instance just like this one, but with these changes"
function clone(dur, alts, clear = false) {
  // deep merge for vals
  const conf = {
    values: clear ? alts.values : { ...dur.values, ...(alts.values || {}) },
    loc: dur.loc.clone(alts.loc),
    conversionAccuracy: alts.conversionAccuracy || dur.conversionAccuracy,
    matrix: alts.matrix || dur.matrix,
  };
  return new Duration(conf);
}

function durationToMillis(matrix, vals) {
  let sum = vals.milliseconds ?? 0;
  for (const unit of reverseUnits.slice(1)) {
    if (vals[unit]) {
      sum += vals[unit] * matrix[unit]["milliseconds"];
    }
  }
  return sum;
}

// NB: mutates parameters
function normalizeValues(matrix, vals) {
  // the logic below assumes the overall value of the duration is positive
  // if this is not the case, factor is used to make it so
  const factor = durationToMillis(matrix, vals) < 0 ? -1 : 1;

  orderedUnits.reduceRight((previous, current) => {
    if (!isUndefined(vals[current])) {
      if (previous) {
        const previousVal = vals[previous] * factor;
        const conv = matrix[current][previous];

        // if (previousVal < 0):
        // lower order unit is negative (e.g. { years: 2, days: -2 })
        // normalize this by reducing the higher order unit by the appropriate amount
        // and increasing the lower order unit
        // this can never make the higher order unit negative, because this function only operates
        // on positive durations, so the amount of time represented by the lower order unit cannot
        // be larger than the higher order unit
        // else:
        // lower order unit is positive (e.g. { years: 2, days: 450 } or { years: -2, days: 450 })
        // in this case we attempt to convert as much as possible from the lower order unit into
        // the higher order one
        //
        // Math.floor takes care of both of these cases, rounding away from 0
        // if previousVal < 0 it makes the absolute value larger
        // if previousVal >= it makes the absolute value smaller
        const rollUp = Math.floor(previousVal / conv);
        vals[current] += rollUp * factor;
        vals[previous] -= rollUp * conv * factor;
      }
      return current;
    } else {
      return previous;
    }
  }, null);

  // try to convert any decimals into smaller units if possible
  // for example for { years: 2.5, days: 0, seconds: 0 } we want to get { years: 2, days: 182, hours: 12 }
  orderedUnits.reduce((previous, current) => {
    if (!isUndefined(vals[current])) {
      if (previous) {
        const fraction = vals[previous] % 1;
        vals[previous] -= fraction;
        vals[current] += fraction * matrix[previous][current];
      }
      return current;
    } else {
      return previous;
    }
  }, null);
}

// Remove all properties with a value of 0 from an object
function removeZeroes(vals) {
  const newVals = {};
  for (const [key, value] of Object.entries(vals)) {
    if (value !== 0) {
      newVals[key] = value;
    }
  }
  return newVals;
}

/**
 * A Duration object represents a period of time, like "2 months" or "1 day, 1 hour". Conceptually, it's just a map of units to their quantities, accompanied by some additional configuration and methods for creating, parsing, interrogating, transforming, and formatting them. They can be used on their own or in conjunction with other Luxon types; for example, you can use {@link DateTime#plus} to add a Duration object to a DateTime, producing another DateTime.
 *
 * Here is a brief overview of commonly used methods and getters in Duration:
 *
 * * **Creation** To create a Duration, use {@link Duration.fromMillis}, {@link Duration.fromObject}, or {@link Duration.fromISO}.
 * * **Unit values** See the {@link Duration#years}, {@link Duration#months}, {@link Duration#weeks}, {@link Duration#days}, {@link Duration#hours}, {@link Duration#minutes}, {@link Duration#seconds}, {@link Duration#milliseconds} accessors.
 * * **Configuration** See  {@link Duration#locale} and {@link Duration#numberingSystem} accessors.
 * * **Transformation** To create new Durations out of old ones use {@link Duration#plus}, {@link Duration#minus}, {@link Duration#normalize}, {@link Duration#set}, {@link Duration#reconfigure}, {@link Duration#shiftTo}, and {@link Duration#negate}.
 * * **Output** To convert the Duration into other representations, see {@link Duration#as}, {@link Duration#toISO}, {@link Duration#toFormat}, and {@link Duration#toJSON}
 *
 * There's are more methods documented below. In addition, for more information on subtler topics like internationalization and validity, see the external documentation.
 */
class Duration {
  /**
   * @private
   */
  constructor(config) {
    const accurate = config.conversionAccuracy === "longterm" || false;
    let matrix = accurate ? accurateMatrix : casualMatrix;

    if (config.matrix) {
      matrix = config.matrix;
    }

    /**
     * @access private
     */
    this.values = config.values;
    /**
     * @access private
     */
    this.loc = config.loc || Locale.create();
    /**
     * @access private
     */
    this.conversionAccuracy = accurate ? "longterm" : "casual";
    /**
     * @access private
     */
    this.invalid = config.invalid || null;
    /**
     * @access private
     */
    this.matrix = matrix;
    /**
     * @access private
     */
    this.isLuxonDuration = true;
  }

  /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  static fromMillis(count, opts) {
    return Duration.fromObject({ milliseconds: count }, opts);
  }

  /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {Object} [opts=[]] - options for creating this Duration
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the custom conversion system to use
   * @return {Duration}
   */
  static fromObject(obj, opts = {}) {
    if (obj == null || typeof obj !== "object") {
      throw new InvalidArgumentError(
        `Duration.fromObject: argument expected to be an object, got ${
          obj === null ? "null" : typeof obj
        }`
      );
    }

    return new Duration({
      values: normalizeObject(obj, Duration.normalizeUnit),
      loc: Locale.fromObject(opts),
      conversionAccuracy: opts.conversionAccuracy,
      matrix: opts.matrix,
    });
  }

  /**
   * Create a Duration from DurationLike.
   *
   * @param {Object | number | Duration} durationLike
   * One of:
   * - object with keys like 'years' and 'hours'.
   * - number representing milliseconds
   * - Duration instance
   * @return {Duration}
   */
  static fromDurationLike(durationLike) {
    if (isNumber(durationLike)) {
      return Duration.fromMillis(durationLike);
    } else if (Duration.isDuration(durationLike)) {
      return durationLike;
    } else if (typeof durationLike === "object") {
      return Duration.fromObject(durationLike);
    } else {
      throw new InvalidArgumentError(
        `Unknown duration argument ${durationLike} of type ${typeof durationLike}`
      );
    }
  }

  /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the preset conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */
  static fromISO(text, opts) {
    const [parsed] = parseISODuration(text);
    if (parsed) {
      return Duration.fromObject(parsed, opts);
    } else {
      return Duration.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
    }
  }

  /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */
  static fromISOTime(text, opts) {
    const [parsed] = parseISOTimeOnly(text);
    if (parsed) {
      return Duration.fromObject(parsed, opts);
    } else {
      return Duration.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
    }
  }

  /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */
  static invalid(reason, explanation = null) {
    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the Duration is invalid");
    }

    const invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);

    if (Settings.throwOnInvalid) {
      throw new InvalidDurationError(invalid);
    } else {
      return new Duration({ invalid });
    }
  }

  /**
   * @private
   */
  static normalizeUnit(unit) {
    const normalized = {
      year: "years",
      years: "years",
      quarter: "quarters",
      quarters: "quarters",
      month: "months",
      months: "months",
      week: "weeks",
      weeks: "weeks",
      day: "days",
      days: "days",
      hour: "hours",
      hours: "hours",
      minute: "minutes",
      minutes: "minutes",
      second: "seconds",
      seconds: "seconds",
      millisecond: "milliseconds",
      milliseconds: "milliseconds",
    }[unit ? unit.toLowerCase() : unit];

    if (!normalized) throw new InvalidUnitError(unit);

    return normalized;
  }

  /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDuration(o) {
    return (o && o.isLuxonDuration) || false;
  }

  /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }

  /**
   * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }

  /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @return {string}
   */
  toFormat(fmt, opts = {}) {
    // reverse-compat since 1.2; we always round down now, never up, and we do it by default
    const fmtOpts = {
      ...opts,
      floor: opts.round !== false && opts.floor !== false,
    };
    return this.isValid
      ? Formatter.create(this.loc, fmtOpts).formatDurationFromString(this, fmt)
      : INVALID;
  }

  /**
   * Returns a string representation of a Duration with all units included.
   * To modify its behavior, use `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#options
   * @param {Object} opts - Formatting options. Accepts the same keys as the options parameter of the native `Intl.NumberFormat` constructor, as well as `listStyle`.
   * @param {string} [opts.listStyle='narrow'] - How to format the merged list. Corresponds to the `style` property of the options parameter of the native `Intl.ListFormat` constructor.
   * @example
   * ```js
   * var dur = Duration.fromObject({ days: 1, hours: 5, minutes: 6 })
   * dur.toHuman() //=> '1 day, 5 hours, 6 minutes'
   * dur.toHuman({ listStyle: "long" }) //=> '1 day, 5 hours, and 6 minutes'
   * dur.toHuman({ unitDisplay: "short" }) //=> '1 day, 5 hr, 6 min'
   * ```
   */
  toHuman(opts = {}) {
    if (!this.isValid) return INVALID;

    const l = orderedUnits
      .map((unit) => {
        const val = this.values[unit];
        if (isUndefined(val)) {
          return null;
        }
        return this.loc
          .numberFormatter({ style: "unit", unitDisplay: "long", ...opts, unit: unit.slice(0, -1) })
          .format(val);
      })
      .filter((n) => n);

    return this.loc
      .listFormatter({ type: "conjunction", style: opts.listStyle || "narrow", ...opts })
      .format(l);
  }

  /**
   * Returns a JavaScript object with this Duration's values.
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */
  toObject() {
    if (!this.isValid) return {};
    return { ...this.values };
  }

  /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */
  toISO() {
    // we could use the formatter, but this is an easier way to get the minimum string
    if (!this.isValid) return null;

    let s = "P";
    if (this.years !== 0) s += this.years + "Y";
    if (this.months !== 0 || this.quarters !== 0) s += this.months + this.quarters * 3 + "M";
    if (this.weeks !== 0) s += this.weeks + "W";
    if (this.days !== 0) s += this.days + "D";
    if (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0)
      s += "T";
    if (this.hours !== 0) s += this.hours + "H";
    if (this.minutes !== 0) s += this.minutes + "M";
    if (this.seconds !== 0 || this.milliseconds !== 0)
      // this will handle "floating point madness" by removing extra decimal places
      // https://stackoverflow.com/questions/588004/is-floating-point-math-broken
      s += roundTo(this.seconds + this.milliseconds / 1000, 3) + "S";
    if (s === "P") s += "T0S";
    return s;
  }

  /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */
  toISOTime(opts = {}) {
    if (!this.isValid) return null;

    const millis = this.toMillis();
    if (millis < 0 || millis >= 86400000) return null;

    opts = {
      suppressMilliseconds: false,
      suppressSeconds: false,
      includePrefix: false,
      format: "extended",
      ...opts,
      includeOffset: false,
    };

    const dateTime = DateTime.fromMillis(millis, { zone: "UTC" });
    return dateTime.toISOTime(opts);
  }

  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }

  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */
  toString() {
    return this.toISO();
  }

  /**
   * Returns a string representation of this Duration appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    if (this.isValid) {
      return `Duration { values: ${JSON.stringify(this.values)} }`;
    } else {
      return `Duration { Invalid, reason: ${this.invalidReason} }`;
    }
  }

  /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */
  toMillis() {
    if (!this.isValid) return NaN;

    return durationToMillis(this.matrix, this.values);
  }

  /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }

  /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  plus(duration) {
    if (!this.isValid) return this;

    const dur = Duration.fromDurationLike(duration),
      result = {};

    for (const k of orderedUnits) {
      if (util_hasOwnProperty(dur.values, k) || util_hasOwnProperty(this.values, k)) {
        result[k] = dur.get(k) + this.get(k);
      }
    }

    return clone(this, { values: result }, true);
  }

  /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  minus(duration) {
    if (!this.isValid) return this;

    const dur = Duration.fromDurationLike(duration);
    return this.plus(dur.negate());
  }

  /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hours" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */
  mapUnits(fn) {
    if (!this.isValid) return this;
    const result = {};
    for (const k of Object.keys(this.values)) {
      result[k] = asNumber(fn(this.values[k], k));
    }
    return clone(this, { values: result }, true);
  }

  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */
  get(unit) {
    return this[Duration.normalizeUnit(unit)];
  }

  /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */
  set(values) {
    if (!this.isValid) return this;

    const mixed = { ...this.values, ...normalizeObject(values, Duration.normalizeUnit) };
    return clone(this, { values: mixed });
  }

  /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */
  reconfigure({ locale, numberingSystem, conversionAccuracy, matrix } = {}) {
    const loc = this.loc.clone({ locale, numberingSystem });
    const opts = { loc, matrix, conversionAccuracy };
    return clone(this, opts);
  }

  /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */
  as(unit) {
    return this.isValid ? this.shiftTo(unit).get(unit) : NaN;
  }

  /**
   * Reduce this Duration to its canonical representation in its current units.
   * Assuming the overall value of the Duration is positive, this means:
   * - excessive values for lower-order units are converted to higher-order units (if possible, see first and second example)
   * - negative lower-order units are converted to higher order units (there must be such a higher order unit, otherwise
   *   the overall value would be negative, see third example)
   * - fractional values for higher-order units are converted to lower-order units (if possible, see fourth example)
   *
   * If the overall value is negative, the result of this method is equivalent to `this.negate().normalize().negate()`.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ days: 5000 }).normalize().toObject() //=> { days: 5000 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @example Duration.fromObject({ years: 2.5, days: 0, hours: 0 }).normalize().toObject() //=> { years: 2, days: 182, hours: 12 }
   * @return {Duration}
   */
  normalize() {
    if (!this.isValid) return this;
    const vals = this.toObject();
    normalizeValues(this.matrix, vals);
    return clone(this, { values: vals }, true);
  }

  /**
   * Rescale units to its largest representation
   * @example Duration.fromObject({ milliseconds: 90000 }).rescale().toObject() //=> { minutes: 1, seconds: 30 }
   * @return {Duration}
   */
  rescale() {
    if (!this.isValid) return this;
    const vals = removeZeroes(this.normalize().shiftToAll().toObject());
    return clone(this, { values: vals }, true);
  }

  /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */
  shiftTo(...units) {
    if (!this.isValid) return this;

    if (units.length === 0) {
      return this;
    }

    units = units.map((u) => Duration.normalizeUnit(u));

    const built = {},
      accumulated = {},
      vals = this.toObject();
    let lastUnit;

    for (const k of orderedUnits) {
      if (units.indexOf(k) >= 0) {
        lastUnit = k;

        let own = 0;

        // anything we haven't boiled down yet should get boiled to this unit
        for (const ak in accumulated) {
          own += this.matrix[ak][k] * accumulated[ak];
          accumulated[ak] = 0;
        }

        // plus anything that's already in this unit
        if (isNumber(vals[k])) {
          own += vals[k];
        }

        // only keep the integer part for now in the hopes of putting any decimal part
        // into a smaller unit later
        const i = Math.trunc(own);
        built[k] = i;
        accumulated[k] = (own * 1000 - i * 1000) / 1000;

        // otherwise, keep it in the wings to boil it later
      } else if (isNumber(vals[k])) {
        accumulated[k] = vals[k];
      }
    }

    // anything leftover becomes the decimal for the last unit
    // lastUnit must be defined since units is not empty
    for (const key in accumulated) {
      if (accumulated[key] !== 0) {
        built[lastUnit] +=
          key === lastUnit ? accumulated[key] : accumulated[key] / this.matrix[lastUnit][key];
      }
    }

    normalizeValues(this.matrix, built);
    return clone(this, { values: built }, true);
  }

  /**
   * Shift this Duration to all available units.
   * Same as shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds")
   * @return {Duration}
   */
  shiftToAll() {
    if (!this.isValid) return this;
    return this.shiftTo(
      "years",
      "months",
      "weeks",
      "days",
      "hours",
      "minutes",
      "seconds",
      "milliseconds"
    );
  }

  /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */
  negate() {
    if (!this.isValid) return this;
    const negated = {};
    for (const k of Object.keys(this.values)) {
      negated[k] = this.values[k] === 0 ? 0 : -this.values[k];
    }
    return clone(this, { values: negated }, true);
  }

  /**
   * Get the years.
   * @type {number}
   */
  get years() {
    return this.isValid ? this.values.years || 0 : NaN;
  }

  /**
   * Get the quarters.
   * @type {number}
   */
  get quarters() {
    return this.isValid ? this.values.quarters || 0 : NaN;
  }

  /**
   * Get the months.
   * @type {number}
   */
  get months() {
    return this.isValid ? this.values.months || 0 : NaN;
  }

  /**
   * Get the weeks
   * @type {number}
   */
  get weeks() {
    return this.isValid ? this.values.weeks || 0 : NaN;
  }

  /**
   * Get the days.
   * @type {number}
   */
  get days() {
    return this.isValid ? this.values.days || 0 : NaN;
  }

  /**
   * Get the hours.
   * @type {number}
   */
  get hours() {
    return this.isValid ? this.values.hours || 0 : NaN;
  }

  /**
   * Get the minutes.
   * @type {number}
   */
  get minutes() {
    return this.isValid ? this.values.minutes || 0 : NaN;
  }

  /**
   * Get the seconds.
   * @return {number}
   */
  get seconds() {
    return this.isValid ? this.values.seconds || 0 : NaN;
  }

  /**
   * Get the milliseconds.
   * @return {number}
   */
  get milliseconds() {
    return this.isValid ? this.values.milliseconds || 0 : NaN;
  }

  /**
   * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
   * on invalid DateTimes or Intervals.
   * @return {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }

  /**
   * Returns an error code if this Duration became invalid, or null if the Duration is valid
   * @return {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }

  /**
   * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }

  /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */
  equals(other) {
    if (!this.isValid || !other.isValid) {
      return false;
    }

    if (!this.loc.equals(other.loc)) {
      return false;
    }

    function eq(v1, v2) {
      // Consider 0 and undefined as equal
      if (v1 === undefined || v1 === 0) return v2 === undefined || v2 === 0;
      return v1 === v2;
    }

    for (const u of orderedUnits) {
      if (!eq(this.values[u], other.values[u])) {
        return false;
      }
    }
    return true;
  }
}

;// CONCATENATED MODULE: ../node_modules/luxon/src/interval.js








const interval_INVALID = "Invalid Interval";

// checks if the start is equal to or before the end
function validateStartEnd(start, end) {
  if (!start || !start.isValid) {
    return Interval.invalid("missing or invalid start");
  } else if (!end || !end.isValid) {
    return Interval.invalid("missing or invalid end");
  } else if (end < start) {
    return Interval.invalid(
      "end before start",
      `The end of an interval must be after its start, but you had start=${start.toISO()} and end=${end.toISO()}`
    );
  } else {
    return null;
  }
}

/**
 * An Interval object represents a half-open interval of time, where each endpoint is a {@link DateTime}. Conceptually, it's a container for those two endpoints, accompanied by methods for creating, parsing, interrogating, comparing, transforming, and formatting them.
 *
 * Here is a brief overview of the most commonly used methods and getters in Interval:
 *
 * * **Creation** To create an Interval, use {@link Interval.fromDateTimes}, {@link Interval.after}, {@link Interval.before}, or {@link Interval.fromISO}.
 * * **Accessors** Use {@link Interval#start} and {@link Interval#end} to get the start and end.
 * * **Interrogation** To analyze the Interval, use {@link Interval#count}, {@link Interval#length}, {@link Interval#hasSame}, {@link Interval#contains}, {@link Interval#isAfter}, or {@link Interval#isBefore}.
 * * **Transformation** To create other Intervals out of this one, use {@link Interval#set}, {@link Interval#splitAt}, {@link Interval#splitBy}, {@link Interval#divideEqually}, {@link Interval.merge}, {@link Interval.xor}, {@link Interval#union}, {@link Interval#intersection}, or {@link Interval#difference}.
 * * **Comparison** To compare this Interval to another one, use {@link Interval#equals}, {@link Interval#overlaps}, {@link Interval#abutsStart}, {@link Interval#abutsEnd}, {@link Interval#engulfs}
 * * **Output** To convert the Interval into other representations, see {@link Interval#toString}, {@link Interval#toLocaleString}, {@link Interval#toISO}, {@link Interval#toISODate}, {@link Interval#toISOTime}, {@link Interval#toFormat}, and {@link Interval#toDuration}.
 */
class Interval {
  /**
   * @private
   */
  constructor(config) {
    /**
     * @access private
     */
    this.s = config.start;
    /**
     * @access private
     */
    this.e = config.end;
    /**
     * @access private
     */
    this.invalid = config.invalid || null;
    /**
     * @access private
     */
    this.isLuxonInterval = true;
  }

  /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */
  static invalid(reason, explanation = null) {
    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the Interval is invalid");
    }

    const invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);

    if (Settings.throwOnInvalid) {
      throw new InvalidIntervalError(invalid);
    } else {
      return new Interval({ invalid });
    }
  }

  /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */
  static fromDateTimes(start, end) {
    const builtStart = friendlyDateTime(start),
      builtEnd = friendlyDateTime(end);

    const validateError = validateStartEnd(builtStart, builtEnd);

    if (validateError == null) {
      return new Interval({
        start: builtStart,
        end: builtEnd,
      });
    } else {
      return validateError;
    }
  }

  /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static after(start, duration) {
    const dur = Duration.fromDurationLike(duration),
      dt = friendlyDateTime(start);
    return Interval.fromDateTimes(dt, dt.plus(dur));
  }

  /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static before(end, duration) {
    const dur = Duration.fromDurationLike(duration),
      dt = friendlyDateTime(end);
    return Interval.fromDateTimes(dt.minus(dur), dt);
  }

  /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */
  static fromISO(text, opts) {
    const [s, e] = (text || "").split("/", 2);
    if (s && e) {
      let start, startIsValid;
      try {
        start = DateTime.fromISO(s, opts);
        startIsValid = start.isValid;
      } catch (e) {
        startIsValid = false;
      }

      let end, endIsValid;
      try {
        end = DateTime.fromISO(e, opts);
        endIsValid = end.isValid;
      } catch (e) {
        endIsValid = false;
      }

      if (startIsValid && endIsValid) {
        return Interval.fromDateTimes(start, end);
      }

      if (startIsValid) {
        const dur = Duration.fromISO(e, opts);
        if (dur.isValid) {
          return Interval.after(start, dur);
        }
      } else if (endIsValid) {
        const dur = Duration.fromISO(s, opts);
        if (dur.isValid) {
          return Interval.before(end, dur);
        }
      }
    }
    return Interval.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
  }

  /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isInterval(o) {
    return (o && o.isLuxonInterval) || false;
  }

  /**
   * Returns the start of the Interval
   * @type {DateTime}
   */
  get start() {
    return this.isValid ? this.s : null;
  }

  /**
   * Returns the end of the Interval
   * @type {DateTime}
   */
  get end() {
    return this.isValid ? this.e : null;
  }

  /**
   * Returns whether this Interval's end is at least its start, meaning that the Interval isn't 'backwards'.
   * @type {boolean}
   */
  get isValid() {
    return this.invalidReason === null;
  }

  /**
   * Returns an error code if this Interval is invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }

  /**
   * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }

  /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */
  length(unit = "milliseconds") {
    return this.isValid ? this.toDuration(...[unit]).get(unit) : NaN;
  }

  /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; this operation will always use the locale of the start DateTime
   * @return {number}
   */
  count(unit = "milliseconds", opts) {
    if (!this.isValid) return NaN;
    const start = this.start.startOf(unit, opts);
    let end;
    if (opts?.useLocaleWeeks) {
      end = this.end.reconfigure({ locale: start.locale });
    } else {
      end = this.end;
    }
    end = end.startOf(unit, opts);
    return Math.floor(end.diff(start, unit).get(unit)) + (end.valueOf() !== this.end.valueOf());
  }

  /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */
  hasSame(unit) {
    return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, unit) : false;
  }

  /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */
  isEmpty() {
    return this.s.valueOf() === this.e.valueOf();
  }

  /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isAfter(dateTime) {
    if (!this.isValid) return false;
    return this.s > dateTime;
  }

  /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isBefore(dateTime) {
    if (!this.isValid) return false;
    return this.e <= dateTime;
  }

  /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  contains(dateTime) {
    if (!this.isValid) return false;
    return this.s <= dateTime && this.e > dateTime;
  }

  /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */
  set({ start, end } = {}) {
    if (!this.isValid) return this;
    return Interval.fromDateTimes(start || this.s, end || this.e);
  }

  /**
   * Split this Interval at each of the specified DateTimes
   * @param {...DateTime} dateTimes - the unit of time to count.
   * @return {Array}
   */
  splitAt(...dateTimes) {
    if (!this.isValid) return [];
    const sorted = dateTimes
        .map(friendlyDateTime)
        .filter((d) => this.contains(d))
        .sort((a, b) => a.toMillis() - b.toMillis()),
      results = [];
    let { s } = this,
      i = 0;

    while (s < this.e) {
      const added = sorted[i] || this.e,
        next = +added > +this.e ? this.e : added;
      results.push(Interval.fromDateTimes(s, next));
      s = next;
      i += 1;
    }

    return results;
  }

  /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {Array}
   */
  splitBy(duration) {
    const dur = Duration.fromDurationLike(duration);

    if (!this.isValid || !dur.isValid || dur.as("milliseconds") === 0) {
      return [];
    }

    let { s } = this,
      idx = 1,
      next;

    const results = [];
    while (s < this.e) {
      const added = this.start.plus(dur.mapUnits((x) => x * idx));
      next = +added > +this.e ? this.e : added;
      results.push(Interval.fromDateTimes(s, next));
      s = next;
      idx += 1;
    }

    return results;
  }

  /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {Array}
   */
  divideEqually(numberOfParts) {
    if (!this.isValid) return [];
    return this.splitBy(this.length() / numberOfParts).slice(0, numberOfParts);
  }

  /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */
  overlaps(other) {
    return this.e > other.s && this.s < other.e;
  }

  /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsStart(other) {
    if (!this.isValid) return false;
    return +this.e === +other.s;
  }

  /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsEnd(other) {
    if (!this.isValid) return false;
    return +other.e === +this.s;
  }

  /**
   * Returns true if this Interval fully contains the specified Interval, specifically if the intersect (of this Interval and the other Interval) is equal to the other Interval; false otherwise.
   * @param {Interval} other
   * @return {boolean}
   */
  engulfs(other) {
    if (!this.isValid) return false;
    return this.s <= other.s && this.e >= other.e;
  }

  /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */
  equals(other) {
    if (!this.isValid || !other.isValid) {
      return false;
    }

    return this.s.equals(other.s) && this.e.equals(other.e);
  }

  /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */
  intersection(other) {
    if (!this.isValid) return this;
    const s = this.s > other.s ? this.s : other.s,
      e = this.e < other.e ? this.e : other.e;

    if (s >= e) {
      return null;
    } else {
      return Interval.fromDateTimes(s, e);
    }
  }

  /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */
  union(other) {
    if (!this.isValid) return this;
    const s = this.s < other.s ? this.s : other.s,
      e = this.e > other.e ? this.e : other.e;
    return Interval.fromDateTimes(s, e);
  }

  /**
   * Merge an array of Intervals into a equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static merge(intervals) {
    const [found, final] = intervals
      .sort((a, b) => a.s - b.s)
      .reduce(
        ([sofar, current], item) => {
          if (!current) {
            return [sofar, item];
          } else if (current.overlaps(item) || current.abutsStart(item)) {
            return [sofar, current.union(item)];
          } else {
            return [sofar.concat([current]), item];
          }
        },
        [[], null]
      );
    if (final) {
      found.push(final);
    }
    return found;
  }

  /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static xor(intervals) {
    let start = null,
      currentCount = 0;
    const results = [],
      ends = intervals.map((i) => [
        { time: i.s, type: "s" },
        { time: i.e, type: "e" },
      ]),
      flattened = Array.prototype.concat(...ends),
      arr = flattened.sort((a, b) => a.time - b.time);

    for (const i of arr) {
      currentCount += i.type === "s" ? 1 : -1;

      if (currentCount === 1) {
        start = i.time;
      } else {
        if (start && +start !== +i.time) {
          results.push(Interval.fromDateTimes(start, i.time));
        }

        start = null;
      }
    }

    return Interval.merge(results);
  }

  /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {Array}
   */
  difference(...intervals) {
    return Interval.xor([this].concat(intervals))
      .map((i) => this.intersection(i))
      .filter((i) => i && !i.isEmpty());
  }

  /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */
  toString() {
    if (!this.isValid) return interval_INVALID;
    return `[${this.s.toISO()} – ${this.e.toISO()})`;
  }

  /**
   * Returns a string representation of this Interval appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    if (this.isValid) {
      return `Interval { start: ${this.s.toISO()}, end: ${this.e.toISO()} }`;
    } else {
      return `Interval { Invalid, reason: ${this.invalidReason} }`;
    }
  }

  /**
   * Returns a localized string representing this Interval. Accepts the same options as the
   * Intl.DateTimeFormat constructor and any presets defined by Luxon, such as
   * {@link DateTime.DATE_FULL} or {@link DateTime.TIME_SIMPLE}. The exact behavior of this method
   * is browser-specific, but in general it will return an appropriate representation of the
   * Interval in the assigned locale. Defaults to the system's locale if no locale has been
   * specified.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {Object} [formatOpts=DateTime.DATE_SHORT] - Either a DateTime preset or
   * Intl.DateTimeFormat constructor options.
   * @param {Object} opts - Options to override the configuration of the start DateTime.
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(); //=> 11/7/2022 – 11/8/2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL); //=> November 7 – 8, 2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL, { locale: 'fr-FR' }); //=> 7–8 novembre 2022
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString(DateTime.TIME_SIMPLE); //=> 6:00 – 8:00 PM
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> Mon, Nov 07, 6:00 – 8:00 p
   * @return {string}
   */
  toLocaleString(formatOpts = DATE_SHORT, opts = {}) {
    return this.isValid
      ? Formatter.create(this.s.loc.clone(opts), formatOpts).formatInterval(this)
      : interval_INVALID;
  }

  /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISO(opts) {
    if (!this.isValid) return interval_INVALID;
    return `${this.s.toISO(opts)}/${this.e.toISO(opts)}`;
  }

  /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */
  toISODate() {
    if (!this.isValid) return interval_INVALID;
    return `${this.s.toISODate()}/${this.e.toISODate()}`;
  }

  /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISOTime(opts) {
    if (!this.isValid) return interval_INVALID;
    return `${this.s.toISOTime(opts)}/${this.e.toISOTime(opts)}`;
  }

  /**
   * Returns a string representation of this Interval formatted according to the specified format
   * string. **You may not want this.** See {@link Interval#toLocaleString} for a more flexible
   * formatting tool.
   * @param {string} dateFormat - The format string. This string formats the start and end time.
   * See {@link DateTime#toFormat} for details.
   * @param {Object} opts - Options.
   * @param {string} [opts.separator =  ' – '] - A separator to place between the start and end
   * representations.
   * @return {string}
   */
  toFormat(dateFormat, { separator = " – " } = {}) {
    if (!this.isValid) return interval_INVALID;
    return `${this.s.toFormat(dateFormat)}${separator}${this.e.toFormat(dateFormat)}`;
  }

  /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */
  toDuration(unit, opts) {
    if (!this.isValid) {
      return Duration.invalid(this.invalidReason);
    }
    return this.e.diff(this.s, unit, opts);
  }

  /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */
  mapEndpoints(mapFn) {
    return Interval.fromDateTimes(mapFn(this.s), mapFn(this.e));
  }
}

;// CONCATENATED MODULE: ../node_modules/luxon/src/info.js








/**
 * The Info class contains static methods for retrieving general time and date related data. For example, it has methods for finding out if a time zone has a DST, for listing the months in any supported locale, and for discovering which of Luxon features are available in the current environment.
 */
class Info {
  /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */
  static hasDST(zone = Settings.defaultZone) {
    const proto = DateTime.now().setZone(zone).set({ month: 12 });

    return !zone.isUniversal && proto.offset !== proto.set({ month: 6 }).offset;
  }

  /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */
  static isValidIANAZone(zone) {
    return IANAZone.isValidZone(zone);
  }

  /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone#isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */
  static normalizeZone(input) {
    return normalizeZone(input, Settings.defaultZone);
  }

  /**
   * Get the weekday on which the week starts according to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number} the start of the week, 1 for Monday through 7 for Sunday
   */
  static getStartOfWeek({ locale = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale)).getStartOfWeek();
  }

  /**
   * Get the minimum number of days necessary in a week before it is considered part of the next year according
   * to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number}
   */
  static getMinimumDaysInFirstWeek({ locale = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale)).getMinDaysInFirstWeek();
  }

  /**
   * Get the weekdays, which are considered the weekend according to the given locale
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number[]} an array of weekdays, 1 for Monday through 7 for Sunday
   */
  static getWeekendWeekdays({ locale = null, locObj = null } = {}) {
    // copy the array, because we cache it internally
    return (locObj || Locale.create(locale)).getWeekendDays().slice();
  }

  /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {Array}
   */
  static months(
    length = "long",
    { locale = null, numberingSystem = null, locObj = null, outputCalendar = "gregory" } = {}
  ) {
    return (locObj || Locale.create(locale, numberingSystem, outputCalendar)).months(length);
  }

  /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link Info#months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {Array}
   */
  static monthsFormat(
    length = "long",
    { locale = null, numberingSystem = null, locObj = null, outputCalendar = "gregory" } = {}
  ) {
    return (locObj || Locale.create(locale, numberingSystem, outputCalendar)).months(length, true);
  }

  /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {Array}
   */
  static weekdays(length = "long", { locale = null, numberingSystem = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale, numberingSystem, null)).weekdays(length);
  }

  /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link Info#weekdays}
   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {Array}
   */
  static weekdaysFormat(
    length = "long",
    { locale = null, numberingSystem = null, locObj = null } = {}
  ) {
    return (locObj || Locale.create(locale, numberingSystem, null)).weekdays(length, true);
  }

  /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {Array}
   */
  static meridiems({ locale = null } = {}) {
    return Locale.create(locale).meridiems();
  }

  /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {Array}
   */
  static eras(length = "short", { locale = null } = {}) {
    return Locale.create(locale, null, "gregory").eras(length);
  }

  /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `relative`: whether this environment supports relative time formatting
   * * `localeWeek`: whether this environment supports different weekdays for the start of the week based on the locale
   * @example Info.features() //=> { relative: false, localeWeek: true }
   * @return {Object}
   */
  static features() {
    return { relative: hasRelative(), localeWeek: hasLocaleWeekInfo() };
  }
}

;// CONCATENATED MODULE: ../node_modules/luxon/src/impl/diff.js


function dayDiff(earlier, later) {
  const utcDayStart = (dt) => dt.toUTC(0, { keepLocalTime: true }).startOf("day").valueOf(),
    ms = utcDayStart(later) - utcDayStart(earlier);
  return Math.floor(Duration.fromMillis(ms).as("days"));
}

function highOrderDiffs(cursor, later, units) {
  const differs = [
    ["years", (a, b) => b.year - a.year],
    ["quarters", (a, b) => b.quarter - a.quarter + (b.year - a.year) * 4],
    ["months", (a, b) => b.month - a.month + (b.year - a.year) * 12],
    [
      "weeks",
      (a, b) => {
        const days = dayDiff(a, b);
        return (days - (days % 7)) / 7;
      },
    ],
    ["days", dayDiff],
  ];

  const results = {};
  const earlier = cursor;
  let lowestOrder, highWater;

  /* This loop tries to diff using larger units first.
     If we overshoot, we backtrack and try the next smaller unit.
     "cursor" starts out at the earlier timestamp and moves closer and closer to "later"
     as we use smaller and smaller units.
     highWater keeps track of where we would be if we added one more of the smallest unit,
     this is used later to potentially convert any difference smaller than the smallest higher order unit
     into a fraction of that smallest higher order unit
  */
  for (const [unit, differ] of differs) {
    if (units.indexOf(unit) >= 0) {
      lowestOrder = unit;

      results[unit] = differ(cursor, later);
      highWater = earlier.plus(results);

      if (highWater > later) {
        // we overshot the end point, backtrack cursor by 1
        results[unit]--;
        cursor = earlier.plus(results);

        // if we are still overshooting now, we need to backtrack again
        // this happens in certain situations when diffing times in different zones,
        // because this calculation ignores time zones
        if (cursor > later) {
          // keep the "overshot by 1" around as highWater
          highWater = cursor;
          // backtrack cursor by 1
          results[unit]--;
          cursor = earlier.plus(results);
        }
      } else {
        cursor = highWater;
      }
    }
  }

  return [cursor, results, highWater, lowestOrder];
}

/* harmony default export */ function diff(earlier, later, units, opts) {
  let [cursor, results, highWater, lowestOrder] = highOrderDiffs(earlier, later, units);

  const remainingMillis = later - cursor;

  const lowerOrderUnits = units.filter(
    (u) => ["hours", "minutes", "seconds", "milliseconds"].indexOf(u) >= 0
  );

  if (lowerOrderUnits.length === 0) {
    if (highWater < later) {
      highWater = cursor.plus({ [lowestOrder]: 1 });
    }

    if (highWater !== cursor) {
      results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor);
    }
  }

  const duration = Duration.fromObject(results, opts);

  if (lowerOrderUnits.length > 0) {
    return Duration.fromMillis(remainingMillis, opts)
      .shiftTo(...lowerOrderUnits)
      .plus(duration);
  } else {
    return duration;
  }
}

;// CONCATENATED MODULE: ../node_modules/luxon/src/impl/tokenParser.js








const MISSING_FTP = "missing Intl.DateTimeFormat.formatToParts support";

function intUnit(regex, post = (i) => i) {
  return { regex, deser: ([s]) => post(parseDigits(s)) };
}

const NBSP = String.fromCharCode(160);
const spaceOrNBSP = `[ ${NBSP}]`;
const spaceOrNBSPRegExp = new RegExp(spaceOrNBSP, "g");

function fixListRegex(s) {
  // make dots optional and also make them literal
  // make space and non breakable space characters interchangeable
  return s.replace(/\./g, "\\.?").replace(spaceOrNBSPRegExp, spaceOrNBSP);
}

function stripInsensitivities(s) {
  return s
    .replace(/\./g, "") // ignore dots that were made optional
    .replace(spaceOrNBSPRegExp, " ") // interchange space and nbsp
    .toLowerCase();
}

function oneOf(strings, startIndex) {
  if (strings === null) {
    return null;
  } else {
    return {
      regex: RegExp(strings.map(fixListRegex).join("|")),
      deser: ([s]) =>
        strings.findIndex((i) => stripInsensitivities(s) === stripInsensitivities(i)) + startIndex,
    };
  }
}

function offset(regex, groups) {
  return { regex, deser: ([, h, m]) => signedOffset(h, m), groups };
}

function simple(regex) {
  return { regex, deser: ([s]) => s };
}

function escapeToken(value) {
  return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}

/**
 * @param token
 * @param {Locale} loc
 */
function unitForToken(token, loc) {
  const one = digitRegex(loc),
    two = digitRegex(loc, "{2}"),
    three = digitRegex(loc, "{3}"),
    four = digitRegex(loc, "{4}"),
    six = digitRegex(loc, "{6}"),
    oneOrTwo = digitRegex(loc, "{1,2}"),
    oneToThree = digitRegex(loc, "{1,3}"),
    oneToSix = digitRegex(loc, "{1,6}"),
    oneToNine = digitRegex(loc, "{1,9}"),
    twoToFour = digitRegex(loc, "{2,4}"),
    fourToSix = digitRegex(loc, "{4,6}"),
    literal = (t) => ({ regex: RegExp(escapeToken(t.val)), deser: ([s]) => s, literal: true }),
    unitate = (t) => {
      if (token.literal) {
        return literal(t);
      }
      switch (t.val) {
        // era
        case "G":
          return oneOf(loc.eras("short"), 0);
        case "GG":
          return oneOf(loc.eras("long"), 0);
        // years
        case "y":
          return intUnit(oneToSix);
        case "yy":
          return intUnit(twoToFour, untruncateYear);
        case "yyyy":
          return intUnit(four);
        case "yyyyy":
          return intUnit(fourToSix);
        case "yyyyyy":
          return intUnit(six);
        // months
        case "M":
          return intUnit(oneOrTwo);
        case "MM":
          return intUnit(two);
        case "MMM":
          return oneOf(loc.months("short", true), 1);
        case "MMMM":
          return oneOf(loc.months("long", true), 1);
        case "L":
          return intUnit(oneOrTwo);
        case "LL":
          return intUnit(two);
        case "LLL":
          return oneOf(loc.months("short", false), 1);
        case "LLLL":
          return oneOf(loc.months("long", false), 1);
        // dates
        case "d":
          return intUnit(oneOrTwo);
        case "dd":
          return intUnit(two);
        // ordinals
        case "o":
          return intUnit(oneToThree);
        case "ooo":
          return intUnit(three);
        // time
        case "HH":
          return intUnit(two);
        case "H":
          return intUnit(oneOrTwo);
        case "hh":
          return intUnit(two);
        case "h":
          return intUnit(oneOrTwo);
        case "mm":
          return intUnit(two);
        case "m":
          return intUnit(oneOrTwo);
        case "q":
          return intUnit(oneOrTwo);
        case "qq":
          return intUnit(two);
        case "s":
          return intUnit(oneOrTwo);
        case "ss":
          return intUnit(two);
        case "S":
          return intUnit(oneToThree);
        case "SSS":
          return intUnit(three);
        case "u":
          return simple(oneToNine);
        case "uu":
          return simple(oneOrTwo);
        case "uuu":
          return intUnit(one);
        // meridiem
        case "a":
          return oneOf(loc.meridiems(), 0);
        // weekYear (k)
        case "kkkk":
          return intUnit(four);
        case "kk":
          return intUnit(twoToFour, untruncateYear);
        // weekNumber (W)
        case "W":
          return intUnit(oneOrTwo);
        case "WW":
          return intUnit(two);
        // weekdays
        case "E":
        case "c":
          return intUnit(one);
        case "EEE":
          return oneOf(loc.weekdays("short", false), 1);
        case "EEEE":
          return oneOf(loc.weekdays("long", false), 1);
        case "ccc":
          return oneOf(loc.weekdays("short", true), 1);
        case "cccc":
          return oneOf(loc.weekdays("long", true), 1);
        // offset/zone
        case "Z":
        case "ZZ":
          return offset(new RegExp(`([+-]${oneOrTwo.source})(?::(${two.source}))?`), 2);
        case "ZZZ":
          return offset(new RegExp(`([+-]${oneOrTwo.source})(${two.source})?`), 2);
        // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
        // because we don't have any way to figure out what they are
        case "z":
          return simple(/[a-z_+-/]{1,256}?/i);
        // this special-case "token" represents a place where a macro-token expanded into a white-space literal
        // in this case we accept any non-newline white-space
        case " ":
          return simple(/[^\S\n\r]/);
        default:
          return literal(t);
      }
    };

  const unit = unitate(token) || {
    invalidReason: MISSING_FTP,
  };

  unit.token = token;

  return unit;
}

const partTypeStyleToTokenVal = {
  year: {
    "2-digit": "yy",
    numeric: "yyyyy",
  },
  month: {
    numeric: "M",
    "2-digit": "MM",
    short: "MMM",
    long: "MMMM",
  },
  day: {
    numeric: "d",
    "2-digit": "dd",
  },
  weekday: {
    short: "EEE",
    long: "EEEE",
  },
  dayperiod: "a",
  dayPeriod: "a",
  hour12: {
    numeric: "h",
    "2-digit": "hh",
  },
  hour24: {
    numeric: "H",
    "2-digit": "HH",
  },
  minute: {
    numeric: "m",
    "2-digit": "mm",
  },
  second: {
    numeric: "s",
    "2-digit": "ss",
  },
  timeZoneName: {
    long: "ZZZZZ",
    short: "ZZZ",
  },
};

function tokenForPart(part, formatOpts, resolvedOpts) {
  const { type, value } = part;

  if (type === "literal") {
    const isSpace = /^\s+$/.test(value);
    return {
      literal: !isSpace,
      val: isSpace ? " " : value,
    };
  }

  const style = formatOpts[type];

  // The user might have explicitly specified hour12 or hourCycle
  // if so, respect their decision
  // if not, refer back to the resolvedOpts, which are based on the locale
  let actualType = type;
  if (type === "hour") {
    if (formatOpts.hour12 != null) {
      actualType = formatOpts.hour12 ? "hour12" : "hour24";
    } else if (formatOpts.hourCycle != null) {
      if (formatOpts.hourCycle === "h11" || formatOpts.hourCycle === "h12") {
        actualType = "hour12";
      } else {
        actualType = "hour24";
      }
    } else {
      // tokens only differentiate between 24 hours or not,
      // so we do not need to check hourCycle here, which is less supported anyways
      actualType = resolvedOpts.hour12 ? "hour12" : "hour24";
    }
  }
  let val = partTypeStyleToTokenVal[actualType];
  if (typeof val === "object") {
    val = val[style];
  }

  if (val) {
    return {
      literal: false,
      val,
    };
  }

  return undefined;
}

function buildRegex(units) {
  const re = units.map((u) => u.regex).reduce((f, r) => `${f}(${r.source})`, "");
  return [`^${re}$`, units];
}

function match(input, regex, handlers) {
  const matches = input.match(regex);

  if (matches) {
    const all = {};
    let matchIndex = 1;
    for (const i in handlers) {
      if (util_hasOwnProperty(handlers, i)) {
        const h = handlers[i],
          groups = h.groups ? h.groups + 1 : 1;
        if (!h.literal && h.token) {
          all[h.token.val[0]] = h.deser(matches.slice(matchIndex, matchIndex + groups));
        }
        matchIndex += groups;
      }
    }
    return [matches, all];
  } else {
    return [matches, {}];
  }
}

function dateTimeFromMatches(matches) {
  const toField = (token) => {
    switch (token) {
      case "S":
        return "millisecond";
      case "s":
        return "second";
      case "m":
        return "minute";
      case "h":
      case "H":
        return "hour";
      case "d":
        return "day";
      case "o":
        return "ordinal";
      case "L":
      case "M":
        return "month";
      case "y":
        return "year";
      case "E":
      case "c":
        return "weekday";
      case "W":
        return "weekNumber";
      case "k":
        return "weekYear";
      case "q":
        return "quarter";
      default:
        return null;
    }
  };

  let zone = null;
  let specificOffset;
  if (!isUndefined(matches.z)) {
    zone = IANAZone.create(matches.z);
  }

  if (!isUndefined(matches.Z)) {
    if (!zone) {
      zone = new FixedOffsetZone(matches.Z);
    }
    specificOffset = matches.Z;
  }

  if (!isUndefined(matches.q)) {
    matches.M = (matches.q - 1) * 3 + 1;
  }

  if (!isUndefined(matches.h)) {
    if (matches.h < 12 && matches.a === 1) {
      matches.h += 12;
    } else if (matches.h === 12 && matches.a === 0) {
      matches.h = 0;
    }
  }

  if (matches.G === 0 && matches.y) {
    matches.y = -matches.y;
  }

  if (!isUndefined(matches.u)) {
    matches.S = parseMillis(matches.u);
  }

  const vals = Object.keys(matches).reduce((r, k) => {
    const f = toField(k);
    if (f) {
      r[f] = matches[k];
    }

    return r;
  }, {});

  return [vals, zone, specificOffset];
}

let dummyDateTimeCache = null;

function getDummyDateTime() {
  if (!dummyDateTimeCache) {
    dummyDateTimeCache = DateTime.fromMillis(1555555555555);
  }

  return dummyDateTimeCache;
}

function maybeExpandMacroToken(token, locale) {
  if (token.literal) {
    return token;
  }

  const formatOpts = Formatter.macroTokenToFormatOpts(token.val);
  const tokens = formatOptsToTokens(formatOpts, locale);

  if (tokens == null || tokens.includes(undefined)) {
    return token;
  }

  return tokens;
}

function expandMacroTokens(tokens, locale) {
  return Array.prototype.concat(...tokens.map((t) => maybeExpandMacroToken(t, locale)));
}

/**
 * @private
 */

class TokenParser {
  constructor(locale, format) {
    this.locale = locale;
    this.format = format;
    this.tokens = expandMacroTokens(Formatter.parseFormat(format), locale);
    this.units = this.tokens.map((t) => unitForToken(t, locale));
    this.disqualifyingUnit = this.units.find((t) => t.invalidReason);

    if (!this.disqualifyingUnit) {
      const [regexString, handlers] = buildRegex(this.units);
      this.regex = RegExp(regexString, "i");
      this.handlers = handlers;
    }
  }

  explainFromTokens(input) {
    if (!this.isValid) {
      return { input, tokens: this.tokens, invalidReason: this.invalidReason };
    } else {
      const [rawMatches, matches] = match(input, this.regex, this.handlers),
        [result, zone, specificOffset] = matches
          ? dateTimeFromMatches(matches)
          : [null, null, undefined];
      if (util_hasOwnProperty(matches, "a") && util_hasOwnProperty(matches, "H")) {
        throw new ConflictingSpecificationError(
          "Can't include meridiem when specifying 24-hour format"
        );
      }
      return {
        input,
        tokens: this.tokens,
        regex: this.regex,
        rawMatches,
        matches,
        result,
        zone,
        specificOffset,
      };
    }
  }

  get isValid() {
    return !this.disqualifyingUnit;
  }

  get invalidReason() {
    return this.disqualifyingUnit ? this.disqualifyingUnit.invalidReason : null;
  }
}

function explainFromTokens(locale, input, format) {
  const parser = new TokenParser(locale, format);
  return parser.explainFromTokens(input);
}

function parseFromTokens(locale, input, format) {
  const { result, zone, specificOffset, invalidReason } = explainFromTokens(locale, input, format);
  return [result, zone, specificOffset, invalidReason];
}

function formatOptsToTokens(formatOpts, locale) {
  if (!formatOpts) {
    return null;
  }

  const formatter = Formatter.create(locale, formatOpts);
  const df = formatter.dtFormatter(getDummyDateTime());
  const parts = df.formatToParts();
  const resolvedOpts = df.resolvedOptions();
  return parts.map((p) => tokenForPart(p, formatOpts, resolvedOpts));
}

;// CONCATENATED MODULE: ../node_modules/luxon/src/datetime.js

















const datetime_INVALID = "Invalid DateTime";
const MAX_DATE = 8.64e15;

function unsupportedZone(zone) {
  return new Invalid("unsupported zone", `the zone "${zone.name}" is not supported`);
}

// we cache week data on the DT object and this intermediates the cache
/**
 * @param {DateTime} dt
 */
function possiblyCachedWeekData(dt) {
  if (dt.weekData === null) {
    dt.weekData = gregorianToWeek(dt.c);
  }
  return dt.weekData;
}

/**
 * @param {DateTime} dt
 */
function possiblyCachedLocalWeekData(dt) {
  if (dt.localWeekData === null) {
    dt.localWeekData = gregorianToWeek(
      dt.c,
      dt.loc.getMinDaysInFirstWeek(),
      dt.loc.getStartOfWeek()
    );
  }
  return dt.localWeekData;
}

// clone really means, "make a new object with these modifications". all "setters" really use this
// to create a new object while only changing some of the properties
function datetime_clone(inst, alts) {
  const current = {
    ts: inst.ts,
    zone: inst.zone,
    c: inst.c,
    o: inst.o,
    loc: inst.loc,
    invalid: inst.invalid,
  };
  return new DateTime({ ...current, ...alts, old: current });
}

// find the right offset a given local time. The o input is our guess, which determines which
// offset we'll pick in ambiguous cases (e.g. there are two 3 AMs b/c Fallback DST)
function fixOffset(localTS, o, tz) {
  // Our UTC time is just a guess because our offset is just a guess
  let utcGuess = localTS - o * 60 * 1000;

  // Test whether the zone matches the offset for this ts
  const o2 = tz.offset(utcGuess);

  // If so, offset didn't change and we're done
  if (o === o2) {
    return [utcGuess, o];
  }

  // If not, change the ts by the difference in the offset
  utcGuess -= (o2 - o) * 60 * 1000;

  // If that gives us the local time we want, we're done
  const o3 = tz.offset(utcGuess);
  if (o2 === o3) {
    return [utcGuess, o2];
  }

  // If it's different, we're in a hole time. The offset has changed, but the we don't adjust the time
  return [localTS - Math.min(o2, o3) * 60 * 1000, Math.max(o2, o3)];
}

// convert an epoch timestamp into a calendar object with the given offset
function tsToObj(ts, offset) {
  ts += offset * 60 * 1000;

  const d = new Date(ts);

  return {
    year: d.getUTCFullYear(),
    month: d.getUTCMonth() + 1,
    day: d.getUTCDate(),
    hour: d.getUTCHours(),
    minute: d.getUTCMinutes(),
    second: d.getUTCSeconds(),
    millisecond: d.getUTCMilliseconds(),
  };
}

// convert a calendar object to a epoch timestamp
function objToTS(obj, offset, zone) {
  return fixOffset(objToLocalTS(obj), offset, zone);
}

// create a new DT instance by adding a duration, adjusting for DSTs
function adjustTime(inst, dur) {
  const oPre = inst.o,
    year = inst.c.year + Math.trunc(dur.years),
    month = inst.c.month + Math.trunc(dur.months) + Math.trunc(dur.quarters) * 3,
    c = {
      ...inst.c,
      year,
      month,
      day:
        Math.min(inst.c.day, daysInMonth(year, month)) +
        Math.trunc(dur.days) +
        Math.trunc(dur.weeks) * 7,
    },
    millisToAdd = Duration.fromObject({
      years: dur.years - Math.trunc(dur.years),
      quarters: dur.quarters - Math.trunc(dur.quarters),
      months: dur.months - Math.trunc(dur.months),
      weeks: dur.weeks - Math.trunc(dur.weeks),
      days: dur.days - Math.trunc(dur.days),
      hours: dur.hours,
      minutes: dur.minutes,
      seconds: dur.seconds,
      milliseconds: dur.milliseconds,
    }).as("milliseconds"),
    localTS = objToLocalTS(c);

  let [ts, o] = fixOffset(localTS, oPre, inst.zone);

  if (millisToAdd !== 0) {
    ts += millisToAdd;
    // that could have changed the offset by going over a DST, but we want to keep the ts the same
    o = inst.zone.offset(ts);
  }

  return { ts, o };
}

// helper useful in turning the results of parsing into real dates
// by handling the zone options
function parseDataToDateTime(parsed, parsedZone, opts, format, text, specificOffset) {
  const { setZone, zone } = opts;
  if ((parsed && Object.keys(parsed).length !== 0) || parsedZone) {
    const interpretationZone = parsedZone || zone,
      inst = DateTime.fromObject(parsed, {
        ...opts,
        zone: interpretationZone,
        specificOffset,
      });
    return setZone ? inst : inst.setZone(zone);
  } else {
    return DateTime.invalid(
      new Invalid("unparsable", `the input "${text}" can't be parsed as ${format}`)
    );
  }
}

// if you want to output a technical format (e.g. RFC 2822), this helper
// helps handle the details
function toTechFormat(dt, format, allowZ = true) {
  return dt.isValid
    ? Formatter.create(Locale.create("en-US"), {
        allowZ,
        forceSimple: true,
      }).formatDateTimeFromString(dt, format)
    : null;
}

function toISODate(o, extended) {
  const longFormat = o.c.year > 9999 || o.c.year < 0;
  let c = "";
  if (longFormat && o.c.year >= 0) c += "+";
  c += padStart(o.c.year, longFormat ? 6 : 4);

  if (extended) {
    c += "-";
    c += padStart(o.c.month);
    c += "-";
    c += padStart(o.c.day);
  } else {
    c += padStart(o.c.month);
    c += padStart(o.c.day);
  }
  return c;
}

function toISOTime(
  o,
  extended,
  suppressSeconds,
  suppressMilliseconds,
  includeOffset,
  extendedZone
) {
  let c = padStart(o.c.hour);
  if (extended) {
    c += ":";
    c += padStart(o.c.minute);
    if (o.c.millisecond !== 0 || o.c.second !== 0 || !suppressSeconds) {
      c += ":";
    }
  } else {
    c += padStart(o.c.minute);
  }

  if (o.c.millisecond !== 0 || o.c.second !== 0 || !suppressSeconds) {
    c += padStart(o.c.second);

    if (o.c.millisecond !== 0 || !suppressMilliseconds) {
      c += ".";
      c += padStart(o.c.millisecond, 3);
    }
  }

  if (includeOffset) {
    if (o.isOffsetFixed && o.offset === 0 && !extendedZone) {
      c += "Z";
    } else if (o.o < 0) {
      c += "-";
      c += padStart(Math.trunc(-o.o / 60));
      c += ":";
      c += padStart(Math.trunc(-o.o % 60));
    } else {
      c += "+";
      c += padStart(Math.trunc(o.o / 60));
      c += ":";
      c += padStart(Math.trunc(o.o % 60));
    }
  }

  if (extendedZone) {
    c += "[" + o.zone.ianaName + "]";
  }
  return c;
}

// defaults for unspecified units in the supported calendars
const defaultUnitValues = {
    month: 1,
    day: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0,
  },
  defaultWeekUnitValues = {
    weekNumber: 1,
    weekday: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0,
  },
  defaultOrdinalUnitValues = {
    ordinal: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0,
  };

// Units in the supported calendars, sorted by bigness
const datetime_orderedUnits = ["year", "month", "day", "hour", "minute", "second", "millisecond"],
  orderedWeekUnits = [
    "weekYear",
    "weekNumber",
    "weekday",
    "hour",
    "minute",
    "second",
    "millisecond",
  ],
  orderedOrdinalUnits = ["year", "ordinal", "hour", "minute", "second", "millisecond"];

// standardize case and plurality in units
function normalizeUnit(unit) {
  const normalized = {
    year: "year",
    years: "year",
    month: "month",
    months: "month",
    day: "day",
    days: "day",
    hour: "hour",
    hours: "hour",
    minute: "minute",
    minutes: "minute",
    quarter: "quarter",
    quarters: "quarter",
    second: "second",
    seconds: "second",
    millisecond: "millisecond",
    milliseconds: "millisecond",
    weekday: "weekday",
    weekdays: "weekday",
    weeknumber: "weekNumber",
    weeksnumber: "weekNumber",
    weeknumbers: "weekNumber",
    weekyear: "weekYear",
    weekyears: "weekYear",
    ordinal: "ordinal",
  }[unit.toLowerCase()];

  if (!normalized) throw new InvalidUnitError(unit);

  return normalized;
}

function normalizeUnitWithLocalWeeks(unit) {
  switch (unit.toLowerCase()) {
    case "localweekday":
    case "localweekdays":
      return "localWeekday";
    case "localweeknumber":
    case "localweeknumbers":
      return "localWeekNumber";
    case "localweekyear":
    case "localweekyears":
      return "localWeekYear";
    default:
      return normalizeUnit(unit);
  }
}

// cache offsets for zones based on the current timestamp when this function is
// first called. When we are handling a datetime from components like (year,
// month, day, hour) in a time zone, we need a guess about what the timezone
// offset is so that we can convert into a UTC timestamp. One way is to find the
// offset of now in the zone. The actual date may have a different offset (for
// example, if we handle a date in June while we're in December in a zone that
// observes DST), but we can check and adjust that.
//
// When handling many dates, calculating the offset for now every time is
// expensive. It's just a guess, so we can cache the offset to use even if we
// are right on a time change boundary (we'll just correct in the other
// direction). Using a timestamp from first read is a slight optimization for
// handling dates close to the current date, since those dates will usually be
// in the same offset (we could set the timestamp statically, instead). We use a
// single timestamp for all zones to make things a bit more predictable.
//
// This is safe for quickDT (used by local() and utc()) because we don't fill in
// higher-order units from tsNow (as we do in fromObject, this requires that
// offset is calculated from tsNow).
function guessOffsetForZone(zone) {
  if (!zoneOffsetGuessCache[zone]) {
    if (zoneOffsetTs === undefined) {
      zoneOffsetTs = Settings.now();
    }

    zoneOffsetGuessCache[zone] = zone.offset(zoneOffsetTs);
  }
  return zoneOffsetGuessCache[zone];
}

// this is a dumbed down version of fromObject() that runs about 60% faster
// but doesn't do any validation, makes a bunch of assumptions about what units
// are present, and so on.
function quickDT(obj, opts) {
  const zone = normalizeZone(opts.zone, Settings.defaultZone);
  if (!zone.isValid) {
    return DateTime.invalid(unsupportedZone(zone));
  }

  const loc = Locale.fromObject(opts);

  let ts, o;

  // assume we have the higher-order units
  if (!isUndefined(obj.year)) {
    for (const u of datetime_orderedUnits) {
      if (isUndefined(obj[u])) {
        obj[u] = defaultUnitValues[u];
      }
    }

    const invalid = hasInvalidGregorianData(obj) || hasInvalidTimeData(obj);
    if (invalid) {
      return DateTime.invalid(invalid);
    }

    const offsetProvis = guessOffsetForZone(zone);
    [ts, o] = objToTS(obj, offsetProvis, zone);
  } else {
    ts = Settings.now();
  }

  return new DateTime({ ts, zone, loc, o });
}

function diffRelative(start, end, opts) {
  const round = isUndefined(opts.round) ? true : opts.round,
    format = (c, unit) => {
      c = roundTo(c, round || opts.calendary ? 0 : 2, true);
      const formatter = end.loc.clone(opts).relFormatter(opts);
      return formatter.format(c, unit);
    },
    differ = (unit) => {
      if (opts.calendary) {
        if (!end.hasSame(start, unit)) {
          return end.startOf(unit).diff(start.startOf(unit), unit).get(unit);
        } else return 0;
      } else {
        return end.diff(start, unit).get(unit);
      }
    };

  if (opts.unit) {
    return format(differ(opts.unit), opts.unit);
  }

  for (const unit of opts.units) {
    const count = differ(unit);
    if (Math.abs(count) >= 1) {
      return format(count, unit);
    }
  }
  return format(start > end ? -0 : 0, opts.units[opts.units.length - 1]);
}

function lastOpts(argList) {
  let opts = {},
    args;
  if (argList.length > 0 && typeof argList[argList.length - 1] === "object") {
    opts = argList[argList.length - 1];
    args = Array.from(argList).slice(0, argList.length - 1);
  } else {
    args = Array.from(argList);
  }
  return [opts, args];
}

/**
 * Timestamp to use for cached zone offset guesses (exposed for test)
 */
let zoneOffsetTs;
/**
 * Cache for zone offset guesses (exposed for test).
 *
 * This optimizes quickDT via guessOffsetForZone to avoid repeated calls of
 * zone.offset().
 */
let zoneOffsetGuessCache = {};

/**
 * A DateTime is an immutable data structure representing a specific date and time and accompanying methods. It contains class and instance methods for creating, parsing, interrogating, transforming, and formatting them.
 *
 * A DateTime comprises of:
 * * A timestamp. Each DateTime instance refers to a specific millisecond of the Unix epoch.
 * * A time zone. Each instance is considered in the context of a specific zone (by default the local system's zone).
 * * Configuration properties that effect how output strings are formatted, such as `locale`, `numberingSystem`, and `outputCalendar`.
 *
 * Here is a brief overview of the most commonly used functionality it provides:
 *
 * * **Creation**: To create a DateTime from its components, use one of its factory class methods: {@link DateTime.local}, {@link DateTime.utc}, and (most flexibly) {@link DateTime.fromObject}. To create one from a standard string format, use {@link DateTime.fromISO}, {@link DateTime.fromHTTP}, and {@link DateTime.fromRFC2822}. To create one from a custom string format, use {@link DateTime.fromFormat}. To create one from a native JS date, use {@link DateTime.fromJSDate}.
 * * **Gregorian calendar and time**: To examine the Gregorian properties of a DateTime individually (i.e as opposed to collectively through {@link DateTime#toObject}), use the {@link DateTime#year}, {@link DateTime#month},
 * {@link DateTime#day}, {@link DateTime#hour}, {@link DateTime#minute}, {@link DateTime#second}, {@link DateTime#millisecond} accessors.
 * * **Week calendar**: For ISO week calendar attributes, see the {@link DateTime#weekYear}, {@link DateTime#weekNumber}, and {@link DateTime#weekday} accessors.
 * * **Configuration** See the {@link DateTime#locale} and {@link DateTime#numberingSystem} accessors.
 * * **Transformation**: To transform the DateTime into other DateTimes, use {@link DateTime#set}, {@link DateTime#reconfigure}, {@link DateTime#setZone}, {@link DateTime#setLocale}, {@link DateTime.plus}, {@link DateTime#minus}, {@link DateTime#endOf}, {@link DateTime#startOf}, {@link DateTime#toUTC}, and {@link DateTime#toLocal}.
 * * **Output**: To convert the DateTime to other representations, use the {@link DateTime#toRelative}, {@link DateTime#toRelativeCalendar}, {@link DateTime#toJSON}, {@link DateTime#toISO}, {@link DateTime#toHTTP}, {@link DateTime#toObject}, {@link DateTime#toRFC2822}, {@link DateTime#toString}, {@link DateTime#toLocaleString}, {@link DateTime#toFormat}, {@link DateTime#toMillis} and {@link DateTime#toJSDate}.
 *
 * There's plenty others documented below. In addition, for more information on subtler topics like internationalization, time zones, alternative calendars, validity, and so on, see the external documentation.
 */
class DateTime {
  /**
   * @access private
   */
  constructor(config) {
    const zone = config.zone || Settings.defaultZone;

    let invalid =
      config.invalid ||
      (Number.isNaN(config.ts) ? new Invalid("invalid input") : null) ||
      (!zone.isValid ? unsupportedZone(zone) : null);
    /**
     * @access private
     */
    this.ts = isUndefined(config.ts) ? Settings.now() : config.ts;

    let c = null,
      o = null;
    if (!invalid) {
      const unchanged = config.old && config.old.ts === this.ts && config.old.zone.equals(zone);

      if (unchanged) {
        [c, o] = [config.old.c, config.old.o];
      } else {
        // If an offset has been passed and we have not been called from
        // clone(), we can trust it and avoid the offset calculation.
        const ot = isNumber(config.o) && !config.old ? config.o : zone.offset(this.ts);
        c = tsToObj(this.ts, ot);
        invalid = Number.isNaN(c.year) ? new Invalid("invalid input") : null;
        c = invalid ? null : c;
        o = invalid ? null : ot;
      }
    }

    /**
     * @access private
     */
    this._zone = zone;
    /**
     * @access private
     */
    this.loc = config.loc || Locale.create();
    /**
     * @access private
     */
    this.invalid = invalid;
    /**
     * @access private
     */
    this.weekData = null;
    /**
     * @access private
     */
    this.localWeekData = null;
    /**
     * @access private
     */
    this.c = c;
    /**
     * @access private
     */
    this.o = o;
    /**
     * @access private
     */
    this.isLuxonDateTime = true;
  }

  // CONSTRUCT

  /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */
  static now() {
    return new DateTime({});
  }

  /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                                  //~> now
   * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
   * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
   * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
   * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */
  static local() {
    const [opts, args] = lastOpts(arguments),
      [year, month, day, hour, minute, second, millisecond] = args;
    return quickDT({ year, month, day, hour, minute, second, millisecond }, opts);
  }

  /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @param {Object} options - configuration options for the DateTime
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [options.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.utc()                                              //~> now
   * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
   * @return {DateTime}
   */
  static utc() {
    const [opts, args] = lastOpts(arguments),
      [year, month, day, hour, minute, second, millisecond] = args;

    opts.zone = FixedOffsetZone.utcInstance;
    return quickDT({ year, month, day, hour, minute, second, millisecond }, opts);
  }

  /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */
  static fromJSDate(date, options = {}) {
    const ts = isDate(date) ? date.valueOf() : NaN;
    if (Number.isNaN(ts)) {
      return DateTime.invalid("invalid input");
    }

    const zoneToUse = normalizeZone(options.zone, Settings.defaultZone);
    if (!zoneToUse.isValid) {
      return DateTime.invalid(unsupportedZone(zoneToUse));
    }

    return new DateTime({
      ts: ts,
      zone: zoneToUse,
      loc: Locale.fromObject(options),
    });
  }

  /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromMillis(milliseconds, options = {}) {
    if (!isNumber(milliseconds)) {
      throw new InvalidArgumentError(
        `fromMillis requires a numerical input, but received a ${typeof milliseconds} with value ${milliseconds}`
      );
    } else if (milliseconds < -MAX_DATE || milliseconds > MAX_DATE) {
      // this isn't perfect because we can still end up out of range because of additional shifting, but it's a start
      return DateTime.invalid("Timestamp out of range");
    } else {
      return new DateTime({
        ts: milliseconds,
        zone: normalizeZone(options.zone, Settings.defaultZone),
        loc: Locale.fromObject(options),
      });
    }
  }

  /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromSeconds(seconds, options = {}) {
    if (!isNumber(seconds)) {
      throw new InvalidArgumentError("fromSeconds requires a numerical input");
    } else {
      return new DateTime({
        ts: seconds * 1000,
        zone: normalizeZone(options.zone, Settings.defaultZone),
        loc: Locale.fromObject(options),
      });
    }
  }

  /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.localWeekYear - a week year, according to the locale
   * @param {number} obj.localWeekNumber - a week number, between 1 and 52 or 53, depending on the year, according to the locale
   * @param {number} obj.localWeekday - a weekday, 1-7, where 1 is the first and 7 is the last day of the week, according to the locale
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {Object} opts - options for creating this DateTime
   * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [opts.locale='system\'s locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @example DateTime.fromObject({ localWeekYear: 2022, localWeekNumber: 1, localWeekday: 1 }, { locale: "en-US" }).toISODate() //=> '2021-12-26'
   * @return {DateTime}
   */
  static fromObject(obj, opts = {}) {
    obj = obj || {};
    const zoneToUse = normalizeZone(opts.zone, Settings.defaultZone);
    if (!zoneToUse.isValid) {
      return DateTime.invalid(unsupportedZone(zoneToUse));
    }

    const loc = Locale.fromObject(opts);
    const normalized = normalizeObject(obj, normalizeUnitWithLocalWeeks);
    const { minDaysInFirstWeek, startOfWeek } = usesLocalWeekValues(normalized, loc);

    const tsNow = Settings.now(),
      offsetProvis = !isUndefined(opts.specificOffset)
        ? opts.specificOffset
        : zoneToUse.offset(tsNow),
      containsOrdinal = !isUndefined(normalized.ordinal),
      containsGregorYear = !isUndefined(normalized.year),
      containsGregorMD = !isUndefined(normalized.month) || !isUndefined(normalized.day),
      containsGregor = containsGregorYear || containsGregorMD,
      definiteWeekDef = normalized.weekYear || normalized.weekNumber;

    // cases:
    // just a weekday -> this week's instance of that weekday, no worries
    // (gregorian data or ordinal) + (weekYear or weekNumber) -> error
    // (gregorian month or day) + ordinal -> error
    // otherwise just use weeks or ordinals or gregorian, depending on what's specified

    if ((containsGregor || containsOrdinal) && definiteWeekDef) {
      throw new ConflictingSpecificationError(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    }

    if (containsGregorMD && containsOrdinal) {
      throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
    }

    const useWeekData = definiteWeekDef || (normalized.weekday && !containsGregor);

    // configure ourselves to deal with gregorian dates or week stuff
    let units,
      defaultValues,
      objNow = tsToObj(tsNow, offsetProvis);
    if (useWeekData) {
      units = orderedWeekUnits;
      defaultValues = defaultWeekUnitValues;
      objNow = gregorianToWeek(objNow, minDaysInFirstWeek, startOfWeek);
    } else if (containsOrdinal) {
      units = orderedOrdinalUnits;
      defaultValues = defaultOrdinalUnitValues;
      objNow = gregorianToOrdinal(objNow);
    } else {
      units = datetime_orderedUnits;
      defaultValues = defaultUnitValues;
    }

    // set default values for missing stuff
    let foundFirst = false;
    for (const u of units) {
      const v = normalized[u];
      if (!isUndefined(v)) {
        foundFirst = true;
      } else if (foundFirst) {
        normalized[u] = defaultValues[u];
      } else {
        normalized[u] = objNow[u];
      }
    }

    // make sure the values we have are in range
    const higherOrderInvalid = useWeekData
        ? hasInvalidWeekData(normalized, minDaysInFirstWeek, startOfWeek)
        : containsOrdinal
        ? hasInvalidOrdinalData(normalized)
        : hasInvalidGregorianData(normalized),
      invalid = higherOrderInvalid || hasInvalidTimeData(normalized);

    if (invalid) {
      return DateTime.invalid(invalid);
    }

    // compute the actual time
    const gregorian = useWeekData
        ? weekToGregorian(normalized, minDaysInFirstWeek, startOfWeek)
        : containsOrdinal
        ? ordinalToGregorian(normalized)
        : normalized,
      [tsFinal, offsetFinal] = objToTS(gregorian, offsetProvis, zoneToUse),
      inst = new DateTime({
        ts: tsFinal,
        zone: zoneToUse,
        o: offsetFinal,
        loc,
      });

    // gregorian data + weekday serves only to validate
    if (normalized.weekday && containsGregor && obj.weekday !== inst.weekday) {
      return DateTime.invalid(
        "mismatched weekday",
        `you can't specify both a weekday of ${normalized.weekday} and a date of ${inst.toISO()}`
      );
    }

    if (!inst.isValid) {
      return DateTime.invalid(inst.invalid);
    }

    return inst;
  }

  /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [opts.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */
  static fromISO(text, opts = {}) {
    const [vals, parsedZone] = parseISODate(text);
    return parseDataToDateTime(vals, parsedZone, opts, "ISO 8601", text);
  }

  /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */
  static fromRFC2822(text, opts = {}) {
    const [vals, parsedZone] = parseRFC2822Date(text);
    return parseDataToDateTime(vals, parsedZone, opts, "RFC 2822", text);
  }

  /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */
  static fromHTTP(text, opts = {}) {
    const [vals, parsedZone] = parseHTTPDate(text);
    return parseDataToDateTime(vals, parsedZone, opts, "HTTP", opts);
  }

  /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromFormat(text, fmt, opts = {}) {
    if (isUndefined(text) || isUndefined(fmt)) {
      throw new InvalidArgumentError("fromFormat requires an input string and a format");
    }

    const { locale = null, numberingSystem = null } = opts,
      localeToUse = Locale.fromOpts({
        locale,
        numberingSystem,
        defaultToEN: true,
      }),
      [vals, parsedZone, specificOffset, invalid] = parseFromTokens(localeToUse, text, fmt);
    if (invalid) {
      return DateTime.invalid(invalid);
    } else {
      return parseDataToDateTime(vals, parsedZone, opts, `format ${fmt}`, text, specificOffset);
    }
  }

  /**
   * @deprecated use fromFormat instead
   */
  static fromString(text, fmt, opts = {}) {
    return DateTime.fromFormat(text, fmt, opts);
  }

  /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */
  static fromSQL(text, opts = {}) {
    const [vals, parsedZone] = parseSQL(text);
    return parseDataToDateTime(vals, parsedZone, opts, "SQL", text);
  }

  /**
   * Create an invalid DateTime.
   * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent.
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */
  static invalid(reason, explanation = null) {
    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the DateTime is invalid");
    }

    const invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);

    if (Settings.throwOnInvalid) {
      throw new InvalidDateTimeError(invalid);
    } else {
      return new DateTime({ invalid });
    }
  }

  /**
   * Check if an object is an instance of DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDateTime(o) {
    return (o && o.isLuxonDateTime) || false;
  }

  /**
   * Produce the format string for a set of options
   * @param formatOpts
   * @param localeOpts
   * @returns {string}
   */
  static parseFormatForOpts(formatOpts, localeOpts = {}) {
    const tokenList = formatOptsToTokens(formatOpts, Locale.fromObject(localeOpts));
    return !tokenList ? null : tokenList.map((t) => (t ? t.val : null)).join("");
  }

  /**
   * Produce the the fully expanded format token for the locale
   * Does NOT quote characters, so quoted tokens will not round trip correctly
   * @param fmt
   * @param localeOpts
   * @returns {string}
   */
  static expandFormat(fmt, localeOpts = {}) {
    const expanded = expandMacroTokens(Formatter.parseFormat(fmt), Locale.fromObject(localeOpts));
    return expanded.map((t) => t.val).join("");
  }

  static resetCache() {
    zoneOffsetTs = undefined;
    zoneOffsetGuessCache = {};
  }

  // INFO

  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */
  get(unit) {
    return this[unit];
  }

  /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }

  /**
   * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }

  /**
   * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }

  /**
   * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
   *
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }

  /**
   * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }

  /**
   * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
   *
   * @type {string}
   */
  get outputCalendar() {
    return this.isValid ? this.loc.outputCalendar : null;
  }

  /**
   * Get the time zone associated with this DateTime.
   * @type {Zone}
   */
  get zone() {
    return this._zone;
  }

  /**
   * Get the name of the time zone.
   * @type {string}
   */
  get zoneName() {
    return this.isValid ? this.zone.name : null;
  }

  /**
   * Get the year
   * @example DateTime.local(2017, 5, 25).year //=> 2017
   * @type {number}
   */
  get year() {
    return this.isValid ? this.c.year : NaN;
  }

  /**
   * Get the quarter
   * @example DateTime.local(2017, 5, 25).quarter //=> 2
   * @type {number}
   */
  get quarter() {
    return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
  }

  /**
   * Get the month (1-12).
   * @example DateTime.local(2017, 5, 25).month //=> 5
   * @type {number}
   */
  get month() {
    return this.isValid ? this.c.month : NaN;
  }

  /**
   * Get the day of the month (1-30ish).
   * @example DateTime.local(2017, 5, 25).day //=> 25
   * @type {number}
   */
  get day() {
    return this.isValid ? this.c.day : NaN;
  }

  /**
   * Get the hour of the day (0-23).
   * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
   * @type {number}
   */
  get hour() {
    return this.isValid ? this.c.hour : NaN;
  }

  /**
   * Get the minute of the hour (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
   * @type {number}
   */
  get minute() {
    return this.isValid ? this.c.minute : NaN;
  }

  /**
   * Get the second of the minute (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
   * @type {number}
   */
  get second() {
    return this.isValid ? this.c.second : NaN;
  }

  /**
   * Get the millisecond of the second (0-999).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
   * @type {number}
   */
  get millisecond() {
    return this.isValid ? this.c.millisecond : NaN;
  }

  /**
   * Get the week year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 12, 31).weekYear //=> 2015
   * @type {number}
   */
  get weekYear() {
    return this.isValid ? possiblyCachedWeekData(this).weekYear : NaN;
  }

  /**
   * Get the week number of the week year (1-52ish).
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
   * @type {number}
   */
  get weekNumber() {
    return this.isValid ? possiblyCachedWeekData(this).weekNumber : NaN;
  }

  /**
   * Get the day of the week.
   * 1 is Monday and 7 is Sunday
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 11, 31).weekday //=> 4
   * @type {number}
   */
  get weekday() {
    return this.isValid ? possiblyCachedWeekData(this).weekday : NaN;
  }

  /**
   * Returns true if this date is on a weekend according to the locale, false otherwise
   * @returns {boolean}
   */
  get isWeekend() {
    return this.isValid && this.loc.getWeekendDays().includes(this.weekday);
  }

  /**
   * Get the day of the week according to the locale.
   * 1 is the first day of the week and 7 is the last day of the week.
   * If the locale assigns Sunday as the first day of the week, then a date which is a Sunday will return 1,
   * @returns {number}
   */
  get localWeekday() {
    return this.isValid ? possiblyCachedLocalWeekData(this).weekday : NaN;
  }

  /**
   * Get the week number of the week year according to the locale. Different locales assign week numbers differently,
   * because the week can start on different days of the week (see localWeekday) and because a different number of days
   * is required for a week to count as the first week of a year.
   * @returns {number}
   */
  get localWeekNumber() {
    return this.isValid ? possiblyCachedLocalWeekData(this).weekNumber : NaN;
  }

  /**
   * Get the week year according to the locale. Different locales assign week numbers (and therefor week years)
   * differently, see localWeekNumber.
   * @returns {number}
   */
  get localWeekYear() {
    return this.isValid ? possiblyCachedLocalWeekData(this).weekYear : NaN;
  }

  /**
   * Get the ordinal (meaning the day of the year)
   * @example DateTime.local(2017, 5, 25).ordinal //=> 145
   * @type {number|DateTime}
   */
  get ordinal() {
    return this.isValid ? gregorianToOrdinal(this.c).ordinal : NaN;
  }

  /**
   * Get the human readable short month name, such as 'Oct'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
   * @type {string}
   */
  get monthShort() {
    return this.isValid ? Info.months("short", { locObj: this.loc })[this.month - 1] : null;
  }

  /**
   * Get the human readable long month name, such as 'October'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthLong //=> October
   * @type {string}
   */
  get monthLong() {
    return this.isValid ? Info.months("long", { locObj: this.loc })[this.month - 1] : null;
  }

  /**
   * Get the human readable short weekday, such as 'Mon'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
   * @type {string}
   */
  get weekdayShort() {
    return this.isValid ? Info.weekdays("short", { locObj: this.loc })[this.weekday - 1] : null;
  }

  /**
   * Get the human readable long weekday, such as 'Monday'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
   * @type {string}
   */
  get weekdayLong() {
    return this.isValid ? Info.weekdays("long", { locObj: this.loc })[this.weekday - 1] : null;
  }

  /**
   * Get the UTC offset of this DateTime in minutes
   * @example DateTime.now().offset //=> -240
   * @example DateTime.utc().offset //=> 0
   * @type {number}
   */
  get offset() {
    return this.isValid ? +this.o : NaN;
  }

  /**
   * Get the short human name for the zone's current offset, for example "EST" or "EDT".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameShort() {
    if (this.isValid) {
      return this.zone.offsetName(this.ts, {
        format: "short",
        locale: this.locale,
      });
    } else {
      return null;
    }
  }

  /**
   * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameLong() {
    if (this.isValid) {
      return this.zone.offsetName(this.ts, {
        format: "long",
        locale: this.locale,
      });
    } else {
      return null;
    }
  }

  /**
   * Get whether this zone's offset ever changes, as in a DST.
   * @type {boolean}
   */
  get isOffsetFixed() {
    return this.isValid ? this.zone.isUniversal : null;
  }

  /**
   * Get whether the DateTime is in a DST.
   * @type {boolean}
   */
  get isInDST() {
    if (this.isOffsetFixed) {
      return false;
    } else {
      return (
        this.offset > this.set({ month: 1, day: 1 }).offset ||
        this.offset > this.set({ month: 5 }).offset
      );
    }
  }

  /**
   * Get those DateTimes which have the same local time as this DateTime, but a different offset from UTC
   * in this DateTime's zone. During DST changes local time can be ambiguous, for example
   * `2023-10-29T02:30:00` in `Europe/Berlin` can have offset `+01:00` or `+02:00`.
   * This method will return both possible DateTimes if this DateTime's local time is ambiguous.
   * @returns {DateTime[]}
   */
  getPossibleOffsets() {
    if (!this.isValid || this.isOffsetFixed) {
      return [this];
    }
    const dayMs = 86400000;
    const minuteMs = 60000;
    const localTS = objToLocalTS(this.c);
    const oEarlier = this.zone.offset(localTS - dayMs);
    const oLater = this.zone.offset(localTS + dayMs);

    const o1 = this.zone.offset(localTS - oEarlier * minuteMs);
    const o2 = this.zone.offset(localTS - oLater * minuteMs);
    if (o1 === o2) {
      return [this];
    }
    const ts1 = localTS - o1 * minuteMs;
    const ts2 = localTS - o2 * minuteMs;
    const c1 = tsToObj(ts1, o1);
    const c2 = tsToObj(ts2, o2);
    if (
      c1.hour === c2.hour &&
      c1.minute === c2.minute &&
      c1.second === c2.second &&
      c1.millisecond === c2.millisecond
    ) {
      return [datetime_clone(this, { ts: ts1 }), datetime_clone(this, { ts: ts2 })];
    }
    return [this];
  }

  /**
   * Returns true if this DateTime is in a leap year, false otherwise
   * @example DateTime.local(2016).isInLeapYear //=> true
   * @example DateTime.local(2013).isInLeapYear //=> false
   * @type {boolean}
   */
  get isInLeapYear() {
    return isLeapYear(this.year);
  }

  /**
   * Returns the number of days in this DateTime's month
   * @example DateTime.local(2016, 2).daysInMonth //=> 29
   * @example DateTime.local(2016, 3).daysInMonth //=> 31
   * @type {number}
   */
  get daysInMonth() {
    return daysInMonth(this.year, this.month);
  }

  /**
   * Returns the number of days in this DateTime's year
   * @example DateTime.local(2016).daysInYear //=> 366
   * @example DateTime.local(2013).daysInYear //=> 365
   * @type {number}
   */
  get daysInYear() {
    return this.isValid ? daysInYear(this.year) : NaN;
  }

  /**
   * Returns the number of weeks in this DateTime's year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2004).weeksInWeekYear //=> 53
   * @example DateTime.local(2013).weeksInWeekYear //=> 52
   * @type {number}
   */
  get weeksInWeekYear() {
    return this.isValid ? weeksInWeekYear(this.weekYear) : NaN;
  }

  /**
   * Returns the number of weeks in this DateTime's local week year
   * @example DateTime.local(2020, 6, {locale: 'en-US'}).weeksInLocalWeekYear //=> 52
   * @example DateTime.local(2020, 6, {locale: 'de-DE'}).weeksInLocalWeekYear //=> 53
   * @type {number}
   */
  get weeksInLocalWeekYear() {
    return this.isValid
      ? weeksInWeekYear(
          this.localWeekYear,
          this.loc.getMinDaysInFirstWeek(),
          this.loc.getStartOfWeek()
        )
      : NaN;
  }

  /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */
  resolvedLocaleOptions(opts = {}) {
    const { locale, numberingSystem, calendar } = Formatter.create(
      this.loc.clone(opts),
      opts
    ).resolvedOptions(this);
    return { locale, numberingSystem, outputCalendar: calendar };
  }

  // TRANSFORM

  /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link DateTime#setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */
  toUTC(offset = 0, opts = {}) {
    return this.setZone(FixedOffsetZone.instance(offset), opts);
  }

  /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */
  toLocal() {
    return this.setZone(Settings.defaultZone);
  }

  /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */
  setZone(zone, { keepLocalTime = false, keepCalendarTime = false } = {}) {
    zone = normalizeZone(zone, Settings.defaultZone);
    if (zone.equals(this.zone)) {
      return this;
    } else if (!zone.isValid) {
      return DateTime.invalid(unsupportedZone(zone));
    } else {
      let newTS = this.ts;
      if (keepLocalTime || keepCalendarTime) {
        const offsetGuess = zone.offset(this.ts);
        const asObj = this.toObject();
        [newTS] = objToTS(asObj, offsetGuess, zone);
      }
      return datetime_clone(this, { ts: newTS, zone });
    }
  }

  /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */
  reconfigure({ locale, numberingSystem, outputCalendar } = {}) {
    const loc = this.loc.clone({ locale, numberingSystem, outputCalendar });
    return datetime_clone(this, { loc });
  }

  /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */
  setLocale(locale) {
    return this.reconfigure({ locale });
  }

  /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
   *
   * This method also supports setting locale-based week units, i.e. `localWeekday`, `localWeekNumber` and `localWeekYear`.
   * They cannot be mixed with ISO-week units like `weekday`.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */
  set(values) {
    if (!this.isValid) return this;

    const normalized = normalizeObject(values, normalizeUnitWithLocalWeeks);
    const { minDaysInFirstWeek, startOfWeek } = usesLocalWeekValues(normalized, this.loc);

    const settingWeekStuff =
        !isUndefined(normalized.weekYear) ||
        !isUndefined(normalized.weekNumber) ||
        !isUndefined(normalized.weekday),
      containsOrdinal = !isUndefined(normalized.ordinal),
      containsGregorYear = !isUndefined(normalized.year),
      containsGregorMD = !isUndefined(normalized.month) || !isUndefined(normalized.day),
      containsGregor = containsGregorYear || containsGregorMD,
      definiteWeekDef = normalized.weekYear || normalized.weekNumber;

    if ((containsGregor || containsOrdinal) && definiteWeekDef) {
      throw new ConflictingSpecificationError(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    }

    if (containsGregorMD && containsOrdinal) {
      throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
    }

    let mixed;
    if (settingWeekStuff) {
      mixed = weekToGregorian(
        { ...gregorianToWeek(this.c, minDaysInFirstWeek, startOfWeek), ...normalized },
        minDaysInFirstWeek,
        startOfWeek
      );
    } else if (!isUndefined(normalized.ordinal)) {
      mixed = ordinalToGregorian({ ...gregorianToOrdinal(this.c), ...normalized });
    } else {
      mixed = { ...this.toObject(), ...normalized };

      // if we didn't set the day but we ended up on an overflow date,
      // use the last day of the right month
      if (isUndefined(normalized.day)) {
        mixed.day = Math.min(daysInMonth(mixed.year, mixed.month), mixed.day);
      }
    }

    const [ts, o] = objToTS(mixed, this.o, this.zone);
    return datetime_clone(this, { ts, o });
  }

  /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */
  plus(duration) {
    if (!this.isValid) return this;
    const dur = Duration.fromDurationLike(duration);
    return datetime_clone(this, adjustTime(this, dur));
  }

  /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link DateTime#plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
   */
  minus(duration) {
    if (!this.isValid) return this;
    const dur = Duration.fromDurationLike(duration).negate();
    return datetime_clone(this, adjustTime(this, dur));
  }

  /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */
  startOf(unit, { useLocaleWeeks = false } = {}) {
    if (!this.isValid) return this;

    const o = {},
      normalizedUnit = Duration.normalizeUnit(unit);
    switch (normalizedUnit) {
      case "years":
        o.month = 1;
      // falls through
      case "quarters":
      case "months":
        o.day = 1;
      // falls through
      case "weeks":
      case "days":
        o.hour = 0;
      // falls through
      case "hours":
        o.minute = 0;
      // falls through
      case "minutes":
        o.second = 0;
      // falls through
      case "seconds":
        o.millisecond = 0;
        break;
      case "milliseconds":
        break;
      // no default, invalid units throw in normalizeUnit()
    }

    if (normalizedUnit === "weeks") {
      if (useLocaleWeeks) {
        const startOfWeek = this.loc.getStartOfWeek();
        const { weekday } = this;
        if (weekday < startOfWeek) {
          o.weekNumber = this.weekNumber - 1;
        }
        o.weekday = startOfWeek;
      } else {
        o.weekday = 1;
      }
    }

    if (normalizedUnit === "quarters") {
      const q = Math.ceil(this.month / 3);
      o.month = (q - 1) * 3 + 1;
    }

    return this.set(o);
  }

  /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */
  endOf(unit, opts) {
    return this.isValid
      ? this.plus({ [unit]: 1 })
          .startOf(unit, opts)
          .minus(1)
      : this;
  }

  // OUTPUT

  /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */
  toFormat(fmt, opts = {}) {
    return this.isValid
      ? Formatter.create(this.loc.redefaultToEN(opts)).formatDateTimeFromString(this, fmt)
      : datetime_INVALID;
  }

  /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL, { locale: 'fr' }); //=> '28 août 2022'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
   * @return {string}
   */
  toLocaleString(formatOpts = DATE_SHORT, opts = {}) {
    return this.isValid
      ? Formatter.create(this.loc.clone(opts), formatOpts).formatDateTime(this)
      : datetime_INVALID;
  }

  /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */
  toLocaleParts(opts = {}) {
    return this.isValid
      ? Formatter.create(this.loc.clone(opts), opts).formatDateTimeParts(this)
      : [];
  }

  /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=false] - add the time zone format extension
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @return {string}
   */
  toISO({
    format = "extended",
    suppressSeconds = false,
    suppressMilliseconds = false,
    includeOffset = true,
    extendedZone = false,
  } = {}) {
    if (!this.isValid) {
      return null;
    }

    const ext = format === "extended";

    let c = toISODate(this, ext);
    c += "T";
    c += toISOTime(this, ext, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone);
    return c;
  }

  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @return {string}
   */
  toISODate({ format = "extended" } = {}) {
    if (!this.isValid) {
      return null;
    }

    return toISODate(this, format === "extended");
  }

  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */
  toISOWeekDate() {
    return toTechFormat(this, "kkkk-'W'WW-c");
  }

  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @return {string}
   */
  toISOTime({
    suppressMilliseconds = false,
    suppressSeconds = false,
    includeOffset = true,
    includePrefix = false,
    extendedZone = false,
    format = "extended",
  } = {}) {
    if (!this.isValid) {
      return null;
    }

    let c = includePrefix ? "T" : "";
    return (
      c +
      toISOTime(
        this,
        format === "extended",
        suppressSeconds,
        suppressMilliseconds,
        includeOffset,
        extendedZone
      )
    );
  }

  /**
   * Returns an RFC 2822-compatible string representation of this DateTime
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */
  toRFC2822() {
    return toTechFormat(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", false);
  }

  /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */
  toHTTP() {
    return toTechFormat(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
  }

  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string}
   */
  toSQLDate() {
    if (!this.isValid) {
      return null;
    }
    return toISODate(this, true);
  }

  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */
  toSQLTime({ includeOffset = true, includeZone = false, includeOffsetSpace = true } = {}) {
    let fmt = "HH:mm:ss.SSS";

    if (includeZone || includeOffset) {
      if (includeOffsetSpace) {
        fmt += " ";
      }
      if (includeZone) {
        fmt += "z";
      } else if (includeOffset) {
        fmt += "ZZ";
      }
    }

    return toTechFormat(this, fmt, true);
  }

  /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */
  toSQL(opts = {}) {
    if (!this.isValid) {
      return null;
    }

    return `${this.toSQLDate()} ${this.toSQLTime(opts)}`;
  }

  /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */
  toString() {
    return this.isValid ? this.toISO() : datetime_INVALID;
  }

  /**
   * Returns a string representation of this DateTime appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    if (this.isValid) {
      return `DateTime { ts: ${this.toISO()}, zone: ${this.zone.name}, locale: ${this.locale} }`;
    } else {
      return `DateTime { Invalid, reason: ${this.invalidReason} }`;
    }
  }

  /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }

  /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */
  toMillis() {
    return this.isValid ? this.ts : NaN;
  }

  /**
   * Returns the epoch seconds of this DateTime.
   * @return {number}
   */
  toSeconds() {
    return this.isValid ? this.ts / 1000 : NaN;
  }

  /**
   * Returns the epoch seconds (as a whole number) of this DateTime.
   * @return {number}
   */
  toUnixInteger() {
    return this.isValid ? Math.floor(this.ts / 1000) : NaN;
  }

  /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }

  /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */
  toBSON() {
    return this.toJSDate();
  }

  /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */
  toObject(opts = {}) {
    if (!this.isValid) return {};

    const base = { ...this.c };

    if (opts.includeConfig) {
      base.outputCalendar = this.outputCalendar;
      base.numberingSystem = this.loc.numberingSystem;
      base.locale = this.loc.locale;
    }
    return base;
  }

  /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */
  toJSDate() {
    return new Date(this.isValid ? this.ts : NaN);
  }

  // COMPARE

  /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */
  diff(otherDateTime, unit = "milliseconds", opts = {}) {
    if (!this.isValid || !otherDateTime.isValid) {
      return Duration.invalid("created by diffing an invalid DateTime");
    }

    const durOpts = { locale: this.locale, numberingSystem: this.numberingSystem, ...opts };

    const units = maybeArray(unit).map(Duration.normalizeUnit),
      otherIsLater = otherDateTime.valueOf() > this.valueOf(),
      earlier = otherIsLater ? this : otherDateTime,
      later = otherIsLater ? otherDateTime : this,
      diffed = diff(earlier, later, units, durOpts);

    return otherIsLater ? diffed.negate() : diffed;
  }

  /**
   * Return the difference between this DateTime and right now.
   * See {@link DateTime#diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  diffNow(unit = "milliseconds", opts = {}) {
    return this.diff(DateTime.now(), unit, opts);
  }

  /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval}
   */
  until(otherDateTime) {
    return this.isValid ? Interval.fromDateTimes(this, otherDateTime) : this;
  }

  /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; only the locale of this DateTime is used
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */
  hasSame(otherDateTime, unit, opts) {
    if (!this.isValid) return false;

    const inputMs = otherDateTime.valueOf();
    const adjustedToZone = this.setZone(otherDateTime.zone, { keepLocalTime: true });
    return (
      adjustedToZone.startOf(unit, opts) <= inputMs && inputMs <= adjustedToZone.endOf(unit, opts)
    );
  }

  /**
   * Equality check
   * Two DateTimes are equal if and only if they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */
  equals(other) {
    return (
      this.isValid &&
      other.isValid &&
      this.valueOf() === other.valueOf() &&
      this.zone.equals(other.zone) &&
      this.loc.equals(other.loc)
    );
  }

  /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds down by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */
  toRelative(options = {}) {
    if (!this.isValid) return null;
    const base = options.base || DateTime.fromObject({}, { zone: this.zone }),
      padding = options.padding ? (this < base ? -options.padding : options.padding) : 0;
    let units = ["years", "months", "days", "hours", "minutes", "seconds"];
    let unit = options.unit;
    if (Array.isArray(options.unit)) {
      units = options.unit;
      unit = undefined;
    }
    return diffRelative(base, this.plus(padding), {
      ...options,
      numeric: "always",
      units,
      unit,
    });
  }

  /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */
  toRelativeCalendar(options = {}) {
    if (!this.isValid) return null;

    return diffRelative(options.base || DateTime.fromObject({}, { zone: this.zone }), this, {
      ...options,
      numeric: "auto",
      units: ["years", "months", "days"],
      calendary: true,
    });
  }

  /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */
  static min(...dateTimes) {
    if (!dateTimes.every(DateTime.isDateTime)) {
      throw new InvalidArgumentError("min requires all arguments be DateTimes");
    }
    return bestBy(dateTimes, (i) => i.valueOf(), Math.min);
  }

  /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */
  static max(...dateTimes) {
    if (!dateTimes.every(DateTime.isDateTime)) {
      throw new InvalidArgumentError("max requires all arguments be DateTimes");
    }
    return bestBy(dateTimes, (i) => i.valueOf(), Math.max);
  }

  // MISC

  /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */
  static fromFormatExplain(text, fmt, options = {}) {
    const { locale = null, numberingSystem = null } = options,
      localeToUse = Locale.fromOpts({
        locale,
        numberingSystem,
        defaultToEN: true,
      });
    return explainFromTokens(localeToUse, text, fmt);
  }

  /**
   * @deprecated use fromFormatExplain instead
   */
  static fromStringExplain(text, fmt, options = {}) {
    return DateTime.fromFormatExplain(text, fmt, options);
  }

  /**
   * Build a parser for `fmt` using the given locale. This parser can be passed
   * to {@link DateTime.fromFormatParser} to a parse a date in this format. This
   * can be used to optimize cases where many dates need to be parsed in a
   * specific format.
   *
   * @param {String} fmt - the format the string is expected to be in (see
   * description)
   * @param {Object} options - options used to set locale and numberingSystem
   * for parser
   * @returns {TokenParser} - opaque object to be used
   */
  static buildFormatParser(fmt, options = {}) {
    const { locale = null, numberingSystem = null } = options,
      localeToUse = Locale.fromOpts({
        locale,
        numberingSystem,
        defaultToEN: true,
      });
    return new TokenParser(localeToUse, fmt);
  }

  /**
   * Create a DateTime from an input string and format parser.
   *
   * The format parser must have been created with the same locale as this call.
   *
   * @param {String} text - the string to parse
   * @param {TokenParser} formatParser - parser from {@link DateTime.buildFormatParser}
   * @param {Object} opts - options taken by fromFormat()
   * @returns {DateTime}
   */
  static fromFormatParser(text, formatParser, opts = {}) {
    if (isUndefined(text) || isUndefined(formatParser)) {
      throw new InvalidArgumentError(
        "fromFormatParser requires an input string and a format parser"
      );
    }
    const { locale = null, numberingSystem = null } = opts,
      localeToUse = Locale.fromOpts({
        locale,
        numberingSystem,
        defaultToEN: true,
      });

    if (!localeToUse.equals(formatParser.locale)) {
      throw new InvalidArgumentError(
        `fromFormatParser called with a locale of ${localeToUse}, ` +
          `but the format parser was created for ${formatParser.locale}`
      );
    }

    const { result, zone, specificOffset, invalidReason } = formatParser.explainFromTokens(text);

    if (invalidReason) {
      return DateTime.invalid(invalidReason);
    } else {
      return parseDataToDateTime(
        result,
        zone,
        opts,
        `format ${formatParser.format}`,
        text,
        specificOffset
      );
    }
  }

  // FORMAT PRESETS

  /**
   * {@link DateTime#toLocaleString} format like 10/14/1983
   * @type {Object}
   */
  static get DATE_SHORT() {
    return DATE_SHORT;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED() {
    return DATE_MED;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'Fri, Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED_WITH_WEEKDAY() {
    return DATE_MED_WITH_WEEKDAY;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983'
   * @type {Object}
   */
  static get DATE_FULL() {
    return DATE_FULL;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'Tuesday, October 14, 1983'
   * @type {Object}
   */
  static get DATE_HUGE() {
    return DATE_HUGE;
  }

  /**
   * {@link DateTime#toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_SIMPLE() {
    return TIME_SIMPLE;
  }

  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SECONDS() {
    return TIME_WITH_SECONDS;
  }

  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SHORT_OFFSET() {
    return TIME_WITH_SHORT_OFFSET;
  }

  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_LONG_OFFSET() {
    return TIME_WITH_LONG_OFFSET;
  }

  /**
   * {@link DateTime#toLocaleString} format like '09:30', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_SIMPLE() {
    return TIME_24_SIMPLE;
  }

  /**
   * {@link DateTime#toLocaleString} format like '09:30:23', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SECONDS() {
    return TIME_24_WITH_SECONDS;
  }

  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 EDT', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SHORT_OFFSET() {
    return TIME_24_WITH_SHORT_OFFSET;
  }

  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_LONG_OFFSET() {
    return TIME_24_WITH_LONG_OFFSET;
  }

  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT() {
    return DATETIME_SHORT;
  }

  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT_WITH_SECONDS() {
    return DATETIME_SHORT_WITH_SECONDS;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED() {
    return DATETIME_MED;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_SECONDS() {
    return DATETIME_MED_WITH_SECONDS;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'Fri, 14 Oct 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_WEEKDAY() {
    return DATETIME_MED_WITH_WEEKDAY;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL() {
    return DATETIME_FULL;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL_WITH_SECONDS() {
    return DATETIME_FULL_WITH_SECONDS;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE() {
    return DATETIME_HUGE;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE_WITH_SECONDS() {
    return DATETIME_HUGE_WITH_SECONDS;
  }
}

/**
 * @private
 */
function friendlyDateTime(dateTimeish) {
  if (DateTime.isDateTime(dateTimeish)) {
    return dateTimeish;
  } else if (dateTimeish && dateTimeish.valueOf && isNumber(dateTimeish.valueOf())) {
    return DateTime.fromJSDate(dateTimeish);
  } else if (dateTimeish && typeof dateTimeish === "object") {
    return DateTime.fromObject(dateTimeish);
  } else {
    throw new InvalidArgumentError(
      `Unknown datetime argument: ${dateTimeish}, of type ${typeof dateTimeish}`
    );
  }
}

;// CONCATENATED MODULE: ../node_modules/luxon/src/luxon.js











const VERSION = "3.5.0";



;// CONCATENATED MODULE: ./src/sections/HeroSlider/HeroSlider.schema.js





var video = function() {
    return {
        label: "Video Settings",
        name: "video",
        description: "Video, controls, autoplay, loop",
        component: "group",
        fields: [
            {
                name: "srcDt",
                component: "text",
                label: "Video URL (desktop)",
                description: "File size should remain below 15MB for mobile data consideration"
            },
            {
                name: "src",
                component: "text",
                label: "Video URL (mobile)",
                description: "Direct links to Mp4/Webm videos recommended. Note: File size should remain around 15MB MAX for mobile data consideration"
            },
            {
                name: "posterDt",
                component: "image",
                label: "Poster image (Desktop)"
            },
            {
                name: "poster",
                component: "image",
                label: "Poster image (Mobile)",
                description: "Poster image for video. Usually the first frame of the video"
            },
            {
                name: "autoplay",
                label: "Autoplay",
                component: "toggle",
                description: "Autoplay video on load (Embed only). The video will be muted",
                toggleLabels: {
                    true: "On",
                    false: "Off"
                }
            },
            {
                name: "loop",
                label: "Loop video",
                component: "toggle",
                description: "Loop video when it ends (Embed only)",
                toggleLabels: {
                    true: "On",
                    false: "Off"
                }
            },
            {
                name: "controls",
                label: "Show controls",
                component: "toggle",
                description: "Show video controls (Embed only)",
                toggleLabels: {
                    true: "On",
                    false: "Off"
                }
            },
            {
                name: "muted",
                label: "Mute Video",
                component: "toggle",
                description: "Mute video on load (Embed only)",
                toggleLabels: {
                    true: "Muted",
                    false: "Unmuted"
                },
                defaultValue: true
            }, 
        ],
        defaultValue: {
            autoplay: true,
            loop: true,
            controls: false,
            muted: true
        }
    };
};
var HeroSlider_schema_image = function(param) {
    var position = param.position;
    return {
        label: "Image Settings",
        name: "image",
        description: "Image, image position",
        component: "group",
        fields: [
            {
                name: "alt",
                component: "text",
                label: "Image Alt",
                description: "Provide a brief description of the image for accessibility compliance"
            },
            {
                name: "imageDt",
                label: "Image (desktop)",
                component: "image"
            },
            {
                name: "positionDt",
                component: "select",
                label: "Image position (desktop)",
                options: position.object
            },
            {
                name: "image",
                label: "Image (mobile)",
                component: "image"
            },
            {
                name: "position",
                component: "select",
                label: "Image position (mobile)",
                options: position.object
            }, 
        ],
        defaultValue: {
            positionDt: "center center",
            position: "center center"
        }
    };
};
var HeroSlider_schema_text = function(param) {
    var color = param.color;
    return {
        label: "Text Settings",
        name: "text",
        description: "Heading, superheading, subheading, color",
        component: "group",
        fields: [
            {
                name: "heading",
                component: "markdown",
                label: "Heading",
                description: 'Ensure heading is "H1" by starting with "# " (Pound/Hash and a space preceeding your text). E.g.: "# Shop All". Text below will become large and bold to indicate "H1".'
            },
            {
                name: "headingOption",
                label: "Font Family Heading Option",
                component: "radio-group",
                direction: "horizontal",
                variant: "radio",
                options: [
                    {
                        label: "Reckless Neue",
                        value: "text.h1"
                    },
                    {
                        label: "Fellix",
                        value: "text.h1.2"
                    }, 
                ],
                defaultValue: "text.h1"
            },
            {
                name: "superheading",
                component: "text",
                label: "Superheading"
            },
            {
                name: "subheading",
                component: "markdown",
                label: "Subheading",
                description: "Tip: You can add in-line links by highlighting the section of text and clicking the link button in the menu options."
            },
            {
                label: "Hide Heading For SEO",
                description: "When hero media contains the messenging, hide the heading text for SEO",
                name: "hiddenHeadingForSeo",
                component: "toggle",
                toggleLabels: {
                    true: "On",
                    false: "Off"
                }
            },
            {
                component: "select",
                name: "colorDt",
                label: "Text color (tablet & desktop)",
                options: [
                    {
                        label: "Default",
                        value: color.text
                    }
                ].concat((0,_to_consumable_array/* default */.Z)(color.options))
            },
            {
                component: "select",
                name: "color",
                label: "Text color (mobile)",
                options: [
                    {
                        label: "Default",
                        value: color.text
                    }
                ].concat((0,_to_consumable_array/* default */.Z)(color.options))
            }, 
        ],
        defaultValue: {
            heading: "RED VELVET COLLECTION",
            subheading: "Serving up Luxe, one drink at a time.",
            hiddenHeadingForSeo: false
        }
    };
};
var HeroSlider_schema_buttons = function(param) {
    var button = param.button;
    return {
        label: "Button Settings",
        name: "button",
        description: "Buttons, clickable hero",
        component: "group",
        fields: [
            {
                label: "Clickable hero",
                description: "Allows entire hero to be clickable, using the first button link as url",
                name: "clickableHero",
                component: "toggle",
                toggleLabels: {
                    true: "On",
                    false: "Off"
                },
                defaultValue: true
            },
            {
                label: "Hide buttons",
                name: "hideButtons",
                component: "toggle",
                toggleLabels: {
                    true: "On",
                    false: "Off"
                },
                defaultValue: false
            },
            {
                name: "buttonWidth",
                label: "Button Width (mobile)",
                component: "radio-group",
                direction: "horizontal",
                variant: "radio",
                options: [
                    {
                        label: "Full Width",
                        value: "100%"
                    },
                    {
                        label: "Fit Content",
                        value: "140px"
                    }, 
                ],
                defaultValue: "140px"
            },
            {
                name: "buttons",
                label: "Buttons",
                component: "group-list",
                description: "Max of 2 buttons",
                itemProps: {
                    label: "{{item.cta.text}}"
                },
                validate: {
                    maxItems: 2
                },
                defaultItem: {
                    cta: {
                        text: "Shop Now",
                        url: "/collections/all"
                    },
                    style: "primary"
                },
                fields: [
                    {
                        name: "cta",
                        component: "link",
                        label: "Button"
                    },
                    {
                        name: "style",
                        label: "Button style",
                        component: "select",
                        options: button.options
                    }, 
                ],
                defaultValue: [
                    {
                        cta: {
                            text: "Shop Now",
                            url: "/collections/all"
                        },
                        style: "primary"
                    }, 
                ]
            }, 
        ]
    };
};
var HeroSlider_schema_content = function(param) {
    var position = param.position;
    return {
        label: "Content Settings",
        name: "content",
        description: "Content alignment, content position",
        component: "group",
        fields: [
            {
                label: "Enable Content",
                name: "enableContent",
                description: "Show Content",
                component: "toggle",
                toggleLabels: {
                    true: "On",
                    false: "Off"
                }
            },
            {
                label: "Enable Video/Image",
                name: "enableMedia",
                description: "Show Video/Image",
                component: "toggle",
                toggleLabels: {
                    true: "On",
                    false: "Off"
                }
            },
            {
                name: "alignmentDt",
                label: "Content alignment (desktop)",
                component: "radio-group",
                direction: "horizontal",
                variant: "radio",
                options: common/* align.options */.AJ.options
            },
            {
                name: "positionDt",
                component: "select",
                label: "Content position (desktop)",
                options: position.flex
            },
            {
                name: "alignment",
                label: "Content alignment (mobile)",
                component: "radio-group",
                direction: "horizontal",
                variant: "radio",
                options: common/* align.options */.AJ.options
            },
            {
                name: "position",
                component: "select",
                label: "Content position (mobile)",
                options: position.flex
            },
            {
                name: "maxWidthDt",
                component: "number",
                label: "Max content pixel width (desktop)"
            },
            {
                name: "maxWidth",
                component: "number",
                label: "Max content pixel width (mobile)"
            }, 
        ],
        defaultValue: {
            alignmentDt: "left",
            positionDt: "left center",
            alignment: "left",
            position: "left center",
            maxWidthDt: 600,
            maxWidth: 343
        }
    };
};
var slider = function(param) {
    var color = param.color;
    return {
        label: "Slider Settings",
        name: "slider",
        description: "Autoplay, delay, transition effect, bullet color, content position",
        component: "group",
        fields: [
            {
                label: "Enable autoplay",
                name: "autoplay",
                description: "Refresh page to observe change",
                component: "toggle",
                toggleLabels: {
                    true: "On",
                    false: "Off"
                }
            },
            {
                label: "Enable pagination",
                name: "pagination",
                description: "Show navigation controls",
                component: "toggle",
                toggleLabels: {
                    true: "On",
                    false: "Off"
                }
            },
            {
                name: "delay",
                component: "number",
                description: "Refresh page to observe change",
                label: "Delay between transitions (ms)"
            },
            {
                component: "radio-group",
                direction: "horizontal",
                variant: "radio",
                name: "effect",
                label: "Effect between transitions",
                description: "Refresh page to observe change",
                options: [
                    {
                        label: "Slide",
                        value: "slide"
                    },
                    {
                        label: "Fade",
                        value: "fade"
                    }, 
                ]
            },
            {
                component: "select",
                name: "activeBulletColor",
                label: "Active bullet color",
                options: color.options
            },
            {
                component: "radio-group",
                direction: "horizontal",
                variant: "radio",
                name: "contentPosition",
                label: "Content position (mobile)",
                options: [
                    {
                        label: "Contained",
                        value: "absolute"
                    },
                    {
                        label: "Below",
                        value: "relative"
                    }, 
                ]
            },
            {
                component: "radio-group",
                direction: "horizontal",
                variant: "radio",
                name: "contentPositionDt",
                label: "Content position (desktop)",
                options: [
                    {
                        label: "Contained",
                        value: "absolute"
                    },
                    {
                        label: "Below",
                        value: "relative"
                    }, 
                ]
            }, 
        ],
        defaultValue: {
            autoplay: true,
            pagination: true,
            delay: 8000,
            effect: "fade",
            activeBulletColor: color.value.text,
            contentPosition: "relative",
            contentPositionDt: "relative"
        }
    };
};
var defaultSlide1 = function() {
    return {
        image: {
            alt: "Woman in red holding cup.",
            image: {
                src: "https://cdn.shopify.com/s/files/1/1114/2308/files/MobileHero.png"
            },
            position: "center center",
            imageDt: {
                src: "https://cdn.shopify.com/s/files/1/1114/2308/files/HeroImage.png"
            },
            positionDt: "center center"
        },
        text: {
            heading: "# Red velvet collection",
            subheading: "Serving up Luxe, one drink at a time."
        },
        button: {
            buttons: [
                {
                    cta: {
                        text: "Shop Now",
                        url: "/collections/all"
                    },
                    style: "primary"
                }, 
            ]
        },
        content: {
            alignment: "left",
            position: "left center",
            alignmentDt: "left",
            positionDt: "left center",
            maxWidth: 340,
            maxWidthDt: 600
        }
    };
};
var defaultSlide2 = function() {
    return {
        video: {
            srcDt: "https://cdn.shopify.com/s/files/1/1114/2308/files/Brumate.mp4",
            src: "https://cdn.shopify.com/s/files/1/1114/2308/files/Brumate.mp4",
            posterDt: {
                src: "https://cdn.shopify.com/s/files/1/1114/2308/files/default.png"
            },
            poster: {
                src: "https://cdn.shopify.com/s/files/1/1114/2308/files/default.png"
            },
            autoplay: true,
            loop: true,
            controls: false,
            muted: true
        },
        text: {
            heading: "# Introducing Br\xfctank",
            subheading: "Worlds first 55 quart, all-terrain cooler."
        },
        button: {
            buttons: [
                {
                    cta: {
                        text: "Shop Now",
                        url: "/collections/brutank"
                    },
                    style: "primary"
                }, 
            ]
        },
        content: {
            alignmentDt: "left",
            positionDt: "left center",
            alignment: "left",
            position: "left center",
            maxWidth: 340,
            maxWidthDt: 600
        }
    };
};
var HeroSlider_schema_section = function(param) {
    var sectionWithHeight = param.sectionWithHeight;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sectionWithHeight), {
        fields: [
            {
                label: "Above the fold",
                name: "aboveTheFold",
                component: "toggle",
                toggleLabels: {
                    true: "Yes",
                    false: "No"
                },
                defaultValue: false
            }, 
        ].concat((0,_to_consumable_array/* default */.Z)(sectionWithHeight.fields)),
        defaultValue: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sectionWithHeight.desktop), {
            desktop: {
                container: "padded",
                mt: "none",
                py: "none"
            }
        }), sectionWithHeight.mobile), {
            mobile: {
                container: "padded",
                mt: "none",
                py: "none",
                minHeight: 375,
                maxHeight: 375
            }
        })
    });
};
var countDown = function(param) {
    var color = param.color;
    return {
        label: "Countdown Timer",
        name: "countdown",
        component: "group",
        fields: [
            {
                label: "Title",
                name: "title",
                component: "text",
                description: "",
                defaultValue: "Countdown Timer Copy"
            },
            {
                name: "titleFont",
                label: "Font Family Option",
                component: "radio-group",
                direction: "horizontal",
                variant: "radio",
                options: [
                    {
                        label: "Reckless Neue",
                        value: "text.h1"
                    },
                    {
                        label: "Fellix",
                        value: "text.h1.2"
                    }, 
                ],
                defaultValue: "text.h1"
            },
            {
                label: "Title Font Size",
                name: "titleFontSize",
                component: "select",
                options: [
                    {
                        label: "H1",
                        value: "text.h1"
                    },
                    {
                        label: "H1.2",
                        value: "text.h1.2"
                    },
                    {
                        label: "H2",
                        value: "text.h2"
                    },
                    {
                        label: "H3",
                        value: "text.h3"
                    },
                    {
                        label: "H4",
                        value: "text.h4"
                    },
                    {
                        label: "H5",
                        value: "text.h5"
                    },
                    {
                        label: "H6",
                        value: "text.h6"
                    },
                    {
                        label: "SM",
                        value: "text.sm"
                    },
                    {
                        label: "Base",
                        value: "text.base"
                    },
                    {
                        label: "Large",
                        value: "text.lg"
                    }, 
                ],
                defaultValue: "text.h1"
            },
            {
                label: "Background color",
                name: "background",
                component: "select",
                options: color.options.concat({
                    label: "None",
                    value: "transparent"
                }),
                defaultValue: color.value.mediumGray
            },
            {
                label: "Text Color",
                name: "clockColor",
                component: "select",
                options: color.options,
                defaultValue: color.value.text
            },
            {
                label: "Clock Font Size",
                name: "clockFontSize",
                component: "select",
                options: [
                    {
                        label: "H1",
                        value: "text.h1"
                    },
                    {
                        label: "H1.2",
                        value: "text.h1.2"
                    },
                    {
                        label: "H2",
                        value: "text.h2"
                    },
                    {
                        label: "H3",
                        value: "text.h3"
                    },
                    {
                        label: "H4",
                        value: "text.h4"
                    },
                    {
                        label: "H5",
                        value: "text.h5"
                    },
                    {
                        label: "H6",
                        value: "text.h6"
                    },
                    {
                        label: "SM",
                        value: "text.sm"
                    },
                    {
                        label: "Base",
                        value: "text.base"
                    },
                    {
                        label: "Large",
                        value: "text.lg"
                    }, 
                ],
                defaultValue: "text.h2"
            },
            {
                label: "Target Time",
                name: "targetTime",
                component: "text",
                description: "Date format: ".concat(DateTime.now().toFormat("MM-dd-yyyy tt")),
                defaultValue: DateTime.now().toFormat("MM-dd-yyyy tt")
            },
            {
                label: "Target TimeZone",
                name: "timezone",
                component: "select",
                options: common/* timezones.options */.LY.options,
                defaultValue: "America/Los_Angeles"
            }, 
        ]
    };
};
var HeroSlider_schema_Schema = function() {
    return {
        label: "Hero Slider",
        key: "hero-slider",
        fields: [
            {
                name: "slides",
                label: "Slides",
                component: "group-list",
                itemProps: {
                    label: "{{item.text.heading}}"
                },
                defaultItem: function() {
                    return defaultSlide1;
                },
                fields: [
                    countDown({
                        color: common/* color */.$_
                    }),
                    video(),
                    HeroSlider_schema_image({
                        position: common/* position */.FK
                    }),
                    HeroSlider_schema_text({
                        color: common/* color */.$_
                    }),
                    HeroSlider_schema_buttons({
                        button: common/* button */.LI
                    }),
                    HeroSlider_schema_content({
                        position: common/* position */.FK
                    }), 
                ],
                defaultValue: [
                    defaultSlide1(),
                    defaultSlide2()
                ]
            },
            slider({
                color: common/* color */.$_
            }),
            HeroSlider_schema_section({
                sectionWithHeight: common/* sectionWithHeight */.Z1
            }), 
        ]
    };
};

;// CONCATENATED MODULE: ./src/sections/HeroSlider/CountdownTimer/CountdownTimer.jsx





function DateTimeDisplay(param) {
    var value = param.value, type = param.type, isDanger = param.isDanger;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)("div", {
        className: "".concat(isDanger ? "countdown danger" : "countdown", " flex gap-1 flex-col items-center"),
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("span", {
                className: "tracking-[1.7px]",
                children: value
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("span", {
                className: "capitalize",
                sx: {
                    fontSize: 1,
                    lineHeight: "normal"
                },
                children: type
            })
        ]
    });
}
function ExpiredNotice() {
    return null;
}
function ShowCountDown(param) {
    var days = param.days, hours = param.hours, minutes = param.minutes, seconds = param.seconds, clockColor = param.clockColor, clockFontSize = param.clockFontSize, theme = param.theme;
    var ref;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)("div", {
        className: "coundown-timer flex items-start justify-center gap-1 lg:pt-1",
        sx: theme === null || theme === void 0 ? void 0 : (ref = theme.countDown) === null || ref === void 0 ? void 0 : ref.clock(clockColor, clockFontSize),
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(DateTimeDisplay, {
                value: days,
                type: "Days",
                isDanger: days <= 3
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("span", {
                children: ":"
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(DateTimeDisplay, {
                value: hours,
                type: "Hours",
                isDanger: false
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("span", {
                children: ":"
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(DateTimeDisplay, {
                value: minutes,
                type: "Mins",
                isDanger: false
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("span", {
                children: ":"
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(DateTimeDisplay, {
                value: seconds,
                type: "Seconds",
                isDanger: false
            })
        ]
    });
}
function CountdownTimer(param) {
    var countdown = param.countdown, theme = param.theme;
    var ref;
    var ref1 = countdown || {}, title = ref1.title, titleFont = ref1.titleFont, titleFontSize = ref1.titleFontSize, background = ref1.background, clockColor = ref1.clockColor, clockFontSize = ref1.clockFontSize, targetTime = ref1.targetTime, timezone = ref1.timezone;
    var targetDate = targetTime;
    var targetDateZone = DateTime.fromFormat("".concat(targetDate, " ").concat(timezone || "America/Los_Angeles"), "MM-dd-yyyy tt z");
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useCountdown */.au)(targetDateZone), 4), days = ref2[0], hours = ref2[1], minutes = ref2[2], seconds = ref2[3];
    if (!targetDateZone.isValid) return null;
    if (days + hours + minutes + seconds <= 0) {
        return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(ExpiredNotice, {});
    }
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)("div", {
        className: "countdown-wrapper px-6 py-9 md:pt-6 md:pb-8",
        sx: {
            fontFamily: "".concat(titleFont == "text.h1" ? "Reckless Neue" : "Fellix"),
            background: [
                background
            ]
        },
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                className: "countdown__title text-center mb-3 md:mb-5",
                sx: theme === null || theme === void 0 ? void 0 : (ref = theme.countDown) === null || ref === void 0 ? void 0 : ref.title(titleFont, clockColor, titleFontSize),
                children: title
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(ShowCountDown, {
                days: days,
                hours: hours,
                minutes: minutes,
                seconds: seconds,
                clockColor: clockColor,
                clockFontSize: clockFontSize,
                theme: theme
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/sections/HeroSlider/CountdownTimer/index.js


;// CONCATENATED MODULE: ./src/sections/HeroSlider/Slide/Slide.theme.js

var Slide_theme_themed = (0,create/* create */.U)(new function() {
    this.slide = {
        height: "100%",
        position: "relative",
        width: "100%"
    };
    this.image = {
        position: "absolute",
        width: "100%",
        height: "100%",
        top: 0,
        left: 0,
        bottom: 0,
        right: 0
    };
    this.contentWrapper = {
        display: "flex",
        flexDirection: "column",
        height: "100%",
        pointerEvents: "none",
        position: "relative",
        width: "100%"
    };
    this.content = {
        px: 0,
        pt: [
            6,
            17
        ],
        mb: [
            14,
            16
        ],
        pointerEvents: "auto"
    };
    this.superheading = {
        variant: "text.label.1"
    };
    this.heading = function() {
        var headingOption = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "text.h1";
        return {
            variant: headingOption,
            m: 0
        };
    };
    this.subheading = {
        variant: "text.lg"
    };
    this.countDown = {
        title: function() {
            var titleFont = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "text.h1", color = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "colors.black", fontSize = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "text.h1";
            return {
                variant: fontSize,
                fontFamily: "inherit",
                color: [
                    color
                ],
                letterSpacing: [
                    0
                ],
                fontWeight: [
                    400
                ]
            };
        },
        clock: function() {
            var color = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "colors.black", fontSize = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "text.h2";
            return {
                variant: fontSize,
                fontFamily: "inherit",
                color: [
                    color
                ],
                letterSpacing: [
                    0
                ],
                fontWeight: [
                    400
                ]
            };
        }
    };
    this.buttons = {
        mt: [
            8,
            11
        ],
        gridAutoFlow: "column",
        gridGap: 9,
        "@media only screen and (max-width: 479px)": {
        }
    };
    this.hidden = {
        opacity: 0,
        pointerEvents: "none"
    };
}());

;// CONCATENATED MODULE: ./src/sections/HeroSlider/Slide/Content.jsx












var Slide_Content_Content = Slide_theme_themed(function(_param) {
    var theme = _param.theme, isBelowHero = _param.isBelowHero, slide = _param.slide, _isVisibleContent = _param.isVisibleContent, isVisibleContent = _isVisibleContent === void 0 ? true : _isVisibleContent, isFirstSlide = _param.isFirstSlide, isMobile = _param.isMobile, clickable = _param.clickable, showContentSliderMobile = _param.showContentSliderMobile, showContentSliderDesktop = _param.showContentSliderDesktop, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme",
        "isBelowHero",
        "slide",
        "isVisibleContent",
        "isFirstSlide",
        "isMobile",
        "clickable",
        "showContentSliderMobile",
        "showContentSliderDesktop"
    ]);
    var ref, ref1;
    var isMobileViewport = (0,hooks/* useMatchMedia */.ag)("(max-width: 767px)");
    var isVisibleH1 = isMobile && isMobileViewport || !isMobile && !isMobileViewport;
    var text = slide.text, button = slide.button, content = slide.content;
    var textAlign = [
        content === null || content === void 0 ? void 0 : content.alignment,
        content === null || content === void 0 ? void 0 : content.alignmentDt
    ];
    var flexAlign = textAlign.map(function(align) {
        return (0,utils_common/* convertAlignToFlex */.nG)(align);
    });
    var color = [
        (text === null || text === void 0 ? void 0 : text.color) || "currentColor",
        (text === null || text === void 0 ? void 0 : text.colorDt) || "currentColor", 
    ];
    var calcWidth = (content === null || content === void 0 ? void 0 : content.maxWidth) ? [
        content.maxWidth + theme_space/* space.12 */.D[12] * 2,
        content.maxWidthDt + theme_space/* space.15 */.D[15] * 2
    ] : "none";
    // Mobile content position
    var posMb = (0,react.useMemo)(function() {
        return (0,utils_common/* parseContentPosition */.M0)(content === null || content === void 0 ? void 0 : content.position);
    }, [
        content === null || content === void 0 ? void 0 : content.position
    ]);
    // Desktop content position
    var posDt = (0,react.useMemo)(function() {
        return (0,utils_common/* parseContentPosition */.M0)(content === null || content === void 0 ? void 0 : content.positionDt);
    }, [
        content === null || content === void 0 ? void 0 : content.positionDt
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
        "data-comp": Slide_Content_Content.displayName,
        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.contentWrapper), {
            alignItems: [
                posMb.alignItems,
                posDt.alignItems
            ],
            justifyContent: [
                posMb.justifyContent,
                posDt.justifyContent
            ]
        }), props.sx), {
            visibility: isVisibleContent ? "visible" : "hidden"
        }),
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(CountdownTimer, {
                countdown: slide === null || slide === void 0 ? void 0 : slide.countdown,
                theme: theme
            }),
            !!(content === null || content === void 0 ? void 0 : content.enableContent) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.content), {
                    maxWidth: calcWidth,
                    pt: isBelowHero ? [
                        6,
                        12
                    ] : [
                        15,
                        17
                    ],
                    px: isBelowHero ? 0 : 10
                }),
                children: [
                    (text === null || text === void 0 ? void 0 : text.superheading) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                        as: "h6",
                        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.superheading, (text === null || text === void 0 ? void 0 : text.hiddenHeadingForSeo) ? theme.hidden : null), {
                            textAlign: textAlign,
                            color: "black",
                            pointerEvents: "auto"
                        }),
                        children: text === null || text === void 0 ? void 0 : text.superheading
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Markdown */.UG, {
                        text: text === null || text === void 0 ? void 0 : text.heading,
                        textSx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme === null || theme === void 0 ? void 0 : theme.heading(text === null || text === void 0 ? void 0 : text.headingOption), (text === null || text === void 0 ? void 0 : text.hiddenHeadingForSeo) ? theme.hidden : null), {
                            textAlign: textAlign,
                            color: color
                        }),
                        sx: {
                            mb: (text === null || text === void 0 ? void 0 : text.subheading) ? 6 : 0,
                            pointerEvents: "auto"
                        },
                        overrides: !isFirstSlide || !isVisibleH1 ? {
                            h1: {
                                component: "h2"
                            }
                        } : null
                    }),
                    (text === null || text === void 0 ? void 0 : text.subheading) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Markdown */.UG, {
                        text: text === null || text === void 0 ? void 0 : text.subheading,
                        textSx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme === null || theme === void 0 ? void 0 : theme.subheading, (text === null || text === void 0 ? void 0 : text.hiddenHeadingForSeo) ? theme.hidden : null), {
                            textAlign: textAlign,
                            color: color
                        })
                    }),
                    !(button === null || button === void 0 ? void 0 : button.hideButtons) && (button === null || button === void 0 ? void 0 : (ref = button.buttons) === null || ref === void 0 ? void 0 : ref.length) > 0 && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Grid */.rj, {
                        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme === null || theme === void 0 ? void 0 : theme.buttons), {
                            justifyContent: flexAlign,
                            "@media only screen and (max-width: 479px)": {
                                alignItems: flexAlign,
                                display: "flex",
                                flexDirection: "row",
                                flexWrap: "wrap",
                                gridGap: 6
                            }
                        }),
                        children: button === null || button === void 0 ? void 0 : (ref1 = button.buttons) === null || ref1 === void 0 ? void 0 : ref1.slice(0, 2).map(function(item, index) {
                            var ref, ref1, ref2, ref3, ref4, ref5;
                            return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(react.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Link */.rU, {
                                        variant: "buttons.".concat(item.style),
                                        href: clickable && !showContentSliderMobile ? null : item === null || item === void 0 ? void 0 : (ref = item.cta) === null || ref === void 0 ? void 0 : ref.url,
                                        newTab: item === null || item === void 0 ? void 0 : (ref1 = item.cta) === null || ref1 === void 0 ? void 0 : ref1.newTab,
                                        sx: {
                                            pointerEvents: "auto",
                                            display: [
                                                "block",
                                                "none"
                                            ],
                                            "@media only screen and (max-width: 479px)": {
                                                minWidth: button === null || button === void 0 ? void 0 : button.buttonWidth
                                            }
                                        },
                                        children: item === null || item === void 0 ? void 0 : (ref2 = item.cta) === null || ref2 === void 0 ? void 0 : ref2.text
                                    }),
                                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Link */.rU, {
                                        variant: "buttons.".concat(item.style),
                                        href: clickable && !showContentSliderDesktop ? null : item === null || item === void 0 ? void 0 : (ref3 = item.cta) === null || ref3 === void 0 ? void 0 : ref3.url,
                                        newTab: item === null || item === void 0 ? void 0 : (ref4 = item.cta) === null || ref4 === void 0 ? void 0 : ref4.newTab,
                                        sx: {
                                            pointerEvents: "auto",
                                            display: [
                                                "none",
                                                "block"
                                            ],
                                            "@media only screen and (max-width: 479px)": {
                                                minWidth: button === null || button === void 0 ? void 0 : button.buttonWidth
                                            }
                                        },
                                        children: item === null || item === void 0 ? void 0 : (ref5 = item.cta) === null || ref5 === void 0 ? void 0 : ref5.text
                                    })
                                ]
                            }, index);
                        })
                    })
                ]
            })
        ]
    });
});
Slide_Content_Content.displayName = "Content";

;// CONCATENATED MODULE: ./src/sections/HeroSlider/Slide/ContentSlide.jsx




var ContentSlide = Slide_theme_themed(function(param) {
    var theme = param.theme, bgColor = param.bgColor, slide = param.slide, showContentSliderMobile = param.showContentSliderMobile, showContentSliderDesktop = param.showContentSliderDesktop, isBelowHero = param.isBelowHero, isVisibleContent = param.isVisibleContent, isFirstSlide = param.isFirstSlide;
    var showSlideMobile = showContentSliderMobile && isBelowHero || !showContentSliderMobile && !isBelowHero;
    var showSlideDesktop = showContentSliderDesktop && isBelowHero || !showContentSliderDesktop && !isBelowHero;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_jsx_runtime_esm/* Fragment */.HY, {
        children: [
            showSlideMobile && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                "data-comp": "".concat(ContentSlide.displayName, ".Mobile"),
                sx: {
                    position: "relative",
                    width: "100%",
                    height: "100%",
                    pointerEvents: isBelowHero ? null : "none",
                    bg: isBelowHero ? bgColor || "background" : "unset",
                    display: [
                        "block",
                        "none"
                    ]
                },
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Slide_Content_Content, {
                    slide: slide,
                    isVisibleContent: isVisibleContent,
                    isBelowHero: isBelowHero,
                    isFirstSlide: isFirstSlide,
                    isMobile: true,
                    showContentSliderMobile: showContentSliderMobile,
                    showContentSliderDesktop: showContentSliderDesktop
                })
            }),
            showSlideDesktop && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                "data-comp": "".concat(ContentSlide.displayName, ".Desktop"),
                sx: {
                    position: "relative",
                    width: "100%",
                    height: "100%",
                    pointerEvents: isBelowHero ? null : "none",
                    bg: isBelowHero ? bgColor || "background" : "unset",
                    display: [
                        "none",
                        "block"
                    ]
                },
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Slide_Content_Content, {
                    slide: slide,
                    isVisibleContent: isVisibleContent,
                    isBelowHero: isBelowHero,
                    isFirstSlide: isFirstSlide,
                    showContentSliderMobile: showContentSliderMobile,
                    showContentSliderDesktop: showContentSliderDesktop
                })
            })
        ]
    });
});
ContentSlide.displayName = "ContentSlide";

;// CONCATENATED MODULE: ./src/sections/HeroSlider/Slide/Image.jsx





var Slide_Image_Image = Slide_theme_themed(function(param) {
    var theme = param.theme, slide = param.slide, preload = param.preload, aboveTheFold = param.aboveTheFold;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var image = slide.image;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_jsx_runtime_esm/* Fragment */.HY, {
        children: [
            (image === null || image === void 0 ? void 0 : image.image) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Picture */.t, {
                "data-comp": Slide_Image_Image.displayName,
                alt: image === null || image === void 0 ? void 0 : image.alt,
                aboveTheFold: aboveTheFold,
                images: [
                    {
                        src: image === null || image === void 0 ? void 0 : (ref = image.image) === null || ref === void 0 ? void 0 : ref.src,
                        width: 768,
                        ratio: 1.1
                    }, 
                ],
                sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.image), {
                    display: (image === null || image === void 0 ? void 0 : image.imageDt) ? [
                        "block",
                        "none"
                    ] : ""
                }),
                preload: preload,
                width: image === null || image === void 0 ? void 0 : (ref1 = image.image) === null || ref1 === void 0 ? void 0 : ref1.width,
                height: image === null || image === void 0 ? void 0 : (ref2 = image.image) === null || ref2 === void 0 ? void 0 : ref2.height,
                imageSx: {
                    objectPosition: [
                        image === null || image === void 0 ? void 0 : image.position,
                        image === null || image === void 0 ? void 0 : image.positionDt
                    ]
                }
            }),
            (image === null || image === void 0 ? void 0 : image.imageDt) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Picture */.t, {
                "data-comp": Slide_Image_Image.displayName,
                alt: image === null || image === void 0 ? void 0 : image.alt,
                aboveTheFold: aboveTheFold,
                images: [
                    {
                        src: image === null || image === void 0 ? void 0 : (ref3 = image.imageDt) === null || ref3 === void 0 ? void 0 : ref3.src,
                        width: 1024,
                        ratio: 1.2
                    },
                    {
                        src: image === null || image === void 0 ? void 0 : (ref4 = image.imageDt) === null || ref4 === void 0 ? void 0 : ref4.src,
                        width: 1280,
                        ratio: 1.2
                    },
                    {
                        src: image === null || image === void 0 ? void 0 : (ref5 = image.imageDt) === null || ref5 === void 0 ? void 0 : ref5.src,
                        width: 1440,
                        ratio: 1.2
                    }, 
                ],
                sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.image), {
                    display: (image === null || image === void 0 ? void 0 : image.image) ? [
                        "none",
                        "block"
                    ] : ""
                }),
                preload: preload,
                width: image === null || image === void 0 ? void 0 : (ref6 = image.imageDt) === null || ref6 === void 0 ? void 0 : ref6.width,
                height: image === null || image === void 0 ? void 0 : (ref7 = image.imageDt) === null || ref7 === void 0 ? void 0 : ref7.height,
                imageSx: {
                    objectPosition: [
                        image === null || image === void 0 ? void 0 : image.position,
                        image === null || image === void 0 ? void 0 : image.positionDt
                    ]
                }
            })
        ]
    });
});
Slide_Image_Image.displayName = "Image";

;// CONCATENATED MODULE: ./src/sections/HeroSlider/Slide/Video.theme.js

var Video_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        width: "100%",
        height: "100%",
        overflowX: "hidden",
        position: "relative"
    };
    this.video = {
        display: "block",
        objectFit: "cover",
        width: "100%",
        height: "100%",
        translate3d: "0, 0, 0"
    };
}());

;// CONCATENATED MODULE: ./src/sections/HeroSlider/Slide/Video.jsx






var Video_Video = Video_theme_themed(function(param) {
    var theme = param.theme, video = param.video, src = param.src, poster = param.poster, isActive = param.isActive;
    var isWebm = src && /\.webm/g.test(src);
    var isMp4 = src && /\.mp4/g.test(src);
    var pointerControls = (video === null || video === void 0 ? void 0 : video.controls) ? "auto" : "none";
    var videoRef = (0,react.useRef)(null);
    // Pause/Play on dependant on activeIndex slide.
    (0,react.useEffect)(function() {
        if (!videoRef.current) return;
        if (!isActive) {
            videoRef.current.pause();
        } else if (video === null || video === void 0 ? void 0 : video.autoplay) {
            videoRef.current.play();
        }
    }, [
        isActive,
        video === null || video === void 0 ? void 0 : video.autoplay
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": Video_Video.displayName,
        sx: theme.wrapper,
        children: !isWebm && !isMp4 ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Embed */.cx, {
            src: src
        }, src) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
            as: "video",
            ref: videoRef,
            playsInline: true,
            autoPlay: video === null || video === void 0 ? void 0 : video.autoplay,
            loop: video === null || video === void 0 ? void 0 : video.loop,
            muted: (video === null || video === void 0 ? void 0 : video.autoplay) ? true : video === null || video === void 0 ? void 0 : video.muted,
            controls: video === null || video === void 0 ? void 0 : video.controls,
            poster: poster === null || poster === void 0 ? void 0 : poster.src,
            sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.video), {
                pointerEvents: pointerControls
            }),
            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("source", {
                src: src,
                type: "video/mp4"
            })
        }, src)
    });
});
Video_Video.displayName = "Video";

;// CONCATENATED MODULE: ./src/sections/HeroSlider/Slide/Slide.jsx










var Slide = Slide_theme_themed(function(param) {
    var theme = param.theme, slide = param.slide, isSlider = param.isSlider, showContentSliderMobile = param.showContentSliderMobile, showContentSliderDesktop = param.showContentSliderDesktop, isActive = param.isActive, isFirstSlide = param.isFirstSlide, isVisibleContent = param.isVisibleContent, aboveTheFold = param.aboveTheFold;
    var ref, ref1;
    var button = slide.button, video = slide.video, content = slide.content;
    var cta = button === null || button === void 0 ? void 0 : (ref = button.buttons) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.cta;
    var clickable = (button === null || button === void 0 ? void 0 : button.clickableHero) && !!(cta === null || cta === void 0 ? void 0 : cta.url);
    var sideRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (!(content === null || content === void 0 ? void 0 : content.enableMedia) && (sideRef === null || sideRef === void 0 ? void 0 : sideRef.current)) {
            if (!showContentSliderDesktop) {
                sideRef === null || sideRef === void 0 ? void 0 : sideRef.current.parentElement.classList.add("!h-auto");
                sideRef === null || sideRef === void 0 ? void 0 : sideRef.current.parentElement.classList.add("!min-h-0");
            } else {
                sideRef === null || sideRef === void 0 ? void 0 : sideRef.current.parentElement.classList.add("!hidden");
            }
        }
    }, [
        content === null || content === void 0 ? void 0 : content.enableMedia,
        sideRef
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(snippets/* Link */.rU, {
        "data-comp": Slide.displayName,
        href: clickable ? cta === null || cta === void 0 ? void 0 : cta.url : null,
        newTab: cta === null || cta === void 0 ? void 0 : cta.newTab,
        tabIndex: clickable && (button === null || button === void 0 ? void 0 : button.hideButtons) ? "0" : "-1",
        "aria-label": clickable && (button === null || button === void 0 ? void 0 : button.hideButtons) ? cta === null || cta === void 0 ? void 0 : cta.text : "",
        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.slide), {
            cursor: clickable ? "pointer" : isSlider ? "grab" : "auto"
        }),
        ref: sideRef,
        children: [
            !!(content === null || content === void 0 ? void 0 : content.enableMedia) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_jsx_runtime_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                        sx: {
                            display: [
                                "block",
                                "none"
                            ],
                            width: "100%",
                            height: "100%",
                            position: "absolute",
                            inset: 0
                        },
                        children: (video === null || video === void 0 ? void 0 : video.src) ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Video_Video, {
                            video: video,
                            src: video === null || video === void 0 ? void 0 : video.src,
                            poster: video === null || video === void 0 ? void 0 : video.poster,
                            isActive: isActive
                        }) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Slide_Image_Image, {
                            slide: slide,
                            preload: isFirstSlide
                        })
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                        sx: {
                            display: [
                                "none",
                                "block"
                            ],
                            width: "100%",
                            height: "100%",
                            position: "absolute",
                            inset: 0
                        },
                        children: (video === null || video === void 0 ? void 0 : video.srcDt) ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Video_Video, {
                            video: video,
                            src: video === null || video === void 0 ? void 0 : video.srcDt,
                            poster: video === null || video === void 0 ? void 0 : video.posterDt,
                            isActive: isActive
                        }) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Slide_Image_Image, {
                            slide: slide,
                            preload: aboveTheFold && isFirstSlide,
                            aboveTheFold: aboveTheFold
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(ContentSlide, {
                slide: slide,
                showContentSliderMobile: showContentSliderMobile,
                showContentSliderDesktop: showContentSliderDesktop,
                isVisibleContent: isVisibleContent,
                isFirstSlide: isFirstSlide
            })
        ]
    });
});
Slide.displayName = "Slide";

;// CONCATENATED MODULE: ./src/sections/HeroSlider/Slide/index.js




// EXTERNAL MODULE: ../node_modules/swiper/esm/components/core/core-class.js + 66 modules
var core_class = __webpack_require__(77796);
// EXTERNAL MODULE: ../node_modules/swiper/esm/components/navigation/navigation.js
var navigation = __webpack_require__(67296);
// EXTERNAL MODULE: ../node_modules/swiper/esm/components/pagination/pagination.js
var pagination = __webpack_require__(71403);
// EXTERNAL MODULE: ../node_modules/swiper/esm/components/effect-fade/effect-fade.js
var effect_fade = __webpack_require__(77803);
;// CONCATENATED MODULE: ./src/sections/HeroSlider/Slider/Slider.theme.js

var Slider_Slider_theme_themed = (0,create/* create */.U)(new function() {
    this.slider = {
        ".swiper-container": {
            height: "100%",
            width: "100%"
        },
        height: "100%",
        width: "100%"
    };
    this.bullets = {
        backgroundColor: "none",
        color: "text",
        display: "flex",
        height: 10,
        justifyContent: "center",
        pb: 11,
        span: {
            backgroundColor: "text",
            height: 10,
            width: 10
        },
        width: "75px"
    };
    this.contentSlide = {
        position: "relative"
    };
}());

;// CONCATENATED MODULE: ./src/sections/HeroSlider/Slider/Slider.jsx








core_class/* default.use */.Z.use([
    navigation/* default */.Z,
    pagination/* default */.Z,
    effect_fade/* default */.Z
]);
var Slider_Slider = Slider_Slider_theme_themed(function(param) {
    var theme = param.theme, activeIndex = param.activeIndex, setSwiper = param.setSwiper, showContentSliderMobile = param.showContentSliderMobile, showContentSliderDesktop = param.showContentSliderDesktop, slider = param.slider, slides = param.slides, swiper = param.swiper, aboveTheFold = param.aboveTheFold;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": Slider_Slider.displayName,
        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.slider), {
            ".swiper-pagination-bullet-active": {
                bg: (slider === null || slider === void 0 ? void 0 : slider.activeBulletColor) || "text"
            }
        }),
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(react_swiper/* Swiper */.t, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultParams), {
            autoplay: (slider === null || slider === void 0 ? void 0 : slider.autoplay) ? {
                delay: slider.delay || 5000,
                disableOnInteraction: false
            } : false,
            effect: (slider === null || slider === void 0 ? void 0 : slider.effect) === "fade" ? "fade" : null,
            onSwiper: setSwiper,
            children: [
                slides === null || slides === void 0 ? void 0 : slides.map(function(slide, index) {
                    /*#__PURE__*/ return (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(swiper_slide/* SwiperSlide */.o, {
                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Slide, {
                            slide: slide,
                            isSlider: true,
                            showContentSliderMobile: showContentSliderMobile,
                            showContentSliderDesktop: showContentSliderDesktop,
                            isVisibleContent: (slider === null || slider === void 0 ? void 0 : slider.effect) !== "fade" || index === activeIndex,
                            isActive: index === activeIndex,
                            isFirstSlide: index === 0,
                            aboveTheFold: aboveTheFold
                        })
                    }, index);
                }),
                (slider === null || slider === void 0 ? void 0 : slider.pagination) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                    className: "swiper-pagination",
                    sx: theme.bullets
                })
            ]
        }))
    });
});
Slider_Slider.displayName = "Slider";
var defaultParams = {
    centeredSlides: false,
    fadeEffect: {
        crossFade: true
    },
    freeMode: false,
    loop: false,
    navigation: false,
    pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true
    },
    slidesPerGroup: 1,
    slidesPerView: 1,
    spaceBetween: 0,
    watchOverflow: true
};

;// CONCATENATED MODULE: ./src/sections/HeroSlider/Slider/ContentSlider.jsx








core_class/* default.use */.Z.use([
    effect_fade/* default */.Z
]);
var ContentSlider = Slider_Slider_theme_themed(function(param) {
    var theme = param.theme, activeIndex = param.activeIndex, bgColor = param.bgColor, setContentSwiper = param.setContentSwiper, slider = param.slider, slides = param.slides, showContentSliderMobile = param.showContentSliderMobile, showContentSliderDesktop = param.showContentSliderDesktop;
    return (slides === null || slides === void 0 ? void 0 : slides.length) > 0 ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Container */.W2, {
        "data-comp": ContentSlider.displayName,
        children: slides.length > 1 ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(react_swiper/* Swiper */.t, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ContentSlider_defaultParams), {
            autoplay: (slider === null || slider === void 0 ? void 0 : slider.autoplay) ? {
                delay: slider.delay || 5000,
                disableOnInteraction: false
            } : false,
            effect: (slider === null || slider === void 0 ? void 0 : slider.effect) === "fade" ? "fade" : null,
            onSwiper: setContentSwiper,
            children: slides.map(function(slide, index) {
                return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(swiper_slide/* SwiperSlide */.o, {
                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(ContentSlide, {
                        bgColor: bgColor,
                        slide: slide,
                        showContentSliderMobile: showContentSliderMobile,
                        showContentSliderDesktop: showContentSliderDesktop,
                        isBelowHero: true,
                        isVisibleContent: (slider === null || slider === void 0 ? void 0 : slider.effect) !== "fade" || index === activeIndex,
                        isFirstSlide: index === 0
                    })
                }, index);
            })
        })) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(ContentSlide, {
            bgColor: bgColor,
            slide: slides[0],
            showContentSliderMobile: showContentSliderMobile,
            showContentSliderDesktop: showContentSliderDesktop,
            isBelowHero: true,
            isVisibleContent: true,
            isFirstSlide: true
        })
    }) : null;
});
ContentSlider.displayName = "ContentSlider";
var ContentSlider_defaultParams = {
    allowSlideNext: false,
    allowSlidePrev: false,
    allowTouchMove: false,
    centeredSlides: false,
    fadeEffect: {
        crossFade: true
    },
    freeMode: false,
    loop: false,
    navigation: false,
    slidesPerGroup: 1,
    slidesPerView: 1,
    spaceBetween: 0,
    watchOverflow: true
};

;// CONCATENATED MODULE: ./src/sections/HeroSlider/Slider/index.js



;// CONCATENATED MODULE: ./src/sections/HeroSlider/HeroSlider.theme.js

var HeroSlider_theme_themed = (0,create/* create */.U)(new function() {
    this.heroSlider = {
        bg: "ghostwhite",
        display: "flex",
        flexDirection: "column"
    };
}());

;// CONCATENATED MODULE: ./src/sections/HeroSlider/HeroSlider.jsx











var HeroSlider = (0,src_utils/* withInView */.Dh)(HeroSlider_theme_themed(function(param) {
    var theme = param.theme, cms = param.cms;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var slider = cms.slider, section = cms.section, slides = cms.slides;
    var ref6 = (0,react.useState)(), swiper = ref6[0], setSwiper = ref6[1];
    var ref7 = (0,react.useState)(), contentSwiper = ref7[0], setContentSwiper = ref7[1];
    var ref8 = (0,react.useState)(0), activeIndex = ref8[0], setActiveIndex = ref8[1];
    var showContentSliderMobile = (slider === null || slider === void 0 ? void 0 : slider.contentPosition) === "relative";
    var showContentSliderDesktop = (slider === null || slider === void 0 ? void 0 : slider.contentPositionDt) === "relative";
    var height = (0,react.useMemo)(function() {
        var ref, ref1;
        return [
            (0,src_utils/* calcResponsiveHeight */.ku)({
                maxHeight: section === null || section === void 0 ? void 0 : (ref = section.mobile) === null || ref === void 0 ? void 0 : ref.maxHeight,
                viewport: 768
            }),
            (0,src_utils/* calcResponsiveHeight */.ku)({
                maxHeight: section === null || section === void 0 ? void 0 : (ref1 = section.desktop) === null || ref1 === void 0 ? void 0 : ref1.maxHeight,
                viewport: 1280
            }), 
        ];
    }, [
        section === null || section === void 0 ? void 0 : (ref = section.mobile) === null || ref === void 0 ? void 0 : ref.maxHeight,
        section === null || section === void 0 ? void 0 : (ref1 = section.desktop) === null || ref1 === void 0 ? void 0 : ref1.maxHeight
    ]);
    var mobileMinHeight = (section === null || section === void 0 ? void 0 : (ref2 = section.mobile) === null || ref2 === void 0 ? void 0 : ref2.minHeight) ? section.mobile.minHeight : 375;
    var desktopMinHeight = (section === null || section === void 0 ? void 0 : (ref3 = section.desktop) === null || ref3 === void 0 ? void 0 : ref3.minHeight) ? section.desktop.minHeight : 460;
    var setActiveIndexAndSlideToOnSlideChange = (0,react.useCallback)(function() {
        if (!swiper || (slides === null || slides === void 0 ? void 0 : slides.length) < 2) return;
        swiper === null || swiper === void 0 ? void 0 : swiper.on("slideChange", function() {
            setActiveIndex(swiper === null || swiper === void 0 ? void 0 : swiper.realIndex);
            contentSwiper === null || contentSwiper === void 0 ? void 0 : contentSwiper.slideTo(swiper === null || swiper === void 0 ? void 0 : swiper.realIndex);
        });
    }, [
        swiper,
        contentSwiper,
        slides === null || slides === void 0 ? void 0 : slides.length
    ]);
    (0,react.useEffect)(function() {
        setActiveIndexAndSlideToOnSlideChange();
    }, [
        swiper,
        contentSwiper,
        slides === null || slides === void 0 ? void 0 : slides.length
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(snippets/* Section */.$0, {
        section: section,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Container */.W2, {
                "data-comp": HeroSlider.displayName,
                sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.heroSlider), {
                    height: height,
                    minHeight: [
                        "".concat(mobileMinHeight, "px"),
                        "".concat(desktopMinHeight, "px")
                    ],
                    maxHeight: [
                        "".concat(section === null || section === void 0 ? void 0 : (ref4 = section.mobile) === null || ref4 === void 0 ? void 0 : ref4.maxHeight, "px"),
                        "".concat(section === null || section === void 0 ? void 0 : (ref5 = section.desktop) === null || ref5 === void 0 ? void 0 : ref5.maxHeight, "px"), 
                    ]
                }),
                children: [
                    (slides === null || slides === void 0 ? void 0 : slides.length) > 1 && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Slider_Slider, {
                        slides: slides,
                        slider: slider,
                        swiper: swiper,
                        setSwiper: setSwiper,
                        showContentSliderMobile: showContentSliderMobile,
                        showContentSliderDesktop: showContentSliderDesktop,
                        activeIndex: activeIndex,
                        aboveTheFold: section.aboveTheFold
                    }),
                    (slides === null || slides === void 0 ? void 0 : slides.length) === 1 && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Slide, {
                        slide: slides[0],
                        isActive: true,
                        showContentSliderMobile: showContentSliderMobile,
                        showContentSliderDesktop: showContentSliderDesktop,
                        isFirstSlide: true,
                        isVisibleContent: true,
                        aboveTheFold: section.aboveTheFold
                    })
                ]
            }),
            (showContentSliderMobile || showContentSliderDesktop) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                sx: {
                    display: [
                        showContentSliderMobile ? "block" : "none",
                        showContentSliderDesktop ? "block" : "none", 
                    ]
                },
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(ContentSlider, {
                    activeIndex: activeIndex,
                    bgColor: section === null || section === void 0 ? void 0 : section.bgColor,
                    contentSwiper: contentSwiper,
                    setContentSwiper: setContentSwiper,
                    showContentSliderMobile: showContentSliderMobile,
                    showContentSliderDesktop: showContentSliderDesktop,
                    slider: slider,
                    slides: slides
                })
            })
        ]
    });
}), {
    triggerOnce: true
});
HeroSlider.displayName = "HeroSlider";
HeroSlider.Schema = HeroSlider_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/HeroSlider/index.js


;// CONCATENATED MODULE: ./src/sections/HeroValueProps/HeroValueProps.theme.js



var HeroValueProps_theme_themed = function(Component) {
    return function ThemedComponent(props) {
        var theme = {
            heroValueProps: {
                position: "relative",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                overflow: "hidden"
            }
        };
        return /*#__PURE__*/ react.createElement(Component, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            theme: theme
        }));
    };
};

;// CONCATENATED MODULE: ./src/sections/HeroValueProps/HeroValueProps.schema.js




var backgroundImage = function() {
    return {
        label: "Background Image Settings",
        name: "backgroundImage",
        description: "Background images for desktop and mobile",
        component: "group",
        fields: [
            {
                name: "desktop",
                label: "Desktop Background",
                component: "group",
                fields: [
                    {
                        name: "src",
                        label: "Desktop Image",
                        component: "image"
                    },
                    {
                        name: "position",
                        component: "select",
                        label: "Image position (desktop)",
                        options: [
                            {
                                label: "Center Center",
                                value: "center center"
                            },
                            {
                                label: "Center Top",
                                value: "center top"
                            },
                            {
                                label: "Center Bottom",
                                value: "center bottom"
                            },
                            {
                                label: "Left Center",
                                value: "left center"
                            },
                            {
                                label: "Right Center",
                                value: "right center"
                            }, 
                        ]
                    }, 
                ]
            },
            {
                name: "mobile",
                label: "Mobile Background",
                component: "group",
                fields: [
                    {
                        name: "src",
                        label: "Mobile Image",
                        component: "image"
                    },
                    {
                        name: "position",
                        component: "select",
                        label: "Image position (mobile)",
                        options: [
                            {
                                label: "Center Center",
                                value: "center center"
                            },
                            {
                                label: "Center Top",
                                value: "center top"
                            },
                            {
                                label: "Center Bottom",
                                value: "center bottom"
                            },
                            {
                                label: "Left Center",
                                value: "left center"
                            },
                            {
                                label: "Right Center",
                                value: "right center"
                            }, 
                        ]
                    }, 
                ]
            }, 
        ],
        defaultValue: {
            desktop: {
                src: "https://cdn.shopify.com/s/files/1/1114/2308/files/HeroBg.png",
                position: "center center"
            },
            mobile: {
                src: "https://cdn.shopify.com/s/files/1/1114/2308/files/Screen_Shot_2022-04-27_at_2.33.14_PM.png",
                position: "center center"
            }
        }
    };
};
var HeroValueProps_schema_text = function() {
    return {
        label: "Text Settings",
        name: "text",
        description: "Superheading, heading, subheading, text color",
        component: "group",
        fields: [
            {
                name: "logo",
                label: "Logo",
                component: "image",
                description: "Recommended image size: 72px x 72px"
            },
            {
                name: "superheading",
                component: "text",
                label: "Superheading"
            },
            {
                name: "heading",
                component: "text",
                label: "Heading"
            },
            {
                name: "headingOption",
                label: "Font Family Heading Option",
                component: "radio-group",
                direction: "horizontal",
                variant: "radio",
                options: [
                    {
                        label: "Reckless Neue",
                        value: "text.h1"
                    },
                    {
                        label: "Fellix",
                        value: "text.h1.2"
                    }, 
                ],
                defaultValue: "text.h1"
            },
            {
                name: "subheading",
                component: "text",
                label: "Subheading / Body"
            },
            {
                name: "desktopFontSize",
                component: "select",
                label: "Desktop Font Size",
                description: "Font size for desktop devices",
                options: [
                    {
                        label: "60px",
                        value: 60
                    },
                    {
                        label: "72px",
                        value: 72
                    },
                    {
                        label: "84px (Default)",
                        value: 84
                    },
                    {
                        label: "96px",
                        value: 96
                    },
                    {
                        label: "108px",
                        value: 108
                    },
                    {
                        label: "Custom",
                        value: "custom"
                    }, 
                ],
                defaultValue: 84
            },
            {
                name: "customDesktopFontSize",
                component: "number",
                label: "Custom Desktop Font Size (px)",
                description: 'Only used when "Custom" is selected above',
                condition: {
                    component: "desktopFontSize",
                    operator: "===",
                    value: "custom"
                }
            },
            {
                name: "mobileFontSize",
                component: "select",
                label: "Mobile Font Size",
                description: "Font size for mobile devices",
                options: [
                    {
                        label: "32px",
                        value: 32
                    },
                    {
                        label: "40px",
                        value: 40
                    },
                    {
                        label: "44px (Default)",
                        value: 44
                    },
                    {
                        label: "48px",
                        value: 48
                    },
                    {
                        label: "56px",
                        value: 56
                    },
                    {
                        label: "Custom",
                        value: "custom"
                    }, 
                ],
                defaultValue: 44
            },
            {
                name: "customMobileFontSize",
                component: "number",
                label: "Custom Mobile Font Size (px)",
                description: 'Only used when "Custom" is selected above',
                condition: {
                    component: "mobileFontSize",
                    operator: "===",
                    value: "custom"
                }
            },
            {
                component: "select",
                name: "color",
                label: "Text color",
                options: [
                    {
                        label: "White",
                        value: "#ffffff"
                    },
                    {
                        label: "Black",
                        value: "#000000"
                    },
                    {
                        label: "Gray",
                        value: "#666666"
                    }, 
                ]
            }, 
        ],
        defaultValue: {
            superheading: "",
            heading: "The only 100% leakproof straw tumbler on the market.",
            subheading: "",
            desktopFontSize: 84,
            customDesktopFontSize: 84,
            mobileFontSize: 44,
            customMobileFontSize: 44,
            color: "#ffffff"
        }
    };
};
var socialProof = function() {
    return {
        label: "Social Proof Animation",
        name: "socialProof",
        description: "Animated social proof with incrementing numbers",
        component: "group",
        fields: [
            {
                label: "Enable Social Proof",
                name: "enabled",
                component: "toggle",
                toggleLabels: {
                    true: "On",
                    false: "Off"
                },
                defaultValue: true
            },
            {
                name: "baseNumber",
                component: "number",
                label: "Base Number",
                description: "Starting number for the animation",
                defaultValue: 30000
            },
            {
                name: "label",
                component: "text",
                label: "Label",
                description: 'Text that appears after the number (e.g., "5 Star Reviews")',
                defaultValue: "5 Star Reviews"
            },
            {
                name: "ringColor",
                component: "color",
                label: "Image Ring Color",
                description: "Color of the ring/border around user images. Set to match your background for a transparent effect.",
                defaultValue: "#ffffff"
            },
            {
                name: "items",
                label: "Social Proof Items",
                component: "group-list",
                description: "Max of 10 items",
                itemProps: {
                    label: "{{item.image.alt}}"
                },
                validate: {
                    maxItems: 10
                },
                defaultItem: {
                    image: {
                        src: "",
                        alt: "User"
                    }
                },
                fields: [
                    {
                        name: "image",
                        component: "group",
                        label: "User Image",
                        fields: [
                            {
                                name: "src",
                                label: "Image",
                                component: "image"
                            },
                            {
                                name: "alt",
                                component: "text",
                                label: "Alt Text",
                                defaultValue: "User"
                            }, 
                        ]
                    }, 
                ],
                defaultValue: [
                    {
                        image: {
                            src: "",
                            alt: "User 1"
                        }
                    },
                    {
                        image: {
                            src: "",
                            alt: "User 2"
                        }
                    },
                    {
                        image: {
                            src: "",
                            alt: "User 3"
                        }
                    },
                    {
                        image: {
                            src: "",
                            alt: "User 4"
                        }
                    }, 
                ]
            }, 
        ]
    };
};
var valueProps = function() {
    return {
        label: "Brand Value Props",
        name: "valueProps",
        description: "Brand value propositions with icons, titles and descriptions",
        component: "group",
        fields: [
            {
                label: "Enable Value Props",
                name: "enabled",
                component: "toggle",
                toggleLabels: {
                    true: "On",
                    false: "Off"
                },
                defaultValue: true
            },
            {
                component: "color",
                name: "backgroundColor",
                label: "Background Color",
                defaultValue: "rgba(0,0,0,0.8)"
            },
            {
                label: "Text Color",
                name: "textColor",
                component: "color",
                defaultValue: "rgba(255,255,255,1)"
            },
            {
                name: "items",
                label: "Value Props",
                component: "group-list",
                description: "Brand value propositions",
                itemProps: {
                    label: "{{item.title}}"
                },
                defaultItem: {
                    icon: {
                        src: "",
                        alt: "Icon"
                    },
                    title: "Value Prop",
                    description: "Description of the value proposition"
                },
                fields: [
                    {
                        name: "icon",
                        component: "group",
                        label: "Icon",
                        fields: [
                            {
                                name: "src",
                                label: "Icon Image/SVG",
                                component: "image"
                            },
                            {
                                name: "alt",
                                component: "text",
                                label: "Alt Text",
                                defaultValue: "Icon"
                            }, 
                        ]
                    },
                    {
                        name: "title",
                        component: "text",
                        label: "Title"
                    },
                    {
                        name: "description",
                        component: "textarea",
                        label: "Description",
                        description: "Hidden on mobile"
                    }, 
                ],
                defaultValue: [
                    {
                        icon: {
                            src: "https://cdn.shopify.com/s/files/1/1114/2308/files/check-icon.svg",
                            alt: "Check icon"
                        },
                        title: "Innovative Design",
                        description: "Our innovative design, has won 3 prestigious Red Dot Design Awards."
                    },
                    {
                        icon: {
                            src: "https://cdn.shopify.com/s/files/1/1114/2308/files/warranty-icon.svg",
                            alt: "Warranty icon"
                        },
                        title: "Lifetime Warranty",
                        description: "Our limited lifetime warranty ensures lasting quality & peace of mind."
                    },
                    {
                        icon: {
                            src: "https://cdn.shopify.com/s/files/1/1114/2308/files/service-icon.svg",
                            alt: "Service icon"
                        },
                        title: "Flawless Customer Service",
                        description: "The Br\xfcGurus are dedicated to providing exceptional support via email and chat."
                    },
                    {
                        icon: {
                            src: "https://cdn.shopify.com/s/files/1/1114/2308/files/shipping-icon.svg",
                            alt: "Shipping icon"
                        },
                        title: "Free Shipping on Us Order $75+",
                        description: "Free shipping on orders over $75 so you can enjoy premium drinkware without added delivery costs."
                    }, 
                ]
            }, 
        ]
    };
};
var HeroValueProps_schema_section = function(param) {
    var sectionConfig = param.sectionWithHeight;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sectionConfig), {
        fields: [
            {
                label: "Above the fold",
                name: "aboveTheFold",
                component: "toggle",
                toggleLabels: {
                    true: "Yes",
                    false: "No"
                },
                defaultValue: true
            }, 
        ].concat((0,_to_consumable_array/* default */.Z)(sectionConfig.fields), [
            {
                label: "Hero Padding",
                name: "heroPadding",
                description: "Control padding inside the hero component",
                component: "group",
                fields: [
                    {
                        name: "desktop",
                        label: "Desktop Padding",
                        component: "group",
                        fields: [
                            {
                                name: "py",
                                label: "Vertical Padding",
                                component: "select",
                                options: [
                                    {
                                        label: "None",
                                        value: "none"
                                    },
                                    {
                                        label: "Small",
                                        value: "s"
                                    },
                                    {
                                        label: "Medium",
                                        value: "m"
                                    },
                                    {
                                        label: "Large",
                                        value: "l"
                                    },
                                    {
                                        label: "XLarge",
                                        value: "xl"
                                    }, 
                                ],
                                defaultValue: "m"
                            },
                            {
                                name: "px",
                                label: "Horizontal Padding",
                                component: "select",
                                options: [
                                    {
                                        label: "None",
                                        value: "none"
                                    },
                                    {
                                        label: "Small",
                                        value: "s"
                                    },
                                    {
                                        label: "Medium",
                                        value: "m"
                                    },
                                    {
                                        label: "Large",
                                        value: "l"
                                    },
                                    {
                                        label: "XLarge",
                                        value: "xl"
                                    }, 
                                ],
                                defaultValue: "m"
                            }, 
                        ]
                    },
                    {
                        name: "mobile",
                        label: "Mobile Padding",
                        component: "group",
                        fields: [
                            {
                                name: "py",
                                label: "Vertical Padding",
                                component: "select",
                                options: [
                                    {
                                        label: "None",
                                        value: "none"
                                    },
                                    {
                                        label: "Small",
                                        value: "s"
                                    },
                                    {
                                        label: "Medium",
                                        value: "m"
                                    },
                                    {
                                        label: "Large",
                                        value: "l"
                                    },
                                    {
                                        label: "XLarge",
                                        value: "xl"
                                    }, 
                                ],
                                defaultValue: "s"
                            },
                            {
                                name: "px",
                                label: "Horizontal Padding",
                                component: "select",
                                options: [
                                    {
                                        label: "None",
                                        value: "none"
                                    },
                                    {
                                        label: "Small",
                                        value: "s"
                                    },
                                    {
                                        label: "Medium",
                                        value: "m"
                                    },
                                    {
                                        label: "Large",
                                        value: "l"
                                    },
                                    {
                                        label: "XLarge",
                                        value: "xl"
                                    }, 
                                ],
                                defaultValue: "s"
                            }, 
                        ]
                    }, 
                ],
                defaultValue: {
                    desktop: {
                        py: "m",
                        px: "m"
                    },
                    mobile: {
                        py: "s",
                        px: "s"
                    }
                }
            }, 
        ]),
        defaultValue: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sectionConfig.defaultValue), {
            desktop: {
                container: "content",
                maxHeight: 800,
                minHeight: 600
            },
            mobile: {
                container: "content",
                maxHeight: 600,
                minHeight: 500
            },
            heroPadding: {
                desktop: {
                    py: "m",
                    px: "m"
                },
                mobile: {
                    py: "s",
                    px: "s"
                }
            }
        })
    });
};
var defaultHeroValueProps = function() {
    return {
        backgroundImage: {
            desktop: {
                src: "https://cdn.shopify.com/s/files/1/1114/2308/files/hero-bg-desktop.jpg",
                position: "center center"
            },
            mobile: {
                src: "https://cdn.shopify.com/s/files/1/1114/2308/files/hero-bg-mobile.jpg",
                position: "center center"
            }
        },
        text: {
            superheading: "",
            heading: "The only 100% leakproof straw tumbler on the market.",
            subheading: "",
            desktopFontSize: 84,
            customDesktopFontSize: 84,
            mobileFontSize: 44,
            customMobileFontSize: 44,
            color: "#ffffff"
        },
        socialProof: {
            enabled: true,
            baseNumber: 30000,
            label: "5 Star Reviews",
            ringColor: "#ffffff",
            items: [
                {
                    image: {
                        src: "https://cdn.shopify.com/s/files/1/1114/2308/files/user1.jpg",
                        alt: "User 1"
                    }
                },
                {
                    image: {
                        src: "https://cdn.shopify.com/s/files/1/1114/2308/files/user2.jpg",
                        alt: "User 2"
                    }
                },
                {
                    image: {
                        src: "https://cdn.shopify.com/s/files/1/1114/2308/files/user3.jpg",
                        alt: "User 3"
                    }
                },
                {
                    image: {
                        src: "https://cdn.shopify.com/s/files/1/1114/2308/files/user4.jpg",
                        alt: "User 4"
                    }
                }, 
            ]
        },
        valueProps: {
            enabled: true,
            backgroundColor: "rgba(0,0,0,0.8)",
            textColor: "rgba(255,255,255,1)",
            items: [
                {
                    icon: {
                        src: "https://cdn.shopify.com/s/files/1/1114/2308/files/check-icon.svg",
                        alt: "Check icon"
                    },
                    title: "Innovative Design",
                    description: "Our innovative design, has won 3 prestigious Red Dot Design Awards."
                },
                {
                    icon: {
                        src: "https://cdn.shopify.com/s/files/1/1114/2308/files/warranty-icon.svg",
                        alt: "Warranty icon"
                    },
                    title: "Lifetime Warranty",
                    description: "Our limited lifetime warranty ensures lasting quality & peace of mind."
                },
                {
                    icon: {
                        src: "https://cdn.shopify.com/s/files/1/1114/2308/files/service-icon.svg",
                        alt: "Service icon"
                    },
                    title: "Flawless Customer Service",
                    description: "The Br\xfcGurus are dedicated to providing exceptional support via email and chat."
                },
                {
                    icon: {
                        src: "https://cdn.shopify.com/s/files/1/1114/2308/files/shipping-icon.svg",
                        alt: "Shipping icon"
                    },
                    title: "Free Shipping on Us Order $75+",
                    description: "Free shipping on orders over $75 so you can enjoy premium drinkware without added delivery costs."
                }, 
            ]
        },
        section: {
            heroPadding: {
                desktop: {
                    py: "m",
                    px: "m"
                },
                mobile: {
                    py: "s",
                    px: "s"
                }
            }
        }
    };
};
var HeroValueProps_schema_Schema = function() {
    return {
        label: "Hero w/ Value Props",
        key: "heroValueProps",
        fields: [
            backgroundImage(),
            HeroValueProps_schema_text(),
            socialProof(),
            valueProps(),
            HeroValueProps_schema_section({
                sectionWithHeight: common/* sectionWithHeight */.Z1
            }), 
        ],
        defaultValue: defaultHeroValueProps()
    };
};

;// CONCATENATED MODULE: ./src/sections/HeroValueProps/HeroValueProps.jsx











function SocialProofAnimation(param) {
    var socialProof = param.socialProof;
    var ref;
    var ref1 = (0,react.useState)(0), currentIndex = ref1[0], setCurrentIndex = ref1[1];
    var ref2 = (0,react.useState)((socialProof === null || socialProof === void 0 ? void 0 : socialProof.baseNumber) || 0), currentNumber = ref2[0], setCurrentNumber = ref2[1];
    var ref3 = (0,react.useState)([]), visibleItems = ref3[0], setVisibleItems = ref3[1];
    (0,react.useEffect)(function() {
        var ref;
        if (!(socialProof === null || socialProof === void 0 ? void 0 : socialProof.enabled) || !(socialProof === null || socialProof === void 0 ? void 0 : (ref = socialProof.items) === null || ref === void 0 ? void 0 : ref.length)) {
            return undefined;
        }
        // Initialize visible items
        setVisibleItems(socialProof.items.slice(0, 4));
        var interval = setInterval(function() {
            setCurrentIndex(function(prev) {
                var nextIndex = (prev + 1) % socialProof.items.length;
                // Create new visible items array with the next item sliding in from left
                setVisibleItems(function(prevItems) {
                    var newItems = [
                        socialProof.items[nextIndex], 
                    ].concat((0,_to_consumable_array/* default */.Z)(prevItems.slice(0, 3)));
                    return newItems;
                });
                return nextIndex;
            });
            setCurrentNumber(function(prev) {
                return prev + 1;
            });
        }, 2500);
        return function() {
            return clearInterval(interval);
        };
    }, [
        socialProof
    ]);
    if (!(socialProof === null || socialProof === void 0 ? void 0 : socialProof.enabled) || !(socialProof === null || socialProof === void 0 ? void 0 : (ref = socialProof.items) === null || ref === void 0 ? void 0 : ref.length)) return null;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
        sx: {
            alignItems: "center",
            gap: "12px",
            mt: 4
        },
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                sx: {
                    position: "relative",
                    width: "94px",
                    height: "38px",
                    overflow: "visible"
                },
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                    sx: {
                        alignItems: "center",
                        position: "absolute",
                        right: 0,
                        transition: "transform 0.5s ease-in-out",
                        transform: "translateX(0)"
                    },
                    children: visibleItems.map(function(item, index) {
                        var ref;
                        /*#__PURE__*/ return (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                            sx: {
                                width: 34,
                                height: 34,
                                borderRadius: "50%",
                                overflow: "hidden",
                                position: "relative",
                                marginLeft: index > 0 ? "-12px" : 0,
                                zIndex: index + 1,
                                flexShrink: 0,
                                border: "2px solid ".concat(socialProof.ringColor || "#ffffff"),
                                boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                                animation: index === 0 ? "slideIn 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94)" : "none",
                                transition: "all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
                                "@keyframes slideIn": {
                                    "0%": {
                                        transform: "translateX(-46px) scale(0.8)",
                                        opacity: 0
                                    },
                                    "60%": {
                                        transform: "translateX(-10px) scale(0.95)",
                                        opacity: 0.7
                                    },
                                    "100%": {
                                        transform: "translateX(0) scale(1)",
                                        opacity: 1
                                    }
                                }
                            },
                            children: function() {
                                var ref, ref1, ref2, ref3, ref4, ref5, ref6;
                                var imageSrc = ((ref = item.image) === null || ref === void 0 ? void 0 : (ref1 = ref.src) === null || ref1 === void 0 ? void 0 : ref1.src) || ((ref2 = item.image) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.src) === null || ref3 === void 0 ? void 0 : ref3.url) || ((ref4 = item.image) === null || ref4 === void 0 ? void 0 : ref4.src) || item.image;
                                return imageSrc ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Image */.Ee, {
                                    src: imageSrc,
                                    alt: ((ref5 = item.image) === null || ref5 === void 0 ? void 0 : ref5.alt) || "User",
                                    sx: {
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover"
                                    }
                                }) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                                    sx: {
                                        width: "100%",
                                        height: "100%",
                                        background: "linear-gradient(135deg, ".concat([
                                            "#FF6B6B",
                                            "#4ECDC4",
                                            "#45B7D1",
                                            "#96CEB4",
                                            "#DDA0DD"
                                        ][index % 5], " 0%, ").concat([
                                            "#FF8E53",
                                            "#44A08D",
                                            "#5C7CFA",
                                            "#FECA57",
                                            "#F093FB"
                                        ][index % 5], " 100%)"),
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        fontSize: "14px",
                                        fontWeight: "bold",
                                        color: "white",
                                        textTransform: "uppercase"
                                    },
                                    children: (((ref6 = item.image) === null || ref6 === void 0 ? void 0 : ref6.alt) || "User").charAt(0)
                                });
                            }()
                        }, "".concat(((ref = item.image) === null || ref === void 0 ? void 0 : ref.alt) || "User", "-").concat(index, "-").concat(currentIndex));
                    })
                })
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                sx: {
                    alignItems: "center",
                    borderRadius: "50px",
                    overflow: "hidden",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                    height: "38px",
                    border: "1px solid #fff"
                },
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                        sx: {
                            bg: "white",
                            px: 3,
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            height: "100%"
                        },
                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Text */.xv, {
                            sx: {
                                fontSize: "14px",
                                fontWeight: 600,
                                color: "#1a1a1a",
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                                minWidth: "70px",
                                justifyContent: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("span", {
                                    children: "⭐"
                                }),
                                currentNumber.toLocaleString(),
                                "+"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                        sx: {
                            bg: "#fff",
                            opacity: 0.5,
                            px: 3,
                            pr: 4,
                            height: "100%",
                            display: "flex",
                            alignItems: "center"
                        },
                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Text */.xv, {
                            sx: {
                                fontSize: "13px",
                                fontWeight: 400,
                                color: "black",
                                letterSpacing: "0.01em"
                            },
                            children: socialProof.label
                        })
                    })
                ]
            })
        ]
    });
}
function ValueProps(param) {
    var valueProps = param.valueProps, setValuePropsHeight = param.setValuePropsHeight;
    var ref, ref1;
    var valuePropsRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var ref;
        if (valuePropsRef === null || valuePropsRef === void 0 ? void 0 : (ref = valuePropsRef.current) === null || ref === void 0 ? void 0 : ref.offsetHeight) {
            setValuePropsHeight(valuePropsRef.current.offsetHeight / 2);
        }
    }, [
        valuePropsRef === null || valuePropsRef === void 0 ? void 0 : (ref = valuePropsRef.current) === null || ref === void 0 ? void 0 : ref.offsetHeight
    ]);
    if (!(valueProps === null || valueProps === void 0 ? void 0 : valueProps.enabled) || !(valueProps === null || valueProps === void 0 ? void 0 : (ref1 = valueProps.items) === null || ref1 === void 0 ? void 0 : ref1.length)) return null;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
        sx: {
            mt: [
                0,
                5
            ],
            position: [
                "absolute",
                "relative"
            ],
            bottom: [
                "-16px",
                "auto"
            ],
            transform: [
                "translateY(50%)",
                "none"
            ],
            width: "100%"
        },
        ref: valuePropsRef,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
            sx: {
                display: "grid",
                gridTemplateColumns: [
                    "repeat(2, 1fr)",
                    "repeat(4, 1fr)"
                ],
                gap: [
                    3,
                    6
                ],
                bg: valueProps.backgroundColor || "rgba(0,0,0,0.8)",
                p: [
                    3,
                    4
                ]
            },
            children: valueProps.items.map(function(item, index) {
                /*#__PURE__*/ return (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                    sx: {
                        p: 4,
                        flexDirection: "column",
                        alignItems: "center",
                        textAlign: "center",
                        color: (valueProps === null || valueProps === void 0 ? void 0 : valueProps.textColor) || "white"
                    },
                    children: [
                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                            sx: {
                                mb: 2
                            },
                            children: function() {
                                var ref, ref1, ref2, ref3, ref4, ref5;
                                var iconSrc = ((ref = item.icon) === null || ref === void 0 ? void 0 : (ref1 = ref.src) === null || ref1 === void 0 ? void 0 : ref1.src) || ((ref2 = item.icon) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.src) === null || ref3 === void 0 ? void 0 : ref3.url) || ((ref4 = item.icon) === null || ref4 === void 0 ? void 0 : ref4.src) || item.icon;
                                return iconSrc ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Image */.Ee, {
                                    src: iconSrc,
                                    alt: ((ref5 = item.icon) === null || ref5 === void 0 ? void 0 : ref5.alt) || item.title,
                                    sx: {
                                        width: 24,
                                        height: 24
                                    }
                                }) : null;
                            }()
                        }),
                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Text */.xv, {
                            sx: {
                                fontSize: [
                                    1,
                                    2
                                ],
                                fontWeight: 600,
                                mb: 1
                            },
                            children: item.title
                        }),
                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Text */.xv, {
                            sx: {
                                fontSize: [
                                    0,
                                    1
                                ],
                                opacity: 0.8,
                                display: [
                                    "none",
                                    "block"
                                ]
                            },
                            children: item.description
                        })
                    ]
                }, index);
            })
        })
    });
}
var HeroValueProps = (0,src_utils/* withInView */.Dh)(HeroValueProps_theme_themed(function(param) {
    var theme = param.theme, cms = param.cms;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21;
    var backgroundImage = cms.backgroundImage, text = cms.text, socialProof = cms.socialProof, valueProps = cms.valueProps, section = cms.section;
    var ref22 = (0,react.useState)(0), valuePropsHeight = ref22[0], setValuePropsHeight = ref22[1];
    var height = (0,react.useMemo)(function() {
        var ref, ref1;
        return [
            (0,src_utils/* calcResponsiveHeight */.ku)({
                maxHeight: section === null || section === void 0 ? void 0 : (ref = section.mobile) === null || ref === void 0 ? void 0 : ref.maxHeight,
                viewport: 768
            }),
            (0,src_utils/* calcResponsiveHeight */.ku)({
                maxHeight: section === null || section === void 0 ? void 0 : (ref1 = section.desktop) === null || ref1 === void 0 ? void 0 : ref1.maxHeight,
                viewport: 1280
            }), 
        ];
    }, [
        section === null || section === void 0 ? void 0 : (ref = section.mobile) === null || ref === void 0 ? void 0 : ref.maxHeight,
        section === null || section === void 0 ? void 0 : (ref1 = section.desktop) === null || ref1 === void 0 ? void 0 : ref1.maxHeight
    ]);
    var backgroundImageSrc = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3;
        var src = [];
        if (backgroundImage === null || backgroundImage === void 0 ? void 0 : (ref = backgroundImage.mobile) === null || ref === void 0 ? void 0 : (ref1 = ref.src) === null || ref1 === void 0 ? void 0 : ref1.src) {
            src.push(backgroundImage.mobile.src.src);
        }
        if (backgroundImage === null || backgroundImage === void 0 ? void 0 : (ref2 = backgroundImage.desktop) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.src) === null || ref3 === void 0 ? void 0 : ref3.src) {
            src.push(backgroundImage.desktop.src.src);
        }
        return src;
    }, [
        backgroundImage
    ]);
    // Get padding values from the schema
    var pyMobile = (common/* padding */.o3 === null || common/* padding */.o3 === void 0 ? void 0 : (ref4 = common/* padding.value */.o3.value) === null || ref4 === void 0 ? void 0 : ref4[section === null || section === void 0 ? void 0 : (ref2 = section.heroPadding) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.mobile) === null || ref3 === void 0 ? void 0 : ref3.py]) || [
        0,
        0,
        0,
        0, 
    ];
    var pxMobile = (common/* padding */.o3 === null || common/* padding */.o3 === void 0 ? void 0 : (ref7 = common/* padding.value */.o3.value) === null || ref7 === void 0 ? void 0 : ref7[section === null || section === void 0 ? void 0 : (ref5 = section.heroPadding) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.mobile) === null || ref6 === void 0 ? void 0 : ref6.px]) || [
        0,
        0,
        0,
        0, 
    ];
    var pyDesktop = (common/* padding */.o3 === null || common/* padding */.o3 === void 0 ? void 0 : (ref10 = common/* padding.value */.o3.value) === null || ref10 === void 0 ? void 0 : ref10[section === null || section === void 0 ? void 0 : (ref8 = section.heroPadding) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.desktop) === null || ref9 === void 0 ? void 0 : ref9.py]) || [
        0,
        0,
        0,
        0, 
    ];
    var pxDesktop = (common/* padding */.o3 === null || common/* padding */.o3 === void 0 ? void 0 : (ref13 = common/* padding.value */.o3.value) === null || ref13 === void 0 ? void 0 : ref13[section === null || section === void 0 ? void 0 : (ref11 = section.heroPadding) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.desktop) === null || ref12 === void 0 ? void 0 : ref12.px]) || [
        0,
        0,
        0,
        0, 
    ];
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Section */.$0, {
        section: section,
        suppressHydrationWarning: true,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Container */.W2, {
            "data-comp": HeroValueProps.displayName,
            sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.heroValueProps), {
                height: height,
                minHeight: [
                    "".concat(section === null || section === void 0 ? void 0 : (ref14 = section.mobile) === null || ref14 === void 0 ? void 0 : ref14.minHeight, "px"),
                    "".concat(section === null || section === void 0 ? void 0 : (ref15 = section.desktop) === null || ref15 === void 0 ? void 0 : ref15.minHeight, "px"), 
                ],
                maxHeight: [
                    "".concat(section === null || section === void 0 ? void 0 : (ref16 = section.mobile) === null || ref16 === void 0 ? void 0 : ref16.maxHeight, "px"),
                    "".concat(section === null || section === void 0 ? void 0 : (ref17 = section.desktop) === null || ref17 === void 0 ? void 0 : ref17.maxHeight, "px"), 
                ],
                backgroundImage: backgroundImageSrc.map(function(src) {
                    return src && "url(".concat(src, ")");
                }),
                backgroundSize: "cover",
                backgroundPosition: [
                    (backgroundImage === null || backgroundImage === void 0 ? void 0 : (ref18 = backgroundImage.mobile) === null || ref18 === void 0 ? void 0 : ref18.position) || "center",
                    (backgroundImage === null || backgroundImage === void 0 ? void 0 : (ref19 = backgroundImage.desktop) === null || ref19 === void 0 ? void 0 : ref19.position) || "center", 
                ],
                backgroundColor: (section === null || section === void 0 ? void 0 : section.bgColor) || "transparent",
                py: [
                    (pyMobile === null || pyMobile === void 0 ? void 0 : pyMobile[0]) || 0,
                    (pyDesktop === null || pyDesktop === void 0 ? void 0 : pyDesktop[1]) || 0,
                    (pyDesktop === null || pyDesktop === void 0 ? void 0 : pyDesktop[2]) || null,
                    (pyDesktop === null || pyDesktop === void 0 ? void 0 : pyDesktop[3]) || null, 
                ],
                px: [
                    (pxMobile === null || pxMobile === void 0 ? void 0 : pxMobile[0]) || 0,
                    (pxDesktop === null || pxDesktop === void 0 ? void 0 : pxDesktop[1]) || 0,
                    (pxDesktop === null || pxDesktop === void 0 ? void 0 : pxDesktop[2]) || null,
                    (pxDesktop === null || pxDesktop === void 0 ? void 0 : pxDesktop[3]) || null, 
                ],
                overflow: [
                    "visible",
                    "hidden"
                ],
                marginBottom: [
                    "".concat(valuePropsHeight, "px"),
                    0
                ]
            }),
            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                sx: {
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    position: "relative",
                    zIndex: 1
                },
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                        sx: {
                            height: "100%",
                            alignItems: "center"
                        },
                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                            sx: {
                                maxWidth: [
                                    "100%",
                                    "50%"
                                ],
                                textAlign: "left",
                                color: (text === null || text === void 0 ? void 0 : text.color) || "white"
                            },
                            children: [
                                (text === null || text === void 0 ? void 0 : (ref20 = text.logo) === null || ref20 === void 0 ? void 0 : ref20.src) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                                    sx: {
                                        mb: 6
                                    },
                                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Image */.Ee, {
                                        src: text.logo.src,
                                        alt: ((ref21 = text.logo) === null || ref21 === void 0 ? void 0 : ref21.altText) || "logo",
                                        width: "36",
                                        height: "36",
                                        className: "w-[36px]"
                                    })
                                }),
                                (text === null || text === void 0 ? void 0 : text.superheading) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Text */.xv, {
                                    sx: {
                                        fontSize: [
                                            1,
                                            2
                                        ],
                                        fontWeight: 400,
                                        mb: 2,
                                        textTransform: "uppercase",
                                        letterSpacing: "0.1em"
                                    },
                                    children: text.superheading
                                }),
                                (text === null || text === void 0 ? void 0 : text.heading) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Text */.xv, {
                                    as: "h1",
                                    variant: text.headingOption || "text.h1",
                                    sx: {
                                        fontSize: [
                                            "".concat(text.mobileFontSize === "custom" ? text.customMobileFontSize || 44 : text.mobileFontSize || 44, "px"),
                                            "".concat(text.desktopFontSize === "custom" ? text.customDesktopFontSize || 84 : text.desktopFontSize || 84, "px"), 
                                        ],
                                        lineHeight: [
                                            "1.10",
                                            "1.10"
                                        ],
                                        mb: 3
                                    },
                                    children: text.heading
                                }),
                                (text === null || text === void 0 ? void 0 : text.subheading) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Text */.xv, {
                                    sx: {
                                        fontSize: [
                                            2,
                                            3
                                        ],
                                        fontWeight: 400,
                                        mb: 3,
                                        opacity: 0.9
                                    },
                                    children: text.subheading
                                }),
                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(SocialProofAnimation, {
                                    socialProof: socialProof
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(ValueProps, {
                        valueProps: valueProps,
                        setValuePropsHeight: setValuePropsHeight
                    })
                ]
            })
        })
    });
}), {
    triggerOnce: true
});
HeroValueProps.displayName = "HeroValueProps";
HeroValueProps.Schema = HeroValueProps_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/HeroValueProps/index.js


;// CONCATENATED MODULE: ./src/sections/Html/Html.schema.js

function Html_schema_Schema() {
    return {
        label: "Html",
        key: "html",
        fields: [
            {
                label: "HTML",
                name: "html",
                component: "html"
            },
            {
                label: "Content Settings",
                name: "content",
                description: "Content alignment, text alignment",
                component: "group",
                fields: [
                    {
                        name: "contentAlign",
                        label: "Content Alignment",
                        component: "radio-group",
                        direction: "horizontal",
                        variant: "radio",
                        options: common/* align.options */.AJ.options,
                        defaultValue: common/* align.value.left */.AJ.value.left
                    },
                    {
                        name: "textAlign",
                        label: "Text Alignment",
                        component: "radio-group",
                        direction: "horizontal",
                        variant: "radio",
                        options: common/* align.options */.AJ.options,
                        defaultValue: common/* align.value.left */.AJ.value.left
                    }, 
                ]
            },
            common/* section */.qi, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/Html/Html.theme.js


var Html_theme_themed = (0,create/* create */.U)(new function() {
    this.html = (0,_define_property/* default */.Z)({
        table: {
            width: "100%"
        },
        thead: {
            backgroundColor: "lightgrey"
        },
        "th, td": {
            py: "5px"
        },
        "tr:nth-of-type(even)": {
            backgroundColor: "#f5f5f5"
        },
        p: {
            mb: 8,
            fontFamily: "body"
        },
        "ul, ol": {
            mb: 8,
            pl: 13
        },
        ul: {
            li: {
                listStyleType: "disc"
            }
        },
        ol: {
            li: {
                listStyleType: "decimal"
            }
        },
        li: {
            p: {
                display: "inline"
            },
            mb: 4,
            listStylePosition: "inside",
            textIndent: "-22px",
            fontFamily: "body"
        },
        a: {
            textDecoration: "underline",
            fontFamily: "body"
        },
        h1: {
            variant: "text.h1",
            mb: 11
        },
        h2: {
            variant: "text.h2",
            mt: 11,
            mb: 10
        },
        h3: {
            variant: "text.h3",
            mt: [
                9,
                null,
                11
            ],
            mb: 9
        },
        h4: {
            variant: "text.h4",
            mb: 9
        },
        h5: {
            variant: "text.h5",
            mb: 9
        },
        h6: {
            variant: "text.h6",
            mb: 9
        },
        "span, del": {
            textDecorationColor: "currentColor"
        },
        strong: {
            fontWeight: "700 !important"
        },
        modal: {
            textDecoration: "underline",
            fontFamily: "body",
            cursor: "pointer"
        }
    }, "modal", {
        textDecoration: "underline",
        fontFamily: "body",
        cursor: "pointer"
    });
}());

;// CONCATENATED MODULE: ./src/sections/Html/Html.jsx








var Html = (0,src_utils/* withInView */.Dh)(Html_theme_themed(function(param) {
    var cms = param.cms, theme = param.theme;
    var content = cms.content, html = cms.html, section = cms.section;
    return html ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Section */.$0, {
        section: section,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
            sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.html), {
                textAlign: content === null || content === void 0 ? void 0 : content.textAlign,
                display: "flex",
                flexDirection: "column",
                alignItems: (content === null || content === void 0 ? void 0 : content.contentAlign) === "center" ? "center" : (content === null || content === void 0 ? void 0 : content.contentAlign) === "right" ? "flex-end" : "flex-start"
            }),
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML: {
                __html: cms.html
            }
        })
    }) : null;
}), {
    triggerOnce: true
});
Html.displayName = "Html";
Html.Schema = Html_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/Html/index.js


;// CONCATENATED MODULE: ./src/sections/Image/Image.schema.js

var Image_schema_Schema = function() {
    return {
        label: "Image",
        key: "image",
        fields: [
            {
                name: "alt",
                component: "text",
                label: "Image Alt",
                description: "Provide a brief description of the image for accessibility compliance",
                defaultValue: 'General description of what the image is without using  "an image/picture of"'
            },
            {
                label: "Mobile Settings",
                name: "mobile",
                component: "group",
                fields: [
                    {
                        name: "src",
                        label: "Image",
                        component: "image"
                    },
                    {
                        name: "position",
                        component: "select",
                        label: "Image position",
                        options: common/* position.object */.FK.object
                    },
                    {
                        name: "ratio",
                        label: "Aspect ratio",
                        component: "radio-group",
                        direction: "horizontal",
                        variant: "radio",
                        options: [
                            {
                                value: "0.75",
                                label: "3:4"
                            },
                            {
                                value: "1",
                                label: "1:1"
                            },
                            {
                                value: "1.25",
                                label: "5:4"
                            },
                            {
                                value: "1.5",
                                label: "3:2"
                            }, 
                        ]
                    },
                    {
                        name: "minHeight",
                        component: "number",
                        label: "Min pixel height (optional)"
                    },
                    {
                        name: "maxHeight",
                        component: "number",
                        label: "Max pixel height (optional)"
                    }, 
                ],
                defaultValue: {
                    src: {
                        src: "https://images.unsplash.com/photo-1508028339507-ff30e5b2d025?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=768&q=90"
                    },
                    position: "center center",
                    ratio: "1",
                    minHeight: "",
                    maxHeight: ""
                }
            },
            {
                label: "Desktop Settings",
                name: "desktop",
                component: "group",
                fields: [
                    {
                        name: "src",
                        label: "Image",
                        component: "image"
                    },
                    {
                        name: "position",
                        component: "select",
                        label: "Image position",
                        options: common/* position.object */.FK.object
                    },
                    {
                        name: "ratio",
                        label: "Aspect ratio",
                        component: "radio-group",
                        direction: "horizontal",
                        variant: "radio",
                        options: [
                            {
                                value: "1",
                                label: "1:1"
                            },
                            {
                                value: "1.25",
                                label: "5:4"
                            },
                            {
                                value: "1.5",
                                label: "3:2"
                            },
                            {
                                value: "1.75",
                                label: "7:4"
                            },
                            {
                                value: "2",
                                label: "2:1"
                            }, 
                        ]
                    },
                    {
                        name: "minHeight",
                        component: "number",
                        label: "Min pixel height (optional)"
                    },
                    {
                        name: "maxHeight",
                        component: "number",
                        label: "Max pixel height (optional)"
                    }, 
                ],
                defaultValue: {
                    src: {
                        src: "https://images.unsplash.com/photo-1508028339507-ff30e5b2d025?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=2552&q=75"
                    },
                    position: "center center",
                    ratio: "1.75",
                    minHeight: "",
                    maxHeight: ""
                }
            },
            common/* section */.qi, 
        ]
    };
};

;// CONCATENATED MODULE: ./src/sections/Image/Image.jsx






var sections_Image_Image_Image = (0,src_utils/* withInView */.Dh)(function(param) {
    var cms = param.cms;
    var ref, ref1, ref2, ref3;
    var alt = cms.alt, mobile = cms.mobile, desktop = cms.desktop, section = cms.section;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Section */.$0, {
        section: section,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Container */.W2, {
            "data-comp": sections_Image_Image_Image.displayName,
            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Picture */.t, {
                "data-comp": sections_Image_Image_Image.displayName,
                alt: alt,
                mobileRatio: (mobile === null || mobile === void 0 ? void 0 : mobile.ratio) || 1,
                desktopRatio: (desktop === null || desktop === void 0 ? void 0 : desktop.ratio) || 1.75,
                images: [
                    {
                        src: mobile === null || mobile === void 0 ? void 0 : (ref = mobile.src) === null || ref === void 0 ? void 0 : ref.src,
                        width: 768,
                        ratio: (mobile === null || mobile === void 0 ? void 0 : mobile.ratio) || 1
                    },
                    {
                        src: desktop === null || desktop === void 0 ? void 0 : (ref1 = desktop.src) === null || ref1 === void 0 ? void 0 : ref1.src,
                        width: 1024,
                        ratio: (desktop === null || desktop === void 0 ? void 0 : desktop.ratio) || 1.75
                    },
                    {
                        src: desktop === null || desktop === void 0 ? void 0 : (ref2 = desktop.src) === null || ref2 === void 0 ? void 0 : ref2.src,
                        width: 1280,
                        ratio: (desktop === null || desktop === void 0 ? void 0 : desktop.ratio) || 1.75
                    },
                    {
                        src: desktop === null || desktop === void 0 ? void 0 : (ref3 = desktop.src) === null || ref3 === void 0 ? void 0 : ref3.src,
                        width: 1440,
                        ratio: (desktop === null || desktop === void 0 ? void 0 : desktop.ratio) || 1.75
                    }, 
                ],
                imageSx: {
                    objectPosition: [
                        mobile === null || mobile === void 0 ? void 0 : mobile.position,
                        desktop === null || desktop === void 0 ? void 0 : desktop.position
                    ]
                },
                sx: {
                    minHeight: [
                        (mobile === null || mobile === void 0 ? void 0 : mobile.minHeight) || "unset",
                        (desktop === null || desktop === void 0 ? void 0 : desktop.minHeight) || "unset", 
                    ],
                    maxHeight: [
                        (mobile === null || mobile === void 0 ? void 0 : mobile.maxHeight) || "unset",
                        (desktop === null || desktop === void 0 ? void 0 : desktop.maxHeight) || "unset", 
                    ]
                }
            })
        })
    });
}, {
    triggerOnce: true
});
sections_Image_Image_Image.displayName = "Image";
sections_Image_Image_Image.Schema = Image_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/Image/index.js


;// CONCATENATED MODULE: ./src/sections/LinkFarm/LinkFarm.schema.js



function LinkFarm_schema_Schema(param) {
    var article = param.article, blog = param.blog;
    if (article || blog) return null;
    var defaultTiles = [
        {
            cta: {
                text: "Shop All",
                url: "/collections/all"
            },
            alt: "",
            image: {
                src: ""
            }
        }, 
    ];
    return {
        label: "Link Farm",
        key: "link-farm",
        fields: [
            {
                name: "tiles",
                label: "Tiles",
                description: "Max of 6 tiles",
                component: "group-list",
                itemProps: {
                    label: "{{item.cta.text}}"
                },
                defaultItem: {
                    cta: {
                        text: "Shop All",
                        url: "/collections/all"
                    },
                    alt: "",
                    image: {
                        src: ""
                    }
                },
                validate: {
                    maxItems: 6
                },
                fields: [
                    {
                        name: "borderColor",
                        label: "Border color",
                        component: "color",
                        colors: common/* color.list */.$_.list,
                        widget: "block",
                        defaultValue: common/* color.value.text */.$_.value.text
                    },
                    {
                        label: "Link",
                        name: "cta",
                        component: "link"
                    },
                    {
                        name: "alt",
                        label: "Image Alt",
                        component: "text",
                        description: "Provide a brief description of the image for accessibility compliance"
                    },
                    {
                        name: "image",
                        label: "Image",
                        component: "image",
                        parse: function(image) {
                            return image;
                        }
                    },
                    {
                        name: "hoverImage",
                        label: "Hover Image",
                        component: "image",
                        parse: function(image) {
                            return image;
                        }
                    }, 
                ],
                defaultValue: defaultTiles
            },
            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, common/* section */.qi), {
                defaultValue: {
                    bgColor: common/* color.value.background */.$_.value.background,
                    color: common/* color.value.text */.$_.value.text,
                    desktop: {
                        container: "content",
                        mt: "none",
                        py: "none"
                    },
                    mobile: {
                        container: "content",
                        mt: "none",
                        py: "none"
                    }
                }
            }), 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/LinkFarm/Slider/Slider.theme.js

var LinkFarm_Slider_Slider_theme_themed = (0,create/* create */.U)(new function() {
    this.swiper = {
        ".swiper-container": {
            cursor: [
                "grab",
                "auto"
            ]
        },
        ".swiper-container, .swiper-wrapper": {
            height: "auto !important",
            width: "100%"
        },
        ".swiper-slide": {
            height: "auto !important",
            width: "100%",
            borderRadius: "4px"
        }
    };
}());

;// CONCATENATED MODULE: ./src/sections/LinkFarm/Slider/useSliderParams.js

var useSliderParams_useSliderParams = function() {
    var defaultParams = (0,react.useMemo)(function() {
        return {
            spaceBetween: 8,
            slidesPerView: 2.75,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 16,
            slidesPerGroup: 1,
            centeredSlides: false,
            centeredSlidesBounds: true,
            centerInsufficientSlides: true,
            autoHeight: true,
            navigation: false,
            loop: false,
            watchOverflow: true,
            breakpoints: {
                480: {
                    spaceBetween: 16,
                    slidesPerView: 2.75,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 16,
                    slidesPerGroup: 1,
                    centeredSlides: false,
                    centeredSlidesBounds: true,
                    centerInsufficientSlides: true
                },
                600: {
                    spaceBetween: 16,
                    slidesPerView: 2.75,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0,
                    slidesPerGroup: 1,
                    centeredSlides: false,
                    centeredSlidesBounds: true,
                    centerInsufficientSlides: true
                },
                768: {
                    spaceBetween: 16,
                    slidesPerView: 6,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0,
                    slidesPerGroup: 1,
                    centeredSlides: false,
                    centeredSlidesBounds: false,
                    centerInsufficientSlides: true
                },
                1024: {
                    spaceBetween: 20,
                    slidesPerView: 6,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0,
                    slidesPerGroup: 1,
                    centeredSlides: false,
                    centeredSlidesBounds: false,
                    centerInsufficientSlides: true
                },
                1280: {
                    spaceBetween: 20,
                    slidesPerView: 6,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0,
                    slidesPerGroup: 1,
                    centeredSlides: false,
                    centeredSlidesBounds: false,
                    centerInsufficientSlides: true
                }
            }
        };
    }, []);
    return defaultParams;
};

;// CONCATENATED MODULE: ./src/sections/LinkFarm/Tile/Tile.theme.js

var LinkFarm_Tile_Tile_theme_themed = (0,create/* create */.U)(new function() {
    this.imageLink = function(param) {
        var isActive = param.isActive, borderColor = param.borderColor;
        return {
            position: "relative",
            ":hover": {
                img: {
                    pointerEvents: "none",
                    border: "2px solid",
                    borderColor: borderColor
                }
            },
            img: {
                borderRadius: "4px",
                border: isActive ? "2px solid" : "unset",
                borderColor: borderColor
            }
        };
    };
    this.heading = {
        position: "absolute",
        pointerEvents: "none",
        width: "100%",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        textAlign: "center",
        p: 6
    };
}());

;// CONCATENATED MODULE: ./src/sections/LinkFarm/Tile/Tile.jsx









var LinkFarm_Tile_Tile_Tile = LinkFarm_Tile_Tile_theme_themed(function(_param) {
    var theme = _param.theme, item = _param.item, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme",
        "item"
    ]);
    var ref;
    var alt = item.alt, image = item.image, hoverImage = item.hoverImage, cta = item.cta, borderColor = item.borderColor;
    var router = (0,next_router.useRouter)();
    var isActive = ((ref = router.asPath) === null || ref === void 0 ? void 0 : ref.split("?")[0]) === (cta === null || cta === void 0 ? void 0 : cta.url);
    var disableHoverMobile = (0,hooks/* useBreakpointValue */.Sx)([
        true,
        false
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-comp": LinkFarm_Tile_Tile_Tile.displayName
    }, props), {
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(snippets/* Link */.rU, {
            href: cta === null || cta === void 0 ? void 0 : cta.url,
            newTab: cta === null || cta === void 0 ? void 0 : cta.newTab,
            sx: theme.imageLink({
                isActive: isActive,
                borderColor: borderColor
            }),
            children: [
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Picture */.t, {
                    alt: alt,
                    images: [
                        {
                            src: image === null || image === void 0 ? void 0 : image.src,
                            ratio: 1.33
                        }, 
                    ],
                    hoverImages: [
                        {
                            src: hoverImage === null || hoverImage === void 0 ? void 0 : hoverImage.src,
                            ratio: 1.33
                        }, 
                    ],
                    disableHoverMobile: disableHoverMobile,
                    imageBgColor: "lightGray",
                    hoverImageBgColor: "lightGray",
                    sx: {
                        borderRadius: "4px"
                    },
                    width: image === null || image === void 0 ? void 0 : image.width,
                    height: image === null || image === void 0 ? void 0 : image.height
                }),
                (cta === null || cta === void 0 ? void 0 : cta.text) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                    variant: "text.h5",
                    sx: theme.heading,
                    children: cta === null || cta === void 0 ? void 0 : cta.text
                })
            ]
        })
    }));
});
LinkFarm_Tile_Tile_Tile.displayName = "Tile";

;// CONCATENATED MODULE: ./src/sections/LinkFarm/Tile/index.js


;// CONCATENATED MODULE: ./src/sections/LinkFarm/Slider/Slider.jsx









var Slider_Slider_Slider = LinkFarm_Slider_Slider_theme_themed(function(param) {
    var theme = param.theme, tiles = param.tiles;
    var ref = (0,react.useState)(), swiper = ref[0], setSwiper = ref[1];
    var defaultParams = useSliderParams_useSliderParams();
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Container */.W2, {
        "data-comp": Slider_Slider_Slider.displayName,
        sx: theme.swiper,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(react_swiper/* Swiper */.t, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            onSwiper: setSwiper
        }, defaultParams), {
            children: tiles === null || tiles === void 0 ? void 0 : tiles.slice(0, 6).map(function(item, index) {
                return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(swiper_slide/* SwiperSlide */.o, {
                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(LinkFarm_Tile_Tile_Tile, {
                        item: item
                    })
                }, index + 1);
            })
        }))
    });
});
Slider_Slider_Slider.displayName = "Slider";

;// CONCATENATED MODULE: ./src/sections/LinkFarm/Slider/index.js


;// CONCATENATED MODULE: ./src/sections/LinkFarm/LinkFarm.jsx







var LinkFarm = (0,src_utils/* withInView */.Dh)(function(param) {
    var cms = param.cms;
    var section = cms.section, tiles = cms.tiles;
    var ref = (0,react.useState)(false), loaded = ref[0], setLoaded = ref[1];
    (0,react.useEffect)(function() {
        setLoaded(true);
        return function() {
            setLoaded(false);
        };
    }, []);
    return loaded && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Section */.$0, {
        section: section,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Container */.W2, {
            "data-comp": LinkFarm.displayName,
            children: (tiles === null || tiles === void 0 ? void 0 : tiles.length) > 0 && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Slider_Slider_Slider, {
                tiles: tiles
            })
        })
    });
}, {
    triggerOnce: true
});
LinkFarm.displayName = "LinkFarm";
LinkFarm.Schema = LinkFarm_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/LinkFarm/index.js


;// CONCATENATED MODULE: ./src/sections/Locator/Locator.schema.js



function Locator_schema_Schema(param) {
    var page = param.page;
    if (!page) return null;
    return {
        label: "Locator",
        key: "locator",
        fields: [
            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, common/* section */.qi), {
                defaultValue: {
                    desktop: {
                        container: "container",
                        mt: "none"
                    },
                    mobile: {
                        container: "container",
                        mt: "none"
                    }
                }
            }), 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/Locator/Locator.jsx




var Locator = (0,src_utils/* withInView */.Dh)(function(param) {
    var cms = param.cms;
    var section = cms.section;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Section */.$0, {
        "data-comp": Locator.displayName,
        section: section,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* StoreLocator */.N$, {})
    });
}, {
    triggerOnce: true
});
Locator.displayName = "Locator";
Locator.Schema = Locator_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/Locator/index.js


// EXTERNAL MODULE: ../node_modules/next/script.js
var script = __webpack_require__(43218);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./src/sections/MalomoTracking/Content/Content.theme.js


var MalomoTracking_Content_Content_theme_themed = (0,create/* create */.U)(new function() {
    this.outer = {
        width: "100%",
        justifyContent: "center",
        alignItems: [
            "flex-start",
            "center"
        ],
        px: 12,
        py: [
            18,
            16
        ],
        "@media only screen and (max-width: 479px)": {
            py: 15
        }
    };
    this.superheading = {
        variant: "text.label.1",
        mb: 2
    };
    this.heading = {
        variant: "text.h2"
    };
    this.bodyWithoutHeading = {
        variant: "text.base",
        mt: 0,
        ul: {
            ml: 0
        },
        "p:last-of-type": {
            mb: 0
        }
    };
    this.bodyWithHeading = (0,_object_spread/* default */.Z)({}, this.bodyWithoutHeading);
}());

;// CONCATENATED MODULE: ./src/sections/MalomoTracking/Content/Content.jsx







var MalomoTracking_Content_Content_Content = MalomoTracking_Content_Content_theme_themed(function(param) {
    var theme = param.theme, content = param.content;
    var ref, ref1, ref2, ref3;
    var color = (0,_object_spread/* default */.Z)({}, content).color;
    var textAlign = [
        content === null || content === void 0 ? void 0 : content.alignment,
        content === null || content === void 0 ? void 0 : content.alignmentDt
    ];
    var flexAlign = textAlign.map(function(align) {
        return (0,utils_common/* convertAlignToFlex */.nG)(align);
    });
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
        "data-comp": MalomoTracking_Content_Content_Content.displayName,
        sx: (0,_object_spread/* default */.Z)({}, theme.outer),
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
            sx: {
                variant: "flex.column",
                width: "100%",
                maxWidth: [
                    "600px",
                    "450px"
                ],
                alignItems: flexAlign
            },
            children: [
                (content === null || content === void 0 ? void 0 : content.superheading) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.superheading), {
                        textAlign: textAlign,
                        color: color
                    }),
                    children: content.superheading
                }),
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.heading), {
                        textAlign: textAlign,
                        color: color
                    }),
                    children: content === null || content === void 0 ? void 0 : content.heading
                }),
                (content === null || content === void 0 ? void 0 : content.body) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Markdown */.UG, {
                    text: content.body,
                    sx: (0,_object_spread/* default */.Z)({
                        color: color
                    }, (content === null || content === void 0 ? void 0 : content.heading) ? theme.bodyWithHeading : theme.bodyWithoutHeading),
                    textSx: {
                        textAlign: textAlign
                    }
                }),
                (content === null || content === void 0 ? void 0 : (ref = content.cta) === null || ref === void 0 ? void 0 : ref.text) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Link */.rU, {
                    variant: "buttons.".concat((content === null || content === void 0 ? void 0 : content.ctaStyle) || "secondary"),
                    href: content === null || content === void 0 ? void 0 : (ref1 = content.cta) === null || ref1 === void 0 ? void 0 : ref1.url,
                    newTab: content === null || content === void 0 ? void 0 : (ref2 = content.cta) === null || ref2 === void 0 ? void 0 : ref2.newTab,
                    sx: {
                        mt: (content === null || content === void 0 ? void 0 : content.heading) || (content === null || content === void 0 ? void 0 : content.body) ? [
                            10,
                            11
                        ] : 0,
                        alignSelf: flexAlign,
                        color: (content === null || content === void 0 ? void 0 : content.ctaStyle) === "articleLink" || (content === null || content === void 0 ? void 0 : content.ctaStyle) === "groupText" ? color : null,
                        "&::after, &::before": {
                            backgroundColor: (content === null || content === void 0 ? void 0 : content.ctaStyle) === "articleLink" || (content === null || content === void 0 ? void 0 : content.ctaStyle) === "groupText" ? color : "currentColor"
                        },
                        "&:hover": {
                            color: (content === null || content === void 0 ? void 0 : content.ctaStyle) === "articleLink" || (content === null || content === void 0 ? void 0 : content.ctaStyle) === "groupText" ? color : "currentColor"
                        }
                    },
                    children: content === null || content === void 0 ? void 0 : (ref3 = content.cta) === null || ref3 === void 0 ? void 0 : ref3.text
                })
            ]
        })
    });
});
MalomoTracking_Content_Content_Content.displayName = "Content";

;// CONCATENATED MODULE: ./src/sections/MalomoTracking/Content/index.js


;// CONCATENATED MODULE: ./src/sections/MalomoTracking/Image/Image.theme.js

var MalomoTracking_Image_Image_theme_themed = (0,create/* create */.U)(new function() {
    this.image = {
        position: "absolute",
        width: "100%",
        height: "100%",
        top: 0,
        left: 0,
        bottom: 0,
        right: 0
    };
}());

;// CONCATENATED MODULE: ./src/sections/MalomoTracking/Image/Image.jsx



var MalomoTracking_Image_Image_Image = MalomoTracking_Image_Image_theme_themed(function(param) {
    var theme = param.theme, image = param.image;
    var ref, ref1, ref2, ref3;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Picture */.t, {
        "data-comp": MalomoTracking_Image_Image_Image.displayName,
        alt: image === null || image === void 0 ? void 0 : image.alt,
        images: [
            {
                src: image === null || image === void 0 ? void 0 : (ref = image.image) === null || ref === void 0 ? void 0 : ref.src,
                width: 768,
                ratio: 1
            },
            {
                src: image === null || image === void 0 ? void 0 : (ref1 = image.imageDt) === null || ref1 === void 0 ? void 0 : ref1.src,
                width: 512,
                ratio: 1
            },
            {
                src: image === null || image === void 0 ? void 0 : (ref2 = image.imageDt) === null || ref2 === void 0 ? void 0 : ref2.src,
                width: 640,
                ratio: 1
            },
            {
                src: image === null || image === void 0 ? void 0 : (ref3 = image.imageDt) === null || ref3 === void 0 ? void 0 : ref3.src,
                width: 720,
                ratio: 1
            }, 
        ],
        imageSx: {
            objectPosition: [
                image === null || image === void 0 ? void 0 : image.position,
                image === null || image === void 0 ? void 0 : image.positionDt
            ]
        },
        sx: theme.image
    });
});
MalomoTracking_Image_Image_Image.displayName = "Image";

;// CONCATENATED MODULE: ./src/sections/MalomoTracking/Image/index.js


;// CONCATENATED MODULE: ./src/sections/MalomoTracking/MalomoTracking.theme.js

var MalomoTracking_theme_themed = (0,create/* create */.U)(new function() {
    this.grid = {
        display: "grid",
        position: "relative",
        gridGap: 0,
        gridTemplateColumns: [
            "1fr",
            "1fr 1fr"
        ]
    };
    this.media = {
        gridArea: "media",
        position: "relative",
        width: "100%",
        height: "100%",
        overflow: "hidden"
    };
    this.content = {
        gridArea: "content",
        display: "flex",
        position: "relative",
        width: "100%",
        height: "100%"
    };
}());

;// CONCATENATED MODULE: ./src/sections/MalomoTracking/MalomoTracking.schema.js

function MalomoTracking_schema_Schema(param) {
    var page = param.page;
    if ((page === null || page === void 0 ? void 0 : page.handle) !== "track-my-order" && (page === null || page === void 0 ? void 0 : page.handle) !== "track-my-order2") return null;
    return {
        label: "Malomo Tracking",
        key: "malomo",
        fields: [
            {
                label: "Image Settings",
                name: "image",
                description: "Image, alt text",
                component: "group",
                fields: [
                    {
                        label: "Image Alt",
                        name: "alt",
                        component: "text",
                        description: "Provide a brief description of the image for accessibility compliance"
                    },
                    {
                        name: "imageDt",
                        label: "Image (desktop)",
                        component: "image"
                    },
                    {
                        label: "Image (mobile)",
                        name: "image",
                        component: "image"
                    }, 
                ],
                defaultValue: {
                    alt: "A Woman sitting on a couch with a Hopsulator slim in her hand.",
                    image: {
                        src: "https://cdn.shopify.com/s/files/1/1114/2308/files/FirstCanCooler.png"
                    },
                    imageDt: {
                        src: "https://cdn.shopify.com/s/files/1/1114/2308/files/FirstCanCooler.png"
                    }
                }
            },
            {
                label: "Media Settings",
                name: "media",
                description: "Position, placement, aspect ratio",
                component: "group",
                fields: [
                    {
                        label: "Media position",
                        name: "positionDt",
                        component: "select",
                        options: common/* position.object */.FK.object
                    },
                    {
                        label: "Placement (desktop)",
                        component: "radio-group",
                        direction: "horizontal",
                        variant: "radio",
                        name: "locationDt",
                        options: [
                            {
                                value: "left",
                                label: "Left"
                            },
                            {
                                value: "right",
                                label: "Right"
                            }, 
                        ]
                    },
                    {
                        label: "Aspect ratio (desktop)",
                        name: "ratioDt",
                        component: "radio-group",
                        description: "Only applies to images and video files not already set to 1:1 ratio",
                        direction: "horizontal",
                        variant: "radio",
                        options: [
                            {
                                value: "80%",
                                label: "5:4"
                            },
                            {
                                value: "100%",
                                label: "1:1"
                            },
                            {
                                value: "120%",
                                label: "5:6"
                            }, 
                        ]
                    },
                    {
                        label: "Media position (mobile)",
                        name: "position",
                        component: "select",
                        options: common/* position.object */.FK.object
                    },
                    {
                        label: "Placement (mobile)",
                        name: "location",
                        component: "radio-group",
                        direction: "horizontal",
                        variant: "radio",
                        options: [
                            {
                                value: "top",
                                label: "Top"
                            },
                            {
                                value: "bottom",
                                label: "Bottom"
                            }, 
                        ]
                    },
                    {
                        label: "Aspect ratio (mobile)",
                        component: "radio-group",
                        description: "Only applies to images and video files not already set to 1:1 ratio",
                        direction: "horizontal",
                        variant: "radio",
                        name: "ratio",
                        options: [
                            {
                                value: "80%",
                                label: "5:4"
                            },
                            {
                                value: "100%",
                                label: "1:1"
                            },
                            {
                                value: "120%",
                                label: "5:6"
                            }, 
                        ]
                    }, 
                ],
                defaultValue: {
                    location: "top",
                    locationDt: "left",
                    ratio: "100%",
                    ratioDt: "100%",
                    position: "center center",
                    positionDt: "center center"
                }
            },
            {
                label: "Content Settings",
                name: "content",
                description: "Heading, superheading body, link, content alignment",
                component: "group",
                fields: [
                    {
                        label: "Heading",
                        name: "heading",
                        component: "text"
                    },
                    {
                        label: "Superheading",
                        name: "superheading",
                        component: "text"
                    },
                    {
                        label: "Body",
                        name: "body",
                        component: "markdown"
                    },
                    {
                        label: "Link",
                        name: "cta",
                        component: "link"
                    },
                    {
                        name: "ctaStyle",
                        label: "Link Style",
                        component: "select",
                        options: common/* button.options */.LI.options
                    },
                    {
                        name: "color",
                        label: "Color",
                        component: "color"
                    },
                    {
                        label: "Content alignment (mobile)",
                        name: "alignment",
                        component: "radio-group",
                        direction: "horizontal",
                        variant: "radio",
                        options: common/* align.options */.AJ.options
                    },
                    {
                        label: "Content alignment (desktop)",
                        name: "alignmentDt",
                        component: "radio-group",
                        direction: "horizontal",
                        variant: "radio",
                        options: common/* align.options */.AJ.options
                    }, 
                ],
                defaultValue: {
                    heading: "THE WORLD'S FIRST SLIM CAN COOLER.",
                    body: "The Hopsulator Slim keeps all of your\n          favorite 12oz slim canned beverages icy-\n          cold, no matter how hot the party gets.\n* Works with all 12oz Slim Cans\n* Works with all 12oz Slim Cans\n* Works with all 12oz Slim Cans\n* Works with all 12oz Slim Cans",
                    ctaStyle: common/* button.value.secondary */.LI.value.secondary,
                    alignment: common/* align.value.left */.AJ.value.left,
                    alignmentDt: common/* align.value.left */.AJ.value.left
                }
            },
            common/* section */.qi, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/MalomoTracking/MalomoTracking.jsx











var MalomoTracking = MalomoTracking_theme_themed(function(param) {
    var cms = param.cms, theme = param.theme;
    var section = cms.section, content = cms.content, image = cms.image, media = cms.media;
    var ref = (0,react.useState)(false), scriptLoaded = ref[0], setScriptLoaded = ref[1];
    var ref1 = (0,react.useState)(false), init = ref1[0], setInit = ref1[1];
    var ref2 = (0,react.useState)(false), orderFound = ref2[0], setOrderFound = ref2[1];
    var mediaLeft = (media === null || media === void 0 ? void 0 : media.locationDt) === "left"; // mobile
    var mediaTop = (media === null || media === void 0 ? void 0 : media.location) === "top"; // desktop
    (0,react.useEffect)(function() {
        var checkForMalomoScript = setInterval(function() {
            if (typeof window.Malomo === "function") {
                setScriptLoaded(true);
                clearInterval(checkForMalomoScript);
            }
        }, 100);
    }, []);
    (0,react.useEffect)(function() {
        if (!scriptLoaded || init) return;
        var Malomo = window.Malomo;
        var apiKey = "".concat("pk_dc4b7fddc52b0bc87a0cbc1167ee26fc");
        var mountPoint = "#shipment-tracker";
        var malomo = Malomo(apiKey);
        var elements = malomo.elements();
        window.addEventListener("malomo-order.found", function() {
            setOrderFound(true);
        });
        setInit(true);
        malomo.fetchOrder().then(function(order) {
            if (order) {
                window.dispatchEvent(new Event("malomo-order.found"));
            }
            return elements.create("shipmentTracker", {
                order: order,
                carrierInfo: {
                    linkToCarrier: true
                }
            }).mount(mountPoint);
        }).catch(function() {
            return elements.create("orderLookup", {
                callback: function(resp) {
                    var url = new URL(document.URL);
                    url.searchParams.append("_m_id", resp.body.id);
                    window.location.href = url;
                }
            }).mount(mountPoint);
        });
    }, [
        scriptLoaded
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(snippets/* Section */.$0, {
        section: section,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)((script_default()), {
                id: "malomo-script",
                type: "text/javascript",
                src: "https://js.gomalomo.com/v2/"
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Container */.W2, {
                sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.grid), {
                    gridTemplateAreas: [
                        mediaTop ? '"media" "content"' : '"content" "media"',
                        mediaLeft ? '"media content"' : '"content media"', 
                    ]
                }),
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                        sx: {
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: [
                                "center",
                                "flex-start"
                            ],
                            width: [
                                "100%",
                                null,
                                "500px"
                            ],
                            mx: "auto",
                            height: "100%",
                            py: orderFound ? [
                                12,
                                0
                            ] : [
                                12,
                                40
                            ],
                            px: [
                                10,
                                14
                            ]
                        },
                        children: [
                            !orderFound && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                                as: "h3",
                                variant: "text.h3",
                                sx: {
                                    mb: "1.5rem"
                                },
                                children: "Track Your Order"
                            }),
                            scriptLoaded && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                                id: "shipment-tracker",
                                sx: {
                                    ".malomo-order-lookup-error-message": {
                                        color: "red"
                                    },
                                    ".malomo-shipment-tracker-latest-activity, .malomo-shipment-tracker-most-recent-event": {
                                        variant: "text.label.1"
                                    },
                                    ".malomo-shipment-tracker-event": {
                                        py: 6
                                    },
                                    ".malomo-shipment-tracker-event-location-city + .malomo-shipment-tracker-event-location-state::before": {
                                        content: '", "'
                                    },
                                    ".malomo-shipment-tracker-event-location": {
                                        variant: "text.label.1",
                                        textTransform: "capitalize",
                                        ml: 6
                                    },
                                    ".malomo-shipment-tracker-header": {
                                        textAlign: [
                                            "center",
                                            "left"
                                        ]
                                    },
                                    ".malomo-shipment-tracker-status-message": {
                                        variant: "text.h2",
                                        fontFamily: "heading",
                                        fontWeight: 600,
                                        textTransform: "capitalize",
                                        mb: [
                                            8,
                                            4
                                        ]
                                    },
                                    ".malomo-order-lookup-number-label": {
                                        display: "block",
                                        variant: "text.label.2",
                                        position: "absolute",
                                        transformOrigin: "top left",
                                        transform: "translate(0px, 4px) ",
                                        width: "auto",
                                        px: 10,
                                        color: "text",
                                        pointerEvents: "none"
                                    },
                                    ".malomo-order-lookup-number-input": {
                                        display: "block",
                                        variant: "text.lg",
                                        borderRadius: 50,
                                        height: "46px",
                                        border: function(t) {
                                            return "1px solid ".concat(t.colors.mediumGray);
                                        },
                                        width: "100%",
                                        minWidth: [
                                            "250px",
                                            "350px"
                                        ],
                                        px: 10,
                                        mt: 4,
                                        pt: 8,
                                        pb: 2,
                                        color: "text"
                                    },
                                    ".malomo-order-lookup-customer-email-label": {
                                        display: "block",
                                        variant: "text.label.2",
                                        position: "absolute",
                                        transformOrigin: "top left",
                                        transform: "translate(0px, 4px) ",
                                        width: "auto",
                                        px: 10,
                                        color: "text",
                                        pointerEvents: "none"
                                    },
                                    ".malomo-order-lookup-customer-email-input": {
                                        display: "block",
                                        variant: "text.lg",
                                        borderRadius: 50,
                                        height: "46px",
                                        border: function(t) {
                                            return "1px solid ".concat(t.colors.mediumGray);
                                        },
                                        width: "100%",
                                        minWidth: [
                                            "250px",
                                            "350px"
                                        ],
                                        px: 10,
                                        mt: 4,
                                        pt: 8,
                                        pb: 2,
                                        color: "text"
                                    },
                                    ".malomo-order-lookup-section-separator": {
                                        display: "flex",
                                        variant: "text.h5",
                                        mx: "auto",
                                        alignSelf: "center",
                                        justifyContent: "center",
                                        my: 8
                                    },
                                    ".malomo-order-lookup-tracking-number-label": {
                                        display: "block",
                                        variant: "text.label.2",
                                        position: "absolute",
                                        transformOrigin: "top left",
                                        transform: "translate(0px, 4px) ",
                                        width: "auto",
                                        px: 10,
                                        color: "text",
                                        pointerEvents: "none"
                                    },
                                    ".malomo-order-lookup-tracking-number-input": {
                                        display: "block",
                                        variant: "text.lg",
                                        borderRadius: 50,
                                        height: "46px",
                                        border: function(t) {
                                            return "1px solid ".concat(t.colors.mediumGray);
                                        },
                                        width: "100%",
                                        minWidth: [
                                            "250px",
                                            "350px"
                                        ],
                                        px: 10,
                                        mt: 4,
                                        pt: 8,
                                        pb: 2,
                                        color: "text"
                                    },
                                    ".malomo-order-lookup-submit-button": {
                                        variant: "buttons.primary",
                                        textTransform: "capitalize",
                                        mt: 12,
                                        width: "100%",
                                        mx: "auto",
                                        px: 10
                                    },
                                    ".malomo-shipment-tracker-delivered-message": {
                                        variant: "text.label.2"
                                    },
                                    ".malomo-shipment-tracker-delivered-message a": {
                                        textDecoration: "underline"
                                    },
                                    ".malomo-shipment-tracker-delivered-message-close": {
                                        cursor: "pointer"
                                    },
                                    ".malomo-shipment-tracker-delivered-message-header": {
                                        alignItems: "center",
                                        display: "flex"
                                    },
                                    " .malomo-shipment-tracker-delivered-message-title": {
                                        flex: 1
                                    },
                                    ".malomo-shipment-tracker-events": {
                                        height: "400px",
                                        overflow: "hidden",
                                        overflowY: "scroll"
                                    },
                                    ".malomo-shipment-tracker-events-backdrop": {
                                        alignItems: "center",
                                        backgroundColor: " rgba(0, 0, 0, 0.65)",
                                        display: "flex",
                                        height: "100vh",
                                        justifyContent: "center",
                                        position: "fixed",
                                        zIndex: 1,
                                        left: 0,
                                        top: 0,
                                        width: "100%"
                                    },
                                    ".malomo-shipment-tracker-events-header": {
                                        display: "flex",
                                        pt: 11,
                                        pb: 6
                                    },
                                    ".malomo-shipment-tracker-events-header-label": {
                                        variant: "text.h5"
                                    },
                                    " .malomo-shipment-tracker-events-header-close": {
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        width: "100%"
                                    },
                                    ".malomo-shipment-tracker-events-header-close-icon": {
                                        cursor: "pointer",
                                        width: "20px"
                                    },
                                    ".malomo-shipment-tracker-events-modal": {
                                        backgroundColor: " #fff",
                                        width: "600px",
                                        borderRadius: "3px",
                                        px: 11,
                                        overflow: "auto"
                                    },
                                    ".malomo-shipment-tracker-history-control": {
                                        variant: "buttons.primary",
                                        textTransform: [
                                            "uppercase",
                                            "capitalize"
                                        ],
                                        textDecoration: [
                                            null,
                                            "underline"
                                        ],
                                        justifyContent: "center",
                                        mt: 6,
                                        cursor: "pointer",
                                        width: "100%",
                                        "@media only screen and (min-width: 767px)": {
                                            fontSize: 1,
                                            display: "inline",
                                            backgroundColor: "transparent",
                                            border: "none",
                                            color: "black",
                                            p: 0,
                                            width: "auto",
                                            "&:hover": {
                                                backgroundColor: "transparent"
                                            }
                                        }
                                    },
                                    ".malomo-shipment-tracker-carrier-info": {
                                        display: "flex",
                                        justifyContent: [
                                            "center",
                                            "flex-start"
                                        ],
                                        borderTop: [
                                            null,
                                            "1px solid #e3ebf6"
                                        ],
                                        pt: 4,
                                        mx: "-24px",
                                        px: 11,
                                        mt: 8,
                                        mb: "-12px"
                                    },
                                    ".malomo-shipment-tracker-carrier-info-tracking-code, .malomo-shipment-tracker-carrier-info-tracking-code-link": {
                                        variant: "text.label.1",
                                        textDecoration: "underline",
                                        letterSpacing: "0.5px"
                                    },
                                    ".malomo-shipment-tracker-carrier-info-image": {
                                        maxHeight: "20px",
                                        maxWidth: "64px",
                                        mr: "4px"
                                    },
                                    ".malomo-shipment-tracker-modal-open": {
                                        overflow: "hidden"
                                    },
                                    ".malomo-shipment-tracker-selector-items": {
                                        justifyContent: [
                                            "center",
                                            "flex-start"
                                        ],
                                        mb: "5px",
                                        mt: 0
                                    },
                                    ".malomo-shipment-tracker-selector-counter": {
                                        variant: "text.label.1",
                                        mb: "5px"
                                    },
                                    ".malomo-shipment-tracker-return-actions": {
                                        mt: "16px"
                                    },
                                    ".malomo-shipment-tracker-event-timestamp-date, .malomo-shipment-tracker-event-message": {
                                        variant: "text.label.1"
                                    },
                                    ".malomo-shipment-tracker-event-timestamp-time": {
                                        variant: "text.label.1",
                                        color: "rgba(18, 38, 63, .7)",
                                        ml: 2
                                    }
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.media), {
                            minHeight: orderFound ? [
                                null,
                                "500px"
                            ] : null
                        }),
                        children: [
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(MalomoTracking_Image_Image_Image, {
                                image: image
                            }),
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                                sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.content), {
                                    justifyContent: mediaLeft ? "flex-start" : "flex-end",
                                    ":before": {
                                        content: '""',
                                        float: "left"
                                    }
                                }),
                                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(MalomoTracking_Content_Content_Content, {
                                    content: content
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
});
MalomoTracking.displayName = "MalomoTracking";
MalomoTracking.Schema = MalomoTracking_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/MalomoTracking/index.js


;// CONCATENATED MODULE: ./src/sections/Markdown/Markdown.schema.js

var Markdown_schema_Schema = function() {
    return {
        label: "Markdown",
        key: "markdown",
        fields: [
            {
                name: "body",
                component: "markdown",
                label: "Body",
                defaultValue: "I am a text field with *italic* __bold__ and other powers..."
            },
            {
                label: "Text Settings",
                name: "text",
                description: "Text align",
                component: "group",
                fields: [
                    {
                        name: "textAlign",
                        label: "Text align",
                        component: "radio-group",
                        direction: "horizontal",
                        variant: "radio",
                        options: common/* align.options */.AJ.options,
                        defaultValue: common/* align.value.left */.AJ.value.left
                    }, 
                ]
            },
            common/* section */.qi, 
        ]
    };
};

;// CONCATENATED MODULE: ./src/sections/Markdown/Markdown.jsx



function Markdown(param) {
    var cms = param.cms;
    var body = cms.body, text = cms.text, section = cms.section;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Section */.$0, {
        section: section,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Markdown */.UG, {
            text: body,
            textAlign: text === null || text === void 0 ? void 0 : text.textAlign
        })
    });
}
Markdown.displayName = "Markdown";
Markdown.Schema = Markdown_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/Markdown/index.js


;// CONCATENATED MODULE: ./src/sections/PressSlider/PressSlider.schema.js



function PressSlider_schema_Schema(param) {
    var article = param.article, blog = param.blog, collection = param.collection;
    if (article || blog || collection) return null;
    var defaultEntries = [
        {
            name: "Bustle",
            logo: {
                src: "https://cdn.shopify.com/s/files/1/1114/2308/files/bustleLogo.svg"
            },
            quote: "Bustle short quote about how much they enjoy Brumate."
        },
        {
            name: "Business Insider",
            logo: {
                src: "https://cdn.shopify.com/s/files/1/1114/2308/files/BILogo.svg"
            },
            quote: "Business Insider quote helping build trust with the Brumate brand."
        },
        {
            name: "ABC News",
            logo: {
                src: "https://cdn.shopify.com/s/files/1/1114/2308/files/abcNewsLogo.svg"
            },
            quote: "ABC News review quote regarding Brumate. 5 out of 5 stars."
        },
        {
            name: "Romper",
            logo: {
                src: "https://cdn.shopify.com/s/files/1/1114/2308/files/romper-logo-vector.svg"
            },
            quote: "Sipping wine on your balcony or deck just got a little better."
        },
        {
            name: "Entrepreneur Magazine",
            logo: {
                src: "https://cdn.shopify.com/s/files/1/1114/2308/files/entrepreneur.svg"
            },
            quote: "Entrepreneur Magazine quote about Brumate goes here."
        },
        {
            name: "Forbes",
            logo: {
                src: "https://cdn.shopify.com/s/files/1/1114/2308/files/forbeslogo.svg"
            },
            quote: "Forbes quote about Brumate appears in this space."
        }, 
    ];
    return {
        label: "Press Slider",
        key: "press-slider",
        description: "A slider of press quotes and logos used as navigation.",
        fields: [
            {
                label: "Entries",
                name: "entries",
                component: "group-list",
                description: "Max of 6 entries",
                itemProps: {
                    label: "{{item.name}}" || 0
                },
                fields: [
                    {
                        name: "name",
                        label: "Logo name",
                        description: "Provide a brief description of the logo for accessibility compliance",
                        component: "text"
                    },
                    {
                        name: "logo",
                        label: "Logo",
                        component: "image",
                        description: "Upload or select a SVG logo for the entry"
                    },
                    {
                        name: "quote",
                        label: "Quote",
                        component: "textarea",
                        description: "Works best with a short sentence or two. Opening and closing quotation marks are added automatically"
                    }, 
                ],
                defaultValue: defaultEntries
            },
            {
                name: "Settings",
                label: "Slider Settings",
                component: "group",
                description: "Loop, Transition effect & speed",
                fields: [
                    {
                        name: "loop",
                        label: "Loop (mobile)",
                        component: "toggle",
                        description: "Loop back to the first logo slide when the lasts slide is reached on mobile navigation.",
                        toggleLabels: {
                            true: "Enable",
                            false: "Disable (default)"
                        }
                    },
                    {
                        name: "speed",
                        label: "Transition speed",
                        component: "number",
                        description: "The time in milliseconds it takes to transition from one slide to another when navigating (default: 300)"
                    }, 
                ],
                defaultValue: {
                    loop: false,
                    speed: 300
                }
            },
            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, common/* section */.qi), {
                defaultValue: {
                    bgColor: common/* color.value.background */.$_.value.background,
                    color: common/* color.value.text */.$_.value.text,
                    desktop: {
                        container: "container",
                        mt: "none",
                        py: "m"
                    },
                    mobile: {
                        container: "container",
                        mt: "none",
                        py: "m"
                    }
                }
            }), 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/PressSlider/PressSlider.theme.js

var PressSlider_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        minHeight: [
            190,
            330
        ]
    };
}());

// EXTERNAL MODULE: ../node_modules/swiper/esm/components/a11y/a11y.js
var a11y = __webpack_require__(15753);
;// CONCATENATED MODULE: ./src/sections/PressSlider/Slider/useSliderParams.js

var Slider_useSliderParams_useSliderParams = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        isLogo: false
    }, isLogo = ref.isLogo, logoCount = ref.logoCount, customParams = ref.customParams;
    var quoteParams = (0,react.useMemo)(function() {
        return {
            allowTouchMove: false,
            navigation: false,
            slidesPerView: 1,
            effect: "slide",
            loop: false
        };
    }, []);
    var logoParams = (0,react.useMemo)(function() {
        return {
            speed: (customParams === null || customParams === void 0 ? void 0 : customParams.speed) || 300,
            loop: (customParams === null || customParams === void 0 ? void 0 : customParams.loop) || false,
            slidesPerView: 2.7,
            spaceBetween: 30,
            effect: "slide",
            freeMode: false,
            autoplay: false,
            breakpoints: {
                370: {
                    slidesPerView: 2.7,
                    spaceBetween: 30,
                    freeMode: true,
                    autoplay: false
                },
                768: {
                    slidesPerView: 3.7,
                    spaceBetween: 30,
                    autoplay: false,
                    freeMode: true
                },
                1024: {
                    slidesPerView: logoCount,
                    allowTouchMove: false,
                    allowSlideNext: false,
                    allowSlidePrev: false,
                    spaceBetween: 30,
                    freeMode: false,
                    autoplay: false
                },
                1280: {
                    slidesPerView: logoCount,
                    allowTouchMove: false,
                    allowSlideNext: false,
                    allowSlidePrev: false,
                    spaceBetween: 30,
                    freeMode: false,
                    autoplay: false
                }
            }
        };
    }, []);
    return isLogo ? logoParams : quoteParams;
};

;// CONCATENATED MODULE: ./src/sections/PressSlider/Slider/Slider.theme.js

var PressSlider_Slider_Slider_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-around",
        alignItems: "center",
        alignContent: "center",
        minHeight: [
            115,
            220
        ],
        ".swiper-slide-active": {
            display: "flex",
            flexDirection: "row",
            justifyContent: "center"
        }
    };
    this.swiper = {
        width: "100%",
        textAlign: "center"
    };
    this.slide = {
        display: "flex",
        minHeight: [
            115,
            170
        ],
        flexDirection: "column",
        justifyContent: "center"
    };
    this.quote = {
        variant: "text.promoQuote",
        width: [
            "auto",
            750
        ],
        px: [
            7,
            0
        ],
        ":before": {
            content: "open-quote"
        },
        ":after": {
            content: "close-quote"
        }
    };
}());

;// CONCATENATED MODULE: ./src/sections/PressSlider/Slider/Navigation.theme.js

var Navigation_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        width: [
            "100%",
            940
        ],
        mt: [
            8,
            11
        ],
        ".swiper-wrapper": {
            flexDirection: [
                "unset",
                "row"
            ],
            justifyContent: [
                "unset",
                "center"
            ],
            alignContent: [
                "unset",
                "center"
            ],
            alignItems: [
                "unset",
                "center"
            ]
        }
    };
    this.slide = {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignContent: "center",
        alignItems: "center",
        cursor: "pointer",
        overflow: "hidden",
        ":hover": {
            opacity: [
                "unset",
                1
            ],
            transition: [
                "unset",
                "opacity .4s ease-in-out"
            ]
        }
    };
    this.logo = {
        height: 40,
        pb: 8,
        ":hover": {
            borderBottom: [
                "unset",
                "1px solid black"
            ],
            transition: [
                "unset",
                "border-bottom .4s linear"
            ]
        }
    };
}());

;// CONCATENATED MODULE: ./src/sections/PressSlider/Slider/Navigation.jsx










core_class/* default.use */.Z.use([
    a11y/* default */.Z
]);
var Navigation = Navigation_theme_themed(function(param) {
    var theme = param.theme, slider = param.slider, entries = param.entries, activeIndex = param.activeIndex, _isLogo = param.isLogo, isLogo = _isLogo === void 0 ? true : _isLogo, setActiveIndex = param.setActiveIndex, _customParams = param.customParams, customParams = _customParams === void 0 ? {} : _customParams;
    if (entries.length == 0) return null;
    var logoCount = entries === null || entries === void 0 ? void 0 : entries.length;
    var defaultParams = Slider_useSliderParams_useSliderParams({
        isLogo: isLogo,
        logoCount: logoCount,
        customParams: customParams
    });
    var ref = (0,react.useState)(), navigationSwiper = ref[0], setNavigationSwiper = ref[1];
    var changeSlide = (0,react.useCallback)(function(index) {
        if (!slider) return;
        setActiveIndex(index);
        return slider.slideTo(activeIndex);
    }, [
        slider
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
        sx: theme.wrapper,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(react_swiper/* Swiper */.t, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            onSwiper: setNavigationSwiper
        }, defaultParams), {
            children: entries.map(function(entry, index) {
                var ref, ref1;
                if (!(entry === null || entry === void 0 ? void 0 : (ref = entry.logo) === null || ref === void 0 ? void 0 : ref.src)) return null;
                var isActive = index === activeIndex;
                return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(swiper_slide/* SwiperSlide */.o, {
                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                        "aria-selected": isActive,
                        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.slide), {
                            opacity: isActive ? 1 : 0.5
                        }),
                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                            variant: "buttons.plain",
                            onClick: function() {
                                changeSlide(index);
                            },
                            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Svg */.ny, {
                                src: entry === null || entry === void 0 ? void 0 : (ref1 = entry.logo) === null || ref1 === void 0 ? void 0 : ref1.src,
                                alt: entry === null || entry === void 0 ? void 0 : entry.name,
                                sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.logo), {
                                    borderBottom: isActive ? "1px solid black" : "none"
                                })
                            })
                        })
                    })
                }, entry === null || entry === void 0 ? void 0 : entry.name);
            })
        }))
    });
});
Navigation.displayName = "Navigation";

;// CONCATENATED MODULE: ./src/sections/PressSlider/Slider/Slider.jsx










core_class/* default.use */.Z.use([
    a11y/* default */.Z
]);
var PressSlider_Slider_Slider_Slider = PressSlider_Slider_Slider_theme_themed(function(param) {
    var theme = param.theme, entries = param.entries, settings = param.settings, activeIndex = param.activeIndex, setActiveIndex = param.setActiveIndex;
    var defaultParams = Slider_useSliderParams_useSliderParams();
    var ref = (0,react.useState)(), slider = ref[0], setSlider = ref[1];
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Container */.W2, {
        "data-comp": PressSlider_Slider_Slider_Slider.displayName,
        sx: theme.wrapper,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(react_swiper/* Swiper */.t, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                onSwiper: setSlider,
                a11y: {
                    enabled: true
                }
            }, defaultParams), {
                speed: settings === null || settings === void 0 ? void 0 : settings.speed,
                sx: theme.swiper,
                children: entries.map(function(entry, index) {
                    var ref;
                    if (index !== activeIndex) return null;
                    if (!(entry === null || entry === void 0 ? void 0 : entry.quote)) return null;
                    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(swiper_slide/* SwiperSlide */.o, {
                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                            sx: theme.slide,
                            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                                sx: theme.quote,
                                children: entry === null || entry === void 0 ? void 0 : entry.quote
                            })
                        })
                    }, (entry === null || entry === void 0 ? void 0 : (ref = entry.logo) === null || ref === void 0 ? void 0 : ref.src) + index);
                })
            })),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Navigation, {
                slider: slider,
                entries: entries,
                customParams: settings,
                activeIndex: activeIndex,
                setActiveIndex: setActiveIndex
            })
        ]
    });
});
PressSlider_Slider_Slider_Slider.displayName = "Slider";

;// CONCATENATED MODULE: ./src/sections/PressSlider/Slider/index.js


;// CONCATENATED MODULE: ./src/sections/PressSlider/PressSlider.jsx







var PressSlider = (0,src_utils/* withInView */.Dh)(PressSlider_theme_themed(function(param) {
    var theme = param.theme, cms = param.cms, inView = param.inView;
    if ((cms === null || cms === void 0 ? void 0 : cms.entries.length) === 0) return null;
    var entries = cms.entries, settings = cms.settings, section = cms.section;
    var ref = (0,react.useState)(0), activeIndex = ref[0], setActiveIndex = ref[1];
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Section */.$0, {
        section: section,
        children: inView && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(PressSlider_Slider_Slider_Slider, {
            entries: entries,
            settings: settings,
            activeIndex: activeIndex,
            setActiveIndex: setActiveIndex,
            sx: theme.wrapper
        })
    });
}), {
    triggerOnce: true
});
PressSlider.displayName = "PressSlider";
PressSlider.Schema = PressSlider_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/PressSlider/index.js


;// CONCATENATED MODULE: ./src/sections/ProductComparison/ProductComparison.schema.js



function ProductComparison_schema_Schema(param) {
    var article = param.article, blog = param.blog, collection = param.collection;
    if (article || blog || collection) return null;
    return {
        label: "Product Comparison",
        key: "product-comparison",
        fields: [
            {
                label: "Text Settings",
                name: "text",
                description: "Heading, alignment",
                component: "group",
                fields: [
                    {
                        label: "Heading",
                        name: "heading",
                        component: "text",
                        defaultValue: "Undeniably Different"
                    },
                    {
                        name: "textAlign",
                        label: "Text align",
                        component: "radio-group",
                        direction: "horizontal",
                        variant: "radio",
                        options: common/* align.options */.AJ.options,
                        defaultValue: common/* align.value.center */.AJ.value.center
                    }, 
                ]
            },
            {
                label: "Brand Settings",
                name: "brands",
                description: "Configure brand names and images",
                component: "group",
                fields: [
                    {
                        label: "Your Brand Name",
                        name: "yourBrand",
                        component: "text",
                        defaultValue: "Br\xfcMate"
                    },
                    {
                        label: "Your Brand Image",
                        name: "yourBrandImage",
                        component: "image"
                    },
                    {
                        label: "Your Brand column background color",
                        name: "yourBrandBgColor",
                        component: "select",
                        options: [
                            {
                                label: "Black",
                                value: "#2c2c2c"
                            },
                            {
                                label: "Gray",
                                value: "#f5f5f5"
                            }, 
                        ],
                        defaultValue: "#2c2c2c"
                    },
                    {
                        label: "Competitor Brand Name",
                        name: "competitorBrand",
                        component: "text",
                        defaultValue: "Others"
                    },
                    {
                        label: "Competitor Brand Image",
                        name: "competitorBrandImage",
                        component: "image"
                    },
                    {
                        label: "Competitor column background color",
                        name: "competitorBgColor",
                        component: "select",
                        options: [
                            {
                                label: "Black",
                                value: "#2c2c2c"
                            },
                            {
                                label: "Gray",
                                value: "#f5f5f5"
                            }, 
                        ],
                        defaultValue: "#f5f5f5"
                    }, 
                ],
                defaultValue: {
                    yourBrand: "Br\xfcMate",
                    competitorBrand: "Others"
                }
            },
            {
                label: "Comparison Items",
                name: "comparisonItems",
                description: "Add comparison features",
                component: "group-list",
                itemProps: function(item) {
                    return {
                        key: item.id,
                        label: item.title || "New Comparison Item"
                    };
                },
                defaultItem: function() {
                    return {
                        id: Math.random().toString(36).substr(2, 9),
                        title: "",
                        description: "",
                        yourBrandStatus: "check",
                        competitorStatus: "cross"
                    };
                },
                fields: [
                    {
                        label: "Feature Title",
                        name: "title",
                        component: "text"
                    },
                    {
                        label: "Feature Description",
                        name: "description",
                        component: "text"
                    },
                    {
                        label: "Your Brand Status",
                        name: "yourBrandStatus",
                        component: "select",
                        options: [
                            {
                                label: "Check Mark",
                                value: "check"
                            },
                            {
                                label: "Cross Mark",
                                value: "cross"
                            },
                            {
                                label: "Partial Check",
                                value: "partial"
                            }, 
                        ]
                    },
                    {
                        label: "Competitor Status",
                        name: "competitorStatus",
                        component: "select",
                        options: [
                            {
                                label: "Check Mark",
                                value: "check"
                            },
                            {
                                label: "Cross Mark",
                                value: "cross"
                            },
                            {
                                label: "Partial Check",
                                value: "partial"
                            }, 
                        ]
                    }, 
                ],
                defaultValue: [
                    {
                        id: "1",
                        title: "U-Turn™ leakproof lid",
                        description: "Patented technology. Keep it open or locked & 100% leakproof",
                        yourBrandStatus: "check",
                        competitorStatus: "cross"
                    },
                    {
                        id: "2",
                        title: "ColdKey™ stainless steel straw",
                        description: "Removable for easy cleaning",
                        yourBrandStatus: "check",
                        competitorStatus: "cross"
                    },
                    {
                        id: "3",
                        title: "BevGuard™ technology",
                        description: "Keeps ice cold for 24+ hours",
                        yourBrandStatus: "check",
                        competitorStatus: "cross"
                    },
                    {
                        id: "4",
                        title: "Reddot award winner",
                        description: "",
                        yourBrandStatus: "check",
                        competitorStatus: "cross"
                    },
                    {
                        id: "5",
                        title: "Cupholder-friendly",
                        description: "",
                        yourBrandStatus: "check",
                        competitorStatus: "partial"
                    },
                    {
                        id: "6",
                        title: "Dishwasher friendly",
                        description: "",
                        yourBrandStatus: "check",
                        competitorStatus: "partial"
                    }, 
                ]
            },
            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, common/* section */.qi), {
                defaultValue: {
                    bgColor: common/* color.value.white */.$_.value.white,
                    color: common/* color.value.dark */.$_.value.dark,
                    desktop: {
                        container: "container",
                        mt: "l",
                        py: "xl"
                    },
                    mobile: {
                        container: "container",
                        mt: "m",
                        py: "l"
                    }
                }
            }), 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/ProductComparison/ProductComparison.theme.js



var ProductComparison_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        width: "100%"
    };
    this.heading = {
        variant: "text.heading",
        fontSize: [
            6,
            7,
            8
        ],
        fontWeight: "bold",
        mb: [
            4,
            5,
            6
        ]
    };
    this.comparisonTable = {
        width: "100%",
        maxWidth: "924px",
        mx: "auto",
        display: "flex",
        flexDirection: "column",
        gap: [
            2,
            3
        ]
    };
    this.headerRow = {
        display: "grid",
        gridTemplateColumns: "2fr 1fr 1fr",
        bg: "transparent",
        gap: [
            2,
            3
        ]
    };
    this.brandHeader = {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        p: [
            4,
            5
        ],
        bg: "transparent",
        minHeight: [
            "120px",
            "140px"
        ]
    };
    this.brandImage = {
        width: [
            "60px",
            "80px"
        ],
        height: [
            "60px",
            "80px"
        ],
        objectFit: "contain",
        mb: 2
    };
    this.brandName = {
        fontSize: [
            3,
            8
        ],
        fontWeight: "400",
        textAlign: "center"
    };
    this.comparisonRow = {
        display: "grid",
        gridTemplateColumns: "2fr 1fr 1fr",
        gap: [
            2,
            3
        ]
    };
    this.featureCell = {
        p: 12,
        bg: "#f5f5f5",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center"
    };
    this.featureTitle = {
        fontSize: [
            2,
            7
        ],
        fontWeight: "500",
        mb: 3,
        color: "dark"
    };
    this.featureDescription = {
        fontSize: [
            1,
            6
        ],
        color: "gray.600",
        lineHeight: 1.4
    };
    this.statusCell = {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: [
            10,
            12
        ],
        py: 12,
        minHeight: [
            "80px",
            "90px"
        ],
        bg: "transparent"
    };
    this.statusIcon = {
        width: [
            "24px",
            "32px"
        ],
        height: [
            "24px",
            "32px"
        ],
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: [
            "14px",
            "18px"
        ],
        fontWeight: "bold"
    };
    this.checkIcon = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this.statusIcon), {
        bg: "#9ACD32",
        color: "white",
        border: "2px solid #9ACD32"
    });
    this.crossIcon = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this.statusIcon), {
        bg: "transparent",
        color: "#666",
        border: "2px solid #666"
    });
    this.partialIcon = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this.statusIcon), {
        bg: "transparent",
        color: "#999",
        border: "2px solid #999"
    });
    // Mobile responsive adjustments
    this.mobileWrapper = {
        "@media (max-width: 768px)": {
            ".comparison-table": {
                display: "block"
            },
            ".header-row": {
                display: "none"
            },
            ".comparison-row": {
                display: "block",
                mb: 4,
                border: "1px solid",
                borderColor: "gray.200",
                borderRadius: "8px",
                overflow: "hidden"
            },
            ".feature-cell": {
                borderBottom: "1px solid",
                borderColor: "gray.200"
            },
            ".status-row": {
                display: "grid",
                gridTemplateColumns: "1fr 1fr"
            },
            ".status-cell": {
                flexDirection: "column",
                gap: 2,
                fontSize: 1
            }
        }
    };
}());

;// CONCATENATED MODULE: ./src/sections/ProductComparison/ProductComparison.jsx







function StatusIcon(param) {
    var status = param.status, theme = param.theme, bgColor = param.bgColor;
    var getIconStyle = function() {
        switch(status){
            case "check":
                return theme.checkIcon;
            case "cross":
                return theme.crossIcon;
            case "partial":
                return theme.partialIcon;
            default:
                return theme.crossIcon;
        }
    };
    var getIconContent = function() {
        switch(status){
            case "check":
                return "✓";
            case "cross":
                return "✕";
            case "partial":
                return "◐";
            default:
                return "✕";
        }
    };
    if (status === "check") {
        return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Svg */.ny, {
            alt: "checkmark",
            src: "/svgs/noprecache/svg/checkmark.svg#checkmark",
            viewBox: "0 0 40 40",
            className: "w-[32px] h-[32px] ".concat(bgColor === "#2c2c2c" ? "text-[#E1FF05]" : "text-[#222222] opacity-50", " ")
        });
    }
    if (status === "cross") {
        return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Svg */.ny, {
            alt: "cross mark",
            src: "/svgs/noprecache/svg/cross-mark.svg#cross-mark",
            viewBox: "0 0 40 40",
            className: "w-[32px] h-[32px] ".concat(bgColor === "#2c2c2c" ? "text-[#E1FF05]" : "text-[#222222] opacity-50", " ")
        });
    }
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
        sx: getIconStyle(),
        children: getIconContent()
    });
}
var ProductComparison = ProductComparison_theme_themed(function(param) {
    var theme = param.theme, cms = param.cms;
    var ref, ref1;
    var text = cms.text, brands = cms.brands, comparisonItems = cms.comparisonItems, section = cms.section;
    var yourBrandBgColor = (brands === null || brands === void 0 ? void 0 : brands.yourBrandBgColor) || "#2c2c2c";
    var competitorBgColor = (brands === null || brands === void 0 ? void 0 : brands.competitorBgColor) || "#f5f5f5";
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Section */.$0, {
        section: section,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
            "data-comp": ProductComparison.displayName,
            sx: theme.wrapper,
            children: [
                (text === null || text === void 0 ? void 0 : text.heading) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Text */.xv, {
                    as: "h2",
                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.heading), {
                        textAlign: text === null || text === void 0 ? void 0 : text.textAlign,
                        fontFamily: "Reckless Neue",
                        fontSize: [
                            10,
                            13
                        ],
                        fontWeight: 400,
                        mb: [
                            12,
                            16
                        ]
                    }),
                    children: text.heading
                }),
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                    sx: theme.comparisonTable,
                    className: "comparison-table",
                    children: [
                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                            sx: theme.headerRow,
                            className: "header-row",
                            children: [
                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                                    sx: theme.brandHeader
                                }),
                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.brandHeader), {
                                        bg: yourBrandBgColor,
                                        color: yourBrandBgColor === "#2c2c2c" ? "white" : "dark"
                                    }),
                                    children: [
                                        (brands === null || brands === void 0 ? void 0 : (ref = brands.yourBrandImage) === null || ref === void 0 ? void 0 : ref.src) ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Image */.Ee, {
                                            src: brands.yourBrandImage.src,
                                            alt: (brands === null || brands === void 0 ? void 0 : brands.yourBrand) || "Your Brand",
                                            sx: theme.brandImage
                                        }) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                                            sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.brandImage), {
                                                bg: "white",
                                                borderRadius: "8px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center"
                                            }),
                                            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Text */.xv, {
                                                sx: {
                                                    fontSize: 2,
                                                    fontWeight: "bold",
                                                    color: "dark"
                                                },
                                                children: ((brands === null || brands === void 0 ? void 0 : brands.yourBrand) || "Br\xfcMate").charAt(0)
                                            })
                                        }),
                                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Text */.xv, {
                                            sx: theme.brandName,
                                            children: (brands === null || brands === void 0 ? void 0 : brands.yourBrand) || "Br\xfcMate"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.brandHeader), {
                                        bg: competitorBgColor,
                                        color: competitorBgColor === "#2c2c2c" ? "white" : "dark"
                                    }),
                                    children: [
                                        (brands === null || brands === void 0 ? void 0 : (ref1 = brands.competitorBrandImage) === null || ref1 === void 0 ? void 0 : ref1.src) ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Image */.Ee, {
                                            src: brands.competitorBrandImage.src,
                                            alt: (brands === null || brands === void 0 ? void 0 : brands.competitorBrand) || "Competitor",
                                            sx: theme.brandImage
                                        }) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                                            sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.brandImage), {
                                                bg: "white",
                                                borderRadius: "8px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center"
                                            }),
                                            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Text */.xv, {
                                                sx: {
                                                    fontSize: 2,
                                                    fontWeight: "bold",
                                                    color: "dark"
                                                },
                                                children: ((brands === null || brands === void 0 ? void 0 : brands.competitorBrand) || "Others").charAt(0)
                                            })
                                        }),
                                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Text */.xv, {
                                            sx: theme.brandName,
                                            children: (brands === null || brands === void 0 ? void 0 : brands.competitorBrand) || "Others"
                                        })
                                    ]
                                })
                            ]
                        }),
                        comparisonItems === null || comparisonItems === void 0 ? void 0 : comparisonItems.map(function(item, index) {
                            /*#__PURE__*/ return (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                                sx: theme.comparisonRow,
                                className: "comparison-row",
                                children: [
                                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                                        sx: theme.featureCell,
                                        className: "feature-cell",
                                        children: [
                                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Text */.xv, {
                                                sx: theme.featureTitle,
                                                children: item.title
                                            }),
                                            item.description && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Text */.xv, {
                                                sx: theme.featureDescription,
                                                children: item.description
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                                        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.statusCell), {
                                            bg: yourBrandBgColor
                                        }),
                                        className: "status-cell",
                                        children: [
                                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(StatusIcon, {
                                                status: item.yourBrandStatus,
                                                theme: theme,
                                                bgColor: yourBrandBgColor
                                            }),
                                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Text */.xv, {
                                                sx: {
                                                    mt: 1,
                                                    fontSize: 0
                                                },
                                                className: "sr-only",
                                                children: (brands === null || brands === void 0 ? void 0 : brands.yourBrand) || "Your Brand"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                                        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.statusCell), {
                                            bg: competitorBgColor
                                        }),
                                        className: "status-cell",
                                        children: [
                                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(StatusIcon, {
                                                status: item.competitorStatus,
                                                theme: theme,
                                                bgColor: competitorBgColor
                                            }),
                                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Text */.xv, {
                                                sx: {
                                                    mt: 1,
                                                    fontSize: 0
                                                },
                                                className: "sr-only",
                                                children: (brands === null || brands === void 0 ? void 0 : brands.competitorBrand) || "Others"
                                            })
                                        ]
                                    })
                                ]
                            }, item.id || index);
                        })
                    ]
                })
            ]
        })
    });
});
ProductComparison.displayName = "ProductComparison";
ProductComparison.Schema = ProductComparison_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/ProductComparison/index.js


;// CONCATENATED MODULE: ./src/sections/ProductRecs/useProductRecsBeacon.js






var useProductRecsBeacon = function(param) {
    var profileData = param.profileData, profileTag = param.profileTag, visibleProducts = param.visibleProducts, inView = param.inView;
    var ref;
    var cachedMounted = (0,react.useRef)(false); // prevent double events on mount
    var sendEventsToBeacon = (0,hooks/* useSearchspringBeacon */.fo)().sendEventsToBeacon;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useSelectedVariant */.BK)(), 1), selectedVariant = ref1[0];
    var ref2 = (0,react.useState)(false), mounted = ref2[0], setMounted = ref2[1];
    var ref3 = (0,react.useState)(false), viewed = ref3[0], setViewed = ref3[1];
    var sku = selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.sku;
    var sendBeaconEventsOnMount = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    if (cachedMounted.current || mounted || !(profileData === null || profileData === void 0 ? void 0 : profileData.results) || !profileTag) return [
                        2
                    ];
                    cachedMounted.current = true;
                    return [
                        4,
                        sendEventsToBeacon({
                            profileTypes: [
                                "profile.render"
                            ],
                            productTypes: [
                                "profile.product.render"
                            ],
                            tag: profileTag,
                            placement: "product-page",
                            products: profileData.results,
                            seed: [
                                {
                                    sku: sku
                                }
                            ]
                        })
                    ];
                case 1:
                    _state.sent();
                    setMounted(true);
                    return [
                        3,
                        3
                    ];
                case 2:
                    error = _state.sent();
                    console.error(error.message);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    }), [
        profileData === null || profileData === void 0 ? void 0 : (ref = profileData.results) === null || ref === void 0 ? void 0 : ref.length,
        profileTag,
        mounted,
        sku
    ]);
    var sendBeaconEventsOnInView = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    if (viewed || !inView || !(visibleProducts === null || visibleProducts === void 0 ? void 0 : visibleProducts.length) || !profileTag) return [
                        2
                    ];
                    return [
                        4,
                        sendEventsToBeacon({
                            profileTypes: [
                                "profile.impression"
                            ],
                            productTypes: [
                                "profile.product.impression"
                            ],
                            tag: profileTag,
                            placement: "product-page",
                            visibleProducts: visibleProducts,
                            seed: [
                                {
                                    sku: sku
                                }
                            ]
                        })
                    ];
                case 1:
                    _state.sent();
                    setViewed(true);
                    return [
                        3,
                        3
                    ];
                case 2:
                    error = _state.sent();
                    console.error(error.message);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    }), [
        visibleProducts,
        profileTag,
        sku,
        inView,
        viewed
    ]);
    var sendBeaconEventsOnClick = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(event, product) {
            var dataComp, productClicked, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        if (!profileTag) return [
                            2
                        ];
                        dataComp = (0,_to_consumable_array/* default */.Z)(event.target.attributes || []).find(function(attr) {
                            return attr.name === "data-comp";
                        });
                        productClicked = product && (event.target.nodeName === "svg" || event.target.nodeName === "use" || (dataComp === null || dataComp === void 0 ? void 0 : dataComp.value) === "AddToCart" || (dataComp === null || dataComp === void 0 ? void 0 : dataComp.value) === "ProductItemTitle" || (dataComp === null || dataComp === void 0 ? void 0 : dataComp.value) === "SeeDetails" || (dataComp === null || dataComp === void 0 ? void 0 : dataComp.value) === "OkendoStarsTotal" || (dataComp === null || dataComp === void 0 ? void 0 : dataComp.value) === "OkendoStarsTotalText" || (dataComp === null || dataComp === void 0 ? void 0 : dataComp.value) === "PictureImage");
                        return [
                            4,
                            sendEventsToBeacon({
                                profileTypes: [
                                    "profile.click"
                                ],
                                productTypes: productClicked ? [
                                    "profile.product.click"
                                ] : [],
                                tag: profileTag,
                                placement: "product-page",
                                clickedProduct: productClicked ? product : null,
                                seed: [
                                    {
                                        sku: sku
                                    }
                                ]
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        console.error(error.message);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(event, product) {
            return _ref.apply(this, arguments);
        };
    }(), [
        profileTag,
        sku
    ]);
    var sendBeaconEventsOnProductsInView = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    if (!mounted || !viewed || !(visibleProducts === null || visibleProducts === void 0 ? void 0 : visibleProducts.length) || !profileTag) return [
                        2
                    ];
                    return [
                        4,
                        sendEventsToBeacon({
                            productTypes: [
                                "profile.product.impression"
                            ],
                            tag: profileTag,
                            placement: "product-page",
                            visibleProducts: visibleProducts,
                            seed: [
                                {
                                    sku: sku
                                }
                            ]
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        3,
                        3
                    ];
                case 2:
                    error = _state.sent();
                    console.error(error.message);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    }), [
        visibleProducts,
        profileTag,
        mounted,
        viewed,
        sku
    ]);
    (0,react.useEffect)(function() {
        sendBeaconEventsOnMount();
    }, [
        profileData === null || profileData === void 0 ? void 0 : profileData.results,
        visibleProducts,
        profileTag
    ]);
    (0,react.useEffect)(function() {
        sendBeaconEventsOnInView();
    }, [
        inView,
        visibleProducts,
        profileTag
    ]);
    (0,react.useEffect)(function() {
        sendBeaconEventsOnProductsInView();
    }, [
        visibleProducts === null || visibleProducts === void 0 ? void 0 : visibleProducts.map(function(p) {
            return p.id;
        }).join(",")
    ]);
    return {
        sendBeaconEventsOnClick: sendBeaconEventsOnClick
    };
};

;// CONCATENATED MODULE: ./src/sections/ProductRecs/useVisibleProductRecItems.js


function useVisibleProductRecItems(param) {
    var profileData = param.profileData, swiper = param.swiper, loop = param.loop;
    var ref = (0,react.useState)(false), mounted = ref[0], setMounted = ref[1];
    var ref1 = (0,react.useState)(0), activeIndex = ref1[0], setActiveIndex = ref1[1];
    var ref2 = (0,react.useState)([]), visibleProducts = ref2[0], setVisibleProducts = ref2[1];
    var setActiveIndexOnSlideChange = (0,react.useCallback)(function() {
        var onSlideChange = function(_swiper) {
            setActiveIndex(_swiper.realIndex);
        };
        if (swiper && swiper.on) {
            swiper.on("slideChange", onSlideChange);
        }
        return function() {
            if (swiper && swiper.off) {
                swiper.off("slideChange", onSlideChange);
            }
        };
    }, [
        swiper
    ]);
    var setVisibleProductsOnProfileInView = (0,react.useCallback)(function() {
        var ref;
        if (!swiper || mounted || !(profileData === null || profileData === void 0 ? void 0 : (ref = profileData.results) === null || ref === void 0 ? void 0 : ref.length)) return;
        var realIndex = swiper.realIndex;
        var centeredSlides = swiper.params.centeredSlides;
        var slidesPerView = Math.ceil(swiper.params.slidesPerView);
        var totalSlides = profileData.results.length;
        var numSlidesBefore = 0;
        var numSlidesAfter = slidesPerView - 1;
        var totalIndexes = slidesPerView;
        if (centeredSlides) {
            if (loop) {
                var halfSlidesCount = Math.ceil((slidesPerView - 1) / 2);
                numSlidesBefore = halfSlidesCount;
                numSlidesAfter = halfSlidesCount;
            } else {
                numSlidesAfter = Math.ceil((slidesPerView - 1) / 2);
            }
        }
        if (loop) {
            totalIndexes = numSlidesBefore + numSlidesAfter + 1;
        }
        var firstIndex = realIndex - numSlidesBefore;
        var indexes = new Array(totalIndexes).fill().map(function(_, i) {
            return firstIndex + i;
        });
        var realIndexes = indexes.reduce(function(arr, index) {
            if (index < 0) return (0,_to_consumable_array/* default */.Z)(arr).concat([
                totalSlides + index
            ]);
            if (index >= totalSlides) {
                if (loop) return (0,_to_consumable_array/* default */.Z)(arr).concat([
                    index - totalSlides
                ]);
                return arr;
            }
            return (0,_to_consumable_array/* default */.Z)(arr).concat([
                index
            ]);
        }, []);
        var _visibleProducts = realIndexes.map(function(index) {
            return profileData.results[index];
        });
        setVisibleProducts(_visibleProducts);
        setMounted(true);
    }, [
        profileData === null || profileData === void 0 ? void 0 : profileData.results,
        swiper
    ]);
    var setVisibleProductsOnSlideChange = (0,react.useCallback)(function() {
        var ref;
        if (!mounted || !swiper || !(profileData === null || profileData === void 0 ? void 0 : (ref = profileData.results) === null || ref === void 0 ? void 0 : ref.length)) return;
        var realIndex = swiper.realIndex;
        var centeredSlides = swiper.params.centeredSlides;
        var slidesPerView = Math.ceil(swiper.params.slidesPerView);
        var totalSlides = profileData.results.length;
        var numSlidesBefore = 0;
        var numSlidesAfter = slidesPerView - 1;
        var totalIndexes = slidesPerView;
        if (centeredSlides) {
            if (loop) {
                var halfSlidesCount = Math.ceil((slidesPerView - 1) / 2);
                numSlidesBefore = halfSlidesCount;
                numSlidesAfter = halfSlidesCount;
            }
        }
        if (loop) {
            totalIndexes = numSlidesBefore + numSlidesAfter + 1;
        }
        var firstIndex = realIndex - numSlidesBefore;
        var indexes = new Array(totalIndexes).fill().map(function(_, i) {
            return firstIndex + i;
        });
        var realIndexes = indexes.reduce(function(arr, index) {
            if (index < 0) return (0,_to_consumable_array/* default */.Z)(arr).concat([
                totalSlides + index
            ]);
            if (index >= totalSlides) {
                if (loop) return (0,_to_consumable_array/* default */.Z)(arr).concat([
                    index - totalSlides
                ]);
                return arr;
            }
            return (0,_to_consumable_array/* default */.Z)(arr).concat([
                index
            ]);
        }, []);
        var _visibleProducts = realIndexes.map(function(index) {
            return profileData.results[index];
        });
        setVisibleProducts(_visibleProducts);
    }, [
        activeIndex
    ]);
    (0,react.useEffect)(function() {
        setActiveIndexOnSlideChange();
    }, [
        swiper
    ]);
    (0,react.useEffect)(function() {
        setVisibleProductsOnSlideChange();
    }, [
        activeIndex
    ]);
    (0,react.useEffect)(function() {
        setVisibleProductsOnProfileInView();
    }, [
        profileData === null || profileData === void 0 ? void 0 : profileData.results,
        swiper
    ]);
    return {
        visibleProducts: visibleProducts
    };
}

;// CONCATENATED MODULE: ./src/sections/ProductRecs/ProductRecs.schema.js



function ProductRecs_schema_Schema() {
    return {
        label: "Product Recs",
        key: "product-recs",
        fields: [
            {
                name: "tag",
                label: "Searchspring Product Recs Tag",
                component: "text",
                description: 'The product recommendations profile tag taken from Searchspring admin, e.g. "cross-sell", "similar", "home", "recently-viewed"',
                defaultValue: "cross-sell"
            },
            {
                name: "limit",
                label: "Number of recommendations",
                component: "number",
                defaultValue: 8
            },
            {
                label: "Content Settings",
                name: "content",
                description: "Heading",
                component: "group",
                fields: [
                    {
                        name: "heading",
                        label: "Heading",
                        component: "text"
                    }, 
                ],
                defaultValue: {
                    heading: "Complete The Fam"
                }
            },
            {
                name: "loop",
                label: "Loop",
                component: "toggle",
                variant: "horizontal",
                description: "Loop products when they reach the end. Note: Requires 5 or more products to be set",
                defaultValue: true
            },
            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, common/* section */.qi), {
                defaultValue: {
                    bgColor: common/* color.value.background */.$_.value.background,
                    color: common/* color.value.text */.$_.value.text,
                    desktop: {
                        container: "container",
                        mt: "none",
                        py: "m"
                    },
                    mobile: {
                        container: "container",
                        mt: "none",
                        py: "m"
                    }
                }
            }), 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/ProductRecs/ProductRecs.theme.js

var ProductRecs_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        display: "flex",
        flexDirection: "column"
    };
    this.header = {
        minHeight: [
            "35px",
            "45px",
            "60px"
        ]
    };
    this.slider = {
        minHeight: "300px",
        position: "relative"
    };
    this.spinner = {
        width: "30px",
        color: "mediumDarkGray",
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)"
    };
}());

;// CONCATENATED MODULE: ./src/sections/ProductRecs/Header/Header.theme.js

var Header_theme_themed = (0,create/* create */.U)(new function() {
    this.header = {
        display: "flex",
        justifyContent: "center",
        width: "100%",
        mb: [
            14,
            null,
            null,
            15
        ]
    };
    this.heading = {
        variant: "text.h3",
        width: "100%",
        mb: [
            10,
            null,
            null,
            0
        ],
        flex: 1,
        px: 9,
        textAlign: "center"
    };
    this.groups = {
        width: [
            "100%",
            "auto"
        ],
        height: [
            "23px",
            "auto"
        ],
        position: "relative",
        ml: [
            0,
            null,
            null,
            10
        ],
        mt: [
            0,
            null,
            null,
            11
        ]
    };
    this.list = {
        position: [
            "absolute",
            "relative"
        ],
        top: [
            0,
            "auto"
        ],
        left: [
            "50%",
            "auto"
        ],
        transform: [
            "translateX(-50%)",
            "none"
        ],
        maxWidth: "100%",
        overflowY: "hidden",
        overflowX: "auto",
        px: 10
    };
    this.listItem = {
        minWidth: "auto"
    };
    this.button = {
        minWidth: "unset",
        fontFamily: "body",
        fontSize: "14px",
        lineHeight: "20px",
        fontWeight: 500,
        width: "auto",
        color: "black",
        whiteSpace: "nowrap",
        position: "relative",
        overflow: "hidden",
        pb: 1,
        ":after": {
            transition: "transform 0.2s ease-in-out",
            content: '""',
            position: "absolute",
            top: "calc(100% - 2px)",
            left: 0,
            width: "100%",
            height: "2px",
            bg: "dark"
        },
        ":hover:after": {
            transform: "translateX(0)"
        }
    };
}());

;// CONCATENATED MODULE: ./src/sections/ProductRecs/Header/Header.jsx




var Header = Header_theme_themed(function(param) {
    var theme = param.theme, content = param.content;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Container */.W2, {
        "data-comp": Header.displayName,
        sx: theme.header,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
            variant: "h2",
            sx: theme.heading,
            children: content === null || content === void 0 ? void 0 : content.heading
        })
    });
});
Header.displayName = "Header";

;// CONCATENATED MODULE: ./src/sections/ProductRecs/Header/index.js


;// CONCATENATED MODULE: ./src/sections/ProductRecs/Slider/Slider.theme.js

var ProductRecs_Slider_Slider_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        width: "100%"
    };
    this.swiper = {
        ".swiper-container": {
            cursor: [
                "grab",
                "auto"
            ],
            pl: [
                "16px",
                "unset"
            ],
            overflow: "visible"
        },
        ".swiper-container, .swiper-wrapper": {
            height: "auto !important",
            width: "100%"
        },
        ".swiper-slide": {
            opacity: 0.35
        },
        ".swiper-slide-visible": {
            opacity: 1
        },
        ".swiper-button-prev": {
            left: "auto",
            right: "56px",
            top: [
                "-75px",
                null,
                null,
                "-66px"
            ],
            color: "black",
            width: "36px",
            height: "36px",
            "@media only screen and (max-width: 767px)": {
                display: "none"
            }
        },
        ".swiper-button-prev:after": {
            fontSize: "30px"
        },
        ".swiper-button-next": {
            left: "auto",
            right: 0,
            top: [
                "-75px",
                null,
                null,
                "-66px"
            ],
            color: "black",
            width: "36px",
            height: "36px",
            "@media only screen and (max-width: 767px)": {
                display: "none"
            }
        },
        ".swiper-button-next:after": {
            fontSize: "30px"
        }
    };
    this.button = {
        mt: [
            12,
            14
        ]
    };
}());

;// CONCATENATED MODULE: ./src/sections/ProductRecs/Slider/Slider.jsx




var ProductRecs_Slider_Slider_Slider = ProductRecs_Slider_Slider_theme_themed(function(param) {
    var theme = param.theme, products = param.products, _loop = param.loop, loop = _loop === void 0 ? true : _loop, swiper = param.swiper, setSwiper = param.setSwiper, onItemClick = param.onItemClick;
    var count = (products === null || products === void 0 ? void 0 : products.length) >= 4;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Container */.W2, {
        "data-comp": ProductRecs_Slider_Slider_Slider.displayName,
        sx: theme.wrapper,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
            sx: theme.swiper,
            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* ProductSwiper */.xy, {
                isProductRow: true,
                isProductRecs: true,
                hideAddToCart: false,
                products: products,
                count: count,
                loop: loop,
                swiper: swiper,
                setSwiper: setSwiper,
                onItemClick: onItemClick
            })
        })
    });
});
ProductRecs_Slider_Slider_Slider.displayName = "Slider";

;// CONCATENATED MODULE: ./src/sections/ProductRecs/Slider/index.js


;// CONCATENATED MODULE: ./src/sections/ProductRecs/ProductRecs.jsx













var ProductRecs = (0,src_utils/* withInView */.Dh)(ProductRecs_theme_themed(function(param) {
    var theme = param.theme, cms = param.cms, inView = param.inView;
    var content = cms.content, loop = cms.loop, section = cms.section, tag = cms.tag, limit = cms.limit;
    var product = (0,dist.useProduct)();
    var ref = (0,hooks/* useProductRecommendations */.$t)({
        tag: tag || "cross-sell",
        limit: limit,
        productId: (product === null || product === void 0 ? void 0 : product.legacyResourceId) || ""
    }), recommendations = ref.recommendations, profileData = ref.profileData, profileTag = ref.profileTag;
    var ref1 = (0,react.useState)(null), swiper = ref1[0], setSwiper = ref1[1];
    var visibleProducts = useVisibleProductRecItems({
        profileData: profileData,
        swiper: swiper,
        loop: loop
    }).visibleProducts;
    var sendBeaconEventsOnClick = useProductRecsBeacon({
        profileData: profileData,
        profileTag: profileTag,
        visibleProducts: visibleProducts,
        inView: inView
    }).sendBeaconEventsOnClick;
    var handleProfileClick = (0,react.useCallback)(function(event) {
        if (event.target.dataset.comp !== "NavigationButton" && !event.target.swiper) return;
        sendBeaconEventsOnClick(event);
    }, [
        profileTag
    ]);
    var handleProfileProductClick = (0,react.useCallback)(function(event, index) {
        var ref;
        sendBeaconEventsOnClick(event, (profileData === null || profileData === void 0 ? void 0 : (ref = profileData.results) === null || ref === void 0 ? void 0 : ref[index]) || null);
    }, [
        profileData === null || profileData === void 0 ? void 0 : profileData.results,
        profileTag
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Section */.$0, {
        section: section,
        sx: {
            overflow: "hidden"
        },
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Container */.W2, {
            "data-comp": ProductRecs.displayName,
            sx: theme.wrapper,
            children: [
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                    sx: theme.header,
                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Header, {
                        content: content
                    })
                }),
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                    sx: theme.slider,
                    onClick: handleProfileClick,
                    children: inView && (recommendations === null || recommendations === void 0 ? void 0 : recommendations.length) ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(ProductRecs_Slider_Slider_Slider, {
                        products: recommendations,
                        ctaStyle: content === null || content === void 0 ? void 0 : content.ctaStyle,
                        loop: loop,
                        swiper: swiper,
                        setSwiper: setSwiper,
                        onItemClick: handleProfileProductClick
                    }) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Spinner */.$j, {
                        sx: theme.spinner
                    })
                })
            ]
        })
    });
}), {
    triggerOnce: true
});
ProductRecs.displayName = "ProductRecs";
ProductRecs.Schema = ProductRecs_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/ProductRecs/index.js


// EXTERNAL MODULE: ../node_modules/@tapcart/webbridge-react/dist/webbridge-react.es.js
var webbridge_react_es = __webpack_require__(13305);
;// CONCATENATED MODULE: ./src/sections/ProductsSlider/ProductsSlider.schema.js



// Pool of products used to set random default products
var products = [
    {
        product: {
            handle: "toddy-16oz-onyx-leopard"
        }
    },
    {
        product: {
            handle: "brumate-25oz-rehydration-bottle-onyx-leopard"
        }
    },
    {
        product: {
            handle: "hopsulator-slim-onyx-leopard-12oz-slim-cans"
        }
    },
    {
        product: {
            handle: "uncorkd-xl-14oz-wine-tumbler-onyx-leopard"
        }
    },
    {
        product: {
            handle: "hopsulator-juggernaut-onyx-leopard-24-25oz-cans"
        }
    },
    {
        product: {
            handle: "brumate-highball-12oz-onyx-leopard"
        }
    }, 
];
function ProductsSlider_schema_Schema() {
    return {
        label: "Products Slider",
        key: "products-slider",
        fields: [
            {
                label: "Content Settings",
                name: "content",
                description: "Heading, text align",
                component: "group",
                fields: [
                    {
                        name: "heading",
                        label: "Heading",
                        component: "text"
                    },
                    {
                        name: "textAlign",
                        label: "Heading alignment",
                        component: "radio-group",
                        direction: "horizontal",
                        variant: "radio",
                        options: common/* align.options */.AJ.options
                    },
                    {
                        name: "textAlignMobile",
                        label: "Heading alignment (mobile)",
                        component: "radio-group",
                        variant: "radio",
                        direction: "horizontal",
                        options: common/* align.options */.AJ.options
                    }, 
                ],
                defaultValue: {
                    heading: "New Releases",
                    textAlign: common/* align.value.center */.AJ.value.center,
                    textAlignMobile: common/* align.value.center */.AJ.value.center
                }
            },
            {
                name: "products",
                label: "Products",
                component: "group-list",
                description: "Add a minimum of 5 products set to enable slider functionality",
                itemProps: {
                    label: "{{item.product.handle}}" || 0
                },
                fields: [
                    {
                        name: "product",
                        component: "productSearch",
                        label: "Product"
                    }, 
                ],
                defaultValue: products
            },
            {
                name: "loop",
                label: "Loop",
                component: "toggle",
                variant: "horizontal",
                description: "Loop products when they reach the end. Note: Requires 5 or more products to be set",
                defaultValue: true
            },
            {
                label: "Call To Action",
                name: "cta",
                component: "link",
                description: "Optional CTA button appearing below the slider"
            },
            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, common/* section */.qi), {
                defaultValue: {
                    bgColor: common/* color.value.background */.$_.value.background,
                    color: common/* color.value.text */.$_.value.text,
                    desktop: {
                        container: "container",
                        mt: "none",
                        py: "m"
                    },
                    mobile: {
                        container: "container",
                        mt: "none",
                        py: "m"
                    }
                }
            }), 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/ProductsSlider/ProductsSlider.theme.js

var ProductsSlider_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        display: "flex",
        flexDirection: "column"
    };
    this.header = {
        minHeight: [
            "35px",
            "45px",
            "60px"
        ]
    };
    this.slider = {
        minHeight: "200px"
    };
    this.cta = {
        mt: [
            11,
            14
        ]
    };
}());

;// CONCATENATED MODULE: ./src/sections/ProductsSlider/Header/Header.theme.js

var Header_Header_theme_themed = (0,create/* create */.U)(new function() {
    this.header = {
        display: "flex",
        width: "100%",
        flexDirection: [
            "column",
            null,
            null,
            "row"
        ],
        mb: [
            14,
            null,
            null,
            15
        ]
    };
    this.heading = {
        variant: "text.h2",
        width: "100%",
        mb: [
            10,
            null,
            null,
            0
        ],
        flex: 1,
        px: 9
    };
    this.groups = {
        width: [
            "100%",
            "auto"
        ],
        height: [
            "23px",
            "auto"
        ],
        position: "relative",
        ml: [
            0,
            null,
            null,
            10
        ],
        mt: [
            0,
            null,
            null,
            11
        ]
    };
    this.list = {
        position: [
            "absolute",
            "relative"
        ],
        top: [
            0,
            "auto"
        ],
        left: [
            "50%",
            "auto"
        ],
        transform: [
            "translateX(-50%)",
            "none"
        ],
        maxWidth: "100%",
        overflowY: "hidden",
        overflowX: "auto",
        px: 10
    };
    this.listItem = {
        minWidth: "auto"
    };
    this.button = {
        minWidth: "unset",
        fontFamily: "body",
        fontSize: "14px",
        lineHeight: "20px",
        fontWeight: 500,
        width: "auto",
        color: "black",
        whiteSpace: "nowrap",
        position: "relative",
        overflow: "hidden",
        pb: 1,
        ":after": {
            transition: "transform 0.2s ease-in-out",
            content: '""',
            position: "absolute",
            top: "calc(100% - 2px)",
            left: 0,
            width: "100%",
            height: "2px",
            bg: "dark"
        },
        ":hover:after": {
            transform: "translateX(0)"
        }
    };
}());

;// CONCATENATED MODULE: ./src/sections/ProductsSlider/Header/Header.jsx






var Header_Header = Header_Header_theme_themed(function(param) {
    var theme = param.theme, _content = param.content, content = _content === void 0 ? {} : _content;
    var textAlign = content.textAlign, textAlignMobile = content.textAlignMobile;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Container */.W2, {
        "data-comp": Header_Header.displayName,
        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.header), {
            justifyContent: [
                (0,src_utils/* convertAlignToFlex */.nG)(textAlignMobile),
                null,
                null,
                (0,src_utils/* convertAlignToFlex */.nG)(textAlign), 
            ],
            alignItems: [
                (0,src_utils/* convertAlignToFlex */.nG)(textAlignMobile),
                null,
                null,
                (0,src_utils/* convertAlignToFlex */.nG)(textAlign), 
            ]
        }),
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
            variant: "h2",
            sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.heading), {
                textAlign: textAlign
            }),
            children: content === null || content === void 0 ? void 0 : content.heading
        })
    });
});
Header_Header.displayName = "Header";

;// CONCATENATED MODULE: ./src/sections/ProductsSlider/Header/index.js


;// CONCATENATED MODULE: ./src/sections/ProductsSlider/Slider/Slider.theme.js

var ProductsSlider_Slider_Slider_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        width: "100%"
    };
    this.swiper = {
        ".swiper-container": {
            cursor: [
                "grab",
                "auto"
            ],
            pl: [
                "16px",
                "unset"
            ],
            overflow: "visible"
        },
        ".swiper-container, .swiper-wrapper": {
            height: "auto !important",
            width: "100%"
        },
        ".swiper-slide": {
            opacity: 0.35
        },
        ".swiper-slide-visible": {
            opacity: 1
        },
        ".swiper-button-prev": {
            left: "auto",
            right: "56px",
            top: [
                "-75px",
                null,
                null,
                "-66px"
            ],
            color: "black",
            width: "36px",
            height: "36px",
            "@media only screen and (max-width: 767px)": {
                display: "none"
            }
        },
        ".swiper-button-prev:after": {
            fontSize: "30px"
        },
        ".swiper-button-next": {
            left: "auto",
            right: 0,
            top: [
                "-75px",
                null,
                null,
                "-66px"
            ],
            color: "black",
            width: "36px",
            height: "36px",
            "@media only screen and (max-width: 767px)": {
                display: "none"
            }
        },
        ".no-heading .swiper-button-next, .no-heading .swiper-button-prev": {
            top: [
                "-40px",
                null,
                null,
                "-40px"
            ]
        },
        ".swiper-button-next:after": {
            fontSize: "30px"
        }
    };
    this.button = {
        mt: [
            12,
            14
        ]
    };
}());

;// CONCATENATED MODULE: ./src/sections/ProductsSlider/Slider/Slider.jsx





var ProductsSlider_Slider_Slider_Slider = ProductsSlider_Slider_Slider_theme_themed(function(param) {
    var theme = param.theme, products = param.products, _loop = param.loop, loop = _loop === void 0 ? true : _loop, swiperClassName = param.swiperClassName;
    var ref = (0,react.useState)(false), mounted = ref[0], setMounted = ref[1];
    (0,react.useEffect)(function() {
        setMounted(true);
    }, []);
    var count = (products === null || products === void 0 ? void 0 : products.length) >= 4;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Container */.W2, {
        "data-comp": ProductsSlider_Slider_Slider_Slider.displayName,
        sx: theme.wrapper,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
            sx: theme.swiper,
            children: mounted && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* ProductSwiper */.xy, {
                isProductRow: true,
                swiperClassName: swiperClassName,
                hideAddToCart: false,
                products: products,
                count: count,
                loop: loop
            })
        })
    });
});
ProductsSlider_Slider_Slider_Slider.displayName = "Slider";

;// CONCATENATED MODULE: ./src/sections/ProductsSlider/Slider/index.js


;// CONCATENATED MODULE: ./src/sections/ProductsSlider/ProductsSlider.jsx










var ProductsSlider = (0,src_utils/* withInView */.Dh)(ProductsSlider_theme_themed(function(param) {
    var theme = param.theme, cms = param.cms;
    var products = cms.products, content = cms.content, loop = cms.loop, cta = cms.cta, section = cms.section;
    var isInitialized = (0,webbridge_react_es/* useVariables */.OQ)().isInitialized;
    var openScreen = (0,webbridge_react_es/* useActions */.ol)().openScreen;
    var handleCtaClick = (0,react.useCallback)(function(event) {
        if (isInitialized && (cta === null || cta === void 0 ? void 0 : cta.url)) {
            var ref;
            event.preventDefault();
            openScreen({
                destination: {
                    type: "web",
                    url: (cta === null || cta === void 0 ? void 0 : (ref = cta.url) === null || ref === void 0 ? void 0 : ref.indexOf("http")) === 0 ? cta.url : "".concat("https://www.brumate.com").concat(cta.url)
                }
            });
        }
    }, [
        isInitialized,
        cta === null || cta === void 0 ? void 0 : cta.url
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Section */.$0, {
        section: section,
        sx: {
            overflow: "hidden"
        },
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Container */.W2, {
            "data-comp": ProductsSlider.displayName,
            sx: theme.wrapper,
            children: [
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                    sx: theme.header,
                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Header_Header, {
                        content: content
                    })
                }),
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                    sx: theme.slider,
                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(ProductsSlider_Slider_Slider_Slider, {
                        swiperClassName: !content.heading ? "no-heading" : "",
                        products: products,
                        ctaStyle: content === null || content === void 0 ? void 0 : content.ctaStyle,
                        loop: loop
                    })
                }),
                (cta === null || cta === void 0 ? void 0 : cta.text) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                    variant: "flex.row.center.center",
                    "data-comp": "".concat(ProductsSlider.displayName, "-cta"),
                    sx: theme.cta,
                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Link */.rU, {
                        variant: "buttons.primary",
                        href: cta === null || cta === void 0 ? void 0 : cta.url,
                        onClick: handleCtaClick,
                        children: cta === null || cta === void 0 ? void 0 : cta.text
                    })
                })
            ]
        })
    });
}), {
    triggerOnce: true
});
ProductsSlider.displayName = "ProductsSlider";
ProductsSlider.Schema = ProductsSlider_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/ProductsSlider/index.js


;// CONCATENATED MODULE: ./src/sections/ProductUpsells/ProductUpsells.schema.js
// eslint-disable-next-line react/prop-types
function ProductUpsells_schema_Schema(param) {
    var product = param.product;
    if (!product) return null;
    return {
        label: "Product Upsells",
        key: "productUpsells",
        fields: [
            {
                component: "text",
                name: "heading",
                label: "Heading",
                defaultValue: "Add-ons"
            },
            {
                component: "group-list",
                name: "products",
                label: "Products",
                description: "Add up to 5 products",
                itemProps: {
                    label: "{{item.product.handle}}" || 0
                },
                fields: [
                    {
                        component: "productSearch",
                        name: "product",
                        label: "Product"
                    }, 
                ]
            }, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/ProductUpsells/ProductUpsells.jsx








var ProductUpsells = (0,src_utils/* withInView */.Dh)(function(param) {
    var cms = param.cms;
    var ref;
    var heading = cms.heading, products = cms.products, section = cms.section;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useSelectedVariant */.BK)(), 1), selectedVariant = ref1[0];
    var upsellProducts = (0,react.useMemo)(function() {
        var ref;
        var tags = selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref = selectedVariant.product) === null || ref === void 0 ? void 0 : ref.tags;
        var newUpsellHandles = tags === null || tags === void 0 ? void 0 : tags.reduce(function(carry, tag) {
            if (tag.indexOf("upsell::") > -1) {
                var ref = (0,_sliced_to_array/* default */.Z)(tag.split("::"), 3), handle = ref[1], order = ref[2];
                return (0,_to_consumable_array/* default */.Z)(carry).concat([
                    {
                        product: {
                            handle: handle,
                            order: order
                        }
                    }, 
                ]).sort(function(a, b) {
                    var ref, ref1;
                    return (a === null || a === void 0 ? void 0 : (ref = a.product) === null || ref === void 0 ? void 0 : ref.order) - (b === null || b === void 0 ? void 0 : (ref1 = b.product) === null || ref1 === void 0 ? void 0 : ref1.order);
                });
            }
            return carry;
        }, []);
        if (newUpsellHandles === null || newUpsellHandles === void 0 ? void 0 : newUpsellHandles.length) {
            return newUpsellHandles;
        }
        return products;
    }, [
        selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref = selectedVariant.product) === null || ref === void 0 ? void 0 : ref.tags
    ]);
    if (!(upsellProducts === null || upsellProducts === void 0 ? void 0 : upsellProducts.length)) return null;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Section */.$0, {
        section: section,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* ProductUpsellsList */.gW, {
            heading: heading,
            products: upsellProducts
        })
    });
}, {
    triggerOnce: true
});
ProductUpsells.displayName = "ProductUpsells";
ProductUpsells.Schema = ProductUpsells_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/ProductUpsells/index.js


;// CONCATENATED MODULE: ./src/sections/QuickSelectCollections/QuickSelectCollections.theme.js

var QuickSelectCollections_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        display: [
            "flex",
            "none"
        ],
        justifyContent: "center",
        overflow: "hidden",
        minHeight: "56px",
        py: 6
    };
    this.scroll = {
        height: "100%",
        overflowY: "hidden",
        overflowX: "auto",
        webkitOverflowScrolling: "touch",
        msOverflowStyle: "none",
        scrollbarWidth: "none",
        "::-webkit-scrollbar": {
            display: "none"
        },
        px: 8
    };
    this.link = {
        variant: "text.label.1",
        bg: "gray",
        height: "32px",
        lineHeight: "32px",
        px: 6,
        borderRadius: "16px",
        minWidth: "auto",
        whiteSpace: "nowrap",
        transition: "background-color 0.2s ease-in-out",
        ":hover": {
            bg: "mediumGray"
        }
    };
}());

;// CONCATENATED MODULE: ./src/sections/QuickSelectCollections/QuickSelectCollections.schema.js

function QuickSelectCollections_schema_Schema(param) {
    var page = param.page;
    if ((page === null || page === void 0 ? void 0 : page.handle) !== "/") return null;
    return {
        label: "Quick Select Collections",
        key: "quick-select-collections",
        fields: [
            {
                label: "Quick select collections",
                name: "links",
                component: "group-list",
                description: "Collection buttons below the header. Mobile only",
                itemProps: {
                    label: "{{item.cta.text}}"
                },
                defaultItem: {
                    cta: {
                        url: "/collections/best-sellers",
                        text: "Best Sellers"
                    }
                },
                fields: [
                    {
                        label: "Link",
                        name: "cta",
                        component: "link"
                    }, 
                ],
                defaultValue: [
                    {
                        cta: {
                            url: "/collections/best-sellers",
                            text: "Best Sellers"
                        }
                    },
                    {
                        cta: {
                            url: "/collections/drinkware",
                            text: "Drinkware"
                        }
                    },
                    {
                        cta: {
                            url: "/collections/coolers",
                            text: "Coolers"
                        }
                    },
                    {
                        cta: {
                            url: "/collections/giftsets",
                            text: "Gifts"
                        }
                    }, 
                ]
            },
            common/* section */.qi, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/QuickSelectCollections/QuickSelectCollections.jsx








var QuickSelectCollections = (0,src_utils/* withInView */.Dh)(QuickSelectCollections_theme_themed(function(param) {
    var theme = param.theme, cms = param.cms;
    var links = cms.links, section = cms.section;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Section */.$0, {
        section: section,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Container */.W2, {
            "data-comp": QuickSelectCollections.displayName,
            sx: theme.wrapper,
            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                sx: theme.scroll,
                children: links === null || links === void 0 ? void 0 : links.map(function(item, index, arr) {
                    var ref, ref1, ref2;
                    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Link */.rU, {
                        href: (ref = item.cta) === null || ref === void 0 ? void 0 : ref.url,
                        newTab: (ref1 = item.cta) === null || ref1 === void 0 ? void 0 : ref1.newTab,
                        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.link), {
                            mr: index !== arr.length - 1 ? 3 : 0
                        }),
                        children: (ref2 = item.cta) === null || ref2 === void 0 ? void 0 : ref2.text
                    }, index);
                })
            })
        })
    });
}), {
    triggerOnce: true
});
QuickSelectCollections.displayName = "QuickSelectCollections";
QuickSelectCollections.Schema = QuickSelectCollections_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/QuickSelectCollections/index.js


;// CONCATENATED MODULE: ./src/sections/ReviewSlider/ReviewSlider.schema.js



function ReviewSlider_schema_Schema(param) {
    var article = param.article, blog = param.blog, collection = param.collection;
    if (article || blog || collection) return null;
    return {
        label: "Review Slider",
        key: "review-slider",
        fields: [
            {
                label: "Text Settings",
                name: "text",
                description: "Heading, alignment",
                component: "group",
                fields: [
                    {
                        label: "Heading",
                        name: "heading",
                        component: "markdown",
                        defaultValue: "## 135,000+ 5-Star Reviews"
                    },
                    {
                        name: "textAlign",
                        label: "Text align",
                        component: "radio-group",
                        direction: "horizontal",
                        variant: "radio",
                        options: common/* align.options */.AJ.options,
                        defaultValue: common/* align.value.center */.AJ.value.center
                    }, 
                ]
            },
            {
                label: "Review Settings",
                name: "reviewSettings",
                description: "Count, order",
                component: "group",
                fields: [
                    {
                        name: "count",
                        label: "Review count",
                        component: "number",
                        description: "Multiples of three will provide a smoother transition on desktop displays",
                        defaultValue: 6
                    },
                    {
                        name: "orderBy",
                        label: "Order by",
                        component: "select",
                        description: "Order in which the reviews will be displayed",
                        options: [
                            {
                                label: "Newest (Default)",
                                value: "date desc"
                            },
                            {
                                label: "Oldest",
                                value: "date asc"
                            },
                            {
                                label: "Highest Rating",
                                value: "rating desc"
                            },
                            {
                                label: "Lowest Rating",
                                value: "rating asc"
                            }, 
                        ],
                        defaultValue: "date desc"
                    }, 
                ]
            },
            {
                name: "sliderSettings",
                label: "Slider Settings",
                component: "group",
                description: "Loop",
                fields: [
                    {
                        name: "loop",
                        label: "Loop",
                        component: "toggle",
                        description: "Loop back to the first set of reviews seamlessly when the last review is reached",
                        toggleLabels: {
                            true: "Enable (default)",
                            false: "Disable"
                        }
                    }, 
                ],
                defaultValue: {
                    loop: true
                }
            },
            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, common/* section */.qi), {
                defaultValue: {
                    bgColor: common/* color.value.dark */.$_.value.dark,
                    color: common/* color.value.white */.$_.value.white,
                    desktop: {
                        container: "container",
                        mt: "none",
                        py: "xl"
                    },
                    mobile: {
                        container: "container",
                        mt: "none",
                        py: "l"
                    }
                }
            }), 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/ReviewSlider/ReviewSlider.theme.js
/* eslint-disable*/ 
var ReviewSlider_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        minHeight: "200px"
    };
    this.header = {
        variant: "text.reviewsHeading",
        mt: [
            15,
            80
        ]
    };
    this.slider = {
        mt: [
            11,
            12
        ]
    };
}());

;// CONCATENATED MODULE: ./src/sections/ReviewSlider/Slider/Slider.theme.js



var ReviewSlider_Slider_Slider_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        display: "flex",
        flexDirection: "column",
        mt: [
            14,
            null,
            null,
            15
        ],
        px: [
            0,
            10,
            17
        ],
        pb: [
            15,
            0
        ]
    };
    this.swiper = {
        width: "100%",
        height: "100%",
        textAlign: "center",
        cursor: "grab",
        ".swiper-container": {
            cursor: [
                "grab",
                "auto"
            ],
            pl: [
                "16px",
                "unset"
            ],
            overflow: "visible"
        },
        ".swiper-container, .swiper-wrapper": {
            height: "auto !important",
            width: "100%"
        },
        ".swiper-slide": {
            opacity: 0.35
        },
        ".swiper-slide-visible": {
            opacity: 1
        },
        ".swiper-button-prev": {
            left: "auto",
            right: "56px",
            top: [
                "-58px",
                null,
                null,
                "-66px"
            ],
            color: "currentColor",
            width: "36px",
            height: "36px",
            "@media only screen and (max-width: 767px)": {
                display: "none"
            }
        },
        ".swiper-button-prev:after": {
            fontSize: "30px"
        },
        ".swiper-button-next": {
            left: "auto",
            right: 0,
            top: [
                "-58px",
                null,
                null,
                "-66px"
            ],
            color: "currentColor",
            width: "36px",
            height: "36px",
            "@media only screen and (max-width: 767px)": {
                display: "none"
            }
        },
        ".swiper-button-next:after": {
            fontSize: "30px"
        }
    };
    this.bullets = {
        mt: 6,
        display: [
            "flex",
            "none"
        ],
        justifyContent: "center",
        gap: 9,
        width: "100%",
        height: "8px",
        ".swiper-pagination-bullet": {
            cursor: "pointer",
            bg: "white",
            opacity: 0.2
        },
        ".swiper-pagination-bullet-active": {
            opacity: "1 !important"
        },
        position: "absolute",
        bottom: 0,
        left: 0
    };
    this.buttonPrev = {
        position: "absolute",
        display: [
            "none",
            "flex"
        ],
        top: "50%",
        transform: "translateY(-50%)",
        zIndex: 1,
        left: [
            8,
            0
        ],
        right: "auto",
        transition: "opacity 0.2s ease-in-out",
        width: [
            "44px",
            null,
            null,
            "56px"
        ],
        height: [
            "44px",
            null,
            null,
            "56px"
        ],
        borderRadius: "50%",
        bg: "background",
        borderStyle: "solid",
        borderWidth: "1px",
        borderColor: "gray",
        justifyContent: "center",
        alignItems: "center",
        boxShadow: "0px 3px 25px rgba(0,0,0,0.2)"
    };
    this.buttonNext = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this.buttonPrev), {
        left: "auto",
        right: [
            8,
            0
        ]
    });
    this.icon = {
        width: "24px",
        userSelect: "none",
        ":hover": {
            color: "text"
        }
    };
    this.slideWrapper = {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        px: [
            0,
            "50px",
            "60px"
        ]
    };
    this.starWrapper = {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-around",
        minWidth: 122,
        height: "18px",
        mx: "auto"
    };
    this.stars = {
        mx: "auto"
    };
    this.title = {
        variant: "text.h3",
        fontWeight: 500,
        fontSize: [
            7,
            9
        ],
        mt: [
            8
        ],
        maxWidth: "225px"
    };
    this.review = {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: [
            44,
            48
        ],
        mt: [
            4,
            3
        ],
        maxWidth: "225px",
        mx: "auto"
    };
    this.paragraph = {
        variant: "text.base"
    };
    this.displayName = {
        mt: [
            4,
            "22px"
        ],
        textTransform: "capitalize"
    };
}());

;// CONCATENATED MODULE: ./src/sections/ReviewSlider/Slider/NavigationButton.jsx







var NavigationButton = ReviewSlider_Slider_Slider_theme_themed(function(_param) {
    var theme = _param.theme, customCss = _param.customCss, _src = _param.src, src = _src === void 0 ? "/svgs/arrow-left.svg#arrow-left" : _src, _alt = _param.alt, alt = _alt === void 0 ? "Previous Review" : _alt, _isNext = _param.isNext, isNext = _isNext === void 0 ? false : _isNext, inactive = _param.inactive, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme",
        "customCss",
        "src",
        "alt",
        "isNext",
        "inactive"
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-comp": NavigationButton.displayName,
        disabled: inactive
    }, props), {
        variant: "buttons.plain",
        sx: (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, isNext ? theme.buttonNext : theme.buttonPrev), {
            opacity: inactive ? 0.5 : 1
        }), props.sx),
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Svg */.ny, {
            alt: alt,
            src: src,
            viewBox: "0 0 24 24",
            draggable: false,
            sx: theme.icon
        })
    }));
});
NavigationButton.displayName = "NavigationButton";

;// CONCATENATED MODULE: ./src/sections/ReviewSlider/Slider/Navigation.jsx




var Navigation_Navigation = ReviewSlider_Slider_Slider_theme_themed(function(param) {
    var theme = param.theme, loop = param.loop, swiper = param.swiper;
    var ref = (0,react.useState)(true), isStart = ref[0], setIsStart = ref[1];
    var ref1 = (0,react.useState)(false), isEnd = ref1[0], setIsEnd = ref1[1];
    var setStartAndEndOnSwiperChange = (0,react.useCallback)(function() {
        if (!swiper) return;
        if (loop) {
            setIsStart(false);
            setIsEnd(false);
        }
        if (!loop) {
            setIsStart(swiper.isBeginning);
            setIsEnd(swiper.isEnd);
            swiper.on("slideChange", function() {
                setIsStart(swiper.isBeginning);
                setIsEnd(swiper.isEnd);
            });
        }
    }, [
        swiper,
        loop
    ]);
    (0,react.useEffect)(function() {
        setStartAndEndOnSwiperChange();
    }, [
        swiper
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_jsx_runtime_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(NavigationButton, {
                onClick: function() {
                    return swiper.slidePrev();
                },
                inactive: isStart
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(NavigationButton, {
                onClick: function() {
                    return swiper.slideNext();
                },
                src: "/svgs/arrow-right.svg#arrow-right",
                alt: "Next Review",
                inactive: isEnd,
                isNext: true
            })
        ]
    });
});
Navigation_Navigation.displayName = "Navigation";

;// CONCATENATED MODULE: ./src/sections/ReviewSlider/Slider/Slide.jsx
/* eslint-disable import/no-unresolved */ 





var Slide_Slide = ReviewSlider_Slider_Slider_theme_themed(function(param) {
    var theme = param.theme, stars = param.stars, title = param.title, review = param.review, name = param.name;
    if (!review.length) return null;
    var reviewBody = (0,react.useMemo)(function() {
        if (review.length === 0) return null;
        var reviewCharLimit = 70;
        var slicedReview = review.slice(0, reviewCharLimit);
        var lastSpaceIndex = slicedReview.lastIndexOf(" ");
        var lastPeriodIndex = slicedReview.lastIndexOf(".");
        var exclaimationIndex = slicedReview.lastIndexOf("!");
        if (review.length < reviewCharLimit) return review;
        if (lastPeriodIndex !== -1 || exclaimationIndex !== -1) {
            return slicedReview.slice(0, lastPeriodIndex + 1 || exclaimationIndex + 1);
        }
        return "".concat(slicedReview.slice(0, lastSpaceIndex + 1), "...");
    }, [
        review
    ]);
    var starArray = stars ? (0,_to_consumable_array/* default */.Z)(Array(stars)) : [];
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": Slide_Slide.displayName,
        sx: theme.slideWrapper,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                sx: theme.starWrapper,
                children: starArray && starArray.map(function(star, index) {
                    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Svg */.ny, {
                        alt: "".concat(index, " ").concat(index === 0 ? "star" : "stars"),
                        viewBox: "0 0 18 18",
                        src: "/svgs/star.svg",
                        sx: theme.stars
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                as: "h3",
                variant: "text.h3",
                sx: theme.title,
                children: title.length < 20 ? title : "".concat(stars, " Stars!")
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                sx: theme.review,
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                    sx: theme.paragraph,
                    children: reviewBody
                })
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                sx: theme.displayName,
                children: "- ".concat(name)
            })
        ]
    });
});
Slide_Slide.displayName = "Slide";

;// CONCATENATED MODULE: ./src/sections/ReviewSlider/Slider/useSliderParams.js

var ReviewSlider_Slider_useSliderParams_useSliderParams = function() {
    var loop = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        loop: false,
        speed: 1500
    }).loop;
    var params = (0,react.useMemo)(function() {
        return {
            centeredSlides: false,
            centeredSlidesBounds: true,
            centerInsufficientSlides: true,
            spaceBetween: 16,
            slidesPerView: 1.5,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 16,
            slidesPerGroup: 1,
            autoHeight: false,
            navigation: true,
            loop: loop,
            watchOverflow: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            breakpoints: {
                768: {
                    spaceBetween: 20,
                    slidesPerView: 2,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0,
                    slidesPerGroup: 1
                },
                1024: {
                    spaceBetween: 20,
                    slidesPerView: 3,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0,
                    slidesPerGroup: 1
                },
                1280: {
                    spaceBetween: 20,
                    slidesPerView: 4,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0,
                    slidesPerGroup: 1
                }
            }
        };
    }, [
        loop
    ]);
    return params;
};

;// CONCATENATED MODULE: ./src/sections/ReviewSlider/Slider/Slider.jsx











core_class/* default.use */.Z.use([
    a11y/* default */.Z,
    pagination/* default */.Z
]);
var ReviewSlider_Slider_Slider_Slider = ReviewSlider_Slider_Slider_theme_themed(function(param) {
    var theme = param.theme, customParams = param.customParams, reviews = param.reviews;
    var defaultParams = ReviewSlider_Slider_useSliderParams_useSliderParams(customParams);
    var ref = (0,react.useState)(), slider = ref[0], setSlider = ref[1];
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Container */.W2, {
        "data-comp": ReviewSlider_Slider_Slider_Slider.displayName,
        sx: theme.wrapper,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
            sx: theme.swiper,
            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(react_swiper/* Swiper */.t, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                onSwiper: setSlider,
                a11y: {
                    enabled: true
                },
                pagination: {
                    el: ".swiper-pagination",
                    type: "bullets",
                    clickable: true
                }
            }, defaultParams), {
                children: reviews.map(function(review, index) {
                    var ref;
                    var isValidReview = (review === null || review === void 0 ? void 0 : (ref = review.reviewer) === null || ref === void 0 ? void 0 : ref.displayName) || (review === null || review === void 0 ? void 0 : review.rating) || (review === null || review === void 0 ? void 0 : review.body);
                    if (!isValidReview) return null;
                    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(swiper_slide/* SwiperSlide */.o, {
                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Slide_Slide, {
                            stars: review.rating,
                            title: review.title,
                            review: review.body,
                            name: review.reviewer.displayName
                        }, review.rating)
                    }, index);
                })
            }))
        })
    });
});
ReviewSlider_Slider_Slider_Slider.displayName = "Slider";

;// CONCATENATED MODULE: ./src/sections/ReviewSlider/Slider/index.js


;// CONCATENATED MODULE: ./src/sections/ReviewSlider/ReviewSlider.jsx











var ReviewSlider = (0,src_utils/* withInView */.Dh)(ReviewSlider_theme_themed(function(param) {
    var theme = param.theme, cms = param.cms, inView = param.inView;
    var text = cms.text, reviewSettings = cms.reviewSettings, sliderSettings = cms.sliderSettings, section = cms.section;
    var ref = (0,_object_spread/* default */.Z)({}, reviewSettings), orderBy = ref.orderBy, count = ref.count;
    var reviews = (0,hooks/* useOkendo */.E4)({
        orderBy: orderBy,
        count: count,
        inView: inView
    }).reviews;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Section */.$0, {
        section: section,
        sx: {
            overflow: "hidden"
        },
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
            "data-comp": ReviewSlider.displayName,
            sx: theme.wrapper,
            children: [
                (text === null || text === void 0 ? void 0 : text.heading) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Markdown */.UG, {
                    text: text === null || text === void 0 ? void 0 : text.heading,
                    textSx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.heading), {
                        textAlign: text === null || text === void 0 ? void 0 : text.textAlign
                    }),
                    sx: (0,_object_spread/* default */.Z)({}, (0,utils_common/* pxWithFullBleed */._T)(section))
                }),
                inView && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(ReviewSlider_Slider_Slider_Slider, {
                    reviews: reviews,
                    customParams: sliderSettings
                })
            ]
        })
    });
}), {
    triggerOnce: true
});
ReviewSlider.displayName = "ReviewSlider";
ReviewSlider.Schema = ReviewSlider_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/ReviewSlider/index.js


// EXTERNAL MODULE: ./src/snippets/Search/index.js + 38 modules
var Search = __webpack_require__(70457);
;// CONCATENATED MODULE: ./src/sections/SearchResults/SearchResults.schema.js
function SearchResults_schema_Schema(param) {
    var page = param.page;
    if ((page === null || page === void 0 ? void 0 : page.handle) !== "search") return null;
    return {
        label: "Search Results",
        key: "search-results",
        fields: []
    };
}

;// CONCATENATED MODULE: ./src/sections/SearchResults/SearchResults.jsx




var SearchResults = (0,src_utils/* withInView */.Dh)(function(param) {
    var cms = param.cms;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Search/* SearchPage */.Z9, {
        cms: cms
    });
}, {
    triggerOnce: true
});
SearchResults.displayName = "SearchResults";
SearchResults.Schema = SearchResults_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/SearchResults/index.js


// EXTERNAL MODULE: ../node_modules/react-intersection-observer/dist/index.mjs
var react_intersection_observer_dist = __webpack_require__(38687);
;// CONCATENATED MODULE: ./src/sections/SuperCollection/SuperCollectionProductItem/Image/Image.theme.js

var SuperCollectionProductItem_Image_Image_theme_themed = (0,create/* create */.U)(new function() {
    this.image = {
        mb: 6,
        bg: "background",
        position: "relative"
    };
    this.imageQuiz = {
        mb: 6,
        bg: "lightGray",
        position: "relative"
    };
    this.spinnerWrapper = {
        width: "100%",
        minHeight: "100%",
        bg: "lightGray"
    };
    this.spinner = {
        width: "30px",
        color: "gray",
        m: "auto"
    };
}());

;// CONCATENATED MODULE: ./src/sections/SuperCollection/SuperCollectionProductItem/Image/Image.jsx





var SuperCollectionProductItem_Image_Image_Image = SuperCollectionProductItem_Image_Image_theme_themed(function(param) {
    var theme = param.theme, product = param.product, _view = param.view, view = _view === void 0 ? "default" : _view, _target = param.target, target = _target === void 0 ? "_self" : _target, handleClick = param.handleClick;
    var ref;
    var ref1 = (0,hooks/* useProductItemImages */.Ep)({
        product: product
    }), primary = ref1.primary, hover = ref1.hover;
    var disableHoverMobile = (0,hooks/* useBreakpointValue */.Sx)([
        true,
        false
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(snippets/* Link */.rU, {
        "data-comp": SuperCollectionProductItem_Image_Image_Image.displayName,
        href: "/products/".concat(product === null || product === void 0 ? void 0 : product.handle),
        "aria-label": product === null || product === void 0 ? void 0 : product.title,
        onClick: handleClick,
        target: target,
        sx: view == "quiz" ? theme.imageQuiz : theme.image,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Picture */.t, {
                alt: product === null || product === void 0 ? void 0 : product.title,
                images: [
                    {
                        src: primary === null || primary === void 0 ? void 0 : primary.originalSrc,
                        width: 600,
                        ratio: 1
                    }, 
                ],
                hoverImages: [
                    {
                        src: hover === null || hover === void 0 ? void 0 : hover.originalSrc,
                        width: 600,
                        ratio: 1
                    }, 
                ],
                disableHoverMobile: disableHoverMobile,
                children: !(primary === null || primary === void 0 ? void 0 : primary.originalSrc) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                    sx: theme.spinnerWrapper,
                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Spinner */.$j, {
                        sx: theme.spinner
                    })
                })
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Badge */.Ct, {
                handle: product === null || product === void 0 ? void 0 : product.handle,
                product: product
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Favorite */.rF, {
                selectedVariant: product === null || product === void 0 ? void 0 : (ref = product.variants) === null || ref === void 0 ? void 0 : ref[0]
            })
        ]
    });
});
SuperCollectionProductItem_Image_Image_Image.displayName = "Image";

;// CONCATENATED MODULE: ./src/sections/SuperCollection/SuperCollectionProductItem/Image/index.js


;// CONCATENATED MODULE: ./src/sections/SuperCollection/SuperCollectionProductItem/Details/ColorOptions/ColorOptions.theme.js

var ColorOptions_theme_themed = (0,create/* create */.U)(new function() {
    this.option = {
        mt: 8,
        width: "100%"
    };
    this.name = {
        variant: "text.label.1",
        mr: 4
    };
    this.color = {
        color: "mediumDarkGray"
    };
    this.values = {
        variant: "flex.row.start",
        pl: 0,
        flexWrap: "wrap",
        flexBasis: "100%",
        mr: "auto",
        gap: 6,
        "@media screen and (max-width: 479px)": {
            gap: 4
        }
    };
    this.value = {
        p: 4,
        alignItems: "center",
        display: "flex",
        justifyContent: "center",
        fontSize: "12px",
        height: "64px",
        minWidth: "64px",
        borderRadius: "4px",
        position: "relative",
        transition: "all 0.15s ease-in-out",
        ":hover": {
            border: function(t) {
                return "1px solid ".concat(t.colors.mediumDarkGray);
            }
        },
        "@media screen and (max-width: 479px)": {
            minWidth: "62px"
        },
        available: {
            selected: {
                border: function(t) {
                    return "1px solid ".concat(t.colors.text);
                },
                bg: "background",
                color: "text"
            },
            unselected: {
                border: function(t) {
                    return "1px solid ".concat(t.colors.gray);
                },
                bg: "background",
                color: "text"
            }
        }
    };
    this.seeAll = {
        height: "64px",
        minWidth: "64px",
        borderRadius: "4px",
        p: 4,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        border: function(t) {
            return "1px solid ".concat(t.colors.gray);
        },
        bg: "background",
        color: "text",
        transition: "all 0.15s ease-in-out",
        ":hover": {
            border: function(t) {
                return "1px solid ".concat(t.colors.mediumDarkGray);
            }
        },
        icon: {
            width: "20px",
            color: "text"
        },
        text: {
            fontSize: "10px",
            lineHeight: "12px"
        }
    };
}());

;// CONCATENATED MODULE: ./src/sections/SuperCollection/SuperCollectionProductItem/Details/ColorOptions/ColorOption.jsx







var ColorOption = ColorOptions_theme_themed(function(param) {
    var theme = param.theme, handle = param.handle, selectedHandle = param.selectedHandle, setSelectedHandle = param.setSelectedHandle;
    var product = (0,dist.useProductByHandle)({
        handle: handle
    }).product;
    var color = (0,react.useMemo)(function() {
        var ref, ref1, ref2;
        if (!product) return null;
        return (ref2 = (ref1 = product === null || product === void 0 ? void 0 : (ref = product.tags) === null || ref === void 0 ? void 0 : ref.find(function(tag) {
            return tag.match(new RegExp("color::", "gi"));
        })) === null || ref1 === void 0 ? void 0 : ref1.split("::")[1]) === null || ref2 === void 0 ? void 0 : ref2.trim();
    }, [
        product === null || product === void 0 ? void 0 : product.id
    ]);
    var firstImage = (0,react.useMemo)(function() {
        var ref, ref1;
        return (ref1 = product === null || product === void 0 ? void 0 : (ref = product.media) === null || ref === void 0 ? void 0 : ref.find(function(item) {
            return item.mediaContentType === "IMAGE";
        })) === null || ref1 === void 0 ? void 0 : ref1.image;
    }, [
        product === null || product === void 0 ? void 0 : product.id
    ]);
    var isSelected = handle === selectedHandle;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
        as: "li",
        "data-comp": ColorOption.displayName,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
            "aria-label": color,
            variant: "buttons.plain",
            onClick: function() {
                setSelectedHandle(handle);
            },
            sx: (0,_object_spread/* default */.Z)({}, theme.value, isSelected ? theme.value.available.selected : theme.value.available.unselected),
            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Picture */.t, {
                alt: color,
                images: [
                    {
                        src: firstImage === null || firstImage === void 0 ? void 0 : firstImage.originalSrc,
                        ratio: 1,
                        width: 46
                    }, 
                ]
            })
        })
    }, handle);
});
ColorOption.displayName = "ColorOption";

;// CONCATENATED MODULE: ./src/sections/SuperCollection/SuperCollectionProductItem/Details/ColorOptions/ColorOptions.jsx







var ColorOptions = ColorOptions_theme_themed(function(param) {
    var theme = param.theme, initialProduct = param.initialProduct, selectedHandle = param.selectedHandle, setSelectedHandle = param.setSelectedHandle, seeAllLink = param.seeAllLink, _view = param.view, view = _view === void 0 ? "default" : _view;
    var maxColorsFromBp = (0,hooks/* useBreakpointValue */.Sx)([
        4,
        4,
        4,
        5,
        5
    ]);
    var target = view === "quiz" ? "_blank" : "_self";
    var ref = (0,react.useState)(4), maxColors = ref[0], setMaxColors = ref[1];
    var handles = initialProduct.groupOptionsMap.handle;
    (0,react.useEffect)(function() {
        setMaxColors(maxColorsFromBp);
    }, [
        maxColorsFromBp
    ]);
    return initialProduct.isGrouped && (handles === null || handles === void 0 ? void 0 : handles.length) ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": ColorOptions.displayName,
        sx: theme.option,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
            as: "ul",
            sx: theme.values,
            children: [
                handles.slice(0, maxColors).map(function(handle, index) {
                    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(ColorOption, {
                        handle: handle,
                        selectedHandle: selectedHandle,
                        setSelectedHandle: setSelectedHandle
                    }, index);
                }),
                handles.length > maxColors && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                    as: "li",
                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(snippets/* Link */.rU, {
                        href: seeAllLink === null || seeAllLink === void 0 ? void 0 : seeAllLink.url,
                        newTab: seeAllLink === null || seeAllLink === void 0 ? void 0 : seeAllLink.newTab,
                        "aria-label": "See all color options.",
                        sx: theme.seeAll,
                        target: target,
                        children: [
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Svg */.ny, {
                                src: "/svgs/arrow-right.svg#arrow-right",
                                alt: "Arrow pointing right",
                                viewBox: "0 0 24 24",
                                sx: theme.seeAll.icon
                            }),
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                                sx: theme.seeAll.text,
                                children: "See All"
                            })
                        ]
                    })
                })
            ]
        })
    }) : null;
});
ColorOptions.displayName = "ColorOptions";

;// CONCATENATED MODULE: ./src/sections/SuperCollection/SuperCollectionProductItem/Details/ColorOptions/index.js


;// CONCATENATED MODULE: ./src/sections/SuperCollection/SuperCollectionProductItem/Details/Details.theme.js



var Details_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        variant: "flex.column.start",
        width: "100%"
    };
    this.productRow = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this.wrapper), {
        minHeight: [
            "113px",
            20
        ],
        overflow: "hidden"
    });
    this.title = {
        variant: "text.h4",
        minHeight: [
            "24px",
            "32px"
        ]
    };
    this.variantStarsWrapper = {
        variant: "flex.row.start.center",
        flexWrap: "wrap",
        columnGap: 6,
        mt: 2
    };
    this.variant = {
        variant: "text.base",
        color: "mediumDarkGray",
        minHeight: "22px"
    };
    this.description = {
        variant: "text.base",
        mt: 2,
        minHeight: "22px"
    };
    this.priceWrapper = {
        mt: 2,
        minHeight: "22px"
    };
    this.newPrice = {
        variant: "text.base",
        color: "red",
        mr: 4
    };
    this.compareAtPrice = {
        variant: "text.base",
        textDecoration: "line-through",
        color: "mediumDarkGray"
    };
    this.price = {
        variant: "text.base"
    };
    this.loader = {
        height: "22px",
        svg: {
            height: "100%",
            color: "gray"
        }
    };
}());

;// CONCATENATED MODULE: ./src/sections/SuperCollection/SuperCollectionProductItem/Details/Details.jsx






var Details = Details_theme_themed(function(param) {
    var theme = param.theme, product = param.product, initialProduct = param.initialProduct, selectedHandle = param.selectedHandle, setSelectedHandle = param.setSelectedHandle, seeAllLink = param.seeAllLink, description = param.description, view = param.view, enableFullProductAccess = param.enableFullProductAccess, handleClick = param.handleClick;
    var ref;
    var titles = (0,react.useMemo)(function() {
        var ref, ref1, ref2;
        var titleArr = product === null || product === void 0 ? void 0 : (ref = product.title) === null || ref === void 0 ? void 0 : ref.split("|");
        return {
            product: (titleArr === null || titleArr === void 0 ? void 0 : (ref1 = titleArr[0]) === null || ref1 === void 0 ? void 0 : ref1.trim()) || "",
            variant: ((ref2 = titleArr === null || titleArr === void 0 ? void 0 : titleArr.slice(1)) === null || ref2 === void 0 ? void 0 : ref2.join("|").trim()) || ""
        };
    }, [
        product === null || product === void 0 ? void 0 : product.title
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
        "data-comp": Details.displayName,
        sx: theme.wrapper,
        className: "".concat(view === "quiz" ? "!gap-2" : ""),
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Link */.rU, {
                href: enableFullProductAccess ? "/products/".concat(product === null || product === void 0 ? void 0 : product.handle) : null,
                tabIndex: "-1",
                onClick: handleClick,
                target: view === "quiz" ? "_blank" : "_self",
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                    as: "h5",
                    sx: theme.title,
                    children: titles === null || titles === void 0 ? void 0 : titles.product
                })
            }),
            description && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                sx: theme.description,
                children: description
            }),
            view === "quiz" && titles.variant && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                sx: theme.variant,
                children: titles.variant
            }),
            view !== "quiz" && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                sx: theme.variantStarsWrapper,
                children: [
                    titles.variant && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                        sx: theme.variant,
                        children: titles.variant
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Link */.rU, {
                        href: "/products/".concat(product === null || product === void 0 ? void 0 : product.handle),
                        tabIndex: "-1",
                        onClick: handleClick,
                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* OkendoStars */.oF, {
                            legacyResourceId: product === null || product === void 0 ? void 0 : product.legacyResourceId,
                            withScroll: false,
                            sx: {
                                my: 0
                            }
                        })
                    })
                ]
            }),
            view === "quiz" && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_jsx_runtime_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(ColorOptions, {
                        initialProduct: initialProduct,
                        selectedHandle: selectedHandle,
                        setSelectedHandle: setSelectedHandle,
                        seeAllLink: seeAllLink,
                        view: view
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Link */.rU, {
                        className: "!mt-3",
                        href: "/products/".concat(product === null || product === void 0 ? void 0 : product.handle),
                        tabIndex: "-1",
                        onClick: handleClick,
                        target: "_blank",
                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* OkendoStars */.oF, {
                            legacyResourceId: product === null || product === void 0 ? void 0 : product.legacyResourceId,
                            withScroll: false,
                            sx: {
                                my: 0
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                sx: theme.priceWrapper,
                children: (product === null || product === void 0 ? void 0 : (ref = product.variants) === null || ref === void 0 ? void 0 : ref[0]) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(snippets/* Locale.Variant */.go.Variant, {
                    variant: product.variants[0],
                    children: [
                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Locale.Price */.go.Price, {
                            children: function(param) {
                                var priceV2 = param.priceV2, compareAtPriceV2 = param.compareAtPriceV2, isOnSale = param.isOnSale;
                                return isOnSale ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                                    children: [
                                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                                            sx: theme.newPrice,
                                            children: priceV2.locale
                                        }),
                                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                                            sx: theme.compareAtPrice,
                                            children: compareAtPriceV2.locale
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                                    sx: theme.price,
                                    children: priceV2.locale
                                });
                            }
                        }),
                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Locale.Loader */.go.Loader, {
                            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                                sx: theme.loader,
                                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Spinner */.$j, {})
                            })
                        })
                    ]
                })
            }),
            view !== "quiz" && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(ColorOptions, {
                initialProduct: initialProduct,
                selectedHandle: selectedHandle,
                setSelectedHandle: setSelectedHandle,
                seeAllLink: seeAllLink
            })
        ]
    });
});
Details.displayName = "Details";

;// CONCATENATED MODULE: ./src/sections/SuperCollection/SuperCollectionProductItem/Details/index.js


;// CONCATENATED MODULE: ./src/sections/SuperCollection/SuperCollectionProductItem/SuperCollectionProductItem.theme.js


var SuperCollectionProductItem_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        variant: "flex.column.start.between",
        height: "100%",
        width: "100%",
        position: "relative",
        '[data-comp="AddToCart"]': {
            opacity: 1,
            transition: "all 0.2s ease-in-out",
            ":focus": {
                opacity: 1
            }
        },
        ":hover": {
            '[data-comp="AddToCart"]': {
                opacity: 1
            }
        }
    };
    this.quizWrapper = {
        display: "grid",
        '[data-comp="Locale.Variant"] p': {
            fontSize: 18
        }
    };
    this.content = {
        width: "100%"
    };
    this.atc = {
        mt: [
            8,
            10
        ],
        width: [
            "100%",
            "unset"
        ]
    };
}());

;// CONCATENATED MODULE: ./src/sections/SuperCollection/SuperCollectionProductItem/SuperCollectionProductItem.jsx














var SuperCollectionProductItem = SuperCollectionProductItem_theme_themed(function(_param) {
    var theme = _param.theme, handle = _param.handle, seeAllLink = _param.seeAllLink, description = _param.description, index = _param.index, view = _param.view, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme",
        "handle",
        "seeAllLink",
        "description",
        "index",
        "view"
    ]);
    if (!handle) return null;
    var sendClickProductItemEvent = (0,hooks/* useDataLayerActions */.KZ)().sendClickProductItemEvent;
    var ref = (0,react.useState)(null), initialProduct = ref[0], setInitialProduct = ref[1];
    var ref1 = (0,react.useState)(handle), selectedHandle = ref1[0], setSelectedHandle = ref1[1];
    var ref2 = (0,react_intersection_observer_dist/* useInView */.YD)({
        rootMargin: "400px",
        triggerOnce: true
    }), ref3 = ref2.ref, inView = ref2.inView;
    var ref4 = (0,dist.useProductByHandle)({
        handle: selectedHandle,
        fetchOnMount: inView
    }), fullProduct = ref4.product;
    var selectedVariant = (0,react.useMemo)(function() {
        var ref;
        return fullProduct === null || fullProduct === void 0 ? void 0 : (ref = fullProduct.variants) === null || ref === void 0 ? void 0 : ref[0];
    }, [
        fullProduct === null || fullProduct === void 0 ? void 0 : fullProduct.id
    ]);
    var localized = (0,dist.useLocalizedVariant)({
        variant: selectedVariant
    }).localized;
    var handleClick = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            sendClickProductItemEvent({
                listIndex: index,
                localized: localized,
                product: fullProduct,
                selectedVariant: selectedVariant
            });
            return [
                2
            ];
        });
    }), [
        index,
        localized,
        fullProduct === null || fullProduct === void 0 ? void 0 : fullProduct.id,
        selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id
    ]);
    (0,react.useEffect)(function() {
        // Update selectedHandle if product updates in cms
        if (!handle) return;
        setSelectedHandle(handle);
    }, [
        handle
    ]);
    (0,react.useEffect)(function() {
        // Update initial product if cms product changes
        if (handle !== (initialProduct === null || initialProduct === void 0 ? void 0 : initialProduct.handle) && handle === (fullProduct === null || fullProduct === void 0 ? void 0 : fullProduct.handle)) {
            setInitialProduct(fullProduct);
        }
    }, [
        handle,
        initialProduct === null || initialProduct === void 0 ? void 0 : initialProduct.handle,
        fullProduct === null || fullProduct === void 0 ? void 0 : fullProduct.handle
    ]);
    (0,react.useEffect)(function() {
        // Set initial product on full product mount
        if (initialProduct || !fullProduct) return;
        setInitialProduct(fullProduct);
    }, [
        fullProduct
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
        "data-comp": SuperCollectionProductItem.displayName,
        ref: ref3,
        sx: (0,_object_spread/* default */.Z)({}, props.sx, view === "quiz" ? theme.quizWrapper : theme.wrapper),
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                sx: theme.content,
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(SuperCollectionProductItem_Image_Image_Image, {
                        product: fullProduct,
                        handleClick: handleClick,
                        view: view,
                        target: view === "quiz" ? "_blank" : "_self"
                    }),
                    initialProduct && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Details, {
                        product: fullProduct,
                        initialProduct: initialProduct,
                        setSelectedHandle: setSelectedHandle,
                        selectedHandle: selectedHandle,
                        seeAllLink: seeAllLink,
                        description: description,
                        handleClick: handleClick,
                        view: view
                    })
                ]
            }),
            fullProduct && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                className: "flex-col md:flex-row md:justify-start justify-center items-center gap-4",
                sx: theme.atc,
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* AddToCart */.o4, {
                        product: fullProduct,
                        selectedVariant: selectedVariant,
                        style: (0,_object_spread/* default */.Z)({}, view === "quiz" ? {
                            mt: 0,
                            mr: 0
                        } : {})
                    }),
                    view === "quiz" && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Link */.rU, {
                        variant: "buttons.articleLink",
                        href: "/products/".concat(fullProduct === null || fullProduct === void 0 ? void 0 : fullProduct.handle),
                        tabIndex: "-1",
                        "aria-hidden": "true",
                        onClick: handleClick,
                        target: "_blank",
                        className: "md:mt-5",
                        children: "Learn More"
                    })
                ]
            })
        ]
    });
});
SuperCollectionProductItem.displayName = "SuperCollectionProductItem";

;// CONCATENATED MODULE: ./src/sections/SuperCollection/SuperCollectionProductItem/index.js


;// CONCATENATED MODULE: ./src/sections/SuperCollection/SuperCollection.theme.js

var SuperCollection_theme_themed = (0,create/* create */.U)(new function() {
    this.mainLayout = {
        variant: "layout.content",
        display: "grid",
        gridTemplateColumns: [
            "1fr",
            "200px 1fr"
        ],
        gridTemplateAreas: [
            '"collection" "footer"',
            '"title collection" "sidebar collection" "sidebar footer"', 
        ],
        gridTemplateRows: "min-content 1fr",
        columnGap: 6,
        rowGap: 0,
        pt: [
            0,
            14,
            15
        ],
        pb: [
            14,
            18,
            "80px"
        ],
        alignItems: "flex-start"
    };
    this.mobileHeader = {
        display: [
            "contents",
            "none"
        ],
        mb: 12
    };
    this.mobileHeading = {
        variant: "text.h2",
        px: 8,
        my: 10
    };
    this.desktopHeader = {
        gridArea: "sidebar",
        display: [
            "none",
            "contents"
        ]
    };
    this.desktopHeading = {
        variant: "text.h2",
        mb: "28px",
        overflowWrap: "break-word",
        gridArea: "title"
    };
    this.grid = {
        gridArea: "collection",
        gridTemplateColumns: [
            "repeat(1, 1fr)",
            "repeat(2, 1fr)"
        ],
        pt: [
            11,
            0
        ],
        pb: [
            14,
            18,
            "80px"
        ],
        display: "grid",
        columnGap: [
            10,
            12
        ],
        rowGap: [
            14,
            12
        ]
    };
    this.noProducts = {
        variant: "flex.column",
        text: {
            variant: "text.lg",
            mt: 20,
            textAlign: "center"
        }
    };
    this.seoText = {
        variant: "text.base",
        fontSize: [
            3,
            4
        ],
        lineHeight: [
            20,
            22
        ]
    };
}());

;// CONCATENATED MODULE: ./src/sections/SuperCollection/SuperCollectionGrid.jsx




var SuperCollectionGrid = SuperCollection_theme_themed(function(param) {
    var theme = param.theme, products = param.products;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Container */.W2, {
        "data-comp": SuperCollectionGrid.displayName,
        sx: theme.grid,
        children: products === null || products === void 0 ? void 0 : products.map(function(param, index) {
            var product = param.product, link = param.link, description = param.description;
            var handle = product === null || product === void 0 ? void 0 : product.handle;
            if (!handle) return null;
            return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(SuperCollectionProductItem, {
                handle: handle,
                seeAllLink: link,
                description: description,
                index: index
            }, index);
        })
    });
});
SuperCollectionGrid.displayName = "SuperCollectionGrid";

;// CONCATENATED MODULE: ./src/sections/SuperCollection/SuperCollectionSeoFooter.jsx




var SuperCollectionSeoFooter = SuperCollection_theme_themed(function(param) {
    var body = param.body, theme = param.theme;
    return body ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": SuperCollectionSeoFooter.displayName,
        sx: {
            gridArea: "footer"
        },
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Markdown */.UG, {
            text: body,
            textSx: theme.seoText
        })
    }) : null;
});
SuperCollectionSeoFooter.displayName = "SuperCollectionSeoFooter";

;// CONCATENATED MODULE: ./src/sections/SuperCollection/SuperCollection.schema.js
function SuperCollection_schema_Schema(param) {
    var page = param.page;
    if (!page) return null;
    return {
        label: "Super Collection",
        key: "super-collection",
        fields: [
            {
                label: "Super Collection Title",
                name: "title",
                component: "text",
                defaultValue: "All Can Holders"
            },
            {
                label: "Product Tiles",
                name: "tiles",
                component: "group",
                fields: [
                    {
                        name: "products",
                        label: "Products",
                        description: "Primary product handle and See All link for each tile",
                        component: "group-list",
                        itemProps: {
                            label: "{{item.product.handle}}" || 0
                        },
                        defaultItem: {
                            product: {
                                handle: "hopsulator-slim-onyx-leopard-12oz-slim-cans"
                            },
                            link: {
                                url: "/collections/hopsulator-slim"
                            }
                        },
                        fields: [
                            {
                                label: "See All Link",
                                name: "link",
                                component: "link"
                            },
                            {
                                name: "product",
                                component: "productSearch",
                                label: "Product"
                            },
                            {
                                name: "description",
                                component: "textarea",
                                label: "Product Description"
                            }, 
                        ],
                        defaultValue: [
                            {
                                product: {
                                    handle: "hopsulator-slim-onyx-leopard-12oz-slim-cans"
                                },
                                link: {
                                    url: "/collections/hopsulator-slim"
                                }
                            },
                            {
                                product: {
                                    handle: "hopsulator-duo-2-in-1-onyx-leopard-12oz-cans-tumbler"
                                },
                                link: {
                                    url: "/collections/hopsulator-duo"
                                }
                            },
                            {
                                product: {
                                    handle: "hopsulator-trio-3-in-1-onyx-leopard-16oz-12oz-cans"
                                },
                                link: {
                                    url: "/collections/hopsulator-trio"
                                }
                            },
                            {
                                product: {
                                    handle: "hopsulator-bottl-onyx-leopard-12oz-bottles"
                                },
                                link: {
                                    url: "/collections/hopsulator-bott-l"
                                }
                            }, 
                        ]
                    }, 
                ]
            },
            {
                label: "Collection Categories",
                name: "menu",
                component: "group",
                description: "Preset list of collection or page links",
                fields: [
                    {
                        label: "Name",
                        name: "name",
                        component: "text",
                        defaultValue: "Size"
                    },
                    {
                        name: "collapsed",
                        label: "Dropdown Collapsed (Desktop)",
                        component: "toggle",
                        toggleLabels: {
                            true: "On",
                            false: "Off"
                        },
                        defaultValue: false
                    },
                    {
                        label: "Categories",
                        name: "categories",
                        component: "group-list",
                        itemProps: {
                            label: "{{item.link.text}}"
                        },
                        defaultItem: {
                            link: {
                                text: "Slim (12oz Slim Cans)",
                                url: "/collections/hopsulator-slim"
                            },
                            mobileImage: {
                                product: {
                                    handle: "hopsulator-slim-onyx-leopard-12oz-slim-cans"
                                }
                            }
                        },
                        fields: [
                            {
                                label: "Collection Link",
                                name: "link",
                                component: "link"
                            },
                            {
                                label: "Image (mobile)",
                                name: "mobileImage",
                                description: "Use default image of specific product or manual upload of image",
                                component: "group",
                                fields: [
                                    {
                                        name: "image",
                                        label: "Manual Image",
                                        component: "image",
                                        description: "If provided, this image will override the default image of the product"
                                    },
                                    {
                                        name: "product",
                                        component: "productSearch",
                                        label: "Default Image of Specific Product"
                                    }, 
                                ],
                                defaultValue: {}
                            }, 
                        ],
                        defaultValue: [
                            {
                                link: {
                                    text: "All Can Holders",
                                    url: "/collections/can-holders"
                                },
                                mobileImage: {
                                    product: {
                                        handle: "hopsulator-slim-gold-leopard-12oz-slim-cans"
                                    }
                                }
                            },
                            {
                                link: {
                                    text: "Slim (12oz Slim Cans)",
                                    url: "/collections/hopsulator-slim"
                                },
                                mobileImage: {
                                    product: {
                                        handle: "hopsulator-slim-onyx-leopard-12oz-slim-cans"
                                    }
                                }
                            },
                            {
                                link: {
                                    text: "Trio (12/16oz Cans)",
                                    url: "/collections/hopsulator-trio"
                                },
                                mobileImage: {
                                    product: {
                                        handle: "hopsulator-trio-v2-0-by-brumate-matte-navy"
                                    }
                                }
                            }, 
                        ]
                    }, 
                ]
            },
            {
                label: "SEO Footer",
                name: "seo",
                component: "group",
                fields: [
                    {
                        label: "Body",
                        name: "body",
                        component: "markdown"
                    }, 
                ],
                defaultValue: {
                    body: "**THE INSULATED BEER TUMBLER YOU'VE BEEN LOOKING FOR**\n\nBr\xfcMate's range of beer and seltzer can coolers are here to take your drinking game to the next level. No matter what you're drinking, we have an insulated tumbler for it. Are you a fan of White Claw or Truly? Try our Hopsulator Slim. Think beer just tastes better from a bottle? We've made the Bott'l just for you. Don't like drinking from a can? Check out our 20oz Imperial Pint. Big beer drinker? We have the Juggernaut to keep your tall boys covered.\n\n**A BEER TUMBLER TO TAKE WITH YOU ANYWHERE**\n\nWith Br\xfcMate beer tumblers and can coolers, the days of worrying about glass at the pool are over! You can safely bring your beer on the pool deck, out on your back patio, out stargazing, to the beach. A Hopsulator or Imperial Pint definitely solves everyone's least favorite party problem: lukewarm beers and seltzer. Not to mention, if you snag our state of the art Growl'r, you can bring your tasty homebrew or local brewery favorite to your next gathering.\n\n**INNOVATIVE, UNIQUE DRINKWARE AND GOOD TIMES**\n\nAt Br\xfcMate, we are committed to designing the products you need to keep your beers and seltzer ice-cold from the first sip to the last. To put it plainly: Life is better with a cold beer in hand. So go ahead, and have fun. Grab some friends, kick back, and relax, knowing we've got your back, and your beers will stay ice cold."
                }
            }, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/SuperCollection/SuperCollection.jsx










var SuperCollection = (0,src_utils/* withInView */.Dh)(SuperCollection_theme_themed(function(param) {
    var cms = param.cms, theme = param.theme;
    var title = cms.title, tiles = cms.tiles, menu = cms.menu, seo = cms.seo, _hideBreadCrumb = cms.hideBreadCrumb, hideBreadCrumb = _hideBreadCrumb === void 0 ? false : _hideBreadCrumb;
    var setCollectionsMap = (0,store/* useSetRecoilState */.Zl)(store/* default.collectionsMap */.ZP.collectionsMap);
    var setSuperCollectionTitle = (0,store/* useSetRecoilState */.Zl)(store/* default.superCollectionTitle */.ZP.superCollectionTitle);
    (0,react.useEffect)(function() {
        var ref, ref1;
        if (menu === null || menu === void 0 ? void 0 : (ref = menu.categories) === null || ref === void 0 ? void 0 : ref.length) {
            setSuperCollectionTitle(title);
        }
        var titles = menu === null || menu === void 0 ? void 0 : (ref1 = menu.categories) === null || ref1 === void 0 ? void 0 : ref1.map(function(category) {
            var ref, ref1, ref2, ref3;
            return {
                title: (ref1 = (ref = category.link) === null || ref === void 0 ? void 0 : ref.url.split("/")) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[2]) === null || ref2 === void 0 ? void 0 : ref2.split("-").map(function(word) {
                    return word.charAt(0).toUpperCase() + word.slice(1);
                }).join(" "),
                url: (ref3 = category.link) === null || ref3 === void 0 ? void 0 : ref3.url
            };
        });
        setCollectionsMap(titles);
        return function() {
            setCollectionsMap([]);
        };
    }, [
        menu === null || menu === void 0 ? void 0 : menu.categories
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Container */.W2, {
        "data-comp": SuperCollection.displayName,
        children: [
            !hideBreadCrumb && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Breadcrumbs */.Oo, {
                isSuperCollection: true,
                superCollectionTitle: title
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                sx: theme.mobileHeader,
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                        as: "h1",
                        sx: theme.mobileHeading,
                        children: title
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* CollectionCategories */.g0, {
                        categories: menu === null || menu === void 0 ? void 0 : menu.categories,
                        collapsed: menu === null || menu === void 0 ? void 0 : menu.collapsed,
                        name: menu === null || menu === void 0 ? void 0 : menu.name,
                        isSuperCollection: true
                    })
                ]
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Container */.W2, {
                sx: theme.mainLayout,
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                        sx: theme.desktopHeader,
                        children: [
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                                as: "h1",
                                sx: theme.desktopHeading,
                                children: title
                            }),
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* CollectionCategories */.g0, {
                                categories: menu === null || menu === void 0 ? void 0 : menu.categories,
                                collapsed: menu === null || menu === void 0 ? void 0 : menu.collapsed,
                                name: menu === null || menu === void 0 ? void 0 : menu.name,
                                isSuperCollection: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(SuperCollectionGrid, {
                        products: tiles === null || tiles === void 0 ? void 0 : tiles.products
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(SuperCollectionSeoFooter, {
                        body: seo === null || seo === void 0 ? void 0 : seo.body
                    })
                ]
            })
        ]
    });
}), {
    triggerOnce: true
});
SuperCollection.displayName = "SuperCollection";
SuperCollection.Schema = SuperCollection_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/SuperCollection/index.js


;// CONCATENATED MODULE: ./src/sections/TabbedThreeTile/TabbedThreeTile.schema.js



var defaultBestSellers = [
    {
        name: "Can Holders",
        items: [
            {
                alt: "A person holding a Hopsulator Slim with a can inside.",
                imageDt: {
                    src: "https://cdn.shopify.com/s/files/1/1114/2308/files/HopsulatorSlim.png"
                },
                image: {
                    src: "https://cdn.shopify.com/s/files/1/1114/2308/files/HopsulatorSlim.png"
                },
                title: "Hopsulator Slim",
                bulletPoints: [
                    {
                        text: "Works with all 12oz Slim Cans"
                    },
                    {
                        text: "20x Colder than other Can Coolers"
                    }, 
                ],
                link: {
                    url: "/products/hopsulator-slim-gold-leopard-12oz-slim-cans"
                }
            },
            {
                alt: "A tattoed person presenting a marble textured Hopsulator Duo  with a canned beverage inside.",
                imageDt: {
                    src: "https://cdn.shopify.com/s/files/1/1114/2308/files/HopsulatorDuo.png"
                },
                image: {
                    src: "https://cdn.shopify.com/s/files/1/1114/2308/files/HopsulatorDuo.png"
                },
                title: "Hopsulator Trio",
                bulletPoints: [
                    {
                        text: "Works with all 12oz Slim Cans"
                    },
                    {
                        text: "20x Colder than other Can Coolers"
                    }, 
                ],
                link: {
                    url: "/products/hopsulator-trio-v2-0-by-brumate-walnut"
                }
            },
            {
                alt: "A tattoed person presenting a marble textured Hopsulator Duo  with a canned beverage inside.",
                imageDt: {
                    src: "https://cdn.shopify.com/s/files/1/1114/2308/files/HopsulatorTrio.png"
                },
                image: {
                    src: "https://cdn.shopify.com/s/files/1/1114/2308/files/HopsulatorTrio.png"
                },
                title: "Hopsulator Duo",
                bulletPoints: [
                    {
                        text: "Works with all 12oz Slim Cans"
                    },
                    {
                        text: "20x Colder than other Can Coolers"
                    }, 
                ],
                link: {
                    url: "/products/hopsulator-slim-gold-leopard-12oz-slim-cans"
                }
            }, 
        ],
        cta: {
            url: "/collections/can-holders",
            text: "shop all can holders"
        }
    },
    // Mugs Section
    {
        name: "Mugs",
        items: [
            {
                alt: "A person holding a Hopsulator Slim with a can inside.",
                imageDt: {
                    src: "https://cdn.shopify.com/s/files/1/1114/2308/files/HopsulatorSlim.png"
                },
                image: {
                    src: "https://cdn.shopify.com/s/files/1/1114/2308/files/HopsulatorSlim.png"
                },
                title: "Mug Example 1",
                bulletPoints: [
                    {
                        icon: {
                            src: "https://cdn.shopify.com/s/files/1/1114/2308/files/arrow.png",
                            alt: "An arrow pointing right"
                        },
                        text: "Works with all 12oz Slim Cans"
                    },
                    {
                        text: "20x Colder than other Can Coolers"
                    }, 
                ],
                link: {
                    url: "/products/hopsulator-slim-gold-leopard-12oz-slim-cans",
                    text: "Buy Now"
                },
                cta: true
            },
            {
                alt: "A person holding a Hopsulator Slim with a can inside.",
                imageDt: {
                    src: "https://cdn.shopify.com/s/files/1/1114/2308/files/HopsulatorSlim.png"
                },
                image: {
                    src: "https://cdn.shopify.com/s/files/1/1114/2308/files/HopsulatorSlim.png"
                },
                title: "Mug example 2",
                bulletPoints: [
                    {
                        text: "Works with all 12oz Slim Cans"
                    },
                    {
                        text: "20x Colder than other Can Coolers"
                    }, 
                ],
                link: {
                    url: "/products/hopsulator-slim-gold-leopard-12oz-slim-cans"
                }
            },
            {
                alt: "A person holding a Hopsulator Slim with a can inside.",
                imageDt: {
                    src: "https://cdn.shopify.com/s/files/1/1114/2308/files/HopsulatorSlim.png"
                },
                image: {
                    src: "https://cdn.shopify.com/s/files/1/1114/2308/files/HopsulatorSlim.png"
                },
                title: "Mug Example 3",
                bulletPoints: [
                    {
                        text: "Works with all 12oz Slim Cans"
                    },
                    {
                        text: "20x Colder than other Can Coolers"
                    }, 
                ],
                link: {
                    url: "/products/hopsulator-slim-gold-leopard-12oz-slim-cans"
                }
            }, 
        ],
        cta: {
            url: "/collections/mugs",
            text: "shop all mugs"
        }
    },
    // Water Bottles Section
    {
        name: "Water Bottles",
        items: [
            {
                alt: "A person holding a Hopsulator Slim with a can inside.",
                imageDt: {
                    src: "https://cdn.shopify.com/s/files/1/1114/2308/files/HopsulatorSlim.png"
                },
                image: {
                    src: "https://cdn.shopify.com/s/files/1/1114/2308/files/HopsulatorSlim.png"
                },
                title: "WB Example 1",
                bulletPoints: [
                    {
                        text: "Works with all 12oz Slim Cans"
                    },
                    {
                        text: "20x Colder than other Can Coolers"
                    }, 
                ],
                link: {
                    url: "/products/hopsulator-slim-gold-leopard-12oz-slim-cans"
                }
            },
            {
                alt: "A person holding a Hopsulator Slim with a can inside.",
                imageDt: {
                    src: "https://cdn.shopify.com/s/files/1/1114/2308/files/HopsulatorSlim.png"
                },
                image: {
                    src: "https://cdn.shopify.com/s/files/1/1114/2308/files/HopsulatorSlim.png"
                },
                title: "WB Example 2",
                bulletPoints: [
                    {
                        text: "Works with all 12oz Slim Cans"
                    },
                    {
                        text: "20x Colder than other Can Coolers"
                    },
                    {
                        text: "Works with all 12oz Slim Cans"
                    }, 
                ],
                link: {
                    url: "/products/hopsulator-slim-gold-leopard-12oz-slim-cans"
                }
            },
            {
                alt: "A person holding a Hopsulator Slim with a can inside.",
                imageDt: {
                    src: "https://cdn.shopify.com/s/files/1/1114/2308/files/HopsulatorSlim.png"
                },
                image: {
                    src: "https://cdn.shopify.com/s/files/1/1114/2308/files/HopsulatorSlim.png"
                },
                title: "WB Example 3",
                bulletPoints: [
                    {
                        text: "Works with all 12oz Slim Cans"
                    },
                    {
                        text: "20x Colder than other Can Coolers"
                    }, 
                ],
                link: {
                    url: "/products/hopsulator-slim-gold-leopard-12oz-slim-cans"
                }
            }, 
        ],
        cta: {
            url: "/collections/water-bottles",
            text: "shop all water bottles"
        }
    }, 
];
function TabbedThreeTile_schema_Schema(param) {
    var article = param.article, blog = param.blog, collection = param.collection;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    if (article || blog || collection) return null;
    return {
        label: "Tabbed Three Tile",
        key: "tabbed-three-tile",
        fields: [
            {
                name: "tabs",
                label: "Product tabs",
                description: "Max 5 tabs, with 3 items each",
                component: "group-list",
                itemProps: {
                    label: "{{item.name}}: {{item.items.length}}"
                },
                defaultItem: (0,_object_spread/* default */.Z)({}, defaultBestSellers[0] || "New Item"),
                fields: [
                    {
                        name: "name",
                        label: "Tab name",
                        component: "text"
                    },
                    {
                        name: "items",
                        label: "Items",
                        component: "group-list",
                        itemProps: {
                            label: "{{item.title}}" || 0
                        },
                        fields: [
                            {
                                name: "alt",
                                label: "Image alt",
                                component: "text",
                                description: "Provide a brief description of the image for accessibility compliance"
                            },
                            {
                                name: "imageDt",
                                label: "Image (desktop)",
                                description: "Image to be displayed on desktop devices",
                                component: "image"
                            },
                            {
                                name: "image",
                                label: "Image (mobile)",
                                description: "Image to be displayed on mobile devices",
                                component: "image"
                            },
                            {
                                name: "title",
                                label: "Title",
                                component: "text",
                                description: "Title heading of the tile"
                            },
                            {
                                name: "bulletPoints",
                                label: "Bullet Points",
                                component: "group-list",
                                description: "Icon and short text (Max: 3)",
                                itemProps: {
                                    label: "{{item.text}}" || 0
                                },
                                defaultItem: (0,_object_spread/* default */.Z)({}, ((ref1 = (ref = defaultBestSellers[0]) === null || ref === void 0 ? void 0 : ref.items[0]) === null || ref1 === void 0 ? void 0 : ref1.bulletPoints[0]) || "New BulletPoint"),
                                fields: [
                                    {
                                        name: "text",
                                        label: "Bullet point text",
                                        component: "markdown",
                                        description: "Works best with 50 characters or less. **Note: highlight a section of text and click the link button in the markdown menu to hyperlink to a page or product"
                                    },
                                    {
                                        name: "icon",
                                        label: "Custom Icon",
                                        component: "image",
                                        description: "Optional: Upload a 32x32 transparent PNG. (If left blank the default icon will be used)"
                                    },
                                    {
                                        name: "alt",
                                        label: "Custom Icon alt",
                                        component: "text",
                                        description: "Provide a brief description of the custom icon for accessibility compliance. (Not used if no custom icon is selected above)"
                                    }, 
                                ]
                            },
                            {
                                name: "link",
                                label: "Link",
                                component: "link",
                                description: "Provides the title and image a link to a page or product"
                            },
                            {
                                name: "cta",
                                label: "Tile CTA button",
                                component: "toggle",
                                description: "Optional: Add a button to the bottom of this tile, using the link field above for its URL and text",
                                toggleLabels: {
                                    true: "Enable",
                                    false: "Disable"
                                },
                                defaultValue: false
                            }, 
                        ],
                        defaultValue: {
                            imageDt: {
                                src: (ref3 = (ref2 = defaultBestSellers[0]) === null || ref2 === void 0 ? void 0 : ref2.items[0]) === null || ref3 === void 0 ? void 0 : ref3.imageDt.src
                            },
                            image: {
                                src: (ref5 = (ref4 = defaultBestSellers[0]) === null || ref4 === void 0 ? void 0 : ref4.items[0]) === null || ref5 === void 0 ? void 0 : ref5.image.src
                            },
                            title: (ref7 = (ref6 = defaultBestSellers[0]) === null || ref6 === void 0 ? void 0 : ref6.items[0]) === null || ref7 === void 0 ? void 0 : ref7.title,
                            bulletPoints: (ref9 = (ref8 = defaultBestSellers[0]) === null || ref8 === void 0 ? void 0 : ref8.items[0]) === null || ref9 === void 0 ? void 0 : ref9.bulletPoints,
                            link: (ref11 = (ref10 = defaultBestSellers[0]) === null || ref10 === void 0 ? void 0 : ref10.items[0]) === null || ref11 === void 0 ? void 0 : ref11.link
                        }
                    },
                    {
                        name: "cta",
                        component: "link",
                        label: "Tab CTA button",
                        description: "Appears at the bottom of the tab"
                    }, 
                ],
                defaultValue: defaultBestSellers
            },
            {
                label: "Tab & tiles Settings",
                name: "settings",
                description: "Heading, menu/text alignment, image ratio, button style",
                component: "group",
                fields: [
                    {
                        name: "heading",
                        label: "Heading",
                        component: "text",
                        description: "Appears above the menu at the top of the section"
                    },
                    {
                        name: "textAlignDt",
                        component: "radio-group",
                        label: "Heading alignment (desktop)",
                        description: "Aligns the heading text on desktop",
                        variant: "radio",
                        direction: "horizontal",
                        options: common/* align.options */.AJ.options
                    },
                    {
                        name: "textAlign",
                        component: "radio-group",
                        label: "Heading alignment (mobile)",
                        variant: "radio",
                        direction: "horizontal",
                        options: common/* align.options */.AJ.options
                    },
                    {
                        name: "menuAlignDt",
                        label: "Tab menu alignment (desktop)",
                        description: "Heading menu alignment on desktop",
                        component: "radio-group",
                        variant: "radio",
                        direction: "horizontal",
                        options: common/* align.options */.AJ.options
                    },
                    {
                        name: "menuAlign",
                        label: "Tab menu alignment (mobile)",
                        component: "radio-group",
                        variant: "radio",
                        direction: "horizontal",
                        options: common/* align.options */.AJ.options
                    },
                    {
                        name: "imageRatio",
                        label: "Tile image aspect ratio",
                        direction: "horizontal",
                        variant: "radio",
                        component: "radio-group",
                        options: [
                            {
                                label: "1:1",
                                value: "square"
                            },
                            {
                                label: "3:4",
                                value: "portrait"
                            }, 
                        ]
                    },
                    {
                        name: "ctaStyle",
                        label: "Tab CTA button style",
                        description: "Appearance of the CTA buttons on the tile and tab",
                        component: "select",
                        options: common/* button.options */.LI.options
                    }, 
                ],
                defaultValue: {
                    heading: "Best sellers",
                    textAlignDt: common/* align.value.center */.AJ.value.center,
                    textAlign: common/* align.value.left */.AJ.value.left,
                    menuAlignDt: common/* align.value.center */.AJ.value.center,
                    menuAlign: common/* align.value.left */.AJ.value.left,
                    imageRatio: "portrait",
                    ctaStyle: common/* button.value.inverseSecondary */.LI.value.inverseSecondary
                }
            },
            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, common/* section */.qi), {
                defaultValue: {
                    bgColor: common/* color.value.gray */.$_.value.gray,
                    color: common/* color.value.text */.$_.value.text,
                    desktop: {
                        container: "padded",
                        mt: "none",
                        py: "m"
                    },
                    mobile: {
                        container: "container",
                        mt: "none",
                        py: "m"
                    }
                }
            }), 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/TabbedThreeTile/TabbedThreeTile.theme.js

var TabbedThreeTile_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        display: "flex",
        flexDirection: "column",
        pr: 0,
        minHeight: [
            "400px",
            "500px"
        ]
    };
    this.header = {
    };
    this.slider = {
    };
}());

;// CONCATENATED MODULE: ./src/sections/TabbedThreeTile/Header/Header.theme.js

var TabbedThreeTile_Header_Header_theme_themed = (0,create/* create */.U)(new function() {
    this.header = {
        display: "flex",
        flexDirection: "column",
        mb: [
            8,
            null,
            null,
            14
        ],
        borderBottom: "1px solid",
        borderColor: "mediumGray"
    };
    this.heading = {
        variant: "text.h2",
        flex: 1,
        mb: [
            10,
            11
        ]
    };
    this.tabs = {
        width: [
            "100%",
            "auto"
        ],
        height: "100%",
        overflowY: "hidden",
        overflowX: "auto",
        webkitOverflowScrolling: "touch",
        msOverflowStyle: "none",
        scrollbarWidth: "none",
        "::-webkit-scrollbar": {
            display: "none"
        },
        mb: "-1px"
    };
    this.list = {
        display: "flex"
    };
    this.listItem = {
        minWidth: "auto",
        fontWeight: 500,
        "is:last-child": {
            mr: 0
        }
    };
    this.button = {
        variant: "buttons.groupText",
        fontSize: 5,
        fontWeight: 500
    };
}());

;// CONCATENATED MODULE: ./src/sections/TabbedThreeTile/Header/Header.jsx






var Header_Header_Header = TabbedThreeTile_Header_Header_theme_themed(function(param) {
    var theme = param.theme, tabs = param.tabs, _settings = param.settings, settings = _settings === void 0 ? {} : _settings, activeIndex = param.activeIndex, setActiveIndex = param.setActiveIndex, swiper = param.swiper;
    var textAlign = settings.textAlign, textAlignDt = settings.textAlignDt, menuAlign = settings.menuAlign, menuAlignDt = settings.menuAlignDt, heading = settings.heading;
    var isTabs = (tabs === null || tabs === void 0 ? void 0 : tabs.length) > 1;
    var justifyContentArr = [
        (0,src_utils/* convertAlignToFlex */.nG)(textAlign),
        (0,src_utils/* convertAlignToFlex */.nG)(textAlign),
        isTabs ? "space-between" : (0,src_utils/* convertAlignToFlex */.nG)(textAlignDt),
        isTabs ? "space-between" : (0,src_utils/* convertAlignToFlex */.nG)(textAlignDt), 
    ];
    var alignItemsArr = [
        (0,src_utils/* convertAlignToFlex */.nG)(textAlign),
        (0,src_utils/* convertAlignToFlex */.nG)(textAlign),
        (0,src_utils/* convertAlignToFlex */.nG)(textAlignDt),
        (0,src_utils/* convertAlignToFlex */.nG)(textAlignDt), 
    ];
    var justifyMenuArr = [
        (0,src_utils/* convertAlignToFlex */.nG)(menuAlign),
        (0,src_utils/* convertAlignToFlex */.nG)(menuAlign),
        (0,src_utils/* convertAlignToFlex */.nG)(menuAlignDt),
        (0,src_utils/* convertAlignToFlex */.nG)(menuAlignDt), 
    ];
    var textAlignArr = [
        textAlign,
        textAlign,
        isTabs ? "left" : textAlignDt,
        isTabs ? "left" : textAlignDt, 
    ];
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": Header_Header_Header.displayName,
        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.header), {
            justifyContent: justifyContentArr,
            alignItems: alignItemsArr
        }),
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                as: "h2",
                variant: "h2",
                sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.heading), {
                    textAlign: textAlignArr
                }),
                children: heading
            }),
            isTabs && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                sx: theme.tabs,
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                    role: "tablist",
                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.list), {
                        justifyContent: justifyMenuArr
                    }),
                    children: tabs.slice(0, 5).map(function(param, index, arr) {
                        var name = param.name;
                        var isActive = index === activeIndex;
                        return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                            sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.listItem), {
                                mr: index !== arr.length - 1 ? [
                                    "30px",
                                    null,
                                    17
                                ] : 0,
                                button: {
                                    ":after": {
                                        transform: isActive ? "translate3D(0, 0, 30px)" : "translateX(-102%)"
                                    }
                                }
                            }),
                            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                                role: "tab",
                                variant: "buttons.plain",
                                "aria-selected": isActive ? "true" : "false",
                                onClick: function() {
                                    setActiveIndex(index);
                                    if (swiper) swiper.slideTo(0);
                                },
                                sx: (0,_object_spread/* default */.Z)({}, theme.button),
                                children: name
                            })
                        }, name);
                    })
                })
            })
        ]
    });
});
Header_Header_Header.displayName = "Header";

;// CONCATENATED MODULE: ./src/sections/TabbedThreeTile/Header/index.js


;// CONCATENATED MODULE: ./src/sections/TabbedThreeTile/Tile/Tile.theme.js



var TabbedThreeTile_Tile_Tile_theme_themed = (0,create/* create */.U)(new function() {
    this.image = {
        mb: [
            10,
            11
        ]
    };
    this.imageLink = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this.image), {
        ":hover": {
            img: {
                transform: "scale(1.03)"
            }
        },
        img: {
            transform: "scale(1.01)",
            transition: "transform 0.3s ease-in-out"
        }
    });
    this.content = {
        flexDirection: "column",
        py: 0
    };
    this.heading = {
        variant: "text.h4"
    };
    this.body = {
        variant: "text.base",
        ml: [
            2,
            3
        ],
        flex: 1
    };
    this.button = {
        mt: 4
    };
    this.flexed = {
        display: "flex",
        alignItems: "center",
        ":hover": {
            svg: {
                transform: "translate3d(5px, 0, 0)",
                transition: "transform 0.3s ease-in-out"
            }
        }
    };
    this.icon = {
        ml: 7,
        width: "24px"
    };
    this.bulletpoint = {
        variant: "flex.row.center",
        pt: [
            3,
            5
        ],
        icon: {
            minWidth: "32px",
            maxWidth: "32px"
        }
    };
}());

;// CONCATENATED MODULE: ./src/sections/TabbedThreeTile/Tile/Tile.jsx








var TabbedThreeTile_Tile_Tile_Tile = TabbedThreeTile_Tile_Tile_theme_themed(function(_param) {
    var theme = _param.theme, item = _param.item, _settings = _param.settings, settings = _settings === void 0 ? {} : _settings, inputRef = _param.inputRef, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme",
        "item",
        "settings",
        "inputRef"
    ]);
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var imageRatio = settings.imageRatio, textAlign = settings.textAlign, ctaStyle = settings.ctaStyle;
    var defaultIcon = {
        src: "/svgs/circle-checkmark.svg#circle-checkmark",
        alt: "checkmark"
    };
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-comp": TabbedThreeTile_Tile_Tile_Tile.displayName
    }, props), {
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Link */.rU, {
                tabIndex: "-1",
                "aria-hidden": "true",
                href: item === null || item === void 0 ? void 0 : (ref = item.link) === null || ref === void 0 ? void 0 : ref.url,
                newTab: item === null || item === void 0 ? void 0 : (ref1 = item.link) === null || ref1 === void 0 ? void 0 : ref1.newTab,
                sx: (item === null || item === void 0 ? void 0 : (ref2 = item.link) === null || ref2 === void 0 ? void 0 : ref2.url) ? theme.imageLink : theme.image,
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Picture */.t, {
                    alt: item === null || item === void 0 ? void 0 : item.alt,
                    images: [
                        {
                            src: item === null || item === void 0 ? void 0 : (ref3 = item.image) === null || ref3 === void 0 ? void 0 : ref3.src,
                            width: 250,
                            ratio: imageRatio === "square" ? 1 : 0.75
                        },
                        {
                            src: item === null || item === void 0 ? void 0 : (ref4 = item.imageDt) === null || ref4 === void 0 ? void 0 : ref4.src,
                            width: 410,
                            ratio: imageRatio === "square" ? 1 : 0.75
                        }, 
                    ]
                })
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.content), {
                    alignItems: (0,src_utils/* convertAlignToFlex */.nG)(textAlign),
                    textAlign: textAlign
                }),
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Link */.rU, {
                        href: item === null || item === void 0 ? void 0 : (ref5 = item.link) === null || ref5 === void 0 ? void 0 : ref5.url,
                        newTab: item === null || item === void 0 ? void 0 : (ref6 = item.link) === null || ref6 === void 0 ? void 0 : ref6.newTab,
                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                            sx: theme.flexed,
                            children: [
                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                                    as: "h3",
                                    sx: theme.heading,
                                    children: item === null || item === void 0 ? void 0 : item.title
                                }),
                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Svg */.ny, {
                                    src: "/svgs/arrow-right.svg#arrow-right",
                                    alt: "Arrow pointing right",
                                    viewBox: "0 0 24 24",
                                    sx: theme.icon
                                })
                            ]
                        })
                    }),
                    (item === null || item === void 0 ? void 0 : item.bulletPoints) && (item === null || item === void 0 ? void 0 : item.bulletPoints.slice(0, 3).map(function(bulletpoint, index) {
                        var ref, ref1;
                        var isCustomIcon = (bulletpoint === null || bulletpoint === void 0 ? void 0 : (ref = bulletpoint.icon) === null || ref === void 0 ? void 0 : ref.src) ? bulletpoint.icon.src : defaultIcon.src;
                        return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                            sx: theme.bulletpoint,
                            children: [
                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Svg */.ny, {
                                    src: isCustomIcon,
                                    alt: (bulletpoint === null || bulletpoint === void 0 ? void 0 : (ref1 = bulletpoint.icon) === null || ref1 === void 0 ? void 0 : ref1.alt) || (defaultIcon === null || defaultIcon === void 0 ? void 0 : defaultIcon.alt),
                                    viewBox: "0 0 32 32",
                                    sx: theme.bulletpoint.icon
                                }),
                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Markdown */.UG, {
                                    text: bulletpoint === null || bulletpoint === void 0 ? void 0 : bulletpoint.text,
                                    textSx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.body), {
                                        textAlign: textAlign
                                    })
                                })
                            ]
                        }, index);
                    })),
                    (item === null || item === void 0 ? void 0 : item.cta) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Link */.rU, {
                        href: item === null || item === void 0 ? void 0 : (ref7 = item.link) === null || ref7 === void 0 ? void 0 : ref7.url,
                        newTab: item === null || item === void 0 ? void 0 : (ref8 = item.link) === null || ref8 === void 0 ? void 0 : ref8.newTab,
                        variant: "buttons.".concat(ctaStyle || "secondary"),
                        sx: theme.button,
                        children: item === null || item === void 0 ? void 0 : (ref9 = item.link) === null || ref9 === void 0 ? void 0 : ref9.text
                    })
                ]
            })
        ]
    }));
});
TabbedThreeTile_Tile_Tile_Tile.displayName = "Tile";

;// CONCATENATED MODULE: ./src/sections/TabbedThreeTile/Tile/index.js


;// CONCATENATED MODULE: ./src/sections/TabbedThreeTile/Slider/Slider.theme.js

var TabbedThreeTile_Slider_Slider_theme_themed = (0,create/* create */.U)(new function() {
    this.swiper = {
        ".swiper-container": {
            cursor: [
                "grab",
                "auto"
            ]
        },
        ".swiper-container, .swiper-wrapper, .swiper-slide": {
            height: "auto !important",
            width: "100%"
        }
    };
    this.grid = {
        display: "grid",
        gridGap: [
            10
        ],
        gridTemplateColumns: [
            "1fr",
            "repeat(3, 1fr)"
        ]
    };
    this.flex = {
        variant: "flex.row.center.center"
    };
    this.button = {
        width: "fit-content",
        mt: [
            12,
            14
        ]
    };
    this.portrait = {
        width: "100%",
        ":before": {
            content: '""',
            pb: "".concat(1 / 0.75 * 100, "%"),
            float: "left"
        }
    };
    this.square = {
        width: "100%",
        ":before": {
            content: '""',
            pb: "100%",
            float: "left"
        }
    };
}());

;// CONCATENATED MODULE: ./src/sections/TabbedThreeTile/Slider/Slider.jsx








var TabbedThreeTile_Slider_Slider_Slider = TabbedThreeTile_Slider_Slider_theme_themed(function(param) {
    var theme = param.theme, tabs = param.tabs, settings = param.settings, activeIndex = param.activeIndex, setSwiper = param.setSwiper;
    var ref;
    var cta = tabs === null || tabs === void 0 ? void 0 : (ref = tabs[activeIndex]) === null || ref === void 0 ? void 0 : ref.cta;
    var ctaStyle = settings === null || settings === void 0 ? void 0 : settings.ctaStyle;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Container */.W2, {
        "data-comp": TabbedThreeTile_Slider_Slider_Slider.displayName,
        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.swiper), {
            ".swiper-slide": (0,_object_spread/* default */.Z)({}, (settings === null || settings === void 0 ? void 0 : settings.imageRatio) === "square" ? theme.square : theme.portrait)
        }),
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(react_swiper/* Swiper */.t, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                onSwiper: setSwiper
            }, Slider_defaultParams), {
                children: tabs.slice(0, 5).map(function(tab, index) {
                    if (index !== activeIndex || tab.length === 0) return null;
                    return tab === null || tab === void 0 ? void 0 : tab.items.slice(0, 3).map(function(item, index) {
                        return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(swiper_slide/* SwiperSlide */.o, {
                            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(TabbedThreeTile_Tile_Tile_Tile, {
                                item: item,
                                settings: settings
                            }, index + (tab === null || tab === void 0 ? void 0 : tab.cta.url))
                        }, (tab === null || tab === void 0 ? void 0 : tab.cta.url) + index);
                    });
                })
            })),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                sx: theme.flex,
                children: (cta === null || cta === void 0 ? void 0 : cta.text) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Link */.rU, {
                    variant: "buttons.".concat(ctaStyle),
                    href: cta === null || cta === void 0 ? void 0 : cta.url,
                    newTab: cta === null || cta === void 0 ? void 0 : cta.newTab,
                    sx: theme.button,
                    children: cta === null || cta === void 0 ? void 0 : cta.text
                })
            })
        ]
    });
});
TabbedThreeTile_Slider_Slider_Slider.displayName = "Slider";
var Slider_defaultParams = {
    spaceBetween: 16,
    slidesPerView: 1.3,
    slidesOffsetBefore: 16,
    slidesOffsetAfter: 16,
    slidesPerGroup: 1,
    centeredSlides: false,
    centeredSlidesBounds: true,
    centerInsufficientSlides: true,
    autoHeight: true,
    navigation: false,
    loop: false,
    watchOverflow: true,
    grabCursor: true,
    breakpoints: {
        480: {
            spaceBetween: 16,
            slidesPerView: 1.3,
            slidesOffsetBefore: 16,
            slidesOffsetAfter: 16,
            slidesPerGroup: 1,
            centeredSlides: false,
            centeredSlidesBounds: true,
            centerInsufficientSlides: true
        },
        600: {
            spaceBetween: 16,
            slidesPerView: 2.4,
            slidesOffsetBefore: 16,
            slidesOffsetAfter: 16,
            slidesPerGroup: 1,
            centeredSlides: false,
            centeredSlidesBounds: true,
            centerInsufficientSlides: true
        },
        768: {
            spaceBetween: 20,
            slidesPerView: 3,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            slidesPerGroup: 1,
            centeredSlides: false,
            centeredSlidesBounds: false,
            centerInsufficientSlides: true
        },
        1024: {
            spaceBetween: 20,
            slidesPerView: 3,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            slidesPerGroup: 1,
            centeredSlides: false,
            centeredSlidesBounds: false,
            centerInsufficientSlides: true
        },
        1280: {
            spaceBetween: 20,
            slidesPerView: 3,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            slidesPerGroup: 1,
            centeredSlides: false,
            centeredSlidesBounds: false,
            centerInsufficientSlides: true
        }
    }
};

;// CONCATENATED MODULE: ./src/sections/TabbedThreeTile/Slider/index.js


;// CONCATENATED MODULE: ./src/sections/TabbedThreeTile/TabbedThreeTile.jsx










var TabbedThreeTile = (0,src_utils/* withInView */.Dh)(TabbedThreeTile_theme_themed(function(param) {
    var theme = param.theme, cms = param.cms;
    var tabs = cms.tabs, section = cms.section, settings = cms.settings;
    var ref = (0,react.useState)(0), activeIndex = ref[0], setActiveIndex = ref[1];
    var ref1 = (0,react.useState)(), swiper = ref1[0], setSwiper = ref1[1];
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Section */.$0, {
        "data-comp": TabbedThreeTile.displayName,
        section: section,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Container */.W2, {
            "data-comp": "".concat(TabbedThreeTile.displayName, " container"),
            sx: theme.wrapper,
            children: [
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                    sx: (0,_object_spread/* default */.Z)({}, theme.header, (0,src_utils/* pxWithFullBleed */._T)(section)),
                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Header_Header_Header, {
                        tabs: tabs,
                        settings: settings,
                        activeIndex: activeIndex,
                        setActiveIndex: setActiveIndex,
                        swiper: swiper
                    })
                }),
                (tabs === null || tabs === void 0 ? void 0 : tabs.length) > 0 ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(TabbedThreeTile_Slider_Slider_Slider, {
                    tabs: tabs,
                    settings: settings,
                    activeIndex: activeIndex,
                    setSwiper: setSwiper
                }) : null
            ]
        })
    });
}), {
    triggerOnce: true
});
TabbedThreeTile.displayName = "TabbedThreeTile";
TabbedThreeTile.Schema = TabbedThreeTile_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/TabbedThreeTile/index.js


;// CONCATENATED MODULE: ./src/sections/ThreeTile/ThreeTile.schema.js



function ThreeTile_schema_Schema(param) {
    var article = param.article, blog = param.blog, collection = param.collection;
    if (article || blog || collection) return null;
    return {
        label: "Three Tile",
        key: "three-tile",
        fields: [
            {
                name: "tiles",
                label: "Tiles",
                description: "Max of 3 tiles",
                component: "group-list",
                itemProps: {
                    label: "{{item.heading}}"
                },
                defaultItem: {
                    heading: "New Tile",
                    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit sed do eiusmod.",
                    alt: "Tile image",
                    image: {
                        src: "https://images.unsplash.com/photo-1528629297340-d1d466945dc5?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=2000&q=80"
                    },
                    cta: {
                        text: "",
                        url: ""
                    }
                },
                validate: {
                    maxItems: 3
                },
                fields: [
                    {
                        name: "heading",
                        label: "Heading",
                        component: "text"
                    },
                    {
                        name: "description",
                        label: "Description",
                        component: "markdown"
                    },
                    {
                        label: "Link",
                        name: "cta",
                        component: "link"
                    },
                    {
                        label: "Image Alt",
                        name: "alt",
                        component: "text",
                        description: "Provide a brief description of the image for accessibility compliance"
                    },
                    {
                        label: "Image",
                        name: "image",
                        component: "image"
                    }, 
                ],
                defaultValue: [
                    {
                        heading: "New Releases",
                        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit sed do eiusmod.",
                        cta: {
                            text: "Shop Now",
                            url: "/collections/all"
                        },
                        alt: "Tile image",
                        image: {
                            src: "https://images.unsplash.com/photo-1528629297340-d1d466945dc5?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=2000&q=80"
                        }
                    },
                    {
                        heading: "Top Products",
                        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit sed do eiusmod.",
                        alt: "Tile image",
                        image: {
                            src: "https://images.unsplash.com/photo-1571333250176-3c316199994b?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=2000&q=80"
                        },
                        cta: {
                            text: "Shop Now",
                            url: "/collections/all"
                        }
                    },
                    {
                        heading: "Bundles",
                        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit sed do eiusmod.",
                        alt: "Tile image",
                        image: {
                            src: "https://images.unsplash.com/photo-1523357585206-175e971f2ad9?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2000&q=80"
                        },
                        cta: {
                            text: "Shop Now",
                            url: "/collections/all"
                        }
                    }, 
                ]
            },
            {
                label: "Heading Settings",
                name: "header",
                description: "Heading, text align, heading button",
                component: "group",
                fields: [
                    {
                        name: "heading",
                        component: "text",
                        label: "Heading"
                    },
                    {
                        component: "radio-group",
                        direction: "horizontal",
                        description: "Doesn't apply on desktop if button is in header",
                        variant: "radio",
                        name: "textAlign",
                        label: "Heading alignment",
                        options: common/* align.options */.AJ.options
                    },
                    {
                        name: "ctas",
                        label: "Heading Button",
                        component: "group-list",
                        description: "Max of 1 button",
                        itemProps: {
                            label: "{{item.cta.text}}"
                        },
                        validate: {
                            maxItems: 1
                        },
                        defaultItem: {
                            cta: {
                                text: "Shop What's Trending",
                                url: "/collections/all"
                            },
                            style: common/* button.value.secondary */.LI.value.secondary
                        },
                        fields: [
                            {
                                name: "cta",
                                component: "link",
                                label: "Button"
                            },
                            {
                                name: "style",
                                label: "Button style",
                                component: "select",
                                options: common/* button.options */.LI.options
                            }, 
                        ]
                    }, 
                ],
                defaultValue: {
                    heading: "Trending Now",
                    textAlign: common/* align.value.center */.AJ.value.center,
                    ctas: [
                        {
                            cta: {
                                text: "Shop What's Trending",
                                url: "/collections/all"
                            },
                            style: common/* button.value.secondary */.LI.value.secondary
                        }, 
                    ]
                }
            },
            {
                label: "Tile Settings",
                name: "tile",
                description: "Display, image ratio, text align, link style",
                component: "group",
                fields: [
                    {
                        component: "radio-group",
                        direction: "horizontal",
                        variant: "radio",
                        name: "display",
                        label: "Tile display (mobile)",
                        options: [
                            {
                                label: "Slider",
                                value: "slider"
                            },
                            {
                                label: "Stacked",
                                value: "stacked"
                            }, 
                        ]
                    },
                    {
                        component: "radio-group",
                        direction: "horizontal",
                        variant: "radio",
                        name: "imageRatio",
                        label: "Image aspect ratio",
                        options: [
                            {
                                label: "1:1",
                                value: "square"
                            },
                            {
                                label: "3:4",
                                value: "portrait"
                            }, 
                        ]
                    },
                    {
                        component: "radio-group",
                        direction: "horizontal",
                        variant: "radio",
                        name: "textAlign",
                        label: "Text alignment",
                        options: common/* align.options */.AJ.options
                    },
                    {
                        name: "ctaStyle",
                        label: "Link style",
                        component: "select",
                        options: common/* button.options */.LI.options
                    }, 
                ],
                defaultValue: {
                    display: "slider",
                    imageRatio: "portrait",
                    textAlign: common/* align.value.left */.AJ.value.left,
                    ctaStyle: common/* button.value.secondary */.LI.value.secondary
                }
            },
            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, common/* section */.qi), {
                defaultValue: {
                    bgColor: common/* color.value.background */.$_.value.background,
                    color: common/* color.value.text */.$_.value.text,
                    mobile: {
                        container: "container",
                        mt: "none",
                        py: "m"
                    },
                    desktop: {
                        container: "content",
                        mt: "none",
                        py: "m"
                    }
                }
            }), 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/ThreeTile/Displays/Displays.theme.js

var Displays_theme_themed = (0,create/* create */.U)(new function() {
    this.swiper = {
        ".swiper-container": {
            cursor: [
                "grab",
                "auto"
            ],
            pl: [
                "16px",
                "unset"
            ],
            overflow: "visible"
        },
        ".swiper-container, .swiper-wrapper": {
            height: "auto !important",
            width: "100%"
        },
        ".swiper-slide": {
            opacity: 0.35
        },
        ".swiper-slide-visible": {
            opacity: 1
        },
        ".swiper-button-prev": {
            left: "auto",
            right: "56px",
            top: [
                "-58px",
                null,
                null,
                "-66px"
            ],
            color: "black",
            width: "36px",
            height: "36px",
            "@media only screen and (max-width: 767px)": {
                display: "none"
            }
        },
        ".swiper-button-prev:after": {
            fontSize: "30px"
        },
        ".swiper-button-next": {
            left: "auto",
            right: 0,
            top: [
                "-58px",
                null,
                null,
                "-66px"
            ],
            color: "black",
            width: "36px",
            height: "36px",
            "@media only screen and (max-width: 767px)": {
                display: "none"
            }
        },
        ".swiper-button-next:after": {
            fontSize: "30px"
        }
    };
    this.grid = {
        display: "grid",
        gridGap: [
            10
        ],
        gridTemplateColumns: [
            "1fr",
            "repeat(3, 1fr)"
        ]
    };
    this.portrait = {
        width: "100%",
        ":before": {
            content: '""',
            pb: "".concat(1 / 0.75 * 100, "%"),
            float: "left"
        }
    };
    this.square = {
        width: "100%",
        ":before": {
            content: '""',
            pb: "100%",
            float: "left"
        }
    };
}());

;// CONCATENATED MODULE: ./src/sections/ThreeTile/Tile/Tile.theme.js



var ThreeTile_Tile_Tile_theme_themed = (0,create/* create */.U)(new function() {
    this.image = {
        mb: 8
    };
    this.imageLink = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this.image), {
        ":hover": {
            img: {
                transform: "scale(1.03)"
            }
        },
        img: {
            transform: "scale(1.01)",
            transition: "transform 0.3s ease-in-out"
        }
    });
    this.content = {
        flexDirection: "column"
    };
    this.heading = {
        mb: 4,
        variant: "text.h5"
    };
    this.body = {
        mt: 0,
        variant: "text.base"
    };
    this.button = {
        mt: 4
    };
}());

;// CONCATENATED MODULE: ./src/sections/ThreeTile/Tile/Tile.jsx








var ThreeTile_Tile_Tile_Tile = ThreeTile_Tile_Tile_theme_themed(function(_param) {
    var theme = _param.theme, item = _param.item, _tile = _param.tile, tile = _tile === void 0 ? {} : _tile, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme",
        "item",
        "tile"
    ]);
    var ref, ref1, ref2, ref3, ref4;
    var display = tile.display, imageRatio = tile.imageRatio, textAlign = tile.textAlign, ctaStyle = tile.ctaStyle;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-comp": ThreeTile_Tile_Tile_Tile.displayName
    }, props), {
        children: [
            ((ref = item.image) === null || ref === void 0 ? void 0 : ref.src) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Link */.rU, {
                href: (ref1 = item.cta) === null || ref1 === void 0 ? void 0 : ref1.url,
                newTab: (ref2 = item.cta) === null || ref2 === void 0 ? void 0 : ref2.newTab,
                sx: ((ref3 = item.cta) === null || ref3 === void 0 ? void 0 : ref3.url) ? theme.imageLink : theme.image,
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Picture */.t, {
                    alt: item.alt,
                    width: 600,
                    height: 600,
                    images: [
                        {
                            src: item.image.src,
                            width: 450,
                            ratio: imageRatio === "square" ? 1 : 0.75
                        }, 
                    ]
                })
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.content), {
                    alignItems: (0,src_utils/* convertAlignToFlex */.nG)(textAlign),
                    textAlign: textAlign,
                    py: display === "stacked" ? [
                        10,
                        0
                    ] : 0
                }),
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                        as: "h3",
                        sx: theme.heading,
                        children: item.heading
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Markdown */.UG, {
                        text: item.description,
                        textSx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.body), {
                            textAlign: textAlign
                        })
                    }),
                    ((ref4 = item.cta) === null || ref4 === void 0 ? void 0 : ref4.text) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Link */.rU, {
                        href: item.cta.url,
                        newTab: item.cta.newTab,
                        variant: "buttons.".concat(ctaStyle || "secondary"),
                        sx: theme.button,
                        children: item.cta.text
                    })
                ]
            })
        ]
    }));
});
ThreeTile_Tile_Tile_Tile.displayName = "Tile";

;// CONCATENATED MODULE: ./src/sections/ThreeTile/Tile/index.js


;// CONCATENATED MODULE: ./src/sections/ThreeTile/Displays/Slider.jsx








var Displays_Slider_Slider = Displays_theme_themed(function(param) {
    var theme = param.theme, tiles = param.tiles, tile = param.tile;
    var ref = (0,react.useState)(), swiper = ref[0], setSwiper = ref[1];
    var noImageAvailable = tiles.every(function(_tile) {
        return !_tile.image;
    });
    var imageRatioStyles = (tile === null || tile === void 0 ? void 0 : tile.imageRatio) === "square" ? theme.square : theme.portrait;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Container */.W2, {
        "data-comp": Displays_Slider_Slider.displayName,
        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.swiper), {
            // Adds minimum aspect ratio before ThreeileItem js loads
            ".swiper-slide": (0,_object_spread/* default */.Z)({}, !noImageAvailable ? imageRatioStyles : "")
        }),
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(react_swiper/* Swiper */.t, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            onSwiper: setSwiper
        }, Displays_Slider_defaultParams), {
            children: tiles === null || tiles === void 0 ? void 0 : tiles.slice(0, 3).map(function(item, index) {
                return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(swiper_slide/* SwiperSlide */.o, {
                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(ThreeTile_Tile_Tile_Tile, {
                        item: item,
                        tile: tile
                    })
                }, index);
            })
        }))
    });
});
Displays_Slider_Slider.displayName = "Slider";
var Displays_Slider_defaultParams = {
    centeredSlides: false,
    centeredSlidesBounds: true,
    centerInsufficientSlides: true,
    spaceBetween: 16,
    slidesPerView: 1.5,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 16,
    slidesPerGroup: 1,
    autoHeight: false,
    navigation: true,
    loop: false,
    watchOverflow: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    breakpoints: {
        768: {
            spaceBetween: 20,
            slidesPerView: 2,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            slidesPerGroup: 1
        },
        1024: {
            spaceBetween: 20,
            slidesPerView: 3,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            slidesPerGroup: 1
        },
        1280: {
            spaceBetween: 20,
            slidesPerView: 4,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            slidesPerGroup: 1
        }
    }
};

;// CONCATENATED MODULE: ./src/sections/ThreeTile/Displays/GridDisplay.jsx




var GridDisplay_GridDisplay = Displays_theme_themed(function(param) {
    var theme = param.theme, tiles = param.tiles, tile = param.tile;
    var noImageAvailable = tiles.every(function(_tile) {
        return !_tile.image;
    });
    var imageRatioStyles = (tile === null || tile === void 0 ? void 0 : tile.imageRatio) === "square" ? theme.square : theme.portrait;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Container */.W2, {
        "data-comp": GridDisplay_GridDisplay.displayName,
        sx: theme.grid,
        children: tiles === null || tiles === void 0 ? void 0 : tiles.slice(0, 3).map(function(item, index) {
            return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                // Adds minimum aspect ratio before ThreeileItem js loads
                sx: !noImageAvailable ? imageRatioStyles : "",
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(ThreeTile_Tile_Tile_Tile, {
                    item: item,
                    tile: tile
                })
            }, index);
        })
    });
});
GridDisplay_GridDisplay.displayName = "GridDisplay";

;// CONCATENATED MODULE: ./src/sections/ThreeTile/Displays/index.js



;// CONCATENATED MODULE: ./src/sections/ThreeTile/Content/Content.theme.js

var ThreeTile_Content_Content_theme_themed = (0,create/* create */.U)(new function() {
    this.header = {
        alignItems: "center",
        display: "flex",
        flex: 1,
        mb: [
            13,
            14
        ]
    };
    this.heading = {
        variant: "text.h2"
    };
    this.footer = {
        display: [
            "flex",
            "none"
        ],
        mt: 14,
        px: 10
    };
}());

;// CONCATENATED MODULE: ./src/sections/ThreeTile/Content/Header.jsx







var Content_Header_Header = ThreeTile_Content_Content_theme_themed(function(param) {
    var theme = param.theme, header = param.header, section = param.section, style = param.style;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    return (header === null || header === void 0 ? void 0 : header.heading) ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Container */.W2, {
        "data-comp": Content_Header_Header.displayName,
        sx: (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.header, (0,src_utils/* pxWithFullBleed */._T)(section)), {
            justifyContent: [
                (0,src_utils/* convertAlignToFlex */.nG)(header === null || header === void 0 ? void 0 : header.textAlign),
                (header === null || header === void 0 ? void 0 : (ref = header.ctas) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.cta) === null || ref2 === void 0 ? void 0 : ref2.text) ? "space-between" : (0,src_utils/* convertAlignToFlex */.nG)(header === null || header === void 0 ? void 0 : header.textAlign), 
            ]
        }), style),
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.heading), {
                    textAlign: (header === null || header === void 0 ? void 0 : (ref3 = header.ctas) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.cta) === null || ref5 === void 0 ? void 0 : ref5.text) ? [
                        header === null || header === void 0 ? void 0 : header.textAlign,
                        "left"
                    ] : [
                        (header === null || header === void 0 ? void 0 : header.textAlign) || "left"
                    ]
                }),
                children: header === null || header === void 0 ? void 0 : header.heading
            }),
            (header === null || header === void 0 ? void 0 : (ref6 = header.ctas) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[0]) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.cta) === null || ref8 === void 0 ? void 0 : ref8.text) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Link */.rU, {
                variant: "buttons.".concat(header.ctas[0].style || "primary"),
                href: header.ctas[0].cta.url,
                newTab: header.ctas[0].cta.newTab,
                sx: {
                    display: [
                        "none",
                        "block"
                    ]
                },
                children: header.ctas[0].cta.text
            })
        ]
    }) : null;
});
Content_Header_Header.displayName = "Header";

;// CONCATENATED MODULE: ./src/sections/ThreeTile/Content/Footer.jsx







var Footer = ThreeTile_Content_Content_theme_themed(function(param) {
    var theme = param.theme, header = param.header, section = param.section;
    var ref, ref1, ref2;
    return (header === null || header === void 0 ? void 0 : (ref = header.ctas) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.cta) === null || ref2 === void 0 ? void 0 : ref2.text) ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Container */.W2, {
        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.footer, (0,utils_common/* pxWithFullBleed */._T)(section)), {
            justifyContent: (0,utils_common/* convertAlignToFlex */.nG)(header.textAlign)
        }),
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Link */.rU, {
            variant: "buttons.".concat(header.ctas[0].style || "primary"),
            href: header.ctas[0].cta.url,
            newTab: header.ctas[0].cta.newTab,
            children: header.ctas[0].cta.text
        })
    }) : null;
});
Footer.displayName = "Footer";

;// CONCATENATED MODULE: ./src/sections/ThreeTile/Content/index.js



;// CONCATENATED MODULE: ./src/sections/ThreeTile/ThreeTile.jsx







var ThreeTile = (0,src_utils/* withInView */.Dh)(function(param) {
    var cms = param.cms;
    var section = cms.section, header = cms.header, tiles = cms.tiles, tile = cms.tile;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Section */.$0, {
        section: section,
        sx: {
            overflow: "hidden"
        },
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Container */.W2, {
            "data-comp": ThreeTile.displayName,
            children: [
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Content_Header_Header, {
                    header: header,
                    section: section,
                    style: {
                        paddingRight: (tile === null || tile === void 0 ? void 0 : tile.display) === "stacked" ? "0" : [
                            0,
                            "100px"
                        ]
                    }
                }),
                (tiles === null || tiles === void 0 ? void 0 : tiles.length) > 0 ? (tile === null || tile === void 0 ? void 0 : tile.display) === "stacked" ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(GridDisplay_GridDisplay, {
                    tiles: tiles,
                    tile: tile
                }) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Displays_Slider_Slider, {
                    tiles: tiles,
                    tile: tile
                }) : null,
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Footer, {
                    header: header,
                    section: section
                })
            ]
        })
    });
}, {
    triggerOnce: true
});
ThreeTile.displayName = "ThreeTile";
ThreeTile.Schema = ThreeTile_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/ThreeTile/index.js


;// CONCATENATED MODULE: ./src/sections/TwoTile/TwoTile.schema.js




function TwoTile_schema_Schema(param) {
    var article = param.article, blog = param.blog, collection = param.collection;
    if (article || blog || collection) return null;
    return {
        label: "Two Tile",
        key: "two-tile",
        fields: [
            {
                name: "tiles",
                label: "Tiles",
                description: "Max of 2 tiles",
                component: "group-list",
                itemProps: {
                    label: "{{item.heading}}"
                },
                defaultItem: {
                    heading: "New Tile",
                    description: "",
                    alt: "Tile image",
                    image: {
                        src: "https://images.unsplash.com/photo-1518050227004-c4cb7104d79a?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2970&q=80"
                    },
                    cta: {
                        text: "",
                        url: ""
                    }
                },
                validate: {
                    maxItems: 2
                },
                fields: [
                    {
                        name: "heading",
                        label: "Heading",
                        component: "text"
                    },
                    {
                        name: "description",
                        label: "Description",
                        component: "markdown"
                    },
                    {
                        component: "select",
                        name: "color",
                        label: "Text color",
                        options: [
                            {
                                label: "Default",
                                value: ""
                            }
                        ].concat((0,_to_consumable_array/* default */.Z)(common/* color.options */.$_.options))
                    },
                    {
                        label: "Link",
                        name: "cta",
                        component: "link"
                    },
                    {
                        label: "Image Alt",
                        name: "alt",
                        component: "text",
                        description: "Provide a brief description of the image for accessibility compliance"
                    },
                    {
                        label: "Image",
                        name: "image",
                        component: "image"
                    }, 
                ],
                defaultValue: [
                    {
                        heading: "New Releases",
                        description: "",
                        color: "",
                        cta: {
                            text: "Bundles",
                            url: "/collections/all"
                        },
                        alt: "Tile image",
                        image: {
                            src: "https://images.unsplash.com/photo-1518050227004-c4cb7104d79a?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2970&q=80"
                        }
                    },
                    {
                        heading: "Best Sellers",
                        description: "",
                        alt: "Tile image",
                        color: "",
                        image: {
                            src: "https://images.unsplash.com/photo-1485965120184-e220f721d03e?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=2000&q=80"
                        },
                        cta: {
                            text: "Shop Now",
                            url: "/collections/all"
                        }
                    }, 
                ]
            },
            {
                label: "Heading Settings",
                name: "header",
                description: "Heading, text align, heading button",
                component: "group",
                fields: [
                    {
                        name: "heading",
                        component: "text",
                        label: "Heading"
                    },
                    {
                        component: "radio-group",
                        direction: "horizontal",
                        variant: "radio",
                        name: "textAlign",
                        description: "Doesn't apply on desktop if button is in header",
                        label: "Heading alignment",
                        options: common/* align.options */.AJ.options
                    },
                    {
                        name: "ctas",
                        label: "Heading Button",
                        component: "group-list",
                        description: "Max of 1 button",
                        itemProps: {
                            label: "{{item.cta.text}}"
                        },
                        validate: {
                            maxItems: 1
                        },
                        defaultItem: {
                            cta: {
                                text: "Shop All",
                                url: "/collections/all"
                            },
                            style: common/* button.value.secondary */.LI.value.secondary
                        },
                        fields: [
                            {
                                name: "cta",
                                component: "link",
                                label: "Button"
                            },
                            {
                                name: "style",
                                label: "Button style",
                                component: "select",
                                options: common/* button.options */.LI.options
                            }, 
                        ]
                    }, 
                ],
                defaultValue: {
                    heading: "",
                    textAlign: common/* align.value.center */.AJ.value.center,
                    ctas: []
                }
            },
            {
                label: "Tile Settings",
                name: "tile",
                description: "Image ratio, text position, text align, link style",
                component: "group",
                fields: [
                    {
                        component: "radio-group",
                        direction: "horizontal",
                        variant: "radio",
                        name: "imageRatio",
                        label: "Image aspect ratio (mobile)",
                        options: [
                            {
                                label: "3:4",
                                value: "portrait"
                            },
                            {
                                label: "1:1",
                                value: "square"
                            }, 
                        ]
                    },
                    {
                        component: "radio-group",
                        direction: "horizontal",
                        variant: "radio",
                        name: "imageRatioDt",
                        label: "Image aspect ratio (desktop)",
                        options: [
                            {
                                label: "3:4",
                                value: "portrait"
                            },
                            {
                                label: "1:1",
                                value: "square"
                            }, 
                        ]
                    },
                    {
                        component: "radio-group",
                        direction: "horizontal",
                        variant: "radio",
                        name: "overlay",
                        label: "Image overlay",
                        options: [
                            {
                                label: "None",
                                value: "none"
                            },
                            {
                                label: "Dark",
                                value: "dark"
                            }, 
                        ]
                    },
                    {
                        component: "radio-group",
                        direction: "horizontal",
                        variant: "radio",
                        name: "textPosition",
                        label: "Text position",
                        options: [
                            {
                                label: "Contained",
                                value: "absolute"
                            },
                            {
                                label: "Below",
                                value: "relative"
                            }, 
                        ]
                    },
                    {
                        component: "radio-group",
                        direction: "horizontal",
                        variant: "radio",
                        name: "textAlign",
                        label: "Text alignment",
                        options: common/* align.options */.AJ.options
                    },
                    {
                        name: "ctaStyle",
                        label: "Link style",
                        component: "select",
                        options: common/* button.options */.LI.options
                    }, 
                ],
                defaultValue: {
                    imageRatio: "square",
                    imageRatioDt: "square",
                    overlay: "none",
                    textPosition: "absolute",
                    textAlign: common/* align.value.left */.AJ.value.left,
                    ctaStyle: common/* button.value.secondary */.LI.value.secondary
                }
            },
            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, common/* section */.qi), {
                defaultValue: {
                    bgColor: common/* color.value.background */.$_.value.background,
                    color: common/* color.value.white */.$_.value.white,
                    mobile: {
                        container: "content",
                        mt: "none",
                        py: "s"
                    },
                    desktop: {
                        container: "content",
                        mt: "none",
                        py: "s"
                    }
                }
            }), 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/TwoTile/GridDisplay/GridDisplay.theme.js

var GridDisplay_GridDisplay_theme_themed = (0,create/* create */.U)(new function() {
    this.grid = {
        display: "grid",
        gridGap: [
            10
        ],
        gridTemplateColumns: [
            "1fr",
            "repeat(2, 1fr)"
        ]
    };
    this.portrait = {
        width: "100%",
        ":before": {
            content: '""',
            pb: "".concat(1 / 0.75 * 100, "%"),
            float: "left"
        }
    };
    this.square = {
        width: "100%",
        ":before": {
            content: '""',
            pb: "100%",
            float: "left"
        }
    };
}());

;// CONCATENATED MODULE: ./src/sections/TwoTile/Tile/Tile.theme.js



var TwoTile_Tile_Tile_theme_themed = (0,create/* create */.U)(new function() {
    this.tile = {
        position: "relative"
    };
    this.tileLink = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this.tile), {
        img: {
            transform: "scale(1.01)",
            transition: "transform 0.3s ease-in-out"
        },
        ":hover": {
            img: {
                transform: "scale(1.03)"
            }
        }
    });
    this.contentRelative = {
        flexDirection: "column",
        position: "relative",
        mt: 8,
        py: [
            10,
            0
        ]
    };
    this.contentAbsolute = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this.contentRelative), {
        position: "absolute",
        bottom: 0,
        left: 0,
        width: "100%",
        mt: 0,
        p: [
            10,
            10,
            14
        ],
        pointerEvents: "none"
    });
    this.heading = {
        mb: 4,
        variant: "text.h4"
    };
    this.icon = {
        ml: 7
    };
    this.body = {
        variant: "text.base"
    };
    this.button = {
        mt: 8,
        pointerEvents: "auto"
    };
}());

;// CONCATENATED MODULE: ./src/sections/TwoTile/Tile/TileContent.jsx







var TileContent_TileContent = TwoTile_Tile_Tile_theme_themed(function(param) {
    var theme = param.theme, item = param.item, _tile = param.tile, tile = _tile === void 0 ? {} : _tile;
    var ref;
    var textAlign = tile.textAlign, ctaStyle = tile.ctaStyle;
    var textColor = item.color || "currentColor";
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
        "data-comp": TileContent_TileContent.displayName,
        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (tile === null || tile === void 0 ? void 0 : tile.textPosition) === "relative" ? theme.contentRelative : theme.contentAbsolute), {
            alignItems: (0,src_utils/* convertAlignToFlex */.nG)(textAlign),
            textAlign: textAlign,
            color: textColor
        }),
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                as: "h3",
                sx: theme.heading,
                children: item.heading
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Markdown */.UG, {
                text: item.description,
                textAlign: textAlign,
                textSx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.body), {
                    color: textColor
                })
            }),
            ((ref = item.cta) === null || ref === void 0 ? void 0 : ref.text) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Link */.rU, {
                href: item.cta.url,
                newTab: item.cta.newTab,
                variant: "buttons.".concat(ctaStyle || "primary"),
                sx: theme.button,
                children: item.cta.text
            })
        ]
    });
});
TileContent_TileContent.displayName = "TileContent";

;// CONCATENATED MODULE: ./src/sections/TwoTile/Tile/Tile.jsx








var TwoTile_Tile_Tile_Tile = TwoTile_Tile_Tile_theme_themed(function(_param) {
    var theme = _param.theme, item = _param.item, tile = _param.tile, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme",
        "item",
        "tile"
    ]);
    var ref, ref1, ref2, ref3, ref4;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-comp": TwoTile_Tile_Tile_Tile.displayName
    }, props), {
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                sx: ((ref = item.cta) === null || ref === void 0 ? void 0 : ref.url) ? theme.tileLink : theme.tile,
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Link */.rU, {
                        href: (ref1 = item.cta) === null || ref1 === void 0 ? void 0 : ref1.url,
                        newTab: (ref2 = item.cta) === null || ref2 === void 0 ? void 0 : ref2.newTab,
                        tabIndex: "-1",
                        "aria-hidden": "true",
                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Picture */.t, {
                            alt: item.alt,
                            images: [
                                {
                                    src: (ref3 = item.image) === null || ref3 === void 0 ? void 0 : ref3.src,
                                    width: 768,
                                    ratio: (tile === null || tile === void 0 ? void 0 : tile.imageRatio) === "portrait" ? 0.75 : 1
                                },
                                {
                                    src: (ref4 = item.image) === null || ref4 === void 0 ? void 0 : ref4.src,
                                    width: 700,
                                    ratio: (tile === null || tile === void 0 ? void 0 : tile.imageRatioDt) === "portrait" ? 0.75 : 1
                                }, 
                            ]
                        })
                    }),
                    tile.overlay === "dark" && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                        sx: {
                            position: "absolute",
                            left: 0,
                            top: 0,
                            width: "100%",
                            height: "100%",
                            bg: "dark",
                            opacity: 0.2,
                            pointerEvents: "none"
                        }
                    }),
                    (tile === null || tile === void 0 ? void 0 : tile.textPosition) === "absolute" && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(TileContent_TileContent, {
                        item: item,
                        tile: tile
                    })
                ]
            }),
            (tile === null || tile === void 0 ? void 0 : tile.textPosition) === "relative" && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(TileContent_TileContent, {
                item: item,
                tile: tile
            })
        ]
    }));
});
TwoTile_Tile_Tile_Tile.displayName = "Tile";

;// CONCATENATED MODULE: ./src/sections/TwoTile/Tile/index.js


;// CONCATENATED MODULE: ./src/sections/TwoTile/GridDisplay/GridDisplay.jsx




var GridDisplay_GridDisplay_GridDisplay = GridDisplay_GridDisplay_theme_themed(function(param) {
    var theme = param.theme, tiles = param.tiles, tile = param.tile;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Container */.W2, {
        "data-comp": GridDisplay_GridDisplay_GridDisplay.displayName,
        sx: theme.grid,
        children: tiles === null || tiles === void 0 ? void 0 : tiles.slice(0, 2).map(function(item, index) {
            return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                // Adds minimum aspect ratio before Tile js loads
                sx: {
                    width: "100%",
                    ":before": {
                        content: '""',
                        pb: [
                            (tile === null || tile === void 0 ? void 0 : tile.imageRatio) === "portrait" ? "".concat(1 / 0.75 * 100, "%") : "100%",
                            (tile === null || tile === void 0 ? void 0 : tile.imageRatioDt) === "portrait" ? "".concat(1 / 0.75 * 100, "%") : "100%", 
                        ],
                        float: "left"
                    }
                },
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(TwoTile_Tile_Tile_Tile, {
                    item: item,
                    tile: tile
                })
            }, index);
        })
    });
});
GridDisplay_GridDisplay_GridDisplay.displayName = "GridDisplay";

;// CONCATENATED MODULE: ./src/sections/TwoTile/GridDisplay/index.js


;// CONCATENATED MODULE: ./src/sections/TwoTile/Content/Content.theme.js

var TwoTile_Content_Content_theme_themed = (0,create/* create */.U)(new function() {
    this.header = {
        display: "flex",
        alignItems: "center",
        mb: [
            13,
            14
        ],
        flex: 1
    };
    this.heading = {
        variant: "text.h2"
    };
    this.footer = {
        display: [
            "flex",
            "none"
        ],
        mt: 14,
        px: 10
    };
}());

;// CONCATENATED MODULE: ./src/sections/TwoTile/Content/Header.jsx







var TwoTile_Content_Header_Header = TwoTile_Content_Content_theme_themed(function(param) {
    var theme = param.theme, header = param.header, section = param.section;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    return (header === null || header === void 0 ? void 0 : header.heading) ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Container */.W2, {
        "data-comp": TwoTile_Content_Header_Header.displayName,
        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.header, (0,src_utils/* pxWithFullBleed */._T)(section)), {
            justifyContent: [
                (0,src_utils/* convertAlignToFlex */.nG)(header === null || header === void 0 ? void 0 : header.textAlign),
                (header === null || header === void 0 ? void 0 : (ref = header.ctas) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.cta) === null || ref2 === void 0 ? void 0 : ref2.text) ? "space-between" : (0,src_utils/* convertAlignToFlex */.nG)(header === null || header === void 0 ? void 0 : header.textAlign), 
            ]
        }),
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.heading), {
                    textAlign: (header === null || header === void 0 ? void 0 : (ref3 = header.ctas) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.cta) === null || ref5 === void 0 ? void 0 : ref5.text) ? [
                        header === null || header === void 0 ? void 0 : header.textAlign,
                        "left"
                    ] : [
                        (header === null || header === void 0 ? void 0 : header.textAlign) || "left"
                    ]
                }),
                children: header.heading
            }),
            (header === null || header === void 0 ? void 0 : (ref6 = header.ctas) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[0]) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.cta) === null || ref8 === void 0 ? void 0 : ref8.text) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Link */.rU, {
                variant: "buttons.".concat(header.ctas[0].style || "primary"),
                href: header.ctas[0].cta.url,
                newTab: header.ctas[0].cta.newTab,
                sx: {
                    display: [
                        "none",
                        "block"
                    ]
                },
                children: header.ctas[0].cta.text
            })
        ]
    }) : null;
});
TwoTile_Content_Header_Header.displayName = "Header";

;// CONCATENATED MODULE: ./src/sections/TwoTile/Content/Footer.jsx







var Footer_Footer = TwoTile_Content_Content_theme_themed(function(param) {
    var theme = param.theme, header = param.header, section = param.section;
    var ref, ref1, ref2;
    return (header === null || header === void 0 ? void 0 : (ref = header.ctas) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.cta) === null || ref2 === void 0 ? void 0 : ref2.text) ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Container */.W2, {
        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.footer, (0,utils_common/* pxWithFullBleed */._T)(section)), {
            justifyContent: (0,utils_common/* convertAlignToFlex */.nG)(header.textAlign)
        }),
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Link */.rU, {
            variant: "buttons.".concat(header.ctas[0].style || "primary"),
            href: header.ctas[0].cta.url,
            newTab: header.ctas[0].cta.newTab,
            children: header.ctas[0].cta.text
        })
    }) : null;
});
Footer_Footer.displayName = "Footer";

;// CONCATENATED MODULE: ./src/sections/TwoTile/Content/index.js



;// CONCATENATED MODULE: ./src/sections/TwoTile/TwoTile.jsx







var TwoTile = (0,src_utils/* withInView */.Dh)(function(param) {
    var cms = param.cms;
    var section = cms.section, header = cms.header, tiles = cms.tiles, tile = cms.tile;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Section */.$0, {
        section: section,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Container */.W2, {
            "data-comp": TwoTile.displayName,
            children: [
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(TwoTile_Content_Header_Header, {
                    header: header,
                    section: section
                }),
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(GridDisplay_GridDisplay_GridDisplay, {
                    tiles: tiles,
                    tile: tile
                }),
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Footer_Footer, {
                    header: header,
                    section: section
                })
            ]
        })
    });
}, {
    triggerOnce: true
});
TwoTile.displayName = "TwoTile";
TwoTile.Schema = TwoTile_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/TwoTile/index.js


;// CONCATENATED MODULE: ./src/sections/TwoThirdsMedia/TwoThirdsMedia.schema.js



function TwoThirdsMedia_schema_Schema(param) {
    var article = param.article, collection = param.collection;
    if (article || collection) return null;
    return {
        label: "Two Thirds Media",
        key: "two-thirds-media",
        fields: [
            {
                label: "Image Settings",
                name: "image",
                description: "Image, position, placement, aspect ratio",
                component: "group",
                fields: [
                    {
                        label: "Image Alt",
                        name: "alt",
                        component: "text",
                        description: "Provide a brief description of the image for accessibility compliance"
                    },
                    {
                        name: "imageDt",
                        label: "Image (desktop)",
                        component: "image"
                    },
                    {
                        name: "positionDt",
                        component: "select",
                        label: "Image position (desktop)",
                        options: common/* position.object */.FK.object
                    },
                    {
                        label: "Placement (desktop)",
                        component: "radio-group",
                        direction: "horizontal",
                        variant: "radio",
                        name: "locationDt",
                        options: [
                            {
                                value: "left",
                                label: "Left"
                            },
                            {
                                value: "right",
                                label: "Right"
                            }, 
                        ]
                    },
                    {
                        label: "Image (mobile)",
                        name: "image",
                        component: "image"
                    },
                    {
                        name: "position",
                        component: "select",
                        label: "Image position (mobile)",
                        options: common/* position.object */.FK.object
                    },
                    {
                        name: "location",
                        label: "Placement (mobile)",
                        component: "radio-group",
                        direction: "horizontal",
                        variant: "radio",
                        options: [
                            {
                                value: "top",
                                label: "Top"
                            },
                            {
                                value: "bottom",
                                label: "Bottom"
                            }, 
                        ]
                    }, 
                ],
                defaultValue: {
                    alt: "A Woman sitting on a couch with a Hopsulator slim in her hand.",
                    imageDt: {
                        src: "https://cdn.shopify.com/s/files/1/1114/2308/files/FirstCanCooler.png"
                    },
                    positionDt: "center center",
                    locationDt: "right",
                    image: {
                        src: "https://cdn.shopify.com/s/files/1/1114/2308/files/FirstCanCooler.png"
                    },
                    location: "top",
                    position: "center center"
                }
            },
            {
                label: "Content Settings",
                name: "content",
                description: "Heading, superheading body, link, content alignment",
                component: "group",
                fields: [
                    {
                        label: "Heading",
                        name: "heading",
                        component: "text"
                    },
                    {
                        label: "Superheading",
                        name: "superheading",
                        component: "text"
                    },
                    {
                        label: "Body",
                        name: "body",
                        component: "markdown"
                    },
                    {
                        label: "Link",
                        name: "cta",
                        component: "link"
                    },
                    {
                        name: "ctaStyle",
                        label: "Link Style",
                        component: "select",
                        options: common/* button.options */.LI.options
                    },
                    {
                        label: "Content alignment (desktop)",
                        name: "alignmentDt",
                        component: "radio-group",
                        direction: "horizontal",
                        variant: "radio",
                        options: common/* align.options */.AJ.options
                    },
                    {
                        label: "Content alignment (mobile)",
                        name: "alignment",
                        component: "radio-group",
                        direction: "horizontal",
                        variant: "radio",
                        options: common/* align.options */.AJ.options
                    }, 
                ],
                defaultValue: {
                    heading: "The Worlds First Slim Can Cooler",
                    body: "The Hopsulator Slim keeps all of your favorite 12oz slim canned beverages icy-cold, no matter how hot the party gets.",
                    alignmentDt: common/* align.value.left */.AJ.value.left,
                    alignment: common/* align.value.left */.AJ.value.left
                }
            },
            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, common/* section */.qi), {
                defaultValue: {
                    desktop: {
                        container: "content",
                        mt: "l"
                    },
                    mobile: {
                        container: "content",
                        mt: "s"
                    }
                }
            }), 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/TwoThirdsMedia/TwoThirdsMedia.theme.js

var TwoThirdsMedia_theme_themed = (0,create/* create */.U)(new function() {
    this.grid = {
        position: "relative",
        display: "grid",
        gridGap: [
            0,
            0,
            15
        ]
    };
    this.media = {
        gridArea: "media",
        position: "relative",
        width: "100%",
        height: "100%",
        overflow: "hidden",
        ":before": {
            content: '""',
            float: "left",
            pb: "65%"
        }
    };
    this.content = {
        gridArea: "content",
        display: "flex",
        position: "relative",
        width: "100%",
        height: "100%"
    };
}());

;// CONCATENATED MODULE: ./src/sections/TwoThirdsMedia/Content/Content.theme.js



var TwoThirdsMedia_Content_Content_theme_themed = (0,create/* create */.U)(new function() {
    this.outer = {
        width: "100%",
        justifyContent: "center",
        alignItems: [
            "flex-start",
            "center"
        ],
        py: [
            12,
            16
        ],
        px: [
            0,
            11
        ],
        "@media only screen and (max-width: 479px)": {
            py: 8
        }
    };
    this.innerLeft = {
        variant: "flex.column",
        width: "100%",
        alignItems: "flex-start"
    };
    this.innerRight = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this.innerLeft), {
        alignItems: "flex-end"
    });
    this.innerCenter = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this.innerLeft), {
        alignItems: "center"
    });
    this.superheading = {
        variant: "text.label.1",
        mb: 2
    };
    this.heading = {
        variant: "text.h2",
        overflowWrap: "break-word"
    };
    this.bodyWithoutHeading = {
        variant: "text.base",
        mt: 0,
        ul: {
            ml: 0
        },
        "p:last-of-type": {
            mb: 0
        }
    };
    this.bodyWithHeading = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this.bodyWithoutHeading), {
        mt: [
            10,
            11
        ]
    });
}());

;// CONCATENATED MODULE: ./src/sections/TwoThirdsMedia/Content/Content.jsx







var TwoThirdsMedia_Content_Content_Content = TwoThirdsMedia_Content_Content_theme_themed(function(param) {
    var theme = param.theme, content = param.content;
    var ref, ref1, ref2, ref3;
    var textAlign = [
        content === null || content === void 0 ? void 0 : content.alignment,
        content === null || content === void 0 ? void 0 : content.alignmentDt
    ];
    var flexAlign = textAlign.map(function(align) {
        return (0,utils_common/* convertAlignToFlex */.nG)(align);
    });
    var marginTop = (content === null || content === void 0 ? void 0 : content.heading) || (content === null || content === void 0 ? void 0 : content.body) ? [
        10,
        11
    ] : 0;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
        "data-comp": TwoThirdsMedia_Content_Content_Content.displayName,
        sx: theme.outer,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
            sx: {
                variant: "flex.column",
                width: "100%",
                alignItems: flexAlign
            },
            children: [
                (content === null || content === void 0 ? void 0 : content.superheading) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                    as: "h6",
                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.superheading), {
                        textAlign: textAlign
                    }),
                    children: content.superheading
                }),
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.heading), {
                        textAlign: textAlign
                    }),
                    children: content === null || content === void 0 ? void 0 : content.heading
                }),
                (content === null || content === void 0 ? void 0 : content.body) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Markdown */.UG, {
                    text: content.body,
                    textSx: {
                        textAlign: textAlign
                    },
                    sx: (0,_object_spread/* default */.Z)({}, (content === null || content === void 0 ? void 0 : content.superheading) ? (content === null || content === void 0 ? void 0 : content.heading) ? theme.bodyWithHeading : theme.bodyWithoutHeading : theme.bodyWithoutHeading)
                }),
                (content === null || content === void 0 ? void 0 : (ref = content.cta) === null || ref === void 0 ? void 0 : ref.text) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Link */.rU, {
                    variant: "buttons.".concat((content === null || content === void 0 ? void 0 : content.ctaStyle) || "secondary"),
                    href: content === null || content === void 0 ? void 0 : (ref1 = content.cta) === null || ref1 === void 0 ? void 0 : ref1.url,
                    newTab: content === null || content === void 0 ? void 0 : (ref2 = content.cta) === null || ref2 === void 0 ? void 0 : ref2.newTab,
                    sx: {
                        mt: marginTop,
                        alignSelf: flexAlign
                    },
                    children: content === null || content === void 0 ? void 0 : (ref3 = content.cta) === null || ref3 === void 0 ? void 0 : ref3.text
                })
            ]
        })
    });
});
TwoThirdsMedia_Content_Content_Content.displayName = "Content";

;// CONCATENATED MODULE: ./src/sections/TwoThirdsMedia/Content/index.js


;// CONCATENATED MODULE: ./src/sections/TwoThirdsMedia/Image/Image.theme.js

var TwoThirdsMedia_Image_Image_theme_themed = (0,create/* create */.U)(new function() {
    this.image = {
        position: "absolute",
        width: "100%",
        height: "100%",
        top: 0,
        left: 0,
        bottom: 0,
        right: 0
    };
}());

;// CONCATENATED MODULE: ./src/sections/TwoThirdsMedia/Image/Image.jsx



var TwoThirdsMedia_Image_Image_Image = TwoThirdsMedia_Image_Image_theme_themed(function(param) {
    var theme = param.theme, image = param.image;
    var ref, ref1, ref2, ref3;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Picture */.t, {
        "data-comp": TwoThirdsMedia_Image_Image_Image.displayName,
        alt: image === null || image === void 0 ? void 0 : image.alt,
        images: [
            {
                src: image === null || image === void 0 ? void 0 : (ref = image.image) === null || ref === void 0 ? void 0 : ref.src,
                width: 768,
                ratio: 1
            },
            {
                src: image === null || image === void 0 ? void 0 : (ref1 = image.imageDt) === null || ref1 === void 0 ? void 0 : ref1.src,
                width: 512,
                ratio: 1
            },
            {
                src: image === null || image === void 0 ? void 0 : (ref2 = image.imageDt) === null || ref2 === void 0 ? void 0 : ref2.src,
                width: 640,
                ratio: 1
            },
            {
                src: image === null || image === void 0 ? void 0 : (ref3 = image.imageDt) === null || ref3 === void 0 ? void 0 : ref3.src,
                width: 720,
                ratio: 1
            }, 
        ],
        imageSx: {
            objectPosition: [
                image === null || image === void 0 ? void 0 : image.position,
                image === null || image === void 0 ? void 0 : image.positionDt
            ]
        },
        sx: theme.image
    });
});
TwoThirdsMedia_Image_Image_Image.displayName = "Image";

;// CONCATENATED MODULE: ./src/sections/TwoThirdsMedia/Image/index.js


;// CONCATENATED MODULE: ./src/sections/TwoThirdsMedia/TwoThirdsMedia.jsx










var TwoThirdsMedia = (0,src_utils/* withInView */.Dh)(TwoThirdsMedia_theme_themed(function(param) {
    var theme = param.theme, cms = param.cms;
    var image = cms.image, content = cms.content, section = cms.section;
    var imageLeft = (image === null || image === void 0 ? void 0 : image.locationDt) === "left"; // Desktop
    var imageTop = (image === null || image === void 0 ? void 0 : image.location) === "top"; // Mobile
    var gridTemplateAreas = imageLeft ? [
        "1fr",
        "2fr 1fr"
    ] : [
        "1fr",
        "1fr 2fr"
    ];
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Section */.$0, {
        section: section,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Container */.W2, {
            "data-comp": TwoThirdsMedia.displayName,
            sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.grid), {
                gridTemplateAreas: [
                    imageTop ? '"media" "content"' : '"content" "media"',
                    imageLeft ? '"media content"' : '"content media"', 
                ],
                gridTemplateColumns: gridTemplateAreas
            }),
            children: [
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                    sx: theme.media,
                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(TwoThirdsMedia_Image_Image_Image, {
                        image: image
                    })
                }),
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.content), {
                        justifyContent: imageLeft ? "flex-start" : "flex-end",
                        ":before": {
                            content: '""',
                            float: "left"
                        }
                    }),
                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(TwoThirdsMedia_Content_Content_Content, {
                        content: content
                    })
                })
            ]
        })
    });
}), {
    triggerOnce: true
});
TwoThirdsMedia.displayName = "TwoThirdsMedia";
TwoThirdsMedia.Schema = TwoThirdsMedia_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/TwoThirdsMedia/index.js


;// CONCATENATED MODULE: ./src/sections/Wishlist/Wishlist.schema.js
function Wishlist_schema_Schema(param) {
    var page = param.page;
    if ((page === null || page === void 0 ? void 0 : page.handle) !== "wishlist") return null;
    return {
        label: "Wishlist",
        key: "wishlist",
        fields: []
    };
}

;// CONCATENATED MODULE: ./src/sections/Wishlist/Wishlist.jsx




var Wishlist = (0,src_utils/* withInView */.Dh)(function(param) {
    var cms = param.cms;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* WishlistPage */.lU, {
        cms: cms
    });
}, {
    triggerOnce: true
});
Wishlist.Schema = Wishlist_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/Wishlist/index.js


;// CONCATENATED MODULE: ./src/sections/KlaviyoForm/KlaviyoForm.schema.js


var fields = [
    {
        name: "bgColor",
        label: "Background color",
        component: "select",
        options: common/* color.options */.$_.options,
        defaultValue: common/* color.value.background */.$_.value.background
    }, 
];
var mobileFields = [
    {
        label: "Container width (mobile)",
        component: "select",
        name: "container",
        options: common/* layout.options */.bK.options
    },
    {
        name: "mt",
        label: "Margin top (mobile)",
        component: "select",
        options: common/* margin.options */.e6.options
    },
    {
        name: "py",
        label: "Vertical padding (mobile)",
        component: "select",
        options: common/* padding.options */.o3.options
    }, 
];
var mobileDefaultValue = {
    container: common/* layout.value.container */.bK.value.container,
    mt: "none",
    py: "none"
};
var desktopFields = [
    {
        label: "Container width (desktop)",
        component: "select",
        name: "container",
        options: common/* layout.options */.bK.options
    },
    {
        name: "mt",
        label: "Margin top (desktop)",
        component: "select",
        options: common/* margin.options */.e6.options
    },
    {
        name: "py",
        label: "Vertical padding (desktop)",
        component: "select",
        options: common/* padding.options */.o3.options
    }, 
];
var desktopDefaultValue = {
    container: common/* layout.value.container */.bK.value.container,
    mt: "none",
    py: "none"
};
var mobile = {
    label: "Mobile Settings",
    name: "mobile",
    component: "group",
    fields: mobileFields,
    defaultValue: mobileDefaultValue
};
var desktop = {
    label: "Desktop Settings",
    name: "desktop",
    component: "group",
    fields: desktopFields,
    defaultValue: desktopDefaultValue
};
var KlaviyoForm_schema_section = {
    label: "Section Settings",
    name: "section",
    description: "Background color, container width, margin top, vertical padding",
    component: "group",
    fields: (0,_to_consumable_array/* default */.Z)(fields).concat([
        desktop,
        mobile
    ])
};
var KlaviyoForm_schema_Schema = function() {
    return {
        label: "Klaviyo Form",
        key: "klaviyo-form",
        fields: [
            {
                label: "Klaviyo Form Id",
                name: "formId",
                component: "text",
                defaultValue: ""
            },
            KlaviyoForm_schema_section, 
        ]
    };
};

;// CONCATENATED MODULE: ./src/sections/KlaviyoForm/KlaviyoForm.jsx




function KlaviyoForm(param) {
    var cms = param.cms;
    var formId = cms.formId, section = cms.section;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Section */.$0, {
        section: section,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
            className: "klaviyo-form-".concat(formId)
        })
    });
}
KlaviyoForm.displayName = "KlaviyoForm";
KlaviyoForm.Schema = KlaviyoForm_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/KlaviyoForm/index.js


;// CONCATENATED MODULE: ./src/sections/LoyaltyLionWelcome/LoyaltyLionWelcome.schema.js



var LoyaltyLionWelcome_schema_fields = [
    {
        label: "Image Settings",
        name: "image",
        description: "Image, alt text",
        component: "group",
        fields: [
            {
                label: "Image Alt",
                name: "alt",
                component: "text",
                description: "Provide a brief description of the image for accessibility compliance"
            },
            {
                name: "imageDt",
                label: "Image (desktop)",
                component: "image"
            },
            {
                label: "Image (mobile)",
                name: "image",
                component: "image"
            }, 
        ],
        defaultValue: {
            alt: "A Woman sitting on a couch with a Hopsulator slim in her hand.",
            image: {
                src: "https://cdn.shopify.com/s/files/1/1114/2308/files/FirstCanCooler.png"
            },
            imageDt: {
                src: "https://cdn.shopify.com/s/files/1/1114/2308/files/FirstCanCooler.png"
            }
        }
    },
    {
        label: "Media Settings",
        name: "media",
        description: "Position, placement, aspect ratio",
        component: "group",
        fields: [
            {
                label: "Placement (desktop)",
                component: "radio-group",
                direction: "horizontal",
                variant: "radio",
                name: "locationDt",
                options: [
                    {
                        value: "left",
                        label: "Left"
                    },
                    {
                        value: "right",
                        label: "Right"
                    }, 
                ]
            },
            {
                label: "Aspect ratio (desktop)",
                name: "ratioDt",
                component: "radio-group",
                description: "Only applies to images and video files not already set to 1:1 ratio",
                direction: "horizontal",
                variant: "radio",
                options: [
                    {
                        value: "42%",
                        label: "42:100"
                    },
                    {
                        value: "80%",
                        label: "5:4"
                    },
                    {
                        value: "80%",
                        label: "5:4"
                    },
                    {
                        value: "100%",
                        label: "1:1"
                    },
                    {
                        value: "120%",
                        label: "5:6"
                    }, 
                ]
            },
            {
                label: "Placement (mobile)",
                name: "location",
                component: "radio-group",
                direction: "horizontal",
                variant: "radio",
                options: [
                    {
                        value: "top",
                        label: "Top"
                    },
                    {
                        value: "bottom",
                        label: "Bottom"
                    }, 
                ]
            },
            {
                label: "Aspect ratio (mobile)",
                component: "radio-group",
                description: "Only applies to images and video files not already set to 1:1 ratio",
                direction: "horizontal",
                variant: "radio",
                name: "ratio",
                options: [
                    {
                        value: "42%",
                        label: "42:100"
                    },
                    {
                        value: "80%",
                        label: "5:4"
                    },
                    {
                        value: "100%",
                        label: "1:1"
                    },
                    {
                        value: "120%",
                        label: "5:6"
                    }, 
                ]
            }, 
        ],
        defaultValue: {
            location: "top",
            locationDt: "left",
            ratio: "100%",
            ratioDt: "100%",
            position: "center center",
            positionDt: "center center"
        }
    },
    {
        label: "Content Settings",
        name: "content",
        description: "Heading, superheading body, link, content alignment",
        component: "group",
        fields: [
            {
                label: "Heading",
                name: "heading",
                component: "text",
                description: "use [customer_name], [customer_firstname], [customer_lastname] for real customer name."
            },
            {
                label: "Body",
                name: "body",
                component: "markdown"
            },
            {
                label: "Link",
                name: "cta1",
                component: "link"
            },
            {
                name: "cta1Style",
                label: "Link Style",
                component: "select",
                options: common/* button.options */.LI.options
            },
            {
                label: "Link",
                name: "cta2",
                component: "link"
            },
            {
                name: "cta2Style",
                label: "Link Style",
                component: "select",
                options: common/* button.options */.LI.options
            },
            {
                label: "Content alignment (mobile)",
                name: "alignment",
                component: "radio-group",
                direction: "horizontal",
                variant: "radio",
                options: common/* align.options */.AJ.options
            },
            {
                label: "Content alignment (desktop)",
                name: "alignmentDt",
                component: "radio-group",
                direction: "horizontal",
                variant: "radio",
                options: common/* align.options */.AJ.options
            }, 
        ],
        defaultValue: {
            heading: "THE WORLD'S FIRST SLIM CAN COOLER.",
            body: "",
            ctaStyle: common/* button.value.secondary */.LI.value.secondary,
            alignment: common/* align.value.left */.AJ.value.left,
            alignmentDt: common/* align.value.left */.AJ.value.left
        }
    }, 
];
function LoyaltyLionWelcome_schema_Schema(param) {
    var article = param.article, blog = param.blog;
    if (article || blog) return null;
    return {
        category: "LoyaltyLion",
        label: "LoyaltyLion Welcome",
        key: "loyaltyllion-welcome",
        fields: [
            {
                label: "User Settings",
                name: "userSettings",
                description: "Settings for Signed In",
                component: "group",
                fields: LoyaltyLionWelcome_schema_fields
            },
            {
                label: "Guest Settings",
                name: "guestSettings",
                description: "Settings for Signed Out",
                component: "group",
                fields: LoyaltyLionWelcome_schema_fields
            },
            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, common/* section */.qi), {
                defaultValue: {
                    desktop: {
                        container: "container",
                        mt: "none",
                        py: "none"
                    },
                    mobile: {
                        container: "content",
                        mt: "none",
                        py: "none"
                    }
                }
            }), 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/LoyaltyLionWelcome/Content/Content.theme.js


var LoyaltyLionWelcome_Content_Content_theme_themed = (0,create/* create */.U)(new function() {
    this.outer = {
        width: "100%",
        justifyContent: "center",
        alignItems: [
            "flex-start",
            "center"
        ],
        px: 12,
        py: [
            18,
            16
        ],
        "@media only screen and (max-width: 479px)": {
            py: 15
        }
    };
    this.heading = {
        variant: "text.h2",
        fontSize: [
            11,
            13
        ]
    };
    this.bodyWithoutHeading = {
        variant: "text.base",
        fontSize: [
            "13px",
            6
        ],
        lineHeight: [
            "normal",
            "24px"
        ],
        mt: 0,
        ul: {
            ml: 0
        },
        "p:last-of-type": {
            mb: 0
        }
    };
    this.bodyWithHeading = (0,_object_spread/* default */.Z)({}, this.bodyWithoutHeading);
}());

;// CONCATENATED MODULE: ./src/sections/LoyaltyLionWelcome/Content/Content.jsx









var LoyaltyLionWelcome_Content_Content_Content = LoyaltyLionWelcome_Content_Content_theme_themed(function(param) {
    var theme = param.theme, content = param.content, customer = param.customer;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
    var textAlign = [
        content === null || content === void 0 ? void 0 : content.alignment,
        content === null || content === void 0 ? void 0 : content.alignmentDt
    ];
    var flexAlign = textAlign.map(function(align) {
        return (0,utils_common/* convertAlignToFlex */.nG)(align);
    });
    var ref13 = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* default.rewardsRedirect */.ZP.rewardsRedirect), 2), _ = ref13[0], setRewardsRedirect = ref13[1];
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
        "data-comp": LoyaltyLionWelcome_Content_Content_Content.displayName,
        sx: theme.outer,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
            sx: {
                variant: "flex.column",
                width: "100%",
                maxWidth: [
                    "600px",
                    "450px"
                ],
                alignItems: flexAlign,
                gap: "11"
            },
            children: [
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.heading), {
                        textAlign: textAlign
                    }),
                    children: (ref2 = (ref1 = content === null || content === void 0 ? void 0 : (ref = content.heading) === null || ref === void 0 ? void 0 : ref.replace(/\[customer_name\]/gi, customer === null || customer === void 0 ? void 0 : customer.displayName)) === null || ref1 === void 0 ? void 0 : ref1.replace(/\[customer_firstname\]/gi, customer === null || customer === void 0 ? void 0 : customer.firstName)) === null || ref2 === void 0 ? void 0 : ref2.replace(/\[customer_lastname\]/gi, customer === null || customer === void 0 ? void 0 : customer.lastName)
                }),
                (content === null || content === void 0 ? void 0 : content.body) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Markdown */.UG, {
                    text: content.body,
                    sx: (0,_object_spread/* default */.Z)({}, (content === null || content === void 0 ? void 0 : content.heading) ? theme.bodyWithHeading : theme.bodyWithoutHeading),
                    textSx: {
                        textAlign: textAlign
                    }
                }),
                ((content === null || content === void 0 ? void 0 : (ref3 = content.cta1) === null || ref3 === void 0 ? void 0 : ref3.text) || (content === null || content === void 0 ? void 0 : (ref4 = content.cta2) === null || ref4 === void 0 ? void 0 : ref4.text)) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)("div", {
                    className: "flex gap-5 md:gap-6",
                    children: [
                        (content === null || content === void 0 ? void 0 : (ref5 = content.cta1) === null || ref5 === void 0 ? void 0 : ref5.text) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Link */.rU, {
                            variant: "buttons.".concat((content === null || content === void 0 ? void 0 : content.cta1Style) || "secondary"),
                            href: content === null || content === void 0 ? void 0 : (ref6 = content.cta1) === null || ref6 === void 0 ? void 0 : ref6.url,
                            newTab: content === null || content === void 0 ? void 0 : (ref7 = content.cta1) === null || ref7 === void 0 ? void 0 : ref7.newTab,
                            onClick: function() {
                                setRewardsRedirect(true);
                            },
                            children: content === null || content === void 0 ? void 0 : (ref8 = content.cta1) === null || ref8 === void 0 ? void 0 : ref8.text
                        }),
                        (content === null || content === void 0 ? void 0 : (ref9 = content.cta2) === null || ref9 === void 0 ? void 0 : ref9.text) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Link */.rU, {
                            variant: "buttons.".concat((content === null || content === void 0 ? void 0 : content.cta2Style) || "secondary"),
                            href: content === null || content === void 0 ? void 0 : (ref10 = content.cta2) === null || ref10 === void 0 ? void 0 : ref10.url,
                            newTab: content === null || content === void 0 ? void 0 : (ref11 = content.cta2) === null || ref11 === void 0 ? void 0 : ref11.newTab,
                            onClick: function() {
                                setRewardsRedirect(true);
                            },
                            children: content === null || content === void 0 ? void 0 : (ref12 = content.cta2) === null || ref12 === void 0 ? void 0 : ref12.text
                        })
                    ]
                })
            ]
        })
    });
});
LoyaltyLionWelcome_Content_Content_Content.displayName = "Content";

;// CONCATENATED MODULE: ./src/sections/LoyaltyLionWelcome/Content/index.js


;// CONCATENATED MODULE: ./src/sections/LoyaltyLionWelcome/Image/Image.jsx


function LoyaltyLionWelcome_Image_Image_Image(param) {
    var image = param.image, media = param.media;
    var ref, ref1, ref2, ref3;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Picture */.t, {
        "data-comp": LoyaltyLionWelcome_Image_Image_Image.displayName,
        alt: image === null || image === void 0 ? void 0 : image.alt,
        images: [
            {
                src: image === null || image === void 0 ? void 0 : (ref = image.image) === null || ref === void 0 ? void 0 : ref.src,
                width: 768
            },
            {
                src: image === null || image === void 0 ? void 0 : (ref1 = image.imageDt) === null || ref1 === void 0 ? void 0 : ref1.src,
                width: 512
            },
            {
                src: image === null || image === void 0 ? void 0 : (ref2 = image.imageDt) === null || ref2 === void 0 ? void 0 : ref2.src,
                width: 640
            },
            {
                src: image === null || image === void 0 ? void 0 : (ref3 = image.imageDt) === null || ref3 === void 0 ? void 0 : ref3.src,
                width: 720
            }, 
        ],
        sx: {
            ":before": {
                content: '""',
                paddingBottom: [
                    media === null || media === void 0 ? void 0 : media.ratio,
                    media === null || media === void 0 ? void 0 : media.ratioDt
                ],
                width: 0
            }
        }
    });
}
LoyaltyLionWelcome_Image_Image_Image.displayName = "Image";

;// CONCATENATED MODULE: ./src/sections/LoyaltyLionWelcome/Image/index.js


;// CONCATENATED MODULE: ./src/sections/LoyaltyLionWelcome/LoyaltyLionWelcome.jsx








var LoyaltyLionWelcome = (0,src_utils/* withInView */.Dh)(function(param) {
    var cms = param.cms;
    var ref = (0,dist.useCustomerAuth)(), authenticated = ref.authenticated, customer = ref.customer, customerInit = ref.customerInit;
    var ref1 = (0,react.useState)(null), secSettings = ref1[0], setSecSettings = ref1[1];
    var ref2 = (0,react.useMemo)(function() {
        return {
            image: secSettings === null || secSettings === void 0 ? void 0 : secSettings.image,
            media: secSettings === null || secSettings === void 0 ? void 0 : secSettings.media,
            content: secSettings === null || secSettings === void 0 ? void 0 : secSettings.content
        };
    }, [
        customer === null || customer === void 0 ? void 0 : customer.id,
        secSettings
    ]), image = ref2.image, media = ref2.media, content = ref2.content;
    var section = cms === null || cms === void 0 ? void 0 : cms.section;
    var mediaLeft = (media === null || media === void 0 ? void 0 : media.locationDt) === "left"; // mobile
    var mediaTop = (media === null || media === void 0 ? void 0 : media.location) === "top"; // desktop
    (0,react.useEffect)(function() {
        if (customerInit) {
            if (customer === null || customer === void 0 ? void 0 : customer.id) {
                setSecSettings(cms === null || cms === void 0 ? void 0 : cms.userSettings);
            } else {
                setSecSettings(cms === null || cms === void 0 ? void 0 : cms.guestSettings);
            }
        }
    }, [
        customerInit,
        authenticated
    ]);
    if (!secSettings) return null;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Section */.$0, {
        "data-comp": LoyaltyLionWelcome.displayName,
        section: section,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)("div", {
            className: "flex items-center ".concat(mediaTop ? "flex-col" : "flex-col-reverse", " ").concat(mediaLeft ? "md:flex-row" : "md:flex-row-reverse"),
            children: [
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                    className: "w-full md:w-[52%]",
                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(LoyaltyLionWelcome_Image_Image_Image, {
                        image: image,
                        media: media
                    })
                }),
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                    className: "w-full md:w-[48%]",
                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(LoyaltyLionWelcome_Content_Content_Content, {
                        content: content,
                        customer: customer
                    })
                })
            ]
        })
    });
}, {
    triggerOnce: true
});
LoyaltyLionWelcome.displayName = "LoyaltyLion Welcome";
LoyaltyLionWelcome.Schema = LoyaltyLionWelcome_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/LoyaltyLionWelcome/index.js


;// CONCATENATED MODULE: ./src/sections/LoyaltyLionHowItWorks/LoyaltyLionHowItWorks.schema.js



function LoyaltyLionHowItWorks_schema_Schema(param) {
    var article = param.article, blog = param.blog;
    if (article || blog) return null;
    return {
        category: "LoyaltyLion",
        label: "LoyaltyLion How It Works",
        key: "loyaltyllion-howitwork",
        fields: [
            {
                label: "Enable If",
                name: "state",
                component: "radio-group",
                direction: "horizontal",
                variant: "radio",
                options: [
                    {
                        value: "guest",
                        label: "Signed Out"
                    },
                    {
                        value: "user",
                        label: "Signed In"
                    },
                    {
                        value: "enable",
                        label: "Always"
                    }, 
                ]
            },
            {
                label: "Image Settings",
                name: "image",
                description: "Image, alt text",
                component: "group",
                fields: [
                    {
                        label: "Image Alt",
                        name: "alt",
                        component: "text",
                        description: "Provide a brief description of the image for accessibility compliance"
                    },
                    {
                        name: "imageDt",
                        label: "Image (desktop)",
                        component: "image"
                    },
                    {
                        label: "Image (mobile)",
                        name: "image",
                        component: "image"
                    }, 
                ],
                defaultValue: {
                    alt: "A Woman sitting on a couch with a Hopsulator slim in her hand.",
                    image: {
                        src: "https://cdn.shopify.com/s/files/1/1114/2308/files/FirstCanCooler.png"
                    },
                    imageDt: {
                        src: "https://cdn.shopify.com/s/files/1/1114/2308/files/FirstCanCooler.png"
                    }
                }
            },
            {
                label: "Media Settings",
                name: "media",
                description: "Position, placement, aspect ratio",
                component: "group",
                fields: [
                    {
                        label: "Placement (desktop)",
                        component: "radio-group",
                        direction: "horizontal",
                        variant: "radio",
                        name: "locationDt",
                        options: [
                            {
                                value: "left",
                                label: "Left"
                            },
                            {
                                value: "right",
                                label: "Right"
                            }, 
                        ]
                    },
                    {
                        label: "Aspect ratio (desktop)",
                        name: "ratioDt",
                        component: "radio-group",
                        description: "Only applies to images and video files not already set to 1:1 ratio",
                        direction: "horizontal",
                        variant: "radio",
                        options: [
                            {
                                value: "42%",
                                label: "42:100"
                            },
                            {
                                value: "80%",
                                label: "5:4"
                            },
                            {
                                value: "100%",
                                label: "1:1"
                            },
                            {
                                value: "120%",
                                label: "5:6"
                            }, 
                        ]
                    },
                    {
                        label: "Placement (mobile)",
                        name: "location",
                        component: "radio-group",
                        direction: "horizontal",
                        variant: "radio",
                        options: [
                            {
                                value: "top",
                                label: "Top"
                            },
                            {
                                value: "bottom",
                                label: "Bottom"
                            }, 
                        ]
                    },
                    {
                        label: "Aspect ratio (mobile)",
                        component: "radio-group",
                        description: "Only applies to images and video files not already set to 1:1 ratio",
                        direction: "horizontal",
                        variant: "radio",
                        name: "ratio",
                        options: [
                            {
                                value: "42%",
                                label: "42:100"
                            },
                            {
                                value: "80%",
                                label: "5:4"
                            },
                            {
                                value: "100%",
                                label: "1:1"
                            },
                            {
                                value: "120%",
                                label: "5:6"
                            }, 
                        ]
                    },
                    {
                        label: "Media Max Width (mobile)",
                        name: "maxWidth",
                        component: "select",
                        options: [
                            {
                                label: "100%",
                                value: ""
                            },
                            {
                                label: "Narrow",
                                value: "narrow"
                            }, 
                        ]
                    }, 
                ],
                defaultValue: {
                    location: "top",
                    locationDt: "left",
                    ratio: "100%",
                    ratioDt: "100%",
                    position: "center center",
                    positionDt: "center center"
                }
            },
            {
                label: "Content Settings",
                name: "content",
                description: "Heading, superheading body, link, content alignment",
                component: "group",
                fields: [
                    {
                        label: "Heading",
                        name: "heading",
                        component: "text"
                    },
                    {
                        label: "Body",
                        name: "body",
                        component: "markdown"
                    },
                    {
                        label: "List Content",
                        name: "list",
                        component: "group-list",
                        itemProps: {
                            label: "{{item.heading}}"
                        },
                        fields: [
                            {
                                name: "heading",
                                label: "Heading",
                                component: "text"
                            },
                            {
                                name: "text",
                                label: "Text",
                                component: "text"
                            }, 
                        ]
                    },
                    {
                        label: "List style",
                        component: "radio-group",
                        direction: "horizontal",
                        variant: "radio",
                        name: "listStyle",
                        options: [
                            {
                                value: "Number",
                                label: "Number"
                            },
                            {
                                value: "Circle",
                                label: "Number (Circle)"
                            }, 
                        ]
                    },
                    {
                        label: "Link",
                        name: "cta",
                        component: "link"
                    },
                    {
                        name: "ctaStyle",
                        label: "Link Style",
                        component: "select",
                        options: common/* button.options */.LI.options
                    },
                    {
                        label: "Content alignment (mobile)",
                        name: "alignment",
                        component: "radio-group",
                        direction: "horizontal",
                        variant: "radio",
                        options: common/* align.options */.AJ.options
                    },
                    {
                        label: "Content alignment (desktop)",
                        name: "alignmentDt",
                        component: "radio-group",
                        direction: "horizontal",
                        variant: "radio",
                        options: common/* align.options */.AJ.options
                    }, 
                ],
                defaultValue: {
                    heading: "THE WORLD'S FIRST SLIM CAN COOLER.",
                    body: "",
                    listStyle: "number",
                    alignment: common/* align.value.left */.AJ.value.left,
                    alignmentDt: common/* align.value.left */.AJ.value.left
                }
            },
            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, common/* section */.qi), {
                defaultValue: {
                    desktop: {
                        container: "container",
                        mt: "none",
                        py: "none"
                    },
                    mobile: {
                        container: "content",
                        mt: "none",
                        py: "none"
                    }
                }
            }), 
        ],
        defaultValue: {
            state: "enable"
        }
    };
}

;// CONCATENATED MODULE: ./src/sections/LoyaltyLionHowItWorks/Content/Content.theme.js


var LoyaltyLionHowItWorks_Content_Content_theme_themed = (0,create/* create */.U)(new function() {
    this.outer = {
        width: "100%",
        justifyContent: "center",
        alignItems: [
            "flex-start",
            "center"
        ],
        px: 12,
        py: [
            18,
            16
        ],
        "@media only screen and (max-width: 479px)": {
            py: 15
        }
    };
    this.heading = {
        variant: "text.h2",
        fontSize: [
            10,
            12
        ]
    };
    this.bodyWithoutHeading = {
        variant: "text.base",
        mt: 0,
        ul: {
            ml: 0
        },
        "p:last-of-type": {
            mb: 0
        }
    };
    this.listNumber = {
        counterReset: "step-counter",
        li: {
            position: "relative"
        },
        "li::before": {
            counterIncrement: "step-counter",
            content: 'counter(step-counter)". "'
        }
    };
    this.listCirlce = {
        counterReset: "step-counter",
        li: {
            position: "relative",
            pl: [
                "61px",
                "66px"
            ]
        },
        "li::before": {
            counterIncrement: "step-counter",
            content: "counter(step-counter)",
            position: "absolute",
            background: "tundora",
            borderRadius: "50%",
            top: "50%",
            left: "0",
            mt: [
                "-20.5px",
                "-23px"
            ],
            width: [
                "41px",
                "46px"
            ],
            height: [
                "41px",
                "46px"
            ],
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }
    };
    this.bodyWithHeading = (0,_object_spread/* default */.Z)({}, this.bodyWithoutHeading);
}());

;// CONCATENATED MODULE: ./src/sections/LoyaltyLionHowItWorks/Content/Content.jsx







var LoyaltyLionHowItWorks_Content_Content_Content = LoyaltyLionHowItWorks_Content_Content_theme_themed(function(param) {
    var theme = param.theme, content = param.content, customer = param.customer;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var textAlign = [
        content === null || content === void 0 ? void 0 : content.alignment,
        content === null || content === void 0 ? void 0 : content.alignmentDt
    ];
    var flexAlign = textAlign.map(function(align) {
        return (0,utils_common/* convertAlignToFlex */.nG)(align);
    });
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
        "data-comp": LoyaltyLionHowItWorks_Content_Content_Content.displayName,
        sx: theme.outer,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
            sx: {
                variant: "flex.column",
                width: "100%",
                maxWidth: [
                    "600px",
                    "450px"
                ],
                alignItems: flexAlign,
                gap: "11"
            },
            children: [
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.heading), {
                        textAlign: textAlign
                    }),
                    children: content === null || content === void 0 ? void 0 : (ref = content.heading) === null || ref === void 0 ? void 0 : ref.replace(/\[customer_name\]/gi, customer === null || customer === void 0 ? void 0 : customer.displayName)
                }),
                (content === null || content === void 0 ? void 0 : content.body) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Markdown */.UG, {
                    text: content.body,
                    sx: (0,_object_spread/* default */.Z)({}, (content === null || content === void 0 ? void 0 : content.heading) ? theme.bodyWithHeading : theme.bodyWithoutHeading),
                    textSx: {
                        textAlign: textAlign
                    }
                }),
                (content === null || content === void 0 ? void 0 : content.list) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("ol", {
                    className: "list-none font-medium flex flex-col gap-4 md:gap-6",
                    sx: (0,_object_spread/* default */.Z)({}, (content === null || content === void 0 ? void 0 : content.listStyle) === "Number" ? theme.listNumber : theme.listCirlce),
                    children: ((content === null || content === void 0 ? void 0 : content.list) || []).map(function(item, index) {
                        /*#__PURE__*/ return (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)("li", {
                            sx: {
                                fontSize: [
                                    4,
                                    6
                                ]
                            },
                            children: [
                                item === null || item === void 0 ? void 0 : item.heading,
                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("p", {
                                    className: "mt-1 md:mt-0",
                                    sx: {
                                        fontSize: [
                                            "13px",
                                            4
                                        ]
                                    },
                                    children: item === null || item === void 0 ? void 0 : item.text
                                })
                            ]
                        }, "list-".concat(index));
                    })
                }),
                (content === null || content === void 0 ? void 0 : (ref1 = content.cta) === null || ref1 === void 0 ? void 0 : ref1.text) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                    className: "flex gap-5 md:gap-6",
                    children: (content === null || content === void 0 ? void 0 : (ref2 = content.cta) === null || ref2 === void 0 ? void 0 : ref2.text) && ((content === null || content === void 0 ? void 0 : content.ctaStyle) === "lionRefer" ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Link */.rU, {
                        variant: "buttons.".concat((content === null || content === void 0 ? void 0 : content.ctaStyle) || "secondary"),
                        href: content === null || content === void 0 ? void 0 : (ref3 = content.cta) === null || ref3 === void 0 ? void 0 : ref3.url,
                        newTab: content === null || content === void 0 ? void 0 : (ref4 = content.cta) === null || ref4 === void 0 ? void 0 : ref4.newTab,
                        "data-lion-refer": true,
                        children: content === null || content === void 0 ? void 0 : (ref5 = content.cta) === null || ref5 === void 0 ? void 0 : ref5.text
                    }) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Link */.rU, {
                        variant: "buttons.".concat((content === null || content === void 0 ? void 0 : content.ctaStyle) || "secondary"),
                        href: content === null || content === void 0 ? void 0 : (ref6 = content.cta) === null || ref6 === void 0 ? void 0 : ref6.url,
                        newTab: content === null || content === void 0 ? void 0 : (ref7 = content.cta) === null || ref7 === void 0 ? void 0 : ref7.newTab,
                        children: content === null || content === void 0 ? void 0 : (ref8 = content.cta) === null || ref8 === void 0 ? void 0 : ref8.text
                    }))
                })
            ]
        })
    });
});
LoyaltyLionHowItWorks_Content_Content_Content.displayName = "Content";

;// CONCATENATED MODULE: ./src/sections/LoyaltyLionHowItWorks/Content/index.js


;// CONCATENATED MODULE: ./src/sections/LoyaltyLionHowItWorks/Image/Image.jsx


function LoyaltyLionHowItWorks_Image_Image_Image(param) {
    var image = param.image, media = param.media;
    var ref, ref1, ref2, ref3;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Picture */.t, {
        "data-comp": LoyaltyLionHowItWorks_Image_Image_Image.displayName,
        alt: image === null || image === void 0 ? void 0 : image.alt,
        images: [
            {
                src: image === null || image === void 0 ? void 0 : (ref = image.image) === null || ref === void 0 ? void 0 : ref.src,
                width: 768
            },
            {
                src: image === null || image === void 0 ? void 0 : (ref1 = image.imageDt) === null || ref1 === void 0 ? void 0 : ref1.src,
                width: 512
            },
            {
                src: image === null || image === void 0 ? void 0 : (ref2 = image.imageDt) === null || ref2 === void 0 ? void 0 : ref2.src,
                width: 640
            },
            {
                src: image === null || image === void 0 ? void 0 : (ref3 = image.imageDt) === null || ref3 === void 0 ? void 0 : ref3.src,
                width: 720
            }, 
        ],
        sx: {
            maxWidth: (media === null || media === void 0 ? void 0 : media.maxWidth) === "narrow" ? [
                "236px",
                "100%"
            ] : "100%",
            mx: "auto",
            ":before": {
                content: '""',
                paddingBottom: [
                    media === null || media === void 0 ? void 0 : media.ratio,
                    media === null || media === void 0 ? void 0 : media.ratioDt
                ],
                width: 0
            }
        }
    });
}
LoyaltyLionHowItWorks_Image_Image_Image.displayName = "Image";

;// CONCATENATED MODULE: ./src/sections/LoyaltyLionHowItWorks/Image/index.js


;// CONCATENATED MODULE: ./src/sections/LoyaltyLionHowItWorks/LoyaltyLionHowItWorks.jsx







var LoyaltyLionHowItWorks = (0,src_utils/* withInView */.Dh)(function(param) {
    var cms = param.cms;
    var customer = (0,dist.useCustomer)();
    var state = cms.state, image = cms.image, media = cms.media, content = cms.content, section = cms.section;
    var mediaLeft = (media === null || media === void 0 ? void 0 : media.locationDt) === "left"; // mobile
    var mediaTop = (media === null || media === void 0 ? void 0 : media.location) === "top"; // desktop
    var enable = state === "enable" || state === "guest" && !(customer === null || customer === void 0 ? void 0 : customer.id) || state === "user" && (customer === null || customer === void 0 ? void 0 : customer.id);
    if (!enable) return null;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Section */.$0, {
        "data-comp": LoyaltyLionHowItWorks.displayName,
        section: section,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)("div", {
            className: "flex items-center ".concat(mediaTop ? "flex-col" : "flex-col-reverse", " ").concat(mediaLeft ? "md:flex-row" : "md:flex-row-reverse"),
            children: [
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                    className: "w-full md:w-1/2",
                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(LoyaltyLionHowItWorks_Image_Image_Image, {
                        image: image,
                        media: media
                    })
                }),
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                    className: "w-full md:w-1/2",
                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(LoyaltyLionHowItWorks_Content_Content_Content, {
                        content: content,
                        customer: customer
                    })
                })
            ]
        })
    });
}, {
    triggerOnce: true
});
LoyaltyLionHowItWorks.displayName = "LoyaltyLion Welcome";
LoyaltyLionHowItWorks.Schema = LoyaltyLionHowItWorks_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/LoyaltyLionHowItWorks/index.js


;// CONCATENATED MODULE: ./src/sections/LoyaltyLionPoints/LoyaltyLionPoints.theme.js


var LoyaltyLionPoints_theme_themed = (0,create/* create */.U)(new function() {
    this.heading = {
        variant: "text.h2",
        fontSize: [
            10,
            12
        ]
    };
    this.paragraph = {
        fontSize: [
            "13px",
            6
        ],
        lineHeight: [
            "normal",
            "24px"
        ],
        fontWeight: "body"
    };
    this.bodyWithoutHeading = {
        variant: "text.base",
        fontSize: [
            "13px",
            6
        ],
        lineHeight: [
            "normal",
            "24px"
        ],
        mt: 0,
        py: 10,
        ul: {
            ml: 0
        },
        "p:last-of-type": {
            mb: 0
        }
    };
    this.bodyWithHeading = (0,_object_spread/* default */.Z)({}, this.bodyWithoutHeading);
}());

;// CONCATENATED MODULE: ./src/sections/LoyaltyLionPoints/LoyaltyLionPoints.schema.js



function LoyaltyLionPoints_schema_Schema(param) {
    var article = param.article, blog = param.blog;
    if (article || blog) return null;
    return {
        category: "LoyaltyLion",
        label: "LoyaltyLion customer poins",
        key: "loyaltyllion-customer-poins",
        fields: [
            {
                label: "Heading",
                name: "heading",
                component: "text",
                description: "use [Points] for real customer points"
            },
            {
                label: "SubHeading",
                name: "subHeading",
                component: "text",
                description: "use [Pending_points] for real customer pending points"
            },
            {
                label: "Body",
                name: "body",
                component: "markdown"
            },
            {
                label: "Link",
                name: "cta",
                component: "link"
            },
            {
                name: "ctaStyle",
                label: "Link Style",
                component: "select",
                options: common/* button.options */.LI.options
            },
            {
                label: "Content alignment (mobile)",
                name: "alignment",
                component: "radio-group",
                direction: "horizontal",
                variant: "radio",
                options: common/* align.options */.AJ.options
            },
            {
                label: "Content alignment (desktop)",
                name: "alignmentDt",
                component: "radio-group",
                direction: "horizontal",
                variant: "radio",
                options: common/* align.options */.AJ.options
            },
            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, common/* section */.qi), {
                defaultValue: {
                    desktop: {
                        container: "container",
                        mt: "none",
                        py: "none"
                    },
                    mobile: {
                        container: "content",
                        mt: "none",
                        py: "none"
                    }
                }
            }), 
        ],
        defaultValue: {
            heading: "You Have [Points] Points",
            subHeading: "([Pending_points] Points Pending)",
            body: "",
            alignment: common/* align.value.left */.AJ.value.left,
            alignmentDt: common/* align.value.left */.AJ.value.left
        }
    };
}

;// CONCATENATED MODULE: ./src/sections/LoyaltyLionPoints/LoyaltyLionPoints.jsx









var LoyaltyLionPoints = LoyaltyLionPoints_theme_themed(function(param) {
    var theme = param.theme, cms = param.cms;
    var customer = (0,dist.useCustomer)();
    var heading = cms.heading, subHeading = cms.subHeading, body = cms.body, cta = cms.cta, ctaStyle = cms.ctaStyle, section = cms.section;
    var textAlign = [
        cms === null || cms === void 0 ? void 0 : cms.alignment,
        cms === null || cms === void 0 ? void 0 : cms.alignmentDt
    ];
    var flexAlign = textAlign.map(function(align) {
        return (0,utils_common/* convertAlignToFlex */.nG)(align);
    });
    if (!(customer === null || customer === void 0 ? void 0 : customer.id)) return null;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Section */.$0, {
        "data-comp": LoyaltyLionPoints.displayName,
        section: section,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)("div", {
            className: "flex flex-col gap-2 py-14",
            children: [
                heading && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.heading), {
                        textAlign: textAlign
                    }),
                    dangerouslySetInnerHTML: {
                        __html: heading === null || heading === void 0 ? void 0 : heading.replace(/\[Points\]/gi, "<span data-lion-points></span>")
                    }
                }),
                subHeading && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.paragraph), {
                        textAlign: textAlign
                    }),
                    dangerouslySetInnerHTML: {
                        __html: subHeading === null || subHeading === void 0 ? void 0 : subHeading.replace(/\[Pending_points\]/gi, '<span data-lion-points="pending"></span>')
                    }
                }),
                body && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Markdown */.UG, {
                    text: body,
                    sx: (0,_object_spread/* default */.Z)({}, heading ? theme.bodyWithHeading : theme.bodyWithoutHeading),
                    textSx: {
                        textAlign: textAlign
                    }
                }),
                (cta === null || cta === void 0 ? void 0 : cta.text) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                    className: "flex gap-5 md:gap-6",
                    sx: {
                        justifyContent: flexAlign
                    },
                    children: ctaStyle === "lionRefer" ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Link */.rU, {
                        variant: "buttons.".concat(ctaStyle || "secondary"),
                        href: cta === null || cta === void 0 ? void 0 : cta.url,
                        newTab: cta === null || cta === void 0 ? void 0 : cta.newTab,
                        "data-lion-refer": true,
                        children: cta === null || cta === void 0 ? void 0 : cta.text
                    }) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Link */.rU, {
                        variant: "buttons.".concat(ctaStyle || "secondary"),
                        href: cta === null || cta === void 0 ? void 0 : cta.url,
                        newTab: cta === null || cta === void 0 ? void 0 : cta.newTab,
                        children: cta === null || cta === void 0 ? void 0 : cta.text
                    })
                })
            ]
        })
    });
});
LoyaltyLionPoints.displayName = "LoyaltyLion Customer Points";
LoyaltyLionPoints.Schema = LoyaltyLionPoints_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/LoyaltyLionPoints/index.js


;// CONCATENATED MODULE: ./src/sections/EmbedContent/EmbedContent.theme.js


var EmbedContent_theme_themed = (0,create/* create */.U)(new function() {
    this.heading = {
        variant: "text.h2",
        fontSize: [
            10,
            12
        ],
        mb: [
            8,
            11
        ]
    };
    this.paragraph = {
        fontSize: [
            "13px",
            6
        ],
        lineHeight: [
            "normal",
            "24px"
        ],
        fontWeight: "body",
        mt: [
            -4,
            -7
        ]
    };
    this.bodyWithoutHeading = {
        variant: "text.base",
        fontSize: [
            "13px",
            6
        ],
        lineHeight: [
            "normal",
            "24px"
        ],
        mt: 0,
        py: 10,
        ul: {
            ml: 0
        },
        "p:last-of-type": {
            mb: 0
        }
    };
    this.bodyWithHeading = (0,_object_spread/* default */.Z)({}, this.bodyWithoutHeading);
}());

// EXTERNAL MODULE: ./src/settings/common/color.js
var color = __webpack_require__(37351);
;// CONCATENATED MODULE: ./src/sections/EmbedContent/EmbedContent.schema.js




var EmbedContent_schema_Schema = function() {
    return {
        category: "Embed",
        label: "Embed Content",
        key: "embed-content",
        fields: [
            {
                label: "Enable If",
                name: "state",
                component: "radio-group",
                direction: "horizontal",
                variant: "radio",
                options: [
                    {
                        value: "guest",
                        label: "Signed Out"
                    },
                    {
                        value: "user",
                        label: "Signed In"
                    },
                    {
                        value: "enable",
                        label: "Always"
                    }, 
                ]
            },
            {
                label: "Heading",
                name: "heading",
                component: "text"
            },
            {
                label: "Heading Color",
                name: "headingColor",
                component: "select",
                options: color/* color.options */.$.options,
                defaultValue: "#574F4C"
            },
            {
                label: "SubHeading",
                name: "subHeading",
                component: "text"
            },
            {
                name: "snippet",
                label: "Embed Code",
                component: "html",
                description: "Paste in snippet we want to display"
            },
            {
                label: "Content alignment (mobile)",
                name: "alignment",
                component: "radio-group",
                direction: "horizontal",
                variant: "radio",
                options: common/* align.options */.AJ.options
            },
            {
                label: "Content alignment (desktop)",
                name: "alignmentDt",
                component: "radio-group",
                direction: "horizontal",
                variant: "radio",
                options: common/* align.options */.AJ.options
            },
            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, common/* section */.qi), {
                defaultValue: {
                    desktop: {
                        container: "container",
                        mt: "none",
                        py: "none"
                    },
                    mobile: {
                        container: "content",
                        mt: "none",
                        py: "none"
                    }
                }
            }), 
        ],
        defaultValue: {
            state: "enable",
            alignment: common/* align.value.center */.AJ.value.center,
            alignmentDt: common/* align.value.center */.AJ.value.center
        }
    };
};

;// CONCATENATED MODULE: ./src/sections/EmbedContent/EmbedContent.jsx








var EmbedContent = EmbedContent_theme_themed(function(param) {
    var theme = param.theme, cms = param.cms;
    var customer = (0,dist.useCustomer)();
    var state = cms.state, heading = cms.heading, headingColor = cms.headingColor, subHeading = cms.subHeading, section = cms.section;
    var textAlign = [
        cms === null || cms === void 0 ? void 0 : cms.alignment,
        cms === null || cms === void 0 ? void 0 : cms.alignmentDt
    ];
    var enable = state === "enable" || state === "guest" && !(customer === null || customer === void 0 ? void 0 : customer.id) || state === "user" && (customer === null || customer === void 0 ? void 0 : customer.id);
    if (!enable) return null;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Section */.$0, {
        "data-comp": EmbedContent.displayName,
        section: section,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)("div", {
            className: "py-10",
            children: [
                heading && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.heading), {
                        textAlign: textAlign,
                        color: headingColor || "text"
                    }),
                    children: heading
                }),
                subHeading && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.paragraph), {
                        textAlign: textAlign,
                        color: headingColor || "text"
                    }),
                    dangerouslySetInnerHTML: {
                        __html: subHeading
                    }
                }),
                (cms === null || cms === void 0 ? void 0 : cms.snippet) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                    className: "m-auto block",
                    dangerouslySetInnerHTML: {
                        __html: cms.snippet
                    }
                })
            ]
        })
    });
});
EmbedContent.displayName = "EmbedContent";
EmbedContent.Schema = EmbedContent_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/EmbedContent/index.js


// EXTERNAL MODULE: ./src/snippets/ProductSwiper/Navigation/NavigationButton.jsx
var Navigation_NavigationButton = __webpack_require__(34086);
// EXTERNAL MODULE: ./src/snippets/ProductSwiper/useProductSwiperParams.js
var useProductSwiperParams = __webpack_require__(65207);
;// CONCATENATED MODULE: ./src/sections/LoyaltylionRewardsList/LoyaltylionRewardsList.theme.js


var LoyaltylionRewardsList_theme_themed = (0,create/* create */.U)(new function() {
    this.heading = {
        variant: "text.h2",
        fontSize: [
            10,
            12
        ],
        mb: [
            8,
            11
        ]
    };
    this.paragraph = {
        fontSize: [
            "13px",
            6
        ],
        lineHeight: [
            "normal",
            "24px"
        ],
        fontWeight: "body",
        mt: [
            -4,
            -7
        ]
    };
    this.bodyWithoutHeading = {
        variant: "text.base",
        fontSize: [
            "13px",
            6
        ],
        lineHeight: [
            "normal",
            "24px"
        ],
        mt: 0,
        py: 10,
        ul: {
            ml: 0
        },
        "p:last-of-type": {
            mb: 0
        }
    };
    this.bodyWithHeading = (0,_object_spread/* default */.Z)({}, this.bodyWithoutHeading);
    this.onlyproductDiscount = {
        ".lion-reward-item--cart-discount-voucher": {
            display: "none!important"
        }
    };
    this.onlycartDiscount = {
        ".lion-reward-item--product-discount-voucher,.lion-reward-item--product-cart": {
            display: "none!important"
        }
    };
    this.slides = {
        ".swiper-slide": {
            opacity: 0.25
        },
        ".swiper-slide-active, .swiper-slide-next, .swiper-slide-prev": {
            opacity: 1
        }
    };
}());

;// CONCATENATED MODULE: ./src/sections/LoyaltylionRewardsList/LoyaltylionRewardsList.schema.js




var LoyaltylionRewardsList_schema_Schema = function() {
    return {
        category: "LoyaltyLion",
        label: "Loyaltylion Rewards List",
        key: "loyaltylion-rewards-list",
        fields: [
            {
                label: "Enable If",
                name: "state",
                component: "radio-group",
                direction: "horizontal",
                variant: "radio",
                options: [
                    {
                        value: "guest",
                        label: "Signed Out"
                    },
                    {
                        value: "user",
                        label: "Signed In"
                    },
                    {
                        value: "enable",
                        label: "Always"
                    },
                    {
                        value: "userByTag",
                        label: "User By Tag"
                    },
                    {
                        value: "userWithoutTag",
                        label: "User without Tag"
                    }, 
                ],
                defaultValue: "enable"
            },
            {
                label: "User Tag",
                name: "userTag",
                component: "textarea",
                defaultValue: "tier: Platinum",
                description: "Enter values with each value separated by a comma"
            },
            {
                label: "Rewards type",
                name: "rewardsType",
                component: "radio-group",
                direction: "horizontal",
                variant: "radio",
                options: [
                    {
                        value: "cartDiscount",
                        label: "Cart Discount Voucher"
                    },
                    {
                        value: "productDiscount",
                        label: "Product Discount Voucher"
                    },
                    {
                        value: "rewardIds",
                        label: "Filter by Reward Ids"
                    },
                    {
                        value: "all",
                        label: "All types"
                    }, 
                ],
                defaultValue: "all"
            },
            {
                label: "Reward Ids",
                name: "rewardIds",
                component: "text",
                defaultValue: ""
            },
            {
                label: "Display type",
                name: "displayType",
                component: "radio-group",
                direction: "horizontal",
                variant: "radio",
                options: [
                    {
                        value: "grid",
                        label: "Grid"
                    },
                    {
                        value: "slider",
                        label: "Slider"
                    }, 
                ],
                defaultValue: "grid"
            },
            {
                label: "Heading",
                name: "heading",
                component: "text"
            },
            {
                label: "Heading Color",
                name: "headingColor",
                component: "select",
                options: color/* color.options */.$.options,
                defaultValue: "#574F4C"
            },
            {
                label: "SubHeading",
                name: "subHeading",
                component: "text",
                defaultValue: "(You need a paid item in your cart to redeem these)"
            },
            {
                label: "Content alignment (mobile)",
                name: "alignment",
                component: "radio-group",
                direction: "horizontal",
                variant: "radio",
                options: common/* align.options */.AJ.options
            },
            {
                label: "Content alignment (desktop)",
                name: "alignmentDt",
                component: "radio-group",
                direction: "horizontal",
                variant: "radio",
                options: common/* align.options */.AJ.options
            },
            {
                name: "icons",
                label: "Icons replacement",
                component: "group-list",
                description: "List icons",
                fields: [
                    {
                        name: "icon",
                        label: "Icon",
                        component: "image"
                    }, 
                ]
            },
            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, common/* section */.qi), {
                defaultValue: {
                    desktop: {
                        container: "container",
                        mt: "none",
                        py: "none"
                    },
                    mobile: {
                        container: "content",
                        mt: "none",
                        py: "none"
                    }
                }
            }), 
        ]
    };
};

;// CONCATENATED MODULE: ./src/sections/LoyaltylionRewardsList/LoyaltylionRewardsList.jsx


















var LoyaltylionRewardsList = LoyaltylionRewardsList_theme_themed(function(param) {
    var theme = param.theme, cms = param.cms;
    var moduleID = "".concat(LoyaltylionRewardsList_schema_Schema().key, "-").concat(cms.id || cms.cmsId || cms.tinaId);
    var customer = (0,dist.useCustomer)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* default.loyaltylionLoaded */.ZP.loyaltylionLoaded), 1), loyaltylionLoaded = ref[0];
    var state = cms.state, userTag = cms.userTag, heading = cms.heading, headingColor = cms.headingColor, subHeading = cms.subHeading, rewardsType = cms.rewardsType, rewardIds = cms.rewardIds, displayType = cms.displayType, icons = cms.icons, section = cms.section;
    var textAlign = [
        cms === null || cms === void 0 ? void 0 : cms.alignment,
        cms === null || cms === void 0 ? void 0 : cms.alignmentDt
    ];
    var ref1 = (0,react.useState)(false), loyaltylionRendered = ref1[0], setLoyaltylionRendered = ref1[1];
    var asPath = (0,next_router.useRouter)().asPath;
    var ref2 = (0,react.useState)(null), swiper = ref2[0], setSwiper = ref2[1];
    var ref3 = (0,react.useState)(true), isStart = ref3[0], setIsStart = ref3[1];
    var ref4 = (0,react.useState)(false), isEnd = ref4[0], setIsEnd = ref4[1];
    var ref5 = (0,react.useState)(true), loop = ref5[0], setLoop = ref5[1];
    var ref6 = (0,react.useState)(true), count = ref6[0], setCount = ref6[1];
    var ref7 = (0,react.useState)(false), initializing = ref7[0], setInitializing = ref7[1];
    var ref8 = (0,react.useState)(0), itemCount = ref8[0], setItemCount = ref8[1];
    var ref9 = (0,react.useState)(0), timer = ref9[0], setTimer = ref9[1];
    var navRef = (0,react.useRef)(null);
    var sliderEnable = displayType === "slider";
    var swiperParams = (0,useProductSwiperParams/* useProductSwiperParams */.c)({
        isProductRecs: true,
        loopEnabled: loop,
        count: count
    });
    var iconsStyle = (0,react.useMemo)(function() {
        return (icons || []).reduce(function(acc, icon, index) {
            var ref;
            if (icon === null || icon === void 0 ? void 0 : (ref = icon.icon) === null || ref === void 0 ? void 0 : ref.src) {
                var ref1;
                return (0,_to_consumable_array/* default */.Z)(acc).concat([
                    "#".concat(moduleID, " .lion-rewards-list .lion-reward-item").concat(index + 1, '{--loyaltyLion-reward-icon: url("').concat(icon === null || icon === void 0 ? void 0 : (ref1 = icon.icon) === null || ref1 === void 0 ? void 0 : ref1.src, '")}'), 
                ]);
            }
            return acc;
        }, []);
    }, [
        icons
    ]);
    var rewardShowClasses = (0,react.useMemo)(function() {
        return (rewardIds || []).reduce(function(acc, id, index) {
            if (index === 0) {
                acc.push("#".concat(moduleID, " .lion-rewards-list .lion-reward-item{display: none;}"));
            }
            return (0,_to_consumable_array/* default */.Z)(acc).concat([
                "#".concat(moduleID, ' .lion-rewards-list .lion-reward-item[data-reward-id="').concat(id.trim(), '"]{display: flex;}'), 
            ]);
        }, []);
    }, [
        rewardIds
    ]);
    var disableRewardIds = (0,react.useMemo)(function() {
        return ((customer === null || customer === void 0 ? void 0 : customer.tags) || []).reduce(function(acc, id) {
            if (id.indexOf("_rewardId:") === 0) {
                var idInt = id.replace("_rewardId:", "");
                return (0,_to_consumable_array/* default */.Z)(acc).concat([
                    idInt
                ]);
            }
            return acc;
        }, []);
    }, [
        customer === null || customer === void 0 ? void 0 : customer.tags
    ]);
    var userTags = (0,react.useMemo)(function() {
        var ref;
        if (!userTag || userTag === "") return [];
        return (ref = userTag === null || userTag === void 0 ? void 0 : userTag.split(",")) === null || ref === void 0 ? void 0 : ref.map(function(tag) {
            return tag.trim();
        });
    }, [
        userTag
    ]);
    var tiersArray = [
        "tier: Bronze",
        "tier: Silver",
        "tier: Gold",
        "tier: Platinum", 
    ];
    var limitRewardReached = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3;
        var year = new Date().toLocaleString("en-US", {
            timeZone: "America/Los_Angeles",
            year: "numeric"
        }).toString();
        var tier = ((ref1 = customer === null || customer === void 0 ? void 0 : (ref = customer.tags) === null || ref === void 0 ? void 0 : ref.find(function(tag) {
            return tiersArray.includes(tag);
        })) === null || ref1 === void 0 ? void 0 : ref1.replace("tier: ", "")) || "";
        var limitTag = "".concat(tier, "_").concat(year, "_rewardId:");
        return tier === "Platinum" && ((ref3 = customer === null || customer === void 0 ? void 0 : (ref2 = customer.tags) === null || ref2 === void 0 ? void 0 : ref2.filter(function(tag) {
            return tag.indexOf(limitTag) === 0;
        })) === null || ref3 === void 0 ? void 0 : ref3.length) === 2;
    }, [
        customer === null || customer === void 0 ? void 0 : customer.tags,
        tiersArray
    ]);
    var enable = (0,react.useMemo)(function() {
        return state === "enable" || state === "guest" && !(customer === null || customer === void 0 ? void 0 : customer.id) || state === "user" && !!(customer === null || customer === void 0 ? void 0 : customer.id) || state === "userByTag" && (customer === null || customer === void 0 ? void 0 : customer.id) && (userTags === null || userTags === void 0 ? void 0 : userTags.length) && (userTags === null || userTags === void 0 ? void 0 : userTags.some(function(tag) {
            var ref;
            return customer === null || customer === void 0 ? void 0 : (ref = customer.tags) === null || ref === void 0 ? void 0 : ref.includes(tag);
        })) || state === "userWithoutTag" && (customer === null || customer === void 0 ? void 0 : customer.id) && (userTags === null || userTags === void 0 ? void 0 : userTags.length) && (userTags === null || userTags === void 0 ? void 0 : userTags.every(function(tag) {
            var ref;
            return !(customer === null || customer === void 0 ? void 0 : (ref = customer.tags) === null || ref === void 0 ? void 0 : ref.includes(tag));
        }));
    }, [
        state,
        customer === null || customer === void 0 ? void 0 : customer.id,
        customer === null || customer === void 0 ? void 0 : customer.tags,
        userTags
    ]);
    (0,react.useEffect)(function() {
        var t = setInterval(function() {
            if (timer > 20) {
                clearInterval(t);
            }
            if (loyaltylionLoaded && document.querySelector("#".concat(moduleID, " .lion-reward-item"))) {
                var rewardItems = Array.from(document.querySelectorAll("#".concat(moduleID, " .lion-reward-item")));
                if ((rewardItems === null || rewardItems === void 0 ? void 0 : rewardItems.length) && (rewardItems === null || rewardItems === void 0 ? void 0 : rewardItems.length) !== itemCount) {
                    setItemCount(rewardItems.length);
                } else {
                    window.clearInterval(t);
                    setLoyaltylionRendered(true);
                }
                clearInterval(t);
            } else {
                setTimer(timer + 1);
            }
        }, 500);
        return function() {
            clearInterval(t);
            setLoyaltylionRendered(false);
        };
    }, [
        loyaltylionLoaded,
        asPath,
        itemCount
    ]);
    (0,react.useEffect)(function() {
        if (loyaltylionLoaded && rewardsType !== "all" && loyaltylionRendered && !swiper) {
            var rewardsClass;
            if (rewardsType === "productDiscount") {
                rewardsClass = "#".concat(moduleID, " .lion-reward-item--cart-discount-voucher, #").concat(moduleID, " .lion-reward-item--checkout-redemption");
            } else if (rewardsType === "cartDiscount") {
                rewardsClass = "#".concat(moduleID, " div[class*=lion-reward-item--product], #").concat(moduleID, " .lion-reward-item--checkout-redemption");
            } else if (rewardsType === "rewardIds") {
                rewardsClass = "#".concat(moduleID, " div[class*=lion-reward-item--product], #").concat(moduleID, " .lion-reward-item--checkout-redemption");
            }
            if (rewardsClass) {
                var rewardsEl = Array.from(document.querySelectorAll("".concat(rewardsClass)));
                rewardsEl.forEach(function(el) {
                    el.parentElement.removeChild(el);
                });
            }
            var swiperEl = document.createElement("div");
            swiperEl.className = "swiper-wrapper";
            var rewards = Array.from(document.querySelector("#".concat(moduleID, " .lion-rewards-list")).children).map(function(child) {
                return child;
            });
            rewards.forEach(function(child, index) {
                var ref;
                child.classList.add("lion-reward-item".concat(index + 1));
                var rewardId = child === null || child === void 0 ? void 0 : (ref = child.dataset) === null || ref === void 0 ? void 0 : ref.rewardId;
                if ((disableRewardIds === null || disableRewardIds === void 0 ? void 0 : disableRewardIds.length) && (disableRewardIds === null || disableRewardIds === void 0 ? void 0 : disableRewardIds.includes(rewardId))) {
                    var actionBtn = child.querySelector(".lion-action-button");
                    if (actionBtn) {
                        var newActionBtn = actionBtn.cloneNode();
                        newActionBtn.classList.add("lion-action-button--disabled");
                        newActionBtn.classList.add("lion-action-button--completed");
                        newActionBtn.disabled = true;
                        newActionBtn.innerHTML = '<span class="lion-reward-item__redeem-button-text lion-loyalty-page-reward-item__redeem-button-text">REDEEMED</span>';
                        if (actionBtn.parentElement) {
                            actionBtn.parentElement.appendChild(newActionBtn);
                            actionBtn.parentElement.removeChild(actionBtn);
                        }
                    }
                }
                if (sliderEnable) {
                    child.classList.add("swiper-slide");
                    swiperEl.appendChild(child);
                }
            });
            if (sliderEnable) {
                var ref, ref1;
                setCount(((ref = swiperEl.children) === null || ref === void 0 ? void 0 : ref.length) >= 4);
                setLoop(!!count);
                if ((navRef === null || navRef === void 0 ? void 0 : navRef.current) && (navRef === null || navRef === void 0 ? void 0 : (ref1 = navRef.current) === null || ref1 === void 0 ? void 0 : ref1.parentElement)) {
                    var swiperNavs = Array.from(navRef.current.querySelectorAll("button"));
                    swiperNavs.forEach(function(button) {
                        document.querySelector("#".concat(moduleID, " .lion-rewards-list")).appendChild(button);
                    });
                    navRef.current.parentElement.removeChild(navRef.current);
                }
                document.querySelector("#".concat(moduleID, " .lion-rewards-list")).prepend(swiperEl);
            }
            setInitializing(sliderEnable);
            if (loyaltylionRendered && document.querySelector("#".concat(moduleID, " [data-lion-rewards-list]"))) {
                var ref2, ref3;
                document.querySelector("#".concat(moduleID, " [data-lion-rewards-list]")).classList.remove("hidden");
                var getVariantInventory = function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(function(variantId) {
                        var endpoint, options, response, body;
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    endpoint = "/api/productVariant";
                                    options = {
                                        method: "POST",
                                        headers: {
                                            "Content-Type": "application/json"
                                        },
                                        body: JSON.stringify({
                                            variantId: variantId
                                        })
                                    };
                                    return [
                                        4,
                                        fetch(endpoint, options)
                                    ];
                                case 1:
                                    response = _state.sent();
                                    return [
                                        4,
                                        response.json()
                                    ];
                                case 2:
                                    body = _state.sent();
                                    if (body === null || body === void 0 ? void 0 : body.productVariant) {
                                        return [
                                            2,
                                            body.productVariant
                                        ];
                                    }
                                    return [
                                        2,
                                        {}
                                    ];
                            }
                        });
                    });
                    return function getVariantInventory(variantId) {
                        return _ref.apply(this, arguments);
                    };
                }();
                var setButtonState = function(productRewards) {
                    (productRewards || []).forEach(function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(function(reward) {
                            var ref, ref1, product, rewardId, nonPlatinumRewards, variant, actionBtn, newActionBtn, externalLink;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        product = reward === null || reward === void 0 ? void 0 : (ref = reward.target_products) === null || ref === void 0 ? void 0 : ref[0];
                                        rewardId = reward.id;
                                        nonPlatinumRewards = [];
                                        ((window === null || window === void 0 ? void 0 : (ref1 = window.loyaltylion) === null || ref1 === void 0 ? void 0 : ref1.program.loyaltyTiers) || []).forEach(function(tier) {
                                            if ((tier === null || tier === void 0 ? void 0 : tier.name) === "Platinum") return;
                                            var rewardOverride = ((tier === null || tier === void 0 ? void 0 : tier.rewardOverrides) || []).find(function(rw) {
                                                return (rw === null || rw === void 0 ? void 0 : rw.enabled) && rw.rewardId === rewardId;
                                            });
                                            if (rewardOverride) {
                                                nonPlatinumRewards.push(rewardOverride);
                                            }
                                        });
                                        if (!((product === null || product === void 0 ? void 0 : product.variant_id) || limitRewardReached && !(nonPlatinumRewards === null || nonPlatinumRewards === void 0 ? void 0 : nonPlatinumRewards.length))) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            getVariantInventory(product.variant_id)
                                        ];
                                    case 1:
                                        variant = _state.sent();
                                        if (!(variant === null || variant === void 0 ? void 0 : variant.availableForSale) || limitRewardReached && !(nonPlatinumRewards === null || nonPlatinumRewards === void 0 ? void 0 : nonPlatinumRewards.length)) {
                                            actionBtn = document.querySelector("#".concat(moduleID, ' [data-lion-rewards-list] .lion-reward-item[data-reward-id="').concat(rewardId, '"] .lion-action-button'));
                                            if (actionBtn) {
                                                newActionBtn = actionBtn.cloneNode();
                                                newActionBtn.classList.add("lion-action-button--disabled");
                                                newActionBtn.classList.add("lion-action-button--completed");
                                                newActionBtn.disabled = true;
                                                if (limitRewardReached && !(nonPlatinumRewards === null || nonPlatinumRewards === void 0 ? void 0 : nonPlatinumRewards.length)) {
                                                    newActionBtn.innerHTML = '<span class="lion-reward-item__redeem-button-text lion-loyalty-page-reward-item__redeem-button-text">Max Limit Reached</span>';
                                                } else if (!(variant === null || variant === void 0 ? void 0 : variant.availableForSale)) {
                                                    newActionBtn.innerHTML = '<span class="lion-reward-item__redeem-button-text lion-loyalty-page-reward-item__redeem-button-text">Out of Stock</span>';
                                                }
                                                if (actionBtn.parentElement) {
                                                    actionBtn.parentElement.appendChild(newActionBtn);
                                                    actionBtn.parentElement.removeChild(actionBtn);
                                                }
                                            }
                                        }
                                        externalLink = document.querySelector("#".concat(moduleID, ' [data-lion-rewards-list] .lion-reward-item[data-reward-id="').concat(rewardId, '"] .lion-reward-item__more-info-url--external-link'));
                                        if (externalLink && (externalLink === null || externalLink === void 0 ? void 0 : externalLink.parentElement)) {
                                            externalLink === null || externalLink === void 0 ? void 0 : externalLink.parentElement.removeChild(externalLink);
                                        }
                                        _state.label = 2;
                                    case 2:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(reward) {
                            return _ref.apply(this, arguments);
                        };
                    }());
                };
                var productRewards = ((window === null || window === void 0 ? void 0 : (ref2 = window.loyaltylion) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.program) === null || ref3 === void 0 ? void 0 : ref3.rewards) || []).reduce(function(acc, reward) {
                    if ((reward === null || reward === void 0 ? void 0 : reward.target_type) === "product") {
                        return (0,_to_consumable_array/* default */.Z)(acc).concat([
                            reward
                        ]);
                    }
                    return acc;
                }, []);
                setButtonState(productRewards);
            }
        }
    }, [
        loyaltylionRendered,
        asPath
    ]);
    (0,react.useEffect)(function() {
        if (!swiper && initializing && sliderEnable) {
            var swiperSlide = new core_class/* default */.Z("#".concat(moduleID, " .lion-rewards-list"), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, swiperParams), {
                modules: [
                    navigation/* default */.Z,
                    pagination/* default */.Z,
                    a11y/* default */.Z
                ],
                loop: loop,
                navigation: {
                    nextEl: ".swiper-button-custom-next",
                    prevEl: ".swiper-button-custom-prev"
                }
            }));
            setSwiper(swiperSlide);
        }
    }, [
        initializing
    ]);
    var setStartAndEndOnSwiperChange = (0,react.useCallback)(function() {
        if (!swiper || !sliderEnable) return;
        if (loop) {
            setIsStart(false);
            setIsEnd(false);
        }
        if (!loop) {
            setIsStart(swiper.isBeginning);
            setIsEnd(swiper.isEnd);
            swiper.on("slideChange", function() {
                setIsStart(swiper.isBeginning);
                setIsEnd(swiper.isEnd);
            });
        }
    }, [
        swiper,
        loop
    ]);
    (0,react.useEffect)(function() {
        setStartAndEndOnSwiperChange();
    }, [
        swiper,
        loop
    ]);
    if (!enable) return null;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(snippets/* Section */.$0, {
        id: moduleID,
        "data-comp": LoyaltylionRewardsList.displayName,
        section: section,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)("div", {
                className: "py-10",
                children: [
                    heading && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.heading), {
                            textAlign: textAlign,
                            color: headingColor || "text"
                        }),
                        children: heading
                    }),
                    subHeading && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.paragraph), {
                            textAlign: textAlign,
                            color: headingColor || "text"
                        }),
                        dangerouslySetInnerHTML: {
                            __html: subHeading
                        }
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)("div", {
                        className: "m-auto block",
                        sx: (0,_object_spread/* default */.Z)({}, theme["only".concat(rewardsType)], theme.slides),
                        children: [
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                                "data-lion-rewards-list": true,
                                className: "hidden"
                            }),
                            !!sliderEnable && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)("div", {
                                ref: navRef,
                                className: "hidden",
                                children: [
                                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Navigation_NavigationButton/* NavigationButton */.W, {
                                        className: "swiper-button-custom-prev after:hidden",
                                        inactive: isStart,
                                        count: count,
                                        alt: "Previous product"
                                    }),
                                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Navigation_NavigationButton/* NavigationButton */.W, {
                                        className: "swiper-button-custom-next after:hidden",
                                        src: "/svgs/arrow-right.svg#arrow-right",
                                        alt: "Next product",
                                        inactive: isEnd,
                                        isNext: true,
                                        count: count
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            !!(iconsStyle === null || iconsStyle === void 0 ? void 0 : iconsStyle.length) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("style", {
                children: iconsStyle.join("")
            }),
            !!(rewardShowClasses === null || rewardShowClasses === void 0 ? void 0 : rewardShowClasses.length) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("style", {
                children: rewardShowClasses.join("")
            })
        ]
    });
});
LoyaltylionRewardsList.displayName = "Loyaltylion Rewards List";
LoyaltylionRewardsList.Schema = LoyaltylionRewardsList_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/LoyaltylionRewardsList/index.js


;// CONCATENATED MODULE: ./src/sections/LoyaltylionStaticRewards/LoyaltylionStaticRewards.theme.js


var LoyaltylionStaticRewards_theme_themed = (0,create/* create */.U)(new function() {
    this.heading = {
        variant: "text.h2",
        fontSize: [
            10,
            12
        ],
        mb: [
            8,
            11
        ]
    };
    this.paragraph = {
        fontSize: [
            "13px",
            6
        ],
        lineHeight: [
            "normal",
            "24px"
        ],
        fontWeight: "body",
        mt: [
            -4,
            -7
        ]
    };
    this.bodyWithoutHeading = {
        variant: "text.base",
        fontSize: [
            "13px",
            6
        ],
        lineHeight: [
            "normal",
            "24px"
        ],
        mt: 0,
        py: 10,
        ul: {
            ml: 0
        },
        "p:last-of-type": {
            mb: 0
        }
    };
    this.bodyWithHeading = (0,_object_spread/* default */.Z)({}, this.bodyWithoutHeading);
    this.onlyproductDiscount = {
        ".lion-reward-item--cart-discount-voucher": {
            display: "none!important"
        }
    };
    this.onlycartDiscount = {
        ".lion-reward-item--product-discount-voucher,.lion-reward-item--product-cart": {
            display: "none!important"
        }
    };
    this.slides = {
        ".swiper-slide": {
            opacity: 0.25
        },
        ".swiper-slide-active, .swiper-slide-next, .swiper-slide-prev": {
            opacity: 1
        }
    };
}());

;// CONCATENATED MODULE: ./src/sections/LoyaltylionStaticRewards/LoyaltylionStaticRewards.schema.js




var LoyaltylionStaticRewards_schema_Schema = function() {
    return {
        category: "LoyaltyLion",
        label: "Loyaltylion Static Rewards List",
        key: "loyaltylion-static-rewards-list",
        fields: [
            {
                label: "Enable If",
                name: "state",
                component: "radio-group",
                direction: "horizontal",
                variant: "radio",
                options: [
                    {
                        value: "guest",
                        label: "Signed Out"
                    },
                    {
                        value: "user",
                        label: "Signed In"
                    },
                    {
                        value: "enable",
                        label: "Always"
                    },
                    {
                        value: "userByTag",
                        label: "User By Tag"
                    },
                    {
                        value: "userWithoutTag",
                        label: "User without Tag"
                    }, 
                ],
                defaultValue: "enable"
            },
            {
                label: "User Tag",
                name: "userTag",
                component: "textarea",
                defaultValue: "tier: Platinum",
                description: "Enter values with each value separated by a comma"
            },
            {
                label: "Heading",
                name: "heading",
                component: "text"
            },
            {
                label: "Heading Color",
                name: "headingColor",
                component: "select",
                options: color/* color.options */.$.options,
                defaultValue: "#574F4C"
            },
            {
                label: "SubHeading",
                name: "subHeading",
                component: "text",
                defaultValue: "(You need a paid item in your cart to redeem these)"
            },
            {
                label: "Content alignment (mobile)",
                name: "alignment",
                component: "radio-group",
                direction: "horizontal",
                variant: "radio",
                options: common/* align.options */.AJ.options,
                defaultValue: "center"
            },
            {
                label: "Content alignment (desktop)",
                name: "alignmentDt",
                component: "radio-group",
                direction: "horizontal",
                variant: "radio",
                options: common/* align.options */.AJ.options,
                defaultValue: "center"
            },
            {
                name: "rewardsList",
                label: "Rewards List",
                component: "group-list",
                description: "List rewards",
                fields: [
                    {
                        name: "icon",
                        label: "Icon",
                        component: "image"
                    },
                    {
                        label: "Title",
                        name: "title",
                        component: "text"
                    },
                    {
                        label: "SubTitle",
                        name: "subTitle",
                        component: "text"
                    },
                    {
                        label: "Button Label",
                        name: "buttonText",
                        component: "text"
                    }, 
                ]
            },
            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, common/* section */.qi), {
                defaultValue: {
                    desktop: {
                        container: "container",
                        mt: "none",
                        py: "none"
                    },
                    mobile: {
                        container: "content",
                        mt: "none",
                        py: "none"
                    }
                }
            }), 
        ]
    };
};

;// CONCATENATED MODULE: ./src/sections/LoyaltylionStaticRewards/LoyaltylionStaticRewards.jsx









var LoyaltylionStaticRewards = LoyaltylionStaticRewards_theme_themed(function(param) {
    var theme = param.theme, cms = param.cms;
    var moduleID = "".concat(LoyaltylionStaticRewards_schema_Schema().key, "-").concat(cms.id || cms.cmsId || cms.tinaId);
    var customer = (0,dist.useCustomer)();
    var state = cms.state, userTag = cms.userTag, heading = cms.heading, headingColor = cms.headingColor, subHeading = cms.subHeading, rewardsList = cms.rewardsList, section = cms.section;
    var textAlign = [
        cms === null || cms === void 0 ? void 0 : cms.alignment,
        cms === null || cms === void 0 ? void 0 : cms.alignmentDt
    ];
    var userTags = (0,react.useMemo)(function() {
        var ref;
        if (!userTag || userTag === "") return [];
        return (ref = userTag === null || userTag === void 0 ? void 0 : userTag.split(",")) === null || ref === void 0 ? void 0 : ref.map(function(tag) {
            return tag.trim();
        });
    }, [
        userTag
    ]);
    var enable = (0,react.useMemo)(function() {
        return state === "enable" || state === "guest" && !(customer === null || customer === void 0 ? void 0 : customer.id) || state === "user" && !!(customer === null || customer === void 0 ? void 0 : customer.id) || state === "userByTag" && (customer === null || customer === void 0 ? void 0 : customer.id) && (userTags === null || userTags === void 0 ? void 0 : userTags.length) && (userTags === null || userTags === void 0 ? void 0 : userTags.some(function(tag) {
            var ref;
            return customer === null || customer === void 0 ? void 0 : (ref = customer.tags) === null || ref === void 0 ? void 0 : ref.includes(tag);
        })) || state === "userWithoutTag" && (customer === null || customer === void 0 ? void 0 : customer.id) && (userTags === null || userTags === void 0 ? void 0 : userTags.length) && (userTags === null || userTags === void 0 ? void 0 : userTags.every(function(tag) {
            var ref;
            return !(customer === null || customer === void 0 ? void 0 : (ref = customer.tags) === null || ref === void 0 ? void 0 : ref.includes(tag));
        }));
    }, [
        state,
        customer === null || customer === void 0 ? void 0 : customer.id,
        customer === null || customer === void 0 ? void 0 : customer.tags,
        userTags
    ]);
    if (!enable) return null;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Section */.$0, {
        id: moduleID,
        "data-comp": LoyaltylionStaticRewards.displayName,
        section: section,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)("div", {
            className: "py-10",
            children: [
                heading && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.heading), {
                        textAlign: textAlign,
                        color: headingColor || "text"
                    }),
                    children: heading
                }),
                subHeading && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.paragraph), {
                        textAlign: textAlign,
                        color: headingColor || "text"
                    }),
                    dangerouslySetInnerHTML: {
                        __html: subHeading
                    }
                }),
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                    id: "loyaltylion",
                    className: "m-auto block",
                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                        className: "lion-rewards-list",
                        children: rewardsList === null || rewardsList === void 0 ? void 0 : rewardsList.map(function(reward, index) {
                            var ref, ref1;
                            return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                                className: "lion-reward-item lion-reward-item--product-discount-voucher lion-reward-item--customer lion-reward-item".concat(index + 1),
                                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)("div", {
                                    className: "lion-reward-item__content",
                                    children: [
                                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                                            className: "lion-reward-item__icon lion-icon lion-icon__reward lion-icon__reward--product-discount-voucher before:!bg-none relative z-0",
                                            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                                                className: "lion-reward-item__icon__image absolute w-full h-full p-[1.5rem] flex items-center",
                                                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("img", {
                                                    src: reward === null || reward === void 0 ? void 0 : (ref = reward.icon) === null || ref === void 0 ? void 0 : ref.src,
                                                    alt: reward === null || reward === void 0 ? void 0 : (ref1 = reward.icon) === null || ref1 === void 0 ? void 0 : ref1.alt,
                                                    className: "w-full h-auto"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                                            className: "lion-reward-item__title",
                                            children: reward === null || reward === void 0 ? void 0 : reward.title
                                        }),
                                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                                            className: "lion-reward-item__meta",
                                            children: reward === null || reward === void 0 ? void 0 : reward.subTitle
                                        }),
                                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                                            className: "lion-reward-item__actions",
                                            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                                                className: "lion-action-button lion-action-button--tile lion-action-button--disabled",
                                                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("span", {
                                                    className: "lion-reward-item__redeem-button-text lion-loyalty-page-reward-item__redeem-button-text",
                                                    children: reward === null || reward === void 0 ? void 0 : reward.buttonText
                                                })
                                            })
                                        })
                                    ]
                                })
                            }, index);
                        })
                    })
                })
            ]
        })
    });
});
LoyaltylionStaticRewards.displayName = "Loyaltylion Static Rewards List";
LoyaltylionStaticRewards.Schema = LoyaltylionStaticRewards_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/LoyaltylionStaticRewards/index.js


;// CONCATENATED MODULE: ./src/sections/VideoWise/VideoWise.schema.js



var VideoWise_schema_fields = common/* section.fields.filter */.qi.fields.filter(function(field) {
    return (field === null || field === void 0 ? void 0 : field.name) !== "color";
});
function VideoWise_schema_Schema() {
    return {
        category: "Embed",
        label: "VideoWise",
        key: "videoWise",
        fields: [
            {
                label: "Embed Content",
                name: "embedContent",
                component: "html"
            },
            {
                label: "VideoWise Tile Style",
                name: "style",
                component: "select",
                options: [
                    {
                        label: "Default",
                        value: "default"
                    },
                    {
                        label: "Custom",
                        value: "custom"
                    }, 
                ]
            },
            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, common/* section */.qi), {
                fields: VideoWise_schema_fields
            }), 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/VideoWise/VideoWise.theme.js

var VideoWise_theme_themed = (0,create/* create */.U)(new function() {}());

;// CONCATENATED MODULE: ./src/sections/VideoWise/VideoWise.jsx











var VideoWise = (0,src_utils/* withInView */.Dh)(VideoWise_theme_themed(function(param) {
    var cms = param.cms, theme = param.theme;
    var embedContent = cms.embedContent, section = cms.section, _style = cms.style, style = _style === void 0 ? "default" : _style;
    var moduleID = "".concat(VideoWise_schema_Schema().key, "-").concat(cms.id || cms.cmsId || cms.tinaId);
    var ref = (0,react.useState)(false), loaded = ref[0], setLoaded = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* default.videoWiseLoaded */.ZP.videoWiseLoaded), 2), videoWiseLoaded = ref1[0], setVideoWiseLoaded = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* default.videoWiseConfig */.ZP.videoWiseConfig), 2), videoWiseConfig = ref2[0], setVideoWiseConfig = ref2[1];
    var asPath = (0,next_router.useRouter)().asPath;
    (0,react.useEffect)(function() {
        var style = document.getElementById("videowise-client-style");
        style && style.parentNode.removeChild(style);
        var t = document.getElementById("videowise-vendors-js");
        t && t.parentNode.removeChild(t);
        var s = document.getElementById("videowise-client-js");
        s && s.parentNode.removeChild(s);
        setLoaded(true);
        return function() {
            setLoaded(false);
        };
    }, []);
    (0,react.useEffect)(function() {
        if ( true && videoWiseConfig && loaded) {
            var style = window.document.createElement("link");
            style.href = "https://assets.videowise.com/style.css.gz";
            style.rel = "stylesheet";
            style.id = "videowise-client-style";
            style.setAttribute("as", "style");
            style.setAttribute("onload", "this.onload=null;this.rel='stylesheet'");
            style.onload = null;
            document.head.appendChild(style);
            var js = window.document.createElement("script");
            js.src = "https://assets.videowise.com/vendors.js.gz";
            js.type = "text/javascript";
            js.fetchPriority = "high";
            js.id = "videowise-vendors-js";
            document.head.appendChild(js);
            js = window.document.createElement("script");
            js.src = "https://assets.videowise.com/client.js.gz";
            js.type = "text/javascript";
            js.fetchPriority = "high";
            js.id = "videowise-client-js";
            document.head.appendChild(js);
            setVideoWiseLoaded(true);
        }
        return function() {
            setVideoWiseLoaded(false);
            var t = document.getElementById("videowise-vendors-js");
            t && t.parentNode.removeChild(t);
            var s = document.getElementById("videowise-client-js");
            s && s.parentNode.removeChild(s);
        };
    }, [
        asPath,
        videoWiseConfig,
        loaded
    ]);
    return embedContent && videoWiseLoaded ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Section */.$0, {
        section: section,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
            sx: (0,_object_spread/* default */.Z)({}, theme.html),
            id: moduleID,
            className: "embedContent videowise-".concat(style, "-styles"),
            dangerouslySetInnerHTML: {
                __html: embedContent
            }
        })
    }) : null;
}), {
    triggerOnce: true
});
VideoWise.displayName = "VideoWise";
VideoWise.Schema = VideoWise_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/VideoWise/index.js


;// CONCATENATED MODULE: ./src/sections/ShopByCategory/ShopByCategory.theme.js

var ShopByCategory_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        overflow: "hidden"
    };
    this.header = {};
}());

;// CONCATENATED MODULE: ./src/sections/ShopByCategory/ShopByCategory.schema.js



var media = function() {
    return {
        label: "Media Settings",
        name: "media",
        description: "Media settings(image, mp4, gif)",
        component: "group",
        fields: [
            {
                name: "alt",
                component: "text",
                label: "Media Alt",
                description: "Provide a brief description of the image for accessibility compliance"
            },
            {
                name: "image",
                label: "Image",
                component: "image"
            },
            {
                name: "video",
                label: "Video URL",
                component: "text",
                description: "Direct video links usually end in or contain '.mp4'"
            },
            {
                name: "imageHover",
                label: "Media Hover",
                component: "image"
            },
            {
                name: "videoHover",
                label: "Video Hover URL",
                component: "text",
                description: "Direct video links usually end in or contain '.mp4'"
            }, 
        ],
        defaultValue: {
            alt: "Shop By Category Image",
            image: {
                src: "https://cdn.shopify.com/s/files/1/0807/0011/3185/files/2024_05_29_Brumate_Q3_Backyard_1024_201.jpg?v=1726502488"
            },
            imageHover: {
                src: "https://cdn.shopify.com/s/files/1/0807/0011/3185/files/2024_05_29_Brumate_Q3_Backyard_1024_201.jpg?v=1726502488"
            },
            video: "",
            videoHover: ""
        }
    };
};
var ShopByCategory_schema_content = function() {
    return {
        label: "Content Settings",
        name: "content",
        description: "Heading, Description, CTA",
        component: "group",
        fields: [
            {
                name: "heading",
                component: "text",
                label: "Heading (desktop)"
            },
            {
                name: "headingMobile",
                component: "text",
                label: "Heading (mobile)"
            },
            {
                name: "description",
                component: "text",
                label: "Description (desktop)"
            },
            {
                name: "descriptionMobile",
                component: "text",
                label: "Description (mobile)"
            },
            {
                name: "alignment",
                label: "Content alignment (desktop)",
                component: "radio-group",
                direction: "horizontal",
                variant: "radio",
                options: [
                    {
                        label: "Left",
                        value: "left"
                    },
                    {
                        label: "Center",
                        value: "center"
                    }, 
                ]
            },
            {
                name: "alignmentMobile",
                label: "Content alignment (mobile)",
                component: "radio-group",
                direction: "horizontal",
                variant: "radio",
                options: [
                    {
                        label: "Left",
                        value: "left"
                    },
                    {
                        label: "Center",
                        value: "center"
                    }, 
                ]
            },
            {
                label: "Link (desktop)",
                name: "cta",
                component: "link"
            },
            {
                name: "style",
                label: "Link style (desktop)",
                component: "select",
                options: common/* button.options */.LI.options
            }, 
        ],
        defaultValue: {
            heading: "Gear Up For Summer",
            headingMobile: "Gear Up For Summer",
            description: "We got all the leakproof essentials.",
            descriptionMobile: "We got all the leakproof essentials.",
            alignment: "left",
            alignmentMobile: "left",
            cta: {
                text: "Shop",
                url: "/collections/all"
            },
            style: common/* button.value.primary */.LI.value.primary
        }
    };
};
var defaultTile = function() {
    return {
        media: {
            alt: "Shop By Category Image",
            image: {
                src: "https://cdn.shopify.com/s/files/1/0807/0011/3185/files/2024_05_29_Brumate_Q3_Backyard_1024_201.jpg?v=1726502488"
            },
            imageHover: {
                src: "https://cdn.shopify.com/s/files/1/0807/0011/3185/files/2024_05_29_Brumate_Q3_Backyard_1024_201.jpg?v=1726502488"
            },
            video: "",
            videoHover: ""
        },
        content: {
            heading: "Gear Up For Summer",
            headingMobile: "Gear Up For Summer",
            description: "We got all the leakproof essentials.",
            descriptionMobile: "We got all the leakproof essentials.",
            alignment: "left",
            alignmentMobile: "left",
            cta: {
                text: "Shop",
                url: "/collections/all"
            },
            style: common/* button.value.primary */.LI.value.primary
        }
    };
};
function ShopByCategory_schema_Schema(param) {
    var article = param.article, blog = param.blog, collection = param.collection;
    if (article || blog || collection) return null;
    return {
        label: "Shop By Category",
        key: "shop-by-category",
        fields: [
            {
                label: "Content Settings",
                name: "content",
                description: "Heading, text align",
                component: "group",
                fields: [
                    {
                        name: "heading",
                        label: "Heading",
                        component: "text"
                    },
                    {
                        name: "textAlign",
                        label: "Heading alignment",
                        component: "radio-group",
                        direction: "horizontal",
                        variant: "radio",
                        options: [
                            {
                                label: "Left",
                                value: "left"
                            },
                            {
                                label: "Center",
                                value: "center"
                            }, 
                        ]
                    }, 
                ],
                defaultValue: {
                    heading: "Shop By Category",
                    textAlign: common/* align.value.left */.AJ.value.left
                }
            },
            {
                name: "tiles",
                label: "Tiles",
                description: "Max of 12 tiles",
                component: "group-list",
                itemProps: {
                    label: "{{item.content.heading}}"
                },
                defaultItem: defaultTile(),
                validate: {
                    maxItems: 12
                },
                fields: [
                    media(),
                    ShopByCategory_schema_content()
                ],
                defaultValue: [
                    defaultTile()
                ]
            },
            {
                label: "Media Settings",
                name: "media",
                description: "Aspect ratio",
                component: "group",
                fields: [
                    {
                        label: "Aspect ratio (desktop)",
                        name: "ratioDt",
                        component: "radio-group",
                        description: "Only applies to images and video files not already set to 1:1 ratio",
                        direction: "horizontal",
                        variant: "radio",
                        options: [
                            {
                                value: "1",
                                label: "1:1"
                            },
                            {
                                value: "0.75",
                                label: "3:4"
                            }, 
                        ]
                    },
                    {
                        label: "Aspect ratio (mobile)",
                        component: "radio-group",
                        description: "Only applies to images and video files not already set to 1:1 ratio",
                        direction: "horizontal",
                        variant: "radio",
                        name: "ratio",
                        options: [
                            {
                                value: "1",
                                label: "1:1"
                            },
                            {
                                value: "0.75",
                                label: "3:4"
                            }, 
                        ]
                    },
                    {
                        label: "Enable Contained",
                        name: "enableContained",
                        description: "Show Content on top of media",
                        component: "toggle",
                        toggleLabels: {
                            true: "On",
                            false: "Off"
                        }
                    }, 
                ],
                defaultValue: {
                    ratio: "0.75",
                    ratioDt: "0.75",
                    enableContained: false
                }
            },
            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, common/* section */.qi), {
                defaultValue: {
                    bgColor: common/* color.value.background */.$_.value.background,
                    color: common/* color.value.text */.$_.value.text,
                    desktop: {
                        container: "content",
                        mt: "none",
                        py: "xs"
                    },
                    mobile: {
                        container: "container",
                        mt: "none",
                        py: "xs"
                    }
                }
            }), 
        ]
    };
}

// EXTERNAL MODULE: ./src/theme/theme.text.js
var theme_text = __webpack_require__(10408);
;// CONCATENATED MODULE: ./src/sections/ShopByCategory/Header/Header.theme.js


var ShopByCategory_Header_Header_theme_themed = (0,create/* create */.U)(new function() {
    this.header = {
        display: "flex",
        width: "100%",
        flexDirection: [
            "column",
            null,
            null,
            "row"
        ],
        marginBottom: 14,
        "@media only screen and (max-width: 767px)": {
            marginBottom: 0
        }
    };
    this.heading = {
        width: "100%",
        variant: "text.h2",
        mb: [
            10,
            null,
            null,
            0
        ],
        flex: 1,
        px: 0,
        fontSize: "40px",
        "@media only screen and (max-width: 767px)": {
            fontSize: "28px",
            px: 8
        }
    };
}());

;// CONCATENATED MODULE: ./src/sections/ShopByCategory/Header/Header.jsx






var ShopByCategory_Header_Header_Header = ShopByCategory_Header_Header_theme_themed(function(param) {
    var theme = param.theme, _content = param.content, content = _content === void 0 ? {} : _content;
    var textAlign = content.textAlign, textAlignMobile = content.textAlignMobile;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Container */.W2, {
        "data-comp": ShopByCategory_Header_Header_Header.displayName,
        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.header), {
            justifyContent: [
                (0,src_utils/* convertAlignToFlex */.nG)(textAlignMobile),
                null,
                null,
                (0,src_utils/* convertAlignToFlex */.nG)(textAlign), 
            ],
            alignItems: [
                (0,src_utils/* convertAlignToFlex */.nG)(textAlignMobile),
                null,
                null,
                (0,src_utils/* convertAlignToFlex */.nG)(textAlign), 
            ]
        }),
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
            variant: "h2",
            sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.heading), {
                textAlign: textAlign
            }),
            children: content === null || content === void 0 ? void 0 : content.heading
        })
    });
});
ShopByCategory_Header_Header_Header.displayName = "Header";

;// CONCATENATED MODULE: ./src/sections/ShopByCategory/Header/index.js


;// CONCATENATED MODULE: ./src/sections/ShopByCategory/Slider/Slider.theme.js

var ShopByCategory_Slider_Slider_theme_themed = (0,create/* create */.U)(new function() {
    this.swiper = {
        ".swiper-container": {
            cursor: [
                "grab",
                "auto"
            ],
            pl: [
                "16px",
                "unset"
            ],
            overflow: "visible"
        },
        ".swiper-container, .swiper-wrapper": {
            height: "auto !important",
            width: "100%"
        },
        ".swiper-slide": {
            opacity: 0.35
        },
        ".swiper-slide-visible": {
            opacity: 1
        },
        ".swiper-button-prev": {
            left: "auto",
            right: "56px",
            top: "-50px",
            color: "black",
            width: "36px",
            height: "36px",
            "@media only screen and (max-width: 767px)": {
                display: "none"
            }
        },
        ".swiper-button-prev:after": {
            fontSize: "30px"
        },
        ".swiper-button-next": {
            left: "auto",
            right: 0,
            top: "-50px",
            color: "black",
            width: "36px",
            height: "36px",
            "@media only screen and (max-width: 767px)": {
                display: "none"
            }
        },
        ".swiper-button-next:after": {
            fontSize: "30px"
        }
    };
}());

;// CONCATENATED MODULE: ./src/sections/ShopByCategory/Slider/useSliderParams.js

var ShopByCategory_Slider_useSliderParams_useSliderParams = function() {
    var defaultParams = (0,react.useMemo)(function() {
        return {
            spaceBetween: 16,
            slidesPerView: 1.5,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 16,
            slidesPerGroup: 1,
            autoHeight: false,
            navigation: true,
            loop: false,
            watchOverflow: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            breakpoints: {
                768: {
                    spaceBetween: 20,
                    slidesPerView: 2,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0,
                    slidesPerGroup: 1
                },
                1024: {
                    spaceBetween: 20,
                    slidesPerView: 3,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0,
                    slidesPerGroup: 1
                },
                1280: {
                    spaceBetween: 20,
                    slidesPerView: 4,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0,
                    slidesPerGroup: 1
                }
            }
        };
    }, []);
    return defaultParams;
};

;// CONCATENATED MODULE: ./src/sections/ShopByCategory/Tile/Tile.theme.js



var ShopByCategory_Tile_Tile_theme_themed = (0,create/* create */.U)(new function() {
    this.image = {
        position: "relative"
    };
    this.imageLink = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this.image), {
        ":hover": {
            img: {
                pointerEvents: "none",
                transform: "scale3d(1.03, 1.03, 1.03)"
            }
        },
        img: {
            transform: "scale3d(1.01, 1.01, 1.01)",
            transition: "transform 0.3s ease-in-out"
        }
    });
    this.overlay = {
        width: "100%",
        paddingTop: "12px",
        pointerEvents: "auto",
        display: "block",
        "@media only screen and (max-width: 767px)": {
            display: "none"
        }
    };
    this.overlayMobile = {
        width: "100%",
        paddingTop: "12px",
        pointerEvents: "auto",
        display: "none",
        "@media only screen and (max-width: 767px)": {
            display: "block"
        }
    };
    this.overlayContained = {
        position: "absolute",
        width: "fit-content",
        padding: "24px",
        pointerEvents: "auto",
        bottom: "0",
        display: "block",
        "@media only screen and (max-width: 767px)": {
            display: "none"
        }
    };
    this.overlayContainedMobile = {
        position: "absolute",
        width: "fit-content",
        padding: "24px",
        pointerEvents: "auto",
        bottom: "0",
        display: "none",
        "@media only screen and (max-width: 767px)": {
            display: "block"
        }
    };
    this.heading = {
        color: "black",
        fontSize: "21px",
        fontStyle: "normal",
        fontWeight: "400",
        lineHeight: "normal",
        letterSpacing: "-0.63px",
        mb: "6px",
        "@media only screen and (max-width: 767px)": {
            fontSize: "16px"
        }
    };
    this.description = {
        color: "black",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: "400",
        lineHeight: "normal",
        letterSpacing: "-0.32px",
        mb: "20px",
        "@media only screen and (max-width: 767px)": {
            fontSize: "13px",
            mb: "16px"
        }
    };
    this.button = {
        display: "inline-block",
        minWidth: "fit-content"
    };
}());

;// CONCATENATED MODULE: ./src/sections/ShopByCategory/Tile/Tile.jsx








var ShopByCategory_Tile_Tile_Tile = ShopByCategory_Tile_Tile_theme_themed(function(_param) {
    var theme = _param.theme, item = _param.item, settings = _param.settings, inputRef = _param.inputRef, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme",
        "item",
        "settings",
        "inputRef"
    ]);
    var ratio = settings.ratio, ratioDt = settings.ratioDt, enableContained = settings.enableContained;
    var media = item.media, content = item.content;
    var image = media.image, video = media.video, alt = media.alt, imageHover = media.imageHover, videoHover = media.videoHover;
    var heading = content.heading, headingMobile = content.headingMobile, description = content.description, descriptionMobile = content.descriptionMobile, alignment = content.alignment, alignmentMobile = content.alignmentMobile, cta = content.cta, style = content.style;
    var disableHoverMobile = (0,hooks/* useBreakpointValue */.Sx)([
        true,
        true,
        false
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-comp": ShopByCategory_Tile_Tile_Tile.displayName
    }, props), {
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(snippets/* Link */.rU, {
            href: cta === null || cta === void 0 ? void 0 : cta.url,
            newTab: cta === null || cta === void 0 ? void 0 : cta.newTab,
            sx: (cta === null || cta === void 0 ? void 0 : cta.url) ? theme.imageLink : theme.image,
            children: [
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Picture */.t, {
                    alt: alt,
                    images: [
                        {
                            src: image === null || image === void 0 ? void 0 : image.src,
                            width: 768,
                            ratio: parseFloat(ratio)
                        },
                        {
                            src: image === null || image === void 0 ? void 0 : image.src,
                            width: 700,
                            ratio: parseFloat(ratioDt)
                        }, 
                    ],
                    hoverImages: [
                        {
                            src: imageHover === null || imageHover === void 0 ? void 0 : imageHover.src,
                            width: 768,
                            ratio: parseFloat(ratio)
                        },
                        {
                            src: imageHover === null || imageHover === void 0 ? void 0 : imageHover.src,
                            width: 700,
                            ratio: parseFloat(ratioDt)
                        }, 
                    ],
                    video: video,
                    videoHover: videoHover,
                    videoRatio: parseFloat(ratio),
                    videoRatioDt: parseFloat(ratioDt),
                    disableHoverMobile: disableHoverMobile,
                    width: image === null || image === void 0 ? void 0 : image.width,
                    height: image === null || image === void 0 ? void 0 : image.height
                }),
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                    sx: enableContained ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.overlayContained), {
                        textAlign: alignment
                    }) : (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.overlay), {
                        textAlign: alignment
                    }),
                    children: [
                        heading && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                            sx: theme.heading,
                            children: heading
                        }),
                        description && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                            sx: theme.description,
                            children: description
                        }),
                        (cta === null || cta === void 0 ? void 0 : cta.text) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                            variant: "buttons.".concat(style || "primary"),
                            sx: theme.button,
                            children: cta === null || cta === void 0 ? void 0 : cta.text
                        })
                    ]
                }),
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                    sx: enableContained ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.overlayContainedMobile), {
                        textAlign: alignmentMobile
                    }) : (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.overlayMobile), {
                        textAlign: alignmentMobile
                    }),
                    children: [
                        headingMobile && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                            sx: theme.heading,
                            children: headingMobile
                        }),
                        descriptionMobile && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                            sx: theme.description,
                            children: descriptionMobile
                        }),
                        (cta === null || cta === void 0 ? void 0 : cta.text) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                            variant: "buttons.".concat(style || "primary"),
                            sx: theme.button,
                            children: cta === null || cta === void 0 ? void 0 : cta.text
                        })
                    ]
                })
            ]
        })
    }));
});
ShopByCategory_Tile_Tile_Tile.displayName = "Tile";

;// CONCATENATED MODULE: ./src/sections/ShopByCategory/Tile/index.js


;// CONCATENATED MODULE: ./src/sections/ShopByCategory/Slider/Slider.jsx









var ShopByCategory_Slider_Slider_Slider = ShopByCategory_Slider_Slider_theme_themed(function(param) {
    var theme = param.theme, tiles = param.tiles, settings = param.settings;
    var ref = (0,react.useState)(), swiper = ref[0], setSwiper = ref[1];
    var defaultParams = ShopByCategory_Slider_useSliderParams_useSliderParams();
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Container */.W2, {
        "data-comp": ShopByCategory_Slider_Slider_Slider.displayName,
        sx: theme.swiper,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(react_swiper/* Swiper */.t, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            onSwiper: setSwiper
        }, defaultParams), {
            children: tiles === null || tiles === void 0 ? void 0 : tiles.slice(0, 12).map(function(item, index) {
                return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(swiper_slide/* SwiperSlide */.o, {
                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(ShopByCategory_Tile_Tile_Tile, {
                        item: item,
                        settings: settings
                    })
                }, index);
            })
        }))
    });
});
ShopByCategory_Slider_Slider_Slider.displayName = "Slider";

;// CONCATENATED MODULE: ./src/sections/ShopByCategory/Slider/index.js


;// CONCATENATED MODULE: ./src/sections/ShopByCategory/ShopByCategory.jsx








var ShopByCategory = (0,src_utils/* withInView */.Dh)(ShopByCategory_theme_themed(function(param) {
    var theme = param.theme, cms = param.cms;
    var content = cms.content, section = cms.section, tiles = cms.tiles, media = cms.media;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Section */.$0, {
        section: section,
        sx: theme.wrapper,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Container */.W2, {
            "data-comp": ShopByCategory.displayName,
            children: [
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                    sx: theme.header,
                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(ShopByCategory_Header_Header_Header, {
                        content: content
                    })
                }),
                (tiles === null || tiles === void 0 ? void 0 : tiles.length) > 0 && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(ShopByCategory_Slider_Slider_Slider, {
                    tiles: tiles,
                    settings: media
                })
            ]
        })
    });
}), {
    triggerOnce: true
});
ShopByCategory.displayName = "Shop By Category";
ShopByCategory.Schema = ShopByCategory_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/ShopByCategory/index.js


;// CONCATENATED MODULE: ./src/sections/QuizSection/QuizContext.jsx

var QuizContext = /*#__PURE__*/ (0,react.createContext)({
    quizSettings: {},
    quizData: {},
    theme: {},
    updateQuizData: function() {},
    getResultsProducts: function() {}
});
function useQuizContext() {
    return (0,react.useContext)(QuizContext);
}

;// CONCATENATED MODULE: ./src/sections/QuizSection/QuizOption.jsx







function QuizOption(param) {
    var theme = param.theme, index = param.index, optionData = param.optionData, isMultipleChoice = param.isMultipleChoice, optionType = param.optionType, optionAlignmentMobile = param.optionAlignmentMobile, isFilter = param.isFilter, currentAnswers = param.currentAnswers;
    var ref, ref1, ref2, ref3, ref4;
    var context = useQuizContext();
    var quizData = context.quizData, updateQuizData = context.updateQuizData;
    var checkbox = (0,react.useRef)();
    var defaultChecked = false;
    var onOptionChange = function(evt) {
        if (evt.target.type !== "checkbox") return;
        var allInputs = evt.target.closest(".quiz-steps__options-container").querySelectorAll("input:checked");
        if ([
            "",
            "everything"
        ].includes(evt.target.value.toLowerCase())) {
            if (allInputs === null || allInputs === void 0 ? void 0 : allInputs.length) {
                var otherInput = (0,_to_consumable_array/* default */.Z)(allInputs).filter(function(input) {
                    return input !== evt.target;
                });
                otherInput.forEach(function(input) {
                    input.checked = false;
                });
            }
        } else {
            var otherInput1 = (0,_to_consumable_array/* default */.Z)(allInputs).filter(function(input) {
                return [
                    "",
                    "everything"
                ].includes(input.value.toLowerCase());
            });
            if (allInputs.length) {
                otherInput1.forEach(function(input) {
                    input.checked = false;
                });
            }
        }
    };
    var removeError = function() {
        updateQuizData({
            hasError: false
        });
    };
    if (Array.isArray(currentAnswers === null || currentAnswers === void 0 ? void 0 : currentAnswers.answer)) {
        var ref5, ref6;
        defaultChecked = (currentAnswers === null || currentAnswers === void 0 ? void 0 : (ref5 = currentAnswers.answer) === null || ref5 === void 0 ? void 0 : ref5.includes(String(index))) || (currentAnswers === null || currentAnswers === void 0 ? void 0 : (ref6 = currentAnswers.answer) === null || ref6 === void 0 ? void 0 : ref6.includes(optionData.value));
    } else {
        defaultChecked = (currentAnswers === null || currentAnswers === void 0 ? void 0 : currentAnswers.answer) == index;
    }
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)("div", {
        className: "quiz__option relative md:inline-block md:align-middle md:m-2 ".concat(optionType === "with-image" ? "sm:w-[198px] !m-0" : ""),
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("input", {
                ref: checkbox,
                type: isMultipleChoice ? "checkbox" : "radio",
                name: "question-".concat(quizData.currentQuestion),
                onChange: function(evt) {
                    onOptionChange(evt);
                    removeError();
                },
                value: isFilter ? optionData.value : index,
                id: (0,utils_common/* handleize */.v8)(optionData.label),
                className: "peer cursor-pointer appearance-none sr-only !absolute !top-0 !left-0 !w-full !h-full !border-none !bg-transparent after:!hidden before:!hidden"
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)("label", {
                htmlFor: (0,utils_common/* handleize */.v8)(optionData.label),
                className: "".concat(optionAlignmentMobile, " flex items-center md:text-center h-full cursor-pointer overflow-hidden border border-[#C6C6C7] peer-checked:border-black\n          ").concat(optionType !== "with-icon" ? "" : "px-4", "\n          ").concat(optionType === "with-image" ? "items-center justify-center !text-center flex-col rounded-xl" : "gap-2 rounded-3xl", "\n        "),
                children: [
                    optionType !== "default" && optionData.image && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                        className: "quiz__option-image ".concat(optionType === "with-image" ? "w-full border-b border-b-[#C6C6C7]" : "", " ").concat(optionType === "with-image" && ((ref = checkbox.current) === null || ref === void 0 ? void 0 : ref.checked) ? "border-b-black" : ""),
                        children: optionType !== "with-icon" ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Picture */.t, {
                            alt: (ref1 = optionData.image) === null || ref1 === void 0 ? void 0 : ref1.alt,
                            sx: theme.optionImage,
                            images: [
                                {
                                    src: (ref2 = optionData.image) === null || ref2 === void 0 ? void 0 : ref2.src,
                                    width: 200
                                }, 
                            ]
                        }) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Picture */.t, {
                            alt: (ref3 = optionData.image) === null || ref3 === void 0 ? void 0 : ref3.alt,
                            width: 20,
                            height: 20,
                            sx: {
                                width: "20px",
                                height: "20px"
                            },
                            images: [
                                {
                                    src: (ref4 = optionData.image) === null || ref4 === void 0 ? void 0 : ref4.src,
                                    width: 768,
                                    ratio: 1
                                }, 
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("span", {
                        className: "".concat(optionType === "with-image" ? "flex items-center justify-center h-full py-2 !px-[11px]" : "block py-1.5", " ").concat(optionType !== "with-icon" ? "px-4" : ""),
                        children: optionData.label
                    })
                ]
            })
        ]
    }, "option-".concat(index));
}

;// CONCATENATED MODULE: ./src/sections/QuizSection/QuizQuestions.jsx








function QuizQuestions() {
    var ref, ref1;
    var context = useQuizContext();
    var ref2 = (0,hooks/* useBodyScrollLock */.yn)(), lockScroll = ref2.lockScroll, unlockScroll = ref2.unlockScroll;
    var quizData = context.quizData, quizSettings = context.quizSettings, updateQuizData = context.updateQuizData, theme = context.theme;
    var ref3 = (0,react.useState)([]), currentAnswers = ref3[0], setCurrentAnswers = ref3[1];
    var ref4 = (0,react.useState)(false), helpTextOpen = ref4[0], setHelpTextOpen = ref4[1];
    var stickyFooter = (0,react.useRef)();
    var quizStepsContainer = (0,react.useRef)();
    var isFollowUpQuestion = String(quizData.currentQuestion).indexOf(".") > -1;
    var parentQuestion = quizSettings.questions.find(function(question) {
        return question.index == [
            parseInt(quizData.currentQuestion)
        ];
    });
    var currentQuestionArrayIndex = quizData.filteredQuestions.findIndex(function(question) {
        return question.index === parseInt(quizData.currentQuestion);
    });
    var getCurrentQuestionData = function() {
        if (!isFollowUpQuestion) {
            var ref;
            var currentQuestion = quizData.filteredQuestions.length > 0 ? (ref = quizData.filteredQuestions) === null || ref === void 0 ? void 0 : ref.find(function(question) {
                return question.index === quizData.currentQuestion;
            }) : quizSettings.questions.find(function(question) {
                return question.index === quizData.currentQuestion;
            });
            return currentQuestion || {};
        }
        var followUpOption = parentQuestion.options[quizData.currentQuestion.split(".")[1]];
        return {
            isMultipleChoice: followUpOption.isMultipleChoice,
            showOptionsImages: followUpOption.showOptionsImages,
            options: followUpOption.followUpOptions,
            message1: followUpOption.followUpMessage1,
            message2: followUpOption.followUpMessage2,
            isFollowUpQuestion: true
        };
    };
    var questionData = getCurrentQuestionData();
    var isMultipleChoice = questionData.isMultipleChoice, _optionType = questionData.optionType, optionType = _optionType === void 0 ? parentQuestion === null || parentQuestion === void 0 ? void 0 : parentQuestion.optionType : _optionType, optionAlignmentMobile = questionData.optionAlignmentMobile;
    var getListMessages = function() {
        var messages = [];
        if (questionData === null || questionData === void 0 ? void 0 : questionData.message1) {
            messages.push(questionData.message1);
        }
        if (questionData === null || questionData === void 0 ? void 0 : questionData.message2) {
            messages.push(questionData.message2);
        }
        return messages;
    };
    var navigateToNextQuestion = function() {
        var ref;
        var answersData = getCurrentAnswers();
        var newAnswers = (0,_to_consumable_array/* default */.Z)(quizData.answers);
        var hasFollowUpQuestion = false;
        if (!isMultipleChoice) {
            var ref1, ref2, ref3, ref4, ref5;
            hasFollowUpQuestion = ((ref1 = questionData === null || questionData === void 0 ? void 0 : questionData.options[answersData]) === null || ref1 === void 0 ? void 0 : ref1.hasFollowUpQuestion) && (!!((ref2 = questionData === null || questionData === void 0 ? void 0 : questionData.options[answersData]) === null || ref2 === void 0 ? void 0 : ref2.followUpMessage1) || !!((ref3 = questionData === null || questionData === void 0 ? void 0 : questionData.options[answersData]) === null || ref3 === void 0 ? void 0 : ref3.followUpMessage2)) && ((ref4 = questionData === null || questionData === void 0 ? void 0 : questionData.options[answersData]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.followUpOptions) === null || ref5 === void 0 ? void 0 : ref5.length) > 0;
        }
        newAnswers[parseInt(currentQuestionArrayIndex)] = {
            questionIndex: parseInt(quizData.currentQuestion),
            answer: questionData.isFollowUpQuestion ? "".concat(quizData.answers[parseInt(currentQuestionArrayIndex)].answer, "---").concat(answersData) : answersData
        };
        // Handles filter question
        if (questionData.isFilterQuestion && (answersData === null || answersData === void 0 ? void 0 : answersData.length) > 0) {
            var ref6, ref7, ref8, ref9;
            var nextQuestion = quizSettings.questions.find(function(question) {
                return answersData.includes(question.category);
            });
            if (nextQuestion) {
                updateQuizData({
                    filter: answersData,
                    currentQuestion: nextQuestion.index,
                    answers: newAnswers,
                    hasError: false
                });
                return;
            }
            // If no next question but has products available, go to results / mailgate
            var filteredQuestions = (ref6 = quizData.filteredQuestions) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[0]) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.options) === null || ref8 === void 0 ? void 0 : ref8.filter(function(option) {
                return option.value === answersData;
            });
            if ((ref9 = quizSettings.mailGate) === null || ref9 === void 0 ? void 0 : ref9.enableMailGate) {
                updateQuizData({
                    quizStep: "mailGate",
                    answers: [],
                    filter: answersData,
                    hasError: false
                });
            } else {
                updateQuizData({
                    quizStep: "results",
                    answers: [],
                    filter: answersData,
                    hasError: false
                });
            }
            return;
        }
        if (!answersData || !answersData.length) {
            updateQuizData({
                hasError: true
            });
            return;
        }
        if (hasFollowUpQuestion || Number.parseInt(quizData.currentQuestion) !== quizData.filteredQuestions[quizData.filteredQuestions.length - 1].index) {
            var currentQuestionArrayIndex1 = quizData.filteredQuestions.findIndex(function(question) {
                return question.index === parseInt(quizData.currentQuestion);
            });
            updateQuizData({
                currentQuestion: hasFollowUpQuestion ? "".concat(quizData.currentQuestion, ".").concat(answersData) : quizData.filteredQuestions[currentQuestionArrayIndex1 + 1].index,
                answers: newAnswers,
                hasError: false
            });
        } else if ((ref = quizSettings.mailGate) === null || ref === void 0 ? void 0 : ref.enableMailGate) {
            updateQuizData({
                quizStep: "mailGate",
                answers: newAnswers,
                hasError: false
            });
        } else {
            updateQuizData({
                quizStep: "results",
                answers: newAnswers,
                hasError: false
            });
        }
    };
    var navigateToPreviousQuestion = function() {
        var currentQuestionArrayIndex = quizData.filteredQuestions.findIndex(function(question) {
            return question.index === parseInt(quizData.currentQuestion);
        });
        updateQuizData({
            currentQuestion: isFollowUpQuestion ? parseInt(quizData.currentQuestion) : quizData.filteredQuestions[currentQuestionArrayIndex - 1].index,
            hasError: false
        });
    };
    var getCurrentAnswers = function() {
        var method = isMultipleChoice ? "querySelectorAll" : "querySelector";
        var answers = document[method](".quiz-steps__options-container input:checked");
        var forceEverything = false;
        if (!answers || answers.length === 0) {
            return null;
        }
        if (questionData.isFilterQuestion && answers.value === "") {
            forceEverything = true;
        }
        answers = answers.value;
        return forceEverything ? [
            "everything"
        ] : answers;
    };
    var toggleInfoModal = function() {
        setHelpTextOpen(!helpTextOpen);
        if (helpTextOpen) {
            unlockScroll(true);
        } else {
            lockScroll(true);
        }
    };
    (0,react.useEffect)(function() {
        var currentQuestionAnswers = quizData.answers.find(function(answer) {
            return (answer === null || answer === void 0 ? void 0 : answer.questionIndex) == parseInt(quizData.currentQuestion);
        });
        setCurrentAnswers(currentQuestionAnswers);
    }, [
        quizData.currentQuestion
    ]);
    // Sticky Menu Area
    (0,react.useEffect)(function() {
        window.addEventListener("scroll", isFooterSticky);
        return function() {
            window.removeEventListener("scroll", isFooterSticky);
        };
    });
    var isFooterSticky = function(e) {
        if (quizStepsContainer.current && stickyFooter.current) {
            if (quizStepsContainer.current.getBoundingClientRect().bottom > 50) {
                // Passed the Quiz section
                stickyFooter.current.classList.remove("hidden");
            } else {
                // In the Quiz section
                stickyFooter.current.classList.add("hidden");
            }
        }
    };
    var messages = getListMessages();
    var isAnwerSelected = !!getCurrentAnswers();
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
        className: "quiz-steps__container flex h-full w-full flex-col overflow-y-auto bg-white text-center",
        ref: quizStepsContainer,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)("div", {
            className: "flex flex-col mx-auto w-full px-5 py-8 md:py-32 min-h-[calc(100dvh-152px)] md:min-h-[620px] ".concat(optionType === "with-image" ? "max-w-[1130px]" : "max-w-[900px]"),
            children: [
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)("div", {
                    className: "quiz-steps__body-content",
                    children: [
                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                            children: messages.length > 0 && messages.map(function(message, index) {
                                return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                                    variant: "h2",
                                    className: "",
                                    children: message
                                }, "message-".concat(quizData.questionIndex, "-").concat(index));
                            })
                        }),
                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                            className: "!mt-6",
                            children: "Select one option below"
                        }),
                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)("fieldset", {
                            "aria-label": messages === null || messages === void 0 ? void 0 : messages[0],
                            className: "quiz-steps__options-container grid pt-12 pb-16 ".concat(optionType === "with-image" ? "grid-cols-2 sm:!flex flex-wrap justify-center gap-6 sm:gap-5" : "md:block gap-3"),
                            children: [
                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("legend", {
                                    className: "sr-only",
                                    children: "Question options"
                                }),
                                questionData === null || questionData === void 0 ? void 0 : (ref = questionData.options) === null || ref === void 0 ? void 0 : ref.map(function(option, index) {
                                    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(QuizOption, {
                                        theme: theme,
                                        optionData: option,
                                        isMultipleChoice: isMultipleChoice,
                                        isFilter: questionData.isFilterQuestion,
                                        optionType: optionType,
                                        optionAlignmentMobile: optionAlignmentMobile,
                                        index: index,
                                        currentAnswers: currentAnswers
                                    }, option.label);
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)("div", {
                    className: "md:!block mt-auto fixed md:static left-0 bottom-0 w-full p-5 bg-white z-[29]",
                    ref: stickyFooter,
                    children: [
                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)("div", {
                            className: "quiz-questions_footer flex items-center justify-center gap-4",
                            children: [
                                parseFloat(quizData.currentQuestion) > 0 && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                                    variant: "buttons.secondary",
                                    className: "mt-4 !inline-block !w-full !min-w-max md:!w-[100px]",
                                    onClick: function() {
                                        navigateToPreviousQuestion();
                                    },
                                    children: "Back"
                                }),
                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                                    variant: "buttons.primary",
                                    className: "mt-4 !inline-block !min-w-[184px] md:w-auto ".concat(parseFloat(quizData.currentQuestion) > 0 ? "!w-auto" : "w-full"),
                                    onClick: function() {
                                        navigateToNextQuestion();
                                    },
                                    disabled: !isAnwerSelected,
                                    children: "Next"
                                })
                            ]
                        }),
                        questionData.helpTitle && questionData.helpContent && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)("div", {
                            className: "quiz-questions__help-modal mt-4 w-full text-center",
                            children: [
                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                                    variant: "buttons.articleLink",
                                    onClick: toggleInfoModal,
                                    "aria-label": "Open Help Modal",
                                    children: "Need Help Deciding?"
                                }),
                                helpTextOpen && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                                    className: "quiz-help-modal fixed top-0 left-0 z-[100001] flex h-full w-full items-center justify-center text-left bg-[#00000070] p-8",
                                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)("div", {
                                        className: "quiz-help-modal__body relative h-auto max-h-[80%] max-w-xl overflow-y-auto bg-white p-8",
                                        children: [
                                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                                                className: "absolute right-4 top-4",
                                                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Button */.zx, {
                                                    className: "p-2",
                                                    variant: "buttons.plain",
                                                    onClick: toggleInfoModal,
                                                    "aria-label": "Close Help Modal",
                                                    children: [
                                                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("span", {
                                                            className: "sr-only",
                                                            children: "Close Modal"
                                                        }),
                                                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Svg */.ny, {
                                                            alt: "Close",
                                                            src: "/svgs/close.svg#close",
                                                            viewBox: "0 0 48 48",
                                                            className: "w-4 h-4"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                                                className: "quiz-help-modal__header",
                                                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                                                    variant: "h2",
                                                    children: questionData.helpTitle
                                                })
                                            }),
                                            questionData.helpContent.length > 0 && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Markdown */.UG, {
                                                className: "!mt-6",
                                                text: (ref1 = questionData.helpContent[0]) === null || ref1 === void 0 ? void 0 : ref1.body
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/hooks/useKlaviyoApi.js
/* provided dependency */ var process = __webpack_require__(14284);



var useKlaviyoApi = function() {
    var klaviyoApiKey = process.env.NEXT_PUBLIC_KLAVIYO_PUBLIC_API_KEY || "QC4SUa";
    var revision = "2025-01-15";
    var subscribeToList = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var listId, email, phone, source, callback, properties, response;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        listId = param.listId, email = param.email, phone = param.phone, source = param.source, callback = param.callback, properties = param.properties;
                        if (typeof listId === "undefined") {
                            console.error("useKlaviyoApi.subscribeToList: listId is required");
                            return [
                                2
                            ];
                        }
                        if (typeof email === "undefined" && typeof phone === "undefined") {
                            console.error("useKlaviyoApi.subscribeToList: email or phone are required");
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            fetch("https://a.klaviyo.com/client/subscriptions?company_id=".concat(klaviyoApiKey), {
                                method: "POST",
                                headers: {
                                    accept: "application/vnd.api+json",
                                    "content-type": "application/vnd.api+json",
                                    revision: revision
                                },
                                body: JSON.stringify({
                                    data: {
                                        type: "subscription",
                                        attributes: {
                                            custom_source: source,
                                            profile: {
                                                data: {
                                                    type: "profile",
                                                    attributes: {
                                                        email: email,
                                                        phone_number: phone
                                                    },
                                                    properties: properties
                                                }
                                            }
                                        },
                                        relationships: {
                                            list: {
                                                data: {
                                                    type: "list",
                                                    id: listId
                                                }
                                            }
                                        }
                                    }
                                })
                            }).then(function(res) {
                                if (res.status === 202) {
                                    return "success";
                                }
                                return res.json();
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        if (callback) {
                            callback(response);
                        }
                        return [
                            2,
                            response
                        ];
                }
            });
        });
        return function subscribeToList(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var sendEvent = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var email, phone, eventName, profileProperties, eventProperties, metricName, callback, response;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        email = param.email, phone = param.phone, eventName = param.eventName, profileProperties = param.profileProperties, eventProperties = param.eventProperties, metricName = param.metricName, callback = param.callback;
                        if (typeof eventName === "undefined") {
                            console.error("useKlaviyoApi.sendEvent: eventName is required to submit an event to klaviyo");
                            return [
                                2
                            ];
                        }
                        if (typeof email === "undefined" && typeof phone === "undefined") {
                            console.error("useKlaviyoApi.sendEvent: email or phone are required to identify the customer on klaviyo");
                            return [
                                2
                            ];
                        }
                        if (typeof metricName === "undefined") {
                            console.error("useKlaviyoApi.sendEvent: metricName property is required to submit an event to klaviyo");
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            fetch("https://a.klaviyo.com/client/events?company_id=".concat(klaviyoApiKey), {
                                method: "POST",
                                headers: {
                                    accept: "application/vnd.api+json",
                                    "content-type": "application/vnd.api+json",
                                    revision: revision
                                },
                                body: JSON.stringify({
                                    data: {
                                        type: "event",
                                        attributes: {
                                            properties: (0,_object_spread/* default */.Z)({}, eventProperties),
                                            metric: {
                                                data: {
                                                    type: "metric",
                                                    attributes: {
                                                        name: metricName
                                                    }
                                                }
                                            },
                                            profile: {
                                                data: {
                                                    type: "profile",
                                                    attributes: {
                                                        email: email,
                                                        phone_number: phone,
                                                        properties: profileProperties
                                                    }
                                                }
                                            }
                                        }
                                    }
                                })
                            }).then(function(res) {
                                if (res.status === 202) {
                                    return "success";
                                }
                                return res.json();
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        if (callback) {
                            callback(response);
                        }
                        return [
                            2,
                            response
                        ];
                }
            });
        });
        return function sendEvent(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var backInStockSubscription = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var email, phone, variantId, callback, channels, response;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        email = param.email, phone = param.phone, variantId = param.variantId, callback = param.callback;
                        if (typeof variantId === "undefined") {
                            console.error("useKlaviyoApi.backInStockSubscription: variantId is required to submit a back in stock subscription event to klaviyo");
                            return [
                                2
                            ];
                        }
                        if (typeof email === "undefined" && typeof phone === "undefined") {
                            console.error("useKlaviyoApi.backInStockSubscription: email or phone are required to identify the customer on klaviyo");
                            return [
                                2
                            ];
                        }
                        channels = [];
                        if (phone) {
                            channels.push("SMS");
                        }
                        if (email) {
                            channels.push("EMAIL");
                        }
                        return [
                            4,
                            fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=".concat(klaviyoApiKey), {
                                method: "POST",
                                headers: {
                                    accept: "application/vnd.api+json",
                                    "content-type": "application/vnd.api+json",
                                    revision: revision
                                },
                                body: JSON.stringify({
                                    data: {
                                        type: "back-in-stock-subscription",
                                        attributes: {
                                            channels: channels,
                                            profile: {
                                                data: {
                                                    type: "profile",
                                                    attributes: {
                                                        email: email,
                                                        phone_number: phone
                                                    }
                                                }
                                            }
                                        },
                                        relationships: {
                                            variant: {
                                                data: {
                                                    type: "catalog-variant",
                                                    id: "$shopify:::$default:::".concat(variantId)
                                                }
                                            }
                                        }
                                    }
                                })
                            }).then(function(res) {
                                if (res.status === 202) {
                                    return "success";
                                }
                                return res.json();
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        if (callback) {
                            callback(response);
                        }
                        return [
                            2,
                            response
                        ];
                }
            });
        });
        return function backInStockSubscription(_) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        subscribeToList: subscribeToList,
        backInStockSubscription: backInStockSubscription,
        sendEvent: sendEvent
    };
};

// EXTERNAL MODULE: ./src/templates/account/Shared/InputField.jsx + 1 modules
var InputField = __webpack_require__(45115);
;// CONCATENATED MODULE: ./src/sections/QuizSection/QuizMailGate.jsx













function QuizMailGate() {
    var form = (0,react.useRef)();
    var email = (0,react.useRef)();
    var stickyFooter = (0,react.useRef)();
    var quizStepsContainer = (0,react.useRef)();
    var context = useQuizContext();
    var customer = (0,dist.useCustomer)();
    var quizSettings = context.quizSettings, quizData = context.quizData, updateQuizData = context.updateQuizData, getResultsProducts = context.getResultsProducts, getQAs = context.getQAs, theme = context.theme;
    var _mailGate = quizSettings.mailGate, mailGateKlaviyoId = _mailGate.mailGateKlaviyoId, title = _mailGate.title, description = _mailGate.description, mailGateSubmitText = _mailGate.mailGateSubmitText, mailGateCTAText = _mailGate.mailGateCTAText, klaviyoProperties = _mailGate.klaviyoProperties;
    var ref = (0,react.useState)(false), hasError = ref[0], setHasError = ref[1];
    var ref1 = (0,react.useState)(false), isSubmitted = ref1[0], setIsSubmitted = ref1[1];
    var ref2 = useKlaviyoApi(), subscribeToList = ref2.subscribeToList, sendEvent = ref2.sendEvent;
    var resultProducts = getResultsProducts();
    var qas = getQAs();
    var profileProperties = (0,react.useMemo)(function() {
        var resultIndex = 0;
        var properties = resultProducts === null || resultProducts === void 0 ? void 0 : resultProducts.reduce(function(acc, result) {
            var ref, ref1;
            if ((ref = result.product) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.title) {
                var ref2, ref3, ref4;
                resultIndex += 1;
                var _obj;
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (_obj = {}, (0,_define_property/* default */.Z)(_obj, "Quiz Result ".concat(resultIndex, " - Product Name"), "".concat((ref2 = result.product) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.title)), (0,_define_property/* default */.Z)(_obj, "Quiz Result ".concat(resultIndex, " - Product ID"), (ref4 = result.product) === null || ref4 === void 0 ? void 0 : ref4.id.split("/Product/")[1]), _obj));
            }
            return acc;
        }, {});
        if (klaviyoProperties && (klaviyoProperties === null || klaviyoProperties === void 0 ? void 0 : klaviyoProperties.length) > 0 && (qas === null || qas === void 0 ? void 0 : qas.length) > 0) {
            var messIndex = 0;
            klaviyoProperties === null || klaviyoProperties === void 0 ? void 0 : klaviyoProperties.forEach(function(item) {
                var selected = qas.find(function(qa) {
                    var ref;
                    return qa.question.indexOf((ref = item.propertyKey) === null || ref === void 0 ? void 0 : ref.trim()) > -1;
                });
                if (selected) {
                    var ref;
                    messIndex += 1;
                    properties["Message ".concat(messIndex, " = ").concat((ref = item.propertyKey) === null || ref === void 0 ? void 0 : ref.trim())] = selected.answer;
                }
            });
        }
        return properties;
    }, [
        resultProducts,
        klaviyoProperties,
        qas
    ]);
    var quizSubscribe = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            var emailElement, nameElement;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        setIsSubmitted(true);
                        emailElement = document.querySelector('input[name="quiz-email"]');
                        nameElement = document.querySelector('input[name="quiz-name"]');
                        return [
                            4,
                            subscribeToList({
                                listId: mailGateKlaviyoId,
                                email: emailElement === null || emailElement === void 0 ? void 0 : emailElement.value,
                                name: nameElement === null || nameElement === void 0 ? void 0 : nameElement.value,
                                source: "Quiz Mail Gate"
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            sendEvent({
                                eventName: "Quiz Mail Gate Results",
                                metricName: "Quiz Save Results",
                                email: emailElement === null || emailElement === void 0 ? void 0 : emailElement.value,
                                name: nameElement === null || nameElement === void 0 ? void 0 : nameElement.value,
                                profileProperties: profileProperties
                            }).then(function(response) {
                                if (response.errors) {
                                    setHasError(true);
                                } else {
                                    setTimeout(function() {
                                        updateQuizData({
                                            quizStep: "results"
                                        });
                                    }, 1500);
                                }
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function quizSubscribe(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var isFooterSticky = function() {
        if (quizStepsContainer.current && stickyFooter.current) {
            if (quizStepsContainer.current.getBoundingClientRect().bottom > 50) {
                // Passed the Quiz section
                stickyFooter.current.classList.remove("hidden");
            } else {
                // In the Quiz section
                stickyFooter.current.classList.add("hidden");
            }
        }
    };
    // Sticky Menu Area
    (0,react.useEffect)(function() {
        window.addEventListener("scroll", isFooterSticky);
        return function() {
            window.removeEventListener("scroll", isFooterSticky);
        };
    });
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Container */.W2, {
        className: "min-h-[620px] flex flex-col py-7 md:py-20 lg:py-28 px-5 max-w-[1240px] mx-auto text-center",
        ref: quizStepsContainer,
        children: [
            isSubmitted && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)("div", {
                className: "flex flex-col items-center justify-center",
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                        variant: "h2",
                        children: "Calculating Your Results...."
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                        className: "mt-16",
                        sx: theme === null || theme === void 0 ? void 0 : theme.loader
                    })
                ]
            }),
            !isSubmitted && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_jsx_runtime_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)("div", {
                        className: "max-w-2xl mx-auto",
                        children: [
                            title && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                                variant: "h2",
                                children: title
                            }),
                            description && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Markdown */.UG, {
                                className: "!mt-6",
                                text: description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)("form", {
                        className: "mt-6 max-w-[312px] mx-auto w-full",
                        ref: form,
                        id: "subscribeForm",
                        onSubmit: quizSubscribe,
                        children: [
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(InputField/* InputField */.U, {
                                type: "text",
                                name: "quiz-name",
                                label: "",
                                placeholder: "Your Name",
                                sx: {
                                    fontSize: "15px",
                                    py: "10px",
                                    mb: "12px"
                                },
                                required: true
                            }),
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(InputField/* InputField */.U, {
                                type: "email",
                                name: "quiz-email",
                                label: "",
                                placeholder: "Your Email",
                                ref: email,
                                value: customer === null || customer === void 0 ? void 0 : customer.email,
                                sx: {
                                    fontSize: "15px",
                                    py: "10px",
                                    mb: "12px"
                                },
                                onChange: function() {
                                    if (hasError) {
                                        setHasError(false);
                                    }
                                },
                                required: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)("div", {
                        className: "md:!block mt-auto fixed md:static left-0 bottom-0 w-full p-5 bg-white z-[29]",
                        ref: stickyFooter,
                        children: [
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)("div", {
                                className: "flex items-center justify-center gap-4",
                                children: [
                                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                                        variant: "buttons.secondary",
                                        className: "mt-4 !inline-block !w-full !min-w-max md:!w-[100px]",
                                        onClick: function() {
                                            updateQuizData({
                                                quizStep: "steps",
                                                hasError: false
                                            });
                                        },
                                        children: "Back"
                                    }),
                                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                                        variant: "buttons.primary",
                                        className: "mt-4 !inline-block !min-w-[184px] !w-auto",
                                        form: "subscribeForm",
                                        type: "submit",
                                        children: mailGateSubmitText
                                    })
                                ]
                            }),
                            mailGateCTAText && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                                variant: "buttons.articleLink",
                                onClick: function() {
                                    setIsSubmitted(true);
                                    setTimeout(function() {
                                        updateQuizData({
                                            quizStep: "results"
                                        });
                                    }, 1500);
                                },
                                className: "!mt-4 !text-[14px] md:!text-[15px]",
                                "aria-label": "Skip to the next step",
                                children: mailGateCTAText
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/sections/QuizSection/QuizResults.jsx





function QuizResult() {
    var ref;
    var context = useQuizContext();
    var quizSettings = context.quizSettings, getResultsProducts = context.getResultsProducts, updateQuizData = context.updateQuizData, theme = context.theme;
    var products = (ref = getResultsProducts() || []) === null || ref === void 0 ? void 0 : ref.filter(function(value) {
        return Object.keys(value).length !== 0;
    });
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Container */.W2, {
        className: "py-7 md:py-20 lg:py-28 px-5 max-w-[1454px] mx-auto",
        children: [
            products && products.length > 0 ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                variant: "h2",
                className: "text-center",
                children: "Your Ultimate Br\xfcMate Match Is Below"
            }) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                variant: "h2",
                className: "text-center",
                children: "No products found."
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                className: "mt-8 md:mt-20 lg:mt-28 ".concat(products.length > 2 ? "grid md:grid-cols-2 lg:grid-cols-3" : "grid md:flex justify-center", " gap-8"),
                products: products,
                children: products === null || products === void 0 ? void 0 : products.map(function(param, index) {
                    var product = param.product, resultMessage = param.resultMessage, seeAllLink = param.seeAllLink;
                    var handle = product === null || product === void 0 ? void 0 : product.handle;
                    if (!handle) return null;
                    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)("div", {
                        className: "grid max-w-[450px] flex-1 w-full",
                        children: [
                            resultMessage && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Markdown */.UG, {
                                text: resultMessage
                            }),
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(SuperCollectionProductItem, {
                                handle: handle,
                                view: "quiz",
                                seeAllLink: seeAllLink,
                                index: index
                            })
                        ]
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                className: "text-center mt-16",
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                    variant: "buttons.secondary",
                    className: "!inline-block",
                    onClick: function() {
                        updateQuizData({
                            quizStep: "steps",
                            currentQuestion: 0,
                            answers: [],
                            isFiltered: false,
                            hasError: false
                        });
                    },
                    children: "Retake The Quiz"
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/sections/QuizSection/QuizHome.jsx




function QuizHome(param) {
    var theme = param.theme, content = param.content;
    var context = useQuizContext();
    var quizSettings = context.quizSettings, updateQuizData = context.updateQuizData;
    var ref = (quizSettings === null || quizSettings === void 0 ? void 0 : quizSettings.homeScreen) || {}, backgroundImageDesktop = ref.backgroundImageDesktop, backgroundImageMobile = ref.backgroundImageMobile, title = ref.title, subtitle = ref.subtitle, description = ref.description, ctaText = ref.ctaText;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)("div", {
        className: "quiz-home relative",
        children: [
            backgroundImageDesktop && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Picture */.t, {
                alt: backgroundImageMobile === null || backgroundImageMobile === void 0 ? void 0 : backgroundImageMobile.alt,
                className: "md:!absolute inset-0 object-cover w-full h-full",
                images: [
                    {
                        src: backgroundImageMobile === null || backgroundImageMobile === void 0 ? void 0 : backgroundImageMobile.src,
                        width: 768,
                        ratio: 1
                    },
                    {
                        src: backgroundImageDesktop === null || backgroundImageDesktop === void 0 ? void 0 : backgroundImageDesktop.src,
                        width: 512,
                        ratio: 1
                    },
                    {
                        src: backgroundImageDesktop === null || backgroundImageDesktop === void 0 ? void 0 : backgroundImageDesktop.src,
                        width: 640,
                        ratio: 1
                    },
                    {
                        src: backgroundImageDesktop === null || backgroundImageDesktop === void 0 ? void 0 : backgroundImageDesktop.src,
                        width: 720,
                        ratio: 1
                    }, 
                ]
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                className: "quiz-home__inner relative md:pt-[104px] md:pb-[93px] flex items-center justify-center",
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                    className: "py-10 px-6 md:py-[55px] md:px-16 bg-white",
                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)("div", {
                        className: "max-w-[410px]",
                        children: [
                            subtitle && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                                variant: "h5",
                                className: "!mb-2",
                                children: subtitle
                            }),
                            title && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                                variant: "h2",
                                children: title
                            }),
                            description && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("p", {
                                className: "mt-4 mb-8",
                                children: description
                            }),
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Link */.rU, {
                                variant: "buttons.primary",
                                className: "mt-4 !inline-block",
                                onClick: function() {
                                    updateQuizData({
                                        quizStep: "steps"
                                    });
                                },
                                children: ctaText || "take quiz"
                            })
                        ]
                    })
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/sections/QuizSection/Quiz.theme.js

var Quiz_theme_themed = (0,create/* create */.U)(new function() {
    this.loader = {
        position: "relative",
        width: "18px",
        height: "18px",
        borderRadius: "100%",
        background: "#7D7D7D",
        animation: "dot-flashing 1.5s infinite linear alternate",
        animationDelay: ".5s",
        ":before": {
            content: '""',
            position: "absolute",
            left: "-35px",
            width: "18px",
            height: "18px",
            borderRadius: "100%",
            background: "#D9D9D9",
            animation: "dot-flashing 1.5s infinite alternate",
            animationDelay: "0s",
            top: "0"
        },
        ":after": {
            content: '""',
            position: "absolute",
            left: "35px",
            width: "18px",
            height: "18px",
            borderRadius: "100%",
            background: "#1C1C1C",
            animation: "dot-flashing 1.5s infinite alternate",
            animationDelay: "1s",
            top: "0"
        },
        "@keyframes dot-flashing": {
            "0%": {
                background: "#D9D9D9"
            },
            "50%": {
                background: "#7D7D7D"
            },
            "100%": {
                background: "#1C1C1C"
            }
        }
    };
    this.optionImage = {
        height: "128px",
        img: {
            objectFit: "cover"
        }
    };
}());

;// CONCATENATED MODULE: ./src/sections/QuizSection/Quiz.jsx












var QuizSection = (0,src_utils/* withInView */.Dh)(Quiz_theme_themed(function(param) {
    var theme = param.theme, cms = param.cms;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var sectionRef = (0,react.useRef)();
    var ref9 = (0,react.useState)({
        quizStep: "home",
        currentQuestion: 0,
        answers: [],
        filter: "",
        hasError: false,
        isFiltered: false,
        filteredQuestions: []
    }), quizData = ref9[0], setQuizData = ref9[1];
    var ref10 = (0,react.useState)("0%"), loaderPercentage = ref10[0], setLoaderPercentage = ref10[1];
    var filterQuestionData = {
        message1: cms === null || cms === void 0 ? void 0 : (ref = cms.filterSettings) === null || ref === void 0 ? void 0 : ref.filterQuestionMessage1,
        message2: cms === null || cms === void 0 ? void 0 : (ref1 = cms.filterSettings) === null || ref1 === void 0 ? void 0 : ref1.filterQuestionMessage2,
        isMultipleChoice: cms === null || cms === void 0 ? void 0 : (ref2 = cms.filterSettings) === null || ref2 === void 0 ? void 0 : ref2.isMultipleChoice,
        optionType: cms === null || cms === void 0 ? void 0 : (ref3 = cms.filterSettings) === null || ref3 === void 0 ? void 0 : ref3.optionType,
        optionAlignmentMobile: cms === null || cms === void 0 ? void 0 : (ref4 = cms.filterSettings) === null || ref4 === void 0 ? void 0 : ref4.optionAlignmentMobile,
        options: cms === null || cms === void 0 ? void 0 : (ref5 = cms.filterSettings) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.filterOptions) === null || ref6 === void 0 ? void 0 : ref6.map(function(option) {
            var ref, ref1;
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, option), {
                label: (ref = option.label) === null || ref === void 0 ? void 0 : ref.trim(),
                value: (ref1 = option.value) === null || ref1 === void 0 ? void 0 : ref1.trim()
            });
        }),
        helpTitle: cms === null || cms === void 0 ? void 0 : (ref7 = cms.filterSettings) === null || ref7 === void 0 ? void 0 : ref7.filterHelpTitle,
        helpContent: cms === null || cms === void 0 ? void 0 : (ref8 = cms.filterSettings) === null || ref8 === void 0 ? void 0 : ref8.filterHelpContent,
        isFilterQuestion: true
    };
    var hasFilterQuestion = !!filterQuestionData.message1 && filterQuestionData.options.length > 0;
    var questionSettings = (cms.questions || []).map(function(question) {
        var ref;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, question), {
            category: (ref = question.category) === null || ref === void 0 ? void 0 : ref.trim()
        });
    });
    var questionList = hasFilterQuestion ? [
        filterQuestionData
    ].concat((0,_to_consumable_array/* default */.Z)(questionSettings)) : questionSettings;
    var quizSettings = {
        title: cms.title,
        description: cms.description,
        homeScreen: cms.homeScreen,
        questions: questionList.map(function(question, index) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, question), {
                index: index
            });
        }),
        mailGate: cms.mailGate
    };
    var updateQuizData = function(newData) {
        setQuizData((0,_object_spread/* default */.Z)({}, quizData, newData));
    };
    var getResultsProducts = function() {
        var ref;
        var products = [];
        if ((quizData === null || quizData === void 0 ? void 0 : (ref = quizData.answers) === null || ref === void 0 ? void 0 : ref.length) === 0) {
            var ref1, ref2, ref3, ref4, ref5;
            var filteredQuestions = (ref1 = quizData.filteredQuestions) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.options) === null || ref3 === void 0 ? void 0 : ref3.filter(function(option) {
                return option.value === quizData.filter;
            });
            if (filteredQuestions && filteredQuestions.length > 0 && ((ref4 = filteredQuestions[0]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.productList) === null || ref5 === void 0 ? void 0 : ref5.length) > 0) {
                var ref6, ref7;
                if ((ref6 = filteredQuestions[0]) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.productList) === null || ref7 === void 0 ? void 0 : ref7.length) {
                    var _products;
                    (_products = products).push.apply(_products, (0,_to_consumable_array/* default */.Z)(filteredQuestions[0].productList));
                }
            }
        } else {
            var ref8;
            quizData === null || quizData === void 0 ? void 0 : (ref8 = quizData.answers) === null || ref8 === void 0 ? void 0 : ref8.forEach(function(answer) {
                if (!answer) {
                    return;
                }
                var question = quizSettings.questions.find(function(q) {
                    return q.index === answer.questionIndex;
                });
                if (answer.answer.indexOf("---") > -1) {
                    var ref, ref1;
                    // Question with follow up question
                    var mainOption = question === null || question === void 0 ? void 0 : question.options[Number.parseInt(answer.answer.split("---")[0])];
                    var followUpOption = question === null || question === void 0 ? void 0 : question.options[Number.parseInt(answer.answer.split("---")[0])].followUpOptions[Number.parseInt(answer.answer.split("---")[1])];
                    if (mainOption && (mainOption === null || mainOption === void 0 ? void 0 : (ref = mainOption.productList) === null || ref === void 0 ? void 0 : ref.length)) {
                        var _products;
                        (_products = products).push.apply(_products, (0,_to_consumable_array/* default */.Z)(mainOption.productList));
                    }
                    if (followUpOption && (followUpOption === null || followUpOption === void 0 ? void 0 : (ref1 = followUpOption.productList) === null || ref1 === void 0 ? void 0 : ref1.length)) {
                        var _products1;
                        (_products1 = products).push.apply(_products1, (0,_to_consumable_array/* default */.Z)(followUpOption.productList));
                    }
                } else {
                    var ref2;
                    // Question without follow up question
                    var option = question === null || question === void 0 ? void 0 : question.options.find(function(option, index) {
                        return String(index) === answer.answer;
                    });
                    if (option && (option === null || option === void 0 ? void 0 : (ref2 = option.productList) === null || ref2 === void 0 ? void 0 : ref2.length)) {
                        var _products2;
                        (_products2 = products).push.apply(_products2, (0,_to_consumable_array/* default */.Z)(option.productList));
                    }
                }
            });
        }
        return products;
    };
    var getQAs = function() {
        var ref, ref1, ref2, ref3;
        var products = [];
        var qas = [];
        var filteredQuestion = (ref = quizData.filteredQuestions) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.options) === null || ref2 === void 0 ? void 0 : ref2.find(function(option) {
            return option.value === quizData.filter;
        });
        if ((quizData === null || quizData === void 0 ? void 0 : (ref3 = quizData.answers) === null || ref3 === void 0 ? void 0 : ref3.length) === 0) {
            if (filteredQuestion) {
                var ref4, ref5;
                qas.push({
                    question: "".concat((ref4 = quizData.filteredQuestions[0]) === null || ref4 === void 0 ? void 0 : ref4.message1, " ").concat((ref5 = quizData.filteredQuestions[0]) === null || ref5 === void 0 ? void 0 : ref5.message2),
                    answer: filteredQuestion.label
                });
            }
        } else {
            var ref6;
            quizData === null || quizData === void 0 ? void 0 : (ref6 = quizData.answers) === null || ref6 === void 0 ? void 0 : ref6.forEach(function(answer) {
                if (!answer) {
                    return;
                }
                var question = quizSettings.questions.find(function(question) {
                    return question.index === answer.questionIndex;
                });
                if (answer.answer.indexOf("---") > -1) {
                    var ref;
                    // Question with follow up question
                    var q1 = answer.answer.split("---")[0];
                    var q2 = answer.answer.split("---")[1];
                    qas.push({
                        question: "".concat(question === null || question === void 0 ? void 0 : question.message1),
                        answer: "".concat((ref = question.options[parseFloat(q1)]) === null || ref === void 0 ? void 0 : ref.label)
                    });
                    if (q2) {
                        var ref1, ref2, ref3;
                        qas.push({
                            question: "".concat((ref1 = question.options[parseFloat(q1)]) === null || ref1 === void 0 ? void 0 : ref1.followUpMessage1),
                            answer: "".concat((ref3 = (ref2 = question.options[parseFloat(q1)]) === null || ref2 === void 0 ? void 0 : ref2.followUpOptions[parseFloat(q2)]) === null || ref3 === void 0 ? void 0 : ref3.label)
                        });
                    }
                } else {
                    // Question without follow up question
                    if (answer.questionIndex === 0) {
                        if (filteredQuestion) {
                            var ref4, ref5;
                            qas.push({
                                question: "".concat((ref4 = quizData.filteredQuestions[0]) === null || ref4 === void 0 ? void 0 : ref4.message1, " ").concat((ref5 = quizData.filteredQuestions[0]) === null || ref5 === void 0 ? void 0 : ref5.message2),
                                answer: filteredQuestion.label
                            });
                        }
                    } else {
                        var ref6;
                        qas.push({
                            question: "".concat(question === null || question === void 0 ? void 0 : question.message1),
                            answer: "".concat((ref6 = question.options[parseFloat(answer.answer)]) === null || ref6 === void 0 ? void 0 : ref6.label)
                        });
                    }
                }
            });
        }
        return qas;
    };
    (0,react.useEffect)(function() {
        if (quizData.filter === "") {
            updateQuizData({
                isFiltered: false,
                filteredQuestions: quizSettings.questions
            });
        } else {
            var filteredQuestions = quizSettings.questions.filter(function(question) {
                return question.isFilterQuestion || quizData.filter.includes(question.category);
            });
            updateQuizData({
                isFiltered: true,
                filteredQuestions: filteredQuestions
            });
        }
    }, [
        quizData.filter
    ]);
    (0,react.useEffect)(function() {
        window.scrollTo({
            top: 0
        });
    }, [
        quizData.currentQuestion,
        quizData.quizStep
    ]);
    (0,react.useEffect)(function() {
        if (quizData.quizStep === "steps") {
            setLoaderPercentage("".concat((parseFloat(quizData.currentQuestion) + 1) / quizSettings.questions.length * 100, "%"));
        } else if (quizData.quizStep === "mailGate") {
            setLoaderPercentage("80%");
        } else if (quizData.quizStep === "results") {
            setLoaderPercentage("100%");
        }
    }, [
        quizData.currentQuestion,
        quizData.quizStep
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(QuizContext.Provider, {
        value: {
            theme: theme,
            quizData: quizData,
            updateQuizData: updateQuizData,
            quizSettings: quizSettings,
            getResultsProducts: getResultsProducts,
            getQAs: getQAs
        },
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)("section", {
            ref: sectionRef,
            className: "quizContainer",
            children: [
                quizData.quizStep !== "home" && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                    className: "quiz-steps__load-bar h-1 bg-[#f3f3f3]",
                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                        className: "quiz-steps__load-bar__progress block h-full bg-[#010101] transition-all duration-200",
                        style: {
                            width: loaderPercentage
                        }
                    })
                }),
                quizData.quizStep === "home" && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(QuizHome, {}),
                quizData.quizStep === "steps" && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(QuizQuestions, {}),
                quizData.quizStep === "mailGate" && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(QuizMailGate, {}),
                quizData.quizStep === "results" && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(QuizResult, {})
            ]
        })
    });
}), {
    triggerOnce: true
});
QuizSection.displayName = "Quiz Section";
QuizSection.Schema = {
    category: "Modules",
    label: QuizSection.displayName,
    key: "quizSection",
    fields: [
        {
            component: "number",
            name: "mobileSpacing",
            label: "Section Top Margin - Mobile",
            defaultValue: 60
        },
        {
            component: "number",
            name: "desktopSpacing",
            label: "Section Top Margin - Desktop",
            defaultValue: 80
        },
        {
            component: "group",
            name: "homeScreen",
            label: "Quiz Home Screen",
            fields: [
                {
                    component: "image",
                    name: "backgroundImageDesktop",
                    label: "Image Desktop",
                    description: "Recommended image size: 2880px x 1240px"
                },
                {
                    component: "image",
                    name: "backgroundImageMobile",
                    label: "Image Mobile",
                    description: "Recommended image size: 750px x 512px"
                },
                {
                    component: "text",
                    name: "subtitle",
                    label: "Sub Title",
                    defaultValue: "We crafted an idea just for you"
                },
                {
                    component: "textarea",
                    name: "title",
                    label: "Title",
                    defaultValue: "Take our 5-minute quiz to get perfect Brumate just for you!"
                },
                {
                    component: "textarea",
                    name: "description",
                    label: "Description",
                    defaultValue: "This is a description field, Lorem Ipsum"
                },
                {
                    component: "text",
                    name: "ctaText",
                    label: "Cta Text",
                    defaultValue: "Take the Quiz"
                }, 
            ]
        },
        {
            component: "group",
            name: "filterSettings",
            label: "Filter Question Settings",
            fields: [
                {
                    component: "textarea",
                    name: "filterQuestionMessage1",
                    label: "Filter Question Message 1",
                    description: "Message to be shown as the intro for the filter question"
                },
                {
                    component: "textarea",
                    name: "filterQuestionMessage2",
                    label: "Filter Question Message 2",
                    description: "Message to be shown as the follow up for the filter question"
                },
                {
                    component: "select",
                    name: "optionType",
                    label: "Option Style",
                    options: [
                        {
                            value: "with-icon",
                            label: "With icon"
                        },
                        {
                            value: "default",
                            label: "Without icon"
                        },
                        {
                            value: "with-image",
                            label: "With image"
                        }, 
                    ],
                    defaultValue: "default"
                },
                {
                    component: "select",
                    name: "optionAlignmentMobile",
                    label: "Option Alignment - Mobile",
                    options: [
                        {
                            value: "text-left",
                            label: "Left"
                        },
                        {
                            value: "justify-center text-center",
                            label: "Center"
                        },
                        {
                            value: "justify-end text-right",
                            label: "Right"
                        }, 
                    ],
                    defaultValue: "justify-center text-center"
                },
                {
                    component: "text",
                    name: "filterHelpTitle",
                    label: "Help Modal Title"
                },
                {
                    component: "group-list",
                    name: "filterHelpContent",
                    label: "Help Modal content",
                    fields: [
                        {
                            component: "markdown",
                            name: "body",
                            label: "Body content",
                            description: "Required, content to be displayed in the modal"
                        }, 
                    ]
                },
                {
                    component: "group-list",
                    name: "filterOptions",
                    label: "Filter Options",
                    itemProps: {
                        label: "{{item.label}}"
                    },
                    fields: [
                        {
                            component: "text",
                            name: "label",
                            label: "Option Label",
                            description: "Label the customer will see on the option button"
                        },
                        {
                            component: "text",
                            name: "value",
                            label: "Option Value",
                            description: "Value used to filter the questions, this value should match exactly with the reference attribute added to the questions below, if empty this will force all the questions set below to be shown with no filters, also all other selected options will be disabled so this doesn't mix up with other filters"
                        },
                        {
                            component: "image",
                            name: "image",
                            label: "Option Image",
                            description: "Optional image. Recommended image size: 196px x 125px, Recommended icon size: 20px x 20px"
                        },
                        {
                            component: "group-list",
                            name: "productList",
                            label: "Products",
                            itemProps: {
                                label: "{{item.product.data.title}}"
                            },
                            description: "If no questions available, the following products will be shown on the results page",
                            fields: [
                                {
                                    component: "markdown",
                                    name: "resultMessage",
                                    label: "Result Message",
                                    description: "Message to be shown on the product card"
                                },
                                {
                                    component: "productSearch",
                                    name: "product",
                                    label: "Product"
                                },
                                {
                                    component: "link",
                                    name: "seeAllLink",
                                    label: "See All Link"
                                }, 
                            ]
                        }, 
                    ]
                }, 
            ]
        },
        {
            component: "group-list",
            name: "questions",
            label: "Questions",
            itemProps: {
                label: "{{item.category}}"
            },
            fields: [
                {
                    component: "text",
                    name: "category",
                    label: "Category",
                    description: "Value to be used when filtering the customer flow by the first question"
                },
                {
                    component: "textarea",
                    name: "message1",
                    label: "Message 1",
                    description: "Text to be shown before the question"
                },
                {
                    component: "textarea",
                    name: "message2",
                    label: "Message 2",
                    description: "Text to be shown before the question"
                },
                {
                    component: "select",
                    name: "optionType",
                    label: "Option Style",
                    options: [
                        {
                            value: "with-icon",
                            label: "With icon"
                        },
                        {
                            value: "default",
                            label: "Without icon"
                        },
                        {
                            value: "with-image",
                            label: "With image"
                        }, 
                    ],
                    defaultValue: "default"
                },
                {
                    component: "select",
                    name: "optionAlignmentMobile",
                    label: "Option Alignment - Mobile",
                    options: [
                        {
                            value: "text-left",
                            label: "Left"
                        },
                        {
                            value: "justify-center text-center",
                            label: "Center"
                        },
                        {
                            value: "justify-end text-right",
                            label: "Right"
                        }, 
                    ],
                    defaultValue: "justify-center text-center"
                },
                {
                    component: "group-list",
                    name: "options",
                    label: "Options",
                    itemProps: {
                        label: "{{item.label}}"
                    },
                    fields: [
                        {
                            component: "text",
                            name: "label",
                            label: "Option Label"
                        },
                        {
                            component: "image",
                            name: "image",
                            label: "Option Image",
                            description: "Optional image. Recommended image size: 196px x 125px, Recommended icon size: 20px x 20px"
                        },
                        {
                            component: "group-list",
                            name: "productList",
                            label: "Products",
                            itemProps: {
                                label: "{{item.product.data.title}}"
                            },
                            fields: [
                                {
                                    component: "markdown",
                                    name: "resultMessage",
                                    label: "Result Message",
                                    description: "Message to be shown on the product card"
                                },
                                {
                                    component: "productSearch",
                                    name: "product",
                                    label: "Product"
                                },
                                {
                                    component: "link",
                                    name: "seeAllLink",
                                    label: "See All Link"
                                }, 
                            ]
                        },
                        {
                            component: "toggle",
                            name: "hasFollowUpQuestion",
                            label: "Has Follow Up Question?",
                            description: "(This option doesn't work with multi option question) If enabled, a follow up question will be shown after the customer selects this option, if a product hs been selected for this option it will be disregarded"
                        },
                        {
                            component: "textarea",
                            name: "followUpMessage1",
                            label: "Message 1",
                            description: "Text to be shown before the question"
                        },
                        {
                            component: "textarea",
                            name: "followUpMessage2",
                            label: "Message 2",
                            description: "Text to be shown before the question"
                        },
                        {
                            component: "group-list",
                            name: "followUpOptions",
                            label: "Follow Up Question Options",
                            itemProps: {
                                label: "{{item.label}}"
                            },
                            fields: [
                                {
                                    component: "text",
                                    name: "label",
                                    label: "Option Label"
                                },
                                {
                                    component: "image",
                                    name: "image",
                                    label: "Option Image",
                                    description: "Optional image. Recommended image size: 196px x 125px, Recommended icon size: 20px x 20px"
                                },
                                {
                                    component: "group-list",
                                    name: "productList",
                                    label: "Products",
                                    itemProps: {
                                        label: "{{item.product.data.title}}"
                                    },
                                    fields: [
                                        {
                                            component: "markdown",
                                            name: "resultMessage",
                                            label: "Result Message",
                                            description: "Message to be shown on the product card"
                                        },
                                        {
                                            component: "productSearch",
                                            name: "product",
                                            label: "Product"
                                        },
                                        {
                                            component: "link",
                                            name: "seeAllLink",
                                            label: "See All Link"
                                        }, 
                                    ]
                                }, 
                            ]
                        }, 
                    ],
                    validate: {
                        required: true
                    }
                },
                {
                    component: "text",
                    name: "helpTitle",
                    label: "Help Modal Title"
                },
                {
                    component: "group-list",
                    name: "helpContent",
                    label: "Help Modal content",
                    fields: [
                        {
                            component: "markdown",
                            name: "body",
                            label: "Body content",
                            description: "Required, content to be displayed in the modal"
                        }, 
                    ]
                }, 
            ]
        },
        {
            component: "group",
            name: "mailGate",
            label: "Mail Gate Settings",
            description: "Settings to configure the mail gate",
            fields: [
                {
                    component: "toggle",
                    name: "enableMailGate",
                    label: "Enable Mail Gate",
                    toggleLabels: {
                        true: "Yes",
                        false: "No"
                    },
                    defaultValue: true
                },
                {
                    component: "text",
                    name: "mailGateKlaviyoId",
                    label: "Mail Gate Klaviyo Id",
                    description: "Klaviyo list ID to subscribe the customers to (required if mail gate is enabled)"
                },
                {
                    component: "textarea",
                    name: "title",
                    label: "Title",
                    defaultValue: "You are just one step away from discovering the right Brumate for you!"
                },
                {
                    component: "markdown",
                    name: "description",
                    label: "Description",
                    defaultValue: "This is a description field, Lorem Ipsum"
                },
                {
                    component: "text",
                    name: "mailGateSubmitText",
                    label: "Mail Gate Submit Text",
                    description: "text for the email form submit button, if empty defaults to 'submit'",
                    defaultValue: "Show My Results"
                },
                {
                    component: "text",
                    name: "mailGateCTAText",
                    label: "Mail Gate skip CTA Text",
                    description: "Text for the button to skip submitting the email, if empty defaults to 'no thanks, just show me my results.'",
                    defaultValue: "Show me my results without sharing my email."
                },
                {
                    component: "group-list",
                    name: "klaviyoProperties",
                    label: "Klaviyo Properties",
                    itemProps: {
                        label: "{{item.propertyKey}}"
                    },
                    validate: {
                        maxItems: 3
                    },
                    description: "These properties will be sent to Klaviyo when the user submits their email, this property key should match the question message",
                    fields: [
                        {
                            component: "text",
                            name: "propertyKey",
                            label: "Property Key"
                        }, 
                    ]
                }, 
            ]
        }, 
    ]
};

;// CONCATENATED MODULE: ./src/sections/QuizSection/index.js


;// CONCATENATED MODULE: ./src/sections/Product/ProductContext.jsx

var ProductContext = /*#__PURE__*/ (0,react.createContext)({
    product: null,
    selectedVariant: null,
    setSelectedVariant: function() {
        return undefined;
    },
    selectedOptions: [],
    setSelectedOptions: function() {
        return undefined;
    },
    selectedMedia: [],
    setSelectedMedia: function() {
        return undefined;
    }
});
function useProductContext() {
    var ctx = (0,react.useContext)(ProductContext);
    if (!ctx) {
        throw new Error("useProductContext must be used within <ProductProvider>");
    }
    return ctx;
}

;// CONCATENATED MODULE: ./src/sections/Product/Main/Details/Icons/Icons.theme.js

var Icons_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        variant: "flex.row.start.center",
        flexWrap: "wrap",
        gap: [
            6,
            11
        ],
        mt: [
            2,
            2,
            4
        ],
        mb: [
            5,
            5,
            11
        ]
    };
    this.iconsRow = {
        variant: "flex.row.start.start"
    };
    this.icon = {
        width: "20px",
        mr: 3
    };
    this.label = {
        variant: "text.label.2",
        maxWidth: "175px",
        mt: "1px"
    };
}());

;// CONCATENATED MODULE: ./src/sections/Product/Main/Details/Icons/Icons.jsx








var Icons = Icons_theme_themed(function(param) {
    var theme = param.theme, product = param.product;
    var ref, ref1;
    var settings = (0,dist.useSettings)();
    var iconsData = settings === null || settings === void 0 ? void 0 : (ref = settings.product) === null || ref === void 0 ? void 0 : (ref1 = ref.icons) === null || ref1 === void 0 ? void 0 : ref1.list;
    var iconsDataDep = iconsData && iconsData.length > 0 ? iconsData.map(function(v) {
        var ref;
        return v.tag + v.label + ((ref = v.icon) === null || ref === void 0 ? void 0 : ref.src);
    }).join("") : null;
    var icons = (0,react.useMemo)(function() {
        var ref;
        if (!(product === null || product === void 0 ? void 0 : (ref = product.tags) === null || ref === void 0 ? void 0 : ref.length)) return [];
        return product.tags.reduce(function(arr, tag) {
            var ref;
            if (!tag.startsWith("icon::")) return arr;
            var tagValue = (ref = tag.split("icon::")[1]) === null || ref === void 0 ? void 0 : ref.toLowerCase().trim();
            return tagValue ? (0,_to_consumable_array/* default */.Z)(arr).concat([
                tagValue
            ]) : arr;
        }, []);
    }, [
        product === null || product === void 0 ? void 0 : product.id
    ]);
    var iconsDep = icons.join("");
    var iconsMap = (0,react.useMemo)(function() {
        if (!icons.length || !(iconsData === null || iconsData === void 0 ? void 0 : iconsData.length)) return {};
        return iconsData.reduce(function(obj, icon, index) {
            var tag = icon.tag.toLowerCase().trim();
            obj[tag] = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, icon), {
                tag: tag,
                order: index
            });
            return obj;
        }, {});
    }, [
        iconsDataDep,
        iconsDep
    ]);
    var iconsMapDep = Object.values(iconsMap).map(function(v) {
        return v.tag;
    }).join("");
    var sortedIcons = (0,react.useMemo)(function() {
        if (!icons.length || !iconsMapDep) return [];
        return (0,_to_consumable_array/* default */.Z)(icons).sort(function(a, b) {
            var ref, ref1, ref2, ref3;
            if (((ref = iconsMap[a]) === null || ref === void 0 ? void 0 : ref.order) < ((ref1 = iconsMap[b]) === null || ref1 === void 0 ? void 0 : ref1.order)) return -1;
            if (((ref2 = iconsMap[a]) === null || ref2 === void 0 ? void 0 : ref2.order) > ((ref3 = iconsMap[b]) === null || ref3 === void 0 ? void 0 : ref3.order)) return 1;
            return 0;
        });
    }, [
        iconsDep,
        iconsMapDep
    ]);
    return sortedIcons.length ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
        "data-comp": Icons.displayName,
        sx: theme.wrapper,
        children: sortedIcons.map(function(item) {
            var ref;
            var icon = iconsMap[item];
            return icon ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                sx: theme.iconsRow,
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Image */.Ee, {
                        alt: icon.tag,
                        src: ((ref = icon.icon) === null || ref === void 0 ? void 0 : ref.src) || "/svgs/default-image.svg",
                        sx: theme.icon,
                        loading: "lazy"
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                        sx: theme.label,
                        children: icon.label
                    })
                ]
            }, icon.tag) : null;
        })
    }) : null;
});
Icons.displayName = "Icons";

;// CONCATENATED MODULE: ./src/sections/Product/Main/Details/Icons/index.js


;// CONCATENATED MODULE: ./src/sections/Product/Main/Header/Price/Price.theme.js

var Price_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        minHeight: [
            0,
            "19px"
        ],
        minWidth: "40px",
        mr: [
            4,
            4
        ],
        position: "relative"
    };
    this.loader = {
        height: "12px",
        color: "mediumDarkGray",
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)"
    };
    this.badges = {
        variant: "flex.row.start.center",
        width: "100%",
        ml: 5
    };
    // Amount styles
    this.badge = {
        oneTime: {
            variant: "badges.sellingPlan"
        },
        subscription: {
            variant: "badges.sellingPlan",
            bg: "dark"
        },
        sale: {
            variant: "badges.sellingPlan",
            bg: "red",
            ml: 3
        }
    };
    this.price = {
        lineThrough: {
            variant: "text.base",
            textDecoration: "line-through",
            ml: 4,
            color: "mediumDarkGray"
        },
        new: {
            variant: "text.base",
            color: "red"
        },
        regular: {
            variant: "text.base"
        }
    };
}());

;// CONCATENATED MODULE: ./src/sections/Product/Main/Header/Price/Amount.jsx



var Amount = Price_theme_themed(function(param) {
    var theme = param.theme, compareAtPriceV2 = param.compareAtPriceV2, isOnSale = param.isOnSale, priceV2 = param.priceV2;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
        "data-comp": Amount.displayName,
        sx: theme.price,
        children: isOnSale ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
            children: [
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                    sx: theme.price.new,
                    children: priceV2.locale
                }),
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                    sx: theme.price.lineThrough,
                    children: compareAtPriceV2.locale
                })
            ]
        }) : // onetime full price
        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
            sx: theme.price.regular,
            children: priceV2.locale
        })
    });
});
Amount.displayName = "Amount";

;// CONCATENATED MODULE: ./src/sections/Product/Main/Header/Price/Price.jsx






var Price = Price_theme_themed(function(param) {
    var theme = param.theme, selectedVariant = param.selectedVariant;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
        sx: theme.wrapper,
        children: selectedVariant && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(snippets/* Locale.Variant */.go.Variant, {
            variant: selectedVariant,
            children: [
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Locale.Price */.go.Price, {
                    children: function(props) {
                        return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Amount, (0,_object_spread/* default */.Z)({}, props));
                    }
                }),
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Locale.Loader */.go.Loader, {
                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Spinner */.$j, {
                        sx: theme.loader
                    })
                })
            ]
        })
    });
});

;// CONCATENATED MODULE: ./src/sections/Product/Main/Header/Price/index.js


;// CONCATENATED MODULE: ./src/sections/Product/Main/Header/Header.theme.js

var Main_Header_Header_theme_themed = (0,create/* create */.U)(new function() {
    this.metadata = {
        maxWidth: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        pb: [
            6,
            null,
            8
        ]
    };
    this.title = {
        variant: "text.h2",
        minHeight: [
            "36x",
            "40px"
        ],
        fontSize: [
            "24px",
            "40px"
        ],
        lineHeight: "normal",
        fontWeight: [
            "400",
            "300"
        ],
        letterSpacing: [
            "0.48px",
            "-0.03em"
        ]
    };
    this.variant = {
        color: "mediumDarkGray",
        fontSize: [
            3,
            4
        ],
        minHeight: "22px"
    };
    this.priceAfterpayWrapper = {
        variant: "flex.row.start.center",
        flexWrap: "wrap",
        mt: 6
    };
    this.price = {
        text: "text.h2",
        minHeight: 40
    };
}());

;// CONCATENATED MODULE: ./src/sections/Product/Main/Header/Header.jsx








var Main_Header_Header_Header = Main_Header_Header_theme_themed(function(_param) {
    var theme = _param.theme, selectedVariant = _param.selectedVariant, currentProduct = _param.currentProduct, titles = _param.titles, isMobile = _param.isMobile, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme",
        "selectedVariant",
        "currentProduct",
        "titles",
        "isMobile"
    ]);
    var isMobileViewport = (0,hooks/* useMatchMedia */.ag)("(max-width: 767px)");
    var isVisibleHeader = isMobile && isMobileViewport || !isMobile && !isMobileViewport;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
        sx: (0,_object_spread/* default */.Z)({}, theme.metadata, props.sx),
        children: [
            isVisibleHeader ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                as: "h1",
                sx: theme.title,
                children: titles.product
            }) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                as: "h2",
                sx: theme.title,
                children: titles.product
            }),
            (titles === null || titles === void 0 ? void 0 : titles.variant) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                sx: theme.variant,
                children: titles.variant
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                sx: theme.priceAfterpayWrapper,
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Price, {
                        selectedVariant: selectedVariant
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* OkendoStars */.oF, {
                        legacyResourceId: currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.legacyResourceId,
                        withScroll: true,
                        sx: {
                            mb: 0,
                            mt: 0,
                            cursor: "auto"
                        },
                        className: "before:content-['_|_'] before:mr-2"
                    })
                ]
            })
        ]
    });
});
Main_Header_Header_Header.displayName = "ProductHeader";

;// CONCATENATED MODULE: ./src/sections/Product/Main/Header/index.js


// EXTERNAL MODULE: ../node_modules/swiper/esm/components/scrollbar/scrollbar.js
var scrollbar = __webpack_require__(57987);
;// CONCATENATED MODULE: ./src/sections/Product/Main/Media/Thumbs/ThumbsNavigation/ThumbsNavigation.theme.js

var ThumbsNavigation_theme_themed = (0,create/* create */.U)(new function() {
    this.up = {
        transition: "opacity 0.15s ease-in-out",
        width: "20px",
        cursor: "pointer",
        position: "absolute",
        bottom: "calc(100% + 12px)",
        left: "50%",
        transform: "translateX(-50%)"
    };
    this.down = {
        transition: "opacity 0.15s ease-in-out",
        width: "20px",
        cursor: "pointer",
        position: "absolute",
        top: "calc(100% + 12px)",
        left: "50%",
        transform: "translateX(-50%)"
    };
}());

;// CONCATENATED MODULE: ./src/sections/Product/Main/Media/Thumbs/ThumbsNavigation/ThumbsNavigation.jsx






var ThumbsNavigation = ThumbsNavigation_theme_themed(function(param) {
    var theme = param.theme, swiper = param.swiper, count = param.count;
    var showNavPerBp = (0,hooks/* useBreakpointValue */.Sx)([
        false,
        false,
        count > 5,
        count > 6
    ]);
    var ref = (0,react.useState)(true), isStart = ref[0], setIsStart = ref[1];
    var ref1 = (0,react.useState)(false), isEnd = ref1[0], setIsEnd = ref1[1];
    var ref2 = (0,react.useState)(false), showNav = ref2[0], setShowNav = ref2[1];
    var setStartAndEndOnSwiperChange = (0,react.useCallback)(function() {
        if (!swiper) return function() {}; // Return empty cleanup function
        setIsStart(swiper.isBeginning);
        setIsEnd(swiper.isEnd);
        var handleSlideChange = function() {
            setIsStart(swiper.isBeginning);
            setIsEnd(swiper.isEnd);
        };
        swiper.on("slideChange", handleSlideChange);
        return function() {
            swiper.off("slideChange", handleSlideChange);
        };
    }, [
        swiper
    ]);
    (0,react.useEffect)(function() {
        var cleanup = setStartAndEndOnSwiperChange();
        return cleanup;
    }, [
        swiper
    ]);
    (0,react.useEffect)(function() {
        setShowNav(showNavPerBp);
    }, [
        showNavPerBp
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_jsx_runtime_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Svg */.ny, {
                alt: "chevron",
                viewBox: "0 0 16 16",
                src: "/svgs/chevron/up.svg#up",
                onClick: function() {
                    return swiper.slidePrev();
                },
                role: "button",
                sx: (0,_object_spread/* default */.Z)({
                    display: showNav ? "block" : "none",
                    opacity: showNav && isStart ? 0 : 1,
                    pointerEvents: showNav && isStart ? "none" : "auto"
                }, theme.up)
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Svg */.ny, {
                alt: "chevron",
                viewBox: "0 0 16 16",
                src: "/svgs/chevron/down.svg#down",
                onClick: function() {
                    return swiper.slideNext();
                },
                role: "button",
                sx: (0,_object_spread/* default */.Z)({
                    display: showNav ? "block" : "none",
                    opacity: showNav && isEnd ? 0 : 1,
                    pointerEvents: showNav && isEnd ? "none" : "auto",
                    transition: "opacity 0.15s ease-in-out"
                }, theme.down)
            })
        ]
    });
});
ThumbsNavigation.displayName = "ThumbsNavigation";

;// CONCATENATED MODULE: ./src/sections/Product/Main/Media/Thumbs/ThumbsNavigation/index.js


;// CONCATENATED MODULE: ./src/sections/Product/Main/Media/Thumbs/Thumbs.theme.js

var Thumbs_theme_themed = (0,create/* create */.U)(new function() {
    this.thumbs = {
        display: [
            "none",
            null,
            "block"
        ],
        width: "80px",
        minWidth: "80px",
        mr: "28px",
        position: "relative",
        height: [
            "calc((80px * 5) + (12px * 4))",
            null,
            null,
            "calc((80px * 6) + (12px * 5))", 
        ]
    };
    this.swiper = {
        height: "100%",
        ".swiper-slide": {
            pb: "100%",
            height: "auto !important",
            position: "relative"
        }
    };
    this.thumb = {
        width: "100%",
        height: "100%",
        cursor: "pointer",
        borderRadius: "4px",
        position: "absolute",
        overflow: "hidden",
        top: 0,
        left: 0,
        transition: "all .25s ease-in-out",
        "&:hover": {
            opacity: 1
        },
        inactive: {
            border: function(t) {
                return "1px solid ".concat(t.colors.gray);
            }
        },
        active: {
            border: function(t) {
                return "1px solid ".concat(t.colors.text);
            }
        },
        default: {
            image: {
                position: "absolute",
                width: "100%",
                height: "80px",
                display: "block",
                objectFit: "cover",
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
            },
            text: {
                position: "absolute",
                transform: "translate(-50%, -50%)",
                top: "50%",
                left: "50%",
                zIndex: 1,
                fontSize: 1,
                textAlign: "center"
            }
        }
    };
    this.play = {
        color: "white",
        position: "absolute",
        width: "38px",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)"
    };
}());

;// CONCATENATED MODULE: ./src/sections/Product/Main/Media/Thumbs/Thumbs.jsx








var Thumbs = Thumbs_theme_themed(function(param) {
    var theme = param.theme, medias = param.medias, activeIndex = param.activeIndex, goToSlide = param.goToSlide;
    var ref = (0,react.useState)(), swiper = ref[0], setSwiper = ref[1];
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": Thumbs.displayName,
        sx: theme.thumbs,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(react_swiper/* Swiper */.t, {
                onSwiper: setSwiper,
                slidesPerView: 5,
                direction: "vertical",
                spaceBetween: 12,
                preventClicksPropagation: false,
                preventClicks: false,
                watchOverflow: true,
                grabCursor: (medias === null || medias === void 0 ? void 0 : medias.length) > 5,
                breakpoints: {
                    1280: {
                        slidesPerView: 6,
                        grabCursor: (medias === null || medias === void 0 ? void 0 : medias.length) > 6
                    }
                },
                sx: theme.swiper,
                children: medias === null || medias === void 0 ? void 0 : medias.map(function(media, index) {
                    var ref;
                    var isActive = activeIndex === index;
                    var image = (media === null || media === void 0 ? void 0 : media.image) || (media === null || media === void 0 ? void 0 : (ref = media.preview) === null || ref === void 0 ? void 0 : ref.image);
                    var isVideo = (media === null || media === void 0 ? void 0 : media.mediaContentType) === "VIDEO";
                    var src = image === null || image === void 0 ? void 0 : image.originalSrc;
                    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(swiper_slide/* SwiperSlide */.o, {
                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                            "data-comp": "Thumb",
                            onClick: function() {
                                return goToSlide(index);
                            },
                            role: "button",
                            tabIndex: "0",
                            "aria-label": "Go to ".concat(media.alt || "image ".concat(index + 1)),
                            onKeyDown: function(e) {
                                if (e.key === "Enter" || e.key === " ") {
                                    e.preventDefault();
                                    goToSlide(index);
                                }
                            },
                            sx: (0,_object_spread/* default */.Z)({}, theme.thumb, isActive ? theme.thumb.active : theme.thumb.inactive),
                            children: [
                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Picture */.t, {
                                    alt: media.alt,
                                    width: 156,
                                    height: 156,
                                    images: [
                                        {
                                            src: src,
                                            ratio: 1,
                                            width: 100
                                        }
                                    ]
                                }),
                                isVideo && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Svg */.ny, {
                                    alt: "play",
                                    src: "/svgs/play.svg#play",
                                    viewBox: "0 0 38 38",
                                    sx: theme.play
                                })
                            ]
                        })
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(ThumbsNavigation, {
                swiper: swiper,
                count: (medias === null || medias === void 0 ? void 0 : medias.length) || 0
            })
        ]
    });
});
Thumbs.displayName = "Thumbs";

;// CONCATENATED MODULE: ./src/sections/Product/Main/Media/Thumbs/index.js


;// CONCATENATED MODULE: ./src/sections/Product/Main/Media/Media.theme.js

var Media_theme_themed = (0,create/* create */.U)(new function() {
    this.medias = {
        width: "100%",
        alignSelf: "flex-start",
        justifySelf: "flex-end",
        display: "flex",
        position: [
            "relative",
            null,
            "sticky"
        ],
        top: [
            "initial",
            null,
            "calc(var(--header-height, 0px) + 10px)"
        ]
    };
    this.swiper = {
        flex: 1,
        position: "relative"
    };
    this.slide = {
        m: 0,
        outline: "none"
    };
    this.bullets = {
        mt: 6,
        display: [
            "flex",
            null,
            "none"
        ],
        justifyContent: "center",
        gap: 9,
        width: "100%",
        height: "8px",
        ".swiper-pagination-bullet-active": {
            bg: "text"
        },
        ".swiper-pagination-bullet": {
            cursor: "pointer"
        }
    };
}());

;// CONCATENATED MODULE: ./src/sections/Product/Main/Media/Media.jsx











var Media = Media_theme_themed(function(param) {
    var theme = param.theme, aboveTheFold = param.aboveTheFold, preload = param.preload;
    var ref = useProductContext(), product = ref.product, selectedOptions = ref.selectedOptions, selectedVariant = ref.selectedVariant, selectedMedia = ref.selectedMedia;
    var ref1 = (0,react.useState)(0), activeIndex = ref1[0], setActiveIndex = ref1[1];
    var ref2 = (0,react.useState)(), swiper = ref2[0], setSwiper = ref2[1];
    var goToSlide = (0,react.useCallback)(function(index) {
        swiper.slideTo(index);
        setActiveIndex(index);
    }, [
        swiper
    ]);
    (0,react.useEffect)(function() {
        if (!swiper || !swiper.initialized) return undefined;
        var handleSlideChange = function(_swiper) {
            setActiveIndex(_swiper.realIndex);
        };
        swiper.on("slideChange", handleSlideChange);
        return function() {
            swiper.off("slideChange", handleSlideChange);
        };
    }, [
        swiper
    ]);
    // on color swatch change go back to first slide
    (0,react.useEffect)(function() {
        var ref;
        if (!swiper || !swiper.initialized) return;
        if (!product) return;
        if (product.isGrouped) {
            swiper.slideTo(0);
            return;
        }
        var variantImageIndex = (ref = product.media) === null || ref === void 0 ? void 0 : ref.findIndex(function(param) {
            var image = param.image;
            var ref;
            return (image === null || image === void 0 ? void 0 : image.id) === (selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref = selectedVariant.image) === null || ref === void 0 ? void 0 : ref.id);
        });
        if (variantImageIndex >= 0) {
            swiper.slideTo(variantImageIndex);
        }
    }, [
        selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.Color,
        product === null || product === void 0 ? void 0 : product.id,
        swiper
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": Media.displayName,
        sx: theme.medias,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Thumbs, {
                medias: selectedMedia,
                activeIndex: activeIndex,
                goToSlide: goToSlide
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                sx: {
                    position: "relative",
                    flex: 1,
                    pb: [
                        10,
                        null,
                        0
                    ]
                },
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(react_swiper/* Swiper */.t, {
                        "data-comp": "MediaSwiper",
                        modules: [
                            navigation/* default */.Z,
                            scrollbar/* default */.Z,
                            a11y/* default */.Z
                        ],
                        pagination: {
                            el: ".swiper-pagination",
                            type: "bullets",
                            clickable: true
                        },
                        preloadImages: true,
                        fadeEffect: {
                            crossFade: true
                        },
                        onSwiper: setSwiper,
                        slidesPerView: 1,
                        freeMode: false,
                        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.swiper), {
                            cursor: (selectedMedia === null || selectedMedia === void 0 ? void 0 : selectedMedia.length) > 1 ? "grab" : "auto"
                        }),
                        watchOverflow: true,
                        children: selectedMedia === null || selectedMedia === void 0 ? void 0 : selectedMedia.map(function(media, index) {
                            var isPrimaryIamge = index === 0 && aboveTheFold;
                            return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(swiper_slide/* SwiperSlide */.o, {
                                virtualIndex: index,
                                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* ShopifyMedia */.WN, {
                                    media: media,
                                    bgColor: "lightGray",
                                    aboveTheFold: isPrimaryIamge,
                                    preload: isPrimaryIamge
                                })
                            }, index);
                        })
                    }),
                    !swiper && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                        sx: {
                            width: "100%",
                            pb: "100%",
                            position: "absolute",
                            top: 0,
                            left: 0,
                            bg: "lightGray",
                            zIndex: 1
                        }
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Badge */.Ct, {
                        handle: product === null || product === void 0 ? void 0 : product.handle,
                        product: product,
                        isPdp: true
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                        as: "div",
                        className: "swiper-pagination",
                        sx: theme.bullets
                    })
                ]
            })
        ]
    });
});
Media.displayName = "Media";

;// CONCATENATED MODULE: ./src/sections/Product/Main/Media/index.js


// EXTERNAL MODULE: ./src/templates/product/Main/Details/Personalize/index.js + 3 modules
var Personalize = __webpack_require__(13542);
;// CONCATENATED MODULE: ./src/sections/Product/Main/Details/Options/Option/Option.theme.js

var Option_theme_themed = (0,create/* create */.U)(new function() {
    this.option = {
        mt: 0,
        pb: 10,
        width: "100%",
        borderBottom: function(t) {
            return "1px solid ".concat(t.colors.gray);
        }
    };
    this.header = {
        variant: "flex.row.start.center",
        mt: 10,
        mb: 3
    };
    this.name = {
        variant: "text.label.1",
        mr: 4
    };
    this.selectedOption = {
        color: "mediumDarkGray"
    };
    this.values = {
        variant: "flex.row.start",
        flexWrap: "wrap",
        flexBasis: "100%",
        mr: "auto",
        gap: 4,
        pl: 0
    };
    this.value = {
        px: 5,
        alignItems: "center",
        cursor: "pointer",
        display: "flex",
        justifyContent: "center",
        height: "40px",
        minWidth: "64px",
        borderRadius: "44px",
        position: "relative",
        transition: "all 0.15s ease-in-out",
        ":hover": {
            border: function(t) {
                return "1px solid ".concat(t.colors.mediumDarkGray);
            }
        },
        available: {
            selected: {
                border: function(t) {
                    return "1px solid ".concat(t.colors.text);
                },
                bg: "background",
                color: "text"
            },
            unselected: {
                border: function(t) {
                    return "1px solid ".concat(t.colors.gray);
                },
                bg: "background",
                color: "text"
            }
        },
        unavailable: {
            selected: {
                border: function(t) {
                    return "1px solid ".concat(t.colors.mediumDarkGray);
                },
                bg: "background",
                color: "mediumDarkGray"
            },
            unselected: {
                border: function(t) {
                    return "1px solid ".concat(t.colors.gray);
                },
                bg: "background",
                color: "mediumGray"
            }
        }
    };
}());

;// CONCATENATED MODULE: ./src/sections/Product/Main/Details/Options/Option/Option.jsx







var Option = Option_theme_themed(function(param) {
    var theme = param.theme, options = param.options, optionName = param.optionName;
    var ref;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useSelectedOptions */.C)(), 2), selectedOptions = ref1[0], setSelectedOptions = ref1[1];
    var selectedOptionIsAvailable = (0,hooks/* useSelectedOptionIsAvailable */.gf)();
    var selectedOption = selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions[optionName];
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": "".concat(Option.displayName, "-").concat(optionName),
        sx: theme.option,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                sx: theme.header,
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                        sx: theme.name,
                        children: optionName
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                        sx: theme.selectedOption,
                        children: selectedOption
                    })
                ]
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                as: "ul",
                sx: theme.values,
                children: (ref = options[optionName]) === null || ref === void 0 ? void 0 : ref.map(function(value) {
                    var isSelected = (selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions[optionName]) === value;
                    var isAvailable = selectedOptionIsAvailable((0,_define_property/* default */.Z)({}, optionName, value));
                    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                        as: "li",
                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                            variant: "buttons.plain",
                            onClick: function() {
                                setSelectedOptions((0,_define_property/* default */.Z)({}, optionName, value));
                            },
                            sx: (0,_object_spread/* default */.Z)({}, theme.value, isAvailable ? isSelected ? theme.value.available.selected : theme.value.available.unselected : isSelected ? theme.value.unavailable.selected : theme.value.unavailable.unselected),
                            children: value
                        })
                    }, value);
                })
            })
        ]
    });
});
Option.displayName = "Option";

;// CONCATENATED MODULE: ./src/sections/Product/Main/Details/Options/Option/index.js


;// CONCATENATED MODULE: ./src/sections/Product/Main/Details/Options/Options.theme.js

var Options_theme_themed = (0,create/* create */.U)(new function() {
    this.options = {
        variant: "flex.column",
        width: "100%"
    };
}());

;// CONCATENATED MODULE: ./src/sections/Product/Main/Details/Options/Options.jsx




var Options = Options_theme_themed(function(param) {
    var theme = param.theme, options = param.options, handle = param.handle, image = param.image;
    var ref;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
        "data-comp": Options.displayName,
        sx: theme.options,
        children: options && ((ref = Object.keys(options)) === null || ref === void 0 ? void 0 : ref.map(function(optionName, index) {
            // Each option group. e.g Sizes, Colors..
            var option = options[optionName];
            if ((option === null || option === void 0 ? void 0 : option.length) < 2 || (option === null || option === void 0 ? void 0 : option[0]) === "Default Title") return null;
            return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Option, {
                optionName: optionName,
                index: index,
                options: options,
                handle: handle,
                image: image
            }, optionName);
        }))
    });
});
Options.displayName = "Options";

;// CONCATENATED MODULE: ./src/sections/Product/Main/Details/Options/index.js


;// CONCATENATED MODULE: ./src/sections/Product/Main/Details/SizeOptions/SizeOptions.theme.js

var SizeOptions_theme_themed = (0,create/* create */.U)(new function() {
    this.option = {
        mt: 0,
        pb: 10,
        width: "100%",
        borderBottom: function(t) {
            return "1px solid ".concat(t.colors.gray);
        }
    };
    this.header = {
        variant: "flex.row.start.center",
        mt: 0,
        mb: 3
    };
    this.name = {
        variant: "text.label.1",
        mr: 4
    };
    this.size = {
        color: "mediumDarkGray"
    };
    this.values = {
        variant: "flex.row.start",
        flexWrap: "wrap",
        flexBasis: "100%",
        mr: "auto",
        gap: 4,
        pl: 0
    };
    this.value = {
        px: 5,
        alignItems: "center",
        cursor: "pointer",
        display: "flex",
        justifyContent: "center",
        height: "40px",
        minWidth: "64px",
        borderRadius: "44px",
        position: "relative",
        transition: "all 0.15s ease-in-out",
        ":hover": {
            border: function(t) {
                return "1px solid ".concat(t.colors.mediumDarkGray);
            }
        },
        available: {
            selected: {
                border: function(t) {
                    return "1px solid ".concat(t.colors.text);
                },
                bg: "background",
                color: "text"
            },
            unselected: {
                border: function(t) {
                    return "1px solid ".concat(t.colors.gray);
                },
                bg: "background",
                color: "text"
            }
        }
    };
}());

;// CONCATENATED MODULE: ./src/sections/Product/Main/Details/SizeOptions/SizeOptions.jsx







var SizeOptions = SizeOptions_theme_themed(function(param) {
    var theme = param.theme, product = param.product;
    var ref;
    var setInitialProductHandle = useProductContext().setInitialProductHandle;
    var options = product === null || product === void 0 ? void 0 : (ref = product.toggles) === null || ref === void 0 ? void 0 : ref.size;
    var selectedSize = (0,react.useMemo)(function() {
        var ref, ref1;
        return ((ref1 = product === null || product === void 0 ? void 0 : (ref = product.title) === null || ref === void 0 ? void 0 : ref.split("|")[2]) === null || ref1 === void 0 ? void 0 : ref1.trim()) || null;
    }, [
        product === null || product === void 0 ? void 0 : product.id
    ]);
    return (options === null || options === void 0 ? void 0 : options.length) ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": SizeOptions.displayName,
        sx: theme.option,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                sx: theme.header,
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                        sx: theme.name,
                        children: "Size"
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                        sx: theme.size,
                        children: selectedSize
                    })
                ]
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                as: "ul",
                sx: theme.values,
                children: options.map(function(param) {
                    var title = param.title, handle = param.handle, url = param.url;
                    var isSelected = product.handle === handle;
                    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                        as: "li",
                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                            variant: "buttons.plain",
                            onClick: function() {
                                return setInitialProductHandle(handle);
                            },
                            sx: (0,_object_spread/* default */.Z)({}, theme.value, isSelected ? theme.value.available.selected : theme.value.available.unselected),
                            children: title
                        })
                    }, handle);
                })
            })
        ]
    }) : null;
});
SizeOptions.displayName = "SizeOptions";

;// CONCATENATED MODULE: ./src/sections/Product/Main/Details/SizeOptions/index.js


;// CONCATENATED MODULE: ./src/sections/Product/Main/Details/ColorOptions/ColorOptions.theme.js

var ColorOptions_ColorOptions_theme_themed = (0,create/* create */.U)(new function() {
    this.option = {
        mt: 0,
        pb: 6,
        width: "100%",
        borderBottom: function(t) {
            return "1px solid ".concat(t.colors.gray);
        }
    };
    this.header = {
        variant: "flex.row.start.center",
        mt: 8,
        mb: 5
    };
    this.name = {
        variant: "text.label.1",
        mr: 4
    };
    this.color = {
        color: "mediumDarkGray"
    };
    this.values = function(totalSquares) {
        return {
            display: "grid",
            pl: 0,
            mr: "auto",
            gap: 6,
            gridTemplateColumns: "repeat(".concat(totalSquares, ", calc((").concat(1 / totalSquares, " * 100%) - (").concat(totalSquares - 1, " * 12px / ").concat(totalSquares, ")))"),
            width: "100%",
            maxWidth: "".concat(64 * totalSquares + (totalSquares - 1) * 12, "px")
        };
    };
    this.colorOptionWrapper = {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%"
    };
    this.value = {
        p: 4,
        alignItems: "center",
        display: "flex",
        justifyContent: "center",
        fontSize: "12px",
        width: "100%",
        borderRadius: "4px",
        position: "relative",
        transition: "all 0.15s ease-in-out",
        ":hover": {
            color: "mediumDarkGray",
            border: function(t) {
                return "1px solid ".concat(t.colors.mediumDarkGray);
            },
            '[data-comp="Picture"]': {
                opacity: 1
            }
        },
        available: {
            selected: {
                border: function(t) {
                    return "1px solid ".concat(t.colors.text);
                },
                bg: "background",
                color: "text"
            },
            unselected: {
                border: function(t) {
                    return "1px solid ".concat(t.colors.gray);
                },
                bg: "background",
                color: "text"
            }
        },
        unavailable: {
            selected: {
                border: function(t) {
                    return "1px solid ".concat(t.colors.text);
                },
                bg: "background",
                color: "text"
            },
            unselected: {
                border: function(t) {
                    return "1px solid ".concat(t.colors.gray);
                },
                bg: "background",
                color: "gray"
            }
        }
    };
    this.colorName = {
        fontSize: "9px",
        lineHeight: "11px",
        textAlign: "center",
        mt: 2,
        color: "text",
        fontWeight: "normal",
        width: "100%",
        maxWidth: "60px",
        overflow: "hidden",
        display: "-webkit-box",
        WebkitLineClamp: 2,
        WebkitBoxOrient: "vertical",
        wordBreak: "normal",
        overflowWrap: "break-word",
        hyphens: "auto"
    };
    this.seeAllWrapper = {
        position: "relative",
        pb: "100%"
    };
    this.seeAll = {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        borderRadius: "4px",
        mb: 6,
        p: 4,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        border: function(t) {
            return "1px solid ".concat(t.colors.gray);
        },
        bg: "background",
        color: "text",
        transition: "all 0.15s ease-in-out",
        ":hover": {
            border: function(t) {
                return "1px solid ".concat(t.colors.mediumDarkGray);
            }
        },
        icon: {
            width: "20px",
            color: "text"
        },
        text: {
            fontSize: "10px",
            lineHeight: "12px"
        }
    };
    this.tabs = {
        display: "flex",
        gap: 0,
        mt: 8,
        mb: 4,
        borderBottom: function(t) {
            return "1px solid ".concat(t.colors.gray);
        }
    };
    this.tab = {
        px: 0,
        py: 3,
        mr: 8,
        bg: "transparent",
        border: "none",
        borderBottom: "2px solid transparent",
        color: "mediumDarkGray",
        fontSize: "14px",
        fontWeight: "450",
        cursor: "pointer",
        transition: "all 0.15s ease-in-out",
        ":hover": {
            color: "text"
        },
        active: {
            color: "text",
            borderBottomColor: "text",
            fontWeight: "500"
        }
    };
    this.colorGrid = {
        display: "grid",
        pl: 0,
        gap: 6,
        gridTemplateColumns: "repeat(auto-fill, minmax(54px, 1fr))",
        width: "100%",
        maxWidth: "100%"
    };
}());

;// CONCATENATED MODULE: ./src/sections/Product/Main/Details/ColorOptions/ColorOption.jsx









var ColorOption_ColorOption = ColorOptions_ColorOptions_theme_themed(function(param) {
    var theme = param.theme, handle = param.handle, selectedColor = param.selectedColor, setSelectedOptions = param.setSelectedOptions, _isGrouped = param.isGrouped, isGrouped = _isGrouped === void 0 ? false : _isGrouped, tmp = param.inventory, initialInventory = tmp === void 0 ? {} : tmp;
    var product = (0,dist.useProductByHandle)({
        handle: handle
    }).product;
    var color = (0,react.useMemo)(function() {
        var ref, ref1, ref2;
        if (!product) return null;
        return (ref2 = (ref1 = product === null || product === void 0 ? void 0 : (ref = product.tags) === null || ref === void 0 ? void 0 : ref.find(function(tag) {
            return tag.match(/color::/gi);
        })) === null || ref1 === void 0 ? void 0 : ref1.split("::")[1]) === null || ref2 === void 0 ? void 0 : ref2.trim();
    }, [
        product === null || product === void 0 ? void 0 : product.id
    ]);
    var firstImage = (0,react.useMemo)(function() {
        var ref, ref1;
        return (ref1 = product === null || product === void 0 ? void 0 : (ref = product.media) === null || ref === void 0 ? void 0 : ref.find(function(item) {
            return item.mediaContentType === "IMAGE";
        })) === null || ref1 === void 0 ? void 0 : ref1.image;
    }, [
        product === null || product === void 0 ? void 0 : product.id
    ]);
    var isSelected = color === selectedColor;
    var _ref = (initialInventory === null || initialInventory === void 0 ? void 0 : initialInventory.id) ? {
        inventory: initialInventory,
        finished: true
    } : (0,dist.useProductInventoryByHandle)({
        handle: product === null || product === void 0 ? void 0 : product.handle,
        withQuantity: true
    }), inventory = _ref.inventory, inventoryStatus = (0,_object_without_properties/* default */.Z)(_ref, [
        "inventory"
    ]);
    var isGiftCard = (inventory === null || inventory === void 0 ? void 0 : inventory.handle) === "brumate-e-gift-card" || (product === null || product === void 0 ? void 0 : product.handle) === "brumate-e-gift-card";
    var isSoldOut = (0,react.useMemo)(function() {
        if (!(inventoryStatus === null || inventoryStatus === void 0 ? void 0 : inventoryStatus.finished)) return false;
        return !inventory || !inventory.availableForSale && !isGiftCard;
    }, [
        inventory,
        inventoryStatus
    ]);
    var selectedStyles = (0,react.useMemo)(function() {
        if (isSoldOut && isGrouped) {
            return isSelected ? theme.value.unavailable.selected : theme.value.unavailable.unselected;
        }
        return isSelected ? theme.value.available.selected : theme.value.available.unselected;
    }, [
        isSelected,
        isSoldOut,
        isGrouped
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
        as: "li",
        "data-comp": ColorOption_ColorOption.displayName,
        sx: theme.colorOptionWrapper,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                "aria-label": color,
                variant: "buttons.plain",
                onClick: function() {
                    setSelectedOptions(function(prev) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                            color: color
                        });
                    });
                },
                sx: (0,_object_spread/* default */.Z)({}, theme.value, selectedStyles || {}),
                style: isSoldOut && isGrouped ? {
                    background: "linear-gradient(to top left, transparent 0%, transparent calc(50% - 1px), currentColor 50%, transparent calc(50% + 1px), transparent 100%)"
                } : {},
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Picture */.t, {
                    alt: color,
                    width: 130,
                    height: 130,
                    images: [
                        {
                            src: firstImage === null || firstImage === void 0 ? void 0 : firstImage.originalSrc,
                            ratio: 1,
                            width: 54
                        }, 
                    ],
                    sx: {
                        opacity: isSoldOut && !isSelected && isGrouped ? 0.4 : 1,
                        zIndex: isSoldOut && isGrouped ? -1 : 0
                    }
                })
            }),
            color && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                sx: theme.colorName,
                children: color
            })
        ]
    });
});
ColorOption_ColorOption.displayName = "ColorOption";

;// CONCATENATED MODULE: ./src/sections/Product/Main/Details/ColorOptions/ColorOptions.jsx









// Enhanced ColorOption that includes badge information
function ColorOptionWithBadge(param) {
    var handle = param.handle, selectedColor = param.selectedColor, setSelectedOptions = param.setSelectedOptions, inventory = param.inventory, activeTab = param.activeTab, onCategoryDetected = param.onCategoryDetected;
    var product = (0,dist.useProductByHandle)({
        handle: handle
    }).product;
    var isLimitedEdition = (0,react.useMemo)(function() {
        var ref;
        return product === null || product === void 0 ? void 0 : (ref = product.tags) === null || ref === void 0 ? void 0 : ref.some(function(tag) {
            return tag.toLowerCase().includes("badge::limited edition");
        });
    }, [
        product === null || product === void 0 ? void 0 : product.tags
    ]);
    var isPersonalized = (0,react.useMemo)(function() {
        var ref;
        return product === null || product === void 0 ? void 0 : (ref = product.tags) === null || ref === void 0 ? void 0 : ref.some(function(tag) {
            return tag.toLowerCase().includes("personalized-enabled");
        });
    }, [
        product === null || product === void 0 ? void 0 : product.tags
    ]);
    // Report category to parent when product data is loaded
    (0,react.useEffect)(function() {
        if (product && onCategoryDetected) {
            onCategoryDetected(handle, {
                isLimitedEdition: isLimitedEdition,
                isPersonalized: isPersonalized,
                isCore: !isLimitedEdition
            });
        }
    }, [
        product,
        handle,
        isLimitedEdition,
        isPersonalized,
        onCategoryDetected
    ]);
    // Filter logic
    var shouldShow = (0,react.useMemo)(function() {
        if (activeTab === "all") return true;
        if (activeTab === "limited") return isLimitedEdition;
        if (activeTab === "personalize") return isPersonalized;
        if (activeTab === "core") return !isLimitedEdition;
        return true;
    }, [
        activeTab,
        isLimitedEdition,
        isPersonalized
    ]);
    if (!shouldShow) return null;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(ColorOption_ColorOption, {
        handle: handle,
        selectedColor: selectedColor,
        setSelectedOptions: setSelectedOptions,
        isGrouped: true,
        inventory: inventory
    });
}
var ColorOptions_ColorOptions = ColorOptions_ColorOptions_theme_themed(function(param) {
    var theme = param.theme;
    var ref;
    var ref1 = useProductContext(), product = ref1.product, selectedOptions = ref1.selectedOptions, setSelectedOptions = ref1.setSelectedOptions, selectedVariant = ref1.selectedVariant;
    var ref2 = (0,react.useState)("all"), activeTab = ref2[0], setActiveTab = ref2[1];
    var selectedColor = selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.color;
    var handles = product === null || product === void 0 ? void 0 : (ref = product.groupOptionsMap) === null || ref === void 0 ? void 0 : ref.handle;
    var handlesWithInventory = (0,hooks/* useProductInventoryByHandles */.$E)({
        handles: handles
    }) || [];
    // Track product categories as they're detected
    var ref3 = (0,react.useState)(new Set()), detectedCategories = ref3[0], setDetectedCategories = ref3[1];
    // Handle category detection from child components
    var handleCategoryDetected = (0,react.useMemo)(function() {
        var detectedHandles = new Set();
        return function(handle, categories) {
            if (detectedHandles.has(handle)) return; // Prevent duplicate counting
            detectedHandles.add(handle);
            setDetectedCategories(function(prev) {
                var newCategories = new Set(prev);
                if (categories.isLimitedEdition) newCategories.add("limited");
                if (categories.isPersonalized) newCategories.add("personalize");
                if (categories.isCore) newCategories.add("core");
                return newCategories;
            });
        };
    }, []);
    // Define all possible tabs
    var allTabs = [
        {
            id: "all",
            label: "All"
        },
        {
            id: "limited",
            label: "Limited Edition"
        },
        {
            id: "core",
            label: "Core"
        }, 
    ];
    // Filter tabs to only show those with products (always show 'all' if there are any products)
    var visibleTabs = allTabs.filter(function(tab) {
        if (tab.id === "all") return handlesWithInventory.length > 0;
        return detectedCategories.has(tab.id);
    });
    // Reset to 'all' tab if current tab becomes invisible
    (0,react.useEffect)(function() {
        if (visibleTabs.length > 0 && !visibleTabs.some(function(tab) {
            return tab.id === activeTab;
        })) {
            setActiveTab("all");
        }
    }, [
        visibleTabs,
        activeTab
    ]);
    return (product === null || product === void 0 ? void 0 : product.isGrouped) && (handlesWithInventory === null || handlesWithInventory === void 0 ? void 0 : handlesWithInventory.length) ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": ColorOptions_ColorOptions.displayName,
        sx: theme.option,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                sx: theme.tabs,
                children: visibleTabs.map(function(tab) {
                    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                        variant: "buttons.plain",
                        onClick: function() {
                            return setActiveTab(tab.id);
                        },
                        sx: (0,_object_spread/* default */.Z)({}, theme.tab, activeTab === tab.id ? theme.tab.active : {}),
                        children: tab.label
                    }, tab.id);
                })
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                as: "ul",
                sx: theme.colorGrid,
                children: handlesWithInventory.map(function(handle) {
                    var ref, ref1;
                    /*#__PURE__*/ return (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(ColorOptionWithBadge, {
                        handle: handle === null || handle === void 0 ? void 0 : (ref = handle.inventory) === null || ref === void 0 ? void 0 : ref.handle,
                        selectedColor: selectedColor,
                        setSelectedOptions: setSelectedOptions,
                        inventory: handle === null || handle === void 0 ? void 0 : handle.inventory,
                        activeTab: activeTab,
                        onCategoryDetected: handleCategoryDetected
                    }, handle === null || handle === void 0 ? void 0 : (ref1 = handle.inventory) === null || ref1 === void 0 ? void 0 : ref1.handle);
                })
            })
        ]
    }) : null;
});
ColorOptions_ColorOptions.displayName = "ColorOptions";

;// CONCATENATED MODULE: ./src/sections/Product/Main/Details/ColorOptions/index.js


;// CONCATENATED MODULE: ./src/sections/Product/Main/Details/AddToCart/AddToCart.theme.js

var AddToCart_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        display: "flex",
        alignItems: "center",
        width: "100%",
        gap: 11
    };
    // todo: nested variants should really be button variants that modify primary
    // so that they can be used through a project and not just here
    this.button = {
        variant: "primary",
        flex: 1,
        outline: "none",
        available: {
            cursor: "pointer",
            oneTime: {
                bg: "black"
            },
            subscribe: {
                border: function(t) {
                    return "1px solid ".concat(t.colors.dark);
                },
                bg: "dark",
                "&:hover": {
                    color: "dark"
                }
            }
        },
        unavailable: {
            // cursor: 'default',
            oneTime: {
                variant: "buttons.secondary",
                color: "mediumDarkGray"
            },
            subscribe: {
                bg: "gray",
                border: function(t) {
                    return "1px solid ".concat(t.colors.dark);
                },
                "&:hover": {
                    bg: "gray",
                    color: "background"
                }
            }
        }
    };
    this.quantityWrapper = {
        variant: "flex.row.start.center",
        mr: 0,
        "input::-webkit-outer-spin-button, input::-webkit-inner-spin-button": {
            WebkitAppearance: "none",
            margin: 0
        },
        "input[type=number]": {
            MozAppearance: "textfield"
        }
    };
    this.quantityButton = {
        cursor: "pointer",
        width: "32px",
        height: "32px",
        minWidth: "32px",
        borderRadius: "50%",
        border: function(t) {
            return "1px solid ".concat(t.colors.gray);
        },
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        transition: "all 0.15s ease-in-out",
        ":hover": {
            borderColor: "mediumDarkGray"
        }
    };
    this.buttonIcon = {
        width: "16px",
        color: "text"
    };
    this.quantity = {
        variant: "text.label.1",
        width: "34px",
        textAlign: "center",
        mx: 5
    };
    this.link = {
        position: "relative",
        display: "inline",
        pb: 1,
        backgroundImage: "linear-gradient(currentColor, currentColor)",
        backgroundPosition: "0% 100%",
        backgroundRepeat: "no-repeat",
        backgroundSize: "0% 1px",
        transition: "background-size 0.2s ease-in-out",
        ":hover, :focus": {
            backgroundSize: "100% 1px"
        }
    };
}());

;// CONCATENATED MODULE: ./src/sections/Product/Main/Details/AddToCart/QuantitySelector.jsx









var QuantitySelector = AddToCart_theme_themed(function(param) {
    var theme = param.theme, quantity = param.quantity, setQuantity = param.setQuantity, isMaxed = param.isMaxed, maxQty = param.maxQty, qtyInCart = param.qtyInCart;
    var ref = (0,react.useState)(null), updatedAt = ref[0], setUpdatedAt = ref[1];
    var ref1 = (0,react.useState)(false), isUpdating = ref1[0], setIsUpdating = ref1[1];
    var disabled = quantity <= 1;
    var handleDecrement = (0,react.useCallback)(function() {
        if (disabled || isUpdating) return;
        setQuantity(quantity - 1);
        setUpdatedAt(new Date());
        setIsUpdating(true);
        setTimeout(function() {
            return setIsUpdating(false);
        }, 700);
    }, [
        disabled,
        quantity,
        isUpdating
    ]);
    var handleIncrement = (0,react.useCallback)(function() {
        if (isMaxed || isUpdating) return;
        setQuantity(quantity + 1);
        setUpdatedAt(new Date());
        setIsUpdating(true);
        setTimeout(function() {
            return setIsUpdating(false);
        }, 700);
    }, [
        isMaxed,
        quantity,
        isUpdating
    ]);
    var handleInputChange = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            var typedQuantity, remainder;
            return (0,tslib_es6.__generator)(this, function(_state) {
                typedQuantity = parseInt(e.target.value, 10);
                if (!typedQuantity) {
                    setQuantity(quantity);
                } else if (typedQuantity < 1) {
                    setQuantity(1);
                } else if (typedQuantity + qtyInCart > maxQty) {
                    remainder = maxQty - qtyInCart;
                    setQuantity(remainder > 0 ? remainder : 1);
                } else {
                    setQuantity(typedQuantity);
                }
                setUpdatedAt(new Date());
                setIsUpdating(true);
                setTimeout(function() {
                    return setIsUpdating(false);
                }, 700);
                return [
                    2
                ];
            });
        });
        return function(e) {
            return _ref.apply(this, arguments);
        };
    }(), [
        quantity,
        maxQty,
        qtyInCart,
        setQuantity
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
        "data-comp": QuantitySelector.displayName,
        sx: theme.quantityWrapper,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                variant: "buttons.plain",
                onClick: handleDecrement,
                disabled: disabled || isUpdating,
                sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.quantityButton), {
                    cursor: disabled || isUpdating ? "default" : "pointer",
                    ":hover": {
                        borderColor: disabled || isUpdating ? "gray" : "mediumGray"
                    }
                }),
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Svg */.ny, {
                    viewBox: "0 0 48 48",
                    alt: "Decrease quantity",
                    src: "/svgs/minus.svg#minus",
                    loading: "lazy",
                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.buttonIcon), {
                        color: disabled || isUpdating ? "mediumDarkGray" : "text"
                    })
                })
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                sx: {
                    variant: "flex.row.center.center",
                    flex: 1,
                    mx: 2,
                    position: "relative",
                    height: "100%",
                    width: "44px"
                },
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                        as: theme_ui_components_esm/* Input */.II,
                        type: "number",
                        min: "1",
                        max: maxQty ? maxQty - qtyInCart : null,
                        name: "quantity",
                        tabIndex: "-1",
                        "aria-hidden": "true",
                        defaultValue: quantity,
                        onBlur: handleInputChange,
                        onKeyDown: function(e) {
                            if (e.key === "Enter") {
                                handleInputChange(e);
                            }
                        },
                        sx: {
                            visibility: isUpdating ? "hidden" : "visible",
                            fontSize: 4,
                            fontFamily: "body",
                            width: "100%",
                            height: "100%",
                            textAlign: "center",
                            p: 0,
                            bg: "transparent",
                            outline: "none",
                            borderStyle: "none",
                            ":focus, :hover": {
                                outline: "none !important"
                            },
                            "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
                                MozAppearance: "none",
                                margin: 0
                            },
                            MozAppearance: "textfield"
                        }
                    }, updatedAt),
                    isUpdating && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Spinner */.$j, {
                        sx: {
                            width: "20px",
                            color: "mediumGray",
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                variant: "buttons.plain",
                onClick: handleIncrement,
                disabled: isMaxed || isUpdating,
                sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.quantityButton), {
                    cursor: isMaxed || isUpdating ? "default" : "pointer",
                    ":hover": {
                        borderColor: isMaxed || isUpdating ? "gray" : "mediumGray"
                    }
                }),
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Svg */.ny, {
                    viewBox: "0 0 48 48",
                    alt: "Increase quantity",
                    src: "/svgs/plus.svg#plus",
                    loading: "lazy",
                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.buttonIcon), {
                        color: isMaxed || isUpdating ? "mediumDarkGray" : "text"
                    })
                })
            })
        ]
    });
});
QuantitySelector.displayName = "QuantitySelector";

;// CONCATENATED MODULE: ./src/sections/Product/Main/Details/AddToCart/useAddToCart.js
/* provided dependency */ var useAddToCart_process = __webpack_require__(14284);









var useAddToCart = function(param) {
    var selectedVariant = param.selectedVariant, product = param.product;
    var ref, ref1;
    var gotoSnapshot = (0,store/* useGotoRecoilSnapshot */.le)();
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useSelectedPlan */.JM)({
        selectedVariant: selectedVariant
    }), 1), selectedPlan = ref2[0];
    var _ref = (0,dist.useCartAddItem)(), cartAddItem = _ref.cartAddItem, addItemStatus = (0,_object_without_properties/* default */.Z)(_ref, [
        "cartAddItem"
    ]);
    var _ref1 = (0,dist.useProductInventoryByHandle)({
        handle: product === null || product === void 0 ? void 0 : product.handle,
        withQuantity: true
    }), inventory = _ref1.inventory, inventoryStatus = (0,_object_without_properties/* default */.Z)(_ref1, [
        "inventory"
    ]);
    // use live inventory data
    var variantStorefrontId = (0,src_utils/* isEncoded */.x)(inventory === null || inventory === void 0 ? void 0 : inventory.id) ? (0,src_utils/* getEncodedId */.m4)(selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.storefrontId) : selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.storefrontId;
    var variantInventory = inventory ? inventory === null || inventory === void 0 ? void 0 : (ref = inventory.variants) === null || ref === void 0 ? void 0 : ref[variantStorefrontId] : null;
    var GIFT_CARD_HANDLE = useAddToCart_process.env.APP_GIFT_CARD_HANDLE || "brumate-e-gift-card";
    var isGiftCard = (variantInventory === null || variantInventory === void 0 ? void 0 : (ref1 = variantInventory.product) === null || ref1 === void 0 ? void 0 : ref1.handle) === GIFT_CARD_HANDLE || (product === null || product === void 0 ? void 0 : product.handle) === GIFT_CARD_HANDLE;
    var isSoldOut = !variantInventory || variantInventory.quantityAvailable <= 0 && !isGiftCard;
    var isPreOrder = isSoldOut && (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.inventoryPolicy) === "CONTINUE";
    var toggleCartSidebar = (0,store/* useRecoilCallback */._8)(function(param) {
        var snapshot = param.snapshot;
        return /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var release, updatedState;
            return (0,tslib_es6.__generator)(this, function(_state) {
                release = snapshot.retain();
                try {
                    updatedState = snapshot.map(function(param) {
                        var set = param.set;
                        return set(store/* default.modal */.ZP.modal, null);
                    }).map(function(param) {
                        var set = param.set;
                        return set(store/* default.overlay */.ZP.overlay, true);
                    }).map(function(param) {
                        var set = param.set;
                        return set(store/* default.sidebar */.ZP.sidebar, "cart");
                    });
                    // update state
                    gotoSnapshot(updatedState);
                } finally{
                    release();
                }
                return [
                    2
                ];
            });
        });
    });
    // add oneTime and subs
    var addToCart = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var ref, _quantity, quantity, callback, _openCart, openCart, item, cart;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ref = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {
                        quantity: 1,
                        openCart: true
                    }, _quantity = ref.quantity, quantity = _quantity === void 0 ? 1 : _quantity, callback = ref.callback, _openCart = ref.openCart, openCart = _openCart === void 0 ? true : _openCart;
                    if (!selectedVariant || isSoldOut && !isPreOrder || typeof quantity !== "number") return [
                        2
                    ];
                    item = {
                        merchandiseId: selectedVariant.id,
                        quantity: quantity
                    };
                    // adds shipscout attribute to collect data for abtest
                    if (typeof window.ShipScoutLineItemProperty !== "undefined") {
                        item.attributes = [
                            {
                                key: "_sc",
                                value: window.ShipScoutLineItemProperty
                            }, 
                        ];
                    }
                    if (typeof window.ShipScoutTrackAddToCart === "function") {
                        window.ShipScoutTrackAddToCart();
                    }
                    // if selling plan is selected we the subscription
                    if (selectedPlan) {
                        item.sellingPlanId = selectedPlan.id;
                    }
                    return [
                        4,
                        cartAddItem(item)
                    ];
                case 1:
                    cart = _state.sent();
                    if (cart) {
                        if (typeof callback === "function") {
                            callback(cart);
                        }
                        if (openCart) {
                            toggleCartSidebar();
                        }
                    }
                    return [
                        2
                    ];
            }
        });
    }), [
        selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id,
        isSoldOut,
        isPreOrder,
        selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.id
    ]);
    return [
        {
            isPreOrder: isPreOrder,
            isSoldOut: isSoldOut,
            selectedPlan: selectedPlan,
            status: {
                addItem: addItemStatus,
                inventory: inventory,
                inventoryStatus: inventoryStatus
            }
        },
        {
            addToCart: addToCart,
            toggleCartSidebar: toggleCartSidebar
        }, 
    ];
};

// EXTERNAL MODULE: ./src/theme/index.js + 16 modules
var theme = __webpack_require__(30450);
;// CONCATENATED MODULE: ./src/sections/Product/Main/Header/AfterPay/AfterPay.theme.js

var AfterPay_theme_themed = (0,create/* create */.U)(new function() {
    this.afterpay = {
        variant: "flex.row.start.center",
        text: {
            color: "mediumDarkGray",
            fontSize: [
                3,
                4
            ],
            mb: 0
        },
        link: {
            ml: 2
        },
        pill: {
            width: [
                "56px",
                "62px"
            ],
            marginTop: "2px",
            borderRadius: "10px",
            bg: "#FFFFFF",
            position: "relative",
            overflow: "hidden"
        },
        logo: {
            width: [
                "56px",
                "62px"
            ]
        }
    };
}());

;// CONCATENATED MODULE: ./src/sections/Product/Main/Header/AfterPay/AfterPay.jsx






// export function AfterPay({ price, variantId, currency, themeSettings }) {
var AfterPay = AfterPay_theme_themed(function(param) {
    var themeSettings = param.theme, price = param.price, variantId = param.variantId, currency = param.currency;
    var ref = (0,react.useState)(false), mounted = ref[0], setMounted = ref[1];
    (0,react.useEffect)(function() {
        setMounted(true);
    }, [
        variantId
    ]);
    var handleClick = function(evt) {
        if (typeof Afterpay === "object") {
            evt.preventDefault();
            window.Afterpay.launchModal("en_US-theme-white");
        }
    };
    if (!mounted) return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
        className: "bg-background absolute inset-0 h-full bg-white"
    });
    return price >= 35 ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)("div", {
        className: "relative -mt-1 md:mt-0 flex items-baseline text-[#8C8C8D]",
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("afterpay-placement", {
                "data-locale": "en_US",
                "data-currency": currency || "USD",
                "data-amount": price,
                "data-modal-theme": "white",
                "data-logo-type": "compact-badge",
                "data-modal-link-style": "none",
                id: "after-pay",
                "data-intro-text": "Pay in"
            }),
            !mounted && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                className: "bg-background absolute inset-0 h-full bg-white"
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("style", {
                children: "afterpay-placement{\n            margin: 0;\n            color: ".concat(theme/* theme.colors.mediumDarkGray */.r.colors.mediumDarkGray, ";\n            --messaging-font-size: ").concat(theme/* theme.fontSizes.4 */.r.fontSizes[4], ";\n            --logo-badge-width: 62px;\n          }\n          @media (max-width: 767px) {\n            afterpay-placement{\n              --messaging-font-size: ").concat(theme/* theme.fontSizes.3 */.r.fontSizes[3], ";\n              --logo-badge-width: 56px;\n            }\n          }\n        ")
            })
        ]
    }) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_jsx_runtime_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                sx: themeSettings.afterpay.text,
                children: "Interest-free installments by"
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Link */.rU, {
                href: "https://www.afterpay.com/en-US/terms-of-service",
                newTab: true,
                sx: themeSettings.afterpay.link,
                onClick: handleClick,
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                    sx: themeSettings.afterpay.pill,
                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Svg */.ny, {
                        alt: "afterpay",
                        src: "/svgs/afterpay.svg",
                        viewBox: "0 0 98 24",
                        sx: themeSettings.afterpay.logo
                    })
                })
            })
        ]
    });
});

;// CONCATENATED MODULE: ./src/sections/Product/Main/Header/AfterPay/index.js


;// CONCATENATED MODULE: ./src/sections/Product/Main/Details/AddToCart/AddToCart.jsx














var AddToCart = AddToCart_theme_themed(function(param) {
    var theme = param.theme, product = param.product, selectedVariant = param.selectedVariant, rebuyProducts = param.rebuyProducts;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var gatedPage = (0,store/* useRecoilValue */.sJ)(store/* default.gatedPage */.ZP.gatedPage);
    var enableFullProductAccess = (0,hooks/* useGatedProduct */.sC)({
        product: product,
        gatedPage: gatedPage
    }).enableFullProductAccess;
    var productByHandle = (0,dist.useProductByHandle)({
        handle: selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref = selectedVariant.product) === null || ref === void 0 ? void 0 : ref.handle
    });
    var settings = (0,dist.useSettings)();
    var cart = (0,dist.useCart)();
    // logic to only show Rebuy mystery item once
    var hasMysteryItem = (0,react.useMemo)(function() {
        var ref;
        return cart === null || cart === void 0 ? void 0 : (ref = cart.lines) === null || ref === void 0 ? void 0 : ref.some(function(line) {
            var ref, ref1;
            return (line === null || line === void 0 ? void 0 : (ref = line.variant) === null || ref === void 0 ? void 0 : (ref1 = ref.product) === null || ref1 === void 0 ? void 0 : ref1.handle) === "mystery-item";
        });
    }, [
        cart === null || cart === void 0 ? void 0 : cart.updatedAt
    ]);
    var crossSells = rebuyProducts === null || rebuyProducts === void 0 ? void 0 : (ref1 = rebuyProducts.crossSells) === null || ref1 === void 0 ? void 0 : ref1.products;
    var upSells = rebuyProducts === null || rebuyProducts === void 0 ? void 0 : (ref2 = rebuyProducts.upSells) === null || ref2 === void 0 ? void 0 : ref2.products;
    if (hasMysteryItem) {
        crossSells = crossSells === null || crossSells === void 0 ? void 0 : crossSells.filter(function(_product) {
            return (_product === null || _product === void 0 ? void 0 : _product.handle) !== "mystery-item";
        });
        upSells = upSells === null || upSells === void 0 ? void 0 : upSells.filter(function(_product) {
            return (_product === null || _product === void 0 ? void 0 : _product.handle) !== "mystery-item";
        });
    }
    var ref7 = (0,_sliced_to_array/* default */.Z)(useAddToCart({
        product: productByHandle.product,
        selectedVariant: selectedVariant
    }), 2), ref8 = ref7[0], status = ref8.status, isSoldOut = ref8.isSoldOut, isPreOrder = ref8.isPreOrder, selectedPlan = ref8.selectedPlan, addToCart = ref7[1].addToCart;
    var _addItem = status.addItem, started = _addItem.started, finished = _addItem.finished, success = _addItem.success, errors = _addItem.errors;
    var ref9 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useModal */.dd)(), 2), openModal = ref9[1].openModal;
    var ref10 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useSidebar */.Ap)(), 2), openSidebar = ref10[1].openSidebar;
    var notifyMeText = (0,hooks/* useBreakpointValue */.Sx)([
        "Notify Me",
        "Notify Me When Available", 
    ]);
    var gwp = (0,hooks/* useGiftWithPurchase */.tG)();
    var ref11 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useCartStatus */.T0)(), 2), ref12 = ref11[1], setAddingToCartStatus = ref12.setAddingToCartStatus, setUpdatingCartStatus = ref12.setUpdatingCartStatus;
    var ref13 = (0,react.useState)(1), quantity = ref13[0], setQuantity = ref13[1];
    var ref14 = (0,react.useState)(false), isMaxed = ref14[0], setIsMaxed = ref14[1];
    var ref15 = (0,react.useState)(false), isOverMax = ref15[0], setIsOverMax = ref15[1];
    var ref16 = (0,react.useState)(0), qtyInCart = ref16[0], setQtyInCart = ref16[1];
    var ref17 = (settings === null || settings === void 0 ? void 0 : (ref3 = settings.cart) === null || ref3 === void 0 ? void 0 : ref3.bulkOrdering) || {}, maxQty = ref17.maxQty, _errorMessage = ref17.errorMessage, errorMessage = _errorMessage === void 0 ? "Please contact bulkorders@brumate.com for orders over 150." : _errorMessage, ignoredProducts = ref17.ignoredProducts;
    var cartItems = cart === null || cart === void 0 ? void 0 : cart.lines;
    var noBackInStockOption = isSoldOut && !isPreOrder && (product === null || product === void 0 ? void 0 : (ref4 = product.tags) === null || ref4 === void 0 ? void 0 : ref4.includes("no-bis"));
    var getText = function() {
        var ref;
        if (!product || (status === null || status === void 0 ? void 0 : (ref = status.inventoryStatus) === null || ref === void 0 ? void 0 : ref.started)) {
            return "Loading...";
        }
        if (noBackInStockOption) {
            return "Sold Out";
        }
        if (isSoldOut && !isPreOrder) {
            return notifyMeText;
        }
        if (isPreOrder) {
            return "Pre-order";
        }
        if (selectedPlan) {
            return "Subscribe";
        }
        return "Add to Bag";
    };
    var text = getText();
    var ignoredFromMaxQty = (0,react.useMemo)(function() {
        return ignoredProducts === null || ignoredProducts === void 0 ? void 0 : ignoredProducts.some(function(param) {
            var ignoredProduct = param.product;
            return ignoredProduct.handle === (product === null || product === void 0 ? void 0 : product.handle);
        });
    }, [
        product === null || product === void 0 ? void 0 : product.handle,
        ignoredProducts
    ]);
    var checkIfCartIsMaxedOnQtyChange = (0,react.useCallback)(function() {
        if (!maxQty) return false;
        var totalProductsInCart = (cartItems === null || cartItems === void 0 ? void 0 : cartItems.reduce(function(total, param) {
            var variant = param.variant, itemQty = param.quantity;
            if (ignoredProducts === null || ignoredProducts === void 0 ? void 0 : ignoredProducts.some(function(param) {
                var ignoredProduct = param.product;
                return ignoredProduct.handle === variant.product.handle;
            })) {
                return total;
            }
            return total + itemQty;
        }, 0)) || 0;
        setQtyInCart(totalProductsInCart);
        setIsMaxed(totalProductsInCart + quantity >= maxQty);
        setIsOverMax(totalProductsInCart + quantity > maxQty);
        return true;
    }, [
        quantity,
        maxQty,
        cart === null || cart === void 0 ? void 0 : cart.updatedAt,
        ignoredProducts
    ]);
    var setGlobalCartStatusOnAdding = (0,react.useCallback)(function() {
        setAddingToCartStatus({
            started: started,
            finished: finished,
            success: success,
            errors: errors
        });
        setUpdatingCartStatus({
            started: started,
            finished: finished,
            success: success,
            errors: errors
        });
        var defaultStatus = {
            started: false,
            finished: false,
            success: false,
            errors: []
        };
        return function() {
            setAddingToCartStatus(defaultStatus);
            setUpdatingCartStatus(defaultStatus);
        };
    }, [
        started,
        finished,
        success
    ]);
    var handleOutOfStock = (0,react.useCallback)(function() {
        openModal(/*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* BackInStockModal */.Yu, {
            legacyResourceId: selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.legacyResourceId,
            title: product === null || product === void 0 ? void 0 : product.title
        }));
    }, [
        selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id,
        product === null || product === void 0 ? void 0 : product.title
    ]);
    (0,react.useEffect)(function() {
        setGlobalCartStatusOnAdding();
    }, [
        started,
        finished,
        success
    ]);
    (0,react.useEffect)(function() {
        checkIfCartIsMaxedOnQtyChange();
    }, [
        quantity,
        maxQty,
        cart === null || cart === void 0 ? void 0 : cart.updatedAt,
        ignoredProducts
    ]);
    var isNotifyMe = isSoldOut && !isPreOrder;
    var overMaxDisabled = isOverMax && !isNotifyMe && !ignoredFromMaxQty;
    if (!enableFullProductAccess) return null;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
        sx: {
            mt: [
                10,
                13
            ],
            mb: [
                11,
                13
            ],
            width: "100%"
        },
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                "data-comp": AddToCart.displayName,
                sx: theme.wrapper,
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(QuantitySelector, {
                        quantity: quantity,
                        setQuantity: setQuantity,
                        isMaxed: isMaxed && !ignoredFromMaxQty,
                        maxQty: maxQty,
                        qtyInCart: qtyInCart
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* StatefulButton */.Lc, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        disabled: !product || overMaxDisabled || noBackInStockOption,
                        loading: !(status === null || status === void 0 ? void 0 : (ref5 = status.inventoryStatus) === null || ref5 === void 0 ? void 0 : ref5.finished) && (status === null || status === void 0 ? void 0 : (ref6 = status.inventoryStatus) === null || ref6 === void 0 ? void 0 : ref6.started),
                        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.button, isNotifyMe || overMaxDisabled || noBackInStockOption ? (0,_object_spread/* default */.Z)({}, theme.button.unavailable, selectedPlan ? theme.button.unavailable.subscribe : (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.button.unavailable.oneTime), {
                            borderColor: overMaxDisabled || noBackInStockOption ? "gray" : "text",
                            color: overMaxDisabled || noBackInStockOption ? "mediumGray" : "mediumDarkGray",
                            ":hover": {
                                borderColor: overMaxDisabled || noBackInStockOption ? "gray" : "text",
                                color: overMaxDisabled || noBackInStockOption ? "mediumGray" : "text",
                                bg: "background"
                            }
                        })) : (0,_object_spread/* default */.Z)({}, theme.button.available, selectedPlan ? theme.button.available.subscribe : theme.button.available.oneTime)), {
                            cursor: !product || overMaxDisabled || noBackInStockOption ? "default" : "pointer"
                        })
                    }, status.addItem), {
                        text: {
                            default: text,
                            started: "Adding",
                            success: "Added",
                            error: "Failed To Add"
                        },
                        onClick: function() {
                            if (isNotifyMe) {
                                handleOutOfStock();
                            } else {
                                addToCart({
                                    quantity: quantity,
                                    callback: function(_cart) {
                                        if (gwp.isEligible(_cart)) {
                                            openModal(/*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* GiftWithPurchase */.QT, {}));
                                        } else if ((crossSells === null || crossSells === void 0 ? void 0 : crossSells.length) || (upSells === null || upSells === void 0 ? void 0 : upSells.length)) {
                                            openModal(/*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* RebuyModal */.oI, {
                                                rebuyProducts: rebuyProducts,
                                                productHandle: product.handle
                                            }));
                                        } else {
                                            openSidebar("cart");
                                        }
                                    },
                                    openCart: false
                                });
                            }
                        }
                    })),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Favorite */.rF, {
                        selectedVariant: selectedVariant,
                        isPdp: true
                    })
                ]
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.afterpay), {
                    mt: [
                        "12px"
                    ],
                    justifyContent: "center",
                    alignItems: "center"
                }),
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(AfterPay, {
                    currency: selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.currencyCode,
                    variantId: selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.legacyResourceId,
                    price: selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.price
                })
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                sx: {
                    mt: [
                        "12px"
                    ],
                    justifyContent: "center",
                    alignItems: "center"
                },
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Link */.rU, {
                    href: "/products/".concat(product === null || product === void 0 ? void 0 : product.handle),
                    sx: (0,_object_spread/* default */.Z)({}, theme.link),
                    children: "View Full Details"
                })
            }),
            isMaxed && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Markdown */.UG, {
                text: errorMessage,
                sx: {
                    mt: 7,
                    a: {
                        textDecoration: "none"
                    }
                },
                textSx: {
                    variant: "text.label.2",
                    color: "red"
                }
            })
        ]
    });
});
AddToCart.displayName = "AddToCart";

;// CONCATENATED MODULE: ./src/sections/Product/Main/Details/AddToCart/index.js


;// CONCATENATED MODULE: ./src/sections/Product/Main/Details/Details.theme.js

var Details_Details_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        width: "100%",
        overflowX: "hidden"
    };
    this.sticky = {
        alignSelf: "flex-start",
        justifySelf: "flex-end",
        position: "sticky",
        pt: [
            11,
            null,
            0
        ],
        top: "calc(var(--header-height) + var(--promoBar-height) + 20px)",
        width: "100%",
        wrapper: {
            variant: "flex.column"
        }
    };
    this.ctas = {
        variant: "flex.column.start"
    };
}());

;// CONCATENATED MODULE: ./src/sections/Product/Main/Details/Upsells/Upsells.jsx






function Upsells(param) {
    var selectedVariant = param.selectedVariant;
    var ref, ref1;
    var settings = (0,dist.useSettings)();
    var ref2 = (settings === null || settings === void 0 ? void 0 : (ref = settings.product) === null || ref === void 0 ? void 0 : ref.upsells) || {}, heading = ref2.heading, products = ref2.products;
    var upsellProducts = (0,react.useMemo)(function() {
        var ref;
        var tags = selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref = selectedVariant.product) === null || ref === void 0 ? void 0 : ref.tags;
        var newUpsellHandles = tags === null || tags === void 0 ? void 0 : tags.reduce(function(carry, tag) {
            if (tag.indexOf("upsell::") > -1) {
                var ref = (0,_sliced_to_array/* default */.Z)(tag.split("::"), 3), handle = ref[1], order = ref[2];
                return (0,_to_consumable_array/* default */.Z)(carry).concat([
                    {
                        product: {
                            handle: handle,
                            order: order
                        }
                    }, 
                ]).sort(function(a, b) {
                    var ref, ref1;
                    return ((a === null || a === void 0 ? void 0 : (ref = a.product) === null || ref === void 0 ? void 0 : ref.order) || 0) - ((b === null || b === void 0 ? void 0 : (ref1 = b.product) === null || ref1 === void 0 ? void 0 : ref1.order) || 0);
                });
            }
            return carry;
        }, []);
        if (newUpsellHandles === null || newUpsellHandles === void 0 ? void 0 : newUpsellHandles.length) {
            return newUpsellHandles;
        }
        return products;
    }, [
        selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref1 = selectedVariant.product) === null || ref1 === void 0 ? void 0 : ref1.tags
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* ProductUpsellsList */.gW, {
        heading: heading,
        products: upsellProducts
    });
}
Upsells.displayName = "Upsells";

;// CONCATENATED MODULE: ./src/sections/Product/Main/Details/Upsells/index.js


;// CONCATENATED MODULE: ./src/sections/Product/Main/BuyWithPrime/BuyWithPrime.jsx


function BuyWithPrime(param) {
    var sku = param.sku;
    var ref = (0,react.useState)(0), count = ref[0], setCount = ref[1];
    (0,react.useEffect)(function() {
        if (true) {
            var js = window.document.createElement("script");
            js.src = "https://code.buywithprime.amazon.com/bwp.v1.js";
            js.type = "text/javascript";
            js.async = true;
            js.fetchPriority = "high";
            js.id = "bwpScript";
            document.head.appendChild(js);
        }
        return function() {
            var frame = document.getElementById("bwpFrame");
            if (frame && frame.parentNode) {
                frame.parentNode.removeChild(frame);
            }
            var script = document.getElementById("bwpScript");
            if (script && script.parentNode) {
                script.parentNode.removeChild(script);
            }
        };
    }, []);
    (0,react.useEffect)(function() {
        var attempts = 0;
        var timer = setInterval(function() {
            attempts++;
            if (attempts > 10) {
                clearInterval(timer);
                return;
            }
            if (typeof window.bwp === "object" && typeof window.bwp.updateWidget === "function" && sku && document.querySelector("#amzn-buy-now")) {
                clearInterval(timer);
                window.bwp.updateWidget(sku);
            }
        }, 500);
        return function() {
            return clearInterval(timer);
        };
    }, [
        sku
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)("div", {
        "data-prime-widget-sku": sku,
        className: "buy-with-prime-container m-auto w-full flex flex-col-reverse mb-6",
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                id: "amzn-buy-now",
                "data-site-id": "o3krsbin2k" || 0,
                "data-widget-id": "w-gfUDvYZJWj7eeyHQGn9uk6" || 0,
                "data-sku": sku
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                className: "or-separator",
                children: "OR"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/sections/Product/Main/BuyWithPrime/index.js


;// CONCATENATED MODULE: ./src/sections/Product/Main/Details/Details.jsx












var Details_Details = Details_Details_theme_themed(function(param) {
    var theme = param.theme, product = param.product, selectedVariant = param.selectedVariant, currentProduct = param.currentProduct, titles = param.titles, productUpsells = param.productUpsells, rebuyProducts = param.rebuyProducts;
    var ref, ref1;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Container */.W2, {
        "data-comp": Details_Details.displayName,
        sx: theme.wrapper,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
            "data-comp": "StickyContainer",
            sx: theme.sticky,
            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                sx: theme.sticky.wrapper,
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                        sx: {
                            display: [
                                "none",
                                null,
                                "block"
                            ]
                        },
                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Main_Header_Header_Header, {
                            selectedVariant: selectedVariant,
                            currentProduct: currentProduct,
                            titles: titles
                        })
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                        sx: {
                            display: [
                                "none",
                                null,
                                "block"
                            ]
                        },
                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Icons, {
                            product: currentProduct
                        })
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                        sx: theme.ctas,
                        children: [
                            (product === null || product === void 0 ? void 0 : product.optionsMap) && selectedVariant ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Options, {
                                options: product === null || product === void 0 ? void 0 : product.optionsMap,
                                handle: selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref = selectedVariant.product) === null || ref === void 0 ? void 0 : ref.handle,
                                image: selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref1 = selectedVariant.image) === null || ref1 === void 0 ? void 0 : ref1.originalSrc
                            }) : null,
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(SizeOptions, {
                                product: currentProduct
                            }),
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(ColorOptions_ColorOptions, {
                                product: product
                            }),
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(AddToCart, {
                                product: currentProduct,
                                selectedVariant: selectedVariant,
                                rebuyProducts: rebuyProducts
                            }),
                            (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.sku) ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(BuyWithPrime, {
                                sku: selectedVariant.sku
                            }) : null,
                            (productUpsells === null || productUpsells === void 0 ? void 0 : productUpsells.length) ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                                sx: {
                                    width: "100%"
                                },
                                children: productUpsells[0]
                            }) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Upsells, {
                                selectedVariant: selectedVariant
                            })
                        ]
                    })
                ]
            })
        })
    });
});
Details_Details.displayName = "ProductDetails";

;// CONCATENATED MODULE: ./src/sections/Product/Main/Details/index.js


;// CONCATENATED MODULE: ./src/sections/Product/Main/Main.theme.js

var Main_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        variant: "layout.content",
        gridTemplateColumns: [
            "1fr",
            null,
            ".58fr .42fr"
        ],
        columnGap: [
            0,
            null,
            12
        ],
        pt: [
            2,
            11,
            14
        ],
        width: "100%",
        mb: [
            8,
            null,
            10,
            12
        ],
        medias: {
            width: "100%",
            flexShrink: 0
        },
        details: {
            width: "100%",
            sticky: {
                alignSelf: "flex-start",
                justifySelf: "flex-end",
                position: "sticky",
                pt: 4,
                top: "calc(var(--header-height) + var(--promoBar-height) + 20px)",
                width: "100%",
                wrapper: {
                    variant: "flex.column"
                }
            }
        },
        metadata: {
            maxWidth: "100%",
            title: {
                text: "text.h2"
            },
            price: {
                text: "text.h2"
            },
            description: {
                mt: 3,
                lineHeight: "18px"
            }
        },
        ctas: {
            variant: "flex.column.start"
        }
    };
}());

;// CONCATENATED MODULE: ./src/sections/Product/Main/Main.jsx











var Main = Main_theme_themed(function(param) {
    var theme = param.theme, productUpsells = param.productUpsells, rebuyProducts = param.rebuyProducts, videoWise = param.videoWise;
    var ref, ref1;
    var ref2 = useProductContext(), product = ref2.product, selectedVariant = ref2.selectedVariant;
    var sendViewProductEvent = (0,hooks/* useDataLayerActions */.KZ)().sendViewProductEvent;
    var titles = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3;
        var titleArr = selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref = selectedVariant.product) === null || ref === void 0 ? void 0 : (ref1 = ref.title) === null || ref1 === void 0 ? void 0 : ref1.split("|");
        return {
            product: (titleArr === null || titleArr === void 0 ? void 0 : (ref2 = titleArr[0]) === null || ref2 === void 0 ? void 0 : ref2.trim()) || "",
            variant: ((ref3 = titleArr === null || titleArr === void 0 ? void 0 : titleArr.slice(1)) === null || ref3 === void 0 ? void 0 : ref3.join("|").trim()) || ""
        };
    }, [
        selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref = selectedVariant.product) === null || ref === void 0 ? void 0 : ref.title
    ]);
    (0,react.useEffect)(function() {
        sendViewProductEvent({
            product: product,
            selectedVariant: selectedVariant
        });
    }, [
        selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref1 = selectedVariant.product) === null || ref1 === void 0 ? void 0 : ref1.handle,
        sendViewProductEvent
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Grid */.rj, {
        "data-comp": Main.displayName,
        sx: theme.wrapper,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)((head_default()), {
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("title", {
                    children: (product === null || product === void 0 ? void 0 : product.title) || ""
                })
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                sx: {
                    display: [
                        "block",
                        null,
                        "none"
                    ]
                },
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Main_Header_Header_Header, {
                        selectedVariant: selectedVariant,
                        currentProduct: product,
                        titles: titles,
                        isMobile: true
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Icons, {
                        product: product,
                        sx: {
                            marginTop: 2
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Media, {
                aboveTheFold: true,
                preload: true
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Details_Details, {
                product: product,
                selectedVariant: selectedVariant,
                currentProduct: product,
                titles: titles,
                productUpsells: productUpsells,
                rebuyProducts: rebuyProducts
            })
        ]
    });
});
Main.displayName = "Main";

;// CONCATENATED MODULE: ./src/sections/Product/Main/index.js


// EXTERNAL MODULE: ../node_modules/fast-deep-equal/index.js
var fast_deep_equal = __webpack_require__(66471);
var fast_deep_equal_default = /*#__PURE__*/__webpack_require__.n(fast_deep_equal);
;// CONCATENATED MODULE: ./src/sections/Product/useInitSelectedVariant.js


var VERBOSE = false;
var useInitSelectedVariant = function() {
    var product = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    var ref = (0,react.useState)(null), selectedVariant = ref[0], setSelectedVariant = ref[1];
    var ref1 = (0,react.useState)(null), selectedOptions = ref1[0], setSelectedOptions = ref1[1];
    // const [selectedMedia, setSelectedMedia] = useState(null);
    var selectedMedia = (0,react.useMemo)(function() {
        if (!(product === null || product === void 0 ? void 0 : product.media) || !selectedOptions) return [];
        var color = selectedOptions.color;
        return color ? product.media.filter(function(param) {
            var p = param.product;
            var ref, ref1;
            return (ref1 = p === null || p === void 0 ? void 0 : (ref = p.tags) === null || ref === void 0 ? void 0 : ref.find(function(tag) {
                return tag.match(new RegExp("color::".concat(color), "gi"));
            })) === null || ref1 === void 0 ? void 0 : ref1.length;
        }) : product.media;
    }, [
        selectedOptions,
        product === null || product === void 0 ? void 0 : product.media
    ]);
    // set initial variant
    (0,react.useEffect)(function() {
        var ref, ref1;
        if (!product) return;
        var isApparel = (product === null || product === void 0 ? void 0 : product.productType) === "Apparel";
        var firstAvailableVariant = isApparel ? product === null || product === void 0 ? void 0 : (ref = product.variants) === null || ref === void 0 ? void 0 : ref.find(function(param) {
            var availableForSale = param.availableForSale;
            return availableForSale;
        }) : null;
        var variant = firstAvailableVariant || (product === null || product === void 0 ? void 0 : (ref1 = product.variants) === null || ref1 === void 0 ? void 0 : ref1[0]);
        setSelectedVariant(variant);
        if (variant) {
            setSelectedOptions(variant === null || variant === void 0 ? void 0 : variant.selectedOptionsMap);
        } else {
            // Should never be get here..
            setSelectedOptions(null);
        }
        return function() {
            // on unmount
            setSelectedOptions(null);
        };
    }, [
        product === null || product === void 0 ? void 0 : product.handle
    ]);
    (0,react.useEffect)(function() {
        var getVariantFromOptions = function(options, variants) {
            return variants === null || variants === void 0 ? void 0 : variants.find(function(param) {
                var selectedOptionsMap = param.selectedOptionsMap;
                return fast_deep_equal_default()(selectedOptions, selectedOptionsMap);
            });
        };
        var _selectedVariant = getVariantFromOptions(selectedOptions, (product === null || product === void 0 ? void 0 : product.variants) || []);
        if (_selectedVariant) {
            setSelectedVariant(_selectedVariant);
        }
    }, [
        product === null || product === void 0 ? void 0 : product.handle,
        selectedOptions
    ]);
    return {
        selectedVariant: selectedVariant,
        selectedOptions: selectedOptions,
        setSelectedOptions: setSelectedOptions,
        selectedMedia: selectedMedia
    };
};

;// CONCATENATED MODULE: ./src/sections/Product/Product.schema.js



var newSection = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, common/* section */.qi), {
    fields: ((common/* section */.qi === null || common/* section */.qi === void 0 ? void 0 : common/* section.fields */.qi.fields) || []).filter(function(field) {
        return field.name !== "bgColor" && field.name !== "color";
    })
});
function Product_schema_Schema() {
    return {
        category: "Product",
        label: "Product",
        key: "product",
        previewSrc: "https://cdn.shopify.com/s/files/1/0822/0439/3780/files/product-preview.jpg?v=1721419443",
        fields: [
            {
                name: "product",
                component: "productSearch",
                label: "Product",
                description: "The product must be both active and on the Hydrogen sales channel to display"
            },
            newSection, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/Product/Product.jsx








function Product(param) {
    var cms = param.cms;
    var ref;
    var ref1 = (0,react.useState)(null), initialProductHandle = ref1[0], setInitialProductHandle = ref1[1];
    var product = (0,dist.useProductByHandle)({
        handle: initialProductHandle || (cms === null || cms === void 0 ? void 0 : (ref = cms.product) === null || ref === void 0 ? void 0 : ref.handle) || ""
    }).product;
    var section = cms.section;
    var anyOf = {
        productUpsells: null,
        videoWise: null
    };
    var rebuyProducts = null;
    var ref2 = useInitSelectedVariant(product), selectedOptions = ref2.selectedOptions, selectedVariant = ref2.selectedVariant, setSelectedOptions = ref2.setSelectedOptions, selectedMedia = ref2.selectedMedia;
    var productData = (0,react.useMemo)(function() {
        return {
            setInitialProductHandle: setInitialProductHandle,
            product: product,
            selectedVariant: selectedVariant,
            selectedOptions: selectedOptions,
            setSelectedOptions: setSelectedOptions,
            selectedMedia: selectedMedia
        };
    }, [
        product,
        selectedVariant,
        selectedOptions,
        selectedMedia
    ]);
    if (!product) {
        return null;
    }
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(ProductContext.Provider, {
        value: productData,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Section */.$0, {
            section: section,
            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Main, {
                productUpsells: anyOf.productUpsells,
                rebuyProducts: rebuyProducts,
                videoWise: anyOf === null || anyOf === void 0 ? void 0 : anyOf.videoWise
            })
        })
    });
}
Product.displayName = "Product";
Product.Schema = Product_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/Product/index.js


;// CONCATENATED MODULE: ./src/sections/Testimonials/Testimonials.schema.js



function Testimonials_schema_Schema(param) {
    var article = param.article, blog = param.blog, collection = param.collection;
    if (article || blog || collection) return null;
    return {
        label: "Testimonials",
        key: "testimonials",
        fields: [
            {
                label: "Text Settings",
                name: "text",
                description: "Heading, alignment",
                component: "group",
                fields: [
                    {
                        label: "Heading",
                        name: "heading",
                        component: "markdown",
                        defaultValue: "## Over 30,000 5-Star Reviews"
                    },
                    {
                        name: "textAlign",
                        label: "Text align",
                        component: "radio-group",
                        direction: "horizontal",
                        variant: "radio",
                        options: common/* align.options */.AJ.options,
                        defaultValue: common/* align.value.center */.AJ.value.center
                    }, 
                ]
            },
            {
                label: "Display Settings",
                name: "display",
                description: "Star rating display options",
                component: "group",
                fields: [
                    {
                        name: "showStars",
                        label: "Show Star Rating",
                        component: "toggle",
                        description: "Display 5-star rating above each testimonial",
                        toggleLabels: {
                            true: "Show",
                            false: "Hide"
                        },
                        defaultValue: true
                    }, 
                ]
            },
            {
                name: "testimonials",
                label: "Testimonials",
                description: "Max of 3 testimonials. If less than 3 are populated, tiles will center",
                component: "group-list",
                itemProps: {
                    label: "{{item.reviewerName}}"
                },
                defaultItem: {
                    reviewText: "This is the best cup I have ever purchased. Absolutely my new favorite. I love that it doesn't leak and keeps my drinks hot or cold.",
                    reviewerName: "Customer Name"
                },
                validate: {
                    maxItems: 3
                },
                fields: [
                    {
                        name: "reviewText",
                        label: "Review Text",
                        component: "textarea",
                        description: "The testimonial review text"
                    },
                    {
                        name: "reviewerName",
                        label: "Reviewer Name",
                        component: "text",
                        description: "Name of the person giving the review"
                    }, 
                ],
                defaultValue: [
                    {
                        reviewText: "This is the best cup I have ever purchased. Absolutely my new favorite. I love that it doesn't leak and keeps my drinks hot or cold.",
                        reviewerName: "Christyal P."
                    },
                    {
                        reviewText: "This was my first Br\xfcmate and I absolutely fell in love. It fit in my cup holders nicely and I haven't had any spills. Also, love the color!",
                        reviewerName: "Paige D."
                    },
                    {
                        reviewText: "I love the way it can be sealed and doesn't leak. I laid it in my purse and had no fear of it getting anything wet. I would definitely buy it again.",
                        reviewerName: "Rebecca H."
                    }, 
                ]
            },
            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, common/* section */.qi), {
                defaultValue: {
                    bgColor: common/* color.value.background */.$_.value.background,
                    color: common/* color.value.text */.$_.value.text,
                    desktop: {
                        container: "container",
                        mt: "none",
                        py: "xl"
                    },
                    mobile: {
                        container: "container",
                        mt: "none",
                        py: "l"
                    }
                }
            }), 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/Testimonials/StarRating.jsx




function StarRating(param) {
    var _rating = param.rating, rating = _rating === void 0 ? 5 : _rating, _size = param.size, size = _size === void 0 ? 16 : _size, _color = param.color, color = _color === void 0 ? "#FFD700" : _color;
    // Clamp rating between 0 and 5
    var clampedRating = Math.max(0, Math.min(5, rating));
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
        sx: {
            display: "flex",
            alignItems: "center",
            gap: "2px",
            justifyContent: "center"
        },
        role: "img",
        "aria-label": "".concat(rating, " out of 5 stars"),
        children: (0,_to_consumable_array/* default */.Z)(Array(5)).map(function(_, index) {
            return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                sx: {
                    width: size,
                    height: size,
                    color: index < clampedRating ? color : "#E5E5E5"
                },
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("svg", {
                    width: "100%",
                    height: "100%",
                    viewBox: "0 0 24 24",
                    fill: "currentColor",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("path", {
                        d: "M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
                    })
                })
            }, index);
        })
    });
}

;// CONCATENATED MODULE: ./src/sections/Testimonials/Testimonials.jsx







var Testimonials = (0,src_utils/* withInView */.Dh)(function(param) {
    var cms = param.cms;
    var section = cms.section, text = cms.text, testimonials = cms.testimonials, display = cms.display;
    if (!testimonials || testimonials.length === 0) return null;
    // Validate testimonial structure
    var validTestimonials = testimonials.filter(function(testimonial) {
        return testimonial && testimonial.reviewText != null && testimonial.reviewerName != null;
    });
    if (validTestimonials.length === 0) return null;
    var getGridColumns = function(testimonialsLength) {
        if (testimonialsLength === 1) return "1fr";
        if (testimonialsLength === 2) return "repeat(2, 1fr)";
        return "repeat(3, 1fr)";
    };
    var textColor = (section === null || section === void 0 ? void 0 : section.color) || "#222222";
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Section */.$0, {
        section: section,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Container */.W2, {
            "data-comp": Testimonials.displayName,
            children: [
                (text === null || text === void 0 ? void 0 : text.heading) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                    sx: {
                        textAlign: text.textAlign || "center",
                        mb: [
                            4,
                            5
                        ]
                    },
                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Markdown */.UG, {
                        text: text === null || text === void 0 ? void 0 : text.heading,
                        as: "h2",
                        sx: {
                            fontSize: [
                                36,
                                56
                            ],
                            fontFamily: "Reckless Neue",
                            fontWeight: 400,
                            color: textColor,
                            lineHeight: 1.2,
                            "& *": {
                                fontFamily: "Reckless Neue!important"
                            }
                        }
                    })
                }),
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                    sx: {
                        display: "grid",
                        gridTemplateColumns: [
                            "1fr",
                            getGridColumns(validTestimonials.length), 
                        ],
                        gap: 11,
                        justifyItems: validTestimonials.length < 3 ? "center" : "stretch",
                        maxWidth: validTestimonials.length < 3 ? "800px" : "100%",
                        mx: validTestimonials.length < 3 ? "auto" : 0
                    },
                    children: validTestimonials.map(function(testimonial, index) {
                        /*#__PURE__*/ return (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                            as: "article",
                            role: "article",
                            "aria-label": "Testimonial by ".concat(testimonial.reviewerName),
                            sx: {
                                bg: "#ffffff",
                                px: [
                                    11,
                                    12
                                ],
                                py: 11,
                                borderRadius: "8px",
                                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                                display: "flex",
                                flexDirection: "column",
                                gap: 8,
                                maxWidth: validTestimonials.length < 3 ? "350px" : "none",
                                textAlign: "center"
                            },
                            children: [
                                (display === null || display === void 0 ? void 0 : display.showStars) !== false && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(StarRating, {
                                    rating: 5,
                                    size: 16,
                                    color: textColor
                                }),
                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Text */.xv, {
                                    as: "blockquote",
                                    sx: {
                                        fontSize: 4,
                                        fontFamily: "Fellix",
                                        fontWeight: 400,
                                        color: textColor,
                                        lineHeight: 1.5,
                                        flex: 1
                                    },
                                    children: testimonial.reviewText
                                }),
                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Text */.xv, {
                                    as: "cite",
                                    sx: {
                                        fontSize: 1,
                                        fontFamily: "Fellix",
                                        fontWeight: 400,
                                        color: textColor,
                                        mt: "auto"
                                    },
                                    children: testimonial.reviewerName
                                })
                            ]
                        }, index);
                    })
                })
            ]
        })
    });
}, {
    triggerOnce: true
});
Testimonials.displayName = "Testimonials";
Testimonials.Schema = Testimonials_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/Testimonials/index.js


;// CONCATENATED MODULE: ./src/sections/ProductCarouselToggle/ProductCarousel/Navigation/NavigationButton/NavigationButton.theme.js

var NavigationButton_theme_themed = (0,create/* create */.U)(new function() {
    this.button = {
        width: "48px",
        height: "48px",
        borderRadius: "50%",
        backgroundColor: "white",
        border: "1px solid #e0e0e0",
        color: "#222222",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "all 0.2s ease",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
        "&:hover": {
            backgroundColor: "#f5f5f5",
            borderColor: "#d0d0d0"
        },
        "&:focus": {
            outline: "none",
            boxShadow: "0 0 0 2px rgba(34, 34, 34, 0.2)"
        }
    };
    this.disabled = {
        opacity: 0.5,
        cursor: "not-allowed",
        "&:hover": {
            backgroundColor: "white",
            borderColor: "#e0e0e0"
        }
    };
}());

;// CONCATENATED MODULE: ./src/sections/ProductCarouselToggle/ProductCarousel/Navigation/NavigationButton/NavigationButton.jsx





var NavigationButton_NavigationButton = NavigationButton_theme_themed(function(param) {
    var theme = param.theme, onClick = param.onClick, disabled = param.disabled, direction = param.direction;
    var isNext = direction === "next";
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
        "data-comp": NavigationButton_NavigationButton.displayName,
        onClick: onClick,
        disabled: disabled,
        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.button, disabled ? theme.disabled : {}), {
            borderRadius: "0",
            border: "none",
            minWidth: "0",
            p: 0,
            width: "36px",
            height: "36px",
            boxShadow: "none",
            backgroundColor: "transparent",
            transform: isNext ? "none" : "rotate(180deg)",
            color: "#222222",
            "&:hover, &:focus": {
                boxShadow: "none",
                backgroundColor: "transparent",
                color: "#05000180"
            }
        }),
        "aria-label": isNext ? "Next products" : "Previous products",
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "36",
            height: "36",
            viewBox: "0 0 36 36",
            fill: "none",
            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("path", {
                d: "M13.5 7.5L24 18L13.5 28.5",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        })
    });
});
NavigationButton_NavigationButton.displayName = "ProductCarouselToggle-NavigationButton";

;// CONCATENATED MODULE: ./src/sections/ProductCarouselToggle/ProductCarousel/Navigation/NavigationButton/index.js


;// CONCATENATED MODULE: ./src/sections/ProductCarouselToggle/ProductCarouselToggle.schema.js



// Default products with color and size
var defaultProducts = [
    {
        product: {
            handle: "toddy-16oz-onyx-leopard",
            title: "Toddy 16oz"
        },
        color: "Onyx Leopard",
        size: "16 oz."
    },
    {
        product: {
            handle: "brumate-25oz-rehydration-bottle-onyx-leopard",
            title: "Br\xfcMate 25oz Rehydration Bottle"
        },
        color: "Onyx Leopard",
        size: "25 oz."
    }, 
];
var ProductCarouselToggle_schema_Schema = function() {
    return {
        label: "Product Carousel - Toggle",
        key: "product-carousel-toggle",
        fields: [
            {
                label: "Content Settings",
                name: "content",
                component: "group",
                fields: [
                    {
                        name: "heading",
                        label: "Section Heading",
                        component: "text"
                    },
                    {
                        name: "headingAlign",
                        label: "Heading Alignment (Desktop)",
                        component: "radio-group",
                        direction: "horizontal",
                        variant: "radio",
                        options: common/* align.options */.AJ.options
                    },
                    {
                        name: "headingAlignMobile",
                        label: "Heading Alignment (Mobile)",
                        component: "radio-group",
                        variant: "radio",
                        direction: "horizontal",
                        options: common/* align.options */.AJ.options
                    },
                    {
                        name: "togglesAlign",
                        label: "Toggles Alignment (Desktop)",
                        component: "radio-group",
                        direction: "horizontal",
                        variant: "radio",
                        options: common/* align.options */.AJ.options
                    },
                    {
                        name: "togglesAlignMobile",
                        label: "Toggles Alignment (Mobile)",
                        component: "radio-group",
                        variant: "radio",
                        direction: "horizontal",
                        options: common/* align.options */.AJ.options
                    }, 
                ],
                defaultValue: {
                    heading: "Shop By Color",
                    headingAlign: common/* align.value.left */.AJ.value.left,
                    headingAlignMobile: common/* align.value.center */.AJ.value.center,
                    togglesAlign: common/* align.value.center */.AJ.value.center,
                    togglesAlignMobile: common/* align.value.center */.AJ.value.center
                }
            },
            {
                name: "toggles",
                label: "Toggle Options",
                component: "group-list",
                itemProps: {
                    label: "{{item.label}}"
                },
                fields: [
                    {
                        name: "label",
                        label: "Toggle Label",
                        component: "text"
                    },
                    {
                        name: "products",
                        label: "Products",
                        component: "group-list",
                        fields: [
                            {
                                name: "product",
                                component: "productSearch",
                                label: "Select Product"
                            },
                            {
                                name: "color",
                                label: "Color",
                                component: "text",
                                description: 'Enter the color name to display (e.g., "Onyx Leopard", "Matte Black")'
                            },
                            {
                                name: "size",
                                label: "Size (Optional)",
                                component: "text",
                                description: 'Enter the size to display (e.g., "30 oz.", "40 oz.") - leave blank to hide'
                            }, 
                        ],
                        defaultValue: defaultProducts
                    }, 
                ],
                defaultValue: [
                    {
                        label: "30 oz.",
                        products: defaultProducts
                    },
                    {
                        label: "40 oz.",
                        products: defaultProducts
                    }, 
                ]
            },
            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, common/* section */.qi), {
                defaultValue: {
                    bgColor: "#ffffff",
                    color: "#000000",
                    desktop: {
                        container: "container",
                        mt: "none",
                        py: "m"
                    },
                    mobile: {
                        container: "container",
                        mt: "none",
                        py: "m"
                    }
                }
            }), 
        ]
    };
};

;// CONCATENATED MODULE: ./src/sections/ProductCarouselToggle/ProductCarouselToggle.theme.js

var ProductCarouselToggle_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        display: "flex",
        flexDirection: "column",
        gap: [
            6,
            8
        ]
    };
    this.header = {
        mb: [
            4,
            6
        ]
    };
    this.toggles = {
        mb: [
            5,
            7
        ],
        display: "flex",
        justifyContent: [
            "center",
            "center",
            "flex-start"
        ]
    };
    this.carousel = {
        position: "relative"
    };
}());

;// CONCATENATED MODULE: ./src/sections/ProductCarouselToggle/ProductCarousel/ProductTile/AddToCart/useAddToCart.js










var useAddToCart_useAddToCart = function(param) {
    var selectedVariant = param.selectedVariant, product = param.product, rebuyWidget = param.rebuyWidget;
    var ref, ref1;
    var gotoSnapshot = (0,store/* useGotoRecoilSnapshot */.le)();
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useSelectedPlan */.JM)({
        selectedVariant: selectedVariant
    }), 1), selectedPlan = ref2[0];
    var _ref = (0,dist.useCartAddItem)(), cartAddItem = _ref.cartAddItem, addItemStatus = (0,_object_without_properties/* default */.Z)(_ref, [
        "cartAddItem"
    ]);
    var _ref1 = (0,dist.useProductInventoryByHandle)({
        handle: product === null || product === void 0 ? void 0 : product.handle,
        withQuantity: true
    }), inventory = _ref1.inventory, inventoryStatus = (0,_object_without_properties/* default */.Z)(_ref1, [
        "inventory"
    ]);
    var variantStorefrontId = (0,src_utils/* isEncoded */.x)(inventory === null || inventory === void 0 ? void 0 : inventory.id) ? (0,src_utils/* getEncodedId */.m4)(selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.storefrontId) : selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.storefrontId;
    var variantInventory = inventory ? inventory === null || inventory === void 0 ? void 0 : (ref = inventory.variants) === null || ref === void 0 ? void 0 : ref[variantStorefrontId] : null;
    var isGiftCard = (variantInventory === null || variantInventory === void 0 ? void 0 : (ref1 = variantInventory.product) === null || ref1 === void 0 ? void 0 : ref1.handle) === "brumate-e-gift-card" || (product === null || product === void 0 ? void 0 : product.handle) === "brumate-e-gift-card";
    var isSoldOut = !variantInventory || variantInventory.quantityAvailable <= 0 && !isGiftCard;
    var isPreOrder = isSoldOut && (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.inventoryPolicy) === "CONTINUE";
    var toggleCartSidebar = (0,store/* useRecoilCallback */._8)(function(param) {
        var snapshot = param.snapshot;
        return /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var release, updatedState;
            return (0,tslib_es6.__generator)(this, function(_state) {
                release = snapshot.retain();
                try {
                    updatedState = snapshot.map(function(param) {
                        var set = param.set;
                        return set(store/* default.modal */.ZP.modal, null);
                    }).map(function(param) {
                        var set = param.set;
                        return set(store/* default.overlay */.ZP.overlay, true);
                    }).map(function(param) {
                        var set = param.set;
                        return set(store/* default.sidebar */.ZP.sidebar, "cart");
                    });
                    // update state
                    gotoSnapshot(updatedState);
                } finally{
                    release();
                }
                return [
                    2
                ];
            });
        });
    });
    // add oneTime and subs
    var addToCart = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var ref, callback, openCart, item, rebuyAttributes, cart;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ref = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {
                        openCart: true
                    }, callback = ref.callback, openCart = ref.openCart;
                    if (!selectedVariant || isSoldOut && !isPreOrder) return [
                        2
                    ];
                    item = {
                        merchandiseId: selectedVariant.id,
                        quantity: 1
                    };
                    // adds shipscout attribute to collect data for abtest
                    if (typeof window.ShipScoutLineItemProperty !== "undefined") {
                        item.attributes = [
                            {
                                key: "_sc",
                                value: window.ShipScoutLineItemProperty
                            }, 
                        ];
                    }
                    // adds tracking attributes if rebuyWidget is present
                    if (rebuyWidget) {
                        rebuyAttributes = [
                            {
                                key: "_attribution",
                                value: "PDP"
                            },
                            {
                                key: "_source",
                                value: "Rebuy"
                            },
                            {
                                key: "_widget",
                                value: rebuyWidget
                            }
                        ];
                        if (item.attributes) {
                            item.attributes = (0,_to_consumable_array/* default */.Z)(item.attributes).concat((0,_to_consumable_array/* default */.Z)(rebuyAttributes));
                        } else {
                            item.attributes = rebuyAttributes;
                        }
                    }
                    if (typeof window.ShipScoutTrackAddToCart === "function") {
                        window.ShipScoutTrackAddToCart();
                    }
                    // if selling plan is selected we the subscription
                    if (selectedPlan) {
                        item.sellingPlanId = selectedPlan.id;
                    }
                    return [
                        4,
                        cartAddItem(item)
                    ];
                case 1:
                    cart = _state.sent();
                    if (typeof callback === "function") {
                        callback(cart);
                    }
                    if (openCart) {
                        toggleCartSidebar();
                    }
                    return [
                        2
                    ];
            }
        });
    }), [
        selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id,
        isSoldOut,
        isPreOrder,
        selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.id
    ]);
    return [
        {
            isPreOrder: isPreOrder,
            isSoldOut: isSoldOut && !isPreOrder,
            selectedPlan: selectedPlan,
            status: {
                addItem: addItemStatus,
                inventory: inventory,
                inventoryStatus: inventoryStatus
            }
        },
        {
            addToCart: addToCart,
            toggleCartSidebar: toggleCartSidebar
        }, 
    ];
};

;// CONCATENATED MODULE: ./src/sections/ProductCarouselToggle/ProductCarousel/ProductTile/AddToCart/AddToCart.theme.js

var AddToCart_AddToCart_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        mr: "auto",
        display: "flex",
        alignItems: "center",
        mt: [
            4,
            8
        ],
        width: "100%"
    };
    // todo: nested variants should really be button variants that modify primary
    // so that they can be used through a project and not just here
    this.button = {
        variant: "primary",
        width: "100%",
        outline: "none",
        whiteSpace: "nowrap",
        available: {
            cursor: "pointer",
            oneTime: {
                bg: "black"
            },
            subscribe: {
                border: function(t) {
                    return "1px solid ".concat(t.colors.dark);
                },
                bg: "dark",
                "&:hover": {
                    color: "dark"
                }
            }
        },
        unavailable: {
            oneTime: {
                variant: "buttons.secondary",
                color: "mediumDarkGray"
            },
            subscribe: {
                bg: "gray",
                border: function(t) {
                    return "1px solid ".concat(t.colors.dark);
                },
                "&:hover": {
                    bg: "gray",
                    color: "background"
                }
            }
        }
    };
}());

;// CONCATENATED MODULE: ./src/sections/ProductCarouselToggle/ProductCarousel/ProductTile/AddToCart/AddToCart.jsx















var AddToCart_AddToCart = AddToCart_AddToCart_theme_themed(function(_param) {
    var _action = _param.action, action = _action === void 0 ? function() {} : _action, theme = _param.theme, product = _param.product, selectedVariant = _param.selectedVariant, handleUpsellRemove = _param.handleUpsellRemove, rebuyWidget = _param.rebuyWidget, style = _param.style, isProductItem = _param.isProductItem, addToTapCart = _param.addToTapCart, isInitialized = _param.isInitialized, props = (0,_object_without_properties/* default */.Z)(_param, [
        "action",
        "theme",
        "product",
        "selectedVariant",
        "handleUpsellRemove",
        "rebuyWidget",
        "style",
        "isProductItem",
        "addToTapCart",
        "isInitialized"
    ]);
    var ref, ref1, ref2, ref3, ref4, ref5;
    var settings = (0,dist.useSettings)();
    var gatedPage = (0,store/* useRecoilValue */.sJ)(store/* default.gatedPage */.ZP.gatedPage);
    var enableFullProductAccess = (0,hooks/* useGatedProduct */.sC)({
        product: product,
        gatedPage: gatedPage
    }).enableFullProductAccess;
    var isDesktop = (0,hooks/* useMatchMedia */.ag)("(min-width: 1024px)");
    var ref6 = (0,react.useState)("Notify Me"), productItemNotifyMeText = ref6[0], setProductItemNotifyMeText = ref6[1];
    var ref7 = (0,_sliced_to_array/* default */.Z)(useAddToCart_useAddToCart({
        product: product,
        selectedVariant: selectedVariant,
        rebuyWidget: rebuyWidget
    }), 2), ref8 = ref7[0], status = ref8.status, isSoldOut = ref8.isSoldOut, isPreOrder = ref8.isPreOrder, selectedPlan = ref8.selectedPlan, addToCart = ref7[1].addToCart;
    var _addItem = status.addItem, started = _addItem.started, finished = _addItem.finished, success = _addItem.success, errors = _addItem.errors;
    var ref9 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useModal */.dd)(), 2), openModal = ref9[1].openModal;
    var ref10 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useSidebar */.Ap)(), 2), openSidebar = ref10[1].openSidebar;
    var soldOutText = isProductItem ? productItemNotifyMeText : "Notify Me When Available";
    var ref11 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useCartStatus */.T0)(), 2), ref12 = ref11[1], setAddingToCartStatus = ref12.setAddingToCartStatus, setUpdatingCartStatus = ref12.setUpdatingCartStatus;
    var gwp = (0,hooks/* useGiftWithPurchase */.tG)();
    var cartIsMaxed = (0,store/* useRecoilValue */.sJ)(store/* default.cartIsMaxed */.ZP.cartIsMaxed);
    var ignoredProducts = settings === null || settings === void 0 ? void 0 : (ref = settings.cart) === null || ref === void 0 ? void 0 : (ref1 = ref.bulkOrdering) === null || ref1 === void 0 ? void 0 : ref1.ignoredProducts;
    var noBackInStockOption = isSoldOut && !isPreOrder && (product === null || product === void 0 ? void 0 : (ref2 = product.tags) === null || ref2 === void 0 ? void 0 : ref2.includes("no-bis"));
    var text = (status === null || status === void 0 ? void 0 : (ref3 = status.inventoryStatus) === null || ref3 === void 0 ? void 0 : ref3.finished) && product ? noBackInStockOption ? "Sold Out" : !isSoldOut && isPreOrder ? "Pre-order" : isSoldOut ? soldOutText : selectedPlan ? "Subscribe" : "Add to Bag" : "LOADING...";
    var ignoredFromMaxQty = (0,react.useMemo)(function() {
        return ignoredProducts === null || ignoredProducts === void 0 ? void 0 : ignoredProducts.some(function(param) {
            var ignoredProduct = param.product;
            return ignoredProduct.handle === (product === null || product === void 0 ? void 0 : product.handle);
        });
    }, [
        product === null || product === void 0 ? void 0 : product.handle,
        ignoredProducts
    ]);
    var setGlobalCartStatusOnAdding = (0,react.useCallback)(function() {
        setAddingToCartStatus({
            started: started,
            finished: finished,
            success: success,
            errors: errors
        });
        setUpdatingCartStatus({
            started: started,
            finished: finished,
            success: success,
            errors: errors
        });
        var defaultStatus = {
            started: false,
            finished: false,
            success: false,
            errors: []
        };
        return function() {
            setAddingToCartStatus(defaultStatus);
            setUpdatingCartStatus(defaultStatus);
        };
    }, [
        started,
        finished,
        success
    ]);
    var handleOutOfStock = (0,react.useCallback)(function() {
        // need timeout for delay if a modal is already open
        setTimeout(function() {
            var ref, ref1;
            openModal(/*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* BackInStockModal */.Yu, {
                legacyResourceId: (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.legacyResourceId) || (product === null || product === void 0 ? void 0 : (ref = product.variants) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.id),
                title: (product === null || product === void 0 ? void 0 : product.title) || (product === null || product === void 0 ? void 0 : product.name) || ""
            }));
        }, 250);
    }, [
        selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id,
        product === null || product === void 0 ? void 0 : product.title
    ]);
    (0,react.useEffect)(function() {
        setGlobalCartStatusOnAdding();
    }, [
        started,
        finished,
        success
    ]);
    (0,react.useEffect)(function() {
        if (!isProductItem || !isSoldOut) return;
        setProductItemNotifyMeText(isDesktop ? "Notify Me When Available" : "Notify Me");
    }, [
        isProductItem,
        isDesktop,
        isSoldOut
    ]);
    var isNotifyMe = isSoldOut && !isPreOrder;
    var overMaxDisabled = cartIsMaxed && !isNotifyMe && !ignoredFromMaxQty;
    if (!enableFullProductAccess) return null;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
        sx: (0,_object_spread/* default */.Z)({}, theme.wrapper, style),
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* StatefulButton */.Lc, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            disabled: overMaxDisabled,
            "data-comp": AddToCart_AddToCart.displayName,
            sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.button, isNotifyMe || overMaxDisabled || noBackInStockOption ? (0,_object_spread/* default */.Z)({}, theme.button.unavailable, selectedPlan ? theme.button.unavailable.subscribe : (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.button.unavailable.oneTime), {
                borderColor: overMaxDisabled || noBackInStockOption ? "gray" : "text",
                color: overMaxDisabled || noBackInStockOption ? "mediumGray" : "mediumDarkGray",
                ":hover": {
                    borderColor: overMaxDisabled || noBackInStockOption ? "gray" : "text",
                    color: overMaxDisabled || noBackInStockOption ? "mediumGray" : "text",
                    bg: "background"
                }
            })) : (0,_object_spread/* default */.Z)({}, theme.button.available, selectedPlan ? theme.button.available.subscribe : theme.button.available.oneTime)), {
                cursor: overMaxDisabled || noBackInStockOption ? "default" : "pointer",
                whiteSpace: "nowrap",
                overflow: "hidden",
                maxWidth: "100%",
                "> span": {
                    display: "flex",
                    width: "100%",
                    justifyContent: "center",
                    alignItems: "center"
                }
            })
        }, status.addItem), {
            loading: !(status === null || status === void 0 ? void 0 : (ref4 = status.inventoryStatus) === null || ref4 === void 0 ? void 0 : ref4.finished),
            text: {
                default: text,
                started: text,
                success: text,
                error: text
            },
            onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!isNotifyMe) return [
                                3,
                                1
                            ];
                            handleOutOfStock();
                            return [
                                3,
                                3
                            ];
                        case 1:
                            if (isInitialized) {
                                addToTapCart({
                                    lineItems: [
                                        {
                                            variantId: selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.legacyResourceId,
                                            quantity: 1
                                        }
                                    ]
                                });
                                return [
                                    2
                                ];
                            }
                            action();
                            return [
                                4,
                                addToCart({
                                    callback: function(_cart) {
                                        if (handleUpsellRemove) handleUpsellRemove();
                                        if (gwp.isEligible(_cart)) {
                                            openModal(/*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* GiftWithPurchase */.QT, {}));
                                        } else {
                                            openSidebar("cart");
                                        }
                                    },
                                    openCart: false
                                })
                            ];
                        case 2:
                            _state.sent();
                            _state.label = 3;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            }),
            children: selectedVariant && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Locale.Variant */.go.Variant, {
                variant: selectedVariant || (product === null || product === void 0 ? void 0 : (ref5 = product.variants) === null || ref5 === void 0 ? void 0 : ref5[0]),
                sx: {
                    p: {
                        fontSize: "15px"
                    }
                },
                className: "flex gap-1 pl-1",
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Locale.Price */.go.Price, {
                    children: function(param) {
                        var priceV2 = param.priceV2, compareAtPriceV2 = param.compareAtPriceV2, isOnSale = param.isOnSale;
                        return isOnSale ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                            sx: {
                                variant: "flex.row.end.start",
                                gap: "4px"
                            },
                            children: [
                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Paragraph */.nv, {
                                    children: [
                                        "• ",
                                        priceV2.locale
                                    ]
                                }),
                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                                    sx: {
                                        textDecoration: "line-through",
                                        color: "mediumDarkGray"
                                    },
                                    children: compareAtPriceV2.locale
                                })
                            ]
                        }) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Paragraph */.nv, {
                            children: [
                                "• ",
                                priceV2.locale
                            ]
                        });
                    }
                })
            })
        }))
    });
});
AddToCart_AddToCart.displayName = "AddToCart";

;// CONCATENATED MODULE: ./src/sections/ProductCarouselToggle/ProductCarousel/ProductTile/AddToCart/index.js


;// CONCATENATED MODULE: ./src/sections/ProductCarouselToggle/ProductCarousel/ProductTile/ProductTile.theme.js

var ProductTile_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        flexDirection: "column",
        width: "100%"
    };
    this.content = {
        backgroundColor: "#f5f5f5",
        borderRadius: "12px",
        p: [
            3,
            4
        ],
        display: "flex",
        flexDirection: "column",
        height: "100%",
        position: "relative"
    };
    this.addToCart = {
        backgroundColor: "#000000",
        color: "#ffffff",
        fontFamily: "body",
        fontWeight: 500,
        fontSize: [
            "14px",
            "15px"
        ],
        borderRadius: "24px",
        border: "none",
        px: [
            3,
            4
        ],
        py: [
            2,
            3
        ],
        mt: "auto",
        cursor: "pointer",
        textAlign: "center",
        textDecoration: "none",
        display: "flex",
        transition: "all 0.2s ease",
        minHeight: [
            "40px",
            "44px"
        ],
        alignItems: "center",
        justifyContent: "center",
        "&:hover": {
            backgroundColor: "#333333"
        },
        "&:focus": {
            outline: "none",
            boxShadow: "0 0 0 2px rgba(0, 0, 0, 0.2)"
        }
    };
}());

;// CONCATENATED MODULE: ./src/sections/ProductCarouselToggle/ProductCarousel/ProductTile/ProductTile.jsx
















var ProductTile = ProductTile_theme_themed(function(param) {
    var theme = param.theme, item = param.item, index = param.index;
    var ref, ref1, ref2;
    // Extract product and admin-entered fields
    var ref3 = item || {}, product = ref3.product, color = ref3.color, size = ref3.size;
    var sendClickProductItemEvent = (0,hooks/* useDataLayerActions */.KZ)().sendClickProductItemEvent;
    var gatedPage = (0,store/* useRecoilValue */.sJ)(store/* default.gatedPage */.ZP.gatedPage);
    var settings = (0,dist.useSettings)();
    var gatedPages = ((0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : settings.gatedPages) || {}).gatedPages;
    var enableFullProductAccess = (0,hooks/* useGatedProduct */.sC)({
        product: product,
        gatedPage: gatedPage
    }).enableFullProductAccess;
    var isInitialized = (0,webbridge_react_es/* useVariables */.OQ)().isInitialized;
    var ref4 = (0,webbridge_react_es/* useActions */.ol)(), openProduct = ref4.openProduct, addToTapCart = ref4.addToCart;
    var ref5 = (0,react_intersection_observer_dist/* useInView */.YD)({
        rootMargin: "400px",
        triggerOnce: true
    }), ref6 = ref5.ref, inView = ref5.inView;
    var ref7 = (0,dist.useProductByHandle)({
        handle: (product === null || product === void 0 ? void 0 : product.handle) || "",
        fetchOnMount: inView
    }), fullProduct = ref7.product;
    var selectedVariant = (0,react.useMemo)(function() {
        var ref;
        return fullProduct === null || fullProduct === void 0 ? void 0 : (ref = fullProduct.variants) === null || ref === void 0 ? void 0 : ref[0];
    }, [
        fullProduct === null || fullProduct === void 0 ? void 0 : fullProduct.id
    ]);
    var localized = (0,dist.useLocalizedVariant)({
        variant: selectedVariant
    }).localized;
    var hasMultipleVariants = (0,react.useMemo)(function() {
        var ref;
        if (!fullProduct) return false;
        var count = 0;
        var hasMultiple = false;
        (ref = fullProduct.variants) === null || ref === void 0 ? void 0 : ref.find(function(variant) {
            if (variant.product.handle === fullProduct.handle) {
                count += 1;
                if (count > 1) {
                    hasMultiple = true;
                    return true;
                }
            }
            return false;
        });
        return hasMultiple;
    }, [
        fullProduct === null || fullProduct === void 0 ? void 0 : fullProduct.id
    ]);
    var hiddenProductHandles = (0,react.useMemo)(function() {
        return !!(gatedPages === null || gatedPages === void 0 ? void 0 : gatedPages.length) && gatedPages.reduce(function(carry, param) {
            var enable = param.enable, page = param.page;
            if (enable) {
                var pages = (0,_object_spread/* default */.Z)({}, page).pages;
                var _products = pages === null || pages === void 0 ? void 0 : pages.reduce(function(_carry, _page) {
                    var ref, ref1;
                    if (_page === null || _page === void 0 ? void 0 : _page.enableFullProductAccess) {
                        return _carry;
                    }
                    return (0,_to_consumable_array/* default */.Z)(_carry).concat((0,_to_consumable_array/* default */.Z)(((ref1 = _page === null || _page === void 0 ? void 0 : (ref = _page.products) === null || ref === void 0 ? void 0 : ref.map(function(param) {
                        var p = param.p;
                        return p === null || p === void 0 ? void 0 : p.handle;
                    })) === null || ref1 === void 0 ? void 0 : ref1.filter(Boolean)) || []));
                }, []);
                return (0,_to_consumable_array/* default */.Z)(carry).concat((0,_to_consumable_array/* default */.Z)(_products || []));
            }
            return carry;
        }, []);
    }, [
        gatedPages
    ]);
    var intellisuggestTrackClick = (0,react.useCallback)(function() {
        if (document.images) {
            var apiUrl = "".concat(window.location.protocol || "http:", "//").concat("nr3jmv", ".a.searchspring.io/api/");
            var imgTag = new Image();
            imgTag.src = "".concat(apiUrl, "track/track.json?d=").concat(fullProduct.intellisuggestData, "&s=").concat(fullProduct.intellisuggestSignature, "&u=").concat(encodeURIComponent("".concat("https://www.brumate.com", "/products/").concat(fullProduct.handle)), "&r=").concat(encodeURIComponent(document.referrer), "&bgfilter.ss_mobile_only=0");
        }
        return true;
    }, [
        fullProduct === null || fullProduct === void 0 ? void 0 : fullProduct.id
    ]);
    var handleClick = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (isInitialized && (fullProduct === null || fullProduct === void 0 ? void 0 : fullProduct.legacyResourceId)) {
                    event.preventDefault();
                    openProduct({
                        productId: "".concat(fullProduct.legacyResourceId)
                    });
                    return [
                        2
                    ];
                }
                sendClickProductItemEvent({
                    isSearchResult: false,
                    listIndex: index,
                    localized: localized,
                    product: fullProduct,
                    searchTerm: null,
                    selectedVariant: selectedVariant
                });
                intellisuggestTrackClick();
                return [
                    2
                ];
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }(), [
        index,
        localized,
        fullProduct === null || fullProduct === void 0 ? void 0 : fullProduct.id,
        selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id,
        isInitialized
    ]);
    // Get product images using the existing hook
    var primary = (0,hooks/* useProductItemImages */.Ep)({
        product: fullProduct
    }).primary;
    // Basic product info with fallbacks
    var productTitle = (fullProduct === null || fullProduct === void 0 ? void 0 : fullProduct.title) || (fullProduct === null || fullProduct === void 0 ? void 0 : fullProduct.handle) || "Product";
    var displayColor = color || "";
    var displaySize = size || "";
    var productImage = (0,react.useMemo)(function() {
        var ref, ref1;
        if (primary === null || primary === void 0 ? void 0 : primary.originalSrc) {
            return primary;
        }
        // Fallback to first image in product data if primary is not available
        return (product === null || product === void 0 ? void 0 : (ref = product.data) === null || ref === void 0 ? void 0 : (ref1 = ref.images) === null || ref1 === void 0 ? void 0 : ref1[0]) || null;
    }, [
        primary === null || primary === void 0 ? void 0 : primary.originalSrc,
        product === null || product === void 0 ? void 0 : (ref = product.data) === null || ref === void 0 ? void 0 : ref.images
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
        "data-comp": ProductTile.displayName,
        sx: theme.wrapper,
        ref: ref6,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
            sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.content), {
                height: [
                    "420px",
                    "450px"
                ],
                display: "flex",
                flexDirection: "column"
            }),
            children: [
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                    sx: {
                        width: "100%",
                        height: [
                            "200px",
                            "250px"
                        ],
                        borderRadius: "8px",
                        overflow: "hidden",
                        backgroundColor: "#f0f0f0",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0
                    },
                    children: (productImage === null || productImage === void 0 ? void 0 : productImage.originalSrc) ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Picture */.t, {
                        alt: productTitle,
                        images: [
                            {
                                src: productImage.originalSrc,
                                width: 300,
                                ratio: 1
                            }, 
                        ],
                        imageBgColor: "lightGray",
                        width: productImage.width,
                        height: productImage.height,
                        sx: {
                            width: "100%",
                            height: "100%",
                            objectFit: "contain"
                        },
                        imageSx: {
                            objectFit: "contain"
                        }
                    }) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                        sx: {
                            color: "#666",
                            fontSize: "14px",
                            textAlign: "center"
                        },
                        children: "Product Image"
                    })
                }),
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                    sx: {
                        flex: 1,
                        textAlign: "center",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        py: 2
                    },
                    children: [
                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                            sx: {
                                fontFamily: "body",
                                fontWeight: 600,
                                fontSize: [
                                    "16px",
                                    "18px"
                                ],
                                color: "#000000",
                                mb: 2
                            },
                            children: displayColor || productTitle
                        }),
                        displaySize && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                            sx: {
                                fontFamily: "body",
                                fontSize: [
                                    "14px",
                                    "15px"
                                ],
                                color: "#666666"
                            },
                            children: displaySize
                        })
                    ]
                }),
                (selectedVariant || (fullProduct === null || fullProduct === void 0 ? void 0 : (ref1 = fullProduct.variants) === null || ref1 === void 0 ? void 0 : ref1[0])) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Locale.Variant */.go.Variant, {
                    variant: selectedVariant || (fullProduct === null || fullProduct === void 0 ? void 0 : (ref2 = fullProduct.variants) === null || ref2 === void 0 ? void 0 : ref2[0]),
                    sx: {
                        display: "none",
                        p: {
                            fontSize: "15px"
                        }
                    },
                    className: "flex gap-1 pl-1",
                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Locale.Price */.go.Price, {
                        children: function(param) {
                            var priceV2 = param.priceV2, compareAtPriceV2 = param.compareAtPriceV2, isOnSale = param.isOnSale;
                            return isOnSale ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                                sx: {
                                    variant: "flex.row.end.start",
                                    gap: "4px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Paragraph */.nv, {
                                        children: [
                                            "• ",
                                            priceV2.locale
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                                        sx: {
                                            textDecoration: "line-through",
                                            color: "mediumDarkGray"
                                        },
                                        children: compareAtPriceV2.locale
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Paragraph */.nv, {
                                children: [
                                    "• ",
                                    priceV2.locale
                                ]
                            });
                        }
                    })
                }),
                !hasMultipleVariants && enableFullProductAccess && (hiddenProductHandles === null || hiddenProductHandles === void 0 ? void 0 : hiddenProductHandles.indexOf(fullProduct === null || fullProduct === void 0 ? void 0 : fullProduct.handle)) === -1 && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(AddToCart_AddToCart, {
                    product: fullProduct,
                    selectedVariant: selectedVariant,
                    isProductItem: true,
                    style: theme.atc,
                    addToTapCart: addToTapCart,
                    isInitialized: isInitialized
                }),
                hasMultipleVariants && enableFullProductAccess && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Link */.rU, {
                    "data-comp": "SeeDetails",
                    href: "/products/".concat(fullProduct === null || fullProduct === void 0 ? void 0 : fullProduct.handle),
                    "aria-label": "View details for ".concat(fullProduct === null || fullProduct === void 0 ? void 0 : fullProduct.title),
                    variant: "buttons.primary",
                    sx: theme.atc,
                    onClick: handleClick,
                    children: "See Details"
                })
            ]
        })
    });
});
ProductTile.displayName = "ProductCarouselToggle-ProductTile";

;// CONCATENATED MODULE: ./src/sections/ProductCarouselToggle/ProductCarousel/ProductTile/index.js


;// CONCATENATED MODULE: ./src/sections/ProductCarouselToggle/ProductCarousel/ProductCarousel.theme.js

var ProductCarousel_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        position: "relative",
        width: "100%"
    };
    this.swiper = {
        overflow: "visible",
        pb: [
            3,
            4
        ]
    };
}());

;// CONCATENATED MODULE: ./src/sections/ProductCarouselToggle/ProductCarousel/ProductCarousel.jsx










core_class/* default.use */.Z.use([
    a11y/* default */.Z
]);
var ProductCarousel = ProductCarousel_theme_themed(function(param) {
    var theme = param.theme, products = param.products, swiper = param.swiper, setSwiper = param.setSwiper, setIsStart = param.setIsStart, setIsEnd = param.setIsEnd;
    var count = (products === null || products === void 0 ? void 0 : products.length) >= 4;
    var defaultParams = (0,useProductSwiperParams/* useProductSwiperParams */.c)({
        isProductRecs: false,
        loopEnabled: false,
        count: count
    });
    // Override navigation to disable default arrows
    var customParams = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultParams), {
        navigation: false
    });
    // Handle swiper state changes
    var setStartAndEndOnSwiperChange = (0,react.useCallback)(function() {
        if (!swiper) return;
        setIsStart(swiper.isBeginning);
        setIsEnd(swiper.isEnd);
        swiper.on("slideChange", function() {
            setIsStart(swiper.isBeginning);
            setIsEnd(swiper.isEnd);
        });
    }, [
        swiper,
        setIsStart,
        setIsEnd
    ]);
    (0,react.useEffect)(function() {
        setStartAndEndOnSwiperChange();
    }, [
        setStartAndEndOnSwiperChange
    ]);
    if (!(products === null || products === void 0 ? void 0 : products.length)) {
        return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
            sx: {
                textAlign: "center",
                py: 4,
                color: "#666"
            },
            children: "No products available"
        });
    }
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": ProductCarousel.displayName,
        sx: {
            position: "relative"
        },
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(react_swiper/* Swiper */.t, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            onSwiper: setSwiper,
            a11y: {
                enabled: true
            }
        }, customParams), {
            children: products.map(function(item, index) {
                return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(swiper_slide/* SwiperSlide */.o, {
                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                        sx: {
                            minWidth: [
                                "min(280px,100%)",
                                "300px"
                            ],
                            flexShrink: 0
                        },
                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(ProductTile, {
                            item: item,
                            index: index
                        })
                    })
                }, index);
            })
        }))
    });
});
ProductCarousel.displayName = "ProductCarouselToggle-ProductCarousel";

;// CONCATENATED MODULE: ./src/sections/ProductCarouselToggle/ProductCarousel/index.js


;// CONCATENATED MODULE: ./src/sections/ProductCarouselToggle/ProductCarouselToggle.jsx









// Minimal test component
var ProductCarouselToggle = (0,src_utils/* withInView */.Dh)(ProductCarouselToggle_theme_themed(function(param) {
    var theme = param.theme, cms = param.cms;
    var ref, ref1;
    var ref2 = cms || {}, content = ref2.content, toggles = ref2.toggles, section = ref2.section;
    var ref3 = (0,react.useState)(0), activeToggle = ref3[0], setActiveToggle = ref3[1];
    var ref4 = (0,react.useState)(null), swiper = ref4[0], setSwiper = ref4[1];
    var ref5 = (0,react.useState)(true), isStart = ref5[0], setIsStart = ref5[1];
    var ref6 = (0,react.useState)(false), isEnd = ref6[0], setIsEnd = ref6[1];
    // Extract alignment settings
    var ref7 = content || {}, _headingAlign = ref7.headingAlign, headingAlign = _headingAlign === void 0 ? "left" : _headingAlign, _headingAlignMobile = ref7.headingAlignMobile, headingAlignMobile = _headingAlignMobile === void 0 ? "center" : _headingAlignMobile, _togglesAlign = ref7.togglesAlign, togglesAlign = _togglesAlign === void 0 ? "center" : _togglesAlign, _togglesAlignMobile = ref7.togglesAlignMobile, togglesAlignMobile = _togglesAlignMobile === void 0 ? "center" : _togglesAlignMobile;
    // Helper function to convert text alignment to flex justification
    var getFlexAlignment = function(align) {
        switch(align){
            case "left":
                return "flex-start";
            case "right":
                return "flex-end";
            case "center":
            default:
                return "center";
        }
    };
    // Check if we have enough products to show navigation
    var currentProducts = ((ref = toggles[activeToggle]) === null || ref === void 0 ? void 0 : ref.products) || [];
    var showNavigation = currentProducts.length >= 4;
    // Basic error handling
    if (!cms) {
        return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Section */.$0, {
            section: {
                bgColor: "#ffffff"
            },
            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Container */.W2, {
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                    sx: {
                        textAlign: "center",
                        py: 4
                    },
                    children: "Loading..."
                })
            })
        });
    }
    if (!(toggles === null || toggles === void 0 ? void 0 : toggles.length)) {
        return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Section */.$0, {
            section: section || {
                bgColor: "#ffffff"
            },
            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Container */.W2, {
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                    sx: {
                        textAlign: "center",
                        py: 4
                    },
                    children: "No toggles configured"
                })
            })
        });
    }
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Section */.$0, {
        section: section || {
            bgColor: "#ffffff"
        },
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Container */.W2, {
            "data-comp": ProductCarouselToggle.displayName,
            sx: (theme === null || theme === void 0 ? void 0 : theme.wrapper) || {},
            children: [
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                    sx: {
                        mb: 4,
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        flexWrap: "wrap",
                        gap: 3,
                        position: "relative",
                        zIndex: 0
                    },
                    children: [
                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                            sx: {
                                textAlign: [
                                    headingAlignMobile,
                                    headingAlign
                                ],
                                justifyContent: [
                                    getFlexAlignment(headingAlignMobile),
                                    getFlexAlignment(headingAlign), 
                                ],
                                flex: 1,
                                display: "flex",
                                alignItems: "center",
                                gap: [
                                    11,
                                    15
                                ],
                                flexDirection: [
                                    "column",
                                    "row"
                                ]
                            },
                            children: [
                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                                    as: "h2",
                                    sx: {
                                        width: [
                                            "100%",
                                            "auto"
                                        ],
                                        margin: 0,
                                        fontSize: [
                                            "36px",
                                            "56px"
                                        ],
                                        fontWeight: 400,
                                        textAlign: [
                                            headingAlignMobile,
                                            headingAlign
                                        ],
                                        fontFamily: "Reckless Neue"
                                    },
                                    children: (content === null || content === void 0 ? void 0 : content.heading) || "Shop By Color"
                                }),
                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                                    sx: {
                                        width: [
                                            "100%",
                                            "auto"
                                        ],
                                        display: "flex",
                                        flexWrap: "wrap",
                                        justifyContent: [
                                            getFlexAlignment(togglesAlignMobile),
                                            getFlexAlignment(togglesAlign), 
                                        ],
                                        gap: 2
                                    },
                                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                                        sx: {
                                            mb: 0,
                                            display: "flex",
                                            flexWrap: "wrap",
                                            gap: 2,
                                            backgroundColor: function(t) {
                                                return t.colors.gray;
                                            },
                                            borderRadius: "100px",
                                            p: "8px"
                                        },
                                        children: toggles.map(function(toggle, index) {
                                            /*#__PURE__*/ return (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("button", {
                                                type: "button",
                                                onClick: function() {
                                                    return setActiveToggle(index);
                                                },
                                                style: {
                                                    backgroundColor: activeToggle === index ? "#fff" : "transparent",
                                                    color: "#000",
                                                    border: "none",
                                                    padding: "16px",
                                                    borderRadius: "100px",
                                                    cursor: "pointer",
                                                    fontSize: "16px",
                                                    lineHeight: "1"
                                                },
                                                children: (toggle === null || toggle === void 0 ? void 0 : toggle.label) || "Toggle ".concat(index + 1)
                                            }, index);
                                        })
                                    })
                                })
                            ]
                        }),
                        showNavigation && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                            sx: {
                                display: [
                                    "none",
                                    "flex"
                                ],
                                gap: 2,
                                alignItems: "center",
                                position: "absolute",
                                right: 0
                            },
                            children: [
                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(NavigationButton_NavigationButton, {
                                    onClick: function() {
                                        return swiper === null || swiper === void 0 ? void 0 : swiper.slidePrev();
                                    },
                                    inactive: isStart,
                                    count: showNavigation,
                                    alt: "Previous products",
                                    direction: "prev",
                                    sx: {
                                        position: "static",
                                        transform: "none"
                                    }
                                }),
                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(NavigationButton_NavigationButton, {
                                    onClick: function() {
                                        return swiper === null || swiper === void 0 ? void 0 : swiper.slideNext();
                                    },
                                    src: "/svgs/arrow-right.svg#arrow-right",
                                    alt: "Next products",
                                    inactive: isEnd,
                                    isNext: true,
                                    direction: "next",
                                    count: showNavigation,
                                    sx: {
                                        position: "static",
                                        transform: "none"
                                    }
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(ProductCarousel, {
                        products: ((ref1 = toggles[activeToggle]) === null || ref1 === void 0 ? void 0 : ref1.products) || [],
                        swiper: swiper,
                        setSwiper: setSwiper,
                        setIsStart: setIsStart,
                        setIsEnd: setIsEnd
                    })
                })
            ]
        })
    });
}), {
    triggerOnce: true
});
ProductCarouselToggle.displayName = "ProductCarouselToggle";
ProductCarouselToggle.Schema = ProductCarouselToggle_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/ProductCarouselToggle/index.js


;// CONCATENATED MODULE: ./src/sections/index.js





















































/* harmony default export */ var sections = ([
    AccessibilityStatement,
    Accordions,
    Aftership,
    BlogGrid,
    CollectionCategories,
    CollectionGrid_CollectionGrid,
    CollectionHero,
    FeaturedArticle,
    FeaturedIcons,
    FeaturedThreeTile,
    FeaturedTwoTile,
    Form,
    FormBuilder,
    FourSixty,
    FullPageReviews,
    FunctionalSchemaDemo,
    HalfMedia,
    Hero,
    HeroSlider,
    HeroValueProps,
    Html,
    sections_Image_Image_Image,
    KlaviyoForm,
    LinkFarm,
    Locator,
    MalomoTracking,
    Markdown,
    PressSlider,
    ProductComparison,
    ProductRecs,
    ProductsSlider,
    ProductUpsells,
    QuickSelectCollections,
    ReviewSlider,
    SearchResults,
    SuperCollection,
    TabbedThreeTile,
    ThreeTile,
    TwoThirdsMedia,
    TwoTile,
    Wishlist,
    LoyaltyLionWelcome,
    LoyaltyLionHowItWorks,
    LoyaltyLionPoints,
    EmbedContent,
    LoyaltylionRewardsList,
    LoyaltylionStaticRewards,
    VideoWise,
    ShopByCategory,
    QuizSection,
    Product,
    Testimonials,
    ProductCarouselToggle, 
]);

;// CONCATENATED MODULE: ./src/settings/account/forgot.js
/* harmony default export */ var forgot = ({
    label: "Forgot Password Settings",
    name: "forgot",
    component: "group",
    fields: [
        // ForgotForm settings
        {
            label: "Heading",
            name: "heading",
            component: "text",
            defaultValue: "RESET PASSWORD"
        },
        {
            label: "Sub heading",
            name: "subHeading",
            component: "textarea",
            defaultValue: "Enter your email and we'll send you a link to reset your password."
        },
        {
            label: "Button text",
            name: "buttonText",
            component: "text",
            defaultValue: "Reset"
        },
        {
            label: "Return link text",
            name: "return",
            component: "text",
            defaultValue: "Back to Login"
        },
        // LoginRegisterLayout settings
        {
            label: "Image",
            name: "image",
            component: "image",
            defaultValue: "https://images.unsplash.com/photo-1614098805147-61657513491f?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=924&q=80",
            description: "Image that will be seen on the right of the reset form."
        }, 
    ]
});

;// CONCATENATED MODULE: ./src/settings/account/login.js
/* harmony default export */ var login = ({
    label: "Login Settings",
    name: "login",
    component: "group",
    fields: [
        // LoginForm settings
        {
            label: "Heading",
            name: "heading",
            component: "text",
            defaultValue: "SIGN IN"
        },
        {
            label: "Sub heading",
            name: "subHeading",
            component: "textarea",
            defaultValue: ""
        },
        {
            label: "Button text",
            name: "buttonText",
            component: "text",
            defaultValue: "Sign In"
        },
        {
            label: "Forgot password text",
            name: "resetText",
            component: "text",
            defaultValue: "Forgot your password?"
        },
        {
            label: "Create account text",
            name: "createText",
            component: "text",
            defaultValue: "Don't have an account?"
        },
        {
            label: "Create account link text",
            name: "createLink",
            component: "text",
            defaultValue: "Sign up now"
        },
        {
            label: "Need help? text",
            name: "helpText",
            component: "text",
            defaultValue: "Need help?"
        },
        {
            label: "Need help? link text",
            name: "helpLink",
            component: "link",
            defaultValue: {
                text: "Contact Us.",
                url: "/pages/contact-us"
            }
        },
        // LoginRegisterLayout settings
        {
            label: "Image",
            name: "image",
            component: "image",
            defaultValue: "https://images.unsplash.com/photo-1620492435196-5116e4a319ce?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=924&q=80",
            description: "Image that will be seen on the right of the login form."
        }, 
    ]
});

;// CONCATENATED MODULE: ./src/settings/account/menu.js
// menu
/* harmony default export */ var menu = ({
    label: "Account Menu Settings",
    name: "menu",
    component: "group",
    fields: [
        {
            name: "items",
            label: "Menu items",
            component: "group-list",
            itemProps: {
                label: "{{item.text}}"
            },
            fields: [
                {
                    name: "text",
                    label: "Text",
                    component: "text"
                },
                {
                    name: "url",
                    label: "Url",
                    component: "text"
                },
                {
                    name: "newTab",
                    label: "Open In New Tab",
                    component: "toggle",
                    toggleLabels: {
                        true: "Yes",
                        false: "No"
                    },
                    defaultValue: false
                }, 
            ]
        },
        {
            label: "Sign Out",
            name: "withSignOut",
            component: "toggle",
            toggleLabels: {
                true: "Yes",
                false: "No"
            },
            defaultValue: true
        }, 
    ],
    defaultValue: {
        items: [
            {
                text: "Order History",
                handle: "orders"
            },
            {
                text: "Edit Profile",
                handle: "edit-profile"
            },
            {
                text: "Address Book",
                handle: "address-book"
            },
            {
                text: "Payment Methods",
                handle: "payment-methods"
            },
            {
                text: "Favorites",
                handle: "favorites"
            }, 
        ],
        withSignOut: true
    }
});

;// CONCATENATED MODULE: ./src/settings/account/register.js
/* harmony default export */ var register = ({
    label: "Register Settings",
    name: "register",
    component: "group",
    fields: [
        // RegisterForm settings
        {
            label: "Heading",
            name: "heading",
            component: "text",
            defaultValue: "SIGN UP"
        },
        {
            label: "Sub Heading",
            name: "subHeading",
            component: "textarea",
            defaultValue: ""
        },
        {
            label: "Button Text",
            name: "buttonText",
            component: "text",
            defaultValue: "Sign Up"
        },
        {
            label: "Return Link Text",
            name: "return",
            component: "text",
            defaultValue: "Return to Login"
        },
        {
            label: "Klaviyo List Id",
            name: "listId",
            component: "text",
            defaultValue: "Mrk7yV"
        },
        {
            label: "Email Marketing Text",
            name: "emailMarketingText",
            component: "text",
            defaultValue: "Subscribe to email newsletter"
        },
        // LoginRegisterLayout settings
        {
            label: "Image",
            name: "image",
            component: "image",
            defaultValue: "https://images.unsplash.com/photo-1533641568252-76ce0951d5b4?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=924&q=80",
            description: "Image that will be seen on the right of the register form."
        }, 
    ]
});

;// CONCATENATED MODULE: ./src/settings/account/reset.js
/* harmony default export */ var account_reset = ({
    label: "Password Reset Settings",
    name: "reset",
    component: "group",
    fields: [
        // RegisterForm settings
        {
            label: "Heading",
            name: "heading",
            component: "text",
            defaultValue: "UPDATE PASSWORD"
        },
        {
            label: "Sub heading",
            name: "subHeading",
            component: "textarea",
            defaultValue: "Please enter your new password."
        },
        {
            label: "Button text",
            name: "buttonText",
            component: "text",
            defaultValue: "Update"
        },
        {
            label: "Return link text",
            name: "return",
            component: "text",
            defaultValue: "Cancel"
        },
        // LoginRegisterLayout settings
        {
            label: "Image",
            name: "image",
            component: "image",
            defaultValue: "https://images.unsplash.com/photo-1533641568252-76ce0951d5b4?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=924&q=80",
            description: "Image that will be seen on the right of the reset form."
        }, 
    ]
});

;// CONCATENATED MODULE: ./src/settings/account/index.js





// account settings
/* harmony default export */ var account = ({
    label: "Account Settings",
    name: "account",
    component: "group",
    fields: [
        {
            name: "heading",
            label: "Heading",
            component: "text",
            defaultValue: "My account"
        },
        menu,
        forgot,
        login,
        register,
        account_reset, 
    ]
});

;// CONCATENATED MODULE: ./src/settings/analytics.js
/* harmony default export */ var analytics = ({
    label: "Analytics",
    name: "analytics",
    component: "group",
    description: "Enable Shopify analytics",
    fields: [
        {
            label: "Enabled",
            name: "enabled",
            component: "toggle",
            description: 'Ensure "NEXT_PUBLIC_SHOPIFY_SHOP_ID" is set as an env var',
            toggleLabels: {
                true: "On",
                false: "Off"
            },
            defaultValue: true
        }, 
    ]
});

;// CONCATENATED MODULE: ./src/settings/blog.js


/* harmony default export */ var blog = ({
    label: "Blog Settings",
    name: "blogSettings",
    component: "group",
    fields: [
        {
            label: "Blog page Settings",
            name: "text",
            description: "Heading, color, alignment, position",
            component: "group",
            fields: [
                {
                    label: "Heading",
                    name: "heading",
                    component: "markdown",
                    description: 'Tip: You can ensure heading is "h1" by starting with "# " e.g. "# Shop All". Text below will become large and bold to indicate "h1"'
                },
                {
                    component: "select",
                    name: "colorDt",
                    label: "Text color (tablet & desktop)",
                    options: [
                        {
                            label: "Default",
                            value: ""
                        }
                    ].concat((0,_to_consumable_array/* default */.Z)(common/* color.options */.$_.options))
                },
                {
                    component: "select",
                    name: "color",
                    label: "Text color (mobile)",
                    options: [
                        {
                            label: "Default",
                            value: ""
                        }
                    ].concat((0,_to_consumable_array/* default */.Z)(common/* color.options */.$_.options))
                },
                {
                    name: "alignmentDt",
                    label: "Alignment",
                    component: "radio-group",
                    direction: "horizontal",
                    variant: "radio",
                    options: common/* align.options */.AJ.options
                },
                {
                    name: "positionDt",
                    component: "select",
                    label: "Position",
                    options: common/* position.flex */.FK.flex
                },
                {
                    name: "alignment",
                    label: "Alignment (mobile)",
                    component: "radio-group",
                    direction: "horizontal",
                    variant: "radio",
                    options: common/* align.options */.AJ.options
                },
                {
                    name: "position",
                    component: "select",
                    label: "Position (mobile)",
                    options: common/* position.flex */.FK.flex
                }, 
            ],
            defaultValue: {
                heading: "# Blog",
                color: "",
                colorDt: "",
                alignmentDt: "center",
                positionDt: "flex-end center",
                alignment: "center"
            }
        }, 
    ]
});

;// CONCATENATED MODULE: ./src/settings/cart.js
/* harmony default export */ var cart = ({
    label: "Cart Settings",
    name: "cart",
    component: "group",
    fields: [
        {
            name: "heading",
            component: "text",
            label: "Heading",
            defaultValue: "My Cart"
        },
        {
            label: "Bulk ordering Settings",
            name: "bulkOrdering",
            component: "group",
            fields: [
                {
                    name: "maxQty",
                    component: "number",
                    label: "Cart max quantity",
                    description: "Max quantity of products in cart. Set ignored products below"
                },
                {
                    name: "errorMessage",
                    component: "markdown",
                    label: "Pdp message",
                    description: "Message when max quantity is already met on PDP"
                },
                {
                    name: "itemMessage",
                    component: "markdown",
                    label: "Cart message",
                    description: "Message when max quantity is already met in cart item"
                },
                {
                    name: "ignoredProducts",
                    label: "Ignored products",
                    component: "group-list",
                    description: "Products ignored from max quantity and bulk ordering limitations",
                    itemProps: {
                        label: "{{item.product.handle}}" || 0
                    },
                    fields: [
                        {
                            name: "product",
                            component: "productSearch",
                            label: "Product"
                        }, 
                    ],
                    defaultValue: [
                        {
                            product: {
                                handle: "byob-charge"
                            }
                        },
                        {
                            product: {
                                handle: "parcel-protection"
                            }
                        },
                        {
                            product: {
                                handle: "brumate-e-gift-card"
                            }
                        }, 
                    ]
                }, 
            ],
            defaultValue: {
                maxQty: 150,
                errorMessage: "Please contact [bulkorders@brumate.com](mailto:bulkorders@brumate.com) for orders over 150.",
                itemMessage: "Please contact [bulkorders@brumate.com](mailto:bulkorders@brumate.com) for orders over 150."
            }
        },
        {
            name: "mixedCartLock",
            component: "group",
            label: "Mixed Cart Lock",
            fields: [
                {
                    name: "enabled",
                    label: "Enable Mixed Cart Lock",
                    component: "toggle",
                    toggleLabels: {
                        true: "Enabled",
                        false: "Disabled"
                    }
                },
                {
                    name: "collection",
                    label: "Collection",
                    component: "collections",
                    description: "Collection defining the products that must be purcased individually"
                },
                {
                    name: "products",
                    label: "Product List",
                    component: "list",
                    description: "Products that must be purchased individually, use in replacement of the collection option above",
                    field: {
                        component: "productSearch",
                        label: "Product"
                    }
                },
                {
                    name: "message",
                    label: "Message",
                    component: "markdown",
                    description: "Message displayed when a customer cart has mixed products"
                }, 
            ]
        },
        {
            label: "Cart empty Settings",
            name: "empty",
            component: "group",
            fields: [
                {
                    label: "Message",
                    name: "message",
                    component: "text",
                    defaultValue: "Your cart is empty"
                },
                {
                    name: "ctas",
                    label: "Links",
                    component: "group-list",
                    itemProps: {
                        label: "{{item.cta.text}}"
                    },
                    defaultItem: {
                        cta: {
                            text: "Shop Best Sellers",
                            url: "/collections/best-sellers"
                        }
                    },
                    fields: [
                        {
                            name: "cta",
                            component: "link",
                            label: "Link"
                        }, 
                    ],
                    defaultValue: [
                        {
                            cta: {
                                text: "Shop Best Sellers",
                                url: "/collections/best-sellers"
                            }
                        },
                        {
                            cta: {
                                text: "Shop New Arrivals",
                                url: "/collections/new-releases"
                            }
                        }, 
                    ]
                }, 
            ]
        },
        {
            label: "Free shipping meter Settings",
            name: "freeShipping",
            component: "group",
            fields: [
                {
                    name: "enabled",
                    label: "Enable free shipping meter",
                    component: "toggle",
                    toggleLabels: {
                        true: "On",
                        false: "Off"
                    }
                },
                {
                    name: "spend",
                    component: "number",
                    label: "Qualifying spend (USD)"
                },
                {
                    name: "message",
                    component: "text",
                    label: "Message",
                    description: 'Denote placement of the remaining spend with a "$"'
                },
                {
                    name: "messageQualified",
                    component: "text",
                    label: "Qualified message"
                }, 
            ],
            defaultValue: {
                enabled: true,
                spend: 50,
                message: "You're only $ away from free shipping!",
                messageQualified: "You're qualified for free shipping!"
            }
        },
        {
            label: "Upsell Settings",
            name: "upsell",
            component: "group",
            fields: [
                {
                    name: "enabled",
                    label: "Enable upsell",
                    component: "toggle",
                    toggleLabels: {
                        true: "On",
                        false: "Off"
                    }
                },
                {
                    name: "message",
                    component: "text",
                    label: "Message w/ active cart"
                },
                {
                    name: "messageEmpty",
                    component: "text",
                    label: "Message w/ empty cart"
                },
                {
                    name: "limit",
                    component: "number",
                    label: "Number of upsell products"
                }, 
            ],
            defaultValue: {
                enabled: true,
                message: "Complete your collection with these favorites",
                messageEmpty: "Start out with these fan favorites!",
                limit: 4
            }
        }, 
    ]
});

;// CONCATENATED MODULE: ./src/settings/collection.js
/* harmony default export */ var collection = ({
    label: "Collection Settings",
    name: "collection",
    component: "group",
    fields: [
        {
            label: "Enable sort",
            name: "sortEnabled",
            component: "toggle",
            toggleLabels: {
                true: "On",
                false: "Off"
            },
            defaultValue: true
        },
        {
            label: "Colors",
            name: "colors",
            component: "group",
            fields: [
                {
                    label: "Color Swatches",
                    name: "swatches",
                    component: "group-list",
                    itemProps: {
                        label: "{{item.name}}"
                    },
                    defaultItem: {
                        name: "New Color"
                    },
                    fields: [
                        {
                            label: "Color Name",
                            name: "name",
                            component: "text",
                            description: "Must match exactly the color name in the color filters"
                        },
                        {
                            label: "Color",
                            name: "color",
                            component: "color"
                        },
                        {
                            name: "image",
                            label: "Image",
                            component: "image",
                            description: "If provided, this image will override the color"
                        }, 
                    ],
                    defaultValue: [
                        {
                            name: "Purple",
                            color: "#9873AF"
                        },
                        {
                            name: "Gray",
                            color: "#8C8C8D"
                        },
                        {
                            name: "Blue",
                            color: "#7190BE"
                        },
                        {
                            name: "Black",
                            color: "#000000"
                        },
                        {
                            name: "Pink",
                            color: "#FFC0CB"
                        },
                        {
                            name: "Brown",
                            color: "#6F4E37"
                        },
                        {
                            name: "Green",
                            color: "#98D28F"
                        },
                        {
                            name: "Multi",
                            image: {
                                src: "https://cdn.shopify.com/s/files/1/1114/2308/files/multi-color-swatch.jpg?v=1657306616"
                            }
                        },
                        {
                            name: "White",
                            color: "#FFFFFF"
                        },
                        {
                            name: "Red",
                            color: "#C51F1F"
                        },
                        {
                            name: "Gold",
                            color: "#C9AA7C"
                        },
                        {
                            name: "Orange",
                            color: "#D85720"
                        },
                        {
                            name: "Yellow",
                            color: "#EEDF8F"
                        }, 
                    ]
                }, 
            ]
        },
        {
            label: "SEO Footer",
            name: "seo",
            component: "group",
            fields: [
                {
                    label: "SEO Text Groups",
                    name: "groups",
                    component: "group-list",
                    itemProps: {
                        label: "{{item.title}}"
                    },
                    defaultItem: {
                        title: "New SEO Text Group",
                        body: ""
                    },
                    fields: [
                        {
                            label: "Title (internal)",
                            name: "title",
                            component: "text"
                        },
                        {
                            label: "Tags (collection handles)",
                            name: "collections",
                            component: "tags",
                            description: 'Collection handles that will use this SEO text, e.g. "hopsulator-slim". Hit enter or spacebar to add to tags'
                        },
                        {
                            label: "Body",
                            name: "body",
                            component: "markdown"
                        }, 
                    ]
                }, 
            ]
        }, 
    ]
});

;// CONCATENATED MODULE: ./src/settings/footer.js

/* harmony default export */ var footer = ({
    label: "Footer Settings",
    name: "footer",
    component: "group",
    fields: [
        {
            label: "Email marketing",
            name: "emailSignup",
            component: "group",
            fields: [
                {
                    label: "Heading",
                    name: "heading",
                    component: "text"
                },
                {
                    label: "Subtext",
                    name: "subtext",
                    component: "textarea"
                },
                {
                    label: "Small Text",
                    name: "small_text",
                    component: "markdown"
                }, 
            ],
            defaultValue: {
                heading: "Stay In Touch",
                subtext: "Keep the buzz going with our newsletter to get the inside scoop on new products, discounts, drink recipes and more."
            }
        },
        {
            label: "Social",
            name: "social",
            component: "group",
            fields: [
                {
                    label: "Heading",
                    name: "heading",
                    component: "text"
                }, 
            ],
            defaultValue: {
                heading: "Stay Connected"
            }
        },
        {
            label: "Benefits",
            name: "benefits",
            component: "group",
            fields: [
                {
                    label: "Items",
                    name: "items",
                    component: "group-list",
                    itemProps: {
                        label: "{{item.label}}"
                    },
                    defaultItem: {
                        icon: "design",
                        label: "Innovative Design"
                    },
                    fields: [
                        {
                            name: "icon",
                            component: "select",
                            label: "Icon",
                            options: [
                                {
                                    label: "Innovative Design",
                                    value: "design"
                                },
                                {
                                    label: "Lifetime Warranty",
                                    value: "warranty"
                                },
                                {
                                    label: "Customer Service",
                                    value: "service"
                                },
                                {
                                    label: "Free Shipping",
                                    value: "shipping"
                                }, 
                            ]
                        },
                        {
                            label: "Label",
                            name: "label",
                            component: "text"
                        }, 
                    ],
                    defaultValue: [
                        {
                            icon: "design",
                            label: "Innovative Design"
                        },
                        {
                            icon: "warranty",
                            label: "Lifetime Warranty"
                        },
                        {
                            icon: "service",
                            label: "Flawless Customer Service"
                        },
                        {
                            icon: "shipping",
                            label: "Free Shipping & Returns on U.S. Orders Over $50"
                        }, 
                    ]
                },
                {
                    component: "select",
                    name: "bgColor",
                    label: "Background color",
                    options: common/* color.options */.$_.options,
                    defaultValue: common/* color.value.gray */.$_.value.gray
                },
                {
                    component: "select",
                    name: "color",
                    label: "Text & icon color",
                    options: common/* color.options */.$_.options,
                    defaultValue: common/* color.value.text */.$_.value.text
                }, 
            ]
        },
        {
            label: "Footer menu",
            name: "menu",
            component: "group-list",
            itemProps: {
                label: "{{item.name}}"
            },
            defaultItem: {
                name: "Shop",
                subMenuItems: [
                    {
                        cta: {
                            text: "Wine",
                            url: "/collections/wine"
                        }
                    },
                    {
                        cta: {
                            text: "Beer",
                            url: "/collections/beer"
                        }
                    },
                    {
                        cta: {
                            text: "Spirits",
                            url: "/collections/spirits"
                        }
                    }, 
                ]
            },
            fields: [
                {
                    label: "Menu item name",
                    name: "name",
                    component: "text"
                },
                {
                    label: "Sub menu",
                    name: "subMenuItems",
                    component: "group-list",
                    itemProps: {
                        label: "{{item.cta.text}}"
                    },
                    defaultItem: {
                        cta: {
                            text: "Wine",
                            url: "/collections/wine"
                        }
                    },
                    fields: [
                        {
                            label: "Link",
                            name: "cta",
                            component: "link"
                        }, 
                    ]
                }, 
            ],
            defaultValue: [
                {
                    name: "Shop",
                    subMenuItems: [
                        {
                            cta: {
                                text: "Wine",
                                url: "/collections/wine"
                            }
                        },
                        {
                            cta: {
                                text: "Beer",
                                url: "/collections/beer"
                            }
                        },
                        {
                            cta: {
                                text: "Spirits",
                                url: "/collections/spirits"
                            }
                        }, 
                    ]
                },
                {
                    name: "Help",
                    subMenuItems: [
                        {
                            cta: {
                                text: "Mobile App",
                                url: "/pages/mobile-app"
                            }
                        },
                        {
                            cta: {
                                text: "Store Locator",
                                url: "/pages/store-locator"
                            }
                        },
                        {
                            cta: {
                                text: "Media Inquiries",
                                url: "/pages/media-inquiries"
                            }
                        }, 
                    ]
                },
                {
                    name: "Brand",
                    subMenuItems: [
                        {
                            cta: {
                                text: "Our Story",
                                url: "/pages/our-story"
                            }
                        },
                        {
                            cta: {
                                text: "Sustainability",
                                url: "/pages/sustainability"
                            }
                        },
                        {
                            cta: {
                                text: "Blog",
                                url: "/blogs/articles"
                            }
                        }, 
                    ]
                }, 
            ]
        },
        {
            label: "Legal links",
            name: "legalLinks",
            component: "group-list",
            itemProps: {
                label: "{{item.cta.text}}"
            },
            defaultItem: {
                cta: {
                    text: "Privacy Policy",
                    url: "/pages/privacy-policy"
                }
            },
            fields: [
                {
                    label: "Link",
                    name: "cta",
                    component: "link"
                }, 
            ],
            defaultValue: [
                {
                    cta: {
                        text: "Privacy Policy",
                        url: "/pages/privacy-policy"
                    }
                },
                {
                    cta: {
                        text: "Terms & Conditions",
                        url: "/pages/terms-conditions"
                    }
                }, 
            ]
        },
        {
            label: "Site copyright notice",
            name: "copyrightNotice",
            component: "text",
            defaultValue: "All Rights Reserved"
        }, 
    ]
});

;// CONCATENATED MODULE: ./src/settings/gatedPages.js


var page = function() {
    return {
        label: "Page Settings",
        name: "page",
        description: "Creates Pages to add products, toggle products as actionable,",
        component: "group",
        fields: [
            {
                component: "group-list",
                name: "pages",
                label: "Pages",
                itemProps: {
                    label: "{{item.pageUrl}}" || 0
                },
                fields: [
                    {
                        name: "enableFullProductAccess",
                        label: "Enable Products As Actionable",
                        description: "Enables products to be accessible and purchaseable",
                        component: "toggle",
                        toggleLabels: {
                            true: "On",
                            false: "Off"
                        },
                        defaultValue: false
                    },
                    {
                        label: "Optional: Page Url",
                        name: "pageUrl",
                        component: "text",
                        description: "This is required if you need to override products in collection grids Ex: /collections/vintage-florals or /pages/vintage-florals. "
                    },
                    {
                        component: "group-list",
                        name: "products",
                        label: "Products",
                        description: "These products will display in collection grids and will also be hidden from search results",
                        itemProps: {
                            label: "{{item.product.handle}}" || 0
                        },
                        fields: [
                            {
                                component: "productSearch",
                                name: "product",
                                label: "Product"
                            }, 
                        ]
                    }, 
                ]
            }, 
        ]
    };
};
var gatedPages_image = function() {
    return {
        label: "Image Settings",
        name: "image",
        description: "Image, image position",
        component: "group",
        fields: [
            {
                name: "alt",
                component: "text",
                description: "Provide a brief description of the image for accessibility compliance",
                label: "Alt"
            },
            {
                name: "imageDt",
                label: "Image (desktop)",
                component: "image"
            },
            {
                name: "image",
                label: "Image (mobile)",
                component: "image"
            },
            {
                name: "position",
                component: "select",
                label: "Image position",
                options: [
                    {
                        value: "left-aligned",
                        label: "Left Aligned"
                    },
                    {
                        value: "full",
                        label: "Full"
                    }, 
                ]
            }, 
        ],
        defaultValue: {
            alt: "Password Protected Image",
            imageDt: {
                src: "https://cdn.shopify.com/s/files/1/1114/2308/files/Era-Teaser-FullSize_D.jpg?v=1685638677"
            },
            image: {
                src: "https://cdn.shopify.com/s/files/1/1114/2308/files/Era-Teaser-FullSize_M.jpg?v=1685638680"
            },
            position: "full"
        }
    };
};
var gatedPages_text = function(param) {
    var _$color = param.color;
    return {
        label: "Text Settings",
        name: "text",
        description: "Superheading, heading, text color",
        component: "group",
        fields: [
            {
                name: "superheading",
                label: "Superheading",
                component: "text"
            },
            {
                name: "superheadingColor",
                label: "Superheading Text color",
                component: "select",
                options: [
                    {
                        label: "Default",
                        value: ""
                    }
                ].concat((0,_to_consumable_array/* default */.Z)(_$color.options))
            },
            {
                name: "heading",
                label: "Heading",
                component: "markdown",
                description: 'Tip: You can ensure heading is "h1" by starting with "# " e.g. "# Shop All". Text below will become large and bold to indicate "h1"'
            },
            {
                name: "headingColor",
                label: "Heading Text color",
                component: "select",
                options: [
                    {
                        label: "Default",
                        value: ""
                    }
                ].concat((0,_to_consumable_array/* default */.Z)(_$color.options))
            },
            {
                name: "headingOption",
                label: "Font Family Heading Option",
                component: "radio-group",
                direction: "horizontal",
                variant: "radio",
                options: [
                    {
                        label: "Reckless Neue",
                        value: "text.h1"
                    },
                    {
                        label: "Fellix",
                        value: "text.h1.2"
                    }, 
                ],
                defaultValue: "text.h1.2"
            },
            {
                name: "copy",
                label: "Copy",
                component: "markdown"
            },
            {
                name: "copyColor",
                label: "Copy Text color",
                component: "select",
                options: [
                    {
                        label: "Default",
                        value: ""
                    }
                ].concat((0,_to_consumable_array/* default */.Z)(_$color.options))
            }, 
        ],
        defaultValue: {
            superheading: "07.24.23",
            heading: "A New Era",
            copy: "Unlock Your Exclusive Access To See Era",
            headingOption: "text.h1.2",
            superheadingColor: "#FFFFFF",
            headingColor: "#FFFFFF",
            copyColor: "#FFFFFF"
        }
    };
};
var closeControl = function() {
    return {
        label: "Close Control Settings",
        name: "closeControl",
        description: "Icon color, Redirect Url",
        component: "group",
        fields: [
            {
                label: "Redirect URL Path",
                name: "redirectUrlPath",
                description: "Add a url path to redirect users to when closing password protected modal. Example: /collections/brutank",
                component: "text"
            },
            {
                name: "iconColor",
                label: "Icon Color",
                component: "select",
                options: [
                    {
                        label: "Default",
                        value: ""
                    }
                ].concat((0,_to_consumable_array/* default */.Z)(common/* color.options */.$_.options))
            }, 
        ],
        defaultValue: {
            redirectUrlPath: "/",
            iconColor: "#FFFFFF"
        }
    };
};
var gatedPages_password = function(param) {
    var _$color = param.color;
    return {
        label: "Password Settings",
        name: "password",
        description: "Icon color, Redirect Url",
        component: "group",
        fields: [
            {
                label: "Password",
                name: "password",
                component: "text"
            },
            {
                name: "passwordColor",
                label: "Password Field and Text Color",
                component: "select",
                options: [
                    {
                        label: "Default",
                        value: ""
                    }
                ].concat((0,_to_consumable_array/* default */.Z)(_$color.options))
            },
            {
                label: "Error Message",
                name: "errorMessage",
                component: "text"
            },
            {
                name: "errorMessageColor",
                label: "Error Message Color",
                component: "select",
                options: [
                    {
                        label: "Default",
                        value: ""
                    }
                ].concat((0,_to_consumable_array/* default */.Z)(_$color.options))
            }, 
        ],
        defaultValue: {
            password: "password123",
            passwordColor: "#E1FF01",
            errorMessage: "Incorrect Password. Please try again",
            errorMessageColor: "#AE2807"
        }
    };
};
/* harmony default export */ var gatedPages = ({
    label: "Gated Pages Settings",
    name: "gatedPages",
    component: "group",
    fields: [
        {
            component: "group-list",
            name: "gatedPages",
            label: "Gated Pages",
            itemProps: {
                label: "{{item.text.heading}}" || 0
            },
            fields: [
                {
                    name: "enable",
                    label: "Enable",
                    component: "toggle",
                    description: "Disables or Activates Gated Page. Disabling will ignore all settings below",
                    toggleLabels: {
                        true: "On",
                        false: "Off"
                    },
                    defaultValue: true
                },
                {
                    name: "show",
                    label: "Hide/Show",
                    component: "toggle",
                    description: "Hides or Shows Gated Page",
                    toggleLabels: {
                        true: "Show",
                        false: "Hide"
                    },
                    defaultValue: true
                },
                {
                    name: "backgroundColor",
                    label: "Background Color",
                    component: "select",
                    options: [
                        {
                            label: "Default",
                            value: ""
                        }
                    ].concat((0,_to_consumable_array/* default */.Z)(common/* color.options */.$_.options)),
                    defaultValue: "#010101"
                },
                closeControl({
                    color: common/* color */.$_
                }),
                gatedPages_image(),
                page(),
                gatedPages_password({
                    color: common/* color */.$_
                }),
                gatedPages_text({
                    color: common/* color */.$_
                }), 
            ]
        }, 
    ]
});

;// CONCATENATED MODULE: ./src/settings/giftWithPurchase.js
/* harmony default export */ var giftWithPurchase = ({
    component: "group",
    name: "gwp",
    label: "Gift With Purchase Settings",
    fields: [
        {
            component: "toggle",
            name: "enabled",
            label: "Enable GWP",
            toggleLabels: {
                true: "Enable",
                false: "Disable"
            },
            defaultValue: false
        },
        {
            component: "number",
            name: "threshold",
            label: "Cart Threshold",
            defaultValue: 100
        },
        {
            component: "text",
            name: "code",
            label: "Discount Code",
            defaultValue: "TREAT"
        },
        {
            component: "group",
            name: "modalText",
            label: "Modal Text Settings",
            fields: [
                {
                    component: "text",
                    name: "heading",
                    label: "Heading",
                    defaultValue: "You qualified for a free gift with purchase!"
                },
                {
                    component: "text",
                    name: "body",
                    label: "Body text",
                    defaultValue: "Code 'TREAT' will be applied at checkout."
                },
                {
                    component: "text",
                    name: "ctaLabel",
                    label: "Add to Bag Label",
                    defaultValue: "Add to Bag"
                },
                {
                    component: "text",
                    name: "ctaSuccessLabel",
                    label: "Add to Bag Success Label",
                    defaultValue: "Product Added"
                },
                {
                    component: "text",
                    name: "cancelLabel",
                    label: "Cancel Label",
                    defaultValue: "No Thanks"
                }, 
            ]
        },
        {
            component: "group",
            name: "cart",
            label: "Cart Settings",
            fields: [
                {
                    component: "markdown",
                    name: "link",
                    label: "Reopen Message",
                    defaultValue: "You qualified for a free gift. Select your gift."
                },
                {
                    component: "markdown",
                    name: "link_success",
                    label: "Gift Added to cart Message",
                    defaultValue: "Free gift added to cart"
                }, 
            ]
        },
        {
            component: "group",
            name: "products",
            label: "Products Settings",
            fields: [
                {
                    label: "Product(s) Display Type",
                    name: "displayType",
                    component: "radio-group",
                    direction: "horizontal",
                    variant: "radio",
                    options: [
                        {
                            value: "image",
                            label: "Image (1 product)"
                        },
                        {
                            value: "slider",
                            label: "Product Slider (1-3 products)"
                        }, 
                    ]
                },
                {
                    component: "group",
                    name: "imageGroup",
                    label: "Image Settings",
                    fields: [
                        {
                            component: "productSearch",
                            name: "giftProduct",
                            label: "Gift Product",
                            description: "Ensure product is not draft, otherwise it will be ignored"
                        },
                        {
                            component: "image",
                            name: "desktopImage",
                            label: "Desktop Image"
                        },
                        {
                            component: "image",
                            name: "mobileImage",
                            label: "Mobile Image"
                        }, 
                    ]
                },
                {
                    component: "group",
                    name: "sliderGroup",
                    label: "Products Slider Settings",
                    fields: [
                        {
                            component: "group-list",
                            name: "giftProducts",
                            label: "Gift Products",
                            description: "Add up to 3 products. Ensure these are not draft products, otherwise they will be ignored",
                            itemProps: {
                                label: "{{item.giftProduct.handle}}" || 0
                            },
                            fields: [
                                {
                                    component: "text",
                                    name: "heading",
                                    label: "Heading"
                                },
                                {
                                    component: "text",
                                    name: "copy",
                                    label: "Copy"
                                },
                                {
                                    component: "productSearch",
                                    name: "giftProduct",
                                    label: "Gift Product"
                                }, 
                            ]
                        }, 
                    ]
                },
                {
                    name: "excludedProducts",
                    label: "Excluded Products",
                    component: "group-list",
                    description: "Products excluded from cart threshold",
                    itemProps: {
                        label: "{{item.product.handle}}" || 0
                    },
                    fields: [
                        {
                            name: "product",
                            component: "productSearch",
                            label: "Product"
                        }, 
                    ]
                }, 
            ]
        }, 
    ]
});

;// CONCATENATED MODULE: ./src/settings/header/promoBar.js

var promoBar = {
    label: "Promobar",
    name: "promoBar",
    component: "group",
    fields: [
        {
            name: "enabled",
            label: "Enabled",
            component: "toggle",
            toggleLabels: {
                true: "Yes",
                false: "No"
            },
            defaultValue: true
        },
        {
            component: "number",
            name: "duration",
            label: "Autoplay duration",
            description: "Time on each message. (sec)",
            step: 1,
            defaultValue: 3
        },
        {
            component: "number",
            name: "speed",
            label: "Autoplay speed",
            description: "Time between message transitions. (sec)",
            step: 0.25,
            defaultValue: 0.75
        },
        {
            label: "Messages",
            name: "messages",
            component: "group-list",
            itemProps: {
                label: "{{item.copy}}" || 0 || 0
            },
            defaultItem: {
                copy: "Your promotional message",
                color: common/* color.value.background */.$_.value.background,
                background: common/* color.value.text */.$_.value.text,
                align: "center",
                link: {
                    url: "",
                    text: ""
                }
            },
            // each message
            fields: [
                {
                    label: "Background color",
                    name: "background",
                    component: "select",
                    options: common/* color.options */.$_.options,
                    defaultValue: common/* color.value.text */.$_.value.text
                },
                {
                    label: "Text color",
                    name: "color",
                    component: "select",
                    options: common/* color.options */.$_.options,
                    defaultValue: common/* color.value.background */.$_.value.background
                },
                {
                    label: "Text alignment",
                    name: "align",
                    component: "select",
                    options: common/* align.options */.AJ.options,
                    defaultValue: common/* align.value.center */.AJ.value.center
                },
                {
                    label: "Message (HTML)",
                    description: 'Primary text: <p></p>\nLink: <a href="/pages/example"></a>\nModal link: <modal id="123"></modal>\nBold: <strong></strong>\nItalic: <em></em>\nUnderline: <span style="text-decoration:underline;"></span>',
                    name: "html",
                    component: "html"
                },
                {
                    label: "Message link (optional)",
                    name: "link",
                    component: "link",
                    description: 'Wraps entire message with a link. If message html contains a hyperlink, i.e. "<a></a>", this link will not be used',
                    defaultValue: {
                        url: "",
                        text: ""
                    }
                }, 
            ]
        }, 
    ],
    defaultValue: {
        enabled: true,
        closeable: false,
        duration: 5,
        speed: 0.75,
        messages: [
            {
                color: "#FFFFFF",
                background: "#222222",
                copy: "Free shipping on U.S. orders of $50+",
                link: {
                    text: "",
                    url: ""
                }
            }, 
        ]
    }
};

;// CONCATENATED MODULE: ./src/settings/header/menu.js

var menu_menu = {
    label: "Menu",
    name: "menu",
    component: "group-list",
    itemProps: {
        label: "{{item.link.text}}"
    },
    defaultItem: {
        link: {
            url: "",
            text: "Menu Item"
        }
    },
    fields: [
        {
            label: "Featured Image",
            name: "featuredImage",
            component: "group",
            itemProps: {
                label: "{{item.link.text}}"
            },
            fields: [
                {
                    label: "Image",
                    name: "image",
                    component: "image"
                },
                {
                    label: "Link",
                    name: "link",
                    component: "link"
                }, 
            ]
        },
        {
            label: "Link",
            name: "link",
            component: "link"
        },
        {
            name: "color",
            label: "Text color",
            component: "select",
            options: color/* color.options */.$.options,
            defaultValue: color/* color.value.text */.$.value.text
        },
        {
            label: "Secondary Menu",
            name: "secondaryMenu",
            component: "group-list",
            itemProps: {
                label: "{{item.link.text}}"
            },
            defaultItem: {
                link: {
                    url: "/collections/best-sellers",
                    text: "Best Sellers"
                }
            },
            fields: [
                {
                    name: "hideShopAll",
                    label: "Hide Shop All",
                    component: "toggle",
                    toggleLabels: {
                        true: "Hide",
                        false: "Show"
                    },
                    defaultValue: false
                },
                {
                    label: "Link",
                    name: "link",
                    component: "link"
                },
                {
                    name: "color",
                    label: "Text color",
                    component: "select",
                    options: color/* color.options */.$.options,
                    defaultValue: color/* color.value.text */.$.value.text
                },
                {
                    label: "Mobile Layout",
                    name: "mobileLayout",
                    component: "radio-group",
                    direction: "vertical",
                    variant: "radio",
                    options: [
                        {
                            value: "images",
                            label: "Images"
                        },
                        {
                            value: "cards",
                            label: "Cards"
                        }, 
                    ],
                    default: "images"
                },
                {
                    label: "Tertiary Menu",
                    name: "tertiaryMenu",
                    component: "group-list",
                    itemProps: {
                        label: "{{item.link.text}}"
                    },
                    defaultItem: {
                        link: {
                            url: "/collections/best-sellers",
                            text: "Best Sellers"
                        }
                    },
                    fields: [
                        {
                            label: "Link",
                            name: "link",
                            component: "link"
                        },
                        {
                            name: "color",
                            label: "Text color",
                            component: "select",
                            options: color/* color.options */.$.options,
                            defaultValue: color/* color.value.text */.$.value.text
                        },
                        {
                            name: "product",
                            component: "productSearch",
                            label: "Default Image of Specific Product"
                        }, 
                    ]
                }, 
            ]
        }, 
    ]
};

;// CONCATENATED MODULE: ./src/settings/header/bestSellers.js
var bestSellers = {
    label: "Best sellers (mobile only)",
    name: "bestSellers",
    component: "group",
    fields: [
        {
            label: "Products heading",
            name: "heading",
            component: "text"
        },
        {
            name: "products",
            label: "Products",
            component: "group-list",
            itemProps: {
                label: "{{item.product.title}}" || 0 || 0
            },
            defaultItem: {
                product: {
                    handle: "hopsulator-slim-sundaisy-12oz-slim-cans",
                    title: "slim"
                }
            },
            fields: [
                {
                    name: "image",
                    label: "Image",
                    description: "Overrides default Shopify product image",
                    component: "image"
                },
                {
                    name: "product",
                    component: "productSearch",
                    label: "Product"
                }, 
            ]
        }, 
    ],
    defaultValue: {
        heading: "Best Sellers",
        products: [
            {
                image: {
                    src: "https://cdn.shopify.com/s/files/1/1114/2308/files/1_a80439a0-e419-4e80-9e57-f902cae2bf58.jpg?v=1649376837"
                },
                product: {
                    handle: "hopsulator-slim-sundaisy-12oz-slim-cans"
                }
            }, 
        ]
    }
};

;// CONCATENATED MODULE: ./src/settings/header/linksList.js
var linksList = {
    label: "Links list (mobile only)",
    name: "links",
    component: "group-list",
    description: "Links at the bottom of the menu sidebar",
    itemProps: {
        label: "{{item.link.text}}"
    },
    defaultItem: {
        link: {
            url: "/account",
            text: "Account"
        }
    },
    fields: [
        {
            label: "Link",
            name: "link",
            component: "link"
        }, 
    ]
};

;// CONCATENATED MODULE: ./src/settings/header/refer.js

var refer = {
    label: "Refer Settings",
    name: "refer",
    component: "group",
    fields: [
        {
            label: "Desktop Settings",
            name: "desktop",
            component: "group",
            fields: [
                {
                    label: "Enabled",
                    name: "enabled",
                    component: "toggle",
                    toggleLabels: {
                        true: "On",
                        false: "Off"
                    },
                    defaultValue: true
                },
                {
                    label: "Desktop Link",
                    name: "link",
                    component: "link",
                    defaultValue: {
                        url: "/pages/refer",
                        text: "Refer A Friend"
                    }
                }, 
            ]
        },
        {
            label: "Mobile Settings",
            name: "mobile",
            component: "group",
            fields: [
                {
                    label: "Enabled",
                    name: "enabled",
                    component: "toggle",
                    toggleLabels: {
                        true: "On",
                        false: "Off"
                    },
                    defaultValue: true
                },
                {
                    label: "Mobile Link",
                    name: "link",
                    component: "link",
                    defaultValue: {
                        url: "/pages/refer",
                        text: "Refer A Friend"
                    }
                },
                {
                    name: "linkText",
                    component: "markdown",
                    label: "Link Text Override",
                    defaultValue: "**Get 20% Off** - <u>LEARN MORE</u>"
                },
                {
                    label: "Text Alignment",
                    name: "textAlign",
                    component: "radio-group",
                    variant: "radio",
                    direction: "horizontal",
                    options: common/* align.options */.AJ.options,
                    defaultValue: "center"
                },
                {
                    label: "Background color",
                    name: "background",
                    component: "color",
                    colors: common/* color.list */.$_.list,
                    widget: "block",
                    defaultValue: common/* color.value.text */.$_.value.text
                },
                {
                    label: "Text color",
                    name: "color",
                    component: "color",
                    colors: common/* color.list */.$_.list,
                    widget: "block",
                    defaultValue: common/* color.value.background */.$_.value.background
                }, 
            ]
        }, 
    ]
};

;// CONCATENATED MODULE: ./src/settings/header/index.js





// header
/* harmony default export */ var header = ({
    label: "Header Settings",
    name: "header",
    component: "group",
    fields: [
        promoBar,
        menu_menu,
        bestSellers,
        linksList,
        refer
    ]
});

;// CONCATENATED MODULE: ./src/settings/markdownmodal.js

/* harmony default export */ var markdownmodal = ({
    label: "Markdown Modal Settings",
    name: "markdownmodal",
    component: "group",
    fields: [
        {
            label: "Modals",
            name: "modals",
            component: "group-list",
            itemProps: {
                label: "Modal ID: {{item.id}}"
            },
            defaultItem: {
                name: "New Modal"
            },
            fields: [
                {
                    label: "Modal ID",
                    name: "id",
                    description: "Provide this modal with a unique ID to reference with the modal tag",
                    component: "number"
                },
                {
                    label: "Show Media",
                    name: "showMedia",
                    component: "toggle",
                    description: "Show or hide videos & images",
                    toggleLabels: {
                        true: "Show media",
                        false: "Hide Media"
                    },
                    defaultValue: true
                },
                {
                    label: "Image Settings",
                    name: "image",
                    description: "Image, alt text",
                    component: "group",
                    fields: [
                        {
                            label: "Image Alt",
                            name: "alt",
                            component: "text",
                            description: "Provide a brief description of the image for accessibility compliance"
                        },
                        {
                            name: "imageDt",
                            label: "Image (desktop)",
                            component: "image"
                        },
                        {
                            label: "Image (mobile)",
                            name: "image",
                            component: "image"
                        }, 
                    ],
                    defaultValue: {
                        alt: "A Woman sitting on a couch with a Hopsulator slim in her hand.",
                        image: {
                            src: "https://cdn.shopify.com/s/files/1/1114/2308/files/FirstCanCooler.png"
                        },
                        imageDt: {
                            src: "https://cdn.shopify.com/s/files/1/1114/2308/files/FirstCanCooler.png"
                        }
                    }
                },
                {
                    label: "Video Settings",
                    name: "video",
                    description: "Direct Video Link, Thumbnail",
                    component: "group",
                    fields: [
                        {
                            label: "Enable Video",
                            name: "enabled",
                            component: "toggle",
                            toggleLabels: {
                                true: "On",
                                false: "Off"
                            }
                        },
                        {
                            label: "Video Alt",
                            name: "alt",
                            component: "text",
                            description: "Provide a brief description of the video for accessibility compliance"
                        },
                        {
                            label: "Direct Video Link",
                            description: "Direct video links usually end in or contain '.mp4'",
                            name: "src",
                            component: "text"
                        },
                        {
                            label: "Video Thumbnail",
                            description: "Usually the first or best frame of the video",
                            name: "poster",
                            component: "image"
                        }, 
                    ],
                    defaultValue: {
                        alt: "Hopsulator Duo image.",
                        enabled: false,
                        src: "https://cdn.shopify.com/s/files/1/1114/2308/files/duoOptimized.mp4",
                        poster: {
                            src: "https://cdn.shopify.com/s/files/1/1114/2308/files/HopsulatorDuo_93eedf12-7170-4eee-bf26-61636f3674b8.png"
                        }
                    }
                },
                {
                    label: "Media Settings",
                    name: "media",
                    description: "Position, placement, aspect ratio",
                    component: "group",
                    fields: [
                        {
                            label: "Media position",
                            name: "positionDt",
                            component: "select",
                            options: common/* position.object */.FK.object
                        },
                        {
                            label: "Placement (desktop)",
                            component: "radio-group",
                            direction: "horizontal",
                            variant: "radio",
                            name: "locationDt",
                            options: [
                                {
                                    value: "left",
                                    label: "Left"
                                },
                                {
                                    value: "right",
                                    label: "Right"
                                }, 
                            ]
                        },
                        {
                            label: "Aspect ratio (desktop)",
                            name: "ratioDt",
                            component: "radio-group",
                            description: "Only applies to images and video files not already set to 1:1 ratio",
                            direction: "horizontal",
                            variant: "radio",
                            options: [
                                {
                                    value: "80%",
                                    label: "5:4"
                                },
                                {
                                    value: "100%",
                                    label: "1:1"
                                },
                                {
                                    value: "120%",
                                    label: "5:6"
                                }, 
                            ]
                        },
                        {
                            label: "Media position (mobile)",
                            name: "position",
                            component: "select",
                            options: common/* position.object */.FK.object
                        },
                        {
                            label: "Placement (mobile)",
                            name: "location",
                            component: "radio-group",
                            direction: "horizontal",
                            variant: "radio",
                            options: [
                                {
                                    value: "top",
                                    label: "Top"
                                },
                                {
                                    value: "bottom",
                                    label: "Bottom"
                                }, 
                            ]
                        },
                        {
                            label: "Aspect ratio (mobile)",
                            component: "radio-group",
                            description: "Only applies to images and video files not already set to 1:1 ratio",
                            direction: "horizontal",
                            variant: "radio",
                            name: "ratio",
                            options: [
                                {
                                    value: "80%",
                                    label: "5:4"
                                },
                                {
                                    value: "100%",
                                    label: "1:1"
                                },
                                {
                                    value: "120%",
                                    label: "5:6"
                                }, 
                            ]
                        }, 
                    ],
                    defaultValue: {
                        location: "top",
                        locationDt: "left",
                        ratio: "100%",
                        ratioDt: "100%",
                        position: "center center",
                        positionDt: "center center"
                    }
                },
                {
                    label: "Content Settings",
                    name: "content",
                    description: "Heading, superheading body, link, content alignment",
                    component: "group",
                    fields: [
                        {
                            label: "Heading",
                            name: "heading",
                            component: "text"
                        },
                        {
                            label: "Superheading",
                            name: "superheading",
                            component: "text"
                        },
                        {
                            label: "Body",
                            name: "body",
                            component: "markdown"
                        },
                        {
                            label: "Link",
                            name: "cta",
                            component: "link"
                        },
                        {
                            name: "ctaStyle",
                            label: "Link Style",
                            component: "select",
                            options: common/* button.options */.LI.options
                        },
                        {
                            label: "Content alignment (mobile)",
                            name: "alignment",
                            component: "radio-group",
                            direction: "horizontal",
                            variant: "radio",
                            options: common/* align.options */.AJ.options
                        },
                        {
                            label: "Content alignment (desktop)",
                            name: "alignmentDt",
                            component: "radio-group",
                            direction: "horizontal",
                            variant: "radio",
                            options: common/* align.options */.AJ.options
                        }, 
                    ],
                    defaultValue: {
                        heading: "THE WORLD'S FIRST SLIM CAN COOLER.",
                        body: "The Hopsulator Slim keeps all of your\n          favorite 12oz slim canned beverages icy-\n          cold, no matter how hot the party gets.\n* Works with all 12oz Slim Cans\n* Works with all 12oz Slim Cans\n* Works with all 12oz Slim Cans\n* Works with all 12oz Slim Cans",
                        ctaStyle: common/* button.value.secondary */.LI.value.secondary,
                        alignment: common/* align.value.left */.AJ.value.left,
                        alignmentDt: common/* align.value.left */.AJ.value.left
                    }
                }, 
            ]
        }, 
    ]
});

;// CONCATENATED MODULE: ./src/settings/product.js
/* harmony default export */ var product = ({
    label: "Product Settings",
    name: "product",
    component: "group",
    fields: [
        {
            label: "Back In Stock Modal",
            name: "backInStock",
            component: "group",
            fields: [
                {
                    label: "Description",
                    name: "description",
                    component: "textarea"
                },
                {
                    label: "Submit Button Text",
                    name: "modalButtonText",
                    component: "text"
                }, 
            ],
            defaultValue: {
                description: "Register to receive a notification when this item comes back in stock.",
                modalButtonText: "Notify When Available"
            }
        },
        {
            component: "group",
            name: "badges",
            label: "Badges",
            fields: [
                {
                    component: "group",
                    name: "onSaleBadge",
                    label: "On Sale Badge",
                    fields: [
                        {
                            label: "Text",
                            name: "text",
                            component: "text"
                        },
                        {
                            label: "Color",
                            name: "color",
                            component: "color"
                        },
                        {
                            label: "Background Color",
                            name: "backgroundColor",
                            component: "color"
                        }, 
                    ],
                    defaultValue: {
                        text: "Sale",
                        color: "#AE2807",
                        backgroundColor: "transparent"
                    }
                },
                {
                    component: "group",
                    name: "soldOutBadge",
                    label: "Sold Out Badge",
                    fields: [
                        {
                            label: "Text",
                            name: "text",
                            component: "text"
                        },
                        {
                            label: "Color",
                            name: "color",
                            component: "color"
                        },
                        {
                            label: "Background Color",
                            name: "backgroundColor",
                            component: "color"
                        }, 
                    ],
                    defaultValue: {
                        text: "Sale",
                        color: "#ffffff",
                        backgroundColor: "#5d5d5d"
                    }
                },
                {
                    component: "group-list",
                    name: "customBadges",
                    label: "Custom Badges",
                    itemProps: {
                        label: "{{item.text}}" || 0
                    },
                    defaultItem: {
                        text: "New",
                        color: "#000000",
                        backgroundColor: "transparent"
                    },
                    fields: [
                        {
                            label: "Product Tag",
                            name: "tag",
                            component: "text",
                            description: "Product tag needed to map to badge to override with settings below. Ex: badge::New"
                        },
                        {
                            label: "Text",
                            name: "text",
                            component: "text"
                        },
                        {
                            label: "Color",
                            name: "color",
                            component: "color"
                        },
                        {
                            label: "Background Color",
                            name: "backgroundColor",
                            component: "color"
                        }, 
                    ]
                }, 
            ],
            defaultValue: [
                {
                    text: "New",
                    color: "#000000",
                    backgroundColor: "transparent"
                }, 
            ]
        },
        {
            label: "Carousel Swatches",
            name: "carouselSwatches",
            component: "group",
            fields: [
                {
                    label: "Enable",
                    name: "enable",
                    component: "toggle",
                    toggleLabels: {
                        true: "On",
                        false: "Off"
                    },
                    defaultValue: false
                },
                {
                    component: "group-list",
                    name: "products",
                    label: "Products to Enable Carousel Swatches",
                    description: "Remove list to enable on all products",
                    itemProps: {
                        label: "{{item.product.handle}}" || 0
                    },
                    fields: [
                        {
                            component: "productSearch",
                            name: "product",
                            label: "Product"
                        }, 
                    ]
                }, 
            ],
            defaultValue: {
                enable: false
            }
        },
        {
            label: "Icons",
            name: "icons",
            component: "group",
            fields: [
                {
                    label: "Icons",
                    name: "list",
                    description: "Order of icons here will determine order of icons on product page",
                    component: "group-list",
                    itemProps: {
                        label: "{{item.label}}"
                    },
                    defaultItem: {
                        tag: "New Icon",
                        label: "New Icon"
                    },
                    fields: [
                        {
                            label: "Tag",
                            name: "tag",
                            component: "text",
                            description: 'Tag name added to product in Shopify, e.g. "Lifetime Warranty" for "icon::warranty" in Shopfiy'
                        },
                        {
                            label: "Label",
                            name: "label",
                            component: "text"
                        },
                        {
                            label: "Icon SVG",
                            name: "icon",
                            component: "image"
                        }, 
                    ]
                }, 
            ]
        },
        {
            label: "Personalize",
            name: "personalize",
            component: "group",
            fields: [
                {
                    label: "Personalize Button Text",
                    name: "buttonText",
                    component: "text"
                }, 
            ],
            defaultValue: {
                buttonText: "Customize"
            }
        },
        {
            label: "Specs & Fitment",
            name: "specs",
            component: "group",
            fields: [
                {
                    label: "Usage Guides",
                    name: "guides",
                    description: "Add product usage guide links here",
                    component: "group-list",
                    itemProps: {
                        label: "{{item.tag}}"
                    },
                    defaultItem: {
                        tag: "MultiShaker",
                        link: {
                            text: "Download the Usage Guide",
                            url: "https://cdn.shopify.com/s/files/1/1114/2308/files/Digital-MultiShaker-PDF.pdf?v=1689617250"
                        }
                    },
                    fields: [
                        {
                            label: "Tag",
                            name: "tag",
                            component: "text",
                            description: 'Tag name added to product in Shopify, e.g. "MultiShaker" for "usage-guide::multishaker" in Shopfiy'
                        },
                        {
                            label: "Link",
                            name: "cta",
                            component: "link",
                            defaultValue: {
                                text: "Download the Usage Guide",
                                url: "https://cdn.shopify.com/s/files/1/1114/2308/files/Digital-MultiShaker-PDF.pdf?v=1689617250"
                            }
                        }, 
                    ]
                }, 
            ]
        },
        {
            label: "Reviews",
            name: "reviews",
            component: "group",
            fields: [
                {
                    label: "Heading",
                    name: "heading",
                    component: "markdown"
                },
                {
                    label: "Percentage",
                    name: "percentage",
                    component: "number"
                },
                {
                    label: "Subtext",
                    name: "subtext",
                    component: "markdown"
                }, 
            ],
            defaultValue: {
                heading: "## 135,000+ 5-Star Reviews",
                percentage: 100,
                subtext: "TRIED AND TESTED | REVIEWS FROM OUR AMAZING CREW ALL OVER THE WORLD."
            }
        },
        {
            component: "group",
            name: "upsells",
            label: "Upsells",
            fields: [
                {
                    component: "text",
                    name: "heading",
                    label: "Heading",
                    defaultValue: "Add-ons"
                },
                {
                    component: "group-list",
                    name: "products",
                    label: "Products",
                    description: "Add up to 5 products",
                    itemProps: {
                        label: "{{item.product.handle}}" || 0
                    },
                    fields: [
                        {
                            component: "productSearch",
                            name: "product",
                            label: "Product"
                        }, 
                    ]
                }, 
            ]
        }, 
    ]
});

;// CONCATENATED MODULE: ./src/settings/search.js
/* harmony default export */ var search = ({
    label: "Search Settings",
    name: "search",
    component: "group",
    fields: [
        {
            label: "Suggested Terms",
            name: "suggested",
            component: "group-list",
            itemProps: {
                key: "{{item.handle}}",
                label: "{{item.label}}"
            },
            fields: [
                {
                    label: "Term",
                    name: "label",
                    component: "text"
                }, 
            ]
        },
        {
            label: "Suggested Terms Heading",
            name: "suggestedHeading",
            component: "text"
        },
        {
            label: "Search Spring Settings",
            name: "searchSpring",
            description: "Heading, Search Spring Recommendation Tag",
            component: "group",
            fields: [
                {
                    label: "Enable",
                    name: "enable",
                    component: "toggle",
                    toggleLabels: {
                        true: "On",
                        false: "Off"
                    },
                    defaultValue: false
                },
                {
                    name: "heading",
                    label: "Heading",
                    component: "text",
                    defaultValue: "Complete Your Collection"
                },
                {
                    name: "tag",
                    label: "Searchspring Product Recs Tag",
                    component: "text",
                    description: 'The product recommendations profile tag taken from Searchspring admin, e.g. "cross-sell", "similar", "home", "recently-viewed"',
                    defaultValue: "cross-sell"
                },
                {
                    name: "limit",
                    label: "Number of recommendations",
                    component: "number",
                    defaultValue: 8
                }, 
            ]
        }, 
    ],
    defaultValue: {
        suggested: [
            {
                label: "Black"
            },
            {
                label: "Micro"
            }
        ],
        suggestedHeading: "Top search terms"
    }
});

;// CONCATENATED MODULE: ./src/settings/social.js
/* harmony default export */ var social = ({
    label: "Social Settings",
    name: "social",
    component: "group",
    fields: [
        {
            label: "Social Links",
            name: "links",
            component: "group-list",
            itemProps: {
                label: "{{item.network}}:@{{item.handle}}"
            },
            defaultItem: {
                network: "facebook",
                handle: "your-handle"
            },
            fields: [
                {
                    name: "network",
                    component: "select",
                    label: "Social Network",
                    options: [
                        {
                            value: "facebook",
                            label: "Facebook"
                        },
                        {
                            value: "instagram",
                            label: "Instagram"
                        },
                        {
                            value: "pinterest",
                            label: "Pinterest"
                        },
                        {
                            value: "twitter",
                            label: "Twitter"
                        },
                        {
                            value: "youtube",
                            label: "YouTube"
                        },
                        {
                            value: "vimeo",
                            label: "Vimeo"
                        },
                        {
                            value: "tiktok",
                            label: "TikTok"
                        }, 
                    ]
                },
                {
                    label: "Handle",
                    name: "handle",
                    component: "text"
                }, 
            ]
        }, 
    ]
});

;// CONCATENATED MODULE: ./src/settings/index.js













/* harmony default export */ var settings = ([
    account,
    analytics,
    blog,
    cart,
    collection,
    footer,
    gatedPages,
    giftWithPurchase,
    header,
    markdownmodal,
    product,
    search,
    social, 
]);

;// CONCATENATED MODULE: ../node_modules/@mdx-js/react/lib/index.js
/**
 * @typedef {import('react').ReactNode} ReactNode
 * @typedef {import('mdx/types.js').MDXComponents} Components
 *
 * @typedef Props
 *   Configuration.
 * @property {Components | MergeComponents | null | undefined} [components]
 *   Mapping of names for JSX components to React components.
 * @property {boolean | null | undefined} [disableParentContext=false]
 *   Turn off outer component context.
 * @property {ReactNode | null | undefined} [children]
 *   Children.
 *
 * @callback MergeComponents
 *   Custom merge function.
 * @param {Components} currentComponents
 *   Current components from the context.
 * @returns {Components}
 *   Merged components.
 */



/**
 * @type {import('react').Context<Components>}
 * @deprecated
 *   This export is marked as a legacy feature.
 *   That means it’s no longer recommended for use as it might be removed
 *   in a future major release.
 *
 *   Please use `useMDXComponents` to get context based components and
 *   `MDXProvider` to set context based components instead.
 */
const MDXContext = react.createContext({})

/**
 * @param {import('react').ComponentType<any>} Component
 * @deprecated
 *   This export is marked as a legacy feature.
 *   That means it’s no longer recommended for use as it might be removed
 *   in a future major release.
 *
 *   Please use `useMDXComponents` to get context based components instead.
 */
function withMDXComponents(Component) {
  return boundMDXComponent

  /**
   * @param {Record<string, unknown> & {components?: Components | null | undefined}} props
   * @returns {JSX.Element}
   */
  function boundMDXComponent(props) {
    const allComponents = useMDXComponents(props.components)
    return React.createElement(Component, {...props, allComponents})
  }
}

/**
 * Get current components from the MDX Context.
 *
 * @param {Components | MergeComponents | null | undefined} [components]
 *   Additional components to use or a function that takes the current
 *   components and filters/merges/changes them.
 * @returns {Components}
 *   Current components.
 */
function useMDXComponents(components) {
  const contextComponents = react.useContext(MDXContext)

  // Memoize to avoid unnecessary top-level context changes
  return react.useMemo(() => {
    // Custom merge via a function prop
    if (typeof components === 'function') {
      return components(contextComponents)
    }

    return {...contextComponents, ...components}
  }, [contextComponents, components])
}

/** @type {Components} */
const emptyObject = {}

/**
 * Provider for MDX context
 *
 * @param {Props} props
 * @returns {JSX.Element}
 */
function MDXProvider({components, children, disableParentContext}) {
  /** @type {Components} */
  let allComponents

  if (disableParentContext) {
    allComponents =
      typeof components === 'function'
        ? components({})
        : components || emptyObject
  } else {
    allComponents = useMDXComponents(components)
  }

  return react.createElement(
    MDXContext.Provider,
    {value: allComponents},
    children
  )
}

// EXTERNAL MODULE: ../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(10043);
// EXTERNAL MODULE: ../node_modules/@emotion/react/dist/emotion-element-f0de968e.browser.esm.js
var emotion_element_f0de968e_browser_esm = __webpack_require__(44512);
// EXTERNAL MODULE: ../node_modules/deepmerge/dist/cjs.js
var cjs = __webpack_require__(20406);
var cjs_default = /*#__PURE__*/__webpack_require__.n(cjs);
;// CONCATENATED MODULE: ../node_modules/@emotion/react/package.json
var package_namespaceObject = {"i8":"11.14.0"};
// EXTERNAL MODULE: ../node_modules/@theme-ui/core/dist/parseProps-376f43a7.esm.js
var parseProps_376f43a7_esm = __webpack_require__(75902);
;// CONCATENATED MODULE: ../node_modules/@theme-ui/core/dist/theme-ui-core.esm.js







function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var __EMOTION_VERSION__ = package_namespaceObject.i8;
var theme_ui_core_esm_jsx = function jsx(type, props) {
  for (var _len = arguments.length, children = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    children[_key - 2] = arguments[_key];
  }

  return emotion_react_browser_esm/* jsx.apply */.tZ.apply(void 0, [type, (0,parseProps_376f43a7_esm.p)(props)].concat(children));
};
/**
 * @internal for Babel JSX pragma
 * @see https://github.com/system-ui/theme-ui/issues/1603
 */

var createElement = (/* unused pure expression or super */ null && (theme_ui_core_esm_jsx));

/**
 * @internal
 */
var __themeUiDefaultContextValue = {
  __EMOTION_VERSION__: __EMOTION_VERSION__,
  theme: {}
};
/**
 * @internal
 */

var __ThemeUIContext = /*#__PURE__*/react.createContext(__themeUiDefaultContextValue);
var theme_ui_core_esm_useThemeUI = function useThemeUI() {
  return react.useContext(__ThemeUIContext);
};
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT = canUseSymbol ? Symbol.for('react.element') : 0xeac7;
var FORWARD_REF = canUseSymbol ? Symbol.for('react.forward_ref') : 0xeac7;
var deepmergeOptions = {
  isMergeableObject: function isMergeableObject(n) {
    return !!n && typeof n === 'object' && n.$$typeof !== REACT_ELEMENT && n.$$typeof !== FORWARD_REF;
  },
  arrayMerge: function arrayMerge(_leftArray, rightArray) {
    return rightArray;
  }
};
/**
 * Deeply merge themes
 */

var merge = function merge(a, b) {
  return cjs_default()(a, b, deepmergeOptions);
};

function mergeAll() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  return cjs_default().all(args, deepmergeOptions);
}

merge.all = mergeAll;

/**
 * @internal
 */
var __ThemeUIInternalBaseThemeProvider = function __ThemeUIInternalBaseThemeProvider(_ref) {
  var context = _ref.context,
      children = _ref.children;
  return theme_ui_core_esm_jsx(emotion_element_f0de968e_browser_esm.T.Provider, {
    value: context.theme
  }, theme_ui_core_esm_jsx(__ThemeUIContext.Provider, {
    value: context,
    children: children
  }));
};
function theme_ui_core_esm_ThemeProvider(_ref2) {
  var theme = _ref2.theme,
      children = _ref2.children;
  var outer = theme_ui_core_esm_useThemeUI();

  if (false) {}

  var context = typeof theme === 'function' ? _extends({}, outer, {
    theme: theme(outer.theme)
  }) : merge.all({}, outer, {
    theme: theme
  });
  return theme_ui_core_esm_jsx(__ThemeUIInternalBaseThemeProvider, {
    context: context,
    children: children
  });
}



// EXTERNAL MODULE: ../node_modules/@theme-ui/css/dist/theme-ui-css.esm.js
var theme_ui_css_esm = __webpack_require__(56861);
;// CONCATENATED MODULE: ../node_modules/@theme-ui/mdx/dist/theme-ui-mdx.esm.js




function theme_ui_mdx_esm_extends() {
  theme_ui_mdx_esm_extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return theme_ui_mdx_esm_extends.apply(this, arguments);
}

// mdx components
var tags = ['p', 'b', 'i', 'a', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'img', 'pre', 'code', 'ol', 'ul', 'li', 'blockquote', 'hr', 'em', 'table', 'tr', 'th', 'td', 'em', 'strong', 'del', // mdx
'inlineCode', 'thematicBreak', // other
'div', // theme-ui
'root'];
var aliases = {
  inlineCode: 'code',
  thematicBreak: 'hr',
  root: 'div'
};

var isAlias = function isAlias(x) {
  return x in aliases;
};

var alias = function alias(n) {
  return isAlias(n) ? aliases[n] : n;
};
/**
 * Extracts styles from `theme.styles` object
 */


var theme_ui_mdx_esm_themed = function themed(key) {
  return function (theme) {
    return (0,theme_ui_css_esm/* css */.iv)((0,theme_ui_css_esm/* get */.U2)(theme, "styles." + key))(theme);
  };
};

var createThemedComponent = function createThemedComponent(name, variant) {
  var variantStyles = theme_ui_mdx_esm_themed(variant);

  var component = function component(props) {
    var extraStyles = {};

    if (name === 'th' || name === 'td') {
      var _ref = props,
          align = _ref.align;
      if (align !== 'char') extraStyles.textAlign = align;
    }

    return theme_ui_core_esm_jsx(name, theme_ui_mdx_esm_extends({}, props, {
      css: [props.css, variantStyles, extraStyles].filter(Boolean)
    }));
  };

  component.displayName = "Themed(" + name + ")";
  return component;
};

var defaultMdxComponents = {};
var Themed = {};
tags.forEach(function (tag) {
  var component = createThemedComponent(alias(tag), tag);
  defaultMdxComponents[tag] = component;
  Themed[tag] = component;
});

function wrapComponent(value, key) {
  var component = function component(props) {
    return theme_ui_core_esm_jsx(value, theme_ui_mdx_esm_extends({}, props, {
      css: theme_ui_mdx_esm_themed(key)
    }));
  };

  component.displayName = "MdxComponents('" + key + "')";
  return component;
}
/** @internal */


var wrapComponentsWithThemeStyles = function wrapComponentsWithThemeStyles(comps) {
  var next = theme_ui_mdx_esm_extends({}, defaultMdxComponents); // We enrich user's components with the styles from theme.styles.
  // Example: `components.p` will get the styles from `theme.styles.p` as className.


  for (var _i = 0, _Object$keys = Object.keys(comps); _i < _Object$keys.length; _i++) {
    var key = _Object$keys[_i];
    var value = comps[key];
    next[key] = typeof value === 'object' ? wrapComponentsWithThemeStyles(value) : wrapComponent(value, key);
  }

  return next;
};

/**
 * @example
 * import { MDXProvider, useMDXComponents } from '@mdx-js/react'
 *
 * function MyMdxProvider({ children }) {
 *   const components = useThemedStylesWithMdx(useMDXComponents())
 *
 *   return <MDXProvider components={components}>{children}</MDXProvider>
 * }
 */

function useThemedStylesWithMdx(outerComponents) {
  return (0,react.useMemo)(function () {
    return wrapComponentsWithThemeStyles(theme_ui_mdx_esm_extends({}, defaultMdxComponents, outerComponents));
  }, [outerComponents]);
}



// EXTERNAL MODULE: ../node_modules/@intelligems/headless/dist/pack.mjs + 1 modules
var pack = __webpack_require__(96807);
;// CONCATENATED MODULE: ../node_modules/@theme-ui/color-modes/dist/theme-ui-color-modes.esm.js





function theme_ui_color_modes_esm_extends() {
  theme_ui_color_modes_esm_extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return theme_ui_color_modes_esm_extends.apply(this, arguments);
}

var toVarName = function toVarName(key) {
  return "--theme-ui-" + key.replace('-__default', '');
};

var toVarValue = function toVarValue(key) {
  return "var(" + toVarName(key) + ")";
};

var join = function join() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return args.filter(Boolean).join('-');
};

var reservedKeys = new Set(['useCustomProperties', 'initialColorModeName', 'printColorModeName', 'initialColorMode', 'useLocalStorage', 'config']); // convert theme values to custom properties

var toCustomProperties = function toCustomProperties(obj, parent) {
  var next = Array.isArray(obj) ? [] : {};

  for (var key in obj) {
    var value = obj[key];
    var name = join(parent, key);

    if (value && typeof value === 'object') {
      next[key] = toCustomProperties(value, name);
      continue;
    }

    if (reservedKeys.has(key)) {
      next[key] = value;
      continue;
    }

    next[key] = toVarValue(name);
  }

  return next;
};
/**
 * @internal
 * Recursively transforms an object into CSS variables excluding "modes" key.
 */

var __objectToVars = function __objectToVars(parent, obj) {
  var vars = {};

  for (var key in obj) {
    if (key === 'modes') continue;
    var name = join(parent, key);
    var value = obj[key];

    if (value && typeof value === 'object') {
      vars = theme_ui_color_modes_esm_extends({}, vars, __objectToVars(name, value));
    } else {
      vars[toVarName(name)] = value;
    }
  }

  return vars;
};
/**
 * @internal
 * Creates root styles for color modes.
 * - Transforms color scale into CSS variables.
 * - Sets background and text color.
 */

var __createColorStyles = function __createColorStyles(theme) {
  if (theme === void 0) {
    theme = {};
  }

  var _ref = theme.config || theme || {},
      useCustomProperties = _ref.useCustomProperties,
      initialColorModeName = _ref.initialColorModeName,
      printColorModeName = _ref.printColorModeName,
      useRootStyles = _ref.useRootStyles;

  var colors = theme.rawColors || theme.colors;
  if (!colors || useRootStyles === false) return {};

  if (useCustomProperties === false) {
    return (0,theme_ui_css_esm/* css */.iv)({
      color: 'text',
      bg: 'background'
    })(theme);
  }

  var modes = colors.modes || {};

  var styles = __createColorProperties(colors, modes);

  if (printColorModeName) {
    var printMode = modes[printColorModeName];
    if (!printMode && printColorModeName === initialColorModeName) printMode = colors;

    if (printMode) {
      styles['@media print'] = __objectToVars('colors', printMode);
    } else {
      console.error("Theme UI `printColorModeName` was not found in colors scale", {
        colors: colors,
        printColorModeName: printColorModeName
      });
    }
  }

  var colorToVarValue = function colorToVarValue(color) {
    return toVarValue("colors-" + color);
  };

  return (0,theme_ui_css_esm/* css */.iv)(theme_ui_color_modes_esm_extends({}, styles, {
    color: colorToVarValue('text'),
    bg: colorToVarValue('background')
  }))(theme);
};
/**
 * @internal
 * Returns an object with colors turned into Custom CSS Properties and
 * .theme-ui-<colormode> classes used for no-flash serverside rendering.
 */

function __createColorProperties(colors, modes) {
  var styles = __objectToVars('colors', colors);

  Object.keys(modes).forEach(function (mode) {
    var className = ".theme-ui-" + mode;
    var key = "&" + className + ", " + className + " &";
    styles[key] = __objectToVars('colors', modes[mode]);
  });
  return styles;
}

var STORAGE_KEY = 'theme-ui-color-mode';
var DARK_QUERY = '(prefers-color-scheme: dark)';
var LIGHT_QUERY = '(prefers-color-scheme: light)';
var storage = {
  get: function get() {
    try {
      return window.localStorage.getItem(STORAGE_KEY);
    } catch (err) {
      console.warn('localStorage is disabled and color mode might not work as expected.', 'Please check your Site Settings.', err);
    }
  },
  set: function set(value) {
    try {
      window.localStorage.setItem(STORAGE_KEY, value);
    } catch (err) {
      console.warn('localStorage is disabled and color mode might not work as expected.', 'Please check your Site Settings.', err);
    }
  }
};

var getPreferredColorScheme = function getPreferredColorScheme() {
  if (typeof window !== 'undefined' && window.matchMedia) {
    if (window.matchMedia(DARK_QUERY).matches) {
      return 'dark';
    }

    if (window.matchMedia(LIGHT_QUERY).matches) {
      return 'light';
    }
  }

  return null;
};

var useClientsideEffect = typeof window === 'undefined' ? function () {} : react.useLayoutEffect;

var TopLevelColorModeProvider = function TopLevelColorModeProvider(_ref) {
  var outerCtx = _ref.outerCtx,
      children = _ref.children;
  var outerTheme = outerCtx.theme || {};

  var _ref2 = outerTheme.config || outerTheme,
      initialColorModeName = _ref2.initialColorModeName,
      useColorSchemeMediaQuery = _ref2.useColorSchemeMediaQuery,
      useLocalStorage = _ref2.useLocalStorage;

  var _useState = (0,react.useState)(function () {
    var preferredMode = useColorSchemeMediaQuery !== false && getPreferredColorScheme();
    return preferredMode || initialColorModeName;
  }),
      colorMode = _useState[0],
      setColorMode = _useState[1]; // on first render, we read the color mode from localStorage and
  // clear the class on document element body


  useClientsideEffect(function () {
    var stored = useLocalStorage !== false && storage.get();

    if (typeof document !== 'undefined') {
      document.documentElement.classList.remove('theme-ui-' + stored);
    }

    if (useColorSchemeMediaQuery !== 'system' && stored && stored !== colorMode) {
      colorMode = stored;
      setColorMode(stored);
    }
  }, []); // when mode changes, we save it to localStorage

  (0,react.useEffect)(function () {
    if (colorMode && useLocalStorage !== false) {
      storage.set(colorMode);
    }
  }, [colorMode, useLocalStorage]);
  var setPreferredColorScheme = (0,react.useCallback)(function () {
    var preferredColorScheme = getPreferredColorScheme();
    setColorMode(preferredColorScheme || initialColorModeName);
  }, [initialColorModeName]);
  (0,react.useEffect)(function () {
    if (useColorSchemeMediaQuery === 'system' && window.matchMedia) {
      // It doesn't matter if we add the listener only to the dark media query
      // Because in our callback function we'll check for both media queries (light and dark).
      var darkMQL = window.matchMedia(DARK_QUERY);

      if (typeof darkMQL.addEventListener === 'function') {
        darkMQL.addEventListener('change', setPreferredColorScheme);
      } else if (typeof darkMQL.addListener === 'function') {
        darkMQL.addListener(setPreferredColorScheme);
      }
    }

    return function () {
      if (useColorSchemeMediaQuery === 'system' && window.matchMedia) {
        var _darkMQL = window.matchMedia(DARK_QUERY);

        if (typeof _darkMQL.removeEventListener === 'function') {
          _darkMQL.removeEventListener('change', setPreferredColorScheme);
        } else if (typeof _darkMQL.removeListener === 'function') {
          _darkMQL.removeListener(setPreferredColorScheme);
        }
      }
    };
  }, [useColorSchemeMediaQuery, setPreferredColorScheme]);

  if (false) { var flattenKeys, allColorKeys, _outerTheme$colors, _outerTheme$colors2; }

  var newTheme = useThemeWithAppliedColorMode({
    colorMode: colorMode,
    outerTheme: outerTheme
  });

  var newCtx = theme_ui_color_modes_esm_extends({}, outerCtx, {
    theme: newTheme,
    colorMode: colorMode,
    setColorMode: setColorMode
  });

  return /*#__PURE__*/react.createElement(__ThemeUIInternalBaseThemeProvider, {
    context: newCtx
  }, /*#__PURE__*/react.createElement(GlobalColorStyles, {
    theme: newTheme
  }), children);
};

function useColorMode() {
  var _useThemeUI = useThemeUI(),
      colorMode = _useThemeUI.colorMode,
      setColorMode = _useThemeUI.setColorMode;

  if (typeof setColorMode !== 'function') {
    throw new Error("[useColorMode] requires the ColorModeProvider component");
  } // We're allowing the user to specify a narrower type for its color mode name.


  return [colorMode, setColorMode];
}

var omitModes = function omitModes(colors) {
  var res = theme_ui_color_modes_esm_extends({}, colors);

  delete res.modes;
  return res;
};

function copyRawColors(colors, outerThemeRawColors) {
  for (var _i = 0, _Object$entries = Object.entries(colors); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _Object$entries[_i],
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];

    if (typeof value === 'string' && !value.startsWith('var(')) {
      outerThemeRawColors[key] = value;
    } else if (typeof value === 'object') {
      var newValue = theme_ui_color_modes_esm_extends({}, outerThemeRawColors[key]);

      copyRawColors(value, newValue);
      outerThemeRawColors[key] = newValue;
    }
  }
}

function useThemeWithAppliedColorMode(_ref3) {
  var outerTheme = _ref3.outerTheme,
      colorMode = _ref3.colorMode;
  var theme = (0,react.useMemo)(function () {
    var res = theme_ui_color_modes_esm_extends({}, outerTheme);

    var modes = (0,theme_ui_css_esm/* get */.U2)(res, 'colors.modes', {});
    var currentColorMode = (0,theme_ui_css_esm/* get */.U2)(modes, colorMode, {});

    if (colorMode) {
      res.colors = theme_ui_color_modes_esm_extends({}, res.colors, currentColorMode);
    }

    var _ref4 = outerTheme.config || outerTheme,
        useCustomProperties = _ref4.useCustomProperties,
        _ref4$initialColorMod = _ref4.initialColorModeName,
        initialColorModeName = _ref4$initialColorMod === void 0 ? '__default' : _ref4$initialColorMod;

    var outerThemeRawColors = outerTheme.rawColors || outerTheme.colors || {};

    if (useCustomProperties !== false) {
      var alreadyHasRawColors = res.rawColors != null;
      var colors = res.colors || {};

      if (alreadyHasRawColors) {
        outerThemeRawColors = theme_ui_color_modes_esm_extends({}, outerThemeRawColors);
        copyRawColors(colors, outerThemeRawColors);

        if (outerThemeRawColors.modes) {
          outerThemeRawColors.modes[initialColorModeName] = omitModes(outerThemeRawColors);
        }

        res.rawColors = outerThemeRawColors;
      } else {
        if (!('modes' in outerThemeRawColors)) {
          res.rawColors = colors;
        } else {
          var _extends2;

          var _modes = theme_ui_color_modes_esm_extends((_extends2 = {}, _extends2[initialColorModeName] = omitModes(outerThemeRawColors), _extends2), outerThemeRawColors.modes);

          res.rawColors = theme_ui_color_modes_esm_extends({}, colors, {
            modes: _modes
          });
          /* modes doesn't match index signature by design */
        }
      }

      res.colors = toCustomProperties(omitModes(outerThemeRawColors), 'colors');
    }

    return res;
  }, [colorMode, outerTheme]);
  return theme;
}

function GlobalColorStyles(_ref5) {
  var theme = _ref5.theme;
  return theme_ui_core_esm_jsx(emotion_react_browser_esm/* Global */.xB, {
    styles: function styles() {
      return {
        html: __createColorStyles(theme)
      };
    }
  });
}

function NestedColorModeProvider(_ref6) {
  var _newTheme$config2;

  var outerCtx = _ref6.outerCtx,
      children = _ref6.children;
  var newTheme = useThemeWithAppliedColorMode({
    outerTheme: outerCtx.theme,
    colorMode: outerCtx.colorMode
  }); // Nested theme providers need to be rerendered after hydration for the correct
  // color mode to apply.

  var _useState2 = (0,react.useState)( // Note: we could also check some "ssr-enabled" flag as an optimization for
  // SPAs, as deeply nested theme providers will also pay a performance penalty
  // for this SSR bug fix
  function () {
    var _newTheme$config;

    return ((_newTheme$config = newTheme.config) == null ? void 0 : _newTheme$config.useLocalStorage) !== false;
  }),
      needsRerender = _useState2[0],
      setNeedsRerender = _useState2[1];

  useClientsideEffect(function () {
    return void setNeedsRerender(false);
  }, []);
  var themeColors = newTheme.rawColors || newTheme.colors;
  var useCustomProperties = (_newTheme$config2 = newTheme.config) == null ? void 0 : _newTheme$config2.useCustomProperties;
  var colorVars = (0,react.useMemo)(function () {
    if (useCustomProperties === false) {
      return {};
    }

    var colors = themeColors || {};
    return (0,theme_ui_css_esm/* css */.iv)(__createColorProperties(colors, colors.modes || {}))(newTheme);
  }, [newTheme, themeColors, useCustomProperties]);
  return /*#__PURE__*/react.createElement(__ThemeUIInternalBaseThemeProvider, {
    context: theme_ui_color_modes_esm_extends({}, outerCtx, {
      theme: newTheme
    })
  }, theme_ui_core_esm_jsx('div', {
    'data-themeui-nested-provider': true,
    // the key here ensures that children will be rerendered after color
    // mode is read from localStorage
    key: Number(needsRerender),
    suppressHydrationWarning: true,
    css: colorVars,
    children: children
  }));
}

var ColorModeProvider = function ColorModeProvider(_ref7) {
  var children = _ref7.children;
  var outerCtx = theme_ui_core_esm_useThemeUI();
  var isTopLevelColorModeProvider = typeof outerCtx.setColorMode !== 'function';
  return isTopLevelColorModeProvider ? /*#__PURE__*/react.createElement(TopLevelColorModeProvider, {
    outerCtx: outerCtx
  }, children) : /*#__PURE__*/react.createElement(NestedColorModeProvider, {
    outerCtx: outerCtx
  }, children);
};
var noflash = "(function() { try {\n  var mode = localStorage.getItem('theme-ui-color-mode');\n  if (!mode) return\n  document.documentElement.classList.add('theme-ui-' + mode);\n} catch (e) {} })();";
var InitializeColorMode = function InitializeColorMode() {
  return jsx('script', {
    key: 'theme-ui-no-flash',
    dangerouslySetInnerHTML: {
      __html: noflash
    }
  });
};



;// CONCATENATED MODULE: ../node_modules/@theme-ui/theme-provider/dist/theme-ui-theme-provider.esm.js






var RootStyles = function RootStyles() {
  return theme_ui_core_esm_jsx(emotion_react_browser_esm/* Global */.xB, {
    styles: function styles(emotionTheme) {
      var _theme$config;

      var theme = emotionTheme;

      var _ref = theme.config || theme,
          useRootStyles = _ref.useRootStyles;

      if (useRootStyles === false || theme.styles && !theme.styles.root) {
        return null;
      }

      var boxSizing = ((_theme$config = theme.config) == null ? void 0 : _theme$config.useBorderBox) === false ? undefined : 'border-box';
      return (0,theme_ui_css_esm/* css */.iv)({
        '*': {
          boxSizing: boxSizing
        },
        html: {
          variant: 'styles.root'
        },
        body: {
          margin: 0
        }
      })(theme);
    }
  });
};

var ThemeProvider = function ThemeProvider(_ref2) {
  var theme = _ref2.theme,
      children = _ref2.children;
  var outer = theme_ui_core_esm_useThemeUI();
  var isTopLevel = outer === __themeUiDefaultContextValue;
  return /*#__PURE__*/react.createElement(theme_ui_core_esm_ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/react.createElement(ColorModeProvider, null, isTopLevel && /*#__PURE__*/react.createElement(RootStyles, null), children));
};



;// CONCATENATED MODULE: ./src/head/Fonts.jsx


function HeadFonts() {
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)((head_default()), {
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("link", {
                rel: "preload",
                as: "font",
                crossOrigin: "anonymous",
                href: "/fonts/MrEavesXLModOT-Bold.woff2"
            }, "MrEavesXLModOT-Bold.woff2"),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("link", {
                rel: "preload",
                as: "font",
                crossOrigin: "anonymous",
                href: "/fonts/MrEavesXLModOT-Heavy.woff2"
            }, "MrEavesXLModOT-Heavy.woff2"),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("link", {
                rel: "preload",
                as: "font",
                crossOrigin: "anonymous",
                href: "/fonts/MrEavesXLModOT-Reg.woff2"
            }, "MrEavesXLModOT-Reg.woff2")
        ]
    });
}
/* harmony default export */ var Fonts = (HeadFonts);

;// CONCATENATED MODULE: ./src/head/Libs.jsx



function Libs() {
    var ref = (0,react.useState)(false), mounted = ref[0], setMounted = ref[1];
    (0,react.useEffect)(function() {
        if (window) {
            window._shipScout = window._shipScout || [];
            /**
      * commented it out because it overrides the Shopify object and breaks the Shopify Privacy library
      window.Shopify = window.Shopify || {};
      window.Shopify.shop =
        process.env.SHOPIFY_DOMAIN || 'kryo-gear.myshopify.com';
      */ window.shipScoutCookieDomain = window.location.host;
        }
        setMounted(true);
    }, []);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_jsx_runtime_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)((script_default()), {
                id: "url-params-cookie-script",
                strategy: "beforeInteractive",
                type: "text/javascript",
                dangerouslySetInnerHTML: {
                    __html: "\n            (function () {\n              const maxAge = '7776000';\n              const getDomain = (url) => {\n                const domainParts = url.split('.');\n                return domainParts.length > 2 ? domainParts.slice(-2).join('.') : url;\n              };\n              const getSubdomainIndex = (url) => {\n                if (!url) return 1;\n                const parts = url.split(\".\");\n                if (parts[0] === 'www') return 1;\n                return parts.length === 1 ? 0 : parts.length === 2 ? 1 : 2;\n              };\n              const subdomainIndex = getSubdomainIndex(window.location.host);\n              const generateFbc = (fbclid) => 'fb.' + subdomainIndex + '.' + Date.now() + '.' + fbclid;\n\n              const fbclid = new URLSearchParams(window.location.search).get('fbclid');\n              if (fbclid) {\n                const fbc = generateFbc(fbclid);\n                document.cookie = '_fbc=' + fbc + '; path=/; domain=.' + getDomain(window.location.hostname) + '; max-age=' + maxAge + '; samesite=lax';\n              }\n            })();"
                }
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("style", {
                children: ".async-hide { opacity: 0 !important}"
            }),
            mounted && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)((script_default()), {
                type: "text/javascript",
                id: "shipscout-script",
                strategy: "afterInteractive",
                src: "https://web.shipscout.app/app.min.js"
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)((script_default()), {
                type: "text/javascript",
                src: "https://cdn.searchspring.net/intellisuggest/is.min.js"
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)((script_default()), {
                id: "corso-checkout-plus",
                src: "https://cdn.corso.com/js/corso-checkout-plus.js?shop=kryo-gear.myshopify.com&sfToken=b93030adce344e1c14bf747d7a843d5d",
                strategy: "beforeInteractive"
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)((script_default()), {
                src: "https://js.afterpay.com/afterpay-1.x.js",
                strategy: "beforeInteractive"
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)((script_default()), {
                id: "tapcart-personalization-script",
                strategy: "beforeInteractive",
                type: "text/javascript",
                dangerouslySetInnerHTML: {
                    __html: 'if (document.querySelector(".main")) {\n            if (\n              Tapcart.variables.device.id === "BE5C7469-A800-45C8-B0E9-1E92284B4277"\n            ) {\n              document.querySelector(".main").style.display = "block";\n            } else {\n              document.querySelector(".main").style.display = "none";\n            }\n          }'
                }
            })
        ]
    });
}
/* harmony default export */ var head_Libs = (Libs);

;// CONCATENATED MODULE: ./src/head/Preconnects.jsx


function HeadPreconnects() {
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)((head_default()), {
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("link", {
                rel: "dns-prefetch",
                href: "https://cdn.shopify.com/"
            }, "cdn.shopify.com-prefetch"),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("link", {
                rel: "preconnect",
                href: "https://cdn.shopify.com/",
                crossOrigin: "anonymous"
            }, "cdn.shopify-prefetch"),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("link", {
                rel: "dns-prefetch",
                href: "https://monorail-edge.shopifysvc.com/"
            }, "monorail-edge.shopifysvc.com-prefetch"),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("link", {
                rel: "preconnect",
                href: "https://monorail-edge.shopifysvc.com/",
                crossOrigin: "anonymous"
            }, "monorail-edge.shopifysvc.com-preconnect"),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("link", {
                rel: "dns-prefetch",
                href: "https://www.googletagmanager.com/"
            }, "googletagmanager-prefetch"),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("link", {
                rel: "preconnect",
                href: "https://www.googletagmanager.com/",
                crossOrigin: "anonymous"
            }, "googletagmanager-preconnect"),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("link", {
                rel: "dns-prefetch",
                href: "https://googleads.g.doubleclick.net/"
            }, "googleads-prefetch"),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("link", {
                rel: "preconnect",
                href: "https://googleads.g.doubleclick.net/",
                crossOrigin: "anonymous"
            }, "googleads-preconnect"),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("link", {
                rel: "dns-prefetch",
                href: "https://www.googleadservices.com/"
            }, "googleadservices-prefetch"),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("link", {
                rel: "preconnect",
                href: "https://www.googleadservices.com/",
                crossOrigin: "anonymous"
            }, "googleadservices-preconnect"),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("link", {
                rel: "dns-prefetch",
                href: "https://www.google-analytics.com/"
            }, "google-analytics-prefetch"),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("link", {
                rel: "preconnect",
                href: "https://www.google-analytics.com/",
                crossOrigin: "anonymous"
            }, "google-analytics-preconnect"),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("link", {
                rel: "dns-prefetch",
                href: "https://fonts.googleapis.com/"
            }, "fonts-googleapis-prefetch"),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("link", {
                rel: "preconnect",
                href: "https://fonts.googleapis.com/",
                crossOrigin: "anonymous"
            }, "fonts-googleapis-preconnect"),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("link", {
                rel: "dns-prefetch",
                href: "https://fonts.gstatic.com/"
            }, "gstatic-prefetch"),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("link", {
                rel: "preconnect",
                href: "https://fonts.gstatic.com/",
                crossOrigin: "anonymous"
            }, "gstatic-preconnect"),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("link", {
                rel: "dns-prefetch",
                href: "https://ajax.googleapis.com/"
            }, "ajax-googleapis-prefetch"),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("link", {
                rel: "preconnect",
                href: "https://ajax.googleapis.com/",
                crossOrigin: "anonymous"
            }, "ajax-googleapis-preconnect"),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("link", {
                rel: "dns-prefetch",
                href: "https://analytics.tiktok.com/"
            }, "analytics-tiktok-prefetch"),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("link", {
                rel: "preconnect",
                href: "https://analytics.tiktok.com/",
                crossOrigin: "anonymous"
            }, "analytics-tiktok-preconnect"),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("link", {
                rel: "dns-prefetch",
                href: "https://tr.snapchat.com/"
            }, "snapchat-prefetch"),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("link", {
                rel: "preconnect",
                href: "https://tr.snapchat.com/",
                crossOrigin: "anonymous"
            }, "snapchat-preconnect"),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("link", {
                rel: "dns-prefetch",
                href: "https://www.facebook.com/"
            }, "facebook-prefetch"),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("link", {
                rel: "preconnect",
                href: "https://www.facebook.com/",
                crossOrigin: "anonymous"
            }, "facebook-preconnect"),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("link", {
                rel: "dns-prefetch",
                href: "https://www.facebook.com/"
            }, "facebook-prefetch"),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("link", {
                rel: "preconnect",
                href: "https://www.facebook.com/",
                crossOrigin: "anonymous"
            }, "facebook-preconnect"),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("link", {
                rel: "dns-prefetch",
                href: "https://connect.facebook.net/"
            }, "connect.facebook-prefetch"),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("link", {
                rel: "preconnect",
                href: "https://connect.facebook.net/",
                crossOrigin: "anonymous"
            }, "connect.facebook-preconnect"),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("link", {
                rel: "dns-prefetch",
                href: "https://connect.facebook.net/"
            }, "connect.facebook-prefetch"),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("link", {
                rel: "preconnect",
                href: "https://connect.facebook.net/",
                crossOrigin: "anonymous"
            }, "connect.facebook-preconnect"),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("link", {
                rel: "dns-prefetch",
                href: "https://cdn.polyfill.io/"
            }, "polyfill-prefetch"),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("link", {
                rel: "preconnect",
                href: "https://cdn.polyfill.io/",
                crossOrigin: "anonymous"
            }, "polyfill-preconnect"),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("link", {
                rel: "dns-prefetch",
                href: "https://cdnjs.cloudflare.com/"
            }, "cloudflare-prefetch"),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("link", {
                rel: "preconnect",
                href: "https://cdnjs.cloudflare.com/",
                crossOrigin: "anonymous"
            }, "cloudflare-preconnect"),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("link", {
                rel: "dns-prefetch",
                href: "https://".concat("kryo-gear.myshopify.com")
            }, "storefront-prefetch"),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("link", {
                rel: "preconnect",
                href: "https://".concat("kryo-gear.myshopify.com"),
                crossOrigin: "anonymous"
            }, "storefront-preconnect"),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("link", {
                rel: "icon",
                type: "image/x-icon",
                href: "/favicon.jpg"
            })
        ]
    });
}
/* harmony default export */ var Preconnects = (HeadPreconnects);

;// CONCATENATED MODULE: ./src/head/StorefrontHead.jsx




function StorefrontHead() {
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_jsx_runtime_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(head_Libs, {}),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Fonts, {}),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Preconnects, {})
        ]
    });
}

;// CONCATENATED MODULE: ./src/head/PageHead.jsx
/* provided dependency */ var PageHead_process = __webpack_require__(14284);


var backpackHeadUserConfig = {
    url: "https://www.brumate.com",
    title: "Br\xfcMate - Insulated Tumblers Coolers and More",
    description: "The world's most innovative premium drinkware coolers and more backed by a lifetime warranty and world class customer service.",
    author: PageHead_process.env.SITE_AUTHOR,
    locale: PageHead_process.env.SITE_LOCALE,
    social: {
        twitter: PageHead_process.env.SOCIAL_TWITTER,
        facebook: PageHead_process.env.SOCIAL_FACEBOOK,
        instagram: PageHead_process.env.SOCIAL_INSTAGRAM
    }
};
function PageHead(param) {
    var _page = param.page, page = _page === void 0 ? {} : _page;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var resourceType = page.resourceType;
    var pageUrl = "";
    if (resourceType === "home_page") {
        pageUrl = backpackHeadUserConfig.url;
    } else if (resourceType === "page") {
        pageUrl = "".concat(backpackHeadUserConfig.url, "/pages/").concat(page.handle);
    } else if (resourceType === "product_page") {
        pageUrl = "".concat(backpackHeadUserConfig.url, "/products/").concat(page.handle);
    } else if (resourceType === "collection_page") {
        pageUrl = "".concat(backpackHeadUserConfig.url, "/collections/").concat(page.handle);
    } else if (resourceType === "article") {
        pageUrl = "".concat(backpackHeadUserConfig.url, "/articles/").concat(page.handle);
    } else if (resourceType === "blog") {
        pageUrl = "".concat(backpackHeadUserConfig.url, "/blogs/").concat(page.handle);
    } else {
        pageUrl = backpackHeadUserConfig.url;
    }
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)((head_default()), {
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("title", {
                children: (page === null || page === void 0 ? void 0 : (ref = page.seo) === null || ref === void 0 ? void 0 : ref.title) || backpackHeadUserConfig.title
            }, "page-title"),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("meta", {
                name: "description",
                content: (page === null || page === void 0 ? void 0 : (ref1 = page.seo) === null || ref1 === void 0 ? void 0 : ref1.description) || backpackHeadUserConfig.description
            }, "page-description"),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("link", {
                rel: "canonical",
                href: pageUrl
            }, "page-canonical-url"),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1"
            }),
            (page === null || page === void 0 ? void 0 : (ref2 = page.seo) === null || ref2 === void 0 ? void 0 : ref2.image) ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_jsx_runtime_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("meta", {
                        property: "og:image",
                        content: page.seo.image
                    }, "page:fb:image"),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("meta", {
                        property: "og:image:alt",
                        content: (page === null || page === void 0 ? void 0 : (ref3 = page.seo) === null || ref3 === void 0 ? void 0 : ref3.title) || backpackHeadUserConfig.title
                    }, "page:fb:image:alt"),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("meta", {
                        name: "twitter:image",
                        content: page.seo.image
                    }, "page:twitter:image")
                ]
            }) : null,
            PageHead_process.env.FACEBOOK_APP_ID ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("meta", {
                property: "fb:app_id",
                content: PageHead_process.env.FACEBOOK_APP_ID
            }, "page:fb:app_id") : null,
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("meta", {
                property: "og:url",
                content: pageUrl
            }, "page:fb:url"),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("meta", {
                property: "og:type",
                content: "website"
            }, "page:fb:type"),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("meta", {
                property: "og:title",
                content: (page === null || page === void 0 ? void 0 : (ref4 = page.seo) === null || ref4 === void 0 ? void 0 : ref4.title) || backpackHeadUserConfig.title
            }, "page:fb:title"),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("meta", {
                property: "og:description",
                content: (page === null || page === void 0 ? void 0 : (ref5 = page.seo) === null || ref5 === void 0 ? void 0 : ref5.description) || backpackHeadUserConfig.description
            }, "page:fb:description"),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("meta", {
                property: "og:site_name",
                content: "BrüMate"
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("meta", {
                property: "og:locale",
                content: backpackHeadUserConfig.locale
            }, "page:fb:locale"),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("meta", {
                property: "og:author",
                content: backpackHeadUserConfig.author
            }, "page:fb:author"),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("meta", {
                name: "twitter:card",
                content: "summary"
            }, "page:twitter:card"),
            backpackHeadUserConfig.social.twitter ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("meta", {
                name: "twitter:site",
                content: backpackHeadUserConfig.social.twitter
            }, "page:twitter:site") : null,
            backpackHeadUserConfig.social.twitter ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("meta", {
                name: "twitter:creator",
                content: backpackHeadUserConfig.social.twitter
            }, "page:twitter:creator") : null,
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("meta", {
                name: "twitter:url",
                content: pageUrl
            }, "page:twitter:url"),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("meta", {
                name: "twitter:title",
                content: (page === null || page === void 0 ? void 0 : (ref6 = page.seo) === null || ref6 === void 0 ? void 0 : ref6.title) || backpackHeadUserConfig.title
            }, "page:twitter:title"),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("meta", {
                name: "twitter:description",
                content: (page === null || page === void 0 ? void 0 : (ref7 = page.seo) === null || ref7 === void 0 ? void 0 : ref7.description) || backpackHeadUserConfig.description
            }, "page:twitter:description"),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("meta", {
                name: "twitter:image:alt",
                content: (page === null || page === void 0 ? void 0 : (ref8 = page.seo) === null || ref8 === void 0 ? void 0 : ref8.title) || backpackHeadUserConfig.title
            }, "page:twitter:image:alt"),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("meta", {
                name: "robots",
                content: "index,follow"
            }, "default-all-search-engines-crawling"),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("meta", {
                name: "googlebot",
                content: "index,follow"
            }, "default-google-engine-crawling"),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("meta", {
                name: "apple-itunes-app",
                content: "app-id=1592551241",
                "app-argument": pageUrl
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("link", {
                rel: "manifest",
                href: "/manifest.json"
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "32x32",
                href: "/icons/icon-32x32.png"
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("link", {
                rel: "apple-touch-icon",
                sizes: "192x192",
                href: "/icons/icon-384x384.png"
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("meta", {
                name: "application-name",
                content: "BrüMate"
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("meta", {
                name: "apple-mobile-web-app-capable",
                content: "yes"
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("meta", {
                name: "apple-mobile-web-app-status-bar-style",
                content: "default"
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("meta", {
                name: "apple-mobile-web-app-title",
                content: "BrüMate"
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("meta", {
                name: "theme-color",
                content: PageHead_process.env.NEXT_PUBLIC_THEME_COLOR || "#000000"
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("meta", {
                name: "format-detection",
                content: "telephone=no"
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("meta", {
                name: "mobile-web-app-capable",
                content: "yes"
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("meta", {
                name: "msapplication-TileColor",
                content: PageHead_process.env.NEXT_PUBLIC_THEME_COLOR || "#000000"
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("meta", {
                name: "msapplication-tap-highlight",
                content: "no"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/head/DevelopmentHead.jsx


// Development only head or scripts
function DevelopmentHead() {
    return  false ? /*#__PURE__*/ 0 : null;
}

;// CONCATENATED MODULE: ./src/head/index.js
/* eslint-disable import/no-default-export */ 



// EXTERNAL MODULE: ./src/snippets/Cart/index.js + 45 modules
var Cart = __webpack_require__(8977);
;// CONCATENATED MODULE: ./src/layouts/Storefront.jsx















var gtmContainerId = /* process.env.NEXT_PUBLIC_GTM_CONTAINER_ID || */ "GTM-P3XTC38C"; // To Do - Switch back to using variable at launch.
function GlobalThemeProvider(param) {
    var children = param.children, theme = param.theme, components = param.components;
    var componentsWithStyles = useThemedStylesWithMdx(useMDXComponents(components));
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(ThemeProvider, {
        theme: theme,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(MDXProvider, {
            components: componentsWithStyles,
            children: children
        })
    });
}
var webbridgeClient = (0,webbridge_react_es/* loadWebbridge */.g1)();
// Intelligems Track Page Views
function IgPageViewTracker() {
    var cart = (0,dist.useCart)();
    var currencyCode = (0,dist.useCurrency)();
    var country = (0,dist.useCountry)().country;
    var countryCode = country === null || country === void 0 ? void 0 : country.isoCode;
    var trackingParams = {
        cartOrCheckoutToken: cart === null || cart === void 0 ? void 0 : cart.id,
        currency: currencyCode,
        country: countryCode || "US"
    };
    (0,pack/* useIgTrack */.q5)(trackingParams);
    (0,pack/* useIgCart */.Gx)(cart === null || cart === void 0 ? void 0 : cart.id);
    return null;
}
function StorefrontLayout(_param) {
    var ContentForLayout = _param.ContentForLayout, props = (0,_object_without_properties/* default */.Z)(_param, [
        "ContentForLayout"
    ]);
    var ref, ref1;
    var settings = (0,dist.useSettings)();
    var getGiftProducts = (0,hooks/* useGiftWithPurchase */.tG)().getGiftProducts;
    var _ref = (0,hooks/* usePasswordProtected */.uE)(), hasAccess = _ref.hasAccess, status = (0,_object_without_properties/* default */.Z)(_ref, [
        "hasAccess"
    ]);
    // initialize customer, cart, shop and markets
    (0,dist.useStorefrontInit)();
    (0,hooks/* useGeolocation */.ZZ)();
    // adds --viewport-height css var to the :root
    (0,hooks/* useSetViewportHeightCssVar */.ri)();
    // auto applies cart discount found on the landing url
    (0,dist.useCartAddDiscountUrl)({
        queryParams: [
            "promo",
            "discountCode",
            "discount_code",
            "discount"
        ],
        removeParams: false
    });
    // track siteSetting changes in recoil
    (0,hooks/* useTrackSettings */.x0)();
    // initialize wishlists
    (0,hooks/* useInitWishlist */.N8)();
    // redirect to home page from cart page & automatically open cart with cart param
    (0,hooks/* useCartRedirect */.Wy)();
    // set shopper id for searchspring intellisuggest
    (0,hooks/* useShopperId */.Xs)();
    // Get Gift Product for Gift With Purchase
    (0,react.useEffect)(function() {
        getGiftProducts();
    }, [
        settings === null || settings === void 0 ? void 0 : (ref = settings.gwp) === null || ref === void 0 ? void 0 : ref.enabled,
        settings === null || settings === void 0 ? void 0 : (ref1 = settings.gwp) === null || ref1 === void 0 ? void 0 : ref1.giftProducts
    ]);
    // send intellisuggest event on cart change
    (0,Cart/* useCartIntelliSuggest */.Z0)();
    (0,Cart/* useCartRejectDiscount */.QF)();
    // set cj cookies
    (0,hooks/* useCJCookies */.Ps)();
    // send page view and add to cart events to Shopify analytics
    (0,hooks/* useShopifyAnalytics */.bu)({
        collection: props.collection,
        product: props.product
    });
    // set pack session cookie
    (0,hooks/* usePackCookie */.ws)();
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(webbridge_react_es/* WebbridgeProvider */.VL, {
        webbridgeClient: webbridgeClient,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(pack/* IntelligemsPackProvider */._A, {
            organizationId: "f06f0aa2-a074-426c-a5d2-23d04c2bf43a",
            storefrontApiToken: "7b8296bfc85c0cb6fbc85bd5fa81686f",
            antiFlicker: true,
            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(GlobalThemeProvider, {
                theme: theme/* theme */.r,
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(PageHead, {
                        page: props.page
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(StorefrontHead, {}),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(IgPageViewTracker, {}),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Fueled */.NA, {}),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* DataLayerEventListeners */.nz, (0,_object_spread/* default */.Z)({}, props)),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* VideoWiseScript */.rc, (0,_object_spread/* default */.Z)({}, props)),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* SeoPageSchema */.Ee, (0,_object_spread/* default */.Z)({}, props)),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Header */.h4, {}),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                        style: {
                            display: "flex",
                            flexDirection: "column",
                            minHeight: "calc(var(--viewport-height) - var(--header-height) - var(--promoBar-height))",
                            alignItems: "stretch"
                        },
                        children: [
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Container */.W2, {
                                as: "main",
                                role: "main",
                                sx: {
                                    flexGrow: 1,
                                    flexShrink: 0
                                },
                                children: (status === null || status === void 0 ? void 0 : status.success) && !hasAccess ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* PasswordProtectedModal */.w6, {}) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(ContentForLayout, (0,_object_spread/* default */.Z)({}, props))
                            }),
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                                sx: {
                                    flexShrink: 0
                                },
                                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Footer */.$_, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Overlay */.aV, {}),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* CartSearchSidebarShell */.uQ, {}),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* FiltersSidebarShell */.WU, {}),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Modal */.u_, {}),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* LoyaltyLionScript */.So, {}),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Vwo */.$Z, {}),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* BuyWithPrime */.pI, {}),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                        dangerouslySetInnerHTML: {
                            __html: '\n              <noscript><iframe src="https://www.googletagmanager.com/ns.html?id='.concat(gtmContainerId, '"\n              height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>\n            ')
                        }
                    })
                ]
            })
        })
    });
}
// eslint-disable-next-line import/no-default-export
/* harmony default export */ var Storefront = (StorefrontLayout);

// EXTERNAL MODULE: ./src/styles/storefront.css
var storefront = __webpack_require__(31307);
;// CONCATENATED MODULE: ./src/pages/_app.jsx
/* eslint-disable react/destructuring-assignment */ /* eslint-disable import/no-unresolved */ 






// This is new customizer bridge






(0,utils/* rafTimeoutInterval */.N$)();
function StorefrontApp(param) {
    var Component = param.Component, pageData = param.pageData, pageProps = param.pageProps, router = param.router, storefrontSettings = param.storefrontSettings;
    var setRoute = dist.store.recoil.useSetRecoilState(dist.store.state.route);
    var setStorefrontSettings = dist.store.recoil.useSetRecoilState(dist.store.state.storefrontSettings);
    var config = (0,telejson_dist/* parse */.Qc)((pageProps === null || pageProps === void 0 ? void 0 : pageProps.config) || "{}");
    // update ROUTE_VIEW state
    // this is responsible for sending all the VIEW_X events
    (0,react.useEffect)(function() {
        setRoute(router.asPath);
    }, [
        router.asPath,
        setRoute
    ]);
    // update the storefront settings in recoil store
    (0,react.useEffect)(function() {
        setStorefrontSettings(storefrontSettings);
    }, [
        storefrontSettings,
        setStorefrontSettings
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_jsx_runtime_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(_components/* Partytown */.iA, (0,_object_spread/* default */.Z)({}, config === null || config === void 0 ? void 0 : config.partytown)),
            pageProps.isPreview && pageProps.isShareableToken && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(_components/* PreviewModeToast */.UZ, {}),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Storefront, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                ContentForLayout: Component
            }, pageProps), {
                config: config,
                renderSections: (0,customizerUtils.renderSections)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pageProps), {
                    page: pageData
                }), sections)
            }))
        ]
    });
}
var useOverlayScript = function(param) {
    var isPreview = param.isPreview, overlay = param.overlay;
    (0,react.useEffect)(function() {
        if (isPreview && ((overlay === null || overlay === void 0 ? void 0 : overlay.src) || (overlay === null || overlay === void 0 ? void 0 : overlay.version)) && !window.isOverlayScriptInjected) {
            var script = document.createElement("script");
            script.src = (overlay === null || overlay === void 0 ? void 0 : overlay.src) || "https://d3dizc9fcooe02.cloudfront.net/overlay@".concat(overlay === null || overlay === void 0 ? void 0 : overlay.version, "/dist/overlay.js");
            script.async = true;
            document.head.appendChild(script);
            window.isOverlayScriptInjected = true;
        }
    }, [
        isPreview,
        overlay
    ]);
};
function App(props) {
    var ref;
    var Component = props.Component, pageProps = props.pageProps, router = props.router;
    var ref1 = (0,customizerUtils.useCustomizerShell)({
        environment: pageProps.environment,
        isPreview: pageProps.isPreview,
        isShareableToken: pageProps.isShareableToken,
        sectionComponents: sections,
        staticProps: pageProps,
        storefrontSettingsSchema: settings
    }), pageData = ref1.pageData, storefrontSettings = ref1.storefrontSettings;
    useOverlayScript({
        isPreview: pageProps.isPreview,
        overlay: (ref = pageProps.customizerMeta) === null || ref === void 0 ? void 0 : ref.overlay
    });
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(_components/* PageErrorBoundary */.bg, {
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(dist.StateProvider, {
            pageData: pageData,
            pageProps: pageProps,
            route: router.asPath,
            storefrontSettings: storefrontSettings,
            children: /*#__PURE__*/ react.cloneElement(/*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(StorefrontApp, {}), {
                Component: Component,
                pageData: pageData,
                pageProps: pageProps,
                router: router,
                storefrontSettings: storefrontSettings
            }, null)
        })
    });
}
/* harmony default export */ var _app = (App);


/***/ }),

/***/ 37351:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ color; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3204);
/* harmony import */ var lodash_startcase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78372);
/* harmony import */ var lodash_startcase__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_startcase__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _theme_theme_colors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75458);



// can be used in any select field as its options
var color = {
    options: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Object.keys(_theme_theme_colors__WEBPACK_IMPORTED_MODULE_1__/* .colors */ .O)).filter(function(colorKey) {
        return colorKey !== "dark";
    }).map(function(colorKey) {
        return {
            label: colorKey === "text" ? "Dark (Text)" : lodash_startcase__WEBPACK_IMPORTED_MODULE_0___default()(colorKey),
            value: _theme_theme_colors__WEBPACK_IMPORTED_MODULE_1__/* .colors */ .O[colorKey]
        };
    }).sort(function(a, b) {
        if (a.label < b.label) {
            return -1;
        }
        if (a.label > b.label) {
            return 1;
        }
        return 0;
    }),
    value: _theme_theme_colors__WEBPACK_IMPORTED_MODULE_1__/* .colors */ .O,
    list: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(new Set((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Object.values(_theme_theme_colors__WEBPACK_IMPORTED_MODULE_1__/* .colors */ .O))))
};


/***/ }),

/***/ 33580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "AJ": function() { return /* reexport */ align; },
  "LI": function() { return /* reexport */ button_button; },
  "$_": function() { return /* reexport */ color/* color */.$; },
  "bK": function() { return /* reexport */ layout; },
  "e6": function() { return /* reexport */ margin; },
  "o3": function() { return /* reexport */ padding; },
  "FK": function() { return /* reexport */ position; },
  "qi": function() { return /* reexport */ section; },
  "Z1": function() { return /* reexport */ sectionWithHeight; },
  "LY": function() { return /* reexport */ timezones; }
});

// UNUSED EXPORTS: space

;// CONCATENATED MODULE: ./src/settings/common/align.js
var align = {
    options: [
        {
            label: "Left",
            value: "left"
        },
        {
            label: "Center",
            value: "center"
        },
        {
            label: "Right",
            value: "right"
        }, 
    ],
    value: {
        left: "left",
        center: "center",
        right: "right"
    }
};

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3204);
// EXTERNAL MODULE: ../node_modules/lodash.startcase/index.js
var lodash_startcase = __webpack_require__(78372);
var lodash_startcase_default = /*#__PURE__*/__webpack_require__.n(lodash_startcase);
// EXTERNAL MODULE: ./src/theme/theme.buttons.js
var theme_buttons = __webpack_require__(27750);
;// CONCATENATED MODULE: ./src/settings/common/button.js



// can be used in any select field as its options
var button_button = {
    options: (0,_to_consumable_array/* default */.Z)(Object.keys(theme_buttons/* buttons */.Z)).filter(function(key) {
        return ![
            "link",
            "plain"
        ].includes(key);
    }).map(function(key) {
        return {
            label: lodash_startcase_default()(key),
            value: key
        };
    }).sort(function(a, b) {
        if (a.label < b.label) {
            return -1;
        }
        if (a.label > b.label) {
            return 1;
        }
        return 0;
    }),
    value: Object.keys(theme_buttons/* buttons */.Z).reduce(function(obj, key) {
        obj[key] = key;
        return obj;
    }, {})
};

// EXTERNAL MODULE: ./src/settings/common/color.js
var color = __webpack_require__(37351);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
;// CONCATENATED MODULE: ./src/settings/common/layout.js
var layout = {
    options: [
        {
            label: "Full Bleed",
            value: "container"
        },
        {
            label: "Padded",
            value: "padded"
        },
        {
            label: "Contained (Narrow)",
            value: "contentNarrow"
        },
        {
            label: "Contained (Medium)",
            value: "content"
        },
        {
            label: "Contained (Wide)",
            value: "contentWide"
        }, 
    ],
    optionsMobile: [
        {
            label: "Full Bleed",
            value: "container"
        },
        {
            label: "Padded",
            value: "padded"
        }, 
    ],
    value: {
        container: "container",
        padded: "padded",
        contentNarrow: "contentNarrow",
        content: "content",
        contentWide: "contentWide"
    }
};

// EXTERNAL MODULE: ./src/theme/theme.space.js
var theme_space = __webpack_require__(58486);
;// CONCATENATED MODULE: ./src/settings/common/space.js

// can be used in any select field as its options
var space = {
    options: theme_space/* space.map */.D.map(function(value, index) {
        return {
            label: "".concat(value, "px"),
            value: index
        };
    }),
    value: Object.keys(theme_space/* space */.D).reduce(function(obj, key) {
        obj[key] = parseInt(key);
        return obj;
    }, {})
};
var margin = {
    options: [
        {
            label: "None",
            value: "none"
        },
        {
            label: "Small",
            value: "s"
        },
        {
            label: "Medium",
            value: "m"
        },
        {
            label: "Large",
            value: "l"
        },
        {
            label: "XLarge",
            value: "xl"
        }, 
    ],
    value: {
        none: [
            0,
            0,
            0,
            0
        ],
        xs: [
            4,
            6,
            8,
            10
        ],
        s: [
            8,
            11,
            12,
            14
        ],
        m: [
            12,
            14,
            15,
            16
        ],
        l: [
            15,
            16,
            17,
            18
        ],
        xl: [
            17,
            18,
            "80px",
            "88px"
        ]
    }
};
var padding = {
    options: [
        {
            label: "None",
            value: "none"
        },
        {
            label: "Small",
            value: "s"
        },
        {
            label: "Medium",
            value: "m"
        },
        {
            label: "Large",
            value: "l"
        },
        {
            label: "XLarge",
            value: "xl"
        }, 
    ],
    value: {
        none: [
            0,
            0,
            0,
            0
        ],
        xs: [
            4,
            6,
            8,
            10
        ],
        s: [
            8,
            11,
            12,
            14
        ],
        m: [
            12,
            14,
            15,
            16
        ],
        l: [
            15,
            16,
            17,
            18
        ],
        xl: [
            17,
            18,
            "80px",
            "88px"
        ]
    }
};

;// CONCATENATED MODULE: ./src/settings/common/section.js






var fields = [
    {
        name: "bgColor",
        label: "Background color",
        component: "select",
        options: color/* color.options */.$.options,
        defaultValue: color/* color.value.background */.$.value.background
    },
    {
        name: "color",
        label: "Text color",
        component: "select",
        options: color/* color.options */.$.options,
        defaultValue: color/* color.value.text */.$.value.text
    }, 
];
var mobileFields = [
    {
        label: "Container width (mobile)",
        component: "select",
        name: "container",
        options: layout.optionsMobile
    },
    {
        name: "mt",
        label: "Margin top (mobile)",
        component: "select",
        options: margin.options
    },
    {
        name: "py",
        label: "Vertical padding (mobile)",
        component: "select",
        options: padding.options
    }, 
];
var mobileDefaultValue = {
    container: layout.value.container,
    mt: "none",
    py: "none"
};
var desktopFields = [
    {
        label: "Container width (desktop)",
        component: "select",
        name: "container",
        options: layout.options
    },
    {
        name: "mt",
        label: "Margin top (desktop)",
        component: "select",
        options: margin.options
    },
    {
        name: "py",
        label: "Vertical padding (desktop)",
        component: "select",
        options: padding.options
    }, 
];
var desktopDefaultValue = {
    container: layout.value.container,
    mt: "none",
    py: "none"
};
var mobile = {
    label: "Mobile Settings",
    name: "mobile",
    component: "group",
    fields: mobileFields,
    defaultValue: mobileDefaultValue
};
var desktop = {
    label: "Desktop Settings",
    name: "desktop",
    component: "group",
    fields: desktopFields,
    defaultValue: desktopDefaultValue
};
var mobileWithHeight = {
    label: "Mobile Settings",
    name: "mobile",
    component: "group",
    fields: (0,_to_consumable_array/* default */.Z)(mobileFields).concat([
        {
            name: "minHeight",
            component: "number",
            label: "Min section pixel height (mobile)"
        },
        {
            name: "maxHeight",
            component: "number",
            label: "Max section pixel height (mobile)"
        }, 
    ]),
    defaultValue: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, mobileDefaultValue), {
        container: layout.value.padded,
        maxHeight: 375,
        minHeight: 375
    })
};
var desktopWithHeight = {
    label: "Desktop Settings",
    name: "desktop",
    component: "group",
    fields: (0,_to_consumable_array/* default */.Z)(desktopFields).concat([
        {
            name: "minHeight",
            component: "number",
            label: "Min section pixel height (desktop)"
        },
        {
            name: "maxHeight",
            component: "number",
            label: "Max section pixel height (desktop)"
        }, 
    ]),
    defaultValue: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, desktopDefaultValue), {
        container: layout.value.padded,
        maxHeight: 460,
        minHeight: 460
    })
};
var section = {
    label: "Section Settings",
    name: "section",
    description: "Background color, text color, container width, margin top, vertical padding",
    component: "group",
    fields: (0,_to_consumable_array/* default */.Z)(fields).concat([
        desktop,
        mobile
    ])
};
var sectionWithHeight = {
    label: "Section Settings",
    name: "section",
    description: "Background color, text color, container width, margin top, vertical padding, section heights",
    component: "group",
    fields: (0,_to_consumable_array/* default */.Z)(fields).concat([
        desktopWithHeight,
        mobileWithHeight
    ])
};

;// CONCATENATED MODULE: ./src/settings/common/position.js
var object = [
    {
        value: "left top",
        label: "Left Top"
    },
    {
        value: "left center",
        label: "Left Center"
    },
    {
        value: "left bottom",
        label: "Left Bottom"
    },
    {
        value: "right top",
        label: "Right Top"
    },
    {
        value: "right center",
        label: "Right Center"
    },
    {
        value: "right bottom",
        label: "Right Bottom"
    },
    {
        value: "center top",
        label: "Center Top"
    },
    {
        value: "center center",
        label: "Center Center"
    },
    {
        value: "center bottom",
        label: "Center Bottom"
    }, 
];
var flex = [
    {
        value: "flex-start flex-start",
        label: "Left Top"
    },
    {
        value: "flex-start center",
        label: "Left Center"
    },
    {
        value: "flex-start flex-end",
        label: "Left Bottom"
    },
    {
        value: "flex-end flex-start",
        label: "Right Top"
    },
    {
        value: "flex-end center",
        label: "Right Center"
    },
    {
        value: "flex-end flex-end",
        label: "Right Bottom"
    },
    {
        value: "center flex-start",
        label: "Center Top"
    },
    {
        value: "center center",
        label: "Center Center"
    },
    {
        value: "center flex-end",
        label: "Center Bottom"
    }, 
];
var position = {
    flex: flex,
    object: object
};

;// CONCATENATED MODULE: ./src/settings/common/timezones.js
var timezones = {
    options: [
        {
            label: "Etc/GMT-12",
            value: "Etc/GMT-12"
        },
        {
            label: "Etc/GMT-11",
            value: "Etc/GMT-11"
        },
        {
            label: "Pacific/Midway",
            value: "Pacific/Midway"
        },
        {
            label: "America/Adak",
            value: "America/Adak"
        },
        {
            label: "America/Anchorage",
            value: "America/Anchorage"
        },
        {
            label: "Pacific/Gambier",
            value: "Pacific/Gambier"
        },
        {
            label: "America/Dawson_Creek",
            value: "America/Dawson_Creek"
        },
        {
            label: "America/Ensenada",
            value: "America/Ensenada"
        },
        {
            label: "America/Los_Angeles",
            value: "America/Los_Angeles"
        },
        {
            label: "America/Chihuahua",
            value: "America/Chihuahua"
        },
        {
            label: "America/Denver",
            value: "America/Denver"
        },
        {
            label: "America/Belize",
            value: "America/Belize"
        },
        {
            label: "America/Cancun",
            value: "America/Cancun"
        },
        {
            label: "America/Chicago",
            value: "America/Chicago"
        },
        {
            label: "Chile/EasterIsland",
            value: "Chile/EasterIsland"
        },
        {
            label: "America/Bogota",
            value: "America/Bogota"
        },
        {
            label: "America/Havana",
            value: "America/Havana"
        },
        {
            label: "America/New_York",
            value: "America/New_York"
        },
        {
            label: "America/Caracas",
            value: "America/Caracas"
        },
        {
            label: "America/Campo_Grande",
            value: "America/Campo_Grande"
        },
        {
            label: "America/Glace_Bay",
            value: "America/Glace_Bay"
        },
        {
            label: "America/Goose_Bay",
            value: "America/Goose_Bay"
        },
        {
            label: "America/Santiago",
            value: "America/Santiago"
        },
        {
            label: "America/La_Paz",
            value: "America/La_Paz"
        },
        {
            label: "America/Argentina/Buenos_Aires",
            value: "America/Argentina/Buenos_Aires"
        },
        {
            label: "America/Montevideo",
            value: "America/Montevideo"
        },
        {
            label: "America/Araguaina",
            value: "America/Araguaina"
        },
        {
            label: "America/Godthab",
            value: "America/Godthab"
        },
        {
            label: "America/Miquelon",
            value: "America/Miquelon"
        },
        {
            label: "America/Sao_Paulo",
            value: "America/Sao_Paulo"
        },
        {
            label: "America/St_Johns",
            value: "America/St_Johns"
        },
        {
            label: "America/Noronha",
            value: "America/Noronha"
        },
        {
            label: "Atlantic/Cape_Verde",
            value: "Atlantic/Cape_Verde"
        },
        {
            label: "Europe/Belfast",
            value: "Europe/Belfast"
        },
        {
            label: "Africa/Abidjan",
            value: "Africa/Abidjan"
        },
        {
            label: "Europe/Dublin",
            value: "Europe/Dublin"
        },
        {
            label: "Europe/Lisbon",
            value: "Europe/Lisbon"
        },
        {
            label: "Europe/London",
            value: "Europe/London"
        },
        {
            label: "UTC",
            value: "UTC"
        },
        {
            label: "Africa/Algiers",
            value: "Africa/Algiers"
        },
        {
            label: "Africa/Windhoek",
            value: "Africa/Windhoek"
        },
        {
            label: "Atlantic/Azores",
            value: "Atlantic/Azores"
        },
        {
            label: "Atlantic/Stanley",
            value: "Atlantic/Stanley"
        },
        {
            label: "Europe/Amsterdam",
            value: "Europe/Amsterdam"
        },
        {
            label: "Europe/Belgrade",
            value: "Europe/Belgrade"
        },
        {
            label: "Europe/Brussels",
            value: "Europe/Brussels"
        },
        {
            label: "Africa/Cairo",
            value: "Africa/Cairo"
        },
        {
            label: "Africa/Blantyre",
            value: "Africa/Blantyre"
        },
        {
            label: "Asia/Beirut",
            value: "Asia/Beirut"
        },
        {
            label: "Asia/Damascus",
            value: "Asia/Damascus"
        },
        {
            label: "Asia/Gaza",
            value: "Asia/Gaza"
        },
        {
            label: "Asia/Jerusalem",
            value: "Asia/Jerusalem"
        },
        {
            label: "Africa/Addis_Ababa",
            value: "Africa/Addis_Ababa"
        },
        {
            label: "Asia/Riyadh89",
            value: "Asia/Riyadh89"
        },
        {
            label: "Europe/Minsk",
            value: "Europe/Minsk"
        },
        {
            label: "Asia/Tehran",
            value: "Asia/Tehran"
        },
        {
            label: "Asia/Dubai",
            value: "Asia/Dubai"
        },
        {
            label: "Asia/Yerevan",
            value: "Asia/Yerevan"
        },
        {
            label: "Europe/Moscow",
            value: "Europe/Moscow"
        },
        {
            label: "Asia/Kabul",
            value: "Asia/Kabul"
        },
        {
            label: "Asia/Tashkent",
            value: "Asia/Tashkent"
        },
        {
            label: "Asia/Kolkata",
            value: "Asia/Kolkata"
        },
        {
            label: "Asia/Katmandu",
            value: "Asia/Katmandu"
        },
        {
            label: "Asia/Dhaka",
            value: "Asia/Dhaka"
        },
        {
            label: "Asia/Yekaterinburg",
            value: "Asia/Yekaterinburg"
        },
        {
            label: "Asia/Rangoon",
            value: "Asia/Rangoon"
        },
        {
            label: "Asia/Bangkok",
            value: "Asia/Bangkok"
        },
        {
            label: "Asia/Novosibirsk",
            value: "Asia/Novosibirsk"
        },
        {
            label: "Etc/GMT+8",
            value: "Etc/GMT+8"
        },
        {
            label: "Asia/Hong_Kong",
            value: "Asia/Hong_Kong"
        },
        {
            label: "Asia/Krasnoyarsk",
            value: "Asia/Krasnoyarsk"
        },
        {
            label: "Australia/Perth",
            value: "Australia/Perth"
        },
        {
            label: "Australia/Eucla",
            value: "Australia/Eucla"
        },
        {
            label: "Asia/Irkutsk",
            value: "Asia/Irkutsk"
        },
        {
            label: "Asia/Seoul",
            value: "Asia/Seoul"
        },
        {
            label: "Asia/Tokyo",
            value: "Asia/Tokyo"
        },
        {
            label: "Australia/Adelaide",
            value: "Australia/Adelaide"
        },
        {
            label: "Australia/Darwin",
            value: "Australia/Darwin"
        },
        {
            label: "Pacific/Marquesas",
            value: "Pacific/Marquesas"
        },
        {
            label: "Etc/GMT+10",
            value: "Etc/GMT+10"
        },
        {
            label: "Australia/Brisbane",
            value: "Australia/Brisbane"
        },
        {
            label: "Australia/Hobart",
            value: "Australia/Hobart"
        },
        {
            label: "Asia/Yakutsk",
            value: "Asia/Yakutsk"
        },
        {
            label: "Australia/Lord_Howe",
            value: "Australia/Lord_Howe"
        },
        {
            label: "Asia/Vladivostok",
            value: "Asia/Vladivostok"
        },
        {
            label: "Pacific/Norfolk",
            value: "Pacific/Norfolk"
        },
        {
            label: "Etc/GMT+12",
            value: "Etc/GMT+12"
        },
        {
            label: "Asia/Anadyr",
            value: "Asia/Anadyr"
        },
        {
            label: "Asia/Magadan",
            value: "Asia/Magadan"
        },
        {
            label: "Pacific/Auckland",
            value: "Pacific/Auckland"
        },
        {
            label: "Pacific/Chatham",
            value: "Pacific/Chatham"
        },
        {
            label: "Pacific/Tongatapu",
            value: "Pacific/Tongatapu"
        },
        {
            label: "Pacific/Kiritimati",
            value: "Pacific/Kiritimati"
        }, 
    ]
};

;// CONCATENATED MODULE: ./src/settings/common/index.js










/***/ }),

/***/ 41906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ useAddToCart; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(23842);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(31373);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52050);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(3204);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(59312);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27695);
/* harmony import */ var _backpackjs_storefront__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52031);
/* harmony import */ var _backpackjs_storefront__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_backpackjs_storefront__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _intelligems_headless_pack__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96807);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74424);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39136);











var useAddToCart = function(param) {
    var selectedVariant = param.selectedVariant, product = param.product, rebuyWidget = param.rebuyWidget;
    var ref, ref1;
    var gotoSnapshot = (0,_store__WEBPACK_IMPORTED_MODULE_1__/* .useGotoRecoilSnapshot */ .le)();
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useSelectedPlan */ .JM)({
        selectedVariant: selectedVariant
    }), 1), selectedPlan = ref2[0];
    var cart = (0,_backpackjs_storefront__WEBPACK_IMPORTED_MODULE_2__.useCart)();
    var wrapCustomAttributes = (0,_intelligems_headless_pack__WEBPACK_IMPORTED_MODULE_3__/* .useIgCart */ .Gx)(cart === null || cart === void 0 ? void 0 : cart.id).wrapCustomAttributes;
    var _ref = (0,_backpackjs_storefront__WEBPACK_IMPORTED_MODULE_2__.useCartAddItem)(), cartAddItem = _ref.cartAddItem, addItemStatus = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_ref, [
        "cartAddItem"
    ]);
    var _ref1 = (0,_backpackjs_storefront__WEBPACK_IMPORTED_MODULE_2__.useProductInventoryByHandle)({
        handle: product === null || product === void 0 ? void 0 : product.handle,
        withQuantity: true
    }), inventory = _ref1.inventory, inventoryStatus = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_ref1, [
        "inventory"
    ]);
    var variantStorefrontId = (0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .isEncoded */ .x)(inventory === null || inventory === void 0 ? void 0 : inventory.id) ? (0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .getEncodedId */ .m4)(selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.storefrontId) : selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.storefrontId;
    var variantInventory = inventory ? inventory === null || inventory === void 0 ? void 0 : (ref = inventory.variants) === null || ref === void 0 ? void 0 : ref[variantStorefrontId] : null;
    var isGiftCard = (variantInventory === null || variantInventory === void 0 ? void 0 : (ref1 = variantInventory.product) === null || ref1 === void 0 ? void 0 : ref1.handle) === "brumate-e-gift-card" || (product === null || product === void 0 ? void 0 : product.handle) === "brumate-e-gift-card";
    var isSoldOut = !variantInventory || variantInventory.quantityAvailable <= 0 && !isGiftCard;
    var isPreOrder = isSoldOut && (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.inventoryPolicy) === "CONTINUE";
    var toggleCartSidebar = (0,_store__WEBPACK_IMPORTED_MODULE_1__/* .useRecoilCallback */ ._8)(function(param) {
        var snapshot = param.snapshot;
        return /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
            var release, updatedState;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                release = snapshot.retain();
                try {
                    updatedState = snapshot.map(function(param) {
                        var set = param.set;
                        return set(_store__WEBPACK_IMPORTED_MODULE_1__/* ["default"].modal */ .ZP.modal, null);
                    }).map(function(param) {
                        var set = param.set;
                        return set(_store__WEBPACK_IMPORTED_MODULE_1__/* ["default"].overlay */ .ZP.overlay, true);
                    }).map(function(param) {
                        var set = param.set;
                        return set(_store__WEBPACK_IMPORTED_MODULE_1__/* ["default"].sidebar */ .ZP.sidebar, "cart");
                    });
                    // update state
                    gotoSnapshot(updatedState);
                } finally{
                    release();
                }
                return [
                    2
                ];
            });
        });
    });
    // add oneTime and subs
    var addToCart = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
        var ref, callback, openCart, ref1, item, rebuyAttributes, cart;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ref = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {
                        openCart: true
                    }, callback = ref.callback, openCart = ref.openCart;
                    if (!selectedVariant || isSoldOut && !isPreOrder) return [
                        2
                    ];
                    item = {
                        merchandiseId: selectedVariant.id,
                        quantity: 1
                    };
                    // adds shipscout attribute to collect data for abtest
                    if (typeof window.ShipScoutLineItemProperty !== "undefined") {
                        item.attributes = [
                            {
                                key: "_sc",
                                value: window.ShipScoutLineItemProperty
                            }, 
                        ];
                    }
                    // adds tracking attributes if rebuyWidget is present
                    if (rebuyWidget) {
                        rebuyAttributes = [
                            {
                                key: "_attribution",
                                value: "PDP"
                            },
                            {
                                key: "_source",
                                value: "Rebuy"
                            },
                            {
                                key: "_widget",
                                value: rebuyWidget
                            }
                        ];
                        if (item.attributes) {
                            item.attributes = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(item.attributes).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(rebuyAttributes));
                        } else {
                            item.attributes = rebuyAttributes;
                        }
                    }
                    if ((selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref1 = selectedVariant.product) === null || ref1 === void 0 ? void 0 : ref1.id) && (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id)) {
                        item.attributes = wrapCustomAttributes({
                            productId: selectedVariant.product.id,
                            variantId: selectedVariant.id,
                            subscribeAndSave: false,
                            customAttributes: item.attributes
                        });
                    }
                    if (typeof window.ShipScoutTrackAddToCart === "function") {
                        window.ShipScoutTrackAddToCart();
                    }
                    // if selling plan is selected we the subscription
                    if (selectedPlan) {
                        item.sellingPlanId = selectedPlan.id;
                    }
                    return [
                        4,
                        cartAddItem(item)
                    ];
                case 1:
                    cart = _state.sent();
                    if (typeof callback === "function") {
                        callback(cart);
                    }
                    if (openCart) {
                        toggleCartSidebar();
                    }
                    return [
                        2
                    ];
            }
        });
    }), [
        selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id,
        isSoldOut,
        isPreOrder,
        selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.id
    ]);
    return [
        {
            isPreOrder: isPreOrder,
            isSoldOut: isSoldOut && !isPreOrder,
            selectedPlan: selectedPlan,
            status: {
                addItem: addItemStatus,
                inventory: inventory,
                inventoryStatus: inventoryStatus
            }
        },
        {
            addToCart: addToCart,
            toggleCartSidebar: toggleCartSidebar
        }, 
    ];
};


/***/ }),

/***/ 1183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "W": function() { return /* reexport */ Navigation; }
});

// EXTERNAL MODULE: ../node_modules/theme-ui/jsx-runtime/dist/theme-ui-jsx-runtime.esm.js + 2 modules
var theme_ui_jsx_runtime_esm = __webpack_require__(70863);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(31373);
// EXTERNAL MODULE: ../node_modules/@theme-ui/components/dist/theme-ui-components.esm.js
var theme_ui_components_esm = __webpack_require__(62680);
// EXTERNAL MODULE: ./src/snippets/index.js + 352 modules
var snippets = __webpack_require__(81234);
// EXTERNAL MODULE: ./src/theme/create.jsx
var create = __webpack_require__(73355);
;// CONCATENATED MODULE: ./src/snippets/Cart/Upsell/Navigation/Navigation.theme.js



var themed = (0,create/* create */.U)(new function() {
    this.buttonPrev = {
        position: "absolute",
        top: "50%",
        transform: "translateY(-50%)",
        zIndex: 1,
        left: 3,
        right: "auto",
        transition: "opacity 0.2s ease-in-out",
        width: "16px",
        height: "16px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    };
    this.buttonNext = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this.buttonPrev), {
        left: "auto",
        right: 3
    });
    this.icon = {
        width: "16px",
        userSelect: "none"
    };
}());

;// CONCATENATED MODULE: ./src/snippets/Cart/Upsell/Navigation/NavigationButton.jsx







var NavigationButton = themed(function(_param) {
    var theme = _param.theme, _src = _param.src, src = _src === void 0 ? "/svgs/chevron/left.svg#left" : _src, _alt = _param.alt, alt = _alt === void 0 ? "Previous product" : _alt, _isNext = _param.isNext, isNext = _isNext === void 0 ? false : _isNext, inactive = _param.inactive, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme",
        "src",
        "alt",
        "isNext",
        "inactive"
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-comp": NavigationButton.displayName,
        disabled: inactive
    }, props), {
        variant: "buttons.plain",
        sx: (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, isNext ? theme.buttonNext : theme.buttonPrev), {
            opacity: inactive ? 0.5 : 1
        }), props.sx),
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Svg */.ny, {
            alt: alt,
            src: src,
            viewBox: "0 0 16 16",
            draggable: false,
            sx: theme.icon
        })
    }));
});
NavigationButton.displayName = "CartUpsellNavigationButton";

;// CONCATENATED MODULE: ./src/snippets/Cart/Upsell/Navigation/Navigation.jsx



var Navigation = themed(function(param) {
    var theme = param.theme, swiper = param.swiper;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_jsx_runtime_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(NavigationButton, {
                onClick: function() {
                    return swiper.slidePrev();
                }
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(NavigationButton, {
                onClick: function() {
                    return swiper.slideNext();
                },
                src: "/svgs/chevron/right.svg#right",
                alt: "Next product",
                isNext: true
            })
        ]
    });
});
Navigation.displayName = "CartUpsellNavigation";

;// CONCATENATED MODULE: ./src/snippets/Cart/Upsell/Navigation/index.js



/***/ }),

/***/ 131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ themed; }
/* harmony export */ });
/* harmony import */ var _theme_create__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73355);

var themed = (0,_theme_create__WEBPACK_IMPORTED_MODULE_0__/* .create */ .U)(new function() {
    this.wrapper = {
        variant: "flex.row.start.center",
        width: "100%",
        minHeight: "106px",
        px: 14
    };
    this.picture = {
        width: "72px",
        mr: 8,
        spinner: {
            width: "16px",
            color: "mediumDarkGray",
            m: "auto"
        }
    };
    this.details = {
        variant: "flex.column.start"
    };
    this.title = {
        variant: "text.h6",
        fontWeight: 500,
        minHeight: "18px"
    };
    this.variant = {
        variant: "text.sm",
        color: "mediumDarkGray",
        minHeight: "18px"
    };
    this.priceWrapper = {
        minHeight: "18px",
        mb: 3
    };
    this.price = {
        p: {
            variant: "text.sm",
            fontSize: 1
        }
    };
    this.newPrice = {
        color: "red",
        mr: 4
    };
    this.compareAtPrice = {
        textDecoration: "line-through",
        color: "mediumDarkGray"
    };
    this.atc = {
        height: "15px"
    };
}());


/***/ }),

/***/ 11578:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ UpsellAddToCart; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(23842);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70169);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(52050);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(59312);
/* harmony import */ var theme_ui_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70863);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var _backpackjs_storefront__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52031);
/* harmony import */ var _backpackjs_storefront__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_backpackjs_storefront__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _snippets__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81234);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74424);
/* harmony import */ var _snippets_AddToCart_useAddToCart__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41906);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27695);
/* harmony import */ var _SliderItem_theme__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(131);













var UpsellAddToCart = (0,_SliderItem_theme__WEBPACK_IMPORTED_MODULE_7__/* .themed */ .H)(function(param) {
    var theme = param.theme, product = param.product, selectedVariant = param.selectedVariant, style = param.style;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var settings = (0,_backpackjs_storefront__WEBPACK_IMPORTED_MODULE_2__.useSettings)();
    var ref6 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_snippets_AddToCart_useAddToCart__WEBPACK_IMPORTED_MODULE_5__/* .useAddToCart */ .t)({
        product: product,
        selectedVariant: selectedVariant
    }), 2), ref7 = ref6[0], status = ref7.status, isPreOrder = ref7.isPreOrder, isSoldOut = ref7.isSoldOut, selectedPlan = ref7.selectedPlan, addToCart = ref6[1].addToCart;
    var _addItem = status.addItem, started = _addItem.started, finished = _addItem.finished, success = _addItem.success, errors = _addItem.errors;
    var ref8 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useSidebar */ .Ap)(), 2), openSidebar = ref8[1].openSidebar;
    var gwp = (0,_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useGiftWithPurchase */ .tG)();
    var ref9 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useModal */ .dd)(), 2), openModal = ref9[1].openModal;
    var ref10 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useCartStatus */ .T0)(), 2), addingToCartStatus = ref10[0].addingToCartStatus, setAddingToCartStatus = ref10[1].setAddingToCartStatus;
    var cartIsMaxed = (0,_store__WEBPACK_IMPORTED_MODULE_6__/* .useRecoilValue */ .sJ)(_store__WEBPACK_IMPORTED_MODULE_6__/* ["default"].cartIsMaxed */ .ZP.cartIsMaxed);
    var isAddingToCart = addingToCartStatus.started && !addingToCartStatus.finished;
    var ignoredProducts = settings === null || settings === void 0 ? void 0 : (ref = settings.cart) === null || ref === void 0 ? void 0 : (ref1 = ref.bulkOrdering) === null || ref1 === void 0 ? void 0 : ref1.ignoredProducts;
    var noBackInStockOption = isSoldOut && !isPreOrder && (product === null || product === void 0 ? void 0 : (ref2 = product.tags) === null || ref2 === void 0 ? void 0 : ref2.includes("no-bis"));
    var text = (status === null || status === void 0 ? void 0 : (ref3 = status.inventoryStatus) === null || ref3 === void 0 ? void 0 : ref3.success) && (status === null || status === void 0 ? void 0 : (ref4 = status.inventoryStatus) === null || ref4 === void 0 ? void 0 : ref4.finished) && product ? noBackInStockOption ? "Sold Out" : isPreOrder ? "Pre-order" : isSoldOut ? "Notify Me" : selectedPlan ? "Subscribe" : "Add to Bag" : "LOADING...";
    var ignoredFromMaxQty = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return ignoredProducts === null || ignoredProducts === void 0 ? void 0 : ignoredProducts.some(function(param) {
            var ignoredProduct = param.product;
            return ignoredProduct.handle === product.handle;
        });
    }, [
        product.handle,
        ignoredProducts
    ]);
    var setGlobalCartStatusOnAdding = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        setAddingToCartStatus({
            started: started,
            finished: finished,
            success: success,
            errors: errors
        });
        return function() {
            setAddingToCartStatus({
                started: false,
                finished: false,
                success: false,
                errors: []
            });
        };
    }, [
        started,
        finished,
        success
    ]);
    var handleOutOfStock = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        openModal(/*#__PURE__*/ (0,theme_ui_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_snippets__WEBPACK_IMPORTED_MODULE_3__/* .BackInStockModal */ .Yu, {
            legacyResourceId: selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.legacyResourceId,
            title: product.title || ""
        }), true);
    }, [
        selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id,
        product.title
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setGlobalCartStatusOnAdding();
    }, [
        started,
        finished,
        success
    ]);
    var isNotifyMe = isSoldOut && !isPreOrder;
    var disabled = noBackInStockOption || isAddingToCart || cartIsMaxed && !isNotifyMe && !ignoredFromMaxQty;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_snippets__WEBPACK_IMPORTED_MODULE_3__/* .StatefulButton */ .Lc, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
        "data-comp": UpsellAddToCart.displayName,
        variant: "buttons.link.1",
        disabled: disabled,
        loading: !(status === null || status === void 0 ? void 0 : (ref5 = status.inventoryStatus) === null || ref5 === void 0 ? void 0 : ref5.success),
        sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, theme.atc), {
            cursor: disabled ? "default" : "pointer",
            color: disabled ? "gray" : "text",
            ":hover": disabled ? {
                ":after": {
                    transform: "translateX(0)"
                },
                ":before": {
                    transform: "translateX(0)"
                },
                color: "gray"
            } : {}
        }), style)
    }, status.addItem), {
        text: {
            default: text,
            started: text,
            success: text,
            error: text
        },
        onClick: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!isNotifyMe) return [
                            3,
                            1
                        ];
                        handleOutOfStock();
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            addToCart({
                                callback: function(_cart) {
                                    if (gwp.isEligible(_cart)) {
                                        openModal(/*#__PURE__*/ (0,theme_ui_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_snippets__WEBPACK_IMPORTED_MODULE_3__/* .GiftWithPurchase */ .QT, {}));
                                    } else {
                                        openSidebar("cart");
                                    }
                                },
                                openCart: false
                            })
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })
    }));
});
UpsellAddToCart.displayName = "UpsellAddToCart";


/***/ }),

/***/ 8977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "qL": function() { return /* reexport */ FreeShippingMeter; },
  "vs": function() { return /* reexport */ ItemsOrEmpty; },
  "jA": function() { return /* reexport */ Totals; },
  "QH": function() { return /* reexport */ Upsell; },
  "iF": function() { return /* reexport */ useCartCount; },
  "Z0": function() { return /* reexport */ useCartIntelliSuggest; },
  "QF": function() { return /* reexport */ useCartRejectDiscount; }
});

// UNUSED EXPORTS: Empty, LineItems

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(31373);
// EXTERNAL MODULE: ../node_modules/theme-ui/jsx-runtime/dist/theme-ui-jsx-runtime.esm.js + 2 modules
var theme_ui_jsx_runtime_esm = __webpack_require__(70863);
// EXTERNAL MODULE: ../node_modules/@theme-ui/components/dist/theme-ui-components.esm.js
var theme_ui_components_esm = __webpack_require__(62680);
// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(23615);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../node_modules/@backpackjs/storefront/dist/index.js
var dist = __webpack_require__(52031);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(52050);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_throw.mjs
var _throw = __webpack_require__(18952);
// EXTERNAL MODULE: ./src/snippets/index.js + 352 modules
var snippets = __webpack_require__(81234);
// EXTERNAL MODULE: ./src/hooks/index.js + 64 modules
var hooks = __webpack_require__(74424);
// EXTERNAL MODULE: ./src/theme/create.jsx
var create = __webpack_require__(73355);
;// CONCATENATED MODULE: ./src/snippets/Cart/Empty/Empty.theme.js



var themed = (0,create/* create */.U)(new function() {
    this.sidebar = {
        variant: "flex.column.center.center",
        height: "100%",
        px: 10,
        text: {
            variant: "text.h4",
            fontSize: 8,
            lineHeight: 32,
            textAlign: "center",
            maxWidth: "250px"
        },
        grid: {
            justifyItems: "center",
            gridGap: 8,
            mt: 12
        },
        link: {}
    };
    // cart empty — rendered in /cart
    this.page = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this.sidebar), {
        border: function(t) {
            return [
                "1px solid ".concat(t.colors.gray),
                null,
                0
            ];
        },
        mr: [
            0,
            null,
            "130px"
        ],
        text: {
            variant: "text.h4",
            fontSize: 8,
            lineHeight: 32
        },
        grid: {
            justifyItems: "center",
            gridGap: 8,
            mt: 12
        },
        link: {}
    });
}());

;// CONCATENATED MODULE: ./src/snippets/Cart/Empty/Empty.jsx












var Empty = themed(function(_param) {
    var themes = _param.theme, inSidebar = _param.inSidebar, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme",
        "inSidebar"
    ]);
    var ref, ref1;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useSidebar */.Ap)(), 2), ref3 = ref2[0], ref3 = ref3 !== null ? ref3 : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined")), closeSidebar = ref2[1].closeSidebar;
    var settings = (0,dist.useSettings)();
    var empty = settings === null || settings === void 0 ? void 0 : (ref = settings.cart) === null || ref === void 0 ? void 0 : ref.empty;
    var theme = inSidebar ? themes.sidebar : themes.page;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-comp": Empty.displayName
    }, props), {
        sx: (0,_object_spread/* default */.Z)({}, props.sx, theme),
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                sx: theme.text,
                as: "h4",
                children: empty === null || empty === void 0 ? void 0 : empty.message
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Grid */.rj, {
                sx: theme.grid,
                children: empty === null || empty === void 0 ? void 0 : (ref1 = empty.ctas) === null || ref1 === void 0 ? void 0 : ref1.map(function(item, index) {
                    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Link */.rU, {
                        href: item.cta.url,
                        newTab: item.cta.newTab,
                        onClick: function() {
                            if (!inSidebar) return;
                            closeSidebar();
                        },
                        variant: "buttons.secondary",
                        children: item.cta.text
                    }, index);
                })
            })
        ]
    }));
});
Empty.displayName = "CartEmpty";
Empty.propTypes = {
    inSidebar: (prop_types_default()).bool
};

;// CONCATENATED MODULE: ./src/snippets/Cart/Empty/index.js


// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(23842);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(17599);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3204);
// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(59312);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ./src/store/index.js + 12 modules
var store = __webpack_require__(27695);
// EXTERNAL MODULE: ./src/utils/index.js + 7 modules
var utils = __webpack_require__(39136);
;// CONCATENATED MODULE: ./src/snippets/Cart/useCartDiscountPrices.js



var useCartDiscountPrices = function() {
    var cart = (0,dist.useCart)();
    var setDiscountAmount = (0,store/* useSetRecoilState */.Zl)(store/* default.cartDiscountAmount */.ZP.cartDiscountAmount);
    // discountAmount used for cart level discount such as discount
    // code that applies to the whole order
    var discountAmount = (0,react.useMemo)(function() {
        var ref;
        if (!(cart === null || cart === void 0 ? void 0 : (ref = cart.discountAllocations) === null || ref === void 0 ? void 0 : ref.length)) return 0;
        var _discountAmount = cart.discountAllocations.reduce(function(carry, discount) {
            var ref;
            if (discount === null || discount === void 0 ? void 0 : (ref = discount.discountedAmount) === null || ref === void 0 ? void 0 : ref.amount) {
                return carry + Number(discount.discountedAmount.amount);
            }
            return carry;
        }, 0);
        return Number(_discountAmount || 0);
    }, [
        cart === null || cart === void 0 ? void 0 : cart.updatedAt
    ]);
    (0,react.useEffect)(function() {
        setDiscountAmount(discountAmount);
    }, [
        discountAmount
    ]);
};
useCartDiscountPrices.displayName = "useCartDiscountPrices";

;// CONCATENATED MODULE: ./src/snippets/Cart/LineItems/useByobLineItems.js







var startStatus = {
    started: true,
    finished: false,
    success: false,
    errors: []
};
var endStatus = {
    started: false,
    finished: true,
    success: true,
    errors: []
};
var useByobLineItems = function(param) {
    var cart = param.cart;
    var ref = (0,_sliced_to_array/* default */.Z)((0,hooks/* useCartStatus */.T0)(), 2), setUpdatingCartStatus = ref[1].setUpdatingCartStatus;
    var cartUpdateItem = (0,dist.useCartUpdateItem)().cartUpdateItem;
    var cartRemoveItem = (0,dist.useCartRemoveItem)().cartRemoveItem;
    var byob = (0,react.useMemo)(function() {
        var ref;
        if (!(cart === null || cart === void 0 ? void 0 : (ref = cart.lines) === null || ref === void 0 ? void 0 : ref.length)) return {
            lineItems: [],
            chargeItems: [],
            quantity: 0,
            updatedAt: null
        };
        var quantity = 0;
        var lineItems = cart.lines.filter(function(line) {
            if (line.variant.product.handle !== "byob-charge" && line.attributes.some(function(attr) {
                return attr.key === "recipe_id";
            })) {
                quantity += line.quantity;
                return true;
            }
            return false;
        });
        var chargeItems = cart.lines.filter(function(line) {
            return line.variant.product.handle === "byob-charge";
        });
        return {
            lineItems: lineItems,
            quantity: quantity,
            chargeItems: chargeItems,
            dependency: (0,_to_consumable_array/* default */.Z)(lineItems).concat((0,_to_consumable_array/* default */.Z)(chargeItems)).map(function(v) {
                var ref;
                return v.id + v.quantity + (((ref = v.attributes.find(function(attr) {
                    return attr.key === "recipe_id";
                })) === null || ref === void 0 ? void 0 : ref.value) || "");
            }).join("")
        };
    }, [
        cart === null || cart === void 0 ? void 0 : cart.updatedAt,
        cart === null || cart === void 0 ? void 0 : cart.lines
    ]);
    var updateOrAddByobChargeItem = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var recipeIdArr, lineItemPromises, chargeItemPromises;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    recipeIdArr = [];
                    lineItemPromises = byob.chargeItems.length ? null : byob.lineItems.map(function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(function(byobItem) {
                            var ref, recipeId, quantity, byobChargeItem;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        recipeId = (ref = byobItem.attributes.find(function(attr) {
                                            return attr.key === "recipe_id";
                                        })) === null || ref === void 0 ? void 0 : ref.value;
                                        if (!((recipeIdArr === null || recipeIdArr === void 0 ? void 0 : recipeIdArr.indexOf(recipeId)) === -1)) return [
                                            3,
                                            4
                                        ];
                                        recipeIdArr.push(recipeId);
                                        quantity = byob.lineItems.reduce(function(acc, lines) {
                                            var ref;
                                            if (((ref = lines.attributes.find(function(attr) {
                                                return attr.key === "recipe_id";
                                            })) === null || ref === void 0 ? void 0 : ref.value) === recipeId) {
                                                return acc + lines.quantity;
                                            }
                                            return acc;
                                        }, 0);
                                        byobChargeItem = byob.chargeItems.find(function(lineItem) {
                                            var ref;
                                            return lineItem.variant.product.handle === "byob-charge" && ((ref = lineItem.attributes.find(function(attr) {
                                                return attr.key === "recipe_id";
                                            })) === null || ref === void 0 ? void 0 : ref.value) === "uc-".concat(recipeId);
                                        });
                                        if (!(quantity > 0)) return [
                                            3,
                                            4
                                        ];
                                        if (!(byobChargeItem && quantity !== byobChargeItem.quantity)) return [
                                            3,
                                            4
                                        ];
                                        // update byob charge quantity on byob product change
                                        return [
                                            4,
                                            setUpdatingCartStatus(startStatus)
                                        ];
                                    case 1:
                                        _state.sent();
                                        return [
                                            4,
                                            cartUpdateItem({
                                                lineId: byobChargeItem.id,
                                                quantity: quantity
                                            })
                                        ];
                                    case 2:
                                        _state.sent();
                                        return [
                                            4,
                                            setUpdatingCartStatus(endStatus)
                                        ];
                                    case 3:
                                        _state.sent();
                                        _state.label = 4;
                                    case 4:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(byobItem) {
                            return _ref.apply(this, arguments);
                        };
                    }());
                    chargeItemPromises = byob.chargeItems.map(function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(function(byobChargeItem) {
                            var ref, ref1, recipeId, ref2, quantity;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        recipeId = (ref = byobChargeItem.attributes.find(function(attr) {
                                            return attr.key === "recipe_id";
                                        })) === null || ref === void 0 ? void 0 : (ref1 = ref.value) === null || ref1 === void 0 ? void 0 : ref1.split("-")[1];
                                        if (!((recipeIdArr === null || recipeIdArr === void 0 ? void 0 : recipeIdArr.indexOf(recipeId)) === -1)) return [
                                            3,
                                            7
                                        ];
                                        recipeIdArr.push(recipeId);
                                        quantity = cart === null || cart === void 0 ? void 0 : (ref2 = cart.lines) === null || ref2 === void 0 ? void 0 : ref2.reduce(function(acc, lines) {
                                            var ref;
                                            if (((ref = lines.attributes.find(function(attr) {
                                                return attr.key === "recipe_id";
                                            })) === null || ref === void 0 ? void 0 : ref.value) === recipeId) {
                                                return acc + lines.quantity;
                                            }
                                            return acc;
                                        }, 0);
                                        if (!(quantity > 0)) return [
                                            3,
                                            5
                                        ];
                                        if (!(quantity !== byobChargeItem.quantity)) return [
                                            3,
                                            4
                                        ];
                                        // update byob charge quantity on byob product change
                                        return [
                                            4,
                                            setUpdatingCartStatus(startStatus)
                                        ];
                                    case 1:
                                        _state.sent();
                                        return [
                                            4,
                                            cartUpdateItem({
                                                lineId: byobChargeItem.id,
                                                quantity: quantity
                                            })
                                        ];
                                    case 2:
                                        _state.sent();
                                        return [
                                            4,
                                            setUpdatingCartStatus(endStatus)
                                        ];
                                    case 3:
                                        _state.sent();
                                        _state.label = 4;
                                    case 4:
                                        return [
                                            3,
                                            7
                                        ];
                                    case 5:
                                        // remove byob charge item if no byob products
                                        setUpdatingCartStatus(startStatus);
                                        return [
                                            4,
                                            cartRemoveItem({
                                                lineId: byobChargeItem.id
                                            })
                                        ];
                                    case 6:
                                        _state.sent();
                                        setUpdatingCartStatus(endStatus);
                                        _state.label = 7;
                                    case 7:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(byobChargeItem) {
                            return _ref.apply(this, arguments);
                        };
                    }());
                    if (!lineItemPromises) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        Promise.all(lineItemPromises)
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        Promise.all(chargeItemPromises)
                    ];
                case 3:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    }), [
        byob.dependency
    ]);
    return {
        updateOrAddByobChargeItem: updateOrAddByobChargeItem,
        byobDependency: byob === null || byob === void 0 ? void 0 : byob.dependency
    };
};

;// CONCATENATED MODULE: ./src/snippets/Cart/LineItem/useByobLineItem.js

var useByobLineItem = function(param) {
    var discountCodeApplied = param.discountCodeApplied, item = param.item, updatedAt = param.updatedAt;
    var handle = item.variant.product.handle;
    var isByob = (0,react.useMemo)(function() {
        return item.attributes.some(function(attr) {
            return attr.key === "recipe_id";
        }) && handle !== "byob-charge";
    }, [
        item.id,
        handle
    ]);
    var byobMessage = (0,react.useMemo)(function() {
        var ref;
        if (handle !== "byob-charge") return null;
        var totalDiscounts = (ref = item.discountAllocations) === null || ref === void 0 ? void 0 : ref.reduce(function(carry, discountAllocation) {
            var ref, ref1, ref2;
            var discount = discountAllocation === null || discountAllocation === void 0 ? void 0 : (ref = discountAllocation.discountedAmount) === null || ref === void 0 ? void 0 : ref.amount;
            var subtotal = (ref1 = item.estimatedCost) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.subtotalAmount) === null || ref2 === void 0 ? void 0 : ref2.amount;
            return carry + Math.floor(parseFloat(discount) / parseFloat(subtotal) * 100);
        }, 0);
        return totalDiscounts ? "".concat(totalDiscounts, "% off ").concat(discountCodeApplied ? "" : "bulk", " discount") : null;
    }, [
        item.id,
        handle,
        updatedAt
    ]);
    return {
        isByob: isByob,
        byobMessage: byobMessage
    };
};

;// CONCATENATED MODULE: ./src/snippets/Cart/LineItem/Quantity/Quantity.theme.js

var Quantity_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        variant: "flex.row.between.center",
        width: "98px",
        height: "32px",
        "input::-webkit-outer-spin-button, input::-webkit-inner-spin-button": {
            WebkitAppearance: "none",
            margin: 0
        },
        "input[type=number]": {
            MozAppearance: "textfield"
        }
    };
    this.inputWrapper = {
        variant: "flex.row.center.center",
        flex: 1,
        mx: 2,
        position: "relative",
        height: "100%"
    };
    this.input = {
        fontSize: 3,
        fontWeight: 500,
        width: "100%",
        height: "100%",
        textAlign: "center",
        p: 0,
        bg: "transparent",
        outline: "none",
        borderStyle: "none",
        ":focus, :hover": {
            outline: "none !important"
        },
        transition: "opacity 0.1s ease-in-out"
    };
    this.spinner = {
        width: "20px",
        color: "mediumGray",
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)"
    };
    this.button = function(disabled) {
        return {
            width: "32px",
            height: "32px",
            borderRadius: "50%",
            border: function(t) {
                return "1px solid ".concat(t.colors.gray);
            },
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "all 0.15s ease-in-out",
            cursor: disabled ? "default" : "pointer",
            ":hover": {
                borderColor: disabled ? "gray" : "mediumGray"
            }
        };
    };
    this.buttonIcon = {
        width: "16px",
        height: "16px"
    };
}());

;// CONCATENATED MODULE: ./src/snippets/Cart/LineItem/Quantity/QuantityButton.jsx







var QuantityButton = Quantity_theme_themed(function(_param) {
    var theme = _param.theme, _type = _param.type, type = _type === void 0 ? "Decrease" : _type, quantity = _param.quantity, disabled = _param.disabled, isStatic = _param.isStatic, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme",
        "type",
        "quantity",
        "disabled",
        "isStatic"
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-comp": "QuantityButton".concat(type),
        variant: "buttons.plain",
        disabled: disabled,
        "aria-label": "".concat(type, " line item quantity")
    }, props), {
        sx: (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.button(disabled)), {
            visibility: isStatic ? "hidden" : "visible"
        }), props.sx),
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Svg */.ny, {
            viewBox: "0 0 48 48",
            alt: type,
            loading: "lazy",
            src: type === "Decrease" ? "/svgs/minus.svg#minus" : "/svgs/plus.svg#plus",
            sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.buttonIcon), {
                color: disabled ? "mediumDarkGray" : "dark"
            })
        })
    }));
});
QuantityButton.displayName = "QuantityButton";

;// CONCATENATED MODULE: ./src/snippets/Cart/LineItem/Quantity/Quantity.jsx














var Quantity = Quantity_theme_themed(function(_param) {
    var theme = _param.theme, inSidebar = _param.inSidebar, id = _param.id, quantity = _param.quantity, cartRemoveItem = _param.cartRemoveItem, setIsDeleting = _param.setIsDeleting, handle = _param.handle, maxQty = _param.maxQty, isMaxed = _param.isMaxed, qtyInCart = _param.qtyInCart, ignoredFromMaxQty = _param.ignoredFromMaxQty, _minQty = _param.minQty, minQty = _minQty === void 0 ? 0 : _minQty, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme",
        "inSidebar",
        "id",
        "quantity",
        "cartRemoveItem",
        "setIsDeleting",
        "handle",
        "maxQty",
        "isMaxed",
        "qtyInCart",
        "ignoredFromMaxQty",
        "minQty"
    ]);
    var _ref = (0,dist.useCartUpdateItem)({
        autoReset: 100
    }), cartUpdateItem = _ref.cartUpdateItem, updateStatus = (0,_object_without_properties/* default */.Z)(_ref, [
        "cartUpdateItem"
    ]);
    var cartUpdatedAt = (0,dist.useCartUpdatedAt)();
    var ref = (0,react.useState)(false), isUpdating = ref[0], setIsUpdating = ref[1];
    var disabled = !id || isUpdating;
    var isStatic = [
        "byob-charge"
    ].includes(handle);
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useCartStatus */.T0)(), 2), setUpdatingCartStatus = ref1[1].setUpdatingCartStatus;
    var started = updateStatus.started, finished = updateStatus.finished, success = updateStatus.success, errors = updateStatus.errors;
    var handleDecrement = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var prevQuantity;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (disabled || minQty > 0 && quantity <= minQty) return [
                        2
                    ];
                    prevQuantity = quantity - 1;
                    if (!prevQuantity) return [
                        3,
                        2
                    ];
                    setIsUpdating(true);
                    return [
                        4,
                        cartUpdateItem({
                            lineId: id,
                            quantity: prevQuantity
                        })
                    ];
                case 1:
                    _state.sent();
                    setIsUpdating(false);
                    return [
                        3,
                        4
                    ];
                case 2:
                    setIsDeleting(true);
                    return [
                        4,
                        cartRemoveItem({
                            lineId: id
                        })
                    ];
                case 3:
                    _state.sent();
                    setIsDeleting(false);
                    _state.label = 4;
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), [
        id,
        quantity,
        disabled,
        minQty
    ]);
    var handleIncrement = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (disabled || isMaxed) return [
                        2
                    ];
                    setIsUpdating(true);
                    return [
                        4,
                        cartUpdateItem({
                            lineId: id,
                            quantity: quantity + 1
                        })
                    ];
                case 1:
                    _state.sent();
                    setIsUpdating(false);
                    return [
                        2
                    ];
            }
        });
    }), [
        id,
        quantity,
        disabled,
        isMaxed
    ]);
    var handleInputChange = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            var typedQuantity, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            5,
                            ,
                            6
                        ]);
                        if (disabled) return [
                            2
                        ];
                        typedQuantity = parseInt(e.target.value, 10);
                        if (quantity === typedQuantity || minQty > 0 && typedQuantity < minQty) return [
                            2
                        ];
                        if (!typedQuantity) return [
                            3,
                            2
                        ];
                        setIsUpdating(true);
                        if (qtyInCart - quantity + typedQuantity > maxQty && !ignoredFromMaxQty) {
                            typedQuantity = maxQty - qtyInCart + quantity;
                        }
                        return [
                            4,
                            cartUpdateItem({
                                lineId: id,
                                quantity: typedQuantity
                            })
                        ];
                    case 1:
                        _state.sent();
                        setIsUpdating(false);
                        return [
                            3,
                            4
                        ];
                    case 2:
                        setIsDeleting(true);
                        return [
                            4,
                            cartRemoveItem({
                                lineId: id
                            })
                        ];
                    case 3:
                        _state.sent();
                        setIsUpdating(false);
                        _state.label = 4;
                    case 4:
                        return [
                            3,
                            6
                        ];
                    case 5:
                        error = _state.sent();
                        setIsUpdating(false);
                        console.error(error.message);
                        return [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function(e) {
            return _ref.apply(this, arguments);
        };
    }(), [
        id,
        quantity,
        disabled,
        maxQty,
        qtyInCart,
        ignoredFromMaxQty,
        minQty
    ]);
    var setGlobalCartStatusOnUpdating = (0,react.useCallback)(function() {
        setUpdatingCartStatus({
            started: started,
            finished: finished,
            success: success,
            errors: errors
        });
        return function() {
            setUpdatingCartStatus({
                started: false,
                finished: false,
                success: false,
                errors: []
            });
        };
    }, [
        started,
        finished,
        success
    ]);
    (0,react.useEffect)(function() {
        setGlobalCartStatusOnUpdating();
    }, [
        started,
        finished,
        success
    ]);
    return !id ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {}) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-comp": Quantity.displayName
    }, props), {
        sx: theme.wrapper,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(QuantityButton, {
                type: "Decrease",
                quantity: quantity,
                onClick: handleDecrement,
                disabled: disabled || minQty > 0 && quantity <= minQty,
                isStatic: isStatic
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                sx: theme.inputWrapper,
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                        as: theme_ui_components_esm/* Input */.II,
                        type: "number",
                        min: "-1",
                        max: maxQty,
                        name: "quantity",
                        tabIndex: "-1",
                        disabled: disabled || isStatic,
                        defaultValue: quantity,
                        onBlur: handleInputChange,
                        onKeyDown: function(e) {
                            if (e.key === "Enter") {
                                handleInputChange(e);
                            }
                        },
                        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.input), {
                            opacity: isUpdating ? 0 : 1
                        })
                    }, cartUpdatedAt),
                    isUpdating && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Spinner */.$j, {
                        sx: theme.spinner
                    })
                ]
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(QuantityButton, {
                type: "Increase",
                quantity: quantity,
                onClick: handleIncrement,
                disabled: disabled || isMaxed,
                isStatic: isStatic
            })
        ]
    }));
});
Quantity.displayName = "Quantity";
Quantity.propTypes = {
    id: (prop_types_default()).string.isRequired,
    quantity: prop_types_default().oneOfType([
        (prop_types_default()).string,
        (prop_types_default()).number
    ]).isRequired
};

;// CONCATENATED MODULE: ./src/snippets/Cart/LineItem/Quantity/index.js


;// CONCATENATED MODULE: ./src/snippets/Cart/LineItem/Price/Price.theme.js

var Price_theme_themed = (0,create/* create */.U)(new function() {
    this.price = {
        flexWrap: "wrap",
        ml: 2,
        justifyContent: "flex-end",
        regular: {
            variant: "text.base",
            fontSize: 1,
            textAlign: "right"
        },
        strike: {
            variant: "text.base",
            fontSize: 1,
            textAlign: "right",
            textDecoration: "line-through",
            textDecorationThickness: "2px",
            color: "black",
            ml: 2
        }
    };
}());

;// CONCATENATED MODULE: ./src/snippets/Cart/LineItem/Price/Price.jsx






var Price = Price_theme_themed(function(param) {
    var theme = param.theme, estimatedCost = param.estimatedCost, isDiscounted = param.isDiscounted, isOnSale = param.isOnSale;
    var ref, ref1, ref2, ref3;
    var savingsPercent = typeof (estimatedCost === null || estimatedCost === void 0 ? void 0 : (ref = estimatedCost.totalAmount) === null || ref === void 0 ? void 0 : ref.amount) === "number" && typeof (estimatedCost === null || estimatedCost === void 0 ? void 0 : (ref1 = estimatedCost.compareAtPriceAmount) === null || ref1 === void 0 ? void 0 : ref1.amount) === "number" ? 100 - (estimatedCost === null || estimatedCost === void 0 ? void 0 : (ref2 = estimatedCost.totalAmount) === null || ref2 === void 0 ? void 0 : ref2.amount) / (estimatedCost === null || estimatedCost === void 0 ? void 0 : (ref3 = estimatedCost.compareAtPriceAmount) === null || ref3 === void 0 ? void 0 : ref3.amount) * 100 : 0;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
        "data-comp": Price.displayName,
        sx: theme.price,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_jsx_runtime_esm/* Fragment */.HY, {
            children: [
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.price.regular), {
                        color: isOnSale || isDiscounted || estimatedCost.totalAmount.amount === 0 ? "redSalePrice" : "text"
                    }),
                    children: estimatedCost.totalAmount.amount === 0 ? estimatedCost.totalAmount.locale : estimatedCost.totalAmount.locale
                }),
                isOnSale || isDiscounted ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                    sx: theme.price.strike,
                    children: estimatedCost.compareAtPriceAmount.locale
                }) : null,
                (isOnSale || isDiscounted) && savingsPercent >= 1 && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                    sx: {
                        width: "100%",
                        textAlign: "right",
                        fontSize: "9px",
                        color: "redSalePrice",
                        textTransform: "uppercase"
                    },
                    children: savingsPercent === 100 ? "Free" : "".concat(savingsPercent === null || savingsPercent === void 0 ? void 0 : savingsPercent.toFixed(0), "% Off")
                })
            ]
        })
    });
});
Price.displayName = "Price";
Price.propTypes = {
    estimatedCost: (prop_types_default()).object,
    isOnSale: (prop_types_default()).bool,
    isDiscounted: (prop_types_default()).bool
};

;// CONCATENATED MODULE: ./src/snippets/Cart/LineItem/Price/index.js


;// CONCATENATED MODULE: ./src/snippets/Cart/LineItem/LineItem.theme.js

var LineItem_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        variant: "flex.row.between.center",
        flexWrap: "wrap",
        p: 10,
        width: "100%",
        minHeight: "146px",
        position: "relative",
        borderBottomStyle: "solid",
        borderBottomWidth: "1px",
        borderBottomColor: "gray"
    };
    this.image = {
        width: "105px",
        height: "105px"
    };
    this.details = {
        variant: "flex.column.start.between",
        flex: 1,
        ml: 10,
        minHeight: "98px"
    };
    this.top = {
        variant: "flex.row.between",
        width: "100%"
    };
    this.titleWrapper = {
        variant: "flex.column.start",
        mb: 4
    };
    this.title = {
        variant: "text.h5",
        fontSize: 6,
        mb: 2
    };
    this.variantTitle = {
        variant: "text.sm",
        fontSize: 1,
        color: "mediumDarkGray"
    };
    this.closeButton = {
        mt: "3px",
        ml: 4
    };
    this.closeIcon = {
        width: "14px",
        height: "14px"
    };
    this.bottom = {
        variant: "flex.row.between.center",
        width: "100%"
    };
    this.deleting = {
        variant: "flex.row.between.center",
        position: "absolute",
        width: "100%",
        height: "100%",
        top: 0,
        left: 0,
        bg: "rgba(255,255,255,0.5)",
        spinner: {
            width: "30px",
            color: "mediumDarkGray",
            m: "auto"
        }
    };
}());

;// CONCATENATED MODULE: ./src/snippets/Cart/LineItem/LineItem.jsx


















var LineItem = LineItem_theme_themed(function(_param) {
    var theme = _param.theme, inSidebar = _param.inSidebar, item = _param.item, isLast = _param.isLast, cart = _param.cart, isMaxed = _param.isMaxed, qtyInCart = _param.qtyInCart, maxQty = _param.maxQty, chargeItems = _param.chargeItems, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme",
        "inSidebar",
        "item",
        "isLast",
        "cart",
        "isMaxed",
        "qtyInCart",
        "maxQty",
        "chargeItems"
    ]);
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14;
    var settings = (0,dist.useSettings)();
    var cartDiscounts = (0,dist.useCartDiscounts)();
    var _ref = (0,dist.useCartRemoveItem)({
        autoReset: 100
    }), cartRemoveItem = _ref.cartRemoveItem, removeStatus = (0,_object_without_properties/* default */.Z)(_ref, [
        "cartRemoveItem"
    ]);
    var ref15 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useCartStatus */.T0)(), 2), setUpdatingCartStatus = ref15[1].setUpdatingCartStatus;
    var ref16 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useSidebar */.Ap)(), 2), closeSidebar = ref16[1].closeSidebar;
    var ref17 = useByobLineItem({
        item: item,
        updatedAt: cart === null || cart === void 0 ? void 0 : cart.updatedAt,
        discountCodeApplied: cartDiscounts === null || cartDiscounts === void 0 ? void 0 : cartDiscounts.length
    }), isByob = ref17.isByob, byobMessage = ref17.byobMessage;
    var gwpVariantIds = (0,store/* useRecoilValue */.sJ)(store/* default.gwpVariantIds */.ZP.gwpVariantIds);
    var ref18 = (0,react.useState)(false), isDeleting = ref18[0], setIsDeleting = ref18[1];
    var handle = item.variant.product.handle;
    var isGift = (gwpVariantIds === null || gwpVariantIds === void 0 ? void 0 : gwpVariantIds.includes(item.variant.id)) || handle === "mystery-item";
    var isSustainabilityCoverage = handle === "sustainability-coverage";
    var started = removeStatus.started, finished = removeStatus.finished, success = removeStatus.success, errors = removeStatus.errors;
    var ignoredProducts = settings === null || settings === void 0 ? void 0 : (ref = settings.cart) === null || ref === void 0 ? void 0 : (ref1 = ref.bulkOrdering) === null || ref1 === void 0 ? void 0 : ref1.ignoredProducts;
    var availableForSale = (0,_object_spread/* default */.Z)({}, item.variant).availableForSale;
    var isJtbCustom = ((item === null || item === void 0 ? void 0 : item.attributes) || []).find(function(attr) {
        return (attr === null || attr === void 0 ? void 0 : attr.key) === "recipe_id";
    });
    var isJtbCustomUpload = ((item === null || item === void 0 ? void 0 : item.attributes) || []).find(function(attr) {
        return (attr === null || attr === void 0 ? void 0 : attr.key) === "personalization_type" && (attr === null || attr === void 0 ? void 0 : attr.value) === "upload";
    });
    var minQty = (0,react.useMemo)(function() {
        if ((isJtbCustomUpload === null || isJtbCustomUpload === void 0 ? void 0 : isJtbCustomUpload.value) === "upload") {
            return 24;
        }
        return 0;
    }, [
        isJtbCustomUpload
    ]);
    var chargeItem = chargeItems === null || chargeItems === void 0 ? void 0 : chargeItems[isJtbCustom === null || isJtbCustom === void 0 ? void 0 : (ref2 = isJtbCustom.value) === null || ref2 === void 0 ? void 0 : ref2.replace("uc-", "")];
    var productUrl = (0,react.useMemo)(function() {
        if (isJtbCustom) {
            var ref, ref1;
            return "/products/".concat(handle, "?variant=").concat((ref = item.variant.id) === null || ref === void 0 ? void 0 : ref.replace("gid://shopify/ProductVariant/", ""), "&mode=edit&recipe_id=").concat(isJtbCustom === null || isJtbCustom === void 0 ? void 0 : (ref1 = isJtbCustom.value) === null || ref1 === void 0 ? void 0 : ref1.replace("uc-", ""));
        }
        if (handle !== "byob-charge" && handle !== "mystery-item" && !isSustainabilityCoverage) {
            var ref2;
            return "/products/".concat(handle, "?variant=").concat((ref2 = item.variant.id) === null || ref2 === void 0 ? void 0 : ref2.replace("gid://shopify/ProductVariant/", ""));
        }
        return null;
    }, [
        handle,
        isJtbCustom
    ]);
    var fullTitle = (ref3 = item.variant) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.product) === null || ref4 === void 0 ? void 0 : ref4.title;
    var image = (0,react.useMemo)(function() {
        var ref;
        if (isJtbCustom) {
            var ref1;
            return {
                src: "https://silhouette.jtbcustom.com/api/recipes/".concat(isJtbCustom === null || isJtbCustom === void 0 ? void 0 : (ref1 = isJtbCustom.value) === null || ref1 === void 0 ? void 0 : ref1.replace("uc-", ""), "/perspectives/back")
            };
        }
        return (ref = item.variant) === null || ref === void 0 ? void 0 : ref.image;
    }, [
        (ref5 = item.variant) === null || ref5 === void 0 ? void 0 : ref5.image,
        isJtbCustom
    ]);
    var sizeVariant = (ref6 = item.variant) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.selectedOptions) === null || ref7 === void 0 ? void 0 : ref7.find(function(option) {
        return option.name === "Size";
    });
    var colorVariant = (ref8 = item.variant) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.selectedOptions) === null || ref9 === void 0 ? void 0 : ref9.find(function(option) {
        return option.name === "Color";
    });
    var ignoredFromMaxQty = (0,react.useMemo)(function() {
        return ignoredProducts === null || ignoredProducts === void 0 ? void 0 : ignoredProducts.some(function(param) {
            var product = param.product;
            return product.handle === handle;
        });
    }, [
        handle,
        ignoredProducts
    ]);
    var title = (0,react.useMemo)(function() {
        var splitIndex = (fullTitle === null || fullTitle === void 0 ? void 0 : fullTitle.indexOf("|")) || -1;
        return {
            product: splitIndex >= 0 ? fullTitle === null || fullTitle === void 0 ? void 0 : fullTitle.slice(0, splitIndex).trim() : fullTitle,
            variant: splitIndex >= 0 ? fullTitle === null || fullTitle === void 0 ? void 0 : fullTitle.slice(splitIndex + 1).trim() : ""
        };
    }, [
        fullTitle
    ]);
    var handleRemove = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    setIsDeleting(true);
                    return [
                        4,
                        cartRemoveItem({
                            lineId: item.id
                        })
                    ];
                case 1:
                    _state.sent();
                    setIsDeleting(false);
                    return [
                        2
                    ];
            }
        });
    }), [
        item.id
    ]);
    var discountDescription = (ref10 = item.discountAllocations) === null || ref10 === void 0 ? void 0 : (ref11 = ref10[0]) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.discountApplication) === null || ref12 === void 0 ? void 0 : ref12.description;
    var setGlobalCartStatusOnUpdating = (0,react.useCallback)(function() {
        setUpdatingCartStatus({
            started: started,
            finished: finished,
            success: success,
            errors: errors
        });
        return function() {
            setUpdatingCartStatus({
                started: false,
                finished: false,
                success: false,
                errors: []
            });
        };
    }, [
        started,
        finished,
        success
    ]);
    var removeItemFromCartIfUnavailable = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (availableForSale) return [
                        2
                    ];
                    setIsDeleting(true);
                    return [
                        4,
                        cartRemoveItem({
                            lineId: item.id
                        })
                    ];
                case 1:
                    _state.sent();
                    setIsDeleting(false);
                    return [
                        2
                    ];
            }
        });
    }), [
        availableForSale,
        item.id
    ]);
    (0,react.useEffect)(function() {
        setGlobalCartStatusOnUpdating();
    }, [
        started,
        finished,
        success
    ]);
    (0,react.useEffect)(function() {
        removeItemFromCartIfUnavailable();
    }, [
        availableForSale
    ]);
    if ((chargeItem === null || chargeItem === void 0 ? void 0 : chargeItem.id) === (item === null || item === void 0 ? void 0 : item.id)) return null;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-comp": LineItem.displayName
    }, props), {
        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.wrapper, props.sx), {
            borderBottomStyle: isLast ? "none" : "solid"
        }),
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Link */.rU, {
                href: productUrl,
                tabIndex: "-1",
                "aria-label": title.product,
                onClick: function() {
                    if (!inSidebar) return;
                    closeSidebar();
                },
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Picture */.t, {
                    alt: title.product,
                    images: [
                        {
                            src: image === null || image === void 0 ? void 0 : image.src,
                            ratio: 1,
                            width: 105
                        }, 
                    ],
                    sx: theme.image
                })
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                sx: theme.details,
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                        sx: theme.top,
                        children: [
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                                sx: theme.titleWrapper,
                                children: [
                                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Link */.rU, {
                                        href: productUrl,
                                        onClick: function() {
                                            if (!inSidebar) return;
                                            closeSidebar();
                                        },
                                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                                            as: "h5",
                                            sx: theme.title,
                                            children: title.product
                                        })
                                    }),
                                    (sizeVariant === null || sizeVariant === void 0 ? void 0 : sizeVariant.value) || (colorVariant === null || colorVariant === void 0 ? void 0 : colorVariant.value) ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                                        sx: theme.variantTitle,
                                        children: (sizeVariant === null || sizeVariant === void 0 ? void 0 : sizeVariant.value) || (colorVariant === null || colorVariant === void 0 ? void 0 : colorVariant.value)
                                    }) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                                        sx: theme.variantTitle,
                                        children: title.variant
                                    }),
                                    isGift && parseInt(item.estimatedCost.subtotalAmount.amount, 10) === 0 && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                                        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.variantTitle), {
                                            color: isGift ? "red" : ""
                                        }),
                                        children: "Free Gift With Purchase"
                                    }),
                                    isByob && !chargeItem && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                                        sx: theme.variantTitle,
                                        children: "With Personalization"
                                    }),
                                    discountDescription && !byobMessage && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                                        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.variantTitle), {
                                            color: "red"
                                        }),
                                        children: discountDescription
                                    }),
                                    byobMessage && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                                        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.variantTitle), {
                                            color: "red"
                                        }),
                                        children: byobMessage
                                    })
                                ]
                            }),
                            handle !== "byob-charge" && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                                variant: "buttons.plain",
                                onClick: handleRemove,
                                sx: theme.closeButton,
                                "aria-label": "Remove item from cart",
                                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Svg */.ny, {
                                    alt: "Close",
                                    src: "/svgs/close.svg#close",
                                    viewBox: "0 0 48 48",
                                    sx: theme.closeIcon
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                        sx: {
                            width: "100%"
                        },
                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                            sx: theme.bottom,
                            children: [
                                isGift ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {}) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Quantity, {
                                    id: item.id,
                                    inSidebar: inSidebar,
                                    quantity: item.quantity,
                                    cartRemoveItem: cartRemoveItem,
                                    setIsDeleting: setIsDeleting,
                                    handle: handle,
                                    isMaxed: isMaxed && !ignoredFromMaxQty,
                                    maxQty: maxQty,
                                    qtyInCart: qtyInCart,
                                    ignoredFromMaxQty: ignoredFromMaxQty,
                                    minQty: minQty
                                }),
                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Locale.CartLine */.go.CartLine, {
                                    line: item,
                                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Locale.Price */.go.Price, {
                                        children: function(props) {
                                            return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Price, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                                                inSidebar: inSidebar
                                            }));
                                        }
                                    })
                                })
                            ]
                        })
                    }),
                    chargeItem && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                        sx: {
                            width: "100%",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            pt: "8"
                        },
                        children: [
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Paragraph */.nv, {
                                sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.variantTitle), {
                                    fontWeight: "500",
                                    color: "black"
                                }),
                                children: [
                                    "+ ",
                                    (ref13 = chargeItem.variant) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.product) === null || ref14 === void 0 ? void 0 : ref14.title
                                ]
                            }),
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Locale.CartLine */.go.CartLine, {
                                line: chargeItem,
                                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Locale.Price */.go.Price, {
                                    children: function(props) {
                                        return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Price, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                                            inSidebar: inSidebar
                                        }));
                                    }
                                })
                            })
                        ]
                    })
                ]
            }),
            isDeleting && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                sx: theme.deleting,
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Spinner */.$j, {
                    sx: theme.deleting.spinner
                })
            })
        ]
    }));
});
LineItem.displayName = "LineItem";
LineItem.propTypes = {
    item: (prop_types_default()).object,
    index: (prop_types_default()).number,
    inSidebar: (prop_types_default()).bool
};

;// CONCATENATED MODULE: ./src/snippets/Cart/LineItem/LoyaltyLionItem.jsx


















var LoyaltyLionItem = LineItem_theme_themed(function(_param) {
    var theme = _param.theme, inSidebar = _param.inSidebar, item = _param.item, isLast = _param.isLast, cart = _param.cart, isMaxed = _param.isMaxed, qtyInCart = _param.qtyInCart, maxQty = _param.maxQty, chargeItems = _param.chargeItems, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme",
        "inSidebar",
        "item",
        "isLast",
        "cart",
        "isMaxed",
        "qtyInCart",
        "maxQty",
        "chargeItems"
    ]);
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    var settings = (0,dist.useSettings)();
    var cartDiscounts = (0,dist.useCartDiscounts)();
    var _ref = (0,dist.useCartRemoveItem)({
        autoReset: 100
    }), cartRemoveItem = _ref.cartRemoveItem, removeStatus = (0,_object_without_properties/* default */.Z)(_ref, [
        "cartRemoveItem"
    ]);
    var ref12 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useCartStatus */.T0)(), 2), setUpdatingCartStatus = ref12[1].setUpdatingCartStatus;
    var ref13 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useSidebar */.Ap)(), 2), closeSidebar = ref13[1].closeSidebar;
    var ref14 = useByobLineItem({
        item: item,
        updatedAt: cart === null || cart === void 0 ? void 0 : cart.updatedAt,
        discountCodeApplied: cartDiscounts === null || cartDiscounts === void 0 ? void 0 : cartDiscounts.length
    }), isByob = ref14.isByob, byobMessage = ref14.byobMessage;
    var gwpVariantIds = (0,store/* useRecoilValue */.sJ)(store/* default.gwpVariantIds */.ZP.gwpVariantIds);
    var ref15 = (0,react.useState)(false), isDeleting = ref15[0], setIsDeleting = ref15[1];
    var handle = item.variant.product.handle;
    var isGift = (gwpVariantIds === null || gwpVariantIds === void 0 ? void 0 : gwpVariantIds.includes(item.variant.id)) || handle === "mystery-item";
    var isSustainabilityCoverage = handle === "sustainability-coverage";
    var started = removeStatus.started, finished = removeStatus.finished, success = removeStatus.success, errors = removeStatus.errors;
    var ignoredProducts = settings === null || settings === void 0 ? void 0 : (ref = settings.cart) === null || ref === void 0 ? void 0 : (ref1 = ref.bulkOrdering) === null || ref1 === void 0 ? void 0 : ref1.ignoredProducts;
    var availableForSale = (0,_object_spread/* default */.Z)({}, item.variant).availableForSale;
    var productUrl = null;
    var fullTitle = (ref2 = item.variant) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.product) === null || ref3 === void 0 ? void 0 : ref3.title;
    var image = (ref4 = item.variant) === null || ref4 === void 0 ? void 0 : ref4.image;
    var sizeVariant = (ref5 = item.variant) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.selectedOptions) === null || ref6 === void 0 ? void 0 : ref6.find(function(option) {
        return option.name === "Size";
    });
    var colorVariant = (ref7 = item.variant) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.selectedOptions) === null || ref8 === void 0 ? void 0 : ref8.find(function(option) {
        return option.name === "Color";
    });
    var ignoredFromMaxQty = (0,react.useMemo)(function() {
        return ignoredProducts === null || ignoredProducts === void 0 ? void 0 : ignoredProducts.some(function(param) {
            var product = param.product;
            return product.handle === handle;
        });
    }, [
        handle,
        ignoredProducts
    ]);
    var title = (0,react.useMemo)(function() {
        var splitIndex = (fullTitle === null || fullTitle === void 0 ? void 0 : fullTitle.indexOf("|")) || -1;
        return {
            product: splitIndex >= 0 ? fullTitle === null || fullTitle === void 0 ? void 0 : fullTitle.slice(0, splitIndex).trim() : fullTitle,
            variant: splitIndex >= 0 ? fullTitle === null || fullTitle === void 0 ? void 0 : fullTitle.slice(splitIndex + 1).trim() : ""
        };
    }, [
        fullTitle
    ]);
    var handleRemove = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    setIsDeleting(true);
                    return [
                        4,
                        cartRemoveItem({
                            lineId: item.id
                        })
                    ];
                case 1:
                    _state.sent();
                    setIsDeleting(false);
                    return [
                        2
                    ];
            }
        });
    }), [
        item.id
    ]);
    var discountDescription = (ref9 = item.discountAllocations) === null || ref9 === void 0 ? void 0 : (ref10 = ref9[0]) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.discountApplication) === null || ref11 === void 0 ? void 0 : ref11.description;
    var setGlobalCartStatusOnUpdating = (0,react.useCallback)(function() {
        setUpdatingCartStatus({
            started: started,
            finished: finished,
            success: success,
            errors: errors
        });
        return function() {
            setUpdatingCartStatus({
                started: false,
                finished: false,
                success: false,
                errors: []
            });
        };
    }, [
        started,
        finished,
        success
    ]);
    var removeItemFromCartIfUnavailable = (0,react.useCallback)(function() {
        if (availableForSale) return;
        cartRemoveItem({
            lineId: item.id
        });
    }, [
        availableForSale,
        item.id
    ]);
    (0,react.useEffect)(function() {
        setGlobalCartStatusOnUpdating();
    }, [
        started,
        finished,
        success
    ]);
    (0,react.useEffect)(function() {
        removeItemFromCartIfUnavailable();
    }, [
        availableForSale
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-comp": LoyaltyLionItem.displayName
    }, props), {
        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.wrapper, props.sx), {
            borderBottomStyle: isLast ? "none" : "solid"
        }),
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Link */.rU, {
                href: productUrl,
                tabIndex: "-1",
                "aria-label": title.product,
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Picture */.t, {
                    alt: title.product,
                    images: [
                        {
                            src: image === null || image === void 0 ? void 0 : image.src,
                            ratio: 1,
                            width: 105
                        }, 
                    ],
                    sx: theme.image
                })
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                sx: theme.details,
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                        sx: theme.top,
                        children: [
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                                sx: theme.titleWrapper,
                                children: [
                                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Link */.rU, {
                                        href: productUrl,
                                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                                            as: "h5",
                                            sx: theme.title,
                                            children: title.product
                                        })
                                    }),
                                    (sizeVariant === null || sizeVariant === void 0 ? void 0 : sizeVariant.value) || (colorVariant === null || colorVariant === void 0 ? void 0 : colorVariant.value) ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                                        sx: theme.variantTitle,
                                        children: (sizeVariant === null || sizeVariant === void 0 ? void 0 : sizeVariant.value) || (colorVariant === null || colorVariant === void 0 ? void 0 : colorVariant.value)
                                    }) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                                        sx: theme.variantTitle,
                                        children: title.variant
                                    }),
                                    isGift && parseInt(item.estimatedCost.subtotalAmount.amount, 10) === 0 && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                                        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.variantTitle), {
                                            color: isGift ? "red" : ""
                                        }),
                                        children: "Free Gift With Purchase"
                                    }),
                                    isByob && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                                        sx: theme.variantTitle,
                                        children: "With Personalization"
                                    }),
                                    discountDescription && !byobMessage && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                                        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.variantTitle), {
                                            color: "red"
                                        }),
                                        children: discountDescription
                                    }),
                                    byobMessage && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                                        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.variantTitle), {
                                            color: "red"
                                        }),
                                        children: byobMessage
                                    })
                                ]
                            }),
                            handle !== "byob-charge" && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                                variant: "buttons.plain",
                                onClick: handleRemove,
                                sx: theme.closeButton,
                                "aria-label": "Remove item from cart",
                                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Svg */.ny, {
                                    alt: "Close",
                                    src: "/svgs/close.svg#close",
                                    viewBox: "0 0 48 48",
                                    sx: theme.closeIcon
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                        sx: {
                            width: "100%"
                        },
                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                            sx: theme.bottom,
                            children: [
                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {}),
                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Locale.CartLine */.go.CartLine, {
                                    line: item,
                                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Locale.Price */.go.Price, {
                                        children: function(props) {
                                            return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Price, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                                                inSidebar: inSidebar
                                            }));
                                        }
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            isDeleting && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                sx: theme.deleting,
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Spinner */.$j, {
                    sx: theme.deleting.spinner
                })
            })
        ]
    }));
});
LoyaltyLionItem.displayName = "LoyaltyLionItem";
LoyaltyLionItem.propTypes = {
    item: (prop_types_default()).object,
    index: (prop_types_default()).number,
    inSidebar: (prop_types_default()).bool
};

;// CONCATENATED MODULE: ./src/snippets/Cart/LineItem/index.js



;// CONCATENATED MODULE: ./src/snippets/Cart/LineItems/LineItems.theme.js



var LineItems_theme_themed = (0,create/* create */.U)(new function() {
    this.sidebar = {
        flex: 1,
        overflow: "hidden",
        mr: "initial"
    };
    // cart empty — rendered in /cart
    this.page = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this.sidebar), {
        width: "80%"
    });
}());

;// CONCATENATED MODULE: ./src/snippets/Cart/LineItems/LineItems.jsx





















var LineItems = LineItems_theme_themed(function(_param) {
    var themes = _param.theme, _inSidebar = _param.inSidebar, inSidebar = _inSidebar === void 0 ? false : _inSidebar, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme",
        "inSidebar"
    ]);
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var gwpProducts = (0,store/* useRecoilValue */.sJ)(store/* default.gwpProducts */.ZP.gwpProducts);
    var settings = (0,dist.useSettings)();
    var cart = (0,dist.useCart)();
    var cartRemoveItem = (0,dist.useCartRemoveItem)({
        autoReset: 100
    }).cartRemoveItem;
    var cartItems = (0,dist.useCartItems)({
        sortByAddedAt: true
    });
    var ref7 = useByobLineItems({
        cart: cart
    }), updateOrAddByobChargeItem = ref7.updateOrAddByobChargeItem, byobDependency = ref7.byobDependency;
    useCartDiscountPrices();
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useModal */.dd)(), 2), openModal = ref8[1].openModal;
    var gwp = (0,hooks/* useGiftWithPurchase */.tG)();
    var cartHasGwp = (0,react.useMemo)(function() {
        if (!gwpProducts) return false;
        return cartItems === null || cartItems === void 0 ? void 0 : cartItems.some(function(item) {
            return gwpProducts === null || gwpProducts === void 0 ? void 0 : gwpProducts.some(function(product) {
                var ref, ref1, ref2;
                return (0,utils/* decodedId */.uP)(product === null || product === void 0 ? void 0 : (ref = product.variants) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.storefrontId) === (0,utils/* decodedId */.uP)((ref2 = item.variant) === null || ref2 === void 0 ? void 0 : ref2.id) && parseInt(item.estimatedCost.subtotalAmount.amount, 10) === 0;
            });
        });
    }, [
        cart === null || cart === void 0 ? void 0 : cart.updatedAt,
        gwpProducts === null || gwpProducts === void 0 ? void 0 : gwpProducts.map(function(p) {
            return p.handle;
        }).join("")
    ]);
    var hasLoyaltyItem = (0,react.useMemo)(function() {
        var ref, ref1;
        if (!(cart === null || cart === void 0 ? void 0 : (ref = cart.lines) === null || ref === void 0 ? void 0 : ref.length)) return [];
        return (ref1 = (cart === null || cart === void 0 ? void 0 : cart.lines) || []) === null || ref1 === void 0 ? void 0 : ref1.reduce(function(acc, item) {
            var ref, ref1;
            if ((item === null || item === void 0 ? void 0 : (ref = item.attributes) === null || ref === void 0 ? void 0 : ref.find(function(attr) {
                return (attr === null || attr === void 0 ? void 0 : attr.key) === "_source" && (attr === null || attr === void 0 ? void 0 : attr.value) === "ll free product";
            })) && (item === null || item === void 0 ? void 0 : (ref1 = item.attributes) === null || ref1 === void 0 ? void 0 : ref1.find(function(attr) {
                var ref, ref1;
                return (attr === null || attr === void 0 ? void 0 : attr.key) === "_discountCode" && (attr === null || attr === void 0 ? void 0 : attr.value) === (cart === null || cart === void 0 ? void 0 : (ref = cart.discountCodes) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.code);
            })) && parseInt(item.estimatedCost.subtotalAmount.amount, 10) === 0) {
                return (0,_to_consumable_array/* default */.Z)(acc).concat([
                    item === null || item === void 0 ? void 0 : item.id
                ]);
            }
            return acc;
        }, []);
    }, [
        cart === null || cart === void 0 ? void 0 : cart.id,
        cart === null || cart === void 0 ? void 0 : cart.lines,
        cart === null || cart === void 0 ? void 0 : cart.discountCodes
    ]);
    var chargeItems = cart === null || cart === void 0 ? void 0 : (ref = cart.lines) === null || ref === void 0 ? void 0 : ref.reduce(function(acc, lineItem) {
        var jtbAttr = ((lineItem === null || lineItem === void 0 ? void 0 : lineItem.attributes) || []).find(function(attr) {
            var ref;
            return (attr === null || attr === void 0 ? void 0 : attr.key) === "recipe_id" && (attr === null || attr === void 0 ? void 0 : (ref = attr.value) === null || ref === void 0 ? void 0 : ref.indexOf("uc-")) !== -1;
        });
        if (jtbAttr) {
            var ref;
            var attrValue = jtbAttr === null || jtbAttr === void 0 ? void 0 : (ref = jtbAttr.value) === null || ref === void 0 ? void 0 : ref.replace("uc-", "");
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, attrValue, lineItem));
        }
        return acc;
    }, {});
    var ref9 = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* default.cartIsMaxed */.ZP.cartIsMaxed), 2), isMaxed = ref9[0], setIsMaxed = ref9[1];
    var ref10 = (0,react.useState)(0), qtyInCart = ref10[0], setQtyInCart = ref10[1];
    var theme = inSidebar ? themes.sidebar : themes.page;
    var showMixedCartMessage = false;
    var ref11 = (settings === null || settings === void 0 ? void 0 : (ref1 = settings.cart) === null || ref1 === void 0 ? void 0 : ref1.bulkOrdering) || {}, maxQty = ref11.maxQty, _itemMessage = ref11.itemMessage, itemMessage = _itemMessage === void 0 ? "Please contact bulkorders@brumate.com for orders over 150." : _itemMessage;
    var mixedCartLock = settings === null || settings === void 0 ? void 0 : (ref2 = settings.cart) === null || ref2 === void 0 ? void 0 : ref2.mixedCartLock;
    var mixedCartProducts = (0,react.useMemo)(function() {
        if (!(mixedCartLock === null || mixedCartLock === void 0 ? void 0 : mixedCartLock.products)) return [];
        return mixedCartLock.products.map(function(product) {
            return product.handle;
        }).toString();
    }, [
        mixedCartLock === null || mixedCartLock === void 0 ? void 0 : mixedCartLock.products
    ]);
    if (mixedCartLock === null || mixedCartLock === void 0 ? void 0 : mixedCartLock.enabled) {
        var cartHasLockedProducts = false;
        var cartHasUnlockedProducts = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = cartItems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var cartItem = _step.value;
                var ref12, ref13, ref14, ref15, ref16, ref17;
                var handle = cartItem === null || cartItem === void 0 ? void 0 : (ref12 = cartItem.variant) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.product) === null || ref13 === void 0 ? void 0 : ref13.handle;
                var inLockedCollection = cartItem === null || cartItem === void 0 ? void 0 : (ref14 = cartItem.variant) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.product) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.collections) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.nodes) === null || ref17 === void 0 ? void 0 : ref17.some(function(collection) {
                    var ref;
                    return (collection === null || collection === void 0 ? void 0 : collection.handle) === (mixedCartLock === null || mixedCartLock === void 0 ? void 0 : (ref = mixedCartLock.collection) === null || ref === void 0 ? void 0 : ref.handle);
                });
                var isLockedProduct = inLockedCollection || // If you adopted the Set version above, replace with: mixedCartProductHandles.has(handle)
                mixedCartProducts.includes(handle);
                if (isLockedProduct) {
                    cartHasLockedProducts = true;
                } else {
                    cartHasUnlockedProducts = true;
                }
                if (cartHasLockedProducts && cartHasUnlockedProducts) break;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (cartHasLockedProducts && cartHasUnlockedProducts) {
            document.dispatchEvent(new CustomEvent("cart:block-checkout", {
                detail: {
                    disableCheckout: true
                }
            }));
            showMixedCartMessage = true;
        } else {
            console.log("checkout enabled");
            document.dispatchEvent(new CustomEvent("cart:block-checkout", {
                detail: {
                    disableCheckout: false
                }
            }));
        }
    }
    (0,react.useEffect)(function() {
        try {
            if (!(cart === null || cart === void 0 ? void 0 : cart.id)) return;
            document.cookie = "pp_widget_cart_id=".concat(cart.id);
            document.cookie = "pp_widget_cart_id=".concat(cart.id, ";domain=.brumate.com;path=/");
        } catch (error) {
            console.error(error);
        }
    }, [
        cart === null || cart === void 0 ? void 0 : cart.id
    ]);
    (0,react.useEffect)(function() {
        updateOrAddByobChargeItem();
    }, [
        byobDependency
    ]);
    var checkIfCartIsMaxedOnCartUpdate = (0,react.useCallback)(function() {
        if (!maxQty) return false;
        var totalProductsInCart = (cartItems === null || cartItems === void 0 ? void 0 : cartItems.reduce(function(total, param) {
            var variant = param.variant, itemQty = param.quantity;
            var ignoredHandles = [
                "byob-charge",
                "parcel-protection",
                "brumate-e-gift-card", 
            ];
            if (ignoredHandles.includes(variant.product.handle)) {
                return total;
            }
            return total + itemQty;
        }, 0)) || 0;
        setQtyInCart(totalProductsInCart);
        setIsMaxed(totalProductsInCart >= maxQty);
        return false;
    }, [
        maxQty,
        cart === null || cart === void 0 ? void 0 : cart.updatedAt
    ]);
    var handleGiftWithPurchase = function() {
        openModal(/*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* GiftWithPurchase */.QT, {}), true);
    };
    (0,react.useEffect)(function() {
        checkIfCartIsMaxedOnCartUpdate();
    }, [
        maxQty,
        cart === null || cart === void 0 ? void 0 : cart.updatedAt
    ]);
    (0,react.useEffect)(function() {
        if (cart === null || cart === void 0 ? void 0 : cart.id) {
            localStorage.setItem("cartID", cart.id);
        }
        var removeMysteryItem = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var ref, hasMystery;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!((cart === null || cart === void 0 ? void 0 : (ref = cart.lines) === null || ref === void 0 ? void 0 : ref.length) === 1)) return [
                                3,
                                2
                            ];
                            hasMystery = cart.lines[0].variant.product.handle === "mystery-item";
                            if (!hasMystery) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                cartRemoveItem({
                                    lineId: cart.lines[0].id
                                })
                            ];
                        case 1:
                            _state.sent();
                            _state.label = 2;
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            });
            return function removeMysteryItem() {
                return _ref.apply(this, arguments);
            };
        }();
        removeMysteryItem();
    }, [
        cart === null || cart === void 0 ? void 0 : cart.lines
    ]);
    var showQualifiedGiftMessage = gwp.isEligible(cart) && !cartHasGwp;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
        sx: {
            position: "relative"
        },
        children: [
            (mixedCartLock === null || mixedCartLock === void 0 ? void 0 : mixedCartLock.enabled) && showMixedCartMessage && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                sx: {
                    px: 12,
                    py: 3,
                    textAlign: "center"
                },
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Markdown */.UG, {
                    text: mixedCartLock === null || mixedCartLock === void 0 ? void 0 : mixedCartLock.message,
                    sx: {
                        a: {
                            textDecoration: "none"
                        }
                    },
                    textSx: {
                        variant: "text.label.2",
                        color: "red",
                        fontSize: 0,
                        textAlign: "center"
                    }
                })
            }),
            isMaxed && itemMessage && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                sx: {
                    position: "sticky",
                    top: 0,
                    bg: "background",
                    zIndex: 1,
                    px: 12,
                    py: 5,
                    borderBottom: function(t) {
                        return "1px solid ".concat(t.colors.gray);
                    }
                },
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Markdown */.UG, {
                    text: itemMessage,
                    sx: {
                        a: {
                            textDecoration: "none"
                        }
                    },
                    textSx: {
                        variant: "text.label.2",
                        color: "red",
                        fontSize: 0,
                        textAlign: "center"
                    }
                })
            }),
            showQualifiedGiftMessage && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                sx: {
                    px: 12,
                    py: 3,
                    textAlign: "center"
                },
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                    variant: "text.label.2",
                    sx: {
                        bg: "transparent",
                        color: "text",
                        cursor: "pointer"
                    },
                    onClick: handleGiftWithPurchase,
                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Markdown */.UG, {
                        text: (settings === null || settings === void 0 ? void 0 : (ref3 = settings.gwp) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.cart) === null || ref4 === void 0 ? void 0 : ref4.link) || "You qualified for a free gift. Select your gift.",
                        textSx: {
                            variant: "text.label.2"
                        }
                    })
                })
            }),
            cartHasGwp && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                sx: {
                    px: 12,
                    py: 3,
                    textAlign: "center"
                },
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                    variant: "text.label.2",
                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Markdown */.UG, {
                        text: (settings === null || settings === void 0 ? void 0 : (ref5 = settings.gwp) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.cart) === null || ref6 === void 0 ? void 0 : ref6.link_success) || "Free gift added to cart",
                        textSx: {
                            variant: "text.label.2"
                        }
                    })
                })
            }),
            !!(hasLoyaltyItem === null || hasLoyaltyItem === void 0 ? void 0 : hasLoyaltyItem.length) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                sx: {
                    px: 12,
                    py: 3,
                    textAlign: "center"
                },
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Markdown */.UG, {
                    text: "<p>Free product added to cart</p>",
                    textSx: {
                        variant: "text.label.2"
                    }
                })
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                as: "ul",
                "data-comp": LineItems.displayName
            }, props), {
                sx: (0,_object_spread/* default */.Z)({}, props.sx, theme),
                children: cartItems.map(function(item, index) {
                    var ref;
                    var isLoyaltyItem = item === null || item === void 0 ? void 0 : (ref = item.attributes) === null || ref === void 0 ? void 0 : ref.find(function(attr) {
                        return (attr === null || attr === void 0 ? void 0 : attr.key) === "_source" && (attr === null || attr === void 0 ? void 0 : attr.value) === "ll free product";
                    });
                    var CartLine = isLoyaltyItem ? LoyaltyLionItem : LineItem;
                    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("li", {
                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(CartLine, {
                            item: item,
                            isLast: index === cartItems.length - 1,
                            inSidebar: inSidebar,
                            cart: cart,
                            isMaxed: isMaxed,
                            qtyInCart: qtyInCart,
                            maxQty: maxQty,
                            chargeItems: chargeItems
                        })
                    }, "".concat(item.id, "-").concat(index));
                })
            }), LineItems.displayName)
        ]
    });
});
LineItems.displayName = "LineItems";
LineItems.propTypes = {
    inSidebar: (prop_types_default()).bool
};

;// CONCATENATED MODULE: ./src/snippets/Cart/LineItems/index.js


;// CONCATENATED MODULE: ./src/snippets/Cart/ItemsOrEmpty.theme.js

var ItemsOrEmpty_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        variant: "flex.column",
        height: "100%"
    };
}());

;// CONCATENATED MODULE: ./src/snippets/Cart/ItemsOrEmpty.jsx










var ItemsOrEmpty = ItemsOrEmpty_theme_themed(function(_param) {
    var theme = _param.theme, _inSidebar = _param.inSidebar, inSidebar = _inSidebar === void 0 ? true : _inSidebar, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme",
        "inSidebar"
    ]);
    var cartEmpty = (0,dist.useCartEmpty)();
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-comp": ItemsOrEmpty.displayName
    }, props), {
        sx: (0,_object_spread/* default */.Z)({}, props.sx, theme.wrapper),
        children: cartEmpty ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Empty, {
            inSidebar: inSidebar
        }) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(LineItems, {
            inSidebar: inSidebar
        })
    }));
});
ItemsOrEmpty.displayName = "CartItemsOrEmpty";
ItemsOrEmpty.propTypes = {
    theme: (prop_types_default()).object,
    inSidebar: (prop_types_default()).bool
};

;// CONCATENATED MODULE: ./src/snippets/Cart/Totals/Prices/Prices.theme.js



var Prices_theme_themed = (0,create/* create */.U)(new function() {
    this.sidebar = {
        price: {
            variant: "flex.row.between.center",
            mb: 0,
            title: {
                variant: "text.h5",
                fontSize: 6,
                mr: 4
            },
            amount: {
                variant: "text.base",
                fontSize: [
                    "12px",
                    3
                ],
                textAlign: "right"
            },
            regular: {
                variant: "text.base",
                fontSize: [
                    "12px",
                    3
                ],
                textAlign: "right"
            },
            strike: {
                variant: "text.base",
                fontSize: [
                    "12px",
                    3
                ],
                textAlign: "right",
                textDecoration: "line-through",
                color: "mediumDarkGray",
                ml: [
                    0,
                    4
                ]
            },
            container: {
                gap: 3,
                ml: 0,
                justifyContent: "flex-end",
                flexFlow: [
                    "row-reverse",
                    "row"
                ]
            }
        }
    }, // cart empty — rendered in /cart
    this.page = {
        price: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this.sidebar.price), {
            title: {
                variant: "text.h5",
                mr: 4
            },
            amount: {
                variant: "text.base",
                fontSize: 3,
                textAlign: "right"
            }
        })
    };
}());

;// CONCATENATED MODULE: ./src/snippets/Cart/Totals/Prices/Prices.jsx




var Prices = Prices_theme_themed(function(param) {
    var themes = param.theme, estimatedCost = param.estimatedCost, isDiscounted = param.isDiscounted, inSidebar = param.inSidebar;
    var theme = inSidebar ? themes.sidebar : themes.page;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": Prices.displayName,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
            sx: theme.price,
            children: [
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                    as: "h5",
                    sx: theme.price.title,
                    className: "hidden",
                    children: "Subtotal"
                }),
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                    sx: theme.price.container,
                    children: [
                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                            sx: theme.price.amount,
                            children: estimatedCost === null || estimatedCost === void 0 ? void 0 : estimatedCost.subtotalAmount.locale
                        }),
                        isDiscounted && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                            sx: theme.price.strike,
                            children: estimatedCost.totalCompareAtAmount.locale
                        })
                    ]
                })
            ]
        })
    });
});
Prices.displayName = "Prices";
Prices.propTypes = {
    estimatedCost: (prop_types_default()).object,
    isDiscounted: (prop_types_default()).bool,
    isOnSale: (prop_types_default()).bool,
    inSidebar: (prop_types_default()).bool
};

;// CONCATENATED MODULE: ./src/snippets/Cart/Totals/Prices/index.js


;// CONCATENATED MODULE: ./src/snippets/Cart/Totals/Discounts/Discounts.theme.js



var Discounts_theme_themed = (0,create/* create */.U)(new function() {
    this.sidebar = {
        price: {
            variant: "flex.row.between.center",
            mb: 4,
            title: {
                variant: "text.h5",
                mr: 4
            },
            amount: {
                variant: "text.base",
                textAlign: "right"
            }
        }
    }, // cart empty — rendered in /cart
    this.page = {
        price: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this.sidebar.price), {
            title: {
                variant: "text.h5",
                mr: 4
            },
            amount: {
                variant: "text.base",
                textAlign: "right"
            }
        })
    };
}());

;// CONCATENATED MODULE: ./src/snippets/Cart/Totals/Discounts/Discounts.jsx











var Discounts = Discounts_theme_themed(function(param) {
    var theme = param.theme;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var cart = (0,dist.useCart)();
    var cartAddDiscount = (0,dist.useCartAddDiscount)().cartAddDiscount;
    var cartRemoveDiscount = (0,dist.useCartRemoveDiscount)().cartRemoveDiscount;
    var cartRemoveItem = (0,dist.useCartRemoveItem)({
        autoReset: 100
    }).cartRemoveItem;
    var showDiscountInput = useCartRejectDiscount().showDiscountInput;
    var cartDiscountAmount = (0,store/* useRecoilValue */.sJ)(store/* default.cartDiscountAmount */.ZP.cartDiscountAmount);
    var ref8 = (0,react.useState)(""), code = ref8[0], setCode = ref8[1];
    var ref9 = (0,react.useState)(false), loading = ref9[0], setLoading = ref9[1];
    var ref10 = (0,react.useState)(""), message = ref10[0], setMessage = ref10[1];
    var ref11 = (0,react.useState)(false), isOpen = ref11[0], setIsOpen = ref11[1];
    var discountCode = showDiscountInput ? (cart === null || cart === void 0 ? void 0 : (ref = cart.discountCodes) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.applicable) && (cart === null || cart === void 0 ? void 0 : (ref2 = cart.discountCodes) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.code) : "";
    var linesDiscountAmount = (0,react.useMemo)(function() {
        var ref, ref1;
        if (!(cart === null || cart === void 0 ? void 0 : (ref = cart.lines) === null || ref === void 0 ? void 0 : ref.length)) return 0;
        return cart === null || cart === void 0 ? void 0 : (ref1 = cart.lines) === null || ref1 === void 0 ? void 0 : ref1.reduce(function(acc, line) {
            var ref, ref1;
            var allocation = line === null || line === void 0 ? void 0 : (ref = line.discountAllocations) === null || ref === void 0 ? void 0 : ref[0];
            var amount = Number(allocation === null || allocation === void 0 ? void 0 : (ref1 = allocation.discountedAmount) === null || ref1 === void 0 ? void 0 : ref1.amount) || 0;
            return acc + amount;
        }, 0);
    }, [
        cart === null || cart === void 0 ? void 0 : cart.lines
    ]);
    // 10off6d8b0b0b70d5 - $10
    // 5OFFf4dad56e2c22 - $5
    // BM0PVZ8HV6M4 - 30% off only brus
    // 3MANRH3XMJ0B
    var handleClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
            var ref, updatedCart, discount, ref1, ref2, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event.preventDefault();
                        event.stopPropagation();
                        setLoading(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        setCode("");
                        return [
                            4,
                            cartAddDiscount({
                                discountCode: code
                            })
                        ];
                    case 2:
                        updatedCart = _state.sent();
                        discount = updatedCart === null || updatedCart === void 0 ? void 0 : (ref = updatedCart.discountCodes) === null || ref === void 0 ? void 0 : ref[0];
                        if (discount === null || discount === void 0 ? void 0 : discount.applicable) {
                            ;
                            if ((ref2 = discount === null || discount === void 0 ? void 0 : (ref1 = discount.code) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) === null || ref2 === void 0 ? void 0 : ref2.startsWith("app")) {
                                setMessage("This coupon is valid for mobile app only.");
                            } else {
                                setCode("");
                                setMessage("");
                            }
                        } else {
                            setCode("");
                            cartRemoveDiscount();
                            setMessage("This code is invalid");
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.log(error);
                        setMessage("Uh something went wrong");
                        return [
                            3,
                            4
                        ];
                    case 4:
                        setLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleClick(event) {
            return _ref.apply(this, arguments);
        };
    }();
    var loyaltyItems = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3;
        if (!(cart === null || cart === void 0 ? void 0 : (ref = cart.discountCodes) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.applicable)) {
            return [];
        }
        if (!(cart === null || cart === void 0 ? void 0 : (ref2 = cart.lines) === null || ref2 === void 0 ? void 0 : ref2.length)) return [];
        return (ref3 = (cart === null || cart === void 0 ? void 0 : cart.lines) || []) === null || ref3 === void 0 ? void 0 : ref3.reduce(function(acc, item) {
            var ref, ref1;
            if ((item === null || item === void 0 ? void 0 : (ref = item.attributes) === null || ref === void 0 ? void 0 : ref.find(function(attr) {
                return (attr === null || attr === void 0 ? void 0 : attr.key) === "_source" && (attr === null || attr === void 0 ? void 0 : attr.value) === "ll free product";
            })) && (item === null || item === void 0 ? void 0 : (ref1 = item.attributes) === null || ref1 === void 0 ? void 0 : ref1.find(function(attr) {
                var ref, ref1;
                return (attr === null || attr === void 0 ? void 0 : attr.key) === "_discountCode" && (attr === null || attr === void 0 ? void 0 : attr.value) === (cart === null || cart === void 0 ? void 0 : (ref = cart.discountCodes) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.code);
            }))) {
                return (0,_to_consumable_array/* default */.Z)(acc).concat([
                    item === null || item === void 0 ? void 0 : item.id
                ]);
            }
            return acc;
        }, []);
    }, [
        cart === null || cart === void 0 ? void 0 : cart.id,
        cart === null || cart === void 0 ? void 0 : cart.lines,
        cart === null || cart === void 0 ? void 0 : cart.discountCodes
    ]);
    var removeDiscount = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(loyaltyItems === null || loyaltyItems === void 0 ? void 0 : loyaltyItems.length)) return [
                            3,
                            1
                        ];
                        loyaltyItems === null || loyaltyItems === void 0 ? void 0 : loyaltyItems.forEach(function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(function(item) {
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                cartRemoveItem({
                                                    lineId: item
                                                })
                                            ];
                                        case 1:
                                            _state.sent();
                                            return [
                                                4,
                                                cartRemoveDiscount()
                                            ];
                                        case 2:
                                            _state.sent();
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(item) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            cartRemoveDiscount()
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function removeDiscount() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": Discounts.displayName,
        mx: -10,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
            mb: 5,
            py: "9px",
            px: 10,
            bg: "#F1F1F1",
            children: [
                !discountCode && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Heading */.X6, {
                    sx: {
                        cursor: "pointer",
                        fontSize: "12px",
                        fontWeight: 500,
                        display: "flex"
                    },
                    as: "h3",
                    onClick: function() {
                        return setIsOpen(!isOpen);
                    },
                    children: [
                        "Add Discount Code",
                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Svg */.ny, {
                            alt: "chevron",
                            viewBox: "0 0 16 16",
                            src: "/svgs/chevron/down.svg#down",
                            sx: {
                                ml: 5,
                                width: "14px",
                                transition: "all 250ms",
                                transform: isOpen ? "rotate(-180deg)" : "rotate(0)"
                            }
                        })
                    ]
                }),
                discountCode && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                    sx: {
                        alignItems: "center",
                        fontSize: "12px",
                        fontWeight: 500
                    },
                    children: [
                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                            className: "pr-2",
                            children: "Discount Code"
                        }),
                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                            sx: {
                                bg: "#000",
                                color: "#fff",
                                display: "grid",
                                padding: "4px 8px",
                                borderRadius: "5px",
                                gridTemplateColumns: "auto 1fr"
                            },
                            children: [
                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Svg */.ny, {
                                    alt: "close",
                                    viewBox: "0 0 48 48",
                                    src: "/svgs/close.svg#close",
                                    sx: {
                                        mr: 2,
                                        mt: 0,
                                        width: "14px",
                                        cursor: "pointer"
                                    },
                                    onClick: removeDiscount
                                }),
                                discountCode
                            ]
                        }),
                        cartDiscountAmount > 0 && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                            sx: {
                                ml: "auto",
                                color: "redSalePrice"
                            },
                            children: [
                                "$-",
                                (ref5 = (ref4 = parseFloat(cartDiscountAmount)) === null || ref4 === void 0 ? void 0 : ref4.toFixed(2)) === null || ref5 === void 0 ? void 0 : ref5.replace(".00", "")
                            ]
                        }),
                        cartDiscountAmount <= 0 && linesDiscountAmount > 0 && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                            sx: {
                                ml: "auto",
                                color: "redSalePrice"
                            },
                            children: [
                                "$-",
                                (ref7 = (ref6 = parseFloat(linesDiscountAmount)) === null || ref6 === void 0 ? void 0 : ref6.toFixed(2)) === null || ref7 === void 0 ? void 0 : ref7.replace(".00", "")
                            ]
                        })
                    ]
                }),
                isOpen && (!discountCode || message) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                    mt: 4,
                    mb: "3px",
                    children: [
                        !discountCode && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                            sx: {
                                position: "relative"
                            },
                            children: [
                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Input */.II, {
                                    name: "code",
                                    placeholder: "Code",
                                    type: "text",
                                    value: code,
                                    onChange: function(e) {
                                        return setCode(e.target.value);
                                    },
                                    required: true,
                                    sx: {
                                        width: "100%",
                                        height: "32px",
                                        borderRadius: "50px",
                                        py: 0,
                                        fontSize: "12px",
                                        bg: "#FFFFFF"
                                    }
                                }),
                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                                    sx: {
                                        position: "absolute",
                                        top: "0",
                                        right: "0",
                                        background: "#222222",
                                        textAlign: "center",
                                        borderRadius: "60px",
                                        color: "white",
                                        height: "32px",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        fontWeight: "bold",
                                        cursor: "pointer",
                                        minWidth: [
                                            "102px",
                                            "160px"
                                        ],
                                        fontSize: "12px"
                                    },
                                    onClick: handleClick,
                                    children: loading ? "Loading" : "Apply"
                                })
                            ]
                        }),
                        message && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                            sx: {
                                mt: 3,
                                textAlign: "center",
                                ml: 3,
                                color: (message === null || message === void 0 ? void 0 : message.includes("Success")) ? "#222222" : "#AE2807"
                            },
                            children: message
                        })
                    ]
                })
            ]
        })
    });
});
Discounts.displayName = "Discounts";

;// CONCATENATED MODULE: ./src/snippets/Cart/Totals/Discounts/index.js


;// CONCATENATED MODULE: ./src/snippets/Cart/Totals/Totals.theme.js



var Totals_theme_themed = (0,create/* create */.U)(new function() {
    this.sidebar = {
        wrapper: {
            variant: "flex.column",
            py: 0,
            px: 10,
            bg: "background"
        },
        summary: {
            display: "none",
            color: "red"
        },
        checkout: {
            variant: "buttons.primary",
            fontSize: [
                "12px",
                "15px"
            ],
            height: [
                "40px",
                "42px"
            ]
        }
    };
    // cart empty — rendered in /cart
    this.page = {
        wrapper: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this.sidebar.wrapper), {
            boxShadow: [
                "none",
                "top"
            ],
            pt: [
                0,
                null,
                11
            ],
            pb: [
                0,
                null,
                10
            ],
            px: [
                0,
                null,
                9
            ],
            mb: [
                11,
                null,
                9
            ]
        }),
        summary: {
            variant: "text.lg",
            display: [
                "none",
                null,
                "block"
            ],
            mb: 8
        }
    };
}());

;// CONCATENATED MODULE: ./src/snippets/Cart/Totals/Totals.jsx














var Totals = Totals_theme_themed(function(_param) {
    var themes = _param.theme, _inSidebar = _param.inSidebar, inSidebar = _inSidebar === void 0 ? false : _inSidebar, inputRef = _param.inputRef, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme",
        "inSidebar",
        "inputRef"
    ]);
    var ref, ref1;
    var cart = (0,dist.useCart)();
    var cartCount = (0,dist.useCartCount)();
    var cartCheckout = (0,dist.useCartCheckout)().cartCheckout;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useCartStatus */.T0)(), 1), updatingCartStatus = ref2[0].updatingCartStatus;
    var ref3 = (0,react.useState)(false), disabledCheckout = ref3[0], setDisabledCheckout = ref3[1];
    var theme = inSidebar ? themes.sidebar : themes.page;
    var cartAmount = cart === null || cart === void 0 ? void 0 : (ref = cart.estimatedCost) === null || ref === void 0 ? void 0 : (ref1 = ref.subtotalAmount) === null || ref1 === void 0 ? void 0 : ref1.amount;
    var checkoutStatusUpdateHandler = function(evt) {
        if (evt.detail.disableCheckout === true) {
            setDisabledCheckout(true);
        } else {
            setDisabledCheckout(false);
        }
    };
    (0,react.useEffect)(function() {
        document.addEventListener("cart:block-checkout", checkoutStatusUpdateHandler);
        return function() {
            document.removeEventListener("cart:block-checkout", checkoutStatusUpdateHandler);
        };
    }, []);
    return cartCount > 0 ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-comp": Totals.displayName
    }, props), {
        ref: inputRef,
        sx: (0,_object_spread/* default */.Z)({}, props.sx, theme.wrapper),
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                sx: theme.summary,
                children: "Order Summary"
            }),
            inSidebar && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Discounts, {}),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Button */.zx, {
                onClick: cartCheckout,
                disabled: updatingCartStatus.started || disabledCheckout,
                sx: theme.checkout,
                id: "SidebarCartCheckout",
                children: [
                    "Checkout ",
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("span", {
                        className: "px-1",
                        children: "-"
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Locale.CartTotals */.go.CartTotals, {
                        cart: cart,
                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Locale.Price */.go.Price, {
                            children: function(propsLoc) {
                                return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Prices, (0,_object_spread/* default */.Z)({
                                    inSidebar: inSidebar
                                }, propsLoc));
                            }
                        })
                    }, cartAmount)
                ]
            })
        ]
    })) : null;
});
Totals.displayName = "CartTotals";
Totals.propTypes = {
    inSidebar: (prop_types_default()).bool
};

;// CONCATENATED MODULE: ./src/snippets/Cart/Totals/index.js


;// CONCATENATED MODULE: ./src/snippets/Cart/FreeShippingMeter/FreeShippingMeter.theme.js

var FreeShippingMeter_theme_themed = (0,create/* create */.U)(new function() {}());

;// CONCATENATED MODULE: ./src/snippets/Cart/FreeShippingMeter/FreeShippingMeter.jsx








var FreeShippingMeter = FreeShippingMeter_theme_themed(function(_param) {
    var theme = _param.theme, inputRef = _param.inputRef, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme",
        "inputRef"
    ]);
    var cartTotals = (0,dist.useCartTotals)();
    var cartDiscountAmount = (0,store/* useRecoilValue */.sJ)(store/* default.cartDiscountAmount */.ZP.cartDiscountAmount);
    var settings = (0,dist.useSettings)();
    var freeShipping = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : settings.cart).freeShipping;
    var ref = (0,_object_spread/* default */.Z)({}, freeShipping), spend = ref.spend, messageRemainder = ref.message, messageQualified = ref.messageQualified, enabled = ref.enabled;
    var meter = (0,react.useMemo)(function() {
        var message = "";
        var progress = 0;
        if (!spend || !(cartTotals === null || cartTotals === void 0 ? void 0 : cartTotals.subtotal) || !enabled) return {
            message: message,
            progress: progress
        };
        var total = parseFloat(parseFloat(cartTotals.subtotal - cartDiscountAmount));
        progress = total / spend;
        if (progress < 1) {
            var remainder = (spend - total).toFixed(2);
            var remainderPrice = remainder.endsWith("00") ? remainder.split(".")[0] : remainder;
            message = messageRemainder.replace("$", "$".concat(remainderPrice));
        } else {
            message = messageQualified;
            progress = 1;
        }
        return {
            message: message,
            progress: progress
        };
    }, [
        enabled,
        messageRemainder,
        messageQualified,
        spend,
        cartTotals === null || cartTotals === void 0 ? void 0 : cartTotals.subtotal,
        cartDiscountAmount, 
    ]);
    return enabled ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
        "data-comp": FreeShippingMeter.displayName,
        sx: {
            variant: "flex.column.center.end",
            bg: "gray",
            height: "66px",
            px: 10,
            pb: "17px"
        },
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                sx: {
                    variant: "text.label.2",
                    lineHeight: "14px",
                    textAlign: "center",
                    minHeight: "18px",
                    pb: 4
                },
                children: meter.message
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                sx: {
                    width: "100%",
                    bg: "white",
                    height: "12px",
                    borderRadius: "6px",
                    position: "relative"
                },
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                    sx: {
                        width: "calc(100% - 8px)",
                        height: "8px",
                        borderRadius: "4px",
                        bg: "dark",
                        position: "absolute",
                        top: 1,
                        left: 2,
                        maxWidth: "".concat(100 * meter.progress, "%"),
                        transition: "max-width 0.4s ease-in-out",
                        transformOrigin: "left"
                    }
                })
            })
        ]
    }) : null;
});
FreeShippingMeter.displayName = "FreeShippingMeter";

;// CONCATENATED MODULE: ./src/snippets/Cart/FreeShippingMeter/index.js


;// CONCATENATED MODULE: ./src/snippets/Cart/Upsell/useUpsellBeacon.js






var useUpsellBeacon = function(param) {
    var profileData = param.profileData, profileTag = param.profileTag, visibleProduct = param.visibleProduct;
    var cartItems = (0,dist.useCartItems)();
    var sendEventsToBeacon = (0,hooks/* useSearchspringBeacon */.fo)().sendEventsToBeacon;
    var ref = (0,react.useState)(false), mounted = ref[0], setMounted = ref[1];
    var cartSkus = (0,react.useMemo)(function() {
        return (cartItems === null || cartItems === void 0 ? void 0 : cartItems.map(function(item) {
            return {
                sku: item.variant.sku
            };
        })) || [];
    }, [
        cartItems
    ]);
    var sendBeaconEventsOnCartOpen = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    if (mounted || !(profileData === null || profileData === void 0 ? void 0 : profileData.results) || !visibleProduct || !profileTag) return [
                        2
                    ];
                    return [
                        4,
                        sendEventsToBeacon({
                            profileTypes: [
                                "profile.render",
                                "profile.impression"
                            ],
                            productTypes: [
                                "profile.product.render",
                                "profile.product.impression"
                            ],
                            tag: profileTag,
                            placement: "basket-page",
                            products: profileData.results,
                            visibleProducts: [
                                visibleProduct
                            ],
                            seed: cartSkus
                        })
                    ];
                case 1:
                    _state.sent();
                    setMounted(true);
                    return [
                        3,
                        3
                    ];
                case 2:
                    error = _state.sent();
                    console.error(error.message);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    }), [
        profileData === null || profileData === void 0 ? void 0 : profileData.results,
        visibleProduct,
        profileTag,
        mounted,
        cartSkus
    ]);
    var sendBeaconEventsOnClick = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
            var dataComp, productClicked, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        if (!profileTag) return [
                            2
                        ];
                        dataComp = (0,_to_consumable_array/* default */.Z)(event.target.attributes || []).find(function(attr) {
                            return attr.name === "data-comp";
                        });
                        productClicked = (dataComp === null || dataComp === void 0 ? void 0 : dataComp.value) === "UpsellAddToCart" || (dataComp === null || dataComp === void 0 ? void 0 : dataComp.value) === "UpsellSliderItemHeading" || (dataComp === null || dataComp === void 0 ? void 0 : dataComp.value) === "PictureImage";
                        return [
                            4,
                            sendEventsToBeacon({
                                profileTypes: [
                                    "profile.click"
                                ],
                                productTypes: productClicked ? [
                                    "profile.product.click"
                                ] : [],
                                tag: profileTag,
                                placement: "basket-page",
                                clickedProduct: productClicked ? visibleProduct : null,
                                seed: cartSkus
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        console.error(error.message);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }(), [
        profileTag,
        visibleProduct,
        cartSkus
    ]);
    var sendBeaconEventsOnProductsInView = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    if (!mounted || !visibleProduct || !profileTag) return [
                        2
                    ];
                    return [
                        4,
                        sendEventsToBeacon({
                            productTypes: [
                                "profile.product.impression"
                            ],
                            tag: profileTag,
                            placement: "basket-page",
                            visibleProducts: [
                                visibleProduct
                            ],
                            seed: cartSkus
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        3,
                        3
                    ];
                case 2:
                    error = _state.sent();
                    console.error(error.message);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    }), [
        visibleProduct,
        profileTag,
        mounted,
        cartSkus
    ]);
    (0,react.useEffect)(function() {
        sendBeaconEventsOnCartOpen();
    }, [
        profileData === null || profileData === void 0 ? void 0 : profileData.results,
        visibleProduct,
        profileTag
    ]);
    (0,react.useEffect)(function() {
        sendBeaconEventsOnProductsInView();
    }, [
        visibleProduct === null || visibleProduct === void 0 ? void 0 : visibleProduct.id
    ]);
    return {
        sendBeaconEventsOnClick: sendBeaconEventsOnClick
    };
};

// EXTERNAL MODULE: ../node_modules/swiper/esm/react/swiper.js + 8 modules
var react_swiper = __webpack_require__(48148);
// EXTERNAL MODULE: ../node_modules/swiper/esm/react/swiper-slide.js
var swiper_slide = __webpack_require__(95445);
// EXTERNAL MODULE: ../node_modules/swiper/esm/components/core/core-class.js + 66 modules
var core_class = __webpack_require__(77796);
// EXTERNAL MODULE: ../node_modules/swiper/esm/components/a11y/a11y.js
var a11y = __webpack_require__(15753);
// EXTERNAL MODULE: ./src/snippets/Cart/Upsell/Navigation/index.js + 3 modules
var Navigation = __webpack_require__(1183);
// EXTERNAL MODULE: ./src/snippets/Cart/Upsell/SliderItem/UpsellAddToCart.jsx
var UpsellAddToCart = __webpack_require__(11578);
// EXTERNAL MODULE: ./src/snippets/Cart/Upsell/SliderItem/SliderItem.theme.js
var SliderItem_theme = __webpack_require__(131);
;// CONCATENATED MODULE: ./src/snippets/Cart/Upsell/SliderItem/UpsellSliderItem.jsx









var UpsellSliderItem = (0,SliderItem_theme/* themed */.H)(function(param) {
    var theme = param.theme, handle = param.handle;
    var ref, ref1;
    var product = (0,dist.useProductByHandle)({
        handle: handle
    }).product;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useSidebar */.Ap)(), 2), closeSidebar = ref2[1].closeSidebar;
    var title = (0,react.useMemo)(function() {
        var fullTitle = product === null || product === void 0 ? void 0 : product.title;
        var splitIndex = (fullTitle === null || fullTitle === void 0 ? void 0 : fullTitle.indexOf("|")) || -1;
        return {
            product: splitIndex >= 0 ? fullTitle === null || fullTitle === void 0 ? void 0 : fullTitle.slice(0, splitIndex).trim() : fullTitle,
            variant: splitIndex >= 0 ? fullTitle === null || fullTitle === void 0 ? void 0 : fullTitle.slice(splitIndex + 1).trim() : ""
        };
    }, [
        product === null || product === void 0 ? void 0 : product.title
    ]);
    var firstImage = (0,react.useMemo)(function() {
        var ref, ref1;
        return (ref1 = product === null || product === void 0 ? void 0 : (ref = product.media) === null || ref === void 0 ? void 0 : ref.find(function(item) {
            return item.mediaContentType === "IMAGE";
        })) === null || ref1 === void 0 ? void 0 : ref1.image;
    }, [
        product === null || product === void 0 ? void 0 : product.id
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
        "data-comp": UpsellSliderItem.displayName,
        sx: theme.wrapper,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Link */.rU, {
                href: "/products/".concat(handle),
                onClick: closeSidebar,
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Picture */.t, {
                    alt: product === null || product === void 0 ? void 0 : product.title,
                    "data-comp": "UpsellSliderItemPicture",
                    images: [
                        {
                            src: firstImage === null || firstImage === void 0 ? void 0 : firstImage.originalSrc,
                            width: 350,
                            ratio: 1
                        }, 
                    ],
                    sx: theme.picture,
                    children: !firstImage && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Spinner */.$j, {
                        sx: theme.picture.spinner
                    })
                })
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                sx: theme.details,
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Link */.rU, {
                        href: "/products/".concat(handle),
                        onClick: closeSidebar,
                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                            "data-comp": "UpsellSliderItemHeading",
                            as: "h6",
                            sx: theme.title,
                            children: title === null || title === void 0 ? void 0 : title.product
                        })
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                        sx: theme.variant,
                        children: title === null || title === void 0 ? void 0 : title.variant
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                        sx: theme.priceWrapper,
                        children: (product === null || product === void 0 ? void 0 : (ref = product.variants) === null || ref === void 0 ? void 0 : ref[0]) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Locale.Variant */.go.Variant, {
                            variant: product.variants[0],
                            sx: theme.price,
                            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Locale.Price */.go.Price, {
                                children: function(param) {
                                    var priceV2 = param.priceV2, compareAtPriceV2 = param.compareAtPriceV2, isOnSale = param.isOnSale;
                                    return isOnSale ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                                        children: [
                                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                                                sx: theme.newPrice,
                                                children: priceV2.locale
                                            }),
                                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                                                sx: theme.compareAtPrice,
                                                children: compareAtPriceV2.locale
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                                        children: priceV2.locale
                                    });
                                }
                            })
                        })
                    }),
                    product && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(UpsellAddToCart/* UpsellAddToCart */.D, {
                        product: product,
                        selectedVariant: product === null || product === void 0 ? void 0 : (ref1 = product.variants) === null || ref1 === void 0 ? void 0 : ref1[0]
                    })
                ]
            })
        ]
    });
});
UpsellSliderItem.displayName = "CartUpsellSliderItem";

;// CONCATENATED MODULE: ./src/snippets/Cart/Upsell/SliderItem/index.js


;// CONCATENATED MODULE: ./src/snippets/Cart/Upsell/Upsell.theme.js

var Upsell_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        py: 3,
        px: 3
    };
    this.heading = {
        variant: "text.h6",
        fontSize: "10px",
        fontWeight: 600,
        letterSpacing: 0,
        textAlign: "center",
        mb: 5
    };
    this.slider = {
        position: "relative",
        border: function(t) {
            return "1px solid ".concat(t.colors.gray);
        },
        cursor: "grab"
    };
}());

;// CONCATENATED MODULE: ./src/snippets/Cart/Upsell/UpsellSlider.jsx








core_class/* default.use */.Z.use([
    a11y/* default */.Z
]);
var UpsellSlider = Upsell_theme_themed(function(param) {
    var theme = param.theme, products = param.products, swiper = param.swiper, setSwiper = param.setSwiper;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": UpsellSlider.displayName,
        sx: theme.slider,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(react_swiper/* Swiper */.t, {
                onSwiper: function(_swiper) {
                    setSwiper(_swiper);
                },
                spaceBetween: 0,
                slidesPerView: 1,
                slidesOffsetBefore: 0,
                slidesOffsetAfter: 0,
                a11y: {
                    enabled: true
                },
                loop: (products === null || products === void 0 ? void 0 : products.length) > 1,
                children: products === null || products === void 0 ? void 0 : products.map(function(param, index) {
                    var handle = param.handle;
                    if (!handle) return null;
                    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(swiper_slide/* SwiperSlide */.o, {
                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(UpsellSliderItem, {
                            handle: handle
                        })
                    }, index);
                })
            }),
            (products === null || products === void 0 ? void 0 : products.length) > 1 && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Navigation/* Navigation */.W, {
                swiper: swiper
            })
        ]
    });
});
UpsellSlider.displayName = "CartUpsellSlider";

;// CONCATENATED MODULE: ./src/snippets/Cart/Upsell/useUpsell.js




var useUpsell = function() {
    var products = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        products: []
    }).products;
    var ref, ref1;
    var settings = (0,dist.useSettings)();
    var upsellEnabled = settings === null || settings === void 0 ? void 0 : (ref = settings.cart) === null || ref === void 0 ? void 0 : (ref1 = ref.upsell) === null || ref1 === void 0 ? void 0 : ref1.enabled;
    var cartItems = (0,dist.useCartItems)();
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* default.upsellProductsNotInCart */.ZP.upsellProductsNotInCart), 2), upsellProductsNotInCart = ref2[0], setUpsellProductsNotInCart = ref2[1];
    var cartItemsStr = upsellEnabled ? cartItems === null || cartItems === void 0 ? void 0 : cartItems.map(function(item, index) {
        return item.id + index;
    }).join() : null;
    (0,react.useEffect)(function() {
        if (!upsellEnabled || !(products === null || products === void 0 ? void 0 : products.length)) return;
        var productsNotInCart;
        if (!(cartItems === null || cartItems === void 0 ? void 0 : cartItems.length)) {
            productsNotInCart = products;
        } else {
            productsNotInCart = products.filter(function(product) {
                var inCart = cartItems.some(function(item) {
                    return item.variant.product.handle === product.handle;
                });
                return !inCart;
            });
        }
        setUpsellProductsNotInCart(productsNotInCart);
    }, [
        upsellEnabled,
        cartItemsStr,
        products
    ]);
    return {
        upsellProductsNotInCart: upsellProductsNotInCart
    };
};

;// CONCATENATED MODULE: ./src/snippets/Cart/Upsell/Upsell.jsx












var Upsell = Upsell_theme_themed(function(_param) {
    var theme = _param.theme, inSidebar = _param.inSidebar, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme",
        "inSidebar"
    ]);
    var ref;
    var upsellRef = (0,react.useRef)(null);
    var cartEmpty = (0,dist.useCartEmpty)();
    var settings = (0,dist.useSettings)();
    var upsell = (settings === null || settings === void 0 ? void 0 : (ref = settings.cart) === null || ref === void 0 ? void 0 : ref.upsell) || {};
    var enabled = upsell.enabled, message = upsell.message, messageEmpty = upsell.messageEmpty, limit = upsell.limit;
    var ref1 = (0,react.useState)(null), visibleProduct = ref1[0], setVisibleProduct = ref1[1];
    var ref2 = (0,react.useState)(null), swiper = ref2[0], setSwiper = ref2[1];
    var activeIndex = (swiper === null || swiper === void 0 ? void 0 : swiper.realIndex) || 0;
    var ref3 = (0,hooks/* useProductRecommendations */.$t)({
        tag: "view-cart",
        limit: limit
    }), recommendations = ref3.recommendations, profileData = ref3.profileData, profileTag = ref3.profileTag;
    var sendBeaconEventsOnClick = useUpsellBeacon({
        profileData: profileData,
        profileTag: profileTag,
        visibleProduct: visibleProduct
    }).sendBeaconEventsOnClick;
    var upsellProductsNotInCart = useUpsell({
        products: recommendations
    }).upsellProductsNotInCart;
    var setVisibleProductOnSlideChange = (0,react.useCallback)(function() {
        var ref;
        if (!(profileData === null || profileData === void 0 ? void 0 : (ref = profileData.results) === null || ref === void 0 ? void 0 : ref.length) || !(upsellProductsNotInCart === null || upsellProductsNotInCart === void 0 ? void 0 : upsellProductsNotInCart.length)) return;
        var product = profileData.results.find(function(result) {
            var ref, ref1;
            return (result === null || result === void 0 ? void 0 : (ref = result.attributes) === null || ref === void 0 ? void 0 : ref.handle) === (upsellProductsNotInCart === null || upsellProductsNotInCart === void 0 ? void 0 : (ref1 = upsellProductsNotInCart[activeIndex]) === null || ref1 === void 0 ? void 0 : ref1.handle);
        });
        setVisibleProduct(product);
    }, [
        upsellProductsNotInCart,
        profileData === null || profileData === void 0 ? void 0 : profileData.results,
        activeIndex
    ]);
    (0,react.useEffect)(function() {
        setVisibleProductOnSlideChange();
    }, [
        upsellProductsNotInCart,
        profileData === null || profileData === void 0 ? void 0 : profileData.results,
        activeIndex
    ]);
    return enabled && (upsellProductsNotInCart === null || upsellProductsNotInCart === void 0 ? void 0 : upsellProductsNotInCart.length) ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-comp": Upsell.displayName,
        ref: upsellRef,
        onClick: sendBeaconEventsOnClick
    }, props), {
        sx: (0,_object_spread/* default */.Z)({}, theme.wrapper, props.sx),
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                as: "h6",
                sx: theme.heading,
                children: cartEmpty ? messageEmpty : message
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(UpsellSlider, {
                swiper: swiper,
                setSwiper: setSwiper,
                products: upsellProductsNotInCart,
                profileData: profileData
            })
        ]
    })) : null;
});
Upsell.displayName = "CartUpsell";

;// CONCATENATED MODULE: ./src/snippets/Cart/Upsell/index.js


;// CONCATENATED MODULE: ./src/snippets/Cart/useCartIntelliSuggest.js



function useCartIntelliSuggest() {
    var route = (0,dist.useRouter)().route;
    var cart = (0,dist.useCart)();
    var shopperId = (0,store/* useRecoilValue */.sJ)(store/* default.shopperId */.ZP.shopperId);
    var ref = (0,react.useState)(false), mounted = ref[0], setMounted = ref[1];
    var cartItems = cart === null || cart === void 0 ? void 0 : cart.lines;
    var setMountAfterDelayForCustomerId = (0,react.useCallback)(function() {
        setTimeout(function() {
            setMounted(true);
        }, 3000);
    }, []);
    var sendIntelliSuggestEventOnMountOrCartChange = (0,react.useCallback)(function() {
        try {
            if (!(cart === null || cart === void 0 ? void 0 : cart.updatedAt) || !mounted || !window.IntelliSuggest) return;
            var skus = JSON.stringify((cartItems === null || cartItems === void 0 ? void 0 : cartItems.map(function(item) {
                return item.variant.sku;
            })) || []);
            IntelliSuggest.init({
                siteId: "nr3jmv",
                context: "Basket",
                seed: skus
            });
            if (shopperId) {
                IntelliSuggest.setShopperId(shopperId);
            }
            cartItems === null || cartItems === void 0 ? void 0 : cartItems.forEach(function(item) {
                IntelliSuggest.haveItem({
                    sku: item.variant.sku,
                    qty: item.quantity,
                    price: (item.estimatedCost.subtotalAmount.amount / item.quantity).toFixed(2)
                });
            });
            IntelliSuggest.inBasket({});
        } catch (error) {
            console.error(error.message);
        }
    }, [
        cart === null || cart === void 0 ? void 0 : cart.updatedAt,
        mounted,
        shopperId
    ]);
    var clearProductSkuInWindowOnNonProductPage = (0,react.useCallback)(function() {
        if (!route || route.startsWith("/product")) return;
        if (window.__brumate_product_sku) {
            window.__brumate_product_sku = null;
        }
    }, [
        route
    ]);
    (0,react.useEffect)(function() {
        setMountAfterDelayForCustomerId();
    }, []);
    (0,react.useEffect)(function() {
        sendIntelliSuggestEventOnMountOrCartChange();
    }, [
        cart === null || cart === void 0 ? void 0 : cart.updatedAt,
        mounted
    ]);
    (0,react.useEffect)(function() {
        clearProductSkuInWindowOnNonProductPage();
    }, [
        route
    ]);
}

;// CONCATENATED MODULE: ./src/snippets/Cart/useCartRejectDiscount.js





var useCartRejectDiscount = function() {
    var cart = (0,dist.useCart)();
    var cartRemoveDiscount = (0,dist.useCartRemoveDiscount)().cartRemoveDiscount;
    var ref = (0,react.useState)(true), showDiscountInput = ref[0], setShowDiscountInput = ref[1];
    var discountCodes = (0,react.useMemo)(function() {
        return ((cart === null || cart === void 0 ? void 0 : cart.discountCodes) || []).reduce(function(acc, discount) {
            var ref, ref1;
            if ((discount === null || discount === void 0 ? void 0 : discount.applicable) && ((ref1 = discount === null || discount === void 0 ? void 0 : (ref = discount.code) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === null || ref1 === void 0 ? void 0 : ref1.startsWith("app"))) {
                return (0,_to_consumable_array/* default */.Z)(acc).concat([
                    discount.code
                ]);
            }
            return acc;
        }, []);
    }, [
        cart === null || cart === void 0 ? void 0 : cart.updatedAt
    ]);
    var removeDiscounts = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setShowDiscountInput(false);
                        return [
                            4,
                            cartRemoveDiscount()
                        ];
                    case 1:
                        _state.sent();
                        setShowDiscountInput(true);
                        return [
                            2
                        ];
                }
            });
        });
        return function removeDiscounts() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (discountCodes === null || discountCodes === void 0 ? void 0 : discountCodes.length) {
            removeDiscounts();
        }
    }, [
        discountCodes
    ]);
    return {
        showDiscountInput: showDiscountInput
    };
};

;// CONCATENATED MODULE: ./src/snippets/Cart/useCartCount.js


var useCartCount = function() {
    var cartCount = (0,dist.useCartCount)();
    var cart = (0,dist.useCart)();
    var cartCountWithoutCharge = (0,react.useMemo)(function() {
        var ref;
        return cart === null || cart === void 0 ? void 0 : (ref = cart.lines) === null || ref === void 0 ? void 0 : ref.reduce(function(acc, lineItem) {
            var jtbAttr = ((lineItem === null || lineItem === void 0 ? void 0 : lineItem.attributes) || []).find(function(attr) {
                var ref;
                return (attr === null || attr === void 0 ? void 0 : attr.key) === "recipe_id" && (attr === null || attr === void 0 ? void 0 : (ref = attr.value) === null || ref === void 0 ? void 0 : ref.startsWith("uc-"));
            });
            if (jtbAttr) {
                return acc - lineItem.quantity;
            }
            return acc;
        }, cartCount);
    }, [
        cart === null || cart === void 0 ? void 0 : cart.lines,
        cartCount
    ]);
    return cartCountWithoutCharge;
};
useCartCount.displayName = "useCartCount";

;// CONCATENATED MODULE: ./src/snippets/Cart/index.js











/***/ }),

/***/ 45158:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ themed; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70169);
/* harmony import */ var _theme_create__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73355);



var themed = (0,_theme_create__WEBPACK_IMPORTED_MODULE_0__/* .create */ .U)(new function() {
    this.buttonPrev = {
        position: "absolute",
        transform: "translateY(-50%)",
        zIndex: 1,
        top: [
            19,
            21
        ],
        left: [
            8,
            10,
            17
        ],
        right: "auto",
        transition: "opacity 0.2s ease-in-out",
        width: [
            "44px",
            null,
            null,
            "56px"
        ],
        height: [
            "44px",
            null,
            null,
            "56px"
        ],
        borderRadius: "50%",
        bg: "background",
        borderStyle: "solid",
        borderWidth: "1px",
        borderColor: "gray",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        boxShadow: "0px 3px 25px rgba(0,0,0,0.2)"
    };
    this.buttonNext = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, this.buttonPrev), {
        left: "auto",
        right: [
            8,
            10,
            17
        ]
    });
    this.icon = {
        width: "24px",
        userSelect: "none",
        pointerEvents: "none"
    };
}());


/***/ }),

/***/ 34086:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ NavigationButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70169);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31373);
/* harmony import */ var theme_ui_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70863);
/* harmony import */ var theme_ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62680);
/* harmony import */ var _snippets__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81234);
/* harmony import */ var _Navigation_theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45158);







var NavigationButton = (0,_Navigation_theme__WEBPACK_IMPORTED_MODULE_2__/* .themed */ .H)(function(_param) {
    var theme = _param.theme, customCss = _param.customCss, _src = _param.src, src = _src === void 0 ? "/svgs/arrow-left.svg#arrow-left" : _src, _alt = _param.alt, alt = _alt === void 0 ? "Previous product" : _alt, _isNext = _param.isNext, isNext = _isNext === void 0 ? false : _isNext, _count = _param.count, count = _count === void 0 ? true : _count, inactive = _param.inactive, inputRef = _param.inputRef, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "theme",
        "customCss",
        "src",
        "alt",
        "isNext",
        "count",
        "inactive",
        "inputRef"
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(theme_ui__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .zx, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        role: "button",
        "data-comp": NavigationButton.displayName,
        disabled: inactive
    }, props), {
        variant: "buttons.plain",
        sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, isNext ? theme.buttonNext : theme.buttonPrev), {
            opacity: inactive ? 0.5 : 1,
            display: count ? "flex" : "none"
        }), props.sx),
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_snippets__WEBPACK_IMPORTED_MODULE_1__/* .Svg */ .ny, {
            alt: alt,
            src: src,
            viewBox: "0 0 24 24",
            draggable: false,
            sx: theme.icon
        })
    }));
});
NavigationButton.displayName = "NavigationButton";


/***/ }),

/***/ 65207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ useProductSwiperParams; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);

var useProductSwiperParams = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        isProductRecs: false,
        loopEnabled: false,
        count: true
    }, isProductRecs = ref.isProductRecs, loopEnabled = ref.loopEnabled, count = ref.count;
    var productRecsParams = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return {
            centerInsufficientSlides: !loopEnabled,
            centeredSlidesBounds: !loopEnabled,
            centeredSlides: true,
            spaceBetween: 16,
            slidesPerView: 1.5,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 16,
            slidesPerGroup: 1,
            autoHeight: false,
            navigation: true,
            loop: count ? loopEnabled : false,
            watchOverflow: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            breakpoints: {
                768: {
                    spaceBetween: 20,
                    slidesPerView: 2,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0,
                    slidesPerGroup: 1
                },
                1024: {
                    spaceBetween: 20,
                    slidesPerView: 3,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0,
                    slidesPerGroup: 1
                },
                1280: {
                    spaceBetween: 20,
                    slidesPerView: 4,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0,
                    slidesPerGroup: 1
                }
            }
        };
    }, [
        loopEnabled,
        count
    ]);
    var productCarouselParams = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return {
            centerInsufficientSlides: !loopEnabled,
            centeredSlidesBounds: !loopEnabled,
            centeredSlides: true,
            spaceBetween: 16,
            slidesPerView: 1.5,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 16,
            slidesPerGroup: 1,
            autoHeight: false,
            navigation: true,
            loop: count ? loopEnabled : false,
            watchOverflow: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            breakpoints: {
                768: {
                    spaceBetween: 20,
                    slidesPerView: 2,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0,
                    slidesPerGroup: 1
                },
                1024: {
                    spaceBetween: 20,
                    slidesPerView: 3,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0,
                    slidesPerGroup: 1
                },
                1280: {
                    spaceBetween: 20,
                    slidesPerView: 4,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0,
                    slidesPerGroup: 1
                }
            }
        };
    }, [
        loopEnabled,
        count
    ]);
    return isProductRecs ? productRecsParams : productCarouselParams;
};


/***/ }),

/***/ 65793:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "d$": function() { return /* reexport */ DesktopFilters; },
  "z": function() { return /* reexport */ MobileFilters; },
  "Sr": function() { return /* reexport */ useSearchFilters/* useSearchFilters */.S; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(52050);
// EXTERNAL MODULE: ../node_modules/theme-ui/jsx-runtime/dist/theme-ui-jsx-runtime.esm.js + 2 modules
var theme_ui_jsx_runtime_esm = __webpack_require__(70863);
// EXTERNAL MODULE: ../node_modules/@theme-ui/components/dist/theme-ui-components.esm.js
var theme_ui_components_esm = __webpack_require__(62680);
// EXTERNAL MODULE: ./src/snippets/index.js + 352 modules
var snippets = __webpack_require__(81234);
// EXTERNAL MODULE: ./src/snippets/Search/SearchPage/Filters/useSearchFilters.js
var useSearchFilters = __webpack_require__(37283);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(31373);
// EXTERNAL MODULE: ./src/theme/create.jsx
var create = __webpack_require__(73355);
;// CONCATENATED MODULE: ./src/snippets/Search/SearchPage/Filters/Filters.theme.js

var themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        mt: 10,
        px: [
            8,
            0
        ]
    };
    this.filtersRow = {
        flexWrap: "wrap",
        gap: 4
    };
    this.filter = {
        height: "32px",
        position: "relative",
        borderRadius: "16px",
        py: 2,
        pr: 6,
        pl: 4,
        overflow: "hidden",
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        maxWidth: "200px",
        border: function(t) {
            return "1px solid ".concat(t.colors.mediumDarkGray);
        },
        transition: "all 0.15s ease-in-out",
        ":hover": {
            borderColor: "text",
            '[data-comp="Close"]': {
                opacity: 1
            }
        }
    };
    this.close = {
        transition: "all 0.15s ease-in-out",
        color: "text",
        opacity: 0.4,
        width: "12px",
        mr: 1
    };
    this.filterValue = {
        textAlign: "left",
        fontSize: 3,
        flex: 1,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    };
    this.clearAll = {
        mt: 10
    };
}());

;// CONCATENATED MODULE: ./src/snippets/Search/SearchPage/Filters/CurrentFilters.jsx









var CurrentFilters = themed(function(_param) {
    var theme = _param.theme, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme"
    ]);
    var ref = (0,_sliced_to_array/* default */.Z)((0,useSearchFilters/* useSearchFilters */.S)(), 2), filterSummary = ref[0].filterSummary, ref1 = ref[1], removeFromSelectedFilters = ref1.removeFromSelectedFilters, clearSelectedFilters = ref1.clearSelectedFilters;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": CurrentFilters.displayName,
        sx: (0,_object_spread/* default */.Z)({}, theme.wrapper, props.sx),
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                sx: theme.filtersRow,
                children: filterSummary === null || filterSummary === void 0 ? void 0 : filterSummary.map(function(filter) {
                    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Button */.zx, {
                        variant: "buttons.plain",
                        "aria-label": "Remove ".concat(filter.filterLabel, " ").concat(filter.filterValue, " from filters"),
                        onClick: function() {
                            var value = filter.value;
                            removeFromSelectedFilters({
                                field: filter.field,
                                option: typeof value === "object" ? {
                                    type: "range",
                                    low: value.rangeLow,
                                    high: value.rangeHigh
                                } : {
                                    type: "value",
                                    value: value
                                }
                            });
                        },
                        sx: theme.filter,
                        children: [
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Svg */.ny, {
                                alt: "Close",
                                src: "/svgs/close.svg#close",
                                viewBox: "0 0 48 48",
                                "data-comp": "Close",
                                sx: theme.close
                            }),
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                                sx: theme.filterValue,
                                children: filter.filterValue
                            })
                        ]
                    }, filter.field + filter.value);
                })
            }),
            (filterSummary === null || filterSummary === void 0 ? void 0 : filterSummary.length) > 0 && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                variant: "buttons.link.1",
                onClick: clearSelectedFilters,
                "aria-label": "Clear all filters",
                sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.clearAll), {
                    display: (filterSummary === null || filterSummary === void 0 ? void 0 : filterSummary.length) > 0 ? "block" : "none"
                }),
                children: "Clear All"
            })
        ]
    });
});
CurrentFilters.displayName = "CurrentFilters";

;// CONCATENATED MODULE: ./src/snippets/Search/SearchPage/Filters/DesktopFilters/DesktopFilters.theme.js

var DesktopFilters_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        display: [
            "none",
            "block"
        ],
        mt: "64px"
    };
    this.heading = {
        variant: "text.h2",
        mb: "28px",
        overflowWrap: "break-word"
    };
    this.accordionHeader = {
        heading: {
            variant: "text.label.1",
            display: "inline-block"
        },
        selected: {
            variant: "text.base",
            textTransform: "none",
            display: "inline",
            color: "mediumDarkGray",
            ml: 4
        }
    };
    this.clearButton = {
        mt: 10
    };
}());

;// CONCATENATED MODULE: ./src/snippets/Search/SearchPage/Filters/DesktopFilters/DesktopFilters.jsx







var DesktopFilters = DesktopFilters_theme_themed(function(param) {
    var theme = param.theme, merchandising = param.merchandising;
    var ref, ref1;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useSearchFilters/* useSearchFilters */.S)(), 2), filters = ref2[0].filters, ref3 = ref2[1], addToSelectedFilters = ref3.addToSelectedFilters, removeFromSelectedFilters = ref3.removeFromSelectedFilters;
    var left = merchandising === null || merchandising === void 0 ? void 0 : (ref = merchandising.content) === null || ref === void 0 ? void 0 : (ref1 = ref.left) === null || ref1 === void 0 ? void 0 : ref1[0];
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": DesktopFilters.displayName,
        sx: theme.wrapper,
        children: [
            (filters === null || filters === void 0 ? void 0 : filters.length) > 0 && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Accordions */.FV, {
                textColor: "text",
                borderColor: "gray",
                iconColor: "text",
                minHeight: "52px",
                maxHeight: "800px",
                oneOpenAtATime: false,
                children: filters.map(function(filter) {
                    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(snippets/* Accordion */.UQ, {
                        collapsed: !!filter.collapse,
                        children: [
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Accordion.Header */.UQ.Header, {
                                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                                    variant: "flex.row.start.center",
                                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                                        as: "h5",
                                        sx: theme.accordionHeader.heading,
                                        children: filter.label
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Accordion.Body */.UQ.Body, {
                                children: function(param) {
                                    var isOpen = param.isOpen;
                                    var ref;
                                    return (ref = filter.values) === null || ref === void 0 ? void 0 : ref.map(function(option) {
                                        return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                                            as: "li",
                                            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* FilterOption */.f2, {
                                                option: option,
                                                field: filter.field,
                                                tabIndex: isOpen ? "0" : "-1",
                                                "aria-hidden": isOpen ? "false" : "true",
                                                addToSelectedFilters: addToSelectedFilters,
                                                removeFromSelectedFilters: removeFromSelectedFilters
                                            })
                                        }, option.label);
                                    });
                                }
                            })
                        ]
                    }, filter.label);
                })
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(CurrentFilters, {}),
            left && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                dangerouslySetInnerHTML: {
                    __html: left
                },
                sx: {
                    mt: 12,
                    display: [
                        "none",
                        "block"
                    ]
                }
            })
        ]
    });
});
DesktopFilters.displayName = "DesktopFilters";

;// CONCATENATED MODULE: ./src/snippets/Search/SearchPage/Filters/DesktopFilters/index.js


// EXTERNAL MODULE: ./src/hooks/index.js + 64 modules
var hooks = __webpack_require__(74424);
;// CONCATENATED MODULE: ./src/snippets/Search/SearchPage/Filters/MobileFilters/MobileFilters.theme.js

var MobileFilters_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        display: [
            "block",
            "none"
        ]
    };
    this.grid = {
        gridTemplateColumns: "1fr",
        gridGap: 0,
        borderTop: function(t) {
            return "1px solid ".concat(t.colors.gray);
        }
    };
    this.button = {
        width: "100%",
        display: "flex",
        alignItems: "center",
        textAlign: "left",
        position: "relative",
        height: "52px",
        p: 8,
        borderTop: function(t) {
            return "1px solid ".concat(t.colors.gray);
        },
        borderBottom: function(t) {
            return "1px solid ".concat(t.colors.gray);
        }
    };
    this.title = {
        variant: "text.label.1",
        display: "inline-block"
    };
    this.selectedSort = {
        fontSize: 3,
        color: "mediumDarkGray",
        ml: 4
    };
    this.icon = {
        position: "absolute",
        right: 8,
        top: "50%",
        width: "24px",
        height: "24px",
        transform: "translateY(-50%)"
    };
}());

;// CONCATENATED MODULE: ./src/snippets/Search/SearchPage/Filters/MobileFilters/MobileFilters.jsx







var MobileFilters = MobileFilters_theme_themed(function(param) {
    var theme = param.theme;
    var ref = (0,_sliced_to_array/* default */.Z)((0,hooks/* useFiltersSidebar */.JE)(), 2), toggleFiltersSidebar = ref[1].toggleFiltersSidebar;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": MobileFilters.displayName,
        sx: theme.wrapper,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Button */.zx, {
                variant: "buttons.plain",
                onClick: function() {
                    return toggleFiltersSidebar({
                        label: "Filter & Sort",
                        isFiltersAndSort: true,
                        isSearchPage: true
                    });
                },
                sx: theme.button,
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                        as: "h5",
                        sx: theme.title,
                        children: "Filter & Sort"
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Svg */.ny, {
                        viewBox: "0 0 24 24",
                        src: "/svgs/arrow-right.svg#arrow-right",
                        sx: theme.icon
                    })
                ]
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(CurrentFilters, {})
        ]
    });
});
MobileFilters.displayName = "MobileFilters";

;// CONCATENATED MODULE: ./src/snippets/Search/SearchPage/Filters/MobileFilters/index.js


;// CONCATENATED MODULE: ./src/snippets/Search/SearchPage/Filters/index.js





/***/ }),

/***/ 37283:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ useSearchFilters; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17599);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52050);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27695);





var useSearchFilters = function() {
    var ref;
    var searchPageData = (0,_store__WEBPACK_IMPORTED_MODULE_1__/* .useRecoilValue */ .sJ)(_store__WEBPACK_IMPORTED_MODULE_1__/* ["default"].searchPageData */ .ZP.searchPageData);
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_store__WEBPACK_IMPORTED_MODULE_1__/* .useRecoilState */ .FV)(_store__WEBPACK_IMPORTED_MODULE_1__/* ["default"].searchSelectedFilters */ .ZP.searchSelectedFilters), 2), selectedFilters = ref1[0], setSelectedFilters = ref1[1];
    var setCurrentResultsPage = (0,_store__WEBPACK_IMPORTED_MODULE_1__/* .useSetRecoilState */ .Zl)(_store__WEBPACK_IMPORTED_MODULE_1__/* ["default"].searchCurrentResultsPage */ .ZP.searchCurrentResultsPage);
    var selectedFiltersDep = JSON.stringify(selectedFilters);
    var totalResults = (searchPageData === null || searchPageData === void 0 ? void 0 : (ref = searchPageData.pagination) === null || ref === void 0 ? void 0 : ref.totalResults) || 0;
    var filters = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        var ref;
        if (!totalResults || !(searchPageData === null || searchPageData === void 0 ? void 0 : (ref = searchPageData.facets) === null || ref === void 0 ? void 0 : ref.length)) return null;
        return searchPageData.facets.filter(function(facet) {
            if (facet.values.length === 1 && facet.values[0].count === totalResults) {
                return false;
            }
            return true;
        });
    }, [
        searchPageData === null || searchPageData === void 0 ? void 0 : searchPageData.facets,
        totalResults
    ]);
    // get filter entries based on type
    var getFilterEntries = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(param) {
        var field = param.field, option = param.option;
        var _filters = {};
        // if option type is range, separate into low and high entries
        if (option.type === "range") {
            var ref = [
                "filter.".concat(field, ".low"),
                option.low
            ], key1 = ref[0], value1 = ref[1];
            var ref1 = [
                "filter.".concat(field, ".high"),
                option.high
            ], key2 = ref1[0], value2 = ref1[1];
            var _obj;
            _filters = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, "".concat(key1, ".").concat(value1), {
                key: key1,
                value: value1
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, "".concat(key2, ".").concat(value2), {
                key: key2,
                value: value2
            }), _obj);
        } else {
            var ref2 = [
                "filter.".concat(field),
                option.value || ""
            ], key = ref2[0], value = ref2[1];
            _filters = (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, "".concat(key, ".").concat(value), {
                key: key,
                value: value
            });
        }
        return _filters;
    }, []);
    // add to filters using filterOptions
    var addToSelectedFilters = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(param) {
        var field = param.field, option = param.option;
        if (!field || !option) {
            return console.error("addToSelectedFilters: missing field or option");
        }
        // Example ss field: 'product_type'
        // Example ss option: { active: false, type: 'value', value: 'Shirts' ... }
        // create map of previous selected filters
        var selectedFiltersMap = selectedFilters === null || selectedFilters === void 0 ? void 0 : selectedFilters.reduce(function(obj, filter) {
            obj["".concat(filter.key, ".").concat(filter.value)] = filter;
            return obj;
        }, {});
        // prevent duplicates by spreading previous and new filters into new map
        var newSelectedFiltersMap = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, selectedFiltersMap, getFilterEntries({
            field: field,
            option: option
        }));
        // convert filters map back into array
        var newSelectedFilters = Object.values(newSelectedFiltersMap);
        setSelectedFilters(newSelectedFilters);
        setCurrentResultsPage(1);
    }, [
        selectedFiltersDep
    ]);
    // remove from selected filters
    var removeFromSelectedFilters = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(param) {
        var field = param.field, option = param.option;
        if (!field || !option) {
            return console.error("removeFromSelectedFilters: missing field or option");
        }
        // Example ss field / option: 'collection_name', { value: 'Shirts', type: 'value }
        // Example ss field / option w/ range: 'ss_price', { high: '80', low: '60', type: 'range }
        if (!(selectedFilters === null || selectedFilters === void 0 ? void 0 : selectedFilters.length)) return null;
        // filter out filters that match the field and option
        var newSelectedFilters = selectedFilters.filter(function(filter) {
            if (option.type === "range") {
                var isEntryLow = filter.key === "filter.".concat(field, ".low") && filter.value === option.low;
                var isEntryHigh = filter.key === "filter.".concat(field, ".high") && filter.value === option.high;
                return !isEntryLow && !isEntryHigh;
            }
            var isEntry = filter.key === "filter.".concat(field) && filter.value === option.value;
            return !isEntry;
        });
        setSelectedFilters(newSelectedFilters);
        setCurrentResultsPage(1);
    }, [
        selectedFiltersDep
    ]);
    // clear filters
    var clearSelectedFilters = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        setSelectedFilters(null);
        setCurrentResultsPage(1);
    }, []);
    return [
        // state
        {
            selectedFilters: selectedFilters,
            filters: filters,
            filterSummary: (searchPageData === null || searchPageData === void 0 ? void 0 : searchPageData.filterSummary) || null
        },
        // actions
        {
            addToSelectedFilters: addToSelectedFilters,
            removeFromSelectedFilters: removeFromSelectedFilters,
            clearSelectedFilters: clearSelectedFilters
        }, 
    ];
};


/***/ }),

/***/ 24239:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P": function() { return /* reexport */ Sort; },
  "q": function() { return /* reexport */ useSearchSort; }
});

// EXTERNAL MODULE: ../node_modules/theme-ui/jsx-runtime/dist/theme-ui-jsx-runtime.esm.js + 2 modules
var theme_ui_jsx_runtime_esm = __webpack_require__(70863);
// EXTERNAL MODULE: ../node_modules/@theme-ui/components/dist/theme-ui-components.esm.js
var theme_ui_components_esm = __webpack_require__(62680);
// EXTERNAL MODULE: ./src/theme/create.jsx
var create = __webpack_require__(73355);
;// CONCATENATED MODULE: ./src/snippets/Search/SearchPage/Sort/Sort.theme.js

var themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        minHeight: "34px",
        mb: 10,
        display: [
            "none",
            "flex"
        ]
    };
    this.dropdown = {
        width: [
            "100%",
            "210px"
        ],
        "[data-comp=DropdownDrawer]": {
            borderColor: "gray"
        }
    };
    this.selected = {
        width: "100%",
        p: 8,
        borderColor: "gray",
        bg: "background",
        transition: "all 0.2s ease-in-out",
        borderRadius: [
            0,
            "22px"
        ],
        borderLeftStyle: [
            "none",
            "solid"
        ],
        borderRightStyle: [
            "none",
            "solid"
        ],
        ":hover": {
            borderColor: [
                "gray",
                "mediumDarkGray"
            ]
        },
        content: {
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%"
        },
        title: {
            variant: "text.label.1"
        },
        icon: {
            transition: "transform 0.2s ease-in-out",
            width: "20px"
        }
    };
    this.option = {
        width: "100%",
        px: 8,
        title: {
            variant: "text.base",
            fontSize: 2,
            lineHeight: 20,
            width: "100%",
            ":hover": {
                fontWeight: 500
            }
        }
    };
}());

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(52050);
// EXTERNAL MODULE: ./src/snippets/index.js + 352 modules
var snippets = __webpack_require__(81234);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(23842);
// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(59312);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ./src/store/index.js + 12 modules
var store = __webpack_require__(27695);
;// CONCATENATED MODULE: ./src/snippets/Search/SearchPage/Sort/useSearchSort.js





var useSearchSort = function() {
    var ref;
    var searchPageData = (0,store/* useRecoilValue */.sJ)(store/* default.searchPageData */.ZP.searchPageData);
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* default.searchSelectedSort */.ZP.searchSelectedSort), 2), selectedSort = ref1[0], setSelectedSort = ref1[1];
    var sortCollection = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var field, direction;
            return (0,tslib_es6.__generator)(this, function(_state) {
                field = param.field, direction = param.direction;
                if (!field || !direction) {
                    // clear sort
                    setSelectedSort(null);
                    return [
                        2
                    ];
                }
                // Examples
                // { field: 'ss_price', direction: 'asc' },
                // { field: 'title', direction: 'desc' }
                // { field: 'ss_days_since_published', direction: 'asc' }
                setSelectedSort({
                    field: field,
                    direction: direction
                });
                return [
                    2
                ];
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    return [
        // state
        {
            selectedSort: selectedSort,
            sortOptions: (searchPageData === null || searchPageData === void 0 ? void 0 : (ref = searchPageData.sorting) === null || ref === void 0 ? void 0 : ref.options) || null
        },
        // actions
        {
            sortCollection: sortCollection
        }, 
    ];
};

;// CONCATENATED MODULE: ./src/snippets/Search/SearchPage/Sort/SortDropdown.jsx








var SortDropdown = themed(function(param) {
    var theme = param.theme;
    var ref = (0,_sliced_to_array/* default */.Z)(useSearchSort(), 2), sortOptions = ref[0].sortOptions, sortCollection = ref[1].sortCollection;
    return (sortOptions === null || sortOptions === void 0 ? void 0 : sortOptions.length) ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(snippets/* Dropdown */.Lt, {
        "data-comp": SortDropdown.displayName,
        initial: "",
        onSelected: function(param) {
            var field = param.field, direction = param.direction;
            return sortCollection({
                field: field,
                direction: direction
            });
        },
        sx: theme.dropdown,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Dropdown.Selected */.Lt.Selected, {
                sx: theme.selected,
                children: function(param) {
                    var selecting = param.selecting, selected = param.selected;
                    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                        sx: theme.selected.content,
                        children: [
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                                sx: theme.selected.title,
                                children: selected.label || "Sort By"
                            }),
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Svg */.ny, {
                                alt: "chevron",
                                viewBox: "0 0 16 16",
                                src: "/svgs/chevron/down.svg#down",
                                sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.selected.icon), {
                                    transform: selecting ? "rotate(180deg)" : "rotate(0deg)"
                                })
                            })
                        ]
                    });
                }
            }),
            sortOptions.map(function(item, index) {
                return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Dropdown.Option */.Lt.Option, {
                    option: item,
                    sx: theme.option,
                    children: function(param) {
                        var selecting = param.selecting, isSelected = param.isSelected, option = param.option;
                        return isSelected ? null : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                            sx: theme.option.title,
                            children: option.label
                        });
                    }
                }, index);
            })
        ]
    }) : null;
});
SortDropdown.displayName = "SortDropdown";

;// CONCATENATED MODULE: ./src/snippets/Search/SearchPage/Sort/Sort.jsx




var Sort = themed(function(param) {
    var theme = param.theme;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
        "data-comp": Sort.displayName,
        variant: "flex.row.end",
        sx: theme.wrapper,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(SortDropdown, {})
    });
});
Sort.displayName = "Sort";

;// CONCATENATED MODULE: ./src/snippets/Search/SearchPage/Sort/index.js




/***/ }),

/***/ 62653:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "R": function() { return /* reexport */ useSearch; },
  "d": function() { return /* reexport */ useSearchInput; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(23842);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(52050);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3204);
// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(59312);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/@backpackjs/storefront/dist/index.js
var dist = __webpack_require__(52031);
// EXTERNAL MODULE: ./src/hooks/index.js + 64 modules
var hooks = __webpack_require__(74424);
// EXTERNAL MODULE: ./src/store/index.js + 12 modules
var store = __webpack_require__(27695);
// EXTERNAL MODULE: ./src/utils/index.js + 7 modules
var utils = __webpack_require__(39136);
;// CONCATENATED MODULE: ./src/snippets/Search/hooks/useSearchResults.jsx











var useSearchResults = function() {
    var ref, ref1;
    var requestSearchspring = (0,hooks/* useSearchspring */.JN)().requestSearchspring;
    var hiddenProductHandles = (0,hooks/* usePasswordProtected */.uE)().hiddenProductHandles;
    var customer = (0,dist.useCustomer)();
    var router = (0,dist.useRouter)();
    var cartItems = (0,dist.useCartItems)();
    var lastViewed = utils/* isBrowser */.jU && window.localStorage.getItem("lastViewed") || "";
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* default.searchData */.ZP.searchData), 2), searchData = ref2[0], setSearchData = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* default.searchPageData */.ZP.searchPageData), 2), searchPageData = ref3[0], setSearchPageData = ref3[1];
    var currentResultsPage = (0,store/* useRecoilValue */.sJ)(store/* default.searchCurrentResultsPage */.ZP.searchCurrentResultsPage);
    var selectedSort = (0,store/* useRecoilValue */.sJ)(store/* default.searchSelectedSort */.ZP.searchSelectedSort);
    var customerId = (customer === null || customer === void 0 ? void 0 : customer.id) || "";
    var cart = (cartItems === null || cartItems === void 0 ? void 0 : cartItems.map(function(item) {
        return item.variant.sku;
    }).join(",")) || "";
    var asPath = router.asPath;
    // Get search results from query from ss
    var getSearchResults = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var query, tag, isAutocomplete, isPage, selectedFilters, ref, ref1, ref2, shopper, data, _data, banners, ref3, resultsLength, results, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        query = param.query, tag = param.tag, isAutocomplete = param.isAutocomplete, isPage = param.isPage, selectedFilters = param.selectedFilters;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        if (isPage && !query && !tag) {
                            setSearchPageData(null);
                            return [
                                2,
                                null
                            ];
                        }
                        if (!isPage && !query) {
                            setSearchData(null);
                            return [
                                2,
                                null
                            ];
                        }
                        shopper = (ref = (0,utils/* decodedId */.uP)(customerId)) === null || ref === void 0 ? void 0 : ref.split("/").pop();
                        return [
                            4,
                            requestSearchspring({
                                action: "getSearchResults",
                                params: (0,_object_spread/* default */.Z)({
                                    query: query || "",
                                    resultsPerPage: isPage ? 60 : 10,
                                    page: isPage ? currentResultsPage : 1,
                                    isAutocomplete: isAutocomplete,
                                    domain: "".concat("https://www.brumate.com", "/").concat(asPath === null || asPath === void 0 ? void 0 : asPath.split("?")[0]),
                                    cart: cart,
                                    lastViewed: lastViewed
                                }, isPage && !query && tag ? {
                                    tag: tag
                                } : null, shopper ? {
                                    shopper: shopper
                                } : null, selectedSort ? {
                                    sort: selectedSort
                                } : null, isPage && selectedFilters ? {
                                    filters: selectedFilters
                                } : null)
                            })
                        ];
                    case 2:
                        data = _state.sent();
                        _data = data;
                        banners = data === null || data === void 0 ? void 0 : (ref1 = data.merchandising) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.content) === null || ref2 === void 0 ? void 0 : ref2.inline;
                        if (isPage && (banners === null || banners === void 0 ? void 0 : banners.length)) {
                            ;
                            resultsLength = (ref3 = _data.results) === null || ref3 === void 0 ? void 0 : ref3.length;
                            results = banners.reduce(function(arr, item, index) {
                                var pos = item.config.position.index;
                                if (resultsLength + index <= pos) return arr;
                                return (0,_to_consumable_array/* default */.Z)(arr.slice(0, pos)).concat([
                                    {
                                        isBanner: true,
                                        value: item.value,
                                        id: "banner-index-".concat(index)
                                    }, 
                                ], (0,_to_consumable_array/* default */.Z)(arr.slice(pos)));
                            }, (0,_to_consumable_array/* default */.Z)(_data.results));
                            _data = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, _data), {
                                results: results
                            });
                        }
                        // removes hidden products that are password protected
                        if (hiddenProductHandles) {
                            _data.results = (0,_to_consumable_array/* default */.Z)(_data.results).filter(function(result) {
                                return !hiddenProductHandles.some(function(handle) {
                                    return handle === result.handle;
                                });
                            });
                        }
                        if (isPage) {
                            setSearchPageData(_data || null);
                        } else {
                            setSearchData(_data || null);
                        }
                        return [
                            2,
                            _data || null
                        ];
                    case 3:
                        error = _state.sent();
                        console.error("Error with getSearchResults: ".concat(error.message));
                        throw error;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        customerId,
        asPath,
        cart,
        lastViewed,
        currentResultsPage,
        selectedSort
    ]);
    return {
        results: (searchData === null || searchData === void 0 ? void 0 : searchData.results) || [],
        totalResults: (searchData === null || searchData === void 0 ? void 0 : (ref = searchData.pagination) === null || ref === void 0 ? void 0 : ref.totalResults) || 0,
        pageResults: (searchPageData === null || searchPageData === void 0 ? void 0 : searchPageData.results) || [],
        totalPageResults: (searchPageData === null || searchPageData === void 0 ? void 0 : (ref1 = searchPageData.pagination) === null || ref1 === void 0 ? void 0 : ref1.totalResults) || 0,
        merchandising: (searchData === null || searchData === void 0 ? void 0 : searchData.merchandising) || null,
        getSearchResults: getSearchResults,
        setSearchData: setSearchData,
        setSearchPageData: setSearchPageData
    };
}; // Example data from api
 // {
 //   "pagination": {...},
 //   "sorting": {
 //       "options": [...]
 //   },
 //   "resultLayout": "grid",
 //   "results": [
 //       {
 //           "brand": "Cuts Clothing",
 //           "handle": "merino-crew-sweater-pacific-blue",
 //           "id": "857a83a6620bcd84620c384e5270818c",
 //           "imageUrl": "https://cdn.shopify.com/s/files/1/1368/3463/products/SoldOutTemplateUPDATEDcopy_0c56ee39-683e-4e83-8090-e0a05fafd056_720x.jpg?v=1637021328",
 //           "intellisuggestData": "eJwyNzIpLK5i0M0JyHI2KfQPd0nOikrONK6Kco3wYSguT00sSS0qZvANNjQwMDH0izcxMIkPZjBkMGQwYDBiSC_KTAEEAAD__423Emk",
 //           "intellisuggestSignature": "a6ce27ca96e70d0dd65bf503ae25ff29f21f66fec01f9bdabe74b48553e231c2",
 //           "msrp": "0",
 //           "name": "Merino Crew Sweater | Pacific Blue Signature-fit Merino Wool",
 //           "price": "150",
 //           "product_type_unigram": "wool",
 //           "sku": "MS10041N_404_S",
 //           "ss_available": "1",
 //           "ss_has_image": "1",
 //           "ss_id": "3.965104206652e+13",
 //           "ss_instock_pct": "40",
 //           "ss_inventory_count": "3",
 //           "ss_is_published": "1",
 //           "thumbnailImageUrl": "https://cdn.shopify.com/s/files/1/1368/3463/products/SoldOutTemplateUPDATEDcopy_0c56ee39-683e-4e83-8090-e0a05fafd056_720x.jpg?v=1637021328",
 //           "uid": "6798711226456",
 //           "url": "https://www.cutsclothing.com/products/merino-crew-sweater-pacific-blue"
 //       },
 //       ...
 //   ],
 //   "facets": [...],
 //   "breadcrumbs": [...],
 //   "filterSummary": [...],
 //   "merchandising": {...}
 // }

;// CONCATENATED MODULE: ./src/snippets/Search/hooks/useSearchSuggestions.jsx







var useSearchSuggestions = function() {
    var requestSearchspring = (0,hooks/* useSearchspring */.JN)().requestSearchspring;
    var ref = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* default.searchSuggestions */.ZP.searchSuggestions), 2), suggestions = ref[0], setSuggestions = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* default.searchPageSuggestions */.ZP.searchPageSuggestions), 2), pageSuggestions = ref1[0], setPageSuggestions = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* default.searchSuggested */.ZP.searchSuggested), 2), suggested = ref2[0], setSuggested = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* default.searchPageSuggested */.ZP.searchPageSuggested), 2), pageSuggested = ref3[0], setPageSuggested = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* default.searchSpellCorrection */.ZP.searchSpellCorrection), 2), spellCorrection = ref4[0], setSpellCorrection = ref4[1];
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* default.searchSpellCorrection */.ZP.searchSpellCorrection), 2), pageSpellCorrection = ref5[0], setPageSpellCorrection = ref5[1];
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* default.isAutocomplete */.ZP.isAutocomplete), 2), isAutocomplete = ref6[0], setIsAutocomplete = ref6[1];
    // Get search suggestions based off query from ss
    var getSearchSuggestions = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var query, isPage, ref, ref1, ref2, data, _alternatives, _suggestions, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        query = param.query, isPage = param.isPage;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        if (!query) {
                            setSuggestions([]);
                            setSuggested(null);
                            setIsAutocomplete(false);
                            setSpellCorrection(null);
                            return [
                                2,
                                false
                            ];
                        }
                        if (isPage && !query) {
                            setPageSuggestions([]);
                            setPageSuggested(null);
                            setPageSpellCorrection(null);
                            return [
                                2,
                                false
                            ];
                        }
                        return [
                            4,
                            requestSearchspring({
                                action: "getSearchSuggestions",
                                params: {
                                    query: query
                                }
                            })
                        ];
                    case 2:
                        data = _state.sent();
                        _alternatives = (data === null || data === void 0 ? void 0 : (ref = data.alternatives) === null || ref === void 0 ? void 0 : ref.length) ? data.alternatives.map(function(param) {
                            var text = param.text;
                            return text;
                        }) : [];
                        _suggestions = (0,_to_consumable_array/* default */.Z)((data === null || data === void 0 ? void 0 : (ref1 = data.suggested) === null || ref1 === void 0 ? void 0 : ref1.type) === "completed" ? [
                            data.suggested.text
                        ] : []).concat((0,_to_consumable_array/* default */.Z)(_alternatives));
                        if (isPage) {
                            setPageSuggestions(_suggestions);
                            setPageSuggested((data === null || data === void 0 ? void 0 : data.suggested) || null);
                            setPageSpellCorrection((data === null || data === void 0 ? void 0 : data["corrected-query"]) || null);
                            return [
                                2,
                                data
                            ];
                        }
                        setSuggestions(_suggestions);
                        setSuggested((data === null || data === void 0 ? void 0 : data.suggested) || null);
                        setIsAutocomplete((data === null || data === void 0 ? void 0 : (ref2 = data.suggested) === null || ref2 === void 0 ? void 0 : ref2.type) === "completed" || false);
                        setSpellCorrection((data === null || data === void 0 ? void 0 : data["corrected-query"]) || null);
                        return [
                            2,
                            data
                        ];
                    case 3:
                        error = _state.sent();
                        console.error("Error with getSearchSuggestions: ".concat(error.message));
                        throw error;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    return {
        suggestions: suggestions,
        pageSuggestions: pageSuggestions,
        suggested: suggested,
        getSearchSuggestions: getSearchSuggestions,
        isAutocomplete: isAutocomplete,
        pageSuggested: pageSuggested,
        spellCorrection: spellCorrection,
        pageSpellCorrection: pageSpellCorrection
    };
}; // Example data from api
 // {
 //   "query": "sweat",
 //   "suggested": {
 //       "text": "sweatpant",
 //       "type": "completed",
 //       "completed": [
 //           {
 //               "token": "sweatpant",
 //               "query": "sweat",
 //               "type": "prefix"
 //           }
 //       ],
 //       "source": "name"
 //   },
 //   "alternatives": [
 //       {
 //           "text": "sweater",
 //           "type": "completed",
 //           "completed": [
 //               {
 //                   "token": "sweater",
 //                   "query": "sweat",
 //                   "type": "prefix"
 //               }
 //           ],
 //           "source": "name"
 //       }
 //   ]
 // }

;// CONCATENATED MODULE: ./src/snippets/Search/hooks/useSearchTrending.jsx






var useSearchTrending = function() {
    var requestSearchspring = (0,hooks/* useSearchspring */.JN)().requestSearchspring;
    var ref = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* default.searchTrending */.ZP.searchTrending), 2), trending = ref[0], setTrending = ref[1];
    // Get trending search suggestions from past 90 days from ss
    var getSearchTrending = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var ref, ref1, data, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        requestSearchspring({
                            action: "getSearchTrending"
                        })
                    ];
                case 1:
                    data = _state.sent();
                    setTrending((data === null || data === void 0 ? void 0 : (ref = data.trending) === null || ref === void 0 ? void 0 : (ref1 = ref.queries) === null || ref1 === void 0 ? void 0 : ref1.length) ? data.trending.queries.map(function(param) {
                        var searchQuery = param.searchQuery;
                        return searchQuery;
                    }) : []);
                    return [
                        3,
                        3
                    ];
                case 2:
                    error = _state.sent();
                    console.error("Error with getSearchTrending: ".concat(error.message));
                    throw error;
                case 3:
                    return [
                        2
                    ];
            }
        });
    }), []);
    return {
        trending: trending,
        getSearchTrending: getSearchTrending
    };
}; // Example data from api
 // "trending": {
 //   "queries": [
 //     {
 //         "popularity": 9973,
 //         "searchQuery": "shirts"
 //     },
 //     {
 //         "popularity": 7467,
 //         "searchQuery": "sweaters"
 //     }
 //   ]
 // }

;// CONCATENATED MODULE: ./src/snippets/Search/hooks/useSearch.jsx



var useSearch = function() {
    var ref = useSearchResults(), getSearchResults = ref.getSearchResults, merchandising = ref.merchandising, pageResults = ref.pageResults, results = ref.results, totalPageResults = ref.totalPageResults, totalResults = ref.totalResults, setSearchData = ref.setSearchData, setSearchPageData = ref.setSearchPageData;
    var ref1 = useSearchSuggestions(), getSearchSuggestions = ref1.getSearchSuggestions, isAutocomplete = ref1.isAutocomplete, pageSpellCorrection = ref1.pageSpellCorrection, pageSuggested = ref1.pageSuggested, pageSuggestions = ref1.pageSuggestions, spellCorrection = ref1.spellCorrection, suggested = ref1.suggested, suggestions = ref1.suggestions;
    var ref2 = useSearchTrending(), trending = ref2.trending, getSearchTrending = ref2.getSearchTrending;
    return [
        // state
        {
            isAutocomplete: isAutocomplete,
            merchandising: merchandising,
            pageResults: pageResults,
            pageSpellCorrection: pageSpellCorrection,
            pageSuggested: pageSuggested,
            pageSuggestions: pageSuggestions,
            results: results,
            spellCorrection: spellCorrection,
            suggested: suggested,
            suggestions: suggestions,
            totalPageResults: totalPageResults,
            totalResults: totalResults,
            trending: trending
        },
        // actions
        {
            getSearchResults: getSearchResults,
            getSearchSuggestions: getSearchSuggestions,
            getSearchTrending: getSearchTrending,
            setSearchData: setSearchData,
            setSearchPageData: setSearchPageData
        }, 
    ];
};

;// CONCATENATED MODULE: ./src/snippets/Search/hooks/useSearchInput.js







var useSearchInput = function() {
    var ref = (0,_sliced_to_array/* default */.Z)(useSearch(), 2), ref1 = ref[1], getSearchResults = ref1.getSearchResults, getSearchSuggestions = ref1.getSearchSuggestions, setSearchData = ref1.setSearchData;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useLocalStorage */._)("searchTerm", ""), 2), searchQuery = ref2[0], setSearchQuery = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* default.rawTerm */.ZP.rawTerm), 2), rawTerm = ref3[0], setRawTerm = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* default.term */.ZP.term), 2), term = ref4[0], setTerm = ref4[1];
    var setSearchIsFocused = (0,store/* useSetRecoilState */.Zl)(store/* default.searchIsFocused */.ZP.searchIsFocused);
    var setLoading = (0,store/* useSetRecoilState */.Zl)(store/* default.searchLoading */.ZP.searchLoading);
    var debouncedTerm = (0,hooks/* useDebounce */.Nr)(rawTerm, 300);
    var isSearching = rawTerm && rawTerm !== "";
    // clear input
    var resetRawTerm = (0,react.useCallback)(function() {
        return setRawTerm("");
    }, []);
    // update the search term with the debounced value
    var updateTermOnDebouncedTermChange = (0,react.useCallback)(function() {
        if (term !== debouncedTerm) {
            setTerm(debouncedTerm);
            setSearchQuery(debouncedTerm);
        }
    }, [
        debouncedTerm,
        term
    ]);
    // check for search suggestions, then return results
    var getSuggestionsThenResults = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var ref, ref1, data, exactTerm, isAutocomplete, searchTerm, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    if (!debouncedTerm) {
                        setSearchData(null);
                    }
                    setLoading(true);
                    return [
                        4,
                        getSearchSuggestions({
                            query: debouncedTerm
                        })
                    ];
                case 1:
                    data = _state.sent();
                    exactTerm = (data === null || data === void 0 ? void 0 : data["corrected-query"]) || (data === null || data === void 0 ? void 0 : data.query);
                    isAutocomplete = (data === null || data === void 0 ? void 0 : (ref = data.suggested) === null || ref === void 0 ? void 0 : ref.type) === "completed";
                    searchTerm = isAutocomplete ? data === null || data === void 0 ? void 0 : (ref1 = data.suggested) === null || ref1 === void 0 ? void 0 : ref1.text : exactTerm;
                    return [
                        4,
                        getSearchResults({
                            query: searchTerm,
                            isAutocomplete: isAutocomplete
                        })
                    ];
                case 2:
                    _state.sent();
                    setLoading(false);
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    setLoading(false);
                    console.error(error.message);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), [
        debouncedTerm
    ]);
    (0,react.useEffect)(function() {
        setRawTerm(searchQuery);
    }, [
        searchQuery
    ]);
    (0,react.useEffect)(function() {
        getSuggestionsThenResults();
    }, [
        debouncedTerm
    ]);
    (0,react.useEffect)(function() {
        updateTermOnDebouncedTermChange();
    }, [
        debouncedTerm,
        term
    ]);
    return [
        {
            term: term,
            rawTerm: rawTerm,
            isSearching: isSearching
        },
        {
            setTerm: setTerm,
            setRawTerm: setRawTerm,
            resetRawTerm: resetRawTerm,
            setSearchIsFocused: setSearchIsFocused
        }, 
    ];
};

;// CONCATENATED MODULE: ./src/snippets/Search/hooks/index.js




/***/ }),

/***/ 70457:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "II": function() { return /* reexport */ Input; },
  "ol": function() { return /* reexport */ Search; },
  "BW": function() { return /* reexport */ SearchFooter; },
  "Z9": function() { return /* reexport */ SearchPage; }
});

// EXTERNAL MODULE: ../node_modules/theme-ui/jsx-runtime/dist/theme-ui-jsx-runtime.esm.js + 2 modules
var theme_ui_jsx_runtime_esm = __webpack_require__(70863);
// EXTERNAL MODULE: ../node_modules/@theme-ui/components/dist/theme-ui-components.esm.js
var theme_ui_components_esm = __webpack_require__(62680);
// EXTERNAL MODULE: ./src/theme/create.jsx
var create = __webpack_require__(73355);
;// CONCATENATED MODULE: ./src/snippets/Search/Search.theme.js

var themed = (0,create/* create */.U)(new function() {
    this.stickySearch = {
        position: "sticky",
        top: 0,
        bg: "background",
        zIndex: 1,
        borderBottom: function(t) {
            return "1px solid ".concat(t.colors.gray);
        }
    };
    this.inputWrapper = {
        pt: 10,
        pb: "28px",
        px: 8,
        position: "relative",
        zIndex: 0,
        ".ss-Powered": {
            fontSize: "11px",
            position: "absolute",
            right: 8,
            bottom: 2,
            color: "#565656"
        }
    };
    this.suggestionsWrapper = {
        p: 8,
        flexDirection: "column",
        gap: 3,
        borderTop: function(t) {
            return "1px solid ".concat(t.colors.gray);
        },
        "p, button, span": {
            variant: "text.base",
            lineHeight: 20
        }
    };
    this.suggested = {
        fontWeight: 500,
        fontStyle: "italic"
    };
    this.suggestion = function(isLast) {
        return {
            variant: "text.base",
            textDecoration: "underline",
            textDecorationThickness: "1px",
            textUnderlineOffset: "1px",
            fontStyle: "italic",
            mr: !isLast ? 3 : 0,
            ":after": {
                content: !isLast ? '","' : '""'
            }
        };
    };
    this.empty = {
        p: 12,
        pb: 0,
        position: "relative",
        variant: "flex.column"
    };
    this.loadingSpinner = {
        width: "22px",
        height: "22px",
        mx: "auto",
        color: "mediumGray"
    };
}());

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(31373);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(52050);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/@backpackjs/storefront/dist/index.js
var dist = __webpack_require__(52031);
// EXTERNAL MODULE: ./src/hooks/index.js + 64 modules
var hooks = __webpack_require__(74424);
// EXTERNAL MODULE: ./src/snippets/index.js + 352 modules
var snippets = __webpack_require__(81234);
// EXTERNAL MODULE: ./src/snippets/Search/hooks/index.js + 5 modules
var Search_hooks = __webpack_require__(62653);
;// CONCATENATED MODULE: ./src/snippets/Search/Input/Input.theme.js



var Input_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        position: "relative",
        height: "44px"
    };
    this.field = {
        // variant: 'forms.input.search',
        height: "100%",
        borderRadius: "22px",
        fontSize: 4,
        borderStyle: "solid",
        borderWidth: "1px",
        borderColor: "mediumGray",
        py: 0,
        pl: 14,
        pr: 8,
        "::placeholder": {
            variant: "text.base",
            color: "text"
        }
    };
    this.icon = {
        position: "absolute",
        top: "50%",
        transform: "translateY(-50%)",
        width: "24px",
        height: "24px",
        cursor: "default",
        color: "text",
        left: 6,
        zIndex: 1
    };
    this.clear = {
        hidden: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this.icon), {
            right: 8,
            left: "auto",
            display: "none",
            width: "16px",
            height: "16px"
        }),
        visible: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this.icon), {
            cursor: "pointer",
            right: 8,
            left: "auto",
            display: "block",
            width: "16px",
            height: "16px"
        })
    };
}());

;// CONCATENATED MODULE: ./src/snippets/Search/Input/Input.jsx












var Input = Input_theme_themed(function(_param) {
    var theme = _param.theme, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme"
    ]);
    var input = (0,react.useRef)();
    var router = (0,dist.useRouter)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,hooks/* useSidebar */.Ap)(), 2), isSearch = ref[0].isSearch, closeSidebarToNavigate = ref[1].closeSidebarToNavigate;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,Search_hooks/* useSearchInput */.d)(), 2), rawTerm = ref1[0].rawTerm, ref2 = ref1[1], setRawTerm = ref2.setRawTerm, resetRawTerm = ref2.resetRawTerm, setSearchIsFocused = ref2.setSearchIsFocused;
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,Search_hooks/* useSearch */.R)(), 1), merchandising = ref3[0].merchandising;
    (0,react.useEffect)(function() {
        if (isSearch) {
            input.current.focus();
        }
    }, [
        isSearch
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-comp": Input.displayName
    }, props), {
        sx: (0,_object_spread/* default */.Z)({}, theme.wrapper, props.sx),
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Svg */.ny, {
                alt: "Search input",
                viewBox: "0 0 48 48",
                src: "/svgs/cta/search.svg#search",
                sx: theme.icon
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Input */.II, {
                ref: input,
                placeholder: "Search here",
                role: "search",
                "aria-label": "Products and collections",
                onFocus: function() {
                    return setSearchIsFocused(true);
                },
                onBlur: function() {
                    return setSearchIsFocused(false);
                },
                onKeyDown: function(e) {
                    if (e.key === "Enter" && !!e.target.value) {
                        var redirect = merchandising === null || merchandising === void 0 ? void 0 : merchandising.redirect;
                        closeSidebarToNavigate();
                        router.push({
                            pathname: redirect || "/pages/search",
                            query: {}
                        });
                    }
                },
                onChange: function(e) {
                    setRawTerm(e.target.value);
                },
                value: rawTerm,
                sx: theme.field
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Svg */.ny, {
                src: "/svgs/close.svg#close",
                alt: "Clear search",
                viewBox: "0 0 48 48",
                onClick: resetRawTerm,
                role: "button",
                sx: rawTerm ? theme.clear.visible : theme.clear.hidden
            })
        ]
    }));
});
Input.displayName = "Input";

;// CONCATENATED MODULE: ./src/snippets/Search/Input/index.js


// EXTERNAL MODULE: ./src/store/index.js + 12 modules
var store = __webpack_require__(27695);
;// CONCATENATED MODULE: ./src/snippets/Search/Suggestions/Suggestions.theme.js



var Suggestions_theme_themed = (0,create/* create */.U)(new function() {
    // have results
    this.hidden = {
        variant: "flex.column",
        display: "none",
        p: 12
    };
    this.visible = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this.hidden), {
        display: "block"
    });
    this.heading = {
        variant: "text.label.1",
        mb: 6
    };
    this.term = {
        variant: "text.base",
        cursor: "pointer",
        mb: 5,
        "&:hover": {
            textDecoration: "underline"
        }
    };
}());

;// CONCATENATED MODULE: ./src/snippets/Search/Suggestions/Suggestions.jsx











var Suggestions = Suggestions_theme_themed(function(_param) {
    var theme = _param.theme, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme"
    ]);
    var ref, ref1;
    var settings = (0,dist.useSettings)();
    var suggestedTerms = settings === null || settings === void 0 ? void 0 : (ref = settings.search) === null || ref === void 0 ? void 0 : ref.suggested;
    var suggestedHeading = (settings === null || settings === void 0 ? void 0 : (ref1 = settings.search) === null || ref1 === void 0 ? void 0 : ref1.suggestedHeading) || "Top search terms";
    var setRawTerm = (0,store/* useSetRecoilState */.Zl)(store/* default.rawTerm */.ZP.rawTerm);
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,Search_hooks/* useSearch */.R)(), 2), totalResults = ref2[0].totalResults, getSearchTrending = ref2[1].getSearchTrending;
    (0,react.useEffect)(function() {
        getSearchTrending();
    }, []);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-comp": Suggestions.displayName
    }, props), {
        sx: totalResults ? theme.hidden : theme.visible,
        children: !!(suggestedTerms === null || suggestedTerms === void 0 ? void 0 : suggestedTerms.length) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
            children: [
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                    as: "h5",
                    sx: theme.heading,
                    children: suggestedHeading
                }),
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                    as: "ul",
                    sx: {
                        pl: 0
                    },
                    children: suggestedTerms.map(function(param, index) {
                        var label = param.label;
                        return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                            as: "li",
                            sx: {
                                mb: 2
                            },
                            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                                variant: "buttons.plain",
                                onClick: function() {
                                    return setRawTerm(label);
                                },
                                children: label
                            })
                        }, label + index);
                    })
                })
            ]
        })
    }));
});
Suggestions.displayName = "Suggestions";

;// CONCATENATED MODULE: ./src/snippets/Search/Suggestions/index.js


// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(23842);
// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(59312);
;// CONCATENATED MODULE: ./src/snippets/Search/Results/Product/Product.theme.js

var Product_theme_themed = (0,create/* create */.U)(new function() {
    this.grid = function(isLast) {
        return {
            display: "grid",
            gridTemplateColumns: "auto 1fr",
            columnGap: 6,
            pl: 6,
            pr: 10,
            py: 10,
            cursor: "pointer",
            borderBottomWidth: "1px",
            borderBottomColor: "gray",
            borderBottomStyle: isLast ? "none" : "solid",
            alignItems: "center"
        };
    };
    this.picture = {
        width: "84px",
        height: "84px"
    };
    this.details = {
        variant: "flex.column",
        ml: 8
    };
    this.title = {
        variant: "text.sm",
        fontWeight: 500,
        pt: 3
    };
    this.variant = {
        fontSize: "13px",
        color: "mediumDarkGray",
        minHeight: "22px"
    };
    this.type = {
        variant: "text.sm",
        color: "grey"
    };
    this.newPrice = {
        variant: "text.base",
        color: "red"
    };
    this.compareAtPrice = {
        variant: "text.base",
        textDecoration: "line-through",
        color: "mediumDarkGray"
    };
    this.price = {
        variant: "text.base"
    };
    this.loader = {
        height: "22px",
        svg: {
            height: "100%",
            color: "gray"
        }
    };
}());

;// CONCATENATED MODULE: ./src/snippets/Search/Results/Product/Product.jsx










var Product = Product_theme_themed(function(param) {
    var theme = param.theme, product = param.product, isLast = param.isLast, index = param.index, searchTerm = param.searchTerm;
    var ref, ref1;
    var sendClickProductItemEvent = (0,hooks/* useDataLayerActions */.KZ)().sendClickProductItemEvent;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useSidebar */.Ap)(), 2), closeSidebar = ref2[1].closeSidebar;
    var ref3 = (0,dist.useProductByHandle)({
        handle: product.handle
    }), fullProduct = ref3.product;
    var productUrl = fullProduct ? "/products/".concat(fullProduct.handle) : "";
    var firstImage = (0,react.useMemo)(function() {
        var ref, ref1;
        return (ref1 = fullProduct === null || fullProduct === void 0 ? void 0 : (ref = fullProduct.media) === null || ref === void 0 ? void 0 : ref.find(function(item) {
            return item.mediaContentType === "IMAGE";
        })) === null || ref1 === void 0 ? void 0 : ref1.image;
    }, [
        fullProduct === null || fullProduct === void 0 ? void 0 : fullProduct.id
    ]);
    var localized = (0,dist.useLocalizedVariant)({
        variant: fullProduct === null || fullProduct === void 0 ? void 0 : (ref = fullProduct.variants) === null || ref === void 0 ? void 0 : ref[0]
    }).localized;
    var titles = (0,react.useMemo)(function() {
        var ref, ref1, ref2;
        var titleArr = fullProduct === null || fullProduct === void 0 ? void 0 : (ref = fullProduct.title) === null || ref === void 0 ? void 0 : ref.split("|");
        return {
            product: (titleArr === null || titleArr === void 0 ? void 0 : (ref1 = titleArr[0]) === null || ref1 === void 0 ? void 0 : ref1.trim()) || "",
            variant: ((ref2 = titleArr === null || titleArr === void 0 ? void 0 : titleArr.slice(1)) === null || ref2 === void 0 ? void 0 : ref2.join("|").trim()) || ""
        };
    }, [
        fullProduct === null || fullProduct === void 0 ? void 0 : fullProduct.title
    ]);
    var intellisuggestTrackClick = (0,react.useCallback)(function() {
        if (document.images) {
            var apiUrl = "".concat(window.location.protocol || "http:", "//").concat("nr3jmv", ".a.searchspring.io/api/");
            var imgTag = new Image();
            imgTag.src = "".concat(apiUrl, "track/track.json?d=").concat(product.intellisuggestData, "&s=").concat(product.intellisuggestSignature, "&u=").concat(encodeURIComponent("".concat("https://www.brumate.com", "/products/").concat(product.handle)), "&r=").concat(encodeURIComponent(document.referrer), "&bgfilter.ss_mobile_only=0");
        }
        return true;
    }, [
        product.id
    ]);
    var handleClick = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var ref;
        return (0,tslib_es6.__generator)(this, function(_state) {
            closeSidebar();
            intellisuggestTrackClick();
            sendClickProductItemEvent({
                isSearchResult: true,
                listIndex: index,
                localized: localized,
                product: fullProduct,
                selectedVariant: fullProduct === null || fullProduct === void 0 ? void 0 : (ref = fullProduct.variants) === null || ref === void 0 ? void 0 : ref[0],
                searchTerm: searchTerm
            });
            return [
                2
            ];
        });
    }), [
        localized,
        fullProduct === null || fullProduct === void 0 ? void 0 : fullProduct.id,
        index
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(snippets/* Link */.rU, {
        "data-comp": Product.displayName,
        href: productUrl,
        onClick: handleClick,
        sx: theme.grid(isLast),
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Picture */.t, {
                alt: product.title,
                images: [
                    {
                        src: firstImage === null || firstImage === void 0 ? void 0 : firstImage.originalSrc,
                        ratio: 1,
                        width: 84
                    }, 
                ],
                sx: theme.picture
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                sx: theme.details,
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                    sx: {
                        variant: "flex.row.between.start"
                    },
                    children: [
                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                            sx: {
                                flex: 1,
                                mr: 6
                            },
                            children: [
                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                                    as: "h5",
                                    sx: {
                                        variant: "text.base",
                                        fontWeight: 500,
                                        fontSize: 3
                                    },
                                    children: titles.product
                                }),
                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                                    sx: theme.variant,
                                    children: titles.variant
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(snippets/* Locale.Variant */.go.Variant, {
                            variant: fullProduct === null || fullProduct === void 0 ? void 0 : (ref1 = fullProduct.variants) === null || ref1 === void 0 ? void 0 : ref1[0],
                            sx: {
                                p: {
                                    fontSize: "13px"
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Locale.Price */.go.Price, {
                                    children: function(param) {
                                        var priceV2 = param.priceV2, compareAtPriceV2 = param.compareAtPriceV2, isOnSale = param.isOnSale;
                                        return isOnSale ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                                            sx: {
                                                variant: "flex.column.end.start"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                                                    sx: theme.newPrice,
                                                    children: priceV2.locale
                                                }),
                                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                                                    sx: theme.compareAtPrice,
                                                    children: compareAtPriceV2.locale
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                                            sx: theme.price,
                                            children: priceV2.locale
                                        });
                                    }
                                }),
                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Locale.Loader */.go.Loader, {
                                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                                        sx: theme.loader,
                                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Spinner */.$j, {})
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
});
Product.displayName = "Product";

;// CONCATENATED MODULE: ./src/snippets/Search/Results/Product/index.js


;// CONCATENATED MODULE: ./src/snippets/Search/Results/Results.theme.js


var Results_theme_themed = (0,create/* create */.U)(new function() {
    this.notFound = {
        variant: "flex.column",
        pb: 0
    };
    this.found = (0,_object_spread/* default */.Z)({}, this.notFound);
    this.products = {
        variant: "flex.column"
    }, this.collections = {
        variant: "flex.column",
        py: 8
    };
    this.list = {
        variant: "flex.column"
    };
    this.heading = {
        variant: "text.searchHeading"
    };
}());

;// CONCATENATED MODULE: ./src/snippets/Search/Results/Results.jsx











var Results = Results_theme_themed(function(_param) {
    var theme = _param.theme, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme"
    ]);
    var ref = (0,_sliced_to_array/* default */.Z)((0,Search_hooks/* useSearch */.R)(), 1), ref1 = ref[0], results = ref1.results, totalResults = ref1.totalResults;
    var sendViewSearchResultsEvent = (0,hooks/* useDataLayerActions */.KZ)().sendViewSearchResultsEvent;
    var searchTerm = (0,store/* useRecoilValue */.sJ)(store/* default.term */.ZP.term);
    (0,react.useEffect)(function() {
        sendViewSearchResultsEvent({
            products: results,
            searchTerm: searchTerm
        });
    }, [
        results,
        sendViewSearchResultsEvent
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
        "data-comp": Results.displayName,
        sx: (0,_object_spread/* default */.Z)({}, props.sx, totalResults ? theme.found : theme.notFound),
        children: totalResults ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
            sx: theme.products,
            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                sx: theme.list,
                as: "ul",
                children: results.map(function(product, index, arr) {
                    if (product.isBanner) return null;
                    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                        as: "li",
                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Product, {
                            product: product,
                            isLast: index === arr.length - 1,
                            index: index,
                            searchTerm: searchTerm
                        })
                    }, product.id);
                })
            })
        }) : null
    });
});
Results.displayName = "Results";

;// CONCATENATED MODULE: ./src/snippets/Search/Results/index.js


;// CONCATENATED MODULE: ./src/snippets/Search/SuggestionsHeader.jsx






var SuggestionsHeader = themed(function(param) {
    var theme = param.theme;
    var ref = (0,_sliced_to_array/* default */.Z)((0,Search_hooks/* useSearch */.R)(), 1), ref1 = ref[0], suggested = ref1.suggested, suggestions = ref1.suggestions, isAutocomplete = ref1.isAutocomplete;
    var setRawTerm = (0,store/* useSetRecoilState */.Zl)(store/* default.rawTerm */.ZP.rawTerm);
    return (suggestions === null || suggestions === void 0 ? void 0 : suggestions.length) > 0 || isAutocomplete ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
        "data-comp": SuggestionsHeader.displayName,
        sx: theme.suggestionsWrapper,
        children: [
            isAutocomplete && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Paragraph */.nv, {
                children: [
                    "Showing results for",
                    " ",
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Text */.xv, {
                        sx: theme.suggested,
                        children: suggested === null || suggested === void 0 ? void 0 : suggested.text
                    })
                ]
            }),
            (suggestions === null || suggestions === void 0 ? void 0 : suggestions.length) > 0 && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                sx: {
                    flexWrap: "wrap"
                },
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                        sx: {
                            mr: 2
                        },
                        children: "Suggestions:"
                    }),
                    suggestions.map(function(suggestion, index, arr) {
                        var isLast = index === arr.length - 1;
                        return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                            variant: "buttons.plain",
                            sx: theme.suggestion(isLast),
                            onClick: function() {
                                return setRawTerm(suggestion);
                            },
                            "aria-label": "Search for ".concat(suggestion),
                            children: suggestion
                        }, suggestion);
                    })
                ]
            })
        ]
    }) : null;
});
SuggestionsHeader.displayName = "SuggestionsHeader";

;// CONCATENATED MODULE: ./src/snippets/Search/Empty.jsx






var Empty = themed(function(param) {
    var theme = param.theme;
    var term = (0,store/* useRecoilValue */.sJ)(store/* default.term */.ZP.term);
    var searchLoading = (0,store/* useRecoilValue */.sJ)(store/* default.searchLoading */.ZP.searchLoading);
    var ref = (0,_sliced_to_array/* default */.Z)((0,Search_hooks/* useSearch */.R)(), 1), totalResults = ref[0].totalResults;
    var noResultsFound = !searchLoading && term && !totalResults;
    var loading = searchLoading && !totalResults;
    return noResultsFound || loading ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
        "data-comp": Empty.displayName,
        sx: theme.empty,
        children: [
            noResultsFound && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                sx: {
                    variant: "text.base"
                },
                children: "No results found, please try a different search"
            }),
            loading && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Spinner */.$j, {
                sx: theme.loadingSpinner
            })
        ]
    }) : null;
});
Empty.displayName = "Empty";

// EXTERNAL MODULE: ./src/snippets/Cart/Upsell/SliderItem/UpsellAddToCart.jsx
var UpsellAddToCart = __webpack_require__(11578);
;// CONCATENATED MODULE: ./src/snippets/Search/Recommendations/RecommendationItem/RecommendationItem.theme.js

var RecommendationItem_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = function(isLast) {
        return {
            variant: "flex.row.start.center",
            width: "100%",
            minHeight: "122px",
            px: 12,
            py: 10,
            borderBottomWidth: "1px",
            borderBottomColor: "gray",
            borderBottomStyle: isLast ? "none" : "solid",
            mb: isLast ? 10 : 0
        };
    };
    this.picture = {
        width: "105px",
        mr: 8,
        spinner: {
            width: "16px",
            color: "mediumDarkGray",
            m: "auto"
        }
    };
    this.details = {
        variant: "flex.column.start",
        flex: 1,
        pr: 10
    };
    this.title = {
        variant: "text.h6",
        fontWeight: 500,
        minHeight: "18px"
    };
    this.variant = {
        variant: "text.sm",
        color: "mediumDarkGray",
        minHeight: "18px"
    };
    this.price = {
        minHeight: "18px",
        mb: 3,
        p: {
            variant: "text.sm",
            fontSize: "13px"
        }
    };
    this.newPrice = {
        color: "red",
        mr: 4
    };
    this.compareAtPrice = {
        textDecoration: "line-through",
        color: "mediumDarkGray"
    };
    this.atc = {
        fontSize: [
            "13px",
            "13px"
        ]
    };
}());

;// CONCATENATED MODULE: ./src/snippets/Search/Recommendations/RecommendationItem/RecommendationItem.jsx









var RecommendationItem = RecommendationItem_theme_themed(function(param) {
    var theme = param.theme, handle = param.handle, isLast = param.isLast;
    var ref, ref1;
    var product = (0,dist.useProductByHandle)({
        handle: handle
    }).product;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useSidebar */.Ap)(), 2), closeSidebar = ref2[1].closeSidebar;
    var title = (0,react.useMemo)(function() {
        var fullTitle = product === null || product === void 0 ? void 0 : product.title;
        var splitIndex = (fullTitle === null || fullTitle === void 0 ? void 0 : fullTitle.indexOf("|")) || -1;
        return {
            product: splitIndex >= 0 ? fullTitle === null || fullTitle === void 0 ? void 0 : fullTitle.slice(0, splitIndex).trim() : fullTitle,
            variant: splitIndex >= 0 ? fullTitle === null || fullTitle === void 0 ? void 0 : fullTitle.slice(splitIndex + 1).trim() : ""
        };
    }, [
        product === null || product === void 0 ? void 0 : product.title
    ]);
    var firstImage = (0,react.useMemo)(function() {
        var ref, ref1;
        return (ref1 = product === null || product === void 0 ? void 0 : (ref = product.media) === null || ref === void 0 ? void 0 : ref.find(function(item) {
            return item.mediaContentType === "IMAGE";
        })) === null || ref1 === void 0 ? void 0 : ref1.image;
    }, [
        product === null || product === void 0 ? void 0 : product.id
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
        "data-comp": RecommendationItem.displayName,
        sx: theme.wrapper(isLast),
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Link */.rU, {
                href: "/products/".concat(handle),
                onClick: closeSidebar,
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Picture */.t, {
                    alt: product === null || product === void 0 ? void 0 : product.title,
                    "data-comp": "".concat(RecommendationItem.displayName, "Picture"),
                    images: [
                        {
                            src: firstImage === null || firstImage === void 0 ? void 0 : firstImage.originalSrc,
                            width: 350,
                            ratio: 1
                        }, 
                    ],
                    sx: theme.picture,
                    children: !firstImage && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Spinner */.$j, {
                        sx: theme.picture.spinner
                    })
                })
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                sx: theme.details,
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Link */.rU, {
                        href: "/products/".concat(handle),
                        onClick: closeSidebar,
                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                            "data-comp": "".concat(RecommendationItem.displayName, "Heading"),
                            as: "h6",
                            sx: theme.title,
                            children: title === null || title === void 0 ? void 0 : title.product
                        })
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                        sx: theme.variant,
                        children: title === null || title === void 0 ? void 0 : title.variant
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                        variant: "flex.row.between",
                        sx: {
                            mt: 10,
                            width: "100%"
                        },
                        children: [
                            product && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(UpsellAddToCart/* UpsellAddToCart */.D, {
                                product: product,
                                selectedVariant: product === null || product === void 0 ? void 0 : (ref = product.variants) === null || ref === void 0 ? void 0 : ref[0],
                                style: theme.atc
                            }),
                            (product === null || product === void 0 ? void 0 : (ref1 = product.variants) === null || ref1 === void 0 ? void 0 : ref1[0]) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Locale.Variant */.go.Variant, {
                                variant: product.variants[0],
                                sx: theme.price,
                                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Locale.Price */.go.Price, {
                                    children: function(param) {
                                        var priceV2 = param.priceV2, compareAtPriceV2 = param.compareAtPriceV2, isOnSale = param.isOnSale;
                                        return isOnSale ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                                            children: [
                                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                                                    sx: theme.newPrice,
                                                    children: priceV2.locale
                                                }),
                                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                                                    sx: theme.compareAtPrice,
                                                    children: compareAtPriceV2.locale
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                                            children: priceV2.locale
                                        });
                                    }
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
});
RecommendationItem.displayName = "SearchRecommendationItem";

;// CONCATENATED MODULE: ./src/snippets/Search/Recommendations/RecommendationItem/index.js


// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3204);
;// CONCATENATED MODULE: ./src/snippets/Search/Recommendations/useRecommendationsBeacon.js






var useRecommendationsBeacon = function(param) {
    var profileData = param.profileData, profileTag = param.profileTag, visibleProducts = param.visibleProducts, inView = param.inView;
    var ref;
    var cachedMounted = (0,react.useRef)(false); // prevent double events on mount
    var sendEventsToBeacon = (0,hooks/* useSearchspringBeacon */.fo)().sendEventsToBeacon;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useSelectedVariant */.BK)(), 1), selectedVariant = ref1[0];
    var ref2 = (0,react.useState)(false), mounted = ref2[0], setMounted = ref2[1];
    var ref3 = (0,react.useState)(false), viewed = ref3[0], setViewed = ref3[1];
    var sku = selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.sku;
    var sendBeaconEventsOnMount = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    if (cachedMounted.current || mounted || !(profileData === null || profileData === void 0 ? void 0 : profileData.results) || !profileTag) return [
                        2
                    ];
                    cachedMounted.current = true;
                    return [
                        4,
                        sendEventsToBeacon({
                            profileTypes: [
                                "profile.render"
                            ],
                            productTypes: [
                                "profile.product.render"
                            ],
                            tag: profileTag,
                            placement: "other-page",
                            products: profileData.results,
                            seed: []
                        })
                    ];
                case 1:
                    _state.sent();
                    setMounted(true);
                    return [
                        3,
                        3
                    ];
                case 2:
                    error = _state.sent();
                    console.error(error.message);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    }), [
        profileData === null || profileData === void 0 ? void 0 : (ref = profileData.results) === null || ref === void 0 ? void 0 : ref.length,
        profileTag,
        mounted,
        sku
    ]);
    var sendBeaconEventsOnInView = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    if (viewed || !inView || !(visibleProducts === null || visibleProducts === void 0 ? void 0 : visibleProducts.length) || !profileTag) return [
                        2
                    ];
                    return [
                        4,
                        sendEventsToBeacon({
                            profileTypes: [
                                "profile.impression"
                            ],
                            productTypes: [
                                "profile.product.impression"
                            ],
                            tag: profileTag,
                            placement: "other-page",
                            visibleProducts: visibleProducts,
                            seed: []
                        })
                    ];
                case 1:
                    _state.sent();
                    setViewed(true);
                    return [
                        3,
                        3
                    ];
                case 2:
                    error = _state.sent();
                    console.error(error.message);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    }), [
        visibleProducts,
        profileTag,
        sku,
        inView,
        viewed
    ]);
    var sendBeaconEventsOnClick = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(event, product) {
            var dataComp, productClicked, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        if (!profileTag) return [
                            2
                        ];
                        dataComp = (0,_to_consumable_array/* default */.Z)(event.target.attributes || []).find(function(attr) {
                            return attr.name === "data-comp";
                        });
                        productClicked = product && (event.target.nodeName === "svg" || event.target.nodeName === "use" || (dataComp === null || dataComp === void 0 ? void 0 : dataComp.value) === "AddToCart" || (dataComp === null || dataComp === void 0 ? void 0 : dataComp.value) === "ProductItemTitle" || (dataComp === null || dataComp === void 0 ? void 0 : dataComp.value) === "SeeDetails" || (dataComp === null || dataComp === void 0 ? void 0 : dataComp.value) === "OkendoStarsTotal" || (dataComp === null || dataComp === void 0 ? void 0 : dataComp.value) === "OkendoStarsTotalText" || (dataComp === null || dataComp === void 0 ? void 0 : dataComp.value) === "PictureImage");
                        return [
                            4,
                            sendEventsToBeacon({
                                profileTypes: [
                                    "profile.click"
                                ],
                                productTypes: productClicked ? [
                                    "profile.product.click"
                                ] : [],
                                tag: profileTag,
                                placement: "other-page",
                                clickedProduct: productClicked ? product : null,
                                seed: []
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        console.error(error.message);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(event, product) {
            return _ref.apply(this, arguments);
        };
    }(), [
        profileTag,
        sku
    ]);
    var sendBeaconEventsOnProductsInView = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    if (!mounted || !viewed || !(visibleProducts === null || visibleProducts === void 0 ? void 0 : visibleProducts.length) || !profileTag) return [
                        2
                    ];
                    return [
                        4,
                        sendEventsToBeacon({
                            productTypes: [
                                "profile.product.impression"
                            ],
                            tag: profileTag,
                            placement: "other-page",
                            visibleProducts: visibleProducts,
                            seed: []
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        3,
                        3
                    ];
                case 2:
                    error = _state.sent();
                    console.error(error.message);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    }), [
        visibleProducts,
        profileTag,
        mounted,
        viewed,
        sku
    ]);
    (0,react.useEffect)(function() {
        sendBeaconEventsOnMount();
    }, [
        profileData === null || profileData === void 0 ? void 0 : profileData.results,
        visibleProducts,
        profileTag
    ]);
    (0,react.useEffect)(function() {
        sendBeaconEventsOnInView();
    }, [
        inView,
        visibleProducts,
        profileTag
    ]);
    (0,react.useEffect)(function() {
        sendBeaconEventsOnProductsInView();
    }, [
        visibleProducts === null || visibleProducts === void 0 ? void 0 : visibleProducts.map(function(p) {
            return p.id;
        }).join(",")
    ]);
    return {
        sendBeaconEventsOnClick: sendBeaconEventsOnClick
    };
};

;// CONCATENATED MODULE: ./src/snippets/Search/Recommendations/Recommendations.theme.js

var Recommendations_theme_themed = (0,create/* create */.U)(new function() {
    this.heading = {
        variant: "text.label.1",
        px: 12,
        py: 10,
        borderTopWidth: "1px",
        borderTopColor: "gray",
        borderTopStyle: "solid",
        borderBottomWidth: "1px",
        borderBottomColor: "gray",
        borderBottomStyle: "solid"
    };
}());

;// CONCATENATED MODULE: ./src/snippets/Search/Recommendations/Recommendations.jsx










var Recommendations = Recommendations_theme_themed(function(param) {
    var theme = param.theme;
    var ref;
    var settings = (0,dist.useSettings)();
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,Search_hooks/* useSearch */.R)(), 1), totalResults = ref1[0].totalResults;
    var ref2 = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : (ref = settings.search) === null || ref === void 0 ? void 0 : ref.searchSpring), enable = ref2.enable, heading = ref2.heading, tag = ref2.tag, _limit = ref2.limit, limit = _limit === void 0 ? 8 : _limit;
    var ref3 = (0,hooks/* useProductRecommendations */.$t)({
        tag: tag || "cross-sell",
        limit: limit
    }), recommendations = ref3.recommendations, profileData = ref3.profileData, profileTag = ref3.profileTag;
    var sendBeaconEventsOnClick = useRecommendationsBeacon({
        profileData: profileData,
        profileTag: profileTag,
        visibleProducts: profileData === null || profileData === void 0 ? void 0 : profileData.results
    }).sendBeaconEventsOnClick;
    if (totalResults || !(recommendations === null || recommendations === void 0 ? void 0 : recommendations.length) || !enable) return null;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": Recommendations.displayName,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                as: "h5",
                sx: theme.heading,
                children: heading || "Complete Your Collection"
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                variant: "flex.column",
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                    variant: "flex.column",
                    as: "ul",
                    children: recommendations === null || recommendations === void 0 ? void 0 : recommendations.map(function(product, index, arr) {
                        if (!(product === null || product === void 0 ? void 0 : product.handle)) return null;
                        return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                            as: "li",
                            onClick: sendBeaconEventsOnClick,
                            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(RecommendationItem, {
                                handle: product.handle,
                                isLast: index === arr.length - 1
                            })
                        }, index);
                    })
                })
            })
        ]
    });
});
Recommendations.displayName = "Recommendations";

;// CONCATENATED MODULE: ./src/snippets/Search/Recommendations/index.js


;// CONCATENATED MODULE: ./src/snippets/Search/Search.jsx









var Search = themed(function(param) {
    var theme = param.theme;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": Search.displayName,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                sx: theme.stickySearch,
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                        sx: theme.inputWrapper,
                        children: [
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Input, {}),
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                                className: "ss-Powered",
                                children: "Powered by SearchSpring"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(SuggestionsHeader, {})
                ]
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Empty, {}),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Suggestions, {}),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Recommendations, {}),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Results, {})
        ]
    });
});
Search.displayName = "Search";

;// CONCATENATED MODULE: ./src/snippets/Search/SearchFooter/SearchFooter.theme.js

var SearchFooter_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        width: "100%",
        p: 8,
        borderTop: function(t) {
            return "1px solid ".concat(t.colors.gray);
        }
    };
}());

;// CONCATENATED MODULE: ./src/snippets/Search/SearchFooter/SearchFooter.jsx








var SearchFooter = SearchFooter_theme_themed(function(param) {
    var theme = param.theme;
    var ref = (0,_sliced_to_array/* default */.Z)((0,Search_hooks/* useSearch */.R)(), 1), ref1 = ref[0], suggested = ref1.suggested, isAutocomplete = ref1.isAutocomplete, totalResults = ref1.totalResults;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useSidebar */.Ap)(), 2), closeSidebar = ref2[1].closeSidebar;
    var rawTerm = (0,store/* useRecoilValue */.sJ)(store/* default.rawTerm */.ZP.rawTerm);
    return totalResults ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": SearchFooter.displayName,
        sx: theme.wrapper,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(snippets/* Link */.rU, {
            href: "/pages/search",
            variant: "buttons.secondary",
            onClick: closeSidebar,
            children: [
                "See All ",
                totalResults,
                " Results"
            ]
        })
    }) : null;
});
SearchFooter.displayName = "SearchFooter";

;// CONCATENATED MODULE: ./src/snippets/Search/SearchFooter/index.js


;// CONCATENATED MODULE: ./src/snippets/Search/SearchPage/Suggestions/SearchPageSuggestions.theme.js

var SearchPageSuggestions_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        justifyContent: "center",
        flexWrap: "wrap",
        mt: 10,
        "p, a, span": {
            variant: "text.lg"
        }
    };
    this.suggestion = function(isLast) {
        return {
            textDecoration: "underline",
            textDecorationThickness: "1px",
            textUnderlineOffset: "1px",
            fontStyle: "italic",
            mr: 3,
            ":after": {
                content: !isLast ? '","' : '""'
            }
        };
    };
}());

;// CONCATENATED MODULE: ./src/snippets/Search/SearchPage/Suggestions/SearchPageSuggestions.jsx







var SearchPageSuggestions = SearchPageSuggestions_theme_themed(function(param) {
    var theme = param.theme;
    var ref = (0,_sliced_to_array/* default */.Z)((0,Search_hooks/* useSearch */.R)(), 1), ref1 = ref[0], pageSuggestions = ref1.pageSuggestions, pageResults = ref1.pageResults, pageSuggested = ref1.pageSuggested;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useLocalStorage */._)("searchTerm", ""), 2), _ = ref2[0], setSearchQuery = ref2[1];
    var isAutocomplete = (pageSuggested === null || pageSuggested === void 0 ? void 0 : pageSuggested.type) === "completed";
    return (pageSuggestions === null || pageSuggestions === void 0 ? void 0 : pageSuggestions.length) && (!(pageResults === null || pageResults === void 0 ? void 0 : pageResults.length) || isAutocomplete) ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
        "data-comp": SearchPageSuggestions.displayName,
        sx: theme.wrapper,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                sx: {
                    mr: 2
                },
                children: "Did you mean:"
            }),
            pageSuggestions.map(function(suggestion, index, arr) {
                var isLast = index === arr.length - 1;
                return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Link */.rU, {
                    href: "/pages/search",
                    query: {},
                    sx: theme.suggestion(isLast),
                    onClick: function() {
                        return setSearchQuery(suggestion);
                    },
                    children: suggestion
                }, suggestion);
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                children: "?"
            })
        ]
    }) : null;
});
SearchPageSuggestions.displayName = "SearchPageSuggestions";

;// CONCATENATED MODULE: ./src/snippets/Search/SearchPage/Suggestions/index.js


;// CONCATENATED MODULE: ./src/snippets/Search/SearchPage/SearchPage.theme.js

var SearchPage_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        variant: "layout.content",
        px: [
            0,
            10,
            11,
            12
        ],
        pt: [
            14,
            16
        ],
        pb: [
            14,
            18,
            "80px"
        ]
    };
    this.headingWrapper = {
        variant: "flex.column.center",
        mb: 13,
        maxWidth: "700px",
        px: [
            8,
            0
        ],
        mx: "auto",
        minHeight: [
            "36px",
            "40px"
        ],
        position: "relative"
    };
    this.heading = {
        variant: "text.h2",
        textAlign: "center"
    };
    this.subheading = {
        textAlign: "center",
        variant: "text.lg",
        mt: 10
    };
    this.italicized = {
        fontStyle: "italic",
        fontWeight: 500
    };
    this.grid = {
        width: "100%",
        display: "grid",
        columnGap: [
            10,
            12
        ],
        rowGap: [
            14,
            12
        ]
    };
    this.noProducts = {
        variant: "flex.column",
        text: {
            variant: "text.lg",
            mt: 20,
            textAlign: "center"
        }
    };
    this.banner = {
        width: "100%",
        height: [
            "100%",
            "calc(100% - 60px)"
        ],
        "h2,h3,h4,h5,h6": {
            variant: "text.h4",
            mt: [
                10,
                11
            ],
            mb: 3
        },
        p: {
            mt: 0,
            variant: "text.lg"
        },
        "p:last-of-type": {
            mb: 0
        }
    };
}());

;// CONCATENATED MODULE: ./src/snippets/Search/SearchPage/SearchPageHeader.jsx







var SearchPageHeader = SearchPage_theme_themed(function(param) {
    var correctedQueryOverridden = param.correctedQueryOverridden, filterSummary = param.filterSummary, isPageAutocomplete = param.isPageAutocomplete, loading = param.loading, pageSpellCorrection = param.pageSpellCorrection, pageSuggested = param.pageSuggested, query = param.query, theme = param.theme, totalPageResults = param.totalPageResults;
    return query ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
        "data-comp": SearchPageHeader.displayName,
        sx: theme.headingWrapper,
        children: !loading ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_jsx_runtime_esm/* Fragment */.HY, {
            children: [
                pageSpellCorrection && !isPageAutocomplete && !correctedQueryOverridden ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_jsx_runtime_esm/* Fragment */.HY, {
                    children: [
                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Heading */.X6, {
                            as: "h1",
                            sx: theme.heading,
                            children: [
                                totalPageResults,
                                " ",
                                (filterSummary === null || filterSummary === void 0 ? void 0 : filterSummary.length) ? "filtered " : "",
                                "result",
                                totalPageResults === 1 ? "" : "s",
                                ' for "',
                                pageSpellCorrection || "",
                                '"'
                            ]
                        }),
                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Heading */.X6, {
                            sx: theme.subheading,
                            children: [
                                "Search for",
                                " ",
                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Link */.rU, {
                                    href: "/pages/search",
                                    query: {
                                        query: query,
                                        spellcorrect: "false"
                                    },
                                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.italicized), {
                                        textDecoration: "underline",
                                        display: "inline"
                                    }),
                                    children: query
                                }),
                                " ",
                                "instead"
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_jsx_runtime_esm/* Fragment */.HY, {
                    children: [
                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Heading */.X6, {
                            as: "h1",
                            sx: theme.heading,
                            children: [
                                isPageAutocomplete ? "0" : totalPageResults,
                                " ",
                                (filterSummary === null || filterSummary === void 0 ? void 0 : filterSummary.length) && !isPageAutocomplete ? "filtered " : "",
                                "result",
                                totalPageResults === 1 ? "" : "s",
                                ' for "',
                                query || "",
                                '"'
                            ]
                        }),
                        isPageAutocomplete && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Heading */.X6, {
                            sx: theme.subheading,
                            children: [
                                "Showing ",
                                totalPageResults,
                                " ",
                                (filterSummary === null || filterSummary === void 0 ? void 0 : filterSummary.length) ? "filtered " : "",
                                " result",
                                totalPageResults === 1 ? "" : "s",
                                " for",
                                " ",
                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Text */.xv, {
                                    sx: theme.italicized,
                                    children: pageSuggested.text || ""
                                }),
                                " ",
                                "instead"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(SearchPageSuggestions, {})
            ]
        }) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Spinner */.$j, {
            sx: {
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "36px"
            }
        })
    }) : null;
});
SearchPageHeader.displayName = "SearchPageHeader";

// EXTERNAL MODULE: ./src/snippets/Search/SearchPage/Sort/index.js + 4 modules
var Sort = __webpack_require__(24239);
;// CONCATENATED MODULE: ./src/snippets/Search/SearchPage/Pagination/useSearchPagination.js



var useSearchPagination = function() {
    var searchPageData = (0,store/* useRecoilValue */.sJ)(store/* default.searchPageData */.ZP.searchPageData);
    var ref = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* default.searchSelectedResultsPerPage */.ZP.searchSelectedResultsPerPage), 2), selectedResultsPerPage = ref[0], setSelectedResultsPerPage = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* default.searchCurrentResultsPage */.ZP.searchCurrentResultsPage), 2), currentResultsPage = ref1[0], setCurrentResultsPage = ref1[1];
    var ref2 = (searchPageData === null || searchPageData === void 0 ? void 0 : searchPageData.pagination) || {}, previousPage = ref2.previousPage, nextPage = ref2.nextPage, totalPages = ref2.totalPages;
    var updateResultsPerPage = (0,react.useCallback)(function(num) {
        if (!num) {
            return console.error("updateResultsPerPage: an integer from 1-100 must be passed");
        }
        setSelectedResultsPerPage(num);
    }, []);
    var goToPrevPage = (0,react.useCallback)(function() {
        if (!previousPage) return;
        setCurrentResultsPage(previousPage);
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }, [
        previousPage
    ]);
    var goToNextPage = (0,react.useCallback)(function() {
        if (!nextPage) return;
        setCurrentResultsPage(nextPage);
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }, [
        nextPage
    ]);
    var goToPage = (0,react.useCallback)(function(num) {
        if (!num || num > totalPages) return;
        setCurrentResultsPage(num);
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }, [
        totalPages
    ]);
    return [
        // state
        {
            resultsPerPage: selectedResultsPerPage,
            currentPage: currentResultsPage,
            totalPages: totalPages || 1
        },
        // actions
        {
            updateResultsPerPage: updateResultsPerPage,
            goToPrevPage: goToPrevPage,
            goToNextPage: goToNextPage,
            goToPage: goToPage
        }, 
    ];
};

;// CONCATENATED MODULE: ./src/snippets/Search/SearchPage/Pagination/Pagination.theme.js

var Pagination_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        variant: "flex.row.center",
        mt: [
            13,
            10
        ]
    };
    this.list = {
        pl: 0
    };
    this.arrowListItem = {
        display: "flex",
        alignItems: "center"
    };
    this.arrowButton = function(disabled) {
        return {
            cursor: disabled ? "default" : "pointer"
        };
    };
    this.arrowIcon = function(disabled) {
        return {
            width: "16px",
            transition: "all .2s ease-in-out",
            color: disabled ? "gray" : "text"
        };
    };
    this.listItem = {
        mr: 5
    };
    this.pageButton = function(isCurrentPage) {
        return {
            position: "relative",
            ":after": {
                content: '""',
                width: "100%",
                position: "absolute",
                height: "1px",
                left: 0,
                top: "100%",
                bg: "text",
                transition: "transform .2s ease-in-out",
                transform: isCurrentPage ? "scaleX(1)" : "scaleX(0)"
            }
        };
    };
}());

;// CONCATENATED MODULE: ./src/snippets/Search/SearchPage/Pagination/Pagination.jsx










var Pagination = Pagination_theme_themed(function(_param) {
    var theme = _param.theme, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme"
    ]);
    var ref = (0,_sliced_to_array/* default */.Z)(useSearchPagination(), 2), ref1 = ref[0], currentPage = ref1.currentPage, totalPages = ref1.totalPages, ref2 = ref[1], goToPrevPage = ref2.goToPrevPage, goToNextPage = ref2.goToNextPage, goToPage = ref2.goToPage;
    var isFirstPage = currentPage === 1;
    var isLastPage = currentPage === totalPages;
    return totalPages > 1 ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-comp": Pagination.displayName
    }, props), {
        sx: (0,_object_spread/* default */.Z)({}, theme.wrapper, props.sx),
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
            as: "nav",
            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                as: "ul",
                variant: "flex.row.start.center",
                sx: theme.list,
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                        as: "li",
                        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.arrowListItem), {
                            mr: 5
                        }),
                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                            variant: "buttons.plain",
                            onClick: goToPrevPage,
                            disabled: isFirstPage,
                            "aria-label": "Go to previous page",
                            sx: theme.arrowButton(isFirstPage),
                            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Svg */.ny, {
                                alt: "chevron",
                                viewBox: "0 0 16 16",
                                src: "/svgs/chevron/left.svg#left",
                                sx: theme.arrowIcon(isFirstPage)
                            })
                        })
                    }),
                    (0,_to_consumable_array/* default */.Z)(Array(totalPages).keys()).map(function(i) {
                        var page = i + 1;
                        return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                            as: "li",
                            sx: theme.listItem,
                            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                                variant: "buttons.plain",
                                onClick: function() {
                                    return goToPage(page);
                                },
                                "aria-label": "Go to page ".concat(page),
                                sx: theme.pageButton(page === currentPage),
                                children: page
                            }, page)
                        }, page);
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                        as: "li",
                        sx: theme.arrowListItem,
                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                            variant: "buttons.plain",
                            onClick: goToNextPage,
                            disabled: isLastPage,
                            "aria-label": "Go to next page",
                            sx: theme.arrowButton(isLastPage),
                            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Svg */.ny, {
                                alt: "chevron",
                                viewBox: "0 0 16 16",
                                src: "/svgs/chevron/right.svg#right",
                                sx: theme.arrowIcon(isLastPage)
                            })
                        })
                    })
                ]
            })
        })
    })) : null;
});
Pagination.displayName = "Pagination";

;// CONCATENATED MODULE: ./src/snippets/Search/SearchPage/Pagination/index.js


;// CONCATENATED MODULE: ./src/snippets/Search/SearchPage/SearchGrid.jsx










var SearchGrid = SearchPage_theme_themed(function(param) {
    var theme = param.theme, merchandising = param.merchandising, searchTerm = param.searchTerm;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,Search_hooks/* useSearch */.R)(), 1), ref7 = ref6[0], pageResults = ref7.pageResults, totalPageResults = ref7.totalPageResults;
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,Sort/* useSearchSort */.q)(), 1), sortOptions = ref8[0].sortOptions;
    var header = merchandising === null || merchandising === void 0 ? void 0 : (ref = merchandising.content) === null || ref === void 0 ? void 0 : (ref1 = ref.header) === null || ref1 === void 0 ? void 0 : ref1[0];
    var footer = merchandising === null || merchandising === void 0 ? void 0 : (ref2 = merchandising.content) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.footer) === null || ref3 === void 0 ? void 0 : ref3[0];
    var banner = merchandising === null || merchandising === void 0 ? void 0 : (ref4 = merchandising.content) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.banner) === null || ref5 === void 0 ? void 0 : ref5[0];
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Container */.W2, {
        "data-comp": SearchGrid.displayName,
        sx: {
            px: [
                8,
                0
            ]
        },
        children: [
            (header || banner) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                sx: {
                    mb: 12,
                    display: [
                        "none",
                        "block"
                    ]
                },
                children: [
                    header,
                    banner
                ].map(function(item, index) {
                    return item ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                        dangerouslySetInnerHTML: {
                            __html: item
                        }
                    }, index) : null;
                })
            }),
            sortOptions && totalPageResults > 0 && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Sort/* Sort */.P, {}),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Container */.W2, {
                sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.grid), {
                    gridTemplateColumns: totalPageResults ? [
                        "repeat(2, 1fr)",
                        "repeat(3, 1fr)"
                    ] : [
                        "1fr"
                    ]
                }),
                children: totalPageResults ? pageResults.map(function(product, index) {
                    if (!product) return null;
                    return !product.isBanner ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* ProductItem */.Cd, {
                        product: product,
                        index: index,
                        isSearchPage: true,
                        searchTerm: searchTerm
                    }, product.handle) : // Inline merchandising banner
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                        sx: theme.banner,
                        dangerouslySetInnerHTML: {
                            __html: product.value
                        }
                    }, product.id);
                }) : null
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Pagination, {}),
            footer && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                dangerouslySetInnerHTML: {
                    __html: footer
                },
                sx: {
                    mt: 12,
                    display: [
                        "none",
                        "block"
                    ]
                }
            })
        ]
    });
});
SearchGrid.displayName = "SearchGrid";

// EXTERNAL MODULE: ./src/snippets/Search/SearchPage/Filters/index.js + 8 modules
var Filters = __webpack_require__(65793);
;// CONCATENATED MODULE: ./src/snippets/Search/SearchPage/SearchPage.jsx
















var SearchPage = SearchPage_theme_themed(function(param) {
    var theme = param.theme;
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,Search_hooks/* useSearch */.R)(), 2), ref6 = ref5[0], pageResults = ref6.pageResults, pageSuggested = ref6.pageSuggested, totalPageResults = ref6.totalPageResults, pageSpellCorrection = ref6.pageSpellCorrection, merchandising = ref6.merchandising, ref7 = ref5[1], getSearchResults = ref7.getSearchResults, getSearchSuggestions = ref7.getSearchSuggestions, setSearchPageData = ref7.setSearchPageData;
    var settings = (0,dist.useSettings)();
    var router = (0,dist.useRouter)();
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,Filters/* useSearchFilters */.Sr)(), 2), ref9 = ref8[0], selectedFilters = ref9.selectedFilters, filterSummary = ref9.filterSummary, clearSelectedFilters = ref8[1].clearSelectedFilters;
    var ref10 = (0,_sliced_to_array/* default */.Z)((0,Sort/* useSearchSort */.q)(), 2), sortCollection = ref10[1].sortCollection;
    var sendViewSearchResultsEvent = (0,hooks/* useDataLayerActions */.KZ)().sendViewSearchResultsEvent;
    var ref11 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useLocalStorage */._)("searchTerm", ""), 1), searchQuery = ref11[0];
    var ref12 = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* default.searchCurrentResultsPage */.ZP.searchCurrentResultsPage), 2), currentResultsPage = ref12[0], setCurrentResultsPage = ref12[1];
    var selectedSort = (0,store/* useRecoilValue */.sJ)(store/* default.searchSelectedSort */.ZP.searchSelectedSort);
    var setSwatchesMap = (0,store/* useSetRecoilState */.Zl)(store/* default.swatchesMap */.ZP.swatchesMap);
    var ref13 = (0,react.useState)(true), loading = ref13[0], setLoading = ref13[1];
    var ref14 = (0,react.useState)(false), mounted = ref14[0], setMounted = ref14[1];
    var ref15 = (0,react.useState)(false), correctedQueryOverridden = ref15[0], setCorrectedQueryOverridden = ref15[1];
    var query = (0,react.useMemo)(function() {
        var ref;
        return searchQuery && searchQuery !== "" ? searchQuery : ((ref = router.query) === null || ref === void 0 ? void 0 : ref.query) || "";
    }, [
        (ref = router.query) === null || ref === void 0 ? void 0 : ref.query,
        searchQuery
    ]);
    var spellcorrect = ((ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.spellcorrect) || true;
    var tag = ((ref2 = router.query) === null || ref2 === void 0 ? void 0 : ref2.tag) || "";
    var swatches = (settings === null || settings === void 0 ? void 0 : (ref3 = settings.collection) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.colors) === null || ref4 === void 0 ? void 0 : ref4.swatches) || [];
    var isPageAutocomplete = (pageSuggested === null || pageSuggested === void 0 ? void 0 : pageSuggested.type) === "completed";
    var deps = [
        query,
        currentResultsPage,
        selectedSort,
        JSON.stringify(selectedFilters),
        spellcorrect,
        tag,
        mounted, 
    ];
    var resetSettingsOnMount = (0,react.useCallback)(function() {
        if (mounted) return;
        setMounted(true);
        setCurrentResultsPage(1);
        clearSelectedFilters();
        sortCollection({
            field: null,
            direction: null
        });
        setLoading(true);
    }, []);
    // check for search suggestions, then return results
    var getSuggestionsThenResults = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var ref, ref1, ref2, data, exactTerm, isAutocomplete, searchTerm, searchData, redirect;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!mounted) return [
                        2
                    ];
                    setCorrectedQueryOverridden(spellcorrect === "false");
                    if (!query && !tag) {
                        setSearchPageData(null);
                        setLoading(false);
                        return [
                            2
                        ];
                    }
                    return [
                        4,
                        getSearchSuggestions({
                            query: query,
                            isPage: true
                        })
                    ];
                case 1:
                    data = _state.sent();
                    exactTerm = null;
                    if (query) {
                        exactTerm = spellcorrect === "false" ? data === null || data === void 0 ? void 0 : data.query : (data === null || data === void 0 ? void 0 : data["corrected-query"]) || (data === null || data === void 0 ? void 0 : data.query);
                    }
                    isAutocomplete = (data === null || data === void 0 ? void 0 : (ref = data.suggested) === null || ref === void 0 ? void 0 : ref.type) === "completed";
                    searchTerm = isAutocomplete ? data === null || data === void 0 ? void 0 : (ref1 = data.suggested) === null || ref1 === void 0 ? void 0 : ref1.text : exactTerm;
                    return [
                        4,
                        getSearchResults({
                            query: searchTerm,
                            isAutocomplete: isAutocomplete,
                            isPage: true,
                            tag: tag,
                            selectedFilters: selectedFilters
                        })
                    ];
                case 2:
                    searchData = _state.sent();
                    redirect = searchData === null || searchData === void 0 ? void 0 : (ref2 = searchData.merchandising) === null || ref2 === void 0 ? void 0 : ref2.redirect;
                    if (redirect) {
                        router.push(redirect);
                        return [
                            2
                        ];
                    }
                    setLoading(false);
                    return [
                        2
                    ];
            }
        });
    }), (0,_to_consumable_array/* default */.Z)(deps));
    (0,react.useEffect)(function() {
        resetSettingsOnMount();
    }, []);
    (0,react.useEffect)(function() {
        getSuggestionsThenResults();
    }, (0,_to_consumable_array/* default */.Z)(deps));
    (0,react.useEffect)(function() {
        return function() {
            setSearchPageData(null);
            setCurrentResultsPage(1);
            clearSelectedFilters();
            sortCollection({
                field: null,
                direction: null
            });
        };
    }, []);
    (0,react.useEffect)(function() {
        var _location = window.location, origin = _location.origin, pathname = _location.pathname, search = _location.search;
        var params = new URLSearchParams(search);
        params.delete("query");
        var updatedUrl = "".concat(origin).concat(pathname).concat(params.toString() !== "" ? "?".concat(params) : "");
        window.history.replaceState(window.history.state, "", updatedUrl);
    }, [
        query
    ]);
    (0,react.useEffect)(function() {
        var _swatchesMap = swatches.reduce(function(map, swatch) {
            var ref;
            map[(ref = swatch.name) === null || ref === void 0 ? void 0 : ref.toLowerCase()] = swatch;
            return map;
        }, {});
        setSwatchesMap(_swatchesMap);
    }, [
        JSON.stringify(swatches)
    ]);
    (0,react.useEffect)(function() {
        sendViewSearchResultsEvent({
            products: pageResults,
            isSearchPage: true,
            searchTerm: query
        });
    }, [
        pageResults,
        sendViewSearchResultsEvent
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Container */.W2, {
        "data-comp": SearchPage.displayName,
        sx: theme.wrapper,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(SearchPageHeader, {
                correctedQueryOverridden: correctedQueryOverridden,
                filterSummary: filterSummary,
                isPageAutocomplete: isPageAutocomplete,
                loading: loading,
                pageSpellCorrection: pageSpellCorrection,
                pageSuggested: pageSuggested,
                query: query,
                totalPageResults: totalPageResults
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Grid */.rj, {
                sx: {
                    gridTemplateColumns: [
                        "1fr",
                        "200px 1fr"
                    ],
                    columnGap: 6,
                    rowGap: 11
                },
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Filters/* DesktopFilters */.d$, {
                        merchandising: merchandising
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Filters/* MobileFilters */.z, {}),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(SearchGrid, {
                        merchandising: merchandising,
                        searchTerm: query
                    })
                ]
            })
        ]
    });
});
SearchPage.displayName = "SearchPage";

;// CONCATENATED MODULE: ./src/snippets/Search/SearchPage/index.js


;// CONCATENATED MODULE: ./src/snippets/Search/index.js






/***/ }),

/***/ 81234:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "UQ": function() { return /* reexport */ Accordion; },
  "FV": function() { return /* reexport */ Accordions; },
  "o4": function() { return /* reexport */ AddToCart; },
  "Yu": function() { return /* reexport */ BackInStockModal; },
  "Ct": function() { return /* reexport */ Badge; },
  "Oo": function() { return /* reexport */ Breadcrumbs; },
  "pI": function() { return /* reexport */ BuyWithPrime; },
  "uQ": function() { return /* reexport */ CartSearchSidebarShell; },
  "g0": function() { return /* reexport */ CollectionCategories; },
  "IP": function() { return /* reexport */ ColorsSidebar; },
  "PY": function() { return /* reexport */ CountrySelector; },
  "nz": function() { return /* reexport */ DataLayerEventListeners; },
  "Lt": function() { return /* reexport */ Dropdown; },
  "mk": function() { return /* reexport */ EmailSignup; },
  "rF": function() { return /* reexport */ Favorite; },
  "f2": function() { return /* reexport */ FilterOption; },
  "WU": function() { return /* reexport */ FiltersSidebarShell; },
  "$_": function() { return /* reexport */ Footer_Footer; },
  "NA": function() { return /* reexport */ FueledAnalyticsWrapper; },
  "QT": function() { return /* reexport */ GiftWithPurchase; },
  "h4": function() { return /* reexport */ Header_Header_Header; },
  "vs": function() { return /* reexport */ Cart/* ItemsOrEmpty */.vs; },
  "rU": function() { return /* reexport */ Link; },
  "go": function() { return /* reexport */ Locale; },
  "So": function() { return /* reexport */ LoyaltyLionScript; },
  "UG": function() { return /* reexport */ Markdown; },
  "u_": function() { return /* reexport */ Modal; },
  "oF": function() { return /* reexport */ OkendoStars; },
  "aV": function() { return /* reexport */ Overlay_Overlay; },
  "w6": function() { return /* reexport */ PasswordProtectedModal; },
  "t": function() { return /* reexport */ Picture; },
  "Cd": function() { return /* reexport */ ProductItem; },
  "Q4": function() { return /* reexport */ ProductReviews; },
  "xy": function() { return /* reexport */ ProductSwiper; },
  "gW": function() { return /* reexport */ ProductUpsellsList; },
  "oI": function() { return /* reexport */ RebuyModal; },
  "ol": function() { return /* reexport */ Search/* Search */.ol; },
  "Mj": function() { return /* reexport */ Search/* Input */.II; },
  "$0": function() { return /* reexport */ Section; },
  "Ee": function() { return /* reexport */ SeoPageSchema; },
  "WN": function() { return /* reexport */ ShopifyMedia; },
  "YE": function() { return /* reexport */ Sidebar; },
  "QH": function() { return /* reexport */ SidebarShell; },
  "cn": function() { return /* reexport */ SiteReviews; },
  "WG": function() { return /* reexport */ SocialLinks; },
  "Lc": function() { return /* reexport */ StatefulButton; },
  "N$": function() { return /* reexport */ StoreLocator; },
  "ny": function() { return /* reexport */ Svg; },
  "rc": function() { return /* reexport */ VideoWiseScript; },
  "$Z": function() { return /* reexport */ Vwo; },
  "lU": function() { return /* reexport */ WishlistPage; }
});

// UNUSED EXPORTS: LocaleProduct

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(31373);
// EXTERNAL MODULE: ../node_modules/theme-ui/jsx-runtime/dist/theme-ui-jsx-runtime.esm.js + 2 modules
var theme_ui_jsx_runtime_esm = __webpack_require__(70863);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/@theme-ui/components/dist/theme-ui-components.esm.js
var theme_ui_components_esm = __webpack_require__(62680);
// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(23615);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/theme/create.jsx
var create = __webpack_require__(73355);
;// CONCATENATED MODULE: ./src/snippets/Accordions/Header/Header.theme.js

var themed = (0,create/* create */.U)(new function() {
    this.header = {
        width: "100%",
        color: "currentColor"
    };
    this.flex = {
        variant: "flex.row.between.center",
        width: "100%",
        height: "100%"
    };
    this.text = {
        variant: "text.label.1",
        flex: 1,
        whiteSpace: "nowrap",
        textAlign: "left"
    };
    this.icon = {
        width: "20px",
        ml: 2,
        transition: "transform .4s ease-in-out"
    };
}());

;// CONCATENATED MODULE: ./src/snippets/Accordions/Header/Header.jsx







var Header = themed(function(_param) {
    var theme = _param.theme, isOpen = _param.isOpen, iconColor = _param.iconColor, minHeight = _param.minHeight, index = _param.index, inputRef = _param.inputRef, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme",
        "isOpen",
        "iconColor",
        "minHeight",
        "index",
        "inputRef",
        "children"
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-comp": Header.displayName,
        "aria-label": "".concat(isOpen ? "Close" : "Open", " accordion for ").concat(children),
        variant: "buttons.plain"
    }, props), {
        sx: (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.header), {
            minHeight: minHeight,
            lineHeight: minHeight
        }), props.sx),
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
            sx: theme.flex,
            children: [
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                    sx: theme.text,
                    children: children
                }),
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Svg, {
                    src: "/svgs/plus.svg",
                    alt: "plus",
                    viewBox: "0 0 16 16",
                    loading: "lazy",
                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.icon), {
                        color: iconColor,
                        display: isOpen ? "none" : "block"
                    })
                }),
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Svg, {
                    src: "/svgs/minus.svg",
                    alt: "plus",
                    viewBox: "0 0 16 16",
                    loading: "lazy",
                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.icon), {
                        color: iconColor,
                        display: isOpen ? "block" : "none"
                    })
                })
            ]
        })
    }));
});
Header.displayName = "Header";

;// CONCATENATED MODULE: ./src/snippets/Accordions/Header/index.js


;// CONCATENATED MODULE: ./src/snippets/Accordions/Body/Body.theme.js

var Body_theme_themed = (0,create/* create */.U)(new function() {
    this.body = {
        width: "100%",
        gridTemplateColumns: "1fr",
        gridTemplateRows: "auto",
        gridGap: 5,
        pb: 8,
        pl: 0
    };
}());

;// CONCATENATED MODULE: ./src/snippets/Accordions/Body/Body.jsx







var Body = Body_theme_themed(function(_param) {
    var theme = _param.theme, index = _param.index, isOpen = _param.isOpen, inputRef = _param.inputRef, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme",
        "index",
        "isOpen",
        "inputRef",
        "children"
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Grid */.rj, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-comp": Body.displayName,
        as: "ul"
    }, props), {
        sx: (0,_object_spread/* default */.Z)({}, theme.body, props.sx),
        children: children({
            isOpen: isOpen
        })
    }));
});
Body.displayName = "Body";
Body.propTypes = {
    children: (prop_types_default()).func
};

;// CONCATENATED MODULE: ./src/snippets/Accordions/Body/index.js


;// CONCATENATED MODULE: ./src/snippets/Accordions/Accordions.theme.js

var Accordions_theme_themed = (0,create/* create */.U)(new function() {
    this.accordions = {
        borderTop: "1px solid",
        display: "grid",
        gridGap: 0,
        gridTemplateColumns: "1fr",
        gridTemplateRows: "auto",
        width: "100%"
    };
    this.accordion = {
        width: "100%",
        height: "auto",
        overflow: "hidden",
        transition: "max-height .5s ease-in-out",
        position: "relative",
        borderBottom: "1px solid"
    };
}());

;// CONCATENATED MODULE: ./src/snippets/Accordions/Accordion.jsx










var Accordion = Accordions_theme_themed(function(_param) {
    var theme = _param.theme, borderColor = _param.borderColor, children = _param.children, iconColor = _param.iconColor, index = _param.index, isOpen = _param.isOpen, maxHeight = _param.maxHeight, minHeight = _param.minHeight, oneOpenAtATime = _param.oneOpenAtATime, setOpenIndex = _param.setOpenIndex, textColor = _param.textColor, _collapsed = _param.collapsed, collapsed = _collapsed === void 0 ? true : _collapsed, inputRef = _param.inputRef, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme",
        "borderColor",
        "children",
        "iconColor",
        "index",
        "isOpen",
        "maxHeight",
        "minHeight",
        "oneOpenAtATime",
        "setOpenIndex",
        "textColor",
        "collapsed",
        "inputRef"
    ]);
    var ref = (0,react.useState)(!collapsed), localOpen = ref[0], setLocalOpen = ref[1];
    var accordionIsOpen = oneOpenAtATime ? isOpen : localOpen;
    var AccordionContent = (0,react.useMemo)(function() {
        var _$Header = null;
        var _$Body = null;
        react.Children.forEach(children, function(child) {
            var ref, ref1, ref2;
            var displayName = (child === null || child === void 0 ? void 0 : (ref = child.props) === null || ref === void 0 ? void 0 : (ref1 = ref.__EMOTION_TYPE_PLEASE_DO_NOT_USE__) === null || ref1 === void 0 ? void 0 : ref1.displayName) || (child === null || child === void 0 ? void 0 : (ref2 = child.type) === null || ref2 === void 0 ? void 0 : ref2.displayName);
            switch(displayName){
                case "Header":
                    _$Header = /*#__PURE__*/ (0,react.cloneElement)(child, (0,_object_spread/* default */.Z)({
                        iconColor: iconColor,
                        index: index,
                        isOpen: accordionIsOpen,
                        minHeight: minHeight,
                        onClick: function() {
                            oneOpenAtATime ? setOpenIndex(isOpen ? null : index) : setLocalOpen(!localOpen);
                        }
                    }, child.props));
                    break;
                case "Body":
                    _$Body = /*#__PURE__*/ (0,react.cloneElement)(child, (0,_object_spread/* default */.Z)({
                        index: index,
                        isOpen: accordionIsOpen
                    }, child.props));
                    break;
                default:
                    break;
            }
        });
        return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_jsx_runtime_esm/* Fragment */.HY, {
            children: [
                _$Header,
                _$Body
            ]
        });
    }, [
        react.Children.count(children),
        children,
        iconColor,
        index,
        isOpen,
        minHeight,
        setOpenIndex,
        oneOpenAtATime,
        localOpen, 
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-comp": Accordion.displayName
    }, props), {
        sx: (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.accordion), {
            borderColor: borderColor,
            maxHeight: !oneOpenAtATime && localOpen || oneOpenAtATime && isOpen ? maxHeight : minHeight
        }), props.sx),
        children: AccordionContent
    }));
});
Accordion.displayName = "Accordion";
Accordion.Header = Header;
Accordion.Body = Body;
Accordion.propTypes = {
    borderColor: (prop_types_default()).string,
    children: prop_types_default().arrayOf((prop_types_default()).element),
    iconColor: (prop_types_default()).string,
    index: (prop_types_default()).number,
    isOpen: (prop_types_default()).bool,
    collapsed: (prop_types_default()).bool,
    maxHeight: prop_types_default().oneOfType([
        (prop_types_default()).string,
        (prop_types_default()).number
    ]),
    minHeight: prop_types_default().oneOfType([
        (prop_types_default()).string,
        (prop_types_default()).number
    ]),
    oneOpenAtATime: (prop_types_default()).bool,
    setOpenIndex: (prop_types_default()).func,
    textColor: (prop_types_default()).string
};

;// CONCATENATED MODULE: ./src/snippets/Accordions/Accordions.jsx









var Accordions = Accordions_theme_themed(function(_param) {
    var theme = _param.theme, _borderColor = _param.borderColor, borderColor = _borderColor === void 0 ? "text" : _borderColor, children = _param.children, _iconColor = _param.iconColor, iconColor = _iconColor === void 0 ? "text" : _iconColor, _maxHeight = _param.maxHeight, maxHeight = _maxHeight === void 0 ? "350px" : _maxHeight, _minHeight = _param.minHeight, minHeight = _minHeight === void 0 ? "60px" : _minHeight, _textColor = _param.textColor, textColor = _textColor === void 0 ? "text" : _textColor, _oneOpenAtATime = _param.oneOpenAtATime, oneOpenAtATime = _oneOpenAtATime === void 0 ? true : _oneOpenAtATime, _defaultIndex = _param.defaultIndex, defaultIndex = _defaultIndex === void 0 ? 0 : _defaultIndex, inputRef = _param.inputRef, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme",
        "borderColor",
        "children",
        "iconColor",
        "maxHeight",
        "minHeight",
        "textColor",
        "oneOpenAtATime",
        "defaultIndex",
        "inputRef"
    ]);
    var ref = (0,react.useState)(defaultIndex), openIndex = ref[0], setOpenIndex = ref[1];
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Container */.W2, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-comp": Accordions.displayName
    }, props), {
        sx: (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.accordions), {
            borderColor: borderColor,
            color: textColor
        }), props.sx),
        children: react.Children.map(children, function(child, index) {
            var ref, ref1, ref2;
            var displayName = (child === null || child === void 0 ? void 0 : (ref = child.props) === null || ref === void 0 ? void 0 : (ref1 = ref.__EMOTION_TYPE_PLEASE_DO_NOT_USE__) === null || ref1 === void 0 ? void 0 : ref1.displayName) || (child === null || child === void 0 ? void 0 : (ref2 = child.type) === null || ref2 === void 0 ? void 0 : ref2.displayName);
            if (displayName !== "Accordion") return null;
            return /*#__PURE__*/ (0,react.cloneElement)(child, (0,_object_spread/* default */.Z)({
                borderColor: borderColor,
                iconColor: iconColor,
                index: index,
                isOpen: index === openIndex,
                key: index,
                maxHeight: maxHeight,
                minHeight: minHeight,
                setOpenIndex: setOpenIndex,
                oneOpenAtATime: oneOpenAtATime,
                textColor: textColor
            }, child.props));
        })
    }));
});
Accordions.displayName = "Accordions";
Accordions.Item = Accordion;
Accordions.propTypes = {
    textColor: (prop_types_default()).string,
    borderColor: (prop_types_default()).string,
    iconColor: (prop_types_default()).string,
    minHeight: prop_types_default().oneOfType([
        (prop_types_default()).string,
        (prop_types_default()).number
    ]),
    maxHeight: prop_types_default().oneOfType([
        (prop_types_default()).string,
        (prop_types_default()).number
    ]),
    oneOpenAtATime: (prop_types_default()).bool,
    children: prop_types_default().arrayOf((prop_types_default()).element)
};

;// CONCATENATED MODULE: ./src/snippets/Accordions/index.js



// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(23842);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(52050);
// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(59312);
// EXTERNAL MODULE: ../node_modules/@backpackjs/storefront/dist/index.js
var dist = __webpack_require__(52031);
// EXTERNAL MODULE: ./src/hooks/index.js + 64 modules
var hooks = __webpack_require__(74424);
// EXTERNAL MODULE: ./src/store/index.js + 12 modules
var store = __webpack_require__(27695);
// EXTERNAL MODULE: ./src/snippets/AddToCart/useAddToCart.js
var useAddToCart = __webpack_require__(41906);
;// CONCATENATED MODULE: ./src/snippets/AddToCart/AddToCart.theme.js

var AddToCart_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        mr: "auto",
        display: "flex",
        alignItems: "center",
        mt: [
            4,
            8
        ]
    };
    // todo: nested variants should really be button variants that modify primary
    // so that they can be used through a project and not just here
    this.button = {
        variant: "primary",
        width: "100%",
        outline: "none",
        whiteSpace: "nowrap",
        available: {
            cursor: "pointer",
            oneTime: {
                bg: "black"
            },
            subscribe: {
                border: function(t) {
                    return "1px solid ".concat(t.colors.dark);
                },
                bg: "dark",
                "&:hover": {
                    color: "dark"
                }
            }
        },
        unavailable: {
            oneTime: {
                variant: "buttons.secondary",
                color: "mediumDarkGray"
            },
            subscribe: {
                bg: "gray",
                border: function(t) {
                    return "1px solid ".concat(t.colors.dark);
                },
                "&:hover": {
                    bg: "gray",
                    color: "background"
                }
            }
        }
    };
}());

;// CONCATENATED MODULE: ./src/snippets/AddToCart/AddToCart.jsx















var AddToCart = AddToCart_theme_themed(function(_param) {
    var _action = _param.action, action = _action === void 0 ? function() {} : _action, theme = _param.theme, product = _param.product, selectedVariant = _param.selectedVariant, handleUpsellRemove = _param.handleUpsellRemove, rebuyWidget = _param.rebuyWidget, style = _param.style, isProductItem = _param.isProductItem, addToTapCart = _param.addToTapCart, isInitialized = _param.isInitialized, props = (0,_object_without_properties/* default */.Z)(_param, [
        "action",
        "theme",
        "product",
        "selectedVariant",
        "handleUpsellRemove",
        "rebuyWidget",
        "style",
        "isProductItem",
        "addToTapCart",
        "isInitialized"
    ]);
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var settings = (0,dist.useSettings)();
    var gatedPage = (0,store/* useRecoilValue */.sJ)(store/* default.gatedPage */.ZP.gatedPage);
    var enableFullProductAccess = (0,hooks/* useGatedProduct */.sC)({
        product: product,
        gatedPage: gatedPage
    }).enableFullProductAccess;
    var productByHandle = (0,dist.useProductByHandle)({
        handle: selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref = selectedVariant.product) === null || ref === void 0 ? void 0 : ref.handle
    });
    var isDesktop = (0,hooks/* useMatchMedia */.ag)("(min-width: 1024px)");
    var ref7 = (0,react.useState)("Notify Me"), productItemNotifyMeText = ref7[0], setProductItemNotifyMeText = ref7[1];
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,useAddToCart/* useAddToCart */.t)({
        product: productByHandle.product,
        selectedVariant: selectedVariant,
        rebuyWidget: rebuyWidget
    }), 2), ref9 = ref8[0], status = ref9.status, isSoldOut = ref9.isSoldOut, isPreOrder = ref9.isPreOrder, selectedPlan = ref9.selectedPlan, addToCart = ref8[1].addToCart;
    var _addItem = status.addItem, started = _addItem.started, finished = _addItem.finished, success = _addItem.success, errors = _addItem.errors;
    var ref10 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useModal */.dd)(), 2), openModal = ref10[1].openModal;
    var ref11 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useSidebar */.Ap)(), 2), openSidebar = ref11[1].openSidebar;
    var soldOutText = isProductItem ? productItemNotifyMeText : "Notify Me When Available";
    var ref12 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useCartStatus */.T0)(), 2), ref13 = ref12[1], setAddingToCartStatus = ref13.setAddingToCartStatus, setUpdatingCartStatus = ref13.setUpdatingCartStatus;
    var gwp = (0,hooks/* useGiftWithPurchase */.tG)();
    var cartIsMaxed = (0,store/* useRecoilValue */.sJ)(store/* default.cartIsMaxed */.ZP.cartIsMaxed);
    var ignoredProducts = settings === null || settings === void 0 ? void 0 : (ref1 = settings.cart) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.bulkOrdering) === null || ref2 === void 0 ? void 0 : ref2.ignoredProducts;
    var noBackInStockOption = isSoldOut && !isPreOrder && (productByHandle === null || productByHandle === void 0 ? void 0 : (ref3 = productByHandle.product) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.tags) === null || ref4 === void 0 ? void 0 : ref4.includes("no-bis"));
    var text = (status === null || status === void 0 ? void 0 : (ref5 = status.inventoryStatus) === null || ref5 === void 0 ? void 0 : ref5.finished) && product ? noBackInStockOption ? "Sold Out" : !isSoldOut && isPreOrder ? "Pre-order" : isSoldOut ? soldOutText : selectedPlan ? "Subscribe" : "Add to Bag" : "LOADING...";
    var ignoredFromMaxQty = (0,react.useMemo)(function() {
        return ignoredProducts === null || ignoredProducts === void 0 ? void 0 : ignoredProducts.some(function(param) {
            var ignoredProduct = param.product;
            return ignoredProduct.handle === product.handle;
        });
    }, [
        product.handle,
        ignoredProducts
    ]);
    var setGlobalCartStatusOnAdding = (0,react.useCallback)(function() {
        setAddingToCartStatus({
            started: started,
            finished: finished,
            success: success,
            errors: errors
        });
        setUpdatingCartStatus({
            started: started,
            finished: finished,
            success: success,
            errors: errors
        });
        var defaultStatus = {
            started: false,
            finished: false,
            success: false,
            errors: []
        };
        return function() {
            setAddingToCartStatus(defaultStatus);
            setUpdatingCartStatus(defaultStatus);
        };
    }, [
        started,
        finished,
        success
    ]);
    var handleOutOfStock = (0,react.useCallback)(function() {
        // need timeout for delay if a modal is already open
        setTimeout(function() {
            var ref, ref1;
            openModal(/*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(BackInStockModal, {
                legacyResourceId: (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.legacyResourceId) || (product === null || product === void 0 ? void 0 : (ref = product.variants) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.id),
                title: product.title || product.name || ""
            }));
        }, 250);
    }, [
        selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id,
        product.title
    ]);
    (0,react.useEffect)(function() {
        setGlobalCartStatusOnAdding();
    }, [
        started,
        finished,
        success
    ]);
    (0,react.useEffect)(function() {
        if (!isProductItem || !isSoldOut) return;
        setProductItemNotifyMeText(isDesktop ? "Notify Me When Available" : "Notify Me");
    }, [
        isProductItem,
        isDesktop,
        isSoldOut
    ]);
    var isNotifyMe = isSoldOut && !isPreOrder;
    var overMaxDisabled = cartIsMaxed && !isNotifyMe && !ignoredFromMaxQty;
    if (!enableFullProductAccess) return null;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
        sx: (0,_object_spread/* default */.Z)({}, theme.wrapper, style),
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(StatefulButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            disabled: overMaxDisabled,
            "data-comp": AddToCart.displayName,
            sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.button, isNotifyMe || overMaxDisabled || noBackInStockOption ? (0,_object_spread/* default */.Z)({}, theme.button.unavailable, selectedPlan ? theme.button.unavailable.subscribe : (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.button.unavailable.oneTime), {
                borderColor: overMaxDisabled || noBackInStockOption ? "gray" : "text",
                color: overMaxDisabled || noBackInStockOption ? "mediumGray" : "mediumDarkGray",
                ":hover": {
                    borderColor: overMaxDisabled || noBackInStockOption ? "gray" : "text",
                    color: overMaxDisabled || noBackInStockOption ? "mediumGray" : "text",
                    bg: "background"
                }
            })) : (0,_object_spread/* default */.Z)({}, theme.button.available, selectedPlan ? theme.button.available.subscribe : theme.button.available.oneTime)), {
                cursor: overMaxDisabled || noBackInStockOption ? "default" : "pointer",
                whiteSpace: "nowrap",
                overflow: "hidden",
                maxWidth: "100%"
            })
        }, status.addItem), {
            loading: !(status === null || status === void 0 ? void 0 : (ref6 = status.inventoryStatus) === null || ref6 === void 0 ? void 0 : ref6.finished),
            text: {
                default: text,
                started: text,
                success: text,
                error: text
            },
            onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!isNotifyMe) return [
                                3,
                                1
                            ];
                            handleOutOfStock();
                            return [
                                3,
                                3
                            ];
                        case 1:
                            if (isInitialized) {
                                addToTapCart({
                                    lineItems: [
                                        {
                                            variantId: selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.legacyResourceId,
                                            quantity: 1
                                        }
                                    ]
                                });
                                return [
                                    2
                                ];
                            }
                            action();
                            return [
                                4,
                                addToCart({
                                    callback: function(_cart) {
                                        if (handleUpsellRemove) handleUpsellRemove();
                                        if (gwp.isEligible(_cart)) {
                                            openModal(/*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(GiftWithPurchase, {}));
                                        } else {
                                            openSidebar("cart");
                                        }
                                    },
                                    openCart: false
                                })
                            ];
                        case 2:
                            _state.sent();
                            _state.label = 3;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            })
        }))
    });
});
AddToCart.displayName = "AddToCart";

;// CONCATENATED MODULE: ./src/snippets/AddToCart/index.js


// EXTERNAL MODULE: ./src/theme/theme.colors.js
var theme_colors = __webpack_require__(75458);
;// CONCATENATED MODULE: ./src/snippets/BackInStockModal/useBackInStock.js






var useBackInStock = function() {
    var _ref = (0,dist.useStartFinishErrors)(), setStarted = _ref.setStarted, setFinished = _ref.setFinished, setErrors = _ref.setErrors, reset = _ref.reset, status = (0,_object_without_properties/* default */.Z)(_ref, [
        "setStarted",
        "setFinished",
        "setErrors",
        "reset"
    ]);
    var subscribeToBackInStock = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var email, variantId, url, options, response, data, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        email = param.email, variantId = param.variantId;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        if (!email) {
                            return [
                                2,
                                console.error("Missing required parameter: email")
                            ];
                        }
                        if (!variantId) {
                            return [
                                2,
                                console.error("Missing required parameter: variant")
                            ];
                        }
                        reset();
                        setStarted(true);
                        url = "/api/klaviyo";
                        options = {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({
                                action: "postBackInStock",
                                email: email,
                                variant: variantId
                            })
                        };
                        return [
                            4,
                            fetch(url, options)
                        ];
                    case 2:
                        response = _state.sent();
                        return [
                            4,
                            response.json()
                        ];
                    case 3:
                        data = _state.sent();
                        if (data === null || data === void 0 ? void 0 : data.success) {
                            setFinished(true);
                            return [
                                2,
                                data
                            ];
                        }
                        setErrors([
                            "Error with subscribing to back in stock."
                        ]);
                        console.error("Response back from API not successful: ".concat(data));
                        return [
                            2,
                            null
                        ];
                    case 4:
                        error = _state.sent();
                        setErrors([
                            "Error with subscribing to back in stock."
                        ]);
                        console.error("Error with subscribeToBackInStock: ".concat(error));
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    return (0,_object_spread/* default */.Z)({
        subscribeToBackInStock: subscribeToBackInStock,
        setErrors: setErrors,
        reset: reset
    }, status);
};

;// CONCATENATED MODULE: ./src/snippets/BackInStockModal/BackInStockModal.theme.js

var BackInStockModal_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        width: "100%",
        minWidth: "300px",
        maxWidth: "500px",
        "@media only screen and (max-width: 479px)": {
            minWidth: "250px"
        },
        textAlign: "center",
        p: 10
    };
    this.title = {
        variant: "text.h3"
    };
    this.variant = {
        fontSize: 6
    };
    this.description = {
        fontSize: 3,
        mt: 10
    };
    this.input = {
        mb: 11,
        px: 11
    };
    this.checkboxWrapper = {
        display: "flex",
        gap: 4,
        mb: 11
    };
    this.button = {
        width: "100%"
    };
}());

;// CONCATENATED MODULE: ./src/snippets/BackInStockModal/BackInStockModal.jsx














var BackInStockModal = BackInStockModal_theme_themed(function(param) {
    var legacyResourceId = param.legacyResourceId, title = param.title, theme = param.theme;
    var ref;
    var settings = (0,dist.useSettings)();
    var customer = (0,dist.useCustomer)();
    var _ref = useBackInStock(), subscribeToBackInStock = _ref.subscribeToBackInStock, status = (0,_object_without_properties/* default */.Z)(_ref, [
        "subscribeToBackInStock"
    ]);
    var submitEmailSignup = (0,hooks/* useEmailSignup */.vk)().submitEmailSignup;
    var closeModal = (0,hooks/* useModal */.dd)()[1].closeModal;
    var ref1 = (0,react.useState)((customer === null || customer === void 0 ? void 0 : customer.email) || ""), email = ref1[0], setEmail = ref1[1];
    var ref2 = (0,react.useState)(true), subscribe = ref2[0], setSubscribe = ref2[1];
    var ref3 = (settings === null || settings === void 0 ? void 0 : (ref = settings.product) === null || ref === void 0 ? void 0 : ref.backInStock) || {}, description = ref3.description, _modalButtonText = ref3.modalButtonText, modalButtonText = _modalButtonText === void 0 ? "Notify When Available" : _modalButtonText;
    var titles = (0,react.useMemo)(function() {
        var ref, ref1, ref2;
        var titleArr = (ref = title === null || title === void 0 ? void 0 : title.replaceAll("&amp;", "&")) === null || ref === void 0 ? void 0 : ref.split("|");
        return {
            product: (titleArr === null || titleArr === void 0 ? void 0 : (ref1 = titleArr[0]) === null || ref1 === void 0 ? void 0 : ref1.trim()) || "",
            variant: ((ref2 = titleArr === null || titleArr === void 0 ? void 0 : titleArr.slice(1)) === null || ref2 === void 0 ? void 0 : ref2.join("|").trim()) || ""
        };
    }, [
        title
    ]);
    var emailListId = "Mrk7yV";
    var handleSubscribe = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        if (!email || !legacyResourceId) return [
                            2
                        ];
                        if (!subscribe) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            submitEmailSignup(emailListId, email, "BackInStockModal")
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            subscribeToBackInStock({
                                email: email,
                                variantId: legacyResourceId
                            })
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(e) {
            return _ref.apply(this, arguments);
        };
    }(), [
        email,
        legacyResourceId,
        subscribe
    ]);
    (0,react.useEffect)(function() {
        if (status.success) {
            setTimeout(function() {
                return closeModal();
            }, 2000);
        }
    }, [
        status.success
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Container */.W2, {
        "data-comp": BackInStockModal.displayName,
        sx: theme.wrapper,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                sx: theme.title,
                children: titles.product
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                as: "h3",
                sx: theme.variant,
                children: titles.variant
            }),
            description && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                sx: theme.description,
                children: description
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                as: "form",
                mt: 10,
                onSubmit: handleSubscribe,
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Input */.II, {
                        name: "email",
                        placeholder: "Email Address",
                        type: "email",
                        value: email,
                        onChange: function(e) {
                            return setEmail(e.target.value);
                        },
                        required: true,
                        sx: theme.input
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                        sx: theme.checkboxWrapper,
                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Label */.__, {
                            variant: "forms.checkbox",
                            sx: {
                                alignItems: "flex-start",
                                mb: 0,
                                gap: 2
                            },
                            children: [
                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Checkbox */.XZ, {
                                    type: "checkbox",
                                    id: "subscribe_for_newsletter",
                                    name: "subscribe",
                                    defaultChecked: true,
                                    onChange: function(param) {
                                        var checked = param.target.checked;
                                        return setSubscribe(checked);
                                    },
                                    sx: {
                                        backgroundColor: subscribe ? theme_colors/* colors.black */.O.black : "transparent",
                                        color: subscribe ? theme_colors/* colors.white */.O.white : theme_colors/* colors.black */.O.black
                                    }
                                }),
                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Text */.xv, {
                                    sx: {
                                        textAlign: "left"
                                    },
                                    children: "Subscribe to Br\xfcMate mailing list. Must be subscribed to receive back-in-stock notifications."
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(StatefulButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, status), {
                        showErrors: false,
                        text: {
                            started: modalButtonText,
                            success: "Email Subscribed!",
                            error: "Please Try Again Later",
                            default: modalButtonText
                        },
                        sx: theme.button
                    }))
                ]
            })
        ]
    });
});
BackInStockModal.displayName = "BackInStockModal";

;// CONCATENATED MODULE: ./src/snippets/BackInStockModal/index.js


// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(86677);
// EXTERNAL MODULE: ./src/utils/index.js + 7 modules
var utils = __webpack_require__(39136);
;// CONCATENATED MODULE: ./src/snippets/Badge/Badge.theme.js



var Badge_theme_themed = (0,create/* create */.U)(new function() {
    var _this = this;
    this.badgeWrapper = function(isPdp) {
        return {
            position: "absolute",
            top: isPdp ? [
                0,
                10
            ] : 0,
            left: isPdp ? [
                0,
                10
            ] : 0,
            display: "flex",
            alignItems: "center",
            height: "24px"
        };
    };
    this.badge = function(isPdp) {
        return {
            variant: "text.label.1",
            fontSize: "11px",
            textTransform: "capitalize",
            zIndex: 1,
            height: "24px",
            lineHeight: "24px",
            bg: "red",
            color: "white",
            px: "11px",
            pointerEvents: "none"
        };
    };
    this.personalize = function(isPdp) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, _this.badge(isPdp)), {
            color: function(t) {
                return t.colors.dark;
            },
            padding: 0,
            height: "19px"
        });
    };
}());

;// CONCATENATED MODULE: ./src/snippets/Badge/Badge.jsx










var Badge = Badge_theme_themed(function(param) {
    var theme = param.theme, handle = param.handle, product = param.product, isPdp = param.isPdp;
    var ref, ref1, ref2, ref3;
    var settings = (0,dist.useSettings)();
    var ref4 = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : (ref = settings.product) === null || ref === void 0 ? void 0 : ref.badges), customBadges = ref4.customBadges, soldOutBadge = ref4.soldOutBadge, onSaleBadge = ref4.onSaleBadge;
    var inventory = (0,dist.useProductInventoryByHandle)({
        handle: handle,
        withQuantity: true
    }).inventory;
    var route = (0,next_router.useRouter)().route;
    var variants = (0,react.useMemo)(function() {
        var ref;
        if (!product) return [];
        var _variants = [];
        (ref = product.variants) === null || ref === void 0 ? void 0 : ref.find(function(variant) {
            if (variant.product.handle === product.handle) {
                _variants.push(variant);
                return false;
            }
            return true;
        });
        return _variants;
    }, [
        product === null || product === void 0 ? void 0 : product.id
    ]);
    var isSoldOut = (0,react.useMemo)(function() {
        var ref;
        if (!(variants === null || variants === void 0 ? void 0 : variants.length) || (inventory === null || inventory === void 0 ? void 0 : (ref = inventory.variants) === null || ref === void 0 ? void 0 : ref.length)) return null;
        return variants.every(function(variant) {
            var ref, ref1;
            var variantStorefrontId = (0,utils/* isEncoded */.x)(inventory === null || inventory === void 0 ? void 0 : inventory.id) ? (0,utils/* getEncodedId */.m4)(variant.storefrontId) : variant.storefrontId;
            var variantInventory = inventory ? inventory === null || inventory === void 0 ? void 0 : (ref = inventory.variants) === null || ref === void 0 ? void 0 : ref[variantStorefrontId] : null;
            var variantSoldOut = variantInventory ? variantInventory.quantityAvailable <= 0 && variant.inventoryPolicy !== "CONTINUE" && ((ref1 = variantInventory.product) === null || ref1 === void 0 ? void 0 : ref1.handle) !== "brumate-e-gift-card" : false;
            return variantSoldOut;
        });
    }, [
        variants,
        inventory === null || inventory === void 0 ? void 0 : inventory.variants
    ]);
    var selectedVariant = product === null || product === void 0 ? void 0 : (ref1 = product.variants) === null || ref1 === void 0 ? void 0 : ref1[0];
    var price = selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref2 = selectedVariant.priceV2) === null || ref2 === void 0 ? void 0 : ref2.amount;
    var compareAtPrice = selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref3 = selectedVariant.compareAtPriceV2) === null || ref3 === void 0 ? void 0 : ref3.amount;
    var isOnSale = (0,react.useMemo)(function() {
        return parseFloat(price) < parseFloat(compareAtPrice);
    }, [
        price,
        compareAtPrice
    ]);
    var isPersonalization = (0,react.useMemo)(function() {
        var ref;
        if (isPdp) return false;
        return (product === null || product === void 0 ? void 0 : (ref = product.tags) === null || ref === void 0 ? void 0 : ref.find(function(tag) {
            return (tag === null || tag === void 0 ? void 0 : tag.toLowerCase()) === "personalized-enabled";
        })) === "personalized-enabled";
    }, [
        product === null || product === void 0 ? void 0 : product.id,
        isPdp
    ]);
    var badge = (0,react.useMemo)(function() {
        var ref, ref1;
        if (!(product === null || product === void 0 ? void 0 : (ref = product.tags) === null || ref === void 0 ? void 0 : ref.length) || !(customBadges === null || customBadges === void 0 ? void 0 : customBadges.length)) return null;
        var shopifyTag = product === null || product === void 0 ? void 0 : (ref1 = product.tags) === null || ref1 === void 0 ? void 0 : ref1.find(function(tag) {
            return tag.startsWith("badge::");
        });
        var match = customBadges.find(function(_badge) {
            return _badge.tag === shopifyTag;
        });
        if (match) return match;
        if ((shopifyTag === null || shopifyTag === void 0 ? void 0 : shopifyTag.toLowerCase()) === "badge::new") return {
            text: "New",
            color: "#000000",
            backgroundColor: "transparent",
            tag: "badge::New"
        };
        return match;
    }, [
        product === null || product === void 0 ? void 0 : product.id,
        customBadges
    ]);
    var bersonalizeBadge = (0,react.useMemo)(function() {
        return isPersonalization && !isPdp && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Paragraph */.nv, {
            "data-comp": Badge.displayName,
            sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.personalize(isPdp)), {
                backgroundColor: "transparent",
                marginLeft: "8px"
            }),
            children: [
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Svg, {
                    alt: "personalization icon",
                    src: "/svgs/noprecache/svg/pencil.svg",
                    viewBox: "0 0 19 19",
                    width: "19px",
                    height: "19px"
                }),
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("span", {
                    className: "sr-only",
                    children: "Personalize"
                })
            ]
        });
    }, [
        isPersonalization,
        isPdp
    ]);
    var badgeContent = (0,react.useMemo)(function() {
        switch(true){
            case isSoldOut:
                {
                    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                        "data-comp": Badge.displayName,
                        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.badge(isPdp)), {
                            color: (soldOutBadge === null || soldOutBadge === void 0 ? void 0 : soldOutBadge.color) || "white",
                            bg: (soldOutBadge === null || soldOutBadge === void 0 ? void 0 : soldOutBadge.backgroundColor) || "#5d5d5d"
                        }),
                        children: (soldOutBadge === null || soldOutBadge === void 0 ? void 0 : soldOutBadge.text) || "Sold Out"
                    });
                }
            case isOnSale:
                {
                    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                        "data-comp": Badge.displayName,
                        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.badge(isPdp)), {
                            color: (onSaleBadge === null || onSaleBadge === void 0 ? void 0 : onSaleBadge.color) || "red",
                            bg: (onSaleBadge === null || onSaleBadge === void 0 ? void 0 : onSaleBadge.backgroundColor) || "transparent"
                        }),
                        children: (onSaleBadge === null || onSaleBadge === void 0 ? void 0 : onSaleBadge.text) || "Sale"
                    });
                }
            case !!badge:
                return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                    "data-comp": Badge.displayName,
                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.badge(isPdp)), {
                        color: (badge === null || badge === void 0 ? void 0 : badge.color) || "black",
                        bg: (badge === null || badge === void 0 ? void 0 : badge.backgroundColor) || "transparent"
                    }),
                    children: badge === null || badge === void 0 ? void 0 : badge.text
                });
            default:
                return null;
        }
    }, [
        isSoldOut,
        isOnSale,
        badge
    ]);
    return (!!badgeContent || !!bersonalizeBadge) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
        sx: (0,_object_spread/* default */.Z)({}, theme.badgeWrapper(isPdp)),
        children: [
            badgeContent,
            bersonalizeBadge
        ]
    });
});
Badge.displayName = "Badge";

;// CONCATENATED MODULE: ./src/snippets/Badge/index.js


;// CONCATENATED MODULE: ./src/snippets/Breadcrumbs/Breadcrumbs.theme.js

var Breadcrumbs_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        height: "30px",
        px: [
            8,
            10,
            11,
            80
        ],
        alignItems: "center",
        flexWrap: [
            "nowrap",
            "wrap"
        ]
    };
    this.itemTitle = {
        textAlign: "left",
        textDecoration: "unset",
        mr: 4,
        fontSize: [
            "13px",
            "15px"
        ],
        "@media screen and (max-width: 479px)": {
            fontSize: "12px",
            mr: 0
        }
    };
    this.itemTitleLink = {
        textAlign: "left",
        textDecoration: "underline",
        textUnderlineOffset: "2px",
        textDecorationThickness: "1px",
        mr: 4,
        fontSize: [
            "13px",
            "15px"
        ],
        "@media screen and (max-width: 479px)": {
            fontSize: "12px",
            mr: 2
        }
    };
    this.icon = {
        width: "12px",
        userSelect: "none",
        color: "currentColor",
        mr: 4,
        "@media screen and (max-width: 479px)": {
            mr: 2
        }
    };
}());

;// CONCATENATED MODULE: ./src/snippets/Breadcrumbs/Breadcrumbs.jsx









var storeCrumbs = function(crumbs) {
    var ref;
    (ref = window.sessionStorage) === null || ref === void 0 ? void 0 : ref.setItem("crumbs", JSON.stringify(crumbs));
};
var readCrumbs = function() {
    var ref;
    var crumbs = (ref = window.sessionStorage) === null || ref === void 0 ? void 0 : ref.getItem("crumbs");
    if (!crumbs) {
        crumbs = [];
        storeCrumbs(crumbs);
    } else {
        crumbs = JSON.parse(crumbs);
    }
    return crumbs;
};
var Breadcrumbs = Breadcrumbs_theme_themed(function(param) {
    var isHome = param.isHome, isSuperCollection = param.isSuperCollection, superCollectionTitle = param.superCollectionTitle, isCollection = param.isCollection, collectionTitle = param.collectionTitle, isPdp = param.isPdp, selectedVariant = param.selectedVariant, collection = param.collection, theme = param.theme;
    var ref;
    var router = (0,next_router.useRouter)();
    var activeRoute = router.asPath;
    var ref1 = (0,react.useState)([]), breadCrumbs = ref1[0], setBreadCrumbs = ref1[1];
    var subCollections = (0,store/* useRecoilValue */.sJ)(store/* default.collectionsMap */.ZP.collectionsMap);
    var superCollectionCrumb = (0,react.useMemo)(function() {
        if (!isSuperCollection) return null;
        return {
            title: superCollectionTitle,
            url: activeRoute
        };
    }, [
        activeRoute,
        isSuperCollection,
        superCollectionTitle
    ]);
    var collectionCrumb = (0,react.useMemo)(function() {
        if (!isCollection) return null;
        return {
            title: collectionTitle,
            url: activeRoute
        };
    }, [
        activeRoute,
        isCollection,
        collectionTitle
    ]);
    var isSubCollection = (0,react.useMemo)(function() {
        return null;
        if (!subCollections) return null;
        var active = subCollections === null || subCollections === void 0 ? void 0 : subCollections.find(function(item) {
            var ref;
            return item === null || item === void 0 ? void 0 : (ref = item.url) === null || ref === void 0 ? void 0 : ref.includes(activeRoute);
        });
        return active;
    }, [
        activeRoute,
        subCollections
    ]);
    var productCrumb = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3;
        if (!isPdp) return null;
        var titleArr = selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref = selectedVariant.product) === null || ref === void 0 ? void 0 : (ref1 = ref.title) === null || ref1 === void 0 ? void 0 : ref1.split("|");
        var productColor = (titleArr === null || titleArr === void 0 ? void 0 : (ref2 = titleArr[1]) === null || ref2 === void 0 ? void 0 : ref2.trim()) || "";
        var productTitle = (titleArr === null || titleArr === void 0 ? void 0 : (ref3 = titleArr[0]) === null || ref3 === void 0 ? void 0 : ref3.trim()) || "";
        if (productTitle !== null && productColor !== null) {
            return {
                title: "".concat(productColor, " ").concat(productTitle),
                titleMobile: "".concat(productColor, " ").concat(productTitle).length > 38 ? "".concat(productTitle) : "".concat(productColor, " ").concat(productTitle),
                url: activeRoute
            };
        }
        return null;
    }, [
        selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref = selectedVariant.product) === null || ref === void 0 ? void 0 : ref.title,
        activeRoute,
        isPdp
    ]);
    (0,react.useEffect)(function() {
        if (isHome) {
            storeCrumbs([
                {
                    title: "Home",
                    url: "/"
                }, 
            ]);
        }
        if (isSuperCollection) {
            storeCrumbs([
                {
                    title: "Home",
                    url: "/"
                }, 
            ]);
            var crumbs = readCrumbs();
            crumbs === null || crumbs === void 0 ? void 0 : crumbs.push(superCollectionCrumb);
            storeCrumbs(crumbs);
        } else if (isCollection) {
            if (isSubCollection) {
                var crumbs1 = readCrumbs();
                var hasProductCrumb = crumbs1 === null || crumbs1 === void 0 ? void 0 : crumbs1.find(function(crumb) {
                    var ref;
                    return crumb === null || crumb === void 0 ? void 0 : (ref = crumb.url) === null || ref === void 0 ? void 0 : ref.includes("products");
                });
                var hasCollection = crumbs1 === null || crumbs1 === void 0 ? void 0 : crumbs1.find(function(crumb) {
                    return crumb === null || crumb === void 0 ? void 0 : crumb.url.includes("/collections");
                });
                if (hasProductCrumb && !hasCollection || !hasProductCrumb && hasCollection) {
                    crumbs1.splice(-1);
                } else if (hasProductCrumb && hasCollection) {
                    crumbs1.splice(-2, 0, collectionCrumb);
                } else {
                    crumbs1 === null || crumbs1 === void 0 ? void 0 : crumbs1.push(collectionCrumb);
                }
                storeCrumbs(crumbs1);
            } else {
                storeCrumbs([
                    {
                        title: "Home",
                        url: "/"
                    }, 
                ]);
                var crumbs2 = readCrumbs();
                crumbs2 === null || crumbs2 === void 0 ? void 0 : crumbs2.push(collectionCrumb);
                storeCrumbs(crumbs2);
            }
        } else if (isPdp) {
            var crumbs3 = readCrumbs();
            if ((crumbs3 === null || crumbs3 === void 0 ? void 0 : crumbs3.findIndex(function(crumb) {
                return (crumb === null || crumb === void 0 ? void 0 : crumb.url) === "/" && (crumb === null || crumb === void 0 ? void 0 : crumb.title) === "Home";
            })) !== -1) {
                crumbs3.splice(0, 1);
            }
            var alreadyExist = crumbs3 === null || crumbs3 === void 0 ? void 0 : crumbs3.find(function(crumb) {
                return (crumb === null || crumb === void 0 ? void 0 : crumb.title) === (productCrumb === null || productCrumb === void 0 ? void 0 : productCrumb.title) && (crumb === null || crumb === void 0 ? void 0 : crumb.url.includes("products"));
            });
            var isProductVariant = crumbs3 === null || crumbs3 === void 0 ? void 0 : crumbs3.findIndex(function(crumb) {
                return crumb === null || crumb === void 0 ? void 0 : crumb.url.includes("products");
            });
            var hasCollection1 = crumbs3 === null || crumbs3 === void 0 ? void 0 : crumbs3.findIndex(function(crumb) {
                return crumb === null || crumb === void 0 ? void 0 : crumb.url.includes("/collections");
            });
            var existCollection = crumbs3 === null || crumbs3 === void 0 ? void 0 : crumbs3.find(function(crumb) {
                return (crumb === null || crumb === void 0 ? void 0 : crumb.url.includes("collections")) && (crumb === null || crumb === void 0 ? void 0 : crumb.url) === "/collections/".concat(collection === null || collection === void 0 ? void 0 : collection.handle);
            });
            if (isProductVariant !== -1) {
                crumbs3.splice(isProductVariant, 1, productCrumb);
            } else {
                crumbs3 === null || crumbs3 === void 0 ? void 0 : crumbs3.push(productCrumb);
            }
            if ((collection === null || collection === void 0 ? void 0 : collection.handle) && !existCollection) {
                if (hasCollection1 !== -1) {
                    crumbs3.splice(hasCollection1, 1, {
                        title: collection === null || collection === void 0 ? void 0 : collection.title,
                        url: "/collections/".concat(collection === null || collection === void 0 ? void 0 : collection.handle)
                    });
                } else {
                    crumbs3.splice(-1, 0, {
                        title: collection === null || collection === void 0 ? void 0 : collection.title,
                        url: "/collections/".concat(collection === null || collection === void 0 ? void 0 : collection.handle)
                    });
                }
            }
            storeCrumbs(crumbs3);
        }
        var crumbs4 = readCrumbs();
        setBreadCrumbs(crumbs4 === null || crumbs4 === void 0 ? void 0 : crumbs4.filter(function(crumb) {
            return crumb !== null;
        }));
    }, [
        superCollectionCrumb,
        collectionCrumb,
        productCrumb,
        isCollection,
        isSubCollection,
        isSuperCollection,
        isPdp,
        isHome,
        collection === null || collection === void 0 ? void 0 : collection.handle, 
    ]);
    if (isHome) return null;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
        "data-comp": Breadcrumbs.displayName,
        sx: theme.wrapper,
        children: breadCrumbs === null || breadCrumbs === void 0 ? void 0 : breadCrumbs.map(function(crumb, index) {
            var isLast = index === breadCrumbs.length - 1 || (crumb === null || crumb === void 0 ? void 0 : crumb.url) === router.asPath;
            return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(react.Fragment, {
                children: [
                    isLast && (crumb === null || crumb === void 0 ? void 0 : crumb.title) ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                        className: "flex-shrink overflow-hidden",
                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                            sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.itemTitle), {
                                width: "100%"
                            }),
                            children: isPdp && (crumb === null || crumb === void 0 ? void 0 : crumb.titleMobile) ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_jsx_runtime_esm/* Fragment */.HY, {
                                children: [
                                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("span", {
                                        className: "max-sm:hidden",
                                        children: crumb === null || crumb === void 0 ? void 0 : crumb.title
                                    }),
                                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("span", {
                                        className: "inline-block sm:hidden whitespace-nowrap overflow-hidden overflow-ellipsis w-full",
                                        children: crumb === null || crumb === void 0 ? void 0 : crumb.titleMobile
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("span", {
                                children: crumb === null || crumb === void 0 ? void 0 : crumb.title
                            })
                        })
                    }) : null,
                    !isLast && (crumb === null || crumb === void 0 ? void 0 : crumb.title) ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Link, {
                        href: crumb === null || crumb === void 0 ? void 0 : crumb.url,
                        sx: theme.itemTitleLink,
                        className: "flex-shrink-0",
                        children: crumb === null || crumb === void 0 ? void 0 : crumb.title
                    }) : null,
                    !isLast && (isSuperCollection || isCollection || isPdp ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("span", {
                        className: "mr-2",
                        children: "/"
                    }) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Svg, {
                        src: "/svgs/chevron/right.svg#right",
                        alt: "",
                        viewBox: "0 0 16 16",
                        draggable: false,
                        sx: theme.icon,
                        className: "flex-shrink-0"
                    }))
                ]
            }, index);
        })
    });
});
Breadcrumbs.displayName = "Breadcrumbs";

;// CONCATENATED MODULE: ./src/snippets/Breadcrumbs/index.js


// EXTERNAL MODULE: ./src/snippets/Cart/index.js + 45 modules
var Cart = __webpack_require__(8977);
;// CONCATENATED MODULE: ./src/snippets/CartSearchSidebar/Header/Header.theme.js

var Header_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        variant: "flex.row.center.center",
        bg: "background",
        color: "text",
        position: "relative",
        borderBottom: function(t) {
            return "1px solid ".concat(t.colors.gray);
        },
        height: "52px"
    };
    this.cart = {
        width: 24,
        zIndex: 1
    };
    this.back = {
        width: 24,
        zIndex: 1
    }, this.heading = {
        variant: "text.h5",
        textAlign: "center",
        whiteSpace: "nowrap"
    };
}());

;// CONCATENATED MODULE: ./src/snippets/CartSearchSidebar/Header/Header.jsx











var Header_Header = Header_theme_themed(function(_param) {
    var theme = _param.theme, inputRef = _param.inputRef, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme",
        "inputRef"
    ]);
    var ref, ref1;
    var cartCount = (0,Cart/* useCartCount */.iF)();
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useSidebar */.Ap)(), 2), ref3 = ref2[0], isCart = ref3.isCart, isColors = ref3.isColors, ref4 = ref2[1], closeSidebar = ref4.closeSidebar, openCartSidebar = ref4.openCartSidebar;
    var settings = (0,dist.useSettings)();
    var cartHeading = (settings === null || settings === void 0 ? void 0 : (ref = settings.cart) === null || ref === void 0 ? void 0 : ref.heading) || "Cart";
    var cartSearchHeading = isCart ? cartHeading : "Search";
    // Cart or Search — side bars
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-comp": Header_Header.displayName,
        ref: inputRef
    }, props), {
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                sx: theme.wrapper,
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                        variant: "buttons.plain",
                        onClick: closeSidebar,
                        "aria-label": isColors ? "Close Colors Sidebar" : "Close ".concat(isCart ? "Cart" : "Search"),
                        sx: {
                            position: "absolute",
                            left: 10,
                            top: "50%",
                            transform: "translateY(-50%)"
                        },
                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Svg, {
                            viewBox: "0 0 24 24",
                            alt: "Close",
                            src: "/svgs/arrow-left.svg#arrow-left",
                            sx: theme.back
                        })
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                        as: "h5",
                        sx: theme.heading,
                        children: isColors ? "Color" : cartSearchHeading
                    }),
                    !isColors && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                        sx: {
                            variant: "flex.row.start.center",
                            height: "100%",
                            pl: 10,
                            width: "80px",
                            // borderLeft: t => `1px solid ${t.colors.gray}`,
                            position: "absolute",
                            right: 0,
                            top: 0,
                            bg: "dark"
                        },
                        children: [
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                                variant: "buttons.plain",
                                onClick: openCartSidebar,
                                "aria-label": "Open cart",
                                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Svg, {
                                    alt: "cart",
                                    viewBox: "0 0 48 48",
                                    src: "/svgs/cta/cart.svg#cart",
                                    sx: {
                                        width: "20px",
                                        color: "white"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Paragraph */.nv, {
                                sx: {
                                    variant: ((ref1 = cartCount === null || cartCount === void 0 ? void 0 : cartCount.toFixed(0)) === null || ref1 === void 0 ? void 0 : ref1.length) > 2 ? "text.label.2" : "text.label.1",
                                    ml: 2,
                                    userSelect: "none",
                                    color: "white"
                                },
                                children: [
                                    "(",
                                    cartCount,
                                    ")"
                                ]
                            })
                        ]
                    })
                ]
            }),
            isCart && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Cart/* FreeShippingMeter */.qL, {})
        ]
    }));
});
Header_Header.displayName = "CartSearchSidebarHeader";

;// CONCATENATED MODULE: ./src/snippets/CartSearchSidebar/Header/index.js


;// CONCATENATED MODULE: ./src/snippets/CartSearchSidebar/Content/Content.theme.js

var Content_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        position: "relative"
    };
}());

;// CONCATENATED MODULE: ./src/snippets/CartSearchSidebar/Content/Content.jsx










var Content = Content_theme_themed(function(_param) {
    var theme = _param.theme, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme"
    ]);
    var cartEmpty = (0,dist.useCartEmpty)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,hooks/* useSidebar */.Ap)(), 1), ref1 = ref[0], isCart = ref1.isCart, isSearch = ref1.isSearch, isColors = ref1.isColors;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useCartStatus */.T0)(), 1), addingToCartStatus = ref2[0].addingToCartStatus;
    var isAddingToCart = addingToCartStatus.started && !addingToCartStatus.finished;
    // Cart ItemsOrEmpty or Search — side drawers
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_jsx_runtime_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                "data-comp": Content.displayName
            }, props), {
                sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.wrapper), {
                    height: isCart && cartEmpty ? "100%" : "auto"
                }),
                children: [
                    isCart ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Cart/* ItemsOrEmpty */.vs, {}) : null,
                    isSearch ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Search/* Search */.ol, {}) : null,
                    isColors ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(ColorsSidebar, {}) : null
                ]
            })),
            isAddingToCart && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                variant: "flex.row.center.center",
                sx: {
                    variant: "box.fill",
                    bg: "rgba(255,255,255,0.5)"
                },
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Spinner */.$j, {
                    width: "24px",
                    color: "mediumDarkGray"
                })
            })
        ]
    });
});
Content.displayName = "CartSearchSidebarContent";

;// CONCATENATED MODULE: ./src/snippets/CartSearchSidebar/Content/index.js


// EXTERNAL MODULE: ./src/snippets/Search/index.js + 38 modules
var Search = __webpack_require__(70457);
;// CONCATENATED MODULE: ./src/snippets/CartSearchSidebar/Footer/Footer.theme.js

var Footer_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {};
}());

;// CONCATENATED MODULE: ./src/snippets/CartSearchSidebar/Footer/Footer.jsx








var Footer = Footer_theme_themed(function(param) {
    var theme = param.theme, inputRef = param.inputRef;
    var cartCount = (0,dist.useCartCount)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,hooks/* useSidebar */.Ap)(), 1), ref1 = ref[0], isCart = ref1.isCart, isSearch = ref1.isSearch;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": Footer.displayName,
        ref: inputRef,
        children: [
            isCart ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_jsx_runtime_esm/* Fragment */.HY, {
                children: [
                    !!cartCount && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Cart/* Totals */.jA, {
                        inSidebar: true
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Cart/* Upsell */.QH, {
                        inSidebar: true
                    })
                ]
            }) : null,
            isSearch ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Search/* SearchFooter */.BW, {}) : null
        ]
    });
});
Footer.displayName = "CartSearchSidebarFooter";

;// CONCATENATED MODULE: ./src/snippets/CartSearchSidebar/Footer/index.js


;// CONCATENATED MODULE: ./src/snippets/CartSearchSidebar/CartSearchSidebar.jsx





function CartSearchSidebar() {
    // Cart or Search — sidebar views
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(Sidebar, {
        "data-comp": CartSearchSidebar.displayName,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Sidebar.Header, {
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Header_Header, {})
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Sidebar.Content, {
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Content, {})
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Sidebar.Footer, {
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Footer, {})
            })
        ]
    });
}
CartSearchSidebar.displayName = "CartSearchSidebar";

;// CONCATENATED MODULE: ./src/snippets/CartSearchSidebar/CartSearchSidebarShell.jsx





// Desktop menu drawer — hovered item sub items
function CartSearchSidebarShell(props) {
    var ref = (0,_sliced_to_array/* default */.Z)((0,hooks/* useSidebar */.Ap)(), 1), sidebar = ref[0].sidebar;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(SidebarShell, {
        open: sidebar,
        children: sidebar ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(CartSearchSidebar, {}) : null
    });
}
CartSearchSidebarShell.displayName = "CartSearchSidebarShell";

;// CONCATENATED MODULE: ./src/snippets/CartSearchSidebar/index.js


// EXTERNAL MODULE: ../node_modules/swiper/esm/react/swiper.js + 8 modules
var react_swiper = __webpack_require__(48148);
// EXTERNAL MODULE: ../node_modules/swiper/esm/react/swiper-slide.js
var swiper_slide = __webpack_require__(95445);
;// CONCATENATED MODULE: ./src/snippets/CollectionCategories/Mobile/CollectionCategoriesMobile.theme.js

var CollectionCategoriesMobile_theme_themed = (0,create/* create */.U)(new function() {
    this.itemLink = {
        width: "100%"
    };
    this.picture = {};
    this.itemTitle = {
        fontSize: "13px",
        lineHeight: "20px",
        textAlign: "center",
        mt: 2,
        textUnderlineOffset: "2px",
        textDecorationThickness: "1px"
    };
    this.button = {
        width: "100%",
        textAlign: "left",
        position: "relative",
        height: "52px",
        p: 8,
        borderTop: function(t) {
            return "1px solid ".concat(t.colors.gray);
        },
        display: "flex",
        alignItems: "center",
        borderBottomStyle: "none",
        borderBottomWidth: "1px",
        borderBottomColor: "gray"
    };
    this.title = {
        variant: "text.label.1",
        display: "inline-block",
        mr: 4
    };
    this.selected = {
        color: "mediumDarkGray",
        variant: "text.base",
        fontSize: [
            3,
            4
        ],
        whiteSpace: "nowrap"
    };
    this.icon = {
        position: "absolute",
        right: 8,
        top: "50%",
        width: "24px",
        height: "24px",
        transform: "translateY(-50%)"
    };
    this.sticky = {
        top: [
            "var(--header-height)"
        ],
        position: "sticky",
        bg: "white",
        zIndex: 2,
        gridArea: "sidebar"
    };
}());

;// CONCATENATED MODULE: ./src/snippets/CollectionCategories/Mobile/CollectionCategoriesItem.jsx








var CollectionCategoriesItem = CollectionCategoriesMobile_theme_themed(function(param) {
    var item = param.item, collectionHandle = param.collectionHandle, theme = param.theme;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var productHandle = (ref = item.mobileImage) === null || ref === void 0 ? void 0 : (ref1 = ref.product) === null || ref1 === void 0 ? void 0 : ref1.handle;
    var manualSrc = (ref2 = item.mobileImage) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.image) === null || ref3 === void 0 ? void 0 : ref3.src;
    var product = (0,dist.useProductByHandle)({
        handle: productHandle
    }).product;
    var firstImage = (0,react.useMemo)(function() {
        var ref, ref1;
        return (ref1 = product === null || product === void 0 ? void 0 : (ref = product.media) === null || ref === void 0 ? void 0 : ref.find(function(item) {
            return item.mediaContentType === "IMAGE";
        })) === null || ref1 === void 0 ? void 0 : ref1.image;
    }, [
        product === null || product === void 0 ? void 0 : product.id
    ]);
    var isActive = (0,react.useMemo)(function() {
        var ref, ref1;
        return ((ref = item.link) === null || ref === void 0 ? void 0 : (ref1 = ref.url) === null || ref1 === void 0 ? void 0 : ref1.split("/").pop()) === collectionHandle;
    }, [
        (ref4 = item.link) === null || ref4 === void 0 ? void 0 : ref4.url,
        collectionHandle
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(Link, {
        "data-comp": CollectionCategoriesItem.displayName,
        href: (ref5 = item.link) === null || ref5 === void 0 ? void 0 : ref5.url,
        newTab: (ref6 = item.link) === null || ref6 === void 0 ? void 0 : ref6.newTab,
        sx: theme.itemLink,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Picture, {
                alt: (ref7 = item.link) === null || ref7 === void 0 ? void 0 : ref7.text,
                images: [
                    {
                        src: firstImage === null || firstImage === void 0 ? void 0 : firstImage.originalSrc,
                        width: 200,
                        ratio: 1
                    }, 
                ],
                imageSx: {
                    p: manualSrc ? 0 : 7,
                    objectFit: manualSrc ? "cover" : "contain"
                },
                sx: (0,_object_spread/* default */.Z)({}, theme.picture)
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.itemTitle), {
                    textDecoration: isActive ? "underline" : "unset"
                }),
                children: (ref8 = item.link) === null || ref8 === void 0 ? void 0 : ref8.text
            })
        ]
    });
});
CollectionCategoriesItem.displayName = "CollectionCategoriesItem";

;// CONCATENATED MODULE: ./src/snippets/CollectionCategories/Mobile/CollectionCategoriesMobile.jsx










var CollectionCategoriesMobile = CollectionCategoriesMobile_theme_themed(function(param) {
    var categories = param.categories, name = param.name, collectionHandle = param.collectionHandle, activeCategory = param.activeCategory, isSuperCollection = param.isSuperCollection, theme = param.theme;
    var ref = (0,_sliced_to_array/* default */.Z)((0,hooks/* useFiltersSidebar */.JE)(), 2), toggleFiltersSidebar = ref[1].toggleFiltersSidebar;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": CollectionCategoriesMobile.displayName,
        sx: {
            display: [
                "contents",
                "none"
            ]
        },
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(react_swiper/* Swiper */.t, {
                spaceBetween: 8,
                slidesPerView: 2.5,
                slidesOffsetBefore: 10,
                slidesOffsetAfter: 10,
                breakpoints: {
                    600: {
                        slidesPerView: 3.5,
                        spaceBetween: 16,
                        slidesOffsetBefore: 16,
                        slidesOffsetAfter: 16
                    }
                },
                sx: {
                    mb: 10,
                    cursor: "grab"
                },
                children: categories.map(function(item, index) {
                    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(swiper_slide/* SwiperSlide */.o, {
                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(CollectionCategoriesItem, {
                            item: item,
                            collectionHandle: collectionHandle
                        })
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                sx: theme.sticky,
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Button */.zx, {
                    variant: "buttons.plain",
                    onClick: function() {
                        return toggleFiltersSidebar({
                            values: categories,
                            label: name,
                            isSize: true
                        });
                    },
                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.button), {
                        borderBottomStyle: isSuperCollection ? "solid" : "none"
                    }),
                    children: [
                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                            as: "h5",
                            sx: theme.title,
                            children: name
                        }),
                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                            sx: theme.selected,
                            children: activeCategory
                        }),
                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Svg, {
                            viewBox: "0 0 24 24",
                            src: "/svgs/arrow-right.svg#arrow-right",
                            sx: theme.icon
                        })
                    ]
                })
            })
        ]
    });
});
CollectionCategoriesMobile.displayName = "CollectionCategoriesMobile";

;// CONCATENATED MODULE: ./src/snippets/CollectionCategories/Mobile/index.js


;// CONCATENATED MODULE: ./src/snippets/CollectionCategories/Desktop/CollectionCategoriesDesktop.theme.js

var CollectionCategoriesDesktop_theme_themed = (0,create/* create */.U)(new function() {
    this.title = {
        textAlign: "center",
        mt: 2,
        textUnderlineOffset: "2px",
        textDecorationThickness: "1px"
    };
    this.list = {
        display: [
            "none",
            "flex"
        ],
        flexDirection: "column",
        alignItems: "flex-start",
        gap: 3,
        mb: 10
    };
    this.heading = {
        variant: "text.h3",
        mb: "28px",
        overflowWrap: "break-word"
    };
    this.accordionHeader = {
        heading: {
            variant: "text.label.1",
            display: "inline-block",
            mr: 4
        },
        selected: {
            flex: 1,
            color: "mediumDarkGray",
            variant: "text.base",
            fontSize: [
                3,
                4
            ],
            whiteSpace: "nowrap",
            textTransform: "none",
            letterSpacing: 0,
            overflow: "hidden",
            textOverflow: "ellipsis"
        }
    };
    this.item = function(isActive) {
        return {
            link: {
                display: "flex"
            },
            picture: {
                width: "40px",
                mr: 5
            },
            label: {
                pt: 5,
                flex: 1,
                textDecoration: "none",
                textUnderlineOffset: "2px",
                textDecorationThickness: "1px",
                color: "text",
                ":hover": {
                    textDecoration: "underline"
                }
            }
        };
    };
    this.sticky = {
        top: [
            "var(--header-height)"
        ],
        position: "sticky",
        bg: "white",
        zIndex: 2,
        gridArea: "sidebar"
    };
}());

;// CONCATENATED MODULE: ./src/snippets/CollectionCategories/Desktop/CollectionCategoriesDesktopItem.jsx







var CollectionCategoriesDesktopItem = CollectionCategoriesDesktop_theme_themed(function(_param) {
    var item = _param.item, collectionHandle = _param.collectionHandle, theme = _param.theme, props = (0,_object_without_properties/* default */.Z)(_param, [
        "item",
        "collectionHandle",
        "theme"
    ]);
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var productHandle = (ref = item.mobileImage) === null || ref === void 0 ? void 0 : (ref1 = ref.product) === null || ref1 === void 0 ? void 0 : ref1.handle;
    var manualSrc = (ref2 = item.mobileImage) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.image) === null || ref3 === void 0 ? void 0 : ref3.src;
    var product = (0,dist.useProductByHandle)({
        handle: productHandle
    }).product;
    var firstImage = (0,react.useMemo)(function() {
        var ref, ref1;
        return (ref1 = product === null || product === void 0 ? void 0 : (ref = product.media) === null || ref === void 0 ? void 0 : ref.find(function(item) {
            return item.mediaContentType === "IMAGE";
        })) === null || ref1 === void 0 ? void 0 : ref1.image;
    }, [
        product === null || product === void 0 ? void 0 : product.id
    ]);
    var isActive = (0,react.useMemo)(function() {
        var ref, ref1;
        return ((ref = item.link) === null || ref === void 0 ? void 0 : (ref1 = ref.url) === null || ref1 === void 0 ? void 0 : ref1.split("/").pop()) === collectionHandle;
    }, [
        (ref4 = item.link) === null || ref4 === void 0 ? void 0 : ref4.url,
        collectionHandle
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(Link, {
        "data-comp": CollectionCategoriesDesktopItem.displayName,
        href: (ref5 = item.link) === null || ref5 === void 0 ? void 0 : ref5.url,
        newTab: (ref6 = item.link) === null || ref6 === void 0 ? void 0 : ref6.newTab,
        tabIndex: props.tabIndex || "0",
        "aria-hidden": props["aria-hidden"] || "false",
        sx: theme.item(isActive).link,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Picture, {
                alt: (ref7 = item.link) === null || ref7 === void 0 ? void 0 : ref7.text,
                images: [
                    {
                        src: firstImage === null || firstImage === void 0 ? void 0 : firstImage.originalSrc,
                        width: 40,
                        ratio: 1
                    }, 
                ],
                sx: theme.item(isActive).picture,
                imageSx: {
                    objectFit: manualSrc ? "cover" : "contain"
                }
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                sx: theme.item(isActive).label,
                children: (ref8 = item.link) === null || ref8 === void 0 ? void 0 : ref8.text
            })
        ]
    });
});
CollectionCategoriesDesktopItem.displayName = "CollectionCategoriesDesktopItem";

;// CONCATENATED MODULE: ./src/snippets/CollectionCategories/Desktop/CollectionCategoriesDesktop.jsx







var CollectionCategoriesDesktop = CollectionCategoriesDesktop_theme_themed(function(param) {
    var categories = param.categories, name = param.name, collectionHandle = param.collectionHandle, isSuperCollection = param.isSuperCollection, activeCategory = param.activeCategory, collapsed = param.collapsed, theme = param.theme;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Accordions, {
        "data-comp": CollectionCategoriesDesktop.displayName,
        textColor: "text",
        borderColor: "gray",
        iconColor: "text",
        minHeight: "52px",
        maxHeight: "800px",
        oneOpenAtATime: false,
        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.sticky), {
            display: [
                "none",
                "grid"
            ]
        }),
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(Accordion, {
            collapsed: collapsed,
            sx: {
                borderBottomStyle: isSuperCollection ? "solid" : "none"
            },
            children: [
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Accordion.Header, {
                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                        variant: "flex.row.start.center",
                        children: [
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                                as: "h5",
                                sx: theme.accordionHeader.heading,
                                children: name
                            }),
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                                sx: theme.accordionHeader.selected,
                                children: activeCategory
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Accordion.Body, {
                    children: function(param) {
                        var isOpen = param.isOpen;
                        return categories.map(function(item, index) {
                            return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                                as: "li",
                                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(CollectionCategoriesDesktopItem, {
                                    item: item,
                                    collectionHandle: collectionHandle,
                                    tabIndex: isOpen ? "0" : "-1",
                                    "aria-hidden": isOpen ? "false" : "true"
                                })
                            }, index);
                        });
                    }
                })
            ]
        })
    });
});
CollectionCategoriesDesktop.displayName = "CollectionCategoriesDesktop";

;// CONCATENATED MODULE: ./src/snippets/CollectionCategories/Desktop/index.js


;// CONCATENATED MODULE: ./src/snippets/CollectionCategories/CollectionCategories.theme.js

var CollectionCategories_theme_themed = (0,create/* create */.U)(new function() {
    this.link = {
        width: "100%"
    };
    this.overlay = {
        width: "100%",
        minHeight: "100%",
        bg: "white",
        opacity: 0.5
    };
    this.title = {
        textAlign: "center",
        mt: 2,
        textUnderlineOffset: "2px",
        textDecorationThickness: "1px"
    };
    this.list = {
        display: [
            "none",
            "flex"
        ],
        flexDirection: "column",
        alignItems: "flex-start",
        gap: 3,
        mb: 10
    };
}());

;// CONCATENATED MODULE: ./src/snippets/CollectionCategories/CollectionCategories.jsx







var CollectionCategories = CollectionCategories_theme_themed(function(param) {
    var categories = param.categories, _name = param.name, name = _name === void 0 ? "Size" : _name, _collapsed = param.collapsed, collapsed = _collapsed === void 0 ? true : _collapsed, _isSuperCollection = param.isSuperCollection, isSuperCollection = _isSuperCollection === void 0 ? false : _isSuperCollection;
    var ref;
    var router = (0,dist.useRouter)();
    var collectionHandle = (ref = router.query) === null || ref === void 0 ? void 0 : ref.handle;
    var activeCategory = (0,react.useMemo)(function() {
        var ref;
        if (!collectionHandle) return null;
        var active = categories === null || categories === void 0 ? void 0 : categories.find(function(category) {
            var ref;
            return ((ref = category.link) === null || ref === void 0 ? void 0 : ref.url.split("/").pop()) === collectionHandle;
        });
        return (active === null || active === void 0 ? void 0 : (ref = active.link) === null || ref === void 0 ? void 0 : ref.text) || null;
    }, [
        collectionHandle,
        categories
    ]);
    return (categories === null || categories === void 0 ? void 0 : categories.length) ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": CollectionCategories.displayName,
        sx: {
            display: "contents"
        },
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(CollectionCategoriesMobile, {
                categories: categories,
                name: name,
                collectionHandle: collectionHandle,
                activeCategory: activeCategory,
                isSuperCollection: isSuperCollection
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(CollectionCategoriesDesktop, {
                categories: categories,
                name: name,
                collectionHandle: collectionHandle,
                activeCategory: activeCategory,
                isSuperCollection: isSuperCollection,
                collapsed: collapsed
            })
        ]
    }) : null;
});
CollectionCategories.displayName = "CollectionCategories";

;// CONCATENATED MODULE: ./src/snippets/CollectionCategories/index.js


;// CONCATENATED MODULE: ./src/snippets/ColorsSidebar/ColorsSidebar.theme.js

var ColorsSidebar_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        width: "100%",
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        columnGap: 8,
        rowGap: 12,
        px: 8,
        py: 11
    };
    this.option = {
        display: "flex",
        flexDirection: "column",
        available: {
            selected: {
                // border: (t) => `1px solid ${t.colors.text}`,
                bg: "background",
                color: "text"
            },
            unselected: {
                // border: (t) => `1px solid ${t.colors.gray}`,
                bg: "background",
                color: "text"
            }
        }
    };
    this.color = {
        color: "mediumDarkGray",
        mt: 4,
        mb: 8
    };
}());

;// CONCATENATED MODULE: ./src/snippets/ColorsSidebar/ColorsSidebarItem.jsx










var ColorsSidebarItem = ColorsSidebar_theme_themed(function(param) {
    var theme = param.theme, handle = param.handle, selectedColor = param.selectedColor;
    var product = (0,dist.useProductByHandle)({
        handle: handle
    }).product;
    var ref = (0,_sliced_to_array/* default */.Z)((0,hooks/* useSidebar */.Ap)(), 2), closeSidebar = ref[1].closeSidebar;
    var color = (0,react.useMemo)(function() {
        var ref, ref1, ref2;
        if (!product) return null;
        return (ref2 = (ref1 = product === null || product === void 0 ? void 0 : (ref = product.tags) === null || ref === void 0 ? void 0 : ref.find(function(tag) {
            return tag.match(new RegExp("color::", "gi"));
        })) === null || ref1 === void 0 ? void 0 : ref1.split("::")[1]) === null || ref2 === void 0 ? void 0 : ref2.trim();
    }, [
        product === null || product === void 0 ? void 0 : product.id
    ]);
    var firstImage = (0,react.useMemo)(function() {
        var ref, ref1;
        return (ref1 = product === null || product === void 0 ? void 0 : (ref = product.media) === null || ref === void 0 ? void 0 : ref.find(function(item) {
            return item.mediaContentType === "IMAGE";
        })) === null || ref1 === void 0 ? void 0 : ref1.image;
    }, [
        product === null || product === void 0 ? void 0 : product.id
    ]);
    var isSelected = color === selectedColor;
    var selectText = isSelected ? "Selected" : "Select";
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": ColorsSidebarItem.displayName,
        as: "li",
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(Link, {
            href: "/products/".concat(handle),
            onClick: function(e) {
                if (isSelected) {
                    e.preventDefault();
                } else {
                    closeSidebar();
                }
            },
            sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.option, isSelected ? theme.option.available.selected : theme.option.available.unselected), {
                cursor: isSelected ? "default" : "pointer"
            }),
            children: [
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Picture, {
                    alt: color,
                    images: [
                        {
                            src: firstImage === null || firstImage === void 0 ? void 0 : firstImage.originalSrc,
                            ratio: 1,
                            width: 200
                        }, 
                    ],
                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Badge, {
                        handle: handle,
                        product: product
                    })
                }),
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                    sx: theme.color,
                    children: color
                }),
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                    variant: isSelected ? "buttons.primary" : "buttons.secondary",
                    sx: {
                        ":hover": isSelected ? {
                            bg: "text",
                            color: "white"
                        } : {}
                    },
                    children: selectText
                })
            ]
        })
    }, handle);
});
ColorsSidebarItem.displayName = "ColorsSidebarItem";

;// CONCATENATED MODULE: ./src/snippets/ColorsSidebar/ColorsSidebar.jsx







var ColorsSidebar = ColorsSidebar_theme_themed(function(param) {
    var theme = param.theme;
    var ref = (0,_sliced_to_array/* default */.Z)((0,hooks/* useSelectedOptions */.C)(), 1), selectedOptions = ref[0];
    var product = (0,store/* useRecoilValue */.sJ)(store/* default.initialProduct */.ZP.initialProduct);
    var selectedColor = selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.color;
    var handles = product === null || product === void 0 ? void 0 : product.groupOptionsMap.handle;
    return (product === null || product === void 0 ? void 0 : product.isGrouped) && (handles === null || handles === void 0 ? void 0 : handles.length) ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": ColorsSidebar.displayName,
        as: "ul",
        sx: theme.wrapper,
        children: handles.map(function(handle, index) {
            return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(ColorsSidebarItem, {
                handle: handle,
                selectedColor: selectedColor
            }, "color-sidebar-item-".concat(index));
        })
    }) : null;
});
ColorsSidebar.displayName = "ColorsSidebar";

;// CONCATENATED MODULE: ./src/snippets/ColorsSidebar/index.js


;// CONCATENATED MODULE: ./src/snippets/CountrySelector/CountrySelector.theme.js

var CountrySelector_theme_themed = (0,create/* create */.U)(new function() {
    this.dropdown = {};
    this.item = {
        variant: "flex.row.start.center",
        width: "100%",
        cursor: "pointer",
        color: "text",
        height: "inherit",
        pl: 10,
        pr: 8,
        "&:hover": {
            bg: "whitesmoke"
        },
        icon: {
            width: 16
        },
        selectedName: {
            variant: "text.base",
            pt: 6
        },
        optionName: {
            variant: "text.base"
        },
        toggle: {
            width: 16,
            ml: "auto"
        }
    };
}());

;// CONCATENATED MODULE: ./src/snippets/CountrySelector/CountrySelector.jsx











var CountrySelector = CountrySelector_theme_themed(function(_param) {
    var theme = _param.theme, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme"
    ]);
    var countries = (0,dist.useCountries)();
    var _ref = (0,dist.useCountry)(), country = _ref.country, updateCountry = _ref.updateCountry, updateStatus = (0,_object_without_properties/* default */.Z)(_ref, [
        "country",
        "updateCountry"
    ]);
    var singleCountry = (countries === null || countries === void 0 ? void 0 : countries.length) === 1;
    var haveCountries = (countries === null || countries === void 0 ? void 0 : countries.length) > 0;
    var countryOptions = (0,react.useMemo)(function() {
        if (!(countries === null || countries === void 0 ? void 0 : countries.length)) return null;
        var codes = [
            "US",
            "AU",
            "CA",
            "FR",
            "GB",
            "NZ"
        ];
        return countries.filter(function(country) {
            return codes.includes(country.isoCode);
        });
    }, [
        countries === null || countries === void 0 ? void 0 : countries.length
    ]);
    var updateSelectedCountry = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(selected) {
            var selectedCountry;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        selectedCountry = countries.find(function(_country) {
                            return _country.isoCode === selected.isoCode;
                        });
                        return [
                            4,
                            updateCountry({
                                country: selectedCountry
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(selected) {
            return _ref.apply(this, arguments);
        };
    }(), [
        countries === null || countries === void 0 ? void 0 : countries.length
    ]);
    return singleCountry ? null : haveCountries ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(Dropdown, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        variant: "countries",
        label: "Location",
        initial: country,
        onSelected: updateSelectedCountry
    }, props), {
        sx: (0,_object_spread/* default */.Z)({}, theme.dropdown, props.sx),
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Dropdown.Selected, {
                children: function(param) {
                    var selecting = param.selecting, selected = param.selected;
                    var ref;
                    /*#__PURE__*/ return (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.item), {
                            bg: selecting ? "lightGray" : "background"
                        }),
                        children: [
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                                sx: theme.item.selectedName,
                                children: (ref = selected.currency) === null || ref === void 0 ? void 0 : ref.isoCode
                            }),
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Svg, {
                                alt: "Select a country",
                                viewBox: "0 0 16 16",
                                src: "/svgs/chevron/up.svg#up",
                                sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.item.toggle), {
                                    transition: "all 0.2s ease-in-out",
                                    transform: selecting ? "rotate(0deg)" : "rotate(-180deg)"
                                })
                            })
                        ]
                    });
                }
            }),
            countryOptions.map(function(_country) {
                /*#__PURE__*/ return (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Dropdown.Option, {
                    option: _country,
                    children: function(param) {
                        var selecting = param.selecting, isSelected = param.isSelected, option = param.option;
                        var ref;
                        return isSelected ? null : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                            sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.item), {
                                bg: isSelected ? "lightGray" : "background"
                            }),
                            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                                sx: theme.item.optionName,
                                children: (ref = option.currency) === null || ref === void 0 ? void 0 : ref.isoCode
                            })
                        });
                    }
                }, _country.name);
            })
        ]
    })) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
        variant: "flex.row.center.center",
        sx: {
            width: "100%",
            maxWidth: "150px",
            height: "44px"
        },
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Spinner */.$j, {
            height: "20px"
        })
    });
});
CountrySelector.displayName = "CountrySelector";

;// CONCATENATED MODULE: ./src/snippets/CountrySelector/index.js


;// CONCATENATED MODULE: ./src/snippets/Fueled/hooks/useScriptLoad.js





var DEFAULT_TIMEOUT = 10000; // 10 seconds
var POLL_INTERVAL = 100; // 100ms
var MAX_RETRY = 100;
var SCRIPTS_LOADED = {};
var waitForCallback = function(callback) {
    var timeout = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : DEFAULT_TIMEOUT;
    var startTime = Date.now();
    var retry = 0;
    return new Promise(function(resolve, reject) {
        var check = function() {
            retry += 1;
            if (callback()) {
                resolve();
                return;
            }
            if (retry >= MAX_RETRY) {
                reject(new Error("Max retry attempts reached"));
                return;
            }
            if (Date.now() - startTime > timeout) {
                reject(new Error("Timeout waiting for callback"));
                return;
            }
            setTimeout(check, POLL_INTERVAL);
        };
        check();
    });
};
var loadScript = function(attributes) {
    var target = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "head";
    var scriptId = attributes.id || attributes.src || attributes.innerHTML || "";
    var isScriptLoaded = SCRIPTS_LOADED[scriptId];
    if (isScriptLoaded) {
        return isScriptLoaded;
    }
    var scriptPromise = new Promise(function(resolve, reject) {
        var innerHTML = attributes.innerHTML, waitFor = attributes.waitFor, attrs = (0,_object_without_properties/* default */.Z)(attributes, [
            "innerHTML",
            "waitFor"
        ]);
        if (!attributes.src && !innerHTML) {
            reject(new Error("Either src or innerHTML must be provided"));
            return;
        }
        var script = document.createElement("script");
        Object.entries(attrs).forEach(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
            if (value !== undefined && key !== "code") {
                script.setAttribute(key, String(value));
            }
        });
        if (attributes.src) {
            script.src = attributes.src;
            script.onload = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                var error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!waitFor) {
                                resolve();
                                return [
                                    2
                                ];
                            }
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                waitForCallback(waitFor)
                            ];
                        case 2:
                            _state.sent();
                            resolve();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error = _state.sent();
                            reject(error);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
        } else if (innerHTML) {
            script.innerHTML = innerHTML;
            (0,_async_to_generator/* default */.Z)(function() {
                var error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!waitFor) {
                                resolve();
                                return [
                                    2
                                ];
                            }
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                waitForCallback(waitFor)
                            ];
                        case 2:
                            _state.sent();
                            resolve();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error = _state.sent();
                            reject(error);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            })();
        }
        script.onerror = function(e) {
            return reject(new Error("Failed to load script: ".concat(e.message)));
        };
        var targetElement = target === "head" ? document.head : document.body;
        targetElement.appendChild(script);
    });
    SCRIPTS_LOADED[scriptId] = scriptPromise;
    return scriptPromise;
};
var useScriptLoad = function() {
    var attributes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, target = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "body", ready = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    var ref = (0,react.useState)("idle"), status = ref[0], setStatus = ref[1];
    var ref1 = (0,react.useState)(), error = ref1[0], setError = ref1[1];
    (0,react.useEffect)(function() {
        if (!ready) return;
        var loadAndTrackScript = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var err;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            setStatus("loading");
                            return [
                                4,
                                loadScript(attributes, target)
                            ];
                        case 1:
                            _state.sent();
                            setStatus("ready");
                            return [
                                3,
                                3
                            ];
                        case 2:
                            err = _state.sent();
                            setError(err);
                            setStatus("error");
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function loadAndTrackScript() {
                return _ref.apply(this, arguments);
            };
        }();
        loadAndTrackScript();
    }, [
        attributes.src,
        ready,
        attributes.innerHTML,
        target
    ]);
    return {
        status: status,
        error: error
    };
};
/* harmony default export */ var hooks_useScriptLoad = ((/* unused pure expression or super */ null && (useScriptLoad)));

;// CONCATENATED MODULE: ./src/snippets/Fueled/hooks/useCustomerPrivacy.js





var CONSENT_API = "https://cdn.shopify.com/shopifycloud/consent-tracking-api/v0.1/consent-tracking-api.js";
var CONSENT_API_WITH_BANNER = "https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js";
function useApisLoaded(param) {
    var withPrivacyBanner = param.withPrivacyBanner, onLoaded = param.onLoaded;
    var observing = (0,react.useRef)({
        customerPrivacy: false,
        privacyBanner: false
    });
    var ref = (0,react.useState)(withPrivacyBanner ? [
        false,
        false
    ] : [
        false
    ]), apisLoaded = ref[0], setApisLoaded = ref[1];
    var loaded = apisLoaded.every(Boolean);
    var setLoaded = {
        customerPrivacy: function() {
            if (withPrivacyBanner) {
                setApisLoaded(function(prev) {
                    return [
                        true,
                        prev[1]
                    ];
                });
            } else {
                setApisLoaded(function() {
                    return [
                        true
                    ];
                });
            }
        },
        privacyBanner: function() {
            if (!withPrivacyBanner) {
                return;
            }
            setApisLoaded(function(prev) {
                return [
                    prev[0],
                    true
                ];
            });
        }
    };
    (0,react.useEffect)(function() {
        if (loaded && onLoaded) {
            onLoaded();
        }
    }, [
        loaded,
        onLoaded
    ]);
    return {
        observing: observing,
        setLoaded: setLoaded
    };
}
function parseStoreDomain(checkoutDomain) {
    if (false) {}
    var host = window.document.location.host;
    var checkoutDomainParts = checkoutDomain.split(".").reverse();
    var currentDomainParts = host.split(".").reverse();
    var sameDomainParts = [];
    checkoutDomainParts.forEach(function(part, index) {
        if (part === currentDomainParts[index]) {
            sameDomainParts.push(part);
        }
    });
    return sameDomainParts.reverse().join("."); // eslint-disable-line
}
function overridePrivacyBannerMethods(param) {
    var privacyBanner = param.privacyBanner, config = param.config;
    var loadBanner = function loadBanner(userConfig) {
        if (typeof userConfig === "object") {
            originalLoadBanner((0,_object_spread/* default */.Z)({}, config, userConfig));
            return;
        }
        originalLoadBanner(config);
    };
    var showPreferences = function showPreferences(userConfig) {
        if (typeof userConfig === "object") {
            originalShowPreferences((0,_object_spread/* default */.Z)({}, config, userConfig));
            return;
        }
        originalShowPreferences(config);
    };
    var originalLoadBanner = privacyBanner.loadBanner;
    var originalShowPreferences = privacyBanner.showPreferences;
    return {
        loadBanner: loadBanner,
        showPreferences: showPreferences
    };
}
function overrideCustomerPrivacySetTrackingConsent(param) {
    var customerPrivacy = param.customerPrivacy, config = param.config;
    var updatedSetTrackingConsent = function updatedSetTrackingConsent(consent, callback) {
        original((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
            headlessStorefront: true
        }), consent), callback);
    };
    var original = customerPrivacy.setTrackingConsent;
    var locale = config.locale, country = config.country, rest = (0,_object_without_properties/* default */.Z)(config, [
        "locale",
        "country"
    ]);
    return updatedSetTrackingConsent;
}
var hasEmitted = false;
function emitCustomerPrivacyApiLoaded() {
    if (hasEmitted) return;
    hasEmitted = true;
    var event = new CustomEvent("shopifyCustomerPrivacyApiLoaded");
    document.dispatchEvent(event);
}
function getCustomerPrivacy() {
    try {
        var ref;
        return window.Shopify && window.Shopify.customerPrivacy ? (ref = window.Shopify) === null || ref === void 0 ? void 0 : ref.customerPrivacy : null;
    } catch (e) {
        return null;
    }
}
function getPrivacyBanner() {
    try {
        return window && (window === null || window === void 0 ? void 0 : window.privacyBanner) ? window.privacyBanner : null;
    } catch (e) {
        return null;
    }
}
function useCustomerPrivacy(props) {
    var _withPrivacyBanner = props.withPrivacyBanner, withPrivacyBanner = _withPrivacyBanner === void 0 ? false : _withPrivacyBanner, onVisitorConsentCollected = props.onVisitorConsentCollected, onReady = props.onReady, consentConfig = (0,_object_without_properties/* default */.Z)(props, [
        "withPrivacyBanner",
        "onVisitorConsentCollected",
        "onReady"
    ]);
    var status = useScriptLoad({
        src: withPrivacyBanner ? CONSENT_API_WITH_BANNER : CONSENT_API,
        id: "customer-privacy-api"
    }, "head").status;
    var ref = useApisLoaded({
        withPrivacyBanner: withPrivacyBanner,
        onLoaded: onReady
    }), observing = ref.observing, setLoaded = ref.setLoaded;
    var config = (0,react.useMemo)(function() {
        var checkoutDomain = consentConfig.checkoutDomain, storefrontAccessToken = consentConfig.storefrontAccessToken;
        return {
            checkoutRootDomain: checkoutDomain,
            storefrontAccessToken: storefrontAccessToken,
            storefrontRootDomain: parseStoreDomain(checkoutDomain),
            country: consentConfig.country,
            locale: consentConfig.locale
        };
    }, [
        consentConfig,
        parseStoreDomain
    ]);
    (0,react.useEffect)(function() {
        var consentCollectedHandler = function(event) {
            if (onVisitorConsentCollected) {
                onVisitorConsentCollected(event.detail);
            }
        };
        document.addEventListener("visitorConsentCollected", consentCollectedHandler);
        return function() {
            document.removeEventListener("visitorConsentCollected", consentCollectedHandler);
        };
    }, [
        onVisitorConsentCollected
    ]);
    (0,react.useEffect)(function() {
        if (!withPrivacyBanner || observing.current.privacyBanner) return;
        observing.current.privacyBanner = true;
        var customPrivacyBanner = window.privacyBanner || undefined;
        var privacyBannerWatcher = {
            configurable: true,
            get: function get() {
                return customPrivacyBanner;
            },
            set: function set(value) {
                if (typeof value === "object" && value !== null && "showPreferences" in value && "loadBanner" in value) {
                    var privacyBanner = value;
                    privacyBanner.loadBanner(config);
                    customPrivacyBanner = overridePrivacyBannerMethods({
                        privacyBanner: privacyBanner,
                        config: config
                    });
                    setLoaded.privacyBanner();
                    emitCustomerPrivacyApiLoaded();
                }
            }
        };
        Object.defineProperty(window, "privacyBanner", privacyBannerWatcher);
    }, [
        withPrivacyBanner,
        config,
        overridePrivacyBannerMethods,
        setLoaded.privacyBanner, 
    ]);
    (0,react.useEffect)(function() {
        if (observing.current.customerPrivacy) return;
        observing.current.customerPrivacy = true;
        var customCustomerPrivacy = null;
        var customShopify = window.Shopify || undefined;
        Object.defineProperty(window, "Shopify", {
            configurable: true,
            get: function get() {
                return customShopify;
            },
            set: function set(value) {
                if (typeof value === "object" && value !== null && Object.keys(value).length === 0) {
                    customShopify = value;
                    Object.defineProperty(window.Shopify, "customerPrivacy", {
                        configurable: true,
                        get: function get() {
                            return customCustomerPrivacy;
                        },
                        // eslint-disable-next-line no-shadow
                        set: function set(value) {
                            if (typeof value === "object" && value !== null && "setTrackingConsent" in value) {
                                var customerPrivacy = value;
                                customCustomerPrivacy = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, customerPrivacy), {
                                    setTrackingConsent: overrideCustomerPrivacySetTrackingConsent({
                                        customerPrivacy: customerPrivacy,
                                        config: config
                                    })
                                });
                                customShopify = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, customShopify), {
                                    customerPrivacy: customCustomerPrivacy
                                });
                                setLoaded.customerPrivacy();
                                emitCustomerPrivacyApiLoaded();
                            }
                        }
                    });
                }
            }
        });
    }, [
        config,
        overrideCustomerPrivacySetTrackingConsent,
        setLoaded.customerPrivacy, 
    ]);
    var result = {
        isReady: status === "ready",
        customerPrivacy: getCustomerPrivacy()
    };
    if (withPrivacyBanner) {
        result.privacyBanner = getPrivacyBanner();
    }
    return result;
}

// EXTERNAL MODULE: ../node_modules/nanoid/index.browser.js
var index_browser = __webpack_require__(72155);
;// CONCATENATED MODULE: ./src/snippets/DataLayerEventListeners/hooks/useDataLayerAccount.js





function useDataLayerAccount(param) {
    var baseEcommerce = param.baseEcommerce, generateUserProperties = param.generateUserProperties, userDataEvent = param.userDataEvent, userDataEventTriggered = param.userDataEventTriggered, customDispatchEvent = param.customDispatchEvent;
    var customer = (0,dist.useCustomer)();
    var accessToken = dist.store.recoil.useRecoilValue(dist.store.state.accessToken);
    var ref = (0,react.useState)(false), loggedIn = ref[0], setLoggedIn = ref[1];
    var ref1 = (0,react.useState)(false), registered = ref1[0], setRegistered = ref1[1];
    var loggedInEvent = (0,react.useCallback)(function(param) {
        var ecommerce = param.ecommerce, userProperties = param.userProperties;
        var event = {
            event: "dl_login",
            event_id: (0,index_browser/* nanoid */.x0)(),
            event_time: new Date().toISOString(),
            user_properties: userProperties,
            ecommerce: ecommerce
        };
        customDispatchEvent("dl_login", event);
        setLoggedIn(false);
    }, []);
    var registeredEvent = (0,react.useCallback)(function(param) {
        var ecommerce = param.ecommerce, userProperties = param.userProperties;
        var event = {
            event: "dl_sign_up",
            event_id: (0,index_browser/* nanoid */.x0)(),
            event_time: new Date().toISOString(),
            user_properties: userProperties,
            ecommerce: ecommerce
        };
        customDispatchEvent("dl_sign_up", event);
        setRegistered(false);
    }, []);
    var getUserPropertiesAndTriggerLoggedInEvents = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var _customer, ecommerce, _accessToken, userProperties;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _customer = param.customer, ecommerce = param.ecommerce, _accessToken = param.accessToken;
                        return [
                            4,
                            generateUserProperties({
                                customer: _customer,
                                accessToken: _accessToken.token
                            })
                        ];
                    case 1:
                        userProperties = _state.sent();
                        loggedInEvent({
                            ecommerce: ecommerce,
                            userProperties: userProperties
                        });
                        setTimeout(function() {
                            userDataEvent({
                                ecommerce: ecommerce,
                                userProperties: userProperties
                            });
                        }, 1000);
                        return [
                            2
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    var getUserPropertiesAndTriggerRegisterEvents = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var _customer, ecommerce, _accessToken, userProperties;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _customer = param.customer, ecommerce = param.ecommerce, _accessToken = param.accessToken;
                        return [
                            4,
                            generateUserProperties({
                                customer: _customer,
                                accessToken: _accessToken.token
                            })
                        ];
                    case 1:
                        userProperties = _state.sent();
                        registeredEvent({
                            ecommerce: ecommerce,
                            userProperties: userProperties
                        });
                        setTimeout(function() {
                            userDataEvent({
                                ecommerce: ecommerce,
                                userProperties: userProperties
                            });
                        }, 1000);
                        return [
                            2
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    (0,react.useEffect)(function() {
        var customerLoggedIn = PubSub.subscribe("CUSTOMER_LOGGED_IN", /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                setLoggedIn(true);
                return [
                    2
                ];
            });
        }));
        var customerRegistered = PubSub.subscribe("CUSTOMER_REGISTERED", /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                setRegistered(true);
                return [
                    2
                ];
            });
        }));
        return function() {
            if (customerLoggedIn) {
                PubSub.unsubscribe(customerLoggedIn);
            }
            if (customerRegistered) {
                PubSub.unsubscribe(customerRegistered);
            }
        };
    }, []);
    // Generate new base data after customer login and customer profile is ready
    // Trigger 'dl_user_data' and 'login' events
    (0,react.useEffect)(function() {
        if (!baseEcommerce || !customer || !(accessToken === null || accessToken === void 0 ? void 0 : accessToken.token) || !loggedIn || !userDataEventTriggered) return;
        getUserPropertiesAndTriggerLoggedInEvents({
            accessToken: accessToken,
            customer: customer,
            ecommerce: baseEcommerce
        });
    }, [
        accessToken === null || accessToken === void 0 ? void 0 : accessToken.token,
        !!baseEcommerce,
        !!customer,
        loggedIn,
        userDataEventTriggered, 
    ]);
    // Generate new base data after customer register and customer profile is ready
    // Trigger 'dl_user_data' and 'dl_sign_up' events
    (0,react.useEffect)(function() {
        if (!baseEcommerce || !customer || !(accessToken === null || accessToken === void 0 ? void 0 : accessToken.token) || !registered || !userDataEventTriggered) return;
        getUserPropertiesAndTriggerRegisterEvents({
            accessToken: accessToken,
            customer: customer,
            ecommerce: baseEcommerce
        });
    }, [
        accessToken === null || accessToken === void 0 ? void 0 : accessToken.token,
        !!baseEcommerce,
        !!customer,
        registered,
        userDataEventTriggered, 
    ]);
}

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(17599);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3204);
// EXTERNAL MODULE: ../node_modules/fast-deep-equal/index.js
var fast_deep_equal = __webpack_require__(66471);
var fast_deep_equal_default = /*#__PURE__*/__webpack_require__.n(fast_deep_equal);
;// CONCATENATED MODULE: ./src/snippets/DataLayerEventListeners/hooks/utils.js



var brand = "BrüMate" || 0;
var mapProductItemProduct = function() {
    var list = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return function(product) {
        var index = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        try {
            var ref, ref1, ref2, ref3;
            if (!product) return null;
            var firstVariant = (ref = product.variants) === null || ref === void 0 ? void 0 : ref[0];
            return {
                sku: (firstVariant === null || firstVariant === void 0 ? void 0 : firstVariant.sku) || "",
                name: product.title || "",
                brand: product.vendor || brand,
                category: product.productType || "",
                variant: (firstVariant === null || firstVariant === void 0 ? void 0 : firstVariant.title) || "",
                price: "".concat((firstVariant === null || firstVariant === void 0 ? void 0 : (ref1 = firstVariant.priceV2) === null || ref1 === void 0 ? void 0 : ref1.amount) || ""),
                list: list,
                product_id: product.legacyResourceId || "",
                variant_id: (firstVariant === null || firstVariant === void 0 ? void 0 : firstVariant.legacyResourceId) || "",
                compare_at_price: "".concat((firstVariant === null || firstVariant === void 0 ? void 0 : (ref2 = firstVariant.compareAtPriceV2) === null || ref2 === void 0 ? void 0 : ref2.amount) || ""),
                image: ((ref3 = product.featuredImage) === null || ref3 === void 0 ? void 0 : ref3.src) || "",
                collections: product.collections || [],
                tags: product.tags || [],
                position: index + 1,
                url: "/products/".concat(product.handle)
            };
        } catch (error) {
            console.error("DataLayer:mapProductItemProduct error", error.message);
            console.error("DataLayer:mapProductItemProduct product", product);
            return null;
        }
    };
};
var mapProductItemVariant = function() {
    var list = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return function(variant) {
        var index = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        try {
            var ref, ref1, ref2;
            if (!variant) return null;
            var _index;
            return {
                sku: variant.sku || "",
                name: variant.product.title || "",
                brand: variant.product.vendor || brand,
                category: variant.product.productType || "",
                variant: variant.title || "",
                price: "".concat(((ref = variant.priceV2) === null || ref === void 0 ? void 0 : ref.amount) || ""),
                list: list,
                product_id: variant.product.legacyResourceId || "",
                variant_id: variant.legacyResourceId || "",
                compare_at_price: "".concat(((ref1 = variant.compareAtPriceV2) === null || ref1 === void 0 ? void 0 : ref1.amount) || ""),
                image: ((ref2 = variant.image) === null || ref2 === void 0 ? void 0 : ref2.src) || "",
                collections: variant.product.collections || [],
                tags: variant.product.tags || [],
                position: ((_index = variant.index) !== null && _index !== void 0 ? _index : index) + 1,
                url: "/products/".concat(variant.product.handle)
            };
        } catch (error) {
            console.error("DataLayer:mapProductItemVariant error", error.message);
            console.error("DataLayer:mapProductItemVariant variant", variant);
            return null;
        }
    };
};
var mapProductPageVariant = function() {
    var list = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return function(variant) {
        try {
            var ref, ref1, ref2, ref3;
            if (!variant) return null;
            return {
                sku: variant.sku || "",
                name: variant.product.title || "",
                brand: variant.product.vendor || brand,
                category: variant.product.productType || "",
                variant: variant.title || "",
                price: "".concat(((ref = variant.priceV2) === null || ref === void 0 ? void 0 : ref.amount) || ""),
                list: list,
                product_id: ((ref1 = variant.product.id) === null || ref1 === void 0 ? void 0 : ref1.split("/").pop()) || "",
                variant_id: variant.legacyResourceId || "",
                compare_at_price: "".concat(((ref2 = variant.compareAtPriceV2) === null || ref2 === void 0 ? void 0 : ref2.amount) || ""),
                image: ((ref3 = variant.image) === null || ref3 === void 0 ? void 0 : ref3.src) || "",
                collections: variant.product.collections || [],
                tags: variant.product.tags || [],
                url: "/products/".concat(variant.product.handle, "?variant=").concat(variant.legacyResourceId)
            };
        } catch (error) {
            console.error("DataLayer:mapProductPageVariant error", error.message);
            console.error("DataLayer:mapProductPageVariant variant", variant);
            return null;
        }
    };
};
var decodedId = function(id) {
    try {
        if (!id) return undefined;
        return window.atob(id);
    } catch (error) {
        return id;
    }
};
var mapLineItem = function() {
    var list = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return function(item) {
        var index = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        try {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
            var ref11 = (0,_object_spread/* default */.Z)({}, item), quantity = ref11.quantity, variant = ref11.variant;
            if (!variant) return null;
            return {
                sku: variant.sku || "",
                name: ((ref = variant.product) === null || ref === void 0 ? void 0 : ref.title) || "",
                brand: brand,
                category: ((ref1 = variant.product) === null || ref1 === void 0 ? void 0 : ref1.productType) || "",
                variant: variant.title || "",
                price: "".concat(((ref2 = variant.priceV2) === null || ref2 === void 0 ? void 0 : ref2.amount) || ""),
                quantity: "".concat(quantity || ""),
                list: list,
                product_id: ((ref4 = decodedId((ref3 = variant.product) === null || ref3 === void 0 ? void 0 : ref3.id)) === null || ref4 === void 0 ? void 0 : ref4.split("/").pop()) || "",
                variant_id: ((ref5 = decodedId(variant.id)) === null || ref5 === void 0 ? void 0 : ref5.split("/").pop()) || "",
                compare_at_price: "".concat(((ref6 = variant.compareAtPriceV2) === null || ref6 === void 0 ? void 0 : ref6.amount) || ""),
                image: ((ref7 = variant.image) === null || ref7 === void 0 ? void 0 : ref7.src) || "",
                collections: ((ref8 = variant.product) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.collections) === null || ref9 === void 0 ? void 0 : ref9.nodes) || [],
                tags: ((ref10 = variant.product) === null || ref10 === void 0 ? void 0 : ref10.tags) || [],
                position: (item.index || index) + 1,
                url: "/products/".concat(variant.product.handle, "?variant=").concat(variant.id.split("/").pop())
            };
        } catch (error) {
            console.error("DataLayer:mapLineItem error", error.message);
            console.error("DataLayer:mapLineItem item", item);
            return null;
        }
    };
};
var fetchCustomerOrders = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var accessToken, url, request, data, ok, response, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    accessToken = param.accessToken;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    if (!accessToken) return [
                        2,
                        null
                    ];
                    url = "/api/customer/orders";
                    return [
                        4,
                        fetch(url, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({
                                first: 100,
                                country: "US",
                                accessToken: accessToken
                            })
                        })
                    ];
                case 2:
                    request = _state.sent();
                    if (!(request === null || request === void 0 ? void 0 : request.ok)) {
                        return [
                            2,
                            null
                        ];
                    }
                    return [
                        4,
                        request.json()
                    ];
                case 3:
                    data = _state.sent();
                    ok = data.ok, response = data.response;
                    if (!ok) {
                        return [
                            2,
                            null
                        ];
                    }
                    return [
                        2,
                        response === null || response === void 0 ? void 0 : response.orders
                    ];
                case 4:
                    error = _state.sent();
                    console.error("DataLayer:fetchCustomerOrders error", error.message);
                    return [
                        2,
                        null
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchCustomerOrders(_) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/snippets/DataLayerEventListeners/hooks/useDataLayerCart.js











function useDataLayerCart(param) {
    var baseEcommerce = param.baseEcommerce, userDataEvent = param.userDataEvent, userDataEventTriggered = param.userDataEventTriggered, userProperties = param.userProperties, customDispatchEvent = param.customDispatchEvent;
    var asPathRef = (0,react.useRef)(null);
    var cart = (0,dist.useCart)();
    var cartCount = (0,dist.useCartCount)();
    var cartItems = (0,dist.useCartItems)();
    var router = (0,next_router.useRouter)();
    var asPath = router.asPath.split("?")[0];
    var sidebar = (0,store/* useRecoilValue */.sJ)(store/* default.sidebar */.ZP.sidebar);
    var cartOpen = sidebar === "cart";
    var ref = (0,react.useState)(null), previousCartCount = ref[0], setPreviousCartCount = ref[1];
    var ref1 = (0,react.useState)(null), previousCartItems = ref1[0], setPreviousCartItems = ref1[1];
    var ref2 = (0,react.useState)(null), previousCartItemsMap = ref2[0], setPreviousCartItemsMap = ref2[1];
    var addToCartEvent = (0,react.useCallback)(function(param) {
        var _cart = param.cart, ecommerce = param.ecommerce, lineItems = param.lineItems, _userProperties = param.userProperties;
        var ref, ref1, ref2, ref3;
        if (!(lineItems === null || lineItems === void 0 ? void 0 : lineItems.length)) return;
        var previousPath = sessionStorage.getItem("PREVIOUS_PATH");
        var list = window.location.pathname.startsWith("/collections") && window.location.pathname || (previousPath === null || previousPath === void 0 ? void 0 : previousPath.startsWith("/collections")) && previousPath || "";
        var event = {
            event: "dl_add_to_cart",
            event_id: (0,index_browser/* nanoid */.x0)(),
            event_time: new Date().toISOString(),
            user_properties: _userProperties,
            ecommerce: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ecommerce), {
                cart_id: (ref = _cart.id) === null || ref === void 0 ? void 0 : ref.split("/").pop(),
                cart_total: (ref1 = _cart.estimatedCost) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.totalAmount) === null || ref2 === void 0 ? void 0 : ref2.amount,
                cart_count: ((ref3 = _cart.lines) === null || ref3 === void 0 ? void 0 : ref3.reduce(function(acc, line) {
                    return acc + line.quantity;
                }, 0)) || 0,
                add: {
                    actionField: {
                        list: list
                    },
                    products: lineItems.slice(0, 12).map(mapLineItem(list))
                }
            })
        };
        customDispatchEvent("dl_add_to_cart", event);
    }, [
        customDispatchEvent
    ]);
    var removeFromCartEvent = (0,react.useCallback)(function(param) {
        var _cart = param.cart, ecommerce = param.ecommerce, lineItems = param.lineItems, _userProperties = param.userProperties;
        var ref, ref1, ref2, ref3;
        if (!(lineItems === null || lineItems === void 0 ? void 0 : lineItems.length)) return;
        var previousPath = sessionStorage.getItem("PREVIOUS_PATH");
        var list = window.location.pathname.startsWith("/collections") && window.location.pathname || (previousPath === null || previousPath === void 0 ? void 0 : previousPath.startsWith("/collections")) && previousPath || "";
        var event = {
            event: "dl_remove_from_cart",
            event_id: (0,index_browser/* nanoid */.x0)(),
            event_time: new Date().toISOString(),
            user_properties: _userProperties,
            ecommerce: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ecommerce), {
                cart_id: (ref = _cart.id) === null || ref === void 0 ? void 0 : ref.split("/").pop(),
                cart_total: (ref1 = _cart.estimatedCost) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.totalAmount) === null || ref2 === void 0 ? void 0 : ref2.amount,
                cart_count: ((ref3 = _cart.lines) === null || ref3 === void 0 ? void 0 : ref3.reduce(function(acc, line) {
                    return acc + line.quantity;
                }, 0)) || 0,
                remove: {
                    actionField: {
                        list: list
                    },
                    products: lineItems.map(mapLineItem(list))
                }
            })
        };
        customDispatchEvent("dl_remove_from_cart", event);
    }, []);
    var viewCartEvent = (0,react.useCallback)(function(param) {
        var _cart = param.cart, ecommerce = param.ecommerce, _userProperties = param.userProperties;
        var ref, ref1, ref2, ref3, ref4;
        if (!_cart) return;
        var previousPath = sessionStorage.getItem("PREVIOUS_PATH");
        var list = window.location.pathname.startsWith("/collections") && window.location.pathname || (previousPath === null || previousPath === void 0 ? void 0 : previousPath.startsWith("/collections")) && previousPath || "";
        var event = {
            event: "dl_view_cart",
            event_id: (0,index_browser/* nanoid */.x0)(),
            event_time: new Date().toISOString(),
            user_properties: _userProperties,
            ecommerce: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ecommerce), {
                actionField: {
                    list: "cart"
                },
                cart_id: (ref = _cart.id) === null || ref === void 0 ? void 0 : ref.split("/").pop(),
                cart_total: (ref1 = _cart.estimatedCost) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.totalAmount) === null || ref2 === void 0 ? void 0 : ref2.amount,
                cart_count: ((ref3 = _cart.lines) === null || ref3 === void 0 ? void 0 : ref3.reduce(function(acc, line) {
                    return acc + line.quantity;
                }, 0)) || 0,
                products: ((ref4 = _cart.lines) === null || ref4 === void 0 ? void 0 : ref4.map(mapLineItem(list))) || []
            })
        };
        customDispatchEvent("dl_view_cart", event);
    }, []);
    // Trigger 'dl_view_cart' event on cart page
    (0,react.useEffect)(function() {
        if (!asPath.startsWith("/cart") || !cart || !baseEcommerce || !userProperties || asPath === asPathRef.current) return undefined;
        userDataEvent({
            ecommerce: baseEcommerce,
            userProperties: userProperties
        });
        viewCartEvent({
            cart: cart,
            ecommerce: baseEcommerce,
            userProperties: userProperties
        });
        asPathRef.current = asPath;
        return function() {
            asPathRef.current = null;
        };
    }, [
        asPath,
        !!cart,
        !!baseEcommerce,
        !!userProperties
    ]);
    // Trigger 'dl_view_cart' event when cart is opened
    (0,react.useEffect)(function() {
        if (!baseEcommerce || !cartOpen || !userDataEventTriggered) return;
        viewCartEvent({
            cart: cart,
            ecommerce: baseEcommerce,
            userProperties: userProperties
        });
    }, [
        !!baseEcommerce,
        cartOpen,
        userDataEventTriggered
    ]);
    // Determine if a cart item was added, removed, or updated for events
    (0,react.useEffect)(function() {
        if (!cart || !baseEcommerce || !userDataEventTriggered) return;
        var cartItemsMap = cartItems.reduce(function(acc, line) {
            if (!line.variant) return acc;
            var variantId = line.variant.id;
            if (!acc[variantId]) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, variantId, [
                    line
                ]));
            }
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, variantId, (0,_to_consumable_array/* default */.Z)(acc[variantId]).concat([
                line
            ])));
        }, {});
        if (!previousCartItems || previousCartCount === cartCount) {
            setPreviousCartItems(cartItems);
            setPreviousCartCount(cartCount);
            setPreviousCartItemsMap(cartItemsMap);
            return;
        }
        var isAddedItems = [];
        var isIncreasedItems = [];
        var isRemovedItems = [];
        var isDecreasedItems = [];
        if (cartCount > previousCartCount) {
            cartItems.forEach(function(line, index) {
                var ref, ref1;
                var variantId = (ref = line.variant) === null || ref === void 0 ? void 0 : ref.id;
                if (!variantId) return;
                var previousLine = (ref1 = previousCartItemsMap[variantId]) === null || ref1 === void 0 ? void 0 : ref1.find(function(prevLine) {
                    var ref, ref1, ref2, ref3;
                    var hasSameSellingPlanSelection = !prevLine.sellingPlanAllocation && !line.sellingPlanAllocation || ((ref = prevLine.sellingPlanAllocation) === null || ref === void 0 ? void 0 : (ref1 = ref.sellingPlan) === null || ref1 === void 0 ? void 0 : ref1.id) === ((ref2 = line.sellingPlanAllocation) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.sellingPlan) === null || ref3 === void 0 ? void 0 : ref3.id);
                    return hasSameSellingPlanSelection && fast_deep_equal_default()(prevLine.attributes.filter(function(attr) {
                        return attr.key !== "_addedAt";
                    }), line.attributes.filter(function(attr) {
                        return attr.key !== "_addedAt";
                    }));
                });
                if (!previousLine) {
                    isAddedItems.push((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, line), {
                        index: index
                    }));
                    return;
                }
                if (line.quantity > previousLine.quantity) {
                    isIncreasedItems.push((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, line), {
                        quantity: line.quantity - previousLine.quantity,
                        index: index
                    }));
                }
            });
        } else if (cartCount < previousCartCount) {
            previousCartItems.forEach(function(prevLine, index) {
                var ref, ref1;
                var variantId = (ref = prevLine.variant) === null || ref === void 0 ? void 0 : ref.id;
                if (!variantId) return;
                var currentLine = (ref1 = cartItemsMap[variantId]) === null || ref1 === void 0 ? void 0 : ref1.find(function(line) {
                    var ref, ref1, ref2, ref3;
                    var hasSameSellingPlanSelection = !prevLine.sellingPlanAllocation && !line.sellingPlanAllocation || ((ref = prevLine.sellingPlanAllocation) === null || ref === void 0 ? void 0 : (ref1 = ref.sellingPlan) === null || ref1 === void 0 ? void 0 : ref1.id) === ((ref2 = line.sellingPlanAllocation) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.sellingPlan) === null || ref3 === void 0 ? void 0 : ref3.id);
                    return hasSameSellingPlanSelection && fast_deep_equal_default()(prevLine.attributes.filter(function(attr) {
                        return attr.key !== "_addedAt";
                    }), line.attributes.filter(function(attr) {
                        return attr.key !== "_addedAt";
                    }));
                });
                if (!currentLine) {
                    isRemovedItems.push((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevLine), {
                        index: index
                    }));
                    return;
                }
                if (currentLine.quantity < prevLine.quantity) {
                    isDecreasedItems.push((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevLine), {
                        quantity: prevLine.quantity - currentLine.quantity,
                        index: index
                    }));
                }
            });
        }
        if (isAddedItems.length || isIncreasedItems.length) {
            (0,_to_consumable_array/* default */.Z)(isAddedItems).concat((0,_to_consumable_array/* default */.Z)(isIncreasedItems)).forEach(function(line) {
                addToCartEvent({
                    cart: cart,
                    ecommerce: baseEcommerce,
                    lineItems: [
                        line
                    ],
                    userProperties: userProperties
                });
            });
        }
        if (isRemovedItems.length || isDecreasedItems.length) {
            removeFromCartEvent({
                cart: cart,
                ecommerce: baseEcommerce,
                lineItems: (0,_to_consumable_array/* default */.Z)(isRemovedItems).concat((0,_to_consumable_array/* default */.Z)(isDecreasedItems)),
                userProperties: userProperties
            });
        }
        setPreviousCartItems(cartItems);
        setPreviousCartCount(cartCount);
        setPreviousCartItemsMap(cartItemsMap);
    }, [
        cart === null || cart === void 0 ? void 0 : cart.updatedAt,
        !!baseEcommerce,
        userDataEventTriggered
    ]);
}

;// CONCATENATED MODULE: ./src/snippets/DataLayerEventListeners/hooks/useDataLayerCollection.js







function useDataLayerCollection(param) {
    var baseEcommerce = param.baseEcommerce, userDataEvent = param.userDataEvent, userDataEventTriggered = param.userDataEventTriggered, userProperties = param.userProperties, customDispatchEvent = param.customDispatchEvent;
    var collectionHandleRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(null), collectionProducts = ref[0], setCollectionProducts = ref[1];
    var ref1 = (0,react.useState)(null), collectionId = ref1[0], setCollectionId = ref1[1];
    var ref2 = (0,react.useState)(null), clickedCollectionItem = ref2[0], setClickedCollectionItem = ref2[1];
    var viewCollectionEvent = (0,react.useCallback)(function(param) {
        var ecommerce = param.ecommerce, products = param.products, _userProperties = param.userProperties;
        if (!(products === null || products === void 0 ? void 0 : products.length)) return;
        var list = window.location.pathname.startsWith("/collections") ? window.location.pathname : "";
        var event = {
            event: "dl_view_item_list",
            event_id: (0,index_browser/* nanoid */.x0)(),
            event_time: new Date().toISOString(),
            user_properties: _userProperties,
            ecommerce: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ecommerce), {
                products: products.slice(0, 12).map(mapProductItemProduct(list))
            })
        };
        customDispatchEvent("dl_view_item_list", event);
    }, []);
    var clickCollectionItemEvent = (0,react.useCallback)(function(param) {
        var ecommerce = param.ecommerce, variant = param.variant;
        if (!variant) return;
        var list = variant.list || "";
        var event = {
            event: "dl_select_item",
            event_id: (0,index_browser/* nanoid */.x0)(),
            event_time: new Date().toISOString(),
            user_properties: userProperties,
            ecommerce: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ecommerce), {
                click: {
                    actionField: {
                        list: window.location.pathname.startsWith("/collection") ? window.location.pathname : "",
                        action: "click"
                    },
                    products: [
                        variant
                    ].map(mapProductItemVariant(list))
                }
            })
        };
        customDispatchEvent("dl_select_item", event);
    }, [
        userProperties
    ]);
    // Subscribe to PubSub topic for 'dl_view_item_list' and 'dl_select_item' events
    (0,react.useEffect)(function() {
        var viewCollection = PubSub.subscribe("VIEW_COLLECTION_PAGE", function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(event, param) {
                var products, id;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    products = param.products, id = param.id;
                    setCollectionProducts(products);
                    setCollectionId(id);
                    return [
                        2
                    ];
                });
            });
            return function(event, _) {
                return _ref.apply(this, arguments);
            };
        }());
        var clickCollectionItem = PubSub.subscribe("CLICK_COLLECTION_ITEM", function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(event, variant) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    setClickedCollectionItem(variant);
                    return [
                        2
                    ];
                });
            });
            return function(event, variant) {
                return _ref.apply(this, arguments);
            };
        }());
        return function() {
            if (viewCollection) {
                PubSub.unsubscribe(viewCollection);
            }
            if (clickCollectionItem) {
                PubSub.unsubscribe(clickCollectionItem);
            }
        };
    }, []);
    // Trigger 'dl_user_data' and view 'dl_view_item_list'
    // events on collection page and after base data is ready
    (0,react.useEffect)(function() {
        var pageHandle = window.location.pathname.startsWith("/pages") ? "/pages/".concat(window.location.pathname.split("/").pop()) : window.location.pathname.split("/").pop();
        if (!collectionId || !(collectionProducts === null || collectionProducts === void 0 ? void 0 : collectionProducts.length) || !baseEcommerce || !userProperties || collectionHandleRef.current === pageHandle) return;
        userDataEvent({
            ecommerce: baseEcommerce,
            userProperties: userProperties
        });
        viewCollectionEvent({
            ecommerce: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, baseEcommerce), {
                collection_id: collectionId
            }),
            products: collectionProducts,
            userProperties: userProperties
        });
        collectionHandleRef.current = pageHandle;
    }, [
        collectionId,
        collectionProducts,
        !!baseEcommerce,
        !!userProperties
    ]);
    // Trigger 'dl_select_item' event on clicked collection
    // item and after user event
    (0,react.useEffect)(function() {
        if (!clickedCollectionItem || !baseEcommerce || !userDataEventTriggered) return;
        clickCollectionItemEvent({
            ecommerce: baseEcommerce,
            variant: clickedCollectionItem
        });
    }, [
        clickedCollectionItem,
        !!baseEcommerce,
        userDataEventTriggered
    ]);
}

;// CONCATENATED MODULE: ./src/snippets/DataLayerEventListeners/hooks/useDataLayerCustomer.js







var IGNORED_PATHS = [
    "account",
    "cart",
    "collections",
    "products"
];
var LOGGED_OUT_ACCOUNT_PATHS = [
    "/account/login",
    "/account/register",
    "/account/reset",
    "/account/activate", 
];
function useDataLayerCustomer(param) {
    var baseEcommerce = param.baseEcommerce, userProperties = param.userProperties, customDispatchEvent = param.customDispatchEvent;
    var asPathRef = (0,react.useRef)(null);
    var cart = (0,dist.useCart)();
    var router = (0,next_router.useRouter)();
    var asPath = router.asPath.split("?")[0];
    var ref = (0,react.useState)(false), delayForContextIsFinished = ref[0], setDelayForContextIsFinished = ref[1];
    var ref1 = (0,react.useState)(false), userDataEventTriggered = ref1[0], setUserDataEventTriggered = ref1[1];
    var userDataEvent = (0,react.useCallback)(function(param) {
        var ecommerce = param.ecommerce, _userProperties = param.userProperties;
        var ref, ref1, ref2;
        var previousPath = sessionStorage.getItem("PREVIOUS_PATH");
        var list = window.location.pathname.startsWith("/collections") && window.location.pathname || (previousPath === null || previousPath === void 0 ? void 0 : previousPath.startsWith("/collections")) && previousPath || "";
        var event = {
            event: "dl_user_data",
            event_id: (0,index_browser/* nanoid */.x0)(),
            event_time: new Date().toISOString(),
            user_properties: _userProperties,
            ecommerce: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ecommerce), {
                cart_total: (cart === null || cart === void 0 ? void 0 : (ref = cart.estimatedCost) === null || ref === void 0 ? void 0 : (ref1 = ref.totalAmount) === null || ref1 === void 0 ? void 0 : ref1.amount) || "0.0",
                cart_contents: {
                    products: (cart === null || cart === void 0 ? void 0 : (ref2 = cart.lines) === null || ref2 === void 0 ? void 0 : ref2.map(mapLineItem(list))) || []
                }
            })
        };
        customDispatchEvent("dl_user_data", event);
        setUserDataEventTriggered(true);
        setDelayForContextIsFinished(false);
    }, [
        cart === null || cart === void 0 ? void 0 : cart.updatedAt
    ]);
    // Force delay on user data event
    (0,react.useEffect)(function() {
        setTimeout(function() {
            return setDelayForContextIsFinished(true);
        }, 1000);
    }, [
        asPath
    ]);
    // Trigger 'dl_user_data' event on path change after base data is ready,
    // excluding account and paths that trigger event directly before their respective events
    (0,react.useEffect)(function() {
        if (!delayForContextIsFinished || !baseEcommerce || !userProperties || IGNORED_PATHS.includes(asPath.split("/")[1]) || asPath.startsWith("/pages/search") || asPath === asPathRef.current) return undefined;
        userDataEvent({
            ecommerce: baseEcommerce,
            userProperties: userProperties
        });
        asPathRef.current = asPath;
        return function() {
            asPathRef.current = null;
        };
    }, [
        asPath,
        !!baseEcommerce,
        delayForContextIsFinished,
        !!userProperties
    ]);
    // Trigger 'dl_user_data' event on account pages after base data is ready,
    // excluding after login/register events
    (0,react.useEffect)(function() {
        if (!delayForContextIsFinished || !baseEcommerce || !userProperties || !asPath.startsWith("/account") || asPath === asPathRef.current) return undefined;
        var prevPath = sessionStorage.getItem("PREVIOUS_PATH");
        var currentPath = sessionStorage.getItem("CURRENT_PATH");
        var prevPathInlcRefresh = sessionStorage.getItem("PREVIOUS_PATH_INLC_REFRESH");
        // On login or register, prevent event as it triggers directly from the login/register events
        var isFromLoginOrRegisterEvent = (prevPath.startsWith("/account/login") || prevPath.startsWith("/account/register")) && currentPath !== prevPathInlcRefresh;
        var isLoggedOutAccountPath = LOGGED_OUT_ACCOUNT_PATHS.some(function(path) {
            return asPath.startsWith(path);
        });
        if (isFromLoginOrRegisterEvent && !isLoggedOutAccountPath) return undefined;
        // On log out, trigger event with guest visitor type
        var isFromLogoutEvent = asPath.startsWith("/account/login") && prevPath.startsWith("/account");
        var prevPathIsLoggedOutAccountPath = LOGGED_OUT_ACCOUNT_PATHS.some(function(path) {
            return prevPath.startsWith(path);
        });
        if (isFromLogoutEvent && !prevPathIsLoggedOutAccountPath) {
            userDataEvent({
                ecommerce: baseEcommerce,
                userProperties: {
                    visitor_type: "guest",
                    user_consent: ""
                }
            });
        } else {
            // Else trigger event for all other instances
            userDataEvent({
                ecommerce: baseEcommerce,
                userProperties: userProperties
            });
        }
        asPathRef.current = asPath;
        return function() {
            asPathRef.current = null;
        };
    }, [
        asPath,
        !!baseEcommerce,
        delayForContextIsFinished,
        !!userProperties
    ]);
    return {
        userDataEvent: userDataEvent,
        userDataEventTriggered: userDataEventTriggered
    };
}

;// CONCATENATED MODULE: ./src/snippets/DataLayerEventListeners/hooks/useDataLayerInit.js







function useDataLayerInit(param) {
    var baseEcommerce = param.baseEcommerce, pageTitle = param.pageTitle, template = param.template, customDispatchEvent = param.customDispatchEvent;
    var asPathRef = (0,react.useRef)(null);
    var customer = (0,dist.useCustomer)();
    var router = (0,next_router.useRouter)();
    var asPath = router.asPath.split("?")[0];
    var accessToken = (0,dist.useCustomerAccessToken)();
    var ref = (0,react.useState)(null), userProperties = ref[0], setUserProperties = ref[1];
    var customerPending = typeof customer === "undefined";
    var pathname = asPath === null || asPath === void 0 ? void 0 : asPath.split("?")[0];
    var generateUserProperties = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var _customer, _accessToken, _userProperties, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, orders;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _customer = param.customer, _accessToken = param.accessToken;
                        _userProperties = {};
                        if (!_customer) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            fetchCustomerOrders({
                                accessToken: _accessToken
                            })
                        ];
                    case 1:
                        orders = _state.sent();
                        _userProperties = {
                            visitor_type: "logged_in",
                            user_consent: "",
                            customer_address_1: ((ref = _customer.defaultAddress) === null || ref === void 0 ? void 0 : ref.address1) || "",
                            customer_address_2: ((ref1 = _customer.defaultAddress) === null || ref1 === void 0 ? void 0 : ref1.address2) || "",
                            customer_city: ((ref2 = _customer.defaultAddress) === null || ref2 === void 0 ? void 0 : ref2.city) || "",
                            customer_country: ((ref3 = _customer.defaultAddress) === null || ref3 === void 0 ? void 0 : ref3.country) || "",
                            customer_country_code: ((ref4 = _customer.defaultAddress) === null || ref4 === void 0 ? void 0 : ref4.countryCode) || "",
                            customer_email: _customer.email,
                            customer_first_name: _customer.firstName,
                            customer_id: ((ref5 = _customer.id) === null || ref5 === void 0 ? void 0 : ref5.split("/").pop()) || "",
                            customer_last_name: _customer.lastName,
                            customer_order_count: (orders === null || orders === void 0 ? void 0 : orders.length) || 0,
                            customer_phone: ((ref6 = _customer.defaultAddress) === null || ref6 === void 0 ? void 0 : ref6.phone) || "",
                            customer_province_code: ((ref7 = _customer.defaultAddress) === null || ref7 === void 0 ? void 0 : ref7.provinceCode) || "",
                            customer_province: ((ref8 = _customer.defaultAddress) === null || ref8 === void 0 ? void 0 : ref8.province) || "",
                            customer_tags: ((ref9 = _customer.tags) === null || ref9 === void 0 ? void 0 : ref9.join(", ")) || "",
                            customer_total_spent: orders === null || orders === void 0 ? void 0 : orders.reduce(function(acc, order) {
                                var ref;
                                return acc + parseFloat(((ref = order.totalPriceV2) === null || ref === void 0 ? void 0 : ref.amount) || 0);
                            }, 0).toFixed(2),
                            customer_zip: ((ref10 = _customer.defaultAddress) === null || ref10 === void 0 ? void 0 : ref10.zip) || ""
                        };
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _userProperties = {
                            visitor_type: "guest",
                            user_consent: ""
                        };
                        _state.label = 3;
                    case 3:
                        setUserProperties(_userProperties);
                        return [
                            2,
                            _userProperties
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    // Set previous paths and current path in session storage
    (0,react.useEffect)(function() {
        var currentPath = sessionStorage.getItem("CURRENT_PATH");
        if (asPath === currentPath) {
            sessionStorage.setItem("PREVIOUS_PATH_INLC_REFRESH", asPath);
            return;
        }
        sessionStorage.setItem("PREVIOUS_PATH", currentPath);
        sessionStorage.setItem("PREVIOUS_PATH_INLC_REFRESH", currentPath);
        sessionStorage.setItem("CURRENT_PATH", asPath);
    }, [
        asPath
    ]);
    // generate user properties on customer ready and path change
    (0,react.useEffect)(function() {
        if (customerPending || // wait until customer status is ready
        customer && !(accessToken === null || accessToken === void 0 ? void 0 : accessToken.token) || // wait until accessToken is ready, if logged in customer
        asPath === asPathRef.current // prevent multiple triggers on same path
        ) return undefined;
        generateUserProperties({
            customer: customer,
            accessToken: accessToken === null || accessToken === void 0 ? void 0 : accessToken.token
        });
        asPathRef.current = asPath;
        return function() {
            asPathRef.current = null;
        };
    }, [
        accessToken === null || accessToken === void 0 ? void 0 : accessToken.token,
        asPath,
        customerPending
    ]);
    (0,react.useEffect)(function() {
        if (!baseEcommerce || !userProperties) return;
        var event = {
            event: "dl_route_update",
            event_id: (0,index_browser/* nanoid */.x0)(),
            event_time: new Date().toISOString(),
            page: {
                path: pathname,
                title: pageTitle,
                type: template,
                search: window.location.search
            },
            user_properties: userProperties,
            ecommerce: baseEcommerce
        };
        customDispatchEvent("dl_route_update", event);
    }, [
        !!baseEcommerce,
        pathname,
        !!userProperties
    ]);
    return {
        generateUserProperties: generateUserProperties,
        userProperties: userProperties
    };
}

;// CONCATENATED MODULE: ./src/snippets/DataLayerEventListeners/hooks/useDataLayerProduct.js







function useDataLayerProduct(param) {
    var baseEcommerce = param.baseEcommerce, userDataEvent = param.userDataEvent, userProperties = param.userProperties, customDispatchEvent = param.customDispatchEvent;
    var ref;
    var productHandleRef = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(null), viewedProductVariant = ref1[0], setViewedProductVariant = ref1[1];
    var viewProductEvent = (0,react.useCallback)(function(param) {
        var ecommerce = param.ecommerce, variant = param.variant, _userProperties = param.userProperties;
        if (!variant) return;
        var previousPath = sessionStorage.getItem("PREVIOUS_PATH");
        var list = (previousPath === null || previousPath === void 0 ? void 0 : previousPath.startsWith("/collections")) ? previousPath : "";
        var event = {
            event: "dl_view_item",
            event_id: (0,index_browser/* nanoid */.x0)(),
            event_time: new Date().toISOString(),
            user_properties: _userProperties,
            ecommerce: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ecommerce), {
                detail: {
                    actionField: {
                        list: list,
                        action: "detail"
                    },
                    products: [
                        variant
                    ].map(mapProductPageVariant(list))
                }
            })
        };
        customDispatchEvent("dl_view_item", event);
    }, []);
    // Subscribe to PubSub topic for 'dl_view_item' event
    (0,react.useEffect)(function() {
        var viewProduct = PubSub.subscribe("VIEW_PRODUCT_PAGE", function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(event, variant) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    setViewedProductVariant(variant);
                    return [
                        2
                    ];
                });
            });
            return function(event, variant) {
                return _ref.apply(this, arguments);
            };
        }());
        return function() {
            if (viewProduct) {
                PubSub.unsubscribe(viewProduct);
            }
        };
    }, []);
    // Trigger 'dl_user_data' and 'dl_view_item' events on product change after base data is ready
    (0,react.useEffect)(function() {
        var pageHandle = window.location.pathname.split("/").pop();
        if (!baseEcommerce || !userProperties || !viewedProductVariant || productHandleRef.current === pageHandle) return;
        userDataEvent({
            ecommerce: baseEcommerce,
            userProperties: userProperties
        });
        viewProductEvent({
            ecommerce: baseEcommerce,
            variant: viewedProductVariant,
            userProperties: userProperties
        });
        productHandleRef.current = pageHandle;
    }, [
        !!baseEcommerce,
        viewedProductVariant === null || viewedProductVariant === void 0 ? void 0 : (ref = viewedProductVariant.product) === null || ref === void 0 ? void 0 : ref.id,
        !!userProperties
    ]);
}

;// CONCATENATED MODULE: ./src/snippets/DataLayerEventListeners/hooks/useDataLayerSearch.js








function useDataLayerSearch(param) {
    var baseEcommerce = param.baseEcommerce, userDataEvent = param.userDataEvent, userDataEventTriggered = param.userDataEventTriggered, userProperties = param.userProperties, customDispatchEvent = param.customDispatchEvent;
    var asPathRef = (0,react.useRef)(null);
    var router = (0,next_router.useRouter)();
    var asPath = router.asPath.split("?")[0];
    var ref = (0,react.useState)(null), searchPageResults = ref[0], setSearchPageResults = ref[1];
    var ref1 = (0,react.useState)(null), searchResults = ref1[0], setSearchResults = ref1[1];
    var ref2 = (0,react.useState)(null), clickedSearchResultsItem = ref2[0], setClickedSearchResultsItem = ref2[1];
    var viewSearchResultsEvent = (0,react.useCallback)(function(param) {
        var ecommerce = param.ecommerce, results = param.results, _userProperties = param.userProperties;
        if (!(results === null || results === void 0 ? void 0 : results.length)) return;
        var event = {
            event: "dl_view_search_results",
            event_id: (0,index_browser/* nanoid */.x0)(),
            event_time: new Date().toISOString(),
            user_properties: _userProperties,
            ecommerce: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ecommerce), {
                actionField: {
                    list: "search_results",
                    search_term: "redacted"
                },
                products: results.slice(0, 12).map(mapProductItemProduct())
            })
        };
        customDispatchEvent("dl_view_search_results", event);
    }, []);
    var clickSearchResultsItemEvent = (0,react.useCallback)(function(param) {
        var ecommerce = param.ecommerce, _userProperties = param.userProperties, variant = param.variant;
        if (!variant) return;
        var event = {
            event: "dl_select_item",
            event_id: (0,index_browser/* nanoid */.x0)(),
            event_time: new Date().toISOString(),
            user_properties: _userProperties,
            ecommerce: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ecommerce), {
                click: {
                    actionField: {
                        list: "search_results",
                        action: "click",
                        search_term: variant.searchTerm
                    },
                    products: [
                        variant
                    ].map(mapProductItemVariant())
                }
            })
        };
        customDispatchEvent("dl_select_item", event);
    }, []);
    // Subscribe to PubSub topics for 'view_search_results' and 'select_item' events
    (0,react.useEffect)(function() {
        var viewSearchPageResults = PubSub.subscribe("VIEW_SEARCH_PAGE_RESULTS", function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(event, results) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    setSearchPageResults(results);
                    return [
                        2
                    ];
                });
            });
            return function(event, results) {
                return _ref.apply(this, arguments);
            };
        }());
        var viewSearchResults = PubSub.subscribe("VIEW_SEARCH_RESULTS", function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(event, results) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    setSearchResults(results);
                    return [
                        2
                    ];
                });
            });
            return function(event, results) {
                return _ref.apply(this, arguments);
            };
        }());
        var clickSearchItem = PubSub.subscribe("CLICK_SEARCH_ITEM", function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(event, variant) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    setClickedSearchResultsItem(variant);
                    return [
                        2
                    ];
                });
            });
            return function(event, variant) {
                return _ref.apply(this, arguments);
            };
        }());
        return function() {
            if (viewSearchPageResults) {
                PubSub.unsubscribe(viewSearchPageResults);
            }
            if (viewSearchResults) {
                PubSub.unsubscribe(viewSearchResults);
            }
            if (clickSearchItem) {
                PubSub.unsubscribe(clickSearchItem);
            }
        };
    }, []);
    // Trigger 'dl_user_data' and 'dl_view_search_results' events after
    // new sidebar search results and base data is ready
    (0,react.useEffect)(function() {
        if (!asPath.startsWith("/pages/search") || !baseEcommerce || !(searchPageResults === null || searchPageResults === void 0 ? void 0 : searchPageResults.length) || !userProperties || asPath === asPathRef.current) return undefined;
        userDataEvent({
            ecommerce: baseEcommerce,
            userProperties: userProperties
        });
        viewSearchResultsEvent({
            ecommerce: baseEcommerce,
            results: searchPageResults,
            userProperties: userProperties
        });
        asPathRef.current = asPath;
        return function() {
            asPathRef.current = null;
        };
    }, [
        asPath,
        !!baseEcommerce,
        searchPageResults === null || searchPageResults === void 0 ? void 0 : searchPageResults.map(function(p) {
            return p === null || p === void 0 ? void 0 : p.handle;
        }).join(""),
        !!userProperties, 
    ]);
    // Trigger 'dl_user_data' and 'dl_view_search_results' events after
    // new search page results and base data is ready
    (0,react.useEffect)(function() {
        if (!baseEcommerce || !searchResults || !userDataEventTriggered) return;
        viewSearchResultsEvent({
            ecommerce: baseEcommerce,
            results: searchResults,
            userProperties: userProperties
        });
    }, [
        !!baseEcommerce,
        searchResults,
        userDataEventTriggered
    ]);
    // Trigger 'dl_select_item' after clicked search item and user event
    (0,react.useEffect)(function() {
        if (!clickedSearchResultsItem || !baseEcommerce || !userDataEventTriggered) return;
        clickSearchResultsItemEvent({
            ecommerce: baseEcommerce,
            userProperties: userProperties,
            variant: clickedSearchResultsItem
        });
    }, [
        clickedSearchResultsItem,
        !!baseEcommerce,
        userDataEventTriggered
    ]);
}

;// CONCATENATED MODULE: ./src/snippets/DataLayerEventListeners/hooks/useDataLayerSubscribe.js




function useDataLayerSubscribe(param) {
    var baseEcommerce = param.baseEcommerce, userDataEventTriggered = param.userDataEventTriggered, customDispatchEvent = param.customDispatchEvent;
    var ref = (0,react.useState)(""), subscribedEmail = ref[0], setSubscribedEmail = ref[1];
    var ref1 = (0,react.useState)(""), subscribedPhone = ref1[0], setSubscribedPhone = ref1[1];
    var subscribeEmailEvent = (0,react.useCallback)(function(param) {
        var ecommerce = param.ecommerce, email = param.email;
        if (!email) return;
        var event = {
            event: "dl_subscribe",
            event_id: (0,index_browser/* nanoid */.x0)(),
            event_time: new Date().toISOString(),
            lead_type: "email",
            user_properties: {
                customer_email: email
            },
            ecommerce: ecommerce
        };
        customDispatchEvent("dl_subscribe", event);
    }, [
        customDispatchEvent
    ]);
    var subscribePhoneEvent = (0,react.useCallback)(function(param) {
        var ecommerce = param.ecommerce, phone = param.phone;
        if (!phone) return;
        var event = {
            event: "dl_subscribe",
            event_id: (0,index_browser/* nanoid */.x0)(),
            event_time: new Date().toISOString(),
            lead_type: "phone",
            user_properties: {
                customer_phone: phone
            },
            ecommerce: ecommerce
        };
        customDispatchEvent("dl_subscribe", event);
    }, []);
    // Subscribe to PubSub topic for 'dl_subscribe' event
    (0,react.useEffect)(function() {
        var subscribedWithEmail = PubSub.subscribe("SUBSCRIBE_EMAIL", function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(event, email) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    setSubscribedEmail(email);
                    return [
                        2
                    ];
                });
            });
            return function(event, email) {
                return _ref.apply(this, arguments);
            };
        }());
        var subscribedWithPhone = PubSub.subscribe("SUBSCRIBE_PHONE", function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(event, phone) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    setSubscribedPhone(phone);
                    return [
                        2
                    ];
                });
            });
            return function(event, phone) {
                return _ref.apply(this, arguments);
            };
        }());
        return function() {
            if (subscribedWithEmail) {
                PubSub.unsubscribe(subscribedWithEmail);
            }
            if (subscribedWithPhone) {
                PubSub.unsubscribe(subscribedWithPhone);
            }
        };
    }, []);
    // Trigger 'dl_subscribe' event after email submission
    (0,react.useEffect)(function() {
        if (!baseEcommerce || !subscribedEmail || !userDataEventTriggered) return;
        subscribeEmailEvent({
            ecommerce: baseEcommerce,
            email: subscribedEmail
        });
    }, [
        !!baseEcommerce,
        subscribedEmail,
        userDataEventTriggered
    ]);
    // Trigger 'dl_subscribe' event after phone submission
    (0,react.useEffect)(function() {
        if (!baseEcommerce || !subscribedPhone || !userDataEventTriggered) return;
        subscribePhoneEvent({
            ecommerce: baseEcommerce,
            phone: subscribedPhone
        });
    }, [
        !!baseEcommerce,
        subscribedPhone,
        userDataEventTriggered
    ]);
}

;// CONCATENATED MODULE: ./src/snippets/DataLayerEventListeners/hooks/index.js









;// CONCATENATED MODULE: ./src/snippets/DataLayerEventListeners/useDataLayerEventListeners.js
/* provided dependency */ var process = __webpack_require__(14284);




// Envs to set:
// * NEXT_PUBLIC_SITE_TITLE // provides backup brand name
// * NEXT_PUBLIC_ENABLE_DL_DEBUGGER // enables console logs for event dispatches
// * NEXT_PUBLIC_SHOPIFY_CUSTOM_APP_ID
var DEBUG = "true" === "true";
function useDataLayerEventListeners(param) {
    var pageTitle = param.pageTitle, template = param.template;
    var currencyCode = (0,dist.useCurrency)();
    var baseEcommerce = (0,react.useMemo)(function() {
        if (!currencyCode) return null;
        return {
            currency_code: currencyCode,
            app_id: process.env.NEXT_PUBLIC_SHOPIFY_CUSTOM_APP_ID
        };
    }, [
        currencyCode
    ]);
    var customDispatchEvent = (0,react.useCallback)(function(eventName, eventData) {
        var customerPrivacy = getCustomerPrivacy();
        if (customerPrivacy && !customerPrivacy.analyticsProcessingAllowed()) {
            return;
        }
        if (DEBUG) {
            console.log("Custom event dispatched:", eventName, eventData);
        }
        window.dispatchEvent(new CustomEvent(eventName, {
            detail: eventData
        }));
    }, []);
    var ref = useDataLayerInit({
        baseEcommerce: baseEcommerce,
        DEBUG: DEBUG,
        pageTitle: pageTitle,
        template: template,
        customDispatchEvent: customDispatchEvent
    }), generateUserProperties = ref.generateUserProperties, userProperties = ref.userProperties;
    var ref1 = useDataLayerCustomer({
        baseEcommerce: baseEcommerce,
        userProperties: userProperties,
        customDispatchEvent: customDispatchEvent
    }), userDataEvent = ref1.userDataEvent, userDataEventTriggered = ref1.userDataEventTriggered;
    useDataLayerAccount({
        baseEcommerce: baseEcommerce,
        generateUserProperties: generateUserProperties,
        userDataEvent: userDataEvent,
        userDataEventTriggered: userDataEventTriggered,
        customDispatchEvent: customDispatchEvent
    });
    useDataLayerCart({
        baseEcommerce: baseEcommerce,
        userDataEvent: userDataEvent,
        userDataEventTriggered: userDataEventTriggered,
        userProperties: userProperties,
        customDispatchEvent: customDispatchEvent
    });
    useDataLayerProduct({
        baseEcommerce: baseEcommerce,
        userDataEvent: userDataEvent,
        userProperties: userProperties,
        customDispatchEvent: customDispatchEvent
    });
    useDataLayerCollection({
        baseEcommerce: baseEcommerce,
        userDataEvent: userDataEvent,
        userDataEventTriggered: userDataEventTriggered,
        userProperties: userProperties,
        customDispatchEvent: customDispatchEvent
    });
    useDataLayerSearch({
        baseEcommerce: baseEcommerce,
        userDataEvent: userDataEvent,
        userDataEventTriggered: userDataEventTriggered,
        userProperties: userProperties,
        customDispatchEvent: customDispatchEvent
    });
    useDataLayerSubscribe({
        baseEcommerce: baseEcommerce,
        userDataEventTriggered: userDataEventTriggered,
        customDispatchEvent: customDispatchEvent
    });
}

;// CONCATENATED MODULE: ./src/snippets/DataLayerEventListeners/DataLayerEventListeners.jsx

// Envs to set:
// * NEXT_PUBLIC_SITE_TITLE // provides backup brand name
// * NEXT_PUBLIC_ENABLE_DL_DEBUGGER // enables console logs for event dispatches
// * NEXT_PUBLIC_SHOPIFY_CUSTOM_APP_ID
function DataLayerEventListeners(param) {
    var pageTitle = param.pageTitle, template = param.template;
    useDataLayerEventListeners({
        pageTitle: pageTitle,
        template: template
    });
    return null;
}
DataLayerEventListeners.displayName = "DataLayerEventListeners";

;// CONCATENATED MODULE: ./src/snippets/DataLayerEventListeners/index.js


;// CONCATENATED MODULE: ./src/snippets/Dropdown/Dropdown.theme.js



var SELECTED_HEIGHT = 44;
var OPTION_HEIGHT = 30;
var MIN_WIDTH = "200px";
var COUNTRIES_MIN_WIDTH = "160px";
var wrapper = {
    minWidth: MIN_WIDTH,
    position: "relative",
    zIndex: 2
};
var drawerWrapper = {
    position: "absolute",
    width: "100%",
    left: 0,
    top: "56px",
    overflow: "hidden"
};
var drawer = {
    bg: "background",
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: "gray",
    borderRadius: "2px",
    flexDirection: "column",
    height: "auto",
    maxHeight: "100%",
    minHeight: "100%",
    overflow: "hidden",
    transition: "max-height 0.2s ease-in-out",
    width: "100%",
    boxShadow: "0px 0px 0px 1px rgba(0, 0, 0, 0.12), 0px 4px 8px -2px rgba(0, 0, 0, 0.28)",
    mt: "-2px"
};
var Dropdown_theme_scroll = {
    "::-webkit-scrollbar": {
        display: "none"
    },
    msOverflowStyle: "none",
    scrollbarWidth: "none",
    webkitOverflowScrolling: "touch",
    height: "auto",
    maxHeight: "100%",
    overflowY: "auto",
    position: "relative",
    width: "100%"
};
var item = {
    alignItems: "center",
    bg: "background",
    color: "text",
    display: "flex",
    flexDirection: "row",
    height: "".concat(SELECTED_HEIGHT, "px"),
    justifyContent: "space-between",
    lineHeight: "".concat(SELECTED_HEIGHT - 2, "px"),
    overflow: "hidden",
    px: 0,
    py: 0,
    textAlign: "left",
    textOverflow: "ellipsis",
    transition: "background-color 0.1s ease-in-out",
    whiteSpace: "nowrap",
    width: "100%",
    zIndex: 1
};
var selected = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: "mediumDarkGray",
    borderRadius: "30px"
});
var Dropdown_theme_option = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
    height: "".concat(OPTION_HEIGHT, "px"),
    lineHeight: "".concat(OPTION_HEIGHT, "px"),
    border: "none",
    "&:first-of-type": {
        borderTopStyle: "solid",
        borderTopWidth: "1px",
        borderTopColor: "gray",
        mt: "2px"
    }
});
var label = {
    position: "relative",
    m: 0,
    width: "100%",
    text: {
        variant: "text.label.2",
        position: "absolute",
        top: 2,
        left: "21px",
        zIndex: 2,
        pointerEvents: "none",
        color: "dark"
    }
};
var Dropdown_theme_themed = (0,create/* create */.U)(new function() {
    this.default = {
        drawerWrapper: drawerWrapper,
        wrapper: wrapper,
        drawer: drawer,
        scroll: Dropdown_theme_scroll,
        selected: selected,
        option: Dropdown_theme_option,
        label: label
    };
    this.countries = {
        drawerWrapper: drawerWrapper,
        wrapper: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, wrapper), {
            minWidth: COUNTRIES_MIN_WIDTH
        }),
        // Drawer wrapper
        drawer: drawer,
        // defining a px maxHeight enables scrolling
        scroll: (0,_object_spread/* default */.Z)({}, Dropdown_theme_scroll),
        // top selected item
        selected: (0,_object_spread/* default */.Z)({}, selected),
        // each dropdown option
        option: (0,_object_spread/* default */.Z)({}, Dropdown_theme_option),
        label: label
    };
    this.subscription = {
        drawerWrapper: drawerWrapper,
        wrapper: wrapper,
        drawer: drawer,
        scroll: Dropdown_theme_scroll,
        selected: selected,
        option: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, Dropdown_theme_option), {
            "&:hover": {
                bg: "lightGray"
            }
        }),
        label: label
    };
    this.sizes = {
        wrapper: wrapper,
        drawerWrapper: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, drawerWrapper), {
            top: "42px"
        }),
        drawer: drawer,
        scroll: Dropdown_theme_scroll,
        selected: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, selected), {
            height: "34px",
            p: {
                variant: "text.base",
                minHeight: [
                    "18px",
                    null,
                    "22px"
                ],
                fontSize: [
                    1,
                    null,
                    4
                ],
                lineHeight: [
                    18,
                    null,
                    22
                ]
            }
        }),
        option: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, Dropdown_theme_option), {
            p: {
                variant: "text.base",
                minHeight: [
                    "18px",
                    null,
                    "22px"
                ],
                fontSize: [
                    1,
                    null,
                    4
                ],
                lineHeight: [
                    18,
                    null,
                    22
                ]
            },
            "&:hover": {
                bg: "lightGray"
            }
        }),
        label: label
    };
    this.colors = {
        wrapper: wrapper,
        drawerWrapper: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, drawerWrapper), {
            top: "42px",
            minWidth: "150px"
        }),
        drawer: drawer,
        scroll: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, Dropdown_theme_scroll), {
            maxHeight: [
                "125px",
                null,
                "175px"
            ]
        }),
        selected: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, selected), {
            height: "34px",
            p: {
                variant: "text.base",
                minHeight: [
                    "18px",
                    null,
                    "22px"
                ],
                fontSize: [
                    1,
                    null,
                    4
                ],
                lineHeight: [
                    18,
                    null,
                    22
                ]
            }
        }),
        option: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, Dropdown_theme_option), {
            p: {
                variant: "text.base",
                minHeight: [
                    "18px",
                    null,
                    "22px"
                ],
                fontSize: [
                    1,
                    null,
                    4
                ],
                lineHeight: [
                    18,
                    null,
                    22
                ]
            },
            "&:hover": {
                bg: "lightGray"
            }
        }),
        label: label
    };
}());

;// CONCATENATED MODULE: ./src/snippets/Dropdown/Dropdown.Option.jsx









var DropdownOption = Dropdown_theme_themed(function(_param) {
    var children = _param.children, option = _param.option, selected = _param.selected, selecting = _param.selecting, setSelected = _param.setSelected, theme = _param.theme, toggle = _param.toggle, variant = _param.variant, inputRef = _param.inputRef, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "option",
        "selected",
        "selecting",
        "setSelected",
        "theme",
        "toggle",
        "variant",
        "inputRef"
    ]);
    var ref;
    // const isSelected = JSON.stringify(selected) == JSON.stringify(option);
    var isSelected = (0,react.useMemo)(function() {
        return fast_deep_equal_default()(selected, option) || (option === null || option === void 0 ? void 0 : option.active) === 1;
    }, [
        selected,
        option
    ]);
    var handleOnSelect = (0,react.useCallback)(function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (!option) return;
        setSelected(option);
        toggle();
    }, [
        option
    ]);
    return isSelected ? null : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-comp": DropdownOption.displayName,
        role: "option",
        variant: "buttons.plain",
        "aria-selected": false,
        "aria-hidden": !selecting,
        tabIndex: selecting ? "0" : "-1",
        onClick: handleOnSelect
    }, props), {
        sx: (0,_object_spread/* default */.Z)({}, (ref = theme[variant]) === null || ref === void 0 ? void 0 : ref.option, props.sx),
        children: children({
            selecting: selecting,
            option: option,
            isSelected: isSelected,
            selected: selected
        })
    }));
});
DropdownOption.displayName = "DropdownOption";
DropdownOption.propTypes = {
    children: (prop_types_default()).func,
    option: (prop_types_default()).any,
    selected: (prop_types_default()).any,
    selecting: (prop_types_default()).bool,
    setSelected: (prop_types_default()).func,
    toggle: (prop_types_default()).func
};

;// CONCATENATED MODULE: ./src/snippets/Dropdown/Dropdown.Selected.jsx








var DropdownSelected = Dropdown_theme_themed(function(_param) {
    var children = _param.children, label = _param.label, selected = _param.selected, selecting = _param.selecting, theme = _param.theme, toggle = _param.toggle, variant = _param.variant, inputRef = _param.inputRef, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "label",
        "selected",
        "selecting",
        "theme",
        "toggle",
        "variant",
        "inputRef"
    ]);
    var ref, ref1, ref2;
    var toggleDropdown = (0,react.useCallback)(function(e) {
        e.preventDefault();
        e.stopPropagation();
        toggle();
    }, []);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Label */.__, {
        "data-comp": DropdownSelected.displayName,
        sx: (ref = theme[variant]) === null || ref === void 0 ? void 0 : ref.label,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Text */.xv, {
                sx: (ref1 = theme[variant]) === null || ref1 === void 0 ? void 0 : ref1.label.text,
                children: label
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                variant: "buttons.plain",
                role: "button",
                "aria-haspopup": "listbox",
                "aria-live": "assertive",
                "aria-expanded": selecting,
                onClick: toggleDropdown
            }, props), {
                sx: (0,_object_spread/* default */.Z)({}, (ref2 = theme[variant]) === null || ref2 === void 0 ? void 0 : ref2.selected, props.sx),
                children: children({
                    selecting: selecting,
                    selected: selected
                })
            }))
        ]
    });
});
DropdownSelected.displayName = "DropdownSelected";
DropdownSelected.propTypes = {
    children: (prop_types_default()).func,
    selected: (prop_types_default()).any,
    selecting: (prop_types_default()).bool,
    toggle: (prop_types_default()).func
};

;// CONCATENATED MODULE: ./src/snippets/Dropdown/useDropdown.js




var defaultProps = {
    initial: null,
    variant: "default",
    children: null,
    onSelected: function() {},
    onSelecting: function() {}
};
var useDropdown = function(passedProps) {
    var option = (0,_object_spread/* default */.Z)({}, defaultProps, passedProps);
    var dropdownRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(option.initial), selected = ref[0], setSelected = ref[1];
    var ref1 = (0,react.useState)(false), selecting = ref1[0], setSelecting = ref1[1];
    var ref2 = (0,react.useState)(false), mounted = ref2[0], setMounted = ref2[1];
    // toggle dropdown open/close
    var toggle = (0,react.useCallback)(function() {
        setSelecting(function(selecting) {
            return !selecting;
        });
    }, []);
    // filter and sort valid Dropdown (Selected or Option ) children components
    var Component = (0,react.useMemo)(function() {
        var Selected = null;
        var Options = [];
        var index = 0;
        // map children to supported sub components
        react.Children.forEach(option.children, function(child) {
            var ref, ref1, ref2;
            var displayName = (child === null || child === void 0 ? void 0 : (ref = child.props) === null || ref === void 0 ? void 0 : (ref1 = ref.__EMOTION_TYPE_PLEASE_DO_NOT_USE__) === null || ref1 === void 0 ? void 0 : ref1.displayName) || (child === null || child === void 0 ? void 0 : (ref2 = child.type) === null || ref2 === void 0 ? void 0 : ref2.displayName);
            switch(displayName){
                case "DropdownSelected":
                    {
                        Selected = /*#__PURE__*/ (0,react.cloneElement)(child, (0,_object_spread/* default */.Z)({
                            key: "selected.option",
                            label: option.label,
                            selecting: selecting,
                            selected: selected,
                            toggle: toggle,
                            variant: option.variant
                        }, child.props));
                        break;
                    }
                case "DropdownOption":
                    {
                        Options = (0,_to_consumable_array/* default */.Z)(Options).concat([
                            /*#__PURE__*/ (0,react.cloneElement)(child, (0,_object_spread/* default */.Z)({
                                key: "option.".concat(selected, ".").concat(index),
                                selecting: selecting,
                                selected: selected,
                                setSelected: setSelected,
                                toggle: toggle,
                                variant: option.variant
                            }, child.props)), 
                        ]);
                        break;
                    }
                default:
                    break;
            }
            index += 1;
        });
        return {
            Selected: Selected,
            Options: Options
        };
    }, [
        selecting,
        selected,
        react.Children.count(option.children)
    ]);
    var closeOnClickOutside = (0,react.useCallback)(function(event) {
        var ref;
        if (!((ref = dropdownRef.current) === null || ref === void 0 ? void 0 : ref.contains(event.target))) {
            return setSelecting(false);
        }
    }, []);
    var setOutsideClickHandler = function() {
        document.addEventListener("mouseup", closeOnClickOutside);
        return function() {
            return document.removeEventListener("mouseup", closeOnClickOutside);
        };
    };
    // run passed callback when selection changes
    (0,react.useEffect)(function() {
        if (!mounted) {
            setMounted(true);
            return;
        }
        if (typeof option.onSelected === "function") option.onSelected(selected);
    }, [
        selected
    ]);
    // run passed callback when selecting
    (0,react.useEffect)(function() {
        selecting && typeof option.onSelecting === "function" && option.onSelecting();
    }, [
        selecting
    ]);
    (0,react.useEffect)(function() {
        setOutsideClickHandler();
    }, []);
    return [
        {
            dropdownRef: dropdownRef,
            Component: Component,
            selecting: selecting
        },
        {
            toggle: toggle
        }, 
    ];
};

;// CONCATENATED MODULE: ./src/snippets/Dropdown/Dropdown.jsx












var Dropdown = Dropdown_theme_themed(function(_param) {
    var theme = _param.theme, _variant = _param.variant, variant = _variant === void 0 ? "default" : _variant, initial = _param.initial, children = _param.children, _label = _param.label, label = _label === void 0 ? "" : _label, _maxHeight = _param.maxHeight, maxHeight = _maxHeight === void 0 ? "400px" : _maxHeight, _onSelected = _param.onSelected, onSelected = _onSelected === void 0 ? function() {} : _onSelected, _onSelecting = _param.onSelecting, onSelecting = _onSelecting === void 0 ? function() {} : _onSelecting, inputRef = _param.inputRef, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme",
        "variant",
        "initial",
        "children",
        "label",
        "maxHeight",
        "onSelected",
        "onSelecting",
        "inputRef"
    ]);
    var ref, ref1, ref2, ref3;
    var ref4 = (0,_sliced_to_array/* default */.Z)(useDropdown((0,_object_spread/* default */.Z)((0,_define_property/* default */.Z)({
        variant: variant,
        initial: initial,
        children: children,
        label: label,
        onSelected: onSelected
    }, "onSelected", onSelected), props)), 1), ref5 = ref4[0], dropdownRef = ref5.dropdownRef, Component = ref5.Component, selecting = ref5.selecting;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-comp": Dropdown.displayName,
        ref: dropdownRef
    }, props), {
        sx: (0,_object_spread/* default */.Z)({}, (ref = theme[variant]) === null || ref === void 0 ? void 0 : ref.wrapper, props.sx),
        children: [
            Component.Selected,
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                sx: (ref1 = theme[variant]) === null || ref1 === void 0 ? void 0 : ref1.drawerWrapper,
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                    "data-comp": "DropdownDrawer",
                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (ref2 = theme[variant]) === null || ref2 === void 0 ? void 0 : ref2.drawer), {
                        // maxHeight: selecting ? maxHeight : '0px',
                        display: selecting ? "block" : "none"
                    }),
                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                        "data-comp": "DropdownScroll",
                        role: "listbox",
                        sx: (0,_object_spread/* default */.Z)({}, (ref3 = theme[variant]) === null || ref3 === void 0 ? void 0 : ref3.scroll),
                        children: Component.Options
                    })
                })
            })
        ]
    }));
});
Dropdown.displayName = "Dropdown";
Dropdown.Option = DropdownOption;
Dropdown.Selected = DropdownSelected;
Dropdown.propTypes = {
    initial: (prop_types_default()).any.isRequired,
    children: (prop_types_default()).node,
    maxHeight: (prop_types_default()).string,
    onSelected: (prop_types_default()).func,
    onSelecting: (prop_types_default()).func
};

;// CONCATENATED MODULE: ./src/snippets/Dropdown/index.js


;// CONCATENATED MODULE: ./src/snippets/EmailSignup/EmailSignup.theme.js

var EmailSignup_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        position: "relative",
        width: "100%"
    };
    this.label = {
        position: "relative",
        m: 0,
        height: "44px"
    };
    this.labelText = {
        variant: "text.label.2",
        position: "absolute",
        top: 2,
        left: "21px",
        zIndex: 1,
        pointerEvents: "none",
        color: "dark"
    };
    this.input = {
        variant: "text.base",
        py: 0,
        px: 10,
        borderRadius: "30px",
        m: 0,
        lineHeight: "28px",
        pt: "14px",
        border: "1px solid",
        borderColor: "mediumDarkGray",
        bg: "background",
        "::placeholder": {
            color: "dark",
            variant: "text.base"
        }
    };
    this.button = {
        width: "100%",
        mt: 6
    };
}());

;// CONCATENATED MODULE: ./src/snippets/EmailSignup/EmailSignup.jsx









var EmailSignup = EmailSignup_theme_themed(function(_param) {
    var theme = _param.theme, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme"
    ]);
    var sendSubscribeEvent = (0,hooks/* useDataLayerActions */.KZ)().sendSubscribeEvent;
    var ref = (0,react.useState)(""), email = ref[0], setEmail = ref[1];
    var ref1 = (0,react.useState)(false), submitted = ref1[0], setSubmitted = ref1[1];
    var ref2 = (0,react.useState)(false), isLoading = ref2[0], setIsLoading = ref2[1];
    var ref3 = (0,react.useState)(""), messageText = ref3[0], setMessageText = ref3[1];
    var submitEmailSignup = (0,hooks/* useEmailSignup */.vk)().submitEmailSignup;
    var handleSubmit = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            var emailListId, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        if (!email || submitted || isLoading) return [
                            2
                        ];
                        emailListId = "Mrk7yV";
                        setIsLoading(true);
                        return [
                            4,
                            submitEmailSignup(emailListId, email)
                        ];
                    case 1:
                        data = _state.sent();
                        if (data.success) {
                            setIsLoading(false);
                            setSubmitted(true);
                            setMessageText("Thank you for signing up!");
                            sendSubscribeEvent({
                                email: email
                            });
                            setEmail("");
                            setTimeout(function() {
                                setMessageText("");
                                setSubmitted(false);
                            }, 4000);
                        } else {
                            setIsLoading(false);
                            setMessageText("Please try again later");
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function(e) {
            return _ref.apply(this, arguments);
        };
    }(), [
        email,
        isLoading
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": "EmailSignup",
        as: "form",
        email: email,
        onSubmit: handleSubmit,
        sx: (0,_object_spread/* default */.Z)({}, theme.wrapper, props.sx),
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Label */.__, {
                sx: theme.label,
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Text */.xv, {
                        sx: theme.labelText,
                        children: "Email Address"
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Input */.II, {
                        placeholder: "Enter your email address",
                        type: "email",
                        required: true,
                        onChange: function(e) {
                            return setEmail(e.target.value);
                        },
                        sx: theme.input
                    })
                ]
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                variant: "buttons.inverse",
                sx: theme.button,
                children: "Sign Up"
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                as: "div",
                variant: "text.label2",
                sx: {
                    mt: 8,
                    mb: 8
                },
                children: messageText
            })
        ]
    });
});

;// CONCATENATED MODULE: ./src/snippets/EmailSignup/index.js


// EXTERNAL MODULE: ../node_modules/lodash.xorby/index.js
var lodash_xorby = __webpack_require__(86312);
var lodash_xorby_default = /*#__PURE__*/__webpack_require__.n(lodash_xorby);
;// CONCATENATED MODULE: ./src/snippets/Favorite/Favorite.theme.js

var Favorite_theme_themed = (0,create/* create */.U)(new function() {
    this.button = function(isPdp) {
        return isPdp ? {
            cursor: "pointer",
            width: "42px",
            height: "42px",
            borderRadius: "50%",
            border: function(t) {
                return "1px solid ".concat(t.colors.gray);
            },
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            transition: "all 0.15s ease-in-out",
            ":hover": {
                borderColor: "mediumDarkGray",
                svg: {
                    color: "mediumDarkGray"
                }
            }
        } : {
            position: "absolute",
            top: 2,
            right: 1,
            zIndex: 1
        };
    };
    this.icon = {
        width: "18px",
        color: "text",
        transition: "all 0.15s ease-in-out",
        ":hover": {
            color: "mediumDarkGray"
        }
    };
}());

;// CONCATENATED MODULE: ./src/snippets/Favorite/Favorite.jsx











var Favorite = Favorite_theme_themed(function(param) {
    var theme = param.theme, selectedVariant = param.selectedVariant, isPdp = param.isPdp;
    var ref, ref1;
    var updateWishlist = (0,hooks/* useWishlist */.Ei)().updateWishlist;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* default.wishlist */.ZP.wishlist), 2), wishlist = ref2[0], setWishlist = ref2[1];
    var lid = (0,store/* useRecoilValue */.sJ)(store/* default.wishlistId */.ZP.wishlistId);
    var wishlistEmail = (0,store/* useRecoilValue */.sJ)(store/* default.wishlistEmail */.ZP.wishlistEmail);
    var isWishlisted = (0,store/* useRecoilValue */.sJ)(store/* default.variantIsWishlisted */.ZP.variantIsWishlisted(selectedVariant));
    var toggleWishlist = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
            var item, updatedWishlist;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event.preventDefault();
                        item = {
                            epi: parseInt(selectedVariant.legacyResourceId, 10),
                            empi: parseInt(selectedVariant.product.legacyResourceId, 10),
                            du: "https://".concat("kryo-gear.myshopify.com", "/products/").concat(selectedVariant.product.handle)
                        };
                        updatedWishlist = lodash_xorby_default()(wishlist, [
                            item
                        ], "epi");
                        setWishlist(updatedWishlist);
                        if (!wishlistEmail) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            updateWishlist({
                                params: {
                                    lid: lid,
                                    email: wishlistEmail,
                                    add: isWishlisted ? [] : [
                                        item
                                    ],
                                    remove: isWishlisted ? [
                                        item
                                    ] : []
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }(), [
        selectedVariant,
        wishlist,
        isWishlisted
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
        "data-comp": Favorite.displayName,
        variant: "buttons.plain",
        "aria-label": isWishlisted ? "Add ".concat((selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref = selectedVariant.product) === null || ref === void 0 ? void 0 : ref.title) || "", " to favorites.") : "Remove ".concat((selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref1 = selectedVariant.product) === null || ref1 === void 0 ? void 0 : ref1.title) || "", " from favorites."),
        onClick: toggleWishlist,
        sx: theme.button(isPdp),
        children: isWishlisted ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Svg, {
            viewBox: "0 0 18 15",
            alt: "Favorite",
            src: "/svgs/heart-filled.svg#heart",
            sx: theme.icon
        }) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Svg, {
            viewBox: "0 0 18 15",
            alt: "Favorite",
            src: "/svgs/heart.svg#heart",
            sx: theme.icon
        })
    });
});
Favorite.displayName = "Favorite";

;// CONCATENATED MODULE: ./src/snippets/Favorite/index.js


;// CONCATENATED MODULE: ../node_modules/@swc/helpers/src/_instanceof.mjs
function _instanceof(left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return !!right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}
// EXTERNAL MODULE: ../node_modules/next/script.js
var script = __webpack_require__(43218);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./src/snippets/Fueled/hooks/index.js



;// CONCATENATED MODULE: ./src/snippets/Fueled/fueled.utils.js
var getEventId = function(event) {
    var ref;
    return (((ref = event.detail) === null || ref === void 0 ? void 0 : ref.event_id) || "").replace(/_/g, "-");
};
var changeFueledConsent = function(consent) {
    var fueled = window.fueled || {};
    if (fueled.setConsent) {
        fueled.setConsent({
            analyticsAllowed: consent.analytics,
            preferencesAllowed: consent.preferences,
            firstPartyMarketingAllowed: consent.marketing,
            thirdPartyMarketingAllowed: consent.sale_of_data
        });
    } else if (typeof fueled.changeConsent === "function") {
        fueled.changeConsent({
            analytics: consent.analytics,
            preferences: consent.preferences,
            marketing: consent.marketing,
            saleOfData: consent.sale_of_data
        });
    }
};

;// CONCATENATED MODULE: ./src/snippets/Fueled/FueledTrueVault.jsx
/* provided dependency */ var FueledTrueVault_process = __webpack_require__(14284);





var PUBLIC_TRUE_VAULT_SDK_URL = "https://polaris.truevaultcdn.com/static/pc/UZTLJPM2J/polaris.js";
var useGetTrueVaultConsent = function() {
    var ref = (0,react.useState)(), consent = ref[0], setConsent = ref[1];
    var customerPrivacy = useCustomerPrivacy({
        storefrontAccessToken: "7b8296bfc85c0cb6fbc85bd5fa81686f",
        checkoutDomain: "shop.brumate.com" || 0,
        onVisitorConsentCollected: function(newConsent) {
            console.log("Visitor consent collected:", newConsent);
            setConsent({
                analytics: newConsent.analyticsAllowed,
                marketing: newConsent.marketingAllowed,
                preferences: newConsent.preferencesAllowed,
                sale_of_data: newConsent.saleOfDataAllowed
            });
        }
    }).customerPrivacy;
    (0,react.useEffect)(function() {
        if (!(customerPrivacy === null || customerPrivacy === void 0 ? void 0 : customerPrivacy.analyticsProcessingAllowed)) return;
        if (!consent) {
            var ref, ref1, ref2, ref3;
            customerPrivacy.setTrackingConsent({
                analytics: customerPrivacy === null || customerPrivacy === void 0 ? void 0 : (ref = customerPrivacy.analyticsProcessingAllowed) === null || ref === void 0 ? void 0 : ref.call(customerPrivacy),
                marketing: customerPrivacy === null || customerPrivacy === void 0 ? void 0 : (ref1 = customerPrivacy.marketingAllowed) === null || ref1 === void 0 ? void 0 : ref1.call(customerPrivacy),
                preferences: customerPrivacy === null || customerPrivacy === void 0 ? void 0 : (ref2 = customerPrivacy.preferencesProcessingAllowed) === null || ref2 === void 0 ? void 0 : ref2.call(customerPrivacy),
                sale_of_data: customerPrivacy === null || customerPrivacy === void 0 ? void 0 : (ref3 = customerPrivacy.saleOfDataAllowed) === null || ref3 === void 0 ? void 0 : ref3.call(customerPrivacy)
            });
        }
    }, [
        customerPrivacy === null || customerPrivacy === void 0 ? void 0 : customerPrivacy.analyticsProcessingAllowed
    ]);
    (0,react.useEffect)(function() {
        if (consent) {
            changeFueledConsent(consent);
        }
        var handleFueledReady = function() {
            if (!consent) return;
            changeFueledConsent(consent);
        };
        window.addEventListener("fueled-ready", handleFueledReady);
        return function() {
            window.removeEventListener("fueled-ready", handleFueledReady);
        };
    }, [
        consent
    ]);
    return consent;
};
function FueledTrueVault() {
    var trueVaultSdkUrl = FueledTrueVault_process.env.PUBLIC_TRUE_VAULT_SDK_URL || PUBLIC_TRUE_VAULT_SDK_URL;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)((script_default()), {
        strategy: "beforeInteractive",
        type: "text/javascript",
        src: trueVaultSdkUrl
    });
}

;// CONCATENATED MODULE: ./src/snippets/Fueled/fueled.events.js
var TRACKING_EVENTS = {
    LOGIN: "dl_login",
    SIGN_UP: "dl_sign_up",
    VIEW_CART: "dl_view_cart",
    VIEW_ITEM: "dl_view_item",
    SUBSCRIBE: "dl_subscribe",
    USER_DATA: "dl_user_data",
    ADD_TO_CART: "dl_add_to_cart",
    SELECT_ITEM: "dl_select_item",
    PAGE_VIEW: "dl_route_update",
    VIEW_ITEM_LIST: "dl_view_item_list",
    REMOVE_FROM_CART: "dl_remove_from_cart",
    VIEW_SEARCH_RESULTS: "dl_view_search_results",
    EXPERIMENT_EXPOSURE: "dl_experiment_exposure",
    VIEW_PROMOTION: "dl_view_promotion",
    SELECT_PROMOTION: "dl_select_promotion",
    SELECT_ITEM_LIST_FILTER: "dl_select_item_list_filter",
    DESELECT_ITEM_LIST_FILTER: "dl_deselect_item_list_filter"
};

;// CONCATENATED MODULE: ./src/snippets/Fueled/FueledAnalytics.jsx





var defaultContext = {
    clients: {},
    register: function() {
        return function() {
            return null;
        };
    },
    publish: function() {
        return null;
    },
    subscribe: function() {
        return function() {
            return null;
        };
    },
    consent: undefined
};
var FueledAnalyticsContext = /*#__PURE__*/ (0,react.createContext)(defaultContext);
var eventCache = new Map();
var subscribers = new Map();
var clients = {};
var areClientsReady = function() {
    return Object.values(clients).every(Boolean) && Object.keys(clients).length > 0;
};
var subscribe = function(eventName, callback) {
    if (!subscribers.has(eventName)) {
        subscribers.set(eventName, new Set());
    }
    subscribers.get(eventName).add(callback);
    return function() {
        var callbacks = subscribers.get(eventName);
        if (callbacks) {
            callbacks.delete(callback);
            if (callbacks.size === 0) {
                subscribers.delete(eventName);
            }
        }
    };
};
var publishEvent = function(eventName, payload) {
    var ref;
    ((ref = subscribers.get(eventName)) !== null && ref !== void 0 ? ref : new Map()).forEach(function(callback) {
        try {
            callback(payload);
        } catch (error) {
            if (typeof error === "object" && _instanceof(error, Error)) {
                console.error(error.message);
            } else {
                console.error(error);
            }
        }
    });
};
var publish = function(eventName, payload) {
    if (!areClientsReady()) {
        return eventCache.set(eventName, payload);
    }
    return publishEvent(eventName, payload);
};
var register = function(client) {
    if (typeof clients[client] === "undefined") {
        clients[client] = false;
    }
    return function() {
        clients[client] = true;
        if (areClientsReady() && eventCache.size > 0) {
            eventCache.forEach(function(payload, eventName) {
                publishEvent(eventName, payload);
            });
            eventCache.clear();
        }
    };
};
var useListenToTrackingEvents = function() {
    (0,react.useEffect)(function() {
        var eventNames = Object.values(TRACKING_EVENTS);
        var handleEvent = function(event) {
            publish(event.type, event);
        };
        eventNames.forEach(function(eventName) {
            window.addEventListener(eventName, handleEvent);
        });
        return function() {
            eventNames.forEach(function(eventName) {
                window.removeEventListener(eventName, handleEvent);
            });
        };
    }, []);
};
function FueledAnalyticsProvider(param) {
    var children = param.children;
    useListenToTrackingEvents();
    var consent = useGetTrueVaultConsent();
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(FueledAnalyticsContext.Provider, {
        // eslint-disable-next-line react/jsx-no-constructed-context-values
        value: {
            clients: clients,
            register: register,
            subscribe: subscribe,
            publish: publish,
            consent: consent
        },
        children: children
    });
}
var useAnalytics = function() {
    var context = (0,react.useContext)(FueledAnalyticsContext);
    if (!context) {
        throw new Error("useAnalytics must be used within a FueledAnalyticsProvider");
    }
    return context;
};

;// CONCATENATED MODULE: ./src/snippets/Fueled/FueledClientScript.jsx






var fueledScriptUrl = "https://mb-cdn.fueled.io/fueled/53616c7465645f5fd48ca0d5f8e061369be440200484413c5366ef0cf6ba0777842400cdb07e71ccc0847fcb50ac4b30c6ffe17880e4620a0943a5a3e666d3cd/packdigital/js" || 0;
function FueledClientScript() {
    var cartId = (0,dist.useCartId)();
    var cartUpdateAttributes = (0,dist.useCartUpdateAttributes)().cartUpdateAttributes;
    (0,react.useEffect)(function() {
        if (!cartId) return function() {
            return null;
        };
        var cleanCartId = cartId.replace("gid://shopify/Cart/", "");
        // eslint-disable-next-line prefer-destructuring
        cleanCartId = cleanCartId.split("?")[0]; // Remove any trailing query strings added to the cartId.
        var setCartToken = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var fueled, res, ref, _context, anonymousId, tmp, ref1, _clientId, clientId, _sessionId, sessionId, tmp1, ref2, _fbp, fbp, _fbc, fbc;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            fueled = window.fueled || {};
                            return [
                                4,
                                fueled.setFrontendStorage(fueled.config.frontendStorageUrl, cleanCartId)
                            ];
                        case 1:
                            res = _state.sent();
                            return [
                                4,
                                res.json()
                            ];
                        case 2:
                            ref = _state.sent(), _context = ref.context, anonymousId = _context.anonymousId, tmp = _context.ga4, ref1 = tmp === void 0 ? {} : tmp, _clientId = ref1.clientId, clientId = _clientId === void 0 ? undefined : _clientId, _sessionId = ref1.sessionId, sessionId = _sessionId === void 0 ? undefined : _sessionId, tmp1 = _context.fb, ref2 = tmp1 === void 0 ? {} : tmp1, _fbp = ref2.fbp, fbp = _fbp === void 0 ? undefined : _fbp, _fbc = ref2.fbc, fbc = _fbc === void 0 ? undefined : _fbc;
                            return [
                                4,
                                cartUpdateAttributes({
                                    attributes: [
                                        {
                                            key: "fueled_context",
                                            value: JSON.stringify({
                                                anonymousId: anonymousId,
                                                ga4: {
                                                    clientId: clientId,
                                                    sessionId: sessionId
                                                },
                                                fb: {
                                                    fbp: fbp,
                                                    fbc: fbc
                                                }
                                            })
                                        }
                                    ]
                                })
                            ];
                        case 3:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function setCartToken() {
                return _ref.apply(this, arguments);
            };
        }();
        if (window.fueled) {
            setCartToken();
        } else {
            window.addEventListener("fueled-ready", setCartToken);
        }
        return function() {
            window.removeEventListener("fueled-ready", setCartToken);
        };
    }, [
        cartId
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)((script_default()), {
        type: "text/javascript",
        src: fueledScriptUrl
    });
}

;// CONCATENATED MODULE: ./src/snippets/Fueled/FueledGTMScript.jsx




function FueledGTMScript(param) {
    var gtmContainerId = param.withKey;
    var subscribe = useAnalytics().subscribe;
    useScriptLoad({
        id: "gtm-script",
        innerHTML: "\n          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n          })(window,document,'script','dataLayer', '".concat(gtmContainerId, "');\n        ")
    }, "head");
    (0,react.useEffect)(function() {
        window.dataLayer = window.dataLayer || [];
        var pageViewListener = function(event) {
            window.dataLayer.push({
                event: "dl_route_update",
                page: event.detail.page,
                event_id: event.detail.event_id,
                event_time: event.detail.event_time,
                ecommerce: event.detail.ecommerce,
                user_properties: event.detail.user_properties
            });
        };
        var unsubscribe = subscribe(TRACKING_EVENTS.PAGE_VIEW, pageViewListener);
        return function() {
            unsubscribe();
        };
    }, []);
    return null;
}

;// CONCATENATED MODULE: ./src/snippets/Fueled/FueledTikTokScript.jsx






var EVENTS = [
    TRACKING_EVENTS.VIEW_ITEM,
    TRACKING_EVENTS.VIEW_ITEM_LIST,
    TRACKING_EVENTS.ADD_TO_CART,
    TRACKING_EVENTS.SIGN_UP,
    TRACKING_EVENTS.VIEW_SEARCH_RESULTS, 
];
function FueledTikTokScript(param) {
    var tiktokPixelId = param.withKey;
    var ref = useAnalytics(), register = ref.register, subscribe = ref.subscribe;
    var ready = register("tiktok-script");
    var status = useScriptLoad({
        id: "tiktok-script",
        innerHTML: '\n        !function (w, d, t) { w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];\n        ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],\n        ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};\n        for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);\n        ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},\n        ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";\n        ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};\n        var o=document.createElement("script");o.type="text/javascript",o.async=!0,o.src=i+"?sdkid="+e+"&lib="+t;\n        var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(o,a)}; ttq.load(\''.concat(tiktokPixelId, "'); ttq.instance('").concat(tiktokPixelId, "').page(); }(window, document, 'ttq');\n      "),
        waitFor: function() {
            return !!(window === null || window === void 0 ? void 0 : window.ttq);
        }
    }, "head", Boolean(tiktokPixelId)).status;
    (0,react.useEffect)(function() {
        if (status !== "ready") return;
        ready();
    }, [
        status
    ]);
    (0,react.useEffect)(function() {
        var identify = function(event) {
            var ref;
            if ((ref = event.detail.user_properties) === null || ref === void 0 ? void 0 : ref.customer_email) {
                var ref1, ref2;
                window.ttq.identify({
                    external_id: (ref1 = event.detail.user_properties) === null || ref1 === void 0 ? void 0 : ref1.customer_id,
                    email: (ref2 = event.detail.user_properties) === null || ref2 === void 0 ? void 0 : ref2.customer_email
                });
            }
        };
        var viewItemListener = function(event) {
            var eventId = getEventId(event);
            var _products = (0,_sliced_to_array/* default */.Z)(event.detail.ecommerce.detail.products, 1), product = _products[0];
            window.ttq.instance(tiktokPixelId).track("ViewContent", {
                content_name: product.name,
                content_category: product.category,
                content_id: product.product_id,
                content_type: "product_group",
                price: product.price,
                value: product.price,
                currency: event.detail.ecommerce.currency_code
            }, eventId ? {
                event_id: eventId
            } : undefined);
        };
        var addToCartListener = function(event) {
            var eventId = getEventId(event);
            var _products = (0,_sliced_to_array/* default */.Z)(event.detail.ecommerce.add.products, 1), product = _products[0];
            window.ttq.instance(tiktokPixelId).track("AddToCart", {
                content_name: product.name,
                content_category: product.category,
                content_id: product.product_id,
                content_type: "product_group",
                quantity: product.quantity,
                price: product.price,
                value: product.price * product.quantity,
                currency: event.detail.ecommerce.currency_code
            }, eventId ? {
                event_id: eventId
            } : undefined);
        };
        var viewSearchResultsListener = function(event) {
            try {
                var ref, ref1, ref2;
                var eventId = getEventId(event);
                var searchTerm = event === null || event === void 0 ? void 0 : (ref = event.detail) === null || ref === void 0 ? void 0 : (ref1 = ref.ecommerce) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.actionField) === null || ref2 === void 0 ? void 0 : ref2.search_term;
                if (searchTerm) {
                    window.ttq.instance(tiktokPixelId).track("Search", {
                        query: searchTerm
                    }, eventId ? {
                        event_id: eventId
                    } : undefined);
                }
            } catch (e) {
                console.log(e);
            }
        };
        var signUpListener = function(event) {
            try {
                window.ttq.instance(tiktokPixelId).track("CompleteRegistration", {});
            } catch (e) {
                console.log(e);
            }
        };
        var viewItemListListener = function(event) {
            try {
                var ref, ref1;
                var eventId = getEventId(event);
                var collectionProducts = event === null || event === void 0 ? void 0 : (ref = event.detail) === null || ref === void 0 ? void 0 : (ref1 = ref.ecommerce) === null || ref1 === void 0 ? void 0 : ref1.products;
                var contentProducts = collectionProducts.map(function(product) {
                    return {
                        content_name: product.name,
                        content_category: product.category,
                        content_id: product.product_id,
                        content_type: "product_group",
                        price: product.price
                    };
                });
                if (collectionProducts) {
                    var ref2, ref3;
                    window.ttq.instance(tiktokPixelId).track("ViewContent", {
                        contents: contentProducts,
                        content_type: "product_group",
                        currency: event === null || event === void 0 ? void 0 : (ref2 = event.detail) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.ecommerce) === null || ref3 === void 0 ? void 0 : ref3.currency_code,
                        value: (collectionProducts === null || collectionProducts === void 0 ? void 0 : collectionProducts.reduce(function(acc, item) {
                            return acc + parseFloat(item.price);
                        }, 0)) || []
                    }, eventId ? {
                        event_id: eventId
                    } : undefined);
                }
            } catch (e) {
                console.log(e);
            }
        };
        var eventHandler = function(event) {
            identify(event);
            switch(event.type){
                case TRACKING_EVENTS.VIEW_ITEM:
                    viewItemListener(event);
                    break;
                case TRACKING_EVENTS.VIEW_ITEM_LIST:
                    viewItemListListener(event);
                    break;
                case TRACKING_EVENTS.ADD_TO_CART:
                    addToCartListener(event);
                    break;
                case TRACKING_EVENTS.SIGN_UP:
                    signUpListener(event);
                    break;
                case TRACKING_EVENTS.VIEW_SEARCH_RESULTS:
                    viewSearchResultsListener(event);
                    break;
                default:
                    break;
            }
        };
        var unsubscribeArray = EVENTS.map(function(eventType) {
            return subscribe(eventType, eventHandler);
        });
        return function() {
            unsubscribeArray.forEach(function(unsubscribe) {
                return unsubscribe();
            });
        };
    }, []);
    return null;
}

// EXTERNAL MODULE: ../node_modules/styled-jsx/style.js
var style = __webpack_require__(14722);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
;// CONCATENATED MODULE: ./src/snippets/Fueled/FueledGorgiasScript.jsx



function GorgiasChatWidget() {
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_jsx_runtime_esm/* Fragment */.HY, {
        children: [
            (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)((style_default()), {
                id: "3019e8331ddce092",
                children: "iframe#chat-button.jsx-3019e8331ddce092,iframe#chat-window.jsx-3019e8331ddce092,iframe#chat-campaigns.jsx-3019e8331ddce092{z-index:40!important}"
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)((script_default()), {
                type: "text/javascript",
                dangerouslySetInnerHTML: {
                    __html: '\n            var HIDE_POWERED_BY_GORGIAS = true;\n            // var HIDE_WIDGET_OUTSIDE_BUSINESS_HOURS = true; // Uncomment if needed\n            !function(_) {\n              _.GORGIAS_CHAT_APP_ID = "338";\n              _.GORGIAS_CHAT_BASE_URL = "us-east1-898b.production.gorgias.chat";\n              _.GORGIAS_API_BASE_URL = "config.gorgias.chat";\n              var e = new XMLHttpRequest();\n              e.open("GET", "https://config.gorgias.chat/applications/338", true);\n              e.onload = function(t) {\n                if (e.readyState === 4)\n                  if (e.status === 200) {\n                    var n = JSON.parse(e.responseText);\n                    if (!n.application || !n.bundleVersion) throw new Error("Missing fields in the response body - https://config.gorgias.chat/applications/338");\n                    _.GORGIAS_CHAT_APP = n.application;\n                    _.GORGIAS_CHAT_BUNDLE_VERSION = n.bundleVersion;\n                    if (n && n.texts) _.GORGIAS_CHAT_TEXTS = n.texts;\n                    if (n && n.sspTexts) _.GORGIAS_CHAT_SELF_SERVICE_PORTAL_TEXTS = n.sspTexts;\n                    if (!document.getElementById("gorgias-chat-container")) {\n                      var o = document.createElement("div");\n                      o.id = "gorgias-chat-container";\n                      o.style = \'z-index:99;\';\n                      document.body.appendChild(o);\n                      var r = document.createElement("script");\n                      r.setAttribute("defer", true);\n                      r.src = "https://client-builds.production.gorgias.chat/" + n.bundleVersion + "/static/js/main.js";\n                      document.body.appendChild(r);\n                    }\n                  } else {\n                    console.error("Failed request GET - https://config.gorgias.chat/applications/338");\n                  }\n              };\n              e.onerror = function(_) {\n                console.error(_);\n              };\n              e.send();\n            }(window || {});\n          '
                }
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/snippets/Fueled/FueledUsableScript.jsx

function FueledUsableScript() {
    useScriptLoad({
        id: "fueled-usable-script",
        src: "https://a40.usablenet.com/pt/c/brumate/cookiestorestart"
    }, "head", typeof window.enableUsableNetAssistive === "undefined");
    return null;
}

;// CONCATENATED MODULE: ./src/snippets/Fueled/FueledKlaviyoScript.jsx






var FueledKlaviyoScript_EVENTS = [
    TRACKING_EVENTS.VIEW_ITEM,
    TRACKING_EVENTS.VIEW_ITEM_LIST,
    TRACKING_EVENTS.ADD_TO_CART,
    TRACKING_EVENTS.VIEW_SEARCH_RESULTS, 
];
function FueledKlaviyoScript(param) {
    var klaviyoPixelId = param.withKey;
    var ref = useAnalytics(), register = ref.register, subscribe = ref.subscribe;
    var status = useScriptLoad({
        id: "klaviyo-script",
        src: "https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=".concat(klaviyoPixelId),
        defer: true,
        waitFor: function() {
            return !!(window === null || window === void 0 ? void 0 : window.klaviyo);
        }
    }, "head").status;
    var ready = register("klaviyo");
    /* Specs:
   * https://developers.klaviyo.com/en/docs/javascript_api
   * https://developers.klaviyo.com/en/docs/guide_to_integrating_a_platform_without_a_pre_built_klaviyo_integration
   */ (0,react.useEffect)(function() {
        if (status !== "ready") return;
        var identify = function(event) {
            var ref;
            // Identify a user
            if ((ref = event.detail.user_properties) === null || ref === void 0 ? void 0 : ref.customer_email) {
                var ref1, ref2, ref3;
                window === null || window === void 0 ? void 0 : window.klaviyo.identify({
                    email: (ref1 = event.detail.user_properties) === null || ref1 === void 0 ? void 0 : ref1.customer_email,
                    first_name: (ref2 = event.detail.user_properties) === null || ref2 === void 0 ? void 0 : ref2.customer_first_name,
                    last_name: (ref3 = event.detail.user_properties) === null || ref3 === void 0 ? void 0 : ref3.customer_last_name
                });
            }
        };
        var viewItemListListener = function(event) {
            window === null || window === void 0 ? void 0 : window.klaviyo.push([
                "track",
                "Category View",
                {
                    CategoryName: event.detail.ecommerce.collection_id
                }, 
            ]);
        };
        var viewItemListener = function(event) {
            var ref, ref1, ref2;
            var ref3 = (0,_sliced_to_array/* default */.Z)(((ref = event.detail) === null || ref === void 0 ? void 0 : (ref1 = ref.ecommerce) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.detail) === null || ref2 === void 0 ? void 0 : ref2.products) || [], 1), product = ref3[0];
            if (!product) return;
            window === null || window === void 0 ? void 0 : window.klaviyo.push([
                "track",
                "Viewed Product",
                {
                    Name: product.name,
                    ProductID: product.sku,
                    Categories: product.category,
                    Collections: product.category,
                    ImageURL: product.image,
                    URL: document.location.href,
                    Brand: product.brand,
                    Price: product.price,
                    CompareAtPrice: product.price
                }, 
            ]);
            window === null || window === void 0 ? void 0 : window.klaviyo.push([
                "trackViewedItem",
                {
                    Title: product.name,
                    ItemId: product.sku,
                    Categories: product.category,
                    Collections: product.category,
                    ImageUrl: product.image,
                    Url: document.location.href,
                    Metadata: {
                        Brand: product.brand,
                        Price: product.price,
                        CompareAtPrice: product.price
                    }
                }, 
            ]);
        };
        var addToCartListener = function(event) {
            var ref, ref1, ref2;
            var ref3 = (0,_sliced_to_array/* default */.Z)(((ref = event.detail) === null || ref === void 0 ? void 0 : (ref1 = ref.ecommerce) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.add) === null || ref2 === void 0 ? void 0 : ref2.products) || [], 1), product = ref3[0];
            if (!product) return;
            var item = {
                Name: product.name,
                ProductID: product.sku,
                ItemId: product.product_id,
                Categories: product.category,
                Collections: product.collections,
                ImageURL: product.image,
                ImageUrl: product.image,
                URL: document.location.href,
                Url: document.location.href,
                Brand: product.brand,
                Price: product.price,
                CompareAtPrice: product.price,
                "Product ID": product.product_id,
                "Product Id": product.product_id,
                product_tags: product.tags,
                product_type: product.category,
                Title: product.name,
                title: product.name,
                "Product Title": product.name,
                "Product Price": product.price
            };
            window === null || window === void 0 ? void 0 : window.klaviyo.push([
                "track",
                "Added to Cart",
                item
            ]);
            window === null || window === void 0 ? void 0 : window.klaviyo.push([
                "trackViewedItem",
                {
                    Title: product.name,
                    ItemId: product.sku,
                    Categories: product.category,
                    Collections: product.category,
                    ImageUrl: product.image,
                    Url: document.location.href,
                    Metadata: {
                        Brand: product.brand,
                        Price: product.price,
                        CompareAtPrice: product.price
                    }
                }, 
            ]);
        };
        var viewSearchResultsListener = function(event) {
            var ref, ref1, ref2, ref3, ref4;
            var products = ((ref = event.detail) === null || ref === void 0 ? void 0 : (ref1 = ref.ecommerce) === null || ref1 === void 0 ? void 0 : ref1.products) || [];
            var searchTerm = ((ref2 = event.detail) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.ecommerce) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.actionField) === null || ref4 === void 0 ? void 0 : ref4.search_term) || "";
            window === null || window === void 0 ? void 0 : window.klaviyo.push([
                "track",
                "Searched Site",
                {
                    SearchTerm: searchTerm,
                    ReturnedResults: products.length,
                    ReturnedProducts: products.map(function(p) {
                        return {
                            Name: p.name,
                            ProductID: p.product_id,
                            Price: p.price,
                            Categories: p.category
                        };
                    })
                }, 
            ]);
        };
        var eventHandler = function(event) {
            identify(event);
            switch(event.type){
                case TRACKING_EVENTS.VIEW_ITEM:
                    viewItemListener(event);
                    break;
                case TRACKING_EVENTS.VIEW_ITEM_LIST:
                    viewItemListListener(event);
                    break;
                case TRACKING_EVENTS.ADD_TO_CART:
                    addToCartListener(event);
                    break;
                case TRACKING_EVENTS.VIEW_SEARCH_RESULTS:
                    viewSearchResultsListener(event);
                    break;
                default:
                    break;
            }
        };
        var klaviyoFormsListener = function(event) {
            if (event.detail.type === "submit") {
                window.dataLayer.push({
                    event: "dl_subscribe",
                    formId: event.detail.formId,
                    formTitle: event.detail.metaData.$source
                });
            }
        };
        var handlePostScriptPopup = function(event) {
            if (event.detail.type === "formSubmit") {
                var _detail = event.detail, popupId = _detail.popupId, popupName = _detail.popupName;
                // Use a regular expression to find key-value pairs in the popupName
                var keyValuePairs = {};
                var regex = /\[([^\]=]+)=([^\]]+)\]/g;
                var match;
                // eslint-disable-next-line no-cond-assign
                while((match = regex.exec(popupName)) !== null){
                    // eslint-disable-next-line prefer-destructuring
                    keyValuePairs[match[1]] = match[2];
                }
                var identifyObj = JSON.stringify(keyValuePairs) !== "{}" ? (0,_object_spread/* default */.Z)({
                    PostscriptPopupId: popupId,
                    PostscriptPopupName: popupName
                }, keyValuePairs) : {
                    PostscriptPopupId: popupId,
                    PostscriptPopupName: popupName
                };
                window.klaviyo.push([
                    "identify",
                    identifyObj
                ]);
            }
        };
        var unsubscribeArray = FueledKlaviyoScript_EVENTS.map(function(eventType) {
            return subscribe(eventType, eventHandler);
        });
        window.addEventListener("klaviyoForms", klaviyoFormsListener);
        window.addEventListener("postscriptPopup", handlePostScriptPopup);
        ready();
        // eslint-disable-next-line consistent-return
        return function() {
            unsubscribeArray.forEach(function(unsubscribe) {
                return unsubscribe();
            });
            window.removeEventListener("klaviyoForms", klaviyoFormsListener);
            window.removeEventListener("postscriptPopup", handlePostScriptPopup);
        };
    }, [
        status
    ]);
    return null;
}

;// CONCATENATED MODULE: ./src/snippets/Fueled/FueledPostscriptScript.jsx







var FueledPostscriptScript_EVENTS = [
    TRACKING_EVENTS.VIEW_ITEM,
    TRACKING_EVENTS.ADD_TO_CART
];
var determinePageType = function() {
    switch(true){
        case window.location.pathname.includes("/collections"):
            return "collection";
        case window.location.pathname.includes("/products"):
            return "product";
        case window.location.pathname.includes("/pages/search"):
            return "search";
        case window.location.pathname.includes("/pages"):
            return "page";
        case window.location.pathname.includes("/articles"):
            return "article";
        case window.location.pathname.includes("/blogs"):
            return "blog";
        default:
            return "home";
    }
};
function FueledPostscriptScript(param) {
    var postScriptShopId = param.withKey;
    var ref = useAnalytics(), register = ref.register, subscribe = ref.subscribe;
    var ready = register("postscript-script");
    var status = useScriptLoad({
        id: "postscript-".concat(postScriptShopId),
        src: "https://sdk.postscript.io/sdk.bundle.js?shopId=".concat(postScriptShopId, "&rand=").concat(Date.now())
    }, "head", Boolean(postScriptShopId)).status;
    (0,react.useEffect)(function() {
        if (status !== "ready") return;
        var identify = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
                var ref, ref1;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    if ((ref = event.detail.user_properties) === null || ref === void 0 ? void 0 : ref.customer_phone) {
                        ;
                        return [
                            2,
                            (ref1 = window.postscript) === null || ref1 === void 0 ? void 0 : ref1.identify({
                                phone: event.detail.user_properties.customer_phone
                            })
                        ];
                    }
                    return [
                        2,
                        null
                    ];
                });
            });
            return function identify(event) {
                return _ref.apply(this, arguments);
            };
        }();
        var viewItemListener = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
                var ref, _products, product;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    _products = (0,_sliced_to_array/* default */.Z)(event.detail.ecommerce.detail.products, 1), product = _products[0];
                    (ref = window.postscript) === null || ref === void 0 ? void 0 : ref.event("page_view", {
                        shop_id: postScriptShopId,
                        url: "".concat("https://www.brumate.com").concat(window.location.pathname),
                        search_params: {
                            variant: Number(product.variant_id)
                        },
                        page_type: determinePageType(),
                        referrer: document.referrer,
                        resource: {
                            category: product.category,
                            name: product.name,
                            price_in_cents: 100 * parseFloat(product.price),
                            resource_id: Number(product.product_id),
                            resource_type: "product",
                            sku: product.sku,
                            variant_id: Number(product.variant_id),
                            vendor: product.vendor || ""
                        }
                    });
                    console.log("Postscript Page View Event Fired:", product);
                    return [
                        2
                    ];
                });
            });
            return function viewItemListener(event) {
                return _ref.apply(this, arguments);
            };
        }();
        var addToCartListener = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
                var _products, product;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    _products = (0,_sliced_to_array/* default */.Z)(event.detail.ecommerce.add.products, 1), product = _products[0];
                    window.postscript.event("add_to_cart", {
                        shop_id: postScriptShopId,
                        url: "".concat("https://www.brumate.com").concat(window.location.pathname),
                        search_params: {
                            variant: Number(product.variant_id)
                        },
                        page_type: determinePageType(),
                        referrer: document.referrer,
                        resource: {
                            category: product.category,
                            name: product.name,
                            price_in_cents: 100 * parseFloat(product.price),
                            resource_id: Number(product.product_id),
                            resource_type: "product",
                            sku: product.sku,
                            variant_id: Number(product.variant_id),
                            vendor: product.vendor || ""
                        }
                    });
                    console.log("Postscript Add to Cart Event Fired:", product);
                    return [
                        2
                    ];
                });
            });
            return function addToCartListener(event) {
                return _ref.apply(this, arguments);
            };
        }();
        var handleEvent = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
                var _;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                identify(event)
                            ];
                        case 1:
                            _state.sent();
                            _ = event.type;
                            switch(_){
                                case TRACKING_EVENTS.VIEW_ITEM:
                                    return [
                                        3,
                                        2
                                    ];
                                case TRACKING_EVENTS.ADD_TO_CART:
                                    return [
                                        3,
                                        4
                                    ];
                            }
                            return [
                                3,
                                6
                            ];
                        case 2:
                            return [
                                4,
                                viewItemListener(event)
                            ];
                        case 3:
                            _state.sent();
                            return [
                                3,
                                7
                            ];
                        case 4:
                            return [
                                4,
                                addToCartListener(event)
                            ];
                        case 5:
                            _state.sent();
                            return [
                                3,
                                7
                            ];
                        case 6:
                            return [
                                3,
                                7
                            ];
                        case 7:
                            return [
                                2
                            ];
                    }
                });
            });
            return function handleEvent(event) {
                return _ref.apply(this, arguments);
            };
        }();
        var unsubscribeArray = FueledPostscriptScript_EVENTS.map(function(event) {
            return subscribe(event, handleEvent);
        });
        ready();
        // eslint-disable-next-line consistent-return
        return function() {
            unsubscribeArray.forEach(function(unsubscribe) {
                return unsubscribe();
            });
        };
    }, [
        status
    ]);
    return null;
}

;// CONCATENATED MODULE: ./src/snippets/Fueled/FueledFondueCashbackScript.jsx





var FueledFondueCashbackScript_EVENTS = [
    TRACKING_EVENTS.REMOVE_FROM_CART,
    TRACKING_EVENTS.ADD_TO_CART
];
function FueledFondueCashbackScript() {
    var cart = (0,dist.useCart)();
    var ref = useAnalytics(), register = ref.register, subscribe = ref.subscribe;
    var ready = register("fondue-cashback");
    var status = useScriptLoad({
        id: "fondue-cashback",
        src: "https://public.getfondue.com/cashback-extension/cart/fundle.js",
        shop: "kryo-gear.myshopify.com",
        api: "STOREFRONT",
        waitFor: function() {
            return !!window.Fondue;
        }
    }, "head").status;
    (0,react.useEffect)(function() {
        if (status !== "ready" || !(cart === null || cart === void 0 ? void 0 : cart.id)) return;
        window.Fondue.cart.getCartId = function() {
            return cart === null || cart === void 0 ? void 0 : cart.id;
        };
        window.getCartId = function() {
            return cart === null || cart === void 0 ? void 0 : cart.id;
        };
        window.Fondue.cart.registerCartId(cart.id);
    }, [
        cart === null || cart === void 0 ? void 0 : cart.id,
        status
    ]);
    (0,react.useEffect)(function() {
        if (status !== "ready") return;
        var updateCartListener = function() {
            // Delay to ensure dl_add_to_cart is fully processed
            if (window.Fondue.status === "ready") {
                window.Fondue.cart.dispatchUpdatedCartEvent();
            }
            console.log("fondueCashback update Cart Event Fired");
        };
        var unsubscribeArray = FueledFondueCashbackScript_EVENTS.map(function(event) {
            return subscribe(event, updateCartListener);
        });
        ready();
        // eslint-disable-next-line consistent-return
        return function() {
            unsubscribeArray.forEach(function(unsubscribe) {
                return unsubscribe();
            });
        };
    }, [
        status
    ]);
    return null;
}

;// CONCATENATED MODULE: ./src/snippets/Fueled/FueledKeynesScript.jsx





function FueledKeynesScript(param) {
    var _withKey = param.withKey, upixelId = _withKey.upixelId, advertiserId = _withKey.advertiserId;
    var ref = useAnalytics(), register = ref.register, subscribe = ref.subscribe;
    var ready = register("fueled-keynes-script");
    var status = useScriptLoad({
        id: "fueled-keynes-script",
        src: "https://js.adsrvr.org/up_loader.1.1.0.js"
    }, "head").status;
    (0,react.useEffect)(function() {
        if (status !== "ready") return;
        var pageViewListener = function() {
            if ((window === null || window === void 0 ? void 0 : window.ttd_dom_ready) && typeof (window === null || window === void 0 ? void 0 : window.TTDUniversalPixelApi) === "function") {
                window === null || window === void 0 ? void 0 : window.ttd_dom_ready(function() {
                    var universalPixelApi = new window.TTDUniversalPixelApi();
                    universalPixelApi.init(advertiserId, [
                        upixelId
                    ], "https://insight.adsrvr.org/track/up");
                });
            }
        };
        var unsubscribe = subscribe(TRACKING_EVENTS.PAGE_VIEW, pageViewListener);
        ready();
        // eslint-disable-next-line consistent-return
        return function() {
            unsubscribe();
        };
    }, [
        status
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("img", {
        width: "1",
        height: "1",
        alt: "",
        src: "//action.dstillery.com/orbserv/nspix?adv=cl172306849900104&ns=8766&nc=BruMate-Site-Visitor&ncv=71"
    });
}

;// CONCATENATED MODULE: ./src/snippets/Fueled/FueledDataLayer.jsx


function FueledDataLayer() {
    // accumulate events until the fueled script is loaded
    (0,react.useEffect)(function() {
        var ref;
        var eventTypes = Object.values(TRACKING_EVENTS);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.packdigital = ((ref = window.dataLayer) === null || ref === void 0 ? void 0 : ref.packdigital) || [];
        var eventHandler = function(event) {
            window.dataLayer.packdigital.push({
                type: event.type,
                detail: event.detail
            });
        };
        eventTypes.forEach(function(eventType) {
            return window.addEventListener(eventType, eventHandler);
        });
        return function() {
            eventTypes.forEach(function(eventType) {
                window.removeEventListener(eventType, eventHandler);
            });
        };
    }, []);
    return null;
}

;// CONCATENATED MODULE: ./src/snippets/Fueled/Fueled.jsx
/* provided dependency */ var Fueled_process = __webpack_require__(14284);





// import { FueledNorthbeamScript } from './FueledNorthbeamScript';








var gtmContainerId = /* process.env.NEXT_PUBLIC_GTM_CONTAINER_ID || */ "GTM-P3XTC38C";
var tiktokPixelId = "C18FEQF4RPCPCMC7H62G" || 0;
var klaviyoApiKey = Fueled_process.env.NEXT_PUBLIC_KLAVIYO_PUBLIC_API_KEY || "QC4SUa";
var postScriptShopId = "398366" || 0;
var keynesAdvertiserId = Fueled_process.env.NEXT_PUBLIC_KEYNES_ADVERTISER_ID || "q39posi";
var keynesUpixelId = Fueled_process.env.NEXT_PUBLIC_KEYNES_UPIXEL_ID || "d579yyz";
var scripts = [
    {
        Component: FueledClientScript,
        consent: [
            "all"
        ]
    },
    {
        withKey: klaviyoApiKey,
        Component: FueledKlaviyoScript,
        consent: [
            "marketing"
        ]
    },
    {
        Component: FueledDataLayer,
        consent: [
            "all"
        ]
    },
    {
        withKey: gtmContainerId,
        Component: FueledGTMScript,
        consent: [
            "all"
        ]
    },
    {
        withKey: tiktokPixelId,
        Component: FueledTikTokScript,
        consent: [
            "marketing"
        ]
    },
    {
        withKey: postScriptShopId,
        Component: FueledPostscriptScript,
        consent: [
            "marketing"
        ]
    },
    // { Component: FueledNorthbeamScript, consent: ['analytics'] },
    {
        Component: GorgiasChatWidget,
        consent: [
            "all"
        ]
    },
    {
        Component: FueledUsableScript,
        consent: [
            "all"
        ]
    },
    {
        Component: FueledFondueCashbackScript,
        consent: [
            "all"
        ]
    },
    {
        withKey: {
            advertiserId: keynesAdvertiserId,
            upixelId: keynesUpixelId
        },
        Component: FueledKeynesScript,
        consent: [
            "marketing"
        ]
    },
    {
        withKey: gtmContainerId,
        Component: FueledGTMScript,
        consent: [
            "all"
        ]
    }, 
];
function Fueled() {
    var consent = useAnalytics().consent;
    if (!consent) {
        return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(FueledDataLayer, {});
    }
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_jsx_runtime_esm/* Fragment */.HY, {
        children: scripts.filter(function(param) {
            var componentConsent = param.consent;
            return componentConsent.includes("all") || componentConsent.every(function(c) {
                return consent[c];
            });
        }).map(function(param, index) {
            var withKey = param.withKey, Component = param.Component, key = param.key;
            return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Component, {
                withKey: withKey || ""
            }, key || index);
        })
    });
}
function FueledAnalyticsWrapper() {
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_jsx_runtime_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(FueledTrueVault, {}),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(FueledAnalyticsProvider, {
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Fueled, {})
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/snippets/Fueled/index.js


;// CONCATENATED MODULE: ./src/snippets/FilterOption/FilterOption.theme.js

var FilterOption_theme_themed = (0,create/* create */.U)(new function() {
    this.button = {
        display: "flex"
    };
    this.swatchOuter = function(isActive) {
        return {
            width: "24px",
            height: "24px",
            borderRadius: "50%",
            position: "relative",
            overflow: "hidden",
            bg: "white",
            borderStyle: !isActive ? "none" : "solid",
            borderWidth: "1px",
            borderColor: "text",
            mr: 7
        };
    };
    this.swatchInner = function(param) {
        var isActive = param.isActive, isWhite = param.isWhite, isImage = param.isImage, bgColor = param.bgColor, borderColor = param.borderColor;
        return {
            width: isActive ? "calc(100% - 4px)" : "100%",
            height: isActive ? "calc(100% - 4px)" : "100%",
            borderRadius: "50%",
            borderWidth: "1px",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            overflow: "hidden",
            bg: isActive && isWhite ? "lightGray" : bgColor,
            borderStyle: isImage || isActive ? "none" : "solid",
            borderColor: borderColor
        };
    };
    this.image = function(isActive) {
        return {
            position: "absolute",
            width: isActive ? "calc(100% + 4px)" : "100%",
            height: isActive ? "calc(100% + 4px)" : "100%",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)"
        };
    };
    this.checkmark = function(isWhite) {
        return {
            color: isWhite ? "text" : "white",
            width: "8px",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)"
        };
    };
    this.label = function(isActive) {
        return {
            variant: "text.lg",
            color: isActive ? "text" : "mediumDarkGray",
            textDecoration: isActive ? "underline" : "unset",
            textUnderlineOffset: "2px",
            textDecorationThickness: "1px",
            textAlign: "left",
            flex: 1
        };
    };
}());

;// CONCATENATED MODULE: ./src/snippets/FilterOption/FilterOption.jsx








var FilterOption = FilterOption_theme_themed(function(_param) {
    var theme = _param.theme, option = _param.option, field = _param.field, buttonSx = _param.buttonSx, isMobile = _param.isMobile, _addToSelectedFilters = _param.addToSelectedFilters, addToSelectedFilters = _addToSelectedFilters === void 0 ? function() {} : _addToSelectedFilters, _removeFromSelectedFilters = _param.removeFromSelectedFilters, removeFromSelectedFilters = _removeFromSelectedFilters === void 0 ? function() {} : _removeFromSelectedFilters, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme",
        "option",
        "field",
        "buttonSx",
        "isMobile",
        "addToSelectedFilters",
        "removeFromSelectedFilters"
    ]);
    var ref, ref1, ref2, ref3;
    var swatchesMap = (0,store/* useRecoilValue */.sJ)(store/* default.swatchesMap */.ZP.swatchesMap);
    var isColor = field === "tags_colorfilter";
    var label = (ref = option.label) === null || ref === void 0 ? void 0 : ref.toLowerCase();
    var swatchColor = isColor ? (ref1 = swatchesMap[label]) === null || ref1 === void 0 ? void 0 : ref1.color : null;
    var isWhite = swatchColor === "#FFFFFF";
    var inactiveBgColor = swatchColor || "#FFFFFF";
    var activeBgColor = inactiveBgColor === "#FFFFFF" ? "text" : inactiveBgColor;
    var bgColor = option.active ? activeBgColor : inactiveBgColor;
    var borderColor = inactiveBgColor === "#FFFFFF" ? "black" : inactiveBgColor;
    var isImage = isColor ? !!((ref2 = swatchesMap[label]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.image) === null || ref3 === void 0 ? void 0 : ref3.src) : false;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Button */.zx, {
        "data-comp": FilterOption.displayName,
        variant: "buttons.plain",
        onClick: function() {
            if (option.active) {
                removeFromSelectedFilters({
                    field: field,
                    option: option
                });
            } else {
                addToSelectedFilters({
                    field: field,
                    option: option
                });
            }
        },
        tabIndex: props.tabIndex || "0",
        "aria-hidden": props["aria-hidden"] || "false",
        sx: (0,_object_spread/* default */.Z)({}, theme.button, buttonSx),
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                sx: theme.swatchOuter(option.active),
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                    sx: theme.swatchInner({
                        isActive: option.active,
                        isWhite: isWhite,
                        isImage: isImage,
                        bgColor: bgColor,
                        borderColor: borderColor
                    }),
                    children: [
                        isImage && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Picture, {
                            alt: label,
                            images: [
                                {
                                    src: swatchesMap[label].image.src,
                                    ratio: 1,
                                    width: 24
                                }, 
                            ],
                            sx: theme.image(option.active)
                        }),
                        option.active && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Svg, {
                            src: "/svgs/checkmark.svg#checkmark",
                            alt: "Checkmark",
                            viewBox: "0 0 14 12",
                            sx: theme.checkmark(isWhite)
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Paragraph */.nv, {
                sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.label(option.active)), {
                    color: (option === null || option === void 0 ? void 0 : option.active) ? "text" : isMobile ? "dark" : "mediumDarkGray"
                }),
                children: [
                    option.label,
                    " ",
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Text */.xv, {
                        children: [
                            "(",
                            option.count,
                            ")"
                        ]
                    })
                ]
            })
        ]
    });
});
FilterOption.displayName = "FilterOption";

;// CONCATENATED MODULE: ./src/snippets/FilterOption/index.js


// EXTERNAL MODULE: ./src/templates/collection/hooks/index.js + 4 modules
var collection_hooks = __webpack_require__(54174);
// EXTERNAL MODULE: ./src/snippets/Search/SearchPage/Filters/index.js + 8 modules
var Filters = __webpack_require__(65793);
;// CONCATENATED MODULE: ./src/snippets/FiltersSidebar/FiltersSidebar.theme.js

var FiltersSidebar_theme_themed = (0,create/* create */.U)(new function() {
    // FiltersSidebarShell theme
    this.shell = {
        display: "block",
        zIndex: 1000,
        position: "fixed",
        width: [
            "100%",
            "494px"
        ],
        bg: "background",
        top: 0,
        left: [
            0,
            "auto"
        ],
        bottom: 0,
        right: [
            "auto",
            0
        ],
        p: [
            "16px",
            "40px"
        ],
        transition: "transform .3s ease-in-out"
    };
    this.scroll = {
        height: [
            "calc(100% - 130px)",
            "calc(100% - 100px)"
        ],
        overflowY: "scroll",
        webkitOverflowScrolling: "touch",
        msOverflowStyle: "none",
        scrollbarWidth: "none",
        "::-webkit-scrollbar": {
            display: "none"
        }
    };
    this.grid = {
        gridTemplateColumns: "1fr",
        gridGap: 0,
        pl: 0
    };
    // Open accordion button theme
    this.button = function(isLast) {
        return {
            minHeight: "46px",
            px: 0,
            py: 4,
            width: "100%",
            display: "flex",
            alignItems: "center",
            borderBottom: function(t) {
                return "1px solid ".concat(t.colors.gray);
            },
            borderBottomStyle: isLast ? "none" : "solid"
        };
    };
    // FiltersSidebarHeader theme
    this.header = {
        variant: "flex.row.start.center",
        height: "52px",
        borderBottom: function(t) {
            return "1px solid ".concat(t.colors.mediumGray);
        },
        position: "sticky",
        top: 0,
        bg: "background",
        zIndex: 1,
        backButton: {
            display: "block",
            position: "absolute",
            top: "50%",
            right: 0,
            transform: "translateY(-50%)"
        },
        icon: {
            width: "24px",
            height: "24px",
            color: "dark"
        },
        heading: {
            fontSize: "20px",
            lineHeight: 24,
            textAlign: "left",
            letterSpacing: "-0.005em",
            fontWeight: 500
        },
        clearAll: {
            position: "absolute",
            top: "50%",
            right: "48px",
            transform: "translateY(-50%)"
        }
    };
    this.accordionHeader = {
        variant: "text.label.1",
        display: "inline-block"
    };
    // Sort theme
    this.swatchOuter = function(isActive) {
        return {
            width: "24px",
            height: "24px",
            borderRadius: "50%",
            position: "relative",
            overflow: "hidden",
            bg: "white",
            borderStyle: isActive ? "solid" : "none",
            borderWidth: "1px",
            borderColor: "text",
            mr: 7
        };
    };
    this.swatchInner = function(isActive) {
        return {
            width: isActive ? "calc(100% - 4px)" : "100%",
            height: isActive ? "calc(100% - 4px)" : "100%",
            borderRadius: "50%",
            borderWidth: "1px",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            overflow: "hidden",
            bg: isActive ? "text" : "white",
            borderStyle: isActive ? "none" : "solid",
            borderColor: "text"
        };
    };
    this.checkmark = function() {
        return {
            color: "white",
            width: "8px",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)"
        };
    };
    this.label = function(isActive) {
        return {
            variant: "text.lg",
            color: isActive ? "text" : "dark",
            textDecoration: isActive ? "underline" : "unset",
            textUnderlineOffset: "2px",
            textDecorationThickness: "1px",
            textAlign: "left",
            flex: 1
        };
    };
    this.selectedSort = {
        fontSize: 3,
        color: "mediumDarkGray",
        ml: 4,
        textTransform: "none"
    };
}());

;// CONCATENATED MODULE: ./src/snippets/FiltersSidebar/SizeSidebar/SizeSidebar.theme.js

var SizeSidebar_theme_themed = (0,create/* create */.U)(new function() {
    this.scroll = {
        height: "calc(var(--viewport-height) - 32px)",
        overflowY: "scroll",
        webkitOverflowScrolling: "touch",
        msOverflowStyle: "none",
        scrollbarWidth: "none",
        "::-webkit-scrollbar": {
            display: "none"
        }
    };
    this.grid = {
        gridTemplateColumns: "1fr",
        gridGap: 0,
        pl: 0
    };
    this.item = function(isActive) {
        return {
            link: {
                display: "flex",
                px: 11,
                py: 6,
                borderBottom: function(t) {
                    return "1px solid ".concat(t.colors.gray);
                },
                ":hover": {
                    p: {
                        textDecoration: "underline",
                        textDecorationThickness: "1px",
                        textUnderlineOffset: "1px"
                    }
                }
            },
            picture: {
                width: "40px",
                mr: 10,
                transition: "all 0.15s ease-in-out"
            },
            label: {
                variant: "text.lg",
                pt: 5,
                flex: 1,
                textDecoration: isActive ? "underline" : "none",
                textDecorationThickness: "1px",
                textUnderlineOffset: "1px",
                transition: "all 0.15s ease-in-out"
            }
        };
    };
}());

;// CONCATENATED MODULE: ./src/snippets/FiltersSidebar/SizeSidebar/SizeSidebarItem.jsx






var SizeSidebarItem = SizeSidebar_theme_themed(function(param) {
    var item = param.item, toggleFiltersSidebar = param.toggleFiltersSidebar, theme = param.theme;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var router = (0,dist.useRouter)();
    var collectionHandle = (ref = router.query) === null || ref === void 0 ? void 0 : ref.handle;
    var productHandle = (ref1 = item.mobileImage) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.product) === null || ref2 === void 0 ? void 0 : ref2.handle;
    var manualSrc = (ref3 = item.mobileImage) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.image) === null || ref4 === void 0 ? void 0 : ref4.src;
    var product = (0,dist.useProductByHandle)({
        handle: productHandle
    }).product;
    var firstImage = (0,react.useMemo)(function() {
        var ref, ref1;
        return (ref1 = product === null || product === void 0 ? void 0 : (ref = product.media) === null || ref === void 0 ? void 0 : ref.find(function(item) {
            return item.mediaContentType === "IMAGE";
        })) === null || ref1 === void 0 ? void 0 : ref1.image;
    }, [
        product === null || product === void 0 ? void 0 : product.id
    ]);
    var isActive = (0,react.useMemo)(function() {
        var ref, ref1;
        return ((ref = item.link) === null || ref === void 0 ? void 0 : (ref1 = ref.url) === null || ref1 === void 0 ? void 0 : ref1.split("/").pop()) === collectionHandle;
    }, [
        (ref5 = item.link) === null || ref5 === void 0 ? void 0 : ref5.url,
        collectionHandle
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(Link, {
        "data-comp": SizeSidebarItem.displayName,
        href: (ref6 = item.link) === null || ref6 === void 0 ? void 0 : ref6.url,
        newTab: (ref7 = item.link) === null || ref7 === void 0 ? void 0 : ref7.newTab,
        sx: theme.item(isActive).link,
        onClick: toggleFiltersSidebar,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Picture, {
                alt: (ref8 = item.link) === null || ref8 === void 0 ? void 0 : ref8.text,
                images: [
                    {
                        src: firstImage === null || firstImage === void 0 ? void 0 : firstImage.originalSrc,
                        width: 40,
                        ratio: 1
                    }, 
                ],
                sx: theme.item(isActive).picture,
                imageSx: {
                    objectFit: manualSrc ? "cover" : "contain"
                }
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                sx: theme.item(isActive).label,
                children: (ref9 = item.link) === null || ref9 === void 0 ? void 0 : ref9.text
            })
        ]
    });
});
SizeSidebarItem.displayName = "SizeSidebarItem";

;// CONCATENATED MODULE: ./src/snippets/FiltersSidebar/SizeSidebar/SizeSidebar.jsx




var SizeSidebar = SizeSidebar_theme_themed(function(param) {
    var theme = param.theme, toggleFiltersSidebar = param.toggleFiltersSidebar, options = param.options;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": SizeSidebar.displayName,
        sx: theme.scroll,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Grid */.rj, {
            as: "ul",
            sx: theme.grid,
            children: options === null || options === void 0 ? void 0 : options.map(function(option) {
                return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                    as: "li",
                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(SizeSidebarItem, {
                        item: option,
                        toggleFiltersSidebar: toggleFiltersSidebar
                    })
                }, option.label);
            })
        })
    });
});
SizeSidebar.displayName = "SizeSidebar";

;// CONCATENATED MODULE: ./src/snippets/FiltersSidebar/SizeSidebar/index.js


// EXTERNAL MODULE: ./src/snippets/Search/SearchPage/Sort/index.js + 4 modules
var Sort = __webpack_require__(24239);
;// CONCATENATED MODULE: ./src/snippets/FiltersSidebar/FiltersSidebar.jsx









var FiltersSidebar = FiltersSidebar_theme_themed(function(param) {
    var theme = param.theme, filters = param.filters, addToSelectedFilters = param.addToSelectedFilters, removeFromSelectedFilters = param.removeFromSelectedFilters, isSearchPage = param.isSearchPage, toggleFiltersSidebar = param.toggleFiltersSidebar;
    var ref = (0,_sliced_to_array/* default */.Z)((0,collection_hooks/* useCollectionSort */.$t)(), 2), collectionSortState = ref[0], collectionSortActions = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,Sort/* useSearchSort */.q)(), 2), searchSortState = ref1[0], searchSortActions = ref1[1];
    var sortOptions = isSearchPage ? searchSortState.sortOptions : collectionSortState.sortOptions;
    var selectedSort = (isSearchPage ? searchSortState.selectedSort : collectionSortState.selectedSort) || {
        field: "best_match",
        direction: "desc"
    };
    var sortCollection = isSearchPage ? searchSortActions.sortCollection : collectionSortActions.sortCollection;
    console.log(collectionSortState, selectedSort, sortOptions);
    var selectedSortLabel = (0,react.useMemo)(function() {
        if (!selectedSort || !sortOptions) return "Best Match";
        var selectedOption = sortOptions.find(function(param) {
            var field = param.field, direction = param.direction;
            return field === selectedSort.field && direction === selectedSort.direction;
        });
        return (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label) || null;
    }, [
        selectedSort === null || selectedSort === void 0 ? void 0 : selectedSort.field,
        selectedSort === null || selectedSort === void 0 ? void 0 : selectedSort.direction,
        sortOptions === null || sortOptions === void 0 ? void 0 : sortOptions.length
    ]);
    var selectedFilters = (0,store/* useRecoilValue */.sJ)(store/* default.selectedFilters */.ZP.selectedFilters);
    var searchSelectedFilters = (0,store/* useRecoilValue */.sJ)(store/* default.searchSelectedFilters */.ZP.searchSelectedFilters);
    var selectedFiltersLength = (0,react.useMemo)(function() {
        var removeDuplicatePriceFilters = isSearchPage ? searchSelectedFilters === null || searchSelectedFilters === void 0 ? void 0 : searchSelectedFilters.filter(function(filter) {
            return filter.key !== "filter.ss_price.low";
        }) : selectedFilters === null || selectedFilters === void 0 ? void 0 : selectedFilters.filter(function(filter) {
            return filter.key !== "filter.ss_price.low";
        });
        return removeDuplicatePriceFilters === null || removeDuplicatePriceFilters === void 0 ? void 0 : removeDuplicatePriceFilters.length;
    }, [
        selectedFilters,
        searchSelectedFilters
    ]);
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,collection_hooks/* useCollectionFilters */.PY)(), 1), totalResults = ref2[0].totalResults;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": FiltersSidebar.displayName,
        sx: theme.scroll,
        children: [
            (filters === null || filters === void 0 ? void 0 : filters.length) > 0 && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(Accordions, {
                textColor: "text",
                borderColor: "gray",
                iconColor: "text",
                minHeight: "52px",
                maxHeight: "800px",
                oneOpenAtATime: false,
                defaultIndex: 1,
                sx: {
                    borderTopStyle: "none"
                },
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(Accordion, {
                        sx: {
                            display: [
                                "block",
                                "none"
                            ],
                            borderColor: "mediumGray"
                        },
                        children: [
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Accordion.Header, {
                                sx: {
                                    pl: 0,
                                    py: 8,
                                    pr: 8
                                },
                                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                                    variant: "flex.row.start.center",
                                    children: [
                                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                                            as: "h5",
                                            sx: theme.accordionHeader,
                                            children: "Sort"
                                        }),
                                        selectedSortLabel && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                                            sx: theme.selectedSort,
                                            children: selectedSortLabel
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Accordion.Body, {
                                sx: {
                                    pb: 0
                                },
                                children: function(param) {
                                    var isOpen = param.isOpen;
                                    /*#__PURE__*/ return (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Grid */.rj, {
                                        as: "ul",
                                        sx: theme.grid,
                                        children: sortOptions === null || sortOptions === void 0 ? void 0 : sortOptions.map(function(param, index) {
                                            var field = param.field, direction = param.direction, label = param.label;
                                            var isActive = (selectedSort === null || selectedSort === void 0 ? void 0 : selectedSort.field) === field && (selectedSort === null || selectedSort === void 0 ? void 0 : selectedSort.direction) === direction;
                                            var isLast = index === sortOptions.length - 1;
                                            return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                                                as: "li",
                                                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Button */.zx, {
                                                    variant: "buttons.plain",
                                                    tabIndex: isOpen ? "0" : "-1",
                                                    "aria-hidden": isOpen ? "false" : "true",
                                                    onClick: function() {
                                                        sortCollection({
                                                            field: field,
                                                            direction: direction
                                                        });
                                                    },
                                                    sx: theme.button(isLast),
                                                    children: [
                                                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                                                            sx: theme.swatchOuter(isActive),
                                                            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                                                                sx: theme.swatchInner(isActive),
                                                                children: isActive && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Svg, {
                                                                    src: "/svgs/checkmark.svg#checkmark",
                                                                    alt: "Checkmark",
                                                                    viewBox: "0 0 14 12",
                                                                    sx: theme.checkmark()
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                                                            sx: theme.label(isActive),
                                                            children: label
                                                        })
                                                    ]
                                                })
                                            }, label);
                                        })
                                    });
                                }
                            })
                        ]
                    }),
                    filters === null || filters === void 0 ? void 0 : filters.map(function(filter, idx) {
                        return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(Accordion, {
                            sx: {
                                borderColor: "mediumGray"
                            },
                            collapsed: idx != 0,
                            children: [
                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Accordion.Header, {
                                    sx: {
                                        pl: 0,
                                        py: 8,
                                        pr: 8
                                    },
                                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                                        variant: "flex.row.start.center",
                                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                                            as: "h5",
                                            sx: theme.accordionHeader,
                                            children: filter.label
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Accordion.Body, {
                                    sx: {
                                        pb: 0
                                    },
                                    children: function(param) {
                                        var isOpen = param.isOpen;
                                        var ref;
                                        /*#__PURE__*/ return (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Grid */.rj, {
                                            as: "ul",
                                            sx: theme.grid,
                                            children: (ref = filter.values) === null || ref === void 0 ? void 0 : ref.map(function(option, index) {
                                                var isLast = index === filter.values.length - 1;
                                                return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                                                    as: "li",
                                                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(FilterOption, {
                                                        buttonSx: theme.button(isLast),
                                                        isMobile: true,
                                                        option: option,
                                                        field: filter.field,
                                                        tabIndex: isOpen ? "0" : "-1",
                                                        "aria-hidden": isOpen ? "false" : "true",
                                                        addToSelectedFilters: addToSelectedFilters,
                                                        removeFromSelectedFilters: removeFromSelectedFilters
                                                    })
                                                }, option.label);
                                            })
                                        });
                                    }
                                })
                            ]
                        }, filter.label);
                    })
                ]
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                sx: {
                    position: "absolute",
                    bottom: 11,
                    left: 0,
                    px: 8,
                    width: "100%"
                },
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                    variant: "buttons.primary",
                    sx: {
                        width: "100%"
                    },
                    onClick: function() {
                        toggleFiltersSidebar();
                    },
                    children: selectedFiltersLength ? "Apply Filters (".concat(totalResults, " Results)") : "Apply Filters"
                })
            })
        ]
    });
});
FiltersSidebar.displayName = "FiltersSidebar";

// EXTERNAL MODULE: ./src/snippets/Search/SearchPage/Filters/useSearchFilters.js
var useSearchFilters = __webpack_require__(37283);
;// CONCATENATED MODULE: ./src/snippets/FiltersSidebar/FiltersSidebarHeader.jsx







var FiltersSidebarHeader = FiltersSidebar_theme_themed(function(param) {
    var theme = param.theme, toggleFiltersSidebar = param.toggleFiltersSidebar, title = param.title, isSearchPage = param.isSearchPage;
    var ref = (0,_sliced_to_array/* default */.Z)(isSearchPage ? (0,useSearchFilters/* useSearchFilters */.S)() : (0,collection_hooks/* useCollectionFilters */.PY)(), 2), clearSelectedFilters = ref[1].clearSelectedFilters;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
        "data-comp": FiltersSidebarHeader.displayName,
        sx: theme.header,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                as: "h5",
                sx: theme.header.heading,
                children: title
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                variant: "buttons.link.1",
                onClick: clearSelectedFilters,
                sx: theme.header.clearAll,
                children: "Clear All"
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                variant: "buttons.plain",
                onClick: toggleFiltersSidebar,
                sx: theme.header.backButton,
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Svg, {
                    viewBox: "0 0 24 24",
                    src: "/svgs/close.svg",
                    sx: theme.header.icon
                })
            })
        ]
    });
});
FiltersSidebarHeader.displayName = "FiltersSidebarHeader";

;// CONCATENATED MODULE: ./src/snippets/FiltersSidebar/FiltersSidebarShell.jsx













var FiltersSidebarShell = FiltersSidebar_theme_themed(function(_param) {
    var theme = _param.theme, inputRef = _param.inputRef, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme",
        "inputRef"
    ]);
    var ref = (0,_sliced_to_array/* default */.Z)((0,hooks/* useFiltersSidebar */.JE)(), 2), ref1 = ref[0], filtersSidebar = ref1.filtersSidebar, isSize = ref1.isSize, isFiltersAndSort = ref1.isFiltersAndSort, isSearchPage = ref1.isSearchPage, toggleFiltersSidebar = ref[1].toggleFiltersSidebar;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,collection_hooks/* useCollectionFilters */.PY)(), 2), collectionFilterState = ref2[0], collectionFilterActions = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,Filters/* useSearchFilters */.Sr)(), 2), searchFilterState = ref3[0], searchFilterActions = ref3[1];
    var addToSelectedFilters = isSearchPage ? searchFilterActions.addToSelectedFilters : collectionFilterActions.addToSelectedFilters;
    var removeFromSelectedFilters = isSearchPage ? searchFilterActions.removeFromSelectedFilters : collectionFilterActions.removeFromSelectedFilters;
    var filters = isSearchPage ? searchFilterState.filters : collectionFilterState.filters;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Container */.W2, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-comp": FiltersSidebarShell.displayName
    }, props), {
        sx: (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.shell), {
            transform: filtersSidebar ? "translateX(0)" : "translateX(100%)"
        }), props.sx),
        children: filtersSidebar && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_jsx_runtime_esm/* Fragment */.HY, {
            children: [
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(FiltersSidebarHeader, {
                    toggleFiltersSidebar: toggleFiltersSidebar,
                    title: filtersSidebar === null || filtersSidebar === void 0 ? void 0 : filtersSidebar.label,
                    isSearchPage: isSearchPage
                }),
                isSize && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(SizeSidebar, {
                    options: filtersSidebar === null || filtersSidebar === void 0 ? void 0 : filtersSidebar.values,
                    toggleFiltersSidebar: toggleFiltersSidebar
                }),
                isFiltersAndSort && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(FiltersSidebar, {
                    filters: filters,
                    addToSelectedFilters: addToSelectedFilters,
                    removeFromSelectedFilters: removeFromSelectedFilters,
                    isSearchPage: isSearchPage,
                    toggleFiltersSidebar: toggleFiltersSidebar
                })
            ]
        })
    }));
});
FiltersSidebarShell.displayName = "FiltersSidebarShell";

;// CONCATENATED MODULE: ./src/snippets/FiltersSidebar/index.js


// EXTERNAL MODULE: ../node_modules/@tapcart/webbridge-react/dist/webbridge-react.es.js
var webbridge_react_es = __webpack_require__(13305);
;// CONCATENATED MODULE: ./src/snippets/Footer/Footer.theme.js

var Footer_Footer_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        pb: [
            12,
            15
        ],
        pt: [
            12,
            18
        ],
        color: "white",
        bg: "dark",
        minHeight: "400px"
    };
    this.content = {
        variant: "layout.content",
        px: [
            0,
            12,
            14
        ],
        maxWidth: "1360px",
        display: "grid",
        gridTemplateColumns: "1fr",
        gridGap: [
            15,
            18
        ]
    };
    this.grid = {
        width: "100%",
        gridTemplateColumns: [
            "1fr",
            "min-content auto",
            "auto 1fr auto"
        ],
        gridTemplateAreas: [
            '"social" "email" "menu"',
            '"social email" "menu menu"',
            '"social menu email"', 
        ],
        rowGap: [
            0,
            16
        ],
        columnGap: [
            0,
            19,
            15,
            19
        ]
    };
}());

;// CONCATENATED MODULE: ./src/snippets/Footer/Desktop/DesktopMenu.theme.js

var DesktopMenu_theme_themed = (0,create/* create */.U)(new function() {
    this.grid = {
        gridArea: "menu",
        display: [
            "none",
            "grid"
        ],
        flex: 1,
        gridTemplateColumns: "repeat(4, min(25%, 210px))",
        columnGap: 0,
        rowGap: 10
    };
    this.menuItem = {
        pr: 10
    };
    this.name = {
        mb: 10
    };
    this.list = {
        display: "grid",
        gridGap: 5,
        pl: 0
    };
    this.item = {
        display: "block",
        variant: "text.base",
        lineHeight: "20px"
    };
    this.link = {
        position: "relative",
        display: "inline",
        pb: 1,
        backgroundImage: "linear-gradient(currentColor, currentColor)",
        backgroundPosition: "0% 100%",
        backgroundRepeat: "no-repeat",
        backgroundSize: "0% 1px",
        transition: "background-size 0.2s ease-in-out",
        ":hover, :focus": {
            backgroundSize: "100% 1px"
        }
    };
}());

;// CONCATENATED MODULE: ./src/snippets/Footer/Desktop/DesktopMenu.jsx





var DesktopMenu = DesktopMenu_theme_themed(function(param) {
    var theme = param.theme;
    var ref;
    var settings = (0,dist.useSettings)();
    var menu = settings === null || settings === void 0 ? void 0 : (ref = settings.footer) === null || ref === void 0 ? void 0 : ref.menu;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": DesktopMenu.displayName,
        sx: theme.grid,
        children: Array.isArray(menu) && (menu === null || menu === void 0 ? void 0 : menu.map(function(menuItem, index) {
            var items = menuItem === null || menuItem === void 0 ? void 0 : menuItem.subMenuItems;
            return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                sx: theme.menuItem,
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                        variant: "label.1",
                        sx: theme.name,
                        children: menuItem === null || menuItem === void 0 ? void 0 : menuItem.name
                    }),
                    (items === null || items === void 0 ? void 0 : items.length) > 0 && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                        as: "ul",
                        sx: theme.list,
                        children: items.map(function(subMenuItem, index) {
                            var ref, ref1, ref2;
                            return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                                as: "li",
                                sx: theme.item,
                                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Link, {
                                    prefetch: false,
                                    href: (ref = subMenuItem.cta) === null || ref === void 0 ? void 0 : ref.url,
                                    newTab: (ref1 = subMenuItem.cta) === null || ref1 === void 0 ? void 0 : ref1.newTab,
                                    sx: theme.link,
                                    children: subMenuItem === null || subMenuItem === void 0 ? void 0 : (ref2 = subMenuItem.cta) === null || ref2 === void 0 ? void 0 : ref2.text
                                })
                            }, index);
                        })
                    })
                ]
            }, index);
        }))
    });
});
DesktopMenu.displayName = "DesktopMenu";

;// CONCATENATED MODULE: ./src/snippets/Footer/Desktop/index.js


;// CONCATENATED MODULE: ./src/snippets/Footer/Mobile/MobileMenu.theme.js

var MobileMenu_theme_themed = (0,create/* create */.U)(new function() {
    this.grid = {
        gridArea: "menu",
        display: [
            "grid",
            "none"
        ],
        width: "100%",
        gridTemplateColumns: "1fr",
        gridTemplateRows: "auto",
        gridGap: 0
    };
    this.accordion = {
        width: "100%",
        height: "auto",
        overflow: "hidden",
        transition: "max-height .5s ease-in-out",
        position: "relative",
        borderBottom: "1px solid",
        borderColor: "mediumDarkGray"
    };
    this.header = {
        px: [
            8,
            0
        ]
    };
    this.body = {
        px: [
            8,
            0
        ]
    };
    this.item = {
        display: "block",
        variant: "text.base",
        lineHeight: "20px"
    };
    this.link = {
        variant: "text.base",
        width: "fit-content",
        display: "inline",
        pb: 1,
        backgroundImage: "linear-gradient(currentColor, currentColor)",
        backgroundPosition: "0% 100%",
        backgroundRepeat: "no-repeat",
        backgroundSize: "0% 1px",
        transition: "background-size 0.2s ease-in-out",
        ":hover, :focus": {
            backgroundSize: "100% 1px"
        }
    };
}());

;// CONCATENATED MODULE: ./src/snippets/Footer/Mobile/MobileMenu.jsx








var MobileMenu = MobileMenu_theme_themed(function(_param) {
    var theme = _param.theme, inputRef = _param.inputRef, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme",
        "inputRef"
    ]);
    var ref;
    var settings = (0,dist.useSettings)();
    var menu = settings === null || settings === void 0 ? void 0 : (ref = settings.footer) === null || ref === void 0 ? void 0 : ref.menu;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-comp": MobileMenu.displayName
    }, props), {
        sx: theme.grid,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Accordions, {
            textColor: "white",
            borderColor: "mediumDarkGray",
            iconColor: "white",
            minHeight: "52px",
            children: Array.isArray(menu) ? menu.map(function(menuItem, index) {
                /*#__PURE__*/ return (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(Accordion, {
                    children: [
                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Accordion.Header, {
                            sx: theme.header,
                            children: menuItem.name
                        }),
                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Accordion.Body, {
                            sx: theme.body,
                            children: function(param) {
                                var isOpen = param.isOpen;
                                var ref;
                                return (ref = menuItem.subMenuItems) === null || ref === void 0 ? void 0 : ref.map(function(subMenuItem, subIndex) {
                                    var ref, ref1, ref2;
                                    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                                        as: "li",
                                        sx: theme.item,
                                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Link, {
                                            href: (ref = subMenuItem.cta) === null || ref === void 0 ? void 0 : ref.url,
                                            newTab: (ref1 = subMenuItem.cta) === null || ref1 === void 0 ? void 0 : ref1.newTab,
                                            tabIndex: isOpen ? "0" : "-1",
                                            "aria-hidden": isOpen ? "false" : "true",
                                            sx: theme.link,
                                            children: (ref2 = subMenuItem.cta) === null || ref2 === void 0 ? void 0 : ref2.text
                                        })
                                    }, subIndex);
                                });
                            }
                        })
                    ]
                }, index);
            }) : []
        })
    }));
});
MobileMenu.displayName = "MobileMenu";

;// CONCATENATED MODULE: ./src/snippets/Footer/Mobile/index.js


;// CONCATENATED MODULE: ./src/snippets/Footer/Legal/Legal.theme.js

var Legal_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        width: "100%",
        maxWidth: "1220px",
        flexDirection: [
            "column",
            "row-reverse"
        ],
        alignItems: [
            "center",
            "flex-start"
        ],
        justifyContent: [
            "flex-start",
            "flex-end"
        ],
        px: [
            8,
            0
        ]
    };
    this.row = {
        justifyContent: [
            "center",
            "flex-start"
        ],
        flexWrap: "wrap",
        mb: [
            2,
            0
        ],
        flex: 1,
        pl: 0
    };
    this.text = {
        variant: "text.base",
        fontSize: [
            "12px",
            "14px"
        ],
        position: "relative",
        // :before
        before: {
            position: "absolute",
            content: '"|"',
            left: "-9px",
            top: 0,
            variant: "text.base",
            fontSize: [
                "12px",
                "14px"
            ],
            color: "currentColor",
            pointerEvents: "none"
        }
    };
    this.link = {
        textAlign: [
            "center",
            "left"
        ],
        position: "relative",
        whiteSpace: "nowrap",
        display: "inline",
        pb: 1,
        backgroundImage: "linear-gradient(currentColor, currentColor)",
        backgroundPosition: "0% 100%",
        backgroundRepeat: "no-repeat",
        backgroundSize: "0% 1px",
        transition: "background-size 0.2s ease-in-out",
        ":hover, :focus": {
            backgroundSize: "100% 1px"
        }
    };
    this.copyright = {
        variant: "text.base",
        fontSize: [
            "12px",
            "14px"
        ],
        mr: [
            0,
            4
        ]
    };
}());

;// CONCATENATED MODULE: ./src/snippets/Footer/Legal/Legal.jsx







var Legal = Legal_theme_themed(function(param) {
    var theme = param.theme;
    var ref, ref1, ref2;
    var settings = (0,dist.useSettings)();
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
        "data-comp": Legal.displayName,
        sx: theme.wrapper,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                as: "ul",
                sx: theme.row,
                children: settings === null || settings === void 0 ? void 0 : (ref = settings.footer) === null || ref === void 0 ? void 0 : (ref1 = ref.legalLinks) === null || ref1 === void 0 ? void 0 : ref1.map(function(legalLink, index, arr) {
                    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                        as: "li",
                        sx: {
                            ml: index === 0 ? [
                                0,
                                4
                            ] : 4,
                            mr: index === arr.length - 1 ? [
                                0,
                                4
                            ] : 4
                        },
                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Text */.xv, {
                            sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.text), {
                                ":before": (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.text.before), {
                                    display: index === 0 ? [
                                        "none",
                                        "block"
                                    ] : "block"
                                })
                            }),
                            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Link, {
                                href: legalLink.cta.url,
                                newTab: legalLink.cta.newTab,
                                sx: (0,_object_spread/* default */.Z)({}, theme.link),
                                children: legalLink.cta.text
                            })
                        })
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Paragraph */.nv, {
                sx: theme.copyright,
                children: [
                    "Copyright \xa9 ",
                    new Date().getFullYear() > 2010 && new Date().getFullYear(),
                    " ",
                    settings === null || settings === void 0 ? void 0 : (ref2 = settings.footer) === null || ref2 === void 0 ? void 0 : ref2.copyrightNotice
                ]
            })
        ]
    });
});
Legal.displayName = "Legal";

;// CONCATENATED MODULE: ./src/snippets/Footer/Legal/index.js


;// CONCATENATED MODULE: ./src/snippets/Footer/EmailSignup/EmailSignup.theme.js

var EmailSignup_EmailSignup_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        gridArea: "email",
        width: [
            "100%",
            "300px"
        ],
        py: [
            12,
            0
        ],
        px: [
            8,
            0
        ],
        "@media only screen and (min-width: 1024px) and (max-width: 1060px)": {
            width: "210px"
        },
        "@media only screen and (min-width: 1061px) and (max-width: 1140px)": {
            width: "250px"
        }
    };
    this.header = {
        mb: [
            8,
            11
        ]
    };
    this.heading = {
        variant: "text.label.1"
    };
    this.subtext = {
        variant: "text.base",
        mt: 8
    };
    this.input = {
        width: "100%"
    };
}());

;// CONCATENATED MODULE: ./src/snippets/Footer/EmailSignup/EmailSignup.jsx





var EmailSignup_EmailSignup = EmailSignup_EmailSignup_theme_themed(function(param) {
    var theme = param.theme;
    var ref;
    var settings = (0,dist.useSettings)();
    var emailSignup = settings === null || settings === void 0 ? void 0 : (ref = settings.footer) === null || ref === void 0 ? void 0 : ref.emailSignup;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
        "data-comp": EmailSignup_EmailSignup.displayName,
        variant: "flex.column.start.start",
        sx: theme.wrapper,
        children: [
            (emailSignup === null || emailSignup === void 0 ? void 0 : emailSignup.heading) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                sx: theme.header,
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                        as: "h3",
                        sx: theme.heading,
                        children: emailSignup.heading
                    }),
                    (emailSignup === null || emailSignup === void 0 ? void 0 : emailSignup.subtext) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                        sx: theme.subtext,
                        children: emailSignup === null || emailSignup === void 0 ? void 0 : emailSignup.subtext
                    })
                ]
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(EmailSignup, {
                sx: theme.input
            }),
            (emailSignup === null || emailSignup === void 0 ? void 0 : emailSignup.small_text) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Markdown, {
                text: emailSignup.small_text,
                textSx: {
                    variant: "text.base",
                    fontSize: [
                        "13px",
                        "15px"
                    ],
                    lineHeight: "19px"
                }
            })
        ]
    });
});
EmailSignup_EmailSignup.displayName = "EmailSignup";

;// CONCATENATED MODULE: ./src/snippets/Footer/EmailSignup/index.js


;// CONCATENATED MODULE: ./src/snippets/Footer/SocialAndCountrySelect/SocialAndCountrySelect.theme.js

var SocialAndCountrySelect_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        gridArea: "social",
        width: [
            "100%",
            "175px"
        ],
        pb: [
            12,
            0
        ],
        px: [
            8,
            0
        ],
        borderBottomStyle: [
            "solid",
            "none"
        ],
        borderBottomWidth: "1px",
        borderBottomColor: "mediumDarkGray"
    };
    this.logo = {
        width: "175px",
        color: "background",
        mb: 10,
        display: [
            "none",
            "block"
        ]
    };
    this.heading = {
        variant: "text.label.1",
        mb: 8
    };
    this.socialLinks = {
        mb: [
            11,
            "28px"
        ]
    };
}());

;// CONCATENATED MODULE: ./src/snippets/Footer/SocialAndCountrySelect/SocialAndCountrySelect.jsx





var SocialAndCountrySelect = SocialAndCountrySelect_theme_themed(function(param) {
    var theme = param.theme;
    var ref, ref1;
    var settings = (0,dist.useSettings)();
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
        "data-comp": SocialAndCountrySelect.displayName,
        variant: "flex.column.start.start",
        sx: theme.wrapper,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Svg, {
                viewBox: "0 0 1588 375",
                src: "/svgs/brumate-logo.svg#brumate-logo",
                alt: "Brumate logo",
                sx: theme.logo
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                as: "h3",
                sx: theme.heading,
                children: settings === null || settings === void 0 ? void 0 : (ref = settings.footer) === null || ref === void 0 ? void 0 : (ref1 = ref.social) === null || ref1 === void 0 ? void 0 : ref1.heading
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(SocialLinks, {
                sx: theme.socialLinks
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(CountrySelector, {})
        ]
    });
});
SocialAndCountrySelect.displayName = "SocialAndCountrySelect";

;// CONCATENATED MODULE: ./src/snippets/Footer/SocialAndCountrySelect/index.js


;// CONCATENATED MODULE: ./src/snippets/Footer/Benefits/Benefits.theme.js

var Benefits_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        display: "flex",
        justifyContent: "center",
        minHeight: "114px",
        py: 12
    };
    this.grid = {
        variant: "layout.content",
        display: "grid",
        width: "100%",
        gridTemplateColumns: [
            "repeat(2, 1fr)",
            "repeat(4, 1fr)"
        ],
        columnGap: 6,
        rowGap: 10
    };
    this.item = {
        variant: "flex.row.start.center",
        icon: {
            width: [
                "45px",
                "50px"
            ],
            height: [
                "45px",
                "50px"
            ],
            color: "currentColor",
            mr: 8
        },
        label: {
            flex: 1,
            variant: "text.label.1"
        }
    };
}());

;// CONCATENATED MODULE: ./src/snippets/Footer/Benefits/Benefits.jsx







var Benefits = Benefits_theme_themed(function(param) {
    var theme = param.theme;
    var ref, ref1, ref2;
    var settings = (0,dist.useSettings)();
    var benefits = settings === null || settings === void 0 ? void 0 : (ref = settings.footer) === null || ref === void 0 ? void 0 : ref.benefits;
    return (benefits === null || benefits === void 0 ? void 0 : (ref1 = benefits.items) === null || ref1 === void 0 ? void 0 : ref1.length) ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Container */.W2, {
        "data-comp": Benefits.displayName,
        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.wrapper), {
            bg: (benefits === null || benefits === void 0 ? void 0 : benefits.bgColor) || "gray",
            color: (benefits === null || benefits === void 0 ? void 0 : benefits.color) || "text"
        }),
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Container */.W2, {
            sx: theme.grid,
            children: benefits === null || benefits === void 0 ? void 0 : (ref2 = benefits.items) === null || ref2 === void 0 ? void 0 : ref2.map(function(item, index) {
                var ref, ref1;
                /*#__PURE__*/ return (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                    sx: theme.item,
                    children: [
                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Svg, {
                            src: (ref = ICONS[item.icon]) === null || ref === void 0 ? void 0 : ref.src,
                            alt: item.label,
                            viewBox: (ref1 = ICONS[item.icon]) === null || ref1 === void 0 ? void 0 : ref1.viewBox,
                            sx: theme.item.icon
                        }),
                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                            sx: theme.item.label,
                            children: item.label
                        })
                    ]
                }, index);
            })
        })
    }) : null;
});
Benefits.displayName = "FooterIcons";
var ICONS = {
    design: {
        src: "/svgs/noprecache/icons/innovative-design.svg#innovative-design",
        viewBox: "0 0 61.73 91.48"
    },
    warranty: {
        src: "/svgs/noprecache/icons/lifetime-warranty.svg#lifetime-warranty",
        viewBox: "0 0 82.72 95.32"
    },
    service: {
        src: "/svgs/noprecache/icons/customer-service.svg#customer-service",
        viewBox: "0 0 88.81 85.71"
    },
    shipping: {
        src: "/svgs/noprecache/icons/free-shipping.svg#free-shipping",
        viewBox: "0 0 85.48 95.87"
    }
};

;// CONCATENATED MODULE: ./src/snippets/Footer/Benefits/index.js


;// CONCATENATED MODULE: ./src/snippets/Footer/Footer.jsx










var Footer_Footer = Footer_Footer_theme_themed(function(param) {
    var theme = param.theme;
    var isInitialized = (0,webbridge_react_es/* useVariables */.OQ)().isInitialized;
    if (isInitialized) return null;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Container */.W2, {
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Benefits, {}),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Container */.W2, {
                "data-comp": Footer_Footer.displayName,
                as: "footer",
                sx: theme.wrapper,
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Container */.W2, {
                    sx: theme.content,
                    children: [
                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Grid */.rj, {
                            sx: theme.grid,
                            children: [
                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(SocialAndCountrySelect, {}),
                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(DesktopMenu, {}),
                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(MobileMenu, {}),
                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(EmailSignup_EmailSignup, {})
                            ]
                        }),
                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Legal, {})
                    ]
                })
            })
        ]
    });
});
Footer_Footer.displayName = "Footer";

;// CONCATENATED MODULE: ./src/snippets/Footer/index.js




;// CONCATENATED MODULE: ./src/snippets/GiftWithPurchase/GiftWithPurchase.theme.js

var GiftWithPurchase_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = function(numOfGwpItems) {
        return {
            maxWidth: [
                null,
                numOfGwpItems === 1 ? "32em" : "64em"
            ],
            width: [
                "auto",
                "90vw"
            ],
            textAlign: "center"
        };
    };
    this.image = {
        height: "100%"
    };
    this.details = function(numOfGwpItems) {
        return {
            alignSelf: "center",
            px: numOfGwpItems === 1 ? 0 : [
                11,
                null,
                17
            ],
            py: numOfGwpItems === 1 ? 5 : [
                14,
                17
            ],
            width: "100%"
        };
    };
    this.heading = {
        mb: 8
    };
    this.buttonWrapper = {
        mt: [
            11,
            "50px"
        ]
    };
    this.bullets = {
        mt: 11,
        display: [
            "flex",
            "none"
        ],
        justifyContent: "center",
        gap: 9,
        width: "100%",
        height: "8px",
        ".swiper-pagination-bullet": {
            cursor: "pointer",
            bg: "black",
            opacity: 0.2
        },
        ".swiper-pagination-bullet-active": {
            opacity: "1 !important"
        },
        position: "static"
    };
    this.arrowBtn = {
        display: [
            null,
            "none !important"
        ],
        width: "44px",
        height: "44px",
        border: "1px solid #e8e8e8",
        borderRadius: "100%",
        backgroundColor: "white",
        color: "black",
        top: "calc(33.33% - ".concat(22, "px)"),
        ":after": {
            display: "none !important"
        },
        svg: {
            width: "20px"
        }
    };
}());

;// CONCATENATED MODULE: ./src/snippets/GiftWithPurchase/GiftWithPurchaseImage.theme.js

var GiftWithPurchaseImage_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        display: [
            null,
            "grid"
        ],
        gridTemplateColumns: "1fr 1fr",
        maxWidth: [
            null,
            "64em"
        ],
        mx: [
            "-20px",
            null,
            "-32px"
        ],
        my: [
            "-32px",
            null,
            "-48px"
        ],
        width: [
            "auto",
            "90vw"
        ]
    };
    this.image = {
        height: "100%"
    };
    this.details = {
        alignSelf: "center",
        p: [
            11,
            17
        ]
    };
    this.heading = {
        mb: [
            4,
            8
        ]
    };
    this.buttonWrapper = {
        mt: [
            11,
            "50px"
        ]
    };
    this.cancel = {
        ml: 11
    };
}());

;// CONCATENATED MODULE: ./src/snippets/GiftWithPurchase/GiftWithPurchaseImage.jsx





var GiftWithPurchaseImage = GiftWithPurchaseImage_theme_themed(function(param) {
    var theme = param.theme, cartHasGwp = param.cartHasGwp, gwpProducts = param.gwpProducts, handleAddToCart = param.handleAddToCart, imageGroup = param.imageGroup, isLoading = param.isLoading, modalText = param.modalText, openSidebar = param.openSidebar;
    var ref = (0,_object_spread/* default */.Z)({}, modalText), _heading = ref.heading, heading = _heading === void 0 ? "You qualified for a free gift with purchase!" : _heading, _body = ref.body, body = _body === void 0 ? "Code 'TREAT' will be applied at checkout" : _body, _ctaLabel = ref.ctaLabel, ctaLabel = _ctaLabel === void 0 ? "Add to Bag" : _ctaLabel, _ctaSuccessLabel = ref.ctaSuccessLabel, ctaSuccessLabel = _ctaSuccessLabel === void 0 ? "Product Added" : _ctaSuccessLabel, _cancelLabel = ref.cancelLabel, cancelLabel = _cancelLabel === void 0 ? "No Thanks" : _cancelLabel;
    var ref1 = (0,_object_spread/* default */.Z)({}, imageGroup), desktopImage = ref1.desktopImage, mobileImage = ref1.mobileImage;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Container */.W2, {
        "data-comp": GiftWithPurchaseImage.displayName,
        sx: theme.wrapper,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Picture, {
                    sx: theme.image,
                    images: [
                        {
                            src: (mobileImage === null || mobileImage === void 0 ? void 0 : mobileImage.src) || (desktopImage === null || desktopImage === void 0 ? void 0 : desktopImage.src),
                            ratio: 1
                        },
                        {
                            src: desktopImage === null || desktopImage === void 0 ? void 0 : desktopImage.src,
                            ratio: 1
                        }, 
                    ]
                })
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                sx: theme.details,
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                        variant: "text.h2",
                        sx: theme.heading,
                        children: heading
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                        variant: "text.h5",
                        children: body
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                        sx: theme.buttonWrapper,
                        children: [
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(StatefulButton, {
                                started: isLoading,
                                finished: cartHasGwp,
                                success: cartHasGwp,
                                disabled: cartHasGwp,
                                text: {
                                    success: ctaSuccessLabel,
                                    default: ctaLabel
                                },
                                onClick: function() {
                                    var ref, ref1, ref2;
                                    return handleAddToCart(gwpProducts === null || gwpProducts === void 0 ? void 0 : (ref = gwpProducts[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.variants) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.id);
                                },
                                sx: {
                                    backgroundColor: cartHasGwp ? "green" : null,
                                    borderColor: cartHasGwp ? "green" : null
                                }
                            }),
                            cartHasGwp ? null : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                                variant: "buttons.link.1",
                                sx: theme.cancel,
                                onClick: function() {
                                    openSidebar("cart");
                                },
                                children: cancelLabel
                            })
                        ]
                    })
                ]
            })
        ]
    });
});
GiftWithPurchaseImage.displayName = "GiftWithPurchaseImage";

// EXTERNAL MODULE: ../node_modules/swiper/esm/components/pagination/pagination.js
var pagination = __webpack_require__(71403);
// EXTERNAL MODULE: ../node_modules/swiper/esm/components/navigation/navigation.js
var navigation = __webpack_require__(67296);
;// CONCATENATED MODULE: ./src/snippets/GiftWithPurchase/GiftwithPurchaseItem.jsx





function GiftWithPurchaseItem(param) {
    var product = param.product, gwpSettings = param.gwpSettings, isLoading = param.isLoading, cartHasGwp = param.cartHasGwp, ctaLabel = param.ctaLabel, ctaSuccessLabel = param.ctaSuccessLabel, handleAddToCart = param.handleAddToCart;
    var ref;
    var gwpVariantId = (ref = product.variants[0]) === null || ref === void 0 ? void 0 : ref.storefrontId;
    var cartItems = (0,dist.useCartItems)();
    var isAddedToCart = cartItems.some(function(item) {
        return item.variant.id === gwpVariantId;
    });
    var firstImage = (0,react.useMemo)(function() {
        var ref, ref1;
        return (ref1 = (ref = product.media) === null || ref === void 0 ? void 0 : ref.find(function(item) {
            return item.mediaContentType === "IMAGE";
        })) === null || ref1 === void 0 ? void 0 : ref1.image;
    }, [
        product.id
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
        sx: {
            width: "100%"
        },
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Picture, {
                alt: product.title,
                images: [
                    {
                        src: firstImage === null || firstImage === void 0 ? void 0 : firstImage.src,
                        ratio: 1,
                        width: 240
                    }, 
                ],
                imageBgColor: "lightGray",
                sx: {
                    width: "100%"
                }
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                variant: "text.h3",
                sx: {
                    mt: 8,
                    fontSize: [
                        "24px",
                        "24px",
                        "30px"
                    ]
                },
                children: (gwpSettings === null || gwpSettings === void 0 ? void 0 : gwpSettings.heading) || product.title
            }),
            (gwpSettings === null || gwpSettings === void 0 ? void 0 : gwpSettings.copy) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                variant: "text.h5",
                sx: {
                    mt: 4,
                    fontWeight: 400
                },
                children: gwpSettings === null || gwpSettings === void 0 ? void 0 : gwpSettings.copy
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                sx: {
                    mt: 8
                },
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(StatefulButton, {
                    started: isLoading,
                    finished: isAddedToCart,
                    success: isAddedToCart,
                    disabled: isLoading || isAddedToCart || cartHasGwp,
                    text: {
                        success: ctaSuccessLabel,
                        default: ctaLabel
                    },
                    onClick: function() {
                        return handleAddToCart(gwpVariantId);
                    },
                    sx: {
                        backgroundColor: isAddedToCart ? "green" : null,
                        borderColor: isAddedToCart ? "green" : null,
                        minWidth: "160px",
                        fontSize: "15px",
                        mx: "auto"
                    }
                })
            })
        ]
    });
}
GiftWithPurchaseItem.displayName = "GiftWithPurchaseItem";

;// CONCATENATED MODULE: ./src/snippets/GiftWithPurchase/GiftWithPurchaseSlider.jsx









var GiftWithPurchaseSlider = GiftWithPurchase_theme_themed(function(param) {
    var theme = param.theme, cartHasGwp = param.cartHasGwp, gwpProducts = param.gwpProducts, handleAddToCart = param.handleAddToCart, isLoading = param.isLoading, modalText = param.modalText, openSidebar = param.openSidebar;
    var ref = (0,_object_spread/* default */.Z)({}, modalText), _heading = ref.heading, heading = _heading === void 0 ? "You qualified for a free gift with purchase!" : _heading, _body = ref.body, body = _body === void 0 ? "Code 'TREAT' will be applied at checkout" : _body, _ctaLabel = ref.ctaLabel, ctaLabel = _ctaLabel === void 0 ? "Add to Bag" : _ctaLabel, _ctaSuccessLabel = ref.ctaSuccessLabel, ctaSuccessLabel = _ctaSuccessLabel === void 0 ? "Product Added" : _ctaSuccessLabel, _cancelLabel = ref.cancelLabel, cancelLabel = _cancelLabel === void 0 ? "No Thanks" : _cancelLabel;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Container */.W2, {
        "data-comp": GiftWithPurchaseSlider.displayName,
        sx: theme.wrapper(gwpProducts === null || gwpProducts === void 0 ? void 0 : gwpProducts.length),
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
            sx: theme.details(gwpProducts === null || gwpProducts === void 0 ? void 0 : gwpProducts.length),
            children: [
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                    variant: "text.h2",
                    sx: theme.heading,
                    children: heading
                }),
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                    variant: "text.h5",
                    children: body
                }),
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(react_swiper/* Swiper */.t, {
                        slidesPerView: 1,
                        spaceBetween: 24,
                        grabCursor: true,
                        loop: (gwpProducts === null || gwpProducts === void 0 ? void 0 : gwpProducts.length) >= 2,
                        modules: [
                            pagination/* default */.Z,
                            navigation/* default */.Z
                        ],
                        pagination: {
                            el: ".swiper-pagination",
                            type: "bullets",
                            clickable: true
                        },
                        navigation: {
                            nextEl: ".swiper-button-next",
                            prevEl: ".swiper-button-prev",
                            disabledClass: "cursor-not-allowed opacity-20"
                        },
                        breakpoints: {
                            768: {
                                enabled: false,
                                slidesPerView: (gwpProducts === null || gwpProducts === void 0 ? void 0 : gwpProducts.length) < 3 ? gwpProducts.length : 3,
                                spaceBetween: 24
                            },
                            1024: {
                                enabled: false,
                                slidesPerView: (gwpProducts === null || gwpProducts === void 0 ? void 0 : gwpProducts.length) < 3 ? gwpProducts.length : 3,
                                spaceBetween: 48
                            }
                        },
                        sx: {
                            my: [
                                11,
                                12
                            ],
                            px: "24px",
                            maxWidth: [
                                "100%",
                                (gwpProducts === null || gwpProducts === void 0 ? void 0 : gwpProducts.length) >= 2 ? "600px" : "300px", 
                            ]
                        },
                        children: [
                            gwpProducts.map(function(product, index) {
                                var gwpSettings = product.gwpSettings;
                                return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(swiper_slide/* SwiperSlide */.o, {
                                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(GiftWithPurchaseItem, {
                                        product: product,
                                        gwpSettings: gwpSettings,
                                        isLoading: isLoading,
                                        cartHasGwp: cartHasGwp,
                                        ctaLabel: ctaLabel,
                                        ctaSuccessLabel: ctaSuccessLabel,
                                        handleAddToCart: handleAddToCart
                                    })
                                }, index);
                            }),
                            (gwpProducts === null || gwpProducts === void 0 ? void 0 : gwpProducts.length) > 1 && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_jsx_runtime_esm/* Fragment */.HY, {
                                children: [
                                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                                        className: "swiper-pagination",
                                        sx: theme.bullets
                                    }),
                                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                                        className: "swiper-button-prev",
                                        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.arrowBtn), {
                                            left: 0
                                        }),
                                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Svg, {
                                            viewBox: "0 0 24 24",
                                            alt: "Arrow Left",
                                            src: "/svgs/arrow-left.svg#arrow-left"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                                        className: "swiper-button-next",
                                        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.arrowBtn), {
                                            right: 0
                                        }),
                                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Svg, {
                                            viewBox: "0 0 24 24",
                                            alt: "Arrow Right",
                                            src: "/svgs/arrow-right.svg#arrow-right"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }),
                cartHasGwp ? null : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                    variant: "buttons.link.1",
                    sx: theme.cancel,
                    onClick: function() {
                        openSidebar("cart");
                    },
                    children: cancelLabel
                })
            ]
        })
    });
});
GiftWithPurchaseSlider.displayName = "GiftWithPurchaseSlider";

;// CONCATENATED MODULE: ./src/snippets/GiftWithPurchase/GiftWithPurchase.jsx













var GiftWithPurchase = GiftWithPurchase_theme_themed(function(param) {
    var theme = param.theme;
    var gwpProducts = (0,store/* useRecoilValue */.sJ)(store/* default.gwpProducts */.ZP.gwpProducts);
    var cartAddItem = (0,dist.useCartAddItem)().cartAddItem;
    var cartAddDiscount = (0,dist.useCartAddDiscount)().cartAddDiscount;
    var cartItems = (0,dist.useCartItems)();
    var ref = (0,react.useState)(false), isLoading = ref[0], setIsLoading = ref[1];
    var ref1 = (0,react.useState)(cartItems === null || cartItems === void 0 ? void 0 : cartItems.some(function(item) {
        return gwpProducts === null || gwpProducts === void 0 ? void 0 : gwpProducts.some(function(product) {
            var ref, ref1, ref2;
            return (0,utils/* decodedId */.uP)(product === null || product === void 0 ? void 0 : (ref = product.variants) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.storefrontId) === (0,utils/* decodedId */.uP)((ref2 = item.variant) === null || ref2 === void 0 ? void 0 : ref2.id) && parseInt(item.estimatedCost.subtotalAmount.amount, 10) === 0;
        });
    })), cartHasGwp = ref1[0], setCartHasGwp = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useSidebar */.Ap)(), 2), openSidebar = ref2[1].openSidebar;
    var settings = (0,dist.useSettings)();
    var ref3 = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : settings.gwp), code = ref3.code, products = ref3.products, modalText = ref3.modalText;
    var isImageDisplay = (products === null || products === void 0 ? void 0 : products.displayType) === "image";
    var handleAddToCart = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(gwpVariantId) {
            var ref, merchandiseId, cart;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsLoading(true);
                        merchandiseId = gwpVariantId;
                        if (!merchandiseId) {
                            openSidebar("cart");
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            cartAddItem({
                                merchandiseId: merchandiseId,
                                quantity: 1
                            })
                        ];
                    case 1:
                        cart = _state.sent();
                        setIsLoading(false);
                        if (!(code && !(cart === null || cart === void 0 ? void 0 : (ref = cart.discountCodes) === null || ref === void 0 ? void 0 : ref.some(function(discountCode) {
                            return discountCode.code === code;
                        })))) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            cartAddDiscount({
                                discountCode: code
                            })
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        if (cart) {
                            setCartHasGwp(true);
                            setTimeout(function() {
                                openSidebar("cart");
                            }, 2000);
                        } else {
                            openSidebar("cart");
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleAddToCart(gwpVariantId) {
            return _ref.apply(this, arguments);
        };
    }();
    return isImageDisplay ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(GiftWithPurchaseImage, {
        cartHasGwp: cartHasGwp,
        gwpProducts: gwpProducts,
        handleAddToCart: handleAddToCart,
        isLoading: isLoading,
        modalText: modalText,
        openSidebar: openSidebar,
        imageGroup: products === null || products === void 0 ? void 0 : products.imageGroup
    }) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(GiftWithPurchaseSlider, {
        cartHasGwp: cartHasGwp,
        gwpProducts: gwpProducts,
        handleAddToCart: handleAddToCart,
        isLoading: isLoading,
        modalText: modalText,
        openSidebar: openSidebar
    });
});
GiftWithPurchase.displayName = "GiftWithPurchase";

;// CONCATENATED MODULE: ./src/snippets/GiftWithPurchase/index.js


// EXTERNAL MODULE: ../node_modules/swiper/esm/components/core/core-class.js + 66 modules
var core_class = __webpack_require__(77796);
// EXTERNAL MODULE: ../node_modules/swiper/esm/components/effect-fade/effect-fade.js
var effect_fade = __webpack_require__(77803);
// EXTERNAL MODULE: ../node_modules/ssr-window/ssr-window.esm.js
var ssr_window_esm = __webpack_require__(95469);
// EXTERNAL MODULE: ../node_modules/swiper/esm/utils/utils.js
var utils_utils = __webpack_require__(89617);
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/autoplay/autoplay.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* eslint no-underscore-dangle: "off" */


var Autoplay = {
  run: function run() {
    var swiper = this;
    var $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
    var delay = swiper.params.autoplay.delay;

    if ($activeSlideEl.attr('data-swiper-autoplay')) {
      delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
    }

    clearTimeout(swiper.autoplay.timeout);
    swiper.autoplay.timeout = (0,utils_utils/* nextTick */.Y3)(function () {
      var autoplayResult;

      if (swiper.params.autoplay.reverseDirection) {
        if (swiper.params.loop) {
          swiper.loopFix();
          autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else if (!swiper.isBeginning) {
          autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else if (!swiper.params.autoplay.stopOnLastSlide) {
          autoplayResult = swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else {
          swiper.autoplay.stop();
        }
      } else if (swiper.params.loop) {
        swiper.loopFix();
        autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
        swiper.emit('autoplay');
      } else if (!swiper.isEnd) {
        autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
        swiper.emit('autoplay');
      } else if (!swiper.params.autoplay.stopOnLastSlide) {
        autoplayResult = swiper.slideTo(0, swiper.params.speed, true, true);
        swiper.emit('autoplay');
      } else {
        swiper.autoplay.stop();
      }

      if (swiper.params.cssMode && swiper.autoplay.running) swiper.autoplay.run();else if (autoplayResult === false) {
        swiper.autoplay.run();
      }
    }, delay);
  },
  start: function start() {
    var swiper = this;
    if (typeof swiper.autoplay.timeout !== 'undefined') return false;
    if (swiper.autoplay.running) return false;
    swiper.autoplay.running = true;
    swiper.emit('autoplayStart');
    swiper.autoplay.run();
    return true;
  },
  stop: function stop() {
    var swiper = this;
    if (!swiper.autoplay.running) return false;
    if (typeof swiper.autoplay.timeout === 'undefined') return false;

    if (swiper.autoplay.timeout) {
      clearTimeout(swiper.autoplay.timeout);
      swiper.autoplay.timeout = undefined;
    }

    swiper.autoplay.running = false;
    swiper.emit('autoplayStop');
    return true;
  },
  pause: function pause(speed) {
    var swiper = this;
    if (!swiper.autoplay.running) return;
    if (swiper.autoplay.paused) return;
    if (swiper.autoplay.timeout) clearTimeout(swiper.autoplay.timeout);
    swiper.autoplay.paused = true;

    if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
      swiper.autoplay.paused = false;
      swiper.autoplay.run();
    } else {
      ['transitionend', 'webkitTransitionEnd'].forEach(function (event) {
        swiper.$wrapperEl[0].addEventListener(event, swiper.autoplay.onTransitionEnd);
      });
    }
  },
  onVisibilityChange: function onVisibilityChange() {
    var swiper = this;
    var document = (0,ssr_window_esm/* getDocument */.Me)();

    if (document.visibilityState === 'hidden' && swiper.autoplay.running) {
      swiper.autoplay.pause();
    }

    if (document.visibilityState === 'visible' && swiper.autoplay.paused) {
      swiper.autoplay.run();
      swiper.autoplay.paused = false;
    }
  },
  onTransitionEnd: function onTransitionEnd(e) {
    var swiper = this;
    if (!swiper || swiper.destroyed || !swiper.$wrapperEl) return;
    if (e.target !== swiper.$wrapperEl[0]) return;
    ['transitionend', 'webkitTransitionEnd'].forEach(function (event) {
      swiper.$wrapperEl[0].removeEventListener(event, swiper.autoplay.onTransitionEnd);
    });
    swiper.autoplay.paused = false;

    if (!swiper.autoplay.running) {
      swiper.autoplay.stop();
    } else {
      swiper.autoplay.run();
    }
  },
  onMouseEnter: function onMouseEnter() {
    var swiper = this;

    if (swiper.params.autoplay.disableOnInteraction) {
      swiper.autoplay.stop();
    } else {
      swiper.autoplay.pause();
    }

    ['transitionend', 'webkitTransitionEnd'].forEach(function (event) {
      swiper.$wrapperEl[0].removeEventListener(event, swiper.autoplay.onTransitionEnd);
    });
  },
  onMouseLeave: function onMouseLeave() {
    var swiper = this;

    if (swiper.params.autoplay.disableOnInteraction) {
      return;
    }

    swiper.autoplay.paused = false;
    swiper.autoplay.run();
  },
  attachMouseEvents: function attachMouseEvents() {
    var swiper = this;

    if (swiper.params.autoplay.pauseOnMouseEnter) {
      swiper.$el.on('mouseenter', swiper.autoplay.onMouseEnter);
      swiper.$el.on('mouseleave', swiper.autoplay.onMouseLeave);
    }
  },
  detachMouseEvents: function detachMouseEvents() {
    var swiper = this;
    swiper.$el.off('mouseenter', swiper.autoplay.onMouseEnter);
    swiper.$el.off('mouseleave', swiper.autoplay.onMouseLeave);
  }
};
/* harmony default export */ var autoplay = ({
  name: 'autoplay',
  params: {
    autoplay: {
      enabled: false,
      delay: 3000,
      waitForTransition: true,
      disableOnInteraction: true,
      stopOnLastSlide: false,
      reverseDirection: false,
      pauseOnMouseEnter: false
    }
  },
  create: function create() {
    var swiper = this;
    (0,utils_utils/* bindModuleMethods */.cR)(swiper, {
      autoplay: _extends({}, Autoplay, {
        running: false,
        paused: false
      })
    });
  },
  on: {
    init: function init(swiper) {
      if (swiper.params.autoplay.enabled) {
        swiper.autoplay.start();
        var document = (0,ssr_window_esm/* getDocument */.Me)();
        document.addEventListener('visibilitychange', swiper.autoplay.onVisibilityChange);
        swiper.autoplay.attachMouseEvents();
      }
    },
    beforeTransitionStart: function beforeTransitionStart(swiper, speed, internal) {
      if (swiper.autoplay.running) {
        if (internal || !swiper.params.autoplay.disableOnInteraction) {
          swiper.autoplay.pause(speed);
        } else {
          swiper.autoplay.stop();
        }
      }
    },
    sliderFirstMove: function sliderFirstMove(swiper) {
      if (swiper.autoplay.running) {
        if (swiper.params.autoplay.disableOnInteraction) {
          swiper.autoplay.stop();
        } else {
          swiper.autoplay.pause();
        }
      }
    },
    touchEnd: function touchEnd(swiper) {
      if (swiper.params.cssMode && swiper.autoplay.paused && !swiper.params.autoplay.disableOnInteraction) {
        swiper.autoplay.run();
      }
    },
    destroy: function destroy(swiper) {
      swiper.autoplay.detachMouseEvents();

      if (swiper.autoplay.running) {
        swiper.autoplay.stop();
      }

      var document = (0,ssr_window_esm/* getDocument */.Me)();
      document.removeEventListener('visibilitychange', swiper.autoplay.onVisibilityChange);
    }
  }
});
;// CONCATENATED MODULE: ./src/snippets/Header/AccessibilityBar/AccessibilityBar.theme.js

var AccessibilityBar_theme_themed = (0,create/* create */.U)(new function() {
    this.bar = {
        bg: "gray",
        justifyContent: "flex-end",
        alignItems: "center",
        height: "40px",
        pl: [
            8,
            10,
            11,
            12
        ],
        pr: [
            0,
            2,
            4,
            8
        ]
    };
    this.link = {
        fontColor: "text",
        px: 8,
        fontSize: 3,
        textDecoration: "underline",
        textDecorationThickness: "1px",
        textUnderlineOffset: "2px",
        lineHeight: "36px",
        outlineColor: "#0000FF",
        textAlign: "right"
    };
}());

;// CONCATENATED MODULE: ./src/snippets/Header/AccessibilityBar/AccessibilityBar.jsx
/* eslint-disable jsx-a11y/anchor-is-valid */ 







var AccessibilityBar = AccessibilityBar_theme_themed(function(param) {
    var theme = param.theme;
    var ref = (0,react.useState)(false), mounted = ref[0], setMounted = ref[1];
    var ref1 = (0,react.useState)(false), injected = ref1[0], setInjected = ref1[1];
    var ref2 = (0,react.useState)(false), enabled = ref2[0], setEnabled = ref2[1];
    var cookies = utils/* isBrowser */.jU && document.cookie;
    var enableUsableNetAssistiveFn = utils/* isBrowser */.jU && window.enableUsableNetAssistive;
    var usableNetReady = typeof enableUsableNetAssistiveFn === "function";
    var enableUsableNetAssistive = (0,react.useCallback)(function() {
        try {
            if (typeof window.enableUsableNetAssistive === "function") {
                window.enableUsableNetAssistive();
            } else {
                console.error("UsableNet script is not injected");
            }
        } catch (error) {
            console.error(error.message);
        }
    }, []);
    var disableUsableNetAssistive = (0,react.useCallback)(function() {
        document.cookie = "UsableNetAssistive=";
    }, []);
    var injectScriptOnMount = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var script;
        return (0,tslib_es6.__generator)(this, function(_state) {
            try {
                if (!mounted || injected || usableNetReady) return [
                    2
                ];
                script = document.createElement("script");
                script.id = "fueled-usable-script";
                script.setAttribute("id", "fueled-usable-script");
                script.src = "https://a40.usablenet.com/pt/c/brumate/cookiestorestart";
                script.async = true;
                document.head.appendChild(script);
                setInjected(true);
            } catch (error) {
                console.error(error.message);
            }
            return [
                2
            ];
        });
    }), [
        injected,
        mounted,
        usableNetReady
    ]);
    var setEnabledOnCookieChange = (0,react.useCallback)(function() {
        setEnabled(usableNetReady && (cookies === null || cookies === void 0 ? void 0 : cookies.indexOf("UsableNetAssistive=1")) > -1);
    }, [
        cookies,
        usableNetReady
    ]);
    // Set mounted on window load
    (0,react.useEffect)(function() {
        var onLoad = function() {
            return setMounted(true);
        };
        window.addEventListener("load", function() {
            onLoad();
            window.removeEventListener("load", onLoad);
        });
        return function() {
            window.removeEventListener("load", onLoad);
        };
    }, []);
    (0,react.useEffect)(function() {
        injectScriptOnMount();
    }, [
        mounted
    ]);
    (0,react.useEffect)(function() {
        setEnabledOnCookieChange();
    }, [
        cookies,
        usableNetReady
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
        "data-comp": AccessibilityBar.displayName,
        sx: theme.bar,
        children: usableNetReady && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Link, {
            href: "#",
            className: "UsableNetAssistive",
            sx: theme.link,
            onClick: enabled ? disableUsableNetAssistive : enableUsableNetAssistive,
            children: enabled ? "Exit Accessibility Mode" : "Enable Accessibility"
        })
    });
});
AccessibilityBar.displayName = "AccessibilityBar";

;// CONCATENATED MODULE: ./src/snippets/Header/AccessibilityBar/index.js


;// CONCATENATED MODULE: ./src/snippets/Header/PromoBar/Navigation/Navigation.theme.js



var Navigation_theme_themed = (0,create/* create */.U)(new function() {
    this.buttonPrev = {
        position: "absolute",
        top: "50%",
        transform: "translateY(-50%)",
        zIndex: 1,
        left: 8,
        right: "auto",
        transition: "opacity 0.2s ease-in-out",
        width: "20px",
        height: "20px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    };
    this.buttonNext = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this.buttonPrev), {
        left: "auto",
        right: 8
    });
    this.icon = {
        width: "20px",
        userSelect: "none",
        color: "white"
    };
}());

;// CONCATENATED MODULE: ./src/snippets/Header/PromoBar/Navigation/NavigationButton.jsx







var NavigationButton = Navigation_theme_themed(function(_param) {
    var theme = _param.theme, _src = _param.src, src = _src === void 0 ? "/svgs/chevron/left.svg#left" : _src, _alt = _param.alt, alt = _alt === void 0 ? "Previous product" : _alt, _isNext = _param.isNext, isNext = _isNext === void 0 ? false : _isNext, inputRef = _param.inputRef, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme",
        "src",
        "alt",
        "isNext",
        "inputRef"
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-comp": NavigationButton.displayName
    }, props), {
        variant: "buttons.plain",
        sx: (0,_object_spread/* default */.Z)({}, isNext ? theme.buttonNext : theme.buttonPrev, props.sx),
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Svg, {
            alt: alt,
            src: src,
            viewBox: "0 0 16 16",
            draggable: false,
            sx: theme.icon
        })
    }));
});
NavigationButton.displayName = "NavigationButton";

;// CONCATENATED MODULE: ./src/snippets/Header/PromoBar/Navigation/Navigation.jsx



var Navigation = Navigation_theme_themed(function(param) {
    var theme = param.theme, swiper = param.swiper;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_jsx_runtime_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(NavigationButton, {
                onClick: function() {
                    return swiper.slidePrev();
                }
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(NavigationButton, {
                onClick: function() {
                    return swiper.slideNext();
                },
                src: "/svgs/chevron/right.svg#right",
                alt: "Next product",
                isNext: true
            })
        ]
    });
});
Navigation.displayName = "Navigation";

;// CONCATENATED MODULE: ./src/snippets/Header/PromoBar/Navigation/index.js


;// CONCATENATED MODULE: ./src/snippets/HalfMedia/Video/Video.jsx





var defaultTransSx = {
    transition: "all 0.3s ease-in-out",
    transform: "translate(-50%, -50%) scale(1.1)",
    opacity: 0
};
function Video(param) {
    var video = param.video;
    var ref = (0,react.useRef)();
    var videoRef = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(false), paused = ref1[0], setPaused = ref1[1];
    var ref2 = (0,react.useState)(defaultTransSx), transitionSx = ref2[0], setTransitionSx = ref2[1];
    var showHideButton = function() {
        setTransitionSx({
            opacity: 0.5,
            transform: "translate(-50%, -50%) scale(1.01)",
            transition: "none"
        });
        setTimeout(function() {
            setTransitionSx(defaultTransSx);
        }, 0);
    };
    var handleVideoClick = function() {
        if (paused) {
            videoRef.current.play();
            setPaused(false);
            showHideButton();
        } else {
            videoRef.current.pause();
            setPaused(true);
            showHideButton();
        }
    };
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": Video.displayName,
        ref: ref,
        sx: {
            display: "block",
            position: "relative",
            width: "100%",
            height: "100%",
            overflow: "hidden"
        },
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                as: "video",
                ref: videoRef,
                muted: true,
                playsInline: true,
                loop: true,
                autoPlay: true,
                poster: video === null || video === void 0 ? void 0 : video.poster,
                sx: {
                    position: "absolute",
                    height: "101%",
                    width: "101%",
                    objectFit: "fit",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)"
                },
                onClick: handleVideoClick,
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("source", {
                    src: video === null || video === void 0 ? void 0 : video.src,
                    type: "video/mp4"
                }, video === null || video === void 0 ? void 0 : video.src)
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                variant: "flex.row.center.center",
                sx: (0,_object_spread/* default */.Z)({
                    position: "absolute",
                    width: "100px",
                    height: "100px",
                    left: "50%",
                    top: "50%",
                    borderRadius: "50%",
                    bg: "black"
                }, transitionSx),
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Svg, {
                    src: !paused ? "/svgs/noprecache/svg/play.svg#play-icon" : "/svgs/noprecache/svg/pause.svg#pause-icon",
                    alt: !paused ? "Play Video" : "Pause Video",
                    viewBox: !paused ? "0 0 29 32" : "0 0 512 512",
                    sx: {
                        color: "white",
                        mr: !paused ? "-4px" : 0,
                        width: !paused ? "40px" : "50px"
                    }
                })
            })
        ]
    });
}
Video.displayName = "Video";

;// CONCATENATED MODULE: ./src/snippets/HalfMedia/Video/index.js


;// CONCATENATED MODULE: ./src/snippets/HalfMedia/HalfMedia.theme.js

var HalfMedia_theme_themed = (0,create/* create */.U)(new function() {
    this.grid = {
        position: "relative",
        display: "grid",
        gridGap: 0,
        gridTemplateColumns: [
            "1fr",
            "1fr 1fr"
        ]
    };
    this.media = {
        gridArea: "media",
        position: "relative",
        width: "100%",
        height: "100%",
        overflow: "hidden"
    };
    this.content = {
        gridArea: "content",
        display: "flex",
        position: "relative",
        width: "100%",
        height: "100%"
    };
}());

// EXTERNAL MODULE: ./src/utils/common.js
var common = __webpack_require__(57795);
;// CONCATENATED MODULE: ./src/snippets/HalfMedia/Content/Content.theme.js



var Content_Content_theme_themed = (0,create/* create */.U)(new function() {
    this.outer = {
        width: "100%",
        justifyContent: "center",
        alignItems: [
            "flex-start",
            "center"
        ],
        px: 12,
        py: [
            18,
            16
        ],
        "@media only screen and (max-width: 479px)": {
            py: 15
        }
    };
    this.innerLeft = {
        variant: "flex.column",
        width: "100%",
        maxWidth: [
            "600px",
            "450px"
        ],
        alignItems: "flex-start"
    };
    this.innerRight = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this.innerLeft), {
        alignItems: "flex-end"
    });
    this.innerCenter = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this.innerLeft), {
        alignItems: "center"
    });
    this.superheading = {
        variant: "text.label.1",
        mb: 2
    };
    this.heading = {
        variant: "text.h2"
    };
    this.bodyWithoutHeading = {
        variant: "text.base",
        mt: 0,
        ul: {
            ml: 0
        },
        "p:last-of-type": {
            mb: 0
        }
    };
    this.bodyWithHeading = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this.bodyWithoutHeading), {
        mt: [
            10,
            11
        ]
    });
}());

;// CONCATENATED MODULE: ./src/snippets/HalfMedia/Content/Content.jsx







var Content_Content = Content_Content_theme_themed(function(param) {
    var theme = param.theme, content = param.content;
    var ref, ref1, ref2, ref3;
    var textAlign = [
        content === null || content === void 0 ? void 0 : content.alignment,
        content === null || content === void 0 ? void 0 : content.alignmentDt
    ];
    var flexAlign = textAlign.map(function(align) {
        return (0,common/* convertAlignToFlex */.nG)(align);
    });
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
        "data-comp": Content_Content.displayName,
        sx: theme.outer,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
            sx: {
                variant: "flex.column",
                width: "100%",
                maxWidth: [
                    "600px",
                    "450px"
                ],
                alignItems: flexAlign
            },
            children: [
                (content === null || content === void 0 ? void 0 : content.superheading) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                    as: "h6",
                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.superheading), {
                        textAlign: textAlign
                    }),
                    children: content.superheading
                }),
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.heading), {
                        textAlign: textAlign
                    }),
                    children: content === null || content === void 0 ? void 0 : content.heading
                }),
                (content === null || content === void 0 ? void 0 : content.body) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Markdown, {
                    text: content.body,
                    textSx: {
                        textAlign: textAlign
                    },
                    sx: (0,_object_spread/* default */.Z)({}, (content === null || content === void 0 ? void 0 : content.heading) ? theme.bodyWithHeading : theme.bodyWithoutHeading)
                }),
                (content === null || content === void 0 ? void 0 : (ref = content.cta) === null || ref === void 0 ? void 0 : ref.text) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Link, {
                    variant: "buttons.".concat((content === null || content === void 0 ? void 0 : content.ctaStyle) || "secondary"),
                    href: content === null || content === void 0 ? void 0 : (ref1 = content.cta) === null || ref1 === void 0 ? void 0 : ref1.url,
                    newTab: content === null || content === void 0 ? void 0 : (ref2 = content.cta) === null || ref2 === void 0 ? void 0 : ref2.newTab,
                    sx: {
                        mt: (content === null || content === void 0 ? void 0 : content.heading) || (content === null || content === void 0 ? void 0 : content.body) ? [
                            10,
                            11
                        ] : 0,
                        alignSelf: flexAlign
                    },
                    children: content === null || content === void 0 ? void 0 : (ref3 = content.cta) === null || ref3 === void 0 ? void 0 : ref3.text
                })
            ]
        })
    });
});
Content_Content.displayName = "Content";

;// CONCATENATED MODULE: ./src/snippets/HalfMedia/Content/index.js


;// CONCATENATED MODULE: ./src/snippets/HalfMedia/Image/Image.theme.js

var Image_theme_themed = (0,create/* create */.U)(new function() {
    this.image = {
        position: "absolute",
        width: "100%",
        height: "100%",
        top: 0,
        left: 0,
        bottom: 0,
        right: 0
    };
}());

;// CONCATENATED MODULE: ./src/snippets/HalfMedia/Image/Image.jsx



var Image_Image = Image_theme_themed(function(param) {
    var theme = param.theme, image = param.image;
    var ref, ref1, ref2, ref3;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Picture, {
        "data-comp": Image_Image.displayName,
        alt: image === null || image === void 0 ? void 0 : image.alt,
        images: [
            {
                src: image === null || image === void 0 ? void 0 : (ref = image.image) === null || ref === void 0 ? void 0 : ref.src,
                width: 768,
                ratio: 1
            },
            {
                src: image === null || image === void 0 ? void 0 : (ref1 = image.imageDt) === null || ref1 === void 0 ? void 0 : ref1.src,
                width: 512,
                ratio: 1
            },
            {
                src: image === null || image === void 0 ? void 0 : (ref2 = image.imageDt) === null || ref2 === void 0 ? void 0 : ref2.src,
                width: 640,
                ratio: 1
            },
            {
                src: image === null || image === void 0 ? void 0 : (ref3 = image.imageDt) === null || ref3 === void 0 ? void 0 : ref3.src,
                width: 720,
                ratio: 1
            }, 
        ],
        imageSx: {
            objectPosition: [
                image === null || image === void 0 ? void 0 : image.position,
                image === null || image === void 0 ? void 0 : image.positionDt
            ]
        },
        sx: theme.image
    });
});
Image_Image.displayName = "Image";

;// CONCATENATED MODULE: ./src/snippets/HalfMedia/Image/index.js


;// CONCATENATED MODULE: ./src/snippets/HalfMedia/HalfMedia.jsx











var HalfMedia = HalfMedia_theme_themed(function(param) {
    var theme = param.theme, passedId = param.passedId;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    if (!passedId) return null;
    var settings = (0,dist.useSettings)();
    var modalArray = settings === null || settings === void 0 ? void 0 : (ref = settings.markdownmodal) === null || ref === void 0 ? void 0 : ref.modals.length;
    var modalId = modalArray ? settings === null || settings === void 0 ? void 0 : (ref1 = settings.markdownmodal) === null || ref1 === void 0 ? void 0 : ref1.modals.find(function(element) {
        return parseInt(element.id, 10) === parseInt(passedId, 10);
    }) : null;
    var modalSettings = (0,react.useMemo)(function() {
        return (0,_object_spread/* default */.Z)({}, modalId);
    }, [
        modalId
    ]);
    var showMedia = modalSettings === null || modalSettings === void 0 ? void 0 : modalSettings.showMedia;
    var mediaLeft = (modalSettings === null || modalSettings === void 0 ? void 0 : (ref2 = modalSettings.media) === null || ref2 === void 0 ? void 0 : ref2.locationDt) === "left"; // mobile
    var mediaTop = (modalSettings === null || modalSettings === void 0 ? void 0 : (ref3 = modalSettings.media) === null || ref3 === void 0 ? void 0 : ref3.location) === "top"; // desktop
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Section, {
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Container */.W2, {
            "data-comp": HalfMedia.displayName,
            sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.grid), {
                gridTemplateAreas: showMedia ? [
                    mediaTop ? '"media" "content"' : '"content" "media"',
                    mediaLeft ? '"media content"' : '"content media"', 
                ] : null
            }),
            children: [
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.media), {
                        ":before": {
                            content: '""',
                            float: "left",
                            pb: [
                                (modalSettings === null || modalSettings === void 0 ? void 0 : (ref4 = modalSettings.media) === null || ref4 === void 0 ? void 0 : ref4.ratio) || "100%",
                                0
                            ]
                        }
                    }),
                    children: showMedia ? (modalSettings === null || modalSettings === void 0 ? void 0 : (ref5 = modalSettings.video) === null || ref5 === void 0 ? void 0 : ref5.enabled) ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Video, {
                        video: modalSettings === null || modalSettings === void 0 ? void 0 : modalSettings.video
                    }) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Image_Image, {
                        image: modalSettings === null || modalSettings === void 0 ? void 0 : modalSettings.image
                    }) : null
                }),
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.content), {
                        justifyContent: mediaLeft ? "flex-start" : "flex-end",
                        ":before": {
                            content: '""',
                            float: "left",
                            pb: [
                                0,
                                (modalSettings === null || modalSettings === void 0 ? void 0 : (ref6 = modalSettings.media) === null || ref6 === void 0 ? void 0 : ref6.ratioDt) || "100%"
                            ]
                        }
                    }),
                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Content_Content, {
                        content: modalSettings === null || modalSettings === void 0 ? void 0 : modalSettings.content
                    })
                })
            ]
        })
    });
});
HalfMedia.DisplayName = "HalfMedia";

;// CONCATENATED MODULE: ./src/snippets/HalfMedia/index.js


;// CONCATENATED MODULE: ./src/snippets/Header/PromoBar/PromoBar.theme.js

var PromoBar_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        position: "relative",
        zIndex: 31,
        minHeight: "32px",
        transition: "max-height 0.2s ease-in-out"
    };
    this.promobarWrapper = {
        variant: "layout.header",
        minHeight: "32px",
        maxHeight: "70px"
    };
    this.swiperWrapper = {
        alignItems: "center",
        width: "100%",
        ".swiper-wrapper": {
            alignItems: "center"
        },
        ".swiper-container": {
            width: "100% !important"
        }
    };
    this.swiper = {
        width: "100%"
    };
    this.message = {
        variant: "flex.row.center",
        width: "100%",
        link: {
            py: 4,
            px: 11
        },
        text: {
            variant: "text.label.1"
        }
    };
    this.accessibilityBar = {
        bg: "gray",
        variant: "layout.header",
        justifyContent: "flex-end",
        alignItems: "center",
        height: "20px"
    };
    this.accessibilityButton = {
        fontColor: "text",
        fontSize: 1,
        textDecoration: "underline"
    };
}());

;// CONCATENATED MODULE: ./src/snippets/Header/PromoBar/PromoBarMessage.jsx












var textHtmlTags = "p, h1, h2, h3, h4, h5, h6, span, label, div, strong, em, blockquote, pre, code, i, b, ul, ol, li, modal";
var PromoBarMessage = PromoBar_theme_themed(function(param) {
    var theme = param.theme, link = param.link, align = param.align, html = param.html, index = param.index;
    var ref = (0,_sliced_to_array/* default */.Z)((0,hooks/* useModal */.dd)(), 2), modal = ref[0].modal, ref1 = ref[1], openModal = ref1.openModal, closeModal = ref1.closeModal;
    var hasLinkInMarkdown = (0,react.useMemo)(function() {
        return (html === null || html === void 0 ? void 0 : html.includes("<a")) && (html === null || html === void 0 ? void 0 : html.includes("</a>"));
    }, [
        html
    ]);
    var toggleModal = (0,react.useCallback)(function(id) {
        if (modal) {
            closeModal();
        }
        openModal(/*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(HalfMedia, {
            passedId: id
        }));
    }, [
        modal,
        HalfMedia
    ]);
    var parsedHtml = (0,react.useMemo)(function() {
        var openModalTagIndex = html === null || html === void 0 ? void 0 : html.indexOf("<modal");
        var closeModalTagIndex = html === null || html === void 0 ? void 0 : html.indexOf("</modal>");
        if (openModalTagIndex >= 0 && closeModalTagIndex >= 0) {
            var ref;
            if (true) {
                window["__brumate_modal_click_".concat(index)] = toggleModal;
            }
            var openModalTagClosingBracketIndex = html === null || html === void 0 ? void 0 : html.indexOf(">", openModalTagIndex);
            var idAttr = (ref = html.slice(openModalTagIndex, openModalTagClosingBracketIndex || 0).match(/id="(.*)"/)) === null || ref === void 0 ? void 0 : ref[0];
            var id = idAttr === null || idAttr === void 0 ? void 0 : idAttr.replace('id="', "").replace('"', "");
            return html.replace("<modal", '<span onClick="window.__brumate_modal_click_'.concat(index, "(").concat(id, ')" class="markdown-modal" ')).replace("</modal>", "</span>");
        }
        return html;
    }, [
        html,
        toggleModal,
        index
    ]);
    var _obj;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
        "data-comp": PromoBarMessage.displayName,
        sx: theme.message,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Link, {
            href: hasLinkInMarkdown ? undefined : link === null || link === void 0 ? void 0 : link.url,
            newTab: link === null || link === void 0 ? void 0 : link.newTab,
            prefetch: false,
            sx: theme.message.link,
            onClick: function(e) {
                if (e.target.className === "markdown-modal") e.preventDefault();
                if (!hasLinkInMarkdown || !(link === null || link === void 0 ? void 0 : link.url)) return;
                next_router.router.push(link.url);
            },
            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                dangerouslySetInnerHTML: {
                    __html: parsedHtml
                },
                sx: (_obj = {}, (0,_define_property/* default */.Z)(_obj, textHtmlTags, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    textAlign: align || "center",
                    mt: 0,
                    "&:last-of-type": {
                        mb: 0
                    }
                }, theme.message.text), {
                    fontWeight: "body !important"
                })), (0,_define_property/* default */.Z)(_obj, "a", {
                    textDecoration: "underline"
                }), (0,_define_property/* default */.Z)(_obj, ".markdown-modal", {
                    textDecoration: "underline",
                    fontFamily: "body",
                    cursor: "pointer",
                    zIndex: 10
                }), _obj)
            })
        })
    });
});
PromoBarMessage.displayName = "PromoBarMessage";

// EXTERNAL MODULE: ../node_modules/react-intersection-observer/dist/index.mjs
var react_intersection_observer_dist = __webpack_require__(38687);
;// CONCATENATED MODULE: ./src/snippets/Header/PromoBar/useSetPromoBarHeightCssVar.js

var useSetPromoBarHeightCssVar = function(inView, entry) {
    var heightVarSet = (0,react.useRef)(false);
    var setPromoBarHeightVar = function() {
        if (heightVarSet.current) return;
        if (!entry) {
            document.documentElement.style.setProperty("--promoBar-height", "0px");
            return;
        }
        if (!inView) return;
        var target = entry.target;
        var promoBarHeightPx = inView ? "".concat(target.getBoundingClientRect().height, "px") : "0px";
        document.documentElement.style.setProperty("--promoBar-height", promoBarHeightPx);
        heightVarSet.current = true;
    };
    (0,react.useEffect)(function() {
        setPromoBarHeightVar();
    }, [
        inView
    ]);
};

;// CONCATENATED MODULE: ./src/snippets/Header/PromoBar/usePromobar.js







var usePromobar = function() {
    var ref, ref1, ref2, ref3, ref4;
    var swiperRef = (0,react.useRef)(false);
    var ref5 = (0,react_intersection_observer_dist/* useInView */.YD)(), promoBarRef = ref5.ref, inView = ref5.inView, entry = ref5.entry;
    var settings = (0,dist.useSettings)();
    var header = (0,_object_spread/* default */.Z)({}, settings).header;
    var promoBar = (0,_object_spread/* default */.Z)({}, header).promoBar;
    var haveMessages = promoBar === null || promoBar === void 0 ? void 0 : (ref = promoBar.messages) === null || ref === void 0 ? void 0 : ref.length;
    var isSingleMessage = haveMessages === 1;
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* default.promobarClosed */.ZP.promobarClosed), 2), promobarClosed = ref6[0], setPromobarClosed = ref6[1]; // closed when clicked X
    var ref7 = (0,react.useState)(), swiper = ref7[0], setSwiper = ref7[1];
    // const [closed, setClosed] = useState(false); // closed when clicked X
    var ref8 = (0,react.useState)(0), activeIndex = ref8[0], setActiveIndex = ref8[1];
    var updateActiveIndex = (0,react.useCallback)(function(swiper) {
        setActiveIndex(swiper.realIndex);
    }, []);
    var animateClose = (0,react.useCallback)(function() {
        setPromobarClosed(true);
    }, []);
    useSetPromoBarHeightCssVar(inView, entry);
    return [
        {
            // refs
            swiperRef: swiperRef,
            promoBarRef: promoBarRef,
            // state
            swiper: swiper,
            isDisabled: !haveMessages || !(promoBar === null || promoBar === void 0 ? void 0 : promoBar.enabled),
            closed: promobarClosed,
            isSingleMessage: isSingleMessage,
            // site settings
            promoBar: promoBar,
            currentColor: (promoBar === null || promoBar === void 0 ? void 0 : (ref1 = promoBar.messages) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[activeIndex]) === null || ref2 === void 0 ? void 0 : ref2.color) || "white",
            bgColor: (promoBar === null || promoBar === void 0 ? void 0 : (ref3 = promoBar.messages) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[activeIndex]) === null || ref4 === void 0 ? void 0 : ref4.background) || "dark"
        },
        {
            animateClose: animateClose,
            updateActiveIndex: updateActiveIndex,
            setSwiper: setSwiper
        }, 
    ];
};

;// CONCATENATED MODULE: ./src/snippets/Header/MenuSidebar/Overlay/Overlay.theme.js



var Overlay_theme_themed = (0,create/* create */.U)(new function() {
    this.closed = {
        display: [
            "block",
            null,
            "none"
        ],
        position: "fixed",
        top: "var(--header-height)",
        left: 0,
        bottom: 0,
        right: 0,
        width: "100%",
        height: "100%",
        bg: "dark",
        opacity: 0,
        pointerEvents: "none",
        transition: "opacity .2s cubic-bezier(0.2, 0.5, 0.2, 1)",
        willChange: "opacity",
        zIndex: "-1",
        "&:hover": {
            cursor: "none"
        }
    };
    this.open = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this.closed), {
        opacity: 0.5,
        pointerEvents: "auto",
        zIndex: 0,
        "&:hover": {
            cursor: "url('/svgs/overlay-close.svg') 0 0, auto"
        }
    });
}());

;// CONCATENATED MODULE: ./src/snippets/Header/MenuSidebar/useMenuSidebar.js



var useMenuSidebar = function() {
    // @refresh reset
    var gotoSnapshot = (0,store/* useGotoRecoilSnapshot */.le)();
    var menuSidebar = (0,store/* useRecoilValue */.sJ)(store/* default.menuSidebar */.ZP.menuSidebar);
    var selectedItem = (0,store/* useRecoilValue */.sJ)(store/* default.selectedItem */.ZP.selectedItem);
    var selectedIndex = (0,store/* useRecoilValue */.sJ)(store/* default.selectedIndex */.ZP.selectedIndex);
    // on click, close the sideBar and navigate to url
    var closeMenuSidebar = (0,store/* useRecoilCallback */._8)(function(param) {
        var snapshot = param.snapshot;
        return /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var release, updatedState;
            return (0,tslib_es6.__generator)(this, function(_state) {
                release = snapshot.retain();
                try {
                    updatedState = snapshot.map(function(param) {
                        var set = param.set;
                        set(store/* default.selectedItem */.ZP.selectedItem, false);
                        set(store/* default.menuSidebar */.ZP.menuSidebar, false);
                        set(store/* default.overlay */.ZP.overlay, false);
                    });
                    // update state
                    gotoSnapshot(updatedState);
                } catch (error) {
                    console.log("closeMenuSidebar", error.message);
                    throw error;
                } finally{
                    release();
                }
                return [
                    2
                ];
            });
        });
    });
    var toggleNestedSidebar = (0,store/* useRecoilCallback */._8)(function(param) {
        var snapshot = param.snapshot;
        return function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(selected) {
                var release, selectors, nextState, isOpening;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    release = snapshot.retain();
                    selectors = {
                        links: "[data-comp='MenuSidebarLinks']",
                        menuSidebar: '[data-comp="MenuSidebar"]',
                        products: "[data-comp='MenuSidebarProductsRow']",
                        subNavItem: "[data-comp='SubNavItem']",
                        searchInput: "[data-comp='MenuSidebarSearchInput']",
                        nestedSidebar: "[data-comp='NestedSidebar']",
                        nestedContent: "[data-comp='NestedSidebarScroll']",
                        nestedFooter: "[data-comp='NestedSidebarFooter']"
                    };
                    try {
                        ;
                        isOpening = selected === null || selected === void 0 ? void 0 : selected.item;
                        if (isOpening) {
                            // mark item as selected
                            nextState = snapshot.map(function(param) {
                                var set = param.set;
                                set(store/* default.selectedItem */.ZP.selectedItem, selected.item);
                            });
                            gotoSnapshot(nextState);
                        } else {
                            // isClosing
                            nextState = snapshot.map(function(param) {
                                var set = param.set;
                                set(store/* default.selectedItem */.ZP.selectedItem, null);
                            });
                            gotoSnapshot(nextState);
                        }
                    } catch (error) {
                        console.log("toggleNestedSidebar", error.message);
                        throw error;
                    } finally{
                        release();
                    }
                    return [
                        2
                    ];
                });
            });
            return function(selected) {
                return _ref.apply(this, arguments);
            };
        }();
    });
    var toggleSidebar = (0,store/* useRecoilCallback */._8)(function(param) {
        var snapshot = param.snapshot;
        return /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var release, nextState, prevMenuSidebar, isOpening;
            return (0,tslib_es6.__generator)(this, function(_state) {
                release = snapshot.retain();
                try {
                    ;
                    prevMenuSidebar = snapshot.getLoadable(store/* default.menuSidebar */.ZP.menuSidebar).contents;
                    isOpening = prevMenuSidebar === false;
                    if (isOpening) {
                        // open the drawer
                        nextState = snapshot.map(function(param) {
                            var set = param.set;
                            set(store/* default.menuSidebar */.ZP.menuSidebar, true);
                        });
                        // update state
                        gotoSnapshot(nextState);
                    } else {
                        // reset selected item
                        // close sidebar
                        nextState = snapshot.map(function(param) {
                            var set = param.set;
                            set(store/* default.selectedIndex */.ZP.selectedIndex, 0);
                            set(store/* default.selectedItem */.ZP.selectedItem, null);
                            set(store/* default.menuSidebar */.ZP.menuSidebar, false);
                            set(store/* default.overlay */.ZP.overlay, false);
                        });
                        // update state
                        gotoSnapshot(nextState);
                    }
                } catch (error) {
                    console.log("toggleSidebar", error.message);
                    throw error;
                } finally{
                    release();
                }
                return [
                    2
                ];
            });
        });
    });
    return [
        // state
        {
            menuSidebar: menuSidebar,
            menuSidebarNested: Boolean(selectedItem),
            selectedItem: selectedItem,
            selectedIndex: selectedIndex
        },
        // actions
        {
            toggleSidebar: toggleSidebar,
            toggleNestedSidebar: toggleNestedSidebar,
            closeMenuSidebar: closeMenuSidebar
        }, 
    ];
};

;// CONCATENATED MODULE: ./src/snippets/Header/MenuSidebar/Overlay/Overlay.jsx








var Overlay = Overlay_theme_themed(function(param) {
    var theme = param.theme;
    var ref = (0,_sliced_to_array/* default */.Z)(useMenuSidebar(), 2), menuSidebar = ref[0].menuSidebar, toggleSidebar = ref[1].toggleSidebar;
    var ref1 = (0,hooks/* useBodyScrollLock */.yn)(), lockScroll = ref1.lockScroll, unlockScroll = ref1.unlockScroll;
    (0,react.useEffect)(function() {
        menuSidebar ? lockScroll() : unlockScroll();
    }, [
        menuSidebar
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": Overlay.displayName,
        onClick: toggleSidebar,
        sx: (0,_object_spread/* default */.Z)({}, menuSidebar ? theme.open : theme.closed)
    });
});
Overlay.displayName = "Overlay";

;// CONCATENATED MODULE: ./src/snippets/Header/MenuSidebar/Overlay/index.js


;// CONCATENATED MODULE: ./src/snippets/Header/MenuSidebar/MenuSidebar.theme.js

var MenuSidebar_theme_themed = (0,create/* create */.U)(new function() {
    this.shell = {
        bg: "transparent",
        left: 0,
        position: "absolute",
        display: [
            "block",
            null,
            "none"
        ],
        top: [
            0,
            "calc(var(--header-height))"
        ],
        width: [
            "100%",
            "375px"
        ],
        height: [
            "var(--viewport-height)",
            "calc(var(--viewport-height) - var(--header-height) - var(--promoBar-height, 0px))", 
        ],
        willChange: "transform",
        transition: "transform .3s ease-in-out",
        zIndex: 1000,
        pointerEvents: "none",
        overflowX: "hidden"
    };
    this.scroll = {
        pointerEvents: "auto",
        bg: "background",
        mt: [
            "calc(var(--header-height))",
            0
        ],
        height: [
            "calc(var(--viewport-height) - var(--header-height))",
            "calc(var(--viewport-height) - var(--header-height) - var(--promoBar-height, 0px))", 
        ],
        overflowY: "scroll",
        webkitOverflowScrolling: "touch",
        msOverflowStyle: "none",
        scrollbarWidth: "none",
        "::-webkit-scrollbar": {
            display: "none"
        }
    };
    this.sidebar = {
        pb: "28px",
        search: {
            px: 8,
            pt: 10,
            pb: "28px",
            borderBottom: function(t) {
                return "1px solid ".concat(t.colors.gray);
            },
            position: "relative",
            ".ss-Powered": {
                fontSize: "11px",
                position: "absolute",
                right: 8,
                bottom: 2,
                color: "#565656"
            }
        },
        items: {
            display: "grid",
            gridTemplateColumns: "1fr",
            gridGap: "28px"
        }
    };
}());

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_throw.mjs
var _throw = __webpack_require__(18952);
;// CONCATENATED MODULE: ./src/snippets/Header/MenuSidebar/Links/Links.theme.js

var Links_theme_themed = (0,create/* create */.U)(new function() {
    this.list = {
        gridTemplateColumns: "1fr",
        justifyItems: "flex-start",
        gridGap: 3,
        px: 8
    };
    this.item = {
        display: "block",
        variant: "text.lg"
    };
    this.link = {
        position: "relative",
        display: "inline",
        pb: 1,
        backgroundImage: "linear-gradient(currentColor, currentColor)",
        backgroundPosition: "0% 100%",
        backgroundRepeat: "no-repeat",
        backgroundSize: "0% 1px",
        transition: "background-size 0.2s ease-in-out",
        ":hover, :focus": {
            backgroundSize: "100% 1px"
        }
    };
}());

;// CONCATENATED MODULE: ./src/snippets/Header/MenuSidebar/Links/Links.jsx










var Links = Links_theme_themed(function(param) {
    var theme = param.theme, links = param.links;
    var ref = (0,_sliced_to_array/* default */.Z)(useMenuSidebar(), 2), ref1 = ref[0], ref1 = ref1 !== null ? ref1 : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined")), closeMenuSidebar = ref[1].closeMenuSidebar;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* default.loyaltylionLoaded */.ZP.loyaltylionLoaded), 1), loyaltylionLoaded = ref2[0];
    var customer = (0,dist.useCustomer)();
    var llPointsRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (customer && typeof window.loyaltylion !== "undefined" && typeof window.loyaltylion.ui !== "undefined" && (llPointsRef === null || llPointsRef === void 0 ? void 0 : llPointsRef.current) && loyaltylionLoaded) {
            window.loyaltylion.ui.refresh();
        }
    }, [
        customer,
        llPointsRef,
        loyaltylionLoaded
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Grid */.rj, {
        "data-comp": Links.displayName,
        as: "ul",
        sx: theme.list,
        children: links === null || links === void 0 ? void 0 : links.map(function(link, index) {
            /*#__PURE__*/ return (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                as: "li",
                sx: theme.item,
                className: "".concat(customer && link.link.url.indexOf("/account") !== -1 ? "!flex gap-3 items-center" : ""),
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Link, {
                        href: link.link.url,
                        newTab: link.link.newTab,
                        onClick: closeMenuSidebar,
                        sx: theme.link,
                        children: link.link.text
                    }),
                    customer && link.link.url.indexOf("/account") !== -1 && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Link, {
                        href: "/pages/rewards",
                        onClick: closeMenuSidebar,
                        sx: theme.link,
                        className: "".concat(link.link.url.indexOf("/account") !== -1 ? "!hidden max-lg:!flex items-center" : ""),
                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)("div", {
                            className: "lg:hidden text-[13px] md:text-[15px] leading-[15px]",
                            children: [
                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)("span", {
                                    className: "font-bold",
                                    children: [
                                        "Hi ",
                                        customer === null || customer === void 0 ? void 0 : customer.firstName
                                    ]
                                }),
                                ",",
                                " ",
                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("span", {
                                    "data-lion-points": true,
                                    ref: llPointsRef
                                }),
                                " Points"
                            ]
                        })
                    })
                ]
            }, index);
        })
    });
});
Links.displayName = "MenuSidebarLinks";

;// CONCATENATED MODULE: ./src/snippets/Header/MenuSidebar/Links/index.js


;// CONCATENATED MODULE: ./src/snippets/Header/MenuSidebar/ProductsRow/ProductsRow.theme.js

var ProductsRow_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        ".swiper-container": {
            width: "100%"
        }
    };
    this.heading = {
        variant: "text.label.1",
        px: 8,
        mb: 4
    };
    this.product = {
        cursor: "pointer",
        img: {
            transform: "scale(1.001)",
            transition: "transform 0.2s ease-in-out"
        },
        ":hover": {
            img: {
                transform: "scale(1.04)"
            }
        },
        picture: {
            width: "100%"
        },
        title: {
            variant: "text.h5",
            mt: 4
        }
    };
    this.skeleton = {
        variant: "flex.row.center.center",
        width: "100%",
        height: "100%",
        bg: "lightGray",
        spinner: {
            width: "30px",
            color: "gray"
        }
    };
}());

;// CONCATENATED MODULE: ./src/snippets/Header/MenuSidebar/ProductsRow/ProductsRowItem.jsx










var ProductsRowItem = ProductsRow_theme_themed(function(param) {
    var theme = param.theme, handle = param.handle, image = param.image;
    var ref, ref1;
    if (!handle) return null;
    var _ref = (0,dist.useProductByHandle)({
        handle: handle
    }), product = _ref.product, status = (0,_object_without_properties/* default */.Z)(_ref, [
        "product"
    ]);
    var ref2 = (0,_sliced_to_array/* default */.Z)(useMenuSidebar(), 2), ref3 = ref2[0], ref3 = ref3 !== null ? ref3 : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined")), closeMenuSidebar = ref2[1].closeMenuSidebar;
    var ratio = (image === null || image === void 0 ? void 0 : image.ratio) || (product === null || product === void 0 ? void 0 : (ref = product.images) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.ratio);
    var url = "/products/".concat(product === null || product === void 0 ? void 0 : product.handle);
    var firstImage = (0,react.useMemo)(function() {
        var ref, ref1;
        return (ref1 = product === null || product === void 0 ? void 0 : (ref = product.media) === null || ref === void 0 ? void 0 : ref.find(function(item) {
            return item.mediaContentType === "IMAGE";
        })) === null || ref1 === void 0 ? void 0 : ref1.image;
    }, [
        product === null || product === void 0 ? void 0 : product.id
    ]);
    var src = (image === null || image === void 0 ? void 0 : image.src) || (firstImage === null || firstImage === void 0 ? void 0 : firstImage.originalSrc);
    var title = (0,react.useMemo)(function() {
        var fullTitle = product === null || product === void 0 ? void 0 : product.title;
        var splitIndex = (fullTitle === null || fullTitle === void 0 ? void 0 : fullTitle.indexOf("|")) || -1;
        return {
            product: splitIndex >= 0 ? fullTitle === null || fullTitle === void 0 ? void 0 : fullTitle.slice(0, splitIndex).trim() : fullTitle,
            variant: splitIndex >= 0 ? fullTitle === null || fullTitle === void 0 ? void 0 : fullTitle.slice(splitIndex + 1).trim() : ""
        };
    }, [
        product === null || product === void 0 ? void 0 : product.title
    ]);
    return (status === null || status === void 0 ? void 0 : status.finished) && product ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(Link, {
        "data-comp": ProductsRowItem.displayName,
        href: url,
        onClick: closeMenuSidebar,
        sx: theme.product,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Picture, {
                alt: product.title,
                images: [
                    {
                        src: src,
                        ratio: ratio,
                        width: 253
                    }, 
                ],
                sx: theme.product.picture
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                sx: theme.product.title,
                as: "h5",
                children: title.product
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                sx: {
                    color: "mediumDarkGray",
                    mt: 1
                },
                children: title.variant
            })
        ]
    }) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* AspectRatio */.oM, {
        ratio: 1,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
            sx: theme.skeleton,
            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Spinner */.$j, {
                sx: theme.skeleton.spinner
            })
        })
    });
});
ProductsRowItem.displayName = "MenuSidebarProductsRowItem";

;// CONCATENATED MODULE: ./src/snippets/Header/MenuSidebar/ProductsRow/ProductsRow.jsx





var ProductsRow = ProductsRow_theme_themed(function(param) {
    var theme = param.theme, heading = param.heading, products = param.products;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": ProductsRow.displayName,
        sx: theme.wrapper,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                as: "h5",
                sx: theme.heading,
                children: heading
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(react_swiper/* Swiper */.t, {
                spaceBetween: 16,
                slidesPerView: 1.4,
                slidesOffsetBefore: 16,
                slidesOffsetAfter: 16,
                children: products.map(function(item, index) {
                    var ref, ref1;
                    /*#__PURE__*/ return (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(swiper_slide/* SwiperSlide */.o, {
                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(ProductsRowItem, {
                            handle: (ref = item.product) === null || ref === void 0 ? void 0 : ref.handle,
                            image: item.image
                        })
                    }, ((ref1 = item.product) === null || ref1 === void 0 ? void 0 : ref1.handle) + index);
                })
            })
        ]
    });
});
ProductsRow.displayName = "MenuSidebarProductsRow";

;// CONCATENATED MODULE: ./src/snippets/Header/MenuSidebar/ProductsRow/index.js


;// CONCATENATED MODULE: ./src/snippets/Header/MenuSidebar/SubNav/SubNav.theme.js

var SubNav_theme_themed = (0,create/* create */.U)(new function() {
    this.nav = {
        position: "relative"
    };
    this.list = {
        p: 0
    };
    this.item = {
        button: {
            width: "100%",
            textAlign: "left",
            position: "relative",
            height: "52px",
            p: 8,
            borderBottom: function(t) {
                return "1px solid ".concat(t.colors.gray);
            }
        },
        text: {
            variant: "text.label.1"
        },
        icon: {
            position: "absolute",
            right: 8,
            top: "50%",
            width: "24px",
            height: "24px",
            transform: "translateY(-50%)"
        }
    };
}());

;// CONCATENATED MODULE: ./src/snippets/Header/MenuSidebar/SubNav/SubNavMenuItem.jsx






var SubNavMenuItem = SubNav_theme_themed(function(param) {
    var theme = param.theme, item = param.item, toggleNestedSidebar = param.toggleNestedSidebar;
    var textColor = item === null || item === void 0 ? void 0 : item.color;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Button */.zx, {
        "data-comp": "".concat(SubNavMenuItem.displayName),
        variant: "buttons.plain",
        onClick: function() {
            toggleNestedSidebar({
                item: item
            });
        },
        sx: theme.item.button,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                as: "h5",
                "data-comp": "SubNavAccordionItemHeading",
                sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.item.text), {
                    color: textColor || "inherit"
                }),
                children: item.link.text
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Svg, {
                "data-comp": "SubNavAccordionItemNextArrow",
                viewBox: "0 0 24 24",
                src: "/svgs/arrow-right.svg#arrow-right",
                sx: theme.item.icon
            })
        ]
    });
});
SubNavMenuItem.displayName = "SubNavMenuItem";

;// CONCATENATED MODULE: ./src/snippets/Header/MenuSidebar/SubNav/SubNavLinkItem.jsx






var SubNavLinkItem = SubNav_theme_themed(function(param) {
    var theme = param.theme, item = param.item, closeMenuSidebar = param.closeMenuSidebar;
    var textColor = item === null || item === void 0 ? void 0 : item.color;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Link, {
        "data-comp": SubNavLinkItem.displayName,
        href: item.link.url,
        newTab: item.link.newTab,
        sx: theme.item.button,
        onClick: closeMenuSidebar,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
            as: "h5",
            sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.item.text), {
                color: textColor || "inherit"
            }),
            children: item.link.text
        })
    });
});
SubNavLinkItem.displayName = "SubNavLinkItem";

;// CONCATENATED MODULE: ./src/snippets/Header/MenuSidebar/SubNav/SubNav.jsx







var SubNav = SubNav_theme_themed(function(param) {
    var theme = param.theme, items = param.items;
    var ref = (0,_sliced_to_array/* default */.Z)(useMenuSidebar(), 2), ref1 = ref[1], closeMenuSidebar = ref1.closeMenuSidebar, toggleNestedSidebar = ref1.toggleNestedSidebar;
    // anim
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": SubNav.displayName,
        as: "nav",
        role: "navigation",
        sx: theme.nav,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
            as: "ul",
            sx: theme.list,
            children: items === null || items === void 0 ? void 0 : items.map(function(item, index) {
                var ref;
                /*#__PURE__*/ return (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                    "data-comp": "".concat(SubNav.displayName, "Item"),
                    as: "li",
                    sx: theme.item,
                    children: ((ref = item.secondaryMenu) === null || ref === void 0 ? void 0 : ref.length) ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(SubNavMenuItem, {
                        item: item,
                        index: index,
                        toggleNestedSidebar: toggleNestedSidebar
                    }) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(SubNavLinkItem, {
                        item: item,
                        closeMenuSidebar: closeMenuSidebar
                    })
                }, index);
            })
        })
    });
});
SubNav.displayName = "SubNav";

;// CONCATENATED MODULE: ./src/snippets/Header/MenuSidebar/SubNav/index.js


;// CONCATENATED MODULE: ./src/snippets/Header/MenuSidebar/ReferLink/ReferLink.theme.js

var ReferLink_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        display: "flex",
        height: "46px",
        mt: "11px",
        alignItems: "center",
        px: "24px"
    };
    this.link = {};
    this.text = {
        fontSize: 6,
        lineHeight: 22,
        letterSpacing: "0.02em",
        fontFamily: "body",
        cursor: "pointer"
    };
}());

;// CONCATENATED MODULE: ./src/snippets/Header/MenuSidebar/ReferLink/ReferLink.jsx











var ReferLink = ReferLink_theme_themed(function(param) {
    var theme = param.theme;
    var ref, ref1;
    var ref2 = (0,_sliced_to_array/* default */.Z)(useMenuSidebar(), 2), ref3 = ref2[0], ref3 = ref3 !== null ? ref3 : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined")), closeMenuSidebar = ref2[1].closeMenuSidebar;
    var settings = (0,dist.useSettings)();
    var mobileSettings = settings === null || settings === void 0 ? void 0 : (ref = settings.header) === null || ref === void 0 ? void 0 : (ref1 = ref.refer) === null || ref1 === void 0 ? void 0 : ref1.mobile;
    var ref4 = (0,_object_spread/* default */.Z)({}, mobileSettings), linkText = ref4.linkText, background = ref4.background, color = ref4.color, link = ref4.link, textAlign = ref4.textAlign, enabled = ref4.enabled;
    if (!enabled) return null;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
        "data-comp": ReferLink.displayName,
        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.wrapper), {
            bg: background,
            justifyContent: (0,utils/* convertAlignToFlex */.nG)(textAlign)
        }),
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Link, {
            href: link.url,
            newTab: link.newTab,
            onClick: closeMenuSidebar,
            sx: theme.link,
            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Markdown, {
                text: linkText || link.text,
                textSx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.text), {
                    color: color
                })
            })
        })
    });
});
ReferLink.displayName = "MenuSidebarReferLink";

;// CONCATENATED MODULE: ./src/snippets/Header/MenuSidebar/ReferLink/index.js


;// CONCATENATED MODULE: ./src/snippets/Header/MenuSidebar/MenuSidebar.jsx










/**
 * Renders the mobile nav and links
 */ var MenuSidebar = MenuSidebar_theme_themed(function(param) {
    var theme = param.theme;
    var ref, ref1;
    var settings = (0,dist.useSettings)();
    var header = (0,_object_spread/* default */.Z)({}, settings).header;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": MenuSidebar.displayName,
        sx: theme.sidebar,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                "data-comp": "MenuSidebarSearchInput",
                sx: theme.sidebar.search,
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Search/* Input */.II, {}),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                        className: "ss-Powered",
                        children: "Powered by SearchSpring"
                    })
                ]
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Grid */.rj, {
                sx: theme.sidebar.items,
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(SubNav, {
                        items: header === null || header === void 0 ? void 0 : header.menu
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(ProductsRow, {
                        heading: header === null || header === void 0 ? void 0 : (ref = header.bestSellers) === null || ref === void 0 ? void 0 : ref.heading,
                        products: header === null || header === void 0 ? void 0 : (ref1 = header.bestSellers) === null || ref1 === void 0 ? void 0 : ref1.products
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Links, {
                        links: header === null || header === void 0 ? void 0 : header.links
                    })
                ]
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(ReferLink, {})
        ]
    });
});
MenuSidebar.displayName = "MenuSidebar";

;// CONCATENATED MODULE: ./src/snippets/Header/MenuSidebar/NestedSidebar/NestedSidebar.theme.js

var NestedSidebar_theme_themed = (0,create/* create */.U)(new function() {
    this.shell = {
        height: [
            "var(--viewport-height)",
            "calc(var(--viewport-height) - var(--header-height) - var(--promoBar-height, 0px))", 
        ],
        width: "100%",
        position: "absolute",
        top: 0,
        left: 0,
        bottom: 0,
        bg: "background",
        zIndex: 2,
        pointerEvents: "auto",
        transition: "transform .3s ease-in-out",
        borderStyle: "solid",
        borderColor: "gray",
        borderWidth: "0 1px 0 0"
    };
    this.scroll = {
        top: 0,
        height: "100%",
        mt: 0,
        pointerEvents: "auto",
        bg: "background",
        overflowY: "scroll",
        webkitOverflowScrolling: "touch",
        msOverflowStyle: "none",
        scrollbarWidth: "none",
        "::-webkit-scrollbar": {
            display: "none"
        }
    };
    this.header = {
        variant: "flex.row.center.center",
        height: "52px",
        borderBottom: function(t) {
            return "1px solid ".concat(t.colors.gray);
        },
        position: "sticky",
        top: 0,
        bg: "background",
        zIndex: 1,
        backButton: {
            position: "absolute",
            top: "50%",
            left: 8,
            transform: "translateY(-50%)"
        },
        icon: {
            width: "24px",
            height: "24px",
            color: "dark"
        },
        heading: {
            fontWeight: 500,
            fontSize: "22px",
            lineHeight: 24,
            textAlign: "center",
            letterSpacing: "-0.005em"
        }
    };
    this.secondaryMenuLinkWrapper = {
        px: 8,
        mt: 8
    };
    this.secondaryMenuLink = {
        fontSize: 3,
        display: "inline",
        textAlign: "left",
        position: "relative"
    };
    this.secondaryMenuItem = {
        fontSize: 3,
        fontWeight: 500,
        p: 8
    };
    this.footer = {
        position: "relative",
        link: {
            position: "fixed",
            bottom: 0,
            right: 0,
            left: 0,
            variant: "text.buttonText",
            fontSize: 3,
            width: "calc(100% + 1px)",
            height: "52px",
            bg: "dark",
            textAlign: "center",
            color: "white",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        }
    };
}());

;// CONCATENATED MODULE: ./src/snippets/Header/MenuSidebar/NestedSidebar/NestedSidebarFooter.jsx




var NestedSidebarFooter = NestedSidebar_theme_themed(function(param) {
    var theme = param.theme, selectedItem = param.selectedItem, closeMenuSidebar = param.closeMenuSidebar;
    var link = selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.link;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": NestedSidebarFooter.displayName,
        sx: theme.footer,
        children: (link === null || link === void 0 ? void 0 : link.url) && (link === null || link === void 0 ? void 0 : link.text) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(Link, {
            href: link.url,
            newTab: link.newTab,
            onClick: closeMenuSidebar,
            sx: theme.footer.link,
            children: [
                "Shop All ",
                link.text
            ]
        })
    });
});
NestedSidebarFooter.displayName = "NestedSidebarFooter";

;// CONCATENATED MODULE: ./src/snippets/Header/MenuSidebar/NestedSidebar/NestedSidebarHeader.jsx




var NestedSidebarHeader = NestedSidebar_theme_themed(function(param) {
    var theme = param.theme, selectedItem = param.selectedItem, toggleNestedSidebar = param.toggleNestedSidebar;
    var ref;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
        "data-comp": NestedSidebarHeader.displayName,
        sx: theme.header,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                variant: "buttons.plain",
                onClick: toggleNestedSidebar,
                sx: theme.header.backButton,
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Svg, {
                    viewBox: "0 0 24 24",
                    src: "/svgs/arrow-left.svg#arrow-left",
                    sx: theme.header.icon
                })
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                as: "h5",
                sx: theme.header.heading,
                children: selectedItem === null || selectedItem === void 0 ? void 0 : (ref = selectedItem.link) === null || ref === void 0 ? void 0 : ref.text
            })
        ]
    });
});
NestedSidebarHeader.displayName = "NestedSidebarHeader";

// EXTERNAL MODULE: ../node_modules/react-expand-animated/build/Expand.js
var Expand = __webpack_require__(71977);
;// CONCATENATED MODULE: ./src/snippets/Header/MenuSidebar/ExpandableMenu/ExpandableMenu.theme.js

var ExpandableMenu_theme_themed = (0,create/* create */.U)(new function() {
    this.expandableMenu = function(open) {
        return {
            width: "100%",
            textAlign: "left",
            position: "relative",
            gridGap: 0,
            cursor: "pointer",
            borderTop: function(t) {
                return "1px solid ".concat(open ? t.colors.black : "transparent");
            },
            borderBottom: function(t) {
                return "1px solid ".concat(open ? "transparent" : t.colors.gray);
            }
        };
    };
    this.expandableMenuHeading = {
        fontSize: 3,
        fontWeight: 500,
        p: 8
    };
    this.expandableMenuArrowIcon = function(open) {
        return {
            position: "absolute",
            right: "23px",
            top: "calc(50% -  8px)",
            width: "16px",
            height: "16px",
            transition: "0.3s ease-in-out transform",
            transform: open ? "rotate(180deg)" : "rotate(0deg)",
            color: function(t) {
                return t.colors.black;
            }
        };
    };
    this.epandableMenuHeadingLink = {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "15px",
        fontWeight: 500,
        height: "38px",
        width: "100%",
        borderRadius: "6px",
        backgroundColor: function(t) {
            return t.colors.mediumLightGray;
        },
        color: function(t) {
            return t.colors.black;
        }
    };
    this.expandableMenuLink = {
        images: {
            minHeight: "32px",
            display: "inline-flex",
            alignItems: "center",
            px: 8,
            "&:last-child": {
                mb: 8
            }
        },
        cards: {
            textAlign: "center"
        }
    };
    this.expandableMenuLinkImage = {
        images: {
            width: "48px",
            height: "48px",
            mr: 6
        },
        cards: {
            width: "148px",
            height: "148px",
            mx: "auto",
            mb: 4,
            borderRadius: "100%",
            backgroundColor: function(t) {
                return t.colors.mediumLightGray;
            }
        }
    };
}());

;// CONCATENATED MODULE: ./src/snippets/Header/MenuSidebar/ExpandableMenu/ExpandableMenuLink.jsx










var ExpandableMenuLink = ExpandableMenu_theme_themed(function(param) {
    var theme = param.theme, item = param.item, layout = param.layout;
    var ref;
    var link = item.link;
    var ref1 = (0,_sliced_to_array/* default */.Z)(useMenuSidebar(), 2), ref2 = ref1[0], ref2 = ref2 !== null ? ref2 : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined")), closeMenuSidebar = ref1[1].closeMenuSidebar;
    var product = (0,dist.useProductByHandle)({
        handle: ((ref = item.product) === null || ref === void 0 ? void 0 : ref.handle) || "hopsulator-slim-gold-leopard-12oz-slim-cans"
    }).product;
    var firstImage = (0,react.useMemo)(function() {
        var ref, ref1;
        return (ref1 = product === null || product === void 0 ? void 0 : (ref = product.media) === null || ref === void 0 ? void 0 : ref.find(function(item) {
            return item.mediaContentType === "IMAGE";
        })) === null || ref1 === void 0 ? void 0 : ref1.image;
    }, [
        product === null || product === void 0 ? void 0 : product.id
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
        as: "li",
        sx: theme.expandableMenuLink[layout],
        "data-comp": ExpandableMenuLink.displayName,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(Link, {
            href: link === null || link === void 0 ? void 0 : link.url,
            newTab: link === null || link === void 0 ? void 0 : link.newTab,
            "aria-label": link === null || link === void 0 ? void 0 : link.text,
            onClick: closeMenuSidebar,
            sx: (0,_object_spread/* default */.Z)({
                fontSize: layout === "images" ? "15px" : "16px",
                color: function(t) {
                    return t.colors.black;
                }
            }, layout === "images" ? {
                display: "flex",
                alignItems: "center"
            } : {}),
            children: [
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Picture, {
                    alt: link === null || link === void 0 ? void 0 : link.text,
                    images: [
                        {
                            src: firstImage === null || firstImage === void 0 ? void 0 : firstImage.originalSrc,
                            width: layout === "images" ? 96 : 296,
                            ratio: 1
                        }, 
                    ],
                    sx: theme.expandableMenuLinkImage[layout]
                }),
                link === null || link === void 0 ? void 0 : link.text
            ]
        })
    });
});
ExpandableMenuLink.displayName = "ExpandableMenuLink";

;// CONCATENATED MODULE: ./src/snippets/Header/MenuSidebar/ExpandableMenu/ExpandableMenu.jsx












var ExpandableMenu = ExpandableMenu_theme_themed(function(param) {
    var theme = param.theme, item = param.item;
    var ref = (0,_sliced_to_array/* default */.Z)(useMenuSidebar(), 2), ref1 = ref[0], ref1 = ref1 !== null ? ref1 : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined")), closeMenuSidebar = ref[1].closeMenuSidebar;
    var ref2 = (0,react.useState)(false), open = ref2[0], setOpen = ref2[1];
    var link = item.link, textColor = item.color, tertiaryMenu = item.tertiaryMenu, _mobileLayout = item.mobileLayout, mobileLayout = _mobileLayout === void 0 ? "cards" : _mobileLayout, hideShopAll = item.hideShopAll;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_jsx_runtime_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                "data-comp": ExpandableMenu.displayName,
                sx: theme.expandableMenu(open),
                onClick: function() {
                    setOpen(!open);
                },
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.expandableMenuHeading), {
                            color: textColor || "black"
                        }),
                        children: link.text
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Svg, {
                        viewBox: "0 0 16 16",
                        src: "/svgs/chevron/down.svg#down",
                        sx: theme.expandableMenuArrowIcon(open)
                    })
                ]
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(Expand/* default */.Z, {
                open: open,
                duration: 300,
                sx: (0,_object_spread/* default */.Z)({}, open ? {
                    borderBottom: function(t) {
                        return "1px solid ".concat(t.colors.black);
                    }
                } : ""),
                children: [
                    !hideShopAll && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                        sx: {
                            px: 8,
                            mb: mobileLayout === "images" ? 4 : 10
                        },
                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(Link, {
                            href: link === null || link === void 0 ? void 0 : link.url,
                            newTab: link === null || link === void 0 ? void 0 : link.newTab,
                            "aria-label": link === null || link === void 0 ? void 0 : link.text,
                            onClick: closeMenuSidebar,
                            sx: theme.epandableMenuHeadingLink,
                            children: [
                                "All ",
                                link === null || link === void 0 ? void 0 : link.text
                            ]
                        })
                    }),
                    mobileLayout === "images" ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                        variant: "flex.column",
                        as: "ul",
                        children: tertiaryMenu === null || tertiaryMenu === void 0 ? void 0 : tertiaryMenu.map(function(item) {
                            return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(ExpandableMenuLink, {
                                item: item,
                                layout: mobileLayout
                            });
                        })
                    }) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Grid */.rj, {
                        sx: {
                            gridTemplateColumns: "1fr 1fr",
                            gridGap: "20px 47px",
                            px: 8,
                            mb: 12
                        },
                        children: tertiaryMenu === null || tertiaryMenu === void 0 ? void 0 : tertiaryMenu.map(function(item) {
                            return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(ExpandableMenuLink, {
                                item: item,
                                layout: mobileLayout
                            });
                        })
                    })
                ]
            })
        ]
    });
});
ExpandableMenu.displayName = "ExpandableMenu";

;// CONCATENATED MODULE: ./src/snippets/Header/MenuSidebar/ExpandableMenu/index.js


;// CONCATENATED MODULE: ./src/snippets/Header/MenuSidebar/NestedSidebar/NestedSidebarMenu.jsx








var NestedSidebarMenu = NestedSidebar_theme_themed(function(_param) {
    var theme = _param.theme, secondaryMenu = _param.secondaryMenu, featuredImage = _param.featuredImage, index = _param.index, closeMenuSidebar = _param.closeMenuSidebar, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme",
        "secondaryMenu",
        "featuredImage",
        "index",
        "closeMenuSidebar"
    ]);
    var ref = (0,_object_spread/* default */.Z)({}, featuredImage), image = ref.image, link = ref.link;
    return (secondaryMenu === null || secondaryMenu === void 0 ? void 0 : secondaryMenu.length) ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-comp": NestedSidebarMenu.displayName
    }, props), {
        as: "ul",
        variant: "flex.column",
        sx: {
            gridGap: 0,
            pb: 19
        },
        children: [
            secondaryMenu.map(function(item, index) {
                var link = item.link, textColor = item.color, tertiaryMenu = item.tertiaryMenu;
                return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                    as: "li",
                    index: index,
                    children: tertiaryMenu ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(ExpandableMenu, {
                        item: item
                    }) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                        sx: theme.secondaryMenuLinkWrapper,
                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Link, {
                            href: link.url,
                            newTab: link.newTab,
                            "aria-label": link.text,
                            onClick: closeMenuSidebar,
                            sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.secondaryMenuLink), {
                                color: textColor || "black"
                            }),
                            children: link.text
                        })
                    })
                });
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                sx: {
                    px: 8,
                    my: 12
                },
                children: [
                    (image === null || image === void 0 ? void 0 : image.src) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Link, {
                        href: link === null || link === void 0 ? void 0 : link.url,
                        newTab: link === null || link === void 0 ? void 0 : link.newTab,
                        "aria-label": link === null || link === void 0 ? void 0 : link.text,
                        onClick: closeMenuSidebar,
                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Picture, {
                            alt: link === null || link === void 0 ? void 0 : link.text,
                            images: [
                                {
                                    src: image.src,
                                    width: 1160,
                                    ratio: 1
                                }, 
                            ],
                            sx: {
                                width: "100%",
                                minHeight: "260px",
                                maxHeight: "260px",
                                maxWidth: "580px",
                                ml: "auto",
                                position: "relative"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Link, {
                        href: link === null || link === void 0 ? void 0 : link.url,
                        newTab: link === null || link === void 0 ? void 0 : link.newTab,
                        "aria-label": link === null || link === void 0 ? void 0 : link.text,
                        onClick: closeMenuSidebar,
                        sx: {
                            color: "black",
                            fontSize: 4,
                            mt: 4
                        },
                        children: link === null || link === void 0 ? void 0 : link.text
                    })
                ]
            })
        ]
    })) : null;
});
NestedSidebarMenu.displayName = "NestedSidebarMenu";

;// CONCATENATED MODULE: ./src/snippets/Header/MenuSidebar/NestedSidebar/NestedSidebar.jsx










var NestedSidebar = NestedSidebar_theme_themed(function(param) {
    var theme = param.theme;
    var ref;
    var ref1 = (0,_sliced_to_array/* default */.Z)(useMenuSidebar(), 2), selectedItem = ref1[0].selectedItem, ref2 = ref1[1], toggleNestedSidebar = ref2.toggleNestedSidebar, closeMenuSidebar = ref2.closeMenuSidebar;
    var hasFooter = !!(selectedItem === null || selectedItem === void 0 ? void 0 : (ref = selectedItem.footerLink) === null || ref === void 0 ? void 0 : ref.text);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Container */.W2, {
        "data-comp": NestedSidebar.displayName,
        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.shell), {
            pb: hasFooter ? "52px" : 0,
            transform: "translateX(".concat(selectedItem ? "0" : "100%", ")")
        }),
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Container */.W2, {
                "data-comp": "NestedSidebarScroll",
                sx: theme.scroll,
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(NestedSidebarHeader, {
                        selectedItem: selectedItem,
                        toggleNestedSidebar: toggleNestedSidebar
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(NestedSidebarMenu, (0,_object_spread/* default */.Z)({
                        closeMenuSidebar: closeMenuSidebar
                    }, selectedItem))
                ]
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(NestedSidebarFooter, {
                selectedItem: selectedItem,
                closeMenuSidebar: closeMenuSidebar
            })
        ]
    });
});
NestedSidebar.displayName = "NestedSidebar";

;// CONCATENATED MODULE: ./src/snippets/Header/MenuSidebar/NestedSidebar/index.js


;// CONCATENATED MODULE: ./src/snippets/Header/MenuSidebar/MenuSidebarShell.jsx











var MenuSidebarShell = MenuSidebar_theme_themed(function(param) {
    var theme = param.theme;
    var ref = (0,_sliced_to_array/* default */.Z)(useMenuSidebar(), 1), menuSidebar = ref[0].menuSidebar;
    (0,react.useEffect)(function() {
        if (document.documentElement) {
            document.documentElement.classList.toggle("sidebarShell-open", menuSidebar);
        }
    }, [
        menuSidebar
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_jsx_runtime_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Overlay, {}),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                as: "aside",
                "data-comp": MenuSidebarShell.displayName,
                sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.shell), {
                    transform: "translateX(".concat(menuSidebar ? "0" : "-100%", ")")
                }),
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Container */.W2, {
                        "data-comp": "".concat(MenuSidebarShell.displayName, "Scroll"),
                        sx: theme.scroll,
                        children: menuSidebar && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(MenuSidebar, {})
                    }),
                    menuSidebar && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(NestedSidebar, {})
                ]
            })
        ]
    });
});
MenuSidebarShell.displayName = "MenuSidebarShell";

;// CONCATENATED MODULE: ./src/snippets/Header/MenuSidebar/index.js



;// CONCATENATED MODULE: ./src/snippets/Header/PromoBar/PromoBar.jsx














core_class/* default.use */.Z.use([
    effect_fade/* default */.Z
]);
core_class/* default.use */.Z.use([
    autoplay
]);
var PromoBar = PromoBar_theme_themed(function(param) {
    var theme = param.theme;
    var ref = (0,_sliced_to_array/* default */.Z)(usePromobar(), 2), ref1 = ref[0], promoBarRef = ref1.promoBarRef, swiper = ref1.swiper, swiperRef = ref1.swiperRef, closed = ref1.closed, currentColor = ref1.currentColor, bgColor = ref1.bgColor, isDisabled = ref1.isDisabled, singleMessage = ref1.singleMessage, promoBar = ref1.promoBar, ref2 = ref[1], updateActiveIndex = ref2.updateActiveIndex, setSwiper = ref2.setSwiper;
    var ref3 = (0,_sliced_to_array/* default */.Z)(useMenuSidebar(), 1), menuSidebar = ref3[0].menuSidebar;
    var ref4 = (0,react.useState)(false), loaded = ref4[0], setLoaded = ref4[1];
    (0,react.useEffect)(function() {
        setLoaded(true);
        return function() {
            setLoaded(false);
        };
    }, []);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": PromoBar.displayName,
        ref: promoBarRef,
        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.wrapper), {
            minHeight: [
                menuSidebar ? 0 : "20px",
                "20px"
            ],
            maxHeight: [
                menuSidebar ? 0 : "102px",
                "102px"
            ],
            overflow: "hidden"
        }),
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(AccessibilityBar, {}),
            !isDisabled && loaded && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.promobarWrapper), {
                    color: currentColor,
                    bg: bgColor
                }),
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.swiperWrapper), {
                        visibility: [
                            menuSidebar ? "hidden" : "visible",
                            "visible"
                        ]
                    }),
                    children: [
                        singleMessage ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(PromoBarMessage, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, promoBar.messages[0]), {
                            isActive: !closed
                        })) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(react_swiper/* Swiper */.t, {
                            "data-comp": "PromoBarMessagesSlider",
                            init: true,
                            autoplay: {
                                enabled: true,
                                delay: promoBar.duration * 1000,
                                disableOnInteraction: false
                            },
                            ref: swiperRef,
                            watchSlidesProgress: true,
                            fadeEffect: {
                                crossFade: true
                            },
                            speed: promoBar.speed * 1000,
                            effect: "fade",
                            onSwiper: setSwiper,
                            onSlideChange: updateActiveIndex,
                            loop: true,
                            sx: theme.swiper,
                            children: promoBar.messages.map(function(message, index) {
                                var ref;
                                /*#__PURE__*/ return (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(swiper_slide/* SwiperSlide */.o, {
                                    children: function(param) {
                                        var isActive = param.isActive;
                                        return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(PromoBarMessage, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, message), {
                                            isActive: !closed && isActive,
                                            index: index
                                        }));
                                    }
                                }, index + (message === null || message === void 0 ? void 0 : (ref = message.copy) === null || ref === void 0 ? void 0 : ref.slice(0, 10)));
                            })
                        }),
                        !singleMessage && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Navigation, {
                            swiper: swiper
                        })
                    ]
                })
            })
        ]
    });
});
PromoBar.displayName = "PromoBar";

;// CONCATENATED MODULE: ./src/snippets/Header/PromoBar/index.js


;// CONCATENATED MODULE: ./src/snippets/Header/Menu/Menu.theme.js

var MENU_HEIGHT = [
    "56px"
];
var Menu_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        variant: "layout.header",
        display: "grid",
        alignItems: "center",
        bg: "background",
        columnGap: [
            4,
            8,
            12
        ],
        gridTemplateColumns: [
            "60px 1fr 60px",
            null,
            "140px 1fr auto"
        ],
        justifyContent: "space-between",
        position: "relative",
        height: MENU_HEIGHT,
        width: "100%",
        zIndex: 2,
        borderBottomStyle: "solid",
        borderBottomWidth: "1px",
        borderBottomColor: "gray"
    };
    // burger + search — mobile
    this.toggle = {
        display: [
            "flex",
            null,
            "none"
        ],
        width: 100
    };
    this.logo = {
        cursor: "pointer",
        mx: "auto",
        width: "140px",
        color: "dark"
    };
    this.nav = {
        variant: "flex.row.start.center",
        display: [
            "none",
            null,
            "flex"
        ],
        height: "inherit",
        flex: 1
    };
    this.item = {
        variant: "text.navItem",
        height: "inherit",
        display: "flex",
        alignItems: "center",
        mr: 10,
        opacity: 1,
        position: "relative",
        underline: {
            content: '""',
            bg: "text",
            bottom: 0,
            display: "block",
            height: "1px",
            left: 0,
            position: "absolute",
            right: 0,
            transition: "transform .15s ease-in-out",
            transformOrigin: "bottom center",
            width: "100%"
        }
    };
    this.refer = {
        mr: [
            5,
            7
        ],
        fontSize: 2,
        lineHeight: 18,
        fontWeight: 500,
        letterSpacing: "0.02em",
        fontFamily: "body",
        cursor: "pointer"
    };
    this.ctas = {
        variant: "flex.row.end.center",
        columnGap: [
            5,
            7
        ],
        gridTemplateColumns: [
            "1fr",
            null,
            "1fr 1fr max-content"
        ],
        ml: "auto",
        width: [
            "auto"
        ]
    };
    this.cta = {
        icon: {
            width: [
                24,
                null,
                20
            ],
            cursor: "pointer"
        }
    };
    this.cartWrapper = {
        variant: "flex.row.start.center",
        height: "100%",
        ml: [
            5,
            null,
            10
        ],
        pl: [
            0,
            null,
            10
        ],
        width: [
            "auto",
            null,
            "56px",
            "48px"
        ],
        borderLeftStyle: [
            "none",
            null,
            "solid"
        ],
        borderLeftWidth: "1px",
        borderLeftColor: "gray",
        position: "relative"
    };
}());

;// CONCATENATED MODULE: ./src/snippets/Header/Menu/Ctas/CtaSearch.jsx










var CtaSearch = Menu_theme_themed(function(_param) {
    var theme = _param.theme, inputRef = _param.inputRef, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme",
        "inputRef"
    ]);
    var ref = (0,_sliced_to_array/* default */.Z)((0,hooks/* useSidebar */.Ap)(), 2), ref1 = ref[0], ref1 = ref1 !== null ? ref1 : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined")), openSearchSidebar = ref[1].openSearchSidebar;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-comp": CtaSearch.displayName
    }, props), {
        variant: "buttons.plain",
        "aria-label": "Open search",
        onClick: openSearchSidebar,
        sx: (0,_object_spread/* default */.Z)({}, props.sx, theme.cta),
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Svg, {
            alt: "Open search",
            viewBox: "0 0 48 48",
            src: "/svgs/cta/search.svg#search",
            sx: theme.cta.icon
        })
    }));
});
CtaSearch.displayName = "CtaSearch";

;// CONCATENATED MODULE: ./src/snippets/Header/Menu/Ctas/CtaAccount.jsx










var CtaAccount = Menu_theme_themed(function(_param) {
    var theme = _param.theme, inputRef = _param.inputRef, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme",
        "inputRef"
    ]);
    var ref = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* default.loyaltylionLoaded */.ZP.loyaltylionLoaded), 1), loyaltylionLoaded = ref[0];
    var customer = (0,dist.useCustomer)();
    var llPointsRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (customer && typeof window.loyaltylion !== "undefined" && typeof window.loyaltylion.ui !== "undefined" && (llPointsRef === null || llPointsRef === void 0 ? void 0 : llPointsRef.current) && loyaltylionLoaded) {
            window.loyaltylion.ui.refresh();
        }
    }, [
        customer,
        llPointsRef,
        loyaltylionLoaded
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)("div", {
        className: "max-lg:!hidden !flex items-center gap-3",
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Link, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                "data-comp": CtaAccount.displayName
            }, props), {
                "aria-label": customer ? "View account" : "Login",
                href: customer ? "/account/orders" : "/account/login",
                sx: (0,_object_spread/* default */.Z)({}, props.sx, theme.cta),
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Svg, {
                    alt: customer ? "View account" : "Login",
                    src: "/svgs/cta/account.svg#account",
                    viewBox: "0 0 48 48",
                    sx: theme.cta.icon
                })
            })),
            customer && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Link, {
                href: "/pages/rewards",
                sx: theme.link,
                "aria-label": "Rewards page",
                className: "max-md:hidden items-center",
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)("div", {
                    className: "text-[13px] font-medium leading-[15px]",
                    children: [
                        "Hi ",
                        customer === null || customer === void 0 ? void 0 : customer.firstName,
                        ",",
                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("br", {}),
                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("span", {
                            "data-lion-points": true,
                            ref: llPointsRef
                        }),
                        " Points"
                    ]
                })
            })
        ]
    });
});
CtaAccount.displayName = "CtaAccount";

;// CONCATENATED MODULE: ./src/snippets/Header/Menu/Ctas/CtaCart.jsx








var CtaCart = Menu_theme_themed(function(_param) {
    var theme = _param.theme, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme"
    ]);
    var ref;
    var cartCount = (0,Cart/* useCartCount */.iF)();
    var openCartSidebar = (0,hooks/* useSidebar */.Ap)()[1].openCartSidebar;
    var length = (ref = cartCount === null || cartCount === void 0 ? void 0 : cartCount.toFixed(0)) === null || ref === void 0 ? void 0 : ref.length;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
        sx: (0,_object_spread/* default */.Z)({}, theme.cartWrapper, props.sx),
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                "data-comp": CtaCart.displayName,
                variant: "buttons.plain",
                onClick: openCartSidebar,
                "aria-label": "Open cart drawer",
                sx: theme.cta,
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Svg, {
                    alt: "cart",
                    viewBox: "0 0 48 48",
                    src: "/svgs/cta/cart.svg#cart",
                    sx: theme.cta.icon
                })
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Paragraph */.nv, {
                sx: {
                    variant: "text.label.1",
                    fontSize: [
                        0,
                        null,
                        length > 2 ? 0 : 2
                    ],
                    ml: [
                        0,
                        null,
                        2
                    ],
                    userSelect: "none"
                },
                children: [
                    "(",
                    cartCount,
                    ")"
                ]
            })
        ]
    });
});
CtaCart.displayName = "CtaCart";

;// CONCATENATED MODULE: ./src/snippets/Header/Menu/Ctas/CtaWishlist.jsx






var CtaWishlist = Menu_theme_themed(function(_param) {
    var theme = _param.theme, inputRef = _param.inputRef, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme",
        "inputRef"
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Link, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-comp": CtaWishlist.displayName
    }, props), {
        href: "/pages/wishlist",
        "aria-label": "View wishlist",
        sx: (0,_object_spread/* default */.Z)({}, props.sx, theme.cta),
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Svg, {
            alt: "wishlist",
            viewBox: "0 0 48 48",
            src: "/svgs/cta/heart.svg#heart",
            sx: theme.cta.icon
        })
    }));
});
CtaWishlist.displayName = "CtaWishlist";

;// CONCATENATED MODULE: ./src/snippets/Header/Menu/Ctas/CtaRefer.jsx







var CtaRefer = Menu_theme_themed(function(_param) {
    var theme = _param.theme, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme"
    ]);
    var ref, ref1, ref2, ref3, ref4, ref5;
    var settings = (0,dist.useSettings)();
    var dtSettings = settings === null || settings === void 0 ? void 0 : (ref = settings.header) === null || ref === void 0 ? void 0 : (ref1 = ref.refer) === null || ref1 === void 0 ? void 0 : ref1.desktop;
    if (!(dtSettings === null || dtSettings === void 0 ? void 0 : dtSettings.enabled)) return null;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Link, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        "data-comp": CtaRefer.displayName,
        href: dtSettings === null || dtSettings === void 0 ? void 0 : (ref2 = dtSettings.link) === null || ref2 === void 0 ? void 0 : ref2.url,
        newTab: dtSettings === null || dtSettings === void 0 ? void 0 : (ref3 = dtSettings.link) === null || ref3 === void 0 ? void 0 : ref3.newTab,
        "aria-label": dtSettings === null || dtSettings === void 0 ? void 0 : (ref4 = dtSettings.link) === null || ref4 === void 0 ? void 0 : ref4.text,
        sx: (0,_object_spread/* default */.Z)({}, props.sx, theme.refer),
        children: dtSettings === null || dtSettings === void 0 ? void 0 : (ref5 = dtSettings.link) === null || ref5 === void 0 ? void 0 : ref5.text
    }));
});
CtaRefer.displayName = "CtaRefer";

;// CONCATENATED MODULE: ./src/snippets/Header/Menu/Ctas/Ctas.jsx








var Ctas = Menu_theme_themed(function(param) {
    var theme = param.theme;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
        sx: {
            height: "100%",
            alignItems: "center"
        },
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(CtaRefer, {
                sx: {
                    display: [
                        "none",
                        null,
                        "block"
                    ]
                }
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Grid */.rj, {
                "data-comp": Ctas.displayName,
                sx: theme.ctas,
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(CtaWishlist, {
                        sx: {
                            display: [
                                "none",
                                null,
                                "block"
                            ]
                        }
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(CtaSearch, {}),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(CtaAccount, {
                        sx: {
                            display: [
                                "none",
                                null,
                                "block"
                            ]
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(CtaCart, {})
        ]
    });
});
Ctas.displayName = "Ctas";

;// CONCATENATED MODULE: ./src/snippets/Header/Menu/Ctas/CtaMenu.jsx









var CtaMenu = Menu_theme_themed(function(_param) {
    var theme = _param.theme, inputRef = _param.inputRef, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme",
        "inputRef"
    ]);
    var ref = (0,_sliced_to_array/* default */.Z)(useMenuSidebar(), 2), menuSidebar = ref[0].menuSidebar, toggleSidebar = ref[1].toggleSidebar;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-comp": CtaMenu.displayName
    }, props), {
        variant: "buttons.plain",
        "aria-label": menuSidebar ? "Close menu" : "Open menu",
        onClick: toggleSidebar,
        sx: (0,_object_spread/* default */.Z)({}, props.sx, theme.cta),
        children: menuSidebar ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Svg, {
            alt: "Close menu",
            src: "/svgs/close.svg#close",
            sx: theme.cta.icon,
            viewBox: "0 0 48 48"
        }) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Svg, {
            alt: "Open menu",
            src: "/svgs/cta/menu.svg#menu",
            sx: theme.cta.icon,
            viewBox: "0 0 48 48"
        })
    }));
});
CtaMenu.displayName = "CtaMenu";

;// CONCATENATED MODULE: ./src/snippets/Header/Menu/Ctas/index.js






;// CONCATENATED MODULE: ./src/snippets/Header/Menu/Logo.jsx



var Logo = Menu_theme_themed(function(param) {
    var theme = param.theme;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Link, {
        href: "/",
        "aria-label": "Go to Brumate homepage",
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Svg, {
            role: "presentation",
            viewBox: "0 0 1588 375",
            src: "/svgs/brumate-logo.svg#brumate-logo",
            alt: "Brumate logo",
            sx: theme.logo
        })
    });
});

// EXTERNAL MODULE: ../node_modules/recoil/es/index.js
var es = __webpack_require__(69853);
;// CONCATENATED MODULE: ./src/snippets/Header/MenuDrawer/useMenuDrawer.js



 // todo expose on @backpackjs/storefront

var useMenuDrawer_DEBUG = true;
var useMenuDrawer = function() {
    var cb = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {}, data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var gotoSnapshot = (0,es.useGotoRecoilSnapshot)();
    var hovered = (0,store/* useRecoilValue */.sJ)(store/* default.hoveredItem */.ZP.hoveredItem);
    var menuDrawer = (0,store/* useRecoilValue */.sJ)(store/* default.menuDrawer */.ZP.menuDrawer);
    // on click, close the drawer and navigate to url
    var closeMenuDrawer = (0,store/* useRecoilCallback */._8)(function(param) {
        var snapshot = param.snapshot;
        return /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var release, updatedState;
            return (0,tslib_es6.__generator)(this, function(_state) {
                release = snapshot.retain();
                try {
                    updatedState = snapshot.map(function(param) {
                        var set = param.set;
                        set(store/* default.hoveredItem */.ZP.hoveredItem, null);
                        set(store/* default.menuDrawer */.ZP.menuDrawer, false);
                    });
                    // update state
                    gotoSnapshot(updatedState);
                } catch (error) {
                    console.log("closeMenuDrawer", error.message);
                    throw error;
                } finally{
                    release();
                }
                return [
                    2
                ];
            });
        });
    });
    // on link hover, clear a previous un-hover timer
    var clearUnHoverTimer = (0,react.useCallback)(function(id) {
        if (window.unHover) {
            clearTimeout(window.unHover);
            window.unHover = null;
        }
    }, []);
    var hoverDrawer = (0,react.useCallback)(function() {
        clearUnHoverTimer();
    }, []);
    var hoverItem = (0,store/* useRecoilCallback */._8)(function(param) {
        var snapshot = param.snapshot;
        return function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(hoveredItem) {
                var release, updatedState, _medias, medias, hoveredSubLinks, hoveredSubLinksCount;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    release = snapshot.retain();
                    try {
                        ;
                        if (hoveredItem) {
                            clearUnHoverTimer();
                            _medias = hoveredItem.medias, medias = _medias === void 0 ? [] : _medias;
                            hoveredSubLinks = medias.filter(Boolean);
                            hoveredSubLinksCount = hoveredSubLinks.length;
                            // if direct link close shell
                            if (!hoveredSubLinksCount) {
                                // console.log('direct link: closed drawer and setting hoverItem to', hoverItemData);
                                updatedState = snapshot.map(function(param) {
                                    var set = param.set;
                                    set(store/* default.hoveredItem */.ZP.hoveredItem, hoveredItem);
                                    set(store/* default.menuDrawer */.ZP.menuDrawer, false);
                                });
                            } else {
                                // console.log('nested link: opened drawer and setting hoverItem to', hoverItemData);
                                updatedState = snapshot.map(function(param) {
                                    var set = param.set;
                                    set(store/* default.hoveredItem */.ZP.hoveredItem, hoveredItem);
                                    set(store/* default.menuDrawer */.ZP.menuDrawer, true);
                                });
                            }
                        } else {
                            // console.log('no link: closed drawer and setting hoveredItem to', null)
                            updatedState = snapshot.map(function(param) {
                                var set = param.set;
                                set(store/* default.hoveredItem */.ZP.hoveredItem, hoveredItem);
                                set(store/* default.menuDrawer */.ZP.menuDrawer, false);
                            });
                        }
                        // update state
                        gotoSnapshot(updatedState);
                    } catch (error) {
                        console.log("hoverItem", error.message);
                        throw error;
                    } finally{
                        release();
                    }
                    return [
                        2
                    ];
                });
            });
            return function(hoveredItem) {
                return _ref.apply(this, arguments);
            };
        }();
    });
    var unHoverItem = (0,react.useCallback)(function() {
        // if we have a previous un-hover we clear it
        clearUnHoverTimer();
        // we set a new un-hover timer, that can be cancelled
        // by the mouseEnter o another link or the MenuDrawer enter
        window.unHover = setTimeout(function() {
            hoverItem(null); // closes the drawer
            clearUnHoverTimer();
        }, 100);
    // console.log('created timer: via unHoverItem', JSON.stringify(window.unHover))
    }, []);
    var unHoverDrawer = (0,store/* useRecoilCallback */._8)(function(param) {
        var snapshot = param.snapshot;
        return function() {
            var release = snapshot.retain();
            // we set a new un-hover timer, that can be cancelled by the mouseEnter
            window.unHover = setTimeout(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                var updatedState;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    // console.log('executing timer: unHoverDrawer after 500ms setting hoveredItem to null')
                    try {
                        updatedState = snapshot.map(function(param) {
                            var set = param.set;
                            set(store/* default.menuDrawer */.ZP.menuDrawer, false);
                            set(store/* default.hoveredItem */.ZP.hoveredItem, null);
                        });
                        gotoSnapshot(updatedState);
                        clearUnHoverTimer();
                    } catch (error) {
                        console.log("unHoverDrawer", error.message);
                        throw error;
                    } finally{
                        release();
                    }
                    return [
                        2
                    ];
                });
            }), 100);
        // console.log('created timer: via unHoverDrawer', JSON.stringify(window.unHover))
        };
    });
    return [
        // state
        {
            hovered: hovered,
            menuDrawer: menuDrawer
        },
        // actions
        {
            hoverItem: hoverItem,
            hoverDrawer: hoverDrawer,
            unHoverItem: unHoverItem,
            unHoverDrawer: unHoverDrawer,
            closeMenuDrawer: closeMenuDrawer
        }, 
    ];
};

;// CONCATENATED MODULE: ./src/snippets/Header/MenuDrawer/MenuDrawer.theme.js

var MenuDrawer_theme_themed = (0,create/* create */.U)(new function() {
    this.shell = {
        bg: "background",
        borderTopStyle: "solid",
        borderTopWidth: "1px",
        display: [
            "none",
            null,
            "block"
        ],
        left: 0,
        position: "absolute",
        top: "100%",
        width: "100%",
        zIndex: -1,
        // visibility: 'hidden',
        transition: "all 0.2s ease-in-out",
        closed: {
            borderTopColor: "transparent",
            boxShadow: "none",
            opacity: 0,
            pointerEvents: "none"
        },
        open: {
            borderTopColor: "lightGray",
            boxShadow: "bottom",
            // visibility: 'visible',
            opacity: 1,
            pointerEvents: "auto"
        }
    };
    this.drawer = {
        position: "relative",
        mx: "auto",
        bg: "background"
    };
    this.megaMenu = {
        variant: "layout.header",
        py: "32px",
        maxWidth: "1440px",
        mx: "auto"
    };
    this.grid = {
        pl: [
            0,
            null,
            null,
            "172px"
        ],
        pr: [
            0,
            null,
            null,
            "8px"
        ],
        gridTemplateColumns: "220px 1fr"
    };
}());

// EXTERNAL MODULE: ../node_modules/lodash/lodash.js
var lodash = __webpack_require__(98784);
;// CONCATENATED MODULE: ./src/snippets/Header/MenuDrawer/NavList/NavList.theme.js

var NavList_theme_themed = (0,create/* create */.U)(new function() {
    this.navList = {
        rowGap: 8,
        width: "225px"
    };
    this.linkHasMenu = {
        display: "inline",
        fontSize: 4,
        fontWeight: 500
    };
    this.link = {
        fontSize: 4,
        fontWeight: 400,
        position: "relative",
        display: "inline",
        pb: 1,
        backgroundImage: "linear-gradient(currentColor, currentColor)",
        backgroundPosition: "0% 100%",
        backgroundRepeat: "no-repeat",
        backgroundSize: "0% 1px",
        transition: "background-size 0.2s ease-in-out",
        ":hover, :focus": {
            backgroundSize: "100% 1px"
        }
    };
    this.arrowIcon = function(isActive) {
        return {
            position: "absolute",
            right: "35px",
            top: "calc(50% -  8px)",
            width: "16px",
            height: "16px",
            opacity: isActive ? "1" : "0.25"
        };
    };
}());

;// CONCATENATED MODULE: ./src/snippets/Header/MenuDrawer/NavList/NavList.jsx










var NavList = NavList_theme_themed(function(param) {
    var theme = param.theme, links = param.links, activeNavMenu = param.activeNavMenu, setActiveNavMenu = param.setActiveNavMenu;
    var ref = (0,_sliced_to_array/* default */.Z)(useMenuDrawer(), 2), ref1 = ref[0], ref1 = ref1 !== null ? ref1 : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined")), closeMenuDrawer = ref[1].closeMenuDrawer;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": NavList.displayName,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Grid */.rj, {
            sx: theme.navList,
            children: links === null || links === void 0 ? void 0 : links.map(function(item, index) {
                var link = item.link, textColor = item.color, tertiaryMenu = item.tertiaryMenu;
                var isActive = (0,lodash.isEqual)(item, activeNavMenu);
                return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                    sx: {
                        position: "relative"
                    },
                    onMouseEnter: function() {
                        if (tertiaryMenu) {
                            setActiveNavMenu(item);
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Link, {
                            href: link.url,
                            newTab: link.newTab,
                            "aria-label": link.text,
                            onClick: closeMenuDrawer,
                            sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tertiaryMenu ? theme.linkHasMenu : theme.link), {
                                color: textColor || "black"
                            }),
                            children: link.text
                        }),
                        tertiaryMenu && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Svg, {
                            viewBox: "0 0 16 16",
                            src: "/svgs/chevron/right.svg#right",
                            sx: theme.arrowIcon(isActive)
                        })
                    ]
                }, index);
            })
        })
    });
});
NavList.displayName = "NavList";

;// CONCATENATED MODULE: ./src/snippets/Header/MenuDrawer/NavList/index.js


;// CONCATENATED MODULE: ./src/snippets/Header/MenuDrawer/NavMenu/NavMenuLink.jsx







function NavMenuLink(param) {
    var theme = param.theme, item = param.item;
    var ref;
    var link = item.link;
    var ref1 = (0,_sliced_to_array/* default */.Z)(useMenuDrawer(), 2), closeMenuDrawer = ref1[1].closeMenuDrawer;
    var product = (0,dist.useProductByHandle)({
        handle: ((ref = item.product) === null || ref === void 0 ? void 0 : ref.handle) || "hopsulator-slim-gold-leopard-12oz-slim-cans"
    }).product;
    var firstImage = (0,react.useMemo)(function() {
        var ref, ref1;
        return (ref1 = product === null || product === void 0 ? void 0 : (ref = product.media) === null || ref === void 0 ? void 0 : ref.find(function(item) {
            return item.mediaContentType === "IMAGE";
        })) === null || ref1 === void 0 ? void 0 : ref1.image;
    }, [
        product === null || product === void 0 ? void 0 : product.id
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
        sx: theme.navMenuLink,
        "data-comp": NavMenuLink.displayName,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Picture, {
                alt: link === null || link === void 0 ? void 0 : link.text,
                images: [
                    {
                        src: firstImage === null || firstImage === void 0 ? void 0 : firstImage.originalSrc,
                        width: 64,
                        ratio: 1
                    }, 
                ],
                sx: theme.navMenuLinkImage
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Link, {
                href: link === null || link === void 0 ? void 0 : link.url,
                newTab: link === null || link === void 0 ? void 0 : link.newTab,
                "aria-label": link === null || link === void 0 ? void 0 : link.text,
                onClick: closeMenuDrawer,
                sx: theme.link,
                children: link === null || link === void 0 ? void 0 : link.text
            })
        ]
    });
}
NavMenuLink.displayName = "NavMenuLink";

;// CONCATENATED MODULE: ./src/snippets/Header/MenuDrawer/NavMenu/NavMenu.theme.js

var NavMenu_theme_themed = (0,create/* create */.U)(new function() {
    this.navMenu = {
        px: 14,
        pr: [
            0,
            null,
            null,
            14
        ],
        gridTemplateColumns: "275px 1fr",
        columnGap: 14
    };
    this.navMenuHeading = {
        fontSize: 3,
        fontWeight: 500
    };
    this.navMenuLink = {
        minHeight: "32px",
        display: "inline-flex",
        alignItems: "center"
    };
    this.navMenuLinkImage = {
        width: "32px",
        height: "32px",
        mr: 6
    };
    this.link = {
        fontSize: 3,
        position: "relative",
        display: "inline-flex",
        alignItems: "center",
        mt: 1,
        pb: 1,
        backgroundImage: "linear-gradient(currentColor, currentColor)",
        backgroundPosition: "0% 100%",
        backgroundRepeat: "no-repeat",
        backgroundSize: "0% 1px",
        transition: "background-size 0.2s ease-in-out",
        ":hover, :focus": {
            backgroundSize: "100% 1px"
        }
    };
    this.arrowIcon = {
        width: "14px",
        height: "14px",
        ml: 4
    };
}());

;// CONCATENATED MODULE: ./src/snippets/Header/MenuDrawer/NavMenu/NavMenuImage.jsx







function NavMenuImage(param) {
    var theme = param.theme, featuredImage = param.featuredImage;
    var ref = (0,_object_spread/* default */.Z)({}, featuredImage), image = ref.image, link = ref.link;
    var ref1 = (0,_sliced_to_array/* default */.Z)(useMenuDrawer(), 2), closeMenuDrawer = ref1[1].closeMenuDrawer;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": NavMenuImage.displayName,
        children: [
            (image === null || image === void 0 ? void 0 : image.src) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Link, {
                href: link === null || link === void 0 ? void 0 : link.url,
                newTab: link === null || link === void 0 ? void 0 : link.newTab,
                "aria-label": link === null || link === void 0 ? void 0 : link.text,
                onClick: closeMenuDrawer,
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Picture, {
                    alt: link === null || link === void 0 ? void 0 : link.text,
                    images: [
                        {
                            src: image.src,
                            width: 1160,
                            ratio: 1
                        }, 
                    ],
                    sx: {
                        width: "100%",
                        minHeight: "260px",
                        maxHeight: "260px",
                        maxWidth: "580px",
                        position: "relative"
                    }
                })
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Link, {
                href: link === null || link === void 0 ? void 0 : link.url,
                newTab: link === null || link === void 0 ? void 0 : link.newTab,
                "aria-label": link === null || link === void 0 ? void 0 : link.text,
                onClick: closeMenuDrawer,
                sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.link), {
                    fontSize: 4,
                    mt: 4
                }),
                children: link === null || link === void 0 ? void 0 : link.text
            })
        ]
    });
}
NavMenuImage.displayName = "NavMenuImage";

;// CONCATENATED MODULE: ./src/snippets/Header/MenuDrawer/NavMenu/NavMenu.jsx










var NavMenu = NavMenu_theme_themed(function(param) {
    var theme = param.theme, activeNavMenu = param.activeNavMenu, featuredImage = param.featuredImage;
    var ref = (0,_object_spread/* default */.Z)({}, activeNavMenu), link = ref.link, tertiaryMenu = ref.tertiaryMenu;
    var ref1 = (0,_sliced_to_array/* default */.Z)(useMenuDrawer(), 2), closeMenuDrawer = ref1[1].closeMenuDrawer;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": NavMenu.displayName,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Grid */.rj, {
            sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.navMenu), {
                borderLeft: function(t) {
                    return "1px solid ".concat(tertiaryMenu ? t.colors.gray : "transparent");
                }
            }),
            children: [
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                    variant: "flex.column",
                    sx: {
                        rowGap: "4px"
                    },
                    children: [
                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                            sx: theme.navMenuHeading,
                            children: link === null || link === void 0 ? void 0 : link.text
                        }),
                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                            variant: "flex.column",
                            sx: {
                                rowGap: "4px",
                                maxHeight: "305px",
                                overflowY: "auto"
                            },
                            children: tertiaryMenu === null || tertiaryMenu === void 0 ? void 0 : tertiaryMenu.map(function(item, index) {
                                return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(NavMenuLink, {
                                    theme: theme,
                                    item: item
                                }, index);
                            })
                        }),
                        tertiaryMenu && !(activeNavMenu === null || activeNavMenu === void 0 ? void 0 : activeNavMenu.hideShopAll) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                            variant: "flex.row.start.center",
                            sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.navMenuLink), {
                                mt: 4
                            }),
                            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(Link, {
                                href: link === null || link === void 0 ? void 0 : link.url,
                                newTab: link === null || link === void 0 ? void 0 : link.newTab,
                                "aria-label": link === null || link === void 0 ? void 0 : link.text,
                                onClick: closeMenuDrawer,
                                sx: theme.link,
                                children: [
                                    "Shop All ",
                                    link === null || link === void 0 ? void 0 : link.text,
                                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Svg, {
                                        viewBox: "0 0 16 16",
                                        src: "/svgs/chevron/right.svg#right",
                                        sx: theme.arrowIcon
                                    })
                                ]
                            })
                        })
                    ]
                }),
                featuredImage && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(NavMenuImage, {
                    featuredImage: featuredImage,
                    theme: theme
                })
            ]
        })
    });
});
NavMenu.displayName = "NavMenu";

;// CONCATENATED MODULE: ./src/snippets/Header/MenuDrawer/NavMenu/index.js


;// CONCATENATED MODULE: ./src/snippets/Header/MenuDrawer/MenuDrawer.jsx









var MenuDrawer = MenuDrawer_theme_themed(function(_param) {
    var theme = _param.theme, hovered = _param.hovered, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme",
        "hovered"
    ]);
    var secondaryMenu = (0,_object_spread/* default */.Z)({}, hovered).secondaryMenu;
    var ref = (0,react.useState)(null), activeNavMenu = ref[0], setActiveNavMenu = ref[1];
    (0,react.useEffect)(function() {
        var ref;
        if (secondaryMenu === null || secondaryMenu === void 0 ? void 0 : (ref = secondaryMenu[0]) === null || ref === void 0 ? void 0 : ref.tertiaryMenu) {
            setActiveNavMenu(secondaryMenu === null || secondaryMenu === void 0 ? void 0 : secondaryMenu[0]);
        } else {
            setActiveNavMenu(null);
        }
    }, [
        hovered
    ]);
    return secondaryMenu ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-comp": MenuDrawer.displayName
    }, props), {
        sx: theme.drawer,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
            sx: theme.megaMenu,
            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Grid */.rj, {
                sx: theme.grid,
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(NavList, {
                        links: secondaryMenu,
                        activeNavMenu: activeNavMenu,
                        setActiveNavMenu: setActiveNavMenu
                    }),
                    hovered && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(NavMenu, {
                        activeNavMenu: activeNavMenu,
                        featuredImage: hovered === null || hovered === void 0 ? void 0 : hovered.featuredImage
                    })
                ]
            })
        })
    })) : null;
});
MenuDrawer.displayName = "MenuDrawer";

;// CONCATENATED MODULE: ./src/snippets/Header/MenuDrawer/MenuDrawerShell.jsx








/**
 * Desktop menu drawer shell — hovered item sub items
 */ var MenuDrawerShell = MenuDrawer_theme_themed(function(param) {
    var theme = param.theme, props = param.props;
    var ref = (0,_sliced_to_array/* default */.Z)(useMenuDrawer(), 2), hovered = ref[0].hovered, ref1 = ref[1], unHoverDrawer = ref1.unHoverDrawer, hoverDrawer = ref1.hoverDrawer;
    return (hovered === null || hovered === void 0 ? void 0 : hovered.secondaryMenu) ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-comp": MenuDrawerShell.displayName,
        as: "aside"
    }, props), {
        onMouseEnter: hoverDrawer,
        onMouseLeave: unHoverDrawer,
        sx: (0,_object_spread/* default */.Z)({}, theme.shell, hovered ? theme.shell.open : theme.shell.closed),
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(MenuDrawer, {
            hovered: hovered
        })
    })) : null;
});
MenuDrawerShell.displayName = "MenuDrawerShell";

;// CONCATENATED MODULE: ./src/snippets/Header/MenuDrawer/index.js



;// CONCATENATED MODULE: ./src/snippets/Header/Menu/NavItem.jsx









var NavItem = Menu_theme_themed(function(_param) {
    var theme = _param.theme, item = _param.item, index = _param.index, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme",
        "item",
        "index"
    ]);
    var ref, ref1, ref2, ref3, ref4, ref5;
    var ref6 = (0,react.useRef)();
    var ref7 = (0,_sliced_to_array/* default */.Z)(useMenuDrawer(), 2), hovered = ref7[0].hovered, ref8 = ref7[1], hoverItem = ref8.hoverItem, unHoverItem = ref8.unHoverItem;
    var textColor = item === null || item === void 0 ? void 0 : item.color;
    var isHovered = (hovered === null || hovered === void 0 ? void 0 : (ref = hovered.link) === null || ref === void 0 ? void 0 : ref.text) === (item === null || item === void 0 ? void 0 : (ref1 = item.link) === null || ref1 === void 0 ? void 0 : ref1.text);
    return(// Level 1 Menu nav item
    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Link, {
        ref: ref6,
        "data-comp": NavItem.displayName,
        href: (ref2 = item.link) === null || ref2 === void 0 ? void 0 : ref2.url,
        newTab: (ref3 = item.link) === null || ref3 === void 0 ? void 0 : ref3.newTab,
        "aria-label": (ref4 = item.link) === null || ref4 === void 0 ? void 0 : ref4.text,
        onClick: unHoverItem,
        onMouseLeave: unHoverItem,
        onMouseEnter: function() {
            return hoverItem(item);
        },
        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.item), {
            color: textColor || "inherit",
            ":after": (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.item.underline), {
                transform: isHovered ? "scaleX(1)" : "scaleX(0)"
            })
        }),
        children: (ref5 = item.link) === null || ref5 === void 0 ? void 0 : ref5.text
    }));
});
NavItem.displayName = "NavItem";

;// CONCATENATED MODULE: ./src/snippets/Header/Menu/useMenu.js




/**
  A utility to sort the siteSettings.header.menu data structure
  to match what's required UX wise by MenuDrawer and MenuSideDrawer
* */ var useMenu = function() {
    var settings = (0,dist.useSettings)();
    var header = (0,_object_spread/* default */.Z)({}, settings).header;
    var menu = (header === null || header === void 0 ? void 0 : header.menu) || [];
    return (0,react.useMemo)(function() {
        var output = {
            desktop: {
                menu: []
            },
            mobile: {
                links: header === null || header === void 0 ? void 0 : header.links,
                bestSellers: header === null || header === void 0 ? void 0 : header.bestSellers,
                quickSelect: header === null || header === void 0 ? void 0 : header.quickSelect,
                menu: []
            }
        };
        if (!(menu === null || menu === void 0 ? void 0 : menu.length)) return output;
        output.desktop.menu = menu;
        /**
          mobile menu: sort links with sub links and those that don't have
        * */ output.mobile.menu = menu.map(function(item) {
            var ref;
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                accordion: !!(item === null || item === void 0 ? void 0 : (ref = item.medias) === null || ref === void 0 ? void 0 : ref.length)
            });
        });
        return output;
    }, [
        menu
    ]);
}; /**
  settings.header.menu format:

  const menu = [
    {
      link: {
        text: 'SHOP ALL',
        url: '/collections/shop-all',
      },
      links: [
        { category: 'By Category', link: { text: 'Supplements', url: '/collections/shop-cbd-supplements/' } },
        { category: 'By Category', link: { text: 'Bodycare', url: '/collections/shop-cbd-bodycare/' } },
        { category: 'By Category', link: { text: 'Skincare', url: '/collections/shop-skincare/' } },
        { category: 'By Category', link: { text: 'Gifts & Bundles', url: '/collections/shop-collections/' } },
        { category: 'By Category', link: { text: 'Tools & Accessories', url: '/collections/shop-tools/' } },
        // needs redirects
        { category: 'By Category', link: { text: 'Subscribe & Save', url: '/pages/subscription-and-save/' } },
        { category: 'By Category', link: { text: 'Gift Card', url: '/products/rise-ai-giftcard/' } },
        //
        { category: 'By Benefit', link: { text: 'Stress', url: '/collections/shop-stress/' } },
        { category: 'By Benefit', link: { text: 'Sleep', url: '/collections/shop-sleep/' } },
        { category: 'By Benefit', link: { text: 'Recovery', url: '/collections/shop-recovery/' } },
        { category: 'By Benefit', link: { text: 'Mood', url: '/collections/shop-mood/' } },
        { category: 'By Benefit', link: { text: 'Skin Health', url: '/collections/shop-skin-health/' } },
      ],
      medias: [
        { src: '/images/shopall_01.jpg', link: { text: '50% Off CBD Powders', url: '/pages/faq' }},
        { src: '/images/shopall_02.jpg', link: { text: 'Better Rewards', url: '/pages/sustainability' }},
      ]
    },
    {
      link: {
        text: 'Supplements',
        url: '/collections/shop-cbd-supplements/',
      },
      links: [
        { category: '', link: { text: 'All Supplements', url: '/collections/shop-cbd-supplements/'} },
        { category: '', link: { text: 'Stress', url: '/collections/shop-stress/' } },
        { category: '', link: { text: 'Sleep', url: '/collections/shop-sleep/' } },
        { category: '', link: { text: 'Recovery', url: '/collections/shop-recovery/' } },
        { category: '', link: { text: 'Mood', url: '/collections/shop-mood/' } },
      ],
      medias: [
        { src: '/images/shopall_01.jpg', link: { ext: '50% Off CBD Powders', url: '/pages/faq' }},
        { src: '/images/supplements.jpg',link: { text: 'How To Take CBD: What to Know', url: '/pages/sustainability' }},
      ]
    },
    { link: { text: 'Bodycare', url: '/collections/shop-cbd-bodycare/' } },
    { link: { text: 'Skincare', url: '/collections/shop-skincare/' } },
    // should chunk right on desktop
    { link: { text: 'Subscribe & Save', url: '/pages/subscription-and-save/' } },
    { link: { text: 'Earn Cash Back', url: '/pages/rewards/' } },
    {
      link: {
        text: 'About',
        url: '/pages/about-us',
      },
      links: [
        { category: 'about', link: { text: 'About Us', url: '/pages/about-us'} },
        { category: 'about', link: { text: 'Our Values', url: '/pages/our-values'} },
        { category: 'about', link: { text: 'Open Letter', url: '/pages/open-letter'} },
        { category: 'about', link: { text: 'FAQ', url: '/pages/faq'} },
        { category: 'standards', link: { text: 'The Prima Way', url: '/pages/prima-way' }},
        { category: 'standards', link: { text: 'Science', url: '/pages/science' }},
        { category: 'standards', link: { text: 'Source', url: '/pages/source' }},
        { category: 'standards', link: { text: 'Sustainability', url: '/pages/sustainability' }},
        { category: 'standards', link: { text: '100% Clean', url: '/pages/100-clean' }},
        { category: 'standards', link: { text: 'Testing & Transparency', url: '/pages/batch' }},
        { category: 'beyond', link: { text: 'Betterment', url: '/pages/betterment' }},
        { category: 'beyond', link: { text: 'Giving', url: '/pages/giving' }},
      ],
      medias: [
        { src: '/images/about_01.jpg', link: { text: 'Frequently asked questions', url: '/pages/faq' }},
        { src: '/images/about_02.jpg', link: { text: 'Sustainability', url: '/pages/sustainability' }},
      ]
    },
  ]
 */  /**
  is converted to the following UI format by useMenu

{
  "desktopMenu": {
    "left": [
        {
            "link": {
                "text": "SHOP ALL",
                "url": "/collections/shop-all"
            },
            "links": [
                [
                    {
                        "category": "By Category",
                        "link": {
                            "text": "Supplements",
                            "url": "/collections/shop-cbd-supplements/"
                        }
                    },
                    {
                        "category": "By Category",
                        "link": {
                            "text": "Bodycare",
                            "url": "/collections/shop-cbd-bodycare/"
                        }
                    },
                    ...
                ],
                [
                    {
                        "category": "By Benefit",
                        "link": {
                            "text": "Stress",
                            "url": "/collections/shop-stress/"
                        }
                    },
                    {
                        "category": "By Benefit",
                        "link": {
                            "text": "Sleep",
                            "url": "/collections/shop-sleep/"
                        }
                    },
                    ....
                ],
                {
                    "src": "/images/shopall_01.jpg",
                    "link": {
                        "text": "50% Off CBD Powders",
                        "url": "/pages/faq"
                    }
                },
                {
                    "src": "/images/shopall_02.jpg",
                    "link": {
                        "text": "Better Rewards",
                        "url": "/pages/sustainability"
                    }
                }
            ],
            "medias": [
                {
                    "src": "/images/shopall_01.jpg",
                    "link": {
                        "text": "50% Off CBD Powders",
                        "url": "/pages/faq"
                    }
                },
                {
                    "src": "/images/shopall_02.jpg",
                    "link": {
                        "text": "Better Rewards",
                        "url": "/pages/sustainability"
                    }
                }
            ]
        },
        {
            "link": {
                "text": "Supplements",
                "url": "/collections/shop-cbd-supplements/"
            },
            "links": [
                [
                    {
                        "category": "",
                        "link": {
                            "text": "All Supplements",
                            "url": "/collections/shop-cbd-supplements/"
                        }
                    },
                    {
                        "category": "",
                        "link": {
                            "text": "Stress",
                            "url": "/collections/shop-stress/"
                        }
                    },
                    ...
                ],
                {
                    "src": "/images/shopall_01.jpg",
                    "link": {
                        "text": "50% Off CBD Powders",
                        "url": "/pages/faq"
                    }
                },
                {
                    "src": "/images/supplements.jpg",
                    "link": {
                        "text": "How To Take CBD: What to Know",
                        "url": "/pages/sustainability"
                    }
                }
            ],
            "medias": [
                {
                    "src": "/images/shopall_01.jpg",
                    "link": {
                        "text": "50% Off CBD Powders",
                        "url": "/pages/faq"
                    }
                },
                {
                    "src": "/images/supplements.jpg",
                    "link": {
                        "text": "How To Take CBD: What to Know",
                        "url": "/pages/sustainability"
                    }
                }
            ]
        },
        {
            "link": {
                "text": "Bodycare",
                "url": "/collections/shop-cbd-bodycare/"
            }
        },
        {
            "link": {
                "text": "Skincare",
                "url": "/collections/shop-skincare/"
            }
        }
    ],
    "right": [
        {
            "link": {
                "text": "Subscribe & Save",
                "url": "/pages/subscription-and-save/"
            }
        },
        {
            "link": {
                "text": "Earn Cash Back",
                "url": "/pages/rewards/"
            }
        },
        {
            "link": {
                "text": "About",
                "url": "/pages/about-us"
            },
            "links": [
                [
                    {
                        "category": "about",
                        "link": {
                            "text": "About Us",
                            "url": "/pages/about-us"
                        }
                    },
                    {
                        "category": "about",
                        "link": {
                            "text": "Our Values",
                            "url": "/pages/our-values"
                        }
                    },
                    ...
                ],
                [
                    {
                        "category": "standards",
                        "link": {
                            "text": "The Prima Way",
                            "url": "/pages/prima-way"
                        }
                    },
                    {
                        "category": "standards",
                        "link": {
                            "text": "Science",
                            "url": "/pages/science"
                        }
                    },
                    ...
                ],
                [
                    {
                        "category": "beyond",
                        "link": {
                            "text": "Betterment",
                            "url": "/pages/betterment"
                        }
                    },
                    {
                        "category": "beyond",
                        "link": {
                            "text": "Giving",
                            "url": "/pages/giving"
                        }
                    }
                ],
                {
                    "src": "/images/about_01.jpg",
                    "link": {
                        "text": "Frequently asked questions",
                        "url": "/pages/faq"
                    }
                },
                {
                    "src": "/images/about_02.jpg",
                    "link": {
                        "text": "Sustainability",
                        "url": "/pages/sustainability"
                    }
                }
            ],
            "medias": [
                {
                    "src": "/images/about_01.jpg",
                    "link": {
                        "text": "Frequently asked questions",
                        "url": "/pages/faq"
                    }
                },
                {
                    "src": "/images/about_02.jpg",
                    "link": {
                        "text": "Sustainability",
                        "url": "/pages/sustainability"
                    }
                }
            ]
        }
    ]
},
"mobileMenu": {
    "nested": [
        {
            "link": {
                "text": "SHOP ALL",
                "url": "/collections/shop-all"
            },
            "links": [
                [
                    {
                        "category": "By Category",
                        "link": {
                            "text": "Supplements",
                            "url": "/collections/shop-cbd-supplements/"
                        }
                    },
                    {
                        "category": "By Category",
                        "link": {
                            "text": "Bodycare",
                            "url": "/collections/shop-cbd-bodycare/"
                        }
                    },
                    ...
                ],
                [
                    {
                        "category": "By Benefit",
                        "link": {
                            "text": "Stress",
                            "url": "/collections/shop-stress/"
                        }
                    },
                    {
                        "category": "By Benefit",
                        "link": {
                            "text": "Sleep",
                            "url": "/collections/shop-sleep/"
                        }
                    },
                    ...
                ],
                {
                    "src": "/images/shopall_01.jpg",
                    "link": {
                        "text": "50% Off CBD Powders",
                        "url": "/pages/faq"
                    }
                },
                {
                    "src": "/images/shopall_02.jpg",
                    "link": {
                        "text": "Better Rewards",
                        "url": "/pages/sustainability"
                    }
                }
            ],
            "medias": [
                {
                    "src": "/images/shopall_01.jpg",
                    "link": {
                        "text": "50% Off CBD Powders",
                        "url": "/pages/faq"
                    }
                },
                {
                    "src": "/images/shopall_02.jpg",
                    "link": {
                        "text": "Better Rewards",
                        "url": "/pages/sustainability"
                    }
                }
            ]
        },
        {
            "link": {
                "text": "Supplements",
                "url": "/collections/shop-cbd-supplements/"
            },
            "links": [
                [
                    {
                        "category": "",
                        "link": {
                            "text": "All Supplements",
                            "url": "/collections/shop-cbd-supplements/"
                        }
                    },
                    {
                        "category": "",
                        "link": {
                            "text": "Stress",
                            "url": "/collections/shop-stress/"
                        }
                    },
                    ...
                ],
                {
                    "src": "/images/shopall_01.jpg",
                    "link": {
                        "text": "50% Off CBD Powders",
                        "url": "/pages/faq"
                    }
                },
                {
                    "src": "/images/supplements.jpg",
                    "link": {
                        "text": "How To Take CBD: What to Know",
                        "url": "/pages/sustainability"
                    }
                }
            ],
            "medias": [
                {
                    "src": "/images/shopall_01.jpg",
                    "link": {
                        "text": "50% Off CBD Powders",
                        "url": "/pages/faq"
                    }
                },
                {
                    "src": "/images/supplements.jpg",
                    "link": {
                        "text": "How To Take CBD: What to Know",
                        "url": "/pages/sustainability"
                    }
                }
            ]
        },
        {
            "link": {
                "text": "About",
                "url": "/pages/about-us"
            },
            "links": [
                [
                    {
                        "category": "about",
                        "link": {
                            "text": "About Us",
                            "url": "/pages/about-us"
                        }
                    },
                    {
                        "category": "about",
                        "link": {
                            "text": "Our Values",
                            "url": "/pages/our-values"
                        }
                    },
                    ...
                ],
                [
                    {
                        "category": "standards",
                        "link": {
                            "text": "The Prima Way",
                            "url": "/pages/prima-way"
                        }
                    },
                    {
                        "category": "standards",
                        "link": {
                            "text": "Science",
                            "url": "/pages/science"
                        }
                    },
                    ...
                ],
                [
                    {
                        "category": "beyond",
                        "link": {
                            "text": "Betterment",
                            "url": "/pages/betterment"
                        }
                    },
                    {
                        "category": "beyond",
                        "link": {
                            "text": "Giving",
                            "url": "/pages/giving"
                        }
                    }
                ],
                {
                    "src": "/images/about_01.jpg",
                    "link": {
                        "text": "Frequently asked questions",
                        "url": "/pages/faq"
                    }
                },
                {
                    "src": "/images/about_02.jpg",
                    "link": {
                        "text": "Sustainability",
                        "url": "/pages/sustainability"
                    }
                }
            ],
            "medias": [
                {
                    "src": "/images/about_01.jpg",
                    "link": {
                        "text": "Frequently asked questions",
                        "url": "/pages/faq"
                    }
                },
                {
                    "src": "/images/about_02.jpg",
                    "link": {
                        "text": "Sustainability",
                        "url": "/pages/sustainability"
                    }
                }
            ]
        }
    ],
    "direct": [
        {
            "link": {
                "text": "Bodycare",
                "url": "/collections/shop-cbd-bodycare/"
            }
        },
        {
            "link": {
                "text": "Skincare",
                "url": "/collections/shop-skincare/"
            }
        },
        {
            "link": {
                "text": "Subscribe & Save",
                "url": "/pages/subscription-and-save/"
            }
        },
        {
            "link": {
                "text": "Earn Cash Back",
                "url": "/pages/rewards/"
            }
        }
    ]
  }
}
*/ 

;// CONCATENATED MODULE: ./src/snippets/Header/Menu/Nav.jsx





var Nav = Menu_theme_themed(function(param) {
    var theme = param.theme;
    var ref, ref1;
    var desktop = useMenu().desktop;
    if (!(desktop === null || desktop === void 0 ? void 0 : (ref = desktop.menu) === null || ref === void 0 ? void 0 : ref.length)) return null;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
        "data-comp": Nav.displayName,
        as: "nav",
        role: "navigation",
        "aria-label": "Main menu",
        sx: theme.nav,
        children: desktop === null || desktop === void 0 ? void 0 : (ref1 = desktop.menu) === null || ref1 === void 0 ? void 0 : ref1.map(function(item, index) {
            return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(NavItem, {
                item: item,
                index: index
            }, index);
        })
    });
});
Nav.displayName = "Nav";

;// CONCATENATED MODULE: ./src/snippets/Header/Menu/Menu.jsx







var Menu = Menu_theme_themed(function(_param) {
    var theme = _param.theme, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme"
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Container */.W2, {
        "data-comp": Menu.displayName,
        sx: theme.wrapper,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                sx: theme.toggle,
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(CtaMenu, {})
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                variant: "flex.row.center",
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Logo, {})
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Nav, {}),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Ctas, {})
        ]
    });
});
Menu.displayName = "Menu";

;// CONCATENATED MODULE: ./src/snippets/Header/Menu/index.js


;// CONCATENATED MODULE: ./src/snippets/Header/Header.theme.js



var Header_Header_theme_themed = (0,create/* create */.U)(new function() {
    this.inProduction = {
        alignItems: "center",
        bg: "background",
        color: "text",
        flexDirection: "column",
        height: "auto",
        position: "sticky",
        width: "100%",
        top: 0,
        zIndex: 30
    };
    // on customizer mode, we push the header under the customizer toolbar
    this.inCustomizer = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this.inProduction), {
        top: "var(--backpack-toolbar-height)"
    });
}());

;// CONCATENATED MODULE: ./src/snippets/Header/Header.jsx











var Header_Header_Header = Header_Header_theme_themed(function(param) {
    var theme = param.theme;
    var isPreview = (0,dist.useRouter)().isPreview;
    var headerRef = (0,react.useRef)(null);
    var isInitialized = (0,webbridge_react_es/* useVariables */.OQ)().isInitialized;
    // Sets --header-height CSS var
    (0,hooks/* useSetHeaderHeightCssVar */.cy)({
        headerRef: headerRef
    });
    if (isInitialized) return null;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_jsx_runtime_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(PromoBar, {}),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Container */.W2, {
                "data-comp": Header_Header_Header.displayName,
                as: "header",
                ref: headerRef,
                sx: isPreview ? theme.inCustomizer : theme.inProduction,
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Menu, {}),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(MenuSidebarShell, {}),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(MenuDrawerShell, {})
                ]
            })
        ]
    });
});
Header_Header_Header.displayName = "Header";

;// CONCATENATED MODULE: ./src/snippets/Header/index.js


// EXTERNAL MODULE: ../node_modules/next/link.js
var next_link = __webpack_require__(79894);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/snippets/Link/Link.jsx








var Link = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var _href = _param.href, href = _href === void 0 ? "" : _href, _newTab = _param.newTab, newTab = _newTab === void 0 ? false : _newTab, _hiddenForSeo = _param.hiddenForSeo, hiddenForSeo = _hiddenForSeo === void 0 ? false : _hiddenForSeo, _prefetch = _param.prefetch, prefetch = _prefetch === void 0 ? false : _prefetch, children = _param.children, query = _param.query, sx = _param.sx, props = (0,_object_without_properties/* default */.Z)(_param, [
        "href",
        "newTab",
        "hiddenForSeo",
        "prefetch",
        "children",
        "query",
        "sx"
    ]);
    return hiddenForSeo ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Link */.rU, {
        "data-comp": "Link-Hidden",
        href: href,
        ref: ref,
        sx: {
            display: "none"
        }
    }) : href ? newTab ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Link */.rU, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-comp": "Link-External",
        href: href,
        ref: ref,
        target: "_blank",
        sx: (0,_object_spread/* default */.Z)({
            display: "block"
        }, sx)
    }, props), {
        children: children
    })) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)((link_default()), {
        href: typeof query === "object" ? {
            pathname: href,
            query: query
        } : href,
        prefetch: prefetch,
        passHref: true,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Link */.rU, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            "data-comp": "Link-Internal",
            ref: ref,
            sx: (0,_object_spread/* default */.Z)({
                display: "block"
            }, sx)
        }, props), {
            children: children
        }))
    }) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-comp": "Link-NoHref",
        ref: ref,
        sx: (0,_object_spread/* default */.Z)({
            cursor: "default"
        }, sx)
    }, props), {
        children: children
    }));
});
Link.propTypes = {
    href: (prop_types_default()).string,
    newTab: (prop_types_default()).bool,
    hiddenForSeo: (prop_types_default()).bool,
    prefetch: (prop_types_default()).bool,
    children: prop_types_default().oneOfType([
        (prop_types_default()).string,
        (prop_types_default()).node
    ]),
    query: (prop_types_default()).object,
    sx: (prop_types_default()).object
};

;// CONCATENATED MODULE: ./src/snippets/Link/index.js


;// CONCATENATED MODULE: ./src/snippets/Locale/formatAmountItem.js


var formatAmount = function(param) {
    var _amount = param.amount, amount = _amount === void 0 ? 0 : _amount, _currency = param.currency, currency = _currency === void 0 ? "USD" : _currency;
    if (amount !== 0 && !amount) return null;
    var total = typeof amount === "string" ? amount : amount.toFixed(2);
    var locale;
    if (currency === "EUR") {
        locale = "".concat(total.replaceAll(".", ","), " €");
    } else if (currency === "GBP") {
        locale = "\xa3".concat(total);
    } else {
        locale = "$".concat(total);
    }
    return locale;
};
var formatAmountItem = function(item, qty) {
    var discountAmount = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    if (!item) return null;
    var total = Math.round((item.amount - discountAmount) * 100) / 100;
    var currency = item.currencyCode;
    return qty ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
        amount: total / qty,
        localeTotal: formatAmount({
            amount: total,
            currency: currency
        }),
        locale: formatAmount({
            amount: total / qty,
            currency: currency
        })
    }) : (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
        amount: total,
        locale: formatAmount({
            amount: total,
            currency: currency
        })
    });
};

;// CONCATENATED MODULE: ./src/snippets/Locale/Locale.Product.jsx








// Target is product item
// TODO: add sellingPlan info
function LocaleProduct(_param) {
    var product = _param.product, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "product",
        "children"
    ]);
    if (!product) {
        return null;
    }
    var _ref = (0,dist.useLocalizedProduct)({
        product: product
    }), localized = _ref.localized, localeStatus = (0,_object_without_properties/* default */.Z)(_ref, [
        "localized"
    ]);
    // TODO: can I make this DRY: useLocaleComponents ??
    var Components = (0,react.useMemo)(function() {
        var PriceComp = null;
        var LoaderComp = null;
        var ErrorComp = null;
        react.Children.forEach(children, function(child) {
            var ref, ref1, ref2;
            var displayName = (child === null || child === void 0 ? void 0 : (ref = child.props) === null || ref === void 0 ? void 0 : (ref1 = ref.__EMOTION_TYPE_PLEASE_DO_NOT_USE__) === null || ref1 === void 0 ? void 0 : ref1.displayName) || (child === null || child === void 0 ? void 0 : (ref2 = child.type) === null || ref2 === void 0 ? void 0 : ref2.displayName);
            switch(displayName){
                case "Locale.Price":
                    var ref3, ref4, ref5, ref6, ref7, ref8, ref9;
                    var isVariablePrice = (localized === null || localized === void 0 ? void 0 : (ref3 = localized.priceRange) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.minVariantPrice) === null || ref4 === void 0 ? void 0 : ref4.amount) < (localized === null || localized === void 0 ? void 0 : (ref5 = localized.priceRange) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.maxVariantPrice) === null || ref6 === void 0 ? void 0 : ref6.amount);
                    var isOnSale = localized === null || localized === void 0 ? void 0 : (ref7 = localized.variants) === null || ref7 === void 0 ? void 0 : ref7.find(function(variant) {
                        return variant.compareAtPrice;
                    });
                    var priceProps = localized ? (0,_object_spread/* default */.Z)({
                        key: "Locale.Price",
                        minVariantPrice: formatAmountItem(localized === null || localized === void 0 ? void 0 : (ref8 = localized.priceRange) === null || ref8 === void 0 ? void 0 : ref8.minVariantPrice),
                        maxVariantPrice: formatAmountItem(localized === null || localized === void 0 ? void 0 : (ref9 = localized.priceRange) === null || ref9 === void 0 ? void 0 : ref9.maxVariantPrice),
                        isVariablePrice: isVariablePrice,
                        isOnSale: isOnSale,
                        locale: localized.locale
                    }, child.props) : null;
                    PriceComp = localized ? /*#__PURE__*/ (0,react.cloneElement)(child, priceProps) : null;
                    break;
                case "Locale.Error":
                    var ref10;
                    ErrorComp = (localeStatus === null || localeStatus === void 0 ? void 0 : (ref10 = localeStatus.errors) === null || ref10 === void 0 ? void 0 : ref10.length) ? /*#__PURE__*/ (0,react.cloneElement)(child, (0,_object_spread/* default */.Z)({
                        key: "Locale.Error",
                        errors: localeStatus.errors
                    }, child.props)) : null;
                    break;
                case "Locale.Loader":
                    var ref11;
                    LoaderComp = !(localeStatus === null || localeStatus === void 0 ? void 0 : localeStatus.finished) && !localized && !(localeStatus === null || localeStatus === void 0 ? void 0 : (ref11 = localeStatus.errors) === null || ref11 === void 0 ? void 0 : ref11.length) ? /*#__PURE__*/ (0,react.cloneElement)(child, (0,_object_spread/* default */.Z)({
                        key: "Locale.Loader"
                    }, localeStatus, child.props)) : null;
                    break;
                default:
                    break;
            }
        });
        // active components
        return [
            PriceComp,
            LoaderComp,
            ErrorComp
        ].filter(Boolean);
    }, [
        localeStatus === null || localeStatus === void 0 ? void 0 : localeStatus.started,
        localeStatus === null || localeStatus === void 0 ? void 0 : localeStatus.finished,
        localized
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-comp": LocaleProduct.displayName
    }, props), {
        sx: (0,_object_spread/* default */.Z)({}, props.sx),
        children: Components.map(function(Component) {
            return Component;
        })
    }));
}
LocaleProduct.displayName = "Locale.Product";

;// CONCATENATED MODULE: ./src/snippets/Locale/Locale.Variant.jsx








function LocaleVariant(_param) {
    var variantFakeColorOption = _param.variant, selectedPlan = _param.selectedPlan, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "variant",
        "selectedPlan",
        "children"
    ]);
    var ref, ref1;
    if (!variantFakeColorOption) {
        return null;
    }
    // the color option is added via a custom transform and is not a real shopify product option
    // here we remove it so that we can find the variant's price
    var variant = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, variantFakeColorOption), {
        selectedOptions: variantFakeColorOption.selectedOptions.filter(function(param) {
            var name = param.name;
            return name !== "color";
        })
    });
    var _ref = (0,dist.useLocalizedVariant)({
        variant: variant
    }), localized = _ref.localized, localeStatus = (0,_object_without_properties/* default */.Z)(_ref, [
        "localized"
    ]);
    var Components = (0,react.useMemo)(function() {
        var PriceComp = null;
        var LoaderComp = null;
        var ErrorComp = null;
        react.Children.forEach(children, function(child) {
            var ref, ref1, ref2;
            var displayName = (child === null || child === void 0 ? void 0 : (ref = child.props) === null || ref === void 0 ? void 0 : (ref1 = ref.__EMOTION_TYPE_PLEASE_DO_NOT_USE__) === null || ref1 === void 0 ? void 0 : ref1.displayName) || (child === null || child === void 0 ? void 0 : (ref2 = child.type) === null || ref2 === void 0 ? void 0 : ref2.displayName);
            // console.log('LocaleVariant:', localized, selectedPlan)
            switch(displayName){
                case "Locale.Price":
                    {
                        var ref3, ref4, ref5, ref6, ref7, ref8, ref9;
                        var hasSubscription = (localized === null || localized === void 0 ? void 0 : (ref3 = localized.sellingPlanAllocations) === null || ref3 === void 0 ? void 0 : ref3.length) > 0;
                        var isSubscribing = hasSubscription && selectedPlan && typeof selectedPlan === "object";
                        var oneTimeSale = parseFloat(localized === null || localized === void 0 ? void 0 : (ref4 = localized.compareAtPriceV2) === null || ref4 === void 0 ? void 0 : ref4.amount) > parseFloat(localized === null || localized === void 0 ? void 0 : (ref5 = localized.priceV2) === null || ref5 === void 0 ? void 0 : ref5.amount);
                        var subscriptionSale = isSubscribing ? selectedPlan === null || selectedPlan === void 0 ? void 0 : (ref6 = selectedPlan.priceAdjustments) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[0]) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.adjustmentValue) === null || ref8 === void 0 ? void 0 : ref8.adjustmentPercentage : false;
                        var isOnSale = oneTimeSale || subscriptionSale || false;
                        var priceProps = localized ? (0,_object_spread/* default */.Z)({
                            key: "Locale.Price",
                            priceV2: formatAmountItem(localized.priceV2),
                            unitPrice: localized.unitPrice,
                            compareAtPriceV2: formatAmountItem(localized.compareAtPriceV2),
                            sellingPlanAllocations: localized.sellingPlanAllocations,
                            sellingPlans: (localized === null || localized === void 0 ? void 0 : localized.sellingPlans) || null,
                            sellingPlan: (localized === null || localized === void 0 ? void 0 : (ref9 = localized.sellingPlans) === null || ref9 === void 0 ? void 0 : ref9[selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.id]) || null,
                            locale: localized.locale,
                            isOnSale: isOnSale,
                            hasSubscription: hasSubscription,
                            isSubscribing: isSubscribing
                        }, child.props) : null;
                        PriceComp = priceProps ? /*#__PURE__*/ (0,react.cloneElement)(child, priceProps) : null; // return null while localized is being fetched..
                        break;
                    }
                case "Locale.Error":
                    var ref10;
                    ErrorComp = (localeStatus === null || localeStatus === void 0 ? void 0 : (ref10 = localeStatus.errors) === null || ref10 === void 0 ? void 0 : ref10.length) ? /*#__PURE__*/ (0,react.cloneElement)(child, (0,_object_spread/* default */.Z)({
                        key: "Locale.Error",
                        errors: localeStatus.errors
                    }, child.props)) : null;
                    break;
                case "Locale.Loader":
                    var ref11;
                    LoaderComp = !(localeStatus === null || localeStatus === void 0 ? void 0 : localeStatus.finished) && !localized && !(localeStatus === null || localeStatus === void 0 ? void 0 : (ref11 = localeStatus.errors) === null || ref11 === void 0 ? void 0 : ref11.length) ? /*#__PURE__*/ (0,react.cloneElement)(child, (0,_object_spread/* default */.Z)({
                        key: "Locale.Loader"
                    }, localeStatus, child.props)) : null;
                    break;
                default:
                    break;
            }
        });
        // active components
        return [
            PriceComp,
            LoaderComp,
            ErrorComp
        ].filter(Boolean);
    }, [
        localeStatus === null || localeStatus === void 0 ? void 0 : localeStatus.started,
        localeStatus === null || localeStatus === void 0 ? void 0 : localeStatus.finished,
        localized,
        selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.id,
        localized === null || localized === void 0 ? void 0 : (ref = localized.compareAtPriceV2) === null || ref === void 0 ? void 0 : ref.amount,
        localized === null || localized === void 0 ? void 0 : (ref1 = localized.sellingPlanAllocations) === null || ref1 === void 0 ? void 0 : ref1.length, 
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-comp": LocaleVariant.displayName
    }, props), {
        sx: (0,_object_spread/* default */.Z)({}, props.sx),
        children: Components.map(function(Component) {
            return Component;
        })
    }));
}
LocaleVariant.displayName = "Locale.Variant";

;// CONCATENATED MODULE: ./src/snippets/Locale/Locale.CartLine.jsx








function LocaleCartLine(_param) {
    var line = _param.line, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "line",
        "children"
    ]);
    var ref, ref1;
    if (!line) {
        return null;
    }
    var localized = (0,dist.useLocalizedCartLine)({
        line: (0,_object_spread/* default */.Z)({}, line)
    }).localized;
    var Components = (0,react.useMemo)(function() {
        var PriceComp = null;
        var LoaderComp = null;
        var ErrorComp = null;
        react.Children.forEach(children, function(child) {
            var ref, ref1, ref2;
            var displayName = (child === null || child === void 0 ? void 0 : (ref = child.props) === null || ref === void 0 ? void 0 : (ref1 = ref.__EMOTION_TYPE_PLEASE_DO_NOT_USE__) === null || ref1 === void 0 ? void 0 : ref1.displayName) || (child === null || child === void 0 ? void 0 : (ref2 = child.type) === null || ref2 === void 0 ? void 0 : ref2.displayName);
            switch(displayName){
                case "Locale.Price":
                    {
                        var ref3, ref4, ref5, ref6, ref7, ref8, ref9;
                        var quantity = localized === null || localized === void 0 ? void 0 : localized.quantity;
                        var discountAmount = formatAmountItem(localized === null || localized === void 0 ? void 0 : (ref3 = localized.estimatedCost) === null || ref3 === void 0 ? void 0 : ref3.discountAmount, quantity);
                        var savingsAmount = formatAmountItem(localized === null || localized === void 0 ? void 0 : (ref4 = localized.estimatedCost) === null || ref4 === void 0 ? void 0 : ref4.savingsAmount, quantity);
                        var isOnSale = (savingsAmount === null || savingsAmount === void 0 ? void 0 : savingsAmount.amount) > 0 || false;
                        var isSubscription = (localized === null || localized === void 0 ? void 0 : localized.sellingPlanAllocation) !== null;
                        var isDiscounted = (discountAmount === null || discountAmount === void 0 ? void 0 : discountAmount.amount) > 0;
                        PriceComp = localized ? /*#__PURE__*/ (0,react.cloneElement)(child, (0,_object_spread/* default */.Z)({
                            key: "Locale.Price",
                            estimatedCost: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, localized.estimatedCost), {
                                totalAmount: formatAmountItem(localized === null || localized === void 0 ? void 0 : (ref5 = localized.estimatedCost) === null || ref5 === void 0 ? void 0 : ref5.totalAmount, quantity),
                                compareAtPriceAmount: formatAmountItem((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, localized === null || localized === void 0 ? void 0 : (ref6 = localized.estimatedCost) === null || ref6 === void 0 ? void 0 : ref6.compareAtPriceAmount), {
                                    amount: localized === null || localized === void 0 ? void 0 : (ref7 = localized.estimatedCost) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.compareAtPriceAmount) === null || ref8 === void 0 ? void 0 : ref8.amountTotal
                                }), quantity),
                                // hotfix to display correct prices after returing from cart
                                // to prevent tax and shipping calculated into subtotalAmount
                                // As a result, subtotalAmount should include discounts
                                subtotalAmount: formatAmountItem(localized === null || localized === void 0 ? void 0 : (ref9 = localized.estimatedCost) === null || ref9 === void 0 ? void 0 : ref9.subtotalAmount, quantity, discountAmount === null || discountAmount === void 0 ? void 0 : discountAmount.amount),
                                discountAmount: discountAmount,
                                savingsAmount: savingsAmount
                            }),
                            discountAllocations: localized === null || localized === void 0 ? void 0 : localized.discountAllocations,
                            sellingPlanAllocation: isSubscription ? localized.sellingPlanAllocation : null,
                            locale: localized.locale,
                            isOnSale: isOnSale,
                            isSubscription: isSubscription,
                            isDiscounted: isDiscounted
                        }, child.props)) : null;
                        break;
                    }
                case "Locale.Error":
                    ErrorComp = null;
                    break;
                case "Locale.Loader":
                    LoaderComp = null;
                    break;
                default:
                    break;
            }
        });
        // active components
        return [
            PriceComp,
            LoaderComp,
            ErrorComp
        ].filter(Boolean);
    }, [
        localized === null || localized === void 0 ? void 0 : (ref = localized.estimatedCost) === null || ref === void 0 ? void 0 : ref.subtotalAmount,
        localized === null || localized === void 0 ? void 0 : localized.sellingPlanAllocation,
        localized === null || localized === void 0 ? void 0 : (ref1 = localized.discountAllocations) === null || ref1 === void 0 ? void 0 : ref1.length, 
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-comp": LocaleCartLine.displayName
    }, props), {
        sx: (0,_object_spread/* default */.Z)({}, props.sx),
        children: Components.map(function(Component) {
            return Component;
        })
    }));
}
LocaleCartLine.displayName = "Locale.CartLine";

;// CONCATENATED MODULE: ./src/snippets/Locale/Locale.CartTotals.jsx









function LocaleCartTotals(_param) {
    var cart = _param.cart, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "cart",
        "children"
    ]);
    var ref, ref1, ref2;
    if (!cart) {
        return null;
    }
    var localized = (0,dist.useLocalizedCartTotals)({
        cart: (0,_object_spread/* default */.Z)({}, cart)
    }).localized;
    var cartDiscountAmount = (0,store/* useRecoilValue */.sJ)(store/* default.cartDiscountAmount */.ZP.cartDiscountAmount);
    var Components = (0,react.useMemo)(function() {
        var PriceComp = null;
        var LoaderComp = null;
        var ErrorComp = null;
        react.Children.forEach(children, function(child) {
            var ref, ref1, ref2;
            var displayName = (child === null || child === void 0 ? void 0 : (ref = child.props) === null || ref === void 0 ? void 0 : (ref1 = ref.__EMOTION_TYPE_PLEASE_DO_NOT_USE__) === null || ref1 === void 0 ? void 0 : ref1.displayName) || (child === null || child === void 0 ? void 0 : (ref2 = child.type) === null || ref2 === void 0 ? void 0 : ref2.displayName);
            switch(displayName){
                case "Locale.Price":
                    {
                        var ref3, ref4;
                        var estimatedCost = localized === null || localized === void 0 ? void 0 : localized.estimatedCost;
                        var isDiscounted = (estimatedCost === null || estimatedCost === void 0 ? void 0 : (ref3 = estimatedCost.discountAmount) === null || ref3 === void 0 ? void 0 : ref3.amount) > 0 || false;
                        var isOnSale = (estimatedCost === null || estimatedCost === void 0 ? void 0 : (ref4 = estimatedCost.totalSavingsAmount) === null || ref4 === void 0 ? void 0 : ref4.amount) > 0 || false;
                        PriceComp = localized ? /*#__PURE__*/ (0,react.cloneElement)(child, (0,_object_spread/* default */.Z)({
                            key: "Locale.Price",
                            estimatedCost: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, estimatedCost), {
                                discountAmount: formatAmountItem(estimatedCost === null || estimatedCost === void 0 ? void 0 : estimatedCost.discountAmount),
                                // hotfix to display correct prices after returing from cart
                                // to prevent tax and shipping calculated into subtotalAmount
                                // As a result, subtotalAmount should include discounts
                                subtotalAmount: formatAmountItem(estimatedCost === null || estimatedCost === void 0 ? void 0 : estimatedCost.subtotalAmount, undefined, cartDiscountAmount),
                                totalAmount: formatAmountItem(estimatedCost === null || estimatedCost === void 0 ? void 0 : estimatedCost.totalAmount),
                                totalCompareAtAmount: formatAmountItem(estimatedCost === null || estimatedCost === void 0 ? void 0 : estimatedCost.totalCompareAtAmount),
                                totalDiscountAmount: formatAmountItem(estimatedCost === null || estimatedCost === void 0 ? void 0 : estimatedCost.totalDiscountAmount),
                                totalSavingsAmount: formatAmountItem(estimatedCost === null || estimatedCost === void 0 ? void 0 : estimatedCost.totalSavingsAmount),
                                totalDutyAmount: formatAmountItem(estimatedCost === null || estimatedCost === void 0 ? void 0 : estimatedCost.totalDutyAmount),
                                totalTaxAmount: formatAmountItem(estimatedCost === null || estimatedCost === void 0 ? void 0 : estimatedCost.totalTaxAmount)
                            }),
                            discountAllocations: localized === null || localized === void 0 ? void 0 : localized.discountAllocations,
                            locale: localized.locale,
                            isDiscounted: isDiscounted,
                            isOnSale: isOnSale
                        }, child.props)) : null;
                        break;
                    }
                case "Locale.Error":
                    ErrorComp = null;
                    break;
                case "Locale.Loader":
                    LoaderComp = null;
                    break;
                default:
                    break;
            }
        });
        // active components
        return [
            PriceComp,
            LoaderComp,
            ErrorComp
        ].filter(Boolean);
    }, [
        localized === null || localized === void 0 ? void 0 : (ref = localized.estimatedCost) === null || ref === void 0 ? void 0 : (ref1 = ref.subtotalAmount) === null || ref1 === void 0 ? void 0 : ref1.amount,
        localized === null || localized === void 0 ? void 0 : (ref2 = localized.discountAllocations) === null || ref2 === void 0 ? void 0 : ref2.length,
        cartDiscountAmount, 
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-comp": LocaleCartTotals.displayName
    }, props), {
        sx: (0,_object_spread/* default */.Z)({}, props.sx),
        children: Components.map(function(Component) {
            return Component;
        })
    }));
}
LocaleCartTotals.displayName = "Locale.CartTotals";

;// CONCATENATED MODULE: ./src/snippets/Locale/Locale.OrderLine.jsx








function LocaleOrderLine(_param) {
    var line = _param.line, currencyCode = _param.currencyCode, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "line",
        "currencyCode",
        "children"
    ]);
    var ref, ref1, ref2;
    if (!line || !(line === null || line === void 0 ? void 0 : line.variant)) return null;
    // TODO:: variant doesn't exist if product isn't added to Pack App Sales channel.
    // We should show a blank line item with original price that's still available in line object
    // to improve UX
    var localized = (0,dist.useLocalizedOrderLine)({
        line: (0,_object_spread/* default */.Z)({}, line),
        currencyCode: currencyCode
    }).localized;
    var Components = (0,react.useMemo)(function() {
        var PriceComp = null;
        var LoaderComp = null;
        var ErrorComp = null;
        react.Children.forEach(children, function(child) {
            var ref, ref1, ref2;
            var displayName = (child === null || child === void 0 ? void 0 : (ref = child.props) === null || ref === void 0 ? void 0 : (ref1 = ref.__EMOTION_TYPE_PLEASE_DO_NOT_USE__) === null || ref1 === void 0 ? void 0 : ref1.displayName) || (child === null || child === void 0 ? void 0 : (ref2 = child.type) === null || ref2 === void 0 ? void 0 : ref2.displayName);
            switch(displayName){
                case "Locale.Price":
                    {
                        var ref3, ref4;
                        // TODO: validate if this hold when we have subscriptions to test
                        var isSubscription = !!(localized === null || localized === void 0 ? void 0 : localized.sellingPlanAllocation);
                        var discountAmount = formatAmountItem(localized === null || localized === void 0 ? void 0 : (ref3 = localized.discountAllocations) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : ref4.allocatedAmount);
                        var isDiscounted = (discountAmount === null || discountAmount === void 0 ? void 0 : discountAmount.amount) > 0;
                        PriceComp = localized ? /*#__PURE__*/ (0,react.cloneElement)(child, (0,_object_spread/* default */.Z)({
                            key: "Locale.Price",
                            originalTotalPrice: formatAmountItem(localized === null || localized === void 0 ? void 0 : localized.originalTotalPrice),
                            discountAmount: discountAmount,
                            discountedTotalPrice: formatAmountItem(localized === null || localized === void 0 ? void 0 : localized.discountedTotalPrice),
                            locale: localized.locale,
                            isSubscription: isSubscription,
                            isDiscounted: isDiscounted
                        }, child.props)) : null;
                        break;
                    }
                case "Locale.Error":
                    ErrorComp = null;
                    break;
                case "Locale.Loader":
                    LoaderComp = null;
                    break;
                default:
                    break;
            }
        });
        // active components
        return [
            PriceComp,
            LoaderComp,
            ErrorComp
        ].filter(Boolean);
    }, [
        localized === null || localized === void 0 ? void 0 : (ref = localized.originalTotalPrice) === null || ref === void 0 ? void 0 : ref.amount,
        localized === null || localized === void 0 ? void 0 : (ref1 = localized.discountAmount) === null || ref1 === void 0 ? void 0 : ref1.amount,
        localized === null || localized === void 0 ? void 0 : (ref2 = localized.discountedTotalPrice) === null || ref2 === void 0 ? void 0 : ref2.amount, 
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-comp": LocaleOrderLine.displayName
    }, props), {
        sx: (0,_object_spread/* default */.Z)({}, props.sx),
        children: Components.map(function(Component) {
            return Component;
        })
    }));
}
LocaleOrderLine.displayName = "Locale.OrderLine";

;// CONCATENATED MODULE: ./src/snippets/Locale/Locale.OrderTotals.jsx








function LocaleOrderTotals(_param) {
    var order = _param.order, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "order",
        "children"
    ]);
    try {
        var ref, ref1;
        if (!order) return null;
        var localized = (0,dist.useLocalizedOrderTotals)({
            order: (0,_object_spread/* default */.Z)({}, order)
        }).localized;
        var Components = (0,react.useMemo)(function() {
            var PriceComp = null;
            var LoaderComp = null;
            var ErrorComp = null;
            react.Children.forEach(children, function(child) {
                var ref, ref1, ref2;
                var displayName = (child === null || child === void 0 ? void 0 : (ref = child.props) === null || ref === void 0 ? void 0 : (ref1 = ref.__EMOTION_TYPE_PLEASE_DO_NOT_USE__) === null || ref1 === void 0 ? void 0 : ref1.displayName) || (child === null || child === void 0 ? void 0 : (ref2 = child.type) === null || ref2 === void 0 ? void 0 : ref2.displayName);
                switch(displayName){
                    case "Locale.Price":
                        {
                            PriceComp = localized ? /*#__PURE__*/ (0,react.cloneElement)(child, (0,_object_spread/* default */.Z)({
                                key: "Locale.Price",
                                currentTotalTax: formatAmountItem(localized.currentTotalTax),
                                currentTotalDuties: formatAmountItem(localized.currentTotalDuties),
                                currentSubtotalPrice: formatAmountItem(localized.currentSubtotalPrice),
                                totalPriceV2: formatAmountItem(localized.totalPriceV2),
                                subtotalPriceV2: formatAmountItem(localized.subtotalPriceV2),
                                totalRefundedV2: formatAmountItem(localized.totalRefundedV2),
                                totalShippingPriceV2: formatAmountItem(localized.totalShippingPriceV2),
                                totalTaxV2: formatAmountItem(localized.totalTaxV2),
                                locale: localized.locale
                            }, child.props)) : null;
                            break;
                        }
                    case "Locale.Error":
                        ErrorComp = null;
                        break;
                    case "Locale.Loader":
                        LoaderComp = null;
                        break;
                    default:
                        break;
                }
            });
            // active components
            return [
                PriceComp,
                LoaderComp,
                ErrorComp
            ].filter(Boolean);
        }, [
            localized === null || localized === void 0 ? void 0 : (ref = localized.totalPriceV2) === null || ref === void 0 ? void 0 : ref.amount,
            localized === null || localized === void 0 ? void 0 : (ref1 = localized.subtotalPriceV2) === null || ref1 === void 0 ? void 0 : ref1.amount
        ]);
        return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            "data-comp": LocaleOrderTotals.displayName
        }, props), {
            sx: (0,_object_spread/* default */.Z)({}, props.sx),
            children: Components.map(function(Component) {
                return Component;
            })
        }));
    } catch (error) {
        return null;
    }
}
LocaleOrderTotals.displayName = "Locale.OrderTotals";

;// CONCATENATED MODULE: ./src/snippets/Locale/Locale.jsx








var Locale = function(param) {
    var children = param.children;
    var locale = (0,dist.useLocale)();
    return children({
        locale: locale
    });
};
// shard sub components
Locale.Loader = function(param) {
    var children = param.children;
    return children;
};
Locale.Loader.displayName = "Locale.Loader";
Locale.Error = function(param) {
    var children = param.children;
    return children;
};
Locale.Error.displayName = "Locale.Error";
var _tmp;
_tmp = function(_param) {
    var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return children(props);
}, Locale.Price = _tmp, _tmp;
Locale.Price.displayName = "Locale.Price";
// locale components
Locale.Product = LocaleProduct;
Locale.Variant = LocaleVariant;
Locale.OrderLine = LocaleOrderLine;
Locale.OrderTotals = LocaleOrderTotals;
Locale.CartLine = LocaleCartLine;
Locale.CartTotals = LocaleCartTotals;

;// CONCATENATED MODULE: ./src/snippets/Locale/index.js







;// CONCATENATED MODULE: ../node_modules/markdown-to-jsx/dist/index.modern.js
function t(){return t=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},t.apply(this,arguments)}const n=["children","options"],r={blockQuote:"0",breakLine:"1",breakThematic:"2",codeBlock:"3",codeFenced:"4",codeInline:"5",footnote:"6",footnoteReference:"7",gfmTask:"8",heading:"9",headingSetext:"10",htmlBlock:"11",htmlComment:"12",htmlSelfClosing:"13",image:"14",link:"15",linkAngleBraceStyleDetector:"16",linkBareUrlDetector:"17",linkMailtoDetector:"18",newlineCoalescer:"19",orderedList:"20",paragraph:"21",ref:"22",refImage:"23",refLink:"24",table:"25",tableSeparator:"26",text:"27",textBolded:"28",textEmphasized:"29",textEscaped:"30",textMarked:"31",textStrikethroughed:"32",unorderedList:"33"};var i;!function(e){e[e.MAX=0]="MAX",e[e.HIGH=1]="HIGH",e[e.MED=2]="MED",e[e.LOW=3]="LOW",e[e.MIN=4]="MIN"}(i||(i={}));const l=["allowFullScreen","allowTransparency","autoComplete","autoFocus","autoPlay","cellPadding","cellSpacing","charSet","className","classId","colSpan","contentEditable","contextMenu","crossOrigin","encType","formAction","formEncType","formMethod","formNoValidate","formTarget","frameBorder","hrefLang","inputMode","keyParams","keyType","marginHeight","marginWidth","maxLength","mediaGroup","minLength","noValidate","radioGroup","readOnly","rowSpan","spellCheck","srcDoc","srcLang","srcSet","tabIndex","useMap"].reduce((e,t)=>(e[t.toLowerCase()]=t,e),{for:"htmlFor"}),a={amp:"&",apos:"'",gt:">",lt:"<",nbsp:" ",quot:"“"},o=["style","script"],c=/([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi,s=/mailto:/i,d=/\n{2,}$/,u=/^(\s*>[\s\S]*?)(?=\n{2,})/,p=/^ *> ?/gm,f=/^ {2,}\n/,h=/^(?:( *[-*_])){3,} *(?:\n *)+\n/,m=/^\s*(`{3,}|~{3,}) *(\S+)?([^\n]*?)?\n([\s\S]+?)\s*\1 *(?:\n *)*\n?/,g=/^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/,y=/^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/,k=/^(?:\n *)*\n/,x=/\r\n?/g,b=/^\[\^([^\]]+)](:(.*)((\n+ {4,}.*)|(\n(?!\[\^).+))*)/,v=/^\[\^([^\]]+)]/,S=/\f/g,E=/^---[ \t]*\n(.|\n)*\n---[ \t]*\n/,$=/^\s*?\[(x|\s)\]/,w=/^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/,C=/^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/,z=/^([^\n]+)\n *(=|-){3,} *(?:\n *)+\n/,L=/^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?((?:[^>]*[^/])?)>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1\b)[\s\S])*?)<\/\1>(?!<\/\1>)\n*/i,A=/&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi,T=/^<!--[\s\S]*?(?:-->)/,O=/^(data|aria|x)-[a-z_][a-z\d_.-]*$/,B=/^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i,M=/^\{.*\}$/,R=/^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/,I=/^<([^ >]+@[^ >]+)>/,U=/^<([^ >]+:\/[^ >]+)>/,D=/-([a-z])?/gi,j=/^(.*\|.*)\n(?: *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*))?\n?/,N=/^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/,H=/^!\[([^\]]*)\] ?\[([^\]]*)\]/,F=/^\[([^\]]*)\] ?\[([^\]]*)\]/,P=/(\[|\])/g,index_modern_=/(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/,W=/\t/g,G=/(^ *\||\| *$)/g,Z=/^ *:-+: *$/,q=/^ *:-+ *$/,Q=/^ *-+: *$/,V="((?:\\[.*?\\][([].*?[)\\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~~.*?~~|==.*?==|.|\\n)*?)",X=new RegExp(`^([*_])\\1${V}\\1\\1(?!\\1)`),J=new RegExp(`^([*_])${V}\\1(?!\\1|\\w)`),K=new RegExp(`^==${V}==`),Y=new RegExp(`^~~${V}~~`),ee=/^\\([^0-9A-Za-z\s])/,te=/^[\s\S]+?(?=[^0-9A-Z\s\u00c0-\uffff&#;.()'"]|\d+\.|\n\n| {2,}\n|\w+:\S|$)/i,ne=/^\n+/,re=/^([ \t]*)/,ie=/\\([^\\])/g,le=/ *\n+$/,ae=/(?:^|\n)( *)$/,oe="(?:\\d+\\.)",ce="(?:[*+-])";function se(e){return"( *)("+(1===e?oe:ce)+") +"}const de=se(1),ue=se(2);function pe(e){return new RegExp("^"+(1===e?de:ue))}const fe=pe(1),he=pe(2);function me(e){return new RegExp("^"+(1===e?de:ue)+"[^\\n]*(?:\\n(?!\\1"+(1===e?oe:ce)+" )[^\\n]*)*(\\n|$)","gm")}const ge=me(1),ye=me(2);function ke(e){const t=1===e?oe:ce;return new RegExp("^( *)("+t+") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1"+t+" (?!"+t+" ))\\n*|\\s*\\n*$)")}const xe=ke(1),be=ke(2);function ve(e,t){const n=1===t,i=n?xe:be,l=n?ge:ye,a=n?fe:he;return{match(e,t,n){const r=ae.exec(n);return r&&(t.list||!t.inline&&!t.simple)?i.exec(e=r[1]+e):null},order:1,parse(e,t,r){const i=n?+e[2]:void 0,o=e[0].replace(d,"\n").match(l);let c=!1;return{items:o.map(function(e,n){const i=a.exec(e)[0].length,l=new RegExp("^ {1,"+i+"}","gm"),s=e.replace(l,"").replace(a,""),d=n===o.length-1,u=-1!==s.indexOf("\n\n")||d&&c;c=u;const p=r.inline,f=r.list;let h;r.list=!0,u?(r.inline=!1,h=s.replace(le,"\n\n")):(r.inline=!0,h=s.replace(le,""));const m=t(h,r);return r.inline=p,r.list=f,m}),ordered:n,start:i}},render:(t,n,i)=>e(t.ordered?"ol":"ul",{key:i.key,start:t.type===r.orderedList?t.start:void 0},t.items.map(function(t,r){return e("li",{key:r},n(t,i))}))}}const Se=new RegExp("^\\[((?:\\[[^\\]]*\\]|[^\\[\\]]|\\](?=[^\\[]*\\]))*)\\]\\(\\s*<?((?:\\([^)]*\\)|[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*\\)"),Ee=/^!\[(.*?)\]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/,$e=[u,m,g,w,z,C,T,j,ge,xe,ye,be],we=[...$e,/^[^\n]+(?:  \n|\n{2,})/,L,B];function Ce(e){return e.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g,"a").replace(/[çÇ]/g,"c").replace(/[ðÐ]/g,"d").replace(/[ÈÉÊËéèêë]/g,"e").replace(/[ÏïÎîÍíÌì]/g,"i").replace(/[Ññ]/g,"n").replace(/[øØœŒÕõÔôÓóÒò]/g,"o").replace(/[ÜüÛûÚúÙù]/g,"u").replace(/[ŸÿÝý]/g,"y").replace(/[^a-z0-9- ]/gi,"").replace(/ /gi,"-").toLowerCase()}function ze(e){return Q.test(e)?"right":Z.test(e)?"center":q.test(e)?"left":null}function Le(e,t,n,i){const l=n.inTable;n.inTable=!0;let a=e.trim().split(/( *(?:`[^`]*`|<.*?>.*?<\/.*?>(?!<\/.*?>)|\\\||\|) *)/).reduce((e,l)=>("|"===l.trim()?e.push(i?{type:r.tableSeparator}:{type:r.text,text:l}):""!==l&&e.push.apply(e,t(l,n)),e),[]);n.inTable=l;let o=[[]];return a.forEach(function(e,t){e.type===r.tableSeparator?0!==t&&t!==a.length-1&&o.push([]):(e.type!==r.text||null!=a[t+1]&&a[t+1].type!==r.tableSeparator||(e.text=e.text.trimEnd()),o[o.length-1].push(e))}),o}function Ae(e,t,n){n.inline=!0;const i=e[2]?e[2].replace(G,"").split("|").map(ze):[],l=e[3]?function(e,t,n){return e.trim().split("\n").map(function(e){return Le(e,t,n,!0)})}(e[3],t,n):[],a=Le(e[1],t,n,!!l.length);return n.inline=!1,l.length?{align:i,cells:l,header:a,type:r.table}:{children:a,type:r.paragraph}}function Te(e,t){return null==e.align[t]?{}:{textAlign:e.align[t]}}function Oe(e){return function(t,n){return n.inline?e.exec(t):null}}function Be(e){return function(t,n){return n.inline||n.simple?e.exec(t):null}}function Me(e){return function(t,n){return n.inline||n.simple?null:e.exec(t)}}function Re(e){return function(t){return e.exec(t)}}function Ie(e,t,n){if(t.inline||t.simple)return null;if(n&&!n.endsWith("\n"))return null;let r="";e.split("\n").every(e=>!$e.some(t=>t.test(e))&&(r+=e+"\n",e.trim()));const i=r.trimEnd();return""==i?null:[r,i]}function Ue(e){try{if(decodeURIComponent(e).replace(/[^A-Za-z0-9/:]/g,"").match(/^\s*(javascript|vbscript|data(?!:image)):/i))return null}catch(e){return null}return e}function De(e){return e.replace(ie,"$1")}function je(e,t,n){const r=n.inline||!1,i=n.simple||!1;n.inline=!0,n.simple=!0;const l=e(t,n);return n.inline=r,n.simple=i,l}function Ne(e,t,n){const r=n.inline||!1,i=n.simple||!1;n.inline=!1,n.simple=!0;const l=e(t,n);return n.inline=r,n.simple=i,l}function He(e,t,n){const r=n.inline||!1;n.inline=!1;const i=e(t,n);return n.inline=r,i}const Fe=(e,t,n)=>({children:je(t,e[1],n)});function Pe(){return{}}function _e(){return null}function We(...e){return e.filter(Boolean).join(" ")}function Ge(e,t,n){let r=e;const i=t.split(".");for(;i.length&&(r=r[i[0]],void 0!==r);)i.shift();return r||n}function Ze(n="",i={}){function d(e,n,...r){const l=Ge(i.overrides,`${e}.props`,{});return i.createElement(function(e,t){const n=Ge(t,e);return n?"function"==typeof n||"object"==typeof n&&"render"in n?n:Ge(t,`${e}.component`,e):e}(e,i.overrides),t({},n,l,{className:We(null==n?void 0:n.className,l.className)||void 0}),...r)}function G(t){t=t.replace(E,"");let n=!1;i.forceInline?n=!0:i.forceBlock||(n=!1===index_modern_.test(t));const r=le(ie(n?t:`${t.trimEnd().replace(ne,"")}\n\n`,{inline:n}));for(;"string"==typeof r[r.length-1]&&!r[r.length-1].trim();)r.pop();if(null===i.wrapper)return r;const l=i.wrapper||(n?"span":"div");let a;if(r.length>1||i.forceWrapper)a=r;else{if(1===r.length)return a=r[0],"string"==typeof a?d("span",{key:"outer"},a):a;a=null}return react.createElement(l,{key:"outer"},a)}function Z(t,n){const r=n.match(c);return r?r.reduce(function(n,r,a){const o=r.indexOf("=");if(-1!==o){const c=function(e){return-1!==e.indexOf("-")&&null===e.match(O)&&(e=e.replace(D,function(e,t){return t.toUpperCase()})),e}(r.slice(0,o)).trim(),s=function(e){const t=e[0];return('"'===t||"'"===t)&&e.length>=2&&e[e.length-1]===t?e.slice(1,-1):e}(r.slice(o+1).trim()),d=l[c]||c,u=n[d]=function(e,t,n,r){return"style"===t?n.split(/;\s?/).reduce(function(e,t){const n=t.slice(0,t.indexOf(":"));return e[n.trim().replace(/(-[a-z])/g,e=>e[1].toUpperCase())]=t.slice(n.length+1).trim(),e},{}):"href"===t||"src"===t?r(n,e,t):(n.match(M)&&(n=n.slice(1,n.length-1)),"true"===n||"false"!==n&&n)}(t,c,s,i.sanitizer);"string"==typeof u&&(L.test(u)||B.test(u))&&(n[d]=react.cloneElement(G(u.trim()),{key:a}))}else"style"!==r&&(n[l[r]||r]=!0);return n},{}):null}i.overrides=i.overrides||{},i.sanitizer=i.sanitizer||Ue,i.slugify=i.slugify||Ce,i.namedCodesToUnicode=i.namedCodesToUnicode?t({},a,i.namedCodesToUnicode):a,i.createElement=i.createElement||react.createElement;const q=[],Q={},V={[r.blockQuote]:{match:Me(u),order:1,parse:(e,t,n)=>({children:t(e[0].replace(p,""),n)}),render:(e,t,n)=>d("blockquote",{key:n.key},t(e.children,n))},[r.breakLine]:{match:Re(f),order:1,parse:Pe,render:(e,t,n)=>d("br",{key:n.key})},[r.breakThematic]:{match:Me(h),order:1,parse:Pe,render:(e,t,n)=>d("hr",{key:n.key})},[r.codeBlock]:{match:Me(g),order:0,parse:e=>({lang:void 0,text:e[0].replace(/^ {4}/gm,"").replace(/\n+$/,"")}),render:(e,n,r)=>d("pre",{key:r.key},d("code",t({},e.attrs,{className:e.lang?`lang-${e.lang}`:""}),e.text))},[r.codeFenced]:{match:Me(m),order:0,parse:e=>({attrs:Z("code",e[3]||""),lang:e[2]||void 0,text:e[4],type:r.codeBlock})},[r.codeInline]:{match:Be(y),order:3,parse:e=>({text:e[2]}),render:(e,t,n)=>d("code",{key:n.key},e.text)},[r.footnote]:{match:Me(b),order:0,parse:e=>(q.push({footnote:e[2],identifier:e[1]}),{}),render:_e},[r.footnoteReference]:{match:Oe(v),order:1,parse:e=>({target:`#${i.slugify(e[1],Ce)}`,text:e[1]}),render:(e,t,n)=>d("a",{key:n.key,href:i.sanitizer(e.target,"a","href")},d("sup",{key:n.key},e.text))},[r.gfmTask]:{match:Oe($),order:1,parse:e=>({completed:"x"===e[1].toLowerCase()}),render:(e,t,n)=>d("input",{checked:e.completed,key:n.key,readOnly:!0,type:"checkbox"})},[r.heading]:{match:Me(i.enforceAtxHeadings?C:w),order:1,parse:(e,t,n)=>({children:je(t,e[2],n),id:i.slugify(e[2],Ce),level:e[1].length}),render:(e,t,n)=>d(`h${e.level}`,{id:e.id,key:n.key},t(e.children,n))},[r.headingSetext]:{match:Me(z),order:0,parse:(e,t,n)=>({children:je(t,e[1],n),level:"="===e[2]?1:2,type:r.heading})},[r.htmlBlock]:{match:Re(L),order:1,parse(e,t,n){const[,r]=e[3].match(re),i=new RegExp(`^${r}`,"gm"),l=e[3].replace(i,""),a=(c=l,we.some(e=>e.test(c))?He:je);var c;const s=e[1].toLowerCase(),d=-1!==o.indexOf(s),u=(d?s:e[1]).trim(),p={attrs:Z(u,e[2]),noInnerParse:d,tag:u};return n.inAnchor=n.inAnchor||"a"===s,d?p.text=e[3]:p.children=a(t,l,n),n.inAnchor=!1,p},render:(e,n,r)=>d(e.tag,t({key:r.key},e.attrs),e.text||n(e.children,r))},[r.htmlSelfClosing]:{match:Re(B),order:1,parse(e){const t=e[1].trim();return{attrs:Z(t,e[2]||""),tag:t}},render:(e,n,r)=>d(e.tag,t({},e.attrs,{key:r.key}))},[r.htmlComment]:{match:Re(T),order:1,parse:()=>({}),render:_e},[r.image]:{match:Be(Ee),order:1,parse:e=>({alt:e[1],target:De(e[2]),title:e[3]}),render:(e,t,n)=>d("img",{key:n.key,alt:e.alt||void 0,title:e.title||void 0,src:i.sanitizer(e.target,"img","src")})},[r.link]:{match:Oe(Se),order:3,parse:(e,t,n)=>({children:Ne(t,e[1],n),target:De(e[2]),title:e[3]}),render:(e,t,n)=>d("a",{key:n.key,href:i.sanitizer(e.target,"a","href"),title:e.title},t(e.children,n))},[r.linkAngleBraceStyleDetector]:{match:Oe(U),order:0,parse:e=>({children:[{text:e[1],type:r.text}],target:e[1],type:r.link})},[r.linkBareUrlDetector]:{match:(e,t)=>t.inAnchor?null:Oe(R)(e,t),order:0,parse:e=>({children:[{text:e[1],type:r.text}],target:e[1],title:void 0,type:r.link})},[r.linkMailtoDetector]:{match:Oe(I),order:0,parse(e){let t=e[1],n=e[1];return s.test(n)||(n="mailto:"+n),{children:[{text:t.replace("mailto:",""),type:r.text}],target:n,type:r.link}}},[r.orderedList]:ve(d,1),[r.unorderedList]:ve(d,2),[r.newlineCoalescer]:{match:Me(k),order:3,parse:Pe,render:()=>"\n"},[r.paragraph]:{match:Ie,order:3,parse:Fe,render:(e,t,n)=>d("p",{key:n.key},t(e.children,n))},[r.ref]:{match:Oe(N),order:0,parse:e=>(Q[e[1]]={target:e[2],title:e[4]},{}),render:_e},[r.refImage]:{match:Be(H),order:0,parse:e=>({alt:e[1]||void 0,ref:e[2]}),render:(e,t,n)=>Q[e.ref]?d("img",{key:n.key,alt:e.alt,src:i.sanitizer(Q[e.ref].target,"img","src"),title:Q[e.ref].title}):null},[r.refLink]:{match:Oe(F),order:0,parse:(e,t,n)=>({children:t(e[1],n),fallbackChildren:t(e[0].replace(P,"\\$1"),n),ref:e[2]}),render:(e,t,n)=>Q[e.ref]?d("a",{key:n.key,href:i.sanitizer(Q[e.ref].target,"a","href"),title:Q[e.ref].title},t(e.children,n)):d("span",{key:n.key},t(e.fallbackChildren,n))},[r.table]:{match:Me(j),order:1,parse:Ae,render(e,t,n){const r=e;return d("table",{key:n.key},d("thead",null,d("tr",null,r.header.map(function(e,i){return d("th",{key:i,style:Te(r,i)},t(e,n))}))),d("tbody",null,r.cells.map(function(e,i){return d("tr",{key:i},e.map(function(e,i){return d("td",{key:i,style:Te(r,i)},t(e,n))}))})))}},[r.text]:{match:Re(te),order:4,parse:e=>({text:e[0].replace(A,(e,t)=>i.namedCodesToUnicode[t]?i.namedCodesToUnicode[t]:e)}),render:e=>e.text},[r.textBolded]:{match:Be(X),order:2,parse:(e,t,n)=>({children:t(e[2],n)}),render:(e,t,n)=>d("strong",{key:n.key},t(e.children,n))},[r.textEmphasized]:{match:Be(J),order:3,parse:(e,t,n)=>({children:t(e[2],n)}),render:(e,t,n)=>d("em",{key:n.key},t(e.children,n))},[r.textEscaped]:{match:Be(ee),order:1,parse:e=>({text:e[1],type:r.text})},[r.textMarked]:{match:Be(K),order:3,parse:Fe,render:(e,t,n)=>d("mark",{key:n.key},t(e.children,n))},[r.textStrikethroughed]:{match:Be(Y),order:3,parse:Fe,render:(e,t,n)=>d("del",{key:n.key},t(e.children,n))}};!0===i.disableParsingRawHTML&&(delete V[r.htmlBlock],delete V[r.htmlSelfClosing]);const ie=function(e){let t=Object.keys(e);function n(r,i){let l=[],a="";for(;r;){let o=0;for(;o<t.length;){const c=t[o],s=e[c],d=s.match(r,i,a);if(d){const e=d[0];r=r.substring(e.length);const t=s.parse(d,n,i);null==t.type&&(t.type=c),l.push(t),a=e;break}o++}}return l}return t.sort(function(t,n){let r=e[t].order,i=e[n].order;return r!==i?r-i:t<n?-1:1}),function(e,t){return n(function(e){return e.replace(x,"\n").replace(S,"").replace(W,"    ")}(e),t)}}(V),le=(ae=function(e,t){return function(n,r,i){const l=e[n.type].render;return t?t(()=>l(n,r,i),n,r,i):l(n,r,i)}}(V,i.renderRule),function e(t,n={}){if(Array.isArray(t)){const r=n.key,i=[];let l=!1;for(let r=0;r<t.length;r++){n.key=r;const a=e(t[r],n),o="string"==typeof a;o&&l?i[i.length-1]+=a:null!==a&&i.push(a),l=o}return n.key=r,i}return ae(t,e,n)});var ae;const oe=G(n);return q.length?d("div",null,oe,d("footer",{key:"footer"},q.map(function(e){return d("div",{id:i.slugify(e.identifier,Ce),key:e.identifier},e.identifier,le(ie(e.footnote,{inline:!0})))}))):oe}/* harmony default export */ var index_modern = (t=>{let{children:r="",options:i}=t,l=function(e,t){if(null==e)return{};var n,r,i={},l=Object.keys(e);for(r=0;r<l.length;r++)t.indexOf(n=l[r])>=0||(i[n]=e[n]);return i}(t,n);return react.cloneElement(Ze(r,i),l)});
//# sourceMappingURL=index.modern.js.map

;// CONCATENATED MODULE: ./src/snippets/Markdown/Markdown.theme.js

var Markdown_theme_themed = (0,create/* create */.U)(new function() {
    this.markdown = {
        table: {
            width: "100%"
        },
        thead: {
            backgroundColor: "lightgrey"
        },
        "th, td": {
            py: "5px"
        },
        "tr:nth-of-type(even)": {
            backgroundColor: "#f5f5f5"
        },
        p: {
            mb: 8,
            fontFamily: "body"
        },
        "ul, ol": {
            mb: 8,
            pl: 13
        },
        ul: {
            li: {
                listStyleType: "disc"
            }
        },
        ol: {
            li: {
                listStyleType: "decimal"
            }
        },
        li: {
            p: {
                display: "inline"
            },
            mb: 4,
            listStylePosition: "inside",
            textIndent: "-22px",
            fontFamily: "body"
        },
        a: {
            textDecoration: "underline",
            fontFamily: "body"
        },
        h1: {
            variant: "text.h1",
            mb: 11
        },
        h2: {
            variant: "text.h2",
            mt: 11,
            mb: 10
        },
        h3: {
            variant: "text.h3",
            mt: [
                9,
                null,
                11
            ],
            mb: 9
        },
        h4: {
            variant: "text.h4",
            mb: 9
        },
        h5: {
            variant: "text.h5",
            mb: 9
        },
        h6: {
            variant: "text.h6",
            mb: 9
        },
        "span, del": {
            textDecorationColor: "currentColor"
        },
        strong: {
            fontWeight: "700 !important"
        },
        ".markdown-modal": {
            textDecoration: "underline",
            fontFamily: "body",
            cursor: "pointer"
        }
    };
}());

;// CONCATENATED MODULE: ./src/snippets/Markdown/Markdown.jsx













var Markdown_textHtmlTags = "p, h1, h2, h3, h4, h5, h6, span, label, div, strong, em, blockquote, pre, code, i, b, ul, ol, li, modal";
var Markdown = Markdown_theme_themed(function(_param) {
    var theme = _param.theme, inputRef = _param.inputRef, text = _param.text, children = _param.children, sx = _param.sx, textSx = _param.textSx, textAlign = _param.textAlign, setIsLoaded = _param.setIsLoaded, overrides = _param.overrides, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme",
        "inputRef",
        "text",
        "children",
        "sx",
        "textSx",
        "textAlign",
        "setIsLoaded",
        "overrides"
    ]);
    var passedText = typeof children === "string" ? children : text || "";
    var markdownText = (0,react.useMemo)(function() {
        return passedText === null || passedText === void 0 ? void 0 : passedText.replaceAll("<modal", '<Modal className="markdown-modal"').replaceAll("</modal", "</Modal").replace(/\(modal\s(.*?)\)(.*?)\(\/modal\)/gi, '<Modal className="markdown-modal" $1>$2</Modal>').replace(/\(readmore(\s|.*?)\)(.*?)\(\/readmore\)/gi, '<Readmore className="read-more underline" $1>Read More</Readmore><span className="read-more-text hidden">$2</span>');
    }, [
        passedText
    ]);
    var ref = (0,_sliced_to_array/* default */.Z)((0,hooks/* useModal */.dd)(), 2), modal = ref[0].modal, ref1 = ref[1], openModal = ref1.openModal, closeModal = ref1.closeModal;
    var toggleModal = (0,react.useCallback)(function(e) {
        var ref, ref1, ref2, ref3;
        var passedId = (e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.id) !== "" ? e === null || e === void 0 ? void 0 : (ref1 = e.target) === null || ref1 === void 0 ? void 0 : ref1.id : e === null || e === void 0 ? void 0 : (ref2 = e.target) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.parentElement) === null || ref3 === void 0 ? void 0 : ref3.id;
        if (modal) {
            closeModal();
            return;
        }
        openModal(/*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(HalfMedia, {
            passedId: passedId
        }));
    }, [
        modal,
        HalfMedia
    ]);
    var toggleReadMore = (0,react.useCallback)(function(e) {
        var ref;
        e.preventDefault();
        var moreText = e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.parentElement.querySelector(".read-more-text");
        if (moreText) {
            e.target.classList.add("hidden");
            moreText.classList.toggle("hidden");
        }
    }, [
        modal,
        HalfMedia
    ]);
    (0,react.useEffect)(function() {
        if (typeof setIsLoaded === "function") {
            setIsLoaded(true);
        }
    }, []);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-comp": Markdown.displayName,
        ref: inputRef
    }, props), {
        sx: (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.markdown), (0,_define_property/* default */.Z)({
            textAlign: textAlign
        }, Markdown_textHtmlTags, (0,_object_spread/* default */.Z)({
            textAlign: textAlign || null,
            mt: textSx ? 0 : null,
            "&:last-of-type": textSx ? {
                mb: 0
            } : {}
        }, textSx))), sx),
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(index_modern, {
            options: {
                forceBlock: true,
                overrides: (0,_object_spread/* default */.Z)({
                    Modal: {
                        component: "span",
                        props: {
                            onClick: toggleModal
                        }
                    },
                    Readmore: {
                        component: "button",
                        props: {
                            onClick: toggleReadMore
                        }
                    }
                }, overrides)
            },
            children: markdownText
        })
    }));
});
Markdown.displayName = "Markdown";
Markdown.propTypes = {
    text: (prop_types_default()).string,
    children: (prop_types_default()).string,
    sx: (prop_types_default()).object,
    textAlign: prop_types_default().oneOfType([
        (prop_types_default()).string,
        (prop_types_default()).array
    ]),
    textSx: (prop_types_default()).object
};

;// CONCATENATED MODULE: ./src/snippets/Markdown/index.js


;// CONCATENATED MODULE: ./src/snippets/Modal/Modal.theme.js



var Modal_theme_themed = (0,create/* create */.U)(new function() {
    this.closed = {
        zIndex: 40,
        position: "fixed",
        p: [
            10,
            null,
            12
        ],
        py: [
            12,
            null,
            15
        ],
        top: "50%",
        left: "50%",
        transform: "translateX(-50%) translateY(-50%)",
        bg: "background",
        opacity: 0,
        pointerEvents: "none",
        minWidth: [
            "90%",
            640
        ],
        maxWidth: [
            "90%",
            "unset"
        ],
        maxHeight: "90%",
        overflowY: "auto"
    };
    this.open = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this.closed), {
        opacity: 1,
        pointerEvents: "auto"
    });
    this.close = {
        position: "absolute",
        cursor: "pointer",
        right: [
            "20px",
            "32px"
        ],
        top: [
            "20px",
            "32px"
        ],
        zIndex: 1
    };
    this.icon = {
        width: [
            24,
            null,
            22
        ],
        cursor: "pointer"
    };
    this.contentHidden = {
        opacity: 0,
        willChange: "opacity",
        transition: "opacity .3s ease-in-out"
    };
    this.contentVisible = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this.contentHidden), {
        opacity: 1
    });
}());

;// CONCATENATED MODULE: ./src/snippets/Modal/Modal.jsx









var Modal = Modal_theme_themed(function(_param) {
    var theme = _param.theme, inputRef = _param.inputRef, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme",
        "inputRef"
    ]);
    var ref = (0,_sliced_to_array/* default */.Z)((0,hooks/* useModal */.dd)(), 2), modal = ref[0].modal, closeModal = ref[1].closeModal;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        as: "aside",
        "data-comp": Modal.displayName
    }, props), {
        sx: (0,_object_spread/* default */.Z)({}, modal ? theme.open : theme.closed, props.sx),
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                "data-comp": "".concat(Modal.displayName, "Close"),
                sx: theme.close,
                onClick: closeModal,
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Svg, {
                    alt: "Close modal",
                    src: "/svgs/close.svg#close",
                    viewBox: "0 0 48 48",
                    sx: theme.icon
                })
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                "data-comp": "".concat(Modal.displayName, "Content"),
                sx: (0,_object_spread/* default */.Z)({}, modal ? theme.contentVisible : theme.contentHidden),
                children: modal
            })
        ]
    }));
});
Modal.displayName = "Modal";

;// CONCATENATED MODULE: ./src/snippets/Modal/index.js


;// CONCATENATED MODULE: ./src/snippets/OkendoStars/OkendoStarsIcon.jsx




var OkendoStarsIcon = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var averageScore = _param.averageScore, emptyColor = _param.emptyColor, fullColor = _param.fullColor, index = _param.index, onClickedStar = _param.onClickedStar, totalReviews = _param.totalReviews, width = _param.width, props = (0,_object_without_properties/* default */.Z)(_param, [
        "averageScore",
        "emptyColor",
        "fullColor",
        "index",
        "onClickedStar",
        "totalReviews",
        "width"
    ]);
    if (typeof averageScore === "undefined") return null;
    var scoreMinusIndex = averageScore - (index + 1);
    var isEmpty = scoreMinusIndex < -0.75;
    var isHalf = !isEmpty && scoreMinusIndex <= -0.25;
    var starIndex = index + 1;
    var starSvgSrc = totalReviews === 0 ? "/svgs/okendo/star-empty.svg#star-empty" : isEmpty ? "/svgs/okendo/star-empty.svg#star-empty" : isHalf ? "/svgs/okendo/star-half-empty.svg#star-half-empty" : "/svgs/okendo/star-full.svg#star-full"; // isFull
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Svg, {
        alt: "".concat(starIndex, " ").concat(starIndex === 1 ? "star" : "stars"),
        viewBox: "0 0 24 24",
        width: width,
        src: starSvgSrc,
        onClick: function() {
            return onClickedStar(index + 1);
        },
        sx: {
            color: isEmpty ? emptyColor : fullColor
        }
    }, index);
});
OkendoStarsIcon.displayName = "OkendoStarsIcon";

;// CONCATENATED MODULE: ./src/snippets/OkendoStars/OkendoStarsIcons.jsx








var OkendoStarsIcons = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var averageScore = _param.averageScore, _emptyColor = _param.emptyColor, emptyColor = _emptyColor === void 0 ? "beige" : _emptyColor, _fullColor = _param.fullColor, fullColor = _fullColor === void 0 ? "red" : _fullColor, _onClickedStar = _param.onClickedStar, onClickedStar = _onClickedStar === void 0 ? function() {} : _onClickedStar, totalReviews = _param.totalReviews, _width = _param.width, width = _width === void 0 ? "16px" : _width, props = (0,_object_without_properties/* default */.Z)(_param, [
        "averageScore",
        "emptyColor",
        "fullColor",
        "onClickedStar",
        "totalReviews",
        "width"
    ]);
    if (typeof averageScore === "undefined") return null;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Grid */.rj, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-comp": OkendoStarsIcons.displayName,
        ref: ref,
        variant: "flex.row.start.center"
    }, props), {
        sx: (0,_object_spread/* default */.Z)({
            gridTemplateColumns: "repeat(5, 10px)",
            columnGap: "3px"
        }, props.sx),
        children: (0,_to_consumable_array/* default */.Z)(new Array(5)).map(function(_, index) {
            return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(OkendoStarsIcon, {
                averageScore: averageScore,
                emptyColor: emptyColor,
                fullColor: fullColor,
                index: index,
                onClickedStar: onClickedStar,
                totalReviews: totalReviews,
                width: width
            }, averageScore + index);
        })
    }));
});
OkendoStarsIcons.displayName = "OkendoStarsIcons";

;// CONCATENATED MODULE: ./src/snippets/OkendoStars/OkendoStars.jsx








// Fetches stars data from yotpo and then renders them
function OkendoStars(_param) {
    var legacyResourceId = _param.legacyResourceId, _isProductItem = _param.isProductItem, isProductItem = _isProductItem === void 0 ? false : _isProductItem, _isPdp = _param.isPdp, isPdp = _isPdp === void 0 ? false : _isPdp, _withCta = _param.withCta, withCta = _withCta === void 0 ? true : _withCta, _withScroll = _param.withScroll, withScroll = _withScroll === void 0 ? true : _withScroll, _onClickedStar = _param.onClickedStar, onClickedStar = _onClickedStar === void 0 ? function() {} : _onClickedStar, _fullColor = _param.fullColor, fullColor = _fullColor === void 0 ? "black" : _fullColor, _emptyColor = _param.emptyColor, emptyColor = _emptyColor === void 0 ? "black" : _emptyColor, props = (0,_object_without_properties/* default */.Z)(_param, [
        "legacyResourceId",
        "isProductItem",
        "isPdp",
        "withCta",
        "withScroll",
        "onClickedStar",
        "fullColor",
        "emptyColor"
    ]);
    var stars = (0,hooks/* useOkendoStars */.BJ)({
        productId: legacyResourceId
    }).stars;
    var ref = stars || {}, averageScore = ref.averageScore, totalReviews = ref.totalReviews, fiveStarTotalReviews = ref.fiveStarTotalReviews;
    var scrollToReviews = (0,hooks/* useOkendoScrollToReviews */.dO)().scrollToReviews;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
        variant: "flex.row.start.center",
        "data-comp": OkendoStars.displayName,
        className: totalReviews > 0 ? "" : "hidden",
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                variant: "flex.row.start.center",
                tabIndex: "0",
                onClick: withScroll ? scrollToReviews : null
            }, props), {
                sx: (0,_object_spread/* default */.Z)({
                    minHeight: "18px",
                    my: 3,
                    cursor: "pointer"
                }, props.sx),
                className: totalReviews > 0 ? "".concat(props === null || props === void 0 ? void 0 : props.className) : "before:hidden",
                children: totalReviews >= 0 && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_jsx_runtime_esm/* Fragment */.HY, {
                    children: [
                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(OkendoStarsIcons, {
                            totalReviews: totalReviews,
                            averageScore: averageScore,
                            onClickedStar: onClickedStar,
                            fullColor: fullColor,
                            emptyColor: emptyColor
                        }),
                        withCta ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                            "data-comp": "".concat(OkendoStars.displayName, "Total"),
                            "aria-label": "".concat(totalReviews, " reviews"),
                            variant: "link2",
                            sx: {
                                pl: 4,
                                textDecoration: withScroll ? "underline" : "none",
                                mr: "auto",
                                span: {
                                    variant: "text.sm"
                                },
                                position: "relative",
                                top: "-3px"
                            },
                            children: totalReviews ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Text */.xv, {
                                "data-comp": "".concat(OkendoStars.displayName, "TotalText"),
                                children: [
                                    "(",
                                    totalReviews,
                                    ")"
                                ]
                            }) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Text */.xv, {
                                "data-comp": "".concat(OkendoStars.displayName, "TotalText"),
                                sx: {
                                    display: [
                                        "none",
                                        "inline-block"
                                    ]
                                },
                                children: "(0)"
                            })
                        }) : null
                    ]
                })
            })),
            isPdp && fiveStarTotalReviews > 0 && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                variant: "flex.row.start.center",
                tabIndex: "0"
            }, props), {
                sx: {
                    background: "#F3F3F3",
                    borderRadius: "100px",
                    marginLeft: "12px",
                    color: "#222222",
                    fontSize: [
                        "11px",
                        "14px"
                    ],
                    padding: [
                        "4px 8px",
                        "6px 12px"
                    ],
                    gap: [
                        "4px",
                        "8px"
                    ]
                },
                className: "okendoFiveStars",
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Svg, {
                        alt: "".concat(fiveStarTotalReviews, " 5-Star Reviews"),
                        viewBox: "0 0 16 17",
                        src: "/svgs/okendo/five-stars.svg#five-stars",
                        sx: {
                            width: "16px",
                            height: "17px",
                            color: "#222222"
                        }
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)("span", {
                        children: [
                            fiveStarTotalReviews.toLocaleString("en-US"),
                            " 5-Star Reviews"
                        ]
                    })
                ]
            }))
        ]
    }, averageScore + totalReviews);
}
OkendoStars.displayName = "OkendoStars";

;// CONCATENATED MODULE: ./src/snippets/OkendoStars/index.js


;// CONCATENATED MODULE: ./src/snippets/Overlay/Overlay.theme.js



var Overlay_Overlay_theme_themed = (0,create/* create */.U)(new function() {
    this.closed = {
        variant: "box.fill",
        bg: "text",
        opacity: 0,
        pointerEvents: "none",
        position: "fixed",
        transition: "opacity .2s cubic-bezier(0.2, 0.5, 0.2, 1)",
        willChange: "opacity",
        zIndex: 40,
        "&:hover": {
            cursor: "none"
        }
    };
    this.open = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this.closed), {
        opacity: 0.5,
        pointerEvents: "auto",
        zIndex: "40",
        "&:hover": {
            cursor: "url('/svgs/overlay-close.svg') 0 0, auto"
        }
    });
}());

;// CONCATENATED MODULE: ./src/snippets/Overlay/Overlay.jsx








var Overlay_Overlay = Overlay_Overlay_theme_themed(function(_param) {
    var theme = _param.theme, inputRef = _param.inputRef, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme",
        "inputRef"
    ]);
    var ref = (0,_sliced_to_array/* default */.Z)((0,hooks/* useOverlay */.Ir)(), 2), overlay = ref[0].overlay, closeOverlay = ref[1].closeOverlay;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-comp": Overlay_Overlay.displayName
    }, props), {
        onClick: closeOverlay,
        sx: (0,_object_spread/* default */.Z)({}, overlay ? theme.open : theme.closed, props.sx)
    }));
});
Overlay_Overlay.displayName = "Overlay";

;// CONCATENATED MODULE: ./src/snippets/Overlay/index.js


;// CONCATENATED MODULE: ./src/snippets/PasswordProtectedModal/PasswordProtectedModal.theme.js


var PasswordProtectedModal_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = function(backgroundColor) {
        return {
            backgroundColor: backgroundColor,
            position: "relative"
        };
    };
    this.main = {
        minHeight: [
            "75vh",
            "700px"
        ],
        position: "relative",
        flexWrap: "wrap",
        py: 14,
        px: 10
    };
    this.close = {
        position: "absolute",
        top: 10,
        right: 10,
        zIndex: 1
    };
    this.icon = function(iconColor) {
        return {
            width: "24px",
            height: "24px",
            color: iconColor
        };
    };
    this.image = function(position) {
        return (0,_object_spread/* default */.Z)({}, position === "full" ? {
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0
        } : {
            width: [
                "100%",
                "50%"
            ],
            mb: [
                14,
                0
            ]
        });
    };
    this.content = function(position) {
        return {
            textAlign: "center",
            zIndex: "1",
            width: position === "full" ? "100%" : [
                "100%",
                "50%"
            ]
        };
    };
    this.superheading = function(superheadingColor) {
        return {
            color: superheadingColor,
            fontSize: [
                4,
                7
            ]
        };
    };
    this.heading = function() {
        var headingOption = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "text.h1", headingColor = arguments.length > 1 ? arguments[1] : void 0;
        return {
            variant: headingOption,
            fontSize: [
                "64px",
                null,
                "120px"
            ],
            fontWeight: 500,
            lineHeight: "1",
            letterSpacing: [
                "-0.02em",
                null,
                "-0.01em"
            ],
            mt: [
                -5,
                null,
                -10
            ],
            color: headingColor
        };
    };
    this.copy = function(copyColor) {
        return {
            variant: "text.base",
            fontSize: [
                4,
                6
            ],
            color: copyColor
        };
    };
    this.passwordInput = function(passwordColor) {
        return {
            fontSize: [
                "13px",
                "13px"
            ],
            textAlign: "center",
            color: passwordColor,
            width: "236px",
            height: "35px",
            px: "35px",
            py: 0,
            borderRadius: "62px",
            "::placeholder": {
                color: passwordColor,
                textTransform: "uppercase"
            },
            "@keyframes shake1": {
                "0%": {
                    ml: 0
                },
                "25%": {
                    ml: "0.5rem"
                },
                "50%": {
                    ml: "-0.5rem"
                },
                "100%": {
                    ml: 0
                }
            }
        };
    };
    this.animationError = function(errorMessageColor) {
        return {
            animation: "shake1 0.2s ease-in-out 0s 2",
            color: errorMessageColor,
            "::placeholder": {
                color: errorMessageColor,
                textTransform: "uppercase"
            }
        };
    };
    this.passwordSubmitBtn = {
        position: "absolute",
        top: "calc(50% - 10px)",
        right: "13px"
    };
    this.passwordInputIcon = function(passwordColor) {
        return {
            width: "20px",
            color: passwordColor
        };
    };
}());

;// CONCATENATED MODULE: ./src/snippets/PasswordProtectedModal/PasswordProtectedForm.jsx






var PasswordProtectedForm = PasswordProtectedModal_theme_themed(function(param) {
    var password = param.password, setShowErrorMessage = param.setShowErrorMessage, showErrorMessage = param.showErrorMessage, submitPassword = param.submitPassword, theme = param.theme;
    var ref = (0,_object_spread/* default */.Z)({}, password), errorMessage = ref.errorMessage, errorMessageColor = ref.errorMessageColor, passwordColor = ref.passwordColor;
    var passwordInputRef = (0,react.useRef)();
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
        variant: "flex.column.center",
        sx: {
            mt: 11
        },
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                as: "form",
                sx: {
                    position: "relative"
                },
                onSubmit: function(e) {
                    var ref;
                    e.preventDefault();
                    submitPassword(passwordInputRef === null || passwordInputRef === void 0 ? void 0 : (ref = passwordInputRef.current) === null || ref === void 0 ? void 0 : ref.value);
                },
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                        variant: "plain",
                        sx: theme.passwordSubmitBtn,
                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Svg, {
                            viewBox: "0 0 24 24",
                            src: "/svgs/arrow-right.svg#arrow-right",
                            sx: theme.passwordInputIcon(showErrorMessage ? errorMessageColor : passwordColor)
                        })
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Input */.II, {
                        placeholder: "Enter Password",
                        type: "text",
                        required: true,
                        ref: passwordInputRef,
                        onChange: function() {
                            return setShowErrorMessage(false);
                        },
                        sx: (0,_object_spread/* default */.Z)({}, theme.passwordInput(passwordColor), showErrorMessage ? theme.animationError(errorMessageColor) : "")
                    })
                ]
            }),
            showErrorMessage && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                sx: {
                    mt: 10,
                    color: errorMessageColor
                },
                children: errorMessage
            })
        ]
    });
});
PasswordProtectedForm.displayName = "PasswordProtectedForm";

;// CONCATENATED MODULE: ./src/snippets/PasswordProtectedModal/PasswordProtectedContent.jsx





var PasswordProtectedContent = PasswordProtectedModal_theme_themed(function(param) {
    var text = param.text, theme = param.theme;
    var ref = (0,_object_spread/* default */.Z)({}, text), copy = ref.copy, copyColor = ref.copyColor, heading = ref.heading, headingColor = ref.headingColor, headingOption = ref.headingOption, superheading = ref.superheading, superheadingColor = ref.superheadingColor;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": PasswordProtectedContent.displayName,
        children: [
            superheading && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                sx: theme.superheading(superheadingColor),
                children: superheading
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Markdown, {
                text: heading,
                textSx: (0,_object_spread/* default */.Z)({}, theme.heading(headingOption, headingColor)),
                sx: {
                    mb: copy ? 10 : 0
                }
            }),
            copy && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Markdown, {
                text: copy,
                textSx: theme.copy(copyColor)
            })
        ]
    });
});
PasswordProtectedContent.displayName = "PasswordProtectedContent";

;// CONCATENATED MODULE: ./src/snippets/PasswordProtectedModal/PasswordProtectedImage.jsx




var PasswordProtectedImage = PasswordProtectedModal_theme_themed(function(param) {
    var image = param.image, theme = param.theme;
    var ref = (0,_object_spread/* default */.Z)({}, image), alt = ref.alt, imageMobile = ref.image, imageDt = ref.imageDt, position = ref.position;
    if (!(imageDt === null || imageDt === void 0 ? void 0 : imageDt.src) && !(imageMobile === null || imageMobile === void 0 ? void 0 : imageMobile.src)) return null;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Picture, {
        "data-comp": PasswordProtectedImage.displayName,
        alt: alt,
        images: [
            {
                src: (imageMobile === null || imageMobile === void 0 ? void 0 : imageMobile.src) || (imageDt === null || imageDt === void 0 ? void 0 : imageDt.src),
                width: 768
            },
            {
                src: imageDt === null || imageDt === void 0 ? void 0 : imageDt.src,
                width: 1024
            },
            {
                src: imageDt === null || imageDt === void 0 ? void 0 : imageDt.src,
                width: 1280
            },
            {
                src: imageDt === null || imageDt === void 0 ? void 0 : imageDt.src,
                width: 1440
            }, 
        ],
        sx: theme.image(position),
        imageSx: {
            objectFit: position === "full" ? "contain" : "cover"
        }
    });
});
PasswordProtectedImage.displayName = "PasswordProtectedImage";

;// CONCATENATED MODULE: ./src/snippets/PasswordProtectedModal/PasswordProtectedModal.jsx









var PasswordProtectedModal = PasswordProtectedModal_theme_themed(function(param) {
    var theme = param.theme;
    var ref = (0,hooks/* usePasswordProtected */.uE)(), gatedPage = ref.gatedPage, setShowErrorMessage = ref.setShowErrorMessage, showErrorMessage = ref.showErrorMessage, submitPassword = ref.submitPassword;
    var ref1 = (0,_object_spread/* default */.Z)({}, gatedPage), backgroundColor = ref1.backgroundColor, closeControl = ref1.closeControl, image = ref1.image, password = ref1.password, text = ref1.text;
    var ref2 = (0,_object_spread/* default */.Z)({}, closeControl), iconColor = ref2.iconColor, redirectUrlPath = ref2.redirectUrlPath;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Container */.W2, {
        "data-comp": PasswordProtectedModal.displayName,
        sx: theme.wrapper(backgroundColor),
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                "data-comp": "".concat(PasswordProtectedModal.displayName, "Close"),
                sx: theme.close,
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Link, {
                    href: redirectUrlPath,
                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Svg, {
                        alt: "Close modal",
                        src: "/svgs/close.svg#close",
                        viewBox: "0 0 48 48",
                        sx: theme.icon(iconColor)
                    })
                })
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                variant: "flex.row.center",
                sx: theme.main,
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(PasswordProtectedImage, {
                        image: image
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                        "data-comp": "".concat(PasswordProtectedModal.displayName, "Content"),
                        sx: theme.content(image === null || image === void 0 ? void 0 : image.position),
                        children: [
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(PasswordProtectedContent, {
                                text: text
                            }),
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(PasswordProtectedForm, {
                                password: password,
                                setShowErrorMessage: setShowErrorMessage,
                                showErrorMessage: showErrorMessage,
                                submitPassword: submitPassword
                            })
                        ]
                    })
                ]
            })
        ]
    });
});
PasswordProtectedModal.displayName = "PasswordProtectedModal";

;// CONCATENATED MODULE: ./src/snippets/PasswordProtectedModal/index.js


// EXTERNAL MODULE: ./src/theme/theme.breakpoints.js
var theme_breakpoints = __webpack_require__(80315);
;// CONCATENATED MODULE: ../node_modules/@swc/helpers/src/_type_of.mjs
function _typeof(obj) {
    "@swc/helpers - typeof";
    return obj && obj.constructor === Symbol ? "symbol" : typeof obj;
};

;// CONCATENATED MODULE: ./src/snippets/Picture/usePicture.js




var usePicture = function(param) {
    var _images = param.images, images = _images === void 0 ? [] : _images, _hoverImages = param.hoverImages, hoverImages = _hoverImages === void 0 ? [] : _hoverImages;
    var refresh = (0,_to_consumable_array/* default */.Z)(images).concat((0,_to_consumable_array/* default */.Z)(hoverImages)).map(function(image, index) {
        return index + (image === null || image === void 0 ? void 0 : image.src) + (image === null || image === void 0 ? void 0 : image.ratio) + (image === null || image === void 0 ? void 0 : image.width) + (image === null || image === void 0 ? void 0 : image.height);
    }).join(",");
    return (0,react.useMemo)(function() {
        // replace nulls images with the previous image value in the array
        var fullImages = images.map(nullValuesToPrevious);
        var picture = fullImages.reduce(imagesToPaddingAndSources, {
            paddingBottom: [],
            sources: [],
            lastUniqueRatio: null
        });
        var fullHoverImages = hoverImages.map(nullValuesToPrevious);
        var hoverPicture = fullHoverImages.reduce(imagesToPaddingAndSources, {
            paddingBottom: [],
            sources: [],
            lastUniqueRatio: null
        });
        return [
            picture,
            hoverPicture
        ];
    }, [
        refresh,
        images,
        hoverImages
    ]);
};
/* Helpers */ /**
 * Converts a width/height ratio to a paddingBottom %
 * @param {float} decimal width/height ratio value
 * @returns percentage of bottom padding for a given ratio
 */ var getPaddingFromRatio = function(decimal) {
    for(var denominator = 1; decimal * denominator % 1 !== 0; denominator++);
    var bottomPadding = denominator / (decimal * denominator) * 100;
    return "".concat(bottomPadding, "%");
};
/**
 * Returns the current image if it not null, otherwise return the previous
 * @param {imageObject} image — e.g { src: '..', width: 123, ratio: 0.8 }
 * @param {*} index
 * @param {*} images
 * @returns
 */ var nullValuesToPrevious = function(image, index, _images) {
    var previous = _images[index - 1];
    return image !== null && image !== void 0 ? image : previous;
};
var imagesToPaddingAndSources = function(_picture, image, index, _images) {
    var isNull = image === null; // null is allowed just like inside sx
    var isDefined = typeof image !== "undefined";
    var isFirst = index === 0;
    var imageSrc = (image === null || image === void 0 ? void 0 : image.src) || "/svgs/default-image.svg";
    // Validate props
    if (isDefined && !isNull) {
        if (!(image === null || image === void 0 ? void 0 : image.ratio)) image.ratio = 1;
        // throw new Error(`Image #${index + 1} "ratio" not provided`); // TODO: check if this is needed
        if (typeof image.ratio === "string") {
            if (image.ratio.includes(".")) {
                image.ratio = parseFloat(image.ratio);
            } else {
                image.ratio = parseInt(image.ratio);
            }
        }
        if (!isInt(image.ratio) && !isFloat(image.ratio)) {
            throw new Error("Image #".concat(index + 1, ' "ratio" must be in decimal (width/height) format: ').concat(image.ratio, " ").concat(_typeof(image.ratio)));
        }
        if (!isInt(image === null || image === void 0 ? void 0 : image.width) && !isInt(image === null || image === void 0 ? void 0 : image.height)) {
            image.width = 768; // default width if not provided
        }
    }
    // convert width/height provided ratio to padding bottom
    var prevRatio = isFirst ? null : _picture.paddingBottom[index - 1];
    var currentRatio = (image === null || image === void 0 ? void 0 : image.ratio) ? getPaddingFromRatio(image.ratio) : null;
    var isSameAsLastUniqueRatio = prevRatio === currentRatio || _picture.lastUniqueRatio === currentRatio || currentRatio === null;
    if (isSameAsLastUniqueRatio) {
        _picture.paddingBottom.push(null);
    } else {
        _picture.lastUniqueRatio = currentRatio;
        _picture.paddingBottom.push(currentRatio);
    }
    // Crop the image source fo the given bp
    var isShopifySrc = imageSrc ? /^https\:\/\/cdn\.shopify\.com/.test(image.src) : false;
    var bpSrc = isShopifySrc ? (0,utils/* shopifySrcFilter */.O7)(image.src, image) : imageSrc;
    var bpSrcUrl = imageSrc && ((image === null || image === void 0 ? void 0 : image.width) || (image === null || image === void 0 ? void 0 : image.height)) ? bpSrc : null;
    // array of width-cropped sources (for all breakpoints)
    _picture.sources.push(bpSrcUrl);
    return _picture;
};
var isInt = function(n) {
    return Number(n) === n && n % 1 === 0;
};
var isFloat = function(n) {
    return Number(n) === n && n % 1 !== 0;
};

// EXTERNAL MODULE: ../node_modules/next/head.js
var head = __webpack_require__(88038);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./src/snippets/Picture/PictureSource.jsx



function PictureSource(param) {
    var breakpoint = param.breakpoint, breakpointPrev = param.breakpointPrev, isLast = param.isLast, width = param.width, src = param.src, preload = param.preload;
    var media = isLast ? "(min-width: ".concat(breakpointPrev, ")") : "(max-width: ".concat(breakpoint, ")");
    var breakpointPx = Math.round(parseFloat(breakpoint.split("em")[0]) * 16);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_jsx_runtime_esm/* Fragment */.HY, {
        children: [
            preload && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)((head_default()), {
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("link", {
                    rel: "preload",
                    href: src,
                    as: "image",
                    media: media
                })
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                as: "source",
                "data-comp": PictureSource.displayName,
                "data-render-until": "".concat(breakpointPx, "px/").concat(breakpoint),
                "data-crop-width": "".concat(width, "px"),
                media: media,
                srcSet: src
            })
        ]
    });
}
PictureSource.displayName = "PictureSource";

;// CONCATENATED MODULE: ./src/snippets/Picture/PictureImage.jsx




function PictureImage(param) {
    var aboveTheFold = param.aboveTheFold, alt = param.alt, imageSx = param.imageSx, initialSrc = param.initialSrc, preload = param.preload, width = param.width, height = param.height, isHover = param.isHover, _onError = param.onError, onError = _onError === void 0 ? function() {} : _onError, _onLoad = param.onLoad, onLoad = _onLoad === void 0 ? function() {} : _onLoad;
    var imageRef = (0,react.useRef)();
    var imgLoading = !isHover && (preload || aboveTheFold) ? "eager" : "lazy";
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Image */.Ee, {
        "data-comp": PictureImage.displayName,
        ref: imageRef,
        alt: alt,
        src: initialSrc,
        width: width,
        height: height,
        sx: (0,_object_spread/* default */.Z)({
            // over-writable..
            height: "100%",
            position: "absolute",
            width: "100%",
            outline: "none",
            objectFit: "cover",
            border: 0,
            p: 0,
            m: 0,
            bottom: 0,
            left: 0,
            right: 0,
            top: 0
        }, imageSx),
        fetchpriority: preload ? "high" : undefined,
        loading: imgLoading,
        onLoad: function() {
            return onLoad(imageRef.current);
        },
        onError: function(event) {
            console.error("Error loading image with src", event.target.currentSrc);
            onError(event);
        }
    });
}
PictureImage.displayName = "PictureImage";

;// CONCATENATED MODULE: ./src/snippets/Picture/Picture.theme.js



var Picture_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        border: 0,
        boxSizing: "border-box",
        display: "flex",
        height: "auto",
        maxWidth: "100%",
        overflow: "hidden",
        p: 0,
        position: "relative",
        width: "100%"
    };
    this.image = {
        bottom: 0,
        left: 0,
        p: 0,
        position: "absolute",
        right: 0,
        top: 0,
        zIndex: 0,
        willChange: "opacity"
    };
    this.hoverImage = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this.image), {
        border: 0
    });
    this.video = {
        bottom: 0,
        left: 0,
        p: 0,
        position: "absolute",
        right: 0,
        top: 0,
        zIndex: 0,
        willChange: "opacity",
        objectFit: "cover"
    };
    this.hoverVideo = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this.video), {
        border: 0
    });
}());

;// CONCATENATED MODULE: ./src/snippets/Picture/Picture.jsx














var Picture = Picture_theme_themed(function(_param) {
    var _aboveTheFold = _param.// inView settings
    aboveTheFold, aboveTheFold = _aboveTheFold === void 0 ? false : _aboveTheFold, _preload = _param.preload, preload = _preload === void 0 ? false : _preload, _alt = _param.alt, alt = _alt === void 0 ? "Image" : _alt, children = _param.children, _disableHoverMobile = _param.disableHoverMobile, disableHoverMobile = _disableHoverMobile === void 0 ? false : _disableHoverMobile, _foreignHover = _param.foreignHover, foreignHover = _foreignHover === void 0 ? false : _foreignHover, _hoverImages = _param.hoverImages, hoverImages = _hoverImages === void 0 ? [] : _hoverImages, id = _param.id, inputRef = _param.inputRef, _images = _param.images, images = _images === void 0 ? [
        {
            src: "/svgs/default-image.svg",
            width: 600,
            ratio: 1
        }
    ] : _images, _imageSx = _param.imageSx, imageSx = _imageSx === void 0 ? {} : _imageSx, _rootMargin = _param.rootMargin, rootMargin = _rootMargin === void 0 ? "100px" : _rootMargin, theme = _param.theme, _threshold = _param.threshold, threshold = _threshold === void 0 ? 0.01 : _threshold, _triggerOnce = _param.triggerOnce, triggerOnce = _triggerOnce === void 0 ? true : _triggerOnce, _variant = _param.variant, variant = _variant === void 0 ? null : _variant, _imageBgColor = _param.imageBgColor, imageBgColor = _imageBgColor === void 0 ? null : _imageBgColor, _hoverImageBgColor = _param.hoverImageBgColor, hoverImageBgColor = _hoverImageBgColor === void 0 ? null : _hoverImageBgColor, _video = _param.video, video = _video === void 0 ? "" : _video, _videoHover = _param.videoHover, videoHover = _videoHover === void 0 ? "" : _videoHover, videoRatio = _param.videoRatio, videoRatioDt = _param.videoRatioDt, mobileRatio = _param.mobileRatio, desktopRatio = _param.desktopRatio, width = _param.width, height = _param.height, _onError = _param.// events
    onError, onError = _onError === void 0 ? function() {} : _onError, _onInView = _param.onInView, onInView = _onInView === void 0 ? function() {} : _onInView, _onLoad = _param.onLoad, onLoad = _onLoad === void 0 ? function() {} : _onLoad, _onMouseEnter = _param.onMouseEnter, onMouseEnter = _onMouseEnter === void 0 ? function() {} : _onMouseEnter, _onMouseLeave = _param.onMouseLeave, onMouseLeave = _onMouseLeave === void 0 ? function() {} : _onMouseLeave, props = (0,_object_without_properties/* default */.Z)(_param, [
        "aboveTheFold",
        "preload",
        "alt",
        "children",
        "disableHoverMobile",
        "foreignHover",
        "hoverImages",
        "id",
        "inputRef",
        "images",
        "imageSx",
        "rootMargin",
        "theme",
        "threshold",
        "triggerOnce",
        "variant",
        "imageBgColor",
        "hoverImageBgColor",
        "video",
        "videoHover",
        "videoRatio",
        "videoRatioDt",
        "mobileRatio",
        "desktopRatio",
        "width",
        "height",
        "onError",
        "onInView",
        "onLoad",
        "onMouseEnter",
        "onMouseLeave"
    ]);
    var ref, ref1;
    var ref2 = (0,_sliced_to_array/* default */.Z)(usePicture({
        images: images,
        hoverImages: hoverImages
    }), 2), picture = ref2[0], hoverPicture = ref2[1];
    var ref3 = (0,react.useState)(foreignHover), hovered = ref3[0], setHovered = ref3[1];
    var ref4 = (0,react.useState)(), windowWidth = ref4[0], setWindowWidth = ref4[1];
    var disableHoverPicture = (hoverPicture === null || hoverPicture === void 0 ? void 0 : (ref = hoverPicture.sources) === null || ref === void 0 ? void 0 : ref[0]) === "/svgs/default-image.svg";
    var hasHoverPicture = (hoverPicture === null || hoverPicture === void 0 ? void 0 : (ref1 = hoverPicture.sources) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 && !disableHoverMobile && !disableHoverPicture;
    var hasHoverVideo = videoHover && !disableHoverMobile;
    var ratioCalculatedWidth = windowWidth >= 1024 ? desktopRatio * 1000 : mobileRatio * 1000;
    (0,react.useEffect)(function() {
        setHovered(foreignHover);
    }, [
        foreignHover
    ]);
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,react_intersection_observer_dist/* useInView */.YD)({
        rootMargin: rootMargin,
        triggerOnce: triggerOnce,
        threshold: threshold
    }), 2), inViewRef = ref5[0], inView = ref5[1];
    var setRefs = (0,react.useCallback)(function(node) {
        if (inputRef) inputRef.current = node;
        inViewRef(node);
    }, [
        inViewRef
    ]);
    var updateDimensions = function() {
        setWindowWidth(window.innerWidth);
    };
    (0,react.useEffect)(function() {
        updateDimensions();
        window.addEventListener("resize", updateDimensions);
        return function() {
            return window.removeEventListener("resize", updateDimensions);
        };
    }, []);
    (0,react.useEffect)(function() {
        return onInView(inView);
    }, [
        inView
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-comp": Picture.displayName,
        id: id
    }, props), {
        ref: setRefs,
        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.wrapper, props.sx), {
            variant: variant,
            ":before": {
                content: '""',
                paddingBottom: picture.paddingBottom,
                width: 0
            }
        }),
        onMouseEnter: function() {
            onMouseEnter();
            setHovered(true);
        },
        onMouseLeave: function() {
            onMouseLeave();
            setHovered(false);
        },
        children: [
            hasHoverVideo ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                as: "video",
                muted: true,
                playsInline: true,
                loop: true,
                autoPlay: true,
                sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.hoverVideo), {
                    opacity: hovered ? 1 : 0,
                    transition: "opacity .3s ease-in-out",
                    bg: hoverImageBgColor,
                    aspectRatio: videoRatioDt,
                    "@media only screen and (max-width: 767px)": {
                        aspectRatio: videoRatio
                    }
                }),
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("source", {
                    src: videoHover,
                    type: "video/mp4"
                }, videoHover)
            }) : null,
            !videoHover && hasHoverPicture ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                "data-comp": "".concat(Picture.displayName, "PictureHover"),
                as: "picture",
                sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.hoverImage), {
                    opacity: hovered ? 1 : 0,
                    transition: "opacity .3s ease-in-out",
                    bg: hoverImageBgColor
                }),
                children: [
                    hoverPicture.sources.map(function(source, index, sources) {
                        var hoverImage = (hoverImages === null || hoverImages === void 0 ? void 0 : hoverImages[index]) || null;
                        var breakpoint = (theme_breakpoints/* breakpoints */.A === null || theme_breakpoints/* breakpoints */.A === void 0 ? void 0 : theme_breakpoints/* breakpoints */.A[index]) || null;
                        var breakpointPrev = (theme_breakpoints/* breakpoints */.A === null || theme_breakpoints/* breakpoints */.A === void 0 ? void 0 : theme_breakpoints/* breakpoints */.A[index - 1]) || null;
                        var isLast = index === sources.length - 1;
                        if (!breakpoint || !hoverImage) return null;
                        return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(PictureSource, {
                            preload: preload,
                            breakpoint: breakpoint,
                            breakpointPrev: breakpointPrev,
                            width: hoverImage.width,
                            src: source,
                            isLast: isLast
                        }, "Hover ".concat(index + ((hoverImage === null || hoverImage === void 0 ? void 0 : hoverImage.width) || (hoverImage === null || hoverImage === void 0 ? void 0 : hoverImage.ratio) || "")));
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(PictureImage, {
                        alt: alt,
                        initialSrc: hoverPicture.sources.find(Boolean),
                        imageSx: imageSx,
                        isHover: true,
                        aboveTheFold: true,
                        preload: preload,
                        inView: inView,
                        width: width,
                        height: height
                    })
                ]
            }) : null,
            video ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                as: "video",
                muted: true,
                playsInline: true,
                loop: true,
                autoPlay: true,
                sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.video), {
                    opacity: hovered && (hasHoverPicture || hasHoverVideo) ? 0 : 1,
                    transition: "opacity .2s ease-in-out",
                    bg: imageBgColor,
                    aspectRatio: videoRatioDt,
                    "@media only screen and (max-width: 767px)": {
                        aspectRatio: videoRatio
                    }
                }),
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("source", {
                    src: video,
                    type: "video/mp4"
                }, video)
            }) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                "data-comp": "".concat(Picture.displayName, "Picture"),
                as: "picture",
                sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.image), {
                    opacity: hovered && (hasHoverPicture || hasHoverVideo) ? 0 : 1,
                    transition: "opacity .2s ease-in-out",
                    bg: imageBgColor
                }),
                children: [
                    picture.sources.map(function(source, index, sources) {
                        var image = (images === null || images === void 0 ? void 0 : images[index]) || null;
                        var breakpoint = (theme_breakpoints/* breakpoints */.A === null || theme_breakpoints/* breakpoints */.A === void 0 ? void 0 : theme_breakpoints/* breakpoints */.A[index]) || null;
                        var breakpointPrev = (theme_breakpoints/* breakpoints */.A === null || theme_breakpoints/* breakpoints */.A === void 0 ? void 0 : theme_breakpoints/* breakpoints */.A[index - 1]) || null;
                        var isLast = index === sources.length - 1;
                        if (!breakpoint || !image) return null;
                        return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(PictureSource, {
                            breakpoint: breakpoint,
                            breakpointPrev: breakpointPrev,
                            width: image.width,
                            src: source,
                            isLast: isLast,
                            preload: preload
                        }, index + ((image === null || image === void 0 ? void 0 : image.width) || (image === null || image === void 0 ? void 0 : image.ratio) || ""));
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(PictureImage, {
                        alt: alt,
                        initialSrc: picture.sources.find(Boolean),
                        imageSx: imageSx,
                        onError: onError,
                        onLoad: onLoad,
                        aboveTheFold: aboveTheFold,
                        preload: preload,
                        inView: inView,
                        width: desktopRatio && mobileRatio ? ratioCalculatedWidth : width,
                        height: desktopRatio && mobileRatio ? 1000 : height
                    })
                ]
            }),
            react.Children.map(children, function(child) {
                if (!/*#__PURE__*/ (0,react.isValidElement)(child)) return null;
                return /*#__PURE__*/ (0,react.cloneElement)(child, {
                    // Don't change 'relative'
                    style: {
                        position: "relative"
                    }
                });
            })
        ]
    }));
});
Picture.displayName = "Picture";
Picture.propTypes = {
    aboveTheFold: (prop_types_default()).bool,
    preload: (prop_types_default()).bool,
    alt: (prop_types_default()).string,
    children: (prop_types_default()).node,
    foreignHover: (prop_types_default()).bool,
    hoverImages: prop_types_default().arrayOf(prop_types_default().exact({
        src: (prop_types_default()).string,
        width: (prop_types_default()).number,
        ratio: (prop_types_default()).number
    })),
    id: (prop_types_default()).string,
    images: prop_types_default().arrayOf((prop_types_default()).object),
    imageSx: (prop_types_default()).object,
    rootMargin: (prop_types_default()).string,
    sx: (prop_types_default()).object,
    threshold: (prop_types_default()).number,
    triggerOnce: (prop_types_default()).bool,
    variant: (prop_types_default()).string,
    onError: (prop_types_default()).func,
    onInView: (prop_types_default()).func,
    onLoad: (prop_types_default()).func,
    onMouseEnter: (prop_types_default()).func,
    onMouseLeave: (prop_types_default()).func
};

;// CONCATENATED MODULE: ./src/snippets/Picture/index.js


;// CONCATENATED MODULE: ./src/snippets/ProductItem/Image/Image.theme.js

var Image_Image_theme_themed = (0,create/* create */.U)(new function() {
    this.image = {
        mb: 6,
        position: "relative"
    };
    this.spinnerWrapper = {
        width: "100%",
        minHeight: "100%",
        bg: "lightGray"
    };
    this.spinner = {
        width: "30px",
        color: "mediumGray",
        m: "auto"
    };
}());

;// CONCATENATED MODULE: ./src/snippets/ProductItem/Image/Image.jsx






var Image_Image_Image = Image_Image_theme_themed(function(param) {
    var theme = param.theme, fullProduct = param.fullProduct, handleClick = param.handleClick, _enableFullProductAccess = param.enableFullProductAccess, enableFullProductAccess = _enableFullProductAccess === void 0 ? true : _enableFullProductAccess;
    var ref;
    var ref1 = (0,hooks/* useProductItemImages */.Ep)({
        product: fullProduct
    }), primary = ref1.primary, hover = ref1.hover;
    var ref2 = (0,react.useState)(false), disableHoverMobile = ref2[0], setDisableHoverMobile = ref2[1];
    var disableHover = (0,hooks/* useBreakpointValue */.Sx)([
        true,
        false
    ]);
    (0,react.useEffect)(function() {
        setDisableHoverMobile(disableHover);
    }, [
        disableHover
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(Link, {
        "data-comp": Image_Image_Image.displayName,
        href: enableFullProductAccess ? "/products/".concat(fullProduct === null || fullProduct === void 0 ? void 0 : fullProduct.handle) : null,
        "aria-label": fullProduct === null || fullProduct === void 0 ? void 0 : fullProduct.title,
        sx: theme.image,
        onClick: handleClick,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Picture, {
                alt: fullProduct === null || fullProduct === void 0 ? void 0 : fullProduct.title,
                images: [
                    {
                        src: primary === null || primary === void 0 ? void 0 : primary.originalSrc,
                        width: 350,
                        ratio: 1
                    }, 
                ],
                hoverImages: [
                    {
                        src: hover === null || hover === void 0 ? void 0 : hover.originalSrc,
                        width: 350,
                        ratio: 1
                    }, 
                ],
                disableHoverMobile: disableHoverMobile,
                imageBgColor: "lightGray",
                hoverImageBgColor: "lightGray",
                width: primary === null || primary === void 0 ? void 0 : primary.width,
                height: primary === null || primary === void 0 ? void 0 : primary.height,
                children: !(primary === null || primary === void 0 ? void 0 : primary.originalSrc) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                    sx: theme.spinnerWrapper,
                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Spinner */.$j, {
                        sx: theme.spinner
                    })
                })
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Badge, {
                handle: fullProduct === null || fullProduct === void 0 ? void 0 : fullProduct.handle,
                product: fullProduct
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Favorite, {
                selectedVariant: fullProduct === null || fullProduct === void 0 ? void 0 : (ref = fullProduct.variants) === null || ref === void 0 ? void 0 : ref[0]
            })
        ]
    });
});
Image_Image_Image.displayName = "Image";

;// CONCATENATED MODULE: ./src/snippets/ProductItem/Image/index.js


;// CONCATENATED MODULE: ./src/snippets/ProductItem/Details/Details.theme.js



var Details_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        variant: "flex.column.start",
        width: "100%"
    };
    this.productRow = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this.wrapper), {
        minHeight: [
            "113px",
            20
        ],
        overflow: "hidden"
    });
    this.title = {
        variant: "text.h5"
    };
    this.variant = {
        color: "mediumDarkGray",
        mt: 1
    };
    this.colorCountVerbiage = {
        color: "mediumDarkGray",
        mt: 6
    };
    this.newPrice = {
        variant: "text.base",
        color: "red",
        mr: 4,
        fontSize: [
            "18px",
            "24px"
        ]
    };
    this.compareAtPrice = {
        variant: "text.base",
        textDecoration: "line-through",
        color: "mediumDarkGray",
        fontSize: [
            "18px",
            "24px"
        ]
    };
    this.price = {
        variant: "text.base",
        fontSize: [
            "18px",
            "24px"
        ]
    };
    this.loader = {
        height: [
            "20px",
            "22px"
        ],
        svg: {
            height: "100%",
            color: "gray"
        }
    };
}());

;// CONCATENATED MODULE: ./src/snippets/ProductItem/Details/Details.jsx







var Details = Details_theme_themed(function(param) {
    var theme = param.theme, fullProduct = param.fullProduct, product = param.product, _isProductRow = param.isProductRow, isProductRow = _isProductRow === void 0 ? false : _isProductRow, handleClick = param.handleClick, _enableFullProductAccess = param.enableFullProductAccess, enableFullProductAccess = _enableFullProductAccess === void 0 ? true : _enableFullProductAccess;
    var ref;
    var productName = isProductRow ? fullProduct === null || fullProduct === void 0 ? void 0 : fullProduct.title : product.name || product.title;
    var colorCountVerbiage = (0,react.useMemo)(function() {
        var ref, ref1;
        var colorsLength = fullProduct === null || fullProduct === void 0 ? void 0 : (ref = fullProduct.groupOptionsMap) === null || ref === void 0 ? void 0 : (ref1 = ref.handle) === null || ref1 === void 0 ? void 0 : ref1.length;
        if (!colorsLength) return null;
        return colorsLength > 1 ? "".concat(colorsLength, " colors available") : "".concat(colorsLength, " color available");
    }, [
        fullProduct === null || fullProduct === void 0 ? void 0 : fullProduct.id
    ]);
    var titles = (0,react.useMemo)(function() {
        var ref, ref1;
        var title = isProductRow ? productName : productName === null || productName === void 0 ? void 0 : productName.replaceAll("&amp;", "&");
        var titleArr = title === null || title === void 0 ? void 0 : title.split("|");
        return {
            product: (titleArr === null || titleArr === void 0 ? void 0 : (ref = titleArr[0]) === null || ref === void 0 ? void 0 : ref.trim()) || "",
            variant: ((ref1 = titleArr === null || titleArr === void 0 ? void 0 : titleArr.slice(1)) === null || ref1 === void 0 ? void 0 : ref1.join("|").trim()) || ""
        };
    }, [
        productName,
        isProductRow
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
        "data-comp": Details.displayName,
        sx: isProductRow ? theme.productRow : theme.wrapper,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Link, {
                href: enableFullProductAccess ? "/products/".concat(fullProduct === null || fullProduct === void 0 ? void 0 : fullProduct.handle) : null,
                tabIndex: "-1",
                "aria-hidden": "true",
                onClick: handleClick,
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                    "data-comp": "ProductItemTitle",
                    as: "h5",
                    sx: theme.title,
                    children: titles === null || titles === void 0 ? void 0 : titles.product
                })
            }),
            titles.variant && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                sx: theme.variant,
                children: titles.variant
            }),
            colorCountVerbiage && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.colorCountVerbiage), {
                    display: [
                        "none",
                        "block"
                    ]
                }),
                children: colorCountVerbiage
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Link, {
                href: enableFullProductAccess ? "/products/".concat(fullProduct === null || fullProduct === void 0 ? void 0 : fullProduct.handle) : null,
                tabIndex: "-1",
                "aria-hidden": "true",
                onClick: handleClick,
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(OkendoStars, {
                    legacyResourceId: fullProduct === null || fullProduct === void 0 ? void 0 : fullProduct.legacyResourceId,
                    withScroll: false,
                    sx: {
                        minHeight: "22px"
                    },
                    tabIndex: "-1",
                    "aria-hidden": "true"
                })
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                sx: {
                    minHeight: "22px",
                    mt: 3
                },
                children: (fullProduct === null || fullProduct === void 0 ? void 0 : (ref = fullProduct.variants) === null || ref === void 0 ? void 0 : ref[0]) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(Locale.Variant, {
                    variant: fullProduct.variants[0],
                    children: [
                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Locale.Price, {
                            children: function(param) {
                                var priceV2 = param.priceV2, compareAtPriceV2 = param.compareAtPriceV2, isOnSale = param.isOnSale;
                                return isOnSale ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                                    children: [
                                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                                            sx: theme.newPrice,
                                            children: priceV2.locale
                                        }),
                                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                                            sx: theme.compareAtPrice,
                                            children: compareAtPriceV2.locale
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                                    sx: theme.price,
                                    children: priceV2.locale
                                });
                            }
                        }),
                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Locale.Loader, {
                            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                                sx: theme.loader,
                                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Spinner */.$j, {})
                            })
                        })
                    ]
                })
            })
        ]
    });
});
Details.displayName = "Details";

;// CONCATENATED MODULE: ./src/snippets/ProductItem/Details/index.js


;// CONCATENATED MODULE: ./src/snippets/ProductItem/ProductItem.theme.js

var ProductItem_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        variant: "flex.column.start.between",
        height: "100%",
        width: "100%",
        '[data-comp="AddToCart"], [data-comp="SeeDetails"]': {
            opacity: 1,
            transition: "all 0.2s ease-in-out",
            ":focus": {
                opacity: 1
            }
        },
        ":hover": {
            '[data-comp="AddToCart"], [data-comp="SeeDetails"]': {
                opacity: 1
            }
        }
    };
    this.atc = {
        mt: [
            6,
            8
        ],
        width: [
            "100%",
            "unset"
        ]
    };
}());

;// CONCATENATED MODULE: ./src/snippets/ProductItem/ProductItem.jsx


















var ProductItem = ProductItem_theme_themed(function(_param) {
    var theme = _param.theme, product = _param.product, _isProductRow = _param.isProductRow, isProductRow = _isProductRow === void 0 ? false : _isProductRow, _hideAddToCart = _param.hideAddToCart, hideAddToCart = _hideAddToCart === void 0 ? false : _hideAddToCart, _onItemClick = _param.onItemClick, onItemClick = _onItemClick === void 0 ? function() {
        return null;
    } : _onItemClick, index = _param.index, inputRef = _param.inputRef, isSearchPage = _param.isSearchPage, searchTerm = _param.searchTerm, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme",
        "product",
        "isProductRow",
        "hideAddToCart",
        "onItemClick",
        "index",
        "inputRef",
        "isSearchPage",
        "searchTerm"
    ]);
    var sendClickProductItemEvent = (0,hooks/* useDataLayerActions */.KZ)().sendClickProductItemEvent;
    var gatedPage = (0,store/* useRecoilValue */.sJ)(store/* default.gatedPage */.ZP.gatedPage);
    var settings = (0,dist.useSettings)();
    var gatedPages = ((0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : settings.gatedPages) || {}).gatedPages;
    var enableFullProductAccess = (0,hooks/* useGatedProduct */.sC)({
        product: product,
        gatedPage: gatedPage
    }).enableFullProductAccess;
    var isInitialized = (0,webbridge_react_es/* useVariables */.OQ)().isInitialized;
    var ref = (0,webbridge_react_es/* useActions */.ol)(), openProduct = ref.openProduct, addToTapCart = ref.addToCart;
    var ref1 = (0,react_intersection_observer_dist/* useInView */.YD)({
        rootMargin: "400px",
        triggerOnce: true
    }), ref2 = ref1.ref, inView = ref1.inView;
    var ref3 = (0,dist.useProductByHandle)({
        handle: product.handle,
        fetchOnMount: inView
    }), fullProduct = ref3.product;
    var selectedVariant = (0,react.useMemo)(function() {
        var ref;
        return fullProduct === null || fullProduct === void 0 ? void 0 : (ref = fullProduct.variants) === null || ref === void 0 ? void 0 : ref[0];
    }, [
        fullProduct === null || fullProduct === void 0 ? void 0 : fullProduct.id
    ]);
    var localized = (0,dist.useLocalizedVariant)({
        variant: selectedVariant
    }).localized;
    var hasMultipleVariants = (0,react.useMemo)(function() {
        var ref;
        if (!fullProduct) return false;
        var count = 0;
        var hasMultiple = false;
        (ref = fullProduct.variants) === null || ref === void 0 ? void 0 : ref.find(function(variant) {
            if (variant.product.handle === fullProduct.handle) {
                count += 1;
                if (count > 1) {
                    hasMultiple = true;
                    return true;
                }
            }
            return false;
        });
        return hasMultiple;
    }, [
        fullProduct === null || fullProduct === void 0 ? void 0 : fullProduct.id
    ]);
    var hiddenProductHandles = (0,react.useMemo)(function() {
        return !!(gatedPages === null || gatedPages === void 0 ? void 0 : gatedPages.length) && gatedPages.reduce(function(carry, param) {
            var enable = param.enable, page = param.page;
            if (enable) {
                var pages = (0,_object_spread/* default */.Z)({}, page).pages;
                var _products = pages === null || pages === void 0 ? void 0 : pages.reduce(function(_carry, _page) {
                    var ref, ref1;
                    if (_page === null || _page === void 0 ? void 0 : _page.enableFullProductAccess) {
                        return _carry;
                    }
                    return (0,_to_consumable_array/* default */.Z)(_carry).concat((0,_to_consumable_array/* default */.Z)(((ref1 = _page === null || _page === void 0 ? void 0 : (ref = _page.products) === null || ref === void 0 ? void 0 : ref.map(function(param) {
                        var p = param.p;
                        return p === null || p === void 0 ? void 0 : p.handle;
                    })) === null || ref1 === void 0 ? void 0 : ref1.filter(Boolean)) || []));
                }, []);
                return (0,_to_consumable_array/* default */.Z)(carry).concat((0,_to_consumable_array/* default */.Z)(_products || []));
            }
            return carry;
        }, []);
    }, [
        gatedPages
    ]);
    var intellisuggestTrackClick = (0,react.useCallback)(function() {
        if (document.images) {
            var apiUrl = "".concat(window.location.protocol || "http:", "//").concat("nr3jmv", ".a.searchspring.io/api/");
            var imgTag = new Image();
            imgTag.src = "".concat(apiUrl, "track/track.json?d=").concat(product.intellisuggestData, "&s=").concat(product.intellisuggestSignature, "&u=").concat(encodeURIComponent("".concat("https://www.brumate.com", "/products/").concat(product.handle)), "&r=").concat(encodeURIComponent(document.referrer), "&bgfilter.ss_mobile_only=0");
        }
        return true;
    }, [
        product.id
    ]);
    var handleClick = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (isInitialized && (fullProduct === null || fullProduct === void 0 ? void 0 : fullProduct.legacyResourceId)) {
                    event.preventDefault();
                    openProduct({
                        productId: "".concat(fullProduct.legacyResourceId)
                    });
                    return [
                        2
                    ];
                }
                sendClickProductItemEvent({
                    isSearchResult: isSearchPage,
                    listIndex: index,
                    localized: localized,
                    product: fullProduct,
                    searchTerm: searchTerm,
                    selectedVariant: selectedVariant
                });
                intellisuggestTrackClick();
                return [
                    2
                ];
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }(), [
        index,
        localized,
        fullProduct === null || fullProduct === void 0 ? void 0 : fullProduct.id,
        selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id,
        isInitialized
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-comp": ProductItem.displayName,
        ref: ref2
    }, props), {
        onClick: function(event) {
            return onItemClick(event, index);
        },
        sx: (0,_object_spread/* default */.Z)({}, theme.wrapper, props.sx),
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                sx: {
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Image_Image_Image, {
                        fullProduct: fullProduct,
                        handleClick: handleClick,
                        enableFullProductAccess: enableFullProductAccess
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Details, {
                        product: product,
                        fullProduct: fullProduct,
                        isProductRow: isProductRow,
                        handleClick: handleClick,
                        enableFullProductAccess: enableFullProductAccess
                    })
                ]
            }),
            !hideAddToCart && !hasMultipleVariants && enableFullProductAccess && (hiddenProductHandles === null || hiddenProductHandles === void 0 ? void 0 : hiddenProductHandles.indexOf(product === null || product === void 0 ? void 0 : product.handle)) === -1 && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(AddToCart, {
                product: product,
                selectedVariant: selectedVariant,
                isProductItem: true,
                style: theme.atc,
                addToTapCart: addToTapCart,
                isInitialized: isInitialized
            }),
            hasMultipleVariants && enableFullProductAccess && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Link, {
                "data-comp": "SeeDetails",
                href: "/products/".concat(fullProduct === null || fullProduct === void 0 ? void 0 : fullProduct.handle),
                "aria-label": "View details for ".concat(fullProduct === null || fullProduct === void 0 ? void 0 : fullProduct.title),
                variant: "buttons.primary",
                sx: theme.atc,
                onClick: handleClick,
                children: "See Details"
            })
        ]
    }));
});
ProductItem.displayName = "ProductItem";

;// CONCATENATED MODULE: ./src/snippets/ProductItem/index.js


;// CONCATENATED MODULE: ./src/snippets/ProductReviews/ProductReviewsHead.jsx


function ProductReviewsHead() {
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)((head_default()), {
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("meta", {
                name: "oke:subscriber_id",
                content: "64fdab67-9789-4d89-bfa4-42a4cef5e5d8"
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("script", {
                async: true,
                src: "https://d3hw6dc1ow8pp2.cloudfront.net/reviews-widget-plus/js/okendo-reviews.js"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/snippets/ProductReviews/Header/Header.theme.js

var ProductReviews_Header_Header_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
        mb: 10
    };
    this.starWrapper = {
        mb: "1rem"
    };
    this.header = {
        variant: "text.reviewsHeading",
        mt: [
            15,
            80
        ]
    };
    this.percentage = {
        position: "absolute",
        width: "fit-content",
        py: 1,
        px: 5,
        backgroundColor: "black",
        bottom: "calc(100% - 13px)",
        left: "calc(50% - 30px)",
        fontWeight: 500
    };
    this.subtextBox = {
        mt: [
            10
        ],
        color: "white",
        alignSelf: "center",
        border: "1px solid",
        borderColor: "mediumGray",
        width: [
            300,
            "fit-content"
        ],
        py: [
            10,
            8
        ],
        px: 9,
        position: "relative"
    };
    this.subtext = {
        color: "text",
        fontWeight: 500
    };
}());

;// CONCATENATED MODULE: ./src/snippets/ProductReviews/Header/Header.jsx






var ProductReviews_Header_Header_Header = ProductReviews_Header_Header_theme_themed(function(param) {
    var theme = param.theme, text = param.text;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": ProductReviews_Header_Header_Header.displayName,
        sx: theme.wrapper,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                variant: "flex.row.center.center",
                sx: theme.starWrapper,
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Svg, {
                    alt: "Five Review Stars.",
                    width: "100px",
                    src: "/svgs/okendo-stars.svg",
                    sx: theme.star,
                    loading: "lazy"
                })
            }),
            (text === null || text === void 0 ? void 0 : text.heading) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Markdown, {
                text: text === null || text === void 0 ? void 0 : text.heading,
                textSx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.heading), {
                    textAlign: "center"
                })
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                sx: theme.subtextBox,
                children: [
                    (text === null || text === void 0 ? void 0 : text.percentage) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Paragraph */.nv, {
                        as: "h4",
                        sx: theme.percentage,
                        children: [
                            text === null || text === void 0 ? void 0 : text.percentage,
                            "%"
                        ]
                    }),
                    (text === null || text === void 0 ? void 0 : text.subtext) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Markdown, {
                        text: text === null || text === void 0 ? void 0 : text.subtext,
                        textSx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.subtext), {
                            textAlign: "center"
                        })
                    })
                ]
            })
        ]
    });
});
ProductReviews_Header_Header_Header.displayName = "Header";

;// CONCATENATED MODULE: ./src/snippets/ProductReviews/Header/index.js


;// CONCATENATED MODULE: ./src/snippets/ProductReviews/ProductReviews.theme.js

var ProductReviews_theme_themed = (0,create/* create */.U)(new function() {
    this.container = {
        variant: "layout.content",
        py: [
            15,
            16,
            17,
            18
        ],
        div: {
            fontFamily: '"Fellix", system-ui, -apple-system, BlinkMacSystemFont, sans-serif !important'
        }
    };
    this.spinnerWrapper = {
        width: "100%",
        height: "400px",
        position: "relative"
    };
    this.spinner = {
        width: "30px",
        color: "mediumDarkGray",
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)"
    };
}());

;// CONCATENATED MODULE: ./src/snippets/ProductReviews/ProductReviews.jsx










var ProductReviews = ProductReviews_theme_themed(function(param) {
    var theme = param.theme;
    var ref, ref1, ref2;
    var reviewsRef = (0,react.useRef)(null);
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useSelectedVariant */.BK)(), 1), selectedVariant = ref3[0];
    var settings = (0,dist.useSettings)();
    var product = (0,dist.useProductByHandle)({
        handle: selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref = selectedVariant.product) === null || ref === void 0 ? void 0 : ref.handle
    }).product;
    var ref4 = (0,react.useState)(false), okendoReady = ref4[0], setOkendoReady = ref4[1];
    var text = settings === null || settings === void 0 ? void 0 : (ref1 = settings.product) === null || ref1 === void 0 ? void 0 : ref1.reviews;
    var productId = product === null || product === void 0 ? void 0 : product.legacyResourceId;
    var setProduct = utils/* isBrowser */.jU && ((ref2 = window.okeWidgetApi) === null || ref2 === void 0 ? void 0 : ref2.setProduct);
    (0,react.useEffect)(function() {
        setOkendoReady(typeof setProduct === "function");
    }, [
        setProduct
    ]);
    (0,react.useEffect)(function() {
        if (!okendoReady) return;
        setProduct(reviewsRef.current, "shopify-".concat(productId || ""));
    }, [
        okendoReady,
        productId
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_jsx_runtime_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(ProductReviewsHead, {}),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Container */.W2, {
                "data-comp": ProductReviews.displayName,
                sx: theme.container,
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(ProductReviews_Header_Header_Header, {
                        text: text
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                        ref: reviewsRef,
                        "data-oke-widget": true,
                        "data-oke-reviews-product-id": "shopify-".concat(productId || "")
                    }),
                    !okendoReady && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                        sx: theme.spinnerWrapper,
                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Spinner */.$j, {
                            sx: theme.spinner
                        })
                    })
                ]
            })
        ]
    });
});
ProductReviews.displayName = "ProductReviews";

;// CONCATENATED MODULE: ./src/snippets/ProductReviews/index.js


// EXTERNAL MODULE: ../node_modules/swiper/esm/components/a11y/a11y.js
var a11y = __webpack_require__(15753);
// EXTERNAL MODULE: ./src/snippets/ProductSwiper/Navigation/NavigationButton.jsx
var Navigation_NavigationButton = __webpack_require__(34086);
// EXTERNAL MODULE: ./src/snippets/ProductSwiper/Navigation/Navigation.theme.js
var Navigation_theme = __webpack_require__(45158);
;// CONCATENATED MODULE: ./src/snippets/ProductSwiper/Navigation/Navigation.jsx




var Navigation_Navigation = (0,Navigation_theme/* themed */.H)(function(param) {
    var theme = param.theme, swiper = param.swiper, loop = param.loop, count = param.count, leftSx = param.leftSx, rightSx = param.rightSx;
    var ref = (0,react.useState)(true), isStart = ref[0], setIsStart = ref[1];
    var ref1 = (0,react.useState)(false), isEnd = ref1[0], setIsEnd = ref1[1];
    var setStartAndEndOnSwiperChange = (0,react.useCallback)(function() {
        if (!swiper) return;
        if (loop) {
            setIsStart(false);
            setIsEnd(false);
        }
        if (!loop) {
            setIsStart(swiper.isBeginning);
            setIsEnd(swiper.isEnd);
            swiper.on("slideChange", function() {
                setIsStart(swiper.isBeginning);
                setIsEnd(swiper.isEnd);
            });
        }
    }, [
        swiper,
        loop
    ]);
    (0,react.useEffect)(function() {
        setStartAndEndOnSwiperChange();
    }, [
        swiper,
        loop
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_jsx_runtime_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Navigation_NavigationButton/* NavigationButton */.W, {
                onClick: function() {
                    return swiper.slidePrev();
                },
                inactive: isStart,
                count: count,
                sx: leftSx,
                alt: "Previous product"
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Navigation_NavigationButton/* NavigationButton */.W, {
                onClick: function() {
                    return swiper.slideNext();
                },
                src: "/svgs/arrow-right.svg#arrow-right",
                alt: "Next product",
                inactive: isEnd,
                isNext: true,
                count: count,
                sx: rightSx
            })
        ]
    });
});
Navigation_Navigation.displayName = "Navigation";

;// CONCATENATED MODULE: ./src/snippets/ProductSwiper/Navigation/index.js


// EXTERNAL MODULE: ./src/snippets/ProductSwiper/useProductSwiperParams.js
var useProductSwiperParams = __webpack_require__(65207);
;// CONCATENATED MODULE: ./src/snippets/ProductSwiper/ProductSwiper.theme.js

var ProductSwiper_theme_themed = (0,create/* create */.U)(new function() {
    this.swiper = {
        width: "100%",
        position: "relative",
        cursor: "grab",
        ".swiper-container, .swiper-wrapper": {
            width: "100%",
            height: "auto !important"
        },
        ".swiper-slide": {
            width: "100%"
        }
    };
}());

;// CONCATENATED MODULE: ./src/snippets/ProductSwiper/ProductSwiper.jsx













core_class/* default.use */.Z.use([
    a11y/* default */.Z
]);
var ProductSwiper = ProductSwiper_theme_themed(function(_param) {
    var theme = _param.theme, products = _param.products, loop = _param.loop, count = _param.count, _params = _param.params, params = _params === void 0 ? {} : _params, isProductRecs = _param.isProductRecs, isProductRow = _param.isProductRow, hideAddToCart = _param.hideAddToCart, onItemClick = _param.onItemClick, passedSwiper = _param.swiper, setPassedSwiper = _param.setSwiper, inputRef = _param.inputRef, swiperClassName = _param.swiperClassName, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme",
        "products",
        "loop",
        "count",
        "params",
        "isProductRecs",
        "isProductRow",
        "hideAddToCart",
        "onItemClick",
        "swiper",
        "setSwiper",
        "inputRef",
        "swiperClassName"
    ]);
    var defaultParams = (0,useProductSwiperParams/* useProductSwiperParams */.c)({
        isProductRecs: isProductRecs,
        loopEnabled: loop,
        count: count
    });
    var ref = (0,react.useState)(null), localSwiper = ref[0], setLocalSwiper = ref[1];
    var swiper = passedSwiper || localSwiper;
    var setSwiper = setPassedSwiper || setLocalSwiper;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-comp": ProductSwiper.displayName
    }, props), {
        sx: (0,_object_spread/* default */.Z)({}, theme.swiper, props.sx),
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(react_swiper/* Swiper */.t, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            className: swiperClassName,
            onSwiper: setSwiper,
            a11y: {
                enabled: true
            }
        }, defaultParams), {
            children: products === null || products === void 0 ? void 0 : products.map(function(item, index) {
                var product = isProductRecs ? item : item.product;
                if (!(product === null || product === void 0 ? void 0 : product.handle)) return null;
                return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(swiper_slide/* SwiperSlide */.o, {
                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(ProductItem, {
                        product: product,
                        hideAddToCart: product === null || product === void 0 ? void 0 : product.hideAddToCart,
                        isProductRow: isProductRow,
                        index: index,
                        onItemClick: onItemClick
                    })
                }, index);
            })
        }))
    }));
});
ProductSwiper.displayName = "ProductSwiper";
ProductSwiper.propTypes = {
    isProductRecs: (prop_types_default()).bool,
    products: (prop_types_default()).array,
    params: (prop_types_default()).object,
    loop: (prop_types_default()).bool,
    count: (prop_types_default()).bool
};

;// CONCATENATED MODULE: ./src/snippets/ProductSwiper/index.js



// EXTERNAL MODULE: ./src/snippets/Cart/Upsell/Navigation/index.js + 3 modules
var Upsell_Navigation = __webpack_require__(1183);
// EXTERNAL MODULE: ./src/snippets/Cart/Upsell/SliderItem/UpsellAddToCart.jsx
var UpsellAddToCart = __webpack_require__(11578);
;// CONCATENATED MODULE: ./src/snippets/ProductUpsellsList/ProductUpsellsListItem/ProductUpsellsListItem.theme.js

var ProductUpsellsListItem_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        variant: "flex.row.start.center",
        border: [
            null,
            null,
            "1px solid"
        ],
        borderColor: [
            null,
            null,
            "gray"
        ],
        borderRadius: [
            null,
            null,
            4
        ],
        width: "100%",
        px: [
            14,
            null,
            12
        ],
        py: [
            6
        ]
    };
    this.picture = {
        width: "72px",
        mr: 8,
        spinner: {
            width: "16px",
            color: "mediumDarkGray",
            m: "auto"
        }
    };
    this.details = {
        variant: "flex.column.start"
    };
    this.title = {
        variant: "text.h6",
        minHeight: [
            "18px",
            null,
            "22px"
        ],
        fontSize: [
            1,
            null,
            5
        ],
        lineHeight: [
            18,
            null,
            22
        ]
    };
    this.variant = {
        variant: "text.base",
        color: "mediumDarkGray",
        minHeight: [
            "18px",
            null,
            "22px"
        ],
        fontSize: [
            1,
            null,
            4
        ],
        lineHeight: [
            18,
            null,
            22
        ]
    };
    this.price = {
        minHeight: [
            "18px",
            null,
            "22px"
        ],
        mb: 3,
        p: {
            variant: "text.base",
            minHeight: [
                "18px",
                null,
                "22px"
            ],
            fontSize: [
                1,
                null,
                4
            ],
            lineHeight: [
                18,
                null,
                22
            ]
        }
    };
    this.newPrice = {
        color: "red",
        mr: 4
    };
    this.compareAtPrice = {
        textDecoration: "line-through",
        color: "mediumDarkGray"
    };
    this.atc = {
        height: "15px"
    };
    this.mobileAtc = {
        display: [
            null,
            null,
            "none"
        ]
    };
    this.desktopAtc = {
        variant: "flex.column.center.center",
        display: [
            "none",
            null,
            "flex"
        ],
        ml: "auto",
        minWidth: "67px"
    };
    this.dropdown = {
        minWidth: "min-content",
        maxWidth: "fit-content",
        width: "auto",
        my: "8px"
    };
    this.option = {
        variant: "flex.row.between.center",
        px: 6,
        width: "100%",
        top: "0px",
        name: {
            variant: "text.base",
            mr: 7
        },
        image: {
            ml: "auto"
        }
    };
}());

;// CONCATENATED MODULE: ./src/snippets/ProductUpsellsList/ProductUpsellsListItem/ProductUpsellsListItem.jsx










var ProductUpsellsListItem = ProductUpsellsListItem_theme_themed(function(param) {
    var theme = param.theme, handle = param.handle, fullProduct = param.fullProduct, zIndex = param.zIndex;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var sizeVariants = (0,react.useMemo)(function() {
        var ref;
        var variantArray = fullProduct === null || fullProduct === void 0 ? void 0 : (ref = fullProduct.variants) === null || ref === void 0 ? void 0 : ref.filter(function(variant) {
            return variant.product.handle === handle && variant.selectedOptionsMap.Size !== undefined;
        }).sort(function(a, b) {
            return a.position - b.position;
        });
        return variantArray;
    }, [
        fullProduct === null || fullProduct === void 0 ? void 0 : fullProduct.variants
    ]);
    var colorVariants = (0,react.useMemo)(function() {
        var ref;
        var variantArray = fullProduct === null || fullProduct === void 0 ? void 0 : (ref = fullProduct.variants) === null || ref === void 0 ? void 0 : ref.filter(function(variant) {
            return variant.product.handle === handle && variant.selectedOptionsMap.Color !== undefined;
        }).sort(function(a, b) {
            return a.position - b.position;
        });
        return variantArray;
    }, [
        fullProduct === null || fullProduct === void 0 ? void 0 : fullProduct.variants
    ]);
    var initialVariant = (0,react.useMemo)(function() {
        var ref;
        if ((sizeVariants === null || sizeVariants === void 0 ? void 0 : sizeVariants.length) > 1) {
            return sizeVariants === null || sizeVariants === void 0 ? void 0 : sizeVariants.find(function(variant) {
                return variant.inventoryQuantity > 0;
            });
        }
        if ((colorVariants === null || colorVariants === void 0 ? void 0 : colorVariants.length) > 1) {
            return colorVariants === null || colorVariants === void 0 ? void 0 : colorVariants.find(function(variant) {
                return variant.inventoryQuantity > 0;
            });
        }
        return fullProduct === null || fullProduct === void 0 ? void 0 : (ref = fullProduct.variants) === null || ref === void 0 ? void 0 : ref[0];
    }, [
        sizeVariants,
        colorVariants,
        fullProduct === null || fullProduct === void 0 ? void 0 : (ref = fullProduct.variants) === null || ref === void 0 ? void 0 : ref[0]
    ]);
    var ref8 = (0,react.useState)(initialVariant), selectedVariant = ref8[0], setSelectedVariant = ref8[1];
    var handleSelect = (0,react.useCallback)(function(option) {
        var selectedSizeVariant = sizeVariants === null || sizeVariants === void 0 ? void 0 : sizeVariants.find(function(variant) {
            var ref;
            return (variant === null || variant === void 0 ? void 0 : (ref = variant.selectedOptionsMap) === null || ref === void 0 ? void 0 : ref.Size) === option;
        });
        var selectedColorVariant = colorVariants === null || colorVariants === void 0 ? void 0 : colorVariants.find(function(variant) {
            var ref;
            return (variant === null || variant === void 0 ? void 0 : (ref = variant.selectedOptionsMap) === null || ref === void 0 ? void 0 : ref.Color) === option;
        });
        setSelectedVariant(selectedSizeVariant || selectedColorVariant);
    }, [
        sizeVariants,
        colorVariants
    ]);
    var productVariant = (0,react.useMemo)(function() {
        var ref;
        if ((sizeVariants === null || sizeVariants === void 0 ? void 0 : sizeVariants.length) > 1 && selectedVariant || (colorVariants === null || colorVariants === void 0 ? void 0 : colorVariants.length) > 1 && selectedVariant) {
            return selectedVariant;
        }
        if ((sizeVariants === null || sizeVariants === void 0 ? void 0 : sizeVariants.length) > 1 && !selectedVariant || (colorVariants === null || colorVariants === void 0 ? void 0 : colorVariants.length) > 1 && !selectedVariant) {
            return initialVariant;
        }
        return fullProduct === null || fullProduct === void 0 ? void 0 : (ref = fullProduct.variants) === null || ref === void 0 ? void 0 : ref[0];
    }, [
        sizeVariants,
        colorVariants,
        initialVariant,
        fullProduct === null || fullProduct === void 0 ? void 0 : (ref1 = fullProduct.variants) === null || ref1 === void 0 ? void 0 : ref1[0],
        selectedVariant, 
    ]);
    var title = (0,react.useMemo)(function() {
        var fullTitle = fullProduct === null || fullProduct === void 0 ? void 0 : fullProduct.title;
        var splitIndex = (fullTitle === null || fullTitle === void 0 ? void 0 : fullTitle.indexOf("|")) || -1;
        return {
            product: splitIndex >= 0 ? fullTitle === null || fullTitle === void 0 ? void 0 : fullTitle.slice(0, splitIndex).trim() : fullTitle,
            variant: splitIndex >= 0 ? fullTitle === null || fullTitle === void 0 ? void 0 : fullTitle.slice(splitIndex + 1).trim() : ""
        };
    }, [
        fullProduct === null || fullProduct === void 0 ? void 0 : fullProduct.title
    ]);
    var image = (sizeVariants === null || sizeVariants === void 0 ? void 0 : sizeVariants.length) > 1 && selectedVariant || (colorVariants === null || colorVariants === void 0 ? void 0 : colorVariants.length) > 1 && selectedVariant ? selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref2 = selectedVariant.image) === null || ref2 === void 0 ? void 0 : ref2.originalSrc : (ref4 = fullProduct === null || fullProduct === void 0 ? void 0 : (ref3 = fullProduct.media) === null || ref3 === void 0 ? void 0 : ref3.find(function(item) {
        return item.mediaContentType === "IMAGE";
    })) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.image) === null || ref5 === void 0 ? void 0 : ref5.originalSrc;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
        "data-comp": ProductUpsellsListItem.displayName,
        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.wrapper), {
            zIndex: zIndex
        }),
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Picture, {
                alt: fullProduct === null || fullProduct === void 0 ? void 0 : fullProduct.title,
                images: [
                    {
                        src: image,
                        width: 350,
                        ratio: 1
                    }, 
                ],
                sx: theme.picture,
                children: !image && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Spinner */.$j, {
                    sx: theme.picture.spinner
                })
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                sx: theme.details,
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                        as: "h6",
                        sx: theme.title,
                        children: title === null || title === void 0 ? void 0 : title.product
                    }),
                    (sizeVariants === null || sizeVariants === void 0 ? void 0 : sizeVariants.length) > 1 && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(Dropdown, {
                            variant: "sizes",
                            initial: sizeVariants === null || sizeVariants === void 0 ? void 0 : (ref6 = sizeVariants[0]) === null || ref6 === void 0 ? void 0 : ref6.selectedOptionsMap.Size,
                            onSelected: function() {
                                var _ref = (0,_async_to_generator/* default */.Z)(function(optionSelected) {
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        handleSelect(optionSelected);
                                        return [
                                            2
                                        ];
                                    });
                                });
                                return function(optionSelected) {
                                    return _ref.apply(this, arguments);
                                };
                            }(),
                            sx: theme.dropdown,
                            children: [
                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Dropdown.Selected, {
                                    children: function(param) {
                                        var selected = param.selected, selecting = param.selecting;
                                        /*#__PURE__*/ return (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                                            sx: theme.option,
                                            children: [
                                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                                                    sx: theme.option.name,
                                                    children: selected
                                                }),
                                                (sizeVariants === null || sizeVariants === void 0 ? void 0 : sizeVariants.length) ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Image */.Ee, {
                                                    alt: "Toggle dropdown",
                                                    src: selecting ? "/svgs/chevron/up.svg#up" : "/svgs/chevron/down.svg#down",
                                                    width: "12px",
                                                    sx: theme.option.image
                                                }) : null
                                            ]
                                        });
                                    }
                                }),
                                sizeVariants === null || sizeVariants === void 0 ? void 0 : sizeVariants.map(function(variant) {
                                    var size = variant.selectedOptionsMap.Size;
                                    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Dropdown.Option, {
                                        option: size,
                                        children: function(param) {
                                            var option = param.option;
                                            return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                                                sx: theme.option,
                                                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                                                    sx: theme.option.name,
                                                    children: option
                                                })
                                            });
                                        }
                                    }, size);
                                })
                            ]
                        })
                    }),
                    (colorVariants === null || colorVariants === void 0 ? void 0 : colorVariants.length) > 1 && !(sizeVariants === null || sizeVariants === void 0 ? void 0 : sizeVariants.length) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(Dropdown, {
                            variant: "colors",
                            initial: colorVariants === null || colorVariants === void 0 ? void 0 : (ref7 = colorVariants[0]) === null || ref7 === void 0 ? void 0 : ref7.selectedOptionsMap.Color,
                            onSelected: function() {
                                var _ref = (0,_async_to_generator/* default */.Z)(function(optionSelected) {
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        handleSelect(optionSelected);
                                        return [
                                            2
                                        ];
                                    });
                                });
                                return function(optionSelected) {
                                    return _ref.apply(this, arguments);
                                };
                            }(),
                            sx: theme.dropdown,
                            children: [
                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Dropdown.Selected, {
                                    children: function(param) {
                                        var selected = param.selected, selecting = param.selecting;
                                        /*#__PURE__*/ return (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                                            sx: theme.option,
                                            children: [
                                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                                                    sx: theme.option.name,
                                                    children: selected
                                                }),
                                                (colorVariants === null || colorVariants === void 0 ? void 0 : colorVariants.length) ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Image */.Ee, {
                                                    alt: "Toggle dropdown",
                                                    src: selecting ? "/svgs/chevron/up.svg#up" : "/svgs/chevron/down.svg#down",
                                                    width: "12px",
                                                    sx: theme.option.image
                                                }) : null
                                            ]
                                        });
                                    }
                                }),
                                colorVariants === null || colorVariants === void 0 ? void 0 : colorVariants.map(function(variant) {
                                    var color = variant.selectedOptionsMap.Color;
                                    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Dropdown.Option, {
                                        option: color,
                                        children: function(param) {
                                            var option = param.option;
                                            return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                                                sx: theme.option,
                                                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                                                    sx: theme.option.name,
                                                    children: option
                                                })
                                            });
                                        }
                                    }, color);
                                })
                            ]
                        })
                    }),
                    (sizeVariants === null || sizeVariants === void 0 ? void 0 : sizeVariants.length) <= 1 && (colorVariants === null || colorVariants === void 0 ? void 0 : colorVariants.length) <= 1 ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                        sx: theme.variant,
                        children: title === null || title === void 0 ? void 0 : title.variant
                    }) : null,
                    productVariant && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Locale.Variant, {
                        variant: productVariant,
                        sx: theme.price,
                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Locale.Price, {
                            children: function(param) {
                                var priceV2 = param.priceV2, compareAtPriceV2 = param.compareAtPriceV2, isOnSale = param.isOnSale;
                                return isOnSale ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                                    children: [
                                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                                            sx: theme.newPrice,
                                            children: priceV2.locale
                                        }),
                                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                                            sx: theme.compareAtPrice,
                                            children: compareAtPriceV2.locale
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                                    children: priceV2.locale
                                });
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                        sx: theme.mobileAtc,
                        children: fullProduct && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(UpsellAddToCart/* UpsellAddToCart */.D, {
                            product: fullProduct,
                            selectedVariant: productVariant
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                sx: theme.desktopAtc,
                children: fullProduct && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(UpsellAddToCart/* UpsellAddToCart */.D, {
                    product: fullProduct,
                    selectedVariant: productVariant
                })
            })
        ]
    });
});

;// CONCATENATED MODULE: ./src/snippets/ProductUpsellsList/ProductUpsellsListItem/index.js


;// CONCATENATED MODULE: ./src/snippets/ProductUpsellsList/ProductUpselItem/ProductUpselItem.jsx



function ProductUpselItem(param) {
    var handle = param.handle, uProducts = param.uProducts, setUProducts = param.setUProducts;
    var product = (0,dist.useProductByHandle)({
        handle: handle
    }).product;
    (0,react.useEffect)(function() {
        if ((product === null || product === void 0 ? void 0 : product.handle) && (product === null || product === void 0 ? void 0 : product.status) !== "DRAFT" && (!uProducts || (uProducts === null || uProducts === void 0 ? void 0 : uProducts.length) < 5)) {
            if (!(uProducts === null || uProducts === void 0 ? void 0 : uProducts.includes(product === null || product === void 0 ? void 0 : product.handle))) {
                setUProducts(function(prev) {
                    return (0,_to_consumable_array/* default */.Z)(prev).concat([
                        product
                    ]);
                });
            }
        }
    }, [
        product === null || product === void 0 ? void 0 : product.status,
        product === null || product === void 0 ? void 0 : product.handle
    ]);
    return null;
}

;// CONCATENATED MODULE: ./src/snippets/ProductUpsellsList/ProductUpselItem/index.js


;// CONCATENATED MODULE: ./src/snippets/ProductUpsellsList/ProductUpsellsList.theme.js

var ProductUpsellsList_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        mt: 10,
        mb: 17,
        width: "100%"
    };
    this.heading = {
        mb: 6
    };
    this.items = {
        variant: "flex.column.start",
        display: [
            "none",
            null,
            "flex"
        ],
        gap: 4
    };
    this.carousel = {
        display: [
            null,
            null,
            "none"
        ],
        border: "1px solid",
        borderColor: "gray",
        borderLeft: "none",
        borderRight: "none",
        position: "relative",
        overflow: "visible",
        ".swiper-container": {
            overflow: "visible"
        },
        ".swiper-wrapper": {
            minHeight: "175px"
        },
        ".swiper-slide": {
            alignSelf: "center"
        }
    };
    this.expand = {
        variant: "buttons.plain",
        fontFamily: "body",
        fontSize: 4,
        fontWeight: 400,
        height: "auto",
        lineHeight: 22,
        mx: "auto",
        textDecoration: "underline",
        textTransform: "none",
        ":hover": {
            background: "transparent"
        }
    };
}());

;// CONCATENATED MODULE: ./src/snippets/ProductUpsellsList/ProductUpsellsList.jsx









core_class/* default.use */.Z.use([
    a11y/* default */.Z
]);
var ProductUpsellsList = ProductUpsellsList_theme_themed(function(param) {
    var theme = param.theme, heading = param.heading, products = param.products;
    var ref = (0,react.useState)(false), showMore = ref[0], setShowMore = ref[1];
    var ref1 = (0,react.useState)(null), swiper = ref1[0], setSwiper = ref1[1];
    var ref2 = (0,react.useState)([]), uProducts = ref2[0], setUProducts = ref2[1];
    var handles = (0,react.useMemo)(function() {
        if (!(products === null || products === void 0 ? void 0 : products.length)) return [];
        return products.reduce(function(_handles, param) {
            var product = param.product;
            if (product === null || product === void 0 ? void 0 : product.handle) _handles.push(product.handle);
            return _handles;
        }, []);
    }, [
        products
    ]);
    (0,react.useEffect)(function() {
        setUProducts([]);
    }, [
        handles
    ]);
    if (!(products === null || products === void 0 ? void 0 : products.length) || !handles.length) return null;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Container */.W2, {
        "data-comp": ProductUpsellsList.displayName,
        sx: theme.wrapper,
        children: [
            !!(uProducts === null || uProducts === void 0 ? void 0 : uProducts.length) && heading && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                variant: "text.label",
                sx: theme.heading,
                children: heading
            }),
            (uProducts === null || uProducts === void 0 ? void 0 : uProducts.length) === 0 && handles.map(function(handle, index) {
                return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(ProductUpselItem, {
                    handle: handle,
                    uProducts: uProducts,
                    setUProducts: setUProducts
                }, "us-item-".concat(handle, "-").concat(index));
            }),
            !!(uProducts === null || uProducts === void 0 ? void 0 : uProducts.length) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_jsx_runtime_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                        sx: theme.carousel,
                        children: [
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(react_swiper/* Swiper */.t, {
                                onSwiper: setSwiper,
                                spaceBetween: 0,
                                slidesPerView: 1,
                                slidesOffsetBefore: 0,
                                slidesOffsetAfter: 0,
                                a11y: {
                                    enabled: true
                                },
                                loop: (products === null || products === void 0 ? void 0 : products.length) > 1,
                                children: (uProducts || []).map(function(product, index) {
                                    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(swiper_slide/* SwiperSlide */.o, {
                                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(ProductUpsellsListItem, {
                                            handle: product === null || product === void 0 ? void 0 : product.handle,
                                            fullProduct: product
                                        })
                                    }, "".concat(product === null || product === void 0 ? void 0 : product.handle, "-").concat(index));
                                })
                            }),
                            (uProducts === null || uProducts === void 0 ? void 0 : uProducts.length) > 1 && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Upsell_Navigation/* Navigation */.W, {
                                swiper: swiper
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                        sx: theme.items,
                        children: [
                            (uProducts || []).map(function(product, index) {
                                if (!showMore && index > 1) return null;
                                return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(ProductUpsellsListItem, {
                                    handle: product === null || product === void 0 ? void 0 : product.handle,
                                    fullProduct: product,
                                    zIndex: uProducts.length - index
                                }, "".concat(product === null || product === void 0 ? void 0 : product.handle, "-").concat(index));
                            }),
                            (uProducts === null || uProducts === void 0 ? void 0 : uProducts.length) > 2 ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                                sx: theme.expand,
                                onClick: function() {
                                    setShowMore(!showMore);
                                },
                                children: showMore ? "See Less" : "See More"
                            }) : null
                        ]
                    })
                ]
            })
        ]
    });
});
ProductUpsellsList.displayName = "ProductUpsellsList";

;// CONCATENATED MODULE: ./src/snippets/ProductUpsellsList/index.js


;// CONCATENATED MODULE: ./src/snippets/RebuyModal/RebuyModal.theme.js


var RebuyModal_theme_themed = (0,create/* create */.U)(new function() {
    var _obj;
    this.wrapper = (_obj = {
        width: "100%",
        minWidth: "300px"
    }, (0,_define_property/* default */.Z)(_obj, "width", [
        "calc(100% - 32px)",
        "1000px"
    ]), (0,_define_property/* default */.Z)(_obj, "@media only screen and (max-width: 479px)", {
        minWidth: "250px"
    }), (0,_define_property/* default */.Z)(_obj, "textAlign", "center"), (0,_define_property/* default */.Z)(_obj, "pt", 10), _obj);
    this.bullets = {
        mt: 10,
        mb: 8,
        display: [
            "flex"
        ],
        justifyContent: "center",
        gap: 9,
        width: "100%",
        height: "8px",
        ".swiper-pagination-bullet": {
            cursor: "pointer",
            bg: "black",
            opacity: 0.2
        },
        ".swiper-pagination-bullet-active": {
            opacity: "1 !important"
        },
        position: "static"
    };
    this.item = {
        variant: "flex.row.start.center",
        width: "100%",
        cursor: "pointer",
        color: "text",
        height: "inherit",
        pl: 10,
        pr: 8,
        "&:hover": {
            bg: "whitesmoke"
        },
        icon: {
            width: 16
        },
        selectedName: {
            variant: "text.base",
            pt: 6,
            overflow: "hidden",
            textOverflow: "ellipsis"
        },
        optionName: {
            variant: "text.base"
        },
        toggle: {
            width: 16,
            ml: "auto"
        }
    };
    this.price = {
        lineThrough: {
            variant: "text.base",
            textDecoration: "line-through",
            ml: 4,
            color: "mediumDarkGray"
        },
        new: {
            variant: "text.base",
            color: "red"
        },
        regular: {
            variant: "text.base"
        }
    };
}());

;// CONCATENATED MODULE: ./src/snippets/RebuyModal/RebuyItemImage.jsx





var RebuyItemImage = RebuyModal_theme_themed(function(param) {
    var selectedVariant = param.selectedVariant, fullProduct = param.fullProduct;
    var ref, ref1;
    var isIcePack = selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref = selectedVariant.product) === null || ref === void 0 ? void 0 : ref.handle.includes("ice-pack");
    var ref2 = (0,hooks/* useProductItemImages */.Ep)({
        product: fullProduct
    }), primary = ref2.primary, hover = ref2.hover;
    var selected = selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.image;
    var primaryImage = (selected === null || selected === void 0 ? void 0 : selected.originalSrc) || (primary === null || primary === void 0 ? void 0 : primary.originalSrc);
    if (!primaryImage) return null;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Picture, {
        alt: selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref1 = selectedVariant.product) === null || ref1 === void 0 ? void 0 : ref1.title,
        images: [
            {
                src: primaryImage,
                width: 240,
                ratio: 1
            }, 
        ],
        hoverImages: isIcePack ? [] : [
            {
                src: hover === null || hover === void 0 ? void 0 : hover.originalSrc,
                width: 240,
                ratio: 1
            }, 
        ],
        disableHoverMobile: false,
        imageBgColor: "lightGray",
        hoverImageBgColor: "lightGray"
    });
});
RebuyItemImage.displayName = "RebuyItemImage";

;// CONCATENATED MODULE: ./src/snippets/RebuyModal/RebuyItem.jsx










var RebuyItem = RebuyModal_theme_themed(function(_param) {
    var theme = _param.theme, isUpsell = _param.isUpsell, product = _param.product, productHandle = _param.productHandle, _onItemClick = _param.onItemClick, onItemClick = _onItemClick === void 0 ? function() {} : _onItemClick, index = _param.index, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme",
        "isUpsell",
        "product",
        "productHandle",
        "onItemClick",
        "index"
    ]);
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    if (!product) return null;
    var ref9 = (0,dist.useProductByHandle)({
        handle: product.handle
    }), fullProduct = ref9.product;
    var cart = (0,dist.useCart)();
    var cartRemoveItem = (0,dist.useCartRemoveItem)().cartRemoveItem;
    var handleUpsellRemove = function() {
        var ref;
        var removeItem = cart === null || cart === void 0 ? void 0 : (ref = cart.lines) === null || ref === void 0 ? void 0 : ref.find(function(item) {
            var ref, ref1;
            return (item === null || item === void 0 ? void 0 : (ref = item.variant) === null || ref === void 0 ? void 0 : (ref1 = ref.product) === null || ref1 === void 0 ? void 0 : ref1.handle) == productHandle;
        });
        if (isUpsell && removeItem) {
            cartRemoveItem({
                lineId: removeItem.id
            });
        }
    };
    var ref10 = (0,react.useState)(null), selectedVariant = ref10[0], setSelectedVariant = ref10[1];
    var updateSelectedVariant = function(option) {
        setSelectedVariant(option);
    };
    var titleArray = fullProduct === null || fullProduct === void 0 ? void 0 : (ref = fullProduct.title) === null || ref === void 0 ? void 0 : ref.split(" | ");
    var title = titleArray === null || titleArray === void 0 ? void 0 : titleArray[0];
    var subTitle = titleArray === null || titleArray === void 0 ? void 0 : titleArray[1];
    var size = titleArray === null || titleArray === void 0 ? void 0 : titleArray[2];
    if (size) subTitle += " | ".concat(size);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-comp": RebuyItem.displayName
    }, props), {
        onClick: function(event) {
            return onItemClick(event, index);
        },
        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props.sx), {
            flexDirection: "column",
            width: "100%",
            maxWidth: "200px",
            mx: "auto"
        }),
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                sx: {
                    width: "100%",
                    maxWidth: "200px",
                    mx: "auto"
                },
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                        sx: {
                            position: "relative"
                        },
                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Link, {
                            href: "/products/".concat(product.handle),
                            "aria-label": fullProduct === null || fullProduct === void 0 ? void 0 : fullProduct.title,
                            sx: {
                                mb: 4,
                                position: "relative"
                            },
                            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(RebuyItemImage, {
                                selectedVariant: selectedVariant || (fullProduct === null || fullProduct === void 0 ? void 0 : (ref1 = fullProduct.variants) === null || ref1 === void 0 ? void 0 : ref1[0]),
                                fullProduct: fullProduct
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                        sx: {
                            fontSize: [
                                "15px",
                                "17px"
                            ],
                            fontWeight: "bold"
                        },
                        children: title
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                        sx: {
                            variant: "text.base",
                            color: "#8C8C8D"
                        },
                        children: subTitle
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                        sx: {
                            minHeight: "22px",
                            mt: [
                                0,
                                3
                            ],
                            mb: 3
                        },
                        children: (fullProduct === null || fullProduct === void 0 ? void 0 : (ref2 = fullProduct.variants) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.product) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Locale.Variant, {
                            variant: selectedVariant || (fullProduct === null || fullProduct === void 0 ? void 0 : (ref4 = fullProduct.variants) === null || ref4 === void 0 ? void 0 : ref4[0]),
                            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Locale.Price, {
                                children: function(param) {
                                    var priceV2 = param.priceV2, compareAtPriceV2 = param.compareAtPriceV2, isOnSale = param.isOnSale;
                                    return isOnSale ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                                        sx: {
                                            justifyContent: "center"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                                                sx: theme.price.new,
                                                children: priceV2.locale
                                            }),
                                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                                                sx: theme.price.lineThrough,
                                                children: compareAtPriceV2.locale
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                                        sx: theme.price.regular,
                                        children: priceV2.locale
                                    });
                                }
                            })
                        })
                    }),
                    (fullProduct === null || fullProduct === void 0 ? void 0 : (ref5 = fullProduct.variants) === null || ref5 === void 0 ? void 0 : ref5[0]) && (fullProduct === null || fullProduct === void 0 ? void 0 : fullProduct.variants.length) > 1 && (fullProduct === null || fullProduct === void 0 ? void 0 : (ref6 = fullProduct.handle) === null || ref6 === void 0 ? void 0 : ref6.includes("ice-pack")) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(Dropdown, {
                            label: "Options",
                            initial: fullProduct === null || fullProduct === void 0 ? void 0 : (ref7 = fullProduct.variants) === null || ref7 === void 0 ? void 0 : ref7[0],
                            onSelected: updateSelectedVariant,
                            sx: {
                                position: "relative",
                                zIndex: 69
                            },
                            children: [
                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Dropdown.Selected, {
                                    children: function(param) {
                                        var selecting = param.selecting, selected = param.selected;
                                        /*#__PURE__*/ return (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                                            sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.item), {
                                                bg: selecting ? "lightGray" : "background"
                                            }),
                                            children: [
                                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                                                    sx: theme.item.selectedName,
                                                    children: selected === null || selected === void 0 ? void 0 : selected.title
                                                }),
                                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Svg, {
                                                    alt: "Select a variant",
                                                    viewBox: "0 0 16 16",
                                                    src: "/svgs/chevron/up.svg#up",
                                                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.item.toggle), {
                                                        transition: "all 0.2s ease-in-out",
                                                        transform: selecting ? "rotate(0deg)" : "rotate(-180deg)"
                                                    })
                                                })
                                            ]
                                        });
                                    }
                                }),
                                fullProduct === null || fullProduct === void 0 ? void 0 : fullProduct.variants.map(function(variant) {
                                    /*#__PURE__*/ return (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Dropdown.Option, {
                                        option: variant,
                                        children: function(param) {
                                            var selecting = param.selecting, isSelected = param.isSelected, option = param.option;
                                            return isSelected ? null : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                                                sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.item), {
                                                    bg: isSelected ? "lightGray" : "background"
                                                }),
                                                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                                                    sx: theme.item.optionName,
                                                    children: variant === null || variant === void 0 ? void 0 : variant.title
                                                })
                                            });
                                        }
                                    }, variant.title);
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                sx: {
                    textAlign: "center",
                    maxWidth: 250,
                    mx: "auto"
                },
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(AddToCart, {
                    product: product,
                    selectedVariant: selectedVariant || (fullProduct === null || fullProduct === void 0 ? void 0 : (ref8 = fullProduct.variants) === null || ref8 === void 0 ? void 0 : ref8[0]),
                    sx: theme.atc,
                    handleUpsellRemove: handleUpsellRemove,
                    rebuyWidget: isUpsell ? "Pack Rebuy Upsell" : "Pack Rebuy Cross-Sell"
                })
            })
        ]
    }));
});
RebuyItem.displayName = "RebuyItem";

;// CONCATENATED MODULE: ./src/snippets/RebuyModal/RebuyModal.jsx










core_class/* default.use */.Z.use([
    a11y/* default */.Z
]);
var RebuyModal = RebuyModal_theme_themed(function(param) {
    var rebuyProducts = param.rebuyProducts, productHandle = param.productHandle, theme = param.theme;
    var ref, ref1, ref2, ref3;
    var closeModal = (0,hooks/* useModal */.dd)()[1].closeModal;
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useSidebar */.Ap)(), 2), openSidebar = ref4[1].openSidebar;
    var crossSells = rebuyProducts === null || rebuyProducts === void 0 ? void 0 : (ref = rebuyProducts.crossSells) === null || ref === void 0 ? void 0 : ref.products;
    var upSells = rebuyProducts === null || rebuyProducts === void 0 ? void 0 : (ref1 = rebuyProducts.upSells) === null || ref1 === void 0 ? void 0 : ref1.products;
    var isUpsell = (upSells === null || upSells === void 0 ? void 0 : upSells.length) > 0;
    var products = isUpsell ? upSells : crossSells;
    var language = isUpsell ? rebuyProducts === null || rebuyProducts === void 0 ? void 0 : (ref2 = rebuyProducts.upSells) === null || ref2 === void 0 ? void 0 : ref2.language : rebuyProducts === null || rebuyProducts === void 0 ? void 0 : (ref3 = rebuyProducts.crossSells) === null || ref3 === void 0 ? void 0 : ref3.language;
    var ref5 = (0,react.useState)(null), localSwiper = ref5[0], setLocalSwiper = ref5[1];
    var swiper = localSwiper;
    var setSwiper = setLocalSwiper;
    if (!products || (products === null || products === void 0 ? void 0 : products.length) == 0) return null;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Container */.W2, {
        "data-comp": RebuyModal.displayName,
        sx: theme.wrapper,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                sx: {
                    color: "dark",
                    fontSize: [
                        "22px",
                        "40px"
                    ],
                    lineHeight: [
                        "28px",
                        "43px"
                    ],
                    fontWeight: "bold",
                    position: "relative",
                    top: [
                        "-10px",
                        -40
                    ]
                },
                children: (language === null || language === void 0 ? void 0 : language.title) || "You’ll also love"
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                sx: {
                    color: "dark",
                    fontSize: [
                        "13px",
                        "15px"
                    ],
                    position: "relative",
                    top: [
                        0,
                        -30
                    ]
                },
                children: (language === null || language === void 0 ? void 0 : language.description) || "Don’t forget these customer favorites"
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                sx: {
                    position: "relative",
                    top: [
                        0,
                        "-20px"
                    ]
                },
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                    mt: 8,
                    mb: 3,
                    sx: {
                        maxWidth: 600,
                        mx: "auto",
                        "& .swiper-container": {
                            overflowY: "visible"
                        },
                        "& button > div > p": {
                            overflow: "hidden",
                            textOverflow: "ellipsis"
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(react_swiper/* Swiper */.t, {
                            onSwiper: setSwiper,
                            a11y: {
                                enabled: true
                            },
                            pagination: {
                                el: ".swiper-pagination-rebuy",
                                type: "bullets",
                                clickable: true
                            },
                            init: true,
                            spaceBetween: 48,
                            loop: (products === null || products === void 0 ? void 0 : products.length) > 1,
                            breakpoints: {
                                480: {
                                    slidesPerView: 1
                                },
                                768: {
                                    slidesPerView: (products === null || products === void 0 ? void 0 : products.length) > 1 ? 2 : 1
                                }
                            },
                            children: products === null || products === void 0 ? void 0 : products.map(function(product, index) {
                                if (!(product === null || product === void 0 ? void 0 : product.handle)) return null;
                                return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(swiper_slide/* SwiperSlide */.o, {
                                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(RebuyItem, {
                                        product: product,
                                        index: index,
                                        isUpsell: isUpsell,
                                        productHandle: productHandle,
                                        onItemClick: function() {
                                            closeModal();
                                        }
                                    })
                                }, product.handle + index);
                            })
                        }),
                        (products === null || products === void 0 ? void 0 : products.length) > 1 && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Navigation_Navigation, {
                            swiper: swiper,
                            loop: true,
                            count: products === null || products === void 0 ? void 0 : products.length,
                            leftSx: {
                                top: [
                                    20,
                                    21
                                ],
                                left: [
                                    -8,
                                    20
                                ]
                            },
                            rightSx: {
                                top: [
                                    20,
                                    21
                                ],
                                right: [
                                    -8,
                                    20
                                ]
                            }
                        }),
                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                            className: "swiper-pagination-rebuy",
                            sx: theme.bullets
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                sx: {
                    color: "dark",
                    fontSize: [
                        "15px",
                        "17px"
                    ],
                    fontWeight: "bold",
                    cursor: "pointer",
                    textDecoration: "underline"
                },
                onClick: function() {
                    closeModal();
                    openSidebar("cart");
                },
                children: "No Thanks"
            })
        ]
    });
});
RebuyModal.displayName = "RebuyModal";

;// CONCATENATED MODULE: ./src/snippets/RebuyModal/index.js


;// CONCATENATED MODULE: ./src/snippets/SeoPageSchema/ArticleSchemaMarkup.jsx


function ArticleSchemaMarkup(param) {
    var _article = param.article, article = _article === void 0 ? {} : _article, pageUrl = param.pageUrl;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)((script_default()), {
        id: "schema-markup-article",
        type: "application/ld+json",
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                "@context": "https://schema.org",
                "@type": "BlogPosting",
                "@id": pageUrl,
                mainEntityOfPage: pageUrl,
                headline: ((ref = article.seo) === null || ref === void 0 ? void 0 : ref.title) || "",
                name: ((ref1 = article.seo) === null || ref1 === void 0 ? void 0 : ref1.title) || "",
                description: ((ref2 = article.seo) === null || ref2 === void 0 ? void 0 : ref2.description) || "",
                datePublished: (article === null || article === void 0 ? void 0 : article.publishedAt) || "",
                dateModified: (article === null || article === void 0 ? void 0 : article.createdAt) || "",
                author: [
                    {
                        "@type": "Person",
                        name: (article === null || article === void 0 ? void 0 : article.author) || ""
                    }, 
                ],
                publisher: {
                    "@type": "Organization",
                    "@id": "https://www.brumate.com",
                    name: "BrüMate" || 0,
                    logo: {
                        "@type": "ImageObject",
                        "@id": "https://cdn.shopify.com/s/files/1/1114/2308/files/Br_Mate_Logo_Black.png?v=1636661870" || 0,
                        url: "https://cdn.shopify.com/s/files/1/1114/2308/files/Br_Mate_Logo_Black.png?v=1636661870" || 0
                    }
                },
                image: {
                    "@type": "ImageObject",
                    "@id": ((ref3 = article.seo) === null || ref3 === void 0 ? void 0 : ref3.image) || "",
                    url: ((ref4 = article.seo) === null || ref4 === void 0 ? void 0 : ref4.image) || ""
                },
                url: pageUrl,
                isPartOf: {
                    "@type": "Blog",
                    "@id": "".concat("https://www.brumate.com", "/blogs/").concat((ref5 = article.blog) === null || ref5 === void 0 ? void 0 : ref5.handle),
                    name: (ref6 = article.blog) === null || ref6 === void 0 ? void 0 : ref6.title,
                    publisher: {
                        "@type": "Organization",
                        "@id": "https://www.brumate.com",
                        name: "BrüMate" || 0
                    }
                }
            })
        }
    });
}
ArticleSchemaMarkup.displayName = "ArticleSchemaMarkup";

;// CONCATENATED MODULE: ./src/snippets/SeoPageSchema/BlogSchemaMarkup.jsx


function BlogSchemaMarkup(param) {
    var _blog = param.blog, blog = _blog === void 0 ? {} : _blog, pageUrl = param.pageUrl;
    var ref, ref1;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)((script_default()), {
        id: "schema-markup-blog",
        type: "application/ld+json",
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                "@context": "https://schema.org",
                "@type": "Blog",
                "@id": pageUrl,
                mainEntityOfPage: pageUrl,
                name: ((ref = blog.seo) === null || ref === void 0 ? void 0 : ref.title) || "",
                description: ((ref1 = blog.seo) === null || ref1 === void 0 ? void 0 : ref1.description) || "",
                publisher: {
                    "@type": "Organization",
                    "@id": "https://www.brumate.com",
                    name: "BrüMate" || 0,
                    logo: {
                        "@type": "ImageObject",
                        "@id": "https://cdn.shopify.com/s/files/1/1114/2308/files/Br_Mate_Logo_Black.png?v=1636661870" || 0,
                        url: "https://cdn.shopify.com/s/files/1/1114/2308/files/Br_Mate_Logo_Black.png?v=1636661870" || 0
                    }
                }
            })
        }
    });
}
BlogSchemaMarkup.displayName = "BlogSchemaMarkup";

;// CONCATENATED MODULE: ./src/snippets/SeoPageSchema/CollectionHead.jsx


function CollectionHead(param) {
    var _collection = param.collection, collection = _collection === void 0 ? {} : _collection, pageUrl = param.pageUrl;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)((head_default()), {
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("script", {
            type: "application/ld+json",
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML: {
                __html: '{\n                "@context": "https://schema.org/",\n                "@type": "BreadcrumbList",\n                "itemListElement": [\n                  {\n                    "@type": "ListItem",\n                    "position": 1,\n                    "name": "Insulated Can Coolers, Tumblers and Drinkware",\n                    "item": "'.concat("https://www.brumate.com", '/"\n                  },\n                  {\n                    "@type": "ListItem",\n                    "position": 2,\n                    "name": "').concat(collection.title, '",\n                    "item": "').concat(pageUrl, '"\n                  }\n                ]\n              }')
            }
        })
    });
}
CollectionHead.displayName = "CollectionHead";

;// CONCATENATED MODULE: ./src/snippets/SeoPageSchema/MainSchemaMarkup.jsx




function MainSchemaMarkup(param) {
    var pageUrl = param.pageUrl;
    var ref = (0,react.useState)(null), itemListSchema = ref[0], setItemListSchema = ref[1];
    var subCollections = (0,store/* useRecoilValue */.sJ)(store/* default */.ZP === null || store/* default */.ZP === void 0 ? void 0 : store/* default.collectionsMap */.ZP.collectionsMap);
    (0,react.useEffect)(function() {
        if (!subCollections) return;
        var itemList = subCollections === null || subCollections === void 0 ? void 0 : subCollections.map(function(collection, index) {
            var name = collection === null || collection === void 0 ? void 0 : collection.title;
            var url = collection.url;
            return {
                "@type": "ListItem",
                position: index,
                name: name,
                url: url
            };
        });
        setItemListSchema(itemList === null || itemList === void 0 ? void 0 : itemList.splice(1, itemList === null || itemList === void 0 ? void 0 : itemList.length));
    }, [
        subCollections,
        pageUrl
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_jsx_runtime_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)((script_default()), {
                id: "schema-markup-org",
                type: "application/ld+json",
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: {
                    __html: '{\n        "@context": "https://schema.org",\n        "@type": "Organization",\n        "name": "'.concat("BrüMate", '",\n        "url": "').concat(pageUrl, '",\n        ').concat( true ? '"sameAs": "https://www.instagram.com/'.concat("@bru.mate".replace("@", ""), '/",') : 0, '\n        "logo": "').concat("https://cdn.shopify.com/s/files/1/1114/2308/files/Br_Mate_Logo_Black.png?v=1636661870", '"\n      }\n      ')
                }
            }),
            (itemListSchema === null || itemListSchema === void 0 ? void 0 : itemListSchema.length) > 0 && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)((script_default()), {
                type: "application/ld+json",
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify({
                        "@context": "https://schema.org/",
                        "@type": "ItemList",
                        itemListElement: itemListSchema
                    })
                }
            })
        ]
    });
}
MainSchemaMarkup.displayName = "MainSchemaMarkup";

;// CONCATENATED MODULE: ./src/snippets/SeoPageSchema/ProductHead.jsx



function ProductHead(param) {
    var _product = param.product, product = _product === void 0 ? {} : _product, pageUrl = param.pageUrl;
    var ref, ref1;
    var ref2 = product.reviewAggregate || {}, ratingAndReviewCount = ref2.ratingAndReviewCount, ratingAndReviewValuesTotal = ref2.ratingAndReviewValuesTotal;
    var firstImage = (0,react.useMemo)(function() {
        var ref, ref1;
        return (ref1 = product === null || product === void 0 ? void 0 : (ref = product.media) === null || ref === void 0 ? void 0 : ref.find(function(item) {
            return item.mediaContentType === "IMAGE";
        })) === null || ref1 === void 0 ? void 0 : ref1.image;
    }, [
        product === null || product === void 0 ? void 0 : product.id
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)((head_default()), {
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("script", {
                type: "application/ld+json",
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: {
                    __html: '{\n              "@context": "https://schema.org/",\n              "@type": "BreadcrumbList",\n              "itemListElement": [\n                {\n                  "@type": "ListItem",\n                  "position": 1,\n                  "name": "Insulated Can Coolers, Tumblers and Drinkware",\n                  "item": "'.concat("https://www.brumate.com", '/"\n                },\n                {\n                  "@type": "ListItem",\n                  "position": 2,\n                  "name": "').concat(product.title, '",\n                  "item": "').concat(pageUrl, '"\n                }\n              ]\n            }')
                }
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("script", {
                type: "application/ld+json",
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: {
                    __html: '{\n              "@context": "https://schema.org/",\n              "@type": "Product",\n              "name": "'.concat(product.title, '",\n              "image": "').concat(firstImage === null || firstImage === void 0 ? void 0 : firstImage.originalSrc, '",\n              "description": "').concat(product.description, '",\n              "brand": {\n                "@type": "Brand",\n                "name": "').concat("BrüMate", '"\n              },\n              "aggregateRating": {\n                "@type": "AggregateRating",\n                "ratingValue": "').concat((ratingAndReviewValuesTotal / ratingAndReviewCount || 0).toFixed(2).replace(".00", ""), '",\n                "ratingCount": "').concat(ratingAndReviewCount || 0, '",\n                "bestRating": "5",\n                "worstRating": "1"\n              },\n              ').concat(product.reviews ? '"review": [\n                      '.concat(product.reviews.map(function(param) {
                        var body = param.body, dateCreated = param.dateCreated, rating = param.rating, reviewer = param.reviewer, title = param.title;
                        return '{\n                              "@type": "Review",\n                              "author": "'.concat(reviewer === null || reviewer === void 0 ? void 0 : reviewer.displayName, '",\n                              "datePublished": "').concat(dateCreated === null || dateCreated === void 0 ? void 0 : dateCreated.split("T")[0], '",\n                              "reviewBody": "').concat(body, '",\n                              "name": "').concat(title, '",\n                              "reviewRating": {\n                                "@type": "Rating",\n                                "bestRating": "5",\n                                "ratingValue": "').concat(rating, '",\n                                "worstRating": "1"\n                              }\n                            }');
                    }), "\n                    ],") : "", '\n              "offers": {\n                "@type": "Offer",\n                "url": "').concat(pageUrl, '",\n                "priceCurrency": "USD",\n                "price": "').concat((ref = product.priceRange) === null || ref === void 0 ? void 0 : (ref1 = ref.minVariantPrice) === null || ref1 === void 0 ? void 0 : ref1.amount, '",\n                "availability": "https://schema.org/InStock",\n                "itemCondition": "https://schema.org/NewCondition",\n                "shippingDetails": {\n                  "@context": "https://schema.org/",\n                  "@type": "OfferShippingDetails",\n                  "shippingDestination": {\n                    "@type": "DefinedRegion",\n                    "name": "United States",\n                    "postalCode": "Any"\n                  },\n                  "shippingRate": {\n                    "@type": "MonetaryAmount",\n                    "currency": "USD",\n                    "value": "5.99"\n                  },\n                  "shippingSettingsLink": "https://brumate.gorgias.help/en-US/how-much-does-shipping-cost-47271",\n                  "deliveryTime": {\n                    "@type": "ShippingDeliveryTime",\n                    "businessDays": {\n                      "@type": "QuantitativeValue",\n                      "minValue": "4",\n                      "maxValue": "8",\n                      "unitText": "Business Days"\n                    },\n                    "cutoffTime": "12:00:00-05:00"\n                  },\n                  "isUnlimitedShipping": true,\n                  "shippingPolicy": "https://brumate.gorgias.help/en-US/how-long-will-it-take-for-me-to-receive-my-order-47268"\n                },\n                "hasMerchantReturnPolicy": {\n                  "@context": "https://schema.org/",\n                  "@type": "StoreReturnPolicy",\n                  "name": "Br\xfcMate Return Policy",\n                  "merchantReturnDays": "30",\n                  "merchantReturnLink": "https://brumate.gorgias.help/en-US/articles/returns-exchanges-2478",\n                  "refundType": "Full",\n                  "returnFees": "Customer is not responsible for return shipping costs for do",\n                  "inStoreReturnsOffered": false,\n                  "returnPolicyCategory": "Online Store"\n                }\n              }\n            }')
                }
            })
        ]
    });
}
ProductHead.displayName = "ProductHead";

;// CONCATENATED MODULE: ./src/snippets/SeoPageSchema/SeoPageSchema.jsx







function SeoPageSchema(_param) {
    var page = _param.page, product = _param.product, collection = _param.collection, blog = _param.blog, article = _param.article, props = (0,_object_without_properties/* default */.Z)(_param, [
        "page",
        "product",
        "collection",
        "blog",
        "article"
    ]);
    var baseUrl = "https://www.brumate.com";
    var resourceType = page === null || page === void 0 ? void 0 : page.resourceType;
    var pageUrl = "";
    if ((page === null || page === void 0 ? void 0 : page.resourceType) === "home_page") {
        pageUrl = baseUrl;
    } else if ((page === null || page === void 0 ? void 0 : page.resourceType) === "page") {
        pageUrl = "".concat(baseUrl, "/pages/").concat(page.handle);
    } else if ((page === null || page === void 0 ? void 0 : page.resourceType) === "product_page") {
        pageUrl = "".concat(baseUrl, "/products/").concat(page.handle);
        resourceType = "product_page";
    } else if ((page === null || page === void 0 ? void 0 : page.resourceType) === "collection_page") {
        pageUrl = "".concat(baseUrl, "/collections/").concat(page.handle);
        resourceType = "collection_page";
    } else if (article) {
        pageUrl = "".concat(baseUrl, "/articles/").concat(article.handle);
        resourceType = "article";
    } else if (blog) {
        pageUrl = "".concat(baseUrl, "/blogs/").concat(blog.handle);
        resourceType = "blog";
    } else {
        pageUrl = baseUrl;
    }
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_jsx_runtime_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(MainSchemaMarkup, {
                pageUrl: pageUrl
            }),
            resourceType === "article" && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(ArticleSchemaMarkup, {
                article: article,
                pageUrl: pageUrl
            }),
            resourceType === "blog" && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(BlogSchemaMarkup, {
                blog: blog,
                pageUrl: pageUrl
            }),
            resourceType === "product_page" && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(ProductHead, {
                product: product,
                pageUrl: pageUrl
            }),
            resourceType === "collection_page" && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(CollectionHead, {
                collection: collection,
                pageUrl: pageUrl
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/snippets/SeoPageSchema/index.js


// EXTERNAL MODULE: ./src/theme/theme.layout.js
var theme_layout = __webpack_require__(28634);
// EXTERNAL MODULE: ./src/settings/common/index.js + 7 modules
var settings_common = __webpack_require__(33580);
;// CONCATENATED MODULE: ./src/snippets/Section/Section.jsx








function Section(_param) {
    var section = _param.section, newTab = _param.newTab, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "section",
        "newTab",
        "children"
    ]);
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
    if (!section) {
        var ref14;
        console.warn('"section" prop not provided to Section. Rendering '.concat((children === null || children === void 0 ? void 0 : (ref14 = children.props) === null || ref14 === void 0 ? void 0 : ref14["data-comp"]) || "", " children without Section."));
        return children;
    }
    var layoutMb = theme_layout/* layout */.b[(ref = section.mobile) === null || ref === void 0 ? void 0 : ref.container];
    var layoutDt = theme_layout/* layout */.b[(ref1 = section.desktop) === null || ref1 === void 0 ? void 0 : ref1.container];
    var mtMb = settings_common/* margin */.e6 === null || settings_common/* margin */.e6 === void 0 ? void 0 : (ref3 = settings_common/* margin.value */.e6.value) === null || ref3 === void 0 ? void 0 : ref3[(ref2 = section.mobile) === null || ref2 === void 0 ? void 0 : ref2.mt];
    var mtDt = settings_common/* margin */.e6 === null || settings_common/* margin */.e6 === void 0 ? void 0 : (ref5 = settings_common/* margin.value */.e6.value) === null || ref5 === void 0 ? void 0 : ref5[(ref4 = section.desktop) === null || ref4 === void 0 ? void 0 : ref4.mt];
    var pyMb = settings_common/* padding */.o3 === null || settings_common/* padding */.o3 === void 0 ? void 0 : (ref7 = settings_common/* padding.value */.o3.value) === null || ref7 === void 0 ? void 0 : ref7[(ref6 = section.mobile) === null || ref6 === void 0 ? void 0 : ref6.py];
    var pyDt = settings_common/* padding */.o3 === null || settings_common/* padding */.o3 === void 0 ? void 0 : (ref9 = settings_common/* padding.value */.o3.value) === null || ref9 === void 0 ? void 0 : ref9[(ref8 = section.desktop) === null || ref8 === void 0 ? void 0 : ref8.py];
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Container */.W2, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-comp": Section.displayName
    }, props), {
        sx: (0,_object_spread/* default */.Z)({
            bg: section.bgColor || "background",
            color: section.color || "text",
            mt: [
                (mtMb === null || mtMb === void 0 ? void 0 : mtMb[0]) || 0,
                (mtDt === null || mtDt === void 0 ? void 0 : mtDt[1]) || 0,
                (mtDt === null || mtDt === void 0 ? void 0 : mtDt[2]) || null,
                (mtDt === null || mtDt === void 0 ? void 0 : mtDt[3]) || null, 
            ],
            py: [
                (pyMb === null || pyMb === void 0 ? void 0 : pyMb[0]) || 0,
                (pyDt === null || pyDt === void 0 ? void 0 : pyDt[1]) || 0,
                (pyDt === null || pyDt === void 0 ? void 0 : pyDt[2]) || null,
                (pyDt === null || pyDt === void 0 ? void 0 : pyDt[3]) || null, 
            ]
        }, props.sx),
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Container */.W2, {
            sx: {
                position: [
                    (layoutMb === null || layoutMb === void 0 ? void 0 : layoutMb.position) || "relative",
                    (layoutDt === null || layoutDt === void 0 ? void 0 : layoutDt.position) || "relative", 
                ],
                px: [
                    (layoutMb === null || layoutMb === void 0 ? void 0 : (ref10 = layoutMb.px) === null || ref10 === void 0 ? void 0 : ref10[0]) || 0,
                    (layoutDt === null || layoutDt === void 0 ? void 0 : (ref11 = layoutDt.px) === null || ref11 === void 0 ? void 0 : ref11[1]) || 0,
                    (layoutDt === null || layoutDt === void 0 ? void 0 : (ref12 = layoutDt.px) === null || ref12 === void 0 ? void 0 : ref12[2]) || null,
                    (layoutDt === null || layoutDt === void 0 ? void 0 : (ref13 = layoutDt.px) === null || ref13 === void 0 ? void 0 : ref13[3]) || null, 
                ],
                mx: [
                    (layoutMb === null || layoutMb === void 0 ? void 0 : layoutMb.mx) || "auto",
                    (layoutDt === null || layoutDt === void 0 ? void 0 : layoutDt.mx) || "auto"
                ],
                maxWidth: [
                    (layoutMb === null || layoutMb === void 0 ? void 0 : layoutMb.maxWidth) || "unset",
                    (layoutDt === null || layoutDt === void 0 ? void 0 : layoutDt.maxWidth) || "unset", 
                ]
            },
            children: children
        })
    }));
}
Section.displayName = "Section";
Section.propTypes = {
    cms: (prop_types_default()).object,
    children: (prop_types_default()).node
};

;// CONCATENATED MODULE: ./src/snippets/Section/index.js


;// CONCATENATED MODULE: ./src/snippets/ShopifyMedia/ShopifyImage.jsx


function ShopifyImage(param) {
    var alt = param.alt, src = param.src, _ratio = param.ratio, ratio = _ratio === void 0 ? 1 : _ratio, id = param.id, _bgColor = param.bgColor, bgColor = _bgColor === void 0 ? null : _bgColor, aboveTheFold = param.aboveTheFold, preload = param.preload, width = param.width, height = param.height;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Picture, {
        alt: alt || "Product image",
        id: id,
        images: [
            {
                src: src,
                ratio: ratio,
                width: 768
            },
            {
                src: src,
                ratio: ratio,
                width: 1024
            },
            {
                src: src,
                ratio: ratio,
                width: 768
            }, 
        ],
        imageBgColor: bgColor,
        aboveTheFold: aboveTheFold,
        preload: preload,
        width: width,
        height: height
    });
} /*
  Can be used to size a src directly or inline.
  for example: sizing a src for a background image:
    ->  url(sizeShopifySrc(src, {width: 800 }))
*/  // export const sizeShopifySrc = _sizeShopifySrc
 /**
<ShopifyImage
  src={image ? image : null}
  ratio={1200/640}
  objectFit='cover'
  fluid
  sizes='(max-width: 640px) 300px, (max-width: 1023px) 1023px, (min-width: 1024px) 1000px'
  layout='fill'
  sx={{
    width: '100%'
  }}
/>
 */ 

;// CONCATENATED MODULE: ./src/snippets/ShopifyMedia/YouTubeEmbed.jsx





function YoutubeEmbed(_param) {
    var _ratio = _param.ratio, ratio = _ratio === void 0 ? 4 / 3 : _ratio, videoId = _param.videoId, _branding = _param.branding, branding = _branding === void 0 ? false : _branding, _controls = _param.controls, controls = _controls === void 0 ? false : _controls, _fullscreen = _param.fullscreen, fullscreen = _fullscreen === void 0 ? true : _fullscreen, _autoplay = _param.autoplay, autoplay = _autoplay === void 0 ? true : _autoplay, _iframeProps = _param.iframeProps, iframeProps = _iframeProps === void 0 ? {
        width: "100%",
        height: "100%",
        title: "Video",
        frameBorder: "0",
        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
        allowFullScreen: true
    } : _iframeProps, props = (0,_object_without_properties/* default */.Z)(_param, [
        "ratio",
        "videoId",
        "branding",
        "controls",
        "fullscreen",
        "autoplay",
        "iframeProps"
    ]);
    if (!videoId) throw new Error("Missing videoId");
    var videoUrl = "https://www.youtube.com/embed/".concat(videoId.trim(), "?&origin=").concat("https://www.brumate.com", "&rel=0&modestbranding=").concat(branding ? 1 : 0, "&controls=").concat(controls ? 1 : 0, "&fs=").concat(fullscreen ? 1 : 0, "&autoplay=").concat(autoplay ? 1 : 0);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* AspectRatio */.oM, {
        ratio: ratio,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            "data-comp": "ShopifyYouTubeEmbed"
        }, props), {
            sx: (0,_object_spread/* default */.Z)({
                // width: 'calc(100% + 4px)',
                // height: 'calc(100% + 4px)',
                width: "100%",
                height: "100%",
                display: "block",
                position: "absolute"
            }, props.sx),
            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("iframe", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                title: "YouTubeEmbed"
            }, iframeProps), {
                src: videoUrl
            }))
        }))
    });
} /*
[
  {
      "mediaContentType": "IMAGE",
      "alt": "",
      "image": {
          "id": "gid://shopify/ImageSource/21462796533944",
          "originalSrc": "https://cdn.shopify.com/s/files/1/0566/5882/1304/products/15mm-icetoolz-combo-wrench_1.jpg?v=1620067885",
          "altText": "",
          "width": 480,
          "height": 320
      }
  },
  {
      "mediaContentType": "VIDEO",
      "alt": "",
      "sources": [
          {
              "url": "https://cdn.shopify.com/videos/c/vp/e4e1db06d7dd44e494a4e24d57ac9066/e4e1db06d7dd44e494a4e24d57ac9066.HD-720p-1.6Mbps.mp4",
              "mimeType": "video/mp4",
              "format": "mp4",
              "height": 720,
              "width": 860
          },
          {
              "url": "https://cdn.shopify.com/videos/c/vp/e4e1db06d7dd44e494a4e24d57ac9066/e4e1db06d7dd44e494a4e24d57ac9066.m3u8",
              "mimeType": "application/x-mpegURL",
              "format": "m3u8",
              "height": 720,
              "width": 860
          },
          {
              "url": "https://cdn.shopify.com/videos/c/vp/e4e1db06d7dd44e494a4e24d57ac9066/e4e1db06d7dd44e494a4e24d57ac9066.SD-480p-0.9Mbps.mp4",
              "mimeType": "video/mp4",
              "format": "mp4",
              "height": 480,
              "width": 574
          }
      ]
  },
  {
      "mediaContentType": "MODEL_3D",
      "alt": "",
      "sources": [
          {
              "url": "https://model3d.shopifycdn.com/models/o/4f0f71eba56af1de/pack-emblem.glb",
              "mimeType": "model/gltf-binary",
              "format": "glb",
              "filesize": 6459380
          },
          {
              "url": "https://model3d.shopifycdn.com/models/o/3784a4be4d0e8d4b/pack-emblem.usdz",
              "mimeType": "model/vnd.usdz+zip",
              "format": "usdz",
              "filesize": 3743066
          }
      ]
  },
  {
      "mediaContentType": "IMAGE",
      "alt": "",
      "image": {
          "id": "gid://shopify/ImageSource/22925286998200",
          "originalSrc": "https://cdn.shopify.com/s/files/1/0566/5882/1304/products/6594_pepe_wine.gif?v=1625850683",
          "altText": "",
          "width": 128,
          "height": 128
      }
  },
  {
      "mediaContentType": "IMAGE",
      "alt": "",
      "image": {
          "id": "gid://shopify/ImageSource/22925292273848",
          "originalSrc": "https://cdn.shopify.com/s/files/1/0566/5882/1304/products/2019-pepe-copter.gif?v=1625850705",
          "altText": "",
          "width": 112,
          "height": 112
      }
  },
  {
      "mediaContentType": "EXTERNAL_VIDEO",
      "alt": "",
      "id": "gid://shopify/ExternalVideo/22916913103032",
      "host": "YOUTUBE",
      "embeddedUrl": "https://youtu.be/bQEJWb2GFSw",
      "preview": {
          "image": {
              "id": "gid://shopify/ImageSource/22925454540984",
              "originalSrc": "https://cdn.shopify.com/s/files/1/0566/5882/1304/products/hqdefault.jpg?v=1625851304",
              "altText": "",
              "width": 480,
              "height": 360
          }
      }
  },
  {
      "mediaContentType": "EXTERNAL_VIDEO",
      "alt": "",
      "id": "gid://shopify/ExternalVideo/22916920934584",
      "host": "VIMEO",
      "embeddedUrl": "https://player.vimeo.com/video/525829236",
      "preview": {
          "image": {
              "id": "gid://shopify/ImageSource/22925462372536",
              "originalSrc": "https://cdn.shopify.com/s/files/1/0566/5882/1304/products/1088544901_640.jpg?v=1625851331",
              "altText": "",
              "width": 640,
              "height": 360
          }
      }
  },
  {
      "mediaContentType": "IMAGE",
      "alt": "",
      "image": {
          "id": "gid://shopify/ImageSource/22925477871800",
          "originalSrc": "https://cdn.shopify.com/s/files/1/0566/5882/1304/products/5nskjq9qpn541.jpg?v=1625851392",
          "altText": "",
          "width": 960,
          "height": 742
      }
  }
]
*/ 

;// CONCATENATED MODULE: ./src/snippets/ShopifyMedia/VimeoEmbed.jsx
// Ref: https://developer.vimeo.com/api/oembed/videos





{
/* <iframe src="https://player.vimeo.com/video/{video_id}" width="{video_width}" height="{video_height}" frameborder="0" title="{video_title}" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe> */ }function VimeoEmbed(_param) {
    var _ratio = _param.ratio, ratio = _ratio === void 0 ? 4 / 3 : _ratio, videoId = _param.videoId, _branding = _param.branding, branding = _branding === void 0 ? false : _branding, _controls = _param.controls, controls = _controls === void 0 ? false : _controls, _fullscreen = _param.fullscreen, fullscreen = _fullscreen === void 0 ? true : _fullscreen, _autoplay = _param.autoplay, autoplay = _autoplay === void 0 ? true : _autoplay, _iframeProps = _param.iframeProps, iframeProps = _iframeProps === void 0 ? {
        width: "100%",
        height: "100%",
        title: "Video",
        frameBorder: "0",
        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
        allowFullScreen: true
    } : _iframeProps, props = (0,_object_without_properties/* default */.Z)(_param, [
        "ratio",
        "videoId",
        "branding",
        "controls",
        "fullscreen",
        "autoplay",
        "iframeProps"
    ]);
    if (!videoId) throw new Error("Missing videoId");
    var videoUrl = "https://player.vimeo.com/video/".concat(videoId, "?api=1&background=1&autoplay=").concat(autoplay ? 1 : 0, "&loop=1&responsive=1&controls=").concat(controls ? 1 : 0);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* AspectRatio */.oM, {
        ratio: ratio,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            "data-comp": "VimeoEmbed"
        }, props), {
            sx: (0,_object_spread/* default */.Z)({
                width: "calc(100% + 4px)",
                height: "calc(100% + 4px)",
                display: "block",
                position: "absolute",
                bottom: "-3px",
                left: "-3px"
            }, props.sx),
            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("iframe", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                title: "VimeoEmbed"
            }, iframeProps), {
                src: videoUrl,
                sx: {
                    minWidth: "100%",
                    minHeight: "100%"
                }
            }))
        }))
    });
} /*
[
  {
      "mediaContentType": "IMAGE",
      "alt": "",
      "image": {
          "id": "gid://shopify/ImageSource/21462796533944",
          "originalSrc": "https://cdn.shopify.com/s/files/1/0566/5882/1304/products/15mm-icetoolz-combo-wrench_1.jpg?v=1620067885",
          "altText": "",
          "width": 480,
          "height": 320
      }
  },
  {
      "mediaContentType": "VIDEO",
      "alt": "",
      "sources": [
          {
              "url": "https://cdn.shopify.com/videos/c/vp/e4e1db06d7dd44e494a4e24d57ac9066/e4e1db06d7dd44e494a4e24d57ac9066.HD-720p-1.6Mbps.mp4",
              "mimeType": "video/mp4",
              "format": "mp4",
              "height": 720,
              "width": 860
          },
          {
              "url": "https://cdn.shopify.com/videos/c/vp/e4e1db06d7dd44e494a4e24d57ac9066/e4e1db06d7dd44e494a4e24d57ac9066.m3u8",
              "mimeType": "application/x-mpegURL",
              "format": "m3u8",
              "height": 720,
              "width": 860
          },
          {
              "url": "https://cdn.shopify.com/videos/c/vp/e4e1db06d7dd44e494a4e24d57ac9066/e4e1db06d7dd44e494a4e24d57ac9066.SD-480p-0.9Mbps.mp4",
              "mimeType": "video/mp4",
              "format": "mp4",
              "height": 480,
              "width": 574
          }
      ]
  },
  {
      "mediaContentType": "MODEL_3D",
      "alt": "",
      "sources": [
          {
              "url": "https://model3d.shopifycdn.com/models/o/4f0f71eba56af1de/pack-emblem.glb",
              "mimeType": "model/gltf-binary",
              "format": "glb",
              "filesize": 6459380
          },
          {
              "url": "https://model3d.shopifycdn.com/models/o/3784a4be4d0e8d4b/pack-emblem.usdz",
              "mimeType": "model/vnd.usdz+zip",
              "format": "usdz",
              "filesize": 3743066
          }
      ]
  },
  {
      "mediaContentType": "IMAGE",
      "alt": "",
      "image": {
          "id": "gid://shopify/ImageSource/22925286998200",
          "originalSrc": "https://cdn.shopify.com/s/files/1/0566/5882/1304/products/6594_pepe_wine.gif?v=1625850683",
          "altText": "",
          "width": 128,
          "height": 128
      }
  },
  {
      "mediaContentType": "IMAGE",
      "alt": "",
      "image": {
          "id": "gid://shopify/ImageSource/22925292273848",
          "originalSrc": "https://cdn.shopify.com/s/files/1/0566/5882/1304/products/2019-pepe-copter.gif?v=1625850705",
          "altText": "",
          "width": 112,
          "height": 112
      }
  },
  {
      "mediaContentType": "EXTERNAL_VIDEO",
      "alt": "",
      "id": "gid://shopify/ExternalVideo/22916913103032",
      "host": "YOUTUBE",
      "embeddedUrl": "https://youtu.be/bQEJWb2GFSw",
      "preview": {
          "image": {
              "id": "gid://shopify/ImageSource/22925454540984",
              "originalSrc": "https://cdn.shopify.com/s/files/1/0566/5882/1304/products/hqdefault.jpg?v=1625851304",
              "altText": "",
              "width": 480,
              "height": 360
          }
      }
  },
  {
      "mediaContentType": "EXTERNAL_VIDEO",
      "alt": "",
      "id": "gid://shopify/ExternalVideo/22916920934584",
      "host": "VIMEO",
      "embeddedUrl": "https://player.vimeo.com/video/525829236",
      "preview": {
          "image": {
              "id": "gid://shopify/ImageSource/22925462372536",
              "originalSrc": "https://cdn.shopify.com/s/files/1/0566/5882/1304/products/1088544901_640.jpg?v=1625851331",
              "altText": "",
              "width": 640,
              "height": 360
          }
      }
  },
  {
      "mediaContentType": "IMAGE",
      "alt": "",
      "image": {
          "id": "gid://shopify/ImageSource/22925477871800",
          "originalSrc": "https://cdn.shopify.com/s/files/1/0566/5882/1304/products/5nskjq9qpn541.jpg?v=1625851392",
          "altText": "",
          "width": 960,
          "height": 742
      }
  }
]
*/ 

;// CONCATENATED MODULE: ./src/snippets/ShopifyMedia/ShopifyVideoExternal.jsx







function ShopifyVideoExternal(_param) {
    var id = _param.id, host = _param.host, embeddedUrl = _param.embeddedUrl, _preview = _param.preview, preview = _preview === void 0 ? {
        image: {
            id: id,
            originalSrc: originalSrc,
            altText: altText,
            width: width,
            height: height
        }
    } : _preview, _branding = _param.branding, branding = _branding === void 0 ? true : _branding, _controls = _param.controls, controls = _controls === void 0 ? false : _controls, _fullscreen = _param.fullscreen, fullscreen = _fullscreen === void 0 ? true : _fullscreen, _ratio = _param.ratio, ratio = _ratio === void 0 ? 5 / 6 : _ratio, props = (0,_object_without_properties/* default */.Z)(_param, [
        "id",
        "host",
        "embeddedUrl",
        "preview",
        "branding",
        "controls",
        "fullscreen",
        "ratio"
    ]);
    var ref, ref1;
    var videoId = (embeddedUrl === null || embeddedUrl === void 0 ? void 0 : embeddedUrl.split("/").pop()) || null;
    var videoRatio = ratio || (preview === null || preview === void 0 ? void 0 : (ref = preview.image) === null || ref === void 0 ? void 0 : ref.width) / (preview === null || preview === void 0 ? void 0 : (ref1 = preview.image) === null || ref1 === void 0 ? void 0 : ref1.height) || 3 / 4;
    var isYouTube = host === "YOUTUBE";
    var isVimeo = host === "VIMEO";
    var ref2 = (0,react_intersection_observer_dist/* useInView */.YD)({
        threshold: 0,
        triggerOnce: true
    }), ref3 = ref2.ref, inView = ref2.inView;
    return videoId ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* AspectRatio */.oM, {
        ref: ref3,
        "data-comp": "ShopifyVideo",
        ratio: ratio,
        sx: {
            bg: "ghostwhite"
        },
        children: isYouTube ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(YoutubeEmbed, (0,_object_spread/* default */.Z)({
            videoId: videoId,
            branding: branding,
            controls: controls,
            fullscreen: fullscreen,
            ratio: videoRatio
        }, props)) : isVimeo && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(VimeoEmbed, (0,_object_spread/* default */.Z)({
            videoId: videoId,
            branding: branding,
            controls: controls,
            fullscreen: fullscreen,
            ratio: videoRatio
        }, props))
    }) : "Missing youtube video id";
} /*
[
  {
      "mediaContentType": "IMAGE",
      "alt": "",
      "image": {
          "id": "gid://shopify/ImageSource/21462796533944",
          "originalSrc": "https://cdn.shopify.com/s/files/1/0566/5882/1304/products/15mm-icetoolz-combo-wrench_1.jpg?v=1620067885",
          "altText": "",
          "width": 480,
          "height": 320
      }
  },
  {
      "mediaContentType": "VIDEO",
      "alt": "",
      "sources": [
          {
              "url": "https://cdn.shopify.com/videos/c/vp/e4e1db06d7dd44e494a4e24d57ac9066/e4e1db06d7dd44e494a4e24d57ac9066.HD-720p-1.6Mbps.mp4",
              "mimeType": "video/mp4",
              "format": "mp4",
              "height": 720,
              "width": 860
          },
          {
              "url": "https://cdn.shopify.com/videos/c/vp/e4e1db06d7dd44e494a4e24d57ac9066/e4e1db06d7dd44e494a4e24d57ac9066.m3u8",
              "mimeType": "application/x-mpegURL",
              "format": "m3u8",
              "height": 720,
              "width": 860
          },
          {
              "url": "https://cdn.shopify.com/videos/c/vp/e4e1db06d7dd44e494a4e24d57ac9066/e4e1db06d7dd44e494a4e24d57ac9066.SD-480p-0.9Mbps.mp4",
              "mimeType": "video/mp4",
              "format": "mp4",
              "height": 480,
              "width": 574
          }
      ]
  },
  {
      "mediaContentType": "MODEL_3D",
      "alt": "",
      "sources": [
          {
              "url": "https://model3d.shopifycdn.com/models/o/4f0f71eba56af1de/pack-emblem.glb",
              "mimeType": "model/gltf-binary",
              "format": "glb",
              "filesize": 6459380
          },
          {
              "url": "https://model3d.shopifycdn.com/models/o/3784a4be4d0e8d4b/pack-emblem.usdz",
              "mimeType": "model/vnd.usdz+zip",
              "format": "usdz",
              "filesize": 3743066
          }
      ]
  },
  {
      "mediaContentType": "IMAGE",
      "alt": "",
      "image": {
          "id": "gid://shopify/ImageSource/22925286998200",
          "originalSrc": "https://cdn.shopify.com/s/files/1/0566/5882/1304/products/6594_pepe_wine.gif?v=1625850683",
          "altText": "",
          "width": 128,
          "height": 128
      }
  },
  {
      "mediaContentType": "IMAGE",
      "alt": "",
      "image": {
          "id": "gid://shopify/ImageSource/22925292273848",
          "originalSrc": "https://cdn.shopify.com/s/files/1/0566/5882/1304/products/2019-pepe-copter.gif?v=1625850705",
          "altText": "",
          "width": 112,
          "height": 112
      }
  },
  {
      "mediaContentType": "EXTERNAL_VIDEO",
      "alt": "",
      "id": "gid://shopify/ExternalVideo/22916913103032",
      "host": "YOUTUBE",
      "embeddedUrl": "https://youtu.be/bQEJWb2GFSw",
      "preview": {
          "image": {
              "id": "gid://shopify/ImageSource/22925454540984",
              "originalSrc": "https://cdn.shopify.com/s/files/1/0566/5882/1304/products/hqdefault.jpg?v=1625851304",
              "altText": "",
              "width": 480,
              "height": 360
          }
      }
  },
  {
      "mediaContentType": "EXTERNAL_VIDEO",
      "alt": "",
      "id": "gid://shopify/ExternalVideo/22916920934584",
      "host": "VIMEO",
      "embeddedUrl": "https://player.vimeo.com/video/525829236",
      "preview": {
          "image": {
              "id": "gid://shopify/ImageSource/22925462372536",
              "originalSrc": "https://cdn.shopify.com/s/files/1/0566/5882/1304/products/1088544901_640.jpg?v=1625851331",
              "altText": "",
              "width": 640,
              "height": 360
          }
      }
  },
  {
      "mediaContentType": "IMAGE",
      "alt": "",
      "image": {
          "id": "gid://shopify/ImageSource/22925477871800",
          "originalSrc": "https://cdn.shopify.com/s/files/1/0566/5882/1304/products/5nskjq9qpn541.jpg?v=1625851392",
          "altText": "",
          "width": 960,
          "height": 742
      }
  }
]
*/ 

;// CONCATENATED MODULE: ./src/snippets/ShopifyMedia/ShopifyVideo.jsx






function ShopifyVideo(_param) {
    var _sources = _param.sources, sources = _sources === void 0 ? [] : _sources, _ratio = _param.ratio, ratio = _ratio === void 0 ? 16 / 9 : _ratio, _muted = _param.muted, muted = _muted === void 0 ? true : _muted, _playsInline = _param.playsInline, playsInline = _playsInline === void 0 ? true : _playsInline, _loop = _param.loop, loop = _loop === void 0 ? true : _loop, _autoplay = _param.autoplay, autoplay = _autoplay === void 0 ? true : _autoplay, _controls = _param.controls, controls = _controls === void 0 ? false : _controls, _posters = _param.posters, posters = _posters === void 0 ? [] : _posters, overlay = _param.overlay, id = _param.id, children = _param.children, sx = _param.sx, props = (0,_object_without_properties/* default */.Z)(_param, [
        "sources",
        "ratio",
        "muted",
        "playsInline",
        "loop",
        "autoplay",
        "controls",
        "posters",
        "overlay",
        "id",
        "children",
        "sx"
    ]);
    var ref, ref1, ref2, ref3;
    var videoSources = sources.filter(function(param) {
        var mimeType = param.mimeType;
        return mimeType === "video/mp4";
    });
    var poster = (0,hooks/* useBreakpointValue */.Sx)((0,_to_consumable_array/* default */.Z)(posters));
    var responsiveRatio = (0,hooks/* useBreakpointValue */.Sx)([
        ((videoSources === null || videoSources === void 0 ? void 0 : (ref = videoSources[1]) === null || ref === void 0 ? void 0 : ref.width) || 1) / ((videoSources === null || videoSources === void 0 ? void 0 : (ref1 = videoSources[1]) === null || ref1 === void 0 ? void 0 : ref1.height) || 1) || null,
        ((videoSources === null || videoSources === void 0 ? void 0 : (ref2 = videoSources[0]) === null || ref2 === void 0 ? void 0 : ref2.width) || 1) / ((videoSources === null || videoSources === void 0 ? void 0 : (ref3 = videoSources[0]) === null || ref3 === void 0 ? void 0 : ref3.height) || 1) || null, 
    ]);
    // const responsiveWidth = useBreakpointValue([
    //   videoSources?.[1]?.width || null,
    //   videoSources?.[0]?.width || null,
    // ]);
    var ref4 = (0,react_intersection_observer_dist/* useInView */.YD)({
        threshold: 0,
        triggerOnce: true
    }), ref5 = ref4.ref, inView = ref4.inView;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* AspectRatio */.oM, {
        ref: ref5,
        "data-comp": "ShopifyVideo",
        ratio: responsiveRatio || ratio,
        sx: {
            bg: "ghostwhite"
        },
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                sx: {
                    position: "absolute",
                    width: "100%",
                    height: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)("video", {
                        muted: muted,
                        playsInline: playsInline,
                        loop: loop,
                        autoPlay: autoplay,
                        controls: controls,
                        poster: poster,
                        sx: {
                            position: "absolute",
                            height: "100%",
                            width: "100%",
                            objectFit: "cover",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)"
                        },
                        children: [
                            inView && (videoSources === null || videoSources === void 0 ? void 0 : videoSources.length) ? videoSources.map(function(source) {
                                return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("source", {
                                    src: source.url,
                                    type: source.mimeType
                                }, source.url);
                            }) : null,
                            "Your browser does not support the ",
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("code", {
                                children: "video"
                            }),
                            " element."
                        ]
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                        sx: {
                            display: overlay ? "block" : "none",
                            position: "absolute",
                            width: "100%",
                            height: "100%",
                            bg: "black",
                            opacity: 0.7
                        }
                    })
                ]
            }),
            children
        ]
    });
} /*
Example props
  {
    "sources": [
      {
          "url": "https://cdn.shopify.com/videos/c/vp/e4e1db06d7dd44e494a4e24d57ac9066/e4e1db06d7dd44e494a4e24d57ac9066.HD-720p-1.6Mbps.mp4",
          "mimeType": "video/mp4",
          "format": "mp4",
          "height": 720,
          "width": 860
      },
      {
          "url": "https://cdn.shopify.com/videos/c/vp/e4e1db06d7dd44e494a4e24d57ac9066/e4e1db06d7dd44e494a4e24d57ac9066.m3u8",
          "mimeType": "application/x-mpegURL",
          "format": "m3u8",
          "height": 720,
          "width": 860
      },
      {
          "url": "https://cdn.shopify.com/videos/c/vp/e4e1db06d7dd44e494a4e24d57ac9066/e4e1db06d7dd44e494a4e24d57ac9066.SD-480p-0.9Mbps.mp4",
          "mimeType": "video/mp4",
          "format": "mp4",
          "height": 480,
          "width": 574
      }
    ]
  }

*/ 

;// CONCATENATED MODULE: ./src/snippets/ShopifyMedia/ShopifyMedia.jsx







var ShopifyMedia = function(_param) {
    var media = _param.media, props = (0,_object_without_properties/* default */.Z)(_param, [
        "media"
    ]);
    if (!media) throw new Error("ShopifyMedia missing required media prop. A shopify media or [media] must be provided.");
    // maps a shopify media item to a react component
    var mapMediaItemToComponent = function(item) {
        var mediaContentType = item.mediaContentType;
        switch(mediaContentType){
            case "IMAGE":
                {
                    var imageProps = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props, item.image), {
                        alt: item.image.altText,
                        src: item.image.originalSrc,
                        id: item.image.id
                    });
                    delete imageProps.altText;
                    delete imageProps.originalSrc;
                    return /*#__PURE__*/ react.createElement(ShopifyImage, imageProps);
                }
            case "VIDEO":
                {
                    var ref;
                    var videoProps = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                        alt: item.alt,
                        sources: item.sources,
                        id: ((ref = item.sources[0]) === null || ref === void 0 ? void 0 : ref.url) || item.alt
                    });
                    return /*#__PURE__*/ react.createElement(ShopifyVideo, videoProps);
                }
            case "EXTERNAL_VIDEO":
                {
                    var externalVideoProps = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props, item), {
                        alt: item.alt,
                        id: item.id || item.alt
                    });
                    return /*#__PURE__*/ react.createElement(ShopifyVideoExternal, externalVideoProps);
                }
            default:
                console.warn("Media element is not valid. Supported media content types: IMAGE, VIDEO, EXTERNAL_VIDEO and MODEL_3D ", media);
                return null;
        }
    };
    // returns a the map component(s)
    return react.useMemo(function() {
        return Array.isArray(media) ? media.map(mapMediaItemToComponent) : mapMediaItemToComponent(media);
    }, [
        media
    ]);
}; /*
[
  {
      "mediaContentType": "IMAGE",
      "alt": "",
      "image": {
          "id": "gid://shopify/ImageSource/21462796533944",
          "originalSrc": "https://cdn.shopify.com/s/files/1/0566/5882/1304/products/15mm-icetoolz-combo-wrench_1.jpg?v=1620067885",
          "altText": "",
          "width": 480,
          "height": 320
      }
  },
  {
      "mediaContentType": "VIDEO",
      "alt": "",
      "sources": [
          {
              "url": "https://cdn.shopify.com/videos/c/vp/e4e1db06d7dd44e494a4e24d57ac9066/e4e1db06d7dd44e494a4e24d57ac9066.HD-720p-1.6Mbps.mp4",
              "mimeType": "video/mp4",
              "format": "mp4",
              "height": 720,
              "width": 860
          },
          {
              "url": "https://cdn.shopify.com/videos/c/vp/e4e1db06d7dd44e494a4e24d57ac9066/e4e1db06d7dd44e494a4e24d57ac9066.m3u8",
              "mimeType": "application/x-mpegURL",
              "format": "m3u8",
              "height": 720,
              "width": 860
          },
          {
              "url": "https://cdn.shopify.com/videos/c/vp/e4e1db06d7dd44e494a4e24d57ac9066/e4e1db06d7dd44e494a4e24d57ac9066.SD-480p-0.9Mbps.mp4",
              "mimeType": "video/mp4",
              "format": "mp4",
              "height": 480,
              "width": 574
          }
      ]
  },
  {
      "mediaContentType": "MODEL_3D",
      "alt": "",
      "sources": [
          {
              "url": "https://model3d.shopifycdn.com/models/o/4f0f71eba56af1de/pack-emblem.glb",
              "mimeType": "model/gltf-binary",
              "format": "glb",
              "filesize": 6459380
          },
          {
              "url": "https://model3d.shopifycdn.com/models/o/3784a4be4d0e8d4b/pack-emblem.usdz",
              "mimeType": "model/vnd.usdz+zip",
              "format": "usdz",
              "filesize": 3743066
          }
      ]
  },
  {
      "mediaContentType": "IMAGE",
      "alt": "",
      "image": {
          "id": "gid://shopify/ImageSource/22925286998200",
          "originalSrc": "https://cdn.shopify.com/s/files/1/0566/5882/1304/products/6594_pepe_wine.gif?v=1625850683",
          "altText": "",
          "width": 128,
          "height": 128
      }
  },
  {
      "mediaContentType": "IMAGE",
      "alt": "",
      "image": {
          "id": "gid://shopify/ImageSource/22925292273848",
          "originalSrc": "https://cdn.shopify.com/s/files/1/0566/5882/1304/products/2019-pepe-copter.gif?v=1625850705",
          "altText": "",
          "width": 112,
          "height": 112
      }
  },
  {
      "mediaContentType": "EXTERNAL_VIDEO",
      "alt": "",
      "id": "gid://shopify/ExternalVideo/22916913103032",
      "host": "YOUTUBE",
      "embeddedUrl": "https://youtu.be/bQEJWb2GFSw",
      "preview": {
          "image": {
              "id": "gid://shopify/ImageSource/22925454540984",
              "originalSrc": "https://cdn.shopify.com/s/files/1/0566/5882/1304/products/hqdefault.jpg?v=1625851304",
              "altText": "",
              "width": 480,
              "height": 360
          }
      }
  },
  {
      "mediaContentType": "EXTERNAL_VIDEO",
      "alt": "",
      "id": "gid://shopify/ExternalVideo/22916920934584",
      "host": "VIMEO",
      "embeddedUrl": "https://player.vimeo.com/video/525829236",
      "preview": {
          "image": {
              "id": "gid://shopify/ImageSource/22925462372536",
              "originalSrc": "https://cdn.shopify.com/s/files/1/0566/5882/1304/products/1088544901_640.jpg?v=1625851331",
              "altText": "",
              "width": 640,
              "height": 360
          }
      }
  },
  {
      "mediaContentType": "IMAGE",
      "alt": "",
      "image": {
          "id": "gid://shopify/ImageSource/22925477871800",
          "originalSrc": "https://cdn.shopify.com/s/files/1/0566/5882/1304/products/5nskjq9qpn541.jpg?v=1625851392",
          "altText": "",
          "width": 960,
          "height": 742
      }
  }
]
*/ 

;// CONCATENATED MODULE: ./src/snippets/ShopifyMedia/index.js


;// CONCATENATED MODULE: ./src/snippets/Sidebar/Sidebar.theme.js

var Sidebar_theme_themed = (0,create/* create */.U)(new function() {
    this.shell = {
        bg: "background",
        boxShadow: "left",
        minHeight: "var(--viewport-height)",
        position: "fixed",
        right: 0,
        top: 0,
        transition: "transform .3s ease-in-out",
        width: [
            "100%",
            "375px"
        ],
        willChange: "transform",
        zIndex: 50,
        inProduction: {
            closed: {
                transform: "translateX(100%)"
            },
            open: {
                transform: "translateX(0)"
            }
        },
        // push it bellow the customizer toolbar
        inCustomizer: {
            closed: {
                transform: "translateX(100%)",
                minHeight: "calc(var(--viewport-height) - var(--backpack-toolbar-height))"
            },
            open: {
                transform: "translateX(0)"
            }
        },
        scroll: {
            overflowY: "scroll",
            webkitOverflowScrolling: "touch",
            msOverflowStyle: "none",
            scrollbarWidth: "none",
            "::-webkit-scrollbar": {
                display: "none"
            }
        }
    };
    // dynamic drawer wrapper
    this.inner = {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: "100vh",
        scroll: {
            overflowY: "auto"
        }
    };
}());

;// CONCATENATED MODULE: ./src/snippets/Sidebar/SidebarShell.jsx








var SidebarShell = Sidebar_theme_themed(function(_param) {
    var theme = _param.theme, _open = _param.open, open = _open === void 0 ? false : _open, _rtl = _param.rtl, rtl = _rtl === void 0 ? true : _rtl, inputRef = _param.inputRef, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme",
        "open",
        "rtl",
        "inputRef",
        "children"
    ]);
    var isPreview = (0,dist.useRouter)().isPreview;
    (0,react.useEffect)(function() {
        if (document.documentElement) {
            document.documentElement.classList.toggle("sidebarShell-open", open);
        }
    }, [
        open
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        as: "aside",
        "data-comp": SidebarShell.displayName
    }, props), {
        sx: (0,_object_spread/* default */.Z)({}, props.sx, theme.shell, isPreview ? open ? theme.shell.inCustomizer.open : theme.shell.inCustomizer.closed : open ? theme.shell.inProduction.open : theme.shell.inProduction.closed),
        children: open ? children : null
    }));
});
SidebarShell.displayName = "SidebarShell";

;// CONCATENATED MODULE: ./src/snippets/Sidebar/Header/Header.theme.js

var Sidebar_Header_Header_theme_themed = (0,create/* create */.U)(new function() {
    this.header = {
        variant: "flex.column",
        bg: "background",
        zIndex: 60
    };
}());

;// CONCATENATED MODULE: ./src/snippets/Sidebar/Header/Header.jsx







var Sidebar_Header_Header_Header = Sidebar_Header_Header_theme_themed(function(_param) {
    var theme = _param.theme, open = _param.open, setHeight = _param.setHeight, children = _param.children, inputRef = _param.inputRef, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme",
        "open",
        "setHeight",
        "children",
        "inputRef"
    ]);
    var childrenWithRefs = (0,react.useMemo)(function() {
        return react.Children.map(children, function(child) {
            /*#__PURE__*/ return (0,react.cloneElement)(child, {
                ref: function(node) {
                    if (node) {
                        var ref;
                        var cartHeaderHeight = (ref = node === null || node === void 0 ? void 0 : node.getBoundingClientRect()) === null || ref === void 0 ? void 0 : ref.height;
                        setHeight(cartHeaderHeight);
                    }
                }
            });
        });
    }, [
        react.Children.count(children),
        open
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-comp": Sidebar_Header_Header_Header.displayName
    }, props), {
        ref: inputRef,
        sx: theme.header,
        children: childrenWithRefs
    }));
});
Sidebar_Header_Header_Header.displayName = "SidebarHeader";

;// CONCATENATED MODULE: ./src/snippets/Sidebar/Header/index.js


;// CONCATENATED MODULE: ./src/snippets/Sidebar/Content/Content.theme.js

var Sidebar_Content_Content_theme_themed = (0,create/* create */.U)(new function() {
    this.content = {
        variant: "flex.column",
        height: "100%"
    };
}());

;// CONCATENATED MODULE: ./src/snippets/Sidebar/Content/Content.jsx







var Content_Content_Content = Sidebar_Content_Content_theme_themed(function(_param) {
    var theme = _param.theme, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme",
        "children"
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-comp": Content_Content_Content.displayName
    }, props), {
        sx: theme.content,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_jsx_runtime_esm/* Fragment */.HY, {
            children: children
        })
    }));
});
Content_Content_Content.displayName = "SidebarContent";

;// CONCATENATED MODULE: ./src/snippets/Sidebar/Content/index.js


// EXTERNAL MODULE: ./src/snippets/Search/hooks/index.js + 5 modules
var Search_hooks = __webpack_require__(62653);
;// CONCATENATED MODULE: ./src/snippets/Sidebar/Footer/Footer.theme.js

var Sidebar_Footer_Footer_theme_themed = (0,create/* create */.U)(new function() {
    this.footer = {
        position: "relative",
        height: "max-content"
    };
}());

;// CONCATENATED MODULE: ./src/snippets/Sidebar/Footer/Footer.jsx











var Footer_Footer_Footer = Sidebar_Footer_Footer_theme_themed(function(_param) {
    var theme = _param.theme, setHeight = _param.setHeight, open = _param.open, children = _param.children, inputRef = _param.inputRef, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme",
        "setHeight",
        "open",
        "children",
        "inputRef"
    ]);
    var ref = (0,_sliced_to_array/* default */.Z)((0,hooks/* useSidebar */.Ap)(), 1), isSearch = ref[0].isSearch;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,Search_hooks/* useSearch */.R)(), 1), totalResults = ref1[0].totalResults;
    var upsellProductsNotInCart = (0,store/* useRecoilValue */.sJ)(store/* default.upsellProductsNotInCart */.ZP.upsellProductsNotInCart);
    var showUpsell = !!upsellProductsNotInCart.length;
    var showSearchFooter = isSearch && !!totalResults;
    var childrenWithRefs = (0,react.useMemo)(function() {
        return react.Children.map(children, function(child) {
            /*#__PURE__*/ return (0,react.cloneElement)(child, {
                ref: function(node) {
                    if (node) {
                        var ref;
                        var cartTotalsHeight = (ref = node === null || node === void 0 ? void 0 : node.getBoundingClientRect()) === null || ref === void 0 ? void 0 : ref.height;
                        setHeight(cartTotalsHeight);
                    }
                }
            });
        });
    }, [
        react.Children.count(children),
        open,
        showUpsell,
        showSearchFooter
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-comp": Footer_Footer_Footer.displayName
    }, props), {
        ref: inputRef,
        sx: theme.footer,
        children: childrenWithRefs
    }));
});
Footer_Footer_Footer.displayName = "SidebarFooter";

;// CONCATENATED MODULE: ./src/snippets/Sidebar/Footer/index.js


;// CONCATENATED MODULE: ./src/snippets/Sidebar/Sidebar.jsx











var Sidebar = Sidebar_theme_themed(function(_param) {
    var theme = _param.theme, open = _param.open, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme",
        "open",
        "children"
    ]);
    var ref = (0,react.useState)(0), headerHeight = ref[0], setHeaderHeight = ref[1];
    var ref1 = (0,react.useState)(0), footerHeight = ref1[0], setFooterHeight = ref1[1];
    var ref2 = (0,react.useState)("100vh"), sidebarHeight = ref2[0], setSidebarHeight = ref2[1];
    // sorts drawer children into Header, Content and Footer slots
    var SidebarSlots = (0,react.useMemo)(function() {
        var _$Header = null;
        var _$Content = null;
        var _$Footer = null;
        var _footerHeight = footerHeight ? "".concat(footerHeight, "px") : "0px";
        var _headerHeight = headerHeight ? "".concat(headerHeight, "px") : "0px";
        // scrollHeight is (header + content) - footer
        var scrollHeight = "calc(var(--viewport-height) - ".concat(_headerHeight, " - ").concat(_footerHeight, ")");
        react.Children.forEach(children, function(child) {
            var ref, ref1, ref2;
            var displayName = (child === null || child === void 0 ? void 0 : (ref = child.props) === null || ref === void 0 ? void 0 : (ref1 = ref.__EMOTION_TYPE_PLEASE_DO_NOT_USE__) === null || ref1 === void 0 ? void 0 : ref1.displayName) || (child === null || child === void 0 ? void 0 : (ref2 = child.type) === null || ref2 === void 0 ? void 0 : ref2.displayName);
            switch(displayName){
                case "SidebarHeader":
                    _$Header = /*#__PURE__*/ (0,react.cloneElement)(child, (0,_object_spread/* default */.Z)({
                        key: "Header",
                        open: open,
                        setHeight: setHeaderHeight
                    }, child.props));
                    break;
                case "SidebarContent":
                    _$Content = /*#__PURE__*/ (0,react.cloneElement)(child, (0,_object_spread/* default */.Z)({
                        key: "Content",
                        open: open
                    }, child.props));
                    break;
                case "SidebarFooter":
                    _$Footer = /*#__PURE__*/ (0,react.cloneElement)(child, (0,_object_spread/* default */.Z)({
                        key: "Footer",
                        open: open,
                        setHeight: setFooterHeight
                    }, child.props));
                    break;
                default:
                    break;
            }
        });
        return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_jsx_runtime_esm/* Fragment */.HY, {
            children: [
                _$Header,
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                    "data-comp": "".concat(Sidebar.displayName, "Scroll"),
                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.inner.scroll), {
                        height: scrollHeight,
                        flexGrow: 1
                    }),
                    children: _$Content
                }),
                _$Footer
            ]
        });
    }, [
        react.Children.count(children),
        children,
        open,
        footerHeight,
        headerHeight
    ]);
    var getBrowserHeight = function() {
        if (utils/* isBrowser */.jU) {
            setSidebarHeight(window.innerHeight);
        }
    };
    (0,react.useEffect)(function() {
        [
            "resize",
            "scroll"
        ].forEach(function(event) {
            window.addEventListener(event, getBrowserHeight);
        });
        return function() {
            [
                "resize",
                "scroll"
            ].forEach(function(event) {
                window.removeEventListener(event, getBrowserHeight);
            });
        };
    }, []);
    (0,react.useEffect)(function() {
        getBrowserHeight();
    }, [
        footerHeight
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": Sidebar.displayName,
        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.inner), {
            height: sidebarHeight
        }),
        children: SidebarSlots
    });
});
Sidebar.displayName = "Sidebar";
Sidebar.Header = Sidebar_Header_Header_Header;
Sidebar.Content = Content_Content_Content;
Sidebar.Footer = Footer_Footer_Footer;

;// CONCATENATED MODULE: ./src/snippets/Sidebar/index.js



;// CONCATENATED MODULE: ./src/snippets/SiteReviews/SiteReviewsHead.jsx



function SiteReviewsHead() {
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_jsx_runtime_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("link", {
                        href: "https://d3hw6dc1ow8pp2.cloudfront.net/styles/main.min.css",
                        rel: "stylesheet",
                        type: "text/css"
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("link", {
                        rel: "stylesheet",
                        type: "text/css",
                        href: "https://dov7r31oq5dkj.cloudfront.net/64fdab67-9789-4d89-bfa4-42a4cef5e5d8/widget-style-customisations.css?v=f0633da3-c6f5-4b6d-9610-b39db21cde11"
                    })
                ]
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)((script_default()), {
                type: "text/javascript",
                strategy: "afterInteractive",
                id: "oke-reviews-script",
                dangerouslySetInnerHTML: {
                    __html: '\n                (function () {\n                  function asyncLoad() {\n                      var urls = ["https://d3hw6dc1ow8pp2.cloudfront.net/reviewsWidget.min.js?shop=kryo-gear.myshopify.com"];\n                      for (var i = 0; i < urls.length; i++) {\n                          var s = document.createElement("script");\n                          s.type = "text/javascript";\n                          s.async = true;\n                          s.src = urls[i];\n                          var x = document.getElementsByTagName("script")[0];\n                          x.parentNode.insertBefore(s, x);\n                      }\n                  }\n                  asyncLoad();\n              })();\n            '
                }
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)((script_default()), {
                type: "text/javascript",
                strategy: "afterInteractive",
                id: "oke-reviews-widget",
                dangerouslySetInnerHTML: {
                    __html: "\n            window.okeReviewsWidgetOnInit = function (okendoInitApi) {\n              window.okendoInitApi = okendoInitApi;\n            }\n            "
                }
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)((script_default()), {
                type: "application/json",
                strategy: "afterInteractive",
                id: "oke-reviews-settings",
                dangerouslySetInnerHTML: {
                    __html: '\n              {\n                "disableInitialReviewsFetchOnProducts":false,\n                "filtersEnabled": false,\n                "initialReviewDisplayCount":5,\n                "locale":"en",\n                "omitMicrodata": true,\n                "reviewSortOrder":"rating",\n                "subscriberId": "64fdab67-9789-4d89-bfa4-42a4cef5e5d8",\n                "widgetTemplateId": "default",\n                "recorderPlus":true\n              }\n            '
                }
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/snippets/SiteReviews/SiteReviews.theme.js

var SiteReviews_theme_themed = (0,create/* create */.U)(new function() {
    this.container = {
        variant: "layout.content"
    };
    this.holder = {
        pt: 0
    };
    this.spinner = {
        width: "30px",
        color: "darkGray",
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)"
    };
    this.widget = {
        position: "relative",
        ".okeReviews .okeReviews-reviewsWidget-header-controls-writeReview": {
            display: "none"
        },
        ".okeReviews .okeReviews-reviewsWidget.is-okeReviews-empty": {
            display: "block"
        },
        "#oke-starSnippet": {
            pt: "5px"
        },
        ".okeReviews-reviewsWidget-poweredBy": {
            display: "none"
        },
        ".okeReviews.okeReviews--theme .okeReviews-badge--rating": {
            backgroundColor: "dark"
        },
        ".okeReviews okeReviews--theme": {
            display: "flex !important",
            justifyContent: "center"
        },
        ".okeReviews-button": {
            display: "inline-block",
            mx: [
                90,
                "initial"
            ],
            variant: "buttons.primary"
        },
        ".okeReviews.okeReviews--theme .okeReviews-badge--recommended": {
            py: 2,
            px: 4,
            backgroundColor: "#4ad2ae",
            fontWeight: 400
        },
        ".okeReviews-barGraph": {
            background: "dark"
        },
        ".okeReviews .okeReviews-barGraph-layer--foreground": {
            background: "#222"
        },
        ".okeReviews-review-reviewer-profile-name": {
            fontSize: 6
        },
        ".okeReviews .okeReviews-flag": {
            display: "none"
        },
        ".okeReviews.okeReviews--theme .okeReviews-review-reviewer-profile-status--verified": {
            color: "mediumDarkGray"
        },
        ".okeReviews-review-reviewer-profile": {
            borderBottom: "none"
        },
        ".okeReviews .okeReviews-reviewsAggregate-primary, .okeReviews .okeReviews-reviewsAggregate-side": {
            border: "1px solid",
            borderColor: "mediumGray"
        },
        ".okeReviews .okeReviews-review-primary, .okeReviews .okeReviews-review-side": {
            borderLeft: "none",
            borderRight: "none",
            borderTop: "none !important",
            borderColor: "mediumGray"
        },
        ".okeReviews.okeReviews--theme, *": {
            fontFamily: '"MrEaves", system-ui, -apple-system, BlinkMacSystemFont, sans-serif'
        },
        ".okeReviews-review-main-heading": {
            variant: "text.h4"
        },
        ".okeReviews.okeReviews--theme .okeReviews-review-recommendation--yes::before": {
            color: "#4ad2ae"
        },
        ".okeReviews .okeReviews-reviewsWidget.is-okeReviews-reviewsWidget-large .okeReviews-review-primary, .okeReviews .okeReviews-reviewsWidget.is-okeReviews-reviewsWidget-large .okeReviews-review-side, .okeReviews .okeReviews-reviewsWidget.is-okeReviews-reviewsWidget-large .okeReviews-reviewsAggregate-primary, .okeReviews .okeReviews-reviewsWidget.is-okeReviews-reviewsWidget-large .okeReviews-reviewsAggregate-side, .okeReviews .okeReviews-reviewsWidget.is-okeReviews-reviewsWidget-medium .okeReviews-review-primary, .okeReviews .okeReviews-reviewsWidget.is-okeReviews-reviewsWidget-medium .okeReviews-review-side, .okeReviews .okeReviews-reviewsWidget.is-okeReviews-reviewsWidget-medium .okeReviews-reviewsAggregate-primary, .okeReviews .okeReviews-reviewsWidget.is-okeReviews-reviewsWidget-medium .okeReviews-reviewsAggregate-side": {
            borderLeft: "none",
            borderRight: "none"
        },
        ".okeReviews-reviews-controls": {
            display: "none"
        },
        ".okeReviews.okeReviews--theme .okeReviews-starRating-indicator-layer--foreground": {
            backgroundImage: "url(/svgs/okendo-stars.svg)"
        }
    };
}());

;// CONCATENATED MODULE: ./src/snippets/SiteReviews/SiteReviews.jsx






var SiteReviews = SiteReviews_theme_themed(function(param) {
    var theme = param.theme;
    var ref;
    var reviewsRef = (0,react.useRef)(null);
    var initCoreWidgets = utils/* isBrowser */.jU && ((ref = window.okendoInitApi) === null || ref === void 0 ? void 0 : ref.initCoreWidgets);
    var okendoReady = typeof initCoreWidgets === "function";
    (0,react.useEffect)(function() {
        if (!okendoReady || !reviewsRef.current) return;
        initCoreWidgets();
    }, [
        okendoReady
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_jsx_runtime_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(SiteReviewsHead, {}),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Container */.W2, {
                "data-comp": SiteReviews.displayName,
                sx: theme.container,
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                    sx: theme.widget,
                    children: [
                        !okendoReady && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Spinner */.$j, {
                            sx: theme.spinner
                        }),
                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                            ref: reviewsRef,
                            "data-oke-reviews-widget-holder": true,
                            sx: theme.holder,
                            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                                "data-oke-reviews-widget": true
                            })
                        })
                    ]
                })
            })
        ]
    });
});
SiteReviews.displayName = "SiteReviews";

;// CONCATENATED MODULE: ./src/snippets/SiteReviews/index.js


;// CONCATENATED MODULE: ./src/snippets/SocialLinks/SocialLinks.theme.js

var SocialLinks_theme_themed = (0,create/* create */.U)(new function() {
    this.link = {
        mr: 7,
        transition: "opacity 0.2s ease-in-out",
        ":hover": {
            opacity: 0.8
        }
    };
    this.icon = {
        color: "currentColor"
    };
}());

;// CONCATENATED MODULE: ./src/snippets/SocialLinks/SocialLinks.jsx








var SocialLinks = SocialLinks_theme_themed(function(_param) {
    var theme = _param.theme, _size = _param.size, size = _size === void 0 ? 24 : _size, inputRef = _param.inputRef, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme",
        "size",
        "inputRef"
    ]);
    var ref;
    var settings = (0,dist.useSettings)();
    var socialLinks = settings === null || settings === void 0 ? void 0 : (ref = settings.social) === null || ref === void 0 ? void 0 : ref.links;
    return (socialLinks === null || socialLinks === void 0 ? void 0 : socialLinks.length) ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-comp": SocialLinks.displayName
    }, props), {
        children: socialLinks.map(function(param, index) {
            var network = param.network, handle = param.handle;
            return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Link, {
                newTab: true,
                href: networks[network] && handle ? "".concat(networks[network].url).concat(handle) : "",
                "aria-label": network,
                sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.link), {
                    width: size,
                    height: size
                }),
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Svg, {
                    src: "/svgs/noprecache/social/".concat(network, ".svg#").concat(network),
                    alt: network,
                    viewBox: "0 0 24 24",
                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.icon), {
                        width: size,
                        height: size
                    })
                })
            }, index);
        })
    })) : null;
});
SocialLinks.displayName = "SocialLinks";
var networks = {
    facebook: {
        url: "https://www.facebook.com/"
    },
    instagram: {
        url: "https://www.instagram.com/"
    },
    twitter: {
        url: "https://www.twitter.com/"
    },
    pinterest: {
        url: "https://www.pinterest.com/"
    },
    youtube: {
        url: "https://www.youtube.com/"
    },
    vimeo: {
        url: "https://www.vimeo.com/"
    },
    tiktok: {
        url: "https://www.tiktok.com/@"
    }
};

;// CONCATENATED MODULE: ./src/snippets/StatefulButton/StatefulButton.jsx






function StatefulButton(_param) {
    var _text = _param.text, text = _text === void 0 ? {
        started: "LOADING",
        success: "DONE",
        error: "FAILED",
        default: "SUBMIT"
    } : _text, setErrors = _param.setErrors, setSuccess = _param.setSuccess, setFinished = _param.setFinished, setStarted = _param.setStarted, started = _param.started, success = _param.success, finished = _param.finished, loading = _param.loading, errors = _param.errors, reset = _param.reset, resetTimer = _param.resetTimer, _showErrors = _param.showErrors, showErrors = _showErrors === void 0 ? true : _showErrors, _autoReset = _param.autoReset, autoReset = _autoReset === void 0 ? true : _autoReset, _resetAfter = _param.resetAfter, resetAfter = _resetAfter === void 0 ? 2000 : _resetAfter, children = _param.children, disabled = _param.disabled, props = (0,_object_without_properties/* default */.Z)(_param, [
        "text",
        "setErrors",
        "setSuccess",
        "setFinished",
        "setStarted",
        "started",
        "success",
        "finished",
        "loading",
        "errors",
        "reset",
        "resetTimer",
        "showErrors",
        "autoReset",
        "resetAfter",
        "children",
        "disabled"
    ]);
    var ref = react.useRef(null);
    var resetTimerRef = resetTimer || ref;
    var buttonText = (0,react.useMemo)(function() {
        if (finished && autoReset) {
            resetTimerRef.current = setTimeout(function() {
                if (reset) reset();
                clearTimeout(resetTimerRef.current);
            }, resetAfter);
        }
        return finished ? success ? text.success : text.error : started ? text.started : text.default;
    }, [
        started,
        success,
        finished,
        Object.values(text).join(",")
    ]);
    var isDisabled = started;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_jsx_runtime_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                disabled: disabled || started
            }, props), {
                children: loading || isDisabled ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Spinner */.$j, {
                    "aria-label": "Loading",
                    sx: {
                        color: "currentColor",
                        height: "60%",
                        position: "absolute",
                        left: "50%",
                        top: "50%",
                        transform: "translate(-50%, -50%)"
                    }
                }) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                    as: "span",
                    children: [
                        buttonText,
                        children
                    ]
                })
            })),
            showErrors && (errors === null || errors === void 0 ? void 0 : errors.length) ? errors.map(function(err) {
                return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Alert */.bZ, {
                    variant: "alerts.error",
                    mt: 6,
                    children: err
                }, err);
            }) : null
        ]
    });
}

;// CONCATENATED MODULE: ./src/snippets/StatefulButton/index.js


;// CONCATENATED MODULE: ./src/snippets/StoreLocator/StoreLocator.jsx
// eslint-disable-next-line jsx-a11y/control-has-associated-label



function StoreLocator() {
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Container */.W2, {
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                id: "lcly-button-0",
                "data-switchlive": "true",
                "data-switchlive-impression": "true",
                "data-switchlive-impression-id-pl": "1",
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("a", {
                    id: "lcly-link-0",
                    "data-switchlive": "true",
                    "data-switchlive-mode": "auto",
                    "data-switchlive-id-pl": "6",
                    href: "https://join.locally.com/for-brands",
                    target: "_blank",
                    rel: "noreferrer"
                })
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)((script_default()), {
                strategy: "afterInteractive",
                type: "text/javascript",
                id: "lcly-script-0",
                async: true
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)((script_default()), {
                strategy: "afterInteractive",
                type: "text/javascript",
                id: "lcly-config-0",
                dangerouslySetInnerHTML: {
                    __html: '\n          var lcly_config_0 = {\n            "company_name": "Br\xfcMate",\n            "company_id": "156418",\n            "inline": "1",\n            "lang": "en-us",\n            "no_link": "1"\n          };\n          var lcly_query_0 = Object.keys(lcly_config_0)\n          .reduce(function(a,k){a.push(encodeURIComponent(k) + \'=\'\n          + encodeURIComponent(lcly_config_0[k]));return a},[]).join(\'&\');\n          var lcly_endpoint_0 = \'https://brumate.locally.com/stores/map.js?\' + lcly_query_0;\n          document.getElementById(\'lcly-script-0\').src = lcly_endpoint_0;'
                }
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/snippets/StoreLocator/index.js


;// CONCATENATED MODULE: ./src/snippets/Svg/Svg.jsx







var Svg = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var src = _param.src, _alt = _param.alt, alt = _alt === void 0 ? "Illustration" : _alt, viewBox = _param.viewBox, _preserveAspectRatio = _param.preserveAspectRatio, preserveAspectRatio = _preserveAspectRatio === void 0 ? true : _preserveAspectRatio, loading = _param.loading, props = (0,_object_without_properties/* default */.Z)(_param, [
        "src",
        "alt",
        "viewBox",
        "preserveAspectRatio",
        "loading"
    ]);
    var srcHasId = /#/.test(src);
    if (srcHasId && !viewBox) {
        throw new Error("viewBox not provided");
    }
    return srcHasId ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-comp": Svg.displayName,
        ref: ref,
        sx: {
            variant: "flex.row.center"
        }
    }, props), {
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
            alt: alt,
            "data-comp": "".concat(Svg.displayName, "Svg"),
            as: "svg",
            role: "img",
            viewBox: viewBox,
            preserveAspectRatio: preserveAspectRatio ? "" : "none",
            sx: {
                width: "100%",
                height: "100%",
                display: "block"
            },
            children: [
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("title", {
                    children: alt
                }),
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                    as: "use",
                    x: "0",
                    y: "0",
                    href: src
                })
            ]
        })
    })) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Image */.Ee, (0,_object_spread/* default */.Z)({
        role: "presentation",
        alt: alt,
        src: src,
        loading: loading
    }, props));
});
Svg.displayName = "Svg";
Svg.propTypes = {
    src: (prop_types_default()).string,
    alt: (prop_types_default()).string,
    viewBox: (prop_types_default()).string,
    preserveAspectRatio: (prop_types_default()).bool
};

;// CONCATENATED MODULE: ./src/snippets/Svg/index.js


;// CONCATENATED MODULE: ./src/snippets/Wishlist/WishlistProduct.jsx


function WishlistProduct(param) {
    var handle = param.handle;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(ProductItem, {
        product: {
            handle: handle
        },
        isProductRow: true
    });
}

;// CONCATENATED MODULE: ./src/snippets/Wishlist/Wishlist.theme.js

var Wishlist_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        variant: "layout.content",
        pt: [
            0,
            14,
            15
        ],
        pb: [
            14,
            18,
            "80px"
        ]
    };
    this.grid = {
        display: "grid",
        columnGap: [
            10,
            12
        ],
        rowGap: [
            14,
            12
        ],
        gridTemplateColumns: [
            "repeat(2, 1fr)",
            "repeat(3, 1fr)",
            "repeat(4, 1fr)", 
        ]
    };
    this.heading = {
        variant: "text.h1",
        mb: "28px"
    };
}());

;// CONCATENATED MODULE: ./src/snippets/Wishlist/WishlistPage.jsx






var WishlistPage = Wishlist_theme_themed(function(param) {
    var theme = param.theme;
    var wishlist = (0,store/* useRecoilValue */.sJ)(store/* default.wishlist */.ZP.wishlist);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Container */.W2, {
        "data-comp": "WishlistPage",
        sx: theme.wrapper,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                as: "h1",
                sx: theme.heading,
                children: "Wishlist"
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Container */.W2, {
                sx: theme.grid,
                children: (wishlist === null || wishlist === void 0 ? void 0 : wishlist.length) ? (0,_to_consumable_array/* default */.Z)(wishlist).reverse().map(function(param) {
                    var epi = param.epi, du = param.du;
                    var handle = du.split("/").pop();
                    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(WishlistProduct, {
                        handle: handle
                    }, epi);
                }) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                    children: "Your wishlist is empty."
                })
            })
        ]
    });
});

;// CONCATENATED MODULE: ./src/snippets/Wishlist/index.js


// EXTERNAL MODULE: ../node_modules/sha-1/dist/sha1.umd.js
var sha1_umd = __webpack_require__(48411);
var sha1_umd_default = /*#__PURE__*/__webpack_require__.n(sha1_umd);
;// CONCATENATED MODULE: ./src/snippets/LoyaltyLion/LoyaltyLionScript.jsx









var logoutCustomer = function() {
    if (typeof window.loyaltylion === "object" && typeof window.loyaltylion.logoutCustomer === "function") {
        window.loyaltylion.logoutCustomer();
    }
};
var injectScript = function() {
    // source: https://developers.loyaltylion.com/sdk/installation#add-the-sdk-snippet-to-your-template
    var script = document.createElement("script");
    script.async = true;
    script.text = '!function(t,n){var e=n.loyaltylion||[];if(!e.isLoyaltyLion){n.loyaltylion=e,void 0===n.lion&&(n.lion=e),e.version=2,e.isLoyaltyLion=!0;var o=n.URLSearchParams,i=n.sessionStorage,r="ll_loader_revision",a=(new Date).toISOString().replace(/-/g,""),s="function"==typeof o?function(){try{var t=new o(n.location.search).get(r);return t&&i.setItem(r,t),i.getItem(r)}catch(t){return""}}():null;c("https://sdk.loyaltylion.net/static/2/"+a.slice(0,8)+"/loader"+(s?"-"+s:"")+".js");var l=!1;e.init=function(t){if(l)throw new Error("Cannot call lion.init more than once");l=!0;var n=e._token=t.token;if(!n)throw new Error("Token must be supplied to lion.init");var o=[];function i(t,n){t[n]=function(){o.push([n,Array.prototype.slice.call(arguments,0)])}}"_push configure bootstrap shutdown on removeListener authenticateCustomer".split(" ").forEach(function(t){i(e,t)}),c("https://sdk.loyaltylion.net/sdk/start/"+a.slice(0,11)+"/"+n+".js"),e._initData=t,e._buffer=o}}function c(n){var e=t.getElementsByTagName("script")[0],o=t.createElement("script");o.src=n,o.crossOrigin="",e.parentNode.insertBefore(o,e)}}(document,window);';
    script.dataset.script = "loyaltylion";
    var t = document.getElementsByTagName("script")[0];
    if (t) {
        t.parentNode.insertBefore(script, t);
    } else {
        document.head.append(script);
    }
    return script;
};
var initializeScript = function() {
    var initializationValues = {
        token: "d760623a4ef28e5174ccbf010150cbdb"
    };
    // source: https://developers.loyaltylion.com/sdk/javascript-api/getting-started#initialization
    if (typeof window.loyaltylion === "object" && typeof window.loyaltylion.init === "function" && typeof window.loyaltylion.api === "undefined" && !window.loyaltylion.initialized) {
        window.loyaltylion.init(initializationValues);
        window.loyaltylion.configure({
            disableBundledFonts: true,
            shopifyFrontend: "unknown"
        });
        window.loyaltylion.initialized = true;
    }
};
var authenticateCustomer = function(customer) {
    var ref, ref1;
    // source: https://developers.loyaltylion.com/sdk/javascript-api/customer-authentication#authentication-after-initialization
    if ((customer === null || customer === void 0 ? void 0 : customer.id) === null || (customer === null || customer === void 0 ? void 0 : customer.email) === null) {
        return;
    }
    var customerId = (ref1 = customer === null || customer === void 0 ? void 0 : (ref = customer.id) === null || ref === void 0 ? void 0 : ref.split("/")) === null || ref1 === void 0 ? void 0 : ref1.pop();
    var customerEmail = customer.email;
    var customerName = customer === null || customer === void 0 ? void 0 : customer.displayName;
    var date = new Date().toISOString();
    var authToken = "".concat(customerId).concat(date).concat(customerEmail).concat("436713e61268c3a324443994e97e7b50" || 0);
    var authenticationValues = {
        customer: {
            id: customerId,
            email: customerEmail,
            name: customerName
        },
        auth: {
            date: date,
            token: sha1_umd_default()(authToken)
        }
    };
    if (typeof window.loyaltylion === "object" && typeof window.loyaltylion.authenticateCustomer === "function") {
        window.loyaltylion.authenticateCustomer(authenticationValues);
    }
};
function LoyaltyLionScript() {
    var gotoSnapshot = (0,store/* useGotoRecoilSnapshot */.le)();
    var cart = (0,dist.useCart)({
        sortByAddedAt: true
    });
    var cartAddItem = (0,dist.useCartAddItem)().cartAddItem;
    var cartAddDiscount = (0,dist.useCartAddDiscount)().cartAddDiscount;
    var cartRemoveItems = (0,dist.useCartRemoveItems)().cartRemoveItems;
    var cartUpdateItem = (0,dist.useCartUpdateItem)().cartUpdateItem;
    var ref = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* default.loyaltylionLoaded */.ZP.loyaltylionLoaded), 2), loyaltylionLoaded = ref[0], setLoyaltylionLoaded = ref[1];
    var ref1 = (0,dist.useCustomerAuth)(), authenticated = ref1.authenticated, customer = ref1.customer, customerInit = ref1.customerInit;
    var router = (0,next_router.useRouter)();
    var loyaltyLionStylesheet = (0,react.useRef)();
    var ref2 = (0,react.useState)(0), count = ref2[0], setCount = ref2[1];
    var ref3 = (0,react.useState)(0), timer = ref3[0], setTimer = ref3[1];
    var ref4 = (0,react.useState)(false), llAuthenticated = ref4[0], setLlllAuthenticated = ref4[1];
    var ref5 = (0,react.useState)(false), loyaltylionInitialized = ref5[0], setLoyaltylionInitialized = ref5[1];
    var toggleCartSidebar = (0,store/* useRecoilCallback */._8)(function(param) {
        var snapshot = param.snapshot;
        return /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var release, updatedState;
            return (0,tslib_es6.__generator)(this, function(_state) {
                release = snapshot.retain();
                try {
                    updatedState = snapshot.map(function(param) {
                        var set = param.set;
                        return set(store/* default.modal */.ZP.modal, null);
                    }).map(function(param) {
                        var set = param.set;
                        return set(store/* default.overlay */.ZP.overlay, true);
                    }).map(function(param) {
                        var set = param.set;
                        return set(store/* default.sidebar */.ZP.sidebar, "cart");
                    });
                    // update state
                    gotoSnapshot(updatedState);
                } finally{
                    release();
                }
                return [
                    2
                ];
            });
        });
    });
    var disableRewardIds = (0,react.useMemo)(function() {
        return ((customer === null || customer === void 0 ? void 0 : customer.tags) || []).reduce(function(acc, id) {
            if (id.indexOf("_rewardId:") === 0) {
                var idInt = id.replace("_rewardId:", "");
                return (0,_to_consumable_array/* default */.Z)(acc).concat([
                    idInt
                ]);
            }
            return acc;
        }, []);
    }, [
        customer === null || customer === void 0 ? void 0 : customer.tags
    ]);
    (0,react.useEffect)(function() {
        var ref;
        var script;
        if (!(window === null || window === void 0 ? void 0 : (ref = window.loyaltylion) === null || ref === void 0 ? void 0 : ref.isLoyaltyLion)) {
            script = injectScript();
            setCount(count + 1);
        }
        return function() {
            if (typeof script === "object") {
                script.remove();
            }
        };
    }, []); // should only run once
    (0,react.useEffect)(function() {
        var interval = setInterval(function() {
            var ref;
            if (!(window === null || window === void 0 ? void 0 : (ref = window.loyaltylion) === null || ref === void 0 ? void 0 : ref.isLoyaltyLion)) {
                setCount(count + 1);
            } else {
                setLoyaltylionLoaded(true);
                clearInterval(interval);
            }
        }, 1000);
        return function() {
            setLoyaltylionLoaded(false);
            clearInterval(interval);
        };
    }, [
        count
    ]);
    (0,react.useEffect)(function() {
        if (loyaltylionLoaded) {
            var timeout = window.setTimeout(function() {
                initializeScript();
                window.loyaltylion.configure({
                    disableBundledFonts: true,
                    shopifyFrontend: "unknown"
                });
                setLoyaltylionInitialized(true);
                clearTimeout(timeout);
            }, 4000);
        }
    }, [
        loyaltylionLoaded,
        router
    ]);
    (0,react.useEffect)(function() {
        if ((customer === null || customer === void 0 ? void 0 : customer.id) && loyaltylionLoaded && authenticated) {
            if (!llAuthenticated) {
                authenticateCustomer(customer);
            }
            setLlllAuthenticated(true);
        } else if (loyaltylionLoaded) {
            setLlllAuthenticated(false);
            logoutCustomer();
        }
    }, [
        customer === null || customer === void 0 ? void 0 : customer.id,
        customerInit,
        authenticated,
        loyaltylionInitialized,
        router, 
    ]);
    (0,react.useEffect)(function() {
        if (cart === null || cart === void 0 ? void 0 : cart.id) {
            localStorage.setItem("ll-cart-object", JSON.stringify(cart));
        }
    }, [
        cart === null || cart === void 0 ? void 0 : cart.lines
    ]);
    (0,react.useEffect)(function() {
        var addProductToCart = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(claimedReward) {
                var ref, ref1, llCartString, llCart, ref2, ref3, ref4, ref5, loyaltyItemIds, couponCode, product, lineItemsId, claimedItem, ref6, ref7, discountCode, rewardId, ref8, updateItem, item;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            llCartString = localStorage.getItem("ll-cart-object") || {};
                            llCart = JSON.parse(llCartString);
                            if ((claimedReward === null || claimedReward === void 0 ? void 0 : (ref = claimedReward.reward) === null || ref === void 0 ? void 0 : ref.id) && (disableRewardIds === null || disableRewardIds === void 0 ? void 0 : disableRewardIds.length) && (disableRewardIds === null || disableRewardIds === void 0 ? void 0 : disableRewardIds.includes("".concat(claimedReward.reward.id)))) {
                                return [
                                    2,
                                    false
                                ];
                            }
                            if (!((claimedReward === null || claimedReward === void 0 ? void 0 : (ref1 = claimedReward.redeemable) === null || ref1 === void 0 ? void 0 : ref1.code) && (llCart === null || llCart === void 0 ? void 0 : llCart.id))) return [
                                3,
                                12
                            ];
                            if (!((claimedReward === null || claimedReward === void 0 ? void 0 : (ref2 = claimedReward.reward) === null || ref2 === void 0 ? void 0 : ref2.targetType) === "product")) return [
                                3,
                                12
                            ];
                            loyaltyItemIds = (ref3 = (llCart === null || llCart === void 0 ? void 0 : llCart.lines) || []) === null || ref3 === void 0 ? void 0 : ref3.reduce(function(acc, item) {
                                var ref;
                                if (item === null || item === void 0 ? void 0 : (ref = item.attributes) === null || ref === void 0 ? void 0 : ref.find(function(attr) {
                                    return (attr === null || attr === void 0 ? void 0 : attr.key) === "_source" && (attr === null || attr === void 0 ? void 0 : attr.value) === "ll free product";
                                })) {
                                    return (0,_to_consumable_array/* default */.Z)(acc).concat([
                                        item
                                    ]);
                                }
                                return acc;
                            }, []);
                            couponCode = claimedReward.redeemable.code;
                            product = claimedReward === null || claimedReward === void 0 ? void 0 : (ref4 = claimedReward.reward) === null || ref4 === void 0 ? void 0 : ref4.targetProducts[0];
                            lineItemsId = (loyaltyItemIds || []).reduce(function(acc, item) {
                                if (item.variant.id !== "gid://shopify/ProductVariant/".concat(product.variantId)) {
                                    return (0,_to_consumable_array/* default */.Z)(acc).concat([
                                        item.id
                                    ]);
                                }
                                return acc;
                            }, []);
                            if (!(lineItemsId === null || lineItemsId === void 0 ? void 0 : lineItemsId.length)) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                cartRemoveItems({
                                    lineIds: lineItemsId
                                })
                            ];
                        case 1:
                            _state.sent();
                            _state.label = 2;
                        case 2:
                            claimedItem = (loyaltyItemIds || []).find(function(item) {
                                return item.variant.id === "gid://shopify/ProductVariant/".concat(product.variantId);
                            });
                            if (!claimedItem) return [
                                3,
                                8
                            ];
                            discountCode = claimedItem === null || claimedItem === void 0 ? void 0 : (ref6 = claimedItem.attributes) === null || ref6 === void 0 ? void 0 : ref6.find(function(item) {
                                return item.key === "_discountCode";
                            });
                            rewardId = claimedItem === null || claimedItem === void 0 ? void 0 : (ref7 = claimedItem.attributes) === null || ref7 === void 0 ? void 0 : ref7.find(function(item) {
                                return item.key === "_rewardId";
                            });
                            if (!(couponCode === (discountCode === null || discountCode === void 0 ? void 0 : discountCode.value) && "".concat(claimedReward.reward.id) === (rewardId === null || rewardId === void 0 ? void 0 : rewardId.value))) return [
                                3,
                                3
                            ];
                            toggleCartSidebar();
                            return [
                                3,
                                7
                            ];
                        case 3:
                            updateItem = {
                                lineId: claimedItem.id,
                                quantity: claimedItem.quantity
                            };
                            updateItem.attributes = claimedItem.attributes.map(function(attr) {
                                if (attr.key === "_discountCode") {
                                    return {
                                        key: "_discountCode",
                                        value: "".concat(couponCode)
                                    };
                                }
                                if (attr.key === "_rewardId") {
                                    return {
                                        key: "_rewardId",
                                        value: "".concat(claimedReward.reward.id)
                                    };
                                }
                                return attr;
                            });
                            return [
                                4,
                                cartUpdateItem(updateItem)
                            ];
                        case 4:
                            _state.sent();
                            if (!(couponCode && !(cart === null || cart === void 0 ? void 0 : (ref8 = cart.discountCodes) === null || ref8 === void 0 ? void 0 : ref8.some(function(dc) {
                                return dc.code === couponCode;
                            })))) return [
                                3,
                                6
                            ];
                            return [
                                4,
                                cartAddDiscount({
                                    discountCode: couponCode
                                })
                            ];
                        case 5:
                            _state.sent();
                            _state.label = 6;
                        case 6:
                            toggleCartSidebar();
                            _state.label = 7;
                        case 7:
                            return [
                                2,
                                false
                            ];
                        case 8:
                            item = {
                                merchandiseId: "gid://shopify/ProductVariant/".concat(product.variantId),
                                quantity: 1
                            };
                            item.attributes = [
                                {
                                    key: "_source",
                                    value: "ll free product"
                                },
                                {
                                    key: "_discountCode",
                                    value: "".concat(claimedReward.redeemable.code)
                                },
                                {
                                    key: "_rewardId",
                                    value: "".concat(claimedReward.reward.id)
                                }, 
                            ];
                            return [
                                4,
                                cartAddItem(item)
                            ];
                        case 9:
                            _state.sent();
                            if (!(couponCode && !(llCart === null || llCart === void 0 ? void 0 : (ref5 = llCart.discountCodes) === null || ref5 === void 0 ? void 0 : ref5.some(function(discountCode) {
                                return discountCode.code === couponCode;
                            })))) return [
                                3,
                                11
                            ];
                            return [
                                4,
                                cartAddDiscount({
                                    discountCode: couponCode
                                })
                            ];
                        case 10:
                            _state.sent();
                            _state.label = 11;
                        case 11:
                            toggleCartSidebar();
                            _state.label = 12;
                        case 12:
                            return [
                                2,
                                true
                            ];
                    }
                });
            });
            return function addProductToCart(claimedReward) {
                return _ref.apply(this, arguments);
            };
        }();
        var t = setInterval(function() {
            var ref;
            if (timer > 20) {
                clearInterval(t);
            }
            if ((window === null || window === void 0 ? void 0 : window.loyaltylion) && (window === null || window === void 0 ? void 0 : (ref = window.loyaltylion) === null || ref === void 0 ? void 0 : ref.token) && (cart === null || cart === void 0 ? void 0 : cart.id)) {
                clearInterval(t);
                window.loyaltylion.on("ready", function() {
                    var ref, ref1, ref2, ref3;
                    if (!(window === null || window === void 0 ? void 0 : (ref = window.loyaltylion) === null || ref === void 0 ? void 0 : (ref1 = ref.registeredHook) === null || ref1 === void 0 ? void 0 : ref1.length) || (window === null || window === void 0 ? void 0 : (ref2 = window.loyaltylion) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.registeredHook) === null || ref3 === void 0 ? void 0 : ref3.indexOf("customers.rewards.claimed")) === -1) {
                        window.loyaltylion.registerHook("customers.rewards.claimed", function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
                                var claimedReward;
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            claimedReward = param.claimedReward;
                                            return [
                                                4,
                                                addProductToCart(claimedReward)
                                            ];
                                        case 1:
                                            _state.sent();
                                            return [
                                                2,
                                                {
                                                    action: "show_claim_modal"
                                                }
                                            ];
                                    }
                                });
                            });
                            return function(_1) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                        window.loyaltylion.registeredHook = [];
                        window.loyaltylion.registeredHook.push("customers.rewards.claimed");
                    }
                });
            } else {
                setTimer(timer + 1);
            }
        }, 500);
        var camelize = function(obj) {
            return _.transform(obj, function(acc, value, key, target) {
                var camelKey = _.isArray(target) ? key : _.camelCase(key);
                acc[camelKey] = _.isObject(value) ? camelize(value) : value;
            });
        };
        var getRewardFromCouponCode = function(couponCode) {
            var ref, ref1;
            if (typeof window.lion !== "object") {
                return null;
            }
            var claimedRewards = (((ref = window.lion) === null || ref === void 0 ? void 0 : (ref1 = ref.customer) === null || ref1 === void 0 ? void 0 : ref1.claimedRewards) || []).find(function(item) {
                var ref;
                return (item === null || item === void 0 ? void 0 : (ref = item.redeemable) === null || ref === void 0 ? void 0 : ref.code) === couponCode;
            });
            return camelize(claimedRewards);
        };
        var couponCodeClick = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
                var couponCodeEl, couponCode, claimedReward;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (e.target.classList.contains("lion-reward-code")) {
                                return [
                                    2
                                ];
                            }
                            if (e.target.classList.contains(".lion-reward-code__code")) {
                                couponCodeEl = e.target;
                            }
                            if (e.target.classList.contains(".lion-copy-to-clipboard-button") || e.target.closest(".lion-history-info-modal-content .lion-reward-code")) {
                                couponCodeEl = e.target.closest(".lion-history-info-modal-content").querySelector(".lion-reward-code__code");
                            }
                            if (!(couponCodeEl && couponCodeEl.innerText !== "")) return [
                                3,
                                5
                            ];
                            couponCode = couponCodeEl.innerText;
                            claimedReward = getRewardFromCouponCode(couponCode);
                            if (!(claimedReward === null || claimedReward === void 0 ? void 0 : claimedReward.id)) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                addProductToCart(claimedReward)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 2:
                            return [
                                4,
                                cartAddDiscount({
                                    discountCode: couponCode
                                })
                            ];
                        case 3:
                            _state.sent();
                            toggleCartSidebar();
                            _state.label = 4;
                        case 4:
                            if (e.target.closest(".lion-modal").querySelector(".lion-modal__close-button")) {
                                e.target.closest(".lion-modal").querySelector(".lion-modal__close-button").click();
                            }
                            _state.label = 5;
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function couponCodeClick(e) {
                return _ref.apply(this, arguments);
            };
        }();
        document.body.addEventListener("click", couponCodeClick);
        return function() {
            clearInterval(t);
            document.body.removeEventListener("click", couponCodeClick);
        };
    }, [
        loyaltylionLoaded,
        cart === null || cart === void 0 ? void 0 : cart.updatedAt,
        disableRewardIds
    ]);
    (0,react.useEffect)(function() {
        var handleBeforeHistoryChange = function() {
            var loyaltylionStyleEl = document.querySelector("link[rel=stylesheet][data-lion-css]");
            if (loyaltylionStyleEl && !(loyaltyLionStylesheet === null || loyaltyLionStylesheet === void 0 ? void 0 : loyaltyLionStylesheet.current)) {
                loyaltyLionStylesheet.current = loyaltylionStyleEl;
            }
        };
        var handleRouteChangeComplete = function() {
            var loyaltylionStyleEl = document.querySelector("link[rel=stylesheet][data-lion-css]");
            if (loyaltylionStyleEl && !(loyaltyLionStylesheet === null || loyaltyLionStylesheet === void 0 ? void 0 : loyaltyLionStylesheet.current)) {
                loyaltyLionStylesheet.current = loyaltylionStyleEl;
            }
            if (!loyaltylionStyleEl && (loyaltyLionStylesheet === null || loyaltyLionStylesheet === void 0 ? void 0 : loyaltyLionStylesheet.current)) {
                document.head.append(loyaltyLionStylesheet.current);
            }
        };
        router.events.on("beforeHistoryChange", handleBeforeHistoryChange);
        router.events.on("routeChangeComplete", handleRouteChangeComplete);
        return function() {
            router.events.off("beforeHistoryChange", handleBeforeHistoryChange);
            router.events.off("routeChangeComplete", handleRouteChangeComplete);
        };
    }, [
        router
    ]);
    return null;
}
LoyaltyLionScript.displayName = "LoyaltyLionScript";

;// CONCATENATED MODULE: ./src/snippets/LoyaltyLion/index.js


;// CONCATENATED MODULE: ./src/snippets/Vwo/Vwo.jsx
/* provided dependency */ var Vwo_process = __webpack_require__(14284);



function Vwo() {
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_jsx_runtime_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)((head_default()), {
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("link", {
                    rel: "preconnect",
                    href: "https://dev.visualwebsiteoptimizer.com"
                })
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)((script_default()), {
                id: "vwoCode",
                strategy: "beforeInteractive",
                dangerouslySetInnerHTML: {
                    __html: "window._vwo_code=window._vwo_code || (function() {\nvar account_id=".concat(Vwo_process.env.NEXT_PUBLIC_VWO_ACCOUNT_ID || 539877, ",\nversion = 1.5,\nsettings_tolerance=2000,\nlibrary_tolerance=2500,\nuse_existing_jquery=false,\nis_spa=1,\nhide_element='body',\nhide_element_style = 'opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important',\n/* DO NOT EDIT BELOW THIS LINE */\nf=false,w=window,d=document,vwoCodeEl=d.querySelector('#vwoCode'),code={use_existing_jquery:function(){return use_existing_jquery},library_tolerance:function(){return library_tolerance},hide_element_style:function(){return'{'+hide_element_style+'}'},finish:function(){if(!f){f=true;var e=d.getElementById('_vis_opt_path_hides');if(e)e.parentNode.removeChild(e)}},finished:function(){return f},load:function(e){var t=d.createElement('script');t.fetchPriority='high';t.src=e;t.type='text/javascript';t.onerror=function(){_vwo_code.finish()};d.getElementsByTagName('head')[0].appendChild(t)},getVersion:function(){return version},getMatchedCookies:function(e){var t=[];if(document.cookie){t=document.cookie.match(e)||[]}return t},getCombinationCookie:function(){var e=code.getMatchedCookies(/(?:^|;)\\s?(_vis_opt_exp_\\d+_combi=[^;$]*)/gi);e=e.map(function(e){try{var t=decodeURIComponent(e);if(!/_vis_opt_exp_\\d+_combi=(?:\\d+,?)+\\s*$/.test(t)){return''}return t}catch(e){return''}});var i=[];e.forEach(function(e){var t=e.match(/([\\d,]+)/g);t&&i.push(t.join('-'))});return i.join('|')},init:function(){if(d.URL.indexOf('__vwo_disable__')>-1)return;w.settings_timer=setTimeout(function(){_vwo_code.finish()},settings_tolerance);var e=d.currentScript,t=d.createElement('style'),i=e&&!e.async?hide_element?hide_element+'{'+hide_element_style+'}':'':code.lA=1,n=d.getElementsByTagName('head')[0];t.setAttribute('id','_vis_opt_path_hides');vwoCodeEl&&t.setAttribute('nonce',vwoCodeEl.nonce);t.setAttribute('type','text/css');if(t.styleSheet)t.styleSheet.cssText=i;else t.appendChild(d.createTextNode(i));n.appendChild(t);var o=this.getCombinationCookie();this.load('https://dev.visualwebsiteoptimizer.com/j.php?a='+account_id+'&u='+encodeURIComponent(d.URL)+'&f='+ +is_spa+'&vn='+version+(o?'&c='+o:''));return settings_timer}};w._vwo_settings_timer = code.init();return code;}());")
                }
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/snippets/Vwo/index.js


;// CONCATENATED MODULE: ./src/snippets/VideoWise/VideoWiseScript.jsx









function VideoWiseScript(param) {
    var template = param.template, product = param.product, collection = param.collection, page = param.page, article = param.article, blog = param.blog;
    var asPath = (0,next_router.useRouter)().asPath;
    var ref = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* default.videoWiseConfig */.ZP.videoWiseConfig), 2), videoWiseConfig = ref[0], setVideoWiseConfig = ref[1];
    var cartAddItem = (0,dist.useCartAddItem)().cartAddItem;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useSidebar */.Ap)(), 2), openSidebar = ref1[1].openSidebar;
    var st = (0,react.useMemo)(function() {
        if (template === "collection_page" && collection) {
            return {
                rid: (collection === null || collection === void 0 ? void 0 : collection.legacyResourceId) || null,
                p: "collection",
                rtyp: "collection"
            };
        }
        if (template === "product_page" && product) {
            return {
                rid: (product === null || product === void 0 ? void 0 : product.legacyResourceId) || null,
                p: "product",
                rtyp: "product"
            };
        }
        if (template === "page" && page) {
            return {
                rid: null,
                p: "page",
                rtyp: "page",
                pageurl: "".concat("https://www.brumate.com", "/pages/").concat(page === null || page === void 0 ? void 0 : page.handle)
            };
        }
        if (template === "article" && article) {
            return {
                rid: null,
                p: "article",
                rtyp: "article",
                pageurl: "".concat("https://www.brumate.com", "/articles/").concat(article === null || article === void 0 ? void 0 : article.handle)
            };
        }
        if (template === "blog" && (blog === null || blog === void 0 ? void 0 : blog.handle)) {
            return {
                rid: null,
                p: "blog",
                rtyp: "blog",
                pageurl: "".concat("https://www.brumate.com", "/blogs/").concat(blog === null || blog === void 0 ? void 0 : blog.handle)
            };
        }
        return {
            rid: null,
            p: "home",
            pageurl: "https://".concat("https://www.brumate.com")
        };
    }, [
        template,
        product === null || product === void 0 ? void 0 : product.id,
        collection,
        page,
        article,
        asPath
    ]);
    var handleVideowiseProductAddToCart = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
            var ref, ref1, ref2, ref3, variantId, item, cart, addedItem;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(event === null || event === void 0 ? void 0 : (ref = event.detail) === null || ref === void 0 ? void 0 : ref.productId) || !(event === null || event === void 0 ? void 0 : (ref1 = event.detail) === null || ref1 === void 0 ? void 0 : ref1.variantId)) {
                            return [
                                2,
                                false
                            ];
                        }
                        variantId = event.detail.variantId;
                        if (!variantId) return [
                            2,
                            false
                        ];
                        item = {
                            merchandiseId: "gid://shopify/ProductVariant/".concat(variantId),
                            quantity: 1
                        };
                        // adds shipscout attribute to collect data for abtest
                        if (typeof window.ShipScoutLineItemProperty !== "undefined") {
                            item.attributes = [
                                {
                                    key: "_sc",
                                    value: window.ShipScoutLineItemProperty
                                }, 
                            ];
                        }
                        if (typeof window.ShipScoutTrackAddToCart === "function") {
                            window.ShipScoutTrackAddToCart();
                        }
                        return [
                            4,
                            cartAddItem(item)
                        ];
                    case 1:
                        cart = _state.sent();
                        addedItem = cart === null || cart === void 0 ? void 0 : (ref2 = cart.lines) === null || ref2 === void 0 ? void 0 : ref2.slice(-1);
                        if ((addedItem === null || addedItem === void 0 ? void 0 : addedItem.length) && ((ref3 = addedItem === null || addedItem === void 0 ? void 0 : addedItem[0].variant) === null || ref3 === void 0 ? void 0 : ref3.id) === "gid://shopify/ProductVariant/".concat(variantId)) {
                            openSidebar("cart");
                        }
                        return [
                            2,
                            true
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    (0,react.useEffect)(function() {
        if (true) {
            window.SKIP_CART = true;
            window.FORCE_DOMAIN = true;
            window.VIDEOWISE_FAST_INLINE_VIDEO_PLAYER = true;
            /**
      * commented it out because it overrides the Shopify object and breaks the Shopify Privacy library
      window.Shopify = {
        shop: 'kryo-gear.myshopify.com',
        currency: { active: 'USD', rate: '1.0' },
      };
      */ if (window === null || window === void 0 ? void 0 : window.videowiseInfo) {
                window.videowiseInfo.currency = "USD";
                window.videowiseInfo.currencyRate = "1.0";
                window.videowiseInfo.host = "kryo-gear.myshopify.com";
            } else {
                window.videowiseInfo = {
                    currency: "USD",
                    currencyRate: "1.0",
                    host: "kryo-gear.myshopify.com"
                };
            }
            window.__st = st;
            // setLoaded(true);
            setVideoWiseConfig(true);
            window.addEventListener("videowiseProductAddToCart", handleVideowiseProductAddToCart);
        }
        return function() {
            // setLoaded(false);
            setVideoWiseConfig(false);
            window.removeEventListener("videowiseProductAddToCart", handleVideowiseProductAddToCart);
        };
    }, []);
    return null;
}
VideoWiseScript.displayName = "VideoWiseScript";

;// CONCATENATED MODULE: ./src/snippets/VideoWise/index.js


;// CONCATENATED MODULE: ./src/snippets/BuyWithPrime/BuyWithPrime.jsx

function BuyWithPrime() {
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
        id: "amzn-bwp-cart",
        "data-site-id": "o3krsbin2k" || 0,
        "data-widget-id": "w-gfUDvYZJWj7eeyHQGn9uk6" || 0
    });
}

;// CONCATENATED MODULE: ./src/snippets/BuyWithPrime/index.js


;// CONCATENATED MODULE: ./src/snippets/index.js



















































/***/ }),

/***/ 27695:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ store; },
  "le": function() { return /* reexport */ es.useGotoRecoilSnapshot; },
  "_8": function() { return /* binding */ useRecoilCallback; },
  "FV": function() { return /* binding */ useRecoilState; },
  "sJ": function() { return /* binding */ useRecoilValue; },
  "Zl": function() { return /* binding */ useSetRecoilState; }
});

// UNUSED EXPORTS: atom, atomFamily, selector, selectorFamily, useRecoilSnapshot, useRecoilStateLoadable, useRecoilValueLoadable, useResetRecoilState

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@backpackjs/storefront/dist/index.js
var dist = __webpack_require__(52031);
;// CONCATENATED MODULE: ./src/store/Cart.js

var addingToCartStatus = dist.store.recoil.atom({
    key: "cart/addingToCartStatus",
    default: {
        started: false,
        finished: false,
        success: false,
        errors: []
    }
});
var updatingCartStatus = dist.store.recoil.atom({
    key: "cart/updatingCartStatus",
    default: {
        started: false,
        finished: false,
        success: false,
        errors: []
    }
});
var upsellProductsNotInCart = dist.store.recoil.atom({
    key: "cart/upsellProductsNotInCart",
    default: []
});
var byobTier = dist.store.recoil.atom({
    key: "cart/byobTier",
    default: null
});
var cartIsMaxed = dist.store.recoil.atom({
    key: "cart/cartIsMaxed",
    default: false
});
var cartDiscountAmount = dist.store.recoil.atom({
    key: "cart/discountAmount",
    default: 0
});
/* harmony default export */ var Cart = ({
    addingToCartStatus: addingToCartStatus,
    updatingCartStatus: updatingCartStatus,
    upsellProductsNotInCart: upsellProductsNotInCart,
    byobTier: byobTier,
    cartIsMaxed: cartIsMaxed,
    cartDiscountAmount: cartDiscountAmount
});

;// CONCATENATED MODULE: ./src/store/Cms.js

var siteSettings = dist.store.recoil.atom({
    key: "cms/siteSettings",
    default: null
});
var sections = dist.store.recoil.atomFamily({
    key: "cms/sections",
    default: null,
    effects_UNSTABLE: []
});
/* harmony default export */ var Cms = ({
    // atoms
    siteSettings: siteSettings,
    sections: sections
});

;// CONCATENATED MODULE: ./src/store/Collection.js
/* provided dependency */ var process = __webpack_require__(14284);

var collection = dist.store.recoil.atom({
    key: "collection",
    default: null
});
var selectedSort = dist.store.recoil.atom({
    key: "collection/selectedSort",
    default: null
});
var selectedFilters = dist.store.recoil.atom({
    key: "collection/selectedFilters",
    default: []
});
var selectedResultsPerPage = dist.store.recoil.atom({
    key: "collection/selectedResultsPerPage",
    default: parseInt(process.env.NEXT_PUBLIC_COLLECTIONS_RESOLVE_FIRST, 10) || 30
});
var currentResultsPage = dist.store.recoil.atom({
    key: "collection/currentResultsPage",
    default: 1
});
var filtersSidebar = dist.store.recoil.atom({
    key: "collection/filtersSidebar",
    default: null
});
var swatchesMap = dist.store.recoil.atom({
    key: "collection/swatchesMap",
    default: {}
});
/* harmony default export */ var Collection = ({
    // atoms
    collection: collection,
    selectedSort: selectedSort,
    selectedFilters: selectedFilters,
    selectedResultsPerPage: selectedResultsPerPage,
    currentResultsPage: currentResultsPage,
    filtersSidebar: filtersSidebar,
    swatchesMap: swatchesMap
});

;// CONCATENATED MODULE: ./src/store/GiftWithPurchase.js

var gwpVariantIds = dist.store.recoil.atom({
    key: "giftWithPurchase/variantIds",
    default: null
});
var gwpProducts = dist.store.recoil.atom({
    key: "giftWithPurchase/products",
    default: null
});
/* harmony default export */ var GiftWithPurchase = ({
    gwpVariantIds: gwpVariantIds,
    gwpProducts: gwpProducts
});

;// CONCATENATED MODULE: ./src/store/Global.js

var overlay = dist.store.recoil.atom({
    key: "global/overlay",
    default: null
});
var modal = dist.store.recoil.atom({
    key: "global/modal",
    default: null
});
var sidebar = dist.store.recoil.atom({
    key: "global/sidebar",
    default: null
});
var cookiesMap = dist.store.recoil.atom({
    key: "global/cookiesMap",
    default: {}
});
var blogCategory = dist.store.recoil.atom({
    key: "global/blogCategory",
    default: null
});
var elevarMarketingObject = dist.store.recoil.atom({
    key: "global/elevarMarketingObject",
    default: null
});
var shopperId = dist.store.recoil.atom({
    key: "global/shopperId",
    default: null
});
var collectionsMap = dist.store.recoil.atom({
    key: "global/collectionsMap",
    default: []
});
var loyaltylionLoaded = dist.store.recoil.atom({
    key: "global/loyaltylionLoaded",
    default: false
});
var videoWiseLoaded = dist.store.recoil.atom({
    key: "global/videoWiseLoaded",
    default: false
});
var videoWiseConfig = dist.store.recoil.atom({
    key: "global/videoWiseConfig",
    default: false
});
var rewardsRedirect = dist.store.recoil.atom({
    key: "global/rewardsRedirect",
    default: false
});
var superCollectionTitle = dist.store.recoil.atom({
    key: "global/superCollectionTitle",
    default: false
});
// Access to Password Protected Pages
// starts as true on first time visit. Value then updates on mount
// when cookie OR gatedPage has been found in usePasswordProtected.js
var hasAccess = dist.store.recoil.atom({
    key: "hasAccess",
    default: true
});
var gatedPage = dist.store.recoil.atom({
    key: "gatedPage",
    default: null
});
/* harmony default export */ var Global = ({
    overlay: overlay,
    modal: modal,
    sidebar: sidebar,
    cookiesMap: cookiesMap,
    blogCategory: blogCategory,
    elevarMarketingObject: elevarMarketingObject,
    shopperId: shopperId,
    collectionsMap: collectionsMap,
    loyaltylionLoaded: loyaltylionLoaded,
    videoWiseLoaded: videoWiseLoaded,
    videoWiseConfig: videoWiseConfig,
    hasAccess: hasAccess,
    gatedPage: gatedPage,
    rewardsRedirect: rewardsRedirect,
    superCollectionTitle: superCollectionTitle
});

;// CONCATENATED MODULE: ./src/store/Menu.js

/**
 *  MenuDrawer states (desktop)
 */ // the currently hovered to menu link object
var hoveredItem = dist.store.recoil.atom({
    key: "menu/hoveredItem",
    default: null
});
// true when the menuDrawer is fully open
var menuDrawer = dist.store.recoil.atom({
    key: "menu/menuDrawer",
    default: false
});
/**
 *  MenuSideBar states (mobile)
 */ var menuSidebar = dist.store.recoil.atom({
    key: "menu/menuSidebar",
    default: false
});
var selectedItem = dist.store.recoil.atom({
    key: "menu/selectedItem",
    default: false
});
var selectedIndex = dist.store.recoil.atom({
    key: "menu/selectedIndex",
    default: 0
});
// Promobar
var promobarClosed = dist.store.recoil.atom({
    key: "menu/promobarClosed",
    default: false
});
// eslint-disable-next-line import/no-default-export
/* harmony default export */ var Menu = ({
    // MenuDrawer (desktop)
    menuDrawer: menuDrawer,
    hoveredItem: hoveredItem,
    // MenuSideBar (Mobile)
    menuSidebar: menuSidebar,
    selectedItem: selectedItem,
    selectedIndex: selectedIndex,
    // Promobar
    promobarClosed: promobarClosed
}); // import { store } from '@backpackjs/storefront';
 // const drawerOpen  = store.recoil.atom({
 //   key: 'menu/drawerOpen',
 //   default: false
 // })
 // const setDrawerOpen$  = store.recoil.selector({
 //   key: 'menu/setDrawerOpen$',
 //   set: ({ get, set }, newState) => {
 //     const _menuItem = get(menuItem);
 //     const _drawerOpen = get(drawerOpen);
 //     // stay open
 //     if (_menuItem && newState !== false) {
 //       set(drawerOpen, true)
 //     }
 //     // maybe closing
 //     else {
 //       const isClosing = !drawerOpen || newState === false
 //       if (isClosing) {
 //         // ensure we close the drawer
 //         set(menuItem, null)
 //       }
 //       if (typeof newState === 'undefined') {
 //         set(drawerOpen, !_drawerOpen)
 //       } else {
 //         set(drawerOpen, newState)
 //       }
 //     }
 //   }
 // })
 // const drawerHoverThreshold = store.recoil.atom({
 //   key: 'menu/drawerHoverThreshold',
 //   default: 250,
 // })
 // const menuItem = store.recoil.atom({
 //   key: 'menu/menuItem',
 //   default: null,
 //   effects_UNSTABLE: [
 //     // logStateChange('menuItem'),
 //   ]
 // })
 // const menuItemChild = store.recoil.atom({
 //   key: 'menu/menuItemChild',
 //   default: null,
 //   effects_UNSTABLE: [
 //     // logStateChange('menuItem')
 //   ]
 // })
 // const setMenuItemAndChild$  = store.recoil.selector({
 //   key: 'menu/setMenuItemAndChild$',
 //   set: ({ get, set }, newState) => {
 //     set(menuItem, newState)
 //     const hoverParentHasSubItem = newState?.subItems?.length
 //     if (hoverParentHasSubItem) {
 //       // set first subItem as hovered
 //       set(menuItemChild, newState?.subItems[0])
 //     } else {
 //       set(menuItemChild, null)
 //     }
 //   }
 // })
 // const menuItemHasChildren$ = store.recoil.selector({
 //   key: 'menu/menuItemHasChildren$',
 //   get: ({ get}) => {
 //     const _menuItem = get(menuItem);
 //     return _menuItem?.subItems?.length
 //   }
 // })
 // // eslint-disable-next-line import/no-default-export
 // export default  {
 //   // atoms
 //   drawerOpen,
 //   drawerHoverThreshold,
 //   menuItem,
 //   menuItemChild,
 //   // selectors
 //   setDrawerOpen$,
 //   menuItemHasChildren$,
 //   setMenuItemAndChild$
 // }

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(23842);
// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(59312);
;// CONCATENATED MODULE: ./src/store/Search.js



// instant un-debounced search term (not used)
var rawTerm = dist.store.recoil.atom({
    key: "search/rawTerm",
    default: ""
});
// debounced term used
var term = dist.store.recoil.atom({
    key: "search/term",
    default: ""
});
// if search term originated from autocomplete
var isAutocomplete = dist.store.recoil.atom({
    key: "search/isAutocomplete",
    default: false
});
// true when search input is focused
var searchIsFocused = dist.store.recoil.atom({
    key: "search/searchIsFocused",
    default: false
});
// holds both results
var results$ = dist.store.recoil.selector({
    key: "search/results$",
    get: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var get, _term, response;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        get = param.get;
                        _term = get(term);
                        if (!_term) return [
                            2,
                            null
                        ];
                        return [
                            4,
                            searchShopify(_term)
                        ];
                    case 1:
                        response = _state.sent();
                        if (response && response.error) {
                            throw response.error;
                        }
                        return [
                            2,
                            response
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()
});
// search fetch function
var searchShopify = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(term) {
        var options, request, response, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    options = {
                        method: "POST",
                        body: JSON.stringify({
                            term: term
                        })
                    };
                    return [
                        4,
                        fetch("/api/shopify/search", options)
                    ];
                case 1:
                    request = _state.sent();
                    return [
                        4,
                        request.json()
                    ];
                case 2:
                    response = _state.sent().response;
                    return [
                        2,
                        (response === null || response === void 0 ? void 0 : response.results) || null
                    ];
                case 3:
                    e = _state.sent();
                    console.error("searchShopify:error", e);
                    return [
                        2,
                        []
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function searchShopify(term) {
        return _ref.apply(this, arguments);
    };
}();
var searchData = dist.store.recoil.atom({
    key: "search/searchData",
    default: null
});
var searchPageData = dist.store.recoil.atom({
    key: "search/searchPageData",
    default: null
});
var searchResults = dist.store.recoil.atom({
    key: "search/searchResults",
    default: []
});
var searchSuggestions = dist.store.recoil.atom({
    key: "search/searchSuggestions",
    default: []
});
var searchSpellCorrection = dist.store.recoil.atom({
    key: "search/searchSpellCorrection",
    default: []
});
var searchPageSpellCorrection = dist.store.recoil.atom({
    key: "search/searchPageSpellCorrection",
    default: []
});
var searchPageSuggestions = dist.store.recoil.atom({
    key: "search/searchPageSuggestions",
    default: []
});
var searchSuggested = dist.store.recoil.atom({
    key: "search/searchSuggested",
    default: null
});
var searchPageSuggested = dist.store.recoil.atom({
    key: "search/searchPageSuggested",
    default: null
});
var searchAlternatives = dist.store.recoil.atom({
    key: "search/searchAlternatives",
    default: []
});
var searchTrending = dist.store.recoil.atom({
    key: "search/searchTrending",
    default: []
});
var searchSelectedSort = dist.store.recoil.atom({
    key: "search/selectedSort",
    default: null
});
var searchSelectedFilters = dist.store.recoil.atom({
    key: "search/searchSelectedFilters",
    default: []
});
var searchSelectedResultsPerPage = dist.store.recoil.atom({
    key: "search/selectedResultsPerPage",
    default: 60
});
var searchCurrentResultsPage = dist.store.recoil.atom({
    key: "search/currentResultsPage",
    default: 1
});
var searchLoading = dist.store.recoil.atom({
    key: "search/searchLoading",
    default: true
});
/* harmony default export */ var Search = ({
    // atoms
    isAutocomplete: isAutocomplete,
    rawTerm: rawTerm,
    searchAlternatives: searchAlternatives,
    searchCurrentResultsPage: searchCurrentResultsPage,
    searchData: searchData,
    searchIsFocused: searchIsFocused,
    searchLoading: searchLoading,
    searchPageData: searchPageData,
    searchPageSpellCorrection: searchPageSpellCorrection,
    searchPageSuggested: searchPageSuggested,
    searchPageSuggestions: searchPageSuggestions,
    searchResults: searchResults,
    searchSelectedFilters: searchSelectedFilters,
    searchSelectedResultsPerPage: searchSelectedResultsPerPage,
    searchSelectedSort: searchSelectedSort,
    searchSpellCorrection: searchSpellCorrection,
    searchSuggested: searchSuggested,
    searchSuggestions: searchSuggestions,
    searchTrending: searchTrending,
    term: term,
    // selectors
    results$: results$
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ./src/utils/index.js + 7 modules
var utils = __webpack_require__(39136);
;// CONCATENATED MODULE: ./src/store/effects.js




// update the "variant" query param on selected variant change
var onSetUpdateVariantUrlParam = function() {
    return function(param) {
        var onSet = param.onSet;
        onSet(function(selectedVariant) {
            if (!utils/* isBrowser */.jU || !(window === null || window === void 0 ? void 0 : window.location)) return;
            if (!(selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.legacyResourceId)) return;
            var _location = window.location, origin = _location.origin, search = _location.search;
            // update variant param
            var params = new URLSearchParams(search);
            params.set("variant", selectedVariant.legacyResourceId);
            var updatedUrl = "".concat(origin, "/products/").concat(selectedVariant.product.handle, "?").concat(params);
            window.history.replaceState(window.history.state, "", updatedUrl);
            return selectedVariant;
        });
    };
};
var updateLocalStorage = function(storageKey) {
    return function(param) {
        var setSelf = param.setSelf, onSet = param.onSet;
        if (!utils/* isBrowser */.jU) return;
        var savedValue = window.localStorage.getItem(storageKey);
        if (savedValue != null) {
            setSelf(JSON.parse(savedValue));
        }
        onSet(function(newValue) {
            if (typeof newValue === "undefined") {
                window.localStorage.removeItem(storageKey);
            } else {
                switch(storageKey){
                    case "WISHLIST_EMAIL":
                        {
                            window.localStorage.setItem(storageKey, JSON.stringify({
                                email: newValue
                            }));
                            break;
                        }
                    case "WISHLIST_ID":
                        {
                            window.localStorage.setItem(storageKey, JSON.stringify({
                                lid: newValue
                            }));
                            break;
                        }
                    case "WISHLIST":
                        {
                            window.localStorage.setItem(storageKey, JSON.stringify({
                                items: newValue
                            }));
                            break;
                        }
                    default:
                        console.log("Unsupported localStorage key", storageKey, ". Skipping.");
                }
            }
        });
    };
};
/* harmony default export */ var effects = ((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, dist.store.effects), {
    // more effects here
    onSetUpdateVariantUrlParam: onSetUpdateVariantUrlParam,
    updateLocalStorage: updateLocalStorage
}));

;// CONCATENATED MODULE: ./src/store/SelectedSellingPlan.js


var sellingPlans = dist.store.recoil.atomFamily({
    key: "sellingPlan/sellingPlans",
    default: null
});
var selectedPlan = dist.store.recoil.atomFamily({
    key: "sellingPlan/selectedPlan",
    default: null,
    effects_UNSTABLE: [
        effects.logStateChange("selectedPlan"),
        // effects.onSetUpdateVariantUrlParam(), // TODO: add &selling_plan=
        effects.onChange({
            key: "selectedPlan",
            topic: "SELLING_PLAN_UPDATE",
            actions: [
                "publishGtmEvent",
                "publishBusEvent"
            ]
        }), 
    ]
});
/* harmony default export */ var SelectedSellingPlan = ({
    sellingPlans: sellingPlans,
    selectedPlan: selectedPlan
});

// EXTERNAL MODULE: ../node_modules/fast-deep-equal/index.js
var fast_deep_equal = __webpack_require__(66471);
var fast_deep_equal_default = /*#__PURE__*/__webpack_require__.n(fast_deep_equal);
;// CONCATENATED MODULE: ./src/store/SelectedVariant.js




// tracks the combined selected options e.g { size: 'sm', color: 'red' }
var selectedOptions = dist.store.recoil.atomFamily({
    key: "product/selectedOptions",
    default: null,
    effects_UNSTABLE: []
});
var selectedVariant = dist.store.recoil.atomFamily({
    key: "product/selectedVariant",
    default: null,
    effects_UNSTABLE: [
        // effects.logStateChange('selectedVariant'),
        effects.onSetUpdateVariantUrlParam(),
        effects.onChange({
            key: "selectedVariant",
            topic: "VARIANT_UPDATE",
            actions: [
                "publishGtmEvent",
                "publishBusEvent"
            ]
        }), 
    ]
});
// return only the medias for the selected handle
var selectedMedia$ = dist.store.recoil.selector({
    key: "product/selectedMedia",
    get: function(param) {
        var get = param.get;
        var _product = get(dist.store.state.product);
        if (!_product) return [];
        var _selectedOptions = get(selectedOptions(_product.handle));
        if (!_selectedOptions) return [];
        try {
            var color = _selectedOptions.color;
            var selectedMedia = color ? _product.media.filter(function(param) {
                var product = param.product;
                var ref;
                return (ref = product.tags.find(function(tag) {
                    return tag.match(new RegExp("color::".concat(color), "gi"));
                })) === null || ref === void 0 ? void 0 : ref.length;
            }) : _product.media;
            return selectedMedia;
        } catch (error) {
            return _product.media;
        }
    }
});
// merges a newly selected option with the existing selectedOptions
// newOption: should be an object e.g { color: 'blue' }
var setSelectedOptions$ = dist.store.recoil.selectorFamily({
    key: "product/setSelectedOptions$",
    set: function(handle) {
        return function(param, newOptions) {
            var get = param.get, set = param.set;
            var _product = get(dist.store.state.product);
            // navigating to a page other than PDP
            if (!_product || !newOptions || !handle) {
                return;
            }
            // have option update both
            var _selectedOptions = get(selectedOptions(handle));
            var updatedSelectedOptions = (0,_object_spread/* default */.Z)({}, _selectedOptions, newOptions);
            // update selected options for this product
            set(selectedOptions(handle), updatedSelectedOptions);
            var _selectedVariant = getVariantFromOptions(updatedSelectedOptions, _product.variants);
            if (_selectedVariant) {
                set(selectedVariant(handle), _selectedVariant);
            }
        };
    }
});
// determines wether a set of options e.g selectedOptions + a passedOption
// returns a variant that's available for sale
var optionIsAvailable$ = dist.store.recoil.selectorFamily({
    key: "product/optionIsAvailable$",
    get: function(queriedOption) {
        return function(param) {
            var get = param.get;
            var _product = get(dist.store.state.product);
            if (!_product) return false;
            var _selectedOptions = get(selectedOptions(_product.handle));
            var queriedOptions = (0,_object_spread/* default */.Z)({}, _selectedOptions, queriedOption);
            var _selectedVariant = getVariantFromOptions(queriedOptions, _product.variants);
            return _selectedVariant ? _selectedVariant.availableForSale : false;
        };
    }
});
var isSoldOut$ = dist.store.recoil.selector({
    key: "product/isSoldOut$",
    get: function(param) {
        var get = param.get;
        var _product = get(dist.store.state.product);
        if (!_product) return false;
        var _selectedVariant = get(selectedVariant(_product.handle));
        return _selectedVariant ? _selectedVariant.inventoryQuantity <= 0 && _selectedVariant.inventoryPolicy !== "CONTINUE" : false;
    }
});
var isPreOrder$ = dist.store.recoil.selector({
    key: "product/isPreOrder$",
    get: function(param) {
        var get = param.get;
        var _product = get(dist.store.state.product);
        if (!_product) return false;
        var _selectedVariant = get(selectedVariant(_product.handle));
        return _selectedVariant ? _selectedVariant.inventoryQuantity <= 0 && _selectedVariant.inventoryPolicy === "CONTINUE" : false;
    }
});
/* Utilities */ var getVariantFromOptions = function(selectedOptions, variants) {
    return variants === null || variants === void 0 ? void 0 : variants.find(function(param) {
        var selectedOptionsMap = param.selectedOptionsMap;
        return fast_deep_equal_default()(selectedOptions, selectedOptionsMap);
    });
};
var initialProduct = dist.store.recoil.atom({
    key: "product/initialProduct",
    default: null
});
/* harmony default export */ var SelectedVariant = ({
    selectedOptions: selectedOptions,
    selectedVariant: selectedVariant,
    selectedMedia$: selectedMedia$,
    setSelectedOptions$: setSelectedOptions$,
    optionIsAvailable$: optionIsAvailable$,
    initialProduct: initialProduct,
    // selectors
    isPreOrder$: isPreOrder$,
    isSoldOut$: isSoldOut$
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(31373);
;// CONCATENATED MODULE: ./src/store/Yotpo.js





var yoptoActivePage = dist.store.recoil.atomFamily({
    key: "yotpo/activePage",
    default: 1
});
// ugc
var yoptoActivePost = dist.store.recoil.atom({
    key: "yotpo/yoptoActivePost",
    default: null
});
// term
var yoptoActiveTerm = dist.store.recoil.atomFamily({
    key: "yotpo/activeTerm",
    default: "all"
});
var yoptoActiveView = dist.store.recoil.atomFamily({
    key: "yotpo/activeView",
    default: "reviews"
});
var getYotpoBottomLine$ = dist.store.recoil.selectorFamily({
    key: "yotpo/stars",
    get: function(legacyResourceId) {
        return function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
                var get;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            get = param.get;
                            if (!legacyResourceId) throw new Error("Yotpo stars legacyResourceId not provided");
                            return [
                                4,
                                yotpoApiClient("getProductsBottomline")({
                                    legacyResourceId: legacyResourceId
                                })
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }();
    }
});
var getYotpoProductReviews$ = dist.store.recoil.selectorFamily({
    key: "yotpo/getYotpoProductReviews$",
    get: function(_param) {
        var legacyResourceId = _param.legacyResourceId, params = (0,_object_without_properties/* default */.Z)(_param, [
            "legacyResourceId"
        ]);
        return function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
                var get;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            get = param.get;
                            if (!legacyResourceId) throw new Error("Yotpo legacyResourceId not provided");
                            return [
                                4,
                                yotpoApiClient("getProductReviews")((0,_object_spread/* default */.Z)({
                                    legacyResourceId: legacyResourceId
                                }, params))
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }();
    }
});
var getYotpoProductQuestions$ = dist.store.recoil.selectorFamily({
    key: "yotpo/getYotpoProductQuestions$",
    get: function(_param) {
        var legacyResourceId = _param.legacyResourceId, params = (0,_object_without_properties/* default */.Z)(_param, [
            "legacyResourceId"
        ]);
        return function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
                var get;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            get = param.get;
                            if (!legacyResourceId) throw new Error("Yotpo legacyResourceId not provided");
                            return [
                                4,
                                yotpoApiClient("getProductQuestions")((0,_object_spread/* default */.Z)({
                                    legacyResourceId: legacyResourceId
                                }, params))
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }();
    }
});
var getYotpoProductTopics$ = dist.store.recoil.selectorFamily({
    key: "yotpo/getYotpoProductTopics$",
    get: function(_param) {
        var legacyResourceId = _param.legacyResourceId, params = (0,_object_without_properties/* default */.Z)(_param, [
            "legacyResourceId"
        ]);
        return function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
                var get;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            get = param.get;
                            if (!legacyResourceId) throw new Error("Yotpo legacyResourceId not provided");
                            return [
                                4,
                                yotpoApiClient("getProductTopics")({
                                    legacyResourceId: legacyResourceId
                                })
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }();
    }
});
var getYotpoSearchReviews$ = dist.store.recoil.selectorFamily({
    key: "yotpo/getYotpoSearchReviews$",
    get: function(_param) {
        var legacyResourceId = _param.legacyResourceId, params = (0,_object_without_properties/* default */.Z)(_param, [
            "legacyResourceId"
        ]);
        return function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
                var get;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            get = param.get;
                            if (!legacyResourceId) throw new Error("Yotpo legacyResourceId not provided");
                            return [
                                4,
                                yotpoApiClient("getSearchReviews")((0,_object_spread/* default */.Z)({
                                    legacyResourceId: legacyResourceId
                                }, params))
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }();
    }
});
var getYotpoSitesReviews$ = dist.store.recoil.selectorFamily({
    key: "yotpo/getYotpoSiteReviews$",
    get: function(params) {
        return function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
                var get;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            get = param.get;
                            return [
                                4,
                                yotpoApiClient("getSiteReviews")(params)
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }();
    }
});
var getYotpoUgcAlbums$ = dist.store.recoil.selector({
    key: "yotpo/getYotpoUgcAlbum$",
    get: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var get;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        get = param.get;
                        return [
                            4,
                            yotpoApiClient("getUgcAlbums")()
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()
});
var getYotpoUgcAlbumByName$ = dist.store.recoil.selectorFamily({
    key: "yotpo/getYotpoUgcAlbumByName$",
    get: function(_param) {
        var name = _param.name, params = (0,_object_without_properties/* default */.Z)(_param, [
            "name"
        ]);
        return function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
                var get;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            get = param.get;
                            if (!name) throw new Error("Yotpo album name not provided");
                            return [
                                4,
                                yotpoApiClient("getUgcAlbumByName")((0,_object_spread/* default */.Z)({
                                    name: name
                                }, params))
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }();
    }
});
/**
 * Helpers
 */ var yotpoApiClient = function(action) {
    return function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var request, response, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            fetch("/api/yotpo", {
                                method: "POST",
                                body: JSON.stringify((0,_object_spread/* default */.Z)({
                                    action: action
                                }, data))
                            })
                        ];
                    case 1:
                        request = _state.sent();
                        if (!request.ok) {
                            throw new Error("Yotpo ".concat(action, " request not ok"));
                        }
                        return [
                            4,
                            request.json()
                        ];
                    case 2:
                        response = _state.sent();
                        return [
                            2,
                            response.data
                        ];
                    case 3:
                        error = _state.sent();
                        console.error(action, error.message);
                        throw error;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }();
};
/* harmony default export */ var Yotpo = ({
    // atom;
    yoptoActivePage: yoptoActivePage,
    yoptoActivePost: yoptoActivePost,
    yoptoActiveView: yoptoActiveView,
    yoptoActiveTerm: yoptoActiveTerm,
    // selectors
    getYotpoUgcAlbumByName$: getYotpoUgcAlbumByName$,
    getYotpoUgcAlbums$: getYotpoUgcAlbums$,
    getYotpoBottomLine$: getYotpoBottomLine$,
    getYotpoProductReviews$: getYotpoProductReviews$,
    getYotpoProductQuestions$: getYotpoProductQuestions$,
    getYotpoProductTopics$: getYotpoProductTopics$,
    getYotpoSearchReviews$: getYotpoSearchReviews$,
    getYotpoSitesReviews$: getYotpoSitesReviews$
});

;// CONCATENATED MODULE: ./src/store/Wishlist.js


var wishlistInit = dist.store.recoil.atom({
    key: "wishlist/wishlistInit",
    default: false
});
var wishlist = dist.store.recoil.atom({
    key: "wishlist/wishlist",
    default: [],
    effects_UNSTABLE: [
        updateLocalStorage("WISHLIST")
    ]
});
var wishlistEmail = dist.store.recoil.atom({
    key: "wishlist/wishlistEmail",
    default: null,
    effects_UNSTABLE: [
        updateLocalStorage("WISHLIST_EMAIL")
    ]
});
var wishlistId = dist.store.recoil.atom({
    key: "wishlist/wishlistId",
    default: null,
    effects_UNSTABLE: [
        updateLocalStorage("WISHLIST_ID")
    ]
});
var variantIsWishlisted = dist.store.recoil.selectorFamily({
    key: "wishlist/variantIsWishlisted",
    get: function(wishlistVariant) {
        return function(param) {
            var get = param.get;
            if (!wishlistVariant) return false;
            var _wishlist = get(wishlist);
            var _selectedResourceId = parseInt(wishlistVariant.legacyResourceId, 10) || null;
            var variantInWishList = function(param) {
                var epi = param.epi;
                return epi === _selectedResourceId;
            };
            var _variantIsWishlisted = (_wishlist === null || _wishlist === void 0 ? void 0 : _wishlist.length) && _selectedResourceId ? _wishlist.find(variantInWishList) : false;
            return _variantIsWishlisted;
        };
    }
});
/* harmony default export */ var Wishlist = ({
    wishlistInit: wishlistInit,
    wishlist: wishlist,
    wishlistEmail: wishlistEmail,
    wishlistId: wishlistId,
    variantIsWishlisted: variantIsWishlisted
});

// EXTERNAL MODULE: ../node_modules/recoil/es/index.js
var es = __webpack_require__(69853);
;// CONCATENATED MODULE: ./src/store/index.js














// share storefront recoil within the project
// export const useGotoRecoilSnapshot = store.recoil.useGotoRecoilSnapshot;
var useRecoilState = dist.store.recoil.useRecoilState;
var useRecoilStateLoadable = dist.store.recoil.useRecoilStateLoadable;
var useSetRecoilState = dist.store.recoil.useSetRecoilState;
var useResetRecoilState = dist.store.recoil.useResetRecoilState;
var useRecoilValue = dist.store.recoil.useRecoilValue;
var useRecoilValueLoadable = dist.store.recoil.useRecoilValueLoadable;
var useRecoilSnapshot = dist.store.recoil.useRecoilSnapshot;
var useRecoilCallback = dist.store.recoil.useRecoilCallback;
var atom = dist.store.recoil.atom;
var atomFamily = dist.store.recoil.atomFamily;
var selector = dist.store.recoil.selector;
var selectorFamily = dist.store.recoil.selectorFamily;
// eslint-disable-next-line import/no-default-export
/* harmony default export */ var store = ((0,_object_spread/* default */.Z)({}, Cart, Cms, Collection, GiftWithPurchase, Global, Menu, Search, SelectedSellingPlan, SelectedVariant, Yotpo, Wishlist));


/***/ }),

/***/ 45115:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* binding */ InputField; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(31373);
// EXTERNAL MODULE: ../node_modules/theme-ui/jsx-runtime/dist/theme-ui-jsx-runtime.esm.js + 2 modules
var theme_ui_jsx_runtime_esm = __webpack_require__(70863);
// EXTERNAL MODULE: ../node_modules/@theme-ui/components/dist/theme-ui-components.esm.js
var theme_ui_components_esm = __webpack_require__(62680);
// EXTERNAL MODULE: ./src/theme/create.jsx
var create = __webpack_require__(73355);
// EXTERNAL MODULE: ./src/theme/theme.colors.js
var theme_colors = __webpack_require__(75458);
;// CONCATENATED MODULE: ./src/templates/account/Shared/InputField.theme.js


var themed = (0,create/* create */.U)(new function() {
    this.label = function(disabled) {
        return {
            variant: "text.label.2",
            position: "absolute",
            transformOrigin: "top left",
            transform: "translate(0px, 10px) ",
            width: "auto",
            px: 10,
            color: disabled ? theme_colors/* colors.mediumGray */.O.mediumGray : theme_colors/* colors.text */.O.text,
            pointerEvents: "none"
        };
    };
    this.input = function(disabled) {
        return {
            variant: "text.lg",
            borderRadius: 50,
            borderColor: theme_colors/* colors.mediumGray */.O.mediumGray,
            width: "100%",
            px: 10,
            mt: 4,
            pb: 2,
            color: disabled ? theme_colors/* colors.mediumGray */.O.mediumGray : theme_colors/* colors.text */.O.text
        };
    };
}());

;// CONCATENATED MODULE: ./src/templates/account/Shared/InputField.jsx





var InputField = themed(function(_param) {
    var theme = _param.theme, label = _param.label, name = _param.name, type = _param.type, placeholder = _param.placeholder, required = _param.required, disabled = _param.disabled, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme",
        "label",
        "name",
        "type",
        "placeholder",
        "required",
        "disabled"
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
        sx: {
            width: "100%"
        },
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Label */.__, {
                className: "emailLabel",
                sx: theme.label(disabled),
                htmlFor: name,
                children: label
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Input */.II, (0,_object_spread/* default */.Z)({
                required: required,
                sx: theme.input(disabled),
                name: name,
                id: name,
                mb: 3,
                type: type,
                placeholder: placeholder,
                disabled: disabled
            }, props))
        ]
    });
});
InputField.displayName = "InputField";


/***/ }),

/***/ 6469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* reexport */ CollectionGrid; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(52050);
// EXTERNAL MODULE: ../node_modules/theme-ui/jsx-runtime/dist/theme-ui-jsx-runtime.esm.js + 2 modules
var theme_ui_jsx_runtime_esm = __webpack_require__(70863);
// EXTERNAL MODULE: ./src/snippets/index.js + 352 modules
var snippets = __webpack_require__(81234);
// EXTERNAL MODULE: ../node_modules/@theme-ui/components/dist/theme-ui-components.esm.js
var theme_ui_components_esm = __webpack_require__(62680);
// EXTERNAL MODULE: ../node_modules/@backpackjs/storefront/dist/index.js
var dist = __webpack_require__(52031);
// EXTERNAL MODULE: ../node_modules/next/dynamic.js
var dynamic = __webpack_require__(65218);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/templates/collection/Sort/Sort.theme.js
var Sort_theme = __webpack_require__(92283);
;// CONCATENATED MODULE: ./src/templates/collection/Sort/Sort.jsx




var SortDropdown = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 590).then(__webpack_require__.bind(__webpack_require__, 97590)).then(function(module) {
        return module.SortDropdown;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(97590)
            ];
        }
    },
    ssr: false,
    suspense: false
});
var Sort = (0,Sort_theme/* themed */.H)(function(param) {
    var theme = param.theme;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
        "data-comp": Sort.displayName,
        variant: "flex.row.end",
        sx: theme.wrapper,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(SortDropdown, {})
    });
});
Sort.displayName = "Sort";

;// CONCATENATED MODULE: ./src/templates/collection/Sort/index.js


// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(31373);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3204);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ./src/templates/collection/hooks/index.js + 4 modules
var hooks = __webpack_require__(54174);
// EXTERNAL MODULE: ./src/theme/create.jsx
var create = __webpack_require__(73355);
;// CONCATENATED MODULE: ./src/templates/collection/Pagination/Pagination.theme.js

var themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        variant: "flex.row.center",
        mt: [
            13,
            10
        ]
    };
    this.list = {
        pl: 0
    };
    this.arrowListItem = {
        display: "flex",
        alignItems: "center"
    };
    this.arrowButton = function(disabled) {
        return {
            cursor: disabled ? "default" : "pointer"
        };
    };
    this.arrowIcon = function(disabled) {
        return {
            width: "16px",
            transition: "all .2s ease-in-out",
            color: disabled ? "gray" : "text"
        };
    };
    this.listItem = {
        mr: 5
    };
    this.pageButton = function(isCurrentPage) {
        return {
            position: "relative",
            ":after": {
                content: '""',
                width: "100%",
                position: "absolute",
                height: "1px",
                left: 0,
                top: "100%",
                bg: "text",
                transition: "transform .2s ease-in-out",
                transform: isCurrentPage ? "scaleX(1)" : "scaleX(0)"
            }
        };
    };
}());

;// CONCATENATED MODULE: ./src/templates/collection/Pagination/Pagination.jsx











var Pagination = themed(function(_param) {
    var theme = _param.theme, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme"
    ]);
    var ref = (0,_sliced_to_array/* default */.Z)((0,hooks/* useCollectionPagination */.SJ)(), 2), ref1 = ref[0], currentPage = ref1.currentPage, totalPages = ref1.totalPages, ref2 = ref[1], goToPrevPage = ref2.goToPrevPage, goToNextPage = ref2.goToNextPage, goToPage = ref2.goToPage;
    var isFirstPage = currentPage === 1;
    var isLastPage = currentPage === totalPages;
    var visiblePages = (0,react.useMemo)(function() {
        var pages = [];
        for(var i = currentPage - 2; i <= currentPage + 2; i++){
            if (i > 0 && i <= totalPages) {
                pages.push(i);
            }
        }
        if (!pages.includes(1) && !isFirstPage) {
            pages = [
                1,
                "..."
            ].concat((0,_to_consumable_array/* default */.Z)(pages));
        }
        if (!pages.includes(totalPages) && !isLastPage) {
            pages = (0,_to_consumable_array/* default */.Z)(pages).concat([
                "...",
                totalPages
            ]);
        }
        return pages;
    }, [
        currentPage,
        totalPages
    ]);
    return totalPages > 1 ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-comp": Pagination.displayName
    }, props), {
        sx: (0,_object_spread/* default */.Z)({}, theme.wrapper, props.sx),
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
            as: "nav",
            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                as: "ul",
                variant: "flex.row.start.center",
                sx: theme.list,
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                        as: "li",
                        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.arrowListItem), {
                            mr: 5
                        }),
                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                            variant: "buttons.plain",
                            onClick: goToPrevPage,
                            disabled: isFirstPage,
                            "aria-label": "Go to previous page",
                            sx: theme.arrowButton(isFirstPage),
                            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Svg */.ny, {
                                alt: "chevron",
                                viewBox: "0 0 16 16",
                                src: "/svgs/chevron/left.svg#left",
                                sx: theme.arrowIcon(isFirstPage)
                            })
                        })
                    }),
                    visiblePages.map(function(i) {
                        var page = i;
                        if (page === "...") {
                            return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                                as: "li",
                                sx: theme.listItem,
                                children: "..."
                            }, page);
                        }
                        return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                            as: "li",
                            sx: theme.listItem,
                            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                                variant: "buttons.plain",
                                onClick: function() {
                                    return goToPage(page);
                                },
                                "aria-label": "Go to page ".concat(page),
                                sx: theme.pageButton(page === currentPage),
                                children: page
                            }, page)
                        }, page);
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                        as: "li",
                        sx: theme.arrowListItem,
                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                            variant: "buttons.plain",
                            onClick: goToNextPage,
                            disabled: isLastPage,
                            "aria-label": "Go to next page",
                            sx: theme.arrowButton(isLastPage),
                            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Svg */.ny, {
                                alt: "chevron",
                                viewBox: "0 0 16 16",
                                src: "/svgs/chevron/right.svg#right",
                                sx: theme.arrowIcon(isLastPage)
                            })
                        })
                    })
                ]
            })
        })
    })) : null;
});
Pagination.displayName = "Pagination";

;// CONCATENATED MODULE: ./src/templates/collection/Pagination/index.js


;// CONCATENATED MODULE: ./src/templates/collection/CollectionGrid/CollectionGrid.theme.js

var CollectionGrid_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        gridArea: "collection",
        pt: 0,
        pb: [
            14,
            18,
            "80px"
        ]
    };
    this.grid = {
        display: "grid",
        columnGap: [
            10,
            12
        ],
        rowGap: [
            14,
            12
        ]
    };
    this.noProducts = {
        variant: "flex.column",
        text: {
            variant: "text.lg",
            mt: 20,
            textAlign: "center"
        }
    };
    this.banner = {
        width: "100%",
        height: [
            "100%",
            "calc(100% - 60px)"
        ],
        "h2,h3,h4,h5,h6": {
            variant: "text.h4",
            mt: [
                10,
                11
            ],
            mb: 3
        },
        p: {
            mt: 0,
            variant: "text.lg"
        },
        "p:last-of-type": {
            mb: 0
        }
    };
    this.loaderWrapper = {
        variant: "flex.row.center.center",
        width: "100%",
        height: [
            "400px",
            "600px"
        ]
    };
    this.loader = {
        color: "mediumDarkGray"
    };
    this.filter = {
        content: {
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%"
        },
        title: {
            variant: "text.label.1"
        },
        icon: {
            transition: "transform 0.2s ease-in-out",
            width: "20px"
        }
    };
}());

// EXTERNAL MODULE: ./src/hooks/index.js + 64 modules
var src_hooks = __webpack_require__(74424);
;// CONCATENATED MODULE: ./src/templates/collection/Filters/Filter/Filter.theme.js

var Filter_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        minHeight: "34px",
        display: [
            "none",
            "flex"
        ],
        top: [
            "0",
            "var(--header-height)"
        ],
        position: "sticky",
        zIndex: 2,
        bg: "white",
        py: [
            0,
            "8px"
        ]
    };
    this.title = {
        variant: "text.label.1",
        display: "inline-block",
        fontWeight: 700
    };
    this.icon = {
        transition: "transform 0.2s ease-in-out",
        width: "20px"
    };
    this.button = {
        minWidth: "104px",
        display: [
            "none",
            "flex"
        ],
        alignItems: "center",
        textAlign: "left",
        position: "relative",
        borderStyle: "solid",
        borderColor: "#5d5d5d",
        borderWidth: "1px",
        bg: "background",
        py: 4,
        px: 8,
        columnGap: "20px",
        borderRadius: [
            0,
            "22px"
        ]
    };
}());

;// CONCATENATED MODULE: ./src/templates/collection/Filters/Filter/Filter.jsx







var Filter = Filter_theme_themed(function(param) {
    var theme = param.theme;
    var ref = (0,_sliced_to_array/* default */.Z)((0,src_hooks/* useFiltersSidebar */.JE)(), 2), toggleFiltersSidebar = ref[1].toggleFiltersSidebar;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": Filter.displayName,
        sx: theme.wrapper,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Button */.zx, {
            variant: "buttons.plain",
            onClick: function() {
                return toggleFiltersSidebar({
                    label: "Filter",
                    isFiltersAndSort: true
                });
            },
            sx: theme.button,
            children: [
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                    as: "h5",
                    sx: theme.title,
                    children: "Filter"
                }),
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Svg */.ny, {
                    alt: "filter",
                    viewBox: "0 0 16 16",
                    src: "/svgs/noprecache/svg/filters.svg",
                    width: 16,
                    height: 16,
                    sx: (0,_object_spread/* default */.Z)({}, theme.icon)
                })
            ]
        })
    });
});
Filter.displayName = "Filter";

;// CONCATENATED MODULE: ./src/templates/collection/Filters/Filter/index.js


// EXTERNAL MODULE: ./src/templates/collection/Filters/CurrentFilters.jsx + 1 modules
var CurrentFilters = __webpack_require__(4903);
;// CONCATENATED MODULE: ./src/templates/collection/CollectionGrid/CollectionGrid.jsx













var CollectionGrid = CollectionGrid_theme_themed(function(param) {
    var theme = param.theme, products = param.products, merchandising = param.merchandising, hasInitialProducts = param.hasInitialProducts, _gatedPage = param.gatedPage, gatedPage = _gatedPage === void 0 ? null : _gatedPage;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useCollectionSort */.$t)(), 1), sortOptions = ref7[0].sortOptions;
    var settings = (0,dist.useSettings)();
    var sortEnabled = settings === null || settings === void 0 ? void 0 : (ref = settings.collection) === null || ref === void 0 ? void 0 : ref.sortEnabled;
    var header = merchandising === null || merchandising === void 0 ? void 0 : (ref1 = merchandising.content) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.header) === null || ref2 === void 0 ? void 0 : ref2[0];
    var footer = merchandising === null || merchandising === void 0 ? void 0 : (ref3 = merchandising.content) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.footer) === null || ref4 === void 0 ? void 0 : ref4[0];
    var banner = merchandising === null || merchandising === void 0 ? void 0 : (ref5 = merchandising.content) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.banner) === null || ref6 === void 0 ? void 0 : ref6[0];
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Container */.W2, {
        "data-comp": CollectionGrid.displayName,
        sx: theme.wrapper,
        children: [
            (header || banner) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                sx: {
                    mb: 12,
                    display: [
                        "none",
                        "block"
                    ]
                },
                children: [
                    header,
                    banner
                ].map(function(item, index) {
                    return item ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                        dangerouslySetInnerHTML: {
                            __html: item
                        }
                    }, index) : null;
                })
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                sx: {
                    display: [
                        "none",
                        "flex"
                    ],
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 8
                },
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(CurrentFilters/* CurrentFilters */.c, {}),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                        sx: {
                            display: "flex",
                            justifyContent: "end",
                            columnGap: "16px"
                        },
                        children: [
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Filter, {}),
                            sortEnabled && sortOptions && (products === null || products === void 0 ? void 0 : products.length) > 0 && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Sort, {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                sx: {
                    position: "relative"
                },
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Container */.W2, {
                        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.grid), {
                            gridTemplateColumns: hasInitialProducts ? [
                                "repeat(2, 1fr)",
                                "repeat(3, 1fr)"
                            ] : [
                                "1fr"
                            ]
                        }),
                        children: hasInitialProducts ? products === null || products === void 0 ? void 0 : products.map(function(product, index) {
                            if (!product) return null;
                            return !product.isBanner ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* ProductItem */.Cd, {
                                product: product,
                                index: index
                            }, product.handle) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                                sx: theme.banner,
                                dangerouslySetInnerHTML: {
                                    __html: product.value.replaceAll("<img ", '<img loading="lazy"')
                                }
                            }, product.id);
                        }) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                            sx: theme.noProducts,
                            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                                role: "status",
                                sx: theme.noProducts.text,
                                children: "Sorry, there are no products in this collection."
                            })
                        })
                    }),
                    hasInitialProducts && !(products === null || products === void 0 ? void 0 : products.length) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                        sx: theme.loaderWrapper,
                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Spinner */.$j, {
                            sx: theme.loader
                        })
                    })
                ]
            }),
            !gatedPage && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Pagination, {}),
            footer && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                dangerouslySetInnerHTML: {
                    __html: footer
                },
                sx: {
                    mt: 12,
                    display: [
                        "none",
                        "block"
                    ]
                }
            })
        ]
    });
});
CollectionGrid.displayName = "CollectionGrid";

;// CONCATENATED MODULE: ./src/templates/collection/CollectionGrid/index.js



/***/ }),

/***/ 4903:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "c": function() { return /* binding */ CurrentFilters; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(31373);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(52050);
// EXTERNAL MODULE: ../node_modules/theme-ui/jsx-runtime/dist/theme-ui-jsx-runtime.esm.js + 2 modules
var theme_ui_jsx_runtime_esm = __webpack_require__(70863);
// EXTERNAL MODULE: ../node_modules/@theme-ui/components/dist/theme-ui-components.esm.js
var theme_ui_components_esm = __webpack_require__(62680);
// EXTERNAL MODULE: ./src/snippets/index.js + 352 modules
var snippets = __webpack_require__(81234);
// EXTERNAL MODULE: ./src/store/index.js + 12 modules
var store = __webpack_require__(27695);
// EXTERNAL MODULE: ./src/templates/collection/hooks/index.js + 4 modules
var hooks = __webpack_require__(54174);
// EXTERNAL MODULE: ./src/theme/create.jsx
var create = __webpack_require__(73355);
;// CONCATENATED MODULE: ./src/templates/collection/Filters/Filters.theme.js

var themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        mt: 6,
        px: [
            8,
            0
        ]
    };
    this.filtersRow = {
        flexWrap: "wrap",
        gap: 4
    };
    this.filter = {
        height: "32px",
        position: "relative",
        borderRadius: "16px",
        py: 2,
        pr: 6,
        pl: 4,
        columnGap: 4,
        overflow: "hidden",
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        maxWidth: "200px",
        backgroundColor: function(t) {
            return "".concat(t.colors.gray);
        },
        border: function(t) {
            return "1px solid ".concat(t.colors.black);
        },
        transition: "all 0.15s ease-in-out",
        ":hover": {
            borderColor: "text",
            '[data-comp="Close"]': {
                opacity: 1
            }
        }
    };
    this.close = {
        transition: "all 0.15s ease-in-out",
        color: "text",
        opacity: 1,
        width: "16px",
        mr: 1
    };
    this.filterValue = {
        textAlign: "left",
        fontSize: 3,
        flex: 1,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    };
    this.clearAll = {
        mt: 10
    };
}());

;// CONCATENATED MODULE: ./src/templates/collection/Filters/CurrentFilters.jsx










var CurrentFilters = themed(function(_param) {
    var theme = _param.theme, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme"
    ]);
    var ref = (0,_sliced_to_array/* default */.Z)((0,hooks/* useCollectionFilters */.PY)(), 2), ref1 = ref[0], filterSummary = ref1.filterSummary, totalResults = ref1.totalResults, ref2 = ref[1], removeFromSelectedFilters = ref2.removeFromSelectedFilters, clearSelectedFilters = ref2.clearSelectedFilters;
    var gatedPage = (0,store/* useRecoilValue */.sJ)(store/* default.gatedPage */.ZP.gatedPage);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": CurrentFilters.displayName,
        sx: (0,_object_spread/* default */.Z)({}, theme.wrapper, props.sx),
        children: [
            !gatedPage && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Paragraph */.nv, {
                sx: {
                    fontSize: "15px",
                    display: [
                        "none",
                        "block"
                    ],
                    my: 4
                },
                children: [
                    totalResults,
                    " Products"
                ]
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                sx: {
                    marginBottom: "18px"
                },
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.filtersRow), {
                            flex: 1
                        }),
                        children: filterSummary === null || filterSummary === void 0 ? void 0 : filterSummary.map(function(filter) {
                            return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Button */.zx, {
                                variant: "buttons.plain",
                                "aria-label": "Remove ".concat(filter.filterLabel, " ").concat(filter.filterValue, " from filters"),
                                onClick: function() {
                                    var value = filter.value;
                                    removeFromSelectedFilters({
                                        field: filter.field,
                                        option: typeof value === "object" ? {
                                            type: "range",
                                            low: value.rangeLow,
                                            high: value.rangeHigh
                                        } : {
                                            type: "value",
                                            value: value
                                        }
                                    });
                                },
                                sx: theme.filter,
                                children: [
                                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                                        sx: theme.filterValue,
                                        children: filter.filterValue
                                    }),
                                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Svg */.ny, {
                                        alt: "Close",
                                        src: "/svgs/close.svg#close",
                                        viewBox: "0 0 48 48",
                                        "data-comp": "Close",
                                        sx: theme.close
                                    })
                                ]
                            }, filter.field + filter.value);
                        })
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Paragraph */.nv, {
                        sx: {
                            fontSize: "11px",
                            display: [
                                "block",
                                "none"
                            ],
                            width: "auto",
                            lineHeight: "32px"
                        },
                        children: [
                            totalResults,
                            " Products"
                        ]
                    })
                ]
            }),
            (filterSummary === null || filterSummary === void 0 ? void 0 : filterSummary.length) > 0 && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                variant: "buttons.link.1",
                onClick: clearSelectedFilters,
                "aria-label": "Clear all filters",
                sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.clearAll), {
                    display: (filterSummary === null || filterSummary === void 0 ? void 0 : filterSummary.length) > 0 ? [
                        "none",
                        "block"
                    ] : "none"
                }),
                children: "Clear All"
            })
        ]
    });
});
CurrentFilters.displayName = "CurrentFilters";


/***/ }),

/***/ 92283:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ themed; }
/* harmony export */ });
/* harmony import */ var _theme_create__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73355);

var themed = (0,_theme_create__WEBPACK_IMPORTED_MODULE_0__/* .create */ .U)(new function() {
    this.wrapper = {
        minHeight: "34px",
        display: [
            "none",
            "flex"
        ],
        top: [
            "0",
            "var(--header-height)"
        ],
        position: "sticky",
        zIndex: 2,
        bg: "white",
        py: [
            0,
            "8px"
        ]
    };
    this.dropdown = {
        width: [
            "100%",
            "auto"
        ],
        "[data-comp=DropdownDrawer]": {
            borderColor: "gray"
        }
    };
    this.selected = {
        width: "100%",
        p: 8,
        borderStyle: "solid",
        borderColor: "#5d5d5d",
        bg: "background",
        transition: "all 0.2s ease-in-out",
        borderRadius: [
            0,
            "22px"
        ],
        content: {
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%"
        },
        title: {
            variant: "text.label.1"
        },
        icon: {
            transition: "transform 0.2s ease-in-out",
            width: "20px"
        }
    };
    this.option = {
        width: "100%",
        px: 8,
        title: {
            variant: "text.base",
            fontSize: 2,
            lineHeight: 20,
            width: "100%",
            ":hover": {
                fontWeight: 500
            }
        }
    };
}());


/***/ }),

/***/ 54174:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Kx": function() { return /* reexport */ useCollection; },
  "PY": function() { return /* reexport */ useCollectionFilters; },
  "SJ": function() { return /* reexport */ useCollectionPagination; },
  "$t": function() { return /* reexport */ useCollectionSort; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(23842);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(52050);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3204);
// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(59312);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/@backpackjs/storefront/dist/index.js
var dist = __webpack_require__(52031);
// EXTERNAL MODULE: ./src/hooks/index.js + 64 modules
var hooks = __webpack_require__(74424);
// EXTERNAL MODULE: ./src/store/index.js + 12 modules
var store = __webpack_require__(27695);
;// CONCATENATED MODULE: ./src/templates/collection/hooks/useCollectionSort.js






var useCollectionSort = function() {
    var ref, ref1, ref2;
    var collection = (0,store/* useRecoilValue */.sJ)(store/* default.collection */.ZP.collection);
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* default.selectedSort */.ZP.selectedSort), 2), selectedSort = ref3[0], setSelectedSort = ref3[1];
    // const setFiltersSidebar = useSetRecoilState(store.filtersSidebar);
    var sortCollection = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var field, direction;
            return (0,tslib_es6.__generator)(this, function(_state) {
                field = param.field, direction = param.direction;
                if (!field || !direction) {
                    // clear sort
                    setSelectedSort({
                        field: "best_match",
                        direction: "desc"
                    });
                    return [
                        2
                    ];
                }
                // Examples
                // { field: 'ss_price', direction: 'asc' },
                // { field: 'title', direction: 'desc' }
                // { field: 'ss_days_since_published', direction: 'asc' }
                setSelectedSort({
                    field: field,
                    direction: direction
                });
                return [
                    2
                ];
            });
        // setFiltersSidebar(null);
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    return [
        // state
        {
            selectedSort: selectedSort,
            sortOptions: (collection === null || collection === void 0 ? void 0 : (ref = collection.sorting) === null || ref === void 0 ? void 0 : (ref1 = ref.options) === null || ref1 === void 0 ? void 0 : ref1.length) ? [
                {
                    field: "best_match",
                    direction: "desc",
                    label: "Best Match"
                }, 
            ].concat((0,_to_consumable_array/* default */.Z)((collection === null || collection === void 0 ? void 0 : (ref2 = collection.sorting) === null || ref2 === void 0 ? void 0 : ref2.options) || [])) : null
        },
        // actions
        {
            sortCollection: sortCollection
        }, 
    ];
};

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(17599);
;// CONCATENATED MODULE: ./src/templates/collection/hooks/useCollectionFilters.js





var useCollectionFilters = function() {
    var ref, ref1, ref2, ref3;
    var collection = (0,store/* useRecoilValue */.sJ)(store/* default.collection */.ZP.collection);
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* default.selectedFilters */.ZP.selectedFilters), 2), selectedFilters = ref4[0], setSelectedFilters = ref4[1];
    var setCurrentResultsPage = (0,store/* useSetRecoilState */.Zl)(store/* default.currentResultsPage */.ZP.currentResultsPage);
    var selectedFiltersDep = JSON.stringify(selectedFilters);
    var totalResults = (collection === null || collection === void 0 ? void 0 : (ref = collection.pagination) === null || ref === void 0 ? void 0 : ref.totalResults) || 0;
    var filters = (0,react.useMemo)(function() {
        var ref;
        if (!totalResults || !(collection === null || collection === void 0 ? void 0 : (ref = collection.facets) === null || ref === void 0 ? void 0 : ref.length)) return null;
        return collection.facets.filter(function(facet) {
            if (facet.values.length === 1 && facet.values[0].count === totalResults) {
                return false;
            }
            return true;
        });
    }, [
        collection === null || collection === void 0 ? void 0 : collection.facets,
        totalResults
    ]);
    // get filter entries based on type
    var getFilterEntries = (0,react.useCallback)(function(param) {
        var field = param.field, option = param.option;
        var _filters = {};
        // if option type is range, separate into low and high entries
        if (option.type === "range") {
            var ref = [
                "filter.".concat(field, ".low"),
                option.low
            ], key1 = ref[0], value1 = ref[1];
            var ref1 = [
                "filter.".concat(field, ".high"),
                option.high
            ], key2 = ref1[0], value2 = ref1[1];
            var _obj;
            _filters = (_obj = {}, (0,_define_property/* default */.Z)(_obj, "".concat(key1, ".").concat(value1), {
                key: key1,
                value: value1
            }), (0,_define_property/* default */.Z)(_obj, "".concat(key2, ".").concat(value2), {
                key: key2,
                value: value2
            }), _obj);
        } else {
            var ref2 = [
                "filter.".concat(field),
                option.value || ""
            ], key = ref2[0], value = ref2[1];
            _filters = (0,_define_property/* default */.Z)({}, "".concat(key, ".").concat(value), {
                key: key,
                value: value
            });
        }
        return _filters;
    }, []);
    // add to filters using filterOptions
    var addToSelectedFilters = (0,react.useCallback)(function(param) {
        var field = param.field, option = param.option;
        if (!field || !option) {
            return console.error("addToSelectedFilters: missing field or option");
        }
        // Example ss field: 'product_type'
        // Example ss option: { active: false, type: 'value', value: 'Shirts' ... }
        // create map of previous selected filters
        var selectedFiltersMap = selectedFilters === null || selectedFilters === void 0 ? void 0 : selectedFilters.reduce(function(obj, filter) {
            obj["".concat(filter.key, ".").concat(filter.value)] = filter;
            return obj;
        }, {});
        // prevent duplicates by spreading previous and new filters into new map
        var newSelectedFiltersMap = (0,_object_spread/* default */.Z)({}, selectedFiltersMap, getFilterEntries({
            field: field,
            option: option
        }));
        // convert filters map back into array
        var newSelectedFilters = Object.values(newSelectedFiltersMap);
        setSelectedFilters(newSelectedFilters);
        setCurrentResultsPage(1);
    }, [
        selectedFiltersDep
    ]);
    // remove from selected filters
    var removeFromSelectedFilters = (0,react.useCallback)(function(param) {
        var field = param.field, option = param.option;
        if (!field || !option) {
            return console.error("removeFromSelectedFilters: missing field or option");
        }
        // Example ss field / option: 'collection_name', { value: 'Shirts', type: 'value }
        // Example ss field / option w/ range: 'ss_price', { high: '80', low: '60', type: 'range }
        if (!(selectedFilters === null || selectedFilters === void 0 ? void 0 : selectedFilters.length)) return;
        // filter out filters that match the field and option
        var newSelectedFilters = selectedFilters.filter(function(filter) {
            if (option.type === "range") {
                var isEntryLow = filter.key === "filter.".concat(field, ".low") && filter.value === option.low;
                var isEntryHigh = filter.key === "filter.".concat(field, ".high") && filter.value === option.high;
                return !isEntryLow && !isEntryHigh;
            }
            var isEntry = filter.key === "filter.".concat(field) && filter.value === option.value;
            return !isEntry;
        });
        setSelectedFilters(newSelectedFilters);
        setCurrentResultsPage(1);
    }, [
        selectedFiltersDep
    ]);
    // clear filters
    var clearSelectedFilters = (0,react.useCallback)(function() {
        setSelectedFilters(null);
        setCurrentResultsPage(1);
    }, []);
    return [
        // state
        {
            selectedFilters: selectedFilters,
            filters: filters,
            filterSummary: (collection === null || collection === void 0 ? void 0 : collection.filterSummary) || null,
            totalResults: totalResults - ((collection === null || collection === void 0 ? void 0 : (ref1 = collection.merchandising) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.content) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.inline) === null || ref3 === void 0 ? void 0 : ref3.length) || 0)
        },
        // actions
        {
            addToSelectedFilters: addToSelectedFilters,
            removeFromSelectedFilters: removeFromSelectedFilters,
            clearSelectedFilters: clearSelectedFilters
        }, 
    ];
};

;// CONCATENATED MODULE: ./src/templates/collection/hooks/useCollection.js












var useCollection = function() {
    var ref;
    var router = (0,dist.useRouter)();
    var requestSearchspring = (0,hooks/* useSearchspring */.JN)().requestSearchspring;
    var ref1 = (0,_sliced_to_array/* default */.Z)(useCollectionSort(), 2), selectedSort = ref1[0].selectedSort, sortCollection = ref1[1].sortCollection;
    var ref2 = (0,_sliced_to_array/* default */.Z)(useCollectionFilters(), 1), selectedFilters = ref2[0].selectedFilters;
    var resultsPerPage = (0,store/* useRecoilValue */.sJ)(store/* default.selectedResultsPerPage */.ZP.selectedResultsPerPage);
    var currentPage = (0,store/* useRecoilValue */.sJ)(store/* default.currentResultsPage */.ZP.currentResultsPage);
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* default.collection */.ZP.collection), 2), collection = ref3[0], setCollection = ref3[1];
    var collectionHandle = router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.handle;
    var asPath = router.asPath;
    var deps = [
        collectionHandle,
        selectedSort === null || selectedSort === void 0 ? void 0 : selectedSort.field,
        selectedSort === null || selectedSort === void 0 ? void 0 : selectedSort.direction,
        JSON.stringify(selectedFilters),
        resultsPerPage,
        currentPage,
        asPath, 
    ];
    // Get collection from ss
    var getCollection = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var ref, ref1, data, _data, banners, results, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        requestSearchspring({
                            action: "getCollection",
                            params: {
                                collectionHandle: collectionHandle,
                                sort: selectedSort,
                                filters: selectedFilters,
                                page: currentPage,
                                resultsPerPage: resultsPerPage,
                                domain: "".concat("https://www.brumate.com", "/").concat(asPath === null || asPath === void 0 ? void 0 : asPath.split("?")[0])
                            }
                        })
                    ];
                case 1:
                    data = _state.sent();
                    _data = data;
                    banners = data === null || data === void 0 ? void 0 : (ref = data.merchandising) === null || ref === void 0 ? void 0 : (ref1 = ref.content) === null || ref1 === void 0 ? void 0 : ref1.inline;
                    if (banners === null || banners === void 0 ? void 0 : banners.length) {
                        results = banners.reduce(function(arr, item, index) {
                            var ref, ref1;
                            var pos = item.config.position.index;
                            if (pos >= (currentPage - 1) * (_data === null || _data === void 0 ? void 0 : (ref = _data.pagination) === null || ref === void 0 ? void 0 : ref.perPage) && pos < currentPage * (_data === null || _data === void 0 ? void 0 : (ref1 = _data.pagination) === null || ref1 === void 0 ? void 0 : ref1.perPage)) {
                                var ref2;
                                var banner = {
                                    isBanner: true,
                                    value: item.value,
                                    id: "banner-index-".concat(index)
                                };
                                arr.splice(pos - (currentPage - 1) * (_data === null || _data === void 0 ? void 0 : (ref2 = _data.pagination) === null || ref2 === void 0 ? void 0 : ref2.perPage), 0, banner);
                            }
                            return arr;
                        }, (0,_to_consumable_array/* default */.Z)(_data.results));
                        _data = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, _data), {
                            results: results
                        });
                    }
                    setCollection(_data || null);
                    return [
                        3,
                        3
                    ];
                case 2:
                    error = _state.sent();
                    console.error("Error with getCollection: ".concat(error.message));
                    throw error;
                case 3:
                    return [
                        2
                    ];
            }
        });
    }), (0,_to_consumable_array/* default */.Z)(deps));
    (0,react.useEffect)(function() {
        getCollection();
    }, (0,_to_consumable_array/* default */.Z)(deps));
    (0,react.useEffect)(function() {
        return function() {
            return setCollection(null);
        };
    }, []);
    return {
        products: (collection === null || collection === void 0 ? void 0 : collection.results) || null,
        merchandising: (collection === null || collection === void 0 ? void 0 : collection.merchandising) || null
    };
}; // Example data from api
 // {
 //   "pagination": {
 //       "totalResults": 5,
 //       "begin": 1,
 //       "end": 5,
 //       "currentPage": 1,
 //       "totalPages": 1,
 //       "previousPage": 0,
 //       "nextPage": 0,
 //       "perPage": 40,
 //       "defaultPerPage": 40
 //   },
 //   "sorting": {
 //       "options": [
 //           {
 //               "field": "ss_days_since_published",
 //               "direction": "asc",
 //               "label": "Newest"
 //           },
 //           {
 //               "field": "title",
 //               "direction": "asc",
 //               "label": "Name: A - Z"
 //           },
 //           {
 //               "field": "title",
 //               "direction": "desc",
 //               "label": "Name: Z - A"
 //           },
 //           {
 //               "field": "ss_price",
 //               "direction": "asc",
 //               "label": "Price: Low to High"
 //           },
 //           {
 //               "field": "ss_price",
 //               "direction": "desc",
 //               "label": "Price: High to Low"
 //           }
 //       ]
 //   },
 //   "resultLayout": "grid",
 //   "results": [
 //       {
 //           "brand": "CUTS CLOTHING",
 //           "handle": "black-mojave-short",
 //           "id": "2e912d3c4c4d49e687c13d813b501dae",
 //           "imageUrl": "https://cdn.shopify.com/s/files/1/1368/3463/products/BLACK-FESTIVAL-SHORT_720x.jpg?v=1648146050",
 //           "intellisuggestData": "eJwyNzIpLK5isPQrzw719fE3DjFJDPWtSA2y8M0LZGDwdTI0MDQz99M1MDDUjQhmMGQwZDBgMGVIL8pMAQQAAP__17AOsg",
 //           "intellisuggestSignature": "d9afe41bf21cb76b44aaf1e6561fab57bc8dac6813c6142be307c5bd9566c86a",
 //           "msrp": "0",
 //           "name": "Mojave Short | Black",
 //           "price": "74",
 //           "product_type_unigram": "black",
 //           "sku": "MB10167N-001-XS",
 //           "ss_available": "1",
 //           "ss_has_image": "1",
 //           "ss_id": "3.9872671973464e+13",
 //           "ss_instock_pct": "50",
 //           "ss_inventory_count": "210",
 //           "ss_is_published": "1",
 //           "thumbnailImageUrl": "https://cdn.shopify.com/s/files/1/1368/3463/products/BLACK-FESTIVAL-SHORT_720x.jpg?v=1648146050",
 //           "uid": "6918117458008",
 //           "url": "https://www.cutsclothing.com/products/black-mojave-short"
 //       },
 //       {
 //           "brand": "CUTS CLOTHING",
 //           "handle": "river-hyperloop-sunday-sweatpant",
 //           "id": "7e74fc3fbc925baa0755fd46e874f0f7",
 //           "imageUrl": "https://cdn.shopify.com/s/files/1/1368/3463/products/RIVER-HYPERLOOP-JOGGER-2.0_720x.jpg?v=1647284510",
 //           "intellisuggestData": "eJwyNzIpLK5isPQrzw719fE3DjFJDPWtSA2y8M0LZGDwdTI0MDQy9NE1MTbSjQhmMGQwYjBgMGVIL8pMAQQAAP__10MOrw",
 //           "intellisuggestSignature": "2bc76ecf1d129d42c328a19fdc61852929e627acb582b073e0ea5a712d7f844b",
 //           "msrp": "0",
 //           "name": "Sunday Sweatpant 2.0 | River Slim-fit Hyperloop",
 //           "price": "98",
 //           "product_type_unigram": "hyperloop",
 //           "sku": "MB10121L-432-XS",
 //           "ss_available": "1",
 //           "ss_has_image": "1",
 //           "ss_id": "3.9844233052248e+13",
 //           "ss_instock_pct": "83",
 //           "ss_inventory_count": "86",
 //           "ss_is_published": "1",
 //           "thumbnailImageUrl": "https://cdn.shopify.com/s/files/1/1368/3463/products/RIVER-HYPERLOOP-JOGGER-2.0_720x.jpg?v=1647284510",
 //           "uid": "6922038050904",
 //           "url": "https://www.cutsclothing.com/products/river-hyperloop-sunday-sweatpant"
 //       },
 //       ...
 //   ],
 //   "facets": [
 //       {
 //           "field": "collection_name",
 //           "label": "Collection",
 //           "type": null,
 //           "multiple": "",
 //           "collapse": 0,
 //           "facet_active": 0,
 //           "values": [
 //               {
 //                   "active": false,
 //                   "type": "value",
 //                   "value": "ALL BOTTOMS",
 //                   "label": "ALL BOTTOMS",
 //                   "count": 5
 //               },
 //               {
 //                   "active": false,
 //                   "type": "value",
 //                   "value": "ALL PRODUCTS",
 //                   "label": "ALL PRODUCTS",
 //                   "count": 5
 //               },
 //               {
 //                   "active": false,
 //                   "type": "value",
 //                   "value": "L",
 //                   "label": "L",
 //                   "count": 5
 //               },
 //               {
 //                   "active": false,
 //                   "type": "value",
 //                   "value": "M",
 //                   "label": "M",
 //                   "count": 5
 //               },
 //               {
 //                   "active": false,
 //                   "type": "value",
 //                   "value": "Low Inventory",
 //                   "label": "Low Inventory",
 //                   "count": 3
 //               },
 //               ...
 //           ]
 //       },
 //       {
 //           "field": "product_type",
 //           "label": "Product Type",
 //           "type": null,
 //           "collapse": 0,
 //           "facet_active": 0,
 //           "values": [
 //               {
 //                   "active": false,
 //                   "type": "value",
 //                   "value": "Bottoms",
 //                   "label": "Bottoms",
 //                   "count": 5
 //               }
 //           ]
 //       },
 //       {
 //           "field": "ss_price",
 //           "label": "Price",
 //           "type": "list",
 //           "collapse": 0,
 //           "facet_active": 0,
 //           "values": [
 //               {
 //                   "active": false,
 //                   "type": "range",
 //                   "low": "60",
 //                   "high": "80",
 //                   "label": "$60 to $80",
 //                   "count": 1
 //               },
 //               {
 //                   "active": false,
 //                   "type": "range",
 //                   "low": "80",
 //                   "high": "100",
 //                   "label": "$80 to $100",
 //                   "count": 3
 //               },
 //               {
 //                   "active": false,
 //                   "type": "range",
 //                   "low": "100",
 //                   "high": "150",
 //                   "label": "$100 to $150",
 //                   "count": 1
 //               }
 //           ]
 //       }
 //   ],
 //   "breadcrumbs": [
 //       {
 //           "field": "collection_handle",
 //           "label": "collection_handle: all-bottoms",
 //           "filterLabel": "collection_handle",
 //           "filterValue": "all-bottoms",
 //           "removeFilters": [],
 //           "removeRefineQuery": []
 //       }
 //   ],
 //   "filterSummary": [],
 //   "merchandising": {
 //       "redirect": "",
 //       "is_elevated": [],
 //       "elevated": [],
 //       "removed": [],
 //       "content": {},
 //       "facets": [],
 //       "facetsHide": [],
 //       "experiments": [],
 //       "variants": [],
 //       "personalized": false,
 //       "triggeredCampaigns": null
 //   }
 // }

;// CONCATENATED MODULE: ./src/templates/collection/hooks/useCollectionPagination.js



var useCollectionPagination = function() {
    var collection = (0,store/* useRecoilValue */.sJ)(store/* default.collection */.ZP.collection);
    var ref = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* default.selectedResultsPerPage */.ZP.selectedResultsPerPage), 2), selectedResultsPerPage = ref[0], setSelectedResultsPerPage = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* default.currentResultsPage */.ZP.currentResultsPage), 2), currentResultsPage = ref1[0], setCurrentResultsPage = ref1[1];
    var ref2 = (collection === null || collection === void 0 ? void 0 : collection.pagination) || {}, previousPage = ref2.previousPage, nextPage = ref2.nextPage, totalPages = ref2.totalPages;
    var updateResultsPerPage = (0,react.useCallback)(function(num) {
        if (!num) {
            return console.error("updateResultsPerPage: an integer from 1-100 must be passed");
        }
        setSelectedResultsPerPage(num);
        return true;
    }, []);
    var goToPrevPage = (0,react.useCallback)(function() {
        if (!previousPage) return;
        setCurrentResultsPage(previousPage);
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }, [
        previousPage
    ]);
    var goToNextPage = (0,react.useCallback)(function() {
        if (!nextPage) return;
        setCurrentResultsPage(nextPage);
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }, [
        nextPage
    ]);
    var goToPage = (0,react.useCallback)(function(num) {
        if (!num || num > totalPages) return;
        setCurrentResultsPage(num);
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }, [
        totalPages
    ]);
    (0,react.useEffect)(function() {
        goToPage(1);
    }, []);
    return [
        // state
        {
            resultsPerPage: selectedResultsPerPage,
            currentPage: currentResultsPage,
            totalPages: totalPages || 1
        },
        // actions
        {
            updateResultsPerPage: updateResultsPerPage,
            goToPrevPage: goToPrevPage,
            goToNextPage: goToNextPage,
            goToPage: goToPage
        }, 
    ];
};

;// CONCATENATED MODULE: ./src/templates/collection/hooks/index.js






/***/ }),

/***/ 13542:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* reexport */ Personalize; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(52050);
// EXTERNAL MODULE: ../node_modules/theme-ui/jsx-runtime/dist/theme-ui-jsx-runtime.esm.js + 2 modules
var theme_ui_jsx_runtime_esm = __webpack_require__(70863);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/@theme-ui/components/dist/theme-ui-components.esm.js
var theme_ui_components_esm = __webpack_require__(62680);
// EXTERNAL MODULE: ./src/snippets/index.js + 352 modules
var snippets = __webpack_require__(81234);
// EXTERNAL MODULE: ../node_modules/@backpackjs/storefront/dist/index.js
var dist = __webpack_require__(52031);
// EXTERNAL MODULE: ./src/hooks/index.js + 64 modules
var hooks = __webpack_require__(74424);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(23842);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3204);
// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(59312);
// EXTERNAL MODULE: ../node_modules/next/head.js
var head = __webpack_require__(88038);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/theme/create.jsx
var create = __webpack_require__(73355);
;// CONCATENATED MODULE: ./src/templates/product/Main/Details/Personalize/Personalize.theme.js

var themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        width: "100%",
        mt: [
            0,
            "-12px"
        ]
    };
    this.button = {
        width: "100%",
        height: "58px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        borderBottom: function(t) {
            return "1px solid ".concat(t.colors.gray);
        }
    };
    this.text = {
        variant: "text.label.1"
    };
    this.icon = {
        color: "text",
        width: "20px",
        ml: 2
    };
    this.modal = {
        minHeight: "400px",
        height: "75vh",
        maxHeight: "1000px",
        width: [
            "100%",
            "85vw"
        ],
        maxWidth: "1280px",
        overflowY: "auto",
        // wrapper
        "#jtbcustomizer .jtbc-wrapper": {
            display: "flex",
            flexDirection: [
                "column",
                "row"
            ]
        },
        "#jtbcustomizer .jtbc-menu-wrapper .jtbc-menu-container": {
            background: "white"
        },
        "#jtbcustomizer .jtbc-info-wrapper__mobile": {
            textAlign: "center",
            padding: "15px"
        },
        "#jtbcustomizer .jtbc-menu-element": {
            marginBottom: "0px !important"
        },
        "#jtbcustomizer .jtbc-menu-element.approval_check": {
            marginTop: [
                "14px!important",
                "20px!important"
            ]
        },
        // all text
        "*": {
            fontFamily: '"Fellix", system-ui, -apple-system, BlinkMacSystemFont, sans-serif !important'
        },
        // heading
        "#jtbcustomizer .jtbc-info-wrapper .jtbc-product-title": {
            variant: "text.h2",
            fontFamily: "Reckless Neue !important",
            textTransform: "capitalize !important"
        },
        // price
        "#jtbcustomizer .jtbc-info-wrapper .jtbc-product-price-container .jtbc-product-charge-description": {
            variant: "text.base"
        },
        // disclaimer
        "#jtbcustomizer .jtbc-disclaimer": {
            variant: "text.base",
            fontSize: [
                3,
                4
            ]
        },
        ".jtbc-hint": {
            mt: "8px !important"
        },
        /// menu panel
        "#jtbcustomizer .jtbc-menu-panel": {
            marginTop: "0 !important",
            paddingTop: "0 !important",
            width: "unset !important",
            flex: "1 !important"
        },
        // menu wrapper
        '#jtbcustomizer .jtbc-menu-wrapper .jtbc-menu-container[data-component-mode="accordion"] .jtbc-menu-tab-pane.jtbc-menu-tab-pane--active[aria-hidden="false"]': {
            paddingTop: 0
        },
        // Choose type heading
        "#jtbcustomizer .jtbc-decision-selector .jtbc-menu-element__label": {
            variant: "text.label.1",
            color: "#222222",
            mb: "4px"
        },
        // Choose type radio buttons
        "#jtbcustomizer .jtbc-radio-buttons-group .jtbc-radio-button label": {
            textTransform: "capitalize !important"
        },
        "#jtbcustomizer .jtbc-radio-buttons-group .jtbc-radio-button label .jtbc-radio-button__checkmark": {
            border: function(t) {
                return "1px solid ".concat(t.colors.gray);
            },
            borderRadius: "44px",
            transition: "all 0.15s ease-in-out"
        },
        // radio button hover
        "#jtbcustomizer .jtbc-radio-buttons-group .jtbc-radio-button label input[type=radio]:hover ~ .jtbc-radio-button__checkmark": {
            border: function(t) {
                return "1px solid ".concat(t.colors.mediumDarkGray);
            }
        },
        // radio button selected
        "#jtbcustomizer .jtbc-radio-buttons-group .jtbc-radio-button label input[type=radio]:checked ~ .jtbc-radio-button__checkmark": {
            border: function(t) {
                return "1px solid ".concat(t.colors.text);
            }
        },
        // initials / icon label
        "#jtbcustomizer .jtbc-menu-element .jtbc-menu-element__label": {
            variant: "text.label.1",
            color: "#222222",
            position: "relative"
        },
        // initials sub label
        "#jtbcustomizer .jtbc-input-text label": {
            position: "relative",
            top: "26px",
            left: "20px",
            zIndex: 9998,
            color: "#222222",
            width: "80%"
        },
        // initials input
        ".jtbc-input-text": {
            width: "100%",
            display: "block",
            mb: "0px !important"
        },
        "#jtbcustomizer .jtbc-input-text input": {
            borderRadius: "50px",
            width: "98%",
            height: "44px",
            pl: "20px",
            pt: "18px",
            fontSize: "15px",
            color: "#222222"
        },
        "#jtbcustomizer .jtbc-input-text__input": {
            border: "1px solid #C6C6C7",
            transition: "all 0.15s ease-in-out"
        },
        "#jtbcustomizer .jtbc-input-text__input:hover": {
            border: "1px solid #8C8C8D"
        },
        "#jtbcustomizer .jtbc-input-text__input:focus": {
            border: "1px solid #222222"
        },
        // ?
        "#jtbcustomizer .jtbc-menu-element-optgroup-selection": {
            mb: 0
        },
        // dropdown mobile
        "#jtbcustomizer .jtbc-select-box .jtbc-selectbox-hide-select.jtbc-selectbox-is-native": {
            border: "none !important"
        },
        // dropdown sub label
        "#jtbcustomizer .jtbc-menu-element__sub_label": {
            position: "relative",
            top: "26px",
            left: "20px",
            zIndex: 9998,
            color: "#222222",
            width: "80%"
        },
        // dropdown
        "#jtbcustomizer .jtbc-select-box": {
            width: "100%"
        },
        "#jtbcustomizer .jtbc-select-box .jtbc-selectbox": {
            borderRadius: "60px",
            border: "1px solid #C6C6C7",
            mb: "16px",
            mt: 0,
            width: "98%",
            height: "44px",
            transition: "all 0.15s ease-in-out",
            pl: "20px",
            pt: "14px",
            pb: "16px"
        },
        "#jtbcustomizer .jtbc-select-box .jtbc-selectbox .label": {
            ml: "0px",
            mt: "0px",
            fontSize: "15px",
            color: "#222222"
        },
        // dropdown hover
        "#jtbcustomizer .jtbc-select-box .jtbc-selectbox-hover .jtbc-selectbox": {
            border: "1px solid #8C8C8D"
        },
        // dropdown open
        "#jtbcustomizer .jtbc-select-box .jtbc-selectbox-open": {
            zIndex: 9995
        },
        "#jtbcustomizer .jtbc-select-box .jtbc-selectbox-open .jtbc-selectbox": {
            border: "1px solid #222222",
            zIndex: 9995
        },
        // dropdown drawer
        "#jtbcustomizer .jtbc-select-box .jtbc-selectbox-open .jtbc-selectbox-items": {
            mt: "8px",
            border: "1px solid #E8E8E8"
        },
        // dropdown drawer hover
        "#jtbcustomizer .jtbc-select-box .jtbc-selectbox-items li": {
            fontSize: "15px",
            color: "#222222"
        },
        // dropdown drawer hover
        "#jtbcustomizer .jtbc-select-box .jtbc-selectbox-items li:hover": {
            border: "1px solid #8C8C8D",
            backgroundColor: "transparent",
            color: "#222222"
        },
        // dropdown drawer selected
        "#jtbcustomizer .jtbc-select-box .jtbc-selectbox-items li.selected": {
            border: "1px solid #222222",
            backgroundColor: "transparent",
            color: "#222222"
        },
        // icon squares
        "#jtbcustomizer .jtbc-attribute-selector .jtbc-attribute-item": {
            border: function(t) {
                return "1px solid ".concat(t.colors.gray);
            }
        },
        // icon squares hover
        "#jtbcustomizer .jtbc-attribute-selector .jtbc-attribute-item.jtbc-attribute-item__square:hover": {
            border: function(t) {
                return "1px solid ".concat(t.colors.mediumDarkGray);
            },
            transform: "scale(1)"
        },
        // icon squares selected
        "#jtbcustomizer .jtbc-attribute-selector .jtbc-attribute-item.jtbc--selected": {
            boxShadow: "none",
            border: function(t) {
                return "1px solid ".concat(t.colors.text);
            }
        },
        // prev/next buttons wrapper
        "#jtbcustomizer .jtbc-pagination-wrapper": {
            justifyContent: "center",
            mt: "5px",
            mr: "10px"
        },
        // prev/next buttons
        "#jtbcustomizer .jtbc-pagination-wrapper .jtbc-pagination-button": {
            border: "1px solid #E8E8E8",
            borderRadius: "50%",
            color: "#222222",
            fontWeight: "800",
            transition: "all 0.15s ease-in-out",
            fontSize: "20px"
        },
        // prev/next buttons hover
        "#jtbcustomizer .jtbc-pagination-wrapper .jtbc-pagination-button:hover": {
            border: "1px solid #8C8C8D",
            backgroundColor: "transparent"
        },
        // prev/next buttons disabled
        "#jtbcustomizer .jtbc-pagination-wrapper .jtbc-pagination-button.jtbc-pagination-button__disabled": {
            color: "#C6C6C7",
            border: "1px solid #E8E8E8"
        },
        // prev button
        "#jtbcustomizer .jtbc-pagination-wrapper .jtbc-pagination-button.jtbc-pagination-button__prev": {
            mr: "8px",
            pr: "2px",
            pb: "1px"
        },
        "#jtbcustomizer .jtbc-pagination-wrapper .jtbc-pagination-button.jtbc-pagination-button__next": {
            pl: "2px",
            pb: "1px"
        },
        // qty wrapper
        "#jtbcustomizer .jtbc-actions .jtbc-quantity": {
            border: "none",
            justifyContent: "flex-start",
            mr: "24px",
            pl: "16px",
            minWidth: "110px"
        },
        // qty buttons outer
        "#jtbcustomizer .jtbc-actions .jtbc-quantity .jtbc-quantity-spinner": {
            borderRadius: "50%",
            width: "32px",
            height: "32px",
            transition: "all 0.15s ease-in-out",
            lineHeight: "26px"
        },
        // qty buttons inner
        "#jtbcustomizer .jtbc-button__symbol": {
            border: "1px solid #E8E8E8",
            borderRadius: "50%",
            width: "32px",
            height: "32px",
            transition: "all 0.15s ease-in-out",
            fontSize: "24px"
        },
        // qty buttons outer before
        "#jtbcustomizer .jtbc-actions .jtbc-quantity .jtbc-quantity-spinner:before": {
            height: "0px",
            width: "0px"
        },
        // qty buttons inner before
        "#jtbcustomizer .jtbc-button__symbol:before": {
            height: "0px",
            width: "0px"
        },
        // qty buttons outer after
        "#jtbcustomizer .jtbc-actions .jtbc-quantity .jtbc-quantity-spinner:after": {
            height: "0px",
            width: "0px"
        },
        // qty buttons inner after
        "#jtbcustomizer .jtbc-button__symbol:after": {
            height: "0px",
            width: "0px"
        },
        // qty buttons outer hover
        "#jtbcustomizer .jtbc-actions .jtbc-quantity .jtbc-quantity-spinner:hover": {
            backgroundColor: "transparent"
        },
        // qty buttons inner hover
        "#jtbcustomizer .jtbc-button__symbol:hover": {
            border: "1px solid #8C8C8D"
        },
        // ATC
        "#jtbcustomizer .jtbc-actions .jtbc-cart-button": {
            borderRadius: "22px",
            pt: "12px",
            transition: "all 0.2s ease-in-out",
            height: "42px",
            alignSelf: "center",
            width: "100%",
            mr: "28px",
            fontSize: "0px !important",
            fontWeight: 500,
            textTransform: "none !important"
        },
        "#jtbcustomizer .jtbc-actions .jtbc-cart-button:after": {
            fontFamily: '"Fellix", system-ui, -apple-system, BlinkMacSystemFont, sans-serif !important',
            fontSize: "15px !important",
            content: '"Add to Bag"',
            color: "white",
            bg: "transparent",
            position: "relative",
            top: "0px",
            left: "0px"
        },
        // ATC hover
        "#jtbcustomizer .jtbc-actions .jtbc-cart-button:hover": {
            bg: "darkGray",
            color: "white"
        },
        // ATC before
        "#jtbcustomizer .jtbc-button:before": {
            height: "0px",
            width: "0px",
            color: "black"
        },
        // ATC after
        "#jtbcustomizer .jtbc-button:after": {
            height: "0px",
            width: "0px",
            color: "black"
        },
        // secondary actions panel
        "#jtbcustomizer .jtbc-actions.jtbc-actions__secondary.jtbc-actions__secondary__mobile": {
            display: "flex",
            justifyContent: "flex-start",
            pl: "16px",
            pr: "28px"
        },
        "#jtbcustomizer .jtbc-actions.jtbc-actions__secondary": {
            width: "100%"
        },
        "#jtbcustomizer .jtbc-actions.jtbc-actions__secondary .jtbc-actions-left, #jtbcustomizer .jtbc-actions.jtbc-actions__secondary .jtbc-actions-right": {
            mb: "24px"
        },
        "#jtbcustomizer .jtbc-actions.jtbc-actions__secondary .jtbc-actions-left": {
            width: "calc(100% - 46px)",
            justifyContent: "space-between"
        },
        // snapshots button
        "#jtbcustomizer .jtbc-button": {
            variant: "text.link",
            border: "none !important",
            backgroundColor: "transparent",
            color: "#222222"
        },
        " #jtbcustomizer .jtbc-button:hover, #jtbcustomizer .jtbc-button:focus": {
            backgroundColor: "transparent",
            color: "#222222",
            borderColor: "#222222"
        },
        "#jtbcustomizer .jtbc-actions.jtbc-actions__secondary .jtbc-camera-button": {
            pt: "14px",
            pl: "0px",
            pr: "0px",
            mr: "8px",
            width: "18px"
        },
        "#jtbcustomizer .jtbc-actions.jtbc-actions__secondary .jtbc-camera-button .jtbc-icon-camera": {
            fill: "#222222"
        },
        "#jtbcustomizer .jtbc-actions.jtbc-actions__secondary .jtbc-camera-button:hover .jtbc-icon-camera": {
            fill: "#444444"
        },
        "#jtbcustomizer .jtbc-actions.jtbc-actions__secondary .jtbc-camera-button:before": {
            height: "0px",
            width: "0px"
        },
        "#jtbcustomizer .jtbc-actions.jtbc-actions__secondary .jtbc-camera-button:after": {
            height: "0px",
            width: "0px"
        },
        "#jtbcustomizer .jtbc-button, .css-14n432b-Box #jtbcustomizer .jtbc-button": {
            lineHeight: "18px",
            backgroundColor: "transparent",
            color: "#222222",
            borderColor: " #222222",
            px: 0,
            pb: 0,
            pt: "14px",
            height: "30px"
        },
        '#jtbcustomizer .jtbc-button.jtbc-user-content-upload-button, .css-14n432b-Box #jtbcustomizer .jtbc-button.jtbc-user-content-upload-button, #jtbcustomizer .jtbc-menu-element[data-element-code="upload_logo"] .jtbc-button': {
            pt: 0,
            height: "auto",
            marginTop: "-12px"
        },
        '#jtbcustomizer .jtbc-menu-element[data-element-code="upload_logo"] .jtbc-button.jtbc-user-content-startover-button': {
            marginRight: "8px"
        },
        '#jtbcustomizer .jtbc-menu-element[data-element-code="upload_logo"] .jtbc-user-content-uploaded-container .jtbc-menu-element__sub_label': {
            position: "relative",
            top: 0,
            left: 0,
            marginTop: "12px"
        },
        // snpashots modal
        "#jtbcustomizer .jtbc-popover": {
            fontSize: "15px",
            fontWeight: 500
        },
        // snapshot modal header
        "#jtbcustomizer .jtbc-popover-header": {
            border: "1px solid #E8E8E8"
        },
        "#jtbcustomizer .jtbc-popover-header .jtbc-popover-title": {
            textTransform: "capitalize",
            fontSize: "17px",
            fontWeight: 500
        },
        "#jtbcustomizer .jtbc-popover-header .jtbc-popover-close-icon": {
            height: "14px",
            width: "14px",
            alignSelf: "center",
            top: "18px",
            right: "18px"
        },
        // snapshot modal body
        "#jtbcustomizer .jtbc-popover-body": {
            border: "1px solid #E8E8E8"
        },
        "#jtbcustomizer .jtbc-snapshots-list .jtbc-snapshot-item": {
            borderBottom: "1px solid #E8E8E8"
        },
        "#jtbcustomizer .jtbc-snapshots-list .jtbc-snapshot-item:hover": {
            backgroundColor: "transparent"
        },
        "#jtbcustomizer .jtbc-snapshots-list .jtbc-snapshot-item__remove": {
            textDecoration: "underline",
            variant: "text.label",
            fontSize: "12px",
            transition: "all 0.15s ease-in-out"
        },
        "#jtbcustomizer .jtbc-snapshots-list .jtbc-snapshot-item__remove:hover": {
            textDecoration: "none",
            transition: "all 0.15s ease-in-out"
        },
        // snapshot badge
        "#jtbcustomizer .jtbc-button__badge": {
            borderRadius: "50%",
            top: "0px",
            right: "0px",
            pb: "5px",
            ":hover, :focus": {
                backgroundColor: "red"
            }
        },
        // share modal
        "#jtbcustomizer .jtbc-share-container": {
            pb: "20px",
            mt: "20px",
            borderBottom: "1px solid #E8E8E8"
        },
        "#jtbcustomizer .jtbc-popover-wrapper": {
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)"
        },
        "#jtbcustomizer .jtbc-share-popover": {
            minHeight: "180px"
        },
        "#jtbcustomizer .jtbc-share-input": {
            borderRadius: "50px",
            border: "1px solid #C6C6C7",
            height: "44px",
            fontSize: "15px"
        },
        // share modal copy button
        "#jtbcustomizer .jtbc-actions.jtbc-actions__secondary .jtbc-button-container:last-child .jtbc-share-copy-button-container": {
            backgroundColor: "black",
            color: "white",
            borderRadius: "54px",
            width: "84px",
            height: "44px",
            ml: "8px",
            pl: "0px",
            justifyContent: "center",
            transition: "all 0.2s ease-in-out",
            ":hover": {
                bg: "darkGray"
            },
            ".jtbc-share-copy-button": {
                color: "white",
                pt: "9px",
                fontSize: "14px",
                ":before, :after": {
                    width: "0px",
                    heigth: "0px"
                }
            }
        },
        // reset modal
        "#jtbcustomizer .jtbc-modal": {
            border: "1px solid #E8E8E8",
            boxShadow: "0 2px 4px 0 rgba(0,0,0,0.19)"
        },
        "#jtbcustomizer .jtbc-modal-footer": {
            flexDirection: "row-reverse",
            justifyContent: "flex-end",
            alignItems: "center",
            pb: "20px",
            mb: "20px",
            mx: "20px",
            px: 0,
            borderBottom: "1px solid #E8E8E8"
        },
        "#jtbcustomizer .jtbc-modal-footer .jtbc-modal-button.jtbc-modal-button__no": {
            backgroundColor: "transparent",
            height: "34px",
            color: "text",
            maxWidth: "100px",
            // pl: '40px',
            ml: "0px",
            pt: "10px",
            fontSize: "12px",
            textDecoration: "underline",
            ":hover": {
                bg: "transparent",
                textDecoration: "none"
            },
            ":before, :after": {
                width: "0px",
                heigth: "0px"
            }
        },
        "#jtbcustomizer .jtbc-modal-footer .jtbc-modal-button.jtbc-modal-button__yes": {
            backgroundColor: "#222222",
            height: "44px",
            maxWidth: "160px",
            borderRadius: "54px",
            fontSize: "14px",
            ml: 0,
            ":hover": {
                bg: "darkGray"
            },
            ":before, :after": {
                width: "0px",
                heigth: "0px"
            }
        },
        // text at bottom
        "#jtbcustomizer .jtbc-actions .jtbc-hint.mt-6": {
            minWidth: [
                "unset !important",
                "400px !important"
            ]
        },
        // preview panel
        "#jtbcustomizer .jtbc-preview-panel": {
            width: [
                "100%",
                "48%"
            ]
        },
        // preview container
        "#jtbcustomizer .jtbc-preview-container": {
            flexWrap: [
                "wrap",
                "nowrap"
            ],
            flexDirection: [
                "row",
                "row-reverse"
            ]
        },
        // actions right
        "#jtbcustomizer .jtbc-actions.jtbc-actions__secondary.jtbc-actions__secondary__desktop": {
            display: "none !important"
        },
        // menu panel actions
        "#jtbcustomizer .jtbc-actions": {
            mt: "0 !important"
        },
        "#jtbcustomizer .jtbc-menu-tab-pane.jtbc-menu-tab-pane--active": {
            mb: "0 !important",
            pb: "0 !important"
        },
        // mobile info wrapper
        "#jtbcustomizer .jtbc-info-wrapper.jtbc-info-wrapper__mobile": {
            display: [
                "block",
                "none"
            ],
            textAlign: "left"
        },
        // desktop info wrapper
        "#jtbcustomizer .jtbc-info-wrapper.jtbc-info-wrapper__desktop": {
            display: [
                "none",
                "block"
            ],
            padding: "20px",
            py: "0px"
        },
        // thumbnails wrapper
        "#jtbcustomizer .jtbc-thumbnail-wrapper": {
            overflow: "visible !important",
            flexDirection: [
                "row",
                "column"
            ],
            width: [
                "100%",
                "20%"
            ],
            // thumbnails
            ".jtbc-thumbnail-inner": {
                display: [
                    "none",
                    "flex"
                ],
                flexWrap: "wrap",
                minHeight: "100px",
                gap: "8px",
                width: "100% !important",
                visibility: "visible !important",
                // thumbnail
                ".jtbc-product-thumbnail": {
                    width: [
                        "calc(20% - (4 * 8px / 5)) !important",
                        "calc(100% - (4 * 8px / 5)) !important", 
                    ],
                    height: "0px !important",
                    pb: [
                        "calc(20% - (4 * 8px / 5)) !important",
                        "calc(100% - (4 * 8px / 5)) !important", 
                    ],
                    position: "relative",
                    // image
                    img: {
                        position: "absolute",
                        width: "100%",
                        height: "100%",
                        top: 0,
                        left: 0,
                        objectFit: "contain"
                    }
                }
            },
            // thumbnail nav
            ".jtbc-preview-arrow": {
                display: "none"
            },
            // thumbnail pagination
            ".jtbc-thumbnail-indicators": {
                display: [
                    "flex",
                    "none"
                ]
            },
            input: {
                fontSize: "16px !important"
            }
        },
        '#jtbcustomizer .jtbc-thumbnail-wrapper[data-thumbnail-mode="carousel"] .jtbc-product-thumbnail': {
            border: "1px solid #E8E8E8",
            transition: "all 0.15s ease-in-out",
            borderRadius: "4px"
        },
        '#jtbcustomizer .jtbc-thumbnail-wrapper[data-thumbnail-mode="carousel"] .jtbc-product-thumbnail.jtbc-product-thumbnail:hover': {
            border: "1px solid #8C8C8D",
            transition: "all 0.15s ease-in-out"
        },
        '#jtbcustomizer .jtbc-thumbnail-wrapper[data-thumbnail-mode="carousel"] .jtbc-product-thumbnail.jtbc-product-thumbnail--active': {
            border: "1px solid #222222"
        },
        "#jtbcustomizer .jtbc-user-content-wrapper .jtbc-user-content-upload-modal .jtbc-modal-container": {
            display: [
                "block",
                "flex"
            ],
            top: [
                "45px",
                0
            ],
            bottom: [
                "24px",
                0
            ],
            left: [
                "8px",
                0
            ],
            right: [
                "8px",
                0
            ]
        },
        "#jtbcustomizer .jtbc-user-content-wrapper .jtbc-user-content-upload-modal .jtbc-modal-container .jtbc-modal": {
            margin: [
                0
            ],
            maxHeight: [
                "none",
                "100vh"
            ]
        },
        "#jtbcustomizer .jtbc-user-content-wrapper .jtbc-user-content-upload-modal .jtbc-modal-container .jtbc-modal-body": {
            paddingLeft: [
                "12px",
                "20px"
            ],
            paddingRight: [
                "12px",
                "20px"
            ]
        },
        "#jtbcustomizer .jtbc-user-content-wrapper .jtbc-user-content-upload-modal .jtbc-user-content-terms-and-conditions__body": {
            maxHeight: "none",
            overflow: "visible"
        },
        "#jtbcustomizer .jtbc-user-content-wrapper .jtbc-user-content-upload-modal .jtbc-modal-body .jtbc-modal-content:first-child": {
            display: "flex",
            flexDirection: "column"
        },
        "#jtbcustomizer .jtbc-user-content-wrapper .jtbc-user-content-upload-modal .jtbc-modal-body .jtbc-modal-content:first-child .jtbc-user-content-choose-file-container": {
            order: 1
        },
        "#jtbcustomizer .jtbc-user-content-wrapper .jtbc-user-content-upload-modal .jtbc-modal-body .jtbc-modal-content:first-child .jtbc-user-content-terms-and-conditions-check": {
            order: 0
        },
        "#jtbcustomizer .jtbc-user-content-wrapper .jtbc-user-content-upload-modal .jtbc-modal-body .jtbc-modal-content:first-child > *": {
            order: 2
        }
    };
}());

;// CONCATENATED MODULE: ./src/templates/product/Main/Details/Personalize/PersonalizeModal.jsx











var PersonalizeModal = themed(function(param) {
    var theme = param.theme, variantId = param.variantId;
    var cartAddItem = (0,dist.useCartAddItem)().cartAddItem;
    var cartAddItems = (0,dist.useCartAddItems)().cartAddItems;
    var ref = (0,_sliced_to_array/* default */.Z)((0,hooks/* useSidebar */.Ap)(), 2), openCartSidebar = ref[1].openCartSidebar;
    var ref1 = (0,react.useState)(false), atcInjected = ref1[0], setAtcInjected = ref1[1];
    (0,react.useEffect)(function() {
        window.__packCommerce = {};
        var remoteMultipleAtc = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(items) {
                var itemsToAdd, cart, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            if (!Array.isArray(items) || !(items === null || items === void 0 ? void 0 : items.every(function(item) {
                                return typeof item === "object";
                            }))) {
                                throw new Error("An array of objects is required to be passed in. Received: `".concat(items, "`"));
                            }
                            itemsToAdd = items.map(function(param) {
                                var merchandiseId = param.merchandiseId, quantity = param.quantity, attributes = param.attributes;
                                if (!merchandiseId) {
                                    throw new Error("`merchandiseId` is a required property of each item");
                                }
                                if (!quantity) {
                                    throw new Error("`quantity` is a required property for each item. Missing for item with `merchandiseId` `".concat(merchandiseId, "`"));
                                }
                                if (attributes) {
                                    attributes.forEach(function(attr) {
                                        var hasKeyValue = (attr === null || attr === void 0 ? void 0 : attr.key) !== undefined && (attr === null || attr === void 0 ? void 0 : attr.value) !== undefined;
                                        if (!hasKeyValue) {
                                            throw new Error('`attributes` must be array of objects with `key` and `value`, e.g. `[{ key: "color", value: "red" }]`');
                                        }
                                    });
                                }
                                var itemAttributes = attributes ? (0,_to_consumable_array/* default */.Z)(attributes).concat([
                                    {
                                        key: "_LPROP",
                                        value: "rtly-non-returnable"
                                    }
                                ]) : [
                                    {
                                        key: "_LPROP",
                                        value: "rtly-non-returnable"
                                    }
                                ];
                                return {
                                    merchandiseId: merchandiseId,
                                    quantity: quantity,
                                    attributes: itemAttributes
                                };
                            });
                            return [
                                4,
                                cartAddItems(itemsToAdd)
                            ];
                        case 1:
                            cart = _state.sent();
                            if (cart) {
                                openCartSidebar();
                            }
                            return [
                                2,
                                true
                            ];
                        case 2:
                            error = _state.sent();
                            console.error("Error with __packCommerce.remoteMultipleAtc:", error.message);
                            return [
                                2,
                                false
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function remoteMultipleAtc(items) {
                return _ref.apply(this, arguments);
            };
        }();
        var remoteAtc = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var ref, merchandiseId, quantity, attributes, hasAttributes, itemAttributes, cart, error;
                var _arguments = arguments;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            ref = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {
                                merchandiseId: null,
                                quantity: 1,
                                attributes: null
                            }, merchandiseId = ref.merchandiseId, quantity = ref.quantity, attributes = ref.attributes;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            hasAttributes = attributes === null || attributes === void 0 ? void 0 : attributes.every(function(attr) {
                                var hasKeyValue = (attr === null || attr === void 0 ? void 0 : attr.key) !== undefined && (attr === null || attr === void 0 ? void 0 : attr.value) !== undefined;
                                if (!hasKeyValue) {
                                    throw new Error('`attributes` must be array of objects with `key` and `value`, e.g. `[{ key: "color", value: "red" }]`');
                                }
                                return hasKeyValue;
                            });
                            itemAttributes = hasAttributes ? (0,_to_consumable_array/* default */.Z)(attributes).concat([
                                {
                                    key: "_LPROP",
                                    value: "rtly-non-returnable"
                                }
                            ]) : [
                                {
                                    key: "_LPROP",
                                    value: "rtly-non-returnable"
                                }
                            ];
                            return [
                                4,
                                cartAddItem({
                                    merchandiseId: merchandiseId,
                                    quantity: quantity,
                                    attributes: itemAttributes
                                })
                            ];
                        case 2:
                            cart = _state.sent();
                            if (cart) {
                                openCartSidebar();
                            }
                            return [
                                2,
                                true
                            ];
                        case 3:
                            error = _state.sent();
                            console.error("Error with __packCommerce.remoteAtc:", error.message);
                            return [
                                2,
                                false
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function remoteAtc() {
                return _ref.apply(this, arguments);
            };
        }();
        window.__packCommerce.remoteMultipleAtc = remoteMultipleAtc;
        window.__packCommerce.remoteAtc = remoteAtc;
        setAtcInjected(true);
    }, []);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": PersonalizeModal.displayName,
        sx: theme.modal,
        children: atcInjected && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_jsx_runtime_esm/* Fragment */.HY, {
            children: [
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)((head_default()), {
                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("script", {
                        src: "https://silhouette.jtbcustom.com/js/loader/".concat(variantId, ".js?store_key=61GbV5ck"),
                        type: "text/javascript"
                    })
                }),
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                    id: "jtbconfigurator"
                })
            ]
        })
    });
});
PersonalizeModal.displayName = "PersonalizeModal";

;// CONCATENATED MODULE: ./src/templates/product/Main/Details/Personalize/Personalize.jsx











var Personalize = themed(function(param) {
    var theme = param.theme, product = param.product;
    var ref, ref1;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useSelectedVariant */.BK)(), 1), selectedVariant = ref2[0];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useModal */.dd)(), 2), openModal = ref3[1].openModal;
    var personalizedEnabled = (0,react.useMemo)(function() {
        var ref;
        return product === null || product === void 0 ? void 0 : (ref = product.tags) === null || ref === void 0 ? void 0 : ref.includes("personalized-enabled");
    }, [
        product === null || product === void 0 ? void 0 : product.id
    ]);
    var variantId = selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.legacyResourceId;
    var customizeBtn = (0,react.useRef)(null);
    var settings = (0,dist.useSettings)();
    var handleOpenModal = (0,react.useCallback)(function() {
        openModal(/*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(PersonalizeModal, {
            variantId: variantId
        }));
    }, [
        variantId
    ]);
    (0,react.useEffect)(function() {
        if (customizeBtn === null || customizeBtn === void 0 ? void 0 : customizeBtn.current) {
            var urlParams = new URLSearchParams(window.location.search);
            var isOpenModal = urlParams.get("recipe_id");
            if (isOpenModal) {
                customizeBtn.current.click();
            }
        }
    }, [
        customizeBtn === null || customizeBtn === void 0 ? void 0 : customizeBtn.current
    ]);
    return personalizedEnabled ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": Personalize.displayName,
        sx: theme.wrapper,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Button */.zx, {
            onClick: handleOpenModal,
            "aria-label": "Open Personalize Modal",
            sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.button), {
                variant: "buttons.customize"
            }),
            ref: customizeBtn,
            children: [
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                    sx: {
                        fontWeight: "500",
                        letterSpacing: "0.28px"
                    },
                    children: (settings === null || settings === void 0 ? void 0 : (ref = settings.product) === null || ref === void 0 ? void 0 : (ref1 = ref.personalize) === null || ref1 === void 0 ? void 0 : ref1.buttonText) || "Customize"
                }),
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Svg */.ny, {
                    alt: "personalization icon",
                    src: "/svgs/noprecache/svg/pencil-black.svg",
                    viewBox: "0 0 19 19",
                    width: "19px",
                    height: "19px",
                    className: "!ml-1"
                })
            ]
        })
    }) : null;
});
Personalize.displayName = "Personalize";

;// CONCATENATED MODULE: ./src/templates/product/Main/Details/Personalize/index.js



/***/ }),

/***/ 73355:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ create; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70169);
/* harmony import */ var theme_ui_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70863);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);




var create = function(theme) {
    return function(FnComp) {
        return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(compProps, ref) {
            return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.cloneElement)(/*#__PURE__*/ (0,theme_ui_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(FnComp, {}), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, compProps), {
                theme: theme
            }), ref ? {
                inputRef: ref
            } : null));
        });
    };
};


/***/ }),

/***/ 30450:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "r": function() { return /* binding */ theme; }
});

;// CONCATENATED MODULE: ./src/theme/theme.alerts.js
var alerts = {
    success: {
        color: "white",
        bg: "green",
        py: 4,
        px: 6,
        fontWeight: 400,
        fontSize: 2
    },
    warning: {
        color: "red",
        bg: "yellow",
        py: 4,
        px: 6,
        fontWeight: 400,
        fontSize: 2
    },
    error: {
        color: "white",
        bg: "red",
        py: 4,
        px: 6,
        fontWeight: 400,
        fontSize: 2
    }
};

;// CONCATENATED MODULE: ./src/theme/theme.badges.js
var badges = {
    onSale: {
        color: "background",
        bg: "dark",
        py: 4,
        px: 6,
        fontSize: 1,
        fontWeight: 400
    },
    sellingPlan: {
        color: "background",
        fontSize: "9px",
        width: "auto",
        lineHeight: 1,
        letterSpacing: ".08em",
        borderRadius: "7px",
        bg: "text",
        py: 2,
        px: 3,
        fontWeight: 400
    }
};

;// CONCATENATED MODULE: ./src/theme/theme.box.js
var box = {
    // <Box variant="box.mobile" />
    mobile: {
        display: [
            "block",
            "none"
        ],
        1: {
            display: [
                "inline-block",
                "none"
            ]
        }
    },
    // <Box variant="box.desktop" />
    desktop: {
        display: [
            "none",
            "block"
        ],
        1: {
            display: [
                "none",
                "inline-block"
            ]
        }
    },
    // <Box variant="box.fill" />
    fill: {
        position: "absolute",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    }
};

// EXTERNAL MODULE: ./src/theme/theme.breakpoints.js
var theme_breakpoints = __webpack_require__(80315);
// EXTERNAL MODULE: ./src/theme/theme.buttons.js
var theme_buttons = __webpack_require__(27750);
// EXTERNAL MODULE: ./src/theme/theme.colors.js
var theme_colors = __webpack_require__(75458);
;// CONCATENATED MODULE: ./src/theme/theme.helper.js
var helper = {
    "none-block": {
        display: [
            "none",
            "block"
        ]
    },
    "none-flex": {
        display: [
            "none",
            "flex"
        ]
    },
    "none-grid": {
        display: [
            "none",
            "grid"
        ]
    },
    "block-none": {
        display: [
            "block",
            "none"
        ]
    },
    "flex-none": {
        display: [
            "flex",
            "none"
        ]
    },
    "grid-none": {
        display: [
            "grid",
            "none"
        ]
    }
};

;// CONCATENATED MODULE: ./src/theme/theme.flex.js
var flex = {
    // <Flex variant="flex.row" />
    inline: {
        display: "inline-flex"
    },
    row: {
        // short cut to bottom
        around: {
            justifyContent: "space-around",
            alignItems: "flex-start",
            start: {
                justifyContent: "space-around",
                alignItems: "flex-start"
            },
            center: {
                justifyContent: "space-around",
                alignItems: "center"
            },
            end: {
                justifyContent: "space-around",
                alignItems: "flex-end"
            }
        },
        between: {
            justifyContent: "space-between",
            alignItems: "flex-start",
            start: {
                justifyContent: "space-between",
                alignItems: "flex-start"
            },
            center: {
                justifyContent: "space-between",
                alignItems: "center"
            },
            end: {
                justifyContent: "space-between",
                alignItems: "flex-end"
            }
        },
        evenly: {
            justifyContent: "space-evenly",
            alignItems: "flex-start",
            start: {
                justifyContent: "space-evenly",
                alignItems: "flex-start"
            },
            center: {
                justifyContent: "space-evenly",
                alignItems: "center"
            },
            end: {
                justifyContent: "space-evenly",
                alignItems: "flex-end"
            }
        },
        start: {
            justifyContent: "flex-start",
            alignItems: "flex-start",
            start: {
                justifyContent: "flex-start",
                alignItems: "flex-start"
            },
            center: {
                justifyContent: "flex-start",
                alignItems: "center"
            },
            end: {
                justifyContent: "flex-start",
                alignItems: "flex-end"
            }
        },
        center: {
            justifyContent: "center",
            alignItems: "center",
            start: {
                justifyContent: "center",
                alignItems: "flex-start"
            },
            center: {
                justifyContent: "center",
                alignItems: "center"
            },
            end: {
                justifyContent: "center",
                alignItems: "flex-end"
            }
        },
        // short cut
        end: {
            justifyContent: "flex-end",
            alignItems: "flex-end",
            start: {
                justifyContent: "flex-end",
                alignItems: "flex-start"
            },
            center: {
                justifyContent: "flex-end",
                alignItems: "center"
            },
            end: {
                justifyContent: "flex-end",
                alignItems: "flex-end"
            }
        }
    },
    /*
    Flex Column
  */ column: {
        flexDirection: "column",
        // short cut to bottom
        start: {
            flexDirection: "column",
            alignItems: "flex-start",
            justifyContent: "flex-start",
            start: {
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "flex-start"
            },
            center: {
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "center"
            },
            end: {
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "flex-end"
            },
            between: {
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "space-between"
            },
            around: {
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "space-around"
            },
            evenly: {
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "space-evenly"
            }
        },
        center: {
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            start: {
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "center"
            },
            center: {
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center"
            },
            end: {
                flexDirection: "column",
                justifyContent: "flex-end",
                alignItems: "center"
            },
            between: {
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "space-between"
            },
            around: {
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "space-around"
            },
            evenly: {
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "space-evenly"
            }
        },
        stretch: {
            flexDirection: "column",
            alignItems: "stretch",
            justifyContent: "flex-start",
            start: {
                flexDirection: "column",
                alignItems: "stretch",
                justifyContent: "flex-start"
            },
            center: {
                flexDirection: "column",
                alignItems: "stretch",
                justifyContent: "center"
            },
            end: {
                flexDirection: "column",
                alignItems: "stretch",
                justifyContent: "flex-end"
            },
            between: {
                flexDirection: "column",
                alignItems: "stretch",
                justifyContent: "space-between"
            },
            around: {
                flexDirection: "column",
                alignItems: "stretch",
                justifyContent: "space-around"
            },
            evenly: {
                flexDirection: "column",
                alignItems: "stretch",
                justifyContent: "space-evenly"
            }
        },
        // short cut
        end: {
            flexDirection: "column",
            justifyContent: "flex-end",
            alignItems: "flex-end",
            start: {
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "flex-end"
            },
            center: {
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "flex-end"
            },
            end: {
                flexDirection: "column",
                justifyContent: "flex-end",
                alignItems: "flex-end"
            },
            between: {
                flexDirection: "column",
                alignItems: "flex-end",
                justifyContent: "space-between"
            },
            around: {
                flexDirection: "column",
                alignItems: "flex-end",
                justifyContent: "space-around"
            },
            evenly: {
                flexDirection: "column",
                alignItems: "flex-end",
                justifyContent: "space-evenly"
            }
        }
    },
    // row mobile / column desktop
    "row-column": {
        flexDirection: [
            "row",
            null,
            null,
            null,
            "column"
        ],
        start: {
            flexDirection: [
                "row",
                null,
                null,
                null,
                "column"
            ],
            justifyContent: "flex-start",
            alignItems: "flex-start"
        },
        center: {
            flexDirection: [
                "row",
                null,
                null,
                null,
                "column"
            ],
            justifyContent: "center",
            alignItems: "center"
        },
        end: {
            flexDirection: [
                "row",
                null,
                null,
                null,
                "column"
            ],
            justifyContent: "flex-end",
            alignItems: "flex-end"
        }
    },
    // column mob / row desktop
    "column-row": {
        flexDirection: [
            "column",
            null,
            null,
            null,
            "row"
        ],
        start: {
            flexDirection: [
                "column",
                null,
                null,
                null,
                "row"
            ],
            justifyContent: "flex-start",
            alignItems: "flex-start"
        },
        center: {
            flexDirection: [
                "column",
                null,
                null,
                null,
                "row"
            ],
            justifyContent: "center",
            alignItems: "center"
        },
        end: {
            flexDirection: [
                "column",
                null,
                null,
                null,
                "row"
            ],
            justifyContent: "flex-end",
            alignItems: "flex-end"
        }
    }
};

;// CONCATENATED MODULE: ./src/theme/theme.fontSizes.js
var fontSizes = [
    /*
    DON'T ADD NEW fontSizes AS IT WILL MESS UP THE SCALE ORDER
    If your value is not here, either choose the closes or just add it inline i.e "40px"
  */ "11px",
    "12px",
    "14px",
    "15px",
    "16px",
    "17px",
    "18px",
    "20px",
    "24px",
    "30px",
    "36px",
    "40px",
    "48px",
    "56px"
];

;// CONCATENATED MODULE: ./src/theme/theme.fontWeights.js
var fontWeights = {
    body: 400,
    regular: 400,
    bold: 700,
    heavy: 800,
    400: 400,
    500: 500,
    600: 600,
    700: 700,
    800: 800
};

;// CONCATENATED MODULE: ./src/theme/theme.fonts.js
var fonts = {
    body: '"Fellix", system-ui, -apple-system, BlinkMacSystemFont, sans-serif',
    heading: '"Fellix", system-ui, -apple-system, BlinkMacSystemFont, sans-serif',
    monospace: '"Fellix", system-ui, -apple-system, BlinkMacSystemFont, sans-serif'
};

;// CONCATENATED MODULE: ./src/theme/theme.forms/theme.forms.account.js
var account = {
    input: {
        variant: "text.base",
        p: 8,
        mb: [
            9
        ],
        border: function(t) {
            return "1px solid ".concat(t.colors.borderGrey);
        },
        borderRadius: 0,
        ":focus": {
            outline: "none !important",
            border: function(t) {
                return "1px solid ".concat(t.colors.borderGrey);
            },
            boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.161);"
        }
    }
};

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
;// CONCATENATED MODULE: ./src/theme/theme.forms/theme.forms.input.js


var defaultInput = {
    variant: "text.base",
    color: "text",
    p: 8,
    // border: t => `1px solid ${t.colors.gray}`,
    borderRadius: 0,
    ":focus": {
        outline: "none !important"
    }
};
var input = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultInput), {
    search: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultInput), {
        pl: "50px",
        mb: 10,
        ":focus": {
            outline: "none !important",
            // border: t => `1px solid ${t.colors.text}`,
            boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.161);"
        }
    })
});

;// CONCATENATED MODULE: ./src/theme/theme.forms/theme.forms.label.js
var label = {
    // default
    variant: "text.base",
    mb: 5,
    // label variants
    sellingPlan: {
        color: "white",
        width: "unset",
        display: "inline-flex",
        flexGrow: 0,
        justifyContent: "center",
        alignItems: "center",
        bg: "black",
        py: 1,
        px: 3,
        border: "1px solid black",
        borderRadius: "4px",
        fontWeight: 100,
        fontSize: 2
    }
};

;// CONCATENATED MODULE: ./src/theme/theme.forms/index.js



var theme_forms_forms = {
    account: account,
    input: input,
    label: label
};

// EXTERNAL MODULE: ./src/theme/theme.layout.js
var theme_layout = __webpack_require__(28634);
;// CONCATENATED MODULE: ./src/theme/theme.letterSpacings.js
var letterSpacings = {
    0: "0px",
    0.25: ".25px",
    6: "6px",
    8: "8px"
};

;// CONCATENATED MODULE: ./src/theme/theme.lineHeights.js
var lineHeights = {
    11: "11px",
    13: "13px",
    14: "14px",
    15: "15px",
    16: "16px",
    18: "18px",
    20: "20px",
    22: "22px",
    24: "24px",
    32: "32px",
    36: "36px",
    38: "38px",
    40: "40px",
    48: "48px",
    60: "60px",
    100: "100px",
    200: "200px"
};

;// CONCATENATED MODULE: ./src/theme/theme.shadows.js
var shadows = {
    bottom: "0 3px 30px rgba(0, 0, 0, 0.08)",
    top: "0px 0px 40px rgba(0,0,0,0.1)",
    left: "10px 0px 30px rgb(0 0 0 / 8%)"
};

// EXTERNAL MODULE: ./src/theme/theme.space.js
var theme_space = __webpack_require__(58486);
;// CONCATENATED MODULE: ./src/theme/theme.styles.js
var styles = {
    root: {
        fontFamily: "body",
        lineHeight: "1.35",
        fontWeight: 400
    },
    h1: {
        variant: "text.h1"
    },
    h2: {
        variant: "text.h2"
    },
    h3: {
        variant: "text.h3"
    },
    h4: {
        variant: "text.h4"
    },
    h5: {
        variant: "text.h5"
    },
    h6: {
        variant: "text.h6"
    },
    articleTitle: {
        variant: "text.articleTitle"
    },
    pre: {
        fontFamily: "monospace",
        overflowX: "auto",
        code: {
            color: "inherit"
        }
    },
    p: {
        display: "none",
        variant: "text.base"
    },
    code: {
        fontFamily: "monospace",
        fontSize: "inherit"
    },
    table: {
        width: "100%",
        borderCollapse: "separate",
        borderSpacing: 0
    },
    th: {
        textAlign: "left",
        borderBottomStyle: "solid"
    },
    td: {
        textAlign: "left",
        borderBottomStyle: "solid"
    },
    a: {
        variant: "text.base"
    },
    "input::placeholder": {
        variant: "text.base"
    },
    span: {
        variant: "text.base"
    },
    div: {
        variant: "text.base"
    }
};

// EXTERNAL MODULE: ./src/theme/theme.text.js
var theme_text = __webpack_require__(10408);
;// CONCATENATED MODULE: ./src/theme/index.js
// theme modules



















// theme export
var theme = {
    // Add more if needed
    alerts: alerts,
    badges: badges,
    box: box,
    breakpoints: theme_breakpoints/* breakpoints */.A,
    buttons: theme_buttons/* buttons */.Z,
    colors: theme_colors/* colors */.O,
    flex: flex,
    helper: helper,
    fonts: fonts,
    fontSizes: fontSizes,
    fontWeights: fontWeights,
    forms: theme_forms_forms,
    layout: theme_layout/* layout */.b,
    letterSpacings: letterSpacings,
    lineHeights: lineHeights,
    shadows: shadows,
    space: theme_space/* space */.D,
    styles: styles,
    text: theme_text/* text */.f
};


/***/ }),

/***/ 80315:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ breakpoints; }
/* harmony export */ });
var breakpoints = [
    /* DO NOT ADD/REMOVE */ "48em",
    "64em",
    "80em",
    "90em"
];


/***/ }),

/***/ 27750:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ buttons; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70169);


var plain = {
    position: "relative",
    minWidth: "unset",
    p: 0,
    m: 0,
    bg: "transparent",
    border: 0,
    borderRadius: 0,
    color: "text",
    fontFamily: "body",
    textDecoration: "none",
    cursor: "pointer",
    ":hover": {
        color: "currentColor"
    }
};
var customize = {
    position: "relative",
    minWidth: "unset",
    p: 0,
    m: 0,
    mb: "24px",
    bg: "chartreuseYellow",
    border: "1px",
    color: "text",
    fontFamily: "Fellix",
    fontSize: "14px",
    textDecoration: "none",
    justifyContent: "center",
    borderColor: "chartreuseYellow",
    borderStyle: "solid",
    borderRadius: "62px",
    cursor: "pointer",
    height: "auto",
    minHeight: "40px",
    ":hover": {
        color: "currentColor",
        borderColor: "black",
        bg: "chartreuseYellow"
    }
};
var buttons = {
    primary: {
        variant: "text.buttonText",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        lineHeight: "38px",
        height: "42px",
        textAlign: "center",
        color: "white",
        minWidth: "160px",
        px: 11,
        py: 0,
        bg: "text",
        border: "1px solid",
        borderRadius: "22px",
        borderColor: "text",
        transition: "all 0.2s ease-in-out",
        cursor: "pointer",
        whiteSpace: "nowrap",
        ":hover": {
            bg: "darkGray",
            borderColor: "darkGray"
        },
        ":disabled": {
            bg: "darkGray",
            borderColor: "darkGray",
            cursor: "not-allowed"
        }
    },
    secondary: {
        variant: "buttons.primary",
        color: "text",
        bg: "white",
        borderColor: "text",
        ":hover": {
            color: "darkGray",
            bg: "white",
            borderColor: "darkGray"
        }
    },
    tertiary: {
        variant: "buttons.primary",
        bg: "tundora",
        borderColor: "tundora",
        ":hover": {
            bg: "#786C68",
            borderColor: "#786C68"
        }
    },
    quaternary: {
        variant: "buttons.primary",
        bg: "#000",
        borderColor: "#000",
        fontSize: [
            "13px",
            3
        ],
        ":hover": {
            bg: "darkGray",
            borderColor: "darkGray"
        }
    },
    groupText: {
        variant: "text.buttonTextSecondary",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "auto",
        minWidth: "unset",
        position: "relative",
        pb: 9,
        color: "text",
        whiteSpace: "nowrap",
        overflow: "hidden",
        ":after": {
            content: '""',
            width: "100%",
            height: "1px",
            position: "absolute",
            top: "calc(100% - 1px)",
            left: 0,
            transition: "transform 0.2s ease-in",
            bg: "text"
        },
        ":hover:after": {
            transform: "translateX(0)"
        }
    },
    inverse: {
        variant: "buttons.primary",
        color: "white",
        bg: "transparent",
        borderColor: "white",
        ":hover": {
            bg: "white",
            color: "text",
            borderColor: "text"
        }
    },
    inverseSecondary: {
        variant: "buttons.secondary",
        color: "text",
        borderColor: "text",
        bg: "transparent"
    },
    link: {
        1: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, plain), {
            variant: "text.link.1",
            cursor: "pointer"
        }),
        2: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, plain), {
            variant: "text.link.2",
            cursor: "pointer"
        })
    },
    articleLink: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, plain), {
        variant: "text.link.2",
        fontSize: 4,
        lineHeight: "20px",
        cursor: "pointer"
    }),
    lionRefer: {
        variant: "buttons.tertiary"
    },
    plain: plain,
    customize: customize
};


/***/ }),

/***/ 75458:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ colors; }
/* harmony export */ });
var TEXT = "#222222";
var BACKGROUND = "#FFF";
var colors = {
    // Required
    black: "#010101",
    white: "#FFFFFF",
    text: TEXT,
    background: BACKGROUND,
    lightGreen: "#E1FF01",
    // Grays
    darkGray: "#444444",
    mediumDarkGray: "#8C8C8D",
    mediumGray: "#C6C6C7",
    gray: "#f3f3f3",
    lightGray: "#F3F3F3",
    mediumLightGray: "#F1F2F4",
    // Primary
    dark: "#222222",
    // Accents
    red: "#AE2807",
    green: "#83B784",
    chiliPepper: "#9B1B30",
    chartreuseYellow: "#E1FF05",
    holidayGreen: "#2E4847",
    redSalePrice: "#FF0000",
    tundora: "#574F4C"
};


/***/ }),

/***/ 28634:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ layout; }
/* harmony export */ });
// <Container> variants
var layout = {
    container: {
        position: "relative"
    },
    padded: {
        position: "relative",
        px: [
            8,
            10,
            11,
            80
        ]
    },
    content: {
        position: "relative",
        px: [
            8,
            10,
            11,
            12
        ],
        maxWidth: "84em",
        mx: "auto"
    },
    contentNarrow: {
        position: "relative",
        px: [
            8,
            10,
            11,
            12
        ],
        maxWidth: "61em",
        mx: "auto"
    },
    contentWide: {
        position: "relative",
        px: [
            8,
            10,
            11,
            12
        ],
        maxWidth: "90em",
        mx: "auto"
    },
    header: {
        position: "relative",
        px: [
            8,
            10,
            11,
            12
        ]
    }
};


/***/ }),

/***/ 58486:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ space; }
/* harmony export */ });
var space = [
    /*
    DON'T ADD NEW SPACES AS IT WILL MESS UP THE SCALE ORDER
    If your value is not here, either choose the closes or just add it inline i.e "40px"
  */ 0,
    2,
    4,
    6,
    8,
    10,
    12,
    14,
    16,
    18,
    20,
    24,
    32,
    36,
    40,
    48,
    56,
    64,
    72,
    100,
    128,
    150,
    175,
    200,
    256
];


/***/ }),

/***/ 10408:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ text; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70169);


var label = {
    fontSize: 3,
    lineHeight: "20px",
    fontWeight: 500,
    fontFamily: "body"
};
var link = {
    fontSize: 1,
    lineHeight: 15,
    fontWeight: 500,
    fontFamily: "body",
    position: "relative",
    overflow: "hidden",
    ":after": {
        content: '""',
        position: "absolute",
        top: "calc(100% - 1px)",
        left: 0,
        width: "100%",
        height: "1px",
        bg: "currentColor",
        transition: "transform 0.4s ease-in-out"
    },
    ":before": {
        content: '""',
        position: "absolute",
        top: "calc(100% - 1px)",
        left: "-200%",
        width: "100%",
        height: "1px",
        bg: "currentColor",
        transition: "transform 0.4s ease-in-out"
    },
    ":hover:after": {
        transform: "translateX(200%)"
    },
    ":hover:before": {
        transform: "translateX(200%)"
    }
};
var text = {
    // HEADINGS
    h1: {
        fontFamily: "Reckless Neue",
        fontSize: [
            10,
            "66px"
        ],
        lineHeight: [
            "40px",
            "70px"
        ],
        fontWeight: 300,
        letterSpacing: "-0.05em",
        2: {
            fontFamily: "heading",
            fontSize: [
                "33px",
                "63px"
            ],
            lineHeight: [
                "40px",
                "67px"
            ],
            fontWeight: 400,
            letterSpacing: "-0.05em"
        }
    },
    h2: {
        variant: "text.h1",
        fontFamily: "Reckless Neue",
        fontSize: [
            "34px",
            11
        ],
        lineHeight: [
            "38px",
            "43px"
        ],
        letterSpacing: "-0.03em"
    },
    h3: {
        variant: "text.h1.2",
        fontSize: [
            "26px",
            "34px"
        ],
        lineHeight: [
            "32px",
            "38px"
        ],
        letterSpacing: "-0.03em"
    },
    h4: {
        variant: "text.h1.2",
        fontSize: [
            "22px",
            "28px"
        ],
        lineHeight: [
            "28px",
            "32px"
        ],
        letterSpacing: [
            "-0.05em",
            "-0.01em"
        ],
        fontWeight: 500
    },
    h5: {
        variant: "text.h1.2",
        fontSize: [
            3,
            6
        ],
        lineHeight: "22px",
        fontWeight: 500
    },
    h6: {
        variant: "text.h1.2",
        fontSize: [
            2,
            4
        ],
        lineHeight: "18px",
        fontWeight: 500
    },
    // BODY
    sm: {
        variant: "text.base",
        fontSize: [
            0,
            1
        ],
        lineHeight: "16px"
    },
    base: {
        fontFamily: "body",
        fontSize: [
            "13px",
            3
        ],
        lineHeight: "19px"
    },
    lg: {
        variant: "text.base",
        fontSize: [
            3,
            4
        ],
        lineHeight: "20px"
    },
    // LABELS, LINKS, OTHERS
    label: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, label), {
        1: label,
        2: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, label), {
            fontSize: [
                1,
                1
            ]
        })
    }),
    link: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, link), {
        1: link,
        2: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, link), {
            fontSize: [
                1,
                2
            ],
            lineHeight: [
                13,
                18
            ]
        })
    }),
    buttonText: {
        fontFamily: "body",
        fontSize: 3,
        lineHeight: 20,
        fontWeight: 500
    },
    buttonTextSecondary: {
        variant: "buttonText",
        fontSize: 5,
        lineHeight: 22,
        fontWeight: 500
    },
    // NAVIGATION
    navItem: {
        fontSize: 3,
        lineHeight: 18,
        fontWeight: 500,
        fontFamily: "body",
        cursor: "pointer"
    },
    navSubItem: {
        fontSize: 6,
        lineHeight: 22,
        fontWeight: 400,
        cursor: "pointer",
        fontFamily: "body"
    },
    searchHeading: {
        variant: "text.navItem",
        position: "sticky",
        top: [
            "-32px",
            "56px"
        ],
        borderBottomWidth: "1px",
        borderBottomStyle: "solid",
        borderBottomColor: "lightGray",
        zIndex: 2,
        pt: 8,
        pb: 4,
        mb: 5,
        bg: "background"
    },
    // SECTION SPECIFIC
    promoQuote: {
        variant: "text.h3",
        fontSize: [
            "32px",
            12
        ],
        lineHeight: [
            38,
            "56px"
        ],
        textTransform: "normal"
    },
    reviewsHeading: {
        variant: "text.h2",
        fontWeight: 500,
        fontSize: [
            10,
            11
        ]
    },
    articleTitle: {
        variant: "text.h4"
    }
};


/***/ }),

/***/ 57795:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M0": function() { return /* binding */ parseContentPosition; },
/* harmony export */   "_T": function() { return /* binding */ pxWithFullBleed; },
/* harmony export */   "ku": function() { return /* binding */ calcResponsiveHeight; },
/* harmony export */   "nG": function() { return /* binding */ convertAlignToFlex; },
/* harmony export */   "v8": function() { return /* binding */ handleize; }
/* harmony export */ });
/* harmony import */ var _theme_theme_layout__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28634);

// Converts text align value to flex
var convertAlignToFlex = function(alignment) {
    if (!alignment) return "center";
    if (alignment === "left") {
        return "flex-start";
    }
    if (alignment === "center") {
        return "center";
    }
    return "flex-end";
};
// Parses flex position value (e.g. "flex-start center") into two values
var parseContentPosition = function(position) {
    return position ? position.split(" ").reduce(function(obj, pos, index) {
        if (index === 0) {
            obj.alignItems = pos;
        } else {
            obj.justifyContent = pos;
        }
        return obj;
    }, {}) : {};
};
// Adds horizontal padding to a specific element when parent section is full bleed
var pxWithFullBleed = function(section) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var isFullBleedMb = (section === null || section === void 0 ? void 0 : (ref = section.mobile) === null || ref === void 0 ? void 0 : ref.container) === "container";
    var isFullBleedDt = (section === null || section === void 0 ? void 0 : (ref1 = section.desktop) === null || ref1 === void 0 ? void 0 : ref1.container) === "container";
    return {
        px: [
            isFullBleedMb ? ((ref2 = _theme_theme_layout__WEBPACK_IMPORTED_MODULE_0__/* .layout.header */ .b.header) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.px) === null || ref3 === void 0 ? void 0 : ref3[0]) || 0 : 0,
            isFullBleedDt ? ((ref4 = _theme_theme_layout__WEBPACK_IMPORTED_MODULE_0__/* .layout.header */ .b.header) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.px) === null || ref5 === void 0 ? void 0 : ref5[1]) || 0 : 0,
            isFullBleedDt ? ((ref6 = _theme_theme_layout__WEBPACK_IMPORTED_MODULE_0__/* .layout.header */ .b.header) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.px) === null || ref7 === void 0 ? void 0 : ref7[2]) || null : 0,
            isFullBleedDt ? ((ref8 = _theme_theme_layout__WEBPACK_IMPORTED_MODULE_0__/* .layout.header */ .b.header) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.px) === null || ref9 === void 0 ? void 0 : ref9[3]) || null : 0, 
        ]
    };
};
var calcResponsiveHeight = function(param) {
    var maxHeight = param.maxHeight, viewport = param.viewport;
    if (!maxHeight || !viewport) return null;
    if (typeof maxHeight !== "number" || typeof viewport !== "number") {
        console.log("maxHeight and viewport must be integers");
        return null;
    }
    return "".concat(maxHeight / (viewport / 100), "vw");
};
var handleize = function(string) {
    var handleizedValue;
    if (string) {
        handleizedValue = string.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/-$/, "").replace(/^-/, "");
    }
    return handleizedValue;
};



/***/ }),

/***/ 39136:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ku": function() { return /* reexport */ common/* calcResponsiveHeight */.ku; },
  "nG": function() { return /* reexport */ common/* convertAlignToFlex */.nG; },
  "uP": function() { return /* reexport */ decodedId; },
  "H4": function() { return /* reexport */ fetchProductsFromHandles; },
  "m4": function() { return /* reexport */ getEncodedId; },
  "MM": function() { return /* reexport */ getValidId; },
  "jU": function() { return /* reexport */ isBrowser; },
  "x": function() { return /* reexport */ isEncoded; },
  "V_": function() { return /* reexport */ loading; },
  "_T": function() { return /* reexport */ common/* pxWithFullBleed */._T; },
  "O7": function() { return /* reexport */ shopifySrcFilter; },
  "Dh": function() { return /* reexport */ withInView; }
});

// UNUSED EXPORTS: fetchProductFromHandle, formatLocalePrice, getValidIdNoKey, parseContentPosition

// EXTERNAL MODULE: ./src/utils/common.js
var common = __webpack_require__(57795);
;// CONCATENATED MODULE: ./src/utils/isBrowser.js
var isBrowser = "object" !== "undefined";

// EXTERNAL MODULE: ../node_modules/theme-ui/jsx-runtime/dist/theme-ui-jsx-runtime.esm.js + 2 modules
var theme_ui_jsx_runtime_esm = __webpack_require__(70863);
// EXTERNAL MODULE: ../node_modules/@theme-ui/components/dist/theme-ui-components.esm.js
var theme_ui_components_esm = __webpack_require__(62680);
;// CONCATENATED MODULE: ./src/utils/loading.jsx


// dynamic components loading component
var loading = function() {
    var minHeight = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        minHeight: 150
    }).minHeight;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
        variant: "flex.row.center",
        sx: {
            minHeight: minHeight,
            width: "100%"
        },
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Spinner */.$j, {})
        })
    });
};

;// CONCATENATED MODULE: ./src/utils/shopifySrcFilter.js
// Implements shopify image sizing, croping, scale and formatting
// @see: https://www.shopify.com/partners/blog/img-url-filter
var shopifySrcFilter = function(src, options) {
    if (!src) {
        console.warn("shopifySrcFilter requires an image src as first parameter");
        return "/svgs/noprecache/svg/default-image.svg";
    }
    var isShopify = src.includes("cdn.shopify.com");
    var isSizeable = /\.png|\.jpg|\.gif|\.jpeg|\.webp/.test(src);
    var hasCropping = /_x\d+\./.test(src);
    if (!isShopify || !isSizeable || hasCropping) {
        return src;
    }
    // src is from shopify's cdn and sizeable
    var width = options && options.width || null;
    var height = options && options.height || null;
    var crop = options && options.crop || "center"; // top, center, bottom, left, right
    var scale = options && options.scale || 2; // 2, 3
    var format = options && options.format || "pjpg"; // jpg, pjpg
    var isPJPG = format === "pjpg";
    var haveWidthOrHeight = width || height;
    if (!haveWidthOrHeight) {
        // nothing to resize
        return src;
    }
    var config = "";
    // sizing: width, height or both
    if (haveWidthOrHeight) {
        config = "_";
        if (width && height) {
            config = "".concat(config).concat(width, "x").concat(height);
        } else if (width) {
            config = "".concat(config).concat(width, "x");
        } else if (height) {
            config = "".concat(config, "x").concat(height);
        }
    }
    if (crop) {
        config = "".concat(config, "_crop_").concat(crop);
    }
    if (scale) {
        config = "".concat(config, "@").concat(scale, "x");
    }
    if (format && isPJPG) {
        config = "".concat(config, ".progressive");
    }
    return src.replace(/(.*)(\..*)(\?*)/, "$1".concat(config, "$2"));
};

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/react-intersection-observer/dist/index.mjs
var dist = __webpack_require__(38687);
// EXTERNAL MODULE: ./src/store/index.js + 12 modules
var store = __webpack_require__(27695);
;// CONCATENATED MODULE: ./src/utils/withInView.jsx







var defaultOptions = {
    rootMargin: "0px 0px 0px 0px",
    threshold: 1,
    trackVisibility: true,
    delay: 200
};
var withInView = function(SectionComp, options) {
    return function withInView(sectionProps) {
        var ref = (0,dist/* useInView */.YD)(options || defaultOptions), ref1 = ref.ref, inView = ref.inView, entry = ref.entry;
        var id = ((sectionProps === null || sectionProps === void 0 ? void 0 : sectionProps.cms) || {}).id;
        var updateSectionInView = (0,store/* useSetRecoilState */.Zl)(store/* default.sections */.ZP.sections(id));
        (0,react.useEffect)(function() {
            updateSectionInView({
                id: id,
                inView: inView,
                entry: entry,
                selector: 'section[data-comp-id="'.concat(id, '"]')
            });
        }, [
            inView,
            id
        ]);
        return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
            "data-comp": "section-inview",
            ref: ref1,
            sx: {
                width: "100%",
                height: "100%"
            },
            children: /*#__PURE__*/ (0,react.cloneElement)(/*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(SectionComp, {}), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sectionProps), {
                inView: inView,
                entry: entry
            }))
        });
    };
};

// EXTERNAL MODULE: ../node_modules/atob/browser-atob.js
var browser_atob = __webpack_require__(88981);
var browser_atob_default = /*#__PURE__*/__webpack_require__.n(browser_atob);
;// CONCATENATED MODULE: ./src/utils/getValidId.js

/**
 *
 * @param {string} value
 */ var isEncoded = function(value) {
    var regex = /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/;
    return regex.test(value);
};
/**
 *
 * @param {string} id
 */ var getValidId = function(id) {
    return isEncoded(id) ? browser_atob_default()(id).split("/").pop() : id.split("/").pop();
};
/**
 *
 * @param {string} id
 * @returns id number
 */ var getValidIdNoKey = function(id) {
    return getValidId(id).split("?")[0];
};
var getEncodedId = function(id) {
    return isEncoded(id) ? id : btoa(id);
};

;// CONCATENATED MODULE: ./src/utils/decodedId.js

var decodedId = function(id) {
    try {
        if (!id) return undefined;
        return browser_atob_default()(id);
    } catch (error) {
        return id;
    }
};

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(23842);
// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(59312);
;// CONCATENATED MODULE: ./src/utils/product.js


var fetchProductFromHandle = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(handle) {
        var endpoint, response, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    if (!handle) return [
                        2,
                        null
                    ];
                    endpoint = "/json/products/".concat(handle, ".json");
                    return [
                        4,
                        fetch(endpoint)
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
                case 3:
                    error = _state.sent();
                    console.error(error.message);
                    return [
                        2,
                        null
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchProductFromHandle(handle) {
        return _ref.apply(this, arguments);
    };
}();
var fetchProductsFromHandles = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(handles) {
        var productPromises;
        return (0,tslib_es6.__generator)(this, function(_state) {
            try {
                if (!Array.isArray(handles) || !(handles === null || handles === void 0 ? void 0 : handles.length)) return [
                    2,
                    []
                ];
                productPromises = handles.map(fetchProductFromHandle);
                return [
                    2,
                    Promise.all(productPromises)
                ];
            } catch (error) {
                console.error(error.message);
                return [
                    2,
                    []
                ];
            }
            return [
                2
            ];
        });
    });
    return function fetchProductsFromHandles(handles) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/utils/index.js












/***/ }),

/***/ 41528:
/***/ (function(module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.getDomainLocale = getDomainLocale;
var basePath = (/* unused pure expression or super */ null && ( false || ""));
function getDomainLocale(path, locale, locales, domainLocales) {
    if (false) { var finalLocale, proto, domain, target, detectDomainLocale, normalizeLocalePath; } else {
        return false;
    }
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=get-domain-locale.js.map


/***/ }),

/***/ 11453:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _slicedToArray = (__webpack_require__(69854)/* ["default"] */ .Z);
var _typeOf = (__webpack_require__(92271)["default"]);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _interop_require_default = (__webpack_require__(42619)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(90518)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(27378));
var _router = __webpack_require__(30194);
var _addLocale = __webpack_require__(24087);
var _routerContext = __webpack_require__(49756);
var _appRouterContext = __webpack_require__(82627);
var _useIntersection = __webpack_require__(41842);
var _getDomainLocale = __webpack_require__(41528);
var _addBasePath = __webpack_require__(91470);
"client";
var prefetched = {};
function prefetch(router, href, as, options) {
    if ( false || !router) return;
    if (!(0, _router).isLocalURL(href)) return;
    // Prefetch the JSON page if asked (only in the client)
    // We need to handle a prefetch error here since we may be
    // loading with priority which can reject but we don't
    // want to force navigation since this is only a prefetch
    Promise.resolve(router.prefetch(href, as, options)).catch(function(err) {
        if (false) {}
    });
    var curLocale = options && typeof options.locale !== "undefined" ? options.locale : router && router.locale;
    // Join on an invalid URI character
    prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")] = true;
}
function isModifiedEvent(event) {
    var target = event.currentTarget.target;
    return target && target !== "_self" || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}
function linkClicked(e, router, href, as, replace, shallow, scroll, locale, isAppRouter, prefetchEnabled) {
    var nodeName = e.currentTarget.nodeName;
    // anchors inside an svg have a lowercase nodeName
    var isAnchorNodeName = nodeName.toUpperCase() === "A";
    if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
        // ignore click for browser’s default behavior
        return;
    }
    e.preventDefault();
    var navigate = function() {
        // If the router is an NextRouter instance it will have `beforePopState`
        if ("beforePopState" in router) {
            router[replace ? "replace" : "push"](href, as, {
                shallow: shallow,
                locale: locale,
                scroll: scroll
            });
        } else {
            // If `beforePopState` doesn't exist on the router it's the AppRouter.
            var method = replace ? "replace" : "push";
            router[method](href, {
                forceOptimisticNavigation: !prefetchEnabled
            });
        }
    };
    if (isAppRouter) {
        // @ts-expect-error startTransition exists.
        _react.default.startTransition(navigate);
    } else {
        navigate();
    }
}
var Link = /*#__PURE__*/ _react.default.forwardRef(function LinkComponent(props, forwardedRef) {
    if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }
    var children;
    var hrefProp = props.href, asProp = props.as, childrenProp = props.children, prefetchProp = props.prefetch, passHref = props.passHref, replace = props.replace, shallow = props.shallow, scroll = props.scroll, locale = props.locale, onClick = props.onClick, onMouseEnter = props.onMouseEnter, onTouchStart = props.onTouchStart, _legacyBehavior = props.legacyBehavior, legacyBehavior = _legacyBehavior === void 0 ? Boolean(false) !== true : _legacyBehavior, restProps = _object_without_properties_loose(props, [
        "href",
        "as",
        "children",
        "prefetch",
        "passHref",
        "replace",
        "shallow",
        "scroll",
        "locale",
        "onClick",
        "onMouseEnter",
        "onTouchStart",
        "legacyBehavior"
    ]);
    children = childrenProp;
    if (legacyBehavior && (typeof children === "string" || typeof children === "number")) {
        children = /*#__PURE__*/ _react.default.createElement("a", null, children);
    }
    var p = prefetchProp !== false;
    var router = _react.default.useContext(_routerContext.RouterContext);
    // TODO-APP: type error. Remove `as any`
    var appRouter = _react.default.useContext(_appRouterContext.AppRouterContext);
    if (appRouter) {
        router = appRouter;
    }
    var ref = _react.default.useMemo(function() {
        var ref = _slicedToArray((0, _router).resolveHref(router, hrefProp, true), 2), resolvedHref = ref[0], resolvedAs = ref[1];
        return {
            href: resolvedHref,
            as: asProp ? (0, _router).resolveHref(router, asProp) : resolvedAs || resolvedHref
        };
    }, [
        router,
        hrefProp,
        asProp
    ]), href = ref.href, as = ref.as;
    var previousHref = _react.default.useRef(href);
    var previousAs = _react.default.useRef(as);
    // This will return the first child, if multiple are provided it will throw an error
    var child;
    if (legacyBehavior) {
        if (false) {} else {
            child = _react.default.Children.only(children);
        }
    }
    var childRef = legacyBehavior ? child && typeof child === "object" && child.ref : forwardedRef;
    var ref1 = _slicedToArray((0, _useIntersection).useIntersection({
        rootMargin: "200px"
    }), 3), setIntersectionRef = ref1[0], isVisible = ref1[1], resetVisible = ref1[2];
    var setRef = _react.default.useCallback(function(el) {
        // Before the link getting observed, check if visible state need to be reset
        if (previousAs.current !== as || previousHref.current !== href) {
            resetVisible();
            previousAs.current = as;
            previousHref.current = href;
        }
        setIntersectionRef(el);
        if (childRef) {
            if (typeof childRef === "function") childRef(el);
            else if (typeof childRef === "object") {
                childRef.current = el;
            }
        }
    }, [
        as,
        childRef,
        href,
        resetVisible,
        setIntersectionRef
    ]);
    _react.default.useEffect(function() {
        var shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        var isPrefetched = prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")];
        if (shouldPrefetch && !isPrefetched) {
            prefetch(router, href, as, {
                locale: curLocale
            });
        }
    }, [
        as,
        href,
        isVisible,
        locale,
        p,
        router
    ]);
    var childProps = {
        ref: setRef,
        onClick: function(e) {
            if (false) {}
            if (!legacyBehavior && typeof onClick === "function") {
                onClick(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onClick === "function") {
                child.props.onClick(e);
            }
            if (!e.defaultPrevented) {
                linkClicked(e, router, href, as, replace, shallow, scroll, locale, Boolean(appRouter), p);
            }
        },
        onMouseEnter: function(e) {
            if (!legacyBehavior && typeof onMouseEnter === "function") {
                onMouseEnter(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onMouseEnter === "function") {
                child.props.onMouseEnter(e);
            }
            // Check for not prefetch disabled in page using appRouter
            if (!(!p && appRouter)) {
                if ((0, _router).isLocalURL(href)) {
                    prefetch(router, href, as, {
                        priority: true
                    });
                }
            }
        },
        onTouchStart: function(e) {
            if (!legacyBehavior && typeof onTouchStart === "function") {
                onTouchStart(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onTouchStart === "function") {
                child.props.onTouchStart(e);
            }
            // Check for not prefetch disabled in page using appRouter
            if (!(!p && appRouter)) {
                if ((0, _router).isLocalURL(href)) {
                    prefetch(router, href, as, {
                        priority: true
                    });
                }
            }
        }
    };
    // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
    // defined, we specify the current 'href', so that repetition is not needed by the user
    if (!legacyBehavior || passHref || child.type === "a" && !("href" in child.props)) {
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        // we only render domain locales if we are currently on a domain locale
        // so that locale links are still visitable in development/preview envs
        var localeDomain = router && router.isLocaleDomain && (0, _getDomainLocale).getDomainLocale(as, curLocale, router.locales, router.domainLocales);
        childProps.href = localeDomain || (0, _addBasePath).addBasePath((0, _addLocale).addLocale(as, curLocale, router && router.defaultLocale));
    }
    return legacyBehavior ? /*#__PURE__*/ _react.default.cloneElement(child, childProps) : /*#__PURE__*/ _react.default.createElement("a", Object.assign({}, restProps, childProps), children);
});
var _default = Link;
exports["default"] = _default;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=link.js.map


/***/ }),

/***/ 41842:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _slicedToArray = (__webpack_require__(69854)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.useIntersection = useIntersection;
var _react = __webpack_require__(27378);
var _requestIdleCallback = __webpack_require__(72878);
var hasIntersectionObserver = typeof IntersectionObserver === "function";
var observers = new Map();
var idList = [];
function createObserver(options) {
    var id = {
        root: options.root || null,
        margin: options.rootMargin || ""
    };
    var existing = idList.find(function(obj) {
        return obj.root === id.root && obj.margin === id.margin;
    });
    var instance;
    if (existing) {
        instance = observers.get(existing);
        if (instance) {
            return instance;
        }
    }
    var elements = new Map();
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            var callback = elements.get(entry.target);
            var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;
            if (callback && isVisible) {
                callback(isVisible);
            }
        });
    }, options);
    instance = {
        id: id,
        observer: observer,
        elements: elements
    };
    idList.push(id);
    observers.set(id, instance);
    return instance;
}
function observe(element, callback, options) {
    var ref = createObserver(options), id = ref.id, observer = ref.observer, elements = ref.elements;
    elements.set(element, callback);
    observer.observe(element);
    return function unobserve() {
        elements.delete(element);
        observer.unobserve(element);
        // Destroy observer when there's nothing left to watch:
        if (elements.size === 0) {
            observer.disconnect();
            observers.delete(id);
            var index = idList.findIndex(function(obj) {
                return obj.root === id.root && obj.margin === id.margin;
            });
            if (index > -1) {
                idList.splice(index, 1);
            }
        }
    };
}
function useIntersection(param) {
    var rootRef = param.rootRef, rootMargin = param.rootMargin, disabled = param.disabled;
    var isDisabled = disabled || !hasIntersectionObserver;
    var ref = _slicedToArray((0, _react).useState(false), 2), visible = ref[0], setVisible = ref[1];
    var ref1 = _slicedToArray((0, _react).useState(null), 2), element = ref1[0], setElement = ref1[1];
    (0, _react).useEffect(function() {
        if (hasIntersectionObserver) {
            if (isDisabled || visible) return;
            if (element && element.tagName) {
                var unobserve = observe(element, function(isVisible) {
                    return isVisible && setVisible(isVisible);
                }, {
                    root: rootRef == null ? void 0 : rootRef.current,
                    rootMargin: rootMargin
                });
                return unobserve;
            }
        } else {
            if (!visible) {
                var idleCallback = (0, _requestIdleCallback).requestIdleCallback(function() {
                    return setVisible(true);
                });
                return function() {
                    return (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
                };
            }
        }
    }, [
        element,
        isDisabled,
        rootMargin,
        rootRef,
        visible
    ]);
    var resetVisible = (0, _react).useCallback(function() {
        setVisible(false);
    }, []);
    return [
        setElement,
        visible,
        resetVisible
    ];
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=use-intersection.js.map


/***/ }),

/***/ 82627:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.TemplateContext = exports.GlobalLayoutRouterContext = exports.LayoutRouterContext = exports.AppRouterContext = void 0;
var _interop_require_default = (__webpack_require__(42619)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(27378));
var AppRouterContext = _react.default.createContext(null);
exports.AppRouterContext = AppRouterContext;
var LayoutRouterContext = _react.default.createContext(null);
exports.LayoutRouterContext = LayoutRouterContext;
var GlobalLayoutRouterContext = _react.default.createContext(null);
exports.GlobalLayoutRouterContext = GlobalLayoutRouterContext;
var TemplateContext = _react.default.createContext(null);
exports.TemplateContext = TemplateContext;
if (false) {} //# sourceMappingURL=app-router-context.js.map


/***/ }),

/***/ 29906:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _instanceof = (__webpack_require__(13210)/* ["default"] */ .Z);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(76516)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(42619)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(27378));
var _loadable = _interop_require_default(__webpack_require__(62456));
function dynamic(dynamicOptions, options) {
    var loadableFn = _loadable.default;
    var loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: function(param) {
            var error = param.error, isLoading = param.isLoading, pastDelay = param.pastDelay;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (_instanceof(dynamicOptions, Promise)) {
        loadableOptions.loader = function() {
            return dynamicOptions;
        };
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if (false) {}
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
"client";
var isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    var Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return function() {
        return /*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
    };
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 37815:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(42619)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(27378));
var LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 62456:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _classCallCheck = (__webpack_require__(30093)/* ["default"] */ .Z);
var _createClass = (__webpack_require__(27758)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(76516)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(42619)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(27378));
var _loadableContext = __webpack_require__(37815);
var useSyncExternalStore = ( true ? __webpack_require__(27378) : 0).useSyncExternalStore;
var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;
function load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    var init = function init() {
        if (!subscription) {
            var sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    };
    var useLoadableModule = function useLoadableModule() {
        init();
        var context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach(function(moduleName) {
                context(moduleName);
            });
        }
    };
    var LoadableImpl = function LoadableImpl(props, ref) {
        useLoadableModule();
        var state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, function() {
            return {
                retry: subscription.retry
            };
        }, []);
        return _react.default.useMemo(function() {
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    };
    var LazyImpl = function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref: ref
        }));
    };
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ var subscription = null;
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        var moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push(function(ids) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = moduleIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var moduleId = _step.value;
                        if (ids.indexOf(moduleId) !== -1) {
                            return init();
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        }
    }
    var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = function() {
        return init();
    };
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
var LoadableSubscription = /*#__PURE__*/ function() {
    function LoadableSubscription(loadFn, opts) {
        _classCallCheck(this, LoadableSubscription);
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
    _createClass(LoadableSubscription, [
        {
            key: "promise",
            value: function promise() {
                return this._res.promise;
            }
        },
        {
            key: "retry",
            value: function retry() {
                var _this = this;
                this._clearTimeouts();
                this._res = this._loadFn(this._opts.loader);
                this._state = {
                    pastDelay: false,
                    timedOut: false
                };
                var ref = this, res = ref._res, opts = ref._opts;
                if (res.loading) {
                    if (typeof opts.delay === "number") {
                        if (opts.delay === 0) {
                            this._state.pastDelay = true;
                        } else {
                            this._delay = setTimeout(function() {
                                _this._update({
                                    pastDelay: true
                                });
                            }, opts.delay);
                        }
                    }
                    if (typeof opts.timeout === "number") {
                        this._timeout = setTimeout(function() {
                            _this._update({
                                timedOut: true
                            });
                        }, opts.timeout);
                    }
                }
                this._res.promise.then(function() {
                    _this._update({});
                    _this._clearTimeouts();
                }).catch(function(_err) {
                    _this._update({});
                    _this._clearTimeouts();
                });
                this._update({});
            }
        },
        {
            key: "_update",
            value: function _update(partial) {
                this._state = _extends({}, this._state, {
                    error: this._res.error,
                    loaded: this._res.loaded,
                    loading: this._res.loading
                }, partial);
                this._callbacks.forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: "_clearTimeouts",
            value: function _clearTimeouts() {
                clearTimeout(this._delay);
                clearTimeout(this._timeout);
            }
        },
        {
            key: "getCurrentValue",
            value: function getCurrentValue() {
                return this._state;
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                var _this = this;
                this._callbacks.add(callback);
                return function() {
                    _this._callbacks.delete(callback);
                };
            }
        }
    ]);
    return LoadableSubscription;
}();
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = function() {
    return new Promise(function(resolveInitializers, reject) {
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    var ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise(function(resolvePreload) {
        var res = function() {
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 59348:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;
/* provided dependency */ var process = __webpack_require__(14284);
var React = __webpack_require__(27378);
function _interopDefaultLegacy(e) {
    return e && typeof e === "object" && "default" in e ? e : {
        "default": e
    };
}
var React__default = /*#__PURE__*/ _interopDefaultLegacy(React);
/*
Based on Glamor's sheet
https://github.com/threepointone/glamor/blob/667b480d31b3721a905021b26e1290ce92ca2879/src/sheet.js
*/ function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
var isProd = typeof process !== "undefined" && process.env && "production" === "production";
var isString = function isString(o) {
    return Object.prototype.toString.call(o) === "[object String]";
};
var StyleSheet = /*#__PURE__*/ function() {
    var StyleSheet = function StyleSheet(param) {
        var ref = param === void 0 ? {} : param, _name = ref.name, name = _name === void 0 ? "stylesheet" : _name, _optimizeForSpeed = ref.optimizeForSpeed, optimizeForSpeed = _optimizeForSpeed === void 0 ? isProd : _optimizeForSpeed;
        invariant$1(isString(name), "`name` must be a string");
        this._name = name;
        this._deletedRulePlaceholder = "#" + name + "-deleted-rule____{}";
        invariant$1(typeof optimizeForSpeed === "boolean", "`optimizeForSpeed` must be a boolean");
        this._optimizeForSpeed = optimizeForSpeed;
        this._serverSheet = undefined;
        this._tags = [];
        this._injected = false;
        this._rulesCount = 0;
        var node =  true && document.querySelector('meta[property="csp-nonce"]');
        this._nonce = node ? node.getAttribute("content") : null;
    };
    var _proto = StyleSheet.prototype;
    _proto.setOptimizeForSpeed = function setOptimizeForSpeed(bool) {
        invariant$1(typeof bool === "boolean", "`setOptimizeForSpeed` accepts a boolean");
        invariant$1(this._rulesCount === 0, "optimizeForSpeed cannot be when rules have already been inserted");
        this.flush();
        this._optimizeForSpeed = bool;
        this.inject();
    };
    _proto.isOptimizeForSpeed = function isOptimizeForSpeed() {
        return this._optimizeForSpeed;
    };
    _proto.inject = function inject() {
        var _this = this;
        invariant$1(!this._injected, "sheet already injected");
        this._injected = true;
        if ( true && this._optimizeForSpeed) {
            this._tags[0] = this.makeStyleTag(this._name);
            this._optimizeForSpeed = "insertRule" in this.getSheet();
            if (!this._optimizeForSpeed) {
                if (!isProd) {
                    console.warn("StyleSheet: optimizeForSpeed mode not supported falling back to standard mode.");
                }
                this.flush();
                this._injected = true;
            }
            return;
        }
        this._serverSheet = {
            cssRules: [],
            insertRule: function insertRule(rule, index) {
                if (typeof index === "number") {
                    _this._serverSheet.cssRules[index] = {
                        cssText: rule
                    };
                } else {
                    _this._serverSheet.cssRules.push({
                        cssText: rule
                    });
                }
                return index;
            },
            deleteRule: function deleteRule(index) {
                _this._serverSheet.cssRules[index] = null;
            }
        };
    };
    _proto.getSheetForTag = function getSheetForTag(tag) {
        if (tag.sheet) {
            return tag.sheet;
        }
        // this weirdness brought to you by firefox
        for(var i = 0; i < document.styleSheets.length; i++){
            if (document.styleSheets[i].ownerNode === tag) {
                return document.styleSheets[i];
            }
        }
    };
    _proto.getSheet = function getSheet() {
        return this.getSheetForTag(this._tags[this._tags.length - 1]);
    };
    _proto.insertRule = function insertRule(rule, index) {
        invariant$1(isString(rule), "`insertRule` accepts only strings");
        if (false) {}
        if (this._optimizeForSpeed) {
            var sheet = this.getSheet();
            if (typeof index !== "number") {
                index = sheet.cssRules.length;
            }
            // this weirdness for perf, and chrome's weird bug
            // https://stackoverflow.com/questions/20007992/chrome-suddenly-stopped-accepting-insertrule
            try {
                sheet.insertRule(rule, index);
            } catch (error) {
                if (!isProd) {
                    console.warn("StyleSheet: illegal rule: \n\n" + rule + "\n\nSee https://stackoverflow.com/q/20007992 for more info");
                }
                return -1;
            }
        } else {
            var insertionPoint = this._tags[index];
            this._tags.push(this.makeStyleTag(this._name, rule, insertionPoint));
        }
        return this._rulesCount++;
    };
    _proto.replaceRule = function replaceRule(index, rule) {
        if (this._optimizeForSpeed || "object" === "undefined") {
            var sheet =  true ? this.getSheet() : 0;
            if (!rule.trim()) {
                rule = this._deletedRulePlaceholder;
            }
            if (!sheet.cssRules[index]) {
                // @TBD Should we throw an error?
                return index;
            }
            sheet.deleteRule(index);
            try {
                sheet.insertRule(rule, index);
            } catch (error) {
                if (!isProd) {
                    console.warn("StyleSheet: illegal rule: \n\n" + rule + "\n\nSee https://stackoverflow.com/q/20007992 for more info");
                }
                // In order to preserve the indices we insert a deleteRulePlaceholder
                sheet.insertRule(this._deletedRulePlaceholder, index);
            }
        } else {
            var tag = this._tags[index];
            invariant$1(tag, "old rule at index `" + index + "` not found");
            tag.textContent = rule;
        }
        return index;
    };
    _proto.deleteRule = function deleteRule(index) {
        if (false) {}
        if (this._optimizeForSpeed) {
            this.replaceRule(index, "");
        } else {
            var tag = this._tags[index];
            invariant$1(tag, "rule at index `" + index + "` not found");
            tag.parentNode.removeChild(tag);
            this._tags[index] = null;
        }
    };
    _proto.flush = function flush() {
        this._injected = false;
        this._rulesCount = 0;
        if (true) {
            this._tags.forEach(function(tag) {
                return tag && tag.parentNode.removeChild(tag);
            });
            this._tags = [];
        } else {}
    };
    _proto.cssRules = function cssRules() {
        var _this = this;
        if (false) {}
        return this._tags.reduce(function(rules, tag) {
            if (tag) {
                rules = rules.concat(Array.prototype.map.call(_this.getSheetForTag(tag).cssRules, function(rule) {
                    return rule.cssText === _this._deletedRulePlaceholder ? null : rule;
                }));
            } else {
                rules.push(null);
            }
            return rules;
        }, []);
    };
    _proto.makeStyleTag = function makeStyleTag(name, cssString, relativeToTag) {
        if (cssString) {
            invariant$1(isString(cssString), "makeStyleTag accepts only strings as second parameter");
        }
        var tag = document.createElement("style");
        if (this._nonce) tag.setAttribute("nonce", this._nonce);
        tag.type = "text/css";
        tag.setAttribute("data-" + name, "");
        if (cssString) {
            tag.appendChild(document.createTextNode(cssString));
        }
        var head = document.head || document.getElementsByTagName("head")[0];
        if (relativeToTag) {
            head.insertBefore(tag, relativeToTag);
        } else {
            head.appendChild(tag);
        }
        return tag;
    };
    _createClass(StyleSheet, [
        {
            key: "length",
            get: function get() {
                return this._rulesCount;
            }
        }
    ]);
    return StyleSheet;
}();
function invariant$1(condition, message) {
    if (!condition) {
        throw new Error("StyleSheet: " + message + ".");
    }
}
function hash(str) {
    var _$hash = 5381, i = str.length;
    while(i){
        _$hash = _$hash * 33 ^ str.charCodeAt(--i);
    }
    /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
   * integers. Since we want the results to be always positive, convert the
   * signed int to an unsigned by doing an unsigned bitshift. */ return _$hash >>> 0;
}
var stringHash = hash;
var sanitize = function sanitize(rule) {
    return rule.replace(/\/style/gi, "\\/style");
};
var cache = {};
/**
 * computeId
 *
 * Compute and memoize a jsx id from a basedId and optionally props.
 */ function computeId(baseId, props) {
    if (!props) {
        return "jsx-" + baseId;
    }
    var propsToString = String(props);
    var key = baseId + propsToString;
    if (!cache[key]) {
        cache[key] = "jsx-" + stringHash(baseId + "-" + propsToString);
    }
    return cache[key];
}
/**
 * computeSelector
 *
 * Compute and memoize dynamic selectors.
 */ function computeSelector(id, css) {
    var selectoPlaceholderRegexp = /__jsx-style-dynamic-selector/g;
    // Sanitize SSR-ed CSS.
    // Client side code doesn't need to be sanitized since we use
    // document.createTextNode (dev) and the CSSOM api sheet.insertRule (prod).
    if (false) {}
    var idcss = id + css;
    if (!cache[idcss]) {
        cache[idcss] = css.replace(selectoPlaceholderRegexp, id);
    }
    return cache[idcss];
}
function mapRulesToStyle(cssRules, options) {
    if (options === void 0) options = {};
    return cssRules.map(function(args) {
        var id = args[0];
        var css = args[1];
        return /*#__PURE__*/ React__default["default"].createElement("style", {
            id: "__" + id,
            // Avoid warnings upon render with a key
            key: "__" + id,
            nonce: options.nonce ? options.nonce : undefined,
            dangerouslySetInnerHTML: {
                __html: css
            }
        });
    });
}
var StyleSheetRegistry = /*#__PURE__*/ function() {
    var StyleSheetRegistry = function StyleSheetRegistry(param) {
        var ref = param === void 0 ? {} : param, _styleSheet = ref.styleSheet, styleSheet = _styleSheet === void 0 ? null : _styleSheet, _optimizeForSpeed = ref.optimizeForSpeed, optimizeForSpeed = _optimizeForSpeed === void 0 ? false : _optimizeForSpeed;
        this._sheet = styleSheet || new StyleSheet({
            name: "styled-jsx",
            optimizeForSpeed: optimizeForSpeed
        });
        this._sheet.inject();
        if (styleSheet && typeof optimizeForSpeed === "boolean") {
            this._sheet.setOptimizeForSpeed(optimizeForSpeed);
            this._optimizeForSpeed = this._sheet.isOptimizeForSpeed();
        }
        this._fromServer = undefined;
        this._indices = {};
        this._instancesCounts = {};
    };
    var _proto = StyleSheetRegistry.prototype;
    _proto.add = function add(props) {
        var _this = this;
        if (undefined === this._optimizeForSpeed) {
            this._optimizeForSpeed = Array.isArray(props.children);
            this._sheet.setOptimizeForSpeed(this._optimizeForSpeed);
            this._optimizeForSpeed = this._sheet.isOptimizeForSpeed();
        }
        if ( true && !this._fromServer) {
            this._fromServer = this.selectFromServer();
            this._instancesCounts = Object.keys(this._fromServer).reduce(function(acc, tagName) {
                acc[tagName] = 0;
                return acc;
            }, {});
        }
        var ref = this.getIdAndRules(props), styleId = ref.styleId, rules = ref.rules;
        // Deduping: just increase the instances count.
        if (styleId in this._instancesCounts) {
            this._instancesCounts[styleId] += 1;
            return;
        }
        var indices = rules.map(function(rule) {
            return _this._sheet.insertRule(rule);
        }) // Filter out invalid rules
        .filter(function(index) {
            return index !== -1;
        });
        this._indices[styleId] = indices;
        this._instancesCounts[styleId] = 1;
    };
    _proto.remove = function remove(props) {
        var _this = this;
        var styleId = this.getIdAndRules(props).styleId;
        invariant(styleId in this._instancesCounts, "styleId: `" + styleId + "` not found");
        this._instancesCounts[styleId] -= 1;
        if (this._instancesCounts[styleId] < 1) {
            var tagFromServer = this._fromServer && this._fromServer[styleId];
            if (tagFromServer) {
                tagFromServer.parentNode.removeChild(tagFromServer);
                delete this._fromServer[styleId];
            } else {
                this._indices[styleId].forEach(function(index) {
                    return _this._sheet.deleteRule(index);
                });
                delete this._indices[styleId];
            }
            delete this._instancesCounts[styleId];
        }
    };
    _proto.update = function update(props, nextProps) {
        this.add(nextProps);
        this.remove(props);
    };
    _proto.flush = function flush() {
        this._sheet.flush();
        this._sheet.inject();
        this._fromServer = undefined;
        this._indices = {};
        this._instancesCounts = {};
    };
    _proto.cssRules = function cssRules() {
        var _this = this;
        var fromServer = this._fromServer ? Object.keys(this._fromServer).map(function(styleId) {
            return [
                styleId,
                _this._fromServer[styleId]
            ];
        }) : [];
        var cssRules1 = this._sheet.cssRules();
        return fromServer.concat(Object.keys(this._indices).map(function(styleId) {
            return [
                styleId,
                _this._indices[styleId].map(function(index) {
                    return cssRules1[index].cssText;
                }).join(_this._optimizeForSpeed ? "" : "\n")
            ];
        }) // filter out empty rules
        .filter(function(rule) {
            return Boolean(rule[1]);
        }));
    };
    _proto.styles = function styles(options) {
        return mapRulesToStyle(this.cssRules(), options);
    };
    _proto.getIdAndRules = function getIdAndRules(props) {
        var css = props.children, dynamic = props.dynamic, id = props.id;
        if (dynamic) {
            var styleId = computeId(id, dynamic);
            return {
                styleId: styleId,
                rules: Array.isArray(css) ? css.map(function(rule) {
                    return computeSelector(styleId, rule);
                }) : [
                    computeSelector(styleId, css)
                ]
            };
        }
        return {
            styleId: computeId(id),
            rules: Array.isArray(css) ? css : [
                css
            ]
        };
    };
    /**
   * selectFromServer
   *
   * Collects style tags from the document with id __jsx-XXX
   */ _proto.selectFromServer = function selectFromServer() {
        var elements = Array.prototype.slice.call(document.querySelectorAll('[id^="__jsx-"]'));
        return elements.reduce(function(acc, element) {
            var id = element.id.slice(2);
            acc[id] = element;
            return acc;
        }, {});
    };
    return StyleSheetRegistry;
}();
function invariant(condition, message) {
    if (!condition) {
        throw new Error("StyleSheetRegistry: " + message + ".");
    }
}
var StyleSheetContext = /*#__PURE__*/ React.createContext(null);
StyleSheetContext.displayName = "StyleSheetContext";
function createStyleRegistry() {
    return new StyleSheetRegistry();
}
function StyleRegistry(param) {
    var configuredRegistry = param.registry, children = param.children;
    var rootRegistry = React.useContext(StyleSheetContext);
    var ref = React.useState(function() {
        return rootRegistry || configuredRegistry || createStyleRegistry();
    }), registry = ref[0];
    return /*#__PURE__*/ React__default["default"].createElement(StyleSheetContext.Provider, {
        value: registry
    }, children);
}
function useStyleRegistry() {
    return React.useContext(StyleSheetContext);
}
// Opt-into the new `useInsertionEffect` API in React 18, fallback to `useLayoutEffect`.
// https://github.com/reactwg/react-18/discussions/110
var useInsertionEffect = React__default["default"].useInsertionEffect || React__default["default"].useLayoutEffect;
var defaultRegistry =  true ? createStyleRegistry() : 0;
function JSXStyle(props) {
    var registry = defaultRegistry ? defaultRegistry : useStyleRegistry();
    // If `registry` does not exist, we do nothing here.
    if (!registry) {
        return null;
    }
    if (false) {}
    useInsertionEffect(function() {
        registry.add(props);
        return function() {
            registry.remove(props);
        };
    // props.children can be string[], will be striped since id is identical
    }, [
        props.id,
        String(props.dynamic)
    ]);
    return null;
}
JSXStyle.dynamic = function(info) {
    return info.map(function(tagInfo) {
        var baseId = tagInfo[0];
        var props = tagInfo[1];
        return computeId(baseId, props);
    }).join(" ");
};
__webpack_unused_export__ = StyleRegistry;
__webpack_unused_export__ = createStyleRegistry;
exports.style = JSXStyle;
__webpack_unused_export__ = useStyleRegistry;


/***/ }),

/***/ 14722:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

module.exports = __webpack_require__(59348).style;


/***/ }),

/***/ 11218:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"skeletonBox":"PageErrorBoundary_skeletonBox__RAWh4","shimmer":"PageErrorBoundary_shimmer__7u3Mk"};

/***/ }),

/***/ 35309:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"PreviewModeToast_container__uXpwm","message":"PreviewModeToast_message___V_Uy"};

/***/ }),

/***/ 34386:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__lbC1D","spin":"Spinner_spin__rcHsC"};

/***/ }),

/***/ 31307:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 66118:
/***/ (function(module) {

var __dirname = "/";
(function(){var e={229:function(e){var t=e.exports={};var r;var n;function defaultSetTimout(){throw new Error("setTimeout has not been defined")}function defaultClearTimeout(){throw new Error("clearTimeout has not been defined")}(function(){try{if(typeof setTimeout==="function"){r=setTimeout}else{r=defaultSetTimout}}catch(e){r=defaultSetTimout}try{if(typeof clearTimeout==="function"){n=clearTimeout}else{n=defaultClearTimeout}}catch(e){n=defaultClearTimeout}})();function runTimeout(e){if(r===setTimeout){return setTimeout(e,0)}if((r===defaultSetTimout||!r)&&setTimeout){r=setTimeout;return setTimeout(e,0)}try{return r(e,0)}catch(t){try{return r.call(null,e,0)}catch(t){return r.call(this,e,0)}}}function runClearTimeout(e){if(n===clearTimeout){return clearTimeout(e)}if((n===defaultClearTimeout||!n)&&clearTimeout){n=clearTimeout;return clearTimeout(e)}try{return n(e)}catch(t){try{return n.call(null,e)}catch(t){return n.call(this,e)}}}var i=[];var o=false;var u;var a=-1;function cleanUpNextTick(){if(!o||!u){return}o=false;if(u.length){i=u.concat(i)}else{a=-1}if(i.length){drainQueue()}}function drainQueue(){if(o){return}var e=runTimeout(cleanUpNextTick);o=true;var t=i.length;while(t){u=i;i=[];while(++a<t){if(u){u[a].run()}}a=-1;t=i.length}u=null;o=false;runClearTimeout(e)}t.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1){for(var r=1;r<arguments.length;r++){t[r-1]=arguments[r]}}i.push(new Item(e,t));if(i.length===1&&!o){runTimeout(drainQueue)}};function Item(e,t){this.fun=e;this.array=t}Item.prototype.run=function(){this.fun.apply(null,this.array)};t.title="browser";t.browser=true;t.env={};t.argv=[];t.version="";t.versions={};function noop(){}t.on=noop;t.addListener=noop;t.once=noop;t.off=noop;t.removeListener=noop;t.removeAllListeners=noop;t.emit=noop;t.prependListener=noop;t.prependOnceListener=noop;t.listeners=function(e){return[]};t.binding=function(e){throw new Error("process.binding is not supported")};t.cwd=function(){return"/"};t.chdir=function(e){throw new Error("process.chdir is not supported")};t.umask=function(){return 0}}};var t={};function __nccwpck_require__(r){var n=t[r];if(n!==undefined){return n.exports}var i=t[r]={exports:{}};var o=true;try{e[r](i,i.exports,__nccwpck_require__);o=false}finally{if(o)delete t[r]}return i.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r=__nccwpck_require__(229);module.exports=r})();

/***/ }),

/***/ 65218:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(29906)


/***/ }),

/***/ 88038:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(80555)


/***/ }),

/***/ 79894:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(11453)


/***/ }),

/***/ 86677:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(15817)


/***/ }),

/***/ 43218:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(17162)


/***/ }),

/***/ 47468:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "B": function() { return /* binding */ noCase; }
});

;// CONCATENATED MODULE: ../node_modules/lower-case/dist.es2015/index.js
/**
 * Source: ftp://ftp.unicode.org/Public/UCD/latest/ucd/SpecialCasing.txt
 */
var SUPPORTED_LOCALE = {
    tr: {
        regexp: /\u0130|\u0049|\u0049\u0307/g,
        map: {
            İ: "\u0069",
            I: "\u0131",
            İ: "\u0069",
        },
    },
    az: {
        regexp: /\u0130/g,
        map: {
            İ: "\u0069",
            I: "\u0131",
            İ: "\u0069",
        },
    },
    lt: {
        regexp: /\u0049|\u004A|\u012E|\u00CC|\u00CD|\u0128/g,
        map: {
            I: "\u0069\u0307",
            J: "\u006A\u0307",
            Į: "\u012F\u0307",
            Ì: "\u0069\u0307\u0300",
            Í: "\u0069\u0307\u0301",
            Ĩ: "\u0069\u0307\u0303",
        },
    },
};
/**
 * Localized lower case.
 */
function localeLowerCase(str, locale) {
    var lang = SUPPORTED_LOCALE[locale.toLowerCase()];
    if (lang)
        return lowerCase(str.replace(lang.regexp, function (m) { return lang.map[m]; }));
    return lowerCase(str);
}
/**
 * Lower case as a function.
 */
function lowerCase(str) {
    return str.toLowerCase();
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/no-case/dist.es2015/index.js

// Support camel case ("camelCase" -> "camel Case" and "CAMELCase" -> "CAMEL Case").
var DEFAULT_SPLIT_REGEXP = [/([a-z0-9])([A-Z])/g, /([A-Z])([A-Z][a-z])/g];
// Remove all non-word characters.
var DEFAULT_STRIP_REGEXP = /[^A-Z0-9]+/gi;
/**
 * Normalize the string into something other libraries can manipulate easier.
 */
function noCase(input, options) {
    if (options === void 0) { options = {}; }
    var _a = options.splitRegexp, splitRegexp = _a === void 0 ? DEFAULT_SPLIT_REGEXP : _a, _b = options.stripRegexp, stripRegexp = _b === void 0 ? DEFAULT_STRIP_REGEXP : _b, _c = options.transform, transform = _c === void 0 ? lowerCase : _c, _d = options.delimiter, delimiter = _d === void 0 ? " " : _d;
    var result = replace(replace(input, splitRegexp, "$1\0$2"), stripRegexp, "\0");
    var start = 0;
    var end = result.length;
    // Trim the delimiter from around the output string.
    while (result.charAt(start) === "\0")
        start++;
    while (result.charAt(end - 1) === "\0")
        end--;
    // Transform each token independently.
    return result.slice(start, end).split("\0").map(transform).join(delimiter);
}
/**
 * Replace `re` in the input string with the replacement value.
 */
function replace(input, re, value) {
    if (re instanceof RegExp)
        return input.replace(re, value);
    return re.reduce(function (input, re) { return input.replace(re, value); }, input);
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 27526:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ho": function() { return /* binding */ pascalCase; }
/* harmony export */ });
/* unused harmony exports pascalCaseTransform, pascalCaseTransformMerge */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59312);
/* harmony import */ var no_case__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47468);


function pascalCaseTransform(input, index) {
    var firstChar = input.charAt(0);
    var lowerChars = input.substr(1).toLowerCase();
    if (index > 0 && firstChar >= "0" && firstChar <= "9") {
        return "_" + firstChar + lowerChars;
    }
    return "" + firstChar.toUpperCase() + lowerChars;
}
function pascalCaseTransformMerge(input) {
    return input.charAt(0).toUpperCase() + input.slice(1).toLowerCase();
}
function pascalCase(input, options) {
    if (options === void 0) { options = {}; }
    return (0,no_case__WEBPACK_IMPORTED_MODULE_0__/* .noCase */ .B)(input, (0,tslib__WEBPACK_IMPORTED_MODULE_1__.__assign)({ delimiter: "", transform: pascalCaseTransform }, options));
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 97221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ErrorCode": function() { return /* reexport */ ErrorCode; },
  "connectToChild": function() { return /* reexport */ connectToChild; },
  "connectToParent": function() { return /* reexport */ connectToParent; }
});

;// CONCATENATED MODULE: ../node_modules/penpal/lib/enums.js
var MessageType;
(function (MessageType) {
    MessageType["Call"] = "call";
    MessageType["Reply"] = "reply";
    MessageType["Syn"] = "syn";
    MessageType["SynAck"] = "synAck";
    MessageType["Ack"] = "ack";
})(MessageType || (MessageType = {}));
var Resolution;
(function (Resolution) {
    Resolution["Fulfilled"] = "fulfilled";
    Resolution["Rejected"] = "rejected";
})(Resolution || (Resolution = {}));
var ErrorCode;
(function (ErrorCode) {
    ErrorCode["ConnectionDestroyed"] = "ConnectionDestroyed";
    ErrorCode["ConnectionTimeout"] = "ConnectionTimeout";
    ErrorCode["NoIframeSrc"] = "NoIframeSrc";
})(ErrorCode || (ErrorCode = {}));
var NativeErrorName;
(function (NativeErrorName) {
    NativeErrorName["DataCloneError"] = "DataCloneError";
})(NativeErrorName || (NativeErrorName = {}));
var NativeEventType;
(function (NativeEventType) {
    NativeEventType["Message"] = "message";
})(NativeEventType || (NativeEventType = {}));

;// CONCATENATED MODULE: ../node_modules/penpal/lib/createDestructor.js
/* harmony default export */ var createDestructor = ((localName, log) => {
    const callbacks = [];
    let destroyed = false;
    return {
        destroy(error) {
            if (!destroyed) {
                destroyed = true;
                log(`${localName}: Destroying connection`);
                callbacks.forEach((callback) => {
                    callback(error);
                });
            }
        },
        onDestroy(callback) {
            destroyed ? callback() : callbacks.push(callback);
        },
    };
});

;// CONCATENATED MODULE: ../node_modules/penpal/lib/createLogger.js
/* harmony default export */ var createLogger = ((debug) => {
    /**
     * Logs a message if debug is enabled.
     */
    return (...args) => {
        if (debug) {
            console.log('[Penpal]', ...args); // eslint-disable-line no-console
        }
    };
});

;// CONCATENATED MODULE: ../node_modules/penpal/lib/parent/getOriginFromSrc.js
const DEFAULT_PORT_BY_PROTOCOL = {
    'http:': '80',
    'https:': '443',
};
const URL_REGEX = /^(https?:)?\/\/([^/:]+)?(:(\d+))?/;
const opaqueOriginSchemes = ['file:', 'data:'];
/**
 * Converts a src value into an origin.
 */
/* harmony default export */ var getOriginFromSrc = ((src) => {
    if (src && opaqueOriginSchemes.find((scheme) => src.startsWith(scheme))) {
        // The origin of the child document is an opaque origin and its
        // serialization is "null"
        // https://html.spec.whatwg.org/multipage/origin.html#origin
        return 'null';
    }
    // Note that if src is undefined, then srcdoc is being used instead of src
    // and we can follow this same logic below to get the origin of the parent,
    // which is the origin that we will need to use.
    const location = document.location;
    const regexResult = URL_REGEX.exec(src);
    let protocol;
    let hostname;
    let port;
    if (regexResult) {
        // It's an absolute URL. Use the parsed info.
        // regexResult[1] will be undefined if the URL starts with //
        protocol = regexResult[1] ? regexResult[1] : location.protocol;
        hostname = regexResult[2];
        port = regexResult[4];
    }
    else {
        // It's a relative path. Use the current location's info.
        protocol = location.protocol;
        hostname = location.hostname;
        port = location.port;
    }
    // If the port is the default for the protocol, we don't want to add it to the origin string
    // or it won't match the message's event.origin.
    const portSuffix = port && port !== DEFAULT_PORT_BY_PROTOCOL[protocol] ? `:${port}` : '';
    return `${protocol}//${hostname}${portSuffix}`;
});

;// CONCATENATED MODULE: ../node_modules/penpal/lib/errorSerialization.js
/**
 * Converts an error object into a plain object.
 */
const serializeError = ({ name, message, stack, }) => ({
    name,
    message,
    stack,
});
/**
 * Converts a plain object into an error object.
 */
const deserializeError = (obj) => {
    const deserializedError = new Error();
    // @ts-ignore
    Object.keys(obj).forEach((key) => (deserializedError[key] = obj[key]));
    return deserializedError;
};

;// CONCATENATED MODULE: ../node_modules/penpal/lib/connectCallReceiver.js


/**
 * Listens for "call" messages coming from the remote, executes the corresponding method, and
 * responds with the return value.
 */
/* harmony default export */ var connectCallReceiver = ((info, serializedMethods, log) => {
    const { localName, local, remote, originForSending, originForReceiving, } = info;
    let destroyed = false;
    const handleMessageEvent = (event) => {
        if (event.source !== remote || event.data.penpal !== MessageType.Call) {
            return;
        }
        if (originForReceiving !== '*' && event.origin !== originForReceiving) {
            log(`${localName} received message from origin ${event.origin} which did not match expected origin ${originForReceiving}`);
            return;
        }
        const callMessage = event.data;
        const { methodName, args, id } = callMessage;
        log(`${localName}: Received ${methodName}() call`);
        const createPromiseHandler = (resolution) => {
            return (returnValue) => {
                log(`${localName}: Sending ${methodName}() reply`);
                if (destroyed) {
                    // It's possible to throw an error here, but it would need to be thrown asynchronously
                    // and would only be catchable using window.onerror. This is because the consumer
                    // is merely returning a value from their method and not calling any function
                    // that they could wrap in a try-catch. Even if the consumer were to catch the error,
                    // the value of doing so is questionable. Instead, we'll just log a message.
                    log(`${localName}: Unable to send ${methodName}() reply due to destroyed connection`);
                    return;
                }
                const message = {
                    penpal: MessageType.Reply,
                    id,
                    resolution,
                    returnValue,
                };
                if (resolution === Resolution.Rejected &&
                    returnValue instanceof Error) {
                    message.returnValue = serializeError(returnValue);
                    message.returnValueIsError = true;
                }
                try {
                    remote.postMessage(message, originForSending);
                }
                catch (err) {
                    // If a consumer attempts to send an object that's not cloneable (e.g., window),
                    // we want to ensure the receiver's promise gets rejected.
                    if (err.name === NativeErrorName.DataCloneError) {
                        const errorReplyMessage = {
                            penpal: MessageType.Reply,
                            id,
                            resolution: Resolution.Rejected,
                            returnValue: serializeError(err),
                            returnValueIsError: true,
                        };
                        remote.postMessage(errorReplyMessage, originForSending);
                    }
                    throw err;
                }
            };
        };
        new Promise((resolve) => resolve(serializedMethods[methodName].apply(serializedMethods, args))).then(createPromiseHandler(Resolution.Fulfilled), createPromiseHandler(Resolution.Rejected));
    };
    local.addEventListener(NativeEventType.Message, handleMessageEvent);
    return () => {
        destroyed = true;
        local.removeEventListener(NativeEventType.Message, handleMessageEvent);
    };
});

;// CONCATENATED MODULE: ../node_modules/penpal/lib/generateId.js
let id = 0;
/**
 * @return {number} A unique ID (not universally unique)
 */
/* harmony default export */ var generateId = (() => ++id);

;// CONCATENATED MODULE: ../node_modules/penpal/lib/methodSerialization.js
const KEY_PATH_DELIMITER = '.';
const keyPathToSegments = (keyPath) => keyPath ? keyPath.split(KEY_PATH_DELIMITER) : [];
const segmentsToKeyPath = (segments) => segments.join(KEY_PATH_DELIMITER);
const createKeyPath = (key, prefix) => {
    const segments = keyPathToSegments(prefix || '');
    segments.push(key);
    return segmentsToKeyPath(segments);
};
/**
 * Given a `keyPath`, set it to be `value` on `subject`, creating any intermediate
 * objects along the way.
 *
 * @param {Object} subject The object on which to set value.
 * @param {string} keyPath The key path at which to set value.
 * @param {Object} value The value to store at the given key path.
 * @returns {Object} Updated subject.
 */
const setAtKeyPath = (subject, keyPath, value) => {
    const segments = keyPathToSegments(keyPath);
    segments.reduce((prevSubject, key, idx) => {
        if (typeof prevSubject[key] === 'undefined') {
            prevSubject[key] = {};
        }
        if (idx === segments.length - 1) {
            prevSubject[key] = value;
        }
        return prevSubject[key];
    }, subject);
    return subject;
};
/**
 * Given a dictionary of (nested) keys to function, flatten them to a map
 * from key path to function.
 *
 * @param {Object} methods The (potentially nested) object to serialize.
 * @param {string} prefix A string with which to prefix entries. Typically not intended to be used by consumers.
 * @returns {Object} An map from key path in `methods` to functions.
 */
const serializeMethods = (methods, prefix) => {
    const flattenedMethods = {};
    Object.keys(methods).forEach((key) => {
        const value = methods[key];
        const keyPath = createKeyPath(key, prefix);
        if (typeof value === 'object') {
            // Recurse into any nested children.
            Object.assign(flattenedMethods, serializeMethods(value, keyPath));
        }
        if (typeof value === 'function') {
            // If we've found a method, expose it.
            flattenedMethods[keyPath] = value;
        }
    });
    return flattenedMethods;
};
/**
 * Given a map of key paths to functions, unpack the key paths to an object.
 *
 * @param {Object} flattenedMethods A map of key paths to functions to unpack.
 * @returns {Object} A (potentially nested) map of functions.
 */
const deserializeMethods = (flattenedMethods) => {
    const methods = {};
    for (const keyPath in flattenedMethods) {
        setAtKeyPath(methods, keyPath, flattenedMethods[keyPath]);
    }
    return methods;
};

;// CONCATENATED MODULE: ../node_modules/penpal/lib/connectCallSender.js




/**
 * Augments an object with methods that match those defined by the remote. When these methods are
 * called, a "call" message will be sent to the remote, the remote's corresponding method will be
 * executed, and the method's return value will be returned via a message.
 * @param {Object} callSender Sender object that should be augmented with methods.
 * @param {Object} info Information about the local and remote windows.
 * @param {Array} methodKeyPaths Key paths of methods available to be called on the remote.
 * @param {Promise} destructionPromise A promise resolved when destroy() is called on the penpal
 * connection.
 * @returns {Object} The call sender object with methods that may be called.
 */
/* harmony default export */ var connectCallSender = ((callSender, info, methodKeyPaths, destroyConnection, log) => {
    const { localName, local, remote, originForSending, originForReceiving, } = info;
    let destroyed = false;
    log(`${localName}: Connecting call sender`);
    const createMethodProxy = (methodName) => {
        return (...args) => {
            log(`${localName}: Sending ${methodName}() call`);
            // This handles the case where the iframe has been removed from the DOM
            // (and therefore its window closed), the consumer has not yet
            // called destroy(), and the user calls a method exposed by
            // the remote. We detect the iframe has been removed and force
            // a destroy() immediately so that the consumer sees the error saying
            // the connection has been destroyed. We wrap this check in a try catch
            // because Edge throws an "Object expected" error when accessing
            // contentWindow.closed on a contentWindow from an iframe that's been
            // removed from the DOM.
            let iframeRemoved;
            try {
                if (remote.closed) {
                    iframeRemoved = true;
                }
            }
            catch (e) {
                iframeRemoved = true;
            }
            if (iframeRemoved) {
                destroyConnection();
            }
            if (destroyed) {
                const error = new Error(`Unable to send ${methodName}() call due ` + `to destroyed connection`);
                error.code = ErrorCode.ConnectionDestroyed;
                throw error;
            }
            return new Promise((resolve, reject) => {
                const id = generateId();
                const handleMessageEvent = (event) => {
                    if (event.source !== remote ||
                        event.data.penpal !== MessageType.Reply ||
                        event.data.id !== id) {
                        return;
                    }
                    if (originForReceiving !== '*' &&
                        event.origin !== originForReceiving) {
                        log(`${localName} received message from origin ${event.origin} which did not match expected origin ${originForReceiving}`);
                        return;
                    }
                    const replyMessage = event.data;
                    log(`${localName}: Received ${methodName}() reply`);
                    local.removeEventListener(NativeEventType.Message, handleMessageEvent);
                    let returnValue = replyMessage.returnValue;
                    if (replyMessage.returnValueIsError) {
                        returnValue = deserializeError(returnValue);
                    }
                    (replyMessage.resolution === Resolution.Fulfilled ? resolve : reject)(returnValue);
                };
                local.addEventListener(NativeEventType.Message, handleMessageEvent);
                const callMessage = {
                    penpal: MessageType.Call,
                    id,
                    methodName,
                    args,
                };
                remote.postMessage(callMessage, originForSending);
            });
        };
    };
    // Wrap each method in a proxy which sends it to the corresponding receiver.
    const flattenedMethods = methodKeyPaths.reduce((api, name) => {
        api[name] = createMethodProxy(name);
        return api;
    }, {});
    // Unpack the structure of the provided methods object onto the CallSender, exposing
    // the methods in the same shape they were provided.
    Object.assign(callSender, deserializeMethods(flattenedMethods));
    return () => {
        destroyed = true;
    };
});

;// CONCATENATED MODULE: ../node_modules/penpal/lib/parent/handleAckMessageFactory.js


/**
 * Handles an ACK handshake message.
 */
/* harmony default export */ var handleAckMessageFactory = ((serializedMethods, childOrigin, originForSending, destructor, log) => {
    const { destroy, onDestroy } = destructor;
    let destroyCallReceiver;
    let receiverMethodNames;
    // We resolve the promise with the call sender. If the child reconnects
    // (for example, after refreshing or navigating to another page that
    // uses Penpal, we'll update the call sender with methods that match the
    // latest provided by the child.
    const callSender = {};
    return (event) => {
        if (childOrigin !== '*' && event.origin !== childOrigin) {
            log(`Parent: Handshake - Received ACK message from origin ${event.origin} which did not match expected origin ${childOrigin}`);
            return;
        }
        log('Parent: Handshake - Received ACK');
        const info = {
            localName: 'Parent',
            local: window,
            remote: event.source,
            originForSending: originForSending,
            originForReceiving: childOrigin,
        };
        // If the child reconnected, we need to destroy the prior call receiver
        // before setting up a new one.
        if (destroyCallReceiver) {
            destroyCallReceiver();
        }
        destroyCallReceiver = connectCallReceiver(info, serializedMethods, log);
        onDestroy(destroyCallReceiver);
        // If the child reconnected, we need to remove the methods from the
        // previous call receiver off the sender.
        if (receiverMethodNames) {
            receiverMethodNames.forEach((receiverMethodName) => {
                delete callSender[receiverMethodName];
            });
        }
        receiverMethodNames = event.data.methodNames;
        const destroyCallSender = connectCallSender(callSender, info, receiverMethodNames, destroy, log);
        onDestroy(destroyCallSender);
        return callSender;
    };
});

;// CONCATENATED MODULE: ../node_modules/penpal/lib/parent/handleSynMessageFactory.js

/**
 * Handles a SYN handshake message.
 */
/* harmony default export */ var handleSynMessageFactory = ((log, serializedMethods, childOrigin, originForSending) => {
    return (event) => {
        // Under specific timing circumstances, we can receive an event
        // whose source is null. This seems to happen when the child iframe is
        // removed from the DOM about the same time it has sent the SYN event.
        // https://github.com/Aaronius/penpal/issues/85
        if (!event.source) {
            return;
        }
        if (childOrigin !== '*' && event.origin !== childOrigin) {
            log(`Parent: Handshake - Received SYN message from origin ${event.origin} which did not match expected origin ${childOrigin}`);
            return;
        }
        log('Parent: Handshake - Received SYN, responding with SYN-ACK');
        const synAckMessage = {
            penpal: MessageType.SynAck,
            methodNames: Object.keys(serializedMethods),
        };
        event.source.postMessage(synAckMessage, originForSending);
    };
});

;// CONCATENATED MODULE: ../node_modules/penpal/lib/parent/monitorIframeRemoval.js
const CHECK_IFRAME_IN_DOC_INTERVAL = 60000;
/**
 * Monitors for iframe removal and destroys connection if iframe
 * is found to have been removed from DOM. This is to prevent memory
 * leaks when the iframe is removed from the document and the consumer
 * hasn't called destroy(). Without this, event listeners attached to
 * the window would stick around and since the event handlers have a
 * reference to the iframe in their closures, the iframe would stick
 * around too.
 */
/* harmony default export */ var monitorIframeRemoval = ((iframe, destructor) => {
    const { destroy, onDestroy } = destructor;
    const checkIframeInDocIntervalId = setInterval(() => {
        if (!iframe.isConnected) {
            clearInterval(checkIframeInDocIntervalId);
            destroy();
        }
    }, CHECK_IFRAME_IN_DOC_INTERVAL);
    onDestroy(() => {
        clearInterval(checkIframeInDocIntervalId);
    });
});

;// CONCATENATED MODULE: ../node_modules/penpal/lib/startConnectionTimeout.js

/**
 * Starts a timeout and calls the callback with an error
 * if the timeout completes before the stop function is called.
 */
/* harmony default export */ var startConnectionTimeout = ((timeout, callback) => {
    let timeoutId;
    if (timeout !== undefined) {
        timeoutId = window.setTimeout(() => {
            const error = new Error(`Connection timed out after ${timeout}ms`);
            error.code = ErrorCode.ConnectionTimeout;
            callback(error);
        }, timeout);
    }
    return () => {
        clearTimeout(timeoutId);
    };
});

;// CONCATENATED MODULE: ../node_modules/penpal/lib/parent/validateIframeHasSrcOrSrcDoc.js

/* harmony default export */ var validateIframeHasSrcOrSrcDoc = ((iframe) => {
    if (!iframe.src && !iframe.srcdoc) {
        const error = new Error('Iframe must have src or srcdoc property defined.');
        error.code = ErrorCode.NoIframeSrc;
        throw error;
    }
});

;// CONCATENATED MODULE: ../node_modules/penpal/lib/parent/connectToChild.js










/**
 * Attempts to establish communication with an iframe.
 */
/* harmony default export */ var connectToChild = ((options) => {
    let { iframe, methods = {}, childOrigin, timeout, debug = false } = options;
    const log = createLogger(debug);
    const destructor = createDestructor('Parent', log);
    const { onDestroy, destroy } = destructor;
    if (!childOrigin) {
        validateIframeHasSrcOrSrcDoc(iframe);
        childOrigin = getOriginFromSrc(iframe.src);
    }
    // If event.origin is "null", the remote protocol is file: or data: and we
    // must post messages with "*" as targetOrigin when sending messages.
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/postMessage#Using_window.postMessage_in_extensions
    const originForSending = childOrigin === 'null' ? '*' : childOrigin;
    const serializedMethods = serializeMethods(methods);
    const handleSynMessage = handleSynMessageFactory(log, serializedMethods, childOrigin, originForSending);
    const handleAckMessage = handleAckMessageFactory(serializedMethods, childOrigin, originForSending, destructor, log);
    const promise = new Promise((resolve, reject) => {
        const stopConnectionTimeout = startConnectionTimeout(timeout, destroy);
        const handleMessage = (event) => {
            if (event.source !== iframe.contentWindow || !event.data) {
                return;
            }
            if (event.data.penpal === MessageType.Syn) {
                handleSynMessage(event);
                return;
            }
            if (event.data.penpal === MessageType.Ack) {
                const callSender = handleAckMessage(event);
                if (callSender) {
                    stopConnectionTimeout();
                    resolve(callSender);
                }
                return;
            }
        };
        window.addEventListener(NativeEventType.Message, handleMessage);
        log('Parent: Awaiting handshake');
        monitorIframeRemoval(iframe, destructor);
        onDestroy((error) => {
            window.removeEventListener(NativeEventType.Message, handleMessage);
            if (error) {
                reject(error);
            }
        });
    });
    return {
        promise,
        destroy() {
            // Don't allow consumer to pass an error into destroy.
            destroy();
        },
    };
});

;// CONCATENATED MODULE: ../node_modules/penpal/lib/child/handleSynAckMessageFactory.js



/**
 * Handles a SYN-ACK handshake message.
 */
/* harmony default export */ var handleSynAckMessageFactory = ((parentOrigin, serializedMethods, destructor, log) => {
    const { destroy, onDestroy } = destructor;
    return (event) => {
        let originQualifies = parentOrigin instanceof RegExp
            ? parentOrigin.test(event.origin)
            : parentOrigin === '*' || parentOrigin === event.origin;
        if (!originQualifies) {
            log(`Child: Handshake - Received SYN-ACK from origin ${event.origin} which did not match expected origin ${parentOrigin}`);
            return;
        }
        log('Child: Handshake - Received SYN-ACK, responding with ACK');
        // If event.origin is "null", the remote protocol is file: or data: and we
        // must post messages with "*" as targetOrigin when sending messages.
        // https://developer.mozilla.org/en-US/docs/Web/API/Window/postMessage#Using_window.postMessage_in_extensions
        const originForSending = event.origin === 'null' ? '*' : event.origin;
        const ackMessage = {
            penpal: MessageType.Ack,
            methodNames: Object.keys(serializedMethods),
        };
        window.parent.postMessage(ackMessage, originForSending);
        const info = {
            localName: 'Child',
            local: window,
            remote: window.parent,
            originForSending,
            originForReceiving: event.origin,
        };
        const destroyCallReceiver = connectCallReceiver(info, serializedMethods, log);
        onDestroy(destroyCallReceiver);
        const callSender = {};
        const destroyCallSender = connectCallSender(callSender, info, event.data.methodNames, destroy, log);
        onDestroy(destroyCallSender);
        return callSender;
    };
});

;// CONCATENATED MODULE: ../node_modules/penpal/lib/child/connectToParent.js






const areGlobalsAccessible = () => {
    try {
        clearTimeout();
    }
    catch (e) {
        return false;
    }
    return true;
};
/**
 * Attempts to establish communication with the parent window.
 */
/* harmony default export */ var connectToParent = ((options = {}) => {
    const { parentOrigin = '*', methods = {}, timeout, debug = false } = options;
    const log = createLogger(debug);
    const destructor = createDestructor('Child', log);
    const { destroy, onDestroy } = destructor;
    const serializedMethods = serializeMethods(methods);
    const handleSynAckMessage = handleSynAckMessageFactory(parentOrigin, serializedMethods, destructor, log);
    const sendSynMessage = () => {
        log('Child: Handshake - Sending SYN');
        const synMessage = { penpal: MessageType.Syn };
        const parentOriginForSyn = parentOrigin instanceof RegExp ? '*' : parentOrigin;
        window.parent.postMessage(synMessage, parentOriginForSyn);
    };
    const promise = new Promise((resolve, reject) => {
        const stopConnectionTimeout = startConnectionTimeout(timeout, destroy);
        const handleMessage = (event) => {
            // Under niche scenarios, we get into this function after
            // the iframe has been removed from the DOM. In Edge, this
            // results in "Object expected" errors being thrown when we
            // try to access properties on window (global properties).
            // For this reason, we try to access a global up front (clearTimeout)
            // and if it fails we can assume the iframe has been removed
            // and we ignore the message event.
            if (!areGlobalsAccessible()) {
                return;
            }
            if (event.source !== parent || !event.data) {
                return;
            }
            if (event.data.penpal === MessageType.SynAck) {
                const callSender = handleSynAckMessage(event);
                if (callSender) {
                    window.removeEventListener(NativeEventType.Message, handleMessage);
                    stopConnectionTimeout();
                    resolve(callSender);
                }
            }
        };
        window.addEventListener(NativeEventType.Message, handleMessage);
        sendSynMessage();
        onDestroy((error) => {
            window.removeEventListener(NativeEventType.Message, handleMessage);
            if (error) {
                reject(error);
            }
        });
    });
    return {
        promise,
        destroy() {
            // Don't allow consumer to pass an error into destroy.
            destroy();
        },
    };
});

;// CONCATENATED MODULE: ../node_modules/penpal/lib/index.js





/***/ }),

/***/ 58772:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(90331);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 23615:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(58772)();
}


/***/ }),

/***/ 90331:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 67651:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
/**
 * Copyright (c) 2010,2011,2012,2013,2014 Morgan Roderick http://roderick.dk
 * License: MIT - http://mrgnrdrck.mit-license.org
 *
 * https://github.com/mroderick/PubSubJS
 */

(function (root, factory){
    'use strict';

    var PubSub = {};

    if (root.PubSub) {
        PubSub = root.PubSub;
        console.warn("PubSub already loaded, using existing version");
    } else {
        root.PubSub = PubSub;
        factory(PubSub);
    }
    // CommonJS and Node.js module support
    if (true){
        if (module !== undefined && module.exports) {
            exports = module.exports = PubSub; // Node.js specific `module.exports`
        }
        exports.PubSub = PubSub; // CommonJS module 1.1.1 spec
        module.exports = exports = PubSub; // CommonJS
    }
    // AMD support
    /* eslint-disable no-undef */
    else {}

}(( typeof window === 'object' && window ) || this, function (PubSub){
    'use strict';

    var messages = {},
        lastUid = -1,
        ALL_SUBSCRIBING_MSG = '*';

    function hasKeys(obj){
        var key;

        for (key in obj){
            if ( Object.prototype.hasOwnProperty.call(obj, key) ){
                return true;
            }
        }
        return false;
    }

    /**
     * Returns a function that throws the passed exception, for use as argument for setTimeout
     * @alias throwException
     * @function
     * @param { Object } ex An Error object
     */
    function throwException( ex ){
        return function reThrowException(){
            throw ex;
        };
    }

    function callSubscriberWithDelayedExceptions( subscriber, message, data ){
        try {
            subscriber( message, data );
        } catch( ex ){
            setTimeout( throwException( ex ), 0);
        }
    }

    function callSubscriberWithImmediateExceptions( subscriber, message, data ){
        subscriber( message, data );
    }

    function deliverMessage( originalMessage, matchedMessage, data, immediateExceptions ){
        var subscribers = messages[matchedMessage],
            callSubscriber = immediateExceptions ? callSubscriberWithImmediateExceptions : callSubscriberWithDelayedExceptions,
            s;

        if ( !Object.prototype.hasOwnProperty.call( messages, matchedMessage ) ) {
            return;
        }

        for (s in subscribers){
            if ( Object.prototype.hasOwnProperty.call(subscribers, s)){
                callSubscriber( subscribers[s], originalMessage, data );
            }
        }
    }

    function createDeliveryFunction( message, data, immediateExceptions ){
        return function deliverNamespaced(){
            var topic = String( message ),
                position = topic.lastIndexOf( '.' );

            // deliver the message as it is now
            deliverMessage(message, message, data, immediateExceptions);

            // trim the hierarchy and deliver message to each level
            while( position !== -1 ){
                topic = topic.substr( 0, position );
                position = topic.lastIndexOf('.');
                deliverMessage( message, topic, data, immediateExceptions );
            }

            deliverMessage(message, ALL_SUBSCRIBING_MSG, data, immediateExceptions);
        };
    }

    function hasDirectSubscribersFor( message ) {
        var topic = String( message ),
            found = Boolean(Object.prototype.hasOwnProperty.call( messages, topic ) && hasKeys(messages[topic]));

        return found;
    }

    function messageHasSubscribers( message ){
        var topic = String( message ),
            found = hasDirectSubscribersFor(topic) || hasDirectSubscribersFor(ALL_SUBSCRIBING_MSG),
            position = topic.lastIndexOf( '.' );

        while ( !found && position !== -1 ){
            topic = topic.substr( 0, position );
            position = topic.lastIndexOf( '.' );
            found = hasDirectSubscribersFor(topic);
        }

        return found;
    }

    function publish( message, data, sync, immediateExceptions ){
        message = (typeof message === 'symbol') ? message.toString() : message;

        var deliver = createDeliveryFunction( message, data, immediateExceptions ),
            hasSubscribers = messageHasSubscribers( message );

        if ( !hasSubscribers ){
            return false;
        }

        if ( sync === true ){
            deliver();
        } else {
            setTimeout( deliver, 0 );
        }
        return true;
    }

    /**
     * Publishes the message, passing the data to it's subscribers
     * @function
     * @alias publish
     * @param { String } message The message to publish
     * @param {} data The data to pass to subscribers
     * @return { Boolean }
     */
    PubSub.publish = function( message, data ){
        return publish( message, data, false, PubSub.immediateExceptions );
    };

    /**
     * Publishes the message synchronously, passing the data to it's subscribers
     * @function
     * @alias publishSync
     * @param { String } message The message to publish
     * @param {} data The data to pass to subscribers
     * @return { Boolean }
     */
    PubSub.publishSync = function( message, data ){
        return publish( message, data, true, PubSub.immediateExceptions );
    };

    /**
     * Subscribes the passed function to the passed message. Every returned token is unique and should be stored if you need to unsubscribe
     * @function
     * @alias subscribe
     * @param { String } message The message to subscribe to
     * @param { Function } func The function to call when a new message is published
     * @return { String }
     */
    PubSub.subscribe = function( message, func ){
        if ( typeof func !== 'function'){
            return false;
        }

        message = (typeof message === 'symbol') ? message.toString() : message;

        // message is not registered yet
        if ( !Object.prototype.hasOwnProperty.call( messages, message ) ){
            messages[message] = {};
        }

        // forcing token as String, to allow for future expansions without breaking usage
        // and allow for easy use as key names for the 'messages' object
        var token = 'uid_' + String(++lastUid);
        messages[message][token] = func;

        // return token for unsubscribing
        return token;
    };

    PubSub.subscribeAll = function( func ){
        return PubSub.subscribe(ALL_SUBSCRIBING_MSG, func);
    };

    /**
     * Subscribes the passed function to the passed message once
     * @function
     * @alias subscribeOnce
     * @param { String } message The message to subscribe to
     * @param { Function } func The function to call when a new message is published
     * @return { PubSub }
     */
    PubSub.subscribeOnce = function( message, func ){
        var token = PubSub.subscribe( message, function(){
            // before func apply, unsubscribe message
            PubSub.unsubscribe( token );
            func.apply( this, arguments );
        });
        return PubSub;
    };

    /**
     * Clears all subscriptions
     * @function
     * @public
     * @alias clearAllSubscriptions
     */
    PubSub.clearAllSubscriptions = function clearAllSubscriptions(){
        messages = {};
    };

    /**
     * Clear subscriptions by the topic
     * @function
     * @public
     * @alias clearAllSubscriptions
     * @return { int }
     */
    PubSub.clearSubscriptions = function clearSubscriptions(topic){
        var m;
        for (m in messages){
            if (Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0){
                delete messages[m];
            }
        }
    };

    /**
       Count subscriptions by the topic
     * @function
     * @public
     * @alias countSubscriptions
     * @return { Array }
    */
    PubSub.countSubscriptions = function countSubscriptions(topic){
        var m;
        // eslint-disable-next-line no-unused-vars
        var token;
        var count = 0;
        for (m in messages) {
            if (Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0) {
                for (token in messages[m]) {
                    count++;
                }
                break;
            }
        }
        return count;
    };


    /**
       Gets subscriptions by the topic
     * @function
     * @public
     * @alias getSubscriptions
    */
    PubSub.getSubscriptions = function getSubscriptions(topic){
        var m;
        var list = [];
        for (m in messages){
            if (Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0){
                list.push(m);
            }
        }
        return list;
    };

    /**
     * Removes subscriptions
     *
     * - When passed a token, removes a specific subscription.
     *
	 * - When passed a function, removes all subscriptions for that function
     *
	 * - When passed a topic, removes all subscriptions for that topic (hierarchy)
     * @function
     * @public
     * @alias subscribeOnce
     * @param { String | Function } value A token, function or topic to unsubscribe from
     * @example // Unsubscribing with a token
     * var token = PubSub.subscribe('mytopic', myFunc);
     * PubSub.unsubscribe(token);
     * @example // Unsubscribing with a function
     * PubSub.unsubscribe(myFunc);
     * @example // Unsubscribing from a topic
     * PubSub.unsubscribe('mytopic');
     */
    PubSub.unsubscribe = function(value){
        var descendantTopicExists = function(topic) {
                var m;
                for ( m in messages ){
                    if ( Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0 ){
                        // a descendant of the topic exists:
                        return true;
                    }
                }

                return false;
            },
            isTopic    = typeof value === 'string' && ( Object.prototype.hasOwnProperty.call(messages, value) || descendantTopicExists(value) ),
            isToken    = !isTopic && typeof value === 'string',
            isFunction = typeof value === 'function',
            result = false,
            m, message, t;

        if (isTopic){
            PubSub.clearSubscriptions(value);
            return;
        }

        for ( m in messages ){
            if ( Object.prototype.hasOwnProperty.call( messages, m ) ){
                message = messages[m];

                if ( isToken && message[value] ){
                    delete message[value];
                    result = value;
                    // tokens are unique, so we can just stop here
                    break;
                }

                if (isFunction) {
                    for ( t in message ){
                        if (Object.prototype.hasOwnProperty.call(message, t) && message[t] === value){
                            delete message[t];
                            result = true;
                        }
                    }
                }
            }
        }

        return result;
    };
}));


/***/ }),

/***/ 68715:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(exports, __webpack_require__(27378)) :
  0;
})(this, (function (exports, React) { 'use strict';

  function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
      Object.keys(e).forEach(function (k) {
        if (k !== 'default') {
          var d = Object.getOwnPropertyDescriptor(e, k);
          Object.defineProperty(n, k, d.get ? d : {
            enumerable: true,
            get: function () { return e[k]; }
          });
        }
      });
    }
    n["default"] = e;
    return Object.freeze(n);
  }

  var React__namespace = /*#__PURE__*/_interopNamespace(React);

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
  }

  var changedArray = function changedArray(a, b) {
    if (a === void 0) {
      a = [];
    }

    if (b === void 0) {
      b = [];
    }

    return a.length !== b.length || a.some(function (item, index) {
      return !Object.is(item, b[index]);
    });
  };

  var initialState = {
    error: null
  };

  var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
    _inheritsLoose(ErrorBoundary, _React$Component);

    function ErrorBoundary() {
      var _this;

      for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
        _args[_key] = arguments[_key];
      }

      _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;
      _this.state = initialState;

      _this.resetErrorBoundary = function () {
        var _this$props;

        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        _this.props.onReset == null ? void 0 : (_this$props = _this.props).onReset.apply(_this$props, args);

        _this.reset();
      };

      return _this;
    }

    ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
      return {
        error: error
      };
    };

    var _proto = ErrorBoundary.prototype;

    _proto.reset = function reset() {
      this.setState(initialState);
    };

    _proto.componentDidCatch = function componentDidCatch(error, info) {
      var _this$props$onError, _this$props2;

      (_this$props$onError = (_this$props2 = this.props).onError) == null ? void 0 : _this$props$onError.call(_this$props2, error, info);
    };

    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
      var error = this.state.error;
      var resetKeys = this.props.resetKeys; // There's an edge case where if the thing that triggered the error
      // happens to *also* be in the resetKeys array, we'd end up resetting
      // the error boundary immediately. This would likely trigger a second
      // error to be thrown.
      // So we make sure that we don't check the resetKeys on the first call
      // of cDU after the error is set

      if (error !== null && prevState.error !== null && changedArray(prevProps.resetKeys, resetKeys)) {
        var _this$props$onResetKe, _this$props3;

        (_this$props$onResetKe = (_this$props3 = this.props).onResetKeysChange) == null ? void 0 : _this$props$onResetKe.call(_this$props3, prevProps.resetKeys, resetKeys);
        this.reset();
      }
    };

    _proto.render = function render() {
      var error = this.state.error;
      var _this$props4 = this.props,
          fallbackRender = _this$props4.fallbackRender,
          FallbackComponent = _this$props4.FallbackComponent,
          fallback = _this$props4.fallback;

      if (error !== null) {
        var _props = {
          error: error,
          resetErrorBoundary: this.resetErrorBoundary
        };

        if ( /*#__PURE__*/React__namespace.isValidElement(fallback)) {
          return fallback;
        } else if (typeof fallbackRender === 'function') {
          return fallbackRender(_props);
        } else if (FallbackComponent) {
          return /*#__PURE__*/React__namespace.createElement(FallbackComponent, _props);
        } else {
          throw new Error('react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop');
        }
      }

      return this.props.children;
    };

    return ErrorBoundary;
  }(React__namespace.Component);

  function withErrorBoundary(Component, errorBoundaryProps) {
    var Wrapped = function Wrapped(props) {
      return /*#__PURE__*/React__namespace.createElement(ErrorBoundary, errorBoundaryProps, /*#__PURE__*/React__namespace.createElement(Component, props));
    }; // Format for display in DevTools


    var name = Component.displayName || Component.name || 'Unknown';
    Wrapped.displayName = "withErrorBoundary(" + name + ")";
    return Wrapped;
  }

  function useErrorHandler(givenError) {
    var _React$useState = React__namespace.useState(null),
        error = _React$useState[0],
        setError = _React$useState[1];

    if (givenError != null) throw givenError;
    if (error != null) throw error;
    return setError;
  }
  /*
  eslint
    @typescript-eslint/sort-type-union-intersection-members: "off",
    @typescript-eslint/no-throw-literal: "off",
    @typescript-eslint/prefer-nullish-coalescing: "off"
  */

  exports.ErrorBoundary = ErrorBoundary;
  exports.useErrorHandler = useErrorHandler;
  exports.withErrorBoundary = withErrorBoundary;

  Object.defineProperty(exports, '__esModule', { value: true });

}));
//# sourceMappingURL=react-error-boundary.umd.js.map


/***/ }),

/***/ 71977:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _react = _interopRequireWildcard(__webpack_require__(27378));

var _propTypes = _interopRequireDefault(__webpack_require__(23615));

var _GROUP, _PropTypes$shape;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// In firefox, setTimeout with duration 0 too short for browser notice the changes in dom
var initialTransitDuration = 20;
var PHASE = {
  CLOSE: 'close',
  CLOSING: 'closing',
  CLOSED: 'closed',
  OPEN: 'open',
  OPENING: 'opening',
  OPENED: 'opened'
};
var GROUP = (_GROUP = {}, _defineProperty(_GROUP, PHASE.CLOSE, PHASE.CLOSE), _defineProperty(_GROUP, PHASE.CLOSED, PHASE.CLOSE), _defineProperty(_GROUP, PHASE.OPENING, PHASE.CLOSE), _defineProperty(_GROUP, PHASE.CLOSING, PHASE.OPEN), _defineProperty(_GROUP, PHASE.OPEN, PHASE.OPEN), _defineProperty(_GROUP, PHASE.OPENED, PHASE.OPEN), _GROUP);

var Expand =
/*#__PURE__*/
function (_Component) {
  _inherits(Expand, _Component);

  function Expand(props) {
    var _this;

    _classCallCheck(this, Expand);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Expand).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "getClientHeight", function () {
      return _this.refWrapper.scrollHeight;
    });

    _defineProperty(_assertThisInitialized(_this), "getDefaultExpandStyle", function () {
      var status = _this.state.status;

      switch (status) {
        case PHASE.OPENING:
        case PHASE.CLOSE:
        case PHASE.CLOSED:
          return {
            height: 0,
            opacity: 0,
            overflow: 'hidden'
          };

        case PHASE.OPENED:
        case PHASE.CLOSING:
          return {
            height: _this.getClientHeight(),
            opacity: 1,
            overflow: 'hidden'
          };

        default:
          return {
            height: 'auto',
            opacity: 1,
            overflow: 'unset'
          };
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getExpandStyle", function () {
      return _objectSpread({}, _this.getDefaultExpandStyle(), {}, _this.props.styles[GROUP[_this.state.status]]);
    });

    _defineProperty(_assertThisInitialized(_this), "getTransition", function (attribute) {
      return "".concat(attribute, " ").concat(_this.props.duration, "ms ").concat(_this.props.easing);
    });

    _defineProperty(_assertThisInitialized(_this), "updateStatus", function (status) {
      return _this.setState({
        status: status
      });
    });

    _defineProperty(_assertThisInitialized(_this), "delay", function (fn, time) {
      _this.timeout = setTimeout(fn, time);
    });

    _defineProperty(_assertThisInitialized(_this), "clearDelay", function () {
      if (_this.timeout) {
        clearTimeout(_this.timeout);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "transit", function (entering, entered, enter) {
      var duration = _this.props.duration;

      _this.updateStatus(entering);

      _this.delay(function () {
        _this.updateStatus(entered);

        _this.delay(function () {
          _this.updateStatus(enter);
        }, duration);
      }, initialTransitDuration);
    });

    _defineProperty(_assertThisInitialized(_this), "toggle", function (open) {
      _this.clearDelay();

      if (open) {
        _this.transit(PHASE.OPENING, PHASE.OPENED, PHASE.OPEN);
      } else {
        _this.transit(PHASE.CLOSING, PHASE.CLOSED, PHASE.CLOSE);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "setRef", function (ref) {
      _this.refWrapper = ref;
    });

    _this.state = {
      status: _this.props.open ? PHASE.OPEN : PHASE.CLOSE
    };
    return _this;
  }

  _createClass(Expand, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps
    /* prevState */
    ) {
      if (prevProps.open !== this.props.open) {
        this.toggle(this.props.open);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clearDelay();
    }
  }, {
    key: "getStyle",
    value: function getStyle() {
      var transition = this.props.transitions.map(this.getTransition).join(',');
      return _objectSpread({}, this.getExpandStyle(), {
        transition: transition
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          Tag = _this$props.tag;
      var childProps = {
        className: className,
        style: this.getStyle(),
        ref: this.setRef
      };
      return _react["default"].createElement(Tag, childProps, children);
    }
  }]);

  return Expand;
}(_react.Component);

Expand.propTypes = {
  children: _propTypes["default"].node.isRequired,
  open: _propTypes["default"].bool,
  duration: _propTypes["default"].number,
  easing: _propTypes["default"].string,
  className: _propTypes["default"].string,
  tag: _propTypes["default"].string,
  transitions: _propTypes["default"].arrayOf(_propTypes["default"].string),
  styles: _propTypes["default"].shape((_PropTypes$shape = {}, _defineProperty(_PropTypes$shape, PHASE.OPEN, _propTypes["default"].object), _defineProperty(_PropTypes$shape, PHASE.CLOSE, _propTypes["default"].object), _PropTypes$shape))
};
Expand.defaultProps = {
  open: false,
  duration: 400,
  easing: 'ease-in-out',
  className: '',
  tag: 'div',
  transitions: ['height', 'opacity'],
  styles: {}
};
var _default = Expand;
exports.Z = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 58702:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 19185:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(58702);
} else {}


/***/ }),

/***/ 80434:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "DEFAULT_LOADER": function() { return /* reexport */ DEFAULT_LOADER; },
  "ERRORS_STACK_SIZE": function() { return /* reexport */ ERRORS_STACK_SIZE; },
  "RecoilDevTools": function() { return /* reexport */ RecoilDevTools; },
  "RecoilReduxBridge": function() { return /* reexport */ RecoilReduxBridge; },
  "RecoilTunnel": function() { return /* reexport */ RecoilTunnel; },
  "TaskStatus": function() { return /* reexport */ TaskStatus; },
  "addCancelSignal": function() { return /* reexport */ addCancelSignal; },
  "and": function() { return /* reexport */ and; },
  "dec": function() { return /* reexport */ dec; },
  "decAbs": function() { return /* reexport */ decAbs; },
  "delay": function() { return /* reexport */ delay; },
  "doCancelSignal": function() { return /* reexport */ doCancelSignal; },
  "errorStack": function() { return /* reexport */ errors_errorStack; },
  "filter": function() { return /* reexport */ filter; },
  "getFetchSignal": function() { return /* reexport */ getFetchSignal; },
  "getRecoilStore": function() { return /* reexport */ getRecoilStore; },
  "hide": function() { return /* reexport */ hide; },
  "inc": function() { return /* reexport */ inc; },
  "isLoading": function() { return /* reexport */ isLoading; },
  "lastError": function() { return /* reexport */ lastError; },
  "lastErrorType": function() { return /* reexport */ lastErrorType; },
  "lastTaskByKey": function() { return /* reexport */ lastTaskByKey; },
  "loader": function() { return /* reexport */ loader; },
  "not": function() { return /* reexport */ not; },
  "or": function() { return /* reexport */ or; },
  "push": function() { return /* reexport */ push; },
  "pushError": function() { return /* reexport */ pushError; },
  "pushTask": function() { return /* reexport */ pushTask; },
  "pushTop": function() { return /* reexport */ pushTop; },
  "reduxSelector": function() { return /* reexport */ reduxSelector; },
  "reduxState": function() { return /* reexport */ reduxState; },
  "removeObj": function() { return /* reexport */ removeObj; },
  "reverse": function() { return /* reexport */ reverse; },
  "runningTasks": function() { return /* reexport */ runningTasks; },
  "set": function() { return /* reexport */ set; },
  "show": function() { return /* reexport */ show; },
  "taskById": function() { return /* reexport */ taskById; },
  "tasks": function() { return /* reexport */ tasks; },
  "toggle": function() { return /* reexport */ toggle; },
  "uniqueId": function() { return /* reexport */ uniqueId; },
  "unshift": function() { return /* reexport */ unshift; },
  "updateObj": function() { return /* reexport */ updateObj; },
  "updateTaskDone": function() { return /* reexport */ updateTaskDone; },
  "updateTaskError": function() { return /* reexport */ updateTaskError; },
  "useDispatch": function() { return /* reexport */ useDispatch; },
  "useIsLoading": function() { return /* reexport */ useIsLoading; },
  "useLastError": function() { return /* reexport */ useLastError; },
  "useMountedRef": function() { return /* reexport */ useMountedRef; },
  "useRecoilCurrentGetLoadable": function() { return /* reexport */ useRecoilCurrentGetLoadable; },
  "useRecoilCurrentGetPromise": function() { return /* reexport */ useRecoilCurrentGetPromise; },
  "useRecoilCurrentRefresh": function() { return /* reexport */ useRecoilCurrentRefresh; },
  "useRecoilCurrentReset": function() { return /* reexport */ useRecoilCurrentReset; },
  "useRecoilCurrentSet": function() { return /* reexport */ useRecoilCurrentSet; },
  "useRecoilCurrentSnapshot": function() { return /* reexport */ useRecoilCurrentSnapshot; },
  "useRecoilQuery": function() { return /* reexport */ useRecoilQuery; },
  "useRecoilRequest": function() { return /* reexport */ useRecoilRequest; },
  "useRecoilTask": function() { return /* reexport */ useRecoilTask; },
  "useResetErrors": function() { return /* reexport */ useResetErrors; },
  "useRunningTasks": function() { return /* reexport */ useRunningTasks; },
  "useSelector": function() { return /* reexport */ useSelector; }
});

;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/_core/helpers/delay.js
const delay = (ms) => new Promise(resolve => {
    setTimeout(() => {
        resolve(true);
    }, ms);
});
//# sourceMappingURL=delay.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/_core/helpers/uniqueId.js
let uniqueIdCounter = 0;
function uniqueId() {
    // eslint-disable-next-line no-plusplus
    return ++uniqueIdCounter;
}
//# sourceMappingURL=uniqueId.js.map
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/_core/helpers/useMountedRef.js

function useMountedRef() {
    const mounted = (0,react.useRef)(true);
    (0,react.useEffect)(() => () => {
        mounted.current = false;
    }, []);
    return mounted;
}
//# sourceMappingURL=useMountedRef.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/_core/helpers/index.js



//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ../node_modules/recoil/es/index.js
var es = __webpack_require__(69853);
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/_core/updaters/number.js
const inc = (s) => s + 1;
const dec = (s) => s - 1;
const decAbs = (s) => (s > 0 ? s - 1 : 0);
// alias
const show = inc;
const hide = decAbs;
//# sourceMappingURL=number.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/_core/hooks/useRecoilRequest.js



const useRecoilRequest = (request) => {
    const setRequestId = (0,es.useSetRecoilState)(request);
    return (0,react.useCallback)(() => {
        setRequestId(inc);
    }, [setRequestId]);
};
//# sourceMappingURL=useRecoilRequest.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/_core/hooks/recoilStore.js

const useRecoilCurrentGetPromise = () => (0,es.useRecoilCallback)(({ snapshot: { getPromise } }) => getPromise, []);
const useRecoilCurrentGetLoadable = () => (0,es.useRecoilCallback)(({ snapshot: { getLoadable } }) => getLoadable, []);
const useRecoilCurrentSnapshot = () => (0,es.useRecoilCallback)(({ snapshot }) => () => snapshot, []);
const useRecoilCurrentSet = () => (0,es.useRecoilCallback)(({ set }) => set, []);
const useRecoilCurrentReset = () => (0,es.useRecoilCallback)(({ reset }) => reset, []);
const useRecoilCurrentRefresh = () => (0,es.useRecoilCallback)(({ refresh }) => refresh, []);
//# sourceMappingURL=recoilStore.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/_core/hooks/signals/store.js
let instanceId = 0;
function getInstanceId() {
    instanceId += 1;
    return instanceId;
}
const signalStore = {};
function addCancelSignal(key, signal) {
    if (!signalStore[key]) {
        signalStore[key] = {};
    }
    signalStore[key][getInstanceId()] = signal;
}
function doCancelSignal(key) {
    if (signalStore[key]) {
        Object.values(signalStore[key]).forEach(abortsignal => {
            try {
                abortsignal.cancel();
            }
            catch (_a) {
                // ignore
            }
        });
        signalStore[key] = {};
    }
}
//# sourceMappingURL=store.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/_core/hooks/signals/fetch.js

function getFetchSignal(key) {
    const newAbortController = new AbortController();
    addCancelSignal(key, {
        signal: newAbortController.signal,
        cancel: () => {
            newAbortController.abort();
        },
    });
    return newAbortController.signal;
}
//# sourceMappingURL=fetch.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/_core/hooks/signals/index.js


//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/_core/hooks/useRecoilQuery.js



//todo freeze options object
const useRecoilQuery = (selector, options) => {
    const { state, contents } = (0,es.useRecoilValueLoadable)(selector);
    const loading = state === 'loading';
    const error = state === 'hasError' ? contents : undefined;
    const data = (state === 'hasValue' ? contents : undefined);
    const lastData = (0,react.useRef)();
    (0,react.useEffect)(() => {
        if (data !== undefined) {
            lastData.current = data;
        }
    }, [data]);
    const refresh = (0,es.useRecoilRefresher_UNSTABLE)(selector);
    (0,react.useEffect)(() => {
        if ((options === null || options === void 0 ? void 0 : options.refreshOnMount) === 'always' || ((options === null || options === void 0 ? void 0 : options.refreshOnMount) === 'error' && error)) {
            !loading && refresh();
        }
    }, []); //eslint-disable-line
    (0,react.useEffect)(() => () => {
        if ((options === null || options === void 0 ? void 0 : options.cancelOnUnmount) === true) {
            doCancelSignal(selector.key);
        }
        if (typeof (options === null || options === void 0 ? void 0 : options.cancelOnUnmount) === 'function') {
            options === null || options === void 0 ? void 0 : options.cancelOnUnmount();
        }
    }, []);
    return {
        loading,
        data: data !== undefined ? data : lastData.current,
        error,
        refresh,
    };
};
//# sourceMappingURL=useRecoilQuery.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/_core/hooks/index.js




//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/_core/tunnel/getStore.js
const recoilStores = {};
const DEFAULT_STORE = '$defaultStore$';
function set(recoilVal, valOrUpdater) {
    var _a, _b;
    if ((_a = recoilStores[DEFAULT_STORE]) === null || _a === void 0 ? void 0 : _a.set)
        return (_b = recoilStores[DEFAULT_STORE]) === null || _b === void 0 ? void 0 : _b.set(recoilVal, valOrUpdater);
    throw new Error('Recoil Toolkit Tunnel not ready');
}
const pendigGetStorePromises = [];
const flushGetStorePending = (name) => {
    pendigGetStorePromises.forEach(p => {
        if (p.pending && p.name === name) {
            // @ts-ignore
            if (recoilStores[name]) {
                // @ts-ignore
                p.resolve(recoilStores[name]);
            }
            else
                p.reject(new Error('no store found'));
            p.pending = false;
        }
    });
};
function getRecoilStore(name = DEFAULT_STORE) {
    return new Promise((resolve, reject) => {
        if (recoilStores[name]) {
            // @ts-ignore
            resolve(recoilStores[name]);
        }
        else {
            pendigGetStorePromises.push({
                resolve,
                reject,
                name,
                pending: true,
            });
        }
    });
}
//# sourceMappingURL=getStore.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/_core/tunnel/RecoilTunnel.js




const RecoilTunnel = ({ name = DEFAULT_STORE, children, }) => {
    const storeName = (0,react.useRef)(name);
    const getPromise = useRecoilCurrentGetPromise();
    const getLoadable = useRecoilCurrentGetLoadable();
    const set = useRecoilCurrentSet();
    const reset = useRecoilCurrentReset();
    const refresh = useRecoilCurrentRefresh();
    const getSnapshot = useRecoilCurrentSnapshot();
    const gotoSnapshot = (0,es.useGotoRecoilSnapshot)();
    const [ready, setReady] = (0,react.useState)(false);
    (0,react.useEffect)(() => {
        recoilStores[storeName.current] = {
            getPromise,
            getLoadable,
            set,
            reset,
            refresh,
            getSnapshot,
            gotoSnapshot,
            //TODO add runTask
        };
        flushGetStorePending(storeName.current);
        setReady(true);
        return () => {
            recoilStores[storeName.current] = undefined;
            flushGetStorePending(storeName.current);
        };
    }, []);
    return ready ? react.createElement(react.Fragment, null, children) : null;
};
//# sourceMappingURL=RecoilTunnel.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/_core/tunnel/index.js


//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/_core/updaters/array.js
const reverse = (s) => s.slice().reverse();
const filter = (predicate) => (s) => s.filter(predicate);
const push = (item, maxSize) => (s) => maxSize === undefined || s.length < maxSize
    ? [...s, item]
    : [...[...s, item].slice(s.length + 1 - maxSize, s.length + 1)];
const unshift = (item, maxSize) => (s) => maxSize === undefined || s.length < maxSize
    ? [item, ...s]
    : [item, ...s.slice(0, maxSize - 1)];
const updateObj = (item, match) => (s) => s.map(el => (Object.keys(match).every(k => match[k] === el[k]) ? Object.assign(Object.assign({}, el), item) : el));
const removeObj = (match) => filter(el => !Object.keys(match).every(k => match[k] === el[k]));
//alias
const pushTop = unshift;
//# sourceMappingURL=array.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/_core/updaters/boolean.js
const not = (s) => !s;
const and = (value) => (s) => s && !!value;
const or = (value) => (s) => s || !!value;
// alias
const toggle = not;
//# sourceMappingURL=boolean.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/_core/updaters/index.js



//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/_core/index.js




//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/atoms/errors.js

const ERRORS_STACK_SIZE = 100;
const errors_errorStack = (0,es.atom)({
    key: '@recoil-toolkit.errorStack',
    default: [],
});
const lastError = (0,es.selector)({
    key: '@recoil-toolkit.lastError',
    get: ({ get }) => {
        const e = get(errors_errorStack);
        return e.length > 0 ? e[e.length - 1] : undefined;
    },
});
const lastErrorType = (0,es.selectorFamily)({
    key: '@recoil-toolkit.lastErrorType',
    get: (key) => ({ get }) => get(errors_errorStack)
        .filter(e => e.key === key)
        .pop(),
});
const useLastError = (key) => (0,es.useRecoilValue)(key ? lastErrorType(key) : lastError);
const useResetErrors = () => (0,es.useResetRecoilState)(errors_errorStack);
//# sourceMappingURL=errors.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/atoms/loader.js

const DEFAULT_LOADER = '@recoil-toolkit.loader.global';
const loader = (0,es.atomFamily)({
    key: '@recoil-toolkit.loader',
    default: 0,
});
const isLoading = (0,es.selectorFamily)({
    key: '@recoil-toolkit.loader.isLoading',
    get: (key) => ({ get }) => get(loader(key)) > 0,
});
const useIsLoading = (key) => (0,es.useRecoilValue)(isLoading(key || DEFAULT_LOADER));
//# sourceMappingURL=loader.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/types.js
// eslint-disable-next-line no-shadow
var TaskStatus;
(function (TaskStatus) {
    TaskStatus[TaskStatus["Running"] = 0] = "Running";
    TaskStatus[TaskStatus["Error"] = 1] = "Error";
    TaskStatus[TaskStatus["Done"] = 2] = "Done";
})(TaskStatus || (TaskStatus = {}));
//# sourceMappingURL=types.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/atoms/tasks.js


const tasks = (0,es.atom)({
    key: '@recoil-toolkit.tasks',
    default: [],
});
const runningTasks = (0,es.selector)({
    key: '@recoil-toolkit.runningTasks',
    get: ({ get }) => get(tasks).filter(t => t.status === TaskStatus.Running),
});
const taskById = (0,es.selectorFamily)({
    key: '@recoil-toolkit.taskById',
    get: (id) => ({ get }) => {
        return get(tasks).find(t => t.id === id);
    },
});
const lastTaskByKey = (0,es.selectorFamily)({
    key: '@recoil-toolkit.lastTaskType',
    get: (key) => ({ get }) => {
        return get(tasks)
            .filter(t => { var _a; return ((_a = t === null || t === void 0 ? void 0 : t.options) === null || _a === void 0 ? void 0 : _a.key) === key; })
            .pop();
    },
});
const useRunningTasks = () => (0,es.useRecoilValue)(runningTasks);
//# sourceMappingURL=tasks.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/atoms/index.js



//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/devtools/consts.js
const RecoilToolkitDevTools = {
    consolePrefix: 'recoil-toolkit: ',
    eventMessageFromPage: '@recoil-toolkit/msg-from-web-page',
    eventMessageToPage: '@recoil-toolkit/msg-to-web-page',
    enableConsole: '@recoil-toolkit/enable-content-script-console',
};
//# sourceMappingURL=consts.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/devtools/getSnapshotState.js
//todo traverse and json stringify Errors
function getSnapshotState(snapshot) {
    var _a;
    const nodes = [];
    for (const node of snapshot.getNodes_UNSTABLE({ isInitialized: true })) {
        const nodeInfo = snapshot.getInfo_UNSTABLE(node);
        const loadable = snapshot.getLoadable(node);
        const subNodes = [];
        for (const comp of nodeInfo.subscribers.nodes) {
            subNodes.push(comp.key);
        }
        nodes.sort((a, b) => a.key.localeCompare(b.key));
        nodes.push({
            key: node.key,
            type: nodeInfo.type,
            // isSet: nodeInfo.isSet,
            // isActive: nodeInfo.isActive,
            isModified: nodeInfo.isModified,
            subNodes,
            state: loadable.state,
            value: loadable.state === 'hasValue'
                ? loadable.contents
                : loadable.state === 'loading'
                    ? '... loading ...'
                    : JSON.stringify(((_a = loadable.contents) === null || _a === void 0 ? void 0 : _a.message) || loadable.contents),
        });
    }
    return {
        id: snapshot.getID().toString(),
        nodes,
    };
}
//# sourceMappingURL=getSnapshotState.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/devtools/RecoilDevTools.js




/*const stringifyCircularJSON = obj => {
   const seen = new WeakSet();
   return JSON.stringify(obj, (k, v) => {
      if (v !== null && typeof v === 'object') {
         if (seen.has(v)) return '[Circular]';
         seen.add(v);
      }
      return v;
   });
};*/
const RecoilDevTools = ({ enableConsole, forceSerialize, serializer }) => {
    const snapshot = (0,es.useRecoilSnapshot)();
    (0,react.useEffect)(() => {
        window.postMessage({ type: RecoilToolkitDevTools.enableConsole, enable: !!enableConsole }, '*');
    }, [enableConsole]);
    /** Send Snapshot to DevTools **/
    (0,react.useEffect)(() => {
        const snapState = getSnapshotState(snapshot);
        window.postMessage({
            type: RecoilToolkitDevTools.eventMessageFromPage,
            data: forceSerialize
                ? JSON.parse(serializer ? serializer(snapState) : JSON.stringify(snapState))
                : snapState,
        }, '*');
    }, [snapshot]); //eslint-disable-line
    /** Listen messages from DevTools **/
    (0,react.useEffect)(() => {
        const onMessage = function (event) {
            // We only accept messages from ourselves
            if (event.source !== window)
                return;
            if (event.data.type && event.data.type === RecoilToolkitDevTools.eventMessageToPage) {
                console.log('DebugObserver Message Received: ', event.data);
            }
        };
        window.addEventListener('message', onMessage, false);
        return () => {
            window.removeEventListener('message', onMessage, false);
        };
    }, []);
    return null;
};
//# sourceMappingURL=RecoilDevTools.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/devtools/index.js

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/updaters/tasks.js


const pushTask = ({ parentId, id, options, args, extra, }) => push({
    parentId,
    id,
    args,
    status: TaskStatus.Running,
    options,
    extra,
    startedAt: new Date(),
});
const updateTaskDone = ({ data, id }) => updateObj({ status: TaskStatus.Done, data, endAt: new Date() }, {
    id,
});
const updateTaskError = ({ error, id }) => updateObj({ status: TaskStatus.Error, error, endAt: new Date() }, {
    id,
});
//# sourceMappingURL=tasks.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/updaters/errors.js


const pushError = ({ key, error, taskId }) => push({ key, error, id: uniqueId(), taskId }, ERRORS_STACK_SIZE);
//# sourceMappingURL=errors.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/updaters/index.js


//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/hooks/waitFor.js
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

const cancelledTaskMap = new Map();
const createCancelled = (taskId) => () => cancelledTaskMap.get(taskId) || false;
const createWaitFor = (cancelled) => (promiseOrMs) => __awaiter(void 0, void 0, void 0, function* () {
    if (typeof promiseOrMs === 'number') {
        const d = promiseOrMs < 0 ? 0 : Math.trunc(promiseOrMs);
        const times = Math.trunc(d / 50);
        for (let i = 0; i < times; i++) {
            yield delay(50);
            if (cancelled())
                throw new Error('Cancelled!');
        }
        return;
    }
    else {
        const data = yield promiseOrMs;
        if (cancelled())
            throw new Error('Cancelled!');
        return data;
    }
});
const cancelTask = (taskId) => {
    cancelledTaskMap.set(taskId, true);
};
//# sourceMappingURL=waitFor.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/hooks/fork.js
var fork_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};




const createFork = (parentId, recoil) => (taskCreator, args, debugKey) => {
    /* child task id */
    const id = uniqueId();
    const cancelledChild = createCancelled(id);
    const cancelled = () => recoil.cancelled() || cancelledChild();
    const cancel = () => cancelTask(id);
    const waitFor = createWaitFor(cancelled);
    /* injected current snapshot */
    const snapshot = recoil.getSnapshot();
    const childRecoil = Object.assign(Object.assign({}, recoil), { snapshot,
        waitFor,
        cancelled });
    /* injected fork recursively */
    const fork = createFork(id, childRecoil);
    const execute = taskCreator(Object.assign(Object.assign({}, childRecoil), { fork }));
    const childTaskObj = {
        parentId,
        id,
        args,
        options: debugKey ? { key: debugKey } : undefined,
    };
    const taskRunner = () => fork_awaiter(void 0, void 0, void 0, function* () {
        try {
            recoil.set(tasks, pushTask(childTaskObj));
            const data = yield execute(...args);
            recoil.set(tasks, updateTaskDone({ data, id }));
            return data;
        }
        catch (error) {
            recoil.set(tasks, updateTaskError({ error, id }));
        }
    });
    /* run child task */
    const task = taskRunner();
    const getTaskState = () => recoil.getLoadable(taskById(id)).getValue();
    return { id, cancel, task, getTaskState };
};
//# sourceMappingURL=fork.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/hooks/useRecoilTask.js
var useRecoilTask_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};








function useRecoilTask(taskCreator, deps, options) {
    const optionsRef = (0,react.useRef)(options || {}); //options freeze
    const { cancelOnUnmount, key, errorStack, loaderStack, exclusive, dataSelector, autoStart } = optionsRef.current;
    if (exclusive && !key) {
        throw new Error('Exclusive tasks must have a key!');
    }
    const [taskId, setTaskId] = (0,react.useState)(0);
    const task = (0,es.useRecoilValue)(exclusive ? lastTaskByKey(key || '') : taskById(taskId));
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const taskData = dataSelector ? (0,es.useRecoilValue)(dataSelector) : task === null || task === void 0 ? void 0 : task.data;
    const getSnapshot = useRecoilCurrentSnapshot();
    const getLoadable = useRecoilCurrentGetLoadable();
    const execute = (0,es.useRecoilCallback)((_a) => {
        var { set, snapshot } = _a, rest = __rest(_a, ["set", "snapshot"]);
        return (...args) => useRecoilTask_awaiter(this, void 0, void 0, function* () {
            if (exclusive && key) {
                const t = snapshot.getLoadable(lastTaskByKey(key)).getValue();
                if (t && t.status === TaskStatus.Running)
                    return;
            }
            const id = uniqueId();
            setTaskId(id);
            const cancelled = createCancelled(id);
            const waitFor = createWaitFor(cancelled);
            const fork = createFork(id, Object.assign({ cancelled,
                waitFor,
                getSnapshot,
                getLoadable,
                set,
                snapshot }, rest));
            try {
                if (loaderStack)
                    set(loader(loaderStack === true ? DEFAULT_LOADER : loaderStack), show);
                set(tasks, pushTask({ id, options, args }));
                const data = yield taskCreator(Object.assign({ fork,
                    cancelled,
                    waitFor,
                    getSnapshot,
                    getLoadable,
                    set,
                    snapshot }, rest))(...args);
                set(tasks, updateTaskDone({ data, id }));
            }
            catch (error) {
                set(tasks, updateTaskError({ error, id }));
                if (errorStack) {
                    set(errors_errorStack, pushError({ key, error, taskId: id }));
                }
            }
            finally {
                if (loaderStack)
                    set(loader(loaderStack === true ? DEFAULT_LOADER : loaderStack), hide);
            }
        });
    }, deps);
    (0,react.useEffect)(() => {
        if (autoStart) {
            execute(...autoStart);
        }
    }, [execute]);
    (0,react.useEffect)(() => {
        if (cancelOnUnmount && taskId) {
            return () => {
                cancelTask(taskId);
            };
        }
    }, [taskId]);
    const resetTask = (0,react.useCallback)(() => {
        setTaskId(0);
    }, []);
    return {
        loading: (task === null || task === void 0 ? void 0 : task.status) === TaskStatus.Running,
        execute,
        error: task === null || task === void 0 ? void 0 : task.error,
        data: taskData,
        success: (task === null || task === void 0 ? void 0 : task.status) === TaskStatus.Done,
        taskId,
        resetTask,
    };
}
//# sourceMappingURL=useRecoilTask.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/hooks/index.js

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/redux/atoms.js


const reduxSelectorsMap = new Map();
const reduxSelectorsMapInv = new Map();
function getSelectorId(selectorFunc) {
    let cachedSelectorId = reduxSelectorsMapInv.get(selectorFunc);
    if (!cachedSelectorId) {
        const id = uniqueId();
        reduxSelectorsMapInv.set(selectorFunc, id);
        reduxSelectorsMap.set(id, selectorFunc);
        cachedSelectorId = id;
    }
    return cachedSelectorId;
}
const reduxState = (0,es.atom)({
    key: '@recoil-toolkit.reduxState',
    default: undefined,
});
const reduxSelectorFamily = (0,es.selectorFamily)({
    key: '@recoil-toolkit.reduxSelectors',
    get: (selectorId) => ({ get }) => {
        const currentReduxState = get(reduxState);
        const selectorFunc = reduxSelectorsMap.get(selectorId);
        return currentReduxState && selectorFunc ? selectorFunc(currentReduxState) : undefined;
    },
});
function reduxSelector(selector) {
    return reduxSelectorFamily(getSelectorId(selector));
}
//# sourceMappingURL=atoms.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/redux/context.js

const RecoilReduxContext = (0,react.createContext)({});
//# sourceMappingURL=context.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/redux/hooks.js




function useSelector(selector) {
    return (0,es.useRecoilValue)(reduxSelector(selector));
}
function useDispatch() {
    const { store } = (0,react.useContext)(RecoilReduxContext);
    if (!store)
        throw new Error('RecoilReduxBridge with store not found!');
    return store.dispatch;
}
//# sourceMappingURL=hooks.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/redux/RecoilReduxBridge.js




const RecoilReduxBridge = ({ store, children }) => {
    const set = useRecoilCurrentSet();
    const [sub, setSub] = (0,react.useState)(false);
    (0,react.useEffect)(() => {
        const unsub = store.subscribe(() => {
            set(reduxState, store.getState());
        });
        set(reduxState, store.getState());
        setSub(true);
        return unsub;
    }, []);
    return (0,react.createElement)(RecoilReduxContext.Provider, {
        children: sub ? children : undefined,
        value: { store },
    });
};
//# sourceMappingURL=RecoilReduxBridge.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/redux/index.js



//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/index.js







//# sourceMappingURL=index.js.map

/***/ }),

/***/ 69853:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DefaultValue": function() { return /* binding */ Recoil_index_1; },
/* harmony export */   "RecoilEnv": function() { return /* binding */ Recoil_index_4; },
/* harmony export */   "RecoilLoadable": function() { return /* binding */ Recoil_index_3; },
/* harmony export */   "RecoilRoot": function() { return /* binding */ Recoil_index_5; },
/* harmony export */   "atom": function() { return /* binding */ Recoil_index_8; },
/* harmony export */   "atomFamily": function() { return /* binding */ Recoil_index_10; },
/* harmony export */   "constSelector": function() { return /* binding */ Recoil_index_12; },
/* harmony export */   "errorSelector": function() { return /* binding */ Recoil_index_13; },
/* harmony export */   "isRecoilValue": function() { return /* binding */ Recoil_index_2; },
/* harmony export */   "noWait": function() { return /* binding */ Recoil_index_15; },
/* harmony export */   "readOnlySelector": function() { return /* binding */ Recoil_index_14; },
/* harmony export */   "retentionZone": function() { return /* binding */ Recoil_index_38; },
/* harmony export */   "selector": function() { return /* binding */ Recoil_index_9; },
/* harmony export */   "selectorFamily": function() { return /* binding */ Recoil_index_11; },
/* harmony export */   "snapshot_UNSTABLE": function() { return /* binding */ Recoil_index_36; },
/* harmony export */   "useGetRecoilValueInfo_UNSTABLE": function() { return /* binding */ Recoil_index_26; },
/* harmony export */   "useGotoRecoilSnapshot": function() { return /* binding */ Recoil_index_33; },
/* harmony export */   "useRecoilBridgeAcrossReactRoots_UNSTABLE": function() { return /* binding */ Recoil_index_7; },
/* harmony export */   "useRecoilCallback": function() { return /* binding */ Recoil_index_31; },
/* harmony export */   "useRecoilRefresher_UNSTABLE": function() { return /* binding */ Recoil_index_27; },
/* harmony export */   "useRecoilSnapshot": function() { return /* binding */ Recoil_index_34; },
/* harmony export */   "useRecoilState": function() { return /* binding */ Recoil_index_22; },
/* harmony export */   "useRecoilStateLoadable": function() { return /* binding */ Recoil_index_23; },
/* harmony export */   "useRecoilState_TRANSITION_SUPPORT_UNSTABLE": function() { return /* binding */ Recoil_index_30; },
/* harmony export */   "useRecoilStoreID": function() { return /* binding */ Recoil_index_6; },
/* harmony export */   "useRecoilTransactionObserver_UNSTABLE": function() { return /* binding */ Recoil_index_35; },
/* harmony export */   "useRecoilTransaction_UNSTABLE": function() { return /* binding */ Recoil_index_32; },
/* harmony export */   "useRecoilValue": function() { return /* binding */ Recoil_index_20; },
/* harmony export */   "useRecoilValueLoadable": function() { return /* binding */ Recoil_index_21; },
/* harmony export */   "useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE": function() { return /* binding */ Recoil_index_28; },
/* harmony export */   "useRecoilValue_TRANSITION_SUPPORT_UNSTABLE": function() { return /* binding */ Recoil_index_29; },
/* harmony export */   "useResetRecoilState": function() { return /* binding */ Recoil_index_25; },
/* harmony export */   "useRetain": function() { return /* binding */ Recoil_index_37; },
/* harmony export */   "useSetRecoilState": function() { return /* binding */ Recoil_index_24; },
/* harmony export */   "waitForAll": function() { return /* binding */ Recoil_index_18; },
/* harmony export */   "waitForAllSettled": function() { return /* binding */ Recoil_index_19; },
/* harmony export */   "waitForAny": function() { return /* binding */ Recoil_index_17; },
/* harmony export */   "waitForNone": function() { return /* binding */ Recoil_index_16; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31542);
/* provided dependency */ var process = __webpack_require__(14284);



/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

function err(message) {
  const error = new Error(message); // In V8, Error objects keep the closure scope chain alive until the
  // err.stack property is accessed.

  if (error.stack === undefined) {
    // IE sets the stack only if error is thrown
    try {
      throw error;
    } catch (_) {} // eslint-disable-line fb-www/no-unused-catch-bindings, no-empty

  }

  return error;
}

var err_1 = err;

// @oss-only


var Recoil_err = err_1;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

// Split declaration and implementation to allow this function to pretend to
// check for actual instance of Promise instead of something with a `then`
// method.
// eslint-disable-next-line no-redeclare
function isPromise(p) {
  return !!p && typeof p.then === 'function';
}

var Recoil_isPromise = isPromise;

function nullthrows(x, message) {
  if (x != null) {
    return x;
  }

  throw Recoil_err(message !== null && message !== void 0 ? message : 'Got unexpected null or undefined');
}

var Recoil_nullthrows = nullthrows;

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

class BaseLoadable {
  getValue() {
    throw Recoil_err('BaseLoadable');
  }

  toPromise() {
    throw Recoil_err('BaseLoadable');
  }

  valueMaybe() {
    throw Recoil_err('BaseLoadable');
  }

  valueOrThrow() {
    // $FlowFixMe[prop-missing]
    throw Recoil_err(`Loadable expected value, but in "${this.state}" state`);
  }

  promiseMaybe() {
    throw Recoil_err('BaseLoadable');
  }

  promiseOrThrow() {
    // $FlowFixMe[prop-missing]
    throw Recoil_err(`Loadable expected promise, but in "${this.state}" state`);
  }

  errorMaybe() {
    throw Recoil_err('BaseLoadable');
  }

  errorOrThrow() {
    // $FlowFixMe[prop-missing]
    throw Recoil_err(`Loadable expected error, but in "${this.state}" state`);
  }

  is(other) {
    // $FlowFixMe[prop-missing]
    return other.state === this.state && other.contents === this.contents;
  }

  map(_map) {
    throw Recoil_err('BaseLoadable');
  }

}

class ValueLoadable extends BaseLoadable {
  constructor(value) {
    super();

    _defineProperty(this, "state", 'hasValue');

    _defineProperty(this, "contents", void 0);

    this.contents = value;
  }

  getValue() {
    return this.contents;
  }

  toPromise() {
    return Promise.resolve(this.contents);
  }

  valueMaybe() {
    return this.contents;
  }

  valueOrThrow() {
    return this.contents;
  }

  promiseMaybe() {
    return undefined;
  }

  errorMaybe() {
    return undefined;
  }

  map(map) {
    try {
      const next = map(this.contents);
      return Recoil_isPromise(next) ? loadableWithPromise(next) : isLoadable(next) ? next : loadableWithValue(next);
    } catch (e) {
      return Recoil_isPromise(e) ? // If we "suspended", then try again.
      // errors and subsequent retries will be handled in 'loading' case
      // $FlowFixMe[prop-missing]
      loadableWithPromise(e.next(() => this.map(map))) : loadableWithError(e);
    }
  }

}

class ErrorLoadable extends BaseLoadable {
  constructor(error) {
    super();

    _defineProperty(this, "state", 'hasError');

    _defineProperty(this, "contents", void 0);

    this.contents = error;
  }

  getValue() {
    throw this.contents;
  }

  toPromise() {
    return Promise.reject(this.contents);
  }

  valueMaybe() {
    return undefined;
  }

  promiseMaybe() {
    return undefined;
  }

  errorMaybe() {
    return this.contents;
  }

  errorOrThrow() {
    return this.contents;
  }

  map(_map) {
    // $FlowIssue[incompatible-return]
    return this;
  }

}

class LoadingLoadable extends BaseLoadable {
  constructor(promise) {
    super();

    _defineProperty(this, "state", 'loading');

    _defineProperty(this, "contents", void 0);

    this.contents = promise;
  }

  getValue() {
    throw this.contents;
  }

  toPromise() {
    return this.contents;
  }

  valueMaybe() {
    return undefined;
  }

  promiseMaybe() {
    return this.contents;
  }

  promiseOrThrow() {
    return this.contents;
  }

  errorMaybe() {
    return undefined;
  }

  map(map) {
    return loadableWithPromise(this.contents.then(value => {
      const next = map(value);

      if (isLoadable(next)) {
        const nextLoadable = next;

        switch (nextLoadable.state) {
          case 'hasValue':
            return nextLoadable.contents;

          case 'hasError':
            throw nextLoadable.contents;

          case 'loading':
            return nextLoadable.contents;
        }
      } // $FlowIssue[incompatible-return]


      return next;
    }) // $FlowFixMe[incompatible-call]
    .catch(e => {
      if (Recoil_isPromise(e)) {
        // we were "suspended," try again
        return e.then(() => this.map(map).contents);
      }

      throw e;
    }));
  }

}

function loadableWithValue(value) {
  return Object.freeze(new ValueLoadable(value));
}

function loadableWithError(error) {
  return Object.freeze(new ErrorLoadable(error));
}

function loadableWithPromise(promise) {
  return Object.freeze(new LoadingLoadable(promise));
}

function loadableLoading() {
  return Object.freeze(new LoadingLoadable(new Promise(() => {})));
}

function loadableAllArray(inputs) {
  return inputs.every(i => i.state === 'hasValue') ? loadableWithValue(inputs.map(i => i.contents)) : inputs.some(i => i.state === 'hasError') ? loadableWithError(Recoil_nullthrows(inputs.find(i => i.state === 'hasError'), 'Invalid loadable passed to loadableAll').contents) : loadableWithPromise(Promise.all(inputs.map(i => i.contents)));
}

function loadableAll(inputs) {
  const unwrapedInputs = Array.isArray(inputs) ? inputs : Object.getOwnPropertyNames(inputs).map(key => inputs[key]);
  const normalizedInputs = unwrapedInputs.map(x => isLoadable(x) ? x : Recoil_isPromise(x) ? loadableWithPromise(x) : loadableWithValue(x));
  const output = loadableAllArray(normalizedInputs);
  return Array.isArray(inputs) ? // $FlowIssue[incompatible-return]
  output : // Object.getOwnPropertyNames() has consistent key ordering with ES6
  // $FlowIssue[incompatible-call]
  output.map(outputs => Object.getOwnPropertyNames(inputs).reduce( // $FlowFixMe[invalid-computed-prop]
  (out, key, idx) => ({ ...out,
    [key]: outputs[idx]
  }), {}));
}

function isLoadable(x) {
  return x instanceof BaseLoadable;
}

const LoadableStaticInterface = {
  of: value => Recoil_isPromise(value) ? loadableWithPromise(value) : isLoadable(value) ? value : loadableWithValue(value),
  error: error => loadableWithError(error),
  // $FlowIssue[incompatible-return]
  loading: () => loadableLoading(),
  // $FlowIssue[unclear-type]
  all: loadableAll,
  isLoadable
};
var Recoil_Loadable = {
  loadableWithValue,
  loadableWithError,
  loadableWithPromise,
  loadableLoading,
  loadableAll,
  isLoadable,
  RecoilLoadable: LoadableStaticInterface
};

var Recoil_Loadable_1 = Recoil_Loadable.loadableWithValue;
var Recoil_Loadable_2 = Recoil_Loadable.loadableWithError;
var Recoil_Loadable_3 = Recoil_Loadable.loadableWithPromise;
var Recoil_Loadable_4 = Recoil_Loadable.loadableLoading;
var Recoil_Loadable_5 = Recoil_Loadable.loadableAll;
var Recoil_Loadable_6 = Recoil_Loadable.isLoadable;
var Recoil_Loadable_7 = Recoil_Loadable.RecoilLoadable;

var Recoil_Loadable$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  loadableWithValue: Recoil_Loadable_1,
  loadableWithError: Recoil_Loadable_2,
  loadableWithPromise: Recoil_Loadable_3,
  loadableLoading: Recoil_Loadable_4,
  loadableAll: Recoil_Loadable_5,
  isLoadable: Recoil_Loadable_6,
  RecoilLoadable: Recoil_Loadable_7
});

const env = {
  RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED: true,
  // Note: RECOIL_GKS_ENABLED settings will only be honored in OSS builds of Recoil
  RECOIL_GKS_ENABLED: new Set(['recoil_hamt_2020', 'recoil_sync_external_store', 'recoil_suppress_rerender_in_callback', 'recoil_memory_managament_2020'])
};

function readProcessEnvBooleanFlag(name, set) {
  var _process$env$name, _process$env$name$toL;

  const sanitizedValue = (_process$env$name = process.env[name]) === null || _process$env$name === void 0 ? void 0 : (_process$env$name$toL = _process$env$name.toLowerCase()) === null || _process$env$name$toL === void 0 ? void 0 : _process$env$name$toL.trim();

  if (sanitizedValue == null || sanitizedValue === '') {
    return;
  }

  const allowedValues = ['true', 'false'];

  if (!allowedValues.includes(sanitizedValue)) {
    throw Recoil_err(`process.env.${name} value must be 'true', 'false', or empty: ${sanitizedValue}`);
  }

  set(sanitizedValue === 'true');
}

function readProcessEnvStringArrayFlag(name, set) {
  var _process$env$name2;

  const sanitizedValue = (_process$env$name2 = process.env[name]) === null || _process$env$name2 === void 0 ? void 0 : _process$env$name2.trim();

  if (sanitizedValue == null || sanitizedValue === '') {
    return;
  }

  set(sanitizedValue.split(/\s*,\s*|\s+/));
}
/**
 * Allow NodeJS/NextJS/etc to set the initial state through process.env variable
 * Note:  we don't assume 'process' is available in all runtime environments
 *
 * @see https://github.com/facebookexperimental/Recoil/issues/733
 */


function applyProcessEnvFlagOverrides() {
  var _process;

  // note: this check is needed in addition to the check below, runtime error will occur without it!
  // eslint-disable-next-line fb-www/typeof-undefined
  if (typeof process === 'undefined') {
    return;
  }

  if (((_process = process) === null || process === void 0 ? void 0 : process.env) == null) {
    return;
  }

  readProcessEnvBooleanFlag('RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED', value => {
    env.RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED = value;
  });
  readProcessEnvStringArrayFlag('RECOIL_GKS_ENABLED', value => {
    value.forEach(gk => {
      env.RECOIL_GKS_ENABLED.add(gk);
    });
  });
}

applyProcessEnvFlagOverrides();
var Recoil_RecoilEnv = env;

function Recoil_gkx_OSS(gk) {
  return Recoil_RecoilEnv.RECOIL_GKS_ENABLED.has(gk);
}

Recoil_gkx_OSS.setPass = gk => {
  Recoil_RecoilEnv.RECOIL_GKS_ENABLED.add(gk);
};

Recoil_gkx_OSS.setFail = gk => {
  Recoil_RecoilEnv.RECOIL_GKS_ENABLED.delete(gk);
};

Recoil_gkx_OSS.clear = () => {
  Recoil_RecoilEnv.RECOIL_GKS_ENABLED.clear();
};

var Recoil_gkx = Recoil_gkx_OSS; // @oss-only

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

function recoverableViolation(message, _projectName, {
  error
} = {}) {
  if (false) {}

  return null;
}

var recoverableViolation_1 = recoverableViolation;

// @oss-only


var Recoil_recoverableViolation = recoverableViolation_1;

var _createMutableSource, _useMutableSource, _useSyncExternalStore;







const createMutableSource = // flowlint-next-line unclear-type:off
(_createMutableSource = react__WEBPACK_IMPORTED_MODULE_0__.createMutableSource) !== null && _createMutableSource !== void 0 ? _createMutableSource : react__WEBPACK_IMPORTED_MODULE_0__.unstable_createMutableSource;
const useMutableSource = // flowlint-next-line unclear-type:off
(_useMutableSource = react__WEBPACK_IMPORTED_MODULE_0__.useMutableSource) !== null && _useMutableSource !== void 0 ? _useMutableSource : react__WEBPACK_IMPORTED_MODULE_0__.unstable_useMutableSource; // https://github.com/reactwg/react-18/discussions/86

const useSyncExternalStore = // flowlint-next-line unclear-type:off
(_useSyncExternalStore = react__WEBPACK_IMPORTED_MODULE_0__.useSyncExternalStore) !== null && _useSyncExternalStore !== void 0 ? _useSyncExternalStore : // flowlint-next-line unclear-type:off
react__WEBPACK_IMPORTED_MODULE_0__.unstable_useSyncExternalStore;
let ReactRendererVersionMismatchWarnOnce = false; // Check if the current renderer supports `useSyncExternalStore()`.
// Since React goes through a proxy dispatcher and the current renderer can
// change we can't simply check if `React.useSyncExternalStore()` is defined.

function currentRendererSupportsUseSyncExternalStore() {
  var _ReactCurrentDispatch;

  // $FlowFixMe[incompatible-use]
  const {
    ReactCurrentDispatcher,
    ReactCurrentOwner
  } =
  /* $FlowFixMe[prop-missing] This workaround was approved as a safer mechanism
   * to detect if the current renderer supports useSyncExternalStore()
   * https://fb.workplace.com/groups/reactjs/posts/9558682330846963/ */
  react__WEBPACK_IMPORTED_MODULE_0__.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  const dispatcher = (_ReactCurrentDispatch = ReactCurrentDispatcher === null || ReactCurrentDispatcher === void 0 ? void 0 : ReactCurrentDispatcher.current) !== null && _ReactCurrentDispatch !== void 0 ? _ReactCurrentDispatch : ReactCurrentOwner.currentDispatcher;
  const isUseSyncExternalStoreSupported = dispatcher.useSyncExternalStore != null;

  if (useSyncExternalStore && !isUseSyncExternalStoreSupported && !ReactRendererVersionMismatchWarnOnce) {
    ReactRendererVersionMismatchWarnOnce = true;
    Recoil_recoverableViolation('A React renderer without React 18+ API support is being used with React 18+.');
  }

  return isUseSyncExternalStoreSupported;
}

/**
 * mode: The React API and approach to use for syncing state with React
 * early: Re-renders from Recoil updates occur:
 *    1) earlier
 *    2) in sync with React updates in the same batch
 *    3) before transaction observers instead of after.
 * concurrent: Is the current mode compatible with Concurrent Mode and useTransition()
 */
function reactMode() {
  // NOTE: This mode is currently broken with some Suspense cases
  // see Recoil_selector-test.js
  if (Recoil_gkx('recoil_transition_support')) {
    return {
      mode: 'TRANSITION_SUPPORT',
      early: true,
      concurrent: true
    };
  }

  if (Recoil_gkx('recoil_sync_external_store') && useSyncExternalStore != null) {
    return {
      mode: 'SYNC_EXTERNAL_STORE',
      early: true,
      concurrent: false
    };
  }

  if (Recoil_gkx('recoil_mutable_source') && useMutableSource != null && typeof window !== 'undefined' && !window.$disableRecoilValueMutableSource_TEMP_HACK_DO_NOT_USE) {
    return Recoil_gkx('recoil_suppress_rerender_in_callback') ? {
      mode: 'MUTABLE_SOURCE',
      early: true,
      concurrent: true
    } : {
      mode: 'MUTABLE_SOURCE',
      early: false,
      concurrent: false
    };
  }

  return Recoil_gkx('recoil_suppress_rerender_in_callback') ? {
    mode: 'LEGACY',
    early: true,
    concurrent: false
  } : {
    mode: 'LEGACY',
    early: false,
    concurrent: false
  };
} // TODO Need to figure out if there is a standard/open-source equivalent to see if hot module replacement is happening:


function isFastRefreshEnabled() {
  // @fb-only: const {isAcceptingUpdate} = require('__debug');
  // @fb-only: return typeof isAcceptingUpdate === 'function' && isAcceptingUpdate();
  return false; // @oss-only
}

var Recoil_ReactMode = {
  createMutableSource,
  useMutableSource,
  useSyncExternalStore,
  currentRendererSupportsUseSyncExternalStore,
  reactMode,
  isFastRefreshEnabled
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

// eslint-disable-next-line no-unused-vars
class AbstractRecoilValue {
  constructor(newKey) {
    _defineProperty(this, "key", void 0);

    this.key = newKey;
  }

  toJSON() {
    return {
      key: this.key
    };
  }

}

class RecoilState extends AbstractRecoilValue {}

class RecoilValueReadOnly extends AbstractRecoilValue {}

function isRecoilValue(x) {
  return x instanceof RecoilState || x instanceof RecoilValueReadOnly;
}

var Recoil_RecoilValue = {
  AbstractRecoilValue,
  RecoilState,
  RecoilValueReadOnly,
  isRecoilValue
};

var Recoil_RecoilValue_1 = Recoil_RecoilValue.AbstractRecoilValue;
var Recoil_RecoilValue_2 = Recoil_RecoilValue.RecoilState;
var Recoil_RecoilValue_3 = Recoil_RecoilValue.RecoilValueReadOnly;
var Recoil_RecoilValue_4 = Recoil_RecoilValue.isRecoilValue;

var Recoil_RecoilValue$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  AbstractRecoilValue: Recoil_RecoilValue_1,
  RecoilState: Recoil_RecoilValue_2,
  RecoilValueReadOnly: Recoil_RecoilValue_3,
  isRecoilValue: Recoil_RecoilValue_4
});

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

function sprintf(format, ...args) {
  let index = 0;
  return format.replace(/%s/g, () => String(args[index++]));
}

var sprintf_1 = (/* unused pure expression or super */ null && (sprintf));

function expectationViolation(format, ...args) {
  if (false) {}
}

var expectationViolation_1 = expectationViolation;

// @oss-only


var Recoil_expectationViolation = expectationViolation_1;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/**
 * Creates a new iterable whose output is generated by passing the input
 * iterable's values through the mapper function.
 */

function mapIterable(iterable, callback) {
  // Use generator to create iterable/iterator
  return function* () {
    let index = 0;

    for (const value of iterable) {
      yield callback(value, index++);
    }
  }();
}

var Recoil_mapIterable = mapIterable;

const {
  isFastRefreshEnabled: isFastRefreshEnabled$1
} = Recoil_ReactMode;















class DefaultValue {}

const DEFAULT_VALUE = new DefaultValue();
// flowlint-next-line unclear-type:off
const nodes = new Map(); // flowlint-next-line unclear-type:off

const recoilValues = new Map();
/* eslint-disable no-redeclare */

function recoilValuesForKeys(keys) {
  return Recoil_mapIterable(keys, key => Recoil_nullthrows(recoilValues.get(key)));
}

function checkForDuplicateAtomKey(key) {
  if (nodes.has(key)) {
    const message = `Duplicate atom key "${key}". This is a FATAL ERROR in
      production. But it is safe to ignore this warning if it occurred because of
      hot module replacement.`;

    if (false) {} else {
      // @fb-only: recoverableViolation(message, 'recoil');
      console.warn(message); // @oss-only
    }
  }
}

function registerNode(node) {
  if (Recoil_RecoilEnv.RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED) {
    checkForDuplicateAtomKey(node.key);
  }

  nodes.set(node.key, node);
  const recoilValue = node.set == null ? new Recoil_RecoilValue$1.RecoilValueReadOnly(node.key) : new Recoil_RecoilValue$1.RecoilState(node.key);
  recoilValues.set(node.key, recoilValue);
  return recoilValue;
}
/* eslint-enable no-redeclare */


class NodeMissingError extends Error {} // flowlint-next-line unclear-type:off


function getNode(key) {
  const node = nodes.get(key);

  if (node == null) {
    throw new NodeMissingError(`Missing definition for RecoilValue: "${key}""`);
  }

  return node;
} // flowlint-next-line unclear-type:off


function getNodeMaybe(key) {
  return nodes.get(key);
}

const configDeletionHandlers = new Map();

function deleteNodeConfigIfPossible(key) {
  var _node$shouldDeleteCon;

  if (!Recoil_gkx('recoil_memory_managament_2020')) {
    return;
  }

  const node = nodes.get(key);

  if (node !== null && node !== void 0 && (_node$shouldDeleteCon = node.shouldDeleteConfigOnRelease) !== null && _node$shouldDeleteCon !== void 0 && _node$shouldDeleteCon.call(node)) {
    var _getConfigDeletionHan;

    nodes.delete(key);
    (_getConfigDeletionHan = getConfigDeletionHandler(key)) === null || _getConfigDeletionHan === void 0 ? void 0 : _getConfigDeletionHan();
    configDeletionHandlers.delete(key);
  }
}

function setConfigDeletionHandler(key, fn) {
  if (!Recoil_gkx('recoil_memory_managament_2020')) {
    return;
  }

  if (fn === undefined) {
    configDeletionHandlers.delete(key);
  } else {
    configDeletionHandlers.set(key, fn);
  }
}

function getConfigDeletionHandler(key) {
  return configDeletionHandlers.get(key);
}

var Recoil_Node = {
  nodes,
  recoilValues,
  registerNode,
  getNode,
  getNodeMaybe,
  deleteNodeConfigIfPossible,
  setConfigDeletionHandler,
  getConfigDeletionHandler,
  recoilValuesForKeys,
  NodeMissingError,
  DefaultValue,
  DEFAULT_VALUE
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

function enqueueExecution(s, f) {
  f();
}

var Recoil_Queue = {
  enqueueExecution
};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var hamt_1 = createCommonjsModule(function (module) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
/**
    @fileOverview Hash Array Mapped Trie.

    Code based on: https://github.com/exclipy/pdata
*/


var hamt = {}; // export

/* Configuration
 ******************************************************************************/

var SIZE = 5;
var BUCKET_SIZE = Math.pow(2, SIZE);
var MASK = BUCKET_SIZE - 1;
var MAX_INDEX_NODE = BUCKET_SIZE / 2;
var MIN_ARRAY_NODE = BUCKET_SIZE / 4;
/*
 ******************************************************************************/

var nothing = {};

var constant = function constant(x) {
  return function () {
    return x;
  };
};
/**
    Get 32 bit hash of string.

    Based on:
    http://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript-jquery
*/


var hash = hamt.hash = function (str) {
  var type = typeof str === 'undefined' ? 'undefined' : _typeof(str);
  if (type === 'number') return str;
  if (type !== 'string') str += '';
  var hash = 0;

  for (var i = 0, len = str.length; i < len; ++i) {
    var c = str.charCodeAt(i);
    hash = (hash << 5) - hash + c | 0;
  }

  return hash;
};
/* Bit Ops
 ******************************************************************************/

/**
    Hamming weight.

    Taken from: http://jsperf.com/hamming-weight
*/


var popcount = function popcount(x) {
  x -= x >> 1 & 0x55555555;
  x = (x & 0x33333333) + (x >> 2 & 0x33333333);
  x = x + (x >> 4) & 0x0f0f0f0f;
  x += x >> 8;
  x += x >> 16;
  return x & 0x7f;
};

var hashFragment = function hashFragment(shift, h) {
  return h >>> shift & MASK;
};

var toBitmap = function toBitmap(x) {
  return 1 << x;
};

var fromBitmap = function fromBitmap(bitmap, bit) {
  return popcount(bitmap & bit - 1);
};
/* Array Ops
 ******************************************************************************/

/**
    Set a value in an array.

    @param mutate Should the input array be mutated?
    @param at Index to change.
    @param v New value
    @param arr Array.
*/


var arrayUpdate = function arrayUpdate(mutate, at, v, arr) {
  var out = arr;

  if (!mutate) {
    var len = arr.length;
    out = new Array(len);

    for (var i = 0; i < len; ++i) {
      out[i] = arr[i];
    }
  }

  out[at] = v;
  return out;
};
/**
    Remove a value from an array.

    @param mutate Should the input array be mutated?
    @param at Index to remove.
    @param arr Array.
*/


var arraySpliceOut = function arraySpliceOut(mutate, at, arr) {
  var newLen = arr.length - 1;
  var i = 0;
  var g = 0;
  var out = arr;

  if (mutate) {
    i = g = at;
  } else {
    out = new Array(newLen);

    while (i < at) {
      out[g++] = arr[i++];
    }
  }

  ++i;

  while (i <= newLen) {
    out[g++] = arr[i++];
  }

  if (mutate) {
    out.length = newLen;
  }

  return out;
};
/**
    Insert a value into an array.

    @param mutate Should the input array be mutated?
    @param at Index to insert at.
    @param v Value to insert,
    @param arr Array.
*/


var arraySpliceIn = function arraySpliceIn(mutate, at, v, arr) {
  var len = arr.length;

  if (mutate) {
    var _i = len;

    while (_i >= at) {
      arr[_i--] = arr[_i];
    }

    arr[at] = v;
    return arr;
  }

  var i = 0,
      g = 0;
  var out = new Array(len + 1);

  while (i < at) {
    out[g++] = arr[i++];
  }

  out[at] = v;

  while (i < len) {
    out[++g] = arr[i++];
  }

  return out;
};
/* Node Structures
 ******************************************************************************/


var LEAF = 1;
var COLLISION = 2;
var INDEX = 3;
var ARRAY = 4;
/**
    Empty node.
*/

var empty = {
  __hamt_isEmpty: true
};

var isEmptyNode = function isEmptyNode(x) {
  return x === empty || x && x.__hamt_isEmpty;
};
/**
    Leaf holding a value.

    @member edit Edit of the node.
    @member hash Hash of key.
    @member key Key.
    @member value Value stored.
*/


var Leaf = function Leaf(edit, hash, key, value) {
  return {
    type: LEAF,
    edit: edit,
    hash: hash,
    key: key,
    value: value,
    _modify: Leaf__modify
  };
};
/**
    Leaf holding multiple values with the same hash but different keys.

    @member edit Edit of the node.
    @member hash Hash of key.
    @member children Array of collision children node.
*/


var Collision = function Collision(edit, hash, children) {
  return {
    type: COLLISION,
    edit: edit,
    hash: hash,
    children: children,
    _modify: Collision__modify
  };
};
/**
    Internal node with a sparse set of children.

    Uses a bitmap and array to pack children.

  @member edit Edit of the node.
    @member mask Bitmap that encode the positions of children in the array.
    @member children Array of child nodes.
*/


var IndexedNode = function IndexedNode(edit, mask, children) {
  return {
    type: INDEX,
    edit: edit,
    mask: mask,
    children: children,
    _modify: IndexedNode__modify
  };
};
/**
    Internal node with many children.

    @member edit Edit of the node.
    @member size Number of children.
    @member children Array of child nodes.
*/


var ArrayNode = function ArrayNode(edit, size, children) {
  return {
    type: ARRAY,
    edit: edit,
    size: size,
    children: children,
    _modify: ArrayNode__modify
  };
};
/**
    Is `node` a leaf node?
*/


var isLeaf = function isLeaf(node) {
  return node === empty || node.type === LEAF || node.type === COLLISION;
};
/* Internal node operations.
 ******************************************************************************/

/**
    Expand an indexed node into an array node.

  @param edit Current edit.
    @param frag Index of added child.
    @param child Added child.
    @param mask Index node mask before child added.
    @param subNodes Index node children before child added.
*/


var expand = function expand(edit, frag, child, bitmap, subNodes) {
  var arr = [];
  var bit = bitmap;
  var count = 0;

  for (var i = 0; bit; ++i) {
    if (bit & 1) arr[i] = subNodes[count++];
    bit >>>= 1;
  }

  arr[frag] = child;
  return ArrayNode(edit, count + 1, arr);
};
/**
    Collapse an array node into a indexed node.

  @param edit Current edit.
    @param count Number of elements in new array.
    @param removed Index of removed element.
    @param elements Array node children before remove.
*/


var pack = function pack(edit, count, removed, elements) {
  var children = new Array(count - 1);
  var g = 0;
  var bitmap = 0;

  for (var i = 0, len = elements.length; i < len; ++i) {
    if (i !== removed) {
      var elem = elements[i];

      if (elem && !isEmptyNode(elem)) {
        children[g++] = elem;
        bitmap |= 1 << i;
      }
    }
  }

  return IndexedNode(edit, bitmap, children);
};
/**
    Merge two leaf nodes.

    @param shift Current shift.
    @param h1 Node 1 hash.
    @param n1 Node 1.
    @param h2 Node 2 hash.
    @param n2 Node 2.
*/


var mergeLeaves = function mergeLeaves(edit, shift, h1, n1, h2, n2) {
  if (h1 === h2) return Collision(edit, h1, [n2, n1]);
  var subH1 = hashFragment(shift, h1);
  var subH2 = hashFragment(shift, h2);
  return IndexedNode(edit, toBitmap(subH1) | toBitmap(subH2), subH1 === subH2 ? [mergeLeaves(edit, shift + SIZE, h1, n1, h2, n2)] : subH1 < subH2 ? [n1, n2] : [n2, n1]);
};
/**
    Update an entry in a collision list.

    @param mutate Should mutation be used?
    @param edit Current edit.
    @param keyEq Key compare function.
    @param hash Hash of collision.
    @param list Collision list.
    @param f Update function.
    @param k Key to update.
    @param size Size ref.
*/


var updateCollisionList = function updateCollisionList(mutate, edit, keyEq, h, list, f, k, size) {
  var len = list.length;

  for (var i = 0; i < len; ++i) {
    var child = list[i];

    if (keyEq(k, child.key)) {
      var value = child.value;

      var _newValue = f(value);

      if (_newValue === value) return list;

      if (_newValue === nothing) {
        --size.value;
        return arraySpliceOut(mutate, i, list);
      }

      return arrayUpdate(mutate, i, Leaf(edit, h, k, _newValue), list);
    }
  }

  var newValue = f();
  if (newValue === nothing) return list;
  ++size.value;
  return arrayUpdate(mutate, len, Leaf(edit, h, k, newValue), list);
};

var canEditNode = function canEditNode(edit, node) {
  return edit === node.edit;
};
/* Editing
 ******************************************************************************/


var Leaf__modify = function Leaf__modify(edit, keyEq, shift, f, h, k, size) {
  if (keyEq(k, this.key)) {
    var _v = f(this.value);

    if (_v === this.value) return this;else if (_v === nothing) {
      --size.value;
      return empty;
    }

    if (canEditNode(edit, this)) {
      this.value = _v;
      return this;
    }

    return Leaf(edit, h, k, _v);
  }

  var v = f();
  if (v === nothing) return this;
  ++size.value;
  return mergeLeaves(edit, shift, this.hash, this, h, Leaf(edit, h, k, v));
};

var Collision__modify = function Collision__modify(edit, keyEq, shift, f, h, k, size) {
  if (h === this.hash) {
    var canEdit = canEditNode(edit, this);
    var list = updateCollisionList(canEdit, edit, keyEq, this.hash, this.children, f, k, size);
    if (list === this.children) return this;
    return list.length > 1 ? Collision(edit, this.hash, list) : list[0]; // collapse single element collision list
  }

  var v = f();
  if (v === nothing) return this;
  ++size.value;
  return mergeLeaves(edit, shift, this.hash, this, h, Leaf(edit, h, k, v));
};

var IndexedNode__modify = function IndexedNode__modify(edit, keyEq, shift, f, h, k, size) {
  var mask = this.mask;
  var children = this.children;
  var frag = hashFragment(shift, h);
  var bit = toBitmap(frag);
  var indx = fromBitmap(mask, bit);
  var exists = mask & bit;
  var current = exists ? children[indx] : empty;

  var child = current._modify(edit, keyEq, shift + SIZE, f, h, k, size);

  if (current === child) return this;
  var canEdit = canEditNode(edit, this);
  var bitmap = mask;
  var newChildren = void 0;

  if (exists && isEmptyNode(child)) {
    // remove
    bitmap &= ~bit;
    if (!bitmap) return empty;
    if (children.length <= 2 && isLeaf(children[indx ^ 1])) return children[indx ^ 1]; // collapse

    newChildren = arraySpliceOut(canEdit, indx, children);
  } else if (!exists && !isEmptyNode(child)) {
    // add
    if (children.length >= MAX_INDEX_NODE) return expand(edit, frag, child, mask, children);
    bitmap |= bit;
    newChildren = arraySpliceIn(canEdit, indx, child, children);
  } else {
    // modify
    newChildren = arrayUpdate(canEdit, indx, child, children);
  }

  if (canEdit) {
    this.mask = bitmap;
    this.children = newChildren;
    return this;
  }

  return IndexedNode(edit, bitmap, newChildren);
};

var ArrayNode__modify = function ArrayNode__modify(edit, keyEq, shift, f, h, k, size) {
  var count = this.size;
  var children = this.children;
  var frag = hashFragment(shift, h);
  var child = children[frag];

  var newChild = (child || empty)._modify(edit, keyEq, shift + SIZE, f, h, k, size);

  if (child === newChild) return this;
  var canEdit = canEditNode(edit, this);
  var newChildren = void 0;

  if (isEmptyNode(child) && !isEmptyNode(newChild)) {
    // add
    ++count;
    newChildren = arrayUpdate(canEdit, frag, newChild, children);
  } else if (!isEmptyNode(child) && isEmptyNode(newChild)) {
    // remove
    --count;
    if (count <= MIN_ARRAY_NODE) return pack(edit, count, frag, children);
    newChildren = arrayUpdate(canEdit, frag, empty, children);
  } else {
    // modify
    newChildren = arrayUpdate(canEdit, frag, newChild, children);
  }

  if (canEdit) {
    this.size = count;
    this.children = newChildren;
    return this;
  }

  return ArrayNode(edit, count, newChildren);
};

empty._modify = function (edit, keyEq, shift, f, h, k, size) {
  var v = f();
  if (v === nothing) return empty;
  ++size.value;
  return Leaf(edit, h, k, v);
};
/*
 ******************************************************************************/


function Map(editable, edit, config, root, size) {
  this._editable = editable;
  this._edit = edit;
  this._config = config;
  this._root = root;
  this._size = size;
}

Map.prototype.setTree = function (newRoot, newSize) {
  if (this._editable) {
    this._root = newRoot;
    this._size = newSize;
    return this;
  }

  return newRoot === this._root ? this : new Map(this._editable, this._edit, this._config, newRoot, newSize);
};
/* Queries
 ******************************************************************************/

/**
    Lookup the value for `key` in `map` using a custom `hash`.

    Returns the value or `alt` if none.
*/


var tryGetHash = hamt.tryGetHash = function (alt, hash, key, map) {
  var node = map._root;
  var shift = 0;
  var keyEq = map._config.keyEq;

  while (true) {
    switch (node.type) {
      case LEAF:
        {
          return keyEq(key, node.key) ? node.value : alt;
        }

      case COLLISION:
        {
          if (hash === node.hash) {
            var children = node.children;

            for (var i = 0, len = children.length; i < len; ++i) {
              var child = children[i];
              if (keyEq(key, child.key)) return child.value;
            }
          }

          return alt;
        }

      case INDEX:
        {
          var frag = hashFragment(shift, hash);
          var bit = toBitmap(frag);

          if (node.mask & bit) {
            node = node.children[fromBitmap(node.mask, bit)];
            shift += SIZE;
            break;
          }

          return alt;
        }

      case ARRAY:
        {
          node = node.children[hashFragment(shift, hash)];

          if (node) {
            shift += SIZE;
            break;
          }

          return alt;
        }

      default:
        return alt;
    }
  }
};

Map.prototype.tryGetHash = function (alt, hash, key) {
  return tryGetHash(alt, hash, key, this);
};
/**
    Lookup the value for `key` in `map` using internal hash function.

    @see `tryGetHash`
*/


var tryGet = hamt.tryGet = function (alt, key, map) {
  return tryGetHash(alt, map._config.hash(key), key, map);
};

Map.prototype.tryGet = function (alt, key) {
  return tryGet(alt, key, this);
};
/**
    Lookup the value for `key` in `map` using a custom `hash`.

    Returns the value or `undefined` if none.
*/


var getHash = hamt.getHash = function (hash, key, map) {
  return tryGetHash(undefined, hash, key, map);
};

Map.prototype.getHash = function (hash, key) {
  return getHash(hash, key, this);
};
/**
    Lookup the value for `key` in `map` using internal hash function.

    @see `get`
*/


var get = hamt.get = function (key, map) {
  return tryGetHash(undefined, map._config.hash(key), key, map);
};

Map.prototype.get = function (key, alt) {
  return tryGet(alt, key, this);
};
/**
    Does an entry exist for `key` in `map`? Uses custom `hash`.
*/


var hasHash = hamt.has = function (hash, key, map) {
  return tryGetHash(nothing, hash, key, map) !== nothing;
};

Map.prototype.hasHash = function (hash, key) {
  return hasHash(hash, key, this);
};
/**
    Does an entry exist for `key` in `map`? Uses internal hash function.
*/


var has = hamt.has = function (key, map) {
  return hasHash(map._config.hash(key), key, map);
};

Map.prototype.has = function (key) {
  return has(key, this);
};

var defKeyCompare = function defKeyCompare(x, y) {
  return x === y;
};
/**
    Create an empty map.

    @param config Configuration.
*/


hamt.make = function (config) {
  return new Map(0, 0, {
    keyEq: config && config.keyEq || defKeyCompare,
    hash: config && config.hash || hash
  }, empty, 0);
};
/**
    Empty map.
*/


hamt.empty = hamt.make();
/**
    Does `map` contain any elements?
*/

var isEmpty = hamt.isEmpty = function (map) {
  return map && !!isEmptyNode(map._root);
};

Map.prototype.isEmpty = function () {
  return isEmpty(this);
};
/* Updates
 ******************************************************************************/

/**
    Alter the value stored for `key` in `map` using function `f` using
    custom hash.

    `f` is invoked with the current value for `k` if it exists,
    or no arguments if no such value exists. `modify` will always either
    update or insert a value into the map.

    Returns a map with the modified value. Does not alter `map`.
*/


var modifyHash = hamt.modifyHash = function (f, hash, key, map) {
  var size = {
    value: map._size
  };

  var newRoot = map._root._modify(map._editable ? map._edit : NaN, map._config.keyEq, 0, f, hash, key, size);

  return map.setTree(newRoot, size.value);
};

Map.prototype.modifyHash = function (hash, key, f) {
  return modifyHash(f, hash, key, this);
};
/**
    Alter the value stored for `key` in `map` using function `f` using
    internal hash function.

    @see `modifyHash`
*/


var modify = hamt.modify = function (f, key, map) {
  return modifyHash(f, map._config.hash(key), key, map);
};

Map.prototype.modify = function (key, f) {
  return modify(f, key, this);
};
/**
    Store `value` for `key` in `map` using custom `hash`.

    Returns a map with the modified value. Does not alter `map`.
*/


var setHash = hamt.setHash = function (hash, key, value, map) {
  return modifyHash(constant(value), hash, key, map);
};

Map.prototype.setHash = function (hash, key, value) {
  return setHash(hash, key, value, this);
};
/**
    Store `value` for `key` in `map` using internal hash function.

    @see `setHash`
*/


var set = hamt.set = function (key, value, map) {
  return setHash(map._config.hash(key), key, value, map);
};

Map.prototype.set = function (key, value) {
  return set(key, value, this);
};
/**
    Remove the entry for `key` in `map`.

    Returns a map with the value removed. Does not alter `map`.
*/


var del = constant(nothing);

var removeHash = hamt.removeHash = function (hash, key, map) {
  return modifyHash(del, hash, key, map);
};

Map.prototype.removeHash = Map.prototype.deleteHash = function (hash, key) {
  return removeHash(hash, key, this);
};
/**
    Remove the entry for `key` in `map` using internal hash function.

    @see `removeHash`
*/


var remove = hamt.remove = function (key, map) {
  return removeHash(map._config.hash(key), key, map);
};

Map.prototype.remove = Map.prototype.delete = function (key) {
  return remove(key, this);
};
/* Mutation
 ******************************************************************************/

/**
    Mark `map` as mutable.
 */


var beginMutation = hamt.beginMutation = function (map) {
  return new Map(map._editable + 1, map._edit + 1, map._config, map._root, map._size);
};

Map.prototype.beginMutation = function () {
  return beginMutation(this);
};
/**
    Mark `map` as immutable.
 */


var endMutation = hamt.endMutation = function (map) {
  map._editable = map._editable && map._editable - 1;
  return map;
};

Map.prototype.endMutation = function () {
  return endMutation(this);
};
/**
    Mutate `map` within the context of `f`.
    @param f
    @param map HAMT
*/


var mutate = hamt.mutate = function (f, map) {
  var transient = beginMutation(map);
  f(transient);
  return endMutation(transient);
};

Map.prototype.mutate = function (f) {
  return mutate(f, this);
};
/* Traversal
 ******************************************************************************/

/**
    Apply a continuation.
*/


var appk = function appk(k) {
  return k && lazyVisitChildren(k[0], k[1], k[2], k[3], k[4]);
};
/**
    Recursively visit all values stored in an array of nodes lazily.
*/


var lazyVisitChildren = function lazyVisitChildren(len, children, i, f, k) {
  while (i < len) {
    var child = children[i++];
    if (child && !isEmptyNode(child)) return lazyVisit(child, f, [len, children, i, f, k]);
  }

  return appk(k);
};
/**
    Recursively visit all values stored in `node` lazily.
*/


var lazyVisit = function lazyVisit(node, f, k) {
  switch (node.type) {
    case LEAF:
      return {
        value: f(node),
        rest: k
      };

    case COLLISION:
    case ARRAY:
    case INDEX:
      var children = node.children;
      return lazyVisitChildren(children.length, children, 0, f, k);

    default:
      return appk(k);
  }
};

var DONE = {
  done: true
};
/**
    Javascript iterator over a map.
*/

function MapIterator(v) {
  this.v = v;
}

MapIterator.prototype.next = function () {
  if (!this.v) return DONE;
  var v0 = this.v;
  this.v = appk(v0.rest);
  return v0;
};

MapIterator.prototype[Symbol.iterator] = function () {
  return this;
};
/**
    Lazily visit each value in map with function `f`.
*/


var visit = function visit(map, f) {
  return new MapIterator(lazyVisit(map._root, f));
};
/**
    Get a Javascsript iterator of `map`.

    Iterates over `[key, value]` arrays.
*/


var buildPairs = function buildPairs(x) {
  return [x.key, x.value];
};

var entries = hamt.entries = function (map) {
  return visit(map, buildPairs);
};

Map.prototype.entries = Map.prototype[Symbol.iterator] = function () {
  return entries(this);
};
/**
    Get array of all keys in `map`.

    Order is not guaranteed.
*/


var buildKeys = function buildKeys(x) {
  return x.key;
};

var keys = hamt.keys = function (map) {
  return visit(map, buildKeys);
};

Map.prototype.keys = function () {
  return keys(this);
};
/**
    Get array of all values in `map`.

    Order is not guaranteed, duplicates are preserved.
*/


var buildValues = function buildValues(x) {
  return x.value;
};

var values = hamt.values = Map.prototype.values = function (map) {
  return visit(map, buildValues);
};

Map.prototype.values = function () {
  return values(this);
};
/* Fold
 ******************************************************************************/

/**
    Visit every entry in the map, aggregating data.

    Order of nodes is not guaranteed.

    @param f Function mapping accumulated value, value, and key to new value.
    @param z Starting value.
    @param m HAMT
*/


var fold = hamt.fold = function (f, z, m) {
  var root = m._root;
  if (root.type === LEAF) return f(z, root.value, root.key);
  var toVisit = [root.children];
  var children = void 0;

  while (children = toVisit.pop()) {
    for (var i = 0, len = children.length; i < len;) {
      var child = children[i++];

      if (child && child.type) {
        if (child.type === LEAF) z = f(z, child.value, child.key);else toVisit.push(child.children);
      }
    }
  }

  return z;
};

Map.prototype.fold = function (f, z) {
  return fold(f, z, this);
};
/**
    Visit every entry in the map, aggregating data.

    Order of nodes is not guaranteed.

    @param f Function invoked with value and key
    @param map HAMT
*/


var forEach = hamt.forEach = function (f, map) {
  return fold(function (_, value, key) {
    return f(value, key, map);
  }, null, map);
};

Map.prototype.forEach = function (f) {
  return forEach(f, this);
};
/* Aggregate
 ******************************************************************************/

/**
    Get the number of entries in `map`.
*/


var count = hamt.count = function (map) {
  return map._size;
};

Map.prototype.count = function () {
  return count(this);
};

Object.defineProperty(Map.prototype, 'size', {
  get: Map.prototype.count
});
/* Export
 ******************************************************************************/

if ( module.exports) {
  module.exports = hamt;
} else {
  undefined.hamt = hamt;
}
});

class BuiltInMap {
  constructor(existing) {
    _defineProperty(this, "_map", void 0);

    this._map = new Map(existing === null || existing === void 0 ? void 0 : existing.entries());
  }

  keys() {
    return this._map.keys();
  }

  entries() {
    return this._map.entries();
  }

  get(k) {
    return this._map.get(k);
  }

  has(k) {
    return this._map.has(k);
  }

  set(k, v) {
    this._map.set(k, v);

    return this;
  }

  delete(k) {
    this._map.delete(k);

    return this;
  }

  clone() {
    return persistentMap(this);
  }

  toMap() {
    return new Map(this._map);
  }

}

class HashArrayMappedTrieMap {
  // Because hamt.empty is not a function there is no way to introduce type
  // parameters on it, so empty is typed as HAMTPlusMap<string, mixed>.
  // $FlowIssue
  constructor(existing) {
    _defineProperty(this, "_hamt", hamt_1.empty.beginMutation());

    if (existing instanceof HashArrayMappedTrieMap) {
      const h = existing._hamt.endMutation();

      existing._hamt = h.beginMutation();
      this._hamt = h.beginMutation();
    } else if (existing) {
      for (const [k, v] of existing.entries()) {
        this._hamt.set(k, v);
      }
    }
  }

  keys() {
    return this._hamt.keys();
  }

  entries() {
    return this._hamt.entries();
  }

  get(k) {
    return this._hamt.get(k);
  }

  has(k) {
    return this._hamt.has(k);
  }

  set(k, v) {
    this._hamt.set(k, v);

    return this;
  }

  delete(k) {
    this._hamt.delete(k);

    return this;
  }

  clone() {
    return persistentMap(this);
  }

  toMap() {
    return new Map(this._hamt);
  }

}

function persistentMap(existing) {
  if (Recoil_gkx('recoil_hamt_2020')) {
    return new HashArrayMappedTrieMap(existing);
  } else {
    return new BuiltInMap(existing);
  }
}

var Recoil_PersistentMap = {
  persistentMap
};

var Recoil_PersistentMap_1 = Recoil_PersistentMap.persistentMap;

var Recoil_PersistentMap$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  persistentMap: Recoil_PersistentMap_1
});

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/**
 * Returns a set containing all of the values from the first set that are not
 * present in any of the subsequent sets.
 *
 * Note: this is written procedurally (i.e., without filterSet) for performant
 * use in tight loops.
 */

function differenceSets(set, ...setsWithValuesToRemove) {
  const ret = new Set();

  FIRST: for (const value of set) {
    for (const otherSet of setsWithValuesToRemove) {
      if (otherSet.has(value)) {
        continue FIRST;
      }
    }

    ret.add(value);
  }

  return ret;
}

var Recoil_differenceSets = differenceSets;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/**
 * Returns a new Map object with the same keys as the original, but with the
 * values replaced with the output of the given callback function.
 */

function mapMap(map, callback) {
  const result = new Map();
  map.forEach((value, key) => {
    result.set(key, callback(value, key));
  });
  return result;
}

var Recoil_mapMap = mapMap;

function makeGraph() {
  return {
    nodeDeps: new Map(),
    nodeToNodeSubscriptions: new Map()
  };
}

function cloneGraph(graph) {
  return {
    nodeDeps: Recoil_mapMap(graph.nodeDeps, s => new Set(s)),
    nodeToNodeSubscriptions: Recoil_mapMap(graph.nodeToNodeSubscriptions, s => new Set(s))
  };
} // Note that this overwrites the deps of existing nodes, rather than unioning
// the new deps with the old deps.


function mergeDepsIntoGraph(key, newDeps, graph, // If olderGraph is given then we will not overwrite changes made to the given
// graph compared with olderGraph:
olderGraph) {
  const {
    nodeDeps,
    nodeToNodeSubscriptions
  } = graph;
  const oldDeps = nodeDeps.get(key);

  if (oldDeps && olderGraph && oldDeps !== olderGraph.nodeDeps.get(key)) {
    return;
  } // Update nodeDeps:


  nodeDeps.set(key, newDeps); // Add new deps to nodeToNodeSubscriptions:

  const addedDeps = oldDeps == null ? newDeps : Recoil_differenceSets(newDeps, oldDeps);

  for (const dep of addedDeps) {
    if (!nodeToNodeSubscriptions.has(dep)) {
      nodeToNodeSubscriptions.set(dep, new Set());
    }

    const existing = Recoil_nullthrows(nodeToNodeSubscriptions.get(dep));
    existing.add(key);
  } // Remove removed deps from nodeToNodeSubscriptions:


  if (oldDeps) {
    const removedDeps = Recoil_differenceSets(oldDeps, newDeps);

    for (const dep of removedDeps) {
      if (!nodeToNodeSubscriptions.has(dep)) {
        return;
      }

      const existing = Recoil_nullthrows(nodeToNodeSubscriptions.get(dep));
      existing.delete(key);

      if (existing.size === 0) {
        nodeToNodeSubscriptions.delete(dep);
      }
    }
  }
}

function saveDepsToStore(key, deps, store, version) {
  var _storeState$nextTree, _storeState$previousT, _storeState$previousT2, _storeState$previousT3;

  const storeState = store.getState();

  if (!(version === storeState.currentTree.version || version === ((_storeState$nextTree = storeState.nextTree) === null || _storeState$nextTree === void 0 ? void 0 : _storeState$nextTree.version) || version === ((_storeState$previousT = storeState.previousTree) === null || _storeState$previousT === void 0 ? void 0 : _storeState$previousT.version))) {
    Recoil_recoverableViolation('Tried to save dependencies to a discarded tree');
  } // Merge the dependencies discovered into the store's dependency map
  // for the version that was read:


  const graph = store.getGraph(version);
  mergeDepsIntoGraph(key, deps, graph); // If this version is not the latest version, also write these dependencies
  // into later versions if they don't already have their own:

  if (version === ((_storeState$previousT2 = storeState.previousTree) === null || _storeState$previousT2 === void 0 ? void 0 : _storeState$previousT2.version)) {
    const currentGraph = store.getGraph(storeState.currentTree.version);
    mergeDepsIntoGraph(key, deps, currentGraph, graph);
  }

  if (version === ((_storeState$previousT3 = storeState.previousTree) === null || _storeState$previousT3 === void 0 ? void 0 : _storeState$previousT3.version) || version === storeState.currentTree.version) {
    var _storeState$nextTree2;

    const nextVersion = (_storeState$nextTree2 = storeState.nextTree) === null || _storeState$nextTree2 === void 0 ? void 0 : _storeState$nextTree2.version;

    if (nextVersion !== undefined) {
      const nextGraph = store.getGraph(nextVersion);
      mergeDepsIntoGraph(key, deps, nextGraph, graph);
    }
  }
}

var Recoil_Graph = {
  cloneGraph,
  graph: makeGraph,
  saveDepsToStore
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

let nextTreeStateVersion = 0;

const getNextTreeStateVersion = () => nextTreeStateVersion++;

let nextStoreID = 0;

const getNextStoreID = () => nextStoreID++;

let nextComponentID = 0;

const getNextComponentID = () => nextComponentID++;

var Recoil_Keys = {
  getNextTreeStateVersion,
  getNextStoreID,
  getNextComponentID
};

const {
  persistentMap: persistentMap$1
} = Recoil_PersistentMap$1;

const {
  graph
} = Recoil_Graph;

const {
  getNextTreeStateVersion: getNextTreeStateVersion$1
} = Recoil_Keys;

function makeEmptyTreeState() {
  const version = getNextTreeStateVersion$1();
  return {
    version,
    stateID: version,
    transactionMetadata: {},
    dirtyAtoms: new Set(),
    atomValues: persistentMap$1(),
    nonvalidatedAtoms: persistentMap$1()
  };
}

function makeEmptyStoreState() {
  const currentTree = makeEmptyTreeState();
  return {
    currentTree,
    nextTree: null,
    previousTree: null,
    commitDepth: 0,
    knownAtoms: new Set(),
    knownSelectors: new Set(),
    transactionSubscriptions: new Map(),
    nodeTransactionSubscriptions: new Map(),
    nodeToComponentSubscriptions: new Map(),
    queuedComponentCallbacks_DEPRECATED: [],
    suspendedComponentResolvers: new Set(),
    graphsByVersion: new Map().set(currentTree.version, graph()),
    retention: {
      referenceCounts: new Map(),
      nodesRetainedByZone: new Map(),
      retainablesToCheckForRelease: new Set()
    },
    nodeCleanupFunctions: new Map()
  };
}

var Recoil_State = {
  makeEmptyTreeState,
  makeEmptyStoreState,
  getNextTreeStateVersion: getNextTreeStateVersion$1
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

class RetentionZone {}

function retentionZone() {
  return new RetentionZone();
}

var Recoil_RetentionZone = {
  RetentionZone,
  retentionZone
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Utilities for working with built-in Maps and Sets without mutating them.
 *
 * 
 * @format
 * @oncall recoil
 */

function setByAddingToSet(set, v) {
  const next = new Set(set);
  next.add(v);
  return next;
}

function setByDeletingFromSet(set, v) {
  const next = new Set(set);
  next.delete(v);
  return next;
}

function mapBySettingInMap(map, k, v) {
  const next = new Map(map);
  next.set(k, v);
  return next;
}

function mapByUpdatingInMap(map, k, updater) {
  const next = new Map(map);
  next.set(k, updater(next.get(k)));
  return next;
}

function mapByDeletingFromMap(map, k) {
  const next = new Map(map);
  next.delete(k);
  return next;
}

function mapByDeletingMultipleFromMap(map, ks) {
  const next = new Map(map);
  ks.forEach(k => next.delete(k));
  return next;
}

var Recoil_CopyOnWrite = {
  setByAddingToSet,
  setByDeletingFromSet,
  mapBySettingInMap,
  mapByUpdatingInMap,
  mapByDeletingFromMap,
  mapByDeletingMultipleFromMap
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/**
 * Creates a new iterable whose output is generated by passing the input
 * iterable's values through the filter function.
 */

function* filterIterable(iterable, predicate) {
  // Use generator to create iterable/iterator
  let index = 0;

  for (const value of iterable) {
    if (predicate(value, index++)) {
      yield value;
    }
  }
}

var Recoil_filterIterable = filterIterable;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/**
 * Return a proxy object based on the provided base and factories objects.
 * The proxy will include all properties of the base object as-is.
 * The factories object contains callbacks to obtain the values of the properies
 * for its keys.
 *
 * This is useful for providing users an object where some properties may be
 * lazily computed only on first access.
 */
// $FlowIssue[unclear-type]

function lazyProxy(base, factories) {
  const proxy = new Proxy(base, {
    // Compute and cache lazy property if not already done.
    get: (target, prop) => {
      if (!(prop in target) && prop in factories) {
        target[prop] = factories[prop]();
      }

      return target[prop];
    },
    // This method allows user to iterate keys as normal
    ownKeys: target => {

      return Object.keys(target);
    }
  }); // $FlowIssue[incompatible-return]

  return proxy;
}

var Recoil_lazyProxy = lazyProxy;

const {
  getNode: getNode$1,
  getNodeMaybe: getNodeMaybe$1,
  recoilValuesForKeys: recoilValuesForKeys$1
} = Recoil_Node;

const {
  RetentionZone: RetentionZone$1
} = Recoil_RetentionZone;

const {
  setByAddingToSet: setByAddingToSet$1
} = Recoil_CopyOnWrite;







 // flowlint-next-line unclear-type:off


const emptySet = Object.freeze(new Set());

class ReadOnlyRecoilValueError extends Error {}

function initializeRetentionForNode(store, nodeKey, retainedBy) {
  if (!Recoil_gkx('recoil_memory_managament_2020')) {
    return () => undefined;
  }

  const {
    nodesRetainedByZone
  } = store.getState().retention;

  function addToZone(zone) {
    let set = nodesRetainedByZone.get(zone);

    if (!set) {
      nodesRetainedByZone.set(zone, set = new Set());
    }

    set.add(nodeKey);
  }

  if (retainedBy instanceof RetentionZone$1) {
    addToZone(retainedBy);
  } else if (Array.isArray(retainedBy)) {
    for (const zone of retainedBy) {
      addToZone(zone);
    }
  }

  return () => {
    if (!Recoil_gkx('recoil_memory_managament_2020')) {
      return;
    }

    const {
      retention
    } = store.getState();

    function deleteFromZone(zone) {
      const set = retention.nodesRetainedByZone.get(zone);
      set === null || set === void 0 ? void 0 : set.delete(nodeKey);

      if (set && set.size === 0) {
        retention.nodesRetainedByZone.delete(zone);
      }
    }

    if (retainedBy instanceof RetentionZone$1) {
      deleteFromZone(retainedBy);
    } else if (Array.isArray(retainedBy)) {
      for (const zone of retainedBy) {
        deleteFromZone(zone);
      }
    }
  };
}

function initializeNodeIfNewToStore(store, treeState, key, trigger) {
  const storeState = store.getState();

  if (storeState.nodeCleanupFunctions.has(key)) {
    return;
  }

  const node = getNode$1(key);
  const retentionCleanup = initializeRetentionForNode(store, key, node.retainedBy);
  const nodeCleanup = node.init(store, treeState, trigger);
  storeState.nodeCleanupFunctions.set(key, () => {
    nodeCleanup();
    retentionCleanup();
  });
}

function initializeNode(store, key, trigger) {
  initializeNodeIfNewToStore(store, store.getState().currentTree, key, trigger);
}

function cleanUpNode(store, key) {
  var _state$nodeCleanupFun;

  const state = store.getState();
  (_state$nodeCleanupFun = state.nodeCleanupFunctions.get(key)) === null || _state$nodeCleanupFun === void 0 ? void 0 : _state$nodeCleanupFun();
  state.nodeCleanupFunctions.delete(key);
} // Get the current value loadable of a node and update the state.
// Update dependencies and subscriptions for selectors.
// Update saved value validation for atoms.


function getNodeLoadable(store, state, key) {
  initializeNodeIfNewToStore(store, state, key, 'get');
  return getNode$1(key).get(store, state);
} // Peek at the current value loadable for a node without any evaluation or state change


function peekNodeLoadable(store, state, key) {
  return getNode$1(key).peek(store, state);
} // Write value directly to state bypassing the Node interface as the node
// definitions may not have been loaded yet when processing the initial snapshot.


function setUnvalidatedAtomValue_DEPRECATED(state, key, newValue) {
  var _node$invalidate;

  const node = getNodeMaybe$1(key);
  node === null || node === void 0 ? void 0 : (_node$invalidate = node.invalidate) === null || _node$invalidate === void 0 ? void 0 : _node$invalidate.call(node, state);
  return { ...state,
    atomValues: state.atomValues.clone().delete(key),
    nonvalidatedAtoms: state.nonvalidatedAtoms.clone().set(key, newValue),
    dirtyAtoms: setByAddingToSet$1(state.dirtyAtoms, key)
  };
} // Return the discovered dependencies and values to be written by setting
// a node value. (Multiple values may be written due to selectors getting to
// set upstreams; deps may be discovered because of reads in updater functions.)


function setNodeValue(store, state, key, newValue) {
  const node = getNode$1(key);

  if (node.set == null) {
    throw new ReadOnlyRecoilValueError(`Attempt to set read-only RecoilValue: ${key}`);
  }

  const set = node.set; // so flow doesn't lose the above refinement.

  initializeNodeIfNewToStore(store, state, key, 'set');
  return set(store, state, newValue);
}

function peekNodeInfo(store, state, key) {
  const storeState = store.getState();
  const graph = store.getGraph(state.version);
  const type = getNode$1(key).nodeType;
  return Recoil_lazyProxy({
    type
  }, {
    // $FlowFixMe[underconstrained-implicit-instantiation]
    loadable: () => peekNodeLoadable(store, state, key),
    isActive: () => storeState.knownAtoms.has(key) || storeState.knownSelectors.has(key),
    isSet: () => type === 'selector' ? false : state.atomValues.has(key),
    isModified: () => state.dirtyAtoms.has(key),
    // Report current dependencies.  If the node hasn't been evaluated, then
    // dependencies may be missing based on the current state.
    deps: () => {
      var _graph$nodeDeps$get;

      return recoilValuesForKeys$1((_graph$nodeDeps$get = graph.nodeDeps.get(key)) !== null && _graph$nodeDeps$get !== void 0 ? _graph$nodeDeps$get : []);
    },
    // Reports all "current" subscribers.  Evaluating other nodes or
    // previous in-progress async evaluations may introduce new subscribers.
    subscribers: () => {
      var _storeState$nodeToCom, _storeState$nodeToCom2;

      return {
        nodes: recoilValuesForKeys$1(Recoil_filterIterable(getDownstreamNodes(store, state, new Set([key])), nodeKey => nodeKey !== key)),
        components: Recoil_mapIterable((_storeState$nodeToCom = (_storeState$nodeToCom2 = storeState.nodeToComponentSubscriptions.get(key)) === null || _storeState$nodeToCom2 === void 0 ? void 0 : _storeState$nodeToCom2.values()) !== null && _storeState$nodeToCom !== void 0 ? _storeState$nodeToCom : [], ([name]) => ({
          name
        }))
      };
    }
  });
} // Find all of the recursively dependent nodes


function getDownstreamNodes(store, state, keys) {
  const visitedNodes = new Set();
  const visitingNodes = Array.from(keys);
  const graph = store.getGraph(state.version);

  for (let key = visitingNodes.pop(); key; key = visitingNodes.pop()) {
    var _graph$nodeToNodeSubs;

    visitedNodes.add(key);
    const subscribedNodes = (_graph$nodeToNodeSubs = graph.nodeToNodeSubscriptions.get(key)) !== null && _graph$nodeToNodeSubs !== void 0 ? _graph$nodeToNodeSubs : emptySet;

    for (const downstreamNode of subscribedNodes) {
      if (!visitedNodes.has(downstreamNode)) {
        visitingNodes.push(downstreamNode);
      }
    }
  }

  return visitedNodes;
}

var Recoil_FunctionalCore = {
  getNodeLoadable,
  peekNodeLoadable,
  setNodeValue,
  initializeNode,
  cleanUpNode,
  setUnvalidatedAtomValue_DEPRECATED,
  peekNodeInfo,
  getDownstreamNodes
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

let _invalidateMemoizedSnapshot = null;

function setInvalidateMemoizedSnapshot(invalidate) {
  _invalidateMemoizedSnapshot = invalidate;
}

function invalidateMemoizedSnapshot() {
  var _invalidateMemoizedSn;

  (_invalidateMemoizedSn = _invalidateMemoizedSnapshot) === null || _invalidateMemoizedSn === void 0 ? void 0 : _invalidateMemoizedSn();
}

var Recoil_SnapshotCache = {
  setInvalidateMemoizedSnapshot,
  invalidateMemoizedSnapshot
};

const {
  getDownstreamNodes: getDownstreamNodes$1,
  getNodeLoadable: getNodeLoadable$1,
  setNodeValue: setNodeValue$1
} = Recoil_FunctionalCore;

const {
  getNextComponentID: getNextComponentID$1
} = Recoil_Keys;

const {
  getNode: getNode$2,
  getNodeMaybe: getNodeMaybe$2
} = Recoil_Node;

const {
  DefaultValue: DefaultValue$1
} = Recoil_Node;

const {
  reactMode: reactMode$1
} = Recoil_ReactMode;

const {
  AbstractRecoilValue: AbstractRecoilValue$1,
  RecoilState: RecoilState$1,
  RecoilValueReadOnly: RecoilValueReadOnly$1,
  isRecoilValue: isRecoilValue$1
} = Recoil_RecoilValue$1;

const {
  invalidateMemoizedSnapshot: invalidateMemoizedSnapshot$1
} = Recoil_SnapshotCache;







function getRecoilValueAsLoadable(store, {
  key
}, treeState = store.getState().currentTree) {
  var _storeState$nextTree, _storeState$previousT;

  // Reading from an older tree can cause bugs because the dependencies that we
  // discover during the read are lost.
  const storeState = store.getState();

  if (!(treeState.version === storeState.currentTree.version || treeState.version === ((_storeState$nextTree = storeState.nextTree) === null || _storeState$nextTree === void 0 ? void 0 : _storeState$nextTree.version) || treeState.version === ((_storeState$previousT = storeState.previousTree) === null || _storeState$previousT === void 0 ? void 0 : _storeState$previousT.version))) {
    Recoil_recoverableViolation('Tried to read from a discarded tree');
  }

  const loadable = getNodeLoadable$1(store, treeState, key);

  if (loadable.state === 'loading') {
    loadable.contents.catch(() => {
      /**
       * HACK: intercept thrown error here to prevent an uncaught promise exception. Ideally this would happen closer to selector
       * execution (perhaps introducing a new ERROR class to be resolved by async selectors that are in an error state)
       */
      return;
    });
  }

  return loadable;
}

function applyAtomValueWrites(atomValues, writes) {
  const result = atomValues.clone();
  writes.forEach((v, k) => {
    if (v.state === 'hasValue' && v.contents instanceof DefaultValue$1) {
      result.delete(k);
    } else {
      result.set(k, v);
    }
  });
  return result;
}

function valueFromValueOrUpdater(store, state, {
  key
}, valueOrUpdater) {
  if (typeof valueOrUpdater === 'function') {
    // Updater form: pass in the current value. Throw if the current value
    // is unavailable (namely when updating an async selector that's
    // pending or errored):
    const current = getNodeLoadable$1(store, state, key);

    if (current.state === 'loading') {
      const msg = `Tried to set atom or selector "${key}" using an updater function while the current state is pending, this is not currently supported.`;
      Recoil_recoverableViolation(msg);
      throw Recoil_err(msg);
    } else if (current.state === 'hasError') {
      throw current.contents;
    } // T itself may be a function, so our refinement is not sufficient:


    return valueOrUpdater(current.contents); // flowlint-line unclear-type:off
  } else {
    return valueOrUpdater;
  }
}

function applyAction(store, state, action) {
  if (action.type === 'set') {
    const {
      recoilValue,
      valueOrUpdater
    } = action;
    const newValue = valueFromValueOrUpdater(store, state, recoilValue, valueOrUpdater);
    const writes = setNodeValue$1(store, state, recoilValue.key, newValue);

    for (const [key, loadable] of writes.entries()) {
      writeLoadableToTreeState(state, key, loadable);
    }
  } else if (action.type === 'setLoadable') {
    const {
      recoilValue: {
        key
      },
      loadable
    } = action;
    writeLoadableToTreeState(state, key, loadable);
  } else if (action.type === 'markModified') {
    const {
      recoilValue: {
        key
      }
    } = action;
    state.dirtyAtoms.add(key);
  } else if (action.type === 'setUnvalidated') {
    var _node$invalidate;

    // Write value directly to state bypassing the Node interface as the node
    // definitions may not have been loaded yet when processing the initial snapshot.
    const {
      recoilValue: {
        key
      },
      unvalidatedValue
    } = action;
    const node = getNodeMaybe$2(key);
    node === null || node === void 0 ? void 0 : (_node$invalidate = node.invalidate) === null || _node$invalidate === void 0 ? void 0 : _node$invalidate.call(node, state);
    state.atomValues.delete(key);
    state.nonvalidatedAtoms.set(key, unvalidatedValue);
    state.dirtyAtoms.add(key);
  } else {
    Recoil_recoverableViolation(`Unknown action ${action.type}`);
  }
}

function writeLoadableToTreeState(state, key, loadable) {
  if (loadable.state === 'hasValue' && loadable.contents instanceof DefaultValue$1) {
    state.atomValues.delete(key);
  } else {
    state.atomValues.set(key, loadable);
  }

  state.dirtyAtoms.add(key);
  state.nonvalidatedAtoms.delete(key);
}

function applyActionsToStore(store, actions) {
  store.replaceState(state => {
    const newState = copyTreeState(state);

    for (const action of actions) {
      applyAction(store, newState, action);
    }

    invalidateDownstreams(store, newState);
    invalidateMemoizedSnapshot$1();
    return newState;
  });
}

function queueOrPerformStateUpdate(store, action) {
  if (batchStack.length) {
    const actionsByStore = batchStack[batchStack.length - 1];
    let actions = actionsByStore.get(store);

    if (!actions) {
      actionsByStore.set(store, actions = []);
    }

    actions.push(action);
  } else {
    applyActionsToStore(store, [action]);
  }
}

const batchStack = [];

function batchStart() {
  const actionsByStore = new Map();
  batchStack.push(actionsByStore);
  return () => {
    for (const [store, actions] of actionsByStore) {
      applyActionsToStore(store, actions);
    }

    const popped = batchStack.pop();

    if (popped !== actionsByStore) {
      Recoil_recoverableViolation('Incorrect order of batch popping');
    }
  };
}

function copyTreeState(state) {
  return { ...state,
    atomValues: state.atomValues.clone(),
    nonvalidatedAtoms: state.nonvalidatedAtoms.clone(),
    dirtyAtoms: new Set(state.dirtyAtoms)
  };
}

function invalidateDownstreams(store, state) {
  // Inform any nodes that were changed or downstream of changes so that they
  // can clear out any caches as needed due to the update:
  const downstreams = getDownstreamNodes$1(store, state, state.dirtyAtoms);

  for (const key of downstreams) {
    var _getNodeMaybe, _getNodeMaybe$invalid;

    (_getNodeMaybe = getNodeMaybe$2(key)) === null || _getNodeMaybe === void 0 ? void 0 : (_getNodeMaybe$invalid = _getNodeMaybe.invalidate) === null || _getNodeMaybe$invalid === void 0 ? void 0 : _getNodeMaybe$invalid.call(_getNodeMaybe, state);
  }
}

function setRecoilValue(store, recoilValue, valueOrUpdater) {
  queueOrPerformStateUpdate(store, {
    type: 'set',
    recoilValue,
    valueOrUpdater
  });
}

function setRecoilValueLoadable(store, recoilValue, loadable) {
  if (loadable instanceof DefaultValue$1) {
    return setRecoilValue(store, recoilValue, loadable);
  }

  queueOrPerformStateUpdate(store, {
    type: 'setLoadable',
    recoilValue,
    loadable: loadable
  });
}

function markRecoilValueModified(store, recoilValue) {
  queueOrPerformStateUpdate(store, {
    type: 'markModified',
    recoilValue
  });
}

function setUnvalidatedRecoilValue(store, recoilValue, unvalidatedValue) {
  queueOrPerformStateUpdate(store, {
    type: 'setUnvalidated',
    recoilValue,
    unvalidatedValue
  });
}

function subscribeToRecoilValue(store, {
  key
}, callback, componentDebugName = null) {
  const subID = getNextComponentID$1();
  const storeState = store.getState();

  if (!storeState.nodeToComponentSubscriptions.has(key)) {
    storeState.nodeToComponentSubscriptions.set(key, new Map());
  }

  Recoil_nullthrows(storeState.nodeToComponentSubscriptions.get(key)).set(subID, [componentDebugName !== null && componentDebugName !== void 0 ? componentDebugName : '<not captured>', callback]); // Handle the case that, during the same tick that we are subscribing, an atom
  // has been updated by some effect handler. Otherwise we will miss the update.

  const mode = reactMode$1();

  if (mode.early && (mode.mode === 'LEGACY' || mode.mode === 'MUTABLE_SOURCE')) {
    const nextTree = store.getState().nextTree;

    if (nextTree && nextTree.dirtyAtoms.has(key)) {
      callback(nextTree);
    }
  }

  return {
    release: () => {
      const releaseStoreState = store.getState();
      const subs = releaseStoreState.nodeToComponentSubscriptions.get(key);

      if (subs === undefined || !subs.has(subID)) {
        Recoil_recoverableViolation(`Subscription missing at release time for atom ${key}. This is a bug in Recoil.`);
        return;
      }

      subs.delete(subID);

      if (subs.size === 0) {
        releaseStoreState.nodeToComponentSubscriptions.delete(key);
      }
    }
  };
}

function refreshRecoilValue(store, recoilValue) {
  var _node$clearCache;

  const {
    currentTree
  } = store.getState();
  const node = getNode$2(recoilValue.key);
  (_node$clearCache = node.clearCache) === null || _node$clearCache === void 0 ? void 0 : _node$clearCache.call(node, store, currentTree);
}

var Recoil_RecoilValueInterface = {
  RecoilValueReadOnly: RecoilValueReadOnly$1,
  AbstractRecoilValue: AbstractRecoilValue$1,
  RecoilState: RecoilState$1,
  getRecoilValueAsLoadable,
  setRecoilValue,
  setRecoilValueLoadable,
  markRecoilValueModified,
  setUnvalidatedRecoilValue,
  subscribeToRecoilValue,
  isRecoilValue: isRecoilValue$1,
  applyAtomValueWrites,
  // TODO Remove export when deprecating initialStoreState_DEPRECATED in RecoilRoot
  batchStart,
  writeLoadableToTreeState,
  invalidateDownstreams,
  copyTreeState,
  refreshRecoilValue
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/**
 * The someSet() method tests whether some elements in the given Set pass the
 * test implemented by the provided function.
 */

function someSet(set, callback, context) {
  const iterator = set.entries();
  let current = iterator.next();

  while (!current.done) {
    const entry = current.value;

    if (callback.call(context, entry[1], entry[0], set)) {
      return true;
    }

    current = iterator.next();
  }

  return false;
}

var Recoil_someSet = someSet;

const {
  cleanUpNode: cleanUpNode$1
} = Recoil_FunctionalCore;

const {
  deleteNodeConfigIfPossible: deleteNodeConfigIfPossible$1,
  getNode: getNode$3
} = Recoil_Node;

const {
  RetentionZone: RetentionZone$2
} = Recoil_RetentionZone;







 // Components that aren't mounted after suspending for this long will be assumed
// to be discarded and their resources released.


const SUSPENSE_TIMEOUT_MS = 120000;
const emptySet$1 = new Set();

function releaseRetainablesNowOnCurrentTree(store, retainables) {
  const storeState = store.getState();
  const treeState = storeState.currentTree;

  if (storeState.nextTree) {
    Recoil_recoverableViolation('releaseNodesNowOnCurrentTree should only be called at the end of a batch');
    return; // leak memory rather than erase something that's about to be used.
  }

  const nodes = new Set();

  for (const r of retainables) {
    if (r instanceof RetentionZone$2) {
      for (const n of nodesRetainedByZone(storeState, r)) {
        nodes.add(n);
      }
    } else {
      nodes.add(r);
    }
  }

  const releasableNodes = findReleasableNodes(store, nodes);

  for (const node of releasableNodes) {
    releaseNode(store, treeState, node);
  }
}

function findReleasableNodes(store, searchFromNodes) {
  const storeState = store.getState();
  const treeState = storeState.currentTree;
  const graph = store.getGraph(treeState.version);
  const releasableNodes = new Set(); // mutated to collect answer

  const nonReleasableNodes = new Set();
  findReleasableNodesInner(searchFromNodes);
  return releasableNodes;

  function findReleasableNodesInner(searchFromNodes) {
    const releasableNodesFoundThisIteration = new Set();
    const downstreams = getDownstreamNodesInTopologicalOrder(store, treeState, searchFromNodes, releasableNodes, // don't descend into these
    nonReleasableNodes // don't descend into these
    ); // Find which of the downstream nodes are releasable and which are not:

    for (const node of downstreams) {
      var _storeState$retention;

      // Not releasable if configured to be retained forever:
      if (getNode$3(node).retainedBy === 'recoilRoot') {
        nonReleasableNodes.add(node);
        continue;
      } // Not releasable if retained directly by a component:


      if (((_storeState$retention = storeState.retention.referenceCounts.get(node)) !== null && _storeState$retention !== void 0 ? _storeState$retention : 0) > 0) {
        nonReleasableNodes.add(node);
        continue;
      } // Not releasable if retained by a zone:


      if (zonesThatCouldRetainNode(node).some(z => storeState.retention.referenceCounts.get(z))) {
        nonReleasableNodes.add(node);
        continue;
      } // Not releasable if it has a non-releasable child (which will already be in
      // nonReleasableNodes because we are going in topological order):


      const nodeChildren = graph.nodeToNodeSubscriptions.get(node);

      if (nodeChildren && Recoil_someSet(nodeChildren, child => nonReleasableNodes.has(child))) {
        nonReleasableNodes.add(node);
        continue;
      }

      releasableNodes.add(node);
      releasableNodesFoundThisIteration.add(node);
    } // If we found any releasable nodes, we need to walk UP from those nodes to
    // find whether their parents can now be released as well:


    const parents = new Set();

    for (const node of releasableNodesFoundThisIteration) {
      for (const parent of (_graph$nodeDeps$get = graph.nodeDeps.get(node)) !== null && _graph$nodeDeps$get !== void 0 ? _graph$nodeDeps$get : emptySet$1) {
        var _graph$nodeDeps$get;

        if (!releasableNodes.has(parent)) {
          parents.add(parent);
        }
      }
    }

    if (parents.size) {
      findReleasableNodesInner(parents);
    }
  }
} // Children before parents


function getDownstreamNodesInTopologicalOrder(store, treeState, nodes, // Mutable set is destroyed in place
doNotDescendInto1, doNotDescendInto2) {
  const graph = store.getGraph(treeState.version);
  const answer = [];
  const visited = new Set();

  while (nodes.size > 0) {
    visit(Recoil_nullthrows(nodes.values().next().value));
  }

  return answer;

  function visit(node) {
    if (doNotDescendInto1.has(node) || doNotDescendInto2.has(node)) {
      nodes.delete(node);
      return;
    }

    if (visited.has(node)) {
      return;
    }

    const children = graph.nodeToNodeSubscriptions.get(node);

    if (children) {
      for (const child of children) {
        visit(child);
      }
    }

    visited.add(node);
    nodes.delete(node);
    answer.push(node);
  }
}

function releaseNode(store, treeState, node) {
  if (!Recoil_gkx('recoil_memory_managament_2020')) {
    return;
  } // Atom effects, in-closure caches, etc.:


  cleanUpNode$1(store, node); // Delete from store state:

  const storeState = store.getState();
  storeState.knownAtoms.delete(node);
  storeState.knownSelectors.delete(node);
  storeState.nodeTransactionSubscriptions.delete(node);
  storeState.retention.referenceCounts.delete(node);
  const zones = zonesThatCouldRetainNode(node);

  for (const zone of zones) {
    var _storeState$retention2;

    (_storeState$retention2 = storeState.retention.nodesRetainedByZone.get(zone)) === null || _storeState$retention2 === void 0 ? void 0 : _storeState$retention2.delete(node);
  } // Note that we DO NOT delete from nodeToComponentSubscriptions because this
  // already happens when the last component that was retaining the node unmounts,
  // and this could happen either before or after that.
  // Delete from TreeState and dep graph:


  treeState.atomValues.delete(node);
  treeState.dirtyAtoms.delete(node);
  treeState.nonvalidatedAtoms.delete(node);
  const graph = storeState.graphsByVersion.get(treeState.version);

  if (graph) {
    const deps = graph.nodeDeps.get(node);

    if (deps !== undefined) {
      graph.nodeDeps.delete(node);

      for (const dep of deps) {
        var _graph$nodeToNodeSubs;

        (_graph$nodeToNodeSubs = graph.nodeToNodeSubscriptions.get(dep)) === null || _graph$nodeToNodeSubs === void 0 ? void 0 : _graph$nodeToNodeSubs.delete(node);
      }
    } // No need to delete sub's deps as there should be no subs at this point.
    // But an invariant would require deleting nodes in topological order.


    graph.nodeToNodeSubscriptions.delete(node);
  } // Node config (for family members only as their configs can be recreated, and
  // only if they are not retained within any other Stores):


  deleteNodeConfigIfPossible$1(node);
}

function nodesRetainedByZone(storeState, zone) {
  var _storeState$retention3;

  return (_storeState$retention3 = storeState.retention.nodesRetainedByZone.get(zone)) !== null && _storeState$retention3 !== void 0 ? _storeState$retention3 : emptySet$1;
}

function zonesThatCouldRetainNode(node) {
  const retainedBy = getNode$3(node).retainedBy;

  if (retainedBy === undefined || retainedBy === 'components' || retainedBy === 'recoilRoot') {
    return [];
  } else if (retainedBy instanceof RetentionZone$2) {
    return [retainedBy];
  } else {
    return retainedBy; // it's an array of zones
  }
}

function scheduleOrPerformPossibleReleaseOfRetainable(store, retainable) {
  const state = store.getState();

  if (state.nextTree) {
    state.retention.retainablesToCheckForRelease.add(retainable);
  } else {
    releaseRetainablesNowOnCurrentTree(store, new Set([retainable]));
  }
}

function updateRetainCount(store, retainable, delta) {
  var _map$get;

  if (!Recoil_gkx('recoil_memory_managament_2020')) {
    return;
  }

  const map = store.getState().retention.referenceCounts;
  const newCount = ((_map$get = map.get(retainable)) !== null && _map$get !== void 0 ? _map$get : 0) + delta;

  if (newCount === 0) {
    updateRetainCountToZero(store, retainable);
  } else {
    map.set(retainable, newCount);
  }
}

function updateRetainCountToZero(store, retainable) {
  if (!Recoil_gkx('recoil_memory_managament_2020')) {
    return;
  }

  const map = store.getState().retention.referenceCounts;
  map.delete(retainable);
  scheduleOrPerformPossibleReleaseOfRetainable(store, retainable);
}

function releaseScheduledRetainablesNow(store) {
  if (!Recoil_gkx('recoil_memory_managament_2020')) {
    return;
  }

  const state = store.getState();
  releaseRetainablesNowOnCurrentTree(store, state.retention.retainablesToCheckForRelease);
  state.retention.retainablesToCheckForRelease.clear();
}

function retainedByOptionWithDefault(r) {
  // The default will change from 'recoilRoot' to 'components' in the future.
  return r === undefined ? 'recoilRoot' : r;
}

var Recoil_Retention = {
  SUSPENSE_TIMEOUT_MS,
  updateRetainCount,
  updateRetainCountToZero,
  releaseScheduledRetainablesNow,
  retainedByOptionWithDefault
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * This is to export esstiential functions from react-dom
 * for our web build
 *
 * 
 * @format
 * @oncall recoil
 */
const {
  unstable_batchedUpdates
} = react_dom__WEBPACK_IMPORTED_MODULE_1__;

var ReactBatchedUpdates = {
  unstable_batchedUpdates
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * This is to export esstiential functions from react-dom
 * for our web build
 *
 * 
 * @format
 * @oncall recoil
 */
// @fb-only: const {unstable_batchedUpdates} = require('ReactDOMComet');
// prettier-ignore
const {
  unstable_batchedUpdates: unstable_batchedUpdates$1
} = ReactBatchedUpdates; // @oss-only


var Recoil_ReactBatchedUpdates = {
  unstable_batchedUpdates: unstable_batchedUpdates$1
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
const {
  batchStart: batchStart$1
} = Recoil_RecoilValueInterface;

const {
  unstable_batchedUpdates: unstable_batchedUpdates$2
} = Recoil_ReactBatchedUpdates; // flowlint-next-line unclear-type:off


/*
 * During SSR, unstable_batchedUpdates may be undefined so this
 * falls back to a basic function that executes the batch
 */
let batcher = unstable_batchedUpdates$2 || (batchFn => batchFn());
/**
 * Sets the provided batcher function as the batcher function used by Recoil.
 *
 * Set the batcher to a custom batcher for your renderer,
 * if you use a renderer other than React DOM or React Native.
 */


const setBatcher = newBatcher => {
  batcher = newBatcher;
};
/**
 * Returns the current batcher function.
 */


const getBatcher = () => batcher;
/**
 * Calls the current batcher function and passes the
 * provided callback function.
 */


const batchUpdates = callback => {
  batcher(() => {
    let batchEnd = () => undefined;

    try {
      batchEnd = batchStart$1();
      callback();
    } finally {
      batchEnd();
    }
  });
};

var Recoil_Batching = {
  getBatcher,
  setBatcher,
  batchUpdates
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/**
 * Combines multiple Iterables into a single Iterable.
 * Traverses the input Iterables in the order provided and maintains the order
 * of their elements.
 *
 * Example:
 * ```
 * const r = Array.from(concatIterables(['a', 'b'], ['c'], ['d', 'e', 'f']));
 * r == ['a', 'b', 'c', 'd', 'e', 'f'];
 * ```
 */

function* concatIterables(iters) {
  for (const iter of iters) {
    for (const val of iter) {
      yield val;
    }
  }
}

var Recoil_concatIterables = concatIterables;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/* eslint-disable fb-www/typeof-undefined */

const isSSR = // $FlowFixMe(site=recoil) Window does not have a FlowType definition https://github.com/facebook/flow/issues/6709
typeof Window === 'undefined' || typeof window === 'undefined';
/* eslint-enable fb-www/typeof-undefined */

const isWindow = value => !isSSR && ( // $FlowFixMe(site=recoil) Window does not have a FlowType definition https://github.com/facebook/flow/issues/6709
value === window || value instanceof Window);

const isReactNative = typeof navigator !== 'undefined' && navigator.product === 'ReactNative'; // eslint-disable-line fb-www/typeof-undefined

var Recoil_Environment = {
  isSSR,
  isReactNative,
  isWindow
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/**
 * Caches a function's results based on the key returned by the passed
 * hashFunction.
 */

function memoizeWithArgsHash(fn, hashFunction) {
  let cache;
  return (...args) => {
    if (!cache) {
      cache = {};
    }

    const key = hashFunction(...args);

    if (!Object.hasOwnProperty.call(cache, key)) {
      cache[key] = fn(...args);
    }

    return cache[key];
  };
}
/**
 * Caches a function's results based on a comparison of the arguments.
 * Only caches the last return of the function.
 * Defaults to reference equality
 */


function memoizeOneWithArgsHash(fn, hashFunction) {
  let lastKey;
  let lastResult; // breaking cache when arguments change

  return (...args) => {
    const key = hashFunction(...args);

    if (lastKey === key) {
      return lastResult;
    }

    lastKey = key;
    lastResult = fn(...args);
    return lastResult;
  };
}
/**
 * Caches a function's results based on a comparison of the arguments.
 * Only caches the last return of the function.
 * Defaults to reference equality
 */


function memoizeOneWithArgsHashAndInvalidation(fn, hashFunction) {
  let lastKey;
  let lastResult; // breaking cache when arguments change

  const memoizedFn = (...args) => {
    const key = hashFunction(...args);

    if (lastKey === key) {
      return lastResult;
    }

    lastKey = key;
    lastResult = fn(...args);
    return lastResult;
  };

  const invalidate = () => {
    lastKey = null;
  };

  return [memoizedFn, invalidate];
}

var Recoil_Memoize = {
  memoizeWithArgsHash,
  memoizeOneWithArgsHash,
  memoizeOneWithArgsHashAndInvalidation
};

const {
  batchUpdates: batchUpdates$1
} = Recoil_Batching;

const {
  initializeNode: initializeNode$1,
  peekNodeInfo: peekNodeInfo$1
} = Recoil_FunctionalCore;

const {
  graph: graph$1
} = Recoil_Graph;

const {
  getNextStoreID: getNextStoreID$1
} = Recoil_Keys;

const {
  DEFAULT_VALUE: DEFAULT_VALUE$1,
  recoilValues: recoilValues$1,
  recoilValuesForKeys: recoilValuesForKeys$2
} = Recoil_Node;

const {
  AbstractRecoilValue: AbstractRecoilValue$2,
  getRecoilValueAsLoadable: getRecoilValueAsLoadable$1,
  setRecoilValue: setRecoilValue$1,
  setUnvalidatedRecoilValue: setUnvalidatedRecoilValue$1
} = Recoil_RecoilValueInterface;

const {
  updateRetainCount: updateRetainCount$1
} = Recoil_Retention;

const {
  setInvalidateMemoizedSnapshot: setInvalidateMemoizedSnapshot$1
} = Recoil_SnapshotCache;

const {
  getNextTreeStateVersion: getNextTreeStateVersion$2,
  makeEmptyStoreState: makeEmptyStoreState$1
} = Recoil_State;



const {
  isSSR: isSSR$1
} = Recoil_Environment;









const {
  memoizeOneWithArgsHashAndInvalidation: memoizeOneWithArgsHashAndInvalidation$1
} = Recoil_Memoize;



 // Opaque at this surface because it's part of the public API from here.


const retainWarning = (/* unused pure expression or super */ null && (`
Recoil Snapshots only last for the duration of the callback they are provided to. To keep a Snapshot longer, do this:

  const release = snapshot.retain();
  try {
    await doSomethingWithSnapshot(snapshot);
  } finally {
    release();
  }

This is currently a DEV-only warning but will become a thrown exception in the next release of Recoil.
`)); // A "Snapshot" is "read-only" and captures a specific set of values of atoms.
// However, the data-flow-graph and selector values may evolve as selector
// evaluation functions are executed and async selectors resolve.

class Snapshot {
  // eslint-disable-next-line fb-www/no-uninitialized-properties
  constructor(storeState, parentStoreID) {
    _defineProperty(this, "_store", void 0);

    _defineProperty(this, "_refCount", 1);

    _defineProperty(this, "getLoadable", recoilValue => {
      this.checkRefCount_INTERNAL();
      return getRecoilValueAsLoadable$1(this._store, recoilValue);
    });

    _defineProperty(this, "getPromise", recoilValue => {
      this.checkRefCount_INTERNAL();
      return this.getLoadable(recoilValue).toPromise();
    });

    _defineProperty(this, "getNodes_UNSTABLE", opt => {
      this.checkRefCount_INTERNAL(); // TODO Deal with modified selectors

      if ((opt === null || opt === void 0 ? void 0 : opt.isModified) === true) {
        if ((opt === null || opt === void 0 ? void 0 : opt.isInitialized) === false) {
          return [];
        }

        const state = this._store.getState().currentTree;

        return recoilValuesForKeys$2(state.dirtyAtoms);
      }

      const knownAtoms = this._store.getState().knownAtoms;

      const knownSelectors = this._store.getState().knownSelectors;

      return (opt === null || opt === void 0 ? void 0 : opt.isInitialized) == null ? recoilValues$1.values() : opt.isInitialized === true ? recoilValuesForKeys$2(Recoil_concatIterables([knownAtoms, knownSelectors])) : Recoil_filterIterable(recoilValues$1.values(), ({
        key
      }) => !knownAtoms.has(key) && !knownSelectors.has(key));
    });

    _defineProperty(this, "getInfo_UNSTABLE", ({
      key
    }) => {
      this.checkRefCount_INTERNAL();
      return peekNodeInfo$1(this._store, this._store.getState().currentTree, key);
    });

    _defineProperty(this, "map", mapper => {
      this.checkRefCount_INTERNAL();
      const mutableSnapshot = new MutableSnapshot(this, batchUpdates$1);
      mapper(mutableSnapshot); // if removing batchUpdates from `set` add it here

      return mutableSnapshot;
    });

    _defineProperty(this, "asyncMap", async mapper => {
      this.checkRefCount_INTERNAL();
      const mutableSnapshot = new MutableSnapshot(this, batchUpdates$1);
      mutableSnapshot.retain(); // Retain new snapshot during async mapper

      await mapper(mutableSnapshot); // Continue to retain the new snapshot for the user, but auto-release it
      // after the next tick, the same as a new synchronous snapshot.

      mutableSnapshot.autoRelease_INTERNAL();
      return mutableSnapshot;
    });

    this._store = {
      storeID: getNextStoreID$1(),
      parentStoreID,
      getState: () => storeState,
      replaceState: replacer => {
        // no batching, so nextTree is never active
        storeState.currentTree = replacer(storeState.currentTree);
      },
      getGraph: version => {
        const graphs = storeState.graphsByVersion;

        if (graphs.has(version)) {
          return Recoil_nullthrows(graphs.get(version));
        }

        const newGraph = graph$1();
        graphs.set(version, newGraph);
        return newGraph;
      },
      subscribeToTransactions: () => ({
        release: () => {}
      }),
      addTransactionMetadata: () => {
        throw Recoil_err('Cannot subscribe to Snapshots');
      }
    }; // Initialize any nodes that are live in the parent store (primarily so that
    // this snapshot gets counted towards the node's live stores count).
    // TODO Optimize this when cloning snapshots for callbacks

    for (const nodeKey of this._store.getState().knownAtoms) {
      initializeNode$1(this._store, nodeKey, 'get');
      updateRetainCount$1(this._store, nodeKey, 1);
    }

    this.autoRelease_INTERNAL();
  }

  retain() {
    if (this._refCount <= 0) {
      if (false) {} else {
        Recoil_recoverableViolation('Attempt to retain() Snapshot that was already released.');
      }
    }

    this._refCount++;
    let released = false;
    return () => {
      if (!released) {
        released = true;

        this._release();
      }
    };
  }
  /**
   * Release the snapshot on the next tick.  This means the snapshot is retained
   * during the execution of the current function using it.
   */


  autoRelease_INTERNAL() {
    if (!isSSR$1) {
      // Use timeout of 10 to workaround Firefox issue: https://github.com/facebookexperimental/Recoil/issues/1936
      window.setTimeout(() => this._release(), 10);
    }
  }

  _release() {
    this._refCount--;

    if (this._refCount === 0) {
      this._store.getState().nodeCleanupFunctions.forEach(cleanup => cleanup());

      this._store.getState().nodeCleanupFunctions.clear();

      if (!Recoil_gkx('recoil_memory_managament_2020')) {
        return;
      } // Temporarily nerfing this to allow us to find broken call sites without
      // actually breaking anybody yet.
      // for (const k of this._store.getState().knownAtoms) {
      //   updateRetainCountToZero(this._store, k);
      // }

    } else if (this._refCount < 0) {
      if (false) {}
    }
  }

  isRetained() {
    return this._refCount > 0;
  }

  checkRefCount_INTERNAL() {
    if (Recoil_gkx('recoil_memory_managament_2020') && this._refCount <= 0) {
      if (false) {} // What we will ship later:
      // throw err(retainWarning);

    }
  }

  getStore_INTERNAL() {
    this.checkRefCount_INTERNAL();
    return this._store;
  }

  getID() {
    this.checkRefCount_INTERNAL();
    return this._store.getState().currentTree.stateID;
  }

  getStoreID() {
    this.checkRefCount_INTERNAL();
    return this._store.storeID;
  } // We want to allow the methods to be destructured and used as accessors

  /* eslint-disable fb-www/extra-arrow-initializer */

  /* eslint-enable fb-www/extra-arrow-initializer */


}

function cloneStoreState(store, treeState, bumpVersion = false) {
  const storeState = store.getState();
  const version = bumpVersion ? getNextTreeStateVersion$2() : treeState.version;
  return {
    // Always clone the TreeState to isolate stores from accidental mutations.
    // For example, reading a selector from a cloned snapshot shouldn't cache
    // in the original treestate which may cause the original to skip
    // initialization of upstream atoms.
    currentTree: {
      // TODO snapshots shouldn't really have versions because a new version number
      // is always assigned when the snapshot is gone to.
      version: bumpVersion ? version : treeState.version,
      stateID: bumpVersion ? version : treeState.stateID,
      transactionMetadata: { ...treeState.transactionMetadata
      },
      dirtyAtoms: new Set(treeState.dirtyAtoms),
      atomValues: treeState.atomValues.clone(),
      nonvalidatedAtoms: treeState.nonvalidatedAtoms.clone()
    },
    commitDepth: 0,
    nextTree: null,
    previousTree: null,
    knownAtoms: new Set(storeState.knownAtoms),
    // FIXME here's a copy
    knownSelectors: new Set(storeState.knownSelectors),
    // FIXME here's a copy
    transactionSubscriptions: new Map(),
    nodeTransactionSubscriptions: new Map(),
    nodeToComponentSubscriptions: new Map(),
    queuedComponentCallbacks_DEPRECATED: [],
    suspendedComponentResolvers: new Set(),
    graphsByVersion: new Map().set(version, store.getGraph(treeState.version)),
    retention: {
      referenceCounts: new Map(),
      nodesRetainedByZone: new Map(),
      retainablesToCheckForRelease: new Set()
    },
    // FIXME here's a copy
    // Create blank cleanup handlers for atoms so snapshots don't re-run
    // atom effects.
    nodeCleanupFunctions: new Map(Recoil_mapIterable(storeState.nodeCleanupFunctions.entries(), ([key]) => [key, () => {}]))
  };
} // Factory to build a fresh snapshot


function freshSnapshot(initializeState) {
  const snapshot = new Snapshot(makeEmptyStoreState$1());
  return initializeState != null ? snapshot.map(initializeState) : snapshot;
} // Factory to clone a snapshot state


const [memoizedCloneSnapshot, invalidateMemoizedSnapshot$2] = memoizeOneWithArgsHashAndInvalidation$1( // $FlowFixMe[missing-local-annot]
(store, version) => {
  var _storeState$nextTree;

  const storeState = store.getState();
  const treeState = version === 'latest' ? (_storeState$nextTree = storeState.nextTree) !== null && _storeState$nextTree !== void 0 ? _storeState$nextTree : storeState.currentTree : Recoil_nullthrows(storeState.previousTree);
  return new Snapshot(cloneStoreState(store, treeState), store.storeID);
}, (store, version) => {
  var _store$getState$nextT, _store$getState$previ;

  return String(version) + String(store.storeID) + String((_store$getState$nextT = store.getState().nextTree) === null || _store$getState$nextT === void 0 ? void 0 : _store$getState$nextT.version) + String(store.getState().currentTree.version) + String((_store$getState$previ = store.getState().previousTree) === null || _store$getState$previ === void 0 ? void 0 : _store$getState$previ.version);
}); // Avoid circular dependencies

setInvalidateMemoizedSnapshot$1(invalidateMemoizedSnapshot$2);

function cloneSnapshot(store, version = 'latest') {
  const snapshot = memoizedCloneSnapshot(store, version);

  if (!snapshot.isRetained()) {
    invalidateMemoizedSnapshot$2();
    return memoizedCloneSnapshot(store, version);
  }

  return snapshot;
}

class MutableSnapshot extends Snapshot {
  constructor(snapshot, batch) {
    super(cloneStoreState(snapshot.getStore_INTERNAL(), snapshot.getStore_INTERNAL().getState().currentTree, true), snapshot.getStoreID());

    _defineProperty(this, "_batch", void 0);

    _defineProperty(this, "set", (recoilState, newValueOrUpdater) => {
      this.checkRefCount_INTERNAL();
      const store = this.getStore_INTERNAL(); // This batchUpdates ensures this `set` is applied immediately and you can
      // read the written value after calling `set`. I would like to remove this
      // behavior and only batch in `Snapshot.map`, but this would be a breaking
      // change potentially.

      this._batch(() => {
        updateRetainCount$1(store, recoilState.key, 1);
        setRecoilValue$1(this.getStore_INTERNAL(), recoilState, newValueOrUpdater);
      });
    });

    _defineProperty(this, "reset", recoilState => {
      this.checkRefCount_INTERNAL();
      const store = this.getStore_INTERNAL(); // See note at `set` about batched updates.

      this._batch(() => {
        updateRetainCount$1(store, recoilState.key, 1);
        setRecoilValue$1(this.getStore_INTERNAL(), recoilState, DEFAULT_VALUE$1);
      });
    });

    _defineProperty(this, "setUnvalidatedAtomValues_DEPRECATED", values => {
      this.checkRefCount_INTERNAL();
      const store = this.getStore_INTERNAL(); // See note at `set` about batched updates.

      batchUpdates$1(() => {
        for (const [k, v] of values.entries()) {
          updateRetainCount$1(store, k, 1);
          setUnvalidatedRecoilValue$1(store, new AbstractRecoilValue$2(k), v);
        }
      });
    });

    this._batch = batch;
  }

}

var Recoil_Snapshot = {
  Snapshot,
  MutableSnapshot,
  freshSnapshot,
  cloneSnapshot
};

var Recoil_Snapshot_1 = Recoil_Snapshot.Snapshot;
var Recoil_Snapshot_2 = Recoil_Snapshot.MutableSnapshot;
var Recoil_Snapshot_3 = Recoil_Snapshot.freshSnapshot;
var Recoil_Snapshot_4 = Recoil_Snapshot.cloneSnapshot;

var Recoil_Snapshot$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Snapshot: Recoil_Snapshot_1,
  MutableSnapshot: Recoil_Snapshot_2,
  freshSnapshot: Recoil_Snapshot_3,
  cloneSnapshot: Recoil_Snapshot_4
});

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

function unionSets(...sets) {
  const result = new Set();

  for (const set of sets) {
    for (const value of set) {
      result.add(value);
    }
  }

  return result;
}

var Recoil_unionSets = unionSets;

const {
  useRef
} = react__WEBPACK_IMPORTED_MODULE_0__;
/**
 * The same as `useRef()` except that if a function is specified then it will
 * call that function to get the value to initialize the reference with.
 * This is similar to how `useState()` behaves when given a function.  It allows
 * the user to avoid generating the initial value for subsequent renders.
 * The tradeoff is that to set the reference to a function itself you need to
 * nest it: useRefInitOnce(() => () => {...});
 */


function useRefInitOnce(initialValue) {
  // $FlowExpectedError[incompatible-call]
  const ref = useRef(initialValue);

  if (ref.current === initialValue && typeof initialValue === 'function') {
    // $FlowExpectedError[incompatible-use]
    ref.current = initialValue();
  }

  return ref;
}

var Recoil_useRefInitOnce = useRefInitOnce;

// @fb-only: const RecoilusagelogEvent = require('RecoilusagelogEvent');
// @fb-only: const RecoilUsageLogFalcoEvent = require('RecoilUsageLogFalcoEvent');
// @fb-only: const URI = require('URI');


const {
  getNextTreeStateVersion: getNextTreeStateVersion$3,
  makeEmptyStoreState: makeEmptyStoreState$2
} = Recoil_State;

const {
  cleanUpNode: cleanUpNode$2,
  getDownstreamNodes: getDownstreamNodes$2,
  initializeNode: initializeNode$2,
  setNodeValue: setNodeValue$2,
  setUnvalidatedAtomValue_DEPRECATED: setUnvalidatedAtomValue_DEPRECATED$1
} = Recoil_FunctionalCore;

const {
  graph: graph$2
} = Recoil_Graph;

const {
  cloneGraph: cloneGraph$1
} = Recoil_Graph;

const {
  getNextStoreID: getNextStoreID$2
} = Recoil_Keys;

const {
  createMutableSource: createMutableSource$1,
  reactMode: reactMode$2
} = Recoil_ReactMode;

const {
  applyAtomValueWrites: applyAtomValueWrites$1
} = Recoil_RecoilValueInterface;

const {
  releaseScheduledRetainablesNow: releaseScheduledRetainablesNow$1
} = Recoil_Retention;

const {
  freshSnapshot: freshSnapshot$1
} = Recoil_Snapshot$1;



const {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef: useRef$1,
  useState
} = react__WEBPACK_IMPORTED_MODULE_0__;















function notInAContext() {
  throw Recoil_err('This component must be used inside a <RecoilRoot> component.');
}

const defaultStore = Object.freeze({
  storeID: getNextStoreID$2(),
  getState: notInAContext,
  replaceState: notInAContext,
  getGraph: notInAContext,
  subscribeToTransactions: notInAContext,
  addTransactionMetadata: notInAContext
});
let stateReplacerIsBeingExecuted = false;

function startNextTreeIfNeeded(store) {
  if (stateReplacerIsBeingExecuted) {
    throw Recoil_err('An atom update was triggered within the execution of a state updater function. State updater functions provided to Recoil must be pure functions.');
  }

  const storeState = store.getState();

  if (storeState.nextTree === null) {
    if (Recoil_gkx('recoil_memory_managament_2020') && Recoil_gkx('recoil_release_on_cascading_update_killswitch_2021')) {
      // If this is a cascading update (that is, rendering due to one state change
      // invokes a second state change), we won't have cleaned up retainables yet
      // because this normally happens after notifying components. Do it before
      // proceeding with the cascading update so that it remains predictable:
      if (storeState.commitDepth > 0) {
        releaseScheduledRetainablesNow$1(store);
      }
    }

    const version = storeState.currentTree.version;
    const nextVersion = getNextTreeStateVersion$3();
    storeState.nextTree = { ...storeState.currentTree,
      version: nextVersion,
      stateID: nextVersion,
      dirtyAtoms: new Set(),
      transactionMetadata: {}
    };
    storeState.graphsByVersion.set(nextVersion, cloneGraph$1(Recoil_nullthrows(storeState.graphsByVersion.get(version))));
  }
}

const AppContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext({
  current: defaultStore
});

const useStoreRef = () => useContext(AppContext); // $FlowExpectedError[incompatible-call]


const MutableSourceContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);

function useRecoilMutableSource() {
  const mutableSource = useContext(MutableSourceContext);

  if (mutableSource == null) {
    Recoil_expectationViolation('Attempted to use a Recoil hook outside of a <RecoilRoot>. ' + '<RecoilRoot> must be an ancestor of any component that uses ' + 'Recoil hooks.');
  }

  return mutableSource;
}

function notifyComponents(store, storeState, treeState) {
  const dependentNodes = getDownstreamNodes$2(store, treeState, treeState.dirtyAtoms);

  for (const key of dependentNodes) {
    const comps = storeState.nodeToComponentSubscriptions.get(key);

    if (comps) {
      for (const [_subID, [_debugName, callback]] of comps) {
        callback(treeState);
      }
    }
  }
}

function sendEndOfBatchNotifications(store) {
  const storeState = store.getState();
  const treeState = storeState.currentTree; // Inform transaction subscribers of the transaction:

  const dirtyAtoms = treeState.dirtyAtoms;

  if (dirtyAtoms.size) {
    // Execute Node-specific subscribers before global subscribers
    for (const [key, subscriptions] of storeState.nodeTransactionSubscriptions) {
      if (dirtyAtoms.has(key)) {
        for (const [_, subscription] of subscriptions) {
          subscription(store);
        }
      }
    }

    for (const [_, subscription] of storeState.transactionSubscriptions) {
      subscription(store);
    }

    if (!reactMode$2().early || storeState.suspendedComponentResolvers.size > 0) {
      // Notifying components is needed to wake from suspense, even when using
      // early rendering.
      notifyComponents(store, storeState, treeState); // Wake all suspended components so the right one(s) can try to re-render.
      // We need to wake up components not just when some asynchronous selector
      // resolved, but also when changing synchronous values because this may cause
      // a selector to change from asynchronous to synchronous, in which case there
      // would be no follow-up asynchronous resolution to wake us up.
      // TODO OPTIMIZATION Only wake up related downstream components

      storeState.suspendedComponentResolvers.forEach(cb => cb());
      storeState.suspendedComponentResolvers.clear();
    }
  } // Special behavior ONLY invoked by useInterface.
  // FIXME delete queuedComponentCallbacks_DEPRECATED when deleting useInterface.


  storeState.queuedComponentCallbacks_DEPRECATED.forEach(cb => cb(treeState));
  storeState.queuedComponentCallbacks_DEPRECATED.splice(0, storeState.queuedComponentCallbacks_DEPRECATED.length);
}

function endBatch(store) {
  const storeState = store.getState();
  storeState.commitDepth++;

  try {
    const {
      nextTree
    } = storeState; // Ignore commits that are not because of Recoil transactions -- namely,
    // because something above RecoilRoot re-rendered:

    if (nextTree == null) {
      return;
    } // nextTree is now committed -- note that copying and reset occurs when
    // a transaction begins, in startNextTreeIfNeeded:


    storeState.previousTree = storeState.currentTree;
    storeState.currentTree = nextTree;
    storeState.nextTree = null;
    sendEndOfBatchNotifications(store);

    if (storeState.previousTree != null) {
      storeState.graphsByVersion.delete(storeState.previousTree.version);
    } else {
      Recoil_recoverableViolation('Ended batch with no previous state, which is unexpected', 'recoil');
    }

    storeState.previousTree = null;

    if (Recoil_gkx('recoil_memory_managament_2020')) {
      // Only release retainables if there were no writes during the end of the
      // batch.  This avoids releasing something we might be about to use.
      if (nextTree == null) {
        releaseScheduledRetainablesNow$1(store);
      }
    }
  } finally {
    storeState.commitDepth--;
  }
}
/*
 * The purpose of the Batcher is to observe when React batches end so that
 * Recoil state changes can be batched. Whenever Recoil state changes, we call
 * setState on the batcher. Then we wait for that change to be committed, which
 * signifies the end of the batch. That's when we respond to the Recoil change.
 */


function Batcher({
  setNotifyBatcherOfChange
}) {
  const storeRef = useStoreRef();
  const [, setState] = useState([]); // $FlowFixMe[incompatible-call]

  setNotifyBatcherOfChange(() => setState({}));
  useEffect(() => {
    // $FlowFixMe[incompatible-call]
    setNotifyBatcherOfChange(() => setState({})); // If an asynchronous selector resolves after the Batcher is unmounted,
    // notifyBatcherOfChange will still be called. An error gets thrown whenever
    // setState is called after a component is already unmounted, so this sets
    // notifyBatcherOfChange to be a no-op.

    return () => {
      setNotifyBatcherOfChange(() => {});
    };
  }, [setNotifyBatcherOfChange]);
  useEffect(() => {
    // enqueueExecution runs this function immediately; it is only used to
    // manipulate the order of useEffects during tests, since React seems to
    // call useEffect in an unpredictable order sometimes.
    Recoil_Queue.enqueueExecution('Batcher', () => {
      endBatch(storeRef.current);
    });
  });
  return null;
}

if (false) {} // When removing this deprecated function, remove stateBySettingRecoilValue
// which will no longer be needed.


function initialStoreState_DEPRECATED(store, initializeState) {
  const initial = makeEmptyStoreState$2();
  initializeState({
    set: (atom, value) => {
      const state = initial.currentTree;
      const writes = setNodeValue$2(store, state, atom.key, value);
      const writtenNodes = new Set(writes.keys());
      const nonvalidatedAtoms = state.nonvalidatedAtoms.clone();

      for (const n of writtenNodes) {
        nonvalidatedAtoms.delete(n);
      }

      initial.currentTree = { ...state,
        dirtyAtoms: Recoil_unionSets(state.dirtyAtoms, writtenNodes),
        atomValues: applyAtomValueWrites$1(state.atomValues, writes),
        // NB: PLEASE un-export applyAtomValueWrites when deleting this code
        nonvalidatedAtoms
      };
    },
    setUnvalidatedAtomValues: atomValues => {
      // FIXME replace this with a mutative loop
      atomValues.forEach((v, k) => {
        initial.currentTree = setUnvalidatedAtomValue_DEPRECATED$1(initial.currentTree, k, v);
      });
    }
  });
  return initial;
} // Initialize state snapshot for <RecoilRoot> for the initializeState prop.
// Atom effect initialization takes precedence over this prop.
// Any atom effects will be run before initialization, but then cleaned up,
// they are then re-run when used as part of rendering.  These semantics are
// compatible with React StrictMode where effects may be re-run multiple times
// but state initialization only happens once the first time.


function initialStoreState(initializeState) {
  // Initialize a snapshot and get its store
  const snapshot = freshSnapshot$1(initializeState);
  const storeState = snapshot.getStore_INTERNAL().getState(); // Counteract the snapshot auto-release

  snapshot.retain(); // Cleanup any effects run during initialization and clear the handlers so
  // they will re-initialize if used during rendering.  This allows atom effect
  // initialization to take precedence over initializeState and be compatible
  // with StrictMode semantics.

  storeState.nodeCleanupFunctions.forEach(cleanup => cleanup());
  storeState.nodeCleanupFunctions.clear();
  return storeState;
}

let nextID = 0;

function RecoilRoot_INTERNAL({
  initializeState_DEPRECATED,
  initializeState,
  store_INTERNAL: storeProp,
  // For use with React "context bridging"
  children
}) {
  // prettier-ignore
  // @fb-only: useEffect(() => {
  // @fb-only: if (gkx('recoil_usage_logging')) {
  // @fb-only: try {
  // @fb-only: RecoilUsageLogFalcoEvent.log(() => ({
  // @fb-only: type: RecoilusagelogEvent.RECOIL_ROOT_MOUNTED,
  // @fb-only: path: URI.getRequestURI().getPath(),
  // @fb-only: }));
  // @fb-only: } catch {
  // @fb-only: recoverableViolation(
  // @fb-only: 'Error when logging Recoil Usage event',
  // @fb-only: 'recoil',
  // @fb-only: );
  // @fb-only: }
  // @fb-only: }
  // @fb-only: }, []);
  let storeStateRef; // eslint-disable-line prefer-const

  const getGraph = version => {
    const graphs = storeStateRef.current.graphsByVersion;

    if (graphs.has(version)) {
      return Recoil_nullthrows(graphs.get(version));
    }

    const newGraph = graph$2();
    graphs.set(version, newGraph);
    return newGraph;
  };

  const subscribeToTransactions = (callback, key) => {
    if (key == null) {
      // Global transaction subscriptions
      const {
        transactionSubscriptions
      } = storeRef.current.getState();
      const id = nextID++;
      transactionSubscriptions.set(id, callback);
      return {
        release: () => {
          transactionSubscriptions.delete(id);
        }
      };
    } else {
      // Node-specific transaction subscriptions:
      const {
        nodeTransactionSubscriptions
      } = storeRef.current.getState();

      if (!nodeTransactionSubscriptions.has(key)) {
        nodeTransactionSubscriptions.set(key, new Map());
      }

      const id = nextID++;
      Recoil_nullthrows(nodeTransactionSubscriptions.get(key)).set(id, callback);
      return {
        release: () => {
          const subs = nodeTransactionSubscriptions.get(key);

          if (subs) {
            subs.delete(id);

            if (subs.size === 0) {
              nodeTransactionSubscriptions.delete(key);
            }
          }
        }
      };
    }
  };

  const addTransactionMetadata = metadata => {
    startNextTreeIfNeeded(storeRef.current);

    for (const k of Object.keys(metadata)) {
      Recoil_nullthrows(storeRef.current.getState().nextTree).transactionMetadata[k] = metadata[k];
    }
  };

  const replaceState = replacer => {
    startNextTreeIfNeeded(storeRef.current); // Use replacer to get the next state:

    const nextTree = Recoil_nullthrows(storeStateRef.current.nextTree);
    let replaced;

    try {
      stateReplacerIsBeingExecuted = true;
      replaced = replacer(nextTree);
    } finally {
      stateReplacerIsBeingExecuted = false;
    }

    if (replaced === nextTree) {
      return;
    }

    if (false) {} // Save changes to nextTree and schedule a React update:


    storeStateRef.current.nextTree = replaced;

    if (reactMode$2().early) {
      notifyComponents(storeRef.current, storeStateRef.current, replaced);
    }

    Recoil_nullthrows(notifyBatcherOfChange.current)();
  };

  const notifyBatcherOfChange = useRef$1(null);
  const setNotifyBatcherOfChange = useCallback(x => {
    notifyBatcherOfChange.current = x;
  }, [notifyBatcherOfChange]);
  const storeRef = Recoil_useRefInitOnce(() => storeProp !== null && storeProp !== void 0 ? storeProp : {
    storeID: getNextStoreID$2(),
    getState: () => storeStateRef.current,
    replaceState,
    getGraph,
    subscribeToTransactions,
    addTransactionMetadata
  });

  if (storeProp != null) {
    storeRef.current = storeProp;
  }

  storeStateRef = Recoil_useRefInitOnce(() => initializeState_DEPRECATED != null ? initialStoreState_DEPRECATED(storeRef.current, initializeState_DEPRECATED) : initializeState != null ? initialStoreState(initializeState) : makeEmptyStoreState$2());
  const mutableSource = useMemo(() => createMutableSource$1 === null || createMutableSource$1 === void 0 ? void 0 : createMutableSource$1(storeStateRef, () => storeStateRef.current.currentTree.version), [storeStateRef]); // Cleanup when the <RecoilRoot> is unmounted

  useEffect(() => {
    // React is free to call effect cleanup handlers and effects at will, the
    // deps array is only an optimization.  For example, React strict mode
    // will execute each effect twice for testing.  Therefore, we need symmetry
    // to re-initialize all known atoms after they were cleaned up.
    const store = storeRef.current;

    for (const atomKey of new Set(store.getState().knownAtoms)) {
      initializeNode$2(store, atomKey, 'get');
    }

    return () => {
      for (const atomKey of store.getState().knownAtoms) {
        cleanUpNode$2(store, atomKey);
      }
    };
  }, [storeRef]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(AppContext.Provider, {
    value: storeRef
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(MutableSourceContext.Provider, {
    value: mutableSource
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Batcher, {
    setNotifyBatcherOfChange: setNotifyBatcherOfChange
  }), children));
}

function RecoilRoot(props) {
  const {
    override,
    ...propsExceptOverride
  } = props;
  const ancestorStoreRef = useStoreRef();

  if (override === false && ancestorStoreRef.current !== defaultStore) {
    // If ancestorStoreRef.current !== defaultStore, it means that this
    // RecoilRoot is not nested within another.
    return props.children;
  }

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(RecoilRoot_INTERNAL, propsExceptOverride);
}

function useRecoilStoreID() {
  return useStoreRef().current.storeID;
}

var Recoil_RecoilRoot = {
  RecoilRoot,
  useStoreRef,
  useRecoilMutableSource,
  useRecoilStoreID,
  notifyComponents_FOR_TESTING: notifyComponents,
  sendEndOfBatchNotifications_FOR_TESTING: sendEndOfBatchNotifications
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

function shallowArrayEqual(a, b) {
  if (a === b) {
    return true;
  }

  if (a.length !== b.length) {
    return false;
  }

  for (let i = 0, l = a.length; i < l; i++) {
    if (a[i] !== b[i]) {
      return false;
    }
  }

  return true;
}

var Recoil_shallowArrayEqual = shallowArrayEqual;

const {
  useEffect: useEffect$1,
  useRef: useRef$2
} = react__WEBPACK_IMPORTED_MODULE_0__;

function usePrevious(value) {
  const ref = useRef$2();
  useEffect$1(() => {
    // $FlowFixMe[incompatible-type]
    ref.current = value;
  });
  return ref.current;
}

var Recoil_usePrevious = usePrevious;

const {
  useStoreRef: useStoreRef$1
} = Recoil_RecoilRoot;

const {
  SUSPENSE_TIMEOUT_MS: SUSPENSE_TIMEOUT_MS$1
} = Recoil_Retention;

const {
  updateRetainCount: updateRetainCount$2
} = Recoil_Retention;

const {
  RetentionZone: RetentionZone$3
} = Recoil_RetentionZone;

const {
  useEffect: useEffect$2,
  useRef: useRef$3
} = react__WEBPACK_IMPORTED_MODULE_0__;

const {
  isSSR: isSSR$2
} = Recoil_Environment;





 // I don't see a way to avoid the any type here because we want to accept readable
// and writable values with any type parameter, but normally with writable ones
// RecoilState<SomeT> is not a subtype of RecoilState<mixed>.


// flowlint-line unclear-type:off
function useRetain(toRetain) {
  if (!Recoil_gkx('recoil_memory_managament_2020')) {
    return;
  } // eslint-disable-next-line fb-www/react-hooks


  return useRetain_ACTUAL(toRetain);
}

function useRetain_ACTUAL(toRetain) {
  const array = Array.isArray(toRetain) ? toRetain : [toRetain];
  const retainables = array.map(a => a instanceof RetentionZone$3 ? a : a.key);
  const storeRef = useStoreRef$1();
  useEffect$2(() => {
    if (!Recoil_gkx('recoil_memory_managament_2020')) {
      return;
    }

    const store = storeRef.current;

    if (timeoutID.current && !isSSR$2) {
      // Already performed a temporary retain on render, simply cancel the release
      // of that temporary retain.
      window.clearTimeout(timeoutID.current);
      timeoutID.current = null;
    } else {
      for (const r of retainables) {
        updateRetainCount$2(store, r, 1);
      }
    }

    return () => {
      for (const r of retainables) {
        updateRetainCount$2(store, r, -1);
      }
    }; // eslint-disable-next-line fb-www/react-hooks-deps
  }, [storeRef, ...retainables]); // We want to retain if the component suspends. This is terrible but the Suspense
  // API affords us no better option. If we suspend and never commit after some
  // seconds, then release. The 'actual' retain/release in the effect above
  // cancels this.

  const timeoutID = useRef$3();
  const previousRetainables = Recoil_usePrevious(retainables);

  if (!isSSR$2 && (previousRetainables === undefined || !Recoil_shallowArrayEqual(previousRetainables, retainables))) {
    const store = storeRef.current;

    for (const r of retainables) {
      updateRetainCount$2(store, r, 1);
    }

    if (previousRetainables) {
      for (const r of previousRetainables) {
        updateRetainCount$2(store, r, -1);
      }
    }

    if (timeoutID.current) {
      window.clearTimeout(timeoutID.current);
    }

    timeoutID.current = window.setTimeout(() => {
      timeoutID.current = null;

      for (const r of retainables) {
        updateRetainCount$2(store, r, -1);
      }
    }, SUSPENSE_TIMEOUT_MS$1);
  }
}

var Recoil_useRetain = useRetain;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/**
 * THIS CODE HAS BEEN COMMENTED OUT INTENTIONALLY
 *
 * This technique of getting the component name is imperfect, since it both only
 * works in a non-minified code base, and more importantly introduces performance
 * problems since it relies in throwing errors which is an expensive operation.
 *
 * At some point we may want to reevaluate this technique hence why we have commented
 * this code out, rather than delete it all together.
 */
// const {useRef} = require('react');
// const gkx = require('recoil-shared/util/Recoil_gkx');
// const stackTraceParser = require('recoil-shared/util/Recoil_stackTraceParser');

function useComponentName() {
  // const nameRef = useRef();
  // if (__DEV__) {
  //   if (gkx('recoil_infer_component_names')) {
  //     if (nameRef.current === undefined) {
  //       // There is no blessed way to determine the calling React component from
  //       // within a hook. This hack uses the fact that hooks must start with 'use'
  //       // and that hooks are either called by React Components or other hooks. It
  //       // follows therefore, that to find the calling component, you simply need
  //       // to look down the stack and find the first function which doesn't start
  //       // with 'use'. We are only enabling this in dev for now, since once the
  //       // codebase is minified, the naming assumptions no longer hold true.
  //       // eslint-disable-next-line fb-www/no-new-error
  //       const frames = stackTraceParser(new Error().stack);
  //       for (const {methodName} of frames) {
  //         // I observed cases where the frame was of the form 'Object.useXXX'
  //         // hence why I'm searching for hooks following a word boundary
  //         if (!methodName.match(/\buse[^\b]+$/)) {
  //           return (nameRef.current = methodName);
  //         }
  //       }
  //       nameRef.current = null;
  //     }
  //     return nameRef.current ?? '<unable to determine component name>';
  //   }
  // }
  // @fb-only: return "<component name only available when both in dev mode and when passing GK 'recoil_infer_component_names'>";
  return '<component name not available>'; // @oss-only
}

var Recoil_useComponentName = useComponentName;

const {
  batchUpdates: batchUpdates$2
} = Recoil_Batching;

const {
  DEFAULT_VALUE: DEFAULT_VALUE$2
} = Recoil_Node;

const {
  currentRendererSupportsUseSyncExternalStore: currentRendererSupportsUseSyncExternalStore$1,
  reactMode: reactMode$3,
  useMutableSource: useMutableSource$1,
  useSyncExternalStore: useSyncExternalStore$1
} = Recoil_ReactMode;

const {
  useRecoilMutableSource: useRecoilMutableSource$1,
  useStoreRef: useStoreRef$2
} = Recoil_RecoilRoot;

const {
  isRecoilValue: isRecoilValue$2
} = Recoil_RecoilValue$1;

const {
  AbstractRecoilValue: AbstractRecoilValue$3,
  getRecoilValueAsLoadable: getRecoilValueAsLoadable$2,
  setRecoilValue: setRecoilValue$2,
  setUnvalidatedRecoilValue: setUnvalidatedRecoilValue$2,
  subscribeToRecoilValue: subscribeToRecoilValue$1
} = Recoil_RecoilValueInterface;



const {
  useCallback: useCallback$1,
  useEffect: useEffect$3,
  useMemo: useMemo$1,
  useRef: useRef$4,
  useState: useState$1
} = react__WEBPACK_IMPORTED_MODULE_0__;

const {
  setByAddingToSet: setByAddingToSet$2
} = Recoil_CopyOnWrite;



const {
  isSSR: isSSR$3
} = Recoil_Environment;













function handleLoadable(loadable, recoilValue, storeRef) {
  // We can't just throw the promise we are waiting on to Suspense.  If the
  // upstream dependencies change it may produce a state in which the component
  // can render, but it would still be suspended on a Promise that may never resolve.
  if (loadable.state === 'hasValue') {
    return loadable.contents;
  } else if (loadable.state === 'loading') {
    const promise = new Promise(resolve => {
      const suspendedComponentResolvers = storeRef.current.getState().suspendedComponentResolvers;
      suspendedComponentResolvers.add(resolve); // SSR should clear out the wake-up resolver if the Promise is resolved
      // to avoid infinite loops.  (See https://github.com/facebookexperimental/Recoil/pull/2073)

      if (isSSR$3 && Recoil_isPromise(loadable.contents)) {
        loadable.contents.finally(() => {
          suspendedComponentResolvers.delete(resolve);
        });
      }
    }); // $FlowExpectedError Flow(prop-missing) for integrating with tools that inspect thrown promises @fb-only
    // @fb-only: promise.displayName = `Recoil State: ${recoilValue.key}`;

    throw promise;
  } else if (loadable.state === 'hasError') {
    throw loadable.contents;
  } else {
    throw Recoil_err(`Invalid value of loadable atom "${recoilValue.key}"`);
  }
}

function validateRecoilValue(recoilValue, hookName // $FlowFixMe[missing-local-annot]
) {
  if (!isRecoilValue$2(recoilValue)) {
    throw Recoil_err(`Invalid argument to ${hookName}: expected an atom or selector but got ${String(recoilValue)}`);
  }
}

/**
 * Various things are broken with useRecoilInterface, particularly concurrent
 * mode, React strict mode, and memory management. They will not be fixed.
 * */
function useRecoilInterface_DEPRECATED() {
  const componentName = Recoil_useComponentName();
  const storeRef = useStoreRef$2(); // eslint-disable-next-line fb-www/react-no-unused-state-hook

  const [, forceUpdate] = useState$1([]);
  const recoilValuesUsed = useRef$4(new Set());
  recoilValuesUsed.current = new Set(); // Track the RecoilValues used just during this render

  const previousSubscriptions = useRef$4(new Set());
  const subscriptions = useRef$4(new Map());
  const unsubscribeFrom = useCallback$1(key => {
    const sub = subscriptions.current.get(key);

    if (sub) {
      sub.release();
      subscriptions.current.delete(key);
    }
  }, [subscriptions]);
  const updateState = useCallback$1((_state, key) => {
    if (subscriptions.current.has(key)) {
      forceUpdate([]);
    }
  }, []); // Effect to add/remove subscriptions as nodes are used

  useEffect$3(() => {
    const store = storeRef.current;
    Recoil_differenceSets(recoilValuesUsed.current, previousSubscriptions.current).forEach(key => {
      if (subscriptions.current.has(key)) {
        Recoil_expectationViolation(`Double subscription to RecoilValue "${key}"`);
        return;
      }

      const sub = subscribeToRecoilValue$1(store, new AbstractRecoilValue$3(key), state => updateState(state, key), componentName);
      subscriptions.current.set(key, sub);
      /**
       * Since we're subscribing in an effect we need to update to the latest
       * value of the atom since it may have changed since we rendered. We can
       * go ahead and do that now, unless we're in the middle of a batch --
       * in which case we should do it at the end of the batch, due to the
       * following edge case: Suppose an atom is updated in another useEffect
       * of this same component. Then the following sequence of events occur:
       * 1. Atom is updated and subs fired (but we may not be subscribed
       *    yet depending on order of effects, so we miss this) Updated value
       *    is now in nextTree, but not currentTree.
       * 2. This effect happens. We subscribe and update.
       * 3. From the update we re-render and read currentTree, with old value.
       * 4. Batcher's effect sets currentTree to nextTree.
       * In this sequence we miss the update. To avoid that, add the update
       * to queuedComponentCallback if a batch is in progress.
       */
      // FIXME delete queuedComponentCallbacks_DEPRECATED when deleting useInterface.

      const state = store.getState();

      if (state.nextTree) {
        store.getState().queuedComponentCallbacks_DEPRECATED.push(() => {
          updateState(store.getState(), key);
        });
      } else {
        updateState(store.getState(), key);
      }
    });
    Recoil_differenceSets(previousSubscriptions.current, recoilValuesUsed.current).forEach(key => {
      unsubscribeFrom(key);
    });
    previousSubscriptions.current = recoilValuesUsed.current;
  }); // Effect to unsubscribe from all when unmounting

  useEffect$3(() => {
    const currentSubscriptions = subscriptions.current; // Restore subscriptions that were cleared due to StrictMode running this effect twice

    Recoil_differenceSets(recoilValuesUsed.current, new Set(currentSubscriptions.keys())).forEach(key => {
      const sub = subscribeToRecoilValue$1(storeRef.current, new AbstractRecoilValue$3(key), state => updateState(state, key), componentName);
      currentSubscriptions.set(key, sub);
    });
    return () => currentSubscriptions.forEach((_, key) => unsubscribeFrom(key));
  }, [componentName, storeRef, unsubscribeFrom, updateState]);
  return useMemo$1(() => {
    // eslint-disable-next-line no-shadow
    function useSetRecoilState(recoilState) {
      if (false) {}

      return newValueOrUpdater => {
        setRecoilValue$2(storeRef.current, recoilState, newValueOrUpdater);
      };
    } // eslint-disable-next-line no-shadow


    function useResetRecoilState(recoilState) {
      if (false) {}

      return () => setRecoilValue$2(storeRef.current, recoilState, DEFAULT_VALUE$2);
    } // eslint-disable-next-line no-shadow


    function useRecoilValueLoadable(recoilValue) {
      var _storeState$nextTree;

      if (false) {}

      if (!recoilValuesUsed.current.has(recoilValue.key)) {
        recoilValuesUsed.current = setByAddingToSet$2(recoilValuesUsed.current, recoilValue.key);
      } // TODO Restore optimization to memoize lookup


      const storeState = storeRef.current.getState();
      return getRecoilValueAsLoadable$2(storeRef.current, recoilValue, reactMode$3().early ? (_storeState$nextTree = storeState.nextTree) !== null && _storeState$nextTree !== void 0 ? _storeState$nextTree : storeState.currentTree : storeState.currentTree);
    } // eslint-disable-next-line no-shadow


    function useRecoilValue(recoilValue) {
      if (false) {}

      const loadable = useRecoilValueLoadable(recoilValue);
      return handleLoadable(loadable, recoilValue, storeRef);
    } // eslint-disable-next-line no-shadow


    function useRecoilState(recoilState) {
      if (false) {}

      return [useRecoilValue(recoilState), useSetRecoilState(recoilState)];
    } // eslint-disable-next-line no-shadow


    function useRecoilStateLoadable(recoilState) {
      if (false) {}

      return [useRecoilValueLoadable(recoilState), useSetRecoilState(recoilState)];
    }

    return {
      getRecoilValue: useRecoilValue,
      getRecoilValueLoadable: useRecoilValueLoadable,
      getRecoilState: useRecoilState,
      getRecoilStateLoadable: useRecoilStateLoadable,
      getSetRecoilState: useSetRecoilState,
      getResetRecoilState: useResetRecoilState
    };
  }, [recoilValuesUsed, storeRef]);
}

const recoilComponentGetRecoilValueCount_FOR_TESTING = {
  current: 0
};

function useRecoilValueLoadable_SYNC_EXTERNAL_STORE(recoilValue) {
  const storeRef = useStoreRef$2();
  const componentName = Recoil_useComponentName();
  const getSnapshot = useCallback$1(() => {
    var _storeState$nextTree2;

    if (false) {}

    const store = storeRef.current;
    const storeState = store.getState();
    const treeState = reactMode$3().early ? (_storeState$nextTree2 = storeState.nextTree) !== null && _storeState$nextTree2 !== void 0 ? _storeState$nextTree2 : storeState.currentTree : storeState.currentTree;
    const loadable = getRecoilValueAsLoadable$2(store, recoilValue, treeState);
    return {
      loadable,
      key: recoilValue.key
    };
  }, [storeRef, recoilValue]); // Memoize the state to avoid unnecessary rerenders

  const memoizePreviousSnapshot = useCallback$1(getState => {
    let prevState;
    return () => {
      var _prevState, _prevState2;

      const nextState = getState();

      if ((_prevState = prevState) !== null && _prevState !== void 0 && _prevState.loadable.is(nextState.loadable) && ((_prevState2 = prevState) === null || _prevState2 === void 0 ? void 0 : _prevState2.key) === nextState.key) {
        return prevState;
      }

      prevState = nextState;
      return nextState;
    };
  }, []);
  const getMemoizedSnapshot = useMemo$1(() => memoizePreviousSnapshot(getSnapshot), [getSnapshot, memoizePreviousSnapshot]);
  const subscribe = useCallback$1(notify => {
    const store = storeRef.current;
    const subscription = subscribeToRecoilValue$1(store, recoilValue, notify, componentName);
    return subscription.release;
  }, [storeRef, recoilValue, componentName]);
  return useSyncExternalStore$1(subscribe, getMemoizedSnapshot, // getSnapshot()
  getMemoizedSnapshot // getServerSnapshot() for SSR support
  ).loadable;
}

function useRecoilValueLoadable_MUTABLE_SOURCE(recoilValue) {
  const storeRef = useStoreRef$2();
  const getLoadable = useCallback$1(() => {
    var _storeState$nextTree3;

    const store = storeRef.current;
    const storeState = store.getState();
    const treeState = reactMode$3().early ? (_storeState$nextTree3 = storeState.nextTree) !== null && _storeState$nextTree3 !== void 0 ? _storeState$nextTree3 : storeState.currentTree : storeState.currentTree;
    return getRecoilValueAsLoadable$2(store, recoilValue, treeState);
  }, [storeRef, recoilValue]);
  const getLoadableWithTesting = useCallback$1(() => {
    if (false) {}

    return getLoadable();
  }, [getLoadable]);
  const componentName = Recoil_useComponentName();
  const subscribe = useCallback$1((_storeState, notify) => {
    const store = storeRef.current;
    const subscription = subscribeToRecoilValue$1(store, recoilValue, () => {
      if (!Recoil_gkx('recoil_suppress_rerender_in_callback')) {
        return notify();
      } // Only re-render if the value has changed.
      // This will evaluate the atom/selector now as well as when the
      // component renders, but that may help with prefetching.


      const newLoadable = getLoadable();

      if (!prevLoadableRef.current.is(newLoadable)) {
        notify();
      } // If the component is suspended then the effect setting prevLoadableRef
      // will not run.  So, set the previous value here when its subscription
      // is fired to wake it up.  We can't just rely on this, though, because
      // this only executes when an atom/selector is dirty and the atom/selector
      // passed to the hook can dynamically change.


      prevLoadableRef.current = newLoadable;
    }, componentName);
    return subscription.release;
  }, [storeRef, recoilValue, componentName, getLoadable]);
  const source = useRecoilMutableSource$1();

  if (source == null) {
    throw Recoil_err('Recoil hooks must be used in components contained within a <RecoilRoot> component.');
  }

  const loadable = useMutableSource$1(source, getLoadableWithTesting, subscribe);
  const prevLoadableRef = useRef$4(loadable);
  useEffect$3(() => {
    prevLoadableRef.current = loadable;
  });
  return loadable;
}

function useRecoilValueLoadable_TRANSITION_SUPPORT(recoilValue) {
  const storeRef = useStoreRef$2();
  const componentName = Recoil_useComponentName(); // Accessors to get the current state

  const getLoadable = useCallback$1(() => {
    var _storeState$nextTree4;

    if (false) {}

    const store = storeRef.current;
    const storeState = store.getState();
    const treeState = reactMode$3().early ? (_storeState$nextTree4 = storeState.nextTree) !== null && _storeState$nextTree4 !== void 0 ? _storeState$nextTree4 : storeState.currentTree : storeState.currentTree;
    return getRecoilValueAsLoadable$2(store, recoilValue, treeState);
  }, [storeRef, recoilValue]);
  const getState = useCallback$1(() => ({
    loadable: getLoadable(),
    key: recoilValue.key
  }), [getLoadable, recoilValue.key]); // Memoize state snapshots

  const updateState = useCallback$1(prevState => {
    const nextState = getState();
    return prevState.loadable.is(nextState.loadable) && prevState.key === nextState.key ? prevState : nextState;
  }, [getState]); // Subscribe to Recoil state changes

  useEffect$3(() => {
    const subscription = subscribeToRecoilValue$1(storeRef.current, recoilValue, _state => {
      setState(updateState);
    }, componentName); // Update state in case we are using a different key

    setState(updateState);
    return subscription.release;
  }, [componentName, recoilValue, storeRef, updateState]); // Get the current state

  const [state, setState] = useState$1(getState); // If we changed keys, then return the state for the new key.
  // This is important in case the old key would cause the component to suspend.
  // We don't have to set the new state here since the subscribing effect above
  // will do that.

  return state.key !== recoilValue.key ? getState().loadable : state.loadable;
}

function useRecoilValueLoadable_LEGACY(recoilValue) {
  const storeRef = useStoreRef$2(); // eslint-disable-next-line fb-www/react-no-unused-state-hook

  const [, forceUpdate] = useState$1([]);
  const componentName = Recoil_useComponentName();
  const getLoadable = useCallback$1(() => {
    var _storeState$nextTree5;

    if (false) {}

    const store = storeRef.current;
    const storeState = store.getState();
    const treeState = reactMode$3().early ? (_storeState$nextTree5 = storeState.nextTree) !== null && _storeState$nextTree5 !== void 0 ? _storeState$nextTree5 : storeState.currentTree : storeState.currentTree;
    return getRecoilValueAsLoadable$2(store, recoilValue, treeState);
  }, [storeRef, recoilValue]);
  const loadable = getLoadable();
  const prevLoadableRef = useRef$4(loadable);
  useEffect$3(() => {
    prevLoadableRef.current = loadable;
  });
  useEffect$3(() => {
    const store = storeRef.current;
    const storeState = store.getState();
    const subscription = subscribeToRecoilValue$1(store, recoilValue, _state => {
      var _prevLoadableRef$curr;

      if (!Recoil_gkx('recoil_suppress_rerender_in_callback')) {
        return forceUpdate([]);
      }

      const newLoadable = getLoadable();

      if (!((_prevLoadableRef$curr = prevLoadableRef.current) !== null && _prevLoadableRef$curr !== void 0 && _prevLoadableRef$curr.is(newLoadable))) {
        // $FlowFixMe[incompatible-call]
        forceUpdate(newLoadable);
      }

      prevLoadableRef.current = newLoadable;
    }, componentName);
    /**
     * Since we're subscribing in an effect we need to update to the latest
     * value of the atom since it may have changed since we rendered. We can
     * go ahead and do that now, unless we're in the middle of a batch --
     * in which case we should do it at the end of the batch, due to the
     * following edge case: Suppose an atom is updated in another useEffect
     * of this same component. Then the following sequence of events occur:
     * 1. Atom is updated and subs fired (but we may not be subscribed
     *    yet depending on order of effects, so we miss this) Updated value
     *    is now in nextTree, but not currentTree.
     * 2. This effect happens. We subscribe and update.
     * 3. From the update we re-render and read currentTree, with old value.
     * 4. Batcher's effect sets currentTree to nextTree.
     * In this sequence we miss the update. To avoid that, add the update
     * to queuedComponentCallback if a batch is in progress.
     */

    if (storeState.nextTree) {
      store.getState().queuedComponentCallbacks_DEPRECATED.push(() => {
        // $FlowFixMe[incompatible-type]
        prevLoadableRef.current = null;
        forceUpdate([]);
      });
    } else {
      var _prevLoadableRef$curr2;

      if (!Recoil_gkx('recoil_suppress_rerender_in_callback')) {
        return forceUpdate([]);
      }

      const newLoadable = getLoadable();

      if (!((_prevLoadableRef$curr2 = prevLoadableRef.current) !== null && _prevLoadableRef$curr2 !== void 0 && _prevLoadableRef$curr2.is(newLoadable))) {
        // $FlowFixMe[incompatible-call]
        forceUpdate(newLoadable);
      }

      prevLoadableRef.current = newLoadable;
    }

    return subscription.release;
  }, [componentName, getLoadable, recoilValue, storeRef]);
  return loadable;
}
/**
  Like useRecoilValue(), but either returns the value if available or
  just undefined if not available for any reason, such as pending or error.
*/


function useRecoilValueLoadable(recoilValue) {
  if (false) {}

  if (Recoil_gkx('recoil_memory_managament_2020')) {
    // eslint-disable-next-line fb-www/react-hooks
    Recoil_useRetain(recoilValue);
  }

  return {
    TRANSITION_SUPPORT: useRecoilValueLoadable_TRANSITION_SUPPORT,
    // Recoil will attemp to detect if `useSyncExternalStore()` is supported with
    // `reactMode()` before calling it.  However, sometimes the host React
    // environment supports it but uses additional React renderers (such as with
    // `react-three-fiber`) which do not.  While this is technically a user issue
    // by using a renderer with React 18+ that doesn't fully support React 18 we
    // don't want to break users if it can be avoided. As the current renderer can
    // change at runtime, we need to dynamically check and fallback if necessary.
    SYNC_EXTERNAL_STORE: currentRendererSupportsUseSyncExternalStore$1() ? useRecoilValueLoadable_SYNC_EXTERNAL_STORE : useRecoilValueLoadable_TRANSITION_SUPPORT,
    MUTABLE_SOURCE: useRecoilValueLoadable_MUTABLE_SOURCE,
    LEGACY: useRecoilValueLoadable_LEGACY
  }[reactMode$3().mode](recoilValue);
}
/**
  Returns the value represented by the RecoilValue.
  If the value is pending, it will throw a Promise to suspend the component,
  if the value is an error it will throw it for the nearest React error boundary.
  This will also subscribe the component for any updates in the value.
  */


function useRecoilValue(recoilValue) {
  if (false) {}

  const storeRef = useStoreRef$2();
  const loadable = useRecoilValueLoadable(recoilValue);
  return handleLoadable(loadable, recoilValue, storeRef);
}
/**
  Returns a function that allows the value of a RecoilState to be updated, but does
  not subscribe the component to changes to that RecoilState.
*/


function useSetRecoilState(recoilState) {
  if (false) {}

  const storeRef = useStoreRef$2();
  return useCallback$1(newValueOrUpdater => {
    setRecoilValue$2(storeRef.current, recoilState, newValueOrUpdater);
  }, [storeRef, recoilState]);
}
/**
  Returns a function that will reset the value of a RecoilState to its default
*/


function useResetRecoilState(recoilState) {
  if (false) {}

  const storeRef = useStoreRef$2();
  return useCallback$1(() => {
    setRecoilValue$2(storeRef.current, recoilState, DEFAULT_VALUE$2);
  }, [storeRef, recoilState]);
}
/**
  Equivalent to useState(). Allows the value of the RecoilState to be read and written.
  Subsequent updates to the RecoilState will cause the component to re-render. If the
  RecoilState is pending, this will suspend the component and initiate the
  retrieval of the value. If evaluating the RecoilState resulted in an error, this will
  throw the error so that the nearest React error boundary can catch it.
*/


function useRecoilState(recoilState) {
  if (false) {}

  return [useRecoilValue(recoilState), useSetRecoilState(recoilState)];
}
/**
  Like useRecoilState(), but does not cause Suspense or React error handling. Returns
  an object that indicates whether the RecoilState is available, pending, or
  unavailable due to an error.
*/


function useRecoilStateLoadable(recoilState) {
  if (false) {}

  return [useRecoilValueLoadable(recoilState), useSetRecoilState(recoilState)];
}

function useSetUnvalidatedAtomValues() {
  const storeRef = useStoreRef$2();
  return (values, transactionMetadata = {}) => {
    batchUpdates$2(() => {
      storeRef.current.addTransactionMetadata(transactionMetadata);
      values.forEach((value, key) => setUnvalidatedRecoilValue$2(storeRef.current, new AbstractRecoilValue$3(key), value));
    });
  };
}
/**
 * Experimental variants of hooks with support for useTransition()
 */


function useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE(recoilValue) {
  if (false) {}

  if (Recoil_gkx('recoil_memory_managament_2020')) {
    // eslint-disable-next-line fb-www/react-hooks
    Recoil_useRetain(recoilValue);
  }

  return useRecoilValueLoadable_TRANSITION_SUPPORT(recoilValue);
}

function useRecoilValue_TRANSITION_SUPPORT_UNSTABLE(recoilValue) {
  if (false) {}

  const storeRef = useStoreRef$2();
  const loadable = useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE(recoilValue);
  return handleLoadable(loadable, recoilValue, storeRef);
}

function useRecoilState_TRANSITION_SUPPORT_UNSTABLE(recoilState) {
  if (false) {}

  return [useRecoilValue_TRANSITION_SUPPORT_UNSTABLE(recoilState), useSetRecoilState(recoilState)];
}

var Recoil_Hooks = {
  recoilComponentGetRecoilValueCount_FOR_TESTING,
  useRecoilInterface: useRecoilInterface_DEPRECATED,
  useRecoilState,
  useRecoilStateLoadable,
  useRecoilValue,
  useRecoilValueLoadable,
  useResetRecoilState,
  useSetRecoilState,
  useSetUnvalidatedAtomValues,
  useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE,
  useRecoilValue_TRANSITION_SUPPORT_UNSTABLE,
  useRecoilState_TRANSITION_SUPPORT_UNSTABLE
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/**
 * Returns a map containing all of the keys + values from the original map where
 * the given callback returned true.
 */

function filterMap(map, callback) {
  const result = new Map();

  for (const [key, value] of map) {
    if (callback(value, key)) {
      result.set(key, value);
    }
  }

  return result;
}

var Recoil_filterMap = filterMap;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/**
 * Returns a set containing all of the values from the original set where
 * the given callback returned true.
 */

function filterSet(set, callback) {
  const result = new Set();

  for (const value of set) {
    if (callback(value)) {
      result.add(value);
    }
  }

  return result;
}

var Recoil_filterSet = filterSet;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

function mergeMaps(...maps) {
  const result = new Map();

  for (let i = 0; i < maps.length; i++) {
    const iterator = maps[i].keys();
    let nextKey;

    while (!(nextKey = iterator.next()).done) {
      // $FlowIssue[incompatible-call] - map/iterator knows nothing about flow types
      result.set(nextKey.value, maps[i].get(nextKey.value));
    }
  }

  return result;
}

var Recoil_mergeMaps = mergeMaps;

const {
  batchUpdates: batchUpdates$3
} = Recoil_Batching;

const {
  DEFAULT_VALUE: DEFAULT_VALUE$3,
  getNode: getNode$4,
  nodes: nodes$1
} = Recoil_Node;

const {
  useStoreRef: useStoreRef$3
} = Recoil_RecoilRoot;

const {
  AbstractRecoilValue: AbstractRecoilValue$4,
  setRecoilValueLoadable: setRecoilValueLoadable$1
} = Recoil_RecoilValueInterface;

const {
  SUSPENSE_TIMEOUT_MS: SUSPENSE_TIMEOUT_MS$2
} = Recoil_Retention;

const {
  cloneSnapshot: cloneSnapshot$1
} = Recoil_Snapshot$1;

const {
  useCallback: useCallback$2,
  useEffect: useEffect$4,
  useRef: useRef$5,
  useState: useState$2
} = react__WEBPACK_IMPORTED_MODULE_0__;

const {
  isSSR: isSSR$4
} = Recoil_Environment;















function useTransactionSubscription(callback) {
  const storeRef = useStoreRef$3();
  useEffect$4(() => {
    const sub = storeRef.current.subscribeToTransactions(callback);
    return sub.release;
  }, [callback, storeRef]);
}

function externallyVisibleAtomValuesInState(state) {
  const atomValues = state.atomValues.toMap();
  const persistedAtomContentsValues = Recoil_mapMap(Recoil_filterMap(atomValues, (v, k) => {
    const node = getNode$4(k);
    const persistence = node.persistence_UNSTABLE;
    return persistence != null && persistence.type !== 'none' && v.state === 'hasValue';
  }), v => v.contents); // Merge in nonvalidated atoms; we may not have defs for them but they will
  // all have persistence on or they wouldn't be there in the first place.

  return Recoil_mergeMaps(state.nonvalidatedAtoms.toMap(), persistedAtomContentsValues);
}

/**
  Calls the given callback after any atoms have been modified and the consequent
  component re-renders have been committed. This is intended for persisting
  the values of the atoms to storage. The stored values can then be restored
  using the useSetUnvalidatedAtomValues hook.

  The callback receives the following info:

  atomValues: The current value of every atom that is both persistable (persistence
              type not set to 'none') and whose value is available (not in an
              error or loading state).

  previousAtomValues: The value of every persistable and available atom before
               the transaction began.

  atomInfo: A map containing the persistence settings for each atom. Every key
            that exists in atomValues will also exist in atomInfo.

  modifiedAtoms: The set of atoms that were written to during the transaction.

  transactionMetadata: Arbitrary information that was added via the
          useSetUnvalidatedAtomValues hook. Useful for ignoring the useSetUnvalidatedAtomValues
          transaction, to avoid loops.
*/
function useTransactionObservation_DEPRECATED(callback) {
  useTransactionSubscription(useCallback$2(store => {
    let previousTree = store.getState().previousTree;
    const currentTree = store.getState().currentTree;

    if (!previousTree) {
      Recoil_recoverableViolation('Transaction subscribers notified without a previous tree being present -- this is a bug in Recoil');
      previousTree = store.getState().currentTree; // attempt to trundle on
    }

    const atomValues = externallyVisibleAtomValuesInState(currentTree);
    const previousAtomValues = externallyVisibleAtomValuesInState(previousTree);
    const atomInfo = Recoil_mapMap(nodes$1, node => {
      var _node$persistence_UNS, _node$persistence_UNS2, _node$persistence_UNS3, _node$persistence_UNS4;

      return {
        persistence_UNSTABLE: {
          type: (_node$persistence_UNS = (_node$persistence_UNS2 = node.persistence_UNSTABLE) === null || _node$persistence_UNS2 === void 0 ? void 0 : _node$persistence_UNS2.type) !== null && _node$persistence_UNS !== void 0 ? _node$persistence_UNS : 'none',
          backButton: (_node$persistence_UNS3 = (_node$persistence_UNS4 = node.persistence_UNSTABLE) === null || _node$persistence_UNS4 === void 0 ? void 0 : _node$persistence_UNS4.backButton) !== null && _node$persistence_UNS3 !== void 0 ? _node$persistence_UNS3 : false
        }
      };
    }); // Filter on existance in atomValues so that externally-visible rules
    // are also applied to modified atoms (specifically exclude selectors):

    const modifiedAtoms = Recoil_filterSet(currentTree.dirtyAtoms, k => atomValues.has(k) || previousAtomValues.has(k));
    callback({
      atomValues,
      previousAtomValues,
      atomInfo,
      modifiedAtoms,
      transactionMetadata: { ...currentTree.transactionMetadata
      }
    });
  }, [callback]));
}

function useRecoilTransactionObserver(callback) {
  useTransactionSubscription(useCallback$2(store => {
    const snapshot = cloneSnapshot$1(store, 'latest');
    const previousSnapshot = cloneSnapshot$1(store, 'previous');
    callback({
      snapshot,
      previousSnapshot
    });
  }, [callback]));
} // Return a snapshot of the current state and subscribe to all state changes


function useRecoilSnapshot() {
  const storeRef = useStoreRef$3();
  const [snapshot, setSnapshot] = useState$2(() => cloneSnapshot$1(storeRef.current));
  const previousSnapshot = Recoil_usePrevious(snapshot);
  const timeoutID = useRef$5();
  const releaseRef = useRef$5();
  useTransactionSubscription(useCallback$2(store => setSnapshot(cloneSnapshot$1(store)), [])); // Retain snapshot for duration component is mounted

  useEffect$4(() => {
    const release = snapshot.retain(); // Release the retain from the rendering call

    if (timeoutID.current && !isSSR$4) {
      var _releaseRef$current;

      window.clearTimeout(timeoutID.current);
      timeoutID.current = null;
      (_releaseRef$current = releaseRef.current) === null || _releaseRef$current === void 0 ? void 0 : _releaseRef$current.call(releaseRef);
      releaseRef.current = null;
    }

    return () => {
      // Defer the release.  If "Fast Refresh"" is used then the component may
      // re-render with the same state.  The previous cleanup will then run and
      // then the new effect will run. We don't want the snapshot to be released
      // by that cleanup before the new effect has a chance to retain it again.
      // Use timeout of 10 to workaround Firefox issue: https://github.com/facebookexperimental/Recoil/issues/1936
      window.setTimeout(release, 10);
    };
  }, [snapshot]); // Retain snapshot until above effect is run.
  // Release after a threshold in case component is suspended.

  if (previousSnapshot !== snapshot && !isSSR$4) {
    // Release the previous snapshot
    if (timeoutID.current) {
      var _releaseRef$current2;

      window.clearTimeout(timeoutID.current);
      timeoutID.current = null;
      (_releaseRef$current2 = releaseRef.current) === null || _releaseRef$current2 === void 0 ? void 0 : _releaseRef$current2.call(releaseRef);
      releaseRef.current = null;
    }

    releaseRef.current = snapshot.retain();
    timeoutID.current = window.setTimeout(() => {
      var _releaseRef$current3;

      timeoutID.current = null;
      (_releaseRef$current3 = releaseRef.current) === null || _releaseRef$current3 === void 0 ? void 0 : _releaseRef$current3.call(releaseRef);
      releaseRef.current = null;
    }, SUSPENSE_TIMEOUT_MS$2);
  }

  return snapshot;
}

function gotoSnapshot(store, snapshot) {
  var _storeState$nextTree;

  const storeState = store.getState();
  const prev = (_storeState$nextTree = storeState.nextTree) !== null && _storeState$nextTree !== void 0 ? _storeState$nextTree : storeState.currentTree;
  const next = snapshot.getStore_INTERNAL().getState().currentTree;
  batchUpdates$3(() => {
    const keysToUpdate = new Set();

    for (const keys of [prev.atomValues.keys(), next.atomValues.keys()]) {
      for (const key of keys) {
        var _prev$atomValues$get, _next$atomValues$get;

        if (((_prev$atomValues$get = prev.atomValues.get(key)) === null || _prev$atomValues$get === void 0 ? void 0 : _prev$atomValues$get.contents) !== ((_next$atomValues$get = next.atomValues.get(key)) === null || _next$atomValues$get === void 0 ? void 0 : _next$atomValues$get.contents) && getNode$4(key).shouldRestoreFromSnapshots) {
          keysToUpdate.add(key);
        }
      }
    }

    keysToUpdate.forEach(key => {
      setRecoilValueLoadable$1(store, new AbstractRecoilValue$4(key), next.atomValues.has(key) ? Recoil_nullthrows(next.atomValues.get(key)) : DEFAULT_VALUE$3);
    });
    store.replaceState(state => ({ ...state,
      stateID: snapshot.getID()
    }));
  });
}

function useGotoRecoilSnapshot() {
  const storeRef = useStoreRef$3();
  return useCallback$2(snapshot => gotoSnapshot(storeRef.current, snapshot), [storeRef]);
}

var Recoil_SnapshotHooks = {
  useRecoilSnapshot,
  gotoSnapshot,
  useGotoRecoilSnapshot,
  useRecoilTransactionObserver,
  useTransactionObservation_DEPRECATED,
  useTransactionSubscription_DEPRECATED: useTransactionSubscription
};

const {
  peekNodeInfo: peekNodeInfo$2
} = Recoil_FunctionalCore;

const {
  useStoreRef: useStoreRef$4
} = Recoil_RecoilRoot;

function useGetRecoilValueInfo() {
  const storeRef = useStoreRef$4(); // $FlowFixMe[incompatible-return]

  return ({
    key
  }) => peekNodeInfo$2(storeRef.current, storeRef.current.getState().currentTree, key);
}

var Recoil_useGetRecoilValueInfo = useGetRecoilValueInfo;

const {
  reactMode: reactMode$4
} = Recoil_ReactMode;

const {
  RecoilRoot: RecoilRoot$1,
  useStoreRef: useStoreRef$5
} = Recoil_RecoilRoot;



const {
  useMemo: useMemo$2
} = react__WEBPACK_IMPORTED_MODULE_0__;

function useRecoilBridgeAcrossReactRoots() {
  // The test fails when using useMutableSource(), but only if act() is used
  // for the nested root.  So, this may only be a testing environment issue.
  if (reactMode$4().mode === 'MUTABLE_SOURCE') {
    // eslint-disable-next-line fb-www/no-console
    console.warn('Warning: There are known issues using useRecoilBridgeAcrossReactRoots() in recoil_mutable_source rendering mode.  Please consider upgrading to recoil_sync_external_store mode.');
  }

  const store = useStoreRef$5().current;
  return useMemo$2(() => {
    // eslint-disable-next-line no-shadow
    function RecoilBridge({
      children
    }) {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(RecoilRoot$1, {
        store_INTERNAL: store
      }, children);
    }

    return RecoilBridge;
  }, [store]);
}

var Recoil_useRecoilBridgeAcrossReactRoots = useRecoilBridgeAcrossReactRoots;

const {
  loadableWithValue: loadableWithValue$1
} = Recoil_Loadable$1;

const {
  initializeNode: initializeNode$3
} = Recoil_FunctionalCore;

const {
  DEFAULT_VALUE: DEFAULT_VALUE$4,
  getNode: getNode$5
} = Recoil_Node;

const {
  copyTreeState: copyTreeState$1,
  getRecoilValueAsLoadable: getRecoilValueAsLoadable$3,
  invalidateDownstreams: invalidateDownstreams$1,
  writeLoadableToTreeState: writeLoadableToTreeState$1
} = Recoil_RecoilValueInterface;



function isAtom(recoilValue) {
  return getNode$5(recoilValue.key).nodeType === 'atom';
}

class TransactionInterfaceImpl {
  constructor(store, treeState) {
    _defineProperty(this, "_store", void 0);

    _defineProperty(this, "_treeState", void 0);

    _defineProperty(this, "_changes", void 0);

    _defineProperty(this, "get", recoilValue => {
      if (this._changes.has(recoilValue.key)) {
        // $FlowIssue[incompatible-return]
        return this._changes.get(recoilValue.key);
      }

      if (!isAtom(recoilValue)) {
        throw Recoil_err('Reading selectors within atomicUpdate is not supported');
      }

      const loadable = getRecoilValueAsLoadable$3(this._store, recoilValue, this._treeState);

      if (loadable.state === 'hasValue') {
        return loadable.contents;
      } else if (loadable.state === 'hasError') {
        throw loadable.contents;
      } else {
        throw Recoil_err(`Expected Recoil atom ${recoilValue.key} to have a value, but it is in a loading state.`);
      }
    });

    _defineProperty(this, "set", (recoilState, valueOrUpdater) => {
      if (!isAtom(recoilState)) {
        throw Recoil_err('Setting selectors within atomicUpdate is not supported');
      }

      if (typeof valueOrUpdater === 'function') {
        const current = this.get(recoilState);

        this._changes.set(recoilState.key, valueOrUpdater(current)); // flowlint-line unclear-type:off

      } else {
        // Initialize atom and run effects if not initialized yet
        initializeNode$3(this._store, recoilState.key, 'set');

        this._changes.set(recoilState.key, valueOrUpdater);
      }
    });

    _defineProperty(this, "reset", recoilState => {
      this.set(recoilState, DEFAULT_VALUE$4);
    });

    this._store = store;
    this._treeState = treeState;
    this._changes = new Map();
  } // Allow destructing
  // eslint-disable-next-line fb-www/extra-arrow-initializer


  newTreeState_INTERNAL() {
    if (this._changes.size === 0) {
      return this._treeState;
    }

    const newState = copyTreeState$1(this._treeState);

    for (const [k, v] of this._changes) {
      writeLoadableToTreeState$1(newState, k, loadableWithValue$1(v));
    }

    invalidateDownstreams$1(this._store, newState);
    return newState;
  }

}

function atomicUpdater(store) {
  return fn => {
    store.replaceState(treeState => {
      const changeset = new TransactionInterfaceImpl(store, treeState);
      fn(changeset);
      return changeset.newTreeState_INTERNAL();
    });
  };
}

var Recoil_AtomicUpdates = {
  atomicUpdater
};

var Recoil_AtomicUpdates_1 = Recoil_AtomicUpdates.atomicUpdater;

var Recoil_AtomicUpdates$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  atomicUpdater: Recoil_AtomicUpdates_1
});

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

function invariant(condition, message) {
  if (!condition) {
    throw new Error(message);
  }
}

var invariant_1 = invariant;

// @oss-only


var Recoil_invariant = invariant_1;

const {
  atomicUpdater: atomicUpdater$1
} = Recoil_AtomicUpdates$1;

const {
  batchUpdates: batchUpdates$4
} = Recoil_Batching;

const {
  DEFAULT_VALUE: DEFAULT_VALUE$5
} = Recoil_Node;

const {
  useStoreRef: useStoreRef$6
} = Recoil_RecoilRoot;

const {
  refreshRecoilValue: refreshRecoilValue$1,
  setRecoilValue: setRecoilValue$3
} = Recoil_RecoilValueInterface;

const {
  cloneSnapshot: cloneSnapshot$2
} = Recoil_Snapshot$1;

const {
  gotoSnapshot: gotoSnapshot$1
} = Recoil_SnapshotHooks;

const {
  useCallback: useCallback$3
} = react__WEBPACK_IMPORTED_MODULE_0__;









class Sentinel {}

const SENTINEL = new Sentinel();

function recoilCallback(store, fn, args, extraInterface) {
  let ret = SENTINEL;
  let releaseSnapshot;
  batchUpdates$4(() => {
    const errMsg = 'useRecoilCallback() expects a function that returns a function: ' + 'it accepts a function of the type (RecoilInterface) => (Args) => ReturnType ' + 'and returns a callback function (Args) => ReturnType, where RecoilInterface is ' + 'an object {snapshot, set, ...} and Args and ReturnType are the argument and return ' + 'types of the callback you want to create.  Please see the docs ' + 'at recoiljs.org for details.';

    if (typeof fn !== 'function') {
      throw Recoil_err(errMsg);
    } // Clone the snapshot lazily to avoid overhead if the callback does not use it.
    // Note that this means the snapshot may represent later state from when
    // the callback was called if it first accesses the snapshot asynchronously.


    const callbackInterface = Recoil_lazyProxy({ ...(extraInterface !== null && extraInterface !== void 0 ? extraInterface : {}),
      // flowlint-line unclear-type:off
      // $FlowFixMe[missing-local-annot]
      set: (node, newValue) => setRecoilValue$3(store, node, newValue),
      // $FlowFixMe[missing-local-annot]
      reset: node => setRecoilValue$3(store, node, DEFAULT_VALUE$5),
      // $FlowFixMe[missing-local-annot]
      refresh: node => refreshRecoilValue$1(store, node),
      gotoSnapshot: snapshot => gotoSnapshot$1(store, snapshot),
      transact_UNSTABLE: transaction => atomicUpdater$1(store)(transaction)
    }, {
      snapshot: () => {
        const snapshot = cloneSnapshot$2(store);
        releaseSnapshot = snapshot.retain();
        return snapshot;
      }
    });
    const callback = fn(callbackInterface);

    if (typeof callback !== 'function') {
      throw Recoil_err(errMsg);
    }

    ret = callback(...args);
  });
  !!(ret instanceof Sentinel) ?  false ? 0 : Recoil_invariant(false) : void 0;

  if (Recoil_isPromise(ret)) {
    ret = ret.finally(() => {
      var _releaseSnapshot;

      (_releaseSnapshot = releaseSnapshot) === null || _releaseSnapshot === void 0 ? void 0 : _releaseSnapshot();
    });
  } else {
    var _releaseSnapshot2;

    (_releaseSnapshot2 = releaseSnapshot) === null || _releaseSnapshot2 === void 0 ? void 0 : _releaseSnapshot2();
  }

  return ret;
}

function useRecoilCallback(fn, deps) {
  const storeRef = useStoreRef$6();
  return useCallback$3( // $FlowIssue[incompatible-call]
  (...args) => {
    return recoilCallback(storeRef.current, fn, args);
  }, deps != null ? [...deps, storeRef] : undefined // eslint-disable-line fb-www/react-hooks-deps
  );
}

var Recoil_useRecoilCallback = {
  recoilCallback,
  useRecoilCallback
};

const {
  useStoreRef: useStoreRef$7
} = Recoil_RecoilRoot;

const {
  refreshRecoilValue: refreshRecoilValue$2
} = Recoil_RecoilValueInterface;

const {
  useCallback: useCallback$4
} = react__WEBPACK_IMPORTED_MODULE_0__;

function useRecoilRefresher(recoilValue) {
  const storeRef = useStoreRef$7();
  return useCallback$4(() => {
    const store = storeRef.current;
    refreshRecoilValue$2(store, recoilValue);
  }, [recoilValue, storeRef]);
}

var Recoil_useRecoilRefresher = useRecoilRefresher;

const {
  atomicUpdater: atomicUpdater$2
} = Recoil_AtomicUpdates$1;

const {
  useStoreRef: useStoreRef$8
} = Recoil_RecoilRoot;

const {
  useMemo: useMemo$3
} = react__WEBPACK_IMPORTED_MODULE_0__;

function useRecoilTransaction(fn, deps) {
  const storeRef = useStoreRef$8();
  return useMemo$3(() => (...args) => {
    const atomicUpdate = atomicUpdater$2(storeRef.current);
    atomicUpdate(transactionInterface => {
      fn(transactionInterface)(...args);
    });
  }, deps != null ? [...deps, storeRef] : undefined // eslint-disable-line fb-www/react-hooks-deps
  );
}

var Recoil_useRecoilTransaction = useRecoilTransaction;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

class WrappedValue {
  constructor(value) {
    _defineProperty(this, "value", void 0);

    this.value = value;
  }

}

var Recoil_Wrapper = {
  WrappedValue
};

var Recoil_Wrapper_1 = Recoil_Wrapper.WrappedValue;

var Recoil_Wrapper$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  WrappedValue: Recoil_Wrapper_1
});

const {
  isFastRefreshEnabled: isFastRefreshEnabled$2
} = Recoil_ReactMode;



class ChangedPathError extends Error {}

class TreeCache {
  // $FlowIssue[unclear-type]
  constructor(options) {
    var _options$onHit, _options$onSet, _options$mapNodeValue;

    _defineProperty(this, "_name", void 0);

    _defineProperty(this, "_numLeafs", void 0);

    _defineProperty(this, "_root", void 0);

    _defineProperty(this, "_onHit", void 0);

    _defineProperty(this, "_onSet", void 0);

    _defineProperty(this, "_mapNodeValue", void 0);

    this._name = options === null || options === void 0 ? void 0 : options.name;
    this._numLeafs = 0;
    this._root = null;
    this._onHit = (_options$onHit = options === null || options === void 0 ? void 0 : options.onHit) !== null && _options$onHit !== void 0 ? _options$onHit : () => {};
    this._onSet = (_options$onSet = options === null || options === void 0 ? void 0 : options.onSet) !== null && _options$onSet !== void 0 ? _options$onSet : () => {};
    this._mapNodeValue = (_options$mapNodeValue = options === null || options === void 0 ? void 0 : options.mapNodeValue) !== null && _options$mapNodeValue !== void 0 ? _options$mapNodeValue : val => val;
  }

  size() {
    return this._numLeafs;
  } // $FlowIssue[unclear-type]


  root() {
    return this._root;
  }

  get(getNodeValue, handlers) {
    var _this$getLeafNode;

    return (_this$getLeafNode = this.getLeafNode(getNodeValue, handlers)) === null || _this$getLeafNode === void 0 ? void 0 : _this$getLeafNode.value;
  }

  getLeafNode(getNodeValue, handlers) {
    if (this._root == null) {
      return undefined;
    } // Iterate down the tree based on the current node values until we hit a leaf
    // $FlowIssue[unclear-type]


    let node = this._root;

    while (node) {
      handlers === null || handlers === void 0 ? void 0 : handlers.onNodeVisit(node);

      if (node.type === 'leaf') {
        this._onHit(node);

        return node;
      }

      const nodeValue = this._mapNodeValue(getNodeValue(node.nodeKey));

      node = node.branches.get(nodeValue);
    }

    return undefined;
  }

  set(route, value, handlers) {
    const addLeaf = () => {
      var _node2, _node3, _this$_root2, _handlers$onNodeVisit2;

      // First, setup the branch nodes for the route:
      // Iterate down the tree to find or add branch nodes following the route
      let node;
      let branchKey;

      for (const [nodeKey, nodeValue] of route) {
        var _node, _handlers$onNodeVisit, _this$_root;

        // If the previous root was a leaf, while we not have a get(), it means
        // the selector has inconsistent values or implementation changed.
        const root = this._root;

        if ((root === null || root === void 0 ? void 0 : root.type) === 'leaf') {
          throw this.invalidCacheError();
        } // node now refers to the next node down in the tree


        const parent = node; // $FlowFixMe[prop-missing]
        // $FlowFixMe[incompatible-type]

        node = parent ? parent.branches.get(branchKey) : root; // $FlowFixMe[prop-missing]
        // $FlowFixMe[incompatible-type]

        node = (_node = node) !== null && _node !== void 0 ? _node : {
          type: 'branch',
          nodeKey,
          parent,
          branches: new Map(),
          branchKey
        }; // If we found an existing node, confirm it has a consistent value

        if (node.type !== 'branch' || node.nodeKey !== nodeKey) {
          throw this.invalidCacheError();
        } // Add the branch node to the tree


        parent === null || parent === void 0 ? void 0 : parent.branches.set(branchKey, node);
        handlers === null || handlers === void 0 ? void 0 : (_handlers$onNodeVisit = handlers.onNodeVisit) === null || _handlers$onNodeVisit === void 0 ? void 0 : _handlers$onNodeVisit.call(handlers, node); // Prepare for next iteration and install root if it is new.

        branchKey = this._mapNodeValue(nodeValue);
        this._root = (_this$_root = this._root) !== null && _this$_root !== void 0 ? _this$_root : node;
      } // Second, setup the leaf node:
      // If there is an existing leaf for this route confirm it is consistent


      const oldLeaf = node ? (_node2 = node) === null || _node2 === void 0 ? void 0 : _node2.branches.get(branchKey) : this._root;

      if (oldLeaf != null && (oldLeaf.type !== 'leaf' || oldLeaf.branchKey !== branchKey)) {
        throw this.invalidCacheError();
      } // Create a new or replacement leaf.


      const leafNode = {
        type: 'leaf',
        value,
        parent: node,
        branchKey
      }; // Install the leaf and call handlers

      (_node3 = node) === null || _node3 === void 0 ? void 0 : _node3.branches.set(branchKey, leafNode);
      this._root = (_this$_root2 = this._root) !== null && _this$_root2 !== void 0 ? _this$_root2 : leafNode;
      this._numLeafs++;

      this._onSet(leafNode);

      handlers === null || handlers === void 0 ? void 0 : (_handlers$onNodeVisit2 = handlers.onNodeVisit) === null || _handlers$onNodeVisit2 === void 0 ? void 0 : _handlers$onNodeVisit2.call(handlers, leafNode);
    };

    try {
      addLeaf();
    } catch (error) {
      // If the cache was stale or observed inconsistent values, such as with
      // Fast Refresh, then clear it and rebuild with the new values.
      if (error instanceof ChangedPathError) {
        this.clear();
        addLeaf();
      } else {
        throw error;
      }
    }
  } // Returns true if leaf was actually deleted from the tree


  delete(leaf) {
    const root = this.root();

    if (!root) {
      return false;
    }

    if (leaf === root) {
      this._root = null;
      this._numLeafs = 0;
      return true;
    } // Iterate up from the leaf deleteing it from it's parent's branches.


    let node = leaf.parent;
    let branchKey = leaf.branchKey;

    while (node) {
      var _node4;

      node.branches.delete(branchKey); // Stop iterating if we hit the root.

      if (node === root) {
        if (node.branches.size === 0) {
          this._root = null;
          this._numLeafs = 0;
        } else {
          this._numLeafs--;
        }

        return true;
      } // Stop iterating if there are other branches since we don't need to
      // remove any more nodes.


      if (node.branches.size > 0) {
        break;
      } // Iterate up to our parent


      branchKey = (_node4 = node) === null || _node4 === void 0 ? void 0 : _node4.branchKey;
      node = node.parent;
    } // Confirm that the leaf we are deleting is actually attached to our tree


    for (; node !== root; node = node.parent) {
      if (node == null) {
        return false;
      }
    }

    this._numLeafs--;
    return true;
  }

  clear() {
    this._numLeafs = 0;
    this._root = null;
  }

  invalidCacheError() {
    const CHANGED_PATH_ERROR_MESSAGE = isFastRefreshEnabled$2() ? 'Possible Fast Refresh module reload detected.  ' + 'This may also be caused by an selector returning inconsistent values. ' + 'Resetting cache.' : 'Invalid cache values.  This happens when selectors do not return ' + 'consistent values for the same input dependency values.  That may also ' + 'be caused when using Fast Refresh to change a selector implementation.  ' + 'Resetting cache.';
    Recoil_recoverableViolation(CHANGED_PATH_ERROR_MESSAGE + (this._name != null ? ` - ${this._name}` : ''));
    throw new ChangedPathError();
  }

}

var Recoil_TreeCache = {
  TreeCache
};

var Recoil_TreeCache_1 = Recoil_TreeCache.TreeCache;

var Recoil_TreeCache$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  TreeCache: Recoil_TreeCache_1
});

class LRUCache {
  constructor(options) {
    var _options$mapKey;

    _defineProperty(this, "_maxSize", void 0);

    _defineProperty(this, "_size", void 0);

    _defineProperty(this, "_head", void 0);

    _defineProperty(this, "_tail", void 0);

    _defineProperty(this, "_map", void 0);

    _defineProperty(this, "_keyMapper", void 0);

    this._maxSize = options.maxSize;
    this._size = 0;
    this._head = null;
    this._tail = null;
    this._map = new Map();
    this._keyMapper = (_options$mapKey = options.mapKey) !== null && _options$mapKey !== void 0 ? _options$mapKey : v => v;
  }

  head() {
    return this._head;
  }

  tail() {
    return this._tail;
  }

  size() {
    return this._size;
  }

  maxSize() {
    return this._maxSize;
  }

  has(key) {
    return this._map.has(this._keyMapper(key));
  }

  get(key) {
    const mappedKey = this._keyMapper(key);

    const node = this._map.get(mappedKey);

    if (!node) {
      return undefined;
    }

    this.set(key, node.value);
    return node.value;
  }

  set(key, val) {
    const mappedKey = this._keyMapper(key);

    const existingNode = this._map.get(mappedKey);

    if (existingNode) {
      this.delete(key);
    }

    const head = this.head();
    const node = {
      key,
      right: head,
      left: null,
      value: val
    };

    if (head) {
      head.left = node;
    } else {
      this._tail = node;
    }

    this._map.set(mappedKey, node);

    this._head = node;
    this._size++;

    this._maybeDeleteLRU();
  }

  _maybeDeleteLRU() {
    if (this.size() > this.maxSize()) {
      this.deleteLru();
    }
  }

  deleteLru() {
    const tail = this.tail();

    if (tail) {
      this.delete(tail.key);
    }
  }

  delete(key) {
    const mappedKey = this._keyMapper(key);

    if (!this._size || !this._map.has(mappedKey)) {
      return;
    }

    const node = Recoil_nullthrows(this._map.get(mappedKey));
    const right = node.right;
    const left = node.left;

    if (right) {
      right.left = node.left;
    }

    if (left) {
      left.right = node.right;
    }

    if (node === this.head()) {
      this._head = right;
    }

    if (node === this.tail()) {
      this._tail = left;
    }

    this._map.delete(mappedKey);

    this._size--;
  }

  clear() {
    this._size = 0;
    this._head = null;
    this._tail = null;
    this._map = new Map();
  }

}

var Recoil_LRUCache = {
  LRUCache
};

var Recoil_LRUCache_1 = Recoil_LRUCache.LRUCache;

var Recoil_LRUCache$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  LRUCache: Recoil_LRUCache_1
});

const {
  LRUCache: LRUCache$1
} = Recoil_LRUCache$1;

const {
  TreeCache: TreeCache$1
} = Recoil_TreeCache$1;

function treeCacheLRU({
  name,
  maxSize,
  mapNodeValue = v => v
}) {
  const lruCache = new LRUCache$1({
    maxSize
  });
  const cache = new TreeCache$1({
    name,
    mapNodeValue,
    onHit: node => {
      lruCache.set(node, true);
    },
    onSet: node => {
      const lruNode = lruCache.tail();
      lruCache.set(node, true);

      if (lruNode && cache.size() > maxSize) {
        // $FlowFixMe[incompatible-call]
        cache.delete(lruNode.key);
      }
    }
  });
  return cache;
}

var Recoil_treeCacheLRU = treeCacheLRU;

const TIME_WARNING_THRESHOLD_MS = 15;

function stringify(x, opt, key) {
  // A optimization to avoid the more expensive JSON.stringify() for simple strings
  // This may lose protection for u2028 and u2029, though.
  if (typeof x === 'string' && !x.includes('"') && !x.includes('\\')) {
    return `"${x}"`;
  } // Handle primitive types


  switch (typeof x) {
    case 'undefined':
      return '';
    // JSON.stringify(undefined) returns undefined, but we always want to return a string

    case 'boolean':
      return x ? 'true' : 'false';

    case 'number':
    case 'symbol':
      // case 'bigint': // BigInt is not supported in www
      return String(x);

    case 'string':
      // Add surrounding quotes and escape internal quotes
      return JSON.stringify(x);

    case 'function':
      if ((opt === null || opt === void 0 ? void 0 : opt.allowFunctions) !== true) {
        throw Recoil_err('Attempt to serialize function in a Recoil cache key');
      }

      return `__FUNCTION(${x.name})__`;
  }

  if (x === null) {
    return 'null';
  } // Fallback case for unknown types


  if (typeof x !== 'object') {
    var _JSON$stringify;

    return (_JSON$stringify = JSON.stringify(x)) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : '';
  } // Deal with all promises as equivalent for now.


  if (Recoil_isPromise(x)) {
    return '__PROMISE__';
  } // Arrays handle recursive stringification


  if (Array.isArray(x)) {
    // $FlowFixMe[missing-local-annot]
    return `[${x.map((v, i) => stringify(v, opt, i.toString()))}]`;
  } // If an object defines a toJSON() method, then use that to override the
  // serialization.  This matches the behavior of JSON.stringify().
  // Pass the key for compatibility.
  // Immutable.js collections define this method to allow us to serialize them.


  if (typeof x.toJSON === 'function') {
    // flowlint-next-line unclear-type: off
    return stringify(x.toJSON(key), opt, key);
  } // For built-in Maps, sort the keys in a stable order instead of the
  // default insertion order.  Support non-string keys.


  if (x instanceof Map) {
    const obj = {};

    for (const [k, v] of x) {
      // Stringify will escape any nested quotes
      obj[typeof k === 'string' ? k : stringify(k, opt)] = v;
    }

    return stringify(obj, opt, key);
  } // For built-in Sets, sort the keys in a stable order instead of the
  // default insertion order.


  if (x instanceof Set) {
    return stringify( // $FlowFixMe[missing-local-annot]
    Array.from(x).sort((a, b) => stringify(a, opt).localeCompare(stringify(b, opt))), opt, key);
  } // Anything else that is iterable serialize as an Array.


  if (Symbol !== undefined && x[Symbol.iterator] != null && typeof x[Symbol.iterator] === 'function') {
    // flowlint-next-line unclear-type: off
    return stringify(Array.from(x), opt, key);
  } // For all other Objects, sort the keys in a stable order.


  return `{${Object.keys(x).filter(k => x[k] !== undefined).sort() // stringify the key to add quotes and escape any nested slashes or quotes.
  .map(k => `${stringify(k, opt)}:${stringify(x[k], opt, k)}`).join(',')}}`;
} // Utility similar to JSON.stringify() except:
// * Serialize built-in Sets as an Array
// * Serialize built-in Maps as an Object.  Supports non-string keys.
// * Serialize other iterables as arrays
// * Sort the keys of Objects and Maps to have a stable order based on string conversion.
//    This overrides their default insertion order.
// * Still uses toJSON() of any object to override serialization
// * Support Symbols (though don't guarantee uniqueness)
// * We could support BigInt, but Flow doesn't seem to like it.
// See Recoil_stableStringify-test.js for examples


function stableStringify(x, opt = {
  allowFunctions: false
}) {
  if (false) {}

  return stringify(x, opt);
}

var Recoil_stableStringify = stableStringify;

const {
  TreeCache: TreeCache$2
} = Recoil_TreeCache$1;









const defaultPolicy = {
  equality: 'reference',
  eviction: 'keep-all',
  maxSize: Infinity
};

function treeCacheFromPolicy({
  equality = defaultPolicy.equality,
  eviction = defaultPolicy.eviction,
  maxSize = defaultPolicy.maxSize
} = defaultPolicy, name) {
  const valueMapper = getValueMapper(equality);
  return getTreeCache(eviction, maxSize, valueMapper, name);
}

function getValueMapper(equality) {
  switch (equality) {
    case 'reference':
      return val => val;

    case 'value':
      return val => Recoil_stableStringify(val);
  }

  throw Recoil_err(`Unrecognized equality policy ${equality}`);
}

function getTreeCache(eviction, maxSize, mapNodeValue, name) {
  switch (eviction) {
    case 'keep-all':
      return new TreeCache$2({
        name,
        mapNodeValue
      });

    case 'lru':
      return Recoil_treeCacheLRU({
        name,
        maxSize: Recoil_nullthrows(maxSize),
        mapNodeValue
      });

    case 'most-recent':
      return Recoil_treeCacheLRU({
        name,
        maxSize: 1,
        mapNodeValue
      });
  }

  throw Recoil_err(`Unrecognized eviction policy ${eviction}`);
}

var Recoil_treeCacheFromPolicy = treeCacheFromPolicy;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

function isNode(object) {
  var _ownerDocument, _doc$defaultView;

  if (typeof window === 'undefined') {
    return false;
  }

  const doc = object != null ? (_ownerDocument = object.ownerDocument) !== null && _ownerDocument !== void 0 ? _ownerDocument : object : document;
  const defaultView = (_doc$defaultView = doc.defaultView) !== null && _doc$defaultView !== void 0 ? _doc$defaultView : window;
  return !!(object != null && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

var Recoil_isNode = (/* unused pure expression or super */ null && (isNode));

const {
  isReactNative: isReactNative$1,
  isWindow: isWindow$1
} = Recoil_Environment;





function shouldNotBeFrozen(value) {
  // Primitives and functions:
  if (value === null || typeof value !== 'object') {
    return true;
  } // React elements:


  switch (typeof value.$$typeof) {
    case 'symbol':
      return true;

    case 'number':
      return true;
  } // Immutable structures:


  if (value['@@__IMMUTABLE_ITERABLE__@@'] != null || value['@@__IMMUTABLE_KEYED__@@'] != null || value['@@__IMMUTABLE_INDEXED__@@'] != null || value['@@__IMMUTABLE_ORDERED__@@'] != null || value['@@__IMMUTABLE_RECORD__@@'] != null) {
    return true;
  } // DOM nodes:


  if (Recoil_isNode(value)) {
    return true;
  }

  if (Recoil_isPromise(value)) {
    return true;
  }

  if (value instanceof Error) {
    return true;
  }

  if (ArrayBuffer.isView(value)) {
    return true;
  } // Some environments, just as Jest, don't work with the instanceof check


  if (!isReactNative$1 && isWindow$1(value)) {
    return true;
  }

  return false;
} // Recursively freeze a value to enforce it is read-only.
// This may also have minimal performance improvements for enumerating
// objects (based on browser implementations, of course)


function deepFreezeValue(value) {
  if (typeof value !== 'object' || shouldNotBeFrozen(value)) {
    return;
  }

  Object.freeze(value); // Make all properties read-only

  for (const key in value) {
    // $FlowIssue[method-unbinding] added when improving typing for this parameters
    if (Object.prototype.hasOwnProperty.call(value, key)) {
      const prop = value[key]; // Prevent infinite recurssion for circular references.

      if (typeof prop === 'object' && prop != null && !Object.isFrozen(prop)) {
        deepFreezeValue(prop);
      }
    }
  }

  Object.seal(value); // This also makes existing properties non-configurable.
}

var Recoil_deepFreezeValue = (/* unused pure expression or super */ null && (deepFreezeValue));

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * This is a stub for some integration into FB internal stuff
 *
 * 
 * @format
 * @oncall recoil
 */
function startPerfBlock(_id) {
  return () => null;
}

var Recoil_PerformanceTimings = {
  startPerfBlock
};

const {
  isLoadable: isLoadable$1,
  loadableWithError: loadableWithError$1,
  loadableWithPromise: loadableWithPromise$1,
  loadableWithValue: loadableWithValue$2
} = Recoil_Loadable$1;

const {
  WrappedValue: WrappedValue$1
} = Recoil_Wrapper$1;



const {
  getNodeLoadable: getNodeLoadable$2,
  peekNodeLoadable: peekNodeLoadable$1,
  setNodeValue: setNodeValue$3
} = Recoil_FunctionalCore;

const {
  saveDepsToStore: saveDepsToStore$1
} = Recoil_Graph;

const {
  DEFAULT_VALUE: DEFAULT_VALUE$6,
  getConfigDeletionHandler: getConfigDeletionHandler$1,
  getNode: getNode$6,
  registerNode: registerNode$1
} = Recoil_Node;

const {
  isRecoilValue: isRecoilValue$3
} = Recoil_RecoilValue$1;

const {
  markRecoilValueModified: markRecoilValueModified$1
} = Recoil_RecoilValueInterface;

const {
  retainedByOptionWithDefault: retainedByOptionWithDefault$1
} = Recoil_Retention;

const {
  recoilCallback: recoilCallback$1
} = Recoil_useRecoilCallback;



















const {
  startPerfBlock: startPerfBlock$1
} = Recoil_PerformanceTimings;



class Canceled {}

const CANCELED = new Canceled();
/**
 * An ExecutionID is an arbitrary ID that lets us distinguish executions from
 * each other. This is necessary as we need a way of solving this problem:
 * "given 3 async executions, only update state for the 'latest' execution when
 * it finishes running regardless of when the other 2 finish". ExecutionIDs
 * provide a convenient way of identifying executions so that we can track and
 * manage them over time.
 */

const dependencyStack = []; // for detecting circular dependencies.

const waitingStores = new Map();

const getNewExecutionID = (() => {
  let executionID = 0;
  return () => executionID++;
})();
/* eslint-disable no-redeclare */


function selector(options) {
  let recoilValue = null;
  const {
    key,
    get,
    cachePolicy_UNSTABLE: cachePolicy
  } = options;
  const set = options.set != null ? options.set : undefined; // flow

  if (false) {} // This is every discovered dependency across all executions


  const discoveredDependencyNodeKeys = new Set();
  const cache = Recoil_treeCacheFromPolicy(cachePolicy !== null && cachePolicy !== void 0 ? cachePolicy : {
    equality: 'reference',
    eviction: 'keep-all'
  }, key);
  const retainedBy = retainedByOptionWithDefault$1(options.retainedBy_UNSTABLE);
  const executionInfoMap = new Map();
  let liveStoresCount = 0;

  function selectorIsLive() {
    return !Recoil_gkx('recoil_memory_managament_2020') || liveStoresCount > 0;
  }

  function selectorInit(store) {
    store.getState().knownSelectors.add(key);
    liveStoresCount++;
    return () => {
      liveStoresCount--;
    };
  }

  function selectorShouldDeleteConfigOnRelease() {
    return getConfigDeletionHandler$1(key) !== undefined && !selectorIsLive();
  }

  function resolveAsync(store, state, executionID, loadable, depValues) {
    setCache(state, loadable, depValues);
    notifyStoresOfResolvedAsync(store, executionID);
  }

  function notifyStoresOfResolvedAsync(store, executionID) {
    if (isLatestExecution(store, executionID)) {
      clearExecutionInfo(store);
    }

    notifyWaitingStores(executionID, true);
  }
  /**
   * Notify stores to pull the selector again if a new async dep was discovered.
   * 1) Async selector adds a new dep but doesn't resolve yet.
   *    Note that deps for an async selector are based on the state when the
   *    evaluation started, in order to provide a consistent picture of state.
   * 2) But, new value of dep based on the current state might cause the selector
   *    to resolve or resolve differently.
   * 3) Therefore, this notification will pull the selector based on the current
   *    state for the components
   */


  function notifyStoresOfNewAsyncDep(store, executionID) {
    if (isLatestExecution(store, executionID)) {
      const executionInfo = Recoil_nullthrows(getExecutionInfo(store));
      executionInfo.stateVersions.clear();
      notifyWaitingStores(executionID, false);
    }
  }

  function notifyWaitingStores(executionID, clearWaitlist) {
    const stores = waitingStores.get(executionID);

    if (stores != null) {
      for (const waitingStore of stores) {
        markRecoilValueModified$1(waitingStore, Recoil_nullthrows(recoilValue));
      }

      if (clearWaitlist) {
        waitingStores.delete(executionID);
      }
    }
  }

  function markStoreWaitingForResolvedAsync(store, executionID) {
    let stores = waitingStores.get(executionID);

    if (stores == null) {
      waitingStores.set(executionID, stores = new Set());
    }

    stores.add(store);
  }
  /**
   * This function attaches a then() and a catch() to a promise that was
   * returned from a selector's get() (either explicitly or implicitly by
   * running a function that uses the "async" keyword). If a selector's get()
   * returns a promise, we have two possibilities:
   *
   * 1. The promise will resolve, in which case it will have completely finished
   *    executing without any remaining pending dependencies. No more retries
   *    are needed and we can proceed with updating the cache and notifying
   *    subscribers (if it is the latest execution, otherwise only the cache
   *    will be updated and subscriptions will not be fired). This is the case
   *    handled by the attached then() handler.
   *
   * 2. The promise will throw because it either has an error or it came across
   *    an async dependency that has not yet resolved, in which case we will
   *    call wrapDepdencyPromise(), whose responsibility is to handle dependency
   *    promises. This case is handled by the attached catch() handler.
   *
   * Both branches will eventually resolve to the final result of the selector
   * (or an error if a real error occurred).
   *
   * The execution will run to completion even if it is stale, and its value
   * will be cached. But stale executions will not update global state or update
   * executionInfo as that is the responsibility of the 'latest' execution.
   *
   * Note this function should not be passed a promise that was thrown--AKA a
   * dependency promise. Dependency promises should be passed to
   * wrapPendingDependencyPromise()).
   */


  function wrapResultPromise(store, promise, state, depValues, executionID, loadingDepsState) {
    return promise.then(value => {
      if (!selectorIsLive()) {
        // The selector was released since the request began; ignore the response.
        clearExecutionInfo(store);
        throw CANCELED;
      }

      const loadable = loadableWithValue$2(value);
      resolveAsync(store, state, executionID, loadable, depValues);
      return value;
    }).catch(errorOrPromise => {
      if (!selectorIsLive()) {
        // The selector was released since the request began; ignore the response.
        clearExecutionInfo(store);
        throw CANCELED;
      }

      if (Recoil_isPromise(errorOrPromise)) {
        return wrapPendingDependencyPromise(store, errorOrPromise, state, depValues, executionID, loadingDepsState);
      }

      const loadable = loadableWithError$1(errorOrPromise);
      resolveAsync(store, state, executionID, loadable, depValues);
      throw errorOrPromise;
    });
  }
  /**
   * This function attaches a then() and a catch() to a promise that was
   * thrown from a selector's get(). If a selector's get() throws a promise,
   * we have two possibilities:
   *
   * 1. The promise will resolve, meaning one of our selector's dependencies is
   *    now available and we should "retry" our get() by running it again. This
   *    is the case handled by the attached then() handler.
   *
   * 2. The promise will throw because something went wrong with the dependency
   *    promise (in other words a real error occurred). This case is handled by
   *    the attached catch() handler. If the dependency promise throws, it is
   *    _always_ a real error and not another dependency promise (any dependency
   *    promises would have been handled upstream).
   *
   * The then() branch will eventually resolve to the final result of the
   * selector (or an error if a real error occurs), and the catch() will always
   * resolve to an error because the dependency promise is a promise that was
   * wrapped upstream, meaning it will only resolve to its real value or to a
   * real error.
   *
   * The execution will run to completion even if it is stale, and its value
   * will be cached. But stale executions will not update global state or update
   * executionInfo as that is the responsibility of the 'latest' execution.
   *
   * Note this function should not be passed a promise that was returned from
   * get(). The intention is that this function is only passed promises that
   * were thrown due to a pending dependency. Promises returned by get() should
   * be passed to wrapResultPromise() instead.
   */


  function wrapPendingDependencyPromise(store, promise, state, existingDeps, executionID, loadingDepsState) {
    return promise.then(resolvedDep => {
      if (!selectorIsLive()) {
        // The selector was released since the request began; ignore the response.
        clearExecutionInfo(store);
        throw CANCELED;
      } // Check if we are handling a pending Recoil dependency or if the user
      // threw their own Promise to "suspend" a selector evaluation.  We need
      // to check that the loadingDepPromise actually matches the promise that
      // we caught in case the selector happened to catch the promise we threw
      // for a pending Recoil dependency from `getRecoilValue()` and threw
      // their own promise instead.


      if (loadingDepsState.loadingDepKey != null && loadingDepsState.loadingDepPromise === promise) {
        /**
         * Note for async atoms, this means we are changing the atom's value
         * in the store for the given version. This should be alright because
         * the version of state is now stale and a new version will have
         * already been triggered by the atom being resolved (see this logic
         * in Recoil_atom.js)
         */
        state.atomValues.set(loadingDepsState.loadingDepKey, loadableWithValue$2(resolvedDep));
      } else {
        /**
         * If resolvedDepKey is not defined, the promise was a user-thrown
         * promise. User-thrown promises are an advanced feature and they
         * should be avoided in almost all cases. Using `loadable.map()` inside
         * of selectors for loading loadables and then throwing that mapped
         * loadable's promise is an example of a user-thrown promise.
         *
         * When we hit a user-thrown promise, we have to bail out of an optimization
         * where we bypass calculating selector cache keys for selectors that
         * have been previously seen for a given state (these selectors are saved in
         * state.atomValues) to avoid stale state as we have no way of knowing
         * what state changes happened (if any) in result to the promise resolving.
         *
         * Ideally we would only bail out selectors that are in the chain of
         * dependencies for this selector, but there's currently no way to get
         * a full list of a selector's downstream nodes because the state that
         * is executing may be a discarded tree (so store.getGraph(state.version)
         * will be empty), and the full dep tree may not be in the selector
         * caches in the case where the selector's cache was cleared. To solve
         * for this we would have to keep track of all running selector
         * executions and their downstream deps. Because this only covers edge
         * cases, that complexity might not be justifyable.
         */
        store.getState().knownSelectors.forEach(nodeKey => {
          state.atomValues.delete(nodeKey);
        });
      }
      /**
       * Optimization: Now that the dependency has resolved, let's try hitting
       * the cache in case the dep resolved to a value we have previously seen.
       *
       * TODO:
       * Note this optimization is not perfect because it only prevents re-executions
       * _after_ the point where an async dependency is found. Any code leading
       * up to the async dependency may have run unnecessarily. The ideal case
       * would be to wait for the async dependency to resolve first, check the
       * cache, and prevent _any_ execution of the selector if the resulting
       * value of the dependency leads to a path that is found in the cache.
       * The ideal case is more difficult to implement as it would require that
       * we capture and wait for the the async dependency right after checking
       * the cache. The current approach takes advantage of the fact that running
       * the selector already has a code path that lets us exit early when
       * an async dep resolves.
       */


      const cachedLoadable = getLoadableFromCacheAndUpdateDeps(store, state);

      if (cachedLoadable && cachedLoadable.state !== 'loading') {
        /**
         * This has to notify stores of a resolved async, even if there is no
         * current pending execution for the following case:
         * 1) A component renders with this pending loadable.
         * 2) The upstream dependency resolves.
         * 3) While processing some other selector it reads this one, such as
         *    while traversing its dependencies.  At this point it gets the
         *    new resolved value synchronously and clears the current
         *    execution ID.  The component wasn't getting the value itself,
         *    though, so it still has the pending loadable.
         * 4) When this code executes the current execution id was cleared
         *    and it wouldn't notify the component of the new value.
         *
         * I think this is only an issue with "early" rendering since the
         * components got their value using the in-progress execution.
         * We don't have a unit test for this case yet.  I'm not sure it is
         * necessary with recoil_transition_support mode.
         */
        if (isLatestExecution(store, executionID) || getExecutionInfo(store) == null) {
          notifyStoresOfResolvedAsync(store, executionID);
        }

        if (cachedLoadable.state === 'hasValue') {
          return cachedLoadable.contents;
        } else {
          throw cachedLoadable.contents;
        }
      }
      /**
       * If this execution is stale, let's check to see if there is some in
       * progress execution with a matching state. If we find a match, then
       * we can take the value from that in-progress execution. Note this may
       * sound like an edge case, but may be very common in cases where a
       * loading dependency resolves from loading to having a value (thus
       * possibly triggering a re-render), and React re-renders before the
       * chained .then() functions run, thus starting a new execution as the
       * dep has changed value. Without this check we will run the selector
       * twice (once in the new execution and once again in this .then(), so
       * this check is necessary to keep unnecessary re-executions to a
       * minimum).
       *
       * Also note this code does not check across all executions that may be
       * running. It only optimizes for the _latest_ execution per store as
       * we currently do not maintain a list of all currently running executions.
       * This means in some cases we may run selectors more than strictly
       * necessary when there are multiple executions running for the same
       * selector. This may be a valid tradeoff as checking for dep changes
       * across all in-progress executions may take longer than just
       * re-running the selector. This will be app-dependent, and maybe in the
       * future we can make the behavior configurable. An ideal fix may be
       * to extend the tree cache to support caching loading states.
       */


      if (!isLatestExecution(store, executionID)) {
        const executionInfo = getInProgressExecutionInfo(store, state);

        if (executionInfo != null) {
          /**
           * Returning promise here without wrapping as the wrapper logic was
           * already done upstream when this promise was generated.
           */
          return executionInfo.loadingLoadable.contents;
        }
      } // Retry the selector evaluation now that the dependency has resolved


      const [loadable, depValues] = evaluateSelectorGetter(store, state, executionID);

      if (loadable.state !== 'loading') {
        resolveAsync(store, state, executionID, loadable, depValues);
      }

      if (loadable.state === 'hasError') {
        throw loadable.contents;
      }

      return loadable.contents;
    }).catch(error => {
      // The selector was released since the request began; ignore the response.
      if (error instanceof Canceled) {
        throw CANCELED;
      }

      if (!selectorIsLive()) {
        clearExecutionInfo(store);
        throw CANCELED;
      }

      const loadable = loadableWithError$1(error);
      resolveAsync(store, state, executionID, loadable, existingDeps);
      throw error;
    });
  }

  function updateDeps(store, state, deps, executionID) {
    var _store$getState, _store$getState$curre, _store$getState2, _store$getState2$next;

    if (isLatestExecution(store, executionID) || state.version === ((_store$getState = store.getState()) === null || _store$getState === void 0 ? void 0 : (_store$getState$curre = _store$getState.currentTree) === null || _store$getState$curre === void 0 ? void 0 : _store$getState$curre.version) || state.version === ((_store$getState2 = store.getState()) === null || _store$getState2 === void 0 ? void 0 : (_store$getState2$next = _store$getState2.nextTree) === null || _store$getState2$next === void 0 ? void 0 : _store$getState2$next.version)) {
      var _store$getState$nextT, _store$getState3, _store$getState3$next;

      saveDepsToStore$1(key, deps, store, (_store$getState$nextT = (_store$getState3 = store.getState()) === null || _store$getState3 === void 0 ? void 0 : (_store$getState3$next = _store$getState3.nextTree) === null || _store$getState3$next === void 0 ? void 0 : _store$getState3$next.version) !== null && _store$getState$nextT !== void 0 ? _store$getState$nextT : store.getState().currentTree.version);
    }

    for (const nodeKey of deps) {
      discoveredDependencyNodeKeys.add(nodeKey);
    }
  }

  function evaluateSelectorGetter(store, state, executionID) {
    const endPerfBlock = startPerfBlock$1(key); // TODO T63965866: use execution ID here

    let duringSynchronousExecution = true;
    let duringAsynchronousExecution = true;

    const finishEvaluation = () => {
      endPerfBlock();
      duringAsynchronousExecution = false;
    };

    let result;
    let resultIsError = false;
    let loadable;
    const loadingDepsState = {
      loadingDepKey: null,
      loadingDepPromise: null
    };
    /**
     * Starting a fresh set of deps that we'll be using to update state. We're
     * starting a new set versus adding it in existing state deps because
     * the version of state that we update deps for may be a more recent version
     * than the version the selector was called with. This is because the latest
     * execution will update the deps of the current/latest version of state
     * (This is safe to do because the fact that the selector is the latest
     * execution means the deps we discover below are our best guess at the
     * deps for the current/latest state in the store)
     */

    const depValues = new Map();

    function getRecoilValue({
      key: depKey
    }) {
      const depLoadable = getNodeLoadable$2(store, state, depKey);
      depValues.set(depKey, depLoadable); // We need to update asynchronous dependencies as we go so the selector
      // knows if it has to restart evaluation if one of them is updated before
      // the asynchronous selector completely resolves.

      if (!duringSynchronousExecution) {
        updateDeps(store, state, new Set(depValues.keys()), executionID);
        notifyStoresOfNewAsyncDep(store, executionID);
      }

      switch (depLoadable.state) {
        case 'hasValue':
          return depLoadable.contents;

        case 'hasError':
          throw depLoadable.contents;

        case 'loading':
          loadingDepsState.loadingDepKey = depKey;
          loadingDepsState.loadingDepPromise = depLoadable.contents;
          throw depLoadable.contents;
      }

      throw Recoil_err('Invalid Loadable state');
    }

    const getCallback = fn => {
      return (...args) => {
        if (duringAsynchronousExecution) {
          throw Recoil_err('Callbacks from getCallback() should only be called asynchronously after the selector is evalutated.  It can be used for selectors to return objects with callbacks that can work with Recoil state without a subscription.');
        }

        !(recoilValue != null) ?  false ? 0 : Recoil_invariant(false) : void 0;
        return recoilCallback$1(store, fn, args, {
          node: recoilValue
        } // flowlint-line unclear-type:off
        );
      };
    };

    try {
      result = get({
        get: getRecoilValue,
        getCallback
      });
      result = isRecoilValue$3(result) ? getRecoilValue(result) : result;

      if (isLoadable$1(result)) {
        if (result.state === 'hasError') {
          resultIsError = true;
        }

        result = result.contents;
      }

      if (Recoil_isPromise(result)) {
        result = wrapResultPromise(store, result, state, depValues, executionID, loadingDepsState).finally(finishEvaluation);
      } else {
        finishEvaluation();
      }

      result = result instanceof WrappedValue$1 ? result.value : result;
    } catch (errorOrDepPromise) {
      result = errorOrDepPromise;

      if (Recoil_isPromise(result)) {
        result = wrapPendingDependencyPromise(store, result, state, depValues, executionID, loadingDepsState).finally(finishEvaluation);
      } else {
        resultIsError = true;
        finishEvaluation();
      }
    }

    if (resultIsError) {
      loadable = loadableWithError$1(result);
    } else if (Recoil_isPromise(result)) {
      loadable = loadableWithPromise$1(result);
    } else {
      loadable = loadableWithValue$2(result);
    }

    duringSynchronousExecution = false;
    updateExecutionInfoDepValues(store, executionID, depValues);
    updateDeps(store, state, new Set(depValues.keys()), executionID);
    return [loadable, depValues];
  }

  function getLoadableFromCacheAndUpdateDeps(store, state) {
    // First, look up in the state cache
    // If it's here, then the deps in the store should already be valid.
    let cachedLoadable = state.atomValues.get(key);

    if (cachedLoadable != null) {
      return cachedLoadable;
    } // Second, look up in the selector cache and update the deps in the store


    const depsAfterCacheLookup = new Set();

    try {
      cachedLoadable = cache.get(nodeKey => {
        !(typeof nodeKey === 'string') ?  false ? 0 : Recoil_invariant(false) : void 0;
        return getNodeLoadable$2(store, state, nodeKey).contents;
      }, {
        onNodeVisit: node => {
          if (node.type === 'branch' && node.nodeKey !== key) {
            depsAfterCacheLookup.add(node.nodeKey);
          }
        }
      });
    } catch (error) {
      throw Recoil_err(`Problem with cache lookup for selector "${key}": ${error.message}`);
    }

    if (cachedLoadable) {
      var _getExecutionInfo;

      // Cache the results in the state to allow for cheaper lookup than
      // iterating the tree cache of dependencies.
      state.atomValues.set(key, cachedLoadable);
      /**
       * Ensure store contains correct dependencies if we hit the cache so that
       * the store deps and cache are in sync for a given state. This is important
       * because store deps are normally updated when new executions are created,
       * but cache hits don't trigger new executions but they still _may_ signify
       * a change in deps in the store if the store deps for this state are empty
       * or stale.
       */

      updateDeps(store, state, depsAfterCacheLookup, (_getExecutionInfo = getExecutionInfo(store)) === null || _getExecutionInfo === void 0 ? void 0 : _getExecutionInfo.executionID);
    }

    return cachedLoadable;
  }
  /**
   * Given a tree state, this function returns a Loadable of the current state.
   *
   * The selector's get() function will only be re-evaluated if _both_ of the
   * following statements are true:
   *
   * 1. The current dep values from the given state produced a cache key that
   *    was not found in the cache.
   * 2. There is no currently running async execution OR there is an
   *    async execution that is running, but after comparing the dep values in
   *    the given state with the dep values that the execution has discovered so
   *    far we find that at least one dep value has changed, in which case we
   *    start a new execution (the previously running execution will continue to
   *    run to completion, but only the new execution will be deemed the
   *    'latest' execution, meaning it will be the only execution that will
   *    update global state when it is finished. Any non-latest executions will
   *    run to completion and update the selector cache but not global state).
   */


  function getSelectorLoadableAndUpdateDeps(store, state) {
    // First, see if our current state is cached
    const cachedVal = getLoadableFromCacheAndUpdateDeps(store, state);

    if (cachedVal != null) {
      clearExecutionInfo(store);
      return cachedVal;
    } // Second, check if there is already an ongoing execution based on the current state


    const inProgressExecutionInfo = getInProgressExecutionInfo(store, state);

    if (inProgressExecutionInfo != null) {
      var _inProgressExecutionI;

      if (((_inProgressExecutionI = inProgressExecutionInfo.loadingLoadable) === null || _inProgressExecutionI === void 0 ? void 0 : _inProgressExecutionI.state) === 'loading') {
        markStoreWaitingForResolvedAsync(store, inProgressExecutionInfo.executionID);
      } // FIXME: check after the fact to see if we made the right choice by waiting


      return inProgressExecutionInfo.loadingLoadable;
    } // Third, start a new evaluation of the selector


    const newExecutionID = getNewExecutionID();
    const [loadable, newDepValues] = evaluateSelectorGetter(store, state, newExecutionID);
    /**
     * Conditionally updates the cache with a given loadable.
     *
     * We only cache loadables that are not loading because our cache keys are
     * based on dep values, which are in an unfinished state for loadables that
     * have a 'loading' state (new deps may be discovered while the selector
     * runs its async code). We never want to cache partial dependencies b/c it
     * could lead to errors, such as prematurely returning the result based on a
     * partial list of deps-- we need the full list of deps to ensure that we
     * are returning the correct result from cache.
     */

    if (loadable.state === 'loading') {
      setExecutionInfo(store, newExecutionID, loadable, newDepValues, state);
      markStoreWaitingForResolvedAsync(store, newExecutionID);
    } else {
      clearExecutionInfo(store);
      setCache(state, loadable, newDepValues);
    }

    return loadable;
  }
  /**
   * Searches execution info across all stores to see if there is an in-progress
   * execution whose dependency values match the values of the requesting store.
   */


  function getInProgressExecutionInfo(store, state) {
    // Sort the pending executions so that our current store is checked first.
    const pendingExecutions = Recoil_concatIterables([executionInfoMap.has(store) ? [Recoil_nullthrows(executionInfoMap.get(store))] : [], Recoil_mapIterable(Recoil_filterIterable(executionInfoMap, ([s]) => s !== store), ([, execInfo]) => execInfo)]);

    function anyDepChanged(execDepValues) {
      for (const [depKey, execLoadable] of execDepValues) {
        if (!getNodeLoadable$2(store, state, depKey).is(execLoadable)) {
          return true;
        }
      }

      return false;
    }

    for (const execInfo of pendingExecutions) {
      if ( // If this execution was already checked to be valid with this version
      // of state, then let's use it!
      execInfo.stateVersions.get(state.version) || // If the deps for the execution match our current state, then it's valid
      !anyDepChanged(execInfo.depValuesDiscoveredSoFarDuringAsyncWork)) {
        execInfo.stateVersions.set(state.version, true);
        return execInfo;
      } else {
        execInfo.stateVersions.set(state.version, false);
      }
    }

    return undefined;
  }

  function getExecutionInfo(store) {
    return executionInfoMap.get(store);
  }
  /**
   * This function will update the selector's execution info when the selector
   * has either finished running an execution or has started a new execution. If
   * the given loadable is in a 'loading' state, the intention is that a new
   * execution has started. Otherwise, the intention is that an execution has
   * just finished.
   */


  function setExecutionInfo(store, newExecutionID, loadable, depValues, state) {
    executionInfoMap.set(store, {
      depValuesDiscoveredSoFarDuringAsyncWork: depValues,
      executionID: newExecutionID,
      loadingLoadable: loadable,
      stateVersions: new Map([[state.version, true]])
    });
  }

  function updateExecutionInfoDepValues(store, executionID, depValues) {
    // We only need to bother updating the deps for the latest execution because
    // that's all getInProgressExecutionInfo() will be looking for.
    if (isLatestExecution(store, executionID)) {
      const executionInfo = getExecutionInfo(store);

      if (executionInfo != null) {
        executionInfo.depValuesDiscoveredSoFarDuringAsyncWork = depValues;
      }
    }
  }

  function clearExecutionInfo(store) {
    executionInfoMap.delete(store);
  }

  function isLatestExecution(store, executionID) {
    var _getExecutionInfo2;

    return executionID === ((_getExecutionInfo2 = getExecutionInfo(store)) === null || _getExecutionInfo2 === void 0 ? void 0 : _getExecutionInfo2.executionID);
  }
  /**
   * FIXME: dep keys should take into account the state of the loadable to
   * prevent the edge case where a loadable with an error and a loadable with
   * an error as a value are treated as the same thing incorrectly. For example
   * these two should be treated differently:
   *
   * selector({key: '', get: () => new Error('hi')});
   * selector({key: '', get () => {throw new Error('hi')}});
   *
   * With current implementation they are treated the same
   */


  function depValuesToDepRoute(depValues) {
    return Array.from(depValues.entries()).map(([depKey, valLoadable]) => [depKey, valLoadable.contents]);
  }

  function setCache(state, loadable, depValues) {
    if (false) {}

    state.atomValues.set(key, loadable);

    try {
      cache.set(depValuesToDepRoute(depValues), loadable);
    } catch (error) {
      throw Recoil_err(`Problem with setting cache for selector "${key}": ${error.message}`);
    }
  }

  function detectCircularDependencies(fn) {
    if (dependencyStack.includes(key)) {
      const message = `Recoil selector has circular dependencies: ${dependencyStack.slice(dependencyStack.indexOf(key)).join(' \u2192 ')}`;
      return loadableWithError$1(Recoil_err(message));
    }

    dependencyStack.push(key);

    try {
      return fn();
    } finally {
      dependencyStack.pop();
    }
  }

  function selectorPeek(store, state) {
    const cachedLoadable = state.atomValues.get(key);

    if (cachedLoadable != null) {
      return cachedLoadable;
    }

    return cache.get(nodeKey => {
      var _peekNodeLoadable;

      !(typeof nodeKey === 'string') ?  false ? 0 : Recoil_invariant(false) : void 0;
      return (_peekNodeLoadable = peekNodeLoadable$1(store, state, nodeKey)) === null || _peekNodeLoadable === void 0 ? void 0 : _peekNodeLoadable.contents;
    });
  }

  function selectorGet(store, state) {
    return detectCircularDependencies(() => getSelectorLoadableAndUpdateDeps(store, state));
  }

  function invalidateSelector(state) {
    state.atomValues.delete(key);
  }

  function clearSelectorCache(store, treeState) {
    !(recoilValue != null) ?  false ? 0 : Recoil_invariant(false) : void 0;

    for (const nodeKey of discoveredDependencyNodeKeys) {
      var _node$clearCache;

      const node = getNode$6(nodeKey);
      (_node$clearCache = node.clearCache) === null || _node$clearCache === void 0 ? void 0 : _node$clearCache.call(node, store, treeState);
    }

    discoveredDependencyNodeKeys.clear();
    invalidateSelector(treeState);
    cache.clear();
    markRecoilValueModified$1(store, recoilValue);
  }

  if (set != null) {
    /**
     * ES5 strict mode prohibits defining non-top-level function declarations,
     * so don't use function declaration syntax here
     */
    const selectorSet = (store, state, newValue) => {
      let syncSelectorSetFinished = false;
      const writes = new Map();

      function getRecoilValue({
        key: depKey
      }) {
        if (syncSelectorSetFinished) {
          throw Recoil_err('Recoil: Async selector sets are not currently supported.');
        }

        const loadable = getNodeLoadable$2(store, state, depKey);

        if (loadable.state === 'hasValue') {
          return loadable.contents;
        } else if (loadable.state === 'loading') {
          const msg = `Getting value of asynchronous atom or selector "${depKey}" in a pending state while setting selector "${key}" is not yet supported.`;
          Recoil_recoverableViolation(msg);
          throw Recoil_err(msg);
        } else {
          throw loadable.contents;
        }
      }

      function setRecoilState(recoilState, valueOrUpdater // $FlowFixMe[missing-local-annot]
      ) {
        if (syncSelectorSetFinished) {
          const msg = 'Recoil: Async selector sets are not currently supported.';
          Recoil_recoverableViolation(msg);
          throw Recoil_err(msg);
        }

        const setValue = typeof valueOrUpdater === 'function' ? // cast to any because we can't restrict type S from being a function itself without losing support for opaque types
        // flowlint-next-line unclear-type:off
        valueOrUpdater(getRecoilValue(recoilState)) : valueOrUpdater;
        const upstreamWrites = setNodeValue$3(store, state, recoilState.key, setValue);
        upstreamWrites.forEach((v, k) => writes.set(k, v));
      }

      function resetRecoilState(recoilState) {
        setRecoilState(recoilState, DEFAULT_VALUE$6);
      }

      const ret = set({
        set: setRecoilState,
        get: getRecoilValue,
        reset: resetRecoilState
      }, newValue); // set should be a void method, but if the user makes it `async`, then it
      // will return a Promise, which we don't currently support.

      if (ret !== undefined) {
        throw Recoil_isPromise(ret) ? Recoil_err('Recoil: Async selector sets are not currently supported.') : Recoil_err('Recoil: selector set should be a void function.');
      }

      syncSelectorSetFinished = true;
      return writes;
    };

    return recoilValue = registerNode$1({
      key,
      nodeType: 'selector',
      peek: selectorPeek,
      get: selectorGet,
      set: selectorSet,
      init: selectorInit,
      invalidate: invalidateSelector,
      clearCache: clearSelectorCache,
      shouldDeleteConfigOnRelease: selectorShouldDeleteConfigOnRelease,
      dangerouslyAllowMutability: options.dangerouslyAllowMutability,
      shouldRestoreFromSnapshots: false,
      retainedBy
    });
  } else {
    return recoilValue = registerNode$1({
      key,
      nodeType: 'selector',
      peek: selectorPeek,
      get: selectorGet,
      init: selectorInit,
      invalidate: invalidateSelector,
      clearCache: clearSelectorCache,
      shouldDeleteConfigOnRelease: selectorShouldDeleteConfigOnRelease,
      dangerouslyAllowMutability: options.dangerouslyAllowMutability,
      shouldRestoreFromSnapshots: false,
      retainedBy
    });
  }
}
/* eslint-enable no-redeclare */
// $FlowIssue[incompatible-use]
// $FlowFixMe[missing-local-annot]


selector.value = value => new WrappedValue$1(value);

var Recoil_selector = selector;

// @fb-only: import type {ScopeRules} from 'Recoil_ScopedAtom';
// @fb-only: const {scopedAtom} = require('Recoil_ScopedAtom');
const {
  isLoadable: isLoadable$2,
  loadableWithError: loadableWithError$2,
  loadableWithPromise: loadableWithPromise$2,
  loadableWithValue: loadableWithValue$3
} = Recoil_Loadable$1;

const {
  WrappedValue: WrappedValue$2
} = Recoil_Wrapper$1;

const {
  peekNodeInfo: peekNodeInfo$3
} = Recoil_FunctionalCore;

const {
  DEFAULT_VALUE: DEFAULT_VALUE$7,
  DefaultValue: DefaultValue$2,
  getConfigDeletionHandler: getConfigDeletionHandler$2,
  registerNode: registerNode$2,
  setConfigDeletionHandler: setConfigDeletionHandler$1
} = Recoil_Node;

const {
  isRecoilValue: isRecoilValue$4
} = Recoil_RecoilValue$1;

const {
  getRecoilValueAsLoadable: getRecoilValueAsLoadable$4,
  markRecoilValueModified: markRecoilValueModified$2,
  setRecoilValue: setRecoilValue$4,
  setRecoilValueLoadable: setRecoilValueLoadable$2
} = Recoil_RecoilValueInterface;

const {
  retainedByOptionWithDefault: retainedByOptionWithDefault$2
} = Recoil_Retention;















const unwrap = x => x instanceof WrappedValue$2 ? x.value : x;

function baseAtom(options) {
  const {
    key,
    persistence_UNSTABLE: persistence
  } = options;
  const retainedBy = retainedByOptionWithDefault$2(options.retainedBy_UNSTABLE);
  let liveStoresCount = 0;

  function unwrapPromise(promise) {
    return loadableWithPromise$2(promise.then(value => {
      defaultLoadable = loadableWithValue$3(value);
      return value;
    }).catch(error => {
      defaultLoadable = loadableWithError$2(error);
      throw error;
    }));
  }

  let defaultLoadable = Recoil_isPromise(options.default) ? unwrapPromise(options.default) : isLoadable$2(options.default) ? options.default.state === 'loading' ? unwrapPromise(options.default.contents) : options.default : // $FlowFixMe[incompatible-call]
  loadableWithValue$3(unwrap(options.default));
  maybeFreezeValueOrPromise(defaultLoadable.contents);
  let cachedAnswerForUnvalidatedValue = undefined; // Cleanup handlers for this atom
  // Rely on stable reference equality of the store to use it as a key per <RecoilRoot>

  const cleanupEffectsByStore = new Map();

  function maybeFreezeValueOrPromise(valueOrPromise) {
    if (false) {}

    return valueOrPromise;
  }

  function wrapPendingPromise(store, promise) {
    const wrappedPromise = promise.then(value => {
      var _store$getState$nextT, _state$atomValues$get;

      const state = (_store$getState$nextT = store.getState().nextTree) !== null && _store$getState$nextT !== void 0 ? _store$getState$nextT : store.getState().currentTree;

      if (((_state$atomValues$get = state.atomValues.get(key)) === null || _state$atomValues$get === void 0 ? void 0 : _state$atomValues$get.contents) === wrappedPromise) {
        setRecoilValue$4(store, node, value);
      }

      return value;
    }).catch(error => {
      var _store$getState$nextT2, _state$atomValues$get2;

      const state = (_store$getState$nextT2 = store.getState().nextTree) !== null && _store$getState$nextT2 !== void 0 ? _store$getState$nextT2 : store.getState().currentTree;

      if (((_state$atomValues$get2 = state.atomValues.get(key)) === null || _state$atomValues$get2 === void 0 ? void 0 : _state$atomValues$get2.contents) === wrappedPromise) {
        setRecoilValueLoadable$2(store, node, loadableWithError$2(error));
      }

      throw error;
    });
    return wrappedPromise;
  }

  function initAtom(store, initState, trigger) {
    var _options$effects;

    liveStoresCount++;

    const cleanupAtom = () => {
      var _cleanupEffectsByStor;

      liveStoresCount--;
      (_cleanupEffectsByStor = cleanupEffectsByStore.get(store)) === null || _cleanupEffectsByStor === void 0 ? void 0 : _cleanupEffectsByStor.forEach(cleanup => cleanup());
      cleanupEffectsByStore.delete(store);
    };

    store.getState().knownAtoms.add(key); // Setup async defaults to notify subscribers when they resolve

    if (defaultLoadable.state === 'loading') {
      const notifyDefaultSubscribers = () => {
        var _store$getState$nextT3;

        const state = (_store$getState$nextT3 = store.getState().nextTree) !== null && _store$getState$nextT3 !== void 0 ? _store$getState$nextT3 : store.getState().currentTree;

        if (!state.atomValues.has(key)) {
          markRecoilValueModified$2(store, node);
        }
      };

      defaultLoadable.contents.finally(notifyDefaultSubscribers);
    } ///////////////////
    // Run Atom Effects
    ///////////////////


    const effects = (_options$effects = options.effects) !== null && _options$effects !== void 0 ? _options$effects : options.effects_UNSTABLE;

    if (effects != null) {
      // This state is scoped by Store, since this is in the initAtom() closure
      let initValue = DEFAULT_VALUE$7;
      let isDuringInit = true;
      let isInitError = false;
      let pendingSetSelf = null;

      function getLoadable(recoilValue) {
        // Normally we can just get the current value of another atom.
        // But for our own value we need to check if there is a pending
        // initialized value or get the fallback default value.
        if (isDuringInit && recoilValue.key === key) {
          // Cast T to S
          const retValue = initValue; // flowlint-line unclear-type:off

          return retValue instanceof DefaultValue$2 ? peekAtom(store, initState) // flowlint-line unclear-type:off
          : Recoil_isPromise(retValue) ? loadableWithPromise$2(retValue.then(v => v instanceof DefaultValue$2 ? // Cast T to S
          defaultLoadable.toPromise() // flowlint-line unclear-type:off
          : v)) : // $FlowFixMe[incompatible-call]
          loadableWithValue$3(retValue);
        }

        return getRecoilValueAsLoadable$4(store, recoilValue);
      }

      function getPromise(recoilValue) {
        return getLoadable(recoilValue).toPromise();
      }

      function getInfo_UNSTABLE(recoilValue) {
        var _store$getState$nextT4;

        const info = peekNodeInfo$3(store, (_store$getState$nextT4 = store.getState().nextTree) !== null && _store$getState$nextT4 !== void 0 ? _store$getState$nextT4 : store.getState().currentTree, recoilValue.key);
        return isDuringInit && recoilValue.key === key && !(initValue instanceof DefaultValue$2) ? { ...info,
          isSet: true,
          loadable: getLoadable(recoilValue)
        } : info;
      }

      const setSelf = effect => valueOrUpdater => {
        if (isDuringInit) {
          const currentLoadable = getLoadable(node);
          const currentValue = currentLoadable.state === 'hasValue' ? currentLoadable.contents : DEFAULT_VALUE$7;
          initValue = typeof valueOrUpdater === 'function' ? // cast to any because we can't restrict T from being a function without losing support for opaque types
          valueOrUpdater(currentValue) // flowlint-line unclear-type:off
          : valueOrUpdater;

          if (Recoil_isPromise(initValue)) {
            initValue = initValue.then(value => {
              // Avoid calling onSet() when setSelf() initializes with a Promise
              pendingSetSelf = {
                effect,
                value
              };
              return value;
            });
          }
        } else {
          if (Recoil_isPromise(valueOrUpdater)) {
            throw Recoil_err('Setting atoms to async values is not implemented.');
          }

          if (typeof valueOrUpdater !== 'function') {
            pendingSetSelf = {
              effect,
              value: unwrap(valueOrUpdater)
            };
          }

          setRecoilValue$4(store, node, typeof valueOrUpdater === 'function' ? currentValue => {
            const newValue = unwrap( // cast to any because we can't restrict T from being a function without losing support for opaque types
            valueOrUpdater(currentValue) // flowlint-line unclear-type:off
            ); // $FlowFixMe[incompatible-type]

            pendingSetSelf = {
              effect,
              value: newValue
            };
            return newValue;
          } : unwrap(valueOrUpdater));
        }
      };

      const resetSelf = effect => () => setSelf(effect)(DEFAULT_VALUE$7);

      const onSet = effect => handler => {
        var _cleanupEffectsByStor2;

        const {
          release
        } = store.subscribeToTransactions(currentStore => {
          var _currentTree$atomValu;

          // eslint-disable-next-line prefer-const
          let {
            currentTree,
            previousTree
          } = currentStore.getState();

          if (!previousTree) {
            Recoil_recoverableViolation('Transaction subscribers notified without a next tree being present -- this is a bug in Recoil');
            previousTree = currentTree; // attempt to trundle on
          }

          const newLoadable = (_currentTree$atomValu = currentTree.atomValues.get(key)) !== null && _currentTree$atomValu !== void 0 ? _currentTree$atomValu : defaultLoadable;

          if (newLoadable.state === 'hasValue') {
            var _previousTree$atomVal, _pendingSetSelf, _pendingSetSelf2, _pendingSetSelf3;

            const newValue = newLoadable.contents;
            const oldLoadable = (_previousTree$atomVal = previousTree.atomValues.get(key)) !== null && _previousTree$atomVal !== void 0 ? _previousTree$atomVal : defaultLoadable;
            const oldValue = oldLoadable.state === 'hasValue' ? oldLoadable.contents : DEFAULT_VALUE$7; // TODO This isn't actually valid, use as a placeholder for now.
            // Ignore atom value changes that were set via setSelf() in the same effect.
            // We will still properly call the handler if there was a subsequent
            // set from something other than an atom effect which was batched
            // with the `setSelf()` call.  However, we may incorrectly ignore
            // the handler if the subsequent batched call happens to set the
            // atom to the exact same value as the `setSelf()`.   But, in that
            // case, it was kind of a noop, so the semantics are debatable..

            if (((_pendingSetSelf = pendingSetSelf) === null || _pendingSetSelf === void 0 ? void 0 : _pendingSetSelf.effect) !== effect || ((_pendingSetSelf2 = pendingSetSelf) === null || _pendingSetSelf2 === void 0 ? void 0 : _pendingSetSelf2.value) !== newValue) {
              handler(newValue, oldValue, !currentTree.atomValues.has(key));
            } else if (((_pendingSetSelf3 = pendingSetSelf) === null || _pendingSetSelf3 === void 0 ? void 0 : _pendingSetSelf3.effect) === effect) {
              pendingSetSelf = null;
            }
          }
        }, key);
        cleanupEffectsByStore.set(store, [...((_cleanupEffectsByStor2 = cleanupEffectsByStore.get(store)) !== null && _cleanupEffectsByStor2 !== void 0 ? _cleanupEffectsByStor2 : []), release]);
      };

      for (const effect of effects) {
        try {
          const cleanup = effect({
            node,
            storeID: store.storeID,
            parentStoreID_UNSTABLE: store.parentStoreID,
            trigger,
            setSelf: setSelf(effect),
            resetSelf: resetSelf(effect),
            onSet: onSet(effect),
            getPromise,
            getLoadable,
            getInfo_UNSTABLE
          });

          if (cleanup != null) {
            var _cleanupEffectsByStor3;

            cleanupEffectsByStore.set(store, [...((_cleanupEffectsByStor3 = cleanupEffectsByStore.get(store)) !== null && _cleanupEffectsByStor3 !== void 0 ? _cleanupEffectsByStor3 : []), cleanup]);
          }
        } catch (error) {
          initValue = error;
          isInitError = true;
        }
      }

      isDuringInit = false; // Mutate initial state in place since we know there are no other subscribers
      // since we are the ones initializing on first use.

      if (!(initValue instanceof DefaultValue$2)) {
        var _store$getState$nextT5;

        const initLoadable = isInitError ? loadableWithError$2(initValue) : Recoil_isPromise(initValue) ? loadableWithPromise$2(wrapPendingPromise(store, initValue)) : loadableWithValue$3(unwrap(initValue));
        maybeFreezeValueOrPromise(initLoadable.contents);
        initState.atomValues.set(key, initLoadable); // If there is a pending transaction, then also mutate the next state tree.
        // This could happen if the atom was first initialized in an action that
        // also updated some other atom's state.

        (_store$getState$nextT5 = store.getState().nextTree) === null || _store$getState$nextT5 === void 0 ? void 0 : _store$getState$nextT5.atomValues.set(key, initLoadable);
      }
    }

    return cleanupAtom;
  }

  function peekAtom(_store, state) {
    var _ref, _state$atomValues$get3;

    return (_ref = (_state$atomValues$get3 = state.atomValues.get(key)) !== null && _state$atomValues$get3 !== void 0 ? _state$atomValues$get3 : cachedAnswerForUnvalidatedValue) !== null && _ref !== void 0 ? _ref : defaultLoadable;
  }

  function getAtom(_store, state) {
    if (state.atomValues.has(key)) {
      // Atom value is stored in state:
      return Recoil_nullthrows(state.atomValues.get(key));
    } else if (state.nonvalidatedAtoms.has(key)) {
      // Atom value is stored but needs validation before use.
      // We might have already validated it and have a cached validated value:
      if (cachedAnswerForUnvalidatedValue != null) {
        return cachedAnswerForUnvalidatedValue;
      }

      if (persistence == null) {
        Recoil_expectationViolation(`Tried to restore a persisted value for atom ${key} but it has no persistence settings.`);
        return defaultLoadable;
      }

      const nonvalidatedValue = state.nonvalidatedAtoms.get(key);
      const validatorResult = persistence.validator(nonvalidatedValue, DEFAULT_VALUE$7);
      const validatedValueLoadable = validatorResult instanceof DefaultValue$2 ? defaultLoadable : loadableWithValue$3(validatorResult);
      cachedAnswerForUnvalidatedValue = validatedValueLoadable;
      return cachedAnswerForUnvalidatedValue;
    } else {
      return defaultLoadable;
    }
  }

  function invalidateAtom() {
    cachedAnswerForUnvalidatedValue = undefined;
  }

  function setAtom(_store, state, newValue) {
    // Bail out if we're being set to the existing value, or if we're being
    // reset but have no stored value (validated or unvalidated) to reset from:
    if (state.atomValues.has(key)) {
      const existing = Recoil_nullthrows(state.atomValues.get(key));

      if (existing.state === 'hasValue' && newValue === existing.contents) {
        return new Map();
      }
    } else if (!state.nonvalidatedAtoms.has(key) && newValue instanceof DefaultValue$2) {
      return new Map();
    }

    maybeFreezeValueOrPromise(newValue);
    cachedAnswerForUnvalidatedValue = undefined; // can be released now if it was previously in use

    return new Map().set(key, loadableWithValue$3(newValue));
  }

  function shouldDeleteConfigOnReleaseAtom() {
    return getConfigDeletionHandler$2(key) !== undefined && liveStoresCount <= 0;
  }

  const node = registerNode$2({
    key,
    nodeType: 'atom',
    peek: peekAtom,
    get: getAtom,
    set: setAtom,
    init: initAtom,
    invalidate: invalidateAtom,
    shouldDeleteConfigOnRelease: shouldDeleteConfigOnReleaseAtom,
    dangerouslyAllowMutability: options.dangerouslyAllowMutability,
    persistence_UNSTABLE: options.persistence_UNSTABLE ? {
      type: options.persistence_UNSTABLE.type,
      backButton: options.persistence_UNSTABLE.backButton
    } : undefined,
    shouldRestoreFromSnapshots: true,
    retainedBy
  });
  return node;
} // prettier-ignore


function atom(options) {
  if (false) {}

  const { // @fb-only: scopeRules_APPEND_ONLY_READ_THE_DOCS,
    ...restOptions
  } = options;
  const optionsDefault = 'default' in options ? // $FlowIssue[incompatible-type] No way to refine in Flow that property is not defined
  options.default : new Promise(() => {});

  if (isRecoilValue$4(optionsDefault) // Continue to use atomWithFallback for promise defaults for scoped atoms
  // for now, since scoped atoms don't support async defaults
  // @fb-only: || (isPromise(optionsDefault) && scopeRules_APPEND_ONLY_READ_THE_DOCS)
  // @fb-only: || (isLoadable(optionsDefault) && scopeRules_APPEND_ONLY_READ_THE_DOCS)
  ) {
    return atomWithFallback({ ...restOptions,
      default: optionsDefault // @fb-only: scopeRules_APPEND_ONLY_READ_THE_DOCS,

    }); // @fb-only: } else if (scopeRules_APPEND_ONLY_READ_THE_DOCS
    // @fb-only: && !isPromise(optionsDefault)
    // @fb-only: && !isLoadable(optionsDefault)
    // @fb-only: ) {
    // @fb-only: return scopedAtom<T>({
    // @fb-only: ...restOptions,
    // @fb-only: default: unwrap<T>(optionsDefault),
    // @fb-only: scopeRules_APPEND_ONLY_READ_THE_DOCS,
    // @fb-only: });
  } else {
    return baseAtom({ ...restOptions,
      default: optionsDefault
    });
  }
}

function atomWithFallback(options) {
  const base = atom({ ...options,
    default: DEFAULT_VALUE$7,
    persistence_UNSTABLE: options.persistence_UNSTABLE === undefined ? undefined : { ...options.persistence_UNSTABLE,
      validator: storedValue => storedValue instanceof DefaultValue$2 ? storedValue : Recoil_nullthrows(options.persistence_UNSTABLE).validator(storedValue, DEFAULT_VALUE$7)
    },
    // TODO Hack for now.
    effects: options.effects,
    // flowlint-line unclear-type: off
    effects_UNSTABLE: options.effects_UNSTABLE // flowlint-line unclear-type: off

  }); // $FlowFixMe[incompatible-call]

  const sel = Recoil_selector({
    key: `${options.key}__withFallback`,
    get: ({
      get
    }) => {
      const baseValue = get(base);
      return baseValue instanceof DefaultValue$2 ? options.default : baseValue;
    },
    // $FlowFixMe[incompatible-call]
    set: ({
      set
    }, newValue) => set(base, newValue),
    // This selector does not need to cache as it is a wrapper selector
    // and the selector within the wrapper selector will have a cache
    // option by default
    cachePolicy_UNSTABLE: {
      eviction: 'most-recent'
    },
    dangerouslyAllowMutability: options.dangerouslyAllowMutability
  });
  setConfigDeletionHandler$1(sel.key, getConfigDeletionHandler$2(options.key));
  return sel;
} // $FlowFixMe[missing-local-annot]


atom.value = value => new WrappedValue$2(value);

var Recoil_atom = atom;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

class MapCache {
  constructor(options) {
    var _options$mapKey;

    _defineProperty(this, "_map", void 0);

    _defineProperty(this, "_keyMapper", void 0);

    this._map = new Map();
    this._keyMapper = (_options$mapKey = options === null || options === void 0 ? void 0 : options.mapKey) !== null && _options$mapKey !== void 0 ? _options$mapKey : v => v;
  }

  size() {
    return this._map.size;
  }

  has(key) {
    return this._map.has(this._keyMapper(key));
  }

  get(key) {
    return this._map.get(this._keyMapper(key));
  }

  set(key, val) {
    this._map.set(this._keyMapper(key), val);
  }

  delete(key) {
    this._map.delete(this._keyMapper(key));
  }

  clear() {
    this._map.clear();
  }

}

var Recoil_MapCache = {
  MapCache
};

var Recoil_MapCache_1 = Recoil_MapCache.MapCache;

var Recoil_MapCache$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  MapCache: Recoil_MapCache_1
});

const {
  LRUCache: LRUCache$2
} = Recoil_LRUCache$1;

const {
  MapCache: MapCache$1
} = Recoil_MapCache$1;







const defaultPolicy$1 = {
  equality: 'reference',
  eviction: 'none',
  maxSize: Infinity
};

function cacheFromPolicy({
  equality = defaultPolicy$1.equality,
  eviction = defaultPolicy$1.eviction,
  maxSize = defaultPolicy$1.maxSize
} = defaultPolicy$1) {
  const valueMapper = getValueMapper$1(equality);
  const cache = getCache(eviction, maxSize, valueMapper);
  return cache;
}

function getValueMapper$1(equality) {
  switch (equality) {
    case 'reference':
      return val => val;

    case 'value':
      return val => Recoil_stableStringify(val);
  }

  throw Recoil_err(`Unrecognized equality policy ${equality}`);
}

function getCache(eviction, maxSize, mapKey) {
  switch (eviction) {
    case 'keep-all':
      return new MapCache$1({
        mapKey
      });

    case 'lru':
      return new LRUCache$2({
        mapKey,
        maxSize: Recoil_nullthrows(maxSize)
      });

    case 'most-recent':
      return new LRUCache$2({
        mapKey,
        maxSize: 1
      });
  }

  throw Recoil_err(`Unrecognized eviction policy ${eviction}`);
}

var Recoil_cacheFromPolicy = cacheFromPolicy;

// @fb-only: import type {ScopeRules} from 'Recoil_ScopedAtom';


const {
  setConfigDeletionHandler: setConfigDeletionHandler$2
} = Recoil_Node;





// Process scopeRules to handle any entries which are functions taking parameters
// prettier-ignore
// @fb-only: function mapScopeRules<P>(
// @fb-only: scopeRules?: ParameterizedScopeRules<P>,
// @fb-only: param: P,
// @fb-only: ): ScopeRules | void {
// @fb-only: return scopeRules?.map(rule =>
// @fb-only: Array.isArray(rule)
// @fb-only: ? rule.map(entry => (typeof entry === 'function' ? entry(param) : entry))
// @fb-only: : rule,
// @fb-only: );
// @fb-only: }

/*
A function which returns an atom based on the input parameter.

Each unique parameter returns a unique atom. E.g.,

  const f = atomFamily(...);
  f({a: 1}) => an atom
  f({a: 2}) => a different atom

This allows components to persist local, private state using atoms.  Each
instance of the component may have a different key, which it uses as the
parameter for a family of atoms; in this way, each component will have
its own atom not shared by other instances.  These state keys may be composed
into children's state keys as well.
*/
function atomFamily(options) {
  var _options$cachePolicyF, _options$cachePolicyF2;

  const atomCache = Recoil_cacheFromPolicy({
    equality: (_options$cachePolicyF = (_options$cachePolicyF2 = options.cachePolicyForParams_UNSTABLE) === null || _options$cachePolicyF2 === void 0 ? void 0 : _options$cachePolicyF2.equality) !== null && _options$cachePolicyF !== void 0 ? _options$cachePolicyF : 'value',
    eviction: 'keep-all'
  }); // Simple atomFamily implementation to cache individual atoms based
  // on the parameter value equality.

  return params => {
    var _stableStringify, _options$effects;

    const cachedAtom = atomCache.get(params);

    if (cachedAtom != null) {
      return cachedAtom;
    }

    const {
      cachePolicyForParams_UNSTABLE,
      ...atomOptions
    } = options;
    const optionsDefault = 'default' in options ? // $FlowIssue[incompatible-type] No way to refine in Flow that property is not defined
    options.default : new Promise(() => {});
    const newAtom = Recoil_atom({ ...atomOptions,
      key: `${options.key}__${(_stableStringify = Recoil_stableStringify(params)) !== null && _stableStringify !== void 0 ? _stableStringify : 'void'}`,
      default: typeof optionsDefault === 'function' ? // The default was parameterized
      // Flow doesn't know that T isn't a function, so we need to case to any
      // $FlowIssue[incompatible-use]
      optionsDefault(params) : // Default may be a static value, promise, or RecoilValue
      optionsDefault,
      retainedBy_UNSTABLE: typeof options.retainedBy_UNSTABLE === 'function' ? options.retainedBy_UNSTABLE(params) : options.retainedBy_UNSTABLE,
      effects: typeof options.effects === 'function' ? options.effects(params) : typeof options.effects_UNSTABLE === 'function' ? options.effects_UNSTABLE(params) : (_options$effects = options.effects) !== null && _options$effects !== void 0 ? _options$effects : options.effects_UNSTABLE // prettier-ignore
      // @fb-only: scopeRules_APPEND_ONLY_READ_THE_DOCS: mapScopeRules(
      // @fb-only: options.scopeRules_APPEND_ONLY_READ_THE_DOCS,
      // @fb-only: params,
      // @fb-only: ),

    });
    atomCache.set(params, newAtom);
    setConfigDeletionHandler$2(newAtom.key, () => {
      atomCache.delete(params);
    });
    return newAtom;
  };
}

var Recoil_atomFamily = atomFamily;

const {
  setConfigDeletionHandler: setConfigDeletionHandler$3
} = Recoil_Node;





 // Keep in mind the parameter needs to be serializable as a cahche key
// using Recoil_stableStringify


// Add a unique index to each selector in case the cache implementation allows
// duplicate keys based on equivalent stringified parameters
let nextIndex = 0;
/* eslint-disable no-redeclare */

// Return a function that returns members of a family of selectors of the same type
// E.g.,
//
// const s = selectorFamily(...);
// s({a: 1}) => a selector
// s({a: 2}) => a different selector
//
// By default, the selectors are distinguished by distinct values of the
// parameter based on value equality, not reference equality.  This allows using
// object literals or other equivalent objects at callsites to not create
// duplicate cache entries.  This behavior may be overridden with the
// cacheImplementationForParams option.
function selectorFamily(options) {
  var _options$cachePolicyF, _options$cachePolicyF2;

  const selectorCache = Recoil_cacheFromPolicy({
    equality: (_options$cachePolicyF = (_options$cachePolicyF2 = options.cachePolicyForParams_UNSTABLE) === null || _options$cachePolicyF2 === void 0 ? void 0 : _options$cachePolicyF2.equality) !== null && _options$cachePolicyF !== void 0 ? _options$cachePolicyF : 'value',
    eviction: 'keep-all'
  });
  return params => {
    var _stableStringify;

    // Throw an error with selector key so that it is clear which
    // selector is causing an error
    let cachedSelector;

    try {
      cachedSelector = selectorCache.get(params);
    } catch (error) {
      throw Recoil_err(`Problem with cache lookup for selector ${options.key}: ${error.message}`);
    }

    if (cachedSelector != null) {
      return cachedSelector;
    }

    const myKey = `${options.key}__selectorFamily/${(_stableStringify = Recoil_stableStringify(params, {
      // It is possible to use functions in parameters if the user uses
      // a cache with reference equality thanks to the incrementing index.
      allowFunctions: true
    })) !== null && _stableStringify !== void 0 ? _stableStringify : 'void'}/${nextIndex++}`; // Append index in case values serialize to the same key string

    const myGet = callbacks => options.get(params)(callbacks);

    const myCachePolicy = options.cachePolicy_UNSTABLE;
    const retainedBy = typeof options.retainedBy_UNSTABLE === 'function' ? options.retainedBy_UNSTABLE(params) : options.retainedBy_UNSTABLE;
    let newSelector;

    if (options.set != null) {
      const set = options.set;

      const mySet = (callbacks, newValue) => set(params)(callbacks, newValue);

      newSelector = Recoil_selector({
        key: myKey,
        get: myGet,
        set: mySet,
        cachePolicy_UNSTABLE: myCachePolicy,
        dangerouslyAllowMutability: options.dangerouslyAllowMutability,
        retainedBy_UNSTABLE: retainedBy
      });
    } else {
      newSelector = Recoil_selector({
        key: myKey,
        get: myGet,
        cachePolicy_UNSTABLE: myCachePolicy,
        dangerouslyAllowMutability: options.dangerouslyAllowMutability,
        retainedBy_UNSTABLE: retainedBy
      });
    }

    selectorCache.set(params, newSelector);
    setConfigDeletionHandler$3(newSelector.key, () => {
      selectorCache.delete(params);
    });
    return newSelector;
  };
}
/* eslint-enable no-redeclare */


var Recoil_selectorFamily = selectorFamily;

// flowlint-next-line unclear-type:off


const constantSelector = Recoil_selectorFamily({
  key: '__constant',
  get: constant => () => constant,
  cachePolicyForParams_UNSTABLE: {
    equality: 'reference'
  }
}); // Function that returns a selector which always produces the
// same constant value.  It may be called multiple times with the
// same value, based on reference equality, and will provide the
// same selector.

function constSelector(constant) {
  return constantSelector(constant);
}

var Recoil_constSelector = constSelector;

// flowlint-next-line unclear-type:off


const throwingSelector = Recoil_selectorFamily({
  key: '__error',
  get: message => () => {
    throw Recoil_err(message);
  },
  // TODO Why?
  cachePolicyForParams_UNSTABLE: {
    equality: 'reference'
  }
}); // Function that returns a selector which always throws an error
// with the provided message.

function errorSelector(message) {
  return throwingSelector(message);
}

var Recoil_errorSelector = errorSelector;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Wraps another recoil value and prevents writing to it.
 *
 * 
 * @format
 * @oncall recoil
 */

function readOnlySelector(atom) {
  // flowlint-next-line unclear-type: off
  return atom;
}

var Recoil_readOnlySelector = readOnlySelector;

const {
  loadableWithError: loadableWithError$3,
  loadableWithPromise: loadableWithPromise$3,
  loadableWithValue: loadableWithValue$4
} = Recoil_Loadable$1;





 /////////////////
//  TRUTH TABLE
/////////////////
// Dependencies        waitForNone         waitForAny        waitForAll       waitForAllSettled
//  [loading, loading]  [Promise, Promise]  Promise           Promise         Promise
//  [value, loading]    [value, Promise]    [value, Promise]  Promise         Promise
//  [value, value]      [value, value]      [value, value]    [value, value]  [value, value]
//
//  [error, loading]    [Error, Promise]    [Error, Promise]  Error           Promise
//  [error, error]      [Error, Error]      [Error, Error]    Error           [error, error]
//  [value, error]      [value, Error]      [value, Error]    Error           [value, error]
// Issue parallel requests for all dependencies and return the current
// status if they have results, have some error, or are still pending.


function concurrentRequests(getRecoilValue, deps) {
  const results = Array(deps.length).fill(undefined);
  const exceptions = Array(deps.length).fill(undefined);

  for (const [i, dep] of deps.entries()) {
    try {
      results[i] = getRecoilValue(dep);
    } catch (e) {
      // exceptions can either be Promises of pending results or real errors
      exceptions[i] = e;
    }
  }

  return [results, exceptions];
}

function isError(exp) {
  return exp != null && !Recoil_isPromise(exp);
}

function unwrapDependencies(dependencies) {
  return Array.isArray(dependencies) ? dependencies : Object.getOwnPropertyNames(dependencies).map(key => dependencies[key]);
}

function wrapResults(dependencies,
/* $FlowFixMe[missing-local-annot] The type annotation(s) required by Flow's
 * LTI update could not be added via codemod */
results) {
  return Array.isArray(dependencies) ? results : // Object.getOwnPropertyNames() has consistent key ordering with ES6
  Object.getOwnPropertyNames(dependencies).reduce((out, key, idx) => ({ ...out,
    [key]: results[idx]
  }), {});
}

function wrapLoadables(dependencies, results, exceptions) {
  const output = exceptions.map((exception, idx) => exception == null ? loadableWithValue$4(results[idx]) : Recoil_isPromise(exception) ? loadableWithPromise$3(exception) : loadableWithError$3(exception));
  return wrapResults(dependencies, output);
}

function combineAsyncResultsWithSyncResults(syncResults, asyncResults) {
  return asyncResults.map((result, idx) =>
  /**
   * it's important we use === undefined as opposed to == null, because the
   * resolved value of the async promise could be `null`, in which case we
   * don't want to use syncResults[idx], which would be undefined. If async
   * promise resolves to `undefined`, that's ok because `syncResults[idx]`
   * will also be `undefined`. That's a little hacky, but it works.
   */
  result === undefined ? syncResults[idx] : result);
} // Selector that requests all dependencies in parallel and immediately returns
// current results without waiting.


const waitForNone = Recoil_selectorFamily({
  key: '__waitForNone',
  get: dependencies => ({
    get
  }) => {
    // Issue requests for all dependencies in parallel.
    const deps = unwrapDependencies(dependencies);
    const [results, exceptions] = concurrentRequests(get, deps); // Always return the current status of the results; never block.

    return wrapLoadables(dependencies, results, exceptions);
  },
  dangerouslyAllowMutability: true
}); // Selector that requests all dependencies in parallel and waits for at least
// one to be available before returning results.  It will only error if all
// dependencies have errors.

const waitForAny = Recoil_selectorFamily({
  key: '__waitForAny',
  get: dependencies => ({
    get
  }) => {
    // Issue requests for all dependencies in parallel.
    // Exceptions can either be Promises of pending results or real errors
    const deps = unwrapDependencies(dependencies);
    const [results, exceptions] = concurrentRequests(get, deps); // If any results are available, value or error, return the current status

    if (exceptions.some(exp => !Recoil_isPromise(exp))) {
      return wrapLoadables(dependencies, results, exceptions);
    } // Otherwise, return a promise that will resolve when the next result is
    // available, whichever one happens to be next.  But, if all pending
    // dependencies end up with errors, then reject the promise.


    return new Promise(resolve => {
      for (const [i, exp] of exceptions.entries()) {
        if (Recoil_isPromise(exp)) {
          exp.then(result => {
            results[i] = result;
            exceptions[i] = undefined;
            resolve(wrapLoadables(dependencies, results, exceptions));
          }).catch(error => {
            exceptions[i] = error;
            resolve(wrapLoadables(dependencies, results, exceptions));
          });
        }
      }
    });
  },
  dangerouslyAllowMutability: true
}); // Selector that requests all dependencies in parallel and waits for all to be
// available before returning a value.  It will error if any dependencies error.

const waitForAll = Recoil_selectorFamily({
  key: '__waitForAll',
  get: dependencies => ({
    get
  }) => {
    // Issue requests for all dependencies in parallel.
    // Exceptions can either be Promises of pending results or real errors
    const deps = unwrapDependencies(dependencies);
    const [results, exceptions] = concurrentRequests(get, deps); // If all results are available, return the results

    if (exceptions.every(exp => exp == null)) {
      return wrapResults(dependencies, results);
    } // If we have any errors, throw the first error


    const error = exceptions.find(isError);

    if (error != null) {
      throw error;
    } // Otherwise, return a promise that will resolve when all results are available


    return Promise.all(exceptions).then(exceptionResults => wrapResults(dependencies, combineAsyncResultsWithSyncResults(results, exceptionResults)));
  },
  dangerouslyAllowMutability: true
});
const waitForAllSettled = Recoil_selectorFamily({
  key: '__waitForAllSettled',
  get: dependencies => ({
    get
  }) => {
    // Issue requests for all dependencies in parallel.
    // Exceptions can either be Promises of pending results or real errors
    const deps = unwrapDependencies(dependencies);
    const [results, exceptions] = concurrentRequests(get, deps); // If all results are available, return the results

    if (exceptions.every(exp => !Recoil_isPromise(exp))) {
      return wrapLoadables(dependencies, results, exceptions);
    } // Wait for all results to settle


    return Promise.all(exceptions.map((exp, i) => Recoil_isPromise(exp) ? exp.then(result => {
      results[i] = result;
      exceptions[i] = undefined;
    }).catch(error => {
      results[i] = undefined;
      exceptions[i] = error;
    }) : null)) // Then wrap them as loadables
    .then(() => wrapLoadables(dependencies, results, exceptions));
  },
  dangerouslyAllowMutability: true
});
const noWait = Recoil_selectorFamily({
  key: '__noWait',
  get: dependency => ({
    get
  }) => {
    try {
      return Recoil_selector.value(loadableWithValue$4(get(dependency)));
    } catch (exception) {
      return Recoil_selector.value(Recoil_isPromise(exception) ? loadableWithPromise$3(exception) : loadableWithError$3(exception));
    }
  },
  dangerouslyAllowMutability: true
});
var Recoil_WaitFor = {
  waitForNone,
  waitForAny,
  waitForAll,
  waitForAllSettled,
  noWait
};

const {
  RecoilLoadable
} = Recoil_Loadable$1;

const {
  DefaultValue: DefaultValue$3
} = Recoil_Node;

const {
  RecoilRoot: RecoilRoot$2,
  useRecoilStoreID: useRecoilStoreID$1
} = Recoil_RecoilRoot;

const {
  isRecoilValue: isRecoilValue$5
} = Recoil_RecoilValue$1;

const {
  retentionZone: retentionZone$1
} = Recoil_RetentionZone;

const {
  freshSnapshot: freshSnapshot$2
} = Recoil_Snapshot$1;

const {
  useRecoilState: useRecoilState$1,
  useRecoilState_TRANSITION_SUPPORT_UNSTABLE: useRecoilState_TRANSITION_SUPPORT_UNSTABLE$1,
  useRecoilStateLoadable: useRecoilStateLoadable$1,
  useRecoilValue: useRecoilValue$1,
  useRecoilValue_TRANSITION_SUPPORT_UNSTABLE: useRecoilValue_TRANSITION_SUPPORT_UNSTABLE$1,
  useRecoilValueLoadable: useRecoilValueLoadable$1,
  useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE: useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE$1,
  useResetRecoilState: useResetRecoilState$1,
  useSetRecoilState: useSetRecoilState$1
} = Recoil_Hooks;

const {
  useGotoRecoilSnapshot: useGotoRecoilSnapshot$1,
  useRecoilSnapshot: useRecoilSnapshot$1,
  useRecoilTransactionObserver: useRecoilTransactionObserver$1
} = Recoil_SnapshotHooks;





const {
  useRecoilCallback: useRecoilCallback$1
} = Recoil_useRecoilCallback;





















const {
  noWait: noWait$1,
  waitForAll: waitForAll$1,
  waitForAllSettled: waitForAllSettled$1,
  waitForAny: waitForAny$1,
  waitForNone: waitForNone$1
} = Recoil_WaitFor;



var Recoil_index = {
  // Types
  DefaultValue: DefaultValue$3,
  isRecoilValue: isRecoilValue$5,
  RecoilLoadable,
  // Global Recoil environment settiongs
  RecoilEnv: Recoil_RecoilEnv,
  // Recoil Root
  RecoilRoot: RecoilRoot$2,
  useRecoilStoreID: useRecoilStoreID$1,
  useRecoilBridgeAcrossReactRoots_UNSTABLE: Recoil_useRecoilBridgeAcrossReactRoots,
  // Atoms/Selectors
  atom: Recoil_atom,
  selector: Recoil_selector,
  // Convenience Atoms/Selectors
  atomFamily: Recoil_atomFamily,
  selectorFamily: Recoil_selectorFamily,
  constSelector: Recoil_constSelector,
  errorSelector: Recoil_errorSelector,
  readOnlySelector: Recoil_readOnlySelector,
  // Concurrency Helpers for Atoms/Selectors
  noWait: noWait$1,
  waitForNone: waitForNone$1,
  waitForAny: waitForAny$1,
  waitForAll: waitForAll$1,
  waitForAllSettled: waitForAllSettled$1,
  // Hooks for Atoms/Selectors
  useRecoilValue: useRecoilValue$1,
  useRecoilValueLoadable: useRecoilValueLoadable$1,
  useRecoilState: useRecoilState$1,
  useRecoilStateLoadable: useRecoilStateLoadable$1,
  useSetRecoilState: useSetRecoilState$1,
  useResetRecoilState: useResetRecoilState$1,
  useGetRecoilValueInfo_UNSTABLE: Recoil_useGetRecoilValueInfo,
  useRecoilRefresher_UNSTABLE: Recoil_useRecoilRefresher,
  useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE: useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE$1,
  useRecoilValue_TRANSITION_SUPPORT_UNSTABLE: useRecoilValue_TRANSITION_SUPPORT_UNSTABLE$1,
  useRecoilState_TRANSITION_SUPPORT_UNSTABLE: useRecoilState_TRANSITION_SUPPORT_UNSTABLE$1,
  // Hooks for complex operations
  useRecoilCallback: useRecoilCallback$1,
  useRecoilTransaction_UNSTABLE: Recoil_useRecoilTransaction,
  // Snapshots
  useGotoRecoilSnapshot: useGotoRecoilSnapshot$1,
  useRecoilSnapshot: useRecoilSnapshot$1,
  useRecoilTransactionObserver_UNSTABLE: useRecoilTransactionObserver$1,
  snapshot_UNSTABLE: freshSnapshot$2,
  // Memory Management
  useRetain: Recoil_useRetain,
  retentionZone: retentionZone$1
};
var Recoil_index_1 = Recoil_index.DefaultValue;
var Recoil_index_2 = Recoil_index.isRecoilValue;
var Recoil_index_3 = Recoil_index.RecoilLoadable;
var Recoil_index_4 = Recoil_index.RecoilEnv;
var Recoil_index_5 = Recoil_index.RecoilRoot;
var Recoil_index_6 = Recoil_index.useRecoilStoreID;
var Recoil_index_7 = Recoil_index.useRecoilBridgeAcrossReactRoots_UNSTABLE;
var Recoil_index_8 = Recoil_index.atom;
var Recoil_index_9 = Recoil_index.selector;
var Recoil_index_10 = Recoil_index.atomFamily;
var Recoil_index_11 = Recoil_index.selectorFamily;
var Recoil_index_12 = Recoil_index.constSelector;
var Recoil_index_13 = Recoil_index.errorSelector;
var Recoil_index_14 = Recoil_index.readOnlySelector;
var Recoil_index_15 = Recoil_index.noWait;
var Recoil_index_16 = Recoil_index.waitForNone;
var Recoil_index_17 = Recoil_index.waitForAny;
var Recoil_index_18 = Recoil_index.waitForAll;
var Recoil_index_19 = Recoil_index.waitForAllSettled;
var Recoil_index_20 = Recoil_index.useRecoilValue;
var Recoil_index_21 = Recoil_index.useRecoilValueLoadable;
var Recoil_index_22 = Recoil_index.useRecoilState;
var Recoil_index_23 = Recoil_index.useRecoilStateLoadable;
var Recoil_index_24 = Recoil_index.useSetRecoilState;
var Recoil_index_25 = Recoil_index.useResetRecoilState;
var Recoil_index_26 = Recoil_index.useGetRecoilValueInfo_UNSTABLE;
var Recoil_index_27 = Recoil_index.useRecoilRefresher_UNSTABLE;
var Recoil_index_28 = Recoil_index.useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE;
var Recoil_index_29 = Recoil_index.useRecoilValue_TRANSITION_SUPPORT_UNSTABLE;
var Recoil_index_30 = Recoil_index.useRecoilState_TRANSITION_SUPPORT_UNSTABLE;
var Recoil_index_31 = Recoil_index.useRecoilCallback;
var Recoil_index_32 = Recoil_index.useRecoilTransaction_UNSTABLE;
var Recoil_index_33 = Recoil_index.useGotoRecoilSnapshot;
var Recoil_index_34 = Recoil_index.useRecoilSnapshot;
var Recoil_index_35 = Recoil_index.useRecoilTransactionObserver_UNSTABLE;
var Recoil_index_36 = Recoil_index.snapshot_UNSTABLE;
var Recoil_index_37 = Recoil_index.useRetain;
var Recoil_index_38 = Recoil_index.retentionZone;

/* harmony default export */ __webpack_exports__["default"] = (Recoil_index);



/***/ }),

/***/ 48411:
/***/ (function(module) {

(function (global, factory) {
   true ? module.exports = factory() :
  0;
}(this, (function () { 'use strict';

  /**
   * @file This is a SHA-1 hash generator by JavaScript.
   * @author Hsun
   * @description For your convenience, the code comments have been translated by Google.
   ***/

  // 消息填充位，补足长度。
  // Message padding bits, complement the length.
  function fillString(str) {
    var blockAmount = ((str.length + 8) >> 6) + 1,
      blocks = [],
      i;

    for (i = 0; i < blockAmount * 16; i++) {
      blocks[i] = 0;
    }
    for (i = 0; i < str.length; i++) {
      blocks[i >> 2] |= str.charCodeAt(i) << (24 - (i & 3) * 8);
    }
    blocks[i >> 2] |= 0x80 << (24 - (i & 3) * 8);
    blocks[blockAmount * 16 - 1] = str.length * 8;

    return blocks;
  }

  // 将输入的二进制数组转化为十六进制的字符串。
  // Convert the input binary array to a hexadecimal string.
  function binToHex(binArray) {
    var hexString = "0123456789abcdef",
      str = "",
      i;

    for (i = 0; i < binArray.length * 4; i++) {
      str += hexString.charAt((binArray[i >> 2] >> ((3 - i % 4) * 8 + 4)) & 0xF) +
        hexString.charAt((binArray[i >> 2] >> ((3 - i % 4) * 8)) & 0xF);
    }

    return str;
  }

  // 核心函数，输出为长度为5的number数组，对应160位的消息摘要。
  // The core function, the output is a number array with a length of 5,
  // corresponding to a 160-bit message digest.
  function core(blockArray) {
    var w = [],
      a = 0x67452301,
      b = 0xEFCDAB89,
      c = 0x98BADCFE,
      d = 0x10325476,
      e = 0xC3D2E1F0,
      olda,
      oldb,
      oldc,
      oldd,
      olde,
      t,
      i,
      j;

    for (i = 0; i < blockArray.length; i += 16) {  //每次处理512位 16*32
      olda = a;
      oldb = b;
      oldc = c;
      oldd = d;
      olde = e;

      for (j = 0; j < 80; j++) {  //对每个512位进行80步操作
        if (j < 16) {
          w[j] = blockArray[i + j];
        } else {
          w[j] = cyclicShift(w[j - 3] ^ w[j - 8] ^ w[j - 14] ^ w[j - 16], 1);
        }
        t = modPlus(modPlus(cyclicShift(a, 5), ft(j, b, c, d)), modPlus(modPlus(e, w[j]), kt(j)));
        e = d;
        d = c;
        c = cyclicShift(b, 30);
        b = a;
        a = t;
      }

      a = modPlus(a, olda);
      b = modPlus(b, oldb);
      c = modPlus(c, oldc);
      d = modPlus(d, oldd);
      e = modPlus(e, olde);
    }

    return [a, b, c, d, e];
  }

  // 根据t值返回相应得压缩函数中用到的f函数。
  // According to the t value, return the corresponding f function used in
  // the compression function.
  function ft(t, b, c, d) {
    if (t < 20) {
      return (b & c) | ((~b) & d);
    } else if (t < 40) {
      return b ^ c ^ d;
    } else if (t < 60) {
      return (b & c) | (b & d) | (c & d);
    } else {
      return b ^ c ^ d;
    }
  }

  // 根据t值返回相应得压缩函数中用到的K值。
  // According to the t value, return the corresponding K value used in
  // the compression function.
  function kt(t) {
    return (t < 20) ? 0x5A827999 :
      (t < 40) ? 0x6ED9EBA1 :
        (t < 60) ? 0x8F1BBCDC : 0xCA62C1D6;
  }

  // 模2的32次方加法，因为JavaScript的number是双精度浮点数表示，所以将32位数拆成高16位和低16位分别进行相加
  // Modulo 2 to the 32nd power addition, because JavaScript's number is a
  // double-precision floating-point number, so the 32-bit number is split
  // into the upper 16 bits and the lower 16 bits are added separately.
  function modPlus(x, y) {
    var low = (x & 0xFFFF) + (y & 0xFFFF),
      high = (x >> 16) + (y >> 16) + (low >> 16);

    return (high << 16) | (low & 0xFFFF);
  }

  // 对输入的32位的num二进制数进行循环左移 ,因为JavaScript的number是双精度浮点数表示，所以移位需需要注意
  // Rotate left of the input 32-bit num binary number, because JavaScript's
  // number is a double-precision floating-point number, so you need to pay
  //  attention to the shift.
  function cyclicShift(num, k) {
    return (num << k) | (num >>> (32 - k));
  }

  // 主函数根据输入的消息字符串计算消息摘要，返回十六进制表示的消息摘要
  // The main function calculates the message digest based on the input message
  // string and returns the message digest in hexadecimal.
  function sha1(s) {
    return binToHex(core(fillString(s)));
  }

  return sha1;

})));


/***/ }),

/***/ 95469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jj": function() { return /* binding */ getWindow; },
/* harmony export */   "Me": function() { return /* binding */ getDocument; }
/* harmony export */ });
/* unused harmony exports extend, ssrDocument, ssrWindow */
/**
 * SSR Window 3.0.0
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2020, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: November 9, 2020
 */
/* eslint-disable no-param-reassign */
function isObject(obj) {
    return (obj !== null &&
        typeof obj === 'object' &&
        'constructor' in obj &&
        obj.constructor === Object);
}
function extend(target, src) {
    if (target === void 0) { target = {}; }
    if (src === void 0) { src = {}; }
    Object.keys(src).forEach(function (key) {
        if (typeof target[key] === 'undefined')
            target[key] = src[key];
        else if (isObject(src[key]) &&
            isObject(target[key]) &&
            Object.keys(src[key]).length > 0) {
            extend(target[key], src[key]);
        }
    });
}

var ssrDocument = {
    body: {},
    addEventListener: function () { },
    removeEventListener: function () { },
    activeElement: {
        blur: function () { },
        nodeName: '',
    },
    querySelector: function () {
        return null;
    },
    querySelectorAll: function () {
        return [];
    },
    getElementById: function () {
        return null;
    },
    createEvent: function () {
        return {
            initEvent: function () { },
        };
    },
    createElement: function () {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute: function () { },
            getElementsByTagName: function () {
                return [];
            },
        };
    },
    createElementNS: function () {
        return {};
    },
    importNode: function () {
        return null;
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: '',
    },
};
function getDocument() {
    var doc = typeof document !== 'undefined' ? document : {};
    extend(doc, ssrDocument);
    return doc;
}

var ssrWindow = {
    document: ssrDocument,
    navigator: {
        userAgent: '',
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: '',
    },
    history: {
        replaceState: function () { },
        pushState: function () { },
        go: function () { },
        back: function () { },
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener: function () { },
    removeEventListener: function () { },
    getComputedStyle: function () {
        return {
            getPropertyValue: function () {
                return '';
            },
        };
    },
    Image: function () { },
    Date: function () { },
    screen: {},
    setTimeout: function () { },
    clearTimeout: function () { },
    matchMedia: function () {
        return {};
    },
    requestAnimationFrame: function (callback) {
        if (typeof setTimeout === 'undefined') {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame: function (id) {
        if (typeof setTimeout === 'undefined') {
            return;
        }
        clearTimeout(id);
    },
};
function getWindow() {
    var win = typeof window !== 'undefined' ? window : {};
    extend(win, ssrWindow);
    return win;
}




/***/ }),

/***/ 15753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _utils_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69680);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89617);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var A11y = {
  getRandomNumber: function getRandomNumber(size) {
    if (size === void 0) {
      size = 16;
    }

    var randomChar = function randomChar() {
      return Math.round(16 * Math.random()).toString(16);
    };

    return 'x'.repeat(size).replace(/x/g, randomChar);
  },
  makeElFocusable: function makeElFocusable($el) {
    $el.attr('tabIndex', '0');
    return $el;
  },
  makeElNotFocusable: function makeElNotFocusable($el) {
    $el.attr('tabIndex', '-1');
    return $el;
  },
  addElRole: function addElRole($el, role) {
    $el.attr('role', role);
    return $el;
  },
  addElRoleDescription: function addElRoleDescription($el, description) {
    $el.attr('aria-roledescription', description);
    return $el;
  },
  addElControls: function addElControls($el, controls) {
    $el.attr('aria-controls', controls);
    return $el;
  },
  addElLabel: function addElLabel($el, label) {
    $el.attr('aria-label', label);
    return $el;
  },
  addElId: function addElId($el, id) {
    $el.attr('id', id);
    return $el;
  },
  addElLive: function addElLive($el, live) {
    $el.attr('aria-live', live);
    return $el;
  },
  disableEl: function disableEl($el) {
    $el.attr('aria-disabled', true);
    return $el;
  },
  enableEl: function enableEl($el) {
    $el.attr('aria-disabled', false);
    return $el;
  },
  onEnterOrSpaceKey: function onEnterOrSpaceKey(e) {
    if (e.keyCode !== 13 && e.keyCode !== 32) return;
    var swiper = this;
    var params = swiper.params.a11y;
    var $targetEl = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(e.target);

    if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
      if (!(swiper.isEnd && !swiper.params.loop)) {
        swiper.slideNext();
      }

      if (swiper.isEnd) {
        swiper.a11y.notify(params.lastSlideMessage);
      } else {
        swiper.a11y.notify(params.nextSlideMessage);
      }
    }

    if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
      if (!(swiper.isBeginning && !swiper.params.loop)) {
        swiper.slidePrev();
      }

      if (swiper.isBeginning) {
        swiper.a11y.notify(params.firstSlideMessage);
      } else {
        swiper.a11y.notify(params.prevSlideMessage);
      }
    }

    if (swiper.pagination && $targetEl.is((0,_utils_utils__WEBPACK_IMPORTED_MODULE_1__/* .classesToSelector */ .Wc)(swiper.params.pagination.bulletClass))) {
      $targetEl[0].click();
    }
  },
  notify: function notify(message) {
    var swiper = this;
    var notification = swiper.a11y.liveRegion;
    if (notification.length === 0) return;
    notification.html('');
    notification.html(message);
  },
  updateNavigation: function updateNavigation() {
    var swiper = this;
    if (swiper.params.loop || !swiper.navigation) return;
    var _swiper$navigation = swiper.navigation,
        $nextEl = _swiper$navigation.$nextEl,
        $prevEl = _swiper$navigation.$prevEl;

    if ($prevEl && $prevEl.length > 0) {
      if (swiper.isBeginning) {
        swiper.a11y.disableEl($prevEl);
        swiper.a11y.makeElNotFocusable($prevEl);
      } else {
        swiper.a11y.enableEl($prevEl);
        swiper.a11y.makeElFocusable($prevEl);
      }
    }

    if ($nextEl && $nextEl.length > 0) {
      if (swiper.isEnd) {
        swiper.a11y.disableEl($nextEl);
        swiper.a11y.makeElNotFocusable($nextEl);
      } else {
        swiper.a11y.enableEl($nextEl);
        swiper.a11y.makeElFocusable($nextEl);
      }
    }
  },
  updatePagination: function updatePagination() {
    var swiper = this;
    var params = swiper.params.a11y;

    if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
      swiper.pagination.bullets.each(function (bulletEl) {
        var $bulletEl = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(bulletEl);
        swiper.a11y.makeElFocusable($bulletEl);

        if (!swiper.params.pagination.renderBullet) {
          swiper.a11y.addElRole($bulletEl, 'button');
          swiper.a11y.addElLabel($bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, $bulletEl.index() + 1));
        }
      });
    }
  },
  init: function init() {
    var swiper = this;
    var params = swiper.params.a11y;
    swiper.$el.append(swiper.a11y.liveRegion); // Container

    var $containerEl = swiper.$el;

    if (params.containerRoleDescriptionMessage) {
      swiper.a11y.addElRoleDescription($containerEl, params.containerRoleDescriptionMessage);
    }

    if (params.containerMessage) {
      swiper.a11y.addElLabel($containerEl, params.containerMessage);
    } // Wrapper


    var $wrapperEl = swiper.$wrapperEl;
    var wrapperId = $wrapperEl.attr('id') || "swiper-wrapper-" + swiper.a11y.getRandomNumber(16);
    var live = swiper.params.autoplay && swiper.params.autoplay.enabled ? 'off' : 'polite';
    swiper.a11y.addElId($wrapperEl, wrapperId);
    swiper.a11y.addElLive($wrapperEl, live); // Slide

    if (params.itemRoleDescriptionMessage) {
      swiper.a11y.addElRoleDescription((0,_utils_dom__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(swiper.slides), params.itemRoleDescriptionMessage);
    }

    swiper.a11y.addElRole((0,_utils_dom__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(swiper.slides), params.slideRole);
    var slidesLength = swiper.params.loop ? swiper.slides.filter(function (el) {
      return !el.classList.contains(swiper.params.slideDuplicateClass);
    }).length : swiper.slides.length;
    swiper.slides.each(function (slideEl, index) {
      var $slideEl = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(slideEl);
      var slideIndex = swiper.params.loop ? parseInt($slideEl.attr('data-swiper-slide-index'), 10) : index;
      var ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
      swiper.a11y.addElLabel($slideEl, ariaLabelMessage);
    }); // Navigation

    var $nextEl;
    var $prevEl;

    if (swiper.navigation && swiper.navigation.$nextEl) {
      $nextEl = swiper.navigation.$nextEl;
    }

    if (swiper.navigation && swiper.navigation.$prevEl) {
      $prevEl = swiper.navigation.$prevEl;
    }

    if ($nextEl && $nextEl.length) {
      swiper.a11y.makeElFocusable($nextEl);

      if ($nextEl[0].tagName !== 'BUTTON') {
        swiper.a11y.addElRole($nextEl, 'button');
        $nextEl.on('keydown', swiper.a11y.onEnterOrSpaceKey);
      }

      swiper.a11y.addElLabel($nextEl, params.nextSlideMessage);
      swiper.a11y.addElControls($nextEl, wrapperId);
    }

    if ($prevEl && $prevEl.length) {
      swiper.a11y.makeElFocusable($prevEl);

      if ($prevEl[0].tagName !== 'BUTTON') {
        swiper.a11y.addElRole($prevEl, 'button');
        $prevEl.on('keydown', swiper.a11y.onEnterOrSpaceKey);
      }

      swiper.a11y.addElLabel($prevEl, params.prevSlideMessage);
      swiper.a11y.addElControls($prevEl, wrapperId);
    } // Pagination


    if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
      swiper.pagination.$el.on('keydown', (0,_utils_utils__WEBPACK_IMPORTED_MODULE_1__/* .classesToSelector */ .Wc)(swiper.params.pagination.bulletClass), swiper.a11y.onEnterOrSpaceKey);
    }
  },
  destroy: function destroy() {
    var swiper = this;
    if (swiper.a11y.liveRegion && swiper.a11y.liveRegion.length > 0) swiper.a11y.liveRegion.remove();
    var $nextEl;
    var $prevEl;

    if (swiper.navigation && swiper.navigation.$nextEl) {
      $nextEl = swiper.navigation.$nextEl;
    }

    if (swiper.navigation && swiper.navigation.$prevEl) {
      $prevEl = swiper.navigation.$prevEl;
    }

    if ($nextEl) {
      $nextEl.off('keydown', swiper.a11y.onEnterOrSpaceKey);
    }

    if ($prevEl) {
      $prevEl.off('keydown', swiper.a11y.onEnterOrSpaceKey);
    } // Pagination


    if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
      swiper.pagination.$el.off('keydown', (0,_utils_utils__WEBPACK_IMPORTED_MODULE_1__/* .classesToSelector */ .Wc)(swiper.params.pagination.bulletClass), swiper.a11y.onEnterOrSpaceKey);
    }
  }
};
/* harmony default export */ __webpack_exports__["Z"] = ({
  name: 'a11y',
  params: {
    a11y: {
      enabled: true,
      notificationClass: 'swiper-notification',
      prevSlideMessage: 'Previous slide',
      nextSlideMessage: 'Next slide',
      firstSlideMessage: 'This is the first slide',
      lastSlideMessage: 'This is the last slide',
      paginationBulletMessage: 'Go to slide {{index}}',
      slideLabelMessage: '{{index}} / {{slidesLength}}',
      containerMessage: null,
      containerRoleDescriptionMessage: null,
      itemRoleDescriptionMessage: null,
      slideRole: 'group'
    }
  },
  create: function create() {
    var swiper = this;
    (0,_utils_utils__WEBPACK_IMPORTED_MODULE_1__/* .bindModuleMethods */ .cR)(swiper, {
      a11y: _extends({}, A11y, {
        liveRegion: (0,_utils_dom__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("<span class=\"" + swiper.params.a11y.notificationClass + "\" aria-live=\"assertive\" aria-atomic=\"true\"></span>")
      })
    });
  },
  on: {
    afterInit: function afterInit(swiper) {
      if (!swiper.params.a11y.enabled) return;
      swiper.a11y.init();
      swiper.a11y.updateNavigation();
    },
    toEdge: function toEdge(swiper) {
      if (!swiper.params.a11y.enabled) return;
      swiper.a11y.updateNavigation();
    },
    fromEdge: function fromEdge(swiper) {
      if (!swiper.params.a11y.enabled) return;
      swiper.a11y.updateNavigation();
    },
    paginationUpdate: function paginationUpdate(swiper) {
      if (!swiper.params.a11y.enabled) return;
      swiper.a11y.updatePagination();
    },
    destroy: function destroy(swiper) {
      if (!swiper.params.a11y.enabled) return;
      swiper.a11y.destroy();
    }
  }
});

/***/ }),

/***/ 77796:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ core_class; }
});

// EXTERNAL MODULE: ../node_modules/ssr-window/ssr-window.esm.js
var ssr_window_esm = __webpack_require__(95469);
// EXTERNAL MODULE: ../node_modules/swiper/esm/utils/dom.js + 1 modules
var dom = __webpack_require__(69680);
// EXTERNAL MODULE: ../node_modules/swiper/esm/utils/utils.js
var utils = __webpack_require__(89617);
;// CONCATENATED MODULE: ../node_modules/swiper/esm/utils/get-support.js

var support;

function calcSupport() {
  var window = (0,ssr_window_esm/* getWindow */.Jj)();
  var document = (0,ssr_window_esm/* getDocument */.Me)();
  return {
    touch: !!('ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch),
    pointerEvents: !!window.PointerEvent && 'maxTouchPoints' in window.navigator && window.navigator.maxTouchPoints >= 0,
    observer: function checkObserver() {
      return 'MutationObserver' in window || 'WebkitMutationObserver' in window;
    }(),
    passiveListener: function checkPassiveListener() {
      var supportsPassive = false;

      try {
        var opts = Object.defineProperty({}, 'passive', {
          // eslint-disable-next-line
          get: function get() {
            supportsPassive = true;
          }
        });
        window.addEventListener('testPassiveListener', null, opts);
      } catch (e) {// No support
      }

      return supportsPassive;
    }(),
    gestures: function checkGestures() {
      return 'ongesturestart' in window;
    }()
  };
}

function getSupport() {
  if (!support) {
    support = calcSupport();
  }

  return support;
}


;// CONCATENATED MODULE: ../node_modules/swiper/esm/utils/get-device.js


var device;

function calcDevice(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      userAgent = _ref.userAgent;

  var support = getSupport();
  var window = (0,ssr_window_esm/* getWindow */.Jj)();
  var platform = window.navigator.platform;
  var ua = userAgent || window.navigator.userAgent;
  var device = {
    ios: false,
    android: false
  };
  var screenWidth = window.screen.width;
  var screenHeight = window.screen.height;
  var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line

  var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
  var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
  var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
  var windows = platform === 'Win32';
  var macos = platform === 'MacIntel'; // iPadOs 13 fix

  var iPadScreens = ['1024x1366', '1366x1024', '834x1194', '1194x834', '834x1112', '1112x834', '768x1024', '1024x768', '820x1180', '1180x820', '810x1080', '1080x810'];

  if (!ipad && macos && support.touch && iPadScreens.indexOf(screenWidth + "x" + screenHeight) >= 0) {
    ipad = ua.match(/(Version)\/([\d.]+)/);
    if (!ipad) ipad = [0, 1, '13_0_0'];
    macos = false;
  } // Android


  if (android && !windows) {
    device.os = 'android';
    device.android = true;
  }

  if (ipad || iphone || ipod) {
    device.os = 'ios';
    device.ios = true;
  } // Export object


  return device;
}

function getDevice(overrides) {
  if (overrides === void 0) {
    overrides = {};
  }

  if (!device) {
    device = calcDevice(overrides);
  }

  return device;
}


;// CONCATENATED MODULE: ../node_modules/swiper/esm/utils/get-browser.js

var browser;

function calcBrowser() {
  var window = (0,ssr_window_esm/* getWindow */.Jj)();

  function isSafari() {
    var ua = window.navigator.userAgent.toLowerCase();
    return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
  }

  return {
    isEdge: !!window.navigator.userAgent.match(/Edge/g),
    isSafari: isSafari(),
    isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent)
  };
}

function getBrowser() {
  if (!browser) {
    browser = calcBrowser();
  }

  return browser;
}


;// CONCATENATED MODULE: ../node_modules/swiper/esm/modules/resize/resize.js



var supportsResizeObserver = function supportsResizeObserver() {
  var window = (0,ssr_window_esm/* getWindow */.Jj)();
  return typeof window.ResizeObserver !== 'undefined';
};

/* harmony default export */ var resize = ({
  name: 'resize',
  create: function create() {
    var swiper = this;
    (0,utils/* extend */.l7)(swiper, {
      resize: {
        observer: null,
        createObserver: function createObserver() {
          if (!swiper || swiper.destroyed || !swiper.initialized) return;
          swiper.resize.observer = new ResizeObserver(function (entries) {
            var width = swiper.width,
                height = swiper.height;
            var newWidth = width;
            var newHeight = height;
            entries.forEach(function (_ref) {
              var contentBoxSize = _ref.contentBoxSize,
                  contentRect = _ref.contentRect,
                  target = _ref.target;
              if (target && target !== swiper.el) return;
              newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
              newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
            });

            if (newWidth !== width || newHeight !== height) {
              swiper.resize.resizeHandler();
            }
          });
          swiper.resize.observer.observe(swiper.el);
        },
        removeObserver: function removeObserver() {
          if (swiper.resize.observer && swiper.resize.observer.unobserve && swiper.el) {
            swiper.resize.observer.unobserve(swiper.el);
            swiper.resize.observer = null;
          }
        },
        resizeHandler: function resizeHandler() {
          if (!swiper || swiper.destroyed || !swiper.initialized) return;
          swiper.emit('beforeResize');
          swiper.emit('resize');
        },
        orientationChangeHandler: function orientationChangeHandler() {
          if (!swiper || swiper.destroyed || !swiper.initialized) return;
          swiper.emit('orientationchange');
        }
      }
    });
  },
  on: {
    init: function init(swiper) {
      var window = (0,ssr_window_esm/* getWindow */.Jj)();

      if (swiper.params.resizeObserver && supportsResizeObserver()) {
        swiper.resize.createObserver();
        return;
      } // Emit resize


      window.addEventListener('resize', swiper.resize.resizeHandler); // Emit orientationchange

      window.addEventListener('orientationchange', swiper.resize.orientationChangeHandler);
    },
    destroy: function destroy(swiper) {
      var window = (0,ssr_window_esm/* getWindow */.Jj)();
      swiper.resize.removeObserver();
      window.removeEventListener('resize', swiper.resize.resizeHandler);
      window.removeEventListener('orientationchange', swiper.resize.orientationChangeHandler);
    }
  }
});
;// CONCATENATED MODULE: ../node_modules/swiper/esm/modules/observer/observer.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var Observer = {
  attach: function attach(target, options) {
    if (options === void 0) {
      options = {};
    }

    var window = (0,ssr_window_esm/* getWindow */.Jj)();
    var swiper = this;
    var ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
    var observer = new ObserverFunc(function (mutations) {
      // The observerUpdate event should only be triggered
      // once despite the number of mutations.  Additional
      // triggers are redundant and are very costly
      if (mutations.length === 1) {
        swiper.emit('observerUpdate', mutations[0]);
        return;
      }

      var observerUpdate = function observerUpdate() {
        swiper.emit('observerUpdate', mutations[0]);
      };

      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(observerUpdate);
      } else {
        window.setTimeout(observerUpdate, 0);
      }
    });
    observer.observe(target, {
      attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
      childList: typeof options.childList === 'undefined' ? true : options.childList,
      characterData: typeof options.characterData === 'undefined' ? true : options.characterData
    });
    swiper.observer.observers.push(observer);
  },
  init: function init() {
    var swiper = this;
    if (!swiper.support.observer || !swiper.params.observer) return;

    if (swiper.params.observeParents) {
      var containerParents = swiper.$el.parents();

      for (var i = 0; i < containerParents.length; i += 1) {
        swiper.observer.attach(containerParents[i]);
      }
    } // Observe container


    swiper.observer.attach(swiper.$el[0], {
      childList: swiper.params.observeSlideChildren
    }); // Observe wrapper

    swiper.observer.attach(swiper.$wrapperEl[0], {
      attributes: false
    });
  },
  destroy: function destroy() {
    var swiper = this;
    swiper.observer.observers.forEach(function (observer) {
      observer.disconnect();
    });
    swiper.observer.observers = [];
  }
};
/* harmony default export */ var observer = ({
  name: 'observer',
  params: {
    observer: false,
    observeParents: false,
    observeSlideChildren: false
  },
  create: function create() {
    var swiper = this;
    (0,utils/* bindModuleMethods */.cR)(swiper, {
      observer: _extends({}, Observer, {
        observers: []
      })
    });
  },
  on: {
    init: function init(swiper) {
      swiper.observer.init();
    },
    destroy: function destroy(swiper) {
      swiper.observer.destroy();
    }
  }
});
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/modular.js

/* harmony default export */ var modular = ({
  useParams: function useParams(instanceParams) {
    var instance = this;
    if (!instance.modules) return;
    Object.keys(instance.modules).forEach(function (moduleName) {
      var module = instance.modules[moduleName]; // Extend params

      if (module.params) {
        (0,utils/* extend */.l7)(instanceParams, module.params);
      }
    });
  },
  useModules: function useModules(modulesParams) {
    if (modulesParams === void 0) {
      modulesParams = {};
    }

    var instance = this;
    if (!instance.modules) return;
    Object.keys(instance.modules).forEach(function (moduleName) {
      var module = instance.modules[moduleName];
      var moduleParams = modulesParams[moduleName] || {}; // Add event listeners

      if (module.on && instance.on) {
        Object.keys(module.on).forEach(function (moduleEventName) {
          instance.on(moduleEventName, module.on[moduleEventName]);
        });
      } // Module create callback


      if (module.create) {
        module.create.bind(instance)(moduleParams);
      }
    });
  }
});
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/events-emitter.js
/* eslint-disable no-underscore-dangle */
/* harmony default export */ var events_emitter = ({
  on: function on(events, handler, priority) {
    var self = this;
    if (typeof handler !== 'function') return self;
    var method = priority ? 'unshift' : 'push';
    events.split(' ').forEach(function (event) {
      if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
      self.eventsListeners[event][method](handler);
    });
    return self;
  },
  once: function once(events, handler, priority) {
    var self = this;
    if (typeof handler !== 'function') return self;

    function onceHandler() {
      self.off(events, onceHandler);

      if (onceHandler.__emitterProxy) {
        delete onceHandler.__emitterProxy;
      }

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      handler.apply(self, args);
    }

    onceHandler.__emitterProxy = handler;
    return self.on(events, onceHandler, priority);
  },
  onAny: function onAny(handler, priority) {
    var self = this;
    if (typeof handler !== 'function') return self;
    var method = priority ? 'unshift' : 'push';

    if (self.eventsAnyListeners.indexOf(handler) < 0) {
      self.eventsAnyListeners[method](handler);
    }

    return self;
  },
  offAny: function offAny(handler) {
    var self = this;
    if (!self.eventsAnyListeners) return self;
    var index = self.eventsAnyListeners.indexOf(handler);

    if (index >= 0) {
      self.eventsAnyListeners.splice(index, 1);
    }

    return self;
  },
  off: function off(events, handler) {
    var self = this;
    if (!self.eventsListeners) return self;
    events.split(' ').forEach(function (event) {
      if (typeof handler === 'undefined') {
        self.eventsListeners[event] = [];
      } else if (self.eventsListeners[event]) {
        self.eventsListeners[event].forEach(function (eventHandler, index) {
          if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) {
            self.eventsListeners[event].splice(index, 1);
          }
        });
      }
    });
    return self;
  },
  emit: function emit() {
    var self = this;
    if (!self.eventsListeners) return self;
    var events;
    var data;
    var context;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    if (typeof args[0] === 'string' || Array.isArray(args[0])) {
      events = args[0];
      data = args.slice(1, args.length);
      context = self;
    } else {
      events = args[0].events;
      data = args[0].data;
      context = args[0].context || self;
    }

    data.unshift(context);
    var eventsArray = Array.isArray(events) ? events : events.split(' ');
    eventsArray.forEach(function (event) {
      if (self.eventsAnyListeners && self.eventsAnyListeners.length) {
        self.eventsAnyListeners.forEach(function (eventHandler) {
          eventHandler.apply(context, [event].concat(data));
        });
      }

      if (self.eventsListeners && self.eventsListeners[event]) {
        self.eventsListeners[event].forEach(function (eventHandler) {
          eventHandler.apply(context, data);
        });
      }
    });
    return self;
  }
});
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/update/updateSize.js

function updateSize() {
  var swiper = this;
  var width;
  var height;
  var $el = swiper.$el;

  if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) {
    width = swiper.params.width;
  } else {
    width = $el[0].clientWidth;
  }

  if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) {
    height = swiper.params.height;
  } else {
    height = $el[0].clientHeight;
  }

  if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) {
    return;
  } // Subtract paddings


  width = width - parseInt($el.css('padding-left') || 0, 10) - parseInt($el.css('padding-right') || 0, 10);
  height = height - parseInt($el.css('padding-top') || 0, 10) - parseInt($el.css('padding-bottom') || 0, 10);
  if (Number.isNaN(width)) width = 0;
  if (Number.isNaN(height)) height = 0;
  (0,utils/* extend */.l7)(swiper, {
    width: width,
    height: height,
    size: swiper.isHorizontal() ? width : height
  });
}
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/update/updateSlides.js

function updateSlides() {
  var swiper = this;

  function getDirectionLabel(property) {
    if (swiper.isHorizontal()) {
      return property;
    } // prettier-ignore


    return {
      'width': 'height',
      'margin-top': 'margin-left',
      'margin-bottom ': 'margin-right',
      'margin-left': 'margin-top',
      'margin-right': 'margin-bottom',
      'padding-left': 'padding-top',
      'padding-right': 'padding-bottom',
      'marginRight': 'marginBottom'
    }[property];
  }

  function getDirectionPropertyValue(node, label) {
    return parseFloat(node.getPropertyValue(getDirectionLabel(label)) || 0);
  }

  var params = swiper.params;
  var $wrapperEl = swiper.$wrapperEl,
      swiperSize = swiper.size,
      rtl = swiper.rtlTranslate,
      wrongRTL = swiper.wrongRTL;
  var isVirtual = swiper.virtual && params.virtual.enabled;
  var previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
  var slides = $wrapperEl.children("." + swiper.params.slideClass);
  var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
  var snapGrid = [];
  var slidesGrid = [];
  var slidesSizesGrid = [];
  var offsetBefore = params.slidesOffsetBefore;

  if (typeof offsetBefore === 'function') {
    offsetBefore = params.slidesOffsetBefore.call(swiper);
  }

  var offsetAfter = params.slidesOffsetAfter;

  if (typeof offsetAfter === 'function') {
    offsetAfter = params.slidesOffsetAfter.call(swiper);
  }

  var previousSnapGridLength = swiper.snapGrid.length;
  var previousSlidesGridLength = swiper.slidesGrid.length;
  var spaceBetween = params.spaceBetween;
  var slidePosition = -offsetBefore;
  var prevSlideSize = 0;
  var index = 0;

  if (typeof swiperSize === 'undefined') {
    return;
  }

  if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
    spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
  }

  swiper.virtualSize = -spaceBetween; // reset margins

  if (rtl) slides.css({
    marginLeft: '',
    marginBottom: '',
    marginTop: ''
  });else slides.css({
    marginRight: '',
    marginBottom: '',
    marginTop: ''
  });
  var slidesNumberEvenToRows;

  if (params.slidesPerColumn > 1) {
    if (Math.floor(slidesLength / params.slidesPerColumn) === slidesLength / swiper.params.slidesPerColumn) {
      slidesNumberEvenToRows = slidesLength;
    } else {
      slidesNumberEvenToRows = Math.ceil(slidesLength / params.slidesPerColumn) * params.slidesPerColumn;
    }

    if (params.slidesPerView !== 'auto' && params.slidesPerColumnFill === 'row') {
      slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, params.slidesPerView * params.slidesPerColumn);
    }
  } // Calc slides


  var slideSize;
  var slidesPerColumn = params.slidesPerColumn;
  var slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
  var numFullColumns = Math.floor(slidesLength / params.slidesPerColumn);

  for (var i = 0; i < slidesLength; i += 1) {
    slideSize = 0;
    var slide = slides.eq(i);

    if (params.slidesPerColumn > 1) {
      // Set slides order
      var newSlideOrderIndex = void 0;
      var column = void 0;
      var row = void 0;

      if (params.slidesPerColumnFill === 'row' && params.slidesPerGroup > 1) {
        var groupIndex = Math.floor(i / (params.slidesPerGroup * params.slidesPerColumn));
        var slideIndexInGroup = i - params.slidesPerColumn * params.slidesPerGroup * groupIndex;
        var columnsInGroup = groupIndex === 0 ? params.slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * slidesPerColumn * params.slidesPerGroup) / slidesPerColumn), params.slidesPerGroup);
        row = Math.floor(slideIndexInGroup / columnsInGroup);
        column = slideIndexInGroup - row * columnsInGroup + groupIndex * params.slidesPerGroup;
        newSlideOrderIndex = column + row * slidesNumberEvenToRows / slidesPerColumn;
        slide.css({
          '-webkit-box-ordinal-group': newSlideOrderIndex,
          '-moz-box-ordinal-group': newSlideOrderIndex,
          '-ms-flex-order': newSlideOrderIndex,
          '-webkit-order': newSlideOrderIndex,
          order: newSlideOrderIndex
        });
      } else if (params.slidesPerColumnFill === 'column') {
        column = Math.floor(i / slidesPerColumn);
        row = i - column * slidesPerColumn;

        if (column > numFullColumns || column === numFullColumns && row === slidesPerColumn - 1) {
          row += 1;

          if (row >= slidesPerColumn) {
            row = 0;
            column += 1;
          }
        }
      } else {
        row = Math.floor(i / slidesPerRow);
        column = i - row * slidesPerRow;
      }

      slide.css(getDirectionLabel('margin-top'), row !== 0 ? params.spaceBetween && params.spaceBetween + "px" : '');
    }

    if (slide.css('display') === 'none') continue; // eslint-disable-line

    if (params.slidesPerView === 'auto') {
      var slideStyles = getComputedStyle(slide[0]);
      var currentTransform = slide[0].style.transform;
      var currentWebKitTransform = slide[0].style.webkitTransform;

      if (currentTransform) {
        slide[0].style.transform = 'none';
      }

      if (currentWebKitTransform) {
        slide[0].style.webkitTransform = 'none';
      }

      if (params.roundLengths) {
        slideSize = swiper.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
      } else {
        // eslint-disable-next-line
        var width = getDirectionPropertyValue(slideStyles, 'width');
        var paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
        var paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
        var marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
        var marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
        var boxSizing = slideStyles.getPropertyValue('box-sizing');

        if (boxSizing && boxSizing === 'border-box') {
          slideSize = width + marginLeft + marginRight;
        } else {
          var _slide$ = slide[0],
              clientWidth = _slide$.clientWidth,
              offsetWidth = _slide$.offsetWidth;
          slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
        }
      }

      if (currentTransform) {
        slide[0].style.transform = currentTransform;
      }

      if (currentWebKitTransform) {
        slide[0].style.webkitTransform = currentWebKitTransform;
      }

      if (params.roundLengths) slideSize = Math.floor(slideSize);
    } else {
      slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
      if (params.roundLengths) slideSize = Math.floor(slideSize);

      if (slides[i]) {
        slides[i].style[getDirectionLabel('width')] = slideSize + "px";
      }
    }

    if (slides[i]) {
      slides[i].swiperSlideSize = slideSize;
    }

    slidesSizesGrid.push(slideSize);

    if (params.centeredSlides) {
      slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
      if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (Math.abs(slidePosition) < 1 / 1000) slidePosition = 0;
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
    } else {
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
      slidePosition = slidePosition + slideSize + spaceBetween;
    }

    swiper.virtualSize += slideSize + spaceBetween;
    prevSlideSize = slideSize;
    index += 1;
  }

  swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
  var newSlidesGrid;

  if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
    $wrapperEl.css({
      width: swiper.virtualSize + params.spaceBetween + "px"
    });
  }

  if (params.setWrapperSize) {
    var _$wrapperEl$css;

    $wrapperEl.css((_$wrapperEl$css = {}, _$wrapperEl$css[getDirectionLabel('width')] = swiper.virtualSize + params.spaceBetween + "px", _$wrapperEl$css));
  }

  if (params.slidesPerColumn > 1) {
    var _$wrapperEl$css2;

    swiper.virtualSize = (slideSize + params.spaceBetween) * slidesNumberEvenToRows;
    swiper.virtualSize = Math.ceil(swiper.virtualSize / params.slidesPerColumn) - params.spaceBetween;
    $wrapperEl.css((_$wrapperEl$css2 = {}, _$wrapperEl$css2[getDirectionLabel('width')] = swiper.virtualSize + params.spaceBetween + "px", _$wrapperEl$css2));

    if (params.centeredSlides) {
      newSlidesGrid = [];

      for (var _i = 0; _i < snapGrid.length; _i += 1) {
        var slidesGridItem = snapGrid[_i];
        if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
        if (snapGrid[_i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
      }

      snapGrid = newSlidesGrid;
    }
  } // Remove last grid elements depending on width


  if (!params.centeredSlides) {
    newSlidesGrid = [];

    for (var _i2 = 0; _i2 < snapGrid.length; _i2 += 1) {
      var _slidesGridItem = snapGrid[_i2];
      if (params.roundLengths) _slidesGridItem = Math.floor(_slidesGridItem);

      if (snapGrid[_i2] <= swiper.virtualSize - swiperSize) {
        newSlidesGrid.push(_slidesGridItem);
      }
    }

    snapGrid = newSlidesGrid;

    if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
      snapGrid.push(swiper.virtualSize - swiperSize);
    }
  }

  if (snapGrid.length === 0) snapGrid = [0];

  if (params.spaceBetween !== 0) {
    var _slides$filter$css;

    var key = swiper.isHorizontal() && rtl ? 'marginLeft' : getDirectionLabel('marginRight');
    slides.filter(function (_, slideIndex) {
      if (!params.cssMode) return true;

      if (slideIndex === slides.length - 1) {
        return false;
      }

      return true;
    }).css((_slides$filter$css = {}, _slides$filter$css[key] = spaceBetween + "px", _slides$filter$css));
  }

  if (params.centeredSlides && params.centeredSlidesBounds) {
    var allSlidesSize = 0;
    slidesSizesGrid.forEach(function (slideSizeValue) {
      allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
    });
    allSlidesSize -= params.spaceBetween;
    var maxSnap = allSlidesSize - swiperSize;
    snapGrid = snapGrid.map(function (snap) {
      if (snap < 0) return -offsetBefore;
      if (snap > maxSnap) return maxSnap + offsetAfter;
      return snap;
    });
  }

  if (params.centerInsufficientSlides) {
    var _allSlidesSize = 0;
    slidesSizesGrid.forEach(function (slideSizeValue) {
      _allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
    });
    _allSlidesSize -= params.spaceBetween;

    if (_allSlidesSize < swiperSize) {
      var allSlidesOffset = (swiperSize - _allSlidesSize) / 2;
      snapGrid.forEach(function (snap, snapIndex) {
        snapGrid[snapIndex] = snap - allSlidesOffset;
      });
      slidesGrid.forEach(function (snap, snapIndex) {
        slidesGrid[snapIndex] = snap + allSlidesOffset;
      });
    }
  }

  (0,utils/* extend */.l7)(swiper, {
    slides: slides,
    snapGrid: snapGrid,
    slidesGrid: slidesGrid,
    slidesSizesGrid: slidesSizesGrid
  });

  if (slidesLength !== previousSlidesLength) {
    swiper.emit('slidesLengthChange');
  }

  if (snapGrid.length !== previousSnapGridLength) {
    if (swiper.params.watchOverflow) swiper.checkOverflow();
    swiper.emit('snapGridLengthChange');
  }

  if (slidesGrid.length !== previousSlidesGridLength) {
    swiper.emit('slidesGridLengthChange');
  }

  if (params.watchSlidesProgress || params.watchSlidesVisibility) {
    swiper.updateSlidesOffset();
  }
}
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/update/updateAutoHeight.js
function updateAutoHeight(speed) {
  var swiper = this;
  var activeSlides = [];
  var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
  var newHeight = 0;
  var i;

  if (typeof speed === 'number') {
    swiper.setTransition(speed);
  } else if (speed === true) {
    swiper.setTransition(swiper.params.speed);
  }

  var getSlideByIndex = function getSlideByIndex(index) {
    if (isVirtual) {
      return swiper.slides.filter(function (el) {
        return parseInt(el.getAttribute('data-swiper-slide-index'), 10) === index;
      })[0];
    }

    return swiper.slides.eq(index)[0];
  }; // Find slides currently in view


  if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
    if (swiper.params.centeredSlides) {
      swiper.visibleSlides.each(function (slide) {
        activeSlides.push(slide);
      });
    } else {
      for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
        var index = swiper.activeIndex + i;
        if (index > swiper.slides.length && !isVirtual) break;
        activeSlides.push(getSlideByIndex(index));
      }
    }
  } else {
    activeSlides.push(getSlideByIndex(swiper.activeIndex));
  } // Find new height from highest slide in view


  for (i = 0; i < activeSlides.length; i += 1) {
    if (typeof activeSlides[i] !== 'undefined') {
      var height = activeSlides[i].offsetHeight;
      newHeight = height > newHeight ? height : newHeight;
    }
  } // Update Height


  if (newHeight) swiper.$wrapperEl.css('height', newHeight + "px");
}
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/update/updateSlidesOffset.js
function updateSlidesOffset() {
  var swiper = this;
  var slides = swiper.slides;

  for (var i = 0; i < slides.length; i += 1) {
    slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
  }
}
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/update/updateSlidesProgress.js

function updateSlidesProgress(translate) {
  if (translate === void 0) {
    translate = this && this.translate || 0;
  }

  var swiper = this;
  var params = swiper.params;
  var slides = swiper.slides,
      rtl = swiper.rtlTranslate;
  if (slides.length === 0) return;
  if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
  var offsetCenter = -translate;
  if (rtl) offsetCenter = translate; // Visible Slides

  slides.removeClass(params.slideVisibleClass);
  swiper.visibleSlidesIndexes = [];
  swiper.visibleSlides = [];

  for (var i = 0; i < slides.length; i += 1) {
    var slide = slides[i];
    var slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slide.swiperSlideOffset) / (slide.swiperSlideSize + params.spaceBetween);

    if (params.watchSlidesVisibility || params.centeredSlides && params.autoHeight) {
      var slideBefore = -(offsetCenter - slide.swiperSlideOffset);
      var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
      var isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;

      if (isVisible) {
        swiper.visibleSlides.push(slide);
        swiper.visibleSlidesIndexes.push(i);
        slides.eq(i).addClass(params.slideVisibleClass);
      }
    }

    slide.progress = rtl ? -slideProgress : slideProgress;
  }

  swiper.visibleSlides = (0,dom/* default */.Z)(swiper.visibleSlides);
}
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/update/updateProgress.js

function updateProgress(translate) {
  var swiper = this;

  if (typeof translate === 'undefined') {
    var multiplier = swiper.rtlTranslate ? -1 : 1; // eslint-disable-next-line

    translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
  }

  var params = swiper.params;
  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  var progress = swiper.progress,
      isBeginning = swiper.isBeginning,
      isEnd = swiper.isEnd;
  var wasBeginning = isBeginning;
  var wasEnd = isEnd;

  if (translatesDiff === 0) {
    progress = 0;
    isBeginning = true;
    isEnd = true;
  } else {
    progress = (translate - swiper.minTranslate()) / translatesDiff;
    isBeginning = progress <= 0;
    isEnd = progress >= 1;
  }

  (0,utils/* extend */.l7)(swiper, {
    progress: progress,
    isBeginning: isBeginning,
    isEnd: isEnd
  });
  if (params.watchSlidesProgress || params.watchSlidesVisibility || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);

  if (isBeginning && !wasBeginning) {
    swiper.emit('reachBeginning toEdge');
  }

  if (isEnd && !wasEnd) {
    swiper.emit('reachEnd toEdge');
  }

  if (wasBeginning && !isBeginning || wasEnd && !isEnd) {
    swiper.emit('fromEdge');
  }

  swiper.emit('progress', progress);
}
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/update/updateSlidesClasses.js
function updateSlidesClasses() {
  var swiper = this;
  var slides = swiper.slides,
      params = swiper.params,
      $wrapperEl = swiper.$wrapperEl,
      activeIndex = swiper.activeIndex,
      realIndex = swiper.realIndex;
  var isVirtual = swiper.virtual && params.virtual.enabled;
  slides.removeClass(params.slideActiveClass + " " + params.slideNextClass + " " + params.slidePrevClass + " " + params.slideDuplicateActiveClass + " " + params.slideDuplicateNextClass + " " + params.slideDuplicatePrevClass);
  var activeSlide;

  if (isVirtual) {
    activeSlide = swiper.$wrapperEl.find("." + params.slideClass + "[data-swiper-slide-index=\"" + activeIndex + "\"]");
  } else {
    activeSlide = slides.eq(activeIndex);
  } // Active classes


  activeSlide.addClass(params.slideActiveClass);

  if (params.loop) {
    // Duplicate to all looped slides
    if (activeSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + realIndex + "\"]").addClass(params.slideDuplicateActiveClass);
    } else {
      $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + realIndex + "\"]").addClass(params.slideDuplicateActiveClass);
    }
  } // Next Slide


  var nextSlide = activeSlide.nextAll("." + params.slideClass).eq(0).addClass(params.slideNextClass);

  if (params.loop && nextSlide.length === 0) {
    nextSlide = slides.eq(0);
    nextSlide.addClass(params.slideNextClass);
  } // Prev Slide


  var prevSlide = activeSlide.prevAll("." + params.slideClass).eq(0).addClass(params.slidePrevClass);

  if (params.loop && prevSlide.length === 0) {
    prevSlide = slides.eq(-1);
    prevSlide.addClass(params.slidePrevClass);
  }

  if (params.loop) {
    // Duplicate to all looped slides
    if (nextSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + nextSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicateNextClass);
    } else {
      $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + nextSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicateNextClass);
    }

    if (prevSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + prevSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicatePrevClass);
    } else {
      $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + prevSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicatePrevClass);
    }
  }

  swiper.emitSlidesClasses();
}
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/update/updateActiveIndex.js

function updateActiveIndex(newActiveIndex) {
  var swiper = this;
  var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  var slidesGrid = swiper.slidesGrid,
      snapGrid = swiper.snapGrid,
      params = swiper.params,
      previousIndex = swiper.activeIndex,
      previousRealIndex = swiper.realIndex,
      previousSnapIndex = swiper.snapIndex;
  var activeIndex = newActiveIndex;
  var snapIndex;

  if (typeof activeIndex === 'undefined') {
    for (var i = 0; i < slidesGrid.length; i += 1) {
      if (typeof slidesGrid[i + 1] !== 'undefined') {
        if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) {
          activeIndex = i;
        } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
          activeIndex = i + 1;
        }
      } else if (translate >= slidesGrid[i]) {
        activeIndex = i;
      }
    } // Normalize slideIndex


    if (params.normalizeSlideIndex) {
      if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
    }
  }

  if (snapGrid.indexOf(translate) >= 0) {
    snapIndex = snapGrid.indexOf(translate);
  } else {
    var skip = Math.min(params.slidesPerGroupSkip, activeIndex);
    snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
  }

  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;

  if (activeIndex === previousIndex) {
    if (snapIndex !== previousSnapIndex) {
      swiper.snapIndex = snapIndex;
      swiper.emit('snapIndexChange');
    }

    return;
  } // Get real index


  var realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);
  (0,utils/* extend */.l7)(swiper, {
    snapIndex: snapIndex,
    realIndex: realIndex,
    previousIndex: previousIndex,
    activeIndex: activeIndex
  });
  swiper.emit('activeIndexChange');
  swiper.emit('snapIndexChange');

  if (previousRealIndex !== realIndex) {
    swiper.emit('realIndexChange');
  }

  if (swiper.initialized || swiper.params.runCallbacksOnInit) {
    swiper.emit('slideChange');
  }
}
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/update/updateClickedSlide.js

function updateClickedSlide(e) {
  var swiper = this;
  var params = swiper.params;
  var slide = (0,dom/* default */.Z)(e.target).closest("." + params.slideClass)[0];
  var slideFound = false;
  var slideIndex;

  if (slide) {
    for (var i = 0; i < swiper.slides.length; i += 1) {
      if (swiper.slides[i] === slide) {
        slideFound = true;
        slideIndex = i;
        break;
      }
    }
  }

  if (slide && slideFound) {
    swiper.clickedSlide = slide;

    if (swiper.virtual && swiper.params.virtual.enabled) {
      swiper.clickedIndex = parseInt((0,dom/* default */.Z)(slide).attr('data-swiper-slide-index'), 10);
    } else {
      swiper.clickedIndex = slideIndex;
    }
  } else {
    swiper.clickedSlide = undefined;
    swiper.clickedIndex = undefined;
    return;
  }

  if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
    swiper.slideToClickedSlide();
  }
}
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/update/index.js









/* harmony default export */ var update = ({
  updateSize: updateSize,
  updateSlides: updateSlides,
  updateAutoHeight: updateAutoHeight,
  updateSlidesOffset: updateSlidesOffset,
  updateSlidesProgress: updateSlidesProgress,
  updateProgress: updateProgress,
  updateSlidesClasses: updateSlidesClasses,
  updateActiveIndex: updateActiveIndex,
  updateClickedSlide: updateClickedSlide
});
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/translate/getTranslate.js

function getSwiperTranslate(axis) {
  if (axis === void 0) {
    axis = this.isHorizontal() ? 'x' : 'y';
  }

  var swiper = this;
  var params = swiper.params,
      rtl = swiper.rtlTranslate,
      translate = swiper.translate,
      $wrapperEl = swiper.$wrapperEl;

  if (params.virtualTranslate) {
    return rtl ? -translate : translate;
  }

  if (params.cssMode) {
    return translate;
  }

  var currentTranslate = (0,utils/* getTranslate */.R6)($wrapperEl[0], axis);
  if (rtl) currentTranslate = -currentTranslate;
  return currentTranslate || 0;
}
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/translate/setTranslate.js
function setTranslate(translate, byController) {
  var swiper = this;
  var rtl = swiper.rtlTranslate,
      params = swiper.params,
      $wrapperEl = swiper.$wrapperEl,
      wrapperEl = swiper.wrapperEl,
      progress = swiper.progress;
  var x = 0;
  var y = 0;
  var z = 0;

  if (swiper.isHorizontal()) {
    x = rtl ? -translate : translate;
  } else {
    y = translate;
  }

  if (params.roundLengths) {
    x = Math.floor(x);
    y = Math.floor(y);
  }

  if (params.cssMode) {
    wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
  } else if (!params.virtualTranslate) {
    $wrapperEl.transform("translate3d(" + x + "px, " + y + "px, " + z + "px)");
  }

  swiper.previousTranslate = swiper.translate;
  swiper.translate = swiper.isHorizontal() ? x : y; // Check if we need to update progress

  var newProgress;
  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();

  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (translate - swiper.minTranslate()) / translatesDiff;
  }

  if (newProgress !== progress) {
    swiper.updateProgress(translate);
  }

  swiper.emit('setTranslate', swiper.translate, byController);
}
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/translate/minTranslate.js
function minTranslate() {
  return -this.snapGrid[0];
}
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/translate/maxTranslate.js
function maxTranslate() {
  return -this.snapGrid[this.snapGrid.length - 1];
}
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/translate/translateTo.js
function translateTo(translate, speed, runCallbacks, translateBounds, internal) {
  if (translate === void 0) {
    translate = 0;
  }

  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  if (translateBounds === void 0) {
    translateBounds = true;
  }

  var swiper = this;
  var params = swiper.params,
      wrapperEl = swiper.wrapperEl;

  if (swiper.animating && params.preventInteractionOnTransition) {
    return false;
  }

  var minTranslate = swiper.minTranslate();
  var maxTranslate = swiper.maxTranslate();
  var newTranslate;
  if (translateBounds && translate > minTranslate) newTranslate = minTranslate;else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;else newTranslate = translate; // Update progress

  swiper.updateProgress(newTranslate);

  if (params.cssMode) {
    var isH = swiper.isHorizontal();

    if (speed === 0) {
      wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
    } else {
      // eslint-disable-next-line
      if (wrapperEl.scrollTo) {
        var _wrapperEl$scrollTo;

        wrapperEl.scrollTo((_wrapperEl$scrollTo = {}, _wrapperEl$scrollTo[isH ? 'left' : 'top'] = -newTranslate, _wrapperEl$scrollTo.behavior = 'smooth', _wrapperEl$scrollTo));
      } else {
        wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
      }
    }

    return true;
  }

  if (speed === 0) {
    swiper.setTransition(0);
    swiper.setTranslate(newTranslate);

    if (runCallbacks) {
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.emit('transitionEnd');
    }
  } else {
    swiper.setTransition(speed);
    swiper.setTranslate(newTranslate);

    if (runCallbacks) {
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.emit('transitionStart');
    }

    if (!swiper.animating) {
      swiper.animating = true;

      if (!swiper.onTranslateToWrapperTransitionEnd) {
        swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
          if (!swiper || swiper.destroyed) return;
          if (e.target !== this) return;
          swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
          swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
          swiper.onTranslateToWrapperTransitionEnd = null;
          delete swiper.onTranslateToWrapperTransitionEnd;

          if (runCallbacks) {
            swiper.emit('transitionEnd');
          }
        };
      }

      swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
      swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
    }
  }

  return true;
}
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/translate/index.js





/* harmony default export */ var translate = ({
  getTranslate: getSwiperTranslate,
  setTranslate: setTranslate,
  minTranslate: minTranslate,
  maxTranslate: maxTranslate,
  translateTo: translateTo
});
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/transition/setTransition.js
function setTransition(duration, byController) {
  var swiper = this;

  if (!swiper.params.cssMode) {
    swiper.$wrapperEl.transition(duration);
  }

  swiper.emit('setTransition', duration, byController);
}
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/transition/transitionStart.js
function transitionStart(runCallbacks, direction) {
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  var swiper = this;
  var activeIndex = swiper.activeIndex,
      params = swiper.params,
      previousIndex = swiper.previousIndex;
  if (params.cssMode) return;

  if (params.autoHeight) {
    swiper.updateAutoHeight();
  }

  var dir = direction;

  if (!dir) {
    if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
  }

  swiper.emit('transitionStart');

  if (runCallbacks && activeIndex !== previousIndex) {
    if (dir === 'reset') {
      swiper.emit('slideResetTransitionStart');
      return;
    }

    swiper.emit('slideChangeTransitionStart');

    if (dir === 'next') {
      swiper.emit('slideNextTransitionStart');
    } else {
      swiper.emit('slidePrevTransitionStart');
    }
  }
}
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/transition/transitionEnd.js
function transitionEnd(runCallbacks, direction) {
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  var swiper = this;
  var activeIndex = swiper.activeIndex,
      previousIndex = swiper.previousIndex,
      params = swiper.params;
  swiper.animating = false;
  if (params.cssMode) return;
  swiper.setTransition(0);
  var dir = direction;

  if (!dir) {
    if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
  }

  swiper.emit('transitionEnd');

  if (runCallbacks && activeIndex !== previousIndex) {
    if (dir === 'reset') {
      swiper.emit('slideResetTransitionEnd');
      return;
    }

    swiper.emit('slideChangeTransitionEnd');

    if (dir === 'next') {
      swiper.emit('slideNextTransitionEnd');
    } else {
      swiper.emit('slidePrevTransitionEnd');
    }
  }
}
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/transition/index.js



/* harmony default export */ var transition = ({
  setTransition: setTransition,
  transitionStart: transitionStart,
  transitionEnd: transitionEnd
});
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/slide/slideTo.js
function slideTo(index, speed, runCallbacks, internal, initial) {
  if (index === void 0) {
    index = 0;
  }

  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  if (typeof index !== 'number' && typeof index !== 'string') {
    throw new Error("The 'index' argument cannot have type other than 'number' or 'string'. [" + typeof index + "] given.");
  }

  if (typeof index === 'string') {
    /**
     * The `index` argument converted from `string` to `number`.
     * @type {number}
     */
    var indexAsNumber = parseInt(index, 10);
    /**
     * Determines whether the `index` argument is a valid `number`
     * after being converted from the `string` type.
     * @type {boolean}
     */

    var isValidNumber = isFinite(indexAsNumber);

    if (!isValidNumber) {
      throw new Error("The passed-in 'index' (string) couldn't be converted to 'number'. [" + index + "] given.");
    } // Knowing that the converted `index` is a valid number,
    // we can update the original argument's value.


    index = indexAsNumber;
  }

  var swiper = this;
  var slideIndex = index;
  if (slideIndex < 0) slideIndex = 0;
  var params = swiper.params,
      snapGrid = swiper.snapGrid,
      slidesGrid = swiper.slidesGrid,
      previousIndex = swiper.previousIndex,
      activeIndex = swiper.activeIndex,
      rtl = swiper.rtlTranslate,
      wrapperEl = swiper.wrapperEl,
      enabled = swiper.enabled;

  if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial) {
    return false;
  }

  var skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
  var snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;

  if ((activeIndex || params.initialSlide || 0) === (previousIndex || 0) && runCallbacks) {
    swiper.emit('beforeSlideChangeStart');
  }

  var translate = -snapGrid[snapIndex]; // Update progress

  swiper.updateProgress(translate); // Normalize slideIndex

  if (params.normalizeSlideIndex) {
    for (var i = 0; i < slidesGrid.length; i += 1) {
      var normalizedTranslate = -Math.floor(translate * 100);
      var normalizedGird = Math.floor(slidesGrid[i] * 100);
      var normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);

      if (typeof slidesGrid[i + 1] !== 'undefined') {
        if (normalizedTranslate >= normalizedGird && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGird) / 2) {
          slideIndex = i;
        } else if (normalizedTranslate >= normalizedGird && normalizedTranslate < normalizedGridNext) {
          slideIndex = i + 1;
        }
      } else if (normalizedTranslate >= normalizedGird) {
        slideIndex = i;
      }
    }
  } // Directions locks


  if (swiper.initialized && slideIndex !== activeIndex) {
    if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) {
      return false;
    }

    if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
      if ((activeIndex || 0) !== slideIndex) return false;
    }
  }

  var direction;
  if (slideIndex > activeIndex) direction = 'next';else if (slideIndex < activeIndex) direction = 'prev';else direction = 'reset'; // Update Index

  if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
    swiper.updateActiveIndex(slideIndex); // Update Height

    if (params.autoHeight) {
      swiper.updateAutoHeight();
    }

    swiper.updateSlidesClasses();

    if (params.effect !== 'slide') {
      swiper.setTranslate(translate);
    }

    if (direction !== 'reset') {
      swiper.transitionStart(runCallbacks, direction);
      swiper.transitionEnd(runCallbacks, direction);
    }

    return false;
  }

  if (params.cssMode) {
    var isH = swiper.isHorizontal();
    var t = -translate;

    if (rtl) {
      t = wrapperEl.scrollWidth - wrapperEl.offsetWidth - t;
    }

    if (speed === 0) {
      wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
    } else {
      // eslint-disable-next-line
      if (wrapperEl.scrollTo) {
        var _wrapperEl$scrollTo;

        wrapperEl.scrollTo((_wrapperEl$scrollTo = {}, _wrapperEl$scrollTo[isH ? 'left' : 'top'] = t, _wrapperEl$scrollTo.behavior = 'smooth', _wrapperEl$scrollTo));
      } else {
        wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
      }
    }

    return true;
  }

  if (speed === 0) {
    swiper.setTransition(0);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit('beforeTransitionStart', speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    swiper.transitionEnd(runCallbacks, direction);
  } else {
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit('beforeTransitionStart', speed, internal);
    swiper.transitionStart(runCallbacks, direction);

    if (!swiper.animating) {
      swiper.animating = true;

      if (!swiper.onSlideToWrapperTransitionEnd) {
        swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
          if (!swiper || swiper.destroyed) return;
          if (e.target !== this) return;
          swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
          swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
          swiper.onSlideToWrapperTransitionEnd = null;
          delete swiper.onSlideToWrapperTransitionEnd;
          swiper.transitionEnd(runCallbacks, direction);
        };
      }

      swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
      swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
    }
  }

  return true;
}
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/slide/slideToLoop.js
function slideToLoop(index, speed, runCallbacks, internal) {
  if (index === void 0) {
    index = 0;
  }

  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  var swiper = this;
  var newIndex = index;

  if (swiper.params.loop) {
    newIndex += swiper.loopedSlides;
  }

  return swiper.slideTo(newIndex, speed, runCallbacks, internal);
}
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/slide/slideNext.js
/* eslint no-unused-vars: "off" */
function slideNext(speed, runCallbacks, internal) {
  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  var swiper = this;
  var params = swiper.params,
      animating = swiper.animating,
      enabled = swiper.enabled;
  if (!enabled) return swiper;
  var increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup;

  if (params.loop) {
    if (animating && params.loopPreventsSlide) return false;
    swiper.loopFix(); // eslint-disable-next-line

    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
  }

  return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/slide/slidePrev.js
/* eslint no-unused-vars: "off" */
function slidePrev(speed, runCallbacks, internal) {
  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  var swiper = this;
  var params = swiper.params,
      animating = swiper.animating,
      snapGrid = swiper.snapGrid,
      slidesGrid = swiper.slidesGrid,
      rtlTranslate = swiper.rtlTranslate,
      enabled = swiper.enabled;
  if (!enabled) return swiper;

  if (params.loop) {
    if (animating && params.loopPreventsSlide) return false;
    swiper.loopFix(); // eslint-disable-next-line

    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
  }

  var translate = rtlTranslate ? swiper.translate : -swiper.translate;

  function normalize(val) {
    if (val < 0) return -Math.floor(Math.abs(val));
    return Math.floor(val);
  }

  var normalizedTranslate = normalize(translate);
  var normalizedSnapGrid = snapGrid.map(function (val) {
    return normalize(val);
  });
  var prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];

  if (typeof prevSnap === 'undefined' && params.cssMode) {
    snapGrid.forEach(function (snap) {
      if (!prevSnap && normalizedTranslate >= snap) prevSnap = snap;
    });
  }

  var prevIndex;

  if (typeof prevSnap !== 'undefined') {
    prevIndex = slidesGrid.indexOf(prevSnap);
    if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
  }

  return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/slide/slideReset.js
/* eslint no-unused-vars: "off" */
function slideReset(speed, runCallbacks, internal) {
  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  var swiper = this;
  return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/slide/slideToClosest.js
/* eslint no-unused-vars: "off" */
function slideToClosest(speed, runCallbacks, internal, threshold) {
  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  if (threshold === void 0) {
    threshold = 0.5;
  }

  var swiper = this;
  var index = swiper.activeIndex;
  var skip = Math.min(swiper.params.slidesPerGroupSkip, index);
  var snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
  var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;

  if (translate >= swiper.snapGrid[snapIndex]) {
    // The current translate is on or after the current snap index, so the choice
    // is between the current index and the one after it.
    var currentSnap = swiper.snapGrid[snapIndex];
    var nextSnap = swiper.snapGrid[snapIndex + 1];

    if (translate - currentSnap > (nextSnap - currentSnap) * threshold) {
      index += swiper.params.slidesPerGroup;
    }
  } else {
    // The current translate is before the current snap index, so the choice
    // is between the current index and the one before it.
    var prevSnap = swiper.snapGrid[snapIndex - 1];
    var _currentSnap = swiper.snapGrid[snapIndex];

    if (translate - prevSnap <= (_currentSnap - prevSnap) * threshold) {
      index -= swiper.params.slidesPerGroup;
    }
  }

  index = Math.max(index, 0);
  index = Math.min(index, swiper.slidesGrid.length - 1);
  return swiper.slideTo(index, speed, runCallbacks, internal);
}
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/slide/slideToClickedSlide.js


function slideToClickedSlide() {
  var swiper = this;
  var params = swiper.params,
      $wrapperEl = swiper.$wrapperEl;
  var slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
  var slideToIndex = swiper.clickedIndex;
  var realIndex;

  if (params.loop) {
    if (swiper.animating) return;
    realIndex = parseInt((0,dom/* default */.Z)(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);

    if (params.centeredSlides) {
      if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
        swiper.loopFix();
        slideToIndex = $wrapperEl.children("." + params.slideClass + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + params.slideDuplicateClass + ")").eq(0).index();
        (0,utils/* nextTick */.Y3)(function () {
          swiper.slideTo(slideToIndex);
        });
      } else {
        swiper.slideTo(slideToIndex);
      }
    } else if (slideToIndex > swiper.slides.length - slidesPerView) {
      swiper.loopFix();
      slideToIndex = $wrapperEl.children("." + params.slideClass + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + params.slideDuplicateClass + ")").eq(0).index();
      (0,utils/* nextTick */.Y3)(function () {
        swiper.slideTo(slideToIndex);
      });
    } else {
      swiper.slideTo(slideToIndex);
    }
  } else {
    swiper.slideTo(slideToIndex);
  }
}
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/slide/index.js







/* harmony default export */ var slide = ({
  slideTo: slideTo,
  slideToLoop: slideToLoop,
  slideNext: slideNext,
  slidePrev: slidePrev,
  slideReset: slideReset,
  slideToClosest: slideToClosest,
  slideToClickedSlide: slideToClickedSlide
});
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/loop/loopCreate.js


function loopCreate() {
  var swiper = this;
  var document = (0,ssr_window_esm/* getDocument */.Me)();
  var params = swiper.params,
      $wrapperEl = swiper.$wrapperEl; // Remove duplicated slides

  $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass).remove();
  var slides = $wrapperEl.children("." + params.slideClass);

  if (params.loopFillGroupWithBlank) {
    var blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;

    if (blankSlidesNum !== params.slidesPerGroup) {
      for (var i = 0; i < blankSlidesNum; i += 1) {
        var blankNode = (0,dom/* default */.Z)(document.createElement('div')).addClass(params.slideClass + " " + params.slideBlankClass);
        $wrapperEl.append(blankNode);
      }

      slides = $wrapperEl.children("." + params.slideClass);
    }
  }

  if (params.slidesPerView === 'auto' && !params.loopedSlides) params.loopedSlides = slides.length;
  swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
  swiper.loopedSlides += params.loopAdditionalSlides;

  if (swiper.loopedSlides > slides.length) {
    swiper.loopedSlides = slides.length;
  }

  var prependSlides = [];
  var appendSlides = [];
  slides.each(function (el, index) {
    var slide = (0,dom/* default */.Z)(el);

    if (index < swiper.loopedSlides) {
      appendSlides.push(el);
    }

    if (index < slides.length && index >= slides.length - swiper.loopedSlides) {
      prependSlides.push(el);
    }

    slide.attr('data-swiper-slide-index', index);
  });

  for (var _i = 0; _i < appendSlides.length; _i += 1) {
    $wrapperEl.append((0,dom/* default */.Z)(appendSlides[_i].cloneNode(true)).addClass(params.slideDuplicateClass));
  }

  for (var _i2 = prependSlides.length - 1; _i2 >= 0; _i2 -= 1) {
    $wrapperEl.prepend((0,dom/* default */.Z)(prependSlides[_i2].cloneNode(true)).addClass(params.slideDuplicateClass));
  }
}
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/loop/loopFix.js
function loopFix() {
  var swiper = this;
  swiper.emit('beforeLoopFix');
  var activeIndex = swiper.activeIndex,
      slides = swiper.slides,
      loopedSlides = swiper.loopedSlides,
      allowSlidePrev = swiper.allowSlidePrev,
      allowSlideNext = swiper.allowSlideNext,
      snapGrid = swiper.snapGrid,
      rtl = swiper.rtlTranslate;
  var newIndex;
  swiper.allowSlidePrev = true;
  swiper.allowSlideNext = true;
  var snapTranslate = -snapGrid[activeIndex];
  var diff = snapTranslate - swiper.getTranslate(); // Fix For Negative Oversliding

  if (activeIndex < loopedSlides) {
    newIndex = slides.length - loopedSlides * 3 + activeIndex;
    newIndex += loopedSlides;
    var slideChanged = swiper.slideTo(newIndex, 0, false, true);

    if (slideChanged && diff !== 0) {
      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
  } else if (activeIndex >= slides.length - loopedSlides) {
    // Fix For Positive Oversliding
    newIndex = -slides.length + activeIndex + loopedSlides;
    newIndex += loopedSlides;

    var _slideChanged = swiper.slideTo(newIndex, 0, false, true);

    if (_slideChanged && diff !== 0) {
      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
  }

  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;
  swiper.emit('loopFix');
}
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/loop/loopDestroy.js
function loopDestroy() {
  var swiper = this;
  var $wrapperEl = swiper.$wrapperEl,
      params = swiper.params,
      slides = swiper.slides;
  $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + ",." + params.slideClass + "." + params.slideBlankClass).remove();
  slides.removeAttr('data-swiper-slide-index');
}
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/loop/index.js



/* harmony default export */ var loop = ({
  loopCreate: loopCreate,
  loopFix: loopFix,
  loopDestroy: loopDestroy
});
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/grab-cursor/setGrabCursor.js
function setGrabCursor(moving) {
  var swiper = this;
  if (swiper.support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
  var el = swiper.el;
  el.style.cursor = 'move';
  el.style.cursor = moving ? '-webkit-grabbing' : '-webkit-grab';
  el.style.cursor = moving ? '-moz-grabbin' : '-moz-grab';
  el.style.cursor = moving ? 'grabbing' : 'grab';
}
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/grab-cursor/unsetGrabCursor.js
function unsetGrabCursor() {
  var swiper = this;

  if (swiper.support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) {
    return;
  }

  swiper.el.style.cursor = '';
}
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/grab-cursor/index.js


/* harmony default export */ var grab_cursor = ({
  setGrabCursor: setGrabCursor,
  unsetGrabCursor: unsetGrabCursor
});
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/manipulation/appendSlide.js
function appendSlide(slides) {
  var swiper = this;
  var $wrapperEl = swiper.$wrapperEl,
      params = swiper.params;

  if (params.loop) {
    swiper.loopDestroy();
  }

  if (typeof slides === 'object' && 'length' in slides) {
    for (var i = 0; i < slides.length; i += 1) {
      if (slides[i]) $wrapperEl.append(slides[i]);
    }
  } else {
    $wrapperEl.append(slides);
  }

  if (params.loop) {
    swiper.loopCreate();
  }

  if (!(params.observer && swiper.support.observer)) {
    swiper.update();
  }
}
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/manipulation/prependSlide.js
function prependSlide(slides) {
  var swiper = this;
  var params = swiper.params,
      $wrapperEl = swiper.$wrapperEl,
      activeIndex = swiper.activeIndex;

  if (params.loop) {
    swiper.loopDestroy();
  }

  var newActiveIndex = activeIndex + 1;

  if (typeof slides === 'object' && 'length' in slides) {
    for (var i = 0; i < slides.length; i += 1) {
      if (slides[i]) $wrapperEl.prepend(slides[i]);
    }

    newActiveIndex = activeIndex + slides.length;
  } else {
    $wrapperEl.prepend(slides);
  }

  if (params.loop) {
    swiper.loopCreate();
  }

  if (!(params.observer && swiper.support.observer)) {
    swiper.update();
  }

  swiper.slideTo(newActiveIndex, 0, false);
}
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/manipulation/addSlide.js
function addSlide(index, slides) {
  var swiper = this;
  var $wrapperEl = swiper.$wrapperEl,
      params = swiper.params,
      activeIndex = swiper.activeIndex;
  var activeIndexBuffer = activeIndex;

  if (params.loop) {
    activeIndexBuffer -= swiper.loopedSlides;
    swiper.loopDestroy();
    swiper.slides = $wrapperEl.children("." + params.slideClass);
  }

  var baseLength = swiper.slides.length;

  if (index <= 0) {
    swiper.prependSlide(slides);
    return;
  }

  if (index >= baseLength) {
    swiper.appendSlide(slides);
    return;
  }

  var newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
  var slidesBuffer = [];

  for (var i = baseLength - 1; i >= index; i -= 1) {
    var currentSlide = swiper.slides.eq(i);
    currentSlide.remove();
    slidesBuffer.unshift(currentSlide);
  }

  if (typeof slides === 'object' && 'length' in slides) {
    for (var _i = 0; _i < slides.length; _i += 1) {
      if (slides[_i]) $wrapperEl.append(slides[_i]);
    }

    newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
  } else {
    $wrapperEl.append(slides);
  }

  for (var _i2 = 0; _i2 < slidesBuffer.length; _i2 += 1) {
    $wrapperEl.append(slidesBuffer[_i2]);
  }

  if (params.loop) {
    swiper.loopCreate();
  }

  if (!(params.observer && swiper.support.observer)) {
    swiper.update();
  }

  if (params.loop) {
    swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
  } else {
    swiper.slideTo(newActiveIndex, 0, false);
  }
}
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/manipulation/removeSlide.js
function removeSlide(slidesIndexes) {
  var swiper = this;
  var params = swiper.params,
      $wrapperEl = swiper.$wrapperEl,
      activeIndex = swiper.activeIndex;
  var activeIndexBuffer = activeIndex;

  if (params.loop) {
    activeIndexBuffer -= swiper.loopedSlides;
    swiper.loopDestroy();
    swiper.slides = $wrapperEl.children("." + params.slideClass);
  }

  var newActiveIndex = activeIndexBuffer;
  var indexToRemove;

  if (typeof slidesIndexes === 'object' && 'length' in slidesIndexes) {
    for (var i = 0; i < slidesIndexes.length; i += 1) {
      indexToRemove = slidesIndexes[i];
      if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
      if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
    }

    newActiveIndex = Math.max(newActiveIndex, 0);
  } else {
    indexToRemove = slidesIndexes;
    if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
    if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
    newActiveIndex = Math.max(newActiveIndex, 0);
  }

  if (params.loop) {
    swiper.loopCreate();
  }

  if (!(params.observer && swiper.support.observer)) {
    swiper.update();
  }

  if (params.loop) {
    swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
  } else {
    swiper.slideTo(newActiveIndex, 0, false);
  }
}
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/manipulation/removeAllSlides.js
function removeAllSlides() {
  var swiper = this;
  var slidesIndexes = [];

  for (var i = 0; i < swiper.slides.length; i += 1) {
    slidesIndexes.push(i);
  }

  swiper.removeSlide(slidesIndexes);
}
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/manipulation/index.js





/* harmony default export */ var manipulation = ({
  appendSlide: appendSlide,
  prependSlide: prependSlide,
  addSlide: addSlide,
  removeSlide: removeSlide,
  removeAllSlides: removeAllSlides
});
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/events/onTouchStart.js


 // Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd

function closestElement(selector, base) {
  if (base === void 0) {
    base = this;
  }

  function __closestFrom(el) {
    if (!el || el === (0,ssr_window_esm/* getDocument */.Me)() || el === (0,ssr_window_esm/* getWindow */.Jj)()) return null;
    if (el.assignedSlot) el = el.assignedSlot;
    var found = el.closest(selector);
    return found || __closestFrom(el.getRootNode().host);
  }

  return __closestFrom(base);
}

function onTouchStart(event) {
  var swiper = this;
  var document = (0,ssr_window_esm/* getDocument */.Me)();
  var window = (0,ssr_window_esm/* getWindow */.Jj)();
  var data = swiper.touchEventsData;
  var params = swiper.params,
      touches = swiper.touches,
      enabled = swiper.enabled;
  if (!enabled) return;

  if (swiper.animating && params.preventInteractionOnTransition) {
    return;
  }

  var e = event;
  if (e.originalEvent) e = e.originalEvent;
  var $targetEl = (0,dom/* default */.Z)(e.target);

  if (params.touchEventsTarget === 'wrapper') {
    if (!$targetEl.closest(swiper.wrapperEl).length) return;
  }

  data.isTouchEvent = e.type === 'touchstart';
  if (!data.isTouchEvent && 'which' in e && e.which === 3) return;
  if (!data.isTouchEvent && 'button' in e && e.button > 0) return;
  if (data.isTouched && data.isMoved) return; // change target el for shadow root component

  var swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== '';

  if (swipingClassHasValue && e.target && e.target.shadowRoot && event.path && event.path[0]) {
    $targetEl = (0,dom/* default */.Z)(event.path[0]);
  }

  var noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : "." + params.noSwipingClass;
  var isTargetShadow = !!(e.target && e.target.shadowRoot); // use closestElement for shadow root element to get the actual closest for nested shadow root element

  if (params.noSwiping && (isTargetShadow ? closestElement(noSwipingSelector, e.target) : $targetEl.closest(noSwipingSelector)[0])) {
    swiper.allowClick = true;
    return;
  }

  if (params.swipeHandler) {
    if (!$targetEl.closest(params.swipeHandler)[0]) return;
  }

  touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
  touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
  var startX = touches.currentX;
  var startY = touches.currentY; // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore

  var edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
  var edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;

  if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
    if (edgeSwipeDetection === 'prevent') {
      event.preventDefault();
    } else {
      return;
    }
  }

  (0,utils/* extend */.l7)(data, {
    isTouched: true,
    isMoved: false,
    allowTouchCallbacks: true,
    isScrolling: undefined,
    startMoving: undefined
  });
  touches.startX = startX;
  touches.startY = startY;
  data.touchStartTime = (0,utils/* now */.zO)();
  swiper.allowClick = true;
  swiper.updateSize();
  swiper.swipeDirection = undefined;
  if (params.threshold > 0) data.allowThresholdMove = false;

  if (e.type !== 'touchstart') {
    var preventDefault = true;
    if ($targetEl.is(data.focusableElements)) preventDefault = false;

    if (document.activeElement && (0,dom/* default */.Z)(document.activeElement).is(data.focusableElements) && document.activeElement !== $targetEl[0]) {
      document.activeElement.blur();
    }

    var shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;

    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !$targetEl[0].isContentEditable) {
      e.preventDefault();
    }
  }

  swiper.emit('touchStart', e);
}
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/events/onTouchMove.js



function onTouchMove(event) {
  var document = (0,ssr_window_esm/* getDocument */.Me)();
  var swiper = this;
  var data = swiper.touchEventsData;
  var params = swiper.params,
      touches = swiper.touches,
      rtl = swiper.rtlTranslate,
      enabled = swiper.enabled;
  if (!enabled) return;
  var e = event;
  if (e.originalEvent) e = e.originalEvent;

  if (!data.isTouched) {
    if (data.startMoving && data.isScrolling) {
      swiper.emit('touchMoveOpposite', e);
    }

    return;
  }

  if (data.isTouchEvent && e.type !== 'touchmove') return;
  var targetTouch = e.type === 'touchmove' && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]);
  var pageX = e.type === 'touchmove' ? targetTouch.pageX : e.pageX;
  var pageY = e.type === 'touchmove' ? targetTouch.pageY : e.pageY;

  if (e.preventedByNestedSwiper) {
    touches.startX = pageX;
    touches.startY = pageY;
    return;
  }

  if (!swiper.allowTouchMove) {
    // isMoved = true;
    swiper.allowClick = false;

    if (data.isTouched) {
      (0,utils/* extend */.l7)(touches, {
        startX: pageX,
        startY: pageY,
        currentX: pageX,
        currentY: pageY
      });
      data.touchStartTime = (0,utils/* now */.zO)();
    }

    return;
  }

  if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
    if (swiper.isVertical()) {
      // Vertical
      if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
        data.isTouched = false;
        data.isMoved = false;
        return;
      }
    } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) {
      return;
    }
  }

  if (data.isTouchEvent && document.activeElement) {
    if (e.target === document.activeElement && (0,dom/* default */.Z)(e.target).is(data.focusableElements)) {
      data.isMoved = true;
      swiper.allowClick = false;
      return;
    }
  }

  if (data.allowTouchCallbacks) {
    swiper.emit('touchMove', e);
  }

  if (e.targetTouches && e.targetTouches.length > 1) return;
  touches.currentX = pageX;
  touches.currentY = pageY;
  var diffX = touches.currentX - touches.startX;
  var diffY = touches.currentY - touches.startY;
  if (swiper.params.threshold && Math.sqrt(Math.pow(diffX, 2) + Math.pow(diffY, 2)) < swiper.params.threshold) return;

  if (typeof data.isScrolling === 'undefined') {
    var touchAngle;

    if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) {
      data.isScrolling = false;
    } else {
      // eslint-disable-next-line
      if (diffX * diffX + diffY * diffY >= 25) {
        touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
        data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
      }
    }
  }

  if (data.isScrolling) {
    swiper.emit('touchMoveOpposite', e);
  }

  if (typeof data.startMoving === 'undefined') {
    if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
      data.startMoving = true;
    }
  }

  if (data.isScrolling) {
    data.isTouched = false;
    return;
  }

  if (!data.startMoving) {
    return;
  }

  swiper.allowClick = false;

  if (!params.cssMode && e.cancelable) {
    e.preventDefault();
  }

  if (params.touchMoveStopPropagation && !params.nested) {
    e.stopPropagation();
  }

  if (!data.isMoved) {
    if (params.loop) {
      swiper.loopFix();
    }

    data.startTranslate = swiper.getTranslate();
    swiper.setTransition(0);

    if (swiper.animating) {
      swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
    }

    data.allowMomentumBounce = false; // Grab Cursor

    if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
      swiper.setGrabCursor(true);
    }

    swiper.emit('sliderFirstMove', e);
  }

  swiper.emit('sliderMove', e);
  data.isMoved = true;
  var diff = swiper.isHorizontal() ? diffX : diffY;
  touches.diff = diff;
  diff *= params.touchRatio;
  if (rtl) diff = -diff;
  swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
  data.currentTranslate = diff + data.startTranslate;
  var disableParentSwiper = true;
  var resistanceRatio = params.resistanceRatio;

  if (params.touchReleaseOnEdges) {
    resistanceRatio = 0;
  }

  if (diff > 0 && data.currentTranslate > swiper.minTranslate()) {
    disableParentSwiper = false;
    if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + Math.pow(-swiper.minTranslate() + data.startTranslate + diff, resistanceRatio);
  } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
    disableParentSwiper = false;
    if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - Math.pow(swiper.maxTranslate() - data.startTranslate - diff, resistanceRatio);
  }

  if (disableParentSwiper) {
    e.preventedByNestedSwiper = true;
  } // Directions locks


  if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }

  if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }

  if (!swiper.allowSlidePrev && !swiper.allowSlideNext) {
    data.currentTranslate = data.startTranslate;
  } // Threshold


  if (params.threshold > 0) {
    if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
      if (!data.allowThresholdMove) {
        data.allowThresholdMove = true;
        touches.startX = touches.currentX;
        touches.startY = touches.currentY;
        data.currentTranslate = data.startTranslate;
        touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
        return;
      }
    } else {
      data.currentTranslate = data.startTranslate;
      return;
    }
  }

  if (!params.followFinger || params.cssMode) return; // Update active index in free mode

  if (params.freeMode || params.watchSlidesProgress || params.watchSlidesVisibility) {
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }

  if (params.freeMode) {
    // Velocity
    if (data.velocities.length === 0) {
      data.velocities.push({
        position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
        time: data.touchStartTime
      });
    }

    data.velocities.push({
      position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
      time: (0,utils/* now */.zO)()
    });
  } // Update progress


  swiper.updateProgress(data.currentTranslate); // Update translate

  swiper.setTranslate(data.currentTranslate);
}
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/events/onTouchEnd.js

function onTouchEnd(event) {
  var swiper = this;
  var data = swiper.touchEventsData;
  var params = swiper.params,
      touches = swiper.touches,
      rtl = swiper.rtlTranslate,
      $wrapperEl = swiper.$wrapperEl,
      slidesGrid = swiper.slidesGrid,
      snapGrid = swiper.snapGrid,
      enabled = swiper.enabled;
  if (!enabled) return;
  var e = event;
  if (e.originalEvent) e = e.originalEvent;

  if (data.allowTouchCallbacks) {
    swiper.emit('touchEnd', e);
  }

  data.allowTouchCallbacks = false;

  if (!data.isTouched) {
    if (data.isMoved && params.grabCursor) {
      swiper.setGrabCursor(false);
    }

    data.isMoved = false;
    data.startMoving = false;
    return;
  } // Return Grab Cursor


  if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
    swiper.setGrabCursor(false);
  } // Time diff


  var touchEndTime = (0,utils/* now */.zO)();
  var timeDiff = touchEndTime - data.touchStartTime; // Tap, doubleTap, Click

  if (swiper.allowClick) {
    swiper.updateClickedSlide(e);
    swiper.emit('tap click', e);

    if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) {
      swiper.emit('doubleTap doubleClick', e);
    }
  }

  data.lastClickTime = (0,utils/* now */.zO)();
  (0,utils/* nextTick */.Y3)(function () {
    if (!swiper.destroyed) swiper.allowClick = true;
  });

  if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    return;
  }

  data.isTouched = false;
  data.isMoved = false;
  data.startMoving = false;
  var currentPos;

  if (params.followFinger) {
    currentPos = rtl ? swiper.translate : -swiper.translate;
  } else {
    currentPos = -data.currentTranslate;
  }

  if (params.cssMode) {
    return;
  }

  if (params.freeMode) {
    if (currentPos < -swiper.minTranslate()) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }

    if (currentPos > -swiper.maxTranslate()) {
      if (swiper.slides.length < snapGrid.length) {
        swiper.slideTo(snapGrid.length - 1);
      } else {
        swiper.slideTo(swiper.slides.length - 1);
      }

      return;
    }

    if (params.freeModeMomentum) {
      if (data.velocities.length > 1) {
        var lastMoveEvent = data.velocities.pop();
        var velocityEvent = data.velocities.pop();
        var distance = lastMoveEvent.position - velocityEvent.position;
        var time = lastMoveEvent.time - velocityEvent.time;
        swiper.velocity = distance / time;
        swiper.velocity /= 2;

        if (Math.abs(swiper.velocity) < params.freeModeMinimumVelocity) {
          swiper.velocity = 0;
        } // this implies that the user stopped moving a finger then released.
        // There would be no events with distance zero, so the last event is stale.


        if (time > 150 || (0,utils/* now */.zO)() - lastMoveEvent.time > 300) {
          swiper.velocity = 0;
        }
      } else {
        swiper.velocity = 0;
      }

      swiper.velocity *= params.freeModeMomentumVelocityRatio;
      data.velocities.length = 0;
      var momentumDuration = 1000 * params.freeModeMomentumRatio;
      var momentumDistance = swiper.velocity * momentumDuration;
      var newPosition = swiper.translate + momentumDistance;
      if (rtl) newPosition = -newPosition;
      var doBounce = false;
      var afterBouncePosition;
      var bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeModeMomentumBounceRatio;
      var needsLoopFix;

      if (newPosition < swiper.maxTranslate()) {
        if (params.freeModeMomentumBounce) {
          if (newPosition + swiper.maxTranslate() < -bounceAmount) {
            newPosition = swiper.maxTranslate() - bounceAmount;
          }

          afterBouncePosition = swiper.maxTranslate();
          doBounce = true;
          data.allowMomentumBounce = true;
        } else {
          newPosition = swiper.maxTranslate();
        }

        if (params.loop && params.centeredSlides) needsLoopFix = true;
      } else if (newPosition > swiper.minTranslate()) {
        if (params.freeModeMomentumBounce) {
          if (newPosition - swiper.minTranslate() > bounceAmount) {
            newPosition = swiper.minTranslate() + bounceAmount;
          }

          afterBouncePosition = swiper.minTranslate();
          doBounce = true;
          data.allowMomentumBounce = true;
        } else {
          newPosition = swiper.minTranslate();
        }

        if (params.loop && params.centeredSlides) needsLoopFix = true;
      } else if (params.freeModeSticky) {
        var nextSlide;

        for (var j = 0; j < snapGrid.length; j += 1) {
          if (snapGrid[j] > -newPosition) {
            nextSlide = j;
            break;
          }
        }

        if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') {
          newPosition = snapGrid[nextSlide];
        } else {
          newPosition = snapGrid[nextSlide - 1];
        }

        newPosition = -newPosition;
      }

      if (needsLoopFix) {
        swiper.once('transitionEnd', function () {
          swiper.loopFix();
        });
      } // Fix duration


      if (swiper.velocity !== 0) {
        if (rtl) {
          momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
        } else {
          momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
        }

        if (params.freeModeSticky) {
          // If freeModeSticky is active and the user ends a swipe with a slow-velocity
          // event, then durations can be 20+ seconds to slide one (or zero!) slides.
          // It's easy to see this when simulating touch with mouse events. To fix this,
          // limit single-slide swipes to the default slide duration. This also has the
          // nice side effect of matching slide speed if the user stopped moving before
          // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
          // For faster swipes, also apply limits (albeit higher ones).
          var moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
          var currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];

          if (moveDistance < currentSlideSize) {
            momentumDuration = params.speed;
          } else if (moveDistance < 2 * currentSlideSize) {
            momentumDuration = params.speed * 1.5;
          } else {
            momentumDuration = params.speed * 2.5;
          }
        }
      } else if (params.freeModeSticky) {
        swiper.slideToClosest();
        return;
      }

      if (params.freeModeMomentumBounce && doBounce) {
        swiper.updateProgress(afterBouncePosition);
        swiper.setTransition(momentumDuration);
        swiper.setTranslate(newPosition);
        swiper.transitionStart(true, swiper.swipeDirection);
        swiper.animating = true;
        $wrapperEl.transitionEnd(function () {
          if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
          swiper.emit('momentumBounce');
          swiper.setTransition(params.speed);
          setTimeout(function () {
            swiper.setTranslate(afterBouncePosition);
            $wrapperEl.transitionEnd(function () {
              if (!swiper || swiper.destroyed) return;
              swiper.transitionEnd();
            });
          }, 0);
        });
      } else if (swiper.velocity) {
        swiper.updateProgress(newPosition);
        swiper.setTransition(momentumDuration);
        swiper.setTranslate(newPosition);
        swiper.transitionStart(true, swiper.swipeDirection);

        if (!swiper.animating) {
          swiper.animating = true;
          $wrapperEl.transitionEnd(function () {
            if (!swiper || swiper.destroyed) return;
            swiper.transitionEnd();
          });
        }
      } else {
        swiper.emit('_freeModeNoMomentumRelease');
        swiper.updateProgress(newPosition);
      }

      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    } else if (params.freeModeSticky) {
      swiper.slideToClosest();
      return;
    } else if (params.freeMode) {
      swiper.emit('_freeModeNoMomentumRelease');
    }

    if (!params.freeModeMomentum || timeDiff >= params.longSwipesMs) {
      swiper.updateProgress();
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }

    return;
  } // Find current slide


  var stopIndex = 0;
  var groupSize = swiper.slidesSizesGrid[0];

  for (var i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup) {
    var _increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;

    if (typeof slidesGrid[i + _increment] !== 'undefined') {
      if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + _increment]) {
        stopIndex = i;
        groupSize = slidesGrid[i + _increment] - slidesGrid[i];
      }
    } else if (currentPos >= slidesGrid[i]) {
      stopIndex = i;
      groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
    }
  } // Find current slide size


  var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
  var increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;

  if (timeDiff > params.longSwipesMs) {
    // Long touches
    if (!params.longSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }

    if (swiper.swipeDirection === 'next') {
      if (ratio >= params.longSwipesRatio) swiper.slideTo(stopIndex + increment);else swiper.slideTo(stopIndex);
    }

    if (swiper.swipeDirection === 'prev') {
      if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);else swiper.slideTo(stopIndex);
    }
  } else {
    // Short swipes
    if (!params.shortSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }

    var isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);

    if (!isNavButtonTarget) {
      if (swiper.swipeDirection === 'next') {
        swiper.slideTo(stopIndex + increment);
      }

      if (swiper.swipeDirection === 'prev') {
        swiper.slideTo(stopIndex);
      }
    } else if (e.target === swiper.navigation.nextEl) {
      swiper.slideTo(stopIndex + increment);
    } else {
      swiper.slideTo(stopIndex);
    }
  }
}
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/events/onResize.js
function onResize() {
  var swiper = this;
  var params = swiper.params,
      el = swiper.el;
  if (el && el.offsetWidth === 0) return; // Breakpoints

  if (params.breakpoints) {
    swiper.setBreakpoint();
  } // Save locks


  var allowSlideNext = swiper.allowSlideNext,
      allowSlidePrev = swiper.allowSlidePrev,
      snapGrid = swiper.snapGrid; // Disable locks on resize

  swiper.allowSlideNext = true;
  swiper.allowSlidePrev = true;
  swiper.updateSize();
  swiper.updateSlides();
  swiper.updateSlidesClasses();

  if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides) {
    swiper.slideTo(swiper.slides.length - 1, 0, false, true);
  } else {
    swiper.slideTo(swiper.activeIndex, 0, false, true);
  }

  if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
    swiper.autoplay.run();
  } // Return locks after resize


  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;

  if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
    swiper.checkOverflow();
  }
}
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/events/onClick.js
function onClick(e) {
  var swiper = this;
  if (!swiper.enabled) return;

  if (!swiper.allowClick) {
    if (swiper.params.preventClicks) e.preventDefault();

    if (swiper.params.preventClicksPropagation && swiper.animating) {
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }
}
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/events/onScroll.js
function onScroll() {
  var swiper = this;
  var wrapperEl = swiper.wrapperEl,
      rtlTranslate = swiper.rtlTranslate,
      enabled = swiper.enabled;
  if (!enabled) return;
  swiper.previousTranslate = swiper.translate;

  if (swiper.isHorizontal()) {
    if (rtlTranslate) {
      swiper.translate = wrapperEl.scrollWidth - wrapperEl.offsetWidth - wrapperEl.scrollLeft;
    } else {
      swiper.translate = -wrapperEl.scrollLeft;
    }
  } else {
    swiper.translate = -wrapperEl.scrollTop;
  } // eslint-disable-next-line


  if (swiper.translate === -0) swiper.translate = 0;
  swiper.updateActiveIndex();
  swiper.updateSlidesClasses();
  var newProgress;
  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();

  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
  }

  if (newProgress !== swiper.progress) {
    swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
  }

  swiper.emit('setTranslate', swiper.translate, false);
}
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/events/index.js







var dummyEventAttached = false;

function dummyEventListener() {}

function attachEvents() {
  var swiper = this;
  var document = (0,ssr_window_esm/* getDocument */.Me)();
  var params = swiper.params,
      touchEvents = swiper.touchEvents,
      el = swiper.el,
      wrapperEl = swiper.wrapperEl,
      device = swiper.device,
      support = swiper.support;
  swiper.onTouchStart = onTouchStart.bind(swiper);
  swiper.onTouchMove = onTouchMove.bind(swiper);
  swiper.onTouchEnd = onTouchEnd.bind(swiper);

  if (params.cssMode) {
    swiper.onScroll = onScroll.bind(swiper);
  }

  swiper.onClick = onClick.bind(swiper);
  var capture = !!params.nested; // Touch Events

  if (!support.touch && support.pointerEvents) {
    el.addEventListener(touchEvents.start, swiper.onTouchStart, false);
    document.addEventListener(touchEvents.move, swiper.onTouchMove, capture);
    document.addEventListener(touchEvents.end, swiper.onTouchEnd, false);
  } else {
    if (support.touch) {
      var passiveListener = touchEvents.start === 'touchstart' && support.passiveListener && params.passiveListeners ? {
        passive: true,
        capture: false
      } : false;
      el.addEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
      el.addEventListener(touchEvents.move, swiper.onTouchMove, support.passiveListener ? {
        passive: false,
        capture: capture
      } : capture);
      el.addEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);

      if (touchEvents.cancel) {
        el.addEventListener(touchEvents.cancel, swiper.onTouchEnd, passiveListener);
      }

      if (!dummyEventAttached) {
        document.addEventListener('touchstart', dummyEventListener);
        dummyEventAttached = true;
      }
    }

    if (params.simulateTouch && !device.ios && !device.android || params.simulateTouch && !support.touch && device.ios) {
      el.addEventListener('mousedown', swiper.onTouchStart, false);
      document.addEventListener('mousemove', swiper.onTouchMove, capture);
      document.addEventListener('mouseup', swiper.onTouchEnd, false);
    }
  } // Prevent Links Clicks


  if (params.preventClicks || params.preventClicksPropagation) {
    el.addEventListener('click', swiper.onClick, true);
  }

  if (params.cssMode) {
    wrapperEl.addEventListener('scroll', swiper.onScroll);
  } // Resize handler


  if (params.updateOnWindowResize) {
    swiper.on(device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize, true);
  } else {
    swiper.on('observerUpdate', onResize, true);
  }
}

function detachEvents() {
  var swiper = this;
  var document = (0,ssr_window_esm/* getDocument */.Me)();
  var params = swiper.params,
      touchEvents = swiper.touchEvents,
      el = swiper.el,
      wrapperEl = swiper.wrapperEl,
      device = swiper.device,
      support = swiper.support;
  var capture = !!params.nested; // Touch Events

  if (!support.touch && support.pointerEvents) {
    el.removeEventListener(touchEvents.start, swiper.onTouchStart, false);
    document.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
    document.removeEventListener(touchEvents.end, swiper.onTouchEnd, false);
  } else {
    if (support.touch) {
      var passiveListener = touchEvents.start === 'onTouchStart' && support.passiveListener && params.passiveListeners ? {
        passive: true,
        capture: false
      } : false;
      el.removeEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
      el.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
      el.removeEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);

      if (touchEvents.cancel) {
        el.removeEventListener(touchEvents.cancel, swiper.onTouchEnd, passiveListener);
      }
    }

    if (params.simulateTouch && !device.ios && !device.android || params.simulateTouch && !support.touch && device.ios) {
      el.removeEventListener('mousedown', swiper.onTouchStart, false);
      document.removeEventListener('mousemove', swiper.onTouchMove, capture);
      document.removeEventListener('mouseup', swiper.onTouchEnd, false);
    }
  } // Prevent Links Clicks


  if (params.preventClicks || params.preventClicksPropagation) {
    el.removeEventListener('click', swiper.onClick, true);
  }

  if (params.cssMode) {
    wrapperEl.removeEventListener('scroll', swiper.onScroll);
  } // Resize handler


  swiper.off(device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize);
}

/* harmony default export */ var events = ({
  attachEvents: attachEvents,
  detachEvents: detachEvents
});
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/breakpoints/setBreakpoint.js

function setBreakpoint() {
  var swiper = this;
  var activeIndex = swiper.activeIndex,
      initialized = swiper.initialized,
      _swiper$loopedSlides = swiper.loopedSlides,
      loopedSlides = _swiper$loopedSlides === void 0 ? 0 : _swiper$loopedSlides,
      params = swiper.params,
      $el = swiper.$el;
  var breakpoints = params.breakpoints;
  if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return; // Get breakpoint for window width and update parameters

  var breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
  if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
  var breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;

  if (breakpointOnlyParams) {
    ['slidesPerView', 'spaceBetween', 'slidesPerGroup', 'slidesPerGroupSkip', 'slidesPerColumn'].forEach(function (param) {
      var paramValue = breakpointOnlyParams[param];
      if (typeof paramValue === 'undefined') return;

      if (param === 'slidesPerView' && (paramValue === 'AUTO' || paramValue === 'auto')) {
        breakpointOnlyParams[param] = 'auto';
      } else if (param === 'slidesPerView') {
        breakpointOnlyParams[param] = parseFloat(paramValue);
      } else {
        breakpointOnlyParams[param] = parseInt(paramValue, 10);
      }
    });
  }

  var breakpointParams = breakpointOnlyParams || swiper.originalParams;
  var wasMultiRow = params.slidesPerColumn > 1;
  var isMultiRow = breakpointParams.slidesPerColumn > 1;
  var wasEnabled = params.enabled;

  if (wasMultiRow && !isMultiRow) {
    $el.removeClass(params.containerModifierClass + "multirow " + params.containerModifierClass + "multirow-column");
    swiper.emitContainerClasses();
  } else if (!wasMultiRow && isMultiRow) {
    $el.addClass(params.containerModifierClass + "multirow");

    if (breakpointParams.slidesPerColumnFill && breakpointParams.slidesPerColumnFill === 'column' || !breakpointParams.slidesPerColumnFill && params.slidesPerColumnFill === 'column') {
      $el.addClass(params.containerModifierClass + "multirow-column");
    }

    swiper.emitContainerClasses();
  }

  var directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
  var needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);

  if (directionChanged && initialized) {
    swiper.changeDirection();
  }

  (0,utils/* extend */.l7)(swiper.params, breakpointParams);
  var isEnabled = swiper.params.enabled;
  (0,utils/* extend */.l7)(swiper, {
    allowTouchMove: swiper.params.allowTouchMove,
    allowSlideNext: swiper.params.allowSlideNext,
    allowSlidePrev: swiper.params.allowSlidePrev
  });

  if (wasEnabled && !isEnabled) {
    swiper.disable();
  } else if (!wasEnabled && isEnabled) {
    swiper.enable();
  }

  swiper.currentBreakpoint = breakpoint;
  swiper.emit('_beforeBreakpoint', breakpointParams);

  if (needsReLoop && initialized) {
    swiper.loopDestroy();
    swiper.loopCreate();
    swiper.updateSlides();
    swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
  }

  swiper.emit('breakpoint', breakpointParams);
}
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/breakpoints/getBreakpoint.js

function getBreakpoint(breakpoints, base, containerEl) {
  if (base === void 0) {
    base = 'window';
  }

  if (!breakpoints || base === 'container' && !containerEl) return undefined;
  var breakpoint = false;
  var window = (0,ssr_window_esm/* getWindow */.Jj)();
  var currentHeight = base === 'window' ? window.innerHeight : containerEl.clientHeight;
  var points = Object.keys(breakpoints).map(function (point) {
    if (typeof point === 'string' && point.indexOf('@') === 0) {
      var minRatio = parseFloat(point.substr(1));
      var value = currentHeight * minRatio;
      return {
        value: value,
        point: point
      };
    }

    return {
      value: point,
      point: point
    };
  });
  points.sort(function (a, b) {
    return parseInt(a.value, 10) - parseInt(b.value, 10);
  });

  for (var i = 0; i < points.length; i += 1) {
    var _points$i = points[i],
        point = _points$i.point,
        value = _points$i.value;

    if (base === 'window') {
      if (window.matchMedia("(min-width: " + value + "px)").matches) {
        breakpoint = point;
      }
    } else if (value <= containerEl.clientWidth) {
      breakpoint = point;
    }
  }

  return breakpoint || 'max';
}
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/breakpoints/index.js


/* harmony default export */ var breakpoints = ({
  setBreakpoint: setBreakpoint,
  getBreakpoint: getBreakpoint
});
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/classes/addClasses.js
function prepareClasses(entries, prefix) {
  var resultClasses = [];
  entries.forEach(function (item) {
    if (typeof item === 'object') {
      Object.keys(item).forEach(function (classNames) {
        if (item[classNames]) {
          resultClasses.push(prefix + classNames);
        }
      });
    } else if (typeof item === 'string') {
      resultClasses.push(prefix + item);
    }
  });
  return resultClasses;
}

function addClasses() {
  var swiper = this;
  var classNames = swiper.classNames,
      params = swiper.params,
      rtl = swiper.rtl,
      $el = swiper.$el,
      device = swiper.device,
      support = swiper.support; // prettier-ignore

  var suffixes = prepareClasses(['initialized', params.direction, {
    'pointer-events': support.pointerEvents && !support.touch
  }, {
    'free-mode': params.freeMode
  }, {
    'autoheight': params.autoHeight
  }, {
    'rtl': rtl
  }, {
    'multirow': params.slidesPerColumn > 1
  }, {
    'multirow-column': params.slidesPerColumn > 1 && params.slidesPerColumnFill === 'column'
  }, {
    'android': device.android
  }, {
    'ios': device.ios
  }, {
    'css-mode': params.cssMode
  }], params.containerModifierClass);
  classNames.push.apply(classNames, suffixes);
  $el.addClass([].concat(classNames).join(' '));
  swiper.emitContainerClasses();
}
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/classes/removeClasses.js
function removeClasses() {
  var swiper = this;
  var $el = swiper.$el,
      classNames = swiper.classNames;
  $el.removeClass(classNames.join(' '));
  swiper.emitContainerClasses();
}
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/classes/index.js


/* harmony default export */ var classes = ({
  addClasses: addClasses,
  removeClasses: removeClasses
});
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/images/loadImage.js


function loadImage(imageEl, src, srcset, sizes, checkForComplete, callback) {
  var window = (0,ssr_window_esm/* getWindow */.Jj)();
  var image;

  function onReady() {
    if (callback) callback();
  }

  var isPicture = (0,dom/* default */.Z)(imageEl).parent('picture')[0];

  if (!isPicture && (!imageEl.complete || !checkForComplete)) {
    if (src) {
      image = new window.Image();
      image.onload = onReady;
      image.onerror = onReady;

      if (sizes) {
        image.sizes = sizes;
      }

      if (srcset) {
        image.srcset = srcset;
      }

      if (src) {
        image.src = src;
      }
    } else {
      onReady();
    }
  } else {
    // image already loaded...
    onReady();
  }
}
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/images/preloadImages.js
function preloadImages() {
  var swiper = this;
  swiper.imagesToLoad = swiper.$el.find('img');

  function onReady() {
    if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) return;
    if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;

    if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
      if (swiper.params.updateOnImagesReady) swiper.update();
      swiper.emit('imagesReady');
    }
  }

  for (var i = 0; i < swiper.imagesToLoad.length; i += 1) {
    var imageEl = swiper.imagesToLoad[i];
    swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute('src'), imageEl.srcset || imageEl.getAttribute('srcset'), imageEl.sizes || imageEl.getAttribute('sizes'), true, onReady);
  }
}
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/images/index.js


/* harmony default export */ var core_images = ({
  loadImage: loadImage,
  preloadImages: preloadImages
});
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/check-overflow/index.js
function checkOverflow() {
  var swiper = this;
  var params = swiper.params;
  var wasLocked = swiper.isLocked;
  var lastSlidePosition = swiper.slides.length > 0 && params.slidesOffsetBefore + params.spaceBetween * (swiper.slides.length - 1) + swiper.slides[0].offsetWidth * swiper.slides.length;

  if (params.slidesOffsetBefore && params.slidesOffsetAfter && lastSlidePosition) {
    swiper.isLocked = lastSlidePosition <= swiper.size;
  } else {
    swiper.isLocked = swiper.snapGrid.length === 1;
  }

  swiper.allowSlideNext = !swiper.isLocked;
  swiper.allowSlidePrev = !swiper.isLocked; // events

  if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? 'lock' : 'unlock');

  if (wasLocked && wasLocked !== swiper.isLocked) {
    swiper.isEnd = false;
    if (swiper.navigation) swiper.navigation.update();
  }
}

/* harmony default export */ var check_overflow = ({
  checkOverflow: checkOverflow
});
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/defaults.js
/* harmony default export */ var defaults = ({
  init: true,
  direction: 'horizontal',
  touchEventsTarget: 'container',
  initialSlide: 0,
  speed: 300,
  cssMode: false,
  updateOnWindowResize: true,
  resizeObserver: false,
  nested: false,
  createElements: false,
  enabled: true,
  focusableElements: 'input, select, option, textarea, button, video, label',
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: false,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: false,
  edgeSwipeThreshold: 20,
  // Free mode
  freeMode: false,
  freeModeMomentum: true,
  freeModeMomentumRatio: 1,
  freeModeMomentumBounce: true,
  freeModeMomentumBounceRatio: 1,
  freeModeMomentumVelocityRatio: 1,
  freeModeSticky: false,
  freeModeMinimumVelocity: 0.02,
  // Autoheight
  autoHeight: false,
  // Set wrapper width
  setWrapperSize: false,
  // Virtual Translate
  virtualTranslate: false,
  // Effects
  effect: 'slide',
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
  // Breakpoints
  breakpoints: undefined,
  breakpointsBase: 'window',
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerColumn: 1,
  slidesPerColumnFill: 'column',
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  centeredSlides: false,
  centeredSlidesBounds: false,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: true,
  centerInsufficientSlides: false,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: false,
  // Round length
  roundLengths: false,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: true,
  shortSwipes: true,
  longSwipes: true,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: true,
  allowTouchMove: true,
  threshold: 0,
  touchMoveStopPropagation: false,
  touchStartPreventDefault: true,
  touchStartForcePreventDefault: false,
  touchReleaseOnEdges: false,
  // Unique Navigation Elements
  uniqueNavElements: true,
  // Resistance
  resistance: true,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: false,
  watchSlidesVisibility: false,
  // Cursor
  grabCursor: false,
  // Clicks
  preventClicks: true,
  preventClicksPropagation: true,
  slideToClickedSlide: false,
  // Images
  preloadImages: true,
  updateOnImagesReady: true,
  // loop
  loop: false,
  loopAdditionalSlides: 0,
  loopedSlides: null,
  loopFillGroupWithBlank: false,
  loopPreventsSlide: true,
  // Swiping/no swiping
  allowSlidePrev: true,
  allowSlideNext: true,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: true,
  noSwipingClass: 'swiper-no-swiping',
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: true,
  // NS
  containerModifierClass: 'swiper-container-',
  // NEW
  slideClass: 'swiper-slide',
  slideBlankClass: 'swiper-slide-invisible-blank',
  slideActiveClass: 'swiper-slide-active',
  slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
  slideVisibleClass: 'swiper-slide-visible',
  slideDuplicateClass: 'swiper-slide-duplicate',
  slideNextClass: 'swiper-slide-next',
  slideDuplicateNextClass: 'swiper-slide-duplicate-next',
  slidePrevClass: 'swiper-slide-prev',
  slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
  wrapperClass: 'swiper-wrapper',
  // Callbacks
  runCallbacksOnInit: true,
  // Internals
  _emitClasses: false
});
;// CONCATENATED MODULE: ../node_modules/swiper/esm/components/core/core-class.js
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/* eslint no-param-reassign: "off" */























var prototypes = {
  modular: modular,
  eventsEmitter: events_emitter,
  update: update,
  translate: translate,
  transition: transition,
  slide: slide,
  loop: loop,
  grabCursor: grab_cursor,
  manipulation: manipulation,
  events: events,
  breakpoints: breakpoints,
  checkOverflow: check_overflow,
  classes: classes,
  images: core_images
};
var extendedDefaults = {};

var Swiper = /*#__PURE__*/function () {
  function Swiper() {
    var el;
    var params;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') {
      params = args[0];
    } else {
      el = args[0];
      params = args[1];
    }

    if (!params) params = {};
    params = (0,utils/* extend */.l7)({}, params);
    if (el && !params.el) params.el = el;

    if (params.el && (0,dom/* default */.Z)(params.el).length > 1) {
      var swipers = [];
      (0,dom/* default */.Z)(params.el).each(function (containerEl) {
        var newParams = (0,utils/* extend */.l7)({}, params, {
          el: containerEl
        });
        swipers.push(new Swiper(newParams));
      });
      return swipers;
    } // Swiper Instance


    var swiper = this;
    swiper.__swiper__ = true;
    swiper.support = getSupport();
    swiper.device = getDevice({
      userAgent: params.userAgent
    });
    swiper.browser = getBrowser();
    swiper.eventsListeners = {};
    swiper.eventsAnyListeners = [];

    if (typeof swiper.modules === 'undefined') {
      swiper.modules = {};
    }

    Object.keys(swiper.modules).forEach(function (moduleName) {
      var module = swiper.modules[moduleName];

      if (module.params) {
        var moduleParamName = Object.keys(module.params)[0];
        var moduleParams = module.params[moduleParamName];
        if (typeof moduleParams !== 'object' || moduleParams === null) return;

        if (['navigation', 'pagination', 'scrollbar'].indexOf(moduleParamName) >= 0 && params[moduleParamName] === true) {
          params[moduleParamName] = {
            auto: true
          };
        }

        if (!(moduleParamName in params && 'enabled' in moduleParams)) return;

        if (params[moduleParamName] === true) {
          params[moduleParamName] = {
            enabled: true
          };
        }

        if (typeof params[moduleParamName] === 'object' && !('enabled' in params[moduleParamName])) {
          params[moduleParamName].enabled = true;
        }

        if (!params[moduleParamName]) params[moduleParamName] = {
          enabled: false
        };
      }
    }); // Extend defaults with modules params

    var swiperParams = (0,utils/* extend */.l7)({}, defaults);
    swiper.useParams(swiperParams); // Extend defaults with passed params

    swiper.params = (0,utils/* extend */.l7)({}, swiperParams, extendedDefaults, params);
    swiper.originalParams = (0,utils/* extend */.l7)({}, swiper.params);
    swiper.passedParams = (0,utils/* extend */.l7)({}, params); // add event listeners

    if (swiper.params && swiper.params.on) {
      Object.keys(swiper.params.on).forEach(function (eventName) {
        swiper.on(eventName, swiper.params.on[eventName]);
      });
    }

    if (swiper.params && swiper.params.onAny) {
      swiper.onAny(swiper.params.onAny);
    } // Save Dom lib


    swiper.$ = dom/* default */.Z; // Extend Swiper

    (0,utils/* extend */.l7)(swiper, {
      enabled: swiper.params.enabled,
      el: el,
      // Classes
      classNames: [],
      // Slides
      slides: (0,dom/* default */.Z)(),
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      // isDirection
      isHorizontal: function isHorizontal() {
        return swiper.params.direction === 'horizontal';
      },
      isVertical: function isVertical() {
        return swiper.params.direction === 'vertical';
      },
      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: true,
      isEnd: false,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: false,
      // Locks
      allowSlideNext: swiper.params.allowSlideNext,
      allowSlidePrev: swiper.params.allowSlidePrev,
      // Touch Events
      touchEvents: function touchEvents() {
        var touch = ['touchstart', 'touchmove', 'touchend', 'touchcancel'];
        var desktop = ['mousedown', 'mousemove', 'mouseup'];

        if (swiper.support.pointerEvents) {
          desktop = ['pointerdown', 'pointermove', 'pointerup'];
        }

        swiper.touchEventsTouch = {
          start: touch[0],
          move: touch[1],
          end: touch[2],
          cancel: touch[3]
        };
        swiper.touchEventsDesktop = {
          start: desktop[0],
          move: desktop[1],
          end: desktop[2]
        };
        return swiper.support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
      }(),
      touchEventsData: {
        isTouched: undefined,
        isMoved: undefined,
        allowTouchCallbacks: undefined,
        touchStartTime: undefined,
        isScrolling: undefined,
        currentTranslate: undefined,
        startTranslate: undefined,
        allowThresholdMove: undefined,
        // Form elements to match
        focusableElements: swiper.params.focusableElements,
        // Last click time
        lastClickTime: (0,utils/* now */.zO)(),
        clickTimeout: undefined,
        // Velocities
        velocities: [],
        allowMomentumBounce: undefined,
        isTouchEvent: undefined,
        startMoving: undefined
      },
      // Clicks
      allowClick: true,
      // Touches
      allowTouchMove: swiper.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    }); // Install Modules

    swiper.useModules();
    swiper.emit('_swiper'); // Init

    if (swiper.params.init) {
      swiper.init();
    } // Return app instance


    return swiper;
  }

  var _proto = Swiper.prototype;

  _proto.enable = function enable() {
    var swiper = this;
    if (swiper.enabled) return;
    swiper.enabled = true;

    if (swiper.params.grabCursor) {
      swiper.setGrabCursor();
    }

    swiper.emit('enable');
  };

  _proto.disable = function disable() {
    var swiper = this;
    if (!swiper.enabled) return;
    swiper.enabled = false;

    if (swiper.params.grabCursor) {
      swiper.unsetGrabCursor();
    }

    swiper.emit('disable');
  };

  _proto.setProgress = function setProgress(progress, speed) {
    var swiper = this;
    progress = Math.min(Math.max(progress, 0), 1);
    var min = swiper.minTranslate();
    var max = swiper.maxTranslate();
    var current = (max - min) * progress + min;
    swiper.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  };

  _proto.emitContainerClasses = function emitContainerClasses() {
    var swiper = this;
    if (!swiper.params._emitClasses || !swiper.el) return;
    var classes = swiper.el.className.split(' ').filter(function (className) {
      return className.indexOf('swiper-container') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
    });
    swiper.emit('_containerClasses', classes.join(' '));
  };

  _proto.getSlideClasses = function getSlideClasses(slideEl) {
    var swiper = this;
    return slideEl.className.split(' ').filter(function (className) {
      return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
    }).join(' ');
  };

  _proto.emitSlidesClasses = function emitSlidesClasses() {
    var swiper = this;
    if (!swiper.params._emitClasses || !swiper.el) return;
    var updates = [];
    swiper.slides.each(function (slideEl) {
      var classNames = swiper.getSlideClasses(slideEl);
      updates.push({
        slideEl: slideEl,
        classNames: classNames
      });
      swiper.emit('_slideClass', slideEl, classNames);
    });
    swiper.emit('_slideClasses', updates);
  };

  _proto.slidesPerViewDynamic = function slidesPerViewDynamic() {
    var swiper = this;
    var params = swiper.params,
        slides = swiper.slides,
        slidesGrid = swiper.slidesGrid,
        swiperSize = swiper.size,
        activeIndex = swiper.activeIndex;
    var spv = 1;

    if (params.centeredSlides) {
      var slideSize = slides[activeIndex].swiperSlideSize;
      var breakLoop;

      for (var i = activeIndex + 1; i < slides.length; i += 1) {
        if (slides[i] && !breakLoop) {
          slideSize += slides[i].swiperSlideSize;
          spv += 1;
          if (slideSize > swiperSize) breakLoop = true;
        }
      }

      for (var _i = activeIndex - 1; _i >= 0; _i -= 1) {
        if (slides[_i] && !breakLoop) {
          slideSize += slides[_i].swiperSlideSize;
          spv += 1;
          if (slideSize > swiperSize) breakLoop = true;
        }
      }
    } else {
      for (var _i2 = activeIndex + 1; _i2 < slides.length; _i2 += 1) {
        if (slidesGrid[_i2] - slidesGrid[activeIndex] < swiperSize) {
          spv += 1;
        }
      }
    }

    return spv;
  };

  _proto.update = function update() {
    var swiper = this;
    if (!swiper || swiper.destroyed) return;
    var snapGrid = swiper.snapGrid,
        params = swiper.params; // Breakpoints

    if (params.breakpoints) {
      swiper.setBreakpoint();
    }

    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateProgress();
    swiper.updateSlidesClasses();

    function setTranslate() {
      var translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
      var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
      swiper.setTranslate(newTranslate);
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }

    var translated;

    if (swiper.params.freeMode) {
      setTranslate();

      if (swiper.params.autoHeight) {
        swiper.updateAutoHeight();
      }
    } else {
      if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
        translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
      } else {
        translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
      }

      if (!translated) {
        setTranslate();
      }
    }

    if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
      swiper.checkOverflow();
    }

    swiper.emit('update');
  };

  _proto.changeDirection = function changeDirection(newDirection, needUpdate) {
    if (needUpdate === void 0) {
      needUpdate = true;
    }

    var swiper = this;
    var currentDirection = swiper.params.direction;

    if (!newDirection) {
      // eslint-disable-next-line
      newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
    }

    if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') {
      return swiper;
    }

    swiper.$el.removeClass("" + swiper.params.containerModifierClass + currentDirection).addClass("" + swiper.params.containerModifierClass + newDirection);
    swiper.emitContainerClasses();
    swiper.params.direction = newDirection;
    swiper.slides.each(function (slideEl) {
      if (newDirection === 'vertical') {
        slideEl.style.width = '';
      } else {
        slideEl.style.height = '';
      }
    });
    swiper.emit('changeDirection');
    if (needUpdate) swiper.update();
    return swiper;
  };

  _proto.mount = function mount(el) {
    var swiper = this;
    if (swiper.mounted) return true; // Find el

    var $el = (0,dom/* default */.Z)(el || swiper.params.el);
    el = $el[0];

    if (!el) {
      return false;
    }

    el.swiper = swiper;

    var getWrapperSelector = function getWrapperSelector() {
      return "." + (swiper.params.wrapperClass || '').trim().split(' ').join('.');
    };

    var getWrapper = function getWrapper() {
      if (el && el.shadowRoot && el.shadowRoot.querySelector) {
        var res = (0,dom/* default */.Z)(el.shadowRoot.querySelector(getWrapperSelector())); // Children needs to return slot items

        res.children = function (options) {
          return $el.children(options);
        };

        return res;
      }

      return $el.children(getWrapperSelector());
    }; // Find Wrapper


    var $wrapperEl = getWrapper();

    if ($wrapperEl.length === 0 && swiper.params.createElements) {
      var document = (0,ssr_window_esm/* getDocument */.Me)();
      var wrapper = document.createElement('div');
      $wrapperEl = (0,dom/* default */.Z)(wrapper);
      wrapper.className = swiper.params.wrapperClass;
      $el.append(wrapper);
      $el.children("." + swiper.params.slideClass).each(function (slideEl) {
        $wrapperEl.append(slideEl);
      });
    }

    (0,utils/* extend */.l7)(swiper, {
      $el: $el,
      el: el,
      $wrapperEl: $wrapperEl,
      wrapperEl: $wrapperEl[0],
      mounted: true,
      // RTL
      rtl: el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl',
      rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
      wrongRTL: $wrapperEl.css('display') === '-webkit-box'
    });
    return true;
  };

  _proto.init = function init(el) {
    var swiper = this;
    if (swiper.initialized) return swiper;
    var mounted = swiper.mount(el);
    if (mounted === false) return swiper;
    swiper.emit('beforeInit'); // Set breakpoint

    if (swiper.params.breakpoints) {
      swiper.setBreakpoint();
    } // Add Classes


    swiper.addClasses(); // Create loop

    if (swiper.params.loop) {
      swiper.loopCreate();
    } // Update size


    swiper.updateSize(); // Update slides

    swiper.updateSlides();

    if (swiper.params.watchOverflow) {
      swiper.checkOverflow();
    } // Set Grab Cursor


    if (swiper.params.grabCursor && swiper.enabled) {
      swiper.setGrabCursor();
    }

    if (swiper.params.preloadImages) {
      swiper.preloadImages();
    } // Slide To Initial Slide


    if (swiper.params.loop) {
      swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit, false, true);
    } else {
      swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
    } // Attach events


    swiper.attachEvents(); // Init Flag

    swiper.initialized = true; // Emit

    swiper.emit('init');
    swiper.emit('afterInit');
    return swiper;
  };

  _proto.destroy = function destroy(deleteInstance, cleanStyles) {
    if (deleteInstance === void 0) {
      deleteInstance = true;
    }

    if (cleanStyles === void 0) {
      cleanStyles = true;
    }

    var swiper = this;
    var params = swiper.params,
        $el = swiper.$el,
        $wrapperEl = swiper.$wrapperEl,
        slides = swiper.slides;

    if (typeof swiper.params === 'undefined' || swiper.destroyed) {
      return null;
    }

    swiper.emit('beforeDestroy'); // Init Flag

    swiper.initialized = false; // Detach events

    swiper.detachEvents(); // Destroy loop

    if (params.loop) {
      swiper.loopDestroy();
    } // Cleanup styles


    if (cleanStyles) {
      swiper.removeClasses();
      $el.removeAttr('style');
      $wrapperEl.removeAttr('style');

      if (slides && slides.length) {
        slides.removeClass([params.slideVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass].join(' ')).removeAttr('style').removeAttr('data-swiper-slide-index');
      }
    }

    swiper.emit('destroy'); // Detach emitter events

    Object.keys(swiper.eventsListeners).forEach(function (eventName) {
      swiper.off(eventName);
    });

    if (deleteInstance !== false) {
      swiper.$el[0].swiper = null;
      (0,utils/* deleteProps */.cP)(swiper);
    }

    swiper.destroyed = true;
    return null;
  };

  Swiper.extendDefaults = function extendDefaults(newDefaults) {
    (0,utils/* extend */.l7)(extendedDefaults, newDefaults);
  };

  Swiper.installModule = function installModule(module) {
    if (!Swiper.prototype.modules) Swiper.prototype.modules = {};
    var name = module.name || Object.keys(Swiper.prototype.modules).length + "_" + (0,utils/* now */.zO)();
    Swiper.prototype.modules[name] = module;
  };

  Swiper.use = function use(module) {
    if (Array.isArray(module)) {
      module.forEach(function (m) {
        return Swiper.installModule(m);
      });
      return Swiper;
    }

    Swiper.installModule(module);
    return Swiper;
  };

  _createClass(Swiper, null, [{
    key: "extendedDefaults",
    get: function get() {
      return extendedDefaults;
    }
  }, {
    key: "defaults",
    get: function get() {
      return defaults;
    }
  }]);

  return Swiper;
}();

Object.keys(prototypes).forEach(function (prototypeGroup) {
  Object.keys(prototypes[prototypeGroup]).forEach(function (protoMethod) {
    Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
  });
});
Swiper.use([resize, observer]);
/* harmony default export */ var core_class = (Swiper);

/***/ }),

/***/ 77803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89617);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }


var Fade = {
  setTranslate: function setTranslate() {
    var swiper = this;
    var slides = swiper.slides;

    for (var i = 0; i < slides.length; i += 1) {
      var $slideEl = swiper.slides.eq(i);
      var offset = $slideEl[0].swiperSlideOffset;
      var tx = -offset;
      if (!swiper.params.virtualTranslate) tx -= swiper.translate;
      var ty = 0;

      if (!swiper.isHorizontal()) {
        ty = tx;
        tx = 0;
      }

      var slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs($slideEl[0].progress), 0) : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
      $slideEl.css({
        opacity: slideOpacity
      }).transform("translate3d(" + tx + "px, " + ty + "px, 0px)");
    }
  },
  setTransition: function setTransition(duration) {
    var swiper = this;
    var slides = swiper.slides,
        $wrapperEl = swiper.$wrapperEl;
    slides.transition(duration);

    if (swiper.params.virtualTranslate && duration !== 0) {
      var eventTriggered = false;
      slides.transitionEnd(function () {
        if (eventTriggered) return;
        if (!swiper || swiper.destroyed) return;
        eventTriggered = true;
        swiper.animating = false;
        var triggerEvents = ['webkitTransitionEnd', 'transitionend'];

        for (var i = 0; i < triggerEvents.length; i += 1) {
          $wrapperEl.trigger(triggerEvents[i]);
        }
      });
    }
  }
};
/* harmony default export */ __webpack_exports__["Z"] = ({
  name: 'effect-fade',
  params: {
    fadeEffect: {
      crossFade: false
    }
  },
  create: function create() {
    var swiper = this;
    (0,_utils_utils__WEBPACK_IMPORTED_MODULE_0__/* .bindModuleMethods */ .cR)(swiper, {
      fadeEffect: _extends({}, Fade)
    });
  },
  on: {
    beforeInit: function beforeInit(swiper) {
      if (swiper.params.effect !== 'fade') return;
      swiper.classNames.push(swiper.params.containerModifierClass + "fade");
      var overwriteParams = {
        slidesPerView: 1,
        slidesPerColumn: 1,
        slidesPerGroup: 1,
        watchSlidesProgress: true,
        spaceBetween: 0,
        virtualTranslate: true
      };
      (0,_utils_utils__WEBPACK_IMPORTED_MODULE_0__/* .extend */ .l7)(swiper.params, overwriteParams);
      (0,_utils_utils__WEBPACK_IMPORTED_MODULE_0__/* .extend */ .l7)(swiper.originalParams, overwriteParams);
    },
    setTranslate: function setTranslate(swiper) {
      if (swiper.params.effect !== 'fade') return;
      swiper.fadeEffect.setTranslate();
    },
    setTransition: function setTransition(swiper, duration) {
      if (swiper.params.effect !== 'fade') return;
      swiper.fadeEffect.setTransition(duration);
    }
  }
});

/***/ }),

/***/ 67296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _utils_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69680);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89617);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var Navigation = {
  toggleEl: function toggleEl($el, disabled) {
    $el[disabled ? 'addClass' : 'removeClass'](this.params.navigation.disabledClass);
    if ($el[0] && $el[0].tagName === 'BUTTON') $el[0].disabled = disabled;
  },
  update: function update() {
    // Update Navigation Buttons
    var swiper = this;
    var params = swiper.params.navigation;
    var toggleEl = swiper.navigation.toggleEl;
    if (swiper.params.loop) return;
    var _swiper$navigation = swiper.navigation,
        $nextEl = _swiper$navigation.$nextEl,
        $prevEl = _swiper$navigation.$prevEl;

    if ($prevEl && $prevEl.length > 0) {
      if (swiper.isBeginning) {
        toggleEl($prevEl, true);
      } else {
        toggleEl($prevEl, false);
      }

      if (swiper.params.watchOverflow && swiper.enabled) {
        $prevEl[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
      }
    }

    if ($nextEl && $nextEl.length > 0) {
      if (swiper.isEnd) {
        toggleEl($nextEl, true);
      } else {
        toggleEl($nextEl, false);
      }

      if (swiper.params.watchOverflow && swiper.enabled) {
        $nextEl[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
      }
    }
  },
  onPrevClick: function onPrevClick(e) {
    var swiper = this;
    e.preventDefault();
    if (swiper.isBeginning && !swiper.params.loop) return;
    swiper.slidePrev();
  },
  onNextClick: function onNextClick(e) {
    var swiper = this;
    e.preventDefault();
    if (swiper.isEnd && !swiper.params.loop) return;
    swiper.slideNext();
  },
  init: function init() {
    var swiper = this;
    var params = swiper.params.navigation;
    swiper.params.navigation = (0,_utils_utils__WEBPACK_IMPORTED_MODULE_1__/* .createElementIfNotDefined */ .Up)(swiper.$el, swiper.params.navigation, swiper.params.createElements, {
      nextEl: 'swiper-button-next',
      prevEl: 'swiper-button-prev'
    });
    if (!(params.nextEl || params.prevEl)) return;
    var $nextEl;
    var $prevEl;

    if (params.nextEl) {
      $nextEl = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(params.nextEl);

      if (swiper.params.uniqueNavElements && typeof params.nextEl === 'string' && $nextEl.length > 1 && swiper.$el.find(params.nextEl).length === 1) {
        $nextEl = swiper.$el.find(params.nextEl);
      }
    }

    if (params.prevEl) {
      $prevEl = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(params.prevEl);

      if (swiper.params.uniqueNavElements && typeof params.prevEl === 'string' && $prevEl.length > 1 && swiper.$el.find(params.prevEl).length === 1) {
        $prevEl = swiper.$el.find(params.prevEl);
      }
    }

    if ($nextEl && $nextEl.length > 0) {
      $nextEl.on('click', swiper.navigation.onNextClick);
    }

    if ($prevEl && $prevEl.length > 0) {
      $prevEl.on('click', swiper.navigation.onPrevClick);
    }

    (0,_utils_utils__WEBPACK_IMPORTED_MODULE_1__/* .extend */ .l7)(swiper.navigation, {
      $nextEl: $nextEl,
      nextEl: $nextEl && $nextEl[0],
      $prevEl: $prevEl,
      prevEl: $prevEl && $prevEl[0]
    });

    if (!swiper.enabled) {
      if ($nextEl) $nextEl.addClass(params.lockClass);
      if ($prevEl) $prevEl.addClass(params.lockClass);
    }
  },
  destroy: function destroy() {
    var swiper = this;
    var _swiper$navigation2 = swiper.navigation,
        $nextEl = _swiper$navigation2.$nextEl,
        $prevEl = _swiper$navigation2.$prevEl;

    if ($nextEl && $nextEl.length) {
      $nextEl.off('click', swiper.navigation.onNextClick);
      $nextEl.removeClass(swiper.params.navigation.disabledClass);
    }

    if ($prevEl && $prevEl.length) {
      $prevEl.off('click', swiper.navigation.onPrevClick);
      $prevEl.removeClass(swiper.params.navigation.disabledClass);
    }
  }
};
/* harmony default export */ __webpack_exports__["Z"] = ({
  name: 'navigation',
  params: {
    navigation: {
      nextEl: null,
      prevEl: null,
      hideOnClick: false,
      disabledClass: 'swiper-button-disabled',
      hiddenClass: 'swiper-button-hidden',
      lockClass: 'swiper-button-lock'
    }
  },
  create: function create() {
    var swiper = this;
    (0,_utils_utils__WEBPACK_IMPORTED_MODULE_1__/* .bindModuleMethods */ .cR)(swiper, {
      navigation: _extends({}, Navigation)
    });
  },
  on: {
    init: function init(swiper) {
      swiper.navigation.init();
      swiper.navigation.update();
    },
    toEdge: function toEdge(swiper) {
      swiper.navigation.update();
    },
    fromEdge: function fromEdge(swiper) {
      swiper.navigation.update();
    },
    destroy: function destroy(swiper) {
      swiper.navigation.destroy();
    },
    'enable disable': function enableDisable(swiper) {
      var _swiper$navigation3 = swiper.navigation,
          $nextEl = _swiper$navigation3.$nextEl,
          $prevEl = _swiper$navigation3.$prevEl;

      if ($nextEl) {
        $nextEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
      }

      if ($prevEl) {
        $prevEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
      }
    },
    click: function click(swiper, e) {
      var _swiper$navigation4 = swiper.navigation,
          $nextEl = _swiper$navigation4.$nextEl,
          $prevEl = _swiper$navigation4.$prevEl;
      var targetEl = e.target;

      if (swiper.params.navigation.hideOnClick && !(0,_utils_dom__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(targetEl).is($prevEl) && !(0,_utils_dom__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(targetEl).is($nextEl)) {
        if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
        var isHidden;

        if ($nextEl) {
          isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
        } else if ($prevEl) {
          isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
        }

        if (isHidden === true) {
          swiper.emit('navigationShow');
        } else {
          swiper.emit('navigationHide');
        }

        if ($nextEl) {
          $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
        }

        if ($prevEl) {
          $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
        }
      }
    }
  }
});

/***/ }),

/***/ 71403:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _utils_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69680);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89617);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var Pagination = {
  update: function update() {
    // Render || Update Pagination bullets/items
    var swiper = this;
    var rtl = swiper.rtl;
    var params = swiper.params.pagination;
    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
    var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    var $el = swiper.pagination.$el; // Current/Total

    var current;
    var total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;

    if (swiper.params.loop) {
      current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);

      if (current > slidesLength - 1 - swiper.loopedSlides * 2) {
        current -= slidesLength - swiper.loopedSlides * 2;
      }

      if (current > total - 1) current -= total;
      if (current < 0 && swiper.params.paginationType !== 'bullets') current = total + current;
    } else if (typeof swiper.snapIndex !== 'undefined') {
      current = swiper.snapIndex;
    } else {
      current = swiper.activeIndex || 0;
    } // Types


    if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
      var bullets = swiper.pagination.bullets;
      var firstIndex;
      var lastIndex;
      var midIndex;

      if (params.dynamicBullets) {
        swiper.pagination.bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
        $el.css(swiper.isHorizontal() ? 'width' : 'height', swiper.pagination.bulletSize * (params.dynamicMainBullets + 4) + "px");

        if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
          swiper.pagination.dynamicBulletIndex += current - swiper.previousIndex;

          if (swiper.pagination.dynamicBulletIndex > params.dynamicMainBullets - 1) {
            swiper.pagination.dynamicBulletIndex = params.dynamicMainBullets - 1;
          } else if (swiper.pagination.dynamicBulletIndex < 0) {
            swiper.pagination.dynamicBulletIndex = 0;
          }
        }

        firstIndex = current - swiper.pagination.dynamicBulletIndex;
        lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
        midIndex = (lastIndex + firstIndex) / 2;
      }

      bullets.removeClass(params.bulletActiveClass + " " + params.bulletActiveClass + "-next " + params.bulletActiveClass + "-next-next " + params.bulletActiveClass + "-prev " + params.bulletActiveClass + "-prev-prev " + params.bulletActiveClass + "-main");

      if ($el.length > 1) {
        bullets.each(function (bullet) {
          var $bullet = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(bullet);
          var bulletIndex = $bullet.index();

          if (bulletIndex === current) {
            $bullet.addClass(params.bulletActiveClass);
          }

          if (params.dynamicBullets) {
            if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
              $bullet.addClass(params.bulletActiveClass + "-main");
            }

            if (bulletIndex === firstIndex) {
              $bullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
            }

            if (bulletIndex === lastIndex) {
              $bullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
            }
          }
        });
      } else {
        var $bullet = bullets.eq(current);
        var bulletIndex = $bullet.index();
        $bullet.addClass(params.bulletActiveClass);

        if (params.dynamicBullets) {
          var $firstDisplayedBullet = bullets.eq(firstIndex);
          var $lastDisplayedBullet = bullets.eq(lastIndex);

          for (var i = firstIndex; i <= lastIndex; i += 1) {
            bullets.eq(i).addClass(params.bulletActiveClass + "-main");
          }

          if (swiper.params.loop) {
            if (bulletIndex >= bullets.length - params.dynamicMainBullets) {
              for (var _i = params.dynamicMainBullets; _i >= 0; _i -= 1) {
                bullets.eq(bullets.length - _i).addClass(params.bulletActiveClass + "-main");
              }

              bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass(params.bulletActiveClass + "-prev");
            } else {
              $firstDisplayedBullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
              $lastDisplayedBullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
            }
          } else {
            $firstDisplayedBullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
            $lastDisplayedBullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
          }
        }
      }

      if (params.dynamicBullets) {
        var dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
        var bulletsOffset = (swiper.pagination.bulletSize * dynamicBulletsLength - swiper.pagination.bulletSize) / 2 - midIndex * swiper.pagination.bulletSize;
        var offsetProp = rtl ? 'right' : 'left';
        bullets.css(swiper.isHorizontal() ? offsetProp : 'top', bulletsOffset + "px");
      }
    }

    if (params.type === 'fraction') {
      $el.find((0,_utils_utils__WEBPACK_IMPORTED_MODULE_1__/* .classesToSelector */ .Wc)(params.currentClass)).text(params.formatFractionCurrent(current + 1));
      $el.find((0,_utils_utils__WEBPACK_IMPORTED_MODULE_1__/* .classesToSelector */ .Wc)(params.totalClass)).text(params.formatFractionTotal(total));
    }

    if (params.type === 'progressbar') {
      var progressbarDirection;

      if (params.progressbarOpposite) {
        progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
      } else {
        progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
      }

      var scale = (current + 1) / total;
      var scaleX = 1;
      var scaleY = 1;

      if (progressbarDirection === 'horizontal') {
        scaleX = scale;
      } else {
        scaleY = scale;
      }

      $el.find((0,_utils_utils__WEBPACK_IMPORTED_MODULE_1__/* .classesToSelector */ .Wc)(params.progressbarFillClass)).transform("translate3d(0,0,0) scaleX(" + scaleX + ") scaleY(" + scaleY + ")").transition(swiper.params.speed);
    }

    if (params.type === 'custom' && params.renderCustom) {
      $el.html(params.renderCustom(swiper, current + 1, total));
      swiper.emit('paginationRender', $el[0]);
    } else {
      swiper.emit('paginationUpdate', $el[0]);
    }

    if (swiper.params.watchOverflow && swiper.enabled) {
      $el[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
    }
  },
  render: function render() {
    // Render Container
    var swiper = this;
    var params = swiper.params.pagination;
    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
    var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    var $el = swiper.pagination.$el;
    var paginationHTML = '';

    if (params.type === 'bullets') {
      var numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;

      if (swiper.params.freeMode && !swiper.params.loop && numberOfBullets > slidesLength) {
        numberOfBullets = slidesLength;
      }

      for (var i = 0; i < numberOfBullets; i += 1) {
        if (params.renderBullet) {
          paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
        } else {
          paginationHTML += "<" + params.bulletElement + " class=\"" + params.bulletClass + "\"></" + params.bulletElement + ">";
        }
      }

      $el.html(paginationHTML);
      swiper.pagination.bullets = $el.find((0,_utils_utils__WEBPACK_IMPORTED_MODULE_1__/* .classesToSelector */ .Wc)(params.bulletClass));
    }

    if (params.type === 'fraction') {
      if (params.renderFraction) {
        paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
      } else {
        paginationHTML = "<span class=\"" + params.currentClass + "\"></span>" + ' / ' + ("<span class=\"" + params.totalClass + "\"></span>");
      }

      $el.html(paginationHTML);
    }

    if (params.type === 'progressbar') {
      if (params.renderProgressbar) {
        paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
      } else {
        paginationHTML = "<span class=\"" + params.progressbarFillClass + "\"></span>";
      }

      $el.html(paginationHTML);
    }

    if (params.type !== 'custom') {
      swiper.emit('paginationRender', swiper.pagination.$el[0]);
    }
  },
  init: function init() {
    var swiper = this;
    swiper.params.pagination = (0,_utils_utils__WEBPACK_IMPORTED_MODULE_1__/* .createElementIfNotDefined */ .Up)(swiper.$el, swiper.params.pagination, swiper.params.createElements, {
      el: 'swiper-pagination'
    });
    var params = swiper.params.pagination;
    if (!params.el) return;
    var $el = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(params.el);
    if ($el.length === 0) return;

    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1) {
      $el = swiper.$el.find(params.el);
    }

    if (params.type === 'bullets' && params.clickable) {
      $el.addClass(params.clickableClass);
    }

    $el.addClass(params.modifierClass + params.type);

    if (params.type === 'bullets' && params.dynamicBullets) {
      $el.addClass("" + params.modifierClass + params.type + "-dynamic");
      swiper.pagination.dynamicBulletIndex = 0;

      if (params.dynamicMainBullets < 1) {
        params.dynamicMainBullets = 1;
      }
    }

    if (params.type === 'progressbar' && params.progressbarOpposite) {
      $el.addClass(params.progressbarOppositeClass);
    }

    if (params.clickable) {
      $el.on('click', (0,_utils_utils__WEBPACK_IMPORTED_MODULE_1__/* .classesToSelector */ .Wc)(params.bulletClass), function onClick(e) {
        e.preventDefault();
        var index = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this).index() * swiper.params.slidesPerGroup;
        if (swiper.params.loop) index += swiper.loopedSlides;
        swiper.slideTo(index);
      });
    }

    (0,_utils_utils__WEBPACK_IMPORTED_MODULE_1__/* .extend */ .l7)(swiper.pagination, {
      $el: $el,
      el: $el[0]
    });

    if (!swiper.enabled) {
      $el.addClass(params.lockClass);
    }
  },
  destroy: function destroy() {
    var swiper = this;
    var params = swiper.params.pagination;
    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
    var $el = swiper.pagination.$el;
    $el.removeClass(params.hiddenClass);
    $el.removeClass(params.modifierClass + params.type);
    if (swiper.pagination.bullets) swiper.pagination.bullets.removeClass(params.bulletActiveClass);

    if (params.clickable) {
      $el.off('click', (0,_utils_utils__WEBPACK_IMPORTED_MODULE_1__/* .classesToSelector */ .Wc)(params.bulletClass));
    }
  }
};
/* harmony default export */ __webpack_exports__["Z"] = ({
  name: 'pagination',
  params: {
    pagination: {
      el: null,
      bulletElement: 'span',
      clickable: false,
      hideOnClick: false,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: false,
      type: 'bullets',
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: false,
      dynamicMainBullets: 1,
      formatFractionCurrent: function formatFractionCurrent(number) {
        return number;
      },
      formatFractionTotal: function formatFractionTotal(number) {
        return number;
      },
      bulletClass: 'swiper-pagination-bullet',
      bulletActiveClass: 'swiper-pagination-bullet-active',
      modifierClass: 'swiper-pagination-',
      // NEW
      currentClass: 'swiper-pagination-current',
      totalClass: 'swiper-pagination-total',
      hiddenClass: 'swiper-pagination-hidden',
      progressbarFillClass: 'swiper-pagination-progressbar-fill',
      progressbarOppositeClass: 'swiper-pagination-progressbar-opposite',
      clickableClass: 'swiper-pagination-clickable',
      // NEW
      lockClass: 'swiper-pagination-lock'
    }
  },
  create: function create() {
    var swiper = this;
    (0,_utils_utils__WEBPACK_IMPORTED_MODULE_1__/* .bindModuleMethods */ .cR)(swiper, {
      pagination: _extends({
        dynamicBulletIndex: 0
      }, Pagination)
    });
  },
  on: {
    init: function init(swiper) {
      swiper.pagination.init();
      swiper.pagination.render();
      swiper.pagination.update();
    },
    activeIndexChange: function activeIndexChange(swiper) {
      if (swiper.params.loop) {
        swiper.pagination.update();
      } else if (typeof swiper.snapIndex === 'undefined') {
        swiper.pagination.update();
      }
    },
    snapIndexChange: function snapIndexChange(swiper) {
      if (!swiper.params.loop) {
        swiper.pagination.update();
      }
    },
    slidesLengthChange: function slidesLengthChange(swiper) {
      if (swiper.params.loop) {
        swiper.pagination.render();
        swiper.pagination.update();
      }
    },
    snapGridLengthChange: function snapGridLengthChange(swiper) {
      if (!swiper.params.loop) {
        swiper.pagination.render();
        swiper.pagination.update();
      }
    },
    destroy: function destroy(swiper) {
      swiper.pagination.destroy();
    },
    'enable disable': function enableDisable(swiper) {
      var $el = swiper.pagination.$el;

      if ($el) {
        $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.pagination.lockClass);
      }
    },
    click: function click(swiper, e) {
      var targetEl = e.target;

      if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && swiper.pagination.$el.length > 0 && !(0,_utils_dom__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(targetEl).hasClass(swiper.params.pagination.bulletClass)) {
        if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
        var isHidden = swiper.pagination.$el.hasClass(swiper.params.pagination.hiddenClass);

        if (isHidden === true) {
          swiper.emit('paginationShow');
        } else {
          swiper.emit('paginationHide');
        }

        swiper.pagination.$el.toggleClass(swiper.params.pagination.hiddenClass);
      }
    }
  }
});

/***/ }),

/***/ 57987:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var ssr_window__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95469);
/* harmony import */ var _utils_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69680);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89617);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }




var Scrollbar = {
  setTranslate: function setTranslate() {
    var swiper = this;
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    var scrollbar = swiper.scrollbar,
        rtl = swiper.rtlTranslate,
        progress = swiper.progress;
    var dragSize = scrollbar.dragSize,
        trackSize = scrollbar.trackSize,
        $dragEl = scrollbar.$dragEl,
        $el = scrollbar.$el;
    var params = swiper.params.scrollbar;
    var newSize = dragSize;
    var newPos = (trackSize - dragSize) * progress;

    if (rtl) {
      newPos = -newPos;

      if (newPos > 0) {
        newSize = dragSize - newPos;
        newPos = 0;
      } else if (-newPos + dragSize > trackSize) {
        newSize = trackSize + newPos;
      }
    } else if (newPos < 0) {
      newSize = dragSize + newPos;
      newPos = 0;
    } else if (newPos + dragSize > trackSize) {
      newSize = trackSize - newPos;
    }

    if (swiper.isHorizontal()) {
      $dragEl.transform("translate3d(" + newPos + "px, 0, 0)");
      $dragEl[0].style.width = newSize + "px";
    } else {
      $dragEl.transform("translate3d(0px, " + newPos + "px, 0)");
      $dragEl[0].style.height = newSize + "px";
    }

    if (params.hide) {
      clearTimeout(swiper.scrollbar.timeout);
      $el[0].style.opacity = 1;
      swiper.scrollbar.timeout = setTimeout(function () {
        $el[0].style.opacity = 0;
        $el.transition(400);
      }, 1000);
    }
  },
  setTransition: function setTransition(duration) {
    var swiper = this;
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    swiper.scrollbar.$dragEl.transition(duration);
  },
  updateSize: function updateSize() {
    var swiper = this;
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    var scrollbar = swiper.scrollbar;
    var $dragEl = scrollbar.$dragEl,
        $el = scrollbar.$el;
    $dragEl[0].style.width = '';
    $dragEl[0].style.height = '';
    var trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;
    var divider = swiper.size / swiper.virtualSize;
    var moveDivider = divider * (trackSize / swiper.size);
    var dragSize;

    if (swiper.params.scrollbar.dragSize === 'auto') {
      dragSize = trackSize * divider;
    } else {
      dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
    }

    if (swiper.isHorizontal()) {
      $dragEl[0].style.width = dragSize + "px";
    } else {
      $dragEl[0].style.height = dragSize + "px";
    }

    if (divider >= 1) {
      $el[0].style.display = 'none';
    } else {
      $el[0].style.display = '';
    }

    if (swiper.params.scrollbar.hide) {
      $el[0].style.opacity = 0;
    }

    (0,_utils_utils__WEBPACK_IMPORTED_MODULE_2__/* .extend */ .l7)(scrollbar, {
      trackSize: trackSize,
      divider: divider,
      moveDivider: moveDivider,
      dragSize: dragSize
    });

    if (swiper.params.watchOverflow && swiper.enabled) {
      scrollbar.$el[swiper.isLocked ? 'addClass' : 'removeClass'](swiper.params.scrollbar.lockClass);
    }
  },
  getPointerPosition: function getPointerPosition(e) {
    var swiper = this;

    if (swiper.isHorizontal()) {
      return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientX : e.clientX;
    }

    return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientY : e.clientY;
  },
  setDragPosition: function setDragPosition(e) {
    var swiper = this;
    var scrollbar = swiper.scrollbar,
        rtl = swiper.rtlTranslate;
    var $el = scrollbar.$el,
        dragSize = scrollbar.dragSize,
        trackSize = scrollbar.trackSize,
        dragStartPos = scrollbar.dragStartPos;
    var positionRatio;
    positionRatio = (scrollbar.getPointerPosition(e) - $el.offset()[swiper.isHorizontal() ? 'left' : 'top'] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
    positionRatio = Math.max(Math.min(positionRatio, 1), 0);

    if (rtl) {
      positionRatio = 1 - positionRatio;
    }

    var position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
    swiper.updateProgress(position);
    swiper.setTranslate(position);
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  },
  onDragStart: function onDragStart(e) {
    var swiper = this;
    var params = swiper.params.scrollbar;
    var scrollbar = swiper.scrollbar,
        $wrapperEl = swiper.$wrapperEl;
    var $el = scrollbar.$el,
        $dragEl = scrollbar.$dragEl;
    swiper.scrollbar.isTouched = true;
    swiper.scrollbar.dragStartPos = e.target === $dragEl[0] || e.target === $dragEl ? scrollbar.getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
    e.preventDefault();
    e.stopPropagation();
    $wrapperEl.transition(100);
    $dragEl.transition(100);
    scrollbar.setDragPosition(e);
    clearTimeout(swiper.scrollbar.dragTimeout);
    $el.transition(0);

    if (params.hide) {
      $el.css('opacity', 1);
    }

    if (swiper.params.cssMode) {
      swiper.$wrapperEl.css('scroll-snap-type', 'none');
    }

    swiper.emit('scrollbarDragStart', e);
  },
  onDragMove: function onDragMove(e) {
    var swiper = this;
    var scrollbar = swiper.scrollbar,
        $wrapperEl = swiper.$wrapperEl;
    var $el = scrollbar.$el,
        $dragEl = scrollbar.$dragEl;
    if (!swiper.scrollbar.isTouched) return;
    if (e.preventDefault) e.preventDefault();else e.returnValue = false;
    scrollbar.setDragPosition(e);
    $wrapperEl.transition(0);
    $el.transition(0);
    $dragEl.transition(0);
    swiper.emit('scrollbarDragMove', e);
  },
  onDragEnd: function onDragEnd(e) {
    var swiper = this;
    var params = swiper.params.scrollbar;
    var scrollbar = swiper.scrollbar,
        $wrapperEl = swiper.$wrapperEl;
    var $el = scrollbar.$el;
    if (!swiper.scrollbar.isTouched) return;
    swiper.scrollbar.isTouched = false;

    if (swiper.params.cssMode) {
      swiper.$wrapperEl.css('scroll-snap-type', '');
      $wrapperEl.transition('');
    }

    if (params.hide) {
      clearTimeout(swiper.scrollbar.dragTimeout);
      swiper.scrollbar.dragTimeout = (0,_utils_utils__WEBPACK_IMPORTED_MODULE_2__/* .nextTick */ .Y3)(function () {
        $el.css('opacity', 0);
        $el.transition(400);
      }, 1000);
    }

    swiper.emit('scrollbarDragEnd', e);

    if (params.snapOnRelease) {
      swiper.slideToClosest();
    }
  },
  enableDraggable: function enableDraggable() {
    var swiper = this;
    if (!swiper.params.scrollbar.el) return;
    var document = (0,ssr_window__WEBPACK_IMPORTED_MODULE_0__/* .getDocument */ .Me)();
    var scrollbar = swiper.scrollbar,
        touchEventsTouch = swiper.touchEventsTouch,
        touchEventsDesktop = swiper.touchEventsDesktop,
        params = swiper.params,
        support = swiper.support;
    var $el = scrollbar.$el;
    var target = $el[0];
    var activeListener = support.passiveListener && params.passiveListeners ? {
      passive: false,
      capture: false
    } : false;
    var passiveListener = support.passiveListener && params.passiveListeners ? {
      passive: true,
      capture: false
    } : false;
    if (!target) return;

    if (!support.touch) {
      target.addEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
      document.addEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
      document.addEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
    } else {
      target.addEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
      target.addEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
      target.addEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
    }
  },
  disableDraggable: function disableDraggable() {
    var swiper = this;
    if (!swiper.params.scrollbar.el) return;
    var document = (0,ssr_window__WEBPACK_IMPORTED_MODULE_0__/* .getDocument */ .Me)();
    var scrollbar = swiper.scrollbar,
        touchEventsTouch = swiper.touchEventsTouch,
        touchEventsDesktop = swiper.touchEventsDesktop,
        params = swiper.params,
        support = swiper.support;
    var $el = scrollbar.$el;
    var target = $el[0];
    var activeListener = support.passiveListener && params.passiveListeners ? {
      passive: false,
      capture: false
    } : false;
    var passiveListener = support.passiveListener && params.passiveListeners ? {
      passive: true,
      capture: false
    } : false;
    if (!target) return;

    if (!support.touch) {
      target.removeEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
      document.removeEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
      document.removeEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
    } else {
      target.removeEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
      target.removeEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
      target.removeEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
    }
  },
  init: function init() {
    var swiper = this;
    var scrollbar = swiper.scrollbar,
        $swiperEl = swiper.$el;
    swiper.params.scrollbar = (0,_utils_utils__WEBPACK_IMPORTED_MODULE_2__/* .createElementIfNotDefined */ .Up)($swiperEl, swiper.params.scrollbar, swiper.params.createElements, {
      el: 'swiper-scrollbar'
    });
    var params = swiper.params.scrollbar;
    if (!params.el) return;
    var $el = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(params.el);

    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && $swiperEl.find(params.el).length === 1) {
      $el = $swiperEl.find(params.el);
    }

    var $dragEl = $el.find("." + swiper.params.scrollbar.dragClass);

    if ($dragEl.length === 0) {
      $dragEl = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("<div class=\"" + swiper.params.scrollbar.dragClass + "\"></div>");
      $el.append($dragEl);
    }

    (0,_utils_utils__WEBPACK_IMPORTED_MODULE_2__/* .extend */ .l7)(scrollbar, {
      $el: $el,
      el: $el[0],
      $dragEl: $dragEl,
      dragEl: $dragEl[0]
    });

    if (params.draggable) {
      scrollbar.enableDraggable();
    }

    if ($el) {
      $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.scrollbar.lockClass);
    }
  },
  destroy: function destroy() {
    var swiper = this;
    swiper.scrollbar.disableDraggable();
  }
};
/* harmony default export */ __webpack_exports__["Z"] = ({
  name: 'scrollbar',
  params: {
    scrollbar: {
      el: null,
      dragSize: 'auto',
      hide: false,
      draggable: false,
      snapOnRelease: true,
      lockClass: 'swiper-scrollbar-lock',
      dragClass: 'swiper-scrollbar-drag'
    }
  },
  create: function create() {
    var swiper = this;
    (0,_utils_utils__WEBPACK_IMPORTED_MODULE_2__/* .bindModuleMethods */ .cR)(swiper, {
      scrollbar: _extends({
        isTouched: false,
        timeout: null,
        dragTimeout: null
      }, Scrollbar)
    });
  },
  on: {
    init: function init(swiper) {
      swiper.scrollbar.init();
      swiper.scrollbar.updateSize();
      swiper.scrollbar.setTranslate();
    },
    update: function update(swiper) {
      swiper.scrollbar.updateSize();
    },
    resize: function resize(swiper) {
      swiper.scrollbar.updateSize();
    },
    observerUpdate: function observerUpdate(swiper) {
      swiper.scrollbar.updateSize();
    },
    setTranslate: function setTranslate(swiper) {
      swiper.scrollbar.setTranslate();
    },
    setTransition: function setTransition(swiper, duration) {
      swiper.scrollbar.setTransition(duration);
    },
    'enable disable': function enableDisable(swiper) {
      var $el = swiper.scrollbar.$el;

      if ($el) {
        $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.scrollbar.lockClass);
      }
    },
    destroy: function destroy(swiper) {
      swiper.scrollbar.destroy();
    }
  }
});

/***/ }),

/***/ 95445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ SwiperSlide; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6259);
/* harmony import */ var _use_isomorphic_layout_effect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9143);
var _excluded = ["tag", "children", "className", "swiper", "zoom", "virtualIndex"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




var SwiperSlide = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_temp, externalRef) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$tag = _ref.tag,
      Tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      swiper = _ref.swiper,
      zoom = _ref.zoom,
      virtualIndex = _ref.virtualIndex,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  var slideElRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)('swiper-slide'),
      slideClasses = _useState[0],
      setSlideClasses = _useState[1];

  function updateClasses(swiper, el, classNames) {
    if (el === slideElRef.current) {
      setSlideClasses(classNames);
    }
  }

  (0,_use_isomorphic_layout_effect__WEBPACK_IMPORTED_MODULE_1__/* .useIsomorphicLayoutEffect */ .L)(function () {
    if (externalRef) {
      externalRef.current = slideElRef.current;
    }

    if (!slideElRef.current || !swiper) {
      return;
    }

    if (swiper.destroyed) {
      if (slideClasses !== 'swiper-slide') {
        setSlideClasses('swiper-slide');
      }

      return;
    }

    swiper.on('_slideClass', updateClasses); // eslint-disable-next-line

    return function () {
      if (!swiper) return;
      swiper.off('_slideClass', updateClasses);
    };
  });
  (0,_use_isomorphic_layout_effect__WEBPACK_IMPORTED_MODULE_1__/* .useIsomorphicLayoutEffect */ .L)(function () {
    if (swiper && slideElRef.current) {
      setSlideClasses(swiper.getSlideClasses(slideElRef.current));
    }
  }, [swiper]);
  var slideData;

  if (typeof children === 'function') {
    slideData = {
      isActive: slideClasses.indexOf('swiper-slide-active') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-active') >= 0,
      isVisible: slideClasses.indexOf('swiper-slide-visible') >= 0,
      isDuplicate: slideClasses.indexOf('swiper-slide-duplicate') >= 0,
      isPrev: slideClasses.indexOf('swiper-slide-prev') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-prev') >= 0,
      isNext: slideClasses.indexOf('swiper-slide-next') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-next') >= 0
    };
  }

  var renderChildren = function renderChildren() {
    return typeof children === 'function' ? children(slideData) : children;
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Tag, _extends({
    ref: slideElRef,
    className: (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .uniqueClasses */ .kI)("" + slideClasses + (className ? " " + className : '')),
    "data-swiper-slide-index": virtualIndex
  }, rest), zoom ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "swiper-zoom-container",
    "data-swiper-zoom": typeof zoom === 'number' ? zoom : undefined
  }, renderChildren()) : renderChildren());
});
SwiperSlide.displayName = 'SwiperSlide';


/***/ }),

/***/ 48148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "t": function() { return /* binding */ Swiper; }
});

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/swiper/esm/components/core/core-class.js + 66 modules
var core_class = __webpack_require__(77796);
// EXTERNAL MODULE: ../node_modules/swiper/esm/react/utils.js
var utils = __webpack_require__(6259);
;// CONCATENATED MODULE: ../node_modules/swiper/esm/react/params-list.js
/* underscore in name -> watch for changes */
var paramsList = ['init', '_direction', 'touchEventsTarget', 'initialSlide', '_speed', 'cssMode', 'updateOnWindowResize', 'resizeObserver', 'nested', 'focusableElements', '_enabled', '_width', '_height', 'preventInteractionOnTransition', 'userAgent', 'url', '_edgeSwipeDetection', '_edgeSwipeThreshold', '_freeMode', '_freeModeMomentum', '_freeModeMomentumRatio', '_freeModeMomentumBounce', '_freeModeMomentumBounceRatio', '_freeModeMomentumVelocityRatio', '_freeModeSticky', '_freeModeMinimumVelocity', '_autoHeight', 'setWrapperSize', 'virtualTranslate', '_effect', 'breakpoints', '_spaceBetween', '_slidesPerView', '_slidesPerColumn', '_slidesPerColumnFill', '_slidesPerGroup', '_slidesPerGroupSkip', '_centeredSlides', '_centeredSlidesBounds', '_slidesOffsetBefore', '_slidesOffsetAfter', 'normalizeSlideIndex', '_centerInsufficientSlides', '_watchOverflow', 'roundLengths', 'touchRatio', 'touchAngle', 'simulateTouch', '_shortSwipes', '_longSwipes', 'longSwipesRatio', 'longSwipesMs', '_followFinger', 'allowTouchMove', '_threshold', 'touchMoveStopPropagation', 'touchStartPreventDefault', 'touchStartForcePreventDefault', 'touchReleaseOnEdges', 'uniqueNavElements', '_resistance', '_resistanceRatio', '_watchSlidesProgress', '_watchSlidesVisibility', '_grabCursor', 'preventClicks', 'preventClicksPropagation', '_slideToClickedSlide', '_preloadImages', 'updateOnImagesReady', '_loop', '_loopAdditionalSlides', '_loopedSlides', '_loopFillGroupWithBlank', 'loopPreventsSlide', '_allowSlidePrev', '_allowSlideNext', '_swipeHandler', '_noSwiping', 'noSwipingClass', 'noSwipingSelector', 'passiveListeners', 'containerModifierClass', 'slideClass', 'slideBlankClass', 'slideActiveClass', 'slideDuplicateActiveClass', 'slideVisibleClass', 'slideDuplicateClass', 'slideNextClass', 'slideDuplicateNextClass', 'slidePrevClass', 'slideDuplicatePrevClass', 'wrapperClass', 'runCallbacksOnInit', 'observer', 'observeParents', 'observeSlideChildren', // modules
'a11y', 'autoplay', '_controller', 'coverflowEffect', 'cubeEffect', 'fadeEffect', 'flipEffect', 'hashNavigation', 'history', 'keyboard', 'lazy', 'mousewheel', '_navigation', '_pagination', 'parallax', '_scrollbar', '_thumbs', 'virtual', 'zoom'];

;// CONCATENATED MODULE: ../node_modules/swiper/esm/react/get-params.js
// eslint-disable-next-line




function getParams(obj) {
  if (obj === void 0) {
    obj = {};
  }

  var params = {
    on: {}
  };
  var events = {};
  var passedParams = {};
  (0,utils/* extend */.l7)(params, core_class/* default.defaults */.Z.defaults);
  (0,utils/* extend */.l7)(params, core_class/* default.extendedDefaults */.Z.extendedDefaults);
  params._emitClasses = true;
  params.init = false;
  var rest = {};
  var allowedParams = paramsList.map(function (key) {
    return key.replace(/_/, '');
  });
  Object.keys(obj).forEach(function (key) {
    if (allowedParams.indexOf(key) >= 0) {
      if ((0,utils/* isObject */.Kn)(obj[key])) {
        params[key] = {};
        passedParams[key] = {};
        (0,utils/* extend */.l7)(params[key], obj[key]);
        (0,utils/* extend */.l7)(passedParams[key], obj[key]);
      } else {
        params[key] = obj[key];
        passedParams[key] = obj[key];
      }
    } else if (key.search(/on[A-Z]/) === 0 && typeof obj[key] === 'function') {
      events["" + key[2].toLowerCase() + key.substr(3)] = obj[key];
    } else {
      rest[key] = obj[key];
    }
  });
  ['navigation', 'pagination', 'scrollbar'].forEach(function (key) {
    if (params[key] === true) params[key] = {};
    if (params[key] === false) delete params[key];
  });
  return {
    params: params,
    passedParams: passedParams,
    rest: rest,
    events: events
  };
}


;// CONCATENATED MODULE: ../node_modules/swiper/esm/react/init-swiper.js
// eslint-disable-next-line



function initSwiper(swiperParams) {
  return new core_class/* default */.Z(swiperParams);
}

function mountSwiper(_ref, swiperParams) {
  var el = _ref.el,
      nextEl = _ref.nextEl,
      prevEl = _ref.prevEl,
      paginationEl = _ref.paginationEl,
      scrollbarEl = _ref.scrollbarEl,
      swiper = _ref.swiper;

  if ((0,utils/* needsNavigation */.d7)(swiperParams) && nextEl && prevEl) {
    swiper.params.navigation.nextEl = nextEl;
    swiper.originalParams.navigation.nextEl = nextEl;
    swiper.params.navigation.prevEl = prevEl;
    swiper.originalParams.navigation.prevEl = prevEl;
  }

  if ((0,utils/* needsPagination */.fw)(swiperParams) && paginationEl) {
    swiper.params.pagination.el = paginationEl;
    swiper.originalParams.pagination.el = paginationEl;
  }

  if ((0,utils/* needsScrollbar */.XE)(swiperParams) && scrollbarEl) {
    swiper.params.scrollbar.el = scrollbarEl;
    swiper.originalParams.scrollbar.el = scrollbarEl;
  }

  swiper.init(el);
}


;// CONCATENATED MODULE: ../node_modules/swiper/esm/react/loop.js
 // eslint-disable-next-line



function calcLoopedSlides(slides, swiperParams) {
  var slidesPerViewParams = swiperParams.slidesPerView;

  if (swiperParams.breakpoints) {
    var breakpoint = core_class/* default.prototype.getBreakpoint */.Z.prototype.getBreakpoint(swiperParams.breakpoints);
    var breakpointOnlyParams = breakpoint in swiperParams.breakpoints ? swiperParams.breakpoints[breakpoint] : undefined;

    if (breakpointOnlyParams && breakpointOnlyParams.slidesPerView) {
      slidesPerViewParams = breakpointOnlyParams.slidesPerView;
    }
  }

  var loopedSlides = Math.ceil(parseFloat(swiperParams.loopedSlides || slidesPerViewParams, 10));
  loopedSlides += swiperParams.loopAdditionalSlides;

  if (loopedSlides > slides.length) {
    loopedSlides = slides.length;
  }

  return loopedSlides;
}

function renderLoop(swiper, slides, swiperParams) {
  var modifiedSlides = slides.map(function (child, index) {
    return /*#__PURE__*/react.cloneElement(child, {
      swiper: swiper,
      'data-swiper-slide-index': index
    });
  });

  function duplicateSlide(child, index, position) {
    return /*#__PURE__*/react.cloneElement(child, {
      key: child.key + "-duplicate-" + index + "-" + position,
      className: (child.props.className || '') + " " + swiperParams.slideDuplicateClass
    });
  }

  if (swiperParams.loopFillGroupWithBlank) {
    var blankSlidesNum = swiperParams.slidesPerGroup - modifiedSlides.length % swiperParams.slidesPerGroup;

    if (blankSlidesNum !== swiperParams.slidesPerGroup) {
      for (var i = 0; i < blankSlidesNum; i += 1) {
        var blankSlide = /*#__PURE__*/react.createElement("div", {
          className: swiperParams.slideClass + " " + swiperParams.slideBlankClass
        });
        modifiedSlides.push(blankSlide);
      }
    }
  }

  if (swiperParams.slidesPerView === 'auto' && !swiperParams.loopedSlides) {
    swiperParams.loopedSlides = modifiedSlides.length;
  }

  var loopedSlides = calcLoopedSlides(modifiedSlides, swiperParams);
  var prependSlides = [];
  var appendSlides = [];
  modifiedSlides.forEach(function (child, index) {
    if (index < loopedSlides) {
      appendSlides.push(duplicateSlide(child, index, 'prepend'));
    }

    if (index < modifiedSlides.length && index >= modifiedSlides.length - loopedSlides) {
      prependSlides.push(duplicateSlide(child, index, 'append'));
    }
  });

  if (swiper) {
    swiper.loopedSlides = loopedSlides;
  }

  return [].concat(prependSlides, modifiedSlides, appendSlides);
}


;// CONCATENATED MODULE: ../node_modules/swiper/esm/react/get-changed-params.js



function getChangedParams(swiperParams, oldParams, children, oldChildren) {
  var keys = [];
  if (!oldParams) return keys;

  var addKey = function addKey(key) {
    if (keys.indexOf(key) < 0) keys.push(key);
  };

  var oldChildrenKeys = oldChildren.map(function (child) {
    return child.key;
  });
  var childrenKeys = children.map(function (child) {
    return child.key;
  });
  if (oldChildrenKeys.join('') !== childrenKeys.join('')) addKey('children');
  if (oldChildren.length !== children.length) addKey('children');
  var watchParams = paramsList.filter(function (key) {
    return key[0] === '_';
  }).map(function (key) {
    return key.replace(/_/, '');
  });
  watchParams.forEach(function (key) {
    if (key in swiperParams && key in oldParams) {
      if ((0,utils/* isObject */.Kn)(swiperParams[key]) && (0,utils/* isObject */.Kn)(oldParams[key])) {
        var newKeys = Object.keys(swiperParams[key]);
        var oldKeys = Object.keys(oldParams[key]);

        if (newKeys.length !== oldKeys.length) {
          addKey(key);
        } else {
          newKeys.forEach(function (newKey) {
            if (swiperParams[key][newKey] !== oldParams[key][newKey]) {
              addKey(key);
            }
          });
          oldKeys.forEach(function (oldKey) {
            if (swiperParams[key][oldKey] !== oldParams[key][oldKey]) addKey(key);
          });
        }
      } else if (swiperParams[key] !== oldParams[key]) {
        addKey(key);
      }
    }
  });
  return keys;
}


;// CONCATENATED MODULE: ../node_modules/swiper/esm/react/get-children.js


function processChildren(c) {
  var slides = [];
  react.Children.toArray(c).forEach(function (child) {
    if (child.type && child.type.displayName === 'SwiperSlide') {
      slides.push(child);
    } else if (child.props && child.props.children) {
      processChildren(child.props.children).forEach(function (slide) {
        return slides.push(slide);
      });
    }
  });
  return slides;
}

function getChildren(c) {
  var slides = [];
  var slots = {
    'container-start': [],
    'container-end': [],
    'wrapper-start': [],
    'wrapper-end': []
  };
  react.Children.toArray(c).forEach(function (child) {
    if (child.type && child.type.displayName === 'SwiperSlide') {
      slides.push(child);
    } else if (child.props && child.props.slot && slots[child.props.slot]) {
      slots[child.props.slot].push(child);
    } else if (child.props && child.props.children) {
      var foundSlides = processChildren(child.props.children);

      if (foundSlides.length > 0) {
        foundSlides.forEach(function (slide) {
          return slides.push(slide);
        });
      } else {
        slots['container-end'].push(child);
      }
    } else {
      slots['container-end'].push(child);
    }
  });
  return {
    slides: slides,
    slots: slots
  };
}


;// CONCATENATED MODULE: ../node_modules/swiper/esm/react/update-swiper.js


function updateSwiper(_ref) {
  var swiper = _ref.swiper,
      slides = _ref.slides,
      passedParams = _ref.passedParams,
      changedParams = _ref.changedParams,
      nextEl = _ref.nextEl,
      prevEl = _ref.prevEl,
      scrollbarEl = _ref.scrollbarEl,
      paginationEl = _ref.paginationEl;
  var updateParams = changedParams.filter(function (key) {
    return key !== 'children' && key !== 'direction';
  });
  var currentParams = swiper.params,
      pagination = swiper.pagination,
      navigation = swiper.navigation,
      scrollbar = swiper.scrollbar,
      virtual = swiper.virtual,
      thumbs = swiper.thumbs;
  var needThumbsInit;
  var needControllerInit;
  var needPaginationInit;
  var needScrollbarInit;
  var needNavigationInit;

  if (changedParams.includes('thumbs') && passedParams.thumbs && passedParams.thumbs.swiper && currentParams.thumbs && !currentParams.thumbs.swiper) {
    needThumbsInit = true;
  }

  if (changedParams.includes('controller') && passedParams.controller && passedParams.controller.control && currentParams.controller && !currentParams.controller.control) {
    needControllerInit = true;
  }

  if (changedParams.includes('pagination') && passedParams.pagination && (passedParams.pagination.el || paginationEl) && (currentParams.pagination || currentParams.pagination === false) && pagination && !pagination.el) {
    needPaginationInit = true;
  }

  if (changedParams.includes('scrollbar') && passedParams.scrollbar && (passedParams.scrollbar.el || scrollbarEl) && (currentParams.scrollbar || currentParams.scrollbar === false) && scrollbar && !scrollbar.el) {
    needScrollbarInit = true;
  }

  if (changedParams.includes('navigation') && passedParams.navigation && (passedParams.navigation.prevEl || prevEl) && (passedParams.navigation.nextEl || nextEl) && (currentParams.navigation || currentParams.navigation === false) && navigation && !navigation.prevEl && !navigation.nextEl) {
    needNavigationInit = true;
  }

  var destroyModule = function destroyModule(mod) {
    if (!swiper[mod]) return;
    swiper[mod].destroy();

    if (mod === 'navigation') {
      currentParams[mod].prevEl = undefined;
      currentParams[mod].nextEl = undefined;
      swiper[mod].prevEl = undefined;
      swiper[mod].nextEl = undefined;
    } else {
      currentParams[mod].el = undefined;
      swiper[mod].el = undefined;
    }
  };

  updateParams.forEach(function (key) {
    if ((0,utils/* isObject */.Kn)(currentParams[key]) && (0,utils/* isObject */.Kn)(passedParams[key])) {
      (0,utils/* extend */.l7)(currentParams[key], passedParams[key]);
    } else {
      var newValue = passedParams[key];

      if ((newValue === true || newValue === false) && (key === 'navigation' || key === 'pagination' || key === 'scrollbar')) {
        if (newValue === false) {
          destroyModule(key);
        }
      } else {
        currentParams[key] = passedParams[key];
      }
    }
  });

  if (changedParams.includes('children') && virtual && currentParams.virtual.enabled) {
    virtual.slides = slides;
    virtual.update(true);
  } else if (changedParams.includes('children') && swiper.lazy && swiper.params.lazy.enabled) {
    swiper.lazy.load();
  }

  if (needThumbsInit) {
    var initialized = thumbs.init();
    if (initialized) thumbs.update(true);
  }

  if (needControllerInit) {
    swiper.controller.control = currentParams.controller.control;
  }

  if (needPaginationInit) {
    if (paginationEl) currentParams.pagination.el = paginationEl;
    pagination.init();
    pagination.render();
    pagination.update();
  }

  if (needScrollbarInit) {
    if (scrollbarEl) currentParams.scrollbar.el = scrollbarEl;
    scrollbar.init();
    scrollbar.updateSize();
    scrollbar.setTranslate();
  }

  if (needNavigationInit) {
    if (nextEl) currentParams.navigation.nextEl = nextEl;
    if (prevEl) currentParams.navigation.prevEl = prevEl;
    navigation.init();
    navigation.update();
  }

  if (changedParams.includes('allowSlideNext')) {
    swiper.allowSlideNext = passedParams.allowSlideNext;
  }

  if (changedParams.includes('allowSlidePrev')) {
    swiper.allowSlidePrev = passedParams.allowSlidePrev;
  }

  if (changedParams.includes('direction')) {
    swiper.changeDirection(passedParams.direction, false);
  }

  swiper.update();
}


;// CONCATENATED MODULE: ../node_modules/swiper/esm/react/virtual.js


function updateOnVirtualData(swiper) {
  if (!swiper || swiper.destroyed || !swiper.params.virtual || swiper.params.virtual && !swiper.params.virtual.enabled) return;
  swiper.updateSlides();
  swiper.updateProgress();
  swiper.updateSlidesClasses();

  if (swiper.lazy && swiper.params.lazy.enabled) {
    swiper.lazy.load();
  }

  if (swiper.parallax && swiper.params.parallax && swiper.params.parallax.enabled) {
    swiper.parallax.setTranslate();
  }
}

function renderVirtual(swiper, slides, virtualData) {
  var _ref;

  if (!virtualData) return null;
  var style = swiper.isHorizontal() ? (_ref = {}, _ref[swiper.rtlTranslate ? 'right' : 'left'] = virtualData.offset + "px", _ref) : {
    top: virtualData.offset + "px"
  };
  return slides.filter(function (child, index) {
    return index >= virtualData.from && index <= virtualData.to;
  }).map(function (child) {
    return /*#__PURE__*/react.cloneElement(child, {
      swiper: swiper,
      style: style
    });
  });
}


// EXTERNAL MODULE: ../node_modules/swiper/esm/react/use-isomorphic-layout-effect.js
var use_isomorphic_layout_effect = __webpack_require__(9143);
;// CONCATENATED MODULE: ../node_modules/swiper/esm/react/swiper.js
var _excluded = ["className", "tag", "wrapperTag", "children", "onSwiper"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }











var Swiper = /*#__PURE__*/(0,react.forwardRef)(function (_temp, externalElRef) {
  var _ref = _temp === void 0 ? {} : _temp,
      className = _ref.className,
      _ref$tag = _ref.tag,
      Tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      _ref$wrapperTag = _ref.wrapperTag,
      WrapperTag = _ref$wrapperTag === void 0 ? 'div' : _ref$wrapperTag,
      children = _ref.children,
      onSwiper = _ref.onSwiper,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  var eventsAssigned = false;

  var _useState = (0,react.useState)('swiper-container'),
      containerClasses = _useState[0],
      setContainerClasses = _useState[1];

  var _useState2 = (0,react.useState)(null),
      virtualData = _useState2[0],
      setVirtualData = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      breakpointChanged = _useState3[0],
      setBreakpointChanged = _useState3[1];

  var initializedRef = (0,react.useRef)(false);
  var swiperElRef = (0,react.useRef)(null);
  var swiperRef = (0,react.useRef)(null);
  var oldPassedParamsRef = (0,react.useRef)(null);
  var oldSlides = (0,react.useRef)(null);
  var nextElRef = (0,react.useRef)(null);
  var prevElRef = (0,react.useRef)(null);
  var paginationElRef = (0,react.useRef)(null);
  var scrollbarElRef = (0,react.useRef)(null);

  var _getParams = getParams(rest),
      swiperParams = _getParams.params,
      passedParams = _getParams.passedParams,
      restProps = _getParams.rest,
      events = _getParams.events;

  var _getChildren = getChildren(children),
      slides = _getChildren.slides,
      slots = _getChildren.slots;

  var onBeforeBreakpoint = function onBeforeBreakpoint() {
    setBreakpointChanged(!breakpointChanged);
  };

  Object.assign(swiperParams.on, {
    _containerClasses: function _containerClasses(swiper, classes) {
      setContainerClasses(classes);
    }
  });

  if (!swiperElRef.current) {
    // init swiper
    Object.assign(swiperParams.on, events);
    eventsAssigned = true;
    swiperRef.current = initSwiper(swiperParams);

    swiperRef.current.loopCreate = function () {};

    swiperRef.current.loopDestroy = function () {};

    if (swiperParams.loop) {
      swiperRef.current.loopedSlides = calcLoopedSlides(slides, swiperParams);
    }

    if (swiperRef.current.virtual && swiperRef.current.params.virtual.enabled) {
      swiperRef.current.virtual.slides = slides;
      var extendWith = {
        cache: false,
        renderExternal: setVirtualData,
        renderExternalUpdate: false
      };
      (0,utils/* extend */.l7)(swiperRef.current.params.virtual, extendWith);
      (0,utils/* extend */.l7)(swiperRef.current.originalParams.virtual, extendWith);
    }
  } // Listen for breakpoints change


  if (swiperRef.current) {
    swiperRef.current.on('_beforeBreakpoint', onBeforeBreakpoint);
  }

  var attachEvents = function attachEvents() {
    if (eventsAssigned || !events || !swiperRef.current) return;
    Object.keys(events).forEach(function (eventName) {
      swiperRef.current.on(eventName, events[eventName]);
    });
  };

  var detachEvents = function detachEvents() {
    if (!events || !swiperRef.current) return;
    Object.keys(events).forEach(function (eventName) {
      swiperRef.current.off(eventName, events[eventName]);
    });
  };

  (0,react.useEffect)(function () {
    return function () {
      if (swiperRef.current) swiperRef.current.off('_beforeBreakpoint', onBeforeBreakpoint);
    };
  }); // set initialized flag

  (0,react.useEffect)(function () {
    if (!initializedRef.current && swiperRef.current) {
      swiperRef.current.emitSlidesClasses();
      initializedRef.current = true;
    }
  }); // mount swiper

  (0,use_isomorphic_layout_effect/* useIsomorphicLayoutEffect */.L)(function () {
    if (externalElRef) {
      externalElRef.current = swiperElRef.current;
    }

    if (!swiperElRef.current) return;
    mountSwiper({
      el: swiperElRef.current,
      nextEl: nextElRef.current,
      prevEl: prevElRef.current,
      paginationEl: paginationElRef.current,
      scrollbarEl: scrollbarElRef.current,
      swiper: swiperRef.current
    }, swiperParams);
    if (onSwiper) onSwiper(swiperRef.current); // eslint-disable-next-line

    return function () {
      if (swiperRef.current && !swiperRef.current.destroyed) {
        swiperRef.current.destroy(true, false);
      }
    };
  }, []); // watch for params change

  (0,use_isomorphic_layout_effect/* useIsomorphicLayoutEffect */.L)(function () {
    attachEvents();
    var changedParams = getChangedParams(passedParams, oldPassedParamsRef.current, slides, oldSlides.current);
    oldPassedParamsRef.current = passedParams;
    oldSlides.current = slides;

    if (changedParams.length && swiperRef.current && !swiperRef.current.destroyed) {
      updateSwiper({
        swiper: swiperRef.current,
        slides: slides,
        passedParams: passedParams,
        changedParams: changedParams,
        nextEl: nextElRef.current,
        prevEl: prevElRef.current,
        scrollbarEl: scrollbarElRef.current,
        paginationEl: paginationElRef.current
      });
    }

    return function () {
      detachEvents();
    };
  }); // update on virtual update

  (0,use_isomorphic_layout_effect/* useIsomorphicLayoutEffect */.L)(function () {
    updateOnVirtualData(swiperRef.current);
  }, [virtualData]); // bypass swiper instance to slides

  function renderSlides() {
    if (swiperParams.virtual) {
      return renderVirtual(swiperRef.current, slides, virtualData);
    }

    if (!swiperParams.loop || swiperRef.current && swiperRef.current.destroyed) {
      return slides.map(function (child) {
        return /*#__PURE__*/react.cloneElement(child, {
          swiper: swiperRef.current
        });
      });
    }

    return renderLoop(swiperRef.current, slides, swiperParams);
  }

  return /*#__PURE__*/react.createElement(Tag, _extends({
    ref: swiperElRef,
    className: (0,utils/* uniqueClasses */.kI)("" + containerClasses + (className ? " " + className : ''))
  }, restProps), slots['container-start'], (0,utils/* needsNavigation */.d7)(swiperParams) && /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("div", {
    ref: prevElRef,
    className: "swiper-button-prev"
  }), /*#__PURE__*/react.createElement("div", {
    ref: nextElRef,
    className: "swiper-button-next"
  })), (0,utils/* needsScrollbar */.XE)(swiperParams) && /*#__PURE__*/react.createElement("div", {
    ref: scrollbarElRef,
    className: "swiper-scrollbar"
  }), (0,utils/* needsPagination */.fw)(swiperParams) && /*#__PURE__*/react.createElement("div", {
    ref: paginationElRef,
    className: "swiper-pagination"
  }), /*#__PURE__*/react.createElement(WrapperTag, {
    className: "swiper-wrapper"
  }, slots['wrapper-start'], renderSlides(), slots['wrapper-end']), slots['container-end']);
});
Swiper.displayName = 'Swiper';


/***/ }),

/***/ 9143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useIsomorphicLayoutEffect; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);


function useIsomorphicLayoutEffect(callback, deps) {
  // eslint-disable-next-line
  if (typeof window === 'undefined') return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(callback, deps);
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(callback, deps);
}



/***/ }),

/***/ 6259:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kn": function() { return /* binding */ isObject; },
/* harmony export */   "XE": function() { return /* binding */ needsScrollbar; },
/* harmony export */   "d7": function() { return /* binding */ needsNavigation; },
/* harmony export */   "fw": function() { return /* binding */ needsPagination; },
/* harmony export */   "kI": function() { return /* binding */ uniqueClasses; },
/* harmony export */   "l7": function() { return /* binding */ extend; }
/* harmony export */ });
function isObject(o) {
  return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}

function extend(target, src) {
  var noExtend = ['__proto__', 'constructor', 'prototype'];
  Object.keys(src).filter(function (key) {
    return noExtend.indexOf(key) < 0;
  }).forEach(function (key) {
    if (typeof target[key] === 'undefined') target[key] = src[key];else if (isObject(src[key]) && isObject(target[key]) && Object.keys(src[key]).length > 0) {
      if (src[key].__swiper__) target[key] = src[key];else extend(target[key], src[key]);
    } else {
      target[key] = src[key];
    }
  });
}

function needsNavigation(params) {
  if (params === void 0) {
    params = {};
  }

  return params.navigation && typeof params.navigation.nextEl === 'undefined' && typeof params.navigation.prevEl === 'undefined';
}

function needsPagination(params) {
  if (params === void 0) {
    params = {};
  }

  return params.pagination && typeof params.pagination.el === 'undefined';
}

function needsScrollbar(params) {
  if (params === void 0) {
    params = {};
  }

  return params.scrollbar && typeof params.scrollbar.el === 'undefined';
}

function uniqueClasses(classNames) {
  if (classNames === void 0) {
    classNames = '';
  }

  var classes = classNames.split(' ').map(function (c) {
    return c.trim();
  }).filter(function (c) {
    return !!c;
  });
  var unique = [];
  classes.forEach(function (c) {
    if (unique.indexOf(c) < 0) unique.push(c);
  });
  return unique.join(' ');
}



/***/ }),

/***/ 69680:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ dom; }
});

// EXTERNAL MODULE: ../node_modules/ssr-window/ssr-window.esm.js
var ssr_window_esm = __webpack_require__(95469);
;// CONCATENATED MODULE: ../node_modules/dom7/dom7.esm.js
/**
 * Dom7 3.0.0
 * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
 * https://framework7.io/docs/dom7.html
 *
 * Copyright 2020, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: November 9, 2020
 */


function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/* eslint-disable no-proto */
function makeReactive(obj) {
  var proto = obj.__proto__;
  Object.defineProperty(obj, '__proto__', {
    get: function get() {
      return proto;
    },
    set: function set(value) {
      proto.__proto__ = value;
    }
  });
}

var Dom7 = /*#__PURE__*/function (_Array) {
  _inheritsLoose(Dom7, _Array);

  function Dom7(items) {
    var _this;

    _this = _Array.call.apply(_Array, [this].concat(items)) || this;
    makeReactive(_assertThisInitialized(_this));
    return _this;
  }

  return Dom7;
}( /*#__PURE__*/_wrapNativeSuper(Array));

function arrayFlat(arr) {
  if (arr === void 0) {
    arr = [];
  }

  var res = [];
  arr.forEach(function (el) {
    if (Array.isArray(el)) {
      res.push.apply(res, arrayFlat(el));
    } else {
      res.push(el);
    }
  });
  return res;
}
function arrayFilter(arr, callback) {
  return Array.prototype.filter.call(arr, callback);
}
function arrayUnique(arr) {
  var uniqueArray = [];

  for (var i = 0; i < arr.length; i += 1) {
    if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
  }

  return uniqueArray;
}
function toCamelCase(string) {
  return string.toLowerCase().replace(/-(.)/g, function (match, group) {
    return group.toUpperCase();
  });
}

function qsa(selector, context) {
  if (typeof selector !== 'string') {
    return [selector];
  }

  var a = [];
  var res = context.querySelectorAll(selector);

  for (var i = 0; i < res.length; i += 1) {
    a.push(res[i]);
  }

  return a;
}

function $(selector, context) {
  var window = (0,ssr_window_esm/* getWindow */.Jj)();
  var document = (0,ssr_window_esm/* getDocument */.Me)();
  var arr = [];

  if (!context && selector instanceof Dom7) {
    return selector;
  }

  if (!selector) {
    return new Dom7(arr);
  }

  if (typeof selector === 'string') {
    var html = selector.trim();

    if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
      var toCreate = 'div';
      if (html.indexOf('<li') === 0) toCreate = 'ul';
      if (html.indexOf('<tr') === 0) toCreate = 'tbody';
      if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) toCreate = 'tr';
      if (html.indexOf('<tbody') === 0) toCreate = 'table';
      if (html.indexOf('<option') === 0) toCreate = 'select';
      var tempParent = document.createElement(toCreate);
      tempParent.innerHTML = html;

      for (var i = 0; i < tempParent.childNodes.length; i += 1) {
        arr.push(tempParent.childNodes[i]);
      }
    } else {
      arr = qsa(selector.trim(), context || document);
    } // arr = qsa(selector, document);

  } else if (selector.nodeType || selector === window || selector === document) {
    arr.push(selector);
  } else if (Array.isArray(selector)) {
    if (selector instanceof Dom7) return selector;
    arr = selector;
  }

  return new Dom7(arrayUnique(arr));
}

$.fn = Dom7.prototype;

function addClass() {
  for (var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++) {
    classes[_key] = arguments[_key];
  }

  var classNames = arrayFlat(classes.map(function (c) {
    return c.split(' ');
  }));
  this.forEach(function (el) {
    var _el$classList;

    (_el$classList = el.classList).add.apply(_el$classList, classNames);
  });
  return this;
}

function removeClass() {
  for (var _len2 = arguments.length, classes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    classes[_key2] = arguments[_key2];
  }

  var classNames = arrayFlat(classes.map(function (c) {
    return c.split(' ');
  }));
  this.forEach(function (el) {
    var _el$classList2;

    (_el$classList2 = el.classList).remove.apply(_el$classList2, classNames);
  });
  return this;
}

function toggleClass() {
  for (var _len3 = arguments.length, classes = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    classes[_key3] = arguments[_key3];
  }

  var classNames = arrayFlat(classes.map(function (c) {
    return c.split(' ');
  }));
  this.forEach(function (el) {
    classNames.forEach(function (className) {
      el.classList.toggle(className);
    });
  });
}

function hasClass() {
  for (var _len4 = arguments.length, classes = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    classes[_key4] = arguments[_key4];
  }

  var classNames = arrayFlat(classes.map(function (c) {
    return c.split(' ');
  }));
  return arrayFilter(this, function (el) {
    return classNames.filter(function (className) {
      return el.classList.contains(className);
    }).length > 0;
  }).length > 0;
}

function attr(attrs, value) {
  if (arguments.length === 1 && typeof attrs === 'string') {
    // Get attr
    if (this[0]) return this[0].getAttribute(attrs);
    return undefined;
  } // Set attrs


  for (var i = 0; i < this.length; i += 1) {
    if (arguments.length === 2) {
      // String
      this[i].setAttribute(attrs, value);
    } else {
      // Object
      for (var attrName in attrs) {
        this[i][attrName] = attrs[attrName];
        this[i].setAttribute(attrName, attrs[attrName]);
      }
    }
  }

  return this;
}

function removeAttr(attr) {
  for (var i = 0; i < this.length; i += 1) {
    this[i].removeAttribute(attr);
  }

  return this;
}

function prop(props, value) {
  if (arguments.length === 1 && typeof props === 'string') {
    // Get prop
    if (this[0]) return this[0][props];
  } else {
    // Set props
    for (var i = 0; i < this.length; i += 1) {
      if (arguments.length === 2) {
        // String
        this[i][props] = value;
      } else {
        // Object
        for (var propName in props) {
          this[i][propName] = props[propName];
        }
      }
    }

    return this;
  }

  return this;
}

function data(key, value) {
  var el;

  if (typeof value === 'undefined') {
    el = this[0];
    if (!el) return undefined; // Get value

    if (el.dom7ElementDataStorage && key in el.dom7ElementDataStorage) {
      return el.dom7ElementDataStorage[key];
    }

    var dataKey = el.getAttribute("data-" + key);

    if (dataKey) {
      return dataKey;
    }

    return undefined;
  } // Set value


  for (var i = 0; i < this.length; i += 1) {
    el = this[i];
    if (!el.dom7ElementDataStorage) el.dom7ElementDataStorage = {};
    el.dom7ElementDataStorage[key] = value;
  }

  return this;
}

function removeData(key) {
  for (var i = 0; i < this.length; i += 1) {
    var el = this[i];

    if (el.dom7ElementDataStorage && el.dom7ElementDataStorage[key]) {
      el.dom7ElementDataStorage[key] = null;
      delete el.dom7ElementDataStorage[key];
    }
  }
}

function dataset() {
  var el = this[0];
  if (!el) return undefined;
  var dataset = {}; // eslint-disable-line

  if (el.dataset) {
    for (var dataKey in el.dataset) {
      dataset[dataKey] = el.dataset[dataKey];
    }
  } else {
    for (var i = 0; i < el.attributes.length; i += 1) {
      var _attr = el.attributes[i];

      if (_attr.name.indexOf('data-') >= 0) {
        dataset[toCamelCase(_attr.name.split('data-')[1])] = _attr.value;
      }
    }
  }

  for (var key in dataset) {
    if (dataset[key] === 'false') dataset[key] = false;else if (dataset[key] === 'true') dataset[key] = true;else if (parseFloat(dataset[key]) === dataset[key] * 1) dataset[key] *= 1;
  }

  return dataset;
}

function val(value) {
  if (typeof value === 'undefined') {
    // get value
    var el = this[0];
    if (!el) return undefined;

    if (el.multiple && el.nodeName.toLowerCase() === 'select') {
      var values = [];

      for (var i = 0; i < el.selectedOptions.length; i += 1) {
        values.push(el.selectedOptions[i].value);
      }

      return values;
    }

    return el.value;
  } // set value


  for (var _i = 0; _i < this.length; _i += 1) {
    var _el = this[_i];

    if (Array.isArray(value) && _el.multiple && _el.nodeName.toLowerCase() === 'select') {
      for (var j = 0; j < _el.options.length; j += 1) {
        _el.options[j].selected = value.indexOf(_el.options[j].value) >= 0;
      }
    } else {
      _el.value = value;
    }
  }

  return this;
}

function value(value) {
  return this.val(value);
}

function transform(transform) {
  for (var i = 0; i < this.length; i += 1) {
    this[i].style.transform = transform;
  }

  return this;
}

function transition(duration) {
  for (var i = 0; i < this.length; i += 1) {
    this[i].style.transitionDuration = typeof duration !== 'string' ? duration + "ms" : duration;
  }

  return this;
}

function on() {
  for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    args[_key5] = arguments[_key5];
  }

  var eventType = args[0],
      targetSelector = args[1],
      listener = args[2],
      capture = args[3];

  if (typeof args[1] === 'function') {
    eventType = args[0];
    listener = args[1];
    capture = args[2];
    targetSelector = undefined;
  }

  if (!capture) capture = false;

  function handleLiveEvent(e) {
    var target = e.target;
    if (!target) return;
    var eventData = e.target.dom7EventData || [];

    if (eventData.indexOf(e) < 0) {
      eventData.unshift(e);
    }

    if ($(target).is(targetSelector)) listener.apply(target, eventData);else {
      var _parents = $(target).parents(); // eslint-disable-line


      for (var k = 0; k < _parents.length; k += 1) {
        if ($(_parents[k]).is(targetSelector)) listener.apply(_parents[k], eventData);
      }
    }
  }

  function handleEvent(e) {
    var eventData = e && e.target ? e.target.dom7EventData || [] : [];

    if (eventData.indexOf(e) < 0) {
      eventData.unshift(e);
    }

    listener.apply(this, eventData);
  }

  var events = eventType.split(' ');
  var j;

  for (var i = 0; i < this.length; i += 1) {
    var el = this[i];

    if (!targetSelector) {
      for (j = 0; j < events.length; j += 1) {
        var event = events[j];
        if (!el.dom7Listeners) el.dom7Listeners = {};
        if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
        el.dom7Listeners[event].push({
          listener: listener,
          proxyListener: handleEvent
        });
        el.addEventListener(event, handleEvent, capture);
      }
    } else {
      // Live events
      for (j = 0; j < events.length; j += 1) {
        var _event = events[j];
        if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
        if (!el.dom7LiveListeners[_event]) el.dom7LiveListeners[_event] = [];

        el.dom7LiveListeners[_event].push({
          listener: listener,
          proxyListener: handleLiveEvent
        });

        el.addEventListener(_event, handleLiveEvent, capture);
      }
    }
  }

  return this;
}

function off() {
  for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    args[_key6] = arguments[_key6];
  }

  var eventType = args[0],
      targetSelector = args[1],
      listener = args[2],
      capture = args[3];

  if (typeof args[1] === 'function') {
    eventType = args[0];
    listener = args[1];
    capture = args[2];
    targetSelector = undefined;
  }

  if (!capture) capture = false;
  var events = eventType.split(' ');

  for (var i = 0; i < events.length; i += 1) {
    var event = events[i];

    for (var j = 0; j < this.length; j += 1) {
      var el = this[j];
      var handlers = void 0;

      if (!targetSelector && el.dom7Listeners) {
        handlers = el.dom7Listeners[event];
      } else if (targetSelector && el.dom7LiveListeners) {
        handlers = el.dom7LiveListeners[event];
      }

      if (handlers && handlers.length) {
        for (var k = handlers.length - 1; k >= 0; k -= 1) {
          var handler = handlers[k];

          if (listener && handler.listener === listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          } else if (!listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          }
        }
      }
    }
  }

  return this;
}

function once() {
  var dom = this;

  for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
    args[_key7] = arguments[_key7];
  }

  var eventName = args[0],
      targetSelector = args[1],
      listener = args[2],
      capture = args[3];

  if (typeof args[1] === 'function') {
    eventName = args[0];
    listener = args[1];
    capture = args[2];
    targetSelector = undefined;
  }

  function onceHandler() {
    for (var _len8 = arguments.length, eventArgs = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
      eventArgs[_key8] = arguments[_key8];
    }

    listener.apply(this, eventArgs);
    dom.off(eventName, targetSelector, onceHandler, capture);

    if (onceHandler.dom7proxy) {
      delete onceHandler.dom7proxy;
    }
  }

  onceHandler.dom7proxy = listener;
  return dom.on(eventName, targetSelector, onceHandler, capture);
}

function trigger() {
  var window = (0,ssr_window_esm/* getWindow */.Jj)();

  for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
    args[_key9] = arguments[_key9];
  }

  var events = args[0].split(' ');
  var eventData = args[1];

  for (var i = 0; i < events.length; i += 1) {
    var event = events[i];

    for (var j = 0; j < this.length; j += 1) {
      var el = this[j];

      if (window.CustomEvent) {
        var evt = new window.CustomEvent(event, {
          detail: eventData,
          bubbles: true,
          cancelable: true
        });
        el.dom7EventData = args.filter(function (data, dataIndex) {
          return dataIndex > 0;
        });
        el.dispatchEvent(evt);
        el.dom7EventData = [];
        delete el.dom7EventData;
      }
    }
  }

  return this;
}

function transitionEnd(callback) {
  var dom = this;

  function fireCallBack(e) {
    if (e.target !== this) return;
    callback.call(this, e);
    dom.off('transitionend', fireCallBack);
  }

  if (callback) {
    dom.on('transitionend', fireCallBack);
  }

  return this;
}

function animationEnd(callback) {
  var dom = this;

  function fireCallBack(e) {
    if (e.target !== this) return;
    callback.call(this, e);
    dom.off('animationend', fireCallBack);
  }

  if (callback) {
    dom.on('animationend', fireCallBack);
  }

  return this;
}

function width() {
  var window = getWindow();

  if (this[0] === window) {
    return window.innerWidth;
  }

  if (this.length > 0) {
    return parseFloat(this.css('width'));
  }

  return null;
}

function dom7_esm_outerWidth(includeMargins) {
  if (this.length > 0) {
    if (includeMargins) {
      var _styles = this.styles();

      return this[0].offsetWidth + parseFloat(_styles.getPropertyValue('margin-right')) + parseFloat(_styles.getPropertyValue('margin-left'));
    }

    return this[0].offsetWidth;
  }

  return null;
}

function height() {
  var window = getWindow();

  if (this[0] === window) {
    return window.innerHeight;
  }

  if (this.length > 0) {
    return parseFloat(this.css('height'));
  }

  return null;
}

function dom7_esm_outerHeight(includeMargins) {
  if (this.length > 0) {
    if (includeMargins) {
      var _styles2 = this.styles();

      return this[0].offsetHeight + parseFloat(_styles2.getPropertyValue('margin-top')) + parseFloat(_styles2.getPropertyValue('margin-bottom'));
    }

    return this[0].offsetHeight;
  }

  return null;
}

function offset() {
  if (this.length > 0) {
    var window = (0,ssr_window_esm/* getWindow */.Jj)();
    var document = (0,ssr_window_esm/* getDocument */.Me)();
    var el = this[0];
    var box = el.getBoundingClientRect();
    var body = document.body;
    var clientTop = el.clientTop || body.clientTop || 0;
    var clientLeft = el.clientLeft || body.clientLeft || 0;
    var scrollTop = el === window ? window.scrollY : el.scrollTop;
    var scrollLeft = el === window ? window.scrollX : el.scrollLeft;
    return {
      top: box.top + scrollTop - clientTop,
      left: box.left + scrollLeft - clientLeft
    };
  }

  return null;
}

function hide() {
  for (var i = 0; i < this.length; i += 1) {
    this[i].style.display = 'none';
  }

  return this;
}

function show() {
  var window = getWindow();

  for (var i = 0; i < this.length; i += 1) {
    var el = this[i];

    if (el.style.display === 'none') {
      el.style.display = '';
    }

    if (window.getComputedStyle(el, null).getPropertyValue('display') === 'none') {
      // Still not visible
      el.style.display = 'block';
    }
  }

  return this;
}

function styles() {
  var window = (0,ssr_window_esm/* getWindow */.Jj)();
  if (this[0]) return window.getComputedStyle(this[0], null);
  return {};
}

function css(props, value) {
  var window = (0,ssr_window_esm/* getWindow */.Jj)();
  var i;

  if (arguments.length === 1) {
    if (typeof props === 'string') {
      // .css('width')
      if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(props);
    } else {
      // .css({ width: '100px' })
      for (i = 0; i < this.length; i += 1) {
        for (var _prop in props) {
          this[i].style[_prop] = props[_prop];
        }
      }

      return this;
    }
  }

  if (arguments.length === 2 && typeof props === 'string') {
    // .css('width', '100px')
    for (i = 0; i < this.length; i += 1) {
      this[i].style[props] = value;
    }

    return this;
  }

  return this;
}

function each(callback) {
  if (!callback) return this;
  this.forEach(function (el, index) {
    callback.apply(el, [el, index]);
  });
  return this;
}

function filter(callback) {
  var result = arrayFilter(this, callback);
  return $(result);
}

function html(html) {
  if (typeof html === 'undefined') {
    return this[0] ? this[0].innerHTML : null;
  }

  for (var i = 0; i < this.length; i += 1) {
    this[i].innerHTML = html;
  }

  return this;
}

function dom7_esm_text(text) {
  if (typeof text === 'undefined') {
    return this[0] ? this[0].textContent.trim() : null;
  }

  for (var i = 0; i < this.length; i += 1) {
    this[i].textContent = text;
  }

  return this;
}

function is(selector) {
  var window = (0,ssr_window_esm/* getWindow */.Jj)();
  var document = (0,ssr_window_esm/* getDocument */.Me)();
  var el = this[0];
  var compareWith;
  var i;
  if (!el || typeof selector === 'undefined') return false;

  if (typeof selector === 'string') {
    if (el.matches) return el.matches(selector);
    if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
    if (el.msMatchesSelector) return el.msMatchesSelector(selector);
    compareWith = $(selector);

    for (i = 0; i < compareWith.length; i += 1) {
      if (compareWith[i] === el) return true;
    }

    return false;
  }

  if (selector === document) {
    return el === document;
  }

  if (selector === window) {
    return el === window;
  }

  if (selector.nodeType || selector instanceof Dom7) {
    compareWith = selector.nodeType ? [selector] : selector;

    for (i = 0; i < compareWith.length; i += 1) {
      if (compareWith[i] === el) return true;
    }

    return false;
  }

  return false;
}

function index() {
  var child = this[0];
  var i;

  if (child) {
    i = 0; // eslint-disable-next-line

    while ((child = child.previousSibling) !== null) {
      if (child.nodeType === 1) i += 1;
    }

    return i;
  }

  return undefined;
}

function eq(index) {
  if (typeof index === 'undefined') return this;
  var length = this.length;

  if (index > length - 1) {
    return $([]);
  }

  if (index < 0) {
    var returnIndex = length + index;
    if (returnIndex < 0) return $([]);
    return $([this[returnIndex]]);
  }

  return $([this[index]]);
}

function append() {
  var newChild;
  var document = (0,ssr_window_esm/* getDocument */.Me)();

  for (var k = 0; k < arguments.length; k += 1) {
    newChild = k < 0 || arguments.length <= k ? undefined : arguments[k];

    for (var i = 0; i < this.length; i += 1) {
      if (typeof newChild === 'string') {
        var tempDiv = document.createElement('div');
        tempDiv.innerHTML = newChild;

        while (tempDiv.firstChild) {
          this[i].appendChild(tempDiv.firstChild);
        }
      } else if (newChild instanceof Dom7) {
        for (var j = 0; j < newChild.length; j += 1) {
          this[i].appendChild(newChild[j]);
        }
      } else {
        this[i].appendChild(newChild);
      }
    }
  }

  return this;
}

function appendTo(parent) {
  $(parent).append(this);
  return this;
}

function prepend(newChild) {
  var document = (0,ssr_window_esm/* getDocument */.Me)();
  var i;
  var j;

  for (i = 0; i < this.length; i += 1) {
    if (typeof newChild === 'string') {
      var tempDiv = document.createElement('div');
      tempDiv.innerHTML = newChild;

      for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
        this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
      }
    } else if (newChild instanceof Dom7) {
      for (j = 0; j < newChild.length; j += 1) {
        this[i].insertBefore(newChild[j], this[i].childNodes[0]);
      }
    } else {
      this[i].insertBefore(newChild, this[i].childNodes[0]);
    }
  }

  return this;
}

function prependTo(parent) {
  $(parent).prepend(this);
  return this;
}

function insertBefore(selector) {
  var before = $(selector);

  for (var i = 0; i < this.length; i += 1) {
    if (before.length === 1) {
      before[0].parentNode.insertBefore(this[i], before[0]);
    } else if (before.length > 1) {
      for (var j = 0; j < before.length; j += 1) {
        before[j].parentNode.insertBefore(this[i].cloneNode(true), before[j]);
      }
    }
  }
}

function insertAfter(selector) {
  var after = $(selector);

  for (var i = 0; i < this.length; i += 1) {
    if (after.length === 1) {
      after[0].parentNode.insertBefore(this[i], after[0].nextSibling);
    } else if (after.length > 1) {
      for (var j = 0; j < after.length; j += 1) {
        after[j].parentNode.insertBefore(this[i].cloneNode(true), after[j].nextSibling);
      }
    }
  }
}

function next(selector) {
  if (this.length > 0) {
    if (selector) {
      if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) {
        return $([this[0].nextElementSibling]);
      }

      return $([]);
    }

    if (this[0].nextElementSibling) return $([this[0].nextElementSibling]);
    return $([]);
  }

  return $([]);
}

function nextAll(selector) {
  var nextEls = [];
  var el = this[0];
  if (!el) return $([]);

  while (el.nextElementSibling) {
    var _next = el.nextElementSibling; // eslint-disable-line

    if (selector) {
      if ($(_next).is(selector)) nextEls.push(_next);
    } else nextEls.push(_next);

    el = _next;
  }

  return $(nextEls);
}

function prev(selector) {
  if (this.length > 0) {
    var el = this[0];

    if (selector) {
      if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) {
        return $([el.previousElementSibling]);
      }

      return $([]);
    }

    if (el.previousElementSibling) return $([el.previousElementSibling]);
    return $([]);
  }

  return $([]);
}

function prevAll(selector) {
  var prevEls = [];
  var el = this[0];
  if (!el) return $([]);

  while (el.previousElementSibling) {
    var _prev = el.previousElementSibling; // eslint-disable-line

    if (selector) {
      if ($(_prev).is(selector)) prevEls.push(_prev);
    } else prevEls.push(_prev);

    el = _prev;
  }

  return $(prevEls);
}

function siblings(selector) {
  return this.nextAll(selector).add(this.prevAll(selector));
}

function dom7_esm_parent(selector) {
  var parents = []; // eslint-disable-line

  for (var i = 0; i < this.length; i += 1) {
    if (this[i].parentNode !== null) {
      if (selector) {
        if ($(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
      } else {
        parents.push(this[i].parentNode);
      }
    }
  }

  return $(parents);
}

function parents(selector) {
  var parents = []; // eslint-disable-line

  for (var i = 0; i < this.length; i += 1) {
    var _parent = this[i].parentNode; // eslint-disable-line

    while (_parent) {
      if (selector) {
        if ($(_parent).is(selector)) parents.push(_parent);
      } else {
        parents.push(_parent);
      }

      _parent = _parent.parentNode;
    }
  }

  return $(parents);
}

function closest(selector) {
  var closest = this; // eslint-disable-line

  if (typeof selector === 'undefined') {
    return $([]);
  }

  if (!closest.is(selector)) {
    closest = closest.parents(selector).eq(0);
  }

  return closest;
}

function find(selector) {
  var foundElements = [];

  for (var i = 0; i < this.length; i += 1) {
    var found = this[i].querySelectorAll(selector);

    for (var j = 0; j < found.length; j += 1) {
      foundElements.push(found[j]);
    }
  }

  return $(foundElements);
}

function children(selector) {
  var children = []; // eslint-disable-line

  for (var i = 0; i < this.length; i += 1) {
    var childNodes = this[i].children;

    for (var j = 0; j < childNodes.length; j += 1) {
      if (!selector || $(childNodes[j]).is(selector)) {
        children.push(childNodes[j]);
      }
    }
  }

  return $(children);
}

function remove() {
  for (var i = 0; i < this.length; i += 1) {
    if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
  }

  return this;
}

function detach() {
  return this.remove();
}

function add() {
  var dom = this;
  var i;
  var j;

  for (var _len10 = arguments.length, els = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
    els[_key10] = arguments[_key10];
  }

  for (i = 0; i < els.length; i += 1) {
    var toAdd = $(els[i]);

    for (j = 0; j < toAdd.length; j += 1) {
      dom.push(toAdd[j]);
    }
  }

  return dom;
}

function empty() {
  for (var i = 0; i < this.length; i += 1) {
    var el = this[i];

    if (el.nodeType === 1) {
      for (var j = 0; j < el.childNodes.length; j += 1) {
        if (el.childNodes[j].parentNode) {
          el.childNodes[j].parentNode.removeChild(el.childNodes[j]);
        }
      }

      el.textContent = '';
    }
  }

  return this;
}

function scrollTo() {
  var window = getWindow();

  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var left = args[0],
      top = args[1],
      duration = args[2],
      easing = args[3],
      callback = args[4];

  if (args.length === 4 && typeof easing === 'function') {
    callback = easing;
    left = args[0];
    top = args[1];
    duration = args[2];
    callback = args[3];
    easing = args[4];
  }

  if (typeof easing === 'undefined') easing = 'swing';
  return this.each(function animate() {
    var el = this;
    var currentTop;
    var currentLeft;
    var maxTop;
    var maxLeft;
    var newTop;
    var newLeft;
    var scrollTop; // eslint-disable-line

    var scrollLeft; // eslint-disable-line

    var animateTop = top > 0 || top === 0;
    var animateLeft = left > 0 || left === 0;

    if (typeof easing === 'undefined') {
      easing = 'swing';
    }

    if (animateTop) {
      currentTop = el.scrollTop;

      if (!duration) {
        el.scrollTop = top;
      }
    }

    if (animateLeft) {
      currentLeft = el.scrollLeft;

      if (!duration) {
        el.scrollLeft = left;
      }
    }

    if (!duration) return;

    if (animateTop) {
      maxTop = el.scrollHeight - el.offsetHeight;
      newTop = Math.max(Math.min(top, maxTop), 0);
    }

    if (animateLeft) {
      maxLeft = el.scrollWidth - el.offsetWidth;
      newLeft = Math.max(Math.min(left, maxLeft), 0);
    }

    var startTime = null;
    if (animateTop && newTop === currentTop) animateTop = false;
    if (animateLeft && newLeft === currentLeft) animateLeft = false;

    function render(time) {
      if (time === void 0) {
        time = new Date().getTime();
      }

      if (startTime === null) {
        startTime = time;
      }

      var progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
      var easeProgress = easing === 'linear' ? progress : 0.5 - Math.cos(progress * Math.PI) / 2;
      var done;
      if (animateTop) scrollTop = currentTop + easeProgress * (newTop - currentTop);
      if (animateLeft) scrollLeft = currentLeft + easeProgress * (newLeft - currentLeft);

      if (animateTop && newTop > currentTop && scrollTop >= newTop) {
        el.scrollTop = newTop;
        done = true;
      }

      if (animateTop && newTop < currentTop && scrollTop <= newTop) {
        el.scrollTop = newTop;
        done = true;
      }

      if (animateLeft && newLeft > currentLeft && scrollLeft >= newLeft) {
        el.scrollLeft = newLeft;
        done = true;
      }

      if (animateLeft && newLeft < currentLeft && scrollLeft <= newLeft) {
        el.scrollLeft = newLeft;
        done = true;
      }

      if (done) {
        if (callback) callback();
        return;
      }

      if (animateTop) el.scrollTop = scrollTop;
      if (animateLeft) el.scrollLeft = scrollLeft;
      window.requestAnimationFrame(render);
    }

    window.requestAnimationFrame(render);
  });
} // scrollTop(top, duration, easing, callback) {


function scrollTop() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  var top = args[0],
      duration = args[1],
      easing = args[2],
      callback = args[3];

  if (args.length === 3 && typeof easing === 'function') {
    top = args[0];
    duration = args[1];
    callback = args[2];
    easing = args[3];
  }

  var dom = this;

  if (typeof top === 'undefined') {
    if (dom.length > 0) return dom[0].scrollTop;
    return null;
  }

  return dom.scrollTo(undefined, top, duration, easing, callback);
}

function scrollLeft() {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }

  var left = args[0],
      duration = args[1],
      easing = args[2],
      callback = args[3];

  if (args.length === 3 && typeof easing === 'function') {
    left = args[0];
    duration = args[1];
    callback = args[2];
    easing = args[3];
  }

  var dom = this;

  if (typeof left === 'undefined') {
    if (dom.length > 0) return dom[0].scrollLeft;
    return null;
  }

  return dom.scrollTo(left, undefined, duration, easing, callback);
}

function animate(initialProps, initialParams) {
  var window = getWindow();
  var els = this;
  var a = {
    props: Object.assign({}, initialProps),
    params: Object.assign({
      duration: 300,
      easing: 'swing' // or 'linear'

      /* Callbacks
      begin(elements)
      complete(elements)
      progress(elements, complete, remaining, start, tweenValue)
      */

    }, initialParams),
    elements: els,
    animating: false,
    que: [],
    easingProgress: function easingProgress(easing, progress) {
      if (easing === 'swing') {
        return 0.5 - Math.cos(progress * Math.PI) / 2;
      }

      if (typeof easing === 'function') {
        return easing(progress);
      }

      return progress;
    },
    stop: function stop() {
      if (a.frameId) {
        window.cancelAnimationFrame(a.frameId);
      }

      a.animating = false;
      a.elements.each(function (el) {
        var element = el;
        delete element.dom7AnimateInstance;
      });
      a.que = [];
    },
    done: function done(complete) {
      a.animating = false;
      a.elements.each(function (el) {
        var element = el;
        delete element.dom7AnimateInstance;
      });
      if (complete) complete(els);

      if (a.que.length > 0) {
        var que = a.que.shift();
        a.animate(que[0], que[1]);
      }
    },
    animate: function animate(props, params) {
      if (a.animating) {
        a.que.push([props, params]);
        return a;
      }

      var elements = []; // Define & Cache Initials & Units

      a.elements.each(function (el, index) {
        var initialFullValue;
        var initialValue;
        var unit;
        var finalValue;
        var finalFullValue;
        if (!el.dom7AnimateInstance) a.elements[index].dom7AnimateInstance = a;
        elements[index] = {
          container: el
        };
        Object.keys(props).forEach(function (prop) {
          initialFullValue = window.getComputedStyle(el, null).getPropertyValue(prop).replace(',', '.');
          initialValue = parseFloat(initialFullValue);
          unit = initialFullValue.replace(initialValue, '');
          finalValue = parseFloat(props[prop]);
          finalFullValue = props[prop] + unit;
          elements[index][prop] = {
            initialFullValue: initialFullValue,
            initialValue: initialValue,
            unit: unit,
            finalValue: finalValue,
            finalFullValue: finalFullValue,
            currentValue: initialValue
          };
        });
      });
      var startTime = null;
      var time;
      var elementsDone = 0;
      var propsDone = 0;
      var done;
      var began = false;
      a.animating = true;

      function render() {
        time = new Date().getTime();
        var progress;
        var easeProgress; // let el;

        if (!began) {
          began = true;
          if (params.begin) params.begin(els);
        }

        if (startTime === null) {
          startTime = time;
        }

        if (params.progress) {
          // eslint-disable-next-line
          params.progress(els, Math.max(Math.min((time - startTime) / params.duration, 1), 0), startTime + params.duration - time < 0 ? 0 : startTime + params.duration - time, startTime);
        }

        elements.forEach(function (element) {
          var el = element;
          if (done || el.done) return;
          Object.keys(props).forEach(function (prop) {
            if (done || el.done) return;
            progress = Math.max(Math.min((time - startTime) / params.duration, 1), 0);
            easeProgress = a.easingProgress(params.easing, progress);
            var _el$prop = el[prop],
                initialValue = _el$prop.initialValue,
                finalValue = _el$prop.finalValue,
                unit = _el$prop.unit;
            el[prop].currentValue = initialValue + easeProgress * (finalValue - initialValue);
            var currentValue = el[prop].currentValue;

            if (finalValue > initialValue && currentValue >= finalValue || finalValue < initialValue && currentValue <= finalValue) {
              el.container.style[prop] = finalValue + unit;
              propsDone += 1;

              if (propsDone === Object.keys(props).length) {
                el.done = true;
                elementsDone += 1;
              }

              if (elementsDone === elements.length) {
                done = true;
              }
            }

            if (done) {
              a.done(params.complete);
              return;
            }

            el.container.style[prop] = currentValue + unit;
          });
        });
        if (done) return; // Then call

        a.frameId = window.requestAnimationFrame(render);
      }

      a.frameId = window.requestAnimationFrame(render);
      return a;
    }
  };

  if (a.elements.length === 0) {
    return els;
  }

  var animateInstance;

  for (var i = 0; i < a.elements.length; i += 1) {
    if (a.elements[i].dom7AnimateInstance) {
      animateInstance = a.elements[i].dom7AnimateInstance;
    } else a.elements[i].dom7AnimateInstance = a;
  }

  if (!animateInstance) {
    animateInstance = a;
  }

  if (initialProps === 'stop') {
    animateInstance.stop();
  } else {
    animateInstance.animate(a.props, a.params);
  }

  return els;
}

function stop() {
  var els = this;

  for (var i = 0; i < els.length; i += 1) {
    if (els[i].dom7AnimateInstance) {
      els[i].dom7AnimateInstance.stop();
    }
  }
}

var noTrigger = 'resize scroll'.split(' ');

function shortcut(name) {
  function eventHandler() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (typeof args[0] === 'undefined') {
      for (var i = 0; i < this.length; i += 1) {
        if (noTrigger.indexOf(name) < 0) {
          if (name in this[i]) this[i][name]();else {
            $(this[i]).trigger(name);
          }
        }
      }

      return this;
    }

    return this.on.apply(this, [name].concat(args));
  }

  return eventHandler;
}

var click = shortcut('click');
var dom7_esm_blur = shortcut('blur');
var dom7_esm_focus = shortcut('focus');
var focusin = shortcut('focusin');
var focusout = shortcut('focusout');
var keyup = shortcut('keyup');
var keydown = shortcut('keydown');
var keypress = shortcut('keypress');
var dom7_esm_submit = shortcut('submit');
var change = shortcut('change');
var mousedown = shortcut('mousedown');
var mousemove = shortcut('mousemove');
var mouseup = shortcut('mouseup');
var mouseenter = shortcut('mouseenter');
var mouseleave = shortcut('mouseleave');
var mouseout = shortcut('mouseout');
var mouseover = shortcut('mouseover');
var touchstart = shortcut('touchstart');
var touchend = shortcut('touchend');
var touchmove = shortcut('touchmove');
var resize = shortcut('resize');
var dom7_esm_scroll = shortcut('scroll');

/* harmony default export */ var dom7_esm = ((/* unused pure expression or super */ null && ($)));


;// CONCATENATED MODULE: ../node_modules/swiper/esm/utils/dom.js

var Methods = {
  addClass: addClass,
  removeClass: removeClass,
  hasClass: hasClass,
  toggleClass: toggleClass,
  attr: attr,
  removeAttr: removeAttr,
  transform: transform,
  transition: transition,
  on: on,
  off: off,
  trigger: trigger,
  transitionEnd: transitionEnd,
  outerWidth: dom7_esm_outerWidth,
  outerHeight: dom7_esm_outerHeight,
  styles: styles,
  offset: offset,
  css: css,
  each: each,
  html: html,
  text: dom7_esm_text,
  is: is,
  index: index,
  eq: eq,
  append: append,
  prepend: prepend,
  next: next,
  nextAll: nextAll,
  prev: prev,
  prevAll: prevAll,
  parent: dom7_esm_parent,
  parents: parents,
  closest: closest,
  find: find,
  children: children,
  filter: filter,
  remove: remove
};
Object.keys(Methods).forEach(function (methodName) {
  Object.defineProperty($.fn, methodName, {
    value: Methods[methodName],
    writable: true
  });
});
/* harmony default export */ var dom = ($);

/***/ }),

/***/ 89617:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R6": function() { return /* binding */ getTranslate; },
/* harmony export */   "Up": function() { return /* binding */ createElementIfNotDefined; },
/* harmony export */   "Wc": function() { return /* binding */ classesToSelector; },
/* harmony export */   "Y3": function() { return /* binding */ nextTick; },
/* harmony export */   "cP": function() { return /* binding */ deleteProps; },
/* harmony export */   "cR": function() { return /* binding */ bindModuleMethods; },
/* harmony export */   "l7": function() { return /* binding */ extend; },
/* harmony export */   "zO": function() { return /* binding */ now; }
/* harmony export */ });
/* unused harmony exports isObject, getComputedStyle */
/* harmony import */ var ssr_window__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95469);


function deleteProps(obj) {
  var object = obj;
  Object.keys(object).forEach(function (key) {
    try {
      object[key] = null;
    } catch (e) {// no getter for object
    }

    try {
      delete object[key];
    } catch (e) {// something got wrong
    }
  });
}

function nextTick(callback, delay) {
  if (delay === void 0) {
    delay = 0;
  }

  return setTimeout(callback, delay);
}

function now() {
  return Date.now();
}

function getComputedStyle(el) {
  var window = (0,ssr_window__WEBPACK_IMPORTED_MODULE_0__/* .getWindow */ .Jj)();
  var style;

  if (window.getComputedStyle) {
    style = window.getComputedStyle(el, null);
  }

  if (!style && el.currentStyle) {
    style = el.currentStyle;
  }

  if (!style) {
    style = el.style;
  }

  return style;
}

function getTranslate(el, axis) {
  if (axis === void 0) {
    axis = 'x';
  }

  var window = (0,ssr_window__WEBPACK_IMPORTED_MODULE_0__/* .getWindow */ .Jj)();
  var matrix;
  var curTransform;
  var transformMatrix;
  var curStyle = getComputedStyle(el, null);

  if (window.WebKitCSSMatrix) {
    curTransform = curStyle.transform || curStyle.webkitTransform;

    if (curTransform.split(',').length > 6) {
      curTransform = curTransform.split(', ').map(function (a) {
        return a.replace(',', '.');
      }).join(', ');
    } // Some old versions of Webkit choke when 'none' is passed; pass
    // empty string instead in this case


    transformMatrix = new window.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
  } else {
    transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
    matrix = transformMatrix.toString().split(',');
  }

  if (axis === 'x') {
    // Latest Chrome and webkits Fix
    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m41; // Crazy IE10 Matrix
    else if (matrix.length === 16) curTransform = parseFloat(matrix[12]); // Normal Browsers
      else curTransform = parseFloat(matrix[4]);
  }

  if (axis === 'y') {
    // Latest Chrome and webkits Fix
    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m42; // Crazy IE10 Matrix
    else if (matrix.length === 16) curTransform = parseFloat(matrix[13]); // Normal Browsers
      else curTransform = parseFloat(matrix[5]);
  }

  return curTransform || 0;
}

function isObject(o) {
  return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}

function isNode(node) {
  // eslint-disable-next-line
  if (typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined') {
    return node instanceof HTMLElement;
  }

  return node && (node.nodeType === 1 || node.nodeType === 11);
}

function extend() {
  var to = Object(arguments.length <= 0 ? undefined : arguments[0]);
  var noExtend = ['__proto__', 'constructor', 'prototype'];

  for (var i = 1; i < arguments.length; i += 1) {
    var nextSource = i < 0 || arguments.length <= i ? undefined : arguments[i];

    if (nextSource !== undefined && nextSource !== null && !isNode(nextSource)) {
      var keysArray = Object.keys(Object(nextSource)).filter(function (key) {
        return noExtend.indexOf(key) < 0;
      });

      for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
        var nextKey = keysArray[nextIndex];
        var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);

        if (desc !== undefined && desc.enumerable) {
          if (isObject(to[nextKey]) && isObject(nextSource[nextKey])) {
            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              extend(to[nextKey], nextSource[nextKey]);
            }
          } else if (!isObject(to[nextKey]) && isObject(nextSource[nextKey])) {
            to[nextKey] = {};

            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              extend(to[nextKey], nextSource[nextKey]);
            }
          } else {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
    }
  }

  return to;
}

function bindModuleMethods(instance, obj) {
  Object.keys(obj).forEach(function (key) {
    if (isObject(obj[key])) {
      Object.keys(obj[key]).forEach(function (subKey) {
        if (typeof obj[key][subKey] === 'function') {
          obj[key][subKey] = obj[key][subKey].bind(instance);
        }
      });
    }

    instance[key] = obj[key];
  });
}

function classesToSelector(classes) {
  if (classes === void 0) {
    classes = '';
  }

  return "." + classes.trim().replace(/([\.:!\/])/g, '\\$1') // eslint-disable-line
  .replace(/ /g, '.');
}

function createElementIfNotDefined($container, params, createElements, checkProps) {
  var document = (0,ssr_window__WEBPACK_IMPORTED_MODULE_0__/* .getDocument */ .Me)();

  if (createElements) {
    Object.keys(checkProps).forEach(function (key) {
      if (!params[key] && params.auto === true) {
        var element = document.createElement('div');
        element.className = checkProps[key];
        $container.append(element);
        params[key] = element;
      }
    });
  }

  return params;
}



/***/ }),

/***/ 70863:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "HY": function() { return /* reexport */ react.Fragment; },
  "tZ": function() { return /* reexport */ jsx; },
  "BX": function() { return /* reexport */ jsxs; }
});

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/@emotion/react/dist/emotion-element-f0de968e.browser.esm.js
var emotion_element_f0de968e_browser_esm = __webpack_require__(44512);
// EXTERNAL MODULE: ../node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js + 7 modules
var emotion_cache_browser_esm = __webpack_require__(93853);
// EXTERNAL MODULE: ../node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(55839);
// EXTERNAL MODULE: ../node_modules/@emotion/serialize/dist/emotion-serialize.esm.js + 2 modules
var emotion_serialize_esm = __webpack_require__(74235);
// EXTERNAL MODULE: ../node_modules/@emotion/use-insertion-effect-with-fallbacks/dist/emotion-use-insertion-effect-with-fallbacks.browser.esm.js
var emotion_use_insertion_effect_with_fallbacks_browser_esm = __webpack_require__(37164);
;// CONCATENATED MODULE: ../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js












var Fragment = jsx_runtime.Fragment;
var emotion_react_jsx_runtime_browser_esm_jsx = function jsx(type, props, key) {
  if (!emotion_element_f0de968e_browser_esm.h.call(props, 'css')) {
    return jsx_runtime.jsx(type, props, key);
  }

  return jsx_runtime.jsx(emotion_element_f0de968e_browser_esm.E, (0,emotion_element_f0de968e_browser_esm.c)(type, props), key);
};
var emotion_react_jsx_runtime_browser_esm_jsxs = function jsxs(type, props, key) {
  if (!emotion_element_f0de968e_browser_esm.h.call(props, 'css')) {
    return jsx_runtime.jsxs(type, props, key);
  }

  return jsx_runtime.jsxs(emotion_element_f0de968e_browser_esm.E, (0,emotion_element_f0de968e_browser_esm.c)(type, props), key);
};



// EXTERNAL MODULE: ../node_modules/@theme-ui/core/dist/parseProps-376f43a7.esm.js
var parseProps_376f43a7_esm = __webpack_require__(75902);
;// CONCATENATED MODULE: ../node_modules/@theme-ui/core/jsx-runtime/dist/theme-ui-core-jsx-runtime.esm.js





var jsx = function jsx(type, props, key) {
  return emotion_react_jsx_runtime_browser_esm_jsx(type, (0,parseProps_376f43a7_esm.p)(props), key);
};
var jsxs = function jsxs(type, props, key) {
  return emotion_react_jsx_runtime_browser_esm_jsxs(type, (0,parseProps_376f43a7_esm.p)(props), key);
};



;// CONCATENATED MODULE: ../node_modules/theme-ui/jsx-runtime/dist/theme-ui-jsx-runtime.esm.js




/***/ }),

/***/ 338:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "NIL", ({
  enumerable: true,
  get: function get() {
    return _nil.default;
  }
}));
Object.defineProperty(exports, "parse", ({
  enumerable: true,
  get: function get() {
    return _parse.default;
  }
}));
Object.defineProperty(exports, "stringify", ({
  enumerable: true,
  get: function get() {
    return _stringify.default;
  }
}));
Object.defineProperty(exports, "v1", ({
  enumerable: true,
  get: function get() {
    return _v.default;
  }
}));
Object.defineProperty(exports, "v3", ({
  enumerable: true,
  get: function get() {
    return _v2.default;
  }
}));
Object.defineProperty(exports, "v4", ({
  enumerable: true,
  get: function get() {
    return _v3.default;
  }
}));
Object.defineProperty(exports, "v5", ({
  enumerable: true,
  get: function get() {
    return _v4.default;
  }
}));
Object.defineProperty(exports, "validate", ({
  enumerable: true,
  get: function get() {
    return _validate.default;
  }
}));
Object.defineProperty(exports, "version", ({
  enumerable: true,
  get: function get() {
    return _version.default;
  }
}));

var _v = _interopRequireDefault(__webpack_require__(3925));

var _v2 = _interopRequireDefault(__webpack_require__(62220));

var _v3 = _interopRequireDefault(__webpack_require__(68015));

var _v4 = _interopRequireDefault(__webpack_require__(70197));

var _nil = _interopRequireDefault(__webpack_require__(85529));

var _version = _interopRequireDefault(__webpack_require__(70923));

var _validate = _interopRequireDefault(__webpack_require__(53447));

var _stringify = _interopRequireDefault(__webpack_require__(93584));

var _parse = _interopRequireDefault(__webpack_require__(75842));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 57809:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

/*
 * Browser-compatible JavaScript MD5
 *
 * Modification of JavaScript MD5
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */
function md5(bytes) {
  if (typeof bytes === 'string') {
    const msg = unescape(encodeURIComponent(bytes)); // UTF8 escape

    bytes = new Uint8Array(msg.length);

    for (let i = 0; i < msg.length; ++i) {
      bytes[i] = msg.charCodeAt(i);
    }
  }

  return md5ToHexEncodedArray(wordsToMd5(bytesToWords(bytes), bytes.length * 8));
}
/*
 * Convert an array of little-endian words to an array of bytes
 */


function md5ToHexEncodedArray(input) {
  const output = [];
  const length32 = input.length * 32;
  const hexTab = '0123456789abcdef';

  for (let i = 0; i < length32; i += 8) {
    const x = input[i >> 5] >>> i % 32 & 0xff;
    const hex = parseInt(hexTab.charAt(x >>> 4 & 0x0f) + hexTab.charAt(x & 0x0f), 16);
    output.push(hex);
  }

  return output;
}
/**
 * Calculate output length with padding and bit length
 */


function getOutputLength(inputLength8) {
  return (inputLength8 + 64 >>> 9 << 4) + 14 + 1;
}
/*
 * Calculate the MD5 of an array of little-endian words, and a bit length.
 */


function wordsToMd5(x, len) {
  /* append padding */
  x[len >> 5] |= 0x80 << len % 32;
  x[getOutputLength(len) - 1] = len;
  let a = 1732584193;
  let b = -271733879;
  let c = -1732584194;
  let d = 271733878;

  for (let i = 0; i < x.length; i += 16) {
    const olda = a;
    const oldb = b;
    const oldc = c;
    const oldd = d;
    a = md5ff(a, b, c, d, x[i], 7, -680876936);
    d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
    c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
    b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
    a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
    d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
    c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
    b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
    a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
    d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
    c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
    b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
    a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
    d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
    c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
    b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
    a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
    d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
    c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
    b = md5gg(b, c, d, a, x[i], 20, -373897302);
    a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
    d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
    c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
    b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
    a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
    d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
    c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
    b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
    a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
    d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
    c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
    b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
    a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
    d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
    c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
    b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
    a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
    d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
    c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
    b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
    a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
    d = md5hh(d, a, b, c, x[i], 11, -358537222);
    c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
    b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
    a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
    d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
    c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
    b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
    a = md5ii(a, b, c, d, x[i], 6, -198630844);
    d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
    c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
    b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
    a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
    d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
    c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
    b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
    a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
    d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
    c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
    b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
    a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
    d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
    c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
    b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
    a = safeAdd(a, olda);
    b = safeAdd(b, oldb);
    c = safeAdd(c, oldc);
    d = safeAdd(d, oldd);
  }

  return [a, b, c, d];
}
/*
 * Convert an array bytes to an array of little-endian words
 * Characters >255 have their high-byte silently ignored.
 */


function bytesToWords(input) {
  if (input.length === 0) {
    return [];
  }

  const length8 = input.length * 8;
  const output = new Uint32Array(getOutputLength(length8));

  for (let i = 0; i < length8; i += 8) {
    output[i >> 5] |= (input[i / 8] & 0xff) << i % 32;
  }

  return output;
}
/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */


function safeAdd(x, y) {
  const lsw = (x & 0xffff) + (y & 0xffff);
  const msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return msw << 16 | lsw & 0xffff;
}
/*
 * Bitwise rotate a 32-bit number to the left.
 */


function bitRotateLeft(num, cnt) {
  return num << cnt | num >>> 32 - cnt;
}
/*
 * These functions implement the four basic operations the algorithm uses.
 */


function md5cmn(q, a, b, x, s, t) {
  return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
}

function md5ff(a, b, c, d, x, s, t) {
  return md5cmn(b & c | ~b & d, a, b, x, s, t);
}

function md5gg(a, b, c, d, x, s, t) {
  return md5cmn(b & d | c & ~d, a, b, x, s, t);
}

function md5hh(a, b, c, d, x, s, t) {
  return md5cmn(b ^ c ^ d, a, b, x, s, t);
}

function md5ii(a, b, c, d, x, s, t) {
  return md5cmn(c ^ (b | ~d), a, b, x, s, t);
}

var _default = md5;
exports["default"] = _default;

/***/ }),

/***/ 19871:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var _default = {
  randomUUID
};
exports["default"] = _default;

/***/ }),

/***/ 85529:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _default = '00000000-0000-0000-0000-000000000000';
exports["default"] = _default;

/***/ }),

/***/ 75842:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _validate = _interopRequireDefault(__webpack_require__(53447));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function parse(uuid) {
  if (!(0, _validate.default)(uuid)) {
    throw TypeError('Invalid UUID');
  }

  let v;
  const arr = new Uint8Array(16); // Parse ########-....-....-....-............

  arr[0] = (v = parseInt(uuid.slice(0, 8), 16)) >>> 24;
  arr[1] = v >>> 16 & 0xff;
  arr[2] = v >>> 8 & 0xff;
  arr[3] = v & 0xff; // Parse ........-####-....-....-............

  arr[4] = (v = parseInt(uuid.slice(9, 13), 16)) >>> 8;
  arr[5] = v & 0xff; // Parse ........-....-####-....-............

  arr[6] = (v = parseInt(uuid.slice(14, 18), 16)) >>> 8;
  arr[7] = v & 0xff; // Parse ........-....-....-####-............

  arr[8] = (v = parseInt(uuid.slice(19, 23), 16)) >>> 8;
  arr[9] = v & 0xff; // Parse ........-....-....-....-############
  // (Use "/" to avoid 32-bit truncation when bit-shifting high-order bytes)

  arr[10] = (v = parseInt(uuid.slice(24, 36), 16)) / 0x10000000000 & 0xff;
  arr[11] = v / 0x100000000 & 0xff;
  arr[12] = v >>> 24 & 0xff;
  arr[13] = v >>> 16 & 0xff;
  arr[14] = v >>> 8 & 0xff;
  arr[15] = v & 0xff;
  return arr;
}

var _default = parse;
exports["default"] = _default;

/***/ }),

/***/ 64261:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
exports["default"] = _default;

/***/ }),

/***/ 59469:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = rng;
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let getRandomValues;
const rnds8 = new Uint8Array(16);

function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}

/***/ }),

/***/ 27230:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

// Adapted from Chris Veness' SHA1 code at
// http://www.movable-type.co.uk/scripts/sha1.html
function f(s, x, y, z) {
  switch (s) {
    case 0:
      return x & y ^ ~x & z;

    case 1:
      return x ^ y ^ z;

    case 2:
      return x & y ^ x & z ^ y & z;

    case 3:
      return x ^ y ^ z;
  }
}

function ROTL(x, n) {
  return x << n | x >>> 32 - n;
}

function sha1(bytes) {
  const K = [0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xca62c1d6];
  const H = [0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0];

  if (typeof bytes === 'string') {
    const msg = unescape(encodeURIComponent(bytes)); // UTF8 escape

    bytes = [];

    for (let i = 0; i < msg.length; ++i) {
      bytes.push(msg.charCodeAt(i));
    }
  } else if (!Array.isArray(bytes)) {
    // Convert Array-like to Array
    bytes = Array.prototype.slice.call(bytes);
  }

  bytes.push(0x80);
  const l = bytes.length / 4 + 2;
  const N = Math.ceil(l / 16);
  const M = new Array(N);

  for (let i = 0; i < N; ++i) {
    const arr = new Uint32Array(16);

    for (let j = 0; j < 16; ++j) {
      arr[j] = bytes[i * 64 + j * 4] << 24 | bytes[i * 64 + j * 4 + 1] << 16 | bytes[i * 64 + j * 4 + 2] << 8 | bytes[i * 64 + j * 4 + 3];
    }

    M[i] = arr;
  }

  M[N - 1][14] = (bytes.length - 1) * 8 / Math.pow(2, 32);
  M[N - 1][14] = Math.floor(M[N - 1][14]);
  M[N - 1][15] = (bytes.length - 1) * 8 & 0xffffffff;

  for (let i = 0; i < N; ++i) {
    const W = new Uint32Array(80);

    for (let t = 0; t < 16; ++t) {
      W[t] = M[i][t];
    }

    for (let t = 16; t < 80; ++t) {
      W[t] = ROTL(W[t - 3] ^ W[t - 8] ^ W[t - 14] ^ W[t - 16], 1);
    }

    let a = H[0];
    let b = H[1];
    let c = H[2];
    let d = H[3];
    let e = H[4];

    for (let t = 0; t < 80; ++t) {
      const s = Math.floor(t / 20);
      const T = ROTL(a, 5) + f(s, b, c, d) + e + K[s] + W[t] >>> 0;
      e = d;
      d = c;
      c = ROTL(b, 30) >>> 0;
      b = a;
      a = T;
    }

    H[0] = H[0] + a >>> 0;
    H[1] = H[1] + b >>> 0;
    H[2] = H[2] + c >>> 0;
    H[3] = H[3] + d >>> 0;
    H[4] = H[4] + e >>> 0;
  }

  return [H[0] >> 24 & 0xff, H[0] >> 16 & 0xff, H[0] >> 8 & 0xff, H[0] & 0xff, H[1] >> 24 & 0xff, H[1] >> 16 & 0xff, H[1] >> 8 & 0xff, H[1] & 0xff, H[2] >> 24 & 0xff, H[2] >> 16 & 0xff, H[2] >> 8 & 0xff, H[2] & 0xff, H[3] >> 24 & 0xff, H[3] >> 16 & 0xff, H[3] >> 8 & 0xff, H[3] & 0xff, H[4] >> 24 & 0xff, H[4] >> 16 & 0xff, H[4] >> 8 & 0xff, H[4] & 0xff];
}

var _default = sha1;
exports["default"] = _default;

/***/ }),

/***/ 93584:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
exports.unsafeStringify = unsafeStringify;

var _validate = _interopRequireDefault(__webpack_require__(53447));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
const byteToHex = [];

for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).slice(1));
}

function unsafeStringify(arr, offset = 0) {
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  return byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]];
}

function stringify(arr, offset = 0) {
  const uuid = unsafeStringify(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!(0, _validate.default)(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

var _default = stringify;
exports["default"] = _default;

/***/ }),

/***/ 3925:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _rng = _interopRequireDefault(__webpack_require__(59469));

var _stringify = __webpack_require__(93584);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
let _nodeId;

let _clockseq; // Previous uuid creation time


let _lastMSecs = 0;
let _lastNSecs = 0; // See https://github.com/uuidjs/uuid for API details

function v1(options, buf, offset) {
  let i = buf && offset || 0;
  const b = buf || new Array(16);
  options = options || {};
  let node = options.node || _nodeId;
  let clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq; // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189

  if (node == null || clockseq == null) {
    const seedBytes = options.random || (options.rng || _rng.default)();

    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [seedBytes[0] | 0x01, seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]];
    }

    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  } // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.


  let msecs = options.msecs !== undefined ? options.msecs : Date.now(); // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock

  let nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1; // Time since last uuid creation (in msecs)

  const dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000; // Per 4.2.1.2, Bump clockseq on clock regression

  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  } // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval


  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  } // Per 4.2.1.2 Throw error if too many uuids are requested


  if (nsecs >= 10000) {
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq; // Per 4.1.4 - Convert from unix epoch to Gregorian epoch

  msecs += 12219292800000; // `time_low`

  const tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff; // `time_mid`

  const tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff; // `time_high_and_version`

  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version

  b[i++] = tmh >>> 16 & 0xff; // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)

  b[i++] = clockseq >>> 8 | 0x80; // `clock_seq_low`

  b[i++] = clockseq & 0xff; // `node`

  for (let n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf || (0, _stringify.unsafeStringify)(b);
}

var _default = v1;
exports["default"] = _default;

/***/ }),

/***/ 62220:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _v = _interopRequireDefault(__webpack_require__(22969));

var _md = _interopRequireDefault(__webpack_require__(57809));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const v3 = (0, _v.default)('v3', 0x30, _md.default);
var _default = v3;
exports["default"] = _default;

/***/ }),

/***/ 22969:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.URL = exports.DNS = void 0;
exports["default"] = v35;

var _stringify = __webpack_require__(93584);

var _parse = _interopRequireDefault(__webpack_require__(75842));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function stringToBytes(str) {
  str = unescape(encodeURIComponent(str)); // UTF8 escape

  const bytes = [];

  for (let i = 0; i < str.length; ++i) {
    bytes.push(str.charCodeAt(i));
  }

  return bytes;
}

const DNS = '6ba7b810-9dad-11d1-80b4-00c04fd430c8';
exports.DNS = DNS;
const URL = '6ba7b811-9dad-11d1-80b4-00c04fd430c8';
exports.URL = URL;

function v35(name, version, hashfunc) {
  function generateUUID(value, namespace, buf, offset) {
    var _namespace;

    if (typeof value === 'string') {
      value = stringToBytes(value);
    }

    if (typeof namespace === 'string') {
      namespace = (0, _parse.default)(namespace);
    }

    if (((_namespace = namespace) === null || _namespace === void 0 ? void 0 : _namespace.length) !== 16) {
      throw TypeError('Namespace must be array-like (16 iterable integer values, 0-255)');
    } // Compute hash of namespace and value, Per 4.3
    // Future: Use spread syntax when supported on all platforms, e.g. `bytes =
    // hashfunc([...namespace, ... value])`


    let bytes = new Uint8Array(16 + value.length);
    bytes.set(namespace);
    bytes.set(value, namespace.length);
    bytes = hashfunc(bytes);
    bytes[6] = bytes[6] & 0x0f | version;
    bytes[8] = bytes[8] & 0x3f | 0x80;

    if (buf) {
      offset = offset || 0;

      for (let i = 0; i < 16; ++i) {
        buf[offset + i] = bytes[i];
      }

      return buf;
    }

    return (0, _stringify.unsafeStringify)(bytes);
  } // Function#name is not settable on some platforms (#270)


  try {
    generateUUID.name = name; // eslint-disable-next-line no-empty
  } catch (err) {} // For CommonJS default export support


  generateUUID.DNS = DNS;
  generateUUID.URL = URL;
  return generateUUID;
}

/***/ }),

/***/ 68015:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _native = _interopRequireDefault(__webpack_require__(19871));

var _rng = _interopRequireDefault(__webpack_require__(59469));

var _stringify = __webpack_require__(93584);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function v4(options, buf, offset) {
  if (_native.default.randomUUID && !buf && !options) {
    return _native.default.randomUUID();
  }

  options = options || {};

  const rnds = options.random || (options.rng || _rng.default)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`


  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (let i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return (0, _stringify.unsafeStringify)(rnds);
}

var _default = v4;
exports["default"] = _default;

/***/ }),

/***/ 70197:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _v = _interopRequireDefault(__webpack_require__(22969));

var _sha = _interopRequireDefault(__webpack_require__(27230));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const v5 = (0, _v.default)('v5', 0x50, _sha.default);
var _default = v5;
exports["default"] = _default;

/***/ }),

/***/ 53447:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _regex = _interopRequireDefault(__webpack_require__(64261));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function validate(uuid) {
  return typeof uuid === 'string' && _regex.default.test(uuid);
}

var _default = validate;
exports["default"] = _default;

/***/ }),

/***/ 70923:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _validate = _interopRequireDefault(__webpack_require__(53447));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function version(uuid) {
  if (!(0, _validate.default)(uuid)) {
    throw TypeError('Invalid UUID');
  }

  return parseInt(uuid.slice(14, 15), 16);
}

var _default = version;
exports["default"] = _default;

/***/ }),

/***/ 42139:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.defaultJsonSerializer = void 0;
exports.defaultJsonSerializer = JSON;
//# sourceMappingURL=defaultJsonSerializer.js.map

/***/ }),

/***/ 17323:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.GraphQLWebSocketClient = void 0;
/* eslint-disable */
const resolveRequestDocument_js_1 = __webpack_require__(37671);
const types_js_1 = __webpack_require__(18876);
// import type WebSocket from 'ws'
const CONNECTION_INIT = `connection_init`;
const CONNECTION_ACK = `connection_ack`;
const PING = `ping`;
const PONG = `pong`;
const SUBSCRIBE = `subscribe`;
const NEXT = `next`;
const ERROR = `error`;
const COMPLETE = `complete`;
class GraphQLWebSocketMessage {
    get type() {
        return this._type;
    }
    get id() {
        return this._id;
    }
    get payload() {
        return this._payload;
    }
    constructor(type, payload, id) {
        this._type = type;
        this._payload = payload;
        this._id = id;
    }
    get text() {
        const result = { type: this.type };
        if (this.id != null && this.id != undefined)
            result.id = this.id;
        if (this.payload != null && this.payload != undefined)
            result.payload = this.payload;
        return JSON.stringify(result);
    }
    static parse(data, f) {
        const { type, payload, id } = JSON.parse(data);
        return new GraphQLWebSocketMessage(type, f(payload), id);
    }
}
class GraphQLWebSocketClient {
    constructor(socket, { onInit, onAcknowledged, onPing, onPong }) {
        this.socketState = { acknowledged: false, lastRequestId: 0, subscriptions: {} };
        this.socket = socket;
        socket.addEventListener(`open`, async (e) => {
            this.socketState.acknowledged = false;
            this.socketState.subscriptions = {};
            socket.send(ConnectionInit(onInit ? await onInit() : null).text);
        });
        socket.addEventListener(`close`, (e) => {
            this.socketState.acknowledged = false;
            this.socketState.subscriptions = {};
        });
        socket.addEventListener(`error`, (e) => {
            console.error(e);
        });
        socket.addEventListener(`message`, (e) => {
            try {
                const message = parseMessage(e.data);
                switch (message.type) {
                    case CONNECTION_ACK: {
                        if (this.socketState.acknowledged) {
                            console.warn(`Duplicate CONNECTION_ACK message ignored`);
                        }
                        else {
                            this.socketState.acknowledged = true;
                            if (onAcknowledged)
                                onAcknowledged(message.payload);
                        }
                        return;
                    }
                    case PING: {
                        if (onPing)
                            onPing(message.payload).then((r) => socket.send(Pong(r).text));
                        else
                            socket.send(Pong(null).text);
                        return;
                    }
                    case PONG: {
                        if (onPong)
                            onPong(message.payload);
                        return;
                    }
                }
                if (!this.socketState.acknowledged) {
                    // Web-socket connection not acknowledged
                    return;
                }
                if (message.id === undefined || message.id === null || !this.socketState.subscriptions[message.id]) {
                    // No subscription identifer or subscription indentifier is not found
                    return;
                }
                const { query, variables, subscriber } = this.socketState.subscriptions[message.id];
                switch (message.type) {
                    case NEXT: {
                        if (!message.payload.errors && message.payload.data) {
                            subscriber.next && subscriber.next(message.payload.data);
                        }
                        if (message.payload.errors) {
                            subscriber.error &&
                                subscriber.error(new types_js_1.ClientError({ ...message.payload, status: 200 }, { query, variables }));
                        }
                        else {
                        }
                        return;
                    }
                    case ERROR: {
                        subscriber.error &&
                            subscriber.error(new types_js_1.ClientError({ errors: message.payload, status: 200 }, { query, variables }));
                        return;
                    }
                    case COMPLETE: {
                        subscriber.complete && subscriber.complete();
                        delete this.socketState.subscriptions[message.id];
                        return;
                    }
                }
            }
            catch (e) {
                // Unexpected errors while handling graphql-ws message
                console.error(e);
                socket.close(1006);
            }
            socket.close(4400, `Unknown graphql-ws message.`);
        });
    }
    makeSubscribe(query, operationName, subscriber, variables) {
        const subscriptionId = (this.socketState.lastRequestId++).toString();
        this.socketState.subscriptions[subscriptionId] = { query, variables, subscriber };
        this.socket.send(Subscribe(subscriptionId, { query, operationName, variables }).text);
        return () => {
            this.socket.send(Complete(subscriptionId).text);
            delete this.socketState.subscriptions[subscriptionId];
        };
    }
    rawRequest(query, variables) {
        return new Promise((resolve, reject) => {
            let result;
            this.rawSubscribe(query, {
                next: (data, extensions) => (result = { data, extensions }),
                error: reject,
                complete: () => resolve(result),
            }, variables);
        });
    }
    request(document, variables) {
        return new Promise((resolve, reject) => {
            let result;
            this.subscribe(document, {
                next: (data) => (result = data),
                error: reject,
                complete: () => resolve(result),
            }, variables);
        });
    }
    subscribe(document, subscriber, variables) {
        const { query, operationName } = (0, resolveRequestDocument_js_1.resolveRequestDocument)(document);
        return this.makeSubscribe(query, operationName, subscriber, variables);
    }
    rawSubscribe(query, subscriber, variables) {
        return this.makeSubscribe(query, undefined, subscriber, variables);
    }
    ping(payload) {
        this.socket.send(Ping(payload).text);
    }
    close() {
        this.socket.close(1000);
    }
}
GraphQLWebSocketClient.PROTOCOL = `graphql-transport-ws`;
exports.GraphQLWebSocketClient = GraphQLWebSocketClient;
// Helper functions
function parseMessage(data, f = (a) => a) {
    const m = GraphQLWebSocketMessage.parse(data, f);
    return m;
}
function ConnectionInit(payload) {
    return new GraphQLWebSocketMessage(CONNECTION_INIT, payload);
}
function Ping(payload) {
    return new GraphQLWebSocketMessage(PING, payload, undefined);
}
function Pong(payload) {
    return new GraphQLWebSocketMessage(PONG, payload, undefined);
}
function Subscribe(id, payload) {
    return new GraphQLWebSocketMessage(SUBSCRIBE, payload, id);
}
function Complete(id) {
    return new GraphQLWebSocketMessage(COMPLETE, undefined, id);
}
//# sourceMappingURL=graphql-ws.js.map

/***/ }),

/***/ 37431:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.HeadersInstanceToPlainObject = exports.uppercase = void 0;
const uppercase = (str) => str.toUpperCase();
exports.uppercase = uppercase;
/**
 * Convert Headers instance into regular object
 */
const HeadersInstanceToPlainObject = (headers) => {
    const o = {};
    headers.forEach((v, k) => {
        o[k] = v;
    });
    return o;
};
exports.HeadersInstanceToPlainObject = HeadersInstanceToPlainObject;
//# sourceMappingURL=helpers.js.map

/***/ }),

/***/ 63671:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.request = exports.rawRequest = exports.GraphQLClient = exports.ClientError = exports.batchRequests = exports.resolveRequestDocument = exports.GraphQLWebSocketClient = exports.gql = void 0;
const defaultJsonSerializer_js_1 = __webpack_require__(42139);
const helpers_js_1 = __webpack_require__(37431);
const parseArgs_js_1 = __webpack_require__(5912);
const resolveRequestDocument_js_1 = __webpack_require__(37671);
const types_js_1 = __webpack_require__(18876);
Object.defineProperty(exports, "ClientError", ({ enumerable: true, get: function () { return types_js_1.ClientError; } }));
const cross_fetch_1 = __importStar(__webpack_require__(89372)), CrossFetch = cross_fetch_1;
/**
 * Convert the given headers configuration into a plain object.
 */
const resolveHeaders = (headers) => {
    let oHeaders = {};
    if (headers) {
        if ((typeof Headers !== `undefined` && headers instanceof Headers) ||
            (CrossFetch && CrossFetch.Headers && headers instanceof CrossFetch.Headers)) {
            oHeaders = (0, helpers_js_1.HeadersInstanceToPlainObject)(headers);
        }
        else if (Array.isArray(headers)) {
            headers.forEach(([name, value]) => {
                if (name && value !== undefined) {
                    oHeaders[name] = value;
                }
            });
        }
        else {
            oHeaders = headers;
        }
    }
    return oHeaders;
};
/**
 * Clean a GraphQL document to send it via a GET query
 */
const cleanQuery = (str) => str.replace(/([\s,]|#[^\n\r]+)+/g, ` `).trim();
/**
 * Create query string for GraphQL request
 */
const buildRequestConfig = (params) => {
    if (!Array.isArray(params.query)) {
        const params_ = params;
        const search = [`query=${encodeURIComponent(cleanQuery(params_.query))}`];
        if (params.variables) {
            search.push(`variables=${encodeURIComponent(params_.jsonSerializer.stringify(params_.variables))}`);
        }
        if (params_.operationName) {
            search.push(`operationName=${encodeURIComponent(params_.operationName)}`);
        }
        return search.join(`&`);
    }
    if (typeof params.variables !== `undefined` && !Array.isArray(params.variables)) {
        throw new Error(`Cannot create query with given variable type, array expected`);
    }
    // Batch support
    const params_ = params;
    const payload = params.query.reduce((acc, currentQuery, index) => {
        acc.push({
            query: cleanQuery(currentQuery),
            variables: params_.variables ? params_.jsonSerializer.stringify(params_.variables[index]) : undefined,
        });
        return acc;
    }, []);
    return `query=${encodeURIComponent(params_.jsonSerializer.stringify(payload))}`;
};
const createHttpMethodFetcher = (method) => async (params) => {
    const { url, query, variables, operationName, fetch, fetchOptions, middleware } = params;
    const headers = { ...params.headers };
    let queryParams = ``;
    let body = undefined;
    if (method === `POST`) {
        body = createRequestBody(query, variables, operationName, fetchOptions.jsonSerializer);
        if (typeof body === `string`) {
            // @ts-expect-error todo
            headers[`Content-Type`] = `application/json`;
        }
    }
    else {
        // @ts-expect-error todo needs ADT for TS to understand the different states
        queryParams = buildRequestConfig({
            query,
            variables,
            operationName,
            jsonSerializer: fetchOptions.jsonSerializer ?? defaultJsonSerializer_js_1.defaultJsonSerializer,
        });
    }
    const init = {
        method,
        headers,
        body,
        ...fetchOptions,
    };
    let urlResolved = url;
    let initResolved = init;
    if (middleware) {
        const result = await Promise.resolve(middleware({ ...init, url, operationName, variables }));
        const { url: urlNew, ...initNew } = result;
        urlResolved = urlNew;
        initResolved = initNew;
    }
    if (queryParams) {
        urlResolved = `${urlResolved}?${queryParams}`;
    }
    return await fetch(urlResolved, initResolved);
};
/**
 * GraphQL Client.
 */
class GraphQLClient {
    constructor(url, requestConfig = {}) {
        this.url = url;
        this.requestConfig = requestConfig;
        /**
         * Send a GraphQL query to the server.
         */
        this.rawRequest = async (...args) => {
            const [queryOrOptions, variables, requestHeaders] = args;
            const rawRequestOptions = (0, parseArgs_js_1.parseRawRequestArgs)(queryOrOptions, variables, requestHeaders);
            const { headers, fetch = cross_fetch_1.default, method = `POST`, requestMiddleware, responseMiddleware, ...fetchOptions } = this.requestConfig;
            const { url } = this;
            if (rawRequestOptions.signal !== undefined) {
                fetchOptions.signal = rawRequestOptions.signal;
            }
            const { operationName } = (0, resolveRequestDocument_js_1.resolveRequestDocument)(rawRequestOptions.query);
            return makeRequest({
                url,
                query: rawRequestOptions.query,
                variables: rawRequestOptions.variables,
                headers: {
                    ...resolveHeaders(callOrIdentity(headers)),
                    ...resolveHeaders(rawRequestOptions.requestHeaders),
                },
                operationName,
                fetch,
                method,
                fetchOptions,
                middleware: requestMiddleware,
            })
                .then((response) => {
                if (responseMiddleware) {
                    responseMiddleware(response);
                }
                return response;
            })
                .catch((error) => {
                if (responseMiddleware) {
                    responseMiddleware(error);
                }
                throw error;
            });
        };
    }
    async request(documentOrOptions, ...variablesAndRequestHeaders) {
        const [variables, requestHeaders] = variablesAndRequestHeaders;
        const requestOptions = (0, parseArgs_js_1.parseRequestArgs)(documentOrOptions, variables, requestHeaders);
        const { headers, fetch = cross_fetch_1.default, method = `POST`, requestMiddleware, responseMiddleware, ...fetchOptions } = this.requestConfig;
        const { url } = this;
        if (requestOptions.signal !== undefined) {
            fetchOptions.signal = requestOptions.signal;
        }
        const { query, operationName } = (0, resolveRequestDocument_js_1.resolveRequestDocument)(requestOptions.document);
        return makeRequest({
            url,
            query,
            variables: requestOptions.variables,
            headers: {
                ...resolveHeaders(callOrIdentity(headers)),
                ...resolveHeaders(requestOptions.requestHeaders),
            },
            operationName,
            fetch,
            method,
            fetchOptions,
            middleware: requestMiddleware,
        })
            .then((response) => {
            if (responseMiddleware) {
                responseMiddleware(response);
            }
            return response.data;
        })
            .catch((error) => {
            if (responseMiddleware) {
                responseMiddleware(error);
            }
            throw error;
        });
    }
    // prettier-ignore
    batchRequests(documentsOrOptions, requestHeaders) {
        const batchRequestOptions = (0, parseArgs_js_1.parseBatchRequestArgs)(documentsOrOptions, requestHeaders);
        const { headers, ...fetchOptions } = this.requestConfig;
        if (batchRequestOptions.signal !== undefined) {
            fetchOptions.signal = batchRequestOptions.signal;
        }
        const queries = batchRequestOptions.documents.map(({ document }) => (0, resolveRequestDocument_js_1.resolveRequestDocument)(document).query);
        const variables = batchRequestOptions.documents.map(({ variables }) => variables);
        return makeRequest({
            url: this.url,
            query: queries,
            // @ts-expect-error TODO reconcile batch variables into system.
            variables,
            headers: {
                ...resolveHeaders(callOrIdentity(headers)),
                ...resolveHeaders(batchRequestOptions.requestHeaders),
            },
            operationName: undefined,
            fetch: this.requestConfig.fetch ?? cross_fetch_1.default,
            method: this.requestConfig.method || `POST`,
            fetchOptions,
            middleware: this.requestConfig.requestMiddleware,
        })
            .then((response) => {
            if (this.requestConfig.responseMiddleware) {
                this.requestConfig.responseMiddleware(response);
            }
            return response.data;
        })
            .catch((error) => {
            if (this.requestConfig.responseMiddleware) {
                this.requestConfig.responseMiddleware(error);
            }
            throw error;
        });
    }
    setHeaders(headers) {
        this.requestConfig.headers = headers;
        return this;
    }
    /**
     * Attach a header to the client. All subsequent requests will have this header.
     */
    setHeader(key, value) {
        const { headers } = this.requestConfig;
        if (headers) {
            // todo what if headers is in nested array form... ?
            //@ts-expect-error todo
            headers[key] = value;
        }
        else {
            this.requestConfig.headers = { [key]: value };
        }
        return this;
    }
    /**
     * Change the client endpoint. All subsequent requests will send to this endpoint.
     */
    setEndpoint(value) {
        this.url = value;
        return this;
    }
}
exports.GraphQLClient = GraphQLClient;
const makeRequest = async (params) => {
    const { query, variables, fetchOptions } = params;
    const fetcher = createHttpMethodFetcher((0, helpers_js_1.uppercase)(params.method ?? `post`));
    const isBatchingQuery = Array.isArray(params.query);
    const response = await fetcher(params);
    const result = await getResult(response, fetchOptions.jsonSerializer ?? defaultJsonSerializer_js_1.defaultJsonSerializer);
    const successfullyReceivedData = Array.isArray(result)
        ? !result.some(({ data }) => !data)
        : Boolean(result.data);
    const successfullyPassedErrorPolicy = Array.isArray(result) ||
        !result.errors ||
        (Array.isArray(result.errors) && !result.errors.length) ||
        fetchOptions.errorPolicy === `all` ||
        fetchOptions.errorPolicy === `ignore`;
    if (response.ok && successfullyPassedErrorPolicy && successfullyReceivedData) {
        // @ts-expect-error TODO fixme
        const { errors: _, ...rest } = Array.isArray(result) ? result : result;
        const data = fetchOptions.errorPolicy === `ignore` ? rest : result;
        const dataEnvelope = isBatchingQuery ? { data } : data;
        // @ts-expect-error TODO
        return {
            ...dataEnvelope,
            headers: response.headers,
            status: response.status,
        };
    }
    else {
        const errorResult = typeof result === `string`
            ? {
                error: result,
            }
            : result;
        throw new types_js_1.ClientError(
        // @ts-expect-error TODO
        { ...errorResult, status: response.status, headers: response.headers }, { query, variables });
    }
};
/**
 * Send a GraphQL Query to the GraphQL server for execution.
 */
const rawRequest = async (...args) => {
    const [urlOrOptions, query, ...variablesAndRequestHeaders] = args;
    const requestOptions = (0, parseArgs_js_1.parseRawRequestExtendedArgs)(urlOrOptions, query, ...variablesAndRequestHeaders);
    const client = new GraphQLClient(requestOptions.url);
    return client.rawRequest({
        ...requestOptions,
    });
};
exports.rawRequest = rawRequest;
// prettier-ignore
// eslint-disable-next-line
async function request(urlOrOptions, document, ...variablesAndRequestHeaders) {
    const requestOptions = (0, parseArgs_js_1.parseRequestExtendedArgs)(urlOrOptions, document, ...variablesAndRequestHeaders);
    const client = new GraphQLClient(requestOptions.url);
    return client.request({
        ...requestOptions,
    });
}
exports.request = request;
/**
 * Send a batch of GraphQL Document to the GraphQL server for execution.
 *
 * @example
 *
 * ```ts
 * // You can pass a raw string
 *
 * await batchRequests('https://foo.bar/graphql', [
 * {
 *  query: `
 *   {
 *     query {
 *       users
 *     }
 *   }`
 * },
 * {
 *   query: `
 *   {
 *     query {
 *       users
 *     }
 *   }`
 * }])
 *
 * // You can also pass a GraphQL DocumentNode as query. Convenient if you
 * // are using graphql-tag package.
 *
 * import gql from 'graphql-tag'
 *
 * await batchRequests('https://foo.bar/graphql', [{ query: gql`...` }])
 * ```
 */
const batchRequests = async (...args) => {
    const params = parseBatchRequestsArgsExtended(args);
    const client = new GraphQLClient(params.url);
    return client.batchRequests(params);
};
exports.batchRequests = batchRequests;
const parseBatchRequestsArgsExtended = (args) => {
    if (args.length === 1) {
        return args[0];
    }
    else {
        return {
            url: args[0],
            documents: args[1],
            requestHeaders: args[2],
            signal: undefined,
        };
    }
};
const createRequestBody = (query, variables, operationName, jsonSerializer) => {
    const jsonSerializer_ = jsonSerializer ?? defaultJsonSerializer_js_1.defaultJsonSerializer;
    if (!Array.isArray(query)) {
        return jsonSerializer_.stringify({ query, variables, operationName });
    }
    if (typeof variables !== `undefined` && !Array.isArray(variables)) {
        throw new Error(`Cannot create request body with given variable type, array expected`);
    }
    // Batch support
    const payload = query.reduce((acc, currentQuery, index) => {
        acc.push({ query: currentQuery, variables: variables ? variables[index] : undefined });
        return acc;
    }, []);
    return jsonSerializer_.stringify(payload);
};
const getResult = async (response, jsonSerializer) => {
    let contentType;
    response.headers.forEach((value, key) => {
        if (key.toLowerCase() === `content-type`) {
            contentType = value;
        }
    });
    if (contentType &&
        (contentType.toLowerCase().startsWith(`application/json`) ||
            contentType.toLowerCase().startsWith(`application/graphql+json`) ||
            contentType.toLowerCase().startsWith(`application/graphql-response+json`))) {
        return jsonSerializer.parse(await response.text());
    }
    else {
        return response.text();
    }
};
const callOrIdentity = (value) => {
    return typeof value === `function` ? value() : value;
};
/**
 * Convenience passthrough template tag to get the benefits of tooling for the gql template tag. This does not actually parse the input into a GraphQL DocumentNode like graphql-tag package does. It just returns the string with any variables given interpolated. Can save you a bit of performance and having to install another package.
 *
 * @example
 * ```
 * import { gql } from 'graphql-request'
 *
 * await request('https://foo.bar/graphql', gql`...`)
 * ```
 *
 * @remarks
 *
 * Several tools in the Node GraphQL ecosystem are hardcoded to specially treat any template tag named "gql". For example see this prettier issue: https://github.com/prettier/prettier/issues/4360. Using this template tag has no runtime effect beyond variable interpolation.
 */
const gql = (chunks, ...variables) => {
    return chunks.reduce((acc, chunk, index) => `${acc}${chunk}${index in variables ? String(variables[index]) : ``}`, ``);
};
exports.gql = gql;
var graphql_ws_js_1 = __webpack_require__(17323);
Object.defineProperty(exports, "GraphQLWebSocketClient", ({ enumerable: true, get: function () { return graphql_ws_js_1.GraphQLWebSocketClient; } }));
var resolveRequestDocument_js_2 = __webpack_require__(37671);
Object.defineProperty(exports, "resolveRequestDocument", ({ enumerable: true, get: function () { return resolveRequestDocument_js_2.resolveRequestDocument; } }));
exports["default"] = request;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 5912:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.parseRawRequestExtendedArgs = exports.parseRequestExtendedArgs = exports.parseBatchRequestArgs = exports.parseRawRequestArgs = exports.parseRequestArgs = void 0;
const parseRequestArgs = (documentOrOptions, variables, requestHeaders) => {
    return documentOrOptions.document
        ? documentOrOptions
        : {
            document: documentOrOptions,
            variables: variables,
            requestHeaders: requestHeaders,
            signal: undefined,
        };
};
exports.parseRequestArgs = parseRequestArgs;
const parseRawRequestArgs = (queryOrOptions, variables, requestHeaders) => {
    return queryOrOptions.query
        ? queryOrOptions
        : {
            query: queryOrOptions,
            variables: variables,
            requestHeaders: requestHeaders,
            signal: undefined,
        };
};
exports.parseRawRequestArgs = parseRawRequestArgs;
const parseBatchRequestArgs = (documentsOrOptions, requestHeaders) => {
    return documentsOrOptions.documents
        ? documentsOrOptions
        : {
            documents: documentsOrOptions,
            requestHeaders: requestHeaders,
            signal: undefined,
        };
};
exports.parseBatchRequestArgs = parseBatchRequestArgs;
const parseRequestExtendedArgs = (urlOrOptions, document, ...variablesAndRequestHeaders) => {
    const [variables, requestHeaders] = variablesAndRequestHeaders;
    return urlOrOptions.document
        ? urlOrOptions
        : {
            url: urlOrOptions,
            document: document,
            variables,
            requestHeaders,
            signal: undefined,
        };
};
exports.parseRequestExtendedArgs = parseRequestExtendedArgs;
const parseRawRequestExtendedArgs = (urlOrOptions, query, ...variablesAndRequestHeaders) => {
    const [variables, requestHeaders] = variablesAndRequestHeaders;
    return urlOrOptions.query
        ? urlOrOptions
        : {
            url: urlOrOptions,
            query: query,
            variables,
            requestHeaders,
            signal: undefined,
        };
};
exports.parseRawRequestExtendedArgs = parseRawRequestExtendedArgs;
//# sourceMappingURL=parseArgs.js.map

/***/ }),

/***/ 37671:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.resolveRequestDocument = void 0;
const graphql_1 = __webpack_require__(58588);
/**
 * helpers
 */
const extractOperationName = (document) => {
    let operationName = undefined;
    const operationDefinitions = document.definitions.filter((definition) => definition.kind === `OperationDefinition`);
    if (operationDefinitions.length === 1) {
        operationName = operationDefinitions[0]?.name?.value;
    }
    return operationName;
};
const resolveRequestDocument = (document) => {
    if (typeof document === `string`) {
        let operationName = undefined;
        try {
            const parsedDocument = (0, graphql_1.parse)(document);
            operationName = extractOperationName(parsedDocument);
        }
        catch (err) {
            // Failed parsing the document, the operationName will be undefined
        }
        return { query: document, operationName };
    }
    const operationName = extractOperationName(document);
    return { query: (0, graphql_1.print)(document), operationName };
};
exports.resolveRequestDocument = resolveRequestDocument;
//# sourceMappingURL=resolveRequestDocument.js.map

/***/ }),

/***/ 18876:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ClientError = void 0;
class ClientError extends Error {
    constructor(response, request) {
        const message = `${ClientError.extractMessage(response)}: ${JSON.stringify({
            response,
            request,
        })}`;
        super(message);
        Object.setPrototypeOf(this, ClientError.prototype);
        this.response = response;
        this.request = request;
        // this is needed as Safari doesn't support .captureStackTrace
        if (typeof Error.captureStackTrace === `function`) {
            Error.captureStackTrace(this, ClientError);
        }
    }
    static extractMessage(response) {
        return response.errors?.[0]?.message ?? `GraphQL Error (Code: ${response.status})`;
    }
}
exports.ClientError = ClientError;
//# sourceMappingURL=types.js.map

/***/ }),

/***/ 7481:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ Qp; },
/* harmony export */   "D": function() { return /* binding */ ig; },
/* harmony export */   "E": function() { return /* binding */ cg; },
/* harmony export */   "G": function() { return /* binding */ vg; },
/* harmony export */   "J": function() { return /* binding */ Hn; },
/* harmony export */   "M": function() { return /* binding */ eh; },
/* harmony export */   "Q": function() { return /* binding */ Nh; },
/* harmony export */   "a": function() { return /* binding */ s; },
/* harmony export */   "b": function() { return /* binding */ Ui; },
/* harmony export */   "c": function() { return /* binding */ k; },
/* harmony export */   "d": function() { return /* binding */ Bi; },
/* harmony export */   "e": function() { return /* binding */ f; },
/* harmony export */   "f": function() { return /* binding */ h; },
/* harmony export */   "g": function() { return /* binding */ g; },
/* harmony export */   "h": function() { return /* binding */ Vl; },
/* harmony export */   "i": function() { return /* binding */ _; },
/* harmony export */   "j": function() { return /* binding */ x; },
/* harmony export */   "k": function() { return /* binding */ dt; },
/* harmony export */   "l": function() { return /* binding */ Jl; },
/* harmony export */   "m": function() { return /* binding */ z; },
/* harmony export */   "n": function() { return /* binding */ Zu; },
/* harmony export */   "o": function() { return /* binding */ Nf; },
/* harmony export */   "p": function() { return /* binding */ Di; },
/* harmony export */   "q": function() { return /* binding */ ze; },
/* harmony export */   "r": function() { return /* binding */ F; },
/* harmony export */   "s": function() { return /* binding */ E; },
/* harmony export */   "t": function() { return /* binding */ Ld; },
/* harmony export */   "u": function() { return /* binding */ Vd; },
/* harmony export */   "v": function() { return /* binding */ On; },
/* harmony export */   "w": function() { return /* binding */ kd; },
/* harmony export */   "x": function() { return /* binding */ Xl; },
/* harmony export */   "y": function() { return /* binding */ Vt; },
/* harmony export */   "z": function() { return /* binding */ Ap; }
/* harmony export */ });
/* unused harmony exports A, B, F, H, I, K, L, N, O, P, R, S, T, U, V, W */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31655);
/* harmony import */ var memory_cache__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14195);
/* harmony import */ var deepmerge__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20406);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27001);
/* harmony import */ var use_immer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(84465);
/* provided dependency */ var process = __webpack_require__(14284);
var jn=Object.create;var be=Object.defineProperty;var qn=Object.getOwnPropertyDescriptor;var Wn=Object.getOwnPropertyNames;var ki=Object.getPrototypeOf,zn=Object.prototype.hasOwnProperty;var Zn=Reflect.get;var Gi=e=>{throw TypeError(e)};var Jn=(e,t,i)=>t in e?be(e,t,{enumerable:true,configurable:true,writable:true,value:i}):e[t]=i;var s=(e,t)=>be(e,"name",{value:t,configurable:true});var Ui=(e,t)=>()=>(t||e((t={exports:{}}).exports,t),t.exports),k=(e,t)=>{for(var i in t)be(e,i,{get:t[i],enumerable:true});},Qn=(e,t,i,r)=>{if(t&&typeof t=="object"||typeof t=="function")for(let n of Wn(t))!zn.call(e,n)&&n!==i&&be(e,n,{get:()=>t[n],enumerable:!(r=qn(t,n))||r.enumerable});return e};var Bi=(e,t,i)=>(i=e!=null?jn(ki(e)):{},Qn(t||!e||!e.__esModule?be(i,"default",{value:e,enumerable:true}):i,e));var f=(e,t,i)=>Jn(e,typeof t!="symbol"?t+"":t,i),Fi=(e,t,i)=>t.has(e)||Gi("Cannot "+i);var tt=(e,t,i)=>(Fi(e,t,"read from private field"),i?i.call(e):t.get(e)),Yt=(e,t,i)=>t.has(e)?Gi("Cannot add the same private member more than once"):t instanceof WeakSet?t.add(e):t.set(e,i),$t=(e,t,i,r)=>(Fi(e,t,"write to private field"),t.set(e,i),i);var it=(e,t,i)=>Zn(ki(e),i,t);var Mr=Ui((Le,Ee)=>{var Cn=200,ir="__lodash_hash_undefined__",rr=9007199254740991,Ct="[object Arguments]",es="[object Array]",nr="[object Boolean]",sr="[object Date]",ts="[object Error]",ei="[object Function]",or="[object GeneratorFunction]",nt="[object Map]",ar="[object Number]",ti="[object Object]",ji="[object Promise]",cr="[object RegExp]",st="[object Set]",lr="[object String]",ur="[object Symbol]",Wt="[object WeakMap]",fr="[object ArrayBuffer]",ot="[object DataView]",mr="[object Float32Array]",dr="[object Float64Array]",pr="[object Int8Array]",gr="[object Int16Array]",hr="[object Int32Array]",Ir="[object Uint8Array]",Er="[object Uint8ClampedArray]",_r="[object Uint16Array]",xr="[object Uint32Array]",is=/[\\^$.*+?()[\]{}|]/g,rs=/\w*$/,ns=/^\[object .+?Constructor\]$/,ss=/^(?:0|[1-9]\d*)$/,T={};T[Ct]=T[es]=T[fr]=T[ot]=T[nr]=T[sr]=T[mr]=T[dr]=T[pr]=T[gr]=T[hr]=T[nt]=T[ar]=T[ti]=T[cr]=T[st]=T[lr]=T[ur]=T[Ir]=T[Er]=T[_r]=T[xr]=true;T[ts]=T[ei]=T[Wt]=false;var os=typeof global=="object"&&global&&global.Object===Object&&global,as=typeof self=="object"&&self&&self.Object===Object&&self,q=os||as||Function("return this")(),Ar=typeof Le=="object"&&Le&&!Le.nodeType&&Le,qi=Ar&&typeof Ee=="object"&&Ee&&!Ee.nodeType&&Ee,cs=qi&&qi.exports===Ar;function ls(e,t){return e.set(t[0],t[1]),e}s(ls,"addMapEntry");function us(e,t){return e.add(t),e}s(us,"addSetEntry");function fs(e,t){for(var i=-1,r=e?e.length:0;++i<r&&t(e[i],i,e)!==false;);return e}s(fs,"arrayEach");function ms(e,t){for(var i=-1,r=t.length,n=e.length;++i<r;)e[n+i]=t[i];return e}s(ms,"arrayPush");function vr(e,t,i,r){var n=-1,o=e?e.length:0;for(r&&o&&(i=e[++n]);++n<o;)i=t(i,e[n],n,e);return i}s(vr,"arrayReduce");function ds(e,t){for(var i=-1,r=Array(e);++i<e;)r[i]=t(i);return r}s(ds,"baseTimes");function ps(e,t){return e==null?void 0:e[t]}s(ps,"getValue");function Tr(e){var t=false;if(e!=null&&typeof e.toString!="function")try{t=!!(e+"");}catch{}return t}s(Tr,"isHostObject");function Wi(e){var t=-1,i=Array(e.size);return e.forEach(function(r,n){i[++t]=[n,r];}),i}s(Wi,"mapToArray");function ii(e,t){return function(i){return e(t(i))}}s(ii,"overArg");function zi(e){var t=-1,i=Array(e.size);return e.forEach(function(r){i[++t]=r;}),i}s(zi,"setToArray");var gs=Array.prototype,hs=Function.prototype,at=Object.prototype,qt=q["__core-js_shared__"],Zi=function(){var e=/[^.]+$/.exec(qt&&qt.keys&&qt.keys.IE_PROTO||"");return e?"Symbol(src)_1."+e:""}(),Pr=hs.toString,ee=at.hasOwnProperty,ct=at.toString,Is=RegExp("^"+Pr.call(ee).replace(is,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$"),Ji=cs?q.Buffer:void 0,Qi=q.Symbol,Xi=q.Uint8Array,Es=ii(Object.getPrototypeOf,Object),_s=Object.create,xs=at.propertyIsEnumerable,As=gs.splice,Ci=Object.getOwnPropertySymbols,vs=Ji?Ji.isBuffer:void 0,Ts=ii(Object.keys,Object),zt=Ae(q,"DataView"),Ve=Ae(q,"Map"),Zt=Ae(q,"Promise"),Jt=Ae(q,"Set"),Qt=Ae(q,"WeakMap"),ke=Ae(Object,"create"),Ps=de(zt),Ns=de(Ve),Rs=de(Zt),Ss=de(Jt),Ds=de(Qt),er=Qi?Qi.prototype:void 0,tr=er?er.valueOf:void 0;function me(e){var t=-1,i=e?e.length:0;for(this.clear();++t<i;){var r=e[t];this.set(r[0],r[1]);}}s(me,"Hash");function Os(){this.__data__=ke?ke(null):{};}s(Os,"hashClear");function ws(e){return this.has(e)&&delete this.__data__[e]}s(ws,"hashDelete");function bs(e){var t=this.__data__;if(ke){var i=t[e];return i===ir?void 0:i}return ee.call(t,e)?t[e]:void 0}s(bs,"hashGet");function Ms(e){var t=this.__data__;return ke?t[e]!==void 0:ee.call(t,e)}s(Ms,"hashHas");function ys(e,t){var i=this.__data__;return i[e]=ke&&t===void 0?ir:t,this}s(ys,"hashSet");me.prototype.clear=Os;me.prototype.delete=ws;me.prototype.get=bs;me.prototype.has=Ms;me.prototype.set=ys;function W(e){var t=-1,i=e?e.length:0;for(this.clear();++t<i;){var r=e[t];this.set(r[0],r[1]);}}s(W,"ListCache");function Ls(){this.__data__=[];}s(Ls,"listCacheClear");function Vs(e){var t=this.__data__,i=lt(t,e);if(i<0)return  false;var r=t.length-1;return i==r?t.pop():As.call(t,i,1),true}s(Vs,"listCacheDelete");function ks(e){var t=this.__data__,i=lt(t,e);return i<0?void 0:t[i][1]}s(ks,"listCacheGet");function Gs(e){return lt(this.__data__,e)>-1}s(Gs,"listCacheHas");function Us(e,t){var i=this.__data__,r=lt(i,e);return r<0?i.push([e,t]):i[r][1]=t,this}s(Us,"listCacheSet");W.prototype.clear=Ls;W.prototype.delete=Vs;W.prototype.get=ks;W.prototype.has=Gs;W.prototype.set=Us;function _e(e){var t=-1,i=e?e.length:0;for(this.clear();++t<i;){var r=e[t];this.set(r[0],r[1]);}}s(_e,"MapCache");function Bs(){this.__data__={hash:new me,map:new(Ve||W),string:new me};}s(Bs,"mapCacheClear");function Fs(e){return ut(this,e).delete(e)}s(Fs,"mapCacheDelete");function Ys(e){return ut(this,e).get(e)}s(Ys,"mapCacheGet");function $s(e){return ut(this,e).has(e)}s($s,"mapCacheHas");function Hs(e,t){return ut(this,e).set(e,t),this}s(Hs,"mapCacheSet");_e.prototype.clear=Bs;_e.prototype.delete=Fs;_e.prototype.get=Ys;_e.prototype.has=$s;_e.prototype.set=Hs;function xe(e){this.__data__=new W(e);}s(xe,"Stack");function Ks(){this.__data__=new W;}s(Ks,"stackClear");function js(e){return this.__data__.delete(e)}s(js,"stackDelete");function qs(e){return this.__data__.get(e)}s(qs,"stackGet");function Ws(e){return this.__data__.has(e)}s(Ws,"stackHas");function zs(e,t){var i=this.__data__;if(i instanceof W){var r=i.__data__;if(!Ve||r.length<Cn-1)return r.push([e,t]),this;i=this.__data__=new _e(r);}return i.set(e,t),this}s(zs,"stackSet");xe.prototype.clear=Ks;xe.prototype.delete=js;xe.prototype.get=qs;xe.prototype.has=Ws;xe.prototype.set=zs;function Zs(e,t){var i=ni(e)||xo(e)?ds(e.length,String):[],r=i.length,n=!!r;for(var o in e)(t||ee.call(e,o))&&!(n&&(o=="length"||ho(o,r)))&&i.push(o);return i}s(Zs,"arrayLikeKeys");function Nr(e,t,i){var r=e[t];(!(ee.call(e,t)&&Or(r,i))||i===void 0&&!(t in e))&&(e[t]=i);}s(Nr,"assignValue");function lt(e,t){for(var i=e.length;i--;)if(Or(e[i][0],t))return i;return  -1}s(lt,"assocIndexOf");function Js(e,t){return e&&Rr(t,si(t),e)}s(Js,"baseAssign");function Xt(e,t,i,r,n,o,a){var c;if(r&&(c=o?r(e,n,o,a):r(e)),c!==void 0)return c;if(!ft(e))return e;var l=ni(e);if(l){if(c=mo(e),!t)return lo(e,c)}else {var u=fe(e),m=u==ei||u==or;if(vo(e))return io(e,t);if(u==ti||u==Ct||m&&!o){if(Tr(e))return o?e:{};if(c=po(m?{}:e),!t)return uo(e,Js(c,e))}else {if(!T[u])return o?e:{};c=go(e,u,Xt,t);}}a||(a=new xe);var d=a.get(e);if(d)return d;if(a.set(e,c),!l)var p=i?fo(e):si(e);return fs(p||e,function(I,A){p&&(A=I,I=e[A]),Nr(c,A,Xt(I,t,i,r,A,e,a));}),c}s(Xt,"baseClone");function Qs(e){return ft(e)?_s(e):{}}s(Qs,"baseCreate");function Xs(e,t,i){var r=t(e);return ni(e)?r:ms(r,i(e))}s(Xs,"baseGetAllKeys");function Cs(e){return ct.call(e)}s(Cs,"baseGetTag");function eo(e){if(!ft(e)||Eo(e))return  false;var t=br(e)||Tr(e)?Is:ns;return t.test(de(e))}s(eo,"baseIsNative");function to(e){if(!Dr(e))return Ts(e);var t=[];for(var i in Object(e))ee.call(e,i)&&i!="constructor"&&t.push(i);return t}s(to,"baseKeys");function io(e,t){if(t)return e.slice();var i=new e.constructor(e.length);return e.copy(i),i}s(io,"cloneBuffer");function ri(e){var t=new e.constructor(e.byteLength);return new Xi(t).set(new Xi(e)),t}s(ri,"cloneArrayBuffer");function ro(e,t){var i=t?ri(e.buffer):e.buffer;return new e.constructor(i,e.byteOffset,e.byteLength)}s(ro,"cloneDataView");function no(e,t,i){var r=t?i(Wi(e),true):Wi(e);return vr(r,ls,new e.constructor)}s(no,"cloneMap");function so(e){var t=new e.constructor(e.source,rs.exec(e));return t.lastIndex=e.lastIndex,t}s(so,"cloneRegExp");function oo(e,t,i){var r=t?i(zi(e),true):zi(e);return vr(r,us,new e.constructor)}s(oo,"cloneSet");function ao(e){return tr?Object(tr.call(e)):{}}s(ao,"cloneSymbol");function co(e,t){var i=t?ri(e.buffer):e.buffer;return new e.constructor(i,e.byteOffset,e.length)}s(co,"cloneTypedArray");function lo(e,t){var i=-1,r=e.length;for(t||(t=Array(r));++i<r;)t[i]=e[i];return t}s(lo,"copyArray");function Rr(e,t,i,r){i||(i={});for(var n=-1,o=t.length;++n<o;){var a=t[n],c=r?r(i[a],e[a],a,i,e):void 0;Nr(i,a,c===void 0?e[a]:c);}return i}s(Rr,"copyObject");function uo(e,t){return Rr(e,Sr(e),t)}s(uo,"copySymbols");function fo(e){return Xs(e,si,Sr)}s(fo,"getAllKeys");function ut(e,t){var i=e.__data__;return Io(t)?i[typeof t=="string"?"string":"hash"]:i.map}s(ut,"getMapData");function Ae(e,t){var i=ps(e,t);return eo(i)?i:void 0}s(Ae,"getNative");var Sr=Ci?ii(Ci,Object):No,fe=Cs;(zt&&fe(new zt(new ArrayBuffer(1)))!=ot||Ve&&fe(new Ve)!=nt||Zt&&fe(Zt.resolve())!=ji||Jt&&fe(new Jt)!=st||Qt&&fe(new Qt)!=Wt)&&(fe=s(function(e){var t=ct.call(e),i=t==ti?e.constructor:void 0,r=i?de(i):void 0;if(r)switch(r){case Ps:return ot;case Ns:return nt;case Rs:return ji;case Ss:return st;case Ds:return Wt}return t},"getTag"));function mo(e){var t=e.length,i=e.constructor(t);return t&&typeof e[0]=="string"&&ee.call(e,"index")&&(i.index=e.index,i.input=e.input),i}s(mo,"initCloneArray");function po(e){return typeof e.constructor=="function"&&!Dr(e)?Qs(Es(e)):{}}s(po,"initCloneObject");function go(e,t,i,r){var n=e.constructor;switch(t){case fr:return ri(e);case nr:case sr:return new n(+e);case ot:return ro(e,r);case mr:case dr:case pr:case gr:case hr:case Ir:case Er:case _r:case xr:return co(e,r);case nt:return no(e,r,i);case ar:case lr:return new n(e);case cr:return so(e);case st:return oo(e,r,i);case ur:return ao(e)}}s(go,"initCloneByTag");function ho(e,t){return t=t==null?rr:t,!!t&&(typeof e=="number"||ss.test(e))&&e>-1&&e%1==0&&e<t}s(ho,"isIndex");function Io(e){var t=typeof e;return t=="string"||t=="number"||t=="symbol"||t=="boolean"?e!=="__proto__":e===null}s(Io,"isKeyable");function Eo(e){return !!Zi&&Zi in e}s(Eo,"isMasked");function Dr(e){var t=e&&e.constructor,i=typeof t=="function"&&t.prototype||at;return e===i}s(Dr,"isPrototype");function de(e){if(e!=null){try{return Pr.call(e)}catch{}try{return e+""}catch{}}return ""}s(de,"toSource");function _o(e){return Xt(e,true,true)}s(_o,"cloneDeep");function Or(e,t){return e===t||e!==e&&t!==t}s(Or,"eq");function xo(e){return Ao(e)&&ee.call(e,"callee")&&(!xs.call(e,"callee")||ct.call(e)==Ct)}s(xo,"isArguments");var ni=Array.isArray;function wr(e){return e!=null&&To(e.length)&&!br(e)}s(wr,"isArrayLike");function Ao(e){return Po(e)&&wr(e)}s(Ao,"isArrayLikeObject");var vo=vs||Ro;function br(e){var t=ft(e)?ct.call(e):"";return t==ei||t==or}s(br,"isFunction");function To(e){return typeof e=="number"&&e>-1&&e%1==0&&e<=rr}s(To,"isLength");function ft(e){var t=typeof e;return !!e&&(t=="object"||t=="function")}s(ft,"isObject");function Po(e){return !!e&&typeof e=="object"}s(Po,"isObjectLike");function si(e){return wr(e)?Zs(e):to(e)}s(si,"keys");function No(){return []}s(No,"stubArray");function Ro(){return  false}s(Ro,"stubFalse");Ee.exports=_o;});var Hr=Ui((ou,$r)=>{var Yr="Expected a function",Br=NaN,So="[object Symbol]",Do=/^\s+|\s+$/g,Oo=/^[-+]0x[0-9a-f]+$/i,wo=/^0b[01]+$/i,bo=/^0o[0-7]+$/i,Mo=parseInt,yo=typeof global=="object"&&global&&global.Object===Object&&global,Lo=typeof self=="object"&&self&&self.Object===Object&&self,Vo=yo||Lo||Function("return this")(),ko=Object.prototype,Go=ko.toString,Uo=Math.max,Bo=Math.min,ci=s(function(){return Vo.Date.now()},"now");function Fo(e,t,i){var r,n,o,a,c,l,u=0,m=false,d=false,p=true;if(typeof e!="function")throw new TypeError(Yr);t=Fr(t)||0,pt(i)&&(m=!!i.leading,d="maxWait"in i,o=d?Uo(Fr(i.maxWait)||0,t):o,p="trailing"in i?!!i.trailing:p);function I(v){var N=r,le=n;return r=n=void 0,u=v,a=e.apply(le,N),a}s(I,"invokeFunc");function A(v){return u=v,c=setTimeout(U,t),m?I(v):a}s(A,"leadingEdge");function P(v){var N=v-l,le=v-u,Vi=t-N;return d?Bo(Vi,o-le):Vi}s(P,"remainingWait");function R(v){var N=v-l,le=v-u;return l===void 0||N>=t||N<0||d&&le>=o}s(R,"shouldInvoke");function U(){var v=ci();if(R(v))return B(v);c=setTimeout(U,P(v));}s(U,"timerExpired");function B(v){return c=void 0,p&&r?I(v):(r=n=void 0,a)}s(B,"trailingEdge");function X(){c!==void 0&&clearTimeout(c),u=0,r=l=n=c=void 0;}s(X,"cancel");function C(){return c===void 0?a:B(ci())}s(C,"flush");function O(){var v=ci(),N=R(v);if(r=arguments,n=this,l=v,N){if(c===void 0)return A(l);if(d)return c=setTimeout(U,t),I(l)}return c===void 0&&(c=setTimeout(U,t)),a}return s(O,"debounced"),O.cancel=X,O.flush=C,O}s(Fo,"debounce");function Yo(e,t,i){var r=true,n=true;if(typeof e!="function")throw new TypeError(Yr);return pt(i)&&(r="leading"in i?!!i.leading:r,n="trailing"in i?!!i.trailing:n),Fo(e,t,{leading:r,maxWait:t,trailing:n})}s(Yo,"throttle");function pt(e){var t=typeof e;return !!e&&(t=="object"||t=="function")}s(pt,"isObject");function $o(e){return !!e&&typeof e=="object"}s($o,"isObjectLike");function Ho(e){return typeof e=="symbol"||$o(e)&&Go.call(e)==So}s(Ho,"isSymbol");function Fr(e){if(typeof e=="number")return e;if(Ho(e))return Br;if(pt(e)){var t=typeof e.valueOf=="function"?e.valueOf():e;e=pt(t)?t+"":t;}if(typeof e!="string")return e===0?e:+e;e=e.replace(Do,"");var i=wo.test(e);return i||bo.test(e)?Mo(e.slice(2),i?2:8):Oo.test(e)?Br:+e}s(Fr,"toNumber");$r.exports=Yo;});var h=(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});var Me={};var j=s((e,t)=>{var i;return typeof Me!="undefined"&&Me.env&&Object.keys(Me.env).length>0&&Me.env[e]?Me.env[e]:typeof process!="undefined"&&(i=process.env[e])!=null?i:t},"fromProcess"),g=s(e=>{var t;return e.length>12?(t=e.split("-").pop())!=null?t:"":e},"shortId"),Yi=s((e,t)=>{let i=[],r=0;for(;r<e.length;)i.push(e.slice(r,t+r)),r+=t;return i},"vanillaChunk"),$i=s(async e=>new Promise(t=>{setTimeout(t,e);}),"sleep");function Ht(e,t){return [...e].sort((i,r)=>i[t]-r[t]),e}s(Ht,"sortBy");var S=s(e=>typeof e=="string"?parseFloat(e):e,"ensureNumber");var rt=s(e=>typeof e=="number"?e.toString():e,"ensureString");var ye=s((e,t)=>typeof e=="string"?t.test(e)?S(e.match(t)[0]):S(e):e,"ensurePriceNumber");function Vl(e){return e?e.charAt(0).toUpperCase()+e.slice(1):""}s(Vl,"capitalizeFirstLetter");var Hi=s(e=>e.replace(/\./g,"-"),"dotToDash");var Kt=s((e,t)=>e.length<=t?e:e.substring(0,t-3)+"...","truncateString");function Ki(e,t){if(navigator.sendBeacon)return navigator.sendBeacon(e,JSON.stringify(t))}s(Ki,"sendBeacon");function jt(){let e=s(()=>Math.floor((1+Math.random())*65536).toString(16).substring(1),"randomNumbers");return e()+e()+"-"+e()+"-4"+e().substr(0,3)+"-"+(Math.random()*4|8).toString(16)+e().substr(1,3)+"-"+e()+e()+e()}s(jt,"generateUUIDv4");var ue=s(e=>{let t=e.endsWith("/")?e.substring(0,e.length-1):e;return t=t.replace("www.",""),!t.includes("https://")&&t.includes("http://")&&(t=t.replace("http://","https://")),t},"formatDomain");var yr=Bi(Mr(),1);var Lr=s(e=>{let t=(0, yr.default)(e),i=0,r=0;for(let n=0;n<t.length;n++){let o=t[n],a=o.percentage;a+=i;let c=Math.round(a);i=a-c,o.percentage=c,r+=c;}for(let n=t.length-1;n>=0;n--){let o=t[n],a=r-100;if(a===0)break;if(o.percentage===0)continue;let c=Math.min(o.percentage,a);o.percentage-=c,r-=c;}return t},"groupRounder");function Vr(e,t,i){return `IG: ${Kt(e,48)} - ${Kt(i,28)} (${g(t)})`}s(Vr,"getGaVariationName");var Ge=class Ge{constructor(t){f(this,"id");f(this,"gid");f(this,"type");this.type=t.type,t.unknownId.includes("gid")?(this.id=Ge.fromGqlId(t.unknownId),this.gid=t.unknownId):(this.id=t.unknownId,this.gid=Ge.toGqlId(t.unknownId,t.type));}toString(){return this.gid}static toGqlId(t,i){return t.includes("gid")?t:`gid://shopify/${i}/${t}`}static fromGqlId(t){return t.split("/").pop()}};s(Ge,"ShopifyId");var mt=Ge;var oi=class oi extends mt{constructor(t){super({unknownId:t,type:"Product"});}static toGqlId(t){return t.includes("gid")?t:`gid://shopify/Product/${t}`}};s(oi,"ShopifyProductId");var ve=oi,ai=class ai extends mt{constructor(t){super({unknownId:t,type:"ProductVariant"});}static toGqlId(t){return t.includes("gid")?t:`gid://shopify/ProductVariant/${t}`}};s(ai,"ShopifyVariantId");var Te=ai;function kr(e,t){for(let i of e.shippingRateGroups||[])for(let r of i.rates)if(r.rateType===t&&r.amount)return S(r.amount)}s(kr,"getShippingTresholdByShippingRateGroups");var x={IG_ID_KEY:"ig-id",IG_FV_KEY:"ig-fv",IG_VARS_KEY:"ig-vars",IG_IGNORED_KEY:"ig-ignored",IG_TOKEN_KEY:"ig-auth-token",IG_PAGE_VIEW_COUNT_KEY:"ig-pv",ID_SIZE:36,ID_PREFIX:"ig",ID_SPACER:"_",ID_COOKIE_DAYS_TO_LIVE:365,INTELLIGEMS_TRACK_ENDPOINT:j("API_URL",void 0)?`${j("API_URL",void 0)}/v3/track`:"https://api.intelligems.io/v3/track",KLAVIYO_IDS_COOKIE:"ig-klaviyo-ids",GEO_LOCATION_COOKIE:"ig-location"},dt={PREVIEW_KEY:"ig-preview",PREVIEW_VARIATION_ID:"ig-variation",INTEGRATION_KEY:"ig-integration",OPT_KEY:"ig-opt",SS_KEY:"ig-ss",TG_KEY:"igTg",SKIP_REDIRECT_KEY:"ig-skip-redirect",BUILDER_KEY:"ig-builder",BUILDER_MODE_KEY:"ig-builder-mode",WARNINGS_KEY:"ig-warnings",PREVIEW_ALL_TRAFFIC_KEY:"ig-preview-traffic",SESSION_CONFIG_KEY:"ig-config",SESSION_INIT_CONFIG_KEY:"ig-init-config",CHANGES_KEY:"ig-changes",CAMPAIGN_QUERY_PARAM_KEY:"ig-campaign",GEO_LOCATION_COOKIE:"ig-location",KLAVIYO_IDS_COOKIE:"ig-klaviyo-ids",BUILDER_CONTAINER:"ig-container"},Jl={CUSTOM_CSS_ID_KEY:"ig-custom-css",CUSTOM_JS_ID_KEY:"ig-custom-js"};var Xl={INTELLIGEMS_HEADLESS_VERSION_ENDPOINT:"https://api.intelligems.io/headless/version",WIDGETS_STATE_KEY:"igWidgetsState",CAMPAIGN_QUERY_PARAM_KEY:"ig-campaign",PREVIEW_KEY:"ig-preview",INTEGRATION_KEY:"ig-integration",BUILDER_KEY:"ig-builder",BUILDER_TOOLBAR:"ig-builder-toolbar",BUILDER_WIDGET_ID:"ig-builder-widget",EXPS_KEY:"ig-exps",IG_VARS_KEY:"ig-vars"},Pe={LINE_ITEM_DISCOUNT:"_igLineItemDiscount",LINE_ITEM_PRICE:"_igp",LINE_ITEM_TEST_GROUP:"_igTestGroup",LINE_ITEM_TEST_GROUPS:"_igTestGroups",LINE_ITEM_PREVIEW:"_igPreview"};var Xe={};k(Xe,{getIgLineItemDiscount:()=>yn,getIgLineItemPrice:()=>Ln,getLineItemDiscount:()=>wn,getLineItemPrice:()=>Mn,wrapStorefrontItemCustomAttributes:()=>bc});function Gr(e){if(e.productVariant){let t=e.productVariant.variationPrices.find(i=>i.name===e.variationName);if(t!=null&&t.price)if(e.variations){let i;i=Math.max(...e.variations.map(o=>{var c;let a=(c=e.productVariant.variationPrices.find(l=>l.name===o.name))==null?void 0:c.price;return a?typeof a=="string"?parseFloat(a):a:0}));let r=Number(i)-Number(t.price),n;return e.includeSubscribeAndSave&&t.subscriptionDiscount?r===0?n=0:n=(1-S(t.subscriptionDiscount)/100)*r:n=r,n=n*100,e.currencyRate&&(n/=parseFloat(e.currencyRate)),n=n.toFixed(0),n==="NaN"?"":n}else return "";else return ""}else return ""}s(Gr,"_getIgLineItemDiscount");function Ur(e){let t=null,i=e.productVariant.variationPrices.find(o=>o.name===e.variationName);if(!i)return "";let r=1,n=1;if(e.includeSubscribeAndSave&&(r=1-S(i.subscriptionDiscount||0)/100),e.isComparePrice){if(!i.compareAtPrice)return "";t=S(i.compareAtPrice)*n;}else t=S(i.price)*r*n;return isNaN(t)?"":rt(t)}s(Ur,"_getIgLineItemPrice");var pe={DEBUG:0,INFO:1,WARNING:2,ERROR:3},te=class te{static debug(...t){te.logLevel<=pe.DEBUG&&console.debug("IG Debug: ",...t);}static info(...t){te.logLevel<=pe.INFO&&console.info("IG Info: ",...t);}static warn(...t){te.logLevel<=pe.WARNING&&console.warn("IG Warning: ",...t);}static error(...t){te.logLevel<=pe.ERROR&&console.error("IG Error: ",...t);}static log(t,...i){switch(t){case "Debug":this.debug(i);break;case "Info":this.info(i);break;case "Warning":this.warn(i);break;case "Error":this.error(i);break;default:this.info(i);}}static logWithFunction(t,i,r){this.log(t,i,r);}static logUndefinedParams(t,i,r){this.logWithFunction(t,i,`Undefined Params: ${JSON.stringify(r,(n,o)=>o===void 0?null:o)}`);}};s(te,"Logger"),f(te,"logLevel",pe[j("IG_LOG_LEVEL","DEBUG")]||0);var _=te;var ht=Bi(Hr(),1);var gt=s(e=>j("NODE_ENV",void 0)==="test"?0:e,"setThrottleTimeout");function Ko(){var e,t,i,r,n,o,a,c;return ((o=(n=(r=(i=(t=(e=window==null?void 0:window.Flow)==null?void 0:e.shopify)==null?void 0:t.cart)==null?void 0:i.shopifyCart)==null?void 0:r.cartData)==null?void 0:n.attributes)==null?void 0:o.geo_currency)||js_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("coin-currency")||JSON.parse(js_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("GlobalE_Data")||"{}").currencyCode||((c=(a=window==null?void 0:window.Shopify)==null?void 0:a.currency)==null?void 0:c.active)||js_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("cart_currency")||false}s(Ko,"_getCurrency");var Kr=(0, ht.default)(Ko,gt(5),{leading:true});function jo(e){var t,i;return ((i=e&&new Intl.Locale(navigator.language).region||((t=window==null?void 0:window.Shopify)==null?void 0:t.country)||js_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("localization"))==null?void 0:i.toUpperCase())||false}s(jo,"_getLocalization");var jr=(0, ht.default)(jo,gt(5),{leading:true});function qo(){return Number(js_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get(x.IG_PAGE_VIEW_COUNT_KEY)||"0")}s(qo,"_getPageViewCount");(0, ht.default)(qo,gt(50),{leading:true});var Ie={};k(Ie,{ExperienceDirective:()=>re,determineAudienceConditionMatch:()=>$a,displayAudienceFilters:()=>Ya,isExcludedByMarket:()=>Ba});var H={};k(H,{_determinePageTargetingIncluded:()=>ga,_getVariation:()=>ea,createLogHandler:()=>Ia,createMessageHandler:()=>ha,determineAudienceURLMatch:()=>pa,determineGlobalAudienceExclusionsShared:()=>da,getControlVariation:()=>Jo,getProductIdFromVariantId:()=>ma,getVariationByIgId:()=>It,getWidget:()=>Qo,hasWidget:()=>Xo,initSharedExperience:()=>Zo});var w=class w{static getParams(){var t;try{return new URLSearchParams(typeof typeof window!="undefined"&&((t=window==null?void 0:window.location)==null?void 0:t.search)||"")}catch{return new URLSearchParams("")}}static mutateFunc(){typeof process!="undefined"&&typeof window!="undefined"&&window.location.search!==w.previousSearch&&(w.debug&&console.log(`[IG Search Params]: Params changed from ${w.previousSearch} to ${window.location.search}`),w.previousSearch=window.location.search,w.params=new URLSearchParams(window.location.search));}static init(){var t;w.getParams(),(t=w.observer)==null||t.observe(document,{childList:true,subtree:true}),w.mutateFunc();}static getItem(t){return this.params.get(t)}};s(w,"IgSearchParams"),f(w,"params",w.getParams()),f(w,"previousSearch",""),f(w,"debug",false),f(w,"observer",typeof MutationObserver!="undefined"&&typeof window!="undefined"?new MutationObserver(function(t){w.mutateFunc();}):void 0);var z=w;var qr=s(()=>!navigator||!navigator.userAgent||!navigator.userAgent.length?null:/Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)?"mobile":"desktop","getDeviceType");function Wr(e,t){if(!(!t||!e))return t==="default"?e.find(i=>i.isControl):e.find(i=>i.id===t)}s(Wr,"getPreviewVariation");var ge={};k(ge,{getShippingRateAmount:()=>Wo,initSharedVariation:()=>li,toTrackModel:()=>zo});function li(e){var t;return {...e,shippingRateGroups:e.shippingRateGroups,isExcluded:"isExcluded"in e?e.isExcluded:void 0,testExperienceId:"testExperienceId"in e&&(t=e.testExperienceId)!=null?t:void 0,onsiteEdits:"onsiteEdits"in e?e.onsiteEdits:[],order:"order"in e?e.order:0,shortId:g(e.id),offer:void 0}}s(li,"initSharedVariation");function Wo(e,t){return kr(e,t)}s(Wo,"getShippingRateAmount");function zo(e){return {id:e.id,name:e.name,percentage:e.percentage,isControl:e.isControl,order:e.order,isExcluded:e.isExcluded}}s(zo,"toTrackModel");var Be={};function Zo(e){var r,n,o,a,c,l,u;if("shippingRateGroups"in e&&((r=e.shippingRateGroups)!=null&&r.length))for(let m of e.shippingRateGroups)((n=Be&&Be[m.variationId])!=null?n:Be[m.variationId]=[]).push(m);let t=(o=e.variations)!=null?o:[],i="experienceIntegrations"in e&&(a=e.experienceIntegrations)!=null?a:null;return {...e,name:"name"in e?e.name:"",entityType:"experience",testTypes:{hasTestOnsiteInjections:false,hasTestContentUrl:false,hasTestContentTheme:false,hasTestContentTemplate:false,hasTestContentOnsite:false,hasTestContentAdvanced:false,hasTestContent:false,hasTestShipping:false,...e.testTypes},isPreview:e.isPreview||false,pausedAtTs:"pausedAtTs"in e&&e.pausedAtTs||null,audience:e.audience?{...e.audience,filters:(c=e.audience)!=null&&c.filters?[...Ht(e.audience.filters,"priority")]:[]}:void 0,variations:t.map(m=>{var p;let d=(p=Be&&Be[m.id])!=null?p:[];return li({...m,shippingRateGroups:d})}),experiencePageTargeting:e.experiencePageTargeting?[...e.experiencePageTargeting.sort((m,d)=>{let p=m.expression!=null,I=d.expression!=null;return p===I?m.order-d.order:p?-1:1})]:void 0,experienceProducts:"experienceProducts"in e&&(l=e.experienceProducts)!=null?l:null,currency:"currency"in e&&(u=e.currency)!=null?u:void 0,experienceIntegrations:i,widgets:{},foundVariation:null,forceExcludeEntireExperience:false,isDiscountEnabled:false,measurementId:"measurementId"in e&&e.measurementId||null,hasRedirects:null}}s(Zo,"initSharedExperience");function zr(e){let{entity:t,audience:i}=e;t.forceExcludeEntireExperience=true,i.permaExclude(t.id);}s(zr,"_setForceExcludeEntireExperiment");function Jo(e){var t;return ((t=e.variations)==null?void 0:t.find(i=>i.isControl))||null}s(Jo,"getControlVariation");function Qo(e,t){return e.widgets[t]}s(Qo,"getWidget");function Xo(e,t){return e.widgets[t]!==void 0}s(Xo,"hasWidget");function Zr(e,t){let i=t.getHistory(e.id);return i&&e.variations?[...e.variations].find(r=>g(r.id)===i||r.name===i):null}s(Zr,"_findStoredVariation");function It(e){let{entity:t}=e;if(e.igId.id()&&t.variations){let i=0;for(let r of t.variations)if(i+=r.percentage,t.igIdHex<i)return r}return null}s(It,"getVariationByIgId");function Jr(e,t){let{audience:i,params:r,geoLocation:n,igId:o}=e;return i.determineAudienceConditionMatch(r,t,o,n)}s(Jr,"_matchByFilter");function Ne(e,t){var i;return (i=e.entity.audience)==null?void 0:i.filters.map(r=>{let n=Jr(e,r);return t==="success"?n.matched?`Audience conditions met: ${n.by}`:void 0:`Audience conditions ${n.matched?"met":"not met"}: ${n.by}`}).filter(r=>r).join(". ")}s(Ne,"_getAudienceMessage");function Co(e){let{entity:t,audience:i,preview:r,message:n,params:o,redirect:a}=e,c=r.isPreviewTraffic&&r.isPreviewIntegration&&r.isPreviewEntity;switch(c&&n.setIfUndefined({severity:"warning",type:"previewTraffic",message:"You have disabled all exclusion rules during preview."}),i.shouldAssign(t.id,t.audience)){case "noassign":return n.setIfUndefined({severity:"error",type:"excluded",message:Ne(e,"fail")||"You are excluded from this test because you were were previously excluded from this test."}),t.forceExcludeEntireExperience=true,"noVariationFound";case "defer":return n.setIfUndefined({severity:"error",type:"unassigned",message:Ne(e,"fail")||"You are not yet assigned in this test because critical information is not present."}),null;}let l=oa(e);if(l)return l;let u=Zr(t,i);if(u)if(fa(e))i.unassign(t.id),i.removeIncludeTimeStamp(t.id);else {let d=ui(e),p=d!=null?d:u;return en(e,p)?n.assign(Xr(p)):d&&n.assign(`You are previewing ${d.name}`),p}if(t.requiresLink&&o.get("ig-campaign")!==t.id.slice(-12))return "noVariationFound";if(a.hasRedirects&&!a.matchesRedirectCondition)return i.unassign(t.id,"redirect"),n.setIfUndefined({severity:"info",type:"unassigned",message:"You are not assigned until you visit the page to be redirected."}),"noVariationFound";if(!c){let d=sa(e);if(d.group)return n.setIfUndefined({severity:"success",type:"assigned",message:Ne(e,"success")}),d.group;if(d.reason)return "noVariationFound";let p=ta(e);if(p.group)return n.setIfUndefined({severity:"success",type:"assigned",message:Ne(e,"success")}),p.group;if(p.reason)return p.reason==="forceExclude"?n.setIfUndefined({severity:"error",type:"excluded",message:Ne(e,"fail")||"You have been excluded from this test because no exclusion rules passed."}):n.setIfUndefined({severity:"error",type:"unassigned",message:Ne(e,"fail")||"You are not yet assigned in this test because no exclusion rules passed."}),"noVariationFound"}let m=It(e);if(m){let d=ui(e);return d?n.assign(Cr(m)):n.setIfUndefined({severity:"info",type:"assigned",message:t.category==="personalization"?"You have been included in the Personalization":`You have been randomly put into ${m.name}`}),d!=null?d:m}return null}s(Co,"_determineVariation");function ea(e){var l;let{entity:t,audience:i,preview:r,storage:n,logger:o}=e;if(t.forceExcludeEntireExperience&&!r.isPreviewIntegration&&!r.isPreviewTraffic)return null;if(!r.isPreviewIntegration&&t.foundVariation!==null)return t.foundVariation=="noVariationFound"?null:t.foundVariation;let a=Co(e);if(t.foundVariation=a,!a||a==="noVariationFound")return o.info(`${t.constructor.name}/getVariation`,JSON.stringify({finalVariation:a})),null;let c=Zr(t,i);return (!c||a.name!==c.name)&&n.set(g(t.id),g(a.id)),(l=t.audience)!=null&&l.evaluationFrequency&&!i.getInclusionTimeStamp(t.id)&&i.setInclusionTimeStamp(t.id),a}s(ea,"_getVariation");function Qr(e,t){let{entity:i,audience:r,logger:n}=e;return r.unassign(i.id),n.debug(t?"experiment/determineElseVariation":"experiment/determineVariationByFilters","Leaving user unassigned"),{group:null,reason:"unassigned"}}s(Qr,"_unassignUser");function ta(e){let{entity:t}=e;return !t.audience||!t.variations||!t.audience.elseAction?{group:null}:t.audience.elseAction==="assignVariation"&&t.audience.elseVariationId?ia(e):t.audience.elseAction==="randomVariation"?ra(e):t.audience.elseAction==="experienceExclude"?na(e):t.audience.elseAction==="experienceUnassigned"?Qr(e,true):{group:null}}s(ta,"_determineElseVariation");function ia(e){var a;let{entity:t,storage:i,message:r,logger:n}=e,o=t.variations.find(c=>{var l;return c.id===((l=t.audience)==null?void 0:l.elseVariationId)});return o?(i.setAnalyticsExcluded((a=t.audience)==null?void 0:a.elseExcludeFromAnalytics),en(e,o)?r.assign(Xr(o)):r.assign(`You have been put into ${o.name} because no exclusion rules passed.`),n.debug("experiment/determineElseVariation",`Forcing into ${o.name}`),{group:o}):{group:null}}s(ia,"_determineVariationByAssignElse");function ra(e){let{message:t,logger:i}=e,r=It(e);return r&&(t.assign(`You have been randomly put into ${r.name} because no exclusion rules passed.`),i.debug("experiment/determineElseVariation",`Forcing into ${r.name}`)),{group:r}}s(ra,"_determineVariationByRandomElse");function na(e){var n;let{entity:t,logger:i,storage:r}=e;return r.setAnalyticsExcluded((n=t.audience)==null?void 0:n.elseExcludeFromAnalytics),zr(e),i.debug("experiment/determineElseVariation","Excluding from test"),{group:null,reason:"forceExclude"}}s(na,"_determineVariationByExcludeElse");function sa(e){var r,n;let{entity:t}=e,i=(n=(r=t.audience)==null?void 0:r.filters)!=null?n:[];i=Ht(i,"priority");for(let o of i){let a=Jr(e,o);if(a.matched)if(t.variations){if(o.action==="assignVariation")return aa(e,o,a);if(o.action==="randomVariation")return ca(e,o,a);if(o.action==="experienceExclude")return la(e,o,a);if(o.action==="experienceInclude")return ua(e,o,a);if(o.action==="experienceUnassigned"||o.action==="leaveUnassigned")return Qr(e)}else return {group:null}}return {group:null}}s(sa,"_determineVariationByFilters");function oa(e){var l;let{entity:t,params:i,message:r,logger:n,preview:o}=e,a=i.get("igTg");if(!a)return null;tn("igTg");let c=((l=t.variations)!=null?l:[]).find(u=>u.id===a||g(u.id)===a);return c&&(r.assign(`You have been forced into ${c.name} by the 'igTg' query param.`),n.debug("experiment/determineVariationByIgTgParam",`Forcing into ${c==null?void 0:c.name} -- igTg Override`),o.setVariationId(c.id)),c!=null?c:null}s(oa,"_determineVariationByIgTgParam");function aa(e,t,i){var u,m,d;let{entity:r,storage:n,message:o,logger:a,params:c}=e,l;return (u=t.expression)!=null&&u.find(p=>{var I;return ((I=p.query)==null?void 0:I.key)==="igTg"})?l=(m=r.variations)==null?void 0:m.find(p=>p.id===c.get("igTg")||g(p.id)===c.get("igTg")):l=(d=r.variations)==null?void 0:d.find(p=>p.id===t.variationId),l?(n.setAnalyticsExcluded(t.excludeFromAnalytics),o.assign(`You have been put into ${l.name} ${i.by}.`),a.debug("experiment/determineVariationByFilters",`Forcing into ${l.name}`),{group:l}):{group:null}}s(aa,"_determineVariationByAssignFilter");function ca(e,t,i){let{message:r,logger:n}=e,o=ui(e);if(o)return r.assign(Cr(o,i)),{group:o};{let a=It(e);return a&&(r.assign(`You have been randomly put into ${a.name} ${i.by}.`),n.debug("experiment/determineVariationByFilters",`Forcing into ${a.name}`)),{group:a}}}s(ca,"_determineVariationByRandomFilter");function la(e,t,i){var c;let{entity:r,storage:n,message:o,logger:a}=e;return n.setAnalyticsExcluded((c=r.audience)==null?void 0:c.elseExcludeFromAnalytics),zr(e),o.set({severity:"error",type:"excluded",message:`You have been excluded from this test ${i.by}.`}),a.debug("experiment/determineVariationByFilters","Excluding from test"),{group:null,reason:"forceExclude"}}s(la,"_determineVariationByExcludeFilter");function ua(e,t,i){let{entity:r,message:n,logger:o}=e;return n.assign(`You have been included in this personalization ${i.by}.`),o.debug("experiment/determineVariationByFilters","Including in experience"),{group:r.variations[0]}}s(ua,"_determineVariationByIncludeFilter");function Xr(e){return `You are excluded from the test and receiving the ${e.name} pricing`}s(Xr,"_getPriceTestElseMessage");function Cr(e,t){let i=t?` (${t.by})`:"";return `You are previewing ${e.name}${i}.`}s(Cr,"_getPreviewMessage");function ui(e){return Wr(e.entity.variations,e.preview.getVariationId())}s(ui,"_getPreviewVariation");function fa(e){var r,n;let{entity:t,audience:i}=e;return ((r=t.audience)==null?void 0:r.evaluationFrequency)&&i.getInclusionTimeStamp(t.id)&&!i.isWithinEvaluationTimeSpan(t.id,(n=t.audience)==null?void 0:n.evaluationFrequency)}s(fa,"_shouldEvaluateAssignment");function en(e,t){var o,a,c;let{entity:i,storage:r,preview:n}=e;return t.isControl&&r.isAnalyticsExcluded()&&n.getVariationId()==="default"&&i.category==="experiment"&&i.type==="pricing"&&((o=i.audience)==null?void 0:o.elseAction)==="assignVariation"&&((a=i.audience)==null?void 0:a.elseVariationId)===t.id&&((c=i.audience)==null?void 0:c.elseExcludeFromAnalytics)}s(en,"_isPriceTestElseAssignment");function ma(e,t){if(e.experienceProducts){for(let i of e.experienceProducts)for(let r of i.variants)if(r.id===t)return i.id}return null}s(ma,"getProductIdFromVariantId");function da(e,t,i){let r=t.isExcluded(e.id),n=t.isPermaExcluded(e.id),{expected:o,found:a,pending:c}=t.isExcludedByMarket(e.audience),l=!c&&a,u=(i.igPageViewCount||0)<=2;r&&!l&&u&&t.unexclude(e.id);let m=t.isWholesale(e.audience);return n||(l?i.messages[e.id]={severity:"error",type:"excluded",message:`You are excluded because your currency/country is ${l}, which is not ${rn(o)}.`}:m&&(i.messages[e.id]={type:"excluded",severity:"error",message:"You are excluded because you are registered as a wholesale customer."})),{trafficExclusion:(r||n?"Previously Excluded":false)||l||m}}s(da,"determineGlobalAudienceExclusionsShared");function pa(e,t){let i=decodeURIComponent(String(t.value)).toLowerCase(),r,n=e.replace(/^\/+|\/+$/g,"");try{r=new URL(i).pathname.replace(/^\/+|\/+$/g,"");}catch{r=t.value.replace(/^\/+|\/+$/g,"");}return fi({actual:n,value:r,matchBy:t.filter})}s(pa,"determineAudienceURLMatch");function ga(e){var i;if(!((i=e.experiencePageTargeting)!=null&&i.length))return  true;let t=new URL(window.location.href);for(let r of e.experiencePageTargeting)if(r.expression!=null&&Et(z.params,r.expression,{id:s(()=>"","id"),isFirstVisit:s(()=>false,"isFirstVisit")},void 0,t).matched)return  true;return  false}s(ga,"_determinePageTargetingIncluded");function ha(e){return {...e,setIfUndefined:s(r=>{e.get()===void 0&&e.set(r);},"setIfUndefined"),assign:s(r=>{e.set({type:"assigned",severity:"info",message:r});},"assign")}}s(ha,"createMessageHandler");function Ia(e){return {debug:s((t,i)=>e.logWithFunction("Debug",t,i),"debug"),info:s((t,i)=>e.logWithFunction("Info",t,i),"info")}}s(Ia,"createLogHandler");var Fe={};k(Fe,{_getExperienceProductById:()=>Ea,_getExperienceProductVariantById:()=>mi,_getExperienceProductVariantByProdId:()=>di});function Ea(e){for(let r of e.experiences)if(!(e.experienceTypeProperty&&!Reflect.get(r,e.experienceTypeProperty))){for(let n of e.experienceProducts.filter(o=>o.experienceId===r.id)||[])if(n.id===e.productId)return {experienceId:r.id,product:n}}return {experienceId:null,product:null}}s(Ea,"_getExperienceProductById");function mi(e){for(let r of e.experiences)if(!(e.experienceTypeProperty&&!Reflect.get(r,e.experienceTypeProperty)))for(let n of e.experienceProducts.filter(o=>o.experienceId===r.id)||[]){let o=n.variants.find(a=>a.id===e.variantId);if(o)return {experienceId:r.id,productVariant:o}}return {experienceId:null,productVariant:null}}s(mi,"_getExperienceProductVariantById");function di(e){var o;let i=((o=e.maxOrMin)!=null?o:"min")==="min"?_a:xa,r=null,n=null;for(let a of e.experiences){if(e.experienceTypeProperty&&!Reflect.get(a,e.experienceTypeProperty))continue;let c=e.getVariationName(a.id);if(c){let l=i({productId:e.productId,variationName:c,products:e.experienceProducts.filter(u=>u.experienceId===a.id)||[]});if(l)return {experienceId:a.id,productVariant:l}}}return {experienceId:n,productVariant:r}}s(di,"_getExperienceProductVariantByProdId");function _a(e){let t={price:Number.MAX_VALUE,variant:void 0};for(let i of e.products)if(i.id===e.productId)for(let r of i.variants){let n=r.variationPrices.find(o=>o.name===e.variationName);n&&S(n.price)<t.price&&(t={variant:r,price:S(n.price)});}return t.variant}s(_a,"getLowestVariantPrice");function xa(e){let t={price:Number.MIN_VALUE,variant:void 0};for(let i of e.products)if(i.id===e.productId)for(let r of i.variants){let n=r.variationPrices.find(o=>o.name===e.variationName);n&&S(n.price)>t.price&&(t={variant:r,price:S(n.price)});}return t.variant}s(xa,"getHighestVariantPrice");function nn(e,t,i,r){let n=i.determinePageTargetingIncluded(e);if(e.isPreview&&!r.isPreviewMode)return "Preview Experience";if(!n)return r.logger.logWithFunction("Debug","shouldExcludeExperiment",`Page Targeting Exclude for ${e.id}`),r.messages[e.id]={severity:"error",type:"excludedPage",message:"You are excluded because Page Targeting is enabled and this page does not match any page targeting rules."},"Page Target Exclude";let o=i.determineGlobalAudienceExclusions(e,t);return r.isPreviewMode?r.isPreviewAllTrafficMode?(r.messages[e.id]={severity:"error",message:"",type:"excluded"},false):o.trafficExclusion:e.isPreview?false:e.forceExcludeEntireExperience?"Force Exclude Experience":o.trafficExclusion}s(nn,"shouldExcludeExperienceShared");var pi=["360.cn","alice","aol","ar.search.yahoo.com","ask","at.search.yahoo.com","au.search.yahoo.com","auone","avg","babylon","baidu","biglobe","biglobe.co.jp","biglobe.ne.jp","bing","br.search.yahoo.com","ca.search.yahoo.com","centrum.cz","ch.search.yahoo.com","cl.search.yahoo.com","cn.bing.com","bing.com","cnn","co.search.yahoo.com","comcast","conduit","daum","daum.net","de.search.yahoo.com","dk.search.yahoo.com","dogpile","dogpile.com","duckduckgo","ecosia.org","email.seznam.cz","eniro","es.search.yahoo.com","espanol.search.yahoo.com","exalead.com","excite.com","fi.search.yahoo.com","firmy.cz","fr.search.yahoo.com","globo","go.mail.ru","google","google.com","google-play","hk.search.yahoo.com","id.search.yahoo.com","in.search.yahoo.com","incredimail","it.search.yahoo.com","kvasir","lens.google.com","lite.qwant.com","lycos","m.baidu.com","m.naver.com","m.search.naver.com","m.sogou.com","mail.rambler.ru","mail.yandex.ru","malaysia.search.yahoo.com","msn","msn.com","mx.search.yahoo.com","najdi","naver","naver.com","news.google.com","nl.search.yahoo.com","no.search.yahoo.com","ntp.msn.com","nz.search.yahoo.com","onet","onet.pl","pe.search.yahoo.com","ph.search.yahoo.com","pl.search.yahoo.com","play.google.com","qwant","qwant.com","rakuten","rakuten.co.jp","rambler","rambler.ru","se.search.yahoo.com","search-results","search.aol.co.uk","search.aol.com","search.google.com","search.smt.docomo.ne.jp","search.ukr.net","secureurl.ukr.net","seznam","seznam.cz","sg.search.yahoo.com","so.com","sogou","sogou.com","sp-web.search.auone.jp","startsiden","startsiden.no","suche.aol.de","terra","th.search.yahoo.com","tr.search.yahoo.com","tut.by","tw.search.yahoo.com","uk.search.yahoo.com","ukr","us.search.yahoo.com","virgilio","vn.search.yahoo.com","wap.sogou.com","webmaster.yandex.ru","websearch.rakuten.co.jp","yahoo","yahoo.co.jp","yahoo.com","yandex","yandex.by","yandex.com","yandex.com.tr","yandex.fr","yandex.kz","yandex.ru","yandex.ua","yandex.uz","zen.yandex.ru"];var gi=["Google Shopping","IGShopping","aax-us-east.amazon-adsystem.com","aax.amazon-adsystem.com","alibaba","alibaba.com","amazon","amazon.co.uk","amazon.com","apps.shopify.com","checkout.shopify.com","checkout.stripe.com","cr.shopping.naver.com","cr2.shopping.naver.com","ebay","ebay.co.uk","ebay.com","ebay.com.au","ebay.de","etsy","etsy.com","m.alibaba.com","m.shopping.naver.com","mercadolibre","mercadolibre.com","mercadolibre.com.ar","mercadolibre.com.mx","message.alibaba.com","msearch.shopping.naver.com","nl.shopping.net","no.shopping.net","offer.alibaba.com","one.walmart.com","order.shopping.yahoo.co.jp","partners.shopify.com","s3.amazonaws.com","se.shopping.net","shop.app","shopify","shopify.com","shopping.naver.com","shopping.yahoo.co.jp","shopping.yahoo.com","shopzilla","shopzilla.com","simplycodes.com","store.shopping.yahoo.co.jp","stripe","stripe.com","uk.shopping.net","walmart","walmart.com"];var hi=["43things","43things.com","51.com","5ch.net","Hatena","ImageShack","academia.edu","activerain","activerain.com","activeworlds","activeworlds.com","addthis","addthis.com","airg.ca","allnurses.com","allrecipes.com","alumniclass","alumniclass.com","ameba.jp","ameblo.jp","americantowns","americantowns.com","amp.reddit.com","ancestry.com","anobii","anobii.com","answerbag","answerbag.com","answers.yahoo.com","aolanswers","aolanswers.com","apps.facebook.com","ar.pinterest.com","artstation.com","askubuntu","askubuntu.com","asmallworld.com","athlinks","athlinks.com","away.vk.com","awe.sm","b.hatena.ne.jp","baby-gaga","baby-gaga.com","babyblog.ru","badoo","badoo.com","bebo","bebo.com","beforeitsnews","beforeitsnews.com","bharatstudent","bharatstudent.com","biip.no","biswap.org","bit.ly","blackcareernetwork.com","blackplanet","blackplanet.com","blip.fm","blog.com","blog.feedspot.com","blog.goo.ne.jp","blog.naver.com","blog.yahoo.co.jp","blogg.no","bloggang.com","blogger","blogger.com","blogher","blogher.com","bloglines","bloglines.com","blogs.com","blogsome","blogsome.com","blogspot","blogspot.com","blogster","blogster.com","blurtit","blurtit.com","bookmarks.yahoo.co.jp","bookmarks.yahoo.com","br.pinterest.com","brightkite","brightkite.com","brizzly","brizzly.com","business.facebook.com","buzzfeed","buzzfeed.com","buzznet","buzznet.com","cafe.naver.com","cafemom","cafemom.com","camospace","camospace.com","canalblog.com","care.com","care2","care2.com","caringbridge.org","catster","catster.com","cbnt.io","cellufun","cellufun.com","centerblog.net","chat.zalo.me","chegg.com","chicagonow","chicagonow.com","chiebukuro.yahoo.co.jp","classmates","classmates.com","classquest","classquest.com","co.pinterest.com","cocolog-nifty","cocolog-nifty.com","copainsdavant.linternaute.com","couchsurfing.org","cozycot","cozycot.com","cross.tv","crunchyroll","crunchyroll.com","cyworld","cyworld.com","cz.pinterest.com","d.hatena.ne.jp","dailystrength.org","deluxe.com","deviantart","deviantart.com","dianping","dianping.com","digg","digg.com","diigo","diigo.com","discover.hubpages.com","disqus","disqus.com","dogster","dogster.com","dol2day","dol2day.com","doostang","doostang.com","dopplr","dopplr.com","douban","douban.com","draft.blogger.com","draugiem.lv","drugs-forum","drugs-forum.com","dzone","dzone.com","edublogs.org","elftown","elftown.com","epicurious.com","everforo.com","exblog.jp","extole","extole.com","facebook","facebook.com","faceparty","faceparty.com","fandom.com","fanpop","fanpop.com","fark","fark.com","fb","fb.me","fc2","fc2.com","feedspot","feministing","feministing.com","filmaffinity","filmaffinity.com","flickr","flickr.com","flipboard","flipboard.com","folkdirect","folkdirect.com","foodservice","foodservice.com","forums.androidcentral.com","forums.crackberry.com","forums.imore.com","forums.nexopia.com","forums.webosnation.com","forums.wpcentral.com","fotki","fotki.com","fotolog","fotolog.com","foursquare","foursquare.com","free.facebook.com","friendfeed","friendfeed.com","fruehstueckstreff.org","fubar","fubar.com","gaiaonline","gaiaonline.com","gamerdna","gamerdna.com","gather.com","geni.com","getpocket.com","glassboard","glassboard.com","glassdoor","glassdoor.com","godtube","godtube.com","goldenline.pl","goldstar","goldstar.com","goo.gl","gooblog","goodreads","goodreads.com","google+","googlegroups.com","googleplus","govloop","govloop.com","gowalla","gowalla.com","gree.jp","groups.google.com","gulli.com","gutefrage.net","habbo","habbo.com","hi5","hi5.com","hootsuite","hootsuite.com","houzz","houzz.com","hoverspot","hoverspot.com","hr.com","hu.pinterest.com","hubculture","hubculture.com","hubpages.com","hyves.net","hyves.nl","ibibo","ibibo.com","id.pinterest.com","identi.ca","ig","imageshack.com","imageshack.us","imvu","imvu.com","in.pinterest.com","insanejournal","insanejournal.com","instagram","instagram.com","instapaper","instapaper.com","internations.org","interpals.net","intherooms","intherooms.com","irc-galleria.net","is.gd","italki","italki.com","jammerdirect","jammerdirect.com","jappy.com","jappy.de","kaboodle.com","kakao","kakao.com","kakaocorp.com","kaneva","kaneva.com","kin.naver.com","l.facebook.com","l.instagram.com","l.messenger.com","last.fm","librarything","librarything.com","lifestream.aol.com","line","line.me","linkedin","linkedin.com","listal","listal.com","listography","listography.com","livedoor.com","livedoorblog","livejournal","livejournal.com","lm.facebook.com","lnkd.in","m.blog.naver.com","m.cafe.naver.com","m.facebook.com","m.kin.naver.com","m.vk.com","m.yelp.com","mbga.jp","medium.com","meetin.org","meetup","meetup.com","meinvz.net","meneame.net","menuism.com","messages.google.com","messages.yahoo.co.jp","messenger","messenger.com","mix.com","mixi.jp","mobile.facebook.com","mocospace","mocospace.com","mouthshut","mouthshut.com","movabletype","movabletype.com","mubi","mubi.com","my.opera.com","myanimelist.net","myheritage","myheritage.com","mylife","mylife.com","mymodernmet","mymodernmet.com","myspace","myspace.com","netvibes","netvibes.com","news.ycombinator.com","newsshowcase","nexopia","ngopost.org","niconico","nicovideo.jp","nightlifelink","nightlifelink.com","ning","ning.com","nl.pinterest.com","odnoklassniki.ru","odnoklassniki.ua","okwave.jp","old.reddit.com","oneworldgroup.org","onstartups","onstartups.com","opendiary","opendiary.com","oshiete.goo.ne.jp","out.reddit.com","over-blog.com","overblog.com","paper.li","partyflock.nl","photobucket","photobucket.com","pinboard","pinboard.in","pingsta","pingsta.com","pinterest","pinterest.at","pinterest.ca","pinterest.ch","pinterest.cl","pinterest.co.kr","pinterest.co.uk","pinterest.com","pinterest.com.au","pinterest.com.mx","pinterest.de","pinterest.es","pinterest.fr","pinterest.it","pinterest.jp","pinterest.nz","pinterest.ph","pinterest.pt","pinterest.ru","pinterest.se","pixiv.net","pl.pinterest.com","playahead.se","plurk","plurk.com","plus.google.com","plus.url.google.com","pocket.co","posterous","posterous.com","pro.homeadvisor.com","pulse.yahoo.com","qapacity","qapacity.com","quechup","quechup.com","quora","quora.com","qzone.qq.com","ravelry","ravelry.com","reddit","reddit.com","redux","redux.com","renren","renren.com","researchgate.net","reunion","reunion.com","reverbnation","reverbnation.com","rtl.de","ryze","ryze.com","salespider","salespider.com","scoop.it","screenrant","screenrant.com","scribd","scribd.com","scvngr","scvngr.com","secondlife","secondlife.com","serverfault","serverfault.com","shareit","sharethis","sharethis.com","shvoong.com","sites.google.com","skype","skyrock","skyrock.com","slashdot.org","slideshare.net","smartnews.com","snapchat","snapchat.com","social","sociallife.com.br","socialvibe","socialvibe.com","spaces.live.com","spoke","spoke.com","spruz","spruz.com","ssense.com","stackapps","stackapps.com","stackexchange","stackexchange.com","stackoverflow","stackoverflow.com","stardoll.com","stickam","stickam.com","studivz.net","suomi24.fi","superuser","superuser.com","sweeva","sweeva.com","t.co","t.me","tagged","tagged.com","taggedmail","taggedmail.com","talkbiznow","talkbiznow.com","taringa.net","techmeme","techmeme.com","tencent","tencent.com","tiktok","tiktok.com","tinyurl","tinyurl.com","toolbox","toolbox.com","touch.facebook.com","tr.pinterest.com","travellerspoint","travellerspoint.com","tripadvisor","tripadvisor.com","trombi","trombi.com","trustpilot","tudou","tudou.com","tuenti","tuenti.com","tumblr","tumblr.com","tweetdeck","tweetdeck.com","twitter","twitter.com","twoo.com","typepad","typepad.com","unblog.fr","urbanspoon.com","ushareit.com","ushi.cn","vampirefreaks","vampirefreaks.com","vampirerave","vampirerave.com","vg.no","video.ibm.com","vk.com","vkontakte.ru","wakoopa","wakoopa.com","wattpad","wattpad.com","web.facebook.com","web.skype.com","webshots","webshots.com","wechat","wechat.com","weebly","weebly.com","weibo","weibo.com","wer-weiss-was.de","weread","weread.com","whatsapp","whatsapp.com","wiki.answers.com","wikihow.com","wikitravel.org","woot.com","wordpress","wordpress.com","wordpress.org","xanga","xanga.com","xing","xing.com","yahoo-mbga.jp","yammer","yammer.com","yelp","yelp.co.uk","yelp.com","youroom.in","za.pinterest.com","zalo","zoo.gr","zooppa","zooppa.com"];var Ii=["blog.twitch.tv","crackle","crackle.com","curiositystream","curiositystream.com","d.tube","dailymotion","dailymotion.com","dashboard.twitch.tv","disneyplus","disneyplus.com","fast.wistia.net","help.hulu.com","help.netflix.com","hulu","hulu.com","id.twitch.tv","iq.com","iqiyi","iqiyi.com","jobs.netflix.com","justin.tv","m.twitch.tv","m.youtube.com","music.youtube.com","netflix","netflix.com","player.twitch.tv","player.vimeo.com","ted","ted.com","twitch","twitch.tv","utreon","utreon.com","veoh","veoh.com","viadeo.journaldunet.com","vimeo","vimeo.com","wistia","wistia.com","youku","youku.com","youtube","youtube.com"];var sn=new RegExp("^(.*(([^a-df-z]|^)shop|shopping).*)$"),Ye=new RegExp("^(.*cp.*|ppc|retargeting|paid.*)$"),Aa=new RegExp("^(.*video.*)$"),Ei=class Ei{constructor(){f(this,"userAgent");f(this,"referrer");f(this,"utmSource");f(this,"utmMedium");f(this,"utmCampaign");f(this,"gclid");f(this,"gad_source");f(this,"fbclid");f(this,"wbraid");f(this,"gbraid");f(this,"ttclid");f(this,"twclid");f(this,"tw_adid");f(this,"_kx");f(this,"inAppBrowser");f(this,"isSocialBrowser");f(this,"isUtmMediumDisplay");f(this,"isUtmMediumSocial");f(this,"isUtmMediumReferral");f(this,"isShoppingReferrer");f(this,"isSocialReferrer");f(this,"isSearchReferrer");f(this,"isVideoReferrer");var i,r,n,o,a,c,l,u,m,d,p,I;this.userAgent=navigator.userAgent.toLowerCase(),this.referrer=document.referrer.length?new URL(document.referrer).hostname.replace("www.",""):"";let t=new URLSearchParams(window.location.search);this.utmSource=((i=t.get("utm_source"))==null?void 0:i.toLowerCase())||"",this.utmMedium=((r=t.get("utm_medium"))==null?void 0:r.toLowerCase())||"",this.utmCampaign=((n=t.get("utm_campaign"))==null?void 0:n.toLowerCase())||"",this.gclid=((o=t.get("gclid"))==null?void 0:o.toLowerCase())||"",this.gad_source=((a=t.get("gad_source"))==null?void 0:a.toLowerCase())||"",this.fbclid=((c=t.get("fbclid"))==null?void 0:c.toLowerCase())||"",this.wbraid=((l=t.get("wbraid"))==null?void 0:l.toLowerCase())||"",this.gbraid=((u=t.get("gbraid"))==null?void 0:u.toLowerCase())||"",this.ttclid=((m=t.get("ttclid"))==null?void 0:m.toLowerCase())||"",this._kx=((d=t.get("_kx"))==null?void 0:d.toLowerCase())||"",this.twclid=((p=t.get("twclid"))==null?void 0:p.toLowerCase())||"",this.tw_adid=((I=t.get("tw_adid"))==null?void 0:I.toLowerCase())||"",this.userAgent.includes("instagram")?this.inAppBrowser="Instagram":this.userAgent.includes("fbav")||this.userAgent.includes("fban")?this.inAppBrowser="Facebook":this.userAgent.includes("musical_ly")?this.inAppBrowser="TikTok":this.inAppBrowser="",this.isSocialBrowser=["Facebook","Instagram"].includes(this.inAppBrowser),this.isUtmMediumDisplay=["display","banner","expandable","interstitial","cpm"].includes(this.utmMedium),this.isUtmMediumSocial=["social","social-network","social-media","sm","social network","social media"].includes(this.utmMedium),this.isUtmMediumReferral=["referral","app","link"].includes(this.utmMedium),this.isShoppingReferrer=gi.includes(this.referrer)||gi.includes(this.utmSource),this.isSocialReferrer=hi.includes(this.referrer)||hi.includes(this.utmSource),this.isSearchReferrer=pi.includes(this.referrer)||pi.includes(this.utmSource),this.isVideoReferrer=Ii.includes(this.referrer)||Ii.includes(this.utmSource);}getSocialAudiences(){let t=[];return this.referrer.includes("facebook")||this.inAppBrowser==="Facebook"||this.utmSource==="facebook"?t.push("Facebook"):this.referrer.includes("instagram")||this.inAppBrowser==="Instagram"||this.utmSource==="instagram"?t.push("Instagram"):this.referrer.includes("twitter")||this.utmSource==="twitter"||this.twclid?t.push("Twitter"):this.referrer.includes("tiktok")||this.inAppBrowser==="TikTok"||this.utmSource==="tiktok"||this.ttclid?t.push("TikTok"):this.referrer.includes("google")||this.utmSource==="google"||this.gclid||this.gad_source||this.wbraid||this.gbraid?t.push("Google"):this.referrer.includes("youtube")||this.utmSource==="youtube"?t.push("Youtube"):this.utmSource==="klaviyo"||this._kx?t.push("Klaviyo"):this.utmSource==="attentive"?t.push("Attentive"):this.utmSource==="postscript"?t.push("Postscript"):this.referrer.includes("linktr.ee")?t.push("Linktree"):this.referrer.length&&t.push("Other"),t}getCommonAudiences(){let t=[];return !this.referrer&&!this.utmMedium&&this.noRelevantQueryParams()?t.push("Direct"):this.isShoppingReferrer||Ye.test(this.utmMedium)&&sn.test(this.utmCampaign)?t.push("Paid Shopping"):this.isSearchReferrer&&Ye.test(this.utmMedium)||this.gclid||this.gad_source||this.wbraid||this.gbraid?t.push("Paid Search"):(this.isSocialReferrer||this.isSocialBrowser)&&Ye.test(this.utmMedium)||this.fbclid||this.ttclid||this.twclid||this.tw_adid?t.push("Paid Social"):this.isVideoReferrer&&Ye.test(this.utmMedium)?t.push("Paid Video"):this.isUtmMediumDisplay?t.push("Display"):Ye.test(this.utmMedium)?t.push("Paid Other"):this.isShoppingReferrer||sn.test(this.utmCampaign)?t.push("Organic Shopping"):this.isSocialReferrer||this.isSocialBrowser||this.isUtmMediumSocial?t.push("Organic Social"):this.isVideoReferrer||Aa.test(this.utmMedium)?t.push("Organic Video"):this.isSearchReferrer||this.utmMedium==="organic"?t.push("Organic Search"):this.isUtmMediumReferral?t.push("Referral"):this.utmMedium==="affiliate"?t.push("Affiliate"):this.utmSource==="sms"||this.utmMedium==="sms"||this.utmMedium==="text"?t.push("SMS"):(["email","e_mail","e-mail","e mail"].includes(this.utmMedium)||["email","e_mail","e-mail","e mail"].includes(this.utmSource)||this._kx)&&t.push("Email"),t}getTrafficSources(){let t=this.getSocialAudiences(),i=this.getCommonAudiences();return [...t,...i]}noRelevantQueryParams(){let t=new Set(["variant","igTg","page","shpxid","shop","view","siteid","token","cart","order","from","search","pb","preview_theme_id","igId","cb"]),i=new URLSearchParams(window.location.search);for(let[r]of i)if(!t.has(r))return  false;return  true}};s(Ei,"TrafficSources");var _t=Ei;var he=new Map;function _i(e){return he.has(e)||he.set(e,new Map),he.get(e)}s(_i,"getCache");function b(e,t){return new Proxy(e,{apply(i,r,n){let o=_i(e),a=t?n.map((u,m)=>t[m](u)):n,c=Re(o,a);if(c.value!==Re.CACHE_MISS)return c.value;let l=i.apply(r,n);return c.node.set(a[a.length-1],l),l},get(i,r,n){return r==="cache"?_i(e):Reflect.get(i,r,n)}})}s(b,"igMemoize");function xt(e,t){if(he.has(e)){let i=he.get(e);va(i,t||[]);}}s(xt,"removeMemo");function M(e,t,i){let r=_i(e),n=Re(r,t);n.node.set(n.key,i);}s(M,"updateMemo");function ie(e){he.has(e)&&he.delete(e);}s(ie,"clearMemo");function va(e,t){let i=e;t.length===0&&(t=[void 0]);for(let r=0;r<t.length;r++){let n=t[r];if(i.has(n)){if(r===t.length-1){i.delete(n);return}i=i.get(n);}}}s(va,"removeFromCache");function Re(e,t){let i=e;t.length===0&&(t=[void 0]);for(let r=0;r<t.length;r++){let n=t[r];if(i.has(n)){if(r===t.length-1)return {node:i,value:i.get(n),key:n};i=i.get(n);}else {if(r===t.length-1)return i.set(n,new Map),{node:i,value:Re.CACHE_MISS,key:n};i.set(n,new Map),i=i.get(n);}}return {node:i,value:Re.CACHE_MISS}}s(Re,"searchCache");var Ta=Symbol("CACHE_MISS");Re.CACHE_MISS=Ta;var cn=s(e=>js_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get(e),"_getCookie");function At(e){return js_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get(e)}s(At,"_getCookieMemoized");var ln=b(At);var xi=s(e=>vt(Sa(e.origin,e.pathname).toLowerCase()),"getFormattedCurrUrlString"),Pa=s(e=>(e=e||"",decodeURIComponent(e)!==e),"isEncoded"),vt=s(e=>{for(;Pa(e);)e=decodeURIComponent(e);return e},"getDecodedUrl"),Na=s((e,t,i)=>{var o,a;let r=i!=null?i:"destinationUrl",n=e[r]&&!((o=e[r])!=null&&o.startsWith("/"))?"/":"";if((a=e[r])!=null&&a.includes("."))return ue(`${e[r]}`);{let c=t!=null?t:window.location.origin;return ue(`${c}${n}${e[r]}`)}},"ensureFullUrl");var un=s((e,t)=>{let i=xi(t);if(e.filter==="contains")return i.includes(e.originUrl);if(e.filter==="endsWith")return i.endsWith(e.originUrl);if(e.filter==="matchesRegex")try{return new RegExp(e.originUrl).test(i)}catch{return  false}else {let r=ue(vt(Na(e,void 0,"originUrl").toLowerCase()));if(t.hostname==="localhost"){let n=new URL(window.location.href),o=new URL(r);return o.host=n.host,i.trim()===o.href.trim()}else return i.trim()===r.trim()}},"isMatchingPageRedirect");var Ra=s(e=>{let t=e.startsWith("/")?e.substring(1):e;return t=t.endsWith("/")?t.substring(0,t.length-1):t,t},"formatPathname");var fn=s(e=>{let t=e.startsWith("https://")?e:e.replace("http://","https://");return e.startsWith("https://")||(t="https://"+t),t},"ensureHttps"),Sa=s((e,t)=>{let i=t==="/"?"":"/";return ue(e)+i+Ra(t)},"formatDomainAndPathname");var tn=s(e=>{let t=new URL(window.location.href),i=t.searchParams;i.has(e)&&(i.delete(e),window.history.replaceState({},"",t.toString()));},"safeRemoveQueryParam");var rn=s(e=>{let t=e.split(","),i=t.length-3;return t.length>3?[...t.slice(0,3),`or ${i} other${i>1?"s":""}`].join(", "):t.join(", ")},"expectedString");function Tt(e,t){if(e==null||t==null)throw new Error("Input parameters idHex and entityId must not be null.");let i=e+t,r=0,n=3432918353,o=461845907;for(let a=0;a<i.length;a++){let c=i.charCodeAt(a);c=c*n&4294967295,c=c<<15|c>>>17,c=c*o&4294967295,r^=c,r=r<<13|r>>>19,r=r*5+3864292196&4294967295;}return r^=i.length,r^=r>>>16,r=r*2246822507&4294967295,r^=r>>>13,r=r*3266489909&4294967295,r^=r>>>16,Math.abs(r)%100}s(Tt,"getIdIndex");function fi(e){let{actual:t,matchBy:i,value:r}=e;switch(i){case "equals":return t===r;case "startsWith":return t.startsWith(r);case "endsWith":return t.endsWith(r);case "doesNotEqual":return t!==r;case "doesNotContain":return !t.includes(r);case "doesNotStartWith":return !t.startsWith(r);case "doesNotEndWith":return !t.endsWith(r);case "isNull":return !t;case "isNotNull":return !!t;case "contains":return t.includes(r);case "regex":return new RegExp(r).test(t);default:return  false}}s(fi,"stringMatchEvaluation");function Se(e){let{actual:t,node:i,label:r}=e;return {matched:fi({value:i.value,actual:t,matchBy:i.filter}),by:y(Pt(i,r),t)}}s(Se,"filterEvaluation");function Pt(e,t=e.type){switch(e.filter){case "equals":return `${t} is ${e.value}`;case "startsWith":return `${t} starts with ${e.value}`;case "endsWith":return `${t} ends with ${e.value}`;case "doesNotEqual":return `${t} is not ${e.value}`;case "doesNotContain":return `${t} does not contain ${e.value}`;case "doesNotStartWith":return `${t} does not start with ${e.value}`;case "doesNotEndWith":return `${t} does not end with ${e.value}`;case "isNull":return `${t} is not defined`;case "isNotNull":return `${t} is defined`;case "contains":return `${t} contains ${e.value}`;case "regex":return `${t} matches regex ${e.value}`;default:return `${t} ${e.filter} ${e.value}`}}s(Pt,"getExpressionCondition");function y(e,t){return `${e} &rarr; ${Da(t)}`}s(y,"getExpressionMessage");function Da(e){return e===""||e===null||e===void 0?"&lt;undefined&gt;":e==null?void 0:e.toString()}s(Da,"formatActual");var Zu=s(()=>navigator.userAgent.indexOf("Googlebot")!==-1||navigator.userAgent.indexOf("AdsBot-Google")!==-1||navigator.userAgent.indexOf("Storebot-Google")!==-1,"isGoogleBot");function Et(e,t,i,r,n){let o=[],a=[];for(let l of t)if(l.operator){let u=o.pop(),m=o.pop();if(l.operator==="and")o.push(!!m&&!!u);else if(l.operator==="or")o.push(!!m||!!u);else throw new Error("Invalid operator")}else if(l.query){let u={matched:false,by:"query type not available"};switch(l.query.type){case "device":u=Oa(l.query);break;case "visitor":u=wa(l.query,i);break;case "urlPath":{n===void 0?u={matched:false,by:y(Pt(l.query,"url"),"unknown")}:u=ba(l.query,n);break}case "url":case "utm":u=Ma(l.query,e);break;case "jsExpression":u=ya(l.query);break;case "trafficSource":u=La(l.query);break;case "country":u=Va(l.query,r);break;case "referrer":u=ka(l.query);break;case "cookie":u=Ga(l.query);break;case "landingPage":u=Ua(l.query);break}o.push(u.matched),a.push(`<br />&nbsp;&nbsp;${u.matched?"&#9989;":"&#10060;"} ${u.by}`);}return {matched:o[0],by:a.join("")}}s(Et,"determineMatchByExpression");function Oa(e){var i;let t=(i=qr())!=null?i:"unknown";return {matched:e.value===t,by:y(`device is ${e.value}`,t)}}s(Oa,"determineNodeDeviceConditionMatch");function wa(e,t){let i="unknown",r=t.isFirstVisit();return r===true?i="new":r===false&&(i="returning"),e.value==="any"?{matched:true,by:y("any visitor",i)}:{matched:e.value===i,by:y(`visitor is ${e.value}`,i)}}s(wa,"determineNodeVisitorConditionMatch");function ba(e,t){let i=t.pathname.replace(/^\/+|\/+$/g,""),r;try{let n=decodeURIComponent(String(e.value)).toLowerCase();r=new URL(n).pathname.replace(/^\/+|\/+$/g,"");}catch{r=e.value.replace(/^\/+|\/+$/g,"");}return Se({node:{...e,value:r},actual:i,label:"url"})}s(ba,"determineNodeUrlPathMatch");function Ma(e,t){var o,a;let i=(o=t.get(e.key))!=null?o:"";try{i=decodeURIComponent(i).toLowerCase();}catch{i=i.toLowerCase();}let r=((a=new URLSearchParams("param="+e.value).get("param"))==null?void 0:a.toLowerCase())||decodeURIComponent(String(e.value)).toLowerCase();return Se({node:{...e,value:r},label:`query param ${e.key}`,actual:i})}s(Ma,"determineNodeTrafficConfigQueryParamMatch");function ya(node){let expression;try{expression=!!eval(node.value);}catch{console.error(`[Intelligems] Could not evaluate the targeting expression: ${node.value}`);}return node.filter==="doesNotEqual"?{matched:expression===false,by:y(`${node.value} is false`,expression)}:{matched:expression===true,by:y(`${node.value} is true`,expression)}}s(ya,"determineNodeTrafficConfigJsExpression");function La(e){var a;let i=new _t().getTrafficSources(),r=(a=i==null?void 0:i.join(","))!=null?a:"",n=e.value,o;if(n==="any")o={matched:true,by:y("any traffic source",r)};else if(n==="All Social")o={matched:i.includes("Organic Social")||i.includes("Paid Social"),by:y("social traffic source",r)};else {if(e.filter==="doesNotEqual")return {matched:!i.includes(n),by:y(`traffic source does not include '${n}'`,r)};o={matched:i.includes(n),by:y(`traffic source includes '${n}'`,r)};}return o}s(La,"determineNodeTrafficSourceMatch");function Va(e,t){let i=(t==null?void 0:t.country)||jr(),r=e.value.toUpperCase();if(!i)return {matched:false,by:y(`country includes ${r}`,"unknown")};let n=i.toUpperCase();return e.filter==="equals"?{matched:n.includes(r),by:y(`country includes '${r}'`,n)}:{matched:!n.includes(r),by:y(`country does not include '${r}'`,n)}}s(Va,"determineNodeCountryMatch");function ka(e){let t=document.referrer;return Se({node:{...e,value:e.value.toLowerCase()},actual:t})}s(ka,"determineNodeReferrerMatch");function Ga(e){let t=cn(e.key)||"";return Se({node:e,label:`cookie ${e.key}`,actual:t})}s(Ga,"determineNodeCookieMatch");function Ua(e){if(document.referrer.includes(window.location.host))return {matched:false,by:y(Pt(e),"not on landing page")};let t=new URL(window.location.href),i=xi(t),r=fn(ue(vt(e.value.toLowerCase())));return Se({node:{...e,value:e.filter==="regex"||e.filter==="contains"||e.filter==="endsWith"?e.value:r},actual:i})}s(Ua,"determineNodeLandingPageMatch");var re={EXCLUDED:"_EXCLUDED",UNASSIGNED:"_UNASSIGNED",PERMA_EXCLUDED:"_PERMA_EXCLUDED"};function Ba(e){if(!e||!e.excludeCurrency.exclude||!e.excludeCurrency.currency)return {expected:"",issue:"",found:false,pending:false};let t=window.__igCurrency||Kr()||false;return t?e.excludeCurrency.currency.split(",").includes(t)?{expected:"",issue:"",found:false,pending:false}:{expected:e.excludeCurrency.currency,issue:"currency",found:t,pending:false}:{expected:"",issue:"",found:false,pending:true}}s(Ba,"isExcludedByMarket");function Fa(e){let t=[];for(let i of e)if(i.operator){let r=t.pop(),n=t.pop();t.push(`${n} (${i.operator}) ${r}`);}else if(i.query){let r="";i.query.type==="device"?r=`device is ${i.query.value}`:i.query.type==="visitor"?r=`visitor is ${i.query.value}`:i.query.type==="utm"?r=`utm ${i.query.filter} ${i.query.key} ${i.query.value}`:i.query.type==="url"?r=`url ${i.query.filter} ${i.query.key} ${i.query.value}`:i.query.type==="jsExpression"?r=`js expression ${i.query.filter} ${i.query.value}`:i.query.type==="trafficSource"?r=`traffic source ${i.query.filter} ${i.query.value}`:i.query.type==="country"?r=`country ${i.query.filter} ${i.query.value}`:i.query.type==="referrer"?r=`referrer ${i.query.filter} ${i.query.value}`:i.query.type==="cookie"?r=`cookie ${i.query.filter} ${i.query.key} ${i.query.value}`:i.query.type==="landingPage"&&(r=`landing page ${i.query.filter} ${i.query.value}`),t.push(r);}return "("+t.join(", ")+")"}s(Fa,"displayAudienceExpression");function Ya(e){let t=e.expression;if(t)return Fa(t)}s(Ya,"displayAudienceFilters");function $a(e,t,i,r){let n=t.expression;return n?Et(e,n,i,r):{matched:false,by:"no expression found"}}s($a,"determineAudienceConditionMatch");var Ha=["track"],Ka=["js_api"],Ai=class Ai{constructor(t,i,r){f(this,"igEvents");f(this,"useBeacon");f(this,"logEvents");this.igEvents=t?this.validateAndReturn(t):[],this.useBeacon=navigator.sendBeacon&&i||false,this.logEvents=r;}async sendPendingEvents(t){await Promise.all(this.igEvents.map(async i=>this.push(i,t)));}validateAndReturn(t){if(!Array.isArray(t))return console.warn("'igEvents' is not implemented as an array"),[];let i=[];for(let r of t)if(r.source&&!Ha.includes(r.source)&&console.warn(`${r.source} is not valid event source.`),r.type&&!Ka.includes(r.type))console.warn(`${r.type} is not valid event type.`);else if(!r.event)console.warn(`need 'event' parameter for event ${r}`);else try{i.push({type:r.type||"track",event:r.event,properties:r.properties,source:r.source||"js_api"});}catch{console.warn(`${r.properties} not valid JSON`);}return i}static sharedCreateTrackPayloadFromIgEvent(t,i,r,n){return i({variants:r,cartOrCheckoutToken:null,isGoogleBot:false,eventType:"custom_event",customEvent:t,id:n})}async push(t,i){t.type||(t.type="track"),this.logEvents&&console.log(`Ig Custom Event: ${JSON.stringify(t,null,2)}`),await i(t,this.useBeacon);}};s(Ai,"SharedIgEvents");var Nt=Ai;var ja=[{name:"Windows Phone",value:"Windows Phone",version:"OS"},{name:"Windows",value:"Win",version:"NT"},{name:"iPhone",value:"iPhone",version:"OS"},{name:"iPad",value:"iPad",version:"OS"},{name:"Kindle",value:"Silk",version:"Silk"},{name:"Android",value:"Android",version:"Android"},{name:"PlayBook",value:"PlayBook",version:"OS"},{name:"BlackBerry",value:"BlackBerry",version:"/"},{name:"Macintosh",value:"Mac",version:"OS X"},{name:"Linux",value:"Linux",version:"rv"},{name:"Palm",value:"Palm",version:"PalmOS"}],qa=[{name:"Chrome",value:"Chrome",version:"Chrome"},{name:"Firefox",value:"Firefox",version:"Firefox"},{name:"Safari",value:"Safari",version:"Version"},{name:"Internet Explorer",value:"MSIE",version:"MSIE"},{name:"Opera",value:"Opera",version:"Opera"},{name:"BlackBerry",value:"CLDC",version:"CLDC"},{name:"Mozilla",value:"Mozilla",version:"Mozilla"}];function Wa(){let t=(typeof window=="undefined"?[]:[window.navigator.platform,window.navigator.userAgent,window.navigator.appVersion,window.navigator.vendor,window.opera]).join(" "),i=mn(t,ja),r=mn(t,qa),n=navigator.userAgent;return {os:i,browser:r,agent:t,useragent:n}}s(Wa,"init");function mn(e,t){let i=0,r=0,o,a,c,l,u;for(i=0;i<t.length;i+=1)if(o=new RegExp(t[i].value,"i"),c=o.test(e),c){if(a=new RegExp(t[i].version+"[- /:;]([\\d._]+)","i"),l=e.match(a),u="",l&&l[1]&&(l=l[1]),l)for(l=l.split(/[._]+/),r=0;r<l.length;r+=1)r===0?u+=l[r]+".":u+=l[r];else u="0";return {name:t[i].name,version:parseFloat(u)}}return {name:"unknown",version:0}}s(mn,"matchItem");var dn=b(Wa);var pn=s((e,t,i,r)=>{if(i.getPreviewIfExists()==="true")return [];let n=new Set;for(let c of i.exclusionGroups){let l=t.determineNonEligibleExperiences(c,r);for(let u of l)u&&n.add(u);}let o=i.getPreviewedEntityState();if(o){let c=e.find(m=>m.id===o),l=false;if(c&&(l=i.shouldExcludeExperience(c),!l)){let m=e.filter(d=>d!==c&&d.category==="personalization"&&!d.isPreview&&!i.shouldExcludeExperience(d));return [c,...m]}return e.filter(m=>i.shouldExcludeExperience(m)||n.has(m.id)?false:m.isPreview?!l&&m.id===o:true)}let a=e.filter(c=>!(n.has(c.id)||i.shouldExcludeExperience(c)));return a.length===0&&console.log("No experiences found \u2014 if this is unexpected, check exclusion rules"),a},"getExperiencesShared");var za=js_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"].remove */ .Z.remove;js_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"].remove */ .Z.remove=function(e,t){V.shouldLogExtra()&&V.addMessage("Removing cookie: "+e),za(e,t);};var L=class L{constructor(){L._idSet=false,L._isIdValid=false;}static shouldLogExtra(){var t;return ["loohm.myshopify.com","pyfi-store.myshopify.com","freshexoticfruit.myshopify.com","kennectpet.myshopify.com","cajun-pizza.myshopify.com"].includes((t=window==null?void 0:window.Shopify)==null?void 0:t.shop)}static confirm(){this.shouldLogExtra()&&this.addMessage(`Confirming ig-id: cookie ${js_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get(x.IG_ID_KEY)} ls: ${localStorage.getItem(x.IG_ID_KEY)}`);}static addMessage(t){window.__igMessages||(window.__igMessages=[]),window.__igMessages.push(t);}static getRawIds(t){if(this.shouldLogExtra()){let i=js_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get(x.IG_ID_KEY);this.addMessage(`${t}: cookie ${i}, ls: ${localStorage.getItem(x.IG_ID_KEY)}`),this.addMessage(`${t}: allCookies ${document.cookie}`);}}static _isFirstVisit(t){if(L.__isFirstVisit!==void 0)return L.__isFirstVisit;let i=js_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("ig-fv"),r=localStorage.getItem("ig-fv"),n;return i&&r?n=Math.min(Number(i),Number(r)).toString():n=i||r||new Date().getTime().toString(),localStorage.setItem("ig-fv",n),t.setFirstVisit(n),this.__isFirstVisit=new Date().getTime()-S(n)<1e3*this.SECONDS_FOR_FIRST_VISIT_SESSION,this.__isFirstVisit}static validateId(t){if(!t)return  false;let i=t.split(x.ID_SPACER),r=/^[a-fA-F0-9]+$/g;return i.length===2&&(i[0]===x.ID_PREFIX||r.test(i[1]))}static generateId(){return x.ID_PREFIX+x.ID_SPACER+[...Array(x.ID_SIZE)].map(()=>Math.floor(Math.random()*16).toString(16)).join("")}static deterministicNumberFromId(t){let i=2166136261;for(let r=0;r<t.length;r++)i^=t.charCodeAt(r),i*=16777619,i>>>=0;return i}static get id(){throw Error("This method must be implemented in the child class")}static getIdForUnitTest(){return L.generateId()}static get idSet(){return L._idSet}static set idSet(t){L._idSet=t;}static _getId(t,i){let r=new URL(window.location.href),n=r.searchParams.get("igId");n&&i.deleteIgId&&(r.searchParams.delete("igId"),history.replaceState({},"",r.href));let o=s(a=>{try{i.setId(a),this.idSet=!0,this._isIdValid=!0;}catch{i.onError&&i.onError();}finally{i.onFinally&&i.onFinally(a);}},"set");return !t||!this.validateId(t)||n&&n!==t?(this.addMessage(`_getId, ${t}, ${t&&this.validateId(t),n&&n!==t}`),n&&n!==t?t=n:t=this.generateId(),this.addMessage(`Setting IgId: ${t}`),o(t),this.confirm()):this.isCookieSet===null&&(this.isCookieSet=i.isCookieSet(),this.isCookieSet||(this.addMessage(`_getId, cookie not set: ${t}`),o(t),this.confirm()),this.idSet=true,this._isIdValid=true),t}};s(L,"SharedIgId"),f(L,"_id"),f(L,"_idSet"),f(L,"_isIdValid"),f(L,"isCookieSet",null),f(L,"__isFirstVisit"),f(L,"SECONDS_FOR_FIRST_VISIT_SESSION",30*60);var V=L;function Nf(e,t){var i,r;try{let n=new Intl.NumberFormat(e,{...t.options}).formatToParts(12345678123e-3),o=Object.fromEntries(n.map(({type:c,value:l})=>[c,l])),a=`\\d{1,3}(?:[${((i=o==null?void 0:o.group)==null?void 0:i.replace(/\s/,"\\s"))||".,"}]?\\d{0,3})*(?:[${((r=o==null?void 0:o.decimal)==null?void 0:r.replace(/\s/,"\\s"))||".,"}]?\\d{0,3})?`;return new RegExp(a,"mu")}catch(n){return console.warn(n),new RegExp("\\d{1,3}(?:[.,]?\\d{0,3})*(?:[.,]?\\d{0,3})?","mu")}}s(Nf,"buildPriceRegex");var ne={};k(ne,{TrackStatus:()=>Rt,_buildTrackBody:()=>Ja,_track:()=>Xa,sharedSendEvent:()=>Qa});var Za=s(e=>typeof e=="object"&&e!==null&&e===e.window,"isWindow"),vi=(()=>{try{return Za(self)?self:globalThis}catch{return globalThis}})();var He=class He{};s(He,"TrackStatus"),f(He,"RAN_TRACK_ONCE",false),f(He,"PAGE_VIEW_UUID",jt());var Rt=He;function Ja(e){var d,p,I,A;let{origin:t,hash:i,pathname:r,search:n,host:o}=vi.location,a=dn(),c=-1;try{c=vi.performance.now();}catch{}let l=r;try{l=new URL(r).pathname;}catch{}let u=(d=e.documentReferrer)!=null?d:e.document.referrer,m;try{let P=new URL(u);m={origin:P.origin,host:P.host,pathname:P.pathname,search:P.search,hash:P.hash,queryParams:Object.fromEntries(new URLSearchParams(P.search))};}catch{}return {Detail:{eventType:(p=e.eventType)!=null?p:"page_view",userId:e.id,variants:e.newVariation?[]:e.variants,newVariation:e.newVariation,version:e.version,buildId:e.buildId,initBuildId:e.initBuildId,preview:(I=e.preview)!=null?I:false,eventTimestamp:new Date().toISOString(),performanceNow:c,referrer:u,parsedReferrer:m,storeName:e.storeName,cartToken:e.cartOrCheckoutToken,messages:window.__igMessages||[],location:{origin:t,host:o,pathname:(A=e.pathnameOverride)!=null?A:l,search:n,hash:i,queryParams:Object.fromEntries(new URLSearchParams(n))},geoLocation:e.geoLocation,device:a,themeId:e.themeId,pageView:e.pageView,inAppInterval:e.inAppInterval,firstVisitTs:e.firstVisitTs&&parseInt(e.firstVisitTs)||void 0,isFirstVisit:e.isFirstVisit,isGoogleBot:e.isGoogleBot,currency:e.currency,country:e.country,viewedProductPrices:e.viewedProductPrices,pageViewId:e.isHeadless?jt():Rt.PAGE_VIEW_UUID,redirect:e.redirect&&Object.keys(e.redirect).length?{redirectedFrom:e.redirect.redirectedFrom,redirectedTo:e.redirect.redirectedTo,isEmpty:e.redirect.isEmpty,variationId:e.redirect.variationId}:void 0,sentDuring:e.sentDuring,customEvent:e.customEvent,orgId:e.orgId,isEsm:e.isEsm}}}s(Ja,"_buildTrackBody");async function Qa(e,t=true){let i=JSON.stringify(e);if(t)navigator.sendBeacon(x.INTELLIGEMS_TRACK_ENDPOINT,i)||console.info("error sending igEvent, sendBeacon returned false");else try{await fetch(x.INTELLIGEMS_TRACK_ENDPOINT,{method:"POST",body:i,mode:"no-cors",keepalive:!0});}catch{console.info("error sending track event, fetch failed");}}s(Qa,"sharedSendEvent");async function Xa(e){let t=JSON.stringify(e.body);return navigator.sendBeacon&&e.useBeacon?Ki(x.INTELLIGEMS_TRACK_ENDPOINT,e.body)||console.debug("beacon not sent"):await fetch(x.INTELLIGEMS_TRACK_ENDPOINT,{method:"POST",body:t,mode:"no-cors",keepalive:true}),t}s(Xa,"_track");var Ke={};k(Ke,{postExperienceImpressions:()=>Ti,sendGaEvent:()=>gn,trackGa4:()=>tc,trackGa4ClientSide:()=>hn,trackGa4ServerSide:()=>ec,trackGa4UsingDataLayer:()=>In,trackGa4WithRetry:()=>En});function gn(e){fetch(`${j("API_URL",void 0)}/v2/integrations/google/ga/track`,{method:"POST",body:JSON.stringify(e),headers:{"Content-Type":"application/json"}});}s(gn,"sendGaEvent");function Ti(e,t){for(let i of t.gaVariationNames){let r={exp_variant_string:i};t.measurementId&&(r.send_to=t.measurementId),e(r);}}s(Ti,"postExperienceImpressions");function hn(e){try{Ti(t=>{window.gtag("event","experience_impression",t);},e);}catch{console.warn("Google Analytics Gtag Failed");}}s(hn,"trackGa4ClientSide");function ec(e){try{let t=e.variationIds.map(n=>g(n).slice(0,7)),r=Yi(t,4).slice(0,4).reduce((n,o,a)=>(a===0?n.ig_test_groups={value:o.join(",")}:n[`ig_test_groups_${a+1}`]={value:o.join(",")},n),{});t.length&&gn({clientId:e.clientId,measurementId:e.measurementId,orgId:e.orgId,userProperties:r});}catch{console.warn("Google Analytics Gtag Failed");}}s(ec,"trackGa4ServerSide");function In(e){try{Ti(t=>{window.dataLayer=window.dataLayer||[],window.dataLayer.push({event:"experience_impression",...t});},e);}catch{console.warn("Google Analytics Gtag Failed");}}s(In,"trackGa4UsingDataLayer");async function En(e,t,i){let n=0,o=false;for(n===0&&(window.dataLayer=window.dataLayer||[],window.dataLayer.push({event:"dl_intelligems_script_loaded"}));!o&&n<=80;){if(n===0){let a=js_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("_ga");a&&(i.logWithFunction("Info","trackGa4","Google Analytics Client ID Found in Cookies"),a.substring(6));}else typeof window.gtag=="function"&&i.logWithFunction("Info","trackGa4","Gtag Found");typeof window.gtag=="function"&&!o&&(hn({gaVariationNames:t,logger:i,measurementId:e}),o=true),n++,await $i(250);}}s(En,"trackGa4WithRetry");function tc(e,t,i){var r;(r=window.igSettings)!=null&&r.useDataLayer?In({measurementId:e,gaVariationNames:t,logger:i}):En(e,t,i);}s(tc,"trackGa4");var xn=s(async(e,t=5)=>{if(t>0){let n=memory_cache__WEBPACK_IMPORTED_MODULE_2__.get(e);if(n)return _.debug(`Returning cached response for ${e}`),n}_.debug(`Fetching ${e}`);let r=await(await fetch(e)).json();return t>0&&memory_cache__WEBPACK_IMPORTED_MODULE_2__.put(e,r,1e3*60*t),r},"cachedFetch");function ic(e){var r;let i=`; ${document.cookie}`.split(`; ${e}=`);if(i.length===2)return (r=i.pop())==null?void 0:r.split(";").shift()}s(ic,"getCookie");var St=s(async e=>{var n,o;let t=new URLSearchParams("");try{typeof window!="undefined"&&typeof document!="undefined"&&(ic(dt.GEO_LOCATION_COOKIE)||t.set("geo","true"));}catch{}let i="1.2.x";let r=`https://cdn.intelligems.io/configs/v/${Hi(i)}/${g(e.orgId)}.json`;return (typeof window!="undefined"&&((o=(n=window==null?void 0:window.location)==null?void 0:n.href)!=null&&o.includes("localhost"))||typeof process!="undefined"&&"production"==="development")&&t.set("v",Date.now().toString()),xn(r+(t.size?`?${t.toString()}`:""),e.cacheIntervalMinutes)},"internalGetIntelligemsConfig");var se={};k(se,{determineNonEligibleExperiences:()=>oc,initExclusionGroupEntity:()=>sc});var je={};k(je,{_determineNonEligibleExperiences:()=>nc});var An=s((e,t,i)=>{let r=t.filter(a=>i?!(a.pausedAtTs||a!=null&&a.endedAtTs):!(a.isPreview||a.pausedAtTs||a!=null&&a.endedAtTs)).map(a=>a.id),n=e.filter(a=>a.experienceId&&r.includes(a.experienceId)),o=n.map(a=>a.percentage).reduce((a,c)=>a+c,0);return Lr(n.map(a=>({...a,percentage:a.percentage/o*100})))},"reweighActiveEntities");function rc(e,t){let i=0,r=t.find(n=>(i+=n.percentage,e._igIdIx<i));return r||null}s(rc,"getAssignedEntity");function vn(e){let t=An(e.exclusionGroupEntities,e.experiences),i=rc(e,t);return e.exclusionGroupEntities.filter(r=>r.experienceId!==(i==null?void 0:i.experienceId)).map(r=>r.experienceId)}s(vn,"getStandardExcludedEntityIds");function nc(e,t){let i=[];for(let r of e.exclusionGroupEntities){let n=r.experienceId&&t.readStorage(g(r.experienceId));n&&n!=="_UNASSIGNED"&&r.experienceId&&i.push(r.experienceId);}return i.length?e.experiences.find(n=>i.includes(n.id))?e.exclusionGroupEntities.filter(o=>o.experienceId&&!i.includes(o.experienceId)).map(o=>o.experienceId):e.reassignOnEnd?vn(e):e.exclusionGroupEntities.map(n=>n.experienceId):vn(e)}s(nc,"_determineNonEligibleExperiences");function sc(e,t,i){let n=e.split(x.ID_SPACER)[1],o=Tt(n,t.id);return {...t,experiences:i,_igIdIx:o}}s(sc,"initExclusionGroupEntity");function oc(e,t){return je._determineNonEligibleExperiences(e,{readStorage:s(i=>t.getVars()[i]||null,"readStorage")})}s(oc,"determineNonEligibleExperiences");var E={};k(E,{determineGlobalAudienceConfigExclusions:()=>Dn,determineGlobalAudienceExclusions:()=>dc,determinePageTargetingIncluded:()=>fc,getVariation:()=>mc,initExperienceEntity:()=>Sn,initFromConfig:()=>uc,shouldExcludeExperience:()=>pc});var Pi=class Pi{constructor(){f(this,"isSupported");}checkIsSupported(){try{let t="__ig_storage_test__";return this.setItem(t,t),this.removeItem(t),!0}catch{return  false}}};s(Pi,"SomeStorage");var oe=Pi;var De,qe,Ni=class Ni extends oe{constructor(i,r=365){super();Yt(this,De,"."+window.location.hostname);Yt(this,qe,365);i&&$t(this,De,"."+i),r&&$t(this,qe,r),this.isSupported=true;}setItem(i,r){let n=js_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"].set */ .Z.set(i,r,{expires:tt(this,qe),domain:tt(this,De)});return M(At,[i],r),n}getItem(i){var r;return (r=ln(i))!=null?r:null}removeItem(i){V.shouldLogExtra()&&V.addMessage(`cookieStorage removeItem ${i}`),js_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"].remove */ .Z.remove(i,{domain:tt(this,De)}),xt(At,[i]);}};De=new WeakMap,qe=new WeakMap,s(Ni,"CookieStorage");var Dt=Ni;var Ri=class Ri extends oe{constructor(){super(),this.isSupported=this.checkIsSupported();}setItem(t,i){if(this.isSupported)return localStorage.setItem(t,i)}getItem(t){return this.isSupported?localStorage.getItem(t):null}removeItem(t){if(this.isSupported)return localStorage.removeItem(t)}};s(Ri,"LocalStorage");var We=Ri;var Si=class Si extends oe{constructor(){super(),this.isSupported=this.checkIsSupported();}setItem(t,i){if(this.isSupported)return sessionStorage.setItem(t,i)}getItem(t){return this.isSupported?sessionStorage.getItem(t):null}removeItem(t){if(this.isSupported)return sessionStorage.removeItem(t)}};s(Si,"SessionStorage");var Ot=Si;var Z=class Z{static setCookiesStorage(t,i){if(!this.cookieStorage)try{this.cookieStorage=new Dt(t,i);}catch(r){console.warn(r);}}static _getItem(t,i){var a,c,l;let r=this.storage.getItem(t)||null,n=((a=this.cookieStorage)==null?void 0:a.getItem(t))||null,o=null;return n&&r?o=JSON.stringify(deepmerge__WEBPACK_IMPORTED_MODULE_3__(JSON.parse(r),JSON.parse(n))):n?o=n:r&&(o=r),t===x.IG_ID_KEY&&V.shouldLogExtra()&&V.addMessage(`_getItem: memoLocal ${r} ${localStorage.getItem(t)} memoCookie ${n} rawCookie: ${js_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get(t)}`),o?(this.storage.setItem(t,o),(c=this.cookieStorage)==null||c.setItem(t,o)):(t===x.IG_ID_KEY&&V.shouldLogExtra()&&V.addMessage(`_getItem Removal: ${t}`),this.storage.removeItem(t),(l=this.cookieStorage)==null||l.removeItem(t)),i?o?JSON.parse(o):void 0:o||void 0}static _getLocalStorageItem(t,i){let r=this.storage.getItem(t);return r?i?JSON.parse(r):r:null}static setLocalStorageItem(t,i){this.storage.setItem(t,i),M(this._getLocalStorageItem,[t],i);}static removeItem(t){var i;this.debug&&console.log(`[${this.storageName}] REMOVE "${t}"`),V.shouldLogExtra()&&V.addMessage(`removeItem ${t}`),this.storage.removeItem(t),(i=this.cookieStorage)==null||i.removeItem(t),xt(this._getItem,[t]);}static setItem(t,i){var r;this.storage.setItem(t,i),(r=this.cookieStorage)==null||r.setItem(t,i),M(this._getItem,[t],i);}static get isSupported(){return this.storage.isSupported}};s(Z,"IgStorage"),f(Z,"storage",new We),f(Z,"cookieStorage"),f(Z,"debug",false),f(Z,"storageName","IgLocalStorage"),f(Z,"getItem",b(Z._getItem));var ce=Z,ae=class ae extends ce{};s(ae,"IgLocalStorage"),f(ae,"storage",new We),f(ae,"storageName","IgLocalStorage"),f(ae,"getItem",b(it(ae,ae,"_getItem")));var $=class $ extends ce{};s($,"IgSessionStorage"),f($,"storage",new Ot),f($,"storageName","IgSessionStorage"),f($,"getItem",b(it($,$,"_getItem"))),f($,"getItemLatest",it($,$,"_getItem"));var Di=$;var D=class D extends ce{static _setObject(t){this.setItem(D.storageKey,JSON.stringify(t));}static _getAll(){return JSON.parse(this._getItem(this.storageKey,false)||"{}")}static _get(t){let i=this.getAll();return t in i?i[t]:null}static clear(){this.debug&&console.log(`[${this.storageName}] clear`),this.removeItem(this.storageKey),ie(this._getAll),ie(this._get);}static update(t,i){let r=(this||D).getAll();t in r&&r[t]===i||(r={...r,[t]:i},(this||D)._setObject(r),M((this||D)._getAll,[],r),M((this||D)._get,[t],r[t]));}static pop(t){let i=(this||D).getAll(),r=null;return t in i?(r=i[t],delete i[t],this._setObject(i),M((this||D)._getAll,[],i),M((this||D)._get,[t],null),r):null}};s(D,"IgEvalsStorage"),f(D,"storageKey","ig-evals"),f(D,"debug",false),f(D,"storageName","IgEvalsStorage"),f(D,"getAll",b(D._getAll)),f(D,"get",b(D._get));var J=D;var G=class G extends ce{static _setObject(t){this.setItem(G.storageKey,JSON.stringify(t));}static setObject(t){this._setObject(t),ie(this._getAll),ie(this._get);}static _getAll(){return JSON.parse(this._getItem(this.storageKey,false)||"{}")}static _get(t){let i=this.getAll();return t in i?i[t]:null}static clear(){this.debug&&console.log(`[${this.storageName}] clear`),this.removeItem(this.storageKey),ie(this._getAll),ie(this._get);}static update(t,i){let r=(this||G).getAll();t in r&&r[t]===i||(r={...r,[t]:i},this._setObject(r),M(this._getAll,[],r),M(this._get,[t],r[t]));}static pop(t){let i=(this||G).getAll(),r=null;return t in i?(r=i[t],delete i[t],this._setObject(i),M(this._getAll,[],i),M(this._get,[t],null),r):null}static clearLargeIgCookies(t,i,r){let n={...(this||G).getAll()||{}};if(JSON.stringify(n).length<=t)return;let a=new Set(i.map(u=>g(u.id))),c=new Set(r.flatMap(u=>u.exclusionGroupEntities.map(m=>m.experienceId))),l=/^[a-zA-Z0-9]{12}$/;for(let u of Object.keys(n))l.test(u)&&!a.has(u)&&!c.has(u)&&delete n[u];(this||G)._setObject(n),M(this._getAll,[],n);}};s(G,"IgVarsStorage"),f(G,"storageKey","ig-vars"),f(G,"debug",false),f(G,"storageName","IgVarsStorage"),f(G,"getAll",b(G._getAll)),f(G,"get",b(G._get));var ze=G;var K=class K extends ze{static _setObject(t){this.setItem(K.storageKey,JSON.stringify(t));}static _getAll(){return super._getAll()}static _get(t){return super._get(t)}};s(K,"IgIgnoreStorage"),f(K,"storageName","IgIgnore"),f(K,"storageKey","ig-ignored"),f(K,"getAll",b(K._getAll)),f(K,"get",b(K._get));var Ze=K;function wt(){try{let e=js_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get(x.GEO_LOCATION_COOKIE);if(e)return JSON.parse(e)}catch(e){console.error("error parsing GEO_LOCATION",e);}}s(wt,"getGeoLocation");function Rn(){return Number(js_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get(x.IG_PAGE_VIEW_COUNT_KEY)||0)}s(Rn,"getPageViewCount");function bt(e,t,i){let r=e.getIgCookie("vars",true)||{};e.setIgCookie("vars",{...r,[t]:i});}s(bt,"updateVars");var F={client:null,getIgnored(e){return (this.client.getIgCookie("ignored",true)||{})[e]},ignore(e,t){let i=this.client.getIgCookie("ignored",true)||{};this.client.setIgCookie("ignored",{...i,[e]:t});},getOfferIdParam(){return this.getParams().get(dt.CAMPAIGN_QUERY_PARAM_KEY)},displayAudienceFilters:Ie.displayAudienceFilters,determineAudienceConditionMatch:Ie.determineAudienceConditionMatch,getInclusionTimeStamp(e){return J.get(g(e))},setInclusionTimeStamp(e){J.update(g(e),Date.now());},removeIncludeTimeStamp(e){J.pop(g(e));},isWithinEvaluationTimeSpan(e,t){let i=J.get(g(e)),r=Date.now(),n=r-i,o=t*24*60*60*1e3,a=30*60*1e3;return n<=o?true:r<=i+o+a?(J.update(g(e),i+a),true):false},setVar(e,t){bt(this.client,g(e),t);},exclude(e){bt(this.client,g(e),re.EXCLUDED);},permaExclude(e){bt(this.client,g(e),re.PERMA_EXCLUDED);},getHistory(e){return (this.client.getIgCookie("vars",true)||{})[g(e)]},hasHistory(e){return Object.keys(this.client.getIgCookie("vars",true)||{}).includes(g(e))},isExcluded(e){return (this.client.getIgCookie("vars",true)||{})[g(e)]===re.EXCLUDED},isPermaExcluded(e){return (this.client.getIgCookie("vars",true)||{})[g(e)]===re.PERMA_EXCLUDED},isExcludedByVisitorType(e){return  false},isUnassigned(e){return (this.client.getIgCookie("vars",true)||{})[g(e)]===re.UNASSIGNED},isWholesale(e){return e!=null&&e.wholesale&&window.isWsgCustomer===true?"Wholesale":false},isExcludedByMarket:Ie.isExcludedByMarket,shouldAssign(e,t){if(this.isPermaExcluded(e)||this.isExcluded(e)||this.isWholesale(t))return "noassign";let{found:i,pending:r}=this.isExcludedByMarket(t);return r?"assign":i?(this.exclude(e),"noassign"):"assign"},unassign(e,t){bt(this.client,g(e),re.UNASSIGNED);},unexclude(e){let t=this.client.getIgCookie("vars",true)||{};delete t[g(e)],this.client.setIgCookie("vars",t);},getParams(){return z.params}};function Sn(e,t,i,r){let o=t.split(x.ID_SPACER)[1],a=Tt(o,i.id);return {...H.initSharedExperience({...i,igIdHex:a}),ig:e,predefinedVariation:r}}s(Sn,"initExperienceEntity");function uc(e,t,i){var l;let r=e.config.audiences.find(u=>u.experienceId===i.id),n=e.config.variations.filter(u=>u.experienceId===i.id).map(u=>Q.initVariationEntity(u)),o=e.config.experiencePageTargeting.filter(u=>u.experienceId===i.id),a=n.map(u=>u.id),c=(l=e.config.userInterfaces)==null?void 0:l.filter(u=>u.variationId&&a.includes(u.variationId));return Sn(e,t,{...i,audience:r,variations:n,experiencePageTargeting:o,userInterfaces:c},null)}s(uc,"initFromConfig");function fc(e){return H._determinePageTargetingIncluded(e)}s(fc,"determinePageTargetingIncluded");function mc(e,t){if(e.predefinedVariation)return e.predefinedVariation;let i=(e.ig.config.redirects||[]).filter(o=>!o.isThemeTest).filter(o=>(e.variations||[]).map(a=>a.id).includes(o.variationId)).length>0,r=new URL(window.location.href),n=(e.variations||[]).some(o=>e.ig.config.redirects.some(a=>a.variationId===o.id&&un(a,r)));return H._getVariation({entity:e,audience:F,igId:{id:s(()=>e.ig.id,"id"),isFirstVisit:s(()=>t.getIsFirstVisit(),"isFirstVisit")},preview:{isPreviewEntity:e.ig.preview===e.id,isPreviewIntegration:!!e.ig.integration,isPreviewTraffic:!!e.ig.previewTraffic,getVariationId(){},setVariationId(o){}},message:H.createMessageHandler({get(){return t.getTrafficMessage(e.id)},set(o){o.message&&t.addTrafficMessage(e.id,o);}}),geoLocation:t.getGeoLocation(),storage:{set(o,a){F.setVar(o,a);},setAnalyticsExcluded(o){o&&(F.ignore(e.id,"true"),e.isIgnored=true);},isAnalyticsExcluded(){return F.getIgnored(e.id)==="true"}},logger:H.createLogHandler(_),params:z.params,redirect:{matchesRedirectCondition:n,hasRedirects:i}})}s(mc,"getVariation");function Dn(e,t){let i=t.exclusions,r=Number(js_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get(x.IG_PAGE_VIEW_COUNT_KEY)||0),n=t.exclusions.some(m=>m===e.id),{found:o,pending:a}=F.isExcludedByMarket(e.audience),c=!a&&!!o,l=(r||0)<=2;n&&!c&&l&&(i=t.exclusions.filter(m=>m!==e.id),t.dispatchData({type:"SET_EXCLUSIONS",payload:i}));let u=F.isWholesale(e.audience);return {trafficExclusion:(i.includes(e.id)?"Previously Excluded":false)||c||u,newExclusions:i}}s(Dn,"determineGlobalAudienceConfigExclusions");function dc(e){return H.determineGlobalAudienceExclusionsShared(e,F,{igPageViewCount:Rn(),messages:{},geoLocation:wt()})}s(dc,"determineGlobalAudienceExclusions");function pc(e,t){let{trafficExclusion:i,newExclusions:r}=Dn(e,{exclusions:t.exclusions,dispatchData:t.dispatchData});return t.isPreview?t.isPreviewAllTraffic?false:i:e.isPreview?"Preview Experience":r!=null&&r.includes(e.id)?"Force Exclude Experience":i}s(pc,"shouldExcludeExperience");var Qe={};k(Qe,{initOfferEntity:()=>vc});var Je={};k(Je,{findProduct:()=>Ic,findVariant:()=>Ec,getWidget:()=>hc,hasFreeShippingTier:()=>xc,hasGWPTier:()=>_c,initSharedOfferEntity:()=>gc,toTrackModel:()=>Ac});function gc(e,t,i){return {...e,offerProducts:t,entityType:"offer",experience:null,variation:i,shortId:g(e.id),experienceShortId:null,variationId:i.id,widgets:{}}}s(gc,"initSharedOfferEntity");function hc(e,t){return e.widgets[t]}s(hc,"getWidget");function Ic(e,t){return e.offerProducts.find(i=>i.id===t)}s(Ic,"findProduct");function Ec(e,t){return e.offerProducts.find(i=>i.variants.find(r=>r.id===t))}s(Ec,"findVariant");function _c(e){let t=e.tiers;return t?t.some(i=>i.isGiftWithPurchase):false}s(_c,"hasGWPTier");function xc(e){let t=e.tiers;return t?t.some(i=>i.isFreeShipping):false}s(xc,"hasFreeShippingTier");function Ac(e){return {id:e.id,variationId:e.variationId,name:e.name,isArchived:e.isArchived,enabled:e.enabled,unitType:e.unitType,discountType:e.discountType,discountApplicationType:e.discountApplicationType,discountApplicationMethod:e.discountApplicationMethod,isTest:e.isTest,combinesWithIntelligems:e.combinesWithIntelligems,combinesWithShopify:e.combinesWithShopify,shouldRejectCodes:e.shouldRejectCodes,shippingDiscount:e.shippingDiscount}}s(Ac,"toTrackModel");function vc(e,t,i,r){let n=Je.initSharedOfferEntity(e,t,i);return n}s(vc,"initOfferEntity");var Q={};k(Q,{getShippingRateAmount:()=>Nc,initVariationEntity:()=>Tc,toTrackModel:()=>Pc});function Tc(e){return ge.initSharedVariation(e)}s(Tc,"initVariationEntity");var Pc=ge.toTrackModel,Nc=ge.getShippingRateAmount;function Rc(e){return nn(e.experience,F,{determineGlobalAudienceExclusions:E.determineGlobalAudienceExclusions,determinePageTargetingIncluded:E.determinePageTargetingIncluded},{isPreviewMode:e.preview,isPreviewAllTrafficMode:e.previewTraffic,logger:{logUndefinedParams:s(()=>{},"logUndefinedParams"),logWithFunction:s(()=>{},"logWithFunction")},messages:{}})}s(Rc,"shouldExcludeExperience");function Ld(e,t){var a;let i=[],r=[];for(let c of t.config.experiences)i.push(E.initFromConfig(t,t.id,c));for(let c of (a=t.config.exclusionGroups)!=null?a:[])r.push(se.initExclusionGroupEntity(t.id,c,i));let n=Dc(e,{configExperiences:i,exclusionGroups:r}),o=Sc({experiences:n,config:t.config});return {experiences:n,offers:o,exclusionGroups:r}}s(Ld,"buildEntities");function Vd(e,t){return e.filter(i=>{var n;if(!(g(i.id)in t))return  false;let r=t[g(i.id)];if(!r)return  false;if((n=i.variations)!=null&&n.some(o=>g(o.id)===r))return  true})}s(Vd,"filterExperiencesOnlyActive");function Sc(e){let t=[];for(let i of e.experiences)for(let r of i.variations||[]){let n=e.config.offers.find(c=>c.variationId===r.id);if(!n)continue;let o=e.config.offerProducts.filter(c=>c.variationId===r.id),a=Qe.initOfferEntity(n,o,{...r,experienceId:i.id},[]);r.offer=a,a.experience=i,t.push(a);}return t=t.flat(),t}s(Sc,"attachOffersToVariations");function Dc(e,t){return pn(t.configExperiences,{determineNonEligibleExperiences:se.determineNonEligibleExperiences},{exclusionGroups:t.exclusionGroups,getPreviewIfExists:s(()=>e.getPreviewValue()||null,"getPreviewIfExists"),getPreviewedEntityState:s(()=>e.getPreviewedEntityState(),"getPreviewedEntityState"),shouldExcludeExperience:s(i=>Rc({experience:i,preview:!!e.getPreviewValue(),previewTraffic:e.getPreviewTraffic()}),"shouldExcludeExperience")},e)}s(Dc,"filterExperiences");var Oi=class Oi{static async getIntelligemsConfig(t){return t.config?t.config:St(t)}};s(Oi,"GetConfig");var On=Oi;function Mt(e,t){for(let i of t)if(!i.isPreview&&i.type==="shipping")return E.getVariation(i,e);for(let i of t)if(i.type==="shipping")return E.getVariation(i,e)}s(Mt,"getShippingTestGroup");function yt(e){return e.map(t=>g(t.id))}s(yt,"getAllExperienceShortIds");function Oe(e,t){let i=[];for(let r of t){let n=E.getVariation(r,e);n&&i.push(n.shortId);}return i}s(Oe,"getAllVariationShortIds");function Oc(e){return e.filter(t=>t.testTypes.hasTestCampaign)}s(Oc,"getOfferExperiences");function wc(e,t){return Oc(t).map(n=>{let o=E.getVariation(n,e);return o?o.offer:null}).filter(n=>!!n)}s(wc,"getOffers");function Lt(e,t){return wc(e,t).map(i=>g(i.id))}s(Lt,"getAllOfferShortIds");var kd=s(e=>{let t=[],i=[];if(e&&e.vars&&e.config)for(let r of e.config.experiences||[]){let n=g(r.id);n in e.vars&&(F.isExcluded(r.id)&&i.push(n),F.isUnassigned(r.id)&&t.push(n));}return {unassigned:t,exclusions:i}},"getAssignments");function wn(e,t){let{experienceId:i,productVariant:r}=bn(e,t),n=null;if(i&&r){let o=t.ig.experiences.find(u=>u.id===i),a=o&&E.getVariation(o,e);if(!a||!o)return;let c=o.variations||[],l=a.name;n=yn(l,c,r,t.subscribeAndSave||false);}return n}s(wn,"getLineItemDiscount");function bn(e,t){let i=t.productId?new ve(t.productId):void 0,r=t.variantId?new Te(t.variantId):void 0;if(!i&&!r)return _.error("Product ProductId or VariantId required"),{experienceId:void 0,productVariant:void 0};let{experienceId:n,productVariant:o}=Y.getExperienceIdFromProductVariant(e,{ig:t.ig,productVariant:{productId:i==null?void 0:i.id,variantId:r==null?void 0:r.id}});return {experienceId:n,productVariant:o}}s(bn,"getExperienceProductVariant");function Mn(e,t){var o;let{experienceId:i,productVariant:r}=bn(e,t),n;if(i&&r){let a=t.ig.experiences.find(l=>l.id===i),c=a&&((o=E.getVariation(a,e))==null?void 0:o.name);c&&(n=Ln(c,r,t.subscribeAndSave||false));}return n}s(Mn,"getLineItemPrice");function bc(e,t,i,r,{productId:n,variantId:o,customAttributes:a,subscribeAndSave:c},l){var d,p;if(!l||!t)return a||[];let u=a||[],m=Mt(e,i);if((p=(d=l==null?void 0:l.config)==null?void 0:d.options)!=null&&p.addVariationId||m){let I=Oe(e,i).join(",");I&&u.push({key:Pe.LINE_ITEM_TEST_GROUPS,value:I});}if(m&&(m.id&&u.push({key:Pe.LINE_ITEM_TEST_GROUP,value:m.id}),l.preview&&u.push({key:Pe.LINE_ITEM_PREVIEW,value:"true"})),!n||!o)return u;if(r){let I=Mn(e,{ig:l,productId:n,variantId:o,subscribeAndSave:c});I&&u.push({key:Pe.LINE_ITEM_PRICE,value:rt(S(I)*100)});}else {let I=wn(e,{ig:l,productId:n,variantId:o,subscribeAndSave:c});I&&u.push({key:Pe.LINE_ITEM_DISCOUNT,value:I});}return u.filter(I=>I.value!=="")}s(bc,"wrapStorefrontItemCustomAttributes");function yn(e,t,i,r){return Gr({variationName:e,variations:t,productVariant:i,includeSubscribeAndSave:r,currencyRate:void 0})}s(yn,"getIgLineItemDiscount");function Ln(e,t,i){return Ur({variationName:e,productVariant:t,includeSubscribeAndSave:i,isComparePrice:false})}s(Ln,"getIgLineItemPrice");var kn="",kt=class kt extends V{constructor(){super();}static getIdFromIgCookies(t){let i=kt._id||t.id||null;return this._getId(i,{deleteIgId:false,setId:s(r=>{},"setId"),isCookieSet:s(()=>true,"isCookieSet")})}static getFirstVisit(t,i){let r=i.fv||null;return r||(r=new Date().getTime().toString(),t(x.IG_FV_KEY,r)),r}static getIsFirstVisit(t){return this._isFirstVisit({setFirstVisit:s(i=>{t(x.IG_FV_KEY,i);},"setFirstVisit")})}static buildTrackBody(t,i){return ne._buildTrackBody({id:this._id,initBuildId:null,buildId:i.ig.config.buildId,version:"1.2.12",preview:i.ig.preview?"true":null,variants:i.variants,cartOrCheckoutToken:i.cartOrCheckoutToken,isGoogleBot:i.isGoogleBot,eventType:i.eventType,country:i.country,currency:i.currency||false,storeName:i.ig.config.storeName,firstVisitTs:js_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get(x.IG_FV_KEY),viewedProductPrices:[],pathnameOverride:i.pathnameOverride,newVariation:i.newVariation,documentReferrer:i.documentReferrer,isFirstVisit:this.getIsFirstVisit(t.setCookie.bind(t)),sentDuring:i.sentDuring,geoLocation:wt(),customEvent:i.customEvent,orgId:i.orgId,isHeadless:true,isEsm:true,document:{referrer:document.referrer}})}static async track(t,i){var m,d,p,I;let r=i.isGoogleBot?[]:i.experiences,n=(((m=i.ig.config)==null?void 0:m.experiences)||[]).filter(A=>i.exclusions.some(P=>P===A.id)).map(A=>E.initFromConfig(i.ig,this._id,A)),o=(((d=i.ig.config)==null?void 0:d.experiences)||[]).filter(A=>i.unassigned.some(P=>P===A.id)).map(A=>E.initFromConfig(i.ig,this._id,A)),a=[...r,...n,...o],c=[],l=a.filter(A=>{var R;return !!((R=i.ig.config)==null?void 0:R.variations.find(U=>U.experienceId===A.id))});for(let A of l){let P=A.id in i.ignored||A.isIgnored,R=[],U=null;for(let O of i.exclusionGroups){let v=se.determineNonEligibleExperiences(O,t);for(let N of v)N&&!R.includes(N)&&R.push(N);for(let N of O.exclusionGroupEntities)N.experienceId===A.id&&(U=O.id);}let B;if(i.unassigned.includes(A.id)?B=false:B=E.shouldExcludeExperience(A,{exclusions:i.exclusions,isPreview:i.ig.preview?i.ig.preview!=="true":false,isPreviewAllTraffic:i.ig.previewTraffic||false,dispatchData:i.dispatchData}),B==="Preview Experience")continue;let X=R.includes(A.id),C=null;X||(C=E.getVariation(A,t)),c.push({...C?Q.toTrackModel(C):{},...B?{isExcluded:true,exclusionReason:B}:{},...X?{isExcluded:true,exclusionReason:"Mutual Exclusion"}:{},ignored:P,experienceId:A.id,exclusionGroupId:U});}let u=this.buildTrackBody(t,{...i,orgId:i.ig.config.orgId,variants:c});return ne._track({body:u,orgId:i.ig.config.orgId,useBeacon:((I=(p=i.ig.config)==null?void 0:p.options)==null?void 0:I.useBeacon)||false})}static trackOnce(t,i){var r,n;if(i.url!==kn){kn=i.url;try{let o=Number(js_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get(x.IG_PAGE_VIEW_COUNT_KEY))||0,a=((n=(r=i.ig.config)==null?void 0:r.options)==null?void 0:n.domain)||window.location.hostname;t.setCookie(x.IG_PAGE_VIEW_COUNT_KEY,String(o+1));}catch(o){_.warn(o);}this.track(t,{...i,isGoogleBot:false}).then(()=>{}).catch(_.error);}}};s(kt,"IgId");var Vt=kt;async function Gt(e,t,i,r=true){let n=we.createTrackPayloadFromIgEvent(e,t,i);await ne.sharedSendEvent(n,r);}s(Gt,"sendEvent");function wi(e,t){let i=[];for(let r of t.experiences){let n=Ze._get(r.id)||r.isIgnored?"true":void 0,o=E.shouldExcludeExperience(r,{exclusions:t.exclusions,isPreview:!!t.ig.preview,isPreviewAllTraffic:t.ig.previewTraffic||false,dispatchData:t.dispatchData});if(o==="Preview Experience")continue;let a=E.getVariation(r,e);i.push({...a?Q.toTrackModel(a):{},...o?{isExcluded:true,exclusionReason:o}:{},ignored:n,experienceId:r.id});}return [...i]}s(wi,"getTrackVariants");var bi=class bi extends Nt{constructor(i,r,n,o){super(r,n,false);f(this,"client");f(this,"options");this.client=i,this.options=o;}static createTrackPayloadFromIgEvent(i,r,n){return Vt.buildTrackBody(i,{ig:n.ig,url:n.url,orgId:n.orgId,variants:wi(i,n),cartOrCheckoutToken:null,isGoogleBot:false,eventType:"custom_event",customEvent:r})}async sendPendingEvents(){return super.sendPendingEvents(async(i,r)=>{var n;return Gt(this.client,i,{...this.options,url:((n=window==null?void 0:window.location)==null?void 0:n.pathname)||""},r)})}async push(i){return super.push(i,async(r,n)=>{var o;return Gt(this.client,r,{...this.options,url:((o=window==null?void 0:window.location)==null?void 0:o.pathname)||""},n)})}};s(bi,"IgEvents");var we=bi;var Y={};k(Y,{formatPrice:()=>kc,getExperienceIdFromProductVariant:()=>Mc,getExperienceProductById:()=>yc});function Mc(e,t){return t.productVariant.variantId?Lc({ig:t.ig,variantId:t.productVariant.variantId}):t.productVariant.productId?Vc(e,{ig:t.ig,productId:t.productVariant.productId}):(_.warn('useIgPrices(): "variantId" or "productId" is required.'),{experienceId:null,productVariant:null})}s(Mc,"getExperienceIdFromProductVariant");function yc(e,t,i){if(!e||!t)return {experienceId:null,product:null};let r=[];return i!=null&&i.config&&(r=i==null?void 0:i.config.experienceProducts),Fe._getExperienceProductById({productId:t,experiences:i.experiences,experienceProducts:r})}s(yc,"getExperienceProductById");function Lc(e){return mi({igId:e.ig.id,variantId:e.variantId,experiences:e.ig.experiences,experienceProducts:e.ig.config.experienceProducts})}s(Lc,"getExperienceIdProductVariantById");function Vc(e,t){return di({igId:t.ig.id,productId:t.productId,experiences:t.ig.experiences,getVariationName:s(i=>{var n;let r=t.ig.experiences.find(o=>o.id===i);return r&&((n=E.getVariation(r,e))==null?void 0:n.name)||null},"getVariationName"),logger:_,experienceProducts:t.ig.config.experienceProducts})}s(Vc,"getExperienceIdProductVariantByProdId");function kc(e){if(!e.price)return null;let t=e.priceFormat||"dollars",i=ye(e.price,e.priceRegex);return t==="dollars"?i:i*100}s(kc,"formatPrice");var yi={};k(yi,{buildCartAttributes:()=>Bt,putCartOrCheckoutAttributes:()=>Mi});var Gn=graphql_tag__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP`
    mutation cartAttributesUpdate($attributes: [AttributeInput!]!, $cartId: ID!) {
  cartAttributesUpdate(attributes: $attributes, cartId: $cartId) {
    cart {
      id
      attributes {
        key
        value
      }
    }
    userErrors {
      field
      message
    }
  }
}
    `,Un=graphql_tag__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP`
    mutation checkoutAttributesUpdateV2($checkoutId: ID!, $input: CheckoutAttributesUpdateV2Input!) {
  checkoutAttributesUpdateV2(checkoutId: $checkoutId, input: $input) {
    checkout {
      id
      customAttributes {
        key
        value
      }
    }
    checkoutUserErrors {
      code
      field
      message
    }
  }
}
    `,Bn=graphql_tag__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP`
    query getCartAttributes($id: ID!) {
  cart(id: $id) {
    attributes {
      key
      value
    }
  }
}
    `,Fn=graphql_tag__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP`
    query getCheckoutAttributes($id: ID!) {
  cart(id: $id) {
    buyerIdentity {
      customer {
        lastIncompleteCheckout {
          customAttributes {
            key
            value
          }
        }
      }
    }
  }
}
    `;var Yn=s(e=>e.loc&&e.loc.source.body,"gqlToString");var Ap=s(e=>{let t;try{t=JSON.parse(e);}catch{t=e;}return t},"tryJsonParse");var Gc="2024-04",Uc="2025-07",Ce=s(async(e,t,i)=>{let r=Yn(e);r||_.error("Invalid GQL Document Node");let n=await fetch(`https://${i.storeName}/api/${i.oldApi?Gc:Uc}/graphql.json`,{method:"POST",headers:{"X-Shopify-Storefront-Access-Token":i.storefrontApiToken,"Content-Type":"application/json"},body:JSON.stringify({query:r,variables:t})}),{data:o,errors:a}=await n.json();return a&&_.error(a),{data:o,res:n}},"fetchGraphql");function Bt(e,t){var r,n;let i=[...e,{key:"igId",value:t.igId}];if(t.isPreview&&i.push({key:"igPreview",value:`${t.isPreview}`}),i.push({key:"igTestGroups",value:((r=t.shortTestGroupIds)==null?void 0:r.join(","))||""}),t.shopifyFunctionsEnabled&&((n=t.shortOfferIds)!=null&&n.length)){let o=t.shortOfferIds.join(",");i.push({key:"igOffers",value:o});}return i}s(Bt,"buildCartAttributes");async function Bc(e){var t,i,r,n,o,a,c;try{if((t=e.cartOrCheckoutToken)!=null&&t.startsWith("gid://shopify/Checkout")){let u=await Ce(Fn,{id:e.cartOrCheckoutToken},{storeName:e.storeName,storefrontApiToken:e.storefrontApiToken,oldApi:!1});return ((o=(n=(r=(i=u==null?void 0:u.data)==null?void 0:i.cart)==null?void 0:r.buyerIdentity.customer)==null?void 0:n.lastIncompleteCheckout)==null?void 0:o.customAttributes)||[]}let l=await Ce(Bn,{id:e.cartOrCheckoutToken},{storeName:e.storeName,storefrontApiToken:e.storefrontApiToken,oldApi:!1});return ((c=(a=l==null?void 0:l.data)==null?void 0:a.cart)==null?void 0:c.attributes)||[]}catch{return _.error("Unable to fetch cart or checkout attributes"),[]}}s(Bc,"getExistingCartAttributes");async function Mi(e){let t=await Bc(e),i=Bt(t,e);return Fc({attributes:i,cartOrCheckoutToken:e.cartOrCheckoutToken,storeName:e.storeName,storefrontApiToken:e.storefrontApiToken})}s(Mi,"putCartOrCheckoutAttributes");async function Fc(e){var t,i;try{if((t=e.cartOrCheckoutToken)!=null&&t.startsWith("gid://shopify/Checkout"))return await Ce(Un,{checkoutId:e.cartOrCheckoutToken,input:{customAttributes:e.attributes}},{storeName:e.storeName,storefrontApiToken:e.storefrontApiToken,oldApi:!0});if((i=e.cartOrCheckoutToken)!=null&&i.startsWith("gid://shopify/Cart"))return await Ce(Gn,{cartId:e.cartOrCheckoutToken,attributes:e.attributes},{storeName:e.storeName,storefrontApiToken:e.storefrontApiToken,oldApi:!1});_.error("Invalid cart or checkout id");}catch(r){_.error(r);}}s(Fc,"updateCartOrCheckoutAttributes");var Li=s(({isIgPrice:e,igPrice:t,className:i,priceFormat:r,priceFormatter:n,integration:o,isCompareAtPrice:a})=>{let{priceRegex:c}=(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(h).data||{};return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{if(!t)return null;let l=Y.formatPrice({priceRegex:c,price:t.value,currencyCode:t.currencyCode,priceFormat:r});n&&l&&(l=n(l,t.currencyCode));let u=`${a?"igCompareAtPrice ":"igPrice "}`;return i&&(u+=`${i} `),o&&(e?u+="ig-changed-price":u+="ig-unchanged-price"),react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:u||void 0,style:o?e?{backgroundColor:"#71dd71",color:"black"}:{backgroundColor:"#b8d3ff",color:"black"}:void 0},l)},[e,o,i,t])},"Price");var et=s(({className:e,igPrices:t,isCompareAtPrice:i,priceFormatter:r})=>{let{ig:n,priceFormat:o}=(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(h).data||{};return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Li,{igPrice:i?t.igCompareAtPrice:t.igPrice,priceFormatter:r,priceFormat:o,integration:(n==null?void 0:n.integration)||false,className:e,isIgPrice:t.isIgPrice,isCompareAtPrice:i})},"IgBasePrice");var Qp=s(e=>{var l,u;let{data:t,dispatchData:i,client:r}=(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(h),{ig:n,storefrontApiToken:o,events:a}=t||{},c=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{var m,d;return ((d=(m=n==null?void 0:n.config)==null?void 0:m.options)==null?void 0:d.usePriceProperty)||false},[(u=(l=n==null?void 0:n.config)==null?void 0:l.options)==null?void 0:u.usePriceProperty]);return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{if(!r||!(n!=null&&n.config)||!(n!=null&&n.id)||!e||a.cartOrCheckoutToken)return;i({type:"SET_EVENTS",payload:{...a,cartOrCheckoutToken:true}});let m=Oe(r,n.experiences),d=yt(n.experiences),p=Lt(r,n.experiences);Mi({cartOrCheckoutToken:e,storefrontApiToken:o,igId:n.id,isPreview:!!n.preview,storeName:n.config.storeName,shortTestGroupIds:m,shopifyFunctionsEnabled:n.config.options.shopifyFunctionsEnabled||false,shortExperienceIds:d,shortOfferIds:p});},[r,e,o,n==null?void 0:n.id,n==null?void 0:n.config,a]),{wrapCustomAttributes:s(m=>!r||!(n!=null&&n.config)?[]:Xe.wrapStorefrontItemCustomAttributes(r,(n==null?void 0:n.id)||void 0,(n==null?void 0:n.experiences)||[],c,m,n),"wrapCustomAttributes")}},"useIgCart");var ig=s(()=>{let{ig:e}=(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(h).data||{},t=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>!!(e!=null&&e.config),[e,e==null?void 0:e.config]);return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{var i;return {isReady:t,experiences:((i=e==null?void 0:e.config)==null?void 0:i.experiences)||[]}},[e,t])},"useIgConfigExperiences");var cg=s(()=>{let{data:e,dispatchData:t,client:i}=(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(h),{ig:r,exclusions:n}=e||{};(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{var o,a;!i||!(r!=null&&r.config)||(window.igEvents=new we(i,window.igEvents,((o=r==null?void 0:r.config)==null?void 0:o.options.useBeacon)||true,{ig:r,orgId:r.config.orgId,isPreviewAllTraffic:r.previewTraffic||false,exclusions:n,dispatchData:t,experiences:r.experiences,isPreview:!!(r.preview&&r.preview!=="true")}),(a=window.igEvents)==null||a.sendPendingEvents());},[i,r==null?void 0:r.config]);},"useIgCustomEvents");var dg=s(()=>{let{ig:e}=(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(h).data||{};return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>e!=null&&e.config?{isReady:true,experiences:e.config.experiences.filter(t=>e.experiences.some(i=>i.id===t.id))}:{isReady:false,experiences:[]},[e==null?void 0:e.experiences,e==null?void 0:e.config])},"useIgExperiences");var vg=s(()=>{var n;let{data:e,client:t}=(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(h),{ig:i}=e||{},r=(n=i==null?void 0:i.config)==null?void 0:n.integrations;(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{var c,l,u;if(!t||!(i!=null&&i.config))return;let o=new Set,a=null;for(let m of i.experiences){a||r&&(a=((u=(l=(c=r.find(p=>p.name==="Google"))==null?void 0:c.globalSettings)==null?void 0:l.ga)==null?void 0:u.measurementId)||null);let d=E.getVariation(m,t);d&&o.add(Vr(m.name,d.id,d.name));}Ke.trackGa4(a,Array.from(o),_);},[t,i==null?void 0:i.config,i==null?void 0:i.experiences]);},"useIgGaTrack");function nl(e){return `${e.experienceName.substring(0,175)} - ${e.variationName.substring(0,75)}`}s(nl,"getTrackingVariationName");var sl={Clarity:s((e,t)=>{window.clarity?window.clarity("set","ig_test_group",e):_.warn("Clarity not found");},"Clarity"),Hotjar:s((e,t)=>{window.hj?window.hj("event",e):_.warn("Hotjar not found");},"Hotjar"),Heatmap:s((e,t)=>{window.heatmap_set_event_tag?window.heatmap_set_event_tag({partner:"intelligems_variant",variant_friendly_name:e,variant_id:t}):_.warn("Heatmap not found");},"Heatmap")},Og=s(e=>{let{data:t,client:i}=(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(h),{ig:r}=t||{};(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{if(!(!i||!(r!=null&&r.config)))for(let n of e)for(let o of r.experiences){let a=E.getVariation(o,i);if(!a)continue;let c=nl({experienceName:o.name,variationName:a.name});sl[n](c,a.id);}},[i,r==null?void 0:r.config]);},"useIgIntegrations");var Lg=s(()=>{let{ig:e}=(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(h).data||{};return !!(e!=null&&e.integration)},"useIgIsIntegration");var Hn=s(e=>{let{data:t,client:i}=(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(h),{ig:r}=t||{};return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{if(!i||!(r!=null&&r.config))return {isReady:false,offer:null};let n=r.experiences.find(a=>a.id===e),o=n&&E.getVariation(n,i);return o?{isReady:true,offer:r.config.offers.find(a=>a.variationId===o.id)||null}:{isReady:true,offer:null}},[i,r==null?void 0:r.config,r==null?void 0:r.experiences])},"useIgOffer");var Kg=s((e,t)=>{let i=Hn(e);return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{var r;return i.isReady?{isReady:true,tier:((r=i.offer)==null?void 0:r.tiers.find(n=>t>=n.minimumUnits&&t<=n.maximumUnits))||null}:{isReady:false,tier:null}},[i.isReady])},"useIgOfferTier");var Zg=s(e=>{let{ig:t}=(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(h).data||{};return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{if(!(t!=null&&t.config))return {isReady:false,offer:null};let i=t.experiences.find(n=>n.id===e),r=(i==null?void 0:i.variations)||[];return {isReady:true,offers:t.config.offers.filter(n=>r.some(o=>o.id===n.variationId))}},[t==null?void 0:t.config,t==null?void 0:t.experiences])},"useIgOffers");var eh=s(()=>{let{ig:e}=(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(h).data||{};return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{var t;return !(e!=null&&e.config)||!e.preview||e.preview==="true"?null:((t=e==null?void 0:e.config)==null?void 0:t.experiences.find(i=>i.id===e.preview))||null},[e==null?void 0:e.experiences,e==null?void 0:e.config,e==null?void 0:e.preview,e==null?void 0:e.isPreviewTrue])},"useIgPreviewedExperience");var Kn=s((e,t,i,r)=>{var C;let{priceFormat:n,activeCurrencyCode:o,priceRegex:a}=t||{},{originalPrice:c,originalCompareAtPrice:l,variantId:u,productId:m,currencyCode:d}=e,p=m?new ve(m):void 0,I=u?new Te(u):void 0;if(!i||!(r!=null&&r.config)||!(r!=null&&r.id))return {igPrice:void 0,igCompareAtPrice:void 0,duplicateProduct:void 0,experienceId:void 0,variationId:void 0,isIgPrice:false,isReady:false};let{experienceId:A,productVariant:P}=Y.getExperienceIdFromProductVariant(i,{ig:r,productVariant:{productId:p==null?void 0:p.id,variantId:I==null?void 0:I.id}}),{product:R}=Y.getExperienceProductById(r.id,p==null?void 0:p.id,r),U=c&&a?{value:ye(c,a),currencyCode:d||o}:void 0,B=l&&a?{value:ye(l,a),currencyCode:d||o}:void 0,X;if(A&&P){let O=r.experiences.find(v=>v.id===A);if((((C=O==null?void 0:O.currency)==null?void 0:C.code)||"USD")===(d||o)){let v=O&&E.getVariation(O,i),N=P.variationPrices.find(le=>le.variationId===(v==null?void 0:v.id));if(O&&v&&N)return (r!=null&&r.preview&&r.preview===O.id||!(r!=null&&r.preview)&&!O.isPreview)&&(U={value:Y.formatPrice({priceRegex:a,price:N.price,currencyCode:d||o,priceFormat:n}),currencyCode:d||o},B={value:Y.formatPrice({priceRegex:a,price:N.compareAtPrice,currencyCode:d||o,priceFormat:n}),currencyCode:d||o},X={productId:R!=null&&R.altIds?R.altIds[v.name]:"",variantId:N.id,handle:R!=null&&R.altHandles?R.altHandles[v.name]:""}),{igPrice:U,igCompareAtPrice:B,duplicateProduct:X,experienceId:O.id,variationId:v.id,isIgPrice:true,isReady:true};_.info(`Product ${m}: Test Group Price not found`);}else _.info(`Product ${m}: currency mismatch`);}return {igPrice:U,igCompareAtPrice:B,duplicateProduct:X,isIgPrice:false,isReady:true}},"processSingleInput"),Ft=s(e=>{let{data:t,client:i}=(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(h),{ig:r}=t||{};return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{if(!r||!r.id||!r.config||!i){if(Array.isArray(e)){let o={};return e.forEach(a=>{a.variantId&&(o[a.variantId]={igPrice:void 0,igCompareAtPrice:void 0,duplicateProduct:void 0,isIgPrice:false,isReady:false});}),o}return {igPrice:void 0,igCompareAtPrice:void 0,duplicateProduct:void 0,isIgPrice:false,isReady:false}}let n=r;if(Array.isArray(e)){let o={};return e.forEach(a=>{a.variantId&&(o[a.variantId]=Kn(a,t,i,n));}),o}return Kn(e,t,i,n)},[e,t,i,r])},"useIgPrices");var ph=s(()=>{let{data:e,client:t}=(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(h),{ig:i}=e||{};return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{if(!t||!(i!=null&&i.config))return {isReady:false,variation:null};let r=Mt(t,i.experiences);return {isReady:true,variation:r&&i.config.variations.find(n=>n.id===r.id)||null}},[t,i==null?void 0:i.config,i==null?void 0:i.experiences])},"useIgShippingVariation");var _h=s(e=>{let{ig:t}=(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(h).data||{};return t!=null&&t.integration?e?{backgroundColor:"#71dd71",color:"black"}:{backgroundColor:"#b8d3ff",color:"black"}:void 0},"useIgStyles");var Nh=s(e=>{let{data:t,client:i}=(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(h),{ig:r}=t||{};return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{if(!i||!(r!=null&&r.config))return {isReady:false,variation:null};let n=r.experiences.find(a=>a.id===e),o=n&&E.getVariation(n,i);return {isReady:true,variation:o&&r.config.variations.find(a=>a.id===o.id)||null}},[i,r==null?void 0:r.config,r==null?void 0:r.experiences])},"useIgVariation");var bh=s(()=>{let{data:e,client:t}=(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(h),{ig:i}=e||{};return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{if(!t||!(i!=null&&i.config))return {isReady:false,variations:[]};let r=i.experiences.map(n=>E.getVariation(n,t)).filter(n=>!!n);return {isReady:true,variations:i.config.variations.filter(n=>r.some(o=>o.id===n.id))}},[t,i==null?void 0:i.config,i==null?void 0:i.experiences])},"useIgVariations");var Bh=s(()=>{let[e,t]=(0,use_immer__WEBPACK_IMPORTED_MODULE_5__/* .useImmer */ .x)({isReady:false,attributes:[]}),{data:i,client:r}=(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(h),{ig:n,storefrontApiToken:o,events:a}=i||{};return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{if(!r||!(n!=null&&n.config)||!(n!=null&&n.id)){t({isReady:false,attributes:[]});return}let c=Oe(r,n.experiences);yt(n.experiences);let u=Lt(r,n.experiences);t({isReady:true,attributes:Bt([],{igId:n.id,isPreview:!!n.preview,shortTestGroupIds:c,shortOfferIds:u,shopifyFunctionsEnabled:n.config.options.shopifyFunctionsEnabled||false})});},[r,o,n==null?void 0:n.id,n==null?void 0:n.config,a]),e},"useIgCartAttributes");var Dl=s(e=>{let{antiFlicker:t}=(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(h).data||{},i=Ft({productId:e.productId,variantId:e.variantId,originalPrice:void 0,originalCompareAtPrice:e.originalCompareAtPrice,currencyCode:e.currencyCode});return t&&!i.isReady?null:react__WEBPACK_IMPORTED_MODULE_0__.createElement(et,{...e,igPrices:i,isCompareAtPrice:true})},"IgCompareAtPrice");var bl=s(e=>{let{antiFlicker:t}=(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(h).data||{},i=Ft({productId:e.productId,variantId:e.variantId,originalPrice:e.originalPrice,originalCompareAtPrice:void 0,currencyCode:e.currencyCode});return t&&!i.isReady?null:react__WEBPACK_IMPORTED_MODULE_0__.createElement(et,{...e,igPrices:i,isCompareAtPrice:false})},"IgPrice");var NI=s(async(e,t=0)=>St({orgId:e,cacheIntervalMinutes:t}),"getIntelligemsConfig"),RI=s(e=>{_.logLevel=pe[e];},"setLogLevel");


/***/ }),

/***/ 96807:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_A": function() { return /* binding */ pack_G; },
  "Gx": function() { return /* reexport */ chunk_ZUAULJT6.C; },
  "q5": function() { return /* binding */ C; }
});

// UNUSED EXPORTS: IgBasePrice, IgCompareAtPrice, IgPrice, IntelligemsContext, Price, getIntelligemsConfig, setLogLevel, useIgCartAttributes, useIgConfigExperiences, useIgCustomEvents, useIgExperiences, useIgGaTrack, useIgIntegrations, useIgIsIntegration, useIgOffer, useIgOfferTier, useIgOffers, useIgPreviewedExperience, useIgPrices, useIgShippingVariation, useIgStyles, useIgVariation, useIgVariations

// EXTERNAL MODULE: ../node_modules/@intelligems/headless/dist/chunks/chunk-ZUAULJT6.mjs
var chunk_ZUAULJT6 = __webpack_require__(7481);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/use-immer/dist/use-immer.module.mjs + 1 modules
var use_immer_module = __webpack_require__(84465);
// EXTERNAL MODULE: ../node_modules/js-cookie/dist/js.cookie.mjs
var js_cookie = __webpack_require__(31655);
// EXTERNAL MODULE: ../node_modules/json-stringify-deterministic/lib/index.js
var lib = __webpack_require__(77332);
// EXTERNAL MODULE: ../node_modules/deepmerge/dist/cjs.js
var cjs = __webpack_require__(20406);
;// CONCATENATED MODULE: ../node_modules/@intelligems/headless/dist/chunks/chunk-RMKZFUSF.mjs
/* provided dependency */ var Buffer = __webpack_require__(30816)["lW"];
var P={};(0,chunk_ZUAULJT6.c)(P,{ExperienceOnsiteInjectionLinkage:()=>T,ExperienceOnsiteInjectionLinkageFactory:()=>k,applyCustomProperties:()=>ve,builderGroupSwitchUpdate:()=>ye,getExistingElement:()=>K,removeAllCustomProperties:()=>Te,removeCustomProperty:()=>y});var w={},S={};function K(i,e){return document.getElementById(`${i==="css"?chunk_ZUAULJT6.l.CUSTOM_CSS_ID_KEY:chunk_ZUAULJT6.l.CUSTOM_JS_ID_KEY}-${(0,chunk_ZUAULJT6.g)(e)}`)}(0,chunk_ZUAULJT6.a)(K,"getExistingElement");function ae(i,e){if(i&&!w[e]){let t=K("css",e);if(t)t.innerHTML=i,t.id=`${chunk_ZUAULJT6.l.CUSTOM_CSS_ID_KEY}-${(0,chunk_ZUAULJT6.g)(e)}`;else {let r=document.createElement("style");r.innerHTML=i,r.id=`${chunk_ZUAULJT6.l.CUSTOM_CSS_ID_KEY}-${(0,chunk_ZUAULJT6.g)(e)}`,document.head.appendChild(r);}w[e]=true;}return w[e]}(0,chunk_ZUAULJT6.a)(ae,"applyCustomCss");function ce(i,e,t){if(i&&!S[e]){let r=K("js",e);if(r)r.innerHTML=i,r.id=`${chunk_ZUAULJT6.l.CUSTOM_JS_ID_KEY}-${(0,chunk_ZUAULJT6.g)(e)}`;else {let n=document.createElement("script");n.innerHTML=i,n.type="text/javascript",n.id=`${chunk_ZUAULJT6.l.CUSTOM_JS_ID_KEY}-${(0,chunk_ZUAULJT6.g)(e)}`,(t==null?void 0:t.type)==="onWindowLoad"?document.readyState==="complete"?document.head.appendChild(n):window.addEventListener("load",()=>{document.head.appendChild(n);}):(t==null?void 0:t.type)==="timeout"&&(t!=null&&t.timeout)?setTimeout(()=>{document.head.appendChild(n);},Number(t.timeout)):document.head.appendChild(n);}S[e]=true;}return S[e]}(0,chunk_ZUAULJT6.a)(ce,"applyCustomJs");var h;function ve(i,e,t){h?i.forEach(n=>{if(!T.experienceTracker.has(n.id)){let a=t.getExperienceOnsiteInjectionLinkageWrapper(n,e);a&&(h==null||h.push(a));}}):(h=[],i.forEach(n=>{let a=t.getExperienceOnsiteInjectionLinkageWrapper(n,e);a&&(h==null||h.push(a));}));let r=new Set;for(let n of h){let a=n.onsiteInjection,s=false;for(let f of a){let u=false,g=false;f.customCss&&(u=ae(f.customCss,n.experience.id)),f.customJs&&(g=ce(f.customJs,n.experience.id,f.jsInjectionMode)),!s&&(u||g)&&(s=true);}s&&r.add(n.experience.id);}h=h.filter(n=>!r.has(n.experience.id));}(0,chunk_ZUAULJT6.a)(ve,"applyCustomProperties");function ye(i,e,t,r){i==="css"?w[e]=false:S[e]=false,i==="js"&&t&&y("js",e),t?i==="css"?ae(t,e):ce(t,e,r):y(i,e);}(0,chunk_ZUAULJT6.a)(ye,"builderGroupSwitchUpdate");function Te(i){y("css",i),y("js",i);}(0,chunk_ZUAULJT6.a)(Te,"removeAllCustomProperties");function y(i,e){let t=K(i,e);i==="css"?w[e]=false:S[e]=false,t&&t.remove();}(0,chunk_ZUAULJT6.a)(y,"removeCustomProperty");var v=class v{constructor(e$1,t){(0,chunk_ZUAULJT6.e)(this,"experience");(0,chunk_ZUAULJT6.e)(this,"onsiteInjection");this.experience=e$1,this.onsiteInjection=t,v.experienceTracker.add(e$1.id);}};(0,chunk_ZUAULJT6.a)(v,"ExperienceOnsiteInjectionLinkage"),(0,chunk_ZUAULJT6.e)(v,"experienceTracker",new Set);var T=v,W=class W{getExperienceOnsiteInjectionLinkage(e,t,r){let n=t.filter(a=>a.variationId===(r==null?void 0:r.id));if(n)return new T(e,n)}};(0,chunk_ZUAULJT6.a)(W,"ExperienceOnsiteInjectionLinkageFactory");var k=W;var $=class $ extends k{constructor(t){super();(0,chunk_ZUAULJT6.e)(this,"client");this.client=t;}getExperienceOnsiteInjectionLinkageWrapper(t,r){if(!this.client)return;let n=chunk_ZUAULJT6.s.getVariation(t,this.client);if(n)return this.getExperienceOnsiteInjectionLinkage(t,r,n)}};(0,chunk_ZUAULJT6.a)($,"HeadlessExperienceInjectionLinkageFactory");var A=$;var fe=(0,chunk_ZUAULJT6.a)(async i$1=>{let e=JSON.stringify(i$1);try{await fetch(chunk_ZUAULJT6.x.INTELLIGEMS_HEADLESS_VERSION_ENDPOINT,{method:"POST",body:e});}catch(t){console.log(t),chunk_ZUAULJT6.i.warn("Failed to post headless version");}return e},"postVersion");var le=(0,chunk_ZUAULJT6.a)(()=>{var n;let{data:i,dispatchData:e}=(0,react.useContext)(chunk_ZUAULJT6.f),{ig:t,events:r}=i||{};(0,react.useEffect)(()=>{(0,chunk_ZUAULJT6.a)(async()=>{var s;if((s=t==null?void 0:t.config)!=null&&s.orgId&&!(r!=null&&r.version)){e({type:"SET_EVENTS",payload:{...r,version:true}});let f="1.2.12";await fe({origin:window.location.origin,version:f,orgId:t.config.orgId});}},"sendEvent")();},[(n=t==null?void 0:t.config)==null?void 0:n.orgId]);},"useTrackVersion");var _e=(0,chunk_ZUAULJT6.a)(i=>typeof i=="function"?i():i||"USD","getDefaultActiveCurrency"),de=(0,chunk_ZUAULJT6.a)(i=>({priceFormat:i.priceFormat||"dollars",ig:null,organizationId:i.organizationId,exclusions:[],unassigned:[],expIds:[],storefrontApiToken:i.storefrontApiToken,activeCurrencyCode:_e(i.activeCurrencyCode),priceRegex:new RegExp("\\d{1,3}(?:[.,]?\\d{0,3})*(?:[.,]?\\d{0,3})?","mu"),antiFlicker:i.antiFlicker||false,events:{cartOrCheckoutToken:false,track:false,version:false}}),"initialReducerState"),ue=(0,chunk_ZUAULJT6.a)((i,e)=>{switch(e.type){case "SET_PRICE_FORMAT":i.priceFormat=e.payload;break;case "SET_IG":i.ig=e.payload;break;case "SET_ORGANIZATION_ID":i.organizationId=e.payload;break;case "SET_EXCLUSIONS":i.exclusions=e.payload;break;case "SET_UNASSIGNED":i.unassigned=e.payload;break;case "SET_STOREFRONT_API_TOKEN":i.storefrontApiToken=e.payload;break;case "SET_ACTIVE_CURRENCY_CODE":i.activeCurrencyCode=e.payload;break;case "SET_PRICE_REGEX":i.priceRegex=e.payload;break;case "SET_ANTI_FLICKER":i.antiFlicker=e.payload;break;case "SET_EVENTS":i.events=e.payload;break;}},"IntelligemsReducer");var Oe=(0,chunk_ZUAULJT6.a)(({children:i})=>(le(),i),"InnerProvider"),J=(0,chunk_ZUAULJT6.a)(i=>{let[e,t]=(0,use_immer_module/* useImmer */.x)({WidgetComponent:null,isLoaded:false}),[r,n]=(0,use_immer_module/* useImmerReducer */.C)(ue,de(i));(0,react.useEffect)(()=>{var s;(s=r.ig)!=null&&s.integration&&(window.igConfig=i.ig.config||void 0),i.activeCurrencyCode&&(typeof i.activeCurrencyCode=="string"?window.__igCurrency=i.activeCurrencyCode:window.__igCurrency=i.activeCurrencyCode());},[]),(0,react.useEffect)(()=>{var g,l,m,C;if(!i.ig||!i.ig.id||!i.ig.config)return;let s=i.ig;chunk_ZUAULJT6.q.setCookiesStorage(((l=(g=s.config)==null?void 0:g.options)==null?void 0:l.domain)||window.location.hostname||void 0,chunk_ZUAULJT6.j.ID_COOKIE_DAYS_TO_LIVE);let{unassigned:f,exclusions:u}=(0,chunk_ZUAULJT6.w)(s);n({type:"SET_IG",payload:s}),n({type:"SET_EXCLUSIONS",payload:u}),n({type:"SET_UNASSIGNED",payload:f}),n({type:"SET_PRICE_REGEX",payload:(0,chunk_ZUAULJT6.o)(((m=s==null?void 0:s.config)==null?void 0:m.options.locale)||"en-US",((C=s==null?void 0:s.config)==null?void 0:C.options.currencyFormat)||{options:{},symbol:"$",suffix:"",removeTrailingZeros:false})});},[i.ig]),(0,react.useEffect)(()=>{__webpack_require__.e(/* import() */ 91).then(__webpack_require__.bind(__webpack_require__, 12091)).then(s=>{t(f=>{f.WidgetComponent=s.Widget,f.isLoaded=true;});}).catch(s=>{console.error("Failed to load Widget component:",s),t(f=>{f.isLoaded=true;});});},[]);let a$1=(0,chunk_ZUAULJT6.a)(()=>e.isLoaded&&e.WidgetComponent?react.createElement(e.WidgetComponent,{noShadowRoot:i.noShadowRoot}):null,"renderWidget");return (0,react.useEffect)(()=>{var s,f;i.client&&i.ig.experiences&&((s=i.ig.config)!=null&&s.onsiteInjections)&&P.applyCustomProperties(i.ig.experiences,((f=i.ig.config)==null?void 0:f.onsiteInjections)||[],new A(i.client));},[i.ig,i.client]),react.createElement(chunk_ZUAULJT6.f.Provider,{value:{data:{...r,ig:i.ig},client:i.client,dispatchData:n}},a$1(),react.createElement(Oe,null,i.children||null))},"ClientsideContextProvider");var Re=/([\p{Ll}\d])(\p{Lu})/gu,Ke=/(\p{Lu})([\p{Lu}][\p{Ll}])/gu,Ae=/(\d)\p{Ll}|(\p{L})\d/u,Ne=/[^\p{L}\d]+/giu,ge="$1\0$2",me="";function he(i){let e=i.trim();e=e.replace(Re,ge).replace(Ke,ge),e=e.replace(Ne,"\0");let t=0,r=e.length;for(;e.charAt(t)==="\0";)t++;if(t===r)return [];for(;e.charAt(r-1)==="\0";)r--;return e.slice(t,r).split(/\0/g)}(0,chunk_ZUAULJT6.a)(he,"split");function Ue(i){var t;let e=he(i);for(let r=0;r<e.length;r++){let n=e[r],a=Ae.exec(n);if(a){let s=a.index+((t=a[1])!=null?t:a[2]).length;e.splice(r,1,n.slice(0,s),n.slice(s));}}return e}(0,chunk_ZUAULJT6.a)(Ue,"splitSeparateNumbers");function De(i,e){var a;let[t,r,n]=pe(i,e);return t+r.map(Ce(e==null?void 0:e.locale)).join((a=e==null?void 0:e.delimiter)!=null?a:" ")+n}(0,chunk_ZUAULJT6.a)(De,"noCase");function U(i,e){var u;let[t,r,n]=pe(i,e),a=Ce(e==null?void 0:e.locale),s=Fe(e==null?void 0:e.locale),f=e!=null&&e.mergeAmbiguousCharacters?Ve(a,s):Ge(a,s);return t+r.map((g,l)=>l===0?a(g):f(g,l)).join((u=e==null?void 0:e.delimiter)!=null?u:"")+n}(0,chunk_ZUAULJT6.a)(U,"camelCase");function D(i,e){return De(i,{delimiter:"-",...e})}(0,chunk_ZUAULJT6.a)(D,"kebabCase");function Ce(i){return i===false?e=>e.toLowerCase():e=>e.toLocaleLowerCase(i)}(0,chunk_ZUAULJT6.a)(Ce,"lowerFactory");function Fe(i){return i===false?e=>e.toUpperCase():e=>e.toLocaleUpperCase(i)}(0,chunk_ZUAULJT6.a)(Fe,"upperFactory");function Ve(i,e){return t=>`${e(t[0])}${i(t.slice(1))}`}(0,chunk_ZUAULJT6.a)(Ve,"capitalCaseTransformFactory");function Ge(i,e){return (t,r)=>{let n=t[0];return (r>0&&n>="0"&&n<="9"?"_"+n:e(n))+i(t.slice(1))}}(0,chunk_ZUAULJT6.a)(Ge,"pascalCaseTransformFactory");function pe(i,e={}){var f,u,g;let t=(f=e.split)!=null?f:e.separateNumbers?Ue:he,r=(u=e.prefixCharacters)!=null?u:me,n=(g=e.suffixCharacters)!=null?g:me,a=0,s=i.length;for(;a<i.length;){let l=i.charAt(a);if(!r.includes(l))break;a++;}for(;s>a;){let l=s-1,m=i.charAt(l);if(!n.includes(m))break;s=l;}return [i.slice(0,a),t(i.slice(a,s)),i.slice(s)]}(0,chunk_ZUAULJT6.a)(pe,"splitPrefixSuffix");var d=class d{constructor(e$1){(0,chunk_ZUAULJT6.e)(this,"url");(0,chunk_ZUAULJT6.e)(this,"params");(0,chunk_ZUAULJT6.e)(this,"allCookies");(0,chunk_ZUAULJT6.e)(this,"igCookies");(0,chunk_ZUAULJT6.e)(this,"domain");(0,chunk_ZUAULJT6.e)(this,"allowedKeys",["id","preview","integration","previewTraffic","ignored","vars","pv","fv"]);(0,chunk_ZUAULJT6.e)(this,"geoLocation",null);(0,chunk_ZUAULJT6.e)(this,"trafficMessages",{});(0,chunk_ZUAULJT6.e)(this,"addTrafficMessage",(0,chunk_ZUAULJT6.a)((e,t)=>{this.trafficMessages[e]=t;},"addTrafficMessage"));(0,chunk_ZUAULJT6.e)(this,"getTrafficMessage",(0,chunk_ZUAULJT6.a)(e=>this.trafficMessages[e],"getTrafficMessage"));this.url=e$1.url,this.params=e$1.params;}getIgCookies(e){let t={...this.allCookies,cookies:e},r=Object.keys(t).filter(a=>a.startsWith(d.cookiePrefix)).reduce((a,s)=>{let f=t[s],u=D(s.split(`${d.cookiePrefix}`)[1]);return {...a,...typeof f!="undefined"&&typeof u!="undefined"&&{[u]:f}}},{}),n={};for(let[a,s]of Object.entries(r)){let f=U(a);this.allowedKeys.includes(f)&&(n[f]=s);}this.igCookies=n;}parseCookiesObject(e){let t={};for(let[r,n]of Object.entries(e))t[r]=n?(0,chunk_ZUAULJT6.z)(n):void 0;return t}cookieCtxKey(e){return `${d.cookiePrefix}${D(e)}`}static unCookieCtxKey(e){return e.startsWith(d.cookiePrefix)?U(e.substring(d.cookiePrefix.length)):e}static headerCtxKey(e){return `${d.hashPrefix}${D(e)}`}static unHeaderCtxKey(e){return e.startsWith(d.hashPrefix)?U(e.substring(d.hashPrefix.length)):e}getFromIgHeaders(e,t){let r=d.headerCtxKey(t);return e.get(r)}static decode(e){return e?Buffer.from(e,"base64").toString("utf-8"):""}static encode(e){return btoa(e)}getIgId(){return chunk_ZUAULJT6.y.getIdFromIgCookies(this.igCookies)}getFirstVisit(){return chunk_ZUAULJT6.y.getFirstVisit(this.setCookie.bind(this),this.igCookies)}getIsFirstVisit(){return chunk_ZUAULJT6.y.getIsFirstVisit(this.setCookie.bind(this))}getPreviewValue(){return this.url.searchParams.get(chunk_ZUAULJT6.k.PREVIEW_KEY)||this.igCookies.preview}getIsPreviewTrue(){return this.getPreviewValue()==="true"}getPreviewedEntityState(){var r;let e=((r=JSON.parse(sessionStorage.getItem(chunk_ZUAULJT6.k.BUILDER_KEY)||"{}"))==null?void 0:r.experienceId)||null,t=this.url.searchParams.get(chunk_ZUAULJT6.k.PREVIEW_KEY);return t&&t!==e?(chunk_ZUAULJT6.p.setItem(chunk_ZUAULJT6.k.BUILDER_KEY,JSON.stringify({experienceId:t})),t):e}getIntegration(){let e=this.url.searchParams.get(chunk_ZUAULJT6.k.INTEGRATION_KEY)||this.igCookies.integration;return e==="true"||e===true}getPreviewTraffic(){return this.igCookies.previewTraffic===true}getVars(){let e=this.getIgCookie("exps",true),t=this.getIgCookie("vars",true);return cjs(e||{},t||{})}getIgnored(){return this.igCookies.ignored||{}}maybeCancelState(e){this.getIgCookie(e)==="false"&&this.deleteIgCookie(e);}maybeCancelPreview(){this.maybeCancelState(d.isPreviewKey);}maybeCancelIntegration(){this.maybeCancelState(d.isIntegrationKey);}maybeCancelPreviewTraffic(){this.maybeCancelState(d.isPreviewTrafficKey);}};(0,chunk_ZUAULJT6.a)(d,"BaseClient"),(0,chunk_ZUAULJT6.e)(d,"cookiePrefix","ig-"),(0,chunk_ZUAULJT6.e)(d,"hashPrefix",""),(0,chunk_ZUAULJT6.e)(d,"isPreviewKey","preview"),(0,chunk_ZUAULJT6.e)(d,"isIntegrationKey","integration"),(0,chunk_ZUAULJT6.e)(d,"isPreviewTrafficKey","previewTraffic");var F=d;var V=class V extends F{constructor(){let e=new URL(window.location.href),t=e.searchParams;super({url:e,params:t}),this.parseRequestCookies(js_cookie/* default.get */.Z.get()),this.getIgCookies({...Object.fromEntries(t)});}static init(){let e=new V;return chunk_ZUAULJT6.r.client=e,e}getCookieDomain(){return this.domain||window.location.hostname?`.${this.domain||window.location.hostname}`:void 0}parseRequestCookies(e){this.allCookies=this.parseCookiesObject(e);}getCookie(e){return js_cookie/* default.get */.Z.get(e)||void 0}setCookie(e,t){js_cookie/* default.set */.Z.set(e,t,{domain:this.getCookieDomain(),expires:365});}deleteCookie(e){js_cookie/* default.remove */.Z.remove(e,{domain:this.getCookieDomain()});}deleteIgCookie(e){js_cookie/* default.remove */.Z.remove(this.cookieCtxKey(e),{domain:window.location.hostname?"."+window.location.hostname:void 0});}getIgCookie(e,t=false){let r=js_cookie/* default.get */.Z.get(this.cookieCtxKey(e));if(r)return t?JSON.parse(r):r}setIgCookie(e,t){t&&this.setCookie(this.cookieCtxKey(e),typeof t=="string"?t:lib(t));}setIgCookies(e){let t=e||this.igCookies;for(let[r,n]of Object.entries(t)){if(r==="id"){let a=new URL(window.location.href),s=a.searchParams.get("igId");if(s){a.searchParams.delete("igId"),history.replaceState({},"",a.href),this.setIgCookie(r,s);continue}}this.allowedKeys.includes(r)&&this.setIgCookie(r,n);}this.maybeCancelPreview(),this.maybeCancelIntegration(),this.maybeCancelPreviewTraffic();}getGeoLocation(){if(this.geoLocation!==null)return this.geoLocation;let e=js_cookie/* default.get */.Z.get(chunk_ZUAULJT6.k.GEO_LOCATION_COOKIE);if(!e){this.geoLocation=void 0;return}return this.geoLocation=JSON.parse(e),this.geoLocation}};(0,chunk_ZUAULJT6.a)(V,"ReactClient");var _=V;var Y=class Y{constructor(e$1,t){(0,chunk_ZUAULJT6.e)(this,"orgId");(0,chunk_ZUAULJT6.e)(this,"settings");(0,chunk_ZUAULJT6.e)(this,"isPreviewTrue");(0,chunk_ZUAULJT6.e)(this,"preview");(0,chunk_ZUAULJT6.e)(this,"integration");(0,chunk_ZUAULJT6.e)(this,"previewTraffic");(0,chunk_ZUAULJT6.e)(this,"igId");(0,chunk_ZUAULJT6.e)(this,"firstVisit");(0,chunk_ZUAULJT6.e)(this,"config");(0,chunk_ZUAULJT6.e)(this,"client");this.client=e$1,this.orgId=t.orgId,this.settings=t,this.isPreviewTrue=this.client.getIsPreviewTrue(),this.preview=this.client.getPreviewedEntityState(),this.integration=this.client.getIntegration(),this.previewTraffic=this.client.getPreviewTraffic(),this.igId=this.client.getIgId(),this.firstVisit=this.client.getFirstVisit();}async getHeadlessConfig(e){if(!this.orgId)throw Error("Org Id Missing!");return chunk_ZUAULJT6.v.getIntelligemsConfig(e)}async buildUpdatedIgUserContextFromConfig(e){chunk_ZUAULJT6.m.init();let t$1=(0,chunk_ZUAULJT6.a)(()=>{let m=this.client.getVars(),C=this.client.getIgnored();return {vars:m,ignored:Object.keys(C).length?C:void 0}},"getVars"),r=await this.getHeadlessConfig({orgId:this.orgId,cacheIntervalMinutes:4,config:e.config});"GEO_LOCATION"in r&&this.client.setCookie(chunk_ZUAULJT6.k.GEO_LOCATION_COOKIE,JSON.stringify(r.GEO_LOCATION));let n={id:this.igId,isPreviewTrue:this.isPreviewTrue,preview:this.preview||void 0,fv:this.firstVisit,pv:void 0,integration:this.integration?true:void 0,previewTraffic:this.previewTraffic?true:void 0,originalSlug:this.client.url.pathname.split("/").pop()||void 0,...t$1()},{experiences:a$1,exclusionGroups:s$1,offers:f}=(0,chunk_ZUAULJT6.t)(this.client,{config:r,...n,id:this.igId,vars:n.vars||{},ignored:n.ignored||{}}),u$1={};for(let m of a$1){let C=chunk_ZUAULJT6.s.getVariation(m,this.client);C&&(u$1[(0,chunk_ZUAULJT6.g)(m.id)]=C.shortId);}let g$1=t$1(),l=cjs(u$1,g$1.vars);return n={...n,vars:l,ignored:g$1.ignored},this.client.domain=window.location.hostname,this.client.setIgCookies(n),{context:n,config:r,experiences:(0,chunk_ZUAULJT6.u)(a$1,n.vars),exclusionGroups:s$1,offers:f}}};(0,chunk_ZUAULJT6.a)(Y,"Context");var G=Y;var H=class H extends G{constructor(t,r){super(t,r);(0,chunk_ZUAULJT6.e)(this,"client");this.client=t;}async initialize(t){return this.buildUpdatedIgUserContextFromConfig(t)}};(0,chunk_ZUAULJT6.a)(H,"ReactContext");var b=H;var He=(0,chunk_ZUAULJT6.a)(i=>{let[e,t]=(0,use_immer_module/* useImmer */.x)(null),[r,n$1]=(0,use_immer_module/* useImmer */.x)({config:null,exclusionGroups:[],experiences:[],fv:void 0,id:void 0,ignored:void 0,integration:void 0,isPreviewTrue:false,offers:[],originalSlug:void 0,preview:void 0,previewTraffic:false,pv:void 0,vars:{}}),{children:a$1,...s}=i,f=(0,react.useRef)(false);return (0,react.useEffect)(()=>{(0,chunk_ZUAULJT6.n)()?t(null):t(_.init());},[]),(0,react.useEffect)(()=>{if(f.current||!e)return;f.current=true,(0,chunk_ZUAULJT6.a)(async()=>{let g=new b(e,{orgId:i.organizationId,cacheIntervalMinutes:i.cacheIntervalMinutes,config:i.config}),{context:l,config:m,experiences:C,offers:xe,exclusionGroups:we}=await g.initialize({config:i.config});n$1({config:m,exclusionGroups:we,experiences:C,fv:l.fv||void 0,id:l.id||void 0,ignored:l.ignored||void 0,integration:l.integration||void 0,isPreviewTrue:l.isPreviewTrue||false,offers:xe,originalSlug:l.originalSlug||void 0,preview:l.preview||void 0,previewTraffic:l.previewTraffic||void 0,pv:l.pv||void 0,vars:l.vars||void 0});},"buildContext")();},[e]),react.createElement(J,{ig:r,client:e,...s},a$1)},"IntelligemsReactProvider");
;// CONCATENATED MODULE: ../node_modules/@intelligems/headless/dist/pack.mjs
var C=(0,chunk_ZUAULJT6.a)(({cartOrCheckoutToken:o,currency:s,country:u})=>{let{data:x,dispatchData:I,client:a$1}=(0,react.useContext)(chunk_ZUAULJT6.f),{ig:r,unassigned:k,exclusions:v}=x||{};(0,chunk_ZUAULJT6.G)(),(0,chunk_ZUAULJT6.E)(),(0,chunk_ZUAULJT6.C)(o);let E$1=(0,chunk_ZUAULJT6.a)((e,c)=>{a$1&&c?(chunk_ZUAULJT6.y._id=e.id,chunk_ZUAULJT6.y.trackOnce(a$1,{url:c,ig:e,ignored:e.ignored||{},experiences:e.experiences,unassigned:k,exclusions:v,dispatchData:I,exclusionGroups:e.exclusionGroups,isGoogleBot:false,cartOrCheckoutToken:o||null,country:u,currency:s})):chunk_ZUAULJT6.i.error("No IG ID found in cookies");},"onRouteChangeDone");(0,react.useEffect)(()=>{var e;if(chunk_ZUAULJT6.i.info("Track Event Hook Triggered"),!(r!=null&&r.config)){chunk_ZUAULJT6.i.info("Track skipped - no `ig` found");return}E$1(r,(e=window==null?void 0:window.location)==null?void 0:e.pathname);},[r]);},"useIgTrack");var pack_G=(0,chunk_ZUAULJT6.a)(o=>{let{children:s}=o;return react.createElement(He,o,react.createElement(react.Fragment,null,react.createElement("div",{style:{display:"none"},id:"ig-headless-version","data-ig-headless-version":"1.2.12"}),s))},"IntelligemsPackProvider");

/***/ }),

/***/ 10719:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 23842:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ }),

/***/ 17599:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}


/***/ }),

/***/ 82126:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 85034:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpread; }
/* harmony export */ });
/* harmony import */ var _define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17599);


function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      (0,_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    });
  }

  return target;
}

/***/ }),

/***/ 70169:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}

/***/ }),

/***/ 31373:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ../node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ../node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 52050:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ../node_modules/@swc/helpers/src/_array_with_holes.mjs
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(82126);
;// CONCATENATED MODULE: ../node_modules/@swc/helpers/src/_non_iterable_rest.mjs
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(12164);
;// CONCATENATED MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs





function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr, i) || (0,_unsupported_iterable_to_array/* default */.Z)(arr, i) || _nonIterableRest();
}


/***/ }),

/***/ 18952:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _throw; }
/* harmony export */ });
function _throw(e) {
    throw e;
}

/***/ }),

/***/ 3204:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(10719);
;// CONCATENATED MODULE: ../node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(82126);
;// CONCATENATED MODULE: ../node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(12164);
;// CONCATENATED MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ }),

/***/ 12164:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10719);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ }),

/***/ 13305:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "OQ": function() { return /* binding */ Zm; },
/* harmony export */   "VL": function() { return /* binding */ Wm; },
/* harmony export */   "g1": function() { return /* binding */ Km; },
/* harmony export */   "ol": function() { return /* binding */ Jm; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);

const fn = (t) => t && Object.keys(t).length === 0 && t.constructor === Object;
function hn(t) {
  const e = {};
  if (!Array.isArray(t))
    return e;
  for (const r of t)
    r && r.name && r.enabled && (e[r.name] = r);
  return e;
}
const dn = (t) => {
  if (!t)
    return {};
  const e = (n) => Array.isArray(n) ? n.reduce((a, { namespace: s, key: i, value: o }) => (a[s] ? a[s][i] = o : a[s] = {
    [i]: o
  }, a), {}) : n, r = Object.entries(t).reduce((n, [a, s]) => (n[a] = fn(s) ? null : s, n), {});
  return t.product && (t.product.metafields && (r.product.metafields = e(
    t.product.metafields
  )), t.product.sourceCollection && t.product.sourceCollection.metafields && (r.product.sourceCollection.metafields = e(
    t.product.sourceCollection.metafields
  ))), t.collection && t.collection.metafields && (r.collection.metafields = e(
    t.collection.metafields
  )), t.customer && t.customer.metafields && (r.customer.metafields = e(
    t.customer.metafields
  )), t.integrations && (r.integrations = hn(t.integrations)), r;
}, pn = () => {
  let t = {};
  return {
    get variables() {
      return t;
    },
    setVariables: (r = {}) => {
      t = {
        ...t,
        ...dn(r)
      };
    }
  };
};
let mn = (t = 21) => crypto.getRandomValues(new Uint8Array(t)).reduce((e, r) => (r &= 63, r < 36 ? e += r.toString(36) : r < 62 ? e += (r - 26).toString(36).toUpperCase() : r > 62 ? e += "-" : e += "_", e), "");
var De;
try {
  De = Map;
} catch {
}
var Pe;
try {
  Pe = Set;
} catch {
}
function er(t, e, r) {
  if (!t || typeof t != "object" || typeof t == "function")
    return t;
  if (t.nodeType && "cloneNode" in t)
    return t.cloneNode(!0);
  if (t instanceof Date)
    return new Date(t.getTime());
  if (t instanceof RegExp)
    return new RegExp(t);
  if (Array.isArray(t))
    return t.map(Ne);
  if (De && t instanceof De)
    return new Map(Array.from(t.entries()));
  if (Pe && t instanceof Pe)
    return new Set(Array.from(t.values()));
  if (t instanceof Object) {
    e.push(t);
    var n = Object.create(t);
    r.push(n);
    for (var a in t) {
      var s = e.findIndex(function(i) {
        return i === t[a];
      });
      n[a] = s > -1 ? r[s] : er(t[a], e, r);
    }
    return n;
  }
  return t;
}
function Ne(t) {
  return er(t, [], []);
}
const yn = Object.prototype.toString, vn = Error.prototype.toString, gn = RegExp.prototype.toString, _n = typeof Symbol < "u" ? Symbol.prototype.toString : () => "", bn = /^Symbol\((.*)\)(.*)$/;
function $n(t) {
  return t != +t ? "NaN" : t === 0 && 1 / t < 0 ? "-0" : "" + t;
}
function ot(t, e = !1) {
  if (t == null || t === !0 || t === !1)
    return "" + t;
  const r = typeof t;
  if (r === "number")
    return $n(t);
  if (r === "string")
    return e ? `"${t}"` : t;
  if (r === "function")
    return "[Function " + (t.name || "anonymous") + "]";
  if (r === "symbol")
    return _n.call(t).replace(bn, "Symbol($1)");
  const n = yn.call(t).slice(8, -1);
  return n === "Date" ? isNaN(t.getTime()) ? "" + t : t.toISOString(t) : n === "Error" || t instanceof Error ? "[" + vn.call(t) + "]" : n === "RegExp" ? gn.call(t) : null;
}
function V(t, e) {
  let r = ot(t, e);
  return r !== null ? r : JSON.stringify(t, function(n, a) {
    let s = ot(this[n], e);
    return s !== null ? s : a;
  }, 2);
}
let j = {
  default: "${path} is invalid",
  required: "${path} is a required field",
  oneOf: "${path} must be one of the following values: ${values}",
  notOneOf: "${path} must not be one of the following values: ${values}",
  notType: ({
    path: t,
    type: e,
    value: r,
    originalValue: n
  }) => {
    let a = n != null && n !== r, s = `${t} must be a \`${e}\` type, but the final value was: \`${V(r, !0)}\`` + (a ? ` (cast from the value \`${V(n, !0)}\`).` : ".");
    return r === null && (s += '\n If "null" is intended as an empty value be sure to mark the schema as `.nullable()`'), s;
  },
  defined: "${path} must be defined"
}, O = {
  length: "${path} must be exactly ${length} characters",
  min: "${path} must be at least ${min} characters",
  max: "${path} must be at most ${max} characters",
  matches: '${path} must match the following: "${regex}"',
  email: "${path} must be a valid email",
  url: "${path} must be a valid URL",
  uuid: "${path} must be a valid UUID",
  trim: "${path} must be a trimmed string",
  lowercase: "${path} must be a lowercase string",
  uppercase: "${path} must be a upper case string"
}, N = {
  min: "${path} must be greater than or equal to ${min}",
  max: "${path} must be less than or equal to ${max}",
  lessThan: "${path} must be less than ${less}",
  moreThan: "${path} must be greater than ${more}",
  positive: "${path} must be a positive number",
  negative: "${path} must be a negative number",
  integer: "${path} must be an integer"
}, Re = {
  min: "${path} field must be later than ${min}",
  max: "${path} field must be at earlier than ${max}"
}, Ie = {
  isValue: "${path} field must be ${value}"
}, Me = {
  noUnknown: "${path} field has unspecified keys: ${unknown}"
}, ce = {
  min: "${path} field must have at least ${min} items",
  max: "${path} field must have less than or equal to ${max} items",
  length: "${path} must have ${length} items"
};
Object.assign(/* @__PURE__ */ Object.create(null), {
  mixed: j,
  string: O,
  number: N,
  date: Re,
  object: Me,
  array: ce,
  boolean: Ie
});
var ae = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, xn = Object.prototype, wn = xn.hasOwnProperty;
function En(t, e) {
  return t != null && wn.call(t, e);
}
var Fn = En, Sn = Array.isArray, I = Sn, Tn = typeof ae == "object" && ae && ae.Object === Object && ae, tr = Tn, An = tr, On = typeof self == "object" && self && self.Object === Object && self, Cn = An || On || Function("return this")(), P = Cn, Dn = P, Pn = Dn.Symbol, ge = Pn, ut = ge, rr = Object.prototype, Nn = rr.hasOwnProperty, Rn = rr.toString, X = ut ? ut.toStringTag : void 0;
function In(t) {
  var e = Nn.call(t, X), r = t[X];
  try {
    t[X] = void 0;
    var n = !0;
  } catch {
  }
  var a = Rn.call(t);
  return n && (e ? t[X] = r : delete t[X]), a;
}
var Mn = In, jn = Object.prototype, Un = jn.toString;
function Ln(t) {
  return Un.call(t);
}
var qn = Ln, ct = ge, kn = Mn, zn = qn, Gn = "[object Null]", Hn = "[object Undefined]", lt = ct ? ct.toStringTag : void 0;
function Vn(t) {
  return t == null ? t === void 0 ? Hn : Gn : lt && lt in Object(t) ? kn(t) : zn(t);
}
var te = Vn;
function Bn(t) {
  return t != null && typeof t == "object";
}
var re = Bn, Kn = te, Wn = re, Jn = "[object Symbol]";
function Zn(t) {
  return typeof t == "symbol" || Wn(t) && Kn(t) == Jn;
}
var We = Zn, Yn = I, Xn = We, Qn = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, ea = /^\w*$/;
function ta(t, e) {
  if (Yn(t))
    return !1;
  var r = typeof t;
  return r == "number" || r == "symbol" || r == "boolean" || t == null || Xn(t) ? !0 : ea.test(t) || !Qn.test(t) || e != null && t in Object(e);
}
var Je = ta;
function ra(t) {
  var e = typeof t;
  return t != null && (e == "object" || e == "function");
}
var Ze = ra, na = te, aa = Ze, sa = "[object AsyncFunction]", ia = "[object Function]", oa = "[object GeneratorFunction]", ua = "[object Proxy]";
function ca(t) {
  if (!aa(t))
    return !1;
  var e = na(t);
  return e == ia || e == oa || e == sa || e == ua;
}
var nr = ca, la = P, fa = la["__core-js_shared__"], ha = fa, Se = ha, ft = function() {
  var t = /[^.]+$/.exec(Se && Se.keys && Se.keys.IE_PROTO || "");
  return t ? "Symbol(src)_1." + t : "";
}();
function da(t) {
  return !!ft && ft in t;
}
var pa = da, ma = Function.prototype, ya = ma.toString;
function va(t) {
  if (t != null) {
    try {
      return ya.call(t);
    } catch {
    }
    try {
      return t + "";
    } catch {
    }
  }
  return "";
}
var ar = va, ga = nr, _a = pa, ba = Ze, $a = ar, xa = /[\\^$.*+?()[\]{}|]/g, wa = /^\[object .+?Constructor\]$/, Ea = Function.prototype, Fa = Object.prototype, Sa = Ea.toString, Ta = Fa.hasOwnProperty, Aa = RegExp(
  "^" + Sa.call(Ta).replace(xa, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Oa(t) {
  if (!ba(t) || _a(t))
    return !1;
  var e = ga(t) ? Aa : wa;
  return e.test($a(t));
}
var Ca = Oa;
function Da(t, e) {
  return t == null ? void 0 : t[e];
}
var Pa = Da, Na = Ca, Ra = Pa;
function Ia(t, e) {
  var r = Ra(t, e);
  return Na(r) ? r : void 0;
}
var k = Ia, Ma = k, ja = Ma(Object, "create"), _e = ja, ht = _e;
function Ua() {
  this.__data__ = ht ? ht(null) : {}, this.size = 0;
}
var La = Ua;
function qa(t) {
  var e = this.has(t) && delete this.__data__[t];
  return this.size -= e ? 1 : 0, e;
}
var ka = qa, za = _e, Ga = "__lodash_hash_undefined__", Ha = Object.prototype, Va = Ha.hasOwnProperty;
function Ba(t) {
  var e = this.__data__;
  if (za) {
    var r = e[t];
    return r === Ga ? void 0 : r;
  }
  return Va.call(e, t) ? e[t] : void 0;
}
var Ka = Ba, Wa = _e, Ja = Object.prototype, Za = Ja.hasOwnProperty;
function Ya(t) {
  var e = this.__data__;
  return Wa ? e[t] !== void 0 : Za.call(e, t);
}
var Xa = Ya, Qa = _e, es = "__lodash_hash_undefined__";
function ts(t, e) {
  var r = this.__data__;
  return this.size += this.has(t) ? 0 : 1, r[t] = Qa && e === void 0 ? es : e, this;
}
var rs = ts, ns = La, as = ka, ss = Ka, is = Xa, os = rs;
function B(t) {
  var e = -1, r = t == null ? 0 : t.length;
  for (this.clear(); ++e < r; ) {
    var n = t[e];
    this.set(n[0], n[1]);
  }
}
B.prototype.clear = ns;
B.prototype.delete = as;
B.prototype.get = ss;
B.prototype.has = is;
B.prototype.set = os;
var us = B;
function cs() {
  this.__data__ = [], this.size = 0;
}
var ls = cs;
function fs(t, e) {
  return t === e || t !== t && e !== e;
}
var sr = fs, hs = sr;
function ds(t, e) {
  for (var r = t.length; r--; )
    if (hs(t[r][0], e))
      return r;
  return -1;
}
var be = ds, ps = be, ms = Array.prototype, ys = ms.splice;
function vs(t) {
  var e = this.__data__, r = ps(e, t);
  if (r < 0)
    return !1;
  var n = e.length - 1;
  return r == n ? e.pop() : ys.call(e, r, 1), --this.size, !0;
}
var gs = vs, _s = be;
function bs(t) {
  var e = this.__data__, r = _s(e, t);
  return r < 0 ? void 0 : e[r][1];
}
var $s = bs, xs = be;
function ws(t) {
  return xs(this.__data__, t) > -1;
}
var Es = ws, Fs = be;
function Ss(t, e) {
  var r = this.__data__, n = Fs(r, t);
  return n < 0 ? (++this.size, r.push([t, e])) : r[n][1] = e, this;
}
var Ts = Ss, As = ls, Os = gs, Cs = $s, Ds = Es, Ps = Ts;
function K(t) {
  var e = -1, r = t == null ? 0 : t.length;
  for (this.clear(); ++e < r; ) {
    var n = t[e];
    this.set(n[0], n[1]);
  }
}
K.prototype.clear = As;
K.prototype.delete = Os;
K.prototype.get = Cs;
K.prototype.has = Ds;
K.prototype.set = Ps;
var $e = K, Ns = k, Rs = P, Is = Ns(Rs, "Map"), Ye = Is, dt = us, Ms = $e, js = Ye;
function Us() {
  this.size = 0, this.__data__ = {
    hash: new dt(),
    map: new (js || Ms)(),
    string: new dt()
  };
}
var Ls = Us;
function qs(t) {
  var e = typeof t;
  return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? t !== "__proto__" : t === null;
}
var ks = qs, zs = ks;
function Gs(t, e) {
  var r = t.__data__;
  return zs(e) ? r[typeof e == "string" ? "string" : "hash"] : r.map;
}
var xe = Gs, Hs = xe;
function Vs(t) {
  var e = Hs(this, t).delete(t);
  return this.size -= e ? 1 : 0, e;
}
var Bs = Vs, Ks = xe;
function Ws(t) {
  return Ks(this, t).get(t);
}
var Js = Ws, Zs = xe;
function Ys(t) {
  return Zs(this, t).has(t);
}
var Xs = Ys, Qs = xe;
function ei(t, e) {
  var r = Qs(this, t), n = r.size;
  return r.set(t, e), this.size += r.size == n ? 0 : 1, this;
}
var ti = ei, ri = Ls, ni = Bs, ai = Js, si = Xs, ii = ti;
function W(t) {
  var e = -1, r = t == null ? 0 : t.length;
  for (this.clear(); ++e < r; ) {
    var n = t[e];
    this.set(n[0], n[1]);
  }
}
W.prototype.clear = ri;
W.prototype.delete = ni;
W.prototype.get = ai;
W.prototype.has = si;
W.prototype.set = ii;
var Xe = W, ir = Xe, oi = "Expected a function";
function Qe(t, e) {
  if (typeof t != "function" || e != null && typeof e != "function")
    throw new TypeError(oi);
  var r = function() {
    var n = arguments, a = e ? e.apply(this, n) : n[0], s = r.cache;
    if (s.has(a))
      return s.get(a);
    var i = t.apply(this, n);
    return r.cache = s.set(a, i) || s, i;
  };
  return r.cache = new (Qe.Cache || ir)(), r;
}
Qe.Cache = ir;
var ui = Qe, ci = ui, li = 500;
function fi(t) {
  var e = ci(t, function(n) {
    return r.size === li && r.clear(), n;
  }), r = e.cache;
  return e;
}
var hi = fi, di = hi, pi = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, mi = /\\(\\)?/g, yi = di(function(t) {
  var e = [];
  return t.charCodeAt(0) === 46 && e.push(""), t.replace(pi, function(r, n, a, s) {
    e.push(a ? s.replace(mi, "$1") : n || r);
  }), e;
}), vi = yi;
function gi(t, e) {
  for (var r = -1, n = t == null ? 0 : t.length, a = Array(n); ++r < n; )
    a[r] = e(t[r], r, t);
  return a;
}
var _i = gi, pt = ge, bi = _i, $i = I, xi = We, wi = 1 / 0, mt = pt ? pt.prototype : void 0, yt = mt ? mt.toString : void 0;
function or(t) {
  if (typeof t == "string")
    return t;
  if ($i(t))
    return bi(t, or) + "";
  if (xi(t))
    return yt ? yt.call(t) : "";
  var e = t + "";
  return e == "0" && 1 / t == -wi ? "-0" : e;
}
var Ei = or, Fi = Ei;
function Si(t) {
  return t == null ? "" : Fi(t);
}
var ne = Si, Ti = I, Ai = Je, Oi = vi, Ci = ne;
function Di(t, e) {
  return Ti(t) ? t : Ai(t, e) ? [t] : Oi(Ci(t));
}
var ur = Di, Pi = te, Ni = re, Ri = "[object Arguments]";
function Ii(t) {
  return Ni(t) && Pi(t) == Ri;
}
var Mi = Ii, vt = Mi, ji = re, cr = Object.prototype, Ui = cr.hasOwnProperty, Li = cr.propertyIsEnumerable, qi = vt(function() {
  return arguments;
}()) ? vt : function(t) {
  return ji(t) && Ui.call(t, "callee") && !Li.call(t, "callee");
}, lr = qi, ki = 9007199254740991, zi = /^(?:0|[1-9]\d*)$/;
function Gi(t, e) {
  var r = typeof t;
  return e = e ?? ki, !!e && (r == "number" || r != "symbol" && zi.test(t)) && t > -1 && t % 1 == 0 && t < e;
}
var fr = Gi, Hi = 9007199254740991;
function Vi(t) {
  return typeof t == "number" && t > -1 && t % 1 == 0 && t <= Hi;
}
var et = Vi, Bi = We, Ki = 1 / 0;
function Wi(t) {
  if (typeof t == "string" || Bi(t))
    return t;
  var e = t + "";
  return e == "0" && 1 / t == -Ki ? "-0" : e;
}
var we = Wi, Ji = ur, Zi = lr, Yi = I, Xi = fr, Qi = et, eo = we;
function to(t, e, r) {
  e = Ji(e, t);
  for (var n = -1, a = e.length, s = !1; ++n < a; ) {
    var i = eo(e[n]);
    if (!(s = t != null && r(t, i)))
      break;
    t = t[i];
  }
  return s || ++n != a ? s : (a = t == null ? 0 : t.length, !!a && Qi(a) && Xi(i, a) && (Yi(t) || Zi(t)));
}
var hr = to, ro = Fn, no = hr;
function ao(t, e) {
  return t != null && no(t, e, ro);
}
var le = ao;
const tt = (t) => t && t.__isYupSchema__;
class so {
  constructor(e, r) {
    if (this.fn = void 0, this.refs = e, this.refs = e, typeof r == "function") {
      this.fn = r;
      return;
    }
    if (!le(r, "is"))
      throw new TypeError("`is:` is required for `when()` conditions");
    if (!r.then && !r.otherwise)
      throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
    let {
      is: n,
      then: a,
      otherwise: s
    } = r, i = typeof n == "function" ? n : (...o) => o.every((u) => u === n);
    this.fn = function(...o) {
      let u = o.pop(), c = o.pop(), f = i(...o) ? a : s;
      if (f)
        return typeof f == "function" ? f(c) : c.concat(f.resolve(u));
    };
  }
  resolve(e, r) {
    let n = this.refs.map((s) => s.getValue(r == null ? void 0 : r.value, r == null ? void 0 : r.parent, r == null ? void 0 : r.context)), a = this.fn.apply(e, n.concat(e, r));
    if (a === void 0 || a === e)
      return e;
    if (!tt(a))
      throw new TypeError("conditions must return a schema object");
    return a.resolve(r);
  }
}
function dr(t) {
  return t == null ? [] : [].concat(t);
}
function je() {
  return je = Object.assign || function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, je.apply(this, arguments);
}
let io = /\$\{\s*(\w+)\s*\}/g;
class E extends Error {
  static formatError(e, r) {
    const n = r.label || r.path || "this";
    return n !== r.path && (r = je({}, r, {
      path: n
    })), typeof e == "string" ? e.replace(io, (a, s) => V(r[s])) : typeof e == "function" ? e(r) : e;
  }
  static isError(e) {
    return e && e.name === "ValidationError";
  }
  constructor(e, r, n, a) {
    super(), this.value = void 0, this.path = void 0, this.type = void 0, this.errors = void 0, this.params = void 0, this.inner = void 0, this.name = "ValidationError", this.value = r, this.path = n, this.type = a, this.errors = [], this.inner = [], dr(e).forEach((s) => {
      E.isError(s) ? (this.errors.push(...s.errors), this.inner = this.inner.concat(s.inner.length ? s.inner : s)) : this.errors.push(s);
    }), this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0], Error.captureStackTrace && Error.captureStackTrace(this, E);
  }
}
const oo = (t) => {
  let e = !1;
  return (...r) => {
    e || (e = !0, t(...r));
  };
};
function fe(t, e) {
  let {
    endEarly: r,
    tests: n,
    args: a,
    value: s,
    errors: i,
    sort: o,
    path: u
  } = t, c = oo(e), f = n.length;
  const l = [];
  if (i = i || [], !f)
    return i.length ? c(new E(i, s, u)) : c(null, s);
  for (let h = 0; h < n.length; h++) {
    const p = n[h];
    p(a, function(y) {
      if (y) {
        if (!E.isError(y))
          return c(y, s);
        if (r)
          return y.value = s, c(y, s);
        l.push(y);
      }
      if (--f <= 0) {
        if (l.length && (o && l.sort(o), i.length && l.push(...i), i = l), i.length) {
          c(new E(i, s, u), s);
          return;
        }
        c(null, s);
      }
    });
  }
}
var uo = k, co = function() {
  try {
    var t = uo(Object, "defineProperty");
    return t({}, "", {}), t;
  } catch {
  }
}(), lo = co, gt = lo;
function fo(t, e, r) {
  e == "__proto__" && gt ? gt(t, e, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : t[e] = r;
}
var pr = fo;
function ho(t) {
  return function(e, r, n) {
    for (var a = -1, s = Object(e), i = n(e), o = i.length; o--; ) {
      var u = i[t ? o : ++a];
      if (r(s[u], u, s) === !1)
        break;
    }
    return e;
  };
}
var po = ho, mo = po, yo = mo(), vo = yo;
function go(t, e) {
  for (var r = -1, n = Array(t); ++r < t; )
    n[r] = e(r);
  return n;
}
var _o = go, ee = {}, bo = {
  get exports() {
    return ee;
  },
  set exports(t) {
    ee = t;
  }
};
function $o() {
  return !1;
}
var xo = $o;
(function(t, e) {
  var r = P, n = xo, a = e && !e.nodeType && e, s = a && !0 && t && !t.nodeType && t, i = s && s.exports === a, o = i ? r.Buffer : void 0, u = o ? o.isBuffer : void 0, c = u || n;
  t.exports = c;
})(bo, ee);
var wo = te, Eo = et, Fo = re, So = "[object Arguments]", To = "[object Array]", Ao = "[object Boolean]", Oo = "[object Date]", Co = "[object Error]", Do = "[object Function]", Po = "[object Map]", No = "[object Number]", Ro = "[object Object]", Io = "[object RegExp]", Mo = "[object Set]", jo = "[object String]", Uo = "[object WeakMap]", Lo = "[object ArrayBuffer]", qo = "[object DataView]", ko = "[object Float32Array]", zo = "[object Float64Array]", Go = "[object Int8Array]", Ho = "[object Int16Array]", Vo = "[object Int32Array]", Bo = "[object Uint8Array]", Ko = "[object Uint8ClampedArray]", Wo = "[object Uint16Array]", Jo = "[object Uint32Array]", _ = {};
_[ko] = _[zo] = _[Go] = _[Ho] = _[Vo] = _[Bo] = _[Ko] = _[Wo] = _[Jo] = !0;
_[So] = _[To] = _[Lo] = _[Ao] = _[qo] = _[Oo] = _[Co] = _[Do] = _[Po] = _[No] = _[Ro] = _[Io] = _[Mo] = _[jo] = _[Uo] = !1;
function Zo(t) {
  return Fo(t) && Eo(t.length) && !!_[wo(t)];
}
var Yo = Zo;
function Xo(t) {
  return function(e) {
    return t(e);
  };
}
var Qo = Xo, he = {}, eu = {
  get exports() {
    return he;
  },
  set exports(t) {
    he = t;
  }
};
(function(t, e) {
  var r = tr, n = e && !e.nodeType && e, a = n && !0 && t && !t.nodeType && t, s = a && a.exports === n, i = s && r.process, o = function() {
    try {
      var u = a && a.require && a.require("util").types;
      return u || i && i.binding && i.binding("util");
    } catch {
    }
  }();
  t.exports = o;
})(eu, he);
var tu = Yo, ru = Qo, _t = he, bt = _t && _t.isTypedArray, nu = bt ? ru(bt) : tu, mr = nu, au = _o, su = lr, iu = I, ou = ee, uu = fr, cu = mr, lu = Object.prototype, fu = lu.hasOwnProperty;
function hu(t, e) {
  var r = iu(t), n = !r && su(t), a = !r && !n && ou(t), s = !r && !n && !a && cu(t), i = r || n || a || s, o = i ? au(t.length, String) : [], u = o.length;
  for (var c in t)
    (e || fu.call(t, c)) && !(i && // Safari 9 has enumerable `arguments.length` in strict mode.
    (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    a && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    s && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
    uu(c, u))) && o.push(c);
  return o;
}
var du = hu, pu = Object.prototype;
function mu(t) {
  var e = t && t.constructor, r = typeof e == "function" && e.prototype || pu;
  return t === r;
}
var yu = mu;
function vu(t, e) {
  return function(r) {
    return t(e(r));
  };
}
var gu = vu, _u = gu, bu = _u(Object.keys, Object), $u = bu, xu = yu, wu = $u, Eu = Object.prototype, Fu = Eu.hasOwnProperty;
function Su(t) {
  if (!xu(t))
    return wu(t);
  var e = [];
  for (var r in Object(t))
    Fu.call(t, r) && r != "constructor" && e.push(r);
  return e;
}
var Tu = Su, Au = nr, Ou = et;
function Cu(t) {
  return t != null && Ou(t.length) && !Au(t);
}
var Du = Cu, Pu = du, Nu = Tu, Ru = Du;
function Iu(t) {
  return Ru(t) ? Pu(t) : Nu(t);
}
var rt = Iu, Mu = vo, ju = rt;
function Uu(t, e) {
  return t && Mu(t, e, ju);
}
var yr = Uu, Lu = $e;
function qu() {
  this.__data__ = new Lu(), this.size = 0;
}
var ku = qu;
function zu(t) {
  var e = this.__data__, r = e.delete(t);
  return this.size = e.size, r;
}
var Gu = zu;
function Hu(t) {
  return this.__data__.get(t);
}
var Vu = Hu;
function Bu(t) {
  return this.__data__.has(t);
}
var Ku = Bu, Wu = $e, Ju = Ye, Zu = Xe, Yu = 200;
function Xu(t, e) {
  var r = this.__data__;
  if (r instanceof Wu) {
    var n = r.__data__;
    if (!Ju || n.length < Yu - 1)
      return n.push([t, e]), this.size = ++r.size, this;
    r = this.__data__ = new Zu(n);
  }
  return r.set(t, e), this.size = r.size, this;
}
var Qu = Xu, ec = $e, tc = ku, rc = Gu, nc = Vu, ac = Ku, sc = Qu;
function J(t) {
  var e = this.__data__ = new ec(t);
  this.size = e.size;
}
J.prototype.clear = tc;
J.prototype.delete = rc;
J.prototype.get = nc;
J.prototype.has = ac;
J.prototype.set = sc;
var vr = J, ic = "__lodash_hash_undefined__";
function oc(t) {
  return this.__data__.set(t, ic), this;
}
var uc = oc;
function cc(t) {
  return this.__data__.has(t);
}
var lc = cc, fc = Xe, hc = uc, dc = lc;
function de(t) {
  var e = -1, r = t == null ? 0 : t.length;
  for (this.__data__ = new fc(); ++e < r; )
    this.add(t[e]);
}
de.prototype.add = de.prototype.push = hc;
de.prototype.has = dc;
var pc = de;
function mc(t, e) {
  for (var r = -1, n = t == null ? 0 : t.length; ++r < n; )
    if (e(t[r], r, t))
      return !0;
  return !1;
}
var yc = mc;
function vc(t, e) {
  return t.has(e);
}
var gc = vc, _c = pc, bc = yc, $c = gc, xc = 1, wc = 2;
function Ec(t, e, r, n, a, s) {
  var i = r & xc, o = t.length, u = e.length;
  if (o != u && !(i && u > o))
    return !1;
  var c = s.get(t), f = s.get(e);
  if (c && f)
    return c == e && f == t;
  var l = -1, h = !0, p = r & wc ? new _c() : void 0;
  for (s.set(t, e), s.set(e, t); ++l < o; ) {
    var m = t[l], y = e[l];
    if (n)
      var g = i ? n(y, m, l, e, t, s) : n(m, y, l, t, e, s);
    if (g !== void 0) {
      if (g)
        continue;
      h = !1;
      break;
    }
    if (p) {
      if (!bc(e, function($, F) {
        if (!$c(p, F) && (m === $ || a(m, $, r, n, s)))
          return p.push(F);
      })) {
        h = !1;
        break;
      }
    } else if (!(m === y || a(m, y, r, n, s))) {
      h = !1;
      break;
    }
  }
  return s.delete(t), s.delete(e), h;
}
var gr = Ec, Fc = P, Sc = Fc.Uint8Array, Tc = Sc;
function Ac(t) {
  var e = -1, r = Array(t.size);
  return t.forEach(function(n, a) {
    r[++e] = [a, n];
  }), r;
}
var Oc = Ac;
function Cc(t) {
  var e = -1, r = Array(t.size);
  return t.forEach(function(n) {
    r[++e] = n;
  }), r;
}
var Dc = Cc, $t = ge, xt = Tc, Pc = sr, Nc = gr, Rc = Oc, Ic = Dc, Mc = 1, jc = 2, Uc = "[object Boolean]", Lc = "[object Date]", qc = "[object Error]", kc = "[object Map]", zc = "[object Number]", Gc = "[object RegExp]", Hc = "[object Set]", Vc = "[object String]", Bc = "[object Symbol]", Kc = "[object ArrayBuffer]", Wc = "[object DataView]", wt = $t ? $t.prototype : void 0, Te = wt ? wt.valueOf : void 0;
function Jc(t, e, r, n, a, s, i) {
  switch (r) {
    case Wc:
      if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset)
        return !1;
      t = t.buffer, e = e.buffer;
    case Kc:
      return !(t.byteLength != e.byteLength || !s(new xt(t), new xt(e)));
    case Uc:
    case Lc:
    case zc:
      return Pc(+t, +e);
    case qc:
      return t.name == e.name && t.message == e.message;
    case Gc:
    case Vc:
      return t == e + "";
    case kc:
      var o = Rc;
    case Hc:
      var u = n & Mc;
      if (o || (o = Ic), t.size != e.size && !u)
        return !1;
      var c = i.get(t);
      if (c)
        return c == e;
      n |= jc, i.set(t, e);
      var f = Nc(o(t), o(e), n, a, s, i);
      return i.delete(t), f;
    case Bc:
      if (Te)
        return Te.call(t) == Te.call(e);
  }
  return !1;
}
var Zc = Jc;
function Yc(t, e) {
  for (var r = -1, n = e.length, a = t.length; ++r < n; )
    t[a + r] = e[r];
  return t;
}
var Xc = Yc, Qc = Xc, el = I;
function tl(t, e, r) {
  var n = e(t);
  return el(t) ? n : Qc(n, r(t));
}
var rl = tl;
function nl(t, e) {
  for (var r = -1, n = t == null ? 0 : t.length, a = 0, s = []; ++r < n; ) {
    var i = t[r];
    e(i, r, t) && (s[a++] = i);
  }
  return s;
}
var al = nl;
function sl() {
  return [];
}
var il = sl, ol = al, ul = il, cl = Object.prototype, ll = cl.propertyIsEnumerable, Et = Object.getOwnPropertySymbols, fl = Et ? function(t) {
  return t == null ? [] : (t = Object(t), ol(Et(t), function(e) {
    return ll.call(t, e);
  }));
} : ul, hl = fl, dl = rl, pl = hl, ml = rt;
function yl(t) {
  return dl(t, ml, pl);
}
var vl = yl, Ft = vl, gl = 1, _l = Object.prototype, bl = _l.hasOwnProperty;
function $l(t, e, r, n, a, s) {
  var i = r & gl, o = Ft(t), u = o.length, c = Ft(e), f = c.length;
  if (u != f && !i)
    return !1;
  for (var l = u; l--; ) {
    var h = o[l];
    if (!(i ? h in e : bl.call(e, h)))
      return !1;
  }
  var p = s.get(t), m = s.get(e);
  if (p && m)
    return p == e && m == t;
  var y = !0;
  s.set(t, e), s.set(e, t);
  for (var g = i; ++l < u; ) {
    h = o[l];
    var $ = t[h], F = e[h];
    if (n)
      var C = i ? n(F, $, h, e, t, s) : n($, F, h, t, e, s);
    if (!(C === void 0 ? $ === F || a($, F, r, n, s) : C)) {
      y = !1;
      break;
    }
    g || (g = h == "constructor");
  }
  if (y && !g) {
    var S = t.constructor, D = e.constructor;
    S != D && "constructor" in t && "constructor" in e && !(typeof S == "function" && S instanceof S && typeof D == "function" && D instanceof D) && (y = !1);
  }
  return s.delete(t), s.delete(e), y;
}
var xl = $l, wl = k, El = P, Fl = wl(El, "DataView"), Sl = Fl, Tl = k, Al = P, Ol = Tl(Al, "Promise"), Cl = Ol, Dl = k, Pl = P, Nl = Dl(Pl, "Set"), Rl = Nl, Il = k, Ml = P, jl = Il(Ml, "WeakMap"), Ul = jl, Ue = Sl, Le = Ye, qe = Cl, ke = Rl, ze = Ul, _r = te, Z = ar, St = "[object Map]", Ll = "[object Object]", Tt = "[object Promise]", At = "[object Set]", Ot = "[object WeakMap]", Ct = "[object DataView]", ql = Z(Ue), kl = Z(Le), zl = Z(qe), Gl = Z(ke), Hl = Z(ze), U = _r;
(Ue && U(new Ue(new ArrayBuffer(1))) != Ct || Le && U(new Le()) != St || qe && U(qe.resolve()) != Tt || ke && U(new ke()) != At || ze && U(new ze()) != Ot) && (U = function(t) {
  var e = _r(t), r = e == Ll ? t.constructor : void 0, n = r ? Z(r) : "";
  if (n)
    switch (n) {
      case ql:
        return Ct;
      case kl:
        return St;
      case zl:
        return Tt;
      case Gl:
        return At;
      case Hl:
        return Ot;
    }
  return e;
});
var Vl = U, Ae = vr, Bl = gr, Kl = Zc, Wl = xl, Dt = Vl, Pt = I, Nt = ee, Jl = mr, Zl = 1, Rt = "[object Arguments]", It = "[object Array]", se = "[object Object]", Yl = Object.prototype, Mt = Yl.hasOwnProperty;
function Xl(t, e, r, n, a, s) {
  var i = Pt(t), o = Pt(e), u = i ? It : Dt(t), c = o ? It : Dt(e);
  u = u == Rt ? se : u, c = c == Rt ? se : c;
  var f = u == se, l = c == se, h = u == c;
  if (h && Nt(t)) {
    if (!Nt(e))
      return !1;
    i = !0, f = !1;
  }
  if (h && !f)
    return s || (s = new Ae()), i || Jl(t) ? Bl(t, e, r, n, a, s) : Kl(t, e, u, r, n, a, s);
  if (!(r & Zl)) {
    var p = f && Mt.call(t, "__wrapped__"), m = l && Mt.call(e, "__wrapped__");
    if (p || m) {
      var y = p ? t.value() : t, g = m ? e.value() : e;
      return s || (s = new Ae()), a(y, g, r, n, s);
    }
  }
  return h ? (s || (s = new Ae()), Wl(t, e, r, n, a, s)) : !1;
}
var Ql = Xl, ef = Ql, jt = re;
function br(t, e, r, n, a) {
  return t === e ? !0 : t == null || e == null || !jt(t) && !jt(e) ? t !== t && e !== e : ef(t, e, r, n, br, a);
}
var $r = br, tf = vr, rf = $r, nf = 1, af = 2;
function sf(t, e, r, n) {
  var a = r.length, s = a, i = !n;
  if (t == null)
    return !s;
  for (t = Object(t); a--; ) {
    var o = r[a];
    if (i && o[2] ? o[1] !== t[o[0]] : !(o[0] in t))
      return !1;
  }
  for (; ++a < s; ) {
    o = r[a];
    var u = o[0], c = t[u], f = o[1];
    if (i && o[2]) {
      if (c === void 0 && !(u in t))
        return !1;
    } else {
      var l = new tf();
      if (n)
        var h = n(c, f, u, t, e, l);
      if (!(h === void 0 ? rf(f, c, nf | af, n, l) : h))
        return !1;
    }
  }
  return !0;
}
var of = sf, uf = Ze;
function cf(t) {
  return t === t && !uf(t);
}
var xr = cf, lf = xr, ff = rt;
function hf(t) {
  for (var e = ff(t), r = e.length; r--; ) {
    var n = e[r], a = t[n];
    e[r] = [n, a, lf(a)];
  }
  return e;
}
var df = hf;
function pf(t, e) {
  return function(r) {
    return r == null ? !1 : r[t] === e && (e !== void 0 || t in Object(r));
  };
}
var wr = pf, mf = of, yf = df, vf = wr;
function gf(t) {
  var e = yf(t);
  return e.length == 1 && e[0][2] ? vf(e[0][0], e[0][1]) : function(r) {
    return r === t || mf(r, t, e);
  };
}
var _f = gf, bf = ur, $f = we;
function xf(t, e) {
  e = bf(e, t);
  for (var r = 0, n = e.length; t != null && r < n; )
    t = t[$f(e[r++])];
  return r && r == n ? t : void 0;
}
var Er = xf, wf = Er;
function Ef(t, e, r) {
  var n = t == null ? void 0 : wf(t, e);
  return n === void 0 ? r : n;
}
var Ff = Ef;
function Sf(t, e) {
  return t != null && e in Object(t);
}
var Tf = Sf, Af = Tf, Of = hr;
function Cf(t, e) {
  return t != null && Of(t, e, Af);
}
var Df = Cf, Pf = $r, Nf = Ff, Rf = Df, If = Je, Mf = xr, jf = wr, Uf = we, Lf = 1, qf = 2;
function kf(t, e) {
  return If(t) && Mf(e) ? jf(Uf(t), e) : function(r) {
    var n = Nf(r, t);
    return n === void 0 && n === e ? Rf(r, t) : Pf(e, n, Lf | qf);
  };
}
var zf = kf;
function Gf(t) {
  return t;
}
var Hf = Gf;
function Vf(t) {
  return function(e) {
    return e == null ? void 0 : e[t];
  };
}
var Bf = Vf, Kf = Er;
function Wf(t) {
  return function(e) {
    return Kf(e, t);
  };
}
var Jf = Wf, Zf = Bf, Yf = Jf, Xf = Je, Qf = we;
function eh(t) {
  return Xf(t) ? Zf(Qf(t)) : Yf(t);
}
var th = eh, rh = _f, nh = zf, ah = Hf, sh = I, ih = th;
function oh(t) {
  return typeof t == "function" ? t : t == null ? ah : typeof t == "object" ? sh(t) ? nh(t[0], t[1]) : rh(t) : ih(t);
}
var Fr = oh, uh = pr, ch = yr, lh = Fr;
function fh(t, e) {
  var r = {};
  return e = lh(e), ch(t, function(n, a, s) {
    uh(r, a, e(n, a, s));
  }), r;
}
var Sr = fh;
function z(t) {
  this._maxSize = t, this.clear();
}
z.prototype.clear = function() {
  this._size = 0, this._values = /* @__PURE__ */ Object.create(null);
};
z.prototype.get = function(t) {
  return this._values[t];
};
z.prototype.set = function(t, e) {
  return this._size >= this._maxSize && this.clear(), t in this._values || this._size++, this._values[t] = e;
};
var hh = /[^.^\]^[]+|(?=\[\]|\.\.)/g, Tr = /^\d+$/, dh = /^\d/, ph = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, mh = /^\s*(['"]?)(.*?)(\1)\s*$/, nt = 512, Ut = new z(nt), Lt = new z(nt), qt = new z(nt), Ee = {
  Cache: z,
  split: Ge,
  normalizePath: Oe,
  setter: function(t) {
    var e = Oe(t);
    return Lt.get(t) || Lt.set(t, function(n, a) {
      for (var s = 0, i = e.length, o = n; s < i - 1; ) {
        var u = e[s];
        if (u === "__proto__" || u === "constructor" || u === "prototype")
          return n;
        o = o[e[s++]];
      }
      o[e[s]] = a;
    });
  },
  getter: function(t, e) {
    var r = Oe(t);
    return qt.get(t) || qt.set(t, function(a) {
      for (var s = 0, i = r.length; s < i; )
        if (a != null || !e)
          a = a[r[s++]];
        else
          return;
      return a;
    });
  },
  join: function(t) {
    return t.reduce(function(e, r) {
      return e + (at(r) || Tr.test(r) ? "[" + r + "]" : (e ? "." : "") + r);
    }, "");
  },
  forEach: function(t, e, r) {
    yh(Array.isArray(t) ? t : Ge(t), e, r);
  }
};
function Oe(t) {
  return Ut.get(t) || Ut.set(
    t,
    Ge(t).map(function(e) {
      return e.replace(mh, "$2");
    })
  );
}
function Ge(t) {
  return t.match(hh) || [""];
}
function yh(t, e, r) {
  var n = t.length, a, s, i, o;
  for (s = 0; s < n; s++)
    a = t[s], a && (_h(a) && (a = '"' + a + '"'), o = at(a), i = !o && /^\d+$/.test(a), e.call(r, a, o, i, s, t));
}
function at(t) {
  return typeof t == "string" && t && ["'", '"'].indexOf(t.charAt(0)) !== -1;
}
function vh(t) {
  return t.match(dh) && !t.match(Tr);
}
function gh(t) {
  return ph.test(t);
}
function _h(t) {
  return !at(t) && (vh(t) || gh(t));
}
const ie = {
  context: "$",
  value: "."
};
class R {
  constructor(e, r = {}) {
    if (this.key = void 0, this.isContext = void 0, this.isValue = void 0, this.isSibling = void 0, this.path = void 0, this.getter = void 0, this.map = void 0, typeof e != "string")
      throw new TypeError("ref must be a string, got: " + e);
    if (this.key = e.trim(), e === "")
      throw new TypeError("ref must be a non-empty string");
    this.isContext = this.key[0] === ie.context, this.isValue = this.key[0] === ie.value, this.isSibling = !this.isContext && !this.isValue;
    let n = this.isContext ? ie.context : this.isValue ? ie.value : "";
    this.path = this.key.slice(n.length), this.getter = this.path && Ee.getter(this.path, !0), this.map = r.map;
  }
  getValue(e, r, n) {
    let a = this.isContext ? n : this.isValue ? e : r;
    return this.getter && (a = this.getter(a || {})), this.map && (a = this.map(a)), a;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */
  cast(e, r) {
    return this.getValue(e, r == null ? void 0 : r.parent, r == null ? void 0 : r.context);
  }
  resolve() {
    return this;
  }
  describe() {
    return {
      type: "ref",
      key: this.key
    };
  }
  toString() {
    return `Ref(${this.key})`;
  }
  static isRef(e) {
    return e && e.__isYupRef;
  }
}
R.prototype.__isYupRef = !0;
function pe() {
  return pe = Object.assign || function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, pe.apply(this, arguments);
}
function bh(t, e) {
  if (t == null)
    return {};
  var r = {}, n = Object.keys(t), a, s;
  for (s = 0; s < n.length; s++)
    a = n[s], !(e.indexOf(a) >= 0) && (r[a] = t[a]);
  return r;
}
function oe(t) {
  function e(r, n) {
    let {
      value: a,
      path: s = "",
      label: i,
      options: o,
      originalValue: u,
      sync: c
    } = r, f = bh(r, ["value", "path", "label", "options", "originalValue", "sync"]);
    const {
      name: l,
      test: h,
      params: p,
      message: m
    } = t;
    let {
      parent: y,
      context: g
    } = o;
    function $(x) {
      return R.isRef(x) ? x.getValue(a, y, g) : x;
    }
    function F(x = {}) {
      const Fe = Sr(pe({
        value: a,
        originalValue: u,
        label: i,
        path: x.path || s
      }, p, x.params), $), st = new E(E.formatError(x.message || m, Fe), a, Fe.path, x.type || l);
      return st.params = Fe, st;
    }
    let C = pe({
      path: s,
      parent: y,
      type: l,
      createError: F,
      resolve: $,
      options: o,
      originalValue: u
    }, f);
    if (!c) {
      try {
        Promise.resolve(h.call(C, a, C)).then((x) => {
          E.isError(x) ? n(x) : x ? n(null, x) : n(F());
        }).catch(n);
      } catch (x) {
        n(x);
      }
      return;
    }
    let S;
    try {
      var D;
      if (S = h.call(C, a, C), typeof ((D = S) == null ? void 0 : D.then) == "function")
        throw new Error(`Validation test of type: "${C.type}" returned a Promise during a synchronous validate. This test will finish after the validate call has returned`);
    } catch (x) {
      n(x);
      return;
    }
    E.isError(S) ? n(S) : S ? n(null, S) : n(F());
  }
  return e.OPTIONS = t, e;
}
let $h = (t) => t.substr(0, t.length - 1).substr(1);
function xh(t, e, r, n = r) {
  let a, s, i;
  return e ? (Ee.forEach(e, (o, u, c) => {
    let f = u ? $h(o) : o;
    if (t = t.resolve({
      context: n,
      parent: a,
      value: r
    }), t.innerType) {
      let l = c ? parseInt(f, 10) : 0;
      if (r && l >= r.length)
        throw new Error(`Yup.reach cannot resolve an array item at index: ${o}, in the path: ${e}. because there is no value at that index. `);
      a = r, r = r && r[l], t = t.innerType;
    }
    if (!c) {
      if (!t.fields || !t.fields[f])
        throw new Error(`The schema does not contain the path: ${e}. (failed at: ${i} which is a type: "${t._type}")`);
      a = r, r = r && r[f], t = t.fields[f];
    }
    s = f, i = u ? "[" + o + "]" : "." + o;
  }), {
    schema: t,
    parent: a,
    parentPath: s
  }) : {
    parent: a,
    parentPath: e,
    schema: t
  };
}
class me {
  constructor() {
    this.list = void 0, this.refs = void 0, this.list = /* @__PURE__ */ new Set(), this.refs = /* @__PURE__ */ new Map();
  }
  get size() {
    return this.list.size + this.refs.size;
  }
  describe() {
    const e = [];
    for (const r of this.list)
      e.push(r);
    for (const [, r] of this.refs)
      e.push(r.describe());
    return e;
  }
  toArray() {
    return Array.from(this.list).concat(Array.from(this.refs.values()));
  }
  resolveAll(e) {
    return this.toArray().reduce((r, n) => r.concat(R.isRef(n) ? e(n) : n), []);
  }
  add(e) {
    R.isRef(e) ? this.refs.set(e.key, e) : this.list.add(e);
  }
  delete(e) {
    R.isRef(e) ? this.refs.delete(e.key) : this.list.delete(e);
  }
  clone() {
    const e = new me();
    return e.list = new Set(this.list), e.refs = new Map(this.refs), e;
  }
  merge(e, r) {
    const n = this.clone();
    return e.list.forEach((a) => n.add(a)), e.refs.forEach((a) => n.add(a)), r.list.forEach((a) => n.delete(a)), r.refs.forEach((a) => n.delete(a)), n;
  }
}
function A() {
  return A = Object.assign || function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, A.apply(this, arguments);
}
class w {
  constructor(e) {
    this.deps = [], this.tests = void 0, this.transforms = void 0, this.conditions = [], this._mutate = void 0, this._typeError = void 0, this._whitelist = new me(), this._blacklist = new me(), this.exclusiveTests = /* @__PURE__ */ Object.create(null), this.spec = void 0, this.tests = [], this.transforms = [], this.withMutation(() => {
      this.typeError(j.notType);
    }), this.type = (e == null ? void 0 : e.type) || "mixed", this.spec = A({
      strip: !1,
      strict: !1,
      abortEarly: !0,
      recursive: !0,
      nullable: !1,
      presence: "optional"
    }, e == null ? void 0 : e.spec);
  }
  // TODO: remove
  get _type() {
    return this.type;
  }
  _typeCheck(e) {
    return !0;
  }
  clone(e) {
    if (this._mutate)
      return e && Object.assign(this.spec, e), this;
    const r = Object.create(Object.getPrototypeOf(this));
    return r.type = this.type, r._typeError = this._typeError, r._whitelistError = this._whitelistError, r._blacklistError = this._blacklistError, r._whitelist = this._whitelist.clone(), r._blacklist = this._blacklist.clone(), r.exclusiveTests = A({}, this.exclusiveTests), r.deps = [...this.deps], r.conditions = [...this.conditions], r.tests = [...this.tests], r.transforms = [...this.transforms], r.spec = Ne(A({}, this.spec, e)), r;
  }
  label(e) {
    let r = this.clone();
    return r.spec.label = e, r;
  }
  meta(...e) {
    if (e.length === 0)
      return this.spec.meta;
    let r = this.clone();
    return r.spec.meta = Object.assign(r.spec.meta || {}, e[0]), r;
  }
  // withContext<TContext extends AnyObject>(): BaseSchema<
  //   TCast,
  //   TContext,
  //   TOutput
  // > {
  //   return this as any;
  // }
  withMutation(e) {
    let r = this._mutate;
    this._mutate = !0;
    let n = e(this);
    return this._mutate = r, n;
  }
  concat(e) {
    if (!e || e === this)
      return this;
    if (e.type !== this.type && this.type !== "mixed")
      throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${e.type}`);
    let r = this, n = e.clone();
    const a = A({}, r.spec, n.spec);
    return n.spec = a, n._typeError || (n._typeError = r._typeError), n._whitelistError || (n._whitelistError = r._whitelistError), n._blacklistError || (n._blacklistError = r._blacklistError), n._whitelist = r._whitelist.merge(e._whitelist, e._blacklist), n._blacklist = r._blacklist.merge(e._blacklist, e._whitelist), n.tests = r.tests, n.exclusiveTests = r.exclusiveTests, n.withMutation((s) => {
      e.tests.forEach((i) => {
        s.test(i.OPTIONS);
      });
    }), n.transforms = [...r.transforms, ...n.transforms], n;
  }
  isType(e) {
    return this.spec.nullable && e === null ? !0 : this._typeCheck(e);
  }
  resolve(e) {
    let r = this;
    if (r.conditions.length) {
      let n = r.conditions;
      r = r.clone(), r.conditions = [], r = n.reduce((a, s) => s.resolve(a, e), r), r = r.resolve(e);
    }
    return r;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {*=} options.parent
   * @param {*=} options.context
   */
  cast(e, r = {}) {
    let n = this.resolve(A({
      value: e
    }, r)), a = n._cast(e, r);
    if (e !== void 0 && r.assert !== !1 && n.isType(a) !== !0) {
      let s = V(e), i = V(a);
      throw new TypeError(`The value of ${r.path || "field"} could not be cast to a value that satisfies the schema type: "${n._type}". 

attempted value: ${s} 
` + (i !== s ? `result of cast: ${i}` : ""));
    }
    return a;
  }
  _cast(e, r) {
    let n = e === void 0 ? e : this.transforms.reduce((a, s) => s.call(this, a, e, this), e);
    return n === void 0 && (n = this.getDefault()), n;
  }
  _validate(e, r = {}, n) {
    let {
      sync: a,
      path: s,
      from: i = [],
      originalValue: o = e,
      strict: u = this.spec.strict,
      abortEarly: c = this.spec.abortEarly
    } = r, f = e;
    u || (f = this._cast(f, A({
      assert: !1
    }, r)));
    let l = {
      value: f,
      path: s,
      options: r,
      originalValue: o,
      schema: this,
      label: this.spec.label,
      sync: a,
      from: i
    }, h = [];
    this._typeError && h.push(this._typeError);
    let p = [];
    this._whitelistError && p.push(this._whitelistError), this._blacklistError && p.push(this._blacklistError), fe({
      args: l,
      value: f,
      path: s,
      sync: a,
      tests: h,
      endEarly: c
    }, (m) => {
      if (m)
        return void n(m, f);
      fe({
        tests: this.tests.concat(p),
        args: l,
        path: s,
        sync: a,
        value: f,
        endEarly: c
      }, n);
    });
  }
  validate(e, r, n) {
    let a = this.resolve(A({}, r, {
      value: e
    }));
    return typeof n == "function" ? a._validate(e, r, n) : new Promise((s, i) => a._validate(e, r, (o, u) => {
      o ? i(o) : s(u);
    }));
  }
  validateSync(e, r) {
    let n = this.resolve(A({}, r, {
      value: e
    })), a;
    return n._validate(e, A({}, r, {
      sync: !0
    }), (s, i) => {
      if (s)
        throw s;
      a = i;
    }), a;
  }
  isValid(e, r) {
    return this.validate(e, r).then(() => !0, (n) => {
      if (E.isError(n))
        return !1;
      throw n;
    });
  }
  isValidSync(e, r) {
    try {
      return this.validateSync(e, r), !0;
    } catch (n) {
      if (E.isError(n))
        return !1;
      throw n;
    }
  }
  _getDefault() {
    let e = this.spec.default;
    return e == null ? e : typeof e == "function" ? e.call(this) : Ne(e);
  }
  getDefault(e) {
    return this.resolve(e || {})._getDefault();
  }
  default(e) {
    return arguments.length === 0 ? this._getDefault() : this.clone({
      default: e
    });
  }
  strict(e = !0) {
    let r = this.clone();
    return r.spec.strict = e, r;
  }
  _isPresent(e) {
    return e != null;
  }
  defined(e = j.defined) {
    return this.test({
      message: e,
      name: "defined",
      exclusive: !0,
      test(r) {
        return r !== void 0;
      }
    });
  }
  required(e = j.required) {
    return this.clone({
      presence: "required"
    }).withMutation((r) => r.test({
      message: e,
      name: "required",
      exclusive: !0,
      test(n) {
        return this.schema._isPresent(n);
      }
    }));
  }
  notRequired() {
    let e = this.clone({
      presence: "optional"
    });
    return e.tests = e.tests.filter((r) => r.OPTIONS.name !== "required"), e;
  }
  nullable(e = !0) {
    return this.clone({
      nullable: e !== !1
    });
  }
  transform(e) {
    let r = this.clone();
    return r.transforms.push(e), r;
  }
  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */
  test(...e) {
    let r;
    if (e.length === 1 ? typeof e[0] == "function" ? r = {
      test: e[0]
    } : r = e[0] : e.length === 2 ? r = {
      name: e[0],
      test: e[1]
    } : r = {
      name: e[0],
      message: e[1],
      test: e[2]
    }, r.message === void 0 && (r.message = j.default), typeof r.test != "function")
      throw new TypeError("`test` is a required parameters");
    let n = this.clone(), a = oe(r), s = r.exclusive || r.name && n.exclusiveTests[r.name] === !0;
    if (r.exclusive && !r.name)
      throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
    return r.name && (n.exclusiveTests[r.name] = !!r.exclusive), n.tests = n.tests.filter((i) => !(i.OPTIONS.name === r.name && (s || i.OPTIONS.test === a.OPTIONS.test))), n.tests.push(a), n;
  }
  when(e, r) {
    !Array.isArray(e) && typeof e != "string" && (r = e, e = ".");
    let n = this.clone(), a = dr(e).map((s) => new R(s));
    return a.forEach((s) => {
      s.isSibling && n.deps.push(s.key);
    }), n.conditions.push(new so(a, r)), n;
  }
  typeError(e) {
    let r = this.clone();
    return r._typeError = oe({
      message: e,
      name: "typeError",
      test(n) {
        return n !== void 0 && !this.schema.isType(n) ? this.createError({
          params: {
            type: this.schema._type
          }
        }) : !0;
      }
    }), r;
  }
  oneOf(e, r = j.oneOf) {
    let n = this.clone();
    return e.forEach((a) => {
      n._whitelist.add(a), n._blacklist.delete(a);
    }), n._whitelistError = oe({
      message: r,
      name: "oneOf",
      test(a) {
        if (a === void 0)
          return !0;
        let s = this.schema._whitelist, i = s.resolveAll(this.resolve);
        return i.includes(a) ? !0 : this.createError({
          params: {
            values: s.toArray().join(", "),
            resolved: i
          }
        });
      }
    }), n;
  }
  notOneOf(e, r = j.notOneOf) {
    let n = this.clone();
    return e.forEach((a) => {
      n._blacklist.add(a), n._whitelist.delete(a);
    }), n._blacklistError = oe({
      message: r,
      name: "notOneOf",
      test(a) {
        let s = this.schema._blacklist, i = s.resolveAll(this.resolve);
        return i.includes(a) ? this.createError({
          params: {
            values: s.toArray().join(", "),
            resolved: i
          }
        }) : !0;
      }
    }), n;
  }
  strip(e = !0) {
    let r = this.clone();
    return r.spec.strip = e, r;
  }
  describe() {
    const e = this.clone(), {
      label: r,
      meta: n
    } = e.spec;
    return {
      meta: n,
      label: r,
      type: e.type,
      oneOf: e._whitelist.describe(),
      notOneOf: e._blacklist.describe(),
      tests: e.tests.map((s) => ({
        name: s.OPTIONS.name,
        params: s.OPTIONS.params
      })).filter((s, i, o) => o.findIndex((u) => u.name === s.name) === i)
    };
  }
}
w.prototype.__isYupSchema__ = !0;
for (const t of ["validate", "validateSync"])
  w.prototype[`${t}At`] = function(e, r, n = {}) {
    const {
      parent: a,
      parentPath: s,
      schema: i
    } = xh(this, e, r, n.context);
    return i[t](a && a[s], A({}, n, {
      parent: a,
      path: e
    }));
  };
for (const t of ["equals", "is"])
  w.prototype[t] = w.prototype.oneOf;
for (const t of ["not", "nope"])
  w.prototype[t] = w.prototype.notOneOf;
w.prototype.optional = w.prototype.notRequired;
const wh = w;
wh.prototype;
const b = (t) => t == null;
function Y() {
  return new Ar();
}
class Ar extends w {
  constructor() {
    super({
      type: "boolean"
    }), this.withMutation(() => {
      this.transform(function(e) {
        if (!this.isType(e)) {
          if (/^(true|1)$/i.test(String(e)))
            return !0;
          if (/^(false|0)$/i.test(String(e)))
            return !1;
        }
        return e;
      });
    });
  }
  _typeCheck(e) {
    return e instanceof Boolean && (e = e.valueOf()), typeof e == "boolean";
  }
  isTrue(e = Ie.isValue) {
    return this.test({
      message: e,
      name: "is-value",
      exclusive: !0,
      params: {
        value: "true"
      },
      test(r) {
        return b(r) || r === !0;
      }
    });
  }
  isFalse(e = Ie.isValue) {
    return this.test({
      message: e,
      name: "is-value",
      exclusive: !0,
      params: {
        value: "false"
      },
      test(r) {
        return b(r) || r === !1;
      }
    });
  }
}
Y.prototype = Ar.prototype;
let Eh = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i, Fh = /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i, Sh = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i, Th = (t) => b(t) || t === t.trim(), Ah = {}.toString();
function d() {
  return new Or();
}
class Or extends w {
  constructor() {
    super({
      type: "string"
    }), this.withMutation(() => {
      this.transform(function(e) {
        if (this.isType(e) || Array.isArray(e))
          return e;
        const r = e != null && e.toString ? e.toString() : e;
        return r === Ah ? e : r;
      });
    });
  }
  _typeCheck(e) {
    return e instanceof String && (e = e.valueOf()), typeof e == "string";
  }
  _isPresent(e) {
    return super._isPresent(e) && !!e.length;
  }
  length(e, r = O.length) {
    return this.test({
      message: r,
      name: "length",
      exclusive: !0,
      params: {
        length: e
      },
      test(n) {
        return b(n) || n.length === this.resolve(e);
      }
    });
  }
  min(e, r = O.min) {
    return this.test({
      message: r,
      name: "min",
      exclusive: !0,
      params: {
        min: e
      },
      test(n) {
        return b(n) || n.length >= this.resolve(e);
      }
    });
  }
  max(e, r = O.max) {
    return this.test({
      name: "max",
      exclusive: !0,
      message: r,
      params: {
        max: e
      },
      test(n) {
        return b(n) || n.length <= this.resolve(e);
      }
    });
  }
  matches(e, r) {
    let n = !1, a, s;
    return r && (typeof r == "object" ? {
      excludeEmptyString: n = !1,
      message: a,
      name: s
    } = r : a = r), this.test({
      name: s || "matches",
      message: a || O.matches,
      params: {
        regex: e
      },
      test: (i) => b(i) || i === "" && n || i.search(e) !== -1
    });
  }
  email(e = O.email) {
    return this.matches(Eh, {
      name: "email",
      message: e,
      excludeEmptyString: !0
    });
  }
  url(e = O.url) {
    return this.matches(Fh, {
      name: "url",
      message: e,
      excludeEmptyString: !0
    });
  }
  uuid(e = O.uuid) {
    return this.matches(Sh, {
      name: "uuid",
      message: e,
      excludeEmptyString: !1
    });
  }
  //-- transforms --
  ensure() {
    return this.default("").transform((e) => e === null ? "" : e);
  }
  trim(e = O.trim) {
    return this.transform((r) => r != null ? r.trim() : r).test({
      message: e,
      name: "trim",
      test: Th
    });
  }
  lowercase(e = O.lowercase) {
    return this.transform((r) => b(r) ? r : r.toLowerCase()).test({
      message: e,
      name: "string_case",
      exclusive: !0,
      test: (r) => b(r) || r === r.toLowerCase()
    });
  }
  uppercase(e = O.uppercase) {
    return this.transform((r) => b(r) ? r : r.toUpperCase()).test({
      message: e,
      name: "string_case",
      exclusive: !0,
      test: (r) => b(r) || r === r.toUpperCase()
    });
  }
}
d.prototype = Or.prototype;
let Oh = (t) => t != +t;
function Q() {
  return new Cr();
}
class Cr extends w {
  constructor() {
    super({
      type: "number"
    }), this.withMutation(() => {
      this.transform(function(e) {
        let r = e;
        if (typeof r == "string") {
          if (r = r.replace(/\s/g, ""), r === "")
            return NaN;
          r = +r;
        }
        return this.isType(r) ? r : parseFloat(r);
      });
    });
  }
  _typeCheck(e) {
    return e instanceof Number && (e = e.valueOf()), typeof e == "number" && !Oh(e);
  }
  min(e, r = N.min) {
    return this.test({
      message: r,
      name: "min",
      exclusive: !0,
      params: {
        min: e
      },
      test(n) {
        return b(n) || n >= this.resolve(e);
      }
    });
  }
  max(e, r = N.max) {
    return this.test({
      message: r,
      name: "max",
      exclusive: !0,
      params: {
        max: e
      },
      test(n) {
        return b(n) || n <= this.resolve(e);
      }
    });
  }
  lessThan(e, r = N.lessThan) {
    return this.test({
      message: r,
      name: "max",
      exclusive: !0,
      params: {
        less: e
      },
      test(n) {
        return b(n) || n < this.resolve(e);
      }
    });
  }
  moreThan(e, r = N.moreThan) {
    return this.test({
      message: r,
      name: "min",
      exclusive: !0,
      params: {
        more: e
      },
      test(n) {
        return b(n) || n > this.resolve(e);
      }
    });
  }
  positive(e = N.positive) {
    return this.moreThan(0, e);
  }
  negative(e = N.negative) {
    return this.lessThan(0, e);
  }
  integer(e = N.integer) {
    return this.test({
      name: "integer",
      message: e,
      test: (r) => b(r) || Number.isInteger(r)
    });
  }
  truncate() {
    return this.transform((e) => b(e) ? e : e | 0);
  }
  round(e) {
    var r;
    let n = ["ceil", "floor", "round", "trunc"];
    if (e = ((r = e) == null ? void 0 : r.toLowerCase()) || "round", e === "trunc")
      return this.truncate();
    if (n.indexOf(e.toLowerCase()) === -1)
      throw new TypeError("Only valid options for round() are: " + n.join(", "));
    return this.transform((a) => b(a) ? a : Math[e](a));
  }
}
Q.prototype = Cr.prototype;
var Ch = /^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
function Dh(t) {
  var e = [1, 4, 5, 6, 7, 10, 11], r = 0, n, a;
  if (a = Ch.exec(t)) {
    for (var s = 0, i; i = e[s]; ++s)
      a[i] = +a[i] || 0;
    a[2] = (+a[2] || 1) - 1, a[3] = +a[3] || 1, a[7] = a[7] ? String(a[7]).substr(0, 3) : 0, (a[8] === void 0 || a[8] === "") && (a[9] === void 0 || a[9] === "") ? n = +new Date(a[1], a[2], a[3], a[4], a[5], a[6], a[7]) : (a[8] !== "Z" && a[9] !== void 0 && (r = a[10] * 60 + a[11], a[9] === "+" && (r = 0 - r)), n = Date.UTC(a[1], a[2], a[3], a[4], a[5] + r, a[6], a[7]));
  } else
    n = Date.parse ? Date.parse(t) : NaN;
  return n;
}
let Dr = /* @__PURE__ */ new Date(""), Ph = (t) => Object.prototype.toString.call(t) === "[object Date]";
class Pr extends w {
  constructor() {
    super({
      type: "date"
    }), this.withMutation(() => {
      this.transform(function(e) {
        return this.isType(e) ? e : (e = Dh(e), isNaN(e) ? Dr : new Date(e));
      });
    });
  }
  _typeCheck(e) {
    return Ph(e) && !isNaN(e.getTime());
  }
  prepareParam(e, r) {
    let n;
    if (R.isRef(e))
      n = e;
    else {
      let a = this.cast(e);
      if (!this._typeCheck(a))
        throw new TypeError(`\`${r}\` must be a Date or a value that can be \`cast()\` to a Date`);
      n = a;
    }
    return n;
  }
  min(e, r = Re.min) {
    let n = this.prepareParam(e, "min");
    return this.test({
      message: r,
      name: "min",
      exclusive: !0,
      params: {
        min: e
      },
      test(a) {
        return b(a) || a >= this.resolve(n);
      }
    });
  }
  max(e, r = Re.max) {
    let n = this.prepareParam(e, "max");
    return this.test({
      message: r,
      name: "max",
      exclusive: !0,
      params: {
        max: e
      },
      test(a) {
        return b(a) || a <= this.resolve(n);
      }
    });
  }
}
Pr.INVALID_DATE = Dr;
Pr.prototype;
function Nh(t, e, r, n) {
  var a = -1, s = t == null ? 0 : t.length;
  for (n && s && (r = t[++a]); ++a < s; )
    r = e(r, t[a], a, t);
  return r;
}
var Rh = Nh;
function Ih(t) {
  return function(e) {
    return t == null ? void 0 : t[e];
  };
}
var Mh = Ih, jh = Mh, Uh = {
  // Latin-1 Supplement block.
  À: "A",
  Á: "A",
  Â: "A",
  Ã: "A",
  Ä: "A",
  Å: "A",
  à: "a",
  á: "a",
  â: "a",
  ã: "a",
  ä: "a",
  å: "a",
  Ç: "C",
  ç: "c",
  Ð: "D",
  ð: "d",
  È: "E",
  É: "E",
  Ê: "E",
  Ë: "E",
  è: "e",
  é: "e",
  ê: "e",
  ë: "e",
  Ì: "I",
  Í: "I",
  Î: "I",
  Ï: "I",
  ì: "i",
  í: "i",
  î: "i",
  ï: "i",
  Ñ: "N",
  ñ: "n",
  Ò: "O",
  Ó: "O",
  Ô: "O",
  Õ: "O",
  Ö: "O",
  Ø: "O",
  ò: "o",
  ó: "o",
  ô: "o",
  õ: "o",
  ö: "o",
  ø: "o",
  Ù: "U",
  Ú: "U",
  Û: "U",
  Ü: "U",
  ù: "u",
  ú: "u",
  û: "u",
  ü: "u",
  Ý: "Y",
  ý: "y",
  ÿ: "y",
  Æ: "Ae",
  æ: "ae",
  Þ: "Th",
  þ: "th",
  ß: "ss",
  // Latin Extended-A block.
  Ā: "A",
  Ă: "A",
  Ą: "A",
  ā: "a",
  ă: "a",
  ą: "a",
  Ć: "C",
  Ĉ: "C",
  Ċ: "C",
  Č: "C",
  ć: "c",
  ĉ: "c",
  ċ: "c",
  č: "c",
  Ď: "D",
  Đ: "D",
  ď: "d",
  đ: "d",
  Ē: "E",
  Ĕ: "E",
  Ė: "E",
  Ę: "E",
  Ě: "E",
  ē: "e",
  ĕ: "e",
  ė: "e",
  ę: "e",
  ě: "e",
  Ĝ: "G",
  Ğ: "G",
  Ġ: "G",
  Ģ: "G",
  ĝ: "g",
  ğ: "g",
  ġ: "g",
  ģ: "g",
  Ĥ: "H",
  Ħ: "H",
  ĥ: "h",
  ħ: "h",
  Ĩ: "I",
  Ī: "I",
  Ĭ: "I",
  Į: "I",
  İ: "I",
  ĩ: "i",
  ī: "i",
  ĭ: "i",
  į: "i",
  ı: "i",
  Ĵ: "J",
  ĵ: "j",
  Ķ: "K",
  ķ: "k",
  ĸ: "k",
  Ĺ: "L",
  Ļ: "L",
  Ľ: "L",
  Ŀ: "L",
  Ł: "L",
  ĺ: "l",
  ļ: "l",
  ľ: "l",
  ŀ: "l",
  ł: "l",
  Ń: "N",
  Ņ: "N",
  Ň: "N",
  Ŋ: "N",
  ń: "n",
  ņ: "n",
  ň: "n",
  ŋ: "n",
  Ō: "O",
  Ŏ: "O",
  Ő: "O",
  ō: "o",
  ŏ: "o",
  ő: "o",
  Ŕ: "R",
  Ŗ: "R",
  Ř: "R",
  ŕ: "r",
  ŗ: "r",
  ř: "r",
  Ś: "S",
  Ŝ: "S",
  Ş: "S",
  Š: "S",
  ś: "s",
  ŝ: "s",
  ş: "s",
  š: "s",
  Ţ: "T",
  Ť: "T",
  Ŧ: "T",
  ţ: "t",
  ť: "t",
  ŧ: "t",
  Ũ: "U",
  Ū: "U",
  Ŭ: "U",
  Ů: "U",
  Ű: "U",
  Ų: "U",
  ũ: "u",
  ū: "u",
  ŭ: "u",
  ů: "u",
  ű: "u",
  ų: "u",
  Ŵ: "W",
  ŵ: "w",
  Ŷ: "Y",
  ŷ: "y",
  Ÿ: "Y",
  Ź: "Z",
  Ż: "Z",
  Ž: "Z",
  ź: "z",
  ż: "z",
  ž: "z",
  Ĳ: "IJ",
  ĳ: "ij",
  Œ: "Oe",
  œ: "oe",
  ŉ: "'n",
  ſ: "s"
}, Lh = jh(Uh), qh = Lh, kh = qh, zh = ne, Gh = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Hh = "\\u0300-\\u036f", Vh = "\\ufe20-\\ufe2f", Bh = "\\u20d0-\\u20ff", Kh = Hh + Vh + Bh, Wh = "[" + Kh + "]", Jh = RegExp(Wh, "g");
function Zh(t) {
  return t = zh(t), t && t.replace(Gh, kh).replace(Jh, "");
}
var Yh = Zh, Xh = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
function Qh(t) {
  return t.match(Xh) || [];
}
var ed = Qh, td = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
function rd(t) {
  return td.test(t);
}
var nd = rd, Nr = "\\ud800-\\udfff", ad = "\\u0300-\\u036f", sd = "\\ufe20-\\ufe2f", id = "\\u20d0-\\u20ff", od = ad + sd + id, Rr = "\\u2700-\\u27bf", Ir = "a-z\\xdf-\\xf6\\xf8-\\xff", ud = "\\xac\\xb1\\xd7\\xf7", cd = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", ld = "\\u2000-\\u206f", fd = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Mr = "A-Z\\xc0-\\xd6\\xd8-\\xde", hd = "\\ufe0e\\ufe0f", jr = ud + cd + ld + fd, Ur = "['’]", kt = "[" + jr + "]", dd = "[" + od + "]", Lr = "\\d+", pd = "[" + Rr + "]", qr = "[" + Ir + "]", kr = "[^" + Nr + jr + Lr + Rr + Ir + Mr + "]", md = "\\ud83c[\\udffb-\\udfff]", yd = "(?:" + dd + "|" + md + ")", vd = "[^" + Nr + "]", zr = "(?:\\ud83c[\\udde6-\\uddff]){2}", Gr = "[\\ud800-\\udbff][\\udc00-\\udfff]", G = "[" + Mr + "]", gd = "\\u200d", zt = "(?:" + qr + "|" + kr + ")", _d = "(?:" + G + "|" + kr + ")", Gt = "(?:" + Ur + "(?:d|ll|m|re|s|t|ve))?", Ht = "(?:" + Ur + "(?:D|LL|M|RE|S|T|VE))?", Hr = yd + "?", Vr = "[" + hd + "]?", bd = "(?:" + gd + "(?:" + [vd, zr, Gr].join("|") + ")" + Vr + Hr + ")*", $d = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", xd = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", wd = Vr + Hr + bd, Ed = "(?:" + [pd, zr, Gr].join("|") + ")" + wd, Fd = RegExp([
  G + "?" + qr + "+" + Gt + "(?=" + [kt, G, "$"].join("|") + ")",
  _d + "+" + Ht + "(?=" + [kt, G + zt, "$"].join("|") + ")",
  G + "?" + zt + "+" + Gt,
  G + "+" + Ht,
  xd,
  $d,
  Lr,
  Ed
].join("|"), "g");
function Sd(t) {
  return t.match(Fd) || [];
}
var Td = Sd, Ad = ed, Od = nd, Cd = ne, Dd = Td;
function Pd(t, e, r) {
  return t = Cd(t), e = r ? void 0 : e, e === void 0 ? Od(t) ? Dd(t) : Ad(t) : t.match(e) || [];
}
var Nd = Pd, Rd = Rh, Id = Yh, Md = Nd, jd = "['’]", Ud = RegExp(jd, "g");
function Ld(t) {
  return function(e) {
    return Rd(Md(Id(e).replace(Ud, "")), t, "");
  };
}
var Br = Ld, qd = Br, kd = qd(function(t, e, r) {
  return t + (r ? "_" : "") + e.toLowerCase();
}), Vt = kd;
function zd(t, e, r) {
  var n = -1, a = t.length;
  e < 0 && (e = -e > a ? 0 : a + e), r = r > a ? a : r, r < 0 && (r += a), a = e > r ? 0 : r - e >>> 0, e >>>= 0;
  for (var s = Array(a); ++n < a; )
    s[n] = t[n + e];
  return s;
}
var Gd = zd, Hd = Gd;
function Vd(t, e, r) {
  var n = t.length;
  return r = r === void 0 ? n : r, !e && r >= n ? t : Hd(t, e, r);
}
var Bd = Vd, Kd = "\\ud800-\\udfff", Wd = "\\u0300-\\u036f", Jd = "\\ufe20-\\ufe2f", Zd = "\\u20d0-\\u20ff", Yd = Wd + Jd + Zd, Xd = "\\ufe0e\\ufe0f", Qd = "\\u200d", ep = RegExp("[" + Qd + Kd + Yd + Xd + "]");
function tp(t) {
  return ep.test(t);
}
var Kr = tp;
function rp(t) {
  return t.split("");
}
var np = rp, Wr = "\\ud800-\\udfff", ap = "\\u0300-\\u036f", sp = "\\ufe20-\\ufe2f", ip = "\\u20d0-\\u20ff", op = ap + sp + ip, up = "\\ufe0e\\ufe0f", cp = "[" + Wr + "]", He = "[" + op + "]", Ve = "\\ud83c[\\udffb-\\udfff]", lp = "(?:" + He + "|" + Ve + ")", Jr = "[^" + Wr + "]", Zr = "(?:\\ud83c[\\udde6-\\uddff]){2}", Yr = "[\\ud800-\\udbff][\\udc00-\\udfff]", fp = "\\u200d", Xr = lp + "?", Qr = "[" + up + "]?", hp = "(?:" + fp + "(?:" + [Jr, Zr, Yr].join("|") + ")" + Qr + Xr + ")*", dp = Qr + Xr + hp, pp = "(?:" + [Jr + He + "?", He, Zr, Yr, cp].join("|") + ")", mp = RegExp(Ve + "(?=" + Ve + ")|" + pp + dp, "g");
function yp(t) {
  return t.match(mp) || [];
}
var vp = yp, gp = np, _p = Kr, bp = vp;
function $p(t) {
  return _p(t) ? bp(t) : gp(t);
}
var xp = $p, wp = Bd, Ep = Kr, Fp = xp, Sp = ne;
function Tp(t) {
  return function(e) {
    e = Sp(e);
    var r = Ep(e) ? Fp(e) : void 0, n = r ? r[0] : e.charAt(0), a = r ? wp(r, 1).join("") : e.slice(1);
    return n[t]() + a;
  };
}
var Ap = Tp, Op = Ap, Cp = Op("toUpperCase"), Dp = Cp, Pp = ne, Np = Dp;
function Rp(t) {
  return Np(Pp(t).toLowerCase());
}
var Ip = Rp, Mp = Ip, jp = Br, Up = jp(function(t, e, r) {
  return e = e.toLowerCase(), t + (r ? Mp(e) : e);
}), Lp = Up, qp = pr, kp = yr, zp = Fr;
function Gp(t, e) {
  var r = {};
  return e = zp(e), kp(t, function(n, a, s) {
    qp(r, e(n, a, s), n);
  }), r;
}
var Hp = Gp, ye = {}, Vp = {
  get exports() {
    return ye;
  },
  set exports(t) {
    ye = t;
  }
};
Vp.exports = function(t) {
  return en(Bp(t), t);
};
ye.array = en;
function en(t, e) {
  var r = t.length, n = new Array(r), a = {}, s = r, i = Kp(e), o = Wp(t);
  for (e.forEach(function(c) {
    if (!o.has(c[0]) || !o.has(c[1]))
      throw new Error("Unknown node. There is an unknown node in the supplied edges.");
  }); s--; )
    a[s] || u(t[s], s, /* @__PURE__ */ new Set());
  return n;
  function u(c, f, l) {
    if (l.has(c)) {
      var h;
      try {
        h = ", node was:" + JSON.stringify(c);
      } catch {
        h = "";
      }
      throw new Error("Cyclic dependency" + h);
    }
    if (!o.has(c))
      throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(c));
    if (!a[f]) {
      a[f] = !0;
      var p = i.get(c) || /* @__PURE__ */ new Set();
      if (p = Array.from(p), f = p.length) {
        l.add(c);
        do {
          var m = p[--f];
          u(m, o.get(m), l);
        } while (f);
        l.delete(c);
      }
      n[--r] = c;
    }
  }
}
function Bp(t) {
  for (var e = /* @__PURE__ */ new Set(), r = 0, n = t.length; r < n; r++) {
    var a = t[r];
    e.add(a[0]), e.add(a[1]);
  }
  return Array.from(e);
}
function Kp(t) {
  for (var e = /* @__PURE__ */ new Map(), r = 0, n = t.length; r < n; r++) {
    var a = t[r];
    e.has(a[0]) || e.set(a[0], /* @__PURE__ */ new Set()), e.has(a[1]) || e.set(a[1], /* @__PURE__ */ new Set()), e.get(a[0]).add(a[1]);
  }
  return e;
}
function Wp(t) {
  for (var e = /* @__PURE__ */ new Map(), r = 0, n = t.length; r < n; r++)
    e.set(t[r], r);
  return e;
}
function Jp(t, e = []) {
  let r = [], n = /* @__PURE__ */ new Set(), a = new Set(e.map(([i, o]) => `${i}-${o}`));
  function s(i, o) {
    let u = Ee.split(i)[0];
    n.add(u), a.has(`${o}-${u}`) || r.push([o, u]);
  }
  for (const i in t)
    if (le(t, i)) {
      let o = t[i];
      n.add(i), R.isRef(o) && o.isSibling ? s(o.path, i) : tt(o) && "deps" in o && o.deps.forEach((u) => s(u, i));
    }
  return ye.array(Array.from(n), r).reverse();
}
function Bt(t, e) {
  let r = 1 / 0;
  return t.some((n, a) => {
    var s;
    if (((s = e.path) == null ? void 0 : s.indexOf(n)) !== -1)
      return r = a, !0;
  }), r;
}
function tn(t) {
  return (e, r) => Bt(t, e) - Bt(t, r);
}
function H() {
  return H = Object.assign || function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, H.apply(this, arguments);
}
let Kt = (t) => Object.prototype.toString.call(t) === "[object Object]";
function Zp(t, e) {
  let r = Object.keys(t.fields);
  return Object.keys(e).filter((n) => r.indexOf(n) === -1);
}
const Yp = tn([]);
class rn extends w {
  constructor(e) {
    super({
      type: "object"
    }), this.fields = /* @__PURE__ */ Object.create(null), this._sortErrors = Yp, this._nodes = [], this._excludedEdges = [], this.withMutation(() => {
      this.transform(function(n) {
        if (typeof n == "string")
          try {
            n = JSON.parse(n);
          } catch {
            n = null;
          }
        return this.isType(n) ? n : null;
      }), e && this.shape(e);
    });
  }
  _typeCheck(e) {
    return Kt(e) || typeof e == "function";
  }
  _cast(e, r = {}) {
    var n;
    let a = super._cast(e, r);
    if (a === void 0)
      return this.getDefault();
    if (!this._typeCheck(a))
      return a;
    let s = this.fields, i = (n = r.stripUnknown) != null ? n : this.spec.noUnknown, o = this._nodes.concat(Object.keys(a).filter((l) => this._nodes.indexOf(l) === -1)), u = {}, c = H({}, r, {
      parent: u,
      __validating: r.__validating || !1
    }), f = !1;
    for (const l of o) {
      let h = s[l], p = le(a, l);
      if (h) {
        let m, y = a[l];
        c.path = (r.path ? `${r.path}.` : "") + l, h = h.resolve({
          value: y,
          context: r.context,
          parent: u
        });
        let g = "spec" in h ? h.spec : void 0, $ = g == null ? void 0 : g.strict;
        if (g != null && g.strip) {
          f = f || l in a;
          continue;
        }
        m = !r.__validating || !$ ? (
          // TODO: use _cast, this is double resolving
          h.cast(a[l], c)
        ) : a[l], m !== void 0 && (u[l] = m);
      } else
        p && !i && (u[l] = a[l]);
      u[l] !== a[l] && (f = !0);
    }
    return f ? u : a;
  }
  _validate(e, r = {}, n) {
    let a = [], {
      sync: s,
      from: i = [],
      originalValue: o = e,
      abortEarly: u = this.spec.abortEarly,
      recursive: c = this.spec.recursive
    } = r;
    i = [{
      schema: this,
      value: o
    }, ...i], r.__validating = !0, r.originalValue = o, r.from = i, super._validate(e, r, (f, l) => {
      if (f) {
        if (!E.isError(f) || u)
          return void n(f, l);
        a.push(f);
      }
      if (!c || !Kt(l)) {
        n(a[0] || null, l);
        return;
      }
      o = o || l;
      let h = this._nodes.map((p) => (m, y) => {
        let g = p.indexOf(".") === -1 ? (r.path ? `${r.path}.` : "") + p : `${r.path || ""}["${p}"]`, $ = this.fields[p];
        if ($ && "validate" in $) {
          $.validate(l[p], H({}, r, {
            // @ts-ignore
            path: g,
            from: i,
            // inner fields are always strict:
            // 1. this isn't strict so the casting will also have cast inner values
            // 2. this is strict in which case the nested values weren't cast either
            strict: !0,
            parent: l,
            originalValue: o[p]
          }), y);
          return;
        }
        y(null);
      });
      fe({
        sync: s,
        tests: h,
        value: l,
        errors: a,
        endEarly: u,
        sort: this._sortErrors,
        path: r.path
      }, n);
    });
  }
  clone(e) {
    const r = super.clone(e);
    return r.fields = H({}, this.fields), r._nodes = this._nodes, r._excludedEdges = this._excludedEdges, r._sortErrors = this._sortErrors, r;
  }
  concat(e) {
    let r = super.concat(e), n = r.fields;
    for (let [a, s] of Object.entries(this.fields)) {
      const i = n[a];
      i === void 0 ? n[a] = s : i instanceof w && s instanceof w && (n[a] = s.concat(i));
    }
    return r.withMutation(() => r.shape(n, this._excludedEdges));
  }
  getDefaultFromShape() {
    let e = {};
    return this._nodes.forEach((r) => {
      const n = this.fields[r];
      e[r] = "default" in n ? n.getDefault() : void 0;
    }), e;
  }
  _getDefault() {
    if ("default" in this.spec)
      return super._getDefault();
    if (this._nodes.length)
      return this.getDefaultFromShape();
  }
  shape(e, r = []) {
    let n = this.clone(), a = Object.assign(n.fields, e);
    return n.fields = a, n._sortErrors = tn(Object.keys(a)), r.length && (Array.isArray(r[0]) || (r = [r]), n._excludedEdges = [...n._excludedEdges, ...r]), n._nodes = Jp(a, n._excludedEdges), n;
  }
  pick(e) {
    const r = {};
    for (const n of e)
      this.fields[n] && (r[n] = this.fields[n]);
    return this.clone().withMutation((n) => (n.fields = {}, n.shape(r)));
  }
  omit(e) {
    const r = this.clone(), n = r.fields;
    r.fields = {};
    for (const a of e)
      delete n[a];
    return r.withMutation(() => r.shape(n));
  }
  from(e, r, n) {
    let a = Ee.getter(e, !0);
    return this.transform((s) => {
      if (s == null)
        return s;
      let i = s;
      return le(s, e) && (i = H({}, s), n || delete i[e], i[r] = a(s)), i;
    });
  }
  noUnknown(e = !0, r = Me.noUnknown) {
    typeof e == "string" && (r = e, e = !0);
    let n = this.test({
      name: "noUnknown",
      exclusive: !0,
      message: r,
      test(a) {
        if (a == null)
          return !0;
        const s = Zp(this.schema, a);
        return !e || s.length === 0 || this.createError({
          params: {
            unknown: s.join(", ")
          }
        });
      }
    });
    return n.spec.noUnknown = e, n;
  }
  unknown(e = !0, r = Me.noUnknown) {
    return this.noUnknown(!e, r);
  }
  transformKeys(e) {
    return this.transform((r) => r && Hp(r, (n, a) => e(a)));
  }
  camelCase() {
    return this.transformKeys(Lp);
  }
  snakeCase() {
    return this.transformKeys(Vt);
  }
  constantCase() {
    return this.transformKeys((e) => Vt(e).toUpperCase());
  }
  describe() {
    let e = super.describe();
    return e.fields = Sr(this.fields, (r) => r.describe()), e;
  }
}
function v(t) {
  return new rn(t);
}
v.prototype = rn.prototype;
function ve() {
  return ve = Object.assign || function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, ve.apply(this, arguments);
}
function q(t) {
  return new nn(t);
}
class nn extends w {
  constructor(e) {
    super({
      type: "array"
    }), this.innerType = void 0, this.innerType = e, this.withMutation(() => {
      this.transform(function(r) {
        if (typeof r == "string")
          try {
            r = JSON.parse(r);
          } catch {
            r = null;
          }
        return this.isType(r) ? r : null;
      });
    });
  }
  _typeCheck(e) {
    return Array.isArray(e);
  }
  get _subType() {
    return this.innerType;
  }
  _cast(e, r) {
    const n = super._cast(e, r);
    if (!this._typeCheck(n) || !this.innerType)
      return n;
    let a = !1;
    const s = n.map((i, o) => {
      const u = this.innerType.cast(i, ve({}, r, {
        path: `${r.path || ""}[${o}]`
      }));
      return u !== i && (a = !0), u;
    });
    return a ? s : n;
  }
  _validate(e, r = {}, n) {
    var a, s;
    let i = [], o = r.sync, u = r.path, c = this.innerType, f = (a = r.abortEarly) != null ? a : this.spec.abortEarly, l = (s = r.recursive) != null ? s : this.spec.recursive, h = r.originalValue != null ? r.originalValue : e;
    super._validate(e, r, (p, m) => {
      if (p) {
        if (!E.isError(p) || f)
          return void n(p, m);
        i.push(p);
      }
      if (!l || !c || !this._typeCheck(m)) {
        n(i[0] || null, m);
        return;
      }
      h = h || m;
      let y = new Array(m.length);
      for (let g = 0; g < m.length; g++) {
        let $ = m[g], F = `${r.path || ""}[${g}]`, C = ve({}, r, {
          path: F,
          strict: !0,
          parent: m,
          index: g,
          originalValue: h[g]
        });
        y[g] = (S, D) => c.validate($, C, D);
      }
      fe({
        sync: o,
        path: u,
        value: m,
        errors: i,
        endEarly: f,
        tests: y
      }, n);
    });
  }
  clone(e) {
    const r = super.clone(e);
    return r.innerType = this.innerType, r;
  }
  concat(e) {
    let r = super.concat(e);
    return r.innerType = this.innerType, e.innerType && (r.innerType = r.innerType ? (
      // @ts-expect-error Lazy doesn't have concat()
      r.innerType.concat(e.innerType)
    ) : e.innerType), r;
  }
  of(e) {
    let r = this.clone();
    if (!tt(e))
      throw new TypeError("`array.of()` sub-schema must be a valid yup schema not: " + V(e));
    return r.innerType = e, r;
  }
  length(e, r = ce.length) {
    return this.test({
      message: r,
      name: "length",
      exclusive: !0,
      params: {
        length: e
      },
      test(n) {
        return b(n) || n.length === this.resolve(e);
      }
    });
  }
  min(e, r) {
    return r = r || ce.min, this.test({
      message: r,
      name: "min",
      exclusive: !0,
      params: {
        min: e
      },
      // FIXME(ts): Array<typeof T>
      test(n) {
        return b(n) || n.length >= this.resolve(e);
      }
    });
  }
  max(e, r) {
    return r = r || ce.max, this.test({
      message: r,
      name: "max",
      exclusive: !0,
      params: {
        max: e
      },
      test(n) {
        return b(n) || n.length <= this.resolve(e);
      }
    });
  }
  ensure() {
    return this.default(() => []).transform((e, r) => this._typeCheck(e) ? e : r == null ? [] : [].concat(r));
  }
  compact(e) {
    let r = e ? (n, a, s) => !e(n, a, s) : (n) => !!n;
    return this.transform((n) => n != null ? n.filter(r) : n);
  }
  describe() {
    let e = super.describe();
    return this.innerType && (e.innerType = this.innerType.describe()), e;
  }
  nullable(e = !0) {
    return super.nullable(e);
  }
  defined() {
    return super.defined();
  }
  required(e) {
    return super.required(e);
  }
}
q.prototype = nn.prototype;
const Wt = q().of(
  v().shape({
    variantId: d().required(),
    productId: d().nullable(),
    quantity: Q().required(),
    sellingPlanId: d().nullable(),
    attributes: q().of(
      v().shape({
        key: d().required(),
        value: d().required()
      })
    ).nullable()
  })
), an = v().shape({
  key: d().required(),
  value: d().required()
}), Xp = v().shape({
  attributes: q().max(255).of(an).required()
}), Qp = v().shape({
  note: d()
}), em = v().shape({
  vaultKey: d().required(),
  scope: d()
}), tm = v().shape({
  vaultKey: d().required(),
  key: d().required()
}), rm = v().shape({
  vaultKey: d().required(),
  key: d().required(),
  value: d()
}), nm = v().shape({
  vaultKey: d().required(),
  key: d().required()
}), am = v().shape({
  vaultKey: d().required()
}), sm = v().shape({
  vaultKey: d().required()
}), im = v().shape({
  vaultKey: d().required(),
  key: d().required()
}), om = v().shape({
  productId: d().required(),
  variantId: d().required()
}), um = q().of(
  v().shape({
    id: d().required(),
    name: d().required(),
    variants: q().of(om).required()
  })
), cm = v().shape({ name: d().required().min(3) }), lm = d().required(), fm = v().shape({
  productId: d().required(),
  variantId: d().required(),
  wishlistId: d().required()
}), hm = Y().required().isTrue(), dm = v().shape({
  productId: d().required(),
  variantId: d().required(),
  wishlistId: d().required()
}), pm = Y().required().isTrue(), mm = v().shape({
  action: d().oneOf(["login", "create"], 'action must be either "login" or "create".').notRequired()
}).notRequired(), ym = Y().required().isTrue(), Be = (t) => typeof t == "function" ? !1 : typeof t == "object" && t !== null ? !Object.values(t).some((e) => !Be(e)) : !0, vm = (t) => {
  if (typeof t == "string")
    try {
      JSON.parse(t);
    } catch {
      return !1;
    }
  return typeof t == "object" && t !== null || Array.isArray(t) ? Be(t) : !1;
}, gm = v().shape({
  analyticEvent: d().required(),
  analyticProperties: v().test("is-json", "Field must be a valid JSON object or array", vm).required()
}), _m = Y().required().isTrue(), bm = (t) => {
  try {
    return new URL(t), !0;
  } catch {
    return !1;
  }
}, $m = [
  {
    functionName: "addToCart",
    actionName: "cart/add",
    schema: v().shape({
      cartAttributes: q().of(an),
      lineItems: Wt
    })
  },
  {
    functionName: "applyDiscount",
    actionName: "discount/apply",
    schema: v().shape({
      discountCode: d().required()
    })
  },
  {
    functionName: "removeDiscounts",
    actionName: "discount/remove/all",
    schema: null
  },
  {
    functionName: "applyGiftCard",
    actionName: "giftcard/apply",
    schema: v().shape({
      giftCardCode: d().required()
    })
  },
  {
    functionName: "openCart",
    actionName: "cart/open",
    schema: null
  },
  {
    functionName: "authenticationOpen",
    actionName: "authentication/open",
    schema: mm,
    successSchema: ym
  },
  {
    functionName: "openCollection",
    actionName: "collection/open",
    schema: v().shape({
      collectionId: d().required()
    })
  },
  {
    functionName: "openProduct",
    actionName: "product/open",
    schema: v().shape({
      productId: d().required(),
      variantId: d(),
      isRelatedProduct: Y()
    })
  },
  {
    functionName: "showToast",
    actionName: "app/toast",
    schema: v().shape({
      message: d().required(),
      type: d().required().oneOf(["success", "warning", "error"])
    })
  },
  {
    functionName: "updateView",
    actionName: "view/updated",
    schema: v().shape({
      height: Q().required(),
      width: Q().required(),
      multiplier: Q().required()
    })
  },
  {
    functionName: "getCustomerIdentity",
    actionName: "customer/identity",
    schema: null
  },
  {
    functionName: "renderView",
    actionName: "view/rendered",
    schema: null
  },
  {
    functionName: "openScreen",
    actionName: "screen/open",
    schema: v().shape({
      destination: v().shape({
        type: d().oneOf(
          ["internal", "web"],
          'Type must be either "internal" or "web".'
        ).required("Type is required."),
        url: d().test("valid-url", "URL is not valid.", function(t) {
          const { type: e } = this.parent;
          return e === "internal" ? !0 : e === "web" ? bm(t) : !1;
        }).required("URL is required.")
      }).required("Destination is required.")
    })
  },
  {
    functionName: "scrollToBlockTop",
    actionName: "view/scrollToBlockTop",
    schema: null
  },
  {
    functionName: "scrollToBlockBottom",
    actionName: "view/scrollToBlockBottom",
    schema: null
  },
  {
    functionName: "removeFromCart",
    actionName: "cart/remove",
    schema: v().shape({
      lineItems: Wt
    })
  },
  {
    functionName: "trackAnalyticEvent",
    actionName: "analytics/track",
    schema: gm,
    successSchema: _m
  },
  {
    functionName: "updateCartAttributes",
    actionName: "cart/updateAttributes",
    schema: Xp
  },
  {
    functionName: "updateCartNote",
    actionName: "cart/updateNote",
    schema: Qp
  },
  {
    functionName: "vaultInitialize",
    actionName: "vault/initialize",
    schema: em
  },
  {
    functionName: "vaultGet",
    actionName: "vault/get",
    schema: tm
  },
  {
    functionName: "vaultSet",
    actionName: "vault/set",
    schema: rm
  },
  {
    functionName: "vaultRemove",
    actionName: "vault/remove",
    schema: nm
  },
  {
    functionName: "vaultClear",
    actionName: "vault/clear",
    schema: am
  },
  {
    functionName: "vaultKeys",
    actionName: "vault/keys",
    schema: sm
  },
  {
    functionName: "vaultObserve",
    actionName: "vault/observe",
    schema: im
  },
  {
    functionName: "wishlistCreate",
    actionName: "wishlist/create",
    schema: cm,
    successSchema: lm
  },
  {
    functionName: "wishlistsGet",
    actionName: "wishlists/get",
    schema: null,
    successSchema: um
  },
  {
    functionName: "wishlistItemAdd",
    actionName: "wishlist/item/add",
    schema: fm,
    successSchema: hm
  },
  {
    functionName: "wishlistItemRemove",
    actionName: "wishlist/item/remove",
    schema: dm,
    successSchema: pm
  }
], T = {
  PLATFORM_IOS: "ios",
  PLATFORM_ANDROID: "android",
  PLATFORM_EDITOR: "editor",
  ACTION_RESPONSE_SUCCESS: "success",
  ACTION_RESPONSE_ERROR: "error",
  TAPCART_SDK: "tapcart-sdk"
}, xm = (t, e) => $m.reduce((n, a, s) => {
  const { schema: i, functionName: o, actionName: u, successSchema: c } = a, f = (l, h = {}) => {
    let p;
    if (i)
      try {
        p = i.validateSync(l);
      } catch (y) {
        throw new Error(y.message);
      }
    const m = {
      id: mn(),
      type: "action",
      name: u,
      data: p
    };
    (h.onSuccess || h.onError) && t(
      m.id,
      h.onSuccess,
      h.onError,
      c
    ), e(m);
  };
  return n[o] = f, n;
}, {}), wm = (t) => {
  const e = {}, r = (s, i, o, u) => {
    let c;
    i && (c = (f) => {
      if (u)
        try {
          i(u.validateSync(f));
        } catch (l) {
          o && o(l);
        }
      else
        i(f);
    }), e[s] = {
      [T.ACTION_RESPONSE_SUCCESS]: c,
      [T.ACTION_RESPONSE_ERROR]: o
    };
  }, n = (s, i, o) => {
    var u;
    typeof ((u = e[s]) == null ? void 0 : u[i]) == "function" && e[s][i](o);
  };
  return {
    actions: xm(r, t),
    respond: n
  };
}, Jt = ["cart/updated", "product/updated", "customer/updated"], Ce = {
  CART_UPDATED: "cart/updated",
  PRODUCT_UPDATED: "product/updated",
  CUSTOMER_UPDATED: "customer/updated"
}, Em = (t, e) => {
  switch (t) {
    case Ce.CART_UPDATED:
      return { cart: e.cart || null };
    case Ce.PRODUCT_UPDATED:
      return { product: e.product || null };
    case Ce.CUSTOMER_UPDATED:
      return { customer: e.customer || null };
    default:
      return e;
  }
}, Fm = ({ setVariables: t }) => {
  const e = {};
  return {
    notify: (a, s) => {
      if (!Jt.includes(a))
        throw new Error("Unsupported Event");
      e[a] && e[a](s);
    },
    registerEventHandler: (a, s) => {
      if (!Jt.includes(a))
        throw new Error("Unsupported Event");
      if (typeof s != "function")
        throw new TypeError("Invalid Handler");
      const i = (o) => {
        o && t(Em(a, o)), s(o);
      };
      e[a] = i;
    }
  };
}, Sm = () => {
  let t;
  const e = (u, c) => window.webkit.messageHandlers[u].postMessage(
    JSON.stringify(c)
  ), r = (u, c) => window[u].postMessage(JSON.stringify(c)), n = (u, c) => {
    var f, l;
    console.log(c), window == null || window.postMessage(
      { type: T.TAPCART_SDK, message: JSON.stringify(c) },
      "*"
    ), (l = (f = window == null ? void 0 : window.parent) == null ? void 0 : f.window) == null || l.postMessage(
      { type: T.TAPCART_SDK, message: JSON.stringify(c) },
      "*"
    );
  }, a = {
    [T.PLATFORM_IOS]: e,
    [T.PLATFORM_ANDROID]: r,
    [T.PLATFORM_EDITOR]: n
  }, s = (u, c) => (f) => a[u](c, f);
  return {
    sendMessage: (u) => t(u),
    init: (u, c) => {
      if (!u || !c)
        throw new Error("Failed to initialize ActionBridge");
      if (u !== T.PLATFORM_IOS && u !== T.PLATFORM_ANDROID && u !== T.PLATFORM_EDITOR)
        throw new Error("Unknown Platform");
      if (u === T.PLATFORM_IOS && !window.webkit)
        throw new Error("Webview Interface not available");
      if (u === T.PLATFORM_ANDROID && !window[c])
        throw new Error("Webview Interface  not available");
      t = s(u, c);
    }
  };
};
class M {
  constructor(e) {
    this.message = e;
  }
}
class Tm extends M {
}
class Am extends M {
}
class Om extends M {
}
class Cm extends M {
}
class Dm extends M {
}
class Pm extends M {
}
const Ke = {
  VaultAccessException: Tm,
  VaultBuildException: Am,
  VaultInvalidArgumentException: Om,
  VaultInvalidScopeException: Cm,
  VaultScopeModificationException: Dm,
  VaultUserException: M,
  VaultUserIdentifierException: Pm
}, L = (t) => {
  if (Object.values(Ke).some((r) => t instanceof r))
    return t;
  const e = Ke[t.type];
  return e ? new e(t.message) : new M("unknown error occurred");
}, Nm = (t, e) => ({
  get: (n) => new Promise((a, s) => {
    e.actions.vaultGet(
      { vaultKey: t, key: n },
      {
        onSuccess: a,
        onError: (i) => s(L(i))
      }
    );
  }),
  set: (n, a) => new Promise((s, i) => {
    e.actions.vaultSet(
      {
        vaultKey: t,
        key: n,
        value: a
      },
      {
        onSuccess: s,
        onError: (o) => i(L(o))
      }
    );
  }),
  clear: () => new Promise((n, a) => {
    e.actions.vaultClear(
      {
        vaultKey: t
      },
      {
        onSuccess: n,
        onError: (s) => a(L(s))
      }
    );
  }),
  remove: (n) => new Promise((a, s) => {
    e.actions.vaultRemove(
      {
        vaultKey: t,
        key: n
      },
      {
        onSuccess: a,
        onError: (i) => s(L(i))
      }
    );
  }),
  keys: () => new Promise((n, a) => {
    e.actions.vaultKeys(
      {
        vaultKey: t
      },
      {
        onSuccess: n,
        onError: (s) => a(L(s))
      }
    );
  }),
  observe: (n, a, s = () => {
  }) => new Promise((i, o) => {
    e.actions.vaultObserve(
      {
        vaultKey: t,
        key: n
      },
      {
        onSuccess: (u) => {
          i(), a(u);
        },
        onError: (u) => {
          const c = L(u);
          o(c), s(c);
        }
      }
    );
  })
}), Rm = (t, e, r) => new Promise((n, a) => {
  r.actions.vaultInitialize(
    { vaultKey: t, scope: e },
    {
      onSuccess: () => {
        n(Nm(t, r));
      },
      onError: (s) => a(L(s))
    }
  );
}), Im = (t) => ({
  initialize: (e, r) => Rm(e, r, t),
  errorTypes: Ke
}), Zt = {
  Error: "Failed to perform wishlist action",
  Auth: "User must be logged in for wishlist actions",
  NoWishlistIntegrationConfigured: "A wishlist integration must be configured",
  InvalidName: "Wishlist name must be 3 characters long",
  WishlistDoesNotExist: "Wishlist does not exist",
  WishlistItemDoesNotExist: "Item does not exist"
}, Mm = (t) => Zt[t] || Zt.Error, ue = (t, e) => new Promise((r, n) => {
  t(e, {
    onSuccess: r,
    onError: (a) => n(Mm(a))
  });
}), jm = (t) => {
  const { wishlistCreate: e, wishlistItemAdd: r, wishlistItemRemove: n, wishlistsGet: a } = t.actions;
  return {
    createWishlist: (s) => ue(e, { name: s }),
    addItemToWishlist: (s, i, o) => ue(r, { productId: s, variantId: i, wishlistId: o }),
    removeItemFromWishlist: (s, i, o) => ue(n, { productId: s, variantId: i, wishlistId: o }),
    getWishlists: () => ue(a, null)
  };
}, Yt = {
  Error: "Failed to perform authentication action"
}, Um = (t) => Yt[t] || Yt.Error, Lm = (t, e) => new Promise((r, n) => {
  t(e, {
    onSuccess: r,
    onError: (a) => n(Um(a))
  });
}), qm = (t) => {
  const { authenticationOpen: e } = t.actions;
  return {
    openAuthentication: (r) => Lm(e, { action: r })
  };
}, km = (t, e) => new Promise((r, n) => {
  t(e, {
    onSuccess: r,
    onError: (a) => n(a)
  });
}), zm = (t) => {
  const { trackAnalyticEvent: e } = t.actions;
  return {
    trackAnalyticEvent: (r, n) => km(e, { analyticEvent: r, analyticProperties: n })
  };
}, Km = () => {
  const t = Sm(), e = wm(t.sendMessage), r = pn(), n = Fm({
    setVariables: r.setVariables
  }), a = async (i) => {
    t.init(i.platform, i.messageHandlerName), r.setVariables(i.variables);
  }, s = {
    addToCart: e.actions.addToCart,
    applyDiscount: e.actions.applyDiscount,
    applyGiftCard: e.actions.applyGiftCard,
    getCustomerIdentity: e.actions.getCustomerIdentity,
    openCart: e.actions.openCart,
    openCollection: e.actions.openCollection,
    openProduct: e.actions.openProduct,
    openScreen: e.actions.openScreen,
    removeDiscounts: e.actions.removeDiscounts,
    removeFromCart: e.actions.removeFromCart,
    scrollToBlockBottom: e.actions.scrollToBlockBottom,
    scrollToBlockTop: e.actions.scrollToBlockTop,
    showToast: e.actions.showToast,
    updateCartAttributes: e.actions.updateCartAttributes,
    updateCartNote: e.actions.updateCartNote,
    vault: Im(e),
    ...jm(e),
    ...qm(e),
    ...zm(e)
  };
  return {
    mobile: {
      respond: e.respond,
      notify: n.notify,
      load: a
    },
    registerEventHandler: n.registerEventHandler,
    actions: s,
    get variables() {
      return r.variables;
    }
  };
}, Gm = () => {
  var r, n, a, s;
  const t = new CustomEvent("webbridge-ready");
  window.dispatchEvent(t);
  const e = JSON.stringify({
    type: "action",
    name: "webbridge/ready"
  });
  (r = window.CustomBlockJavascriptInterface) == null || r.postMessage(e), (s = (a = (n = window.webkit) == null ? void 0 : n.messageHandlers) == null ? void 0 : a.Tapcart) == null || s.postMessage(e);
}, Hm = () => ({
  device: null,
  product: null,
  cart: null,
  customer: null,
  isInitialized: !1
}), sn = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null), on = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
function Vm(t, e) {
  switch (e.type) {
    case "set-device":
      return {
        ...t,
        device: {
          ...e.payload
        }
      };
    case "set-cart":
      return {
        ...t,
        cart: {
          ...e.payload
        }
      };
    case "set-product":
      return {
        ...t,
        product: {
          ...e.payload
        }
      };
    case "set-customer":
      return {
        ...t,
        customer: {
          ...e.payload
        }
      };
    case "initialize":
      return {
        ...e.payload,
        isInitialized: !0
      };
    default:
      throw new Error(`Unknown action: ${e.type}`);
  }
}
function Wm({ webbridgeClient: t, children: e }) {
  const [r, n] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)(Vm, Hm()), [a, s] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(t.actions);
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    t.registerEventHandler("cart/updated", (i) => {
      n({ type: "set-cart", payload: i == null ? void 0 : i.cart });
    }), t.registerEventHandler("product/updated", (i) => {
      n({ type: "set-product", payload: i == null ? void 0 : i.product });
    }), t.registerEventHandler("customer/updated", (i) => {
      n({ type: "set-customer", payload: i == null ? void 0 : i.customer });
    }), window.Tapcart = {
      mobile: {
        ...t.mobile,
        load: (i) => {
          t.mobile.load(i), n({ type: "initialize", payload: i.variables });
        }
      }
    }, Gm();
  }, [t]), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(sn.Provider, { value: r }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(on.Provider, { value: a }, e));
}
const Jm = () => ({
  ...(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(on)
}), Zm = () => (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(sn);



/***/ }),

/***/ 7990:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "OS": function() { return /* binding */ printError; },
/* harmony export */   "Z": function() { return /* binding */ formatError; },
/* harmony export */   "__": function() { return /* binding */ GraphQLError; }
/* harmony export */ });
/* harmony import */ var _jsutils_isObjectLike_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52689);
/* harmony import */ var _language_location_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31472);
/* harmony import */ var _language_printLocation_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56403);




function toNormalizedOptions(args) {
  const firstArg = args[0];

  if (firstArg == null || 'kind' in firstArg || 'length' in firstArg) {
    return {
      nodes: firstArg,
      source: args[1],
      positions: args[2],
      path: args[3],
      originalError: args[4],
      extensions: args[5],
    };
  }

  return firstArg;
}
/**
 * A GraphQLError describes an Error found during the parse, validate, or
 * execute phases of performing a GraphQL operation. In addition to a message
 * and stack trace, it also includes information about the locations in a
 * GraphQL document and/or execution result that correspond to the Error.
 */

class GraphQLError extends Error {
  /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */

  /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */

  /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */

  /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */

  /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */

  /**
   * The original error thrown from a field resolver during execution.
   */

  /**
   * Extension fields to add to the formatted error.
   */

  /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */
  constructor(message, ...rawArgs) {
    var _this$nodes, _nodeLocations$, _ref;

    const { nodes, source, positions, path, originalError, extensions } =
      toNormalizedOptions(rawArgs);
    super(message);
    this.name = 'GraphQLError';
    this.path = path !== null && path !== void 0 ? path : undefined;
    this.originalError =
      originalError !== null && originalError !== void 0
        ? originalError
        : undefined; // Compute list of blame nodes.

    this.nodes = undefinedIfEmpty(
      Array.isArray(nodes) ? nodes : nodes ? [nodes] : undefined,
    );
    const nodeLocations = undefinedIfEmpty(
      (_this$nodes = this.nodes) === null || _this$nodes === void 0
        ? void 0
        : _this$nodes.map((node) => node.loc).filter((loc) => loc != null),
    ); // Compute locations in the source for the given nodes/positions.

    this.source =
      source !== null && source !== void 0
        ? source
        : nodeLocations === null || nodeLocations === void 0
        ? void 0
        : (_nodeLocations$ = nodeLocations[0]) === null ||
          _nodeLocations$ === void 0
        ? void 0
        : _nodeLocations$.source;
    this.positions =
      positions !== null && positions !== void 0
        ? positions
        : nodeLocations === null || nodeLocations === void 0
        ? void 0
        : nodeLocations.map((loc) => loc.start);
    this.locations =
      positions && source
        ? positions.map((pos) => (0,_language_location_mjs__WEBPACK_IMPORTED_MODULE_0__/* .getLocation */ .k)(source, pos))
        : nodeLocations === null || nodeLocations === void 0
        ? void 0
        : nodeLocations.map((loc) => (0,_language_location_mjs__WEBPACK_IMPORTED_MODULE_0__/* .getLocation */ .k)(loc.source, loc.start));
    const originalExtensions = (0,_jsutils_isObjectLike_mjs__WEBPACK_IMPORTED_MODULE_1__/* .isObjectLike */ .y)(
      originalError === null || originalError === void 0
        ? void 0
        : originalError.extensions,
    )
      ? originalError === null || originalError === void 0
        ? void 0
        : originalError.extensions
      : undefined;
    this.extensions =
      (_ref =
        extensions !== null && extensions !== void 0
          ? extensions
          : originalExtensions) !== null && _ref !== void 0
        ? _ref
        : Object.create(null); // Only properties prescribed by the spec should be enumerable.
    // Keep the rest as non-enumerable.

    Object.defineProperties(this, {
      message: {
        writable: true,
        enumerable: true,
      },
      name: {
        enumerable: false,
      },
      nodes: {
        enumerable: false,
      },
      source: {
        enumerable: false,
      },
      positions: {
        enumerable: false,
      },
      originalError: {
        enumerable: false,
      },
    }); // Include (non-enumerable) stack trace.

    /* c8 ignore start */
    // FIXME: https://github.com/graphql/graphql-js/issues/2317

    if (
      originalError !== null &&
      originalError !== void 0 &&
      originalError.stack
    ) {
      Object.defineProperty(this, 'stack', {
        value: originalError.stack,
        writable: true,
        configurable: true,
      });
    } else if (Error.captureStackTrace) {
      Error.captureStackTrace(this, GraphQLError);
    } else {
      Object.defineProperty(this, 'stack', {
        value: Error().stack,
        writable: true,
        configurable: true,
      });
    }
    /* c8 ignore stop */
  }

  get [Symbol.toStringTag]() {
    return 'GraphQLError';
  }

  toString() {
    let output = this.message;

    if (this.nodes) {
      for (const node of this.nodes) {
        if (node.loc) {
          output += '\n\n' + (0,_language_printLocation_mjs__WEBPACK_IMPORTED_MODULE_2__/* .printLocation */ .Q)(node.loc);
        }
      }
    } else if (this.source && this.locations) {
      for (const location of this.locations) {
        output += '\n\n' + (0,_language_printLocation_mjs__WEBPACK_IMPORTED_MODULE_2__/* .printSourceLocation */ .z)(this.source, location);
      }
    }

    return output;
  }

  toJSON() {
    const formattedError = {
      message: this.message,
    };

    if (this.locations != null) {
      formattedError.locations = this.locations;
    }

    if (this.path != null) {
      formattedError.path = this.path;
    }

    if (this.extensions != null && Object.keys(this.extensions).length > 0) {
      formattedError.extensions = this.extensions;
    }

    return formattedError;
  }
}

function undefinedIfEmpty(array) {
  return array === undefined || array.length === 0 ? undefined : array;
}
/**
 * See: https://spec.graphql.org/draft/#sec-Errors
 */

/**
 * Prints a GraphQLError to a string, representing useful location information
 * about the error's position in the source.
 *
 * @deprecated Please use `error.toString` instead. Will be removed in v17
 */
function printError(error) {
  return error.toString();
}
/**
 * Given a GraphQLError, format it according to the rules described by the
 * Response Format, Errors section of the GraphQL Specification.
 *
 * @deprecated Please use `error.toJSON` instead. Will be removed in v17
 */

function formatError(error) {
  return error.toJSON();
}


/***/ }),

/***/ 23445:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ syntaxError; }
/* harmony export */ });
/* harmony import */ var _GraphQLError_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7990);

/**
 * Produces a GraphQLError representing a syntax error, containing useful
 * descriptive information about the syntax error's position in the source.
 */

function syntaxError(source, position, description) {
  return new _GraphQLError_mjs__WEBPACK_IMPORTED_MODULE_0__/* .GraphQLError */ .__(`Syntax Error: ${description}`, {
    source,
    positions: [position],
  });
}


/***/ }),

/***/ 58588:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "BREAK": function() { return /* reexport */ BREAK; },
  "BreakingChangeType": function() { return /* reexport */ BreakingChangeType; },
  "DEFAULT_DEPRECATION_REASON": function() { return /* reexport */ DEFAULT_DEPRECATION_REASON; },
  "DangerousChangeType": function() { return /* reexport */ DangerousChangeType; },
  "DirectiveLocation": function() { return /* reexport */ directiveLocation/* DirectiveLocation */.B; },
  "ExecutableDefinitionsRule": function() { return /* reexport */ ExecutableDefinitionsRule; },
  "FieldsOnCorrectTypeRule": function() { return /* reexport */ FieldsOnCorrectTypeRule; },
  "FragmentsOnCompositeTypesRule": function() { return /* reexport */ FragmentsOnCompositeTypesRule; },
  "GRAPHQL_MAX_INT": function() { return /* reexport */ GRAPHQL_MAX_INT; },
  "GRAPHQL_MIN_INT": function() { return /* reexport */ GRAPHQL_MIN_INT; },
  "GraphQLBoolean": function() { return /* reexport */ GraphQLBoolean; },
  "GraphQLDeprecatedDirective": function() { return /* reexport */ GraphQLDeprecatedDirective; },
  "GraphQLDirective": function() { return /* reexport */ GraphQLDirective; },
  "GraphQLEnumType": function() { return /* reexport */ GraphQLEnumType; },
  "GraphQLError": function() { return /* reexport */ GraphQLError/* GraphQLError */.__; },
  "GraphQLFloat": function() { return /* reexport */ GraphQLFloat; },
  "GraphQLID": function() { return /* reexport */ GraphQLID; },
  "GraphQLIncludeDirective": function() { return /* reexport */ GraphQLIncludeDirective; },
  "GraphQLInputObjectType": function() { return /* reexport */ GraphQLInputObjectType; },
  "GraphQLInt": function() { return /* reexport */ GraphQLInt; },
  "GraphQLInterfaceType": function() { return /* reexport */ GraphQLInterfaceType; },
  "GraphQLList": function() { return /* reexport */ GraphQLList; },
  "GraphQLNonNull": function() { return /* reexport */ GraphQLNonNull; },
  "GraphQLObjectType": function() { return /* reexport */ GraphQLObjectType; },
  "GraphQLOneOfDirective": function() { return /* reexport */ GraphQLOneOfDirective; },
  "GraphQLScalarType": function() { return /* reexport */ GraphQLScalarType; },
  "GraphQLSchema": function() { return /* reexport */ GraphQLSchema; },
  "GraphQLSkipDirective": function() { return /* reexport */ GraphQLSkipDirective; },
  "GraphQLSpecifiedByDirective": function() { return /* reexport */ GraphQLSpecifiedByDirective; },
  "GraphQLString": function() { return /* reexport */ GraphQLString; },
  "GraphQLUnionType": function() { return /* reexport */ GraphQLUnionType; },
  "Kind": function() { return /* reexport */ kinds/* Kind */.h; },
  "KnownArgumentNamesRule": function() { return /* reexport */ KnownArgumentNamesRule; },
  "KnownDirectivesRule": function() { return /* reexport */ KnownDirectivesRule; },
  "KnownFragmentNamesRule": function() { return /* reexport */ KnownFragmentNamesRule; },
  "KnownTypeNamesRule": function() { return /* reexport */ KnownTypeNamesRule; },
  "Lexer": function() { return /* reexport */ language_lexer/* Lexer */.h; },
  "Location": function() { return /* reexport */ ast/* Location */.Ye; },
  "LoneAnonymousOperationRule": function() { return /* reexport */ LoneAnonymousOperationRule; },
  "LoneSchemaDefinitionRule": function() { return /* reexport */ LoneSchemaDefinitionRule; },
  "MaxIntrospectionDepthRule": function() { return /* reexport */ MaxIntrospectionDepthRule; },
  "NoDeprecatedCustomRule": function() { return /* reexport */ NoDeprecatedCustomRule; },
  "NoFragmentCyclesRule": function() { return /* reexport */ NoFragmentCyclesRule; },
  "NoSchemaIntrospectionCustomRule": function() { return /* reexport */ NoSchemaIntrospectionCustomRule; },
  "NoUndefinedVariablesRule": function() { return /* reexport */ NoUndefinedVariablesRule; },
  "NoUnusedFragmentsRule": function() { return /* reexport */ NoUnusedFragmentsRule; },
  "NoUnusedVariablesRule": function() { return /* reexport */ NoUnusedVariablesRule; },
  "OperationTypeNode": function() { return /* reexport */ ast/* OperationTypeNode */.ku; },
  "OverlappingFieldsCanBeMergedRule": function() { return /* reexport */ OverlappingFieldsCanBeMergedRule; },
  "PossibleFragmentSpreadsRule": function() { return /* reexport */ PossibleFragmentSpreadsRule; },
  "PossibleTypeExtensionsRule": function() { return /* reexport */ PossibleTypeExtensionsRule; },
  "ProvidedRequiredArgumentsRule": function() { return /* reexport */ ProvidedRequiredArgumentsRule; },
  "ScalarLeafsRule": function() { return /* reexport */ ScalarLeafsRule; },
  "SchemaMetaFieldDef": function() { return /* reexport */ SchemaMetaFieldDef; },
  "SingleFieldSubscriptionsRule": function() { return /* reexport */ SingleFieldSubscriptionsRule; },
  "Source": function() { return /* reexport */ language_source/* Source */.H; },
  "Token": function() { return /* reexport */ ast/* Token */.WU; },
  "TokenKind": function() { return /* reexport */ language_tokenKind/* TokenKind */.T; },
  "TypeInfo": function() { return /* reexport */ TypeInfo; },
  "TypeKind": function() { return /* reexport */ TypeKind; },
  "TypeMetaFieldDef": function() { return /* reexport */ TypeMetaFieldDef; },
  "TypeNameMetaFieldDef": function() { return /* reexport */ TypeNameMetaFieldDef; },
  "UniqueArgumentDefinitionNamesRule": function() { return /* reexport */ UniqueArgumentDefinitionNamesRule; },
  "UniqueArgumentNamesRule": function() { return /* reexport */ UniqueArgumentNamesRule; },
  "UniqueDirectiveNamesRule": function() { return /* reexport */ UniqueDirectiveNamesRule; },
  "UniqueDirectivesPerLocationRule": function() { return /* reexport */ UniqueDirectivesPerLocationRule; },
  "UniqueEnumValueNamesRule": function() { return /* reexport */ UniqueEnumValueNamesRule; },
  "UniqueFieldDefinitionNamesRule": function() { return /* reexport */ UniqueFieldDefinitionNamesRule; },
  "UniqueFragmentNamesRule": function() { return /* reexport */ UniqueFragmentNamesRule; },
  "UniqueInputFieldNamesRule": function() { return /* reexport */ UniqueInputFieldNamesRule; },
  "UniqueOperationNamesRule": function() { return /* reexport */ UniqueOperationNamesRule; },
  "UniqueOperationTypesRule": function() { return /* reexport */ UniqueOperationTypesRule; },
  "UniqueTypeNamesRule": function() { return /* reexport */ UniqueTypeNamesRule; },
  "UniqueVariableNamesRule": function() { return /* reexport */ UniqueVariableNamesRule; },
  "ValidationContext": function() { return /* reexport */ ValidationContext; },
  "ValuesOfCorrectTypeRule": function() { return /* reexport */ ValuesOfCorrectTypeRule; },
  "VariablesAreInputTypesRule": function() { return /* reexport */ VariablesAreInputTypesRule; },
  "VariablesInAllowedPositionRule": function() { return /* reexport */ VariablesInAllowedPositionRule; },
  "__Directive": function() { return /* reexport */ __Directive; },
  "__DirectiveLocation": function() { return /* reexport */ __DirectiveLocation; },
  "__EnumValue": function() { return /* reexport */ __EnumValue; },
  "__Field": function() { return /* reexport */ __Field; },
  "__InputValue": function() { return /* reexport */ __InputValue; },
  "__Schema": function() { return /* reexport */ __Schema; },
  "__Type": function() { return /* reexport */ __Type; },
  "__TypeKind": function() { return /* reexport */ __TypeKind; },
  "assertAbstractType": function() { return /* reexport */ assertAbstractType; },
  "assertCompositeType": function() { return /* reexport */ assertCompositeType; },
  "assertDirective": function() { return /* reexport */ assertDirective; },
  "assertEnumType": function() { return /* reexport */ assertEnumType; },
  "assertEnumValueName": function() { return /* reexport */ assertEnumValueName; },
  "assertInputObjectType": function() { return /* reexport */ assertInputObjectType; },
  "assertInputType": function() { return /* reexport */ assertInputType; },
  "assertInterfaceType": function() { return /* reexport */ assertInterfaceType; },
  "assertLeafType": function() { return /* reexport */ assertLeafType; },
  "assertListType": function() { return /* reexport */ assertListType; },
  "assertName": function() { return /* reexport */ assertName; },
  "assertNamedType": function() { return /* reexport */ assertNamedType; },
  "assertNonNullType": function() { return /* reexport */ assertNonNullType; },
  "assertNullableType": function() { return /* reexport */ assertNullableType; },
  "assertObjectType": function() { return /* reexport */ assertObjectType; },
  "assertOutputType": function() { return /* reexport */ assertOutputType; },
  "assertScalarType": function() { return /* reexport */ assertScalarType; },
  "assertSchema": function() { return /* reexport */ assertSchema; },
  "assertType": function() { return /* reexport */ assertType; },
  "assertUnionType": function() { return /* reexport */ assertUnionType; },
  "assertValidName": function() { return /* reexport */ assertValidName; },
  "assertValidSchema": function() { return /* reexport */ assertValidSchema; },
  "assertWrappingType": function() { return /* reexport */ assertWrappingType; },
  "astFromValue": function() { return /* reexport */ astFromValue; },
  "buildASTSchema": function() { return /* reexport */ buildASTSchema; },
  "buildClientSchema": function() { return /* reexport */ buildClientSchema; },
  "buildSchema": function() { return /* reexport */ buildSchema; },
  "coerceInputValue": function() { return /* reexport */ coerceInputValue; },
  "concatAST": function() { return /* reexport */ concatAST; },
  "createSourceEventStream": function() { return /* reexport */ createSourceEventStream; },
  "defaultFieldResolver": function() { return /* reexport */ defaultFieldResolver; },
  "defaultTypeResolver": function() { return /* reexport */ defaultTypeResolver; },
  "doTypesOverlap": function() { return /* reexport */ doTypesOverlap; },
  "execute": function() { return /* reexport */ execute; },
  "executeSync": function() { return /* reexport */ executeSync; },
  "extendSchema": function() { return /* reexport */ extendSchema; },
  "findBreakingChanges": function() { return /* reexport */ findBreakingChanges; },
  "findDangerousChanges": function() { return /* reexport */ findDangerousChanges; },
  "formatError": function() { return /* reexport */ GraphQLError/* formatError */.Z; },
  "getArgumentValues": function() { return /* reexport */ getArgumentValues; },
  "getDirectiveValues": function() { return /* reexport */ getDirectiveValues; },
  "getEnterLeaveForKind": function() { return /* reexport */ getEnterLeaveForKind; },
  "getIntrospectionQuery": function() { return /* reexport */ getIntrospectionQuery; },
  "getLocation": function() { return /* reexport */ language_location/* getLocation */.k; },
  "getNamedType": function() { return /* reexport */ getNamedType; },
  "getNullableType": function() { return /* reexport */ getNullableType; },
  "getOperationAST": function() { return /* reexport */ getOperationAST; },
  "getOperationRootType": function() { return /* reexport */ getOperationRootType; },
  "getVariableValues": function() { return /* reexport */ getVariableValues; },
  "getVisitFn": function() { return /* reexport */ getVisitFn; },
  "graphql": function() { return /* reexport */ graphql; },
  "graphqlSync": function() { return /* reexport */ graphqlSync; },
  "introspectionFromSchema": function() { return /* reexport */ introspectionFromSchema; },
  "introspectionTypes": function() { return /* reexport */ introspectionTypes; },
  "isAbstractType": function() { return /* reexport */ isAbstractType; },
  "isCompositeType": function() { return /* reexport */ isCompositeType; },
  "isConstValueNode": function() { return /* reexport */ isConstValueNode; },
  "isDefinitionNode": function() { return /* reexport */ isDefinitionNode; },
  "isDirective": function() { return /* reexport */ isDirective; },
  "isEnumType": function() { return /* reexport */ isEnumType; },
  "isEqualType": function() { return /* reexport */ isEqualType; },
  "isExecutableDefinitionNode": function() { return /* reexport */ isExecutableDefinitionNode; },
  "isInputObjectType": function() { return /* reexport */ isInputObjectType; },
  "isInputType": function() { return /* reexport */ isInputType; },
  "isInterfaceType": function() { return /* reexport */ isInterfaceType; },
  "isIntrospectionType": function() { return /* reexport */ isIntrospectionType; },
  "isLeafType": function() { return /* reexport */ isLeafType; },
  "isListType": function() { return /* reexport */ isListType; },
  "isNamedType": function() { return /* reexport */ isNamedType; },
  "isNonNullType": function() { return /* reexport */ isNonNullType; },
  "isNullableType": function() { return /* reexport */ isNullableType; },
  "isObjectType": function() { return /* reexport */ isObjectType; },
  "isOutputType": function() { return /* reexport */ isOutputType; },
  "isRequiredArgument": function() { return /* reexport */ isRequiredArgument; },
  "isRequiredInputField": function() { return /* reexport */ isRequiredInputField; },
  "isScalarType": function() { return /* reexport */ isScalarType; },
  "isSchema": function() { return /* reexport */ isSchema; },
  "isSelectionNode": function() { return /* reexport */ isSelectionNode; },
  "isSpecifiedDirective": function() { return /* reexport */ isSpecifiedDirective; },
  "isSpecifiedScalarType": function() { return /* reexport */ isSpecifiedScalarType; },
  "isType": function() { return /* reexport */ isType; },
  "isTypeDefinitionNode": function() { return /* reexport */ isTypeDefinitionNode; },
  "isTypeExtensionNode": function() { return /* reexport */ isTypeExtensionNode; },
  "isTypeNode": function() { return /* reexport */ isTypeNode; },
  "isTypeSubTypeOf": function() { return /* reexport */ isTypeSubTypeOf; },
  "isTypeSystemDefinitionNode": function() { return /* reexport */ isTypeSystemDefinitionNode; },
  "isTypeSystemExtensionNode": function() { return /* reexport */ isTypeSystemExtensionNode; },
  "isUnionType": function() { return /* reexport */ isUnionType; },
  "isValidNameError": function() { return /* reexport */ isValidNameError; },
  "isValueNode": function() { return /* reexport */ isValueNode; },
  "isWrappingType": function() { return /* reexport */ isWrappingType; },
  "lexicographicSortSchema": function() { return /* reexport */ lexicographicSortSchema; },
  "locatedError": function() { return /* reexport */ locatedError; },
  "parse": function() { return /* reexport */ parser/* parse */.Qc; },
  "parseConstValue": function() { return /* reexport */ parser/* parseConstValue */.tl; },
  "parseType": function() { return /* reexport */ parser/* parseType */.gZ; },
  "parseValue": function() { return /* reexport */ parser/* parseValue */.H2; },
  "print": function() { return /* reexport */ print; },
  "printError": function() { return /* reexport */ GraphQLError/* printError */.OS; },
  "printIntrospectionSchema": function() { return /* reexport */ printIntrospectionSchema; },
  "printLocation": function() { return /* reexport */ printLocation/* printLocation */.Q; },
  "printSchema": function() { return /* reexport */ printSchema; },
  "printSourceLocation": function() { return /* reexport */ printLocation/* printSourceLocation */.z; },
  "printType": function() { return /* reexport */ printType; },
  "recommendedRules": function() { return /* reexport */ recommendedRules; },
  "resolveObjMapThunk": function() { return /* reexport */ resolveObjMapThunk; },
  "resolveReadonlyArrayThunk": function() { return /* reexport */ resolveReadonlyArrayThunk; },
  "responsePathAsArray": function() { return /* reexport */ pathToArray; },
  "separateOperations": function() { return /* reexport */ separateOperations; },
  "specifiedDirectives": function() { return /* reexport */ specifiedDirectives; },
  "specifiedRules": function() { return /* reexport */ specifiedRules; },
  "specifiedScalarTypes": function() { return /* reexport */ specifiedScalarTypes; },
  "stripIgnoredCharacters": function() { return /* reexport */ stripIgnoredCharacters; },
  "subscribe": function() { return /* reexport */ subscribe; },
  "syntaxError": function() { return /* reexport */ syntaxError/* syntaxError */.h; },
  "typeFromAST": function() { return /* reexport */ typeFromAST; },
  "validate": function() { return /* reexport */ validate; },
  "validateSchema": function() { return /* reexport */ validateSchema; },
  "valueFromAST": function() { return /* reexport */ valueFromAST; },
  "valueFromASTUntyped": function() { return /* reexport */ valueFromASTUntyped; },
  "version": function() { return /* reexport */ version; },
  "versionInfo": function() { return /* reexport */ versionInfo; },
  "visit": function() { return /* reexport */ visit; },
  "visitInParallel": function() { return /* reexport */ visitInParallel; },
  "visitWithTypeInfo": function() { return /* reexport */ visitWithTypeInfo; }
});

;// CONCATENATED MODULE: ../node_modules/graphql/version.mjs
// Note: This file is autogenerated using "resources/gen-version.js" script and
// automatically updated by "npm version" command.

/**
 * A string containing the version of the GraphQL.js library
 */
const version = '16.9.0';
/**
 * An object containing the components of the GraphQL.js version string
 */

const versionInfo = Object.freeze({
  major: 16,
  minor: 9,
  patch: 0,
  preReleaseTag: null,
});

// EXTERNAL MODULE: ../node_modules/graphql/jsutils/devAssert.mjs
var devAssert = __webpack_require__(34317);
;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/isPromise.mjs
/**
 * Returns true if the value acts like a Promise, i.e. has a "then" function,
 * otherwise returns false.
 */
function isPromise(value) {
  return (
    typeof (value === null || value === void 0 ? void 0 : value.then) ===
    'function'
  );
}

// EXTERNAL MODULE: ../node_modules/graphql/language/parser.mjs
var parser = __webpack_require__(65449);
// EXTERNAL MODULE: ../node_modules/graphql/jsutils/inspect.mjs
var inspect = __webpack_require__(59329);
// EXTERNAL MODULE: ../node_modules/graphql/error/GraphQLError.mjs
var GraphQLError = __webpack_require__(7990);
// EXTERNAL MODULE: ../node_modules/graphql/language/ast.mjs
var ast = __webpack_require__(35239);
;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/didYouMean.mjs
const MAX_SUGGESTIONS = 5;
/**
 * Given [ A, B, C ] return ' Did you mean A, B, or C?'.
 */

function didYouMean(firstArg, secondArg) {
  const [subMessage, suggestionsArg] = secondArg
    ? [firstArg, secondArg]
    : [undefined, firstArg];
  let message = ' Did you mean ';

  if (subMessage) {
    message += subMessage + ' ';
  }

  const suggestions = suggestionsArg.map((x) => `"${x}"`);

  switch (suggestions.length) {
    case 0:
      return '';

    case 1:
      return message + suggestions[0] + '?';

    case 2:
      return message + suggestions[0] + ' or ' + suggestions[1] + '?';
  }

  const selected = suggestions.slice(0, MAX_SUGGESTIONS);
  const lastItem = selected.pop();
  return message + selected.join(', ') + ', or ' + lastItem + '?';
}

;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/identityFunc.mjs
/**
 * Returns the first argument it receives.
 */
function identityFunc(x) {
  return x;
}

// EXTERNAL MODULE: ../node_modules/graphql/jsutils/instanceOf.mjs
var instanceOf = __webpack_require__(93956);
// EXTERNAL MODULE: ../node_modules/graphql/jsutils/isObjectLike.mjs
var isObjectLike = __webpack_require__(52689);
;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/keyMap.mjs
/**
 * Creates a keyed JS object from an array, given a function to produce the keys
 * for each value in the array.
 *
 * This provides a convenient lookup for the array items if the key function
 * produces unique results.
 * ```ts
 * const phoneBook = [
 *   { name: 'Jon', num: '555-1234' },
 *   { name: 'Jenny', num: '867-5309' }
 * ]
 *
 * const entriesByName = keyMap(
 *   phoneBook,
 *   entry => entry.name
 * )
 *
 * // {
 * //   Jon: { name: 'Jon', num: '555-1234' },
 * //   Jenny: { name: 'Jenny', num: '867-5309' }
 * // }
 *
 * const jennyEntry = entriesByName['Jenny']
 *
 * // { name: 'Jenny', num: '857-6309' }
 * ```
 */
function keyMap(list, keyFn) {
  const result = Object.create(null);

  for (const item of list) {
    result[keyFn(item)] = item;
  }

  return result;
}

;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/keyValMap.mjs
/**
 * Creates a keyed JS object from an array, given a function to produce the keys
 * and a function to produce the values from each item in the array.
 * ```ts
 * const phoneBook = [
 *   { name: 'Jon', num: '555-1234' },
 *   { name: 'Jenny', num: '867-5309' }
 * ]
 *
 * // { Jon: '555-1234', Jenny: '867-5309' }
 * const phonesByName = keyValMap(
 *   phoneBook,
 *   entry => entry.name,
 *   entry => entry.num
 * )
 * ```
 */
function keyValMap(list, keyFn, valFn) {
  const result = Object.create(null);

  for (const item of list) {
    result[keyFn(item)] = valFn(item);
  }

  return result;
}

;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/mapValue.mjs
/**
 * Creates an object map with the same keys as `map` and values generated by
 * running each value of `map` thru `fn`.
 */
function mapValue(map, fn) {
  const result = Object.create(null);

  for (const key of Object.keys(map)) {
    result[key] = fn(map[key], key);
  }

  return result;
}

;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/naturalCompare.mjs
/**
 * Returns a number indicating whether a reference string comes before, or after,
 * or is the same as the given string in natural sort order.
 *
 * See: https://en.wikipedia.org/wiki/Natural_sort_order
 *
 */
function naturalCompare(aStr, bStr) {
  let aIndex = 0;
  let bIndex = 0;

  while (aIndex < aStr.length && bIndex < bStr.length) {
    let aChar = aStr.charCodeAt(aIndex);
    let bChar = bStr.charCodeAt(bIndex);

    if (isDigit(aChar) && isDigit(bChar)) {
      let aNum = 0;

      do {
        ++aIndex;
        aNum = aNum * 10 + aChar - DIGIT_0;
        aChar = aStr.charCodeAt(aIndex);
      } while (isDigit(aChar) && aNum > 0);

      let bNum = 0;

      do {
        ++bIndex;
        bNum = bNum * 10 + bChar - DIGIT_0;
        bChar = bStr.charCodeAt(bIndex);
      } while (isDigit(bChar) && bNum > 0);

      if (aNum < bNum) {
        return -1;
      }

      if (aNum > bNum) {
        return 1;
      }
    } else {
      if (aChar < bChar) {
        return -1;
      }

      if (aChar > bChar) {
        return 1;
      }

      ++aIndex;
      ++bIndex;
    }
  }

  return aStr.length - bStr.length;
}
const DIGIT_0 = 48;
const DIGIT_9 = 57;

function isDigit(code) {
  return !isNaN(code) && DIGIT_0 <= code && code <= DIGIT_9;
}

;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/suggestionList.mjs

/**
 * Given an invalid input string and a list of valid options, returns a filtered
 * list of valid options sorted based on their similarity with the input.
 */

function suggestionList(input, options) {
  const optionsByDistance = Object.create(null);
  const lexicalDistance = new LexicalDistance(input);
  const threshold = Math.floor(input.length * 0.4) + 1;

  for (const option of options) {
    const distance = lexicalDistance.measure(option, threshold);

    if (distance !== undefined) {
      optionsByDistance[option] = distance;
    }
  }

  return Object.keys(optionsByDistance).sort((a, b) => {
    const distanceDiff = optionsByDistance[a] - optionsByDistance[b];
    return distanceDiff !== 0 ? distanceDiff : naturalCompare(a, b);
  });
}
/**
 * Computes the lexical distance between strings A and B.
 *
 * The "distance" between two strings is given by counting the minimum number
 * of edits needed to transform string A into string B. An edit can be an
 * insertion, deletion, or substitution of a single character, or a swap of two
 * adjacent characters.
 *
 * Includes a custom alteration from Damerau-Levenshtein to treat case changes
 * as a single edit which helps identify mis-cased values with an edit distance
 * of 1.
 *
 * This distance can be useful for detecting typos in input or sorting
 */

class LexicalDistance {
  constructor(input) {
    this._input = input;
    this._inputLowerCase = input.toLowerCase();
    this._inputArray = stringToArray(this._inputLowerCase);
    this._rows = [
      new Array(input.length + 1).fill(0),
      new Array(input.length + 1).fill(0),
      new Array(input.length + 1).fill(0),
    ];
  }

  measure(option, threshold) {
    if (this._input === option) {
      return 0;
    }

    const optionLowerCase = option.toLowerCase(); // Any case change counts as a single edit

    if (this._inputLowerCase === optionLowerCase) {
      return 1;
    }

    let a = stringToArray(optionLowerCase);
    let b = this._inputArray;

    if (a.length < b.length) {
      const tmp = a;
      a = b;
      b = tmp;
    }

    const aLength = a.length;
    const bLength = b.length;

    if (aLength - bLength > threshold) {
      return undefined;
    }

    const rows = this._rows;

    for (let j = 0; j <= bLength; j++) {
      rows[0][j] = j;
    }

    for (let i = 1; i <= aLength; i++) {
      const upRow = rows[(i - 1) % 3];
      const currentRow = rows[i % 3];
      let smallestCell = (currentRow[0] = i);

      for (let j = 1; j <= bLength; j++) {
        const cost = a[i - 1] === b[j - 1] ? 0 : 1;
        let currentCell = Math.min(
          upRow[j] + 1, // delete
          currentRow[j - 1] + 1, // insert
          upRow[j - 1] + cost, // substitute
        );

        if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) {
          // transposition
          const doubleDiagonalCell = rows[(i - 2) % 3][j - 2];
          currentCell = Math.min(currentCell, doubleDiagonalCell + 1);
        }

        if (currentCell < smallestCell) {
          smallestCell = currentCell;
        }

        currentRow[j] = currentCell;
      } // Early exit, since distance can't go smaller than smallest element of the previous row.

      if (smallestCell > threshold) {
        return undefined;
      }
    }

    const distance = rows[aLength % 3][bLength];
    return distance <= threshold ? distance : undefined;
  }
}

function stringToArray(str) {
  const strLength = str.length;
  const array = new Array(strLength);

  for (let i = 0; i < strLength; ++i) {
    array[i] = str.charCodeAt(i);
  }

  return array;
}

;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/toObjMap.mjs
function toObjMap(obj) {
  if (obj == null) {
    return Object.create(null);
  }

  if (Object.getPrototypeOf(obj) === null) {
    return obj;
  }

  const map = Object.create(null);

  for (const [key, value] of Object.entries(obj)) {
    map[key] = value;
  }

  return map;
}

// EXTERNAL MODULE: ../node_modules/graphql/language/kinds.mjs
var kinds = __webpack_require__(57554);
// EXTERNAL MODULE: ../node_modules/graphql/language/blockString.mjs
var language_blockString = __webpack_require__(25965);
;// CONCATENATED MODULE: ../node_modules/graphql/language/printString.mjs
/**
 * Prints a string as a GraphQL StringValue literal. Replaces control characters
 * and excluded characters (" U+0022 and \\ U+005C) with escape sequences.
 */
function printString(str) {
  return `"${str.replace(escapedRegExp, escapedReplacer)}"`;
} // eslint-disable-next-line no-control-regex

const escapedRegExp = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;

function escapedReplacer(str) {
  return escapeSequences[str.charCodeAt(0)];
} // prettier-ignore

const escapeSequences = [
  '\\u0000',
  '\\u0001',
  '\\u0002',
  '\\u0003',
  '\\u0004',
  '\\u0005',
  '\\u0006',
  '\\u0007',
  '\\b',
  '\\t',
  '\\n',
  '\\u000B',
  '\\f',
  '\\r',
  '\\u000E',
  '\\u000F',
  '\\u0010',
  '\\u0011',
  '\\u0012',
  '\\u0013',
  '\\u0014',
  '\\u0015',
  '\\u0016',
  '\\u0017',
  '\\u0018',
  '\\u0019',
  '\\u001A',
  '\\u001B',
  '\\u001C',
  '\\u001D',
  '\\u001E',
  '\\u001F',
  '',
  '',
  '\\"',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '', // 2F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '', // 3F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '', // 4F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '\\\\',
  '',
  '',
  '', // 5F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '', // 6F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '\\u007F',
  '\\u0080',
  '\\u0081',
  '\\u0082',
  '\\u0083',
  '\\u0084',
  '\\u0085',
  '\\u0086',
  '\\u0087',
  '\\u0088',
  '\\u0089',
  '\\u008A',
  '\\u008B',
  '\\u008C',
  '\\u008D',
  '\\u008E',
  '\\u008F',
  '\\u0090',
  '\\u0091',
  '\\u0092',
  '\\u0093',
  '\\u0094',
  '\\u0095',
  '\\u0096',
  '\\u0097',
  '\\u0098',
  '\\u0099',
  '\\u009A',
  '\\u009B',
  '\\u009C',
  '\\u009D',
  '\\u009E',
  '\\u009F',
];

;// CONCATENATED MODULE: ../node_modules/graphql/language/visitor.mjs




/**
 * A visitor is provided to visit, it contains the collection of
 * relevant functions to be called during the visitor's traversal.
 */

const BREAK = Object.freeze({});
/**
 * visit() will walk through an AST using a depth-first traversal, calling
 * the visitor's enter function at each node in the traversal, and calling the
 * leave function after visiting that node and all of its child nodes.
 *
 * By returning different values from the enter and leave functions, the
 * behavior of the visitor can be altered, including skipping over a sub-tree of
 * the AST (by returning false), editing the AST by returning a value or null
 * to remove the value, or to stop the whole traversal by returning BREAK.
 *
 * When using visit() to edit an AST, the original AST will not be modified, and
 * a new version of the AST with the changes applied will be returned from the
 * visit function.
 *
 * ```ts
 * const editedAST = visit(ast, {
 *   enter(node, key, parent, path, ancestors) {
 *     // @return
 *     //   undefined: no action
 *     //   false: skip visiting this node
 *     //   visitor.BREAK: stop visiting altogether
 *     //   null: delete this node
 *     //   any value: replace this node with the returned value
 *   },
 *   leave(node, key, parent, path, ancestors) {
 *     // @return
 *     //   undefined: no action
 *     //   false: no action
 *     //   visitor.BREAK: stop visiting altogether
 *     //   null: delete this node
 *     //   any value: replace this node with the returned value
 *   }
 * });
 * ```
 *
 * Alternatively to providing enter() and leave() functions, a visitor can
 * instead provide functions named the same as the kinds of AST nodes, or
 * enter/leave visitors at a named key, leading to three permutations of the
 * visitor API:
 *
 * 1) Named visitors triggered when entering a node of a specific kind.
 *
 * ```ts
 * visit(ast, {
 *   Kind(node) {
 *     // enter the "Kind" node
 *   }
 * })
 * ```
 *
 * 2) Named visitors that trigger upon entering and leaving a node of a specific kind.
 *
 * ```ts
 * visit(ast, {
 *   Kind: {
 *     enter(node) {
 *       // enter the "Kind" node
 *     }
 *     leave(node) {
 *       // leave the "Kind" node
 *     }
 *   }
 * })
 * ```
 *
 * 3) Generic visitors that trigger upon entering and leaving any node.
 *
 * ```ts
 * visit(ast, {
 *   enter(node) {
 *     // enter any node
 *   },
 *   leave(node) {
 *     // leave any node
 *   }
 * })
 * ```
 */

function visit(root, visitor, visitorKeys = ast/* QueryDocumentKeys */.h8) {
  const enterLeaveMap = new Map();

  for (const kind of Object.values(kinds/* Kind */.h)) {
    enterLeaveMap.set(kind, getEnterLeaveForKind(visitor, kind));
  }
  /* eslint-disable no-undef-init */

  let stack = undefined;
  let inArray = Array.isArray(root);
  let keys = [root];
  let index = -1;
  let edits = [];
  let node = root;
  let key = undefined;
  let parent = undefined;
  const path = [];
  const ancestors = [];
  /* eslint-enable no-undef-init */

  do {
    index++;
    const isLeaving = index === keys.length;
    const isEdited = isLeaving && edits.length !== 0;

    if (isLeaving) {
      key = ancestors.length === 0 ? undefined : path[path.length - 1];
      node = parent;
      parent = ancestors.pop();

      if (isEdited) {
        if (inArray) {
          node = node.slice();
          let editOffset = 0;

          for (const [editKey, editValue] of edits) {
            const arrayKey = editKey - editOffset;

            if (editValue === null) {
              node.splice(arrayKey, 1);
              editOffset++;
            } else {
              node[arrayKey] = editValue;
            }
          }
        } else {
          node = Object.defineProperties(
            {},
            Object.getOwnPropertyDescriptors(node),
          );

          for (const [editKey, editValue] of edits) {
            node[editKey] = editValue;
          }
        }
      }

      index = stack.index;
      keys = stack.keys;
      edits = stack.edits;
      inArray = stack.inArray;
      stack = stack.prev;
    } else if (parent) {
      key = inArray ? index : keys[index];
      node = parent[key];

      if (node === null || node === undefined) {
        continue;
      }

      path.push(key);
    }

    let result;

    if (!Array.isArray(node)) {
      var _enterLeaveMap$get, _enterLeaveMap$get2;

      (0,ast/* isNode */.UG)(node) || (0,devAssert/* devAssert */.a)(false, `Invalid AST Node: ${(0,inspect/* inspect */.X)(node)}.`);
      const visitFn = isLeaving
        ? (_enterLeaveMap$get = enterLeaveMap.get(node.kind)) === null ||
          _enterLeaveMap$get === void 0
          ? void 0
          : _enterLeaveMap$get.leave
        : (_enterLeaveMap$get2 = enterLeaveMap.get(node.kind)) === null ||
          _enterLeaveMap$get2 === void 0
        ? void 0
        : _enterLeaveMap$get2.enter;
      result =
        visitFn === null || visitFn === void 0
          ? void 0
          : visitFn.call(visitor, node, key, parent, path, ancestors);

      if (result === BREAK) {
        break;
      }

      if (result === false) {
        if (!isLeaving) {
          path.pop();
          continue;
        }
      } else if (result !== undefined) {
        edits.push([key, result]);

        if (!isLeaving) {
          if ((0,ast/* isNode */.UG)(result)) {
            node = result;
          } else {
            path.pop();
            continue;
          }
        }
      }
    }

    if (result === undefined && isEdited) {
      edits.push([key, node]);
    }

    if (isLeaving) {
      path.pop();
    } else {
      var _node$kind;

      stack = {
        inArray,
        index,
        keys,
        edits,
        prev: stack,
      };
      inArray = Array.isArray(node);
      keys = inArray
        ? node
        : (_node$kind = visitorKeys[node.kind]) !== null &&
          _node$kind !== void 0
        ? _node$kind
        : [];
      index = -1;
      edits = [];

      if (parent) {
        ancestors.push(parent);
      }

      parent = node;
    }
  } while (stack !== undefined);

  if (edits.length !== 0) {
    // New root
    return edits[edits.length - 1][1];
  }

  return root;
}
/**
 * Creates a new visitor instance which delegates to many visitors to run in
 * parallel. Each visitor will be visited for each node before moving on.
 *
 * If a prior visitor edits a node, no following visitors will see that node.
 */

function visitInParallel(visitors) {
  const skipping = new Array(visitors.length).fill(null);
  const mergedVisitor = Object.create(null);

  for (const kind of Object.values(kinds/* Kind */.h)) {
    let hasVisitor = false;
    const enterList = new Array(visitors.length).fill(undefined);
    const leaveList = new Array(visitors.length).fill(undefined);

    for (let i = 0; i < visitors.length; ++i) {
      const { enter, leave } = getEnterLeaveForKind(visitors[i], kind);
      hasVisitor || (hasVisitor = enter != null || leave != null);
      enterList[i] = enter;
      leaveList[i] = leave;
    }

    if (!hasVisitor) {
      continue;
    }

    const mergedEnterLeave = {
      enter(...args) {
        const node = args[0];

        for (let i = 0; i < visitors.length; i++) {
          if (skipping[i] === null) {
            var _enterList$i;

            const result =
              (_enterList$i = enterList[i]) === null || _enterList$i === void 0
                ? void 0
                : _enterList$i.apply(visitors[i], args);

            if (result === false) {
              skipping[i] = node;
            } else if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined) {
              return result;
            }
          }
        }
      },

      leave(...args) {
        const node = args[0];

        for (let i = 0; i < visitors.length; i++) {
          if (skipping[i] === null) {
            var _leaveList$i;

            const result =
              (_leaveList$i = leaveList[i]) === null || _leaveList$i === void 0
                ? void 0
                : _leaveList$i.apply(visitors[i], args);

            if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined && result !== false) {
              return result;
            }
          } else if (skipping[i] === node) {
            skipping[i] = null;
          }
        }
      },
    };
    mergedVisitor[kind] = mergedEnterLeave;
  }

  return mergedVisitor;
}
/**
 * Given a visitor instance and a node kind, return EnterLeaveVisitor for that kind.
 */

function getEnterLeaveForKind(visitor, kind) {
  const kindVisitor = visitor[kind];

  if (typeof kindVisitor === 'object') {
    // { Kind: { enter() {}, leave() {} } }
    return kindVisitor;
  } else if (typeof kindVisitor === 'function') {
    // { Kind() {} }
    return {
      enter: kindVisitor,
      leave: undefined,
    };
  } // { enter() {}, leave() {} }

  return {
    enter: visitor.enter,
    leave: visitor.leave,
  };
}
/**
 * Given a visitor instance, if it is leaving or not, and a node kind, return
 * the function the visitor runtime should call.
 *
 * @deprecated Please use `getEnterLeaveForKind` instead. Will be removed in v17
 */

/* c8 ignore next 8 */

function getVisitFn(visitor, kind, isLeaving) {
  const { enter, leave } = getEnterLeaveForKind(visitor, kind);
  return isLeaving ? leave : enter;
}

;// CONCATENATED MODULE: ../node_modules/graphql/language/printer.mjs



/**
 * Converts an AST into a string, using one set of reasonable
 * formatting rules.
 */

function print(ast) {
  return visit(ast, printDocASTReducer);
}
const MAX_LINE_LENGTH = 80;
const printDocASTReducer = {
  Name: {
    leave: (node) => node.value,
  },
  Variable: {
    leave: (node) => '$' + node.name,
  },
  // Document
  Document: {
    leave: (node) => join(node.definitions, '\n\n'),
  },
  OperationDefinition: {
    leave(node) {
      const varDefs = wrap('(', join(node.variableDefinitions, ', '), ')');
      const prefix = join(
        [
          node.operation,
          join([node.name, varDefs]),
          join(node.directives, ' '),
        ],
        ' ',
      ); // Anonymous queries with no directives or variable definitions can use
      // the query short form.

      return (prefix === 'query' ? '' : prefix + ' ') + node.selectionSet;
    },
  },
  VariableDefinition: {
    leave: ({ variable, type, defaultValue, directives }) =>
      variable +
      ': ' +
      type +
      wrap(' = ', defaultValue) +
      wrap(' ', join(directives, ' ')),
  },
  SelectionSet: {
    leave: ({ selections }) => block(selections),
  },
  Field: {
    leave({ alias, name, arguments: args, directives, selectionSet }) {
      const prefix = wrap('', alias, ': ') + name;
      let argsLine = prefix + wrap('(', join(args, ', '), ')');

      if (argsLine.length > MAX_LINE_LENGTH) {
        argsLine = prefix + wrap('(\n', indent(join(args, '\n')), '\n)');
      }

      return join([argsLine, join(directives, ' '), selectionSet], ' ');
    },
  },
  Argument: {
    leave: ({ name, value }) => name + ': ' + value,
  },
  // Fragments
  FragmentSpread: {
    leave: ({ name, directives }) =>
      '...' + name + wrap(' ', join(directives, ' ')),
  },
  InlineFragment: {
    leave: ({ typeCondition, directives, selectionSet }) =>
      join(
        [
          '...',
          wrap('on ', typeCondition),
          join(directives, ' '),
          selectionSet,
        ],
        ' ',
      ),
  },
  FragmentDefinition: {
    leave: (
      { name, typeCondition, variableDefinitions, directives, selectionSet }, // Note: fragment variable definitions are experimental and may be changed
    ) =>
      // or removed in the future.
      `fragment ${name}${wrap('(', join(variableDefinitions, ', '), ')')} ` +
      `on ${typeCondition} ${wrap('', join(directives, ' '), ' ')}` +
      selectionSet,
  },
  // Value
  IntValue: {
    leave: ({ value }) => value,
  },
  FloatValue: {
    leave: ({ value }) => value,
  },
  StringValue: {
    leave: ({ value, block: isBlockString }) =>
      isBlockString ? (0,language_blockString/* printBlockString */.LZ)(value) : printString(value),
  },
  BooleanValue: {
    leave: ({ value }) => (value ? 'true' : 'false'),
  },
  NullValue: {
    leave: () => 'null',
  },
  EnumValue: {
    leave: ({ value }) => value,
  },
  ListValue: {
    leave: ({ values }) => '[' + join(values, ', ') + ']',
  },
  ObjectValue: {
    leave: ({ fields }) => '{' + join(fields, ', ') + '}',
  },
  ObjectField: {
    leave: ({ name, value }) => name + ': ' + value,
  },
  // Directive
  Directive: {
    leave: ({ name, arguments: args }) =>
      '@' + name + wrap('(', join(args, ', '), ')'),
  },
  // Type
  NamedType: {
    leave: ({ name }) => name,
  },
  ListType: {
    leave: ({ type }) => '[' + type + ']',
  },
  NonNullType: {
    leave: ({ type }) => type + '!',
  },
  // Type System Definitions
  SchemaDefinition: {
    leave: ({ description, directives, operationTypes }) =>
      wrap('', description, '\n') +
      join(['schema', join(directives, ' '), block(operationTypes)], ' '),
  },
  OperationTypeDefinition: {
    leave: ({ operation, type }) => operation + ': ' + type,
  },
  ScalarTypeDefinition: {
    leave: ({ description, name, directives }) =>
      wrap('', description, '\n') +
      join(['scalar', name, join(directives, ' ')], ' '),
  },
  ObjectTypeDefinition: {
    leave: ({ description, name, interfaces, directives, fields }) =>
      wrap('', description, '\n') +
      join(
        [
          'type',
          name,
          wrap('implements ', join(interfaces, ' & ')),
          join(directives, ' '),
          block(fields),
        ],
        ' ',
      ),
  },
  FieldDefinition: {
    leave: ({ description, name, arguments: args, type, directives }) =>
      wrap('', description, '\n') +
      name +
      (hasMultilineItems(args)
        ? wrap('(\n', indent(join(args, '\n')), '\n)')
        : wrap('(', join(args, ', '), ')')) +
      ': ' +
      type +
      wrap(' ', join(directives, ' ')),
  },
  InputValueDefinition: {
    leave: ({ description, name, type, defaultValue, directives }) =>
      wrap('', description, '\n') +
      join(
        [name + ': ' + type, wrap('= ', defaultValue), join(directives, ' ')],
        ' ',
      ),
  },
  InterfaceTypeDefinition: {
    leave: ({ description, name, interfaces, directives, fields }) =>
      wrap('', description, '\n') +
      join(
        [
          'interface',
          name,
          wrap('implements ', join(interfaces, ' & ')),
          join(directives, ' '),
          block(fields),
        ],
        ' ',
      ),
  },
  UnionTypeDefinition: {
    leave: ({ description, name, directives, types }) =>
      wrap('', description, '\n') +
      join(
        ['union', name, join(directives, ' '), wrap('= ', join(types, ' | '))],
        ' ',
      ),
  },
  EnumTypeDefinition: {
    leave: ({ description, name, directives, values }) =>
      wrap('', description, '\n') +
      join(['enum', name, join(directives, ' '), block(values)], ' '),
  },
  EnumValueDefinition: {
    leave: ({ description, name, directives }) =>
      wrap('', description, '\n') + join([name, join(directives, ' ')], ' '),
  },
  InputObjectTypeDefinition: {
    leave: ({ description, name, directives, fields }) =>
      wrap('', description, '\n') +
      join(['input', name, join(directives, ' '), block(fields)], ' '),
  },
  DirectiveDefinition: {
    leave: ({ description, name, arguments: args, repeatable, locations }) =>
      wrap('', description, '\n') +
      'directive @' +
      name +
      (hasMultilineItems(args)
        ? wrap('(\n', indent(join(args, '\n')), '\n)')
        : wrap('(', join(args, ', '), ')')) +
      (repeatable ? ' repeatable' : '') +
      ' on ' +
      join(locations, ' | '),
  },
  SchemaExtension: {
    leave: ({ directives, operationTypes }) =>
      join(
        ['extend schema', join(directives, ' '), block(operationTypes)],
        ' ',
      ),
  },
  ScalarTypeExtension: {
    leave: ({ name, directives }) =>
      join(['extend scalar', name, join(directives, ' ')], ' '),
  },
  ObjectTypeExtension: {
    leave: ({ name, interfaces, directives, fields }) =>
      join(
        [
          'extend type',
          name,
          wrap('implements ', join(interfaces, ' & ')),
          join(directives, ' '),
          block(fields),
        ],
        ' ',
      ),
  },
  InterfaceTypeExtension: {
    leave: ({ name, interfaces, directives, fields }) =>
      join(
        [
          'extend interface',
          name,
          wrap('implements ', join(interfaces, ' & ')),
          join(directives, ' '),
          block(fields),
        ],
        ' ',
      ),
  },
  UnionTypeExtension: {
    leave: ({ name, directives, types }) =>
      join(
        [
          'extend union',
          name,
          join(directives, ' '),
          wrap('= ', join(types, ' | ')),
        ],
        ' ',
      ),
  },
  EnumTypeExtension: {
    leave: ({ name, directives, values }) =>
      join(['extend enum', name, join(directives, ' '), block(values)], ' '),
  },
  InputObjectTypeExtension: {
    leave: ({ name, directives, fields }) =>
      join(['extend input', name, join(directives, ' '), block(fields)], ' '),
  },
};
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */

function join(maybeArray, separator = '') {
  var _maybeArray$filter$jo;

  return (_maybeArray$filter$jo =
    maybeArray === null || maybeArray === void 0
      ? void 0
      : maybeArray.filter((x) => x).join(separator)) !== null &&
    _maybeArray$filter$jo !== void 0
    ? _maybeArray$filter$jo
    : '';
}
/**
 * Given array, print each item on its own line, wrapped in an indented `{ }` block.
 */

function block(array) {
  return wrap('{\n', indent(join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */

function wrap(start, maybeString, end = '') {
  return maybeString != null && maybeString !== ''
    ? start + maybeString + end
    : '';
}

function indent(str) {
  return wrap('  ', str.replace(/\n/g, '\n  '));
}

function hasMultilineItems(maybeArray) {
  var _maybeArray$some;

  // FIXME: https://github.com/graphql/graphql-js/issues/2203

  /* c8 ignore next */
  return (_maybeArray$some =
    maybeArray === null || maybeArray === void 0
      ? void 0
      : maybeArray.some((str) => str.includes('\n'))) !== null &&
    _maybeArray$some !== void 0
    ? _maybeArray$some
    : false;
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/valueFromASTUntyped.mjs


/**
 * Produces a JavaScript value given a GraphQL Value AST.
 *
 * Unlike `valueFromAST()`, no type is provided. The resulting JavaScript value
 * will reflect the provided GraphQL value AST.
 *
 * | GraphQL Value        | JavaScript Value |
 * | -------------------- | ---------------- |
 * | Input Object         | Object           |
 * | List                 | Array            |
 * | Boolean              | Boolean          |
 * | String / Enum        | String           |
 * | Int / Float          | Number           |
 * | Null                 | null             |
 *
 */

function valueFromASTUntyped(valueNode, variables) {
  switch (valueNode.kind) {
    case kinds/* Kind.NULL */.h.NULL:
      return null;

    case kinds/* Kind.INT */.h.INT:
      return parseInt(valueNode.value, 10);

    case kinds/* Kind.FLOAT */.h.FLOAT:
      return parseFloat(valueNode.value);

    case kinds/* Kind.STRING */.h.STRING:
    case kinds/* Kind.ENUM */.h.ENUM:
    case kinds/* Kind.BOOLEAN */.h.BOOLEAN:
      return valueNode.value;

    case kinds/* Kind.LIST */.h.LIST:
      return valueNode.values.map((node) =>
        valueFromASTUntyped(node, variables),
      );

    case kinds/* Kind.OBJECT */.h.OBJECT:
      return keyValMap(
        valueNode.fields,
        (field) => field.name.value,
        (field) => valueFromASTUntyped(field.value, variables),
      );

    case kinds/* Kind.VARIABLE */.h.VARIABLE:
      return variables === null || variables === void 0
        ? void 0
        : variables[valueNode.name.value];
  }
}

// EXTERNAL MODULE: ../node_modules/graphql/language/characterClasses.mjs
var characterClasses = __webpack_require__(76714);
;// CONCATENATED MODULE: ../node_modules/graphql/type/assertName.mjs



/**
 * Upholds the spec rules about naming.
 */

function assertName(name) {
  name != null || (0,devAssert/* devAssert */.a)(false, 'Must provide name.');
  typeof name === 'string' || (0,devAssert/* devAssert */.a)(false, 'Expected name to be a string.');

  if (name.length === 0) {
    throw new GraphQLError/* GraphQLError */.__('Expected name to be a non-empty string.');
  }

  for (let i = 1; i < name.length; ++i) {
    if (!(0,characterClasses/* isNameContinue */.HQ)(name.charCodeAt(i))) {
      throw new GraphQLError/* GraphQLError */.__(
        `Names must only contain [_a-zA-Z0-9] but "${name}" does not.`,
      );
    }
  }

  if (!(0,characterClasses/* isNameStart */.LQ)(name.charCodeAt(0))) {
    throw new GraphQLError/* GraphQLError */.__(
      `Names must start with [_a-zA-Z] but "${name}" does not.`,
    );
  }

  return name;
}
/**
 * Upholds the spec rules about naming enum values.
 *
 * @internal
 */

function assertEnumValueName(name) {
  if (name === 'true' || name === 'false' || name === 'null') {
    throw new GraphQLError/* GraphQLError */.__(`Enum values cannot be named: ${name}`);
  }

  return assertName(name);
}

;// CONCATENATED MODULE: ../node_modules/graphql/type/definition.mjs
















function isType(type) {
  return (
    isScalarType(type) ||
    isObjectType(type) ||
    isInterfaceType(type) ||
    isUnionType(type) ||
    isEnumType(type) ||
    isInputObjectType(type) ||
    isListType(type) ||
    isNonNullType(type)
  );
}
function assertType(type) {
  if (!isType(type)) {
    throw new Error(`Expected ${(0,inspect/* inspect */.X)(type)} to be a GraphQL type.`);
  }

  return type;
}
/**
 * There are predicates for each kind of GraphQL type.
 */

function isScalarType(type) {
  return (0,instanceOf/* instanceOf */.n)(type, GraphQLScalarType);
}
function assertScalarType(type) {
  if (!isScalarType(type)) {
    throw new Error(`Expected ${(0,inspect/* inspect */.X)(type)} to be a GraphQL Scalar type.`);
  }

  return type;
}
function isObjectType(type) {
  return (0,instanceOf/* instanceOf */.n)(type, GraphQLObjectType);
}
function assertObjectType(type) {
  if (!isObjectType(type)) {
    throw new Error(`Expected ${(0,inspect/* inspect */.X)(type)} to be a GraphQL Object type.`);
  }

  return type;
}
function isInterfaceType(type) {
  return (0,instanceOf/* instanceOf */.n)(type, GraphQLInterfaceType);
}
function assertInterfaceType(type) {
  if (!isInterfaceType(type)) {
    throw new Error(
      `Expected ${(0,inspect/* inspect */.X)(type)} to be a GraphQL Interface type.`,
    );
  }

  return type;
}
function isUnionType(type) {
  return (0,instanceOf/* instanceOf */.n)(type, GraphQLUnionType);
}
function assertUnionType(type) {
  if (!isUnionType(type)) {
    throw new Error(`Expected ${(0,inspect/* inspect */.X)(type)} to be a GraphQL Union type.`);
  }

  return type;
}
function isEnumType(type) {
  return (0,instanceOf/* instanceOf */.n)(type, GraphQLEnumType);
}
function assertEnumType(type) {
  if (!isEnumType(type)) {
    throw new Error(`Expected ${(0,inspect/* inspect */.X)(type)} to be a GraphQL Enum type.`);
  }

  return type;
}
function isInputObjectType(type) {
  return (0,instanceOf/* instanceOf */.n)(type, GraphQLInputObjectType);
}
function assertInputObjectType(type) {
  if (!isInputObjectType(type)) {
    throw new Error(
      `Expected ${(0,inspect/* inspect */.X)(type)} to be a GraphQL Input Object type.`,
    );
  }

  return type;
}
function isListType(type) {
  return (0,instanceOf/* instanceOf */.n)(type, GraphQLList);
}
function assertListType(type) {
  if (!isListType(type)) {
    throw new Error(`Expected ${(0,inspect/* inspect */.X)(type)} to be a GraphQL List type.`);
  }

  return type;
}
function isNonNullType(type) {
  return (0,instanceOf/* instanceOf */.n)(type, GraphQLNonNull);
}
function assertNonNullType(type) {
  if (!isNonNullType(type)) {
    throw new Error(`Expected ${(0,inspect/* inspect */.X)(type)} to be a GraphQL Non-Null type.`);
  }

  return type;
}
/**
 * These types may be used as input types for arguments and directives.
 */

function isInputType(type) {
  return (
    isScalarType(type) ||
    isEnumType(type) ||
    isInputObjectType(type) ||
    (isWrappingType(type) && isInputType(type.ofType))
  );
}
function assertInputType(type) {
  if (!isInputType(type)) {
    throw new Error(`Expected ${(0,inspect/* inspect */.X)(type)} to be a GraphQL input type.`);
  }

  return type;
}
/**
 * These types may be used as output types as the result of fields.
 */

function isOutputType(type) {
  return (
    isScalarType(type) ||
    isObjectType(type) ||
    isInterfaceType(type) ||
    isUnionType(type) ||
    isEnumType(type) ||
    (isWrappingType(type) && isOutputType(type.ofType))
  );
}
function assertOutputType(type) {
  if (!isOutputType(type)) {
    throw new Error(`Expected ${(0,inspect/* inspect */.X)(type)} to be a GraphQL output type.`);
  }

  return type;
}
/**
 * These types may describe types which may be leaf values.
 */

function isLeafType(type) {
  return isScalarType(type) || isEnumType(type);
}
function assertLeafType(type) {
  if (!isLeafType(type)) {
    throw new Error(`Expected ${(0,inspect/* inspect */.X)(type)} to be a GraphQL leaf type.`);
  }

  return type;
}
/**
 * These types may describe the parent context of a selection set.
 */

function isCompositeType(type) {
  return isObjectType(type) || isInterfaceType(type) || isUnionType(type);
}
function assertCompositeType(type) {
  if (!isCompositeType(type)) {
    throw new Error(
      `Expected ${(0,inspect/* inspect */.X)(type)} to be a GraphQL composite type.`,
    );
  }

  return type;
}
/**
 * These types may describe the parent context of a selection set.
 */

function isAbstractType(type) {
  return isInterfaceType(type) || isUnionType(type);
}
function assertAbstractType(type) {
  if (!isAbstractType(type)) {
    throw new Error(`Expected ${(0,inspect/* inspect */.X)(type)} to be a GraphQL abstract type.`);
  }

  return type;
}
/**
 * List Type Wrapper
 *
 * A list is a wrapping type which points to another type.
 * Lists are often created within the context of defining the fields of
 * an object type.
 *
 * Example:
 *
 * ```ts
 * const PersonType = new GraphQLObjectType({
 *   name: 'Person',
 *   fields: () => ({
 *     parents: { type: new GraphQLList(PersonType) },
 *     children: { type: new GraphQLList(PersonType) },
 *   })
 * })
 * ```
 */

class GraphQLList {
  constructor(ofType) {
    isType(ofType) ||
      (0,devAssert/* devAssert */.a)(false, `Expected ${(0,inspect/* inspect */.X)(ofType)} to be a GraphQL type.`);
    this.ofType = ofType;
  }

  get [Symbol.toStringTag]() {
    return 'GraphQLList';
  }

  toString() {
    return '[' + String(this.ofType) + ']';
  }

  toJSON() {
    return this.toString();
  }
}
/**
 * Non-Null Type Wrapper
 *
 * A non-null is a wrapping type which points to another type.
 * Non-null types enforce that their values are never null and can ensure
 * an error is raised if this ever occurs during a request. It is useful for
 * fields which you can make a strong guarantee on non-nullability, for example
 * usually the id field of a database row will never be null.
 *
 * Example:
 *
 * ```ts
 * const RowType = new GraphQLObjectType({
 *   name: 'Row',
 *   fields: () => ({
 *     id: { type: new GraphQLNonNull(GraphQLString) },
 *   })
 * })
 * ```
 * Note: the enforcement of non-nullability occurs within the executor.
 */

class GraphQLNonNull {
  constructor(ofType) {
    isNullableType(ofType) ||
      (0,devAssert/* devAssert */.a)(
        false,
        `Expected ${(0,inspect/* inspect */.X)(ofType)} to be a GraphQL nullable type.`,
      );
    this.ofType = ofType;
  }

  get [Symbol.toStringTag]() {
    return 'GraphQLNonNull';
  }

  toString() {
    return String(this.ofType) + '!';
  }

  toJSON() {
    return this.toString();
  }
}
/**
 * These types wrap and modify other types
 */

function isWrappingType(type) {
  return isListType(type) || isNonNullType(type);
}
function assertWrappingType(type) {
  if (!isWrappingType(type)) {
    throw new Error(`Expected ${(0,inspect/* inspect */.X)(type)} to be a GraphQL wrapping type.`);
  }

  return type;
}
/**
 * These types can all accept null as a value.
 */

function isNullableType(type) {
  return isType(type) && !isNonNullType(type);
}
function assertNullableType(type) {
  if (!isNullableType(type)) {
    throw new Error(`Expected ${(0,inspect/* inspect */.X)(type)} to be a GraphQL nullable type.`);
  }

  return type;
}
function getNullableType(type) {
  if (type) {
    return isNonNullType(type) ? type.ofType : type;
  }
}
/**
 * These named types do not include modifiers like List or NonNull.
 */

function isNamedType(type) {
  return (
    isScalarType(type) ||
    isObjectType(type) ||
    isInterfaceType(type) ||
    isUnionType(type) ||
    isEnumType(type) ||
    isInputObjectType(type)
  );
}
function assertNamedType(type) {
  if (!isNamedType(type)) {
    throw new Error(`Expected ${(0,inspect/* inspect */.X)(type)} to be a GraphQL named type.`);
  }

  return type;
}
function getNamedType(type) {
  if (type) {
    let unwrappedType = type;

    while (isWrappingType(unwrappedType)) {
      unwrappedType = unwrappedType.ofType;
    }

    return unwrappedType;
  }
}
/**
 * Used while defining GraphQL types to allow for circular references in
 * otherwise immutable type definitions.
 */

function resolveReadonlyArrayThunk(thunk) {
  return typeof thunk === 'function' ? thunk() : thunk;
}
function resolveObjMapThunk(thunk) {
  return typeof thunk === 'function' ? thunk() : thunk;
}
/**
 * Custom extensions
 *
 * @remarks
 * Use a unique identifier name for your extension, for example the name of
 * your library or project. Do not use a shortened identifier as this increases
 * the risk of conflicts. We recommend you add at most one extension field,
 * an object which can contain all the values you need.
 */

/**
 * Scalar Type Definition
 *
 * The leaf values of any request and input values to arguments are
 * Scalars (or Enums) and are defined with a name and a series of functions
 * used to parse input from ast or variables and to ensure validity.
 *
 * If a type's serialize function returns `null` or does not return a value
 * (i.e. it returns `undefined`) then an error will be raised and a `null`
 * value will be returned in the response. It is always better to validate
 *
 * Example:
 *
 * ```ts
 * const OddType = new GraphQLScalarType({
 *   name: 'Odd',
 *   serialize(value) {
 *     if (!Number.isFinite(value)) {
 *       throw new Error(
 *         `Scalar "Odd" cannot represent "${value}" since it is not a finite number.`,
 *       );
 *     }
 *
 *     if (value % 2 === 0) {
 *       throw new Error(`Scalar "Odd" cannot represent "${value}" since it is even.`);
 *     }
 *     return value;
 *   }
 * });
 * ```
 */
class GraphQLScalarType {
  constructor(config) {
    var _config$parseValue,
      _config$serialize,
      _config$parseLiteral,
      _config$extensionASTN;

    const parseValue =
      (_config$parseValue = config.parseValue) !== null &&
      _config$parseValue !== void 0
        ? _config$parseValue
        : identityFunc;
    this.name = assertName(config.name);
    this.description = config.description;
    this.specifiedByURL = config.specifiedByURL;
    this.serialize =
      (_config$serialize = config.serialize) !== null &&
      _config$serialize !== void 0
        ? _config$serialize
        : identityFunc;
    this.parseValue = parseValue;
    this.parseLiteral =
      (_config$parseLiteral = config.parseLiteral) !== null &&
      _config$parseLiteral !== void 0
        ? _config$parseLiteral
        : (node, variables) => parseValue(valueFromASTUntyped(node, variables));
    this.extensions = toObjMap(config.extensions);
    this.astNode = config.astNode;
    this.extensionASTNodes =
      (_config$extensionASTN = config.extensionASTNodes) !== null &&
      _config$extensionASTN !== void 0
        ? _config$extensionASTN
        : [];
    config.specifiedByURL == null ||
      typeof config.specifiedByURL === 'string' ||
      (0,devAssert/* devAssert */.a)(
        false,
        `${this.name} must provide "specifiedByURL" as a string, ` +
          `but got: ${(0,inspect/* inspect */.X)(config.specifiedByURL)}.`,
      );
    config.serialize == null ||
      typeof config.serialize === 'function' ||
      (0,devAssert/* devAssert */.a)(
        false,
        `${this.name} must provide "serialize" function. If this custom Scalar is also used as an input type, ensure "parseValue" and "parseLiteral" functions are also provided.`,
      );

    if (config.parseLiteral) {
      (typeof config.parseValue === 'function' &&
        typeof config.parseLiteral === 'function') ||
        (0,devAssert/* devAssert */.a)(
          false,
          `${this.name} must provide both "parseValue" and "parseLiteral" functions.`,
        );
    }
  }

  get [Symbol.toStringTag]() {
    return 'GraphQLScalarType';
  }

  toConfig() {
    return {
      name: this.name,
      description: this.description,
      specifiedByURL: this.specifiedByURL,
      serialize: this.serialize,
      parseValue: this.parseValue,
      parseLiteral: this.parseLiteral,
      extensions: this.extensions,
      astNode: this.astNode,
      extensionASTNodes: this.extensionASTNodes,
    };
  }

  toString() {
    return this.name;
  }

  toJSON() {
    return this.toString();
  }
}

/**
 * Object Type Definition
 *
 * Almost all of the GraphQL types you define will be object types. Object types
 * have a name, but most importantly describe their fields.
 *
 * Example:
 *
 * ```ts
 * const AddressType = new GraphQLObjectType({
 *   name: 'Address',
 *   fields: {
 *     street: { type: GraphQLString },
 *     number: { type: GraphQLInt },
 *     formatted: {
 *       type: GraphQLString,
 *       resolve(obj) {
 *         return obj.number + ' ' + obj.street
 *       }
 *     }
 *   }
 * });
 * ```
 *
 * When two types need to refer to each other, or a type needs to refer to
 * itself in a field, you can use a function expression (aka a closure or a
 * thunk) to supply the fields lazily.
 *
 * Example:
 *
 * ```ts
 * const PersonType = new GraphQLObjectType({
 *   name: 'Person',
 *   fields: () => ({
 *     name: { type: GraphQLString },
 *     bestFriend: { type: PersonType },
 *   })
 * });
 * ```
 */
class GraphQLObjectType {
  constructor(config) {
    var _config$extensionASTN2;

    this.name = assertName(config.name);
    this.description = config.description;
    this.isTypeOf = config.isTypeOf;
    this.extensions = toObjMap(config.extensions);
    this.astNode = config.astNode;
    this.extensionASTNodes =
      (_config$extensionASTN2 = config.extensionASTNodes) !== null &&
      _config$extensionASTN2 !== void 0
        ? _config$extensionASTN2
        : [];

    this._fields = () => defineFieldMap(config);

    this._interfaces = () => defineInterfaces(config);

    config.isTypeOf == null ||
      typeof config.isTypeOf === 'function' ||
      (0,devAssert/* devAssert */.a)(
        false,
        `${this.name} must provide "isTypeOf" as a function, ` +
          `but got: ${(0,inspect/* inspect */.X)(config.isTypeOf)}.`,
      );
  }

  get [Symbol.toStringTag]() {
    return 'GraphQLObjectType';
  }

  getFields() {
    if (typeof this._fields === 'function') {
      this._fields = this._fields();
    }

    return this._fields;
  }

  getInterfaces() {
    if (typeof this._interfaces === 'function') {
      this._interfaces = this._interfaces();
    }

    return this._interfaces;
  }

  toConfig() {
    return {
      name: this.name,
      description: this.description,
      interfaces: this.getInterfaces(),
      fields: fieldsToFieldsConfig(this.getFields()),
      isTypeOf: this.isTypeOf,
      extensions: this.extensions,
      astNode: this.astNode,
      extensionASTNodes: this.extensionASTNodes,
    };
  }

  toString() {
    return this.name;
  }

  toJSON() {
    return this.toString();
  }
}

function defineInterfaces(config) {
  var _config$interfaces;

  const interfaces = resolveReadonlyArrayThunk(
    (_config$interfaces = config.interfaces) !== null &&
      _config$interfaces !== void 0
      ? _config$interfaces
      : [],
  );
  Array.isArray(interfaces) ||
    (0,devAssert/* devAssert */.a)(
      false,
      `${config.name} interfaces must be an Array or a function which returns an Array.`,
    );
  return interfaces;
}

function defineFieldMap(config) {
  const fieldMap = resolveObjMapThunk(config.fields);
  isPlainObj(fieldMap) ||
    (0,devAssert/* devAssert */.a)(
      false,
      `${config.name} fields must be an object with field names as keys or a function which returns such an object.`,
    );
  return mapValue(fieldMap, (fieldConfig, fieldName) => {
    var _fieldConfig$args;

    isPlainObj(fieldConfig) ||
      (0,devAssert/* devAssert */.a)(
        false,
        `${config.name}.${fieldName} field config must be an object.`,
      );
    fieldConfig.resolve == null ||
      typeof fieldConfig.resolve === 'function' ||
      (0,devAssert/* devAssert */.a)(
        false,
        `${config.name}.${fieldName} field resolver must be a function if ` +
          `provided, but got: ${(0,inspect/* inspect */.X)(fieldConfig.resolve)}.`,
      );
    const argsConfig =
      (_fieldConfig$args = fieldConfig.args) !== null &&
      _fieldConfig$args !== void 0
        ? _fieldConfig$args
        : {};
    isPlainObj(argsConfig) ||
      (0,devAssert/* devAssert */.a)(
        false,
        `${config.name}.${fieldName} args must be an object with argument names as keys.`,
      );
    return {
      name: assertName(fieldName),
      description: fieldConfig.description,
      type: fieldConfig.type,
      args: defineArguments(argsConfig),
      resolve: fieldConfig.resolve,
      subscribe: fieldConfig.subscribe,
      deprecationReason: fieldConfig.deprecationReason,
      extensions: toObjMap(fieldConfig.extensions),
      astNode: fieldConfig.astNode,
    };
  });
}

function defineArguments(config) {
  return Object.entries(config).map(([argName, argConfig]) => ({
    name: assertName(argName),
    description: argConfig.description,
    type: argConfig.type,
    defaultValue: argConfig.defaultValue,
    deprecationReason: argConfig.deprecationReason,
    extensions: toObjMap(argConfig.extensions),
    astNode: argConfig.astNode,
  }));
}

function isPlainObj(obj) {
  return (0,isObjectLike/* isObjectLike */.y)(obj) && !Array.isArray(obj);
}

function fieldsToFieldsConfig(fields) {
  return mapValue(fields, (field) => ({
    description: field.description,
    type: field.type,
    args: argsToArgsConfig(field.args),
    resolve: field.resolve,
    subscribe: field.subscribe,
    deprecationReason: field.deprecationReason,
    extensions: field.extensions,
    astNode: field.astNode,
  }));
}
/**
 * @internal
 */

function argsToArgsConfig(args) {
  return keyValMap(
    args,
    (arg) => arg.name,
    (arg) => ({
      description: arg.description,
      type: arg.type,
      defaultValue: arg.defaultValue,
      deprecationReason: arg.deprecationReason,
      extensions: arg.extensions,
      astNode: arg.astNode,
    }),
  );
}
function isRequiredArgument(arg) {
  return isNonNullType(arg.type) && arg.defaultValue === undefined;
}

/**
 * Interface Type Definition
 *
 * When a field can return one of a heterogeneous set of types, a Interface type
 * is used to describe what types are possible, what fields are in common across
 * all types, as well as a function to determine which type is actually used
 * when the field is resolved.
 *
 * Example:
 *
 * ```ts
 * const EntityType = new GraphQLInterfaceType({
 *   name: 'Entity',
 *   fields: {
 *     name: { type: GraphQLString }
 *   }
 * });
 * ```
 */
class GraphQLInterfaceType {
  constructor(config) {
    var _config$extensionASTN3;

    this.name = assertName(config.name);
    this.description = config.description;
    this.resolveType = config.resolveType;
    this.extensions = toObjMap(config.extensions);
    this.astNode = config.astNode;
    this.extensionASTNodes =
      (_config$extensionASTN3 = config.extensionASTNodes) !== null &&
      _config$extensionASTN3 !== void 0
        ? _config$extensionASTN3
        : [];
    this._fields = defineFieldMap.bind(undefined, config);
    this._interfaces = defineInterfaces.bind(undefined, config);
    config.resolveType == null ||
      typeof config.resolveType === 'function' ||
      (0,devAssert/* devAssert */.a)(
        false,
        `${this.name} must provide "resolveType" as a function, ` +
          `but got: ${(0,inspect/* inspect */.X)(config.resolveType)}.`,
      );
  }

  get [Symbol.toStringTag]() {
    return 'GraphQLInterfaceType';
  }

  getFields() {
    if (typeof this._fields === 'function') {
      this._fields = this._fields();
    }

    return this._fields;
  }

  getInterfaces() {
    if (typeof this._interfaces === 'function') {
      this._interfaces = this._interfaces();
    }

    return this._interfaces;
  }

  toConfig() {
    return {
      name: this.name,
      description: this.description,
      interfaces: this.getInterfaces(),
      fields: fieldsToFieldsConfig(this.getFields()),
      resolveType: this.resolveType,
      extensions: this.extensions,
      astNode: this.astNode,
      extensionASTNodes: this.extensionASTNodes,
    };
  }

  toString() {
    return this.name;
  }

  toJSON() {
    return this.toString();
  }
}

/**
 * Union Type Definition
 *
 * When a field can return one of a heterogeneous set of types, a Union type
 * is used to describe what types are possible as well as providing a function
 * to determine which type is actually used when the field is resolved.
 *
 * Example:
 *
 * ```ts
 * const PetType = new GraphQLUnionType({
 *   name: 'Pet',
 *   types: [ DogType, CatType ],
 *   resolveType(value) {
 *     if (value instanceof Dog) {
 *       return DogType;
 *     }
 *     if (value instanceof Cat) {
 *       return CatType;
 *     }
 *   }
 * });
 * ```
 */
class GraphQLUnionType {
  constructor(config) {
    var _config$extensionASTN4;

    this.name = assertName(config.name);
    this.description = config.description;
    this.resolveType = config.resolveType;
    this.extensions = toObjMap(config.extensions);
    this.astNode = config.astNode;
    this.extensionASTNodes =
      (_config$extensionASTN4 = config.extensionASTNodes) !== null &&
      _config$extensionASTN4 !== void 0
        ? _config$extensionASTN4
        : [];
    this._types = defineTypes.bind(undefined, config);
    config.resolveType == null ||
      typeof config.resolveType === 'function' ||
      (0,devAssert/* devAssert */.a)(
        false,
        `${this.name} must provide "resolveType" as a function, ` +
          `but got: ${(0,inspect/* inspect */.X)(config.resolveType)}.`,
      );
  }

  get [Symbol.toStringTag]() {
    return 'GraphQLUnionType';
  }

  getTypes() {
    if (typeof this._types === 'function') {
      this._types = this._types();
    }

    return this._types;
  }

  toConfig() {
    return {
      name: this.name,
      description: this.description,
      types: this.getTypes(),
      resolveType: this.resolveType,
      extensions: this.extensions,
      astNode: this.astNode,
      extensionASTNodes: this.extensionASTNodes,
    };
  }

  toString() {
    return this.name;
  }

  toJSON() {
    return this.toString();
  }
}

function defineTypes(config) {
  const types = resolveReadonlyArrayThunk(config.types);
  Array.isArray(types) ||
    (0,devAssert/* devAssert */.a)(
      false,
      `Must provide Array of types or a function which returns such an array for Union ${config.name}.`,
    );
  return types;
}

/**
 * Enum Type Definition
 *
 * Some leaf values of requests and input values are Enums. GraphQL serializes
 * Enum values as strings, however internally Enums can be represented by any
 * kind of type, often integers.
 *
 * Example:
 *
 * ```ts
 * const RGBType = new GraphQLEnumType({
 *   name: 'RGB',
 *   values: {
 *     RED: { value: 0 },
 *     GREEN: { value: 1 },
 *     BLUE: { value: 2 }
 *   }
 * });
 * ```
 *
 * Note: If a value is not provided in a definition, the name of the enum value
 * will be used as its internal value.
 */
class GraphQLEnumType {
  /* <T> */
  constructor(config) {
    var _config$extensionASTN5;

    this.name = assertName(config.name);
    this.description = config.description;
    this.extensions = toObjMap(config.extensions);
    this.astNode = config.astNode;
    this.extensionASTNodes =
      (_config$extensionASTN5 = config.extensionASTNodes) !== null &&
      _config$extensionASTN5 !== void 0
        ? _config$extensionASTN5
        : [];
    this._values =
      typeof config.values === 'function'
        ? config.values
        : defineEnumValues(this.name, config.values);
    this._valueLookup = null;
    this._nameLookup = null;
  }

  get [Symbol.toStringTag]() {
    return 'GraphQLEnumType';
  }

  getValues() {
    if (typeof this._values === 'function') {
      this._values = defineEnumValues(this.name, this._values());
    }

    return this._values;
  }

  getValue(name) {
    if (this._nameLookup === null) {
      this._nameLookup = keyMap(this.getValues(), (value) => value.name);
    }

    return this._nameLookup[name];
  }

  serialize(outputValue) {
    if (this._valueLookup === null) {
      this._valueLookup = new Map(
        this.getValues().map((enumValue) => [enumValue.value, enumValue]),
      );
    }

    const enumValue = this._valueLookup.get(outputValue);

    if (enumValue === undefined) {
      throw new GraphQLError/* GraphQLError */.__(
        `Enum "${this.name}" cannot represent value: ${(0,inspect/* inspect */.X)(outputValue)}`,
      );
    }

    return enumValue.name;
  }

  parseValue(inputValue) /* T */
  {
    if (typeof inputValue !== 'string') {
      const valueStr = (0,inspect/* inspect */.X)(inputValue);
      throw new GraphQLError/* GraphQLError */.__(
        `Enum "${this.name}" cannot represent non-string value: ${valueStr}.` +
          didYouMeanEnumValue(this, valueStr),
      );
    }

    const enumValue = this.getValue(inputValue);

    if (enumValue == null) {
      throw new GraphQLError/* GraphQLError */.__(
        `Value "${inputValue}" does not exist in "${this.name}" enum.` +
          didYouMeanEnumValue(this, inputValue),
      );
    }

    return enumValue.value;
  }

  parseLiteral(valueNode, _variables) /* T */
  {
    // Note: variables will be resolved to a value before calling this function.
    if (valueNode.kind !== kinds/* Kind.ENUM */.h.ENUM) {
      const valueStr = print(valueNode);
      throw new GraphQLError/* GraphQLError */.__(
        `Enum "${this.name}" cannot represent non-enum value: ${valueStr}.` +
          didYouMeanEnumValue(this, valueStr),
        {
          nodes: valueNode,
        },
      );
    }

    const enumValue = this.getValue(valueNode.value);

    if (enumValue == null) {
      const valueStr = print(valueNode);
      throw new GraphQLError/* GraphQLError */.__(
        `Value "${valueStr}" does not exist in "${this.name}" enum.` +
          didYouMeanEnumValue(this, valueStr),
        {
          nodes: valueNode,
        },
      );
    }

    return enumValue.value;
  }

  toConfig() {
    const values = keyValMap(
      this.getValues(),
      (value) => value.name,
      (value) => ({
        description: value.description,
        value: value.value,
        deprecationReason: value.deprecationReason,
        extensions: value.extensions,
        astNode: value.astNode,
      }),
    );
    return {
      name: this.name,
      description: this.description,
      values,
      extensions: this.extensions,
      astNode: this.astNode,
      extensionASTNodes: this.extensionASTNodes,
    };
  }

  toString() {
    return this.name;
  }

  toJSON() {
    return this.toString();
  }
}

function didYouMeanEnumValue(enumType, unknownValueStr) {
  const allNames = enumType.getValues().map((value) => value.name);
  const suggestedValues = suggestionList(unknownValueStr, allNames);
  return didYouMean('the enum value', suggestedValues);
}

function defineEnumValues(typeName, valueMap) {
  isPlainObj(valueMap) ||
    (0,devAssert/* devAssert */.a)(
      false,
      `${typeName} values must be an object with value names as keys.`,
    );
  return Object.entries(valueMap).map(([valueName, valueConfig]) => {
    isPlainObj(valueConfig) ||
      (0,devAssert/* devAssert */.a)(
        false,
        `${typeName}.${valueName} must refer to an object with a "value" key ` +
          `representing an internal value but got: ${(0,inspect/* inspect */.X)(valueConfig)}.`,
      );
    return {
      name: assertEnumValueName(valueName),
      description: valueConfig.description,
      value: valueConfig.value !== undefined ? valueConfig.value : valueName,
      deprecationReason: valueConfig.deprecationReason,
      extensions: toObjMap(valueConfig.extensions),
      astNode: valueConfig.astNode,
    };
  });
}

/**
 * Input Object Type Definition
 *
 * An input object defines a structured collection of fields which may be
 * supplied to a field argument.
 *
 * Using `NonNull` will ensure that a value must be provided by the query
 *
 * Example:
 *
 * ```ts
 * const GeoPoint = new GraphQLInputObjectType({
 *   name: 'GeoPoint',
 *   fields: {
 *     lat: { type: new GraphQLNonNull(GraphQLFloat) },
 *     lon: { type: new GraphQLNonNull(GraphQLFloat) },
 *     alt: { type: GraphQLFloat, defaultValue: 0 },
 *   }
 * });
 * ```
 */
class GraphQLInputObjectType {
  constructor(config) {
    var _config$extensionASTN6, _config$isOneOf;

    this.name = assertName(config.name);
    this.description = config.description;
    this.extensions = toObjMap(config.extensions);
    this.astNode = config.astNode;
    this.extensionASTNodes =
      (_config$extensionASTN6 = config.extensionASTNodes) !== null &&
      _config$extensionASTN6 !== void 0
        ? _config$extensionASTN6
        : [];
    this.isOneOf =
      (_config$isOneOf = config.isOneOf) !== null && _config$isOneOf !== void 0
        ? _config$isOneOf
        : false;
    this._fields = defineInputFieldMap.bind(undefined, config);
  }

  get [Symbol.toStringTag]() {
    return 'GraphQLInputObjectType';
  }

  getFields() {
    if (typeof this._fields === 'function') {
      this._fields = this._fields();
    }

    return this._fields;
  }

  toConfig() {
    const fields = mapValue(this.getFields(), (field) => ({
      description: field.description,
      type: field.type,
      defaultValue: field.defaultValue,
      deprecationReason: field.deprecationReason,
      extensions: field.extensions,
      astNode: field.astNode,
    }));
    return {
      name: this.name,
      description: this.description,
      fields,
      extensions: this.extensions,
      astNode: this.astNode,
      extensionASTNodes: this.extensionASTNodes,
      isOneOf: this.isOneOf,
    };
  }

  toString() {
    return this.name;
  }

  toJSON() {
    return this.toString();
  }
}

function defineInputFieldMap(config) {
  const fieldMap = resolveObjMapThunk(config.fields);
  isPlainObj(fieldMap) ||
    (0,devAssert/* devAssert */.a)(
      false,
      `${config.name} fields must be an object with field names as keys or a function which returns such an object.`,
    );
  return mapValue(fieldMap, (fieldConfig, fieldName) => {
    !('resolve' in fieldConfig) ||
      (0,devAssert/* devAssert */.a)(
        false,
        `${config.name}.${fieldName} field has a resolve property, but Input Types cannot define resolvers.`,
      );
    return {
      name: assertName(fieldName),
      description: fieldConfig.description,
      type: fieldConfig.type,
      defaultValue: fieldConfig.defaultValue,
      deprecationReason: fieldConfig.deprecationReason,
      extensions: toObjMap(fieldConfig.extensions),
      astNode: fieldConfig.astNode,
    };
  });
}

function isRequiredInputField(field) {
  return isNonNullType(field.type) && field.defaultValue === undefined;
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/typeComparators.mjs


/**
 * Provided two types, return true if the types are equal (invariant).
 */
function isEqualType(typeA, typeB) {
  // Equivalent types are equal.
  if (typeA === typeB) {
    return true;
  } // If either type is non-null, the other must also be non-null.

  if (isNonNullType(typeA) && isNonNullType(typeB)) {
    return isEqualType(typeA.ofType, typeB.ofType);
  } // If either type is a list, the other must also be a list.

  if (isListType(typeA) && isListType(typeB)) {
    return isEqualType(typeA.ofType, typeB.ofType);
  } // Otherwise the types are not equal.

  return false;
}
/**
 * Provided a type and a super type, return true if the first type is either
 * equal or a subset of the second super type (covariant).
 */

function isTypeSubTypeOf(schema, maybeSubType, superType) {
  // Equivalent type is a valid subtype
  if (maybeSubType === superType) {
    return true;
  } // If superType is non-null, maybeSubType must also be non-null.

  if (isNonNullType(superType)) {
    if (isNonNullType(maybeSubType)) {
      return isTypeSubTypeOf(schema, maybeSubType.ofType, superType.ofType);
    }

    return false;
  }

  if (isNonNullType(maybeSubType)) {
    // If superType is nullable, maybeSubType may be non-null or nullable.
    return isTypeSubTypeOf(schema, maybeSubType.ofType, superType);
  } // If superType type is a list, maybeSubType type must also be a list.

  if (isListType(superType)) {
    if (isListType(maybeSubType)) {
      return isTypeSubTypeOf(schema, maybeSubType.ofType, superType.ofType);
    }

    return false;
  }

  if (isListType(maybeSubType)) {
    // If superType is not a list, maybeSubType must also be not a list.
    return false;
  } // If superType type is an abstract type, check if it is super type of maybeSubType.
  // Otherwise, the child type is not a valid subtype of the parent type.

  return (
    isAbstractType(superType) &&
    (isInterfaceType(maybeSubType) || isObjectType(maybeSubType)) &&
    schema.isSubType(superType, maybeSubType)
  );
}
/**
 * Provided two composite types, determine if they "overlap". Two composite
 * types overlap when the Sets of possible concrete types for each intersect.
 *
 * This is often used to determine if a fragment of a given type could possibly
 * be visited in a context of another type.
 *
 * This function is commutative.
 */

function doTypesOverlap(schema, typeA, typeB) {
  // Equivalent types overlap
  if (typeA === typeB) {
    return true;
  }

  if (isAbstractType(typeA)) {
    if (isAbstractType(typeB)) {
      // If both types are abstract, then determine if there is any intersection
      // between possible concrete types of each.
      return schema
        .getPossibleTypes(typeA)
        .some((type) => schema.isSubType(typeB, type));
    } // Determine if the latter type is a possible concrete type of the former.

    return schema.isSubType(typeA, typeB);
  }

  if (isAbstractType(typeB)) {
    // Determine if the former type is a possible concrete type of the latter.
    return schema.isSubType(typeB, typeA);
  } // Otherwise the types do not overlap.

  return false;
}

// EXTERNAL MODULE: ../node_modules/graphql/language/directiveLocation.mjs
var directiveLocation = __webpack_require__(65916);
;// CONCATENATED MODULE: ../node_modules/graphql/type/scalars.mjs






/**
 * Maximum possible Int value as per GraphQL Spec (32-bit signed integer).
 * n.b. This differs from JavaScript's numbers that are IEEE 754 doubles safe up-to 2^53 - 1
 * */

const GRAPHQL_MAX_INT = 2147483647;
/**
 * Minimum possible Int value as per GraphQL Spec (32-bit signed integer).
 * n.b. This differs from JavaScript's numbers that are IEEE 754 doubles safe starting at -(2^53 - 1)
 * */

const GRAPHQL_MIN_INT = -2147483648;
const GraphQLInt = new GraphQLScalarType({
  name: 'Int',
  description:
    'The `Int` scalar type represents non-fractional signed whole numeric values. Int can represent values between -(2^31) and 2^31 - 1.',

  serialize(outputValue) {
    const coercedValue = serializeObject(outputValue);

    if (typeof coercedValue === 'boolean') {
      return coercedValue ? 1 : 0;
    }

    let num = coercedValue;

    if (typeof coercedValue === 'string' && coercedValue !== '') {
      num = Number(coercedValue);
    }

    if (typeof num !== 'number' || !Number.isInteger(num)) {
      throw new GraphQLError/* GraphQLError */.__(
        `Int cannot represent non-integer value: ${(0,inspect/* inspect */.X)(coercedValue)}`,
      );
    }

    if (num > GRAPHQL_MAX_INT || num < GRAPHQL_MIN_INT) {
      throw new GraphQLError/* GraphQLError */.__(
        'Int cannot represent non 32-bit signed integer value: ' +
          (0,inspect/* inspect */.X)(coercedValue),
      );
    }

    return num;
  },

  parseValue(inputValue) {
    if (typeof inputValue !== 'number' || !Number.isInteger(inputValue)) {
      throw new GraphQLError/* GraphQLError */.__(
        `Int cannot represent non-integer value: ${(0,inspect/* inspect */.X)(inputValue)}`,
      );
    }

    if (inputValue > GRAPHQL_MAX_INT || inputValue < GRAPHQL_MIN_INT) {
      throw new GraphQLError/* GraphQLError */.__(
        `Int cannot represent non 32-bit signed integer value: ${inputValue}`,
      );
    }

    return inputValue;
  },

  parseLiteral(valueNode) {
    if (valueNode.kind !== kinds/* Kind.INT */.h.INT) {
      throw new GraphQLError/* GraphQLError */.__(
        `Int cannot represent non-integer value: ${print(valueNode)}`,
        {
          nodes: valueNode,
        },
      );
    }

    const num = parseInt(valueNode.value, 10);

    if (num > GRAPHQL_MAX_INT || num < GRAPHQL_MIN_INT) {
      throw new GraphQLError/* GraphQLError */.__(
        `Int cannot represent non 32-bit signed integer value: ${valueNode.value}`,
        {
          nodes: valueNode,
        },
      );
    }

    return num;
  },
});
const GraphQLFloat = new GraphQLScalarType({
  name: 'Float',
  description:
    'The `Float` scalar type represents signed double-precision fractional values as specified by [IEEE 754](https://en.wikipedia.org/wiki/IEEE_floating_point).',

  serialize(outputValue) {
    const coercedValue = serializeObject(outputValue);

    if (typeof coercedValue === 'boolean') {
      return coercedValue ? 1 : 0;
    }

    let num = coercedValue;

    if (typeof coercedValue === 'string' && coercedValue !== '') {
      num = Number(coercedValue);
    }

    if (typeof num !== 'number' || !Number.isFinite(num)) {
      throw new GraphQLError/* GraphQLError */.__(
        `Float cannot represent non numeric value: ${(0,inspect/* inspect */.X)(coercedValue)}`,
      );
    }

    return num;
  },

  parseValue(inputValue) {
    if (typeof inputValue !== 'number' || !Number.isFinite(inputValue)) {
      throw new GraphQLError/* GraphQLError */.__(
        `Float cannot represent non numeric value: ${(0,inspect/* inspect */.X)(inputValue)}`,
      );
    }

    return inputValue;
  },

  parseLiteral(valueNode) {
    if (valueNode.kind !== kinds/* Kind.FLOAT */.h.FLOAT && valueNode.kind !== kinds/* Kind.INT */.h.INT) {
      throw new GraphQLError/* GraphQLError */.__(
        `Float cannot represent non numeric value: ${print(valueNode)}`,
        valueNode,
      );
    }

    return parseFloat(valueNode.value);
  },
});
const GraphQLString = new GraphQLScalarType({
  name: 'String',
  description:
    'The `String` scalar type represents textual data, represented as UTF-8 character sequences. The String type is most often used by GraphQL to represent free-form human-readable text.',

  serialize(outputValue) {
    const coercedValue = serializeObject(outputValue); // Serialize string, boolean and number values to a string, but do not
    // attempt to coerce object, function, symbol, or other types as strings.

    if (typeof coercedValue === 'string') {
      return coercedValue;
    }

    if (typeof coercedValue === 'boolean') {
      return coercedValue ? 'true' : 'false';
    }

    if (typeof coercedValue === 'number' && Number.isFinite(coercedValue)) {
      return coercedValue.toString();
    }

    throw new GraphQLError/* GraphQLError */.__(
      `String cannot represent value: ${(0,inspect/* inspect */.X)(outputValue)}`,
    );
  },

  parseValue(inputValue) {
    if (typeof inputValue !== 'string') {
      throw new GraphQLError/* GraphQLError */.__(
        `String cannot represent a non string value: ${(0,inspect/* inspect */.X)(inputValue)}`,
      );
    }

    return inputValue;
  },

  parseLiteral(valueNode) {
    if (valueNode.kind !== kinds/* Kind.STRING */.h.STRING) {
      throw new GraphQLError/* GraphQLError */.__(
        `String cannot represent a non string value: ${print(valueNode)}`,
        {
          nodes: valueNode,
        },
      );
    }

    return valueNode.value;
  },
});
const GraphQLBoolean = new GraphQLScalarType({
  name: 'Boolean',
  description: 'The `Boolean` scalar type represents `true` or `false`.',

  serialize(outputValue) {
    const coercedValue = serializeObject(outputValue);

    if (typeof coercedValue === 'boolean') {
      return coercedValue;
    }

    if (Number.isFinite(coercedValue)) {
      return coercedValue !== 0;
    }

    throw new GraphQLError/* GraphQLError */.__(
      `Boolean cannot represent a non boolean value: ${(0,inspect/* inspect */.X)(coercedValue)}`,
    );
  },

  parseValue(inputValue) {
    if (typeof inputValue !== 'boolean') {
      throw new GraphQLError/* GraphQLError */.__(
        `Boolean cannot represent a non boolean value: ${(0,inspect/* inspect */.X)(inputValue)}`,
      );
    }

    return inputValue;
  },

  parseLiteral(valueNode) {
    if (valueNode.kind !== kinds/* Kind.BOOLEAN */.h.BOOLEAN) {
      throw new GraphQLError/* GraphQLError */.__(
        `Boolean cannot represent a non boolean value: ${print(valueNode)}`,
        {
          nodes: valueNode,
        },
      );
    }

    return valueNode.value;
  },
});
const GraphQLID = new GraphQLScalarType({
  name: 'ID',
  description:
    'The `ID` scalar type represents a unique identifier, often used to refetch an object or as key for a cache. The ID type appears in a JSON response as a String; however, it is not intended to be human-readable. When expected as an input type, any string (such as `"4"`) or integer (such as `4`) input value will be accepted as an ID.',

  serialize(outputValue) {
    const coercedValue = serializeObject(outputValue);

    if (typeof coercedValue === 'string') {
      return coercedValue;
    }

    if (Number.isInteger(coercedValue)) {
      return String(coercedValue);
    }

    throw new GraphQLError/* GraphQLError */.__(
      `ID cannot represent value: ${(0,inspect/* inspect */.X)(outputValue)}`,
    );
  },

  parseValue(inputValue) {
    if (typeof inputValue === 'string') {
      return inputValue;
    }

    if (typeof inputValue === 'number' && Number.isInteger(inputValue)) {
      return inputValue.toString();
    }

    throw new GraphQLError/* GraphQLError */.__(`ID cannot represent value: ${(0,inspect/* inspect */.X)(inputValue)}`);
  },

  parseLiteral(valueNode) {
    if (valueNode.kind !== kinds/* Kind.STRING */.h.STRING && valueNode.kind !== kinds/* Kind.INT */.h.INT) {
      throw new GraphQLError/* GraphQLError */.__(
        'ID cannot represent a non-string and non-integer value: ' +
          print(valueNode),
        {
          nodes: valueNode,
        },
      );
    }

    return valueNode.value;
  },
});
const specifiedScalarTypes = Object.freeze([
  GraphQLString,
  GraphQLInt,
  GraphQLFloat,
  GraphQLBoolean,
  GraphQLID,
]);
function isSpecifiedScalarType(type) {
  return specifiedScalarTypes.some(({ name }) => type.name === name);
} // Support serializing objects with custom valueOf() or toJSON() functions -
// a common way to represent a complex value which can be represented as
// a string (ex: MongoDB id objects).

function serializeObject(outputValue) {
  if ((0,isObjectLike/* isObjectLike */.y)(outputValue)) {
    if (typeof outputValue.valueOf === 'function') {
      const valueOfResult = outputValue.valueOf();

      if (!(0,isObjectLike/* isObjectLike */.y)(valueOfResult)) {
        return valueOfResult;
      }
    }

    if (typeof outputValue.toJSON === 'function') {
      return outputValue.toJSON();
    }
  }

  return outputValue;
}

;// CONCATENATED MODULE: ../node_modules/graphql/type/directives.mjs









/**
 * Test if the given value is a GraphQL directive.
 */

function isDirective(directive) {
  return (0,instanceOf/* instanceOf */.n)(directive, GraphQLDirective);
}
function assertDirective(directive) {
  if (!isDirective(directive)) {
    throw new Error(
      `Expected ${(0,inspect/* inspect */.X)(directive)} to be a GraphQL directive.`,
    );
  }

  return directive;
}
/**
 * Custom extensions
 *
 * @remarks
 * Use a unique identifier name for your extension, for example the name of
 * your library or project. Do not use a shortened identifier as this increases
 * the risk of conflicts. We recommend you add at most one extension field,
 * an object which can contain all the values you need.
 */

/**
 * Directives are used by the GraphQL runtime as a way of modifying execution
 * behavior. Type system creators will usually not create these directly.
 */
class GraphQLDirective {
  constructor(config) {
    var _config$isRepeatable, _config$args;

    this.name = assertName(config.name);
    this.description = config.description;
    this.locations = config.locations;
    this.isRepeatable =
      (_config$isRepeatable = config.isRepeatable) !== null &&
      _config$isRepeatable !== void 0
        ? _config$isRepeatable
        : false;
    this.extensions = toObjMap(config.extensions);
    this.astNode = config.astNode;
    Array.isArray(config.locations) ||
      (0,devAssert/* devAssert */.a)(false, `@${config.name} locations must be an Array.`);
    const args =
      (_config$args = config.args) !== null && _config$args !== void 0
        ? _config$args
        : {};
    ((0,isObjectLike/* isObjectLike */.y)(args) && !Array.isArray(args)) ||
      (0,devAssert/* devAssert */.a)(
        false,
        `@${config.name} args must be an object with argument names as keys.`,
      );
    this.args = defineArguments(args);
  }

  get [Symbol.toStringTag]() {
    return 'GraphQLDirective';
  }

  toConfig() {
    return {
      name: this.name,
      description: this.description,
      locations: this.locations,
      args: argsToArgsConfig(this.args),
      isRepeatable: this.isRepeatable,
      extensions: this.extensions,
      astNode: this.astNode,
    };
  }

  toString() {
    return '@' + this.name;
  }

  toJSON() {
    return this.toString();
  }
}

/**
 * Used to conditionally include fields or fragments.
 */
const GraphQLIncludeDirective = new GraphQLDirective({
  name: 'include',
  description:
    'Directs the executor to include this field or fragment only when the `if` argument is true.',
  locations: [
    directiveLocation/* DirectiveLocation.FIELD */.B.FIELD,
    directiveLocation/* DirectiveLocation.FRAGMENT_SPREAD */.B.FRAGMENT_SPREAD,
    directiveLocation/* DirectiveLocation.INLINE_FRAGMENT */.B.INLINE_FRAGMENT,
  ],
  args: {
    if: {
      type: new GraphQLNonNull(GraphQLBoolean),
      description: 'Included when true.',
    },
  },
});
/**
 * Used to conditionally skip (exclude) fields or fragments.
 */

const GraphQLSkipDirective = new GraphQLDirective({
  name: 'skip',
  description:
    'Directs the executor to skip this field or fragment when the `if` argument is true.',
  locations: [
    directiveLocation/* DirectiveLocation.FIELD */.B.FIELD,
    directiveLocation/* DirectiveLocation.FRAGMENT_SPREAD */.B.FRAGMENT_SPREAD,
    directiveLocation/* DirectiveLocation.INLINE_FRAGMENT */.B.INLINE_FRAGMENT,
  ],
  args: {
    if: {
      type: new GraphQLNonNull(GraphQLBoolean),
      description: 'Skipped when true.',
    },
  },
});
/**
 * Constant string used for default reason for a deprecation.
 */

const DEFAULT_DEPRECATION_REASON = 'No longer supported';
/**
 * Used to declare element of a GraphQL schema as deprecated.
 */

const GraphQLDeprecatedDirective = new GraphQLDirective({
  name: 'deprecated',
  description: 'Marks an element of a GraphQL schema as no longer supported.',
  locations: [
    directiveLocation/* DirectiveLocation.FIELD_DEFINITION */.B.FIELD_DEFINITION,
    directiveLocation/* DirectiveLocation.ARGUMENT_DEFINITION */.B.ARGUMENT_DEFINITION,
    directiveLocation/* DirectiveLocation.INPUT_FIELD_DEFINITION */.B.INPUT_FIELD_DEFINITION,
    directiveLocation/* DirectiveLocation.ENUM_VALUE */.B.ENUM_VALUE,
  ],
  args: {
    reason: {
      type: GraphQLString,
      description:
        'Explains why this element was deprecated, usually also including a suggestion for how to access supported similar data. Formatted using the Markdown syntax, as specified by [CommonMark](https://commonmark.org/).',
      defaultValue: DEFAULT_DEPRECATION_REASON,
    },
  },
});
/**
 * Used to provide a URL for specifying the behavior of custom scalar definitions.
 */

const GraphQLSpecifiedByDirective = new GraphQLDirective({
  name: 'specifiedBy',
  description: 'Exposes a URL that specifies the behavior of this scalar.',
  locations: [directiveLocation/* DirectiveLocation.SCALAR */.B.SCALAR],
  args: {
    url: {
      type: new GraphQLNonNull(GraphQLString),
      description: 'The URL that specifies the behavior of this scalar.',
    },
  },
});
/**
 * Used to indicate an Input Object is a OneOf Input Object.
 */

const GraphQLOneOfDirective = new GraphQLDirective({
  name: 'oneOf',
  description:
    'Indicates exactly one field must be supplied and this field must not be `null`.',
  locations: [directiveLocation/* DirectiveLocation.INPUT_OBJECT */.B.INPUT_OBJECT],
  args: {},
});
/**
 * The full list of specified directives.
 */

const specifiedDirectives = Object.freeze([
  GraphQLIncludeDirective,
  GraphQLSkipDirective,
  GraphQLDeprecatedDirective,
  GraphQLSpecifiedByDirective,
  GraphQLOneOfDirective,
]);
function isSpecifiedDirective(directive) {
  return specifiedDirectives.some(({ name }) => name === directive.name);
}

// EXTERNAL MODULE: ../node_modules/graphql/jsutils/invariant.mjs
var invariant = __webpack_require__(87021);
;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/isIterableObject.mjs
/**
 * Returns true if the provided object is an Object (i.e. not a string literal)
 * and implements the Iterator protocol.
 *
 * This may be used in place of [Array.isArray()][isArray] to determine if
 * an object should be iterated-over e.g. Array, Map, Set, Int8Array,
 * TypedArray, etc. but excludes string literals.
 *
 * @example
 * ```ts
 * isIterableObject([ 1, 2, 3 ]) // true
 * isIterableObject(new Map()) // true
 * isIterableObject('ABC') // false
 * isIterableObject({ key: 'value' }) // false
 * isIterableObject({ length: 1, 0: 'Alpha' }) // false
 * ```
 */
function isIterableObject(maybeIterable) {
  return (
    typeof maybeIterable === 'object' &&
    typeof (maybeIterable === null || maybeIterable === void 0
      ? void 0
      : maybeIterable[Symbol.iterator]) === 'function'
  );
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/astFromValue.mjs







/**
 * Produces a GraphQL Value AST given a JavaScript object.
 * Function will match JavaScript/JSON values to GraphQL AST schema format
 * by using suggested GraphQLInputType. For example:
 *
 *     astFromValue("value", GraphQLString)
 *
 * A GraphQL type must be provided, which will be used to interpret different
 * JavaScript values.
 *
 * | JSON Value    | GraphQL Value        |
 * | ------------- | -------------------- |
 * | Object        | Input Object         |
 * | Array         | List                 |
 * | Boolean       | Boolean              |
 * | String        | String / Enum Value  |
 * | Number        | Int / Float          |
 * | Unknown       | Enum Value           |
 * | null          | NullValue            |
 *
 */

function astFromValue(value, type) {
  if (isNonNullType(type)) {
    const astValue = astFromValue(value, type.ofType);

    if (
      (astValue === null || astValue === void 0 ? void 0 : astValue.kind) ===
      kinds/* Kind.NULL */.h.NULL
    ) {
      return null;
    }

    return astValue;
  } // only explicit null, not undefined, NaN

  if (value === null) {
    return {
      kind: kinds/* Kind.NULL */.h.NULL,
    };
  } // undefined

  if (value === undefined) {
    return null;
  } // Convert JavaScript array to GraphQL list. If the GraphQLType is a list, but
  // the value is not an array, convert the value using the list's item type.

  if (isListType(type)) {
    const itemType = type.ofType;

    if (isIterableObject(value)) {
      const valuesNodes = [];

      for (const item of value) {
        const itemNode = astFromValue(item, itemType);

        if (itemNode != null) {
          valuesNodes.push(itemNode);
        }
      }

      return {
        kind: kinds/* Kind.LIST */.h.LIST,
        values: valuesNodes,
      };
    }

    return astFromValue(value, itemType);
  } // Populate the fields of the input object by creating ASTs from each value
  // in the JavaScript object according to the fields in the input type.

  if (isInputObjectType(type)) {
    if (!(0,isObjectLike/* isObjectLike */.y)(value)) {
      return null;
    }

    const fieldNodes = [];

    for (const field of Object.values(type.getFields())) {
      const fieldValue = astFromValue(value[field.name], field.type);

      if (fieldValue) {
        fieldNodes.push({
          kind: kinds/* Kind.OBJECT_FIELD */.h.OBJECT_FIELD,
          name: {
            kind: kinds/* Kind.NAME */.h.NAME,
            value: field.name,
          },
          value: fieldValue,
        });
      }
    }

    return {
      kind: kinds/* Kind.OBJECT */.h.OBJECT,
      fields: fieldNodes,
    };
  }

  if (isLeafType(type)) {
    // Since value is an internally represented value, it must be serialized
    // to an externally represented value before converting into an AST.
    const serialized = type.serialize(value);

    if (serialized == null) {
      return null;
    } // Others serialize based on their corresponding JavaScript scalar types.

    if (typeof serialized === 'boolean') {
      return {
        kind: kinds/* Kind.BOOLEAN */.h.BOOLEAN,
        value: serialized,
      };
    } // JavaScript numbers can be Int or Float values.

    if (typeof serialized === 'number' && Number.isFinite(serialized)) {
      const stringNum = String(serialized);
      return integerStringRegExp.test(stringNum)
        ? {
            kind: kinds/* Kind.INT */.h.INT,
            value: stringNum,
          }
        : {
            kind: kinds/* Kind.FLOAT */.h.FLOAT,
            value: stringNum,
          };
    }

    if (typeof serialized === 'string') {
      // Enum types use Enum literals.
      if (isEnumType(type)) {
        return {
          kind: kinds/* Kind.ENUM */.h.ENUM,
          value: serialized,
        };
      } // ID types can use Int literals.

      if (type === GraphQLID && integerStringRegExp.test(serialized)) {
        return {
          kind: kinds/* Kind.INT */.h.INT,
          value: serialized,
        };
      }

      return {
        kind: kinds/* Kind.STRING */.h.STRING,
        value: serialized,
      };
    }

    throw new TypeError(`Cannot convert value to AST: ${(0,inspect/* inspect */.X)(serialized)}.`);
  }
  /* c8 ignore next 3 */
  // Not reachable, all possible types have been considered.

   false || (0,invariant/* invariant */.k)(false, 'Unexpected input type: ' + (0,inspect/* inspect */.X)(type));
}
/**
 * IntValue:
 *   - NegativeSign? 0
 *   - NegativeSign? NonZeroDigit ( Digit+ )?
 */

const integerStringRegExp = /^-?(?:0|[1-9][0-9]*)$/;

;// CONCATENATED MODULE: ../node_modules/graphql/type/introspection.mjs







const __Schema = new GraphQLObjectType({
  name: '__Schema',
  description:
    'A GraphQL Schema defines the capabilities of a GraphQL server. It exposes all available types and directives on the server, as well as the entry points for query, mutation, and subscription operations.',
  fields: () => ({
    description: {
      type: GraphQLString,
      resolve: (schema) => schema.description,
    },
    types: {
      description: 'A list of all types supported by this server.',
      type: new GraphQLNonNull(new GraphQLList(new GraphQLNonNull(__Type))),

      resolve(schema) {
        return Object.values(schema.getTypeMap());
      },
    },
    queryType: {
      description: 'The type that query operations will be rooted at.',
      type: new GraphQLNonNull(__Type),
      resolve: (schema) => schema.getQueryType(),
    },
    mutationType: {
      description:
        'If this server supports mutation, the type that mutation operations will be rooted at.',
      type: __Type,
      resolve: (schema) => schema.getMutationType(),
    },
    subscriptionType: {
      description:
        'If this server support subscription, the type that subscription operations will be rooted at.',
      type: __Type,
      resolve: (schema) => schema.getSubscriptionType(),
    },
    directives: {
      description: 'A list of all directives supported by this server.',
      type: new GraphQLNonNull(
        new GraphQLList(new GraphQLNonNull(__Directive)),
      ),
      resolve: (schema) => schema.getDirectives(),
    },
  }),
});
const __Directive = new GraphQLObjectType({
  name: '__Directive',
  description:
    "A Directive provides a way to describe alternate runtime execution and type validation behavior in a GraphQL document.\n\nIn some cases, you need to provide options to alter GraphQL's execution behavior in ways field arguments will not suffice, such as conditionally including or skipping a field. Directives provide this by describing additional information to the executor.",
  fields: () => ({
    name: {
      type: new GraphQLNonNull(GraphQLString),
      resolve: (directive) => directive.name,
    },
    description: {
      type: GraphQLString,
      resolve: (directive) => directive.description,
    },
    isRepeatable: {
      type: new GraphQLNonNull(GraphQLBoolean),
      resolve: (directive) => directive.isRepeatable,
    },
    locations: {
      type: new GraphQLNonNull(
        new GraphQLList(new GraphQLNonNull(__DirectiveLocation)),
      ),
      resolve: (directive) => directive.locations,
    },
    args: {
      type: new GraphQLNonNull(
        new GraphQLList(new GraphQLNonNull(__InputValue)),
      ),
      args: {
        includeDeprecated: {
          type: GraphQLBoolean,
          defaultValue: false,
        },
      },

      resolve(field, { includeDeprecated }) {
        return includeDeprecated
          ? field.args
          : field.args.filter((arg) => arg.deprecationReason == null);
      },
    },
  }),
});
const __DirectiveLocation = new GraphQLEnumType({
  name: '__DirectiveLocation',
  description:
    'A Directive can be adjacent to many parts of the GraphQL language, a __DirectiveLocation describes one such possible adjacencies.',
  values: {
    QUERY: {
      value: directiveLocation/* DirectiveLocation.QUERY */.B.QUERY,
      description: 'Location adjacent to a query operation.',
    },
    MUTATION: {
      value: directiveLocation/* DirectiveLocation.MUTATION */.B.MUTATION,
      description: 'Location adjacent to a mutation operation.',
    },
    SUBSCRIPTION: {
      value: directiveLocation/* DirectiveLocation.SUBSCRIPTION */.B.SUBSCRIPTION,
      description: 'Location adjacent to a subscription operation.',
    },
    FIELD: {
      value: directiveLocation/* DirectiveLocation.FIELD */.B.FIELD,
      description: 'Location adjacent to a field.',
    },
    FRAGMENT_DEFINITION: {
      value: directiveLocation/* DirectiveLocation.FRAGMENT_DEFINITION */.B.FRAGMENT_DEFINITION,
      description: 'Location adjacent to a fragment definition.',
    },
    FRAGMENT_SPREAD: {
      value: directiveLocation/* DirectiveLocation.FRAGMENT_SPREAD */.B.FRAGMENT_SPREAD,
      description: 'Location adjacent to a fragment spread.',
    },
    INLINE_FRAGMENT: {
      value: directiveLocation/* DirectiveLocation.INLINE_FRAGMENT */.B.INLINE_FRAGMENT,
      description: 'Location adjacent to an inline fragment.',
    },
    VARIABLE_DEFINITION: {
      value: directiveLocation/* DirectiveLocation.VARIABLE_DEFINITION */.B.VARIABLE_DEFINITION,
      description: 'Location adjacent to a variable definition.',
    },
    SCHEMA: {
      value: directiveLocation/* DirectiveLocation.SCHEMA */.B.SCHEMA,
      description: 'Location adjacent to a schema definition.',
    },
    SCALAR: {
      value: directiveLocation/* DirectiveLocation.SCALAR */.B.SCALAR,
      description: 'Location adjacent to a scalar definition.',
    },
    OBJECT: {
      value: directiveLocation/* DirectiveLocation.OBJECT */.B.OBJECT,
      description: 'Location adjacent to an object type definition.',
    },
    FIELD_DEFINITION: {
      value: directiveLocation/* DirectiveLocation.FIELD_DEFINITION */.B.FIELD_DEFINITION,
      description: 'Location adjacent to a field definition.',
    },
    ARGUMENT_DEFINITION: {
      value: directiveLocation/* DirectiveLocation.ARGUMENT_DEFINITION */.B.ARGUMENT_DEFINITION,
      description: 'Location adjacent to an argument definition.',
    },
    INTERFACE: {
      value: directiveLocation/* DirectiveLocation.INTERFACE */.B.INTERFACE,
      description: 'Location adjacent to an interface definition.',
    },
    UNION: {
      value: directiveLocation/* DirectiveLocation.UNION */.B.UNION,
      description: 'Location adjacent to a union definition.',
    },
    ENUM: {
      value: directiveLocation/* DirectiveLocation.ENUM */.B.ENUM,
      description: 'Location adjacent to an enum definition.',
    },
    ENUM_VALUE: {
      value: directiveLocation/* DirectiveLocation.ENUM_VALUE */.B.ENUM_VALUE,
      description: 'Location adjacent to an enum value definition.',
    },
    INPUT_OBJECT: {
      value: directiveLocation/* DirectiveLocation.INPUT_OBJECT */.B.INPUT_OBJECT,
      description: 'Location adjacent to an input object type definition.',
    },
    INPUT_FIELD_DEFINITION: {
      value: directiveLocation/* DirectiveLocation.INPUT_FIELD_DEFINITION */.B.INPUT_FIELD_DEFINITION,
      description: 'Location adjacent to an input object field definition.',
    },
  },
});
const __Type = new GraphQLObjectType({
  name: '__Type',
  description:
    'The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.\n\nDepending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.',
  fields: () => ({
    kind: {
      type: new GraphQLNonNull(__TypeKind),

      resolve(type) {
        if (isScalarType(type)) {
          return TypeKind.SCALAR;
        }

        if (isObjectType(type)) {
          return TypeKind.OBJECT;
        }

        if (isInterfaceType(type)) {
          return TypeKind.INTERFACE;
        }

        if (isUnionType(type)) {
          return TypeKind.UNION;
        }

        if (isEnumType(type)) {
          return TypeKind.ENUM;
        }

        if (isInputObjectType(type)) {
          return TypeKind.INPUT_OBJECT;
        }

        if (isListType(type)) {
          return TypeKind.LIST;
        }

        if (isNonNullType(type)) {
          return TypeKind.NON_NULL;
        }
        /* c8 ignore next 3 */
        // Not reachable, all possible types have been considered)

         false || (0,invariant/* invariant */.k)(false, `Unexpected type: "${(0,inspect/* inspect */.X)(type)}".`);
      },
    },
    name: {
      type: GraphQLString,
      resolve: (type) => ('name' in type ? type.name : undefined),
    },
    description: {
      type: GraphQLString,
      resolve: (
        type, // FIXME: add test case
      ) =>
        /* c8 ignore next */
        'description' in type ? type.description : undefined,
    },
    specifiedByURL: {
      type: GraphQLString,
      resolve: (obj) =>
        'specifiedByURL' in obj ? obj.specifiedByURL : undefined,
    },
    fields: {
      type: new GraphQLList(new GraphQLNonNull(__Field)),
      args: {
        includeDeprecated: {
          type: GraphQLBoolean,
          defaultValue: false,
        },
      },

      resolve(type, { includeDeprecated }) {
        if (isObjectType(type) || isInterfaceType(type)) {
          const fields = Object.values(type.getFields());
          return includeDeprecated
            ? fields
            : fields.filter((field) => field.deprecationReason == null);
        }
      },
    },
    interfaces: {
      type: new GraphQLList(new GraphQLNonNull(__Type)),

      resolve(type) {
        if (isObjectType(type) || isInterfaceType(type)) {
          return type.getInterfaces();
        }
      },
    },
    possibleTypes: {
      type: new GraphQLList(new GraphQLNonNull(__Type)),

      resolve(type, _args, _context, { schema }) {
        if (isAbstractType(type)) {
          return schema.getPossibleTypes(type);
        }
      },
    },
    enumValues: {
      type: new GraphQLList(new GraphQLNonNull(__EnumValue)),
      args: {
        includeDeprecated: {
          type: GraphQLBoolean,
          defaultValue: false,
        },
      },

      resolve(type, { includeDeprecated }) {
        if (isEnumType(type)) {
          const values = type.getValues();
          return includeDeprecated
            ? values
            : values.filter((field) => field.deprecationReason == null);
        }
      },
    },
    inputFields: {
      type: new GraphQLList(new GraphQLNonNull(__InputValue)),
      args: {
        includeDeprecated: {
          type: GraphQLBoolean,
          defaultValue: false,
        },
      },

      resolve(type, { includeDeprecated }) {
        if (isInputObjectType(type)) {
          const values = Object.values(type.getFields());
          return includeDeprecated
            ? values
            : values.filter((field) => field.deprecationReason == null);
        }
      },
    },
    ofType: {
      type: __Type,
      resolve: (type) => ('ofType' in type ? type.ofType : undefined),
    },
    isOneOf: {
      type: GraphQLBoolean,
      resolve: (type) => {
        if (isInputObjectType(type)) {
          return type.isOneOf;
        }
      },
    },
  }),
});
const __Field = new GraphQLObjectType({
  name: '__Field',
  description:
    'Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type.',
  fields: () => ({
    name: {
      type: new GraphQLNonNull(GraphQLString),
      resolve: (field) => field.name,
    },
    description: {
      type: GraphQLString,
      resolve: (field) => field.description,
    },
    args: {
      type: new GraphQLNonNull(
        new GraphQLList(new GraphQLNonNull(__InputValue)),
      ),
      args: {
        includeDeprecated: {
          type: GraphQLBoolean,
          defaultValue: false,
        },
      },

      resolve(field, { includeDeprecated }) {
        return includeDeprecated
          ? field.args
          : field.args.filter((arg) => arg.deprecationReason == null);
      },
    },
    type: {
      type: new GraphQLNonNull(__Type),
      resolve: (field) => field.type,
    },
    isDeprecated: {
      type: new GraphQLNonNull(GraphQLBoolean),
      resolve: (field) => field.deprecationReason != null,
    },
    deprecationReason: {
      type: GraphQLString,
      resolve: (field) => field.deprecationReason,
    },
  }),
});
const __InputValue = new GraphQLObjectType({
  name: '__InputValue',
  description:
    'Arguments provided to Fields or Directives and the input fields of an InputObject are represented as Input Values which describe their type and optionally a default value.',
  fields: () => ({
    name: {
      type: new GraphQLNonNull(GraphQLString),
      resolve: (inputValue) => inputValue.name,
    },
    description: {
      type: GraphQLString,
      resolve: (inputValue) => inputValue.description,
    },
    type: {
      type: new GraphQLNonNull(__Type),
      resolve: (inputValue) => inputValue.type,
    },
    defaultValue: {
      type: GraphQLString,
      description:
        'A GraphQL-formatted string representing the default value for this input value.',

      resolve(inputValue) {
        const { type, defaultValue } = inputValue;
        const valueAST = astFromValue(defaultValue, type);
        return valueAST ? print(valueAST) : null;
      },
    },
    isDeprecated: {
      type: new GraphQLNonNull(GraphQLBoolean),
      resolve: (field) => field.deprecationReason != null,
    },
    deprecationReason: {
      type: GraphQLString,
      resolve: (obj) => obj.deprecationReason,
    },
  }),
});
const __EnumValue = new GraphQLObjectType({
  name: '__EnumValue',
  description:
    'One possible value for a given Enum. Enum values are unique values, not a placeholder for a string or numeric value. However an Enum value is returned in a JSON response as a string.',
  fields: () => ({
    name: {
      type: new GraphQLNonNull(GraphQLString),
      resolve: (enumValue) => enumValue.name,
    },
    description: {
      type: GraphQLString,
      resolve: (enumValue) => enumValue.description,
    },
    isDeprecated: {
      type: new GraphQLNonNull(GraphQLBoolean),
      resolve: (enumValue) => enumValue.deprecationReason != null,
    },
    deprecationReason: {
      type: GraphQLString,
      resolve: (enumValue) => enumValue.deprecationReason,
    },
  }),
});
var TypeKind;

(function (TypeKind) {
  TypeKind['SCALAR'] = 'SCALAR';
  TypeKind['OBJECT'] = 'OBJECT';
  TypeKind['INTERFACE'] = 'INTERFACE';
  TypeKind['UNION'] = 'UNION';
  TypeKind['ENUM'] = 'ENUM';
  TypeKind['INPUT_OBJECT'] = 'INPUT_OBJECT';
  TypeKind['LIST'] = 'LIST';
  TypeKind['NON_NULL'] = 'NON_NULL';
})(TypeKind || (TypeKind = {}));


const __TypeKind = new GraphQLEnumType({
  name: '__TypeKind',
  description: 'An enum describing what kind of type a given `__Type` is.',
  values: {
    SCALAR: {
      value: TypeKind.SCALAR,
      description: 'Indicates this type is a scalar.',
    },
    OBJECT: {
      value: TypeKind.OBJECT,
      description:
        'Indicates this type is an object. `fields` and `interfaces` are valid fields.',
    },
    INTERFACE: {
      value: TypeKind.INTERFACE,
      description:
        'Indicates this type is an interface. `fields`, `interfaces`, and `possibleTypes` are valid fields.',
    },
    UNION: {
      value: TypeKind.UNION,
      description:
        'Indicates this type is a union. `possibleTypes` is a valid field.',
    },
    ENUM: {
      value: TypeKind.ENUM,
      description:
        'Indicates this type is an enum. `enumValues` is a valid field.',
    },
    INPUT_OBJECT: {
      value: TypeKind.INPUT_OBJECT,
      description:
        'Indicates this type is an input object. `inputFields` is a valid field.',
    },
    LIST: {
      value: TypeKind.LIST,
      description: 'Indicates this type is a list. `ofType` is a valid field.',
    },
    NON_NULL: {
      value: TypeKind.NON_NULL,
      description:
        'Indicates this type is a non-null. `ofType` is a valid field.',
    },
  },
});
/**
 * Note that these are GraphQLField and not GraphQLFieldConfig,
 * so the format for args is different.
 */

const SchemaMetaFieldDef = {
  name: '__schema',
  type: new GraphQLNonNull(__Schema),
  description: 'Access the current type schema of this server.',
  args: [],
  resolve: (_source, _args, _context, { schema }) => schema,
  deprecationReason: undefined,
  extensions: Object.create(null),
  astNode: undefined,
};
const TypeMetaFieldDef = {
  name: '__type',
  type: __Type,
  description: 'Request the type information of a single type.',
  args: [
    {
      name: 'name',
      description: undefined,
      type: new GraphQLNonNull(GraphQLString),
      defaultValue: undefined,
      deprecationReason: undefined,
      extensions: Object.create(null),
      astNode: undefined,
    },
  ],
  resolve: (_source, { name }, _context, { schema }) => schema.getType(name),
  deprecationReason: undefined,
  extensions: Object.create(null),
  astNode: undefined,
};
const TypeNameMetaFieldDef = {
  name: '__typename',
  type: new GraphQLNonNull(GraphQLString),
  description: 'The name of the current Object type at runtime.',
  args: [],
  resolve: (_source, _args, _context, { parentType }) => parentType.name,
  deprecationReason: undefined,
  extensions: Object.create(null),
  astNode: undefined,
};
const introspectionTypes = Object.freeze([
  __Schema,
  __Directive,
  __DirectiveLocation,
  __Type,
  __Field,
  __InputValue,
  __EnumValue,
  __TypeKind,
]);
function isIntrospectionType(type) {
  return introspectionTypes.some(({ name }) => type.name === name);
}

;// CONCATENATED MODULE: ../node_modules/graphql/type/schema.mjs









/**
 * Test if the given value is a GraphQL schema.
 */

function isSchema(schema) {
  return (0,instanceOf/* instanceOf */.n)(schema, GraphQLSchema);
}
function assertSchema(schema) {
  if (!isSchema(schema)) {
    throw new Error(`Expected ${(0,inspect/* inspect */.X)(schema)} to be a GraphQL schema.`);
  }

  return schema;
}
/**
 * Custom extensions
 *
 * @remarks
 * Use a unique identifier name for your extension, for example the name of
 * your library or project. Do not use a shortened identifier as this increases
 * the risk of conflicts. We recommend you add at most one extension field,
 * an object which can contain all the values you need.
 */

/**
 * Schema Definition
 *
 * A Schema is created by supplying the root types of each type of operation,
 * query and mutation (optional). A schema definition is then supplied to the
 * validator and executor.
 *
 * Example:
 *
 * ```ts
 * const MyAppSchema = new GraphQLSchema({
 *   query: MyAppQueryRootType,
 *   mutation: MyAppMutationRootType,
 * })
 * ```
 *
 * Note: When the schema is constructed, by default only the types that are
 * reachable by traversing the root types are included, other types must be
 * explicitly referenced.
 *
 * Example:
 *
 * ```ts
 * const characterInterface = new GraphQLInterfaceType({
 *   name: 'Character',
 *   ...
 * });
 *
 * const humanType = new GraphQLObjectType({
 *   name: 'Human',
 *   interfaces: [characterInterface],
 *   ...
 * });
 *
 * const droidType = new GraphQLObjectType({
 *   name: 'Droid',
 *   interfaces: [characterInterface],
 *   ...
 * });
 *
 * const schema = new GraphQLSchema({
 *   query: new GraphQLObjectType({
 *     name: 'Query',
 *     fields: {
 *       hero: { type: characterInterface, ... },
 *     }
 *   }),
 *   ...
 *   // Since this schema references only the `Character` interface it's
 *   // necessary to explicitly list the types that implement it if
 *   // you want them to be included in the final schema.
 *   types: [humanType, droidType],
 * })
 * ```
 *
 * Note: If an array of `directives` are provided to GraphQLSchema, that will be
 * the exact list of directives represented and allowed. If `directives` is not
 * provided then a default set of the specified directives (e.g. `@include` and
 * `@skip`) will be used. If you wish to provide *additional* directives to these
 * specified directives, you must explicitly declare them. Example:
 *
 * ```ts
 * const MyAppSchema = new GraphQLSchema({
 *   ...
 *   directives: specifiedDirectives.concat([ myCustomDirective ]),
 * })
 * ```
 */
class GraphQLSchema {
  // Used as a cache for validateSchema().
  constructor(config) {
    var _config$extensionASTN, _config$directives;

    // If this schema was built from a source known to be valid, then it may be
    // marked with assumeValid to avoid an additional type system validation.
    this.__validationErrors = config.assumeValid === true ? [] : undefined; // Check for common mistakes during construction to produce early errors.

    (0,isObjectLike/* isObjectLike */.y)(config) ||
      (0,devAssert/* devAssert */.a)(false, 'Must provide configuration object.');
    !config.types ||
      Array.isArray(config.types) ||
      (0,devAssert/* devAssert */.a)(
        false,
        `"types" must be Array if provided but got: ${(0,inspect/* inspect */.X)(config.types)}.`,
      );
    !config.directives ||
      Array.isArray(config.directives) ||
      (0,devAssert/* devAssert */.a)(
        false,
        '"directives" must be Array if provided but got: ' +
          `${(0,inspect/* inspect */.X)(config.directives)}.`,
      );
    this.description = config.description;
    this.extensions = toObjMap(config.extensions);
    this.astNode = config.astNode;
    this.extensionASTNodes =
      (_config$extensionASTN = config.extensionASTNodes) !== null &&
      _config$extensionASTN !== void 0
        ? _config$extensionASTN
        : [];
    this._queryType = config.query;
    this._mutationType = config.mutation;
    this._subscriptionType = config.subscription; // Provide specified directives (e.g. @include and @skip) by default.

    this._directives =
      (_config$directives = config.directives) !== null &&
      _config$directives !== void 0
        ? _config$directives
        : specifiedDirectives; // To preserve order of user-provided types, we add first to add them to
    // the set of "collected" types, so `collectReferencedTypes` ignore them.

    const allReferencedTypes = new Set(config.types);

    if (config.types != null) {
      for (const type of config.types) {
        // When we ready to process this type, we remove it from "collected" types
        // and then add it together with all dependent types in the correct position.
        allReferencedTypes.delete(type);
        collectReferencedTypes(type, allReferencedTypes);
      }
    }

    if (this._queryType != null) {
      collectReferencedTypes(this._queryType, allReferencedTypes);
    }

    if (this._mutationType != null) {
      collectReferencedTypes(this._mutationType, allReferencedTypes);
    }

    if (this._subscriptionType != null) {
      collectReferencedTypes(this._subscriptionType, allReferencedTypes);
    }

    for (const directive of this._directives) {
      // Directives are not validated until validateSchema() is called.
      if (isDirective(directive)) {
        for (const arg of directive.args) {
          collectReferencedTypes(arg.type, allReferencedTypes);
        }
      }
    }

    collectReferencedTypes(__Schema, allReferencedTypes); // Storing the resulting map for reference by the schema.

    this._typeMap = Object.create(null);
    this._subTypeMap = Object.create(null); // Keep track of all implementations by interface name.

    this._implementationsMap = Object.create(null);

    for (const namedType of allReferencedTypes) {
      if (namedType == null) {
        continue;
      }

      const typeName = namedType.name;
      typeName ||
        (0,devAssert/* devAssert */.a)(
          false,
          'One of the provided types for building the Schema is missing a name.',
        );

      if (this._typeMap[typeName] !== undefined) {
        throw new Error(
          `Schema must contain uniquely named types but contains multiple types named "${typeName}".`,
        );
      }

      this._typeMap[typeName] = namedType;

      if (isInterfaceType(namedType)) {
        // Store implementations by interface.
        for (const iface of namedType.getInterfaces()) {
          if (isInterfaceType(iface)) {
            let implementations = this._implementationsMap[iface.name];

            if (implementations === undefined) {
              implementations = this._implementationsMap[iface.name] = {
                objects: [],
                interfaces: [],
              };
            }

            implementations.interfaces.push(namedType);
          }
        }
      } else if (isObjectType(namedType)) {
        // Store implementations by objects.
        for (const iface of namedType.getInterfaces()) {
          if (isInterfaceType(iface)) {
            let implementations = this._implementationsMap[iface.name];

            if (implementations === undefined) {
              implementations = this._implementationsMap[iface.name] = {
                objects: [],
                interfaces: [],
              };
            }

            implementations.objects.push(namedType);
          }
        }
      }
    }
  }

  get [Symbol.toStringTag]() {
    return 'GraphQLSchema';
  }

  getQueryType() {
    return this._queryType;
  }

  getMutationType() {
    return this._mutationType;
  }

  getSubscriptionType() {
    return this._subscriptionType;
  }

  getRootType(operation) {
    switch (operation) {
      case ast/* OperationTypeNode.QUERY */.ku.QUERY:
        return this.getQueryType();

      case ast/* OperationTypeNode.MUTATION */.ku.MUTATION:
        return this.getMutationType();

      case ast/* OperationTypeNode.SUBSCRIPTION */.ku.SUBSCRIPTION:
        return this.getSubscriptionType();
    }
  }

  getTypeMap() {
    return this._typeMap;
  }

  getType(name) {
    return this.getTypeMap()[name];
  }

  getPossibleTypes(abstractType) {
    return isUnionType(abstractType)
      ? abstractType.getTypes()
      : this.getImplementations(abstractType).objects;
  }

  getImplementations(interfaceType) {
    const implementations = this._implementationsMap[interfaceType.name];
    return implementations !== null && implementations !== void 0
      ? implementations
      : {
          objects: [],
          interfaces: [],
        };
  }

  isSubType(abstractType, maybeSubType) {
    let map = this._subTypeMap[abstractType.name];

    if (map === undefined) {
      map = Object.create(null);

      if (isUnionType(abstractType)) {
        for (const type of abstractType.getTypes()) {
          map[type.name] = true;
        }
      } else {
        const implementations = this.getImplementations(abstractType);

        for (const type of implementations.objects) {
          map[type.name] = true;
        }

        for (const type of implementations.interfaces) {
          map[type.name] = true;
        }
      }

      this._subTypeMap[abstractType.name] = map;
    }

    return map[maybeSubType.name] !== undefined;
  }

  getDirectives() {
    return this._directives;
  }

  getDirective(name) {
    return this.getDirectives().find((directive) => directive.name === name);
  }

  toConfig() {
    return {
      description: this.description,
      query: this.getQueryType(),
      mutation: this.getMutationType(),
      subscription: this.getSubscriptionType(),
      types: Object.values(this.getTypeMap()),
      directives: this.getDirectives(),
      extensions: this.extensions,
      astNode: this.astNode,
      extensionASTNodes: this.extensionASTNodes,
      assumeValid: this.__validationErrors !== undefined,
    };
  }
}

function collectReferencedTypes(type, typeSet) {
  const namedType = getNamedType(type);

  if (!typeSet.has(namedType)) {
    typeSet.add(namedType);

    if (isUnionType(namedType)) {
      for (const memberType of namedType.getTypes()) {
        collectReferencedTypes(memberType, typeSet);
      }
    } else if (isObjectType(namedType) || isInterfaceType(namedType)) {
      for (const interfaceType of namedType.getInterfaces()) {
        collectReferencedTypes(interfaceType, typeSet);
      }

      for (const field of Object.values(namedType.getFields())) {
        collectReferencedTypes(field.type, typeSet);

        for (const arg of field.args) {
          collectReferencedTypes(arg.type, typeSet);
        }
      }
    } else if (isInputObjectType(namedType)) {
      for (const field of Object.values(namedType.getFields())) {
        collectReferencedTypes(field.type, typeSet);
      }
    }
  }

  return typeSet;
}

;// CONCATENATED MODULE: ../node_modules/graphql/type/validate.mjs








/**
 * Implements the "Type Validation" sub-sections of the specification's
 * "Type System" section.
 *
 * Validation runs synchronously, returning an array of encountered errors, or
 * an empty array if no errors were encountered and the Schema is valid.
 */

function validateSchema(schema) {
  // First check to ensure the provided value is in fact a GraphQLSchema.
  assertSchema(schema); // If this Schema has already been validated, return the previous results.

  if (schema.__validationErrors) {
    return schema.__validationErrors;
  } // Validate the schema, producing a list of errors.

  const context = new SchemaValidationContext(schema);
  validateRootTypes(context);
  validateDirectives(context);
  validateTypes(context); // Persist the results of validation before returning to ensure validation
  // does not run multiple times for this schema.

  const errors = context.getErrors();
  schema.__validationErrors = errors;
  return errors;
}
/**
 * Utility function which asserts a schema is valid by throwing an error if
 * it is invalid.
 */

function assertValidSchema(schema) {
  const errors = validateSchema(schema);

  if (errors.length !== 0) {
    throw new Error(errors.map((error) => error.message).join('\n\n'));
  }
}

class SchemaValidationContext {
  constructor(schema) {
    this._errors = [];
    this.schema = schema;
  }

  reportError(message, nodes) {
    const _nodes = Array.isArray(nodes) ? nodes.filter(Boolean) : nodes;

    this._errors.push(
      new GraphQLError/* GraphQLError */.__(message, {
        nodes: _nodes,
      }),
    );
  }

  getErrors() {
    return this._errors;
  }
}

function validateRootTypes(context) {
  const schema = context.schema;
  const queryType = schema.getQueryType();

  if (!queryType) {
    context.reportError('Query root type must be provided.', schema.astNode);
  } else if (!isObjectType(queryType)) {
    var _getOperationTypeNode;

    context.reportError(
      `Query root type must be Object type, it cannot be ${(0,inspect/* inspect */.X)(
        queryType,
      )}.`,
      (_getOperationTypeNode = getOperationTypeNode(
        schema,
        ast/* OperationTypeNode.QUERY */.ku.QUERY,
      )) !== null && _getOperationTypeNode !== void 0
        ? _getOperationTypeNode
        : queryType.astNode,
    );
  }

  const mutationType = schema.getMutationType();

  if (mutationType && !isObjectType(mutationType)) {
    var _getOperationTypeNode2;

    context.reportError(
      'Mutation root type must be Object type if provided, it cannot be ' +
        `${(0,inspect/* inspect */.X)(mutationType)}.`,
      (_getOperationTypeNode2 = getOperationTypeNode(
        schema,
        ast/* OperationTypeNode.MUTATION */.ku.MUTATION,
      )) !== null && _getOperationTypeNode2 !== void 0
        ? _getOperationTypeNode2
        : mutationType.astNode,
    );
  }

  const subscriptionType = schema.getSubscriptionType();

  if (subscriptionType && !isObjectType(subscriptionType)) {
    var _getOperationTypeNode3;

    context.reportError(
      'Subscription root type must be Object type if provided, it cannot be ' +
        `${(0,inspect/* inspect */.X)(subscriptionType)}.`,
      (_getOperationTypeNode3 = getOperationTypeNode(
        schema,
        ast/* OperationTypeNode.SUBSCRIPTION */.ku.SUBSCRIPTION,
      )) !== null && _getOperationTypeNode3 !== void 0
        ? _getOperationTypeNode3
        : subscriptionType.astNode,
    );
  }
}

function getOperationTypeNode(schema, operation) {
  var _flatMap$find;

  return (_flatMap$find = [schema.astNode, ...schema.extensionASTNodes]
    .flatMap(
      // FIXME: https://github.com/graphql/graphql-js/issues/2203
      (schemaNode) => {
        var _schemaNode$operation;

        return (
          /* c8 ignore next */
          (_schemaNode$operation =
            schemaNode === null || schemaNode === void 0
              ? void 0
              : schemaNode.operationTypes) !== null &&
            _schemaNode$operation !== void 0
            ? _schemaNode$operation
            : []
        );
      },
    )
    .find((operationNode) => operationNode.operation === operation)) === null ||
    _flatMap$find === void 0
    ? void 0
    : _flatMap$find.type;
}

function validateDirectives(context) {
  for (const directive of context.schema.getDirectives()) {
    // Ensure all directives are in fact GraphQL directives.
    if (!isDirective(directive)) {
      context.reportError(
        `Expected directive but got: ${(0,inspect/* inspect */.X)(directive)}.`,
        directive === null || directive === void 0 ? void 0 : directive.astNode,
      );
      continue;
    } // Ensure they are named correctly.

    validateName(context, directive); // TODO: Ensure proper locations.
    // Ensure the arguments are valid.

    for (const arg of directive.args) {
      // Ensure they are named correctly.
      validateName(context, arg); // Ensure the type is an input type.

      if (!isInputType(arg.type)) {
        context.reportError(
          `The type of @${directive.name}(${arg.name}:) must be Input Type ` +
            `but got: ${(0,inspect/* inspect */.X)(arg.type)}.`,
          arg.astNode,
        );
      }

      if (isRequiredArgument(arg) && arg.deprecationReason != null) {
        var _arg$astNode;

        context.reportError(
          `Required argument @${directive.name}(${arg.name}:) cannot be deprecated.`,
          [
            getDeprecatedDirectiveNode(arg.astNode),
            (_arg$astNode = arg.astNode) === null || _arg$astNode === void 0
              ? void 0
              : _arg$astNode.type,
          ],
        );
      }
    }
  }
}

function validateName(context, node) {
  // Ensure names are valid, however introspection types opt out.
  if (node.name.startsWith('__')) {
    context.reportError(
      `Name "${node.name}" must not begin with "__", which is reserved by GraphQL introspection.`,
      node.astNode,
    );
  }
}

function validateTypes(context) {
  const validateInputObjectCircularRefs =
    createInputObjectCircularRefsValidator(context);
  const typeMap = context.schema.getTypeMap();

  for (const type of Object.values(typeMap)) {
    // Ensure all provided types are in fact GraphQL type.
    if (!isNamedType(type)) {
      context.reportError(
        `Expected GraphQL named type but got: ${(0,inspect/* inspect */.X)(type)}.`,
        type.astNode,
      );
      continue;
    } // Ensure it is named correctly (excluding introspection types).

    if (!isIntrospectionType(type)) {
      validateName(context, type);
    }

    if (isObjectType(type)) {
      // Ensure fields are valid
      validateFields(context, type); // Ensure objects implement the interfaces they claim to.

      validateInterfaces(context, type);
    } else if (isInterfaceType(type)) {
      // Ensure fields are valid.
      validateFields(context, type); // Ensure interfaces implement the interfaces they claim to.

      validateInterfaces(context, type);
    } else if (isUnionType(type)) {
      // Ensure Unions include valid member types.
      validateUnionMembers(context, type);
    } else if (isEnumType(type)) {
      // Ensure Enums have valid values.
      validateEnumValues(context, type);
    } else if (isInputObjectType(type)) {
      // Ensure Input Object fields are valid.
      validateInputFields(context, type); // Ensure Input Objects do not contain non-nullable circular references

      validateInputObjectCircularRefs(type);
    }
  }
}

function validateFields(context, type) {
  const fields = Object.values(type.getFields()); // Objects and Interfaces both must define one or more fields.

  if (fields.length === 0) {
    context.reportError(`Type ${type.name} must define one or more fields.`, [
      type.astNode,
      ...type.extensionASTNodes,
    ]);
  }

  for (const field of fields) {
    // Ensure they are named correctly.
    validateName(context, field); // Ensure the type is an output type

    if (!isOutputType(field.type)) {
      var _field$astNode;

      context.reportError(
        `The type of ${type.name}.${field.name} must be Output Type ` +
          `but got: ${(0,inspect/* inspect */.X)(field.type)}.`,
        (_field$astNode = field.astNode) === null || _field$astNode === void 0
          ? void 0
          : _field$astNode.type,
      );
    } // Ensure the arguments are valid

    for (const arg of field.args) {
      const argName = arg.name; // Ensure they are named correctly.

      validateName(context, arg); // Ensure the type is an input type

      if (!isInputType(arg.type)) {
        var _arg$astNode2;

        context.reportError(
          `The type of ${type.name}.${field.name}(${argName}:) must be Input ` +
            `Type but got: ${(0,inspect/* inspect */.X)(arg.type)}.`,
          (_arg$astNode2 = arg.astNode) === null || _arg$astNode2 === void 0
            ? void 0
            : _arg$astNode2.type,
        );
      }

      if (isRequiredArgument(arg) && arg.deprecationReason != null) {
        var _arg$astNode3;

        context.reportError(
          `Required argument ${type.name}.${field.name}(${argName}:) cannot be deprecated.`,
          [
            getDeprecatedDirectiveNode(arg.astNode),
            (_arg$astNode3 = arg.astNode) === null || _arg$astNode3 === void 0
              ? void 0
              : _arg$astNode3.type,
          ],
        );
      }
    }
  }
}

function validateInterfaces(context, type) {
  const ifaceTypeNames = Object.create(null);

  for (const iface of type.getInterfaces()) {
    if (!isInterfaceType(iface)) {
      context.reportError(
        `Type ${(0,inspect/* inspect */.X)(type)} must only implement Interface types, ` +
          `it cannot implement ${(0,inspect/* inspect */.X)(iface)}.`,
        getAllImplementsInterfaceNodes(type, iface),
      );
      continue;
    }

    if (type === iface) {
      context.reportError(
        `Type ${type.name} cannot implement itself because it would create a circular reference.`,
        getAllImplementsInterfaceNodes(type, iface),
      );
      continue;
    }

    if (ifaceTypeNames[iface.name]) {
      context.reportError(
        `Type ${type.name} can only implement ${iface.name} once.`,
        getAllImplementsInterfaceNodes(type, iface),
      );
      continue;
    }

    ifaceTypeNames[iface.name] = true;
    validateTypeImplementsAncestors(context, type, iface);
    validateTypeImplementsInterface(context, type, iface);
  }
}

function validateTypeImplementsInterface(context, type, iface) {
  const typeFieldMap = type.getFields(); // Assert each interface field is implemented.

  for (const ifaceField of Object.values(iface.getFields())) {
    const fieldName = ifaceField.name;
    const typeField = typeFieldMap[fieldName]; // Assert interface field exists on type.

    if (!typeField) {
      context.reportError(
        `Interface field ${iface.name}.${fieldName} expected but ${type.name} does not provide it.`,
        [ifaceField.astNode, type.astNode, ...type.extensionASTNodes],
      );
      continue;
    } // Assert interface field type is satisfied by type field type, by being
    // a valid subtype. (covariant)

    if (!isTypeSubTypeOf(context.schema, typeField.type, ifaceField.type)) {
      var _ifaceField$astNode, _typeField$astNode;

      context.reportError(
        `Interface field ${iface.name}.${fieldName} expects type ` +
          `${(0,inspect/* inspect */.X)(ifaceField.type)} but ${type.name}.${fieldName} ` +
          `is type ${(0,inspect/* inspect */.X)(typeField.type)}.`,
        [
          (_ifaceField$astNode = ifaceField.astNode) === null ||
          _ifaceField$astNode === void 0
            ? void 0
            : _ifaceField$astNode.type,
          (_typeField$astNode = typeField.astNode) === null ||
          _typeField$astNode === void 0
            ? void 0
            : _typeField$astNode.type,
        ],
      );
    } // Assert each interface field arg is implemented.

    for (const ifaceArg of ifaceField.args) {
      const argName = ifaceArg.name;
      const typeArg = typeField.args.find((arg) => arg.name === argName); // Assert interface field arg exists on object field.

      if (!typeArg) {
        context.reportError(
          `Interface field argument ${iface.name}.${fieldName}(${argName}:) expected but ${type.name}.${fieldName} does not provide it.`,
          [ifaceArg.astNode, typeField.astNode],
        );
        continue;
      } // Assert interface field arg type matches object field arg type.
      // (invariant)
      // TODO: change to contravariant?

      if (!isEqualType(ifaceArg.type, typeArg.type)) {
        var _ifaceArg$astNode, _typeArg$astNode;

        context.reportError(
          `Interface field argument ${iface.name}.${fieldName}(${argName}:) ` +
            `expects type ${(0,inspect/* inspect */.X)(ifaceArg.type)} but ` +
            `${type.name}.${fieldName}(${argName}:) is type ` +
            `${(0,inspect/* inspect */.X)(typeArg.type)}.`,
          [
            (_ifaceArg$astNode = ifaceArg.astNode) === null ||
            _ifaceArg$astNode === void 0
              ? void 0
              : _ifaceArg$astNode.type,
            (_typeArg$astNode = typeArg.astNode) === null ||
            _typeArg$astNode === void 0
              ? void 0
              : _typeArg$astNode.type,
          ],
        );
      } // TODO: validate default values?
    } // Assert additional arguments must not be required.

    for (const typeArg of typeField.args) {
      const argName = typeArg.name;
      const ifaceArg = ifaceField.args.find((arg) => arg.name === argName);

      if (!ifaceArg && isRequiredArgument(typeArg)) {
        context.reportError(
          `Object field ${type.name}.${fieldName} includes required argument ${argName} that is missing from the Interface field ${iface.name}.${fieldName}.`,
          [typeArg.astNode, ifaceField.astNode],
        );
      }
    }
  }
}

function validateTypeImplementsAncestors(context, type, iface) {
  const ifaceInterfaces = type.getInterfaces();

  for (const transitive of iface.getInterfaces()) {
    if (!ifaceInterfaces.includes(transitive)) {
      context.reportError(
        transitive === type
          ? `Type ${type.name} cannot implement ${iface.name} because it would create a circular reference.`
          : `Type ${type.name} must implement ${transitive.name} because it is implemented by ${iface.name}.`,
        [
          ...getAllImplementsInterfaceNodes(iface, transitive),
          ...getAllImplementsInterfaceNodes(type, iface),
        ],
      );
    }
  }
}

function validateUnionMembers(context, union) {
  const memberTypes = union.getTypes();

  if (memberTypes.length === 0) {
    context.reportError(
      `Union type ${union.name} must define one or more member types.`,
      [union.astNode, ...union.extensionASTNodes],
    );
  }

  const includedTypeNames = Object.create(null);

  for (const memberType of memberTypes) {
    if (includedTypeNames[memberType.name]) {
      context.reportError(
        `Union type ${union.name} can only include type ${memberType.name} once.`,
        getUnionMemberTypeNodes(union, memberType.name),
      );
      continue;
    }

    includedTypeNames[memberType.name] = true;

    if (!isObjectType(memberType)) {
      context.reportError(
        `Union type ${union.name} can only include Object types, ` +
          `it cannot include ${(0,inspect/* inspect */.X)(memberType)}.`,
        getUnionMemberTypeNodes(union, String(memberType)),
      );
    }
  }
}

function validateEnumValues(context, enumType) {
  const enumValues = enumType.getValues();

  if (enumValues.length === 0) {
    context.reportError(
      `Enum type ${enumType.name} must define one or more values.`,
      [enumType.astNode, ...enumType.extensionASTNodes],
    );
  }

  for (const enumValue of enumValues) {
    // Ensure valid name.
    validateName(context, enumValue);
  }
}

function validateInputFields(context, inputObj) {
  const fields = Object.values(inputObj.getFields());

  if (fields.length === 0) {
    context.reportError(
      `Input Object type ${inputObj.name} must define one or more fields.`,
      [inputObj.astNode, ...inputObj.extensionASTNodes],
    );
  } // Ensure the arguments are valid

  for (const field of fields) {
    // Ensure they are named correctly.
    validateName(context, field); // Ensure the type is an input type

    if (!isInputType(field.type)) {
      var _field$astNode2;

      context.reportError(
        `The type of ${inputObj.name}.${field.name} must be Input Type ` +
          `but got: ${(0,inspect/* inspect */.X)(field.type)}.`,
        (_field$astNode2 = field.astNode) === null || _field$astNode2 === void 0
          ? void 0
          : _field$astNode2.type,
      );
    }

    if (isRequiredInputField(field) && field.deprecationReason != null) {
      var _field$astNode3;

      context.reportError(
        `Required input field ${inputObj.name}.${field.name} cannot be deprecated.`,
        [
          getDeprecatedDirectiveNode(field.astNode),
          (_field$astNode3 = field.astNode) === null ||
          _field$astNode3 === void 0
            ? void 0
            : _field$astNode3.type,
        ],
      );
    }

    if (inputObj.isOneOf) {
      validateOneOfInputObjectField(inputObj, field, context);
    }
  }
}

function validateOneOfInputObjectField(type, field, context) {
  if (isNonNullType(field.type)) {
    var _field$astNode4;

    context.reportError(
      `OneOf input field ${type.name}.${field.name} must be nullable.`,
      (_field$astNode4 = field.astNode) === null || _field$astNode4 === void 0
        ? void 0
        : _field$astNode4.type,
    );
  }

  if (field.defaultValue !== undefined) {
    context.reportError(
      `OneOf input field ${type.name}.${field.name} cannot have a default value.`,
      field.astNode,
    );
  }
}

function createInputObjectCircularRefsValidator(context) {
  // Modified copy of algorithm from 'src/validation/rules/NoFragmentCycles.js'.
  // Tracks already visited types to maintain O(N) and to ensure that cycles
  // are not redundantly reported.
  const visitedTypes = Object.create(null); // Array of types nodes used to produce meaningful errors

  const fieldPath = []; // Position in the type path

  const fieldPathIndexByTypeName = Object.create(null);
  return detectCycleRecursive; // This does a straight-forward DFS to find cycles.
  // It does not terminate when a cycle was found but continues to explore
  // the graph to find all possible cycles.

  function detectCycleRecursive(inputObj) {
    if (visitedTypes[inputObj.name]) {
      return;
    }

    visitedTypes[inputObj.name] = true;
    fieldPathIndexByTypeName[inputObj.name] = fieldPath.length;
    const fields = Object.values(inputObj.getFields());

    for (const field of fields) {
      if (isNonNullType(field.type) && isInputObjectType(field.type.ofType)) {
        const fieldType = field.type.ofType;
        const cycleIndex = fieldPathIndexByTypeName[fieldType.name];
        fieldPath.push(field);

        if (cycleIndex === undefined) {
          detectCycleRecursive(fieldType);
        } else {
          const cyclePath = fieldPath.slice(cycleIndex);
          const pathStr = cyclePath.map((fieldObj) => fieldObj.name).join('.');
          context.reportError(
            `Cannot reference Input Object "${fieldType.name}" within itself through a series of non-null fields: "${pathStr}".`,
            cyclePath.map((fieldObj) => fieldObj.astNode),
          );
        }

        fieldPath.pop();
      }
    }

    fieldPathIndexByTypeName[inputObj.name] = undefined;
  }
}

function getAllImplementsInterfaceNodes(type, iface) {
  const { astNode, extensionASTNodes } = type;
  const nodes =
    astNode != null ? [astNode, ...extensionASTNodes] : extensionASTNodes; // FIXME: https://github.com/graphql/graphql-js/issues/2203

  return nodes
    .flatMap((typeNode) => {
      var _typeNode$interfaces;

      return (
        /* c8 ignore next */
        (_typeNode$interfaces = typeNode.interfaces) !== null &&
          _typeNode$interfaces !== void 0
          ? _typeNode$interfaces
          : []
      );
    })
    .filter((ifaceNode) => ifaceNode.name.value === iface.name);
}

function getUnionMemberTypeNodes(union, typeName) {
  const { astNode, extensionASTNodes } = union;
  const nodes =
    astNode != null ? [astNode, ...extensionASTNodes] : extensionASTNodes; // FIXME: https://github.com/graphql/graphql-js/issues/2203

  return nodes
    .flatMap((unionNode) => {
      var _unionNode$types;

      return (
        /* c8 ignore next */
        (_unionNode$types = unionNode.types) !== null &&
          _unionNode$types !== void 0
          ? _unionNode$types
          : []
      );
    })
    .filter((typeNode) => typeNode.name.value === typeName);
}

function getDeprecatedDirectiveNode(definitionNode) {
  var _definitionNode$direc;

  return definitionNode === null || definitionNode === void 0
    ? void 0
    : (_definitionNode$direc = definitionNode.directives) === null ||
      _definitionNode$direc === void 0
    ? void 0
    : _definitionNode$direc.find(
        (node) => node.name.value === GraphQLDeprecatedDirective.name,
      );
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/typeFromAST.mjs


function typeFromAST(schema, typeNode) {
  switch (typeNode.kind) {
    case kinds/* Kind.LIST_TYPE */.h.LIST_TYPE: {
      const innerType = typeFromAST(schema, typeNode.type);
      return innerType && new GraphQLList(innerType);
    }

    case kinds/* Kind.NON_NULL_TYPE */.h.NON_NULL_TYPE: {
      const innerType = typeFromAST(schema, typeNode.type);
      return innerType && new GraphQLNonNull(innerType);
    }

    case kinds/* Kind.NAMED_TYPE */.h.NAMED_TYPE:
      return schema.getType(typeNode.name.value);
  }
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/TypeInfo.mjs






/**
 * TypeInfo is a utility class which, given a GraphQL schema, can keep track
 * of the current field and type definitions at any point in a GraphQL document
 * AST during a recursive descent by calling `enter(node)` and `leave(node)`.
 */

class TypeInfo {
  constructor(
    schema,
    /**
     * Initial type may be provided in rare cases to facilitate traversals
     *  beginning somewhere other than documents.
     */
    initialType,
    /** @deprecated will be removed in 17.0.0 */
    getFieldDefFn,
  ) {
    this._schema = schema;
    this._typeStack = [];
    this._parentTypeStack = [];
    this._inputTypeStack = [];
    this._fieldDefStack = [];
    this._defaultValueStack = [];
    this._directive = null;
    this._argument = null;
    this._enumValue = null;
    this._getFieldDef =
      getFieldDefFn !== null && getFieldDefFn !== void 0
        ? getFieldDefFn
        : getFieldDef;

    if (initialType) {
      if (isInputType(initialType)) {
        this._inputTypeStack.push(initialType);
      }

      if (isCompositeType(initialType)) {
        this._parentTypeStack.push(initialType);
      }

      if (isOutputType(initialType)) {
        this._typeStack.push(initialType);
      }
    }
  }

  get [Symbol.toStringTag]() {
    return 'TypeInfo';
  }

  getType() {
    if (this._typeStack.length > 0) {
      return this._typeStack[this._typeStack.length - 1];
    }
  }

  getParentType() {
    if (this._parentTypeStack.length > 0) {
      return this._parentTypeStack[this._parentTypeStack.length - 1];
    }
  }

  getInputType() {
    if (this._inputTypeStack.length > 0) {
      return this._inputTypeStack[this._inputTypeStack.length - 1];
    }
  }

  getParentInputType() {
    if (this._inputTypeStack.length > 1) {
      return this._inputTypeStack[this._inputTypeStack.length - 2];
    }
  }

  getFieldDef() {
    if (this._fieldDefStack.length > 0) {
      return this._fieldDefStack[this._fieldDefStack.length - 1];
    }
  }

  getDefaultValue() {
    if (this._defaultValueStack.length > 0) {
      return this._defaultValueStack[this._defaultValueStack.length - 1];
    }
  }

  getDirective() {
    return this._directive;
  }

  getArgument() {
    return this._argument;
  }

  getEnumValue() {
    return this._enumValue;
  }

  enter(node) {
    const schema = this._schema; // Note: many of the types below are explicitly typed as "unknown" to drop
    // any assumptions of a valid schema to ensure runtime types are properly
    // checked before continuing since TypeInfo is used as part of validation
    // which occurs before guarantees of schema and document validity.

    switch (node.kind) {
      case kinds/* Kind.SELECTION_SET */.h.SELECTION_SET: {
        const namedType = getNamedType(this.getType());

        this._parentTypeStack.push(
          isCompositeType(namedType) ? namedType : undefined,
        );

        break;
      }

      case kinds/* Kind.FIELD */.h.FIELD: {
        const parentType = this.getParentType();
        let fieldDef;
        let fieldType;

        if (parentType) {
          fieldDef = this._getFieldDef(schema, parentType, node);

          if (fieldDef) {
            fieldType = fieldDef.type;
          }
        }

        this._fieldDefStack.push(fieldDef);

        this._typeStack.push(isOutputType(fieldType) ? fieldType : undefined);

        break;
      }

      case kinds/* Kind.DIRECTIVE */.h.DIRECTIVE:
        this._directive = schema.getDirective(node.name.value);
        break;

      case kinds/* Kind.OPERATION_DEFINITION */.h.OPERATION_DEFINITION: {
        const rootType = schema.getRootType(node.operation);

        this._typeStack.push(isObjectType(rootType) ? rootType : undefined);

        break;
      }

      case kinds/* Kind.INLINE_FRAGMENT */.h.INLINE_FRAGMENT:
      case kinds/* Kind.FRAGMENT_DEFINITION */.h.FRAGMENT_DEFINITION: {
        const typeConditionAST = node.typeCondition;
        const outputType = typeConditionAST
          ? typeFromAST(schema, typeConditionAST)
          : getNamedType(this.getType());

        this._typeStack.push(isOutputType(outputType) ? outputType : undefined);

        break;
      }

      case kinds/* Kind.VARIABLE_DEFINITION */.h.VARIABLE_DEFINITION: {
        const inputType = typeFromAST(schema, node.type);

        this._inputTypeStack.push(
          isInputType(inputType) ? inputType : undefined,
        );

        break;
      }

      case kinds/* Kind.ARGUMENT */.h.ARGUMENT: {
        var _this$getDirective;

        let argDef;
        let argType;
        const fieldOrDirective =
          (_this$getDirective = this.getDirective()) !== null &&
          _this$getDirective !== void 0
            ? _this$getDirective
            : this.getFieldDef();

        if (fieldOrDirective) {
          argDef = fieldOrDirective.args.find(
            (arg) => arg.name === node.name.value,
          );

          if (argDef) {
            argType = argDef.type;
          }
        }

        this._argument = argDef;

        this._defaultValueStack.push(argDef ? argDef.defaultValue : undefined);

        this._inputTypeStack.push(isInputType(argType) ? argType : undefined);

        break;
      }

      case kinds/* Kind.LIST */.h.LIST: {
        const listType = getNullableType(this.getInputType());
        const itemType = isListType(listType) ? listType.ofType : listType; // List positions never have a default value.

        this._defaultValueStack.push(undefined);

        this._inputTypeStack.push(isInputType(itemType) ? itemType : undefined);

        break;
      }

      case kinds/* Kind.OBJECT_FIELD */.h.OBJECT_FIELD: {
        const objectType = getNamedType(this.getInputType());
        let inputFieldType;
        let inputField;

        if (isInputObjectType(objectType)) {
          inputField = objectType.getFields()[node.name.value];

          if (inputField) {
            inputFieldType = inputField.type;
          }
        }

        this._defaultValueStack.push(
          inputField ? inputField.defaultValue : undefined,
        );

        this._inputTypeStack.push(
          isInputType(inputFieldType) ? inputFieldType : undefined,
        );

        break;
      }

      case kinds/* Kind.ENUM */.h.ENUM: {
        const enumType = getNamedType(this.getInputType());
        let enumValue;

        if (isEnumType(enumType)) {
          enumValue = enumType.getValue(node.value);
        }

        this._enumValue = enumValue;
        break;
      }

      default: // Ignore other nodes
    }
  }

  leave(node) {
    switch (node.kind) {
      case kinds/* Kind.SELECTION_SET */.h.SELECTION_SET:
        this._parentTypeStack.pop();

        break;

      case kinds/* Kind.FIELD */.h.FIELD:
        this._fieldDefStack.pop();

        this._typeStack.pop();

        break;

      case kinds/* Kind.DIRECTIVE */.h.DIRECTIVE:
        this._directive = null;
        break;

      case kinds/* Kind.OPERATION_DEFINITION */.h.OPERATION_DEFINITION:
      case kinds/* Kind.INLINE_FRAGMENT */.h.INLINE_FRAGMENT:
      case kinds/* Kind.FRAGMENT_DEFINITION */.h.FRAGMENT_DEFINITION:
        this._typeStack.pop();

        break;

      case kinds/* Kind.VARIABLE_DEFINITION */.h.VARIABLE_DEFINITION:
        this._inputTypeStack.pop();

        break;

      case kinds/* Kind.ARGUMENT */.h.ARGUMENT:
        this._argument = null;

        this._defaultValueStack.pop();

        this._inputTypeStack.pop();

        break;

      case kinds/* Kind.LIST */.h.LIST:
      case kinds/* Kind.OBJECT_FIELD */.h.OBJECT_FIELD:
        this._defaultValueStack.pop();

        this._inputTypeStack.pop();

        break;

      case kinds/* Kind.ENUM */.h.ENUM:
        this._enumValue = null;
        break;

      default: // Ignore other nodes
    }
  }
}

/**
 * Not exactly the same as the executor's definition of getFieldDef, in this
 * statically evaluated environment we do not always have an Object type,
 * and need to handle Interface and Union types.
 */
function getFieldDef(schema, parentType, fieldNode) {
  const name = fieldNode.name.value;

  if (
    name === SchemaMetaFieldDef.name &&
    schema.getQueryType() === parentType
  ) {
    return SchemaMetaFieldDef;
  }

  if (name === TypeMetaFieldDef.name && schema.getQueryType() === parentType) {
    return TypeMetaFieldDef;
  }

  if (name === TypeNameMetaFieldDef.name && isCompositeType(parentType)) {
    return TypeNameMetaFieldDef;
  }

  if (isObjectType(parentType) || isInterfaceType(parentType)) {
    return parentType.getFields()[name];
  }
}
/**
 * Creates a new visitor instance which maintains a provided TypeInfo instance
 * along with visiting visitor.
 */

function visitWithTypeInfo(typeInfo, visitor) {
  return {
    enter(...args) {
      const node = args[0];
      typeInfo.enter(node);
      const fn = getEnterLeaveForKind(visitor, node.kind).enter;

      if (fn) {
        const result = fn.apply(visitor, args);

        if (result !== undefined) {
          typeInfo.leave(node);

          if ((0,ast/* isNode */.UG)(result)) {
            typeInfo.enter(result);
          }
        }

        return result;
      }
    },

    leave(...args) {
      const node = args[0];
      const fn = getEnterLeaveForKind(visitor, node.kind).leave;
      let result;

      if (fn) {
        result = fn.apply(visitor, args);
      }

      typeInfo.leave(node);
      return result;
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/language/predicates.mjs

function isDefinitionNode(node) {
  return (
    isExecutableDefinitionNode(node) ||
    isTypeSystemDefinitionNode(node) ||
    isTypeSystemExtensionNode(node)
  );
}
function isExecutableDefinitionNode(node) {
  return (
    node.kind === kinds/* Kind.OPERATION_DEFINITION */.h.OPERATION_DEFINITION ||
    node.kind === kinds/* Kind.FRAGMENT_DEFINITION */.h.FRAGMENT_DEFINITION
  );
}
function isSelectionNode(node) {
  return (
    node.kind === kinds/* Kind.FIELD */.h.FIELD ||
    node.kind === kinds/* Kind.FRAGMENT_SPREAD */.h.FRAGMENT_SPREAD ||
    node.kind === kinds/* Kind.INLINE_FRAGMENT */.h.INLINE_FRAGMENT
  );
}
function isValueNode(node) {
  return (
    node.kind === kinds/* Kind.VARIABLE */.h.VARIABLE ||
    node.kind === kinds/* Kind.INT */.h.INT ||
    node.kind === kinds/* Kind.FLOAT */.h.FLOAT ||
    node.kind === kinds/* Kind.STRING */.h.STRING ||
    node.kind === kinds/* Kind.BOOLEAN */.h.BOOLEAN ||
    node.kind === kinds/* Kind.NULL */.h.NULL ||
    node.kind === kinds/* Kind.ENUM */.h.ENUM ||
    node.kind === kinds/* Kind.LIST */.h.LIST ||
    node.kind === kinds/* Kind.OBJECT */.h.OBJECT
  );
}
function isConstValueNode(node) {
  return (
    isValueNode(node) &&
    (node.kind === kinds/* Kind.LIST */.h.LIST
      ? node.values.some(isConstValueNode)
      : node.kind === kinds/* Kind.OBJECT */.h.OBJECT
      ? node.fields.some((field) => isConstValueNode(field.value))
      : node.kind !== kinds/* Kind.VARIABLE */.h.VARIABLE)
  );
}
function isTypeNode(node) {
  return (
    node.kind === kinds/* Kind.NAMED_TYPE */.h.NAMED_TYPE ||
    node.kind === kinds/* Kind.LIST_TYPE */.h.LIST_TYPE ||
    node.kind === kinds/* Kind.NON_NULL_TYPE */.h.NON_NULL_TYPE
  );
}
function isTypeSystemDefinitionNode(node) {
  return (
    node.kind === kinds/* Kind.SCHEMA_DEFINITION */.h.SCHEMA_DEFINITION ||
    isTypeDefinitionNode(node) ||
    node.kind === kinds/* Kind.DIRECTIVE_DEFINITION */.h.DIRECTIVE_DEFINITION
  );
}
function isTypeDefinitionNode(node) {
  return (
    node.kind === kinds/* Kind.SCALAR_TYPE_DEFINITION */.h.SCALAR_TYPE_DEFINITION ||
    node.kind === kinds/* Kind.OBJECT_TYPE_DEFINITION */.h.OBJECT_TYPE_DEFINITION ||
    node.kind === kinds/* Kind.INTERFACE_TYPE_DEFINITION */.h.INTERFACE_TYPE_DEFINITION ||
    node.kind === kinds/* Kind.UNION_TYPE_DEFINITION */.h.UNION_TYPE_DEFINITION ||
    node.kind === kinds/* Kind.ENUM_TYPE_DEFINITION */.h.ENUM_TYPE_DEFINITION ||
    node.kind === kinds/* Kind.INPUT_OBJECT_TYPE_DEFINITION */.h.INPUT_OBJECT_TYPE_DEFINITION
  );
}
function isTypeSystemExtensionNode(node) {
  return node.kind === kinds/* Kind.SCHEMA_EXTENSION */.h.SCHEMA_EXTENSION || isTypeExtensionNode(node);
}
function isTypeExtensionNode(node) {
  return (
    node.kind === kinds/* Kind.SCALAR_TYPE_EXTENSION */.h.SCALAR_TYPE_EXTENSION ||
    node.kind === kinds/* Kind.OBJECT_TYPE_EXTENSION */.h.OBJECT_TYPE_EXTENSION ||
    node.kind === kinds/* Kind.INTERFACE_TYPE_EXTENSION */.h.INTERFACE_TYPE_EXTENSION ||
    node.kind === kinds/* Kind.UNION_TYPE_EXTENSION */.h.UNION_TYPE_EXTENSION ||
    node.kind === kinds/* Kind.ENUM_TYPE_EXTENSION */.h.ENUM_TYPE_EXTENSION ||
    node.kind === kinds/* Kind.INPUT_OBJECT_TYPE_EXTENSION */.h.INPUT_OBJECT_TYPE_EXTENSION
  );
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/ExecutableDefinitionsRule.mjs




/**
 * Executable definitions
 *
 * A GraphQL document is only valid for execution if all definitions are either
 * operation or fragment definitions.
 *
 * See https://spec.graphql.org/draft/#sec-Executable-Definitions
 */
function ExecutableDefinitionsRule(context) {
  return {
    Document(node) {
      for (const definition of node.definitions) {
        if (!isExecutableDefinitionNode(definition)) {
          const defName =
            definition.kind === kinds/* Kind.SCHEMA_DEFINITION */.h.SCHEMA_DEFINITION ||
            definition.kind === kinds/* Kind.SCHEMA_EXTENSION */.h.SCHEMA_EXTENSION
              ? 'schema'
              : '"' + definition.name.value + '"';
          context.reportError(
            new GraphQLError/* GraphQLError */.__(`The ${defName} definition is not executable.`, {
              nodes: definition,
            }),
          );
        }
      }

      return false;
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/FieldsOnCorrectTypeRule.mjs






/**
 * Fields on correct type
 *
 * A GraphQL document is only valid if all fields selected are defined by the
 * parent type, or are an allowed meta field such as __typename.
 *
 * See https://spec.graphql.org/draft/#sec-Field-Selections
 */
function FieldsOnCorrectTypeRule(context) {
  return {
    Field(node) {
      const type = context.getParentType();

      if (type) {
        const fieldDef = context.getFieldDef();

        if (!fieldDef) {
          // This field doesn't exist, lets look for suggestions.
          const schema = context.getSchema();
          const fieldName = node.name.value; // First determine if there are any suggested types to condition on.

          let suggestion = didYouMean(
            'to use an inline fragment on',
            getSuggestedTypeNames(schema, type, fieldName),
          ); // If there are no suggested types, then perhaps this was a typo?

          if (suggestion === '') {
            suggestion = didYouMean(getSuggestedFieldNames(type, fieldName));
          } // Report an error, including helpful suggestions.

          context.reportError(
            new GraphQLError/* GraphQLError */.__(
              `Cannot query field "${fieldName}" on type "${type.name}".` +
                suggestion,
              {
                nodes: node,
              },
            ),
          );
        }
      }
    },
  };
}
/**
 * Go through all of the implementations of type, as well as the interfaces that
 * they implement. If any of those types include the provided field, suggest them,
 * sorted by how often the type is referenced.
 */

function getSuggestedTypeNames(schema, type, fieldName) {
  if (!isAbstractType(type)) {
    // Must be an Object type, which does not have possible fields.
    return [];
  }

  const suggestedTypes = new Set();
  const usageCount = Object.create(null);

  for (const possibleType of schema.getPossibleTypes(type)) {
    if (!possibleType.getFields()[fieldName]) {
      continue;
    } // This object type defines this field.

    suggestedTypes.add(possibleType);
    usageCount[possibleType.name] = 1;

    for (const possibleInterface of possibleType.getInterfaces()) {
      var _usageCount$possibleI;

      if (!possibleInterface.getFields()[fieldName]) {
        continue;
      } // This interface type defines this field.

      suggestedTypes.add(possibleInterface);
      usageCount[possibleInterface.name] =
        ((_usageCount$possibleI = usageCount[possibleInterface.name]) !==
          null && _usageCount$possibleI !== void 0
          ? _usageCount$possibleI
          : 0) + 1;
    }
  }

  return [...suggestedTypes]
    .sort((typeA, typeB) => {
      // Suggest both interface and object types based on how common they are.
      const usageCountDiff = usageCount[typeB.name] - usageCount[typeA.name];

      if (usageCountDiff !== 0) {
        return usageCountDiff;
      } // Suggest super types first followed by subtypes

      if (isInterfaceType(typeA) && schema.isSubType(typeA, typeB)) {
        return -1;
      }

      if (isInterfaceType(typeB) && schema.isSubType(typeB, typeA)) {
        return 1;
      }

      return naturalCompare(typeA.name, typeB.name);
    })
    .map((x) => x.name);
}
/**
 * For the field name provided, determine if there are any similar field names
 * that may be the result of a typo.
 */

function getSuggestedFieldNames(type, fieldName) {
  if (isObjectType(type) || isInterfaceType(type)) {
    const possibleFieldNames = Object.keys(type.getFields());
    return suggestionList(fieldName, possibleFieldNames);
  } // Otherwise, must be a Union type, which does not define fields.

  return [];
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/FragmentsOnCompositeTypesRule.mjs





/**
 * Fragments on composite type
 *
 * Fragments use a type condition to determine if they apply, since fragments
 * can only be spread into a composite type (object, interface, or union), the
 * type condition must also be a composite type.
 *
 * See https://spec.graphql.org/draft/#sec-Fragments-On-Composite-Types
 */
function FragmentsOnCompositeTypesRule(context) {
  return {
    InlineFragment(node) {
      const typeCondition = node.typeCondition;

      if (typeCondition) {
        const type = typeFromAST(context.getSchema(), typeCondition);

        if (type && !isCompositeType(type)) {
          const typeStr = print(typeCondition);
          context.reportError(
            new GraphQLError/* GraphQLError */.__(
              `Fragment cannot condition on non composite type "${typeStr}".`,
              {
                nodes: typeCondition,
              },
            ),
          );
        }
      }
    },

    FragmentDefinition(node) {
      const type = typeFromAST(context.getSchema(), node.typeCondition);

      if (type && !isCompositeType(type)) {
        const typeStr = print(node.typeCondition);
        context.reportError(
          new GraphQLError/* GraphQLError */.__(
            `Fragment "${node.name.value}" cannot condition on non composite type "${typeStr}".`,
            {
              nodes: node.typeCondition,
            },
          ),
        );
      }
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/KnownArgumentNamesRule.mjs






/**
 * Known argument names
 *
 * A GraphQL field is only valid if all supplied arguments are defined by
 * that field.
 *
 * See https://spec.graphql.org/draft/#sec-Argument-Names
 * See https://spec.graphql.org/draft/#sec-Directives-Are-In-Valid-Locations
 */
function KnownArgumentNamesRule(context) {
  return {
    // eslint-disable-next-line new-cap
    ...KnownArgumentNamesOnDirectivesRule(context),

    Argument(argNode) {
      const argDef = context.getArgument();
      const fieldDef = context.getFieldDef();
      const parentType = context.getParentType();

      if (!argDef && fieldDef && parentType) {
        const argName = argNode.name.value;
        const knownArgsNames = fieldDef.args.map((arg) => arg.name);
        const suggestions = suggestionList(argName, knownArgsNames);
        context.reportError(
          new GraphQLError/* GraphQLError */.__(
            `Unknown argument "${argName}" on field "${parentType.name}.${fieldDef.name}".` +
              didYouMean(suggestions),
            {
              nodes: argNode,
            },
          ),
        );
      }
    },
  };
}
/**
 * @internal
 */

function KnownArgumentNamesOnDirectivesRule(context) {
  const directiveArgs = Object.create(null);
  const schema = context.getSchema();
  const definedDirectives = schema
    ? schema.getDirectives()
    : specifiedDirectives;

  for (const directive of definedDirectives) {
    directiveArgs[directive.name] = directive.args.map((arg) => arg.name);
  }

  const astDefinitions = context.getDocument().definitions;

  for (const def of astDefinitions) {
    if (def.kind === kinds/* Kind.DIRECTIVE_DEFINITION */.h.DIRECTIVE_DEFINITION) {
      var _def$arguments;

      // FIXME: https://github.com/graphql/graphql-js/issues/2203

      /* c8 ignore next */
      const argsNodes =
        (_def$arguments = def.arguments) !== null && _def$arguments !== void 0
          ? _def$arguments
          : [];
      directiveArgs[def.name.value] = argsNodes.map((arg) => arg.name.value);
    }
  }

  return {
    Directive(directiveNode) {
      const directiveName = directiveNode.name.value;
      const knownArgs = directiveArgs[directiveName];

      if (directiveNode.arguments && knownArgs) {
        for (const argNode of directiveNode.arguments) {
          const argName = argNode.name.value;

          if (!knownArgs.includes(argName)) {
            const suggestions = suggestionList(argName, knownArgs);
            context.reportError(
              new GraphQLError/* GraphQLError */.__(
                `Unknown argument "${argName}" on directive "@${directiveName}".` +
                  didYouMean(suggestions),
                {
                  nodes: argNode,
                },
              ),
            );
          }
        }
      }

      return false;
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/KnownDirectivesRule.mjs








/**
 * Known directives
 *
 * A GraphQL document is only valid if all `@directives` are known by the
 * schema and legally positioned.
 *
 * See https://spec.graphql.org/draft/#sec-Directives-Are-Defined
 */
function KnownDirectivesRule(context) {
  const locationsMap = Object.create(null);
  const schema = context.getSchema();
  const definedDirectives = schema
    ? schema.getDirectives()
    : specifiedDirectives;

  for (const directive of definedDirectives) {
    locationsMap[directive.name] = directive.locations;
  }

  const astDefinitions = context.getDocument().definitions;

  for (const def of astDefinitions) {
    if (def.kind === kinds/* Kind.DIRECTIVE_DEFINITION */.h.DIRECTIVE_DEFINITION) {
      locationsMap[def.name.value] = def.locations.map((name) => name.value);
    }
  }

  return {
    Directive(node, _key, _parent, _path, ancestors) {
      const name = node.name.value;
      const locations = locationsMap[name];

      if (!locations) {
        context.reportError(
          new GraphQLError/* GraphQLError */.__(`Unknown directive "@${name}".`, {
            nodes: node,
          }),
        );
        return;
      }

      const candidateLocation = getDirectiveLocationForASTPath(ancestors);

      if (candidateLocation && !locations.includes(candidateLocation)) {
        context.reportError(
          new GraphQLError/* GraphQLError */.__(
            `Directive "@${name}" may not be used on ${candidateLocation}.`,
            {
              nodes: node,
            },
          ),
        );
      }
    },
  };
}

function getDirectiveLocationForASTPath(ancestors) {
  const appliedTo = ancestors[ancestors.length - 1];
  'kind' in appliedTo || (0,invariant/* invariant */.k)(false);

  switch (appliedTo.kind) {
    case kinds/* Kind.OPERATION_DEFINITION */.h.OPERATION_DEFINITION:
      return getDirectiveLocationForOperation(appliedTo.operation);

    case kinds/* Kind.FIELD */.h.FIELD:
      return directiveLocation/* DirectiveLocation.FIELD */.B.FIELD;

    case kinds/* Kind.FRAGMENT_SPREAD */.h.FRAGMENT_SPREAD:
      return directiveLocation/* DirectiveLocation.FRAGMENT_SPREAD */.B.FRAGMENT_SPREAD;

    case kinds/* Kind.INLINE_FRAGMENT */.h.INLINE_FRAGMENT:
      return directiveLocation/* DirectiveLocation.INLINE_FRAGMENT */.B.INLINE_FRAGMENT;

    case kinds/* Kind.FRAGMENT_DEFINITION */.h.FRAGMENT_DEFINITION:
      return directiveLocation/* DirectiveLocation.FRAGMENT_DEFINITION */.B.FRAGMENT_DEFINITION;

    case kinds/* Kind.VARIABLE_DEFINITION */.h.VARIABLE_DEFINITION:
      return directiveLocation/* DirectiveLocation.VARIABLE_DEFINITION */.B.VARIABLE_DEFINITION;

    case kinds/* Kind.SCHEMA_DEFINITION */.h.SCHEMA_DEFINITION:
    case kinds/* Kind.SCHEMA_EXTENSION */.h.SCHEMA_EXTENSION:
      return directiveLocation/* DirectiveLocation.SCHEMA */.B.SCHEMA;

    case kinds/* Kind.SCALAR_TYPE_DEFINITION */.h.SCALAR_TYPE_DEFINITION:
    case kinds/* Kind.SCALAR_TYPE_EXTENSION */.h.SCALAR_TYPE_EXTENSION:
      return directiveLocation/* DirectiveLocation.SCALAR */.B.SCALAR;

    case kinds/* Kind.OBJECT_TYPE_DEFINITION */.h.OBJECT_TYPE_DEFINITION:
    case kinds/* Kind.OBJECT_TYPE_EXTENSION */.h.OBJECT_TYPE_EXTENSION:
      return directiveLocation/* DirectiveLocation.OBJECT */.B.OBJECT;

    case kinds/* Kind.FIELD_DEFINITION */.h.FIELD_DEFINITION:
      return directiveLocation/* DirectiveLocation.FIELD_DEFINITION */.B.FIELD_DEFINITION;

    case kinds/* Kind.INTERFACE_TYPE_DEFINITION */.h.INTERFACE_TYPE_DEFINITION:
    case kinds/* Kind.INTERFACE_TYPE_EXTENSION */.h.INTERFACE_TYPE_EXTENSION:
      return directiveLocation/* DirectiveLocation.INTERFACE */.B.INTERFACE;

    case kinds/* Kind.UNION_TYPE_DEFINITION */.h.UNION_TYPE_DEFINITION:
    case kinds/* Kind.UNION_TYPE_EXTENSION */.h.UNION_TYPE_EXTENSION:
      return directiveLocation/* DirectiveLocation.UNION */.B.UNION;

    case kinds/* Kind.ENUM_TYPE_DEFINITION */.h.ENUM_TYPE_DEFINITION:
    case kinds/* Kind.ENUM_TYPE_EXTENSION */.h.ENUM_TYPE_EXTENSION:
      return directiveLocation/* DirectiveLocation.ENUM */.B.ENUM;

    case kinds/* Kind.ENUM_VALUE_DEFINITION */.h.ENUM_VALUE_DEFINITION:
      return directiveLocation/* DirectiveLocation.ENUM_VALUE */.B.ENUM_VALUE;

    case kinds/* Kind.INPUT_OBJECT_TYPE_DEFINITION */.h.INPUT_OBJECT_TYPE_DEFINITION:
    case kinds/* Kind.INPUT_OBJECT_TYPE_EXTENSION */.h.INPUT_OBJECT_TYPE_EXTENSION:
      return directiveLocation/* DirectiveLocation.INPUT_OBJECT */.B.INPUT_OBJECT;

    case kinds/* Kind.INPUT_VALUE_DEFINITION */.h.INPUT_VALUE_DEFINITION: {
      const parentNode = ancestors[ancestors.length - 3];
      'kind' in parentNode || (0,invariant/* invariant */.k)(false);
      return parentNode.kind === kinds/* Kind.INPUT_OBJECT_TYPE_DEFINITION */.h.INPUT_OBJECT_TYPE_DEFINITION
        ? directiveLocation/* DirectiveLocation.INPUT_FIELD_DEFINITION */.B.INPUT_FIELD_DEFINITION
        : directiveLocation/* DirectiveLocation.ARGUMENT_DEFINITION */.B.ARGUMENT_DEFINITION;
    }
    // Not reachable, all possible types have been considered.

    /* c8 ignore next */

    default:
       false || (0,invariant/* invariant */.k)(false, 'Unexpected kind: ' + (0,inspect/* inspect */.X)(appliedTo.kind));
  }
}

function getDirectiveLocationForOperation(operation) {
  switch (operation) {
    case ast/* OperationTypeNode.QUERY */.ku.QUERY:
      return directiveLocation/* DirectiveLocation.QUERY */.B.QUERY;

    case ast/* OperationTypeNode.MUTATION */.ku.MUTATION:
      return directiveLocation/* DirectiveLocation.MUTATION */.B.MUTATION;

    case ast/* OperationTypeNode.SUBSCRIPTION */.ku.SUBSCRIPTION:
      return directiveLocation/* DirectiveLocation.SUBSCRIPTION */.B.SUBSCRIPTION;
  }
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/KnownFragmentNamesRule.mjs


/**
 * Known fragment names
 *
 * A GraphQL document is only valid if all `...Fragment` fragment spreads refer
 * to fragments defined in the same document.
 *
 * See https://spec.graphql.org/draft/#sec-Fragment-spread-target-defined
 */
function KnownFragmentNamesRule(context) {
  return {
    FragmentSpread(node) {
      const fragmentName = node.name.value;
      const fragment = context.getFragment(fragmentName);

      if (!fragment) {
        context.reportError(
          new GraphQLError/* GraphQLError */.__(`Unknown fragment "${fragmentName}".`, {
            nodes: node.name,
          }),
        );
      }
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/KnownTypeNamesRule.mjs







/**
 * Known type names
 *
 * A GraphQL document is only valid if referenced types (specifically
 * variable definitions and fragment conditions) are defined by the type schema.
 *
 * See https://spec.graphql.org/draft/#sec-Fragment-Spread-Type-Existence
 */
function KnownTypeNamesRule(context) {
  const schema = context.getSchema();
  const existingTypesMap = schema ? schema.getTypeMap() : Object.create(null);
  const definedTypes = Object.create(null);

  for (const def of context.getDocument().definitions) {
    if (isTypeDefinitionNode(def)) {
      definedTypes[def.name.value] = true;
    }
  }

  const typeNames = [
    ...Object.keys(existingTypesMap),
    ...Object.keys(definedTypes),
  ];
  return {
    NamedType(node, _1, parent, _2, ancestors) {
      const typeName = node.name.value;

      if (!existingTypesMap[typeName] && !definedTypes[typeName]) {
        var _ancestors$;

        const definitionNode =
          (_ancestors$ = ancestors[2]) !== null && _ancestors$ !== void 0
            ? _ancestors$
            : parent;
        const isSDL = definitionNode != null && isSDLNode(definitionNode);

        if (isSDL && standardTypeNames.includes(typeName)) {
          return;
        }

        const suggestedTypes = suggestionList(
          typeName,
          isSDL ? standardTypeNames.concat(typeNames) : typeNames,
        );
        context.reportError(
          new GraphQLError/* GraphQLError */.__(
            `Unknown type "${typeName}".` + didYouMean(suggestedTypes),
            {
              nodes: node,
            },
          ),
        );
      }
    },
  };
}
const standardTypeNames = [...specifiedScalarTypes, ...introspectionTypes].map(
  (type) => type.name,
);

function isSDLNode(value) {
  return (
    'kind' in value &&
    (isTypeSystemDefinitionNode(value) || isTypeSystemExtensionNode(value))
  );
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/LoneAnonymousOperationRule.mjs



/**
 * Lone anonymous operation
 *
 * A GraphQL document is only valid if when it contains an anonymous operation
 * (the query short-hand) that it contains only that one operation definition.
 *
 * See https://spec.graphql.org/draft/#sec-Lone-Anonymous-Operation
 */
function LoneAnonymousOperationRule(context) {
  let operationCount = 0;
  return {
    Document(node) {
      operationCount = node.definitions.filter(
        (definition) => definition.kind === kinds/* Kind.OPERATION_DEFINITION */.h.OPERATION_DEFINITION,
      ).length;
    },

    OperationDefinition(node) {
      if (!node.name && operationCount > 1) {
        context.reportError(
          new GraphQLError/* GraphQLError */.__(
            'This anonymous operation must be the only defined operation.',
            {
              nodes: node,
            },
          ),
        );
      }
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/LoneSchemaDefinitionRule.mjs


/**
 * Lone Schema definition
 *
 * A GraphQL document is only valid if it contains only one schema definition.
 */
function LoneSchemaDefinitionRule(context) {
  var _ref, _ref2, _oldSchema$astNode;

  const oldSchema = context.getSchema();
  const alreadyDefined =
    (_ref =
      (_ref2 =
        (_oldSchema$astNode =
          oldSchema === null || oldSchema === void 0
            ? void 0
            : oldSchema.astNode) !== null && _oldSchema$astNode !== void 0
          ? _oldSchema$astNode
          : oldSchema === null || oldSchema === void 0
          ? void 0
          : oldSchema.getQueryType()) !== null && _ref2 !== void 0
        ? _ref2
        : oldSchema === null || oldSchema === void 0
        ? void 0
        : oldSchema.getMutationType()) !== null && _ref !== void 0
      ? _ref
      : oldSchema === null || oldSchema === void 0
      ? void 0
      : oldSchema.getSubscriptionType();
  let schemaDefinitionsCount = 0;
  return {
    SchemaDefinition(node) {
      if (alreadyDefined) {
        context.reportError(
          new GraphQLError/* GraphQLError */.__(
            'Cannot define a new schema within a schema extension.',
            {
              nodes: node,
            },
          ),
        );
        return;
      }

      if (schemaDefinitionsCount > 0) {
        context.reportError(
          new GraphQLError/* GraphQLError */.__('Must provide only one schema definition.', {
            nodes: node,
          }),
        );
      }

      ++schemaDefinitionsCount;
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/MaxIntrospectionDepthRule.mjs


const MAX_LISTS_DEPTH = 3;
function MaxIntrospectionDepthRule(context) {
  /**
   * Counts the depth of list fields in "__Type" recursively and
   * returns `true` if the limit has been reached.
   */
  function checkDepth(node, visitedFragments = Object.create(null), depth = 0) {
    if (node.kind === kinds/* Kind.FRAGMENT_SPREAD */.h.FRAGMENT_SPREAD) {
      const fragmentName = node.name.value;

      if (visitedFragments[fragmentName] === true) {
        // Fragment cycles are handled by `NoFragmentCyclesRule`.
        return false;
      }

      const fragment = context.getFragment(fragmentName);

      if (!fragment) {
        // Missing fragments checks are handled by `KnownFragmentNamesRule`.
        return false;
      } // Rather than following an immutable programming pattern which has
      // significant memory and garbage collection overhead, we've opted to
      // take a mutable approach for efficiency's sake. Importantly visiting a
      // fragment twice is fine, so long as you don't do one visit inside the
      // other.

      try {
        visitedFragments[fragmentName] = true;
        return checkDepth(fragment, visitedFragments, depth);
      } finally {
        visitedFragments[fragmentName] = undefined;
      }
    }

    if (
      node.kind === kinds/* Kind.FIELD */.h.FIELD && // check all introspection lists
      (node.name.value === 'fields' ||
        node.name.value === 'interfaces' ||
        node.name.value === 'possibleTypes' ||
        node.name.value === 'inputFields')
    ) {
      // eslint-disable-next-line no-param-reassign
      depth++;

      if (depth >= MAX_LISTS_DEPTH) {
        return true;
      }
    } // handles fields and inline fragments

    if ('selectionSet' in node && node.selectionSet) {
      for (const child of node.selectionSet.selections) {
        if (checkDepth(child, visitedFragments, depth)) {
          return true;
        }
      }
    }

    return false;
  }

  return {
    Field(node) {
      if (node.name.value === '__schema' || node.name.value === '__type') {
        if (checkDepth(node)) {
          context.reportError(
            new GraphQLError/* GraphQLError */.__('Maximum introspection depth exceeded', {
              nodes: [node],
            }),
          );
          return false;
        }
      }
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/NoFragmentCyclesRule.mjs


/**
 * No fragment cycles
 *
 * The graph of fragment spreads must not form any cycles including spreading itself.
 * Otherwise an operation could infinitely spread or infinitely execute on cycles in the underlying data.
 *
 * See https://spec.graphql.org/draft/#sec-Fragment-spreads-must-not-form-cycles
 */
function NoFragmentCyclesRule(context) {
  // Tracks already visited fragments to maintain O(N) and to ensure that cycles
  // are not redundantly reported.
  const visitedFrags = Object.create(null); // Array of AST nodes used to produce meaningful errors

  const spreadPath = []; // Position in the spread path

  const spreadPathIndexByName = Object.create(null);
  return {
    OperationDefinition: () => false,

    FragmentDefinition(node) {
      detectCycleRecursive(node);
      return false;
    },
  }; // This does a straight-forward DFS to find cycles.
  // It does not terminate when a cycle was found but continues to explore
  // the graph to find all possible cycles.

  function detectCycleRecursive(fragment) {
    if (visitedFrags[fragment.name.value]) {
      return;
    }

    const fragmentName = fragment.name.value;
    visitedFrags[fragmentName] = true;
    const spreadNodes = context.getFragmentSpreads(fragment.selectionSet);

    if (spreadNodes.length === 0) {
      return;
    }

    spreadPathIndexByName[fragmentName] = spreadPath.length;

    for (const spreadNode of spreadNodes) {
      const spreadName = spreadNode.name.value;
      const cycleIndex = spreadPathIndexByName[spreadName];
      spreadPath.push(spreadNode);

      if (cycleIndex === undefined) {
        const spreadFragment = context.getFragment(spreadName);

        if (spreadFragment) {
          detectCycleRecursive(spreadFragment);
        }
      } else {
        const cyclePath = spreadPath.slice(cycleIndex);
        const viaPath = cyclePath
          .slice(0, -1)
          .map((s) => '"' + s.name.value + '"')
          .join(', ');
        context.reportError(
          new GraphQLError/* GraphQLError */.__(
            `Cannot spread fragment "${spreadName}" within itself` +
              (viaPath !== '' ? ` via ${viaPath}.` : '.'),
            {
              nodes: cyclePath,
            },
          ),
        );
      }

      spreadPath.pop();
    }

    spreadPathIndexByName[fragmentName] = undefined;
  }
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/NoUndefinedVariablesRule.mjs


/**
 * No undefined variables
 *
 * A GraphQL operation is only valid if all variables encountered, both directly
 * and via fragment spreads, are defined by that operation.
 *
 * See https://spec.graphql.org/draft/#sec-All-Variable-Uses-Defined
 */
function NoUndefinedVariablesRule(context) {
  let variableNameDefined = Object.create(null);
  return {
    OperationDefinition: {
      enter() {
        variableNameDefined = Object.create(null);
      },

      leave(operation) {
        const usages = context.getRecursiveVariableUsages(operation);

        for (const { node } of usages) {
          const varName = node.name.value;

          if (variableNameDefined[varName] !== true) {
            context.reportError(
              new GraphQLError/* GraphQLError */.__(
                operation.name
                  ? `Variable "$${varName}" is not defined by operation "${operation.name.value}".`
                  : `Variable "$${varName}" is not defined.`,
                {
                  nodes: [node, operation],
                },
              ),
            );
          }
        }
      },
    },

    VariableDefinition(node) {
      variableNameDefined[node.variable.name.value] = true;
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/NoUnusedFragmentsRule.mjs


/**
 * No unused fragments
 *
 * A GraphQL document is only valid if all fragment definitions are spread
 * within operations, or spread within other fragments spread within operations.
 *
 * See https://spec.graphql.org/draft/#sec-Fragments-Must-Be-Used
 */
function NoUnusedFragmentsRule(context) {
  const operationDefs = [];
  const fragmentDefs = [];
  return {
    OperationDefinition(node) {
      operationDefs.push(node);
      return false;
    },

    FragmentDefinition(node) {
      fragmentDefs.push(node);
      return false;
    },

    Document: {
      leave() {
        const fragmentNameUsed = Object.create(null);

        for (const operation of operationDefs) {
          for (const fragment of context.getRecursivelyReferencedFragments(
            operation,
          )) {
            fragmentNameUsed[fragment.name.value] = true;
          }
        }

        for (const fragmentDef of fragmentDefs) {
          const fragName = fragmentDef.name.value;

          if (fragmentNameUsed[fragName] !== true) {
            context.reportError(
              new GraphQLError/* GraphQLError */.__(`Fragment "${fragName}" is never used.`, {
                nodes: fragmentDef,
              }),
            );
          }
        }
      },
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/NoUnusedVariablesRule.mjs


/**
 * No unused variables
 *
 * A GraphQL operation is only valid if all variables defined by an operation
 * are used, either directly or within a spread fragment.
 *
 * See https://spec.graphql.org/draft/#sec-All-Variables-Used
 */
function NoUnusedVariablesRule(context) {
  let variableDefs = [];
  return {
    OperationDefinition: {
      enter() {
        variableDefs = [];
      },

      leave(operation) {
        const variableNameUsed = Object.create(null);
        const usages = context.getRecursiveVariableUsages(operation);

        for (const { node } of usages) {
          variableNameUsed[node.name.value] = true;
        }

        for (const variableDef of variableDefs) {
          const variableName = variableDef.variable.name.value;

          if (variableNameUsed[variableName] !== true) {
            context.reportError(
              new GraphQLError/* GraphQLError */.__(
                operation.name
                  ? `Variable "$${variableName}" is never used in operation "${operation.name.value}".`
                  : `Variable "$${variableName}" is never used.`,
                {
                  nodes: variableDef,
                },
              ),
            );
          }
        }
      },
    },

    VariableDefinition(def) {
      variableDefs.push(def);
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/sortValueNode.mjs


/**
 * Sort ValueNode.
 *
 * This function returns a sorted copy of the given ValueNode.
 *
 * @internal
 */

function sortValueNode(valueNode) {
  switch (valueNode.kind) {
    case kinds/* Kind.OBJECT */.h.OBJECT:
      return { ...valueNode, fields: sortFields(valueNode.fields) };

    case kinds/* Kind.LIST */.h.LIST:
      return { ...valueNode, values: valueNode.values.map(sortValueNode) };

    case kinds/* Kind.INT */.h.INT:
    case kinds/* Kind.FLOAT */.h.FLOAT:
    case kinds/* Kind.STRING */.h.STRING:
    case kinds/* Kind.BOOLEAN */.h.BOOLEAN:
    case kinds/* Kind.NULL */.h.NULL:
    case kinds/* Kind.ENUM */.h.ENUM:
    case kinds/* Kind.VARIABLE */.h.VARIABLE:
      return valueNode;
  }
}

function sortFields(fields) {
  return fields
    .map((fieldNode) => ({
      ...fieldNode,
      value: sortValueNode(fieldNode.value),
    }))
    .sort((fieldA, fieldB) =>
      naturalCompare(fieldA.name.value, fieldB.name.value),
    );
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/OverlappingFieldsCanBeMergedRule.mjs








function reasonMessage(reason) {
  if (Array.isArray(reason)) {
    return reason
      .map(
        ([responseName, subReason]) =>
          `subfields "${responseName}" conflict because ` +
          reasonMessage(subReason),
      )
      .join(' and ');
  }

  return reason;
}
/**
 * Overlapping fields can be merged
 *
 * A selection set is only valid if all fields (including spreading any
 * fragments) either correspond to distinct response names or can be merged
 * without ambiguity.
 *
 * See https://spec.graphql.org/draft/#sec-Field-Selection-Merging
 */

function OverlappingFieldsCanBeMergedRule(context) {
  // A memoization for when two fragments are compared "between" each other for
  // conflicts. Two fragments may be compared many times, so memoizing this can
  // dramatically improve the performance of this validator.
  const comparedFragmentPairs = new PairSet(); // A cache for the "field map" and list of fragment names found in any given
  // selection set. Selection sets may be asked for this information multiple
  // times, so this improves the performance of this validator.

  const cachedFieldsAndFragmentNames = new Map();
  return {
    SelectionSet(selectionSet) {
      const conflicts = findConflictsWithinSelectionSet(
        context,
        cachedFieldsAndFragmentNames,
        comparedFragmentPairs,
        context.getParentType(),
        selectionSet,
      );

      for (const [[responseName, reason], fields1, fields2] of conflicts) {
        const reasonMsg = reasonMessage(reason);
        context.reportError(
          new GraphQLError/* GraphQLError */.__(
            `Fields "${responseName}" conflict because ${reasonMsg}. Use different aliases on the fields to fetch both if this was intentional.`,
            {
              nodes: fields1.concat(fields2),
            },
          ),
        );
      }
    },
  };
}

/**
 * Algorithm:
 *
 * Conflicts occur when two fields exist in a query which will produce the same
 * response name, but represent differing values, thus creating a conflict.
 * The algorithm below finds all conflicts via making a series of comparisons
 * between fields. In order to compare as few fields as possible, this makes
 * a series of comparisons "within" sets of fields and "between" sets of fields.
 *
 * Given any selection set, a collection produces both a set of fields by
 * also including all inline fragments, as well as a list of fragments
 * referenced by fragment spreads.
 *
 * A) Each selection set represented in the document first compares "within" its
 * collected set of fields, finding any conflicts between every pair of
 * overlapping fields.
 * Note: This is the *only time* that a the fields "within" a set are compared
 * to each other. After this only fields "between" sets are compared.
 *
 * B) Also, if any fragment is referenced in a selection set, then a
 * comparison is made "between" the original set of fields and the
 * referenced fragment.
 *
 * C) Also, if multiple fragments are referenced, then comparisons
 * are made "between" each referenced fragment.
 *
 * D) When comparing "between" a set of fields and a referenced fragment, first
 * a comparison is made between each field in the original set of fields and
 * each field in the the referenced set of fields.
 *
 * E) Also, if any fragment is referenced in the referenced selection set,
 * then a comparison is made "between" the original set of fields and the
 * referenced fragment (recursively referring to step D).
 *
 * F) When comparing "between" two fragments, first a comparison is made between
 * each field in the first referenced set of fields and each field in the the
 * second referenced set of fields.
 *
 * G) Also, any fragments referenced by the first must be compared to the
 * second, and any fragments referenced by the second must be compared to the
 * first (recursively referring to step F).
 *
 * H) When comparing two fields, if both have selection sets, then a comparison
 * is made "between" both selection sets, first comparing the set of fields in
 * the first selection set with the set of fields in the second.
 *
 * I) Also, if any fragment is referenced in either selection set, then a
 * comparison is made "between" the other set of fields and the
 * referenced fragment.
 *
 * J) Also, if two fragments are referenced in both selection sets, then a
 * comparison is made "between" the two fragments.
 *
 */
// Find all conflicts found "within" a selection set, including those found
// via spreading in fragments. Called when visiting each SelectionSet in the
// GraphQL Document.
function findConflictsWithinSelectionSet(
  context,
  cachedFieldsAndFragmentNames,
  comparedFragmentPairs,
  parentType,
  selectionSet,
) {
  const conflicts = [];
  const [fieldMap, fragmentNames] = getFieldsAndFragmentNames(
    context,
    cachedFieldsAndFragmentNames,
    parentType,
    selectionSet,
  ); // (A) Find find all conflicts "within" the fields of this selection set.
  // Note: this is the *only place* `collectConflictsWithin` is called.

  collectConflictsWithin(
    context,
    conflicts,
    cachedFieldsAndFragmentNames,
    comparedFragmentPairs,
    fieldMap,
  );

  if (fragmentNames.length !== 0) {
    // (B) Then collect conflicts between these fields and those represented by
    // each spread fragment name found.
    for (let i = 0; i < fragmentNames.length; i++) {
      collectConflictsBetweenFieldsAndFragment(
        context,
        conflicts,
        cachedFieldsAndFragmentNames,
        comparedFragmentPairs,
        false,
        fieldMap,
        fragmentNames[i],
      ); // (C) Then compare this fragment with all other fragments found in this
      // selection set to collect conflicts between fragments spread together.
      // This compares each item in the list of fragment names to every other
      // item in that same list (except for itself).

      for (let j = i + 1; j < fragmentNames.length; j++) {
        collectConflictsBetweenFragments(
          context,
          conflicts,
          cachedFieldsAndFragmentNames,
          comparedFragmentPairs,
          false,
          fragmentNames[i],
          fragmentNames[j],
        );
      }
    }
  }

  return conflicts;
} // Collect all conflicts found between a set of fields and a fragment reference
// including via spreading in any nested fragments.

function collectConflictsBetweenFieldsAndFragment(
  context,
  conflicts,
  cachedFieldsAndFragmentNames,
  comparedFragmentPairs,
  areMutuallyExclusive,
  fieldMap,
  fragmentName,
) {
  const fragment = context.getFragment(fragmentName);

  if (!fragment) {
    return;
  }

  const [fieldMap2, referencedFragmentNames] =
    getReferencedFieldsAndFragmentNames(
      context,
      cachedFieldsAndFragmentNames,
      fragment,
    ); // Do not compare a fragment's fieldMap to itself.

  if (fieldMap === fieldMap2) {
    return;
  } // (D) First collect any conflicts between the provided collection of fields
  // and the collection of fields represented by the given fragment.

  collectConflictsBetween(
    context,
    conflicts,
    cachedFieldsAndFragmentNames,
    comparedFragmentPairs,
    areMutuallyExclusive,
    fieldMap,
    fieldMap2,
  ); // (E) Then collect any conflicts between the provided collection of fields
  // and any fragment names found in the given fragment.

  for (const referencedFragmentName of referencedFragmentNames) {
    // Memoize so two fragments are not compared for conflicts more than once.
    if (
      comparedFragmentPairs.has(
        referencedFragmentName,
        fragmentName,
        areMutuallyExclusive,
      )
    ) {
      continue;
    }

    comparedFragmentPairs.add(
      referencedFragmentName,
      fragmentName,
      areMutuallyExclusive,
    );
    collectConflictsBetweenFieldsAndFragment(
      context,
      conflicts,
      cachedFieldsAndFragmentNames,
      comparedFragmentPairs,
      areMutuallyExclusive,
      fieldMap,
      referencedFragmentName,
    );
  }
} // Collect all conflicts found between two fragments, including via spreading in
// any nested fragments.

function collectConflictsBetweenFragments(
  context,
  conflicts,
  cachedFieldsAndFragmentNames,
  comparedFragmentPairs,
  areMutuallyExclusive,
  fragmentName1,
  fragmentName2,
) {
  // No need to compare a fragment to itself.
  if (fragmentName1 === fragmentName2) {
    return;
  } // Memoize so two fragments are not compared for conflicts more than once.

  if (
    comparedFragmentPairs.has(
      fragmentName1,
      fragmentName2,
      areMutuallyExclusive,
    )
  ) {
    return;
  }

  comparedFragmentPairs.add(fragmentName1, fragmentName2, areMutuallyExclusive);
  const fragment1 = context.getFragment(fragmentName1);
  const fragment2 = context.getFragment(fragmentName2);

  if (!fragment1 || !fragment2) {
    return;
  }

  const [fieldMap1, referencedFragmentNames1] =
    getReferencedFieldsAndFragmentNames(
      context,
      cachedFieldsAndFragmentNames,
      fragment1,
    );
  const [fieldMap2, referencedFragmentNames2] =
    getReferencedFieldsAndFragmentNames(
      context,
      cachedFieldsAndFragmentNames,
      fragment2,
    ); // (F) First, collect all conflicts between these two collections of fields
  // (not including any nested fragments).

  collectConflictsBetween(
    context,
    conflicts,
    cachedFieldsAndFragmentNames,
    comparedFragmentPairs,
    areMutuallyExclusive,
    fieldMap1,
    fieldMap2,
  ); // (G) Then collect conflicts between the first fragment and any nested
  // fragments spread in the second fragment.

  for (const referencedFragmentName2 of referencedFragmentNames2) {
    collectConflictsBetweenFragments(
      context,
      conflicts,
      cachedFieldsAndFragmentNames,
      comparedFragmentPairs,
      areMutuallyExclusive,
      fragmentName1,
      referencedFragmentName2,
    );
  } // (G) Then collect conflicts between the second fragment and any nested
  // fragments spread in the first fragment.

  for (const referencedFragmentName1 of referencedFragmentNames1) {
    collectConflictsBetweenFragments(
      context,
      conflicts,
      cachedFieldsAndFragmentNames,
      comparedFragmentPairs,
      areMutuallyExclusive,
      referencedFragmentName1,
      fragmentName2,
    );
  }
} // Find all conflicts found between two selection sets, including those found
// via spreading in fragments. Called when determining if conflicts exist
// between the sub-fields of two overlapping fields.

function findConflictsBetweenSubSelectionSets(
  context,
  cachedFieldsAndFragmentNames,
  comparedFragmentPairs,
  areMutuallyExclusive,
  parentType1,
  selectionSet1,
  parentType2,
  selectionSet2,
) {
  const conflicts = [];
  const [fieldMap1, fragmentNames1] = getFieldsAndFragmentNames(
    context,
    cachedFieldsAndFragmentNames,
    parentType1,
    selectionSet1,
  );
  const [fieldMap2, fragmentNames2] = getFieldsAndFragmentNames(
    context,
    cachedFieldsAndFragmentNames,
    parentType2,
    selectionSet2,
  ); // (H) First, collect all conflicts between these two collections of field.

  collectConflictsBetween(
    context,
    conflicts,
    cachedFieldsAndFragmentNames,
    comparedFragmentPairs,
    areMutuallyExclusive,
    fieldMap1,
    fieldMap2,
  ); // (I) Then collect conflicts between the first collection of fields and
  // those referenced by each fragment name associated with the second.

  for (const fragmentName2 of fragmentNames2) {
    collectConflictsBetweenFieldsAndFragment(
      context,
      conflicts,
      cachedFieldsAndFragmentNames,
      comparedFragmentPairs,
      areMutuallyExclusive,
      fieldMap1,
      fragmentName2,
    );
  } // (I) Then collect conflicts between the second collection of fields and
  // those referenced by each fragment name associated with the first.

  for (const fragmentName1 of fragmentNames1) {
    collectConflictsBetweenFieldsAndFragment(
      context,
      conflicts,
      cachedFieldsAndFragmentNames,
      comparedFragmentPairs,
      areMutuallyExclusive,
      fieldMap2,
      fragmentName1,
    );
  } // (J) Also collect conflicts between any fragment names by the first and
  // fragment names by the second. This compares each item in the first set of
  // names to each item in the second set of names.

  for (const fragmentName1 of fragmentNames1) {
    for (const fragmentName2 of fragmentNames2) {
      collectConflictsBetweenFragments(
        context,
        conflicts,
        cachedFieldsAndFragmentNames,
        comparedFragmentPairs,
        areMutuallyExclusive,
        fragmentName1,
        fragmentName2,
      );
    }
  }

  return conflicts;
} // Collect all Conflicts "within" one collection of fields.

function collectConflictsWithin(
  context,
  conflicts,
  cachedFieldsAndFragmentNames,
  comparedFragmentPairs,
  fieldMap,
) {
  // A field map is a keyed collection, where each key represents a response
  // name and the value at that key is a list of all fields which provide that
  // response name. For every response name, if there are multiple fields, they
  // must be compared to find a potential conflict.
  for (const [responseName, fields] of Object.entries(fieldMap)) {
    // This compares every field in the list to every other field in this list
    // (except to itself). If the list only has one item, nothing needs to
    // be compared.
    if (fields.length > 1) {
      for (let i = 0; i < fields.length; i++) {
        for (let j = i + 1; j < fields.length; j++) {
          const conflict = findConflict(
            context,
            cachedFieldsAndFragmentNames,
            comparedFragmentPairs,
            false, // within one collection is never mutually exclusive
            responseName,
            fields[i],
            fields[j],
          );

          if (conflict) {
            conflicts.push(conflict);
          }
        }
      }
    }
  }
} // Collect all Conflicts between two collections of fields. This is similar to,
// but different from the `collectConflictsWithin` function above. This check
// assumes that `collectConflictsWithin` has already been called on each
// provided collection of fields. This is true because this validator traverses
// each individual selection set.

function collectConflictsBetween(
  context,
  conflicts,
  cachedFieldsAndFragmentNames,
  comparedFragmentPairs,
  parentFieldsAreMutuallyExclusive,
  fieldMap1,
  fieldMap2,
) {
  // A field map is a keyed collection, where each key represents a response
  // name and the value at that key is a list of all fields which provide that
  // response name. For any response name which appears in both provided field
  // maps, each field from the first field map must be compared to every field
  // in the second field map to find potential conflicts.
  for (const [responseName, fields1] of Object.entries(fieldMap1)) {
    const fields2 = fieldMap2[responseName];

    if (fields2) {
      for (const field1 of fields1) {
        for (const field2 of fields2) {
          const conflict = findConflict(
            context,
            cachedFieldsAndFragmentNames,
            comparedFragmentPairs,
            parentFieldsAreMutuallyExclusive,
            responseName,
            field1,
            field2,
          );

          if (conflict) {
            conflicts.push(conflict);
          }
        }
      }
    }
  }
} // Determines if there is a conflict between two particular fields, including
// comparing their sub-fields.

function findConflict(
  context,
  cachedFieldsAndFragmentNames,
  comparedFragmentPairs,
  parentFieldsAreMutuallyExclusive,
  responseName,
  field1,
  field2,
) {
  const [parentType1, node1, def1] = field1;
  const [parentType2, node2, def2] = field2; // If it is known that two fields could not possibly apply at the same
  // time, due to the parent types, then it is safe to permit them to diverge
  // in aliased field or arguments used as they will not present any ambiguity
  // by differing.
  // It is known that two parent types could never overlap if they are
  // different Object types. Interface or Union types might overlap - if not
  // in the current state of the schema, then perhaps in some future version,
  // thus may not safely diverge.

  const areMutuallyExclusive =
    parentFieldsAreMutuallyExclusive ||
    (parentType1 !== parentType2 &&
      isObjectType(parentType1) &&
      isObjectType(parentType2));

  if (!areMutuallyExclusive) {
    // Two aliases must refer to the same field.
    const name1 = node1.name.value;
    const name2 = node2.name.value;

    if (name1 !== name2) {
      return [
        [responseName, `"${name1}" and "${name2}" are different fields`],
        [node1],
        [node2],
      ];
    } // Two field calls must have the same arguments.

    if (!sameArguments(node1, node2)) {
      return [
        [responseName, 'they have differing arguments'],
        [node1],
        [node2],
      ];
    }
  } // The return type for each field.

  const type1 = def1 === null || def1 === void 0 ? void 0 : def1.type;
  const type2 = def2 === null || def2 === void 0 ? void 0 : def2.type;

  if (type1 && type2 && doTypesConflict(type1, type2)) {
    return [
      [
        responseName,
        `they return conflicting types "${(0,inspect/* inspect */.X)(type1)}" and "${(0,inspect/* inspect */.X)(
          type2,
        )}"`,
      ],
      [node1],
      [node2],
    ];
  } // Collect and compare sub-fields. Use the same "visited fragment names" list
  // for both collections so fields in a fragment reference are never
  // compared to themselves.

  const selectionSet1 = node1.selectionSet;
  const selectionSet2 = node2.selectionSet;

  if (selectionSet1 && selectionSet2) {
    const conflicts = findConflictsBetweenSubSelectionSets(
      context,
      cachedFieldsAndFragmentNames,
      comparedFragmentPairs,
      areMutuallyExclusive,
      getNamedType(type1),
      selectionSet1,
      getNamedType(type2),
      selectionSet2,
    );
    return subfieldConflicts(conflicts, responseName, node1, node2);
  }
}

function sameArguments(node1, node2) {
  const args1 = node1.arguments;
  const args2 = node2.arguments;

  if (args1 === undefined || args1.length === 0) {
    return args2 === undefined || args2.length === 0;
  }

  if (args2 === undefined || args2.length === 0) {
    return false;
  }
  /* c8 ignore next */

  if (args1.length !== args2.length) {
    /* c8 ignore next */
    return false;
    /* c8 ignore next */
  }

  const values2 = new Map(args2.map(({ name, value }) => [name.value, value]));
  return args1.every((arg1) => {
    const value1 = arg1.value;
    const value2 = values2.get(arg1.name.value);

    if (value2 === undefined) {
      return false;
    }

    return stringifyValue(value1) === stringifyValue(value2);
  });
}

function stringifyValue(value) {
  return print(sortValueNode(value));
} // Two types conflict if both types could not apply to a value simultaneously.
// Composite types are ignored as their individual field types will be compared
// later recursively. However List and Non-Null types must match.

function doTypesConflict(type1, type2) {
  if (isListType(type1)) {
    return isListType(type2)
      ? doTypesConflict(type1.ofType, type2.ofType)
      : true;
  }

  if (isListType(type2)) {
    return true;
  }

  if (isNonNullType(type1)) {
    return isNonNullType(type2)
      ? doTypesConflict(type1.ofType, type2.ofType)
      : true;
  }

  if (isNonNullType(type2)) {
    return true;
  }

  if (isLeafType(type1) || isLeafType(type2)) {
    return type1 !== type2;
  }

  return false;
} // Given a selection set, return the collection of fields (a mapping of response
// name to field nodes and definitions) as well as a list of fragment names
// referenced via fragment spreads.

function getFieldsAndFragmentNames(
  context,
  cachedFieldsAndFragmentNames,
  parentType,
  selectionSet,
) {
  const cached = cachedFieldsAndFragmentNames.get(selectionSet);

  if (cached) {
    return cached;
  }

  const nodeAndDefs = Object.create(null);
  const fragmentNames = Object.create(null);

  _collectFieldsAndFragmentNames(
    context,
    parentType,
    selectionSet,
    nodeAndDefs,
    fragmentNames,
  );

  const result = [nodeAndDefs, Object.keys(fragmentNames)];
  cachedFieldsAndFragmentNames.set(selectionSet, result);
  return result;
} // Given a reference to a fragment, return the represented collection of fields
// as well as a list of nested fragment names referenced via fragment spreads.

function getReferencedFieldsAndFragmentNames(
  context,
  cachedFieldsAndFragmentNames,
  fragment,
) {
  // Short-circuit building a type from the node if possible.
  const cached = cachedFieldsAndFragmentNames.get(fragment.selectionSet);

  if (cached) {
    return cached;
  }

  const fragmentType = typeFromAST(context.getSchema(), fragment.typeCondition);
  return getFieldsAndFragmentNames(
    context,
    cachedFieldsAndFragmentNames,
    fragmentType,
    fragment.selectionSet,
  );
}

function _collectFieldsAndFragmentNames(
  context,
  parentType,
  selectionSet,
  nodeAndDefs,
  fragmentNames,
) {
  for (const selection of selectionSet.selections) {
    switch (selection.kind) {
      case kinds/* Kind.FIELD */.h.FIELD: {
        const fieldName = selection.name.value;
        let fieldDef;

        if (isObjectType(parentType) || isInterfaceType(parentType)) {
          fieldDef = parentType.getFields()[fieldName];
        }

        const responseName = selection.alias
          ? selection.alias.value
          : fieldName;

        if (!nodeAndDefs[responseName]) {
          nodeAndDefs[responseName] = [];
        }

        nodeAndDefs[responseName].push([parentType, selection, fieldDef]);
        break;
      }

      case kinds/* Kind.FRAGMENT_SPREAD */.h.FRAGMENT_SPREAD:
        fragmentNames[selection.name.value] = true;
        break;

      case kinds/* Kind.INLINE_FRAGMENT */.h.INLINE_FRAGMENT: {
        const typeCondition = selection.typeCondition;
        const inlineFragmentType = typeCondition
          ? typeFromAST(context.getSchema(), typeCondition)
          : parentType;

        _collectFieldsAndFragmentNames(
          context,
          inlineFragmentType,
          selection.selectionSet,
          nodeAndDefs,
          fragmentNames,
        );

        break;
      }
    }
  }
} // Given a series of Conflicts which occurred between two sub-fields, generate
// a single Conflict.

function subfieldConflicts(conflicts, responseName, node1, node2) {
  if (conflicts.length > 0) {
    return [
      [responseName, conflicts.map(([reason]) => reason)],
      [node1, ...conflicts.map(([, fields1]) => fields1).flat()],
      [node2, ...conflicts.map(([, , fields2]) => fields2).flat()],
    ];
  }
}
/**
 * A way to keep track of pairs of things when the ordering of the pair does not matter.
 */

class PairSet {
  constructor() {
    this._data = new Map();
  }

  has(a, b, areMutuallyExclusive) {
    var _this$_data$get;

    const [key1, key2] = a < b ? [a, b] : [b, a];
    const result =
      (_this$_data$get = this._data.get(key1)) === null ||
      _this$_data$get === void 0
        ? void 0
        : _this$_data$get.get(key2);

    if (result === undefined) {
      return false;
    } // areMutuallyExclusive being false is a superset of being true, hence if
    // we want to know if this PairSet "has" these two with no exclusivity,
    // we have to ensure it was added as such.

    return areMutuallyExclusive ? true : areMutuallyExclusive === result;
  }

  add(a, b, areMutuallyExclusive) {
    const [key1, key2] = a < b ? [a, b] : [b, a];

    const map = this._data.get(key1);

    if (map === undefined) {
      this._data.set(key1, new Map([[key2, areMutuallyExclusive]]));
    } else {
      map.set(key2, areMutuallyExclusive);
    }
  }
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/PossibleFragmentSpreadsRule.mjs






/**
 * Possible fragment spread
 *
 * A fragment spread is only valid if the type condition could ever possibly
 * be true: if there is a non-empty intersection of the possible parent types,
 * and possible types which pass the type condition.
 */
function PossibleFragmentSpreadsRule(context) {
  return {
    InlineFragment(node) {
      const fragType = context.getType();
      const parentType = context.getParentType();

      if (
        isCompositeType(fragType) &&
        isCompositeType(parentType) &&
        !doTypesOverlap(context.getSchema(), fragType, parentType)
      ) {
        const parentTypeStr = (0,inspect/* inspect */.X)(parentType);
        const fragTypeStr = (0,inspect/* inspect */.X)(fragType);
        context.reportError(
          new GraphQLError/* GraphQLError */.__(
            `Fragment cannot be spread here as objects of type "${parentTypeStr}" can never be of type "${fragTypeStr}".`,
            {
              nodes: node,
            },
          ),
        );
      }
    },

    FragmentSpread(node) {
      const fragName = node.name.value;
      const fragType = getFragmentType(context, fragName);
      const parentType = context.getParentType();

      if (
        fragType &&
        parentType &&
        !doTypesOverlap(context.getSchema(), fragType, parentType)
      ) {
        const parentTypeStr = (0,inspect/* inspect */.X)(parentType);
        const fragTypeStr = (0,inspect/* inspect */.X)(fragType);
        context.reportError(
          new GraphQLError/* GraphQLError */.__(
            `Fragment "${fragName}" cannot be spread here as objects of type "${parentTypeStr}" can never be of type "${fragTypeStr}".`,
            {
              nodes: node,
            },
          ),
        );
      }
    },
  };
}

function getFragmentType(context, name) {
  const frag = context.getFragment(name);

  if (frag) {
    const type = typeFromAST(context.getSchema(), frag.typeCondition);

    if (isCompositeType(type)) {
      return type;
    }
  }
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/PossibleTypeExtensionsRule.mjs









/**
 * Possible type extension
 *
 * A type extension is only valid if the type is defined and has the same kind.
 */
function PossibleTypeExtensionsRule(context) {
  const schema = context.getSchema();
  const definedTypes = Object.create(null);

  for (const def of context.getDocument().definitions) {
    if (isTypeDefinitionNode(def)) {
      definedTypes[def.name.value] = def;
    }
  }

  return {
    ScalarTypeExtension: checkExtension,
    ObjectTypeExtension: checkExtension,
    InterfaceTypeExtension: checkExtension,
    UnionTypeExtension: checkExtension,
    EnumTypeExtension: checkExtension,
    InputObjectTypeExtension: checkExtension,
  };

  function checkExtension(node) {
    const typeName = node.name.value;
    const defNode = definedTypes[typeName];
    const existingType =
      schema === null || schema === void 0 ? void 0 : schema.getType(typeName);
    let expectedKind;

    if (defNode) {
      expectedKind = defKindToExtKind[defNode.kind];
    } else if (existingType) {
      expectedKind = typeToExtKind(existingType);
    }

    if (expectedKind) {
      if (expectedKind !== node.kind) {
        const kindStr = extensionKindToTypeName(node.kind);
        context.reportError(
          new GraphQLError/* GraphQLError */.__(`Cannot extend non-${kindStr} type "${typeName}".`, {
            nodes: defNode ? [defNode, node] : node,
          }),
        );
      }
    } else {
      const allTypeNames = Object.keys({
        ...definedTypes,
        ...(schema === null || schema === void 0
          ? void 0
          : schema.getTypeMap()),
      });
      const suggestedTypes = suggestionList(typeName, allTypeNames);
      context.reportError(
        new GraphQLError/* GraphQLError */.__(
          `Cannot extend type "${typeName}" because it is not defined.` +
            didYouMean(suggestedTypes),
          {
            nodes: node.name,
          },
        ),
      );
    }
  }
}
const defKindToExtKind = {
  [kinds/* Kind.SCALAR_TYPE_DEFINITION */.h.SCALAR_TYPE_DEFINITION]: kinds/* Kind.SCALAR_TYPE_EXTENSION */.h.SCALAR_TYPE_EXTENSION,
  [kinds/* Kind.OBJECT_TYPE_DEFINITION */.h.OBJECT_TYPE_DEFINITION]: kinds/* Kind.OBJECT_TYPE_EXTENSION */.h.OBJECT_TYPE_EXTENSION,
  [kinds/* Kind.INTERFACE_TYPE_DEFINITION */.h.INTERFACE_TYPE_DEFINITION]: kinds/* Kind.INTERFACE_TYPE_EXTENSION */.h.INTERFACE_TYPE_EXTENSION,
  [kinds/* Kind.UNION_TYPE_DEFINITION */.h.UNION_TYPE_DEFINITION]: kinds/* Kind.UNION_TYPE_EXTENSION */.h.UNION_TYPE_EXTENSION,
  [kinds/* Kind.ENUM_TYPE_DEFINITION */.h.ENUM_TYPE_DEFINITION]: kinds/* Kind.ENUM_TYPE_EXTENSION */.h.ENUM_TYPE_EXTENSION,
  [kinds/* Kind.INPUT_OBJECT_TYPE_DEFINITION */.h.INPUT_OBJECT_TYPE_DEFINITION]: kinds/* Kind.INPUT_OBJECT_TYPE_EXTENSION */.h.INPUT_OBJECT_TYPE_EXTENSION,
};

function typeToExtKind(type) {
  if (isScalarType(type)) {
    return kinds/* Kind.SCALAR_TYPE_EXTENSION */.h.SCALAR_TYPE_EXTENSION;
  }

  if (isObjectType(type)) {
    return kinds/* Kind.OBJECT_TYPE_EXTENSION */.h.OBJECT_TYPE_EXTENSION;
  }

  if (isInterfaceType(type)) {
    return kinds/* Kind.INTERFACE_TYPE_EXTENSION */.h.INTERFACE_TYPE_EXTENSION;
  }

  if (isUnionType(type)) {
    return kinds/* Kind.UNION_TYPE_EXTENSION */.h.UNION_TYPE_EXTENSION;
  }

  if (isEnumType(type)) {
    return kinds/* Kind.ENUM_TYPE_EXTENSION */.h.ENUM_TYPE_EXTENSION;
  }

  if (isInputObjectType(type)) {
    return kinds/* Kind.INPUT_OBJECT_TYPE_EXTENSION */.h.INPUT_OBJECT_TYPE_EXTENSION;
  }
  /* c8 ignore next 3 */
  // Not reachable. All possible types have been considered

   false || (0,invariant/* invariant */.k)(false, 'Unexpected type: ' + (0,inspect/* inspect */.X)(type));
}

function extensionKindToTypeName(kind) {
  switch (kind) {
    case kinds/* Kind.SCALAR_TYPE_EXTENSION */.h.SCALAR_TYPE_EXTENSION:
      return 'scalar';

    case kinds/* Kind.OBJECT_TYPE_EXTENSION */.h.OBJECT_TYPE_EXTENSION:
      return 'object';

    case kinds/* Kind.INTERFACE_TYPE_EXTENSION */.h.INTERFACE_TYPE_EXTENSION:
      return 'interface';

    case kinds/* Kind.UNION_TYPE_EXTENSION */.h.UNION_TYPE_EXTENSION:
      return 'union';

    case kinds/* Kind.ENUM_TYPE_EXTENSION */.h.ENUM_TYPE_EXTENSION:
      return 'enum';

    case kinds/* Kind.INPUT_OBJECT_TYPE_EXTENSION */.h.INPUT_OBJECT_TYPE_EXTENSION:
      return 'input object';
    // Not reachable. All possible types have been considered

    /* c8 ignore next */

    default:
       false || (0,invariant/* invariant */.k)(false, 'Unexpected kind: ' + (0,inspect/* inspect */.X)(kind));
  }
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/ProvidedRequiredArgumentsRule.mjs








/**
 * Provided required arguments
 *
 * A field or directive is only valid if all required (non-null without a
 * default value) field arguments have been provided.
 */
function ProvidedRequiredArgumentsRule(context) {
  return {
    // eslint-disable-next-line new-cap
    ...ProvidedRequiredArgumentsOnDirectivesRule(context),
    Field: {
      // Validate on leave to allow for deeper errors to appear first.
      leave(fieldNode) {
        var _fieldNode$arguments;

        const fieldDef = context.getFieldDef();

        if (!fieldDef) {
          return false;
        }

        const providedArgs = new Set( // FIXME: https://github.com/graphql/graphql-js/issues/2203
          /* c8 ignore next */
          (_fieldNode$arguments = fieldNode.arguments) === null ||
          _fieldNode$arguments === void 0
            ? void 0
            : _fieldNode$arguments.map((arg) => arg.name.value),
        );

        for (const argDef of fieldDef.args) {
          if (!providedArgs.has(argDef.name) && isRequiredArgument(argDef)) {
            const argTypeStr = (0,inspect/* inspect */.X)(argDef.type);
            context.reportError(
              new GraphQLError/* GraphQLError */.__(
                `Field "${fieldDef.name}" argument "${argDef.name}" of type "${argTypeStr}" is required, but it was not provided.`,
                {
                  nodes: fieldNode,
                },
              ),
            );
          }
        }
      },
    },
  };
}
/**
 * @internal
 */

function ProvidedRequiredArgumentsOnDirectivesRule(context) {
  var _schema$getDirectives;

  const requiredArgsMap = Object.create(null);
  const schema = context.getSchema();
  const definedDirectives =
    (_schema$getDirectives =
      schema === null || schema === void 0
        ? void 0
        : schema.getDirectives()) !== null && _schema$getDirectives !== void 0
      ? _schema$getDirectives
      : specifiedDirectives;

  for (const directive of definedDirectives) {
    requiredArgsMap[directive.name] = keyMap(
      directive.args.filter(isRequiredArgument),
      (arg) => arg.name,
    );
  }

  const astDefinitions = context.getDocument().definitions;

  for (const def of astDefinitions) {
    if (def.kind === kinds/* Kind.DIRECTIVE_DEFINITION */.h.DIRECTIVE_DEFINITION) {
      var _def$arguments;

      // FIXME: https://github.com/graphql/graphql-js/issues/2203

      /* c8 ignore next */
      const argNodes =
        (_def$arguments = def.arguments) !== null && _def$arguments !== void 0
          ? _def$arguments
          : [];
      requiredArgsMap[def.name.value] = keyMap(
        argNodes.filter(isRequiredArgumentNode),
        (arg) => arg.name.value,
      );
    }
  }

  return {
    Directive: {
      // Validate on leave to allow for deeper errors to appear first.
      leave(directiveNode) {
        const directiveName = directiveNode.name.value;
        const requiredArgs = requiredArgsMap[directiveName];

        if (requiredArgs) {
          var _directiveNode$argume;

          // FIXME: https://github.com/graphql/graphql-js/issues/2203

          /* c8 ignore next */
          const argNodes =
            (_directiveNode$argume = directiveNode.arguments) !== null &&
            _directiveNode$argume !== void 0
              ? _directiveNode$argume
              : [];
          const argNodeMap = new Set(argNodes.map((arg) => arg.name.value));

          for (const [argName, argDef] of Object.entries(requiredArgs)) {
            if (!argNodeMap.has(argName)) {
              const argType = isType(argDef.type)
                ? (0,inspect/* inspect */.X)(argDef.type)
                : print(argDef.type);
              context.reportError(
                new GraphQLError/* GraphQLError */.__(
                  `Directive "@${directiveName}" argument "${argName}" of type "${argType}" is required, but it was not provided.`,
                  {
                    nodes: directiveNode,
                  },
                ),
              );
            }
          }
        }
      },
    },
  };
}

function isRequiredArgumentNode(arg) {
  return arg.type.kind === kinds/* Kind.NON_NULL_TYPE */.h.NON_NULL_TYPE && arg.defaultValue == null;
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/ScalarLeafsRule.mjs




/**
 * Scalar leafs
 *
 * A GraphQL document is valid only if all leaf fields (fields without
 * sub selections) are of scalar or enum types.
 */
function ScalarLeafsRule(context) {
  return {
    Field(node) {
      const type = context.getType();
      const selectionSet = node.selectionSet;

      if (type) {
        if (isLeafType(getNamedType(type))) {
          if (selectionSet) {
            const fieldName = node.name.value;
            const typeStr = (0,inspect/* inspect */.X)(type);
            context.reportError(
              new GraphQLError/* GraphQLError */.__(
                `Field "${fieldName}" must not have a selection since type "${typeStr}" has no subfields.`,
                {
                  nodes: selectionSet,
                },
              ),
            );
          }
        } else if (!selectionSet) {
          const fieldName = node.name.value;
          const typeStr = (0,inspect/* inspect */.X)(type);
          context.reportError(
            new GraphQLError/* GraphQLError */.__(
              `Field "${fieldName}" of type "${typeStr}" must have a selection of subfields. Did you mean "${fieldName} { ... }"?`,
              {
                nodes: node,
              },
            ),
          );
        }
      }
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/printPathArray.mjs
/**
 * Build a string describing the path.
 */
function printPathArray(path) {
  return path
    .map((key) =>
      typeof key === 'number' ? '[' + key.toString() + ']' : '.' + key,
    )
    .join('');
}

;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/Path.mjs
/**
 * Given a Path and a key, return a new Path containing the new key.
 */
function addPath(prev, key, typename) {
  return {
    prev,
    key,
    typename,
  };
}
/**
 * Given a Path, return an Array of the path keys.
 */

function pathToArray(path) {
  const flattened = [];
  let curr = path;

  while (curr) {
    flattened.push(curr.key);
    curr = curr.prev;
  }

  return flattened.reverse();
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/coerceInputValue.mjs











/**
 * Coerces a JavaScript value given a GraphQL Input Type.
 */
function coerceInputValue(inputValue, type, onError = defaultOnError) {
  return coerceInputValueImpl(inputValue, type, onError, undefined);
}

function defaultOnError(path, invalidValue, error) {
  let errorPrefix = 'Invalid value ' + (0,inspect/* inspect */.X)(invalidValue);

  if (path.length > 0) {
    errorPrefix += ` at "value${printPathArray(path)}"`;
  }

  error.message = errorPrefix + ': ' + error.message;
  throw error;
}

function coerceInputValueImpl(inputValue, type, onError, path) {
  if (isNonNullType(type)) {
    if (inputValue != null) {
      return coerceInputValueImpl(inputValue, type.ofType, onError, path);
    }

    onError(
      pathToArray(path),
      inputValue,
      new GraphQLError/* GraphQLError */.__(
        `Expected non-nullable type "${(0,inspect/* inspect */.X)(type)}" not to be null.`,
      ),
    );
    return;
  }

  if (inputValue == null) {
    // Explicitly return the value null.
    return null;
  }

  if (isListType(type)) {
    const itemType = type.ofType;

    if (isIterableObject(inputValue)) {
      return Array.from(inputValue, (itemValue, index) => {
        const itemPath = addPath(path, index, undefined);
        return coerceInputValueImpl(itemValue, itemType, onError, itemPath);
      });
    } // Lists accept a non-list value as a list of one.

    return [coerceInputValueImpl(inputValue, itemType, onError, path)];
  }

  if (isInputObjectType(type)) {
    if (!(0,isObjectLike/* isObjectLike */.y)(inputValue)) {
      onError(
        pathToArray(path),
        inputValue,
        new GraphQLError/* GraphQLError */.__(`Expected type "${type.name}" to be an object.`),
      );
      return;
    }

    const coercedValue = {};
    const fieldDefs = type.getFields();

    for (const field of Object.values(fieldDefs)) {
      const fieldValue = inputValue[field.name];

      if (fieldValue === undefined) {
        if (field.defaultValue !== undefined) {
          coercedValue[field.name] = field.defaultValue;
        } else if (isNonNullType(field.type)) {
          const typeStr = (0,inspect/* inspect */.X)(field.type);
          onError(
            pathToArray(path),
            inputValue,
            new GraphQLError/* GraphQLError */.__(
              `Field "${field.name}" of required type "${typeStr}" was not provided.`,
            ),
          );
        }

        continue;
      }

      coercedValue[field.name] = coerceInputValueImpl(
        fieldValue,
        field.type,
        onError,
        addPath(path, field.name, type.name),
      );
    } // Ensure every provided field is defined.

    for (const fieldName of Object.keys(inputValue)) {
      if (!fieldDefs[fieldName]) {
        const suggestions = suggestionList(
          fieldName,
          Object.keys(type.getFields()),
        );
        onError(
          pathToArray(path),
          inputValue,
          new GraphQLError/* GraphQLError */.__(
            `Field "${fieldName}" is not defined by type "${type.name}".` +
              didYouMean(suggestions),
          ),
        );
      }
    }

    if (type.isOneOf) {
      const keys = Object.keys(coercedValue);

      if (keys.length !== 1) {
        onError(
          pathToArray(path),
          inputValue,
          new GraphQLError/* GraphQLError */.__(
            `Exactly one key must be specified for OneOf type "${type.name}".`,
          ),
        );
      }

      const key = keys[0];
      const value = coercedValue[key];

      if (value === null) {
        onError(
          pathToArray(path).concat(key),
          value,
          new GraphQLError/* GraphQLError */.__(`Field "${key}" must be non-null.`),
        );
      }
    }

    return coercedValue;
  }

  if (isLeafType(type)) {
    let parseResult; // Scalars and Enums determine if a input value is valid via parseValue(),
    // which can throw to indicate failure. If it throws, maintain a reference
    // to the original error.

    try {
      parseResult = type.parseValue(inputValue);
    } catch (error) {
      if (error instanceof GraphQLError/* GraphQLError */.__) {
        onError(pathToArray(path), inputValue, error);
      } else {
        onError(
          pathToArray(path),
          inputValue,
          new GraphQLError/* GraphQLError */.__(`Expected type "${type.name}". ` + error.message, {
            originalError: error,
          }),
        );
      }

      return;
    }

    if (parseResult === undefined) {
      onError(
        pathToArray(path),
        inputValue,
        new GraphQLError/* GraphQLError */.__(`Expected type "${type.name}".`),
      );
    }

    return parseResult;
  }
  /* c8 ignore next 3 */
  // Not reachable, all possible types have been considered.

   false || (0,invariant/* invariant */.k)(false, 'Unexpected input type: ' + (0,inspect/* inspect */.X)(type));
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/valueFromAST.mjs





/**
 * Produces a JavaScript value given a GraphQL Value AST.
 *
 * A GraphQL type must be provided, which will be used to interpret different
 * GraphQL Value literals.
 *
 * Returns `undefined` when the value could not be validly coerced according to
 * the provided type.
 *
 * | GraphQL Value        | JSON Value    |
 * | -------------------- | ------------- |
 * | Input Object         | Object        |
 * | List                 | Array         |
 * | Boolean              | Boolean       |
 * | String               | String        |
 * | Int / Float          | Number        |
 * | Enum Value           | Unknown       |
 * | NullValue            | null          |
 *
 */

function valueFromAST(valueNode, type, variables) {
  if (!valueNode) {
    // When there is no node, then there is also no value.
    // Importantly, this is different from returning the value null.
    return;
  }

  if (valueNode.kind === kinds/* Kind.VARIABLE */.h.VARIABLE) {
    const variableName = valueNode.name.value;

    if (variables == null || variables[variableName] === undefined) {
      // No valid return value.
      return;
    }

    const variableValue = variables[variableName];

    if (variableValue === null && isNonNullType(type)) {
      return; // Invalid: intentionally return no value.
    } // Note: This does no further checking that this variable is correct.
    // This assumes that this query has been validated and the variable
    // usage here is of the correct type.

    return variableValue;
  }

  if (isNonNullType(type)) {
    if (valueNode.kind === kinds/* Kind.NULL */.h.NULL) {
      return; // Invalid: intentionally return no value.
    }

    return valueFromAST(valueNode, type.ofType, variables);
  }

  if (valueNode.kind === kinds/* Kind.NULL */.h.NULL) {
    // This is explicitly returning the value null.
    return null;
  }

  if (isListType(type)) {
    const itemType = type.ofType;

    if (valueNode.kind === kinds/* Kind.LIST */.h.LIST) {
      const coercedValues = [];

      for (const itemNode of valueNode.values) {
        if (isMissingVariable(itemNode, variables)) {
          // If an array contains a missing variable, it is either coerced to
          // null or if the item type is non-null, it considered invalid.
          if (isNonNullType(itemType)) {
            return; // Invalid: intentionally return no value.
          }

          coercedValues.push(null);
        } else {
          const itemValue = valueFromAST(itemNode, itemType, variables);

          if (itemValue === undefined) {
            return; // Invalid: intentionally return no value.
          }

          coercedValues.push(itemValue);
        }
      }

      return coercedValues;
    }

    const coercedValue = valueFromAST(valueNode, itemType, variables);

    if (coercedValue === undefined) {
      return; // Invalid: intentionally return no value.
    }

    return [coercedValue];
  }

  if (isInputObjectType(type)) {
    if (valueNode.kind !== kinds/* Kind.OBJECT */.h.OBJECT) {
      return; // Invalid: intentionally return no value.
    }

    const coercedObj = Object.create(null);
    const fieldNodes = keyMap(valueNode.fields, (field) => field.name.value);

    for (const field of Object.values(type.getFields())) {
      const fieldNode = fieldNodes[field.name];

      if (!fieldNode || isMissingVariable(fieldNode.value, variables)) {
        if (field.defaultValue !== undefined) {
          coercedObj[field.name] = field.defaultValue;
        } else if (isNonNullType(field.type)) {
          return; // Invalid: intentionally return no value.
        }

        continue;
      }

      const fieldValue = valueFromAST(fieldNode.value, field.type, variables);

      if (fieldValue === undefined) {
        return; // Invalid: intentionally return no value.
      }

      coercedObj[field.name] = fieldValue;
    }

    if (type.isOneOf) {
      const keys = Object.keys(coercedObj);

      if (keys.length !== 1) {
        return; // Invalid: not exactly one key, intentionally return no value.
      }

      if (coercedObj[keys[0]] === null) {
        return; // Invalid: value not non-null, intentionally return no value.
      }
    }

    return coercedObj;
  }

  if (isLeafType(type)) {
    // Scalars and Enums fulfill parsing a literal value via parseLiteral().
    // Invalid values represent a failure to parse correctly, in which case
    // no value is returned.
    let result;

    try {
      result = type.parseLiteral(valueNode, variables);
    } catch (_error) {
      return; // Invalid: intentionally return no value.
    }

    if (result === undefined) {
      return; // Invalid: intentionally return no value.
    }

    return result;
  }
  /* c8 ignore next 3 */
  // Not reachable, all possible input types have been considered.

   false || (0,invariant/* invariant */.k)(false, 'Unexpected input type: ' + (0,inspect/* inspect */.X)(type));
} // Returns true if the provided valueNode is a variable which is not defined
// in the set of variables.

function isMissingVariable(valueNode, variables) {
  return (
    valueNode.kind === kinds/* Kind.VARIABLE */.h.VARIABLE &&
    (variables == null || variables[valueNode.name.value] === undefined)
  );
}

;// CONCATENATED MODULE: ../node_modules/graphql/execution/values.mjs











/**
 * Prepares an object map of variableValues of the correct type based on the
 * provided variable definitions and arbitrary input. If the input cannot be
 * parsed to match the variable definitions, a GraphQLError will be thrown.
 *
 * Note: The returned value is a plain Object with a prototype, since it is
 * exposed to user code. Care should be taken to not pull values from the
 * Object prototype.
 */
function getVariableValues(schema, varDefNodes, inputs, options) {
  const errors = [];
  const maxErrors =
    options === null || options === void 0 ? void 0 : options.maxErrors;

  try {
    const coerced = coerceVariableValues(
      schema,
      varDefNodes,
      inputs,
      (error) => {
        if (maxErrors != null && errors.length >= maxErrors) {
          throw new GraphQLError/* GraphQLError */.__(
            'Too many errors processing variables, error limit reached. Execution aborted.',
          );
        }

        errors.push(error);
      },
    );

    if (errors.length === 0) {
      return {
        coerced,
      };
    }
  } catch (error) {
    errors.push(error);
  }

  return {
    errors,
  };
}

function coerceVariableValues(schema, varDefNodes, inputs, onError) {
  const coercedValues = {};

  for (const varDefNode of varDefNodes) {
    const varName = varDefNode.variable.name.value;
    const varType = typeFromAST(schema, varDefNode.type);

    if (!isInputType(varType)) {
      // Must use input types for variables. This should be caught during
      // validation, however is checked again here for safety.
      const varTypeStr = print(varDefNode.type);
      onError(
        new GraphQLError/* GraphQLError */.__(
          `Variable "$${varName}" expected value of type "${varTypeStr}" which cannot be used as an input type.`,
          {
            nodes: varDefNode.type,
          },
        ),
      );
      continue;
    }

    if (!values_hasOwnProperty(inputs, varName)) {
      if (varDefNode.defaultValue) {
        coercedValues[varName] = valueFromAST(varDefNode.defaultValue, varType);
      } else if (isNonNullType(varType)) {
        const varTypeStr = (0,inspect/* inspect */.X)(varType);
        onError(
          new GraphQLError/* GraphQLError */.__(
            `Variable "$${varName}" of required type "${varTypeStr}" was not provided.`,
            {
              nodes: varDefNode,
            },
          ),
        );
      }

      continue;
    }

    const value = inputs[varName];

    if (value === null && isNonNullType(varType)) {
      const varTypeStr = (0,inspect/* inspect */.X)(varType);
      onError(
        new GraphQLError/* GraphQLError */.__(
          `Variable "$${varName}" of non-null type "${varTypeStr}" must not be null.`,
          {
            nodes: varDefNode,
          },
        ),
      );
      continue;
    }

    coercedValues[varName] = coerceInputValue(
      value,
      varType,
      (path, invalidValue, error) => {
        let prefix =
          `Variable "$${varName}" got invalid value ` + (0,inspect/* inspect */.X)(invalidValue);

        if (path.length > 0) {
          prefix += ` at "${varName}${printPathArray(path)}"`;
        }

        onError(
          new GraphQLError/* GraphQLError */.__(prefix + '; ' + error.message, {
            nodes: varDefNode,
            originalError: error,
          }),
        );
      },
    );
  }

  return coercedValues;
}
/**
 * Prepares an object map of argument values given a list of argument
 * definitions and list of argument AST nodes.
 *
 * Note: The returned value is a plain Object with a prototype, since it is
 * exposed to user code. Care should be taken to not pull values from the
 * Object prototype.
 */

function getArgumentValues(def, node, variableValues) {
  var _node$arguments;

  const coercedValues = {}; // FIXME: https://github.com/graphql/graphql-js/issues/2203

  /* c8 ignore next */

  const argumentNodes =
    (_node$arguments = node.arguments) !== null && _node$arguments !== void 0
      ? _node$arguments
      : [];
  const argNodeMap = keyMap(argumentNodes, (arg) => arg.name.value);

  for (const argDef of def.args) {
    const name = argDef.name;
    const argType = argDef.type;
    const argumentNode = argNodeMap[name];

    if (!argumentNode) {
      if (argDef.defaultValue !== undefined) {
        coercedValues[name] = argDef.defaultValue;
      } else if (isNonNullType(argType)) {
        throw new GraphQLError/* GraphQLError */.__(
          `Argument "${name}" of required type "${(0,inspect/* inspect */.X)(argType)}" ` +
            'was not provided.',
          {
            nodes: node,
          },
        );
      }

      continue;
    }

    const valueNode = argumentNode.value;
    let isNull = valueNode.kind === kinds/* Kind.NULL */.h.NULL;

    if (valueNode.kind === kinds/* Kind.VARIABLE */.h.VARIABLE) {
      const variableName = valueNode.name.value;

      if (
        variableValues == null ||
        !values_hasOwnProperty(variableValues, variableName)
      ) {
        if (argDef.defaultValue !== undefined) {
          coercedValues[name] = argDef.defaultValue;
        } else if (isNonNullType(argType)) {
          throw new GraphQLError/* GraphQLError */.__(
            `Argument "${name}" of required type "${(0,inspect/* inspect */.X)(argType)}" ` +
              `was provided the variable "$${variableName}" which was not provided a runtime value.`,
            {
              nodes: valueNode,
            },
          );
        }

        continue;
      }

      isNull = variableValues[variableName] == null;
    }

    if (isNull && isNonNullType(argType)) {
      throw new GraphQLError/* GraphQLError */.__(
        `Argument "${name}" of non-null type "${(0,inspect/* inspect */.X)(argType)}" ` +
          'must not be null.',
        {
          nodes: valueNode,
        },
      );
    }

    const coercedValue = valueFromAST(valueNode, argType, variableValues);

    if (coercedValue === undefined) {
      // Note: ValuesOfCorrectTypeRule validation should catch this before
      // execution. This is a runtime check to ensure execution does not
      // continue with an invalid argument value.
      throw new GraphQLError/* GraphQLError */.__(
        `Argument "${name}" has invalid value ${print(valueNode)}.`,
        {
          nodes: valueNode,
        },
      );
    }

    coercedValues[name] = coercedValue;
  }

  return coercedValues;
}
/**
 * Prepares an object map of argument values given a directive definition
 * and a AST node which may contain directives. Optionally also accepts a map
 * of variable values.
 *
 * If the directive does not exist on the node, returns undefined.
 *
 * Note: The returned value is a plain Object with a prototype, since it is
 * exposed to user code. Care should be taken to not pull values from the
 * Object prototype.
 */

function getDirectiveValues(directiveDef, node, variableValues) {
  var _node$directives;

  const directiveNode =
    (_node$directives = node.directives) === null || _node$directives === void 0
      ? void 0
      : _node$directives.find(
          (directive) => directive.name.value === directiveDef.name,
        );

  if (directiveNode) {
    return getArgumentValues(directiveDef, directiveNode, variableValues);
  }
}

function values_hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

;// CONCATENATED MODULE: ../node_modules/graphql/execution/collectFields.mjs





/**
 * Given a selectionSet, collects all of the fields and returns them.
 *
 * CollectFields requires the "runtime type" of an object. For a field that
 * returns an Interface or Union type, the "runtime type" will be the actual
 * object type returned by that field.
 *
 * @internal
 */

function collectFields(
  schema,
  fragments,
  variableValues,
  runtimeType,
  selectionSet,
) {
  const fields = new Map();
  collectFieldsImpl(
    schema,
    fragments,
    variableValues,
    runtimeType,
    selectionSet,
    fields,
    new Set(),
  );
  return fields;
}
/**
 * Given an array of field nodes, collects all of the subfields of the passed
 * in fields, and returns them at the end.
 *
 * CollectSubFields requires the "return type" of an object. For a field that
 * returns an Interface or Union type, the "return type" will be the actual
 * object type returned by that field.
 *
 * @internal
 */

function collectSubfields(
  schema,
  fragments,
  variableValues,
  returnType,
  fieldNodes,
) {
  const subFieldNodes = new Map();
  const visitedFragmentNames = new Set();

  for (const node of fieldNodes) {
    if (node.selectionSet) {
      collectFieldsImpl(
        schema,
        fragments,
        variableValues,
        returnType,
        node.selectionSet,
        subFieldNodes,
        visitedFragmentNames,
      );
    }
  }

  return subFieldNodes;
}

function collectFieldsImpl(
  schema,
  fragments,
  variableValues,
  runtimeType,
  selectionSet,
  fields,
  visitedFragmentNames,
) {
  for (const selection of selectionSet.selections) {
    switch (selection.kind) {
      case kinds/* Kind.FIELD */.h.FIELD: {
        if (!shouldIncludeNode(variableValues, selection)) {
          continue;
        }

        const name = getFieldEntryKey(selection);
        const fieldList = fields.get(name);

        if (fieldList !== undefined) {
          fieldList.push(selection);
        } else {
          fields.set(name, [selection]);
        }

        break;
      }

      case kinds/* Kind.INLINE_FRAGMENT */.h.INLINE_FRAGMENT: {
        if (
          !shouldIncludeNode(variableValues, selection) ||
          !doesFragmentConditionMatch(schema, selection, runtimeType)
        ) {
          continue;
        }

        collectFieldsImpl(
          schema,
          fragments,
          variableValues,
          runtimeType,
          selection.selectionSet,
          fields,
          visitedFragmentNames,
        );
        break;
      }

      case kinds/* Kind.FRAGMENT_SPREAD */.h.FRAGMENT_SPREAD: {
        const fragName = selection.name.value;

        if (
          visitedFragmentNames.has(fragName) ||
          !shouldIncludeNode(variableValues, selection)
        ) {
          continue;
        }

        visitedFragmentNames.add(fragName);
        const fragment = fragments[fragName];

        if (
          !fragment ||
          !doesFragmentConditionMatch(schema, fragment, runtimeType)
        ) {
          continue;
        }

        collectFieldsImpl(
          schema,
          fragments,
          variableValues,
          runtimeType,
          fragment.selectionSet,
          fields,
          visitedFragmentNames,
        );
        break;
      }
    }
  }
}
/**
 * Determines if a field should be included based on the `@include` and `@skip`
 * directives, where `@skip` has higher precedence than `@include`.
 */

function shouldIncludeNode(variableValues, node) {
  const skip = getDirectiveValues(GraphQLSkipDirective, node, variableValues);

  if ((skip === null || skip === void 0 ? void 0 : skip.if) === true) {
    return false;
  }

  const include = getDirectiveValues(
    GraphQLIncludeDirective,
    node,
    variableValues,
  );

  if (
    (include === null || include === void 0 ? void 0 : include.if) === false
  ) {
    return false;
  }

  return true;
}
/**
 * Determines if a fragment is applicable to the given type.
 */

function doesFragmentConditionMatch(schema, fragment, type) {
  const typeConditionNode = fragment.typeCondition;

  if (!typeConditionNode) {
    return true;
  }

  const conditionalType = typeFromAST(schema, typeConditionNode);

  if (conditionalType === type) {
    return true;
  }

  if (isAbstractType(conditionalType)) {
    return schema.isSubType(conditionalType, type);
  }

  return false;
}
/**
 * Implements the logic to compute the key of a given field's entry
 */

function getFieldEntryKey(node) {
  return node.alias ? node.alias.value : node.name.value;
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/SingleFieldSubscriptionsRule.mjs




/**
 * Subscriptions must only include a non-introspection field.
 *
 * A GraphQL subscription is valid only if it contains a single root field and
 * that root field is not an introspection field.
 *
 * See https://spec.graphql.org/draft/#sec-Single-root-field
 */
function SingleFieldSubscriptionsRule(context) {
  return {
    OperationDefinition(node) {
      if (node.operation === 'subscription') {
        const schema = context.getSchema();
        const subscriptionType = schema.getSubscriptionType();

        if (subscriptionType) {
          const operationName = node.name ? node.name.value : null;
          const variableValues = Object.create(null);
          const document = context.getDocument();
          const fragments = Object.create(null);

          for (const definition of document.definitions) {
            if (definition.kind === kinds/* Kind.FRAGMENT_DEFINITION */.h.FRAGMENT_DEFINITION) {
              fragments[definition.name.value] = definition;
            }
          }

          const fields = collectFields(
            schema,
            fragments,
            variableValues,
            subscriptionType,
            node.selectionSet,
          );

          if (fields.size > 1) {
            const fieldSelectionLists = [...fields.values()];
            const extraFieldSelectionLists = fieldSelectionLists.slice(1);
            const extraFieldSelections = extraFieldSelectionLists.flat();
            context.reportError(
              new GraphQLError/* GraphQLError */.__(
                operationName != null
                  ? `Subscription "${operationName}" must select only one top level field.`
                  : 'Anonymous Subscription must select only one top level field.',
                {
                  nodes: extraFieldSelections,
                },
              ),
            );
          }

          for (const fieldNodes of fields.values()) {
            const field = fieldNodes[0];
            const fieldName = field.name.value;

            if (fieldName.startsWith('__')) {
              context.reportError(
                new GraphQLError/* GraphQLError */.__(
                  operationName != null
                    ? `Subscription "${operationName}" must not select an introspection top level field.`
                    : 'Anonymous Subscription must not select an introspection top level field.',
                  {
                    nodes: fieldNodes,
                  },
                ),
              );
            }
          }
        }
      }
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/groupBy.mjs
/**
 * Groups array items into a Map, given a function to produce grouping key.
 */
function groupBy(list, keyFn) {
  const result = new Map();

  for (const item of list) {
    const key = keyFn(item);
    const group = result.get(key);

    if (group === undefined) {
      result.set(key, [item]);
    } else {
      group.push(item);
    }
  }

  return result;
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/UniqueArgumentDefinitionNamesRule.mjs



/**
 * Unique argument definition names
 *
 * A GraphQL Object or Interface type is only valid if all its fields have uniquely named arguments.
 * A GraphQL Directive is only valid if all its arguments are uniquely named.
 */
function UniqueArgumentDefinitionNamesRule(context) {
  return {
    DirectiveDefinition(directiveNode) {
      var _directiveNode$argume;

      // FIXME: https://github.com/graphql/graphql-js/issues/2203

      /* c8 ignore next */
      const argumentNodes =
        (_directiveNode$argume = directiveNode.arguments) !== null &&
        _directiveNode$argume !== void 0
          ? _directiveNode$argume
          : [];
      return checkArgUniqueness(`@${directiveNode.name.value}`, argumentNodes);
    },

    InterfaceTypeDefinition: checkArgUniquenessPerField,
    InterfaceTypeExtension: checkArgUniquenessPerField,
    ObjectTypeDefinition: checkArgUniquenessPerField,
    ObjectTypeExtension: checkArgUniquenessPerField,
  };

  function checkArgUniquenessPerField(typeNode) {
    var _typeNode$fields;

    const typeName = typeNode.name.value; // FIXME: https://github.com/graphql/graphql-js/issues/2203

    /* c8 ignore next */

    const fieldNodes =
      (_typeNode$fields = typeNode.fields) !== null &&
      _typeNode$fields !== void 0
        ? _typeNode$fields
        : [];

    for (const fieldDef of fieldNodes) {
      var _fieldDef$arguments;

      const fieldName = fieldDef.name.value; // FIXME: https://github.com/graphql/graphql-js/issues/2203

      /* c8 ignore next */

      const argumentNodes =
        (_fieldDef$arguments = fieldDef.arguments) !== null &&
        _fieldDef$arguments !== void 0
          ? _fieldDef$arguments
          : [];
      checkArgUniqueness(`${typeName}.${fieldName}`, argumentNodes);
    }

    return false;
  }

  function checkArgUniqueness(parentName, argumentNodes) {
    const seenArgs = groupBy(argumentNodes, (arg) => arg.name.value);

    for (const [argName, argNodes] of seenArgs) {
      if (argNodes.length > 1) {
        context.reportError(
          new GraphQLError/* GraphQLError */.__(
            `Argument "${parentName}(${argName}:)" can only be defined once.`,
            {
              nodes: argNodes.map((node) => node.name),
            },
          ),
        );
      }
    }

    return false;
  }
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/UniqueArgumentNamesRule.mjs



/**
 * Unique argument names
 *
 * A GraphQL field or directive is only valid if all supplied arguments are
 * uniquely named.
 *
 * See https://spec.graphql.org/draft/#sec-Argument-Names
 */
function UniqueArgumentNamesRule(context) {
  return {
    Field: checkArgUniqueness,
    Directive: checkArgUniqueness,
  };

  function checkArgUniqueness(parentNode) {
    var _parentNode$arguments;

    // FIXME: https://github.com/graphql/graphql-js/issues/2203

    /* c8 ignore next */
    const argumentNodes =
      (_parentNode$arguments = parentNode.arguments) !== null &&
      _parentNode$arguments !== void 0
        ? _parentNode$arguments
        : [];
    const seenArgs = groupBy(argumentNodes, (arg) => arg.name.value);

    for (const [argName, argNodes] of seenArgs) {
      if (argNodes.length > 1) {
        context.reportError(
          new GraphQLError/* GraphQLError */.__(
            `There can be only one argument named "${argName}".`,
            {
              nodes: argNodes.map((node) => node.name),
            },
          ),
        );
      }
    }
  }
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/UniqueDirectiveNamesRule.mjs


/**
 * Unique directive names
 *
 * A GraphQL document is only valid if all defined directives have unique names.
 */
function UniqueDirectiveNamesRule(context) {
  const knownDirectiveNames = Object.create(null);
  const schema = context.getSchema();
  return {
    DirectiveDefinition(node) {
      const directiveName = node.name.value;

      if (
        schema !== null &&
        schema !== void 0 &&
        schema.getDirective(directiveName)
      ) {
        context.reportError(
          new GraphQLError/* GraphQLError */.__(
            `Directive "@${directiveName}" already exists in the schema. It cannot be redefined.`,
            {
              nodes: node.name,
            },
          ),
        );
        return;
      }

      if (knownDirectiveNames[directiveName]) {
        context.reportError(
          new GraphQLError/* GraphQLError */.__(
            `There can be only one directive named "@${directiveName}".`,
            {
              nodes: [knownDirectiveNames[directiveName], node.name],
            },
          ),
        );
      } else {
        knownDirectiveNames[directiveName] = node.name;
      }

      return false;
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/UniqueDirectivesPerLocationRule.mjs





/**
 * Unique directive names per location
 *
 * A GraphQL document is only valid if all non-repeatable directives at
 * a given location are uniquely named.
 *
 * See https://spec.graphql.org/draft/#sec-Directives-Are-Unique-Per-Location
 */
function UniqueDirectivesPerLocationRule(context) {
  const uniqueDirectiveMap = Object.create(null);
  const schema = context.getSchema();
  const definedDirectives = schema
    ? schema.getDirectives()
    : specifiedDirectives;

  for (const directive of definedDirectives) {
    uniqueDirectiveMap[directive.name] = !directive.isRepeatable;
  }

  const astDefinitions = context.getDocument().definitions;

  for (const def of astDefinitions) {
    if (def.kind === kinds/* Kind.DIRECTIVE_DEFINITION */.h.DIRECTIVE_DEFINITION) {
      uniqueDirectiveMap[def.name.value] = !def.repeatable;
    }
  }

  const schemaDirectives = Object.create(null);
  const typeDirectivesMap = Object.create(null);
  return {
    // Many different AST nodes may contain directives. Rather than listing
    // them all, just listen for entering any node, and check to see if it
    // defines any directives.
    enter(node) {
      if (!('directives' in node) || !node.directives) {
        return;
      }

      let seenDirectives;

      if (
        node.kind === kinds/* Kind.SCHEMA_DEFINITION */.h.SCHEMA_DEFINITION ||
        node.kind === kinds/* Kind.SCHEMA_EXTENSION */.h.SCHEMA_EXTENSION
      ) {
        seenDirectives = schemaDirectives;
      } else if (isTypeDefinitionNode(node) || isTypeExtensionNode(node)) {
        const typeName = node.name.value;
        seenDirectives = typeDirectivesMap[typeName];

        if (seenDirectives === undefined) {
          typeDirectivesMap[typeName] = seenDirectives = Object.create(null);
        }
      } else {
        seenDirectives = Object.create(null);
      }

      for (const directive of node.directives) {
        const directiveName = directive.name.value;

        if (uniqueDirectiveMap[directiveName]) {
          if (seenDirectives[directiveName]) {
            context.reportError(
              new GraphQLError/* GraphQLError */.__(
                `The directive "@${directiveName}" can only be used once at this location.`,
                {
                  nodes: [seenDirectives[directiveName], directive],
                },
              ),
            );
          } else {
            seenDirectives[directiveName] = directive;
          }
        }
      }
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/UniqueEnumValueNamesRule.mjs



/**
 * Unique enum value names
 *
 * A GraphQL enum type is only valid if all its values are uniquely named.
 */
function UniqueEnumValueNamesRule(context) {
  const schema = context.getSchema();
  const existingTypeMap = schema ? schema.getTypeMap() : Object.create(null);
  const knownValueNames = Object.create(null);
  return {
    EnumTypeDefinition: checkValueUniqueness,
    EnumTypeExtension: checkValueUniqueness,
  };

  function checkValueUniqueness(node) {
    var _node$values;

    const typeName = node.name.value;

    if (!knownValueNames[typeName]) {
      knownValueNames[typeName] = Object.create(null);
    } // FIXME: https://github.com/graphql/graphql-js/issues/2203

    /* c8 ignore next */

    const valueNodes =
      (_node$values = node.values) !== null && _node$values !== void 0
        ? _node$values
        : [];
    const valueNames = knownValueNames[typeName];

    for (const valueDef of valueNodes) {
      const valueName = valueDef.name.value;
      const existingType = existingTypeMap[typeName];

      if (isEnumType(existingType) && existingType.getValue(valueName)) {
        context.reportError(
          new GraphQLError/* GraphQLError */.__(
            `Enum value "${typeName}.${valueName}" already exists in the schema. It cannot also be defined in this type extension.`,
            {
              nodes: valueDef.name,
            },
          ),
        );
      } else if (valueNames[valueName]) {
        context.reportError(
          new GraphQLError/* GraphQLError */.__(
            `Enum value "${typeName}.${valueName}" can only be defined once.`,
            {
              nodes: [valueNames[valueName], valueDef.name],
            },
          ),
        );
      } else {
        valueNames[valueName] = valueDef.name;
      }
    }

    return false;
  }
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/UniqueFieldDefinitionNamesRule.mjs



/**
 * Unique field definition names
 *
 * A GraphQL complex type is only valid if all its fields are uniquely named.
 */
function UniqueFieldDefinitionNamesRule(context) {
  const schema = context.getSchema();
  const existingTypeMap = schema ? schema.getTypeMap() : Object.create(null);
  const knownFieldNames = Object.create(null);
  return {
    InputObjectTypeDefinition: checkFieldUniqueness,
    InputObjectTypeExtension: checkFieldUniqueness,
    InterfaceTypeDefinition: checkFieldUniqueness,
    InterfaceTypeExtension: checkFieldUniqueness,
    ObjectTypeDefinition: checkFieldUniqueness,
    ObjectTypeExtension: checkFieldUniqueness,
  };

  function checkFieldUniqueness(node) {
    var _node$fields;

    const typeName = node.name.value;

    if (!knownFieldNames[typeName]) {
      knownFieldNames[typeName] = Object.create(null);
    } // FIXME: https://github.com/graphql/graphql-js/issues/2203

    /* c8 ignore next */

    const fieldNodes =
      (_node$fields = node.fields) !== null && _node$fields !== void 0
        ? _node$fields
        : [];
    const fieldNames = knownFieldNames[typeName];

    for (const fieldDef of fieldNodes) {
      const fieldName = fieldDef.name.value;

      if (hasField(existingTypeMap[typeName], fieldName)) {
        context.reportError(
          new GraphQLError/* GraphQLError */.__(
            `Field "${typeName}.${fieldName}" already exists in the schema. It cannot also be defined in this type extension.`,
            {
              nodes: fieldDef.name,
            },
          ),
        );
      } else if (fieldNames[fieldName]) {
        context.reportError(
          new GraphQLError/* GraphQLError */.__(
            `Field "${typeName}.${fieldName}" can only be defined once.`,
            {
              nodes: [fieldNames[fieldName], fieldDef.name],
            },
          ),
        );
      } else {
        fieldNames[fieldName] = fieldDef.name;
      }
    }

    return false;
  }
}

function hasField(type, fieldName) {
  if (isObjectType(type) || isInterfaceType(type) || isInputObjectType(type)) {
    return type.getFields()[fieldName] != null;
  }

  return false;
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/UniqueFragmentNamesRule.mjs


/**
 * Unique fragment names
 *
 * A GraphQL document is only valid if all defined fragments have unique names.
 *
 * See https://spec.graphql.org/draft/#sec-Fragment-Name-Uniqueness
 */
function UniqueFragmentNamesRule(context) {
  const knownFragmentNames = Object.create(null);
  return {
    OperationDefinition: () => false,

    FragmentDefinition(node) {
      const fragmentName = node.name.value;

      if (knownFragmentNames[fragmentName]) {
        context.reportError(
          new GraphQLError/* GraphQLError */.__(
            `There can be only one fragment named "${fragmentName}".`,
            {
              nodes: [knownFragmentNames[fragmentName], node.name],
            },
          ),
        );
      } else {
        knownFragmentNames[fragmentName] = node.name;
      }

      return false;
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/UniqueInputFieldNamesRule.mjs



/**
 * Unique input field names
 *
 * A GraphQL input object value is only valid if all supplied fields are
 * uniquely named.
 *
 * See https://spec.graphql.org/draft/#sec-Input-Object-Field-Uniqueness
 */
function UniqueInputFieldNamesRule(context) {
  const knownNameStack = [];
  let knownNames = Object.create(null);
  return {
    ObjectValue: {
      enter() {
        knownNameStack.push(knownNames);
        knownNames = Object.create(null);
      },

      leave() {
        const prevKnownNames = knownNameStack.pop();
        prevKnownNames || (0,invariant/* invariant */.k)(false);
        knownNames = prevKnownNames;
      },
    },

    ObjectField(node) {
      const fieldName = node.name.value;

      if (knownNames[fieldName]) {
        context.reportError(
          new GraphQLError/* GraphQLError */.__(
            `There can be only one input field named "${fieldName}".`,
            {
              nodes: [knownNames[fieldName], node.name],
            },
          ),
        );
      } else {
        knownNames[fieldName] = node.name;
      }
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/UniqueOperationNamesRule.mjs


/**
 * Unique operation names
 *
 * A GraphQL document is only valid if all defined operations have unique names.
 *
 * See https://spec.graphql.org/draft/#sec-Operation-Name-Uniqueness
 */
function UniqueOperationNamesRule(context) {
  const knownOperationNames = Object.create(null);
  return {
    OperationDefinition(node) {
      const operationName = node.name;

      if (operationName) {
        if (knownOperationNames[operationName.value]) {
          context.reportError(
            new GraphQLError/* GraphQLError */.__(
              `There can be only one operation named "${operationName.value}".`,
              {
                nodes: [
                  knownOperationNames[operationName.value],
                  operationName,
                ],
              },
            ),
          );
        } else {
          knownOperationNames[operationName.value] = operationName;
        }
      }

      return false;
    },

    FragmentDefinition: () => false,
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/UniqueOperationTypesRule.mjs


/**
 * Unique operation types
 *
 * A GraphQL document is only valid if it has only one type per operation.
 */
function UniqueOperationTypesRule(context) {
  const schema = context.getSchema();
  const definedOperationTypes = Object.create(null);
  const existingOperationTypes = schema
    ? {
        query: schema.getQueryType(),
        mutation: schema.getMutationType(),
        subscription: schema.getSubscriptionType(),
      }
    : {};
  return {
    SchemaDefinition: checkOperationTypes,
    SchemaExtension: checkOperationTypes,
  };

  function checkOperationTypes(node) {
    var _node$operationTypes;

    // See: https://github.com/graphql/graphql-js/issues/2203

    /* c8 ignore next */
    const operationTypesNodes =
      (_node$operationTypes = node.operationTypes) !== null &&
      _node$operationTypes !== void 0
        ? _node$operationTypes
        : [];

    for (const operationType of operationTypesNodes) {
      const operation = operationType.operation;
      const alreadyDefinedOperationType = definedOperationTypes[operation];

      if (existingOperationTypes[operation]) {
        context.reportError(
          new GraphQLError/* GraphQLError */.__(
            `Type for ${operation} already defined in the schema. It cannot be redefined.`,
            {
              nodes: operationType,
            },
          ),
        );
      } else if (alreadyDefinedOperationType) {
        context.reportError(
          new GraphQLError/* GraphQLError */.__(
            `There can be only one ${operation} type in schema.`,
            {
              nodes: [alreadyDefinedOperationType, operationType],
            },
          ),
        );
      } else {
        definedOperationTypes[operation] = operationType;
      }
    }

    return false;
  }
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/UniqueTypeNamesRule.mjs


/**
 * Unique type names
 *
 * A GraphQL document is only valid if all defined types have unique names.
 */
function UniqueTypeNamesRule(context) {
  const knownTypeNames = Object.create(null);
  const schema = context.getSchema();
  return {
    ScalarTypeDefinition: checkTypeName,
    ObjectTypeDefinition: checkTypeName,
    InterfaceTypeDefinition: checkTypeName,
    UnionTypeDefinition: checkTypeName,
    EnumTypeDefinition: checkTypeName,
    InputObjectTypeDefinition: checkTypeName,
  };

  function checkTypeName(node) {
    const typeName = node.name.value;

    if (schema !== null && schema !== void 0 && schema.getType(typeName)) {
      context.reportError(
        new GraphQLError/* GraphQLError */.__(
          `Type "${typeName}" already exists in the schema. It cannot also be defined in this type definition.`,
          {
            nodes: node.name,
          },
        ),
      );
      return;
    }

    if (knownTypeNames[typeName]) {
      context.reportError(
        new GraphQLError/* GraphQLError */.__(`There can be only one type named "${typeName}".`, {
          nodes: [knownTypeNames[typeName], node.name],
        }),
      );
    } else {
      knownTypeNames[typeName] = node.name;
    }

    return false;
  }
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/UniqueVariableNamesRule.mjs



/**
 * Unique variable names
 *
 * A GraphQL operation is only valid if all its variables are uniquely named.
 */
function UniqueVariableNamesRule(context) {
  return {
    OperationDefinition(operationNode) {
      var _operationNode$variab;

      // See: https://github.com/graphql/graphql-js/issues/2203

      /* c8 ignore next */
      const variableDefinitions =
        (_operationNode$variab = operationNode.variableDefinitions) !== null &&
        _operationNode$variab !== void 0
          ? _operationNode$variab
          : [];
      const seenVariableDefinitions = groupBy(
        variableDefinitions,
        (node) => node.variable.name.value,
      );

      for (const [variableName, variableNodes] of seenVariableDefinitions) {
        if (variableNodes.length > 1) {
          context.reportError(
            new GraphQLError/* GraphQLError */.__(
              `There can be only one variable named "$${variableName}".`,
              {
                nodes: variableNodes.map((node) => node.variable.name),
              },
            ),
          );
        }
      }
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/ValuesOfCorrectTypeRule.mjs









/**
 * Value literals of correct type
 *
 * A GraphQL document is only valid if all value literals are of the type
 * expected at their position.
 *
 * See https://spec.graphql.org/draft/#sec-Values-of-Correct-Type
 */
function ValuesOfCorrectTypeRule(context) {
  let variableDefinitions = {};
  return {
    OperationDefinition: {
      enter() {
        variableDefinitions = {};
      },
    },

    VariableDefinition(definition) {
      variableDefinitions[definition.variable.name.value] = definition;
    },

    ListValue(node) {
      // Note: TypeInfo will traverse into a list's item type, so look to the
      // parent input type to check if it is a list.
      const type = getNullableType(context.getParentInputType());

      if (!isListType(type)) {
        isValidValueNode(context, node);
        return false; // Don't traverse further.
      }
    },

    ObjectValue(node) {
      const type = getNamedType(context.getInputType());

      if (!isInputObjectType(type)) {
        isValidValueNode(context, node);
        return false; // Don't traverse further.
      } // Ensure every required field exists.

      const fieldNodeMap = keyMap(node.fields, (field) => field.name.value);

      for (const fieldDef of Object.values(type.getFields())) {
        const fieldNode = fieldNodeMap[fieldDef.name];

        if (!fieldNode && isRequiredInputField(fieldDef)) {
          const typeStr = (0,inspect/* inspect */.X)(fieldDef.type);
          context.reportError(
            new GraphQLError/* GraphQLError */.__(
              `Field "${type.name}.${fieldDef.name}" of required type "${typeStr}" was not provided.`,
              {
                nodes: node,
              },
            ),
          );
        }
      }

      if (type.isOneOf) {
        validateOneOfInputObject(
          context,
          node,
          type,
          fieldNodeMap,
          variableDefinitions,
        );
      }
    },

    ObjectField(node) {
      const parentType = getNamedType(context.getParentInputType());
      const fieldType = context.getInputType();

      if (!fieldType && isInputObjectType(parentType)) {
        const suggestions = suggestionList(
          node.name.value,
          Object.keys(parentType.getFields()),
        );
        context.reportError(
          new GraphQLError/* GraphQLError */.__(
            `Field "${node.name.value}" is not defined by type "${parentType.name}".` +
              didYouMean(suggestions),
            {
              nodes: node,
            },
          ),
        );
      }
    },

    NullValue(node) {
      const type = context.getInputType();

      if (isNonNullType(type)) {
        context.reportError(
          new GraphQLError/* GraphQLError */.__(
            `Expected value of type "${(0,inspect/* inspect */.X)(type)}", found ${print(node)}.`,
            {
              nodes: node,
            },
          ),
        );
      }
    },

    EnumValue: (node) => isValidValueNode(context, node),
    IntValue: (node) => isValidValueNode(context, node),
    FloatValue: (node) => isValidValueNode(context, node),
    StringValue: (node) => isValidValueNode(context, node),
    BooleanValue: (node) => isValidValueNode(context, node),
  };
}
/**
 * Any value literal may be a valid representation of a Scalar, depending on
 * that scalar type.
 */

function isValidValueNode(context, node) {
  // Report any error at the full type expected by the location.
  const locationType = context.getInputType();

  if (!locationType) {
    return;
  }

  const type = getNamedType(locationType);

  if (!isLeafType(type)) {
    const typeStr = (0,inspect/* inspect */.X)(locationType);
    context.reportError(
      new GraphQLError/* GraphQLError */.__(
        `Expected value of type "${typeStr}", found ${print(node)}.`,
        {
          nodes: node,
        },
      ),
    );
    return;
  } // Scalars and Enums determine if a literal value is valid via parseLiteral(),
  // which may throw or return an invalid value to indicate failure.

  try {
    const parseResult = type.parseLiteral(
      node,
      undefined,
      /* variables */
    );

    if (parseResult === undefined) {
      const typeStr = (0,inspect/* inspect */.X)(locationType);
      context.reportError(
        new GraphQLError/* GraphQLError */.__(
          `Expected value of type "${typeStr}", found ${print(node)}.`,
          {
            nodes: node,
          },
        ),
      );
    }
  } catch (error) {
    const typeStr = (0,inspect/* inspect */.X)(locationType);

    if (error instanceof GraphQLError/* GraphQLError */.__) {
      context.reportError(error);
    } else {
      context.reportError(
        new GraphQLError/* GraphQLError */.__(
          `Expected value of type "${typeStr}", found ${print(node)}; ` +
            error.message,
          {
            nodes: node,
            originalError: error,
          },
        ),
      );
    }
  }
}

function validateOneOfInputObject(
  context,
  node,
  type,
  fieldNodeMap,
  variableDefinitions,
) {
  var _fieldNodeMap$keys$;

  const keys = Object.keys(fieldNodeMap);
  const isNotExactlyOneField = keys.length !== 1;

  if (isNotExactlyOneField) {
    context.reportError(
      new GraphQLError/* GraphQLError */.__(
        `OneOf Input Object "${type.name}" must specify exactly one key.`,
        {
          nodes: [node],
        },
      ),
    );
    return;
  }

  const value =
    (_fieldNodeMap$keys$ = fieldNodeMap[keys[0]]) === null ||
    _fieldNodeMap$keys$ === void 0
      ? void 0
      : _fieldNodeMap$keys$.value;
  const isNullLiteral = !value || value.kind === kinds/* Kind.NULL */.h.NULL;
  const isVariable =
    (value === null || value === void 0 ? void 0 : value.kind) ===
    kinds/* Kind.VARIABLE */.h.VARIABLE;

  if (isNullLiteral) {
    context.reportError(
      new GraphQLError/* GraphQLError */.__(`Field "${type.name}.${keys[0]}" must be non-null.`, {
        nodes: [node],
      }),
    );
    return;
  }

  if (isVariable) {
    const variableName = value.name.value;
    const definition = variableDefinitions[variableName];
    const isNullableVariable = definition.type.kind !== kinds/* Kind.NON_NULL_TYPE */.h.NON_NULL_TYPE;

    if (isNullableVariable) {
      context.reportError(
        new GraphQLError/* GraphQLError */.__(
          `Variable "${variableName}" must be non-nullable to be used for OneOf Input Object "${type.name}".`,
          {
            nodes: [node],
          },
        ),
      );
    }
  }
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/VariablesAreInputTypesRule.mjs





/**
 * Variables are input types
 *
 * A GraphQL operation is only valid if all the variables it defines are of
 * input types (scalar, enum, or input object).
 *
 * See https://spec.graphql.org/draft/#sec-Variables-Are-Input-Types
 */
function VariablesAreInputTypesRule(context) {
  return {
    VariableDefinition(node) {
      const type = typeFromAST(context.getSchema(), node.type);

      if (type !== undefined && !isInputType(type)) {
        const variableName = node.variable.name.value;
        const typeName = print(node.type);
        context.reportError(
          new GraphQLError/* GraphQLError */.__(
            `Variable "$${variableName}" cannot be non-input type "${typeName}".`,
            {
              nodes: node.type,
            },
          ),
        );
      }
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/VariablesInAllowedPositionRule.mjs







/**
 * Variables in allowed position
 *
 * Variable usages must be compatible with the arguments they are passed to.
 *
 * See https://spec.graphql.org/draft/#sec-All-Variable-Usages-are-Allowed
 */
function VariablesInAllowedPositionRule(context) {
  let varDefMap = Object.create(null);
  return {
    OperationDefinition: {
      enter() {
        varDefMap = Object.create(null);
      },

      leave(operation) {
        const usages = context.getRecursiveVariableUsages(operation);

        for (const { node, type, defaultValue } of usages) {
          const varName = node.name.value;
          const varDef = varDefMap[varName];

          if (varDef && type) {
            // A var type is allowed if it is the same or more strict (e.g. is
            // a subtype of) than the expected type. It can be more strict if
            // the variable type is non-null when the expected type is nullable.
            // If both are list types, the variable item type can be more strict
            // than the expected item type (contravariant).
            const schema = context.getSchema();
            const varType = typeFromAST(schema, varDef.type);

            if (
              varType &&
              !allowedVariableUsage(
                schema,
                varType,
                varDef.defaultValue,
                type,
                defaultValue,
              )
            ) {
              const varTypeStr = (0,inspect/* inspect */.X)(varType);
              const typeStr = (0,inspect/* inspect */.X)(type);
              context.reportError(
                new GraphQLError/* GraphQLError */.__(
                  `Variable "$${varName}" of type "${varTypeStr}" used in position expecting type "${typeStr}".`,
                  {
                    nodes: [varDef, node],
                  },
                ),
              );
            }
          }
        }
      },
    },

    VariableDefinition(node) {
      varDefMap[node.variable.name.value] = node;
    },
  };
}
/**
 * Returns true if the variable is allowed in the location it was found,
 * which includes considering if default values exist for either the variable
 * or the location at which it is located.
 */

function allowedVariableUsage(
  schema,
  varType,
  varDefaultValue,
  locationType,
  locationDefaultValue,
) {
  if (isNonNullType(locationType) && !isNonNullType(varType)) {
    const hasNonNullVariableDefaultValue =
      varDefaultValue != null && varDefaultValue.kind !== kinds/* Kind.NULL */.h.NULL;
    const hasLocationDefaultValue = locationDefaultValue !== undefined;

    if (!hasNonNullVariableDefaultValue && !hasLocationDefaultValue) {
      return false;
    }

    const nullableLocationType = locationType.ofType;
    return isTypeSubTypeOf(schema, varType, nullableLocationType);
  }

  return isTypeSubTypeOf(schema, varType, locationType);
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/specifiedRules.mjs
// Spec Section: "Executable Definitions"
 // Spec Section: "Field Selections on Objects, Interfaces, and Unions Types"

 // Spec Section: "Fragments on Composite Types"

 // Spec Section: "Argument Names"

 // Spec Section: "Directives Are Defined"

 // Spec Section: "Fragment spread target defined"

 // Spec Section: "Fragment Spread Type Existence"

 // Spec Section: "Lone Anonymous Operation"

 // SDL-specific validation rules

 // TODO: Spec Section

 // Spec Section: "Fragments must not form cycles"

 // Spec Section: "All Variable Used Defined"

 // Spec Section: "Fragments must be used"

 // Spec Section: "All Variables Used"

 // Spec Section: "Field Selection Merging"

 // Spec Section: "Fragment spread is possible"


 // Spec Section: "Argument Optionality"

 // Spec Section: "Leaf Field Selections"

 // Spec Section: "Subscriptions with Single Root Field"


 // Spec Section: "Argument Uniqueness"


 // Spec Section: "Directives Are Unique Per Location"



 // Spec Section: "Fragment Name Uniqueness"

 // Spec Section: "Input Object Field Uniqueness"

 // Spec Section: "Operation Name Uniqueness"



 // Spec Section: "Variable Uniqueness"

 // Spec Section: "Value Type Correctness"

 // Spec Section: "Variables are Input Types"

 // Spec Section: "All Variable Usages Are Allowed"



/**
 * Technically these aren't part of the spec but they are strongly encouraged
 * validation rules.
 */
const recommendedRules = Object.freeze([MaxIntrospectionDepthRule]);
/**
 * This set includes all validation rules defined by the GraphQL spec.
 *
 * The order of the rules in this list has been adjusted to lead to the
 * most clear output when encountering multiple validation errors.
 */

const specifiedRules = Object.freeze([
  ExecutableDefinitionsRule,
  UniqueOperationNamesRule,
  LoneAnonymousOperationRule,
  SingleFieldSubscriptionsRule,
  KnownTypeNamesRule,
  FragmentsOnCompositeTypesRule,
  VariablesAreInputTypesRule,
  ScalarLeafsRule,
  FieldsOnCorrectTypeRule,
  UniqueFragmentNamesRule,
  KnownFragmentNamesRule,
  NoUnusedFragmentsRule,
  PossibleFragmentSpreadsRule,
  NoFragmentCyclesRule,
  UniqueVariableNamesRule,
  NoUndefinedVariablesRule,
  NoUnusedVariablesRule,
  KnownDirectivesRule,
  UniqueDirectivesPerLocationRule,
  KnownArgumentNamesRule,
  UniqueArgumentNamesRule,
  ValuesOfCorrectTypeRule,
  ProvidedRequiredArgumentsRule,
  VariablesInAllowedPositionRule,
  OverlappingFieldsCanBeMergedRule,
  UniqueInputFieldNamesRule,
  ...recommendedRules,
]);
/**
 * @internal
 */

const specifiedSDLRules = Object.freeze([
  LoneSchemaDefinitionRule,
  UniqueOperationTypesRule,
  UniqueTypeNamesRule,
  UniqueEnumValueNamesRule,
  UniqueFieldDefinitionNamesRule,
  UniqueArgumentDefinitionNamesRule,
  UniqueDirectiveNamesRule,
  KnownTypeNamesRule,
  KnownDirectivesRule,
  UniqueDirectivesPerLocationRule,
  PossibleTypeExtensionsRule,
  KnownArgumentNamesOnDirectivesRule,
  UniqueArgumentNamesRule,
  UniqueInputFieldNamesRule,
  ProvidedRequiredArgumentsOnDirectivesRule,
]);

;// CONCATENATED MODULE: ../node_modules/graphql/validation/ValidationContext.mjs




/**
 * An instance of this class is passed as the "this" context to all validators,
 * allowing access to commonly useful contextual information from within a
 * validation rule.
 */
class ASTValidationContext {
  constructor(ast, onError) {
    this._ast = ast;
    this._fragments = undefined;
    this._fragmentSpreads = new Map();
    this._recursivelyReferencedFragments = new Map();
    this._onError = onError;
  }

  get [Symbol.toStringTag]() {
    return 'ASTValidationContext';
  }

  reportError(error) {
    this._onError(error);
  }

  getDocument() {
    return this._ast;
  }

  getFragment(name) {
    let fragments;

    if (this._fragments) {
      fragments = this._fragments;
    } else {
      fragments = Object.create(null);

      for (const defNode of this.getDocument().definitions) {
        if (defNode.kind === kinds/* Kind.FRAGMENT_DEFINITION */.h.FRAGMENT_DEFINITION) {
          fragments[defNode.name.value] = defNode;
        }
      }

      this._fragments = fragments;
    }

    return fragments[name];
  }

  getFragmentSpreads(node) {
    let spreads = this._fragmentSpreads.get(node);

    if (!spreads) {
      spreads = [];
      const setsToVisit = [node];
      let set;

      while ((set = setsToVisit.pop())) {
        for (const selection of set.selections) {
          if (selection.kind === kinds/* Kind.FRAGMENT_SPREAD */.h.FRAGMENT_SPREAD) {
            spreads.push(selection);
          } else if (selection.selectionSet) {
            setsToVisit.push(selection.selectionSet);
          }
        }
      }

      this._fragmentSpreads.set(node, spreads);
    }

    return spreads;
  }

  getRecursivelyReferencedFragments(operation) {
    let fragments = this._recursivelyReferencedFragments.get(operation);

    if (!fragments) {
      fragments = [];
      const collectedNames = Object.create(null);
      const nodesToVisit = [operation.selectionSet];
      let node;

      while ((node = nodesToVisit.pop())) {
        for (const spread of this.getFragmentSpreads(node)) {
          const fragName = spread.name.value;

          if (collectedNames[fragName] !== true) {
            collectedNames[fragName] = true;
            const fragment = this.getFragment(fragName);

            if (fragment) {
              fragments.push(fragment);
              nodesToVisit.push(fragment.selectionSet);
            }
          }
        }
      }

      this._recursivelyReferencedFragments.set(operation, fragments);
    }

    return fragments;
  }
}
class SDLValidationContext extends ASTValidationContext {
  constructor(ast, schema, onError) {
    super(ast, onError);
    this._schema = schema;
  }

  get [Symbol.toStringTag]() {
    return 'SDLValidationContext';
  }

  getSchema() {
    return this._schema;
  }
}
class ValidationContext extends ASTValidationContext {
  constructor(schema, ast, typeInfo, onError) {
    super(ast, onError);
    this._schema = schema;
    this._typeInfo = typeInfo;
    this._variableUsages = new Map();
    this._recursiveVariableUsages = new Map();
  }

  get [Symbol.toStringTag]() {
    return 'ValidationContext';
  }

  getSchema() {
    return this._schema;
  }

  getVariableUsages(node) {
    let usages = this._variableUsages.get(node);

    if (!usages) {
      const newUsages = [];
      const typeInfo = new TypeInfo(this._schema);
      visit(
        node,
        visitWithTypeInfo(typeInfo, {
          VariableDefinition: () => false,

          Variable(variable) {
            newUsages.push({
              node: variable,
              type: typeInfo.getInputType(),
              defaultValue: typeInfo.getDefaultValue(),
            });
          },
        }),
      );
      usages = newUsages;

      this._variableUsages.set(node, usages);
    }

    return usages;
  }

  getRecursiveVariableUsages(operation) {
    let usages = this._recursiveVariableUsages.get(operation);

    if (!usages) {
      usages = this.getVariableUsages(operation);

      for (const frag of this.getRecursivelyReferencedFragments(operation)) {
        usages = usages.concat(this.getVariableUsages(frag));
      }

      this._recursiveVariableUsages.set(operation, usages);
    }

    return usages;
  }

  getType() {
    return this._typeInfo.getType();
  }

  getParentType() {
    return this._typeInfo.getParentType();
  }

  getInputType() {
    return this._typeInfo.getInputType();
  }

  getParentInputType() {
    return this._typeInfo.getParentInputType();
  }

  getFieldDef() {
    return this._typeInfo.getFieldDef();
  }

  getDirective() {
    return this._typeInfo.getDirective();
  }

  getArgument() {
    return this._typeInfo.getArgument();
  }

  getEnumValue() {
    return this._typeInfo.getEnumValue();
  }
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/validate.mjs







/**
 * Implements the "Validation" section of the spec.
 *
 * Validation runs synchronously, returning an array of encountered errors, or
 * an empty array if no errors were encountered and the document is valid.
 *
 * A list of specific validation rules may be provided. If not provided, the
 * default list of rules defined by the GraphQL specification will be used.
 *
 * Each validation rules is a function which returns a visitor
 * (see the language/visitor API). Visitor methods are expected to return
 * GraphQLErrors, or Arrays of GraphQLErrors when invalid.
 *
 * Validate will stop validation after a `maxErrors` limit has been reached.
 * Attackers can send pathologically invalid queries to induce a DoS attack,
 * so by default `maxErrors` set to 100 errors.
 *
 * Optionally a custom TypeInfo instance may be provided. If not provided, one
 * will be created from the provided schema.
 */

function validate(
  schema,
  documentAST,
  rules = specifiedRules,
  options,
  /** @deprecated will be removed in 17.0.0 */
  typeInfo = new TypeInfo(schema),
) {
  var _options$maxErrors;

  const maxErrors =
    (_options$maxErrors =
      options === null || options === void 0 ? void 0 : options.maxErrors) !==
      null && _options$maxErrors !== void 0
      ? _options$maxErrors
      : 100;
  documentAST || (0,devAssert/* devAssert */.a)(false, 'Must provide document.'); // If the schema used for validation is invalid, throw an error.

  assertValidSchema(schema);
  const abortObj = Object.freeze({});
  const errors = [];
  const context = new ValidationContext(
    schema,
    documentAST,
    typeInfo,
    (error) => {
      if (errors.length >= maxErrors) {
        errors.push(
          new GraphQLError/* GraphQLError */.__(
            'Too many validation errors, error limit reached. Validation aborted.',
          ),
        ); // eslint-disable-next-line @typescript-eslint/no-throw-literal

        throw abortObj;
      }

      errors.push(error);
    },
  ); // This uses a specialized visitor which runs multiple visitors in parallel,
  // while maintaining the visitor skip and break API.

  const visitor = visitInParallel(rules.map((rule) => rule(context))); // Visit the whole document with each instance of all provided rules.

  try {
    visit(documentAST, visitWithTypeInfo(typeInfo, visitor));
  } catch (e) {
    if (e !== abortObj) {
      throw e;
    }
  }

  return errors;
}
/**
 * @internal
 */

function validateSDL(
  documentAST,
  schemaToExtend,
  rules = specifiedSDLRules,
) {
  const errors = [];
  const context = new SDLValidationContext(
    documentAST,
    schemaToExtend,
    (error) => {
      errors.push(error);
    },
  );
  const visitors = rules.map((rule) => rule(context));
  visit(documentAST, visitInParallel(visitors));
  return errors;
}
/**
 * Utility function which asserts a SDL document is valid by throwing an error
 * if it is invalid.
 *
 * @internal
 */

function assertValidSDL(documentAST) {
  const errors = validateSDL(documentAST);

  if (errors.length !== 0) {
    throw new Error(errors.map((error) => error.message).join('\n\n'));
  }
}
/**
 * Utility function which asserts a SDL document is valid by throwing an error
 * if it is invalid.
 *
 * @internal
 */

function assertValidSDLExtension(documentAST, schema) {
  const errors = validateSDL(documentAST, schema);

  if (errors.length !== 0) {
    throw new Error(errors.map((error) => error.message).join('\n\n'));
  }
}

;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/memoize3.mjs
/**
 * Memoizes the provided three-argument function.
 */
function memoize3(fn) {
  let cache0;
  return function memoized(a1, a2, a3) {
    if (cache0 === undefined) {
      cache0 = new WeakMap();
    }

    let cache1 = cache0.get(a1);

    if (cache1 === undefined) {
      cache1 = new WeakMap();
      cache0.set(a1, cache1);
    }

    let cache2 = cache1.get(a2);

    if (cache2 === undefined) {
      cache2 = new WeakMap();
      cache1.set(a2, cache2);
    }

    let fnResult = cache2.get(a3);

    if (fnResult === undefined) {
      fnResult = fn(a1, a2, a3);
      cache2.set(a3, fnResult);
    }

    return fnResult;
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/promiseForObject.mjs
/**
 * This function transforms a JS object `ObjMap<Promise<T>>` into
 * a `Promise<ObjMap<T>>`
 *
 * This is akin to bluebird's `Promise.props`, but implemented only using
 * `Promise.all` so it will work with any implementation of ES6 promises.
 */
function promiseForObject(object) {
  return Promise.all(Object.values(object)).then((resolvedValues) => {
    const resolvedObject = Object.create(null);

    for (const [i, key] of Object.keys(object).entries()) {
      resolvedObject[key] = resolvedValues[i];
    }

    return resolvedObject;
  });
}

;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/promiseReduce.mjs


/**
 * Similar to Array.prototype.reduce(), however the reducing callback may return
 * a Promise, in which case reduction will continue after each promise resolves.
 *
 * If the callback does not return a Promise, then this function will also not
 * return a Promise.
 */
function promiseReduce(values, callbackFn, initialValue) {
  let accumulator = initialValue;

  for (const value of values) {
    accumulator = isPromise(accumulator)
      ? accumulator.then((resolved) => callbackFn(resolved, value))
      : callbackFn(accumulator, value);
  }

  return accumulator;
}

;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/toError.mjs

/**
 * Sometimes a non-error is thrown, wrap it as an Error instance to ensure a consistent Error interface.
 */

function toError(thrownValue) {
  return thrownValue instanceof Error
    ? thrownValue
    : new NonErrorThrown(thrownValue);
}

class NonErrorThrown extends Error {
  constructor(thrownValue) {
    super('Unexpected error value: ' + (0,inspect/* inspect */.X)(thrownValue));
    this.name = 'NonErrorThrown';
    this.thrownValue = thrownValue;
  }
}

;// CONCATENATED MODULE: ../node_modules/graphql/error/locatedError.mjs


/**
 * Given an arbitrary value, presumably thrown while attempting to execute a
 * GraphQL operation, produce a new GraphQLError aware of the location in the
 * document responsible for the original Error.
 */

function locatedError(rawOriginalError, nodes, path) {
  var _nodes;

  const originalError = toError(rawOriginalError); // Note: this uses a brand-check to support GraphQL errors originating from other contexts.

  if (isLocatedGraphQLError(originalError)) {
    return originalError;
  }

  return new GraphQLError/* GraphQLError */.__(originalError.message, {
    nodes:
      (_nodes = originalError.nodes) !== null && _nodes !== void 0
        ? _nodes
        : nodes,
    source: originalError.source,
    positions: originalError.positions,
    path,
    originalError,
  });
}

function isLocatedGraphQLError(error) {
  return Array.isArray(error.path);
}

;// CONCATENATED MODULE: ../node_modules/graphql/execution/execute.mjs



















/**
 * A memoized collection of relevant subfields with regard to the return
 * type. Memoizing ensures the subfields are not repeatedly calculated, which
 * saves overhead when resolving lists of values.
 */

const execute_collectSubfields = memoize3((exeContext, returnType, fieldNodes) =>
  collectSubfields(
    exeContext.schema,
    exeContext.fragments,
    exeContext.variableValues,
    returnType,
    fieldNodes,
  ),
);
/**
 * Terminology
 *
 * "Definitions" are the generic name for top-level statements in the document.
 * Examples of this include:
 * 1) Operations (such as a query)
 * 2) Fragments
 *
 * "Operations" are a generic name for requests in the document.
 * Examples of this include:
 * 1) query,
 * 2) mutation
 *
 * "Selections" are the definitions that can appear legally and at
 * single level of the query. These include:
 * 1) field references e.g `a`
 * 2) fragment "spreads" e.g. `...c`
 * 3) inline fragment "spreads" e.g. `...on Type { a }`
 */

/**
 * Data that must be available at all points during query execution.
 *
 * Namely, schema of the type system that is currently executing,
 * and the fragments defined in the query document
 */

/**
 * Implements the "Executing requests" section of the GraphQL specification.
 *
 * Returns either a synchronous ExecutionResult (if all encountered resolvers
 * are synchronous), or a Promise of an ExecutionResult that will eventually be
 * resolved and never rejected.
 *
 * If the arguments to this function do not result in a legal execution context,
 * a GraphQLError will be thrown immediately explaining the invalid input.
 */
function execute(args) {
  // Temporary for v15 to v16 migration. Remove in v17
  arguments.length < 2 ||
    (0,devAssert/* devAssert */.a)(
      false,
      'graphql@16 dropped long-deprecated support for positional arguments, please pass an object instead.',
    );
  const { schema, document, variableValues, rootValue } = args; // If arguments are missing or incorrect, throw an error.

  assertValidExecutionArguments(schema, document, variableValues); // If a valid execution context cannot be created due to incorrect arguments,
  // a "Response" with only errors is returned.

  const exeContext = buildExecutionContext(args); // Return early errors if execution context failed.

  if (!('schema' in exeContext)) {
    return {
      errors: exeContext,
    };
  } // Return a Promise that will eventually resolve to the data described by
  // The "Response" section of the GraphQL specification.
  //
  // If errors are encountered while executing a GraphQL field, only that
  // field and its descendants will be omitted, and sibling fields will still
  // be executed. An execution which encounters errors will still result in a
  // resolved Promise.
  //
  // Errors from sub-fields of a NonNull type may propagate to the top level,
  // at which point we still log the error and null the parent field, which
  // in this case is the entire response.

  try {
    const { operation } = exeContext;
    const result = executeOperation(exeContext, operation, rootValue);

    if (isPromise(result)) {
      return result.then(
        (data) => buildResponse(data, exeContext.errors),
        (error) => {
          exeContext.errors.push(error);
          return buildResponse(null, exeContext.errors);
        },
      );
    }

    return buildResponse(result, exeContext.errors);
  } catch (error) {
    exeContext.errors.push(error);
    return buildResponse(null, exeContext.errors);
  }
}
/**
 * Also implements the "Executing requests" section of the GraphQL specification.
 * However, it guarantees to complete synchronously (or throw an error) assuming
 * that all field resolvers are also synchronous.
 */

function executeSync(args) {
  const result = execute(args); // Assert that the execution was synchronous.

  if (isPromise(result)) {
    throw new Error('GraphQL execution failed to complete synchronously.');
  }

  return result;
}
/**
 * Given a completed execution context and data, build the `{ errors, data }`
 * response defined by the "Response" section of the GraphQL specification.
 */

function buildResponse(data, errors) {
  return errors.length === 0
    ? {
        data,
      }
    : {
        errors,
        data,
      };
}
/**
 * Essential assertions before executing to provide developer feedback for
 * improper use of the GraphQL library.
 *
 * @internal
 */

function assertValidExecutionArguments(
  schema,
  document,
  rawVariableValues,
) {
  document || (0,devAssert/* devAssert */.a)(false, 'Must provide document.'); // If the schema used for execution is invalid, throw an error.

  assertValidSchema(schema); // Variables, if provided, must be an object.

  rawVariableValues == null ||
    (0,isObjectLike/* isObjectLike */.y)(rawVariableValues) ||
    (0,devAssert/* devAssert */.a)(
      false,
      'Variables must be provided as an Object where each property is a variable value. Perhaps look to see if an unparsed JSON string was provided.',
    );
}
/**
 * Constructs a ExecutionContext object from the arguments passed to
 * execute, which we will pass throughout the other execution methods.
 *
 * Throws a GraphQLError if a valid execution context cannot be created.
 *
 * @internal
 */

function buildExecutionContext(args) {
  var _definition$name, _operation$variableDe;

  const {
    schema,
    document,
    rootValue,
    contextValue,
    variableValues: rawVariableValues,
    operationName,
    fieldResolver,
    typeResolver,
    subscribeFieldResolver,
  } = args;
  let operation;
  const fragments = Object.create(null);

  for (const definition of document.definitions) {
    switch (definition.kind) {
      case kinds/* Kind.OPERATION_DEFINITION */.h.OPERATION_DEFINITION:
        if (operationName == null) {
          if (operation !== undefined) {
            return [
              new GraphQLError/* GraphQLError */.__(
                'Must provide operation name if query contains multiple operations.',
              ),
            ];
          }

          operation = definition;
        } else if (
          ((_definition$name = definition.name) === null ||
          _definition$name === void 0
            ? void 0
            : _definition$name.value) === operationName
        ) {
          operation = definition;
        }

        break;

      case kinds/* Kind.FRAGMENT_DEFINITION */.h.FRAGMENT_DEFINITION:
        fragments[definition.name.value] = definition;
        break;

      default: // ignore non-executable definitions
    }
  }

  if (!operation) {
    if (operationName != null) {
      return [new GraphQLError/* GraphQLError */.__(`Unknown operation named "${operationName}".`)];
    }

    return [new GraphQLError/* GraphQLError */.__('Must provide an operation.')];
  } // FIXME: https://github.com/graphql/graphql-js/issues/2203

  /* c8 ignore next */

  const variableDefinitions =
    (_operation$variableDe = operation.variableDefinitions) !== null &&
    _operation$variableDe !== void 0
      ? _operation$variableDe
      : [];
  const coercedVariableValues = getVariableValues(
    schema,
    variableDefinitions,
    rawVariableValues !== null && rawVariableValues !== void 0
      ? rawVariableValues
      : {},
    {
      maxErrors: 50,
    },
  );

  if (coercedVariableValues.errors) {
    return coercedVariableValues.errors;
  }

  return {
    schema,
    fragments,
    rootValue,
    contextValue,
    operation,
    variableValues: coercedVariableValues.coerced,
    fieldResolver:
      fieldResolver !== null && fieldResolver !== void 0
        ? fieldResolver
        : defaultFieldResolver,
    typeResolver:
      typeResolver !== null && typeResolver !== void 0
        ? typeResolver
        : defaultTypeResolver,
    subscribeFieldResolver:
      subscribeFieldResolver !== null && subscribeFieldResolver !== void 0
        ? subscribeFieldResolver
        : defaultFieldResolver,
    errors: [],
  };
}
/**
 * Implements the "Executing operations" section of the spec.
 */

function executeOperation(exeContext, operation, rootValue) {
  const rootType = exeContext.schema.getRootType(operation.operation);

  if (rootType == null) {
    throw new GraphQLError/* GraphQLError */.__(
      `Schema is not configured to execute ${operation.operation} operation.`,
      {
        nodes: operation,
      },
    );
  }

  const rootFields = collectFields(
    exeContext.schema,
    exeContext.fragments,
    exeContext.variableValues,
    rootType,
    operation.selectionSet,
  );
  const path = undefined;

  switch (operation.operation) {
    case ast/* OperationTypeNode.QUERY */.ku.QUERY:
      return executeFields(exeContext, rootType, rootValue, path, rootFields);

    case ast/* OperationTypeNode.MUTATION */.ku.MUTATION:
      return executeFieldsSerially(
        exeContext,
        rootType,
        rootValue,
        path,
        rootFields,
      );

    case ast/* OperationTypeNode.SUBSCRIPTION */.ku.SUBSCRIPTION:
      // TODO: deprecate `subscribe` and move all logic here
      // Temporary solution until we finish merging execute and subscribe together
      return executeFields(exeContext, rootType, rootValue, path, rootFields);
  }
}
/**
 * Implements the "Executing selection sets" section of the spec
 * for fields that must be executed serially.
 */

function executeFieldsSerially(
  exeContext,
  parentType,
  sourceValue,
  path,
  fields,
) {
  return promiseReduce(
    fields.entries(),
    (results, [responseName, fieldNodes]) => {
      const fieldPath = addPath(path, responseName, parentType.name);
      const result = executeField(
        exeContext,
        parentType,
        sourceValue,
        fieldNodes,
        fieldPath,
      );

      if (result === undefined) {
        return results;
      }

      if (isPromise(result)) {
        return result.then((resolvedResult) => {
          results[responseName] = resolvedResult;
          return results;
        });
      }

      results[responseName] = result;
      return results;
    },
    Object.create(null),
  );
}
/**
 * Implements the "Executing selection sets" section of the spec
 * for fields that may be executed in parallel.
 */

function executeFields(exeContext, parentType, sourceValue, path, fields) {
  const results = Object.create(null);
  let containsPromise = false;

  try {
    for (const [responseName, fieldNodes] of fields.entries()) {
      const fieldPath = addPath(path, responseName, parentType.name);
      const result = executeField(
        exeContext,
        parentType,
        sourceValue,
        fieldNodes,
        fieldPath,
      );

      if (result !== undefined) {
        results[responseName] = result;

        if (isPromise(result)) {
          containsPromise = true;
        }
      }
    }
  } catch (error) {
    if (containsPromise) {
      // Ensure that any promises returned by other fields are handled, as they may also reject.
      return promiseForObject(results).finally(() => {
        throw error;
      });
    }

    throw error;
  } // If there are no promises, we can just return the object

  if (!containsPromise) {
    return results;
  } // Otherwise, results is a map from field name to the result of resolving that
  // field, which is possibly a promise. Return a promise that will return this
  // same map, but with any promises replaced with the values they resolved to.

  return promiseForObject(results);
}
/**
 * Implements the "Executing fields" section of the spec
 * In particular, this function figures out the value that the field returns by
 * calling its resolve function, then calls completeValue to complete promises,
 * serialize scalars, or execute the sub-selection-set for objects.
 */

function executeField(exeContext, parentType, source, fieldNodes, path) {
  var _fieldDef$resolve;

  const fieldDef = execute_getFieldDef(exeContext.schema, parentType, fieldNodes[0]);

  if (!fieldDef) {
    return;
  }

  const returnType = fieldDef.type;
  const resolveFn =
    (_fieldDef$resolve = fieldDef.resolve) !== null &&
    _fieldDef$resolve !== void 0
      ? _fieldDef$resolve
      : exeContext.fieldResolver;
  const info = buildResolveInfo(
    exeContext,
    fieldDef,
    fieldNodes,
    parentType,
    path,
  ); // Get the resolve function, regardless of if its result is normal or abrupt (error).

  try {
    // Build a JS object of arguments from the field.arguments AST, using the
    // variables scope to fulfill any variable references.
    // TODO: find a way to memoize, in case this field is within a List type.
    const args = getArgumentValues(
      fieldDef,
      fieldNodes[0],
      exeContext.variableValues,
    ); // The resolve function's optional third argument is a context value that
    // is provided to every resolve function within an execution. It is commonly
    // used to represent an authenticated user, or request-specific caches.

    const contextValue = exeContext.contextValue;
    const result = resolveFn(source, args, contextValue, info);
    let completed;

    if (isPromise(result)) {
      completed = result.then((resolved) =>
        completeValue(exeContext, returnType, fieldNodes, info, path, resolved),
      );
    } else {
      completed = completeValue(
        exeContext,
        returnType,
        fieldNodes,
        info,
        path,
        result,
      );
    }

    if (isPromise(completed)) {
      // Note: we don't rely on a `catch` method, but we do expect "thenable"
      // to take a second callback for the error case.
      return completed.then(undefined, (rawError) => {
        const error = locatedError(rawError, fieldNodes, pathToArray(path));
        return handleFieldError(error, returnType, exeContext);
      });
    }

    return completed;
  } catch (rawError) {
    const error = locatedError(rawError, fieldNodes, pathToArray(path));
    return handleFieldError(error, returnType, exeContext);
  }
}
/**
 * @internal
 */

function buildResolveInfo(
  exeContext,
  fieldDef,
  fieldNodes,
  parentType,
  path,
) {
  // The resolve function's optional fourth argument is a collection of
  // information about the current execution state.
  return {
    fieldName: fieldDef.name,
    fieldNodes,
    returnType: fieldDef.type,
    parentType,
    path,
    schema: exeContext.schema,
    fragments: exeContext.fragments,
    rootValue: exeContext.rootValue,
    operation: exeContext.operation,
    variableValues: exeContext.variableValues,
  };
}

function handleFieldError(error, returnType, exeContext) {
  // If the field type is non-nullable, then it is resolved without any
  // protection from errors, however it still properly locates the error.
  if (isNonNullType(returnType)) {
    throw error;
  } // Otherwise, error protection is applied, logging the error and resolving
  // a null value for this field if one is encountered.

  exeContext.errors.push(error);
  return null;
}
/**
 * Implements the instructions for completeValue as defined in the
 * "Value Completion" section of the spec.
 *
 * If the field type is Non-Null, then this recursively completes the value
 * for the inner type. It throws a field error if that completion returns null,
 * as per the "Nullability" section of the spec.
 *
 * If the field type is a List, then this recursively completes the value
 * for the inner type on each item in the list.
 *
 * If the field type is a Scalar or Enum, ensures the completed value is a legal
 * value of the type by calling the `serialize` method of GraphQL type
 * definition.
 *
 * If the field is an abstract type, determine the runtime type of the value
 * and then complete based on that type
 *
 * Otherwise, the field type expects a sub-selection set, and will complete the
 * value by executing all sub-selections.
 */

function completeValue(exeContext, returnType, fieldNodes, info, path, result) {
  // If result is an Error, throw a located error.
  if (result instanceof Error) {
    throw result;
  } // If field type is NonNull, complete for inner type, and throw field error
  // if result is null.

  if (isNonNullType(returnType)) {
    const completed = completeValue(
      exeContext,
      returnType.ofType,
      fieldNodes,
      info,
      path,
      result,
    );

    if (completed === null) {
      throw new Error(
        `Cannot return null for non-nullable field ${info.parentType.name}.${info.fieldName}.`,
      );
    }

    return completed;
  } // If result value is null or undefined then return null.

  if (result == null) {
    return null;
  } // If field type is List, complete each item in the list with the inner type

  if (isListType(returnType)) {
    return completeListValue(
      exeContext,
      returnType,
      fieldNodes,
      info,
      path,
      result,
    );
  } // If field type is a leaf type, Scalar or Enum, serialize to a valid value,
  // returning null if serialization is not possible.

  if (isLeafType(returnType)) {
    return completeLeafValue(returnType, result);
  } // If field type is an abstract type, Interface or Union, determine the
  // runtime Object type and complete for that type.

  if (isAbstractType(returnType)) {
    return completeAbstractValue(
      exeContext,
      returnType,
      fieldNodes,
      info,
      path,
      result,
    );
  } // If field type is Object, execute and complete all sub-selections.

  if (isObjectType(returnType)) {
    return completeObjectValue(
      exeContext,
      returnType,
      fieldNodes,
      info,
      path,
      result,
    );
  }
  /* c8 ignore next 6 */
  // Not reachable, all possible output types have been considered.

   false ||
    (0,invariant/* invariant */.k)(
      false,
      'Cannot complete value of unexpected output type: ' + (0,inspect/* inspect */.X)(returnType),
    );
}
/**
 * Complete a list value by completing each item in the list with the
 * inner type
 */

function completeListValue(
  exeContext,
  returnType,
  fieldNodes,
  info,
  path,
  result,
) {
  if (!isIterableObject(result)) {
    throw new GraphQLError/* GraphQLError */.__(
      `Expected Iterable, but did not find one for field "${info.parentType.name}.${info.fieldName}".`,
    );
  } // This is specified as a simple map, however we're optimizing the path
  // where the list contains no Promises by avoiding creating another Promise.

  const itemType = returnType.ofType;
  let containsPromise = false;
  const completedResults = Array.from(result, (item, index) => {
    // No need to modify the info object containing the path,
    // since from here on it is not ever accessed by resolver functions.
    const itemPath = addPath(path, index, undefined);

    try {
      let completedItem;

      if (isPromise(item)) {
        completedItem = item.then((resolved) =>
          completeValue(
            exeContext,
            itemType,
            fieldNodes,
            info,
            itemPath,
            resolved,
          ),
        );
      } else {
        completedItem = completeValue(
          exeContext,
          itemType,
          fieldNodes,
          info,
          itemPath,
          item,
        );
      }

      if (isPromise(completedItem)) {
        containsPromise = true; // Note: we don't rely on a `catch` method, but we do expect "thenable"
        // to take a second callback for the error case.

        return completedItem.then(undefined, (rawError) => {
          const error = locatedError(
            rawError,
            fieldNodes,
            pathToArray(itemPath),
          );
          return handleFieldError(error, itemType, exeContext);
        });
      }

      return completedItem;
    } catch (rawError) {
      const error = locatedError(rawError, fieldNodes, pathToArray(itemPath));
      return handleFieldError(error, itemType, exeContext);
    }
  });
  return containsPromise ? Promise.all(completedResults) : completedResults;
}
/**
 * Complete a Scalar or Enum by serializing to a valid value, returning
 * null if serialization is not possible.
 */

function completeLeafValue(returnType, result) {
  const serializedResult = returnType.serialize(result);

  if (serializedResult == null) {
    throw new Error(
      `Expected \`${(0,inspect/* inspect */.X)(returnType)}.serialize(${(0,inspect/* inspect */.X)(result)})\` to ` +
        `return non-nullable value, returned: ${(0,inspect/* inspect */.X)(serializedResult)}`,
    );
  }

  return serializedResult;
}
/**
 * Complete a value of an abstract type by determining the runtime object type
 * of that value, then complete the value for that type.
 */

function completeAbstractValue(
  exeContext,
  returnType,
  fieldNodes,
  info,
  path,
  result,
) {
  var _returnType$resolveTy;

  const resolveTypeFn =
    (_returnType$resolveTy = returnType.resolveType) !== null &&
    _returnType$resolveTy !== void 0
      ? _returnType$resolveTy
      : exeContext.typeResolver;
  const contextValue = exeContext.contextValue;
  const runtimeType = resolveTypeFn(result, contextValue, info, returnType);

  if (isPromise(runtimeType)) {
    return runtimeType.then((resolvedRuntimeType) =>
      completeObjectValue(
        exeContext,
        ensureValidRuntimeType(
          resolvedRuntimeType,
          exeContext,
          returnType,
          fieldNodes,
          info,
          result,
        ),
        fieldNodes,
        info,
        path,
        result,
      ),
    );
  }

  return completeObjectValue(
    exeContext,
    ensureValidRuntimeType(
      runtimeType,
      exeContext,
      returnType,
      fieldNodes,
      info,
      result,
    ),
    fieldNodes,
    info,
    path,
    result,
  );
}

function ensureValidRuntimeType(
  runtimeTypeName,
  exeContext,
  returnType,
  fieldNodes,
  info,
  result,
) {
  if (runtimeTypeName == null) {
    throw new GraphQLError/* GraphQLError */.__(
      `Abstract type "${returnType.name}" must resolve to an Object type at runtime for field "${info.parentType.name}.${info.fieldName}". Either the "${returnType.name}" type should provide a "resolveType" function or each possible type should provide an "isTypeOf" function.`,
      fieldNodes,
    );
  } // releases before 16.0.0 supported returning `GraphQLObjectType` from `resolveType`
  // TODO: remove in 17.0.0 release

  if (isObjectType(runtimeTypeName)) {
    throw new GraphQLError/* GraphQLError */.__(
      'Support for returning GraphQLObjectType from resolveType was removed in graphql-js@16.0.0 please return type name instead.',
    );
  }

  if (typeof runtimeTypeName !== 'string') {
    throw new GraphQLError/* GraphQLError */.__(
      `Abstract type "${returnType.name}" must resolve to an Object type at runtime for field "${info.parentType.name}.${info.fieldName}" with ` +
        `value ${(0,inspect/* inspect */.X)(result)}, received "${(0,inspect/* inspect */.X)(runtimeTypeName)}".`,
    );
  }

  const runtimeType = exeContext.schema.getType(runtimeTypeName);

  if (runtimeType == null) {
    throw new GraphQLError/* GraphQLError */.__(
      `Abstract type "${returnType.name}" was resolved to a type "${runtimeTypeName}" that does not exist inside the schema.`,
      {
        nodes: fieldNodes,
      },
    );
  }

  if (!isObjectType(runtimeType)) {
    throw new GraphQLError/* GraphQLError */.__(
      `Abstract type "${returnType.name}" was resolved to a non-object type "${runtimeTypeName}".`,
      {
        nodes: fieldNodes,
      },
    );
  }

  if (!exeContext.schema.isSubType(returnType, runtimeType)) {
    throw new GraphQLError/* GraphQLError */.__(
      `Runtime Object type "${runtimeType.name}" is not a possible type for "${returnType.name}".`,
      {
        nodes: fieldNodes,
      },
    );
  }

  return runtimeType;
}
/**
 * Complete an Object value by executing all sub-selections.
 */

function completeObjectValue(
  exeContext,
  returnType,
  fieldNodes,
  info,
  path,
  result,
) {
  // Collect sub-fields to execute to complete this value.
  const subFieldNodes = execute_collectSubfields(exeContext, returnType, fieldNodes); // If there is an isTypeOf predicate function, call it with the
  // current result. If isTypeOf returns false, then raise an error rather
  // than continuing execution.

  if (returnType.isTypeOf) {
    const isTypeOf = returnType.isTypeOf(result, exeContext.contextValue, info);

    if (isPromise(isTypeOf)) {
      return isTypeOf.then((resolvedIsTypeOf) => {
        if (!resolvedIsTypeOf) {
          throw invalidReturnTypeError(returnType, result, fieldNodes);
        }

        return executeFields(
          exeContext,
          returnType,
          result,
          path,
          subFieldNodes,
        );
      });
    }

    if (!isTypeOf) {
      throw invalidReturnTypeError(returnType, result, fieldNodes);
    }
  }

  return executeFields(exeContext, returnType, result, path, subFieldNodes);
}

function invalidReturnTypeError(returnType, result, fieldNodes) {
  return new GraphQLError/* GraphQLError */.__(
    `Expected value of type "${returnType.name}" but got: ${(0,inspect/* inspect */.X)(result)}.`,
    {
      nodes: fieldNodes,
    },
  );
}
/**
 * If a resolveType function is not given, then a default resolve behavior is
 * used which attempts two strategies:
 *
 * First, See if the provided value has a `__typename` field defined, if so, use
 * that value as name of the resolved type.
 *
 * Otherwise, test each possible type for the abstract type by calling
 * isTypeOf for the object being coerced, returning the first type that matches.
 */

const defaultTypeResolver = function (
  value,
  contextValue,
  info,
  abstractType,
) {
  // First, look for `__typename`.
  if ((0,isObjectLike/* isObjectLike */.y)(value) && typeof value.__typename === 'string') {
    return value.__typename;
  } // Otherwise, test each possible type.

  const possibleTypes = info.schema.getPossibleTypes(abstractType);
  const promisedIsTypeOfResults = [];

  for (let i = 0; i < possibleTypes.length; i++) {
    const type = possibleTypes[i];

    if (type.isTypeOf) {
      const isTypeOfResult = type.isTypeOf(value, contextValue, info);

      if (isPromise(isTypeOfResult)) {
        promisedIsTypeOfResults[i] = isTypeOfResult;
      } else if (isTypeOfResult) {
        return type.name;
      }
    }
  }

  if (promisedIsTypeOfResults.length) {
    return Promise.all(promisedIsTypeOfResults).then((isTypeOfResults) => {
      for (let i = 0; i < isTypeOfResults.length; i++) {
        if (isTypeOfResults[i]) {
          return possibleTypes[i].name;
        }
      }
    });
  }
};
/**
 * If a resolve function is not given, then a default resolve behavior is used
 * which takes the property of the source object of the same name as the field
 * and returns it as the result, or if it's a function, returns the result
 * of calling that function while passing along args and context value.
 */

const defaultFieldResolver = function (
  source,
  args,
  contextValue,
  info,
) {
  // ensure source is a value for which property access is acceptable.
  if ((0,isObjectLike/* isObjectLike */.y)(source) || typeof source === 'function') {
    const property = source[info.fieldName];

    if (typeof property === 'function') {
      return source[info.fieldName](args, contextValue, info);
    }

    return property;
  }
};
/**
 * This method looks up the field on the given type definition.
 * It has special casing for the three introspection fields,
 * __schema, __type and __typename. __typename is special because
 * it can always be queried as a field, even in situations where no
 * other fields are allowed, like on a Union. __schema and __type
 * could get automatically added to the query type, but that would
 * require mutating type definitions, which would cause issues.
 *
 * @internal
 */

function execute_getFieldDef(schema, parentType, fieldNode) {
  const fieldName = fieldNode.name.value;

  if (
    fieldName === SchemaMetaFieldDef.name &&
    schema.getQueryType() === parentType
  ) {
    return SchemaMetaFieldDef;
  } else if (
    fieldName === TypeMetaFieldDef.name &&
    schema.getQueryType() === parentType
  ) {
    return TypeMetaFieldDef;
  } else if (fieldName === TypeNameMetaFieldDef.name) {
    return TypeNameMetaFieldDef;
  }

  return parentType.getFields()[fieldName];
}

;// CONCATENATED MODULE: ../node_modules/graphql/graphql.mjs






/**
 * This is the primary entry point function for fulfilling GraphQL operations
 * by parsing, validating, and executing a GraphQL document along side a
 * GraphQL schema.
 *
 * More sophisticated GraphQL servers, such as those which persist queries,
 * may wish to separate the validation and execution phases to a static time
 * tooling step, and a server runtime step.
 *
 * Accepts either an object with named arguments, or individual arguments:
 *
 * schema:
 *    The GraphQL type system to use when validating and executing a query.
 * source:
 *    A GraphQL language formatted string representing the requested operation.
 * rootValue:
 *    The value provided as the first argument to resolver functions on the top
 *    level type (e.g. the query object type).
 * contextValue:
 *    The context value is provided as an argument to resolver functions after
 *    field arguments. It is used to pass shared information useful at any point
 *    during executing this query, for example the currently logged in user and
 *    connections to databases or other services.
 * variableValues:
 *    A mapping of variable name to runtime value to use for all variables
 *    defined in the requestString.
 * operationName:
 *    The name of the operation to use if requestString contains multiple
 *    possible operations. Can be omitted if requestString contains only
 *    one operation.
 * fieldResolver:
 *    A resolver function to use when one is not provided by the schema.
 *    If not provided, the default field resolver is used (which looks for a
 *    value or method on the source value with the field's name).
 * typeResolver:
 *    A type resolver function to use when none is provided by the schema.
 *    If not provided, the default type resolver is used (which looks for a
 *    `__typename` field or alternatively calls the `isTypeOf` method).
 */

function graphql(args) {
  // Always return a Promise for a consistent API.
  return new Promise((resolve) => resolve(graphqlImpl(args)));
}
/**
 * The graphqlSync function also fulfills GraphQL operations by parsing,
 * validating, and executing a GraphQL document along side a GraphQL schema.
 * However, it guarantees to complete synchronously (or throw an error) assuming
 * that all field resolvers are also synchronous.
 */

function graphqlSync(args) {
  const result = graphqlImpl(args); // Assert that the execution was synchronous.

  if (isPromise(result)) {
    throw new Error('GraphQL execution failed to complete synchronously.');
  }

  return result;
}

function graphqlImpl(args) {
  // Temporary for v15 to v16 migration. Remove in v17
  arguments.length < 2 ||
    (0,devAssert/* devAssert */.a)(
      false,
      'graphql@16 dropped long-deprecated support for positional arguments, please pass an object instead.',
    );
  const {
    schema,
    source,
    rootValue,
    contextValue,
    variableValues,
    operationName,
    fieldResolver,
    typeResolver,
  } = args; // Validate Schema

  const schemaValidationErrors = validateSchema(schema);

  if (schemaValidationErrors.length > 0) {
    return {
      errors: schemaValidationErrors,
    };
  } // Parse

  let document;

  try {
    document = (0,parser/* parse */.Qc)(source);
  } catch (syntaxError) {
    return {
      errors: [syntaxError],
    };
  } // Validate

  const validationErrors = validate(schema, document);

  if (validationErrors.length > 0) {
    return {
      errors: validationErrors,
    };
  } // Execute

  return execute({
    schema,
    document,
    rootValue,
    contextValue,
    variableValues,
    operationName,
    fieldResolver,
    typeResolver,
  });
}

// EXTERNAL MODULE: ../node_modules/graphql/language/source.mjs
var language_source = __webpack_require__(23476);
// EXTERNAL MODULE: ../node_modules/graphql/language/location.mjs
var language_location = __webpack_require__(31472);
// EXTERNAL MODULE: ../node_modules/graphql/language/printLocation.mjs
var printLocation = __webpack_require__(56403);
// EXTERNAL MODULE: ../node_modules/graphql/language/lexer.mjs
var language_lexer = __webpack_require__(78636);
// EXTERNAL MODULE: ../node_modules/graphql/language/tokenKind.mjs
var language_tokenKind = __webpack_require__(20471);
;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/isAsyncIterable.mjs
/**
 * Returns true if the provided object implements the AsyncIterator protocol via
 * implementing a `Symbol.asyncIterator` method.
 */
function isAsyncIterable(maybeAsyncIterable) {
  return (
    typeof (maybeAsyncIterable === null || maybeAsyncIterable === void 0
      ? void 0
      : maybeAsyncIterable[Symbol.asyncIterator]) === 'function'
  );
}

;// CONCATENATED MODULE: ../node_modules/graphql/execution/mapAsyncIterator.mjs
/**
 * Given an AsyncIterable and a callback function, return an AsyncIterator
 * which produces values mapped via calling the callback function.
 */
function mapAsyncIterator(iterable, callback) {
  const iterator = iterable[Symbol.asyncIterator]();

  async function mapResult(result) {
    if (result.done) {
      return result;
    }

    try {
      return {
        value: await callback(result.value),
        done: false,
      };
    } catch (error) {
      /* c8 ignore start */
      // FIXME: add test case
      if (typeof iterator.return === 'function') {
        try {
          await iterator.return();
        } catch (_e) {
          /* ignore error */
        }
      }

      throw error;
      /* c8 ignore stop */
    }
  }

  return {
    async next() {
      return mapResult(await iterator.next());
    },

    async return() {
      // If iterator.return() does not exist, then type R must be undefined.
      return typeof iterator.return === 'function'
        ? mapResult(await iterator.return())
        : {
            value: undefined,
            done: true,
          };
    },

    async throw(error) {
      if (typeof iterator.throw === 'function') {
        return mapResult(await iterator.throw(error));
      }

      throw error;
    },

    [Symbol.asyncIterator]() {
      return this;
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/execution/subscribe.mjs










/**
 * Implements the "Subscribe" algorithm described in the GraphQL specification.
 *
 * Returns a Promise which resolves to either an AsyncIterator (if successful)
 * or an ExecutionResult (error). The promise will be rejected if the schema or
 * other arguments to this function are invalid, or if the resolved event stream
 * is not an async iterable.
 *
 * If the client-provided arguments to this function do not result in a
 * compliant subscription, a GraphQL Response (ExecutionResult) with
 * descriptive errors and no data will be returned.
 *
 * If the source stream could not be created due to faulty subscription
 * resolver logic or underlying systems, the promise will resolve to a single
 * ExecutionResult containing `errors` and no `data`.
 *
 * If the operation succeeded, the promise resolves to an AsyncIterator, which
 * yields a stream of ExecutionResults representing the response stream.
 *
 * Accepts either an object with named arguments, or individual arguments.
 */

async function subscribe(args) {
  // Temporary for v15 to v16 migration. Remove in v17
  arguments.length < 2 ||
    (0,devAssert/* devAssert */.a)(
      false,
      'graphql@16 dropped long-deprecated support for positional arguments, please pass an object instead.',
    );
  const resultOrStream = await createSourceEventStream(args);

  if (!isAsyncIterable(resultOrStream)) {
    return resultOrStream;
  } // For each payload yielded from a subscription, map it over the normal
  // GraphQL `execute` function, with `payload` as the rootValue.
  // This implements the "MapSourceToResponseEvent" algorithm described in
  // the GraphQL specification. The `execute` function provides the
  // "ExecuteSubscriptionEvent" algorithm, as it is nearly identical to the
  // "ExecuteQuery" algorithm, for which `execute` is also used.

  const mapSourceToResponse = (payload) =>
    execute({ ...args, rootValue: payload }); // Map every source value to a ExecutionResult value as described above.

  return mapAsyncIterator(resultOrStream, mapSourceToResponse);
}

function toNormalizedArgs(args) {
  const firstArg = args[0];

  if (firstArg && 'document' in firstArg) {
    return firstArg;
  }

  return {
    schema: firstArg,
    // FIXME: when underlying TS bug fixed, see https://github.com/microsoft/TypeScript/issues/31613
    document: args[1],
    rootValue: args[2],
    contextValue: args[3],
    variableValues: args[4],
    operationName: args[5],
    subscribeFieldResolver: args[6],
  };
}
/**
 * Implements the "CreateSourceEventStream" algorithm described in the
 * GraphQL specification, resolving the subscription source event stream.
 *
 * Returns a Promise which resolves to either an AsyncIterable (if successful)
 * or an ExecutionResult (error). The promise will be rejected if the schema or
 * other arguments to this function are invalid, or if the resolved event stream
 * is not an async iterable.
 *
 * If the client-provided arguments to this function do not result in a
 * compliant subscription, a GraphQL Response (ExecutionResult) with
 * descriptive errors and no data will be returned.
 *
 * If the the source stream could not be created due to faulty subscription
 * resolver logic or underlying systems, the promise will resolve to a single
 * ExecutionResult containing `errors` and no `data`.
 *
 * If the operation succeeded, the promise resolves to the AsyncIterable for the
 * event stream returned by the resolver.
 *
 * A Source Event Stream represents a sequence of events, each of which triggers
 * a GraphQL execution for that event.
 *
 * This may be useful when hosting the stateful subscription service in a
 * different process or machine than the stateless GraphQL execution engine,
 * or otherwise separating these two steps. For more on this, see the
 * "Supporting Subscriptions at Scale" information in the GraphQL specification.
 */

async function createSourceEventStream(...rawArgs) {
  const args = toNormalizedArgs(rawArgs);
  const { schema, document, variableValues } = args; // If arguments are missing or incorrectly typed, this is an internal
  // developer mistake which should throw an early error.

  assertValidExecutionArguments(schema, document, variableValues); // If a valid execution context cannot be created due to incorrect arguments,
  // a "Response" with only errors is returned.

  const exeContext = buildExecutionContext(args); // Return early errors if execution context failed.

  if (!('schema' in exeContext)) {
    return {
      errors: exeContext,
    };
  }

  try {
    const eventStream = await executeSubscription(exeContext); // Assert field returned an event stream, otherwise yield an error.

    if (!isAsyncIterable(eventStream)) {
      throw new Error(
        'Subscription field must return Async Iterable. ' +
          `Received: ${(0,inspect/* inspect */.X)(eventStream)}.`,
      );
    }

    return eventStream;
  } catch (error) {
    // If it GraphQLError, report it as an ExecutionResult, containing only errors and no data.
    // Otherwise treat the error as a system-class error and re-throw it.
    if (error instanceof GraphQLError/* GraphQLError */.__) {
      return {
        errors: [error],
      };
    }

    throw error;
  }
}

async function executeSubscription(exeContext) {
  const { schema, fragments, operation, variableValues, rootValue } =
    exeContext;
  const rootType = schema.getSubscriptionType();

  if (rootType == null) {
    throw new GraphQLError/* GraphQLError */.__(
      'Schema is not configured to execute subscription operation.',
      {
        nodes: operation,
      },
    );
  }

  const rootFields = collectFields(
    schema,
    fragments,
    variableValues,
    rootType,
    operation.selectionSet,
  );
  const [responseName, fieldNodes] = [...rootFields.entries()][0];
  const fieldDef = execute_getFieldDef(schema, rootType, fieldNodes[0]);

  if (!fieldDef) {
    const fieldName = fieldNodes[0].name.value;
    throw new GraphQLError/* GraphQLError */.__(
      `The subscription field "${fieldName}" is not defined.`,
      {
        nodes: fieldNodes,
      },
    );
  }

  const path = addPath(undefined, responseName, rootType.name);
  const info = buildResolveInfo(
    exeContext,
    fieldDef,
    fieldNodes,
    rootType,
    path,
  );

  try {
    var _fieldDef$subscribe;

    // Implements the "ResolveFieldEventStream" algorithm from GraphQL specification.
    // It differs from "ResolveFieldValue" due to providing a different `resolveFn`.
    // Build a JS object of arguments from the field.arguments AST, using the
    // variables scope to fulfill any variable references.
    const args = getArgumentValues(fieldDef, fieldNodes[0], variableValues); // The resolve function's optional third argument is a context value that
    // is provided to every resolve function within an execution. It is commonly
    // used to represent an authenticated user, or request-specific caches.

    const contextValue = exeContext.contextValue; // Call the `subscribe()` resolver or the default resolver to produce an
    // AsyncIterable yielding raw payloads.

    const resolveFn =
      (_fieldDef$subscribe = fieldDef.subscribe) !== null &&
      _fieldDef$subscribe !== void 0
        ? _fieldDef$subscribe
        : exeContext.subscribeFieldResolver;
    const eventStream = await resolveFn(rootValue, args, contextValue, info);

    if (eventStream instanceof Error) {
      throw eventStream;
    }

    return eventStream;
  } catch (error) {
    throw locatedError(error, fieldNodes, pathToArray(path));
  }
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/custom/NoDeprecatedCustomRule.mjs




/**
 * No deprecated
 *
 * A GraphQL document is only valid if all selected fields and all used enum values have not been
 * deprecated.
 *
 * Note: This rule is optional and is not part of the Validation section of the GraphQL
 * Specification. The main purpose of this rule is detection of deprecated usages and not
 * necessarily to forbid their use when querying a service.
 */
function NoDeprecatedCustomRule(context) {
  return {
    Field(node) {
      const fieldDef = context.getFieldDef();
      const deprecationReason =
        fieldDef === null || fieldDef === void 0
          ? void 0
          : fieldDef.deprecationReason;

      if (fieldDef && deprecationReason != null) {
        const parentType = context.getParentType();
        parentType != null || (0,invariant/* invariant */.k)(false);
        context.reportError(
          new GraphQLError/* GraphQLError */.__(
            `The field ${parentType.name}.${fieldDef.name} is deprecated. ${deprecationReason}`,
            {
              nodes: node,
            },
          ),
        );
      }
    },

    Argument(node) {
      const argDef = context.getArgument();
      const deprecationReason =
        argDef === null || argDef === void 0
          ? void 0
          : argDef.deprecationReason;

      if (argDef && deprecationReason != null) {
        const directiveDef = context.getDirective();

        if (directiveDef != null) {
          context.reportError(
            new GraphQLError/* GraphQLError */.__(
              `Directive "@${directiveDef.name}" argument "${argDef.name}" is deprecated. ${deprecationReason}`,
              {
                nodes: node,
              },
            ),
          );
        } else {
          const parentType = context.getParentType();
          const fieldDef = context.getFieldDef();
          (parentType != null && fieldDef != null) || (0,invariant/* invariant */.k)(false);
          context.reportError(
            new GraphQLError/* GraphQLError */.__(
              `Field "${parentType.name}.${fieldDef.name}" argument "${argDef.name}" is deprecated. ${deprecationReason}`,
              {
                nodes: node,
              },
            ),
          );
        }
      }
    },

    ObjectField(node) {
      const inputObjectDef = getNamedType(context.getParentInputType());

      if (isInputObjectType(inputObjectDef)) {
        const inputFieldDef = inputObjectDef.getFields()[node.name.value];
        const deprecationReason =
          inputFieldDef === null || inputFieldDef === void 0
            ? void 0
            : inputFieldDef.deprecationReason;

        if (deprecationReason != null) {
          context.reportError(
            new GraphQLError/* GraphQLError */.__(
              `The input field ${inputObjectDef.name}.${inputFieldDef.name} is deprecated. ${deprecationReason}`,
              {
                nodes: node,
              },
            ),
          );
        }
      }
    },

    EnumValue(node) {
      const enumValueDef = context.getEnumValue();
      const deprecationReason =
        enumValueDef === null || enumValueDef === void 0
          ? void 0
          : enumValueDef.deprecationReason;

      if (enumValueDef && deprecationReason != null) {
        const enumTypeDef = getNamedType(context.getInputType());
        enumTypeDef != null || (0,invariant/* invariant */.k)(false);
        context.reportError(
          new GraphQLError/* GraphQLError */.__(
            `The enum value "${enumTypeDef.name}.${enumValueDef.name}" is deprecated. ${deprecationReason}`,
            {
              nodes: node,
            },
          ),
        );
      }
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/custom/NoSchemaIntrospectionCustomRule.mjs




/**
 * Prohibit introspection queries
 *
 * A GraphQL document is only valid if all fields selected are not fields that
 * return an introspection type.
 *
 * Note: This rule is optional and is not part of the Validation section of the
 * GraphQL Specification. This rule effectively disables introspection, which
 * does not reflect best practices and should only be done if absolutely necessary.
 */
function NoSchemaIntrospectionCustomRule(context) {
  return {
    Field(node) {
      const type = getNamedType(context.getType());

      if (type && isIntrospectionType(type)) {
        context.reportError(
          new GraphQLError/* GraphQLError */.__(
            `GraphQL introspection has been disabled, but the requested query contained the field "${node.name.value}".`,
            {
              nodes: node,
            },
          ),
        );
      }
    },
  };
}

// EXTERNAL MODULE: ../node_modules/graphql/error/syntaxError.mjs
var syntaxError = __webpack_require__(23445);
;// CONCATENATED MODULE: ../node_modules/graphql/utilities/getIntrospectionQuery.mjs
/**
 * Produce the GraphQL query recommended for a full schema introspection.
 * Accepts optional IntrospectionOptions.
 */
function getIntrospectionQuery(options) {
  const optionsWithDefault = {
    descriptions: true,
    specifiedByUrl: false,
    directiveIsRepeatable: false,
    schemaDescription: false,
    inputValueDeprecation: false,
    oneOf: false,
    ...options,
  };
  const descriptions = optionsWithDefault.descriptions ? 'description' : '';
  const specifiedByUrl = optionsWithDefault.specifiedByUrl
    ? 'specifiedByURL'
    : '';
  const directiveIsRepeatable = optionsWithDefault.directiveIsRepeatable
    ? 'isRepeatable'
    : '';
  const schemaDescription = optionsWithDefault.schemaDescription
    ? descriptions
    : '';

  function inputDeprecation(str) {
    return optionsWithDefault.inputValueDeprecation ? str : '';
  }

  const oneOf = optionsWithDefault.oneOf ? 'isOneOf' : '';
  return `
    query IntrospectionQuery {
      __schema {
        ${schemaDescription}
        queryType { name }
        mutationType { name }
        subscriptionType { name }
        types {
          ...FullType
        }
        directives {
          name
          ${descriptions}
          ${directiveIsRepeatable}
          locations
          args${inputDeprecation('(includeDeprecated: true)')} {
            ...InputValue
          }
        }
      }
    }

    fragment FullType on __Type {
      kind
      name
      ${descriptions}
      ${specifiedByUrl}
      ${oneOf}
      fields(includeDeprecated: true) {
        name
        ${descriptions}
        args${inputDeprecation('(includeDeprecated: true)')} {
          ...InputValue
        }
        type {
          ...TypeRef
        }
        isDeprecated
        deprecationReason
      }
      inputFields${inputDeprecation('(includeDeprecated: true)')} {
        ...InputValue
      }
      interfaces {
        ...TypeRef
      }
      enumValues(includeDeprecated: true) {
        name
        ${descriptions}
        isDeprecated
        deprecationReason
      }
      possibleTypes {
        ...TypeRef
      }
    }

    fragment InputValue on __InputValue {
      name
      ${descriptions}
      type { ...TypeRef }
      defaultValue
      ${inputDeprecation('isDeprecated')}
      ${inputDeprecation('deprecationReason')}
    }

    fragment TypeRef on __Type {
      kind
      name
      ofType {
        kind
        name
        ofType {
          kind
          name
          ofType {
            kind
            name
            ofType {
              kind
              name
              ofType {
                kind
                name
                ofType {
                  kind
                  name
                  ofType {
                    kind
                    name
                    ofType {
                      kind
                      name
                      ofType {
                        kind
                        name
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `;
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/getOperationAST.mjs

/**
 * Returns an operation AST given a document AST and optionally an operation
 * name. If a name is not provided, an operation is only returned if only one is
 * provided in the document.
 */

function getOperationAST(documentAST, operationName) {
  let operation = null;

  for (const definition of documentAST.definitions) {
    if (definition.kind === kinds/* Kind.OPERATION_DEFINITION */.h.OPERATION_DEFINITION) {
      var _definition$name;

      if (operationName == null) {
        // If no operation name was provided, only return an Operation if there
        // is one defined in the document. Upon encountering the second, return
        // null.
        if (operation) {
          return null;
        }

        operation = definition;
      } else if (
        ((_definition$name = definition.name) === null ||
        _definition$name === void 0
          ? void 0
          : _definition$name.value) === operationName
      ) {
        return definition;
      }
    }
  }

  return operation;
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/getOperationRootType.mjs


/**
 * Extracts the root type of the operation from the schema.
 *
 * @deprecated Please use `GraphQLSchema.getRootType` instead. Will be removed in v17
 */
function getOperationRootType(schema, operation) {
  if (operation.operation === 'query') {
    const queryType = schema.getQueryType();

    if (!queryType) {
      throw new GraphQLError/* GraphQLError */.__(
        'Schema does not define the required query root type.',
        {
          nodes: operation,
        },
      );
    }

    return queryType;
  }

  if (operation.operation === 'mutation') {
    const mutationType = schema.getMutationType();

    if (!mutationType) {
      throw new GraphQLError/* GraphQLError */.__('Schema is not configured for mutations.', {
        nodes: operation,
      });
    }

    return mutationType;
  }

  if (operation.operation === 'subscription') {
    const subscriptionType = schema.getSubscriptionType();

    if (!subscriptionType) {
      throw new GraphQLError/* GraphQLError */.__('Schema is not configured for subscriptions.', {
        nodes: operation,
      });
    }

    return subscriptionType;
  }

  throw new GraphQLError/* GraphQLError */.__(
    'Can only have query, mutation and subscription operations.',
    {
      nodes: operation,
    },
  );
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/introspectionFromSchema.mjs




/**
 * Build an IntrospectionQuery from a GraphQLSchema
 *
 * IntrospectionQuery is useful for utilities that care about type and field
 * relationships, but do not need to traverse through those relationships.
 *
 * This is the inverse of buildClientSchema. The primary use case is outside
 * of the server context, for instance when doing schema comparisons.
 */

function introspectionFromSchema(schema, options) {
  const optionsWithDefaults = {
    specifiedByUrl: true,
    directiveIsRepeatable: true,
    schemaDescription: true,
    inputValueDeprecation: true,
    oneOf: true,
    ...options,
  };
  const document = (0,parser/* parse */.Qc)(getIntrospectionQuery(optionsWithDefaults));
  const result = executeSync({
    schema,
    document,
  });
  (!result.errors && result.data) || (0,invariant/* invariant */.k)(false);
  return result.data;
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/buildClientSchema.mjs











/**
 * Build a GraphQLSchema for use by client tools.
 *
 * Given the result of a client running the introspection query, creates and
 * returns a GraphQLSchema instance which can be then used with all graphql-js
 * tools, but cannot be used to execute a query, as introspection does not
 * represent the "resolver", "parse" or "serialize" functions or any other
 * server-internal mechanisms.
 *
 * This function expects a complete introspection result. Don't forget to check
 * the "errors" field of a server response before calling this function.
 */

function buildClientSchema(introspection, options) {
  ((0,isObjectLike/* isObjectLike */.y)(introspection) && (0,isObjectLike/* isObjectLike */.y)(introspection.__schema)) ||
    (0,devAssert/* devAssert */.a)(
      false,
      `Invalid or incomplete introspection result. Ensure that you are passing "data" property of introspection response and no "errors" was returned alongside: ${(0,inspect/* inspect */.X)(
        introspection,
      )}.`,
    ); // Get the schema from the introspection result.

  const schemaIntrospection = introspection.__schema; // Iterate through all types, getting the type definition for each.

  const typeMap = keyValMap(
    schemaIntrospection.types,
    (typeIntrospection) => typeIntrospection.name,
    (typeIntrospection) => buildType(typeIntrospection),
  ); // Include standard types only if they are used.

  for (const stdType of [...specifiedScalarTypes, ...introspectionTypes]) {
    if (typeMap[stdType.name]) {
      typeMap[stdType.name] = stdType;
    }
  } // Get the root Query, Mutation, and Subscription types.

  const queryType = schemaIntrospection.queryType
    ? getObjectType(schemaIntrospection.queryType)
    : null;
  const mutationType = schemaIntrospection.mutationType
    ? getObjectType(schemaIntrospection.mutationType)
    : null;
  const subscriptionType = schemaIntrospection.subscriptionType
    ? getObjectType(schemaIntrospection.subscriptionType)
    : null; // Get the directives supported by Introspection, assuming empty-set if
  // directives were not queried for.

  const directives = schemaIntrospection.directives
    ? schemaIntrospection.directives.map(buildDirective)
    : []; // Then produce and return a Schema with these types.

  return new GraphQLSchema({
    description: schemaIntrospection.description,
    query: queryType,
    mutation: mutationType,
    subscription: subscriptionType,
    types: Object.values(typeMap),
    directives,
    assumeValid:
      options === null || options === void 0 ? void 0 : options.assumeValid,
  }); // Given a type reference in introspection, return the GraphQLType instance.
  // preferring cached instances before building new instances.

  function getType(typeRef) {
    if (typeRef.kind === TypeKind.LIST) {
      const itemRef = typeRef.ofType;

      if (!itemRef) {
        throw new Error('Decorated type deeper than introspection query.');
      }

      return new GraphQLList(getType(itemRef));
    }

    if (typeRef.kind === TypeKind.NON_NULL) {
      const nullableRef = typeRef.ofType;

      if (!nullableRef) {
        throw new Error('Decorated type deeper than introspection query.');
      }

      const nullableType = getType(nullableRef);
      return new GraphQLNonNull(assertNullableType(nullableType));
    }

    return getNamedType(typeRef);
  }

  function getNamedType(typeRef) {
    const typeName = typeRef.name;

    if (!typeName) {
      throw new Error(`Unknown type reference: ${(0,inspect/* inspect */.X)(typeRef)}.`);
    }

    const type = typeMap[typeName];

    if (!type) {
      throw new Error(
        `Invalid or incomplete schema, unknown type: ${typeName}. Ensure that a full introspection query is used in order to build a client schema.`,
      );
    }

    return type;
  }

  function getObjectType(typeRef) {
    return assertObjectType(getNamedType(typeRef));
  }

  function getInterfaceType(typeRef) {
    return assertInterfaceType(getNamedType(typeRef));
  } // Given a type's introspection result, construct the correct
  // GraphQLType instance.

  function buildType(type) {
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    if (type != null && type.name != null && type.kind != null) {
      // FIXME: Properly type IntrospectionType, it's a breaking change so fix in v17
      // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
      switch (type.kind) {
        case TypeKind.SCALAR:
          return buildScalarDef(type);

        case TypeKind.OBJECT:
          return buildObjectDef(type);

        case TypeKind.INTERFACE:
          return buildInterfaceDef(type);

        case TypeKind.UNION:
          return buildUnionDef(type);

        case TypeKind.ENUM:
          return buildEnumDef(type);

        case TypeKind.INPUT_OBJECT:
          return buildInputObjectDef(type);
      }
    }

    const typeStr = (0,inspect/* inspect */.X)(type);
    throw new Error(
      `Invalid or incomplete introspection result. Ensure that a full introspection query is used in order to build a client schema: ${typeStr}.`,
    );
  }

  function buildScalarDef(scalarIntrospection) {
    return new GraphQLScalarType({
      name: scalarIntrospection.name,
      description: scalarIntrospection.description,
      specifiedByURL: scalarIntrospection.specifiedByURL,
    });
  }

  function buildImplementationsList(implementingIntrospection) {
    // TODO: Temporary workaround until GraphQL ecosystem will fully support
    // 'interfaces' on interface types.
    if (
      implementingIntrospection.interfaces === null &&
      implementingIntrospection.kind === TypeKind.INTERFACE
    ) {
      return [];
    }

    if (!implementingIntrospection.interfaces) {
      const implementingIntrospectionStr = (0,inspect/* inspect */.X)(implementingIntrospection);
      throw new Error(
        `Introspection result missing interfaces: ${implementingIntrospectionStr}.`,
      );
    }

    return implementingIntrospection.interfaces.map(getInterfaceType);
  }

  function buildObjectDef(objectIntrospection) {
    return new GraphQLObjectType({
      name: objectIntrospection.name,
      description: objectIntrospection.description,
      interfaces: () => buildImplementationsList(objectIntrospection),
      fields: () => buildFieldDefMap(objectIntrospection),
    });
  }

  function buildInterfaceDef(interfaceIntrospection) {
    return new GraphQLInterfaceType({
      name: interfaceIntrospection.name,
      description: interfaceIntrospection.description,
      interfaces: () => buildImplementationsList(interfaceIntrospection),
      fields: () => buildFieldDefMap(interfaceIntrospection),
    });
  }

  function buildUnionDef(unionIntrospection) {
    if (!unionIntrospection.possibleTypes) {
      const unionIntrospectionStr = (0,inspect/* inspect */.X)(unionIntrospection);
      throw new Error(
        `Introspection result missing possibleTypes: ${unionIntrospectionStr}.`,
      );
    }

    return new GraphQLUnionType({
      name: unionIntrospection.name,
      description: unionIntrospection.description,
      types: () => unionIntrospection.possibleTypes.map(getObjectType),
    });
  }

  function buildEnumDef(enumIntrospection) {
    if (!enumIntrospection.enumValues) {
      const enumIntrospectionStr = (0,inspect/* inspect */.X)(enumIntrospection);
      throw new Error(
        `Introspection result missing enumValues: ${enumIntrospectionStr}.`,
      );
    }

    return new GraphQLEnumType({
      name: enumIntrospection.name,
      description: enumIntrospection.description,
      values: keyValMap(
        enumIntrospection.enumValues,
        (valueIntrospection) => valueIntrospection.name,
        (valueIntrospection) => ({
          description: valueIntrospection.description,
          deprecationReason: valueIntrospection.deprecationReason,
        }),
      ),
    });
  }

  function buildInputObjectDef(inputObjectIntrospection) {
    if (!inputObjectIntrospection.inputFields) {
      const inputObjectIntrospectionStr = (0,inspect/* inspect */.X)(inputObjectIntrospection);
      throw new Error(
        `Introspection result missing inputFields: ${inputObjectIntrospectionStr}.`,
      );
    }

    return new GraphQLInputObjectType({
      name: inputObjectIntrospection.name,
      description: inputObjectIntrospection.description,
      fields: () => buildInputValueDefMap(inputObjectIntrospection.inputFields),
      isOneOf: inputObjectIntrospection.isOneOf,
    });
  }

  function buildFieldDefMap(typeIntrospection) {
    if (!typeIntrospection.fields) {
      throw new Error(
        `Introspection result missing fields: ${(0,inspect/* inspect */.X)(typeIntrospection)}.`,
      );
    }

    return keyValMap(
      typeIntrospection.fields,
      (fieldIntrospection) => fieldIntrospection.name,
      buildField,
    );
  }

  function buildField(fieldIntrospection) {
    const type = getType(fieldIntrospection.type);

    if (!isOutputType(type)) {
      const typeStr = (0,inspect/* inspect */.X)(type);
      throw new Error(
        `Introspection must provide output type for fields, but received: ${typeStr}.`,
      );
    }

    if (!fieldIntrospection.args) {
      const fieldIntrospectionStr = (0,inspect/* inspect */.X)(fieldIntrospection);
      throw new Error(
        `Introspection result missing field args: ${fieldIntrospectionStr}.`,
      );
    }

    return {
      description: fieldIntrospection.description,
      deprecationReason: fieldIntrospection.deprecationReason,
      type,
      args: buildInputValueDefMap(fieldIntrospection.args),
    };
  }

  function buildInputValueDefMap(inputValueIntrospections) {
    return keyValMap(
      inputValueIntrospections,
      (inputValue) => inputValue.name,
      buildInputValue,
    );
  }

  function buildInputValue(inputValueIntrospection) {
    const type = getType(inputValueIntrospection.type);

    if (!isInputType(type)) {
      const typeStr = (0,inspect/* inspect */.X)(type);
      throw new Error(
        `Introspection must provide input type for arguments, but received: ${typeStr}.`,
      );
    }

    const defaultValue =
      inputValueIntrospection.defaultValue != null
        ? valueFromAST((0,parser/* parseValue */.H2)(inputValueIntrospection.defaultValue), type)
        : undefined;
    return {
      description: inputValueIntrospection.description,
      type,
      defaultValue,
      deprecationReason: inputValueIntrospection.deprecationReason,
    };
  }

  function buildDirective(directiveIntrospection) {
    if (!directiveIntrospection.args) {
      const directiveIntrospectionStr = (0,inspect/* inspect */.X)(directiveIntrospection);
      throw new Error(
        `Introspection result missing directive args: ${directiveIntrospectionStr}.`,
      );
    }

    if (!directiveIntrospection.locations) {
      const directiveIntrospectionStr = (0,inspect/* inspect */.X)(directiveIntrospection);
      throw new Error(
        `Introspection result missing directive locations: ${directiveIntrospectionStr}.`,
      );
    }

    return new GraphQLDirective({
      name: directiveIntrospection.name,
      description: directiveIntrospection.description,
      isRepeatable: directiveIntrospection.isRepeatable,
      locations: directiveIntrospection.locations.slice(),
      args: buildInputValueDefMap(directiveIntrospection.args),
    });
  }
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/extendSchema.mjs
















/**
 * Produces a new schema given an existing schema and a document which may
 * contain GraphQL type extensions and definitions. The original schema will
 * remain unaltered.
 *
 * Because a schema represents a graph of references, a schema cannot be
 * extended without effectively making an entire copy. We do not know until it's
 * too late if subgraphs remain unchanged.
 *
 * This algorithm copies the provided schema, applying extensions while
 * producing the copy. The original schema remains unaltered.
 */
function extendSchema(schema, documentAST, options) {
  assertSchema(schema);
  (documentAST != null && documentAST.kind === kinds/* Kind.DOCUMENT */.h.DOCUMENT) ||
    (0,devAssert/* devAssert */.a)(false, 'Must provide valid Document AST.');

  if (
    (options === null || options === void 0 ? void 0 : options.assumeValid) !==
      true &&
    (options === null || options === void 0
      ? void 0
      : options.assumeValidSDL) !== true
  ) {
    assertValidSDLExtension(documentAST, schema);
  }

  const schemaConfig = schema.toConfig();
  const extendedConfig = extendSchemaImpl(schemaConfig, documentAST, options);
  return schemaConfig === extendedConfig
    ? schema
    : new GraphQLSchema(extendedConfig);
}
/**
 * @internal
 */

function extendSchemaImpl(schemaConfig, documentAST, options) {
  var _schemaDef, _schemaDef$descriptio, _schemaDef2, _options$assumeValid;

  // Collect the type definitions and extensions found in the document.
  const typeDefs = [];
  const typeExtensionsMap = Object.create(null); // New directives and types are separate because a directives and types can
  // have the same name. For example, a type named "skip".

  const directiveDefs = [];
  let schemaDef; // Schema extensions are collected which may add additional operation types.

  const schemaExtensions = [];

  for (const def of documentAST.definitions) {
    if (def.kind === kinds/* Kind.SCHEMA_DEFINITION */.h.SCHEMA_DEFINITION) {
      schemaDef = def;
    } else if (def.kind === kinds/* Kind.SCHEMA_EXTENSION */.h.SCHEMA_EXTENSION) {
      schemaExtensions.push(def);
    } else if (isTypeDefinitionNode(def)) {
      typeDefs.push(def);
    } else if (isTypeExtensionNode(def)) {
      const extendedTypeName = def.name.value;
      const existingTypeExtensions = typeExtensionsMap[extendedTypeName];
      typeExtensionsMap[extendedTypeName] = existingTypeExtensions
        ? existingTypeExtensions.concat([def])
        : [def];
    } else if (def.kind === kinds/* Kind.DIRECTIVE_DEFINITION */.h.DIRECTIVE_DEFINITION) {
      directiveDefs.push(def);
    }
  } // If this document contains no new types, extensions, or directives then
  // return the same unmodified GraphQLSchema instance.

  if (
    Object.keys(typeExtensionsMap).length === 0 &&
    typeDefs.length === 0 &&
    directiveDefs.length === 0 &&
    schemaExtensions.length === 0 &&
    schemaDef == null
  ) {
    return schemaConfig;
  }

  const typeMap = Object.create(null);

  for (const existingType of schemaConfig.types) {
    typeMap[existingType.name] = extendNamedType(existingType);
  }

  for (const typeNode of typeDefs) {
    var _stdTypeMap$name;

    const name = typeNode.name.value;
    typeMap[name] =
      (_stdTypeMap$name = stdTypeMap[name]) !== null &&
      _stdTypeMap$name !== void 0
        ? _stdTypeMap$name
        : buildType(typeNode);
  }

  const operationTypes = {
    // Get the extended root operation types.
    query: schemaConfig.query && replaceNamedType(schemaConfig.query),
    mutation: schemaConfig.mutation && replaceNamedType(schemaConfig.mutation),
    subscription:
      schemaConfig.subscription && replaceNamedType(schemaConfig.subscription),
    // Then, incorporate schema definition and all schema extensions.
    ...(schemaDef && getOperationTypes([schemaDef])),
    ...getOperationTypes(schemaExtensions),
  }; // Then produce and return a Schema config with these types.

  return {
    description:
      (_schemaDef = schemaDef) === null || _schemaDef === void 0
        ? void 0
        : (_schemaDef$descriptio = _schemaDef.description) === null ||
          _schemaDef$descriptio === void 0
        ? void 0
        : _schemaDef$descriptio.value,
    ...operationTypes,
    types: Object.values(typeMap),
    directives: [
      ...schemaConfig.directives.map(replaceDirective),
      ...directiveDefs.map(buildDirective),
    ],
    extensions: Object.create(null),
    astNode:
      (_schemaDef2 = schemaDef) !== null && _schemaDef2 !== void 0
        ? _schemaDef2
        : schemaConfig.astNode,
    extensionASTNodes: schemaConfig.extensionASTNodes.concat(schemaExtensions),
    assumeValid:
      (_options$assumeValid =
        options === null || options === void 0
          ? void 0
          : options.assumeValid) !== null && _options$assumeValid !== void 0
        ? _options$assumeValid
        : false,
  }; // Below are functions used for producing this schema that have closed over
  // this scope and have access to the schema, cache, and newly defined types.

  function replaceType(type) {
    if (isListType(type)) {
      // @ts-expect-error
      return new GraphQLList(replaceType(type.ofType));
    }

    if (isNonNullType(type)) {
      // @ts-expect-error
      return new GraphQLNonNull(replaceType(type.ofType));
    } // @ts-expect-error FIXME

    return replaceNamedType(type);
  }

  function replaceNamedType(type) {
    // Note: While this could make early assertions to get the correctly
    // typed values, that would throw immediately while type system
    // validation with validateSchema() will produce more actionable results.
    return typeMap[type.name];
  }

  function replaceDirective(directive) {
    const config = directive.toConfig();
    return new GraphQLDirective({
      ...config,
      args: mapValue(config.args, extendArg),
    });
  }

  function extendNamedType(type) {
    if (isIntrospectionType(type) || isSpecifiedScalarType(type)) {
      // Builtin types are not extended.
      return type;
    }

    if (isScalarType(type)) {
      return extendScalarType(type);
    }

    if (isObjectType(type)) {
      return extendObjectType(type);
    }

    if (isInterfaceType(type)) {
      return extendInterfaceType(type);
    }

    if (isUnionType(type)) {
      return extendUnionType(type);
    }

    if (isEnumType(type)) {
      return extendEnumType(type);
    }

    if (isInputObjectType(type)) {
      return extendInputObjectType(type);
    }
    /* c8 ignore next 3 */
    // Not reachable, all possible type definition nodes have been considered.

     false || (0,invariant/* invariant */.k)(false, 'Unexpected type: ' + (0,inspect/* inspect */.X)(type));
  }

  function extendInputObjectType(type) {
    var _typeExtensionsMap$co;

    const config = type.toConfig();
    const extensions =
      (_typeExtensionsMap$co = typeExtensionsMap[config.name]) !== null &&
      _typeExtensionsMap$co !== void 0
        ? _typeExtensionsMap$co
        : [];
    return new GraphQLInputObjectType({
      ...config,
      fields: () => ({
        ...mapValue(config.fields, (field) => ({
          ...field,
          type: replaceType(field.type),
        })),
        ...buildInputFieldMap(extensions),
      }),
      extensionASTNodes: config.extensionASTNodes.concat(extensions),
    });
  }

  function extendEnumType(type) {
    var _typeExtensionsMap$ty;

    const config = type.toConfig();
    const extensions =
      (_typeExtensionsMap$ty = typeExtensionsMap[type.name]) !== null &&
      _typeExtensionsMap$ty !== void 0
        ? _typeExtensionsMap$ty
        : [];
    return new GraphQLEnumType({
      ...config,
      values: { ...config.values, ...buildEnumValueMap(extensions) },
      extensionASTNodes: config.extensionASTNodes.concat(extensions),
    });
  }

  function extendScalarType(type) {
    var _typeExtensionsMap$co2;

    const config = type.toConfig();
    const extensions =
      (_typeExtensionsMap$co2 = typeExtensionsMap[config.name]) !== null &&
      _typeExtensionsMap$co2 !== void 0
        ? _typeExtensionsMap$co2
        : [];
    let specifiedByURL = config.specifiedByURL;

    for (const extensionNode of extensions) {
      var _getSpecifiedByURL;

      specifiedByURL =
        (_getSpecifiedByURL = getSpecifiedByURL(extensionNode)) !== null &&
        _getSpecifiedByURL !== void 0
          ? _getSpecifiedByURL
          : specifiedByURL;
    }

    return new GraphQLScalarType({
      ...config,
      specifiedByURL,
      extensionASTNodes: config.extensionASTNodes.concat(extensions),
    });
  }

  function extendObjectType(type) {
    var _typeExtensionsMap$co3;

    const config = type.toConfig();
    const extensions =
      (_typeExtensionsMap$co3 = typeExtensionsMap[config.name]) !== null &&
      _typeExtensionsMap$co3 !== void 0
        ? _typeExtensionsMap$co3
        : [];
    return new GraphQLObjectType({
      ...config,
      interfaces: () => [
        ...type.getInterfaces().map(replaceNamedType),
        ...buildInterfaces(extensions),
      ],
      fields: () => ({
        ...mapValue(config.fields, extendField),
        ...buildFieldMap(extensions),
      }),
      extensionASTNodes: config.extensionASTNodes.concat(extensions),
    });
  }

  function extendInterfaceType(type) {
    var _typeExtensionsMap$co4;

    const config = type.toConfig();
    const extensions =
      (_typeExtensionsMap$co4 = typeExtensionsMap[config.name]) !== null &&
      _typeExtensionsMap$co4 !== void 0
        ? _typeExtensionsMap$co4
        : [];
    return new GraphQLInterfaceType({
      ...config,
      interfaces: () => [
        ...type.getInterfaces().map(replaceNamedType),
        ...buildInterfaces(extensions),
      ],
      fields: () => ({
        ...mapValue(config.fields, extendField),
        ...buildFieldMap(extensions),
      }),
      extensionASTNodes: config.extensionASTNodes.concat(extensions),
    });
  }

  function extendUnionType(type) {
    var _typeExtensionsMap$co5;

    const config = type.toConfig();
    const extensions =
      (_typeExtensionsMap$co5 = typeExtensionsMap[config.name]) !== null &&
      _typeExtensionsMap$co5 !== void 0
        ? _typeExtensionsMap$co5
        : [];
    return new GraphQLUnionType({
      ...config,
      types: () => [
        ...type.getTypes().map(replaceNamedType),
        ...buildUnionTypes(extensions),
      ],
      extensionASTNodes: config.extensionASTNodes.concat(extensions),
    });
  }

  function extendField(field) {
    return {
      ...field,
      type: replaceType(field.type),
      args: field.args && mapValue(field.args, extendArg),
    };
  }

  function extendArg(arg) {
    return { ...arg, type: replaceType(arg.type) };
  }

  function getOperationTypes(nodes) {
    const opTypes = {};

    for (const node of nodes) {
      var _node$operationTypes;

      // FIXME: https://github.com/graphql/graphql-js/issues/2203
      const operationTypesNodes =
        /* c8 ignore next */
        (_node$operationTypes = node.operationTypes) !== null &&
        _node$operationTypes !== void 0
          ? _node$operationTypes
          : [];

      for (const operationType of operationTypesNodes) {
        // Note: While this could make early assertions to get the correctly
        // typed values below, that would throw immediately while type system
        // validation with validateSchema() will produce more actionable results.
        // @ts-expect-error
        opTypes[operationType.operation] = getNamedType(operationType.type);
      }
    }

    return opTypes;
  }

  function getNamedType(node) {
    var _stdTypeMap$name2;

    const name = node.name.value;
    const type =
      (_stdTypeMap$name2 = stdTypeMap[name]) !== null &&
      _stdTypeMap$name2 !== void 0
        ? _stdTypeMap$name2
        : typeMap[name];

    if (type === undefined) {
      throw new Error(`Unknown type: "${name}".`);
    }

    return type;
  }

  function getWrappedType(node) {
    if (node.kind === kinds/* Kind.LIST_TYPE */.h.LIST_TYPE) {
      return new GraphQLList(getWrappedType(node.type));
    }

    if (node.kind === kinds/* Kind.NON_NULL_TYPE */.h.NON_NULL_TYPE) {
      return new GraphQLNonNull(getWrappedType(node.type));
    }

    return getNamedType(node);
  }

  function buildDirective(node) {
    var _node$description;

    return new GraphQLDirective({
      name: node.name.value,
      description:
        (_node$description = node.description) === null ||
        _node$description === void 0
          ? void 0
          : _node$description.value,
      // @ts-expect-error
      locations: node.locations.map(({ value }) => value),
      isRepeatable: node.repeatable,
      args: buildArgumentMap(node.arguments),
      astNode: node,
    });
  }

  function buildFieldMap(nodes) {
    const fieldConfigMap = Object.create(null);

    for (const node of nodes) {
      var _node$fields;

      // FIXME: https://github.com/graphql/graphql-js/issues/2203
      const nodeFields =
        /* c8 ignore next */
        (_node$fields = node.fields) !== null && _node$fields !== void 0
          ? _node$fields
          : [];

      for (const field of nodeFields) {
        var _field$description;

        fieldConfigMap[field.name.value] = {
          // Note: While this could make assertions to get the correctly typed
          // value, that would throw immediately while type system validation
          // with validateSchema() will produce more actionable results.
          type: getWrappedType(field.type),
          description:
            (_field$description = field.description) === null ||
            _field$description === void 0
              ? void 0
              : _field$description.value,
          args: buildArgumentMap(field.arguments),
          deprecationReason: getDeprecationReason(field),
          astNode: field,
        };
      }
    }

    return fieldConfigMap;
  }

  function buildArgumentMap(args) {
    // FIXME: https://github.com/graphql/graphql-js/issues/2203
    const argsNodes =
      /* c8 ignore next */
      args !== null && args !== void 0 ? args : [];
    const argConfigMap = Object.create(null);

    for (const arg of argsNodes) {
      var _arg$description;

      // Note: While this could make assertions to get the correctly typed
      // value, that would throw immediately while type system validation
      // with validateSchema() will produce more actionable results.
      const type = getWrappedType(arg.type);
      argConfigMap[arg.name.value] = {
        type,
        description:
          (_arg$description = arg.description) === null ||
          _arg$description === void 0
            ? void 0
            : _arg$description.value,
        defaultValue: valueFromAST(arg.defaultValue, type),
        deprecationReason: getDeprecationReason(arg),
        astNode: arg,
      };
    }

    return argConfigMap;
  }

  function buildInputFieldMap(nodes) {
    const inputFieldMap = Object.create(null);

    for (const node of nodes) {
      var _node$fields2;

      // FIXME: https://github.com/graphql/graphql-js/issues/2203
      const fieldsNodes =
        /* c8 ignore next */
        (_node$fields2 = node.fields) !== null && _node$fields2 !== void 0
          ? _node$fields2
          : [];

      for (const field of fieldsNodes) {
        var _field$description2;

        // Note: While this could make assertions to get the correctly typed
        // value, that would throw immediately while type system validation
        // with validateSchema() will produce more actionable results.
        const type = getWrappedType(field.type);
        inputFieldMap[field.name.value] = {
          type,
          description:
            (_field$description2 = field.description) === null ||
            _field$description2 === void 0
              ? void 0
              : _field$description2.value,
          defaultValue: valueFromAST(field.defaultValue, type),
          deprecationReason: getDeprecationReason(field),
          astNode: field,
        };
      }
    }

    return inputFieldMap;
  }

  function buildEnumValueMap(nodes) {
    const enumValueMap = Object.create(null);

    for (const node of nodes) {
      var _node$values;

      // FIXME: https://github.com/graphql/graphql-js/issues/2203
      const valuesNodes =
        /* c8 ignore next */
        (_node$values = node.values) !== null && _node$values !== void 0
          ? _node$values
          : [];

      for (const value of valuesNodes) {
        var _value$description;

        enumValueMap[value.name.value] = {
          description:
            (_value$description = value.description) === null ||
            _value$description === void 0
              ? void 0
              : _value$description.value,
          deprecationReason: getDeprecationReason(value),
          astNode: value,
        };
      }
    }

    return enumValueMap;
  }

  function buildInterfaces(nodes) {
    // Note: While this could make assertions to get the correctly typed
    // values below, that would throw immediately while type system
    // validation with validateSchema() will produce more actionable results.
    // @ts-expect-error
    return nodes.flatMap(
      // FIXME: https://github.com/graphql/graphql-js/issues/2203
      (node) => {
        var _node$interfaces$map, _node$interfaces;

        return (
          /* c8 ignore next */
          (_node$interfaces$map =
            (_node$interfaces = node.interfaces) === null ||
            _node$interfaces === void 0
              ? void 0
              : _node$interfaces.map(getNamedType)) !== null &&
            _node$interfaces$map !== void 0
            ? _node$interfaces$map
            : []
        );
      },
    );
  }

  function buildUnionTypes(nodes) {
    // Note: While this could make assertions to get the correctly typed
    // values below, that would throw immediately while type system
    // validation with validateSchema() will produce more actionable results.
    // @ts-expect-error
    return nodes.flatMap(
      // FIXME: https://github.com/graphql/graphql-js/issues/2203
      (node) => {
        var _node$types$map, _node$types;

        return (
          /* c8 ignore next */
          (_node$types$map =
            (_node$types = node.types) === null || _node$types === void 0
              ? void 0
              : _node$types.map(getNamedType)) !== null &&
            _node$types$map !== void 0
            ? _node$types$map
            : []
        );
      },
    );
  }

  function buildType(astNode) {
    var _typeExtensionsMap$na;

    const name = astNode.name.value;
    const extensionASTNodes =
      (_typeExtensionsMap$na = typeExtensionsMap[name]) !== null &&
      _typeExtensionsMap$na !== void 0
        ? _typeExtensionsMap$na
        : [];

    switch (astNode.kind) {
      case kinds/* Kind.OBJECT_TYPE_DEFINITION */.h.OBJECT_TYPE_DEFINITION: {
        var _astNode$description;

        const allNodes = [astNode, ...extensionASTNodes];
        return new GraphQLObjectType({
          name,
          description:
            (_astNode$description = astNode.description) === null ||
            _astNode$description === void 0
              ? void 0
              : _astNode$description.value,
          interfaces: () => buildInterfaces(allNodes),
          fields: () => buildFieldMap(allNodes),
          astNode,
          extensionASTNodes,
        });
      }

      case kinds/* Kind.INTERFACE_TYPE_DEFINITION */.h.INTERFACE_TYPE_DEFINITION: {
        var _astNode$description2;

        const allNodes = [astNode, ...extensionASTNodes];
        return new GraphQLInterfaceType({
          name,
          description:
            (_astNode$description2 = astNode.description) === null ||
            _astNode$description2 === void 0
              ? void 0
              : _astNode$description2.value,
          interfaces: () => buildInterfaces(allNodes),
          fields: () => buildFieldMap(allNodes),
          astNode,
          extensionASTNodes,
        });
      }

      case kinds/* Kind.ENUM_TYPE_DEFINITION */.h.ENUM_TYPE_DEFINITION: {
        var _astNode$description3;

        const allNodes = [astNode, ...extensionASTNodes];
        return new GraphQLEnumType({
          name,
          description:
            (_astNode$description3 = astNode.description) === null ||
            _astNode$description3 === void 0
              ? void 0
              : _astNode$description3.value,
          values: buildEnumValueMap(allNodes),
          astNode,
          extensionASTNodes,
        });
      }

      case kinds/* Kind.UNION_TYPE_DEFINITION */.h.UNION_TYPE_DEFINITION: {
        var _astNode$description4;

        const allNodes = [astNode, ...extensionASTNodes];
        return new GraphQLUnionType({
          name,
          description:
            (_astNode$description4 = astNode.description) === null ||
            _astNode$description4 === void 0
              ? void 0
              : _astNode$description4.value,
          types: () => buildUnionTypes(allNodes),
          astNode,
          extensionASTNodes,
        });
      }

      case kinds/* Kind.SCALAR_TYPE_DEFINITION */.h.SCALAR_TYPE_DEFINITION: {
        var _astNode$description5;

        return new GraphQLScalarType({
          name,
          description:
            (_astNode$description5 = astNode.description) === null ||
            _astNode$description5 === void 0
              ? void 0
              : _astNode$description5.value,
          specifiedByURL: getSpecifiedByURL(astNode),
          astNode,
          extensionASTNodes,
        });
      }

      case kinds/* Kind.INPUT_OBJECT_TYPE_DEFINITION */.h.INPUT_OBJECT_TYPE_DEFINITION: {
        var _astNode$description6;

        const allNodes = [astNode, ...extensionASTNodes];
        return new GraphQLInputObjectType({
          name,
          description:
            (_astNode$description6 = astNode.description) === null ||
            _astNode$description6 === void 0
              ? void 0
              : _astNode$description6.value,
          fields: () => buildInputFieldMap(allNodes),
          astNode,
          extensionASTNodes,
          isOneOf: isOneOf(astNode),
        });
      }
    }
  }
}
const stdTypeMap = keyMap(
  [...specifiedScalarTypes, ...introspectionTypes],
  (type) => type.name,
);
/**
 * Given a field or enum value node, returns the string value for the
 * deprecation reason.
 */

function getDeprecationReason(node) {
  const deprecated = getDirectiveValues(GraphQLDeprecatedDirective, node); // @ts-expect-error validated by `getDirectiveValues`

  return deprecated === null || deprecated === void 0
    ? void 0
    : deprecated.reason;
}
/**
 * Given a scalar node, returns the string value for the specifiedByURL.
 */

function getSpecifiedByURL(node) {
  const specifiedBy = getDirectiveValues(GraphQLSpecifiedByDirective, node); // @ts-expect-error validated by `getDirectiveValues`

  return specifiedBy === null || specifiedBy === void 0
    ? void 0
    : specifiedBy.url;
}
/**
 * Given an input object node, returns if the node should be OneOf.
 */

function isOneOf(node) {
  return Boolean(getDirectiveValues(GraphQLOneOfDirective, node));
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/buildASTSchema.mjs








/**
 * This takes the ast of a schema document produced by the parse function in
 * src/language/parser.js.
 *
 * If no schema definition is provided, then it will look for types named Query,
 * Mutation and Subscription.
 *
 * Given that AST it constructs a GraphQLSchema. The resulting schema
 * has no resolve methods, so execution will use default resolvers.
 */
function buildASTSchema(documentAST, options) {
  (documentAST != null && documentAST.kind === kinds/* Kind.DOCUMENT */.h.DOCUMENT) ||
    (0,devAssert/* devAssert */.a)(false, 'Must provide valid Document AST.');

  if (
    (options === null || options === void 0 ? void 0 : options.assumeValid) !==
      true &&
    (options === null || options === void 0
      ? void 0
      : options.assumeValidSDL) !== true
  ) {
    assertValidSDL(documentAST);
  }

  const emptySchemaConfig = {
    description: undefined,
    types: [],
    directives: [],
    extensions: Object.create(null),
    extensionASTNodes: [],
    assumeValid: false,
  };
  const config = extendSchemaImpl(emptySchemaConfig, documentAST, options);

  if (config.astNode == null) {
    for (const type of config.types) {
      switch (type.name) {
        // Note: While this could make early assertions to get the correctly
        // typed values below, that would throw immediately while type system
        // validation with validateSchema() will produce more actionable results.
        case 'Query':
          // @ts-expect-error validated in `validateSchema`
          config.query = type;
          break;

        case 'Mutation':
          // @ts-expect-error validated in `validateSchema`
          config.mutation = type;
          break;

        case 'Subscription':
          // @ts-expect-error validated in `validateSchema`
          config.subscription = type;
          break;
      }
    }
  }

  const directives = [
    ...config.directives, // If specified directives were not explicitly declared, add them.
    ...specifiedDirectives.filter((stdDirective) =>
      config.directives.every(
        (directive) => directive.name !== stdDirective.name,
      ),
    ),
  ];
  return new GraphQLSchema({ ...config, directives });
}
/**
 * A helper function to build a GraphQLSchema directly from a source
 * document.
 */

function buildSchema(source, options) {
  const document = (0,parser/* parse */.Qc)(source, {
    noLocation:
      options === null || options === void 0 ? void 0 : options.noLocation,
    allowLegacyFragmentVariables:
      options === null || options === void 0
        ? void 0
        : options.allowLegacyFragmentVariables,
  });
  return buildASTSchema(document, {
    assumeValidSDL:
      options === null || options === void 0 ? void 0 : options.assumeValidSDL,
    assumeValid:
      options === null || options === void 0 ? void 0 : options.assumeValid,
  });
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/lexicographicSortSchema.mjs








/**
 * Sort GraphQLSchema.
 *
 * This function returns a sorted copy of the given GraphQLSchema.
 */

function lexicographicSortSchema(schema) {
  const schemaConfig = schema.toConfig();
  const typeMap = keyValMap(
    sortByName(schemaConfig.types),
    (type) => type.name,
    sortNamedType,
  );
  return new GraphQLSchema({
    ...schemaConfig,
    types: Object.values(typeMap),
    directives: sortByName(schemaConfig.directives).map(sortDirective),
    query: replaceMaybeType(schemaConfig.query),
    mutation: replaceMaybeType(schemaConfig.mutation),
    subscription: replaceMaybeType(schemaConfig.subscription),
  });

  function replaceType(type) {
    if (isListType(type)) {
      // @ts-expect-error
      return new GraphQLList(replaceType(type.ofType));
    } else if (isNonNullType(type)) {
      // @ts-expect-error
      return new GraphQLNonNull(replaceType(type.ofType));
    } // @ts-expect-error FIXME: TS Conversion

    return replaceNamedType(type);
  }

  function replaceNamedType(type) {
    return typeMap[type.name];
  }

  function replaceMaybeType(maybeType) {
    return maybeType && replaceNamedType(maybeType);
  }

  function sortDirective(directive) {
    const config = directive.toConfig();
    return new GraphQLDirective({
      ...config,
      locations: sortBy(config.locations, (x) => x),
      args: sortArgs(config.args),
    });
  }

  function sortArgs(args) {
    return sortObjMap(args, (arg) => ({ ...arg, type: replaceType(arg.type) }));
  }

  function sortFields(fieldsMap) {
    return sortObjMap(fieldsMap, (field) => ({
      ...field,
      type: replaceType(field.type),
      args: field.args && sortArgs(field.args),
    }));
  }

  function sortInputFields(fieldsMap) {
    return sortObjMap(fieldsMap, (field) => ({
      ...field,
      type: replaceType(field.type),
    }));
  }

  function sortTypes(array) {
    return sortByName(array).map(replaceNamedType);
  }

  function sortNamedType(type) {
    if (isScalarType(type) || isIntrospectionType(type)) {
      return type;
    }

    if (isObjectType(type)) {
      const config = type.toConfig();
      return new GraphQLObjectType({
        ...config,
        interfaces: () => sortTypes(config.interfaces),
        fields: () => sortFields(config.fields),
      });
    }

    if (isInterfaceType(type)) {
      const config = type.toConfig();
      return new GraphQLInterfaceType({
        ...config,
        interfaces: () => sortTypes(config.interfaces),
        fields: () => sortFields(config.fields),
      });
    }

    if (isUnionType(type)) {
      const config = type.toConfig();
      return new GraphQLUnionType({
        ...config,
        types: () => sortTypes(config.types),
      });
    }

    if (isEnumType(type)) {
      const config = type.toConfig();
      return new GraphQLEnumType({
        ...config,
        values: sortObjMap(config.values, (value) => value),
      });
    }

    if (isInputObjectType(type)) {
      const config = type.toConfig();
      return new GraphQLInputObjectType({
        ...config,
        fields: () => sortInputFields(config.fields),
      });
    }
    /* c8 ignore next 3 */
    // Not reachable, all possible types have been considered.

     false || (0,invariant/* invariant */.k)(false, 'Unexpected type: ' + (0,inspect/* inspect */.X)(type));
  }
}

function sortObjMap(map, sortValueFn) {
  const sortedMap = Object.create(null);

  for (const key of Object.keys(map).sort(naturalCompare)) {
    sortedMap[key] = sortValueFn(map[key]);
  }

  return sortedMap;
}

function sortByName(array) {
  return sortBy(array, (obj) => obj.name);
}

function sortBy(array, mapToKey) {
  return array.slice().sort((obj1, obj2) => {
    const key1 = mapToKey(obj1);
    const key2 = mapToKey(obj2);
    return naturalCompare(key1, key2);
  });
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/printSchema.mjs










function printSchema(schema) {
  return printFilteredSchema(
    schema,
    (n) => !isSpecifiedDirective(n),
    isDefinedType,
  );
}
function printIntrospectionSchema(schema) {
  return printFilteredSchema(schema, isSpecifiedDirective, isIntrospectionType);
}

function isDefinedType(type) {
  return !isSpecifiedScalarType(type) && !isIntrospectionType(type);
}

function printFilteredSchema(schema, directiveFilter, typeFilter) {
  const directives = schema.getDirectives().filter(directiveFilter);
  const types = Object.values(schema.getTypeMap()).filter(typeFilter);
  return [
    printSchemaDefinition(schema),
    ...directives.map((directive) => printDirective(directive)),
    ...types.map((type) => printType(type)),
  ]
    .filter(Boolean)
    .join('\n\n');
}

function printSchemaDefinition(schema) {
  if (schema.description == null && isSchemaOfCommonNames(schema)) {
    return;
  }

  const operationTypes = [];
  const queryType = schema.getQueryType();

  if (queryType) {
    operationTypes.push(`  query: ${queryType.name}`);
  }

  const mutationType = schema.getMutationType();

  if (mutationType) {
    operationTypes.push(`  mutation: ${mutationType.name}`);
  }

  const subscriptionType = schema.getSubscriptionType();

  if (subscriptionType) {
    operationTypes.push(`  subscription: ${subscriptionType.name}`);
  }

  return printDescription(schema) + `schema {\n${operationTypes.join('\n')}\n}`;
}
/**
 * GraphQL schema define root types for each type of operation. These types are
 * the same as any other type and can be named in any manner, however there is
 * a common naming convention:
 *
 * ```graphql
 *   schema {
 *     query: Query
 *     mutation: Mutation
 *     subscription: Subscription
 *   }
 * ```
 *
 * When using this naming convention, the schema description can be omitted.
 */

function isSchemaOfCommonNames(schema) {
  const queryType = schema.getQueryType();

  if (queryType && queryType.name !== 'Query') {
    return false;
  }

  const mutationType = schema.getMutationType();

  if (mutationType && mutationType.name !== 'Mutation') {
    return false;
  }

  const subscriptionType = schema.getSubscriptionType();

  if (subscriptionType && subscriptionType.name !== 'Subscription') {
    return false;
  }

  return true;
}

function printType(type) {
  if (isScalarType(type)) {
    return printScalar(type);
  }

  if (isObjectType(type)) {
    return printObject(type);
  }

  if (isInterfaceType(type)) {
    return printInterface(type);
  }

  if (isUnionType(type)) {
    return printUnion(type);
  }

  if (isEnumType(type)) {
    return printEnum(type);
  }

  if (isInputObjectType(type)) {
    return printInputObject(type);
  }
  /* c8 ignore next 3 */
  // Not reachable, all possible types have been considered.

   false || (0,invariant/* invariant */.k)(false, 'Unexpected type: ' + (0,inspect/* inspect */.X)(type));
}

function printScalar(type) {
  return (
    printDescription(type) + `scalar ${type.name}` + printSpecifiedByURL(type)
  );
}

function printImplementedInterfaces(type) {
  const interfaces = type.getInterfaces();
  return interfaces.length
    ? ' implements ' + interfaces.map((i) => i.name).join(' & ')
    : '';
}

function printObject(type) {
  return (
    printDescription(type) +
    `type ${type.name}` +
    printImplementedInterfaces(type) +
    printFields(type)
  );
}

function printInterface(type) {
  return (
    printDescription(type) +
    `interface ${type.name}` +
    printImplementedInterfaces(type) +
    printFields(type)
  );
}

function printUnion(type) {
  const types = type.getTypes();
  const possibleTypes = types.length ? ' = ' + types.join(' | ') : '';
  return printDescription(type) + 'union ' + type.name + possibleTypes;
}

function printEnum(type) {
  const values = type
    .getValues()
    .map(
      (value, i) =>
        printDescription(value, '  ', !i) +
        '  ' +
        value.name +
        printDeprecated(value.deprecationReason),
    );
  return printDescription(type) + `enum ${type.name}` + printBlock(values);
}

function printInputObject(type) {
  const fields = Object.values(type.getFields()).map(
    (f, i) => printDescription(f, '  ', !i) + '  ' + printInputValue(f),
  );
  return (
    printDescription(type) +
    `input ${type.name}` +
    (type.isOneOf ? ' @oneOf' : '') +
    printBlock(fields)
  );
}

function printFields(type) {
  const fields = Object.values(type.getFields()).map(
    (f, i) =>
      printDescription(f, '  ', !i) +
      '  ' +
      f.name +
      printArgs(f.args, '  ') +
      ': ' +
      String(f.type) +
      printDeprecated(f.deprecationReason),
  );
  return printBlock(fields);
}

function printBlock(items) {
  return items.length !== 0 ? ' {\n' + items.join('\n') + '\n}' : '';
}

function printArgs(args, indentation = '') {
  if (args.length === 0) {
    return '';
  } // If every arg does not have a description, print them on one line.

  if (args.every((arg) => !arg.description)) {
    return '(' + args.map(printInputValue).join(', ') + ')';
  }

  return (
    '(\n' +
    args
      .map(
        (arg, i) =>
          printDescription(arg, '  ' + indentation, !i) +
          '  ' +
          indentation +
          printInputValue(arg),
      )
      .join('\n') +
    '\n' +
    indentation +
    ')'
  );
}

function printInputValue(arg) {
  const defaultAST = astFromValue(arg.defaultValue, arg.type);
  let argDecl = arg.name + ': ' + String(arg.type);

  if (defaultAST) {
    argDecl += ` = ${print(defaultAST)}`;
  }

  return argDecl + printDeprecated(arg.deprecationReason);
}

function printDirective(directive) {
  return (
    printDescription(directive) +
    'directive @' +
    directive.name +
    printArgs(directive.args) +
    (directive.isRepeatable ? ' repeatable' : '') +
    ' on ' +
    directive.locations.join(' | ')
  );
}

function printDeprecated(reason) {
  if (reason == null) {
    return '';
  }

  if (reason !== DEFAULT_DEPRECATION_REASON) {
    const astValue = print({
      kind: kinds/* Kind.STRING */.h.STRING,
      value: reason,
    });
    return ` @deprecated(reason: ${astValue})`;
  }

  return ' @deprecated';
}

function printSpecifiedByURL(scalar) {
  if (scalar.specifiedByURL == null) {
    return '';
  }

  const astValue = print({
    kind: kinds/* Kind.STRING */.h.STRING,
    value: scalar.specifiedByURL,
  });
  return ` @specifiedBy(url: ${astValue})`;
}

function printDescription(def, indentation = '', firstInBlock = true) {
  const { description } = def;

  if (description == null) {
    return '';
  }

  const blockString = print({
    kind: kinds/* Kind.STRING */.h.STRING,
    value: description,
    block: (0,language_blockString/* isPrintableAsBlockString */.MZ)(description),
  });
  const prefix =
    indentation && !firstInBlock ? '\n' + indentation : indentation;
  return prefix + blockString.replace(/\n/g, '\n' + indentation) + '\n';
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/concatAST.mjs

/**
 * Provided a collection of ASTs, presumably each from different files,
 * concatenate the ASTs together into batched AST, useful for validating many
 * GraphQL source files which together represent one conceptual application.
 */

function concatAST(documents) {
  const definitions = [];

  for (const doc of documents) {
    definitions.push(...doc.definitions);
  }

  return {
    kind: kinds/* Kind.DOCUMENT */.h.DOCUMENT,
    definitions,
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/separateOperations.mjs


/**
 * separateOperations accepts a single AST document which may contain many
 * operations and fragments and returns a collection of AST documents each of
 * which contains a single operation as well the fragment definitions it
 * refers to.
 */

function separateOperations(documentAST) {
  const operations = [];
  const depGraph = Object.create(null); // Populate metadata and build a dependency graph.

  for (const definitionNode of documentAST.definitions) {
    switch (definitionNode.kind) {
      case kinds/* Kind.OPERATION_DEFINITION */.h.OPERATION_DEFINITION:
        operations.push(definitionNode);
        break;

      case kinds/* Kind.FRAGMENT_DEFINITION */.h.FRAGMENT_DEFINITION:
        depGraph[definitionNode.name.value] = collectDependencies(
          definitionNode.selectionSet,
        );
        break;

      default: // ignore non-executable definitions
    }
  } // For each operation, produce a new synthesized AST which includes only what
  // is necessary for completing that operation.

  const separatedDocumentASTs = Object.create(null);

  for (const operation of operations) {
    const dependencies = new Set();

    for (const fragmentName of collectDependencies(operation.selectionSet)) {
      collectTransitiveDependencies(dependencies, depGraph, fragmentName);
    } // Provides the empty string for anonymous operations.

    const operationName = operation.name ? operation.name.value : ''; // The list of definition nodes to be included for this operation, sorted
    // to retain the same order as the original document.

    separatedDocumentASTs[operationName] = {
      kind: kinds/* Kind.DOCUMENT */.h.DOCUMENT,
      definitions: documentAST.definitions.filter(
        (node) =>
          node === operation ||
          (node.kind === kinds/* Kind.FRAGMENT_DEFINITION */.h.FRAGMENT_DEFINITION &&
            dependencies.has(node.name.value)),
      ),
    };
  }

  return separatedDocumentASTs;
}

// From a dependency graph, collects a list of transitive dependencies by
// recursing through a dependency graph.
function collectTransitiveDependencies(collected, depGraph, fromName) {
  if (!collected.has(fromName)) {
    collected.add(fromName);
    const immediateDeps = depGraph[fromName];

    if (immediateDeps !== undefined) {
      for (const toName of immediateDeps) {
        collectTransitiveDependencies(collected, depGraph, toName);
      }
    }
  }
}

function collectDependencies(selectionSet) {
  const dependencies = [];
  visit(selectionSet, {
    FragmentSpread(node) {
      dependencies.push(node.name.value);
    },
  });
  return dependencies;
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/stripIgnoredCharacters.mjs




/**
 * Strips characters that are not significant to the validity or execution
 * of a GraphQL document:
 *   - UnicodeBOM
 *   - WhiteSpace
 *   - LineTerminator
 *   - Comment
 *   - Comma
 *   - BlockString indentation
 *
 * Note: It is required to have a delimiter character between neighboring
 * non-punctuator tokens and this function always uses single space as delimiter.
 *
 * It is guaranteed that both input and output documents if parsed would result
 * in the exact same AST except for nodes location.
 *
 * Warning: It is guaranteed that this function will always produce stable results.
 * However, it's not guaranteed that it will stay the same between different
 * releases due to bugfixes or changes in the GraphQL specification.
 *
 * Query example:
 *
 * ```graphql
 * query SomeQuery($foo: String!, $bar: String) {
 *   someField(foo: $foo, bar: $bar) {
 *     a
 *     b {
 *       c
 *       d
 *     }
 *   }
 * }
 * ```
 *
 * Becomes:
 *
 * ```graphql
 * query SomeQuery($foo:String!$bar:String){someField(foo:$foo bar:$bar){a b{c d}}}
 * ```
 *
 * SDL example:
 *
 * ```graphql
 * """
 * Type description
 * """
 * type Foo {
 *   """
 *   Field description
 *   """
 *   bar: String
 * }
 * ```
 *
 * Becomes:
 *
 * ```graphql
 * """Type description""" type Foo{"""Field description""" bar:String}
 * ```
 */

function stripIgnoredCharacters(source) {
  const sourceObj = (0,language_source/* isSource */.T)(source) ? source : new language_source/* Source */.H(source);
  const body = sourceObj.body;
  const lexer = new language_lexer/* Lexer */.h(sourceObj);
  let strippedBody = '';
  let wasLastAddedTokenNonPunctuator = false;

  while (lexer.advance().kind !== language_tokenKind/* TokenKind.EOF */.T.EOF) {
    const currentToken = lexer.token;
    const tokenKind = currentToken.kind;
    /**
     * Every two non-punctuator tokens should have space between them.
     * Also prevent case of non-punctuator token following by spread resulting
     * in invalid token (e.g. `1...` is invalid Float token).
     */

    const isNonPunctuator = !(0,language_lexer/* isPunctuatorTokenKind */.u)(currentToken.kind);

    if (wasLastAddedTokenNonPunctuator) {
      if (isNonPunctuator || currentToken.kind === language_tokenKind/* TokenKind.SPREAD */.T.SPREAD) {
        strippedBody += ' ';
      }
    }

    const tokenBody = body.slice(currentToken.start, currentToken.end);

    if (tokenKind === language_tokenKind/* TokenKind.BLOCK_STRING */.T.BLOCK_STRING) {
      strippedBody += (0,language_blockString/* printBlockString */.LZ)(currentToken.value, {
        minimize: true,
      });
    } else {
      strippedBody += tokenBody;
    }

    wasLastAddedTokenNonPunctuator = isNonPunctuator;
  }

  return strippedBody;
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/assertValidName.mjs



/* c8 ignore start */

/**
 * Upholds the spec rules about naming.
 * @deprecated Please use `assertName` instead. Will be removed in v17
 */

function assertValidName(name) {
  const error = isValidNameError(name);

  if (error) {
    throw error;
  }

  return name;
}
/**
 * Returns an Error if a name is invalid.
 * @deprecated Please use `assertName` instead. Will be removed in v17
 */

function isValidNameError(name) {
  typeof name === 'string' || (0,devAssert/* devAssert */.a)(false, 'Expected name to be a string.');

  if (name.startsWith('__')) {
    return new GraphQLError/* GraphQLError */.__(
      `Name "${name}" must not begin with "__", which is reserved by GraphQL introspection.`,
    );
  }

  try {
    assertName(name);
  } catch (error) {
    return error;
  }
}
/* c8 ignore stop */

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/findBreakingChanges.mjs








var BreakingChangeType;

(function (BreakingChangeType) {
  BreakingChangeType['TYPE_REMOVED'] = 'TYPE_REMOVED';
  BreakingChangeType['TYPE_CHANGED_KIND'] = 'TYPE_CHANGED_KIND';
  BreakingChangeType['TYPE_REMOVED_FROM_UNION'] = 'TYPE_REMOVED_FROM_UNION';
  BreakingChangeType['VALUE_REMOVED_FROM_ENUM'] = 'VALUE_REMOVED_FROM_ENUM';
  BreakingChangeType['REQUIRED_INPUT_FIELD_ADDED'] =
    'REQUIRED_INPUT_FIELD_ADDED';
  BreakingChangeType['IMPLEMENTED_INTERFACE_REMOVED'] =
    'IMPLEMENTED_INTERFACE_REMOVED';
  BreakingChangeType['FIELD_REMOVED'] = 'FIELD_REMOVED';
  BreakingChangeType['FIELD_CHANGED_KIND'] = 'FIELD_CHANGED_KIND';
  BreakingChangeType['REQUIRED_ARG_ADDED'] = 'REQUIRED_ARG_ADDED';
  BreakingChangeType['ARG_REMOVED'] = 'ARG_REMOVED';
  BreakingChangeType['ARG_CHANGED_KIND'] = 'ARG_CHANGED_KIND';
  BreakingChangeType['DIRECTIVE_REMOVED'] = 'DIRECTIVE_REMOVED';
  BreakingChangeType['DIRECTIVE_ARG_REMOVED'] = 'DIRECTIVE_ARG_REMOVED';
  BreakingChangeType['REQUIRED_DIRECTIVE_ARG_ADDED'] =
    'REQUIRED_DIRECTIVE_ARG_ADDED';
  BreakingChangeType['DIRECTIVE_REPEATABLE_REMOVED'] =
    'DIRECTIVE_REPEATABLE_REMOVED';
  BreakingChangeType['DIRECTIVE_LOCATION_REMOVED'] =
    'DIRECTIVE_LOCATION_REMOVED';
})(BreakingChangeType || (BreakingChangeType = {}));


var DangerousChangeType;

(function (DangerousChangeType) {
  DangerousChangeType['VALUE_ADDED_TO_ENUM'] = 'VALUE_ADDED_TO_ENUM';
  DangerousChangeType['TYPE_ADDED_TO_UNION'] = 'TYPE_ADDED_TO_UNION';
  DangerousChangeType['OPTIONAL_INPUT_FIELD_ADDED'] =
    'OPTIONAL_INPUT_FIELD_ADDED';
  DangerousChangeType['OPTIONAL_ARG_ADDED'] = 'OPTIONAL_ARG_ADDED';
  DangerousChangeType['IMPLEMENTED_INTERFACE_ADDED'] =
    'IMPLEMENTED_INTERFACE_ADDED';
  DangerousChangeType['ARG_DEFAULT_VALUE_CHANGE'] = 'ARG_DEFAULT_VALUE_CHANGE';
})(DangerousChangeType || (DangerousChangeType = {}));



/**
 * Given two schemas, returns an Array containing descriptions of all the types
 * of breaking changes covered by the other functions down below.
 */
function findBreakingChanges(oldSchema, newSchema) {
  // @ts-expect-error
  return findSchemaChanges(oldSchema, newSchema).filter(
    (change) => change.type in BreakingChangeType,
  );
}
/**
 * Given two schemas, returns an Array containing descriptions of all the types
 * of potentially dangerous changes covered by the other functions down below.
 */

function findDangerousChanges(oldSchema, newSchema) {
  // @ts-expect-error
  return findSchemaChanges(oldSchema, newSchema).filter(
    (change) => change.type in DangerousChangeType,
  );
}

function findSchemaChanges(oldSchema, newSchema) {
  return [
    ...findTypeChanges(oldSchema, newSchema),
    ...findDirectiveChanges(oldSchema, newSchema),
  ];
}

function findDirectiveChanges(oldSchema, newSchema) {
  const schemaChanges = [];
  const directivesDiff = diff(
    oldSchema.getDirectives(),
    newSchema.getDirectives(),
  );

  for (const oldDirective of directivesDiff.removed) {
    schemaChanges.push({
      type: BreakingChangeType.DIRECTIVE_REMOVED,
      description: `${oldDirective.name} was removed.`,
    });
  }

  for (const [oldDirective, newDirective] of directivesDiff.persisted) {
    const argsDiff = diff(oldDirective.args, newDirective.args);

    for (const newArg of argsDiff.added) {
      if (isRequiredArgument(newArg)) {
        schemaChanges.push({
          type: BreakingChangeType.REQUIRED_DIRECTIVE_ARG_ADDED,
          description: `A required arg ${newArg.name} on directive ${oldDirective.name} was added.`,
        });
      }
    }

    for (const oldArg of argsDiff.removed) {
      schemaChanges.push({
        type: BreakingChangeType.DIRECTIVE_ARG_REMOVED,
        description: `${oldArg.name} was removed from ${oldDirective.name}.`,
      });
    }

    if (oldDirective.isRepeatable && !newDirective.isRepeatable) {
      schemaChanges.push({
        type: BreakingChangeType.DIRECTIVE_REPEATABLE_REMOVED,
        description: `Repeatable flag was removed from ${oldDirective.name}.`,
      });
    }

    for (const location of oldDirective.locations) {
      if (!newDirective.locations.includes(location)) {
        schemaChanges.push({
          type: BreakingChangeType.DIRECTIVE_LOCATION_REMOVED,
          description: `${location} was removed from ${oldDirective.name}.`,
        });
      }
    }
  }

  return schemaChanges;
}

function findTypeChanges(oldSchema, newSchema) {
  const schemaChanges = [];
  const typesDiff = diff(
    Object.values(oldSchema.getTypeMap()),
    Object.values(newSchema.getTypeMap()),
  );

  for (const oldType of typesDiff.removed) {
    schemaChanges.push({
      type: BreakingChangeType.TYPE_REMOVED,
      description: isSpecifiedScalarType(oldType)
        ? `Standard scalar ${oldType.name} was removed because it is not referenced anymore.`
        : `${oldType.name} was removed.`,
    });
  }

  for (const [oldType, newType] of typesDiff.persisted) {
    if (isEnumType(oldType) && isEnumType(newType)) {
      schemaChanges.push(...findEnumTypeChanges(oldType, newType));
    } else if (isUnionType(oldType) && isUnionType(newType)) {
      schemaChanges.push(...findUnionTypeChanges(oldType, newType));
    } else if (isInputObjectType(oldType) && isInputObjectType(newType)) {
      schemaChanges.push(...findInputObjectTypeChanges(oldType, newType));
    } else if (isObjectType(oldType) && isObjectType(newType)) {
      schemaChanges.push(
        ...findFieldChanges(oldType, newType),
        ...findImplementedInterfacesChanges(oldType, newType),
      );
    } else if (isInterfaceType(oldType) && isInterfaceType(newType)) {
      schemaChanges.push(
        ...findFieldChanges(oldType, newType),
        ...findImplementedInterfacesChanges(oldType, newType),
      );
    } else if (oldType.constructor !== newType.constructor) {
      schemaChanges.push({
        type: BreakingChangeType.TYPE_CHANGED_KIND,
        description:
          `${oldType.name} changed from ` +
          `${typeKindName(oldType)} to ${typeKindName(newType)}.`,
      });
    }
  }

  return schemaChanges;
}

function findInputObjectTypeChanges(oldType, newType) {
  const schemaChanges = [];
  const fieldsDiff = diff(
    Object.values(oldType.getFields()),
    Object.values(newType.getFields()),
  );

  for (const newField of fieldsDiff.added) {
    if (isRequiredInputField(newField)) {
      schemaChanges.push({
        type: BreakingChangeType.REQUIRED_INPUT_FIELD_ADDED,
        description: `A required field ${newField.name} on input type ${oldType.name} was added.`,
      });
    } else {
      schemaChanges.push({
        type: DangerousChangeType.OPTIONAL_INPUT_FIELD_ADDED,
        description: `An optional field ${newField.name} on input type ${oldType.name} was added.`,
      });
    }
  }

  for (const oldField of fieldsDiff.removed) {
    schemaChanges.push({
      type: BreakingChangeType.FIELD_REMOVED,
      description: `${oldType.name}.${oldField.name} was removed.`,
    });
  }

  for (const [oldField, newField] of fieldsDiff.persisted) {
    const isSafe = isChangeSafeForInputObjectFieldOrFieldArg(
      oldField.type,
      newField.type,
    );

    if (!isSafe) {
      schemaChanges.push({
        type: BreakingChangeType.FIELD_CHANGED_KIND,
        description:
          `${oldType.name}.${oldField.name} changed type from ` +
          `${String(oldField.type)} to ${String(newField.type)}.`,
      });
    }
  }

  return schemaChanges;
}

function findUnionTypeChanges(oldType, newType) {
  const schemaChanges = [];
  const possibleTypesDiff = diff(oldType.getTypes(), newType.getTypes());

  for (const newPossibleType of possibleTypesDiff.added) {
    schemaChanges.push({
      type: DangerousChangeType.TYPE_ADDED_TO_UNION,
      description: `${newPossibleType.name} was added to union type ${oldType.name}.`,
    });
  }

  for (const oldPossibleType of possibleTypesDiff.removed) {
    schemaChanges.push({
      type: BreakingChangeType.TYPE_REMOVED_FROM_UNION,
      description: `${oldPossibleType.name} was removed from union type ${oldType.name}.`,
    });
  }

  return schemaChanges;
}

function findEnumTypeChanges(oldType, newType) {
  const schemaChanges = [];
  const valuesDiff = diff(oldType.getValues(), newType.getValues());

  for (const newValue of valuesDiff.added) {
    schemaChanges.push({
      type: DangerousChangeType.VALUE_ADDED_TO_ENUM,
      description: `${newValue.name} was added to enum type ${oldType.name}.`,
    });
  }

  for (const oldValue of valuesDiff.removed) {
    schemaChanges.push({
      type: BreakingChangeType.VALUE_REMOVED_FROM_ENUM,
      description: `${oldValue.name} was removed from enum type ${oldType.name}.`,
    });
  }

  return schemaChanges;
}

function findImplementedInterfacesChanges(oldType, newType) {
  const schemaChanges = [];
  const interfacesDiff = diff(oldType.getInterfaces(), newType.getInterfaces());

  for (const newInterface of interfacesDiff.added) {
    schemaChanges.push({
      type: DangerousChangeType.IMPLEMENTED_INTERFACE_ADDED,
      description: `${newInterface.name} added to interfaces implemented by ${oldType.name}.`,
    });
  }

  for (const oldInterface of interfacesDiff.removed) {
    schemaChanges.push({
      type: BreakingChangeType.IMPLEMENTED_INTERFACE_REMOVED,
      description: `${oldType.name} no longer implements interface ${oldInterface.name}.`,
    });
  }

  return schemaChanges;
}

function findFieldChanges(oldType, newType) {
  const schemaChanges = [];
  const fieldsDiff = diff(
    Object.values(oldType.getFields()),
    Object.values(newType.getFields()),
  );

  for (const oldField of fieldsDiff.removed) {
    schemaChanges.push({
      type: BreakingChangeType.FIELD_REMOVED,
      description: `${oldType.name}.${oldField.name} was removed.`,
    });
  }

  for (const [oldField, newField] of fieldsDiff.persisted) {
    schemaChanges.push(...findArgChanges(oldType, oldField, newField));
    const isSafe = isChangeSafeForObjectOrInterfaceField(
      oldField.type,
      newField.type,
    );

    if (!isSafe) {
      schemaChanges.push({
        type: BreakingChangeType.FIELD_CHANGED_KIND,
        description:
          `${oldType.name}.${oldField.name} changed type from ` +
          `${String(oldField.type)} to ${String(newField.type)}.`,
      });
    }
  }

  return schemaChanges;
}

function findArgChanges(oldType, oldField, newField) {
  const schemaChanges = [];
  const argsDiff = diff(oldField.args, newField.args);

  for (const oldArg of argsDiff.removed) {
    schemaChanges.push({
      type: BreakingChangeType.ARG_REMOVED,
      description: `${oldType.name}.${oldField.name} arg ${oldArg.name} was removed.`,
    });
  }

  for (const [oldArg, newArg] of argsDiff.persisted) {
    const isSafe = isChangeSafeForInputObjectFieldOrFieldArg(
      oldArg.type,
      newArg.type,
    );

    if (!isSafe) {
      schemaChanges.push({
        type: BreakingChangeType.ARG_CHANGED_KIND,
        description:
          `${oldType.name}.${oldField.name} arg ${oldArg.name} has changed type from ` +
          `${String(oldArg.type)} to ${String(newArg.type)}.`,
      });
    } else if (oldArg.defaultValue !== undefined) {
      if (newArg.defaultValue === undefined) {
        schemaChanges.push({
          type: DangerousChangeType.ARG_DEFAULT_VALUE_CHANGE,
          description: `${oldType.name}.${oldField.name} arg ${oldArg.name} defaultValue was removed.`,
        });
      } else {
        // Since we looking only for client's observable changes we should
        // compare default values in the same representation as they are
        // represented inside introspection.
        const oldValueStr = findBreakingChanges_stringifyValue(oldArg.defaultValue, oldArg.type);
        const newValueStr = findBreakingChanges_stringifyValue(newArg.defaultValue, newArg.type);

        if (oldValueStr !== newValueStr) {
          schemaChanges.push({
            type: DangerousChangeType.ARG_DEFAULT_VALUE_CHANGE,
            description: `${oldType.name}.${oldField.name} arg ${oldArg.name} has changed defaultValue from ${oldValueStr} to ${newValueStr}.`,
          });
        }
      }
    }
  }

  for (const newArg of argsDiff.added) {
    if (isRequiredArgument(newArg)) {
      schemaChanges.push({
        type: BreakingChangeType.REQUIRED_ARG_ADDED,
        description: `A required arg ${newArg.name} on ${oldType.name}.${oldField.name} was added.`,
      });
    } else {
      schemaChanges.push({
        type: DangerousChangeType.OPTIONAL_ARG_ADDED,
        description: `An optional arg ${newArg.name} on ${oldType.name}.${oldField.name} was added.`,
      });
    }
  }

  return schemaChanges;
}

function isChangeSafeForObjectOrInterfaceField(oldType, newType) {
  if (isListType(oldType)) {
    return (
      // if they're both lists, make sure the underlying types are compatible
      (isListType(newType) &&
        isChangeSafeForObjectOrInterfaceField(
          oldType.ofType,
          newType.ofType,
        )) || // moving from nullable to non-null of the same underlying type is safe
      (isNonNullType(newType) &&
        isChangeSafeForObjectOrInterfaceField(oldType, newType.ofType))
    );
  }

  if (isNonNullType(oldType)) {
    // if they're both non-null, make sure the underlying types are compatible
    return (
      isNonNullType(newType) &&
      isChangeSafeForObjectOrInterfaceField(oldType.ofType, newType.ofType)
    );
  }

  return (
    // if they're both named types, see if their names are equivalent
    (isNamedType(newType) && oldType.name === newType.name) || // moving from nullable to non-null of the same underlying type is safe
    (isNonNullType(newType) &&
      isChangeSafeForObjectOrInterfaceField(oldType, newType.ofType))
  );
}

function isChangeSafeForInputObjectFieldOrFieldArg(oldType, newType) {
  if (isListType(oldType)) {
    // if they're both lists, make sure the underlying types are compatible
    return (
      isListType(newType) &&
      isChangeSafeForInputObjectFieldOrFieldArg(oldType.ofType, newType.ofType)
    );
  }

  if (isNonNullType(oldType)) {
    return (
      // if they're both non-null, make sure the underlying types are
      // compatible
      (isNonNullType(newType) &&
        isChangeSafeForInputObjectFieldOrFieldArg(
          oldType.ofType,
          newType.ofType,
        )) || // moving from non-null to nullable of the same underlying type is safe
      (!isNonNullType(newType) &&
        isChangeSafeForInputObjectFieldOrFieldArg(oldType.ofType, newType))
    );
  } // if they're both named types, see if their names are equivalent

  return isNamedType(newType) && oldType.name === newType.name;
}

function typeKindName(type) {
  if (isScalarType(type)) {
    return 'a Scalar type';
  }

  if (isObjectType(type)) {
    return 'an Object type';
  }

  if (isInterfaceType(type)) {
    return 'an Interface type';
  }

  if (isUnionType(type)) {
    return 'a Union type';
  }

  if (isEnumType(type)) {
    return 'an Enum type';
  }

  if (isInputObjectType(type)) {
    return 'an Input type';
  }
  /* c8 ignore next 3 */
  // Not reachable, all possible types have been considered.

   false || (0,invariant/* invariant */.k)(false, 'Unexpected type: ' + (0,inspect/* inspect */.X)(type));
}

function findBreakingChanges_stringifyValue(value, type) {
  const ast = astFromValue(value, type);
  ast != null || (0,invariant/* invariant */.k)(false);
  return print(sortValueNode(ast));
}

function diff(oldArray, newArray) {
  const added = [];
  const removed = [];
  const persisted = [];
  const oldMap = keyMap(oldArray, ({ name }) => name);
  const newMap = keyMap(newArray, ({ name }) => name);

  for (const oldItem of oldArray) {
    const newItem = newMap[oldItem.name];

    if (newItem === undefined) {
      removed.push(oldItem);
    } else {
      persisted.push([oldItem, newItem]);
    }
  }

  for (const newItem of newArray) {
    if (oldMap[newItem.name] === undefined) {
      added.push(newItem);
    }
  }

  return {
    added,
    persisted,
    removed,
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/index.mjs
/**
 * GraphQL.js provides a reference implementation for the GraphQL specification
 * but is also a useful utility for operating on GraphQL files and building
 * sophisticated tools.
 *
 * This primary module exports a general purpose function for fulfilling all
 * steps of the GraphQL specification in a single operation, but also includes
 * utilities for every part of the GraphQL specification:
 *
 *   - Parsing the GraphQL language.
 *   - Building a GraphQL type schema.
 *   - Validating a GraphQL request against a type schema.
 *   - Executing a GraphQL request against a type schema.
 *
 * This also includes utility functions for operating on GraphQL types and
 * GraphQL documents to facilitate building tools.
 *
 * You may also import from each sub-directory directly. For example, the
 * following two import statements are equivalent:
 *
 * ```ts
 * import { parse } from 'graphql';
 * import { parse } from 'graphql/language';
 * ```
 *
 * @packageDocumentation
 */
// The GraphQL.js version info.
 // The primary entry point into fulfilling a GraphQL request.

 // Create and operate on GraphQL type definitions and schema.


// Parse and operate on GraphQL language source files.

// Execute GraphQL queries.

// Validate GraphQL documents.

// Create, format, and print GraphQL errors.

// Utilities for operating on GraphQL type schema and parsed sources.



/***/ }),

/***/ 34317:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ devAssert; }
/* harmony export */ });
function devAssert(condition, message) {
  const booleanCondition = Boolean(condition);

  if (!booleanCondition) {
    throw new Error(message);
  }
}


/***/ }),

/***/ 59329:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ inspect; }
/* harmony export */ });
const MAX_ARRAY_LENGTH = 10;
const MAX_RECURSIVE_DEPTH = 2;
/**
 * Used to print values in error messages.
 */

function inspect(value) {
  return formatValue(value, []);
}

function formatValue(value, seenValues) {
  switch (typeof value) {
    case 'string':
      return JSON.stringify(value);

    case 'function':
      return value.name ? `[function ${value.name}]` : '[function]';

    case 'object':
      return formatObjectValue(value, seenValues);

    default:
      return String(value);
  }
}

function formatObjectValue(value, previouslySeenValues) {
  if (value === null) {
    return 'null';
  }

  if (previouslySeenValues.includes(value)) {
    return '[Circular]';
  }

  const seenValues = [...previouslySeenValues, value];

  if (isJSONable(value)) {
    const jsonValue = value.toJSON(); // check for infinite recursion

    if (jsonValue !== value) {
      return typeof jsonValue === 'string'
        ? jsonValue
        : formatValue(jsonValue, seenValues);
    }
  } else if (Array.isArray(value)) {
    return formatArray(value, seenValues);
  }

  return formatObject(value, seenValues);
}

function isJSONable(value) {
  return typeof value.toJSON === 'function';
}

function formatObject(object, seenValues) {
  const entries = Object.entries(object);

  if (entries.length === 0) {
    return '{}';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[' + getObjectTag(object) + ']';
  }

  const properties = entries.map(
    ([key, value]) => key + ': ' + formatValue(value, seenValues),
  );
  return '{ ' + properties.join(', ') + ' }';
}

function formatArray(array, seenValues) {
  if (array.length === 0) {
    return '[]';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[Array]';
  }

  const len = Math.min(MAX_ARRAY_LENGTH, array.length);
  const remaining = array.length - len;
  const items = [];

  for (let i = 0; i < len; ++i) {
    items.push(formatValue(array[i], seenValues));
  }

  if (remaining === 1) {
    items.push('... 1 more item');
  } else if (remaining > 1) {
    items.push(`... ${remaining} more items`);
  }

  return '[' + items.join(', ') + ']';
}

function getObjectTag(object) {
  const tag = Object.prototype.toString
    .call(object)
    .replace(/^\[object /, '')
    .replace(/]$/, '');

  if (tag === 'Object' && typeof object.constructor === 'function') {
    const name = object.constructor.name;

    if (typeof name === 'string' && name !== '') {
      return name;
    }
  }

  return tag;
}


/***/ }),

/***/ 93956:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ instanceOf; }
/* harmony export */ });
/* harmony import */ var _inspect_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59329);

/* c8 ignore next 3 */

const isProduction =
  globalThis.process && // eslint-disable-next-line no-undef
  "production" === 'production';
/**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 * See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
 * See: https://webpack.js.org/guides/production/
 */

const instanceOf =
  /* c8 ignore next 6 */
  // FIXME: https://github.com/graphql/graphql-js/issues/2317
  isProduction
    ? function instanceOf(value, constructor) {
        return value instanceof constructor;
      }
    : function instanceOf(value, constructor) {
        if (value instanceof constructor) {
          return true;
        }

        if (typeof value === 'object' && value !== null) {
          var _value$constructor;

          // Prefer Symbol.toStringTag since it is immune to minification.
          const className = constructor.prototype[Symbol.toStringTag];
          const valueClassName = // We still need to support constructor's name to detect conflicts with older versions of this library.
            Symbol.toStringTag in value // @ts-expect-error TS bug see, https://github.com/microsoft/TypeScript/issues/38009
              ? value[Symbol.toStringTag]
              : (_value$constructor = value.constructor) === null ||
                _value$constructor === void 0
              ? void 0
              : _value$constructor.name;

          if (className === valueClassName) {
            const stringifiedValue = (0,_inspect_mjs__WEBPACK_IMPORTED_MODULE_0__/* .inspect */ .X)(value);
            throw new Error(`Cannot use ${className} "${stringifiedValue}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
          }
        }

        return false;
      };


/***/ }),

/***/ 87021:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ invariant; }
/* harmony export */ });
function invariant(condition, message) {
  const booleanCondition = Boolean(condition);

  if (!booleanCondition) {
    throw new Error(
      message != null ? message : 'Unexpected invariant triggered.',
    );
  }
}


/***/ }),

/***/ 52689:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ isObjectLike; }
/* harmony export */ });
/**
 * Return true if `value` is object-like. A value is object-like if it's not
 * `null` and has a `typeof` result of "object".
 */
function isObjectLike(value) {
  return typeof value == 'object' && value !== null;
}


/***/ }),

/***/ 35239:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "UG": function() { return /* binding */ isNode; },
/* harmony export */   "WU": function() { return /* binding */ Token; },
/* harmony export */   "Ye": function() { return /* binding */ Location; },
/* harmony export */   "h8": function() { return /* binding */ QueryDocumentKeys; },
/* harmony export */   "ku": function() { return /* binding */ OperationTypeNode; }
/* harmony export */ });
/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */
class Location {
  /**
   * The character offset at which this Node begins.
   */

  /**
   * The character offset at which this Node ends.
   */

  /**
   * The Token at which this Node begins.
   */

  /**
   * The Token at which this Node ends.
   */

  /**
   * The Source document the AST represents.
   */
  constructor(startToken, endToken, source) {
    this.start = startToken.start;
    this.end = endToken.end;
    this.startToken = startToken;
    this.endToken = endToken;
    this.source = source;
  }

  get [Symbol.toStringTag]() {
    return 'Location';
  }

  toJSON() {
    return {
      start: this.start,
      end: this.end,
    };
  }
}
/**
 * Represents a range of characters represented by a lexical token
 * within a Source.
 */

class Token {
  /**
   * The kind of Token.
   */

  /**
   * The character offset at which this Node begins.
   */

  /**
   * The character offset at which this Node ends.
   */

  /**
   * The 1-indexed line number on which this Token appears.
   */

  /**
   * The 1-indexed column number at which this Token begins.
   */

  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */

  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  constructor(kind, start, end, line, column, value) {
    this.kind = kind;
    this.start = start;
    this.end = end;
    this.line = line;
    this.column = column; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

    this.value = value;
    this.prev = null;
    this.next = null;
  }

  get [Symbol.toStringTag]() {
    return 'Token';
  }

  toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column,
    };
  }
}
/**
 * The list of all possible AST node types.
 */

/**
 * @internal
 */
const QueryDocumentKeys = {
  Name: [],
  Document: ['definitions'],
  OperationDefinition: [
    'name',
    'variableDefinitions',
    'directives',
    'selectionSet',
  ],
  VariableDefinition: ['variable', 'type', 'defaultValue', 'directives'],
  Variable: ['name'],
  SelectionSet: ['selections'],
  Field: ['alias', 'name', 'arguments', 'directives', 'selectionSet'],
  Argument: ['name', 'value'],
  FragmentSpread: ['name', 'directives'],
  InlineFragment: ['typeCondition', 'directives', 'selectionSet'],
  FragmentDefinition: [
    'name', // Note: fragment variable definitions are deprecated and will removed in v17.0.0
    'variableDefinitions',
    'typeCondition',
    'directives',
    'selectionSet',
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ['values'],
  ObjectValue: ['fields'],
  ObjectField: ['name', 'value'],
  Directive: ['name', 'arguments'],
  NamedType: ['name'],
  ListType: ['type'],
  NonNullType: ['type'],
  SchemaDefinition: ['description', 'directives', 'operationTypes'],
  OperationTypeDefinition: ['type'],
  ScalarTypeDefinition: ['description', 'name', 'directives'],
  ObjectTypeDefinition: [
    'description',
    'name',
    'interfaces',
    'directives',
    'fields',
  ],
  FieldDefinition: ['description', 'name', 'arguments', 'type', 'directives'],
  InputValueDefinition: [
    'description',
    'name',
    'type',
    'defaultValue',
    'directives',
  ],
  InterfaceTypeDefinition: [
    'description',
    'name',
    'interfaces',
    'directives',
    'fields',
  ],
  UnionTypeDefinition: ['description', 'name', 'directives', 'types'],
  EnumTypeDefinition: ['description', 'name', 'directives', 'values'],
  EnumValueDefinition: ['description', 'name', 'directives'],
  InputObjectTypeDefinition: ['description', 'name', 'directives', 'fields'],
  DirectiveDefinition: ['description', 'name', 'arguments', 'locations'],
  SchemaExtension: ['directives', 'operationTypes'],
  ScalarTypeExtension: ['name', 'directives'],
  ObjectTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  InterfaceTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  UnionTypeExtension: ['name', 'directives', 'types'],
  EnumTypeExtension: ['name', 'directives', 'values'],
  InputObjectTypeExtension: ['name', 'directives', 'fields'],
};
const kindValues = new Set(Object.keys(QueryDocumentKeys));
/**
 * @internal
 */

function isNode(maybeNode) {
  const maybeKind =
    maybeNode === null || maybeNode === void 0 ? void 0 : maybeNode.kind;
  return typeof maybeKind === 'string' && kindValues.has(maybeKind);
}
/** Name */

var OperationTypeNode;

(function (OperationTypeNode) {
  OperationTypeNode['QUERY'] = 'query';
  OperationTypeNode['MUTATION'] = 'mutation';
  OperationTypeNode['SUBSCRIPTION'] = 'subscription';
})(OperationTypeNode || (OperationTypeNode = {}));




/***/ }),

/***/ 25965:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LZ": function() { return /* binding */ printBlockString; },
/* harmony export */   "MZ": function() { return /* binding */ isPrintableAsBlockString; },
/* harmony export */   "wv": function() { return /* binding */ dedentBlockStringLines; }
/* harmony export */ });
/* harmony import */ var _characterClasses_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76714);

/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */

function dedentBlockStringLines(lines) {
  var _firstNonEmptyLine2;

  let commonIndent = Number.MAX_SAFE_INTEGER;
  let firstNonEmptyLine = null;
  let lastNonEmptyLine = -1;

  for (let i = 0; i < lines.length; ++i) {
    var _firstNonEmptyLine;

    const line = lines[i];
    const indent = leadingWhitespace(line);

    if (indent === line.length) {
      continue; // skip empty lines
    }

    firstNonEmptyLine =
      (_firstNonEmptyLine = firstNonEmptyLine) !== null &&
      _firstNonEmptyLine !== void 0
        ? _firstNonEmptyLine
        : i;
    lastNonEmptyLine = i;

    if (i !== 0 && indent < commonIndent) {
      commonIndent = indent;
    }
  }

  return lines // Remove common indentation from all lines but first.
    .map((line, i) => (i === 0 ? line : line.slice(commonIndent))) // Remove leading and trailing blank lines.
    .slice(
      (_firstNonEmptyLine2 = firstNonEmptyLine) !== null &&
        _firstNonEmptyLine2 !== void 0
        ? _firstNonEmptyLine2
        : 0,
      lastNonEmptyLine + 1,
    );
}

function leadingWhitespace(str) {
  let i = 0;

  while (i < str.length && (0,_characterClasses_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isWhiteSpace */ .FD)(str.charCodeAt(i))) {
    ++i;
  }

  return i;
}
/**
 * @internal
 */

function isPrintableAsBlockString(value) {
  if (value === '') {
    return true; // empty string is printable
  }

  let isEmptyLine = true;
  let hasIndent = false;
  let hasCommonIndent = true;
  let seenNonEmptyLine = false;

  for (let i = 0; i < value.length; ++i) {
    switch (value.codePointAt(i)) {
      case 0x0000:
      case 0x0001:
      case 0x0002:
      case 0x0003:
      case 0x0004:
      case 0x0005:
      case 0x0006:
      case 0x0007:
      case 0x0008:
      case 0x000b:
      case 0x000c:
      case 0x000e:
      case 0x000f:
        return false;
      // Has non-printable characters

      case 0x000d:
        //  \r
        return false;
      // Has \r or \r\n which will be replaced as \n

      case 10:
        //  \n
        if (isEmptyLine && !seenNonEmptyLine) {
          return false; // Has leading new line
        }

        seenNonEmptyLine = true;
        isEmptyLine = true;
        hasIndent = false;
        break;

      case 9: //   \t

      case 32:
        //  <space>
        hasIndent || (hasIndent = isEmptyLine);
        break;

      default:
        hasCommonIndent && (hasCommonIndent = hasIndent);
        isEmptyLine = false;
    }
  }

  if (isEmptyLine) {
    return false; // Has trailing empty lines
  }

  if (hasCommonIndent && seenNonEmptyLine) {
    return false; // Has internal indent
  }

  return true;
}
/**
 * Print a block string in the indented block form by adding a leading and
 * trailing blank line. However, if a block string starts with whitespace and is
 * a single-line, adding a leading blank line would strip that whitespace.
 *
 * @internal
 */

function printBlockString(value, options) {
  const escapedValue = value.replace(/"""/g, '\\"""'); // Expand a block string's raw value into independent lines.

  const lines = escapedValue.split(/\r\n|[\n\r]/g);
  const isSingleLine = lines.length === 1; // If common indentation is found we can fix some of those cases by adding leading new line

  const forceLeadingNewLine =
    lines.length > 1 &&
    lines
      .slice(1)
      .every((line) => line.length === 0 || (0,_characterClasses_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isWhiteSpace */ .FD)(line.charCodeAt(0))); // Trailing triple quotes just looks confusing but doesn't force trailing new line

  const hasTrailingTripleQuotes = escapedValue.endsWith('\\"""'); // Trailing quote (single or double) or slash forces trailing new line

  const hasTrailingQuote = value.endsWith('"') && !hasTrailingTripleQuotes;
  const hasTrailingSlash = value.endsWith('\\');
  const forceTrailingNewline = hasTrailingQuote || hasTrailingSlash;
  const printAsMultipleLines =
    !(options !== null && options !== void 0 && options.minimize) && // add leading and trailing new lines only if it improves readability
    (!isSingleLine ||
      value.length > 70 ||
      forceTrailingNewline ||
      forceLeadingNewLine ||
      hasTrailingTripleQuotes);
  let result = ''; // Format a multi-line block quote to account for leading space.

  const skipLeadingNewLine = isSingleLine && (0,_characterClasses_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isWhiteSpace */ .FD)(value.charCodeAt(0));

  if ((printAsMultipleLines && !skipLeadingNewLine) || forceLeadingNewLine) {
    result += '\n';
  }

  result += escapedValue;

  if (printAsMultipleLines || forceTrailingNewline) {
    result += '\n';
  }

  return '"""' + result + '"""';
}


/***/ }),

/***/ 76714:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FD": function() { return /* binding */ isWhiteSpace; },
/* harmony export */   "HQ": function() { return /* binding */ isNameContinue; },
/* harmony export */   "LQ": function() { return /* binding */ isNameStart; },
/* harmony export */   "X1": function() { return /* binding */ isDigit; }
/* harmony export */ });
/* unused harmony export isLetter */
/**
 * ```
 * WhiteSpace ::
 *   - "Horizontal Tab (U+0009)"
 *   - "Space (U+0020)"
 * ```
 * @internal
 */
function isWhiteSpace(code) {
  return code === 0x0009 || code === 0x0020;
}
/**
 * ```
 * Digit :: one of
 *   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
 * ```
 * @internal
 */

function isDigit(code) {
  return code >= 0x0030 && code <= 0x0039;
}
/**
 * ```
 * Letter :: one of
 *   - `A` `B` `C` `D` `E` `F` `G` `H` `I` `J` `K` `L` `M`
 *   - `N` `O` `P` `Q` `R` `S` `T` `U` `V` `W` `X` `Y` `Z`
 *   - `a` `b` `c` `d` `e` `f` `g` `h` `i` `j` `k` `l` `m`
 *   - `n` `o` `p` `q` `r` `s` `t` `u` `v` `w` `x` `y` `z`
 * ```
 * @internal
 */

function isLetter(code) {
  return (
    (code >= 0x0061 && code <= 0x007a) || // A-Z
    (code >= 0x0041 && code <= 0x005a) // a-z
  );
}
/**
 * ```
 * NameStart ::
 *   - Letter
 *   - `_`
 * ```
 * @internal
 */

function isNameStart(code) {
  return isLetter(code) || code === 0x005f;
}
/**
 * ```
 * NameContinue ::
 *   - Letter
 *   - Digit
 *   - `_`
 * ```
 * @internal
 */

function isNameContinue(code) {
  return isLetter(code) || isDigit(code) || code === 0x005f;
}


/***/ }),

/***/ 65916:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ DirectiveLocation; }
/* harmony export */ });
/**
 * The set of allowed directive location values.
 */
var DirectiveLocation;

(function (DirectiveLocation) {
  DirectiveLocation['QUERY'] = 'QUERY';
  DirectiveLocation['MUTATION'] = 'MUTATION';
  DirectiveLocation['SUBSCRIPTION'] = 'SUBSCRIPTION';
  DirectiveLocation['FIELD'] = 'FIELD';
  DirectiveLocation['FRAGMENT_DEFINITION'] = 'FRAGMENT_DEFINITION';
  DirectiveLocation['FRAGMENT_SPREAD'] = 'FRAGMENT_SPREAD';
  DirectiveLocation['INLINE_FRAGMENT'] = 'INLINE_FRAGMENT';
  DirectiveLocation['VARIABLE_DEFINITION'] = 'VARIABLE_DEFINITION';
  DirectiveLocation['SCHEMA'] = 'SCHEMA';
  DirectiveLocation['SCALAR'] = 'SCALAR';
  DirectiveLocation['OBJECT'] = 'OBJECT';
  DirectiveLocation['FIELD_DEFINITION'] = 'FIELD_DEFINITION';
  DirectiveLocation['ARGUMENT_DEFINITION'] = 'ARGUMENT_DEFINITION';
  DirectiveLocation['INTERFACE'] = 'INTERFACE';
  DirectiveLocation['UNION'] = 'UNION';
  DirectiveLocation['ENUM'] = 'ENUM';
  DirectiveLocation['ENUM_VALUE'] = 'ENUM_VALUE';
  DirectiveLocation['INPUT_OBJECT'] = 'INPUT_OBJECT';
  DirectiveLocation['INPUT_FIELD_DEFINITION'] = 'INPUT_FIELD_DEFINITION';
})(DirectiveLocation || (DirectiveLocation = {}));


/**
 * The enum type representing the directive location values.
 *
 * @deprecated Please use `DirectiveLocation`. Will be remove in v17.
 */


/***/ }),

/***/ 57554:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Kind; }
/* harmony export */ });
/**
 * The set of allowed kind values for AST nodes.
 */
var Kind;

(function (Kind) {
  Kind['NAME'] = 'Name';
  Kind['DOCUMENT'] = 'Document';
  Kind['OPERATION_DEFINITION'] = 'OperationDefinition';
  Kind['VARIABLE_DEFINITION'] = 'VariableDefinition';
  Kind['SELECTION_SET'] = 'SelectionSet';
  Kind['FIELD'] = 'Field';
  Kind['ARGUMENT'] = 'Argument';
  Kind['FRAGMENT_SPREAD'] = 'FragmentSpread';
  Kind['INLINE_FRAGMENT'] = 'InlineFragment';
  Kind['FRAGMENT_DEFINITION'] = 'FragmentDefinition';
  Kind['VARIABLE'] = 'Variable';
  Kind['INT'] = 'IntValue';
  Kind['FLOAT'] = 'FloatValue';
  Kind['STRING'] = 'StringValue';
  Kind['BOOLEAN'] = 'BooleanValue';
  Kind['NULL'] = 'NullValue';
  Kind['ENUM'] = 'EnumValue';
  Kind['LIST'] = 'ListValue';
  Kind['OBJECT'] = 'ObjectValue';
  Kind['OBJECT_FIELD'] = 'ObjectField';
  Kind['DIRECTIVE'] = 'Directive';
  Kind['NAMED_TYPE'] = 'NamedType';
  Kind['LIST_TYPE'] = 'ListType';
  Kind['NON_NULL_TYPE'] = 'NonNullType';
  Kind['SCHEMA_DEFINITION'] = 'SchemaDefinition';
  Kind['OPERATION_TYPE_DEFINITION'] = 'OperationTypeDefinition';
  Kind['SCALAR_TYPE_DEFINITION'] = 'ScalarTypeDefinition';
  Kind['OBJECT_TYPE_DEFINITION'] = 'ObjectTypeDefinition';
  Kind['FIELD_DEFINITION'] = 'FieldDefinition';
  Kind['INPUT_VALUE_DEFINITION'] = 'InputValueDefinition';
  Kind['INTERFACE_TYPE_DEFINITION'] = 'InterfaceTypeDefinition';
  Kind['UNION_TYPE_DEFINITION'] = 'UnionTypeDefinition';
  Kind['ENUM_TYPE_DEFINITION'] = 'EnumTypeDefinition';
  Kind['ENUM_VALUE_DEFINITION'] = 'EnumValueDefinition';
  Kind['INPUT_OBJECT_TYPE_DEFINITION'] = 'InputObjectTypeDefinition';
  Kind['DIRECTIVE_DEFINITION'] = 'DirectiveDefinition';
  Kind['SCHEMA_EXTENSION'] = 'SchemaExtension';
  Kind['SCALAR_TYPE_EXTENSION'] = 'ScalarTypeExtension';
  Kind['OBJECT_TYPE_EXTENSION'] = 'ObjectTypeExtension';
  Kind['INTERFACE_TYPE_EXTENSION'] = 'InterfaceTypeExtension';
  Kind['UNION_TYPE_EXTENSION'] = 'UnionTypeExtension';
  Kind['ENUM_TYPE_EXTENSION'] = 'EnumTypeExtension';
  Kind['INPUT_OBJECT_TYPE_EXTENSION'] = 'InputObjectTypeExtension';
})(Kind || (Kind = {}));


/**
 * The enum type representing the possible kind values of AST nodes.
 *
 * @deprecated Please use `Kind`. Will be remove in v17.
 */


/***/ }),

/***/ 78636:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Lexer; },
/* harmony export */   "u": function() { return /* binding */ isPunctuatorTokenKind; }
/* harmony export */ });
/* harmony import */ var _error_syntaxError_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23445);
/* harmony import */ var _ast_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35239);
/* harmony import */ var _blockString_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25965);
/* harmony import */ var _characterClasses_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76714);
/* harmony import */ var _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20471);





/**
 * Given a Source object, creates a Lexer for that source.
 * A Lexer is a stateful stream generator in that every time
 * it is advanced, it returns the next token in the Source. Assuming the
 * source lexes, the final Token emitted by the lexer will be of kind
 * EOF, after which the lexer will repeatedly return the same EOF token
 * whenever called.
 */

class Lexer {
  /**
   * The previously focused non-ignored token.
   */

  /**
   * The currently focused non-ignored token.
   */

  /**
   * The (1-indexed) line containing the current token.
   */

  /**
   * The character offset at which the current line begins.
   */
  constructor(source) {
    const startOfFileToken = new _ast_mjs__WEBPACK_IMPORTED_MODULE_0__/* .Token */ .WU(_tokenKind_mjs__WEBPACK_IMPORTED_MODULE_1__/* .TokenKind.SOF */ .T.SOF, 0, 0, 0, 0);
    this.source = source;
    this.lastToken = startOfFileToken;
    this.token = startOfFileToken;
    this.line = 1;
    this.lineStart = 0;
  }

  get [Symbol.toStringTag]() {
    return 'Lexer';
  }
  /**
   * Advances the token stream to the next non-ignored token.
   */

  advance() {
    this.lastToken = this.token;
    const token = (this.token = this.lookahead());
    return token;
  }
  /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */

  lookahead() {
    let token = this.token;

    if (token.kind !== _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_1__/* .TokenKind.EOF */ .T.EOF) {
      do {
        if (token.next) {
          token = token.next;
        } else {
          // Read the next token and form a link in the token linked-list.
          const nextToken = readNextToken(this, token.end); // @ts-expect-error next is only mutable during parsing.

          token.next = nextToken; // @ts-expect-error prev is only mutable during parsing.

          nextToken.prev = token;
          token = nextToken;
        }
      } while (token.kind === _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_1__/* .TokenKind.COMMENT */ .T.COMMENT);
    }

    return token;
  }
}
/**
 * @internal
 */

function isPunctuatorTokenKind(kind) {
  return (
    kind === _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_1__/* .TokenKind.BANG */ .T.BANG ||
    kind === _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_1__/* .TokenKind.DOLLAR */ .T.DOLLAR ||
    kind === _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_1__/* .TokenKind.AMP */ .T.AMP ||
    kind === _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_1__/* .TokenKind.PAREN_L */ .T.PAREN_L ||
    kind === _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_1__/* .TokenKind.PAREN_R */ .T.PAREN_R ||
    kind === _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_1__/* .TokenKind.SPREAD */ .T.SPREAD ||
    kind === _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_1__/* .TokenKind.COLON */ .T.COLON ||
    kind === _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_1__/* .TokenKind.EQUALS */ .T.EQUALS ||
    kind === _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_1__/* .TokenKind.AT */ .T.AT ||
    kind === _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_1__/* .TokenKind.BRACKET_L */ .T.BRACKET_L ||
    kind === _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_1__/* .TokenKind.BRACKET_R */ .T.BRACKET_R ||
    kind === _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_1__/* .TokenKind.BRACE_L */ .T.BRACE_L ||
    kind === _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_1__/* .TokenKind.PIPE */ .T.PIPE ||
    kind === _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_1__/* .TokenKind.BRACE_R */ .T.BRACE_R
  );
}
/**
 * A Unicode scalar value is any Unicode code point except surrogate code
 * points. In other words, the inclusive ranges of values 0x0000 to 0xD7FF and
 * 0xE000 to 0x10FFFF.
 *
 * SourceCharacter ::
 *   - "Any Unicode scalar value"
 */

function isUnicodeScalarValue(code) {
  return (
    (code >= 0x0000 && code <= 0xd7ff) || (code >= 0xe000 && code <= 0x10ffff)
  );
}
/**
 * The GraphQL specification defines source text as a sequence of unicode scalar
 * values (which Unicode defines to exclude surrogate code points). However
 * JavaScript defines strings as a sequence of UTF-16 code units which may
 * include surrogates. A surrogate pair is a valid source character as it
 * encodes a supplementary code point (above U+FFFF), but unpaired surrogate
 * code points are not valid source characters.
 */

function isSupplementaryCodePoint(body, location) {
  return (
    isLeadingSurrogate(body.charCodeAt(location)) &&
    isTrailingSurrogate(body.charCodeAt(location + 1))
  );
}

function isLeadingSurrogate(code) {
  return code >= 0xd800 && code <= 0xdbff;
}

function isTrailingSurrogate(code) {
  return code >= 0xdc00 && code <= 0xdfff;
}
/**
 * Prints the code point (or end of file reference) at a given location in a
 * source for use in error messages.
 *
 * Printable ASCII is printed quoted, while other points are printed in Unicode
 * code point form (ie. U+1234).
 */

function printCodePointAt(lexer, location) {
  const code = lexer.source.body.codePointAt(location);

  if (code === undefined) {
    return _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_1__/* .TokenKind.EOF */ .T.EOF;
  } else if (code >= 0x0020 && code <= 0x007e) {
    // Printable ASCII
    const char = String.fromCodePoint(code);
    return char === '"' ? "'\"'" : `"${char}"`;
  } // Unicode code point

  return 'U+' + code.toString(16).toUpperCase().padStart(4, '0');
}
/**
 * Create a token with line and column location information.
 */

function createToken(lexer, kind, start, end, value) {
  const line = lexer.line;
  const col = 1 + start - lexer.lineStart;
  return new _ast_mjs__WEBPACK_IMPORTED_MODULE_0__/* .Token */ .WU(kind, start, end, line, col, value);
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */

function readNextToken(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start;

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // SourceCharacter

    switch (code) {
      // Ignored ::
      //   - UnicodeBOM
      //   - WhiteSpace
      //   - LineTerminator
      //   - Comment
      //   - Comma
      //
      // UnicodeBOM :: "Byte Order Mark (U+FEFF)"
      //
      // WhiteSpace ::
      //   - "Horizontal Tab (U+0009)"
      //   - "Space (U+0020)"
      //
      // Comma :: ,
      case 0xfeff: // <BOM>

      case 0x0009: // \t

      case 0x0020: // <space>

      case 0x002c:
        // ,
        ++position;
        continue;
      // LineTerminator ::
      //   - "New Line (U+000A)"
      //   - "Carriage Return (U+000D)" [lookahead != "New Line (U+000A)"]
      //   - "Carriage Return (U+000D)" "New Line (U+000A)"

      case 0x000a:
        // \n
        ++position;
        ++lexer.line;
        lexer.lineStart = position;
        continue;

      case 0x000d:
        // \r
        if (body.charCodeAt(position + 1) === 0x000a) {
          position += 2;
        } else {
          ++position;
        }

        ++lexer.line;
        lexer.lineStart = position;
        continue;
      // Comment

      case 0x0023:
        // #
        return readComment(lexer, position);
      // Token ::
      //   - Punctuator
      //   - Name
      //   - IntValue
      //   - FloatValue
      //   - StringValue
      //
      // Punctuator :: one of ! $ & ( ) ... : = @ [ ] { | }

      case 0x0021:
        // !
        return createToken(lexer, _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_1__/* .TokenKind.BANG */ .T.BANG, position, position + 1);

      case 0x0024:
        // $
        return createToken(lexer, _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_1__/* .TokenKind.DOLLAR */ .T.DOLLAR, position, position + 1);

      case 0x0026:
        // &
        return createToken(lexer, _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_1__/* .TokenKind.AMP */ .T.AMP, position, position + 1);

      case 0x0028:
        // (
        return createToken(lexer, _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_1__/* .TokenKind.PAREN_L */ .T.PAREN_L, position, position + 1);

      case 0x0029:
        // )
        return createToken(lexer, _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_1__/* .TokenKind.PAREN_R */ .T.PAREN_R, position, position + 1);

      case 0x002e:
        // .
        if (
          body.charCodeAt(position + 1) === 0x002e &&
          body.charCodeAt(position + 2) === 0x002e
        ) {
          return createToken(lexer, _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_1__/* .TokenKind.SPREAD */ .T.SPREAD, position, position + 3);
        }

        break;

      case 0x003a:
        // :
        return createToken(lexer, _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_1__/* .TokenKind.COLON */ .T.COLON, position, position + 1);

      case 0x003d:
        // =
        return createToken(lexer, _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_1__/* .TokenKind.EQUALS */ .T.EQUALS, position, position + 1);

      case 0x0040:
        // @
        return createToken(lexer, _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_1__/* .TokenKind.AT */ .T.AT, position, position + 1);

      case 0x005b:
        // [
        return createToken(lexer, _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_1__/* .TokenKind.BRACKET_L */ .T.BRACKET_L, position, position + 1);

      case 0x005d:
        // ]
        return createToken(lexer, _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_1__/* .TokenKind.BRACKET_R */ .T.BRACKET_R, position, position + 1);

      case 0x007b:
        // {
        return createToken(lexer, _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_1__/* .TokenKind.BRACE_L */ .T.BRACE_L, position, position + 1);

      case 0x007c:
        // |
        return createToken(lexer, _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_1__/* .TokenKind.PIPE */ .T.PIPE, position, position + 1);

      case 0x007d:
        // }
        return createToken(lexer, _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_1__/* .TokenKind.BRACE_R */ .T.BRACE_R, position, position + 1);
      // StringValue

      case 0x0022:
        // "
        if (
          body.charCodeAt(position + 1) === 0x0022 &&
          body.charCodeAt(position + 2) === 0x0022
        ) {
          return readBlockString(lexer, position);
        }

        return readString(lexer, position);
    } // IntValue | FloatValue (Digit | -)

    if ((0,_characterClasses_mjs__WEBPACK_IMPORTED_MODULE_2__/* .isDigit */ .X1)(code) || code === 0x002d) {
      return readNumber(lexer, position, code);
    } // Name

    if ((0,_characterClasses_mjs__WEBPACK_IMPORTED_MODULE_2__/* .isNameStart */ .LQ)(code)) {
      return readName(lexer, position);
    }

    throw (0,_error_syntaxError_mjs__WEBPACK_IMPORTED_MODULE_3__/* .syntaxError */ .h)(
      lexer.source,
      position,
      code === 0x0027
        ? 'Unexpected single quote character (\'), did you mean to use a double quote (")?'
        : isUnicodeScalarValue(code) || isSupplementaryCodePoint(body, position)
        ? `Unexpected character: ${printCodePointAt(lexer, position)}.`
        : `Invalid character: ${printCodePointAt(lexer, position)}.`,
    );
  }

  return createToken(lexer, _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_1__/* .TokenKind.EOF */ .T.EOF, bodyLength, bodyLength);
}
/**
 * Reads a comment token from the source file.
 *
 * ```
 * Comment :: # CommentChar* [lookahead != CommentChar]
 *
 * CommentChar :: SourceCharacter but not LineTerminator
 * ```
 */

function readComment(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start + 1;

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // LineTerminator (\n | \r)

    if (code === 0x000a || code === 0x000d) {
      break;
    } // SourceCharacter

    if (isUnicodeScalarValue(code)) {
      ++position;
    } else if (isSupplementaryCodePoint(body, position)) {
      position += 2;
    } else {
      break;
    }
  }

  return createToken(
    lexer,
    _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_1__/* .TokenKind.COMMENT */ .T.COMMENT,
    start,
    position,
    body.slice(start + 1, position),
  );
}
/**
 * Reads a number token from the source file, either a FloatValue or an IntValue
 * depending on whether a FractionalPart or ExponentPart is encountered.
 *
 * ```
 * IntValue :: IntegerPart [lookahead != {Digit, `.`, NameStart}]
 *
 * IntegerPart ::
 *   - NegativeSign? 0
 *   - NegativeSign? NonZeroDigit Digit*
 *
 * NegativeSign :: -
 *
 * NonZeroDigit :: Digit but not `0`
 *
 * FloatValue ::
 *   - IntegerPart FractionalPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart FractionalPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *
 * FractionalPart :: . Digit+
 *
 * ExponentPart :: ExponentIndicator Sign? Digit+
 *
 * ExponentIndicator :: one of `e` `E`
 *
 * Sign :: one of + -
 * ```
 */

function readNumber(lexer, start, firstCode) {
  const body = lexer.source.body;
  let position = start;
  let code = firstCode;
  let isFloat = false; // NegativeSign (-)

  if (code === 0x002d) {
    code = body.charCodeAt(++position);
  } // Zero (0)

  if (code === 0x0030) {
    code = body.charCodeAt(++position);

    if ((0,_characterClasses_mjs__WEBPACK_IMPORTED_MODULE_2__/* .isDigit */ .X1)(code)) {
      throw (0,_error_syntaxError_mjs__WEBPACK_IMPORTED_MODULE_3__/* .syntaxError */ .h)(
        lexer.source,
        position,
        `Invalid number, unexpected digit after 0: ${printCodePointAt(
          lexer,
          position,
        )}.`,
      );
    }
  } else {
    position = readDigits(lexer, position, code);
    code = body.charCodeAt(position);
  } // Full stop (.)

  if (code === 0x002e) {
    isFloat = true;
    code = body.charCodeAt(++position);
    position = readDigits(lexer, position, code);
    code = body.charCodeAt(position);
  } // E e

  if (code === 0x0045 || code === 0x0065) {
    isFloat = true;
    code = body.charCodeAt(++position); // + -

    if (code === 0x002b || code === 0x002d) {
      code = body.charCodeAt(++position);
    }

    position = readDigits(lexer, position, code);
    code = body.charCodeAt(position);
  } // Numbers cannot be followed by . or NameStart

  if (code === 0x002e || (0,_characterClasses_mjs__WEBPACK_IMPORTED_MODULE_2__/* .isNameStart */ .LQ)(code)) {
    throw (0,_error_syntaxError_mjs__WEBPACK_IMPORTED_MODULE_3__/* .syntaxError */ .h)(
      lexer.source,
      position,
      `Invalid number, expected digit but got: ${printCodePointAt(
        lexer,
        position,
      )}.`,
    );
  }

  return createToken(
    lexer,
    isFloat ? _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_1__/* .TokenKind.FLOAT */ .T.FLOAT : _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_1__/* .TokenKind.INT */ .T.INT,
    start,
    position,
    body.slice(start, position),
  );
}
/**
 * Returns the new position in the source after reading one or more digits.
 */

function readDigits(lexer, start, firstCode) {
  if (!(0,_characterClasses_mjs__WEBPACK_IMPORTED_MODULE_2__/* .isDigit */ .X1)(firstCode)) {
    throw (0,_error_syntaxError_mjs__WEBPACK_IMPORTED_MODULE_3__/* .syntaxError */ .h)(
      lexer.source,
      start,
      `Invalid number, expected digit but got: ${printCodePointAt(
        lexer,
        start,
      )}.`,
    );
  }

  const body = lexer.source.body;
  let position = start + 1; // +1 to skip first firstCode

  while ((0,_characterClasses_mjs__WEBPACK_IMPORTED_MODULE_2__/* .isDigit */ .X1)(body.charCodeAt(position))) {
    ++position;
  }

  return position;
}
/**
 * Reads a single-quote string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `""` [lookahead != `"`]
 *   - `"` StringCharacter+ `"`
 *
 * StringCharacter ::
 *   - SourceCharacter but not `"` or `\` or LineTerminator
 *   - `\u` EscapedUnicode
 *   - `\` EscapedCharacter
 *
 * EscapedUnicode ::
 *   - `{` HexDigit+ `}`
 *   - HexDigit HexDigit HexDigit HexDigit
 *
 * EscapedCharacter :: one of `"` `\` `/` `b` `f` `n` `r` `t`
 * ```
 */

function readString(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start + 1;
  let chunkStart = position;
  let value = '';

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // Closing Quote (")

    if (code === 0x0022) {
      value += body.slice(chunkStart, position);
      return createToken(lexer, _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_1__/* .TokenKind.STRING */ .T.STRING, start, position + 1, value);
    } // Escape Sequence (\)

    if (code === 0x005c) {
      value += body.slice(chunkStart, position);
      const escape =
        body.charCodeAt(position + 1) === 0x0075 // u
          ? body.charCodeAt(position + 2) === 0x007b // {
            ? readEscapedUnicodeVariableWidth(lexer, position)
            : readEscapedUnicodeFixedWidth(lexer, position)
          : readEscapedCharacter(lexer, position);
      value += escape.value;
      position += escape.size;
      chunkStart = position;
      continue;
    } // LineTerminator (\n | \r)

    if (code === 0x000a || code === 0x000d) {
      break;
    } // SourceCharacter

    if (isUnicodeScalarValue(code)) {
      ++position;
    } else if (isSupplementaryCodePoint(body, position)) {
      position += 2;
    } else {
      throw (0,_error_syntaxError_mjs__WEBPACK_IMPORTED_MODULE_3__/* .syntaxError */ .h)(
        lexer.source,
        position,
        `Invalid character within String: ${printCodePointAt(
          lexer,
          position,
        )}.`,
      );
    }
  }

  throw (0,_error_syntaxError_mjs__WEBPACK_IMPORTED_MODULE_3__/* .syntaxError */ .h)(lexer.source, position, 'Unterminated string.');
} // The string value and lexed size of an escape sequence.

function readEscapedUnicodeVariableWidth(lexer, position) {
  const body = lexer.source.body;
  let point = 0;
  let size = 3; // Cannot be larger than 12 chars (\u{00000000}).

  while (size < 12) {
    const code = body.charCodeAt(position + size++); // Closing Brace (})

    if (code === 0x007d) {
      // Must be at least 5 chars (\u{0}) and encode a Unicode scalar value.
      if (size < 5 || !isUnicodeScalarValue(point)) {
        break;
      }

      return {
        value: String.fromCodePoint(point),
        size,
      };
    } // Append this hex digit to the code point.

    point = (point << 4) | readHexDigit(code);

    if (point < 0) {
      break;
    }
  }

  throw (0,_error_syntaxError_mjs__WEBPACK_IMPORTED_MODULE_3__/* .syntaxError */ .h)(
    lexer.source,
    position,
    `Invalid Unicode escape sequence: "${body.slice(
      position,
      position + size,
    )}".`,
  );
}

function readEscapedUnicodeFixedWidth(lexer, position) {
  const body = lexer.source.body;
  const code = read16BitHexCode(body, position + 2);

  if (isUnicodeScalarValue(code)) {
    return {
      value: String.fromCodePoint(code),
      size: 6,
    };
  } // GraphQL allows JSON-style surrogate pair escape sequences, but only when
  // a valid pair is formed.

  if (isLeadingSurrogate(code)) {
    // \u
    if (
      body.charCodeAt(position + 6) === 0x005c &&
      body.charCodeAt(position + 7) === 0x0075
    ) {
      const trailingCode = read16BitHexCode(body, position + 8);

      if (isTrailingSurrogate(trailingCode)) {
        // JavaScript defines strings as a sequence of UTF-16 code units and
        // encodes Unicode code points above U+FFFF using a surrogate pair of
        // code units. Since this is a surrogate pair escape sequence, just
        // include both codes into the JavaScript string value. Had JavaScript
        // not been internally based on UTF-16, then this surrogate pair would
        // be decoded to retrieve the supplementary code point.
        return {
          value: String.fromCodePoint(code, trailingCode),
          size: 12,
        };
      }
    }
  }

  throw (0,_error_syntaxError_mjs__WEBPACK_IMPORTED_MODULE_3__/* .syntaxError */ .h)(
    lexer.source,
    position,
    `Invalid Unicode escape sequence: "${body.slice(position, position + 6)}".`,
  );
}
/**
 * Reads four hexadecimal characters and returns the positive integer that 16bit
 * hexadecimal string represents. For example, "000f" will return 15, and "dead"
 * will return 57005.
 *
 * Returns a negative number if any char was not a valid hexadecimal digit.
 */

function read16BitHexCode(body, position) {
  // readHexDigit() returns -1 on error. ORing a negative value with any other
  // value always produces a negative value.
  return (
    (readHexDigit(body.charCodeAt(position)) << 12) |
    (readHexDigit(body.charCodeAt(position + 1)) << 8) |
    (readHexDigit(body.charCodeAt(position + 2)) << 4) |
    readHexDigit(body.charCodeAt(position + 3))
  );
}
/**
 * Reads a hexadecimal character and returns its positive integer value (0-15).
 *
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 if the provided character code was not a valid hexadecimal digit.
 *
 * HexDigit :: one of
 *   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
 *   - `A` `B` `C` `D` `E` `F`
 *   - `a` `b` `c` `d` `e` `f`
 */

function readHexDigit(code) {
  return code >= 0x0030 && code <= 0x0039 // 0-9
    ? code - 0x0030
    : code >= 0x0041 && code <= 0x0046 // A-F
    ? code - 0x0037
    : code >= 0x0061 && code <= 0x0066 // a-f
    ? code - 0x0057
    : -1;
}
/**
 * | Escaped Character | Code Point | Character Name               |
 * | ----------------- | ---------- | ---------------------------- |
 * | `"`               | U+0022     | double quote                 |
 * | `\`               | U+005C     | reverse solidus (back slash) |
 * | `/`               | U+002F     | solidus (forward slash)      |
 * | `b`               | U+0008     | backspace                    |
 * | `f`               | U+000C     | form feed                    |
 * | `n`               | U+000A     | line feed (new line)         |
 * | `r`               | U+000D     | carriage return              |
 * | `t`               | U+0009     | horizontal tab               |
 */

function readEscapedCharacter(lexer, position) {
  const body = lexer.source.body;
  const code = body.charCodeAt(position + 1);

  switch (code) {
    case 0x0022:
      // "
      return {
        value: '\u0022',
        size: 2,
      };

    case 0x005c:
      // \
      return {
        value: '\u005c',
        size: 2,
      };

    case 0x002f:
      // /
      return {
        value: '\u002f',
        size: 2,
      };

    case 0x0062:
      // b
      return {
        value: '\u0008',
        size: 2,
      };

    case 0x0066:
      // f
      return {
        value: '\u000c',
        size: 2,
      };

    case 0x006e:
      // n
      return {
        value: '\u000a',
        size: 2,
      };

    case 0x0072:
      // r
      return {
        value: '\u000d',
        size: 2,
      };

    case 0x0074:
      // t
      return {
        value: '\u0009',
        size: 2,
      };
  }

  throw (0,_error_syntaxError_mjs__WEBPACK_IMPORTED_MODULE_3__/* .syntaxError */ .h)(
    lexer.source,
    position,
    `Invalid character escape sequence: "${body.slice(
      position,
      position + 2,
    )}".`,
  );
}
/**
 * Reads a block string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `"""` BlockStringCharacter* `"""`
 *
 * BlockStringCharacter ::
 *   - SourceCharacter but not `"""` or `\"""`
 *   - `\"""`
 * ```
 */

function readBlockString(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let lineStart = lexer.lineStart;
  let position = start + 3;
  let chunkStart = position;
  let currentLine = '';
  const blockLines = [];

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // Closing Triple-Quote (""")

    if (
      code === 0x0022 &&
      body.charCodeAt(position + 1) === 0x0022 &&
      body.charCodeAt(position + 2) === 0x0022
    ) {
      currentLine += body.slice(chunkStart, position);
      blockLines.push(currentLine);
      const token = createToken(
        lexer,
        _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_1__/* .TokenKind.BLOCK_STRING */ .T.BLOCK_STRING,
        start,
        position + 3, // Return a string of the lines joined with U+000A.
        (0,_blockString_mjs__WEBPACK_IMPORTED_MODULE_4__/* .dedentBlockStringLines */ .wv)(blockLines).join('\n'),
      );
      lexer.line += blockLines.length - 1;
      lexer.lineStart = lineStart;
      return token;
    } // Escaped Triple-Quote (\""")

    if (
      code === 0x005c &&
      body.charCodeAt(position + 1) === 0x0022 &&
      body.charCodeAt(position + 2) === 0x0022 &&
      body.charCodeAt(position + 3) === 0x0022
    ) {
      currentLine += body.slice(chunkStart, position);
      chunkStart = position + 1; // skip only slash

      position += 4;
      continue;
    } // LineTerminator

    if (code === 0x000a || code === 0x000d) {
      currentLine += body.slice(chunkStart, position);
      blockLines.push(currentLine);

      if (code === 0x000d && body.charCodeAt(position + 1) === 0x000a) {
        position += 2;
      } else {
        ++position;
      }

      currentLine = '';
      chunkStart = position;
      lineStart = position;
      continue;
    } // SourceCharacter

    if (isUnicodeScalarValue(code)) {
      ++position;
    } else if (isSupplementaryCodePoint(body, position)) {
      position += 2;
    } else {
      throw (0,_error_syntaxError_mjs__WEBPACK_IMPORTED_MODULE_3__/* .syntaxError */ .h)(
        lexer.source,
        position,
        `Invalid character within String: ${printCodePointAt(
          lexer,
          position,
        )}.`,
      );
    }
  }

  throw (0,_error_syntaxError_mjs__WEBPACK_IMPORTED_MODULE_3__/* .syntaxError */ .h)(lexer.source, position, 'Unterminated string.');
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * ```
 * Name ::
 *   - NameStart NameContinue* [lookahead != NameContinue]
 * ```
 */

function readName(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start + 1;

  while (position < bodyLength) {
    const code = body.charCodeAt(position);

    if ((0,_characterClasses_mjs__WEBPACK_IMPORTED_MODULE_2__/* .isNameContinue */ .HQ)(code)) {
      ++position;
    } else {
      break;
    }
  }

  return createToken(
    lexer,
    _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_1__/* .TokenKind.NAME */ .T.NAME,
    start,
    position,
    body.slice(start, position),
  );
}


/***/ }),

/***/ 31472:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ getLocation; }
/* harmony export */ });
/* harmony import */ var _jsutils_invariant_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87021);

const LineRegExp = /\r\n|[\n\r]/g;
/**
 * Represents a location in a Source.
 */

/**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */
function getLocation(source, position) {
  let lastLineStart = 0;
  let line = 1;

  for (const match of source.body.matchAll(LineRegExp)) {
    typeof match.index === 'number' || (0,_jsutils_invariant_mjs__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .k)(false);

    if (match.index >= position) {
      break;
    }

    lastLineStart = match.index + match[0].length;
    line += 1;
  }

  return {
    line,
    column: position + 1 - lastLineStart,
  };
}


/***/ }),

/***/ 65449:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H2": function() { return /* binding */ parseValue; },
/* harmony export */   "Qc": function() { return /* binding */ parse; },
/* harmony export */   "gZ": function() { return /* binding */ parseType; },
/* harmony export */   "tl": function() { return /* binding */ parseConstValue; }
/* harmony export */ });
/* unused harmony export Parser */
/* harmony import */ var _error_syntaxError_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23445);
/* harmony import */ var _ast_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35239);
/* harmony import */ var _directiveLocation_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65916);
/* harmony import */ var _kinds_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57554);
/* harmony import */ var _lexer_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78636);
/* harmony import */ var _source_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23476);
/* harmony import */ var _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20471);







/**
 * Configuration options to control parser behavior
 */

/**
 * Given a GraphQL source, parses it into a Document.
 * Throws GraphQLError if a syntax error is encountered.
 */
function parse(source, options) {
  const parser = new Parser(source, options);
  return parser.parseDocument();
}
/**
 * Given a string containing a GraphQL value (ex. `[42]`), parse the AST for
 * that value.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Values directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: valueFromAST().
 */

function parseValue(source, options) {
  const parser = new Parser(source, options);
  parser.expectToken(_tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.SOF */ .T.SOF);
  const value = parser.parseValueLiteral(false);
  parser.expectToken(_tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.EOF */ .T.EOF);
  return value;
}
/**
 * Similar to parseValue(), but raises a parse error if it encounters a
 * variable. The return type will be a constant value.
 */

function parseConstValue(source, options) {
  const parser = new Parser(source, options);
  parser.expectToken(_tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.SOF */ .T.SOF);
  const value = parser.parseConstValueLiteral();
  parser.expectToken(_tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.EOF */ .T.EOF);
  return value;
}
/**
 * Given a string containing a GraphQL Type (ex. `[Int!]`), parse the AST for
 * that type.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Types directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: typeFromAST().
 */

function parseType(source, options) {
  const parser = new Parser(source, options);
  parser.expectToken(_tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.SOF */ .T.SOF);
  const type = parser.parseTypeReference();
  parser.expectToken(_tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.EOF */ .T.EOF);
  return type;
}
/**
 * This class is exported only to assist people in implementing their own parsers
 * without duplicating too much code and should be used only as last resort for cases
 * such as experimental syntax or if certain features could not be contributed upstream.
 *
 * It is still part of the internal API and is versioned, so any changes to it are never
 * considered breaking changes. If you still need to support multiple versions of the
 * library, please use the `versionInfo` variable for version detection.
 *
 * @internal
 */

class Parser {
  constructor(source, options = {}) {
    const sourceObj = (0,_source_mjs__WEBPACK_IMPORTED_MODULE_1__/* .isSource */ .T)(source) ? source : new _source_mjs__WEBPACK_IMPORTED_MODULE_1__/* .Source */ .H(source);
    this._lexer = new _lexer_mjs__WEBPACK_IMPORTED_MODULE_2__/* .Lexer */ .h(sourceObj);
    this._options = options;
    this._tokenCounter = 0;
  }
  /**
   * Converts a name lex token into a name parse node.
   */

  parseName() {
    const token = this.expectToken(_tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.NAME */ .T.NAME);
    return this.node(token, {
      kind: _kinds_mjs__WEBPACK_IMPORTED_MODULE_3__/* .Kind.NAME */ .h.NAME,
      value: token.value,
    });
  } // Implements the parsing rules in the Document section.

  /**
   * Document : Definition+
   */

  parseDocument() {
    return this.node(this._lexer.token, {
      kind: _kinds_mjs__WEBPACK_IMPORTED_MODULE_3__/* .Kind.DOCUMENT */ .h.DOCUMENT,
      definitions: this.many(
        _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.SOF */ .T.SOF,
        this.parseDefinition,
        _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.EOF */ .T.EOF,
      ),
    });
  }
  /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */

  parseDefinition() {
    if (this.peek(_tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.BRACE_L */ .T.BRACE_L)) {
      return this.parseOperationDefinition();
    } // Many definitions begin with a description and require a lookahead.

    const hasDescription = this.peekDescription();
    const keywordToken = hasDescription
      ? this._lexer.lookahead()
      : this._lexer.token;

    if (keywordToken.kind === _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.NAME */ .T.NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaDefinition();

        case 'scalar':
          return this.parseScalarTypeDefinition();

        case 'type':
          return this.parseObjectTypeDefinition();

        case 'interface':
          return this.parseInterfaceTypeDefinition();

        case 'union':
          return this.parseUnionTypeDefinition();

        case 'enum':
          return this.parseEnumTypeDefinition();

        case 'input':
          return this.parseInputObjectTypeDefinition();

        case 'directive':
          return this.parseDirectiveDefinition();
      }

      if (hasDescription) {
        throw (0,_error_syntaxError_mjs__WEBPACK_IMPORTED_MODULE_4__/* .syntaxError */ .h)(
          this._lexer.source,
          this._lexer.token.start,
          'Unexpected description, descriptions are supported only on type definitions.',
        );
      }

      switch (keywordToken.value) {
        case 'query':
        case 'mutation':
        case 'subscription':
          return this.parseOperationDefinition();

        case 'fragment':
          return this.parseFragmentDefinition();

        case 'extend':
          return this.parseTypeSystemExtension();
      }
    }

    throw this.unexpected(keywordToken);
  } // Implements the parsing rules in the Operations section.

  /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */

  parseOperationDefinition() {
    const start = this._lexer.token;

    if (this.peek(_tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.BRACE_L */ .T.BRACE_L)) {
      return this.node(start, {
        kind: _kinds_mjs__WEBPACK_IMPORTED_MODULE_3__/* .Kind.OPERATION_DEFINITION */ .h.OPERATION_DEFINITION,
        operation: _ast_mjs__WEBPACK_IMPORTED_MODULE_5__/* .OperationTypeNode.QUERY */ .ku.QUERY,
        name: undefined,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet(),
      });
    }

    const operation = this.parseOperationType();
    let name;

    if (this.peek(_tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.NAME */ .T.NAME)) {
      name = this.parseName();
    }

    return this.node(start, {
      kind: _kinds_mjs__WEBPACK_IMPORTED_MODULE_3__/* .Kind.OPERATION_DEFINITION */ .h.OPERATION_DEFINITION,
      operation,
      name,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
    });
  }
  /**
   * OperationType : one of query mutation subscription
   */

  parseOperationType() {
    const operationToken = this.expectToken(_tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.NAME */ .T.NAME);

    switch (operationToken.value) {
      case 'query':
        return _ast_mjs__WEBPACK_IMPORTED_MODULE_5__/* .OperationTypeNode.QUERY */ .ku.QUERY;

      case 'mutation':
        return _ast_mjs__WEBPACK_IMPORTED_MODULE_5__/* .OperationTypeNode.MUTATION */ .ku.MUTATION;

      case 'subscription':
        return _ast_mjs__WEBPACK_IMPORTED_MODULE_5__/* .OperationTypeNode.SUBSCRIPTION */ .ku.SUBSCRIPTION;
    }

    throw this.unexpected(operationToken);
  }
  /**
   * VariableDefinitions : ( VariableDefinition+ )
   */

  parseVariableDefinitions() {
    return this.optionalMany(
      _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.PAREN_L */ .T.PAREN_L,
      this.parseVariableDefinition,
      _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.PAREN_R */ .T.PAREN_R,
    );
  }
  /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */

  parseVariableDefinition() {
    return this.node(this._lexer.token, {
      kind: _kinds_mjs__WEBPACK_IMPORTED_MODULE_3__/* .Kind.VARIABLE_DEFINITION */ .h.VARIABLE_DEFINITION,
      variable: this.parseVariable(),
      type: (this.expectToken(_tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.COLON */ .T.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(_tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.EQUALS */ .T.EQUALS)
        ? this.parseConstValueLiteral()
        : undefined,
      directives: this.parseConstDirectives(),
    });
  }
  /**
   * Variable : $ Name
   */

  parseVariable() {
    const start = this._lexer.token;
    this.expectToken(_tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.DOLLAR */ .T.DOLLAR);
    return this.node(start, {
      kind: _kinds_mjs__WEBPACK_IMPORTED_MODULE_3__/* .Kind.VARIABLE */ .h.VARIABLE,
      name: this.parseName(),
    });
  }
  /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */

  parseSelectionSet() {
    return this.node(this._lexer.token, {
      kind: _kinds_mjs__WEBPACK_IMPORTED_MODULE_3__/* .Kind.SELECTION_SET */ .h.SELECTION_SET,
      selections: this.many(
        _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.BRACE_L */ .T.BRACE_L,
        this.parseSelection,
        _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.BRACE_R */ .T.BRACE_R,
      ),
    });
  }
  /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */

  parseSelection() {
    return this.peek(_tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.SPREAD */ .T.SPREAD)
      ? this.parseFragment()
      : this.parseField();
  }
  /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */

  parseField() {
    const start = this._lexer.token;
    const nameOrAlias = this.parseName();
    let alias;
    let name;

    if (this.expectOptionalToken(_tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.COLON */ .T.COLON)) {
      alias = nameOrAlias;
      name = this.parseName();
    } else {
      name = nameOrAlias;
    }

    return this.node(start, {
      kind: _kinds_mjs__WEBPACK_IMPORTED_MODULE_3__/* .Kind.FIELD */ .h.FIELD,
      alias,
      name,
      arguments: this.parseArguments(false),
      directives: this.parseDirectives(false),
      selectionSet: this.peek(_tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.BRACE_L */ .T.BRACE_L)
        ? this.parseSelectionSet()
        : undefined,
    });
  }
  /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */

  parseArguments(isConst) {
    const item = isConst ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(_tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.PAREN_L */ .T.PAREN_L, item, _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.PAREN_R */ .T.PAREN_R);
  }
  /**
   * Argument[Const] : Name : Value[?Const]
   */

  parseArgument(isConst = false) {
    const start = this._lexer.token;
    const name = this.parseName();
    this.expectToken(_tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.COLON */ .T.COLON);
    return this.node(start, {
      kind: _kinds_mjs__WEBPACK_IMPORTED_MODULE_3__/* .Kind.ARGUMENT */ .h.ARGUMENT,
      name,
      value: this.parseValueLiteral(isConst),
    });
  }

  parseConstArgument() {
    return this.parseArgument(true);
  } // Implements the parsing rules in the Fragments section.

  /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */

  parseFragment() {
    const start = this._lexer.token;
    this.expectToken(_tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.SPREAD */ .T.SPREAD);
    const hasTypeCondition = this.expectOptionalKeyword('on');

    if (!hasTypeCondition && this.peek(_tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.NAME */ .T.NAME)) {
      return this.node(start, {
        kind: _kinds_mjs__WEBPACK_IMPORTED_MODULE_3__/* .Kind.FRAGMENT_SPREAD */ .h.FRAGMENT_SPREAD,
        name: this.parseFragmentName(),
        directives: this.parseDirectives(false),
      });
    }

    return this.node(start, {
      kind: _kinds_mjs__WEBPACK_IMPORTED_MODULE_3__/* .Kind.INLINE_FRAGMENT */ .h.INLINE_FRAGMENT,
      typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
    });
  }
  /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */

  parseFragmentDefinition() {
    const start = this._lexer.token;
    this.expectKeyword('fragment'); // Legacy support for defining variables within fragments changes
    // the grammar of FragmentDefinition:
    //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet

    if (this._options.allowLegacyFragmentVariables === true) {
      return this.node(start, {
        kind: _kinds_mjs__WEBPACK_IMPORTED_MODULE_3__/* .Kind.FRAGMENT_DEFINITION */ .h.FRAGMENT_DEFINITION,
        name: this.parseFragmentName(),
        variableDefinitions: this.parseVariableDefinitions(),
        typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
        directives: this.parseDirectives(false),
        selectionSet: this.parseSelectionSet(),
      });
    }

    return this.node(start, {
      kind: _kinds_mjs__WEBPACK_IMPORTED_MODULE_3__/* .Kind.FRAGMENT_DEFINITION */ .h.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
    });
  }
  /**
   * FragmentName : Name but not `on`
   */

  parseFragmentName() {
    if (this._lexer.token.value === 'on') {
      throw this.unexpected();
    }

    return this.parseName();
  } // Implements the parsing rules in the Values section.

  /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */

  parseValueLiteral(isConst) {
    const token = this._lexer.token;

    switch (token.kind) {
      case _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.BRACKET_L */ .T.BRACKET_L:
        return this.parseList(isConst);

      case _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.BRACE_L */ .T.BRACE_L:
        return this.parseObject(isConst);

      case _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.INT */ .T.INT:
        this.advanceLexer();
        return this.node(token, {
          kind: _kinds_mjs__WEBPACK_IMPORTED_MODULE_3__/* .Kind.INT */ .h.INT,
          value: token.value,
        });

      case _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.FLOAT */ .T.FLOAT:
        this.advanceLexer();
        return this.node(token, {
          kind: _kinds_mjs__WEBPACK_IMPORTED_MODULE_3__/* .Kind.FLOAT */ .h.FLOAT,
          value: token.value,
        });

      case _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.STRING */ .T.STRING:
      case _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.BLOCK_STRING */ .T.BLOCK_STRING:
        return this.parseStringLiteral();

      case _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.NAME */ .T.NAME:
        this.advanceLexer();

        switch (token.value) {
          case 'true':
            return this.node(token, {
              kind: _kinds_mjs__WEBPACK_IMPORTED_MODULE_3__/* .Kind.BOOLEAN */ .h.BOOLEAN,
              value: true,
            });

          case 'false':
            return this.node(token, {
              kind: _kinds_mjs__WEBPACK_IMPORTED_MODULE_3__/* .Kind.BOOLEAN */ .h.BOOLEAN,
              value: false,
            });

          case 'null':
            return this.node(token, {
              kind: _kinds_mjs__WEBPACK_IMPORTED_MODULE_3__/* .Kind.NULL */ .h.NULL,
            });

          default:
            return this.node(token, {
              kind: _kinds_mjs__WEBPACK_IMPORTED_MODULE_3__/* .Kind.ENUM */ .h.ENUM,
              value: token.value,
            });
        }

      case _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.DOLLAR */ .T.DOLLAR:
        if (isConst) {
          this.expectToken(_tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.DOLLAR */ .T.DOLLAR);

          if (this._lexer.token.kind === _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.NAME */ .T.NAME) {
            const varName = this._lexer.token.value;
            throw (0,_error_syntaxError_mjs__WEBPACK_IMPORTED_MODULE_4__/* .syntaxError */ .h)(
              this._lexer.source,
              token.start,
              `Unexpected variable "$${varName}" in constant value.`,
            );
          } else {
            throw this.unexpected(token);
          }
        }

        return this.parseVariable();

      default:
        throw this.unexpected();
    }
  }

  parseConstValueLiteral() {
    return this.parseValueLiteral(true);
  }

  parseStringLiteral() {
    const token = this._lexer.token;
    this.advanceLexer();
    return this.node(token, {
      kind: _kinds_mjs__WEBPACK_IMPORTED_MODULE_3__/* .Kind.STRING */ .h.STRING,
      value: token.value,
      block: token.kind === _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.BLOCK_STRING */ .T.BLOCK_STRING,
    });
  }
  /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */

  parseList(isConst) {
    const item = () => this.parseValueLiteral(isConst);

    return this.node(this._lexer.token, {
      kind: _kinds_mjs__WEBPACK_IMPORTED_MODULE_3__/* .Kind.LIST */ .h.LIST,
      values: this.any(_tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.BRACKET_L */ .T.BRACKET_L, item, _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.BRACKET_R */ .T.BRACKET_R),
    });
  }
  /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */

  parseObject(isConst) {
    const item = () => this.parseObjectField(isConst);

    return this.node(this._lexer.token, {
      kind: _kinds_mjs__WEBPACK_IMPORTED_MODULE_3__/* .Kind.OBJECT */ .h.OBJECT,
      fields: this.any(_tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.BRACE_L */ .T.BRACE_L, item, _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.BRACE_R */ .T.BRACE_R),
    });
  }
  /**
   * ObjectField[Const] : Name : Value[?Const]
   */

  parseObjectField(isConst) {
    const start = this._lexer.token;
    const name = this.parseName();
    this.expectToken(_tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.COLON */ .T.COLON);
    return this.node(start, {
      kind: _kinds_mjs__WEBPACK_IMPORTED_MODULE_3__/* .Kind.OBJECT_FIELD */ .h.OBJECT_FIELD,
      name,
      value: this.parseValueLiteral(isConst),
    });
  } // Implements the parsing rules in the Directives section.

  /**
   * Directives[Const] : Directive[?Const]+
   */

  parseDirectives(isConst) {
    const directives = [];

    while (this.peek(_tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.AT */ .T.AT)) {
      directives.push(this.parseDirective(isConst));
    }

    return directives;
  }

  parseConstDirectives() {
    return this.parseDirectives(true);
  }
  /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */

  parseDirective(isConst) {
    const start = this._lexer.token;
    this.expectToken(_tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.AT */ .T.AT);
    return this.node(start, {
      kind: _kinds_mjs__WEBPACK_IMPORTED_MODULE_3__/* .Kind.DIRECTIVE */ .h.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(isConst),
    });
  } // Implements the parsing rules in the Types section.

  /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */

  parseTypeReference() {
    const start = this._lexer.token;
    let type;

    if (this.expectOptionalToken(_tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.BRACKET_L */ .T.BRACKET_L)) {
      const innerType = this.parseTypeReference();
      this.expectToken(_tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.BRACKET_R */ .T.BRACKET_R);
      type = this.node(start, {
        kind: _kinds_mjs__WEBPACK_IMPORTED_MODULE_3__/* .Kind.LIST_TYPE */ .h.LIST_TYPE,
        type: innerType,
      });
    } else {
      type = this.parseNamedType();
    }

    if (this.expectOptionalToken(_tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.BANG */ .T.BANG)) {
      return this.node(start, {
        kind: _kinds_mjs__WEBPACK_IMPORTED_MODULE_3__/* .Kind.NON_NULL_TYPE */ .h.NON_NULL_TYPE,
        type,
      });
    }

    return type;
  }
  /**
   * NamedType : Name
   */

  parseNamedType() {
    return this.node(this._lexer.token, {
      kind: _kinds_mjs__WEBPACK_IMPORTED_MODULE_3__/* .Kind.NAMED_TYPE */ .h.NAMED_TYPE,
      name: this.parseName(),
    });
  } // Implements the parsing rules in the Type Definition section.

  peekDescription() {
    return this.peek(_tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.STRING */ .T.STRING) || this.peek(_tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.BLOCK_STRING */ .T.BLOCK_STRING);
  }
  /**
   * Description : StringValue
   */

  parseDescription() {
    if (this.peekDescription()) {
      return this.parseStringLiteral();
    }
  }
  /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */

  parseSchemaDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('schema');
    const directives = this.parseConstDirectives();
    const operationTypes = this.many(
      _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.BRACE_L */ .T.BRACE_L,
      this.parseOperationTypeDefinition,
      _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.BRACE_R */ .T.BRACE_R,
    );
    return this.node(start, {
      kind: _kinds_mjs__WEBPACK_IMPORTED_MODULE_3__/* .Kind.SCHEMA_DEFINITION */ .h.SCHEMA_DEFINITION,
      description,
      directives,
      operationTypes,
    });
  }
  /**
   * OperationTypeDefinition : OperationType : NamedType
   */

  parseOperationTypeDefinition() {
    const start = this._lexer.token;
    const operation = this.parseOperationType();
    this.expectToken(_tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.COLON */ .T.COLON);
    const type = this.parseNamedType();
    return this.node(start, {
      kind: _kinds_mjs__WEBPACK_IMPORTED_MODULE_3__/* .Kind.OPERATION_TYPE_DEFINITION */ .h.OPERATION_TYPE_DEFINITION,
      operation,
      type,
    });
  }
  /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */

  parseScalarTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('scalar');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: _kinds_mjs__WEBPACK_IMPORTED_MODULE_3__/* .Kind.SCALAR_TYPE_DEFINITION */ .h.SCALAR_TYPE_DEFINITION,
      description,
      name,
      directives,
    });
  }
  /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */

  parseObjectTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('type');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();
    return this.node(start, {
      kind: _kinds_mjs__WEBPACK_IMPORTED_MODULE_3__/* .Kind.OBJECT_TYPE_DEFINITION */ .h.OBJECT_TYPE_DEFINITION,
      description,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */

  parseImplementsInterfaces() {
    return this.expectOptionalKeyword('implements')
      ? this.delimitedMany(_tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.AMP */ .T.AMP, this.parseNamedType)
      : [];
  }
  /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */

  parseFieldsDefinition() {
    return this.optionalMany(
      _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.BRACE_L */ .T.BRACE_L,
      this.parseFieldDefinition,
      _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.BRACE_R */ .T.BRACE_R,
    );
  }
  /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */

  parseFieldDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    const name = this.parseName();
    const args = this.parseArgumentDefs();
    this.expectToken(_tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.COLON */ .T.COLON);
    const type = this.parseTypeReference();
    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: _kinds_mjs__WEBPACK_IMPORTED_MODULE_3__/* .Kind.FIELD_DEFINITION */ .h.FIELD_DEFINITION,
      description,
      name,
      arguments: args,
      type,
      directives,
    });
  }
  /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */

  parseArgumentDefs() {
    return this.optionalMany(
      _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.PAREN_L */ .T.PAREN_L,
      this.parseInputValueDef,
      _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.PAREN_R */ .T.PAREN_R,
    );
  }
  /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */

  parseInputValueDef() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    const name = this.parseName();
    this.expectToken(_tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.COLON */ .T.COLON);
    const type = this.parseTypeReference();
    let defaultValue;

    if (this.expectOptionalToken(_tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.EQUALS */ .T.EQUALS)) {
      defaultValue = this.parseConstValueLiteral();
    }

    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: _kinds_mjs__WEBPACK_IMPORTED_MODULE_3__/* .Kind.INPUT_VALUE_DEFINITION */ .h.INPUT_VALUE_DEFINITION,
      description,
      name,
      type,
      defaultValue,
      directives,
    });
  }
  /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */

  parseInterfaceTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('interface');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();
    return this.node(start, {
      kind: _kinds_mjs__WEBPACK_IMPORTED_MODULE_3__/* .Kind.INTERFACE_TYPE_DEFINITION */ .h.INTERFACE_TYPE_DEFINITION,
      description,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */

  parseUnionTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('union');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const types = this.parseUnionMemberTypes();
    return this.node(start, {
      kind: _kinds_mjs__WEBPACK_IMPORTED_MODULE_3__/* .Kind.UNION_TYPE_DEFINITION */ .h.UNION_TYPE_DEFINITION,
      description,
      name,
      directives,
      types,
    });
  }
  /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */

  parseUnionMemberTypes() {
    return this.expectOptionalToken(_tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.EQUALS */ .T.EQUALS)
      ? this.delimitedMany(_tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.PIPE */ .T.PIPE, this.parseNamedType)
      : [];
  }
  /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */

  parseEnumTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('enum');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const values = this.parseEnumValuesDefinition();
    return this.node(start, {
      kind: _kinds_mjs__WEBPACK_IMPORTED_MODULE_3__/* .Kind.ENUM_TYPE_DEFINITION */ .h.ENUM_TYPE_DEFINITION,
      description,
      name,
      directives,
      values,
    });
  }
  /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */

  parseEnumValuesDefinition() {
    return this.optionalMany(
      _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.BRACE_L */ .T.BRACE_L,
      this.parseEnumValueDefinition,
      _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.BRACE_R */ .T.BRACE_R,
    );
  }
  /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */

  parseEnumValueDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    const name = this.parseEnumValueName();
    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: _kinds_mjs__WEBPACK_IMPORTED_MODULE_3__/* .Kind.ENUM_VALUE_DEFINITION */ .h.ENUM_VALUE_DEFINITION,
      description,
      name,
      directives,
    });
  }
  /**
   * EnumValue : Name but not `true`, `false` or `null`
   */

  parseEnumValueName() {
    if (
      this._lexer.token.value === 'true' ||
      this._lexer.token.value === 'false' ||
      this._lexer.token.value === 'null'
    ) {
      throw (0,_error_syntaxError_mjs__WEBPACK_IMPORTED_MODULE_4__/* .syntaxError */ .h)(
        this._lexer.source,
        this._lexer.token.start,
        `${getTokenDesc(
          this._lexer.token,
        )} is reserved and cannot be used for an enum value.`,
      );
    }

    return this.parseName();
  }
  /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */

  parseInputObjectTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('input');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const fields = this.parseInputFieldsDefinition();
    return this.node(start, {
      kind: _kinds_mjs__WEBPACK_IMPORTED_MODULE_3__/* .Kind.INPUT_OBJECT_TYPE_DEFINITION */ .h.INPUT_OBJECT_TYPE_DEFINITION,
      description,
      name,
      directives,
      fields,
    });
  }
  /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */

  parseInputFieldsDefinition() {
    return this.optionalMany(
      _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.BRACE_L */ .T.BRACE_L,
      this.parseInputValueDef,
      _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.BRACE_R */ .T.BRACE_R,
    );
  }
  /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */

  parseTypeSystemExtension() {
    const keywordToken = this._lexer.lookahead();

    if (keywordToken.kind === _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.NAME */ .T.NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaExtension();

        case 'scalar':
          return this.parseScalarTypeExtension();

        case 'type':
          return this.parseObjectTypeExtension();

        case 'interface':
          return this.parseInterfaceTypeExtension();

        case 'union':
          return this.parseUnionTypeExtension();

        case 'enum':
          return this.parseEnumTypeExtension();

        case 'input':
          return this.parseInputObjectTypeExtension();
      }
    }

    throw this.unexpected(keywordToken);
  }
  /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */

  parseSchemaExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('schema');
    const directives = this.parseConstDirectives();
    const operationTypes = this.optionalMany(
      _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.BRACE_L */ .T.BRACE_L,
      this.parseOperationTypeDefinition,
      _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.BRACE_R */ .T.BRACE_R,
    );

    if (directives.length === 0 && operationTypes.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: _kinds_mjs__WEBPACK_IMPORTED_MODULE_3__/* .Kind.SCHEMA_EXTENSION */ .h.SCHEMA_EXTENSION,
      directives,
      operationTypes,
    });
  }
  /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */

  parseScalarTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('scalar');
    const name = this.parseName();
    const directives = this.parseConstDirectives();

    if (directives.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: _kinds_mjs__WEBPACK_IMPORTED_MODULE_3__/* .Kind.SCALAR_TYPE_EXTENSION */ .h.SCALAR_TYPE_EXTENSION,
      name,
      directives,
    });
  }
  /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */

  parseObjectTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('type');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();

    if (
      interfaces.length === 0 &&
      directives.length === 0 &&
      fields.length === 0
    ) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: _kinds_mjs__WEBPACK_IMPORTED_MODULE_3__/* .Kind.OBJECT_TYPE_EXTENSION */ .h.OBJECT_TYPE_EXTENSION,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */

  parseInterfaceTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('interface');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();

    if (
      interfaces.length === 0 &&
      directives.length === 0 &&
      fields.length === 0
    ) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: _kinds_mjs__WEBPACK_IMPORTED_MODULE_3__/* .Kind.INTERFACE_TYPE_EXTENSION */ .h.INTERFACE_TYPE_EXTENSION,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */

  parseUnionTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('union');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const types = this.parseUnionMemberTypes();

    if (directives.length === 0 && types.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: _kinds_mjs__WEBPACK_IMPORTED_MODULE_3__/* .Kind.UNION_TYPE_EXTENSION */ .h.UNION_TYPE_EXTENSION,
      name,
      directives,
      types,
    });
  }
  /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */

  parseEnumTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('enum');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const values = this.parseEnumValuesDefinition();

    if (directives.length === 0 && values.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: _kinds_mjs__WEBPACK_IMPORTED_MODULE_3__/* .Kind.ENUM_TYPE_EXTENSION */ .h.ENUM_TYPE_EXTENSION,
      name,
      directives,
      values,
    });
  }
  /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */

  parseInputObjectTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('input');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const fields = this.parseInputFieldsDefinition();

    if (directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: _kinds_mjs__WEBPACK_IMPORTED_MODULE_3__/* .Kind.INPUT_OBJECT_TYPE_EXTENSION */ .h.INPUT_OBJECT_TYPE_EXTENSION,
      name,
      directives,
      fields,
    });
  }
  /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */

  parseDirectiveDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('directive');
    this.expectToken(_tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.AT */ .T.AT);
    const name = this.parseName();
    const args = this.parseArgumentDefs();
    const repeatable = this.expectOptionalKeyword('repeatable');
    this.expectKeyword('on');
    const locations = this.parseDirectiveLocations();
    return this.node(start, {
      kind: _kinds_mjs__WEBPACK_IMPORTED_MODULE_3__/* .Kind.DIRECTIVE_DEFINITION */ .h.DIRECTIVE_DEFINITION,
      description,
      name,
      arguments: args,
      repeatable,
      locations,
    });
  }
  /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */

  parseDirectiveLocations() {
    return this.delimitedMany(_tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.PIPE */ .T.PIPE, this.parseDirectiveLocation);
  }
  /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */

  parseDirectiveLocation() {
    const start = this._lexer.token;
    const name = this.parseName();

    if (Object.prototype.hasOwnProperty.call(_directiveLocation_mjs__WEBPACK_IMPORTED_MODULE_6__/* .DirectiveLocation */ .B, name.value)) {
      return name;
    }

    throw this.unexpected(start);
  } // Core parsing utility functions

  /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */

  node(startToken, node) {
    if (this._options.noLocation !== true) {
      node.loc = new _ast_mjs__WEBPACK_IMPORTED_MODULE_5__/* .Location */ .Ye(
        startToken,
        this._lexer.lastToken,
        this._lexer.source,
      );
    }

    return node;
  }
  /**
   * Determines if the next token is of a given kind
   */

  peek(kind) {
    return this._lexer.token.kind === kind;
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */

  expectToken(kind) {
    const token = this._lexer.token;

    if (token.kind === kind) {
      this.advanceLexer();
      return token;
    }

    throw (0,_error_syntaxError_mjs__WEBPACK_IMPORTED_MODULE_4__/* .syntaxError */ .h)(
      this._lexer.source,
      token.start,
      `Expected ${getTokenKindDesc(kind)}, found ${getTokenDesc(token)}.`,
    );
  }
  /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */

  expectOptionalToken(kind) {
    const token = this._lexer.token;

    if (token.kind === kind) {
      this.advanceLexer();
      return true;
    }

    return false;
  }
  /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */

  expectKeyword(value) {
    const token = this._lexer.token;

    if (token.kind === _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.NAME */ .T.NAME && token.value === value) {
      this.advanceLexer();
    } else {
      throw (0,_error_syntaxError_mjs__WEBPACK_IMPORTED_MODULE_4__/* .syntaxError */ .h)(
        this._lexer.source,
        token.start,
        `Expected "${value}", found ${getTokenDesc(token)}.`,
      );
    }
  }
  /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */

  expectOptionalKeyword(value) {
    const token = this._lexer.token;

    if (token.kind === _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.NAME */ .T.NAME && token.value === value) {
      this.advanceLexer();
      return true;
    }

    return false;
  }
  /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */

  unexpected(atToken) {
    const token =
      atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
    return (0,_error_syntaxError_mjs__WEBPACK_IMPORTED_MODULE_4__/* .syntaxError */ .h)(
      this._lexer.source,
      token.start,
      `Unexpected ${getTokenDesc(token)}.`,
    );
  }
  /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */

  any(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    const nodes = [];

    while (!this.expectOptionalToken(closeKind)) {
      nodes.push(parseFn.call(this));
    }

    return nodes;
  }
  /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */

  optionalMany(openKind, parseFn, closeKind) {
    if (this.expectOptionalToken(openKind)) {
      const nodes = [];

      do {
        nodes.push(parseFn.call(this));
      } while (!this.expectOptionalToken(closeKind));

      return nodes;
    }

    return [];
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */

  many(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    const nodes = [];

    do {
      nodes.push(parseFn.call(this));
    } while (!this.expectOptionalToken(closeKind));

    return nodes;
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */

  delimitedMany(delimiterKind, parseFn) {
    this.expectOptionalToken(delimiterKind);
    const nodes = [];

    do {
      nodes.push(parseFn.call(this));
    } while (this.expectOptionalToken(delimiterKind));

    return nodes;
  }

  advanceLexer() {
    const { maxTokens } = this._options;

    const token = this._lexer.advance();

    if (maxTokens !== undefined && token.kind !== _tokenKind_mjs__WEBPACK_IMPORTED_MODULE_0__/* .TokenKind.EOF */ .T.EOF) {
      ++this._tokenCounter;

      if (this._tokenCounter > maxTokens) {
        throw (0,_error_syntaxError_mjs__WEBPACK_IMPORTED_MODULE_4__/* .syntaxError */ .h)(
          this._lexer.source,
          token.start,
          `Document contains more that ${maxTokens} tokens. Parsing aborted.`,
        );
      }
    }
  }
}
/**
 * A helper function to describe a token as a string for debugging.
 */

function getTokenDesc(token) {
  const value = token.value;
  return getTokenKindDesc(token.kind) + (value != null ? ` "${value}"` : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */

function getTokenKindDesc(kind) {
  return (0,_lexer_mjs__WEBPACK_IMPORTED_MODULE_2__/* .isPunctuatorTokenKind */ .u)(kind) ? `"${kind}"` : kind;
}


/***/ }),

/***/ 56403:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ printLocation; },
/* harmony export */   "z": function() { return /* binding */ printSourceLocation; }
/* harmony export */ });
/* harmony import */ var _location_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31472);


/**
 * Render a helpful description of the location in the GraphQL Source document.
 */
function printLocation(location) {
  return printSourceLocation(
    location.source,
    (0,_location_mjs__WEBPACK_IMPORTED_MODULE_0__/* .getLocation */ .k)(location.source, location.start),
  );
}
/**
 * Render a helpful description of the location in the GraphQL Source document.
 */

function printSourceLocation(source, sourceLocation) {
  const firstLineColumnOffset = source.locationOffset.column - 1;
  const body = ''.padStart(firstLineColumnOffset) + source.body;
  const lineIndex = sourceLocation.line - 1;
  const lineOffset = source.locationOffset.line - 1;
  const lineNum = sourceLocation.line + lineOffset;
  const columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
  const columnNum = sourceLocation.column + columnOffset;
  const locationStr = `${source.name}:${lineNum}:${columnNum}\n`;
  const lines = body.split(/\r\n|[\n\r]/g);
  const locationLine = lines[lineIndex]; // Special case for minified documents

  if (locationLine.length > 120) {
    const subLineIndex = Math.floor(columnNum / 80);
    const subLineColumnNum = columnNum % 80;
    const subLines = [];

    for (let i = 0; i < locationLine.length; i += 80) {
      subLines.push(locationLine.slice(i, i + 80));
    }

    return (
      locationStr +
      printPrefixedLines([
        [`${lineNum} |`, subLines[0]],
        ...subLines.slice(1, subLineIndex + 1).map((subLine) => ['|', subLine]),
        ['|', '^'.padStart(subLineColumnNum)],
        ['|', subLines[subLineIndex + 1]],
      ])
    );
  }

  return (
    locationStr +
    printPrefixedLines([
      // Lines specified like this: ["prefix", "string"],
      [`${lineNum - 1} |`, lines[lineIndex - 1]],
      [`${lineNum} |`, locationLine],
      ['|', '^'.padStart(columnNum)],
      [`${lineNum + 1} |`, lines[lineIndex + 1]],
    ])
  );
}

function printPrefixedLines(lines) {
  const existingLines = lines.filter(([_, line]) => line !== undefined);
  const padLen = Math.max(...existingLines.map(([prefix]) => prefix.length));
  return existingLines
    .map(([prefix, line]) => prefix.padStart(padLen) + (line ? ' ' + line : ''))
    .join('\n');
}


/***/ }),

/***/ 23476:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ Source; },
/* harmony export */   "T": function() { return /* binding */ isSource; }
/* harmony export */ });
/* harmony import */ var _jsutils_devAssert_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34317);
/* harmony import */ var _jsutils_inspect_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59329);
/* harmony import */ var _jsutils_instanceOf_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93956);




/**
 * A representation of source input to GraphQL. The `name` and `locationOffset` parameters are
 * optional, but they are useful for clients who store GraphQL documents in source files.
 * For example, if the GraphQL input starts at line 40 in a file named `Foo.graphql`, it might
 * be useful for `name` to be `"Foo.graphql"` and location to be `{ line: 40, column: 1 }`.
 * The `line` and `column` properties in `locationOffset` are 1-indexed.
 */
class Source {
  constructor(
    body,
    name = 'GraphQL request',
    locationOffset = {
      line: 1,
      column: 1,
    },
  ) {
    typeof body === 'string' ||
      (0,_jsutils_devAssert_mjs__WEBPACK_IMPORTED_MODULE_0__/* .devAssert */ .a)(false, `Body must be a string. Received: ${(0,_jsutils_inspect_mjs__WEBPACK_IMPORTED_MODULE_1__/* .inspect */ .X)(body)}.`);
    this.body = body;
    this.name = name;
    this.locationOffset = locationOffset;
    this.locationOffset.line > 0 ||
      (0,_jsutils_devAssert_mjs__WEBPACK_IMPORTED_MODULE_0__/* .devAssert */ .a)(
        false,
        'line in locationOffset is 1-indexed and must be positive.',
      );
    this.locationOffset.column > 0 ||
      (0,_jsutils_devAssert_mjs__WEBPACK_IMPORTED_MODULE_0__/* .devAssert */ .a)(
        false,
        'column in locationOffset is 1-indexed and must be positive.',
      );
  }

  get [Symbol.toStringTag]() {
    return 'Source';
  }
}
/**
 * Test if the given value is a Source object.
 *
 * @internal
 */

function isSource(source) {
  return (0,_jsutils_instanceOf_mjs__WEBPACK_IMPORTED_MODULE_2__/* .instanceOf */ .n)(source, Source);
}


/***/ }),

/***/ 20471:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ TokenKind; }
/* harmony export */ });
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */
var TokenKind;

(function (TokenKind) {
  TokenKind['SOF'] = '<SOF>';
  TokenKind['EOF'] = '<EOF>';
  TokenKind['BANG'] = '!';
  TokenKind['DOLLAR'] = '$';
  TokenKind['AMP'] = '&';
  TokenKind['PAREN_L'] = '(';
  TokenKind['PAREN_R'] = ')';
  TokenKind['SPREAD'] = '...';
  TokenKind['COLON'] = ':';
  TokenKind['EQUALS'] = '=';
  TokenKind['AT'] = '@';
  TokenKind['BRACKET_L'] = '[';
  TokenKind['BRACKET_R'] = ']';
  TokenKind['BRACE_L'] = '{';
  TokenKind['PIPE'] = '|';
  TokenKind['BRACE_R'] = '}';
  TokenKind['NAME'] = 'Name';
  TokenKind['INT'] = 'Int';
  TokenKind['FLOAT'] = 'Float';
  TokenKind['STRING'] = 'String';
  TokenKind['BLOCK_STRING'] = 'BlockString';
  TokenKind['COMMENT'] = 'Comment';
})(TokenKind || (TokenKind = {}));


/**
 * The enum type representing the token kinds values.
 *
 * @deprecated Please use `TokenKind`. Will be remove in v17.
 */


/***/ }),

/***/ 31655:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ api; }
/* harmony export */ });
/*! js-cookie v3.0.5 | MIT */
/* eslint-disable no-var */
function assign (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target
}
/* eslint-enable no-var */

/* eslint-disable no-var */
var defaultConverter = {
  read: function (value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
  },
  write: function (value) {
    return encodeURIComponent(value).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    )
  }
};
/* eslint-enable no-var */

/* eslint-disable no-var */

function init (converter, defaultAttributes) {
  function set (name, value, attributes) {
    if (typeof document === 'undefined') {
      return
    }

    attributes = assign({}, defaultAttributes, attributes);

    if (typeof attributes.expires === 'number') {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }

    name = encodeURIComponent(name)
      .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
      .replace(/[()]/g, escape);

    var stringifiedAttributes = '';
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue
      }

      stringifiedAttributes += '; ' + attributeName;

      if (attributes[attributeName] === true) {
        continue
      }

      // Considers RFC 6265 section 5.2:
      // ...
      // 3.  If the remaining unparsed-attributes contains a %x3B (";")
      //     character:
      // Consume the characters of the unparsed-attributes up to,
      // not including, the first %x3B (";") character.
      // ...
      stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }

    return (document.cookie =
      name + '=' + converter.write(value, name) + stringifiedAttributes)
  }

  function get (name) {
    if (typeof document === 'undefined' || (arguments.length && !name)) {
      return
    }

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      var value = parts.slice(1).join('=');

      try {
        var found = decodeURIComponent(parts[0]);
        jar[found] = converter.read(value, found);

        if (name === found) {
          break
        }
      } catch (e) {}
    }

    return name ? jar[name] : jar
  }

  return Object.create(
    {
      set,
      get,
      remove: function (name, attributes) {
        set(
          name,
          '',
          assign({}, attributes, {
            expires: -1
          })
        );
      },
      withAttributes: function (attributes) {
        return init(this.converter, assign({}, this.attributes, attributes))
      },
      withConverter: function (converter) {
        return init(assign({}, this.converter, converter), this.attributes)
      }
    },
    {
      attributes: { value: Object.freeze(defaultAttributes) },
      converter: { value: Object.freeze(converter) }
    }
  )
}

var api = init(defaultConverter, { path: '/' });
/* eslint-enable no-var */




/***/ }),

/***/ 72155:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x0": function() { return /* binding */ nanoid; }
/* harmony export */ });
/* unused harmony exports random, customRandom, customAlphabet */

let random = bytes => crypto.getRandomValues(new Uint8Array(bytes))
let customRandom = (alphabet, defaultSize, getRandom) => {
  let mask = (2 << (Math.log(alphabet.length - 1) / Math.LN2)) - 1
  let step = -~((1.6 * mask * defaultSize) / alphabet.length)
  return (size = defaultSize) => {
    let id = ''
    while (true) {
      let bytes = getRandom(step)
      let j = step
      while (j--) {
        id += alphabet[bytes[j] & mask] || ''
        if (id.length === size) return id
      }
    }
  }
}
let customAlphabet = (alphabet, size = 21) =>
  customRandom(alphabet, size, random)
let nanoid = (size = 21) =>
  crypto.getRandomValues(new Uint8Array(size)).reduce((id, byte) => {
    byte &= 63
    if (byte < 36) {
      id += byte.toString(36)
    } else if (byte < 62) {
      id += (byte - 26).toString(36).toUpperCase()
    } else if (byte > 62) {
      id += '-'
    } else {
      id += '_'
    }
    return id
  }, '')


/***/ }),

/***/ 38687:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YD": function() { return /* binding */ useInView; }
/* harmony export */ });
/* unused harmony exports InView, defaultFallbackInView, observe */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
"use client";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);

// src/InView.tsx


// src/observe.ts
var observerMap = /* @__PURE__ */ new Map();
var RootIds = /* @__PURE__ */ new WeakMap();
var rootId = 0;
var unsupportedValue = void 0;
function defaultFallbackInView(inView) {
  unsupportedValue = inView;
}
function getRootId(root) {
  if (!root) return "0";
  if (RootIds.has(root)) return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
function optionsToId(options) {
  return Object.keys(options).sort().filter(
    (key) => options[key] !== void 0
  ).map((key) => {
    return `${key}_${key === "root" ? getRootId(options.root) : options[key]}`;
  }).toString();
}
function createObserver(options) {
  const id = optionsToId(options);
  let instance = observerMap.get(id);
  if (!instance) {
    const elements = /* @__PURE__ */ new Map();
    let thresholds;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        var _a;
        const inView = entry.isIntersecting && thresholds.some((threshold) => entry.intersectionRatio >= threshold);
        if (options.trackVisibility && typeof entry.isVisible === "undefined") {
          entry.isVisible = inView;
        }
        (_a = elements.get(entry.target)) == null ? void 0 : _a.forEach((callback) => {
          callback(inView, entry);
        });
      });
    }, options);
    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id,
      observer,
      elements
    };
    observerMap.set(id, instance);
  }
  return instance;
}
function observe(element, callback, options = {}, fallbackInView = unsupportedValue) {
  if (typeof window.IntersectionObserver === "undefined" && fallbackInView !== void 0) {
    const bounds = element.getBoundingClientRect();
    callback(fallbackInView, {
      isIntersecting: fallbackInView,
      target: element,
      intersectionRatio: typeof options.threshold === "number" ? options.threshold : 0,
      time: 0,
      boundingClientRect: bounds,
      intersectionRect: bounds,
      rootBounds: bounds
    });
    return () => {
    };
  }
  const { id, observer, elements } = createObserver(options);
  const callbacks = elements.get(element) || [];
  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }
  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    callbacks.splice(callbacks.indexOf(callback), 1);
    if (callbacks.length === 0) {
      elements.delete(element);
      observer.unobserve(element);
    }
    if (elements.size === 0) {
      observer.disconnect();
      observerMap.delete(id);
    }
  };
}

// src/InView.tsx
function isPlainChildren(props) {
  return typeof props.children !== "function";
}
var InView = class extends react__WEBPACK_IMPORTED_MODULE_0__.Component {
  constructor(props) {
    super(props);
    __publicField(this, "node", null);
    __publicField(this, "_unobserveCb", null);
    __publicField(this, "handleNode", (node) => {
      if (this.node) {
        this.unobserve();
        if (!node && !this.props.triggerOnce && !this.props.skip) {
          this.setState({ inView: !!this.props.initialInView, entry: void 0 });
        }
      }
      this.node = node ? node : null;
      this.observeNode();
    });
    __publicField(this, "handleChange", (inView, entry) => {
      if (inView && this.props.triggerOnce) {
        this.unobserve();
      }
      if (!isPlainChildren(this.props)) {
        this.setState({ inView, entry });
      }
      if (this.props.onChange) {
        this.props.onChange(inView, entry);
      }
    });
    this.state = {
      inView: !!props.initialInView,
      entry: void 0
    };
  }
  componentDidMount() {
    this.unobserve();
    this.observeNode();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
      this.unobserve();
      this.observeNode();
    }
  }
  componentWillUnmount() {
    this.unobserve();
  }
  observeNode() {
    if (!this.node || this.props.skip) return;
    const {
      threshold,
      root,
      rootMargin,
      trackVisibility,
      delay,
      fallbackInView
    } = this.props;
    this._unobserveCb = observe(
      this.node,
      this.handleChange,
      {
        threshold,
        root,
        rootMargin,
        // @ts-ignore
        trackVisibility,
        // @ts-ignore
        delay
      },
      fallbackInView
    );
  }
  unobserve() {
    if (this._unobserveCb) {
      this._unobserveCb();
      this._unobserveCb = null;
    }
  }
  render() {
    const { children } = this.props;
    if (typeof children === "function") {
      const { inView, entry } = this.state;
      return children({ inView, entry, ref: this.handleNode });
    }
    const {
      as,
      triggerOnce,
      threshold,
      root,
      rootMargin,
      onChange,
      skip,
      trackVisibility,
      delay,
      initialInView,
      fallbackInView,
      ...props
    } = this.props;
    return React.createElement(
      as || "div",
      { ref: this.handleNode, ...props },
      children
    );
  }
};

// src/useInView.tsx

function useInView({
  threshold,
  delay,
  trackVisibility,
  rootMargin,
  root,
  triggerOnce,
  skip,
  initialInView,
  fallbackInView,
  onChange
} = {}) {
  var _a;
  const [ref, setRef] = react__WEBPACK_IMPORTED_MODULE_0__.useState(null);
  const callback = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  const [state, setState] = react__WEBPACK_IMPORTED_MODULE_0__.useState({
    inView: !!initialInView,
    entry: void 0
  });
  callback.current = onChange;
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(
    () => {
      if (skip || !ref) return;
      let unobserve;
      unobserve = observe(
        ref,
        (inView, entry) => {
          setState({
            inView,
            entry
          });
          if (callback.current) callback.current(inView, entry);
          if (entry.isIntersecting && triggerOnce && unobserve) {
            unobserve();
            unobserve = void 0;
          }
        },
        {
          root,
          rootMargin,
          threshold,
          // @ts-ignore
          trackVisibility,
          // @ts-ignore
          delay
        },
        fallbackInView
      );
      return () => {
        if (unobserve) {
          unobserve();
        }
      };
    },
    // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      // If the threshold is an array, convert it to a string, so it won't change between renders.
      Array.isArray(threshold) ? threshold.toString() : threshold,
      ref,
      root,
      rootMargin,
      triggerOnce,
      skip,
      trackVisibility,
      fallbackInView,
      delay
    ]
  );
  const entryTarget = (_a = state.entry) == null ? void 0 : _a.target;
  const previousEntryTarget = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  if (!ref && entryTarget && !triggerOnce && !skip && previousEntryTarget.current !== entryTarget) {
    previousEntryTarget.current = entryTarget;
    setState({
      inView: !!initialInView,
      entry: void 0
    });
  }
  const result = [setRef, state.inView, state.entry];
  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}

//# sourceMappingURL=index.mjs.map

/***/ }),

/***/ 81069:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ee": function() { return /* binding */ __commonJS; },
/* harmony export */   "_l": function() { return /* binding */ extractEventHiddenProperties; },
/* harmony export */   "v": function() { return /* binding */ __toESM; }
/* harmony export */ });
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// src/dom-event.ts
var eventProperties = [
  "bubbles",
  "cancelBubble",
  "cancelable",
  "composed",
  "currentTarget",
  "defaultPrevented",
  "eventPhase",
  "isTrusted",
  "returnValue",
  "srcElement",
  "target",
  "timeStamp",
  "type"
];
var customEventSpecificProperties = ["detail"];
function extractEventHiddenProperties(event) {
  const rebuildEvent = eventProperties.filter((value) => event[value] !== void 0).reduce((acc, value) => {
    return { ...acc, [value]: event[value] };
  }, {});
  if (event instanceof CustomEvent) {
    customEventSpecificProperties.filter((value) => event[value] !== void 0).forEach((value) => {
      rebuildEvent[value] = event[value];
    });
  }
  return rebuildEvent;
}




/***/ }),

/***/ 73347:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qc": function() { return /* binding */ parse; }
/* harmony export */ });
/* unused harmony exports isJSON, replacer, reviver, stringify */
/* harmony import */ var _chunk_465TF3XA_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81069);
/* harmony import */ var memoizerific__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18425);


// node_modules/has-symbols/shams.js
var require_shams = (0,_chunk_465TF3XA_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__commonJS */ .Ee)({
  "node_modules/has-symbols/shams.js"(exports, module) {
    "use strict";
    module.exports = function hasSymbols() {
      if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") {
        return false;
      }
      if (typeof Symbol.iterator === "symbol") {
        return true;
      }
      var obj = {};
      var sym = Symbol("test");
      var symObj = Object(sym);
      if (typeof sym === "string") {
        return false;
      }
      if (Object.prototype.toString.call(sym) !== "[object Symbol]") {
        return false;
      }
      if (Object.prototype.toString.call(symObj) !== "[object Symbol]") {
        return false;
      }
      var symVal = 42;
      obj[sym] = symVal;
      for (sym in obj) {
        return false;
      }
      if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) {
        return false;
      }
      if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) {
        return false;
      }
      var syms = Object.getOwnPropertySymbols(obj);
      if (syms.length !== 1 || syms[0] !== sym) {
        return false;
      }
      if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) {
        return false;
      }
      if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) {
          return false;
        }
      }
      return true;
    };
  }
});

// node_modules/has-symbols/index.js
var require_has_symbols = (0,_chunk_465TF3XA_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__commonJS */ .Ee)({
  "node_modules/has-symbols/index.js"(exports, module) {
    "use strict";
    var origSymbol = typeof Symbol !== "undefined" && Symbol;
    var hasSymbolSham = require_shams();
    module.exports = function hasNativeSymbols() {
      if (typeof origSymbol !== "function") {
        return false;
      }
      if (typeof Symbol !== "function") {
        return false;
      }
      if (typeof origSymbol("foo") !== "symbol") {
        return false;
      }
      if (typeof Symbol("bar") !== "symbol") {
        return false;
      }
      return hasSymbolSham();
    };
  }
});

// node_modules/function-bind/implementation.js
var require_implementation = (0,_chunk_465TF3XA_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__commonJS */ .Ee)({
  "node_modules/function-bind/implementation.js"(exports, module) {
    "use strict";
    var ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
    var slice = Array.prototype.slice;
    var toStr = Object.prototype.toString;
    var funcType = "[object Function]";
    module.exports = function bind(that) {
      var target = this;
      if (typeof target !== "function" || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
      }
      var args2 = slice.call(arguments, 1);
      var bound;
      var binder = function() {
        if (this instanceof bound) {
          var result2 = target.apply(
            this,
            args2.concat(slice.call(arguments))
          );
          if (Object(result2) === result2) {
            return result2;
          }
          return this;
        } else {
          return target.apply(
            that,
            args2.concat(slice.call(arguments))
          );
        }
      };
      var boundLength = Math.max(0, target.length - args2.length);
      var boundArgs = [];
      for (var i = 0; i < boundLength; i++) {
        boundArgs.push("$" + i);
      }
      bound = Function("binder", "return function (" + boundArgs.join(",") + "){ return binder.apply(this,arguments); }")(binder);
      if (target.prototype) {
        var Empty = function Empty2() {
        };
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
      }
      return bound;
    };
  }
});

// node_modules/function-bind/index.js
var require_function_bind = (0,_chunk_465TF3XA_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__commonJS */ .Ee)({
  "node_modules/function-bind/index.js"(exports, module) {
    "use strict";
    var implementation = require_implementation();
    module.exports = Function.prototype.bind || implementation;
  }
});

// node_modules/has/src/index.js
var require_src = (0,_chunk_465TF3XA_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__commonJS */ .Ee)({
  "node_modules/has/src/index.js"(exports, module) {
    "use strict";
    var bind = require_function_bind();
    module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);
  }
});

// node_modules/get-intrinsic/index.js
var require_get_intrinsic = (0,_chunk_465TF3XA_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__commonJS */ .Ee)({
  "node_modules/get-intrinsic/index.js"(exports, module) {
    "use strict";
    var undefined2;
    var $SyntaxError = SyntaxError;
    var $Function = Function;
    var $TypeError = TypeError;
    var getEvalledConstructor = function(expressionSyntax) {
      try {
        return $Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
      } catch (e) {
      }
    };
    var $gOPD = Object.getOwnPropertyDescriptor;
    if ($gOPD) {
      try {
        $gOPD({}, "");
      } catch (e) {
        $gOPD = null;
      }
    }
    var throwTypeError = function() {
      throw new $TypeError();
    };
    var ThrowTypeError = $gOPD ? function() {
      try {
        arguments.callee;
        return throwTypeError;
      } catch (calleeThrows) {
        try {
          return $gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
          return throwTypeError;
        }
      }
    }() : throwTypeError;
    var hasSymbols = require_has_symbols()();
    var getProto = Object.getPrototypeOf || function(x) {
      return x.__proto__;
    };
    var needsEval = {};
    var TypedArray = typeof Uint8Array === "undefined" ? undefined2 : getProto(Uint8Array);
    var INTRINSICS = {
      "%AggregateError%": typeof AggregateError === "undefined" ? undefined2 : AggregateError,
      "%Array%": Array,
      "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined2 : ArrayBuffer,
      "%ArrayIteratorPrototype%": hasSymbols ? getProto([][Symbol.iterator]()) : undefined2,
      "%AsyncFromSyncIteratorPrototype%": undefined2,
      "%AsyncFunction%": needsEval,
      "%AsyncGenerator%": needsEval,
      "%AsyncGeneratorFunction%": needsEval,
      "%AsyncIteratorPrototype%": needsEval,
      "%Atomics%": typeof Atomics === "undefined" ? undefined2 : Atomics,
      "%BigInt%": typeof BigInt === "undefined" ? undefined2 : BigInt,
      "%Boolean%": Boolean,
      "%DataView%": typeof DataView === "undefined" ? undefined2 : DataView,
      "%Date%": Date,
      "%decodeURI%": decodeURI,
      "%decodeURIComponent%": decodeURIComponent,
      "%encodeURI%": encodeURI,
      "%encodeURIComponent%": encodeURIComponent,
      "%Error%": Error,
      "%eval%": eval,
      "%EvalError%": EvalError,
      "%Float32Array%": typeof Float32Array === "undefined" ? undefined2 : Float32Array,
      "%Float64Array%": typeof Float64Array === "undefined" ? undefined2 : Float64Array,
      "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined2 : FinalizationRegistry,
      "%Function%": $Function,
      "%GeneratorFunction%": needsEval,
      "%Int8Array%": typeof Int8Array === "undefined" ? undefined2 : Int8Array,
      "%Int16Array%": typeof Int16Array === "undefined" ? undefined2 : Int16Array,
      "%Int32Array%": typeof Int32Array === "undefined" ? undefined2 : Int32Array,
      "%isFinite%": isFinite,
      "%isNaN%": isNaN,
      "%IteratorPrototype%": hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined2,
      "%JSON%": typeof JSON === "object" ? JSON : undefined2,
      "%Map%": typeof Map === "undefined" ? undefined2 : Map,
      "%MapIteratorPrototype%": typeof Map === "undefined" || !hasSymbols ? undefined2 : getProto((/* @__PURE__ */ new Map())[Symbol.iterator]()),
      "%Math%": Math,
      "%Number%": Number,
      "%Object%": Object,
      "%parseFloat%": parseFloat,
      "%parseInt%": parseInt,
      "%Promise%": typeof Promise === "undefined" ? undefined2 : Promise,
      "%Proxy%": typeof Proxy === "undefined" ? undefined2 : Proxy,
      "%RangeError%": RangeError,
      "%ReferenceError%": ReferenceError,
      "%Reflect%": typeof Reflect === "undefined" ? undefined2 : Reflect,
      "%RegExp%": RegExp,
      "%Set%": typeof Set === "undefined" ? undefined2 : Set,
      "%SetIteratorPrototype%": typeof Set === "undefined" || !hasSymbols ? undefined2 : getProto((/* @__PURE__ */ new Set())[Symbol.iterator]()),
      "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined2 : SharedArrayBuffer,
      "%String%": String,
      "%StringIteratorPrototype%": hasSymbols ? getProto(""[Symbol.iterator]()) : undefined2,
      "%Symbol%": hasSymbols ? Symbol : undefined2,
      "%SyntaxError%": $SyntaxError,
      "%ThrowTypeError%": ThrowTypeError,
      "%TypedArray%": TypedArray,
      "%TypeError%": $TypeError,
      "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined2 : Uint8Array,
      "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined2 : Uint8ClampedArray,
      "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined2 : Uint16Array,
      "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined2 : Uint32Array,
      "%URIError%": URIError,
      "%WeakMap%": typeof WeakMap === "undefined" ? undefined2 : WeakMap,
      "%WeakRef%": typeof WeakRef === "undefined" ? undefined2 : WeakRef,
      "%WeakSet%": typeof WeakSet === "undefined" ? undefined2 : WeakSet
    };
    var doEval = function doEval2(name2) {
      var value2;
      if (name2 === "%AsyncFunction%") {
        value2 = getEvalledConstructor("async function () {}");
      } else if (name2 === "%GeneratorFunction%") {
        value2 = getEvalledConstructor("function* () {}");
      } else if (name2 === "%AsyncGeneratorFunction%") {
        value2 = getEvalledConstructor("async function* () {}");
      } else if (name2 === "%AsyncGenerator%") {
        var fn = doEval2("%AsyncGeneratorFunction%");
        if (fn) {
          value2 = fn.prototype;
        }
      } else if (name2 === "%AsyncIteratorPrototype%") {
        var gen = doEval2("%AsyncGenerator%");
        if (gen) {
          value2 = getProto(gen.prototype);
        }
      }
      INTRINSICS[name2] = value2;
      return value2;
    };
    var LEGACY_ALIASES = {
      "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
      "%ArrayPrototype%": ["Array", "prototype"],
      "%ArrayProto_entries%": ["Array", "prototype", "entries"],
      "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
      "%ArrayProto_keys%": ["Array", "prototype", "keys"],
      "%ArrayProto_values%": ["Array", "prototype", "values"],
      "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
      "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
      "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
      "%BooleanPrototype%": ["Boolean", "prototype"],
      "%DataViewPrototype%": ["DataView", "prototype"],
      "%DatePrototype%": ["Date", "prototype"],
      "%ErrorPrototype%": ["Error", "prototype"],
      "%EvalErrorPrototype%": ["EvalError", "prototype"],
      "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
      "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
      "%FunctionPrototype%": ["Function", "prototype"],
      "%Generator%": ["GeneratorFunction", "prototype"],
      "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
      "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
      "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
      "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
      "%JSONParse%": ["JSON", "parse"],
      "%JSONStringify%": ["JSON", "stringify"],
      "%MapPrototype%": ["Map", "prototype"],
      "%NumberPrototype%": ["Number", "prototype"],
      "%ObjectPrototype%": ["Object", "prototype"],
      "%ObjProto_toString%": ["Object", "prototype", "toString"],
      "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
      "%PromisePrototype%": ["Promise", "prototype"],
      "%PromiseProto_then%": ["Promise", "prototype", "then"],
      "%Promise_all%": ["Promise", "all"],
      "%Promise_reject%": ["Promise", "reject"],
      "%Promise_resolve%": ["Promise", "resolve"],
      "%RangeErrorPrototype%": ["RangeError", "prototype"],
      "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
      "%RegExpPrototype%": ["RegExp", "prototype"],
      "%SetPrototype%": ["Set", "prototype"],
      "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
      "%StringPrototype%": ["String", "prototype"],
      "%SymbolPrototype%": ["Symbol", "prototype"],
      "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
      "%TypedArrayPrototype%": ["TypedArray", "prototype"],
      "%TypeErrorPrototype%": ["TypeError", "prototype"],
      "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
      "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
      "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
      "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
      "%URIErrorPrototype%": ["URIError", "prototype"],
      "%WeakMapPrototype%": ["WeakMap", "prototype"],
      "%WeakSetPrototype%": ["WeakSet", "prototype"]
    };
    var bind = require_function_bind();
    var hasOwn = require_src();
    var $concat = bind.call(Function.call, Array.prototype.concat);
    var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
    var $replace = bind.call(Function.call, String.prototype.replace);
    var $strSlice = bind.call(Function.call, String.prototype.slice);
    var $exec = bind.call(Function.call, RegExp.prototype.exec);
    var rePropName2 = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
    var reEscapeChar2 = /\\(\\)?/g;
    var stringToPath2 = function stringToPath3(string) {
      var first = $strSlice(string, 0, 1);
      var last = $strSlice(string, -1);
      if (first === "%" && last !== "%") {
        throw new $SyntaxError("invalid intrinsic syntax, expected closing `%`");
      } else if (last === "%" && first !== "%") {
        throw new $SyntaxError("invalid intrinsic syntax, expected opening `%`");
      }
      var result2 = [];
      $replace(string, rePropName2, function(match, number, quote, subString) {
        result2[result2.length] = quote ? $replace(subString, reEscapeChar2, "$1") : number || match;
      });
      return result2;
    };
    var getBaseIntrinsic = function getBaseIntrinsic2(name2, allowMissing) {
      var intrinsicName = name2;
      var alias;
      if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
        alias = LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
      }
      if (hasOwn(INTRINSICS, intrinsicName)) {
        var value2 = INTRINSICS[intrinsicName];
        if (value2 === needsEval) {
          value2 = doEval(intrinsicName);
        }
        if (typeof value2 === "undefined" && !allowMissing) {
          throw new $TypeError("intrinsic " + name2 + " exists, but is not available. Please file an issue!");
        }
        return {
          alias,
          name: intrinsicName,
          value: value2
        };
      }
      throw new $SyntaxError("intrinsic " + name2 + " does not exist!");
    };
    module.exports = function GetIntrinsic(name2, allowMissing) {
      if (typeof name2 !== "string" || name2.length === 0) {
        throw new $TypeError("intrinsic name must be a non-empty string");
      }
      if (arguments.length > 1 && typeof allowMissing !== "boolean") {
        throw new $TypeError('"allowMissing" argument must be a boolean');
      }
      if ($exec(/^%?[^%]*%?$/, name2) === null) {
        throw new $SyntaxError("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
      }
      var parts = stringToPath2(name2);
      var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
      var intrinsic = getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
      var intrinsicRealName = intrinsic.name;
      var value2 = intrinsic.value;
      var skipFurtherCaching = false;
      var alias = intrinsic.alias;
      if (alias) {
        intrinsicBaseName = alias[0];
        $spliceApply(parts, $concat([0, 1], alias));
      }
      for (var i = 1, isOwn = true; i < parts.length; i += 1) {
        var part = parts[i];
        var first = $strSlice(part, 0, 1);
        var last = $strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || (last === '"' || last === "'" || last === "`")) && first !== last) {
          throw new $SyntaxError("property names with quotes must have matching quotes");
        }
        if (part === "constructor" || !isOwn) {
          skipFurtherCaching = true;
        }
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if (hasOwn(INTRINSICS, intrinsicRealName)) {
          value2 = INTRINSICS[intrinsicRealName];
        } else if (value2 != null) {
          if (!(part in value2)) {
            if (!allowMissing) {
              throw new $TypeError("base intrinsic for " + name2 + " exists, but the property is not available.");
            }
            return void 0;
          }
          if ($gOPD && i + 1 >= parts.length) {
            var desc = $gOPD(value2, part);
            isOwn = !!desc;
            if (isOwn && "get" in desc && !("originalValue" in desc.get)) {
              value2 = desc.get;
            } else {
              value2 = value2[part];
            }
          } else {
            isOwn = hasOwn(value2, part);
            value2 = value2[part];
          }
          if (isOwn && !skipFurtherCaching) {
            INTRINSICS[intrinsicRealName] = value2;
          }
        }
      }
      return value2;
    };
  }
});

// node_modules/call-bind/index.js
var require_call_bind = (0,_chunk_465TF3XA_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__commonJS */ .Ee)({
  "node_modules/call-bind/index.js"(exports, module) {
    "use strict";
    var bind = require_function_bind();
    var GetIntrinsic = require_get_intrinsic();
    var $apply = GetIntrinsic("%Function.prototype.apply%");
    var $call = GetIntrinsic("%Function.prototype.call%");
    var $reflectApply = GetIntrinsic("%Reflect.apply%", true) || bind.call($call, $apply);
    var $gOPD = GetIntrinsic("%Object.getOwnPropertyDescriptor%", true);
    var $defineProperty = GetIntrinsic("%Object.defineProperty%", true);
    var $max = GetIntrinsic("%Math.max%");
    if ($defineProperty) {
      try {
        $defineProperty({}, "a", { value: 1 });
      } catch (e) {
        $defineProperty = null;
      }
    }
    module.exports = function callBind(originalFunction) {
      var func = $reflectApply(bind, $call, arguments);
      if ($gOPD && $defineProperty) {
        var desc = $gOPD(func, "length");
        if (desc.configurable) {
          $defineProperty(
            func,
            "length",
            { value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
          );
        }
      }
      return func;
    };
    var applyBind = function applyBind2() {
      return $reflectApply(bind, $apply, arguments);
    };
    if ($defineProperty) {
      $defineProperty(module.exports, "apply", { value: applyBind });
    } else {
      module.exports.apply = applyBind;
    }
  }
});

// node_modules/call-bind/callBound.js
var require_callBound = (0,_chunk_465TF3XA_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__commonJS */ .Ee)({
  "node_modules/call-bind/callBound.js"(exports, module) {
    "use strict";
    var GetIntrinsic = require_get_intrinsic();
    var callBind = require_call_bind();
    var $indexOf = callBind(GetIntrinsic("String.prototype.indexOf"));
    module.exports = function callBoundIntrinsic(name2, allowMissing) {
      var intrinsic = GetIntrinsic(name2, !!allowMissing);
      if (typeof intrinsic === "function" && $indexOf(name2, ".prototype.") > -1) {
        return callBind(intrinsic);
      }
      return intrinsic;
    };
  }
});

// node_modules/has-tostringtag/shams.js
var require_shams2 = (0,_chunk_465TF3XA_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__commonJS */ .Ee)({
  "node_modules/has-tostringtag/shams.js"(exports, module) {
    "use strict";
    var hasSymbols = require_shams();
    module.exports = function hasToStringTagShams() {
      return hasSymbols() && !!Symbol.toStringTag;
    };
  }
});

// node_modules/is-regex/index.js
var require_is_regex = (0,_chunk_465TF3XA_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__commonJS */ .Ee)({
  "node_modules/is-regex/index.js"(exports, module) {
    "use strict";
    var callBound = require_callBound();
    var hasToStringTag = require_shams2()();
    var has;
    var $exec;
    var isRegexMarker;
    var badStringifier;
    if (hasToStringTag) {
      has = callBound("Object.prototype.hasOwnProperty");
      $exec = callBound("RegExp.prototype.exec");
      isRegexMarker = {};
      throwRegexMarker = function() {
        throw isRegexMarker;
      };
      badStringifier = {
        toString: throwRegexMarker,
        valueOf: throwRegexMarker
      };
      if (typeof Symbol.toPrimitive === "symbol") {
        badStringifier[Symbol.toPrimitive] = throwRegexMarker;
      }
    }
    var throwRegexMarker;
    var $toString = callBound("Object.prototype.toString");
    var gOPD = Object.getOwnPropertyDescriptor;
    var regexClass = "[object RegExp]";
    module.exports = hasToStringTag ? function isRegex(value2) {
      if (!value2 || typeof value2 !== "object") {
        return false;
      }
      var descriptor = gOPD(value2, "lastIndex");
      var hasLastIndexDataProperty = descriptor && has(descriptor, "value");
      if (!hasLastIndexDataProperty) {
        return false;
      }
      try {
        $exec(value2, badStringifier);
      } catch (e) {
        return e === isRegexMarker;
      }
    } : function isRegex(value2) {
      if (!value2 || typeof value2 !== "object" && typeof value2 !== "function") {
        return false;
      }
      return $toString(value2) === regexClass;
    };
  }
});

// node_modules/is-function/index.js
var require_is_function = (0,_chunk_465TF3XA_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__commonJS */ .Ee)({
  "node_modules/is-function/index.js"(exports, module) {
    module.exports = isFunction3;
    var toString2 = Object.prototype.toString;
    function isFunction3(fn) {
      if (!fn) {
        return false;
      }
      var string = toString2.call(fn);
      return string === "[object Function]" || typeof fn === "function" && string !== "[object RegExp]" || typeof window !== "undefined" && (fn === window.setTimeout || fn === window.alert || fn === window.confirm || fn === window.prompt);
    }
  }
});

// node_modules/is-symbol/index.js
var require_is_symbol = (0,_chunk_465TF3XA_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__commonJS */ .Ee)({
  "node_modules/is-symbol/index.js"(exports, module) {
    "use strict";
    var toStr = Object.prototype.toString;
    var hasSymbols = require_has_symbols()();
    if (hasSymbols) {
      symToStr = Symbol.prototype.toString;
      symStringRegex = /^Symbol\(.*\)$/;
      isSymbolObject = function isRealSymbolObject(value2) {
        if (typeof value2.valueOf() !== "symbol") {
          return false;
        }
        return symStringRegex.test(symToStr.call(value2));
      };
      module.exports = function isSymbol3(value2) {
        if (typeof value2 === "symbol") {
          return true;
        }
        if (toStr.call(value2) !== "[object Symbol]") {
          return false;
        }
        try {
          return isSymbolObject(value2);
        } catch (e) {
          return false;
        }
      };
    } else {
      module.exports = function isSymbol3(value2) {
        return false;
      };
    }
    var symToStr;
    var symStringRegex;
    var isSymbolObject;
  }
});

// src/index.ts
var import_is_regex = (0,_chunk_465TF3XA_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__toESM */ .v)(require_is_regex());
var import_is_function = (0,_chunk_465TF3XA_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__toESM */ .v)(require_is_function());
var import_is_symbol = (0,_chunk_465TF3XA_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__toESM */ .v)(require_is_symbol());

// node_modules/isobject/index.js
function isObject(val) {
  return val != null && typeof val === "object" && Array.isArray(val) === false;
}

// node_modules/lodash-es/_freeGlobal.js
var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
var freeGlobal_default = freeGlobal;

// node_modules/lodash-es/_root.js
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root2 = freeGlobal_default || freeSelf || Function("return this")();
var root_default = root2;

// node_modules/lodash-es/_Symbol.js
var Symbol2 = root_default.Symbol;
var Symbol_default = Symbol2;

// node_modules/lodash-es/_getRawTag.js
var objectProto = Object.prototype;
var hasOwnProperty = objectProto.hasOwnProperty;
var nativeObjectToString = objectProto.toString;
var symToStringTag = Symbol_default ? Symbol_default.toStringTag : void 0;
function getRawTag(value2) {
  var isOwn = hasOwnProperty.call(value2, symToStringTag), tag = value2[symToStringTag];
  try {
    value2[symToStringTag] = void 0;
    var unmasked = true;
  } catch (e) {
  }
  var result2 = nativeObjectToString.call(value2);
  if (unmasked) {
    if (isOwn) {
      value2[symToStringTag] = tag;
    } else {
      delete value2[symToStringTag];
    }
  }
  return result2;
}
var getRawTag_default = getRawTag;

// node_modules/lodash-es/_objectToString.js
var objectProto2 = Object.prototype;
var nativeObjectToString2 = objectProto2.toString;
function objectToString(value2) {
  return nativeObjectToString2.call(value2);
}
var objectToString_default = objectToString;

// node_modules/lodash-es/_baseGetTag.js
var nullTag = "[object Null]";
var undefinedTag = "[object Undefined]";
var symToStringTag2 = Symbol_default ? Symbol_default.toStringTag : void 0;
function baseGetTag(value2) {
  if (value2 == null) {
    return value2 === void 0 ? undefinedTag : nullTag;
  }
  return symToStringTag2 && symToStringTag2 in Object(value2) ? getRawTag_default(value2) : objectToString_default(value2);
}
var baseGetTag_default = baseGetTag;

// node_modules/lodash-es/isObjectLike.js
function isObjectLike(value2) {
  return value2 != null && typeof value2 == "object";
}
var isObjectLike_default = isObjectLike;

// node_modules/lodash-es/isSymbol.js
var symbolTag = "[object Symbol]";
function isSymbol(value2) {
  return typeof value2 == "symbol" || isObjectLike_default(value2) && baseGetTag_default(value2) == symbolTag;
}
var isSymbol_default = isSymbol;

// node_modules/lodash-es/_arrayMap.js
function arrayMap(array, iteratee) {
  var index = -1, length = array == null ? 0 : array.length, result2 = Array(length);
  while (++index < length) {
    result2[index] = iteratee(array[index], index, array);
  }
  return result2;
}
var arrayMap_default = arrayMap;

// node_modules/lodash-es/isArray.js
var isArray = Array.isArray;
var isArray_default = isArray;

// node_modules/lodash-es/_baseToString.js
var INFINITY = 1 / 0;
var symbolProto = Symbol_default ? Symbol_default.prototype : void 0;
var symbolToString = symbolProto ? symbolProto.toString : void 0;
function baseToString(value2) {
  if (typeof value2 == "string") {
    return value2;
  }
  if (isArray_default(value2)) {
    return arrayMap_default(value2, baseToString) + "";
  }
  if (isSymbol_default(value2)) {
    return symbolToString ? symbolToString.call(value2) : "";
  }
  var result2 = value2 + "";
  return result2 == "0" && 1 / value2 == -INFINITY ? "-0" : result2;
}
var baseToString_default = baseToString;

// node_modules/lodash-es/isObject.js
function isObject2(value2) {
  var type = typeof value2;
  return value2 != null && (type == "object" || type == "function");
}
var isObject_default = isObject2;

// node_modules/lodash-es/isFunction.js
var asyncTag = "[object AsyncFunction]";
var funcTag = "[object Function]";
var genTag = "[object GeneratorFunction]";
var proxyTag = "[object Proxy]";
function isFunction(value2) {
  if (!isObject_default(value2)) {
    return false;
  }
  var tag = baseGetTag_default(value2);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
var isFunction_default = isFunction;

// node_modules/lodash-es/_coreJsData.js
var coreJsData = root_default["__core-js_shared__"];
var coreJsData_default = coreJsData;

// node_modules/lodash-es/_isMasked.js
var maskSrcKey = function() {
  var uid = /[^.]+$/.exec(coreJsData_default && coreJsData_default.keys && coreJsData_default.keys.IE_PROTO || "");
  return uid ? "Symbol(src)_1." + uid : "";
}();
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}
var isMasked_default = isMasked;

// node_modules/lodash-es/_toSource.js
var funcProto = Function.prototype;
var funcToString = funcProto.toString;
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {
    }
    try {
      return func + "";
    } catch (e) {
    }
  }
  return "";
}
var toSource_default = toSource;

// node_modules/lodash-es/_baseIsNative.js
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
var reIsHostCtor = /^\[object .+?Constructor\]$/;
var funcProto2 = Function.prototype;
var objectProto3 = Object.prototype;
var funcToString2 = funcProto2.toString;
var hasOwnProperty2 = objectProto3.hasOwnProperty;
var reIsNative = RegExp(
  "^" + funcToString2.call(hasOwnProperty2).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function baseIsNative(value2) {
  if (!isObject_default(value2) || isMasked_default(value2)) {
    return false;
  }
  var pattern = isFunction_default(value2) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource_default(value2));
}
var baseIsNative_default = baseIsNative;

// node_modules/lodash-es/_getValue.js
function getValue(object, key2) {
  return object == null ? void 0 : object[key2];
}
var getValue_default = getValue;

// node_modules/lodash-es/_getNative.js
function getNative(object, key2) {
  var value2 = getValue_default(object, key2);
  return baseIsNative_default(value2) ? value2 : void 0;
}
var getNative_default = getNative;

// node_modules/lodash-es/eq.js
function eq(value2, other) {
  return value2 === other || value2 !== value2 && other !== other;
}
var eq_default = eq;

// node_modules/lodash-es/_isKey.js
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/;
var reIsPlainProp = /^\w*$/;
function isKey(value2, object) {
  if (isArray_default(value2)) {
    return false;
  }
  var type = typeof value2;
  if (type == "number" || type == "symbol" || type == "boolean" || value2 == null || isSymbol_default(value2)) {
    return true;
  }
  return reIsPlainProp.test(value2) || !reIsDeepProp.test(value2) || object != null && value2 in Object(object);
}
var isKey_default = isKey;

// node_modules/lodash-es/_nativeCreate.js
var nativeCreate = getNative_default(Object, "create");
var nativeCreate_default = nativeCreate;

// node_modules/lodash-es/_hashClear.js
function hashClear() {
  this.__data__ = nativeCreate_default ? nativeCreate_default(null) : {};
  this.size = 0;
}
var hashClear_default = hashClear;

// node_modules/lodash-es/_hashDelete.js
function hashDelete(key2) {
  var result2 = this.has(key2) && delete this.__data__[key2];
  this.size -= result2 ? 1 : 0;
  return result2;
}
var hashDelete_default = hashDelete;

// node_modules/lodash-es/_hashGet.js
var HASH_UNDEFINED = "__lodash_hash_undefined__";
var objectProto4 = Object.prototype;
var hasOwnProperty3 = objectProto4.hasOwnProperty;
function hashGet(key2) {
  var data = this.__data__;
  if (nativeCreate_default) {
    var result2 = data[key2];
    return result2 === HASH_UNDEFINED ? void 0 : result2;
  }
  return hasOwnProperty3.call(data, key2) ? data[key2] : void 0;
}
var hashGet_default = hashGet;

// node_modules/lodash-es/_hashHas.js
var objectProto5 = Object.prototype;
var hasOwnProperty4 = objectProto5.hasOwnProperty;
function hashHas(key2) {
  var data = this.__data__;
  return nativeCreate_default ? data[key2] !== void 0 : hasOwnProperty4.call(data, key2);
}
var hashHas_default = hashHas;

// node_modules/lodash-es/_hashSet.js
var HASH_UNDEFINED2 = "__lodash_hash_undefined__";
function hashSet(key2, value2) {
  var data = this.__data__;
  this.size += this.has(key2) ? 0 : 1;
  data[key2] = nativeCreate_default && value2 === void 0 ? HASH_UNDEFINED2 : value2;
  return this;
}
var hashSet_default = hashSet;

// node_modules/lodash-es/_Hash.js
function Hash(entries) {
  var index = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
Hash.prototype.clear = hashClear_default;
Hash.prototype["delete"] = hashDelete_default;
Hash.prototype.get = hashGet_default;
Hash.prototype.has = hashHas_default;
Hash.prototype.set = hashSet_default;
var Hash_default = Hash;

// node_modules/lodash-es/_listCacheClear.js
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}
var listCacheClear_default = listCacheClear;

// node_modules/lodash-es/_assocIndexOf.js
function assocIndexOf(array, key2) {
  var length = array.length;
  while (length--) {
    if (eq_default(array[length][0], key2)) {
      return length;
    }
  }
  return -1;
}
var assocIndexOf_default = assocIndexOf;

// node_modules/lodash-es/_listCacheDelete.js
var arrayProto = Array.prototype;
var splice = arrayProto.splice;
function listCacheDelete(key2) {
  var data = this.__data__, index = assocIndexOf_default(data, key2);
  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}
var listCacheDelete_default = listCacheDelete;

// node_modules/lodash-es/_listCacheGet.js
function listCacheGet(key2) {
  var data = this.__data__, index = assocIndexOf_default(data, key2);
  return index < 0 ? void 0 : data[index][1];
}
var listCacheGet_default = listCacheGet;

// node_modules/lodash-es/_listCacheHas.js
function listCacheHas(key2) {
  return assocIndexOf_default(this.__data__, key2) > -1;
}
var listCacheHas_default = listCacheHas;

// node_modules/lodash-es/_listCacheSet.js
function listCacheSet(key2, value2) {
  var data = this.__data__, index = assocIndexOf_default(data, key2);
  if (index < 0) {
    ++this.size;
    data.push([key2, value2]);
  } else {
    data[index][1] = value2;
  }
  return this;
}
var listCacheSet_default = listCacheSet;

// node_modules/lodash-es/_ListCache.js
function ListCache(entries) {
  var index = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
ListCache.prototype.clear = listCacheClear_default;
ListCache.prototype["delete"] = listCacheDelete_default;
ListCache.prototype.get = listCacheGet_default;
ListCache.prototype.has = listCacheHas_default;
ListCache.prototype.set = listCacheSet_default;
var ListCache_default = ListCache;

// node_modules/lodash-es/_Map.js
var Map2 = getNative_default(root_default, "Map");
var Map_default = Map2;

// node_modules/lodash-es/_mapCacheClear.js
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    "hash": new Hash_default(),
    "map": new (Map_default || ListCache_default)(),
    "string": new Hash_default()
  };
}
var mapCacheClear_default = mapCacheClear;

// node_modules/lodash-es/_isKeyable.js
function isKeyable(value2) {
  var type = typeof value2;
  return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value2 !== "__proto__" : value2 === null;
}
var isKeyable_default = isKeyable;

// node_modules/lodash-es/_getMapData.js
function getMapData(map, key2) {
  var data = map.__data__;
  return isKeyable_default(key2) ? data[typeof key2 == "string" ? "string" : "hash"] : data.map;
}
var getMapData_default = getMapData;

// node_modules/lodash-es/_mapCacheDelete.js
function mapCacheDelete(key2) {
  var result2 = getMapData_default(this, key2)["delete"](key2);
  this.size -= result2 ? 1 : 0;
  return result2;
}
var mapCacheDelete_default = mapCacheDelete;

// node_modules/lodash-es/_mapCacheGet.js
function mapCacheGet(key2) {
  return getMapData_default(this, key2).get(key2);
}
var mapCacheGet_default = mapCacheGet;

// node_modules/lodash-es/_mapCacheHas.js
function mapCacheHas(key2) {
  return getMapData_default(this, key2).has(key2);
}
var mapCacheHas_default = mapCacheHas;

// node_modules/lodash-es/_mapCacheSet.js
function mapCacheSet(key2, value2) {
  var data = getMapData_default(this, key2), size = data.size;
  data.set(key2, value2);
  this.size += data.size == size ? 0 : 1;
  return this;
}
var mapCacheSet_default = mapCacheSet;

// node_modules/lodash-es/_MapCache.js
function MapCache(entries) {
  var index = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
MapCache.prototype.clear = mapCacheClear_default;
MapCache.prototype["delete"] = mapCacheDelete_default;
MapCache.prototype.get = mapCacheGet_default;
MapCache.prototype.has = mapCacheHas_default;
MapCache.prototype.set = mapCacheSet_default;
var MapCache_default = MapCache;

// node_modules/lodash-es/memoize.js
var FUNC_ERROR_TEXT = "Expected a function";
function memoize(func, resolver) {
  if (typeof func != "function" || resolver != null && typeof resolver != "function") {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args2 = arguments, key2 = resolver ? resolver.apply(this, args2) : args2[0], cache = memoized.cache;
    if (cache.has(key2)) {
      return cache.get(key2);
    }
    var result2 = func.apply(this, args2);
    memoized.cache = cache.set(key2, result2) || cache;
    return result2;
  };
  memoized.cache = new (memoize.Cache || MapCache_default)();
  return memoized;
}
memoize.Cache = MapCache_default;
var memoize_default = memoize;

// node_modules/lodash-es/_memoizeCapped.js
var MAX_MEMOIZE_SIZE = 500;
function memoizeCapped(func) {
  var result2 = memoize_default(func, function(key2) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key2;
  });
  var cache = result2.cache;
  return result2;
}
var memoizeCapped_default = memoizeCapped;

// node_modules/lodash-es/_stringToPath.js
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
var reEscapeChar = /\\(\\)?/g;
var stringToPath = memoizeCapped_default(function(string) {
  var result2 = [];
  if (string.charCodeAt(0) === 46) {
    result2.push("");
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result2.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
  });
  return result2;
});
var stringToPath_default = stringToPath;

// node_modules/lodash-es/toString.js
function toString(value2) {
  return value2 == null ? "" : baseToString_default(value2);
}
var toString_default = toString;

// node_modules/lodash-es/_castPath.js
function castPath(value2, object) {
  if (isArray_default(value2)) {
    return value2;
  }
  return isKey_default(value2, object) ? [value2] : stringToPath_default(toString_default(value2));
}
var castPath_default = castPath;

// node_modules/lodash-es/_toKey.js
var INFINITY2 = 1 / 0;
function toKey(value2) {
  if (typeof value2 == "string" || isSymbol_default(value2)) {
    return value2;
  }
  var result2 = value2 + "";
  return result2 == "0" && 1 / value2 == -INFINITY2 ? "-0" : result2;
}
var toKey_default = toKey;

// node_modules/lodash-es/_baseGet.js
function baseGet(object, path) {
  path = castPath_default(path, object);
  var index = 0, length = path.length;
  while (object != null && index < length) {
    object = object[toKey_default(path[index++])];
  }
  return index && index == length ? object : void 0;
}
var baseGet_default = baseGet;

// node_modules/lodash-es/get.js
function get(object, path, defaultValue) {
  var result2 = object == null ? void 0 : baseGet_default(object, path);
  return result2 === void 0 ? defaultValue : result2;
}
var get_default = get;

// src/index.ts

var isObject3 = isObject;
var removeCodeComments = (code) => {
  let inQuoteChar = null;
  let inBlockComment = false;
  let inLineComment = false;
  let inRegexLiteral = false;
  let newCode = "";
  if (code.indexOf("//") >= 0 || code.indexOf("/*") >= 0) {
    for (let i = 0; i < code.length; i += 1) {
      if (!inQuoteChar && !inBlockComment && !inLineComment && !inRegexLiteral) {
        if (code[i] === '"' || code[i] === "'" || code[i] === "`") {
          inQuoteChar = code[i];
        } else if (code[i] === "/" && code[i + 1] === "*") {
          inBlockComment = true;
        } else if (code[i] === "/" && code[i + 1] === "/") {
          inLineComment = true;
        } else if (code[i] === "/" && code[i + 1] !== "/") {
          inRegexLiteral = true;
        }
      } else {
        if (inQuoteChar && (code[i] === inQuoteChar && code[i - 1] !== "\\" || code[i] === "\n" && inQuoteChar !== "`")) {
          inQuoteChar = null;
        }
        if (inRegexLiteral && (code[i] === "/" && code[i - 1] !== "\\" || code[i] === "\n")) {
          inRegexLiteral = false;
        }
        if (inBlockComment && code[i - 1] === "/" && code[i - 2] === "*") {
          inBlockComment = false;
        }
        if (inLineComment && code[i] === "\n") {
          inLineComment = false;
        }
      }
      if (!inBlockComment && !inLineComment) {
        newCode += code[i];
      }
    }
  } else {
    newCode = code;
  }
  return newCode;
};
var cleanCode = memoizerific__WEBPACK_IMPORTED_MODULE_1__(1e4)(
  (code) => removeCodeComments(code).replace(/\n\s*/g, "").trim()
);
var convertShorthandMethods = function convertShorthandMethods2(key2, stringified) {
  const fnHead = stringified.slice(0, stringified.indexOf("{"));
  const fnBody = stringified.slice(stringified.indexOf("{"));
  if (fnHead.includes("=>")) {
    return stringified;
  }
  if (fnHead.includes("function")) {
    return stringified;
  }
  let modifiedHead = fnHead;
  modifiedHead = modifiedHead.replace(key2, "function");
  return modifiedHead + fnBody;
};
var dateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?Z$/;
var isJSON = (input) => input.match(/^[\[\{\"\}].*[\]\}\"]$/);
function convertUnconventionalData(data) {
  if (!isObject3(data)) {
    return data;
  }
  let result2 = data;
  let wasMutated = false;
  if (typeof Event !== "undefined" && data instanceof Event) {
    result2 = (0,_chunk_465TF3XA_mjs__WEBPACK_IMPORTED_MODULE_0__/* .extractEventHiddenProperties */ ._l)(result2);
    wasMutated = true;
  }
  result2 = Object.keys(result2).reduce((acc, key2) => {
    try {
      if (result2[key2]) {
        result2[key2].toJSON;
      }
      acc[key2] = result2[key2];
    } catch (err) {
      wasMutated = true;
    }
    return acc;
  }, {});
  return wasMutated ? result2 : data;
}
var replacer = function replacer2(options2) {
  let objects;
  let map;
  let stack;
  let keys;
  return function replace(key2, value2) {
    try {
      if (key2 === "") {
        keys = [];
        objects = /* @__PURE__ */ new Map([[value2, "[]"]]);
        map = /* @__PURE__ */ new Map();
        stack = [];
        return value2;
      }
      const origin = map.get(this) || this;
      while (stack.length && origin !== stack[0]) {
        stack.shift();
        keys.pop();
      }
      if (typeof value2 === "boolean") {
        return value2;
      }
      if (value2 === void 0) {
        if (!options2.allowUndefined) {
          return void 0;
        }
        return "_undefined_";
      }
      if (value2 === null) {
        return null;
      }
      if (typeof value2 === "number") {
        if (value2 === -Infinity) {
          return "_-Infinity_";
        }
        if (value2 === Infinity) {
          return "_Infinity_";
        }
        if (Number.isNaN(value2)) {
          return "_NaN_";
        }
        return value2;
      }
      if (typeof value2 === "bigint") {
        return `_bigint_${value2.toString()}`;
      }
      if (typeof value2 === "string") {
        if (dateFormat.test(value2)) {
          if (!options2.allowDate) {
            return void 0;
          }
          return `_date_${value2}`;
        }
        return value2;
      }
      if ((0, import_is_regex.default)(value2)) {
        if (!options2.allowRegExp) {
          return void 0;
        }
        return `_regexp_${value2.flags}|${value2.source}`;
      }
      if ((0, import_is_function.default)(value2)) {
        if (!options2.allowFunction) {
          return void 0;
        }
        const { name: name2 } = value2;
        const stringified = value2.toString();
        if (!stringified.match(
          /(\[native code\]|WEBPACK_IMPORTED_MODULE|__webpack_exports__|__webpack_require__)/
        )) {
          return `_function_${name2}|${cleanCode(convertShorthandMethods(key2, stringified))}`;
        }
        return `_function_${name2}|${(() => {
        }).toString()}`;
      }
      if ((0, import_is_symbol.default)(value2)) {
        if (!options2.allowSymbol) {
          return void 0;
        }
        const globalRegistryKey = Symbol.keyFor(value2);
        if (globalRegistryKey !== void 0) {
          return `_gsymbol_${globalRegistryKey}`;
        }
        return `_symbol_${value2.toString().slice(7, -1)}`;
      }
      if (stack.length >= options2.maxDepth) {
        if (Array.isArray(value2)) {
          return `[Array(${value2.length})]`;
        }
        return "[Object]";
      }
      if (value2 === this) {
        return `_duplicate_${JSON.stringify(keys)}`;
      }
      if (value2 instanceof Error && options2.allowError) {
        return {
          __isConvertedError__: true,
          errorProperties: {
            ...value2.cause ? { cause: value2.cause } : {},
            ...value2,
            name: value2.name,
            message: value2.message,
            stack: value2.stack,
            "_constructor-name_": value2.constructor.name
          }
        };
      }
      if (value2.constructor && value2.constructor.name && value2.constructor.name !== "Object" && !Array.isArray(value2) && !options2.allowClass) {
        return void 0;
      }
      const found = objects.get(value2);
      if (!found) {
        const converted = Array.isArray(value2) ? value2 : convertUnconventionalData(value2);
        if (value2.constructor && value2.constructor.name && value2.constructor.name !== "Object" && !Array.isArray(value2) && options2.allowClass) {
          try {
            Object.assign(converted, { "_constructor-name_": value2.constructor.name });
          } catch (e) {
          }
        }
        keys.push(key2);
        stack.unshift(converted);
        objects.set(value2, JSON.stringify(keys));
        if (value2 !== converted) {
          map.set(value2, converted);
        }
        return converted;
      }
      return `_duplicate_${found}`;
    } catch (e) {
      return void 0;
    }
  };
};
var reviver2 = function reviver(options) {
  const refs = [];
  let root;
  return function revive(key, value) {
    if (key === "") {
      root = value;
      refs.forEach(({ target, container, replacement }) => {
        const replacementArr = isJSON(replacement) ? JSON.parse(replacement) : replacement.split(".");
        if (replacementArr.length === 0) {
          container[target] = root;
        } else {
          container[target] = get_default(root, replacementArr);
        }
      });
    }
    if (key === "_constructor-name_") {
      return value;
    }
    if (isObject3(value) && value.__isConvertedError__) {
      const { message, ...properties } = value.errorProperties;
      const error = new Error(message);
      Object.assign(error, properties);
      return error;
    }
    if (isObject3(value) && value["_constructor-name_"] && options.allowFunction) {
      const name2 = value["_constructor-name_"];
      if (name2 !== "Object") {
        const Fn = new Function(`return function ${name2.replace(/[^a-zA-Z0-9$_]+/g, "")}(){}`)();
        Object.setPrototypeOf(value, new Fn());
      }
      delete value["_constructor-name_"];
      return value;
    }
    if (typeof value === "string" && value.startsWith("_function_") && options.allowFunction) {
      const [, name, source] = value.match(/_function_([^|]*)\|(.*)/) || [];
      const sourceSanitized = source.replace(/[(\(\))|\\| |\]|`]*$/, "");
      if (!options.lazyEval) {
        return eval(`(${sourceSanitized})`);
      }
      const result = (...args) => {
        const f = eval(`(${sourceSanitized})`);
        return f(...args);
      };
      Object.defineProperty(result, "toString", {
        value: () => sourceSanitized
      });
      Object.defineProperty(result, "name", {
        value: name
      });
      return result;
    }
    if (typeof value === "string" && value.startsWith("_regexp_") && options.allowRegExp) {
      const [, flags, source2] = value.match(/_regexp_([^|]*)\|(.*)/) || [];
      return new RegExp(source2, flags);
    }
    if (typeof value === "string" && value.startsWith("_date_") && options.allowDate) {
      return new Date(value.replace("_date_", ""));
    }
    if (typeof value === "string" && value.startsWith("_duplicate_")) {
      refs.push({ target: key, container: this, replacement: value.replace(/^_duplicate_/, "") });
      return null;
    }
    if (typeof value === "string" && value.startsWith("_symbol_") && options.allowSymbol) {
      return Symbol(value.replace("_symbol_", ""));
    }
    if (typeof value === "string" && value.startsWith("_gsymbol_") && options.allowSymbol) {
      return Symbol.for(value.replace("_gsymbol_", ""));
    }
    if (typeof value === "string" && value === "_-Infinity_") {
      return -Infinity;
    }
    if (typeof value === "string" && value === "_Infinity_") {
      return Infinity;
    }
    if (typeof value === "string" && value === "_NaN_") {
      return NaN;
    }
    if (typeof value === "string" && value.startsWith("_bigint_") && typeof BigInt === "function") {
      return BigInt(value.replace("_bigint_", ""));
    }
    return value;
  };
};
var defaultOptions = {
  maxDepth: 10,
  space: void 0,
  allowFunction: true,
  allowRegExp: true,
  allowDate: true,
  allowClass: true,
  allowError: true,
  allowUndefined: true,
  allowSymbol: true,
  lazyEval: true
};
var stringify = (data, options2 = {}) => {
  const mergedOptions = { ...defaultOptions, ...options2 };
  return JSON.stringify(convertUnconventionalData(data), replacer(mergedOptions), options2.space);
};
var mutator = () => {
  const mutated = /* @__PURE__ */ new Map();
  return function mutateUndefined(value2) {
    if (isObject3(value2)) {
      Object.entries(value2).forEach(([k, v]) => {
        if (v === "_undefined_") {
          value2[k] = void 0;
        } else if (!mutated.get(v)) {
          mutated.set(v, true);
          mutateUndefined(v);
        }
      });
    }
    if (Array.isArray(value2)) {
      value2.forEach((v, index) => {
        if (v === "_undefined_") {
          mutated.set(v, true);
          value2[index] = void 0;
        } else if (!mutated.get(v)) {
          mutated.set(v, true);
          mutateUndefined(v);
        }
      });
    }
  };
};
var parse = (data, options2 = {}) => {
  const mergedOptions = { ...defaultOptions, ...options2 };
  const result2 = JSON.parse(data, reviver2(mergedOptions));
  mutator()(result2);
  return result2;
};

/*!
 * isobject <https://github.com/jonschlinkert/isobject>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */
/**
 * @license
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="es" -o ./`
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */


/***/ }),

/***/ 84465:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* binding */ i; },
  "C": function() { return /* binding */ e; }
});

;// CONCATENATED MODULE: ../node_modules/immer/dist/immer.mjs
// src/utils/env.ts
var NOTHING = Symbol.for("immer-nothing");
var DRAFTABLE = Symbol.for("immer-draftable");
var DRAFT_STATE = Symbol.for("immer-state");

// src/utils/errors.ts
var errors =  false ? 0 : [];
function die(error, ...args) {
  if (false) {}
  throw new Error(
    `[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`
  );
}

// src/utils/common.ts
var getPrototypeOf = Object.getPrototypeOf;
function isDraft(value) {
  return !!value && !!value[DRAFT_STATE];
}
function isDraftable(value) {
  if (!value)
    return false;
  return isPlainObject(value) || Array.isArray(value) || !!value[DRAFTABLE] || !!value.constructor?.[DRAFTABLE] || isMap(value) || isSet(value);
}
var objectCtorString = Object.prototype.constructor.toString();
function isPlainObject(value) {
  if (!value || typeof value !== "object")
    return false;
  const proto = getPrototypeOf(value);
  if (proto === null) {
    return true;
  }
  const Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
  if (Ctor === Object)
    return true;
  return typeof Ctor == "function" && Function.toString.call(Ctor) === objectCtorString;
}
function original(value) {
  if (!isDraft(value))
    die(15, value);
  return value[DRAFT_STATE].base_;
}
function each(obj, iter) {
  if (getArchtype(obj) === 0 /* Object */) {
    Reflect.ownKeys(obj).forEach((key) => {
      iter(key, obj[key], obj);
    });
  } else {
    obj.forEach((entry, index) => iter(index, entry, obj));
  }
}
function getArchtype(thing) {
  const state = thing[DRAFT_STATE];
  return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */ : isMap(thing) ? 2 /* Map */ : isSet(thing) ? 3 /* Set */ : 0 /* Object */;
}
function has(thing, prop) {
  return getArchtype(thing) === 2 /* Map */ ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function get(thing, prop) {
  return getArchtype(thing) === 2 /* Map */ ? thing.get(prop) : thing[prop];
}
function set(thing, propOrOldValue, value) {
  const t = getArchtype(thing);
  if (t === 2 /* Map */)
    thing.set(propOrOldValue, value);
  else if (t === 3 /* Set */) {
    thing.add(value);
  } else
    thing[propOrOldValue] = value;
}
function is(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}
function isMap(target) {
  return target instanceof Map;
}
function isSet(target) {
  return target instanceof Set;
}
function latest(state) {
  return state.copy_ || state.base_;
}
function shallowCopy(base, strict) {
  if (isMap(base)) {
    return new Map(base);
  }
  if (isSet(base)) {
    return new Set(base);
  }
  if (Array.isArray(base))
    return Array.prototype.slice.call(base);
  const isPlain = isPlainObject(base);
  if (strict === true || strict === "class_only" && !isPlain) {
    const descriptors = Object.getOwnPropertyDescriptors(base);
    delete descriptors[DRAFT_STATE];
    let keys = Reflect.ownKeys(descriptors);
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      const desc = descriptors[key];
      if (desc.writable === false) {
        desc.writable = true;
        desc.configurable = true;
      }
      if (desc.get || desc.set)
        descriptors[key] = {
          configurable: true,
          writable: true,
          // could live with !!desc.set as well here...
          enumerable: desc.enumerable,
          value: base[key]
        };
    }
    return Object.create(getPrototypeOf(base), descriptors);
  } else {
    const proto = getPrototypeOf(base);
    if (proto !== null && isPlain) {
      return { ...base };
    }
    const obj = Object.create(proto);
    return Object.assign(obj, base);
  }
}
function freeze(obj, deep = false) {
  if (isFrozen(obj) || isDraft(obj) || !isDraftable(obj))
    return obj;
  if (getArchtype(obj) > 1) {
    obj.set = obj.add = obj.clear = obj.delete = dontMutateFrozenCollections;
  }
  Object.freeze(obj);
  if (deep)
    Object.entries(obj).forEach(([key, value]) => freeze(value, true));
  return obj;
}
function dontMutateFrozenCollections() {
  die(2);
}
function isFrozen(obj) {
  return Object.isFrozen(obj);
}

// src/utils/plugins.ts
var plugins = {};
function getPlugin(pluginKey) {
  const plugin = plugins[pluginKey];
  if (!plugin) {
    die(0, pluginKey);
  }
  return plugin;
}
function loadPlugin(pluginKey, implementation) {
  if (!plugins[pluginKey])
    plugins[pluginKey] = implementation;
}

// src/core/scope.ts
var currentScope;
function getCurrentScope() {
  return currentScope;
}
function createScope(parent_, immer_) {
  return {
    drafts_: [],
    parent_,
    immer_,
    // Whenever the modified draft contains a draft from another scope, we
    // need to prevent auto-freezing so the unowned draft can be finalized.
    canAutoFreeze_: true,
    unfinalizedDrafts_: 0
  };
}
function usePatchesInScope(scope, patchListener) {
  if (patchListener) {
    getPlugin("Patches");
    scope.patches_ = [];
    scope.inversePatches_ = [];
    scope.patchListener_ = patchListener;
  }
}
function revokeScope(scope) {
  leaveScope(scope);
  scope.drafts_.forEach(revokeDraft);
  scope.drafts_ = null;
}
function leaveScope(scope) {
  if (scope === currentScope) {
    currentScope = scope.parent_;
  }
}
function enterScope(immer2) {
  return currentScope = createScope(currentScope, immer2);
}
function revokeDraft(draft) {
  const state = draft[DRAFT_STATE];
  if (state.type_ === 0 /* Object */ || state.type_ === 1 /* Array */)
    state.revoke_();
  else
    state.revoked_ = true;
}

// src/core/finalize.ts
function processResult(result, scope) {
  scope.unfinalizedDrafts_ = scope.drafts_.length;
  const baseDraft = scope.drafts_[0];
  const isReplaced = result !== void 0 && result !== baseDraft;
  if (isReplaced) {
    if (baseDraft[DRAFT_STATE].modified_) {
      revokeScope(scope);
      die(4);
    }
    if (isDraftable(result)) {
      result = finalize(scope, result);
      if (!scope.parent_)
        maybeFreeze(scope, result);
    }
    if (scope.patches_) {
      getPlugin("Patches").generateReplacementPatches_(
        baseDraft[DRAFT_STATE].base_,
        result,
        scope.patches_,
        scope.inversePatches_
      );
    }
  } else {
    result = finalize(scope, baseDraft, []);
  }
  revokeScope(scope);
  if (scope.patches_) {
    scope.patchListener_(scope.patches_, scope.inversePatches_);
  }
  return result !== NOTHING ? result : void 0;
}
function finalize(rootScope, value, path) {
  if (isFrozen(value))
    return value;
  const state = value[DRAFT_STATE];
  if (!state) {
    each(
      value,
      (key, childValue) => finalizeProperty(rootScope, state, value, key, childValue, path)
    );
    return value;
  }
  if (state.scope_ !== rootScope)
    return value;
  if (!state.modified_) {
    maybeFreeze(rootScope, state.base_, true);
    return state.base_;
  }
  if (!state.finalized_) {
    state.finalized_ = true;
    state.scope_.unfinalizedDrafts_--;
    const result = state.copy_;
    let resultEach = result;
    let isSet2 = false;
    if (state.type_ === 3 /* Set */) {
      resultEach = new Set(result);
      result.clear();
      isSet2 = true;
    }
    each(
      resultEach,
      (key, childValue) => finalizeProperty(rootScope, state, result, key, childValue, path, isSet2)
    );
    maybeFreeze(rootScope, result, false);
    if (path && rootScope.patches_) {
      getPlugin("Patches").generatePatches_(
        state,
        path,
        rootScope.patches_,
        rootScope.inversePatches_
      );
    }
  }
  return state.copy_;
}
function finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
  if (false)
    {}
  if (isDraft(childValue)) {
    const path = rootPath && parentState && parentState.type_ !== 3 /* Set */ && // Set objects are atomic since they have no keys.
    !has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
    const res = finalize(rootScope, childValue, path);
    set(targetObject, prop, res);
    if (isDraft(res)) {
      rootScope.canAutoFreeze_ = false;
    } else
      return;
  } else if (targetIsSet) {
    targetObject.add(childValue);
  }
  if (isDraftable(childValue) && !isFrozen(childValue)) {
    if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) {
      return;
    }
    finalize(rootScope, childValue);
    if ((!parentState || !parentState.scope_.parent_) && typeof prop !== "symbol" && Object.prototype.propertyIsEnumerable.call(targetObject, prop))
      maybeFreeze(rootScope, childValue);
  }
}
function maybeFreeze(scope, value, deep = false) {
  if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) {
    freeze(value, deep);
  }
}

// src/core/proxy.ts
function createProxyProxy(base, parent) {
  const isArray = Array.isArray(base);
  const state = {
    type_: isArray ? 1 /* Array */ : 0 /* Object */,
    // Track which produce call this is associated with.
    scope_: parent ? parent.scope_ : getCurrentScope(),
    // True for both shallow and deep changes.
    modified_: false,
    // Used during finalization.
    finalized_: false,
    // Track which properties have been assigned (true) or deleted (false).
    assigned_: {},
    // The parent draft state.
    parent_: parent,
    // The base state.
    base_: base,
    // The base proxy.
    draft_: null,
    // set below
    // The base copy with any updated values.
    copy_: null,
    // Called by the `produce` function.
    revoke_: null,
    isManual_: false
  };
  let target = state;
  let traps = objectTraps;
  if (isArray) {
    target = [state];
    traps = arrayTraps;
  }
  const { revoke, proxy } = Proxy.revocable(target, traps);
  state.draft_ = proxy;
  state.revoke_ = revoke;
  return proxy;
}
var objectTraps = {
  get(state, prop) {
    if (prop === DRAFT_STATE)
      return state;
    const source = latest(state);
    if (!has(source, prop)) {
      return readPropFromProto(state, source, prop);
    }
    const value = source[prop];
    if (state.finalized_ || !isDraftable(value)) {
      return value;
    }
    if (value === peek(state.base_, prop)) {
      prepareCopy(state);
      return state.copy_[prop] = createProxy(value, state);
    }
    return value;
  },
  has(state, prop) {
    return prop in latest(state);
  },
  ownKeys(state) {
    return Reflect.ownKeys(latest(state));
  },
  set(state, prop, value) {
    const desc = getDescriptorFromProto(latest(state), prop);
    if (desc?.set) {
      desc.set.call(state.draft_, value);
      return true;
    }
    if (!state.modified_) {
      const current2 = peek(latest(state), prop);
      const currentState = current2?.[DRAFT_STATE];
      if (currentState && currentState.base_ === value) {
        state.copy_[prop] = value;
        state.assigned_[prop] = false;
        return true;
      }
      if (is(value, current2) && (value !== void 0 || has(state.base_, prop)))
        return true;
      prepareCopy(state);
      markChanged(state);
    }
    if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
    (value !== void 0 || prop in state.copy_) || // special case: NaN
    Number.isNaN(value) && Number.isNaN(state.copy_[prop]))
      return true;
    state.copy_[prop] = value;
    state.assigned_[prop] = true;
    return true;
  },
  deleteProperty(state, prop) {
    if (peek(state.base_, prop) !== void 0 || prop in state.base_) {
      state.assigned_[prop] = false;
      prepareCopy(state);
      markChanged(state);
    } else {
      delete state.assigned_[prop];
    }
    if (state.copy_) {
      delete state.copy_[prop];
    }
    return true;
  },
  // Note: We never coerce `desc.value` into an Immer draft, because we can't make
  // the same guarantee in ES5 mode.
  getOwnPropertyDescriptor(state, prop) {
    const owner = latest(state);
    const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
    if (!desc)
      return desc;
    return {
      writable: true,
      configurable: state.type_ !== 1 /* Array */ || prop !== "length",
      enumerable: desc.enumerable,
      value: owner[prop]
    };
  },
  defineProperty() {
    die(11);
  },
  getPrototypeOf(state) {
    return getPrototypeOf(state.base_);
  },
  setPrototypeOf() {
    die(12);
  }
};
var arrayTraps = {};
each(objectTraps, (key, fn) => {
  arrayTraps[key] = function() {
    arguments[0] = arguments[0][0];
    return fn.apply(this, arguments);
  };
});
arrayTraps.deleteProperty = function(state, prop) {
  if (false)
    {}
  return arrayTraps.set.call(this, state, prop, void 0);
};
arrayTraps.set = function(state, prop, value) {
  if (false)
    {}
  return objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function peek(draft, prop) {
  const state = draft[DRAFT_STATE];
  const source = state ? latest(state) : draft;
  return source[prop];
}
function readPropFromProto(state, source, prop) {
  const desc = getDescriptorFromProto(source, prop);
  return desc ? `value` in desc ? desc.value : (
    // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    desc.get?.call(state.draft_)
  ) : void 0;
}
function getDescriptorFromProto(source, prop) {
  if (!(prop in source))
    return void 0;
  let proto = getPrototypeOf(source);
  while (proto) {
    const desc = Object.getOwnPropertyDescriptor(proto, prop);
    if (desc)
      return desc;
    proto = getPrototypeOf(proto);
  }
  return void 0;
}
function markChanged(state) {
  if (!state.modified_) {
    state.modified_ = true;
    if (state.parent_) {
      markChanged(state.parent_);
    }
  }
}
function prepareCopy(state) {
  if (!state.copy_) {
    state.copy_ = shallowCopy(
      state.base_,
      state.scope_.immer_.useStrictShallowCopy_
    );
  }
}

// src/core/immerClass.ts
var Immer2 = class {
  constructor(config) {
    this.autoFreeze_ = true;
    this.useStrictShallowCopy_ = false;
    /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */
    this.produce = (base, recipe, patchListener) => {
      if (typeof base === "function" && typeof recipe !== "function") {
        const defaultBase = recipe;
        recipe = base;
        const self = this;
        return function curriedProduce(base2 = defaultBase, ...args) {
          return self.produce(base2, (draft) => recipe.call(this, draft, ...args));
        };
      }
      if (typeof recipe !== "function")
        die(6);
      if (patchListener !== void 0 && typeof patchListener !== "function")
        die(7);
      let result;
      if (isDraftable(base)) {
        const scope = enterScope(this);
        const proxy = createProxy(base, void 0);
        let hasError = true;
        try {
          result = recipe(proxy);
          hasError = false;
        } finally {
          if (hasError)
            revokeScope(scope);
          else
            leaveScope(scope);
        }
        usePatchesInScope(scope, patchListener);
        return processResult(result, scope);
      } else if (!base || typeof base !== "object") {
        result = recipe(base);
        if (result === void 0)
          result = base;
        if (result === NOTHING)
          result = void 0;
        if (this.autoFreeze_)
          freeze(result, true);
        if (patchListener) {
          const p = [];
          const ip = [];
          getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
          patchListener(p, ip);
        }
        return result;
      } else
        die(1, base);
    };
    this.produceWithPatches = (base, recipe) => {
      if (typeof base === "function") {
        return (state, ...args) => this.produceWithPatches(state, (draft) => base(draft, ...args));
      }
      let patches, inversePatches;
      const result = this.produce(base, recipe, (p, ip) => {
        patches = p;
        inversePatches = ip;
      });
      return [result, patches, inversePatches];
    };
    if (typeof config?.autoFreeze === "boolean")
      this.setAutoFreeze(config.autoFreeze);
    if (typeof config?.useStrictShallowCopy === "boolean")
      this.setUseStrictShallowCopy(config.useStrictShallowCopy);
  }
  createDraft(base) {
    if (!isDraftable(base))
      die(8);
    if (isDraft(base))
      base = current(base);
    const scope = enterScope(this);
    const proxy = createProxy(base, void 0);
    proxy[DRAFT_STATE].isManual_ = true;
    leaveScope(scope);
    return proxy;
  }
  finishDraft(draft, patchListener) {
    const state = draft && draft[DRAFT_STATE];
    if (!state || !state.isManual_)
      die(9);
    const { scope_: scope } = state;
    usePatchesInScope(scope, patchListener);
    return processResult(void 0, scope);
  }
  /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */
  setAutoFreeze(value) {
    this.autoFreeze_ = value;
  }
  /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */
  setUseStrictShallowCopy(value) {
    this.useStrictShallowCopy_ = value;
  }
  applyPatches(base, patches) {
    let i;
    for (i = patches.length - 1; i >= 0; i--) {
      const patch = patches[i];
      if (patch.path.length === 0 && patch.op === "replace") {
        base = patch.value;
        break;
      }
    }
    if (i > -1) {
      patches = patches.slice(i + 1);
    }
    const applyPatchesImpl = getPlugin("Patches").applyPatches_;
    if (isDraft(base)) {
      return applyPatchesImpl(base, patches);
    }
    return this.produce(
      base,
      (draft) => applyPatchesImpl(draft, patches)
    );
  }
};
function createProxy(value, parent) {
  const draft = isMap(value) ? getPlugin("MapSet").proxyMap_(value, parent) : isSet(value) ? getPlugin("MapSet").proxySet_(value, parent) : createProxyProxy(value, parent);
  const scope = parent ? parent.scope_ : getCurrentScope();
  scope.drafts_.push(draft);
  return draft;
}

// src/core/current.ts
function current(value) {
  if (!isDraft(value))
    die(10, value);
  return currentImpl(value);
}
function currentImpl(value) {
  if (!isDraftable(value) || isFrozen(value))
    return value;
  const state = value[DRAFT_STATE];
  let copy;
  if (state) {
    if (!state.modified_)
      return state.base_;
    state.finalized_ = true;
    copy = shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
  } else {
    copy = shallowCopy(value, true);
  }
  each(copy, (key, childValue) => {
    set(copy, key, currentImpl(childValue));
  });
  if (state) {
    state.finalized_ = false;
  }
  return copy;
}

// src/plugins/patches.ts
function enablePatches() {
  const errorOffset = 16;
  if (false) {}
  const REPLACE = "replace";
  const ADD = "add";
  const REMOVE = "remove";
  function generatePatches_(state, basePath, patches, inversePatches) {
    switch (state.type_) {
      case 0 /* Object */:
      case 2 /* Map */:
        return generatePatchesFromAssigned(
          state,
          basePath,
          patches,
          inversePatches
        );
      case 1 /* Array */:
        return generateArrayPatches(state, basePath, patches, inversePatches);
      case 3 /* Set */:
        return generateSetPatches(
          state,
          basePath,
          patches,
          inversePatches
        );
    }
  }
  function generateArrayPatches(state, basePath, patches, inversePatches) {
    let { base_, assigned_ } = state;
    let copy_ = state.copy_;
    if (copy_.length < base_.length) {
      ;
      [base_, copy_] = [copy_, base_];
      [patches, inversePatches] = [inversePatches, patches];
    }
    for (let i = 0; i < base_.length; i++) {
      if (assigned_[i] && copy_[i] !== base_[i]) {
        const path = basePath.concat([i]);
        patches.push({
          op: REPLACE,
          path,
          // Need to maybe clone it, as it can in fact be the original value
          // due to the base/copy inversion at the start of this function
          value: clonePatchValueIfNeeded(copy_[i])
        });
        inversePatches.push({
          op: REPLACE,
          path,
          value: clonePatchValueIfNeeded(base_[i])
        });
      }
    }
    for (let i = base_.length; i < copy_.length; i++) {
      const path = basePath.concat([i]);
      patches.push({
        op: ADD,
        path,
        // Need to maybe clone it, as it can in fact be the original value
        // due to the base/copy inversion at the start of this function
        value: clonePatchValueIfNeeded(copy_[i])
      });
    }
    for (let i = copy_.length - 1; base_.length <= i; --i) {
      const path = basePath.concat([i]);
      inversePatches.push({
        op: REMOVE,
        path
      });
    }
  }
  function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
    const { base_, copy_ } = state;
    each(state.assigned_, (key, assignedValue) => {
      const origValue = get(base_, key);
      const value = get(copy_, key);
      const op = !assignedValue ? REMOVE : has(base_, key) ? REPLACE : ADD;
      if (origValue === value && op === REPLACE)
        return;
      const path = basePath.concat(key);
      patches.push(op === REMOVE ? { op, path } : { op, path, value });
      inversePatches.push(
        op === ADD ? { op: REMOVE, path } : op === REMOVE ? { op: ADD, path, value: clonePatchValueIfNeeded(origValue) } : { op: REPLACE, path, value: clonePatchValueIfNeeded(origValue) }
      );
    });
  }
  function generateSetPatches(state, basePath, patches, inversePatches) {
    let { base_, copy_ } = state;
    let i = 0;
    base_.forEach((value) => {
      if (!copy_.has(value)) {
        const path = basePath.concat([i]);
        patches.push({
          op: REMOVE,
          path,
          value
        });
        inversePatches.unshift({
          op: ADD,
          path,
          value
        });
      }
      i++;
    });
    i = 0;
    copy_.forEach((value) => {
      if (!base_.has(value)) {
        const path = basePath.concat([i]);
        patches.push({
          op: ADD,
          path,
          value
        });
        inversePatches.unshift({
          op: REMOVE,
          path,
          value
        });
      }
      i++;
    });
  }
  function generateReplacementPatches_(baseValue, replacement, patches, inversePatches) {
    patches.push({
      op: REPLACE,
      path: [],
      value: replacement === NOTHING ? void 0 : replacement
    });
    inversePatches.push({
      op: REPLACE,
      path: [],
      value: baseValue
    });
  }
  function applyPatches_(draft, patches) {
    patches.forEach((patch) => {
      const { path, op } = patch;
      let base = draft;
      for (let i = 0; i < path.length - 1; i++) {
        const parentType = getArchtype(base);
        let p = path[i];
        if (typeof p !== "string" && typeof p !== "number") {
          p = "" + p;
        }
        if ((parentType === 0 /* Object */ || parentType === 1 /* Array */) && (p === "__proto__" || p === "constructor"))
          die(errorOffset + 3);
        if (typeof base === "function" && p === "prototype")
          die(errorOffset + 3);
        base = get(base, p);
        if (typeof base !== "object")
          die(errorOffset + 2, path.join("/"));
      }
      const type = getArchtype(base);
      const value = deepClonePatchValue(patch.value);
      const key = path[path.length - 1];
      switch (op) {
        case REPLACE:
          switch (type) {
            case 2 /* Map */:
              return base.set(key, value);
            case 3 /* Set */:
              die(errorOffset);
            default:
              return base[key] = value;
          }
        case ADD:
          switch (type) {
            case 1 /* Array */:
              return key === "-" ? base.push(value) : base.splice(key, 0, value);
            case 2 /* Map */:
              return base.set(key, value);
            case 3 /* Set */:
              return base.add(value);
            default:
              return base[key] = value;
          }
        case REMOVE:
          switch (type) {
            case 1 /* Array */:
              return base.splice(key, 1);
            case 2 /* Map */:
              return base.delete(key);
            case 3 /* Set */:
              return base.delete(patch.value);
            default:
              return delete base[key];
          }
        default:
          die(errorOffset + 1, op);
      }
    });
    return draft;
  }
  function deepClonePatchValue(obj) {
    if (!isDraftable(obj))
      return obj;
    if (Array.isArray(obj))
      return obj.map(deepClonePatchValue);
    if (isMap(obj))
      return new Map(
        Array.from(obj.entries()).map(([k, v]) => [k, deepClonePatchValue(v)])
      );
    if (isSet(obj))
      return new Set(Array.from(obj).map(deepClonePatchValue));
    const cloned = Object.create(getPrototypeOf(obj));
    for (const key in obj)
      cloned[key] = deepClonePatchValue(obj[key]);
    if (has(obj, DRAFTABLE))
      cloned[DRAFTABLE] = obj[DRAFTABLE];
    return cloned;
  }
  function clonePatchValueIfNeeded(obj) {
    if (isDraft(obj)) {
      return deepClonePatchValue(obj);
    } else
      return obj;
  }
  loadPlugin("Patches", {
    applyPatches_,
    generatePatches_,
    generateReplacementPatches_
  });
}

// src/plugins/mapset.ts
function enableMapSet() {
  class DraftMap extends Map {
    constructor(target, parent) {
      super();
      this[DRAFT_STATE] = {
        type_: 2 /* Map */,
        parent_: parent,
        scope_: parent ? parent.scope_ : getCurrentScope(),
        modified_: false,
        finalized_: false,
        copy_: void 0,
        assigned_: void 0,
        base_: target,
        draft_: this,
        isManual_: false,
        revoked_: false
      };
    }
    get size() {
      return latest(this[DRAFT_STATE]).size;
    }
    has(key) {
      return latest(this[DRAFT_STATE]).has(key);
    }
    set(key, value) {
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      if (!latest(state).has(key) || latest(state).get(key) !== value) {
        prepareMapCopy(state);
        markChanged(state);
        state.assigned_.set(key, true);
        state.copy_.set(key, value);
        state.assigned_.set(key, true);
      }
      return this;
    }
    delete(key) {
      if (!this.has(key)) {
        return false;
      }
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      prepareMapCopy(state);
      markChanged(state);
      if (state.base_.has(key)) {
        state.assigned_.set(key, false);
      } else {
        state.assigned_.delete(key);
      }
      state.copy_.delete(key);
      return true;
    }
    clear() {
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      if (latest(state).size) {
        prepareMapCopy(state);
        markChanged(state);
        state.assigned_ = /* @__PURE__ */ new Map();
        each(state.base_, (key) => {
          state.assigned_.set(key, false);
        });
        state.copy_.clear();
      }
    }
    forEach(cb, thisArg) {
      const state = this[DRAFT_STATE];
      latest(state).forEach((_value, key, _map) => {
        cb.call(thisArg, this.get(key), key, this);
      });
    }
    get(key) {
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      const value = latest(state).get(key);
      if (state.finalized_ || !isDraftable(value)) {
        return value;
      }
      if (value !== state.base_.get(key)) {
        return value;
      }
      const draft = createProxy(value, state);
      prepareMapCopy(state);
      state.copy_.set(key, draft);
      return draft;
    }
    keys() {
      return latest(this[DRAFT_STATE]).keys();
    }
    values() {
      const iterator = this.keys();
      return {
        [Symbol.iterator]: () => this.values(),
        next: () => {
          const r = iterator.next();
          if (r.done)
            return r;
          const value = this.get(r.value);
          return {
            done: false,
            value
          };
        }
      };
    }
    entries() {
      const iterator = this.keys();
      return {
        [Symbol.iterator]: () => this.entries(),
        next: () => {
          const r = iterator.next();
          if (r.done)
            return r;
          const value = this.get(r.value);
          return {
            done: false,
            value: [r.value, value]
          };
        }
      };
    }
    [(DRAFT_STATE, Symbol.iterator)]() {
      return this.entries();
    }
  }
  function proxyMap_(target, parent) {
    return new DraftMap(target, parent);
  }
  function prepareMapCopy(state) {
    if (!state.copy_) {
      state.assigned_ = /* @__PURE__ */ new Map();
      state.copy_ = new Map(state.base_);
    }
  }
  class DraftSet extends Set {
    constructor(target, parent) {
      super();
      this[DRAFT_STATE] = {
        type_: 3 /* Set */,
        parent_: parent,
        scope_: parent ? parent.scope_ : getCurrentScope(),
        modified_: false,
        finalized_: false,
        copy_: void 0,
        base_: target,
        draft_: this,
        drafts_: /* @__PURE__ */ new Map(),
        revoked_: false,
        isManual_: false
      };
    }
    get size() {
      return latest(this[DRAFT_STATE]).size;
    }
    has(value) {
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      if (!state.copy_) {
        return state.base_.has(value);
      }
      if (state.copy_.has(value))
        return true;
      if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value)))
        return true;
      return false;
    }
    add(value) {
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      if (!this.has(value)) {
        prepareSetCopy(state);
        markChanged(state);
        state.copy_.add(value);
      }
      return this;
    }
    delete(value) {
      if (!this.has(value)) {
        return false;
      }
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      prepareSetCopy(state);
      markChanged(state);
      return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : (
        /* istanbul ignore next */
        false
      ));
    }
    clear() {
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      if (latest(state).size) {
        prepareSetCopy(state);
        markChanged(state);
        state.copy_.clear();
      }
    }
    values() {
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      prepareSetCopy(state);
      return state.copy_.values();
    }
    entries() {
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      prepareSetCopy(state);
      return state.copy_.entries();
    }
    keys() {
      return this.values();
    }
    [(DRAFT_STATE, Symbol.iterator)]() {
      return this.values();
    }
    forEach(cb, thisArg) {
      const iterator = this.values();
      let result = iterator.next();
      while (!result.done) {
        cb.call(thisArg, result.value, result.value, this);
        result = iterator.next();
      }
    }
  }
  function proxySet_(target, parent) {
    return new DraftSet(target, parent);
  }
  function prepareSetCopy(state) {
    if (!state.copy_) {
      state.copy_ = /* @__PURE__ */ new Set();
      state.base_.forEach((value) => {
        if (isDraftable(value)) {
          const draft = createProxy(value, state);
          state.drafts_.set(value, draft);
          state.copy_.add(draft);
        } else {
          state.copy_.add(value);
        }
      });
    }
  }
  function assertUnrevoked(state) {
    if (state.revoked_)
      die(3, JSON.stringify(latest(state)));
  }
  loadPlugin("MapSet", { proxyMap_, proxySet_ });
}

// src/immer.ts
var immer = new Immer2();
var produce = immer.produce;
var produceWithPatches = immer.produceWithPatches.bind(
  immer
);
var setAutoFreeze = immer.setAutoFreeze.bind(immer);
var setUseStrictShallowCopy = immer.setUseStrictShallowCopy.bind(immer);
var applyPatches = immer.applyPatches.bind(immer);
var createDraft = immer.createDraft.bind(immer);
var finishDraft = immer.finishDraft.bind(immer);
function castDraft(value) {
  return value;
}
function castImmutable(value) {
  return value;
}

//# sourceMappingURL=immer.mjs.map
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
;// CONCATENATED MODULE: ../node_modules/use-immer/dist/use-immer.module.mjs
function i(f){var u=(0,react.useState)(function(){return freeze("function"==typeof f?f():f,!0)}),i=u[1];return[u[0],(0,react.useCallback)(function(t){i("function"==typeof t?produce(t):freeze(t))},[])]}function e(n,t,o){var i=(0,react.useMemo)(function(){return produce(n)},[n]);return (0,react.useReducer)(i,t,o)}
//# sourceMappingURL=use-immer.module.mjs.map


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,179], function() { return __webpack_exec__(6461), __webpack_exec__(15817); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);